
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4b75"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4b75"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7YWoO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iGyvS"));

});
parcelRegister("iGyvS", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d9a6ebd1c1d3add2$export$ffb0004e005737fa; }, function (v) { return $d9a6ebd1c1d3add2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d9a6ebd1c1d3add2$export$34b9dba7ce09269b; }, function (v) { return $d9a6ebd1c1d3add2$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d9a6ebd1c1d3add2$export$25062201e9e25d76; }, function (v) { return $d9a6ebd1c1d3add2$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9a6ebd1c1d3add2$export$ffb0004e005737fa;
var $d9a6ebd1c1d3add2$export$34b9dba7ce09269b;
var $d9a6ebd1c1d3add2$export$25062201e9e25d76;
'use strict';

var $dvPqk = parcelRequire("dvPqk");
var $d9a6ebd1c1d3add2$var$k = Symbol.for("react.element"), $d9a6ebd1c1d3add2$var$l = Symbol.for("react.fragment"), $d9a6ebd1c1d3add2$var$m = Object.prototype.hasOwnProperty, $d9a6ebd1c1d3add2$var$n = $dvPqk.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d9a6ebd1c1d3add2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d9a6ebd1c1d3add2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d9a6ebd1c1d3add2$var$m.call(a, b) && !$d9a6ebd1c1d3add2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d9a6ebd1c1d3add2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d9a6ebd1c1d3add2$var$n.current
    };
}
$d9a6ebd1c1d3add2$export$ffb0004e005737fa = $d9a6ebd1c1d3add2$var$l;
$d9a6ebd1c1d3add2$export$34b9dba7ce09269b = $d9a6ebd1c1d3add2$var$q;
$d9a6ebd1c1d3add2$export$25062201e9e25d76 = $d9a6ebd1c1d3add2$var$q;

});
parcelRegister("dvPqk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bpvQ4"));

});
parcelRegister("bpvQ4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $84eaba09e7c1c990$export$dca3b0875bd9a954; }, function (v) { return $84eaba09e7c1c990$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $84eaba09e7c1c990$export$16fa2f45be04daa8; }, function (v) { return $84eaba09e7c1c990$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $84eaba09e7c1c990$export$ffb0004e005737fa; }, function (v) { return $84eaba09e7c1c990$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $84eaba09e7c1c990$export$e2c29f18771995cb; }, function (v) { return $84eaba09e7c1c990$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $84eaba09e7c1c990$export$221d75b3f55bb0bd; }, function (v) { return $84eaba09e7c1c990$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $84eaba09e7c1c990$export$5f8d39834fd61797; }, function (v) { return $84eaba09e7c1c990$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $84eaba09e7c1c990$export$74bf444e3cd11ea5; }, function (v) { return $84eaba09e7c1c990$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $84eaba09e7c1c990$export$ae55be85d98224ed; }, function (v) { return $84eaba09e7c1c990$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $84eaba09e7c1c990$export$3ba232387fd5d6dd; }, function (v) { return $84eaba09e7c1c990$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $84eaba09e7c1c990$export$e530037191fcd5d7; }, function (v) { return $84eaba09e7c1c990$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $84eaba09e7c1c990$export$fd42f52fd3ae1109; }, function (v) { return $84eaba09e7c1c990$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $84eaba09e7c1c990$export$c8a8987d4410bf2d; }, function (v) { return $84eaba09e7c1c990$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $84eaba09e7c1c990$export$d38cd72104c1f0e9; }, function (v) { return $84eaba09e7c1c990$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $84eaba09e7c1c990$export$7d1e3a5e95ceca43; }, function (v) { return $84eaba09e7c1c990$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $84eaba09e7c1c990$export$257a8862b851cb5b; }, function (v) { return $84eaba09e7c1c990$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $84eaba09e7c1c990$export$a8257692ac88316c; }, function (v) { return $84eaba09e7c1c990$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $84eaba09e7c1c990$export$488013bae63b21da; }, function (v) { return $84eaba09e7c1c990$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $84eaba09e7c1c990$export$7c73462e0d25e514; }, function (v) { return $84eaba09e7c1c990$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $84eaba09e7c1c990$export$7568632d0d33d16d; }, function (v) { return $84eaba09e7c1c990$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $84eaba09e7c1c990$export$88948ce120ea2619; }, function (v) { return $84eaba09e7c1c990$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $84eaba09e7c1c990$export$35808ee640e87ca7; }, function (v) { return $84eaba09e7c1c990$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $84eaba09e7c1c990$export$fae74005e78b1a27; }, function (v) { return $84eaba09e7c1c990$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $84eaba09e7c1c990$export$dc8fbce3eb94dc1e; }, function (v) { return $84eaba09e7c1c990$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $84eaba09e7c1c990$export$6a7bc4e911dc01cf; }, function (v) { return $84eaba09e7c1c990$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $84eaba09e7c1c990$export$6d9c69b0de29b591; }, function (v) { return $84eaba09e7c1c990$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $84eaba09e7c1c990$export$f680877a34711e37; }, function (v) { return $84eaba09e7c1c990$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $84eaba09e7c1c990$export$d5a552a76deda3c2; }, function (v) { return $84eaba09e7c1c990$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $84eaba09e7c1c990$export$aaabe4eda9ed9969; }, function (v) { return $84eaba09e7c1c990$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $84eaba09e7c1c990$export$e5c5a5f917a5871c; }, function (v) { return $84eaba09e7c1c990$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $84eaba09e7c1c990$export$1538c33de8887b59; }, function (v) { return $84eaba09e7c1c990$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $84eaba09e7c1c990$export$13e3392192263954; }, function (v) { return $84eaba09e7c1c990$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $84eaba09e7c1c990$export$b8f5890fc79d6aca; }, function (v) { return $84eaba09e7c1c990$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $84eaba09e7c1c990$export$60241385465d0a34; }, function (v) { return $84eaba09e7c1c990$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $84eaba09e7c1c990$export$306c0aa65ff9ec16; }, function (v) { return $84eaba09e7c1c990$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $84eaba09e7c1c990$export$7b286972b8d8ccbf; }, function (v) { return $84eaba09e7c1c990$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $84eaba09e7c1c990$export$83d89fbfd8236492; }, function (v) { return $84eaba09e7c1c990$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $84eaba09e7c1c990$export$dca3b0875bd9a954;
var $84eaba09e7c1c990$export$16fa2f45be04daa8;
var $84eaba09e7c1c990$export$ffb0004e005737fa;
var $84eaba09e7c1c990$export$e2c29f18771995cb;
var $84eaba09e7c1c990$export$221d75b3f55bb0bd;
var $84eaba09e7c1c990$export$5f8d39834fd61797;
var $84eaba09e7c1c990$export$74bf444e3cd11ea5;
var $84eaba09e7c1c990$export$ae55be85d98224ed;
var $84eaba09e7c1c990$export$3ba232387fd5d6dd;
var $84eaba09e7c1c990$export$e530037191fcd5d7;
var $84eaba09e7c1c990$export$fd42f52fd3ae1109;
var $84eaba09e7c1c990$export$c8a8987d4410bf2d;
var $84eaba09e7c1c990$export$d38cd72104c1f0e9;
var $84eaba09e7c1c990$export$7d1e3a5e95ceca43;
var $84eaba09e7c1c990$export$257a8862b851cb5b;
var $84eaba09e7c1c990$export$a8257692ac88316c;
var $84eaba09e7c1c990$export$488013bae63b21da;
var $84eaba09e7c1c990$export$7c73462e0d25e514;
var $84eaba09e7c1c990$export$7568632d0d33d16d;
var $84eaba09e7c1c990$export$88948ce120ea2619;
var $84eaba09e7c1c990$export$35808ee640e87ca7;
var $84eaba09e7c1c990$export$fae74005e78b1a27;
var $84eaba09e7c1c990$export$dc8fbce3eb94dc1e;
var $84eaba09e7c1c990$export$6a7bc4e911dc01cf;
var $84eaba09e7c1c990$export$6d9c69b0de29b591;
var $84eaba09e7c1c990$export$f680877a34711e37;
var $84eaba09e7c1c990$export$d5a552a76deda3c2;
var $84eaba09e7c1c990$export$aaabe4eda9ed9969;
var $84eaba09e7c1c990$export$e5c5a5f917a5871c;
var $84eaba09e7c1c990$export$1538c33de8887b59;
var $84eaba09e7c1c990$export$13e3392192263954;
var $84eaba09e7c1c990$export$b8f5890fc79d6aca;
var $84eaba09e7c1c990$export$60241385465d0a34;
var $84eaba09e7c1c990$export$306c0aa65ff9ec16;
var $84eaba09e7c1c990$export$7b286972b8d8ccbf;
var $84eaba09e7c1c990$export$83d89fbfd8236492;
'use strict';
var $84eaba09e7c1c990$var$l = Symbol.for("react.element"), $84eaba09e7c1c990$var$n = Symbol.for("react.portal"), $84eaba09e7c1c990$var$p = Symbol.for("react.fragment"), $84eaba09e7c1c990$var$q = Symbol.for("react.strict_mode"), $84eaba09e7c1c990$var$r = Symbol.for("react.profiler"), $84eaba09e7c1c990$var$t = Symbol.for("react.provider"), $84eaba09e7c1c990$var$u = Symbol.for("react.context"), $84eaba09e7c1c990$var$v = Symbol.for("react.forward_ref"), $84eaba09e7c1c990$var$w = Symbol.for("react.suspense"), $84eaba09e7c1c990$var$x = Symbol.for("react.memo"), $84eaba09e7c1c990$var$y = Symbol.for("react.lazy"), $84eaba09e7c1c990$var$z = Symbol.iterator;
function $84eaba09e7c1c990$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $84eaba09e7c1c990$var$z && a[$84eaba09e7c1c990$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $84eaba09e7c1c990$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $84eaba09e7c1c990$var$C = Object.assign, $84eaba09e7c1c990$var$D = {};
function $84eaba09e7c1c990$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $84eaba09e7c1c990$var$D;
    this.updater = e || $84eaba09e7c1c990$var$B;
}
$84eaba09e7c1c990$var$E.prototype.isReactComponent = {};
$84eaba09e7c1c990$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$84eaba09e7c1c990$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $84eaba09e7c1c990$var$F() {}
$84eaba09e7c1c990$var$F.prototype = $84eaba09e7c1c990$var$E.prototype;
function $84eaba09e7c1c990$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $84eaba09e7c1c990$var$D;
    this.updater = e || $84eaba09e7c1c990$var$B;
}
var $84eaba09e7c1c990$var$H = $84eaba09e7c1c990$var$G.prototype = new $84eaba09e7c1c990$var$F;
$84eaba09e7c1c990$var$H.constructor = $84eaba09e7c1c990$var$G;
$84eaba09e7c1c990$var$C($84eaba09e7c1c990$var$H, $84eaba09e7c1c990$var$E.prototype);
$84eaba09e7c1c990$var$H.isPureReactComponent = !0;
var $84eaba09e7c1c990$var$I = Array.isArray, $84eaba09e7c1c990$var$J = Object.prototype.hasOwnProperty, $84eaba09e7c1c990$var$K = {
    current: null
}, $84eaba09e7c1c990$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $84eaba09e7c1c990$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$84eaba09e7c1c990$var$J.call(b, d) && !$84eaba09e7c1c990$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $84eaba09e7c1c990$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $84eaba09e7c1c990$var$K.current
    };
}
function $84eaba09e7c1c990$var$N(a, b) {
    return {
        $$typeof: $84eaba09e7c1c990$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $84eaba09e7c1c990$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $84eaba09e7c1c990$var$l;
}
function $84eaba09e7c1c990$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $84eaba09e7c1c990$var$P = /\/+/g;
function $84eaba09e7c1c990$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $84eaba09e7c1c990$var$escape("" + a.key) : b.toString(36);
}
function $84eaba09e7c1c990$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $84eaba09e7c1c990$var$l:
                case $84eaba09e7c1c990$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $84eaba09e7c1c990$var$Q(h, 0) : d, $84eaba09e7c1c990$var$I(c) ? (e = "", null != a && (e = a.replace($84eaba09e7c1c990$var$P, "$&/") + "/"), $84eaba09e7c1c990$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($84eaba09e7c1c990$var$O(c) && (c = $84eaba09e7c1c990$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($84eaba09e7c1c990$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($84eaba09e7c1c990$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $84eaba09e7c1c990$var$Q(k, g);
        h += $84eaba09e7c1c990$var$R(k, b, e, f, c);
    }
    else if (f = $84eaba09e7c1c990$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $84eaba09e7c1c990$var$Q(k, g++), h += $84eaba09e7c1c990$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $84eaba09e7c1c990$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $84eaba09e7c1c990$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $84eaba09e7c1c990$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $84eaba09e7c1c990$var$U = {
    current: null
}, $84eaba09e7c1c990$var$V = {
    transition: null
}, $84eaba09e7c1c990$var$W = {
    ReactCurrentDispatcher: $84eaba09e7c1c990$var$U,
    ReactCurrentBatchConfig: $84eaba09e7c1c990$var$V,
    ReactCurrentOwner: $84eaba09e7c1c990$var$K
};
function $84eaba09e7c1c990$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$84eaba09e7c1c990$export$dca3b0875bd9a954 = {
    map: $84eaba09e7c1c990$var$S,
    forEach: function(a, b, e) {
        $84eaba09e7c1c990$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $84eaba09e7c1c990$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $84eaba09e7c1c990$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$84eaba09e7c1c990$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$84eaba09e7c1c990$export$16fa2f45be04daa8 = $84eaba09e7c1c990$var$E;
$84eaba09e7c1c990$export$ffb0004e005737fa = $84eaba09e7c1c990$var$p;
$84eaba09e7c1c990$export$e2c29f18771995cb = $84eaba09e7c1c990$var$r;
$84eaba09e7c1c990$export$221d75b3f55bb0bd = $84eaba09e7c1c990$var$G;
$84eaba09e7c1c990$export$5f8d39834fd61797 = $84eaba09e7c1c990$var$q;
$84eaba09e7c1c990$export$74bf444e3cd11ea5 = $84eaba09e7c1c990$var$w;
$84eaba09e7c1c990$export$ae55be85d98224ed = $84eaba09e7c1c990$var$W;
$84eaba09e7c1c990$export$3ba232387fd5d6dd = $84eaba09e7c1c990$var$X;
$84eaba09e7c1c990$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $84eaba09e7c1c990$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $84eaba09e7c1c990$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$84eaba09e7c1c990$var$J.call(b, f) && !$84eaba09e7c1c990$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $84eaba09e7c1c990$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$84eaba09e7c1c990$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $84eaba09e7c1c990$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $84eaba09e7c1c990$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$84eaba09e7c1c990$export$c8a8987d4410bf2d = $84eaba09e7c1c990$var$M;
$84eaba09e7c1c990$export$d38cd72104c1f0e9 = function(a) {
    var b = $84eaba09e7c1c990$var$M.bind(null, a);
    b.type = a;
    return b;
};
$84eaba09e7c1c990$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$84eaba09e7c1c990$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $84eaba09e7c1c990$var$v,
        render: a
    };
};
$84eaba09e7c1c990$export$a8257692ac88316c = $84eaba09e7c1c990$var$O;
$84eaba09e7c1c990$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $84eaba09e7c1c990$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $84eaba09e7c1c990$var$T
    };
};
$84eaba09e7c1c990$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $84eaba09e7c1c990$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$84eaba09e7c1c990$export$7568632d0d33d16d = function(a) {
    var b = $84eaba09e7c1c990$var$V.transition;
    $84eaba09e7c1c990$var$V.transition = {};
    try {
        a();
    } finally{
        $84eaba09e7c1c990$var$V.transition = b;
    }
};
$84eaba09e7c1c990$export$88948ce120ea2619 = $84eaba09e7c1c990$var$X;
$84eaba09e7c1c990$export$35808ee640e87ca7 = function(a, b) {
    return $84eaba09e7c1c990$var$U.current.useCallback(a, b);
};
$84eaba09e7c1c990$export$fae74005e78b1a27 = function(a) {
    return $84eaba09e7c1c990$var$U.current.useContext(a);
};
$84eaba09e7c1c990$export$dc8fbce3eb94dc1e = function() {};
$84eaba09e7c1c990$export$6a7bc4e911dc01cf = function(a) {
    return $84eaba09e7c1c990$var$U.current.useDeferredValue(a);
};
$84eaba09e7c1c990$export$6d9c69b0de29b591 = function(a, b) {
    return $84eaba09e7c1c990$var$U.current.useEffect(a, b);
};
$84eaba09e7c1c990$export$f680877a34711e37 = function() {
    return $84eaba09e7c1c990$var$U.current.useId();
};
$84eaba09e7c1c990$export$d5a552a76deda3c2 = function(a, b, e) {
    return $84eaba09e7c1c990$var$U.current.useImperativeHandle(a, b, e);
};
$84eaba09e7c1c990$export$aaabe4eda9ed9969 = function(a, b) {
    return $84eaba09e7c1c990$var$U.current.useInsertionEffect(a, b);
};
$84eaba09e7c1c990$export$e5c5a5f917a5871c = function(a, b) {
    return $84eaba09e7c1c990$var$U.current.useLayoutEffect(a, b);
};
$84eaba09e7c1c990$export$1538c33de8887b59 = function(a, b) {
    return $84eaba09e7c1c990$var$U.current.useMemo(a, b);
};
$84eaba09e7c1c990$export$13e3392192263954 = function(a, b, e) {
    return $84eaba09e7c1c990$var$U.current.useReducer(a, b, e);
};
$84eaba09e7c1c990$export$b8f5890fc79d6aca = function(a) {
    return $84eaba09e7c1c990$var$U.current.useRef(a);
};
$84eaba09e7c1c990$export$60241385465d0a34 = function(a) {
    return $84eaba09e7c1c990$var$U.current.useState(a);
};
$84eaba09e7c1c990$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $84eaba09e7c1c990$var$U.current.useSyncExternalStore(a, b, e);
};
$84eaba09e7c1c990$export$7b286972b8d8ccbf = function() {
    return $84eaba09e7c1c990$var$U.current.useTransition();
};
$84eaba09e7c1c990$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("7c65l", function(module, exports) {

module.exports = (parcelRequire("VqeAM"));

});
parcelRegister("VqeAM", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_17 = [
        'navigation',
        'request',
        'process',
        'log',
        'user',
        'state',
        'error',
        'manual'
    ];
    // Array#reduce
    var _$reduce_26 = function(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    };
    // Array#filter
    var _$filter_21 = function(arr, fn) {
        return _$reduce_26(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    };
    // Array#includes
    var _$includes_22 = function(arr, x) {
        return _$reduce_26(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_23 = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable('toString');
    var _dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    // Object#keys
    var _$keys_24 = function(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_33 = function(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
        };
    };
    var _$listOfFunctions_34 = function(value) {
        return typeof value === 'function' || _$isArray_23(value) && _$filter_21(value, function(f) {
            return typeof f === 'function';
        }).length === value.length;
    };
    var _$stringWithLength_35 = function(value) {
        return typeof value === 'string' && !!value.length;
    };
    var _$config_14 = {};
    var defaultErrorTypes = function() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_14.schema = {
        apiKey: {
            defaultValue: function() {
                return null;
            },
            message: 'is required',
            validate: _$stringWithLength_35
        },
        appVersion: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || _$stringWithLength_35(value);
            }
        },
        appType: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || _$stringWithLength_35(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function() {
                return true;
            },
            message: 'should be true|false',
            validate: function(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function() {
                return defaultErrorTypes();
            },
            message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
            allowPartialObject: true,
            validate: function(value) {
                // ensure we have an object
                if (typeof value !== 'object' || !value) return false;
                var providedKeys = _$keys_24(value);
                var defaultKeys = _$keys_24(defaultErrorTypes());
                // ensure it only has a subset of the allowed keys
                if (_$filter_21(providedKeys, function(k) {
                    return _$includes_22(defaultKeys, k);
                }).length < providedKeys.length) return false;
                // ensure all of the values are boolean
                if (_$filter_21(_$keys_24(value), function(k) {
                    return typeof value[k] !== 'boolean';
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_34
        },
        onSession: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_34
        },
        onBreadcrumb: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_34
        },
        endpoints: {
            defaultValue: function(endpoints) {
                // only apply the default value if no endpoints have been provided, otherwise prevent delivery by setting to null
                if (typeof endpoints === 'undefined') return {
                    notify: 'https://notify.bugsnag.com',
                    sessions: 'https://sessions.bugsnag.com'
                };
                else return {
                    notify: null,
                    sessions: null
                };
            },
            message: 'should be an object containing endpoint URLs { notify, sessions }',
            validate: function(val) {
                return(// first, ensure it's an object
                val && typeof val === 'object' && // notify and sessions must always be set
                _$stringWithLength_35(val.notify) && _$stringWithLength_35(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_21(_$keys_24(val), function(k) {
                    return !_$includes_22([
                        'notify',
                        'sessions'
                    ], k);
                }).length === 0);
            }
        },
        autoTrackSessions: {
            defaultValue: function(val) {
                return true;
            },
            message: 'should be true|false',
            validate: function(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function() {
                return null;
            },
            message: 'should be an array of strings',
            validate: function(value) {
                return value === null || _$isArray_23(value) && _$filter_21(value, function(f) {
                    return typeof f === 'string';
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function() {
                return 'production';
            },
            message: 'should be a string',
            validate: function(value) {
                return typeof value === 'string' && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function() {
                return 25;
            },
            message: "should be a number \u2264100",
            validate: function(value) {
                return _$intRange_33(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function() {
                return _$breadcrumbTypes_17;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_17.join(',') + ")",
            validate: function(value) {
                return value === null || _$isArray_23(value) && _$reduce_26(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_22(_$breadcrumbTypes_17, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || typeof value === 'string';
            }
        },
        user: {
            defaultValue: function() {
                return {};
            },
            message: 'should be an object with { id, email, name } properties',
            validate: function(value) {
                return value === null || value && _$reduce_26(_$keys_24(value), function(accum, key) {
                    return accum && _$includes_22([
                        'id',
                        'email',
                        'name'
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function() {
                return {};
            },
            message: 'should be an object',
            validate: function(value) {
                return typeof value === 'object' && value !== null;
            }
        },
        logger: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be null or an object with methods { debug, info, warn, error }',
            validate: function(value) {
                return !value || value && _$reduce_26([
                    'debug',
                    'info',
                    'warn',
                    'error'
                ], function(accum, method) {
                    return accum && typeof value[method] === 'function';
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function() {
                return [
                    'password'
                ];
            },
            message: 'should be an array of strings|regexes',
            validate: function(value) {
                return _$isArray_23(value) && value.length === _$filter_21(value, function(s) {
                    return typeof s === 'string' || s && typeof s.test === 'function';
                }).length;
            }
        },
        plugins: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of plugin objects',
            validate: function(value) {
                return _$isArray_23(value) && value.length === _$filter_21(value, function(p) {
                    return p && typeof p === 'object' && typeof p.load === 'function';
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function(value) {
                return _$isArray_23(value) && value.length === _$filter_21(value, function(feature) {
                    return feature && typeof feature === 'object' && typeof feature.name === 'string';
                }).length;
            }
        },
        reportUnhandledPromiseRejectionsAsHandled: {
            defaultValue: function() {
                return false;
            },
            message: 'should be true|false',
            validate: function(value) {
                return value === true || value === false;
            }
        },
        sendPayloadChecksums: {
            defaultValue: function() {
                return false;
            },
            message: 'should be true|false',
            validate: function(value) {
                return value === true || value === false;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_20 = function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    // Array#map
    var _$map_25 = function(arr, fn) {
        return _$reduce_26(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        return _extends = Object.assign ? Object.assign.bind() : function(n) {
            for(var e = 1; e < arguments.length; e++){
                var t = arguments[e];
                for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
            }
            return n;
        }, _extends.apply(null, arguments);
    }
    var schema = _$config_14.schema;
    var _$config_10 = {
        releaseStage: _$assign_20({}, schema.releaseStage, {
            defaultValue: function() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
                return 'production';
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function() {
                return 'browser';
            }
        }),
        logger: _$assign_20({}, schema.logger, {
            defaultValue: function() {
                return(// set logger based on browser capability
                typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined);
            }
        })
    };
    var getPrefixedConsole = function() {
        var logger = {};
        var consoleLog = console.log;
        _$map_25([
            'debug',
            'info',
            'warn',
            'error'
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_12 = Breadcrumb;
    var _$stackframe_9 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
        else if (typeof _$stackframe_9 === 'object') _$stackframe_9 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        'use strict';
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            'isConstructor',
            'isEval',
            'isNative',
            'isToplevel'
        ];
        var numericProps = [
            'columnNumber',
            'lineNumber'
        ];
        var stringProps = [
            'fileName',
            'functionName',
            'source'
        ];
        var arrayProps = [
            'args'
        ];
        var objectProps = [
            'evalOrigin'
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
        function StackFrame(obj) {
            if (!obj) return;
            for(var i = 0; i < props.length; i++)if (obj[props[i]] !== undefined) this['set' + _capitalize(props[i])](obj[props[i]]);
        }
        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
                this.args = v;
            },
            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError('Eval Origin must be an Object or StackFrame');
            },
            toString: function() {
                var fileName = this.getFileName() || '';
                var lineNumber = this.getLineNumber() || '';
                var columnNumber = this.getColumnNumber() || '';
                var functionName = this.getFunctionName() || '';
                if (this.getIsEval()) {
                    if (fileName) return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                    return '[eval]:' + lineNumber + ':' + columnNumber;
                }
                if (functionName) return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                return fileName + ':' + lineNumber + ':' + columnNumber;
            }
        };
        StackFrame.fromString = function StackFrame$$fromString(str) {
            var argsStartIndex = str.indexOf('(');
            var argsEndIndex = str.lastIndexOf(')');
            var functionName = str.substring(0, argsStartIndex);
            var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
            var locationString = str.substring(argsEndIndex + 1);
            if (locationString.indexOf('@') === 0) {
                var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
                var fileName = parts[1];
                var lineNumber = parts[2];
                var columnNumber = parts[3];
            }
            return new StackFrame({
                functionName: functionName,
                args: args || undefined,
                fileName: fileName,
                lineNumber: lineNumber || undefined,
                columnNumber: columnNumber || undefined
            });
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype['set' + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + ' must be a Number');
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype['set' + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$stackGenerator_8 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stack-generator', [
            'stackframe'
        ], factory);
        else if (typeof _$stackGenerator_8 === 'object') _$stackGenerator_8 = factory(_$stackframe_9);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr['arguments']){
                    // Allow V8 optimizations
                    var args = new Array(curr['arguments'].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr['arguments'][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    });
    var _$errorStackParser_6 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
            'stackframe'
        ], factory);
        else if (typeof _$errorStackParser_6 === 'object') _$errorStackParser_6 = factory(_$stackframe_9);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        'use strict';
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error('Cannot parse given Error object');
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(':') === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(\),.*$)/g, '');
                    var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(');
                    // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                    // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1);
                    // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(' ') || undefined;
                    var fileName = [
                        'eval',
                        '<anonymous>'
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                    if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split('\n');
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split('\n');
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || '';
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^)]*\)/g, '') || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                    var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_19 = _$errorStackParser_6;
    var _$safeJsonStringify_5 = function(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = '...';
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return '[Throws: ' + (err ? err.message : '?') + ']';
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    }
    // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_5(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || typeof obj !== 'object') return obj;
            if (find(seen, obj)) return '[Circular]';
            seen.push(obj);
            if (typeof obj.toJSON === 'function') try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_5(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat('[]')));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = '[REDACTED]';
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    }
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== 'string') return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== 'string') variant = _$safeJsonStringify_5(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === 'number') {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_23(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || typeof feature !== 'object') continue;
            // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    }
    // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_25(_$filter_21(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            };
            // don't add a 'variant' property unless there's actually a value
            if (typeof variant === 'string') flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === 'number') {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_27 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_28 = function(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_7 = __isError_7;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_7(value) {
        switch(Object.prototype.toString.call(value)){
            case '[object Error]':
                return true;
            case '[object Exception]':
                return true;
            case '[object DOMException]':
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_29 = _$isError_7;
    var __add_31 = function(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates;
        // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_31(state, section);
        // normalise the two supported input types into object form
        if (typeof keyOrObj === 'object') updates = keyOrObj;
        if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates);
        // exit if we don't have an updates object at this point
        if (!updates) return;
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // ensure a section with this name exists
        if (!state[section]) state[section] = {};
        // merge the updates with the existing section
        state[section] = _$assign_20({}, state[section], updates);
    };
    var get = function(state, section, key) {
        if (typeof section !== 'string') return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_31 = function(state, section, key) {
        if (typeof section !== 'string') return;
        // clear an entire section
        if (!key) {
            delete state[section];
            return;
        }
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_31 = {
        add: __add_31,
        get: get,
        clear: __clear_31
    };
    function ___extends_15() {
        return ___extends_15 = Object.assign ? Object.assign.bind() : function(n) {
            for(var e = 1; e < arguments.length; e++){
                var t = arguments[e];
                for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
            }
            return n;
        }, ___extends_15.apply(null, arguments);
    }
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this._correlation = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ];
        // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_31.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.setTraceCorrelation = function setTraceCorrelation(traceId, spanId) {
            if (typeof traceId === 'string') this._correlation = ___extends_15({
                traceId: traceId
            }, typeof spanId === 'string' ? {
                spanId: spanId
            } : {});
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_31.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_31.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_27.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_27.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_27.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_27.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: '4',
                exceptions: _$map_25(this.errors, function(er) {
                    return _$assign_20({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags(),
                correlation: this._correlation
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        };
        // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = 'global code';
        return f;
    };
    var normaliseFunctionName = function(name) {
        return /^global code$/i.test(name) ? 'global code' : name;
    };
    var defaultHandledState = function() {
        return {
            unhandled: false,
            severity: 'warning',
            severityReason: {
                type: 'handledException'
            }
        };
    };
    var ensureString = function(str) {
        return typeof str === 'string' ? str : '';
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_26(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame);
                // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === '{}') return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    }
    // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_28(error)) return _$errorStackParser_19.parse(error).slice(errorFramesToSkip);
        // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_21(_$stackGenerator_8.backtrace(), function(frame) {
                return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
            // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
            // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === 'InvalidError') event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_25(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_29(cause) && _$hasStack_28(cause) ? _$errorStackParser_19.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, 'error cause'), error = _normaliseError2[0];
                if (error.name === 'InvalidError') event.addMetadata('error cause', makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function(err) {
        if (err === null) return 'null';
        if (err === undefined) return 'undefined';
        return err;
    };
    var normaliseError = function(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function(reason) {
            var verb = component === 'error cause' ? 'was' : 'received';
            if (logger) logger.warn(component + " " + verb + " a non-error: \"" + reason + "\"");
            var err = new Error(component + " " + verb + " a non-error. See \"" + component + "\" tab for more detail.");
            err.name = 'InvalidError';
            return err;
        };
        // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_29(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError);
                internalFrames += 2;
            }
        } else switch(typeof maybeError){
            case 'string':
            case 'number':
            case 'boolean':
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case 'function':
                error = createAndLogInputError('function');
                internalFrames += 2;
                break;
            case 'object':
                if (maybeError !== null && _$iserror_29(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError('nothing');
                internalFrames += 2;
        }
        if (!_$hasStack_28(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_28(e)) {
                error = e;
                // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    };
    // default value for stacktrace.type
    Event.__type = 'browserjs';
    var hasNecessaryFields = function(error) {
        return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
    };
    var _$Event_15 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_16 = function(arr, fn, cb) {
        var index = 0;
        var next = function() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    };
    var _$callbackRunner_18 = function(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function(fn, cb) {
            if (typeof fn !== 'function') return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event);
                    // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === 'function') return ret.then(// resolve
                    function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, // reject
                    function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                }
                // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_16(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_32 = function(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_4 = function pad(num, size) {
        var s = '000000000' + num;
        return s.substr(s.length - size);
    };
    var env = typeof window === 'object' ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_4((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_2 = function fingerprint() {
        return clientId;
    };
    /**
 * Check the provided value is a valid device id
 * @param {unknown} value
 * @returns
 */ var _$isCuid_3 = function isCuid(value) {
        return typeof value === 'string' && /^c[a-z0-9]{20,32}$/.test(value);
    };
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_4((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = 'c', // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_4(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_2(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_2;
    cuid.isCuid = _$isCuid_3;
    var _$cuid_1 = cuid;
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_1();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
        };
        return Session;
    }();
    var _$Session_36 = Session;
    var __add_13 = _$featureFlagDelegate_27.add, __clear_13 = _$featureFlagDelegate_27.clear, __merge_13 = _$featureFlagDelegate_27.merge;
    var HUB_PREFIX = '00000';
    var HUB_NOTIFY = 'https://notify.insighthub.smartbear.com';
    var HUB_SESSION = 'https://sessions.insighthub.smartbear.com';
    var noop = function() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_14.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier;
            // intialise opts and config
            this._config = {};
            this._schema = schema;
            // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            };
            // plugins
            this._plugins = {};
            // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {};
            // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            };
            // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_15;
            this.Breadcrumb = _$Breadcrumb_12;
            this.Session = _$Session_36;
            this._config = this._configure(configuration, internalPlugins);
            _$map_25(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            });
            // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var self1 = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(self1, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_31.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_31.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_31.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_13(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_13(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_13(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_26(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_20({}, schema, plugin.configSchema);
                return schema;
            }, this._schema);
            // sendPayloadChecksums is false by default unless custom endpoints are not specified
            if (!opts.endpoints) opts.sendPayloadChecksums = 'sendPayloadChecksums' in opts ? opts.sendPayloadChecksums : true;
            // accumulate configuration and error messages
            var _reduce = _$reduce_26(_$keys_24(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_20(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error('No Bugsnag API Key set');
                // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
                if (opts.endpoints === undefined && config.apiKey.startsWith(HUB_PREFIX)) config.endpoints = {
                    notify: HUB_NOTIFY,
                    sessions: HUB_SESSION
                };
            }
            // update and elevate some options
            this._metadata = _$assign_20({}, config.metadata);
            __merge_13(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_20({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger;
            // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession);
            // finally warn about any invalid config where we fell back to the default
            if (_$keys_24(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this);
            // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_36();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_20({}, this._user);
            // run onSession callbacks
            var ignore = _$syncCallbackRunner_32(this._cbs.s, session, 'onSession', this._logger);
            if (ignore) {
                this._logger.debug('Session not started due to onSession callback');
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_21(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_21(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_21(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === 'string' ? message : '';
            type = typeof type === 'string' && _$includes_22(_$breadcrumbTypes_17, type) ? type : 'manual';
            metadata = typeof metadata === 'object' && metadata !== null ? metadata : {};
            // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_12(message, metadata, type);
            // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_32(this._cbs.b, crumb, 'onBreadcrumb', this._logger);
            if (ignore) {
                this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');
                return;
            }
            // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_22(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_15.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_20({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_20({}, event._metadata, this._metadata);
            event._user = _$assign_20({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_13(event._features, this._features, event._featuresIndex);
            // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_22(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway\u2026");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_18(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug('Event not sent due to onError callback');
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled('error')) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, 'error');
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: 'userCallbackSetSeverity'
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_25(_$keys_24(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join('\n\n'));
        return er;
    };
    var stringify = function(val) {
        switch(typeof val){
            case 'string':
            case 'number':
            case 'object':
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_13 = Client;
    var _$jsonPayload_30 = {};
    var EVENT_REDACTION_PATHS = [
        'events.[].metaData',
        'events.[].breadcrumbs.[].metaData',
        'events.[].request'
    ];
    _$jsonPayload_30.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_5(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_5(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_30.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_5(session, null, null);
        return payload;
    };
    var _$delivery_37 = {};
    _$delivery_37 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                if (client._config.endpoints.notify === null) {
                    var err = new Error('Event not sent due to incomplete endpoint configuration');
                    return cb(err);
                }
                var url = getApiUrl(client._config, 'notify', '4', win);
                var body = _$jsonPayload_30.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error('Event failed to send');
                    client._logger.error("Event failed to send\u2026", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                if (client._config.endpoints.sessions === null) {
                    var err = new Error('Session not sent due to incomplete endpoint configuration');
                    return cb(err);
                }
                var url = getApiUrl(client._config, 'sessions', '1', win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_30.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_37._matchPageProtocol = function(endpoint, pageProtocol) {
        return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
    };
    function getIntegrityHeaderValue(windowOrWorkerGlobalScope, requestBody) {
        if (windowOrWorkerGlobalScope.isSecureContext && windowOrWorkerGlobalScope.crypto && windowOrWorkerGlobalScope.crypto.subtle && windowOrWorkerGlobalScope.crypto.subtle.digest && typeof TextEncoder === 'function') {
            var msgUint8 = new TextEncoder().encode(requestBody);
            return windowOrWorkerGlobalScope.crypto.subtle.digest('SHA-1', msgUint8).then(function(hashBuffer) {
                var hashArray = Array.from(new Uint8Array(hashBuffer));
                var hashHex = hashArray.map(function(b) {
                    return b.toString(16).padStart(2, '0');
                }).join('');
                return 'sha1 ' + hashHex;
            });
        }
        return Promise.resolve();
    }
    var _$delivery_38 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.notify;
                    if (url === null) {
                        var err = new Error('Event not sent due to incomplete endpoint configuration');
                        return cb(err);
                    }
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_30.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var _err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send\u2026", _err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(_err);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '4');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    if (client._config.sendPayloadChecksums && typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) getIntegrityHeaderValue(win, body).then(function(integrity) {
                        if (integrity) req.setRequestHeader('Bugsnag-Integrity', integrity);
                        req.send(body);
                    })["catch"](function(err) {
                        client._logger.error(err);
                        req.send(body);
                    });
                    else req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.sessions;
                    if (url === null) {
                        var err = new Error('Session not sent due to incomplete endpoint configuration');
                        return cb(err);
                    }
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_30.session(session, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var _err2 = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send\u2026", _err2);
                                cb(_err2);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '1');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    if (client._config.sendPayloadChecksums && typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) getIntegrityHeaderValue(win, body).then(function(integrity) {
                        if (integrity) req.setRequestHeader('Bugsnag-Integrity', integrity);
                        req.send(body);
                    })["catch"](function(err) {
                        client._logger.error(err);
                        req.send(body);
                    });
                    else req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function() {
        appStart = new Date();
    };
    var _$app_39 = {
        name: 'appDuration',
        load: function(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_40 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';
    var getDeviceId = function(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY);
            // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
            id = _$cuid_1();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {
        // If localStorage is not available (e.g. because it's disabled) then give up
        }
    };
    /*
 * Automatically detects browser device details
 */ var _$device_41 = function(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? 'landscape' : 'portrait';
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_20({}, session.device, device);
                    // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                });
                // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_20({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    var setDefaultUserId = function(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    };
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_42 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_20({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    };
    var _$session_43 = {
        load: function(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null;
            // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_22(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
            // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            }
            // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    };
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_44 = {
        load: function(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
                event._user = _$assign_20({
                    id: '[REDACTED]'
                }, event._user);
                event.request = _$assign_20({
                    clientIp: '[REDACTED]'
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function() {
                    return true;
                },
                message: 'should be true|false',
                validate: function(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_45 = {};
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_45.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled('log')) return;
        _$map_25(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb('Console output', _$reduce_26(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = '[Unknown value]';
                    // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {}
                    // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === '[object Object]') // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf('group') === 0 ? 'log' : method
                }), 'log');
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_21([
        'log',
        'debug',
        'info',
        'warn',
        'error'
    ], function(method) {
        return typeof console !== 'undefined' && typeof console[method] === 'function';
    });
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_46 = function(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = '';
                // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === 'complete' : doc.readyState !== 'loading';
                var getHtml = function() {
                    return doc.documentElement.outerHTML;
                };
                // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange;
                // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === 'interactive') {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName('script');
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml();
                    // simulate the raw html
                    var htmlLines = [
                        '<!-- DOC START -->'
                    ].concat(html.split('\n'));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_26(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_21(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0];
                    // remove hash and query string from url
                    var cleanUrl = function(url) {
                        return url.replace(/#.*$/, '').replace(/\?.*$/, '');
                    };
                    // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && cleanUrl(frame.file) !== cleanUrl(originalLocation)) return;
                    // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
                        // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true);
                // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_25([
                    'setTimeout',
                    'setInterval',
                    'setImmediate',
                    'requestAnimationFrame'
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function() {
                                    return args[0];
                                },
                                replace: function(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0];
                // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_25([
                    'EventTarget',
                    'Window',
                    'Node',
                    'ApplicationCache',
                    'AudioTrackList',
                    'ChannelMergerNode',
                    'CryptoOperation',
                    'EventSource',
                    'FileReader',
                    'HTMLUnknownElement',
                    'IDBDatabase',
                    'IDBRequest',
                    'IDBTransaction',
                    'KeyOperation',
                    'MediaController',
                    'MessagePort',
                    'ModalWindow',
                    'Notification',
                    'SVGElementInstance',
                    'Screen',
                    'TextTrack',
                    'TextTrackCue',
                    'TextTrackList',
                    'WebSocket',
                    'WebSocketWorker',
                    'Worker',
                    'XMLHttpRequest',
                    'XMLHttpRequestEventTarget',
                    'XMLHttpRequestUpload'
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;
                    __proxy(win[o].prototype, 'addEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, 'removeEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== 'function') return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript();
                                // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script);
                                    // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // swallow these errors on Selenium:
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        }
                        // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
        return {
            get: function() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_47 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('user')) return;
                win.addEventListener('click', function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = '[hidden]';
                        targetSelector = '[hidden]';
                        client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
                    }
                    client.leaveBreadcrumb('UI click', {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, 'user');
                }, true);
            }
        };
    };
    var trim = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || '';
        if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
        text = text.replace(trim, '$1');
        if (text.length > 140) return text.slice(0, 135) + '(...)';
        return text;
    }
    // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push('#' + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.'));
        // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');
        try {
            if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join('');
        }
        // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
        return parts.join('');
    }
    var _$navigationBreadcrumbs_48 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_48 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('navigation')) return;
                // returns a function that will drop a breadcrumb with a given name
                var drop = function(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, 'navigation');
                    };
                };
                // simple drops – just names, no meta
                win.addEventListener('pagehide', drop('Page hidden'), true);
                win.addEventListener('pageshow', drop('Page shown'), true);
                win.addEventListener('load', drop('Page loaded'), true);
                win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true);
                // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener('load', function() {
                    return win.addEventListener('popstate', drop('Navigated back'), true);
                });
                // hashchange has some metadata that we care about
                win.addEventListener('hashchange', function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
                }, true);
                // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win, true);
                if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
            }
        };
        return plugin;
    };
    // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function(url, win) {
        var a = win.document.createElement('A');
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function(client, target, fn, win, resetEventCount) {
        if (resetEventCount === void 0) resetEventCount = false;
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation');
            // if throttle plugin is in use, reset the event sent count
            if (resetEventCount && typeof client.resetEventCount === 'function') client.resetEventCount();
            // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = 'request';
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_49 = function(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function(client) {
                if (!client._isBreadcrumbTypeEnabled('request')) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch();
                // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!('addEventListener' in win.XMLHttpRequest.prototype) || !('WeakMap' in win)) return;
                    var trackedRequests = new WeakMap();
                    var requestHandlers = new WeakMap();
                    var originalOpen = win.XMLHttpRequest.prototype.open;
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        // it's possible for `this` to be `undefined`, which is not a valid key for a WeakMap
                        if (this) trackedRequests.set(this, {
                            method: method,
                            url: url
                        });
                        originalOpen.apply(this, arguments);
                    };
                    var originalSend = win.XMLHttpRequest.prototype.send;
                    win.XMLHttpRequest.prototype.send = function send(body) {
                        var _this = this;
                        var requestData = trackedRequests.get(this);
                        if (requestData) {
                            // if we have already setup listeners then this request instance is being reused,
                            // so we need to remove the listeners from the previous send
                            var listeners = requestHandlers.get(this);
                            if (listeners) {
                                this.removeEventListener('load', listeners.load);
                                this.removeEventListener('error', listeners.error);
                            }
                            var requestStart = new Date();
                            var error = function() {
                                return handleXHRError(requestData.method, requestData.url, getDuration(requestStart));
                            };
                            var load = function() {
                                return handleXHRLoad(requestData.method, requestData.url, _this.status, getDuration(requestStart));
                            };
                            this.addEventListener('load', load);
                            this.addEventListener('error', error);
                            // it's possible for `this` to be `undefined`, which is not a valid key for a WeakMap
                            if (this) requestHandlers.set(this, {
                                load: load,
                                error: error
                            });
                        }
                        originalSend.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status, duration) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === 'string' && _$includes_22(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        method: String(method),
                        url: String(url),
                        duration: duration
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url, duration) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    if (typeof url === 'string' && _$includes_22(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    // failed to contact server
                    client.leaveBreadcrumb('XMLHttpRequest error', {
                        method: String(method),
                        url: String(url),
                        duration: duration
                    }, BREADCRUMB_TYPE);
                }
                // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!('fetch' in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && typeof urlOrRequest === 'object') {
                            url = urlOrRequest.url;
                            if (options && 'method' in options) method = options.method;
                            else if (urlOrRequest && 'method' in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && 'method' in options) method = options.method;
                        }
                        if (method === undefined) method = 'GET';
                        return new Promise(function(resolve, reject) {
                            var requestStart = new Date();
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url, getDuration(requestStart));
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url, getDuration(requestStart));
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function(response, method, url, duration) {
                    var metadata = {
                        method: String(method),
                        status: response.status,
                        url: String(url),
                        duration: duration
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function(method, url, duration) {
                    client.leaveBreadcrumb('fetch() error', {
                        method: String(method),
                        url: String(url),
                        duration: duration
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    };
    var getDuration = function(startTime) {
        return startTime && new Date() - startTime;
    };
    /*
 * Throttles and dedupes events
 */ var _$throttle_50 = {
        load: function(client) {
            // track sent events for each init of the plugin
            var n = 0;
            // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function() {
                    return 10;
                },
                message: "should be a positive integer \u2264100",
                validate: function(val) {
                    return _$intRange_33(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_51 = {};
    _$stripQueryString_51 = {
        load: function(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_26(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_25(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_51._strip = function(str) {
        return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_52 = function(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = 'window onerror';
        return {
            load: function(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: 'error',
                            unhandled: true,
                            severityReason: {
                                type: 'unhandledException'
                            }
                        };
                        var event;
                        // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// This complex case detects "error" events that are typically synthesised
                        // by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error';
                            // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || '';
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1);
                            // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent;
                            // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    };
    // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === 'string') culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function(n) {
        return typeof n === 'number' && String.call(n) !== 'NaN';
    };
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_53 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function(evt) {
                    var error = evt.reason;
                    var isBluebird = false;
                    // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    // Report unhandled promise rejections as handled if the user has configured it
                    var unhandled = !client._config.reportUnhandledPromiseRejectionsAsHandled;
                    var event = client.Event.create(error, false, {
                        severity: 'error',
                        unhandled: unhandled,
                        severityReason: {
                            type: 'unhandledPromiseRejection'
                        }
                    }, 'unhandledrejection handler', 1, client._logger);
                    if (isBluebird) _$map_25(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_29(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ('addEventListener' in win) win.addEventListener('unhandledrejection', listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    };
    // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, '');
        };
    };
    var _$notifier_11 = {};
    var name = 'Bugsnag JavaScript';
    var version = '8.4.0';
    var url = 'https://github.com/bugsnag/bugsnag-js';
    // extend the base config schema with some browser-specific options
    var __schema_11 = _$assign_20({}, _$config_14.schema, _$config_10);
    var Bugsnag = {
        _client: null,
        createClient: function(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === 'string') opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                // add browser-specific plugins
                _$app_39,
                _$device_41(),
                _$context_40(),
                _$request_42(),
                _$throttle_50,
                _$session_43,
                _$clientIp_44,
                _$stripQueryString_51,
                _$onerror_52(),
                _$unhandledRejection_53(),
                _$navigationBreadcrumbs_48(),
                _$interactionBreadcrumbs_47(),
                _$networkBreadcrumbs_49(),
                _$consoleBreadcrumbs_45,
                // this one added last to avoid wrapping functionality before bugsnag uses it
                _$inlineScriptContent_46()
            ];
            // configure a client with user supplied options
            var bugsnag = new _$Client_13(opts, __schema_11, internalPlugins, {
                name: name,
                version: version,
                url: url
            });
            // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_37 : _$delivery_38);
            bugsnag._logger.debug('Loaded!');
            bugsnag.leaveBreadcrumb('Bugsnag loaded', {}, 'state');
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function() {
            return Bugsnag._client != null;
        }
    };
    _$map_25([
        'resetEventCount'
    ].concat(_$keys_24(_$Client_13.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_11 = Bugsnag;
    _$notifier_11.Client = _$Client_13;
    _$notifier_11.Event = _$Event_15;
    _$notifier_11.Session = _$Session_36;
    _$notifier_11.Breadcrumb = _$Breadcrumb_12;
    // Export a "default" property for compatibility with ESM imports
    _$notifier_11["default"] = Bugsnag;
    return _$notifier_11;
});

});


parcelRegister("ioVMT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6574b4f7b743763$export$2e2bcd8739ae039; });

var $hRnoc = parcelRequire("hRnoc");

var $7wVIe = parcelRequire("7wVIe");

var $gyNqR = parcelRequire("gyNqR");

var $4sQKr = parcelRequire("4sQKr");

var $gIlix = parcelRequire("gIlix");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d6574b4f7b743763$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $d6574b4f7b743763$var$includes(collection, value, fromIndex, guard) {
    collection = (0, $7wVIe.default)(collection) ? collection : (0, $gIlix.default)(collection);
    fromIndex = fromIndex && !guard ? (0, $4sQKr.default)(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $d6574b4f7b743763$var$nativeMax(length + fromIndex, 0);
    return (0, $gyNqR.default)(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && (0, $hRnoc.default)(collection, value, fromIndex) > -1;
}
var $d6574b4f7b743763$export$2e2bcd8739ae039 = $d6574b4f7b743763$var$includes;

});
parcelRegister("hRnoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d009878f5c7a8e59$export$2e2bcd8739ae039; });

var $g1I2l = parcelRequire("g1I2l");

var $7dfO8 = parcelRequire("7dfO8");

var $49kBT = parcelRequire("49kBT");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d009878f5c7a8e59$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? (0, $49kBT.default)(array, value, fromIndex) : (0, $g1I2l.default)(array, (0, $7dfO8.default), fromIndex);
}
var $d009878f5c7a8e59$export$2e2bcd8739ae039 = $d009878f5c7a8e59$var$baseIndexOf;

});
parcelRegister("g1I2l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baaee620725b3f92$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $baaee620725b3f92$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var $baaee620725b3f92$export$2e2bcd8739ae039 = $baaee620725b3f92$var$baseFindIndex;

});

parcelRegister("7dfO8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5406025f1816698d$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $5406025f1816698d$var$baseIsNaN(value) {
    return value !== value;
}
var $5406025f1816698d$export$2e2bcd8739ae039 = $5406025f1816698d$var$baseIsNaN;

});

parcelRegister("49kBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3057fd6ca65d0241$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3057fd6ca65d0241$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
var $3057fd6ca65d0241$export$2e2bcd8739ae039 = $3057fd6ca65d0241$var$strictIndexOf;

});


parcelRegister("7wVIe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57b84a08333937c1$export$2e2bcd8739ae039; });

var $f3hTG = parcelRequire("f3hTG");

var $l0TQG = parcelRequire("l0TQG");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $57b84a08333937c1$var$isArrayLike(value) {
    return value != null && (0, $l0TQG.default)(value.length) && !(0, $f3hTG.default)(value);
}
var $57b84a08333937c1$export$2e2bcd8739ae039 = $57b84a08333937c1$var$isArrayLike;

});
parcelRegister("f3hTG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af5504cd9621dd8d$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $42tql = parcelRequire("42tql");
/** `Object#toString` result references. */ var $af5504cd9621dd8d$var$asyncTag = '[object AsyncFunction]', $af5504cd9621dd8d$var$funcTag = '[object Function]', $af5504cd9621dd8d$var$genTag = '[object GeneratorFunction]', $af5504cd9621dd8d$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $af5504cd9621dd8d$var$isFunction(value) {
    if (!(0, $42tql.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $65ROZ.default)(value);
    return tag == $af5504cd9621dd8d$var$funcTag || tag == $af5504cd9621dd8d$var$genTag || tag == $af5504cd9621dd8d$var$asyncTag || tag == $af5504cd9621dd8d$var$proxyTag;
}
var $af5504cd9621dd8d$export$2e2bcd8739ae039 = $af5504cd9621dd8d$var$isFunction;

});
parcelRegister("65ROZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46fcf585fa8cec0b$export$2e2bcd8739ae039; });

var $j22Bs = parcelRequire("j22Bs");

var $b5eRm = parcelRequire("b5eRm");

var $aCh9f = parcelRequire("aCh9f");
/** `Object#toString` result references. */ var $46fcf585fa8cec0b$var$nullTag = '[object Null]', $46fcf585fa8cec0b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $46fcf585fa8cec0b$var$symToStringTag = (0, $j22Bs.default) ? (0, $j22Bs.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $46fcf585fa8cec0b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $46fcf585fa8cec0b$var$undefinedTag : $46fcf585fa8cec0b$var$nullTag;
    return $46fcf585fa8cec0b$var$symToStringTag && $46fcf585fa8cec0b$var$symToStringTag in Object(value) ? (0, $b5eRm.default)(value) : (0, $aCh9f.default)(value);
}
var $46fcf585fa8cec0b$export$2e2bcd8739ae039 = $46fcf585fa8cec0b$var$baseGetTag;

});
parcelRegister("j22Bs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb039290b941713$export$2e2bcd8739ae039; });

var $ewUh0 = parcelRequire("ewUh0");
/** Built-in value references. */ var $ddb039290b941713$var$Symbol = (0, $ewUh0.default).Symbol;
var $ddb039290b941713$export$2e2bcd8739ae039 = $ddb039290b941713$var$Symbol;

});
parcelRegister("ewUh0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93fb491a996ca62$export$2e2bcd8739ae039; });

var $aUlWO = parcelRequire("aUlWO");
/** Detect free variable `self`. */ var $a93fb491a996ca62$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a93fb491a996ca62$var$root = (0, $aUlWO.default) || $a93fb491a996ca62$var$freeSelf || Function('return this')();
var $a93fb491a996ca62$export$2e2bcd8739ae039 = $a93fb491a996ca62$var$root;

});
parcelRegister("aUlWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f1028a9d451d10a$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $7f1028a9d451d10a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $7f1028a9d451d10a$export$2e2bcd8739ae039 = $7f1028a9d451d10a$var$freeGlobal;

});



parcelRegister("b5eRm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $811bb0254ecabe93$export$2e2bcd8739ae039; });

var $j22Bs = parcelRequire("j22Bs");
/** Used for built-in method references. */ var $811bb0254ecabe93$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $811bb0254ecabe93$var$hasOwnProperty = $811bb0254ecabe93$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $811bb0254ecabe93$var$nativeObjectToString = $811bb0254ecabe93$var$objectProto.toString;
/** Built-in value references. */ var $811bb0254ecabe93$var$symToStringTag = (0, $j22Bs.default) ? (0, $j22Bs.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $811bb0254ecabe93$var$getRawTag(value) {
    var isOwn = $811bb0254ecabe93$var$hasOwnProperty.call(value, $811bb0254ecabe93$var$symToStringTag), tag = value[$811bb0254ecabe93$var$symToStringTag];
    try {
        value[$811bb0254ecabe93$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $811bb0254ecabe93$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$811bb0254ecabe93$var$symToStringTag] = tag;
        else delete value[$811bb0254ecabe93$var$symToStringTag];
    }
    return result;
}
var $811bb0254ecabe93$export$2e2bcd8739ae039 = $811bb0254ecabe93$var$getRawTag;

});

parcelRegister("aCh9f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7baac1422b1bb553$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $7baac1422b1bb553$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7baac1422b1bb553$var$nativeObjectToString = $7baac1422b1bb553$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $7baac1422b1bb553$var$objectToString(value) {
    return $7baac1422b1bb553$var$nativeObjectToString.call(value);
}
var $7baac1422b1bb553$export$2e2bcd8739ae039 = $7baac1422b1bb553$var$objectToString;

});


parcelRegister("42tql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f0e2c48e013ca9a$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2f0e2c48e013ca9a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $2f0e2c48e013ca9a$export$2e2bcd8739ae039 = $2f0e2c48e013ca9a$var$isObject;

});


parcelRegister("l0TQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4c4eb71893d0dbc$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $f4c4eb71893d0dbc$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $f4c4eb71893d0dbc$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $f4c4eb71893d0dbc$var$MAX_SAFE_INTEGER;
}
var $f4c4eb71893d0dbc$export$2e2bcd8739ae039 = $f4c4eb71893d0dbc$var$isLength;

});


parcelRegister("gyNqR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0e62a854ea9d22a$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $hCd6c = parcelRequire("hCd6c");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $c0e62a854ea9d22a$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $c0e62a854ea9d22a$var$isString(value) {
    return typeof value == 'string' || !(0, $hCd6c.default)(value) && (0, $bBbWb.default)(value) && (0, $65ROZ.default)(value) == $c0e62a854ea9d22a$var$stringTag;
}
var $c0e62a854ea9d22a$export$2e2bcd8739ae039 = $c0e62a854ea9d22a$var$isString;

});
parcelRegister("hCd6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $034f3a6930a1671a$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $034f3a6930a1671a$var$isArray = Array.isArray;
var $034f3a6930a1671a$export$2e2bcd8739ae039 = $034f3a6930a1671a$var$isArray;

});

parcelRegister("bBbWb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $871c68ebef2571f3$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $871c68ebef2571f3$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $871c68ebef2571f3$export$2e2bcd8739ae039 = $871c68ebef2571f3$var$isObjectLike;

});


parcelRegister("4sQKr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3402b1a396be0a5a$export$2e2bcd8739ae039; });

var $9dNfM = parcelRequire("9dNfM");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $3402b1a396be0a5a$var$toInteger(value) {
    var result = (0, $9dNfM.default)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var $3402b1a396be0a5a$export$2e2bcd8739ae039 = $3402b1a396be0a5a$var$toInteger;

});
parcelRegister("9dNfM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b6b88a8df97386f$export$2e2bcd8739ae039; });

var $3jH8d = parcelRequire("3jH8d");
/** Used as references for various `Number` constants. */ var $6b6b88a8df97386f$var$INFINITY = 1 / 0, $6b6b88a8df97386f$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6b6b88a8df97386f$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $3jH8d.default)(value);
    if (value === $6b6b88a8df97386f$var$INFINITY || value === -$6b6b88a8df97386f$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6b6b88a8df97386f$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var $6b6b88a8df97386f$export$2e2bcd8739ae039 = $6b6b88a8df97386f$var$toFinite;

});
parcelRegister("3jH8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a49a7967e36259$export$2e2bcd8739ae039; });

var $9wyjI = parcelRequire("9wyjI");

var $42tql = parcelRequire("42tql");

var $ebwzy = parcelRequire("ebwzy");
/** Used as references for various `Number` constants. */ var $26a49a7967e36259$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $26a49a7967e36259$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $26a49a7967e36259$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $26a49a7967e36259$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $26a49a7967e36259$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $26a49a7967e36259$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $ebwzy.default)(value)) return $26a49a7967e36259$var$NAN;
    if ((0, $42tql.default)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $42tql.default)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $9wyjI.default)(value);
    var isBinary = $26a49a7967e36259$var$reIsBinary.test(value);
    return isBinary || $26a49a7967e36259$var$reIsOctal.test(value) ? $26a49a7967e36259$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $26a49a7967e36259$var$reIsBadHex.test(value) ? $26a49a7967e36259$var$NAN : +value;
}
var $26a49a7967e36259$export$2e2bcd8739ae039 = $26a49a7967e36259$var$toNumber;

});
parcelRegister("9wyjI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ef1b8e1228a5e9c$export$2e2bcd8739ae039; });

var $9n9Ks = parcelRequire("9n9Ks");
/** Used to match leading whitespace. */ var $6ef1b8e1228a5e9c$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $6ef1b8e1228a5e9c$var$baseTrim(string) {
    return string ? string.slice(0, (0, $9n9Ks.default)(string) + 1).replace($6ef1b8e1228a5e9c$var$reTrimStart, '') : string;
}
var $6ef1b8e1228a5e9c$export$2e2bcd8739ae039 = $6ef1b8e1228a5e9c$var$baseTrim;

});
parcelRegister("9n9Ks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d2dd2dd49f21b3a$export$2e2bcd8739ae039; });
/** Used to match a single whitespace character. */ var $6d2dd2dd49f21b3a$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6d2dd2dd49f21b3a$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6d2dd2dd49f21b3a$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $6d2dd2dd49f21b3a$export$2e2bcd8739ae039 = $6d2dd2dd49f21b3a$var$trimmedEndIndex;

});


parcelRegister("ebwzy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a53b5bfb62fead39$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $a53b5bfb62fead39$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a53b5bfb62fead39$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $bBbWb.default)(value) && (0, $65ROZ.default)(value) == $a53b5bfb62fead39$var$symbolTag;
}
var $a53b5bfb62fead39$export$2e2bcd8739ae039 = $a53b5bfb62fead39$var$isSymbol;

});




parcelRegister("gIlix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2b146b8baa676a2$export$2e2bcd8739ae039; });

var $5FhTA = parcelRequire("5FhTA");

var $egoNX = parcelRequire("egoNX");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $c2b146b8baa676a2$var$values(object) {
    return object == null ? [] : (0, $5FhTA.default)(object, (0, $egoNX.default)(object));
}
var $c2b146b8baa676a2$export$2e2bcd8739ae039 = $c2b146b8baa676a2$var$values;

});
parcelRegister("5FhTA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41fea9cb377bae6e$export$2e2bcd8739ae039; });

var $dqScn = parcelRequire("dqScn");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $41fea9cb377bae6e$var$baseValues(object, props) {
    return (0, $dqScn.default)(props, function(key) {
        return object[key];
    });
}
var $41fea9cb377bae6e$export$2e2bcd8739ae039 = $41fea9cb377bae6e$var$baseValues;

});
parcelRegister("dqScn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c77bec78ed8b6f4$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9c77bec78ed8b6f4$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $9c77bec78ed8b6f4$export$2e2bcd8739ae039 = $9c77bec78ed8b6f4$var$arrayMap;

});


parcelRegister("egoNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a625cd008e781bc0$export$2e2bcd8739ae039; });

var $iKUo3 = parcelRequire("iKUo3");

var $5BZwQ = parcelRequire("5BZwQ");

var $7wVIe = parcelRequire("7wVIe");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $a625cd008e781bc0$var$keys(object) {
    return (0, $7wVIe.default)(object) ? (0, $iKUo3.default)(object) : (0, $5BZwQ.default)(object);
}
var $a625cd008e781bc0$export$2e2bcd8739ae039 = $a625cd008e781bc0$var$keys;

});
parcelRegister("iKUo3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da7843272ac3d678$export$2e2bcd8739ae039; });

var $bZna3 = parcelRequire("bZna3");

var $71cEU = parcelRequire("71cEU");

var $hCd6c = parcelRequire("hCd6c");

var $2WNrA = parcelRequire("2WNrA");

var $dAIRS = parcelRequire("dAIRS");

var $kcxRF = parcelRequire("kcxRF");
/** Used for built-in method references. */ var $da7843272ac3d678$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $da7843272ac3d678$var$hasOwnProperty = $da7843272ac3d678$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $da7843272ac3d678$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hCd6c.default)(value), isArg = !isArr && (0, $71cEU.default)(value), isBuff = !isArr && !isArg && (0, $2WNrA.default)(value), isType = !isArr && !isArg && !isBuff && (0, $kcxRF.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $bZna3.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $da7843272ac3d678$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $dAIRS.default)(key, length)))) result.push(key);
    return result;
}
var $da7843272ac3d678$export$2e2bcd8739ae039 = $da7843272ac3d678$var$arrayLikeKeys;

});
parcelRegister("bZna3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba75b903b6a01a0$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $8ba75b903b6a01a0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $8ba75b903b6a01a0$export$2e2bcd8739ae039 = $8ba75b903b6a01a0$var$baseTimes;

});

parcelRegister("71cEU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51c2722c96f7914b$export$2e2bcd8739ae039; });

var $5XWts = parcelRequire("5XWts");

var $bBbWb = parcelRequire("bBbWb");
/** Used for built-in method references. */ var $51c2722c96f7914b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $51c2722c96f7914b$var$hasOwnProperty = $51c2722c96f7914b$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $51c2722c96f7914b$var$propertyIsEnumerable = $51c2722c96f7914b$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $51c2722c96f7914b$var$isArguments = (0, $5XWts.default)(function() {
    return arguments;
}()) ? (0, $5XWts.default) : function(value) {
    return (0, $bBbWb.default)(value) && $51c2722c96f7914b$var$hasOwnProperty.call(value, 'callee') && !$51c2722c96f7914b$var$propertyIsEnumerable.call(value, 'callee');
};
var $51c2722c96f7914b$export$2e2bcd8739ae039 = $51c2722c96f7914b$var$isArguments;

});
parcelRegister("5XWts", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457fd2289638561b$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $457fd2289638561b$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $457fd2289638561b$var$baseIsArguments(value) {
    return (0, $bBbWb.default)(value) && (0, $65ROZ.default)(value) == $457fd2289638561b$var$argsTag;
}
var $457fd2289638561b$export$2e2bcd8739ae039 = $457fd2289638561b$var$baseIsArguments;

});


parcelRegister("2WNrA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22575a199fd31348$export$2e2bcd8739ae039; });

var $ewUh0 = parcelRequire("ewUh0");

var $cjGEy = parcelRequire("cjGEy");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ewUh0.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $cjGEy.default);
var $22575a199fd31348$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("cjGEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f7858656b0dcaed$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $8f7858656b0dcaed$var$stubFalse() {
    return false;
}
var $8f7858656b0dcaed$export$2e2bcd8739ae039 = $8f7858656b0dcaed$var$stubFalse;

});


parcelRegister("dAIRS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e517104ecbb682e$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $9e517104ecbb682e$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9e517104ecbb682e$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9e517104ecbb682e$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9e517104ecbb682e$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $9e517104ecbb682e$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $9e517104ecbb682e$export$2e2bcd8739ae039 = $9e517104ecbb682e$var$isIndex;

});

parcelRegister("kcxRF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb4f3272cc7586f5$export$2e2bcd8739ae039; });

var $5toSh = parcelRequire("5toSh");

var $j7MgO = parcelRequire("j7MgO");

var $dWa57 = parcelRequire("dWa57");
/* Node.js helper references. */ var $eb4f3272cc7586f5$var$nodeIsTypedArray = (0, $dWa57.default) && (0, $dWa57.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $eb4f3272cc7586f5$var$isTypedArray = $eb4f3272cc7586f5$var$nodeIsTypedArray ? (0, $j7MgO.default)($eb4f3272cc7586f5$var$nodeIsTypedArray) : (0, $5toSh.default);
var $eb4f3272cc7586f5$export$2e2bcd8739ae039 = $eb4f3272cc7586f5$var$isTypedArray;

});
parcelRegister("5toSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fc2f4bfd11a7284$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $l0TQG = parcelRequire("l0TQG");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $3fc2f4bfd11a7284$var$argsTag = '[object Arguments]', $3fc2f4bfd11a7284$var$arrayTag = '[object Array]', $3fc2f4bfd11a7284$var$boolTag = '[object Boolean]', $3fc2f4bfd11a7284$var$dateTag = '[object Date]', $3fc2f4bfd11a7284$var$errorTag = '[object Error]', $3fc2f4bfd11a7284$var$funcTag = '[object Function]', $3fc2f4bfd11a7284$var$mapTag = '[object Map]', $3fc2f4bfd11a7284$var$numberTag = '[object Number]', $3fc2f4bfd11a7284$var$objectTag = '[object Object]', $3fc2f4bfd11a7284$var$regexpTag = '[object RegExp]', $3fc2f4bfd11a7284$var$setTag = '[object Set]', $3fc2f4bfd11a7284$var$stringTag = '[object String]', $3fc2f4bfd11a7284$var$weakMapTag = '[object WeakMap]';
var $3fc2f4bfd11a7284$var$arrayBufferTag = '[object ArrayBuffer]', $3fc2f4bfd11a7284$var$dataViewTag = '[object DataView]', $3fc2f4bfd11a7284$var$float32Tag = '[object Float32Array]', $3fc2f4bfd11a7284$var$float64Tag = '[object Float64Array]', $3fc2f4bfd11a7284$var$int8Tag = '[object Int8Array]', $3fc2f4bfd11a7284$var$int16Tag = '[object Int16Array]', $3fc2f4bfd11a7284$var$int32Tag = '[object Int32Array]', $3fc2f4bfd11a7284$var$uint8Tag = '[object Uint8Array]', $3fc2f4bfd11a7284$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3fc2f4bfd11a7284$var$uint16Tag = '[object Uint16Array]', $3fc2f4bfd11a7284$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $3fc2f4bfd11a7284$var$typedArrayTags = {};
$3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$float32Tag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$float64Tag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$int8Tag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$int16Tag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$int32Tag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$uint8Tag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$uint8ClampedTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$uint16Tag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$uint32Tag] = true;
$3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$argsTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$arrayTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$arrayBufferTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$boolTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$dataViewTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$dateTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$errorTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$funcTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$mapTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$numberTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$objectTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$regexpTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$setTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$stringTag] = $3fc2f4bfd11a7284$var$typedArrayTags[$3fc2f4bfd11a7284$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $3fc2f4bfd11a7284$var$baseIsTypedArray(value) {
    return (0, $bBbWb.default)(value) && (0, $l0TQG.default)(value.length) && !!$3fc2f4bfd11a7284$var$typedArrayTags[(0, $65ROZ.default)(value)];
}
var $3fc2f4bfd11a7284$export$2e2bcd8739ae039 = $3fc2f4bfd11a7284$var$baseIsTypedArray;

});

parcelRegister("j7MgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dec41d39a51261d2$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $dec41d39a51261d2$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $dec41d39a51261d2$export$2e2bcd8739ae039 = $dec41d39a51261d2$var$baseUnary;

});

parcelRegister("dWa57", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2588323867cd742$export$2e2bcd8739ae039; });

var $aUlWO = parcelRequire("aUlWO");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $aUlWO.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $a2588323867cd742$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("5BZwQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $416022c223414765$export$2e2bcd8739ae039; });

var $aeTMJ = parcelRequire("aeTMJ");

var $a8jCh = parcelRequire("a8jCh");
/** Used for built-in method references. */ var $416022c223414765$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $416022c223414765$var$hasOwnProperty = $416022c223414765$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $416022c223414765$var$baseKeys(object) {
    if (!(0, $aeTMJ.default)(object)) return (0, $a8jCh.default)(object);
    var result = [];
    for(var key in Object(object))if ($416022c223414765$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $416022c223414765$export$2e2bcd8739ae039 = $416022c223414765$var$baseKeys;

});
parcelRegister("aeTMJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77467beee8abae25$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $77467beee8abae25$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $77467beee8abae25$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $77467beee8abae25$var$objectProto;
    return value === proto;
}
var $77467beee8abae25$export$2e2bcd8739ae039 = $77467beee8abae25$var$isPrototype;

});

parcelRegister("a8jCh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7609de2ac6537eff$export$2e2bcd8739ae039; });

var $7zX8O = parcelRequire("7zX8O");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7609de2ac6537eff$var$nativeKeys = (0, $7zX8O.default)(Object.keys, Object);
var $7609de2ac6537eff$export$2e2bcd8739ae039 = $7609de2ac6537eff$var$nativeKeys;

});
parcelRegister("7zX8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5849ad775295964f$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5849ad775295964f$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5849ad775295964f$export$2e2bcd8739ae039 = $5849ad775295964f$var$overArg;

});






parcelRegister("bEEBX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87c2eea7e488b98d$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $87c2eea7e488b98d$var$isNil(value) {
    return value == null;
}
var $87c2eea7e488b98d$export$2e2bcd8739ae039 = $87c2eea7e488b98d$var$isNil;

});

parcelRegister("bcbvQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $384ea8564881ce25$export$2e2bcd8739ae039; });

var $7c65l = parcelRequire("7c65l");

var $eOaNI = parcelRequire("eOaNI");
var $lBd8A = parcelRequire("lBd8A");
var $khZbR = parcelRequire("khZbR");
var $9cxlt = parcelRequire("9cxlt");
var $2BBSn = parcelRequire("2BBSn");
var $5jpKo = parcelRequire("5jpKo");

var $45ElK = parcelRequire("45ElK");
var $dyKVY = parcelRequire("dyKVY");
var $jNFGw = parcelRequire("jNFGw");

var $jf2w9 = parcelRequire("jf2w9");

var $5LjUB = parcelRequire("5LjUB");

var $bEEBX = parcelRequire("bEEBX");

var $3xOZa = parcelRequire("3xOZa");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $f2Bp8 = parcelRequire("f2Bp8");

var $isIf6 = parcelRequire("isIf6");

var $76PCP = parcelRequire("76PCP");

var $25aT1 = parcelRequire("25aT1");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $9Vhxl = parcelRequire("9Vhxl");

var $hOaHV = parcelRequire("hOaHV");

var $biFcX = parcelRequire("biFcX");

var $2JqjA = parcelRequire("2JqjA");

var $bZiDo = parcelRequire("bZiDo");

var $i6TQx = parcelRequire("i6TQx");

var $5aUWQ = parcelRequire("5aUWQ");

var $gvoND = parcelRequire("gvoND");

var $jnFMu = parcelRequire("jnFMu");

var $lKrOo = parcelRequire("lKrOo");
/** Configuration settings for scheduled refresh of auth tokens */ // If there is less than 20 minutes left in the token expiry, we do an immidiate refresh after
const $384ea8564881ce25$var$IMMEDIATE_REFRESH_LIMIT = (0, $9cxlt.default)(20);
// If we are withing the immidiate refresh period, we wait 30 seconds and then trigger refresh
const $384ea8564881ce25$var$IMMEDIATE_REFRESH_WAIT = (0, $5jpKo.default)(30);
// If we are not refreshing right now, we set a timeout and trigger it when there is 20 minutes until expiry
const $384ea8564881ce25$var$REFRESH_MARGIN = (0, $9cxlt.default)(20);
let $384ea8564881ce25$var$refeshTimeoutId;
let $384ea8564881ce25$var$logoutTimeoutId;
const $384ea8564881ce25$var$authStore = (0, $Kk7R3.makeAutoObservable)({
    session: (0, $f2Bp8.getSessionFromStorage)(),
    user: null,
    companies: [],
    currentCompany: null,
    currentlyRequiresLogin: [],
    codeChallengeId: null,
    resetPasswordId: (0, $duLFK.initializeWithDefaultData)(null),
    resetPasswordProgress: (0, $duLFK.initializeWithDefaultData)(false),
    switchingCompany: false,
    isLoggedIn: ()=>{
        return (0, $lKrOo.default).is("LOGGED_IN");
    },
    isPunchoutSession: ()=>{
        return $384ea8564881ce25$var$authStore.user?.loginType === "PUNCHOUT";
    },
    getCustomerData: async (token)=>{
        const customerDataEndpoint = `${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/me`;
        const profileData = await (0, $3Y1Wx.apiClient)(customerDataEndpoint, token).get().json();
        const user = (0, $jNFGw.default)(profileData, "companies");
        const companies = profileData.companies.map((company)=>{
            const { businessChainLevel1: businessChainLevel1, businessChainLevel2: businessChainLevel2, businessChainLevel3: businessChainLevel3, businessChainLevel4: businessChainLevel4, ...rest } = company;
            return {
                ...rest,
                businessLevels: {
                    level1: businessChainLevel1 || "",
                    level2: businessChainLevel2 || "",
                    level3: businessChainLevel3 || "",
                    level4: businessChainLevel4 || ""
                },
                minimumOrderValue: company.minimumOrderValue || 0
            };
        });
        const currentCompany = (0, $45ElK.default)(companies)?.customerNumber;
        if ((0, $bEEBX.default)(currentCompany)) throw new (0, $aMYzM.BackendIssueError)("Unable to determine default customer number");
        return {
            user: user,
            companies: companies,
            currentCompany: currentCompany
        };
    },
    getSessionToken: ()=>{
        const token = $384ea8564881ce25$var$authStore.session?.accessToken;
        if ((0, $3xOZa.default)(token)) return null;
        return token;
    },
    refreshToken: async ()=>{
        (0, $gtsdT.logger).log("auth", "Refreshing access token using existing access token");
        if ((0, $bEEBX.default)($384ea8564881ce25$var$authStore.user) || (0, $bEEBX.default)($384ea8564881ce25$var$authStore.session)) {
            (0, $gtsdT.logger).warn("auth", "The session is no longer defined in the store, aborting refresh...");
            return Promise.resolve();
        }
        const expiryTime = (0, $2BBSn.default)($384ea8564881ce25$var$authStore.session.expiry);
        if ((0, $khZbR.default)(expiryTime)) {
            (0, $gtsdT.logger).warn("auth", `Token past expiry time (${expiryTime}), logout user out...`);
            (0, $gvoND.default).addError("Logget ut pga inaktivitet", "Du har blitt logget ut p\xe5 grunn av inaktivitet. Logg inn igjen for \xe5 fortsette handleturen.", {
                context: "login",
                text: "token_past_expiry_error"
            });
            (0, $lKrOo.default).transitionToIfPossible("NOT_LOGGED_IN");
            return Promise.resolve();
        }
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/refresh`, $384ea8564881ce25$var$authStore.getSessionToken()).post().json((0, $Kk7R3.action)((newSession)=>{
            $384ea8564881ce25$var$authStore.scheduleTokenRefresh(newSession);
            $384ea8564881ce25$var$authStore.session = newSession;
        })).catch((err)=>{
            (0, $gtsdT.logger).warn("auth", "Unable to refresh access token, will automatically log user out when token expires...", err);
            (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(err, (e)=>{
                e.context = "Token refresh";
            });
        });
    },
    scheduleTokenRefresh: (session)=>{
        // Schedule a refresh of the access token so we don't time out
        const expiryTime = (0, $2BBSn.default)(session.expiry);
        const expiryIn = (0, $lBd8A.default)(expiryTime, new Date());
        if ($384ea8564881ce25$var$logoutTimeoutId) clearTimeout($384ea8564881ce25$var$logoutTimeoutId);
        $384ea8564881ce25$var$logoutTimeoutId = setTimeout(()=>(0, $lKrOo.default).transitionToIfPossible("NOT_LOGGED_IN"), expiryIn);
        // If there is less than 10 minutes until expiry, refresh the token in 30 seconds.
        const refreshIn = expiryIn < $384ea8564881ce25$var$IMMEDIATE_REFRESH_LIMIT ? $384ea8564881ce25$var$IMMEDIATE_REFRESH_WAIT : expiryIn - $384ea8564881ce25$var$REFRESH_MARGIN;
        const refreshAt = (0, $eOaNI.default)(new Date(), refreshIn);
        (0, $gtsdT.logger).log("auth", `Scheduling refresh of access token in ${refreshIn} ms (${(0, $4udGV.formatDateTime)(refreshAt)})`);
        $384ea8564881ce25$var$refeshTimeoutId = setTimeout($384ea8564881ce25$var$authStore.refreshToken, refreshIn);
    },
    abortTokenTimers: ()=>{
        if ($384ea8564881ce25$var$refeshTimeoutId) clearTimeout($384ea8564881ce25$var$refeshTimeoutId);
        if ($384ea8564881ce25$var$logoutTimeoutId) clearTimeout($384ea8564881ce25$var$logoutTimeoutId);
    },
    getSessionFromQuery: ()=>{
        const params = new URLSearchParams(window.location.search);
        const accessToken = params.get("token");
        const expiry = params.get("expiry");
        if ((0, $bEEBX.default)(accessToken) || (0, $bEEBX.default)(expiry)) return false;
        if ((0, $5LjUB.default)(accessToken) || (0, $5LjUB.default)(expiry)) return false;
        (0, $gtsdT.logger).log("auth", "Creating session data from query string");
        $384ea8564881ce25$var$authStore.session = {
            accessToken: accessToken,
            expiry: expiry
        };
        return true;
    },
    verifySession: async (session = null)=>{
        const { username: username } = $384ea8564881ce25$var$authStore;
        const usableSession = session === null && $384ea8564881ce25$var$authStore.session !== null ? $384ea8564881ce25$var$authStore.session : session;
        if (usableSession === null) {
            (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
            return;
        }
        (0, $lKrOo.default).transitionTo("VERIFY_SESSION");
        let customerResult;
        try {
            customerResult = await $384ea8564881ce25$var$authStore.getCustomerData(usableSession.accessToken);
        } catch (err) {
            const wErr = (0, $3Y1Wx.ensureWretchError)(err);
            if (!(0, $bEEBX.default)(wErr)) (0, $gtsdT.logger).log("auth", "Token is likely expired. Response: ", wErr.status);
            (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
            return;
        }
        try {
            (0, $gtsdT.logger).log("auth", "Customer Data verified:", customerResult);
            (0, $Kk7R3.runInAction)(()=>{
                (0, $lKrOo.default).transitionTo("LOGGING_IN");
                $384ea8564881ce25$var$authStore.session = usableSession;
                $384ea8564881ce25$var$authStore.user = customerResult.user;
                $384ea8564881ce25$var$authStore.companies = customerResult.companies.map((company)=>(0, $jnFMu.enhanceCompany)(company));
            });
            const { companies: companies, currentCompany: currentCompany } = $384ea8564881ce25$var$authStore;
            const usernameCompany = companies?.find((company)=>company.customerNumber === username)?.customerNumber;
            const sessionCompany = (0, $f2Bp8.getCompanyFromStorage)();
            const currentCompanyNumber = currentCompany || usernameCompany || sessionCompany;
            if (currentCompanyNumber) await $384ea8564881ce25$var$authStore.changeCompany(currentCompanyNumber);
            else {
                let company;
                if (companies?.length === 1) {
                    (0, $gtsdT.logger).log("auth", "COMPANY SELECTION: Only one company available, selecting it automatically");
                    company = companies[0];
                } else {
                    (0, $gtsdT.logger).log("auth", `COMPANY SELECTION: Multiple companies available, checking if username ${username} matches`);
                    company = companies?.find((company)=>username === company.customerNumber);
                }
                if (company) {
                    (0, $gtsdT.logger).log("auth", `COMPANY SELECTION: Company found ${company.customerNumber}, proceeding with changeCompany...`);
                    await $384ea8564881ce25$var$authStore.changeCompany(company.customerNumber);
                } else {
                    (0, $gtsdT.logger).log("auth", "COMPANY SELECTION: Multiple companies available, showing selection screen");
                    (0, $lKrOo.default).transitionTo("COMPANY_SELECTION");
                }
            }
            $384ea8564881ce25$var$authStore.scheduleTokenRefresh(usableSession);
        } catch (err) {
            (0, $gtsdT.logger).warn("auth", "Error verifying session", err);
            $384ea8564881ce25$var$authStore.logout();
            throw err;
        }
    },
    verifyStillLoggedIn: async (visible)=>{
        if (!$384ea8564881ce25$var$authStore.isLoggedIn() || !$384ea8564881ce25$var$authStore.session || !visible) return;
        try {
            const usableSession = $384ea8564881ce25$var$authStore.session;
            await $384ea8564881ce25$var$authStore.getCustomerData(usableSession.accessToken);
            (0, $gtsdT.logger).log("auth", "Session is verified as still active!");
        } catch (_err) {
            if ((0, $76PCP.default).isEditing()) {
                (0, $76PCP.default).items = [];
                if ($384ea8564881ce25$var$authStore.isLoggedIn()) (0, $76PCP.default).saveCartToServerWithoutDelay();
            }
            (0, $gtsdT.logger).log("auth", "Session is not longer valid! Logging out...");
            (0, $lKrOo.default).transitionToIfPossible("FORCED_LOGOUT");
        }
    },
    changeCompany: async (newCompany)=>{
        (0, $gtsdT.logger).log("auth", `Switching to company ${newCompany}`);
        (0, $lKrOo.default).transitionTo("COMPANY_SELECTED");
        $384ea8564881ce25$var$authStore.error = undefined;
        try {
            if ((0, $bEEBX.default)($384ea8564881ce25$var$authStore.session)) throw new (0, $aMYzM.GenericError)("MISSING TOKEN");
            $384ea8564881ce25$var$authStore.currentCompany = newCompany;
            (0, $f2Bp8.setCompanyInStorage)(newCompany);
            (0, $f2Bp8.setLastCompanyInStorage)(newCompany);
            const company = $384ea8564881ce25$var$authStore.getCurrentCompany();
            if (company === undefined) throw new (0, $aMYzM.BackendIssueError)("Unable to find selected company");
            (0, $9yKIH.default).updateCurrentCustomerProperties();
            (0, $lKrOo.default).transitionTo("FEATURES_LOADING");
            await (0, $biFcX.default).fetchEnabledCustomerFeatures($384ea8564881ce25$var$authStore.currentCompany);
            await (0, $biFcX.default).fetchEnabledConfigCatFeatures($384ea8564881ce25$var$authStore.getCurrentCompany());
            if ((0, $biFcX.default).navigationTestVariant) company.experiments = {
                navigation: (0, $biFcX.default).navigationTestVariant
            };
            (0, $hOaHV.default).loadFavorites();
            (0, $lKrOo.default).transitionTo("DELIVERY_DATES_LOADING");
            await (0, $9Vhxl.default).fetchDeliveryDates($384ea8564881ce25$var$authStore.currentCompany);
            const availableOrderTypes = (0, $9Vhxl.default).getAvailableOrderTypes();
            const orderType = (0, $f2Bp8.getOrdertypeFromStorage)((0, $isIf6.default).defaultOrderType); // Defaults to order type from SiteConfig
            if (availableOrderTypes === null || availableOrderTypes.length === 0) (0, $76PCP.default).changeOrderType(orderType); // Should be handeled another way as they don't have ordertype
            else if (availableOrderTypes.includes(orderType)) (0, $76PCP.default).changeOrderType(orderType);
            else (0, $76PCP.default).changeOrderType(availableOrderTypes[0]);
            const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
            if (currentDelivery === null) {
                $384ea8564881ce25$var$authStore.error = new (0, $aMYzM.BackendIssueError)("Missing delivery dates");
                (0, $lKrOo.default).transitionTo("LOGGED_IN");
                return;
            }
            (0, $lKrOo.default).transitionTo("ASSORTMENT_LOADING");
            try {
                await (0, $bZiDo.default).getAssortment($384ea8564881ce25$var$authStore.currentCompany, currentDelivery.date, (0, $76PCP.default).orderType);
                await (0, $25aT1.default).updateCategorySkus();
            } catch (err) {
                if (err instanceof (0, $aMYzM.BackendIssueError)) $384ea8564881ce25$var$authStore.error = err;
                else $384ea8564881ce25$var$authStore.error = new (0, $aMYzM.BackendIssueError)("Unable to load assortment, error from backend");
                (0, $lKrOo.default).transitionTo("LOGGED_IN");
                return;
            }
            (0, $lKrOo.default).transitionTo("NOTIFICATIONS_LOADING");
            await (0, $i6TQx.default).fetchAvailablePromotions();
            await (0, $i6TQx.default).fetchSignUps();
            (0, $76PCP.default).loadCartFromServer();
            (0, $5aUWQ.default).fetchSubscriptionList();
            if ((0, $biFcX.default).notificationsEnabled && (0, $isIf6.default).notifications.enableDeliveryMessages) {
                await (0, $2JqjA.default).fetchNotifications();
                await (0, $2JqjA.default).fetchOldNotifications();
            }
            (0, $jlTfJ.default).viewedPromotionArticleIds = (0, $f2Bp8.getViewedPromotionArticlesFromStorage)($384ea8564881ce25$var$authStore.currentCompany);
            (0, $lKrOo.default).transitionTo("LOGGED_IN");
        } catch (err) {
            (0, $gtsdT.logger).warn("auth", "Error occured during login", err);
            throw err;
        }
    },
    getCurrentCompany: ()=>{
        return (0, $jf2w9.default)($384ea8564881ce25$var$authStore.companies, (0, $dyKVY.default)({
            customerNumber: $384ea8564881ce25$var$authStore.currentCompany
        }));
    },
    getAlgoliaUserToken: ()=>`company-${$384ea8564881ce25$var$authStore.currentCompany}`,
    changePassword: async (newPassword)=>{
        const endpoint = `${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/me/password`;
        try {
            await (0, $3Y1Wx.apiClient)(endpoint, $384ea8564881ce25$var$authStore.getSessionToken()).content("application/json").post({
                newPassword: newPassword
            }).text();
            return "";
        } catch (error) {
            (0, $gtsdT.logger).log("auth", {
                error: error,
                where: "authStore.changePassword"
            });
            return error && typeof error === "object" && "text" in error ? error.text : "unknown error cause";
        }
    },
    updateCompanyContactInfo: async (email, phone1, phone2)=>{
        if (!$384ea8564881ce25$var$authStore.isLoggedIn() || (0, $bEEBX.default)($384ea8564881ce25$var$authStore.user)) {
            (0, $gvoND.default).addError("Det oppsto en feil", "Pr\xf8v \xe5 logge ut og inn igjen for \xe5 oppdatere profilen.", {
                context: "login",
                text: "not_logged_in_error"
            });
            return;
        }
        const currentCompany = $384ea8564881ce25$var$authStore.currentCompany;
        if ((0, $bEEBX.default)(currentCompany)) return;
        const res = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/company/${currentCompany}`, $384ea8564881ce25$var$authStore.getSessionToken()).post({
            email: email,
            phone1: phone1,
            phone2: phone2
        }).json();
        (0, $Kk7R3.runInAction)(()=>{
            const infoIsUpdated = res.email === email && res.phone1 === phone1 && res.phone2 === phone2;
            if (!infoIsUpdated) throw "Unable to save new contact info";
            (0, $gtsdT.logger).log("auth", "Updated email, phone and phone2 successfully");
            const companyIndex = $384ea8564881ce25$var$authStore.companies?.findIndex((company)=>company.customerNumber === currentCompany);
            if (!(0, $bEEBX.default)($384ea8564881ce25$var$authStore.companies) && !(0, $bEEBX.default)(companyIndex)) {
                $384ea8564881ce25$var$authStore.companies[companyIndex].email = email;
                $384ea8564881ce25$var$authStore.companies[companyIndex].phone1 = phone1;
                $384ea8564881ce25$var$authStore.companies[companyIndex].phone2 = phone2;
            }
        });
    },
    updatePersonalContactInfo: async (email, firstName, lastName, mobile)=>{
        if (!$384ea8564881ce25$var$authStore.isLoggedIn() || (0, $bEEBX.default)($384ea8564881ce25$var$authStore.user)) {
            (0, $gvoND.default).addError("Det oppsto en feil", "Pr\xf8v \xe5 logge ut og inn igjen for \xe5 oppdatere profilen.", {
                context: "login",
                text: "not_logged_in_error "
            });
            return;
        }
        const currentCompany = $384ea8564881ce25$var$authStore.currentCompany;
        if ((0, $bEEBX.default)(currentCompany)) return;
        const res = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/me`, $384ea8564881ce25$var$authStore.getSessionToken()).post({
            id: $384ea8564881ce25$var$authStore.user.id,
            email: email,
            firstName: firstName,
            lastName: lastName,
            mobile: mobile
        }).json();
        (0, $gtsdT.logger).log("auth", "Updated firstName, lastName, email and mobile successfully");
        $384ea8564881ce25$var$authStore.user.email = res.email;
        $384ea8564881ce25$var$authStore.user.firstName = res.firstName;
        $384ea8564881ce25$var$authStore.user.lastName = res.lastName;
        $384ea8564881ce25$var$authStore.user.mobile = res.mobile;
    },
    requestSmsLoginOtp: async (mobileNumber)=>{
        $384ea8564881ce25$var$authStore.codeChallengeId = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/sms/requestcode`).query({
            mobileNumber: mobileNumber
        }).post().text();
    },
    verifySmsLoginOtp: async (code)=>{
        (0, $lKrOo.default).transitionTo("CHECKING_LOGIN");
        try {
            const session = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/sms/verify`).query({
                challengeId: $384ea8564881ce25$var$authStore.codeChallengeId,
                code: code
            }).post().json();
            (0, $gtsdT.logger).log("auth", "Verifying OneTimeCode session", session);
            await $384ea8564881ce25$var$authStore.verifySession(session);
            // Clear the codeChallengeId once the progress dialog has disappeared
            setTimeout(()=>{
                $384ea8564881ce25$var$authStore.codeChallengeId = null;
            }, 500);
        } catch (err) {
            (0, $lKrOo.default).transitionTo("LOGIN_MODAL");
            const wErr = (0, $3Y1Wx.ensureWretchError)(err);
            if (wErr?.response?.status === 403) throw new (0, $aMYzM.WrongCodeError)();
            (0, $gtsdT.logger).log("auth", "Got error during OneTimeCode login: ", err);
            throw new (0, $aMYzM.BackendIssueError)("Unable to verify OneTimeCode");
        }
    },
    requestResetPasswordOtp: async (email)=>{
        const transitionedSuccessfully = (0, $duLFK.setAsWaitingForData)($384ea8564881ce25$var$authStore.resetPasswordId);
        if (!transitionedSuccessfully) return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/forgottenpassword`).query({
            email: email
        }).post().text((resetId)=>{
            (0, $duLFK.setAsDataAvailable)($384ea8564881ce25$var$authStore.resetPasswordId, resetId);
        }).catch((errorObject)=>{
            (0, $duLFK.setAsErrorOccured)($384ea8564881ce25$var$authStore.resetPasswordId, `${errorObject}`);
        });
    },
    attemptResetPassword: async (code, newPassword)=>{
        const transitionedSuccessfully = (0, $duLFK.setAsWaitingForData)($384ea8564881ce25$var$authStore.resetPasswordProgress);
        if (!transitionedSuccessfully) return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/resetpassword`).query({
            resetId: $384ea8564881ce25$var$authStore.resetPasswordId.data,
            code: code,
            newPassword: newPassword
        }).post().res((res)=>{
            (0, $duLFK.setAsDataAvailable)($384ea8564881ce25$var$authStore.resetPasswordProgress, res.ok);
        }).catch((errorObject)=>{
            (0, $duLFK.setAsErrorOccured)($384ea8564881ce25$var$authStore.resetPasswordProgress, `${errorObject}`);
        });
    },
    clearResetPassword: ()=>{
        $384ea8564881ce25$var$authStore.resetPasswordId = (0, $duLFK.initializeWithDefaultData)(null);
        $384ea8564881ce25$var$authStore.resetPasswordProgress = (0, $duLFK.initializeWithDefaultData)(false);
    },
    login: async (username, password)=>{
        (0, $lKrOo.default).transitionTo("CHECKING_LOGIN");
        (0, $gtsdT.logger).log("auth", `Starting login process using host ${(0, $8ZCSm.API_HOST)}`);
        // Need to set it to a initial value, because typescript will not understand that the catch-block guarantees a
        // value being set before next try/catch block
        let session = {
            expiry: "",
            accessToken: ""
        };
        try {
            // Attempting to get session with access token for user
            session = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/login`).query({
                username: username,
                password: password
            }).post().json();
        } catch (err) {
            (0, $lKrOo.default).transitionTo("LOGIN_MODAL");
            const wErr = (0, $3Y1Wx.ensureWretchError)(err);
            if (wErr !== null) switch(wErr.response.status){
                case 400:
                case 401:
                    if (wErr.text === "StoreId not found") throw new (0, $aMYzM.BackendIssueError)("StoreId not found");
                    throw new (0, $aMYzM.WrongUsernameOrPasswordError)();
                case 500:
                    throw new (0, $aMYzM.BackendIssueError)();
            }
            throw new (0, $aMYzM.ServerNotFoundError)();
        }
        try {
            (0, $gtsdT.logger).log("auth", "Verifying session", session);
            (0, $Kk7R3.runInAction)(()=>{
                $384ea8564881ce25$var$authStore.username = username;
            });
            await $384ea8564881ce25$var$authStore.verifySession(session);
        } catch (err) {
            (0, $gtsdT.logger).log("auth", "Got error during login: ", err);
            (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
            if (err instanceof Error) (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(err, (e)=>{
                e.context = "Session Verification";
            });
            if (err instanceof (0, $aMYzM.BackendIssueError)) throw err;
            throw new (0, $aMYzM.BackendIssueError)();
        }
    },
    logout: (0, $Kk7R3.action)(()=>{
        $384ea8564881ce25$var$authStore.abortTokenTimers();
        $384ea8564881ce25$var$authStore.user = null;
        $384ea8564881ce25$var$authStore.session = null;
        $384ea8564881ce25$var$authStore.companies = [];
        $384ea8564881ce25$var$authStore.currentCompany = null;
        (0, $f2Bp8.setCompanyInStorage)(null);
    }),
    clearCompanySpecificData: ()=>{}
});
// Save user info to session storage whenever it changes
(0, $Kk7R3.autorun)(()=>(0, $f2Bp8.setSessionInStorage)($384ea8564881ce25$var$authStore.session));
// Make customer info available for Google Analytics and other software outside React
(0, $Kk7R3.autorun)(()=>{
    window.isUserLoggedIn = $384ea8564881ce25$var$authStore.isLoggedIn();
    window.companyInfo = $384ea8564881ce25$var$authStore.getCurrentCompany();
    window.customerInfo = $384ea8564881ce25$var$authStore.user;
});
var $384ea8564881ce25$export$2e2bcd8739ae039 = $384ea8564881ce25$var$authStore;

});
parcelRegister("eOaNI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac7e1d093bbfd19e$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $ac7e1d093bbfd19e$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var timestamp = (0, $8pX4r.default)(dirtyDate).getTime();
    var amount = (0, $970db.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("970db", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a24ee8450f10a94$export$2e2bcd8739ae039; });
function $6a24ee8450f10a94$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("8pX4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $620e7abdf7346b44$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");

var $hFacL = parcelRequire("hFacL");
function $620e7abdf7346b44$export$2e2bcd8739ae039(argument) {
    (0, $hFacL.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $5PKFW.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("5PKFW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43f5ebefc6bed040$export$2e2bcd8739ae039; });
function $43f5ebefc6bed040$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $43f5ebefc6bed040$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $43f5ebefc6bed040$export$2e2bcd8739ae039(o);
}

});

parcelRegister("hFacL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdbe2e7ee798ed5e$export$2e2bcd8739ae039; });
function $cdbe2e7ee798ed5e$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});



parcelRegister("lBd8A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb973e7c494c4976$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $fb973e7c494c4976$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $hFacL.default)(2, arguments);
    return (0, $8pX4r.default)(dateLeft).getTime() - (0, $8pX4r.default)(dateRight).getTime();
}

});

parcelRegister("khZbR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec54dc4f52feaa06$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $ec54dc4f52feaa06$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    return (0, $8pX4r.default)(dirtyDate).getTime() < Date.now();
}

});

parcelRegister("9cxlt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b2f19bdcfd00982$export$2e2bcd8739ae039; });

var $hFacL = parcelRequire("hFacL");

var $2KlUs = parcelRequire("2KlUs");
function $6b2f19bdcfd00982$export$2e2bcd8739ae039(minutes) {
    (0, $hFacL.default)(1, arguments);
    return Math.floor(minutes * (0, $2KlUs.millisecondsInMinute));
}

});
parcelRegister("2KlUs", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $2000df759c714e23$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $2000df759c714e23$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $2000df759c714e23$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $2000df759c714e23$export$dfd9b671c89acc8e = 7;
var $2000df759c714e23$export$3913210603d8e9ae = 365.2425;
var $2000df759c714e23$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $2000df759c714e23$export$91246f0b9bd9beff = 60000;
var $2000df759c714e23$export$7f72910d6dfd237a = 3600000;
var $2000df759c714e23$export$397c2d5776aa9055 = 1000;
var $2000df759c714e23$export$4dec998e48f9c246 = -$2000df759c714e23$export$81caae6e1cc7a622;
var $2000df759c714e23$export$f2f5ae5a8e2d8f9f = 60;
var $2000df759c714e23$export$3c58128db900d44e = 3;
var $2000df759c714e23$export$80d7e435f744f319 = 12;
var $2000df759c714e23$export$4db7641526e3241f = 4;
var $2000df759c714e23$export$698aec755e92c695 = 3600;
var $2000df759c714e23$export$a77c1a7ebebe2a5a = 60;
var $2000df759c714e23$export$815a9362476d2fe3 = $2000df759c714e23$export$698aec755e92c695 * 24;
var $2000df759c714e23$export$34804a017b31e2fe = $2000df759c714e23$export$815a9362476d2fe3 * 7;
var $2000df759c714e23$export$7271e9e3478110d1 = $2000df759c714e23$export$815a9362476d2fe3 * $2000df759c714e23$export$3913210603d8e9ae;
var $2000df759c714e23$export$8e6600bbdee7dabb = $2000df759c714e23$export$7271e9e3478110d1 / 12;
var $2000df759c714e23$export$be1dccf2de902d31 = $2000df759c714e23$export$8e6600bbdee7dabb * 3;

});


parcelRegister("2BBSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e5c6ae2e4960c1d$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $1e5c6ae2e4960c1d$export$2e2bcd8739ae039(argument) {
    (0, $hFacL.default)(1, arguments);
    if (typeof argument === 'string') {
        var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
        if (parts) // Group 8 matches the sign
        return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
        return new Date(NaN);
    }
    return (0, $8pX4r.default)(argument);
}

});

parcelRegister("5jpKo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3de2b2f77ee1249b$export$2e2bcd8739ae039; });

var $hFacL = parcelRequire("hFacL");

var $2KlUs = parcelRequire("2KlUs");
function $3de2b2f77ee1249b$export$2e2bcd8739ae039(seconds) {
    (0, $hFacL.default)(1, arguments);
    return seconds * (0, $2KlUs.millisecondsInSecond);
}

});

parcelRegister("45ElK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fa6eda808c1004d$export$2e2bcd8739ae039; });
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $2fa6eda808c1004d$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
var $2fa6eda808c1004d$export$2e2bcd8739ae039 = $2fa6eda808c1004d$var$head;

});

parcelRegister("dyKVY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9df2db749b26d714$export$2e2bcd8739ae039; });

var $luO7C = parcelRequire("luO7C");

var $3c4XD = parcelRequire("3c4XD");
/** Used to compose bitmasks for cloning. */ var $9df2db749b26d714$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that performs a partial deep comparison between a given
 * object and `source`, returning `true` if the given object has equivalent
 * property values, else `false`.
 *
 * **Note:** The created function is equivalent to `_.isMatch` with `source`
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
 * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */ function $9df2db749b26d714$var$matches(source) {
    return (0, $3c4XD.default)((0, $luO7C.default)(source, $9df2db749b26d714$var$CLONE_DEEP_FLAG));
}
var $9df2db749b26d714$export$2e2bcd8739ae039 = $9df2db749b26d714$var$matches;

});
parcelRegister("luO7C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa634775d9386048$export$2e2bcd8739ae039; });

var $kmWRU = parcelRequire("kmWRU");

var $fo4tZ = parcelRequire("fo4tZ");

var $g61zT = parcelRequire("g61zT");

var $bOaNB = parcelRequire("bOaNB");

var $8TPty = parcelRequire("8TPty");

var $2Y7T9 = parcelRequire("2Y7T9");

var $1XCwi = parcelRequire("1XCwi");

var $aPEXd = parcelRequire("aPEXd");

var $j2GsH = parcelRequire("j2GsH");

var $g6rzB = parcelRequire("g6rzB");

var $h11vi = parcelRequire("h11vi");

var $3Q0KW = parcelRequire("3Q0KW");

var $6P2xZ = parcelRequire("6P2xZ");

var $d0Wb9 = parcelRequire("d0Wb9");

var $d2DPO = parcelRequire("d2DPO");

var $hCd6c = parcelRequire("hCd6c");

var $2WNrA = parcelRequire("2WNrA");

var $1GcYn = parcelRequire("1GcYn");

var $42tql = parcelRequire("42tql");

var $hpUbC = parcelRequire("hpUbC");

var $egoNX = parcelRequire("egoNX");

var $1F2kI = parcelRequire("1F2kI");
/** Used to compose bitmasks for cloning. */ var $fa634775d9386048$var$CLONE_DEEP_FLAG = 1, $fa634775d9386048$var$CLONE_FLAT_FLAG = 2, $fa634775d9386048$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $fa634775d9386048$var$argsTag = '[object Arguments]', $fa634775d9386048$var$arrayTag = '[object Array]', $fa634775d9386048$var$boolTag = '[object Boolean]', $fa634775d9386048$var$dateTag = '[object Date]', $fa634775d9386048$var$errorTag = '[object Error]', $fa634775d9386048$var$funcTag = '[object Function]', $fa634775d9386048$var$genTag = '[object GeneratorFunction]', $fa634775d9386048$var$mapTag = '[object Map]', $fa634775d9386048$var$numberTag = '[object Number]', $fa634775d9386048$var$objectTag = '[object Object]', $fa634775d9386048$var$regexpTag = '[object RegExp]', $fa634775d9386048$var$setTag = '[object Set]', $fa634775d9386048$var$stringTag = '[object String]', $fa634775d9386048$var$symbolTag = '[object Symbol]', $fa634775d9386048$var$weakMapTag = '[object WeakMap]';
var $fa634775d9386048$var$arrayBufferTag = '[object ArrayBuffer]', $fa634775d9386048$var$dataViewTag = '[object DataView]', $fa634775d9386048$var$float32Tag = '[object Float32Array]', $fa634775d9386048$var$float64Tag = '[object Float64Array]', $fa634775d9386048$var$int8Tag = '[object Int8Array]', $fa634775d9386048$var$int16Tag = '[object Int16Array]', $fa634775d9386048$var$int32Tag = '[object Int32Array]', $fa634775d9386048$var$uint8Tag = '[object Uint8Array]', $fa634775d9386048$var$uint8ClampedTag = '[object Uint8ClampedArray]', $fa634775d9386048$var$uint16Tag = '[object Uint16Array]', $fa634775d9386048$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $fa634775d9386048$var$cloneableTags = {};
$fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$argsTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$arrayTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$arrayBufferTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$dataViewTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$boolTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$dateTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$float32Tag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$float64Tag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$int8Tag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$int16Tag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$int32Tag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$mapTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$numberTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$objectTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$regexpTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$setTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$stringTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$symbolTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$uint8Tag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$uint8ClampedTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$uint16Tag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$uint32Tag] = true;
$fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$errorTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$funcTag] = $fa634775d9386048$var$cloneableTags[$fa634775d9386048$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $fa634775d9386048$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $fa634775d9386048$var$CLONE_DEEP_FLAG, isFlat = bitmask & $fa634775d9386048$var$CLONE_FLAT_FLAG, isFull = bitmask & $fa634775d9386048$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $42tql.default)(value)) return value;
    var isArr = (0, $hCd6c.default)(value);
    if (isArr) {
        result = (0, $6P2xZ.default)(value);
        if (!isDeep) return (0, $1XCwi.default)(value, result);
    } else {
        var tag = (0, $3Q0KW.default)(value), isFunc = tag == $fa634775d9386048$var$funcTag || tag == $fa634775d9386048$var$genTag;
        if ((0, $2WNrA.default)(value)) return (0, $2Y7T9.default)(value, isDeep);
        if (tag == $fa634775d9386048$var$objectTag || tag == $fa634775d9386048$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $d2DPO.default)(value);
            if (!isDeep) return isFlat ? (0, $j2GsH.default)(value, (0, $8TPty.default)(result, value)) : (0, $aPEXd.default)(value, (0, $bOaNB.default)(result, value));
        } else {
            if (!$fa634775d9386048$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $d0Wb9.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $kmWRU.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $hpUbC.default)(value)) value.forEach(function(subValue) {
        result.add($fa634775d9386048$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $1GcYn.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $fa634775d9386048$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $h11vi.default) : (0, $g6rzB.default) : isFlat ? (0, $1F2kI.default) : (0, $egoNX.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $fo4tZ.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $g61zT.default)(result, key, $fa634775d9386048$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $fa634775d9386048$export$2e2bcd8739ae039 = $fa634775d9386048$var$baseClone;

});
parcelRegister("kmWRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed4386c310984102$export$2e2bcd8739ae039; });

var $47Nf5 = parcelRequire("47Nf5");

var $iI4R0 = parcelRequire("iI4R0");

var $5z5L3 = parcelRequire("5z5L3");

var $lQPKZ = parcelRequire("lQPKZ");

var $aarhG = parcelRequire("aarhG");

var $dG8cx = parcelRequire("dG8cx");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ed4386c310984102$var$Stack(entries) {
    var data = this.__data__ = new (0, $47Nf5.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$ed4386c310984102$var$Stack.prototype.clear = (0, $iI4R0.default);
$ed4386c310984102$var$Stack.prototype['delete'] = (0, $5z5L3.default);
$ed4386c310984102$var$Stack.prototype.get = (0, $lQPKZ.default);
$ed4386c310984102$var$Stack.prototype.has = (0, $aarhG.default);
$ed4386c310984102$var$Stack.prototype.set = (0, $dG8cx.default);
var $ed4386c310984102$export$2e2bcd8739ae039 = $ed4386c310984102$var$Stack;

});
parcelRegister("47Nf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $300e035fbb4cc740$export$2e2bcd8739ae039; });

var $lfTGM = parcelRequire("lfTGM");

var $cGsDN = parcelRequire("cGsDN");

var $kZm0F = parcelRequire("kZm0F");

var $1DiKr = parcelRequire("1DiKr");

var $gNWJl = parcelRequire("gNWJl");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $300e035fbb4cc740$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$300e035fbb4cc740$var$ListCache.prototype.clear = (0, $lfTGM.default);
$300e035fbb4cc740$var$ListCache.prototype['delete'] = (0, $cGsDN.default);
$300e035fbb4cc740$var$ListCache.prototype.get = (0, $kZm0F.default);
$300e035fbb4cc740$var$ListCache.prototype.has = (0, $1DiKr.default);
$300e035fbb4cc740$var$ListCache.prototype.set = (0, $gNWJl.default);
var $300e035fbb4cc740$export$2e2bcd8739ae039 = $300e035fbb4cc740$var$ListCache;

});
parcelRegister("lfTGM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f796325ee763a67e$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f796325ee763a67e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $f796325ee763a67e$export$2e2bcd8739ae039 = $f796325ee763a67e$var$listCacheClear;

});

parcelRegister("cGsDN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93bf9fc0615ce3e9$export$2e2bcd8739ae039; });

var $gNS2d = parcelRequire("gNS2d");
/** Used for built-in method references. */ var $93bf9fc0615ce3e9$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $93bf9fc0615ce3e9$var$splice = $93bf9fc0615ce3e9$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $93bf9fc0615ce3e9$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $gNS2d.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $93bf9fc0615ce3e9$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $93bf9fc0615ce3e9$export$2e2bcd8739ae039 = $93bf9fc0615ce3e9$var$listCacheDelete;

});
parcelRegister("gNS2d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3bb231f22f51d6f$export$2e2bcd8739ae039; });

var $lAkoK = parcelRequire("lAkoK");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c3bb231f22f51d6f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lAkoK.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $c3bb231f22f51d6f$export$2e2bcd8739ae039 = $c3bb231f22f51d6f$var$assocIndexOf;

});
parcelRegister("lAkoK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb6cc86b72d711eb$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fb6cc86b72d711eb$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fb6cc86b72d711eb$export$2e2bcd8739ae039 = $fb6cc86b72d711eb$var$eq;

});



parcelRegister("kZm0F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47a93ceb22da65f$export$2e2bcd8739ae039; });

var $gNS2d = parcelRequire("gNS2d");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f47a93ceb22da65f$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $gNS2d.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $f47a93ceb22da65f$export$2e2bcd8739ae039 = $f47a93ceb22da65f$var$listCacheGet;

});

parcelRegister("1DiKr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1307f9f5ee1625f9$export$2e2bcd8739ae039; });

var $gNS2d = parcelRequire("gNS2d");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1307f9f5ee1625f9$var$listCacheHas(key) {
    return (0, $gNS2d.default)(this.__data__, key) > -1;
}
var $1307f9f5ee1625f9$export$2e2bcd8739ae039 = $1307f9f5ee1625f9$var$listCacheHas;

});

parcelRegister("gNWJl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3bec79394bcf522$export$2e2bcd8739ae039; });

var $gNS2d = parcelRequire("gNS2d");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c3bec79394bcf522$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $gNS2d.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $c3bec79394bcf522$export$2e2bcd8739ae039 = $c3bec79394bcf522$var$listCacheSet;

});


parcelRegister("iI4R0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f019ed89e0e36b$export$2e2bcd8739ae039; });

var $47Nf5 = parcelRequire("47Nf5");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d9f019ed89e0e36b$var$stackClear() {
    this.__data__ = new (0, $47Nf5.default);
    this.size = 0;
}
var $d9f019ed89e0e36b$export$2e2bcd8739ae039 = $d9f019ed89e0e36b$var$stackClear;

});

parcelRegister("5z5L3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40d4b0046fcf9a8d$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $40d4b0046fcf9a8d$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $40d4b0046fcf9a8d$export$2e2bcd8739ae039 = $40d4b0046fcf9a8d$var$stackDelete;

});

parcelRegister("lQPKZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe869a23d06a4d6f$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fe869a23d06a4d6f$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fe869a23d06a4d6f$export$2e2bcd8739ae039 = $fe869a23d06a4d6f$var$stackGet;

});

parcelRegister("aarhG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $767000a550708248$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $767000a550708248$var$stackHas(key) {
    return this.__data__.has(key);
}
var $767000a550708248$export$2e2bcd8739ae039 = $767000a550708248$var$stackHas;

});

parcelRegister("dG8cx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f558f35a228679a$export$2e2bcd8739ae039; });

var $47Nf5 = parcelRequire("47Nf5");

var $eYjHF = parcelRequire("eYjHF");

var $dmF51 = parcelRequire("dmF51");
/** Used as the size to enable large array optimizations. */ var $9f558f35a228679a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9f558f35a228679a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $47Nf5.default)) {
        var pairs = data.__data__;
        if (!(0, $eYjHF.default) || pairs.length < $9f558f35a228679a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $dmF51.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $9f558f35a228679a$export$2e2bcd8739ae039 = $9f558f35a228679a$var$stackSet;

});
parcelRegister("eYjHF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae65f3ef9fcfd52d$export$2e2bcd8739ae039; });

var $bJvdO = parcelRequire("bJvdO");

var $ewUh0 = parcelRequire("ewUh0");
/* Built-in method references that are verified to be native. */ var $ae65f3ef9fcfd52d$var$Map = (0, $bJvdO.default)((0, $ewUh0.default), 'Map');
var $ae65f3ef9fcfd52d$export$2e2bcd8739ae039 = $ae65f3ef9fcfd52d$var$Map;

});
parcelRegister("bJvdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88ac1dac25a6fcab$export$2e2bcd8739ae039; });

var $lywLo = parcelRequire("lywLo");

var $do1M3 = parcelRequire("do1M3");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $88ac1dac25a6fcab$var$getNative(object, key) {
    var value = (0, $do1M3.default)(object, key);
    return (0, $lywLo.default)(value) ? value : undefined;
}
var $88ac1dac25a6fcab$export$2e2bcd8739ae039 = $88ac1dac25a6fcab$var$getNative;

});
parcelRegister("lywLo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb16301a8449839d$export$2e2bcd8739ae039; });

var $f3hTG = parcelRequire("f3hTG");

var $bZpp2 = parcelRequire("bZpp2");

var $42tql = parcelRequire("42tql");

var $flEUg = parcelRequire("flEUg");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $fb16301a8449839d$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $fb16301a8449839d$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $fb16301a8449839d$var$funcProto = Function.prototype, $fb16301a8449839d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $fb16301a8449839d$var$funcToString = $fb16301a8449839d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $fb16301a8449839d$var$hasOwnProperty = $fb16301a8449839d$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $fb16301a8449839d$var$reIsNative = RegExp('^' + $fb16301a8449839d$var$funcToString.call($fb16301a8449839d$var$hasOwnProperty).replace($fb16301a8449839d$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $fb16301a8449839d$var$baseIsNative(value) {
    if (!(0, $42tql.default)(value) || (0, $bZpp2.default)(value)) return false;
    var pattern = (0, $f3hTG.default)(value) ? $fb16301a8449839d$var$reIsNative : $fb16301a8449839d$var$reIsHostCtor;
    return pattern.test((0, $flEUg.default)(value));
}
var $fb16301a8449839d$export$2e2bcd8739ae039 = $fb16301a8449839d$var$baseIsNative;

});
parcelRegister("bZpp2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba918abaffe42aa$export$2e2bcd8739ae039; });

var $kzyzu = parcelRequire("kzyzu");
/** Used to detect methods masquerading as native. */ var $8ba918abaffe42aa$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $kzyzu.default) && (0, $kzyzu.default).keys && (0, $kzyzu.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8ba918abaffe42aa$var$isMasked(func) {
    return !!$8ba918abaffe42aa$var$maskSrcKey && $8ba918abaffe42aa$var$maskSrcKey in func;
}
var $8ba918abaffe42aa$export$2e2bcd8739ae039 = $8ba918abaffe42aa$var$isMasked;

});
parcelRegister("kzyzu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efa1e4b46a025982$export$2e2bcd8739ae039; });

var $ewUh0 = parcelRequire("ewUh0");
/** Used to detect overreaching core-js shims. */ var $efa1e4b46a025982$var$coreJsData = (0, $ewUh0.default)['__core-js_shared__'];
var $efa1e4b46a025982$export$2e2bcd8739ae039 = $efa1e4b46a025982$var$coreJsData;

});


parcelRegister("flEUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2c88c58b185cd94$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $b2c88c58b185cd94$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $b2c88c58b185cd94$var$funcToString = $b2c88c58b185cd94$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $b2c88c58b185cd94$var$toSource(func) {
    if (func != null) {
        try {
            return $b2c88c58b185cd94$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $b2c88c58b185cd94$export$2e2bcd8739ae039 = $b2c88c58b185cd94$var$toSource;

});


parcelRegister("do1M3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9beee4869b21fe71$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9beee4869b21fe71$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $9beee4869b21fe71$export$2e2bcd8739ae039 = $9beee4869b21fe71$var$getValue;

});



parcelRegister("dmF51", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bad320d9a2f351b$export$2e2bcd8739ae039; });

var $19oB9 = parcelRequire("19oB9");

var $fpOKm = parcelRequire("fpOKm");

var $l8qwe = parcelRequire("l8qwe");

var $aQaq1 = parcelRequire("aQaq1");

var $lz27l = parcelRequire("lz27l");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9bad320d9a2f351b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9bad320d9a2f351b$var$MapCache.prototype.clear = (0, $19oB9.default);
$9bad320d9a2f351b$var$MapCache.prototype['delete'] = (0, $fpOKm.default);
$9bad320d9a2f351b$var$MapCache.prototype.get = (0, $l8qwe.default);
$9bad320d9a2f351b$var$MapCache.prototype.has = (0, $aQaq1.default);
$9bad320d9a2f351b$var$MapCache.prototype.set = (0, $lz27l.default);
var $9bad320d9a2f351b$export$2e2bcd8739ae039 = $9bad320d9a2f351b$var$MapCache;

});
parcelRegister("19oB9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d69b66764d95fe9$export$2e2bcd8739ae039; });

var $jzNE8 = parcelRequire("jzNE8");

var $47Nf5 = parcelRequire("47Nf5");

var $eYjHF = parcelRequire("eYjHF");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0d69b66764d95fe9$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $jzNE8.default),
        'map': new ((0, $eYjHF.default) || (0, $47Nf5.default)),
        'string': new (0, $jzNE8.default)
    };
}
var $0d69b66764d95fe9$export$2e2bcd8739ae039 = $0d69b66764d95fe9$var$mapCacheClear;

});
parcelRegister("jzNE8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e407cbf38fc46df8$export$2e2bcd8739ae039; });

var $kE2vj = parcelRequire("kE2vj");

var $jmwRp = parcelRequire("jmwRp");

var $2njLh = parcelRequire("2njLh");

var $e4W9L = parcelRequire("e4W9L");

var $hUc91 = parcelRequire("hUc91");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e407cbf38fc46df8$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e407cbf38fc46df8$var$Hash.prototype.clear = (0, $kE2vj.default);
$e407cbf38fc46df8$var$Hash.prototype['delete'] = (0, $jmwRp.default);
$e407cbf38fc46df8$var$Hash.prototype.get = (0, $2njLh.default);
$e407cbf38fc46df8$var$Hash.prototype.has = (0, $e4W9L.default);
$e407cbf38fc46df8$var$Hash.prototype.set = (0, $hUc91.default);
var $e407cbf38fc46df8$export$2e2bcd8739ae039 = $e407cbf38fc46df8$var$Hash;

});
parcelRegister("kE2vj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0797c4d93e97198$export$2e2bcd8739ae039; });

var $aRdga = parcelRequire("aRdga");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f0797c4d93e97198$var$hashClear() {
    this.__data__ = (0, $aRdga.default) ? (0, $aRdga.default)(null) : {};
    this.size = 0;
}
var $f0797c4d93e97198$export$2e2bcd8739ae039 = $f0797c4d93e97198$var$hashClear;

});
parcelRegister("aRdga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e7923bf0426f960$export$2e2bcd8739ae039; });

var $bJvdO = parcelRequire("bJvdO");
/* Built-in method references that are verified to be native. */ var $7e7923bf0426f960$var$nativeCreate = (0, $bJvdO.default)(Object, 'create');
var $7e7923bf0426f960$export$2e2bcd8739ae039 = $7e7923bf0426f960$var$nativeCreate;

});


parcelRegister("jmwRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1898fce92204971$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e1898fce92204971$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $e1898fce92204971$export$2e2bcd8739ae039 = $e1898fce92204971$var$hashDelete;

});

parcelRegister("2njLh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bad0ef7cbb9a9c1$export$2e2bcd8739ae039; });

var $aRdga = parcelRequire("aRdga");
/** Used to stand-in for `undefined` hash values. */ var $1bad0ef7cbb9a9c1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $1bad0ef7cbb9a9c1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1bad0ef7cbb9a9c1$var$hasOwnProperty = $1bad0ef7cbb9a9c1$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1bad0ef7cbb9a9c1$var$hashGet(key) {
    var data = this.__data__;
    if (0, $aRdga.default) {
        var result = data[key];
        return result === $1bad0ef7cbb9a9c1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1bad0ef7cbb9a9c1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $1bad0ef7cbb9a9c1$export$2e2bcd8739ae039 = $1bad0ef7cbb9a9c1$var$hashGet;

});

parcelRegister("e4W9L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3fe8d17015efef4$export$2e2bcd8739ae039; });

var $aRdga = parcelRequire("aRdga");
/** Used for built-in method references. */ var $a3fe8d17015efef4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a3fe8d17015efef4$var$hasOwnProperty = $a3fe8d17015efef4$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a3fe8d17015efef4$var$hashHas(key) {
    var data = this.__data__;
    return (0, $aRdga.default) ? data[key] !== undefined : $a3fe8d17015efef4$var$hasOwnProperty.call(data, key);
}
var $a3fe8d17015efef4$export$2e2bcd8739ae039 = $a3fe8d17015efef4$var$hashHas;

});

parcelRegister("hUc91", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d09116412ae866e3$export$2e2bcd8739ae039; });

var $aRdga = parcelRequire("aRdga");
/** Used to stand-in for `undefined` hash values. */ var $d09116412ae866e3$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d09116412ae866e3$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $aRdga.default) && value === undefined ? $d09116412ae866e3$var$HASH_UNDEFINED : value;
    return this;
}
var $d09116412ae866e3$export$2e2bcd8739ae039 = $d09116412ae866e3$var$hashSet;

});



parcelRegister("fpOKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3908e0de5ca650d$export$2e2bcd8739ae039; });

var $2d5PP = parcelRequire("2d5PP");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b3908e0de5ca650d$var$mapCacheDelete(key) {
    var result = (0, $2d5PP.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $b3908e0de5ca650d$export$2e2bcd8739ae039 = $b3908e0de5ca650d$var$mapCacheDelete;

});
parcelRegister("2d5PP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19c1525c339c9ee1$export$2e2bcd8739ae039; });

var $8PCRj = parcelRequire("8PCRj");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $19c1525c339c9ee1$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $8PCRj.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $19c1525c339c9ee1$export$2e2bcd8739ae039 = $19c1525c339c9ee1$var$getMapData;

});
parcelRegister("8PCRj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01a8cb450738bce2$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $01a8cb450738bce2$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $01a8cb450738bce2$export$2e2bcd8739ae039 = $01a8cb450738bce2$var$isKeyable;

});



parcelRegister("l8qwe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f62eea6efef7c54f$export$2e2bcd8739ae039; });

var $2d5PP = parcelRequire("2d5PP");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f62eea6efef7c54f$var$mapCacheGet(key) {
    return (0, $2d5PP.default)(this, key).get(key);
}
var $f62eea6efef7c54f$export$2e2bcd8739ae039 = $f62eea6efef7c54f$var$mapCacheGet;

});

parcelRegister("aQaq1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e46d7a52c6c7c72$export$2e2bcd8739ae039; });

var $2d5PP = parcelRequire("2d5PP");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7e46d7a52c6c7c72$var$mapCacheHas(key) {
    return (0, $2d5PP.default)(this, key).has(key);
}
var $7e46d7a52c6c7c72$export$2e2bcd8739ae039 = $7e46d7a52c6c7c72$var$mapCacheHas;

});

parcelRegister("lz27l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb2e8254db4fe135$export$2e2bcd8739ae039; });

var $2d5PP = parcelRequire("2d5PP");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $fb2e8254db4fe135$var$mapCacheSet(key, value) {
    var data = (0, $2d5PP.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $fb2e8254db4fe135$export$2e2bcd8739ae039 = $fb2e8254db4fe135$var$mapCacheSet;

});




parcelRegister("fo4tZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b33c93177052dabc$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $b33c93177052dabc$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $b33c93177052dabc$export$2e2bcd8739ae039 = $b33c93177052dabc$var$arrayEach;

});

parcelRegister("g61zT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb7e6e3d0c979086$export$2e2bcd8739ae039; });

var $hiRHm = parcelRequire("hiRHm");

var $lAkoK = parcelRequire("lAkoK");
/** Used for built-in method references. */ var $bb7e6e3d0c979086$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb7e6e3d0c979086$var$hasOwnProperty = $bb7e6e3d0c979086$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $bb7e6e3d0c979086$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($bb7e6e3d0c979086$var$hasOwnProperty.call(object, key) && (0, $lAkoK.default)(objValue, value)) || value === undefined && !(key in object)) (0, $hiRHm.default)(object, key, value);
}
var $bb7e6e3d0c979086$export$2e2bcd8739ae039 = $bb7e6e3d0c979086$var$assignValue;

});
parcelRegister("hiRHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c98dc57f52321d26$export$2e2bcd8739ae039; });

var $1zBuI = parcelRequire("1zBuI");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c98dc57f52321d26$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $1zBuI.default)) (0, $1zBuI.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $c98dc57f52321d26$export$2e2bcd8739ae039 = $c98dc57f52321d26$var$baseAssignValue;

});
parcelRegister("1zBuI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $125624eec7b8477f$export$2e2bcd8739ae039; });

var $bJvdO = parcelRequire("bJvdO");
var $125624eec7b8477f$var$defineProperty = function() {
    try {
        var func = (0, $bJvdO.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $125624eec7b8477f$export$2e2bcd8739ae039 = $125624eec7b8477f$var$defineProperty;

});



parcelRegister("bOaNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $898cbdb3e485c54b$export$2e2bcd8739ae039; });

var $iRIvT = parcelRequire("iRIvT");

var $egoNX = parcelRequire("egoNX");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $898cbdb3e485c54b$var$baseAssign(object, source) {
    return object && (0, $iRIvT.default)(source, (0, $egoNX.default)(source), object);
}
var $898cbdb3e485c54b$export$2e2bcd8739ae039 = $898cbdb3e485c54b$var$baseAssign;

});
parcelRegister("iRIvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbbfb4ac7723e192$export$2e2bcd8739ae039; });

var $g61zT = parcelRequire("g61zT");

var $hiRHm = parcelRequire("hiRHm");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $dbbfb4ac7723e192$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $hiRHm.default)(object, key, newValue);
        else (0, $g61zT.default)(object, key, newValue);
    }
    return object;
}
var $dbbfb4ac7723e192$export$2e2bcd8739ae039 = $dbbfb4ac7723e192$var$copyObject;

});


parcelRegister("8TPty", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ab63c36769a227$export$2e2bcd8739ae039; });

var $iRIvT = parcelRequire("iRIvT");

var $1F2kI = parcelRequire("1F2kI");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $67ab63c36769a227$var$baseAssignIn(object, source) {
    return object && (0, $iRIvT.default)(source, (0, $1F2kI.default)(source), object);
}
var $67ab63c36769a227$export$2e2bcd8739ae039 = $67ab63c36769a227$var$baseAssignIn;

});
parcelRegister("1F2kI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $135b6e125828133f$export$2e2bcd8739ae039; });

var $iKUo3 = parcelRequire("iKUo3");

var $3FFnK = parcelRequire("3FFnK");

var $7wVIe = parcelRequire("7wVIe");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $135b6e125828133f$var$keysIn(object) {
    return (0, $7wVIe.default)(object) ? (0, $iKUo3.default)(object, true) : (0, $3FFnK.default)(object);
}
var $135b6e125828133f$export$2e2bcd8739ae039 = $135b6e125828133f$var$keysIn;

});
parcelRegister("3FFnK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ac54d0f390e5bbe$export$2e2bcd8739ae039; });

var $42tql = parcelRequire("42tql");

var $aeTMJ = parcelRequire("aeTMJ");

var $jfSWG = parcelRequire("jfSWG");
/** Used for built-in method references. */ var $2ac54d0f390e5bbe$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2ac54d0f390e5bbe$var$hasOwnProperty = $2ac54d0f390e5bbe$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2ac54d0f390e5bbe$var$baseKeysIn(object) {
    if (!(0, $42tql.default)(object)) return (0, $jfSWG.default)(object);
    var isProto = (0, $aeTMJ.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$2ac54d0f390e5bbe$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $2ac54d0f390e5bbe$export$2e2bcd8739ae039 = $2ac54d0f390e5bbe$var$baseKeysIn;

});
parcelRegister("jfSWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e04a0a1394a7faa9$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e04a0a1394a7faa9$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $e04a0a1394a7faa9$export$2e2bcd8739ae039 = $e04a0a1394a7faa9$var$nativeKeysIn;

});




parcelRegister("2Y7T9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22974de10159bfb4$export$2e2bcd8739ae039; });

var $ewUh0 = parcelRequire("ewUh0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ewUh0.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $22974de10159bfb4$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("1XCwi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d92e635b60058f$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $16d92e635b60058f$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $16d92e635b60058f$export$2e2bcd8739ae039 = $16d92e635b60058f$var$copyArray;

});

parcelRegister("aPEXd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e2e6f6e589a150e$export$2e2bcd8739ae039; });

var $iRIvT = parcelRequire("iRIvT");

var $jYogy = parcelRequire("jYogy");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $7e2e6f6e589a150e$var$copySymbols(source, object) {
    return (0, $iRIvT.default)(source, (0, $jYogy.default)(source), object);
}
var $7e2e6f6e589a150e$export$2e2bcd8739ae039 = $7e2e6f6e589a150e$var$copySymbols;

});
parcelRegister("jYogy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8a671a3d2877084$export$2e2bcd8739ae039; });

var $eK15E = parcelRequire("eK15E");

var $6A2L2 = parcelRequire("6A2L2");
/** Used for built-in method references. */ var $e8a671a3d2877084$var$objectProto = Object.prototype;
/** Built-in value references. */ var $e8a671a3d2877084$var$propertyIsEnumerable = $e8a671a3d2877084$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e8a671a3d2877084$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e8a671a3d2877084$var$getSymbols = !$e8a671a3d2877084$var$nativeGetSymbols ? (0, $6A2L2.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $eK15E.default)($e8a671a3d2877084$var$nativeGetSymbols(object), function(symbol) {
        return $e8a671a3d2877084$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $e8a671a3d2877084$export$2e2bcd8739ae039 = $e8a671a3d2877084$var$getSymbols;

});
parcelRegister("eK15E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abb6350b6f318687$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $abb6350b6f318687$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $abb6350b6f318687$export$2e2bcd8739ae039 = $abb6350b6f318687$var$arrayFilter;

});

parcelRegister("6A2L2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca83e827c3da6d4$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $4ca83e827c3da6d4$var$stubArray() {
    return [];
}
var $4ca83e827c3da6d4$export$2e2bcd8739ae039 = $4ca83e827c3da6d4$var$stubArray;

});



parcelRegister("j2GsH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddcf2441383b7504$export$2e2bcd8739ae039; });

var $iRIvT = parcelRequire("iRIvT");

var $6xqXw = parcelRequire("6xqXw");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ddcf2441383b7504$var$copySymbolsIn(source, object) {
    return (0, $iRIvT.default)(source, (0, $6xqXw.default)(source), object);
}
var $ddcf2441383b7504$export$2e2bcd8739ae039 = $ddcf2441383b7504$var$copySymbolsIn;

});
parcelRegister("6xqXw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c2abca10b1f8dc4$export$2e2bcd8739ae039; });

var $31cwr = parcelRequire("31cwr");

var $4jcRQ = parcelRequire("4jcRQ");

var $jYogy = parcelRequire("jYogy");

var $6A2L2 = parcelRequire("6A2L2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4c2abca10b1f8dc4$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4c2abca10b1f8dc4$var$getSymbolsIn = !$4c2abca10b1f8dc4$var$nativeGetSymbols ? (0, $6A2L2.default) : function(object) {
    var result = [];
    while(object){
        (0, $31cwr.default)(result, (0, $jYogy.default)(object));
        object = (0, $4jcRQ.default)(object);
    }
    return result;
};
var $4c2abca10b1f8dc4$export$2e2bcd8739ae039 = $4c2abca10b1f8dc4$var$getSymbolsIn;

});
parcelRegister("31cwr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $232b2dc33b9b9a60$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $232b2dc33b9b9a60$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $232b2dc33b9b9a60$export$2e2bcd8739ae039 = $232b2dc33b9b9a60$var$arrayPush;

});

parcelRegister("4jcRQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3232eafe34c701f1$export$2e2bcd8739ae039; });

var $7zX8O = parcelRequire("7zX8O");
/** Built-in value references. */ var $3232eafe34c701f1$var$getPrototype = (0, $7zX8O.default)(Object.getPrototypeOf, Object);
var $3232eafe34c701f1$export$2e2bcd8739ae039 = $3232eafe34c701f1$var$getPrototype;

});



parcelRegister("g6rzB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb929856c50efb15$export$2e2bcd8739ae039; });

var $cdxOm = parcelRequire("cdxOm");

var $jYogy = parcelRequire("jYogy");

var $egoNX = parcelRequire("egoNX");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bb929856c50efb15$var$getAllKeys(object) {
    return (0, $cdxOm.default)(object, (0, $egoNX.default), (0, $jYogy.default));
}
var $bb929856c50efb15$export$2e2bcd8739ae039 = $bb929856c50efb15$var$getAllKeys;

});
parcelRegister("cdxOm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e50ed296c7e5874$export$2e2bcd8739ae039; });

var $31cwr = parcelRequire("31cwr");

var $hCd6c = parcelRequire("hCd6c");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8e50ed296c7e5874$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hCd6c.default)(object) ? result : (0, $31cwr.default)(result, symbolsFunc(object));
}
var $8e50ed296c7e5874$export$2e2bcd8739ae039 = $8e50ed296c7e5874$var$baseGetAllKeys;

});


parcelRegister("h11vi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c633b241d2565215$export$2e2bcd8739ae039; });

var $cdxOm = parcelRequire("cdxOm");

var $6xqXw = parcelRequire("6xqXw");

var $1F2kI = parcelRequire("1F2kI");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c633b241d2565215$var$getAllKeysIn(object) {
    return (0, $cdxOm.default)(object, (0, $1F2kI.default), (0, $6xqXw.default));
}
var $c633b241d2565215$export$2e2bcd8739ae039 = $c633b241d2565215$var$getAllKeysIn;

});

parcelRegister("3Q0KW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb6d091288bf98d$export$2e2bcd8739ae039; });

var $8q1r0 = parcelRequire("8q1r0");

var $eYjHF = parcelRequire("eYjHF");

var $j4FyR = parcelRequire("j4FyR");

var $4Oq6x = parcelRequire("4Oq6x");

var $9LgtO = parcelRequire("9LgtO");

var $65ROZ = parcelRequire("65ROZ");

var $flEUg = parcelRequire("flEUg");
/** `Object#toString` result references. */ var $2cb6d091288bf98d$var$mapTag = '[object Map]', $2cb6d091288bf98d$var$objectTag = '[object Object]', $2cb6d091288bf98d$var$promiseTag = '[object Promise]', $2cb6d091288bf98d$var$setTag = '[object Set]', $2cb6d091288bf98d$var$weakMapTag = '[object WeakMap]';
var $2cb6d091288bf98d$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $2cb6d091288bf98d$var$dataViewCtorString = (0, $flEUg.default)((0, $8q1r0.default)), $2cb6d091288bf98d$var$mapCtorString = (0, $flEUg.default)((0, $eYjHF.default)), $2cb6d091288bf98d$var$promiseCtorString = (0, $flEUg.default)((0, $j4FyR.default)), $2cb6d091288bf98d$var$setCtorString = (0, $flEUg.default)((0, $4Oq6x.default)), $2cb6d091288bf98d$var$weakMapCtorString = (0, $flEUg.default)((0, $9LgtO.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $2cb6d091288bf98d$var$getTag = (0, $65ROZ.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $8q1r0.default) && $2cb6d091288bf98d$var$getTag(new (0, $8q1r0.default)(new ArrayBuffer(1))) != $2cb6d091288bf98d$var$dataViewTag || (0, $eYjHF.default) && $2cb6d091288bf98d$var$getTag(new (0, $eYjHF.default)) != $2cb6d091288bf98d$var$mapTag || (0, $j4FyR.default) && $2cb6d091288bf98d$var$getTag((0, $j4FyR.default).resolve()) != $2cb6d091288bf98d$var$promiseTag || (0, $4Oq6x.default) && $2cb6d091288bf98d$var$getTag(new (0, $4Oq6x.default)) != $2cb6d091288bf98d$var$setTag || (0, $9LgtO.default) && $2cb6d091288bf98d$var$getTag(new (0, $9LgtO.default)) != $2cb6d091288bf98d$var$weakMapTag) $2cb6d091288bf98d$var$getTag = function(value) {
    var result = (0, $65ROZ.default)(value), Ctor = result == $2cb6d091288bf98d$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $flEUg.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $2cb6d091288bf98d$var$dataViewCtorString:
            return $2cb6d091288bf98d$var$dataViewTag;
        case $2cb6d091288bf98d$var$mapCtorString:
            return $2cb6d091288bf98d$var$mapTag;
        case $2cb6d091288bf98d$var$promiseCtorString:
            return $2cb6d091288bf98d$var$promiseTag;
        case $2cb6d091288bf98d$var$setCtorString:
            return $2cb6d091288bf98d$var$setTag;
        case $2cb6d091288bf98d$var$weakMapCtorString:
            return $2cb6d091288bf98d$var$weakMapTag;
    }
    return result;
};
var $2cb6d091288bf98d$export$2e2bcd8739ae039 = $2cb6d091288bf98d$var$getTag;

});
parcelRegister("8q1r0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6211dd5567f74832$export$2e2bcd8739ae039; });

var $bJvdO = parcelRequire("bJvdO");

var $ewUh0 = parcelRequire("ewUh0");
/* Built-in method references that are verified to be native. */ var $6211dd5567f74832$var$DataView = (0, $bJvdO.default)((0, $ewUh0.default), 'DataView');
var $6211dd5567f74832$export$2e2bcd8739ae039 = $6211dd5567f74832$var$DataView;

});

parcelRegister("j4FyR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de2ea13e1ff709bb$export$2e2bcd8739ae039; });

var $bJvdO = parcelRequire("bJvdO");

var $ewUh0 = parcelRequire("ewUh0");
/* Built-in method references that are verified to be native. */ var $de2ea13e1ff709bb$var$Promise = (0, $bJvdO.default)((0, $ewUh0.default), 'Promise');
var $de2ea13e1ff709bb$export$2e2bcd8739ae039 = $de2ea13e1ff709bb$var$Promise;

});

parcelRegister("4Oq6x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $381014b89696cefc$export$2e2bcd8739ae039; });

var $bJvdO = parcelRequire("bJvdO");

var $ewUh0 = parcelRequire("ewUh0");
/* Built-in method references that are verified to be native. */ var $381014b89696cefc$var$Set = (0, $bJvdO.default)((0, $ewUh0.default), 'Set');
var $381014b89696cefc$export$2e2bcd8739ae039 = $381014b89696cefc$var$Set;

});

parcelRegister("9LgtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71b5495f4d5eb0e9$export$2e2bcd8739ae039; });

var $bJvdO = parcelRequire("bJvdO");

var $ewUh0 = parcelRequire("ewUh0");
/* Built-in method references that are verified to be native. */ var $71b5495f4d5eb0e9$var$WeakMap = (0, $bJvdO.default)((0, $ewUh0.default), 'WeakMap');
var $71b5495f4d5eb0e9$export$2e2bcd8739ae039 = $71b5495f4d5eb0e9$var$WeakMap;

});


parcelRegister("6P2xZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f797b572ae52479$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $4f797b572ae52479$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4f797b572ae52479$var$hasOwnProperty = $4f797b572ae52479$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $4f797b572ae52479$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $4f797b572ae52479$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $4f797b572ae52479$export$2e2bcd8739ae039 = $4f797b572ae52479$var$initCloneArray;

});

parcelRegister("d0Wb9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97986794cdcbc6ba$export$2e2bcd8739ae039; });

var $8Jnvv = parcelRequire("8Jnvv");

var $bmh8V = parcelRequire("bmh8V");

var $9WEME = parcelRequire("9WEME");

var $5pwRL = parcelRequire("5pwRL");

var $hzMeV = parcelRequire("hzMeV");
/** `Object#toString` result references. */ var $97986794cdcbc6ba$var$boolTag = '[object Boolean]', $97986794cdcbc6ba$var$dateTag = '[object Date]', $97986794cdcbc6ba$var$mapTag = '[object Map]', $97986794cdcbc6ba$var$numberTag = '[object Number]', $97986794cdcbc6ba$var$regexpTag = '[object RegExp]', $97986794cdcbc6ba$var$setTag = '[object Set]', $97986794cdcbc6ba$var$stringTag = '[object String]', $97986794cdcbc6ba$var$symbolTag = '[object Symbol]';
var $97986794cdcbc6ba$var$arrayBufferTag = '[object ArrayBuffer]', $97986794cdcbc6ba$var$dataViewTag = '[object DataView]', $97986794cdcbc6ba$var$float32Tag = '[object Float32Array]', $97986794cdcbc6ba$var$float64Tag = '[object Float64Array]', $97986794cdcbc6ba$var$int8Tag = '[object Int8Array]', $97986794cdcbc6ba$var$int16Tag = '[object Int16Array]', $97986794cdcbc6ba$var$int32Tag = '[object Int32Array]', $97986794cdcbc6ba$var$uint8Tag = '[object Uint8Array]', $97986794cdcbc6ba$var$uint8ClampedTag = '[object Uint8ClampedArray]', $97986794cdcbc6ba$var$uint16Tag = '[object Uint16Array]', $97986794cdcbc6ba$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $97986794cdcbc6ba$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $97986794cdcbc6ba$var$arrayBufferTag:
            return (0, $8Jnvv.default)(object);
        case $97986794cdcbc6ba$var$boolTag:
        case $97986794cdcbc6ba$var$dateTag:
            return new Ctor(+object);
        case $97986794cdcbc6ba$var$dataViewTag:
            return (0, $bmh8V.default)(object, isDeep);
        case $97986794cdcbc6ba$var$float32Tag:
        case $97986794cdcbc6ba$var$float64Tag:
        case $97986794cdcbc6ba$var$int8Tag:
        case $97986794cdcbc6ba$var$int16Tag:
        case $97986794cdcbc6ba$var$int32Tag:
        case $97986794cdcbc6ba$var$uint8Tag:
        case $97986794cdcbc6ba$var$uint8ClampedTag:
        case $97986794cdcbc6ba$var$uint16Tag:
        case $97986794cdcbc6ba$var$uint32Tag:
            return (0, $hzMeV.default)(object, isDeep);
        case $97986794cdcbc6ba$var$mapTag:
            return new Ctor;
        case $97986794cdcbc6ba$var$numberTag:
        case $97986794cdcbc6ba$var$stringTag:
            return new Ctor(object);
        case $97986794cdcbc6ba$var$regexpTag:
            return (0, $9WEME.default)(object);
        case $97986794cdcbc6ba$var$setTag:
            return new Ctor;
        case $97986794cdcbc6ba$var$symbolTag:
            return (0, $5pwRL.default)(object);
    }
}
var $97986794cdcbc6ba$export$2e2bcd8739ae039 = $97986794cdcbc6ba$var$initCloneByTag;

});
parcelRegister("8Jnvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b4c2b898ab7c9f$export$2e2bcd8739ae039; });

var $l2yFO = parcelRequire("l2yFO");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $65b4c2b898ab7c9f$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $l2yFO.default)(result).set(new (0, $l2yFO.default)(arrayBuffer));
    return result;
}
var $65b4c2b898ab7c9f$export$2e2bcd8739ae039 = $65b4c2b898ab7c9f$var$cloneArrayBuffer;

});
parcelRegister("l2yFO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f514ae482f1d6a88$export$2e2bcd8739ae039; });

var $ewUh0 = parcelRequire("ewUh0");
/** Built-in value references. */ var $f514ae482f1d6a88$var$Uint8Array = (0, $ewUh0.default).Uint8Array;
var $f514ae482f1d6a88$export$2e2bcd8739ae039 = $f514ae482f1d6a88$var$Uint8Array;

});


parcelRegister("bmh8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $844f0c0439ed989a$export$2e2bcd8739ae039; });

var $8Jnvv = parcelRequire("8Jnvv");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $844f0c0439ed989a$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $8Jnvv.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $844f0c0439ed989a$export$2e2bcd8739ae039 = $844f0c0439ed989a$var$cloneDataView;

});

parcelRegister("9WEME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73d92aa05964ca93$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $73d92aa05964ca93$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $73d92aa05964ca93$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $73d92aa05964ca93$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $73d92aa05964ca93$export$2e2bcd8739ae039 = $73d92aa05964ca93$var$cloneRegExp;

});

parcelRegister("5pwRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f08c815db5fa0b0$export$2e2bcd8739ae039; });

var $j22Bs = parcelRequire("j22Bs");
/** Used to convert symbols to primitives and strings. */ var $3f08c815db5fa0b0$var$symbolProto = (0, $j22Bs.default) ? (0, $j22Bs.default).prototype : undefined, $3f08c815db5fa0b0$var$symbolValueOf = $3f08c815db5fa0b0$var$symbolProto ? $3f08c815db5fa0b0$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $3f08c815db5fa0b0$var$cloneSymbol(symbol) {
    return $3f08c815db5fa0b0$var$symbolValueOf ? Object($3f08c815db5fa0b0$var$symbolValueOf.call(symbol)) : {};
}
var $3f08c815db5fa0b0$export$2e2bcd8739ae039 = $3f08c815db5fa0b0$var$cloneSymbol;

});

parcelRegister("hzMeV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccbb1ff466ee386c$export$2e2bcd8739ae039; });

var $8Jnvv = parcelRequire("8Jnvv");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $ccbb1ff466ee386c$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $8Jnvv.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $ccbb1ff466ee386c$export$2e2bcd8739ae039 = $ccbb1ff466ee386c$var$cloneTypedArray;

});


parcelRegister("d2DPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97ea5c96b0d52434$export$2e2bcd8739ae039; });

var $9M1DU = parcelRequire("9M1DU");

var $4jcRQ = parcelRequire("4jcRQ");

var $aeTMJ = parcelRequire("aeTMJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $97ea5c96b0d52434$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $aeTMJ.default)(object) ? (0, $9M1DU.default)((0, $4jcRQ.default)(object)) : {};
}
var $97ea5c96b0d52434$export$2e2bcd8739ae039 = $97ea5c96b0d52434$var$initCloneObject;

});
parcelRegister("9M1DU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71d9def7707b84c5$export$2e2bcd8739ae039; });

var $42tql = parcelRequire("42tql");
/** Built-in value references. */ var $71d9def7707b84c5$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $71d9def7707b84c5$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $42tql.default)(proto)) return {};
        if ($71d9def7707b84c5$var$objectCreate) return $71d9def7707b84c5$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $71d9def7707b84c5$export$2e2bcd8739ae039 = $71d9def7707b84c5$var$baseCreate;

});


parcelRegister("1GcYn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1393c6d690e9f73d$export$2e2bcd8739ae039; });

var $8k1Y3 = parcelRequire("8k1Y3");

var $j7MgO = parcelRequire("j7MgO");

var $dWa57 = parcelRequire("dWa57");
/* Node.js helper references. */ var $1393c6d690e9f73d$var$nodeIsMap = (0, $dWa57.default) && (0, $dWa57.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $1393c6d690e9f73d$var$isMap = $1393c6d690e9f73d$var$nodeIsMap ? (0, $j7MgO.default)($1393c6d690e9f73d$var$nodeIsMap) : (0, $8k1Y3.default);
var $1393c6d690e9f73d$export$2e2bcd8739ae039 = $1393c6d690e9f73d$var$isMap;

});
parcelRegister("8k1Y3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60f1b7bd3b537276$export$2e2bcd8739ae039; });

var $3Q0KW = parcelRequire("3Q0KW");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $60f1b7bd3b537276$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $60f1b7bd3b537276$var$baseIsMap(value) {
    return (0, $bBbWb.default)(value) && (0, $3Q0KW.default)(value) == $60f1b7bd3b537276$var$mapTag;
}
var $60f1b7bd3b537276$export$2e2bcd8739ae039 = $60f1b7bd3b537276$var$baseIsMap;

});


parcelRegister("hpUbC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cae05ae99ff588a0$export$2e2bcd8739ae039; });

var $lNOLm = parcelRequire("lNOLm");

var $j7MgO = parcelRequire("j7MgO");

var $dWa57 = parcelRequire("dWa57");
/* Node.js helper references. */ var $cae05ae99ff588a0$var$nodeIsSet = (0, $dWa57.default) && (0, $dWa57.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $cae05ae99ff588a0$var$isSet = $cae05ae99ff588a0$var$nodeIsSet ? (0, $j7MgO.default)($cae05ae99ff588a0$var$nodeIsSet) : (0, $lNOLm.default);
var $cae05ae99ff588a0$export$2e2bcd8739ae039 = $cae05ae99ff588a0$var$isSet;

});
parcelRegister("lNOLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdf58d05c4e0476e$export$2e2bcd8739ae039; });

var $3Q0KW = parcelRequire("3Q0KW");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $fdf58d05c4e0476e$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $fdf58d05c4e0476e$var$baseIsSet(value) {
    return (0, $bBbWb.default)(value) && (0, $3Q0KW.default)(value) == $fdf58d05c4e0476e$var$setTag;
}
var $fdf58d05c4e0476e$export$2e2bcd8739ae039 = $fdf58d05c4e0476e$var$baseIsSet;

});



parcelRegister("3c4XD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25365739e17ddfbf$export$2e2bcd8739ae039; });

var $leiwU = parcelRequire("leiwU");

var $4uRqq = parcelRequire("4uRqq");

var $e5OyX = parcelRequire("e5OyX");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $25365739e17ddfbf$var$baseMatches(source) {
    var matchData = (0, $4uRqq.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $e5OyX.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $leiwU.default)(object, source, matchData);
    };
}
var $25365739e17ddfbf$export$2e2bcd8739ae039 = $25365739e17ddfbf$var$baseMatches;

});
parcelRegister("leiwU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f74947692cd772ed$export$2e2bcd8739ae039; });

var $kmWRU = parcelRequire("kmWRU");

var $2h5cw = parcelRequire("2h5cw");
/** Used to compose bitmasks for value comparisons. */ var $f74947692cd772ed$var$COMPARE_PARTIAL_FLAG = 1, $f74947692cd772ed$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $f74947692cd772ed$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $kmWRU.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $2h5cw.default)(srcValue, objValue, $f74947692cd772ed$var$COMPARE_PARTIAL_FLAG | $f74947692cd772ed$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $f74947692cd772ed$export$2e2bcd8739ae039 = $f74947692cd772ed$var$baseIsMatch;

});
parcelRegister("2h5cw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a81341acb818c8d$export$2e2bcd8739ae039; });

var $9tZ3H = parcelRequire("9tZ3H");

var $bBbWb = parcelRequire("bBbWb");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $1a81341acb818c8d$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $bBbWb.default)(value) && !(0, $bBbWb.default)(other)) return value !== value && other !== other;
    return (0, $9tZ3H.default)(value, other, bitmask, customizer, $1a81341acb818c8d$var$baseIsEqual, stack);
}
var $1a81341acb818c8d$export$2e2bcd8739ae039 = $1a81341acb818c8d$var$baseIsEqual;

});
parcelRegister("9tZ3H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e762f7647fa323e$export$2e2bcd8739ae039; });

var $kmWRU = parcelRequire("kmWRU");

var $iywbo = parcelRequire("iywbo");

var $4D6mK = parcelRequire("4D6mK");

var $bneZT = parcelRequire("bneZT");

var $3Q0KW = parcelRequire("3Q0KW");

var $hCd6c = parcelRequire("hCd6c");

var $2WNrA = parcelRequire("2WNrA");

var $kcxRF = parcelRequire("kcxRF");
/** Used to compose bitmasks for value comparisons. */ var $6e762f7647fa323e$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $6e762f7647fa323e$var$argsTag = '[object Arguments]', $6e762f7647fa323e$var$arrayTag = '[object Array]', $6e762f7647fa323e$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $6e762f7647fa323e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6e762f7647fa323e$var$hasOwnProperty = $6e762f7647fa323e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6e762f7647fa323e$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $hCd6c.default)(object), othIsArr = (0, $hCd6c.default)(other), objTag = objIsArr ? $6e762f7647fa323e$var$arrayTag : (0, $3Q0KW.default)(object), othTag = othIsArr ? $6e762f7647fa323e$var$arrayTag : (0, $3Q0KW.default)(other);
    objTag = objTag == $6e762f7647fa323e$var$argsTag ? $6e762f7647fa323e$var$objectTag : objTag;
    othTag = othTag == $6e762f7647fa323e$var$argsTag ? $6e762f7647fa323e$var$objectTag : othTag;
    var objIsObj = objTag == $6e762f7647fa323e$var$objectTag, othIsObj = othTag == $6e762f7647fa323e$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $2WNrA.default)(object)) {
        if (!(0, $2WNrA.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $kmWRU.default));
        return objIsArr || (0, $kcxRF.default)(object) ? (0, $iywbo.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $4D6mK.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $6e762f7647fa323e$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $6e762f7647fa323e$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $6e762f7647fa323e$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $kmWRU.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $kmWRU.default));
    return (0, $bneZT.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $6e762f7647fa323e$export$2e2bcd8739ae039 = $6e762f7647fa323e$var$baseIsEqualDeep;

});
parcelRegister("iywbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8245dccdfcee01f$export$2e2bcd8739ae039; });

var $kH0q3 = parcelRequire("kH0q3");

var $jxcvR = parcelRequire("jxcvR");

var $dy9tX = parcelRequire("dy9tX");
/** Used to compose bitmasks for value comparisons. */ var $d8245dccdfcee01f$var$COMPARE_PARTIAL_FLAG = 1, $d8245dccdfcee01f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $d8245dccdfcee01f$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d8245dccdfcee01f$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $d8245dccdfcee01f$var$COMPARE_UNORDERED_FLAG ? new (0, $kH0q3.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $jxcvR.default)(other, function(othValue, othIndex) {
                if (!(0, $dy9tX.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $d8245dccdfcee01f$export$2e2bcd8739ae039 = $d8245dccdfcee01f$var$equalArrays;

});
parcelRegister("kH0q3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f10826098fb6bae3$export$2e2bcd8739ae039; });

var $dmF51 = parcelRequire("dmF51");

var $2VFW1 = parcelRequire("2VFW1");

var $ifVP5 = parcelRequire("ifVP5");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $f10826098fb6bae3$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $dmF51.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$f10826098fb6bae3$var$SetCache.prototype.add = $f10826098fb6bae3$var$SetCache.prototype.push = (0, $2VFW1.default);
$f10826098fb6bae3$var$SetCache.prototype.has = (0, $ifVP5.default);
var $f10826098fb6bae3$export$2e2bcd8739ae039 = $f10826098fb6bae3$var$SetCache;

});
parcelRegister("2VFW1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22216f04e84486a4$export$2e2bcd8739ae039; });
/** Used to stand-in for `undefined` hash values. */ var $22216f04e84486a4$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $22216f04e84486a4$var$setCacheAdd(value) {
    this.__data__.set(value, $22216f04e84486a4$var$HASH_UNDEFINED);
    return this;
}
var $22216f04e84486a4$export$2e2bcd8739ae039 = $22216f04e84486a4$var$setCacheAdd;

});

parcelRegister("ifVP5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a67b2435d81f87$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $d4a67b2435d81f87$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $d4a67b2435d81f87$export$2e2bcd8739ae039 = $d4a67b2435d81f87$var$setCacheHas;

});


parcelRegister("jxcvR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e38ace2a6ad29d56$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $e38ace2a6ad29d56$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $e38ace2a6ad29d56$export$2e2bcd8739ae039 = $e38ace2a6ad29d56$var$arraySome;

});

parcelRegister("dy9tX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dd5ce4d1e08f1aa$export$2e2bcd8739ae039; });
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9dd5ce4d1e08f1aa$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $9dd5ce4d1e08f1aa$export$2e2bcd8739ae039 = $9dd5ce4d1e08f1aa$var$cacheHas;

});


parcelRegister("4D6mK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35efbe19354ed56b$export$2e2bcd8739ae039; });

var $j22Bs = parcelRequire("j22Bs");

var $l2yFO = parcelRequire("l2yFO");

var $lAkoK = parcelRequire("lAkoK");

var $iywbo = parcelRequire("iywbo");

var $kjIx3 = parcelRequire("kjIx3");

var $ixHim = parcelRequire("ixHim");
/** Used to compose bitmasks for value comparisons. */ var $35efbe19354ed56b$var$COMPARE_PARTIAL_FLAG = 1, $35efbe19354ed56b$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $35efbe19354ed56b$var$boolTag = '[object Boolean]', $35efbe19354ed56b$var$dateTag = '[object Date]', $35efbe19354ed56b$var$errorTag = '[object Error]', $35efbe19354ed56b$var$mapTag = '[object Map]', $35efbe19354ed56b$var$numberTag = '[object Number]', $35efbe19354ed56b$var$regexpTag = '[object RegExp]', $35efbe19354ed56b$var$setTag = '[object Set]', $35efbe19354ed56b$var$stringTag = '[object String]', $35efbe19354ed56b$var$symbolTag = '[object Symbol]';
var $35efbe19354ed56b$var$arrayBufferTag = '[object ArrayBuffer]', $35efbe19354ed56b$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $35efbe19354ed56b$var$symbolProto = (0, $j22Bs.default) ? (0, $j22Bs.default).prototype : undefined, $35efbe19354ed56b$var$symbolValueOf = $35efbe19354ed56b$var$symbolProto ? $35efbe19354ed56b$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $35efbe19354ed56b$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $35efbe19354ed56b$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $35efbe19354ed56b$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $l2yFO.default)(object), new (0, $l2yFO.default)(other))) return false;
            return true;
        case $35efbe19354ed56b$var$boolTag:
        case $35efbe19354ed56b$var$dateTag:
        case $35efbe19354ed56b$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $lAkoK.default)(+object, +other);
        case $35efbe19354ed56b$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $35efbe19354ed56b$var$regexpTag:
        case $35efbe19354ed56b$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $35efbe19354ed56b$var$mapTag:
            var convert = (0, $kjIx3.default);
        case $35efbe19354ed56b$var$setTag:
            var isPartial = bitmask & $35efbe19354ed56b$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $ixHim.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $35efbe19354ed56b$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $iywbo.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $35efbe19354ed56b$var$symbolTag:
            if ($35efbe19354ed56b$var$symbolValueOf) return $35efbe19354ed56b$var$symbolValueOf.call(object) == $35efbe19354ed56b$var$symbolValueOf.call(other);
    }
    return false;
}
var $35efbe19354ed56b$export$2e2bcd8739ae039 = $35efbe19354ed56b$var$equalByTag;

});
parcelRegister("kjIx3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca82029305dd6af$export$2e2bcd8739ae039; });
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $eca82029305dd6af$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $eca82029305dd6af$export$2e2bcd8739ae039 = $eca82029305dd6af$var$mapToArray;

});

parcelRegister("ixHim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7fce4989716df82$export$2e2bcd8739ae039; });
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $d7fce4989716df82$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $d7fce4989716df82$export$2e2bcd8739ae039 = $d7fce4989716df82$var$setToArray;

});


parcelRegister("bneZT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $847d79d2be0a8fbe$export$2e2bcd8739ae039; });

var $g6rzB = parcelRequire("g6rzB");
/** Used to compose bitmasks for value comparisons. */ var $847d79d2be0a8fbe$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $847d79d2be0a8fbe$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $847d79d2be0a8fbe$var$hasOwnProperty = $847d79d2be0a8fbe$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $847d79d2be0a8fbe$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $847d79d2be0a8fbe$var$COMPARE_PARTIAL_FLAG, objProps = (0, $g6rzB.default)(object), objLength = objProps.length, othProps = (0, $g6rzB.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $847d79d2be0a8fbe$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $847d79d2be0a8fbe$export$2e2bcd8739ae039 = $847d79d2be0a8fbe$var$equalObjects;

});




parcelRegister("4uRqq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $346367ec4940b9e6$export$2e2bcd8739ae039; });

var $f6O4e = parcelRequire("f6O4e");

var $egoNX = parcelRequire("egoNX");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $346367ec4940b9e6$var$getMatchData(object) {
    var result = (0, $egoNX.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $f6O4e.default)(value)
        ];
    }
    return result;
}
var $346367ec4940b9e6$export$2e2bcd8739ae039 = $346367ec4940b9e6$var$getMatchData;

});
parcelRegister("f6O4e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $affe40e1b12df83e$export$2e2bcd8739ae039; });

var $42tql = parcelRequire("42tql");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $affe40e1b12df83e$var$isStrictComparable(value) {
    return value === value && !(0, $42tql.default)(value);
}
var $affe40e1b12df83e$export$2e2bcd8739ae039 = $affe40e1b12df83e$var$isStrictComparable;

});


parcelRegister("e5OyX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a428c1049244f54b$export$2e2bcd8739ae039; });
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $a428c1049244f54b$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $a428c1049244f54b$export$2e2bcd8739ae039 = $a428c1049244f54b$var$matchesStrictComparable;

});



parcelRegister("jNFGw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6a2edab9dcc18ab$export$2e2bcd8739ae039; });

var $dqScn = parcelRequire("dqScn");

var $luO7C = parcelRequire("luO7C");

var $lkLur = parcelRequire("lkLur");

var $e8stg = parcelRequire("e8stg");

var $iRIvT = parcelRequire("iRIvT");

var $cig6q = parcelRequire("cig6q");

var $l2wL3 = parcelRequire("l2wL3");

var $h11vi = parcelRequire("h11vi");
/** Used to compose bitmasks for cloning. */ var $e6a2edab9dcc18ab$var$CLONE_DEEP_FLAG = 1, $e6a2edab9dcc18ab$var$CLONE_FLAT_FLAG = 2, $e6a2edab9dcc18ab$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e6a2edab9dcc18ab$var$omit = (0, $l2wL3.default)(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = (0, $dqScn.default)(paths, function(path) {
        path = (0, $e8stg.default)(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    (0, $iRIvT.default)(object, (0, $h11vi.default)(object), result);
    if (isDeep) result = (0, $luO7C.default)(result, $e6a2edab9dcc18ab$var$CLONE_DEEP_FLAG | $e6a2edab9dcc18ab$var$CLONE_FLAT_FLAG | $e6a2edab9dcc18ab$var$CLONE_SYMBOLS_FLAG, (0, $cig6q.default));
    var length = paths.length;
    while(length--)(0, $lkLur.default)(result, paths[length]);
    return result;
});
var $e6a2edab9dcc18ab$export$2e2bcd8739ae039 = $e6a2edab9dcc18ab$var$omit;

});
parcelRegister("lkLur", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8804dbbfdd1c134$export$2e2bcd8739ae039; });

var $e8stg = parcelRequire("e8stg");

var $cCffx = parcelRequire("cCffx");

var $apmAD = parcelRequire("apmAD");

var $cWBvA = parcelRequire("cWBvA");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $f8804dbbfdd1c134$var$baseUnset(object, path) {
    path = (0, $e8stg.default)(path, object);
    object = (0, $apmAD.default)(object, path);
    return object == null || delete object[(0, $cWBvA.default)((0, $cCffx.default)(path))];
}
var $f8804dbbfdd1c134$export$2e2bcd8739ae039 = $f8804dbbfdd1c134$var$baseUnset;

});
parcelRegister("e8stg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4a7e5cd123d9a06$export$2e2bcd8739ae039; });

var $hCd6c = parcelRequire("hCd6c");

var $QS8d4 = parcelRequire("QS8d4");

var $lXv7R = parcelRequire("lXv7R");

var $cQbRr = parcelRequire("cQbRr");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a4a7e5cd123d9a06$var$castPath(value, object) {
    if ((0, $hCd6c.default)(value)) return value;
    return (0, $QS8d4.default)(value, object) ? [
        value
    ] : (0, $lXv7R.default)((0, $cQbRr.default)(value));
}
var $a4a7e5cd123d9a06$export$2e2bcd8739ae039 = $a4a7e5cd123d9a06$var$castPath;

});
parcelRegister("QS8d4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09eed8d0913f942f$export$2e2bcd8739ae039; });

var $hCd6c = parcelRequire("hCd6c");

var $ebwzy = parcelRequire("ebwzy");
/** Used to match property names within property paths. */ var $09eed8d0913f942f$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $09eed8d0913f942f$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $09eed8d0913f942f$var$isKey(value, object) {
    if ((0, $hCd6c.default)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $ebwzy.default)(value)) return true;
    return $09eed8d0913f942f$var$reIsPlainProp.test(value) || !$09eed8d0913f942f$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $09eed8d0913f942f$export$2e2bcd8739ae039 = $09eed8d0913f942f$var$isKey;

});

parcelRegister("lXv7R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffc74092455ff6a8$export$2e2bcd8739ae039; });

var $5Z07c = parcelRequire("5Z07c");
/** Used to match property names within property paths. */ var $ffc74092455ff6a8$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $ffc74092455ff6a8$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $ffc74092455ff6a8$var$stringToPath = (0, $5Z07c.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($ffc74092455ff6a8$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($ffc74092455ff6a8$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $ffc74092455ff6a8$export$2e2bcd8739ae039 = $ffc74092455ff6a8$var$stringToPath;

});
parcelRegister("5Z07c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45b2bd22aff21b6b$export$2e2bcd8739ae039; });

var $7ysl3 = parcelRequire("7ysl3");
/** Used as the maximum memoize cache size. */ var $45b2bd22aff21b6b$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $45b2bd22aff21b6b$var$memoizeCapped(func) {
    var result = (0, $7ysl3.default)(func, function(key) {
        if (cache.size === $45b2bd22aff21b6b$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $45b2bd22aff21b6b$export$2e2bcd8739ae039 = $45b2bd22aff21b6b$var$memoizeCapped;

});
parcelRegister("7ysl3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5801b0d7b9ee6144$export$2e2bcd8739ae039; });

var $dmF51 = parcelRequire("dmF51");
/** Error message constants. */ var $5801b0d7b9ee6144$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5801b0d7b9ee6144$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5801b0d7b9ee6144$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5801b0d7b9ee6144$var$memoize.Cache || (0, $dmF51.default));
    return memoized;
}
// Expose `MapCache`.
$5801b0d7b9ee6144$var$memoize.Cache = (0, $dmF51.default);
var $5801b0d7b9ee6144$export$2e2bcd8739ae039 = $5801b0d7b9ee6144$var$memoize;

});



parcelRegister("cQbRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95938ab9910a124a$export$2e2bcd8739ae039; });

var $jjUEx = parcelRequire("jjUEx");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $95938ab9910a124a$var$toString(value) {
    return value == null ? '' : (0, $jjUEx.default)(value);
}
var $95938ab9910a124a$export$2e2bcd8739ae039 = $95938ab9910a124a$var$toString;

});
parcelRegister("jjUEx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e10bbcbefb426915$export$2e2bcd8739ae039; });

var $j22Bs = parcelRequire("j22Bs");

var $dqScn = parcelRequire("dqScn");

var $hCd6c = parcelRequire("hCd6c");

var $ebwzy = parcelRequire("ebwzy");
/** Used as references for various `Number` constants. */ var $e10bbcbefb426915$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e10bbcbefb426915$var$symbolProto = (0, $j22Bs.default) ? (0, $j22Bs.default).prototype : undefined, $e10bbcbefb426915$var$symbolToString = $e10bbcbefb426915$var$symbolProto ? $e10bbcbefb426915$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e10bbcbefb426915$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $hCd6c.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $dqScn.default)(value, $e10bbcbefb426915$var$baseToString) + '';
    if ((0, $ebwzy.default)(value)) return $e10bbcbefb426915$var$symbolToString ? $e10bbcbefb426915$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e10bbcbefb426915$var$INFINITY ? '-0' : result;
}
var $e10bbcbefb426915$export$2e2bcd8739ae039 = $e10bbcbefb426915$var$baseToString;

});



parcelRegister("cCffx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92f4dce7ae61fb53$export$2e2bcd8739ae039; });
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $92f4dce7ae61fb53$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $92f4dce7ae61fb53$export$2e2bcd8739ae039 = $92f4dce7ae61fb53$var$last;

});

parcelRegister("apmAD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $793dc310be85d28b$export$2e2bcd8739ae039; });

var $dHL9I = parcelRequire("dHL9I");

var $awSUU = parcelRequire("awSUU");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $793dc310be85d28b$var$parent(object, path) {
    return path.length < 2 ? object : (0, $dHL9I.default)(object, (0, $awSUU.default)(path, 0, -1));
}
var $793dc310be85d28b$export$2e2bcd8739ae039 = $793dc310be85d28b$var$parent;

});
parcelRegister("dHL9I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa3deab027f74c0$export$2e2bcd8739ae039; });

var $e8stg = parcelRequire("e8stg");

var $cWBvA = parcelRequire("cWBvA");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $9fa3deab027f74c0$var$baseGet(object, path) {
    path = (0, $e8stg.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $cWBvA.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $9fa3deab027f74c0$export$2e2bcd8739ae039 = $9fa3deab027f74c0$var$baseGet;

});
parcelRegister("cWBvA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96c7ff35a05ce9dd$export$2e2bcd8739ae039; });

var $ebwzy = parcelRequire("ebwzy");
/** Used as references for various `Number` constants. */ var $96c7ff35a05ce9dd$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $96c7ff35a05ce9dd$var$toKey(value) {
    if (typeof value == 'string' || (0, $ebwzy.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$96c7ff35a05ce9dd$var$INFINITY ? '-0' : result;
}
var $96c7ff35a05ce9dd$export$2e2bcd8739ae039 = $96c7ff35a05ce9dd$var$toKey;

});


parcelRegister("awSUU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aa77de78b2f59db$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $7aa77de78b2f59db$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $7aa77de78b2f59db$export$2e2bcd8739ae039 = $7aa77de78b2f59db$var$baseSlice;

});



parcelRegister("cig6q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f33a81e609417e3$export$2e2bcd8739ae039; });

var $2kaDr = parcelRequire("2kaDr");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $8f33a81e609417e3$var$customOmitClone(value) {
    return (0, $2kaDr.default)(value) ? undefined : value;
}
var $8f33a81e609417e3$export$2e2bcd8739ae039 = $8f33a81e609417e3$var$customOmitClone;

});
parcelRegister("2kaDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b15b2edcb4a2caf$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $4jcRQ = parcelRequire("4jcRQ");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $1b15b2edcb4a2caf$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $1b15b2edcb4a2caf$var$funcProto = Function.prototype, $1b15b2edcb4a2caf$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $1b15b2edcb4a2caf$var$funcToString = $1b15b2edcb4a2caf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $1b15b2edcb4a2caf$var$hasOwnProperty = $1b15b2edcb4a2caf$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $1b15b2edcb4a2caf$var$objectCtorString = $1b15b2edcb4a2caf$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $1b15b2edcb4a2caf$var$isPlainObject(value) {
    if (!(0, $bBbWb.default)(value) || (0, $65ROZ.default)(value) != $1b15b2edcb4a2caf$var$objectTag) return false;
    var proto = (0, $4jcRQ.default)(value);
    if (proto === null) return true;
    var Ctor = $1b15b2edcb4a2caf$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $1b15b2edcb4a2caf$var$funcToString.call(Ctor) == $1b15b2edcb4a2caf$var$objectCtorString;
}
var $1b15b2edcb4a2caf$export$2e2bcd8739ae039 = $1b15b2edcb4a2caf$var$isPlainObject;

});


parcelRegister("l2wL3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f51331e8bc5194e9$export$2e2bcd8739ae039; });

var $aLSva = parcelRequire("aLSva");

var $5kKPU = parcelRequire("5kKPU");

var $f7N5B = parcelRequire("f7N5B");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $f51331e8bc5194e9$var$flatRest(func) {
    return (0, $f7N5B.default)((0, $5kKPU.default)(func, undefined, (0, $aLSva.default)), func + '');
}
var $f51331e8bc5194e9$export$2e2bcd8739ae039 = $f51331e8bc5194e9$var$flatRest;

});
parcelRegister("aLSva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d78920f24579fc4$export$2e2bcd8739ae039; });

var $gSJMz = parcelRequire("gSJMz");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $7d78920f24579fc4$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $gSJMz.default)(array, 1) : [];
}
var $7d78920f24579fc4$export$2e2bcd8739ae039 = $7d78920f24579fc4$var$flatten;

});
parcelRegister("gSJMz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4a533f0050e0a20$export$2e2bcd8739ae039; });

var $31cwr = parcelRequire("31cwr");

var $2pmXS = parcelRequire("2pmXS");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $c4a533f0050e0a20$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $2pmXS.default));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $c4a533f0050e0a20$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $31cwr.default)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $c4a533f0050e0a20$export$2e2bcd8739ae039 = $c4a533f0050e0a20$var$baseFlatten;

});
parcelRegister("2pmXS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c0fbadffec82281$export$2e2bcd8739ae039; });

var $j22Bs = parcelRequire("j22Bs");

var $71cEU = parcelRequire("71cEU");

var $hCd6c = parcelRequire("hCd6c");
/** Built-in value references. */ var $1c0fbadffec82281$var$spreadableSymbol = (0, $j22Bs.default) ? (0, $j22Bs.default).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $1c0fbadffec82281$var$isFlattenable(value) {
    return (0, $hCd6c.default)(value) || (0, $71cEU.default)(value) || !!($1c0fbadffec82281$var$spreadableSymbol && value && value[$1c0fbadffec82281$var$spreadableSymbol]);
}
var $1c0fbadffec82281$export$2e2bcd8739ae039 = $1c0fbadffec82281$var$isFlattenable;

});



parcelRegister("5kKPU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e2326af456bb9de$export$2e2bcd8739ae039; });

var $8LitB = parcelRequire("8LitB");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3e2326af456bb9de$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3e2326af456bb9de$var$overRest(func, start, transform) {
    start = $3e2326af456bb9de$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3e2326af456bb9de$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $8LitB.default)(func, this, otherArgs);
    };
}
var $3e2326af456bb9de$export$2e2bcd8739ae039 = $3e2326af456bb9de$var$overRest;

});
parcelRegister("8LitB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66110b9497669769$export$2e2bcd8739ae039; });
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $66110b9497669769$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $66110b9497669769$export$2e2bcd8739ae039 = $66110b9497669769$var$apply;

});


parcelRegister("f7N5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b02d969c755fe597$export$2e2bcd8739ae039; });

var $aGlFv = parcelRequire("aGlFv");

var $iHpjm = parcelRequire("iHpjm");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b02d969c755fe597$var$setToString = (0, $iHpjm.default)((0, $aGlFv.default));
var $b02d969c755fe597$export$2e2bcd8739ae039 = $b02d969c755fe597$var$setToString;

});
parcelRegister("aGlFv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c6ea28d5b6b504f$export$2e2bcd8739ae039; });

var $782kM = parcelRequire("782kM");

var $1zBuI = parcelRequire("1zBuI");

var $jHP7K = parcelRequire("jHP7K");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $7c6ea28d5b6b504f$var$baseSetToString = !(0, $1zBuI.default) ? (0, $jHP7K.default) : function(func, string) {
    return (0, $1zBuI.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $782kM.default)(string),
        'writable': true
    });
};
var $7c6ea28d5b6b504f$export$2e2bcd8739ae039 = $7c6ea28d5b6b504f$var$baseSetToString;

});
parcelRegister("782kM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $530b174b6d9a1970$export$2e2bcd8739ae039; });
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $530b174b6d9a1970$var$constant(value) {
    return function() {
        return value;
    };
}
var $530b174b6d9a1970$export$2e2bcd8739ae039 = $530b174b6d9a1970$var$constant;

});

parcelRegister("jHP7K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e589b09a2cd7c446$export$2e2bcd8739ae039; });
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e589b09a2cd7c446$var$identity(value) {
    return value;
}
var $e589b09a2cd7c446$export$2e2bcd8739ae039 = $e589b09a2cd7c446$var$identity;

});


parcelRegister("iHpjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9cfe06e1b83d759$export$2e2bcd8739ae039; });
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d9cfe06e1b83d759$var$HOT_COUNT = 800, $d9cfe06e1b83d759$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9cfe06e1b83d759$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d9cfe06e1b83d759$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d9cfe06e1b83d759$var$nativeNow(), remaining = $d9cfe06e1b83d759$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d9cfe06e1b83d759$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $d9cfe06e1b83d759$export$2e2bcd8739ae039 = $d9cfe06e1b83d759$var$shortOut;

});




parcelRegister("jf2w9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0215ef9ba5a1b63$export$2e2bcd8739ae039; });

var $xAnpS = parcelRequire("xAnpS");

var $2Tybz = parcelRequire("2Tybz");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $e0215ef9ba5a1b63$var$find = (0, $xAnpS.default)((0, $2Tybz.default));
var $e0215ef9ba5a1b63$export$2e2bcd8739ae039 = $e0215ef9ba5a1b63$var$find;

});
parcelRegister("xAnpS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $064f4cd576f64181$export$2e2bcd8739ae039; });

var $aIIzU = parcelRequire("aIIzU");

var $7wVIe = parcelRequire("7wVIe");

var $egoNX = parcelRequire("egoNX");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $064f4cd576f64181$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!(0, $7wVIe.default)(collection)) {
            var iteratee = (0, $aIIzU.default)(predicate, 3);
            collection = (0, $egoNX.default)(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
var $064f4cd576f64181$export$2e2bcd8739ae039 = $064f4cd576f64181$var$createFind;

});
parcelRegister("aIIzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ce097c0be04894c$export$2e2bcd8739ae039; });

var $3c4XD = parcelRequire("3c4XD");

var $l3kO5 = parcelRequire("l3kO5");

var $jHP7K = parcelRequire("jHP7K");

var $hCd6c = parcelRequire("hCd6c");

var $dJjdl = parcelRequire("dJjdl");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $7ce097c0be04894c$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, $jHP7K.default;
    if (typeof value == 'object') return (0, $hCd6c.default)(value) ? (0, $l3kO5.default)(value[0], value[1]) : (0, $3c4XD.default)(value);
    return (0, $dJjdl.default)(value);
}
var $7ce097c0be04894c$export$2e2bcd8739ae039 = $7ce097c0be04894c$var$baseIteratee;

});
parcelRegister("l3kO5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f53a0494b8d4505e$export$2e2bcd8739ae039; });

var $2h5cw = parcelRequire("2h5cw");

var $iZVuD = parcelRequire("iZVuD");

var $y1ls0 = parcelRequire("y1ls0");

var $QS8d4 = parcelRequire("QS8d4");

var $f6O4e = parcelRequire("f6O4e");

var $e5OyX = parcelRequire("e5OyX");

var $cWBvA = parcelRequire("cWBvA");
/** Used to compose bitmasks for value comparisons. */ var $f53a0494b8d4505e$var$COMPARE_PARTIAL_FLAG = 1, $f53a0494b8d4505e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f53a0494b8d4505e$var$baseMatchesProperty(path, srcValue) {
    if ((0, $QS8d4.default)(path) && (0, $f6O4e.default)(srcValue)) return (0, $e5OyX.default)((0, $cWBvA.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $iZVuD.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $y1ls0.default)(object, path) : (0, $2h5cw.default)(srcValue, objValue, $f53a0494b8d4505e$var$COMPARE_PARTIAL_FLAG | $f53a0494b8d4505e$var$COMPARE_UNORDERED_FLAG);
    };
}
var $f53a0494b8d4505e$export$2e2bcd8739ae039 = $f53a0494b8d4505e$var$baseMatchesProperty;

});
parcelRegister("iZVuD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd4a8571509bd616$export$2e2bcd8739ae039; });

var $dHL9I = parcelRequire("dHL9I");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $dd4a8571509bd616$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $dHL9I.default)(object, path);
    return result === undefined ? defaultValue : result;
}
var $dd4a8571509bd616$export$2e2bcd8739ae039 = $dd4a8571509bd616$var$get;

});

parcelRegister("y1ls0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0664382cf6c8008d$export$2e2bcd8739ae039; });

var $1IZIq = parcelRequire("1IZIq");

var $hTnF1 = parcelRequire("hTnF1");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $0664382cf6c8008d$var$hasIn(object, path) {
    return object != null && (0, $hTnF1.default)(object, path, (0, $1IZIq.default));
}
var $0664382cf6c8008d$export$2e2bcd8739ae039 = $0664382cf6c8008d$var$hasIn;

});
parcelRegister("1IZIq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1419c5e9c583dfd0$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $1419c5e9c583dfd0$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $1419c5e9c583dfd0$export$2e2bcd8739ae039 = $1419c5e9c583dfd0$var$baseHasIn;

});

parcelRegister("hTnF1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d069ed3c96744e12$export$2e2bcd8739ae039; });

var $e8stg = parcelRequire("e8stg");

var $71cEU = parcelRequire("71cEU");

var $hCd6c = parcelRequire("hCd6c");

var $dAIRS = parcelRequire("dAIRS");

var $l0TQG = parcelRequire("l0TQG");

var $cWBvA = parcelRequire("cWBvA");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $d069ed3c96744e12$var$hasPath(object, path, hasFunc) {
    path = (0, $e8stg.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $cWBvA.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $l0TQG.default)(length) && (0, $dAIRS.default)(key, length) && ((0, $hCd6c.default)(object) || (0, $71cEU.default)(object));
}
var $d069ed3c96744e12$export$2e2bcd8739ae039 = $d069ed3c96744e12$var$hasPath;

});



parcelRegister("dJjdl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fee61e2b32bdad4$export$2e2bcd8739ae039; });

var $8lBkA = parcelRequire("8lBkA");

var $dX1Pa = parcelRequire("dX1Pa");

var $QS8d4 = parcelRequire("QS8d4");

var $cWBvA = parcelRequire("cWBvA");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $9fee61e2b32bdad4$var$property(path) {
    return (0, $QS8d4.default)(path) ? (0, $8lBkA.default)((0, $cWBvA.default)(path)) : (0, $dX1Pa.default)(path);
}
var $9fee61e2b32bdad4$export$2e2bcd8739ae039 = $9fee61e2b32bdad4$var$property;

});
parcelRegister("8lBkA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $613d3e142530fed3$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $613d3e142530fed3$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $613d3e142530fed3$export$2e2bcd8739ae039 = $613d3e142530fed3$var$baseProperty;

});

parcelRegister("dX1Pa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2823354629b8d9d$export$2e2bcd8739ae039; });

var $dHL9I = parcelRequire("dHL9I");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a2823354629b8d9d$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $dHL9I.default)(object, path);
    };
}
var $a2823354629b8d9d$export$2e2bcd8739ae039 = $a2823354629b8d9d$var$basePropertyDeep;

});




parcelRegister("2Tybz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21bb3c6483ac480d$export$2e2bcd8739ae039; });

var $g1I2l = parcelRequire("g1I2l");

var $aIIzU = parcelRequire("aIIzU");

var $4sQKr = parcelRequire("4sQKr");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $21bb3c6483ac480d$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $21bb3c6483ac480d$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : (0, $4sQKr.default)(fromIndex);
    if (index < 0) index = $21bb3c6483ac480d$var$nativeMax(length + index, 0);
    return (0, $g1I2l.default)(array, (0, $aIIzU.default)(predicate, 3), index);
}
var $21bb3c6483ac480d$export$2e2bcd8739ae039 = $21bb3c6483ac480d$var$findIndex;

});


parcelRegister("5LjUB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4320c9a253e329b1$export$2e2bcd8739ae039; });

var $5BZwQ = parcelRequire("5BZwQ");

var $3Q0KW = parcelRequire("3Q0KW");

var $71cEU = parcelRequire("71cEU");

var $hCd6c = parcelRequire("hCd6c");

var $7wVIe = parcelRequire("7wVIe");

var $2WNrA = parcelRequire("2WNrA");

var $aeTMJ = parcelRequire("aeTMJ");

var $kcxRF = parcelRequire("kcxRF");
/** `Object#toString` result references. */ var $4320c9a253e329b1$var$mapTag = '[object Map]', $4320c9a253e329b1$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $4320c9a253e329b1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4320c9a253e329b1$var$hasOwnProperty = $4320c9a253e329b1$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $4320c9a253e329b1$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $7wVIe.default)(value) && ((0, $hCd6c.default)(value) || typeof value == 'string' || typeof value.splice == 'function' || (0, $2WNrA.default)(value) || (0, $kcxRF.default)(value) || (0, $71cEU.default)(value))) return !value.length;
    var tag = (0, $3Q0KW.default)(value);
    if (tag == $4320c9a253e329b1$var$mapTag || tag == $4320c9a253e329b1$var$setTag) return !value.size;
    if ((0, $aeTMJ.default)(value)) return !(0, $5BZwQ.default)(value).length;
    for(var key in value){
        if ($4320c9a253e329b1$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $4320c9a253e329b1$export$2e2bcd8739ae039 = $4320c9a253e329b1$var$isEmpty;

});

parcelRegister("3xOZa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $294c00d8b18728e4$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $294c00d8b18728e4$var$isUndefined(value) {
    return value === undefined;
}
var $294c00d8b18728e4$export$2e2bcd8739ae039 = $294c00d8b18728e4$var$isUndefined;

});

parcelRegister("Kk7R3", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "autorun", function () { return autorun; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "makeAutoObservable", function () { return makeAutoObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("3Y1Wx", function(module, exports) {

$parcel$export(module.exports, "apiClient", function () { return $bcf24bc3f3c32151$export$407ca81eb46778dd; });
$parcel$export(module.exports, "ensureWretchError", function () { return $bcf24bc3f3c32151$export$aed2406fec1b8945; });

var $bEEBX = parcelRequire("bEEBX");

var $gQFa1 = parcelRequire("gQFa1");

var $e4lRF = parcelRequire("e4lRF");
var $6OUJ6 = parcelRequire("6OUJ6");
var $iFIf7 = parcelRequire("iFIf7");
const $bcf24bc3f3c32151$export$407ca81eb46778dd = (url, token, controller)=>{
    let client = (0, $gQFa1.default)(url).addon((0, $iFIf7.default)).addon((0, $6OUJ6.default)).addon((0, $e4lRF.default)()).headers({
        Accept: "application/json"
    });
    if (controller) client = client.signal(controller);
    if (!(0, $bEEBX.default)(token)) client = client.auth(`Bearer ${token}`);
    return client;
};
const $bcf24bc3f3c32151$export$aed2406fec1b8945 = (error)=>{
    if (error.response) return error;
    return null;
};

});
parcelRegister("gQFa1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4416e4ce029a43b$export$2e2bcd8739ae039; });

var $ewgNS = parcelRequire("ewgNS");

var $5Nzg0 = parcelRequire("5Nzg0");

var $3UYWC = parcelRequire("3UYWC");
/**
 * Creates a new wretch instance with a base url and base
 * [fetch options](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch).
 *
 * ```ts
 * import wretch from "wretch"
 *
 * // Reusable instance
 * const w = wretch("https://domain.com", { mode: "cors" })
 * ```
 *
 * @param _url The base url
 * @param _options The base fetch options
 * @returns A fresh wretch instance
 */ function $c4416e4ce029a43b$var$factory(_url = "", _options = {}) {
    return {
        ...(0, $5Nzg0.core),
        _url: _url,
        _options: _options
    };
}
$c4416e4ce029a43b$var$factory["default"] = $c4416e4ce029a43b$var$factory;
/** {@inheritDoc setOptions} */ $c4416e4ce029a43b$var$factory.options = (0, $ewgNS.setOptions);
/** {@inheritDoc setErrorType} */ $c4416e4ce029a43b$var$factory.errorType = (0, $ewgNS.setErrorType);
/** {@inheritDoc setPolyfills} */ $c4416e4ce029a43b$var$factory.polyfills = (0, $ewgNS.setPolyfills);
$c4416e4ce029a43b$var$factory.WretchError = (0, $3UYWC.WretchError);
var $c4416e4ce029a43b$export$2e2bcd8739ae039 = $c4416e4ce029a43b$var$factory;

});
parcelRegister("ewgNS", function(module, exports) {

$parcel$export(module.exports, "setOptions", function () { return $a92116a4f391ae8b$export$add91eafeaeab287; });
$parcel$export(module.exports, "setPolyfills", function () { return $a92116a4f391ae8b$export$e7b525096036746b; });
$parcel$export(module.exports, "setErrorType", function () { return $a92116a4f391ae8b$export$bf3df2a01e7984c3; });
$parcel$export(module.exports, "default", function () { return $a92116a4f391ae8b$export$2e2bcd8739ae039; });

var $hh8pF = parcelRequire("hh8pF");
const $a92116a4f391ae8b$var$config = {
    // Default options
    options: {},
    // Error type
    errorType: "text",
    // Polyfills
    polyfills: {
    },
    polyfill (p, doThrow = true, instance = false, ...args) {
        const res = this.polyfills[p] || (typeof self !== "undefined" ? self[p] : null) || (typeof $parcel$global !== "undefined" ? $parcel$global[p] : null);
        if (doThrow && !res) throw new Error(p + " is not defined");
        return instance && res ? new res(...args) : res;
    }
};
function $a92116a4f391ae8b$export$add91eafeaeab287(options, replace = false) {
    $a92116a4f391ae8b$var$config.options = replace ? options : (0, $hh8pF.mix)($a92116a4f391ae8b$var$config.options, options);
}
function $a92116a4f391ae8b$export$e7b525096036746b(polyfills, replace = false) {
    $a92116a4f391ae8b$var$config.polyfills = replace ? polyfills : (0, $hh8pF.mix)($a92116a4f391ae8b$var$config.polyfills, polyfills);
}
function $a92116a4f391ae8b$export$bf3df2a01e7984c3(errorType) {
    $a92116a4f391ae8b$var$config.errorType = errorType;
}
var $a92116a4f391ae8b$export$2e2bcd8739ae039 = $a92116a4f391ae8b$var$config;

});
parcelRegister("hh8pF", function(module, exports) {

$parcel$export(module.exports, "extractContentType", function () { return $c93a8cd9688f06f8$export$2b9b51eb2e7a33e6; });
$parcel$export(module.exports, "isLikelyJsonMime", function () { return $c93a8cd9688f06f8$export$986f6039e68070e3; });
$parcel$export(module.exports, "mix", function () { return $c93a8cd9688f06f8$export$2c9e8a9632a706b2; });

var $19ZDg = parcelRequire("19ZDg");
function $c93a8cd9688f06f8$export$2b9b51eb2e7a33e6(headers = {}) {
    var _a;
    return (_a = Object.entries(headers).find(([k])=>k.toLowerCase() === (0, $19ZDg.CONTENT_TYPE_HEADER).toLowerCase())) === null || _a === void 0 ? void 0 : _a[1];
}
function $c93a8cd9688f06f8$export$986f6039e68070e3(value) {
    return /^application\/.*json.*/.test(value);
}
const $c93a8cd9688f06f8$export$2c9e8a9632a706b2 = function(one, two, mergeArrays = false) {
    return Object.entries(two).reduce((acc, [key, newValue])=>{
        const value = one[key];
        if (Array.isArray(value) && Array.isArray(newValue)) acc[key] = mergeArrays ? [
            ...value,
            ...newValue
        ] : newValue;
        else if (typeof value === "object" && typeof newValue === "object") acc[key] = $c93a8cd9688f06f8$export$2c9e8a9632a706b2(value, newValue, mergeArrays);
        else acc[key] = newValue;
        return acc;
    }, {
        ...one
    });
};

});
parcelRegister("19ZDg", function(module, exports) {

$parcel$export(module.exports, "JSON_MIME", function () { return $0d86709c9274f0ab$export$a7024616b83d7949; });
$parcel$export(module.exports, "CONTENT_TYPE_HEADER", function () { return $0d86709c9274f0ab$export$39c708a4bc085737; });
$parcel$export(module.exports, "FETCH_ERROR", function () { return $0d86709c9274f0ab$export$a71624947af1f122; });
$parcel$export(module.exports, "CATCHER_FALLBACK", function () { return $0d86709c9274f0ab$export$e525b14750665244; });
const $0d86709c9274f0ab$export$a7024616b83d7949 = "application/json";
const $0d86709c9274f0ab$export$39c708a4bc085737 = "Content-Type";
const $0d86709c9274f0ab$export$a71624947af1f122 = Symbol();
const $0d86709c9274f0ab$export$e525b14750665244 = Symbol();

});



parcelRegister("5Nzg0", function(module, exports) {

$parcel$export(module.exports, "core", function () { return $438ce0b4921603a2$export$b75f8c4f8f3fbd14; });

var $hh8pF = parcelRequire("hh8pF");

var $19ZDg = parcelRequire("19ZDg");

var $3UYWC = parcelRequire("3UYWC");

var $ewgNS = parcelRequire("ewgNS");
const $438ce0b4921603a2$export$b75f8c4f8f3fbd14 = {
    _url: "",
    _options: {},
    _config: (0, $ewgNS.default),
    _catchers: new Map(),
    _resolvers: [],
    _deferred: [],
    _middlewares: [],
    _addons: [],
    addon (addon) {
        return {
            ...this,
            _addons: [
                ...this._addons,
                addon
            ],
            ...addon.wretch
        };
    },
    errorType (errorType) {
        return {
            ...this,
            _config: {
                ...this._config,
                errorType: errorType
            }
        };
    },
    polyfills (polyfills, replace = false) {
        return {
            ...this,
            _config: {
                ...this._config,
                polyfills: replace ? polyfills : (0, $hh8pF.mix)(this._config.polyfills, polyfills)
            }
        };
    },
    url (_url, replace = false) {
        if (replace) return {
            ...this,
            _url: _url
        };
        const split = this._url.split("?");
        return {
            ...this,
            _url: split.length > 1 ? split[0] + _url + "?" + split[1] : this._url + _url
        };
    },
    options (options, replace = false) {
        return {
            ...this,
            _options: replace ? options : (0, $hh8pF.mix)(this._options, options)
        };
    },
    headers (headerValues) {
        return {
            ...this,
            _options: (0, $hh8pF.mix)(this._options, {
                headers: headerValues || {}
            })
        };
    },
    accept (headerValue) {
        return this.headers({
            Accept: headerValue
        });
    },
    content (headerValue) {
        return this.headers({
            [(0, $19ZDg.CONTENT_TYPE_HEADER)]: headerValue
        });
    },
    auth (headerValue) {
        return this.headers({
            Authorization: headerValue
        });
    },
    catcher (errorId, catcher) {
        const newMap = new Map(this._catchers);
        newMap.set(errorId, catcher);
        return {
            ...this,
            _catchers: newMap
        };
    },
    catcherFallback (catcher) {
        return this.catcher((0, $19ZDg.CATCHER_FALLBACK), catcher);
    },
    resolve (resolver, clear = false) {
        return {
            ...this,
            _resolvers: clear ? [
                resolver
            ] : [
                ...this._resolvers,
                resolver
            ]
        };
    },
    defer (callback, clear = false) {
        return {
            ...this,
            _deferred: clear ? [
                callback
            ] : [
                ...this._deferred,
                callback
            ]
        };
    },
    middlewares (middlewares, clear = false) {
        return {
            ...this,
            _middlewares: clear ? middlewares : [
                ...this._middlewares,
                ...middlewares
            ]
        };
    },
    fetch (method = this._options.method, url = "", body = null) {
        let base = this.url(url).options({
            method: method
        });
        // "Jsonify" the body if it is an object and if it is likely that the content type targets json.
        const contentType = (0, $hh8pF.extractContentType)(base._options.headers);
        const jsonify = typeof body === "object" && (!base._options.headers || !contentType || (0, $hh8pF.isLikelyJsonMime)(contentType));
        base = !body ? base : jsonify ? base.json(body, contentType) : base.body(body);
        return (0, $3UYWC.resolver)(base._deferred.reduce((acc, curr)=>curr(acc, acc._url, acc._options), base));
    },
    get (url = "") {
        return this.fetch("GET", url);
    },
    delete (url = "") {
        return this.fetch("DELETE", url);
    },
    put (body, url = "") {
        return this.fetch("PUT", url, body);
    },
    post (body, url = "") {
        return this.fetch("POST", url, body);
    },
    patch (body, url = "") {
        return this.fetch("PATCH", url, body);
    },
    head (url = "") {
        return this.fetch("HEAD", url);
    },
    opts (url = "") {
        return this.fetch("OPTIONS", url);
    },
    body (contents) {
        return {
            ...this,
            _options: {
                ...this._options,
                body: contents
            }
        };
    },
    json (jsObject, contentType) {
        const currentContentType = (0, $hh8pF.extractContentType)(this._options.headers);
        return this.content(contentType || (0, $hh8pF.isLikelyJsonMime)(currentContentType) && currentContentType || (0, $19ZDg.JSON_MIME)).body(JSON.stringify(jsObject));
    }
};

});
parcelRegister("3UYWC", function(module, exports) {

$parcel$export(module.exports, "WretchError", function () { return $2da5e05d3f03f08f$export$8ced8b81234b99dd; });
$parcel$export(module.exports, "resolver", function () { return $2da5e05d3f03f08f$export$50397835cbfdbc24; });

var $eHGmM = parcelRequire("eHGmM");

var $hh8pF = parcelRequire("hh8pF");

var $19ZDg = parcelRequire("19ZDg");
class $2da5e05d3f03f08f$export$8ced8b81234b99dd extends Error {
}
const $2da5e05d3f03f08f$export$50397835cbfdbc24 = (wretch)=>{
    const sharedState = Object.create(null);
    wretch = wretch._addons.reduce((w, addon)=>addon.beforeRequest && addon.beforeRequest(w, wretch._options, sharedState) || w, wretch);
    const { _url: url, _options: opts, _config: config, _catchers: _catchers, _resolvers: resolvers, _middlewares: middlewares, _addons: addons } = wretch;
    const catchers = new Map(_catchers);
    const finalOptions = (0, $hh8pF.mix)(config.options, opts);
    // The generated fetch request
    let finalUrl = url;
    const _fetchReq = (0, $eHGmM.middlewareHelper)(middlewares)((url, options)=>{
        finalUrl = url;
        return config.polyfill("fetch")(url, options);
    })(url, finalOptions);
    // Throws on an http error
    const referenceError = new Error();
    const throwingPromise = _fetchReq.catch((error)=>{
        throw {
            [(0, $19ZDg.FETCH_ERROR)]: error
        };
    }).then((response)=>{
        if (!response.ok) {
            const err = new $2da5e05d3f03f08f$export$8ced8b81234b99dd();
            // Enhance the error object
            err["cause"] = referenceError;
            err.stack = err.stack + "\nCAUSE: " + referenceError.stack;
            err.response = response;
            err.url = finalUrl;
            if (response.type === "opaque") throw err;
            return response.text().then((body)=>{
                var _a;
                err.message = body;
                if (config.errorType === "json" || ((_a = response.headers.get("Content-Type")) === null || _a === void 0 ? void 0 : _a.split(";")[0]) === "application/json") try {
                    err.json = JSON.parse(body);
                } catch (e) {}
                err.text = body;
                err["status"] = response.status;
                throw err;
            });
        }
        return response;
    });
    // Wraps the Promise in order to dispatch the error to a matching catcher
    const catchersWrapper = (promise)=>{
        return promise.catch((err)=>{
            const fetchErrorFlag = err.hasOwnProperty((0, $19ZDg.FETCH_ERROR));
            const error = fetchErrorFlag ? err[0, $19ZDg.FETCH_ERROR] : err;
            const catcher = (error === null || error === void 0 ? void 0 : error.status) && catchers.get(error.status) || catchers.get(error === null || error === void 0 ? void 0 : error.name) || fetchErrorFlag && catchers.has((0, $19ZDg.FETCH_ERROR)) && catchers.get((0, $19ZDg.FETCH_ERROR));
            if (catcher) return catcher(error, wretch);
            const catcherFallback = catchers.get((0, $19ZDg.CATCHER_FALLBACK));
            if (catcherFallback) return catcherFallback(error, wretch);
            throw error;
        });
    };
    const bodyParser = (funName)=>(cb)=>funName ? // If a callback is provided, then callback with the body result otherwise return the parsed body itself.
            catchersWrapper(throwingPromise.then((_)=>_ && _[funName]()).then((_)=>cb ? cb(_) : _)) : // No body parsing method - return the response
            catchersWrapper(throwingPromise.then((_)=>cb ? cb(_) : _));
    const responseChain = {
        _wretchReq: wretch,
        _fetchReq: _fetchReq,
        _sharedState: sharedState,
        res: bodyParser(null),
        json: bodyParser("json"),
        blob: bodyParser("blob"),
        formData: bodyParser("formData"),
        arrayBuffer: bodyParser("arrayBuffer"),
        text: bodyParser("text"),
        error (errorId, cb) {
            catchers.set(errorId, cb);
            return this;
        },
        badRequest (cb) {
            return this.error(400, cb);
        },
        unauthorized (cb) {
            return this.error(401, cb);
        },
        forbidden (cb) {
            return this.error(403, cb);
        },
        notFound (cb) {
            return this.error(404, cb);
        },
        timeout (cb) {
            return this.error(408, cb);
        },
        internalError (cb) {
            return this.error(500, cb);
        },
        fetchError (cb) {
            return this.error((0, $19ZDg.FETCH_ERROR), cb);
        }
    };
    const enhancedResponseChain = addons.reduce((chain, addon)=>({
            ...chain,
            ...addon.resolver
        }), responseChain);
    return resolvers.reduce((chain, r)=>r(chain, wretch), enhancedResponseChain);
};

});
parcelRegister("eHGmM", function(module, exports) {

$parcel$export(module.exports, "middlewareHelper", function () { return $ab45f1f401e19f28$export$7b5ade2cfae8da4f; });
/**
 * @private @internal
 */ const $ab45f1f401e19f28$export$7b5ade2cfae8da4f = (middlewares)=>(fetchFunction)=>{
        return middlewares.reduceRight((acc, curr)=>curr(acc), fetchFunction) || fetchFunction;
    };

});




parcelRegister("e4lRF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3e26640b3168ab4$export$2e2bcd8739ae039; });
/**
 * Adds the ability to abort requests using AbortController and signals under the hood.
 *
 *
 * _Only compatible with browsers that support
 * [AbortControllers](https://developer.mozilla.org/en-US/docs/Web/API/AbortController).
 * Otherwise, you could use a (partial)
 * [polyfill](https://www.npmjs.com/package/abortcontroller-polyfill)._
 *
 * ```js
 * import AbortAddon from "wretch/addons/abort"
 *
 * const [c, w] = wretch("...")
 *   .addon(AbortAddon())
 *   .get()
 *   .onAbort((_) => console.log("Aborted !"))
 *   .controller();
 *
 * w.text((_) => console.log("should never be called"));
 * c.abort();
 *
 * // Or :
 *
 * const controller = new AbortController();
 *
 * wretch("...")
 *   .addon(AbortAddon())
 *   .signal(controller)
 *   .get()
 *   .onAbort((_) => console.log("Aborted !"))
 *   .text((_) => console.log("should never be called"));
 *
 * controller.abort();
 * ```
 */ const $a3e26640b3168ab4$var$abort = ()=>{
    return {
        beforeRequest (wretch, options, state) {
            const fetchController = wretch._config.polyfill("AbortController", false, true);
            if (!options["signal"] && fetchController) options["signal"] = fetchController.signal;
            const timeout = {
                ref: null,
                clear () {
                    if (timeout.ref) {
                        clearTimeout(timeout.ref);
                        timeout.ref = null;
                    }
                }
            };
            state.abort = {
                timeout: timeout,
                fetchController: fetchController
            };
            return wretch;
        },
        wretch: {
            signal (controller) {
                return {
                    ...this,
                    _options: {
                        ...this._options,
                        signal: controller.signal
                    }
                };
            }
        },
        resolver: {
            setTimeout (time, controller = this._sharedState.abort.fetchController) {
                const { timeout: timeout } = this._sharedState.abort;
                timeout.clear();
                timeout.ref = setTimeout(()=>controller.abort(), time);
                return this;
            },
            controller () {
                return [
                    this._sharedState.abort.fetchController,
                    this
                ];
            },
            onAbort (cb) {
                return this.error("AbortError", cb);
            }
        }
    };
};
var $a3e26640b3168ab4$export$2e2bcd8739ae039 = $a3e26640b3168ab4$var$abort;

});

parcelRegister("6OUJ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f736a4c8ecb4e06$export$2e2bcd8739ae039; });
function $4f736a4c8ecb4e06$var$convertFormData(formObject, recursive = false, config, formData = config.polyfill("FormData", true, true), ancestors = []) {
    Object.entries(formObject).forEach(([key, value])=>{
        let formKey = ancestors.reduce((acc, ancestor)=>acc ? `${acc}[${ancestor}]` : ancestor, null);
        formKey = formKey ? `${formKey}[${key}]` : key;
        if (value instanceof Array || globalThis.FileList && value instanceof FileList) for (const item of value)formData.append(formKey, item);
        else if (recursive && typeof value === "object" && (!(recursive instanceof Array) || !recursive.includes(key))) {
            if (value !== null) $4f736a4c8ecb4e06$var$convertFormData(value, recursive, config, formData, [
                ...ancestors,
                key
            ]);
        } else formData.append(formKey, value);
    });
    return formData;
}
/**
 * Adds the ability to convert a an object to a FormData and use it as a request body.
 *
 * ```js
 * import FormDataAddon from "wretch/addons/formData"
 *
 * wretch().addon(FormDataAddon)
 * ```
 */ const $4f736a4c8ecb4e06$var$formData = {
    wretch: {
        formData (formObject, recursive = false) {
            return this.body($4f736a4c8ecb4e06$var$convertFormData(formObject, recursive, this._config));
        }
    }
};
var $4f736a4c8ecb4e06$export$2e2bcd8739ae039 = $4f736a4c8ecb4e06$var$formData;

});

parcelRegister("iFIf7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d97e6004a50999e7$export$2e2bcd8739ae039; });
function $d97e6004a50999e7$var$stringify(value) {
    return typeof value !== "undefined" ? value : "";
}
const $d97e6004a50999e7$var$appendQueryParams = (url, qp, replace, config)=>{
    let queryString;
    if (typeof qp === "string") queryString = qp;
    else {
        const usp = config.polyfill("URLSearchParams", true, true);
        for(const key in qp){
            const value = qp[key];
            if (qp[key] instanceof Array) for (const val of value)usp.append(key, $d97e6004a50999e7$var$stringify(val));
            else usp.append(key, $d97e6004a50999e7$var$stringify(value));
        }
        queryString = usp.toString();
    }
    const split = url.split("?");
    if (!queryString) return replace ? split[0] : url;
    if (replace || split.length < 2) return split[0] + "?" + queryString;
    return url + "&" + queryString;
};
/**
 * Adds the ability to append query parameters from a javascript object.
 *
 * ```js
 * import QueryAddon from "wretch/addons/queryString"
 *
 * wretch().addon(QueryAddon)
 * ```
 */ const $d97e6004a50999e7$var$queryString = {
    wretch: {
        query (qp, replace = false) {
            return {
                ...this,
                _url: $d97e6004a50999e7$var$appendQueryParams(this._url, qp, replace, this._config)
            };
        }
    }
};
var $d97e6004a50999e7$export$2e2bcd8739ae039 = $d97e6004a50999e7$var$queryString;

});


parcelRegister("8ZCSm", function(module, exports) {

$parcel$export(module.exports, "API_HOST", function () { return $389a98b8ca4fdd35$export$961a507a52292452; });
$parcel$export(module.exports, "PROXY_HOST", function () { return $389a98b8ca4fdd35$export$465751bd8cdffa89; });
$parcel$export(module.exports, "STATICDATA_HOST", function () { return $389a98b8ca4fdd35$export$fd00eebc61edf700; });
$parcel$export(module.exports, "ENV_NAME", function () { return $389a98b8ca4fdd35$export$d83c88e8fa34151c; });
$parcel$export(module.exports, "APP_VERSION", function () { return $389a98b8ca4fdd35$export$8ee1df3c6367a60; });
$parcel$export(module.exports, "CONTENTFUL_SPACE", function () { return $389a98b8ca4fdd35$export$1ae0a7be60e6658c; });
$parcel$export(module.exports, "CONTENTFUL_PREVIEWTOKEN", function () { return $389a98b8ca4fdd35$export$7a51f47a514a34b6; });
$parcel$export(module.exports, "CONTENTFUL_READTOKEN", function () { return $389a98b8ca4fdd35$export$d9cdb100323e5e69; });
$parcel$export(module.exports, "CONTENTFUL_ENV", function () { return $389a98b8ca4fdd35$export$b3a67dd349cf54c5; });
$parcel$export(module.exports, "BUGSNAG_ID", function () { return $389a98b8ca4fdd35$export$f8edadbb442ab4f8; });
$parcel$export(module.exports, "BUGSNAG_STAGE", function () { return $389a98b8ca4fdd35$export$aad8b116870e17f5; });
$parcel$export(module.exports, "CONFIG_CAT_KEY", function () { return $389a98b8ca4fdd35$export$c4dff1cc936759fc; });
$parcel$export(module.exports, "SOLIDUM_POSTTOKEN", function () { return $389a98b8ca4fdd35$export$c140c7d8dba3ceaa; });
$parcel$export(module.exports, "SOLIDUM_POSTFORM", function () { return $389a98b8ca4fdd35$export$3172686867d6341f; });
$parcel$export(module.exports, "DYNAMICS_INGESTION_KEY", function () { return $389a98b8ca4fdd35$export$27b830d9528f1a60; });
const $389a98b8ca4fdd35$export$961a507a52292452 = "https://dsp-pwaproxy.tine.no";
const $389a98b8ca4fdd35$export$465751bd8cdffa89 = undefined;
const $389a98b8ca4fdd35$export$fd00eebc61edf700 = "https://dsp-pwa-data.tine.no/pwadata";
const $389a98b8ca4fdd35$export$d83c88e8fa34151c = "prod";
const $389a98b8ca4fdd35$export$8ee1df3c6367a60 = "2024.01.01-120000";
const $389a98b8ca4fdd35$export$1ae0a7be60e6658c = "y71dec381j7h";
const $389a98b8ca4fdd35$export$7a51f47a514a34b6 = "nMT44894VkrbebyCvokfrRO31HYvyB0N7_f_3psj_B8";
const $389a98b8ca4fdd35$export$d9cdb100323e5e69 = "SQdLFcHDou1XZZbvVmZxrDbkLJ8wdp666NMbgTINUgU";
const $389a98b8ca4fdd35$export$b3a67dd349cf54c5 = "master";
const $389a98b8ca4fdd35$export$bdff87d30cf73db1 = "products_prod";
const $389a98b8ca4fdd35$export$3d66ac79c6346cdb = "GTM-PLW9BMZ";
const $389a98b8ca4fdd35$export$f8edadbb442ab4f8 = "aa1b36853bdc6f1ea5cbab07371f6a2e";
const $389a98b8ca4fdd35$export$aad8b116870e17f5 = "production";
const $389a98b8ca4fdd35$export$b3a98dbc3d82d925 = "tine";
const $389a98b8ca4fdd35$export$c4dff1cc936759fc = "configcat-sdk-1/ibXXCFJaggix6yE_SB6vVQ/O59b45tAXESq_kEQVIgqnQ";
const $389a98b8ca4fdd35$export$c140c7d8dba3ceaa = "f20b377b-6012-4653-b975-9be0353495e8";
const $389a98b8ca4fdd35$export$3172686867d6341f = "e7f22de9-996f-4bd2-a631-5061f4dde0a8";
const $389a98b8ca4fdd35$export$27b830d9528f1a60 = undefined;
const $389a98b8ca4fdd35$export$dd8826725fa2a3d4 = "production";

});

parcelRegister("aMYzM", function(module, exports) {

$parcel$export(module.exports, "GenericError", function () { return $991caca5560852c0$export$7d465be8efa67280; });
$parcel$export(module.exports, "WrongCodeError", function () { return $991caca5560852c0$export$1f1581643d05e360; });
$parcel$export(module.exports, "WrongUsernameOrPasswordError", function () { return $991caca5560852c0$export$8542f75014675e67; });
$parcel$export(module.exports, "BackendIssueError", function () { return $991caca5560852c0$export$234f06651997b87d; });
$parcel$export(module.exports, "ServerNotFoundError", function () { return $991caca5560852c0$export$260eca5f17a567c2; });
$parcel$export(module.exports, "TokenExpiryError", function () { return $991caca5560852c0$export$d0cb70b39c0d2bf4; });
$parcel$export(module.exports, "AvailabilityError", function () { return $991caca5560852c0$export$9892780d0f32452e; });
$parcel$export(module.exports, "UserCancelError", function () { return $991caca5560852c0$export$b7caafdec7b09e24; });
$parcel$export(module.exports, "PageNotFoundError", function () { return $991caca5560852c0$export$af99ca4694b8d1b5; });
$parcel$export(module.exports, "ensureError", function () { return $991caca5560852c0$export$f0ff5c81573c8df0; });
$parcel$export(module.exports, "genericLoginErrorByLocale", function () { return $991caca5560852c0$export$22a5bfaaaef90c72; });
$parcel$export(module.exports, "backendIssueMessagesByLocale", function () { return $991caca5560852c0$export$874fadf5c84d069c; });
$parcel$export(module.exports, "getCredentialsErrorMessage", function () { return $991caca5560852c0$export$7f386b1df9f0ab4b; });
$parcel$export(module.exports, "networkErrorMessageByLocale", function () { return $991caca5560852c0$export$21b9e8f40c048298; });

var $bEEBX = parcelRequire("bEEBX");

var $gyNqR = parcelRequire("gyNqR");

var $isIf6 = parcelRequire("isIf6");
class $991caca5560852c0$export$7d465be8efa67280 extends Error {
    constructor(message, errorOptions){
        super(message, errorOptions);
        this.message = message;
    }
}
class $991caca5560852c0$export$1f1581643d05e360 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("WRONG CODE");
    }
}
class $991caca5560852c0$export$8542f75014675e67 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("USERNAME OR PASSWORD");
    }
}
class $991caca5560852c0$export$234f06651997b87d extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(message = "BACKEND ISSUE", errorOptions = {}){
        super(message, errorOptions);
    }
}
class $991caca5560852c0$export$260eca5f17a567c2 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("SERVER NOT FOUND");
    }
}
class $991caca5560852c0$export$6c1af69fea283694 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("MULTI ACCOUNT");
    }
}
class $991caca5560852c0$export$d0cb70b39c0d2bf4 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("TOKEN EXPIRY");
    }
}
class $991caca5560852c0$export$9a508cbbdcc083c9 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("MISSING DELIVERY DATES");
    }
}
class $991caca5560852c0$export$9892780d0f32452e extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("AVAILABILITY ERROR");
    }
}
class $991caca5560852c0$export$b7caafdec7b09e24 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("USER CANCEL");
    }
}
class $991caca5560852c0$export$af99ca4694b8d1b5 extends $991caca5560852c0$export$7d465be8efa67280 {
    constructor(){
        super("PAGE NOT FOUND");
    }
}
const $991caca5560852c0$export$f0ff5c81573c8df0 = (err)=>{
    if ((0, $bEEBX.default)(err)) return new Error("Null or undefined passed as error", {
        cause: err
    });
    if (err instanceof Error) return err;
    if ((0, $gyNqR.default)(err)) return new Error(err);
    if (typeof err === "object" && err !== null && "message" in err) return new Error(`${err.message}`, {
        cause: err
    });
    return new Error("Unknown error", {
        cause: err
    });
};
const $991caca5560852c0$export$22a5bfaaaef90c72 = {
    "nb-NO": "Det oppsto en feil med et underliggende system ved innlogging.",
    "en-US": "There was an error with one of the supporting system during login."
};
const $991caca5560852c0$export$874fadf5c84d069c = {
    "nb-NO": {
        "BACKEND ISSUE": $991caca5560852c0$export$22a5bfaaaef90c72["nb-NO"],
        "StoreId not found": $991caca5560852c0$export$22a5bfaaaef90c72["nb-NO"],
        "Missing delivery dates": "Det oppsto en feil ved henting av leveringsdager.",
        "Unable to load assortment, error from backend": "Det oppsto en feil ved henting av produktsortiment.",
        "Unable to load delivery dates / pickup": "Det oppsto en feil ved henting av leveringsdager.",
        "Unable to load favourites, error from backend": "Det oppsto en feil ved henting av favoritter.",
        "Unable to determine default customer number": "Kunne ikke finne foretrukket kundenummer.",
        "Unable to verify OneTimeCode": "Kunne ikke verifisere engangskoden.",
        "Delivery day not available": "Leveringsdagen er ikke tilgjengelig.",
        "Unable to find selected company": "Kunne ikke finne det valgte firma."
    },
    "en-US": {
        "BACKEND ISSUE": $991caca5560852c0$export$22a5bfaaaef90c72["en-US"],
        "StoreId not found": $991caca5560852c0$export$22a5bfaaaef90c72["en-US"],
        "Unable to load assortment, error from backend": "There was an error loading your product assortment.",
        "Unable to load delivery dates / pickup": "There was an error loading delivery dates.",
        "Missing delivery dates": "There was an error loading your delivery dates.",
        "Unable to load favourites, error from backend": "There was an error loading your favourites.",
        "Unable to determine default customer number": "Unable to determine default customer number.",
        "Unable to verify OneTimeCode": "Unable to verify OneTimeCode.",
        "Delivery day not available": "Delivery day not available.",
        "Unable to find selected company": "Unable to find selected company."
    }
};
const $991caca5560852c0$export$7f386b1df9f0ab4b = (username, locale)=>{
    if (locale === "en-US") {
        const userType = username.includes("@") ? "email" : "customer number";
        return `Wrong ${userType} or password`;
    }
    const userType = username.includes("@") ? "e-post" : "kundenummer";
    return `Feil ${userType} eller passord`;
};
const $991caca5560852c0$export$21b9e8f40c048298 = {
    "en-US": `Cannot locate the login server. This may be caused by a network error or technical difficulties at ${(0, $isIf6.default).storeCompanyName}.`,
    "nb-NO": `Fikk ikke kontakt med innloggingsserver. \xc5rsaken kan v\xe6re nettverksfeil eller tekniske utfordringer hos ${(0, $isIf6.default).storeCompanyName}.`
};

});
parcelRegister("isIf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eefa59c057a00d9d$export$2e2bcd8739ae039; });

var $gtsdT = parcelRequire("gtsdT");
parcelRequire("4ojub");
parcelRequire("gtdrX");
parcelRequire("4UfQE");

var $lppps = parcelRequire("lppps");
(0, $gtsdT.logger).log("ui", "Theme selected: ", "tine");
const $eefa59c057a00d9d$var$theme = (0, $lppps.default);
var $eefa59c057a00d9d$export$2e2bcd8739ae039 = $eefa59c057a00d9d$var$theme;

});
parcelRegister("gtsdT", function(module, exports) {

$parcel$export(module.exports, "logTags", function () { return $bcc5d856cfa9bae9$export$39dfc7025c38cb12; });
$parcel$export(module.exports, "logger", function () { return $bcc5d856cfa9bae9$export$af88d00dbe7f521; });

var $7c65l = parcelRequire("7c65l");

var $9n21e = parcelRequire("9n21e");
const $bcc5d856cfa9bae9$export$39dfc7025c38cb12 = [
    "account",
    "auth",
    "cart",
    "categories",
    "claims",
    "contentful",
    "delivery",
    "favorites",
    "logger",
    "login-state",
    "order",
    "products",
    "promotions",
    "recipients",
    "recommendations",
    "search",
    "scanner",
    "subscription",
    "tracking",
    "ui",
    "utils"
];
let $bcc5d856cfa9bae9$var$enabledTags = new Set((0, $9n21e.getEnabledLogTagsFromStorage)());
const $bcc5d856cfa9bae9$var$refreshTagsFromStorage = ()=>{
    $bcc5d856cfa9bae9$var$enabledTags = new Set((0, $9n21e.getEnabledLogTagsFromStorage)());
};
const $bcc5d856cfa9bae9$var$shouldLog = (tag, level)=>{
    if (level === "warn" || level === "error") return true;
    return $bcc5d856cfa9bae9$var$enabledTags.has(tag);
};
const $bcc5d856cfa9bae9$var$sendBreadcrumb = (tag, args, level)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).isStarted()) (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).leaveBreadcrumb(`[${tag}] ${$bcc5d856cfa9bae9$var$stringifyArgs(args)}`, {
        type: level,
        tag: tag
    });
};
const $bcc5d856cfa9bae9$var$stringifyArgs = (args)=>{
    try {
        return args.map((arg)=>typeof arg === "string" ? arg : JSON.stringify(arg)).join(" ");
    } catch  {
        return "Ukjente argumenter";
    }
};
const $bcc5d856cfa9bae9$var$logInternal = (level, tag, args)=>{
    if (level !== "error") $bcc5d856cfa9bae9$var$sendBreadcrumb(tag, args, level);
    if (!$bcc5d856cfa9bae9$var$shouldLog(tag, level)) return;
    const prefix = `[${tag}]`;
    // biome-ignore lint/suspicious/noConsole: This is the only place where console logging is allowed
    console[level](prefix, ...args);
};
const $bcc5d856cfa9bae9$export$af88d00dbe7f521 = {
    log: (tag, ...args)=>$bcc5d856cfa9bae9$var$logInternal("log", tag, args),
    warn: (tag, ...args)=>$bcc5d856cfa9bae9$var$logInternal("warn", tag, args),
    error: (tag, ...args)=>$bcc5d856cfa9bae9$var$logInternal("error", tag, args),
    enable: (tag)=>{
        (0, $9n21e.enableLogTagInStorage)(tag);
        $bcc5d856cfa9bae9$var$refreshTagsFromStorage();
    },
    disable: (tag)=>{
        (0, $9n21e.disableLogTagInStorage)(tag);
        $bcc5d856cfa9bae9$var$refreshTagsFromStorage();
    },
    isEnabled: (tag)=>(0, $9n21e.isLogTagEnabledInStorage)(tag),
    getEnabledTags: ()=>Array.from($bcc5d856cfa9bae9$var$enabledTags),
    enableAllTags: ()=>{
        for (const tag of $bcc5d856cfa9bae9$export$39dfc7025c38cb12)(0, $9n21e.enableLogTagInStorage)(tag);
        $bcc5d856cfa9bae9$var$refreshTagsFromStorage();
    },
    disableAllTags: ()=>{
        for (const tag of $bcc5d856cfa9bae9$export$39dfc7025c38cb12)(0, $9n21e.disableLogTagInStorage)(tag);
        $bcc5d856cfa9bae9$var$refreshTagsFromStorage();
    }
};

});
parcelRegister("9n21e", function(module, exports) {

$parcel$export(module.exports, "getEnabledLogTagsFromStorage", function () { return $7ab1abb84ad754ce$export$cb2760d301e9e504; });
$parcel$export(module.exports, "enableLogTagInStorage", function () { return $7ab1abb84ad754ce$export$28d782a483977d6b; });
$parcel$export(module.exports, "disableLogTagInStorage", function () { return $7ab1abb84ad754ce$export$d5d88444d9b01535; });
$parcel$export(module.exports, "isLogTagEnabledInStorage", function () { return $7ab1abb84ad754ce$export$bd04db640a189492; });
$parcel$export(module.exports, "getConfigCatLogLevelFromStorage", function () { return $7ab1abb84ad754ce$export$4b5c1c1b135df086; });
$parcel$export(module.exports, "setConfigCatLogLevelInStorage", function () { return $7ab1abb84ad754ce$export$43ec0e782615c4d7; });

var $kPpIG = parcelRequire("kPpIG");
const $7ab1abb84ad754ce$export$cb2760d301e9e504 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).LOGGING_TAGS, [], "keepBetweenSessions");
const $7ab1abb84ad754ce$export$1a4d85992bd9d802 = (tags)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).LOGGING_TAGS, tags, "keepBetweenSessions");
const $7ab1abb84ad754ce$export$28d782a483977d6b = (tag)=>{
    const current = new Set($7ab1abb84ad754ce$export$cb2760d301e9e504());
    current.add(tag);
    $7ab1abb84ad754ce$export$1a4d85992bd9d802([
        ...current
    ]);
};
const $7ab1abb84ad754ce$export$d5d88444d9b01535 = (tag)=>{
    const current = new Set($7ab1abb84ad754ce$export$cb2760d301e9e504());
    current.delete(tag);
    $7ab1abb84ad754ce$export$1a4d85992bd9d802([
        ...current
    ]);
};
const $7ab1abb84ad754ce$export$bd04db640a189492 = (tag)=>{
    const current = $7ab1abb84ad754ce$export$cb2760d301e9e504();
    return current.includes(tag);
};
const $7ab1abb84ad754ce$export$4b5c1c1b135df086 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).CONFIG_CAT_LOG_LEVEL, "-1", "keepBetweenSessions");
const $7ab1abb84ad754ce$export$43ec0e782615c4d7 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).CONFIG_CAT_LOG_LEVEL, newValue, "keepBetweenSessions");

});
parcelRegister("kPpIG", function(module, exports) {

$parcel$export(module.exports, "STORAGEKEY", function () { return $21860f93080df75e$export$28f4070306e5fd05; });
$parcel$export(module.exports, "getStorage", function () { return $21860f93080df75e$export$fbd9b57a66480737; });
$parcel$export(module.exports, "setStorage", function () { return $21860f93080df75e$export$825479ec1107c193; });

var $bEEBX = parcelRequire("bEEBX");
var $21860f93080df75e$export$28f4070306e5fd05 = /*#__PURE__*/ function(STORAGEKEY) {
    STORAGEKEY["EDIT_MODE"] = "editMode";
    STORAGEKEY["ASSORTMENT"] = "assortment";
    STORAGEKEY["SESSION"] = "session";
    STORAGEKEY["CAMPAIGN_SIGNUP"] = "campaignSignup";
    STORAGEKEY["USER_NAME"] = "storeUsername";
    STORAGEKEY["BARCODE_FOCUS_DIST"] = "barcodeFocusDist";
    STORAGEKEY["BARCODE_DEVICE_ID"] = "barcodeDeviceId";
    STORAGEKEY["PHONE_NUMBER"] = "rememberPhoneNumber";
    STORAGEKEY["ORDER_TYPE"] = "orderType";
    STORAGEKEY["DATA_VERSION"] = "dataVersion";
    STORAGEKEY["HAS_REFRESHED"] = "hasRefreshed";
    STORAGEKEY["LANGUAGE"] = "language";
    STORAGEKEY["COMPANY"] = "company";
    STORAGEKEY["LAST_COMPANY"] = "lastCompany";
    STORAGEKEY["CART_ID"] = "cartId";
    STORAGEKEY["VIEWED_PROMOTION_ARTICLES_KEY"] = "promotionArticles";
    STORAGEKEY["NAVIGATION_TEST_VARIANT"] = "navigationtestvariant";
    STORAGEKEY["LOGGING_TAGS"] = "loggingTags";
    STORAGEKEY["CONFIG_CAT_LOG_LEVEL"] = "configCatLogLevel";
    return STORAGEKEY;
}({});
const $21860f93080df75e$export$fbd9b57a66480737 = (key, defaultValue, storageType)=>{
    if (typeof window === "undefined") return defaultValue;
    const storage = storageType === "keepBetweenSessions" ? window.localStorage : window.sessionStorage;
    const item = storage.getItem(key);
    if ((0, $bEEBX.default)(item)) return defaultValue;
    try {
        return JSON.parse(item);
    } catch  {
        return defaultValue;
    }
};
const $21860f93080df75e$export$825479ec1107c193 = (key, newValue, storageType)=>{
    const storage = storageType === "keepBetweenSessions" ? window.localStorage : window.sessionStorage;
    (0, $bEEBX.default)(newValue) ? storage.removeItem(key) : storage.setItem(key, JSON.stringify(newValue));
};

});



parcelRegister("4ojub", function(module, exports) {
// @ts-ignore


var $8ZCSm = parcelRequire("8ZCSm");

var $Z5T7p = parcelRequire("Z5T7p");

var $8aSS4 = parcelRequire("8aSS4");
const $ab088c7cbcd8a8f7$var$ALGOLIA_APPID = "KJ28FN3CEH";
const $ab088c7cbcd8a8f7$var$ALGOLIA_SEARCHKEY = "5e181b299b6ea57f88b628c867a2f1b9";
const $ab088c7cbcd8a8f7$var$algoliaEnvironment = (0, $8ZCSm.ENV_NAME) === "prod" ? "prod" : "preprod";
const $ab088c7cbcd8a8f7$var$logoUrl = (0, {}).src || (0, {});
const $ab088c7cbcd8a8f7$var$enhanceDiplomisProducts = (product)=>{
    const parentCategoryCode = product.parentCategory?.externalReference;
    const categoryCode = product.category?.externalReference;
    const productEnhancement = {};
    if (parentCategoryCode === "036") productEnhancement.customerType = "Dagligvare";
    else productEnhancement.customerType = "Isbar";
    if (categoryCode === "0351") productEnhancement.accessoryType = "Saus";
    else if (categoryCode === "0352") productEnhancement.accessoryType = "Str\xf8ssel";
    else if (categoryCode === "0354") productEnhancement.accessoryType = "Kjeks";
    else if ([
        "F61",
        "099"
    ].includes(parentCategoryCode || "")) productEnhancement.accessoryType = "Softisdeler";
    else if ([
        "035",
        "036"
    ].includes(parentCategoryCode || "")) productEnhancement.accessoryType = "Annet tilbeh\xf8r";
    return {
        ...product,
        ...productEnhancement
    };
};
const $ab088c7cbcd8a8f7$var$diplomisSiteConfig = {
    storeId: "diplomis",
    storeCompanyName: "Diplom-Is",
    siteName: "Diplom-Is Handel",
    orderSupportEmail: "varebestilling@diplom-is.no",
    m3CompanyNumber: "500",
    m3DivisionNumber: "100",
    defaultOrderType: (0, $8aSS4.ORDERTYPE).WEB,
    storeLogo: {
        searchbar: {
            url: $ab088c7cbcd8a8f7$var$logoUrl,
            width: 55
        },
        searchbarMobile: {
            url: $ab088c7cbcd8a8f7$var$logoUrl,
            width: 40
        },
        footer: {
            url: $ab088c7cbcd8a8f7$var$logoUrl,
            width: 70,
            mobileWidth: 72
        }
    },
    productDropdownEnabled: false,
    showComparisonPrice: false,
    faqSlug: "",
    baseUrl: "https://www.diplomishandel.no",
    filterAttributes: (variant)=>variant === "tilbehor" ? {
            customerType: "Type",
            accessoryType: "Kategori"
        } : {
            brand: "Merkevare"
        },
    tipApiPrefix: "di-",
    papirflyApsCustomerId: "12843",
    papirflyApsImagePrefix: "",
    enhanceProduct: $ab088c7cbcd8a8f7$var$enhanceDiplomisProducts,
    fetchCustomerFeatures: ()=>{
        return Promise.resolve([
            {
                name: (0, $Z5T7p.FEATURE_NAME).subscriptionOrderAvailable,
                description: "Makes subscriptions available"
            },
            {
                name: (0, $Z5T7p.FEATURE_NAME).invoicePaymentAvailable,
                description: "Makes invoice overview available"
            },
            {
                name: (0, $Z5T7p.FEATURE_NAME).createOrderAvailable,
                description: "Allows customer to place orders"
            }
        ]);
    },
    invoiceTooltipText: (_invoice)=>"",
    deliveryFee: {
        enabled: true
    },
    productAvailability: {
        enabled: true
    },
    newCustomerForm: "https://kundeskjema.diplom-is.no/",
    deliveryNotes: {
        visible: false
    },
    contentImages: {
        cloudinaryMapping: "diplomis_images"
    },
    searchConfig: {
        algoliaConfig: {
            appId: $ab088c7cbcd8a8f7$var$ALGOLIA_APPID,
            searchApiKey: $ab088c7cbcd8a8f7$var$ALGOLIA_SEARCHKEY
        },
        searchDomains: [
            {
                type: "product",
                name: "produkter",
                displayName: (locale)=>locale === "en-US" ? "Products" : "Produkter",
                homePath: (_locale)=>"/produkter.html",
                indexName: `products_${$ab088c7cbcd8a8f7$var$algoliaEnvironment}`,
                linkText: (_locale)=>"Se alle produkter"
            },
            {
                type: "v2_article",
                name: "artikler",
                displayName: (locale)=>locale === "en-US" ? "Articles" : "Artikler",
                homePath: (_locale)=>"/artikler",
                indexName: `contentful_${(0, $8ZCSm.CONTENTFUL_ENV)}`,
                linkText: (_locale)=>"Se alle artikler"
            }
        ]
    },
    contactForm: {
        apiPath: "/api/di-contactform",
        reasons: [
            {
                value: "claims",
                label: "Reklamasjon",
                label_en: "Claims"
            },
            {
                value: "invoice",
                label: "Fakturasp\xf8rsm\xe5l / endring av fakturaadresse",
                label_en: "Invoice address changes"
            },
            {
                value: "delivery",
                label: "\xd8nske om levering f\xf8r oppsatt leveringsdag",
                label_en: "Questions about ordering"
            },
            {
                value: "product_question",
                label: "Sp\xf8rsm\xe5l om v\xe5re produkter eller sortiment",
                label_en: "Question about products"
            },
            {
                value: "other",
                label: "Annet",
                label_en: "Other"
            }
        ]
    },
    whileYouWaitMessage: "Ta frem en Royal Trippel fra fryseren, len deg tilbake og nyt et par sekunders velfortjent pause!",
    notifications: {
        categories: [
            {
                id: "ORDER_CONFIRMATION",
                name: "Ordrebekreftelse"
            },
            {
                id: "DELIVERY_CONFIRMATION",
                name: "Leveringsbekreftelse"
            },
            {
                id: "ORDER_DEADLINE",
                name: "P\xe5minnelse om ordrefrist"
            }
        ],
        enableDeliveryMessages: false
    },
    orderConfirmation: {
        headerSubTitle: "Du vil motta en bestillingsbekreftelse p\xe5 e-post om kort tid."
    },
    cart: {
        customerReferenceLabel: "Melding til sj\xe5f\xf8r"
    },
    promotionsPage: {
        enabled: false
    }
};
var $ab088c7cbcd8a8f7$export$2e2bcd8739ae039 = $ab088c7cbcd8a8f7$var$diplomisSiteConfig;

});
parcelRegister("Z5T7p", function(module, exports) {

$parcel$export(module.exports, "FEATURE_NAME", function () { return $d882dca9e91430ad$export$7e598866fa8de8d0; });
var $d882dca9e91430ad$export$7e598866fa8de8d0 = /*#__PURE__*/ function(FEATURE_NAME) {
    FEATURE_NAME["subscriptionOrderAvailable"] = "subscriptionOrderAvailable";
    FEATURE_NAME["invoicePaymentAvailable"] = "invoicePaymentAvailable";
    FEATURE_NAME["createOrderAvailable"] = "createOrderAvailable";
    FEATURE_NAME["pickupOrderAvailable"] = "pickupOrderAvailable";
    FEATURE_NAME["canBuySingleItems"] = "canBuySingleItems";
    return FEATURE_NAME;
}({});

});

parcelRegister("8aSS4", function(module, exports) {

$parcel$export(module.exports, "ORDER_UNIT", function () { return $e53a239db024c006$export$c648f659bff35165; });
$parcel$export(module.exports, "ORDERTYPE", function () { return $e53a239db024c006$export$feec46979a28aede; });
var $e53a239db024c006$export$c648f659bff35165 = /*#__PURE__*/ function(ORDER_UNIT) {
    ORDER_UNIT["D"] = "D";
    ORDER_UNIT["STK"] = "STK";
    ORDER_UNIT["L"] = "L";
    ORDER_UNIT["K"] = "K";
    ORDER_UNIT["P"] = "P";
    ORDER_UNIT["CS"] = "CS";
    ORDER_UNIT["KG"] = "KG";
    ORDER_UNIT["DFP"] = "DFP";
    ORDER_UNIT["TNK"] = "TNK";
    return ORDER_UNIT;
}({});
var $e53a239db024c006$export$feec46979a28aede = /*#__PURE__*/ function(ORDERTYPE) {
    ORDERTYPE["WEB"] = "WEB";
    ORDERTYPE["LEV"] = "LEV";
    ORDERTYPE["WAS"] = "WAS";
    ORDERTYPE["STD"] = "STD";
    ORDERTYPE["EXP"] = "EXP";
    ORDERTYPE["EXL"] = "EXL";
    ORDERTYPE["HPN"] = "HPN";
    ORDERTYPE["KOE"] = "KOE";
    ORDERTYPE["RLG"] = "RLG";
    ORDERTYPE["TUP"] = "TUP";
    ORDERTYPE["XML"] = "XML";
    ORDERTYPE["ETT"] = "ETT";
    return ORDERTYPE;
}({});

});


parcelRegister("gtdrX", function(module, exports) {

var $ioVMT = parcelRequire("ioVMT");

var $hCd6c = parcelRequire("hCd6c");

var $8ZCSm = parcelRequire("8ZCSm");

var $Z5T7p = parcelRequire("Z5T7p");

var $8aSS4 = parcelRequire("8aSS4");

var $2z91A = parcelRequire("2z91A");
const $e72fc5680e7c4fd1$var$ALGOLIA_APPID = "CV5266SV9V";
const $e72fc5680e7c4fd1$var$ALGOLIA_SEARCHKEY = "6e0ed776d4e102db935498659894446c";
const $e72fc5680e7c4fd1$var$algoliaEnvironment = "prod";

const $e72fc5680e7c4fd1$var$desktopLogoUrl = new URL((parcelRequire("j2D6A")));

const $e72fc5680e7c4fd1$var$mobileLogoUrl = new URL((parcelRequire("6cMtK")));
const $e72fc5680e7c4fd1$var$enhanceIsdalenProduct = (product)=>{
    // Additional mappings based on product name or external category reference
    if (product.size === "-") product.size = undefined;
    if (product.category?.externalReference === "I0041" || product.category?.externalReference === "I0061") product.type = "Tilbeh\xf8r";
    if (product.category?.externalReference === "I0140") product.type = "Frukt";
    if (product.size === null && (0, $ioVMT.default)(product.name, "5L")) product.size = "5 liter";
    if (product.type === null && (0, $ioVMT.default)(product.name, "Eskimo") || (0, $ioVMT.default)(product.name, "Shake")) product.type = "Iskrem";
    // Product data is published with a period as decimal, this in not correct in Norwegian.
    if ((0, $hCd6c.default)(product.nutritions)) {
        if (!(0, $2z91A.isProductNutrition)(product.nutritions)) for (const nutrition of product.nutritions)nutrition.value = nutrition.value.replace(/\./g, ",");
    }
    return product;
};
const $e72fc5680e7c4fd1$var$isdalenSiteConfig = {
    storeId: "isdalen",
    storeCompanyName: "Isdalen",
    orderSupportEmail: "post@isdalen.no",
    baseUrl: "",
    siteName: "Isdalen Handel",
    m3CompanyNumber: "500",
    m3DivisionNumber: "500",
    productDropdownEnabled: false,
    showComparisonPrice: false,
    defaultOrderType: (0, $8aSS4.ORDERTYPE).WEB,
    storeLogo: {
        searchbar: {
            url: $e72fc5680e7c4fd1$var$desktopLogoUrl.toString(),
            width: 150
        },
        searchbarMobile: {
            url: $e72fc5680e7c4fd1$var$mobileLogoUrl.toString(),
            width: 80
        },
        footer: {
            url: $e72fc5680e7c4fd1$var$mobileLogoUrl.toString(),
            width: 140,
            mobileWidth: 90
        }
    },
    faqSlug: "/kundeservice/ofte-stilte-sporsmal",
    filterAttributes: ()=>({
            type: "Type",
            size: "St\xf8rrelse"
        }),
    papirflyApsCustomerId: "12590",
    papirflyApsImagePrefix: "isd-",
    enhanceProduct: $e72fc5680e7c4fd1$var$enhanceIsdalenProduct,
    tipApiPrefix: "is-",
    fetchCustomerFeatures: async ()=>{
        return Promise.resolve([
            {
                name: (0, $Z5T7p.FEATURE_NAME).subscriptionOrderAvailable,
                description: "Makes subscriptions available"
            },
            {
                name: (0, $Z5T7p.FEATURE_NAME).invoicePaymentAvailable,
                description: "Makes invoice overview available"
            },
            {
                name: (0, $Z5T7p.FEATURE_NAME).createOrderAvailable,
                description: "Allows customer to place orders"
            }
        ]);
    },
    invoiceTooltipText: (_invoice)=>"",
    deliveryFee: {
        enabled: false
    },
    productAvailability: {
        enabled: true
    },
    newCustomerForm: "https://forms.office.com/e/SyiwHskSJT",
    deliveryNotes: {
        visible: true
    },
    searchConfig: {
        algoliaConfig: {
            appId: $e72fc5680e7c4fd1$var$ALGOLIA_APPID,
            searchApiKey: $e72fc5680e7c4fd1$var$ALGOLIA_SEARCHKEY
        },
        searchDomains: [
            {
                type: "product",
                name: "produkter",
                displayName: (locale)=>locale === "en-US" ? "Products" : "Produkter",
                homePath: (_locale)=>"/produkter.html",
                indexName: `products_${$e72fc5680e7c4fd1$var$algoliaEnvironment}`,
                linkText: (_locale)=>"Se alle produkter"
            },
            {
                type: "v2_article",
                name: "inspirasjon",
                displayName: (_locale)=>"Nyheter",
                homePath: ()=>"/nyheter",
                indexName: `contentful_${(0, $8ZCSm.CONTENTFUL_ENV)}`,
                linkText: ()=>"Se alle nyheter"
            }
        ]
    },
    contentImages: {
        cloudinaryMapping: "isdalen_images"
    },
    contactForm: {
        apiPath: "/api/is-contactform",
        reasons: [
            {
                value: "delivery",
                label: "Sp\xf8rsm\xe5l ang\xe5ende levering",
                label_en: "Questions about ordering"
            },
            {
                value: "invoice",
                label: "Endring av fakturaadresse",
                label_en: "Invoice address changes"
            },
            {
                value: "invoice_credit",
                label: "Sp\xf8rsm\xe5l ang\xe5ende faktura",
                label_en: "Invoice inquiries"
            },
            {
                value: "other",
                label: "Annet",
                label_en: "Other"
            },
            {
                value: "product_order",
                label: "Sp\xf8rsm\xe5l ang\xe5ende bestillling",
                label_en: "Questions about ordering"
            },
            {
                value: "product_question",
                label: "Sp\xf8rsm\xe5l ang\xe5ende produkter",
                label_en: "Question about products"
            },
            {
                value: "refrigeration_equipment",
                label: "Sp\xf8rsm\xe5l ang\xe5ende kj\xf8lem\xf8bler",
                label_en: "Questions about refrigeration equipment"
            }
        ]
    },
    whileYouWaitMessage: "Lag deg en cola-slush og nyt et par sekunders velfortjent pause!",
    notifications: {
        categories: [
            {
                id: "ORDER_CONFIRMATION",
                name: "Ordrebekreftelse"
            },
            {
                id: "DELIVERY_CONFIRMATION",
                name: "Leveringsbekreftelse"
            },
            {
                id: "IMPORTANT_INFO_ABOUT_DELIVERY",
                name: "Viktig melding om levering"
            }
        ],
        enableDeliveryMessages: false
    },
    orderConfirmation: {
        headerSubTitle: "Du vil motta en bestillingsbekreftelse p\xe5 e-post om kort tid."
    },
    cart: {
        customerReferenceLabel: "Din betalingsreferanse"
    },
    promotionsPage: {
        enabled: false
    }
};
var $e72fc5680e7c4fd1$export$2e2bcd8739ae039 = $e72fc5680e7c4fd1$var$isdalenSiteConfig;

});
parcelRegister("2z91A", function(module, exports) {

$parcel$export(module.exports, "isProductNutrition", function () { return $6e50e33c8f9ac857$export$6d49d87822f77830; });
const $6e50e33c8f9ac857$export$6d49d87822f77830 = (nutrition)=>{
    return nutrition.length > 0 && "productName" in nutrition[0];
};

});

parcelRegister("j2D6A", function(module, exports) {
module.exports = $parcel$resolve("62Hhy");

});

parcelRegister("6cMtK", function(module, exports) {
module.exports = $parcel$resolve("MCPlP");

});


parcelRegister("4UfQE", function(module, exports) {

var $Z5T7p = parcelRequire("Z5T7p");

var $8aSS4 = parcelRequire("8aSS4");
const $ecf8a248f61b47f4$var$CONTENTFUL_ENV = "master" ?? "";
const $ecf8a248f61b47f4$var$ALGOLIA_APPID = "D4VU44A4OA";
const $ecf8a248f61b47f4$var$ALGOLIA_SEARCHKEY = "4d6a5d2430cde6d18ba421ceb9bf6d27";
const $ecf8a248f61b47f4$var$algoliaEnvironment = "prod";

const $ecf8a248f61b47f4$var$logoUrl = new URL((parcelRequire("auW1N")));
/**
 * Parses the response bodies into suitable data structure for use in stores. Diplomis does not up pickup alternatives
 */ const $ecf8a248f61b47f4$var$leverantSiteConfig = {
    storeId: "leverant",
    storeCompanyName: "Leverant",
    siteName: "Leverant Handel",
    orderSupportEmail: "kontakt@leverant.no",
    m3CompanyNumber: "100",
    m3DivisionNumber: "102",
    defaultOrderType: (0, $8aSS4.ORDERTYPE).LEV,
    storeLogo: {
        searchbar: {
            url: `${$ecf8a248f61b47f4$var$logoUrl}`,
            width: 72
        },
        searchbarMobile: null,
        footer: null
    },
    productDropdownEnabled: false,
    showComparisonPrice: false,
    faqSlug: "",
    filterAttributes: ()=>({
            brand: "Type"
        }),
    tipApiPrefix: "lev-",
    papirflyApsCustomerId: "12590",
    papirflyApsImagePrefix: "",
    baseUrl: "",
    enhanceProduct: (product)=>{
        return product;
    },
    fetchCustomerFeatures: ()=>{
        return Promise.resolve([
            {
                name: (0, $Z5T7p.FEATURE_NAME).invoicePaymentAvailable,
                description: "Makes invoice overview available"
            },
            {
                name: (0, $Z5T7p.FEATURE_NAME).createOrderAvailable,
                description: "Allows customer to place orders"
            },
            {
                name: (0, $Z5T7p.FEATURE_NAME).subscriptionOrderAvailable,
                description: "Allows customer to place subscription orders"
            }
        ]);
    },
    invoiceTooltipText: ()=>"",
    deliveryFee: {
        enabled: false
    },
    productAvailability: {
        enabled: false
    },
    newCustomerForm: "mailto:kontakt@leverant.no",
    deliveryNotes: {
        visible: false
    },
    contentImages: {
        cloudinaryMapping: "leverant_images"
    },
    searchConfig: {
        algoliaConfig: {
            appId: $ecf8a248f61b47f4$var$ALGOLIA_APPID,
            searchApiKey: $ecf8a248f61b47f4$var$ALGOLIA_SEARCHKEY
        },
        searchDomains: [
            {
                type: "product",
                name: "produkter",
                displayName: (locale)=>locale === "en-US" ? "Products" : "Produkter",
                homePath: (_locale)=>"/produkter.html",
                indexName: `products_${$ecf8a248f61b47f4$var$algoliaEnvironment}`,
                linkText: (_locale)=>"Se alle produkter"
            },
            {
                type: "v2_article",
                name: "artikler",
                displayName: (locale)=>locale === "en-US" ? "Articles" : "Artikler",
                homePath: (_locale)=>"/artikler",
                indexName: `contentful_${$ecf8a248f61b47f4$var$CONTENTFUL_ENV}`,
                linkText: (_locale)=>"Se alle artikler"
            }
        ]
    },
    contactForm: {
        apiPath: "/api/lev-contactform",
        reasons: [
            {
                value: "claims",
                label: "Reklamasjon",
                label_en: "Claims"
            },
            {
                value: "invoice",
                label: "Fakturasp\xf8rsm\xe5l / endring av fakturaadresse",
                label_en: "Invoice address changes"
            },
            {
                value: "delivery",
                label: "\xd8nske om levering f\xf8r oppsatt leveringsdag",
                label_en: "Questions about ordering"
            },
            {
                value: "product_question",
                label: "Sp\xf8rsm\xe5l om v\xe5re produkter eller sortiment",
                label_en: "Question about products"
            },
            {
                value: "new_customer",
                label: "Ny kunde?",
                label_en: "New customer?"
            },
            {
                value: "other",
                label: "Annet",
                label_en: "Other"
            }
        ]
    },
    whileYouWaitMessage: "Ta frem kaffekoppen, len deg tilbake og nyt soloppgangen!",
    notifications: {
        categories: [
            {
                id: "IMPORTANT_INFO_ABOUT_DELIVERY",
                name: "Viktige meldinger om levering"
            },
            {
                id: "ORDER_CONFIRMATION",
                name: "Ordrebekreftelse"
            }
        ],
        enableDeliveryMessages: false
    },
    orderConfirmation: {
        headerSubTitle: ""
    },
    cart: {
        customerReferenceLabel: "Din betalingsreferanse"
    },
    promotionsPage: {
        enabled: false
    }
};
var $ecf8a248f61b47f4$export$2e2bcd8739ae039 = $ecf8a248f61b47f4$var$leverantSiteConfig;

});
parcelRegister("auW1N", function(module, exports) {
module.exports = $parcel$resolve("e063Z");

});


parcelRegister("lppps", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $684c21356acb56e1$export$2e2bcd8739ae039; });

var $3Y1Wx = parcelRequire("3Y1Wx");

var $bYgbs = parcelRequire("bYgbs");

var $8aSS4 = parcelRequire("8aSS4");

const $684c21356acb56e1$var$footerCowUrl = new URL((parcelRequire("nTNy4")));

const $684c21356acb56e1$var$footerGrassUrl = new URL((parcelRequire("e2klx")));

const $684c21356acb56e1$var$desktopLogoUrl = new URL((parcelRequire("4YU74")));

const $684c21356acb56e1$var$mobileLogoUrl = new URL((parcelRequire("5MfSg")));
const $684c21356acb56e1$var$CONTENTFUL_ENV = "master" ?? "";
const $684c21356acb56e1$var$ALGOLIA_APPID = "4RRKWA9QAI";
const $684c21356acb56e1$var$ALGOLIA_SEARCHKEY = "b13d7842783d41922109815b23b958a3";
const $684c21356acb56e1$var$algoliaEnvironment = "prod";
const $684c21356acb56e1$var$tineSiteConfig = {
    storeId: "tinehandel",
    storeCompanyName: "TINE",
    orderSupportEmail: "kundeservice@tine.no",
    siteName: "TINE Handel",
    m3CompanyNumber: "100",
    m3DivisionNumber: "102",
    defaultOrderType: (0, $8aSS4.ORDERTYPE).WEB,
    footerDecorationImageUrl1: $684c21356acb56e1$var$footerGrassUrl.toString(),
    footerDecorationImageUrl2: $684c21356acb56e1$var$footerCowUrl.toString(),
    productDropdownEnabled: true,
    showComparisonPrice: true,
    storeLogo: {
        searchbar: {
            url: $684c21356acb56e1$var$desktopLogoUrl.toString(),
            width: 50
        },
        searchbarMobile: {
            url: $684c21356acb56e1$var$mobileLogoUrl.toString(),
            width: 40
        },
        footer: {
            url: $684c21356acb56e1$var$mobileLogoUrl.toString(),
            width: 72,
            mobileWidth: 50
        }
    },
    faqSlug: "/kundeservice/ofte-stilte-sporsmal",
    baseUrl: "https://www.tinehandel.no",
    filterAttributes: (variant)=>{
        const isLiquid = /melk/i.test(variant) || /flote/i.test(variant) || /juice/i.test(variant) || /iste/i.test(variant) || /mineral/i.test(variant);
        const isSolid = /ost/i.test(variant) || /yoghurt/i.test(variant) || /smor/i.test(variant) || /romme/i.test(variant) || /cottage/i.test(variant) || /grot/i.test(variant) || /ferdig/i.test(variant) || /creme/i.test(variant);
        const measurementDependentFilters = isLiquid ? {
            volumeRange: "Volum"
        } : isSolid ? {
            weightRange: "Vekt"
        } : {
            sizeRange: "St\xf8rrelse"
        };
        return {
            tastes: "Smak",
            tasteGroups: "Smak",
            allergyInfo: "Fri for",
            certifications: "Sertifisering",
            ...measurementDependentFilters
        };
    },
    papirflyApsCustomerId: "12590",
    papirflyApsImagePrefix: "",
    enhanceProduct: (product)=>product,
    tipApiPrefix: "",
    fetchCustomerFeatures: async (customerNumber, sessionToken)=>{
        const url = `${(0, $bYgbs.getBaseUrl)("features")}/api/features/${customerNumber}.json`;
        return await (0, $3Y1Wx.apiClient)(url, sessionToken).get().json();
    },
    invoiceTooltipText: (invoice)=>`Intrum saksnr. er:${invoice.debtCollectionCaseNumber}. Kontaktes p\xe5 Inkasso telefonnr.:+4723211000`,
    deliveryFee: {
        enabled: true
    },
    productAvailability: {
        enabled: true
    },
    newCustomerForm: "https://kundeskjema.tine.no/",
    deliveryNotes: {
        visible: true
    },
    searchConfig: {
        algoliaConfig: {
            appId: $684c21356acb56e1$var$ALGOLIA_APPID,
            searchApiKey: $684c21356acb56e1$var$ALGOLIA_SEARCHKEY
        },
        categorySearchIndexName: `products_${$684c21356acb56e1$var$algoliaEnvironment}_customer_groups`,
        searchDomains: [
            {
                type: "product",
                name: "produkter",
                displayName: (locale)=>locale === "en-US" ? "Products" : "Produkter",
                homePath: (_locale)=>"/produkter.html",
                indexName: `products_${$684c21356acb56e1$var$algoliaEnvironment}_customer_groups`,
                linkText: (_locale)=>"Se alle produkter"
            },
            {
                type: "v2_article",
                name: "inspirasjon",
                displayName: (locale)=>locale === "en-US" ? "Inspiration" : "Matfaglig inspirasjon",
                homePath: ()=>"/matfaglig",
                indexName: `contentful_${$684c21356acb56e1$var$CONTENTFUL_ENV}`,
                linkText: ()=>"Se all matfaglig inspirasjon"
            },
            {
                type: "recipe",
                name: "oppskrifter",
                displayName: (locale)=>locale === "en-US" ? "Recipes" : "Oppskrifter",
                homePath: (_locale)=>"/oppskrifter",
                indexName: `contentful_${$684c21356acb56e1$var$CONTENTFUL_ENV}`,
                linkText: ()=>"Se alle oppskrifter"
            }
        ]
    },
    contentImages: {
        cloudinaryMapping: "content_images"
    },
    contactForm: {
        apiPath: "/api/contactform",
        reasons: [
            {
                value: "delivery",
                label: "Sp\xf8rsm\xe5l ang\xe5ende levering",
                label_en: "Questions about ordering"
            },
            {
                value: "invoice",
                label: "Endring av fakturaadresse",
                label_en: "Invoice address changes"
            },
            {
                value: "invoice_credit",
                label: "Sp\xf8rsm\xe5l ang\xe5ende faktura",
                label_en: "Invoice inquiries"
            },
            {
                value: "other",
                label: "Annet",
                label_en: "Other"
            },
            {
                value: "product_order",
                label: "Sp\xf8rsm\xe5l ang\xe5ende bestillling",
                label_en: "Questions about ordering"
            },
            {
                value: "product_question",
                label: "Sp\xf8rsm\xe5l ang\xe5ende produkter",
                label_en: "Question about products"
            },
            {
                value: "refrigeration_equipment",
                label: "Sp\xf8rsm\xe5l ang\xe5ende kj\xf8lem\xf8bler",
                label_en: "Questions about refrigeration equipment"
            }
        ]
    },
    whileYouWaitMessage: "Ta frem en Go'morgen yoghurt fra kj\xf8leskapet, len deg tilbake og nyt et par sekunders velfortjent pause!",
    notifications: {
        categories: [
            {
                id: "ORDER_CONFIRMATION",
                name: "Ordrebekreftelse"
            },
            {
                id: "DELIVERY_CONFIRMATION",
                name: "Leveringsbekreftelse"
            },
            {
                id: "IMPORTANT_INFO_ABOUT_DELIVERY",
                name: "Viktig melding om levering"
            },
            {
                id: "ORDER_DEADLINE",
                name: "P\xe5minnelse om ordrefrist"
            }
        ],
        enableDeliveryMessages: true
    },
    orderConfirmation: {
        headerSubTitle: "Du vil motta en bestillingsbekreftelse p\xe5 e-post om kort tid."
    },
    cart: {
        customerReferenceLabel: "Din betalingsreferanse"
    },
    promotionsPage: {
        enabled: true
    }
};
var $684c21356acb56e1$export$2e2bcd8739ae039 = $684c21356acb56e1$var$tineSiteConfig;

});
parcelRegister("bYgbs", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", function () { return $95ec2c00a03a82c9$export$f654b28f82155665; });

var $biFcX = parcelRequire("biFcX");

var $8ZCSm = parcelRequire("8ZCSm");
const $95ec2c00a03a82c9$export$f654b28f82155665 = (endpoint)=>{
    const featureMap = {
        orders: (0, $biFcX.default).apiProxyOrders,
        invoices: (0, $biFcX.default).apiProxyInvoices,
        features: (0, $biFcX.default).apiProxyFeatures,
        deliveryWindows: (0, $biFcX.default).apiProxyDeliveryWindows,
        notification_profiles: (0, $biFcX.default).apiProxyNotificationProfiles
    };
    const base = featureMap[endpoint] ? (0, $8ZCSm.PROXY_HOST) : (0, $8ZCSm.API_HOST);
    if (!base) throw new Error(`Missing base URL for ${endpoint}. Check API_HOST/PROXY_HOST and environment setup.`);
    return base;
};

});
parcelRegister("biFcX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99cc86957baa5d23$export$2e2bcd8739ae039; });

var $djkK5 = parcelRequire("djkK5");

var $Kk7R3 = parcelRequire("Kk7R3");

var $ibBxS = parcelRequire("ibBxS");

var $gtsdT = parcelRequire("gtsdT");

var $fj1oy = parcelRequire("fj1oy");

var $f2Bp8 = parcelRequire("f2Bp8");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");
const $99cc86957baa5d23$export$6c0089bb1964eaa8 = (0, $Kk7R3.makeAutoObservable)({
    customerFeatures: [],
    barcodeScannerEnabled: false,
    claimsEnabled: false,
    pickupOrderAvailable: false,
    notificationsEnabled: false,
    newPromotionNotificationsEnabled: false,
    keyFiguresAvailable: false,
    recommendationType: "AI1",
    contractualRecommendations: false,
    voucherifyAvailable: false,
    useDynamicsForNotificationProfiles: false,
    prioritizeAgreementAssortment: false,
    searchResultsSortedByCustomerGroupSales: false,
    apiProxyOrders: false,
    apiProxyInvoices: false,
    apiProxyFeatures: false,
    apiProxyDeliveryWindows: false,
    apiProxyNotificationProfiles: false,
    filterDisplayThreshold: 8,
    navigationTestVariant: "megamenu",
    fetchEnabledConfigCatFeatures: async (company)=>{
        const userData = new (0, $djkK5.User)(company?.customerNumber || "Anonymous");
        userData.custom = {
            chainLevel1: (0, $fj1oy.keepIdOnly)(company?.businessLevels.level1 || "N/A"),
            chainLevel2: (0, $fj1oy.keepIdOnly)(company?.businessLevels.level2 || "N/A"),
            chainLevel3: (0, $fj1oy.keepIdOnly)(company?.businessLevels.level3 || "N/A"),
            chainLevel4: (0, $fj1oy.keepIdOnly)(company?.businessLevels.level4 || "N/A"),
            customerGroup: (0, $fj1oy.keepIdOnly)(company?.customerGroup || "N/A")
        };
        const flagsAndValues = {};
        flagsAndValues.barcodeScannerEnabled = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).BARCODESCANNER_AVAILABLE, userData);
        flagsAndValues.claimsEnabled = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).CLAIMS_AVAILABLE, userData);
        flagsAndValues.pickupOrderAvailable = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).PICKUP_ORDER_AVAILABLE, userData);
        flagsAndValues.notificationsEnabled = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).NOTIFICATIONS_AVAILABLE, userData);
        flagsAndValues.newPromotionNotificationsEnabled = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).NEW_PROMOTION_NOTIFICATIONS_AVAILABLE, userData);
        flagsAndValues.recommendationType = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).RECOMMENDATION_TYPE, userData);
        flagsAndValues.keyFiguresAvailable = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).KEYFIGURES_AVAILABLE, userData);
        flagsAndValues.contractualRecommendations = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).CONTRACTUAL_RECOMMENDATIONS, userData);
        flagsAndValues.voucherifyAvailable = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).VOUCHERIFY_AVAILABLE, userData);
        flagsAndValues.useDynamicsForNotificationProfiles = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).USE_DYNAMICS_FOR_NOTIFICATION_PROFILES, userData);
        flagsAndValues.prioritizeAgreementAssortment = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).PRIORITIZE_AGREEMENT_ASSORTMENT, userData);
        flagsAndValues.searchResultsSortedByCustomerGroupSales = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).SEARCH_RESULTS_SORTED_BY_CUSTOMER_GROUP_SALES, userData);
        flagsAndValues.filterDisplayThreshold = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).FILTER_DISPLAY_THRESHOLD, userData);
        if (userData.custom.customerNumber !== "Anonymous") {
            flagsAndValues.navigationTestVariant = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).NAVIGATION_TEST_VARIANT, userData);
            (0, $f2Bp8.setNavigationTestVariantInStorage)($99cc86957baa5d23$export$6c0089bb1964eaa8.navigationTestVariant);
        } else flagsAndValues.navigationTestVariant = (0, $f2Bp8.getNavigationTestVariantFromStorage)() || "megamenu";
        flagsAndValues.apiProxyOrders = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).API_PROXY_ORDERS, userData);
        flagsAndValues.apiProxyInvoices = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).API_PROXY_INVOICES, userData);
        flagsAndValues.apiProxyFeatures = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).API_PROXY_FEATURES, userData);
        flagsAndValues.apiProxyDeliveryWindows = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).API_PROXY_DELIVERY_WINDOWS, userData);
        flagsAndValues.apiProxyNotificationProfiles = await (0, $ibBxS.getConfigCatValue)((0, $ibBxS.ConfigCatKeys).API_PROXY_NOTIFICATION_PROFILES, userData);
        (0, $Kk7R3.runInAction)(()=>{
            Object.assign($99cc86957baa5d23$export$6c0089bb1964eaa8, flagsAndValues);
        });
    },
    fetchEnabledCustomerFeatures: async (customerNumber)=>{
        const resp = await (0, $isIf6.default).fetchCustomerFeatures(customerNumber, (0, $bcbvQ.default).getSessionToken() || "");
        (0, $Kk7R3.runInAction)(()=>{
            $99cc86957baa5d23$export$6c0089bb1964eaa8.customerFeatures = resp.map((feature)=>feature.name);
        });
        (0, $gtsdT.logger).log("auth", "Features found: ", $99cc86957baa5d23$export$6c0089bb1964eaa8.customerFeatures);
    },
    hasCustomerFeature: (featureName)=>{
        return $99cc86957baa5d23$export$6c0089bb1964eaa8.customerFeatures.includes(featureName);
    },
    clearCompanySpecificData: ()=>{
        $99cc86957baa5d23$export$6c0089bb1964eaa8.customerFeatures = [];
        $99cc86957baa5d23$export$6c0089bb1964eaa8.fetchEnabledConfigCatFeatures();
    }
});
var $99cc86957baa5d23$export$2e2bcd8739ae039 = $99cc86957baa5d23$export$6c0089bb1964eaa8;

});
parcelRegister("djkK5", function(module, exports) {

$parcel$export(module.exports, "User", function () { return $9b0d23b406533abf$export$1f44aaf2ec115b54; });
$parcel$export(module.exports, "getUserAttribute", function () { return $9b0d23b406533abf$export$247545f1114b5324; });
$parcel$export(module.exports, "getUserAttributes", function () { return $9b0d23b406533abf$export$e741ea695767fdb4; });
/**
 * User Object. Contains user attributes which are used for evaluating targeting rules and percentage options.
 * @remarks
 * Please note that the `User` class is not designed to be used as a DTO (data transfer object).
 * (Since the type of the `custom` property is polymorphic, it's not guaranteed that deserializing a serialized instance produces an instance with an identical or even valid data content.)
 **/ var $9b0d23b406533abf$export$1f44aaf2ec115b54 = /** @class */ function() {
    function User(/** The unique identifier of the user or session (e.g. email address, primary key, session ID, etc.) */ identifier, /** Email address of the user. */ email, /** Country of the user. */ country, /**
     * Custom attributes of the user for advanced targeting rule definitions (e.g. user role, subscription type, etc.)
     * @remarks
     * All comparators support `string` values as User Object attribute (in some cases they need to be provided in a specific format though, see below),
     * but some of them also support other types of values. It depends on the comparator how the values will be handled. The following rules apply:
     *
     * **Text-based comparators** (EQUALS, IS ONE OF, etc.)
     * * accept `string` values,
     * * all other values are automatically converted to `string` (a warning will be logged but evaluation will continue as normal).
     *
     * **SemVer-based comparators** (IS ONE OF, &lt;, &gt;=, etc.)
     * * accept `string` values containing a properly formatted, valid semver value,
     * * all other values are considered invalid (a warning will be logged and the currently evaluated targeting rule will be skipped).
     *
     * **Number-based comparators** (=, &lt;, &gt;=, etc.)
     * * accept `number` values,
     * * accept `string` values containing a properly formatted, valid `number` value,
     * * all other values are considered invalid (a warning will be logged and the currently evaluated targeting rule will be skipped).
     *
     * **Date time-based comparators** (BEFORE / AFTER)
     * * accept `Date` values, which are automatically converted to a second-based Unix timestamp,
     * * accept `number` values representing a second-based Unix timestamp,
     * * accept `string` values containing a properly formatted, valid `number` value,
     * * all other values are considered invalid (a warning will be logged and the currently evaluated targeting rule will be skipped).
     *
     * **String array-based comparators** (ARRAY CONTAINS ANY OF / ARRAY NOT CONTAINS ANY OF)
     * * accept arrays of `string`,
     * * accept `string` values containing a valid JSON string which can be deserialized to an array of `string`,
     * * all other values are considered invalid (a warning will be logged and the currently evaluated targeting rule will be skipped).
     **/ custom) {
        if (custom === void 0) custom = {};
        this.identifier = identifier;
        this.email = email;
        this.country = country;
        this.custom = custom;
    }
    return User;
}();
function $9b0d23b406533abf$export$247545f1114b5324(user, name) {
    var _a, _b;
    switch(name){
        case "Identifier":
            return (_a = user.identifier) !== null && _a !== void 0 ? _a : "";
        case "Email":
            return user.email;
        case "Country":
            return user.country;
        default:
            return (_b = user.custom) === null || _b === void 0 ? void 0 : _b[name];
    }
}
function $9b0d23b406533abf$export$e741ea695767fdb4(user) {
    var _a;
    var result = {};
    var identifierAttribute = "Identifier";
    var emailAttribute = "Email";
    var countryAttribute = "Country";
    result[identifierAttribute] = (_a = user.identifier) !== null && _a !== void 0 ? _a : "";
    if (user.email != null) result[emailAttribute] = user.email;
    if (user.country != null) result[countryAttribute] = user.country;
    if (user.custom != null) {
        var wellKnownAttributes = [
            identifierAttribute,
            emailAttribute,
            countryAttribute
        ];
        for(var _i = 0, _b = Object.entries(user.custom); _i < _b.length; _i++){
            var _c = _b[_i], attributeName = _c[0], attributeValue = _c[1];
            if (attributeValue != null && wellKnownAttributes.indexOf(attributeName) < 0) result[attributeName] = attributeValue;
        }
    }
    return result;
}

});

parcelRegister("ibBxS", function(module, exports) {

$parcel$export(module.exports, "ConfigCatKeys", function () { return $c7b41c90e7160d7a$export$ed0d1a819fd2d8d4; });
$parcel$export(module.exports, "getConfigCatValue", function () { return $c7b41c90e7160d7a$export$57aeb784add6966d; });

var $ihF1l = parcelRequire("ihF1l");
var $7NnoB = parcelRequire("7NnoB");
var $isReF = parcelRequire("isReF");

var $8ZCSm = parcelRequire("8ZCSm");

var $9n21e = parcelRequire("9n21e");
var $c7b41c90e7160d7a$export$ed0d1a819fd2d8d4 = /*#__PURE__*/ function(ConfigCatKeys) {
    ConfigCatKeys["BARCODESCANNER_AVAILABLE"] = "barcodeScannerAvailable";
    ConfigCatKeys["CLAIMS_AVAILABLE"] = "claimsAvailable";
    ConfigCatKeys["PICKUP_ORDER_AVAILABLE"] = "pickupOrderAvailable";
    ConfigCatKeys["NOTIFICATIONS_AVAILABLE"] = "notificationsAvailable";
    ConfigCatKeys["NEW_PROMOTION_NOTIFICATIONS_AVAILABLE"] = "newPromotionNotificationsAvailable";
    ConfigCatKeys["RECOMMENDATION_TYPE"] = "recommendationType";
    ConfigCatKeys["KEYFIGURES_AVAILABLE"] = "keyFiguresAvailable";
    ConfigCatKeys["CONTRACTUAL_RECOMMENDATIONS"] = "contractualRecommendations";
    ConfigCatKeys["VOUCHERIFY_AVAILABLE"] = "voucherifyAvailable";
    ConfigCatKeys["USE_DYNAMICS_FOR_NOTIFICATION_PROFILES"] = "useDynamicsForNotificationProfiles";
    ConfigCatKeys["PRIORITIZE_AGREEMENT_ASSORTMENT"] = "prioritizeAgreementAssortment";
    ConfigCatKeys["SEARCH_RESULTS_SORTED_BY_CUSTOMER_GROUP_SALES"] = "searchResultsSortedByCustomerGroupSales";
    ConfigCatKeys["NAVIGATION_TEST_VARIANT"] = "navigationtestvariant";
    ConfigCatKeys["API_PROXY_ORDERS"] = "apiProxyOrders";
    ConfigCatKeys["API_PROXY_INVOICES"] = "apiProxyInvoices";
    ConfigCatKeys["API_PROXY_FEATURES"] = "apiProxyFeatures";
    ConfigCatKeys["API_PROXY_DELIVERY_WINDOWS"] = "apiProxyDeliveryWindows";
    ConfigCatKeys["API_PROXY_NOTIFICATION_PROFILES"] = "apiProxyNotificationProfiles";
    ConfigCatKeys["FILTER_DISPLAY_THRESHOLD"] = "filterdisplaythreshold";
    return ConfigCatKeys;
}({});
// Define a mapping object with default values for each key now that we can no longer default to false
const $c7b41c90e7160d7a$var$defaultValueReturnValues = {
    ["barcodeScannerAvailable"]: false,
    ["claimsAvailable"]: false,
    ["pickupOrderAvailable"]: false,
    ["notificationsAvailable"]: false,
    ["newPromotionNotificationsAvailable"]: false,
    ["keyFiguresAvailable"]: false,
    ["recommendationType"]: "AI2",
    ["contractualRecommendations"]: false,
    ["voucherifyAvailable"]: false,
    ["useDynamicsForNotificationProfiles"]: false,
    ["prioritizeAgreementAssortment"]: false,
    ["searchResultsSortedByCustomerGroupSales"]: false,
    ["navigationtestvariant"]: "megamenu",
    ["apiProxyOrders"]: false,
    ["apiProxyInvoices"]: false,
    ["apiProxyFeatures"]: false,
    ["apiProxyDeliveryWindows"]: false,
    ["apiProxyNotificationProfiles"]: false,
    ["filterdisplaythreshold"]: 8
};
/**
 * Set up ConfigCat client so we can do true feature toggles
 */ const $c7b41c90e7160d7a$var$logLevelFromStorage = Number.parseInt((0, $9n21e.getConfigCatLogLevelFromStorage)());
const $c7b41c90e7160d7a$var$configCatClient = $7NnoB.getClient((0, $8ZCSm.CONFIG_CAT_KEY) || "MISSING-API-KEY", (0, $isReF.PollingMode).AutoPoll, {
    pollIntervalSeconds: 1200,
    logger: $ihF1l.createConsoleLogger($c7b41c90e7160d7a$var$logLevelFromStorage)
});
async function $c7b41c90e7160d7a$export$57aeb784add6966d(key, userData) {
    const value = await $c7b41c90e7160d7a$var$configCatClient.getValueAsync(key, $c7b41c90e7160d7a$var$defaultValueReturnValues[key], userData).catch((_e)=>{
        return $c7b41c90e7160d7a$var$defaultValueReturnValues[key];
    });
    if (key === "recommendationType" || key === "navigationtestvariant") return value;
    if (key === "filterdisplaythreshold") {
        const num = Number(value);
        return Number.isNaN(num) ? $c7b41c90e7160d7a$var$defaultValueReturnValues[key] : num;
    }
    return Boolean(value);
}

});
parcelRegister("ihF1l", function(module, exports) {

$parcel$export(module.exports, "getClient", function () { return $d4f9a25d570686a2$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "createConsoleLogger", function () { return $d4f9a25d570686a2$export$297abbbd7d012370; });

var $8LRzm = parcelRequire("8LRzm");

var $isReF = parcelRequire("isReF");

var $dqDdj = parcelRequire("dqDdj");

var $cCuGt = parcelRequire("cCuGt");

var $dEOe6 = parcelRequire("dEOe6");

var $MHqav = parcelRequire("MHqav");

var $8ZGXJ = parcelRequire("8ZGXJ");


var $djkK5 = parcelRequire("djkK5");

(0, $dEOe6.setupPolyfills)();
function $d4f9a25d570686a2$export$6bb76d6eba7e258c(sdkKey, pollingMode, options, configCatKernel) {
    return (0, $8LRzm.ConfigCatClient).get(sdkKey, pollingMode, options, configCatKernel);
}
function $d4f9a25d570686a2$export$2a8a0af47d4d16b0() {
    (0, $8LRzm.ConfigCatClient).disposeAll();
}
function $d4f9a25d570686a2$export$297abbbd7d012370(logLevel, eol) {
    return new (0, $dqDdj.ConfigCatConsoleLogger)(logLevel, eol);
}
function $d4f9a25d570686a2$export$f9c1d9609afd86ea(map, behaviour, watchChanges) {
    return new (0, $cCuGt.FlagOverrides)(new (0, $cCuGt.MapOverrideDataSource)(map, watchChanges), behaviour);
}

});
parcelRegister("8LRzm", function(module, exports) {

$parcel$export(module.exports, "ConfigCatClient", function () { return $662c44409fdf67e2$export$3dd3e3fd07d83f61; });

var $ixrLi = parcelRequire("ixrLi");

var $TWDpE = parcelRequire("TWDpE");

var $isReF = parcelRequire("isReF");

var $dqDdj = parcelRequire("dqDdj");

var $jh0RI = parcelRequire("jh0RI");

var $cCuGt = parcelRequire("cCuGt");

var $fCJUV = parcelRequire("fCJUV");

var $aXBrO = parcelRequire("aXBrO");

var $dEOe6 = parcelRequire("dEOe6");

var $jBPdJ = parcelRequire("jBPdJ");

var $djkK5 = parcelRequire("djkK5");

var $dzur7 = parcelRequire("dzur7");
var $662c44409fdf67e2$export$dfeb68e5a0f06f27 = /** @class */ function() {
    function ConfigCatClientCache() {
        this.instances = {};
    }
    ConfigCatClientCache.prototype.getOrCreate = function(options, configCatKernel) {
        var instance;
        var cachedInstance = this.instances[options.sdkKey];
        if (cachedInstance) {
            var weakRef = cachedInstance[0];
            instance = weakRef.deref();
            if (instance) return [
                instance,
                true
            ];
        }
        var token = {};
        instance = new $662c44409fdf67e2$export$3dd3e3fd07d83f61(options, configCatKernel, token);
        var weakRefCtor = (0, $dEOe6.isWeakRefAvailable)() ? WeakRef : (0, $dEOe6.getWeakRefStub)();
        this.instances[options.sdkKey] = [
            new weakRefCtor(instance),
            token
        ];
        return [
            instance,
            false
        ];
    };
    ConfigCatClientCache.prototype.remove = function(sdkKey, cacheToken) {
        var cachedInstance = this.instances[sdkKey];
        if (cachedInstance) {
            var weakRef = cachedInstance[0], token = cachedInstance[1];
            var instanceIsAvailable = !!weakRef.deref();
            if (!instanceIsAvailable || token === cacheToken) {
                delete this.instances[sdkKey];
                return instanceIsAvailable;
            }
        }
        return false;
    };
    ConfigCatClientCache.prototype.clear = function() {
        var removedInstances = [];
        for(var _i = 0, _a = Object.entries(this.instances); _i < _a.length; _i++){
            var _b = _a[_i], sdkKey = _b[0], weakRef = _b[1][0];
            var instance = weakRef.deref();
            if (instance) removedInstances.push(instance);
            delete this.instances[sdkKey];
        }
        return removedInstances;
    };
    return ConfigCatClientCache;
}();
var $662c44409fdf67e2$var$clientInstanceCache = new $662c44409fdf67e2$export$dfeb68e5a0f06f27();
var $662c44409fdf67e2$export$3dd3e3fd07d83f61 = /** @class */ function() {
    function ConfigCatClient(options, configCatKernel, cacheToken) {
        var _a;
        this.cacheToken = cacheToken;
        /** @inheritdoc */ this.addListener = this.on;
        /** @inheritdoc */ this.off = this.removeListener;
        if (!options) throw new Error("Invalid 'options' value");
        this.options = options;
        if (options.logger.isEnabled((0, $dqDdj.LogLevel).Debug)) options.logger.debug("Initializing ConfigCatClient. Options: " + JSON.stringify($662c44409fdf67e2$export$e718dcb27f143ab3(options)));
        if (!configCatKernel) throw new Error("Invalid 'configCatKernel' value");
        if (!configCatKernel.configFetcher) throw new Error("Invalid 'configCatKernel.configFetcher' value");
        // To avoid possible memory leaks, the components of the client should not hold a strong reference to the hooks object (see also SafeHooksWrapper).
        this.hooks = options.yieldHooks();
        if (options.defaultUser) this.setDefaultUser(options.defaultUser);
        this.evaluator = new (0, $jBPdJ.RolloutEvaluator)(options.logger);
        if (((_a = options.flagOverrides) === null || _a === void 0 ? void 0 : _a.behaviour) !== (0, $cCuGt.OverrideBehaviour).LocalOnly) this.configService = options instanceof (0, $isReF.AutoPollOptions) ? new (0, $TWDpE.AutoPollConfigService)(configCatKernel.configFetcher, options) : options instanceof (0, $isReF.ManualPollOptions) ? new (0, $aXBrO.ManualPollConfigService)(configCatKernel.configFetcher, options) : options instanceof (0, $isReF.LazyLoadOptions) ? new (0, $fCJUV.LazyLoadConfigService)(configCatKernel.configFetcher, options) : (0, $dzur7.throwError)(new Error("Invalid 'options' value"));
        else this.hooks.emit("clientReady", (0, $jh0RI.ClientCacheState).HasLocalOverrideFlagDataOnly);
        this.suppressFinalize = $662c44409fdf67e2$var$registerForFinalization(this, {
            sdkKey: options.sdkKey,
            cacheToken: cacheToken,
            configService: this.configService,
            logger: options.logger
        });
    }
    Object.defineProperty(ConfigCatClient, "instanceCache", {
        get: function() {
            return $662c44409fdf67e2$var$clientInstanceCache;
        },
        enumerable: false,
        configurable: true
    });
    ConfigCatClient.get = function(sdkKey, pollingMode, options, configCatKernel) {
        var _a;
        var invalidSdkKeyError = "Invalid 'sdkKey' value";
        if (!sdkKey) throw new Error(invalidSdkKeyError);
        var optionsClass = pollingMode === (0, $isReF.PollingMode).AutoPoll ? (0, $isReF.AutoPollOptions) : pollingMode === (0, $isReF.PollingMode).ManualPoll ? (0, $isReF.ManualPollOptions) : pollingMode === (0, $isReF.PollingMode).LazyLoad ? (0, $isReF.LazyLoadOptions) : (0, $dzur7.throwError)(new Error("Invalid 'pollingMode' value"));
        var actualOptions = new optionsClass(sdkKey, configCatKernel.sdkType, configCatKernel.sdkVersion, options, configCatKernel.defaultCacheFactory, configCatKernel.eventEmitterFactory);
        if (((_a = actualOptions.flagOverrides) === null || _a === void 0 ? void 0 : _a.behaviour) !== (0, $cCuGt.OverrideBehaviour).LocalOnly && !$662c44409fdf67e2$var$isValidSdkKey(sdkKey, actualOptions.baseUrlOverriden)) throw new Error(invalidSdkKeyError);
        var _b = $662c44409fdf67e2$var$clientInstanceCache.getOrCreate(actualOptions, configCatKernel), instance = _b[0], instanceAlreadyCreated = _b[1];
        if (instanceAlreadyCreated && options) actualOptions.logger.clientIsAlreadyCreated(sdkKey);
        return instance;
    };
    ConfigCatClient.finalize = function(data) {
        // Safeguard against situations where user forgets to dispose of the client instance.
        var _a;
        (_a = data.logger) === null || _a === void 0 || _a.debug("finalize() called");
        if (data.cacheToken) $662c44409fdf67e2$var$clientInstanceCache.remove(data.sdkKey, data.cacheToken);
        ConfigCatClient.close(data.configService, data.logger);
    };
    ConfigCatClient.close = function(configService, logger, hooks) {
        logger === null || logger === void 0 || logger.debug("close() called");
        hooks === null || hooks === void 0 || hooks.tryDisconnect();
        configService === null || configService === void 0 || configService.dispose();
    };
    ConfigCatClient.prototype.dispose = function() {
        var options = this.options;
        options.logger.debug("dispose() called");
        if (this.cacheToken) $662c44409fdf67e2$var$clientInstanceCache.remove(options.sdkKey, this.cacheToken);
        ConfigCatClient.close(this.configService, options.logger, this.hooks);
        this.suppressFinalize();
    };
    ConfigCatClient.disposeAll = function() {
        var removedInstances = $662c44409fdf67e2$var$clientInstanceCache.clear();
        var errors;
        for(var _i = 0, removedInstances_1 = removedInstances; _i < removedInstances_1.length; _i++){
            var instance = removedInstances_1[_i];
            try {
                ConfigCatClient.close(instance.configService, instance.options.logger, instance.hooks);
                instance.suppressFinalize();
            } catch (err) {
                errors !== null && errors !== void 0 ? errors : errors = [];
                errors.push(err);
            }
        }
        if (errors) throw typeof AggregateError !== "undefined" ? new AggregateError(errors) : errors.pop();
    };
    ConfigCatClient.prototype.getValueAsync = function(key, defaultValue, user) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var value, evaluationDetails, remoteConfig, settings, err_1;
            var _a;
            return (0, $ixrLi.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.options.logger.debug("getValueAsync() called.");
                        $662c44409fdf67e2$var$validateKey(key);
                        $662c44409fdf67e2$var$ensureAllowedDefaultValue(defaultValue);
                        remoteConfig = null;
                        user !== null && user !== void 0 ? user : user = this.defaultUser;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        settings = void 0;
                        return [
                            4 /*yield*/ ,
                            this.getSettingsAsync()
                        ];
                    case 2:
                        _a = _b.sent(), settings = _a[0], remoteConfig = _a[1];
                        evaluationDetails = (0, $jBPdJ.evaluate)(this.evaluator, settings, key, defaultValue, user, remoteConfig, this.options.logger);
                        value = evaluationDetails.value;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _b.sent();
                        this.options.logger.settingEvaluationErrorSingle("getValueAsync", key, "defaultValue", defaultValue, err_1);
                        evaluationDetails = (0, $jBPdJ.evaluationDetailsFromDefaultValue)(key, defaultValue, (0, $jBPdJ.getTimestampAsDate)(remoteConfig), user, (0, $dzur7.errorToString)(err_1), err_1);
                        value = defaultValue;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        this.hooks.emit("flagEvaluated", evaluationDetails);
                        return [
                            2 /*return*/ ,
                            value
                        ];
                }
            });
        });
    };
    ConfigCatClient.prototype.getValueDetailsAsync = function(key, defaultValue, user) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var evaluationDetails, remoteConfig, settings, err_2;
            var _a;
            return (0, $ixrLi.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.options.logger.debug("getValueDetailsAsync() called.");
                        $662c44409fdf67e2$var$validateKey(key);
                        $662c44409fdf67e2$var$ensureAllowedDefaultValue(defaultValue);
                        remoteConfig = null;
                        user !== null && user !== void 0 ? user : user = this.defaultUser;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        settings = void 0;
                        return [
                            4 /*yield*/ ,
                            this.getSettingsAsync()
                        ];
                    case 2:
                        _a = _b.sent(), settings = _a[0], remoteConfig = _a[1];
                        evaluationDetails = (0, $jBPdJ.evaluate)(this.evaluator, settings, key, defaultValue, user, remoteConfig, this.options.logger);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_2 = _b.sent();
                        this.options.logger.settingEvaluationErrorSingle("getValueDetailsAsync", key, "defaultValue", defaultValue, err_2);
                        evaluationDetails = (0, $jBPdJ.evaluationDetailsFromDefaultValue)(key, defaultValue, (0, $jBPdJ.getTimestampAsDate)(remoteConfig), user, (0, $dzur7.errorToString)(err_2), err_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        this.hooks.emit("flagEvaluated", evaluationDetails);
                        return [
                            2 /*return*/ ,
                            evaluationDetails
                        ];
                }
            });
        });
    };
    ConfigCatClient.prototype.getAllKeysAsync = function() {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var defaultReturnValue, settings, err_3;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.options.logger.debug("getAllKeysAsync() called.");
                        defaultReturnValue = "empty array";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getSettingsAsync()
                        ];
                    case 2:
                        settings = _a.sent()[0];
                        if (!(0, $jBPdJ.checkSettingsAvailable)(settings, this.options.logger, defaultReturnValue)) return [
                            2 /*return*/ ,
                            []
                        ];
                        return [
                            2 /*return*/ ,
                            Object.keys(settings)
                        ];
                    case 3:
                        err_3 = _a.sent();
                        this.options.logger.settingEvaluationError("getAllKeysAsync", defaultReturnValue, err_3);
                        return [
                            2 /*return*/ ,
                            []
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigCatClient.prototype.getAllValuesAsync = function(user) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var defaultReturnValue, result, evaluationDetailsArray, evaluationErrors, _a, settings, remoteConfig, err_4, _i, evaluationDetailsArray_1, evaluationDetail;
            var _b;
            return (0, $ixrLi.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this.options.logger.debug("getAllValuesAsync() called.");
                        defaultReturnValue = "empty array";
                        user !== null && user !== void 0 ? user : user = this.defaultUser;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getSettingsAsync()
                        ];
                    case 2:
                        _a = _c.sent(), settings = _a[0], remoteConfig = _a[1];
                        _b = (0, $jBPdJ.evaluateAll)(this.evaluator, settings, user, remoteConfig, this.options.logger, defaultReturnValue), evaluationDetailsArray = _b[0], evaluationErrors = _b[1];
                        result = evaluationDetailsArray.map(function(details) {
                            return new $662c44409fdf67e2$export$2a14f59ee5736201(details.key, details.value);
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_4 = _c.sent();
                        this.options.logger.settingEvaluationError("getAllValuesAsync", defaultReturnValue, err_4);
                        return [
                            2 /*return*/ ,
                            []
                        ];
                    case 4:
                        if (evaluationErrors === null || evaluationErrors === void 0 ? void 0 : evaluationErrors.length) this.options.logger.settingEvaluationError("getAllValuesAsync", "evaluation result", typeof AggregateError !== "undefined" ? new AggregateError(evaluationErrors) : evaluationErrors.pop());
                        for(_i = 0, evaluationDetailsArray_1 = evaluationDetailsArray; _i < evaluationDetailsArray_1.length; _i++){
                            evaluationDetail = evaluationDetailsArray_1[_i];
                            this.hooks.emit("flagEvaluated", evaluationDetail);
                        }
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    ConfigCatClient.prototype.getAllValueDetailsAsync = function(user) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var defaultReturnValue, evaluationDetailsArray, evaluationErrors, _a, settings, remoteConfig, err_5, _i, evaluationDetailsArray_2, evaluationDetail;
            var _b;
            return (0, $ixrLi.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this.options.logger.debug("getAllValueDetailsAsync() called.");
                        defaultReturnValue = "empty array";
                        user !== null && user !== void 0 ? user : user = this.defaultUser;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getSettingsAsync()
                        ];
                    case 2:
                        _a = _c.sent(), settings = _a[0], remoteConfig = _a[1];
                        _b = (0, $jBPdJ.evaluateAll)(this.evaluator, settings, user, remoteConfig, this.options.logger, defaultReturnValue), evaluationDetailsArray = _b[0], evaluationErrors = _b[1];
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_5 = _c.sent();
                        this.options.logger.settingEvaluationError("getAllValueDetailsAsync", defaultReturnValue, err_5);
                        return [
                            2 /*return*/ ,
                            []
                        ];
                    case 4:
                        if (evaluationErrors === null || evaluationErrors === void 0 ? void 0 : evaluationErrors.length) this.options.logger.settingEvaluationError("getAllValueDetailsAsync", "evaluation result", typeof AggregateError !== "undefined" ? new AggregateError(evaluationErrors) : evaluationErrors.pop());
                        for(_i = 0, evaluationDetailsArray_2 = evaluationDetailsArray; _i < evaluationDetailsArray_2.length; _i++){
                            evaluationDetail = evaluationDetailsArray_2[_i];
                            this.hooks.emit("flagEvaluated", evaluationDetail);
                        }
                        return [
                            2 /*return*/ ,
                            evaluationDetailsArray
                        ];
                }
            });
        });
    };
    ConfigCatClient.prototype.getKeyAndValueAsync = function(variationId) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var defaultReturnValue, settings, _i, _a, _b, settingKey, setting, targetingRules, i, then, j, percentageOption, percentageOptions, i, percentageOption, err_6;
            return (0, $ixrLi.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this.options.logger.debug("getKeyAndValueAsync() called.");
                        defaultReturnValue = "null";
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getSettingsAsync()
                        ];
                    case 2:
                        settings = _c.sent()[0];
                        if (!(0, $jBPdJ.checkSettingsAvailable)(settings, this.options.logger, defaultReturnValue)) return [
                            2 /*return*/ ,
                            null
                        ];
                        for(_i = 0, _a = Object.entries(settings); _i < _a.length; _i++){
                            _b = _a[_i], settingKey = _b[0], setting = _b[1];
                            if (variationId === setting.variationId) return [
                                2 /*return*/ ,
                                new $662c44409fdf67e2$export$2a14f59ee5736201(settingKey, $662c44409fdf67e2$var$ensureAllowedValue(setting.value))
                            ];
                            targetingRules = settings[settingKey].targetingRules;
                            if (targetingRules && targetingRules.length > 0) for(i = 0; i < targetingRules.length; i++){
                                then = targetingRules[i].then;
                                if ((0, $dzur7.isArray)(then)) for(j = 0; j < then.length; j++){
                                    percentageOption = then[j];
                                    if (variationId === percentageOption.variationId) return [
                                        2 /*return*/ ,
                                        new $662c44409fdf67e2$export$2a14f59ee5736201(settingKey, $662c44409fdf67e2$var$ensureAllowedValue(percentageOption.value))
                                    ];
                                }
                                else if (variationId === then.variationId) return [
                                    2 /*return*/ ,
                                    new $662c44409fdf67e2$export$2a14f59ee5736201(settingKey, $662c44409fdf67e2$var$ensureAllowedValue(then.value))
                                ];
                            }
                            percentageOptions = settings[settingKey].percentageOptions;
                            if (percentageOptions && percentageOptions.length > 0) for(i = 0; i < percentageOptions.length; i++){
                                percentageOption = percentageOptions[i];
                                if (variationId === percentageOption.variationId) return [
                                    2 /*return*/ ,
                                    new $662c44409fdf67e2$export$2a14f59ee5736201(settingKey, $662c44409fdf67e2$var$ensureAllowedValue(percentageOption.value))
                                ];
                            }
                        }
                        this.options.logger.settingForVariationIdIsNotPresent(variationId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_6 = _c.sent();
                        this.options.logger.settingEvaluationError("getKeyAndValueAsync", defaultReturnValue, err_6);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            null
                        ];
                }
            });
        });
    };
    ConfigCatClient.prototype.forceRefreshAsync = function() {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var result, err_7;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.options.logger.debug("forceRefreshAsync() called.");
                        if (!this.configService) return [
                            3 /*break*/ ,
                            5
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configService.refreshConfigAsync()
                        ];
                    case 2:
                        result = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        err_7 = _a.sent();
                        this.options.logger.forceRefreshError("forceRefreshAsync", err_7);
                        return [
                            2 /*return*/ ,
                            (0, $jh0RI.RefreshResult).failure((0, $dzur7.errorToString)(err_7), err_7)
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            (0, $jh0RI.RefreshResult).failure("Client is configured to use the LocalOnly override behavior, which prevents synchronization with external cache and making HTTP requests.")
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigCatClient.prototype.setDefaultUser = function(defaultUser) {
        this.defaultUser = defaultUser;
    };
    ConfigCatClient.prototype.clearDefaultUser = function() {
        this.defaultUser = void 0;
    };
    Object.defineProperty(ConfigCatClient.prototype, "isOffline", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.configService) === null || _a === void 0 ? void 0 : _a.isOffline) !== null && _b !== void 0 ? _b : true;
        },
        enumerable: false,
        configurable: true
    });
    ConfigCatClient.prototype.setOnline = function() {
        if (this.configService) this.configService.setOnline();
        else this.options.logger.configServiceMethodHasNoEffectDueToOverrideBehavior((0, $cCuGt.OverrideBehaviour)[(0, $cCuGt.OverrideBehaviour).LocalOnly], "setOnline");
    };
    ConfigCatClient.prototype.setOffline = function() {
        var _a;
        (_a = this.configService) === null || _a === void 0 || _a.setOffline();
    };
    ConfigCatClient.prototype.waitForReady = function() {
        var configService = this.configService;
        return configService ? configService.readyPromise : Promise.resolve((0, $jh0RI.ClientCacheState).HasLocalOverrideFlagDataOnly);
    };
    ConfigCatClient.prototype.snapshot = function() {
        var _a, _b, _c;
        var _this = this;
        var _d;
        var getRemoteConfig = function() {
            var config = _this.options.cache.getInMemory();
            var settings = !config.isEmpty ? config.config.settings : null;
            return [
                settings,
                config
            ];
        };
        var remoteSettings;
        var remoteConfig;
        var flagOverrides = (_d = this.options) === null || _d === void 0 ? void 0 : _d.flagOverrides;
        if (flagOverrides) {
            var localSettings = flagOverrides.dataSource.getOverridesSync();
            switch(flagOverrides.behaviour){
                case (0, $cCuGt.OverrideBehaviour).LocalOnly:
                    return new $662c44409fdf67e2$var$Snapshot(localSettings, null, this);
                case (0, $cCuGt.OverrideBehaviour).LocalOverRemote:
                    _a = getRemoteConfig(), remoteSettings = _a[0], remoteConfig = _a[1];
                    return new $662c44409fdf67e2$var$Snapshot((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, remoteSettings !== null && remoteSettings !== void 0 ? remoteSettings : {}), localSettings), remoteConfig, this);
                case (0, $cCuGt.OverrideBehaviour).RemoteOverLocal:
                    _b = getRemoteConfig(), remoteSettings = _b[0], remoteConfig = _b[1];
                    return new $662c44409fdf67e2$var$Snapshot((0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, localSettings), remoteSettings !== null && remoteSettings !== void 0 ? remoteSettings : {}), remoteConfig, this);
            }
        }
        _c = getRemoteConfig(), remoteSettings = _c[0], remoteConfig = _c[1];
        return new $662c44409fdf67e2$var$Snapshot(remoteSettings, remoteConfig, this);
    };
    ConfigCatClient.prototype.getSettingsAsync = function() {
        var _a;
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var getRemoteConfigAsync, flagOverrides, remoteSettings, remoteConfig, localSettings, _b;
            var _c, _d;
            var _this = this;
            return (0, $ixrLi.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        this.options.logger.debug("getSettingsAsync() called.");
                        getRemoteConfigAsync = function() {
                            return (0, $ixrLi.__awaiter)(_this, void 0, void 0, function() {
                                var config, settings;
                                return (0, $ixrLi.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.configService.getConfig()
                                            ];
                                        case 1:
                                            config = _a.sent();
                                            settings = !config.isEmpty ? config.config.settings : null;
                                            return [
                                                2 /*return*/ ,
                                                [
                                                    settings,
                                                    config
                                                ]
                                            ];
                                    }
                                });
                            });
                        };
                        flagOverrides = (_a = this.options) === null || _a === void 0 ? void 0 : _a.flagOverrides;
                        if (!flagOverrides) return [
                            3 /*break*/ ,
                            7
                        ];
                        remoteSettings = void 0;
                        remoteConfig = void 0;
                        return [
                            4 /*yield*/ ,
                            flagOverrides.dataSource.getOverrides()
                        ];
                    case 1:
                        localSettings = _e.sent();
                        _b = flagOverrides.behaviour;
                        switch(_b){
                            case (0, $cCuGt.OverrideBehaviour).LocalOnly:
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case (0, $cCuGt.OverrideBehaviour).LocalOverRemote:
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case (0, $cCuGt.OverrideBehaviour).RemoteOverLocal:
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            [
                                localSettings,
                                null
                            ]
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            getRemoteConfigAsync()
                        ];
                    case 4:
                        _c = _e.sent(), remoteSettings = _c[0], remoteConfig = _c[1];
                        return [
                            2 /*return*/ ,
                            [
                                (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, remoteSettings !== null && remoteSettings !== void 0 ? remoteSettings : {}), localSettings),
                                remoteConfig
                            ]
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            getRemoteConfigAsync()
                        ];
                    case 6:
                        _d = _e.sent(), remoteSettings = _d[0], remoteConfig = _d[1];
                        return [
                            2 /*return*/ ,
                            [
                                (0, $ixrLi.__assign)((0, $ixrLi.__assign)({}, localSettings), remoteSettings !== null && remoteSettings !== void 0 ? remoteSettings : {}),
                                remoteConfig
                            ]
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            getRemoteConfigAsync()
                        ];
                    case 8:
                        return [
                            2 /*return*/ ,
                            _e.sent()
                        ];
                }
            });
        });
    };
    /** @inheritdoc */ ConfigCatClient.prototype.on = function(eventName, listener) {
        this.hooks.on(eventName, listener);
        return this;
    };
    /** @inheritdoc */ ConfigCatClient.prototype.once = function(eventName, listener) {
        this.hooks.once(eventName, listener);
        return this;
    };
    /** @inheritdoc */ ConfigCatClient.prototype.removeListener = function(eventName, listener) {
        this.hooks.removeListener(eventName, listener);
        return this;
    };
    /** @inheritdoc */ ConfigCatClient.prototype.removeAllListeners = function(eventName) {
        this.hooks.removeAllListeners(eventName);
        return this;
    };
    /** @inheritdoc */ ConfigCatClient.prototype.listeners = function(eventName) {
        return this.hooks.listeners(eventName);
    };
    /** @inheritdoc */ ConfigCatClient.prototype.listenerCount = function(eventName) {
        return this.hooks.listenerCount(eventName);
    };
    /** @inheritdoc */ ConfigCatClient.prototype.eventNames = function() {
        return this.hooks.eventNames();
    };
    return ConfigCatClient;
}();
var $662c44409fdf67e2$var$Snapshot = /** @class */ function() {
    function Snapshot(mergedSettings, remoteConfig, client) {
        this.mergedSettings = mergedSettings;
        this.remoteConfig = remoteConfig;
        this.defaultUser = client["defaultUser"];
        this.evaluator = client["evaluator"];
        this.options = client["options"];
        this.cacheState = remoteConfig ? client["configService"].getCacheState(remoteConfig) : (0, $jh0RI.ClientCacheState).HasLocalOverrideFlagDataOnly;
    }
    Object.defineProperty(Snapshot.prototype, "fetchedConfig", {
        get: function() {
            var config = this.remoteConfig;
            return config && !config.isEmpty ? config.config : null;
        },
        enumerable: false,
        configurable: true
    });
    Snapshot.prototype.getAllKeys = function() {
        return this.mergedSettings ? Object.keys(this.mergedSettings) : [];
    };
    Snapshot.prototype.getValue = function(key, defaultValue, user) {
        this.options.logger.debug("Snapshot.getValue() called.");
        $662c44409fdf67e2$var$validateKey(key);
        $662c44409fdf67e2$var$ensureAllowedDefaultValue(defaultValue);
        var value, evaluationDetails;
        user !== null && user !== void 0 ? user : user = this.defaultUser;
        try {
            evaluationDetails = (0, $jBPdJ.evaluate)(this.evaluator, this.mergedSettings, key, defaultValue, user, this.remoteConfig, this.options.logger);
            value = evaluationDetails.value;
        } catch (err) {
            this.options.logger.settingEvaluationErrorSingle("Snapshot.getValue", key, "defaultValue", defaultValue, err);
            evaluationDetails = (0, $jBPdJ.evaluationDetailsFromDefaultValue)(key, defaultValue, (0, $jBPdJ.getTimestampAsDate)(this.remoteConfig), user, (0, $dzur7.errorToString)(err), err);
            value = defaultValue;
        }
        this.options.hooks.emit("flagEvaluated", evaluationDetails);
        return value;
    };
    Snapshot.prototype.getValueDetails = function(key, defaultValue, user) {
        this.options.logger.debug("Snapshot.getValueDetails() called.");
        $662c44409fdf67e2$var$validateKey(key);
        $662c44409fdf67e2$var$ensureAllowedDefaultValue(defaultValue);
        var evaluationDetails;
        user !== null && user !== void 0 ? user : user = this.defaultUser;
        try {
            evaluationDetails = (0, $jBPdJ.evaluate)(this.evaluator, this.mergedSettings, key, defaultValue, user, this.remoteConfig, this.options.logger);
        } catch (err) {
            this.options.logger.settingEvaluationErrorSingle("Snapshot.getValueDetails", key, "defaultValue", defaultValue, err);
            evaluationDetails = (0, $jBPdJ.evaluationDetailsFromDefaultValue)(key, defaultValue, (0, $jBPdJ.getTimestampAsDate)(this.remoteConfig), user, (0, $dzur7.errorToString)(err), err);
        }
        this.options.hooks.emit("flagEvaluated", evaluationDetails);
        return evaluationDetails;
    };
    return Snapshot;
}();
/** Setting key-value pair. */ var $662c44409fdf67e2$export$2a14f59ee5736201 = /** @class */ function() {
    function SettingKeyValue(settingKey, settingValue) {
        this.settingKey = settingKey;
        this.settingValue = settingValue;
    }
    return SettingKeyValue;
}();
function $662c44409fdf67e2$var$isValidSdkKey(sdkKey, customBaseUrl) {
    var proxyPrefix = "configcat-proxy/";
    // NOTE: String.prototype.startsWith was introduced after ES5. We'd rather work around it instead of polyfilling it.
    if (customBaseUrl && sdkKey.length > proxyPrefix.length && sdkKey.lastIndexOf(proxyPrefix, 0) === 0) return true;
    var components = sdkKey.split("/");
    var keyLength = 22;
    switch(components.length){
        case 2:
            return components[0].length === keyLength && components[1].length === keyLength;
        case 3:
            return components[0] === "configcat-sdk-1" && components[1].length === keyLength && components[2].length === keyLength;
        default:
            return false;
    }
}
function $662c44409fdf67e2$var$validateKey(key) {
    if (!key) throw new Error("Invalid 'key' value");
}
function $662c44409fdf67e2$var$ensureAllowedDefaultValue(value) {
    if (value != null && !(0, $jBPdJ.isAllowedValue)(value)) throw new TypeError("The default value must be boolean, number, string, null or undefined.");
}
function $662c44409fdf67e2$var$ensureAllowedValue(value) {
    return (0, $jBPdJ.isAllowedValue)(value) ? value : (0, $jBPdJ.handleInvalidReturnValue)(value);
}
function $662c44409fdf67e2$export$e718dcb27f143ab3(options) {
    return (0, $dzur7.shallowClone)(options, function(key, value) {
        if (key === "defaultUser") return (0, $djkK5.getUserAttributes)(value);
        if (key === "flagOverrides") return (0, $dzur7.shallowClone)(value, function(_, value) {
            return (0, $dzur7.isObject)(value) ? value.toString() : value;
        });
        // NOTE: Prevent internals from leaking into logs and avoid errors because of circular references in user-provided objects.
        return (0, $dzur7.isObject)(value) ? value.toString() : value;
    });
}
var $662c44409fdf67e2$var$registerForFinalization = function(client, data) {
    // Use FinalizationRegistry (finalization callbacks) if the runtime provides that feature.
    if (typeof FinalizationRegistry !== "undefined") {
        var finalizationRegistry_1 = new FinalizationRegistry(function(data) {
            return $662c44409fdf67e2$export$3dd3e3fd07d83f61["finalize"](data);
        });
        $662c44409fdf67e2$var$registerForFinalization = function(client, data) {
            var unregisterToken = {};
            finalizationRegistry_1.register(client, data, unregisterToken);
            return function() {
                return finalizationRegistry_1.unregister(unregisterToken);
            };
        };
    } else $662c44409fdf67e2$var$registerForFinalization = function() {
        return function() {};
    };
    return $662c44409fdf67e2$var$registerForFinalization(client, data);
};

});
parcelRegister("ixrLi", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $8d3f654b827b6101$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $8d3f654b827b6101$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__awaiter", function () { return $8d3f654b827b6101$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $8d3f654b827b6101$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArrays", function () { return $8d3f654b827b6101$export$6388937ca91ccae8; });
$parcel$export(module.exports, "__makeTemplateObject", function () { return $8d3f654b827b6101$export$4fb47efe1390b86f; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8d3f654b827b6101$var$extendStatics = function(d, b) {
    $8d3f654b827b6101$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8d3f654b827b6101$var$extendStatics(d, b);
};
function $8d3f654b827b6101$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8d3f654b827b6101$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8d3f654b827b6101$export$18ce0697a983be9b = function() {
    $8d3f654b827b6101$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8d3f654b827b6101$export$18ce0697a983be9b.apply(this, arguments);
};
function $8d3f654b827b6101$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8d3f654b827b6101$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8d3f654b827b6101$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8d3f654b827b6101$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8d3f654b827b6101$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8d3f654b827b6101$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8d3f654b827b6101$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8d3f654b827b6101$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8d3f654b827b6101$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8d3f654b827b6101$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8d3f654b827b6101$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8d3f654b827b6101$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8d3f654b827b6101$export$45d3717a4c69092e(o, m, p);
}
function $8d3f654b827b6101$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8d3f654b827b6101$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8d3f654b827b6101$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8d3f654b827b6101$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8d3f654b827b6101$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8d3f654b827b6101$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8d3f654b827b6101$export$10c90e4f7922046c(v) {
    return this instanceof $8d3f654b827b6101$export$10c90e4f7922046c ? (this.v = v, this) : new $8d3f654b827b6101$export$10c90e4f7922046c(v);
}
function $8d3f654b827b6101$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8d3f654b827b6101$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8d3f654b827b6101$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8d3f654b827b6101$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8d3f654b827b6101$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8d3f654b827b6101$export$19a8beecd37a4c45 === "function" ? $8d3f654b827b6101$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8d3f654b827b6101$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8d3f654b827b6101$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8d3f654b827b6101$var$ownKeys = function(o) {
    $8d3f654b827b6101$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8d3f654b827b6101$var$ownKeys(o);
};
function $8d3f654b827b6101$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8d3f654b827b6101$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8d3f654b827b6101$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8d3f654b827b6101$var$__setModuleDefault(result, mod);
    return result;
}
function $8d3f654b827b6101$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8d3f654b827b6101$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8d3f654b827b6101$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8d3f654b827b6101$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8d3f654b827b6101$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8d3f654b827b6101$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8d3f654b827b6101$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8d3f654b827b6101$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8d3f654b827b6101$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8d3f654b827b6101$export$2e2bcd8739ae039 = {
    __extends: $8d3f654b827b6101$export$a8ba968b8961cb8a,
    __assign: $8d3f654b827b6101$export$18ce0697a983be9b,
    __rest: $8d3f654b827b6101$export$3c9a16f847548506,
    __decorate: $8d3f654b827b6101$export$29e00dfd3077644b,
    __param: $8d3f654b827b6101$export$d5ad3fd78186038f,
    __esDecorate: $8d3f654b827b6101$export$3a84e1ae4e97e9b0,
    __runInitializers: $8d3f654b827b6101$export$d831c04e792af3d,
    __propKey: $8d3f654b827b6101$export$6a2a36740a146cb8,
    __setFunctionName: $8d3f654b827b6101$export$d1a06452d3489bc7,
    __metadata: $8d3f654b827b6101$export$f1db080c865becb9,
    __awaiter: $8d3f654b827b6101$export$1050f835b63b671e,
    __generator: $8d3f654b827b6101$export$67ebef60e6f28a6,
    __createBinding: $8d3f654b827b6101$export$45d3717a4c69092e,
    __exportStar: $8d3f654b827b6101$export$f33643c0debef087,
    __values: $8d3f654b827b6101$export$19a8beecd37a4c45,
    __read: $8d3f654b827b6101$export$8d051b38c9118094,
    __spread: $8d3f654b827b6101$export$afc72e2116322959,
    __spreadArrays: $8d3f654b827b6101$export$6388937ca91ccae8,
    __spreadArray: $8d3f654b827b6101$export$1216008129fb82ed,
    __await: $8d3f654b827b6101$export$10c90e4f7922046c,
    __asyncGenerator: $8d3f654b827b6101$export$e427f37a30a4de9b,
    __asyncDelegator: $8d3f654b827b6101$export$bbd80228419bb833,
    __asyncValues: $8d3f654b827b6101$export$e3b29a3d6162315f,
    __makeTemplateObject: $8d3f654b827b6101$export$4fb47efe1390b86f,
    __importStar: $8d3f654b827b6101$export$c21735bcef00d192,
    __importDefault: $8d3f654b827b6101$export$da59b14a69baef04,
    __classPrivateFieldGet: $8d3f654b827b6101$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8d3f654b827b6101$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8d3f654b827b6101$export$81fdc39f203e4e04,
    __addDisposableResource: $8d3f654b827b6101$export$88ac25d8e944e405,
    __disposeResources: $8d3f654b827b6101$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8d3f654b827b6101$export$889dfb5d17574b0b
};

});

parcelRegister("TWDpE", function(module, exports) {

$parcel$export(module.exports, "AutoPollConfigService", function () { return $0a829ecbe90325d0$export$d8f6c0499b55d3a5; });

var $ixrLi = parcelRequire("ixrLi");

var $jh0RI = parcelRequire("jh0RI");

var $dzur7 = parcelRequire("dzur7");
var $0a829ecbe90325d0$export$83e9c9b852fcfe31 = 500;
var $0a829ecbe90325d0$export$d8f6c0499b55d3a5 = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(AutoPollConfigService, _super);
    function AutoPollConfigService(configFetcher, options) {
        var _this = _super.call(this, configFetcher, options) || this;
        _this.signalInitialization = function() {};
        _this.stopToken = new (0, $dzur7.AbortToken)();
        _this.pollIntervalMs = options.pollIntervalSeconds * 1000;
        // Due to the inaccuracy of the timer, some tolerance should be allowed when checking for
        // cache expiration in the polling loop, otherwise some fetch operations may be missed.
        _this.pollExpirationMs = _this.pollIntervalMs - $0a829ecbe90325d0$export$83e9c9b852fcfe31;
        var initialCacheSyncUp = _this.syncUpWithCache();
        if (options.maxInitWaitTimeSeconds !== 0) {
            _this.initialized = false;
            // This promise will be resolved as soon as
            // 1. a cache sync operation completes, and the obtained config is up-to-date (see getConfig and startRefreshWorker),
            // 2. or, in case the client is online and the internal cache is still empty or expired after the initial cache sync-up,
            //    the first config fetch operation completes, regardless of success or failure (see onConfigFetched).
            var initSignalPromise = new Promise(function(resolve) {
                return _this.signalInitialization = resolve;
            });
            // This promise will be resolved when either initialization ready is signalled by signalInitialization() or maxInitWaitTimeSeconds pass.
            _this.initializationPromise = _this.waitForInitializationAsync(initSignalPromise).then(function(success) {
                _this.initialized = true;
                return success;
            });
        } else {
            _this.initialized = true;
            _this.initializationPromise = Promise.resolve(false);
        }
        _this.readyPromise = _this.getReadyPromise(_this.initializationPromise, function(initializationPromise) {
            return (0, $ixrLi.__awaiter)(_this, void 0, void 0, function() {
                return (0, $ixrLi.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                initializationPromise
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this.getCacheState(this.options.cache.getInMemory())
                            ];
                    }
                });
            });
        });
        _this.startRefreshWorker(initialCacheSyncUp, _this.stopToken);
        return _this;
    }
    AutoPollConfigService.prototype.waitForInitializationAsync = function(initSignalPromise) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var abortToken, success;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.options.maxInitWaitTimeSeconds < 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            initSignalPromise
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        abortToken = new (0, $dzur7.AbortToken)();
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                initSignalPromise.then(function() {
                                    return true;
                                }),
                                (0, $dzur7.delay)(this.options.maxInitWaitTimeSeconds * 1000, abortToken).then(function() {
                                    return false;
                                })
                            ])
                        ];
                    case 3:
                        success = _a.sent();
                        abortToken.abort();
                        return [
                            2 /*return*/ ,
                            success
                        ];
                }
            });
        });
    };
    AutoPollConfigService.prototype.getConfig = function() {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var cachedConfig;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.options.logger.debug("AutoPollConfigService.getConfig() called.");
                        return [
                            4 /*yield*/ ,
                            this.syncUpWithCache()
                        ];
                    case 1:
                        cachedConfig = _a.sent();
                        if (!!cachedConfig.isExpired(this.pollIntervalMs)) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.signalInitialization();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(!this.isOffline && !this.initialized)) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.options.logger.debug("AutoPollConfigService.getConfig() - cache is empty or expired, waiting for initialization.");
                        return [
                            4 /*yield*/ ,
                            this.initializationPromise
                        ];
                    case 3:
                        _a.sent();
                        cachedConfig = this.options.cache.getInMemory();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        this.options.logger.debug("AutoPollConfigService.getConfig() - cache is empty or expired.");
                        return [
                            2 /*return*/ ,
                            cachedConfig
                        ];
                    case 5:
                        this.options.logger.debug("AutoPollConfigService.getConfig() - returning value from cache.");
                        return [
                            2 /*return*/ ,
                            cachedConfig
                        ];
                }
            });
        });
    };
    AutoPollConfigService.prototype.refreshConfigAsync = function() {
        this.options.logger.debug("AutoPollConfigService.refreshConfigAsync() called.");
        return _super.prototype.refreshConfigAsync.call(this);
    };
    AutoPollConfigService.prototype.dispose = function() {
        this.options.logger.debug("AutoPollConfigService.dispose() called.");
        _super.prototype.dispose.call(this);
        if (!this.stopToken.aborted) this.stopRefreshWorker();
    };
    AutoPollConfigService.prototype.onConfigFetched = function(newConfig) {
        _super.prototype.onConfigFetched.call(this, newConfig);
        this.signalInitialization();
    };
    AutoPollConfigService.prototype.goOnline = function() {
        // We need to restart the polling loop because going from offline to online should trigger a refresh operation
        // immediately instead of waiting for the next tick (which might not happen until much later).
        this.stopRefreshWorker();
        this.stopToken = new (0, $dzur7.AbortToken)();
        this.startRefreshWorker(null, this.stopToken);
    };
    AutoPollConfigService.prototype.startRefreshWorker = function(initialCacheSyncUp, stopToken) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var scheduledNextTimeMs, err_1, realNextTimeMs, err_2;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.options.logger.debug("AutoPollConfigService.startRefreshWorker() called.");
                        _a.label = 1;
                    case 1:
                        if (!!stopToken.aborted) return [
                            3 /*break*/ ,
                            11
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            9,
                            ,
                            10
                        ]);
                        scheduledNextTimeMs = (0, $dzur7.getMonotonicTimeMs)() + this.pollIntervalMs;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.refreshWorkerLogic(initialCacheSyncUp)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _a.sent();
                        this.options.logger.autoPollConfigServiceErrorDuringPolling(err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        realNextTimeMs = scheduledNextTimeMs - (0, $dzur7.getMonotonicTimeMs)();
                        if (!(realNextTimeMs > 0)) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $dzur7.delay)(realNextTimeMs, stopToken)
                        ];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        err_2 = _a.sent();
                        this.options.logger.autoPollConfigServiceErrorDuringPolling(err_2);
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        initialCacheSyncUp = null; // allow GC to collect the Promise and its result
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AutoPollConfigService.prototype.stopRefreshWorker = function() {
        this.options.logger.debug("AutoPollConfigService.stopRefreshWorker() called.");
        this.stopToken.abort();
    };
    AutoPollConfigService.prototype.refreshWorkerLogic = function(initialCacheSyncUp) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var latestConfig;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.options.logger.debug("AutoPollConfigService.refreshWorkerLogic() - called.");
                        return [
                            4 /*yield*/ ,
                            initialCacheSyncUp !== null && initialCacheSyncUp !== void 0 ? initialCacheSyncUp : this.syncUpWithCache()
                        ];
                    case 1:
                        latestConfig = _a.sent();
                        if (!latestConfig.isExpired(this.pollExpirationMs)) return [
                            3 /*break*/ ,
                            3
                        ];
                        if (!(initialCacheSyncUp ? !this.isOfflineExactly : !this.isOffline)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.refreshConfigCoreAsync(latestConfig)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ]; // postpone signalling initialization until `onConfigFetched`
                    case 3:
                        this.signalInitialization();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AutoPollConfigService.prototype.getCacheState = function(cachedConfig) {
        if (cachedConfig.isEmpty) return (0, $jh0RI.ClientCacheState).NoFlagData;
        if (cachedConfig.isExpired(this.pollIntervalMs)) return (0, $jh0RI.ClientCacheState).HasCachedFlagDataOnly;
        return (0, $jh0RI.ClientCacheState).HasUpToDateFlagData;
    };
    return AutoPollConfigService;
}((0, $jh0RI.ConfigServiceBase));

});
parcelRegister("jh0RI", function(module, exports) {

$parcel$export(module.exports, "RefreshResult", function () { return $e08046b0dfb2f9d8$export$e4e21a9c39f836c; });
$parcel$export(module.exports, "ClientCacheState", function () { return $e08046b0dfb2f9d8$export$b8a7e8827e7432a8; });
$parcel$export(module.exports, "ConfigServiceBase", function () { return $e08046b0dfb2f9d8$export$b8e3b952fa46ba90; });

var $ixrLi = parcelRequire("ixrLi");

var $8ZGXJ = parcelRequire("8ZGXJ");

var $MHqav = parcelRequire("MHqav");

var $aOidd = parcelRequire("aOidd");

var $lpUFt = parcelRequire("lpUFt");

var $dzur7 = parcelRequire("dzur7");
/** Contains the result of an `IConfigCatClient.forceRefreshAsync` operation. */ var $e08046b0dfb2f9d8$export$e4e21a9c39f836c = /** @class */ function() {
    function RefreshResult(/** Error message in case the operation failed, otherwise `null`. */ errorMessage, /** The exception object related to the error in case the operation failed (if any). */ errorException) {
        this.errorMessage = errorMessage;
        this.errorException = errorException;
    }
    Object.defineProperty(RefreshResult.prototype, "isSuccess", {
        /** Indicates whether the operation was successful or not. */ get: function() {
            return this.errorMessage === null;
        },
        enumerable: false,
        configurable: true
    });
    RefreshResult.from = function(fetchResult) {
        return fetchResult.status !== (0, $MHqav.FetchStatus).Errored ? RefreshResult.success() : RefreshResult.failure(fetchResult.errorMessage, fetchResult.errorException);
    };
    /** Creates an instance of the `RefreshResult` class which indicates that the operation was successful. */ RefreshResult.success = function() {
        return new RefreshResult(null);
    };
    /** Creates an instance of the `RefreshResult` class which indicates that the operation failed. */ RefreshResult.failure = function(errorMessage, errorException) {
        return new RefreshResult(errorMessage, errorException);
    };
    return RefreshResult;
}();
var $e08046b0dfb2f9d8$export$b8a7e8827e7432a8;
(function(ClientCacheState) {
    /** No config data is available in the internal cache. */ ClientCacheState[ClientCacheState["NoFlagData"] = 0] = "NoFlagData";
    /** Only config data provided by local flag override is available in the internal cache. */ ClientCacheState[ClientCacheState["HasLocalOverrideFlagDataOnly"] = 1] = "HasLocalOverrideFlagDataOnly";
    /** Only expired config data obtained from the external cache or the ConfigCat CDN is available in the internal cache. */ ClientCacheState[ClientCacheState["HasCachedFlagDataOnly"] = 2] = "HasCachedFlagDataOnly";
    /** Up-to-date config data obtained from the external cache or the ConfigCat CDN is available in the internal cache. */ ClientCacheState[ClientCacheState["HasUpToDateFlagData"] = 3] = "HasUpToDateFlagData";
})($e08046b0dfb2f9d8$export$b8a7e8827e7432a8 || ($e08046b0dfb2f9d8$export$b8a7e8827e7432a8 = {}));
var $e08046b0dfb2f9d8$var$ConfigServiceStatus;
(function(ConfigServiceStatus) {
    ConfigServiceStatus[ConfigServiceStatus["Online"] = 0] = "Online";
    ConfigServiceStatus[ConfigServiceStatus["Offline"] = 1] = "Offline";
    ConfigServiceStatus[ConfigServiceStatus["Disposed"] = 2] = "Disposed";
})($e08046b0dfb2f9d8$var$ConfigServiceStatus || ($e08046b0dfb2f9d8$var$ConfigServiceStatus = {}));
var $e08046b0dfb2f9d8$export$b8e3b952fa46ba90 = /** @class */ function() {
    function ConfigServiceBase(configFetcher, options) {
        this.configFetcher = configFetcher;
        this.options = options;
        this.pendingCacheSyncUp = null;
        this.pendingConfigRefresh = null;
        this.cacheKey = options.getCacheKey();
        this.configFetcher = configFetcher;
        this.options = options;
        this.status = options.offline ? $e08046b0dfb2f9d8$var$ConfigServiceStatus.Offline : $e08046b0dfb2f9d8$var$ConfigServiceStatus.Online;
    }
    ConfigServiceBase.prototype.dispose = function() {
        this.status = $e08046b0dfb2f9d8$var$ConfigServiceStatus.Disposed;
    };
    Object.defineProperty(ConfigServiceBase.prototype, "disposed", {
        get: function() {
            return this.status === $e08046b0dfb2f9d8$var$ConfigServiceStatus.Disposed;
        },
        enumerable: false,
        configurable: true
    });
    ConfigServiceBase.prototype.refreshConfigAsync = function() {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var latestConfig, _a, fetchResult, config, errorMessage;
            return (0, $ixrLi.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.syncUpWithCache()
                        ];
                    case 1:
                        latestConfig = _b.sent();
                        if (!!this.isOffline) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.refreshConfigCoreAsync(latestConfig)
                        ];
                    case 2:
                        _a = _b.sent(), fetchResult = _a[0], config = _a[1];
                        return [
                            2 /*return*/ ,
                            [
                                $e08046b0dfb2f9d8$export$e4e21a9c39f836c.from(fetchResult),
                                config
                            ]
                        ];
                    case 3:
                        if (this.options.cache instanceof (0, $8ZGXJ.ExternalConfigCache)) return [
                            2 /*return*/ ,
                            [
                                $e08046b0dfb2f9d8$export$e4e21a9c39f836c.success(),
                                latestConfig
                            ]
                        ];
                        else {
                            errorMessage = this.options.logger.configServiceCannotInitiateHttpCalls().toString();
                            return [
                                2 /*return*/ ,
                                [
                                    $e08046b0dfb2f9d8$export$e4e21a9c39f836c.failure(errorMessage),
                                    latestConfig
                                ]
                            ];
                        }
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigServiceBase.prototype.refreshConfigCoreAsync = function(latestConfig) {
        var _this = this;
        if (this.pendingConfigRefresh) // NOTE: Joiners may obtain more up-to-date config data from the external cache than the `latestConfig`
        // that was used to initiate the fetch operation. However, we ignore this possibility because we consider
        // the fetch operation result a more authentic source of truth. Although this may lead to overwriting
        // the cache with stale data, we expect this to be a temporary effect, which corrects itself eventually.
        return this.pendingConfigRefresh;
        var configRefreshPromise = function(latestConfig) {
            return (0, $ixrLi.__awaiter)(_this, void 0, void 0, function() {
                var fetchResult, shouldUpdateCache;
                return (0, $ixrLi.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.fetchAsync(latestConfig)
                            ];
                        case 1:
                            fetchResult = _a.sent();
                            shouldUpdateCache = fetchResult.status === (0, $MHqav.FetchStatus).Fetched || fetchResult.status === (0, $MHqav.FetchStatus).NotModified || fetchResult.config.timestamp > latestConfig.timestamp // is not transient error?
                             && (!fetchResult.config.isEmpty || this.options.cache.getInMemory().isEmpty);
                            if (!shouldUpdateCache) return [
                                3 /*break*/ ,
                                3
                            ];
                            // NOTE: `ExternalConfigCache.set` makes sure that the external cache is not overwritten with empty
                            // config data under any circumstances.
                            return [
                                4 /*yield*/ ,
                                this.options.cache.set(this.cacheKey, fetchResult.config)
                            ];
                        case 2:
                            // NOTE: `ExternalConfigCache.set` makes sure that the external cache is not overwritten with empty
                            // config data under any circumstances.
                            _a.sent();
                            latestConfig = fetchResult.config;
                            _a.label = 3;
                        case 3:
                            this.onConfigFetched(fetchResult.config);
                            if (fetchResult.status === (0, $MHqav.FetchStatus).Fetched) this.onConfigChanged(fetchResult.config);
                            return [
                                2 /*return*/ ,
                                [
                                    fetchResult,
                                    latestConfig
                                ]
                            ];
                    }
                });
            });
        }(latestConfig);
        this.pendingConfigRefresh = configRefreshPromise;
        try {
            configRefreshPromise.finally(function() {
                return _this.pendingConfigRefresh = null;
            });
        } catch (err) {
            this.pendingConfigRefresh = null;
            throw err;
        }
        return configRefreshPromise;
    };
    ConfigServiceBase.prototype.onConfigFetched = function(newConfig) {};
    ConfigServiceBase.prototype.onConfigChanged = function(newConfig) {
        var _a;
        this.options.logger.debug("config changed");
        this.options.hooks.emit("configChanged", (_a = newConfig.config) !== null && _a !== void 0 ? _a : new (0, $lpUFt.Config)({}));
    };
    ConfigServiceBase.prototype.fetchAsync = function(lastConfig) {
        var _a;
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var options, errorMessage, _b, response, configOrError, err_1;
            return (0, $ixrLi.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        options = this.options;
                        options.logger.debug("ConfigServiceBase.fetchAsync() - called.");
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchRequestAsync((_a = lastConfig.httpETag) !== null && _a !== void 0 ? _a : null)
                        ];
                    case 2:
                        _b = _c.sent(), response = _b[0], configOrError = _b[1];
                        switch(response.statusCode){
                            case 200:
                                if (!(configOrError instanceof (0, $lpUFt.Config))) {
                                    errorMessage = options.logger.fetchReceived200WithInvalidBody(configOrError).toString();
                                    options.logger.debug("ConfigServiceBase.fetchAsync(): " + response.statusCode + " " + response.reasonPhrase + " was received but the HTTP response content was invalid. Returning null.");
                                    return [
                                        2 /*return*/ ,
                                        (0, $MHqav.FetchResult).error(lastConfig, errorMessage, configOrError)
                                    ];
                                }
                                options.logger.debug("ConfigServiceBase.fetchAsync(): fetch was successful. Returning new config.");
                                return [
                                    2 /*return*/ ,
                                    (0, $MHqav.FetchResult).success(new (0, $lpUFt.ProjectConfig)(response.body, configOrError, (0, $lpUFt.ProjectConfig).generateTimestamp(), response.eTag))
                                ];
                            case 304:
                                if (lastConfig.isEmpty) {
                                    errorMessage = options.logger.fetchReceived304WhenLocalCacheIsEmpty(response.statusCode, response.reasonPhrase).toString();
                                    options.logger.debug("ConfigServiceBase.fetchAsync(): " + response.statusCode + " " + response.reasonPhrase + " was received when no config is cached locally. Returning null.");
                                    return [
                                        2 /*return*/ ,
                                        (0, $MHqav.FetchResult).error(lastConfig, errorMessage)
                                    ];
                                }
                                options.logger.debug("ConfigServiceBase.fetchAsync(): content was not modified. Returning last config with updated timestamp.");
                                return [
                                    2 /*return*/ ,
                                    (0, $MHqav.FetchResult).notModified(lastConfig.with((0, $lpUFt.ProjectConfig).generateTimestamp()))
                                ];
                            case 403:
                            case 404:
                                errorMessage = options.logger.fetchFailedDueToInvalidSdkKey(options.sdkKey).toString();
                                options.logger.debug("ConfigServiceBase.fetchAsync(): fetch was unsuccessful. Returning last config (if any) with updated timestamp.");
                                return [
                                    2 /*return*/ ,
                                    (0, $MHqav.FetchResult).error(lastConfig.with((0, $lpUFt.ProjectConfig).generateTimestamp()), errorMessage)
                                ];
                            default:
                                errorMessage = options.logger.fetchFailedDueToUnexpectedHttpResponse(response.statusCode, response.reasonPhrase).toString();
                                options.logger.debug("ConfigServiceBase.fetchAsync(): fetch was unsuccessful. Returning null.");
                                return [
                                    2 /*return*/ ,
                                    (0, $MHqav.FetchResult).error(lastConfig, errorMessage)
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _c.sent();
                        errorMessage = (err_1 instanceof (0, $MHqav.FetchError) && err_1.cause === "timeout" ? options.logger.fetchFailedDueToRequestTimeout(err_1.args[0], err_1) : options.logger.fetchFailedDueToUnexpectedError(err_1)).toString();
                        options.logger.debug("ConfigServiceBase.fetchAsync(): fetch was unsuccessful. Returning null.");
                        return [
                            2 /*return*/ ,
                            (0, $MHqav.FetchResult).error(lastConfig, errorMessage, err_1)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigServiceBase.prototype.fetchRequestAsync = function(lastETag, maxRetryCount) {
        if (maxRetryCount === void 0) maxRetryCount = 2;
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var options, retryNumber, response, config, preferences, baseUrl, redirect;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        options = this.options;
                        options.logger.debug("ConfigServiceBase.fetchRequestAsync() - called.");
                        retryNumber = 0;
                        _a.label = 1;
                    case 1:
                        options.logger.debug("ConfigServiceBase.fetchRequestAsync(): calling fetchLogic()" + (retryNumber > 0 ? ", retry " + retryNumber + "/" + maxRetryCount : ""));
                        return [
                            4 /*yield*/ ,
                            this.configFetcher.fetchLogic(options, lastETag)
                        ];
                    case 2:
                        response = _a.sent();
                        if (response.statusCode !== 200) return [
                            2 /*return*/ ,
                            [
                                response
                            ]
                        ];
                        if (!response.body) {
                            options.logger.debug("ConfigServiceBase.fetchRequestAsync(): no response body.");
                            return [
                                2 /*return*/ ,
                                [
                                    response,
                                    new Error("No response body.")
                                ]
                            ];
                        }
                        config = void 0;
                        try {
                            config = (0, $lpUFt.Config).deserialize(response.body);
                        } catch (err) {
                            options.logger.debug("ConfigServiceBase.fetchRequestAsync(): invalid response body.");
                            return [
                                2 /*return*/ ,
                                [
                                    response,
                                    err
                                ]
                            ];
                        }
                        preferences = config.preferences;
                        if (!preferences) {
                            options.logger.debug("ConfigServiceBase.fetchRequestAsync(): preferences is empty.");
                            return [
                                2 /*return*/ ,
                                [
                                    response,
                                    config
                                ]
                            ];
                        }
                        baseUrl = preferences.baseUrl;
                        // If the base_url is the same as the last called one, just return the response.
                        if (!baseUrl || baseUrl === options.baseUrl) {
                            options.logger.debug("ConfigServiceBase.fetchRequestAsync(): baseUrl OK.");
                            return [
                                2 /*return*/ ,
                                [
                                    response,
                                    config
                                ]
                            ];
                        }
                        redirect = preferences.redirectMode;
                        // If the base_url is overridden, and the redirect parameter is not 2 (force),
                        // the SDK should not redirect the calls and it just have to return the response.
                        if (options.baseUrlOverriden && redirect !== (0, $aOidd.RedirectMode).Force) {
                            options.logger.debug("ConfigServiceBase.fetchRequestAsync(): options.baseUrlOverriden && redirect !== 2.");
                            return [
                                2 /*return*/ ,
                                [
                                    response,
                                    config
                                ]
                            ];
                        }
                        options.baseUrl = baseUrl;
                        if (redirect === (0, $aOidd.RedirectMode).No) return [
                            2 /*return*/ ,
                            [
                                response,
                                config
                            ]
                        ];
                        if (redirect === (0, $aOidd.RedirectMode).Should) options.logger.dataGovernanceIsOutOfSync();
                        if (retryNumber >= maxRetryCount) {
                            options.logger.fetchFailedDueToRedirectLoop();
                            return [
                                2 /*return*/ ,
                                [
                                    response,
                                    config
                                ]
                            ];
                        }
                        _a.label = 3;
                    case 3:
                        retryNumber++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(ConfigServiceBase.prototype, "isOfflineExactly", {
        get: function() {
            return this.status === $e08046b0dfb2f9d8$var$ConfigServiceStatus.Offline;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigServiceBase.prototype, "isOffline", {
        get: function() {
            return this.status !== $e08046b0dfb2f9d8$var$ConfigServiceStatus.Online;
        },
        enumerable: false,
        configurable: true
    });
    ConfigServiceBase.prototype.goOnline = function() {};
    ConfigServiceBase.prototype.setOnline = function() {
        if (this.status === $e08046b0dfb2f9d8$var$ConfigServiceStatus.Offline) {
            this.goOnline();
            this.status = $e08046b0dfb2f9d8$var$ConfigServiceStatus.Online;
            this.options.logger.configServiceStatusChanged($e08046b0dfb2f9d8$var$ConfigServiceStatus[this.status]);
        } else if (this.disposed) this.options.logger.configServiceMethodHasNoEffectDueToDisposedClient("setOnline");
    };
    ConfigServiceBase.prototype.setOffline = function() {
        if (this.status === $e08046b0dfb2f9d8$var$ConfigServiceStatus.Online) {
            this.status = $e08046b0dfb2f9d8$var$ConfigServiceStatus.Offline;
            this.options.logger.configServiceStatusChanged($e08046b0dfb2f9d8$var$ConfigServiceStatus[this.status]);
        } else if (this.disposed) this.options.logger.configServiceMethodHasNoEffectDueToDisposedClient("setOffline");
    };
    ConfigServiceBase.prototype.syncUpWithCache = function() {
        var _this = this;
        var cache = this.options.cache;
        if (cache instanceof (0, $8ZGXJ.InMemoryConfigCache)) return cache.get(this.cacheKey);
        if (this.pendingCacheSyncUp) return this.pendingCacheSyncUp;
        var syncResult = cache.get(this.cacheKey);
        if (!(0, $dzur7.isPromiseLike)(syncResult)) return this.onCacheSynced(syncResult);
        var cacheSyncUpPromise = syncResult.then(function(syncResult) {
            return _this.onCacheSynced(syncResult);
        });
        this.pendingCacheSyncUp = cacheSyncUpPromise;
        try {
            cacheSyncUpPromise.finally(function() {
                return _this.pendingCacheSyncUp = null;
            });
        } catch (err) {
            this.pendingCacheSyncUp = null;
            throw err;
        }
        return cacheSyncUpPromise;
    };
    ConfigServiceBase.prototype.onCacheSynced = function(syncResult) {
        if (!Array.isArray(syncResult)) return syncResult;
        var newConfig = syncResult[0];
        if (!newConfig.isEmpty) this.onConfigChanged(newConfig);
        return newConfig;
    };
    ConfigServiceBase.prototype.getReadyPromise = function(state, waitForReadyAsync) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var cacheState;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            waitForReadyAsync(state)
                        ];
                    case 1:
                        cacheState = _a.sent();
                        this.options.hooks.emit("clientReady", cacheState);
                        return [
                            2 /*return*/ ,
                            cacheState
                        ];
                }
            });
        });
    };
    return ConfigServiceBase;
}();

});
parcelRegister("8ZGXJ", function(module, exports) {

$parcel$export(module.exports, "InMemoryConfigCache", function () { return $68c558ac49d08254$export$c666bb97319c1ed1; });
$parcel$export(module.exports, "ExternalConfigCache", function () { return $68c558ac49d08254$export$d3eee83c35444e77; });

var $ixrLi = parcelRequire("ixrLi");

var $lpUFt = parcelRequire("lpUFt");

var $dzur7 = parcelRequire("dzur7");
var $68c558ac49d08254$export$c666bb97319c1ed1 = /** @class */ function() {
    function InMemoryConfigCache() {
        this.cachedConfig = (0, $lpUFt.ProjectConfig).empty;
    }
    InMemoryConfigCache.prototype.set = function(_key, config) {
        this.cachedConfig = config;
    };
    InMemoryConfigCache.prototype.get = function(_key) {
        return this.cachedConfig;
    };
    InMemoryConfigCache.prototype.getInMemory = function() {
        return this.cachedConfig;
    };
    return InMemoryConfigCache;
}();
var $68c558ac49d08254$export$d3eee83c35444e77 = /** @class */ function() {
    function ExternalConfigCache(cache, logger) {
        this.cache = cache;
        this.logger = logger;
        this.cachedConfig = (0, $lpUFt.ProjectConfig).empty;
    }
    ExternalConfigCache.prototype.set = function(key, config) {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            var err_1;
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!config.isEmpty) {
                            this.cachedSerializedConfig = (0, $lpUFt.ProjectConfig).serialize(config);
                            this.cachedConfig = config;
                        } else {
                            // We may have empty entries with timestamp > 0 (see the flooding prevention logic in ConfigServiceBase.fetchAsync).
                            // In such cases we want to preserve the timestamp locally but don't want to store those entries into the external cache.
                            this.cachedSerializedConfig = void 0;
                            this.cachedConfig = config;
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this.cache.set(key, this.cachedSerializedConfig)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        err_1 = _a.sent();
                        this.logger.configServiceCacheWriteError(err_1);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ExternalConfigCache.prototype.updateCachedConfig = function(externalSerializedConfig) {
        if (externalSerializedConfig == null || externalSerializedConfig === this.cachedSerializedConfig) return this.cachedConfig;
        var externalConfig = (0, $lpUFt.ProjectConfig).deserialize(externalSerializedConfig);
        var hasChanged = !(0, $lpUFt.ProjectConfig).contentEquals(externalConfig, this.cachedConfig);
        this.cachedConfig = externalConfig;
        this.cachedSerializedConfig = externalSerializedConfig;
        return hasChanged ? [
            this.cachedConfig
        ] : this.cachedConfig;
    };
    ExternalConfigCache.prototype.get = function(key) {
        var _this = this;
        var cacheSyncResult;
        try {
            var cacheGetResult = this.cache.get(key);
            // Take the async path only when the IConfigCatCache.get operation is asynchronous.
            if ((0, $dzur7.isPromiseLike)(cacheGetResult)) return function(cacheGetPromise) {
                return (0, $ixrLi.__awaiter)(_this, void 0, void 0, function() {
                    var cacheSyncResult, _a, err_2;
                    return (0, $ixrLi.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _b.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _a = this.updateCachedConfig;
                                return [
                                    4 /*yield*/ ,
                                    cacheGetPromise
                                ];
                            case 1:
                                cacheSyncResult = _a.apply(this, [
                                    _b.sent()
                                ]);
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_2 = _b.sent();
                                cacheSyncResult = this.cachedConfig;
                                this.logger.configServiceCacheReadError(err_2);
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                return [
                                    2 /*return*/ ,
                                    cacheSyncResult
                                ];
                        }
                    });
                });
            }(cacheGetResult);
            // Otherwise, keep the code flow synchronous so the config services can sync up
            // with the cache in their ctors synchronously (see ConfigServiceBase.syncUpWithCache).
            cacheSyncResult = this.updateCachedConfig(cacheGetResult);
        } catch (err) {
            cacheSyncResult = this.cachedConfig;
            this.logger.configServiceCacheReadError(err);
        }
        return cacheSyncResult;
    };
    ExternalConfigCache.prototype.getInMemory = function() {
        return this.cachedConfig;
    };
    return ExternalConfigCache;
}();

});
parcelRegister("lpUFt", function(module, exports) {

$parcel$export(module.exports, "ProjectConfig", function () { return $f977e3d956834f0f$export$3c1fe5323954457b; });
$parcel$export(module.exports, "Config", function () { return $f977e3d956834f0f$export$29cd7b75162a9425; });
$parcel$export(module.exports, "Setting", function () { return $f977e3d956834f0f$export$805dc0bee9369f09; });

var $ixrLi = parcelRequire("ixrLi");
var $f977e3d956834f0f$export$3c1fe5323954457b = /** @class */ function() {
    function ProjectConfig(configJson, config, timestamp, httpETag) {
        this.configJson = configJson;
        this.config = config;
        this.timestamp = timestamp;
        this.httpETag = httpETag;
    }
    ProjectConfig.contentEquals = function(projectConfig1, projectConfig2) {
        // When both ETags are available, we don't need to check the JSON content.
        return projectConfig1.httpETag && projectConfig2.httpETag ? projectConfig1.httpETag === projectConfig2.httpETag : projectConfig1.configJson === projectConfig2.configJson;
    };
    ProjectConfig.prototype.with = function(timestamp) {
        return new ProjectConfig(this.configJson, this.config, timestamp, this.httpETag);
    };
    Object.defineProperty(ProjectConfig.prototype, "isEmpty", {
        get: function() {
            return !this.config;
        },
        enumerable: false,
        configurable: true
    });
    ProjectConfig.prototype.isExpired = function(expirationMs) {
        return this === ProjectConfig.empty || this.timestamp + expirationMs < ProjectConfig.generateTimestamp();
    };
    ProjectConfig.generateTimestamp = function() {
        return new Date().getTime();
    };
    ProjectConfig.serialize = function(config) {
        var _a, _b;
        return config.timestamp + "\n" + ((_a = config.httpETag) !== null && _a !== void 0 ? _a : "") + "\n" + ((_b = config.configJson) !== null && _b !== void 0 ? _b : "");
    };
    ProjectConfig.deserialize = function(value) {
        var separatorIndices = Array(2);
        var index = 0;
        for(var i = 0; i < separatorIndices.length; i++){
            index = value.indexOf("\n", index);
            if (index < 0) throw new Error("Number of values is fewer than expected.");
            separatorIndices[i] = index++;
        }
        var endIndex = separatorIndices[0];
        var slice = value.substring(0, endIndex);
        var fetchTime = parseInt(slice);
        if (isNaN(fetchTime)) throw new Error("Invalid fetch time: " + slice);
        index = endIndex + 1;
        endIndex = separatorIndices[1];
        slice = value.substring(index, endIndex);
        var httpETag = slice.length > 0 ? slice : void 0;
        index = endIndex + 1;
        slice = value.substring(index);
        var config;
        var configJson;
        if (slice.length > 0) {
            config = $f977e3d956834f0f$export$29cd7b75162a9425.deserialize(slice);
            configJson = slice;
        }
        return new ProjectConfig(configJson, config, fetchTime, httpETag);
    };
    ProjectConfig.serializationFormatVersion = "v2";
    ProjectConfig.empty = new ProjectConfig(void 0, void 0, 0, void 0);
    return ProjectConfig;
}();
var $f977e3d956834f0f$export$29cd7b75162a9425 = /** @class */ function() {
    function Config(json) {
        var _this = this;
        var _a, _b;
        this.preferences = json.p != null ? new $f977e3d956834f0f$export$6b7b6cff4ccb438b(json.p) : void 0;
        this.segments = (_b = (_a = json.s) === null || _a === void 0 ? void 0 : _a.map(function(item) {
            return new $f977e3d956834f0f$export$d53aa5c5ab432700(item);
        })) !== null && _b !== void 0 ? _b : [];
        this.settings = json.f != null ? Object.fromEntries(Object.entries(json.f).map(function(_a) {
            var key = _a[0], value = _a[1];
            return [
                key,
                new $f977e3d956834f0f$export$805dc0bee9369f09(value, _this)
            ];
        })) : {};
    }
    Config.deserialize = function(configJson) {
        var configJsonParsed = JSON.parse(configJson);
        if (typeof configJsonParsed !== "object" || !configJsonParsed) throw new Error("Invalid config JSON content:" + configJson);
        return new Config(configJsonParsed);
    };
    Object.defineProperty(Config.prototype, "salt", {
        get: function() {
            var _a;
            return (_a = this.preferences) === null || _a === void 0 ? void 0 : _a.salt;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}();
var $f977e3d956834f0f$export$6b7b6cff4ccb438b = /** @class */ function() {
    function Preferences(json) {
        this.baseUrl = json.u;
        this.redirectMode = json.r;
        this.salt = json.s;
    }
    return Preferences;
}();
var $f977e3d956834f0f$export$d53aa5c5ab432700 = /** @class */ function() {
    function Segment(json) {
        var _a, _b;
        this.name = json.n;
        this.conditions = (_b = (_a = json.r) === null || _a === void 0 ? void 0 : _a.map(function(item) {
            return new $f977e3d956834f0f$export$e291cfbaed34c98d(item);
        })) !== null && _b !== void 0 ? _b : [];
    }
    return Segment;
}();
var $f977e3d956834f0f$export$9e4dc60a86ca4da3 = /** @class */ function() {
    function SettingValueContainer(json, hasUnwrappedValue) {
        if (hasUnwrappedValue === void 0) hasUnwrappedValue = false;
        this.value = !hasUnwrappedValue ? $f977e3d956834f0f$var$unwrapSettingValue(json.v) : json.v;
        this.variationId = json.i;
    }
    return SettingValueContainer;
}();
var $f977e3d956834f0f$export$805dc0bee9369f09 = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(Setting, _super);
    function Setting(json, config) {
        var _a, _b, _c, _d, _e, _f;
        var _this = _super.call(this, json, json.t < 0) || this;
        _this.type = json.t;
        var identifierAttribute = "Identifier";
        _this.percentageOptionsAttribute = (_a = json.a) !== null && _a !== void 0 ? _a : identifierAttribute;
        _this.targetingRules = (_c = (_b = json.r) === null || _b === void 0 ? void 0 : _b.map(function(item) {
            return new $f977e3d956834f0f$export$2d5390721da8c2cb(item, config);
        })) !== null && _c !== void 0 ? _c : [];
        _this.percentageOptions = (_e = (_d = json.p) === null || _d === void 0 ? void 0 : _d.map(function(item) {
            return new $f977e3d956834f0f$export$ce4c7feaa3eaa52d(item);
        })) !== null && _e !== void 0 ? _e : [];
        _this.configJsonSalt = (_f = config === null || config === void 0 ? void 0 : config.salt) !== null && _f !== void 0 ? _f : "";
        return _this;
    }
    Setting.fromValue = function(value) {
        return new Setting({
            t: -1,
            v: value
        });
    };
    return Setting;
}($f977e3d956834f0f$export$9e4dc60a86ca4da3);
var $f977e3d956834f0f$export$2d5390721da8c2cb = /** @class */ function() {
    function TargetingRule(json, config) {
        var _a, _b;
        this.conditions = (_b = (_a = json.c) === null || _a === void 0 ? void 0 : _a.map(function(item) {
            return item.u != null ? new $f977e3d956834f0f$export$e291cfbaed34c98d(item.u) : item.p != null ? new $f977e3d956834f0f$export$4347e9bd13e5ea9c(item.p) : item.s != null ? new $f977e3d956834f0f$export$f7ead1dd5da36ad1(item.s, config) : void 0;
        })) !== null && _b !== void 0 ? _b : [];
        this.then = json.p != null ? json.p.map(function(item) {
            return new $f977e3d956834f0f$export$ce4c7feaa3eaa52d(item);
        }) : new $f977e3d956834f0f$export$9e4dc60a86ca4da3(json.s);
    }
    return TargetingRule;
}();
var $f977e3d956834f0f$export$ce4c7feaa3eaa52d = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(PercentageOption, _super);
    function PercentageOption(json) {
        var _this = _super.call(this, json) || this;
        _this.percentage = json.p;
        return _this;
    }
    return PercentageOption;
}($f977e3d956834f0f$export$9e4dc60a86ca4da3);
var $f977e3d956834f0f$export$e291cfbaed34c98d = /** @class */ function() {
    function UserCondition(json) {
        var _a, _b;
        this.type = "UserCondition";
        this.comparisonAttribute = json.a;
        this.comparator = json.c;
        this.comparisonValue = (_b = (_a = json.s) !== null && _a !== void 0 ? _a : json.d) !== null && _b !== void 0 ? _b : json.l;
    }
    return UserCondition;
}();
var $f977e3d956834f0f$export$4347e9bd13e5ea9c = /** @class */ function() {
    function PrerequisiteFlagCondition(json) {
        this.type = "PrerequisiteFlagCondition";
        this.prerequisiteFlagKey = json.f;
        this.comparator = json.c;
        this.comparisonValue = $f977e3d956834f0f$var$unwrapSettingValue(json.v);
    }
    return PrerequisiteFlagCondition;
}();
var $f977e3d956834f0f$export$f7ead1dd5da36ad1 = /** @class */ function() {
    function SegmentCondition(json, config) {
        this.type = "SegmentCondition";
        this.segment = config.segments[json.s];
        this.comparator = json.c;
    }
    return SegmentCondition;
}();
function $f977e3d956834f0f$var$unwrapSettingValue(json) {
    var _a, _b, _c;
    return (_c = (_b = (_a = json.b) !== null && _a !== void 0 ? _a : json.s) !== null && _b !== void 0 ? _b : json.i) !== null && _c !== void 0 ? _c : json.d;
}

});

parcelRegister("dzur7", function(module, exports) {

$parcel$export(module.exports, "AbortToken", function () { return $9e1627440b2933c3$export$1f0297554524896f; });
$parcel$export(module.exports, "delay", function () { return $9e1627440b2933c3$export$1391212d75b2ee65; });
$parcel$export(module.exports, "getMonotonicTimeMs", function () { return $9e1627440b2933c3$export$5957dec76d809ec5; });
$parcel$export(module.exports, "errorToString", function () { return $9e1627440b2933c3$export$46c1952d522542d7; });
$parcel$export(module.exports, "throwError", function () { return $9e1627440b2933c3$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "isObject", function () { return $9e1627440b2933c3$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isArray", function () { return $9e1627440b2933c3$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isStringArray", function () { return $9e1627440b2933c3$export$f6e922e536d8305c; });
$parcel$export(module.exports, "formatStringList", function () { return $9e1627440b2933c3$export$462b00dc9e6b5f46; });
$parcel$export(module.exports, "isPromiseLike", function () { return $9e1627440b2933c3$export$ae936b9d47e5870e; });
$parcel$export(module.exports, "utf8Encode", function () { return $9e1627440b2933c3$export$e1b32e613f230dc6; });
$parcel$export(module.exports, "parseFloatStrict", function () { return $9e1627440b2933c3$export$63b1a38eb307b18b; });
$parcel$export(module.exports, "shallowClone", function () { return $9e1627440b2933c3$export$370e8311c3cdebd9; });
// NOTE: Normally, we'd just use AbortController/AbortSignal, however that may not be available on all platforms,
// and we don't want to include a complete polyfill. So we implement a simplified version that fits our use case.
var $9e1627440b2933c3$export$1f0297554524896f = /** @class */ function() {
    function AbortToken() {
        this.callbacks = [];
    }
    Object.defineProperty(AbortToken.prototype, "aborted", {
        get: function() {
            return !this.callbacks;
        },
        enumerable: false,
        configurable: true
    });
    AbortToken.prototype.abort = function() {
        if (!this.aborted) {
            var callbacks = this.callbacks;
            this.callbacks = null;
            for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
                var callback = callbacks_1[_i];
                callback();
            }
        }
    };
    AbortToken.prototype.registerCallback = function(callback) {
        var _this = this;
        if (this.aborted) {
            callback();
            return function() {};
        }
        this.callbacks.push(callback);
        return function() {
            var callbacks = _this.callbacks;
            var index;
            if (callbacks && (index = callbacks.indexOf(callback)) >= 0) callbacks.splice(index, 1);
        };
    };
    return AbortToken;
}();
function $9e1627440b2933c3$export$1391212d75b2ee65(delayMs, abortToken) {
    var timerId;
    return new Promise(function(resolve) {
        var unregisterAbortCallback = abortToken === null || abortToken === void 0 ? void 0 : abortToken.registerCallback(function() {
            clearTimeout(timerId);
            resolve(false);
        });
        timerId = setTimeout(function() {
            unregisterAbortCallback === null || unregisterAbortCallback === void 0 || unregisterAbortCallback();
            resolve(true);
        }, delayMs);
    });
}
var $9e1627440b2933c3$export$5957dec76d809ec5 = typeof performance !== "undefined" && typeof performance.now === "function" ? function() {
    return performance.now();
} : function() {
    return new Date().getTime();
};
function $9e1627440b2933c3$export$46c1952d522542d7(err, includeStackTrace) {
    if (includeStackTrace === void 0) includeStackTrace = false;
    return err instanceof Error ? visit(err, "") : "" + err;
    function visit(err, indent, visited) {
        var errString = err.toString();
        var s = (!indent ? indent : indent.substring(4) + "--> ") + errString;
        if (includeStackTrace && err.stack) {
            var stack = err.stack.trim();
            // NOTE: Some JS runtimes (e.g. V8) includes the error in the stack trace, some don't (e.g. SpiderMonkey).
            if (stack.lastIndexOf(errString, 0) === 0) stack = stack.substring(errString.length).trim();
            s += "\n" + stack.replace(/^\s*(?:at\s)?/gm, indent + "    at ");
        }
        if (typeof AggregateError !== "undefined" && err instanceof AggregateError) {
            (visited !== null && visited !== void 0 ? visited : visited = []).push(err);
            for(var _i = 0, _a = err.errors; _i < _a.length; _i++){
                var innerErr = _a[_i];
                if (innerErr instanceof Error) {
                    if (visited.indexOf(innerErr) >= 0) continue;
                    s += "\n" + visit(innerErr, indent + "    ", visited);
                } else s += "\n" + indent + "--> " + innerErr;
            }
            visited.pop();
        }
        return s;
    }
}
function $9e1627440b2933c3$export$8bf7aba4a9e09055(err) {
    throw err;
}
function $9e1627440b2933c3$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === "object" && !$9e1627440b2933c3$export$43bee75e5e14138e(value);
}
function $9e1627440b2933c3$export$43bee75e5e14138e(value) {
    // See also: https://github.com/microsoft/TypeScript/issues/17002#issuecomment-1477626624
    return Array.isArray(value);
}
function $9e1627440b2933c3$export$f6e922e536d8305c(value) {
    return $9e1627440b2933c3$export$43bee75e5e14138e(value) && !value.some(function(item) {
        return typeof item !== "string";
    });
}
function $9e1627440b2933c3$export$462b00dc9e6b5f46(items, maxLength, getOmittedItemsText, separator) {
    if (maxLength === void 0) maxLength = 0;
    if (separator === void 0) separator = ", ";
    var length = items.length;
    if (!length) return "";
    var appendix = "";
    if (maxLength > 0 && length > maxLength) {
        items = items.slice(0, maxLength);
        if (getOmittedItemsText) appendix = getOmittedItemsText(length - maxLength);
    }
    return "'" + items.join("'" + separator + "'") + "'" + appendix;
}
function $9e1627440b2933c3$export$ae936b9d47e5870e(obj) {
    var _a;
    // See also: https://stackoverflow.com/a/27746324/8656352
    return typeof ((_a = obj) === null || _a === void 0 ? void 0 : _a.then) === "function";
}
function $9e1627440b2933c3$export$e1b32e613f230dc6(text) {
    function codePointAt(text, index) {
        var ch = text.charCodeAt(index);
        if (0xD800 <= ch && ch < 0xDC00) {
            var nextCh = text.charCodeAt(index + 1);
            if (0xDC00 <= nextCh && nextCh <= 0xDFFF) return (ch << 10) + nextCh - 0x35FDC00;
        }
        return ch;
    }
    var utf8text = "", chunkStart = 0;
    var fromCharCode = String.fromCharCode;
    var i;
    for(i = 0; i < text.length; i++){
        var cp = codePointAt(text, i);
        if (cp <= 0x7F) continue;
        // See also: https://stackoverflow.com/a/6240184/8656352
        utf8text += text.slice(chunkStart, i);
        if (cp <= 0x7FF) {
            utf8text += fromCharCode(0xC0 | cp >> 6);
            utf8text += fromCharCode(0x80 | cp & 0x3F);
        } else if (cp <= 0xFFFF) {
            utf8text += fromCharCode(0xE0 | cp >> 12);
            utf8text += fromCharCode(0x80 | cp >> 6 & 0x3F);
            utf8text += fromCharCode(0x80 | cp & 0x3F);
        } else {
            utf8text += fromCharCode(0xF0 | cp >> 18);
            utf8text += fromCharCode(0x80 | cp >> 12 & 0x3F);
            utf8text += fromCharCode(0x80 | cp >> 6 & 0x3F);
            utf8text += fromCharCode(0x80 | cp & 0x3F);
            ++i;
        }
        chunkStart = i + 1;
    }
    return utf8text += text.slice(chunkStart, i);
}
function $9e1627440b2933c3$export$63b1a38eb307b18b(value) {
    // NOTE: JS's float to string conversion is too forgiving, it accepts hex numbers and ignores invalid characters after the number.
    if (typeof value === "number") return value;
    if (typeof value !== "string" || !value.length || /^\s*$|^\s*0[^\d.eE]/.test(value)) return NaN;
    return +value;
}
function $9e1627440b2933c3$export$370e8311c3cdebd9(obj, propertyReplacer) {
    var clone = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var value = obj[key];
        clone[key] = propertyReplacer ? propertyReplacer(key, value) : value;
    }
    return clone;
}

});


parcelRegister("MHqav", function(module, exports) {

$parcel$export(module.exports, "FetchStatus", function () { return $09262a5481573dfc$export$343debacecd20c13; });
$parcel$export(module.exports, "FetchResult", function () { return $09262a5481573dfc$export$d1397a0be8364ab6; });
$parcel$export(module.exports, "FetchError", function () { return $09262a5481573dfc$export$26e841bcf1aeb894; });

var $ixrLi = parcelRequire("ixrLi");
var $09262a5481573dfc$export$343debacecd20c13;
(function(FetchStatus) {
    FetchStatus[FetchStatus["Fetched"] = 0] = "Fetched";
    FetchStatus[FetchStatus["NotModified"] = 1] = "NotModified";
    FetchStatus[FetchStatus["Errored"] = 2] = "Errored";
})($09262a5481573dfc$export$343debacecd20c13 || ($09262a5481573dfc$export$343debacecd20c13 = {}));
var $09262a5481573dfc$export$d1397a0be8364ab6 = /** @class */ function() {
    function FetchResult(status, config, errorMessage, errorException) {
        this.status = status;
        this.config = config;
        this.errorMessage = errorMessage;
        this.errorException = errorException;
    }
    FetchResult.success = function(config) {
        return new FetchResult($09262a5481573dfc$export$343debacecd20c13.Fetched, config);
    };
    FetchResult.notModified = function(config) {
        return new FetchResult($09262a5481573dfc$export$343debacecd20c13.NotModified, config);
    };
    FetchResult.error = function(config, errorMessage, errorException) {
        return new FetchResult($09262a5481573dfc$export$343debacecd20c13.Errored, config, errorMessage !== null && errorMessage !== void 0 ? errorMessage : "Unknown error.", errorException);
    };
    return FetchResult;
}();
var $09262a5481573dfc$export$26e841bcf1aeb894 = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(FetchError, _super);
    function FetchError(cause) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _this = _super.call(this, function(cause, args) {
            switch(cause){
                case "abort":
                    return "Request was aborted.";
                case "timeout":
                    var timeoutMs = args[0];
                    return "Request timed out. Timeout value: " + timeoutMs + "ms";
                case "failure":
                    var err = args[0];
                    var message = "Request failed due to a network or protocol error.";
                    return err ? message + " " + (err instanceof Error ? err.message : err + "") : message;
            }
        }(cause, args)) || this;
        _this.cause = cause;
        _this.name = FetchError.name;
        // NOTE: due to a known issue in the TS compiler, instanceof is broken when subclassing Error and targeting ES5 or earlier
        // (see https://github.com/microsoft/TypeScript/issues/13965).
        // Thus, we need to manually fix the prototype chain as recommended in the TS docs
        // (see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work)
        if (!(_this instanceof FetchError)) (Object.setPrototypeOf || function(o, proto) {
            return o["__proto__"] = proto;
        })(_this, FetchError.prototype);
        _this.args = args;
        return _this;
    }
    return FetchError;
}(Error);

});

parcelRegister("aOidd", function(module, exports) {

$parcel$export(module.exports, "RedirectMode", function () { return $7decb3725a8f09f4$export$2a9df83409c0d596; });
$parcel$export(module.exports, "SettingType", function () { return $7decb3725a8f09f4$export$36badde56bb9eac3; });
$parcel$export(module.exports, "UserComparator", function () { return $7decb3725a8f09f4$export$586026e52d852798; });
$parcel$export(module.exports, "PrerequisiteFlagComparator", function () { return $7decb3725a8f09f4$export$9f1f43cd6b9ae2ed; });
$parcel$export(module.exports, "SegmentComparator", function () { return $7decb3725a8f09f4$export$b887c0a639abaad2; });
/**
 * The ConfigCat config_v6.json schema that is used by the ConfigCat SDKs, described using TypeScript types.
 */ var $7decb3725a8f09f4$export$2a9df83409c0d596;
(function(RedirectMode) {
    RedirectMode[RedirectMode["No"] = 0] = "No";
    RedirectMode[RedirectMode["Should"] = 1] = "Should";
    RedirectMode[RedirectMode["Force"] = 2] = "Force";
})($7decb3725a8f09f4$export$2a9df83409c0d596 || ($7decb3725a8f09f4$export$2a9df83409c0d596 = {}));
var $7decb3725a8f09f4$export$36badde56bb9eac3;
(function(SettingType) {
    /** On/off type (feature flag). */ SettingType[SettingType["Boolean"] = 0] = "Boolean";
    /** Text type. */ SettingType[SettingType["String"] = 1] = "String";
    /** Whole number type. */ SettingType[SettingType["Int"] = 2] = "Int";
    /** Decimal number type. */ SettingType[SettingType["Double"] = 3] = "Double";
})($7decb3725a8f09f4$export$36badde56bb9eac3 || ($7decb3725a8f09f4$export$36badde56bb9eac3 = {}));
var $7decb3725a8f09f4$export$586026e52d852798;
(function(UserComparator) {
    /** IS ONE OF (cleartext) - Checks whether the comparison attribute is equal to any of the comparison values. */ UserComparator[UserComparator["TextIsOneOf"] = 0] = "TextIsOneOf";
    /** IS NOT ONE OF (cleartext) - Checks whether the comparison attribute is not equal to any of the comparison values. */ UserComparator[UserComparator["TextIsNotOneOf"] = 1] = "TextIsNotOneOf";
    /** CONTAINS ANY OF (cleartext) - Checks whether the comparison attribute contains any comparison values as a substring. */ UserComparator[UserComparator["TextContainsAnyOf"] = 2] = "TextContainsAnyOf";
    /** NOT CONTAINS ANY OF (cleartext) - Checks whether the comparison attribute does not contain any comparison values as a substring. */ UserComparator[UserComparator["TextNotContainsAnyOf"] = 3] = "TextNotContainsAnyOf";
    /** IS ONE OF (semver) - Checks whether the comparison attribute interpreted as a semantic version is equal to any of the comparison values. */ UserComparator[UserComparator["SemVerIsOneOf"] = 4] = "SemVerIsOneOf";
    /** IS NOT ONE OF (semver) - Checks whether the comparison attribute interpreted as a semantic version is not equal to any of the comparison values. */ UserComparator[UserComparator["SemVerIsNotOneOf"] = 5] = "SemVerIsNotOneOf";
    /** &lt; (semver) - Checks whether the comparison attribute interpreted as a semantic version is less than the comparison value. */ UserComparator[UserComparator["SemVerLess"] = 6] = "SemVerLess";
    /** &lt;= (semver) - Checks whether the comparison attribute interpreted as a semantic version is less than or equal to the comparison value. */ UserComparator[UserComparator["SemVerLessOrEquals"] = 7] = "SemVerLessOrEquals";
    /** &gt; (semver) - Checks whether the comparison attribute interpreted as a semantic version is greater than the comparison value. */ UserComparator[UserComparator["SemVerGreater"] = 8] = "SemVerGreater";
    /** &gt;= (semver) - Checks whether the comparison attribute interpreted as a semantic version is greater than or equal to the comparison value. */ UserComparator[UserComparator["SemVerGreaterOrEquals"] = 9] = "SemVerGreaterOrEquals";
    /** = (number) - Checks whether the comparison attribute interpreted as a decimal number is equal to the comparison value. */ UserComparator[UserComparator["NumberEquals"] = 10] = "NumberEquals";
    /** != (number) - Checks whether the comparison attribute interpreted as a decimal number is not equal to the comparison value. */ UserComparator[UserComparator["NumberNotEquals"] = 11] = "NumberNotEquals";
    /** &lt; (number) - Checks whether the comparison attribute interpreted as a decimal number is less than the comparison value. */ UserComparator[UserComparator["NumberLess"] = 12] = "NumberLess";
    /** &lt;= (number) - Checks whether the comparison attribute interpreted as a decimal number is less than or equal to the comparison value. */ UserComparator[UserComparator["NumberLessOrEquals"] = 13] = "NumberLessOrEquals";
    /** &gt; (number) - Checks whether the comparison attribute interpreted as a decimal number is greater than the comparison value. */ UserComparator[UserComparator["NumberGreater"] = 14] = "NumberGreater";
    /** &gt;= (number) - Checks whether the comparison attribute interpreted as a decimal number is greater than or equal to the comparison value. */ UserComparator[UserComparator["NumberGreaterOrEquals"] = 15] = "NumberGreaterOrEquals";
    /** IS ONE OF (hashed) - Checks whether the comparison attribute is equal to any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextIsOneOf"] = 16] = "SensitiveTextIsOneOf";
    /** IS NOT ONE OF (hashed) - Checks whether the comparison attribute is not equal to any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextIsNotOneOf"] = 17] = "SensitiveTextIsNotOneOf";
    /** BEFORE (UTC datetime) - Checks whether the comparison attribute interpreted as the seconds elapsed since <see href="https://en.wikipedia.org/wiki/Unix_time">Unix Epoch</see> is less than the comparison value. */ UserComparator[UserComparator["DateTimeBefore"] = 18] = "DateTimeBefore";
    /** AFTER (UTC datetime) - Checks whether the comparison attribute interpreted as the seconds elapsed since <see href="https://en.wikipedia.org/wiki/Unix_time">Unix Epoch</see> is greater than the comparison value. */ UserComparator[UserComparator["DateTimeAfter"] = 19] = "DateTimeAfter";
    /** EQUALS (hashed) - Checks whether the comparison attribute is equal to the comparison value (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextEquals"] = 20] = "SensitiveTextEquals";
    /** NOT EQUALS (hashed) - Checks whether the comparison attribute is not equal to the comparison value (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextNotEquals"] = 21] = "SensitiveTextNotEquals";
    /** STARTS WITH ANY OF (hashed) - Checks whether the comparison attribute starts with any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextStartsWithAnyOf"] = 22] = "SensitiveTextStartsWithAnyOf";
    /** NOT STARTS WITH ANY OF (hashed) - Checks whether the comparison attribute does not start with any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextNotStartsWithAnyOf"] = 23] = "SensitiveTextNotStartsWithAnyOf";
    /** ENDS WITH ANY OF (hashed) - Checks whether the comparison attribute ends with any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextEndsWithAnyOf"] = 24] = "SensitiveTextEndsWithAnyOf";
    /** NOT ENDS WITH ANY OF (hashed) - Checks whether the comparison attribute does not end with any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveTextNotEndsWithAnyOf"] = 25] = "SensitiveTextNotEndsWithAnyOf";
    /** ARRAY CONTAINS ANY OF (hashed) - Checks whether the comparison attribute interpreted as a comma-separated list contains any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveArrayContainsAnyOf"] = 26] = "SensitiveArrayContainsAnyOf";
    /** ARRAY NOT CONTAINS ANY OF (hashed) - Checks whether the comparison attribute interpreted as a comma-separated list does not contain any of the comparison values (where the comparison is performed using the salted SHA256 hashes of the values). */ UserComparator[UserComparator["SensitiveArrayNotContainsAnyOf"] = 27] = "SensitiveArrayNotContainsAnyOf";
    /** EQUALS (cleartext) - Checks whether the comparison attribute is equal to the comparison value. */ UserComparator[UserComparator["TextEquals"] = 28] = "TextEquals";
    /** NOT EQUALS (cleartext) - Checks whether the comparison attribute is not equal to the comparison value. */ UserComparator[UserComparator["TextNotEquals"] = 29] = "TextNotEquals";
    /** STARTS WITH ANY OF (cleartext) - Checks whether the comparison attribute starts with any of the comparison values. */ UserComparator[UserComparator["TextStartsWithAnyOf"] = 30] = "TextStartsWithAnyOf";
    /** NOT STARTS WITH ANY OF (cleartext) - Checks whether the comparison attribute does not start with any of the comparison values. */ UserComparator[UserComparator["TextNotStartsWithAnyOf"] = 31] = "TextNotStartsWithAnyOf";
    /** ENDS WITH ANY OF (cleartext) - Checks whether the comparison attribute ends with any of the comparison values. */ UserComparator[UserComparator["TextEndsWithAnyOf"] = 32] = "TextEndsWithAnyOf";
    /** NOT ENDS WITH ANY OF (cleartext) - Checks whether the comparison attribute does not end with any of the comparison values. */ UserComparator[UserComparator["TextNotEndsWithAnyOf"] = 33] = "TextNotEndsWithAnyOf";
    /** ARRAY CONTAINS ANY OF (cleartext) - Checks whether the comparison attribute interpreted as a comma-separated list contains any of the comparison values. */ UserComparator[UserComparator["ArrayContainsAnyOf"] = 34] = "ArrayContainsAnyOf";
    /** ARRAY NOT CONTAINS ANY OF (cleartext) - Checks whether the comparison attribute interpreted as a comma-separated list does not contain any of the comparison values. */ UserComparator[UserComparator["ArrayNotContainsAnyOf"] = 35] = "ArrayNotContainsAnyOf";
})($7decb3725a8f09f4$export$586026e52d852798 || ($7decb3725a8f09f4$export$586026e52d852798 = {}));
var $7decb3725a8f09f4$export$9f1f43cd6b9ae2ed;
(function(PrerequisiteFlagComparator) {
    /** EQUALS - Checks whether the evaluated value of the specified prerequisite flag is equal to the comparison value. */ PrerequisiteFlagComparator[PrerequisiteFlagComparator["Equals"] = 0] = "Equals";
    /** NOT EQUALS - Checks whether the evaluated value of the specified prerequisite flag is not equal to the comparison value. */ PrerequisiteFlagComparator[PrerequisiteFlagComparator["NotEquals"] = 1] = "NotEquals";
})($7decb3725a8f09f4$export$9f1f43cd6b9ae2ed || ($7decb3725a8f09f4$export$9f1f43cd6b9ae2ed = {}));
var $7decb3725a8f09f4$export$b887c0a639abaad2;
(function(SegmentComparator) {
    /** IS IN SEGMENT - Checks whether the conditions of the specified segment are evaluated to true. */ SegmentComparator[SegmentComparator["IsIn"] = 0] = "IsIn";
    /** IS NOT IN SEGMENT - Checks whether the conditions of the specified segment are evaluated to false. */ SegmentComparator[SegmentComparator["IsNotIn"] = 1] = "IsNotIn";
})($7decb3725a8f09f4$export$b887c0a639abaad2 || ($7decb3725a8f09f4$export$b887c0a639abaad2 = {}));

});



parcelRegister("isReF", function(module, exports) {

$parcel$export(module.exports, "PollingMode", function () { return $d71422f9f0ac1a8c$export$f1e68d26f1bae5dc; });
$parcel$export(module.exports, "AutoPollOptions", function () { return $d71422f9f0ac1a8c$export$1f381f133c119a81; });
$parcel$export(module.exports, "ManualPollOptions", function () { return $d71422f9f0ac1a8c$export$5a7abcd2cc00b0ae; });
$parcel$export(module.exports, "LazyLoadOptions", function () { return $d71422f9f0ac1a8c$export$50caae8a2b56f562; });

var $ixrLi = parcelRequire("ixrLi");

var $8ZGXJ = parcelRequire("8ZGXJ");

var $dqDdj = parcelRequire("dqDdj");

var $cTVJM = parcelRequire("cTVJM");

var $cYGfN = parcelRequire("cYGfN");

var $by1qu = parcelRequire("by1qu");

var $4G6mW = parcelRequire("4G6mW");

var $dEOe6 = parcelRequire("dEOe6");

var $lpUFt = parcelRequire("lpUFt");
var $d71422f9f0ac1a8c$export$f1e68d26f1bae5dc;
(function(PollingMode) {
    /** The ConfigCat SDK downloads the latest config data automatically and stores it in the cache. */ PollingMode[PollingMode["AutoPoll"] = 0] = "AutoPoll";
    /** The ConfigCat SDK downloads the latest config data only if it is not present in the cache, or if it is but has expired. */ PollingMode[PollingMode["LazyLoad"] = 1] = "LazyLoad";
    /** The ConfigCat SDK will not download the config data automatically. You need to update the cache manually, by calling `forceRefreshAsync()`. */ PollingMode[PollingMode["ManualPoll"] = 2] = "ManualPoll";
})($d71422f9f0ac1a8c$export$f1e68d26f1bae5dc || ($d71422f9f0ac1a8c$export$f1e68d26f1bae5dc = {}));
var $d71422f9f0ac1a8c$export$443f6bb20448b4b7;
(function(DataGovernance) {
    /** Choose this option if your config JSON files are published to all global CDN nodes. */ DataGovernance[DataGovernance["Global"] = 0] = "Global";
    /** Choose this option if your config JSON files are published to CDN nodes only in the EU. */ DataGovernance[DataGovernance["EuOnly"] = 1] = "EuOnly";
})($d71422f9f0ac1a8c$export$443f6bb20448b4b7 || ($d71422f9f0ac1a8c$export$443f6bb20448b4b7 = {}));
/* eslint-disable @typescript-eslint/no-inferrable-types */ var $d71422f9f0ac1a8c$export$7bbb7deb1fd3ddfd = /** @class */ function() {
    function OptionsBase(sdkKey, clientVersion, options, defaultCacheFactory, eventEmitterFactory) {
        var _a, _b, _c;
        this.requestTimeoutMs = 30000;
        this.baseUrlOverriden = false;
        this.proxy = "";
        this.offline = false;
        if (!sdkKey) throw new Error("Invalid 'sdkKey' value");
        this.sdkKey = sdkKey;
        this.clientVersion = clientVersion;
        this.dataGovernance = (_a = options === null || options === void 0 ? void 0 : options.dataGovernance) !== null && _a !== void 0 ? _a : $d71422f9f0ac1a8c$export$443f6bb20448b4b7.Global;
        switch(this.dataGovernance){
            case $d71422f9f0ac1a8c$export$443f6bb20448b4b7.EuOnly:
                this.baseUrl = "https://cdn-eu.configcat.com";
                break;
            default:
                this.baseUrl = "https://cdn-global.configcat.com";
                break;
        }
        var eventEmitter = (_b = eventEmitterFactory === null || eventEmitterFactory === void 0 ? void 0 : eventEmitterFactory()) !== null && _b !== void 0 ? _b : new (0, $cTVJM.DefaultEventEmitter)();
        var hooks = new (0, $4G6mW.Hooks)(eventEmitter);
        var hooksWeakRef = new ((0, $dEOe6.isWeakRefAvailable)() ? WeakRef : (0, $dEOe6.getWeakRefStub)())(hooks);
        this.hooks = {
            hooks: hooks,
            hooksWeakRef: hooksWeakRef,
            emit: function(eventName) {
                var _a, _b;
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                return (_b = (_a = this.hooksWeakRef.deref()) === null || _a === void 0 ? void 0 : _a.emit.apply(_a, (0, $ixrLi.__spreadArrays)([
                    eventName
                ], args))) !== null && _b !== void 0 ? _b : false;
            }
        };
        var logger;
        var cache;
        if (options) {
            logger = options.logger;
            cache = options.cache;
            if (options.requestTimeoutMs) {
                if (options.requestTimeoutMs < 0) throw new Error("Invalid 'requestTimeoutMs' value");
                this.requestTimeoutMs = options.requestTimeoutMs;
            }
            if (options.baseUrl) {
                this.baseUrl = options.baseUrl;
                this.baseUrlOverriden = true;
            }
            if (options.proxy) this.proxy = options.proxy;
            if (options.flagOverrides) this.flagOverrides = options.flagOverrides;
            if (options.defaultUser) this.defaultUser = options.defaultUser;
            if (options.offline) this.offline = options.offline;
            (_c = options.setupHooks) === null || _c === void 0 || _c.call(options, hooks);
        }
        this.logger = new (0, $dqDdj.LoggerWrapper)(logger !== null && logger !== void 0 ? logger : new (0, $dqDdj.ConfigCatConsoleLogger)(), this.hooks);
        this.cache = cache ? new (0, $8ZGXJ.ExternalConfigCache)(cache, this.logger) : defaultCacheFactory ? defaultCacheFactory(this) : new (0, $8ZGXJ.InMemoryConfigCache)();
    }
    OptionsBase.prototype.yieldHooks = function() {
        var hooksWrapper = this.hooks;
        var hooks = hooksWrapper.hooks;
        delete hooksWrapper.hooks;
        return hooks !== null && hooks !== void 0 ? hooks : new (0, $4G6mW.Hooks)(new (0, $cYGfN.NullEventEmitter)());
    };
    OptionsBase.prototype.getUrl = function() {
        return this.baseUrl + "/configuration-files/" + this.sdkKey + "/" + OptionsBase.configFileName + "?sdk=" + this.clientVersion;
    };
    OptionsBase.prototype.getCacheKey = function() {
        return (0, $by1qu.sha1)(this.sdkKey + "_" + OptionsBase.configFileName + "_" + (0, $lpUFt.ProjectConfig).serializationFormatVersion);
    };
    OptionsBase.configFileName = "config_v6.json";
    return OptionsBase;
}();
var $d71422f9f0ac1a8c$export$1f381f133c119a81 = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(AutoPollOptions, _super);
    function AutoPollOptions(sdkKey, sdkType, sdkVersion, options, defaultCacheFactory, eventEmitterFactory) {
        var _this = _super.call(this, sdkKey, sdkType + "/a-" + sdkVersion, options, defaultCacheFactory, eventEmitterFactory) || this;
        _this.pollIntervalSeconds = 60;
        _this.maxInitWaitTimeSeconds = 5;
        if (options) {
            if (options.pollIntervalSeconds != null) _this.pollIntervalSeconds = options.pollIntervalSeconds;
            if (options.maxInitWaitTimeSeconds != null) _this.maxInitWaitTimeSeconds = options.maxInitWaitTimeSeconds;
        }
        // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
        // https://stackoverflow.com/a/3468650/8656352
        var maxSetTimeoutIntervalSecs = 2147483;
        if (!(typeof _this.pollIntervalSeconds === "number" && 1 <= _this.pollIntervalSeconds && _this.pollIntervalSeconds <= maxSetTimeoutIntervalSecs)) throw new Error("Invalid 'pollIntervalSeconds' value");
        if (!(typeof _this.maxInitWaitTimeSeconds === "number" && _this.maxInitWaitTimeSeconds <= maxSetTimeoutIntervalSecs)) throw new Error("Invalid 'maxInitWaitTimeSeconds' value");
        return _this;
    }
    return AutoPollOptions;
}($d71422f9f0ac1a8c$export$7bbb7deb1fd3ddfd);
var $d71422f9f0ac1a8c$export$5a7abcd2cc00b0ae = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(ManualPollOptions, _super);
    function ManualPollOptions(sdkKey, sdkType, sdkVersion, options, defaultCacheFactory, eventEmitterFactory) {
        return _super.call(this, sdkKey, sdkType + "/m-" + sdkVersion, options, defaultCacheFactory, eventEmitterFactory) || this;
    }
    return ManualPollOptions;
}($d71422f9f0ac1a8c$export$7bbb7deb1fd3ddfd);
var $d71422f9f0ac1a8c$export$50caae8a2b56f562 = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(LazyLoadOptions, _super);
    function LazyLoadOptions(sdkKey, sdkType, sdkVersion, options, defaultCacheFactory, eventEmitterFactory) {
        var _this = _super.call(this, sdkKey, sdkType + "/l-" + sdkVersion, options, defaultCacheFactory, eventEmitterFactory) || this;
        _this.cacheTimeToLiveSeconds = 60;
        if (options) {
            if (options.cacheTimeToLiveSeconds != null) _this.cacheTimeToLiveSeconds = options.cacheTimeToLiveSeconds;
        }
        if (!(typeof _this.cacheTimeToLiveSeconds === "number" && 1 <= _this.cacheTimeToLiveSeconds && _this.cacheTimeToLiveSeconds <= 2147483647)) throw new Error("Invalid 'cacheTimeToLiveSeconds' value");
        return _this;
    }
    return LazyLoadOptions;
}($d71422f9f0ac1a8c$export$7bbb7deb1fd3ddfd);

});
parcelRegister("dqDdj", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $9c6c1f17a1cba25a$export$243e62d78d3b544d; });
$parcel$export(module.exports, "LoggerWrapper", function () { return $9c6c1f17a1cba25a$export$96e53cadcbbb0f4c; });
$parcel$export(module.exports, "ConfigCatConsoleLogger", function () { return $9c6c1f17a1cba25a$export$564bc9b1c988eb49; });

var $ixrLi = parcelRequire("ixrLi");

var $dzur7 = parcelRequire("dzur7");
var $9c6c1f17a1cba25a$export$243e62d78d3b544d;
(function(LogLevel) {
    /** All events are logged. */ LogLevel[LogLevel["Debug"] = 4] = "Debug";
    /** Info, Warn and Error are logged. Debug events are discarded. */ LogLevel[LogLevel["Info"] = 3] = "Info";
    /** Warn and Error events are logged. Info and Debug events are discarded. */ LogLevel[LogLevel["Warn"] = 2] = "Warn";
    /** Error events are logged. All other events are discarded. */ LogLevel[LogLevel["Error"] = 1] = "Error";
    /** No events are logged. */ LogLevel[LogLevel["Off"] = -1] = "Off";
})($9c6c1f17a1cba25a$export$243e62d78d3b544d || ($9c6c1f17a1cba25a$export$243e62d78d3b544d = {}));
/** Represents a log message format with named arguments. */ var $9c6c1f17a1cba25a$export$f36a8af8c17b2f06 = /** @class */ function() {
    function FormattableLogMessage(strings, argNames, argValues) {
        this.strings = strings;
        this.argNames = argNames;
        this.argValues = argValues;
    }
    FormattableLogMessage.from = function() {
        var argNames = [];
        for(var _i = 0; _i < arguments.length; _i++)argNames[_i] = arguments[_i];
        return function(strings) {
            var argValues = [];
            for(var _i = 1; _i < arguments.length; _i++)argValues[_i - 1] = arguments[_i];
            return new FormattableLogMessage(strings, argNames, argValues);
        };
    };
    Object.defineProperty(FormattableLogMessage.prototype, "defaultFormattedMessage", {
        get: function() {
            var cachedMessage = this.cachedDefaultFormattedMessage;
            if (cachedMessage === void 0) {
                // This logic should give exactly the same result as string interpolation.
                cachedMessage = "";
                var _a = this, strings = _a.strings, argValues = _a.argValues;
                var i = 0;
                for(; i < strings.length - 1; i++){
                    cachedMessage += strings[i];
                    cachedMessage += argValues[i];
                }
                cachedMessage += strings[i];
                this.cachedDefaultFormattedMessage = cachedMessage;
            }
            return cachedMessage;
        },
        enumerable: false,
        configurable: true
    });
    FormattableLogMessage.prototype.toString = function() {
        return this.defaultFormattedMessage;
    };
    return FormattableLogMessage;
}();
var $9c6c1f17a1cba25a$export$96e53cadcbbb0f4c = /** @class */ function() {
    function LoggerWrapper(logger, hooks) {
        this.logger = logger;
        this.hooks = hooks;
    }
    Object.defineProperty(LoggerWrapper.prototype, "level", {
        get: function() {
            var _a;
            return (_a = this.logger.level) !== null && _a !== void 0 ? _a : $9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoggerWrapper.prototype, "eol", {
        get: function() {
            var _a;
            return (_a = this.logger.eol) !== null && _a !== void 0 ? _a : "\n";
        },
        enumerable: false,
        configurable: true
    });
    LoggerWrapper.prototype.isEnabled = function(logLevel) {
        return this.level >= logLevel;
    };
    /** @inheritdoc */ LoggerWrapper.prototype.log = function(level, eventId, message, exception) {
        var _a;
        if (this.isEnabled(level)) this.logger.log(level, eventId, message, exception);
        if (level === $9c6c1f17a1cba25a$export$243e62d78d3b544d.Error) (_a = this.hooks) === null || _a === void 0 || _a.emit("clientError", message.toString(), exception);
        return message;
    };
    /**
     * Shorthand method for `logger.logEvent(LogLevel.Debug, 0, message);`
     */ LoggerWrapper.prototype.debug = function(message) {
        this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Debug, 0, message);
    };
    /* Common error messages (1000-1999) */ LoggerWrapper.prototype.configJsonIsNotPresent = function(defaultReturnValue) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1000, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("DEFAULT_RETURN_VALUE")($9c6c1f17a1cba25a$var$templateObject_1 || ($9c6c1f17a1cba25a$var$templateObject_1 = (0, $ixrLi.__makeTemplateObject)([
            "Config JSON is not present. Returning ",
            "."
        ], [
            "Config JSON is not present. Returning ",
            "."
        ])), defaultReturnValue));
    };
    LoggerWrapper.prototype.configJsonIsNotPresentSingle = function(key, defaultParamName, defaultParamValue) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1000, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("KEY", "DEFAULT_PARAM_NAME", "DEFAULT_PARAM_VALUE")($9c6c1f17a1cba25a$var$templateObject_2 || ($9c6c1f17a1cba25a$var$templateObject_2 = (0, $ixrLi.__makeTemplateObject)([
            "Config JSON is not present when evaluating setting '",
            "'. Returning the `",
            "` parameter that you specified in your application: '",
            "'."
        ], [
            "Config JSON is not present when evaluating setting '",
            "'. Returning the \\`",
            "\\` parameter that you specified in your application: '",
            "'."
        ])), key, defaultParamName, defaultParamValue));
    };
    LoggerWrapper.prototype.settingEvaluationFailedDueToMissingKey = function(key, defaultParamName, defaultParamValue, availableKeys) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1001, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("KEY", "DEFAULT_PARAM_NAME", "DEFAULT_PARAM_VALUE", "AVAILABLE_KEYS")($9c6c1f17a1cba25a$var$templateObject_3 || ($9c6c1f17a1cba25a$var$templateObject_3 = (0, $ixrLi.__makeTemplateObject)([
            "Failed to evaluate setting '",
            "' (the key was not found in config JSON). Returning the `",
            "` parameter that you specified in your application: '",
            "'. Available keys: [",
            "]."
        ], [
            "Failed to evaluate setting '",
            "' (the key was not found in config JSON). Returning the \\`",
            "\\` parameter that you specified in your application: '",
            "'. Available keys: [",
            "]."
        ])), key, defaultParamName, defaultParamValue, availableKeys));
    };
    LoggerWrapper.prototype.settingEvaluationError = function(methodName, defaultReturnValue, ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1002, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("METHOD_NAME", "DEFAULT_RETURN_VALUE")($9c6c1f17a1cba25a$var$templateObject_4 || ($9c6c1f17a1cba25a$var$templateObject_4 = (0, $ixrLi.__makeTemplateObject)([
            "Error occurred in the `",
            "` method. Returning ",
            "."
        ], [
            "Error occurred in the \\`",
            "\\` method. Returning ",
            "."
        ])), methodName, defaultReturnValue), ex);
    };
    LoggerWrapper.prototype.settingEvaluationErrorSingle = function(methodName, key, defaultParamName, defaultParamValue, ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1002, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("METHOD_NAME", "KEY", "DEFAULT_PARAM_NAME", "DEFAULT_PARAM_VALUE")($9c6c1f17a1cba25a$var$templateObject_5 || ($9c6c1f17a1cba25a$var$templateObject_5 = (0, $ixrLi.__makeTemplateObject)([
            "Error occurred in the `",
            "` method while evaluating setting '",
            "'. Returning the `",
            "` parameter that you specified in your application: '",
            "'."
        ], [
            "Error occurred in the \\`",
            "\\` method while evaluating setting '",
            "'. Returning the \\`",
            "\\` parameter that you specified in your application: '",
            "'."
        ])), methodName, key, defaultParamName, defaultParamValue), ex);
    };
    LoggerWrapper.prototype.forceRefreshError = function(methodName, ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1003, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("METHOD_NAME")($9c6c1f17a1cba25a$var$templateObject_6 || ($9c6c1f17a1cba25a$var$templateObject_6 = (0, $ixrLi.__makeTemplateObject)([
            "Error occurred in the `",
            "` method."
        ], [
            "Error occurred in the \\`",
            "\\` method."
        ])), methodName), ex);
    };
    LoggerWrapper.prototype.fetchFailedDueToInvalidSdkKey = function(sdkKey) {
        sdkKey = $9c6c1f17a1cba25a$var$maskSdkKey(sdkKey);
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1100, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("SDK_KEY")($9c6c1f17a1cba25a$var$templateObject_7 || ($9c6c1f17a1cba25a$var$templateObject_7 = (0, $ixrLi.__makeTemplateObject)([
            "Your SDK Key seems to be wrong: '",
            "'. You can find the valid SDK Key at https://app.configcat.com/sdkkey"
        ], [
            "Your SDK Key seems to be wrong: '",
            "'. You can find the valid SDK Key at https://app.configcat.com/sdkkey"
        ])), sdkKey));
    };
    LoggerWrapper.prototype.fetchFailedDueToUnexpectedHttpResponse = function(statusCode, reasonPhrase) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1101, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("STATUS_CODE", "REASON_PHRASE")($9c6c1f17a1cba25a$var$templateObject_8 || ($9c6c1f17a1cba25a$var$templateObject_8 = (0, $ixrLi.__makeTemplateObject)([
            "Unexpected HTTP response was received while trying to fetch config JSON: ",
            " ",
            ""
        ], [
            "Unexpected HTTP response was received while trying to fetch config JSON: ",
            " ",
            ""
        ])), statusCode, reasonPhrase));
    };
    LoggerWrapper.prototype.fetchFailedDueToRequestTimeout = function(timeoutMs, ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1102, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("TIMEOUT")($9c6c1f17a1cba25a$var$templateObject_9 || ($9c6c1f17a1cba25a$var$templateObject_9 = (0, $ixrLi.__makeTemplateObject)([
            "Request timed out while trying to fetch config JSON. Timeout value: ",
            "ms"
        ], [
            "Request timed out while trying to fetch config JSON. Timeout value: ",
            "ms"
        ])), timeoutMs), ex);
    };
    LoggerWrapper.prototype.fetchFailedDueToUnexpectedError = function(ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1103, "Unexpected error occurred while trying to fetch config JSON. It is most likely due to a local network issue. Please make sure your application can reach the ConfigCat CDN servers (or your proxy server) over HTTP.", ex);
    };
    LoggerWrapper.prototype.fetchFailedDueToRedirectLoop = function() {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1104, "Redirection loop encountered while trying to fetch config JSON. Please contact us at https://configcat.com/support/");
    };
    LoggerWrapper.prototype.fetchReceived200WithInvalidBody = function(ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1105, "Fetching config JSON was successful but the HTTP response content was invalid.", ex);
    };
    LoggerWrapper.prototype.fetchReceived304WhenLocalCacheIsEmpty = function(statusCode, reasonPhrase) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1106, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("STATUS_CODE", "REASON_PHRASE")($9c6c1f17a1cba25a$var$templateObject_10 || ($9c6c1f17a1cba25a$var$templateObject_10 = (0, $ixrLi.__makeTemplateObject)([
            "Unexpected HTTP response was received when no config JSON is cached locally: ",
            " ",
            ""
        ], [
            "Unexpected HTTP response was received when no config JSON is cached locally: ",
            " ",
            ""
        ])), statusCode, reasonPhrase));
    };
    LoggerWrapper.prototype.autoPollConfigServiceErrorDuringPolling = function(ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 1200, "Error occurred during auto polling.", ex);
    };
    /* SDK-specific error messages (2000-2999) */ LoggerWrapper.prototype.settingForVariationIdIsNotPresent = function(variationId) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 2011, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("VARIATION_ID")($9c6c1f17a1cba25a$var$templateObject_11 || ($9c6c1f17a1cba25a$var$templateObject_11 = (0, $ixrLi.__makeTemplateObject)([
            "Could not find the setting for the specified variation ID: '",
            "'."
        ], [
            "Could not find the setting for the specified variation ID: '",
            "'."
        ])), variationId));
    };
    LoggerWrapper.prototype.configServiceCacheReadError = function(ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 2200, "Error occurred while reading the cache.", ex);
    };
    LoggerWrapper.prototype.configServiceCacheWriteError = function(ex) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Error, 2201, "Error occurred while writing the cache.", ex);
    };
    /* Common warning messages (3000-3999) */ LoggerWrapper.prototype.clientIsAlreadyCreated = function(sdkKey) {
        sdkKey = $9c6c1f17a1cba25a$var$maskSdkKey(sdkKey);
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3000, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("SDK_KEY")($9c6c1f17a1cba25a$var$templateObject_12 || ($9c6c1f17a1cba25a$var$templateObject_12 = (0, $ixrLi.__makeTemplateObject)([
            "There is an existing client instance for the specified SDK Key. No new client instance will be created and the specified options are ignored. Returning the existing client instance. SDK Key: '",
            "'."
        ], [
            "There is an existing client instance for the specified SDK Key. No new client instance will be created and the specified options are ignored. Returning the existing client instance. SDK Key: '",
            "'."
        ])), sdkKey));
    };
    LoggerWrapper.prototype.userObjectIsMissing = function(key) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3001, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("KEY")($9c6c1f17a1cba25a$var$templateObject_13 || ($9c6c1f17a1cba25a$var$templateObject_13 = (0, $ixrLi.__makeTemplateObject)([
            "Cannot evaluate targeting rules and % options for setting '",
            "' (User Object is missing). You should pass a User Object to the evaluation methods like `getValueAsync()` in order to make targeting work properly. Read more: https://configcat.com/docs/advanced/user-object/"
        ], [
            "Cannot evaluate targeting rules and % options for setting '",
            "' (User Object is missing). You should pass a User Object to the evaluation methods like \\`getValueAsync()\\` in order to make targeting work properly. Read more: https://configcat.com/docs/advanced/user-object/"
        ])), key));
    };
    LoggerWrapper.prototype.dataGovernanceIsOutOfSync = function() {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3002, "The `dataGovernance` parameter specified at the client initialization is not in sync with the preferences on the ConfigCat Dashboard. Read more: https://configcat.com/docs/advanced/data-governance/");
    };
    LoggerWrapper.prototype.userObjectAttributeIsMissingPercentage = function(key, attributeName) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3003, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("KEY", "ATTRIBUTE_NAME", "ATTRIBUTE_NAME")($9c6c1f17a1cba25a$var$templateObject_14 || ($9c6c1f17a1cba25a$var$templateObject_14 = (0, $ixrLi.__makeTemplateObject)([
            "Cannot evaluate % options for setting '",
            "' (the User.",
            " attribute is missing). You should set the User.",
            " attribute in order to make targeting work properly. Read more: https://configcat.com/docs/advanced/user-object/"
        ], [
            "Cannot evaluate % options for setting '",
            "' (the User.",
            " attribute is missing). You should set the User.",
            " attribute in order to make targeting work properly. Read more: https://configcat.com/docs/advanced/user-object/"
        ])), key, attributeName, attributeName));
    };
    LoggerWrapper.prototype.userObjectAttributeIsMissingCondition = function(condition, key, attributeName) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3003, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("CONDITION", "KEY", "ATTRIBUTE_NAME", "ATTRIBUTE_NAME")($9c6c1f17a1cba25a$var$templateObject_15 || ($9c6c1f17a1cba25a$var$templateObject_15 = (0, $ixrLi.__makeTemplateObject)([
            "Cannot evaluate condition (",
            ") for setting '",
            "' (the User.",
            " attribute is missing). You should set the User.",
            " attribute in order to make targeting work properly. Read more: https://configcat.com/docs/advanced/user-object/"
        ], [
            "Cannot evaluate condition (",
            ") for setting '",
            "' (the User.",
            " attribute is missing). You should set the User.",
            " attribute in order to make targeting work properly. Read more: https://configcat.com/docs/advanced/user-object/"
        ])), condition, key, attributeName, attributeName));
    };
    LoggerWrapper.prototype.userObjectAttributeIsInvalid = function(condition, key, reason, attributeName) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3004, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("CONDITION", "KEY", "REASON", "ATTRIBUTE_NAME")($9c6c1f17a1cba25a$var$templateObject_16 || ($9c6c1f17a1cba25a$var$templateObject_16 = (0, $ixrLi.__makeTemplateObject)([
            "Cannot evaluate condition (",
            ") for setting '",
            "' (",
            "). Please check the User.",
            " attribute and make sure that its value corresponds to the comparison operator."
        ], [
            "Cannot evaluate condition (",
            ") for setting '",
            "' (",
            "). Please check the User.",
            " attribute and make sure that its value corresponds to the comparison operator."
        ])), condition, key, reason, attributeName));
    };
    LoggerWrapper.prototype.userObjectAttributeIsAutoConverted = function(condition, key, attributeName, attributeValue) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3005, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("CONDITION", "KEY", "ATTRIBUTE_NAME", "ATTRIBUTE_VALUE")($9c6c1f17a1cba25a$var$templateObject_17 || ($9c6c1f17a1cba25a$var$templateObject_17 = (0, $ixrLi.__makeTemplateObject)([
            "Evaluation of condition (",
            ") for setting '",
            "' may not produce the expected result (the User.",
            " attribute is not a string value, thus it was automatically converted to the string value '",
            "'). Please make sure that using a non-string value was intended."
        ], [
            "Evaluation of condition (",
            ") for setting '",
            "' may not produce the expected result (the User.",
            " attribute is not a string value, thus it was automatically converted to the string value '",
            "'). Please make sure that using a non-string value was intended."
        ])), condition, key, attributeName, attributeValue));
    };
    LoggerWrapper.prototype.configServiceCannotInitiateHttpCalls = function() {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3200, "Client is in offline mode, it cannot initiate HTTP calls.");
    };
    LoggerWrapper.prototype.configServiceMethodHasNoEffectDueToDisposedClient = function(methodName) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3201, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("METHOD_NAME")($9c6c1f17a1cba25a$var$templateObject_18 || ($9c6c1f17a1cba25a$var$templateObject_18 = (0, $ixrLi.__makeTemplateObject)([
            "The client object is already disposed, thus `",
            "()` has no effect."
        ], [
            "The client object is already disposed, thus \\`",
            "()\\` has no effect."
        ])), methodName));
    };
    LoggerWrapper.prototype.configServiceMethodHasNoEffectDueToOverrideBehavior = function(overrideBehavior, methodName) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn, 3202, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("OVERRIDE_BEHAVIOR", "METHOD_NAME")($9c6c1f17a1cba25a$var$templateObject_19 || ($9c6c1f17a1cba25a$var$templateObject_19 = (0, $ixrLi.__makeTemplateObject)([
            "Client is configured to use the `",
            "` override behavior, thus `",
            "()` has no effect."
        ], [
            "Client is configured to use the \\`",
            "\\` override behavior, thus \\`",
            "()\\` has no effect."
        ])), overrideBehavior, methodName));
    };
    /* SDK-specific warning messages (4000-4999) */ /* Common info messages (5000-5999) */ LoggerWrapper.prototype.settingEvaluated = function(evaluateLog) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Info, 5000, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("EVALUATE_LOG")($9c6c1f17a1cba25a$var$templateObject_20 || ($9c6c1f17a1cba25a$var$templateObject_20 = (0, $ixrLi.__makeTemplateObject)([
            "",
            ""
        ], [
            "",
            ""
        ])), evaluateLog));
    };
    LoggerWrapper.prototype.configServiceStatusChanged = function(status) {
        return this.log($9c6c1f17a1cba25a$export$243e62d78d3b544d.Info, 5200, $9c6c1f17a1cba25a$export$f36a8af8c17b2f06.from("MODE")($9c6c1f17a1cba25a$var$templateObject_21 || ($9c6c1f17a1cba25a$var$templateObject_21 = (0, $ixrLi.__makeTemplateObject)([
            "Switched to ",
            " mode."
        ], [
            "Switched to ",
            " mode."
        ])), status.toUpperCase()));
    };
    return LoggerWrapper;
}();
var $9c6c1f17a1cba25a$export$564bc9b1c988eb49 = /** @class */ function() {
    /**
     * Create an instance of ConfigCatConsoleLogger
     */ function ConfigCatConsoleLogger(level, eol) {
        if (level === void 0) level = $9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn;
        if (eol === void 0) eol = "\n";
        this.level = level;
        this.eol = eol;
        this.SOURCE = "ConfigCat";
    }
    /** @inheritdoc */ ConfigCatConsoleLogger.prototype.log = function(level, eventId, message, exception) {
        var _a = level === $9c6c1f17a1cba25a$export$243e62d78d3b544d.Debug ? [
            console.info,
            "DEBUG"
        ] : level === $9c6c1f17a1cba25a$export$243e62d78d3b544d.Info ? [
            console.info,
            "INFO"
        ] : level === $9c6c1f17a1cba25a$export$243e62d78d3b544d.Warn ? [
            console.warn,
            "WARN"
        ] : level === $9c6c1f17a1cba25a$export$243e62d78d3b544d.Error ? [
            console.error,
            "ERROR"
        ] : [
            console.log,
            $9c6c1f17a1cba25a$export$243e62d78d3b544d[level].toUpperCase()
        ], logMethod = _a[0], levelString = _a[1];
        var exceptionString = exception !== void 0 ? this.eol + (0, $dzur7.errorToString)(exception, true) : "";
        logMethod(this.SOURCE + " - " + levelString + " - [" + eventId + "] " + message + exceptionString);
    };
    return ConfigCatConsoleLogger;
}();
function $9c6c1f17a1cba25a$var$maskSdkKey(sdkKey) {
    var numCharsToKeep = 6;
    return sdkKey.substring(0, sdkKey.length - numCharsToKeep).replace(/[^/]/g, "*") + sdkKey.substring(sdkKey.length - numCharsToKeep);
}
var $9c6c1f17a1cba25a$var$templateObject_1, $9c6c1f17a1cba25a$var$templateObject_2, $9c6c1f17a1cba25a$var$templateObject_3, $9c6c1f17a1cba25a$var$templateObject_4, $9c6c1f17a1cba25a$var$templateObject_5, $9c6c1f17a1cba25a$var$templateObject_6, $9c6c1f17a1cba25a$var$templateObject_7, $9c6c1f17a1cba25a$var$templateObject_8, $9c6c1f17a1cba25a$var$templateObject_9, $9c6c1f17a1cba25a$var$templateObject_10, $9c6c1f17a1cba25a$var$templateObject_11, $9c6c1f17a1cba25a$var$templateObject_12, $9c6c1f17a1cba25a$var$templateObject_13, $9c6c1f17a1cba25a$var$templateObject_14, $9c6c1f17a1cba25a$var$templateObject_15, $9c6c1f17a1cba25a$var$templateObject_16, $9c6c1f17a1cba25a$var$templateObject_17, $9c6c1f17a1cba25a$var$templateObject_18, $9c6c1f17a1cba25a$var$templateObject_19, $9c6c1f17a1cba25a$var$templateObject_20, $9c6c1f17a1cba25a$var$templateObject_21;

});

parcelRegister("cTVJM", function(module, exports) {

$parcel$export(module.exports, "DefaultEventEmitter", function () { return $964768855c278331$export$f486de5a854c0cda; });
function $964768855c278331$var$isSingle(listeners) {
    return !!listeners.fn;
}
// NOTE: It's better to place this class into a separate module so
// it can be omitted from the final bundle in case we choose to
// make the common library EventEmitter implementation-agnostic in the future.
/** A platform-independent implementation of `IEventEmitter`. */ var $964768855c278331$export$f486de5a854c0cda = /** @class */ function() {
    function DefaultEventEmitter() {
        this.events = {};
        this.eventCount = 0;
        this.addListener = this.on;
        this.off = this.removeListener;
    }
    DefaultEventEmitter.prototype.addListenerCore = function(eventName, fn, once) {
        if (typeof fn !== "function") throw new TypeError("Listener must be a function");
        // TODO: remove `as string` when updating to TypeScript 4.4 or newer (https://stackoverflow.com/a/64943542/8656352)
        var listeners = this.events[eventName];
        var listener = {
            fn: fn,
            once: once
        };
        if (!listeners) {
            this.events[eventName] = listener;
            this.eventCount++;
        } else if ($964768855c278331$var$isSingle(listeners)) this.events[eventName] = [
            listeners,
            listener
        ];
        else listeners.push(listener);
        return this;
    };
    DefaultEventEmitter.prototype.removeListenerCore = function(eventName, state, isMatch) {
        var listeners = this.events[eventName];
        if (!listeners) return this;
        if (!$964768855c278331$var$isSingle(listeners)) {
            for(var i = listeners.length - 1; i >= 0; i--)if (isMatch(listeners[i], state)) {
                listeners.splice(i, 1);
                if (!listeners.length) this.removeEvent(eventName);
                else if (listeners.length === 1) this.events[eventName] = listeners[0];
                break;
            }
        } else if (isMatch(listeners, state)) this.removeEvent(eventName);
        return this;
    };
    DefaultEventEmitter.prototype.removeEvent = function(eventName) {
        if (--this.eventCount === 0) this.events = {};
        else delete this.events[eventName];
    };
    DefaultEventEmitter.prototype.on = function(eventName, listener) {
        return this.addListenerCore(eventName, listener, false);
    };
    DefaultEventEmitter.prototype.once = function(eventName, listener) {
        return this.addListenerCore(eventName, listener, true);
    };
    DefaultEventEmitter.prototype.removeListener = function(eventName, listener) {
        if (typeof listener !== "function") throw new TypeError("Listener must be a function");
        return this.removeListenerCore(eventName, listener, function(listener, fn) {
            return listener.fn === fn;
        });
    };
    DefaultEventEmitter.prototype.removeAllListeners = function(eventName) {
        if (!eventName) {
            this.events = {};
            this.eventCount = 0;
        } else if (this.events[eventName]) this.removeEvent(eventName);
        return this;
    };
    DefaultEventEmitter.prototype.listeners = function(eventName) {
        var listeners = this.events[eventName];
        if (!listeners) return [];
        if ($964768855c278331$var$isSingle(listeners)) return [
            listeners.fn
        ];
        var length = listeners.length, fns = new Array(length);
        for(var i = 0; i < length; i++)fns[i] = listeners[i].fn;
        return fns;
    };
    DefaultEventEmitter.prototype.listenerCount = function(eventName) {
        var listeners = this.events[eventName];
        if (!listeners) return 0;
        if ($964768855c278331$var$isSingle(listeners)) return 1;
        return listeners.length;
    };
    DefaultEventEmitter.prototype.eventNames = function() {
        var names = [];
        if (this.eventCount === 0) return names;
        var events = this.events;
        for(var name in events)if (Object.prototype.hasOwnProperty.call(events, name)) names.push(name);
        if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
        return names;
    };
    DefaultEventEmitter.prototype.emit = function(eventName, arg0, arg1, arg2, arg3) {
        var _a, _b;
        var moreArgs = [];
        for(var _i = 5; _i < arguments.length; _i++)moreArgs[_i - 5] = arguments[_i];
        var listeners = this.events[eventName];
        if (!listeners) return false;
        var listener, length;
        if ($964768855c278331$var$isSingle(listeners)) _a = [
            listeners,
            1
        ], listener = _a[0], length = _a[1];
        else {
            // According to the specification, potential removes during emit should not change the list of notified listeners,
            // so we need to create a local copy of the current listeners.
            listeners = listeners.slice();
            _b = [
                listeners[0],
                listeners.length
            ], listener = _b[0], length = _b[1];
        }
        var argCount = arguments.length - 1;
        for(var i = 0;;){
            if (listener.once) this.removeListenerCore(eventName, listener, function(listener, toRemove) {
                return listener === toRemove;
            });
            switch(argCount){
                case 0:
                    listener.fn.call(this);
                    break;
                case 1:
                    listener.fn.call(this, arg0);
                    break;
                case 2:
                    listener.fn.call(this, arg0, arg1);
                    break;
                case 3:
                    listener.fn.call(this, arg0, arg1, arg2);
                    break;
                case 4:
                    listener.fn.call(this, arg0, arg1, arg2, arg3);
                    break;
                default:
                    var args = new Array(argCount);
                    for(var j = 0; j < argCount; j++)// eslint-disable-next-line prefer-rest-params
                    args[j] = arguments[j + 1];
                    listener.fn.apply(this, args);
                    break;
            }
            if (++i >= length) break;
            listener = listeners[i];
        }
        return true;
    };
    return DefaultEventEmitter;
}();

});

parcelRegister("cYGfN", function(module, exports) {

$parcel$export(module.exports, "NullEventEmitter", function () { return $972bdd5823ff2302$export$866fd9c5f8c7c392; });
// The interfaces below define a subset of Node's EventEmitter (see https://nodejs.org/api/events.html#class-eventemitter),
// so they are (structurally) compatible with instances of EventEmitter.
var $972bdd5823ff2302$export$866fd9c5f8c7c392 = /** @class */ function() {
    function NullEventEmitter() {
        this.addListener = this.on;
        this.off = this.removeListener;
    }
    NullEventEmitter.prototype.on = function() {
        return this;
    };
    NullEventEmitter.prototype.once = function() {
        return this;
    };
    NullEventEmitter.prototype.removeListener = function() {
        return this;
    };
    NullEventEmitter.prototype.removeAllListeners = function() {
        return this;
    };
    NullEventEmitter.prototype.listeners = function() {
        return [];
    };
    NullEventEmitter.prototype.listenerCount = function() {
        return 0;
    };
    NullEventEmitter.prototype.eventNames = function() {
        return [];
    };
    NullEventEmitter.prototype.emit = function() {
        return false;
    };
    return NullEventEmitter;
}();

});

parcelRegister("by1qu", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $8683f9eb3dcd3452$export$5091bdda49ba90f5; });
$parcel$export(module.exports, "sha256", function () { return $8683f9eb3dcd3452$export$bced8d2aada2d1c9; });

var $dzur7 = parcelRequire("dzur7");
function $8683f9eb3dcd3452$export$5091bdda49ba90f5(msg) {
    function rotate_left(n, s) {
        var t4 = n << s | n >>> 32 - s;
        return t4;
    }
    var blockstart;
    var i, j;
    var W = new Array(80);
    var H0 = 0x67452301;
    var H1 = 0xEFCDAB89;
    var H2 = 0x98BADCFE;
    var H3 = 0x10325476;
    var H4 = 0xC3D2E1F0;
    var A, B, C, D, E;
    var temp;
    msg = (0, $dzur7.utf8Encode)(msg);
    var msg_len = msg.length;
    var word_array = new Array();
    for(i = 0; i < msg_len - 3; i += 4){
        j = msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 | msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3);
        word_array.push(j);
    }
    switch(msg_len % 4){
        case 0:
            i = 0x080000000;
            break;
        case 1:
            i = msg.charCodeAt(msg_len - 1) << 24 | 0x0800000;
            break;
        case 2:
            i = msg.charCodeAt(msg_len - 2) << 24 | msg.charCodeAt(msg_len - 1) << 16 | 0x08000;
            break;
        case 3:
            i = msg.charCodeAt(msg_len - 3) << 24 | msg.charCodeAt(msg_len - 2) << 16 | msg.charCodeAt(msg_len - 1) << 8 | 0x80;
            break;
    }
    word_array.push(i);
    while(word_array.length % 16 != 14)word_array.push(0);
    word_array.push(msg_len >>> 29);
    word_array.push(msg_len << 3 & 0x0ffffffff);
    for(blockstart = 0; blockstart < word_array.length; blockstart += 16){
        for(i = 0; i < 16; i++)W[i] = word_array[blockstart + i];
        for(i = 16; i <= 79; i++)W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for(i = 0; i <= 19; i++){
            temp = rotate_left(A, 5) + (B & C | ~B & D) + E + W[i] + 0x5A827999 & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for(i = 20; i <= 39; i++){
            temp = rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1 & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for(i = 40; i <= 59; i++){
            temp = rotate_left(A, 5) + (B & C | B & D | C & D) + E + W[i] + 0x8F1BBCDC & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        for(i = 60; i <= 79; i++){
            temp = rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6 & 0x0ffffffff;
            E = D;
            D = C;
            C = rotate_left(B, 30);
            B = A;
            A = temp;
        }
        H0 = H0 + A & 0x0ffffffff;
        H1 = H1 + B & 0x0ffffffff;
        H2 = H2 + C & 0x0ffffffff;
        H3 = H3 + D & 0x0ffffffff;
        H4 = H4 + E & 0x0ffffffff;
    }
    return $8683f9eb3dcd3452$var$toHexString([
        H0,
        H1,
        H2,
        H3,
        H4
    ]);
}
function $8683f9eb3dcd3452$export$bced8d2aada2d1c9(msgUtf8) {
    function rightRotate(value, amount) {
        return value >>> amount | value << 32 - amount;
    }
    var lengthProperty = "length";
    var mathPow = Math.pow;
    var maxWord = mathPow(2, 32);
    var i, j; // Used as a counter across the whole file
    var precomputedData = $8683f9eb3dcd3452$export$bced8d2aada2d1c9;
    var hash = precomputedData.h;
    var k = precomputedData.k;
    if (!k) {
        // Initial hash value: first 32 bits of the fractional parts of the square roots of the first 8 primes
        // (we actually calculate the first 64, but extra values are just ignored)
        hash = [];
        // Round constants: first 32 bits of the fractional parts of the cube roots of the first 64 primes
        k = [];
        var isComposite = {};
        for(var candidate = 2, primeCounter = 0; primeCounter < 64; candidate++)if (!isComposite[candidate]) {
            for(i = 0; i < 313; i += candidate)isComposite[i] = candidate;
            hash[primeCounter] = mathPow(candidate, .5) * maxWord | 0;
            k[primeCounter++] = mathPow(candidate, 1 / 3) * maxWord | 0;
        }
        precomputedData.h = hash = hash.slice(0, 8);
        precomputedData.k = k;
    }
    var asciiBitLength = msgUtf8[lengthProperty] * 8;
    msgUtf8 += '\x80'; // Append Ƈ' bit (plus zero padding)
    var words = [];
    while(msgUtf8[lengthProperty] % 64 - 56)msgUtf8 += '\x00'; // More zero padding
    for(i = 0; i < msgUtf8[lengthProperty]; i++){
        j = msgUtf8.charCodeAt(i);
        words[i >> 2] |= j << (3 - i) % 4 * 8;
    }
    words[words[lengthProperty]] = asciiBitLength / maxWord | 0;
    words[words[lengthProperty]] = asciiBitLength;
    // process each chunk
    for(j = 0; j < words[lengthProperty];){
        var w = words.slice(j, j += 16); // The message is expanded into 64 words as part of the iteration
        var oldHash = hash;
        // This is now the undefinedworking hash", often labelled as variables a...g
        // (we have to truncate as well, otherwise extra entries at the end accumulate
        hash = hash.slice(0, 8);
        for(i = 0; i < 64; i++){
            // Expand the message into 64 words
            // Used below if 
            var w15 = w[i - 15], w2 = w[i - 2];
            // Iterate
            var a = hash[0], e = hash[4];
            var temp1 = hash[7] + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25) // S1
            ) + (e & hash[5] ^ ~e & hash[6] // ch
            ) + k[i] + (w[i] = i < 16 ? w[i] : w[i - 16] + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ w15 >>> 3 // s0
            ) + w[i - 7] + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ w2 >>> 10 // s1
            ) | 0);
            // This is only used once, so *could* be moved below, but it only saves 4 bytes and makes things unreadble
            var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22) // S0
            ) + (a & hash[1] ^ a & hash[2] ^ hash[1] & hash[2]); // maj
            hash = [
                temp1 + temp2 | 0
            ].concat(hash); // We don't bother trimming off the extra ones, they're harmless as long as we're truncating when we do the slice()
            hash[4] = hash[4] + temp1 | 0;
        }
        for(i = 0; i < 8; i++)hash[i] = hash[i] + oldHash[i] | 0;
    }
    return $8683f9eb3dcd3452$var$toHexString(hash, 8);
}
function $8683f9eb3dcd3452$var$toHexString(int32Array, count) {
    var hexDigits = "0123456789abcdef";
    var result = "";
    count !== null && count !== void 0 ? count : count = int32Array.length;
    for(var i = 0; i < count; i++)for(var j = 3; j >= 0; j--){
        var b = int32Array[i] >> (j << 3) & 0xFF;
        result += hexDigits[b >> 4];
        result += hexDigits[b & 0xF];
    }
    return result;
}

});

parcelRegister("4G6mW", function(module, exports) {

$parcel$export(module.exports, "Hooks", function () { return $368006677b3c8dea$export$5fbefe39e79899a6; });

var $ixrLi = parcelRequire("ixrLi");

var $cYGfN = parcelRequire("cYGfN");
var $368006677b3c8dea$var$disconnectedEventEmitter = new (0, $cYGfN.NullEventEmitter)();
var $368006677b3c8dea$export$5fbefe39e79899a6 = /** @class */ function() {
    function Hooks(eventEmitter) {
        /** @inheritdoc */ this.addListener = this.on;
        /** @inheritdoc */ this.off = this.removeListener;
        this.eventEmitter = eventEmitter;
    }
    Hooks.prototype.tryDisconnect = function() {
        // Replacing the current IEventEmitter object (eventEmitter) with a special instance of IEventEmitter (disconnectedEventEmitter) achieves multiple things:
        // 1. determines whether the hooks instance has already been disconnected or not,
        // 2. removes implicit references to subscriber objects (so this instance won't keep them alive under any circumstances),
        // 3. makes sure that future subscriptions are ignored from this point on.
        var originalEventEmitter = this.eventEmitter;
        this.eventEmitter = $368006677b3c8dea$var$disconnectedEventEmitter;
        return originalEventEmitter !== $368006677b3c8dea$var$disconnectedEventEmitter;
    };
    /** @inheritdoc */ Hooks.prototype.on = function(eventName, listener) {
        this.eventEmitter.on(eventName, listener);
        return this;
    };
    /** @inheritdoc */ Hooks.prototype.once = function(eventName, listener) {
        this.eventEmitter.once(eventName, listener);
        return this;
    };
    /** @inheritdoc */ Hooks.prototype.removeListener = function(eventName, listener) {
        this.eventEmitter.removeListener(eventName, listener);
        return this;
    };
    /** @inheritdoc */ Hooks.prototype.removeAllListeners = function(eventName) {
        this.eventEmitter.removeAllListeners(eventName);
        return this;
    };
    /** @inheritdoc */ Hooks.prototype.listeners = function(eventName) {
        return this.eventEmitter.listeners(eventName);
    };
    /** @inheritdoc */ Hooks.prototype.listenerCount = function(eventName) {
        return this.eventEmitter.listenerCount(eventName);
    };
    /** @inheritdoc */ Hooks.prototype.eventNames = function() {
        return this.eventEmitter.eventNames();
    };
    /** @inheritdoc */ Hooks.prototype.emit = function(eventName) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return (_a = this.eventEmitter).emit.apply(_a, (0, $ixrLi.__spreadArrays)([
            eventName
        ], args));
    };
    return Hooks;
}();

});

parcelRegister("dEOe6", function(module, exports) {

$parcel$export(module.exports, "setupPolyfills", function () { return $9f15f8b71cd4092a$export$ec2b497860dccb0f; });
$parcel$export(module.exports, "getWeakRefStub", function () { return $9f15f8b71cd4092a$export$422b1ae810ba3a59; });
$parcel$export(module.exports, "isWeakRefAvailable", function () { return $9f15f8b71cd4092a$export$ef95f1bb026ba3f5; });
function $9f15f8b71cd4092a$export$ec2b497860dccb0f() {
    // Object.values
    if (typeof Object.values === "undefined") Object.values = $9f15f8b71cd4092a$export$bfe721af2b610d14;
    // Object.entries
    if (typeof Object.entries === "undefined") Object.entries = $9f15f8b71cd4092a$export$c5686cd3caa077c3;
    // Object.fromEntries
    if (typeof Object.fromEntries === "undefined") Object.fromEntries = $9f15f8b71cd4092a$export$e9f594c14b3756cf;
}
function $9f15f8b71cd4092a$export$bfe721af2b610d14(o) {
    var result = [];
    for(var _i = 0, _a = Object.keys(o); _i < _a.length; _i++){
        var key = _a[_i];
        result.push(o[key]);
    }
    return result;
}
function $9f15f8b71cd4092a$export$c5686cd3caa077c3(o) {
    var result = [];
    for(var _i = 0, _a = Object.keys(o); _i < _a.length; _i++){
        var key = _a[_i];
        result.push([
            key,
            o[key]
        ]);
    }
    return result;
}
function $9f15f8b71cd4092a$export$e9f594c14b3756cf(entries) {
    var _a;
    // TODO: change `k: string` to `k: PropertyKey` in the following line and remove `as string` below
    // when updating to TypeScript 4.4 or newer (https://stackoverflow.com/a/64943542/8656352)
    var result = {};
    if (Array.isArray(entries)) for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _b = entries_1[_i], key = _b[0], value = _b[1];
        result[key] = value;
    }
    else if (typeof Symbol !== "undefined" && (entries === null || entries === void 0 ? void 0 : entries[Symbol.iterator])) {
        var iterator = entries[Symbol.iterator]();
        var element = void 0, done = void 0;
        while(_a = iterator.next(), element = _a.value, done = _a.done, _a, !done){
            var key = element[0], value = element[1];
            result[key] = value;
        }
    } else throw new TypeError("Object.fromEntries() requires a single iterable argument");
    return result;
}
function $9f15f8b71cd4092a$export$422b1ae810ba3a59() {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var WeakRef1 = function(target) {
        this.target = target;
    };
    WeakRef1.prototype.deref = function() {
        return this.target;
    };
    WeakRef1.isFallback = true;
    return WeakRef1;
}
var $9f15f8b71cd4092a$export$ef95f1bb026ba3f5 = function() {
    return typeof WeakRef === "function";
};

});


parcelRegister("cCuGt", function(module, exports) {

$parcel$export(module.exports, "OverrideBehaviour", function () { return $9300d5da8c831ce9$export$d0a00b6c4c4879b4; });
$parcel$export(module.exports, "MapOverrideDataSource", function () { return $9300d5da8c831ce9$export$e48bdb50b697554d; });
$parcel$export(module.exports, "FlagOverrides", function () { return $9300d5da8c831ce9$export$7ae32c5ba2d59a9b; });

var $lpUFt = parcelRequire("lpUFt");
var $9300d5da8c831ce9$export$d0a00b6c4c4879b4;
(function(OverrideBehaviour) {
    /**
     * When evaluating values, the SDK will not use feature flags and settings from the ConfigCat CDN, but it will use
     * all feature flags and settings that are loaded from local-override sources.
     */ OverrideBehaviour[OverrideBehaviour["LocalOnly"] = 0] = "LocalOnly";
    /**
     * When evaluating values, the SDK will use all feature flags and settings that are downloaded from the ConfigCat CDN,
     * plus all feature flags and settings that are loaded from local-override sources. If a feature flag or a setting is
     * defined both in the fetched and the local-override source then the local-override version will take precedence.
     */ OverrideBehaviour[OverrideBehaviour["LocalOverRemote"] = 1] = "LocalOverRemote";
    /**
     * When evaluating values, the SDK will use all feature flags and settings that are downloaded from the ConfigCat CDN,
     * plus all feature flags and settings that are loaded from local-override sources. If a feature flag or a setting is
     * defined both in the fetched and the local-override source then the fetched version will take precedence.
     */ OverrideBehaviour[OverrideBehaviour["RemoteOverLocal"] = 2] = "RemoteOverLocal";
})($9300d5da8c831ce9$export$d0a00b6c4c4879b4 || ($9300d5da8c831ce9$export$d0a00b6c4c4879b4 = {}));
var $9300d5da8c831ce9$export$e48bdb50b697554d = /** @class */ function() {
    function MapOverrideDataSource(map, watchChanges) {
        this.initialSettings = this.constructor.getCurrentSettings(map);
        if (watchChanges) this.map = map;
    }
    MapOverrideDataSource.getCurrentSettings = function(map) {
        return Object.fromEntries(Object.entries(map).map(function(_a) {
            var key = _a[0], value = _a[1];
            return [
                key,
                (0, $lpUFt.Setting).fromValue(value)
            ];
        }));
    };
    MapOverrideDataSource.prototype.getOverrides = function() {
        return Promise.resolve(this.getOverridesSync());
    };
    MapOverrideDataSource.prototype.getOverridesSync = function() {
        return this.map ? this.constructor.getCurrentSettings(this.map) : this.initialSettings;
    };
    return MapOverrideDataSource;
}();
var $9300d5da8c831ce9$export$7ae32c5ba2d59a9b = /** @class */ function() {
    function FlagOverrides(dataSource, behaviour) {
        this.dataSource = dataSource;
        this.behaviour = behaviour;
    }
    return FlagOverrides;
}();

});

parcelRegister("fCJUV", function(module, exports) {

$parcel$export(module.exports, "LazyLoadConfigService", function () { return $b5fe05d1676139b3$export$d8f941aec6a4499c; });

var $ixrLi = parcelRequire("ixrLi");

var $jh0RI = parcelRequire("jh0RI");
var $b5fe05d1676139b3$export$d8f941aec6a4499c = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(LazyLoadConfigService, _super);
    function LazyLoadConfigService(configFetcher, options) {
        var _this = _super.call(this, configFetcher, options) || this;
        _this.cacheTimeToLiveMs = options.cacheTimeToLiveSeconds * 1000;
        var initialCacheSyncUp = _this.syncUpWithCache();
        _this.readyPromise = _this.getReadyPromise(initialCacheSyncUp, function(initialCacheSyncUp) {
            return (0, $ixrLi.__awaiter)(_this, void 0, void 0, function() {
                var _a;
                return (0, $ixrLi.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _a = this.getCacheState;
                            return [
                                4 /*yield*/ ,
                                initialCacheSyncUp
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.apply(this, [
                                    _b.sent()
                                ])
                            ];
                    }
                });
            });
        });
        return _this;
    }
    LazyLoadConfigService.prototype.getConfig = function() {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            function logExpired(logger, appendix) {
                if (appendix === void 0) appendix = "";
                logger.debug("LazyLoadConfigService.getConfig(): cache is empty or expired" + appendix + ".");
            }
            var cachedConfig;
            var _a;
            return (0, $ixrLi.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.options.logger.debug("LazyLoadConfigService.getConfig() called.");
                        return [
                            4 /*yield*/ ,
                            this.syncUpWithCache()
                        ];
                    case 1:
                        cachedConfig = _b.sent();
                        if (!cachedConfig.isExpired(this.cacheTimeToLiveMs)) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!!this.isOffline) return [
                            3 /*break*/ ,
                            3
                        ];
                        logExpired(this.options.logger, ", calling refreshConfigCoreAsync()");
                        return [
                            4 /*yield*/ ,
                            this.refreshConfigCoreAsync(cachedConfig)
                        ];
                    case 2:
                        _a = _b.sent(), cachedConfig = _a[1];
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        logExpired(this.options.logger);
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            cachedConfig
                        ];
                    case 5:
                        this.options.logger.debug("LazyLoadConfigService.getConfig(): cache is valid, returning from cache.");
                        return [
                            2 /*return*/ ,
                            cachedConfig
                        ];
                }
            });
        });
    };
    LazyLoadConfigService.prototype.refreshConfigAsync = function() {
        this.options.logger.debug("LazyLoadConfigService.refreshConfigAsync() called.");
        return _super.prototype.refreshConfigAsync.call(this);
    };
    LazyLoadConfigService.prototype.getCacheState = function(cachedConfig) {
        if (cachedConfig.isEmpty) return (0, $jh0RI.ClientCacheState).NoFlagData;
        if (cachedConfig.isExpired(this.cacheTimeToLiveMs)) return (0, $jh0RI.ClientCacheState).HasCachedFlagDataOnly;
        return (0, $jh0RI.ClientCacheState).HasUpToDateFlagData;
    };
    return LazyLoadConfigService;
}((0, $jh0RI.ConfigServiceBase));

});

parcelRegister("aXBrO", function(module, exports) {

$parcel$export(module.exports, "ManualPollConfigService", function () { return $7fac76645cea2ec0$export$19564cf0373afa8a; });

var $ixrLi = parcelRequire("ixrLi");

var $jh0RI = parcelRequire("jh0RI");
var $7fac76645cea2ec0$export$19564cf0373afa8a = /** @class */ function(_super) {
    (0, $ixrLi.__extends)(ManualPollConfigService, _super);
    function ManualPollConfigService(configFetcher, options) {
        var _this = _super.call(this, configFetcher, options) || this;
        var initialCacheSyncUp = _this.syncUpWithCache();
        _this.readyPromise = _this.getReadyPromise(initialCacheSyncUp, function(initialCacheSyncUp) {
            return (0, $ixrLi.__awaiter)(_this, void 0, void 0, function() {
                var _a;
                return (0, $ixrLi.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _a = this.getCacheState;
                            return [
                                4 /*yield*/ ,
                                initialCacheSyncUp
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.apply(this, [
                                    _b.sent()
                                ])
                            ];
                    }
                });
            });
        });
        return _this;
    }
    ManualPollConfigService.prototype.getCacheState = function(cachedConfig) {
        if (cachedConfig.isEmpty) return (0, $jh0RI.ClientCacheState).NoFlagData;
        return (0, $jh0RI.ClientCacheState).HasCachedFlagDataOnly;
    };
    ManualPollConfigService.prototype.getConfig = function() {
        return (0, $ixrLi.__awaiter)(this, void 0, void 0, function() {
            return (0, $ixrLi.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.options.logger.debug("ManualPollService.getConfig() called.");
                        return [
                            4 /*yield*/ ,
                            this.syncUpWithCache()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ManualPollConfigService.prototype.refreshConfigAsync = function() {
        this.options.logger.debug("ManualPollService.refreshConfigAsync() called.");
        return _super.prototype.refreshConfigAsync.call(this);
    };
    return ManualPollConfigService;
}((0, $jh0RI.ConfigServiceBase));

});

parcelRegister("jBPdJ", function(module, exports) {

$parcel$export(module.exports, "RolloutEvaluator", function () { return $e469345ab0e6bf7a$export$684863d910d0f350; });
$parcel$export(module.exports, "isAllowedValue", function () { return $e469345ab0e6bf7a$export$a0f4c9f7d8b8a082; });
$parcel$export(module.exports, "handleInvalidReturnValue", function () { return $e469345ab0e6bf7a$export$1107fc4e2f84ee21; });
$parcel$export(module.exports, "evaluationDetailsFromDefaultValue", function () { return $e469345ab0e6bf7a$export$649986bfd107f89b; });
$parcel$export(module.exports, "evaluate", function () { return $e469345ab0e6bf7a$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getTimestampAsDate", function () { return $e469345ab0e6bf7a$export$779cfe25876e7f02; });
$parcel$export(module.exports, "evaluateAll", function () { return $e469345ab0e6bf7a$export$67c37a03b3d5dd3f; });
$parcel$export(module.exports, "checkSettingsAvailable", function () { return $e469345ab0e6bf7a$export$4b483ed1551db5f7; });

var $dqDdj = parcelRequire("dqDdj");

var $aOidd = parcelRequire("aOidd");

var $gizTB = parcelRequire("gizTB");

var $by1qu = parcelRequire("by1qu");

var $7dX62 = parcelRequire("7dX62");

var $djkK5 = parcelRequire("djkK5");

var $dzur7 = parcelRequire("dzur7");
var $e469345ab0e6bf7a$export$9743a6eccb1d671b = /** @class */ function() {
    function EvaluateContext(key, setting, user, settings) {
        this.key = key;
        this.setting = setting;
        this.user = user;
        this.settings = settings;
    }
    Object.defineProperty(EvaluateContext.prototype, "visitedFlags", {
        get: function() {
            var _a;
            return (_a = this.$visitedFlags) !== null && _a !== void 0 ? _a : this.$visitedFlags = [];
        },
        enumerable: false,
        configurable: true
    });
    EvaluateContext.forPrerequisiteFlag = function(key, setting, dependentFlagContext) {
        var context = new EvaluateContext(key, setting, dependentFlagContext.user, dependentFlagContext.settings);
        context.$visitedFlags = dependentFlagContext.visitedFlags; // crucial to use the computed property here to make sure the list is created!
        context.logBuilder = dependentFlagContext.logBuilder;
        return context;
    };
    return EvaluateContext;
}();
var $e469345ab0e6bf7a$var$targetingRuleIgnoredMessage = "The current targeting rule is ignored and the evaluation continues with the next rule.";
var $e469345ab0e6bf7a$var$missingUserObjectError = "cannot evaluate, User Object is missing";
var $e469345ab0e6bf7a$var$missingUserAttributeError = function(attributeName) {
    return "cannot evaluate, the User." + attributeName + " attribute is missing";
};
var $e469345ab0e6bf7a$var$invalidUserAttributeError = function(attributeName, reason) {
    return "cannot evaluate, the User." + attributeName + " attribute is invalid (" + reason + ")";
};
var $e469345ab0e6bf7a$export$684863d910d0f350 = /** @class */ function() {
    function RolloutEvaluator(logger) {
        this.logger = logger;
    }
    RolloutEvaluator.prototype.evaluate = function(defaultValue, context) {
        this.logger.debug("RolloutEvaluator.evaluate() called.");
        var logBuilder = context.logBuilder;
        // Building the evaluation log is expensive, so let's not do it if it wouldn't be logged anyway.
        if (this.logger.isEnabled((0, $dqDdj.LogLevel).Info)) {
            context.logBuilder = logBuilder = new (0, $gizTB.EvaluateLogBuilder)(this.logger.eol);
            logBuilder.append("Evaluating '" + context.key + "'");
            if (context.user) logBuilder.append(" for User '" + JSON.stringify((0, $djkK5.getUserAttributes)(context.user)) + "'");
            logBuilder.increaseIndent();
        }
        var returnValue;
        try {
            var result = void 0, isValidReturnValue = void 0;
            if (defaultValue != null) {
                // NOTE: We've already checked earlier in the call chain that the defaultValue is of an allowed type (see also ensureAllowedDefaultValue).
                var settingType = context.setting.type;
                // Setting type -1 indicates a setting which comes from a flag override (see also Setting.fromValue).
                if (settingType === -1) settingType = $e469345ab0e6bf7a$var$inferSettingType(context.setting.value);
                // At this point, setting type -1 indicates a setting which comes from a flag override AND has an unsupported value.
                // This case will be handled by handleInvalidReturnValue below.
                if (settingType !== -1 && !$e469345ab0e6bf7a$var$isCompatibleValue(defaultValue, settingType)) throw new TypeError("The type of a setting must match the type of the specified default value. " + ("Setting's type was " + (0, $aOidd.SettingType)[settingType] + " but the default value's type was " + typeof defaultValue + ". ") + ("Please use a default value which corresponds to the setting type " + (0, $aOidd.SettingType)[settingType] + ". ") + "Learn more: https://configcat.com/docs/sdk-reference/js/#setting-type-mapping");
                result = this.evaluateSetting(context);
                returnValue = result.selectedValue.value;
                // When a default value other than null or undefined is specified, the return value must have the same type as the default value
                // so that the consistency between TS (compile-time) and JS (run-time) return value types is maintained.
                isValidReturnValue = typeof returnValue === typeof defaultValue;
            } else {
                result = this.evaluateSetting(context);
                returnValue = result.selectedValue.value;
                // When the specified default value is null or undefined, the return value can be of whatever allowed type (boolean, string, number).
                isValidReturnValue = $e469345ab0e6bf7a$export$a0f4c9f7d8b8a082(returnValue);
            }
            if (!isValidReturnValue) $e469345ab0e6bf7a$export$1107fc4e2f84ee21(returnValue);
            return result;
        } catch (err) {
            logBuilder === null || logBuilder === void 0 || logBuilder.resetIndent().increaseIndent();
            returnValue = defaultValue;
            throw err;
        } finally{
            if (logBuilder) {
                logBuilder.newLine("Returning '" + returnValue + "'.").decreaseIndent();
                this.logger.settingEvaluated(logBuilder.toString());
            }
        }
    };
    RolloutEvaluator.prototype.evaluateSetting = function(context) {
        var evaluateResult;
        var targetingRules = context.setting.targetingRules;
        if (targetingRules.length > 0 && (evaluateResult = this.evaluateTargetingRules(targetingRules, context))) return evaluateResult;
        var percentageOptions = context.setting.percentageOptions;
        if (percentageOptions.length > 0 && (evaluateResult = this.evaluatePercentageOptions(percentageOptions, void 0, context))) return evaluateResult;
        return {
            selectedValue: context.setting
        };
    };
    RolloutEvaluator.prototype.evaluateTargetingRules = function(targetingRules, context) {
        var logBuilder = context.logBuilder;
        logBuilder === null || logBuilder === void 0 || logBuilder.newLine("Evaluating targeting rules and applying the first match if any:");
        for(var i = 0; i < targetingRules.length; i++){
            var targetingRule = targetingRules[i];
            var conditions = targetingRule.conditions;
            var isMatchOrError = this.evaluateConditions(conditions, targetingRule, context.key, context);
            if (isMatchOrError !== true) {
                if ($e469345ab0e6bf7a$var$isEvaluationError(isMatchOrError)) logBuilder === null || logBuilder === void 0 || logBuilder.increaseIndent().newLine($e469345ab0e6bf7a$var$targetingRuleIgnoredMessage).decreaseIndent();
                continue;
            }
            if (!(0, $dzur7.isArray)(targetingRule.then)) return {
                selectedValue: targetingRule.then,
                matchedTargetingRule: targetingRule
            };
            var percentageOptions = targetingRule.then;
            logBuilder === null || logBuilder === void 0 || logBuilder.increaseIndent();
            var evaluateResult = this.evaluatePercentageOptions(percentageOptions, targetingRule, context);
            if (evaluateResult) {
                logBuilder === null || logBuilder === void 0 || logBuilder.decreaseIndent();
                return evaluateResult;
            }
            logBuilder === null || logBuilder === void 0 || logBuilder.newLine($e469345ab0e6bf7a$var$targetingRuleIgnoredMessage).decreaseIndent();
        }
    };
    RolloutEvaluator.prototype.evaluatePercentageOptions = function(percentageOptions, matchedTargetingRule, context) {
        var _a;
        var logBuilder = context.logBuilder;
        if (!context.user) {
            logBuilder === null || logBuilder === void 0 || logBuilder.newLine("Skipping % options because the User Object is missing.");
            if (!context.isMissingUserObjectLogged) {
                this.logger.userObjectIsMissing(context.key);
                context.isMissingUserObjectLogged = true;
            }
            return;
        }
        var percentageOptionsAttributeName = context.setting.percentageOptionsAttribute;
        var percentageOptionsAttributeValue;
        if (percentageOptionsAttributeName == null) {
            percentageOptionsAttributeName = "Identifier";
            percentageOptionsAttributeValue = (_a = context.user.identifier) !== null && _a !== void 0 ? _a : "";
        } else percentageOptionsAttributeValue = (0, $djkK5.getUserAttribute)(context.user, percentageOptionsAttributeName);
        if (percentageOptionsAttributeValue == null) {
            logBuilder === null || logBuilder === void 0 || logBuilder.newLine("Skipping % options because the User." + percentageOptionsAttributeName + " attribute is missing.");
            if (!context.isMissingUserObjectAttributeLogged) {
                this.logger.userObjectAttributeIsMissingPercentage(context.key, percentageOptionsAttributeName);
                context.isMissingUserObjectAttributeLogged = true;
            }
            return;
        }
        logBuilder === null || logBuilder === void 0 || logBuilder.newLine("Evaluating % options based on the User." + percentageOptionsAttributeName + " attribute:");
        var sha1Hash = (0, $by1qu.sha1)(context.key + $e469345ab0e6bf7a$var$userAttributeValueToString(percentageOptionsAttributeValue));
        var hashValue = parseInt(sha1Hash.substring(0, 7), 16) % 100;
        logBuilder === null || logBuilder === void 0 || logBuilder.newLine("- Computing hash in the [0..99] range from User." + percentageOptionsAttributeName + " => " + hashValue + " (this value is sticky and consistent across all SDKs)");
        var bucket = 0;
        for(var i = 0; i < percentageOptions.length; i++){
            var percentageOption = percentageOptions[i];
            bucket += percentageOption.percentage;
            if (hashValue >= bucket) continue;
            logBuilder === null || logBuilder === void 0 || logBuilder.newLine("- Hash value " + hashValue + " selects % option " + (i + 1) + " (" + percentageOption.percentage + "%), '" + (0, $gizTB.valueToString)(percentageOption.value) + "'.");
            return {
                selectedValue: percentageOption,
                matchedTargetingRule: matchedTargetingRule,
                matchedPercentageOption: percentageOption
            };
        }
        throw new Error("Sum of percentage option percentages is less than 100.");
    };
    RolloutEvaluator.prototype.evaluateConditions = function(conditions, targetingRule, contextSalt, context) {
        // The result of a condition evaluation is either match (true) / no match (false) or an error (string).
        var result = true;
        var logBuilder = context.logBuilder;
        var newLineBeforeThen = false;
        logBuilder === null || logBuilder === void 0 || logBuilder.newLine("- ");
        for(var i = 0; i < conditions.length; i++){
            var condition = conditions[i];
            if (logBuilder) {
                if (!i) logBuilder.append("IF ").increaseIndent();
                else logBuilder.increaseIndent().newLine("AND ");
            }
            switch(condition.type){
                case "UserCondition":
                    result = this.evaluateUserCondition(condition, contextSalt, context);
                    newLineBeforeThen = conditions.length > 1;
                    break;
                case "PrerequisiteFlagCondition":
                    result = this.evaluatePrerequisiteFlagCondition(condition, context);
                    newLineBeforeThen = true;
                    break;
                case "SegmentCondition":
                    result = this.evaluateSegmentCondition(condition, context);
                    newLineBeforeThen = !$e469345ab0e6bf7a$var$isEvaluationError(result) || result !== $e469345ab0e6bf7a$var$missingUserObjectError || conditions.length > 1;
                    break;
                default:
                    throw new Error(); // execution should never get here
            }
            var success = result === true;
            if (logBuilder) {
                if (!targetingRule || conditions.length > 1) logBuilder.appendConditionConsequence(success);
                logBuilder.decreaseIndent();
            }
            if (!success) break;
        }
        if (targetingRule) logBuilder === null || logBuilder === void 0 || logBuilder.appendTargetingRuleConsequence(targetingRule, result, newLineBeforeThen);
        return result;
    };
    RolloutEvaluator.prototype.evaluateUserCondition = function(condition, contextSalt, context) {
        var logBuilder = context.logBuilder;
        logBuilder === null || logBuilder === void 0 || logBuilder.appendUserCondition(condition);
        if (!context.user) {
            if (!context.isMissingUserObjectLogged) {
                this.logger.userObjectIsMissing(context.key);
                context.isMissingUserObjectLogged = true;
            }
            return $e469345ab0e6bf7a$var$missingUserObjectError;
        }
        var userAttributeName = condition.comparisonAttribute;
        var userAttributeValue = (0, $djkK5.getUserAttribute)(context.user, userAttributeName);
        if (userAttributeValue == null || userAttributeValue === "") {
            this.logger.userObjectAttributeIsMissingCondition((0, $gizTB.formatUserCondition)(condition), context.key, userAttributeName);
            return $e469345ab0e6bf7a$var$missingUserAttributeError(userAttributeName);
        }
        var text, versionOrError, numberOrError, arrayOrError;
        switch(condition.comparator){
            case (0, $aOidd.UserComparator).TextEquals:
            case (0, $aOidd.UserComparator).TextNotEquals:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateTextEquals(text, condition.comparisonValue, condition.comparator === (0, $aOidd.UserComparator).TextNotEquals);
            case (0, $aOidd.UserComparator).SensitiveTextEquals:
            case (0, $aOidd.UserComparator).SensitiveTextNotEquals:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateSensitiveTextEquals(text, condition.comparisonValue, context.setting.configJsonSalt, contextSalt, condition.comparator === (0, $aOidd.UserComparator).SensitiveTextNotEquals);
            case (0, $aOidd.UserComparator).TextIsOneOf:
            case (0, $aOidd.UserComparator).TextIsNotOneOf:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateTextIsOneOf(text, condition.comparisonValue, condition.comparator === (0, $aOidd.UserComparator).TextIsNotOneOf);
            case (0, $aOidd.UserComparator).SensitiveTextIsOneOf:
            case (0, $aOidd.UserComparator).SensitiveTextIsNotOneOf:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateSensitiveTextIsOneOf(text, condition.comparisonValue, context.setting.configJsonSalt, contextSalt, condition.comparator === (0, $aOidd.UserComparator).SensitiveTextIsNotOneOf);
            case (0, $aOidd.UserComparator).TextStartsWithAnyOf:
            case (0, $aOidd.UserComparator).TextNotStartsWithAnyOf:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateTextSliceEqualsAnyOf(text, condition.comparisonValue, true, condition.comparator === (0, $aOidd.UserComparator).TextNotStartsWithAnyOf);
            case (0, $aOidd.UserComparator).SensitiveTextStartsWithAnyOf:
            case (0, $aOidd.UserComparator).SensitiveTextNotStartsWithAnyOf:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateSensitiveTextSliceEqualsAnyOf(text, condition.comparisonValue, context.setting.configJsonSalt, contextSalt, true, condition.comparator === (0, $aOidd.UserComparator).SensitiveTextNotStartsWithAnyOf);
            case (0, $aOidd.UserComparator).TextEndsWithAnyOf:
            case (0, $aOidd.UserComparator).TextNotEndsWithAnyOf:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateTextSliceEqualsAnyOf(text, condition.comparisonValue, false, condition.comparator === (0, $aOidd.UserComparator).TextNotEndsWithAnyOf);
            case (0, $aOidd.UserComparator).SensitiveTextEndsWithAnyOf:
            case (0, $aOidd.UserComparator).SensitiveTextNotEndsWithAnyOf:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateSensitiveTextSliceEqualsAnyOf(text, condition.comparisonValue, context.setting.configJsonSalt, contextSalt, false, condition.comparator === (0, $aOidd.UserComparator).SensitiveTextNotEndsWithAnyOf);
            case (0, $aOidd.UserComparator).TextContainsAnyOf:
            case (0, $aOidd.UserComparator).TextNotContainsAnyOf:
                text = $e469345ab0e6bf7a$var$getUserAttributeValueAsText(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return this.evaluateTextContainsAnyOf(text, condition.comparisonValue, condition.comparator === (0, $aOidd.UserComparator).TextNotContainsAnyOf);
            case (0, $aOidd.UserComparator).SemVerIsOneOf:
            case (0, $aOidd.UserComparator).SemVerIsNotOneOf:
                versionOrError = $e469345ab0e6bf7a$var$getUserAttributeValueAsSemVer(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return typeof versionOrError !== "string" ? this.evaluateSemVerIsOneOf(versionOrError, condition.comparisonValue, condition.comparator === (0, $aOidd.UserComparator).SemVerIsNotOneOf) : versionOrError;
            case (0, $aOidd.UserComparator).SemVerLess:
            case (0, $aOidd.UserComparator).SemVerLessOrEquals:
            case (0, $aOidd.UserComparator).SemVerGreater:
            case (0, $aOidd.UserComparator).SemVerGreaterOrEquals:
                versionOrError = $e469345ab0e6bf7a$var$getUserAttributeValueAsSemVer(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return typeof versionOrError !== "string" ? this.evaluateSemVerRelation(versionOrError, condition.comparator, condition.comparisonValue) : versionOrError;
            case (0, $aOidd.UserComparator).NumberEquals:
            case (0, $aOidd.UserComparator).NumberNotEquals:
            case (0, $aOidd.UserComparator).NumberLess:
            case (0, $aOidd.UserComparator).NumberLessOrEquals:
            case (0, $aOidd.UserComparator).NumberGreater:
            case (0, $aOidd.UserComparator).NumberGreaterOrEquals:
                numberOrError = $e469345ab0e6bf7a$var$getUserAttributeValueAsNumber(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return typeof numberOrError !== "string" ? this.evaluateNumberRelation(numberOrError, condition.comparator, condition.comparisonValue) : numberOrError;
            case (0, $aOidd.UserComparator).DateTimeBefore:
            case (0, $aOidd.UserComparator).DateTimeAfter:
                numberOrError = $e469345ab0e6bf7a$var$getUserAttributeValueAsUnixTimeSeconds(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return typeof numberOrError !== "string" ? this.evaluateDateTimeRelation(numberOrError, condition.comparisonValue, condition.comparator === (0, $aOidd.UserComparator).DateTimeBefore) : numberOrError;
            case (0, $aOidd.UserComparator).ArrayContainsAnyOf:
            case (0, $aOidd.UserComparator).ArrayNotContainsAnyOf:
                arrayOrError = $e469345ab0e6bf7a$var$getUserAttributeValueAsStringArray(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return typeof arrayOrError !== "string" ? this.evaluateArrayContainsAnyOf(arrayOrError, condition.comparisonValue, condition.comparator === (0, $aOidd.UserComparator).ArrayNotContainsAnyOf) : arrayOrError;
            case (0, $aOidd.UserComparator).SensitiveArrayContainsAnyOf:
            case (0, $aOidd.UserComparator).SensitiveArrayNotContainsAnyOf:
                arrayOrError = $e469345ab0e6bf7a$var$getUserAttributeValueAsStringArray(userAttributeName, userAttributeValue, condition, context.key, this.logger);
                return typeof arrayOrError !== "string" ? this.evaluateSensitiveArrayContainsAnyOf(arrayOrError, condition.comparisonValue, context.setting.configJsonSalt, contextSalt, condition.comparator === (0, $aOidd.UserComparator).SensitiveArrayNotContainsAnyOf) : arrayOrError;
            default:
                throw new Error(); // execution should never get here (unless there is an error in the config JSON)
        }
    };
    RolloutEvaluator.prototype.evaluateTextEquals = function(text, comparisonValue, negate) {
        return text === comparisonValue !== negate;
    };
    RolloutEvaluator.prototype.evaluateSensitiveTextEquals = function(text, comparisonValue, configJsonSalt, contextSalt, negate) {
        var hash = $e469345ab0e6bf7a$var$hashComparisonValue(text, configJsonSalt, contextSalt);
        return hash === comparisonValue !== negate;
    };
    RolloutEvaluator.prototype.evaluateTextIsOneOf = function(text, comparisonValues, negate) {
        // NOTE: Array.prototype.indexOf uses strict equality.
        var result = comparisonValues.indexOf(text) >= 0;
        return result !== negate;
    };
    RolloutEvaluator.prototype.evaluateSensitiveTextIsOneOf = function(text, comparisonValues, configJsonSalt, contextSalt, negate) {
        var hash = $e469345ab0e6bf7a$var$hashComparisonValue(text, configJsonSalt, contextSalt);
        // NOTE: Array.prototype.indexOf uses strict equality.
        var result = comparisonValues.indexOf(hash) >= 0;
        return result !== negate;
    };
    RolloutEvaluator.prototype.evaluateTextSliceEqualsAnyOf = function(text, comparisonValues, startsWith, negate) {
        for(var i = 0; i < comparisonValues.length; i++){
            var item = comparisonValues[i];
            if (text.length < item.length) continue;
            // NOTE: String.prototype.startsWith/endsWith were introduced after ES5. We'd rather work around them instead of polyfilling them.
            var result = (startsWith ? text.lastIndexOf(item, 0) : text.indexOf(item, text.length - item.length)) >= 0;
            if (result) return !negate;
        }
        return negate;
    };
    RolloutEvaluator.prototype.evaluateSensitiveTextSliceEqualsAnyOf = function(text, comparisonValues, configJsonSalt, contextSalt, startsWith, negate) {
        var textUtf8 = (0, $dzur7.utf8Encode)(text);
        for(var i = 0; i < comparisonValues.length; i++){
            var item = comparisonValues[i];
            var index = item.indexOf("_");
            var sliceLength = parseInt(item.slice(0, index));
            if (textUtf8.length < sliceLength) continue;
            var sliceUtf8 = startsWith ? textUtf8.slice(0, sliceLength) : textUtf8.slice(textUtf8.length - sliceLength);
            var hash = $e469345ab0e6bf7a$var$hashComparisonValueSlice(sliceUtf8, configJsonSalt, contextSalt);
            var result = hash === item.slice(index + 1);
            if (result) return !negate;
        }
        return negate;
    };
    RolloutEvaluator.prototype.evaluateTextContainsAnyOf = function(text, comparisonValues, negate) {
        for(var i = 0; i < comparisonValues.length; i++){
            if (text.indexOf(comparisonValues[i]) >= 0) return !negate;
        }
        return negate;
    };
    RolloutEvaluator.prototype.evaluateSemVerIsOneOf = function(version, comparisonValues, negate) {
        var result = false;
        for(var i = 0; i < comparisonValues.length; i++){
            var item = comparisonValues[i];
            // NOTE: Previous versions of the evaluation algorithm ignore empty comparison values.
            // We keep this behavior for backward compatibility.
            if (!item.length) continue;
            var version2 = (0, $7dX62.parse)(item.trim());
            if (!version2) // NOTE: Previous versions of the evaluation algorithm ignored invalid comparison values.
            // We keep this behavior for backward compatibility.
            return false;
            if (!result && version.compare(version2) === 0) // NOTE: Previous versions of the evaluation algorithm require that
            // none of the comparison values are empty or invalid, that is, we can't stop when finding a match.
            // We keep this behavior for backward compatibility.
            result = true;
        }
        return result !== negate;
    };
    RolloutEvaluator.prototype.evaluateSemVerRelation = function(version, comparator, comparisonValue) {
        var version2 = (0, $7dX62.parse)(comparisonValue.trim());
        if (!version2) return false;
        var comparisonResult = version.compare(version2);
        switch(comparator){
            case (0, $aOidd.UserComparator).SemVerLess:
                return comparisonResult < 0;
            case (0, $aOidd.UserComparator).SemVerLessOrEquals:
                return comparisonResult <= 0;
            case (0, $aOidd.UserComparator).SemVerGreater:
                return comparisonResult > 0;
            case (0, $aOidd.UserComparator).SemVerGreaterOrEquals:
                return comparisonResult >= 0;
        }
    };
    RolloutEvaluator.prototype.evaluateNumberRelation = function(number, comparator, comparisonValue) {
        switch(comparator){
            case (0, $aOidd.UserComparator).NumberEquals:
                return number === comparisonValue;
            case (0, $aOidd.UserComparator).NumberNotEquals:
                return number !== comparisonValue;
            case (0, $aOidd.UserComparator).NumberLess:
                return number < comparisonValue;
            case (0, $aOidd.UserComparator).NumberLessOrEquals:
                return number <= comparisonValue;
            case (0, $aOidd.UserComparator).NumberGreater:
                return number > comparisonValue;
            case (0, $aOidd.UserComparator).NumberGreaterOrEquals:
                return number >= comparisonValue;
        }
    };
    RolloutEvaluator.prototype.evaluateDateTimeRelation = function(number, comparisonValue, before) {
        return before ? number < comparisonValue : number > comparisonValue;
    };
    RolloutEvaluator.prototype.evaluateArrayContainsAnyOf = function(array, comparisonValues, negate) {
        for(var i = 0; i < array.length; i++){
            // NOTE: Array.prototype.indexOf uses strict equality.
            var result = comparisonValues.indexOf(array[i]) >= 0;
            if (result) return !negate;
        }
        return negate;
    };
    RolloutEvaluator.prototype.evaluateSensitiveArrayContainsAnyOf = function(array, comparisonValues, configJsonSalt, contextSalt, negate) {
        for(var i = 0; i < array.length; i++){
            var hash = $e469345ab0e6bf7a$var$hashComparisonValue(array[i], configJsonSalt, contextSalt);
            // NOTE: Array.prototype.indexOf uses strict equality.
            var result = comparisonValues.indexOf(hash) >= 0;
            if (result) return !negate;
        }
        return negate;
    };
    RolloutEvaluator.prototype.evaluatePrerequisiteFlagCondition = function(condition, context) {
        var logBuilder = context.logBuilder;
        logBuilder === null || logBuilder === void 0 || logBuilder.appendPrerequisiteFlagCondition(condition, context.settings);
        var prerequisiteFlagKey = condition.prerequisiteFlagKey;
        var prerequisiteFlag = context.settings[prerequisiteFlagKey];
        context.visitedFlags.push(context.key);
        if (context.visitedFlags.indexOf(prerequisiteFlagKey) >= 0) {
            context.visitedFlags.push(prerequisiteFlagKey);
            var dependencyCycle = (0, $dzur7.formatStringList)(context.visitedFlags, void 0, void 0, " -> ");
            throw new Error("Circular dependency detected between the following depending flags: " + dependencyCycle + ".");
        }
        var prerequisiteFlagContext = $e469345ab0e6bf7a$export$9743a6eccb1d671b.forPrerequisiteFlag(prerequisiteFlagKey, prerequisiteFlag, context);
        logBuilder === null || logBuilder === void 0 || logBuilder.newLine("(").increaseIndent().newLine("Evaluating prerequisite flag '" + prerequisiteFlagKey + "':");
        var prerequisiteFlagEvaluateResult = this.evaluateSetting(prerequisiteFlagContext);
        context.visitedFlags.pop();
        var prerequisiteFlagValue = prerequisiteFlagEvaluateResult.selectedValue.value;
        if (typeof prerequisiteFlagValue !== typeof condition.comparisonValue) {
            if ($e469345ab0e6bf7a$export$a0f4c9f7d8b8a082(prerequisiteFlagValue)) throw new Error("Type mismatch between comparison value '" + condition.comparisonValue + "' and prerequisite flag '" + prerequisiteFlagKey + "'.");
            else $e469345ab0e6bf7a$export$1107fc4e2f84ee21(prerequisiteFlagValue);
        }
        var result;
        switch(condition.comparator){
            case (0, $aOidd.PrerequisiteFlagComparator).Equals:
                result = prerequisiteFlagValue === condition.comparisonValue;
                break;
            case (0, $aOidd.PrerequisiteFlagComparator).NotEquals:
                result = prerequisiteFlagValue !== condition.comparisonValue;
                break;
            default:
                throw new Error(); // execution should never get here (unless there is an error in the config JSON)
        }
        logBuilder === null || logBuilder === void 0 || logBuilder.newLine("Prerequisite flag evaluation result: '" + (0, $gizTB.valueToString)(prerequisiteFlagValue) + "'.").newLine("Condition (").appendPrerequisiteFlagCondition(condition, context.settings).append(") evaluates to ").appendConditionResult(result).append(".").decreaseIndent().newLine(")");
        return result;
    };
    RolloutEvaluator.prototype.evaluateSegmentCondition = function(condition, context) {
        var logBuilder = context.logBuilder;
        logBuilder === null || logBuilder === void 0 || logBuilder.appendSegmentCondition(condition);
        if (!context.user) {
            if (!context.isMissingUserObjectLogged) {
                this.logger.userObjectIsMissing(context.key);
                context.isMissingUserObjectLogged = true;
            }
            return $e469345ab0e6bf7a$var$missingUserObjectError;
        }
        var segment = condition.segment;
        logBuilder === null || logBuilder === void 0 || logBuilder.newLine("(").increaseIndent().newLine("Evaluating segment '" + segment.name + "':");
        var segmentResult = this.evaluateConditions(segment.conditions, void 0, segment.name, context);
        var result = segmentResult;
        if (!$e469345ab0e6bf7a$var$isEvaluationError(result)) switch(condition.comparator){
            case (0, $aOidd.SegmentComparator).IsIn:
                break;
            case (0, $aOidd.SegmentComparator).IsNotIn:
                result = !result;
                break;
            default:
                throw new Error(); // execution should never get here (unless there is an error in the config JSON)
        }
        if (logBuilder) {
            logBuilder.newLine("Segment evaluation result: ");
            (!$e469345ab0e6bf7a$var$isEvaluationError(result) ? logBuilder.append("User " + (0, $gizTB.formatSegmentComparator)(segmentResult ? (0, $aOidd.SegmentComparator).IsIn : (0, $aOidd.SegmentComparator).IsNotIn)) : logBuilder.append(result)).append(".");
            logBuilder.newLine("Condition (").appendSegmentCondition(condition).append(")");
            (!$e469345ab0e6bf7a$var$isEvaluationError(result) ? logBuilder.append(" evaluates to ").appendConditionResult(result) : logBuilder.append(" failed to evaluate")).append(".");
            logBuilder.decreaseIndent().newLine(")");
        }
        return result;
    };
    return RolloutEvaluator;
}();
function $e469345ab0e6bf7a$var$isEvaluationError(isMatchOrError) {
    return typeof isMatchOrError === "string";
}
function $e469345ab0e6bf7a$var$hashComparisonValue(value, configJsonSalt, contextSalt) {
    return $e469345ab0e6bf7a$var$hashComparisonValueSlice((0, $dzur7.utf8Encode)(value), configJsonSalt, contextSalt);
}
function $e469345ab0e6bf7a$var$hashComparisonValueSlice(sliceUtf8, configJsonSalt, contextSalt) {
    return (0, $by1qu.sha256)(sliceUtf8 + (0, $dzur7.utf8Encode)(configJsonSalt) + (0, $dzur7.utf8Encode)(contextSalt));
}
function $e469345ab0e6bf7a$var$userAttributeValueToString(userAttributeValue) {
    return typeof userAttributeValue === "string" ? userAttributeValue : userAttributeValue instanceof Date ? userAttributeValue.getTime() / 1000 + "" : (0, $dzur7.isStringArray)(userAttributeValue) ? JSON.stringify(userAttributeValue) : userAttributeValue + "";
}
function $e469345ab0e6bf7a$var$getUserAttributeValueAsText(attributeName, attributeValue, condition, key, logger) {
    if (typeof attributeValue === "string") return attributeValue;
    attributeValue = $e469345ab0e6bf7a$var$userAttributeValueToString(attributeValue);
    logger.userObjectAttributeIsAutoConverted((0, $gizTB.formatUserCondition)(condition), key, attributeName, attributeValue);
    return attributeValue;
}
function $e469345ab0e6bf7a$var$getUserAttributeValueAsSemVer(attributeName, attributeValue, condition, key, logger) {
    var version;
    if (typeof attributeValue === "string" && (version = (0, $7dX62.parse)(attributeValue.trim()))) return version;
    return $e469345ab0e6bf7a$var$handleInvalidUserAttribute(logger, condition, key, attributeName, "'" + attributeValue + "' is not a valid semantic version");
}
function $e469345ab0e6bf7a$var$getUserAttributeValueAsNumber(attributeName, attributeValue, condition, key, logger) {
    if (typeof attributeValue === "number") return attributeValue;
    var number;
    if (typeof attributeValue === "string" && (!isNaN(number = (0, $dzur7.parseFloatStrict)(attributeValue.replace(",", "."))) || attributeValue.trim() === "NaN")) return number;
    return $e469345ab0e6bf7a$var$handleInvalidUserAttribute(logger, condition, key, attributeName, "'" + attributeValue + "' is not a valid decimal number");
}
function $e469345ab0e6bf7a$var$getUserAttributeValueAsUnixTimeSeconds(attributeName, attributeValue, condition, key, logger) {
    if (attributeValue instanceof Date) return attributeValue.getTime() / 1000;
    if (typeof attributeValue === "number") return attributeValue;
    var number;
    if (typeof attributeValue === "string" && (!isNaN(number = (0, $dzur7.parseFloatStrict)(attributeValue.replace(",", "."))) || attributeValue.trim() === "NaN")) return number;
    return $e469345ab0e6bf7a$var$handleInvalidUserAttribute(logger, condition, key, attributeName, "'" + attributeValue + "' is not a valid Unix timestamp (number of seconds elapsed since Unix epoch)");
}
function $e469345ab0e6bf7a$var$getUserAttributeValueAsStringArray(attributeName, attributeValue, condition, key, logger) {
    var stringArray = attributeValue;
    if (typeof stringArray === "string") try {
        stringArray = JSON.parse(stringArray);
    } catch (err) {}
    if ((0, $dzur7.isStringArray)(stringArray)) return stringArray;
    return $e469345ab0e6bf7a$var$handleInvalidUserAttribute(logger, condition, key, attributeName, "'" + attributeValue + "' is not a valid string array");
}
function $e469345ab0e6bf7a$var$handleInvalidUserAttribute(logger, condition, key, attributeName, reason) {
    logger.userObjectAttributeIsInvalid((0, $gizTB.formatUserCondition)(condition), key, reason, attributeName);
    return $e469345ab0e6bf7a$var$invalidUserAttributeError(attributeName, reason);
}
/* Helper functions */ function $e469345ab0e6bf7a$var$evaluationDetailsFromEvaluateResult(key, evaluateResult, fetchTime, user) {
    return {
        key: key,
        value: evaluateResult.selectedValue.value,
        variationId: evaluateResult.selectedValue.variationId,
        fetchTime: fetchTime,
        user: user,
        isDefaultValue: false,
        matchedTargetingRule: evaluateResult.matchedTargetingRule,
        matchedPercentageOption: evaluateResult.matchedPercentageOption
    };
}
function $e469345ab0e6bf7a$export$649986bfd107f89b(key, defaultValue, fetchTime, user, errorMessage, errorException) {
    return {
        key: key,
        value: defaultValue,
        fetchTime: fetchTime,
        user: user,
        isDefaultValue: true,
        errorMessage: errorMessage,
        errorException: errorException
    };
}
function $e469345ab0e6bf7a$export$fef61f332f2c0afc(evaluator, settings, key, defaultValue, user, remoteConfig, logger) {
    var errorMessage;
    if (!settings) {
        errorMessage = logger.configJsonIsNotPresentSingle(key, "defaultValue", defaultValue).toString();
        return $e469345ab0e6bf7a$export$649986bfd107f89b(key, defaultValue, $e469345ab0e6bf7a$export$779cfe25876e7f02(remoteConfig), user, errorMessage);
    }
    var setting = settings[key];
    if (!setting) {
        errorMessage = logger.settingEvaluationFailedDueToMissingKey(key, "defaultValue", defaultValue, (0, $dzur7.formatStringList)(Object.keys(settings))).toString();
        return $e469345ab0e6bf7a$export$649986bfd107f89b(key, defaultValue, $e469345ab0e6bf7a$export$779cfe25876e7f02(remoteConfig), user, errorMessage);
    }
    var evaluateResult = evaluator.evaluate(defaultValue, new $e469345ab0e6bf7a$export$9743a6eccb1d671b(key, setting, user, settings));
    return $e469345ab0e6bf7a$var$evaluationDetailsFromEvaluateResult(key, evaluateResult, $e469345ab0e6bf7a$export$779cfe25876e7f02(remoteConfig), user);
}
function $e469345ab0e6bf7a$export$67c37a03b3d5dd3f(evaluator, settings, user, remoteConfig, logger, defaultReturnValue) {
    var errors;
    if (!$e469345ab0e6bf7a$export$4b483ed1551db5f7(settings, logger, defaultReturnValue)) return [
        [],
        errors
    ];
    var evaluationDetailsArray = [];
    for(var _i = 0, _a = Object.entries(settings); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], setting = _b[1];
        var evaluationDetails = void 0;
        try {
            var evaluateResult = evaluator.evaluate(null, new $e469345ab0e6bf7a$export$9743a6eccb1d671b(key, setting, user, settings));
            evaluationDetails = $e469345ab0e6bf7a$var$evaluationDetailsFromEvaluateResult(key, evaluateResult, $e469345ab0e6bf7a$export$779cfe25876e7f02(remoteConfig), user);
        } catch (err) {
            errors !== null && errors !== void 0 ? errors : errors = [];
            errors.push(err);
            evaluationDetails = $e469345ab0e6bf7a$export$649986bfd107f89b(key, null, $e469345ab0e6bf7a$export$779cfe25876e7f02(remoteConfig), user, (0, $dzur7.errorToString)(err), err);
        }
        evaluationDetailsArray.push(evaluationDetails);
    }
    return [
        evaluationDetailsArray,
        errors
    ];
}
function $e469345ab0e6bf7a$export$4b483ed1551db5f7(settings, logger, defaultReturnValue) {
    if (!settings) {
        logger.configJsonIsNotPresent(defaultReturnValue);
        return false;
    }
    return true;
}
function $e469345ab0e6bf7a$export$a0f4c9f7d8b8a082(value) {
    return $e469345ab0e6bf7a$var$inferSettingType(value) !== -1;
}
function $e469345ab0e6bf7a$var$inferSettingType(value) {
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(typeof value){
        case "boolean":
            return (0, $aOidd.SettingType).Boolean;
        case "string":
            return (0, $aOidd.SettingType).String;
        case "number":
            return (0, $aOidd.SettingType).Double;
        default:
            return -1;
    }
}
function $e469345ab0e6bf7a$var$isCompatibleValue(value, settingType) {
    switch(settingType){
        case (0, $aOidd.SettingType).Boolean:
            return typeof value === "boolean";
        case (0, $aOidd.SettingType).String:
            return typeof value === "string";
        case (0, $aOidd.SettingType).Int:
        case (0, $aOidd.SettingType).Double:
            return typeof value === "number";
        default:
            return false;
    }
}
function $e469345ab0e6bf7a$export$1107fc4e2f84ee21(value) {
    throw new TypeError(value === null ? "Setting value is null." : value === void 0 ? "Setting value is undefined." : "Setting value '" + value + "' is of an unsupported type (" + typeof value + ").");
}
function $e469345ab0e6bf7a$export$779cfe25876e7f02(projectConfig) {
    return projectConfig ? new Date(projectConfig.timestamp) : void 0;
}

});
parcelRegister("gizTB", function(module, exports) {

$parcel$export(module.exports, "EvaluateLogBuilder", function () { return $bdda2bedeaa4c162$export$b5ab735495409d51; });
$parcel$export(module.exports, "valueToString", function () { return $bdda2bedeaa4c162$export$7fcada0453713929; });
$parcel$export(module.exports, "formatSegmentComparator", function () { return $bdda2bedeaa4c162$export$7b425ed186aee2fd; });
$parcel$export(module.exports, "formatUserCondition", function () { return $bdda2bedeaa4c162$export$58df4b3ce5d5abfc; });

var $aOidd = parcelRequire("aOidd");

var $jBPdJ = parcelRequire("jBPdJ");

var $dzur7 = parcelRequire("dzur7");
var $bdda2bedeaa4c162$var$invalidValuePlaceholder = "<invalid value>";
var $bdda2bedeaa4c162$var$invalidNamePlaceholder = "<invalid name>";
var $bdda2bedeaa4c162$var$invalidOperatorPlaceholder = "<invalid operator>";
var $bdda2bedeaa4c162$var$invalidReferencePlaceholder = "<invalid reference>";
var $bdda2bedeaa4c162$var$stringListMaxLength = 10;
var $bdda2bedeaa4c162$export$b5ab735495409d51 = /** @class */ function() {
    function EvaluateLogBuilder(eol) {
        this.eol = eol;
        this.log = "";
        this.indent = "";
    }
    EvaluateLogBuilder.prototype.resetIndent = function() {
        this.indent = "";
        return this;
    };
    EvaluateLogBuilder.prototype.increaseIndent = function() {
        this.indent += "  ";
        return this;
    };
    EvaluateLogBuilder.prototype.decreaseIndent = function() {
        this.indent = this.indent.slice(0, -2);
        return this;
    };
    EvaluateLogBuilder.prototype.newLine = function(text) {
        this.log += this.eol + this.indent + (text !== null && text !== void 0 ? text : "");
        return this;
    };
    EvaluateLogBuilder.prototype.append = function(text) {
        this.log += text;
        return this;
    };
    EvaluateLogBuilder.prototype.toString = function() {
        return this.log;
    };
    EvaluateLogBuilder.prototype.appendUserConditionCore = function(comparisonAttribute, comparator, comparisonValue) {
        return this.append("User." + comparisonAttribute + " " + $bdda2bedeaa4c162$export$3222c049b6aae5f5(comparator) + " '" + (comparisonValue !== null && comparisonValue !== void 0 ? comparisonValue : $bdda2bedeaa4c162$var$invalidValuePlaceholder) + "'");
    };
    EvaluateLogBuilder.prototype.appendUserConditionString = function(comparisonAttribute, comparator, comparisonValue, isSensitive) {
        if (typeof comparisonValue !== "string") return this.appendUserConditionCore(comparisonAttribute, comparator);
        return this.appendUserConditionCore(comparisonAttribute, comparator, !isSensitive ? comparisonValue : "<hashed value>");
    };
    EvaluateLogBuilder.prototype.appendUserConditionStringList = function(comparisonAttribute, comparator, comparisonValue, isSensitive) {
        if (!(0, $dzur7.isStringArray)(comparisonValue)) return this.appendUserConditionCore(comparisonAttribute, comparator);
        var valueText = "value", valuesText = "values";
        var comparatorFormatted = $bdda2bedeaa4c162$export$3222c049b6aae5f5(comparator);
        if (isSensitive) return this.append("User." + comparisonAttribute + " " + comparatorFormatted + " [<" + comparisonValue.length + " hashed " + (comparisonValue.length === 1 ? valueText : valuesText) + ">]");
        else {
            var comparisonValueFormatted = (0, $dzur7.formatStringList)(comparisonValue, $bdda2bedeaa4c162$var$stringListMaxLength, function(count) {
                return ", ... <" + count + " more " + (count === 1 ? valueText : valuesText) + ">";
            });
            return this.append("User." + comparisonAttribute + " " + comparatorFormatted + " [" + comparisonValueFormatted + "]");
        }
    };
    EvaluateLogBuilder.prototype.appendUserConditionNumber = function(comparisonAttribute, comparator, comparisonValue, isDateTime) {
        if (typeof comparisonValue !== "number") return this.appendUserConditionCore(comparisonAttribute, comparator);
        var comparatorFormatted = $bdda2bedeaa4c162$export$3222c049b6aae5f5(comparator);
        var date;
        return isDateTime && !isNaN(date = new Date(comparisonValue * 1000)) // see https://stackoverflow.com/a/1353711/8656352
         ? this.append("User." + comparisonAttribute + " " + comparatorFormatted + " '" + comparisonValue + "' (" + date.toISOString() + " UTC)") : this.append("User." + comparisonAttribute + " " + comparatorFormatted + " '" + comparisonValue + "'");
    };
    EvaluateLogBuilder.prototype.appendUserCondition = function(condition) {
        var comparisonAttribute = typeof condition.comparisonAttribute === "string" ? condition.comparisonAttribute : $bdda2bedeaa4c162$var$invalidNamePlaceholder;
        var comparator = condition.comparator;
        switch(condition.comparator){
            case (0, $aOidd.UserComparator).TextIsOneOf:
            case (0, $aOidd.UserComparator).TextIsNotOneOf:
            case (0, $aOidd.UserComparator).TextContainsAnyOf:
            case (0, $aOidd.UserComparator).TextNotContainsAnyOf:
            case (0, $aOidd.UserComparator).SemVerIsOneOf:
            case (0, $aOidd.UserComparator).SemVerIsNotOneOf:
            case (0, $aOidd.UserComparator).TextStartsWithAnyOf:
            case (0, $aOidd.UserComparator).TextNotStartsWithAnyOf:
            case (0, $aOidd.UserComparator).TextEndsWithAnyOf:
            case (0, $aOidd.UserComparator).TextNotEndsWithAnyOf:
            case (0, $aOidd.UserComparator).ArrayContainsAnyOf:
            case (0, $aOidd.UserComparator).ArrayNotContainsAnyOf:
                return this.appendUserConditionStringList(comparisonAttribute, comparator, condition.comparisonValue, false);
            case (0, $aOidd.UserComparator).SemVerLess:
            case (0, $aOidd.UserComparator).SemVerLessOrEquals:
            case (0, $aOidd.UserComparator).SemVerGreater:
            case (0, $aOidd.UserComparator).SemVerGreaterOrEquals:
            case (0, $aOidd.UserComparator).TextEquals:
            case (0, $aOidd.UserComparator).TextNotEquals:
                return this.appendUserConditionString(comparisonAttribute, comparator, condition.comparisonValue, false);
            case (0, $aOidd.UserComparator).NumberEquals:
            case (0, $aOidd.UserComparator).NumberNotEquals:
            case (0, $aOidd.UserComparator).NumberLess:
            case (0, $aOidd.UserComparator).NumberLessOrEquals:
            case (0, $aOidd.UserComparator).NumberGreater:
            case (0, $aOidd.UserComparator).NumberGreaterOrEquals:
                return this.appendUserConditionNumber(comparisonAttribute, comparator, condition.comparisonValue);
            case (0, $aOidd.UserComparator).SensitiveTextIsOneOf:
            case (0, $aOidd.UserComparator).SensitiveTextIsNotOneOf:
            case (0, $aOidd.UserComparator).SensitiveTextStartsWithAnyOf:
            case (0, $aOidd.UserComparator).SensitiveTextNotStartsWithAnyOf:
            case (0, $aOidd.UserComparator).SensitiveTextEndsWithAnyOf:
            case (0, $aOidd.UserComparator).SensitiveTextNotEndsWithAnyOf:
            case (0, $aOidd.UserComparator).SensitiveArrayContainsAnyOf:
            case (0, $aOidd.UserComparator).SensitiveArrayNotContainsAnyOf:
                return this.appendUserConditionStringList(comparisonAttribute, comparator, condition.comparisonValue, true);
            case (0, $aOidd.UserComparator).DateTimeBefore:
            case (0, $aOidd.UserComparator).DateTimeAfter:
                return this.appendUserConditionNumber(comparisonAttribute, comparator, condition.comparisonValue, true);
            case (0, $aOidd.UserComparator).SensitiveTextEquals:
            case (0, $aOidd.UserComparator).SensitiveTextNotEquals:
                return this.appendUserConditionString(comparisonAttribute, comparator, condition.comparisonValue, true);
            default:
                return this.appendUserConditionCore(comparisonAttribute, comparator, condition.comparisonValue);
        }
    };
    EvaluateLogBuilder.prototype.appendPrerequisiteFlagCondition = function(condition, settings) {
        var prerequisiteFlagKey = typeof condition.prerequisiteFlagKey !== "string" ? $bdda2bedeaa4c162$var$invalidNamePlaceholder : !(condition.prerequisiteFlagKey in settings) ? $bdda2bedeaa4c162$var$invalidReferencePlaceholder : condition.prerequisiteFlagKey;
        var comparator = condition.comparator;
        var comparisonValue = condition.comparisonValue;
        return this.append("Flag '" + prerequisiteFlagKey + "' " + $bdda2bedeaa4c162$export$901357db83c8e64a(comparator) + " '" + $bdda2bedeaa4c162$export$7fcada0453713929(comparisonValue) + "'");
    };
    EvaluateLogBuilder.prototype.appendSegmentCondition = function(condition) {
        var segment = condition.segment;
        var comparator = condition.comparator;
        var segmentName = segment == null ? $bdda2bedeaa4c162$var$invalidReferencePlaceholder : typeof segment.name !== "string" || !segment.name ? $bdda2bedeaa4c162$var$invalidNamePlaceholder : segment.name;
        return this.append("User " + $bdda2bedeaa4c162$export$7b425ed186aee2fd(comparator) + " '" + segmentName + "'");
    };
    EvaluateLogBuilder.prototype.appendConditionResult = function(result) {
        return this.append("" + result);
    };
    EvaluateLogBuilder.prototype.appendConditionConsequence = function(result) {
        this.append(" => ").appendConditionResult(result);
        return result ? this : this.append(", skipping the remaining AND conditions");
    };
    EvaluateLogBuilder.prototype.appendTargetingRuleThenPart = function(targetingRule, newLine) {
        (newLine ? this.newLine() : this.append(" ")).append("THEN");
        var then = targetingRule.then;
        return this.append(!(0, $dzur7.isArray)(then) ? " '" + $bdda2bedeaa4c162$export$7fcada0453713929(then.value) + "'" : " % options");
    };
    EvaluateLogBuilder.prototype.appendTargetingRuleConsequence = function(targetingRule, isMatchOrError, newLine) {
        this.increaseIndent();
        this.appendTargetingRuleThenPart(targetingRule, newLine).append(" => ").append(isMatchOrError === true ? "MATCH, applying rule" : isMatchOrError === false ? "no match" : isMatchOrError);
        return this.decreaseIndent();
    };
    return EvaluateLogBuilder;
}();
function $bdda2bedeaa4c162$export$3222c049b6aae5f5(comparator) {
    switch(comparator){
        case (0, $aOidd.UserComparator).TextIsOneOf:
        case (0, $aOidd.UserComparator).SensitiveTextIsOneOf:
        case (0, $aOidd.UserComparator).SemVerIsOneOf:
            return "IS ONE OF";
        case (0, $aOidd.UserComparator).TextIsNotOneOf:
        case (0, $aOidd.UserComparator).SensitiveTextIsNotOneOf:
        case (0, $aOidd.UserComparator).SemVerIsNotOneOf:
            return "IS NOT ONE OF";
        case (0, $aOidd.UserComparator).TextContainsAnyOf:
            return "CONTAINS ANY OF";
        case (0, $aOidd.UserComparator).TextNotContainsAnyOf:
            return "NOT CONTAINS ANY OF";
        case (0, $aOidd.UserComparator).SemVerLess:
        case (0, $aOidd.UserComparator).NumberLess:
            return "<";
        case (0, $aOidd.UserComparator).SemVerLessOrEquals:
        case (0, $aOidd.UserComparator).NumberLessOrEquals:
            return "<=";
        case (0, $aOidd.UserComparator).SemVerGreater:
        case (0, $aOidd.UserComparator).NumberGreater:
            return ">";
        case (0, $aOidd.UserComparator).SemVerGreaterOrEquals:
        case (0, $aOidd.UserComparator).NumberGreaterOrEquals:
            return ">=";
        case (0, $aOidd.UserComparator).NumberEquals:
            return "=";
        case (0, $aOidd.UserComparator).NumberNotEquals:
            return "!=";
        case (0, $aOidd.UserComparator).DateTimeBefore:
            return "BEFORE";
        case (0, $aOidd.UserComparator).DateTimeAfter:
            return "AFTER";
        case (0, $aOidd.UserComparator).TextEquals:
        case (0, $aOidd.UserComparator).SensitiveTextEquals:
            return "EQUALS";
        case (0, $aOidd.UserComparator).TextNotEquals:
        case (0, $aOidd.UserComparator).SensitiveTextNotEquals:
            return "NOT EQUALS";
        case (0, $aOidd.UserComparator).TextStartsWithAnyOf:
        case (0, $aOidd.UserComparator).SensitiveTextStartsWithAnyOf:
            return "STARTS WITH ANY OF";
        case (0, $aOidd.UserComparator).TextNotStartsWithAnyOf:
        case (0, $aOidd.UserComparator).SensitiveTextNotStartsWithAnyOf:
            return "NOT STARTS WITH ANY OF";
        case (0, $aOidd.UserComparator).TextEndsWithAnyOf:
        case (0, $aOidd.UserComparator).SensitiveTextEndsWithAnyOf:
            return "ENDS WITH ANY OF";
        case (0, $aOidd.UserComparator).TextNotEndsWithAnyOf:
        case (0, $aOidd.UserComparator).SensitiveTextNotEndsWithAnyOf:
            return "NOT ENDS WITH ANY OF";
        case (0, $aOidd.UserComparator).ArrayContainsAnyOf:
        case (0, $aOidd.UserComparator).SensitiveArrayContainsAnyOf:
            return "ARRAY CONTAINS ANY OF";
        case (0, $aOidd.UserComparator).ArrayNotContainsAnyOf:
        case (0, $aOidd.UserComparator).SensitiveArrayNotContainsAnyOf:
            return "ARRAY NOT CONTAINS ANY OF";
        default:
            return $bdda2bedeaa4c162$var$invalidOperatorPlaceholder;
    }
}
function $bdda2bedeaa4c162$export$58df4b3ce5d5abfc(condition) {
    return new $bdda2bedeaa4c162$export$b5ab735495409d51("").appendUserCondition(condition).toString();
}
function $bdda2bedeaa4c162$export$901357db83c8e64a(comparator) {
    switch(comparator){
        case (0, $aOidd.PrerequisiteFlagComparator).Equals:
            return "EQUALS";
        case (0, $aOidd.PrerequisiteFlagComparator).NotEquals:
            return "NOT EQUALS";
        default:
            return $bdda2bedeaa4c162$var$invalidOperatorPlaceholder;
    }
}
function $bdda2bedeaa4c162$export$7b425ed186aee2fd(comparator) {
    switch(comparator){
        case (0, $aOidd.SegmentComparator).IsIn:
            return "IS IN SEGMENT";
        case (0, $aOidd.SegmentComparator).IsNotIn:
            return "IS NOT IN SEGMENT";
        default:
            return $bdda2bedeaa4c162$var$invalidOperatorPlaceholder;
    }
}
function $bdda2bedeaa4c162$export$7fcada0453713929(value) {
    return (0, $jBPdJ.isAllowedValue)(value) ? value.toString() : $bdda2bedeaa4c162$var$invalidValuePlaceholder;
}

});

parcelRegister("7dX62", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $5427969c64f373ff$export$98e6a39c04603d36; });
var $5427969c64f373ff$var$numeric = /^[0-9]+$/;
var $5427969c64f373ff$var$compareIdentifiers = function(a, b) {
    var anum = $5427969c64f373ff$var$numeric.test(a);
    var bnum = $5427969c64f373ff$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
var $5427969c64f373ff$var$rcompareIdentifiers = function(a, b) {
    return $5427969c64f373ff$var$compareIdentifiers(b, a);
};
var $5427969c64f373ff$var$SEMVER_SPEC_VERSION = '2.0.0';
var $5427969c64f373ff$var$MAX_LENGTH = 256;
var $5427969c64f373ff$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
var $5427969c64f373ff$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// The actual regexps go on exports.re
var $5427969c64f373ff$var$re = [];
var $5427969c64f373ff$var$src = [];
var $5427969c64f373ff$var$t = {};
var $5427969c64f373ff$var$R = 0;
var $5427969c64f373ff$var$createToken = function(name, value) {
    var index = $5427969c64f373ff$var$R++;
    $5427969c64f373ff$var$t[name] = index;
    $5427969c64f373ff$var$src[index] = value;
    $5427969c64f373ff$var$re[index] = new RegExp(value);
};
$5427969c64f373ff$var$createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
$5427969c64f373ff$var$createToken('NUMERICIDENTIFIERLOOSE', '[0-9]+');
$5427969c64f373ff$var$createToken('NONNUMERICIDENTIFIER', '\\d*[a-zA-Z-][a-zA-Z0-9-]*');
$5427969c64f373ff$var$createToken('MAINVERSION', "(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIER']] + ")\\." + ("(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIER']] + ")\\.") + ("(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIER']] + ")"));
$5427969c64f373ff$var$createToken('MAINVERSIONLOOSE', "(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIERLOOSE']] + ")\\." + ("(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIERLOOSE']] + ")\\.") + ("(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIERLOOSE']] + ")"));
$5427969c64f373ff$var$createToken('PRERELEASEIDENTIFIER', "(?:" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIER']] + "|" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NONNUMERICIDENTIFIER']] + ")");
$5427969c64f373ff$var$createToken('PRERELEASEIDENTIFIERLOOSE', "(?:" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NUMERICIDENTIFIERLOOSE']] + "|" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['NONNUMERICIDENTIFIER']] + ")");
$5427969c64f373ff$var$createToken('PRERELEASE', "(?:-(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['PRERELEASEIDENTIFIER']] + "(?:\\." + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['PRERELEASEIDENTIFIER']] + ")*))");
$5427969c64f373ff$var$createToken('PRERELEASELOOSE', "(?:-?(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['PRERELEASEIDENTIFIERLOOSE']] + "(?:\\." + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['PRERELEASEIDENTIFIERLOOSE']] + ")*))");
$5427969c64f373ff$var$createToken('BUILDIDENTIFIER', '[0-9A-Za-z-]+');
$5427969c64f373ff$var$createToken('BUILD', "(?:\\+(" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['BUILDIDENTIFIER']] + "(?:\\." + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['BUILDIDENTIFIER']] + ")*))");
$5427969c64f373ff$var$createToken('FULLPLAIN', "v?" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['MAINVERSION']] + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['PRERELEASE']] + "?" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['BUILD']] + "?");
$5427969c64f373ff$var$createToken('FULL', "^" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['FULLPLAIN']] + "$");
$5427969c64f373ff$var$createToken('LOOSEPLAIN', "[v=\\s]*" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['MAINVERSIONLOOSE']] + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['PRERELEASELOOSE']] + "?" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['BUILD']] + "?");
$5427969c64f373ff$var$createToken('LOOSE', "^" + $5427969c64f373ff$var$src[$5427969c64f373ff$var$t['LOOSEPLAIN']] + "$");
var $5427969c64f373ff$var$SemVer = /** @class */ function() {
    function SemVer(version, options) {
        if (!options || typeof options !== 'object') options = {
            loose: !!options,
            includePrerelease: false
        };
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError("Invalid Version: " + version);
        if (version.length > $5427969c64f373ff$var$MAX_LENGTH) throw new TypeError("version is longer than " + $5427969c64f373ff$var$MAX_LENGTH + " characters");
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        var m = version.trim().match(options.loose ? $5427969c64f373ff$var$re[$5427969c64f373ff$var$t['LOOSE']] : $5427969c64f373ff$var$re[$5427969c64f373ff$var$t['FULL']]);
        if (!m) throw new TypeError("Invalid Version: " + version);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $5427969c64f373ff$var$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > $5427969c64f373ff$var$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > $5427969c64f373ff$var$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map(function(id) {
            if (/^[0-9]+$/.test(id)) {
                var num = +id;
                if (num >= 0 && num < $5427969c64f373ff$var$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    SemVer.prototype.format = function() {
        this.version = this.major + "." + this.minor + "." + this.patch;
        if (this.prerelease.length) this.version += "-" + this.prerelease.join('.');
        return this.version;
    };
    SemVer.prototype.toString = function() {
        return this.version;
    };
    SemVer.prototype.compare = function(other) {
        if (!(other instanceof SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    };
    SemVer.prototype.compareMain = function(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        return $5427969c64f373ff$var$compareIdentifiers(this.major, other.major) || $5427969c64f373ff$var$compareIdentifiers(this.minor, other.minor) || $5427969c64f373ff$var$compareIdentifiers(this.patch, other.patch);
    };
    SemVer.prototype.comparePre = function(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        var i = 0;
        do {
            var a = this.prerelease[i];
            var b = other.prerelease[i];
            if (a === void 0 && b === void 0) return 0;
            else if (b === void 0) return 1;
            else if (a === void 0) return -1;
            else if (a === b) continue;
            else return $5427969c64f373ff$var$compareIdentifiers(a, b);
        }while (++i);
    };
    SemVer.prototype.compareBuild = function(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        var i = 0;
        do {
            var a = this.build[i];
            var b = other.build[i];
            if (a === void 0 && b === void 0) return 0;
            else if (b === void 0) return 1;
            else if (a === void 0) return -1;
            else if (a === b) continue;
            else return $5427969c64f373ff$var$compareIdentifiers(a, b);
        }while (++i);
    };
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    SemVer.prototype.inc = function(release, identifier) {
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier);
                this.inc('pre', identifier);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier);
                this.inc('pre', identifier);
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                if (this.prerelease.length === 0) this.prerelease = [
                    0
                ];
                else {
                    var i = this.prerelease.length;
                    while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                        this.prerelease[i]++;
                        i = -2;
                    }
                    if (i === -1) // didn't increment anything
                    this.prerelease.push(0);
                }
                if (identifier) {
                    // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                    // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                    if (this.prerelease[0] === identifier) {
                        if (isNaN(this.prerelease[1])) this.prerelease = [
                            identifier,
                            0
                        ];
                    } else this.prerelease = [
                        identifier,
                        0
                    ];
                }
                break;
            default:
                throw new Error("invalid increment argument: " + release);
        }
        this.format();
        this.raw = this.version;
        return this;
    };
    return SemVer;
}();
var $5427969c64f373ff$export$98e6a39c04603d36 = function(version, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof $5427969c64f373ff$var$SemVer) return version;
    if (typeof version !== 'string') return null;
    if (version.length > $5427969c64f373ff$var$MAX_LENGTH) return null;
    var r = options.loose ? $5427969c64f373ff$var$re[$5427969c64f373ff$var$t['LOOSE']] : $5427969c64f373ff$var$re[$5427969c64f373ff$var$t['FULL']];
    if (!r.test(version)) return null;
    try {
        return new $5427969c64f373ff$var$SemVer(version, options);
    } catch (er) {
        return null;
    }
};

});




parcelRegister("7NnoB", function(module, exports) {

$parcel$export(module.exports, "getClient", function () { return $5acf41ed8230b00e$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "PollingMode", function () { return (parcelRequire("isReF")).PollingMode; });

var $ihF1l = parcelRequire("ihF1l");
var $isReF = parcelRequire("isReF");
var $djkK5 = parcelRequire("djkK5");

var $4NEcB = parcelRequire("4NEcB");

var $8z4r3 = parcelRequire("8z4r3");

var $dnm1W = parcelRequire("dnm1W");
function $5acf41ed8230b00e$export$6bb76d6eba7e258c(sdkKey, pollingMode, options) {
    return (0, $ihF1l.getClient)(sdkKey, pollingMode !== null && pollingMode !== void 0 ? pollingMode : (0, $isReF.PollingMode).AutoPoll, options, (0, $4NEcB.LocalStorageCache).setup({
        configFetcher: new (0, $8z4r3.HttpConfigFetcher)(),
        sdkType: "ConfigCat-JS",
        sdkVersion: (0, $dnm1W.default)
    }));
}
function $5acf41ed8230b00e$export$2e2bcd8739ae039(sdkKey, options) {
    return $5acf41ed8230b00e$export$6bb76d6eba7e258c(sdkKey, (0, $isReF.PollingMode).AutoPoll, options);
}

});
parcelRegister("4NEcB", function(module, exports) {

$parcel$export(module.exports, "LocalStorageCache", function () { return $37eaec5aaa808012$export$40ef2cb682e70737; });

var $8ZGXJ = parcelRequire("8ZGXJ");
var $37eaec5aaa808012$export$40ef2cb682e70737 = /** @class */ function() {
    function LocalStorageCache(storage) {
        this.storage = storage;
    }
    LocalStorageCache.setup = function(kernel, localStorageGetter) {
        var localStorage = (localStorageGetter !== null && localStorageGetter !== void 0 ? localStorageGetter : $37eaec5aaa808012$export$d3720feff416e85b)();
        if (localStorage) kernel.defaultCacheFactory = function(options) {
            return new (0, $8ZGXJ.ExternalConfigCache)(new LocalStorageCache(localStorage), options.logger);
        };
        return kernel;
    };
    LocalStorageCache.prototype.set = function(key, value) {
        this.storage.setItem(key, $37eaec5aaa808012$export$e5fb31decd58fe50(value));
    };
    LocalStorageCache.prototype.get = function(key) {
        var configString = this.storage.getItem(key);
        if (configString) return $37eaec5aaa808012$export$425f1563ccb49a0b(configString);
    };
    return LocalStorageCache;
}();
function $37eaec5aaa808012$export$d3720feff416e85b() {
    var testKey = "__configcat_localStorage_test";
    try {
        var storage = window.localStorage;
        storage.setItem(testKey, testKey);
        var retrievedItem = void 0;
        try {
            retrievedItem = storage.getItem(testKey);
        } finally{
            storage.removeItem(testKey);
        }
        if (retrievedItem === testKey) return storage;
    } catch (err) {}
    return null;
}
function $37eaec5aaa808012$export$e5fb31decd58fe50(str) {
    str = encodeURIComponent(str);
    str = str.replace(/%([0-9A-F]{2})/g, function(_, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    });
    return btoa(str);
}
function $37eaec5aaa808012$export$425f1563ccb49a0b(str) {
    str = atob(str);
    str = str.replace(/[%\x80-\xFF]/g, function(m) {
        return "%" + m.charCodeAt(0).toString(16);
    });
    return decodeURIComponent(str);
}

});

parcelRegister("8z4r3", function(module, exports) {

$parcel$export(module.exports, "HttpConfigFetcher", function () { return $63c50868cd72c47d$export$ab6857e3f374c197; });

var $MHqav = parcelRequire("MHqav");
var $63c50868cd72c47d$export$ab6857e3f374c197 = /** @class */ function() {
    function HttpConfigFetcher() {}
    HttpConfigFetcher.prototype.handleStateChange = function(httpRequest, resolve, reject) {
        var _a;
        try {
            if (httpRequest.readyState === 4) {
                var statusCode = httpRequest.status, reasonPhrase = httpRequest.statusText;
                if (statusCode === 200) {
                    var eTag = (_a = httpRequest.getResponseHeader("ETag")) !== null && _a !== void 0 ? _a : void 0;
                    resolve({
                        statusCode: statusCode,
                        reasonPhrase: reasonPhrase,
                        eTag: eTag,
                        body: httpRequest.responseText
                    });
                } else if (statusCode) resolve({
                    statusCode: statusCode,
                    reasonPhrase: reasonPhrase
                });
            }
        } catch (err) {
            reject(err);
        }
    };
    HttpConfigFetcher.prototype.fetchLogic = function(options, lastEtag) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                options.logger.debug("HttpConfigFetcher.fetchLogic() called.");
                var httpRequest_1 = new XMLHttpRequest();
                httpRequest_1.onreadystatechange = function() {
                    return _this.handleStateChange(httpRequest_1, resolve, reject);
                };
                httpRequest_1.ontimeout = function() {
                    return reject(new (0, $MHqav.FetchError)("timeout", options.requestTimeoutMs));
                };
                httpRequest_1.onabort = function() {
                    return reject(new (0, $MHqav.FetchError)("abort"));
                };
                httpRequest_1.onerror = function() {
                    return reject(new (0, $MHqav.FetchError)("failure"));
                };
                var url = options.getUrl();
                if (lastEtag) // We are sending the etag as a query parameter so if the browser doesn't automatically adds the If-None-Match header, we can transorm this query param to the header in our CDN provider.
                url += "&ccetag=" + encodeURIComponent(lastEtag);
                httpRequest_1.open("GET", url, true);
                httpRequest_1.timeout = options.requestTimeoutMs;
                // NOTE: It's intentional that we don't specify the If-None-Match header.
                // The browser automatically handles it, adding it manually would cause an unnecessary CORS OPTIONS request.
                // In case the browser doesn't handle it, we are transforming the ccetag query parameter to the If-None-Match header in our CDN provider.
                httpRequest_1.send(null);
            } catch (err) {
                reject(err);
            }
        });
    };
    return HttpConfigFetcher;
}();

});

parcelRegister("dnm1W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bce831bca5a0a00$export$2e2bcd8739ae039; });
var $9bce831bca5a0a00$export$2e2bcd8739ae039 = "9.6.0";

});



parcelRegister("fj1oy", function(module, exports) {

$parcel$export(module.exports, "convertEntriesToSegment", function () { return $85edc6496af03946$export$c3a0e093733a5d7c; });
$parcel$export(module.exports, "keepIdOnly", function () { return $85edc6496af03946$export$c2f96542fdf6afe5; });
$parcel$export(module.exports, "getModuleVisibility", function () { return $85edc6496af03946$export$ee95238f1f7df4d1; });
$parcel$export(module.exports, "getEntryVisibility", function () { return $85edc6496af03946$export$587f0b6268429cc0; });

var $98kgb = parcelRequire("98kgb");
var $bVGbk = parcelRequire("bVGbk");
var $eoV8o = parcelRequire("eoV8o");

var $gyNqR = parcelRequire("gyNqR");

var $gtsdT = parcelRequire("gtsdT");
// If you get an entry with multiple comma separated values, this fuctuon splits it into an array
// E.g. ["102030, 100300", "109770"] => ["102030", "100300", "109770"]
const $85edc6496af03946$var$flattenListField = (field)=>{
    if (field?.length) return field.flatMap((value)=>value.replace(/\s/g, "").split(","));
    return field;
};
const $85edc6496af03946$export$9826fe7ad3921016 = (array1, array2)=>(0, $eoV8o.default)((0, $98kgb.default)(array1, array2)).filter((element)=>!!element);
const $85edc6496af03946$var$getCustomerAttributesFromEntryFields = (entry)=>{
    const customerAttributes = [];
    if (entry?.fields.loggedIn) customerAttributes.push("loggedIn");
    if (entry?.fields.punchoutCustomer) customerAttributes.push("punchoutCustomer");
    return customerAttributes;
};
const $85edc6496af03946$export$c3a0e093733a5d7c = (entries)=>entries.reduce((result, entry)=>{
        if (entry && !entry.fields) {
            (0, $gtsdT.logger).warn("utils", "Encountered segment entry without fields, skipping...", entry);
            return result;
        }
        return entry ? {
            customerNumber: $85edc6496af03946$export$9826fe7ad3921016(result.customerNumber, $85edc6496af03946$var$flattenListField(entry.fields.customerNumbers)),
            chains: $85edc6496af03946$export$9826fe7ad3921016(result.chains, $85edc6496af03946$var$flattenListField(entry.fields.chains)),
            customerGroups: $85edc6496af03946$export$9826fe7ad3921016(result.customerGroups, $85edc6496af03946$var$flattenListField(entry.fields.customerGroups)),
            customerWarehouses: $85edc6496af03946$export$9826fe7ad3921016(result.customerWarehouses, $85edc6496af03946$var$flattenListField(entry.fields.customerWarehouses)),
            customerAttributes: $85edc6496af03946$export$9826fe7ad3921016(result.customerAttributes, $85edc6496af03946$var$getCustomerAttributesFromEntryFields(entry))
        } : result;
    }, {
        customerNumber: [],
        chains: [],
        customerGroups: [],
        customerWarehouses: [],
        customerAttributes: []
    });
const $85edc6496af03946$export$38bceec26af94ae6 = (array1, array2)=>(0, $bVGbk.default)(array1, array2).filter((element)=>!!element).length > 0;
const $85edc6496af03946$export$ae783ece9825c8d3 = ({ customerNumber: customerNumber, chains: chains, customerGroups: customerGroups, customerWarehouses: customerWarehouses, customerAttributes: customerAttributes }, currentCustomerProperties)=>{
    return $85edc6496af03946$export$38bceec26af94ae6(customerNumber, currentCustomerProperties.customerNumber) || $85edc6496af03946$export$38bceec26af94ae6(chains, currentCustomerProperties.chains) || $85edc6496af03946$export$38bceec26af94ae6(customerGroups, currentCustomerProperties.customerGroups) || $85edc6496af03946$export$38bceec26af94ae6(customerWarehouses, currentCustomerProperties.customerWarehouses) || $85edc6496af03946$export$38bceec26af94ae6(customerAttributes, currentCustomerProperties.customerAttributes);
};
const $85edc6496af03946$export$c2f96542fdf6afe5 = (segment)=>{
    if (!(0, $gyNqR.default)(segment) || !segment.includes("|")) return segment;
    return segment.split("|")[0];
};
const $85edc6496af03946$export$ee95238f1f7df4d1 = (content, currentCustomerProperties)=>{
    const include = content.fields.includeSegments && $85edc6496af03946$export$c3a0e093733a5d7c(content.fields.includeSegments);
    const exclude = content.fields.excludeSegments && $85edc6496af03946$export$c3a0e093733a5d7c(content.fields.excludeSegments);
    const visibility = $85edc6496af03946$export$587f0b6268429cc0(currentCustomerProperties, {
        include: include,
        exclude: exclude
    });
    return visibility === "visible";
};
const $85edc6496af03946$export$587f0b6268429cc0 = (currentCustomerProperties, entrySegment)=>{
    const { exclude: exclude, include: include } = entrySegment;
    const isLoggedIn = currentCustomerProperties.customerAttributes.includes("loggedIn");
    if (exclude) {
        const isExcludeOverlap = $85edc6496af03946$export$ae783ece9825c8d3(exclude, currentCustomerProperties);
        if (isExcludeOverlap) return "hidden";
    }
    if (include) {
        if (!isLoggedIn) {
            if (include.customerAttributes.includes("punchoutCustomer")) return "hidden";
            return "requiresLogin";
        }
        const isIncludeOverlap = $85edc6496af03946$export$ae783ece9825c8d3(include, currentCustomerProperties);
        return isIncludeOverlap ? "visible" : "hidden";
    }
    return "visible";
};

});
parcelRegister("98kgb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a6493a43f5620a3$export$2e2bcd8739ae039; });

var $31cwr = parcelRequire("31cwr");

var $gSJMz = parcelRequire("gSJMz");

var $1XCwi = parcelRequire("1XCwi");

var $hCd6c = parcelRequire("hCd6c");
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function $6a6493a43f5620a3$var$concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return (0, $31cwr.default)((0, $hCd6c.default)(array) ? (0, $1XCwi.default)(array) : [
        array
    ], (0, $gSJMz.default)(args, 1));
}
var $6a6493a43f5620a3$export$2e2bcd8739ae039 = $6a6493a43f5620a3$var$concat;

});

parcelRegister("bVGbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8af5bd00fd1b8ec0$export$2e2bcd8739ae039; });

var $dqScn = parcelRequire("dqScn");

var $j1FjB = parcelRequire("j1FjB");

var $1SdxG = parcelRequire("1SdxG");

var $fAqkX = parcelRequire("fAqkX");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $8af5bd00fd1b8ec0$var$intersection = (0, $1SdxG.default)(function(arrays) {
    var mapped = (0, $dqScn.default)(arrays, (0, $fAqkX.default));
    return mapped.length && mapped[0] === arrays[0] ? (0, $j1FjB.default)(mapped) : [];
});
var $8af5bd00fd1b8ec0$export$2e2bcd8739ae039 = $8af5bd00fd1b8ec0$var$intersection;

});
parcelRegister("j1FjB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd9e28ac396abf29$export$2e2bcd8739ae039; });

var $kH0q3 = parcelRequire("kH0q3");

var $kSKhY = parcelRequire("kSKhY");

var $hUabk = parcelRequire("hUabk");

var $dqScn = parcelRequire("dqScn");

var $j7MgO = parcelRequire("j7MgO");

var $dy9tX = parcelRequire("dy9tX");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dd9e28ac396abf29$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $dd9e28ac396abf29$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? (0, $hUabk.default) : (0, $kSKhY.default), length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = (0, $dqScn.default)(array, (0, $j7MgO.default)(iteratee));
        maxLength = $dd9e28ac396abf29$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new (0, $kH0q3.default)(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? (0, $dy9tX.default)(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? (0, $dy9tX.default)(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $dd9e28ac396abf29$export$2e2bcd8739ae039 = $dd9e28ac396abf29$var$baseIntersection;

});
parcelRegister("kSKhY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f33cc1d22eebc8cd$export$2e2bcd8739ae039; });

var $hRnoc = parcelRequire("hRnoc");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f33cc1d22eebc8cd$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && (0, $hRnoc.default)(array, value, 0) > -1;
}
var $f33cc1d22eebc8cd$export$2e2bcd8739ae039 = $f33cc1d22eebc8cd$var$arrayIncludes;

});

parcelRegister("hUabk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d08f907f705ccb53$export$2e2bcd8739ae039; });
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $d08f907f705ccb53$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
var $d08f907f705ccb53$export$2e2bcd8739ae039 = $d08f907f705ccb53$var$arrayIncludesWith;

});


parcelRegister("1SdxG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15d556d031d94732$export$2e2bcd8739ae039; });

var $jHP7K = parcelRequire("jHP7K");

var $5kKPU = parcelRequire("5kKPU");

var $f7N5B = parcelRequire("f7N5B");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $15d556d031d94732$var$baseRest(func, start) {
    return (0, $f7N5B.default)((0, $5kKPU.default)(func, start, (0, $jHP7K.default)), func + '');
}
var $15d556d031d94732$export$2e2bcd8739ae039 = $15d556d031d94732$var$baseRest;

});

parcelRegister("fAqkX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b58ea5cc20045083$export$2e2bcd8739ae039; });

var $4nGiS = parcelRequire("4nGiS");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $b58ea5cc20045083$var$castArrayLikeObject(value) {
    return (0, $4nGiS.default)(value) ? value : [];
}
var $b58ea5cc20045083$export$2e2bcd8739ae039 = $b58ea5cc20045083$var$castArrayLikeObject;

});
parcelRegister("4nGiS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $330a1ffd54c739ef$export$2e2bcd8739ae039; });

var $7wVIe = parcelRequire("7wVIe");

var $bBbWb = parcelRequire("bBbWb");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $330a1ffd54c739ef$var$isArrayLikeObject(value) {
    return (0, $bBbWb.default)(value) && (0, $7wVIe.default)(value);
}
var $330a1ffd54c739ef$export$2e2bcd8739ae039 = $330a1ffd54c739ef$var$isArrayLikeObject;

});



parcelRegister("eoV8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7bfa04b104f34d8$export$2e2bcd8739ae039; });

var $ftwd4 = parcelRequire("ftwd4");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $a7bfa04b104f34d8$var$uniq(array) {
    return array && array.length ? (0, $ftwd4.default)(array) : [];
}
var $a7bfa04b104f34d8$export$2e2bcd8739ae039 = $a7bfa04b104f34d8$var$uniq;

});
parcelRegister("ftwd4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4428ca808d95eb2$export$2e2bcd8739ae039; });

var $kH0q3 = parcelRequire("kH0q3");

var $kSKhY = parcelRequire("kSKhY");

var $hUabk = parcelRequire("hUabk");

var $dy9tX = parcelRequire("dy9tX");

var $6Zzrr = parcelRequire("6Zzrr");

var $ixHim = parcelRequire("ixHim");
/** Used as the size to enable large array optimizations. */ var $b4428ca808d95eb2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $b4428ca808d95eb2$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = (0, $kSKhY.default), length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = (0, $hUabk.default);
    } else if (length >= $b4428ca808d95eb2$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : (0, $6Zzrr.default)(array);
        if (set) return (0, $ixHim.default)(set);
        isCommon = false;
        includes = (0, $dy9tX.default);
        seen = new (0, $kH0q3.default);
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $b4428ca808d95eb2$export$2e2bcd8739ae039 = $b4428ca808d95eb2$var$baseUniq;

});
parcelRegister("6Zzrr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5173ee888fed8b57$export$2e2bcd8739ae039; });

var $4Oq6x = parcelRequire("4Oq6x");

var $i5VLY = parcelRequire("i5VLY");

var $ixHim = parcelRequire("ixHim");
/** Used as references for various `Number` constants. */ var $5173ee888fed8b57$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $5173ee888fed8b57$var$createSet = !((0, $4Oq6x.default) && 1 / (0, $ixHim.default)(new (0, $4Oq6x.default)([
    ,
    -0
]))[1] == $5173ee888fed8b57$var$INFINITY) ? (0, $i5VLY.default) : function(values) {
    return new (0, $4Oq6x.default)(values);
};
var $5173ee888fed8b57$export$2e2bcd8739ae039 = $5173ee888fed8b57$var$createSet;

});
parcelRegister("i5VLY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2c5821c17a1a521$export$2e2bcd8739ae039; });
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $d2c5821c17a1a521$var$noop() {
// No operation performed.
}
var $d2c5821c17a1a521$export$2e2bcd8739ae039 = $d2c5821c17a1a521$var$noop;

});





parcelRegister("f2Bp8", function(module, exports) {

$parcel$export(module.exports, "getBarcodeDeviceId", function () { return $1401c689647d8d9e$export$8351b6b70bd1ffbf; });
$parcel$export(module.exports, "setBarcodeDeviceIdInStorage", function () { return $1401c689647d8d9e$export$1b288bb22ab89f65; });
$parcel$export(module.exports, "getBarcodeFocusDistFromStorage", function () { return $1401c689647d8d9e$export$8e85dd3f65b95b0d; });
$parcel$export(module.exports, "setBarcodeFocusDistInStorage", function () { return $1401c689647d8d9e$export$6854d8cd88455352; });
$parcel$export(module.exports, "getPhoneNumberFromStorage", function () { return $1401c689647d8d9e$export$c963259feefb5acc; });
$parcel$export(module.exports, "setPhoneNumberInStorage", function () { return $1401c689647d8d9e$export$7a527ab9ad4575ad; });
$parcel$export(module.exports, "getUserNameFromStorage", function () { return $1401c689647d8d9e$export$f16cb92f0080e521; });
$parcel$export(module.exports, "setUserNameInStorage", function () { return $1401c689647d8d9e$export$36cad08aa5858af8; });
$parcel$export(module.exports, "getSessionFromStorage", function () { return $1401c689647d8d9e$export$95ecdd5affdb6f7; });
$parcel$export(module.exports, "setSessionInStorage", function () { return $1401c689647d8d9e$export$e468fa63fe93ed1e; });
$parcel$export(module.exports, "getHasRefreshedFromStorage", function () { return $1401c689647d8d9e$export$35d2454e75aa6750; });
$parcel$export(module.exports, "setHasRefreshedInStorage", function () { return $1401c689647d8d9e$export$620f917b64336a3c; });
$parcel$export(module.exports, "getDataVersionFromStorage", function () { return $1401c689647d8d9e$export$f53117832cf8dc71; });
$parcel$export(module.exports, "setDataVersionInStorage", function () { return $1401c689647d8d9e$export$ac625e4e4f9c5311; });
$parcel$export(module.exports, "getOrdertypeFromStorage", function () { return $1401c689647d8d9e$export$11ffafaaa8574712; });
$parcel$export(module.exports, "setOrderTypeInStorage", function () { return $1401c689647d8d9e$export$9eb03314d6c4148c; });
$parcel$export(module.exports, "getCartIdFromStorage", function () { return $1401c689647d8d9e$export$428bb4d4dfd16083; });
$parcel$export(module.exports, "setCartIdInStorage", function () { return $1401c689647d8d9e$export$28e9257ebf98510c; });
$parcel$export(module.exports, "getAssortmentFromStorage", function () { return $1401c689647d8d9e$export$5be6aee6c3069883; });
$parcel$export(module.exports, "setAssortmentInStorage", function () { return $1401c689647d8d9e$export$9b8937429665d887; });
$parcel$export(module.exports, "getEditModeFromStorage", function () { return $1401c689647d8d9e$export$d53dc8ae336dd70c; });
$parcel$export(module.exports, "setEditmodeInStorage", function () { return $1401c689647d8d9e$export$190203ea7e79521e; });
$parcel$export(module.exports, "getLanguageFromStorage", function () { return $1401c689647d8d9e$export$6315b20dadf2d917; });
$parcel$export(module.exports, "getCompanyFromStorage", function () { return $1401c689647d8d9e$export$e4761ef30171d8dc; });
$parcel$export(module.exports, "setCompanyInStorage", function () { return $1401c689647d8d9e$export$1f0def17629a3bdf; });
$parcel$export(module.exports, "getLastCompanyFromStorage", function () { return $1401c689647d8d9e$export$7f0d71d1e1f18f5d; });
$parcel$export(module.exports, "setLastCompanyInStorage", function () { return $1401c689647d8d9e$export$d5e81601289d8894; });
$parcel$export(module.exports, "getNavigationTestVariantFromStorage", function () { return $1401c689647d8d9e$export$800bff698d135a70; });
$parcel$export(module.exports, "setNavigationTestVariantInStorage", function () { return $1401c689647d8d9e$export$3595585774527da1; });
$parcel$export(module.exports, "getViewedPromotionArticlesFromStorage", function () { return $1401c689647d8d9e$export$f348ea16d21683de; });
$parcel$export(module.exports, "setViewedPromotionArticlesInStorage", function () { return $1401c689647d8d9e$export$d3950f4a10c5b564; });

var $fZvaD = parcelRequire("fZvaD");

var $kPpIG = parcelRequire("kPpIG");
const $1401c689647d8d9e$export$8351b6b70bd1ffbf = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).BARCODE_DEVICE_ID, null, "keepBetweenSessions");
const $1401c689647d8d9e$export$1b288bb22ab89f65 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).BARCODE_DEVICE_ID, newValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$8e85dd3f65b95b0d = (defaultValue)=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).BARCODE_FOCUS_DIST, defaultValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$6854d8cd88455352 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).BARCODE_FOCUS_DIST, newValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$c963259feefb5acc = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).PHONE_NUMBER, "", "keepBetweenSessions");
const $1401c689647d8d9e$export$7a527ab9ad4575ad = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).PHONE_NUMBER, newValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$f16cb92f0080e521 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).USER_NAME, "", "keepBetweenSessions");
const $1401c689647d8d9e$export$36cad08aa5858af8 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).USER_NAME, newValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$95ecdd5affdb6f7 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).SESSION, null, "keepThisSession");
const $1401c689647d8d9e$export$e468fa63fe93ed1e = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).SESSION, newValue, "keepThisSession");
const $1401c689647d8d9e$export$35d2454e75aa6750 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).HAS_REFRESHED, false, "keepBetweenSessions");
const $1401c689647d8d9e$export$620f917b64336a3c = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).HAS_REFRESHED, newValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$f53117832cf8dc71 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).DATA_VERSION, null, "keepThisSession");
const $1401c689647d8d9e$export$ac625e4e4f9c5311 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).DATA_VERSION, newValue, "keepThisSession");
const $1401c689647d8d9e$export$11ffafaaa8574712 = (defaultOrderType)=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).ORDER_TYPE, defaultOrderType, "keepThisSession");
const $1401c689647d8d9e$export$9eb03314d6c4148c = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).ORDER_TYPE, newValue, "keepThisSession");
const $1401c689647d8d9e$export$428bb4d4dfd16083 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).CART_ID, (0, $fZvaD.generateRandomOrderId)(), "keepThisSession");
const $1401c689647d8d9e$export$28e9257ebf98510c = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).CART_ID, newValue, "keepThisSession");
const $1401c689647d8d9e$export$5be6aee6c3069883 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).ASSORTMENT, [], "keepThisSession");
const $1401c689647d8d9e$export$9b8937429665d887 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).ASSORTMENT, newValue, "keepThisSession");
const $1401c689647d8d9e$export$d53dc8ae336dd70c = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).EDIT_MODE, null, "keepThisSession");
const $1401c689647d8d9e$export$190203ea7e79521e = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).EDIT_MODE, newValue, "keepThisSession");
const $1401c689647d8d9e$export$6315b20dadf2d917 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).LANGUAGE, null, "keepBetweenSessions");
const $1401c689647d8d9e$export$808f3e43b7585d4f = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).LANGUAGE, newValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$e4761ef30171d8dc = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).COMPANY, null, "keepThisSession");
const $1401c689647d8d9e$export$1f0def17629a3bdf = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).COMPANY, newValue, "keepThisSession");
const $1401c689647d8d9e$export$7f0d71d1e1f18f5d = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).LAST_COMPANY, null, "keepBetweenSessions");
const $1401c689647d8d9e$export$d5e81601289d8894 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).LAST_COMPANY, newValue, "keepBetweenSessions");
// PROMOTION ARTICLES
const $1401c689647d8d9e$var$getAllViewedPromotionArticlesFromStorage = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).VIEWED_PROMOTION_ARTICLES_KEY, {}, "keepBetweenSessions");
const $1401c689647d8d9e$export$800bff698d135a70 = ()=>(0, $kPpIG.getStorage)((0, $kPpIG.STORAGEKEY).NAVIGATION_TEST_VARIANT, null, "keepBetweenSessions");
const $1401c689647d8d9e$export$3595585774527da1 = (newValue)=>(0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).NAVIGATION_TEST_VARIANT, newValue, "keepBetweenSessions");
const $1401c689647d8d9e$export$f348ea16d21683de = (companyId)=>{
    const allViewedPromotionArticles = $1401c689647d8d9e$var$getAllViewedPromotionArticlesFromStorage();
    const viewedPromotionArticles = allViewedPromotionArticles?.[companyId] ?? [];
    return viewedPromotionArticles;
};
const $1401c689647d8d9e$export$d3950f4a10c5b564 = (companyId, newValue)=>{
    const allViewedPromotionArticles = $1401c689647d8d9e$var$getAllViewedPromotionArticlesFromStorage();
    allViewedPromotionArticles[companyId] = newValue;
    (0, $kPpIG.setStorage)((0, $kPpIG.STORAGEKEY).VIEWED_PROMOTION_ARTICLES_KEY, allViewedPromotionArticles, "keepBetweenSessions");
};

});
parcelRegister("fZvaD", function(module, exports) {

$parcel$export(module.exports, "fetchOrderListFromM3", function () { return $6dc052a0fbbb13d5$export$b05626420eed8e2b; });
$parcel$export(module.exports, "fetchOrderDetailsFromM3", function () { return $6dc052a0fbbb13d5$export$7a4d0f2969e1e087; });
$parcel$export(module.exports, "fetchDeliveryNotes", function () { return $6dc052a0fbbb13d5$export$155eae0c938f6995; });
$parcel$export(module.exports, "norwegianListFormatter", function () { return $6dc052a0fbbb13d5$export$4b5bef30d84c39a5; });
$parcel$export(module.exports, "createReadableDiscountInformation", function () { return $6dc052a0fbbb13d5$export$cd47a6f85d0765e0; });
$parcel$export(module.exports, "generateRandomOrderId", function () { return $6dc052a0fbbb13d5$export$2a25e87d63a460e9; });

var $dmVvg = parcelRequire("dmVvg");

var $c7ZFp = parcelRequire("c7ZFp");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $bYgbs = parcelRequire("bYgbs");

var $4udGV = parcelRequire("4udGV");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");
const $6dc052a0fbbb13d5$export$59b9e579c29ecc8c = (filters)=>{
    const filterQueryParams = {
        typeOfOrder: "K"
    };
    if (filters.orderNumber.trim().length > 0) // If searching for order number we don't care about the other filters
    filterQueryParams.orderNumber = filters.orderNumber.trim();
    else {
        if (filters.orderName.trim().length > 0) filterQueryParams.orderName = filters.orderName.trim();
        if (!(0, $c7ZFp.default)(filters.dateRange.from)) filterQueryParams.fromDate = (0, $4udGV.formatM3Date)(filters.dateRange.from);
        if (!(0, $c7ZFp.default)(filters.dateRange.to)) filterQueryParams.toDate = (0, $4udGV.formatM3Date)(filters.dateRange.to);
        if (!(0, $c7ZFp.default)(filters.dateRange.from) && (0, $c7ZFp.default)(filters.dateRange.to)) // If only one date is selected in the date range, use this date as both start and end date
        filterQueryParams.toDate = (0, $4udGV.formatM3Date)(filters.dateRange.from);
        if (filters.status !== "") {
            const fromTo = filters.status.split("/");
            filterQueryParams.fromStatus = fromTo[0];
            filterQueryParams.toStatus = fromTo[1];
        }
    }
    return filterQueryParams;
};
const $6dc052a0fbbb13d5$export$b05626420eed8e2b = async (companyNumber, customerNumber, filters)=>{
    const queryParams = $6dc052a0fbbb13d5$export$59b9e579c29ecc8c(filters);
    return await (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("orders")}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/customerOrderList`, (0, $bcbvQ.default).getSessionToken()).query({
        companyNumber: companyNumber,
        customerNumber: customerNumber,
        ...queryParams
    }).get().json();
};
const $6dc052a0fbbb13d5$export$7a4d0f2969e1e087 = async (companyNumber, customerNumber, orderNumber)=>{
    return await (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("orders")}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/customerOrder`, (0, $bcbvQ.default).getSessionToken()).query({
        companyNumber: companyNumber,
        customerNumber: customerNumber,
        orderNumber: orderNumber
    }).get().json();
};
const $6dc052a0fbbb13d5$export$155eae0c938f6995 = async (orderNumber, customerNumber, companyNumber, division)=>{
    return await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/invoices/customer/${customerNumber}/deliverynote/${orderNumber}`, (0, $bcbvQ.default).getSessionToken()).query({
        companyNumber: companyNumber,
        division: division
    }).get().json();
};
const $6dc052a0fbbb13d5$export$4b5bef30d84c39a5 = typeof Intl !== "undefined" && typeof Intl.ListFormat !== "undefined" ? new Intl.ListFormat("no-NO", {
    style: "short",
    type: "conjunction"
}) : {
    format: (items)=>items.join(", ")
};
const $6dc052a0fbbb13d5$var$currencyFormat = typeof Intl !== "undefined" && typeof Intl.NumberFormat !== "undefined" ? new Intl.NumberFormat("nb-NO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
}) : {
    format: (value)=>value.toFixed(2).replace(".", ",")
};
const $6dc052a0fbbb13d5$export$cd47a6f85d0765e0 = (appliedPromotionInformation, totalDiscountAmount)=>{
    const discountFromVoucherify = (0, $dmVvg.default)(appliedPromotionInformation, "appliedDiscount");
    const discountFromM3 = totalDiscountAmount - discountFromVoucherify;
    const numberOfDiscounts = appliedPromotionInformation.length + (discountFromM3 > 0 ? 1 : 0);
    const label = numberOfDiscounts === 1 ? "Kampanje" : "Kampanjer";
    return `${label}: kr ${$6dc052a0fbbb13d5$var$currencyFormat.format(-discountFromVoucherify - discountFromM3)}`;
};
const $6dc052a0fbbb13d5$export$2a25e87d63a460e9 = ()=>Math.random().toString(36).substring(2, 8);
const $6dc052a0fbbb13d5$export$ea7669dc888f8a20 = (order)=>{
    return (0, $dmVvg.default)(order.orderLines, "lineRecyclingCharge");
};

});
parcelRegister("dmVvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bb9ef5d33fbfcad$export$2e2bcd8739ae039; });

var $aIIzU = parcelRequire("aIIzU");

var $loObr = parcelRequire("loObr");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $9bb9ef5d33fbfcad$var$sumBy(array, iteratee) {
    return array && array.length ? (0, $loObr.default)(array, (0, $aIIzU.default)(iteratee, 2)) : 0;
}
var $9bb9ef5d33fbfcad$export$2e2bcd8739ae039 = $9bb9ef5d33fbfcad$var$sumBy;

});
parcelRegister("loObr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f942c440f450245c$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $f942c440f450245c$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
var $f942c440f450245c$export$2e2bcd8739ae039 = $f942c440f450245c$var$baseSum;

});


parcelRegister("c7ZFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d45f93835961d78$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $8d45f93835961d78$var$isNull(value) {
    return value === null;
}
var $8d45f93835961d78$export$2e2bcd8739ae039 = $8d45f93835961d78$var$isNull;

});

parcelRegister("4udGV", function(module, exports) {

$parcel$export(module.exports, "removeUnwantedDates", function () { return $2c8d46437e9ac29f$export$7bad8b003b5bc3c2; });
$parcel$export(module.exports, "generateSubscriptionName", function () { return $2c8d46437e9ac29f$export$6a9741ba51b84151; });
$parcel$export(module.exports, "formatDeliveryDate", function () { return $2c8d46437e9ac29f$export$ffb729a98b4ba67; });
$parcel$export(module.exports, "formatDate", function () { return $2c8d46437e9ac29f$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatDateTime", function () { return $2c8d46437e9ac29f$export$8b492ed8828f789c; });
$parcel$export(module.exports, "parseM3Date", function () { return $2c8d46437e9ac29f$export$b1ea03b676f08a46; });
$parcel$export(module.exports, "formatM3Date", function () { return $2c8d46437e9ac29f$export$9516139a121e0a5e; });
$parcel$export(module.exports, "formatISODate", function () { return $2c8d46437e9ac29f$export$fb9f91b434a357bf; });
$parcel$export(module.exports, "formatDatesTuple", function () { return $2c8d46437e9ac29f$export$b9c7eebed53df0a5; });
$parcel$export(module.exports, "summarizeOpeningHours", function () { return $2c8d46437e9ac29f$export$6378a8f963ca2c77; });
$parcel$export(module.exports, "isDateInTheFuture", function () { return $2c8d46437e9ac29f$export$591e4510a5ed2026; });
$parcel$export(module.exports, "isDateInThePast", function () { return $2c8d46437e9ac29f$export$200ab5b8c99897d7; });
$parcel$export(module.exports, "isDateBetween", function () { return $2c8d46437e9ac29f$export$e664967ed4e9bea; });
$parcel$export(module.exports, "getFirstDate", function () { return $2c8d46437e9ac29f$export$fc4a4281370f98e9; });
$parcel$export(module.exports, "datesForWeek", function () { return $2c8d46437e9ac29f$export$111b3e4211ab8b86; });
$parcel$export(module.exports, "createCalendarMatrix", function () { return $2c8d46437e9ac29f$export$b4faa49f0cb222b8; });
$parcel$export(module.exports, "getRelativeDate", function () { return $2c8d46437e9ac29f$export$1408a2451dc58071; });
$parcel$export(module.exports, "isArrowDirection", function () { return $2c8d46437e9ac29f$export$7c5ef5d096269ccc; });
$parcel$export(module.exports, "isInMonthYears", function () { return $2c8d46437e9ac29f$export$bb27c6245d9bbdb5; });
$parcel$export(module.exports, "monthAndYearCompare", function () { return $2c8d46437e9ac29f$export$4df7ed300963487f; });
$parcel$export(module.exports, "getLowestMonthAndYear", function () { return $2c8d46437e9ac29f$export$ec5b7c5b9b65f9ab; });
$parcel$export(module.exports, "getHighestMonthAndYear", function () { return $2c8d46437e9ac29f$export$11c4faed4732b93f; });
$parcel$export(module.exports, "getPreviousMonth", function () { return $2c8d46437e9ac29f$export$dee316666c2ef75b; });
$parcel$export(module.exports, "getNextMonth", function () { return $2c8d46437e9ac29f$export$336804f18a0452c1; });
$parcel$export(module.exports, "getMonthAndYears", function () { return $2c8d46437e9ac29f$export$6160f9864a6cdc81; });
$parcel$export(module.exports, "getSelectedOrFirstSelectableDate", function () { return $2c8d46437e9ac29f$export$d9e8c38e52aa9832; });
$parcel$export(module.exports, "englishDayToDay", function () { return $2c8d46437e9ac29f$export$ffccd97badd13891; });

var $kOl9R = parcelRequire("kOl9R");
var $g7Ysb = parcelRequire("g7Ysb");
var $d2sDA = parcelRequire("d2sDA");
var $ggvVa = parcelRequire("ggvVa");
var $i3YG6 = parcelRequire("i3YG6");
var $akfNn = parcelRequire("akfNn");
var $cVpOa = parcelRequire("cVpOa");
var $fjQgv = parcelRequire("fjQgv");
var $kuUjW = parcelRequire("kuUjW");
var $1Qg53 = parcelRequire("1Qg53");
var $epcVC = parcelRequire("epcVC");
var $khZbR = parcelRequire("khZbR");
var $fbCoc = parcelRequire("fbCoc");
var $f3OQA = parcelRequire("f3OQA");
var $8l6c2 = parcelRequire("8l6c2");
var $9FOUz = parcelRequire("9FOUz");
var $7NesW = parcelRequire("7NesW");

var $25dV3 = parcelRequire("25dV3");

var $bEEBX = parcelRequire("bEEBX");
var $3b1Vf = parcelRequire("3b1Vf");
var $ge6NY = parcelRequire("ge6NY");

var $5LjUB = parcelRequire("5LjUB");

var $gtsdT = parcelRequire("gtsdT");

var $8aSS4 = parcelRequire("8aSS4");
const $2c8d46437e9ac29f$export$7bad8b003b5bc3c2 = (orderTypeWithDeliveryDates, orderTypesToProcess)=>{
    const cutoff = (0, $9FOUz.default)((0, $g7Ysb.default)(new Date(), 4));
    for (const key of orderTypesToProcess)if (key in orderTypeWithDeliveryDates) orderTypeWithDeliveryDates[key] = orderTypeWithDeliveryDates[key]?.filter((e)=>(0, $epcVC.default)(e.date) && (0, $1Qg53.default)(e.date, cutoff));
    return orderTypeWithDeliveryDates;
};
const $2c8d46437e9ac29f$export$6a9741ba51b84151 = (weekdayIndex, interval)=>{
    if ((0, $bEEBX.default)(interval)) return "Missing parameter: interval";
    const weekdayIndexNumber = typeof weekdayIndex === "string" ? Number.parseInt(weekdayIndex) : weekdayIndex;
    let name = $2c8d46437e9ac29f$export$8fd3a6c4b0ed9b91(interval);
    name += ` ${(0, $i3YG6.default)((0, $kOl9R.default)((0, $7NesW.default)(new Date()), weekdayIndexNumber), "EEEE", {
        locale: (0, $25dV3.default),
        weekStartsOn: 1
    })}`;
    return name;
};
const $2c8d46437e9ac29f$export$ffb729a98b4ba67 = (date, orderType, interval, shortened = false)=>{
    if ((0, $bEEBX.default)(date)) return "-";
    if (orderType === (0, $8aSS4.ORDERTYPE).WAS && !(0, $bEEBX.default)(interval)) {
        const intervalDescription = $2c8d46437e9ac29f$export$8fd3a6c4b0ed9b91(interval);
        const dayOfWeek = (0, $i3YG6.default)(date, "EEEE", {
            locale: (0, $25dV3.default)
        });
        return `${intervalDescription} ${dayOfWeek}${shortened ? "" : ` f.o.m. ${$2c8d46437e9ac29f$export$3ae94a2503e890a1(date)}`}`;
    }
    if (orderType === (0, $8aSS4.ORDERTYPE).HPN) return $2c8d46437e9ac29f$export$8b492ed8828f789c(date, true, true);
    return $2c8d46437e9ac29f$export$3ae94a2503e890a1(date, true, false, true);
};
const $2c8d46437e9ac29f$export$8fd3a6c4b0ed9b91 = (interval)=>{
    if ((0, $bEEBX.default)(interval)) return "-";
    const parsedInterval = typeof interval === "string" ? Number.parseInt(interval) : interval;
    if (parsedInterval === 7) return "Hver";
    if (parsedInterval === 14) return "Annenhver";
    if (parsedInterval === 21) return "Hver tredje";
    if (parsedInterval === 28) return "Hver fjerde";
    return `Hver ${interval}.`;
};
const $2c8d46437e9ac29f$export$b1ea03b676f08a46 = (date)=>{
    return (0, $8l6c2.default)(date, "yyyyMMdd", new Date());
};
const $2c8d46437e9ac29f$export$9516139a121e0a5e = (date)=>{
    if ((0, $bEEBX.default)(date)) {
        (0, $gtsdT.logger).log("utils", "formatM3Date attempted to format empty date");
        return "";
    }
    return (0, $i3YG6.default)(date, "yyyyMMdd");
};
const $2c8d46437e9ac29f$export$fb9f91b434a357bf = (date)=>{
    return (0, $akfNn.default)(date, {
        representation: "date"
    });
};
const $2c8d46437e9ac29f$export$e7f75af0130abf21 = (dateStr)=>{
    if ((0, $bEEBX.default)(dateStr)) return undefined;
    const isM3Format = dateStr.length === 8;
    const isISOFormat = dateStr.length >= 10 && dateStr.length < 16;
    const isISOWithTimeFormat = dateStr.length >= 16;
    if (isM3Format) return $2c8d46437e9ac29f$export$b1ea03b676f08a46(dateStr);
    if (isISOFormat) return (0, $8l6c2.default)(dateStr.substring(0, 10), "yyyy-MM-dd", new Date());
    if (isISOWithTimeFormat) return (0, $8l6c2.default)(dateStr.substring(0, 16), "yyyy-MM-dd'T'HH:mm", new Date());
};
/**
 * Ensures the param is a Date-object, parsing datetime strings if needed
 */ const $2c8d46437e9ac29f$var$forceDate = (date)=>{
    if (date instanceof Date) return date;
    return $2c8d46437e9ac29f$export$e7f75af0130abf21(date);
};
const $2c8d46437e9ac29f$var$formatDateWithWeekday = (date, monthYearFormat)=>(0, $i3YG6.default)(date, `EEEE ${monthYearFormat}`, {
        locale: (0, $25dV3.default)
    });
const $2c8d46437e9ac29f$export$3ae94a2503e890a1 = (dateOrString, showDayName = false, showFullMonthYear = false, capitalize = false)=>{
    const date = $2c8d46437e9ac29f$var$forceDate(dateOrString);
    if (!date) return `Unknown date: ${dateOrString}`;
    const monthYearFormat = showFullMonthYear ? "d. MMM yyyy" : "dd.MM.yy";
    if (showDayName) {
        const dateWithDayNameFormat = $2c8d46437e9ac29f$var$formatDateWithWeekday(date, monthYearFormat);
        return capitalize ? (0, $ge6NY.default)(dateWithDayNameFormat) : dateWithDayNameFormat;
    }
    return (0, $i3YG6.default)(date, `${monthYearFormat}`, {
        locale: (0, $25dV3.default)
    });
};
const $2c8d46437e9ac29f$export$b9c7eebed53df0a5 = (dates)=>{
    return `${$2c8d46437e9ac29f$export$3ae94a2503e890a1(dates[0])} - ${$2c8d46437e9ac29f$export$3ae94a2503e890a1(dates[1])}`;
};
const $2c8d46437e9ac29f$export$8b492ed8828f789c = (dateOrString, showDayName = true, capitalize = false, separator = "|")=>{
    const date = $2c8d46437e9ac29f$var$forceDate(dateOrString);
    if ((0, $bEEBX.default)(date)) return `Unknown date: ${dateOrString}`;
    if (showDayName) {
        const dateWithDayNameFormat = (0, $i3YG6.default)(date, `EEEE dd.MM.yy '${separator}' HH.mm`, {
            locale: (0, $25dV3.default)
        });
        return capitalize ? (0, $ge6NY.default)(dateWithDayNameFormat) : dateWithDayNameFormat;
    }
    return (0, $i3YG6.default)(date, "dd.MM.yy | HH.mm");
};
const $2c8d46437e9ac29f$var$combineDays = (first, last)=>{
    if (last === "") return first;
    return `${first} - ${last}`;
};
const $2c8d46437e9ac29f$export$6378a8f963ca2c77 = (openingHours)=>{
    if ((0, $bEEBX.default)(openingHours) || (0, $5LjUB.default)(openingHours)) return [];
    const openingHourSummary = [];
    let currentFirstDay = "";
    let currentLastDay = "";
    let currentOpeningWindow = "";
    for (const opening of openingHours){
        const { weekday: weekday, openingHour: openingHour, closingHour: closingHour } = opening;
        const openingWindow = `${openingHour} - ${closingHour}`;
        const hasNewOpeningWindow = currentOpeningWindow !== openingWindow;
        const hasValidData = currentOpeningWindow !== "";
        if (hasNewOpeningWindow) {
            if (hasValidData) openingHourSummary.push({
                days: $2c8d46437e9ac29f$var$combineDays(currentFirstDay, currentLastDay),
                open: currentOpeningWindow
            });
            currentFirstDay = weekday;
            currentLastDay = "";
            currentOpeningWindow = openingWindow;
        } else currentLastDay = weekday;
    }
    openingHourSummary.push({
        days: $2c8d46437e9ac29f$var$combineDays(currentFirstDay, currentLastDay),
        open: currentOpeningWindow
    });
    return openingHourSummary;
};
const $2c8d46437e9ac29f$export$591e4510a5ed2026 = (date)=>{
    return (0, $epcVC.default)(date) && !(0, $f3OQA.default)(date);
};
const $2c8d46437e9ac29f$export$200ab5b8c99897d7 = (date)=>{
    return (0, $khZbR.default)(date) && !(0, $f3OQA.default)(date);
};
const $2c8d46437e9ac29f$export$e664967ed4e9bea = (candiDate, date1, date2)=>!(0, $fbCoc.default)(candiDate, date1) && !(0, $fbCoc.default)(candiDate, date2) && ((0, $kuUjW.default)(candiDate, date1) && (0, $1Qg53.default)(candiDate, date2) || (0, $kuUjW.default)(candiDate, date2) && (0, $1Qg53.default)(candiDate, date1));
const $2c8d46437e9ac29f$export$fc4a4281370f98e9 = (dates)=>dates.filter((d)=>d).reduce((current, next)=>current && next && (0, $1Qg53.default)(current, next) ? current : next, undefined);
const $2c8d46437e9ac29f$export$d0d8f75ab167c3c0 = (date)=>({
        month: date.getMonth(),
        year: date.getFullYear()
    });
const $2c8d46437e9ac29f$export$111b3e4211ab8b86 = (weekIndex, monthYear, weekStartsOn)=>{
    const { month: month, year: year } = monthYear;
    const startOfMonth = new Date(year, month, 1);
    const startOfWeek0 = (0, $7NesW.default)(startOfMonth, {
        weekStartsOn: weekStartsOn
    });
    const startOfThisWeek = weekIndex ? (0, $d2sDA.default)(startOfWeek0, weekIndex) : startOfWeek0;
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((daysToAdd)=>(0, $kOl9R.default)(startOfThisWeek, daysToAdd));
};
const $2c8d46437e9ac29f$export$b4faa49f0cb222b8 = (months, getDayFlags)=>{
    const weekStartsOn = 1;
    return months.map((monthYear)=>{
        const { year: year, month: month } = monthYear;
        const weeks = [];
        const weekCount = (0, $fjQgv.default)(new Date(year, month, 1), {
            weekStartsOn: weekStartsOn
        });
        for(let i = 0; i < weekCount; i++){
            const dates = $2c8d46437e9ac29f$export$111b3e4211ab8b86(i, monthYear, weekStartsOn);
            weeks.push(dates.map((date)=>{
                const dayFlags = getDayFlags(date);
                dayFlags.notInMonth = date.getMonth() !== month;
                dayFlags.selectable = dayFlags.selectable && !dayFlags.notInMonth;
                return {
                    date: date,
                    ...dayFlags
                };
            }));
        }
        return weeks;
    });
};
const $2c8d46437e9ac29f$export$7e3c61ff361b8297 = (date, calendarMatrix)=>{
    const month = date.getMonth();
    const monthIndex = calendarMatrix.findIndex((weeks)=>{
        return weeks.length > 1 && weeks[1][0].date.getMonth() === month;
    });
    if (monthIndex >= 0) {
        let dayIndex = -1;
        const weeks = calendarMatrix[monthIndex];
        const weekIndex = weeks.findIndex((week)=>{
            const index = week.findIndex((day)=>{
                const { date: currentDate, notInMonth: notInMonth } = day;
                return !notInMonth && (0, $fbCoc.default)(currentDate, date);
            });
            if (index >= 0) {
                dayIndex = index;
                return true;
            }
            return false;
        });
        if (weekIndex >= 0 && dayIndex >= 0) return [
            monthIndex,
            weekIndex,
            dayIndex
        ];
    }
    return undefined;
};
const $2c8d46437e9ac29f$export$1408a2451dc58071 = (date, direction, calendarMatrix)=>{
    const indices = $2c8d46437e9ac29f$export$7e3c61ff361b8297(date, calendarMatrix);
    if (indices) {
        const isBackwards = direction === "ArrowUp" || direction === "ArrowLeft";
        if (direction === "ArrowDown" || direction === "ArrowUp") return $2c8d46437e9ac29f$var$verticalRelativeDate(indices, isBackwards, calendarMatrix);
        return $2c8d46437e9ac29f$var$horizontalRelativeDate(indices, isBackwards, calendarMatrix);
    }
};
const $2c8d46437e9ac29f$var$closestSelectableInWeekInDirection = (week, dayIndex, isBackwards)=>{
    if (week[dayIndex].selectable && !week[dayIndex].notInMonth) //
    return week[dayIndex].date;
    if (isBackwards) {
        if (dayIndex > 0) return $2c8d46437e9ac29f$var$closestSelectableInWeekInDirection(week, dayIndex - 1, true);
    } else {
        if (dayIndex + 1 < week.length) return $2c8d46437e9ac29f$var$closestSelectableInWeekInDirection(week, dayIndex + 1, false);
    }
};
const $2c8d46437e9ac29f$var$closestSelectableInWeek = (week, dayIndex, isBackwards)=>{
    const dateInDirection = $2c8d46437e9ac29f$var$closestSelectableInWeekInDirection(week, dayIndex, isBackwards);
    return dateInDirection || $2c8d46437e9ac29f$var$closestSelectableInWeekInDirection(week, dayIndex, !isBackwards);
};
const $2c8d46437e9ac29f$var$verticalRelativeDate = (startIndices, isBackwards, calendarMatrix)=>{
    const nextWeek = isBackwards ? (monthIndex, weekIndex)=>{
        return weekIndex ? {
            weekIndex: weekIndex - 1,
            monthIndex: monthIndex
        } : monthIndex ? {
            monthIndex: monthIndex - 1,
            weekIndex: calendarMatrix[monthIndex - 1].length - 1
        } : undefined;
    } : (monthIndex, weekIndex)=>{
        return weekIndex + 1 < calendarMatrix[monthIndex].length ? {
            weekIndex: weekIndex + 1,
            monthIndex: monthIndex
        } : monthIndex + 1 < calendarMatrix.length ? {
            monthIndex: monthIndex + 1,
            weekIndex: 0
        } : undefined;
    };
    const [monthIndex, weekIndex, dayIndex] = startIndices;
    let weekAndMonth = nextWeek(monthIndex, weekIndex);
    while(weekAndMonth){
        const date = $2c8d46437e9ac29f$var$closestSelectableInWeek(calendarMatrix[weekAndMonth.monthIndex][weekAndMonth.weekIndex], dayIndex, isBackwards);
        if (date) return date;
        weekAndMonth = nextWeek(weekAndMonth.monthIndex, weekAndMonth.weekIndex);
    }
};
const $2c8d46437e9ac29f$var$horizontalRelativeDate = (startIndices, isBackwards, calendarMatrix)=>{
    const [monthIndex, weekIndex, dayIndex] = startIndices;
    const currentWeek = calendarMatrix[monthIndex][weekIndex];
    const subweek = isBackwards ? [
        ...currentWeek.slice(0, dayIndex)
    ].reverse() : currentWeek.slice(dayIndex + 1);
    const found = subweek.find((dateAndFlags)=>dateAndFlags.selectable);
    if (found) return found.date;
    if (isBackwards && monthIndex > 0) {
        const previousMonth = calendarMatrix[monthIndex - 1];
        const previousMonthWeekIndex = weekIndex < previousMonth.length ? weekIndex : weekIndex - 1;
        const previousMonthWeek = previousMonth[previousMonthWeekIndex];
        const found = [
            ...previousMonthWeek
        ].reverse().find((dateAndFlags)=>dateAndFlags.selectable);
        if (found) return found.date;
        for(let weekIndexDelta = 1; weekIndexDelta < 5; weekIndexDelta++){
            let found = previousMonthWeekIndex - weekIndexDelta >= 0 ? [
                ...previousMonth[previousMonthWeekIndex - weekIndexDelta]
            ].reverse().find((dateAndFlags)=>dateAndFlags.selectable) : undefined;
            if (found) return found.date;
            found = previousMonthWeekIndex + weekIndexDelta < previousMonth.length ? [
                ...previousMonth[previousMonthWeekIndex + weekIndexDelta]
            ].reverse().find((dateAndFlags)=>dateAndFlags.selectable) : undefined;
            if (found) return found.date;
        }
        if (monthIndex > 1) {
            const previousMonthStartIndices = [
                monthIndex - 1,
                previousMonthWeekIndex,
                0
            ];
            return $2c8d46437e9ac29f$var$horizontalRelativeDate(previousMonthStartIndices, true, calendarMatrix);
        }
    }
    if (!isBackwards && monthIndex + 1 < calendarMatrix.length) {
        const nextMonth = calendarMatrix[monthIndex + 1];
        const nextMonthWeekIndex = weekIndex < nextMonth.length ? weekIndex : weekIndex - 1;
        const nextMonthWeek = nextMonth[nextMonthWeekIndex];
        const found = nextMonthWeek.find((dateAndFlags)=>dateAndFlags.selectable);
        if (found) return found.date;
        for(let weekIndexDelta = 1; weekIndexDelta < 5; weekIndexDelta++){
            let found = nextMonthWeekIndex + weekIndexDelta < nextMonth.length ? nextMonth[nextMonthWeekIndex + weekIndexDelta].find((dateAndFlags)=>dateAndFlags.selectable) : undefined;
            if (found) return found.date;
            found = nextMonthWeekIndex - weekIndexDelta >= 0 ? nextMonth[nextMonthWeekIndex - weekIndexDelta].find((dateAndFlags)=>dateAndFlags.selectable) : undefined;
            if (found) return found.date;
        }
        if (monthIndex + 2 < calendarMatrix.length) {
            const nextMonthStartIndices = [
                monthIndex + 1,
                nextMonthWeekIndex,
                6
            ];
            return $2c8d46437e9ac29f$var$horizontalRelativeDate(nextMonthStartIndices, false, calendarMatrix);
        }
    }
};
const $2c8d46437e9ac29f$export$7c5ef5d096269ccc = (value)=>{
    return [
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight"
    ].includes(value);
};
const $2c8d46437e9ac29f$export$8db3e26e5f93159 = (date, monthYear)=>{
    const { month: month, year: year } = monthYear;
    const monthStart = new Date(year, month, 1);
    const monthEnd = (0, $ggvVa.default)(monthStart);
    return (0, $fbCoc.default)(date, monthStart) || (0, $fbCoc.default)(date, monthEnd) || (0, $kuUjW.default)(date, monthStart) && (0, $1Qg53.default)(date, monthEnd);
};
const $2c8d46437e9ac29f$export$bb27c6245d9bbdb5 = (date, monthYears)=>monthYears.some((monthYear)=>$2c8d46437e9ac29f$export$8db3e26e5f93159(date, monthYear));
const $2c8d46437e9ac29f$export$59482079f453f898 = (date)=>({
        month: date.getMonth(),
        year: date.getFullYear()
    });
const $2c8d46437e9ac29f$export$4df7ed300963487f = (my1, my2)=>my1.year * 12 + my1.month - (my2.year * 12 + my2.month);
const $2c8d46437e9ac29f$export$ec5b7c5b9b65f9ab = (min)=>min ? $2c8d46437e9ac29f$export$59482079f453f898(min) : {
        month: 0,
        year: 0
    };
const $2c8d46437e9ac29f$export$11c4faed4732b93f = (max)=>max ? $2c8d46437e9ac29f$export$59482079f453f898(max) : {
        month: 11,
        year: 9999
    };
const $2c8d46437e9ac29f$export$dee316666c2ef75b = ({ month: month, year: year })=>month ? {
        month: month - 1,
        year: year
    } : {
        month: 11,
        year: year - 1
    };
const $2c8d46437e9ac29f$export$336804f18a0452c1 = ({ month: month, year: year })=>month === 11 ? {
        month: 0,
        year: year + 1
    } : {
        month: month + 1,
        year: year
    };
const $2c8d46437e9ac29f$var$toMonthAD = (monthAndYear)=>monthAndYear.year * 12 + monthAndYear.month;
const $2c8d46437e9ac29f$var$fromMonthAD = (monthAD)=>({
        year: Math.floor(monthAD / 12),
        month: monthAD % 12
    });
const $2c8d46437e9ac29f$export$6160f9864a6cdc81 = (month, year, monthCount, min, max)=>{
    const lowestMonthAndYear = $2c8d46437e9ac29f$export$ec5b7c5b9b65f9ab(min);
    const highestMonthAndYear = $2c8d46437e9ac29f$export$11c4faed4732b93f(max);
    const lowestMonths = $2c8d46437e9ac29f$var$toMonthAD(lowestMonthAndYear);
    const highestMonths = $2c8d46437e9ac29f$var$toMonthAD(highestMonthAndYear);
    const count = (0, $3b1Vf.default)([
        monthCount,
        1 + highestMonths - lowestMonths
    ]) || 1;
    const months = [
        $2c8d46437e9ac29f$var$toMonthAD({
            month: month,
            year: year
        })
    ];
    let monthsLeft = count - 1;
    let nextMonthAfter = true;
    while(monthsLeft)if (nextMonthAfter) {
        const lastMonths = months[months.length - 1];
        if (lastMonths < highestMonths) {
            months.push(lastMonths + 1);
            monthsLeft--;
        }
        nextMonthAfter = false;
    } else {
        const firstMonths = months[0];
        if (firstMonths > lowestMonths) {
            months.unshift(firstMonths - 1);
            monthsLeft--;
        }
        nextMonthAfter = true;
    }
    return months.map((month)=>$2c8d46437e9ac29f$var$fromMonthAD(month));
};
const $2c8d46437e9ac29f$export$705eb4180dbda0ed = (monthAndYear)=>{
    const { month: month, year: year } = monthAndYear;
    const daysInMonth = (0, $cVpOa.default)(new Date(year, month));
    const dates = [];
    for(let day = 1; day <= daysInMonth; day++)dates.push(new Date(year, month, day));
    return dates;
};
const $2c8d46437e9ac29f$export$d9e8c38e52aa9832 = (monthsAndYears, getDayFlags)=>{
    if (monthsAndYears.length) {
        const dates = monthsAndYears.flatMap((monthAndYear)=>$2c8d46437e9ac29f$export$705eb4180dbda0ed(monthAndYear));
        const date = dates.find((date)=>getDayFlags(date).selected);
        if (date) return date;
        return dates.find((date)=>getDayFlags(date).selectable);
    }
    return;
};
const $2c8d46437e9ac29f$export$ffccd97badd13891 = (englishDay)=>{
    const lcDay = (englishDay || "").toLowerCase();
    const days = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6
    };
    return days[lcDay];
};

});
parcelRegister("kOl9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f268e3b6591b1aa0$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $f268e3b6591b1aa0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var amount = (0, $970db.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("g7Ysb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbdc31a1a2eaa923$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $bbdc31a1a2eaa923$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var amount = (0, $970db.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("d2sDA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97e1ad10a4a7092f$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $kOl9R = parcelRequire("kOl9R");

var $hFacL = parcelRequire("hFacL");
function $97e1ad10a4a7092f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var amount = (0, $970db.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $kOl9R.default)(dirtyDate, days);
}

});

parcelRegister("ggvVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd76e6d73f38bf95$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $bd76e6d73f38bf95$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("i3YG6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d26793338df79c0d$export$2e2bcd8739ae039; });

var $a0DIN = parcelRequire("a0DIN");

var $7e87O = parcelRequire("7e87O");

var $8pX4r = parcelRequire("8pX4r");

var $0J8Za = parcelRequire("0J8Za");

var $bqo2D = parcelRequire("bqo2D");

var $8g9Dy = parcelRequire("8g9Dy");

var $j29Um = parcelRequire("j29Um");

var $970db = parcelRequire("970db");

var $hFacL = parcelRequire("hFacL");

var $9WzlS = parcelRequire("9WzlS");

var $6ybw5 = parcelRequire("6ybw5");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $d26793338df79c0d$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $d26793338df79c0d$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $d26793338df79c0d$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $d26793338df79c0d$var$doubleQuoteRegExp = /''/g;
var $d26793338df79c0d$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d26793338df79c0d$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $hFacL.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $9WzlS.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $6ybw5.default);
    var firstWeekContainsDate = (0, $970db.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $970db.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $8pX4r.default)(dirtyDate);
    if (!(0, $a0DIN.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $8g9Dy.default)(originalDate);
    var utcDate = (0, $7e87O.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($d26793338df79c0d$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $bqo2D.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($d26793338df79c0d$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $d26793338df79c0d$var$cleanEscapedString(substring);
        var formatter = (0, $0J8Za.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $j29Um.isProtectedWeekYearToken)(substring)) (0, $j29Um.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $j29Um.isProtectedDayOfYearToken)(substring)) (0, $j29Um.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($d26793338df79c0d$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $d26793338df79c0d$var$cleanEscapedString(input) {
    var matched = input.match($d26793338df79c0d$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($d26793338df79c0d$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("a0DIN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7498b74fef94a729$export$2e2bcd8739ae039; });

var $bTbBH = parcelRequire("bTbBH");

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $7498b74fef94a729$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    if (!(0, $bTbBH.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $8pX4r.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("bTbBH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a7dd5a97a8e15c2$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");

var $hFacL = parcelRequire("hFacL");
function $8a7dd5a97a8e15c2$export$2e2bcd8739ae039(value) {
    (0, $hFacL.default)(1, arguments);
    return value instanceof Date || (0, $5PKFW.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("7e87O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $543024af6f0c30c9$export$2e2bcd8739ae039; });

var $eOaNI = parcelRequire("eOaNI");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");
function $543024af6f0c30c9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var amount = (0, $970db.default)(dirtyAmount);
    return (0, $eOaNI.default)(dirtyDate, -amount);
}

});

parcelRegister("0J8Za", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $002304d887acc708$export$2e2bcd8739ae039; });

var $arJEP = parcelRequire("arJEP");

var $d34PH = parcelRequire("d34PH");

var $cgRnt = parcelRequire("cgRnt");

var $cZajv = parcelRequire("cZajv");

var $3z0JA = parcelRequire("3z0JA");

var $l9A7K = parcelRequire("l9A7K");

var $l1gEK = parcelRequire("l1gEK");
var $002304d887acc708$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $002304d887acc708$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $l1gEK.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $3z0JA.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $l9A7K.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $l9A7K.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $cgRnt.default)(date);
        // Padding
        return (0, $l9A7K.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $l9A7K.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $l9A7K.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $l9A7K.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $l1gEK.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $l9A7K.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $cZajv.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $l9A7K.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $d34PH.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $l9A7K.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $l1gEK.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $arJEP.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $l9A7K.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $l9A7K.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $l9A7K.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $l9A7K.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $002304d887acc708$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $002304d887acc708$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $002304d887acc708$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $002304d887acc708$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $002304d887acc708$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $002304d887acc708$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $l1gEK.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $l1gEK.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $l9A7K.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $l9A7K.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $l1gEK.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $l1gEK.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $l1gEK.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $002304d887acc708$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $002304d887acc708$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $002304d887acc708$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $002304d887acc708$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $002304d887acc708$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $002304d887acc708$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $002304d887acc708$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $002304d887acc708$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $002304d887acc708$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $002304d887acc708$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $l9A7K.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $l9A7K.default)(timestamp, token.length);
    }
};
function $002304d887acc708$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $l9A7K.default)(minutes, 2);
}
function $002304d887acc708$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $l9A7K.default)(Math.abs(offset) / 60, 2);
    }
    return $002304d887acc708$var$formatTimezone(offset, dirtyDelimiter);
}
function $002304d887acc708$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $l9A7K.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $l9A7K.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $002304d887acc708$export$2e2bcd8739ae039 = $002304d887acc708$var$formatters;

});
parcelRegister("arJEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79afd7a6f7496f80$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
var $79afd7a6f7496f80$var$MILLISECONDS_IN_DAY = 86400000;
function $79afd7a6f7496f80$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $79afd7a6f7496f80$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("d34PH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97ff4de3ec5e8aa7$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $jGECh = parcelRequire("jGECh");

var $a8qAF = parcelRequire("a8qAF");

var $hFacL = parcelRequire("hFacL");
var $97ff4de3ec5e8aa7$var$MILLISECONDS_IN_WEEK = 604800000;
function $97ff4de3ec5e8aa7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var diff = (0, $jGECh.default)(date).getTime() - (0, $a8qAF.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $97ff4de3ec5e8aa7$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("jGECh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5517220dfbc2cb9$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $e5517220dfbc2cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $8pX4r.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("a8qAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $760f4706b130e719$export$2e2bcd8739ae039; });

var $cgRnt = parcelRequire("cgRnt");

var $jGECh = parcelRequire("jGECh");

var $hFacL = parcelRequire("hFacL");
function $760f4706b130e719$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var year = (0, $cgRnt.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $jGECh.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("cgRnt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ef0625b76a38a5b$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");

var $jGECh = parcelRequire("jGECh");
function $8ef0625b76a38a5b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $jGECh.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $jGECh.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("cZajv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97432e9dbe82d5b2$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $l1hfz = parcelRequire("l1hfz");

var $59AeV = parcelRequire("59AeV");

var $hFacL = parcelRequire("hFacL");
var $97432e9dbe82d5b2$var$MILLISECONDS_IN_WEEK = 604800000;
function $97432e9dbe82d5b2$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var diff = (0, $l1hfz.default)(date, options).getTime() - (0, $59AeV.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $97432e9dbe82d5b2$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("l1hfz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4d7127f79bf769b$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");

var $9WzlS = parcelRequire("9WzlS");
function $f4d7127f79bf769b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $hFacL.default)(1, arguments);
    var defaultOptions = (0, $9WzlS.getDefaultOptions)();
    var weekStartsOn = (0, $970db.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8pX4r.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("9WzlS", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $73d4f3fd48a7fc74$export$430a3269e24b912e; });
var $73d4f3fd48a7fc74$var$defaultOptions = {};
function $73d4f3fd48a7fc74$export$430a3269e24b912e() {
    return $73d4f3fd48a7fc74$var$defaultOptions;
}
function $73d4f3fd48a7fc74$export$95365be1b0704abc(newOptions) {
    $73d4f3fd48a7fc74$var$defaultOptions = newOptions;
}

});


parcelRegister("59AeV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c09e77733a7ab11$export$2e2bcd8739ae039; });

var $3z0JA = parcelRequire("3z0JA");

var $hFacL = parcelRequire("hFacL");

var $l1hfz = parcelRequire("l1hfz");

var $970db = parcelRequire("970db");

var $9WzlS = parcelRequire("9WzlS");
function $3c09e77733a7ab11$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $hFacL.default)(1, arguments);
    var defaultOptions = (0, $9WzlS.getDefaultOptions)();
    var firstWeekContainsDate = (0, $970db.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $3z0JA.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $l1hfz.default)(firstWeek, options);
    return date;
}

});
parcelRegister("3z0JA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298535cbb8bc6f0e$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");

var $l1hfz = parcelRequire("l1hfz");

var $970db = parcelRequire("970db");

var $9WzlS = parcelRequire("9WzlS");
function $298535cbb8bc6f0e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $9WzlS.getDefaultOptions)();
    var firstWeekContainsDate = (0, $970db.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $l1hfz.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $l1hfz.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("l9A7K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f66675b19bb58a24$export$2e2bcd8739ae039; });
function $f66675b19bb58a24$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("l1gEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4d69c90cc06ff3d$export$2e2bcd8739ae039; });

var $l9A7K = parcelRequire("l9A7K");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $f4d69c90cc06ff3d$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $l9A7K.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $l9A7K.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $l9A7K.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $l9A7K.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $l9A7K.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $l9A7K.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $l9A7K.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $l9A7K.default)(fractionalSeconds, token.length);
    }
};
var $f4d69c90cc06ff3d$export$2e2bcd8739ae039 = $f4d69c90cc06ff3d$var$formatters;

});


parcelRegister("bqo2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8514c58997e7e571$export$2e2bcd8739ae039; });
var $8514c58997e7e571$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $8514c58997e7e571$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $8514c58997e7e571$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $8514c58997e7e571$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $8514c58997e7e571$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $8514c58997e7e571$var$timeLongFormatter(timePattern, formatLong));
};
var $8514c58997e7e571$var$longFormatters = {
    p: $8514c58997e7e571$var$timeLongFormatter,
    P: $8514c58997e7e571$var$dateTimeLongFormatter
};
var $8514c58997e7e571$export$2e2bcd8739ae039 = $8514c58997e7e571$var$longFormatters;

});

parcelRegister("8g9Dy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60374b0af341b139$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $60374b0af341b139$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("j29Um", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $039373285f3c36db$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $039373285f3c36db$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $039373285f3c36db$export$8073c1ae88f0e727; });
var $039373285f3c36db$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $039373285f3c36db$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $039373285f3c36db$export$c6cc36aa33304772(token) {
    return $039373285f3c36db$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $039373285f3c36db$export$c6b49d6dceb604a1(token) {
    return $039373285f3c36db$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $039373285f3c36db$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("6ybw5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c4ed9ffb8927c75$export$2e2bcd8739ae039; });

var $6XoGi = parcelRequire("6XoGi");
var $4c4ed9ffb8927c75$export$2e2bcd8739ae039 = (0, $6XoGi.default);

});
parcelRegister("6XoGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $510b65ec9f23cb6f$export$2e2bcd8739ae039; });

var $cFOuJ = parcelRequire("cFOuJ");

var $aMlYL = parcelRequire("aMlYL");

var $9UwX5 = parcelRequire("9UwX5");

var $fT0OK = parcelRequire("fT0OK");

var $cNFkU = parcelRequire("cNFkU");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $510b65ec9f23cb6f$var$locale = {
    code: 'en-US',
    formatDistance: (0, $cFOuJ.default),
    formatLong: (0, $aMlYL.default),
    formatRelative: (0, $9UwX5.default),
    localize: (0, $fT0OK.default),
    match: (0, $cNFkU.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $510b65ec9f23cb6f$export$2e2bcd8739ae039 = $510b65ec9f23cb6f$var$locale;

});
parcelRegister("cFOuJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93a07b9358b995ac$export$2e2bcd8739ae039; });
var $93a07b9358b995ac$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $93a07b9358b995ac$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $93a07b9358b995ac$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $93a07b9358b995ac$export$2e2bcd8739ae039 = $93a07b9358b995ac$var$formatDistance;

});

parcelRegister("aMlYL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d8f6fa4e77c7202$export$2e2bcd8739ae039; });

var $4DmBO = parcelRequire("4DmBO");
var $7d8f6fa4e77c7202$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $7d8f6fa4e77c7202$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $7d8f6fa4e77c7202$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7d8f6fa4e77c7202$var$formatLong = {
    date: (0, $4DmBO.default)({
        formats: $7d8f6fa4e77c7202$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4DmBO.default)({
        formats: $7d8f6fa4e77c7202$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4DmBO.default)({
        formats: $7d8f6fa4e77c7202$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7d8f6fa4e77c7202$export$2e2bcd8739ae039 = $7d8f6fa4e77c7202$var$formatLong;

});
parcelRegister("4DmBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35fc579d882a5b13$export$2e2bcd8739ae039; });
function $35fc579d882a5b13$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("9UwX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7372e796f7648276$export$2e2bcd8739ae039; });
var $7372e796f7648276$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $7372e796f7648276$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7372e796f7648276$var$formatRelativeLocale[token];
};
var $7372e796f7648276$export$2e2bcd8739ae039 = $7372e796f7648276$var$formatRelative;

});

parcelRegister("fT0OK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b90ca06ec0dc38ee$export$2e2bcd8739ae039; });

var $lgVBX = parcelRequire("lgVBX");
var $b90ca06ec0dc38ee$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $b90ca06ec0dc38ee$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $b90ca06ec0dc38ee$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $b90ca06ec0dc38ee$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $b90ca06ec0dc38ee$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $b90ca06ec0dc38ee$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $b90ca06ec0dc38ee$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $b90ca06ec0dc38ee$var$localize = {
    ordinalNumber: $b90ca06ec0dc38ee$var$ordinalNumber,
    era: (0, $lgVBX.default)({
        values: $b90ca06ec0dc38ee$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lgVBX.default)({
        values: $b90ca06ec0dc38ee$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lgVBX.default)({
        values: $b90ca06ec0dc38ee$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lgVBX.default)({
        values: $b90ca06ec0dc38ee$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lgVBX.default)({
        values: $b90ca06ec0dc38ee$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b90ca06ec0dc38ee$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b90ca06ec0dc38ee$export$2e2bcd8739ae039 = $b90ca06ec0dc38ee$var$localize;

});
parcelRegister("lgVBX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7c7c7f6c8b50d2d$export$2e2bcd8739ae039; });
function $f7c7c7f6c8b50d2d$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("cNFkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $951a2022979a1e02$export$2e2bcd8739ae039; });

var $87cbQ = parcelRequire("87cbQ");

var $fzR5N = parcelRequire("fzR5N");
var $951a2022979a1e02$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $951a2022979a1e02$var$parseOrdinalNumberPattern = /\d+/i;
var $951a2022979a1e02$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $951a2022979a1e02$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $951a2022979a1e02$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $951a2022979a1e02$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $951a2022979a1e02$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $951a2022979a1e02$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $951a2022979a1e02$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $951a2022979a1e02$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $951a2022979a1e02$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $951a2022979a1e02$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $951a2022979a1e02$var$match = {
    ordinalNumber: (0, $fzR5N.default)({
        matchPattern: $951a2022979a1e02$var$matchOrdinalNumberPattern,
        parsePattern: $951a2022979a1e02$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $87cbQ.default)({
        matchPatterns: $951a2022979a1e02$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $951a2022979a1e02$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $87cbQ.default)({
        matchPatterns: $951a2022979a1e02$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $951a2022979a1e02$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $87cbQ.default)({
        matchPatterns: $951a2022979a1e02$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $951a2022979a1e02$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $87cbQ.default)({
        matchPatterns: $951a2022979a1e02$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $951a2022979a1e02$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $87cbQ.default)({
        matchPatterns: $951a2022979a1e02$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $951a2022979a1e02$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $951a2022979a1e02$export$2e2bcd8739ae039 = $951a2022979a1e02$var$match;

});
parcelRegister("87cbQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e886ed860c39542$export$2e2bcd8739ae039; });
function $5e886ed860c39542$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $5e886ed860c39542$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $5e886ed860c39542$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $5e886ed860c39542$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $5e886ed860c39542$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("fzR5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5734ef026c610c9$export$2e2bcd8739ae039; });
function $b5734ef026c610c9$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("akfNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f0a54332a904b7$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $l9A7K = parcelRequire("l9A7K");

var $hFacL = parcelRequire("hFacL");
function $01f0a54332a904b7$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $hFacL.default)(1, arguments);
    var originalDate = (0, $8pX4r.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $l9A7K.default)(originalDate.getDate(), 2);
        var month = (0, $l9A7K.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $l9A7K.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $l9A7K.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $l9A7K.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $l9A7K.default)(originalDate.getHours(), 2);
        var minute = (0, $l9A7K.default)(originalDate.getMinutes(), 2);
        var second = (0, $l9A7K.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("cVpOa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $968ed3d8b2e36f37$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $968ed3d8b2e36f37$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("fjQgv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2712c252c29762a$export$2e2bcd8739ae039; });

var $1DDuo = parcelRequire("1DDuo");

var $koTPy = parcelRequire("koTPy");

var $9FOUz = parcelRequire("9FOUz");

var $hFacL = parcelRequire("hFacL");
function $b2712c252c29762a$export$2e2bcd8739ae039(date, options) {
    (0, $hFacL.default)(1, arguments);
    return (0, $1DDuo.default)((0, $koTPy.default)(date), (0, $9FOUz.default)(date), options) + 1;
}

});
parcelRegister("1DDuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $131810b8d7463caf$export$2e2bcd8739ae039; });

var $7NesW = parcelRequire("7NesW");

var $8g9Dy = parcelRequire("8g9Dy");

var $hFacL = parcelRequire("hFacL");
var $131810b8d7463caf$var$MILLISECONDS_IN_WEEK = 604800000;
function $131810b8d7463caf$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $hFacL.default)(2, arguments);
    var startOfWeekLeft = (0, $7NesW.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $7NesW.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $8g9Dy.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $8g9Dy.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $131810b8d7463caf$var$MILLISECONDS_IN_WEEK);
}

});
parcelRegister("7NesW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ac85499a89ce205$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $970db = parcelRequire("970db");

var $hFacL = parcelRequire("hFacL");

var $9WzlS = parcelRequire("9WzlS");
function $5ac85499a89ce205$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $hFacL.default)(1, arguments);
    var defaultOptions = (0, $9WzlS.getDefaultOptions)();
    var weekStartsOn = (0, $970db.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8pX4r.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("koTPy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eda15b555a96318c$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $eda15b555a96318c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("9FOUz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70af6f581a5100e8$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $70af6f581a5100e8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("kuUjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eec24c171a42bf07$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $eec24c171a42bf07$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $hFacL.default)(2, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var dateToCompare = (0, $8pX4r.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("1Qg53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15771f045b8c7b38$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $15771f045b8c7b38$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $hFacL.default)(2, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var dateToCompare = (0, $8pX4r.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("epcVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7cd6dcda8b61d4b$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $a7cd6dcda8b61d4b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    return (0, $8pX4r.default)(dirtyDate).getTime() > Date.now();
}

});

parcelRegister("fbCoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0e5a96f84a7f4b3$export$2e2bcd8739ae039; });

var $g0WqO = parcelRequire("g0WqO");

var $hFacL = parcelRequire("hFacL");
function $b0e5a96f84a7f4b3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $hFacL.default)(2, arguments);
    var dateLeftStartOfDay = (0, $g0WqO.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $g0WqO.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});
parcelRegister("g0WqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $030239b04afa57d0$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $030239b04afa57d0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("f3OQA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af6e94080975e30c$export$2e2bcd8739ae039; });

var $fbCoc = parcelRequire("fbCoc");

var $hFacL = parcelRequire("hFacL");
function $af6e94080975e30c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    return (0, $fbCoc.default)(dirtyDate, Date.now());
}

});

parcelRegister("8l6c2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $612516bb4a7157b8$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");

var $iIFkw = parcelRequire("iIFkw");

var $6ybw5 = parcelRequire("6ybw5");

var $7e87O = parcelRequire("7e87O");

var $8pX4r = parcelRequire("8pX4r");

var $c3Qe5 = parcelRequire("c3Qe5");

var $bqo2D = parcelRequire("bqo2D");

var $8g9Dy = parcelRequire("8g9Dy");

var $j29Um = parcelRequire("j29Um");

var $970db = parcelRequire("970db");

var $hFacL = parcelRequire("hFacL");

var $6M4PE = parcelRequire("6M4PE");

var $4YGmS = parcelRequire("4YGmS");

var $9WzlS = parcelRequire("9WzlS");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $612516bb4a7157b8$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $612516bb4a7157b8$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $612516bb4a7157b8$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $612516bb4a7157b8$var$doubleQuoteRegExp = /''/g;
var $612516bb4a7157b8$var$notWhitespaceRegExp = /\S/;
var $612516bb4a7157b8$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $612516bb4a7157b8$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $hFacL.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $9WzlS.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $6ybw5.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $970db.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $970db.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $8pX4r.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $6M4PE.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($612516bb4a7157b8$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $bqo2D.default)) {
            var longFormatter = (0, $bqo2D.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($612516bb4a7157b8$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $iIFkw.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $j29Um.isProtectedWeekYearToken)(token)) (0, $j29Um.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $j29Um.isProtectedDayOfYearToken)(token)) (0, $j29Um.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $4YGmS.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($612516bb4a7157b8$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $612516bb4a7157b8$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $5PKFW.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $612516bb4a7157b8$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $8pX4r.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $7e87O.default)(date, (0, $8g9Dy.default)(date));
    var flags = {};
    var _iterator2 = (0, $iIFkw.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $c3Qe5.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $612516bb4a7157b8$var$cleanEscapedString(input) {
    return input.match($612516bb4a7157b8$var$escapedStringRegExp)[1].replace($612516bb4a7157b8$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("iIFkw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da0c6557f18d80a4$export$2e2bcd8739ae039; });

var $8iSCO = parcelRequire("8iSCO");
function $da0c6557f18d80a4$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $8iSCO.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("8iSCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60ba6091616cdd08$export$2e2bcd8739ae039; });

var $b0xDi = parcelRequire("b0xDi");
function $60ba6091616cdd08$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $b0xDi.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $b0xDi.default)(r, a) : void 0;
    }
}

});
parcelRegister("b0xDi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8039c8927d018979$export$2e2bcd8739ae039; });
function $8039c8927d018979$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("c3Qe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7e46e7ace0830f$export$2e2bcd8739ae039; });
function $8c7e46e7ace0830f$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("6M4PE", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $4eeaf94d27f6f2e6$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $4eeaf94d27f6f2e6$export$5aaf7ff7f09ea4ee; });

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $iJu6p = parcelRequire("iJu6p");
var $4eeaf94d27f6f2e6$var$TIMEZONE_UNIT_PRIORITY = 10;
var $4eeaf94d27f6f2e6$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $l1bBi.default)(this, Setter);
        (0, $iJu6p.default)(this, "priority", void 0);
        (0, $iJu6p.default)(this, "subPriority", 0);
    }
    (0, $1nobA.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $4eeaf94d27f6f2e6$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $bT0ux.default)(ValueSetter, _Setter);
    var _super = (0, $iVGJG.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $l1bBi.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $1nobA.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($4eeaf94d27f6f2e6$export$81d53e3678089a6);
var $4eeaf94d27f6f2e6$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $bT0ux.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $iVGJG.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $l1bBi.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this2), "priority", $4eeaf94d27f6f2e6$var$TIMEZONE_UNIT_PRIORITY);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $1nobA.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($4eeaf94d27f6f2e6$export$81d53e3678089a6);

});
parcelRegister("fL1XQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b78cc4de62b7d5ea$export$2e2bcd8739ae039; });
function $b78cc4de62b7d5ea$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("bT0ux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a7536616f89267d$export$2e2bcd8739ae039; });

var $lwnlK = parcelRequire("lwnlK");
function $8a7536616f89267d$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $lwnlK.default)(t, e);
}

});
parcelRegister("lwnlK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faaeb2e9cbd4d660$export$2e2bcd8739ae039; });
function $faaeb2e9cbd4d660$export$2e2bcd8739ae039(t, e) {
    return $faaeb2e9cbd4d660$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $faaeb2e9cbd4d660$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("iVGJG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7eb353ba86904b$export$2e2bcd8739ae039; });

var $6fB1r = parcelRequire("6fB1r");

var $eEXNY = parcelRequire("eEXNY");

var $7NrNU = parcelRequire("7NrNU");
function $dc7eb353ba86904b$export$2e2bcd8739ae039(t) {
    var r = (0, $eEXNY.default)();
    return function() {
        var e, o = (0, $6fB1r.default)(t);
        if (r) {
            var s = (0, $6fB1r.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $7NrNU.default)(this, e);
    };
}

});
parcelRegister("6fB1r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48d0dca7b4099485$export$2e2bcd8739ae039; });
function $48d0dca7b4099485$export$2e2bcd8739ae039(t) {
    return $48d0dca7b4099485$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $48d0dca7b4099485$export$2e2bcd8739ae039(t);
}

});

parcelRegister("eEXNY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aac331206cffb704$export$2e2bcd8739ae039; });
function $aac331206cffb704$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($aac331206cffb704$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("7NrNU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ad2ad4ea004a923$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");

var $fL1XQ = parcelRequire("fL1XQ");
function $5ad2ad4ea004a923$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5PKFW.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $fL1XQ.default)(t);
}

});


parcelRegister("l1bBi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4d2b09471892358$export$2e2bcd8739ae039; });
function $f4d2b09471892358$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1nobA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $100ab339e5310015$export$2e2bcd8739ae039; });

var $5yW3p = parcelRequire("5yW3p");
function $100ab339e5310015$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $5yW3p.default)(o.key), o);
    }
}
function $100ab339e5310015$export$2e2bcd8739ae039(e, r, t) {
    return r && $100ab339e5310015$var$_defineProperties(e.prototype, r), t && $100ab339e5310015$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("5yW3p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40cd290fad8bdfaf$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");

var $e6CEg = parcelRequire("e6CEg");
function $40cd290fad8bdfaf$export$2e2bcd8739ae039(t) {
    var i = (0, $e6CEg.default)(t, "string");
    return "symbol" == (0, $5PKFW.default)(i) ? i : i + "";
}

});
parcelRegister("e6CEg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44f9afff14bcbf4$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");
function $a44f9afff14bcbf4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5PKFW.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5PKFW.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("iJu6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da33c7adcfb08774$export$2e2bcd8739ae039; });

var $5yW3p = parcelRequire("5yW3p");
function $da33c7adcfb08774$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5yW3p.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("4YGmS", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $39fda1664a7255db$export$19131010e7fd8373; });

var $2GMfp = parcelRequire("2GMfp");

var $3eLKb = parcelRequire("3eLKb");

var $bGYkG = parcelRequire("bGYkG");

var $al0t0 = parcelRequire("al0t0");

var $iUqDS = parcelRequire("iUqDS");

var $hbdwl = parcelRequire("hbdwl");

var $lfML7 = parcelRequire("lfML7");

var $eMIrP = parcelRequire("eMIrP");

var $4Uuww = parcelRequire("4Uuww");

var $b1lfx = parcelRequire("b1lfx");

var $8EeaI = parcelRequire("8EeaI");

var $4mzTY = parcelRequire("4mzTY");

var $8E1MP = parcelRequire("8E1MP");

var $lUDbe = parcelRequire("lUDbe");

var $i4r9M = parcelRequire("i4r9M");

var $4ef2F = parcelRequire("4ef2F");

var $lfsvV = parcelRequire("lfsvV");

var $eKJC2 = parcelRequire("eKJC2");

var $heKr8 = parcelRequire("heKr8");

var $dVmCk = parcelRequire("dVmCk");

var $i0PJR = parcelRequire("i0PJR");

var $2DPQH = parcelRequire("2DPQH");

var $YUaSX = parcelRequire("YUaSX");

var $MzW6B = parcelRequire("MzW6B");

var $428Lm = parcelRequire("428Lm");

var $dFO2x = parcelRequire("dFO2x");

var $hXx1X = parcelRequire("hXx1X");

var $i2UwV = parcelRequire("i2UwV");

var $bdOha = parcelRequire("bdOha");

var $6wrut = parcelRequire("6wrut");

var $464jN = parcelRequire("464jN");
var $39fda1664a7255db$export$19131010e7fd8373 = {
    G: new (0, $2GMfp.EraParser)(),
    y: new (0, $3eLKb.YearParser)(),
    Y: new (0, $bGYkG.LocalWeekYearParser)(),
    R: new (0, $al0t0.ISOWeekYearParser)(),
    u: new (0, $iUqDS.ExtendedYearParser)(),
    Q: new (0, $hbdwl.QuarterParser)(),
    q: new (0, $lfML7.StandAloneQuarterParser)(),
    M: new (0, $eMIrP.MonthParser)(),
    L: new (0, $4Uuww.StandAloneMonthParser)(),
    w: new (0, $b1lfx.LocalWeekParser)(),
    I: new (0, $8EeaI.ISOWeekParser)(),
    d: new (0, $4mzTY.DateParser)(),
    D: new (0, $8E1MP.DayOfYearParser)(),
    E: new (0, $lUDbe.DayParser)(),
    e: new (0, $i4r9M.LocalDayParser)(),
    c: new (0, $4ef2F.StandAloneLocalDayParser)(),
    i: new (0, $lfsvV.ISODayParser)(),
    a: new (0, $eKJC2.AMPMParser)(),
    b: new (0, $heKr8.AMPMMidnightParser)(),
    B: new (0, $dVmCk.DayPeriodParser)(),
    h: new (0, $i0PJR.Hour1to12Parser)(),
    H: new (0, $2DPQH.Hour0to23Parser)(),
    K: new (0, $YUaSX.Hour0To11Parser)(),
    k: new (0, $MzW6B.Hour1To24Parser)(),
    m: new (0, $428Lm.MinuteParser)(),
    s: new (0, $dFO2x.SecondParser)(),
    S: new (0, $hXx1X.FractionOfSecondParser)(),
    X: new (0, $i2UwV.ISOTimezoneWithZParser)(),
    x: new (0, $bdOha.ISOTimezoneParser)(),
    t: new (0, $6wrut.TimestampSecondsParser)(),
    T: new (0, $464jN.TimestampMillisecondsParser)()
};

});
parcelRegister("2GMfp", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $1f54edf8d49d6197$export$8e5a1d3f85a9688; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");
var $1f54edf8d49d6197$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(EraParser, _Parser);
    var _super = (0, $iVGJG.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $l1bBi.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 140);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $jZaM8.Parser));

});
parcelRegister("jZaM8", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $e8cc1298036c8c83$export$7acfa6ed01010e37; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $iJu6p = parcelRequire("iJu6p");

var $6M4PE = parcelRequire("6M4PE");
var $e8cc1298036c8c83$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $l1bBi.default)(this, Parser);
        (0, $iJu6p.default)(this, "incompatibleTokens", void 0);
        (0, $iJu6p.default)(this, "priority", void 0);
        (0, $iJu6p.default)(this, "subPriority", void 0);
    }
    (0, $1nobA.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $6M4PE.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("3eLKb", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $25b7b6dcb463b36f$export$48d352de7cd4a988; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $25b7b6dcb463b36f$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(YearParser, _Parser);
    var _super = (0, $iVGJG.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $l1bBi.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 130);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $dobbO.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $dobbO.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $jZaM8.Parser));

});
parcelRegister("dobbO", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $9bf6323ea8d65e8c$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $9bf6323ea8d65e8c$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $9bf6323ea8d65e8c$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $9bf6323ea8d65e8c$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $9bf6323ea8d65e8c$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $9bf6323ea8d65e8c$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $9bf6323ea8d65e8c$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $9bf6323ea8d65e8c$export$3d50627710b84d75; });

var $2KlUs = parcelRequire("2KlUs");

var $78AU3 = parcelRequire("78AU3");
function $9bf6323ea8d65e8c$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $9bf6323ea8d65e8c$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $2KlUs.millisecondsInHour) + minutes * (0, $2KlUs.millisecondsInMinute) + seconds * (0, $2KlUs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $9bf6323ea8d65e8c$export$d931c43c4608a164(dateString) {
    return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).anyDigitsSigned, dateString);
}
function $9bf6323ea8d65e8c$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).singleDigit, dateString);
        case 2:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).twoDigits, dateString);
        case 3:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).threeDigits, dateString);
        case 4:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).fourDigits, dateString);
        default:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $9bf6323ea8d65e8c$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388((0, $78AU3.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $9bf6323ea8d65e8c$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $9bf6323ea8d65e8c$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $9bf6323ea8d65e8c$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $9bf6323ea8d65e8c$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("78AU3", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $5325e7f212760498$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $5325e7f212760498$export$a7ee192b982af9c1; });
var $5325e7f212760498$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $5325e7f212760498$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("bGYkG", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $88326abef53e1a54$export$b8ef38dfcf05d5db; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");

var $3z0JA = parcelRequire("3z0JA");

var $l1hfz = parcelRequire("l1hfz");
var $88326abef53e1a54$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $iVGJG.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $l1bBi.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 130);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $dobbO.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $3z0JA.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $dobbO.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $l1hfz.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $l1hfz.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $jZaM8.Parser));

});

parcelRegister("al0t0", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $786c3a43628b6fd7$export$951d1df011fde06f; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");

var $jGECh = parcelRequire("jGECh");
var $786c3a43628b6fd7$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $iVGJG.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $l1bBi.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 130);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $dobbO.parseNDigitsSigned)(4, dateString);
                return (0, $dobbO.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $jGECh.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $jZaM8.Parser));

});

parcelRegister("iUqDS", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $dc421f8b42c2be77$export$bad9d2ea38e8f1a; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $dc421f8b42c2be77$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(ExtendedYearParser, _Parser);
    var _super = (0, $iVGJG.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $l1bBi.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 130);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $dobbO.parseNDigitsSigned)(4, dateString);
                return (0, $dobbO.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $jZaM8.Parser));

});

parcelRegister("hbdwl", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $c81df3b0b22b368b$export$5cb0f701186dde1d; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $c81df3b0b22b368b$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(QuarterParser, _Parser);
    var _super = (0, $iVGJG.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $l1bBi.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 120);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $jZaM8.Parser));

});

parcelRegister("lfML7", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $f790d23900e6022f$export$300c0c2990e20e6d; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $f790d23900e6022f$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $iVGJG.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $l1bBi.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 120);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $jZaM8.Parser));

});

parcelRegister("eMIrP", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $ac3806caf09cd5ca$export$400dd8b40ef138a3; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $dobbO = parcelRequire("dobbO");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");
var $ac3806caf09cd5ca$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(MonthParser, _Parser);
    var _super = (0, $iVGJG.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $l1bBi.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 110);
        return _this;
    }
    (0, $1nobA.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $dobbO.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $jZaM8.Parser));

});

parcelRegister("4Uuww", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $393411bebaf52baf$export$1d7eaa53eaa5deba; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $393411bebaf52baf$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $iVGJG.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $l1bBi.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 110);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $dobbO.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $jZaM8.Parser));

});

parcelRegister("b1lfx", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $8060456fcb57a0fb$export$c4005ffc174e07c0; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");

var $iEaYS = parcelRequire("iEaYS");

var $l1hfz = parcelRequire("l1hfz");
var $8060456fcb57a0fb$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(LocalWeekParser, _Parser);
    var _super = (0, $iVGJG.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $l1bBi.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 100);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $l1hfz.default)((0, $iEaYS.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $jZaM8.Parser));

});
parcelRegister("iEaYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9347afbee0e846e$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $8pX4r = parcelRequire("8pX4r");

var $cZajv = parcelRequire("cZajv");

var $hFacL = parcelRequire("hFacL");
function $d9347afbee0e846e$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $hFacL.default)(2, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var week = (0, $970db.default)(dirtyWeek);
    var diff = (0, $cZajv.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("8EeaI", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $64bd0d6143bd9567$export$6fc8dbedd560a6af; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");

var $frLvH = parcelRequire("frLvH");

var $jGECh = parcelRequire("jGECh");
var $64bd0d6143bd9567$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(ISOWeekParser, _Parser);
    var _super = (0, $iVGJG.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $l1bBi.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 100);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $jGECh.default)((0, $frLvH.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $jZaM8.Parser));

});
parcelRegister("frLvH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3ee3b2a0f05613c$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $8pX4r = parcelRequire("8pX4r");

var $d34PH = parcelRequire("d34PH");

var $hFacL = parcelRequire("hFacL");
function $b3ee3b2a0f05613c$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $hFacL.default)(2, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var isoWeek = (0, $970db.default)(dirtyISOWeek);
    var diff = (0, $d34PH.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("4mzTY", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $32d510d2d128a6a8$export$e8d4b28a20981dd2; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $dobbO = parcelRequire("dobbO");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");
var $32d510d2d128a6a8$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $32d510d2d128a6a8$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $32d510d2d128a6a8$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(DateParser, _Parser);
    var _super = (0, $iVGJG.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $l1bBi.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 90);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "subPriority", 1);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $dobbO.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $32d510d2d128a6a8$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $32d510d2d128a6a8$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $jZaM8.Parser));

});

parcelRegister("8E1MP", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $64b371f438fa5886$export$6cfe0d613455f615; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $64b371f438fa5886$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(DayOfYearParser, _Parser);
    var _super = (0, $iVGJG.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $l1bBi.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 90);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "subpriority", 1);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $dobbO.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $jZaM8.Parser));

});

parcelRegister("lUDbe", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $ff3d384b97c61efe$export$1b03c8b76262f7bd; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $1kcXL = parcelRequire("1kcXL");
var $ff3d384b97c61efe$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(DayParser, _Parser);
    var _super = (0, $iVGJG.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $l1bBi.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 90);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $1kcXL.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $jZaM8.Parser));

});
parcelRegister("1kcXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f71b6dddd15af5b$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");

var $9WzlS = parcelRequire("9WzlS");
function $0f71b6dddd15af5b$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $hFacL.default)(2, arguments);
    var defaultOptions = (0, $9WzlS.getDefaultOptions)();
    var weekStartsOn = (0, $970db.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8pX4r.default)(dirtyDate);
    var day = (0, $970db.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("i4r9M", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $d27daa7a07297806$export$44d1c127ab42c480; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");

var $1kcXL = parcelRequire("1kcXL");
var $d27daa7a07297806$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(LocalDayParser, _Parser);
    var _super = (0, $iVGJG.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $l1bBi.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 90);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $dobbO.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $1kcXL.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $jZaM8.Parser));

});

parcelRegister("4ef2F", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $3144233dc90e8832$export$e447a647caaaec1d; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");

var $1kcXL = parcelRequire("1kcXL");
var $3144233dc90e8832$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $iVGJG.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $l1bBi.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 90);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $dobbO.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $1kcXL.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $jZaM8.Parser));

});

parcelRegister("lfsvV", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $f7811df49bea3d9e$export$693fb1e525095b2a; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");

var $bbl09 = parcelRequire("bbl09");
var $f7811df49bea3d9e$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(ISODayParser, _Parser);
    var _super = (0, $iVGJG.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $l1bBi.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 90);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $dobbO.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $dobbO.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $dobbO.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $dobbO.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $bbl09.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $jZaM8.Parser));

});
parcelRegister("bbl09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8241033bbdc45a85$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");
function $8241033bbdc45a85$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $hFacL.default)(2, arguments);
    var day = (0, $970db.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $8pX4r.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("eKJC2", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $abd8be46875d7a30$export$8d1e08492351df91; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $abd8be46875d7a30$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(AMPMParser, _Parser);
    var _super = (0, $iVGJG.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $l1bBi.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 80);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $dobbO.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $jZaM8.Parser));

});

parcelRegister("heKr8", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $c8c7c3d1d2f2177a$export$73ca2bd0a17d273; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $c8c7c3d1d2f2177a$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $iVGJG.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $l1bBi.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 80);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $dobbO.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $jZaM8.Parser));

});

parcelRegister("dVmCk", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $a232248cb6a5e06a$export$bb9212adf05373db; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $a232248cb6a5e06a$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(DayPeriodParser, _Parser);
    var _super = (0, $iVGJG.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $l1bBi.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 80);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $dobbO.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $jZaM8.Parser));

});

parcelRegister("i0PJR", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $d1d05c50fb93ff79$export$8a04050a727a1756; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $d1d05c50fb93ff79$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(Hour1to12Parser, _Parser);
    var _super = (0, $iVGJG.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $l1bBi.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 70);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $jZaM8.Parser));

});

parcelRegister("2DPQH", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $1ec77169312af90a$export$e56f4dea2c3e56dd; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $1ec77169312af90a$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(Hour0to23Parser, _Parser);
    var _super = (0, $iVGJG.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $l1bBi.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 70);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $jZaM8.Parser));

});

parcelRegister("YUaSX", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $0b712dcf9433a04e$export$cbbe855312f87d77; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $0b712dcf9433a04e$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(Hour0To11Parser, _Parser);
    var _super = (0, $iVGJG.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $l1bBi.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 70);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $jZaM8.Parser));

});

parcelRegister("MzW6B", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $09205bfca604d866$export$6008046d2b34b6a5; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $09205bfca604d866$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(Hour1To24Parser, _Parser);
    var _super = (0, $iVGJG.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $l1bBi.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 70);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $jZaM8.Parser));

});

parcelRegister("428Lm", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $2efe25732ec4912b$export$2b52670d9e2be53; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $2efe25732ec4912b$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(MinuteParser, _Parser);
    var _super = (0, $iVGJG.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $l1bBi.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 60);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $jZaM8.Parser));

});

parcelRegister("dFO2x", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $9f45eb9cc96ac73d$export$94d46d540cf1366a; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $9f45eb9cc96ac73d$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(SecondParser, _Parser);
    var _super = (0, $iVGJG.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $l1bBi.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 50);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $dobbO.parseNumericPattern)((0, $78AU3.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $dobbO.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $jZaM8.Parser));

});

parcelRegister("hXx1X", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $d1319183ed30c4c2$export$b8e6f8b2d70893b1; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $d1319183ed30c4c2$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $iVGJG.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $l1bBi.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 30);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1nobA.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $dobbO.mapValue)((0, $dobbO.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $jZaM8.Parser));

});

parcelRegister("i2UwV", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $d234439844654153$export$104d901d49fea29b; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $d234439844654153$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $iVGJG.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $l1bBi.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 10);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $1nobA.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $jZaM8.Parser));

});

parcelRegister("bdOha", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $021bbd8dc3eae82b$export$12910e5204b52b9; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $78AU3 = parcelRequire("78AU3");

var $dobbO = parcelRequire("dobbO");
var $021bbd8dc3eae82b$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $iVGJG.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $l1bBi.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 10);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $1nobA.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $dobbO.parseTimezonePattern)((0, $78AU3.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $jZaM8.Parser));

});

parcelRegister("6wrut", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $4bfb0e4c38cdf088$export$2cd8bf877a05e96; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $4bfb0e4c38cdf088$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $iVGJG.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $l1bBi.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 40);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $1nobA.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $dobbO.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $jZaM8.Parser));

});

parcelRegister("464jN", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $2fbb127b2561ed03$export$6d8f69c6906d6368; });

var $l1bBi = parcelRequire("l1bBi");

var $1nobA = parcelRequire("1nobA");

var $fL1XQ = parcelRequire("fL1XQ");

var $bT0ux = parcelRequire("bT0ux");

var $iVGJG = parcelRequire("iVGJG");

var $iJu6p = parcelRequire("iJu6p");

var $jZaM8 = parcelRequire("jZaM8");

var $dobbO = parcelRequire("dobbO");
var $2fbb127b2561ed03$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $bT0ux.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $iVGJG.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $l1bBi.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "priority", 20);
        (0, $iJu6p.default)((0, $fL1XQ.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $1nobA.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $dobbO.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $jZaM8.Parser));

});



parcelRegister("25dV3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1846d8745be347b9$export$2e2bcd8739ae039; });

var $A9EUN = parcelRequire("A9EUN");

var $4Vmy2 = parcelRequire("4Vmy2");

var $56ksW = parcelRequire("56ksW");

var $ai79g = parcelRequire("ai79g");

var $cOR2C = parcelRequire("cOR2C");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $1846d8745be347b9$var$locale = {
    code: 'nb',
    formatDistance: (0, $A9EUN.default),
    formatLong: (0, $4Vmy2.default),
    formatRelative: (0, $56ksW.default),
    localize: (0, $ai79g.default),
    match: (0, $cOR2C.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1846d8745be347b9$export$2e2bcd8739ae039 = $1846d8745be347b9$var$locale;

});
parcelRegister("A9EUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06cadaf7e2ecf401$export$2e2bcd8739ae039; });
var $06cadaf7e2ecf401$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $06cadaf7e2ecf401$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $06cadaf7e2ecf401$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $06cadaf7e2ecf401$export$2e2bcd8739ae039 = $06cadaf7e2ecf401$var$formatDistance;

});

parcelRegister("4Vmy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $395df9dd3bfa8e96$export$2e2bcd8739ae039; });

var $4DmBO = parcelRequire("4DmBO");
var $395df9dd3bfa8e96$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $395df9dd3bfa8e96$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $395df9dd3bfa8e96$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $395df9dd3bfa8e96$var$formatLong = {
    date: (0, $4DmBO.default)({
        formats: $395df9dd3bfa8e96$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $4DmBO.default)({
        formats: $395df9dd3bfa8e96$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $4DmBO.default)({
        formats: $395df9dd3bfa8e96$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $395df9dd3bfa8e96$export$2e2bcd8739ae039 = $395df9dd3bfa8e96$var$formatLong;

});

parcelRegister("56ksW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b6d6359170a904f$export$2e2bcd8739ae039; });
var $3b6d6359170a904f$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $3b6d6359170a904f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3b6d6359170a904f$var$formatRelativeLocale[token];
};
var $3b6d6359170a904f$export$2e2bcd8739ae039 = $3b6d6359170a904f$var$formatRelative;

});

parcelRegister("ai79g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77e1215ae563e168$export$2e2bcd8739ae039; });

var $lgVBX = parcelRequire("lgVBX");
var $77e1215ae563e168$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $77e1215ae563e168$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $77e1215ae563e168$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $77e1215ae563e168$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $77e1215ae563e168$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $77e1215ae563e168$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $77e1215ae563e168$var$localize = {
    ordinalNumber: $77e1215ae563e168$var$ordinalNumber,
    era: (0, $lgVBX.default)({
        values: $77e1215ae563e168$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $lgVBX.default)({
        values: $77e1215ae563e168$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $lgVBX.default)({
        values: $77e1215ae563e168$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $lgVBX.default)({
        values: $77e1215ae563e168$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $lgVBX.default)({
        values: $77e1215ae563e168$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $77e1215ae563e168$export$2e2bcd8739ae039 = $77e1215ae563e168$var$localize;

});

parcelRegister("cOR2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95534c6f97edd63b$export$2e2bcd8739ae039; });

var $87cbQ = parcelRequire("87cbQ");

var $fzR5N = parcelRequire("fzR5N");
var $95534c6f97edd63b$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $95534c6f97edd63b$var$parseOrdinalNumberPattern = /\d+/i;
var $95534c6f97edd63b$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $95534c6f97edd63b$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $95534c6f97edd63b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $95534c6f97edd63b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $95534c6f97edd63b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $95534c6f97edd63b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $95534c6f97edd63b$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $95534c6f97edd63b$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $95534c6f97edd63b$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $95534c6f97edd63b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $95534c6f97edd63b$var$match = {
    ordinalNumber: (0, $fzR5N.default)({
        matchPattern: $95534c6f97edd63b$var$matchOrdinalNumberPattern,
        parsePattern: $95534c6f97edd63b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $87cbQ.default)({
        matchPatterns: $95534c6f97edd63b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95534c6f97edd63b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $87cbQ.default)({
        matchPatterns: $95534c6f97edd63b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95534c6f97edd63b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $87cbQ.default)({
        matchPatterns: $95534c6f97edd63b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95534c6f97edd63b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $87cbQ.default)({
        matchPatterns: $95534c6f97edd63b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $95534c6f97edd63b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $87cbQ.default)({
        matchPatterns: $95534c6f97edd63b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $95534c6f97edd63b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $95534c6f97edd63b$export$2e2bcd8739ae039 = $95534c6f97edd63b$var$match;

});


parcelRegister("3b1Vf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2503e3efe16323cf$export$2e2bcd8739ae039; });

var $9aP4i = parcelRequire("9aP4i");

var $2xHgv = parcelRequire("2xHgv");

var $jHP7K = parcelRequire("jHP7K");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $2503e3efe16323cf$var$min(array) {
    return array && array.length ? (0, $9aP4i.default)(array, (0, $jHP7K.default), (0, $2xHgv.default)) : undefined;
}
var $2503e3efe16323cf$export$2e2bcd8739ae039 = $2503e3efe16323cf$var$min;

});
parcelRegister("9aP4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6adca957e7e355eb$export$2e2bcd8739ae039; });

var $ebwzy = parcelRequire("ebwzy");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $6adca957e7e355eb$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !(0, $ebwzy.default)(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
var $6adca957e7e355eb$export$2e2bcd8739ae039 = $6adca957e7e355eb$var$baseExtremum;

});

parcelRegister("2xHgv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1da0396e65174534$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $1da0396e65174534$var$baseLt(value, other) {
    return value < other;
}
var $1da0396e65174534$export$2e2bcd8739ae039 = $1da0396e65174534$var$baseLt;

});


parcelRegister("ge6NY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd033b7e91d9dd5c$export$2e2bcd8739ae039; });

var $3GE3c = parcelRequire("3GE3c");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $bd033b7e91d9dd5c$var$upperFirst = (0, $3GE3c.default)('toUpperCase');
var $bd033b7e91d9dd5c$export$2e2bcd8739ae039 = $bd033b7e91d9dd5c$var$upperFirst;

});
parcelRegister("3GE3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2af45c92e82593ef$export$2e2bcd8739ae039; });

var $6QJPP = parcelRequire("6QJPP");

var $aCxUA = parcelRequire("aCxUA");

var $fXIA9 = parcelRequire("fXIA9");

var $cQbRr = parcelRequire("cQbRr");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $2af45c92e82593ef$var$createCaseFirst(methodName) {
    return function(string) {
        string = (0, $cQbRr.default)(string);
        var strSymbols = (0, $aCxUA.default)(string) ? (0, $fXIA9.default)(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? (0, $6QJPP.default)(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
var $2af45c92e82593ef$export$2e2bcd8739ae039 = $2af45c92e82593ef$var$createCaseFirst;

});
parcelRegister("6QJPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fcb274a1e472f4b$export$2e2bcd8739ae039; });

var $awSUU = parcelRequire("awSUU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $4fcb274a1e472f4b$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : (0, $awSUU.default)(array, start, end);
}
var $4fcb274a1e472f4b$export$2e2bcd8739ae039 = $4fcb274a1e472f4b$var$castSlice;

});

parcelRegister("aCxUA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bb7c22512a3baad$export$2e2bcd8739ae039; });
/** Used to compose unicode character classes. */ var $7bb7c22512a3baad$var$rsAstralRange = '\\ud800-\\udfff', $7bb7c22512a3baad$var$rsComboMarksRange = '\\u0300-\\u036f', $7bb7c22512a3baad$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7bb7c22512a3baad$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7bb7c22512a3baad$var$rsComboRange = $7bb7c22512a3baad$var$rsComboMarksRange + $7bb7c22512a3baad$var$reComboHalfMarksRange + $7bb7c22512a3baad$var$rsComboSymbolsRange, $7bb7c22512a3baad$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7bb7c22512a3baad$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $7bb7c22512a3baad$var$reHasUnicode = RegExp('[' + $7bb7c22512a3baad$var$rsZWJ + $7bb7c22512a3baad$var$rsAstralRange + $7bb7c22512a3baad$var$rsComboRange + $7bb7c22512a3baad$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $7bb7c22512a3baad$var$hasUnicode(string) {
    return $7bb7c22512a3baad$var$reHasUnicode.test(string);
}
var $7bb7c22512a3baad$export$2e2bcd8739ae039 = $7bb7c22512a3baad$var$hasUnicode;

});

parcelRegister("fXIA9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9eef2c603c2fdbe$export$2e2bcd8739ae039; });

var $16bwq = parcelRequire("16bwq");

var $aCxUA = parcelRequire("aCxUA");

var $awxaE = parcelRequire("awxaE");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b9eef2c603c2fdbe$var$stringToArray(string) {
    return (0, $aCxUA.default)(string) ? (0, $awxaE.default)(string) : (0, $16bwq.default)(string);
}
var $b9eef2c603c2fdbe$export$2e2bcd8739ae039 = $b9eef2c603c2fdbe$var$stringToArray;

});
parcelRegister("16bwq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ccf49fd5bda2527$export$2e2bcd8739ae039; });
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0ccf49fd5bda2527$var$asciiToArray(string) {
    return string.split('');
}
var $0ccf49fd5bda2527$export$2e2bcd8739ae039 = $0ccf49fd5bda2527$var$asciiToArray;

});

parcelRegister("awxaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a969f9072962d3c$export$2e2bcd8739ae039; });
/** Used to compose unicode character classes. */ var $7a969f9072962d3c$var$rsAstralRange = '\\ud800-\\udfff', $7a969f9072962d3c$var$rsComboMarksRange = '\\u0300-\\u036f', $7a969f9072962d3c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7a969f9072962d3c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7a969f9072962d3c$var$rsComboRange = $7a969f9072962d3c$var$rsComboMarksRange + $7a969f9072962d3c$var$reComboHalfMarksRange + $7a969f9072962d3c$var$rsComboSymbolsRange, $7a969f9072962d3c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7a969f9072962d3c$var$rsAstral = '[' + $7a969f9072962d3c$var$rsAstralRange + ']', $7a969f9072962d3c$var$rsCombo = '[' + $7a969f9072962d3c$var$rsComboRange + ']', $7a969f9072962d3c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7a969f9072962d3c$var$rsModifier = '(?:' + $7a969f9072962d3c$var$rsCombo + '|' + $7a969f9072962d3c$var$rsFitz + ')', $7a969f9072962d3c$var$rsNonAstral = '[^' + $7a969f9072962d3c$var$rsAstralRange + ']', $7a969f9072962d3c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7a969f9072962d3c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7a969f9072962d3c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7a969f9072962d3c$var$reOptMod = $7a969f9072962d3c$var$rsModifier + '?', $7a969f9072962d3c$var$rsOptVar = '[' + $7a969f9072962d3c$var$rsVarRange + ']?', $7a969f9072962d3c$var$rsOptJoin = '(?:' + $7a969f9072962d3c$var$rsZWJ + '(?:' + [
    $7a969f9072962d3c$var$rsNonAstral,
    $7a969f9072962d3c$var$rsRegional,
    $7a969f9072962d3c$var$rsSurrPair
].join('|') + ')' + $7a969f9072962d3c$var$rsOptVar + $7a969f9072962d3c$var$reOptMod + ')*', $7a969f9072962d3c$var$rsSeq = $7a969f9072962d3c$var$rsOptVar + $7a969f9072962d3c$var$reOptMod + $7a969f9072962d3c$var$rsOptJoin, $7a969f9072962d3c$var$rsSymbol = '(?:' + [
    $7a969f9072962d3c$var$rsNonAstral + $7a969f9072962d3c$var$rsCombo + '?',
    $7a969f9072962d3c$var$rsCombo,
    $7a969f9072962d3c$var$rsRegional,
    $7a969f9072962d3c$var$rsSurrPair,
    $7a969f9072962d3c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7a969f9072962d3c$var$reUnicode = RegExp($7a969f9072962d3c$var$rsFitz + '(?=' + $7a969f9072962d3c$var$rsFitz + ')|' + $7a969f9072962d3c$var$rsSymbol + $7a969f9072962d3c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7a969f9072962d3c$var$unicodeToArray(string) {
    return string.match($7a969f9072962d3c$var$reUnicode) || [];
}
var $7a969f9072962d3c$export$2e2bcd8739ae039 = $7a969f9072962d3c$var$unicodeToArray;

});









parcelRegister("nTNy4", function(module, exports) {
module.exports = $parcel$resolve("eV24G");

});

parcelRegister("e2klx", function(module, exports) {
module.exports = $parcel$resolve("3mguL");

});

parcelRegister("4YU74", function(module, exports) {
module.exports = $parcel$resolve("dxK8z");

});

parcelRegister("5MfSg", function(module, exports) {
module.exports = $parcel$resolve("aUKr0");

});




parcelRegister("duLFK", function(module, exports) {

$parcel$export(module.exports, "isAbortError", function () { return $e3449f1771026ebe$export$d2c30ea522b3259e; });
$parcel$export(module.exports, "initializeWithDefaultData", function () { return $e3449f1771026ebe$export$52893b8046bf339; });
$parcel$export(module.exports, "setAsLoading", function () { return $e3449f1771026ebe$export$89893751f2714852; });
$parcel$export(module.exports, "isLoading", function () { return $e3449f1771026ebe$export$20bb0d907fbbe433; });
$parcel$export(module.exports, "setAsErrorOccured", function () { return $e3449f1771026ebe$export$862e2c6b91cb5c49; });
$parcel$export(module.exports, "setAsDataAvailable", function () { return $e3449f1771026ebe$export$28ad74fbbf5a22d; });
$parcel$export(module.exports, "setAsWaitingForData", function () { return $e3449f1771026ebe$export$30a89b3f789d3b1b; });
$parcel$export(module.exports, "isDefaultData", function () { return $e3449f1771026ebe$export$da5bf2222f43ab86; });
$parcel$export(module.exports, "isErrorOccured", function () { return $e3449f1771026ebe$export$c8b12516e9bbe961; });
$parcel$export(module.exports, "isDataAvailable", function () { return $e3449f1771026ebe$export$e41a9e99cc437568; });
$parcel$export(module.exports, "isWaitingForData", function () { return $e3449f1771026ebe$export$dfe4ebc6477f5ff3; });

var $Kk7R3 = parcelRequire("Kk7R3");

var $gtsdT = parcelRequire("gtsdT");
var $e3449f1771026ebe$export$b8081f25e3a7bfbd = /*#__PURE__*/ function(RequestProgress) {
    RequestProgress["defaultData"] = "defaultData";
    RequestProgress["loading"] = "loading";
    RequestProgress["errorOccured"] = "errorOccured";
    RequestProgress["dataAvailable"] = "dataAvailable";
    RequestProgress["updating"] = "updating";
    return RequestProgress;
}({});
const $e3449f1771026ebe$export$d2c30ea522b3259e = (error)=>{
    return error instanceof DOMException && error.name === "AbortError";
};
const $e3449f1771026ebe$export$5dbf73155043ec8c = "Request aborted due to new request.";
/** AsyncData flow represented as a Record*/ const $e3449f1771026ebe$var$asyncDataFlow = {
    defaultData: [
        "loading"
    ],
    loading: [
        "errorOccured",
        "dataAvailable"
    ],
    errorOccured: [
        "loading"
    ],
    dataAvailable: [
        "loading",
        "updating"
    ],
    updating: [
        "errorOccured",
        "dataAvailable"
    ]
};
const $e3449f1771026ebe$var$isValidFlow = (prevProgress, newProgress)=>$e3449f1771026ebe$var$asyncDataFlow[prevProgress].includes(newProgress);
/** Sets the new AsyncData if the progress transition matches the AsyncData flow */ const $e3449f1771026ebe$var$attemptProgressTransition = (0, $Kk7R3.action)((exisitingData, newAsyncData)=>{
    if ($e3449f1771026ebe$var$isValidFlow(exisitingData.progress, newAsyncData.progress)) {
        if ("errorMessage" in exisitingData) exisitingData.errorMessage = undefined;
        Object.assign(exisitingData, newAsyncData);
        return true;
    }
    (0, $gtsdT.logger).warn("utils", "Invalid transition: ", exisitingData.progress, " to ", newAsyncData.progress);
    return false;
});
const $e3449f1771026ebe$export$52893b8046bf339 = (0, $Kk7R3.action)((defaultData)=>({
        progress: "defaultData",
        data: defaultData
    }));
const $e3449f1771026ebe$export$89893751f2714852 = (0, $Kk7R3.action)((currentAsyncData)=>{
    if ($e3449f1771026ebe$export$20bb0d907fbbe433(currentAsyncData) && currentAsyncData.abortController) {
        currentAsyncData.abortController.abort($e3449f1771026ebe$export$5dbf73155043ec8c);
        currentAsyncData.abortController = new AbortController();
        return currentAsyncData.abortController;
    }
    const controller = new AbortController();
    $e3449f1771026ebe$var$attemptProgressTransition(currentAsyncData, {
        data: currentAsyncData.data,
        progress: "loading",
        abortController: controller
    });
    return controller;
});
const $e3449f1771026ebe$export$862e2c6b91cb5c49 = (0, $Kk7R3.action)((currentAsyncData, errorMessage)=>{
    if (typeof errorMessage === "string" && errorMessage === $e3449f1771026ebe$export$5dbf73155043ec8c) return;
    $e3449f1771026ebe$var$attemptProgressTransition(currentAsyncData, {
        data: currentAsyncData.data,
        progress: "errorOccured",
        errorMessage: errorMessage
    });
});
const $e3449f1771026ebe$export$28ad74fbbf5a22d = (0, $Kk7R3.action)((currentAsyncData, newData)=>$e3449f1771026ebe$var$attemptProgressTransition(currentAsyncData, {
        data: newData ?? currentAsyncData.data,
        progress: "dataAvailable"
    }));
const $e3449f1771026ebe$export$cfdaf397b43692f2 = (0, $Kk7R3.action)((currentAsyncData)=>{
    if ($e3449f1771026ebe$export$47c4de0d33d39df3(currentAsyncData) && currentAsyncData.abortController) {
        currentAsyncData.abortController.abort($e3449f1771026ebe$export$5dbf73155043ec8c);
        currentAsyncData.abortController = new AbortController();
        return currentAsyncData.abortController;
    }
    const controller = new AbortController();
    $e3449f1771026ebe$var$attemptProgressTransition(currentAsyncData, {
        data: currentAsyncData.data,
        progress: "updating",
        abortController: controller
    });
    return controller;
});
const $e3449f1771026ebe$export$30a89b3f789d3b1b = (0, $Kk7R3.action)((currentAsyncData)=>{
    const isNextStateLoading = $e3449f1771026ebe$export$da5bf2222f43ab86(currentAsyncData) || $e3449f1771026ebe$export$20bb0d907fbbe433(currentAsyncData) || $e3449f1771026ebe$export$c8b12516e9bbe961(currentAsyncData);
    return isNextStateLoading ? $e3449f1771026ebe$export$89893751f2714852(currentAsyncData) : $e3449f1771026ebe$export$cfdaf397b43692f2(currentAsyncData);
});
const $e3449f1771026ebe$export$da5bf2222f43ab86 = (asyncData)=>asyncData.progress === "defaultData";
const $e3449f1771026ebe$export$e41a9e99cc437568 = (asyncData)=>asyncData.progress === "dataAvailable";
const $e3449f1771026ebe$export$20bb0d907fbbe433 = (asyncData)=>asyncData.progress === "loading";
const $e3449f1771026ebe$export$c8b12516e9bbe961 = (asyncData)=>asyncData.progress === "errorOccured";
const $e3449f1771026ebe$export$47c4de0d33d39df3 = (asyncData)=>asyncData.progress === "updating";
const $e3449f1771026ebe$export$dfe4ebc6477f5ff3 = (asyncData)=>$e3449f1771026ebe$export$20bb0d907fbbe433(asyncData) || $e3449f1771026ebe$export$47c4de0d33d39df3(asyncData);

});

parcelRegister("76PCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c3633ed555a266$export$2e2bcd8739ae039; });

var $7c65l = parcelRequire("7c65l");

var $fbCoc = parcelRequire("fbCoc");
var $5UIm0 = parcelRequire("5UIm0");

var $5qW1i = parcelRequire("5qW1i");

var $d4mYJ = parcelRequire("d4mYJ");

var $kneHr = parcelRequire("kneHr");

var $jf2w9 = parcelRequire("jf2w9");

var $bEEBX = parcelRequire("bEEBX");

var $3xOZa = parcelRequire("3xOZa");

var $f3FkZ = parcelRequire("f3FkZ");

var $15TRa = parcelRequire("15TRa");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $8aSS4 = parcelRequire("8aSS4");

var $aRSTV = parcelRequire("aRSTV");

var $5OqMf = parcelRequire("5OqMf");

var $4udGV = parcelRequire("4udGV");

var $f2Bp8 = parcelRequire("f2Bp8");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $8Wejn = parcelRequire("8Wejn");

var $9Vhxl = parcelRequire("9Vhxl");

var $jAf35 = parcelRequire("jAf35");

var $7mifc = parcelRequire("7mifc");

var $bZiDo = parcelRequire("bZiDo");

var $i6TQx = parcelRequire("i6TQx");

var $5aUWQ = parcelRequire("5aUWQ");

var $gvoND = parcelRequire("gvoND");

var $345Ip = parcelRequire("345Ip");
const $c0c3633ed555a266$var$cartStore = (0, $Kk7R3.makeAutoObservable)({
    items: [],
    orderType: (0, $f2Bp8.getOrdertypeFromStorage)((0, $isIf6.default).defaultOrderType),
    miniCartVisible: false,
    cancelled: [],
    sendingOrder: false,
    editing: (0, $f2Bp8.getEditModeFromStorage)(),
    orderRefs: {
        orderName: "",
        customerReference: "",
        customerOrderNumber: ""
    },
    lostSales: [],
    getCartItem: (sku)=>{
        return (0, $jf2w9.default)($c0c3633ed555a266$var$cartStore.items, {
            sku: sku
        });
    },
    resetOrderRefs: ()=>{
        $c0c3633ed555a266$var$cartStore.orderRefs = {
            orderName: "",
            customerReference: "",
            customerOrderNumber: ""
        };
    },
    deliveryDateForPicker: ()=>{
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if ((0, $bEEBX.default)(currentDelivery)) return [];
        return [
            currentDelivery.date
        ];
    },
    getCartTotalBeforeDiscount: ()=>{
        const cartItems = $c0c3633ed555a266$var$cartStore.items;
        return (0, $345Ip.getCartTotal)(cartItems, true);
    },
    getCartTotal: ()=>{
        const cartItems = $c0c3633ed555a266$var$cartStore.items;
        return (0, $345Ip.getCartTotal)(cartItems, false);
    },
    startEditOrderMode: async (m3Order)=>{
        if ($c0c3633ed555a266$var$cartStore.editing !== null) (0, $gtsdT.logger).warn("cart", "Something unexpected happened, we are trying to start editing an order while editing");
        // Extract the neccesary data from the m3 order objekt from TIP API
        const orderNumber = m3Order.orderNumber;
        const deliveryDate = (0, $5UIm0.default)(m3Order.requestedDeliveryDate);
        const deadline = m3Order.deadline;
        const orderItems = m3Order.optimizedOrderLines.map((ol)=>(0, $f3FkZ.default)(ol, [
                "sku",
                "combinedOrderLineNumbers",
                "canDecrease",
                "canIncrease",
                "canDelete",
                "totalQuantity"
            ])).map((ol)=>({
                ...ol,
                qty: ol.totalQuantity,
                combinedLines: ol.combinedOrderLineNumbers
            }));
        await (0, $9Vhxl.default).changeDeliveryDate(deliveryDate, $c0c3633ed555a266$var$cartStore.orderType);
        // Filling in the editing key turns the store over to "edit mode"
        $c0c3633ed555a266$var$cartStore.editing = {
            orderNumber: orderNumber,
            deadline: deadline,
            orderType: m3Order.orderType,
            oldState: orderItems,
            canAddItems: true,
            deliveryDate: deliveryDate,
            canEditOrder: (0, $7mifc.default).orderDetails[m3Order.orderNumber]?.data?.canDelete ?? true,
            canEditOrderLine: (sku)=>orderItems.find((item)=>item.sku === sku)?.canDelete ?? true
        };
        // Set up cart contents with the items from the order we are editing
        $c0c3633ed555a266$var$cartStore.emptyCart();
        for (const oi of orderItems)$c0c3633ed555a266$var$cartStore.addToCart(oi.sku, oi.qty, 0);
        // We need to set the canAddItems after we have added all the items to the cart to avoid getting blocked
        $c0c3633ed555a266$var$cartStore.editing = {
            ...$c0c3633ed555a266$var$cartStore.editing,
            canAddItems: m3Order.canAddOrderline
        };
        $c0c3633ed555a266$var$cartStore.orderRefs = {
            orderName: (0, $7mifc.default).orderDetails[m3Order.orderNumber].data?.orderName ?? "",
            customerReference: (0, $7mifc.default).orderDetails[m3Order.orderNumber].data?.customerReference ?? "",
            customerOrderNumber: (0, $7mifc.default).orderDetails[m3Order.orderNumber].data?.customerOrderNumber ?? ""
        };
        (0, $f2Bp8.setEditmodeInStorage)($c0c3633ed555a266$var$cartStore.editing);
    },
    startEditSubscriptionMode: async (subscription, instanceDate, existingInstance = false)=>{
        if ($c0c3633ed555a266$var$cartStore.editing !== null) (0, $gtsdT.logger).warn("cart", "Something unexpected happened, we are trying to start editing an order while editing");
        $c0c3633ed555a266$var$cartStore.changeOrderType((0, $8aSS4.ORDERTYPE).WAS);
        let orderDetails;
        let changeToDate;
        if ((0, $bEEBX.default)(instanceDate)) {
            (0, $gtsdT.logger).log("cart", `Starting edit of main subscription ${subscription.orderNumber}`);
            const nextDeliveryDate = (0, $9Vhxl.default).getNextMatchingDeliveryDate(subscription.deliveryWeekdayNumber);
            if ((0, $bEEBX.default)(nextDeliveryDate)) {
                (0, $gvoND.default).addError("Det oppsto en feil", "Dessverre greier vi ikke \xe5 starte redigering av dette abonnementet pga en utfordring med leveringsdagene.");
                return;
            }
            changeToDate = nextDeliveryDate.date;
            orderDetails = subscription;
        } else {
            changeToDate = (0, $4udGV.parseM3Date)(instanceDate);
            if (existingInstance) {
                (0, $gtsdT.logger).log("cart", `Starting edit of existing ${instanceDate} instance of subscription ${subscription.orderNumber}`);
                orderDetails = await (0, $5aUWQ.default).fetchInstanceOrder(subscription.orderNumber, instanceDate);
            } else {
                (0, $gtsdT.logger).log("cart", `Starting creation of new ${instanceDate} instance of subscription ${subscription.orderNumber}`);
                orderDetails = subscription;
            }
        }
        await (0, $9Vhxl.default).changeDeliveryDate(changeToDate, (0, $8aSS4.ORDERTYPE).WAS);
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if ((0, $bEEBX.default)(currentDelivery)) {
            (0, $gvoND.default).addError("Det oppsto en feil", "Det oppsto en feil etter endring av leveringsdag.");
            return;
        }
        currentDelivery.interval = Number.parseInt(subscription.deliveryIntervalDays);
        const orderItems = orderDetails.optimizedOrderLines.map((ol)=>(0, $f3FkZ.default)(ol, [
                "sku",
                "combinedOrderLineNumbers",
                "canDecrease",
                "canIncrease",
                "canDelete",
                "totalQuantity"
            ])).map((ol)=>({
                ...ol,
                qty: ol.totalQuantity,
                combinedLines: ol.combinedOrderLineNumbers
            }));
        // Set up cart contents with the items from the order we are editing
        $c0c3633ed555a266$var$cartStore.emptyCart();
        for (const oi of orderItems)$c0c3633ed555a266$var$cartStore.addToCart(oi.sku, (0, $kneHr.default)(oi.qty, 1), 0);
        // Filling in the editing key turns the store over to "edit mode"
        $c0c3633ed555a266$var$cartStore.editing = {
            orderNumber: orderDetails.orderNumber,
            orderType: (0, $8aSS4.ORDERTYPE).WAS,
            instanceDate: instanceDate,
            existingInstance: existingInstance,
            // The difference between these two is the s at the end, unfortuantely the two APIs behave differently.
            canAddItems: (0, $kneHr.default)(orderDetails.canAddOrderline, orderDetails.canAddOrderlines) ?? false,
            oldState: orderItems,
            deliveryDate: changeToDate,
            canEditOrder: (0, $7mifc.default).orderDetails[orderDetails.orderNumber]?.data?.canDelete ?? true,
            canEditOrderLine: (sku)=>orderItems.find((item)=>item.sku === sku)?.canDelete ?? true
        };
        $c0c3633ed555a266$var$cartStore.orderRefs = {
            orderName: "",
            customerReference: (0, $5aUWQ.default).subscriptionDetails[subscription.orderNumber].data?.customerReference ?? "",
            customerOrderNumber: ""
        };
        (0, $f2Bp8.setEditmodeInStorage)($c0c3633ed555a266$var$cartStore.editing);
    },
    getValidQtyRange: (sku)=>{
        let min = 1;
        let max = Number.MAX_SAFE_INTEGER;
        if (!$c0c3633ed555a266$var$cartStore.isEditing()) return {
            min: min,
            max: max
        };
        const item = (0, $jf2w9.default)($c0c3633ed555a266$var$cartStore.editing?.oldState, {
            sku: sku
        });
        if ((0, $3xOZa.default)(item)) return {
            min: min,
            max: max
        };
        if (!item.canIncrease) max = item.qty;
        if (!item.canDecrease) min = item.qty;
        return {
            min: min,
            max: max
        };
    },
    isEditing: ()=>{
        return $c0c3633ed555a266$var$cartStore.editing !== null;
    },
    isEditingInstance: ()=>{
        return !(0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing) && !(0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing.instanceDate);
    },
    isAddedDuringEdit: (sku)=>{
        if ((0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing)) return true;
        const previousOrder = (0, $jf2w9.default)($c0c3633ed555a266$var$cartStore.editing.oldState, {
            sku: sku
        });
        return (0, $bEEBX.default)(previousOrder);
    },
    hasQtyChangedDuringEdit: (sku)=>{
        if ((0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing)) return false;
        const previousOrder = (0, $jf2w9.default)($c0c3633ed555a266$var$cartStore.editing.oldState, {
            sku: sku
        });
        if ((0, $bEEBX.default)(previousOrder)) // Product was not in previous order at all, so mark this as not a change
        return false;
        const currentCart = $c0c3633ed555a266$var$cartStore.getCartItem(sku);
        if ((0, $bEEBX.default)(currentCart)) return false;
        // Only true if the cart qty has changed
        return currentCart.qty !== previousOrder.qty;
    },
    getEditingCartChanges: ()=>{
        if ($c0c3633ed555a266$var$cartStore.editing) {
            const oldState = $c0c3633ed555a266$var$cartStore.editing.oldState;
            const newAndChanged = $c0c3633ed555a266$var$cartStore.items.map((item)=>{
                const orderLine = oldState.find((orderLine)=>orderLine.sku === item.sku);
                if (orderLine) return {
                    ...item,
                    qtyDelta: item.qty - orderLine.qty
                };
                return {
                    ...item,
                    qtyDelta: item.qty
                };
            }).filter((cartItemDelta)=>cartItemDelta.qtyDelta !== 0);
            const removed = oldState.filter((orderLine)=>!$c0c3633ed555a266$var$cartStore.items.find((item)=>item.sku === orderLine.sku)).map((orderLine)=>({
                    sku: orderLine.sku,
                    qty: 0,
                    fromEditing: true,
                    qtyDelta: -orderLine.qty,
                    unit: (0, $bZiDo.default).resolveSku(orderLine.sku)?.unit || (0, $8aSS4.ORDER_UNIT).D
                }));
            return [
                ...newAndChanged,
                ...removed
            ];
        }
        return [];
    },
    generateChangeOrderPayload: ()=>{
        if ((0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing) || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany) || (0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing.orderNumber)) return null;
        const changedLines = $c0c3633ed555a266$var$cartStore.items.filter((ci)=>$c0c3633ed555a266$var$cartStore.hasQtyChangedDuringEdit(ci.sku));
        (0, $gtsdT.logger).log("cart", "Changed lines: ", changedLines);
        const addedLines = $c0c3633ed555a266$var$cartStore.items.filter((ci)=>$c0c3633ed555a266$var$cartStore.isAddedDuringEdit(ci.sku));
        (0, $gtsdT.logger).log("cart", "Added lines: ", addedLines);
        const removedOrderLines = $c0c3633ed555a266$var$cartStore.editing.oldState.filter((os)=>(0, $3xOZa.default)((0, $jf2w9.default)($c0c3633ed555a266$var$cartStore.items, {
                sku: os.sku
            })));
        (0, $gtsdT.logger).log("cart", "Removed order lines: ", removedOrderLines);
        if (removedOrderLines.length === 0 && changedLines.length === 0 && addedLines.length === 0) return null;
        const actions = (0, $5OqMf.createActionsFromCartChanges)(addedLines, changedLines, removedOrderLines, $c0c3633ed555a266$var$cartStore.editing.oldState);
        for (const lostSale of $c0c3633ed555a266$var$cartStore.lostSales)actions.push({
            action: "add",
            lostSalesUniqueId: (0, $5OqMf.createRandomHex)(10),
            ...lostSale
        });
        return {
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            orderNumber: $c0c3633ed555a266$var$cartStore.editing.orderNumber,
            estimatedOrderAmount: 2500,
            orderLines: actions
        };
    },
    stopEditOrderMode: async ()=>{
        if ((0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing) || (0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.orderType)) {
            (0, $gtsdT.logger).warn("cart", `Wrong state to stop edit mode, editing: ${$c0c3633ed555a266$var$cartStore.editing}, orderType: ${$c0c3633ed555a266$var$cartStore.orderType}`);
            return Promise.reject("Wrong state to stop edit mode");
        }
        const orderNumber = $c0c3633ed555a266$var$cartStore.editing.orderNumber;
        if ((0, $bEEBX.default)(orderNumber)) return Promise.reject("Unable to determine what order number was being edited");
        $c0c3633ed555a266$var$cartStore.emptyCart();
        $c0c3633ed555a266$var$cartStore.editing = null;
        (0, $f2Bp8.setEditmodeInStorage)($c0c3633ed555a266$var$cartStore.editing);
        (0, $9Vhxl.default).selectNextDeliveryDateForOrderType($c0c3633ed555a266$var$cartStore.orderType);
        return Promise.resolve(orderNumber);
    },
    changeOrderType: (0, $Kk7R3.action)((newOrderType)=>{
        if (!(0, $lKrOo.default).is("DELIVERY_DATES_LOADING") || (0, $lKrOo.default).is("LOGGED_IN")) (0, $gtsdT.logger).warn("cart", "Unexpected order type change?");
        // const currentDelivery = deliveryDatesStore.getCurrentDelivery();
        $c0c3633ed555a266$var$cartStore.orderType = newOrderType;
        (0, $8Wejn.default).clearAvailability();
        (0, $f2Bp8.setOrderTypeInStorage)(newOrderType);
        const deliveryForType = (0, $9Vhxl.default).getCurrentDelivery(newOrderType);
        const expiration = (0, $9Vhxl.default).getCurrentDeliveryExpiration(newOrderType);
        if (deliveryForType && expiration) (0, $9Vhxl.default).changeDeliveryDate(deliveryForType.date, newOrderType);
        else (0, $9Vhxl.default).selectNextDeliveryDateForOrderType(newOrderType);
        // Find the next possible delivery date for this order type
        if (newOrderType === (0, $8aSS4.ORDERTYPE).WAS) {
            (0, $8Wejn.default).clearAvailability();
            if (deliveryForType) deliveryForType.interval = 7;
            (0, $i6TQx.default).clearDiscounts();
        }
        // If this runs while we are fully logged in, we should refetch the cart depdenencies
        if ((0, $lKrOo.default).is("LOGGED_IN")) $c0c3633ed555a266$var$cartStore.updateCartDependencies();
        (0, $gtsdT.logger).log("cart", "Selected delivery", (0, $9Vhxl.default).getCurrentDelivery());
    }),
    findExisitingSubscription: ()=>{
        if ($c0c3633ed555a266$var$cartStore.orderType !== (0, $8aSS4.ORDERTYPE).WAS || $c0c3633ed555a266$var$cartStore.isEditing()) return [];
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if ((0, $bEEBX.default)(currentDelivery)) return [];
        return (0, $5aUWQ.default).subscriptionsList.data.filter((subscription)=>currentDelivery.interval === Number.parseInt(subscription.deliveryIntervalDays) && currentDelivery.date.getDay() === Number.parseInt(subscription.deliveryWeekdayNumber));
    },
    emptyCart: ()=>{
        $c0c3633ed555a266$var$cartStore.items = [];
        if ((0, $bcbvQ.default).isLoggedIn()) {
            $c0c3633ed555a266$var$cartStore.saveCartToServerWithoutDelay();
            $c0c3633ed555a266$var$cartStore.updateCartDependencies();
        }
    },
    addToCart: (sku, qty, delay = 800)=>{
        const cartItem = $c0c3633ed555a266$var$cartStore.getCartItem(sku);
        const alreadyInCart = !(0, $3xOZa.default)(cartItem);
        const product = (0, $bZiDo.default).resolveSku(sku);
        if ((0, $3xOZa.default)(product)) {
            (0, $gtsdT.logger).warn("cart", `Tried to add unavailable product to cart, sku ${sku}`);
            return false;
        }
        const unit = product.unit;
        if (!(0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing) && !$c0c3633ed555a266$var$cartStore.editing.canAddItems) {
            (0, $gvoND.default).addError("Ordren har begrensninger", "Ordren som du redigerer har begrensninger som gj\xf8r at du ikke kan legge til nye varelinjer.", {
                context: "order",
                text: "order_limitation_error"
            });
            return false;
        }
        if (delay === 0) {
            if (alreadyInCart) cartItem.qty += qty;
            else $c0c3633ed555a266$var$cartStore.items.push({
                sku: sku,
                qty: qty,
                unit: unit,
                fromEditing: $c0c3633ed555a266$var$cartStore.isEditing()
            });
            $c0c3633ed555a266$var$cartStore.saveCartToServer();
            $c0c3633ed555a266$var$cartStore.updateCartDependencies();
            return true;
        }
        // Delay adding the product to cart to match animation
        setTimeout((0, $Kk7R3.action)(()=>{
            const cartItem = $c0c3633ed555a266$var$cartStore.getCartItem(sku);
            const alreadyInCart = !(0, $3xOZa.default)(cartItem);
            if (alreadyInCart) cartItem.qty += qty;
            else $c0c3633ed555a266$var$cartStore.items.push({
                sku: sku,
                qty: qty,
                unit: unit,
                fromEditing: $c0c3633ed555a266$var$cartStore.isEditing()
            });
            $c0c3633ed555a266$var$cartStore.saveCartToServer();
            $c0c3633ed555a266$var$cartStore.updateCartDependencies();
        }), delay);
        return true;
    },
    loadCartFromServer: async ()=>{
        if ((0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) {
            (0, $gtsdT.logger).warn("cart", "Attempted to load cart without being logged in");
            return Promise.reject();
        }
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/carts/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).get().json((0, $Kk7R3.action)((cartFromServer)=>{
            (0, $gtsdT.logger).log("cart", "Received cart from server: ", cartFromServer);
            // Avoid loading cart items from a previous editing session, if we are not editing
            $c0c3633ed555a266$var$cartStore.items = cartFromServer.filter((item)=>item.fromEditing === $c0c3633ed555a266$var$cartStore.isEditing());
            // If we received items from a different editing state, we need to let the customer know and save the new cart.
            if ($c0c3633ed555a266$var$cartStore.items.length !== cartFromServer.length) {
                (0, $6fuyt.sendCartCleared)();
                (0, $gtsdT.logger).log("cart", "Received cart items with incorrect state from server, saving updated cart to server.");
                $c0c3633ed555a266$var$cartStore.saveCartToServer();
                (0, $gvoND.default).addToast("Endringer i handlekurven", "Handlekurven din har blitt endret.\nDette kan skje om du jobber i to faner samtidig mens du endrer en eksisterende ordre eller om du tidligere har lukket nettleseren under endring av ordre.\nVennligst dobbelsjekk innholdet i handlekurven.", "error", true);
            }
            $c0c3633ed555a266$var$cartStore.updateCartDependencies();
        }));
    },
    saveCartToServer: (0, $d4mYJ.default)(()=>{
        $c0c3633ed555a266$var$cartStore.saveCartToServerWithoutDelay();
    }, 1000),
    saveCartToServerWithoutDelay: ()=>{
        if (!(0, $bcbvQ.default).isLoggedIn()) {
            (0, $gtsdT.logger).warn("cart", "Attempted to save cart without being logged in");
            return;
        }
        // Add price and vatRate to the server-side cart so we can use them to build punchout cart on the backend
        const payload = $c0c3633ed555a266$var$cartStore.items.map((item)=>{
            const product = (0, $bZiDo.default).resolveSku(item.sku);
            return {
                ...item,
                fromEditing: $c0c3633ed555a266$var$cartStore.isEditing(),
                price: product?.price ?? null,
                vatRate: product?.vatRate ?? null
            };
        });
        (0, $gtsdT.logger).log("cart", "Saving cart with payload:", payload);
        (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/carts/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).post(payload).json((res)=>{
            if (res) (0, $gtsdT.logger).log("cart", "Remote cart has been updated");
            else (0, $gtsdT.logger).warn("cart", "Something went wrong when storing cart");
        }).catch((err)=>{
            (0, $gtsdT.logger).warn("cart", "Unable to store cart remotely", err);
        });
    },
    updateCartDependencies: ()=>{
        (0, $jAf35.default).recalculateDeliveryCharge();
        (0, $i6TQx.default).fetchPromotionDiscounts();
    },
    removeFromCart: (sku)=>{
        const cartItem = (0, $jf2w9.default)($c0c3633ed555a266$var$cartStore.items, {
            sku: sku
        });
        if ((0, $3xOZa.default)(cartItem)) {
            (0, $gtsdT.logger).warn("cart", "Attempting to remove SKU that is not in the cart, bug?");
            return;
        }
        (0, $15TRa.default)($c0c3633ed555a266$var$cartStore.items, {
            sku: sku
        });
        $c0c3633ed555a266$var$cartStore.saveCartToServer();
        $c0c3633ed555a266$var$cartStore.updateCartDependencies();
    },
    addLostSales: (unavailable)=>{
        for (const availability of unavailable){
            const product = (0, $bZiDo.default).resolveSku(availability.productNumber);
            if (product) {
                const quantity = availability.partialAvailable ? availability.requestedQuantity - availability.availableQuantity : availability.requestedQuantity;
                const existingLostSales = $c0c3633ed555a266$var$cartStore.lostSales.find((lostSale)=>lostSale.sku === availability.productNumber);
                if (existingLostSales) existingLostSales.quantity += quantity;
                else $c0c3633ed555a266$var$cartStore.lostSales.push({
                    quantity: quantity,
                    sku: availability.productNumber,
                    isLostSales: true,
                    lostSalesWareHouse: availability.supplyingWarehouse || availability.warehouse || "",
                    orderLineUnit: product.salesUnit
                });
            }
        }
    },
    applyAvailabilityChanges: ()=>{
        if ((0, $bEEBX.default)((0, $8Wejn.default).availability)) {
            (0, $gtsdT.logger).warn("cart", "Unable to apply availability, it's already null...");
            return;
        }
        const itemsAdded = [];
        const itemsRemoved = [];
        const listInformation = {
            type: (0, $aRSTV.LIST_TYPE).AVAILABILITY_CHECK,
            name: "Tilgjengelighetskontroll",
            length: (0, $8Wejn.default).availability.length
        };
        (0, $gtsdT.logger).log("cart", "Applying availability changes", (0, $8Wejn.default).availability, (0, $8Wejn.default).newCartItems);
        for (const productAvailability of (0, $8Wejn.default).availability){
            const cartItem = $c0c3633ed555a266$var$cartStore.getCartItem(productAvailability.productNumber);
            if (!cartItem) {
                if (productAvailability.selectedQuantity) {
                    $c0c3633ed555a266$var$cartStore.addToCart(productAvailability.productNumber, productAvailability.selectedQuantity);
                    itemsAdded.push({
                        sku: productAvailability.productNumber,
                        qty: productAvailability.selectedQuantity
                    });
                }
            } else if (productAvailability.selectedQuantity) {
                if (cartItem.qty < productAvailability.selectedQuantity) itemsAdded.push({
                    sku: productAvailability.productNumber,
                    qty: productAvailability.selectedQuantity - cartItem.qty
                });
                else {
                    const product = (0, $bZiDo.default).resolveSku(productAvailability.productNumber);
                    product && itemsRemoved.push({
                        sku: product.sku,
                        qty: cartItem.qty - productAvailability.selectedQuantity
                    });
                }
                cartItem.qty = productAvailability.selectedQuantity;
            } else {
                $c0c3633ed555a266$var$cartStore.removeFromCart(productAvailability.productNumber);
                const product = (0, $bZiDo.default).resolveSku(productAvailability.productNumber);
                product && itemsRemoved.push({
                    sku: product.sku,
                    qty: cartItem.qty
                });
            }
        }
        for(const sku in (0, $8Wejn.default).newCartItems){
            const item = $c0c3633ed555a266$var$cartStore.items.find((item)=>item.sku === sku);
            if (item) {
                if ((0, $8Wejn.default).newCartItems[sku].qty) item.qty += (0, $8Wejn.default).newCartItems[sku].qty;
            } else if ((0, $8Wejn.default).newCartItems[sku].qty) $c0c3633ed555a266$var$cartStore.items.push({
                ...(0, $8Wejn.default).newCartItems[sku]
            });
            itemsAdded.push({
                sku: sku,
                qty: (0, $8Wejn.default).newCartItems[sku].qty
            });
        }
        itemsAdded.length && (0, $6fuyt.sendAddToCart)(itemsAdded, listInformation);
        itemsRemoved.length && (0, $6fuyt.sendRemoveFromCart)(itemsRemoved, listInformation);
        (0, $8Wejn.default).clearAvailability();
    },
    submitOrder: async ()=>{
        // Subscription
        if ($c0c3633ed555a266$var$cartStore.orderType === "WAS") {
            // Changing one planned delivery of a subscription (subscription instance)
            if ($c0c3633ed555a266$var$cartStore.isEditingInstance()) {
                if (!(0, $bEEBX.default)($c0c3633ed555a266$var$cartStore.editing) && $c0c3633ed555a266$var$cartStore.editing.existingInstance) return (0, $5aUWQ.default).submitInstanceChanges();
                return (0, $5aUWQ.default).submitNewInstanceOrder();
            }
            // Normal subscription
            if ($c0c3633ed555a266$var$cartStore.isEditing()) return (0, $5aUWQ.default).submitSubscriptionChanges();
            return (0, $5aUWQ.default).submitNewSubscription();
        }
        // One-time order
        if ($c0c3633ed555a266$var$cartStore.orderType === (0, $8aSS4.ORDERTYPE).WEB || $c0c3633ed555a266$var$cartStore.orderType === (0, $8aSS4.ORDERTYPE).HPN || $c0c3633ed555a266$var$cartStore.orderType === (0, $8aSS4.ORDERTYPE).LEV) return $c0c3633ed555a266$var$cartStore.isEditing() ? (0, $7mifc.default).submitOrderChanges() : (0, $7mifc.default).submitNewOrder();
        (0, $gvoND.default).addError("Ukjent ordretype aktiv", `Ordretypen som er valgt (${$c0c3633ed555a266$var$cartStore.orderType}) er ikke kjent, og vi f\xe5r ikke plassert ordren.`, {
            context: "order",
            text: "unknown_order_type_error"
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(new Error(`Unknown order type [${$c0c3633ed555a266$var$cartStore.orderType}]`));
        return Promise.reject();
    },
    showMiniCart: ()=>{
        (0, $6fuyt.sendMiniCartVisible)();
        $c0c3633ed555a266$var$cartStore.miniCartVisible = true;
    },
    hideMiniCart: ()=>{
        $c0c3633ed555a266$var$cartStore.miniCartVisible = false;
    },
    isDeliveryDateChanged: ()=>{
        const currentDeliveryDate = (0, $9Vhxl.default).getCurrentDelivery()?.date;
        const originalDeliveryDate = $c0c3633ed555a266$var$cartStore.editing?.deliveryDate;
        if (currentDeliveryDate && originalDeliveryDate) return !(0, $fbCoc.default)(currentDeliveryDate, originalDeliveryDate);
        return false;
    },
    isEditingCartUnchanged: ()=>{
        const { editing: editing } = $c0c3633ed555a266$var$cartStore;
        if (editing) {
            if ($c0c3633ed555a266$var$cartStore.items.length === editing.oldState.length) {
                const itemsUnchanged = $c0c3633ed555a266$var$cartStore.items.every((item)=>editing.oldState.find((orderState)=>orderState.sku === item.sku && orderState.qty === item.qty));
                if (!itemsUnchanged) return false;
                return !$c0c3633ed555a266$var$cartStore.isDeliveryDateChanged();
            }
        }
        return false;
    },
    clearCompanySpecificData: ()=>{
        if ($c0c3633ed555a266$var$cartStore.isEditing()) $c0c3633ed555a266$var$cartStore.stopEditOrderMode();
        else $c0c3633ed555a266$var$cartStore.emptyCart();
        $c0c3633ed555a266$var$cartStore.lostSales = [];
    }
});
(0, $Kk7R3.autorun)(()=>{
    $c0c3633ed555a266$var$cartStore.orderRefs.customerOrderNumber = (0, $5qW1i.default)($c0c3633ed555a266$var$cartStore.orderRefs.customerOrderNumber, {
        length: 20,
        omission: ""
    });
    $c0c3633ed555a266$var$cartStore.orderRefs.customerReference = (0, $5qW1i.default)($c0c3633ed555a266$var$cartStore.orderRefs.customerReference, {
        length: 30,
        omission: ""
    });
    $c0c3633ed555a266$var$cartStore.orderRefs.orderName = (0, $5qW1i.default)($c0c3633ed555a266$var$cartStore.orderRefs.orderName, {
        length: 36,
        omission: ""
    });
});
// Expose the emptyCart function to the global scope for punchout purposes
window.emptyCart = $c0c3633ed555a266$var$cartStore.emptyCart;
var $c0c3633ed555a266$export$2e2bcd8739ae039 = $c0c3633ed555a266$var$cartStore;

});
parcelRegister("5UIm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44e49678db43650d$export$2e2bcd8739ae039; });

var $2KlUs = parcelRequire("2KlUs");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");
function $44e49678db43650d$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $hFacL.default)(1, arguments);
    var additionalDigits = (0, $970db.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $44e49678db43650d$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $44e49678db43650d$var$parseYear(dateStrings.date, additionalDigits);
        date = $44e49678db43650d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $44e49678db43650d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $44e49678db43650d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $44e49678db43650d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $44e49678db43650d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $44e49678db43650d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $44e49678db43650d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $44e49678db43650d$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($44e49678db43650d$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($44e49678db43650d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($44e49678db43650d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $44e49678db43650d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $44e49678db43650d$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $44e49678db43650d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($44e49678db43650d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $44e49678db43650d$var$parseDateUnit(captures[1]);
    var month = $44e49678db43650d$var$parseDateUnit(captures[2]) - 1;
    var day = $44e49678db43650d$var$parseDateUnit(captures[3]);
    var week = $44e49678db43650d$var$parseDateUnit(captures[4]);
    var dayOfWeek = $44e49678db43650d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$44e49678db43650d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $44e49678db43650d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$44e49678db43650d$var$validateDate(year, month, day) || !$44e49678db43650d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $44e49678db43650d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $44e49678db43650d$var$parseTime(timeString) {
    var captures = timeString.match($44e49678db43650d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $44e49678db43650d$var$parseTimeUnit(captures[1]);
    var minutes = $44e49678db43650d$var$parseTimeUnit(captures[2]);
    var seconds = $44e49678db43650d$var$parseTimeUnit(captures[3]);
    if (!$44e49678db43650d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $2KlUs.millisecondsInHour) + minutes * (0, $2KlUs.millisecondsInMinute) + seconds * 1000;
}
function $44e49678db43650d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $44e49678db43650d$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($44e49678db43650d$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$44e49678db43650d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $2KlUs.millisecondsInHour) + minutes * (0, $2KlUs.millisecondsInMinute));
}
function $44e49678db43650d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $44e49678db43650d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $44e49678db43650d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $44e49678db43650d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($44e49678db43650d$var$daysInMonths[month] || ($44e49678db43650d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $44e49678db43650d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($44e49678db43650d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $44e49678db43650d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $44e49678db43650d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $44e49678db43650d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("5qW1i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f4c62fe2292bff7$export$2e2bcd8739ae039; });

var $jjUEx = parcelRequire("jjUEx");

var $6QJPP = parcelRequire("6QJPP");

var $aCxUA = parcelRequire("aCxUA");

var $42tql = parcelRequire("42tql");

var $4ejFk = parcelRequire("4ejFk");

var $lL8TL = parcelRequire("lL8TL");

var $fXIA9 = parcelRequire("fXIA9");

var $4sQKr = parcelRequire("4sQKr");

var $cQbRr = parcelRequire("cQbRr");
/** Used as default options for `_.truncate`. */ var $3f4c62fe2292bff7$var$DEFAULT_TRUNC_LENGTH = 30, $3f4c62fe2292bff7$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $3f4c62fe2292bff7$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $3f4c62fe2292bff7$var$truncate(string, options) {
    var length = $3f4c62fe2292bff7$var$DEFAULT_TRUNC_LENGTH, omission = $3f4c62fe2292bff7$var$DEFAULT_TRUNC_OMISSION;
    if ((0, $42tql.default)(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? (0, $4sQKr.default)(options.length) : length;
        omission = 'omission' in options ? (0, $jjUEx.default)(options.omission) : omission;
    }
    string = (0, $cQbRr.default)(string);
    var strLength = string.length;
    if ((0, $aCxUA.default)(string)) {
        var strSymbols = (0, $fXIA9.default)(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - (0, $lL8TL.default)(omission);
    if (end < 1) return omission;
    var result = strSymbols ? (0, $6QJPP.default)(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ((0, $4ejFk.default)(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, (0, $cQbRr.default)($3f4c62fe2292bff7$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf((0, $jjUEx.default)(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
var $3f4c62fe2292bff7$export$2e2bcd8739ae039 = $3f4c62fe2292bff7$var$truncate;

});
parcelRegister("4ejFk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3147b962bc4557dc$export$2e2bcd8739ae039; });

var $i9S9J = parcelRequire("i9S9J");

var $j7MgO = parcelRequire("j7MgO");

var $dWa57 = parcelRequire("dWa57");
/* Node.js helper references. */ var $3147b962bc4557dc$var$nodeIsRegExp = (0, $dWa57.default) && (0, $dWa57.default).isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $3147b962bc4557dc$var$isRegExp = $3147b962bc4557dc$var$nodeIsRegExp ? (0, $j7MgO.default)($3147b962bc4557dc$var$nodeIsRegExp) : (0, $i9S9J.default);
var $3147b962bc4557dc$export$2e2bcd8739ae039 = $3147b962bc4557dc$var$isRegExp;

});
parcelRegister("i9S9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d383137c7ae0e40d$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $d383137c7ae0e40d$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $d383137c7ae0e40d$var$baseIsRegExp(value) {
    return (0, $bBbWb.default)(value) && (0, $65ROZ.default)(value) == $d383137c7ae0e40d$var$regexpTag;
}
var $d383137c7ae0e40d$export$2e2bcd8739ae039 = $d383137c7ae0e40d$var$baseIsRegExp;

});


parcelRegister("lL8TL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd74e3d112a59780$export$2e2bcd8739ae039; });

var $cdBmD = parcelRequire("cdBmD");

var $aCxUA = parcelRequire("aCxUA");

var $i1DYI = parcelRequire("i1DYI");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $fd74e3d112a59780$var$stringSize(string) {
    return (0, $aCxUA.default)(string) ? (0, $i1DYI.default)(string) : (0, $cdBmD.default)(string);
}
var $fd74e3d112a59780$export$2e2bcd8739ae039 = $fd74e3d112a59780$var$stringSize;

});
parcelRegister("cdBmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e53aea37f95214a$export$2e2bcd8739ae039; });

var $8lBkA = parcelRequire("8lBkA");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $8e53aea37f95214a$var$asciiSize = (0, $8lBkA.default)('length');
var $8e53aea37f95214a$export$2e2bcd8739ae039 = $8e53aea37f95214a$var$asciiSize;

});

parcelRegister("i1DYI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1f754da82aab621$export$2e2bcd8739ae039; });
/** Used to compose unicode character classes. */ var $d1f754da82aab621$var$rsAstralRange = '\\ud800-\\udfff', $d1f754da82aab621$var$rsComboMarksRange = '\\u0300-\\u036f', $d1f754da82aab621$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $d1f754da82aab621$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $d1f754da82aab621$var$rsComboRange = $d1f754da82aab621$var$rsComboMarksRange + $d1f754da82aab621$var$reComboHalfMarksRange + $d1f754da82aab621$var$rsComboSymbolsRange, $d1f754da82aab621$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $d1f754da82aab621$var$rsAstral = '[' + $d1f754da82aab621$var$rsAstralRange + ']', $d1f754da82aab621$var$rsCombo = '[' + $d1f754da82aab621$var$rsComboRange + ']', $d1f754da82aab621$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $d1f754da82aab621$var$rsModifier = '(?:' + $d1f754da82aab621$var$rsCombo + '|' + $d1f754da82aab621$var$rsFitz + ')', $d1f754da82aab621$var$rsNonAstral = '[^' + $d1f754da82aab621$var$rsAstralRange + ']', $d1f754da82aab621$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $d1f754da82aab621$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $d1f754da82aab621$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $d1f754da82aab621$var$reOptMod = $d1f754da82aab621$var$rsModifier + '?', $d1f754da82aab621$var$rsOptVar = '[' + $d1f754da82aab621$var$rsVarRange + ']?', $d1f754da82aab621$var$rsOptJoin = '(?:' + $d1f754da82aab621$var$rsZWJ + '(?:' + [
    $d1f754da82aab621$var$rsNonAstral,
    $d1f754da82aab621$var$rsRegional,
    $d1f754da82aab621$var$rsSurrPair
].join('|') + ')' + $d1f754da82aab621$var$rsOptVar + $d1f754da82aab621$var$reOptMod + ')*', $d1f754da82aab621$var$rsSeq = $d1f754da82aab621$var$rsOptVar + $d1f754da82aab621$var$reOptMod + $d1f754da82aab621$var$rsOptJoin, $d1f754da82aab621$var$rsSymbol = '(?:' + [
    $d1f754da82aab621$var$rsNonAstral + $d1f754da82aab621$var$rsCombo + '?',
    $d1f754da82aab621$var$rsCombo,
    $d1f754da82aab621$var$rsRegional,
    $d1f754da82aab621$var$rsSurrPair,
    $d1f754da82aab621$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $d1f754da82aab621$var$reUnicode = RegExp($d1f754da82aab621$var$rsFitz + '(?=' + $d1f754da82aab621$var$rsFitz + ')|' + $d1f754da82aab621$var$rsSymbol + $d1f754da82aab621$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $d1f754da82aab621$var$unicodeSize(string) {
    var result = $d1f754da82aab621$var$reUnicode.lastIndex = 0;
    while($d1f754da82aab621$var$reUnicode.test(string))++result;
    return result;
}
var $d1f754da82aab621$export$2e2bcd8739ae039 = $d1f754da82aab621$var$unicodeSize;

});



parcelRegister("d4mYJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $983d791fa70a4910$export$2e2bcd8739ae039; });

var $42tql = parcelRequire("42tql");

var $7WucT = parcelRequire("7WucT");

var $3jH8d = parcelRequire("3jH8d");
/** Error message constants. */ var $983d791fa70a4910$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $983d791fa70a4910$var$nativeMax = Math.max, $983d791fa70a4910$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $983d791fa70a4910$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($983d791fa70a4910$var$FUNC_ERROR_TEXT);
    wait = (0, $3jH8d.default)(wait) || 0;
    if ((0, $42tql.default)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $983d791fa70a4910$var$nativeMax((0, $3jH8d.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $983d791fa70a4910$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $7WucT.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $7WucT.default)());
    }
    function debounced() {
        var time = (0, $7WucT.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $983d791fa70a4910$export$2e2bcd8739ae039 = $983d791fa70a4910$var$debounce;

});
parcelRegister("7WucT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c8561a38d09b441$export$2e2bcd8739ae039; });

var $ewUh0 = parcelRequire("ewUh0");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $5c8561a38d09b441$var$now = function() {
    return (0, $ewUh0.default).Date.now();
};
var $5c8561a38d09b441$export$2e2bcd8739ae039 = $5c8561a38d09b441$var$now;

});


parcelRegister("kneHr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed515ba81fe9d6aa$export$2e2bcd8739ae039; });
/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */ function $ed515ba81fe9d6aa$var$defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
}
var $ed515ba81fe9d6aa$export$2e2bcd8739ae039 = $ed515ba81fe9d6aa$var$defaultTo;

});

parcelRegister("f3FkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af67339ddf6b74f2$export$2e2bcd8739ae039; });

var $cxAYD = parcelRequire("cxAYD");

var $l2wL3 = parcelRequire("l2wL3");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $af67339ddf6b74f2$var$pick = (0, $l2wL3.default)(function(object, paths) {
    return object == null ? {} : (0, $cxAYD.default)(object, paths);
});
var $af67339ddf6b74f2$export$2e2bcd8739ae039 = $af67339ddf6b74f2$var$pick;

});
parcelRegister("cxAYD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92153ff6ec698fc8$export$2e2bcd8739ae039; });

var $cxBcb = parcelRequire("cxBcb");

var $y1ls0 = parcelRequire("y1ls0");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $92153ff6ec698fc8$var$basePick(object, paths) {
    return (0, $cxBcb.default)(object, paths, function(value, path) {
        return (0, $y1ls0.default)(object, path);
    });
}
var $92153ff6ec698fc8$export$2e2bcd8739ae039 = $92153ff6ec698fc8$var$basePick;

});
parcelRegister("cxBcb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92156b5d3682d839$export$2e2bcd8739ae039; });

var $dHL9I = parcelRequire("dHL9I");

var $ipHzQ = parcelRequire("ipHzQ");

var $e8stg = parcelRequire("e8stg");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $92156b5d3682d839$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = (0, $dHL9I.default)(object, path);
        if (predicate(value, path)) (0, $ipHzQ.default)(result, (0, $e8stg.default)(path, object), value);
    }
    return result;
}
var $92156b5d3682d839$export$2e2bcd8739ae039 = $92156b5d3682d839$var$basePickBy;

});
parcelRegister("ipHzQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67c5d5405455d6c$export$2e2bcd8739ae039; });

var $g61zT = parcelRequire("g61zT");

var $e8stg = parcelRequire("e8stg");

var $dAIRS = parcelRequire("dAIRS");

var $42tql = parcelRequire("42tql");

var $cWBvA = parcelRequire("cWBvA");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $d67c5d5405455d6c$var$baseSet(object, path, value, customizer) {
    if (!(0, $42tql.default)(object)) return object;
    path = (0, $e8stg.default)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $cWBvA.default)(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $42tql.default)(objValue) ? objValue : (0, $dAIRS.default)(path[index + 1]) ? [] : {};
        }
        (0, $g61zT.default)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $d67c5d5405455d6c$export$2e2bcd8739ae039 = $d67c5d5405455d6c$var$baseSet;

});




parcelRegister("15TRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cc196083e85e627$export$2e2bcd8739ae039; });

var $aIIzU = parcelRequire("aIIzU");

var $cvg5h = parcelRequire("cvg5h");
/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */ function $0cc196083e85e627$var$remove(array, predicate) {
    var result = [];
    if (!(array && array.length)) return result;
    var index = -1, indexes = [], length = array.length;
    predicate = (0, $aIIzU.default)(predicate, 3);
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
        }
    }
    (0, $cvg5h.default)(array, indexes);
    return result;
}
var $0cc196083e85e627$export$2e2bcd8739ae039 = $0cc196083e85e627$var$remove;

});
parcelRegister("cvg5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91a4db3f7e9a976e$export$2e2bcd8739ae039; });

var $lkLur = parcelRequire("lkLur");

var $dAIRS = parcelRequire("dAIRS");
/** Used for built-in method references. */ var $91a4db3f7e9a976e$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $91a4db3f7e9a976e$var$splice = $91a4db3f7e9a976e$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */ function $91a4db3f7e9a976e$var$basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while(length--){
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
            var previous = index;
            if ((0, $dAIRS.default)(index)) $91a4db3f7e9a976e$var$splice.call(array, index, 1);
            else (0, $lkLur.default)(array, index);
        }
    }
    return array;
}
var $91a4db3f7e9a976e$export$2e2bcd8739ae039 = $91a4db3f7e9a976e$var$basePullAt;

});


parcelRegister("6fuyt", function(module, exports) {

$parcel$export(module.exports, "GA_NAVIGATION_MAIN_CATEGORY", function () { return $b02f9449a2203fa9$export$642ea26497d82a44; });
$parcel$export(module.exports, "GA_NAVIGATION_SUB_CATEGORY", function () { return $b02f9449a2203fa9$export$4097c716d460f04; });
$parcel$export(module.exports, "sendSearch", function () { return $b02f9449a2203fa9$export$cf5176745b6a82fb; });
$parcel$export(module.exports, "sendFilter", function () { return $b02f9449a2203fa9$export$6262e850c12d8313; });
$parcel$export(module.exports, "sendLoginStart", function () { return $b02f9449a2203fa9$export$b332c0b0875049c1; });
$parcel$export(module.exports, "sendLoginStep", function () { return $b02f9449a2203fa9$export$f1b9f4ea9742017a; });
$parcel$export(module.exports, "sendLoginSuccess", function () { return $b02f9449a2203fa9$export$c6f09cea4f555e07; });
$parcel$export(module.exports, "sendLoginFailed", function () { return $b02f9449a2203fa9$export$5a2132c74edbf946; });
$parcel$export(module.exports, "sendCartCleared", function () { return $b02f9449a2203fa9$export$a4dee0f54deabbec; });
$parcel$export(module.exports, "sendAddToCart", function () { return $b02f9449a2203fa9$export$6950e6dc050f6dc0; });
$parcel$export(module.exports, "sendRemoveFromCart", function () { return $b02f9449a2203fa9$export$f936e50309c45049; });
$parcel$export(module.exports, "sendProductClick", function () { return $b02f9449a2203fa9$export$c151aad81c7eabc7; });
$parcel$export(module.exports, "sendAddItemsToFavoriteList", function () { return $b02f9449a2203fa9$export$a503245b0f96e779; });
$parcel$export(module.exports, "sendRemoveItemFromFavoriteList", function () { return $b02f9449a2203fa9$export$ef40bbf2ab318916; });
$parcel$export(module.exports, "sendAddCartToFavoriteList", function () { return $b02f9449a2203fa9$export$86e81ec0a8833b8d; });
$parcel$export(module.exports, "sendMiniCartVisible", function () { return $b02f9449a2203fa9$export$663a36a6e71cb877; });
$parcel$export(module.exports, "sendCartVisible", function () { return $b02f9449a2203fa9$export$7b56b1794f88d379; });
$parcel$export(module.exports, "sendModal", function () { return $b02f9449a2203fa9$export$e9f743cc2b005fa; });
$parcel$export(module.exports, "sendPageNotFound", function () { return $b02f9449a2203fa9$export$c45bcd82dc6deb2a; });
$parcel$export(module.exports, "sendViewUnavailableItems", function () { return $b02f9449a2203fa9$export$51151388ab486e44; });
$parcel$export(module.exports, "sendProductDetails", function () { return $b02f9449a2203fa9$export$63176fbc79d66603; });
$parcel$export(module.exports, "sendViewTeaser", function () { return $b02f9449a2203fa9$export$13c9ce0f66f21ebf; });
$parcel$export(module.exports, "sendSelectTeaser", function () { return $b02f9449a2203fa9$export$1da44eae772d05ac; });
$parcel$export(module.exports, "sendInternalLinkClick", function () { return $b02f9449a2203fa9$export$da4162e1965a7d0a; });
$parcel$export(module.exports, "sendButtonClick", function () { return $b02f9449a2203fa9$export$4207a8c982b1d34b; });
$parcel$export(module.exports, "sendSignup", function () { return $b02f9449a2203fa9$export$d67b1d924da3aeb2; });
$parcel$export(module.exports, "sendPurchase", function () { return $b02f9449a2203fa9$export$7b69f0249c68d452; });
$parcel$export(module.exports, "sendOrderTypeChange", function () { return $b02f9449a2203fa9$export$e3dbd0da52126923; });
$parcel$export(module.exports, "sendDeliveryDateChange", function () { return $b02f9449a2203fa9$export$b91f23c3a245fadf; });
$parcel$export(module.exports, "sendOrderIntervalChange", function () { return $b02f9449a2203fa9$export$94f5755a868a24a6; });
$parcel$export(module.exports, "queueImpression", function () { return $b02f9449a2203fa9$export$b4f51be64170eb29; });
$parcel$export(module.exports, "sendErrorMessage", function () { return $b02f9449a2203fa9$export$3bfa289d331b448a; });
$parcel$export(module.exports, "sendAccordionClick", function () { return $b02f9449a2203fa9$export$68ce3dc81129e97f; });

var $jvljM = parcelRequire("jvljM");
var $ioVMT = parcelRequire("ioVMT");

var $d4mYJ = parcelRequire("d4mYJ");

var $45ElK = parcelRequire("45ElK");

var $hCd6c = parcelRequire("hCd6c");

var $bEEBX = parcelRequire("bEEBX");

var $3xOZa = parcelRequire("3xOZa");

var $8Wejn = parcelRequire("8Wejn");

var $76PCP = parcelRequire("76PCP");

var $25aT1 = parcelRequire("25aT1");

var $9Vhxl = parcelRequire("9Vhxl");

var $jAf35 = parcelRequire("jAf35");

var $bZiDo = parcelRequire("bZiDo");

var $luszM = parcelRequire("luszM");

var $i6TQx = parcelRequire("i6TQx");

var $a2SqC = parcelRequire("a2SqC");

var $isIf6 = parcelRequire("isIf6");

var $gtsdT = parcelRequire("gtsdT");

var $aRSTV = parcelRequire("aRSTV");

var $5OqMf = parcelRequire("5OqMf");
const $b02f9449a2203fa9$var$productToGA4 = (product)=>{
    if ((0, $3xOZa.default)(product)) return {};
    const categories = (0, $25aT1.default).findCategoryKeysBySku(product.sku);
    const category = categories.length > 0 ? (0, $45ElK.default)(categories) : {
        cat1: null,
        cat2: null,
        cat3: null
    };
    const voucherifyPromotionIds = (0, $i6TQx.default).availablePromotions.data.flatMap((promotion)=>promotion.products.includes(product.sku) ? [
            promotion.id
        ] : []);
    const priceBeforeDiscount = product.priceBeforeDiscount ?? 0;
    const price = product.price ?? 0;
    const M3Discount = priceBeforeDiscount - price;
    const M3DiscountPercentage = M3Discount ?? (M3Discount / priceBeforeDiscount * 100).toFixed(2);
    const labels = product.labels.map((label)=>label.text);
    if (product.expired && (0, $ioVMT.default)((0, $luszM.SEASONAL_PRODUCTS), product.sku)) labels.push("Utg\xe5tt");
    const promotionTypes = [];
    if (voucherifyPromotionIds.length) promotionTypes.push("Voucherify");
    if (M3Discount > 0) promotionTypes.push("M3");
    return {
        item_id: product.sku,
        item_name: product.name,
        item_brand: product.brand,
        item_category: category?.cat1,
        item_category2: category?.cat2,
        item_category3: category?.cat3,
        price: product.price,
        unit_size: product.unit,
        callout: labels,
        promotionTypes: promotionTypes,
        voucherifyIds: voucherifyPromotionIds,
        m3_discount: `${M3DiscountPercentage.toString()}%`
    };
};
const $b02f9449a2203fa9$var$buildListInfo = (listName, position)=>{
    const listInfo = {};
    // If we added to cart from a list, we want to report which list and which position the product had in that list.
    if (!(0, $bEEBX.default)(listName)) {
        listInfo.item_list_name = listName;
        listInfo.index = position;
    }
    return listInfo;
};
const $b02f9449a2203fa9$var$productSkusToGAItem = (items, listInformation)=>{
    const GAItems = items.reduce((arr, item)=>{
        const product = (0, $bZiDo.default).resolveSku(item.sku);
        if (!product) {
            (0, $gtsdT.logger).warn("tracking", "Unable to find product when sending add to cart event", item);
            return arr;
        }
        const GAItem = {
            ...$b02f9449a2203fa9$var$productToGA4(product),
            ...$b02f9449a2203fa9$var$buildListInfo(listInformation?.name, item.position),
            quantity: item.qty
        };
        arr.push(GAItem);
        return arr;
    }, []);
    return GAItems;
};
const $b02f9449a2203fa9$var$debouncedSendSearch = (searchType, searchResults, searchTerm)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_search", {
        search_type: searchType,
        search_results: searchResults,
        search_term: searchTerm
    });
};
const $b02f9449a2203fa9$export$642ea26497d82a44 = "hovedkategori";
const $b02f9449a2203fa9$export$4097c716d460f04 = "underkategori";
const $b02f9449a2203fa9$export$cf5176745b6a82fb = (0, $d4mYJ.default)($b02f9449a2203fa9$var$debouncedSendSearch, 1000);
const $b02f9449a2203fa9$export$6262e850c12d8313 = (filterType, filterContent)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_filter", {
        filter_type: filterType,
        filter_content: filterContent
    });
};
const $b02f9449a2203fa9$export$b332c0b0875049c1 = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_login_start", {
        method: (0, $a2SqC.default).loginMode
    });
};
const $b02f9449a2203fa9$export$f1b9f4ea9742017a = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_login_step", {
        method: (0, $a2SqC.default).loginMode
    });
};
const $b02f9449a2203fa9$export$c6f09cea4f555e07 = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_login", {
        method: (0, $a2SqC.default).loginMode
    });
};
const $b02f9449a2203fa9$export$5a2132c74edbf946 = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_login_failed");
};
const $b02f9449a2203fa9$export$a4dee0f54deabbec = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_cart_cleared");
};
const $b02f9449a2203fa9$export$6950e6dc050f6dc0 = (items, listInformation)=>{
    const GAItems = $b02f9449a2203fa9$var$productSkusToGAItem(items, listInformation);
    const sumOfProductPrices = GAItems.reduce((acc, item)=>acc + (item.price || 0), 0);
    $b02f9449a2203fa9$var$sendEvent("ga4_add_to_cart", {
        ecommerce: {
            item_list_id: listInformation.type,
            item_list_name: listInformation.name,
            item_list_length: listInformation.length,
            currency: "NOK",
            value: sumOfProductPrices,
            items: GAItems
        }
    });
};
const $b02f9449a2203fa9$export$f936e50309c45049 = (items, listInformation)=>{
    const GAItems = $b02f9449a2203fa9$var$productSkusToGAItem(items);
    $b02f9449a2203fa9$var$sendEvent("ga4_remove_from_cart", {
        ecommerce: {
            item_list_id: listInformation.type,
            item_list_name: listInformation.name,
            currency: "NOK",
            items: GAItems
        }
    });
};
const $b02f9449a2203fa9$export$c151aad81c7eabc7 = (product, listInformation, position)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_select_item", {
        ecommerce: {
            item_list_id: listInformation.type,
            item_list_name: listInformation.name,
            item_list_length: listInformation.length,
            items: [
                {
                    ...$b02f9449a2203fa9$var$productToGA4(product),
                    ...$b02f9449a2203fa9$var$buildListInfo(listInformation.name, position)
                }
            ]
        }
    });
};
const $b02f9449a2203fa9$export$a503245b0f96e779 = (products, listInformation, position)=>{
    const items = products.map((product)=>{
        return {
            ...$b02f9449a2203fa9$var$productToGA4(product),
            ...$b02f9449a2203fa9$var$buildListInfo(listInformation.name, position)
        };
    });
    const value = items.reduce((acc, item)=>acc + (item.price || 0), 0);
    $b02f9449a2203fa9$var$sendEvent("ga4_add_to_favorite_list", {
        ecommerce: {
            item_list_id: listInformation.type,
            item_list_name: listInformation.name,
            item_list_length: listInformation.length,
            value: value,
            items: items
        }
    });
};
const $b02f9449a2203fa9$export$ef40bbf2ab318916 = (sku, list, position)=>{
    const product = (0, $bZiDo.default).resolveSku(sku);
    if (!(0, $bEEBX.default)(product)) $b02f9449a2203fa9$var$sendEvent("ga4_remove_from_favorite_list", {
        ecommerce: {
            items: [
                {
                    ...$b02f9449a2203fa9$var$productToGA4(product),
                    ...$b02f9449a2203fa9$var$buildListInfo(list, position)
                }
            ]
        }
    });
};
const $b02f9449a2203fa9$export$86e81ec0a8833b8d = (cartName)=>{
    const cartItems = (0, $76PCP.default).items;
    const skus = cartItems.map(({ sku: sku })=>sku);
    const products = (0, $bZiDo.default).resolveSkus(skus);
    $b02f9449a2203fa9$export$a503245b0f96e779(products, {
        type: (0, $aRSTV.LIST_TYPE).CART,
        name: cartName,
        length: cartItems.length
    });
};
const $b02f9449a2203fa9$export$663a36a6e71cb877 = ()=>{
    $b02f9449a2203fa9$var$sendViewCart("ga4_view_mini_cart");
};
const $b02f9449a2203fa9$export$7b56b1794f88d379 = ()=>{
    $b02f9449a2203fa9$var$sendViewCart("ga4_view_cart");
};
const $b02f9449a2203fa9$export$e9f743cc2b005fa = (name)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_modal_view", {
        modal_name: name
    });
};
const $b02f9449a2203fa9$export$c45bcd82dc6deb2a = (url)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_page_not_found", {
        link_url: `${(0, $isIf6.default).baseUrl}${url}`
    });
};
/**
 * Sends the cart contents to Google Analytics, with a specific event name.
 */ const $b02f9449a2203fa9$var$sendViewCart = (eventName)=>{
    const cartTotal = (0, $76PCP.default).getCartTotal();
    const itemSkusAndQty = (0, $76PCP.default).items.map((item)=>({
            sku: item.sku,
            qty: item.qty
        }));
    const items = $b02f9449a2203fa9$var$productSkusToGAItem(itemSkusAndQty);
    const cartInfo = {
        order_type: (0, $5OqMf.translateOrderType)((0, $76PCP.default).orderType, (0, $isIf6.default).storeCompanyName),
        order_interval: (0, $9Vhxl.default).getCurrentDelivery()?.interval,
        order_class: (0, $76PCP.default).isEditing() ? "change" : "new"
    };
    $b02f9449a2203fa9$var$sendEvent(eventName, {
        ...eventName === "ga4_view_cart" && cartInfo,
        ecommerce: {
            currency: "NOK",
            value: cartTotal.total,
            items: items
        }
    });
};
const $b02f9449a2203fa9$export$51151388ab486e44 = ()=>{
    const items = (0, $8Wejn.default).availability || [];
    const itemPayload = items.map((item)=>{
        const product = (0, $bZiDo.default).resolveSku(item.productNumber);
        return {
            ...$b02f9449a2203fa9$var$productToGA4(product)
        };
    });
    $b02f9449a2203fa9$var$sendEvent("ga4_view_unavailable_items", {
        ecommerce: {
            items: itemPayload
        }
    });
};
const $b02f9449a2203fa9$export$63176fbc79d66603 = (product, stock_status)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_view_item", {
        ecommerce: {
            currency: "NOK",
            value: product.price,
            items: [
                {
                    ...$b02f9449a2203fa9$var$productToGA4(product),
                    stock_status: stock_status
                }
            ]
        }
    });
};
const $b02f9449a2203fa9$export$13c9ce0f66f21ebf = (teaserName, teaserType, trackingListName)=>$b02f9449a2203fa9$var$sendEvent("ga4_view_promotion", {
        creative_slot: trackingListName,
        creative_name: teaserName,
        creative_type: teaserType
    });
const $b02f9449a2203fa9$export$1da44eae772d05ac = (teaserName, teaserType, trackingListName, url)=>$b02f9449a2203fa9$var$sendEvent("ga4_select_promotion", {
        creative_slot: trackingListName,
        creative_name: teaserName,
        creative_type: teaserType,
        link_url: `${(0, $isIf6.default).baseUrl}${url}`
    });
const $b02f9449a2203fa9$export$da4162e1965a7d0a = (url, trackingLocationName, trackingName)=>$b02f9449a2203fa9$var$sendEvent("ga4_internal_link_click", {
        link_slot: trackingLocationName,
        link_url: `${(0, $isIf6.default).baseUrl}${url}`,
        link_name: trackingName
    });
const $b02f9449a2203fa9$export$4207a8c982b1d34b = (trackingName)=>$b02f9449a2203fa9$var$sendEvent("ga4_button_click", {
        button_name: trackingName
    });
const $b02f9449a2203fa9$export$d67b1d924da3aeb2 = (trackingFormName)=>$b02f9449a2203fa9$var$sendEvent("ga4_signup", {
        signup_name: trackingFormName
    });
const $b02f9449a2203fa9$export$7b69f0249c68d452 = (orderNumber, cartItems, wasEditing)=>{
    const useOrderNumber = (0, $hCd6c.default)(orderNumber) ? orderNumber[0] : orderNumber;
    const cartCalculations = (0, $76PCP.default).getCartTotal();
    const products = cartItems.map((cartItem)=>{
        const productFromCartItem = (0, $bZiDo.default).resolveSku(cartItem.sku);
        return {
            ...$b02f9449a2203fa9$var$productToGA4(productFromCartItem),
            quantity: cartItem.qty
        };
    });
    $b02f9449a2203fa9$var$sendEvent("ga4_purchase", {
        order_type: (0, $5OqMf.translateOrderType)((0, $76PCP.default).orderType, (0, $isIf6.default).storeCompanyName),
        order_interval: (0, $9Vhxl.default).getCurrentDelivery()?.interval,
        order_class: wasEditing ? "changed order" : "new order",
        ecommerce: {
            currency: "NOK",
            coupon: null,
            transaction_id: useOrderNumber,
            value: cartCalculations.total,
            deliveryFee: (0, $jAf35.default).currentDeliveryCharge().currentFee?.fee,
            items: products
        }
    });
};
const $b02f9449a2203fa9$export$e3dbd0da52126923 = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_change_order_type", {
        order_type: (0, $5OqMf.translateOrderType)((0, $76PCP.default).orderType, (0, $isIf6.default).storeCompanyName)
    });
};
const $b02f9449a2203fa9$export$b91f23c3a245fadf = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_change_delivery_date", {
        action: "updated"
    });
};
const $b02f9449a2203fa9$export$94f5755a868a24a6 = ()=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_change_order_interval", {
        action: "updated",
        order_interval: (0, $9Vhxl.default).getCurrentDelivery()?.interval
    });
};
// Keep track of queued impressions
const $b02f9449a2203fa9$var$impressions = [];
let $b02f9449a2203fa9$var$impressionTimeout = null;
const $b02f9449a2203fa9$export$b4f51be64170eb29 = (product, list, position)=>{
    $b02f9449a2203fa9$var$impressions.push({
        product: product,
        list: list,
        position: position
    });
    if ($b02f9449a2203fa9$var$impressions.length > 25) $b02f9449a2203fa9$var$sendQueuedImpressions();
    if ($b02f9449a2203fa9$var$impressionTimeout === null) $b02f9449a2203fa9$var$impressionTimeout = window.setTimeout($b02f9449a2203fa9$var$sendQueuedImpressions, 2000);
};
const $b02f9449a2203fa9$var$sendQueuedImpressions = ()=>{
    if ($b02f9449a2203fa9$var$impressions.length > 0) {
        const itemPayload = $b02f9449a2203fa9$var$impressions.map(({ product: product, list: list, position: position })=>({
                ...$b02f9449a2203fa9$var$productToGA4(product),
                ...$b02f9449a2203fa9$var$buildListInfo(list, position)
            }));
        const impressionsGrouped = (0, $jvljM.default)(itemPayload, "item_list_name");
        $b02f9449a2203fa9$var$impressions.length = 0;
        for (const items of Object.values(impressionsGrouped)){
            const item = items[0];
            $b02f9449a2203fa9$var$sendEvent("ga4_view_item_list", {
                ecommerce: {
                    item_list_id: item.item_list_id,
                    item_list_name: item.item_list_name,
                    num_items: items.length,
                    items: items
                }
            });
        }
    }
    if ($b02f9449a2203fa9$var$impressionTimeout !== null) {
        clearTimeout($b02f9449a2203fa9$var$impressionTimeout);
        $b02f9449a2203fa9$var$impressionTimeout = null;
    }
};
const $b02f9449a2203fa9$export$3bfa289d331b448a = (error)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_error_message", {
        error_context: error.context,
        error_text: error.text
    });
};
const $b02f9449a2203fa9$export$68ce3dc81129e97f = (accordionTitle)=>{
    $b02f9449a2203fa9$var$sendEvent("ga4_accordion_information", {
        accordion_title: accordionTitle
    });
};
const $b02f9449a2203fa9$var$sendEvent = (event, additionalData)=>{
    const eventPayload = {
        event: event,
        ...additionalData,
        _clear: true
    };
    (0, $gtsdT.logger).log("tracking", "Event submitted: ", eventPayload);
    window.dataLayer.push(eventPayload);
};

});
parcelRegister("jvljM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e33172e18d73df6b$export$2e2bcd8739ae039; });

var $hiRHm = parcelRequire("hiRHm");

var $2Dr72 = parcelRequire("2Dr72");
/** Used for built-in method references. */ var $e33172e18d73df6b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e33172e18d73df6b$var$hasOwnProperty = $e33172e18d73df6b$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $e33172e18d73df6b$var$groupBy = (0, $2Dr72.default)(function(result, value, key) {
    if ($e33172e18d73df6b$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else (0, $hiRHm.default)(result, key, [
        value
    ]);
});
var $e33172e18d73df6b$export$2e2bcd8739ae039 = $e33172e18d73df6b$var$groupBy;

});
parcelRegister("2Dr72", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb4414b8a405f08$export$2e2bcd8739ae039; });

var $dlwmd = parcelRequire("dlwmd");

var $iczXf = parcelRequire("iczXf");

var $aIIzU = parcelRequire("aIIzU");

var $hCd6c = parcelRequire("hCd6c");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $1eb4414b8a405f08$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = (0, $hCd6c.default)(collection) ? (0, $dlwmd.default) : (0, $iczXf.default), accumulator = initializer ? initializer() : {};
        return func(collection, setter, (0, $aIIzU.default)(iteratee, 2), accumulator);
    };
}
var $1eb4414b8a405f08$export$2e2bcd8739ae039 = $1eb4414b8a405f08$var$createAggregator;

});
parcelRegister("dlwmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b765608718e18d3$export$2e2bcd8739ae039; });
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $9b765608718e18d3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
var $9b765608718e18d3$export$2e2bcd8739ae039 = $9b765608718e18d3$var$arrayAggregator;

});

parcelRegister("iczXf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4053ccc13d6ed48$export$2e2bcd8739ae039; });

var $7xRth = parcelRequire("7xRth");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $d4053ccc13d6ed48$var$baseAggregator(collection, setter, iteratee, accumulator) {
    (0, $7xRth.default)(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
var $d4053ccc13d6ed48$export$2e2bcd8739ae039 = $d4053ccc13d6ed48$var$baseAggregator;

});
parcelRegister("7xRth", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57e517c585a3b233$export$2e2bcd8739ae039; });

var $bGsl1 = parcelRequire("bGsl1");

var $lk6ZM = parcelRequire("lk6ZM");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $57e517c585a3b233$var$baseEach = (0, $lk6ZM.default)((0, $bGsl1.default));
var $57e517c585a3b233$export$2e2bcd8739ae039 = $57e517c585a3b233$var$baseEach;

});
parcelRegister("bGsl1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $881999535c3a707a$export$2e2bcd8739ae039; });

var $3kwdF = parcelRequire("3kwdF");

var $egoNX = parcelRequire("egoNX");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $881999535c3a707a$var$baseForOwn(object, iteratee) {
    return object && (0, $3kwdF.default)(object, iteratee, (0, $egoNX.default));
}
var $881999535c3a707a$export$2e2bcd8739ae039 = $881999535c3a707a$var$baseForOwn;

});
parcelRegister("3kwdF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26cc3b7a087d32d4$export$2e2bcd8739ae039; });

var $agQam = parcelRequire("agQam");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $26cc3b7a087d32d4$var$baseFor = (0, $agQam.default)();
var $26cc3b7a087d32d4$export$2e2bcd8739ae039 = $26cc3b7a087d32d4$var$baseFor;

});
parcelRegister("agQam", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77a3dd155b3380c7$export$2e2bcd8739ae039; });
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $77a3dd155b3380c7$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $77a3dd155b3380c7$export$2e2bcd8739ae039 = $77a3dd155b3380c7$var$createBaseFor;

});



parcelRegister("lk6ZM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f860e4662eeeceeb$export$2e2bcd8739ae039; });

var $7wVIe = parcelRequire("7wVIe");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f860e4662eeeceeb$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $7wVIe.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $f860e4662eeeceeb$export$2e2bcd8739ae039 = $f860e4662eeeceeb$var$createBaseEach;

});





parcelRegister("8Wejn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bbd6e8228ea38f4$export$2e2bcd8739ae039; });

var $hNQAU = parcelRequire("hNQAU");

var $3xOZa = parcelRequire("3xOZa");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $5OqMf = parcelRequire("5OqMf");

var $4udGV = parcelRequire("4udGV");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");

var $bZiDo = parcelRequire("bZiDo");
const $4bbd6e8228ea38f4$var$DEFAULT_AVAILABILITY_CHECK_QTY = 1000;
const $4bbd6e8228ea38f4$var$AVAILABILITY_CHUNK_SIZE = 10;
const $4bbd6e8228ea38f4$var$chunkQuantitiesBySku = (quantities, chunkSize)=>{
    const quantitiesArray = Object.keys(quantities).map((sku)=>({
            sku: sku,
            qty: quantities[sku]
        }));
    if (quantitiesArray.length > chunkSize) return (0, $hNQAU.default)(quantitiesArray, chunkSize).map((chunk)=>chunk.map((item)=>({
                [item.sku]: item.qty
            })).reduce((0, $5OqMf.accumulate), {}));
    return [
        quantities
    ];
};
const $4bbd6e8228ea38f4$var$serialFetchAvailability = async (chunks)=>{
    if (chunks.length) {
        const firstChunkAvailability = await $4bbd6e8228ea38f4$var$fetchAvailability(chunks[0]);
        const subsequentChunksAvailability = await $4bbd6e8228ea38f4$var$serialFetchAvailability(chunks.slice(1));
        return [
            ...firstChunkAvailability,
            ...subsequentChunksAvailability
        ];
    }
    return [];
};
const $4bbd6e8228ea38f4$var$fetchAvailability = async (quantities, isSerial)=>{
    const skus = Object.keys(quantities);
    if (!skus.length) return [];
    if (skus.length > $4bbd6e8228ea38f4$var$AVAILABILITY_CHUNK_SIZE) {
        const chunks = $4bbd6e8228ea38f4$var$chunkQuantitiesBySku(quantities, $4bbd6e8228ea38f4$var$AVAILABILITY_CHUNK_SIZE);
        $4bbd6e8228ea38f4$var$availabilityStore.availabilityFetchProgress = {
            count: 0,
            target: chunks.length
        };
        try {
            let fetches;
            if (isSerial) fetches = [
                await $4bbd6e8228ea38f4$var$serialFetchAvailability(chunks)
            ];
            else fetches = await Promise.all(chunks.map((chunk)=>$4bbd6e8228ea38f4$var$fetchAvailability(chunk)));
            $4bbd6e8228ea38f4$var$availabilityStore.abortController = undefined;
            return fetches.flat();
        } catch (err) {
            if (err?.name === "AbortError") throw new (0, $aMYzM.UserCancelError)();
            throw err;
        }
    }
    if (!$4bbd6e8228ea38f4$var$availabilityStore.abortController) $4bbd6e8228ea38f4$var$availabilityStore.abortController = new AbortController();
    const abortController = $4bbd6e8228ea38f4$var$availabilityStore.abortController;
    const params = {
        customerNumber: (0, $bcbvQ.default).currentCompany,
        m3OrderType: (0, $76PCP.default).orderType,
        requestedDeliveryDate: (0, $4udGV.formatM3Date)((0, $9Vhxl.default).getCurrentDelivery()?.date),
        products: skus.map((sku)=>`${sku}*${quantities[sku]}`).join("|")
    };
    try {
        const availability = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/productAvailability`, (0, $bcbvQ.default).getSessionToken()).signal(abortController).query(params).get().json();
        if ($4bbd6e8228ea38f4$var$availabilityStore.availabilityFetchProgress) $4bbd6e8228ea38f4$var$availabilityStore.availabilityFetchProgress.count++;
        return availability;
    } catch (err) {
        $4bbd6e8228ea38f4$var$availabilityStore.abortController = undefined;
        throw err;
    }
};
const $4bbd6e8228ea38f4$var$availabilityStore = (0, $Kk7R3.makeAutoObservable)({
    newCartItems: {},
    availability: null,
    lookingForAlternatives: false,
    alternatives: [],
    hasUnavailable: ()=>{
        return $4bbd6e8228ea38f4$var$availabilityStore.availability !== null && !!$4bbd6e8228ea38f4$var$availabilityStore.availability.length;
    },
    clearAvailability: ()=>{
        $4bbd6e8228ea38f4$var$availabilityStore.newCartItems = {};
        $4bbd6e8228ea38f4$var$availabilityStore.availability = null;
        $4bbd6e8228ea38f4$var$availabilityStore.alternatives = [];
    },
    fetchAvailabilitiesBySkus: async (skus)=>{
        if (!skus.length) return [];
        const quantities = skus.map((sku)=>({
                [sku]: $4bbd6e8228ea38f4$var$DEFAULT_AVAILABILITY_CHECK_QTY
            })).reduce((0, $5OqMf.accumulate), {});
        return $4bbd6e8228ea38f4$var$fetchAvailability(quantities);
    },
    checkAvailability: async ()=>{
        if (!(0, $isIf6.default).productAvailability.enabled) return true;
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if (!currentDelivery) {
            $4bbd6e8228ea38f4$var$availabilityStore.clearAvailability();
            return true;
        }
        const quantities = (0, $76PCP.default).editing ? (0, $76PCP.default).getEditingCartChanges().filter((delta)=>delta.qtyDelta > 0).map((delta)=>({
                [delta.sku]: delta.qtyDelta
            })).reduce((0, $5OqMf.accumulate), {}) : (0, $76PCP.default).items.map((item)=>({
                [item.sku]: item.qty
            })).reduce((0, $5OqMf.accumulate), {});
        const availabilities = await $4bbd6e8228ea38f4$var$fetchAvailability(quantities, true);
        const unavailable = availabilities.filter((availability)=>!availability.available).flatMap((availability)=>{
            const cartItem = (0, $76PCP.default).getCartItem(availability.productNumber);
            if (availability.delayedDeliveryDate) availability.availableQuantity = 0;
            return cartItem ? {
                ...availability,
                selectedQuantity: availability.availableQuantity,
                requestedQuantity: cartItem.qty
            } : [];
        });
        if (!unavailable.length) {
            $4bbd6e8228ea38f4$var$availabilityStore.clearAvailability();
            return true;
        }
        (0, $76PCP.default).addLostSales(unavailable);
        $4bbd6e8228ea38f4$var$availabilityStore.availability = unavailable;
        $4bbd6e8228ea38f4$var$availabilityStore.fetchAlternatives();
        return false;
    },
    fetchAlternatives: async ()=>{
        if (!$4bbd6e8228ea38f4$var$availabilityStore.availability) return;
        $4bbd6e8228ea38f4$var$availabilityStore.lookingForAlternatives = true;
        const unavailableProducts = $4bbd6e8228ea38f4$var$availabilityStore.availability.map((availability)=>(0, $bZiDo.default).resolveSku(availability.productNumber)).filter((product)=>!(0, $3xOZa.default)(product));
        const alternativeSkus = unavailableProducts.flatMap((product)=>product.similarProducts || []).filter((sku, i, skus)=>skus.indexOf(sku) === i).filter((sku)=>!unavailableProducts.find((product)=>product.sku === sku));
        try {
            const alternativeAvailabilities = (await $4bbd6e8228ea38f4$var$availabilityStore.fetchAvailabilitiesBySkus(alternativeSkus)).map((availability)=>{
                if (availability.delayedDeliveryDate) return {
                    ...availability,
                    availableQuantity: 0
                };
                return availability;
            });
            const alternativeProductAvailabilities = alternativeSkus.map((sku)=>({
                    product: (0, $bZiDo.default).resolveSku(sku),
                    availability: alternativeAvailabilities.find((availability)=>availability.productNumber === sku)
                })).filter((productAndAvailability)=>!(0, $3xOZa.default)(productAndAvailability.product) && !(0, $3xOZa.default)(productAndAvailability.availability));
            const productsWithoutAvailableAlternatives = unavailableProducts.filter((product)=>{
                return product.similarProducts.filter((sku)=>!unavailableProducts.find((unavailableProduct)=>unavailableProduct.sku === sku)).every((similarSku)=>{
                    const productAvailability = alternativeAvailabilities.find((availability)=>availability.productNumber === similarSku);
                    return !productAvailability?.availableQuantity;
                });
            });
            const alternativeProductAndAvailabilities = alternativeProductAvailabilities.filter((productAndAvailability)=>productAndAvailability.availability.availableQuantity);
            for (const product of productsWithoutAvailableAlternatives){
                const alternativeProducts = product.similarProducts.map((sku)=>(0, $bZiDo.default).resolveSku(sku)).flatMap((product)=>product ? product : []);
                for (const alternativeProduct of alternativeProducts)if (!alternativeProductAndAvailabilities.find((productAndAvailability)=>productAndAvailability.product.sku === alternativeProduct.sku)) {
                    const availability = alternativeAvailabilities.find((availability)=>availability.productNumber === alternativeProduct.sku);
                    if (availability) alternativeProductAndAvailabilities.push({
                        product: alternativeProduct,
                        availability: availability
                    });
                }
            }
            $4bbd6e8228ea38f4$var$availabilityStore.alternatives = alternativeProductAndAvailabilities.filter((productAndAvailability)=>!$4bbd6e8228ea38f4$var$availabilityStore.availability?.find((availability)=>availability.productNumber === productAndAvailability.product.sku));
        } catch (_err) {
            $4bbd6e8228ea38f4$var$availabilityStore.clearAvailability();
        } finally{
            $4bbd6e8228ea38f4$var$availabilityStore.lookingForAlternatives = false;
        }
    },
    clearCompanySpecificData: ()=>{
        $4bbd6e8228ea38f4$var$availabilityStore.clearAvailability();
    }
});
var $4bbd6e8228ea38f4$export$2e2bcd8739ae039 = $4bbd6e8228ea38f4$var$availabilityStore;

});
parcelRegister("hNQAU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5fcf67ebd4053b$export$2e2bcd8739ae039; });

var $awSUU = parcelRequire("awSUU");

var $e0K8B = parcelRequire("e0K8B");

var $4sQKr = parcelRequire("4sQKr");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cf5fcf67ebd4053b$var$nativeCeil = Math.ceil, $cf5fcf67ebd4053b$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $cf5fcf67ebd4053b$var$chunk(array, size, guard) {
    if (guard ? (0, $e0K8B.default)(array, size, guard) : size === undefined) size = 1;
    else size = $cf5fcf67ebd4053b$var$nativeMax((0, $4sQKr.default)(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($cf5fcf67ebd4053b$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = (0, $awSUU.default)(array, index, index += size);
    return result;
}
var $cf5fcf67ebd4053b$export$2e2bcd8739ae039 = $cf5fcf67ebd4053b$var$chunk;

});
parcelRegister("e0K8B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a334dacc457339ef$export$2e2bcd8739ae039; });

var $lAkoK = parcelRequire("lAkoK");

var $7wVIe = parcelRequire("7wVIe");

var $dAIRS = parcelRequire("dAIRS");

var $42tql = parcelRequire("42tql");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $a334dacc457339ef$var$isIterateeCall(value, index, object) {
    if (!(0, $42tql.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $7wVIe.default)(object) && (0, $dAIRS.default)(index, object.length) : type == 'string' && index in object) return (0, $lAkoK.default)(object[index], value);
    return false;
}
var $a334dacc457339ef$export$2e2bcd8739ae039 = $a334dacc457339ef$var$isIterateeCall;

});


parcelRegister("5OqMf", function(module, exports) {

$parcel$export(module.exports, "makeGenericSearch", function () { return $000918b6e6d4559f$export$66210d300e31b3ca; });
$parcel$export(module.exports, "forceArray", function () { return $000918b6e6d4559f$export$f042e3ffe0775958; });
$parcel$export(module.exports, "formatUnit", function () { return $000918b6e6d4559f$export$fab59da06805c4ec; });
$parcel$export(module.exports, "translateBaseUnit", function () { return $000918b6e6d4559f$export$49f2eff219e89580; });
$parcel$export(module.exports, "warnIfCyclicObject", function () { return $000918b6e6d4559f$export$fefe18ca3bb38636; });
$parcel$export(module.exports, "formatQuantity", function () { return $000918b6e6d4559f$export$dd9196c8186add55; });
$parcel$export(module.exports, "formatPrice", function () { return $000918b6e6d4559f$export$c86caf1be068fb8d; });
$parcel$export(module.exports, "formatPhoneNumber", function () { return $000918b6e6d4559f$export$842dcfa371c6bb83; });
$parcel$export(module.exports, "isExternalLink", function () { return $000918b6e6d4559f$export$b98882f166bb7ce2; });
$parcel$export(module.exports, "hasContent", function () { return $000918b6e6d4559f$export$7ad75c69830b76d7; });
$parcel$export(module.exports, "formatOtp", function () { return $000918b6e6d4559f$export$bc5d3a44b2015cf1; });
$parcel$export(module.exports, "stripPossibleHtmlExtension", function () { return $000918b6e6d4559f$export$c2954326511919ab; });
$parcel$export(module.exports, "generateSubscriptionObjectName", function () { return $000918b6e6d4559f$export$8a7d8274ccc24be1; });
$parcel$export(module.exports, "createActionsFromCartChanges", function () { return $000918b6e6d4559f$export$a7b145a7a80c350d; });
$parcel$export(module.exports, "formatEan", function () { return $000918b6e6d4559f$export$f315f92f215d4780; });
$parcel$export(module.exports, "translateOrderType", function () { return $000918b6e6d4559f$export$c67120e1f23c4f06; });
$parcel$export(module.exports, "buildUnavailableAlertBox", function () { return $000918b6e6d4559f$export$2bf5c56cdf0fdcd; });
$parcel$export(module.exports, "translateDayLabel", function () { return $000918b6e6d4559f$export$6cb33bcfd749d7e; });
$parcel$export(module.exports, "translateNutritionBaseUnit", function () { return $000918b6e6d4559f$export$1e287507332bf47d; });
$parcel$export(module.exports, "translateStatus", function () { return $000918b6e6d4559f$export$2214c3d82b0b6d4c; });
$parcel$export(module.exports, "translateWeekday", function () { return $000918b6e6d4559f$export$64213b7cb0a772c5; });
$parcel$export(module.exports, "makeUserLabel", function () { return $000918b6e6d4559f$export$8bd71c5dcdd15218; });
$parcel$export(module.exports, "makeUserColor", function () { return $000918b6e6d4559f$export$170595bacc449436; });
$parcel$export(module.exports, "desktopBreakpoint", function () { return $000918b6e6d4559f$export$665f466a14f18a56; });
$parcel$export(module.exports, "mediumBreakpoint", function () { return $000918b6e6d4559f$export$91e4bf93df95a062; });
$parcel$export(module.exports, "mobileBreakpoint", function () { return $000918b6e6d4559f$export$2e65b7c7134e01f0; });
$parcel$export(module.exports, "twDesktopBreakpoint", function () { return $000918b6e6d4559f$export$e5cfa9cee1739b16; });
$parcel$export(module.exports, "inRangeInclusive", function () { return $000918b6e6d4559f$export$162dfb62bbf666b0; });
$parcel$export(module.exports, "weekDayNames", function () { return $000918b6e6d4559f$export$329de300752858e8; });
$parcel$export(module.exports, "monthNames", function () { return $000918b6e6d4559f$export$2e59fa295abca125; });
$parcel$export(module.exports, "mediaQueries", function () { return $000918b6e6d4559f$export$f68cee56cc062164; });
$parcel$export(module.exports, "focusableElementCssSelector", function () { return $000918b6e6d4559f$export$f5d5ba6955af2f32; });
$parcel$export(module.exports, "getYoutubeVideoIdFromURL", function () { return $000918b6e6d4559f$export$b2dcf2d20647bb78; });
$parcel$export(module.exports, "titleCase", function () { return $000918b6e6d4559f$export$348afa8c9ff47183; });
$parcel$export(module.exports, "createRandomHex", function () { return $000918b6e6d4559f$export$4a67ed3c75706e00; });
$parcel$export(module.exports, "getKeyboardFocusableElements", function () { return $000918b6e6d4559f$export$d68aba5567a52975; });
$parcel$export(module.exports, "extractTextFromReactNode", function () { return $000918b6e6d4559f$export$e70d5fff12c4d1e5; });
$parcel$export(module.exports, "accumulate", function () { return $000918b6e6d4559f$export$63fce1f81095ac4f; });

var $kneHr = parcelRequire("kneHr");
var $jf2w9 = parcelRequire("jf2w9");
var $hCd6c = parcelRequire("hCd6c");
var $bEEBX = parcelRequire("bEEBX");
var $2WS6X = parcelRequire("2WS6X");
var $j9RzS = parcelRequire("j9RzS");

var $gyNqR = parcelRequire("gyNqR");

var $dvPqk = parcelRequire("dvPqk");

var $gtsdT = parcelRequire("gtsdT");

var $8aSS4 = parcelRequire("8aSS4");

var $4udGV = parcelRequire("4udGV");
const $000918b6e6d4559f$export$66210d300e31b3ca = (searchString)=>{
    return (0, $2WS6X.default)(searchString, " ").filter((word)=>!Number.isFinite(Number.parseInt(word[0]))).join(" ");
};
const $000918b6e6d4559f$export$f042e3ffe0775958 = (val)=>(0, $hCd6c.default)(val) ? val : [
        val
    ];
const $000918b6e6d4559f$var$priceFormat = new Intl.NumberFormat("no-NO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
const $000918b6e6d4559f$var$quantityFormat = Intl.NumberFormat("no-NO", {
    minimumFractionDigits: 0,
    useGrouping: true
});
const $000918b6e6d4559f$export$fab59da06805c4ec = (unit, short = true)=>{
    switch(unit){
        case (0, $8aSS4.ORDER_UNIT).D:
        case (0, $8aSS4.ORDER_UNIT).DFP:
            return short ? "D-pak" : "per D-pak (eks mva)";
        case (0, $8aSS4.ORDER_UNIT).STK:
            return short ? "STK" : "per stk (eks mva)";
        case (0, $8aSS4.ORDER_UNIT).L:
            return short ? "Liter" : "per liter (eks mva)";
        case (0, $8aSS4.ORDER_UNIT).P:
            return short ? "Pall" : "per pall (eks mva)";
        case (0, $8aSS4.ORDER_UNIT).K:
            return short ? "Kartong" : "per kartong (eks mva)";
        case (0, $8aSS4.ORDER_UNIT).KG:
            return short ? "Kg" : "per Kg (eks mva)";
        case (0, $8aSS4.ORDER_UNIT).CS:
            return short ? "Kasse" : "per kasse (eks mva)";
        case (0, $8aSS4.ORDER_UNIT).TNK:
            return short ? "1000L" : "per 1000 L (eks mva)";
        default:
            (0, $gtsdT.logger).warn("utils", `formatUnit does not recognise unit ${unit}`);
            return short ? "STK" : "per stk (eks mva)";
    }
};
const $000918b6e6d4559f$export$49f2eff219e89580 = (baseUnit, amount)=>{
    switch(baseUnit){
        case (0, $8aSS4.ORDER_UNIT).D:
        case (0, $8aSS4.ORDER_UNIT).DFP:
            return "D-pak";
        case (0, $8aSS4.ORDER_UNIT).STK:
            return "stk";
        case (0, $8aSS4.ORDER_UNIT).L:
            return "liter";
        case (0, $8aSS4.ORDER_UNIT).P:
            return amount > 1 ? "paller" : "pall";
        case (0, $8aSS4.ORDER_UNIT).K:
            return amount > 1 ? "kartonger" : "kartong";
        case (0, $8aSS4.ORDER_UNIT).KG:
            return "kg";
        case (0, $8aSS4.ORDER_UNIT).CS:
            return amount > 1 ? "kasser" : "kasse";
        default:
            (0, $gtsdT.logger).warn("utils", `formatBaseUnit does not recognise unit ${baseUnit}`);
            return baseUnit;
    }
};
// hasOwnPropertyWithType is a type guard that checks if an object has a property, as the built-in one does not narrow the type
function $000918b6e6d4559f$var$hasOwnPropertyWithType(obj, prop) {
    return Object.hasOwn(obj, prop);
}
const $000918b6e6d4559f$export$fefe18ca3bb38636 = (obj)=>{
    const keys = [];
    const stack = [];
    const stackSet = new Set();
    let detected = false;
    function detect(obj, key) {
        if (!obj) return;
        if (typeof obj !== "object") return;
        if (stackSet.has(obj)) {
            // it's cyclic! Print the object and its locations.
            const oldindex = stack.indexOf(obj);
            const l1 = `${keys.join(".")}.${key}`;
            const l2 = keys.slice(0, oldindex + 1).join(".");
            (0, $gtsdT.logger).warn("utils", `CYCLIC RERERENCE FOUND: ${l1} = ${l2}`, obj);
            detected = true;
            return;
        }
        keys.push(key);
        stack.push(obj);
        stackSet.add(obj);
        for(const k in obj)//dive on the object's children
        if ($000918b6e6d4559f$var$hasOwnPropertyWithType(obj, k)) detect(obj[k], k);
        keys.pop();
        stack.pop();
        stackSet.delete(obj);
        return;
    }
    detect(obj, "obj");
    return detected;
};
const $000918b6e6d4559f$export$56831a8b9cb27763 = (obj)=>{
    const seen = new WeakSet();
    return JSON.stringify(obj, (_key, value)=>{
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) return "[Circular]";
            seen.add(value);
        }
        return value;
    });
};
const $000918b6e6d4559f$export$dd9196c8186add55 = (amount)=>{
    return $000918b6e6d4559f$var$quantityFormat.format(amount);
};
const $000918b6e6d4559f$export$c86caf1be068fb8d = (price, simplify = false)=>{
    if ((0, $bEEBX.default)(price) || Number.isNaN(price)) return "-";
    const priceStr = $000918b6e6d4559f$var$priceFormat.format(price);
    if (simplify) {
        const decimalIndex = priceStr.lastIndexOf(",");
        return `${priceStr.substring(0, decimalIndex + 1)}-`;
    }
    return `kr ${priceStr}`;
};
const $000918b6e6d4559f$export$842dcfa371c6bb83 = (phoneNumber)=>{
    if (!(0, $gyNqR.default)(phoneNumber)) return phoneNumber;
    return phoneNumber.replace(/[^+\d]/g, "");
};
const $000918b6e6d4559f$export$b98882f166bb7ce2 = (url)=>{
    const resolvedUrl = new URL(url, window.location.href);
    return resolvedUrl.origin !== window.location.origin;
};
const $000918b6e6d4559f$export$7ad75c69830b76d7 = (val)=>!!val;
const $000918b6e6d4559f$export$bc5d3a44b2015cf1 = (otp, prevOtp)=>{
    const cleanedOtp = otp.replace(/\D/g, "");
    return otp.length <= 6 ? cleanedOtp : prevOtp;
};
const $000918b6e6d4559f$export$c2954326511919ab = (path)=>path.replace(".html", "");
const $000918b6e6d4559f$export$8a7d8274ccc24be1 = (sub)=>{
    if ((0, $bEEBX.default)(sub)) return "";
    return (0, $4udGV.generateSubscriptionName)(sub.deliveryWeekdayNumber, sub.deliveryIntervalDays);
};
const $000918b6e6d4559f$export$a7b145a7a80c350d = (addedLines, changedLines, removedOrderLines, oldState)=>{
    const actions = [];
    for (const al of addedLines)actions.push({
        action: "add",
        sku: al.sku,
        quantity: al.qty,
        orderLineUnit: al.unit
    });
    /**
    *
    * Why are we generating payloads with both orderLineNumber and orderLineNumbers?
    *
    * Because the order API and the subscription API was not created with the same orderLineNumber(s) property name,
    * we add both so that we can reuse this function for both. This means we are always sending one field that the API
    * will ignore, but we get to avoid duplicating code.
    *
    */ for (const cl of changedLines){
        const oldStateLine = (0, $jf2w9.default)(oldState, {
            sku: cl.sku
        });
        actions.push({
            action: "upd",
            orderLineNumber: oldStateLine?.combinedLines,
            orderLineNumbers: oldStateLine?.combinedLines,
            sku: cl.sku,
            quantity: cl.qty,
            orderLineUnit: cl.unit
        });
    }
    for (const rl of removedOrderLines)actions.push({
        action: "del",
        sku: rl.sku,
        orderLineNumber: rl.combinedLines,
        orderLineNumbers: rl.combinedLines
    });
    return actions;
};
const $000918b6e6d4559f$export$f315f92f215d4780 = (ean)=>{
    if (!(0, $gyNqR.default)(ean)) {
        (0, $gtsdT.logger).error("utils", `Invalid EAN: ${ean}. Expected a string.`);
        return "";
    }
    if (ean.length !== 13) {
        (0, $gtsdT.logger).warn("utils", `Unexpected EAN length: ${ean.length}. Expected 13.`);
        return ean;
    }
    return `${ean.substring(0, 1)} ${ean.substring(1, 7)} ${ean.substring(7)}`;
};
const $000918b6e6d4559f$export$c67120e1f23c4f06 = (orderType, storeName)=>{
    const orderTypeToHumanString = {
        WEB: "Engangsordre",
        STD: `Opprettet av ${storeName}`,
        LEV: "Engangsordre",
        WAS: "Abonnement",
        EXP: "Ekspressordre",
        EXL: "Ekstralevering",
        HPN: "Henteordre",
        KOE: "Konsulentordre",
        RLG: "Reklameartikler",
        TUP: "Kundeprogram",
        XML: "EDI-ordre",
        ETT: "Etterregistrering"
    };
    return (0, $kneHr.default)(orderTypeToHumanString[orderType], orderType);
};
const $000918b6e6d4559f$export$2bf5c56cdf0fdcd = (unavailable)=>{
    const containsUnavailable = unavailable?.some((item)=>!item.available && !item.partialAvailable);
    const containsPartialUnavailable = unavailable?.some((item)=>item.partialAvailable);
    const type = containsPartialUnavailable && containsUnavailable ? "BOTH" : containsPartialUnavailable ? "LIMITED" : "SOLD_OUT";
    switch(type){
        case "BOTH":
            return {
                headerUnavailabilityText: "er ikke tilgjengelig / har begrenset antall p\xe5 lager",
                listTitleUnavailabilityText: "Dessverre er noen av produktene du \xf8nsker \xe5 bestille ikke tilgjengelig \u2013 se detaljer under. Oppdater handlekurven og send inn ordren p\xe5 nytt."
            };
        case "LIMITED":
            return {
                headerUnavailabilityText: "har begrenset antall p\xe5 lager",
                listTitleUnavailabilityText: `${unavailable?.length === 1 ? "Ett" : "Noen"} av produktene du har bestilt har begrenset tilgjengelighet for \xf8yeblikket.`
            };
        default:
            return {
                headerUnavailabilityText: "er ikke tilgjengelig",
                listTitleUnavailabilityText: "Dessverre er noen av produktene du \xf8nsker \xe5 bestille ikke tilgjengelig \u2013 se detaljer under. Oppdater handlekurven og send inn ordren p\xe5 nytt."
            };
    }
};
const $000918b6e6d4559f$export$6cb33bcfd749d7e = (orderType)=>{
    switch(orderType){
        case (0, $8aSS4.ORDERTYPE).HPN:
            return "Hentes etter";
        default:
            return "Levering";
    }
};
const $000918b6e6d4559f$export$1e287507332bf47d = (baseUnit)=>{
    if (baseUnit === "100_mililiter") return "per 100 ml";
    if (baseUnit === "100_gram") return "per 100 g";
    return "";
};
const $000918b6e6d4559f$export$2214c3d82b0b6d4c = (status)=>{
    const statusToHumanString = {
        "20": {
            text: "bestilling mottatt",
            color: "information"
        },
        "22": {
            text: "bestilling mottatt",
            color: "information"
        },
        "33": {
            text: "bestilling mottatt",
            color: "information"
        },
        "44": {
            text: "under plukking",
            color: "warning"
        },
        "66": {
            text: "ferdig pakket",
            color: "information"
        },
        "77": {
            text: "pakket og fakturert",
            color: "success"
        },
        "79": {
            text: "fakturert med manko",
            color: "warning"
        },
        "90": {
            text: "slettet",
            color: "error"
        },
        "99": {
            text: "kan ikke leveres",
            color: "error"
        }
    };
    return (0, $kneHr.default)(statusToHumanString[status], {
        text: `status ${status}`,
        color: "black"
    });
};
const $000918b6e6d4559f$export$64213b7cb0a772c5 = (englishWeekday)=>{
    const englishToNorwegianWeekdays = {
        Monday: "Mandag",
        Tuesday: "Tirsdag",
        Wednesday: "Onsdag",
        Thursday: "Torsdag",
        Friday: "Fredag",
        Saturday: "L\xf8rdag",
        Sunday: "S\xf8ndag"
    };
    return (0, $kneHr.default)(englishToNorwegianWeekdays[englishWeekday], englishWeekday);
};
const $000918b6e6d4559f$export$8bd71c5dcdd15218 = (user)=>{
    if (user.firstName && user.lastName) return (0, $j9RzS.default)((0, $kneHr.default)(user.firstName, " ").substring(0, 1) + (0, $kneHr.default)(user.lastName, " ").substring(0, 1));
    if (user.firstName) return user.firstName.substring(0, 2);
    if (user.lastName) return user.lastName.substring(0, 2);
    const emailsParts = user.email.split("@")[0].split(".");
    if (emailsParts.length > 1) return emailsParts[0].substring(0, 1) + emailsParts[1].substring(0, 1);
    return emailsParts[0].substring(0, 2);
};
const $000918b6e6d4559f$var$stringToColor = (string, saturation = 75, lightness = 75)=>{
    let hash = 0;
    for(let i = 0; i < string.length; i++){
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    return `hsl(${hash % 360}, ${saturation}%, ${lightness}%)`;
};
const $000918b6e6d4559f$export$170595bacc449436 = (user)=>$000918b6e6d4559f$var$stringToColor($000918b6e6d4559f$export$8bd71c5dcdd15218(user));
const $000918b6e6d4559f$export$665f466a14f18a56 = "(min-width: 768px)";
const $000918b6e6d4559f$export$91e4bf93df95a062 = "(max-width: 767.98px)";
const $000918b6e6d4559f$export$2e65b7c7134e01f0 = "(max-width: 639.98px)";
const $000918b6e6d4559f$export$e5cfa9cee1739b16 = "(min-width: 1024px)";
const $000918b6e6d4559f$export$162dfb62bbf666b0 = (num, validRange)=>num >= validRange.min && num <= validRange.max;
const $000918b6e6d4559f$export$329de300752858e8 = [
    "S\xf8.",
    "Ma.",
    "Ti.",
    "On.",
    "To.",
    "Fr.",
    "L\xf8."
];
const $000918b6e6d4559f$export$2e59fa295abca125 = [
    "Januar",
    "Februar",
    "Mars",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Desember"
];
const $000918b6e6d4559f$export$d07517a676ce386f = {
    xs: "",
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    xxl: "1536px",
    "2xl": "1536px"
};
const $000918b6e6d4559f$export$f68cee56cc062164 = {
    xs: "",
    sm: `(min-width: ${$000918b6e6d4559f$export$d07517a676ce386f.sm})`,
    md: `(min-width: ${$000918b6e6d4559f$export$d07517a676ce386f.md})`,
    lg: `(min-width: ${$000918b6e6d4559f$export$d07517a676ce386f.lg})`,
    xl: `(min-width: ${$000918b6e6d4559f$export$d07517a676ce386f.xl})`,
    xxl: `(min-width: ${$000918b6e6d4559f$export$d07517a676ce386f.xxl})`,
    "2xl": `(min-width: ${$000918b6e6d4559f$export$d07517a676ce386f["2xl"]})`
};
const $000918b6e6d4559f$export$f5d5ba6955af2f32 = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const $000918b6e6d4559f$export$b2dcf2d20647bb78 = (url)=>{
    const [preQuery, postQuery] = url.split("?");
    if (/youtube\.com/i.test(preQuery) && postQuery) return postQuery.split("&").find((param)=>param.startsWith("v="))?.substring(2);
};
const $000918b6e6d4559f$export$348afa8c9ff47183 = (str)=>{
    const lower = str.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
};
const $000918b6e6d4559f$export$4a67ed3c75706e00 = (size)=>[
        ...Array(size)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join("");
function $000918b6e6d4559f$export$d68aba5567a52975(element = document) {
    return [
        ...element.querySelectorAll('a, button:not([tabindex="-1"]), input, textarea, select, details,[tabindex]:not([tabindex="-1"])')
    ].filter((el)=>!el.hasAttribute("disabled"));
}
const $000918b6e6d4559f$export$e70d5fff12c4d1e5 = (node)=>{
    if (typeof node === "string") return node;
    if (Array.isArray(node)) return node.map($000918b6e6d4559f$export$e70d5fff12c4d1e5).join("");
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).isValidElement(node)) return $000918b6e6d4559f$export$e70d5fff12c4d1e5(node.props.children);
    return "";
};
const $000918b6e6d4559f$export$63fce1f81095ac4f = (acc, currentValue)=>Object.assign(acc, currentValue);

});
parcelRegister("2WS6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $225af8e4f987a2bc$export$2e2bcd8739ae039; });

var $jjUEx = parcelRequire("jjUEx");

var $6QJPP = parcelRequire("6QJPP");

var $aCxUA = parcelRequire("aCxUA");

var $e0K8B = parcelRequire("e0K8B");

var $4ejFk = parcelRequire("4ejFk");

var $fXIA9 = parcelRequire("fXIA9");

var $cQbRr = parcelRequire("cQbRr");
/** Used as references for the maximum length and index of an array. */ var $225af8e4f987a2bc$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */ function $225af8e4f987a2bc$var$split(string, separator, limit) {
    if (limit && typeof limit != 'number' && (0, $e0K8B.default)(string, separator, limit)) separator = limit = undefined;
    limit = limit === undefined ? $225af8e4f987a2bc$var$MAX_ARRAY_LENGTH : limit >>> 0;
    if (!limit) return [];
    string = (0, $cQbRr.default)(string);
    if (string && (typeof separator == 'string' || separator != null && !(0, $4ejFk.default)(separator))) {
        separator = (0, $jjUEx.default)(separator);
        if (!separator && (0, $aCxUA.default)(string)) return (0, $6QJPP.default)((0, $fXIA9.default)(string), 0, limit);
    }
    return string.split(separator, limit);
}
var $225af8e4f987a2bc$export$2e2bcd8739ae039 = $225af8e4f987a2bc$var$split;

});

parcelRegister("j9RzS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df286afd0fb6e829$export$2e2bcd8739ae039; });

var $jjUEx = parcelRequire("jjUEx");

var $9wyjI = parcelRequire("9wyjI");

var $6QJPP = parcelRequire("6QJPP");

var $htGWJ = parcelRequire("htGWJ");

var $fMBrn = parcelRequire("fMBrn");

var $fXIA9 = parcelRequire("fXIA9");

var $cQbRr = parcelRequire("cQbRr");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $df286afd0fb6e829$var$trim(string, chars, guard) {
    string = (0, $cQbRr.default)(string);
    if (string && (guard || chars === undefined)) return (0, $9wyjI.default)(string);
    if (!string || !(chars = (0, $jjUEx.default)(chars))) return string;
    var strSymbols = (0, $fXIA9.default)(string), chrSymbols = (0, $fXIA9.default)(chars), start = (0, $fMBrn.default)(strSymbols, chrSymbols), end = (0, $htGWJ.default)(strSymbols, chrSymbols) + 1;
    return (0, $6QJPP.default)(strSymbols, start, end).join('');
}
var $df286afd0fb6e829$export$2e2bcd8739ae039 = $df286afd0fb6e829$var$trim;

});
parcelRegister("htGWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb9675575f7d9926$export$2e2bcd8739ae039; });

var $hRnoc = parcelRequire("hRnoc");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $cb9675575f7d9926$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && (0, $hRnoc.default)(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
var $cb9675575f7d9926$export$2e2bcd8739ae039 = $cb9675575f7d9926$var$charsEndIndex;

});

parcelRegister("fMBrn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7d861a0bbca7f61$export$2e2bcd8739ae039; });

var $hRnoc = parcelRequire("hRnoc");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $b7d861a0bbca7f61$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && (0, $hRnoc.default)(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
var $b7d861a0bbca7f61$export$2e2bcd8739ae039 = $b7d861a0bbca7f61$var$charsStartIndex;

});



parcelRegister("9Vhxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50793fddd4a3e7c0$export$2e2bcd8739ae039; });

var $4O279 = parcelRequire("4O279");
var $kuUjW = parcelRequire("kuUjW");
var $fbCoc = parcelRequire("fbCoc");
var $5UIm0 = parcelRequire("5UIm0");

var $2Vh19 = parcelRequire("2Vh19");
var $5LjUB = parcelRequire("5LjUB");
var $ikiOO = parcelRequire("ikiOO");

var $kneHr = parcelRequire("kneHr");

var $bEEBX = parcelRequire("bEEBX");

var $42tql = parcelRequire("42tql");

var $gyNqR = parcelRequire("gyNqR");

var $3xOZa = parcelRequire("3xOZa");

var $jNFGw = parcelRequire("jNFGw");

var $c3PBx = parcelRequire("c3PBx");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $Z5T7p = parcelRequire("Z5T7p");

var $8aSS4 = parcelRequire("8aSS4");

var $5OqMf = parcelRequire("5OqMf");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $76PCP = parcelRequire("76PCP");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $gvoND = parcelRequire("gvoND");

var $a2SqC = parcelRequire("a2SqC");

var $8z7vy = parcelRequire("8z7vy");
const $50793fddd4a3e7c0$var$deliveryDatesStore = (0, $Kk7R3.makeAutoObservable)({
    deliveryDates: (0, $duLFK.initializeWithDefaultData)({}),
    holidays: (0, $duLFK.initializeWithDefaultData)([]),
    pickupLocation: (0, $duLFK.initializeWithDefaultData)(null),
    cancelledDates: [],
    currentDelivery: {},
    changingDeliveryDate: false,
    nowTimestamp: Date.now(),
    fetchDeliveryDates: async (customerNumber)=>{
        if (!(0, $biFcX.default).hasCustomerFeature((0, $Z5T7p.FEATURE_NAME).createOrderAvailable)) {
            (0, $gtsdT.logger).log("delivery", "Create ordre feature not available, aborting delivery dates fetch.");
            return;
        }
        (0, $duLFK.setAsWaitingForData)($50793fddd4a3e7c0$var$deliveryDatesStore.pickupLocation);
        (0, $duLFK.setAsWaitingForData)($50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates);
        const token = (0, $bcbvQ.default).getSessionToken();
        let deliveries = {};
        try {
            const resp = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/deliverydates_2022/${customerNumber}`, token).query({
                company: (0, $isIf6.default).m3CompanyNumber
            }).get().json();
            (0, $Kk7R3.runInAction)(()=>{
                if ((0, $2Vh19.default)(resp, "deliveryDates")) {
                    deliveries[(0, $isIf6.default).defaultOrderType] = (0, $8z7vy.parse2022DeliveryDates)(resp);
                    deliveries[(0, $8aSS4.ORDERTYPE).WAS] = (0, $8z7vy.parse2022DeliveryDatesForSubscription)(resp);
                }
                if ((0, $2Vh19.default)(resp, "cancelledDeliveryDates")) $50793fddd4a3e7c0$var$deliveryDatesStore.cancelledDates = resp.cancelledDeliveryDates.map((dateStr)=>(0, $5UIm0.default)(dateStr));
                else $50793fddd4a3e7c0$var$deliveryDatesStore.cancelledDates = [];
                if ((0, $2Vh19.default)(resp, "extraDeliveryDates")) {
                    const extraDates = resp.extraDeliveryDates.map((dateStr)=>new Date(dateStr));
                    const webDeliveries = deliveries[(0, $isIf6.default).defaultOrderType];
                    for (const delivery of webDeliveries || [])if (extraDates.some((extraDate)=>(0, $fbCoc.default)(extraDate, delivery.date))) delivery.isExtra = true;
                    (0, $gtsdT.logger).log("delivery", {
                        extra: resp.extraDeliveryDates
                    });
                }
                deliveries = (0, $4udGV.removeUnwantedDates)(deliveries, [
                    (0, $isIf6.default).defaultOrderType,
                    (0, $8aSS4.ORDERTYPE).WAS
                ]);
            });
        } catch (err) {
            (0, $gtsdT.logger).log("delivery", "User has no delivery dates.", `${err}`);
        }
        if ((0, $biFcX.default).hasCustomerFeature((0, $Z5T7p.FEATURE_NAME).pickupOrderAvailable)) try {
            const pickupData = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/deliverydates_2022/pickupdates/${(0, $isIf6.default).m3CompanyNumber}/${customerNumber}`, token).get().json();
            (0, $Kk7R3.runInAction)(()=>{
                if (!(0, $bEEBX.default)(pickupData)) deliveries[(0, $8aSS4.ORDERTYPE).HPN] = (0, $8z7vy.parse2022PickupDates)(pickupData);
                (0, $duLFK.setAsDataAvailable)($50793fddd4a3e7c0$var$deliveryDatesStore.pickupLocation, (0, $jNFGw.default)(pickupData, "pickupAt"));
            });
        } catch (err) {
            (0, $duLFK.setAsErrorOccured)($50793fddd4a3e7c0$var$deliveryDatesStore.pickupLocation, `${err}`);
            (0, $gtsdT.logger).log("delivery", "User has no pick up dates.", `${err}`);
        }
        else (0, $duLFK.setAsErrorOccured)($50793fddd4a3e7c0$var$deliveryDatesStore.pickupLocation, "No pickup location when user don't have 'pickupOrderAvailable'-feature");
        if ((0, $5LjUB.default)($50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates)) (0, $duLFK.setAsErrorOccured)($50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates, "User has neither delivery dates nor pickup dates.");
        else (0, $duLFK.setAsDataAvailable)($50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates, deliveries);
    },
    fetchHolidays: async ()=>{
        (0, $duLFK.setAsLoading)($50793fddd4a3e7c0$var$deliveryDatesStore.holidays);
        const holidayUrl = `${(0, $8ZCSm.STATICDATA_HOST)}/holidays.${(0, $8ZCSm.ENV_NAME)}_${(0, $a2SqC.default).dataVersion}.json`;
        (0, $gtsdT.logger).log("delivery", `Fetching holidays from ${holidayUrl}`);
        return (0, $3Y1Wx.apiClient)(holidayUrl).get().json((holidays)=>{
            (0, $duLFK.setAsDataAvailable)($50793fddd4a3e7c0$var$deliveryDatesStore.holidays, holidays.map((0, $5UIm0.default)));
        }).catch((err)=>{
            (0, $duLFK.setAsErrorOccured)($50793fddd4a3e7c0$var$deliveryDatesStore.holidays, err);
        });
    },
    getCurrentDelivery: (type)=>{
        const orderType = type || (0, $76PCP.default).orderType;
        return $50793fddd4a3e7c0$var$deliveryDatesStore.currentDelivery?.[orderType] || null;
    },
    getExpiration: (deliveryDate)=>{
        let msToDeadline = Math.floor((deliveryDate.deadline.getTime() - $50793fddd4a3e7c0$var$deliveryDatesStore.nowTimestamp) / 1000) * 1000;
        if (msToDeadline > (0, $8z7vy.SIXTY_MINUTES)) msToDeadline = (0, $8z7vy.MORE_THAN_SIXTY_MINUTES);
        return (0, $ikiOO.default)([
            msToDeadline,
            0
        ]) || 0;
    },
    getCurrentDeliveryExpiration: (type)=>{
        const orderType = type || (0, $76PCP.default).orderType;
        const currentDelivery = $50793fddd4a3e7c0$var$deliveryDatesStore.getCurrentDelivery(orderType);
        if (currentDelivery?.deadline) return $50793fddd4a3e7c0$var$deliveryDatesStore.getExpiration(currentDelivery);
        return null;
    },
    removeExpiredDeliveryDates: ()=>{
        $50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates.data = Object.keys($50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates.data).map((orderType)=>{
            const deliveryDates = $50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates.data[orderType];
            return {
                orderType: orderType,
                deliveryDates: deliveryDates?.filter((deliveryDate)=>$50793fddd4a3e7c0$var$deliveryDatesStore.getExpiration(deliveryDate))
            };
        }).filter((d)=>d.deliveryDates?.length).map((item)=>({
                [item.orderType]: item.deliveryDates
            })).reduce((0, $5OqMf.accumulate), {});
    },
    /**
    * Find first delivery date for the ordertype where delivery date and order deadline is in the future.
    * If weekday is given, make sure that the delivery date also matches the given day of week.
    *
    * @param {string | number | null} requiredWeekDay - Weekday number (1-7) or null
    * @param {ORDERTYPE} orderType - Order type to find delivery date for
    */ getNextMatchingDeliveryDate: (requiredWeekDay, orderType)=>{
        const deliveryDates = $50793fddd4a3e7c0$var$deliveryDatesStore.getAllDeliveriesForOrderType((0, $kneHr.default)(orderType, (0, $76PCP.default).orderType));
        const now = new Date();
        const weekdayNumber = (0, $gyNqR.default)(requiredWeekDay) ? Number.parseInt(requiredWeekDay) : requiredWeekDay;
        return deliveryDates.find((dd)=>(0, $kuUjW.default)(dd.date, now) && (0, $kuUjW.default)(dd.deadline, now) && (requiredWeekDay === null || (0, $4O279.default)(dd.date) === weekdayNumber));
    },
    getAllDeliveriesForOrderType: (orderType)=>{
        return (0, $kneHr.default)($50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates.data[orderType], []);
    },
    getNextDeliveryDateForOrderType: (orderType)=>{
        const deliveriesForOrderType = $50793fddd4a3e7c0$var$deliveryDatesStore.getAllDeliveriesForOrderType(orderType);
        if (deliveriesForOrderType.length === 0) return null;
        return deliveriesForOrderType.find((deliveryDate)=>$50793fddd4a3e7c0$var$deliveryDatesStore.getExpiration(deliveryDate)) || null;
    },
    selectNextDeliveryDateForOrderType: (orderType)=>{
        const nextDelivery = $50793fddd4a3e7c0$var$deliveryDatesStore.getNextDeliveryDateForOrderType(orderType);
        const newDelivery = (0, $42tql.default)(nextDelivery) ? {
            ...nextDelivery
        } : null;
        if (newDelivery) {
            if ((0, $bcbvQ.default).isLoggedIn()) $50793fddd4a3e7c0$var$deliveryDatesStore.changeDeliveryDate(newDelivery.date, orderType);
            else $50793fddd4a3e7c0$var$deliveryDatesStore.currentDelivery[orderType] = newDelivery;
        }
    },
    changeDeliveryDate: async (newDate, type = (0, $76PCP.default).orderType)=>{
        (0, $Kk7R3.runInAction)(()=>{
            $50793fddd4a3e7c0$var$deliveryDatesStore.changingDeliveryDate = true;
        });
        const foundDate = $50793fddd4a3e7c0$var$deliveryDatesStore.getDeliveryForDate(newDate, type);
        if ((0, $3xOZa.default)(foundDate)) {
            (0, $Kk7R3.runInAction)(()=>{
                $50793fddd4a3e7c0$var$deliveryDatesStore.changingDeliveryDate = false;
                (0, $gvoND.default).addError("Feil", "Kunne ikke endre leveringsdato.", {
                    context: "delivery_dates",
                    text: "no_delivery_day_found_error"
                });
            });
            (0, $gtsdT.logger).warn("delivery", "Unable to find date selected in calendar, bug?");
            throw "Unable to find date selected in calendar";
        }
        const previousInterval = (0, $kneHr.default)($50793fddd4a3e7c0$var$deliveryDatesStore.getCurrentDelivery(type)?.interval, 7);
        (0, $Kk7R3.runInAction)(()=>{
            $50793fddd4a3e7c0$var$deliveryDatesStore.currentDelivery[type] = {
                ...foundDate
            };
        });
        if (type === (0, $8aSS4.ORDERTYPE).WAS) {
            const currentWASDelivery = $50793fddd4a3e7c0$var$deliveryDatesStore.currentDelivery[(0, $8aSS4.ORDERTYPE).WAS];
            if (currentWASDelivery) currentWASDelivery.interval = previousInterval;
        }
        const currentDelivery = $50793fddd4a3e7c0$var$deliveryDatesStore.getCurrentDelivery(type);
        (0, $gtsdT.logger).log("delivery", "Selected delivery", currentDelivery);
        if ((0, $bEEBX.default)(currentDelivery)) {
            (0, $gvoND.default).addError("Feil", "Kunne ikke endre leveringsdato.", {
                context: "delivery_dates",
                text: "no_current_delivery_day_error"
            });
            (0, $Kk7R3.runInAction)(()=>{
                $50793fddd4a3e7c0$var$deliveryDatesStore.changingDeliveryDate = false;
            });
            return;
        }
        if ((0, $lKrOo.default).is("LOGGED_IN")) await (0, $bZiDo.default).getAssortment((0, $bcbvQ.default).currentCompany, currentDelivery.date, (0, $76PCP.default).orderType);
        (0, $Kk7R3.runInAction)(()=>{
            (0, $76PCP.default).lostSales = [];
            $50793fddd4a3e7c0$var$deliveryDatesStore.changingDeliveryDate = false;
        });
    },
    getDeliveryForDate: (date, orderType)=>{
        const deliveries = $50793fddd4a3e7c0$var$deliveryDatesStore.getAllDeliveriesForOrderType(orderType);
        return deliveries.find((delivery)=>(0, $fbCoc.default)(delivery.date, date));
    },
    getDeadlineForDelivery: (queryDate, orderType)=>{
        const delivery = $50793fddd4a3e7c0$var$deliveryDatesStore.getDeliveryForDate(queryDate, orderType);
        return delivery?.deadline;
    },
    getDayFlags: (date)=>{
        const holiday = $50793fddd4a3e7c0$var$deliveryDatesStore.isHoliday(date);
        const cancelled = $50793fddd4a3e7c0$var$deliveryDatesStore.isCancelledDate(date);
        const selectable = $50793fddd4a3e7c0$var$deliveryDatesStore.isDeliveryDate(date, (0, $76PCP.default).orderType) && !cancelled;
        const dayFlags = {
            holiday: holiday,
            cancelled: cancelled,
            disabled: !selectable,
            delivery: selectable,
            selectable: selectable
        };
        return dayFlags;
    },
    isDeliveryDate: (queryDate, orderType = (0, $76PCP.default).orderType)=>{
        const deliveries = $50793fddd4a3e7c0$var$deliveryDatesStore.getAllDeliveriesForOrderType(orderType);
        return (0, $c3PBx.default)(deliveries, (delivery)=>(0, $fbCoc.default)(delivery.date, queryDate) && $50793fddd4a3e7c0$var$deliveryDatesStore.getExpiration(delivery));
    },
    isCancelledDate: (queryDate)=>{
        return (0, $c3PBx.default)($50793fddd4a3e7c0$var$deliveryDatesStore.cancelledDates, (cancelledDate)=>(0, $fbCoc.default)(cancelledDate, queryDate));
    },
    isHoliday: (queryDate)=>{
        return (0, $c3PBx.default)($50793fddd4a3e7c0$var$deliveryDatesStore.holidays.data, (holiday)=>(0, $fbCoc.default)(holiday, queryDate));
    },
    getAvailableOrderTypes: ()=>{
        if (!(0, $lKrOo.default).is("DELIVERY_DATES_LOADING")) return null;
        return Object.keys($50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates.data);
    },
    clearCompanySpecificData () {
        $50793fddd4a3e7c0$var$deliveryDatesStore.currentDelivery = {};
        $50793fddd4a3e7c0$var$deliveryDatesStore.deliveryDates = (0, $duLFK.initializeWithDefaultData)({});
    }
});
const $50793fddd4a3e7c0$var$intervalId = setInterval((0, $Kk7R3.action)(()=>{
    $50793fddd4a3e7c0$var$deliveryDatesStore.nowTimestamp = Date.now();
}), 1000);
if (window) window.addEventListener("onbeforeunload", ()=>{
    clearInterval($50793fddd4a3e7c0$var$intervalId);
});
var $50793fddd4a3e7c0$export$2e2bcd8739ae039 = $50793fddd4a3e7c0$var$deliveryDatesStore;

});
parcelRegister("4O279", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37fd78d30be67756$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $37fd78d30be67756$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var day = date.getDay();
    if (day === 0) day = 7;
    return day;
}

});

parcelRegister("2Vh19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $220e1afdd6d6e7e1$export$2e2bcd8739ae039; });

var $h2rNt = parcelRequire("h2rNt");

var $hTnF1 = parcelRequire("hTnF1");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $220e1afdd6d6e7e1$var$has(object, path) {
    return object != null && (0, $hTnF1.default)(object, path, (0, $h2rNt.default));
}
var $220e1afdd6d6e7e1$export$2e2bcd8739ae039 = $220e1afdd6d6e7e1$var$has;

});
parcelRegister("h2rNt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6782f72c6cb4e52$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $c6782f72c6cb4e52$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c6782f72c6cb4e52$var$hasOwnProperty = $c6782f72c6cb4e52$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $c6782f72c6cb4e52$var$baseHas(object, key) {
    return object != null && $c6782f72c6cb4e52$var$hasOwnProperty.call(object, key);
}
var $c6782f72c6cb4e52$export$2e2bcd8739ae039 = $c6782f72c6cb4e52$var$baseHas;

});


parcelRegister("ikiOO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d578b13fe701efce$export$2e2bcd8739ae039; });

var $9aP4i = parcelRequire("9aP4i");

var $6J85Y = parcelRequire("6J85Y");

var $jHP7K = parcelRequire("jHP7K");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $d578b13fe701efce$var$max(array) {
    return array && array.length ? (0, $9aP4i.default)(array, (0, $jHP7K.default), (0, $6J85Y.default)) : undefined;
}
var $d578b13fe701efce$export$2e2bcd8739ae039 = $d578b13fe701efce$var$max;

});
parcelRegister("6J85Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e5d39a1a0e04f12$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $4e5d39a1a0e04f12$var$baseGt(value, other) {
    return value > other;
}
var $4e5d39a1a0e04f12$export$2e2bcd8739ae039 = $4e5d39a1a0e04f12$var$baseGt;

});


parcelRegister("c3PBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7dcb69d8d224b4$export$2e2bcd8739ae039; });

var $jxcvR = parcelRequire("jxcvR");

var $aIIzU = parcelRequire("aIIzU");

var $8qH48 = parcelRequire("8qH48");

var $hCd6c = parcelRequire("hCd6c");

var $e0K8B = parcelRequire("e0K8B");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $8c7dcb69d8d224b4$var$some(collection, predicate, guard) {
    var func = (0, $hCd6c.default)(collection) ? (0, $jxcvR.default) : (0, $8qH48.default);
    if (guard && (0, $e0K8B.default)(collection, predicate, guard)) predicate = undefined;
    return func(collection, (0, $aIIzU.default)(predicate, 3));
}
var $8c7dcb69d8d224b4$export$2e2bcd8739ae039 = $8c7dcb69d8d224b4$var$some;

});
parcelRegister("8qH48", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62322869115b52e1$export$2e2bcd8739ae039; });

var $7xRth = parcelRequire("7xRth");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $62322869115b52e1$var$baseSome(collection, predicate) {
    var result;
    (0, $7xRth.default)(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
var $62322869115b52e1$export$2e2bcd8739ae039 = $62322869115b52e1$var$baseSome;

});


parcelRegister("lKrOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e6a9b6349a164eb$export$2e2bcd8739ae039; });

var $Kk7R3 = parcelRequire("Kk7R3");

var $7nQ1B = parcelRequire("7nQ1B");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $f2Bp8 = parcelRequire("f2Bp8");

var $9yKIH = parcelRequire("9yKIH");

var $44W8i = parcelRequire("44W8i");

var $gvoND = parcelRequire("gvoND");

var $a2SqC = parcelRequire("a2SqC");

var $bcbvQ = parcelRequire("bcbvQ");

var $iJEB8 = parcelRequire("iJEB8");
const $1e6a9b6349a164eb$var$legalTransitions = {
    START_UP: [
        "NOT_LOGGED_IN",
        "VERIFY_SESSION"
    ],
    VERIFY_SESSION: [
        "NOT_LOGGED_IN",
        "LOGGING_IN"
    ],
    LOGGING_IN: [
        "COMPANY_SELECTION",
        "COMPANY_SELECTED"
    ],
    COMPANY_SELECTION: [
        "COMPANY_SELECTED",
        "LOGGED_IN",
        "NOT_LOGGED_IN"
    ],
    COMPANY_SELECTED: [
        "FEATURES_LOADING"
    ],
    FEATURES_LOADING: [
        "DELIVERY_DATES_LOADING"
    ],
    DELIVERY_DATES_LOADING: [
        "ASSORTMENT_LOADING",
        "LOGGED_IN"
    ],
    ASSORTMENT_LOADING: [
        "NOTIFICATIONS_LOADING",
        "LOGGED_IN"
    ],
    NOTIFICATIONS_LOADING: [
        "LOGGED_IN"
    ],
    LOGGED_IN: [
        "NOT_LOGGED_IN",
        "COMPANY_SELECTION",
        "FORCED_LOGOUT"
    ],
    NOT_LOGGED_IN: [
        "LOGIN_MODAL"
    ],
    FORCED_LOGOUT: [
        "LOGIN_MODAL",
        "NOT_LOGGED_IN"
    ],
    LOGIN_MODAL: [
        "CHECKING_LOGIN",
        "NOT_LOGGED_IN"
    ],
    CHECKING_LOGIN: [
        "LOGIN_MODAL",
        "VERIFY_SESSION"
    ]
};
/**
 * Because some of the components update their needs for login on mount and unmount
 * we want to give the page a few milliseconds to settle before we check if any components
 * require login. Most typical scenario this is needed is when code redirects to frontpage and
 * transitions in the next line of code.
 */ const $1e6a9b6349a164eb$var$openLoginModalIfNeeded = ()=>setTimeout($1e6a9b6349a164eb$var$delayedOpenLoginModalIfNeeded, 250);
const $1e6a9b6349a164eb$var$delayedOpenLoginModalIfNeeded = ()=>{
    (0, $gtsdT.logger).log("login-state", `Checking if we should show login modal... ${(0, $bcbvQ.default).currentlyRequiresLogin}`);
    const currentQueryParams = window.location.search;
    if (currentQueryParams.includes("newaccount=true")) {
        (0, $gtsdT.logger).log("login-state", "Showing modal because of new account param");
        (0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_EMAIL);
        $1e6a9b6349a164eb$var$loginState.transitionTo("LOGIN_MODAL");
    } else if (currentQueryParams.includes("showlogin=true")) {
        (0, $gtsdT.logger).log("login-state", "Showing modal because of show login param");
        (0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).USERNAME);
        $1e6a9b6349a164eb$var$loginState.transitionTo("LOGIN_MODAL");
    } else if ((0, $bcbvQ.default).currentlyRequiresLogin.length > 0) {
        (0, $gtsdT.logger).log("login-state", `Showing modal because of ${(0, $bcbvQ.default).currentlyRequiresLogin}`);
        $1e6a9b6349a164eb$var$loginState.transitionTo("LOGIN_MODAL");
    }
};
/** Removes query parameter if present in current URL */ const $1e6a9b6349a164eb$var$dropQueryParameter = (parameterToRemove)=>{
    if (!window.location.search.includes(parameterToRemove)) return;
    // Remove the parameter specified, rebuilds URL and navigates to it
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(parameterToRemove);
    const newSearch = searchParams.toString();
    (0, $7nQ1B.navigate)(`${window.location.pathname}${newSearch ? `?${newSearch}` : ""}`);
};
const $1e6a9b6349a164eb$var$transitionSideEffects = {
    "VERIFY_SESSION -> NOT_LOGGED_IN": ()=>{
        (0, $gtsdT.logger).log("login-state", "User token was not valid, not logged in");
        (0, $6fuyt.sendLoginFailed)();
        $1e6a9b6349a164eb$var$openLoginModalIfNeeded();
    },
    "START_UP -> NOT_LOGGED_IN": ()=>{
        (0, $gtsdT.logger).log("login-state", " User did not have a token");
        $1e6a9b6349a164eb$var$openLoginModalIfNeeded();
    },
    "NOT_LOGGED_IN -> LOGIN_MODAL": ()=>{
        (0, $6fuyt.sendLoginStart)();
        (0, $gtsdT.logger).log("login-state", "Showing login modal from not logged in");
    },
    "FORCED_LOGOUT -> LOGIN_MODAL": ()=>{
        (0, $6fuyt.sendLoginStart)();
        (0, $gtsdT.logger).log("login-state", "Showing login modal from forced logout");
    },
    "VERIFY_SESSION -> LOGIN_MODAL": ()=>{
        (0, $6fuyt.sendLoginStart)();
        (0, $gtsdT.logger).log("login-state", "Showing login modal because session verification failed");
    },
    "DELIVERY_DATES_LOADING -> LOGGED_IN": ()=>{
        if ((0, $bcbvQ.default).error) (0, $gvoND.default).addError("Feil", (0, $aMYzM.backendIssueMessagesByLocale)[(0, $a2SqC.default).locale][(0, $bcbvQ.default).error.message], {
            context: "login",
            text: "fetch_delivery_dates_error"
        });
        (0, $9yKIH.default).updateCurrentCustomerProperties();
        (0, $6fuyt.sendLoginSuccess)();
        (0, $gtsdT.logger).log("login-state", "User does not have delivery dates available, but we allow them in anyway...", {
            context: "login",
            text: "fetch_assortment_error"
        });
    },
    "ASSORTMENT_LOADING -> LOGGED_IN": ()=>{
        if ((0, $bcbvQ.default).error) (0, $gvoND.default).addError("Feil", (0, $aMYzM.backendIssueMessagesByLocale)[(0, $a2SqC.default).locale][(0, $bcbvQ.default).error.message]);
        (0, $9yKIH.default).updateCurrentCustomerProperties();
        (0, $6fuyt.sendLoginSuccess)();
        (0, $gtsdT.logger).log("login-state", "User does not have assortment available, but we allow them in anyway...");
    },
    "NOTIFICATIONS_LOADING -> LOGGED_IN": ()=>{
        (0, $9yKIH.default).updateCurrentCustomerProperties();
        (0, $6fuyt.sendLoginSuccess)();
        $1e6a9b6349a164eb$var$dropQueryParameter("showlogin");
        (0, $44W8i.default).getRecommendations();
        (0, $gtsdT.logger).log("login-state", "Login complete");
    },
    "LOGIN_MODAL -> NOT_LOGGED_IN": ()=>{
        // Removes the query parameters when the login modal is closed
        $1e6a9b6349a164eb$var$dropQueryParameter("newaccount");
        $1e6a9b6349a164eb$var$dropQueryParameter("showlogin");
        (0, $bcbvQ.default).clearResetPassword();
    },
    "LOGGED_IN -> NOT_LOGGED_IN": ()=>{
        (0, $bcbvQ.default).logout();
        (0, $iJEB8.clearAllCompanySpecificStoreData)();
        $1e6a9b6349a164eb$var$openLoginModalIfNeeded();
        (0, $f2Bp8.setOrderTypeInStorage)(undefined);
    },
    "LOGGED_IN -> FORCED_LOGOUT": ()=>{
        (0, $bcbvQ.default).logout();
        (0, $iJEB8.clearAllCompanySpecificStoreData)();
        (0, $f2Bp8.setOrderTypeInStorage)(undefined);
    },
    "COMPANY_SELECTION -> NOT_LOGGED_IN": ()=>{
        (0, $bcbvQ.default).logout();
        (0, $iJEB8.clearAllCompanySpecificStoreData)();
    },
    "COMPANY_SELECTION -> COMPANY_SELECTED": ()=>{
        (0, $f2Bp8.setOrderTypeInStorage)(undefined);
        (0, $iJEB8.clearAllCompanySpecificStoreData)();
    }
};
const $1e6a9b6349a164eb$var$getTransitionName = (from, to)=>`${from} -> ${to}`;
const $1e6a9b6349a164eb$var$loginState = (0, $Kk7R3.makeAutoObservable)({
    currentState: "START_UP",
    transitionTo (newState) {
        if (!$1e6a9b6349a164eb$var$legalTransitions[$1e6a9b6349a164eb$var$loginState.currentState].includes(newState)) {
            (0, $gtsdT.logger).error("login-state", `Illegal state transition from ${$1e6a9b6349a164eb$var$loginState.currentState} to ${newState}`);
            throw new Error(`Illegal state transition from ${$1e6a9b6349a164eb$var$loginState.currentState} to ${newState}`);
        }
        const transitionName = $1e6a9b6349a164eb$var$getTransitionName($1e6a9b6349a164eb$var$loginState.currentState, newState);
        (0, $gtsdT.logger).log("login-state", `Transitioning ${transitionName}`);
        $1e6a9b6349a164eb$var$loginState.currentState = newState;
        if ($1e6a9b6349a164eb$var$transitionSideEffects[transitionName]) {
            (0, $gtsdT.logger).log("login-state", `Executing side effect for ${transitionName}`);
            $1e6a9b6349a164eb$var$transitionSideEffects[transitionName]();
        }
    },
    transitionToIfPossible: (newState)=>{
        if ($1e6a9b6349a164eb$var$legalTransitions[$1e6a9b6349a164eb$var$loginState.currentState].includes(newState)) $1e6a9b6349a164eb$var$loginState.transitionTo(newState);
    },
    is (state) {
        return $1e6a9b6349a164eb$var$loginState.currentState === state;
    },
    isLoggingIn: ()=>{
        const loggingInStates = [
            "VERIFY_SESSION",
            "LOGGING_IN",
            "COMPANY_SELECTION",
            "COMPANY_SELECTED",
            "FEATURES_LOADING",
            "DELIVERY_DATES_LOADING",
            "ASSORTMENT_LOADING",
            "NOTIFICATIONS_LOADING"
        ];
        return loggingInStates.some((state)=>$1e6a9b6349a164eb$var$loginState.is(state));
    }
});
var $1e6a9b6349a164eb$export$2e2bcd8739ae039 = $1e6a9b6349a164eb$var$loginState;

});
parcelRegister("7nQ1B", function(module, exports) {

$parcel$export(module.exports, "useSearch", function () { return $56030970f35316eb$export$bd221a7c56b93941; });
$parcel$export(module.exports, "navigate", function () { return $56030970f35316eb$export$ff7962acd6052c28; });
$parcel$export(module.exports, "useBrowserLocation", function () { return $56030970f35316eb$export$29c60f5332583; });
parcelRequire("fqosc");
var $2KJJ2 = parcelRequire("2KJJ2");
/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const $56030970f35316eb$var$eventPopstate = "popstate";
const $56030970f35316eb$var$eventPushState = "pushState";
const $56030970f35316eb$var$eventReplaceState = "replaceState";
const $56030970f35316eb$var$eventHashchange = "hashchange";
const $56030970f35316eb$var$events = [
    $56030970f35316eb$var$eventPopstate,
    $56030970f35316eb$var$eventPushState,
    $56030970f35316eb$var$eventReplaceState,
    $56030970f35316eb$var$eventHashchange
];
const $56030970f35316eb$var$subscribeToLocationUpdates = (callback)=>{
    for (const event of $56030970f35316eb$var$events)addEventListener(event, callback);
    return ()=>{
        for (const event of $56030970f35316eb$var$events)removeEventListener(event, callback);
    };
};
const $56030970f35316eb$export$3a1ff78c39f8a86 = (fn, ssrFn)=>(0, $2KJJ2.useSyncExternalStore)($56030970f35316eb$var$subscribeToLocationUpdates, fn, ssrFn);
const $56030970f35316eb$var$currentSearch = ()=>location.search;
const $56030970f35316eb$export$bd221a7c56b93941 = ({ ssrSearch: ssrSearch = "" } = {})=>$56030970f35316eb$export$3a1ff78c39f8a86($56030970f35316eb$var$currentSearch, ()=>ssrSearch);
const $56030970f35316eb$var$currentPathname = ()=>location.pathname;
const $56030970f35316eb$export$2a28ef6a9fe822a4 = ({ ssrPath: ssrPath } = {})=>$56030970f35316eb$export$3a1ff78c39f8a86($56030970f35316eb$var$currentPathname, ssrPath ? ()=>ssrPath : $56030970f35316eb$var$currentPathname);
const $56030970f35316eb$var$currentHistoryState = ()=>history.state;
const $56030970f35316eb$export$3ba9310fb9209e7f = ()=>$56030970f35316eb$export$3a1ff78c39f8a86($56030970f35316eb$var$currentHistoryState, ()=>null);
const $56030970f35316eb$export$ff7962acd6052c28 = (to, { replace: replace = false, state: state = null } = {})=>history[replace ? $56030970f35316eb$var$eventReplaceState : $56030970f35316eb$var$eventPushState](state, "", to);
// the 2nd argument of the `useBrowserLocation` return value is a function
// that allows to perform a navigation.
const $56030970f35316eb$export$29c60f5332583 = (opts = {})=>[
        $56030970f35316eb$export$2a28ef6a9fe822a4(opts),
        $56030970f35316eb$export$ff7962acd6052c28
    ];
const $56030970f35316eb$var$patchKey = Symbol.for("wouter_v3");
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined" && typeof window[$56030970f35316eb$var$patchKey] === "undefined") {
    for (const type of [
        $56030970f35316eb$var$eventPushState,
        $56030970f35316eb$var$eventReplaceState
    ]){
        const original = history[type];
        // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
        // however that will require an additional peer dependency on react-dom.
        // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
        history[type] = function() {
            const result = original.apply(this, arguments);
            const event = new Event(type);
            event.arguments = arguments;
            dispatchEvent(event);
            return result;
        };
    }
    // patch history object only once
    // See: https://github.com/molefrog/wouter/issues/167
    Object.defineProperty(window, $56030970f35316eb$var$patchKey, {
        value: true
    });
}

});
parcelRegister("fqosc", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $b3ac40bb9770d8de$export$700979bc83e7db82; });
$parcel$export(module.exports, "useEvent", function () { return $b3ac40bb9770d8de$export$90fc3a17d93f704c; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("dvPqk")).Fragment; });
$parcel$export(module.exports, "cloneElement", function () { return (parcelRequire("dvPqk")).cloneElement; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("dvPqk")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("dvPqk")).createElement; });
$parcel$export(module.exports, "forwardRef", function () { return (parcelRequire("dvPqk")).forwardRef; });
$parcel$export(module.exports, "isValidElement", function () { return (parcelRequire("dvPqk")).isValidElement; });
$parcel$export(module.exports, "useContext", function () { return (parcelRequire("dvPqk")).useContext; });
$parcel$export(module.exports, "useMemo", function () { return (parcelRequire("dvPqk")).useMemo; });
$parcel$export(module.exports, "useRef", function () { return (parcelRequire("dvPqk")).useRef; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return (parcelRequire("2KJJ2")).useSyncExternalStore; });

var $dvPqk = parcelRequire("dvPqk");

var $2KJJ2 = parcelRequire("2KJJ2");
// React.useInsertionEffect is not available in React <18
// This hack fixes a transpilation issue on some apps
const $b3ac40bb9770d8de$var$useBuiltinInsertionEffect = $dvPqk.useInsertionEffect;
// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const $b3ac40bb9770d8de$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
// Copied from:
// https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.ts
// "React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser."
const $b3ac40bb9770d8de$export$700979bc83e7db82 = $b3ac40bb9770d8de$var$canUseDOM ? $dvPqk.useLayoutEffect : $dvPqk.useEffect;
// useInsertionEffect is already a noop on the server.
// See: https://github.com/facebook/react/blob/main/packages/react-server/src/ReactFizzHooks.js
const $b3ac40bb9770d8de$export$aaabe4eda9ed9969 = $b3ac40bb9770d8de$var$useBuiltinInsertionEffect || $b3ac40bb9770d8de$export$700979bc83e7db82;
// Userland polyfill while we wait for the forthcoming
// https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
// Note: "A high-fidelity polyfill for useEvent is not possible because
// there is no lifecycle or Hook in React that we can use to switch
// .current at the right timing."
// So we will have to make do with this "close enough" approach for now.
const $b3ac40bb9770d8de$export$90fc3a17d93f704c = (fn)=>{
    const ref = $dvPqk.useRef([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    // Per Dan Abramov: useInsertionEffect executes marginally closer to the
    // correct timing for ref synchronization than useLayoutEffect on React 18.
    // See: https://github.com/facebook/react/pull/25881#issuecomment-1356244360
    $b3ac40bb9770d8de$export$aaabe4eda9ed9969(()=>{
        ref[0] = fn;
    });
    return ref[1];
};

});
parcelRegister("2KJJ2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4NBtC"));

});
parcelRegister("4NBtC", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $37e8cf1cb1ec6cec$export$306c0aa65ff9ec16; }, function (v) { return $37e8cf1cb1ec6cec$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $37e8cf1cb1ec6cec$export$306c0aa65ff9ec16;
"use strict";

var $dvPqk = parcelRequire("dvPqk");
function $37e8cf1cb1ec6cec$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $37e8cf1cb1ec6cec$var$objectIs = "function" === typeof Object.is ? Object.is : $37e8cf1cb1ec6cec$var$is, $37e8cf1cb1ec6cec$var$useState = $dvPqk.useState, $37e8cf1cb1ec6cec$var$useEffect = $dvPqk.useEffect, $37e8cf1cb1ec6cec$var$useLayoutEffect = $dvPqk.useLayoutEffect, $37e8cf1cb1ec6cec$var$useDebugValue = $dvPqk.useDebugValue;
function $37e8cf1cb1ec6cec$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $37e8cf1cb1ec6cec$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $37e8cf1cb1ec6cec$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $37e8cf1cb1ec6cec$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $37e8cf1cb1ec6cec$var$useEffect(function() {
        $37e8cf1cb1ec6cec$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $37e8cf1cb1ec6cec$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $37e8cf1cb1ec6cec$var$useDebugValue(value);
    return value;
}
function $37e8cf1cb1ec6cec$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$37e8cf1cb1ec6cec$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $37e8cf1cb1ec6cec$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $37e8cf1cb1ec6cec$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $37e8cf1cb1ec6cec$var$useSyncExternalStore$1 : $37e8cf1cb1ec6cec$var$useSyncExternalStore$2;
$37e8cf1cb1ec6cec$export$306c0aa65ff9ec16 = void 0 !== $dvPqk.useSyncExternalStore ? $dvPqk.useSyncExternalStore : $37e8cf1cb1ec6cec$var$shim;

});




parcelRegister("9yKIH", function(module, exports) {

$parcel$export(module.exports, "filterHitsVisibleForSegment", function () { return $7f1f5d743b5db1c8$export$852e37fc813c768e; });
$parcel$export(module.exports, "default", function () { return $7f1f5d743b5db1c8$export$2e2bcd8739ae039; });

var $Kk7R3 = parcelRequire("Kk7R3");

var $gtsdT = parcelRequire("gtsdT");

var $fj1oy = parcelRequire("fj1oy");

var $bcbvQ = parcelRequire("bcbvQ");

var $fLkLy = parcelRequire("fLkLy");
const $7f1f5d743b5db1c8$var$getCustomerAttributes = ()=>{
    const attributes = [];
    if ((0, $bcbvQ.default).isLoggedIn()) attributes.push("loggedIn");
    if ((0, $bcbvQ.default).isPunchoutSession()) attributes.push("punchoutCustomer");
    return attributes;
};
const $7f1f5d743b5db1c8$export$852e37fc813c768e = (hits)=>hits.filter((hit)=>$7f1f5d743b5db1c8$var$segmentStore.isArticleVisible(hit.objectID));
const $7f1f5d743b5db1c8$var$segmentStore = (0, $Kk7R3.makeAutoObservable)({
    currentCustomerProperties: {
        customerNumber: [],
        chains: [],
        customerGroups: [],
        customerWarehouses: [],
        customerAttributes: []
    },
    articleSegments: {},
    currentPreviewSegment: undefined,
    isArticleVisible: (articleId)=>{
        const currentCustomerProperties = $7f1f5d743b5db1c8$var$segmentStore.currentCustomerProperties;
        const article = $7f1f5d743b5db1c8$var$segmentStore.articleSegments[articleId];
        if (!article) return false;
        return (0, $fj1oy.getEntryVisibility)(currentCustomerProperties, article) === "visible";
    },
    getArticleVisibility: (articleId)=>{
        const currentCustomerProperties = $7f1f5d743b5db1c8$var$segmentStore.currentCustomerProperties;
        const article = $7f1f5d743b5db1c8$var$segmentStore.articleSegments[articleId];
        if (!article) return "hidden";
        return (0, $fj1oy.getEntryVisibility)(currentCustomerProperties, article);
    },
    updateCurrentCustomerProperties: ()=>{
        const company = (0, $bcbvQ.default).getCurrentCompany();
        if (!company) return;
        $7f1f5d743b5db1c8$var$segmentStore.currentCustomerProperties = {
            customerNumber: [
                company.customerNumber
            ],
            chains: [
                (0, $fj1oy.keepIdOnly)(company.businessLevels.level1),
                (0, $fj1oy.keepIdOnly)(company.businessLevels.level2),
                (0, $fj1oy.keepIdOnly)(company.businessLevels.level3),
                (0, $fj1oy.keepIdOnly)(company.businessLevels.level4)
            ],
            customerGroups: [
                (0, $fj1oy.keepIdOnly)(company.customerGroup)
            ],
            customerWarehouses: [
                (0, $fj1oy.keepIdOnly)(company.warehouse || "")
            ],
            customerAttributes: $7f1f5d743b5db1c8$var$getCustomerAttributes()
        };
        (0, $gtsdT.logger).log("contentful", "The current customer properties are: ", $7f1f5d743b5db1c8$var$segmentStore.currentCustomerProperties);
    },
    updateCurrentPreviewSegmentProperties: ()=>{
        const previewSegment = $7f1f5d743b5db1c8$var$segmentStore.currentPreviewSegment;
        $7f1f5d743b5db1c8$var$segmentStore.currentCustomerProperties = {
            customerNumber: previewSegment?.customerNumber ? [
                previewSegment.customerNumber
            ] : [],
            chains: previewSegment?.chain ? [
                previewSegment?.chain
            ] : [],
            customerGroups: previewSegment?.customerGroup ? [
                previewSegment?.customerGroup
            ] : [],
            customerWarehouses: previewSegment?.customerWarehouse ? [
                previewSegment?.customerWarehouse
            ] : [],
            customerAttributes: (0, $fLkLy.getPreviewSegmentAttributes)($7f1f5d743b5db1c8$var$segmentStore.currentPreviewSegment?.notLoggedIn, $7f1f5d743b5db1c8$var$segmentStore.currentPreviewSegment?.punchoutCustomer)
        };
        (0, $gtsdT.logger).log("contentful", "The current preview segment properties are: ", $7f1f5d743b5db1c8$var$segmentStore.currentCustomerProperties);
    },
    setArticleSegments: (articles)=>{
        for (const article of articles){
            const include = article.fields.includeSegments && (0, $fj1oy.convertEntriesToSegment)(article.fields.includeSegments);
            const exclude = article.fields.excludeSegments && (0, $fj1oy.convertEntriesToSegment)(article.fields.excludeSegments);
            $7f1f5d743b5db1c8$var$segmentStore.articleSegments[article.sys.id] = {
                include: include,
                exclude: exclude
            };
        }
    },
    updateCurrentPreviewSegment: (previewSegment)=>{
        $7f1f5d743b5db1c8$var$segmentStore.currentPreviewSegment = previewSegment;
        $7f1f5d743b5db1c8$var$segmentStore.updateCurrentPreviewSegmentProperties();
    },
    clearCompanySpecificData: ()=>{
        $7f1f5d743b5db1c8$var$segmentStore.currentCustomerProperties = {
            customerNumber: [],
            chains: [],
            customerGroups: [],
            customerWarehouses: [],
            customerAttributes: []
        };
    }
});
var $7f1f5d743b5db1c8$export$2e2bcd8739ae039 = $7f1f5d743b5db1c8$var$segmentStore;

});
parcelRegister("fLkLy", function(module, exports) {

$parcel$export(module.exports, "extractSegmentsFromContent", function () { return $4da476f303eee73e$export$65bda176a3867515; });
$parcel$export(module.exports, "getPreviewSegmentAttributes", function () { return $4da476f303eee73e$export$f102de05fc213d62; });
const $4da476f303eee73e$export$65bda176a3867515 = (content)=>{
    const segments = [];
    const idsSeen = new Set();
    const visited = new WeakSet();
    // biome-ignore lint/suspicious/noExplicitAny: contentful types are too complex to type here
    function traverse(content) {
        if (!content || typeof content !== "object") return;
        if (visited.has(content)) return;
        visited.add(content);
        // Look for segments
        if (content.sys?.contentType?.sys?.id === "segment" && !idsSeen.has(content.sys.id)) {
            idsSeen.add(content.sys.id);
            segments.push({
                sys: content.sys,
                fields: content.fields
            });
        }
        // Traverse arrays or objects
        if (Array.isArray(content)) content.forEach(traverse);
        else {
            for(const key in content)if (Object.hasOwn(content, key)) traverse(content[key]);
        }
    }
    traverse(content);
    return segments;
};
const $4da476f303eee73e$export$f102de05fc213d62 = (notLoggedIn, punchoutCustomer)=>{
    const attributes = [];
    if (!notLoggedIn) attributes.push("loggedIn");
    if (punchoutCustomer) attributes.push("punchoutCustomer");
    return attributes;
};

});


parcelRegister("44W8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5264cadae7c9fa62$export$2e2bcd8739ae039; });

var $2Vh19 = parcelRequire("2Vh19");

var $bVGbk = parcelRequire("bVGbk");

var $1987g = parcelRequire("1987g");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $bZiDo = parcelRequire("bZiDo");
const $5264cadae7c9fa62$var$getSkusFromRecommendation = (recommendation, type)=>{
    if (!(0, $2Vh19.default)(recommendation.suggestions, type)) return [];
    return recommendation.suggestions[type].map((suggestion)=>suggestion.sku);
};
const $5264cadae7c9fa62$var$adjustForAvailableProducts = (recommendation)=>{
    if (!recommendation) return {
        reason: "Ingen tilgjengelig anbefalinger",
        skus: [],
        producedBy: "",
        createdAt: ""
    };
    let skus = [];
    if ("suggestions" in recommendation) {
        // Handle old backend with split product suggestions
        const newProducts = (0, $bVGbk.default)((0, $bZiDo.default).assortment, $5264cadae7c9fa62$var$getSkusFromRecommendation(recommendation, "Nyhet"));
        const focusProducts = (0, $bVGbk.default)((0, $bZiDo.default).assortment, $5264cadae7c9fa62$var$getSkusFromRecommendation(recommendation, "Fokus"));
        const normalProducts = (0, $bVGbk.default)((0, $bZiDo.default).assortment, $5264cadae7c9fa62$var$getSkusFromRecommendation(recommendation, "Fordelingsn\xf8kkel"));
        const newProductsCount = Math.min(1, newProducts.length);
        const focusProductsCount = Math.min(2, focusProducts.length);
        const normalProductsCount = Math.min(6 - newProductsCount - focusProductsCount);
        (0, $gtsdT.logger).log("recommendations", `Using ${newProductsCount} new products, ${focusProductsCount} focus products and ${normalProductsCount} other products`);
        skus = [
            ...(0, $1987g.default)(normalProducts, normalProductsCount),
            ...(0, $1987g.default)(focusProducts, focusProductsCount),
            ...(0, $1987g.default)(newProducts, newProductsCount)
        ].map((sku)=>({
                sku: sku,
                confidence: 1
            }));
    } else // Handle new backend, with combined product suggestions and intergrated confidence
    skus = recommendation.skus;
    return {
        reason: recommendation.reason,
        skus: skus,
        producedBy: recommendation.producedBy,
        createdAt: recommendation.createdAt
    };
};
const $5264cadae7c9fa62$var$recommendationStore = (0, $Kk7R3.makeAutoObservable)({
    recommendations: (0, $duLFK.initializeWithDefaultData)(null),
    contractualRecommendations: (0, $duLFK.initializeWithDefaultData)(null),
    getRecommendations: ()=>{
        const abortController = (0, $duLFK.setAsWaitingForData)($5264cadae7c9fa62$var$recommendationStore.recommendations);
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/recommend/ml001/${customerNumber}`, (0, $bcbvQ.default).getSessionToken()).signal(abortController).get().json(async (res)=>{
            (0, $duLFK.setAsDataAvailable)($5264cadae7c9fa62$var$recommendationStore.recommendations, {
                AI1: $5264cadae7c9fa62$var$adjustForAvailableProducts(res.AI1),
                AI2: $5264cadae7c9fa62$var$adjustForAvailableProducts(res.AI2),
                AI3: $5264cadae7c9fa62$var$adjustForAvailableProducts(res.AI3)
            });
            (0, $gtsdT.logger).log("recommendations", "Custom Recommendations loaded", $5264cadae7c9fa62$var$recommendationStore.recommendations.data);
        }).catch((err)=>{
            if (!(0, $duLFK.isAbortError)(err)) {
                (0, $gtsdT.logger).warn("recommendations", "Unable to load recommendations: ", err.message);
                (0, $duLFK.setAsErrorOccured)($5264cadae7c9fa62$var$recommendationStore.recommendations, `${err}`);
            }
        });
    },
    sendRecommendationFeedback: (serviceId, sku, action)=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        (0, $gtsdT.logger).log("recommendations", `Sending feedback for recommendation service ${serviceId} ${action} with SKU ${sku}`);
        (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/recommend/${customerNumber}`, (0, $bcbvQ.default).getSessionToken()).query({
            serviceId: serviceId,
            sku: sku,
            action: action
        }).post().json();
    },
    getContractualRecommendations: ()=>{
        const abortController = (0, $duLFK.setAsWaitingForData)($5264cadae7c9fa62$var$recommendationStore.contractualRecommendations);
        const m3CompanyNumber = (0, $isIf6.default).m3CompanyNumber;
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/recommend/contractual/${m3CompanyNumber}/${customerNumber}`, (0, $bcbvQ.default).getSessionToken()).signal(abortController).get().json(async (res)=>{
            (0, $duLFK.setAsDataAvailable)($5264cadae7c9fa62$var$recommendationStore.contractualRecommendations, res);
            (0, $gtsdT.logger).log("recommendations", "Contractual Recommendations loaded", $5264cadae7c9fa62$var$recommendationStore.contractualRecommendations.data);
        }).catch((err)=>{
            if (!(0, $duLFK.isAbortError)(err)) {
                (0, $gtsdT.logger).warn("recommendations", "Unable to load contractual recommendations: ", err.message);
                (0, $duLFK.setAsErrorOccured)($5264cadae7c9fa62$var$recommendationStore.contractualRecommendations, `${err}`);
            }
        });
    },
    clearCompanySpecificData: ()=>{
        $5264cadae7c9fa62$var$recommendationStore.recommendations = (0, $duLFK.initializeWithDefaultData)(null);
    }
});
var $5264cadae7c9fa62$export$2e2bcd8739ae039 = $5264cadae7c9fa62$var$recommendationStore;

});
parcelRegister("1987g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d5ced6ea1c2ef97$export$2e2bcd8739ae039; });

var $awSUU = parcelRequire("awSUU");

var $4sQKr = parcelRequire("4sQKr");
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */ function $0d5ced6ea1c2ef97$var$take(array, n, guard) {
    if (!(array && array.length)) return [];
    n = guard || n === undefined ? 1 : (0, $4sQKr.default)(n);
    return (0, $awSUU.default)(array, 0, n < 0 ? 0 : n);
}
var $0d5ced6ea1c2ef97$export$2e2bcd8739ae039 = $0d5ced6ea1c2ef97$var$take;

});

parcelRegister("bZiDo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f05cce4e4f8c0319$export$2e2bcd8739ae039; });

var $wZWxe = parcelRequire("wZWxe");

var $jf2w9 = parcelRequire("jf2w9");

var $ioVMT = parcelRequire("ioVMT");

var $bVGbk = parcelRequire("bVGbk");

var $hCd6c = parcelRequire("hCd6c");

var $bEEBX = parcelRequire("bEEBX");

var $3xOZa = parcelRequire("3xOZa");

var $kalVm = parcelRequire("kalVm");

var $jQCqo = parcelRequire("jQCqo");

var $hQjjC = parcelRequire("hQjjC");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $Z5T7p = parcelRequire("Z5T7p");

var $5OqMf = parcelRequire("5OqMf");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $f2Bp8 = parcelRequire("f2Bp8");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $25aT1 = parcelRequire("25aT1");

var $9Vhxl = parcelRequire("9Vhxl");

var $biFcX = parcelRequire("biFcX");

var $a2SqC = parcelRequire("a2SqC");

var $luszM = parcelRequire("luszM");
const $f05cce4e4f8c0319$var$enhanceProduct = (product)=>{
    const enhancedProduct = (0, $isIf6.default).enhanceProduct(product);
    enhancedProduct.name = (0, $luszM.fixDanglingUnits)(enhancedProduct.name)?.replace(/1\/2/g, "\xbd")?.replace(/1\/4/g, "\xbc")?.replace(/1\/3/g, "\u2153");
    return {
        ...enhancedProduct,
        badges: (0, $luszM.mapBadges)(product),
        labels: (0, $luszM.mapLabels)(product)
    };
};
const $f05cce4e4f8c0319$var$productStore = (0, $Kk7R3.makeAutoObservable)({
    products: [],
    productsLoaded: false,
    guestAssortment: [],
    assortment: (0, $f2Bp8.getAssortmentFromStorage)(),
    assortmentCache: {},
    favorites: [],
    activeFilters: {},
    stockLevels: {},
    replacementProducts: [],
    newProductSkus: [],
    addFilterValue: (field, value)=>{
        if ((0, $3xOZa.default)($f05cce4e4f8c0319$var$productStore.activeFilters[field])) {
            $f05cce4e4f8c0319$var$productStore.activeFilters[field] = [
                value
            ];
            $f05cce4e4f8c0319$var$productStore.activeFilters = {
                ...$f05cce4e4f8c0319$var$productStore.activeFilters
            };
        } else {
            if ($f05cce4e4f8c0319$var$productStore.activeFilters[field].includes(value)) return;
            $f05cce4e4f8c0319$var$productStore.activeFilters[field] = [
                ...$f05cce4e4f8c0319$var$productStore.activeFilters[field],
                value
            ];
        }
    },
    removeFilterValue: (field, value)=>{
        if ((0, $3xOZa.default)($f05cce4e4f8c0319$var$productStore.activeFilters[field])) return;
        (0, $kalVm.default)($f05cce4e4f8c0319$var$productStore.activeFilters[field], value);
        if ($f05cce4e4f8c0319$var$productStore.activeFilters[field].length === 0) (0, $hQjjC.default)($f05cce4e4f8c0319$var$productStore.activeFilters, field);
        $f05cce4e4f8c0319$var$productStore.activeFilters = {
            ...$f05cce4e4f8c0319$var$productStore.activeFilters
        };
    },
    isFilterActive: (field, value)=>{
        if ((0, $3xOZa.default)($f05cce4e4f8c0319$var$productStore.activeFilters[field])) return false;
        return (0, $ioVMT.default)($f05cce4e4f8c0319$var$productStore.activeFilters[field], value);
    },
    filterWithActiveFilters: (products)=>{
        return products.filter((p)=>(0, $luszM.matchesFilter)(p, $f05cce4e4f8c0319$var$productStore.activeFilters));
    },
    clearFilter: ()=>{
        $f05cce4e4f8c0319$var$productStore.activeFilters = {};
    },
    clearFilterFields: (fields)=>{
        for (const field of fields)(0, $hQjjC.default)($f05cce4e4f8c0319$var$productStore.activeFilters, field);
        $f05cce4e4f8c0319$var$productStore.activeFilters = {
            ...$f05cce4e4f8c0319$var$productStore.activeFilters
        };
    },
    checkStockForSkus: async (skus)=>{
        if (!skus.length) return {};
        const params = {
            customerNumber: (0, $bcbvQ.default).currentCompany,
            m3OrderType: (0, $76PCP.default).orderType,
            requestedDeliveryDate: (0, $4udGV.formatM3Date)((0, $9Vhxl.default).getCurrentDelivery()?.date),
            products: skus.map((sku)=>`${sku}*10`).join("|")
        };
        try {
            const resp = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/productAvailability`, (0, $bcbvQ.default).getSessionToken()).query(params).get().json();
            return resp.map((item)=>({
                    [item.productNumber]: item.availableQuantity || 0
                })).reduce((0, $5OqMf.accumulate), {});
        } catch (_err) {
            return {};
        }
    },
    checkStockForSku: async (sku)=>{
        if (!(0, $3xOZa.default)($f05cce4e4f8c0319$var$productStore.stockLevels[sku])) {
            (0, $gtsdT.logger).log("products", `Already cached. Not going to do stock check for SKU ${sku}`);
            return;
        }
        const params = {
            customerNumber: (0, $bcbvQ.default).currentCompany,
            m3OrderType: (0, $76PCP.default).orderType,
            requestedDeliveryDate: (0, $4udGV.formatM3Date)((0, $9Vhxl.default).getCurrentDelivery()?.date),
            products: `${sku}*10`
        };
        $f05cce4e4f8c0319$var$productStore.stockLevels[sku] = (0, $duLFK.initializeWithDefaultData)(null);
        (0, $duLFK.setAsLoading)($f05cce4e4f8c0319$var$productStore.stockLevels[sku]);
        try {
            const resp = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/productAvailability`, (0, $bcbvQ.default).getSessionToken()).query(params).get().json();
            if (!(0, $bEEBX.default)(resp[0]?.availableQuantity)) (0, $duLFK.setAsDataAvailable)($f05cce4e4f8c0319$var$productStore.stockLevels[sku], resp[0].availableQuantity);
        } catch (_err) {
            // Set it to 15 to avoid showing errors on page if the call fails, lets call it an optimistic failure
            (0, $duLFK.setAsDataAvailable)($f05cce4e4f8c0319$var$productStore.stockLevels[sku], 15);
        }
    },
    inAssortment: (sku)=>{
        return (0, $ioVMT.default)($f05cce4e4f8c0319$var$productStore.assortment, sku);
    },
    replacementFor: (oldSku)=>{
        const newSkuString = $f05cce4e4f8c0319$var$productStore.replacementProducts.find((replacement)=>replacement.oldSku === oldSku)?.newSku;
        const newSkus = newSkuString && newSkuString.length > 1 ? newSkuString.split(",") : [];
        return newSkus?.length === 1 ? newSkus[0] : undefined;
    },
    resolveSkus: (skus, onlyInAssortment = true)=>{
        if (!(0, $hCd6c.default)(skus) || skus.length === 0) return [];
        const replaced = $f05cce4e4f8c0319$var$productStore.replacementProducts.map((rp)=>rp.oldSku);
        const allowed = [
            ...$f05cce4e4f8c0319$var$productStore.assortment,
            ...replaced
        ];
        const visibleRequestedSkus = onlyInAssortment ? (0, $bVGbk.default)(skus, allowed) : skus;
        const products = $f05cce4e4f8c0319$var$productStore.products.filter((p)=>(0, $ioVMT.default)(visibleRequestedSkus, p.sku));
        return (0, $jQCqo.default)(products, (p)=>skus.indexOf(p.sku));
    },
    resolveSku: (sku)=>{
        if ((0, $bEEBX.default)(sku)) return undefined;
        const p = (0, $jf2w9.default)($f05cce4e4f8c0319$var$productStore.products, {
            sku: sku
        });
        if (!(0, $3xOZa.default)(p) && !$f05cce4e4f8c0319$var$productStore.inAssortment(p.sku)) {
            const newSku = $f05cce4e4f8c0319$var$productStore.replacementFor(p.sku);
            if (newSku) return p;
            return undefined;
        }
        return p;
    },
    findProductsByEAN: (ean)=>{
        return $f05cce4e4f8c0319$var$productStore.products.filter((p)=>$f05cce4e4f8c0319$var$productStore.inAssortment(p.sku) && p.eans).filter((p)=>p.eans.some((e)=>e.code === ean));
    },
    findProductByUrlKey: (urlKey)=>{
        return $f05cce4e4f8c0319$var$productStore.products.find((p)=>p.url_key === urlKey);
    },
    fillStore: async ()=>{
        const productDataUrl = `${(0, $8ZCSm.STATICDATA_HOST)}/products.${(0, $8ZCSm.ENV_NAME)}_${(0, $a2SqC.default).dataVersion}.json`;
        (0, $gtsdT.logger).log("products", `Fetching products from ${productDataUrl}`);
        const productDataPromise = (0, $3Y1Wx.apiClient)(productDataUrl).get().json((0, $Kk7R3.action)((res)=>{
            $f05cce4e4f8c0319$var$productStore.products = res.map((p)=>$f05cce4e4f8c0319$var$enhanceProduct(p));
            $f05cce4e4f8c0319$var$productStore.newProductSkus = $f05cce4e4f8c0319$var$productStore.products.filter((p)=>(0, $luszM.isNewProduct)(p)).map((p)=>p.sku);
            $f05cce4e4f8c0319$var$productStore.productsLoaded = true;
            (0, $gtsdT.logger).log("products", `Products loaded: ${$f05cce4e4f8c0319$var$productStore.products.length}`);
            return;
        })).catch((err)=>{
            (0, $gtsdT.logger).error("products", `Error loading products: ${err}`);
            return;
        });
        const guestAssortmentUrl = `${(0, $8ZCSm.STATICDATA_HOST)}/guest-assortment.${(0, $8ZCSm.ENV_NAME)}_${(0, $a2SqC.default).dataVersion}.json`;
        (0, $gtsdT.logger).log("products", `Fetching guest assortment from ${guestAssortmentUrl}`);
        const guestAssortmentPromise = (0, $3Y1Wx.apiClient)(guestAssortmentUrl).get().json((0, $Kk7R3.action)((res)=>{
            $f05cce4e4f8c0319$var$productStore.guestAssortment = res;
            (0, $gtsdT.logger).log("products", `Guest assortment loaded: ${$f05cce4e4f8c0319$var$productStore.guestAssortment.length}`);
            return undefined;
        })).catch((err)=>{
            (0, $gtsdT.logger).error("products", `Error loading guest assortment: ${err}`);
            return;
        });
        // If anyone waits for this, they have to wait until both promises are resolved.
        return Promise.all([
            guestAssortmentPromise,
            productDataPromise
        ]).then(()=>{
            return;
        });
    },
    // We fake the object format for each product since we are just resetting old logged in info
    loadGuestAssortment: ()=>{
        const fakeAssortmentResult = $f05cce4e4f8c0319$var$productStore.guestAssortment.map((sku)=>({
                itemId: sku,
                inAgreementAssortment: false,
                dpakPrice: null,
                dpakPriceBeforeDiscount: null,
                comparisonPrice: null,
                comparisonPriceUnit: null
            }));
        $f05cce4e4f8c0319$var$productStore.setNewAssortment(fakeAssortmentResult, true);
        (0, $25aT1.default).updateCategorySkus();
    },
    getUrl: (product)=>{
        return `/produkt/${product.url_key}.html`;
    },
    getAssortment: async (customerNumber, date, orderType)=>{
        if ((0, $bEEBX.default)(customerNumber)) return Promise.reject("No customer number given for assortment");
        if ((0, $bEEBX.default)(date)) return Promise.reject("No date specified for assortment");
        if ((0, $bEEBX.default)(orderType)) return Promise.reject("No order type specified for assortment");
        (0, $gtsdT.logger).log("products", `Fetching assortment for ${customerNumber} on ${date} for order type ${orderType}`);
        let assortment;
        const m3Date = (0, $4udGV.formatM3Date)(date);
        const cache = $f05cce4e4f8c0319$var$productStore.assortmentCache;
        const cachedAssortment = cache[customerNumber]?.[orderType]?.[m3Date];
        if (cachedAssortment) {
            $f05cce4e4f8c0319$var$productStore.setNewAssortment(cachedAssortment);
            return;
        }
        try {
            assortment = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}assortment`, (0, $bcbvQ.default).getSessionToken()).query({
                CONO: (0, $isIf6.default).m3CompanyNumber,
                CUNO: customerNumber,
                DIVI: (0, $isIf6.default).m3DivisionNumber,
                UNIT: "BOTH",
                ORTP: orderType,
                DATE: m3Date
            }).get().json();
            if ("error" in assortment) throw new (0, $aMYzM.BackendIssueError)("Unable to load assortment, error from backend");
            await $f05cce4e4f8c0319$var$productStore.getReplacements(assortment.map((a)=>a.itemId));
        } catch (err) {
            (0, $gtsdT.logger).warn("products", `Unable to fetch assortment - ${err}`);
            throw err;
        }
        (0, $Kk7R3.runInAction)(()=>{
            (0, $wZWxe.default)(cache, [
                customerNumber,
                orderType,
                m3Date
            ], assortment);
            (0, $gtsdT.logger).log("products", `Loaded assortment info with ${assortment.length} items`);
            $f05cce4e4f8c0319$var$productStore.setNewAssortment(assortment);
            $f05cce4e4f8c0319$var$productStore.applyReplacementsAndLabels();
        });
    },
    setNewAssortment: (assortment, isGuestAssortment = false)=>{
        const canBuySingleItems = (0, $biFcX.default).hasCustomerFeature((0, $Z5T7p.FEATURE_NAME).canBuySingleItems);
        const filteredAssortment = isGuestAssortment ? assortment : assortment.filter((p)=>!(0, $bEEBX.default)(p.dpakPrice));
        $f05cce4e4f8c0319$var$productStore.assortment = filteredAssortment.map((p)=>p.itemId);
        for (const ap of assortment){
            const p = $f05cce4e4f8c0319$var$productStore.resolveSku(ap.itemId);
            if (!(0, $3xOZa.default)(p)) {
                if (p.buyableInBaseUnit && canBuySingleItems) {
                    p.price = ap.fpakPrice ?? null;
                    p.unit = p.baseUnit;
                } else {
                    p.price = ap.dpakPrice;
                    p.unit = p.salesUnit;
                }
                p.priceBeforeDiscount = ap.dpakPriceBeforeDiscount;
                p.inAgreementAssortment = ap.inAgreementAssortment;
                p.comparisonPrice = ap.comparisonPrice;
                p.comparisonUnit = ap.comparisonPriceUnit;
                p.vatRate = ap.VAT ?? null;
            }
        }
        (0, $25aT1.default).hideEmptyCategories();
    },
    // Replacement products only contain products the customer no longer have access to. This logic is inside the PWA Proxy backend call.
    applyReplacementsAndLabels: ()=>{
        for (const replacementProduct of $f05cce4e4f8c0319$var$productStore.replacementProducts){
            const oldProduct = $f05cce4e4f8c0319$var$productStore.products.find((p)=>p.sku === replacementProduct.oldSku);
            if (oldProduct) {
                oldProduct.expired = true;
                oldProduct.newSkus = replacementProduct.newSku !== "" ? replacementProduct.newSku.split(",") : [];
            }
        }
        for (const p of $f05cce4e4f8c0319$var$productStore.products)p.labels = (0, $luszM.mapLabels)(p);
    },
    getReplacements: async (assortment)=>{
        const replacementProducts = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/replacementproducts/${(0, $isIf6.default).storeId}?returnAll=true`, (0, $bcbvQ.default).getSessionToken()).post(assortment).json();
        (0, $Kk7R3.runInAction)(()=>{
            $f05cce4e4f8c0319$var$productStore.replacementProducts = replacementProducts;
        });
    },
    clearCompanySpecificData () {
        $f05cce4e4f8c0319$var$productStore.loadGuestAssortment();
    }
});
(0, $Kk7R3.autorun)(()=>(0, $f2Bp8.setAssortmentInStorage)($f05cce4e4f8c0319$var$productStore.assortment));
(0, $Kk7R3.autorun)(()=>{
    (0, $gtsdT.logger).log("products", "Assortment changed:", $f05cce4e4f8c0319$var$productStore.assortment);
});
var $f05cce4e4f8c0319$export$2e2bcd8739ae039 = $f05cce4e4f8c0319$var$productStore;

});
parcelRegister("wZWxe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063309e2c9aee899$export$2e2bcd8739ae039; });

var $ipHzQ = parcelRequire("ipHzQ");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $063309e2c9aee899$var$set(object, path, value) {
    return object == null ? object : (0, $ipHzQ.default)(object, path, value);
}
var $063309e2c9aee899$export$2e2bcd8739ae039 = $063309e2c9aee899$var$set;

});

parcelRegister("kalVm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eae5bf85816d39c0$export$2e2bcd8739ae039; });

var $1SdxG = parcelRequire("1SdxG");

var $b7c6Y = parcelRequire("b7c6Y");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $eae5bf85816d39c0$var$pull = (0, $1SdxG.default)((0, $b7c6Y.default));
var $eae5bf85816d39c0$export$2e2bcd8739ae039 = $eae5bf85816d39c0$var$pull;

});
parcelRegister("b7c6Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8179be4186176d05$export$2e2bcd8739ae039; });

var $foJEL = parcelRequire("foJEL");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $8179be4186176d05$var$pullAll(array, values) {
    return array && array.length && values && values.length ? (0, $foJEL.default)(array, values) : array;
}
var $8179be4186176d05$export$2e2bcd8739ae039 = $8179be4186176d05$var$pullAll;

});
parcelRegister("foJEL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b35c8354d11c8404$export$2e2bcd8739ae039; });

var $dqScn = parcelRequire("dqScn");

var $hRnoc = parcelRequire("hRnoc");

var $fHro5 = parcelRequire("fHro5");

var $j7MgO = parcelRequire("j7MgO");

var $1XCwi = parcelRequire("1XCwi");
/** Used for built-in method references. */ var $b35c8354d11c8404$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $b35c8354d11c8404$var$splice = $b35c8354d11c8404$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $b35c8354d11c8404$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? (0, $fHro5.default) : (0, $hRnoc.default), index = -1, length = values.length, seen = array;
    if (array === values) values = (0, $1XCwi.default)(values);
    if (iteratee) seen = (0, $dqScn.default)(array, (0, $j7MgO.default)(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $b35c8354d11c8404$var$splice.call(seen, fromIndex, 1);
            $b35c8354d11c8404$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
var $b35c8354d11c8404$export$2e2bcd8739ae039 = $b35c8354d11c8404$var$basePullAll;

});
parcelRegister("fHro5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6e01dc64876dd0f$export$2e2bcd8739ae039; });
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b6e01dc64876dd0f$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
var $b6e01dc64876dd0f$export$2e2bcd8739ae039 = $b6e01dc64876dd0f$var$baseIndexOfWith;

});




parcelRegister("jQCqo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e730adf95ade9a7d$export$2e2bcd8739ae039; });

var $gSJMz = parcelRequire("gSJMz");

var $cjhTv = parcelRequire("cjhTv");

var $1SdxG = parcelRequire("1SdxG");

var $e0K8B = parcelRequire("e0K8B");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $e730adf95ade9a7d$var$sortBy = (0, $1SdxG.default)(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && (0, $e0K8B.default)(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && (0, $e0K8B.default)(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return (0, $cjhTv.default)(collection, (0, $gSJMz.default)(iteratees, 1), []);
});
var $e730adf95ade9a7d$export$2e2bcd8739ae039 = $e730adf95ade9a7d$var$sortBy;

});
parcelRegister("cjhTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f6523d613543ded$export$2e2bcd8739ae039; });

var $dqScn = parcelRequire("dqScn");

var $dHL9I = parcelRequire("dHL9I");

var $aIIzU = parcelRequire("aIIzU");

var $3DdyA = parcelRequire("3DdyA");

var $cNWHL = parcelRequire("cNWHL");

var $j7MgO = parcelRequire("j7MgO");

var $848mT = parcelRequire("848mT");

var $jHP7K = parcelRequire("jHP7K");

var $hCd6c = parcelRequire("hCd6c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $8f6523d613543ded$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = (0, $dqScn.default)(iteratees, function(iteratee) {
        if ((0, $hCd6c.default)(iteratee)) return function(value) {
            return (0, $dHL9I.default)(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        (0, $jHP7K.default)
    ];
    var index = -1;
    iteratees = (0, $dqScn.default)(iteratees, (0, $j7MgO.default)((0, $aIIzU.default)));
    var result = (0, $3DdyA.default)(collection, function(value, key, collection) {
        var criteria = (0, $dqScn.default)(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return (0, $cNWHL.default)(result, function(object, other) {
        return (0, $848mT.default)(object, other, orders);
    });
}
var $8f6523d613543ded$export$2e2bcd8739ae039 = $8f6523d613543ded$var$baseOrderBy;

});
parcelRegister("3DdyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a4f87b555542012$export$2e2bcd8739ae039; });

var $7xRth = parcelRequire("7xRth");

var $7wVIe = parcelRequire("7wVIe");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2a4f87b555542012$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $7wVIe.default)(collection) ? Array(collection.length) : [];
    (0, $7xRth.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $2a4f87b555542012$export$2e2bcd8739ae039 = $2a4f87b555542012$var$baseMap;

});

parcelRegister("cNWHL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9527993a0ef897b8$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9527993a0ef897b8$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
var $9527993a0ef897b8$export$2e2bcd8739ae039 = $9527993a0ef897b8$var$baseSortBy;

});

parcelRegister("848mT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5df5303c294576d0$export$2e2bcd8739ae039; });

var $36zk3 = parcelRequire("36zk3");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $5df5303c294576d0$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = (0, $36zk3.default)(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
var $5df5303c294576d0$export$2e2bcd8739ae039 = $5df5303c294576d0$var$compareMultiple;

});
parcelRegister("36zk3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $242d54f1414e25bb$export$2e2bcd8739ae039; });

var $ebwzy = parcelRequire("ebwzy");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $242d54f1414e25bb$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = (0, $ebwzy.default)(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = (0, $ebwzy.default)(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
var $242d54f1414e25bb$export$2e2bcd8739ae039 = $242d54f1414e25bb$var$compareAscending;

});




parcelRegister("hQjjC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfd646a83a1fde83$export$2e2bcd8739ae039; });

var $lkLur = parcelRequire("lkLur");
/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */ function $cfd646a83a1fde83$var$unset(object, path) {
    return object == null ? true : (0, $lkLur.default)(object, path);
}
var $cfd646a83a1fde83$export$2e2bcd8739ae039 = $cfd646a83a1fde83$var$unset;

});

parcelRegister("25aT1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37eeba8ee94656da$export$2e2bcd8739ae039; });

var $ir4nw = parcelRequire("ir4nw");

var $jf2w9 = parcelRequire("jf2w9");
var $3HSZo = parcelRequire("3HSZo");
var $2Vh19 = parcelRequire("2Vh19");
var $bEEBX = parcelRequire("bEEBX");
var $42tql = parcelRequire("42tql");
var $7ysl3 = parcelRequire("7ysl3");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $fj1oy = parcelRequire("fj1oy");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $a2SqC = parcelRequire("a2SqC");

var $iPn7G = parcelRequire("iPn7G");
const $37eeba8ee94656da$var$searchClient = (0, $ir4nw.algoliasearch)((0, $isIf6.default).searchConfig.algoliaConfig.appId, (0, $isIf6.default).searchConfig.algoliaConfig.searchApiKey);
const { categorySearchIndexName: $37eeba8ee94656da$var$categorySearchIndexName } = (0, $isIf6.default).searchConfig;
const $37eeba8ee94656da$var$categoryStore = (0, $Kk7R3.makeAutoObservable)({
    menuCategories: [],
    navigationCategories: [],
    leftMenuOn: false,
    mobile: {
        visible: false,
        path: []
    },
    get categories () {
        return (0, $isIf6.default).storeId !== "tinehandel" || (0, $biFcX.default).navigationTestVariant === "megamenu" ? this.menuCategories : this.navigationCategories;
    },
    // Used for the mobile menu that slides in
    showMenu: (setTo)=>{
        $37eeba8ee94656da$var$categoryStore.mobile.visible = setTo;
    },
    addNavigationCategory: (urlKeys, name, index, skus)=>{
        const { cat1: cat1, cat2: cat2, cat3: cat3 } = urlKeys;
        const existingCategory = (0, $iPn7G.findCategory)(urlKeys, $37eeba8ee94656da$var$categoryStore.navigationCategories);
        if (existingCategory) {
            existingCategory.skus = skus;
            return;
        }
        const parentKeys = cat3 ? {
            cat1: cat1,
            cat2: cat2
        } : {
            cat1: cat1
        };
        const key = cat3 || cat2;
        const id = [
            cat1,
            cat2,
            cat3
        ].filter((key)=>key).join("/");
        if (key) {
            const category = {
                id: id,
                catId: id,
                name: name,
                url_key: key,
                fullUrl: `/${id}.html`,
                children: [],
                skus: skus
            };
            const parent = (0, $iPn7G.findCategory)(parentKeys, $37eeba8ee94656da$var$categoryStore.navigationCategories);
            if (parent) {
                parent.children.splice(index, 0, category);
                $37eeba8ee94656da$var$categoryStore.navigationCategories = [
                    ...$37eeba8ee94656da$var$categoryStore.navigationCategories
                ];
            }
        }
    },
    updateCategorySkus: async ()=>{
        if ($37eeba8ee94656da$var$categorySearchIndexName) {
            const assortment = (0, $bZiDo.default).assortment;
            const replacementProducts = (0, $bZiDo.default).replacementProducts;
            const company = (0, $bcbvQ.default).getCurrentCompany();
            const customerGroup = company ? (0, $fj1oy.keepIdOnly)(company.customerGroup) : "default";
            try {
                const skusAndPaths = await (0, $iPn7G.searchForCategoryProducts)(assortment, replacementProducts, $37eeba8ee94656da$var$searchClient, $37eeba8ee94656da$var$categorySearchIndexName, customerGroup);
                (0, $Kk7R3.runInAction)(()=>{
                    for (const category of $37eeba8ee94656da$var$categoryStore.navigationCategories)(0, $iPn7G.updateSkusForCategory)(category, skusAndPaths, (0, $bZiDo.default).newProductSkus);
                    for (const category of $37eeba8ee94656da$var$categoryStore.menuCategories)(0, $iPn7G.updateSkusForCategory)(category, skusAndPaths, (0, $bZiDo.default).newProductSkus);
                });
                (0, $gtsdT.logger).log("categories", `Found ${skusAndPaths.length} skus for categories`);
            } catch (error) {
                (0, $gtsdT.logger).error("categories", "Error updating category skus:", error);
            }
        }
    },
    findCategoryByUrlKey: (urlKeys)=>{
        const levels = [];
        let category = (0, $jf2w9.default)($37eeba8ee94656da$var$categoryStore.categories, {
            url_key: urlKeys.cat1
        });
        if ((0, $bEEBX.default)(category)) throw new (0, $aMYzM.PageNotFoundError)();
        levels.push(category);
        if ((0, $2Vh19.default)(urlKeys, "cat2")) {
            const category2 = (0, $jf2w9.default)(category.children, {
                url_key: urlKeys.cat2
            });
            if (!(0, $bEEBX.default)(category2)) {
                category = category2;
                levels.push(category2);
            } else throw new (0, $aMYzM.PageNotFoundError)();
        }
        if ((0, $2Vh19.default)(urlKeys, "cat3")) {
            const category3 = (0, $jf2w9.default)(category.children, {
                url_key: urlKeys.cat3
            });
            if (!(0, $bEEBX.default)(category3)) {
                category = category3;
                levels.push(category3);
            } else throw new (0, $aMYzM.PageNotFoundError)();
        }
        return {
            category: category,
            levels: levels
        };
    },
    findCategoryKeysBySku: (0, $7ysl3.default)((lookForSku)=>{
        return (0, $3HSZo.default)($37eeba8ee94656da$var$categoryStore.categories.map((cat)=>(0, $iPn7G.searchCategoryRescursive)(lookForSku, cat, 1))).filter((0, $42tql.default));
    }),
    hideEmptyCategories: ()=>{
        for(let i = 0; i < $37eeba8ee94656da$var$categoryStore.categories.length; i++)(0, $iPn7G.setHiddenStatus)($37eeba8ee94656da$var$categoryStore.categories[i]);
    },
    fillStore: async ()=>{
        const categoryDataUrl = `${(0, $8ZCSm.STATICDATA_HOST)}/categories.${(0, $8ZCSm.ENV_NAME)}_${(0, $a2SqC.default).dataVersion}.json`;
        const navigationCategoryDataUrl = `${(0, $8ZCSm.STATICDATA_HOST)}/navigation-categories.${(0, $8ZCSm.ENV_NAME)}_${(0, $a2SqC.default).dataVersion}.json`;
        try {
            await (0, $3Y1Wx.apiClient)(categoryDataUrl).get().json((res)=>{
                (0, $Kk7R3.runInAction)(()=>{
                    $37eeba8ee94656da$var$categoryStore.menuCategories = res;
                });
                (0, $gtsdT.logger).log("categories", `Menu Categories loaded: ${$37eeba8ee94656da$var$categoryStore.menuCategories.length} root categories`);
            });
        } catch (error) {
            (0, $gtsdT.logger).error("categories", `Error loading menu categories: ${error}`);
        }
        if ((0, $isIf6.default).storeId === "tinehandel") try {
            await (0, $3Y1Wx.apiClient)(navigationCategoryDataUrl).get().json((res)=>{
                $37eeba8ee94656da$var$categoryStore.navigationCategories = res;
                $37eeba8ee94656da$var$categoryStore.addNavigationCategory({
                    cat1: "produkter",
                    cat2: "nyheter"
                }, "Nyheter", 0, (0, $bZiDo.default).newProductSkus);
                (0, $gtsdT.logger).log("categories", `Navigation Categories loaded: ${$37eeba8ee94656da$var$categoryStore.navigationCategories.length} root categories`);
            });
        } catch (error) {
            (0, $gtsdT.logger).error("categories", `Error loading navigation categories: ${error}`);
        }
    },
    clearCompanySpecificData: ()=>{}
});
var $37eeba8ee94656da$export$2e2bcd8739ae039 = $37eeba8ee94656da$var$categoryStore;

});
parcelRegister("ir4nw", function(module, exports) {

$parcel$export(module.exports, "algoliasearch", function () { return $d6be2516bf599171$export$e63737c6f074d9d7; });

var $kd0I5 = parcelRequire("kd0I5");

var $2Z7mK = parcelRequire("2Z7mK");

var $3xdaN = parcelRequire("3xdaN");

var $51xCb = parcelRequire("51xCb");

var $2iyEF = parcelRequire("2iyEF");

var $bQt1x = parcelRequire("bQt1x");

var $kSzRf = parcelRequire("kSzRf");

var $jCVbX = parcelRequire("jCVbX");

var $5v5Tx = parcelRequire("5v5Tx");

var $bSRQm = parcelRequire("bSRQm");
var $d6be2516bf599171$var$__defProp = Object.defineProperty;
var $d6be2516bf599171$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d6be2516bf599171$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d6be2516bf599171$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d6be2516bf599171$var$__export = (target, all)=>{
    for(var name in all)$d6be2516bf599171$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d6be2516bf599171$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d6be2516bf599171$var$__getOwnPropNames(from))if (!$d6be2516bf599171$var$__hasOwnProp.call(to, key) && key !== except) $d6be2516bf599171$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d6be2516bf599171$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d6be2516bf599171$var$__reExport = (target, mod, secondTarget)=>($d6be2516bf599171$var$__copyProps(target, mod, "default"), secondTarget && $d6be2516bf599171$var$__copyProps(secondTarget, mod, "default"));
// builds/browser.ts
var $d6be2516bf599171$var$browser_exports = {};
$d6be2516bf599171$var$__export($d6be2516bf599171$var$browser_exports, {
    algoliasearch: ()=>$d6be2516bf599171$export$e63737c6f074d9d7,
    apiClientVersion: ()=>(0, $kSzRf.apiClientVersion)
});
// builds/models.ts
var $d6be2516bf599171$var$models_exports = {};
$d6be2516bf599171$var$__export($d6be2516bf599171$var$models_exports, {
    apiClientVersion: ()=>(0, $kSzRf.apiClientVersion)
});
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $kd0I5);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $2Z7mK);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $3xdaN);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $51xCb);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $2iyEF);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $bQt1x);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $kSzRf);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $jCVbX);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $5v5Tx);
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$models_exports, $bSRQm);
// builds/browser.ts
$d6be2516bf599171$var$__reExport($d6be2516bf599171$var$browser_exports, $d6be2516bf599171$var$models_exports);
function $d6be2516bf599171$export$e63737c6f074d9d7(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    const client = (0, $kSzRf.searchClient)(appId, apiKey, options);
    let ingestionTransporter;
    if (options?.transformation) {
        if (!options.transformation.region) throw new Error("`region` must be provided when leveraging the transformation pipeline");
        ingestionTransporter = (0, $jCVbX.ingestionClient)(appId, apiKey, options.transformation.region, options);
    }
    return {
        ...client,
        async saveObjectsWithTransformation ({ indexName: indexName, objects: objects, waitForTasks: waitForTasks }, requestOptions) {
            if (!ingestionTransporter) throw new Error("`transformation.region` must be provided at client instantiation before calling this method.");
            if (!options?.transformation?.region) throw new Error("`region` must be provided when leveraging the transformation pipeline");
            return ingestionTransporter.chunkedPush({
                indexName: indexName,
                objects: objects,
                action: "addObject",
                waitForTasks: waitForTasks
            }, requestOptions);
        },
        async partialUpdateObjectsWithTransformation ({ indexName: indexName, objects: objects, createIfNotExists: createIfNotExists, waitForTasks: waitForTasks }, requestOptions) {
            if (!ingestionTransporter) throw new Error("`transformation.region` must be provided at client instantiation before calling this method.");
            if (!options?.transformation?.region) throw new Error("`region` must be provided when leveraging the transformation pipeline");
            return ingestionTransporter.chunkedPush({
                indexName: indexName,
                objects: objects,
                action: createIfNotExists ? "partialUpdateObject" : "partialUpdateObjectNoCreate",
                waitForTasks: waitForTasks
            }, requestOptions);
        },
        async replaceAllObjectsWithTransformation ({ indexName: indexName, objects: objects, batchSize: batchSize, scopes: scopes }, requestOptions) {
            if (!ingestionTransporter) throw new Error("`transformation.region` must be provided at client instantiation before calling this method.");
            if (!options?.transformation?.region) throw new Error("`region` must be provided when leveraging the transformation pipeline");
            const randomSuffix = Math.floor(Math.random() * 1e6) + 1e5;
            const tmpIndexName = `${indexName}_tmp_${randomSuffix}`;
            if (scopes === void 0) scopes = [
                "settings",
                "rules",
                "synonyms"
            ];
            try {
                let copyOperationResponse = await this.operationIndex({
                    indexName: indexName,
                    operationIndexParams: {
                        operation: "copy",
                        destination: tmpIndexName,
                        scope: scopes
                    }
                }, requestOptions);
                const watchResponses = await ingestionTransporter.chunkedPush({
                    indexName: tmpIndexName,
                    objects: objects,
                    waitForTasks: true,
                    batchSize: batchSize,
                    referenceIndexName: indexName
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: copyOperationResponse.taskID
                });
                copyOperationResponse = await this.operationIndex({
                    indexName: indexName,
                    operationIndexParams: {
                        operation: "copy",
                        destination: tmpIndexName,
                        scope: scopes
                    }
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: copyOperationResponse.taskID
                });
                const moveOperationResponse = await this.operationIndex({
                    indexName: tmpIndexName,
                    operationIndexParams: {
                        operation: "move",
                        destination: indexName
                    }
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: moveOperationResponse.taskID
                });
                return {
                    copyOperationResponse: copyOperationResponse,
                    watchResponses: watchResponses,
                    moveOperationResponse: moveOperationResponse
                };
            } catch (error) {
                await this.deleteIndex({
                    indexName: tmpIndexName
                });
                throw error;
            }
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return client.transporter.algoliaAgent.value;
        },
        initAbtesting: (initOptions)=>{
            return (0, $2Z7mK.abtestingClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initAbtestingV3: (initOptions)=>{
            return (0, $kd0I5.abtestingV3Client)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initAnalytics: (initOptions)=>{
            return (0, $3xdaN.analyticsClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initIngestion: (initOptions)=>{
            return (0, $jCVbX.ingestionClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initInsights: (initOptions)=>{
            return (0, $51xCb.insightsClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initMonitoring: (initOptions = {})=>{
            return (0, $5v5Tx.monitoringClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.options);
        },
        initPersonalization: (initOptions)=>{
            return (0, $2iyEF.personalizationClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initQuerySuggestions: (initOptions)=>{
            return (0, $bQt1x.querySuggestionsClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.region, initOptions.options);
        },
        initRecommend: (initOptions = {})=>{
            return (0, $bSRQm.recommendClient)(initOptions.appId || appId, initOptions.apiKey || apiKey, initOptions.options);
        }
    };
}

});
parcelRegister("kd0I5", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $eb659288cb0e44e7$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "abtestingV3Client", function () { return $eb659288cb0e44e7$export$41c575c87be06888; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $eb659288cb0e44e7$export$ad1dfbed11feb646 = "1.1.0";
var $eb659288cb0e44e7$var$REGIONS = [
    "de",
    "us"
];
function $eb659288cb0e44e7$var$getDefaultHosts(region) {
    const url = !region ? "analytics.algolia.com" : "analytics.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $eb659288cb0e44e7$var$createAbtestingV3Client({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $eb659288cb0e44e7$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "AbtestingV3",
            version: $eb659288cb0e44e7$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Creates a new A/B test.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param addABTestsRequest - The addABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ addABTests (addABTestsRequest, requestOptions) {
            if (!addABTestsRequest) throw new Error("Parameter `addABTestsRequest` is required when calling `addABTests`.");
            if (!addABTestsRequest.name) throw new Error("Parameter `addABTestsRequest.name` is required when calling `addABTests`.");
            if (!addABTestsRequest.variants) throw new Error("Parameter `addABTestsRequest.variants` is required when calling `addABTests`.");
            if (!addABTestsRequest.metrics) throw new Error("Parameter `addABTestsRequest.metrics` is required when calling `addABTests`.");
            if (!addABTestsRequest.endAt) throw new Error("Parameter `addABTestsRequest.endAt` is required when calling `addABTests`.");
            const requestPath = "/3/abtests";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: addABTestsRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteABTest - The deleteABTest object.
     * @param deleteABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `deleteABTest`.");
            const requestPath = "/3/abtests/{id}".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Given the traffic percentage and the expected effect size, this endpoint estimates the sample size and duration of an A/B test based on historical traffic.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param estimateABTestRequest - The estimateABTestRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ estimateABTest (estimateABTestRequest, requestOptions) {
            if (!estimateABTestRequest) throw new Error("Parameter `estimateABTestRequest` is required when calling `estimateABTest`.");
            if (!estimateABTestRequest.configuration) throw new Error("Parameter `estimateABTestRequest.configuration` is required when calling `estimateABTest`.");
            if (!estimateABTestRequest.variants) throw new Error("Parameter `estimateABTestRequest.variants` is required when calling `estimateABTest`.");
            const requestPath = "/3/abtests/estimate";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: estimateABTestRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the details for an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getABTest - The getABTest object.
     * @param getABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `getABTest`.");
            const requestPath = "/3/abtests/{id}".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves timeseries for an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTimeseries - The getTimeseries object.
     * @param getTimeseries.id - Unique A/B test identifier.
     * @param getTimeseries.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTimeseries.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTimeseries.metric - List of metrics to retrieve. If not specified, all metrics are returned.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTimeseries ({ id: id, startDate: startDate, endDate: endDate, metric: metric }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `getTimeseries`.");
            const requestPath = "/3/abtests/{id}/timeseries".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (metric !== void 0) queryParameters["metric"] = metric.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists all A/B tests you configured for this application.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param listABTests - The listABTests object.
     * @param listABTests.offset - Position of the first item to return.
     * @param listABTests.limit - Number of items to return.
     * @param listABTests.indexPrefix - Index name prefix. Only A/B tests for indices starting with this string are included in the response.
     * @param listABTests.indexSuffix - Index name suffix. Only A/B tests for indices ending with this string are included in the response.
     * @param listABTests.direction - Sort order for A/B tests by start date. Use \'asc\' for ascending or \'desc\' for descending. Active A/B tests are always listed first.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listABTests ({ offset: offset, limit: limit, indexPrefix: indexPrefix, indexSuffix: indexSuffix, direction: direction } = {}, requestOptions) {
            const requestPath = "/3/abtests";
            const headers = {};
            const queryParameters = {};
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (indexPrefix !== void 0) queryParameters["indexPrefix"] = indexPrefix.toString();
            if (indexSuffix !== void 0) queryParameters["indexSuffix"] = indexSuffix.toString();
            if (direction !== void 0) queryParameters["direction"] = direction.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Schedule an A/B test to be started at a later time.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param scheduleABTestsRequest - The scheduleABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ scheduleABTest (scheduleABTestsRequest, requestOptions) {
            if (!scheduleABTestsRequest) throw new Error("Parameter `scheduleABTestsRequest` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.name) throw new Error("Parameter `scheduleABTestsRequest.name` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.variants) throw new Error("Parameter `scheduleABTestsRequest.variants` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.metrics) throw new Error("Parameter `scheduleABTestsRequest.metrics` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.scheduledAt) throw new Error("Parameter `scheduleABTestsRequest.scheduledAt` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.endAt) throw new Error("Parameter `scheduleABTestsRequest.endAt` is required when calling `scheduleABTest`.");
            const requestPath = "/3/abtests/schedule";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: scheduleABTestsRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Stops an A/B test by its ID.  You can\'t restart stopped A/B tests.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param stopABTest - The stopABTest object.
     * @param stopABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ stopABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `stopABTest`.");
            const requestPath = "/3/abtests/{id}/stop".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $eb659288cb0e44e7$export$41c575c87be06888(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (region && (typeof region !== "string" || !$eb659288cb0e44e7$var$REGIONS.includes(region))) throw new Error(`\`region\` must be one of the following: ${$eb659288cb0e44e7$var$REGIONS.join(", ")}`);
    return $eb659288cb0e44e7$var$createAbtestingV3Client({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$eb659288cb0e44e7$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});
parcelRegister("9J5i1", function(module, exports) {

$parcel$export(module.exports, "createXhrRequester", function () { return $714c6b76a05ca94d$export$2b053666affad54a; });
function $714c6b76a05ca94d$export$2b053666affad54a() {
    function r(t) {
        return new Promise((s)=>{
            let e = new XMLHttpRequest;
            e.open(t.method, t.url, !0), Object.keys(t.headers).forEach((n)=>e.setRequestHeader(n, t.headers[n]));
            let i = (n, a)=>setTimeout(()=>{
                    e.abort(), s({
                        status: 0,
                        content: a,
                        isTimedOut: !0
                    });
                }, n), u = i(t.connectTimeout, "Connection timeout"), o;
            e.onreadystatechange = ()=>{
                e.readyState > e.OPENED && o === void 0 && (clearTimeout(u), o = i(t.responseTimeout, "Socket timeout"));
            }, e.onerror = ()=>{
                e.status === 0 && (clearTimeout(u), clearTimeout(o), s({
                    content: e.responseText || "Network request failed",
                    status: e.status,
                    isTimedOut: !1
                }));
            }, e.onload = ()=>{
                clearTimeout(u), clearTimeout(o), s({
                    content: e.responseText,
                    status: e.status,
                    isTimedOut: !1
                });
            }, e.send(t.data);
        });
    }
    return {
        send: r
    };
}

});

parcelRegister("goxFl", function(module, exports) {

$parcel$export(module.exports, "createBrowserLocalStorageCache", function () { return $bef90096bd8e008d$export$ca8cae1c5b20815a; });
$parcel$export(module.exports, "createFallbackableCache", function () { return $bef90096bd8e008d$export$8637a0800116df9b; });
$parcel$export(module.exports, "createMemoryCache", function () { return $bef90096bd8e008d$export$b1fc9484ccfcd328; });
$parcel$export(module.exports, "createAuth", function () { return $bef90096bd8e008d$export$5f096e4c9da248bb; });
$parcel$export(module.exports, "createIterablePromise", function () { return $bef90096bd8e008d$export$d96db6d38a87ffce; });
$parcel$export(module.exports, "getAlgoliaAgent", function () { return $bef90096bd8e008d$export$dc28410830ce888d; });
$parcel$export(module.exports, "createNullLogger", function () { return $bef90096bd8e008d$export$6d3f4ca34494bf2d; });
$parcel$export(module.exports, "ApiError", function () { return $bef90096bd8e008d$export$f2e832acab1bdd79; });
$parcel$export(module.exports, "shuffle", function () { return $bef90096bd8e008d$export$448332262467e042; });
$parcel$export(module.exports, "createTransporter", function () { return $bef90096bd8e008d$export$9f379e42258ad245; });
// src/cache/createBrowserLocalStorageCache.ts
function $bef90096bd8e008d$export$ca8cae1c5b20815a(options) {
    let storage;
    const namespaceKey = `algolia-client-js-${options.key}`;
    function getStorage() {
        if (storage === void 0) storage = options.localStorage || window.localStorage;
        return storage;
    }
    function getNamespace() {
        return JSON.parse(getStorage().getItem(namespaceKey) || "{}");
    }
    function setNamespace(namespace) {
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
    }
    function removeOutdatedCacheItems() {
        const timeToLive = options.timeToLive ? options.timeToLive * 1e3 : null;
        const namespace = getNamespace();
        const filteredNamespaceWithoutOldFormattedCacheItems = Object.fromEntries(Object.entries(namespace).filter(([, cacheItem])=>{
            return cacheItem.timestamp !== void 0;
        }));
        setNamespace(filteredNamespaceWithoutOldFormattedCacheItems);
        if (!timeToLive) return;
        const filteredNamespaceWithoutExpiredItems = Object.fromEntries(Object.entries(filteredNamespaceWithoutOldFormattedCacheItems).filter(([, cacheItem])=>{
            const currentTimestamp = /* @__PURE__ */ new Date().getTime();
            const isExpired = cacheItem.timestamp + timeToLive < currentTimestamp;
            return !isExpired;
        }));
        setNamespace(filteredNamespaceWithoutExpiredItems);
    }
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return Promise.resolve().then(()=>{
                removeOutdatedCacheItems();
                return getNamespace()[JSON.stringify(key)];
            }).then((value)=>{
                return Promise.all([
                    value ? value.value : defaultValue(),
                    value !== void 0
                ]);
            }).then(([value, exists])=>{
                return Promise.all([
                    value,
                    exists || events.miss(value)
                ]);
            }).then(([value])=>value);
        },
        set (key, value) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                namespace[JSON.stringify(key)] = {
                    timestamp: /* @__PURE__ */ new Date().getTime(),
                    value: value
                };
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
                return value;
            });
        },
        delete (key) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                delete namespace[JSON.stringify(key)];
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
            });
        },
        clear () {
            return Promise.resolve().then(()=>{
                getStorage().removeItem(namespaceKey);
            });
        }
    };
}
// src/cache/createNullCache.ts
function $bef90096bd8e008d$export$2774a8bf79d531b() {
    return {
        get (_key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const value = defaultValue();
            return value.then((result)=>Promise.all([
                    result,
                    events.miss(result)
                ])).then(([result])=>result);
        },
        set (_key, value) {
            return Promise.resolve(value);
        },
        delete (_key) {
            return Promise.resolve();
        },
        clear () {
            return Promise.resolve();
        }
    };
}
// src/cache/createFallbackableCache.ts
function $bef90096bd8e008d$export$8637a0800116df9b(options) {
    const caches = [
        ...options.caches
    ];
    const current = caches.shift();
    if (current === void 0) return $bef90096bd8e008d$export$2774a8bf79d531b();
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return current.get(key, defaultValue, events).catch(()=>{
                return $bef90096bd8e008d$export$8637a0800116df9b({
                    caches: caches
                }).get(key, defaultValue, events);
            });
        },
        set (key, value) {
            return current.set(key, value).catch(()=>{
                return $bef90096bd8e008d$export$8637a0800116df9b({
                    caches: caches
                }).set(key, value);
            });
        },
        delete (key) {
            return current.delete(key).catch(()=>{
                return $bef90096bd8e008d$export$8637a0800116df9b({
                    caches: caches
                }).delete(key);
            });
        },
        clear () {
            return current.clear().catch(()=>{
                return $bef90096bd8e008d$export$8637a0800116df9b({
                    caches: caches
                }).clear();
            });
        }
    };
}
// src/cache/createMemoryCache.ts
function $bef90096bd8e008d$export$b1fc9484ccfcd328(options = {
    serializable: true
}) {
    let cache = {};
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const keyAsString = JSON.stringify(key);
            if (keyAsString in cache) return Promise.resolve(options.serializable ? JSON.parse(cache[keyAsString]) : cache[keyAsString]);
            const promise = defaultValue();
            return promise.then((value)=>events.miss(value)).then(()=>promise);
        },
        set (key, value) {
            cache[JSON.stringify(key)] = options.serializable ? JSON.stringify(value) : value;
            return Promise.resolve(value);
        },
        delete (key) {
            delete cache[JSON.stringify(key)];
            return Promise.resolve();
        },
        clear () {
            cache = {};
            return Promise.resolve();
        }
    };
}
// src/constants.ts
var $bef90096bd8e008d$export$1c9d677a000d9c75 = 1e3;
var $bef90096bd8e008d$export$cc6130e78d57e416 = 2e3;
var $bef90096bd8e008d$export$a36d433dda13154c = 3e4;
var $bef90096bd8e008d$export$3d443caeeeeb0358 = 2e3;
var $bef90096bd8e008d$export$da73fde44cbc636a = 5e3;
var $bef90096bd8e008d$export$fdad022791f75c95 = 3e4;
// src/createAlgoliaAgent.ts
function $bef90096bd8e008d$export$f3ef4b722067ac71(version) {
    const algoliaAgent = {
        value: `Algolia for JavaScript (${version})`,
        add (options) {
            const addedAlgoliaAgent = `; ${options.segment}${options.version !== void 0 ? ` (${options.version})` : ""}`;
            if (algoliaAgent.value.indexOf(addedAlgoliaAgent) === -1) algoliaAgent.value = `${algoliaAgent.value}${addedAlgoliaAgent}`;
            return algoliaAgent;
        }
    };
    return algoliaAgent;
}
// src/createAuth.ts
function $bef90096bd8e008d$export$5f096e4c9da248bb(appId, apiKey, authMode = "WithinHeaders") {
    const credentials = {
        "x-algolia-api-key": apiKey,
        "x-algolia-application-id": appId
    };
    return {
        headers () {
            return authMode === "WithinHeaders" ? credentials : {};
        },
        queryParameters () {
            return authMode === "WithinQueryParameters" ? credentials : {};
        }
    };
}
// src/createIterablePromise.ts
function $bef90096bd8e008d$export$d96db6d38a87ffce({ func: func, validate: validate, aggregator: aggregator, error: error, timeout: timeout = ()=>0 }) {
    const retry = (previousResponse)=>{
        return new Promise((resolve, reject)=>{
            func(previousResponse).then(async (response)=>{
                if (aggregator) await aggregator(response);
                if (await validate(response)) return resolve(response);
                if (error && await error.validate(response)) return reject(new Error(await error.message(response)));
                return setTimeout(()=>{
                    retry(response).then(resolve).catch(reject);
                }, await timeout());
            }).catch((err)=>{
                reject(err);
            });
        });
    };
    return retry();
}
// src/getAlgoliaAgent.ts
function $bef90096bd8e008d$export$dc28410830ce888d({ algoliaAgents: algoliaAgents, client: client, version: version }) {
    const defaultAlgoliaAgent = $bef90096bd8e008d$export$f3ef4b722067ac71(version).add({
        segment: client,
        version: version
    });
    algoliaAgents.forEach((algoliaAgent)=>defaultAlgoliaAgent.add(algoliaAgent));
    return defaultAlgoliaAgent;
}
// src/logger/createNullLogger.ts
function $bef90096bd8e008d$export$6d3f4ca34494bf2d() {
    return {
        debug (_message, _args) {
            return Promise.resolve();
        },
        info (_message, _args) {
            return Promise.resolve();
        },
        error (_message, _args) {
            return Promise.resolve();
        }
    };
}
// src/transporter/createStatefulHost.ts
var $bef90096bd8e008d$var$EXPIRATION_DELAY = 120000;
function $bef90096bd8e008d$export$3fb3dda619608b7(host, status = "up") {
    const lastUpdate = Date.now();
    function isUp() {
        return status === "up" || Date.now() - lastUpdate > $bef90096bd8e008d$var$EXPIRATION_DELAY;
    }
    function isTimedOut() {
        return status === "timed out" && Date.now() - lastUpdate <= $bef90096bd8e008d$var$EXPIRATION_DELAY;
    }
    return {
        ...host,
        status: status,
        lastUpdate: lastUpdate,
        isUp: isUp,
        isTimedOut: isTimedOut
    };
}
// src/transporter/errors.ts
var $bef90096bd8e008d$export$94fb2163d3563f9d = class extends Error {
    name = "AlgoliaError";
    constructor(message, name){
        super(message);
        if (name) this.name = name;
    }
};
var $bef90096bd8e008d$export$82008413de5a8872 = class extends $bef90096bd8e008d$export$94fb2163d3563f9d {
    constructor(indexName){
        super(`${indexName} does not exist`, "IndexNotFoundError");
    }
};
var $bef90096bd8e008d$export$798e760e91f47f7a = class extends $bef90096bd8e008d$export$94fb2163d3563f9d {
    constructor(){
        super("Indices are in the same application. Use operationIndex instead.", "IndicesInSameAppError");
    }
};
var $bef90096bd8e008d$export$16e2147305eecb9 = class extends $bef90096bd8e008d$export$94fb2163d3563f9d {
    constructor(indexName){
        super(`${indexName} index already exists.`, "IndexAlreadyExistsError");
    }
};
var $bef90096bd8e008d$export$2fd7939d0c81cd0c = class extends $bef90096bd8e008d$export$94fb2163d3563f9d {
    stackTrace;
    constructor(message, stackTrace, name){
        super(message, name);
        this.stackTrace = stackTrace;
    }
};
var $bef90096bd8e008d$export$aa6cf8a4f695f0ee = class extends $bef90096bd8e008d$export$2fd7939d0c81cd0c {
    constructor(stackTrace){
        super("Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support.", stackTrace, "RetryError");
    }
};
var $bef90096bd8e008d$export$f2e832acab1bdd79 = class extends $bef90096bd8e008d$export$2fd7939d0c81cd0c {
    status;
    constructor(message, status, stackTrace, name = "ApiError"){
        super(message, stackTrace, name);
        this.status = status;
    }
};
var $bef90096bd8e008d$export$e711248598da7854 = class extends $bef90096bd8e008d$export$94fb2163d3563f9d {
    response;
    constructor(message, response){
        super(message, "DeserializationError");
        this.response = response;
    }
};
var $bef90096bd8e008d$export$5f44dadb2efd3cfb = class extends $bef90096bd8e008d$export$f2e832acab1bdd79 {
    error;
    constructor(message, status, error, stackTrace){
        super(message, status, stackTrace, "DetailedApiError");
        this.error = error;
    }
};
// src/transporter/helpers.ts
function $bef90096bd8e008d$export$448332262467e042(array) {
    const shuffledArray = array;
    for(let c = array.length - 1; c > 0; c--){
        const b = Math.floor(Math.random() * (c + 1));
        const a = array[c];
        shuffledArray[c] = array[b];
        shuffledArray[b] = a;
    }
    return shuffledArray;
}
function $bef90096bd8e008d$export$102dee260a456972(host, path, queryParameters) {
    const queryParametersAsString = $bef90096bd8e008d$export$b3f68c1f6e4b3e22(queryParameters);
    let url = `${host.protocol}://${host.url}${host.port ? `:${host.port}` : ""}/${path.charAt(0) === "/" ? path.substring(1) : path}`;
    if (queryParametersAsString.length) url += `?${queryParametersAsString}`;
    return url;
}
function $bef90096bd8e008d$export$b3f68c1f6e4b3e22(parameters) {
    return Object.keys(parameters).filter((key)=>parameters[key] !== void 0).sort().map((key)=>`${key}=${encodeURIComponent(Object.prototype.toString.call(parameters[key]) === "[object Array]" ? parameters[key].join(",") : parameters[key]).replace(/\+/g, "%20")}`).join("&");
}
function $bef90096bd8e008d$export$b2290ffa247cf0a7(request, requestOptions) {
    if (request.method === "GET" || request.data === void 0 && requestOptions.data === void 0) return void 0;
    const data = Array.isArray(request.data) ? request.data : {
        ...request.data,
        ...requestOptions.data
    };
    return JSON.stringify(data);
}
function $bef90096bd8e008d$export$dfd5dd9013041417(baseHeaders, requestHeaders, requestOptionsHeaders) {
    const headers = {
        Accept: "application/json",
        ...baseHeaders,
        ...requestHeaders,
        ...requestOptionsHeaders
    };
    const serializedHeaders = {};
    Object.keys(headers).forEach((header)=>{
        const value = headers[header];
        serializedHeaders[header.toLowerCase()] = value;
    });
    return serializedHeaders;
}
function $bef90096bd8e008d$export$699210646009f15c(response) {
    try {
        return JSON.parse(response.content);
    } catch (e) {
        throw new $bef90096bd8e008d$export$e711248598da7854(e.message, response);
    }
}
function $bef90096bd8e008d$export$36794b0ec2a5c1b1({ content: content, status: status }, stackFrame) {
    try {
        const parsed = JSON.parse(content);
        if ("error" in parsed) return new $bef90096bd8e008d$export$5f44dadb2efd3cfb(parsed.message, status, parsed.error, stackFrame);
        return new $bef90096bd8e008d$export$f2e832acab1bdd79(parsed.message, status, stackFrame);
    } catch  {}
    return new $bef90096bd8e008d$export$f2e832acab1bdd79(content, status, stackFrame);
}
// src/transporter/responses.ts
function $bef90096bd8e008d$export$476aa014e2fd89d5({ isTimedOut: isTimedOut, status: status }) {
    return !isTimedOut && ~~status === 0;
}
function $bef90096bd8e008d$export$f146c102d7613638({ isTimedOut: isTimedOut, status: status }) {
    return isTimedOut || $bef90096bd8e008d$export$476aa014e2fd89d5({
        isTimedOut: isTimedOut,
        status: status
    }) || ~~(status / 100) !== 2 && ~~(status / 100) !== 4;
}
function $bef90096bd8e008d$export$b0ac3e614a309be3({ status: status }) {
    return ~~(status / 100) === 2;
}
// src/transporter/stackTrace.ts
function $bef90096bd8e008d$export$719a2b5349a98bb0(stackTrace) {
    return stackTrace.map((stackFrame)=>$bef90096bd8e008d$export$e8a46da9420defe9(stackFrame));
}
function $bef90096bd8e008d$export$e8a46da9420defe9(stackFrame) {
    const modifiedHeaders = stackFrame.request.headers["x-algolia-api-key"] ? {
        "x-algolia-api-key": "*****"
    } : {};
    return {
        ...stackFrame,
        request: {
            ...stackFrame.request,
            headers: {
                ...stackFrame.request.headers,
                ...modifiedHeaders
            }
        }
    };
}
// src/transporter/createTransporter.ts
function $bef90096bd8e008d$export$9f379e42258ad245({ hosts: hosts, hostsCache: hostsCache, baseHeaders: baseHeaders, logger: logger, baseQueryParameters: baseQueryParameters, algoliaAgent: algoliaAgent, timeouts: timeouts, requester: requester, requestsCache: requestsCache, responsesCache: responsesCache }) {
    async function createRetryableOptions(compatibleHosts) {
        const statefulHosts = await Promise.all(compatibleHosts.map((compatibleHost)=>{
            return hostsCache.get(compatibleHost, ()=>{
                return Promise.resolve($bef90096bd8e008d$export$3fb3dda619608b7(compatibleHost));
            });
        }));
        const hostsUp = statefulHosts.filter((host)=>host.isUp());
        const hostsTimedOut = statefulHosts.filter((host)=>host.isTimedOut());
        const hostsAvailable = [
            ...hostsUp,
            ...hostsTimedOut
        ];
        const compatibleHostsAvailable = hostsAvailable.length > 0 ? hostsAvailable : compatibleHosts;
        return {
            hosts: compatibleHostsAvailable,
            getTimeout (timeoutsCount, baseTimeout) {
                const timeoutMultiplier = hostsTimedOut.length === 0 && timeoutsCount === 0 ? 1 : hostsTimedOut.length + 3 + timeoutsCount;
                return timeoutMultiplier * baseTimeout;
            }
        };
    }
    async function retryableRequest(request, requestOptions, isRead = true) {
        const stackTrace = [];
        const data = $bef90096bd8e008d$export$b2290ffa247cf0a7(request, requestOptions);
        const headers = $bef90096bd8e008d$export$dfd5dd9013041417(baseHeaders, request.headers, requestOptions.headers);
        const dataQueryParameters = request.method === "GET" ? {
            ...request.data,
            ...requestOptions.data
        } : {};
        const queryParameters = {
            ...baseQueryParameters,
            ...request.queryParameters,
            ...dataQueryParameters
        };
        if (algoliaAgent.value) queryParameters["x-algolia-agent"] = algoliaAgent.value;
        if (requestOptions && requestOptions.queryParameters) {
            for (const key of Object.keys(requestOptions.queryParameters))if (!requestOptions.queryParameters[key] || Object.prototype.toString.call(requestOptions.queryParameters[key]) === "[object Object]") queryParameters[key] = requestOptions.queryParameters[key];
            else queryParameters[key] = requestOptions.queryParameters[key].toString();
        }
        let timeoutsCount = 0;
        const retry = async (retryableHosts, getTimeout)=>{
            const host = retryableHosts.pop();
            if (host === void 0) throw new $bef90096bd8e008d$export$aa6cf8a4f695f0ee($bef90096bd8e008d$export$719a2b5349a98bb0(stackTrace));
            const timeout = {
                ...timeouts,
                ...requestOptions.timeouts
            };
            const payload = {
                data: data,
                headers: headers,
                method: request.method,
                url: $bef90096bd8e008d$export$102dee260a456972(host, request.path, queryParameters),
                connectTimeout: getTimeout(timeoutsCount, timeout.connect),
                responseTimeout: getTimeout(timeoutsCount, isRead ? timeout.read : timeout.write)
            };
            const pushToStackTrace = (response2)=>{
                const stackFrame = {
                    request: payload,
                    response: response2,
                    host: host,
                    triesLeft: retryableHosts.length
                };
                stackTrace.push(stackFrame);
                return stackFrame;
            };
            const response = await requester.send(payload);
            if ($bef90096bd8e008d$export$f146c102d7613638(response)) {
                const stackFrame = pushToStackTrace(response);
                if (response.isTimedOut) timeoutsCount++;
                logger.info("Retryable failure", $bef90096bd8e008d$export$e8a46da9420defe9(stackFrame));
                await hostsCache.set(host, $bef90096bd8e008d$export$3fb3dda619608b7(host, response.isTimedOut ? "timed out" : "down"));
                return retry(retryableHosts, getTimeout);
            }
            if ($bef90096bd8e008d$export$b0ac3e614a309be3(response)) return $bef90096bd8e008d$export$699210646009f15c(response);
            pushToStackTrace(response);
            throw $bef90096bd8e008d$export$36794b0ec2a5c1b1(response, stackTrace);
        };
        const compatibleHosts = hosts.filter((host)=>host.accept === "readWrite" || (isRead ? host.accept === "read" : host.accept === "write"));
        const options = await createRetryableOptions(compatibleHosts);
        return retry([
            ...options.hosts
        ].reverse(), options.getTimeout);
    }
    function createRequest(request, requestOptions = {}) {
        const isRead = request.useReadTransporter || request.method === "GET";
        if (!isRead) return retryableRequest(request, requestOptions, isRead);
        const createRetryableRequest = ()=>{
            return retryableRequest(request, requestOptions);
        };
        const cacheable = requestOptions.cacheable || request.cacheable;
        if (cacheable !== true) return createRetryableRequest();
        const key = {
            request: request,
            requestOptions: requestOptions,
            transporter: {
                queryParameters: baseQueryParameters,
                headers: baseHeaders
            }
        };
        return responsesCache.get(key, ()=>{
            return requestsCache.get(key, ()=>/**
             * Finally, if there is no request in progress with the same key,
             * this `createRetryableRequest()` will actually trigger the
             * retryable request.
             */ requestsCache.set(key, createRetryableRequest()).then((response)=>Promise.all([
                        requestsCache.delete(key),
                        response
                    ]), (err)=>Promise.all([
                        requestsCache.delete(key),
                        Promise.reject(err)
                    ])).then(([_, response])=>response));
        }, {
            /**
         * Of course, once we get this response back from the server, we
         * tell response cache to actually store the received response
         * to be used later.
         */ miss: (response)=>responsesCache.set(key, response)
        });
    }
    return {
        hostsCache: hostsCache,
        requester: requester,
        timeouts: timeouts,
        logger: logger,
        algoliaAgent: algoliaAgent,
        baseHeaders: baseHeaders,
        baseQueryParameters: baseQueryParameters,
        hosts: hosts,
        request: createRequest,
        requestsCache: requestsCache,
        responsesCache: responsesCache
    };
}
// src/types/logger.ts
var $bef90096bd8e008d$export$d65602050420b80d = {
    Debug: 1,
    Info: 2,
    Error: 3
};

});


parcelRegister("2Z7mK", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $22c6fdf9a276b0dd$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "abtestingClient", function () { return $22c6fdf9a276b0dd$export$c1558718601bb704; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $22c6fdf9a276b0dd$export$ad1dfbed11feb646 = "5.35.0";
var $22c6fdf9a276b0dd$var$REGIONS = [
    "de",
    "us"
];
function $22c6fdf9a276b0dd$var$getDefaultHosts(region) {
    const url = !region ? "analytics.algolia.com" : "analytics.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $22c6fdf9a276b0dd$var$createAbtestingClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $22c6fdf9a276b0dd$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Abtesting",
            version: $22c6fdf9a276b0dd$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Creates a new A/B test.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param addABTestsRequest - The addABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ addABTests (addABTestsRequest, requestOptions) {
            if (!addABTestsRequest) throw new Error("Parameter `addABTestsRequest` is required when calling `addABTests`.");
            if (!addABTestsRequest.name) throw new Error("Parameter `addABTestsRequest.name` is required when calling `addABTests`.");
            if (!addABTestsRequest.variants) throw new Error("Parameter `addABTestsRequest.variants` is required when calling `addABTests`.");
            if (!addABTestsRequest.endAt) throw new Error("Parameter `addABTestsRequest.endAt` is required when calling `addABTests`.");
            const requestPath = "/2/abtests";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: addABTestsRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteABTest - The deleteABTest object.
     * @param deleteABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `deleteABTest`.");
            const requestPath = "/2/abtests/{id}".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Given the traffic percentage and the expected effect size, this endpoint estimates the sample size and duration of an A/B test based on historical traffic.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param estimateABTestRequest - The estimateABTestRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ estimateABTest (estimateABTestRequest, requestOptions) {
            if (!estimateABTestRequest) throw new Error("Parameter `estimateABTestRequest` is required when calling `estimateABTest`.");
            if (!estimateABTestRequest.configuration) throw new Error("Parameter `estimateABTestRequest.configuration` is required when calling `estimateABTest`.");
            if (!estimateABTestRequest.variants) throw new Error("Parameter `estimateABTestRequest.variants` is required when calling `estimateABTest`.");
            const requestPath = "/2/abtests/estimate";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: estimateABTestRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the details for an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getABTest - The getABTest object.
     * @param getABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `getABTest`.");
            const requestPath = "/2/abtests/{id}".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists all A/B tests you configured for this application.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param listABTests - The listABTests object.
     * @param listABTests.offset - Position of the first item to return.
     * @param listABTests.limit - Number of items to return.
     * @param listABTests.indexPrefix - Index name prefix. Only A/B tests for indices starting with this string are included in the response.
     * @param listABTests.indexSuffix - Index name suffix. Only A/B tests for indices ending with this string are included in the response.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listABTests ({ offset: offset, limit: limit, indexPrefix: indexPrefix, indexSuffix: indexSuffix } = {}, requestOptions) {
            const requestPath = "/2/abtests";
            const headers = {};
            const queryParameters = {};
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (indexPrefix !== void 0) queryParameters["indexPrefix"] = indexPrefix.toString();
            if (indexSuffix !== void 0) queryParameters["indexSuffix"] = indexSuffix.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Schedule an A/B test to be started at a later time.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param scheduleABTestsRequest - The scheduleABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ scheduleABTest (scheduleABTestsRequest, requestOptions) {
            if (!scheduleABTestsRequest) throw new Error("Parameter `scheduleABTestsRequest` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.name) throw new Error("Parameter `scheduleABTestsRequest.name` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.variants) throw new Error("Parameter `scheduleABTestsRequest.variants` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.scheduledAt) throw new Error("Parameter `scheduleABTestsRequest.scheduledAt` is required when calling `scheduleABTest`.");
            if (!scheduleABTestsRequest.endAt) throw new Error("Parameter `scheduleABTestsRequest.endAt` is required when calling `scheduleABTest`.");
            const requestPath = "/2/abtests/schedule";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: scheduleABTestsRequest
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Stops an A/B test by its ID.  You can\'t restart stopped A/B tests.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param stopABTest - The stopABTest object.
     * @param stopABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ stopABTest ({ id: id }, requestOptions) {
            if (!id) throw new Error("Parameter `id` is required when calling `stopABTest`.");
            const requestPath = "/2/abtests/{id}/stop".replace("{id}", encodeURIComponent(id));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $22c6fdf9a276b0dd$export$c1558718601bb704(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (region && (typeof region !== "string" || !$22c6fdf9a276b0dd$var$REGIONS.includes(region))) throw new Error(`\`region\` must be one of the following: ${$22c6fdf9a276b0dd$var$REGIONS.join(", ")}`);
    return $22c6fdf9a276b0dd$var$createAbtestingClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$22c6fdf9a276b0dd$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("3xdaN", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $292eac11f388d39e$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "analyticsClient", function () { return $292eac11f388d39e$export$f1caacacb426dc27; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $292eac11f388d39e$export$ad1dfbed11feb646 = "5.35.0";
var $292eac11f388d39e$var$REGIONS = [
    "de",
    "us"
];
function $292eac11f388d39e$var$getDefaultHosts(region) {
    const url = !region ? "analytics.algolia.com" : "analytics.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $292eac11f388d39e$var$createAnalyticsClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $292eac11f388d39e$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Analytics",
            version: $292eac11f388d39e$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the add-to-cart rate for all your searches with at least one add-to-cart event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  The rate is the number of add-to-cart conversion events divided by the number of tracked searches. A search is tracked if it returns a queryID (`clickAnalytics` is `true`). This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`.  **There\'s a difference between a 0 and null add-to-cart rate when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the add-to-cart rate is null. - **0** mean there _were_ queries but no [add-to-cart events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getAddToCartRate - The getAddToCartRate object.
     * @param getAddToCartRate.index - Index name.
     * @param getAddToCartRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAddToCartRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAddToCartRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAddToCartRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getAddToCartRate`.");
            const requestPath = "/2/conversions/addToCartRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the average click position of your search results, including a daily breakdown.  The average click position is the average of all clicked search result positions. For example, if users only ever click on the first result for any search, the average click position is 1. By default, the analyzed period includes the last eight days including the current day.  An average of `null` when `clickAnalytics` is enabled means Algolia didn\'t receive any [click events](https://www.algolia.com/doc/guides/sending-events/getting-started/) for the queries. The average is `null` until Algolia receives at least one click event.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getAverageClickPosition - The getAverageClickPosition object.
     * @param getAverageClickPosition.index - Index name.
     * @param getAverageClickPosition.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAverageClickPosition.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAverageClickPosition.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAverageClickPosition ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getAverageClickPosition`.");
            const requestPath = "/2/clicks/averageClickPosition";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the positions in the search results and their associated number of clicks.  This lets you check how many clicks the first, second, or tenth search results receive.  An average of `0` when `clickAnalytics` is enabled means Algolia didn\'t receive any [click events](https://www.algolia.com/doc/guides/sending-events/getting-started/) for the queries.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getClickPositions - The getClickPositions object.
     * @param getClickPositions.index - Index name.
     * @param getClickPositions.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickPositions.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickPositions.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClickPositions ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getClickPositions`.");
            const requestPath = "/2/clicks/positions";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the click-through rate (CTR) for all your searches with at least one click event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  **There\'s a difference between a 0 and null CTR when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, CTR is null. - **0** mean there _were_ queries but no [click events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getClickThroughRate - The getClickThroughRate object.
     * @param getClickThroughRate.index - Index name.
     * @param getClickThroughRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickThroughRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickThroughRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClickThroughRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getClickThroughRate`.");
            const requestPath = "/2/clicks/clickThroughRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the conversion rate (CR) for all your searches with at least one conversion event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  **There\'s a difference between a 0 and null CR when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, CR is null. - **0** mean there _were_ queries but no [conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getConversionRate - The getConversionRate object.
     * @param getConversionRate.index - Index name.
     * @param getConversionRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getConversionRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getConversionRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getConversionRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getConversionRate`.");
            const requestPath = "/2/conversions/conversionRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the fraction of searches that didn\'t lead to any click within a time range, including a daily breakdown. It also returns the number of tracked searches and tracked searches without clicks.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getNoClickRate - The getNoClickRate object.
     * @param getNoClickRate.index - Index name.
     * @param getNoClickRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoClickRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoClickRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getNoClickRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getNoClickRate`.");
            const requestPath = "/2/searches/noClickRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the fraction of searches that didn\'t return any results within a time range, including a daily breakdown. It also returns the count of searches and searches without results used to compute the rates.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getNoResultsRate - The getNoResultsRate object.
     * @param getNoResultsRate.index - Index name.
     * @param getNoResultsRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoResultsRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoResultsRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getNoResultsRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getNoResultsRate`.");
            const requestPath = "/2/searches/noResultRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the purchase rate for all your searches with at least one purchase event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  The rate is the number of purchase conversion events divided by the number of tracked searches. A search is tracked if it returns a query ID (`clickAnalytics` is `true`). This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`.  **There\'s a difference between a 0 and null purchase rate when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the purchase rate is null. - **0** mean there _were_ queries but no [purchase conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getPurchaseRate - The getPurchaseRate object.
     * @param getPurchaseRate.index - Index name.
     * @param getPurchaseRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getPurchaseRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getPurchaseRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getPurchaseRate ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getPurchaseRate`.");
            const requestPath = "/2/conversions/purchaseRate";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves revenue-related metrics, such as the total revenue or the average order value.  To retrieve revenue-related metrics, send purchase events. By default, the analyzed period includes the last eight days including the current day.  Revenue is based on purchase conversion events (a conversion event with an `eventSubtype` attribute of `purchase`). The revenue is the `price` attribute multiplied by the `quantity` attribute for each object in the event\'s `objectData` array.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getRevenue - The getRevenue object.
     * @param getRevenue.index - Index name.
     * @param getRevenue.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getRevenue.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getRevenue.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRevenue ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getRevenue`.");
            const requestPath = "/2/conversions/revenue";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the number of searches within a time range, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesCount - The getSearchesCount object.
     * @param getSearchesCount.index - Index name.
     * @param getSearchesCount.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesCount.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesCount.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSearchesCount ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getSearchesCount`.");
            const requestPath = "/2/searches/count";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the most popular searches that didn\'t lead to any clicks, from the 1,000 most frequent searches.  For each search, it also returns the number of displayed search results that remained unclicked.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesNoClicks - The getSearchesNoClicks object.
     * @param getSearchesNoClicks.index - Index name.
     * @param getSearchesNoClicks.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoClicks.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoClicks.limit - Number of items to return.
     * @param getSearchesNoClicks.offset - Position of the first item to return.
     * @param getSearchesNoClicks.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSearchesNoClicks ({ index: index, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getSearchesNoClicks`.");
            const requestPath = "/2/searches/noClicks";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequent searches that produced zero results.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesNoResults - The getSearchesNoResults object.
     * @param getSearchesNoResults.index - Index name.
     * @param getSearchesNoResults.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoResults.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoResults.limit - Number of items to return.
     * @param getSearchesNoResults.offset - Position of the first item to return.
     * @param getSearchesNoResults.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSearchesNoResults ({ index: index, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getSearchesNoResults`.");
            const requestPath = "/2/searches/noResults";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the time when the Analytics data for the specified index was last updated.  If the index has been recently created or no search has been performed yet the updated time is `null`.  The Analytics data is updated every 5&nbsp;minutes.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getStatus - The getStatus object.
     * @param getStatus.index - Index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getStatus ({ index: index }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getStatus`.");
            const requestPath = "/2/status";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the countries with the most searches in your index.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopCountries - The getTopCountries object.
     * @param getTopCountries.index - Index name.
     * @param getTopCountries.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopCountries.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopCountries.limit - Number of items to return.
     * @param getTopCountries.offset - Position of the first item to return.
     * @param getTopCountries.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopCountries ({ index: index, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopCountries`.");
            const requestPath = "/2/countries";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequently used filter attributes.  These are attributes of your records that you included in the `attributesForFaceting` setting.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFilterAttributes - The getTopFilterAttributes object.
     * @param getTopFilterAttributes.index - Index name.
     * @param getTopFilterAttributes.search - Search query.
     * @param getTopFilterAttributes.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterAttributes.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterAttributes.limit - Number of items to return.
     * @param getTopFilterAttributes.offset - Position of the first item to return.
     * @param getTopFilterAttributes.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopFilterAttributes ({ index: index, search: search, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopFilterAttributes`.");
            const requestPath = "/2/filters";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequent filter (facet) values for a filter attribute.  These are attributes of your records that you included in the `attributesForFaceting` setting.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFilterForAttribute - The getTopFilterForAttribute object.
     * @param getTopFilterForAttribute.attribute - Attribute name.
     * @param getTopFilterForAttribute.index - Index name.
     * @param getTopFilterForAttribute.search - Search query.
     * @param getTopFilterForAttribute.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterForAttribute.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterForAttribute.limit - Number of items to return.
     * @param getTopFilterForAttribute.offset - Position of the first item to return.
     * @param getTopFilterForAttribute.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopFilterForAttribute ({ attribute: attribute, index: index, search: search, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!attribute) throw new Error("Parameter `attribute` is required when calling `getTopFilterForAttribute`.");
            if (!index) throw new Error("Parameter `index` is required when calling `getTopFilterForAttribute`.");
            const requestPath = "/2/filters/{attribute}".replace("{attribute}", encodeURIComponent(attribute));
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the 1,000 most frequently used filters for a search that didn\'t return any results.  To get the most frequent searches without results, use the [Retrieve searches without results](#tag/search/operation/getSearchesNoResults) operation.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFiltersNoResults - The getTopFiltersNoResults object.
     * @param getTopFiltersNoResults.index - Index name.
     * @param getTopFiltersNoResults.search - Search query.
     * @param getTopFiltersNoResults.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFiltersNoResults.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFiltersNoResults.limit - Number of items to return.
     * @param getTopFiltersNoResults.offset - Position of the first item to return.
     * @param getTopFiltersNoResults.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopFiltersNoResults ({ index: index, search: search, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopFiltersNoResults`.");
            const requestPath = "/2/filters/noResults";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the object IDs of the 1,000 most frequent search results.  If you set the `clickAnalytics` query parameter to true, the response also includes:  - Tracked searches count. Tracked searches are Search API requests with the `clickAnalytics` parameter set to `true`. This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`. - Click count - Click-through rate (CTR) - Conversion count - Conversion rate (CR) - Average click position  If you set the `revenueAnalytics` parameter to `true`, the response also includes:  - Add-to-cart count - Add-to-cart rate (ATCR) - Purchase count - Purchase rate - Revenue details for each currency  **There\'s a difference between 0% rates and null rates:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the rates (CTR, CR, ATCR, purchase rate) are null. - **0% rates** mean there _were_ queries but no [click or conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopHits - The getTopHits object.
     * @param getTopHits.index - Index name.
     * @param getTopHits.search - Search query.
     * @param getTopHits.clickAnalytics - Whether to include metrics related to click and conversion events in the response.
     * @param getTopHits.revenueAnalytics - Whether to include metrics related to revenue events in the response.
     * @param getTopHits.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopHits.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopHits.limit - Number of items to return.
     * @param getTopHits.offset - Position of the first item to return.
     * @param getTopHits.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopHits ({ index: index, search: search, clickAnalytics: clickAnalytics, revenueAnalytics: revenueAnalytics, startDate: startDate, endDate: endDate, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopHits`.");
            const requestPath = "/2/hits";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (search !== void 0) queryParameters["search"] = search.toString();
            if (clickAnalytics !== void 0) queryParameters["clickAnalytics"] = clickAnalytics.toString();
            if (revenueAnalytics !== void 0) queryParameters["revenueAnalytics"] = revenueAnalytics.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Returns the most popular searches. For each search, it also includes the average number of hits.  If you set the `clickAnalytics` query parameter to `true`, the response also includes  - Tracked searches count. Tracked searches are Search API requests with the `clickAnalytics` parameter set to `true`. This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`. - Click count - Click-through rate (CTR) - Conversion count - Conversion rate (CR) - Average click position  If you set the `revenueAnalytics` query parameter to `true`, the response also includes:  - Add-to-cart count - Add-to-cart rate (ATCR) - Purchase count - Purchase rate - Revenue details for each currency  **There\'s a difference between 0% rates and null rates:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the rates (CTR, CR, ATCR, purchase rate) are null. - **0% rates** mean there _were_ queries but no [click or conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started/) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopSearches - The getTopSearches object.
     * @param getTopSearches.index - Index name.
     * @param getTopSearches.clickAnalytics - Whether to include metrics related to click and conversion events in the response.
     * @param getTopSearches.revenueAnalytics - Whether to include metrics related to revenue events in the response.
     * @param getTopSearches.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopSearches.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopSearches.orderBy - Attribute by which to order the response items.  If the `clickAnalytics` parameter is false, only `searchCount` is available.
     * @param getTopSearches.direction - Sorting direction of the results: ascending or descending.
     * @param getTopSearches.limit - Number of items to return.
     * @param getTopSearches.offset - Position of the first item to return.
     * @param getTopSearches.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopSearches ({ index: index, clickAnalytics: clickAnalytics, revenueAnalytics: revenueAnalytics, startDate: startDate, endDate: endDate, orderBy: orderBy, direction: direction, limit: limit, offset: offset, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getTopSearches`.");
            const requestPath = "/2/searches";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (clickAnalytics !== void 0) queryParameters["clickAnalytics"] = clickAnalytics.toString();
            if (revenueAnalytics !== void 0) queryParameters["revenueAnalytics"] = revenueAnalytics.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (orderBy !== void 0) queryParameters["orderBy"] = orderBy.toString();
            if (direction !== void 0) queryParameters["direction"] = direction.toString();
            if (limit !== void 0) queryParameters["limit"] = limit.toString();
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the number of unique users within a time range, including a daily breakdown.  Since it returns the number of unique users, the sum of the daily values might be different from the total number.  By default:  - Algolia distinguishes search users by their IP address, _unless_ you include a pseudonymous user identifier in your search requests with the `userToken` API parameter or `x-algolia-usertoken` request header. - The analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getUsersCount - The getUsersCount object.
     * @param getUsersCount.index - Index name.
     * @param getUsersCount.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getUsersCount.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getUsersCount.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments/).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getUsersCount ({ index: index, startDate: startDate, endDate: endDate, tags: tags }, requestOptions) {
            if (!index) throw new Error("Parameter `index` is required when calling `getUsersCount`.");
            const requestPath = "/2/users/count";
            const headers = {};
            const queryParameters = {};
            if (index !== void 0) queryParameters["index"] = index.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            if (tags !== void 0) queryParameters["tags"] = tags.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $292eac11f388d39e$export$f1caacacb426dc27(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (region && (typeof region !== "string" || !$292eac11f388d39e$var$REGIONS.includes(region))) throw new Error(`\`region\` must be one of the following: ${$292eac11f388d39e$var$REGIONS.join(", ")}`);
    return $292eac11f388d39e$var$createAnalyticsClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$292eac11f388d39e$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("51xCb", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $3a871ef29210e935$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "insightsClient", function () { return $3a871ef29210e935$export$856f93a58939b342; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $3a871ef29210e935$export$ad1dfbed11feb646 = "5.35.0";
var $3a871ef29210e935$var$REGIONS = [
    "de",
    "us"
];
function $3a871ef29210e935$var$getDefaultHosts(region) {
    const url = !region ? "insights.algolia.io" : "insights.{region}.algolia.io".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $3a871ef29210e935$var$createInsightsClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $3a871ef29210e935$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Insights",
            version: $3a871ef29210e935$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes all events related to the specified user token from events metrics and analytics. The deletion is asynchronous, and processed within 48 hours. To delete a personalization user profile, see `Delete a user profile` in the Personalization API.
     *
     * Required API Key ACLs:
     *  - deleteObject
     * @param deleteUserToken - The deleteUserToken object.
     * @param deleteUserToken.userToken - User token for which to delete all associated events.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteUserToken ({ userToken: userToken }, requestOptions) {
            if (!userToken) throw new Error("Parameter `userToken` is required when calling `deleteUserToken`.");
            const requestPath = "/1/usertokens/{userToken}".replace("{userToken}", encodeURIComponent(userToken));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Sends a list of events to the Insights API.  You can include up to 1,000 events in a single request, but the request body must be smaller than 2&nbsp;MB.
     *
     * Required API Key ACLs:
     *  - search
     * @param insightsEvents - The insightsEvents object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ pushEvents (insightsEvents, requestOptions) {
            if (!insightsEvents) throw new Error("Parameter `insightsEvents` is required when calling `pushEvents`.");
            if (!insightsEvents.events) throw new Error("Parameter `insightsEvents.events` is required when calling `pushEvents`.");
            const requestPath = "/1/events";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: insightsEvents
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $3a871ef29210e935$export$856f93a58939b342(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (region && (typeof region !== "string" || !$3a871ef29210e935$var$REGIONS.includes(region))) throw new Error(`\`region\` must be one of the following: ${$3a871ef29210e935$var$REGIONS.join(", ")}`);
    return $3a871ef29210e935$var$createInsightsClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$3a871ef29210e935$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("2iyEF", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $1ac824efa12da957$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "personalizationClient", function () { return $1ac824efa12da957$export$56412180a9807a64; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $1ac824efa12da957$export$ad1dfbed11feb646 = "5.35.0";
var $1ac824efa12da957$var$REGIONS = [
    "eu",
    "us"
];
function $1ac824efa12da957$var$getDefaultHosts(region) {
    const url = "personalization.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $1ac824efa12da957$var$createPersonalizationClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $1ac824efa12da957$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Personalization",
            version: $1ac824efa12da957$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a user profile.  The response includes a date and time when the user profile can safely be considered deleted.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param deleteUserProfile - The deleteUserProfile object.
     * @param deleteUserProfile.userToken - Unique identifier representing a user for which to fetch the personalization profile.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteUserProfile ({ userToken: userToken }, requestOptions) {
            if (!userToken) throw new Error("Parameter `userToken` is required when calling `deleteUserProfile`.");
            const requestPath = "/1/profiles/{userToken}".replace("{userToken}", encodeURIComponent(userToken));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the current personalization strategy.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getPersonalizationStrategy (requestOptions) {
            const requestPath = "/1/strategies/personalization";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a user profile and their affinities for different facets.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param getUserTokenProfile - The getUserTokenProfile object.
     * @param getUserTokenProfile.userToken - Unique identifier representing a user for which to fetch the personalization profile.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getUserTokenProfile ({ userToken: userToken }, requestOptions) {
            if (!userToken) throw new Error("Parameter `userToken` is required when calling `getUserTokenProfile`.");
            const requestPath = "/1/profiles/personalization/{userToken}".replace("{userToken}", encodeURIComponent(userToken));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new personalization strategy.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param personalizationStrategyParams - The personalizationStrategyParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ setPersonalizationStrategy (personalizationStrategyParams, requestOptions) {
            if (!personalizationStrategyParams) throw new Error("Parameter `personalizationStrategyParams` is required when calling `setPersonalizationStrategy`.");
            if (!personalizationStrategyParams.eventsScoring) throw new Error("Parameter `personalizationStrategyParams.eventsScoring` is required when calling `setPersonalizationStrategy`.");
            if (!personalizationStrategyParams.facetsScoring) throw new Error("Parameter `personalizationStrategyParams.facetsScoring` is required when calling `setPersonalizationStrategy`.");
            if (!personalizationStrategyParams.personalizationImpact) throw new Error("Parameter `personalizationStrategyParams.personalizationImpact` is required when calling `setPersonalizationStrategy`.");
            const requestPath = "/1/strategies/personalization";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: personalizationStrategyParams
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $1ac824efa12da957$export$56412180a9807a64(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (!region || region && (typeof region !== "string" || !$1ac824efa12da957$var$REGIONS.includes(region))) throw new Error(`\`region\` is required and must be one of the following: ${$1ac824efa12da957$var$REGIONS.join(", ")}`);
    return $1ac824efa12da957$var$createPersonalizationClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$1ac824efa12da957$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("bQt1x", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $89fb108b0e2c4b01$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "querySuggestionsClient", function () { return $89fb108b0e2c4b01$export$1efe5b59a2a2df14; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $89fb108b0e2c4b01$export$ad1dfbed11feb646 = "5.35.0";
var $89fb108b0e2c4b01$var$REGIONS = [
    "eu",
    "us"
];
function $89fb108b0e2c4b01$var$getDefaultHosts(region) {
    const url = "query-suggestions.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $89fb108b0e2c4b01$var$createQuerySuggestionsClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $89fb108b0e2c4b01$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "QuerySuggestions",
            version: $89fb108b0e2c4b01$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Creates a new Query Suggestions configuration.  You can have up to 100 configurations per Algolia application.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param configurationWithIndex - The configurationWithIndex object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createConfig (configurationWithIndex, requestOptions) {
            if (!configurationWithIndex) throw new Error("Parameter `configurationWithIndex` is required when calling `createConfig`.");
            const requestPath = "/1/configs";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: configurationWithIndex
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a Query Suggestions configuration.  Deleting only removes the configuration and stops updates to the Query Suggestions index. To delete the Query Suggestions index itself, use the Search API and the `Delete an index` operation.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteConfig - The deleteConfig object.
     * @param deleteConfig.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteConfig ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteConfig`.");
            const requestPath = "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves all Query Suggestions configurations of your Algolia application.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAllConfigs (requestOptions) {
            const requestPath = "/1/configs";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a single Query Suggestions configuration by its index name.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getConfig - The getConfig object.
     * @param getConfig.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getConfig ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getConfig`.");
            const requestPath = "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Reports the status of a Query Suggestions index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getConfigStatus - The getConfigStatus object.
     * @param getConfigStatus.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getConfigStatus ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getConfigStatus`.");
            const requestPath = "/1/configs/{indexName}/status".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the logs for a single Query Suggestions index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getLogFile - The getLogFile object.
     * @param getLogFile.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getLogFile ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getLogFile`.");
            const requestPath = "/1/logs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a QuerySuggestions configuration.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param updateConfig - The updateConfig object.
     * @param updateConfig.indexName - Query Suggestions index name.
     * @param updateConfig.configuration - The configuration object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateConfig ({ indexName: indexName, configuration: configuration }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `updateConfig`.");
            if (!configuration) throw new Error("Parameter `configuration` is required when calling `updateConfig`.");
            if (!configuration.sourceIndices) throw new Error("Parameter `configuration.sourceIndices` is required when calling `updateConfig`.");
            const requestPath = "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: configuration
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $89fb108b0e2c4b01$export$1efe5b59a2a2df14(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (!region || region && (typeof region !== "string" || !$89fb108b0e2c4b01$var$REGIONS.includes(region))) throw new Error(`\`region\` is required and must be one of the following: ${$89fb108b0e2c4b01$var$REGIONS.join(", ")}`);
    return $89fb108b0e2c4b01$var$createQuerySuggestionsClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$89fb108b0e2c4b01$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("kSzRf", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $f334aa6bd8d96f3d$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "searchClient", function () { return $f334aa6bd8d96f3d$export$b72856d058786d12; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $f334aa6bd8d96f3d$export$ad1dfbed11feb646 = "5.35.0";
function $f334aa6bd8d96f3d$var$getDefaultHosts(appId) {
    return [
        {
            url: `${appId}-dsn.algolia.net`,
            accept: "read",
            protocol: "https"
        },
        {
            url: `${appId}.algolia.net`,
            accept: "write",
            protocol: "https"
        }
    ].concat((0, $goxFl.shuffle)([
        {
            url: `${appId}-1.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-2.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-3.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        }
    ]));
}
function $f334aa6bd8d96f3d$var$createSearchClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $f334aa6bd8d96f3d$var$getDefaultHosts(appIdOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Search",
            version: $f334aa6bd8d96f3d$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Helper: Wait for a task to be published (completed) for a given `indexName` and `taskID`.
     *
     * @summary Helper method that waits for a task to be published (completed).
     * @param waitForTaskOptions - The `waitForTaskOptions` object.
     * @param waitForTaskOptions.indexName - The `indexName` where the operation was performed.
     * @param waitForTaskOptions.taskID - The `taskID` returned in the method response.
     * @param waitForTaskOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForTaskOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ waitForTask ({ indexName: indexName, taskID: taskID, maxRetries: maxRetries = 50, timeout: timeout = (retryCount)=>Math.min(retryCount * 200, 5e3) }, requestOptions) {
            let retryCount = 0;
            return (0, $goxFl.createIterablePromise)({
                func: ()=>this.getTask({
                        indexName: indexName,
                        taskID: taskID
                    }, requestOptions),
                validate: (response)=>response.status === "published",
                aggregator: ()=>retryCount += 1,
                error: {
                    validate: ()=>retryCount >= maxRetries,
                    message: ()=>`The maximum number of retries exceeded. (${retryCount}/${maxRetries})`
                },
                timeout: ()=>timeout(retryCount)
            });
        },
        /**
     * Helper: Wait for an application-level task to complete for a given `taskID`.
     *
     * @summary Helper method that waits for a task to be published (completed).
     * @param waitForAppTaskOptions - The `waitForTaskOptions` object.
     * @param waitForAppTaskOptions.taskID - The `taskID` returned in the method response.
     * @param waitForAppTaskOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForAppTaskOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ waitForAppTask ({ taskID: taskID, maxRetries: maxRetries = 50, timeout: timeout = (retryCount)=>Math.min(retryCount * 200, 5e3) }, requestOptions) {
            let retryCount = 0;
            return (0, $goxFl.createIterablePromise)({
                func: ()=>this.getAppTask({
                        taskID: taskID
                    }, requestOptions),
                validate: (response)=>response.status === "published",
                aggregator: ()=>retryCount += 1,
                error: {
                    validate: ()=>retryCount >= maxRetries,
                    message: ()=>`The maximum number of retries exceeded. (${retryCount}/${maxRetries})`
                },
                timeout: ()=>timeout(retryCount)
            });
        },
        /**
     * Helper: Wait for an API key to be added, updated or deleted based on a given `operation`.
     *
     * @summary Helper method that waits for an API key task to be processed.
     * @param waitForApiKeyOptions - The `waitForApiKeyOptions` object.
     * @param waitForApiKeyOptions.operation - The `operation` that was done on a `key`.
     * @param waitForApiKeyOptions.key - The `key` that has been added, deleted or updated.
     * @param waitForApiKeyOptions.apiKey - Necessary to know if an `update` operation has been processed, compare fields of the response with it.
     * @param waitForApiKeyOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForApiKeyOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getApikey` method and merged with the transporter requestOptions.
     */ waitForApiKey ({ operation: operation, key: key, apiKey: apiKey, maxRetries: maxRetries = 50, timeout: timeout = (retryCount)=>Math.min(retryCount * 200, 5e3) }, requestOptions) {
            let retryCount = 0;
            const baseIteratorOptions = {
                aggregator: ()=>retryCount += 1,
                error: {
                    validate: ()=>retryCount >= maxRetries,
                    message: ()=>`The maximum number of retries exceeded. (${retryCount}/${maxRetries})`
                },
                timeout: ()=>timeout(retryCount)
            };
            if (operation === "update") {
                if (!apiKey) throw new Error("`apiKey` is required when waiting for an `update` operation.");
                return (0, $goxFl.createIterablePromise)({
                    ...baseIteratorOptions,
                    func: ()=>this.getApiKey({
                            key: key
                        }, requestOptions),
                    validate: (response)=>{
                        for (const field of Object.keys(apiKey)){
                            const value = apiKey[field];
                            const resValue = response[field];
                            if (Array.isArray(value) && Array.isArray(resValue)) {
                                if (value.length !== resValue.length || value.some((v, index)=>v !== resValue[index])) return false;
                            } else if (value !== resValue) return false;
                        }
                        return true;
                    }
                });
            }
            return (0, $goxFl.createIterablePromise)({
                ...baseIteratorOptions,
                func: ()=>this.getApiKey({
                        key: key
                    }, requestOptions).catch((error)=>{
                        if (error.status === 404) return void 0;
                        throw error;
                    }),
                validate: (response)=>operation === "add" ? response !== void 0 : response === void 0
            });
        },
        /**
     * Helper: Iterate on the `browse` method of the client to allow aggregating objects of an index.
     *
     * @summary Helper method that iterates on the `browse` method.
     * @param browseObjects - The `browseObjects` object.
     * @param browseObjects.indexName - The index in which to perform the request.
     * @param browseObjects.browseParams - The `browse` parameters.
     * @param browseObjects.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is no `cursor` in the response.
     * @param browseObjects.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `browse` method and merged with the transporter requestOptions.
     */ browseObjects ({ indexName: indexName, browseParams: browseParams, ...browseObjectsOptions }, requestOptions) {
            return (0, $goxFl.createIterablePromise)({
                func: (previousResponse)=>{
                    return this.browse({
                        indexName: indexName,
                        browseParams: {
                            cursor: previousResponse ? previousResponse.cursor : void 0,
                            hitsPerPage: 1e3,
                            ...browseParams
                        }
                    }, requestOptions);
                },
                validate: (response)=>response.cursor === void 0,
                ...browseObjectsOptions
            });
        },
        /**
     * Helper: Iterate on the `searchRules` method of the client to allow aggregating rules of an index.
     *
     * @summary Helper method that iterates on the `searchRules` method.
     * @param browseRules - The `browseRules` object.
     * @param browseRules.indexName - The index in which to perform the request.
     * @param browseRules.searchRulesParams - The `searchRules` method parameters.
     * @param browseRules.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is less hits returned than the number of maximum hits (1000).
     * @param browseRules.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `searchRules` method and merged with the transporter requestOptions.
     */ browseRules ({ indexName: indexName, searchRulesParams: searchRulesParams, ...browseRulesOptions }, requestOptions) {
            const params = {
                ...searchRulesParams,
                hitsPerPage: searchRulesParams?.hitsPerPage || 1e3
            };
            return (0, $goxFl.createIterablePromise)({
                func: (previousResponse)=>{
                    return this.searchRules({
                        indexName: indexName,
                        searchRulesParams: {
                            ...params,
                            page: previousResponse ? previousResponse.page + 1 : params.page || 0
                        }
                    }, requestOptions);
                },
                validate: (response)=>response.hits.length < params.hitsPerPage,
                ...browseRulesOptions
            });
        },
        /**
     * Helper: Iterate on the `searchSynonyms` method of the client to allow aggregating rules of an index.
     *
     * @summary Helper method that iterates on the `searchSynonyms` method.
     * @param browseSynonyms - The `browseSynonyms` object.
     * @param browseSynonyms.indexName - The index in which to perform the request.
     * @param browseSynonyms.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is less hits returned than the number of maximum hits (1000).
     * @param browseSynonyms.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param browseSynonyms.searchSynonymsParams - The `searchSynonyms` method parameters.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `searchSynonyms` method and merged with the transporter requestOptions.
     */ browseSynonyms ({ indexName: indexName, searchSynonymsParams: searchSynonymsParams, ...browseSynonymsOptions }, requestOptions) {
            const params = {
                ...searchSynonymsParams,
                page: searchSynonymsParams?.page || 0,
                hitsPerPage: 1e3
            };
            return (0, $goxFl.createIterablePromise)({
                func: (_)=>{
                    const resp = this.searchSynonyms({
                        indexName: indexName,
                        searchSynonymsParams: {
                            ...params,
                            page: params.page
                        }
                    }, requestOptions);
                    params.page += 1;
                    return resp;
                },
                validate: (response)=>response.hits.length < params.hitsPerPage,
                ...browseSynonymsOptions
            });
        },
        /**
     * Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     *
     * @summary Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     * @param chunkedBatch - The `chunkedBatch` object.
     * @param chunkedBatch.indexName - The `indexName` to replace `objects` in.
     * @param chunkedBatch.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param chunkedBatch.action - The `batch` `action` to perform on the given array of `objects`, defaults to `addObject`.
     * @param chunkedBatch.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param chunkedBatch.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ async chunkedBatch ({ indexName: indexName, objects: objects, action: action = "addObject", waitForTasks: waitForTasks, batchSize: batchSize = 1e3 }, requestOptions) {
            let requests = [];
            const responses = [];
            const objectEntries = objects.entries();
            for (const [i, obj] of objectEntries){
                requests.push({
                    action: action,
                    body: obj
                });
                if (requests.length === batchSize || i === objects.length - 1) {
                    responses.push(await this.batch({
                        indexName: indexName,
                        batchWriteParams: {
                            requests: requests
                        }
                    }, requestOptions));
                    requests = [];
                }
            }
            if (waitForTasks) for (const resp of responses)await this.waitForTask({
                indexName: indexName,
                taskID: resp.taskID
            });
            return responses;
        },
        /**
     * Helper: Saves the given array of objects in the given index. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     *
     * @summary Helper: Saves the given array of objects in the given index. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     * @param saveObjects - The `saveObjects` object.
     * @param saveObjects.indexName - The `indexName` to save `objects` in.
     * @param saveObjects.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param saveObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param saveObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch` method and merged with the transporter requestOptions.
     */ async saveObjects ({ indexName: indexName, objects: objects, waitForTasks: waitForTasks, batchSize: batchSize }, requestOptions) {
            return await this.chunkedBatch({
                indexName: indexName,
                objects: objects,
                action: "addObject",
                waitForTasks: waitForTasks,
                batchSize: batchSize
            }, requestOptions);
        },
        /**
     * Helper: Deletes every records for the given objectIDs. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objectIDs in it.
     *
     * @summary Helper: Deletes every records for the given objectIDs. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objectIDs in it.
     * @param deleteObjects - The `deleteObjects` object.
     * @param deleteObjects.indexName - The `indexName` to delete `objectIDs` from.
     * @param deleteObjects.objectIDs - The objectIDs to delete.
     * @param deleteObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param deleteObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch` method and merged with the transporter requestOptions.
     */ async deleteObjects ({ indexName: indexName, objectIDs: objectIDs, waitForTasks: waitForTasks, batchSize: batchSize }, requestOptions) {
            return await this.chunkedBatch({
                indexName: indexName,
                objects: objectIDs.map((objectID)=>({
                        objectID: objectID
                    })),
                action: "deleteObject",
                waitForTasks: waitForTasks,
                batchSize: batchSize
            }, requestOptions);
        },
        /**
     * Helper: Replaces object content of all the given objects according to their respective `objectID` field. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     *
     * @summary Helper: Replaces object content of all the given objects according to their respective `objectID` field. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     * @param partialUpdateObjects - The `partialUpdateObjects` object.
     * @param partialUpdateObjects.indexName - The `indexName` to update `objects` in.
     * @param partialUpdateObjects.objects - The array of `objects` to update in the given Algolia `indexName`.
     * @param partialUpdateObjects.createIfNotExists - To be provided if non-existing objects are passed, otherwise, the call will fail..
     * @param partialUpdateObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param partialUpdateObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */ async partialUpdateObjects ({ indexName: indexName, objects: objects, createIfNotExists: createIfNotExists, waitForTasks: waitForTasks, batchSize: batchSize }, requestOptions) {
            return await this.chunkedBatch({
                indexName: indexName,
                objects: objects,
                action: createIfNotExists ? "partialUpdateObject" : "partialUpdateObjectNoCreate",
                batchSize: batchSize,
                waitForTasks: waitForTasks
            }, requestOptions);
        },
        /**
     * Helper: Replaces all objects (records) in the given `index_name` with the given `objects`. A temporary index is created during this process in order to backup your data.
     * See https://api-clients-automation.netlify.app/docs/add-new-api-client#5-helpers for implementation details.
     *
     * @summary Helper: Replaces all objects (records) in the given `index_name` with the given `objects`. A temporary index is created during this process in order to backup your data.
     * @param replaceAllObjects - The `replaceAllObjects` object.
     * @param replaceAllObjects.indexName - The `indexName` to replace `objects` in.
     * @param replaceAllObjects.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param replaceAllObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `objects.length / batchSize`. Defaults to 1000.
     * @param replaceAllObjects.scopes - The `scopes` to keep from the index. Defaults to ['settings', 'rules', 'synonyms'].
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch`, `operationIndex` and `getTask` method and merged with the transporter requestOptions.
     */ async replaceAllObjects ({ indexName: indexName, objects: objects, batchSize: batchSize, scopes: scopes }, requestOptions) {
            const randomSuffix = Math.floor(Math.random() * 1e6) + 1e5;
            const tmpIndexName = `${indexName}_tmp_${randomSuffix}`;
            if (scopes === void 0) scopes = [
                "settings",
                "rules",
                "synonyms"
            ];
            try {
                let copyOperationResponse = await this.operationIndex({
                    indexName: indexName,
                    operationIndexParams: {
                        operation: "copy",
                        destination: tmpIndexName,
                        scope: scopes
                    }
                }, requestOptions);
                const batchResponses = await this.chunkedBatch({
                    indexName: tmpIndexName,
                    objects: objects,
                    waitForTasks: true,
                    batchSize: batchSize
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: copyOperationResponse.taskID
                });
                copyOperationResponse = await this.operationIndex({
                    indexName: indexName,
                    operationIndexParams: {
                        operation: "copy",
                        destination: tmpIndexName,
                        scope: scopes
                    }
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: copyOperationResponse.taskID
                });
                const moveOperationResponse = await this.operationIndex({
                    indexName: tmpIndexName,
                    operationIndexParams: {
                        operation: "move",
                        destination: indexName
                    }
                }, requestOptions);
                await this.waitForTask({
                    indexName: tmpIndexName,
                    taskID: moveOperationResponse.taskID
                });
                return {
                    copyOperationResponse: copyOperationResponse,
                    batchResponses: batchResponses,
                    moveOperationResponse: moveOperationResponse
                };
            } catch (error) {
                await this.deleteIndex({
                    indexName: tmpIndexName
                });
                throw error;
            }
        },
        async indexExists ({ indexName: indexName }) {
            try {
                await this.getSettings({
                    indexName: indexName
                });
            } catch (error) {
                if (error instanceof (0, $goxFl.ApiError) && error.status === 404) return false;
                throw error;
            }
            return true;
        },
        /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia records (hits) and not facets.
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `hits` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `hits`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForHits (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia facets and not records (hits).
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `facets` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `facets`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForFacets (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
     * Creates a new API key with specific permissions and restrictions.
     *
     * Required API Key ACLs:
     *  - admin
     * @param apiKey - The apiKey object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ addApiKey (apiKey, requestOptions) {
            if (!apiKey) throw new Error("Parameter `apiKey` is required when calling `addApiKey`.");
            if (!apiKey.acl) throw new Error("Parameter `apiKey.acl` is required when calling `addApiKey`.");
            const requestPath = "/1/keys";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: apiKey
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a record with the specified object ID exists, the existing record is replaced. Otherwise, a new record is added to the index.  If you want to use auto-generated object IDs, use the [`saveObject` operation](#tag/Records/operation/saveObject). To update _some_ attributes of an existing record, use the [`partial` operation](#tag/Records/operation/partialUpdateObject) instead. To add, update, or replace multiple records, use the [`batch` operation](#tag/Records/operation/batch).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param addOrUpdateObject - The addOrUpdateObject object.
     * @param addOrUpdateObject.indexName - Name of the index on which to perform the operation.
     * @param addOrUpdateObject.objectID - Unique record identifier.
     * @param addOrUpdateObject.body - The record. A schemaless object with attributes that are useful in the context of search and discovery.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ addOrUpdateObject ({ indexName: indexName, objectID: objectID, body: body }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `addOrUpdateObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `addOrUpdateObject`.");
            if (!body) throw new Error("Parameter `body` is required when calling `addOrUpdateObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds a source to the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param source - Source to add.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ appendSource (source, requestOptions) {
            if (!source) throw new Error("Parameter `source` is required when calling `appendSource`.");
            if (!source.source) throw new Error("Parameter `source.source` is required when calling `appendSource`.");
            const requestPath = "/1/security/sources/append";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: source
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Assigns or moves a user ID to a cluster.  The time it takes to move a user is proportional to the amount of data linked to the user ID.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param assignUserId - The assignUserId object.
     * @param assignUserId.xAlgoliaUserID - Unique identifier of the user who makes the search request.
     * @param assignUserId.assignUserIdParams - The assignUserIdParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ assignUserId ({ xAlgoliaUserID: xAlgoliaUserID, assignUserIdParams: assignUserIdParams }, requestOptions) {
            if (!xAlgoliaUserID) throw new Error("Parameter `xAlgoliaUserID` is required when calling `assignUserId`.");
            if (!assignUserIdParams) throw new Error("Parameter `assignUserIdParams` is required when calling `assignUserId`.");
            if (!assignUserIdParams.cluster) throw new Error("Parameter `assignUserIdParams.cluster` is required when calling `assignUserId`.");
            const requestPath = "/1/clusters/mapping";
            const headers = {};
            const queryParameters = {};
            if (xAlgoliaUserID !== void 0) headers["X-Algolia-User-ID"] = xAlgoliaUserID.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: assignUserIdParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds, updates, or deletes records in one index with a single API request.  Batching index updates reduces latency and increases data integrity.  - Actions are applied in the order they\'re specified. - Actions are equivalent to the individual API requests of the same name.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     * @param batch - The batch object.
     * @param batch.indexName - Name of the index on which to perform the operation.
     * @param batch.batchWriteParams - The batchWriteParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batch ({ indexName: indexName, batchWriteParams: batchWriteParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `batch`.");
            if (!batchWriteParams) throw new Error("Parameter `batchWriteParams` is required when calling `batch`.");
            if (!batchWriteParams.requests) throw new Error("Parameter `batchWriteParams.requests` is required when calling `batch`.");
            const requestPath = "/1/indexes/{indexName}/batch".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchWriteParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Assigns multiple user IDs to a cluster.  **You can\'t move users with this operation**.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param batchAssignUserIds - The batchAssignUserIds object.
     * @param batchAssignUserIds.xAlgoliaUserID - Unique identifier of the user who makes the search request.
     * @param batchAssignUserIds.batchAssignUserIdsParams - The batchAssignUserIdsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batchAssignUserIds ({ xAlgoliaUserID: xAlgoliaUserID, batchAssignUserIdsParams: batchAssignUserIdsParams }, requestOptions) {
            if (!xAlgoliaUserID) throw new Error("Parameter `xAlgoliaUserID` is required when calling `batchAssignUserIds`.");
            if (!batchAssignUserIdsParams) throw new Error("Parameter `batchAssignUserIdsParams` is required when calling `batchAssignUserIds`.");
            if (!batchAssignUserIdsParams.cluster) throw new Error("Parameter `batchAssignUserIdsParams.cluster` is required when calling `batchAssignUserIds`.");
            if (!batchAssignUserIdsParams.users) throw new Error("Parameter `batchAssignUserIdsParams.users` is required when calling `batchAssignUserIds`.");
            const requestPath = "/1/clusters/mapping/batch";
            const headers = {};
            const queryParameters = {};
            if (xAlgoliaUserID !== void 0) headers["X-Algolia-User-ID"] = xAlgoliaUserID.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchAssignUserIdsParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds or deletes multiple entries from your plurals, segmentation, or stop word dictionaries.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param batchDictionaryEntries - The batchDictionaryEntries object.
     * @param batchDictionaryEntries.dictionaryName - Dictionary type in which to search.
     * @param batchDictionaryEntries.batchDictionaryEntriesParams - The batchDictionaryEntriesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batchDictionaryEntries ({ dictionaryName: dictionaryName, batchDictionaryEntriesParams: batchDictionaryEntriesParams }, requestOptions) {
            if (!dictionaryName) throw new Error("Parameter `dictionaryName` is required when calling `batchDictionaryEntries`.");
            if (!batchDictionaryEntriesParams) throw new Error("Parameter `batchDictionaryEntriesParams` is required when calling `batchDictionaryEntries`.");
            if (!batchDictionaryEntriesParams.requests) throw new Error("Parameter `batchDictionaryEntriesParams.requests` is required when calling `batchDictionaryEntries`.");
            const requestPath = "/1/dictionaries/{dictionaryName}/batch".replace("{dictionaryName}", encodeURIComponent(dictionaryName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchDictionaryEntriesParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves records from an index, up to 1,000 per request.  While searching retrieves _hits_ (records augmented with attributes for highlighting and ranking details), browsing _just_ returns matching records. This can be useful if you want to export your indices.  - The Analytics API doesn\'t collect data when using `browse`. - Records are ranked by attributes and custom ranking. - There\'s no ranking for: typo-tolerance, number of matched words, proximity, geo distance.  Browse requests automatically apply these settings:  - `advancedSyntax`: `false` - `attributesToHighlight`: `[]` - `attributesToSnippet`: `[]` - `distinct`: `false` - `enablePersonalization`: `false` - `enableRules`: `false` - `facets`: `[]` - `getRankingInfo`: `false` - `ignorePlurals`: `false` - `optionalFilters`: `[]` - `typoTolerance`: `true` or `false` (`min` and `strict` evaluate to `true`)  If you send these parameters with your browse requests, they\'ll be ignored.
     *
     * Required API Key ACLs:
     *  - browse
     * @param browse - The browse object.
     * @param browse.indexName - Name of the index on which to perform the operation.
     * @param browse.browseParams - The browseParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ browse ({ indexName: indexName, browseParams: browseParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `browse`.");
            const requestPath = "/1/indexes/{indexName}/browse".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: browseParams ? browseParams : {},
                useReadTransporter: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes only the records from an index while keeping settings, synonyms, and rules. This operation is resource-intensive and subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param clearObjects - The clearObjects object.
     * @param clearObjects.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ clearObjects ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `clearObjects`.");
            const requestPath = "/1/indexes/{indexName}/clear".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes all rules from the index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param clearRules - The clearRules object.
     * @param clearRules.indexName - Name of the index on which to perform the operation.
     * @param clearRules.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ clearRules ({ indexName: indexName, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `clearRules`.");
            const requestPath = "/1/indexes/{indexName}/rules/clear".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes all synonyms from the index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param clearSynonyms - The clearSynonyms object.
     * @param clearSynonyms.indexName - Name of the index on which to perform the operation.
     * @param clearSynonyms.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ clearSynonyms ({ indexName: indexName, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `clearSynonyms`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/clear".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes the API key.
     *
     * Required API Key ACLs:
     *  - admin
     * @param deleteApiKey - The deleteApiKey object.
     * @param deleteApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteApiKey ({ key: key }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `deleteApiKey`.");
            const requestPath = "/1/keys/{key}".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This operation doesn\'t accept empty filters.  This operation is resource-intensive. You should only use it if you can\'t get the object IDs of the records you want to delete. It\'s more efficient to get a list of object IDs with the [`browse` operation](#tag/Search/operation/browse), and then delete the records using the [`batch` operation](#tag/Records/operation/batch).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param deleteBy - The deleteBy object.
     * @param deleteBy.indexName - Name of the index on which to perform the operation.
     * @param deleteBy.deleteByParams - The deleteByParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteBy ({ indexName: indexName, deleteByParams: deleteByParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteBy`.");
            if (!deleteByParams) throw new Error("Parameter `deleteByParams` is required when calling `deleteBy`.");
            const requestPath = "/1/indexes/{indexName}/deleteByQuery".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: deleteByParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes an index and all its settings.  - Deleting an index doesn\'t delete its analytics data. - If you try to delete a non-existing index, the operation is ignored without warning. - If the index you want to delete has replica indices, the replicas become independent indices. - If the index you want to delete is a replica index, you must first unlink it from its primary index before you can delete it.   For more information, see [Delete replica indices](https://www.algolia.com/doc/guides/managing-results/refine-results/sorting/how-to/deleting-replicas/).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param deleteIndex - The deleteIndex object.
     * @param deleteIndex.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteIndex ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteIndex`.");
            const requestPath = "/1/indexes/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a record by its object ID.  To delete more than one record, use the [`batch` operation](#tag/Records/operation/batch). To delete records matching a query, use the [`deleteBy` operation](#tag/Records/operation/deleteBy).
     *
     * Required API Key ACLs:
     *  - deleteObject
     * @param deleteObject - The deleteObject object.
     * @param deleteObject.indexName - Name of the index on which to perform the operation.
     * @param deleteObject.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteObject ({ indexName: indexName, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a rule by its ID. To find the object ID for rules, use the [`search` operation](#tag/Rules/operation/searchRules).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteRule - The deleteRule object.
     * @param deleteRule.indexName - Name of the index on which to perform the operation.
     * @param deleteRule.objectID - Unique identifier of a rule object.
     * @param deleteRule.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteRule ({ indexName: indexName, objectID: objectID, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteRule`.");
            const requestPath = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a source from the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param deleteSource - The deleteSource object.
     * @param deleteSource.source - IP address range of the source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteSource ({ source: source }, requestOptions) {
            if (!source) throw new Error("Parameter `source` is required when calling `deleteSource`.");
            const requestPath = "/1/security/sources/{source}".replace("{source}", encodeURIComponent(source));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a synonym by its ID. To find the object IDs of your synonyms, use the [`search` operation](#tag/Synonyms/operation/searchSynonyms).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteSynonym - The deleteSynonym object.
     * @param deleteSynonym.indexName - Name of the index on which to perform the operation.
     * @param deleteSynonym.objectID - Unique identifier of a synonym object.
     * @param deleteSynonym.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteSynonym ({ indexName: indexName, objectID: objectID, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteSynonym`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteSynonym`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Gets the permissions and restrictions of an API key.  When authenticating with the admin API key, you can request information for any of your application\'s keys. When authenticating with other API keys, you can only retrieve information for that key, with the description replaced by `<redacted>`.
     * @param getApiKey - The getApiKey object.
     * @param getApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getApiKey ({ key: key }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `getApiKey`.");
            const requestPath = "/1/keys/{key}".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Checks the status of a given application task.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param getAppTask - The getAppTask object.
     * @param getAppTask.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAppTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getAppTask`.");
            const requestPath = "/1/task/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists supported languages with their supported dictionary types and number of custom entries.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getDictionaryLanguages (requestOptions) {
            const requestPath = "/1/dictionaries/*/languages";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the languages for which standard dictionary entries are turned off.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getDictionarySettings (requestOptions) {
            const requestPath = "/1/dictionaries/*/settings";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * The request must be authenticated by an API key with the [`logs` ACL](https://www.algolia.com/doc/guides/security/api-keys/#access-control-list-acl).  - Logs are held for the last seven days. - Up to 1,000 API requests per server are logged. - This request counts towards your [operations quota](https://support.algolia.com/hc/en-us/articles/4406981829777-How-does-Algolia-count-records-and-operations-) but doesn\'t appear in the logs itself.
     *
     * Required API Key ACLs:
     *  - logs
     * @param getLogs - The getLogs object.
     * @param getLogs.offset - First log entry to retrieve. The most recent entries are listed first.
     * @param getLogs.length - Maximum number of entries to retrieve.
     * @param getLogs.indexName - Index for which to retrieve log entries. By default, log entries are retrieved for all indices.
     * @param getLogs.type - Type of log entries to retrieve. By default, all log entries are retrieved.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getLogs ({ offset: offset, length: length, indexName: indexName, type: type } = {}, requestOptions) {
            const requestPath = "/1/logs";
            const headers = {};
            const queryParameters = {};
            if (offset !== void 0) queryParameters["offset"] = offset.toString();
            if (length !== void 0) queryParameters["length"] = length.toString();
            if (indexName !== void 0) queryParameters["indexName"] = indexName.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves one record by its object ID.  To retrieve more than one record, use the [`objects` operation](#tag/Records/operation/getObjects).
     *
     * Required API Key ACLs:
     *  - search
     * @param getObject - The getObject object.
     * @param getObject.indexName - Name of the index on which to perform the operation.
     * @param getObject.objectID - Unique record identifier.
     * @param getObject.attributesToRetrieve - Attributes to include with the records in the response. This is useful to reduce the size of the API response. By default, all retrievable attributes are returned.  `objectID` is always retrieved.  Attributes included in `unretrievableAttributes` won\'t be retrieved unless the request is authenticated with the admin API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getObject ({ indexName: indexName, objectID: objectID, attributesToRetrieve: attributesToRetrieve }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (attributesToRetrieve !== void 0) queryParameters["attributesToRetrieve"] = attributesToRetrieve.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves one or more records, potentially from different indices.  Records are returned in the same order as the requests.
     *
     * Required API Key ACLs:
     *  - search
     * @param getObjectsParams - Request object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getObjects (getObjectsParams, requestOptions) {
            if (!getObjectsParams) throw new Error("Parameter `getObjectsParams` is required when calling `getObjects`.");
            if (!getObjectsParams.requests) throw new Error("Parameter `getObjectsParams.requests` is required when calling `getObjects`.");
            const requestPath = "/1/indexes/*/objects";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: getObjectsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a rule by its ID. To find the object ID of rules, use the [`search` operation](#tag/Rules/operation/searchRules).
     *
     * Required API Key ACLs:
     *  - settings
     * @param getRule - The getRule object.
     * @param getRule.indexName - Name of the index on which to perform the operation.
     * @param getRule.objectID - Unique identifier of a rule object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRule ({ indexName: indexName, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getRule`.");
            const requestPath = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves an object with non-null index settings.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getSettings - The getSettings object.
     * @param getSettings.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSettings ({ indexName: indexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getSettings`.");
            const requestPath = "/1/indexes/{indexName}/settings".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves all allowed IP addresses with access to your application.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSources (requestOptions) {
            const requestPath = "/1/security/sources";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a synonym by its ID. To find the object IDs for your synonyms, use the [`search` operation](#tag/Synonyms/operation/searchSynonyms).
     *
     * Required API Key ACLs:
     *  - settings
     * @param getSynonym - The getSynonym object.
     * @param getSynonym.indexName - Name of the index on which to perform the operation.
     * @param getSynonym.objectID - Unique identifier of a synonym object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSynonym ({ indexName: indexName, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getSynonym`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getSynonym`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Checks the status of a given task.  Indexing tasks are asynchronous. When you add, update, or delete records or indices, a task is created on a queue and completed depending on the load on the server.  The indexing tasks\' responses include a task ID that you can use to check the status.
     *
     * Required API Key ACLs:
     *  - addObject
     * @param getTask - The getTask object.
     * @param getTask.indexName - Name of the index on which to perform the operation.
     * @param getTask.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTask ({ indexName: indexName, taskID: taskID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getTask`.");
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getTask`.");
            const requestPath = "/1/indexes/{indexName}/task/{taskID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Get the IDs of the 10 users with the highest number of records per cluster.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTopUserIds (requestOptions) {
            const requestPath = "/1/clusters/mapping/top";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Returns the user ID data stored in the mapping.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param getUserId - The getUserId object.
     * @param getUserId.userID - Unique identifier of the user who makes the search request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getUserId ({ userID: userID }, requestOptions) {
            if (!userID) throw new Error("Parameter `userID` is required when calling `getUserId`.");
            const requestPath = "/1/clusters/mapping/{userID}".replace("{userID}", encodeURIComponent(userID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * To determine when the time-consuming process of creating a large batch of users or migrating users from one cluster to another is complete, this operation retrieves the status of the process.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param hasPendingMappings - The hasPendingMappings object.
     * @param hasPendingMappings.getClusters - Whether to include the cluster\'s pending mapping state in the response.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ hasPendingMappings ({ getClusters: getClusters } = {}, requestOptions) {
            const requestPath = "/1/clusters/mapping/pending";
            const headers = {};
            const queryParameters = {};
            if (getClusters !== void 0) queryParameters["getClusters"] = getClusters.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists all API keys associated with your Algolia application, including their permissions and restrictions.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listApiKeys (requestOptions) {
            const requestPath = "/1/keys";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists the available clusters in a multi-cluster setup.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listClusters (requestOptions) {
            const requestPath = "/1/clusters";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists all indices in the current Algolia application.  The request follows any index restrictions of the API key you use to make the request.
     *
     * Required API Key ACLs:
     *  - listIndexes
     * @param listIndices - The listIndices object.
     * @param listIndices.page - Requested page of the API response. If `null`, the API response is not paginated.
     * @param listIndices.hitsPerPage - Number of hits per page.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listIndices ({ page: page, hitsPerPage: hitsPerPage } = {}, requestOptions) {
            const requestPath = "/1/indexes";
            const headers = {};
            const queryParameters = {};
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (hitsPerPage !== void 0) queryParameters["hitsPerPage"] = hitsPerPage.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Lists the userIDs assigned to a multi-cluster application.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param listUserIds - The listUserIds object.
     * @param listUserIds.page - Requested page of the API response. If `null`, the API response is not paginated.
     * @param listUserIds.hitsPerPage - Number of hits per page.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listUserIds ({ page: page, hitsPerPage: hitsPerPage } = {}, requestOptions) {
            const requestPath = "/1/clusters/mapping";
            const headers = {};
            const queryParameters = {};
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (hitsPerPage !== void 0) queryParameters["hitsPerPage"] = hitsPerPage.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds, updates, or deletes records in multiple indices with a single API request.  - Actions are applied in the order they are specified. - Actions are equivalent to the individual API requests of the same name.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     * @param batchParams - The batchParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ multipleBatch (batchParams, requestOptions) {
            if (!batchParams) throw new Error("Parameter `batchParams` is required when calling `multipleBatch`.");
            if (!batchParams.requests) throw new Error("Parameter `batchParams.requests` is required when calling `multipleBatch`.");
            const requestPath = "/1/indexes/*/batch";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: batchParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Copies or moves (renames) an index within the same Algolia application.  - Existing destination indices are overwritten, except for their analytics data. - If the destination index doesn\'t exist yet, it\'ll be created. - This operation is resource-intensive.  **Copy**  - Copying a source index that doesn\'t exist creates a new index with 0 records and default settings. - The API keys of the source index are merged with the existing keys in the destination index. - You can\'t copy the `enableReRanking`, `mode`, and `replicas` settings. - You can\'t copy to a destination index that already has replicas. - Be aware of the [size limits](https://www.algolia.com/doc/guides/scaling/algolia-service-limits/#application-record-and-index-limits). - Related guide: [Copy indices](https://www.algolia.com/doc/guides/sending-and-managing-data/manage-indices-and-apps/manage-indices/how-to/copy-indices/)  **Move**  - Moving a source index that doesn\'t exist is ignored without returning an error. - When moving an index, the analytics data keeps its original name, and a new set of analytics data is started for the new name.   To access the original analytics in the dashboard, create an index with the original name. - If the destination index has replicas, moving will overwrite the existing index and copy the data to the replica indices. - Related guide: [Move indices](https://www.algolia.com/doc/guides/sending-and-managing-data/manage-indices-and-apps/manage-indices/how-to/move-indices/).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param operationIndex - The operationIndex object.
     * @param operationIndex.indexName - Name of the index on which to perform the operation.
     * @param operationIndex.operationIndexParams - The operationIndexParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ operationIndex ({ indexName: indexName, operationIndexParams: operationIndexParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `operationIndex`.");
            if (!operationIndexParams) throw new Error("Parameter `operationIndexParams` is required when calling `operationIndex`.");
            if (!operationIndexParams.operation) throw new Error("Parameter `operationIndexParams.operation` is required when calling `operationIndex`.");
            if (!operationIndexParams.destination) throw new Error("Parameter `operationIndexParams.destination` is required when calling `operationIndex`.");
            const requestPath = "/1/indexes/{indexName}/operation".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: operationIndexParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds new attributes to a record, or updates existing ones.  - If a record with the specified object ID doesn\'t exist,   a new record is added to the index **if** `createIfNotExists` is true. - If the index doesn\'t exist yet, this method creates a new index. - You can use any first-level attribute but not nested attributes.   If you specify a nested attribute, this operation replaces its first-level ancestor.  To update an attribute without pushing the entire record, you can use these built-in operations. These operations can be helpful if you don\'t have access to your initial data.  - Increment: increment a numeric attribute - Decrement: decrement a numeric attribute - Add: append a number or string element to an array attribute - Remove: remove all matching number or string elements from an array attribute made of numbers or strings - AddUnique: add a number or string element to an array attribute made of numbers or strings only if it\'s not already present - IncrementFrom: increment a numeric integer attribute only if the provided value matches the current value, and otherwise ignore the whole object update. For example, if you pass an IncrementFrom value of 2 for the version attribute, but the current value of the attribute is 1, the engine ignores the update. If the object doesn\'t exist, the engine only creates it if you pass an IncrementFrom value of 0. - IncrementSet: increment a numeric integer attribute only if the provided value is greater than the current value, and otherwise ignore the whole object update. For example, if you pass an IncrementSet value of 2 for the version attribute, and the current value of the attribute is 1, the engine updates the object. If the object doesn\'t exist yet, the engine only creates it if you pass an IncrementSet value greater than 0.  You can specify an operation by providing an object with the attribute to update as the key and its value being an object with the following properties:  - _operation: the operation to apply on the attribute - value: the right-hand side argument to the operation, for example, increment or decrement step, value to add or remove.  When updating multiple attributes or using multiple operations targeting the same record, you should use a single partial update for faster processing.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param partialUpdateObject - The partialUpdateObject object.
     * @param partialUpdateObject.indexName - Name of the index on which to perform the operation.
     * @param partialUpdateObject.objectID - Unique record identifier.
     * @param partialUpdateObject.attributesToUpdate - Attributes with their values.
     * @param partialUpdateObject.createIfNotExists - Whether to create a new record if it doesn\'t exist.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ partialUpdateObject ({ indexName: indexName, objectID: objectID, attributesToUpdate: attributesToUpdate, createIfNotExists: createIfNotExists }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `partialUpdateObject`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `partialUpdateObject`.");
            if (!attributesToUpdate) throw new Error("Parameter `attributesToUpdate` is required when calling `partialUpdateObject`.");
            const requestPath = "/1/indexes/{indexName}/{objectID}/partial".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (createIfNotExists !== void 0) queryParameters["createIfNotExists"] = createIfNotExists.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: attributesToUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a user ID and its associated data from the clusters.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param removeUserId - The removeUserId object.
     * @param removeUserId.userID - Unique identifier of the user who makes the search request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ removeUserId ({ userID: userID }, requestOptions) {
            if (!userID) throw new Error("Parameter `userID` is required when calling `removeUserId`.");
            const requestPath = "/1/clusters/mapping/{userID}".replace("{userID}", encodeURIComponent(userID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Replaces the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param replaceSources - The replaceSources object.
     * @param replaceSources.source - Allowed sources.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ replaceSources ({ source: source }, requestOptions) {
            if (!source) throw new Error("Parameter `source` is required when calling `replaceSources`.");
            const requestPath = "/1/security/sources";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: source
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Restores a deleted API key.  Restoring resets the `validity` attribute to `0`.  Algolia stores up to 1,000 API keys per application. If you create more, the oldest API keys are deleted and can\'t be restored.
     *
     * Required API Key ACLs:
     *  - admin
     * @param restoreApiKey - The restoreApiKey object.
     * @param restoreApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ restoreApiKey ({ key: key }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `restoreApiKey`.");
            const requestPath = "/1/keys/{key}/restore".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Adds a record to an index or replaces it.  - If the record doesn\'t have an object ID, a new record with an auto-generated object ID is added to your index. - If a record with the specified object ID exists, the existing record is replaced. - If a record with the specified object ID doesn\'t exist, a new record is added to your index. - If you add a record to an index that doesn\'t exist yet, a new index is created.  To update _some_ attributes of a record, use the [`partial` operation](#tag/Records/operation/partialUpdateObject). To add, update, or replace multiple records, use the [`batch` operation](#tag/Records/operation/batch).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param saveObject - The saveObject object.
     * @param saveObject.indexName - Name of the index on which to perform the operation.
     * @param saveObject.body - The record. A schemaless object with attributes that are useful in the context of search and discovery.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveObject ({ indexName: indexName, body: body }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveObject`.");
            if (!body) throw new Error("Parameter `body` is required when calling `saveObject`.");
            const requestPath = "/1/indexes/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a rule with the specified object ID doesn\'t exist, it\'s created. Otherwise, the existing rule is replaced.  To create or update more than one rule, use the [`batch` operation](#tag/Rules/operation/saveRules).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveRule - The saveRule object.
     * @param saveRule.indexName - Name of the index on which to perform the operation.
     * @param saveRule.objectID - Unique identifier of a rule object.
     * @param saveRule.rule - The rule object.
     * @param saveRule.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveRule ({ indexName: indexName, objectID: objectID, rule: rule, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `saveRule`.");
            if (!rule) throw new Error("Parameter `rule` is required when calling `saveRule`.");
            if (!rule.objectID) throw new Error("Parameter `rule.objectID` is required when calling `saveRule`.");
            if (!rule.consequence) throw new Error("Parameter `rule.consequence` is required when calling `saveRule`.");
            const requestPath = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: rule
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Create or update multiple rules.  If a rule with the specified object ID doesn\'t exist, Algolia creates a new one. Otherwise, existing rules are replaced.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveRules - The saveRules object.
     * @param saveRules.indexName - Name of the index on which to perform the operation.
     * @param saveRules.rules - The rules object.
     * @param saveRules.forwardToReplicas - Whether changes are applied to replica indices.
     * @param saveRules.clearExistingRules - Whether existing rules should be deleted before adding this batch.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveRules ({ indexName: indexName, rules: rules, forwardToReplicas: forwardToReplicas, clearExistingRules: clearExistingRules }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveRules`.");
            if (!rules) throw new Error("Parameter `rules` is required when calling `saveRules`.");
            const requestPath = "/1/indexes/{indexName}/rules/batch".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            if (clearExistingRules !== void 0) queryParameters["clearExistingRules"] = clearExistingRules.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: rules
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a synonym with the specified object ID doesn\'t exist, Algolia adds a new one. Otherwise, the existing synonym is replaced. To add multiple synonyms in a single API request, use the [`batch` operation](#tag/Synonyms/operation/saveSynonyms).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveSynonym - The saveSynonym object.
     * @param saveSynonym.indexName - Name of the index on which to perform the operation.
     * @param saveSynonym.objectID - Unique identifier of a synonym object.
     * @param saveSynonym.synonymHit - The synonymHit object.
     * @param saveSynonym.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveSynonym ({ indexName: indexName, objectID: objectID, synonymHit: synonymHit, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveSynonym`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `saveSynonym`.");
            if (!synonymHit) throw new Error("Parameter `synonymHit` is required when calling `saveSynonym`.");
            if (!synonymHit.objectID) throw new Error("Parameter `synonymHit.objectID` is required when calling `saveSynonym`.");
            if (!synonymHit.type) throw new Error("Parameter `synonymHit.type` is required when calling `saveSynonym`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: synonymHit
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * If a synonym with the `objectID` doesn\'t exist, Algolia adds a new one. Otherwise, existing synonyms are replaced.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/en-us/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveSynonyms - The saveSynonyms object.
     * @param saveSynonyms.indexName - Name of the index on which to perform the operation.
     * @param saveSynonyms.synonymHit - The synonymHit object.
     * @param saveSynonyms.forwardToReplicas - Whether changes are applied to replica indices.
     * @param saveSynonyms.replaceExistingSynonyms - Whether to replace all synonyms in the index with the ones sent with this request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ saveSynonyms ({ indexName: indexName, synonymHit: synonymHit, forwardToReplicas: forwardToReplicas, replaceExistingSynonyms: replaceExistingSynonyms }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `saveSynonyms`.");
            if (!synonymHit) throw new Error("Parameter `synonymHit` is required when calling `saveSynonyms`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/batch".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            if (replaceExistingSynonyms !== void 0) queryParameters["replaceExistingSynonyms"] = replaceExistingSynonyms.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: synonymHit
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Sends multiple search requests to one or more indices.  This can be useful in these cases:  - Different indices for different purposes, such as, one index for products, another one for marketing content. - Multiple searches to the same index—for example, with different filters.  Use the helper `searchForHits` or `searchForFacets` to get the results in a more convenient format, if you already know the return type you want.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchMethodParams - Muli-search request body. Results are returned in the same order as the requests.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ search (searchMethodParams, requestOptions) {
            if (searchMethodParams && Array.isArray(searchMethodParams)) {
                const newSignatureRequest = {
                    requests: searchMethodParams.map(({ params: params, ...legacyRequest })=>{
                        if (legacyRequest.type === "facet") return {
                            ...legacyRequest,
                            ...params,
                            type: "facet"
                        };
                        return {
                            ...legacyRequest,
                            ...params,
                            facet: void 0,
                            maxFacetHits: void 0,
                            facetQuery: void 0
                        };
                    })
                };
                searchMethodParams = newSignatureRequest;
            }
            if (!searchMethodParams) throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
            if (!searchMethodParams.requests) throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
            const requestPath = "/1/indexes/*/queries";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchMethodParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for standard and custom dictionary entries.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchDictionaryEntries - The searchDictionaryEntries object.
     * @param searchDictionaryEntries.dictionaryName - Dictionary type in which to search.
     * @param searchDictionaryEntries.searchDictionaryEntriesParams - The searchDictionaryEntriesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchDictionaryEntries ({ dictionaryName: dictionaryName, searchDictionaryEntriesParams: searchDictionaryEntriesParams }, requestOptions) {
            if (!dictionaryName) throw new Error("Parameter `dictionaryName` is required when calling `searchDictionaryEntries`.");
            if (!searchDictionaryEntriesParams) throw new Error("Parameter `searchDictionaryEntriesParams` is required when calling `searchDictionaryEntries`.");
            if (!searchDictionaryEntriesParams.query) throw new Error("Parameter `searchDictionaryEntriesParams.query` is required when calling `searchDictionaryEntries`.");
            const requestPath = "/1/dictionaries/{dictionaryName}/search".replace("{dictionaryName}", encodeURIComponent(dictionaryName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchDictionaryEntriesParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for values of a specified facet attribute.  - By default, facet values are sorted by decreasing count.   You can adjust this with the `sortFacetValueBy` parameter. - Searching for facet values doesn\'t work if you have **more than 65 searchable facets and searchable attributes combined**.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchForFacetValues - The searchForFacetValues object.
     * @param searchForFacetValues.indexName - Name of the index on which to perform the operation.
     * @param searchForFacetValues.facetName - Facet attribute in which to search for values.  This attribute must be included in the `attributesForFaceting` index setting with the `searchable()` modifier.
     * @param searchForFacetValues.searchForFacetValuesRequest - The searchForFacetValuesRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForFacetValues ({ indexName: indexName, facetName: facetName, searchForFacetValuesRequest: searchForFacetValuesRequest }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchForFacetValues`.");
            if (!facetName) throw new Error("Parameter `facetName` is required when calling `searchForFacetValues`.");
            const requestPath = "/1/indexes/{indexName}/facets/{facetName}/query".replace("{indexName}", encodeURIComponent(indexName)).replace("{facetName}", encodeURIComponent(facetName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchForFacetValuesRequest ? searchForFacetValuesRequest : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for rules in your index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchRules - The searchRules object.
     * @param searchRules.indexName - Name of the index on which to perform the operation.
     * @param searchRules.searchRulesParams - The searchRulesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchRules ({ indexName: indexName, searchRulesParams: searchRulesParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchRules`.");
            const requestPath = "/1/indexes/{indexName}/rules/search".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchRulesParams ? searchRulesParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches a single index and returns matching search results (_hits_).  This method lets you retrieve up to 1,000 hits. If you need more, use the [`browse` operation](#tag/Search/operation/browse) or increase the `paginatedLimitedTo` index setting.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchSingleIndex - The searchSingleIndex object.
     * @param searchSingleIndex.indexName - Name of the index on which to perform the operation.
     * @param searchSingleIndex.searchParams - The searchParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchSingleIndex ({ indexName: indexName, searchParams: searchParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchSingleIndex`.");
            const requestPath = "/1/indexes/{indexName}/query".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchParams ? searchParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for synonyms in your index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchSynonyms - The searchSynonyms object.
     * @param searchSynonyms.indexName - Name of the index on which to perform the operation.
     * @param searchSynonyms.searchSynonymsParams - Body of the `searchSynonyms` operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchSynonyms ({ indexName: indexName, searchSynonymsParams: searchSynonymsParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchSynonyms`.");
            const requestPath = "/1/indexes/{indexName}/synonyms/search".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchSynonymsParams ? searchSynonymsParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.  To ensure rapid updates, the user IDs index isn\'t built at the same time as the mapping. Instead, it\'s built every 12 hours, at the same time as the update of user ID usage. For example, if you add or move a user ID, the search will show an old value until the next time the mapping is rebuilt (every 12 hours).
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param searchUserIdsParams - The searchUserIdsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchUserIds (searchUserIdsParams, requestOptions) {
            if (!searchUserIdsParams) throw new Error("Parameter `searchUserIdsParams` is required when calling `searchUserIds`.");
            if (!searchUserIdsParams.query) throw new Error("Parameter `searchUserIdsParams.query` is required when calling `searchUserIds`.");
            const requestPath = "/1/clusters/mapping/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchUserIdsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Turns standard stop word dictionary entries on or off for a given language.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param dictionarySettingsParams - The dictionarySettingsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ setDictionarySettings (dictionarySettingsParams, requestOptions) {
            if (!dictionarySettingsParams) throw new Error("Parameter `dictionarySettingsParams` is required when calling `setDictionarySettings`.");
            if (!dictionarySettingsParams.disableStandardEntries) throw new Error("Parameter `dictionarySettingsParams.disableStandardEntries` is required when calling `setDictionarySettings`.");
            const requestPath = "/1/dictionaries/*/settings";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: dictionarySettingsParams
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Update the specified index settings.  Index settings that you don\'t specify are left unchanged. Specify `null` to reset a setting to its default value.  For best performance, update the index settings before you add new records to your index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param setSettings - The setSettings object.
     * @param setSettings.indexName - Name of the index on which to perform the operation.
     * @param setSettings.indexSettings - The indexSettings object.
     * @param setSettings.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ setSettings ({ indexName: indexName, indexSettings: indexSettings, forwardToReplicas: forwardToReplicas }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `setSettings`.");
            if (!indexSettings) throw new Error("Parameter `indexSettings` is required when calling `setSettings`.");
            const requestPath = "/1/indexes/{indexName}/settings".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (forwardToReplicas !== void 0) queryParameters["forwardToReplicas"] = forwardToReplicas.toString();
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: indexSettings
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Replaces the permissions of an existing API key.  Any unspecified attribute resets that attribute to its default value.
     *
     * Required API Key ACLs:
     *  - admin
     * @param updateApiKey - The updateApiKey object.
     * @param updateApiKey.key - API key.
     * @param updateApiKey.apiKey - The apiKey object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateApiKey ({ key: key, apiKey: apiKey }, requestOptions) {
            if (!key) throw new Error("Parameter `key` is required when calling `updateApiKey`.");
            if (!apiKey) throw new Error("Parameter `apiKey` is required when calling `updateApiKey`.");
            if (!apiKey.acl) throw new Error("Parameter `apiKey.acl` is required when calling `updateApiKey`.");
            const requestPath = "/1/keys/{key}".replace("{key}", encodeURIComponent(key));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: apiKey
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $f334aa6bd8d96f3d$export$b72856d058786d12(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $f334aa6bd8d96f3d$var$createSearchClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$f334aa6bd8d96f3d$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("jCVbX", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $e49dee0eba8824c9$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "isOnDemandTrigger", function () { return $e49dee0eba8824c9$export$1d06324d5774046d; });
$parcel$export(module.exports, "isScheduleTrigger", function () { return $e49dee0eba8824c9$export$fe93fab81010f657; });
$parcel$export(module.exports, "isSubscriptionTrigger", function () { return $e49dee0eba8824c9$export$354f27d77e7d8bdc; });
$parcel$export(module.exports, "ingestionClient", function () { return $e49dee0eba8824c9$export$f458e77ddebad4b; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $e49dee0eba8824c9$export$ad1dfbed11feb646 = "1.35.0";
var $e49dee0eba8824c9$var$REGIONS = [
    "eu",
    "us"
];
function $e49dee0eba8824c9$var$getDefaultHosts(region) {
    const url = "data.{region}.algolia.com".replace("{region}", region);
    return [
        {
            url: url,
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $e49dee0eba8824c9$export$1d06324d5774046d(trigger) {
    return trigger.type === "onDemand";
}
function $e49dee0eba8824c9$export$fe93fab81010f657(trigger) {
    return trigger.type === "schedule";
}
function $e49dee0eba8824c9$export$354f27d77e7d8bdc(trigger) {
    return trigger.type === "subscription";
}
function $e49dee0eba8824c9$var$createIngestionClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, region: regionOption, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $e49dee0eba8824c9$var$getDefaultHosts(regionOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Ingestion",
            version: $e49dee0eba8824c9$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `push` requests by leveraging the Transformation pipeline setup in the Push connector (https://www.algolia.com/doc/guides/sending-and-managing-data/send-and-update-your-data/connectors/push/).
     *
     * @summary Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     * @param chunkedPush - The `chunkedPush` object.
     * @param chunkedPush.indexName - The `indexName` to replace `objects` in.
     * @param chunkedPush.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param chunkedPush.action - The `batch` `action` to perform on the given array of `objects`, defaults to `addObject`.
     * @param chunkedPush.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param chunkedPush.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param chunkedPush.referenceIndexName - This is required when targeting an index that does not have a push connector setup (e.g. a tmp index), but you wish to attach another index's transformation to it (e.g. the source index name).
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getEvent` method and merged with the transporter requestOptions.
     */ async chunkedPush ({ indexName: indexName, objects: objects, action: action = "addObject", waitForTasks: waitForTasks, batchSize: batchSize = 1e3, referenceIndexName: referenceIndexName }, requestOptions) {
            let records = [];
            let offset = 0;
            const responses = [];
            const waitBatchSize = Math.floor(batchSize / 10) || batchSize;
            const objectEntries = objects.entries();
            for (const [i, obj] of objectEntries){
                records.push(obj);
                if (records.length === batchSize || i === objects.length - 1) {
                    responses.push(await this.push({
                        indexName: indexName,
                        pushTaskPayload: {
                            action: action,
                            records: records
                        },
                        referenceIndexName: referenceIndexName
                    }, requestOptions));
                    records = [];
                }
                if (waitForTasks && responses.length > 0 && (responses.length % waitBatchSize === 0 || i === objects.length - 1)) {
                    for (const resp of responses.slice(offset, offset + waitBatchSize)){
                        if (!resp.eventID) throw new Error("received unexpected response from the push endpoint, eventID must not be undefined");
                        let retryCount = 0;
                        await (0, $goxFl.createIterablePromise)({
                            func: async ()=>{
                                if (resp.eventID === void 0 || !resp.eventID) throw new Error("received unexpected response from the push endpoint, eventID must not be undefined");
                                return this.getEvent({
                                    runID: resp.runID,
                                    eventID: resp.eventID
                                }).catch((error)=>{
                                    if (error.status === 404) return void 0;
                                    throw error;
                                });
                            },
                            validate: (response)=>response !== void 0,
                            aggregator: ()=>retryCount += 1,
                            error: {
                                validate: ()=>retryCount >= 50,
                                message: ()=>`The maximum number of retries exceeded. (${retryCount}/${50})`
                            },
                            timeout: ()=>Math.min(retryCount * 500, 5e3)
                        });
                    }
                    offset += waitBatchSize;
                }
            }
            return responses;
        },
        /**
     * Creates a new authentication resource.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param authenticationCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createAuthentication (authenticationCreate, requestOptions) {
            if (!authenticationCreate) throw new Error("Parameter `authenticationCreate` is required when calling `createAuthentication`.");
            if (!authenticationCreate.type) throw new Error("Parameter `authenticationCreate.type` is required when calling `createAuthentication`.");
            if (!authenticationCreate.name) throw new Error("Parameter `authenticationCreate.name` is required when calling `createAuthentication`.");
            if (!authenticationCreate.input) throw new Error("Parameter `authenticationCreate.input` is required when calling `createAuthentication`.");
            const requestPath = "/1/authentications";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: authenticationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new destination.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param destinationCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createDestination (destinationCreate, requestOptions) {
            if (!destinationCreate) throw new Error("Parameter `destinationCreate` is required when calling `createDestination`.");
            if (!destinationCreate.type) throw new Error("Parameter `destinationCreate.type` is required when calling `createDestination`.");
            if (!destinationCreate.name) throw new Error("Parameter `destinationCreate.name` is required when calling `createDestination`.");
            if (!destinationCreate.input) throw new Error("Parameter `destinationCreate.input` is required when calling `createDestination`.");
            const requestPath = "/1/destinations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: destinationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new source.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createSource (sourceCreate, requestOptions) {
            if (!sourceCreate) throw new Error("Parameter `sourceCreate` is required when calling `createSource`.");
            if (!sourceCreate.type) throw new Error("Parameter `sourceCreate.type` is required when calling `createSource`.");
            if (!sourceCreate.name) throw new Error("Parameter `sourceCreate.name` is required when calling `createSource`.");
            const requestPath = "/1/sources";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new task.
     * @param taskCreate - Request body for creating a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createTask (taskCreate, requestOptions) {
            if (!taskCreate) throw new Error("Parameter `taskCreate` is required when calling `createTask`.");
            if (!taskCreate.sourceID) throw new Error("Parameter `taskCreate.sourceID` is required when calling `createTask`.");
            if (!taskCreate.destinationID) throw new Error("Parameter `taskCreate.destinationID` is required when calling `createTask`.");
            if (!taskCreate.action) throw new Error("Parameter `taskCreate.action` is required when calling `createTask`.");
            const requestPath = "/2/tasks";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new task using the v1 endpoint, please use `createTask` instead.
     *
     * @deprecated
     * @param taskCreate - Request body for creating a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createTaskV1 (taskCreate, requestOptions) {
            if (!taskCreate) throw new Error("Parameter `taskCreate` is required when calling `createTaskV1`.");
            if (!taskCreate.sourceID) throw new Error("Parameter `taskCreate.sourceID` is required when calling `createTaskV1`.");
            if (!taskCreate.destinationID) throw new Error("Parameter `taskCreate.destinationID` is required when calling `createTaskV1`.");
            if (!taskCreate.trigger) throw new Error("Parameter `taskCreate.trigger` is required when calling `createTaskV1`.");
            if (!taskCreate.action) throw new Error("Parameter `taskCreate.action` is required when calling `createTaskV1`.");
            const requestPath = "/1/tasks";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Creates a new transformation.
     * @param transformationCreate - Request body for creating a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ createTransformation (transformationCreate, requestOptions) {
            if (!transformationCreate) throw new Error("Parameter `transformationCreate` is required when calling `createTransformation`.");
            if (!transformationCreate.name) throw new Error("Parameter `transformationCreate.name` is required when calling `createTransformation`.");
            const requestPath = "/1/transformations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes an authentication resource. You can\'t delete authentication resources that are used by a source or a destination.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteAuthentication - The deleteAuthentication object.
     * @param deleteAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteAuthentication ({ authenticationID: authenticationID }, requestOptions) {
            if (!authenticationID) throw new Error("Parameter `authenticationID` is required when calling `deleteAuthentication`.");
            const requestPath = "/1/authentications/{authenticationID}".replace("{authenticationID}", encodeURIComponent(authenticationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a destination by its ID. You can\'t delete destinations that are referenced in tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteDestination - The deleteDestination object.
     * @param deleteDestination.destinationID - Unique identifier of a destination.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteDestination ({ destinationID: destinationID }, requestOptions) {
            if (!destinationID) throw new Error("Parameter `destinationID` is required when calling `deleteDestination`.");
            const requestPath = "/1/destinations/{destinationID}".replace("{destinationID}", encodeURIComponent(destinationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a source by its ID. You can\'t delete sources that are referenced in tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteSource - The deleteSource object.
     * @param deleteSource.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteSource ({ sourceID: sourceID }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `deleteSource`.");
            const requestPath = "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a task by its ID.
     * @param deleteTask - The deleteTask object.
     * @param deleteTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `deleteTask`.");
            const requestPath = "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a task by its ID using the v1 endpoint, please use `deleteTask` instead.
     *
     * @deprecated
     * @param deleteTaskV1 - The deleteTaskV1 object.
     * @param deleteTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `deleteTaskV1`.");
            const requestPath = "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a transformation by its ID.
     * @param deleteTransformation - The deleteTransformation object.
     * @param deleteTransformation.transformationID - Unique identifier of a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteTransformation ({ transformationID: transformationID }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `deleteTransformation`.");
            const requestPath = "/1/transformations/{transformationID}".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Disables a task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param disableTask - The disableTask object.
     * @param disableTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ disableTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `disableTask`.");
            const requestPath = "/2/tasks/{taskID}/disable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Disables a task using the v1 endpoint, please use `disableTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param disableTaskV1 - The disableTaskV1 object.
     * @param disableTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ disableTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `disableTaskV1`.");
            const requestPath = "/1/tasks/{taskID}/disable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Enables a task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param enableTask - The enableTask object.
     * @param enableTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ enableTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `enableTask`.");
            const requestPath = "/2/tasks/{taskID}/enable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Enables a task using the v1 endpoint, please use `enableTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param enableTaskV1 - The enableTaskV1 object.
     * @param enableTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ enableTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `enableTaskV1`.");
            const requestPath = "/1/tasks/{taskID}/enable".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves an authentication resource by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getAuthentication - The getAuthentication object.
     * @param getAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getAuthentication ({ authenticationID: authenticationID }, requestOptions) {
            if (!authenticationID) throw new Error("Parameter `authenticationID` is required when calling `getAuthentication`.");
            const requestPath = "/1/authentications/{authenticationID}".replace("{authenticationID}", encodeURIComponent(authenticationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a destination by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getDestination - The getDestination object.
     * @param getDestination.destinationID - Unique identifier of a destination.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getDestination ({ destinationID: destinationID }, requestOptions) {
            if (!destinationID) throw new Error("Parameter `destinationID` is required when calling `getDestination`.");
            const requestPath = "/1/destinations/{destinationID}".replace("{destinationID}", encodeURIComponent(destinationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a single task run event by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getEvent - The getEvent object.
     * @param getEvent.runID - Unique identifier of a task run.
     * @param getEvent.eventID - Unique identifier of an event.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getEvent ({ runID: runID, eventID: eventID }, requestOptions) {
            if (!runID) throw new Error("Parameter `runID` is required when calling `getEvent`.");
            if (!eventID) throw new Error("Parameter `eventID` is required when calling `getEvent`.");
            const requestPath = "/1/runs/{runID}/events/{eventID}".replace("{runID}", encodeURIComponent(runID)).replace("{eventID}", encodeURIComponent(eventID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieve a single task run by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getRun - The getRun object.
     * @param getRun.runID - Unique identifier of a task run.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRun ({ runID: runID }, requestOptions) {
            if (!runID) throw new Error("Parameter `runID` is required when calling `getRun`.");
            const requestPath = "/1/runs/{runID}".replace("{runID}", encodeURIComponent(runID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieve a source by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getSource - The getSource object.
     * @param getSource.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getSource ({ sourceID: sourceID }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `getSource`.");
            const requestPath = "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a task by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getTask - The getTask object.
     * @param getTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTask ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getTask`.");
            const requestPath = "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a task by its ID using the v1 endpoint, please use `getTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param getTaskV1 - The getTaskV1 object.
     * @param getTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTaskV1 ({ taskID: taskID }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getTaskV1`.");
            const requestPath = "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a transformation by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getTransformation - The getTransformation object.
     * @param getTransformation.transformationID - Unique identifier of a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getTransformation ({ transformationID: transformationID }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `getTransformation`.");
            const requestPath = "/1/transformations/{transformationID}".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of all authentication resources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listAuthentications - The listAuthentications object.
     * @param listAuthentications.itemsPerPage - Number of items per page.
     * @param listAuthentications.page - Page number of the paginated API response.
     * @param listAuthentications.type - Type of authentication resource to retrieve.
     * @param listAuthentications.platform - Ecommerce platform for which to retrieve authentications.
     * @param listAuthentications.sort - Property by which to sort the list of authentications.
     * @param listAuthentications.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listAuthentications ({ itemsPerPage: itemsPerPage, page: page, type: type, platform: platform, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/authentications";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (platform !== void 0) queryParameters["platform"] = platform.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of destinations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listDestinations - The listDestinations object.
     * @param listDestinations.itemsPerPage - Number of items per page.
     * @param listDestinations.page - Page number of the paginated API response.
     * @param listDestinations.type - Destination type.
     * @param listDestinations.authenticationID - Authentication ID used by destinations.
     * @param listDestinations.transformationID - Get the list of destinations used by a transformation.
     * @param listDestinations.sort - Property by which to sort the destinations.
     * @param listDestinations.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listDestinations ({ itemsPerPage: itemsPerPage, page: page, type: type, authenticationID: authenticationID, transformationID: transformationID, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/destinations";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (authenticationID !== void 0) queryParameters["authenticationID"] = authenticationID.toString();
            if (transformationID !== void 0) queryParameters["transformationID"] = transformationID.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of events for a task run, identified by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listEvents - The listEvents object.
     * @param listEvents.runID - Unique identifier of a task run.
     * @param listEvents.itemsPerPage - Number of items per page.
     * @param listEvents.page - Page number of the paginated API response.
     * @param listEvents.status - Event status for filtering the list of task runs.
     * @param listEvents.type - Event type for filtering the list of task runs.
     * @param listEvents.sort - Property by which to sort the list of task run events.
     * @param listEvents.order - Sort order of the response, ascending or descending.
     * @param listEvents.startDate - Date and time in RFC 3339 format for the earliest events to retrieve. By default, the current time minus three hours is used.
     * @param listEvents.endDate - Date and time in RFC 3339 format for the latest events to retrieve. By default, the current time is used.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listEvents ({ runID: runID, itemsPerPage: itemsPerPage, page: page, status: status, type: type, sort: sort, order: order, startDate: startDate, endDate: endDate }, requestOptions) {
            if (!runID) throw new Error("Parameter `runID` is required when calling `listEvents`.");
            const requestPath = "/1/runs/{runID}/events".replace("{runID}", encodeURIComponent(runID));
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (status !== void 0) queryParameters["status"] = status.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieve a list of task runs.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listRuns - The listRuns object.
     * @param listRuns.itemsPerPage - Number of items per page.
     * @param listRuns.page - Page number of the paginated API response.
     * @param listRuns.status - Run status for filtering the list of task runs.
     * @param listRuns.type - Run type for filtering the list of task runs.
     * @param listRuns.taskID - Task ID for filtering the list of task runs.
     * @param listRuns.sort - Property by which to sort the list of task runs.
     * @param listRuns.order - Sort order of the response, ascending or descending.
     * @param listRuns.startDate - Date in RFC 3339 format for the earliest run to retrieve. By default, the current day minus seven days is used.
     * @param listRuns.endDate - Date in RFC 3339 format for the latest run to retrieve. By default, the current day is used.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listRuns ({ itemsPerPage: itemsPerPage, page: page, status: status, type: type, taskID: taskID, sort: sort, order: order, startDate: startDate, endDate: endDate } = {}, requestOptions) {
            const requestPath = "/1/runs";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (status !== void 0) queryParameters["status"] = status.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (taskID !== void 0) queryParameters["taskID"] = taskID.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            if (startDate !== void 0) queryParameters["startDate"] = startDate.toString();
            if (endDate !== void 0) queryParameters["endDate"] = endDate.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of sources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listSources - The listSources object.
     * @param listSources.itemsPerPage - Number of items per page.
     * @param listSources.page - Page number of the paginated API response.
     * @param listSources.type - Source type. Some sources require authentication.
     * @param listSources.authenticationID - Authentication IDs of the sources to retrieve. \'none\' returns sources that doesn\'t have an authentication.
     * @param listSources.sort - Property by which to sort the list of sources.
     * @param listSources.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listSources ({ itemsPerPage: itemsPerPage, page: page, type: type, authenticationID: authenticationID, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/sources";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (type !== void 0) queryParameters["type"] = type.toString();
            if (authenticationID !== void 0) queryParameters["authenticationID"] = authenticationID.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listTasks - The listTasks object.
     * @param listTasks.itemsPerPage - Number of items per page.
     * @param listTasks.page - Page number of the paginated API response.
     * @param listTasks.action - Actions for filtering the list of tasks.
     * @param listTasks.enabled - Whether to filter the list of tasks by the `enabled` status.
     * @param listTasks.sourceID - Source IDs for filtering the list of tasks.
     * @param listTasks.sourceType - Filters the tasks with the specified source type.
     * @param listTasks.destinationID - Destination IDs for filtering the list of tasks.
     * @param listTasks.triggerType - Type of task trigger for filtering the list of tasks.
     * @param listTasks.withEmailNotifications - If specified, the response only includes tasks with notifications.email.enabled set to this value.
     * @param listTasks.sort - Property by which to sort the list of tasks.
     * @param listTasks.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listTasks ({ itemsPerPage: itemsPerPage, page: page, action: action, enabled: enabled, sourceID: sourceID, sourceType: sourceType, destinationID: destinationID, triggerType: triggerType, withEmailNotifications: withEmailNotifications, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/2/tasks";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (action !== void 0) queryParameters["action"] = action.toString();
            if (enabled !== void 0) queryParameters["enabled"] = enabled.toString();
            if (sourceID !== void 0) queryParameters["sourceID"] = sourceID.toString();
            if (sourceType !== void 0) queryParameters["sourceType"] = sourceType.toString();
            if (destinationID !== void 0) queryParameters["destinationID"] = destinationID.toString();
            if (triggerType !== void 0) queryParameters["triggerType"] = triggerType.toString();
            if (withEmailNotifications !== void 0) queryParameters["withEmailNotifications"] = withEmailNotifications.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of tasks using the v1 endpoint, please use `getTasks` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param listTasksV1 - The listTasksV1 object.
     * @param listTasksV1.itemsPerPage - Number of items per page.
     * @param listTasksV1.page - Page number of the paginated API response.
     * @param listTasksV1.action - Actions for filtering the list of tasks.
     * @param listTasksV1.enabled - Whether to filter the list of tasks by the `enabled` status.
     * @param listTasksV1.sourceID - Source IDs for filtering the list of tasks.
     * @param listTasksV1.destinationID - Destination IDs for filtering the list of tasks.
     * @param listTasksV1.triggerType - Type of task trigger for filtering the list of tasks.
     * @param listTasksV1.sort - Property by which to sort the list of tasks.
     * @param listTasksV1.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listTasksV1 ({ itemsPerPage: itemsPerPage, page: page, action: action, enabled: enabled, sourceID: sourceID, destinationID: destinationID, triggerType: triggerType, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/tasks";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (action !== void 0) queryParameters["action"] = action.toString();
            if (enabled !== void 0) queryParameters["enabled"] = enabled.toString();
            if (sourceID !== void 0) queryParameters["sourceID"] = sourceID.toString();
            if (destinationID !== void 0) queryParameters["destinationID"] = destinationID.toString();
            if (triggerType !== void 0) queryParameters["triggerType"] = triggerType.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a list of transformations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listTransformations - The listTransformations object.
     * @param listTransformations.itemsPerPage - Number of items per page.
     * @param listTransformations.page - Page number of the paginated API response.
     * @param listTransformations.sort - Property by which to sort the list of transformations.
     * @param listTransformations.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ listTransformations ({ itemsPerPage: itemsPerPage, page: page, sort: sort, order: order } = {}, requestOptions) {
            const requestPath = "/1/transformations";
            const headers = {};
            const queryParameters = {};
            if (itemsPerPage !== void 0) queryParameters["itemsPerPage"] = itemsPerPage.toString();
            if (page !== void 0) queryParameters["page"] = page.toString();
            if (sort !== void 0) queryParameters["sort"] = sort.toString();
            if (order !== void 0) queryParameters["order"] = order.toString();
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Pushes records through the Pipeline, directly to an index. You can make the call synchronous by providing the `watch` parameter, for asynchronous calls, you can use the observability endpoints and/or debugger dashboard to see the status of your task. If you want to leverage the [pre-indexing data transformation](https://www.algolia.com/doc/guides/sending-and-managing-data/send-and-update-your-data/how-to/transform-your-data/), this is the recommended way of ingesting your records. This method is similar to `pushTask`, but requires an `indexName` instead of a `taskID`. If zero or many tasks are found, an error will be returned.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param push - The push object.
     * @param push.indexName - Name of the index on which to perform the operation.
     * @param push.pushTaskPayload - The pushTaskPayload object.
     * @param push.watch - When provided, the push operation will be synchronous and the API will wait for the ingestion to be finished before responding.
     * @param push.referenceIndexName - This is required when targeting an index that does not have a push connector setup (e.g. a tmp index), but you wish to attach another index\'s transformation to it (e.g. the source index name).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ push ({ indexName: indexName, pushTaskPayload: pushTaskPayload, watch: watch, referenceIndexName: referenceIndexName }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `push`.");
            if (!pushTaskPayload) throw new Error("Parameter `pushTaskPayload` is required when calling `push`.");
            if (!pushTaskPayload.action) throw new Error("Parameter `pushTaskPayload.action` is required when calling `push`.");
            if (!pushTaskPayload.records) throw new Error("Parameter `pushTaskPayload.records` is required when calling `push`.");
            const requestPath = "/1/push/{indexName}".replace("{indexName}", encodeURIComponent(indexName));
            const headers = {};
            const queryParameters = {};
            if (watch !== void 0) queryParameters["watch"] = watch.toString();
            if (referenceIndexName !== void 0) queryParameters["referenceIndexName"] = referenceIndexName.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: pushTaskPayload
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Pushes records through the Pipeline, directly to an index. You can make the call synchronous by providing the `watch` parameter, for asynchronous calls, you can use the observability endpoints and/or debugger dashboard to see the status of your task. If you want to leverage the [pre-indexing data transformation](https://www.algolia.com/doc/guides/sending-and-managing-data/send-and-update-your-data/how-to/transform-your-data/), this is the recommended way of ingesting your records. This method is similar to `push`, but requires a `taskID` instead of a `indexName`, which is useful when many `destinations` target the same `indexName`.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param pushTask - The pushTask object.
     * @param pushTask.taskID - Unique identifier of a task.
     * @param pushTask.pushTaskPayload - The pushTaskPayload object.
     * @param pushTask.watch - When provided, the push operation will be synchronous and the API will wait for the ingestion to be finished before responding.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ pushTask ({ taskID: taskID, pushTaskPayload: pushTaskPayload, watch: watch }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `pushTask`.");
            if (!pushTaskPayload) throw new Error("Parameter `pushTaskPayload` is required when calling `pushTask`.");
            if (!pushTaskPayload.action) throw new Error("Parameter `pushTaskPayload.action` is required when calling `pushTask`.");
            if (!pushTaskPayload.records) throw new Error("Parameter `pushTaskPayload.records` is required when calling `pushTask`.");
            const requestPath = "/2/tasks/{taskID}/push".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            if (watch !== void 0) queryParameters["watch"] = watch.toString();
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: pushTaskPayload
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Runs all tasks linked to a source, only available for Shopify, BigCommerce and commercetools sources. Creates one run per task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param runSource - The runSource object.
     * @param runSource.sourceID - Unique identifier of a source.
     * @param runSource.runSourcePayload -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ runSource ({ sourceID: sourceID, runSourcePayload: runSourcePayload }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `runSource`.");
            const requestPath = "/1/sources/{sourceID}/run".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: runSourcePayload ? runSourcePayload : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Runs a task. You can check the status of task runs with the observability endpoints.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param runTask - The runTask object.
     * @param runTask.taskID - Unique identifier of a task.
     * @param runTask.runTaskPayload -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ runTask ({ taskID: taskID, runTaskPayload: runTaskPayload }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `runTask`.");
            const requestPath = "/2/tasks/{taskID}/run".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: runTaskPayload ? runTaskPayload : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Runs a task using the v1 endpoint, please use `runTask` instead. You can check the status of task runs with the observability endpoints.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param runTaskV1 - The runTaskV1 object.
     * @param runTaskV1.taskID - Unique identifier of a task.
     * @param runTaskV1.runTaskPayload -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ runTaskV1 ({ taskID: taskID, runTaskPayload: runTaskPayload }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `runTaskV1`.");
            const requestPath = "/1/tasks/{taskID}/run".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: runTaskPayload ? runTaskPayload : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for authentication resources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param authenticationSearch - The authenticationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchAuthentications (authenticationSearch, requestOptions) {
            if (!authenticationSearch) throw new Error("Parameter `authenticationSearch` is required when calling `searchAuthentications`.");
            if (!authenticationSearch.authenticationIDs) throw new Error("Parameter `authenticationSearch.authenticationIDs` is required when calling `searchAuthentications`.");
            const requestPath = "/1/authentications/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: authenticationSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for destinations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param destinationSearch - The destinationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchDestinations (destinationSearch, requestOptions) {
            if (!destinationSearch) throw new Error("Parameter `destinationSearch` is required when calling `searchDestinations`.");
            if (!destinationSearch.destinationIDs) throw new Error("Parameter `destinationSearch.destinationIDs` is required when calling `searchDestinations`.");
            const requestPath = "/1/destinations/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: destinationSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for sources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceSearch - The sourceSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchSources (sourceSearch, requestOptions) {
            if (!sourceSearch) throw new Error("Parameter `sourceSearch` is required when calling `searchSources`.");
            if (!sourceSearch.sourceIDs) throw new Error("Parameter `sourceSearch.sourceIDs` is required when calling `searchSources`.");
            const requestPath = "/1/sources/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param taskSearch - The taskSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchTasks (taskSearch, requestOptions) {
            if (!taskSearch) throw new Error("Parameter `taskSearch` is required when calling `searchTasks`.");
            if (!taskSearch.taskIDs) throw new Error("Parameter `taskSearch.taskIDs` is required when calling `searchTasks`.");
            const requestPath = "/2/tasks/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for tasks using the v1 endpoint, please use `searchTasks` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param taskSearch - The taskSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchTasksV1 (taskSearch, requestOptions) {
            if (!taskSearch) throw new Error("Parameter `taskSearch` is required when calling `searchTasksV1`.");
            if (!taskSearch.taskIDs) throw new Error("Parameter `taskSearch.taskIDs` is required when calling `searchTasksV1`.");
            const requestPath = "/1/tasks/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for transformations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param transformationSearch - The transformationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchTransformations (transformationSearch, requestOptions) {
            if (!transformationSearch) throw new Error("Parameter `transformationSearch` is required when calling `searchTransformations`.");
            if (!transformationSearch.transformationIDs) throw new Error("Parameter `transformationSearch.transformationIDs` is required when calling `searchTransformations`.");
            const requestPath = "/1/transformations/search";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationSearch
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Triggers a stream-listing request for a source. Triggering stream-listing requests only works with sources with `type: docker` and `imageType: airbyte`.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param triggerDockerSourceDiscover - The triggerDockerSourceDiscover object.
     * @param triggerDockerSourceDiscover.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ triggerDockerSourceDiscover ({ sourceID: sourceID }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `triggerDockerSourceDiscover`.");
            const requestPath = "/1/sources/{sourceID}/discover".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Try a transformation before creating it.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param transformationTry - The transformationTry object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ tryTransformation (transformationTry, requestOptions) {
            if (!transformationTry) throw new Error("Parameter `transformationTry` is required when calling `tryTransformation`.");
            if (!transformationTry.sampleRecord) throw new Error("Parameter `transformationTry.sampleRecord` is required when calling `tryTransformation`.");
            const requestPath = "/1/transformations/try";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationTry
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Try a transformation before updating it.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param tryTransformationBeforeUpdate - The tryTransformationBeforeUpdate object.
     * @param tryTransformationBeforeUpdate.transformationID - Unique identifier of a transformation.
     * @param tryTransformationBeforeUpdate.transformationTry - The transformationTry object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ tryTransformationBeforeUpdate ({ transformationID: transformationID, transformationTry: transformationTry }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `tryTransformationBeforeUpdate`.");
            if (!transformationTry) throw new Error("Parameter `transformationTry` is required when calling `tryTransformationBeforeUpdate`.");
            if (!transformationTry.sampleRecord) throw new Error("Parameter `transformationTry.sampleRecord` is required when calling `tryTransformationBeforeUpdate`.");
            const requestPath = "/1/transformations/{transformationID}/try".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationTry
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates an authentication resource.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateAuthentication - The updateAuthentication object.
     * @param updateAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param updateAuthentication.authenticationUpdate - The authenticationUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateAuthentication ({ authenticationID: authenticationID, authenticationUpdate: authenticationUpdate }, requestOptions) {
            if (!authenticationID) throw new Error("Parameter `authenticationID` is required when calling `updateAuthentication`.");
            if (!authenticationUpdate) throw new Error("Parameter `authenticationUpdate` is required when calling `updateAuthentication`.");
            const requestPath = "/1/authentications/{authenticationID}".replace("{authenticationID}", encodeURIComponent(authenticationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: authenticationUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates the destination by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateDestination - The updateDestination object.
     * @param updateDestination.destinationID - Unique identifier of a destination.
     * @param updateDestination.destinationUpdate - The destinationUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateDestination ({ destinationID: destinationID, destinationUpdate: destinationUpdate }, requestOptions) {
            if (!destinationID) throw new Error("Parameter `destinationID` is required when calling `updateDestination`.");
            if (!destinationUpdate) throw new Error("Parameter `destinationUpdate` is required when calling `updateDestination`.");
            const requestPath = "/1/destinations/{destinationID}".replace("{destinationID}", encodeURIComponent(destinationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: destinationUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a source by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateSource - The updateSource object.
     * @param updateSource.sourceID - Unique identifier of a source.
     * @param updateSource.sourceUpdate - The sourceUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateSource ({ sourceID: sourceID, sourceUpdate: sourceUpdate }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `updateSource`.");
            if (!sourceUpdate) throw new Error("Parameter `sourceUpdate` is required when calling `updateSource`.");
            const requestPath = "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a task by its ID.
     * @param updateTask - The updateTask object.
     * @param updateTask.taskID - Unique identifier of a task.
     * @param updateTask.taskUpdate - The taskUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateTask ({ taskID: taskID, taskUpdate: taskUpdate }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `updateTask`.");
            if (!taskUpdate) throw new Error("Parameter `taskUpdate` is required when calling `updateTask`.");
            const requestPath = "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a task by its ID using the v1 endpoint, please use `updateTask` instead.
     *
     * @deprecated
     * @param updateTaskV1 - The updateTaskV1 object.
     * @param updateTaskV1.taskID - Unique identifier of a task.
     * @param updateTaskV1.taskUpdate - The taskUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateTaskV1 ({ taskID: taskID, taskUpdate: taskUpdate }, requestOptions) {
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `updateTaskV1`.");
            if (!taskUpdate) throw new Error("Parameter `taskUpdate` is required when calling `updateTaskV1`.");
            const requestPath = "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PATCH",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: taskUpdate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Updates a transformation by its ID.
     * @param updateTransformation - The updateTransformation object.
     * @param updateTransformation.transformationID - Unique identifier of a transformation.
     * @param updateTransformation.transformationCreate - The transformationCreate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ updateTransformation ({ transformationID: transformationID, transformationCreate: transformationCreate }, requestOptions) {
            if (!transformationID) throw new Error("Parameter `transformationID` is required when calling `updateTransformation`.");
            if (!transformationCreate) throw new Error("Parameter `transformationCreate` is required when calling `updateTransformation`.");
            if (!transformationCreate.name) throw new Error("Parameter `transformationCreate.name` is required when calling `updateTransformation`.");
            const requestPath = "/1/transformations/{transformationID}".replace("{transformationID}", encodeURIComponent(transformationID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: transformationCreate
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Validates a source payload to ensure it can be created and that the data source can be reached by Algolia.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ validateSource (sourceCreate, requestOptions) {
            const requestPath = "/1/sources/validate";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceCreate ? sourceCreate : {}
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Validates an update of a source payload to ensure it can be created and that the data source can be reached by Algolia.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param validateSourceBeforeUpdate - The validateSourceBeforeUpdate object.
     * @param validateSourceBeforeUpdate.sourceID - Unique identifier of a source.
     * @param validateSourceBeforeUpdate.sourceUpdate - The sourceUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ validateSourceBeforeUpdate ({ sourceID: sourceID, sourceUpdate: sourceUpdate }, requestOptions) {
            if (!sourceID) throw new Error("Parameter `sourceID` is required when calling `validateSourceBeforeUpdate`.");
            if (!sourceUpdate) throw new Error("Parameter `sourceUpdate` is required when calling `validateSourceBeforeUpdate`.");
            const requestPath = "/1/sources/{sourceID}/validate".replace("{sourceID}", encodeURIComponent(sourceID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: sourceUpdate
            };
            requestOptions = {
                timeouts: {
                    connect: 18e4,
                    read: 18e4,
                    write: 18e4,
                    ...requestOptions?.timeouts
                }
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $e49dee0eba8824c9$export$f458e77ddebad4b(appId, apiKey, region, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    if (!region || region && (typeof region !== "string" || !$e49dee0eba8824c9$var$REGIONS.includes(region))) throw new Error(`\`region\` is required and must be one of the following: ${$e49dee0eba8824c9$var$REGIONS.join(", ")}`);
    return $e49dee0eba8824c9$var$createIngestionClient({
        appId: appId,
        apiKey: apiKey,
        region: region,
        timeouts: {
            connect: 25e3,
            read: 25e3,
            write: 25e3
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$e49dee0eba8824c9$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("5v5Tx", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $40146b99cf4835ed$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "monitoringClient", function () { return $40146b99cf4835ed$export$4ae4681adb143a8a; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $40146b99cf4835ed$export$ad1dfbed11feb646 = "1.35.0";
function $40146b99cf4835ed$var$getDefaultHosts() {
    return [
        {
            url: "status.algolia.com",
            accept: "readWrite",
            protocol: "https"
        }
    ];
}
function $40146b99cf4835ed$var$createMonitoringClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $40146b99cf4835ed$var$getDefaultHosts(),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Monitoring",
            version: $40146b99cf4835ed$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves known incidents for the selected clusters.
     * @param getClusterIncidents - The getClusterIncidents object.
     * @param getClusterIncidents.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClusterIncidents ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getClusterIncidents`.");
            const requestPath = "/1/incidents/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the status of selected clusters.
     * @param getClusterStatus - The getClusterStatus object.
     * @param getClusterStatus.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getClusterStatus ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getClusterStatus`.");
            const requestPath = "/1/status/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves known incidents for all clusters.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getIncidents (requestOptions) {
            const requestPath = "/1/incidents";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves average times for indexing operations for selected clusters.
     * @param getIndexingTime - The getIndexingTime object.
     * @param getIndexingTime.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getIndexingTime ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getIndexingTime`.");
            const requestPath = "/1/indexing/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the average latency for search requests for selected clusters.
     * @param getLatency - The getLatency object.
     * @param getLatency.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getLatency ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getLatency`.");
            const requestPath = "/1/latency/{clusters}".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves metrics related to your Algolia infrastructure, aggregated over a selected time window.  Access to this API is available as part of the [Premium or Elevate plans](https://www.algolia.com/pricing). You must authenticate requests with the `x-algolia-application-id` and `x-algolia-api-key` headers (using the Monitoring API key).
     * @param getMetrics - The getMetrics object.
     * @param getMetrics.metric - Metric to report.  For more information about the individual metrics, see the description of the API response. To include all metrics, use `*`.
     * @param getMetrics.period - Period over which to aggregate the metrics:  - `minute`. Aggregate the last minute. 1 data point per 10 seconds. - `hour`. Aggregate the last hour. 1 data point per minute. - `day`. Aggregate the last day. 1 data point per 10 minutes. - `week`. Aggregate the last week. 1 data point per hour. - `month`. Aggregate the last month. 1 data point per day.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getMetrics ({ metric: metric, period: period }, requestOptions) {
            if (!metric) throw new Error("Parameter `metric` is required when calling `getMetrics`.");
            if (!period) throw new Error("Parameter `period` is required when calling `getMetrics`.");
            const requestPath = "/1/infrastructure/{metric}/period/{period}".replace("{metric}", encodeURIComponent(metric)).replace("{period}", encodeURIComponent(period));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Test whether clusters are reachable or not.
     * @param getReachability - The getReachability object.
     * @param getReachability.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getReachability ({ clusters: clusters }, requestOptions) {
            if (!clusters) throw new Error("Parameter `clusters` is required when calling `getReachability`.");
            const requestPath = "/1/reachability/{clusters}/probes".replace("{clusters}", encodeURIComponent(clusters));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the servers that belong to clusters.  The response depends on whether you authenticate your API request:  - With authentication, the response lists the servers assigned to your Algolia application\'s cluster.  - Without authentication, the response lists the servers for all Algolia clusters.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getServers (requestOptions) {
            const requestPath = "/1/inventory/servers";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves the status of all Algolia clusters and instances.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getStatus (requestOptions) {
            const requestPath = "/1/status";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $40146b99cf4835ed$export$4ae4681adb143a8a(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $40146b99cf4835ed$var$createMonitoringClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$40146b99cf4835ed$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});

parcelRegister("bSRQm", function(module, exports) {

$parcel$export(module.exports, "apiClientVersion", function () { return $8a6e810e04d6019b$export$ad1dfbed11feb646; });
$parcel$export(module.exports, "recommendClient", function () { return $8a6e810e04d6019b$export$d4c266a0cfaa4787; });
// builds/browser.ts

var $9J5i1 = parcelRequire("9J5i1");

var $goxFl = parcelRequire("goxFl");
var $8a6e810e04d6019b$export$ad1dfbed11feb646 = "5.35.0";
function $8a6e810e04d6019b$var$getDefaultHosts(appId) {
    return [
        {
            url: `${appId}-dsn.algolia.net`,
            accept: "read",
            protocol: "https"
        },
        {
            url: `${appId}.algolia.net`,
            accept: "write",
            protocol: "https"
        }
    ].concat((0, $goxFl.shuffle)([
        {
            url: `${appId}-1.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-2.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-3.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        }
    ]));
}
function $8a6e810e04d6019b$var$createRecommendClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = (0, $goxFl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $goxFl.createTransporter)({
        hosts: $8a6e810e04d6019b$var$getDefaultHosts(appIdOption),
        ...options,
        algoliaAgent: (0, $goxFl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Recommend",
            version: $8a6e810e04d6019b$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * The `apiKey` currently in use.
     */ apiKey: apiKeyOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Create or update a batch of Recommend Rules  Each Recommend Rule is created or updated, depending on whether a Recommend Rule with the same `objectID` already exists. You may also specify `true` for `clearExistingRules`, in which case the batch will atomically replace all the existing Recommend Rules.  Recommend Rules are similar to Search Rules, except that the conditions and consequences apply to a [source item](/doc/guides/algolia-recommend/overview/#recommend-models) instead of a query. The main differences are the following: - Conditions `pattern` and `anchoring` are unavailable. - Condition `filters` triggers if the source item matches the specified filters. - Condition `filters` accepts numeric filters. - Consequence `params` only covers filtering parameters. - Consequence `automaticFacetFilters` doesn\'t require a facet value placeholder (it tries to match the data source item\'s attributes instead).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param batchRecommendRules - The batchRecommendRules object.
     * @param batchRecommendRules.indexName - Name of the index on which to perform the operation.
     * @param batchRecommendRules.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param batchRecommendRules.recommendRule - The recommendRule object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ batchRecommendRules ({ indexName: indexName, model: model, recommendRule: recommendRule }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `batchRecommendRules`.");
            if (!model) throw new Error("Parameter `model` is required when calling `batchRecommendRules`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/batch".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: recommendRule ? recommendRule : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customDelete ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customDelete`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customGet ({ path: path, parameters: parameters }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customGet`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPut ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPut`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "PUT",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Deletes a Recommend rule from a recommendation scenario.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteRecommendRule - The deleteRecommendRule object.
     * @param deleteRecommendRule.indexName - Name of the index on which to perform the operation.
     * @param deleteRecommendRule.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param deleteRecommendRule.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ deleteRecommendRule ({ indexName: indexName, model: model, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `deleteRecommendRule`.");
            if (!model) throw new Error("Parameter `model` is required when calling `deleteRecommendRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `deleteRecommendRule`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "DELETE",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves a Recommend rule that you previously created in the Algolia dashboard.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getRecommendRule - The getRecommendRule object.
     * @param getRecommendRule.indexName - Name of the index on which to perform the operation.
     * @param getRecommendRule.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param getRecommendRule.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRecommendRule ({ indexName: indexName, model: model, objectID: objectID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getRecommendRule`.");
            if (!model) throw new Error("Parameter `model` is required when calling `getRecommendRule`.");
            if (!objectID) throw new Error("Parameter `objectID` is required when calling `getRecommendRule`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/{objectID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model)).replace("{objectID}", encodeURIComponent(objectID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Checks the status of a given task.  Deleting a Recommend rule is asynchronous. When you delete a rule, a task is created on a queue and completed depending on the load on the server. The API response includes a task ID that you can use to check the status.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param getRecommendStatus - The getRecommendStatus object.
     * @param getRecommendStatus.indexName - Name of the index on which to perform the operation.
     * @param getRecommendStatus.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param getRecommendStatus.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRecommendStatus ({ indexName: indexName, model: model, taskID: taskID }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `getRecommendStatus`.");
            if (!model) throw new Error("Parameter `model` is required when calling `getRecommendStatus`.");
            if (!taskID) throw new Error("Parameter `taskID` is required when calling `getRecommendStatus`.");
            const requestPath = "/1/indexes/{indexName}/{model}/task/{taskID}".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model)).replace("{taskID}", encodeURIComponent(taskID));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "GET",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves recommendations from selected AI models.
     *
     * Required API Key ACLs:
     *  - search
     * @param getRecommendationsParams - The getRecommendationsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRecommendations (getRecommendationsParams, requestOptions) {
            if (getRecommendationsParams && Array.isArray(getRecommendationsParams)) {
                const newSignatureRequest = {
                    requests: getRecommendationsParams
                };
                getRecommendationsParams = newSignatureRequest;
            }
            if (!getRecommendationsParams) throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
            if (!getRecommendationsParams.requests) throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
            const requestPath = "/1/indexes/*/recommendations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: getRecommendationsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Searches for Recommend rules.  Use an empty query to list all rules for this recommendation scenario.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchRecommendRules - The searchRecommendRules object.
     * @param searchRecommendRules.indexName - Name of the index on which to perform the operation.
     * @param searchRecommendRules.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param searchRecommendRules.searchRecommendRulesParams - The searchRecommendRulesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchRecommendRules ({ indexName: indexName, model: model, searchRecommendRulesParams: searchRecommendRulesParams }, requestOptions) {
            if (!indexName) throw new Error("Parameter `indexName` is required when calling `searchRecommendRules`.");
            if (!model) throw new Error("Parameter `model` is required when calling `searchRecommendRules`.");
            const requestPath = "/1/indexes/{indexName}/{model}/recommend/rules/search".replace("{indexName}", encodeURIComponent(indexName)).replace("{model}", encodeURIComponent(model));
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchRecommendRulesParams ? searchRecommendRulesParams : {},
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// builds/browser.ts
function $8a6e810e04d6019b$export$d4c266a0cfaa4787(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $8a6e810e04d6019b$var$createRecommendClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: 1e3,
            read: 2e3,
            write: 3e4
        },
        logger: (0, $goxFl.createNullLogger)(),
        requester: (0, $9J5i1.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $goxFl.createMemoryCache)(),
        requestsCache: (0, $goxFl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $goxFl.createFallbackableCache)({
            caches: [
                (0, $goxFl.createBrowserLocalStorageCache)({
                    key: `${$8a6e810e04d6019b$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $goxFl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});


parcelRegister("3HSZo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b300aefd80d2c65$export$2e2bcd8739ae039; });

var $gSJMz = parcelRequire("gSJMz");
/** Used as references for various `Number` constants. */ var $2b300aefd80d2c65$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $2b300aefd80d2c65$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $gSJMz.default)(array, $2b300aefd80d2c65$var$INFINITY) : [];
}
var $2b300aefd80d2c65$export$2e2bcd8739ae039 = $2b300aefd80d2c65$var$flattenDeep;

});

parcelRegister("a2SqC", function(module, exports) {

$parcel$export(module.exports, "LOGIN_MODE", function () { return $e0814cd51de7e03f$export$d301a1b0b3b9ddad; });
$parcel$export(module.exports, "default", function () { return $e0814cd51de7e03f$export$2e2bcd8739ae039; });

var $jf2w9 = parcelRequire("jf2w9");

var $ioVMT = parcelRequire("ioVMT");

var $bEEBX = parcelRequire("bEEBX");

var $15TRa = parcelRequire("15TRa");

var $Kk7R3 = parcelRequire("Kk7R3");

var $k5JR3 = parcelRequire("k5JR3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aRCaF = parcelRequire("aRCaF");

var $gtsdT = parcelRequire("gtsdT");

var $f2Bp8 = parcelRequire("f2Bp8");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $bZiDo = parcelRequire("bZiDo");

var $gvoND = parcelRequire("gvoND");
const $e0814cd51de7e03f$var$landingPadId = "mini-cart";
var $e0814cd51de7e03f$export$d301a1b0b3b9ddad = /*#__PURE__*/ function(LOGIN_MODE) {
    LOGIN_MODE["USERNAME"] = "username";
    LOGIN_MODE["SMS"] = "sms";
    LOGIN_MODE["RESET_PASSWORD_EMAIL"] = "resetPasswordEmail";
    LOGIN_MODE["RESET_PASSWORD_OTP"] = "resetPasswordOtp";
    LOGIN_MODE["RESET_PASSWORD_SUCCESS"] = "resetPasswordSuccess";
    return LOGIN_MODE;
}({});
const $e0814cd51de7e03f$var$uiStore = (0, $Kk7R3.makeAutoObservable)({
    planes: [],
    dataVersion: (0, $f2Bp8.getDataVersionFromStorage)(),
    locale: (0, $aRCaF.default).language?.startsWith("en") ? "en-US" : "nb-NO",
    newDataAvailable: false,
    accessLevel: 0,
    loginMode: "username",
    showTranslationKeys: false,
    showDefaultTranslationText: true,
    showLanguageSwitcher: false,
    showLoggerModal: false,
    ensureDataVersionAvailable: async ()=>{
        if ($e0814cd51de7e03f$var$uiStore.dataVersion === null) // If we don't know a valid data version, just fetch it so its stored for next time.
        // No need to schedule an update check this session.
        return $e0814cd51de7e03f$var$uiStore.checkDataVersion(false);
        // If we already know a valid data version, we use that and schedule an update check
        // in 10 seconds once everything has settled.
        setTimeout(()=>$e0814cd51de7e03f$var$uiStore.checkDataVersion(false), 10000);
    },
    checkDataVersion: async (giveFeedback)=>{
        const dataVersionUrl = `${(0, $8ZCSm.STATICDATA_HOST)}/currentVersion.${(0, $8ZCSm.ENV_NAME)}.txt`;
        const latestDataVersion = await (0, $3Y1Wx.apiClient)(dataVersionUrl).get().text();
        (0, $Kk7R3.runInAction)(()=>{
            if ($e0814cd51de7e03f$var$uiStore.dataVersion !== latestDataVersion) {
                (0, $gtsdT.logger).log("ui", `Static data available is version ${latestDataVersion}`);
                if (giveFeedback) (0, $gvoND.default).addSuccess("Ny data tilgjengelig", "Det er ny data tilgjengelig. Vennligst last siden p\xe5 nytt for \xe5 f\xe5 oppdatert informasjon.");
                if ($e0814cd51de7e03f$var$uiStore.dataVersion === null) {
                    $e0814cd51de7e03f$var$uiStore.dataVersion = latestDataVersion;
                    (0, $f2Bp8.setDataVersionInStorage)($e0814cd51de7e03f$var$uiStore.dataVersion);
                } else {
                    // If we detect that new data is available, we can remove the
                    // data version stored in session storage. This ensures that the
                    // next time the user visits the site, we will fetch the latest data.
                    $e0814cd51de7e03f$var$uiStore.newDataAvailable = true;
                    (0, $f2Bp8.setDataVersionInStorage)(null);
                }
            } else if (giveFeedback) (0, $gvoND.default).addError("Ingen ny data tilgjengelig", "Det er ingen ny data tilgjengelig.");
        });
    },
    handleMissingDataFileError: async (err)=>{
        (0, $gtsdT.logger).warn("ui", "An error occured while fetching data files!", err);
        // Check session storage to see if we have already tried to refresh, to avoid refresh loops
        const alreadyRefreshed = (0, $f2Bp8.getHasRefreshedFromStorage)();
        if ((0, $ioVMT.default)(err.message, "BlobNotFound") && !alreadyRefreshed) {
            (0, $f2Bp8.setHasRefreshedInStorage)(true);
            await $e0814cd51de7e03f$var$uiStore.checkDataVersion(false);
            window.location.reload();
        } else throw err;
    },
    takeOff: (animationId)=>{
        const targetEl = document.getElementById($e0814cd51de7e03f$var$landingPadId);
        if ((0, $bEEBX.default)(targetEl)) return;
        const rect = targetEl.getBoundingClientRect();
        const plane = (0, $jf2w9.default)($e0814cd51de7e03f$var$uiStore.planes, {
            animationId: animationId
        });
        if ((0, $bEEBX.default)(plane)) return;
        plane.x = rect.left + window.scrollX;
        plane.y = rect.top + window.scrollY;
        plane.height = targetEl.clientHeight;
        setTimeout((0, $Kk7R3.action)(()=>{
            (0, $15TRa.default)($e0814cd51de7e03f$var$uiStore.planes, {
                animationId: animationId
            });
        }), 1000);
    },
    addFlyingProduct: (sku, fromRef)=>{
        if (fromRef.current === null) {
            (0, $gtsdT.logger).warn("ui", "Attempted to fly image from undefined reference");
            return;
        }
        const el = fromRef.current;
        if ((0, $bEEBX.default)(el)) {
            (0, $gtsdT.logger).warn("ui", `Unable to find current image for sku ${sku} in ref: ${JSON.stringify(fromRef)}`);
            return;
        }
        const rect = el.getBoundingClientRect();
        const animationId = (0, $k5JR3.default)();
        $e0814cd51de7e03f$var$uiStore.planes.push({
            animationId: animationId,
            sku: sku,
            x: rect.left + window.scrollX,
            y: rect.top + window.scrollY,
            sourceWidth: el.naturalWidth,
            height: el.clientHeight
        });
    },
    handleShortcutKeypress: (e)=>{
        // Toggle logger modal
        if (e.ctrlKey && e.shiftKey && e.code === "KeyL") {
            e.preventDefault();
            $e0814cd51de7e03f$var$uiStore.toggleLoggerModal();
        }
        const isFunctionKeysHeld = e.altKey && e.ctrlKey && e.shiftKey;
        if (!isFunctionKeysHeld) // The rest of this function should only run if user is holdeing
        // alt + ctrl + shift, so return if this is not the case.
        return;
        if (e.code === "KeyO") $e0814cd51de7e03f$var$uiStore.showTranslationKeys = !$e0814cd51de7e03f$var$uiStore.showTranslationKeys;
        if (e.code === "KeyK" && $e0814cd51de7e03f$var$uiStore.accessLevel === 0) $e0814cd51de7e03f$var$uiStore.accessLevel = 1;
        else if (e.code === "KeyS" && $e0814cd51de7e03f$var$uiStore.accessLevel === 1) {
            $e0814cd51de7e03f$var$uiStore.accessLevel = 2;
            if ((0, $lKrOo.default).is("LOGGED_IN")) (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
            (0, $bZiDo.default).assortment = (0, $bZiDo.default).products.map((p)=>p.sku);
            (0, $gvoND.default).addSuccess("Du har n\xe5 KS-tilgang", "Du har blitt logget ut, men kan n\xe5 s\xf8ke p\xe5 alle produkter");
        }
    },
    switchLoginMode: (newMode)=>{
        $e0814cd51de7e03f$var$uiStore.loginMode = newMode;
    },
    showLoginModal: ()=>{
        if ((0, $lKrOo.default).is("START_UP")) return;
        (0, $lKrOo.default).transitionTo("LOGIN_MODAL");
    },
    toggleLoggerModal () {
        $e0814cd51de7e03f$var$uiStore.showLoggerModal = !$e0814cd51de7e03f$var$uiStore.showLoggerModal;
    },
    hideLoginModal: ()=>{
        (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
        (0, $bcbvQ.default).codeChallengeId = null;
        $e0814cd51de7e03f$var$uiStore.switchLoginMode("username");
    },
    clearCompanySpecificData: ()=>{
    // add methods to clear company specific data
    }
});
var $e0814cd51de7e03f$export$2e2bcd8739ae039 = $e0814cd51de7e03f$var$uiStore;

});
parcelRegister("k5JR3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea07d80f1426d4df$export$2e2bcd8739ae039; });

var $5tgFt = parcelRequire("5tgFt");

var $gOtxM = parcelRequire("gOtxM");

var $icGne = parcelRequire("icGne");
function $ea07d80f1426d4df$var$v4(options, buf, offset) {
    if ((0, $5tgFt.default).randomUUID && !buf && !options) return (0, $5tgFt.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $gOtxM.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $icGne.unsafeStringify)(rnds);
}
var $ea07d80f1426d4df$export$2e2bcd8739ae039 = $ea07d80f1426d4df$var$v4;

});
parcelRegister("5tgFt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fbc97131c48181d$export$2e2bcd8739ae039; });
const $3fbc97131c48181d$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $3fbc97131c48181d$export$2e2bcd8739ae039 = {
    randomUUID: $3fbc97131c48181d$var$randomUUID
};

});

parcelRegister("gOtxM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3d83bab6eb4da87$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $c3d83bab6eb4da87$var$getRandomValues;
const $c3d83bab6eb4da87$var$rnds8 = new Uint8Array(16);
function $c3d83bab6eb4da87$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$c3d83bab6eb4da87$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $c3d83bab6eb4da87$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$c3d83bab6eb4da87$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $c3d83bab6eb4da87$var$getRandomValues($c3d83bab6eb4da87$var$rnds8);
}

});

parcelRegister("icGne", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $d40a37891a004cf5$export$8fb373d660548968; });

var $fpM69 = parcelRequire("fpM69");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $d40a37891a004cf5$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$d40a37891a004cf5$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $d40a37891a004cf5$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $d40a37891a004cf5$var$byteToHex[arr[offset + 0]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 1]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 2]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 3]] + '-' + $d40a37891a004cf5$var$byteToHex[arr[offset + 4]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 5]] + '-' + $d40a37891a004cf5$var$byteToHex[arr[offset + 6]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 7]] + '-' + $d40a37891a004cf5$var$byteToHex[arr[offset + 8]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 9]] + '-' + $d40a37891a004cf5$var$byteToHex[arr[offset + 10]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 11]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 12]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 13]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 14]] + $d40a37891a004cf5$var$byteToHex[arr[offset + 15]];
}
function $d40a37891a004cf5$var$stringify(arr, offset = 0) {
    const uuid = $d40a37891a004cf5$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $fpM69.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $d40a37891a004cf5$export$2e2bcd8739ae039 = $d40a37891a004cf5$var$stringify;

});
parcelRegister("fpM69", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b38e801f06985c6a$export$2e2bcd8739ae039; });

var $52rB5 = parcelRequire("52rB5");
function $b38e801f06985c6a$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $52rB5.default).test(uuid);
}
var $b38e801f06985c6a$export$2e2bcd8739ae039 = $b38e801f06985c6a$var$validate;

});
parcelRegister("52rB5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab28be38ea67e82$export$2e2bcd8739ae039; });
var $3ab28be38ea67e82$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("aRCaF", function(module, exports) {

$parcel$export(module.exports, "getKeyPlural", function () { return $f3b796dcce4235bf$export$91839cc42c64fde5; });
$parcel$export(module.exports, "default", function () { return $f3b796dcce4235bf$export$2e2bcd8739ae039; });

var $4DmuH = parcelRequire("4DmuH");

var $f9hHD = parcelRequire("f9hHD");
parcelRequire("1wfes");
var $hbeiY = parcelRequire("hbeiY");

var $c3N6n = parcelRequire("c3N6n");

var $f2Bp8 = parcelRequire("f2Bp8");
const $f3b796dcce4235bf$export$91839cc42c64fde5 = (key, count)=>{
    const currentLanguage = (0, $c3N6n.default).languages.find((l)=>l.language === (0, $4DmuH.default).language);
    const pluralType = currentLanguage?.pluralType(+count);
    return `${key}.${pluralType}`;
};
const $f3b796dcce4235bf$export$3d0bc18ea50ceb43 = (language)=>{
    if (language.region === "") return language.language;
    return `${language.language}-${language.region}`;
};
const $f3b796dcce4235bf$export$4f395be9ac13be1c = ()=>(0, $c3N6n.default).languages.map((l)=>{
        return $f3b796dcce4235bf$export$3d0bc18ea50ceb43(l);
    });
const $f3b796dcce4235bf$export$8d272496390b3783 = ()=>(0, $c3N6n.default).baseLocale;
const $f3b796dcce4235bf$export$604ba5624273df44 = ()=>{
    return (0, $f2Bp8.getLanguageFromStorage)() || "nb";
};
const $f3b796dcce4235bf$export$329ccd9862d07caf = ()=>{
    return (0, $c3N6n.default).languages;
};
(0, $4DmuH.default).use((0, $hbeiY.initReactI18next)).use((0, $f9hHD.default)).init({
    lng: $f3b796dcce4235bf$export$8d272496390b3783(),
    fallbackLng: {
        nb: [
            "nb-NO"
        ],
        en: [
            "en-US"
        ]
    },
    debug: false,
    supportedLngs: $f3b796dcce4235bf$export$4f395be9ac13be1c(),
    resources: {},
    partialBundledLanguages: true,
    keySeparator: ".",
    interpolation: {
        escapeValue: false
    },
    load: "currentOnly",
    react: {
        useSuspense: false
    },
    backend: {
        loadPath: "https://delivery.localazy.com/_a765905005502057668266b33190/_e0/ed13368406891cf5fa833d4b09428a6c673a523a/{{lng}}/translations.json"
    }
});
var $f3b796dcce4235bf$export$2e2bcd8739ae039 = (0, $4DmuH.default);

});
parcelRegister("4DmuH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35fc40caa151f5a6$export$2e2bcd8739ae039; });
const $35fc40caa151f5a6$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $35fc40caa151f5a6$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $35fc40caa151f5a6$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $35fc40caa151f5a6$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $35fc40caa151f5a6$var$Logger(this.logger, options);
    }
}
var $35fc40caa151f5a6$var$baseLogger = new $35fc40caa151f5a6$var$Logger();
class $35fc40caa151f5a6$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = [].concat(this.observers['*']);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $35fc40caa151f5a6$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $35fc40caa151f5a6$var$makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function $35fc40caa151f5a6$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $35fc40caa151f5a6$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    const stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $35fc40caa151f5a6$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $35fc40caa151f5a6$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $35fc40caa151f5a6$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $35fc40caa151f5a6$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $35fc40caa151f5a6$var$getPath(object, path) {
    const { obj: obj, k: k } = $35fc40caa151f5a6$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $35fc40caa151f5a6$var$getPathWithDefaults(data, defaultData, key) {
    const value = $35fc40caa151f5a6$var$getPath(data, key);
    if (value !== undefined) return value;
    return $35fc40caa151f5a6$var$getPath(defaultData, key);
}
function $35fc40caa151f5a6$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $35fc40caa151f5a6$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $35fc40caa151f5a6$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var $35fc40caa151f5a6$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function $35fc40caa151f5a6$var$escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, (s)=>$35fc40caa151f5a6$var$_entityMap[s]);
    return data;
}
const $35fc40caa151f5a6$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
function $35fc40caa151f5a6$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $35fc40caa151f5a6$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $35fc40caa151f5a6$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === 'string') return mix;
                if (p && typeof mix[p] === 'string') return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $35fc40caa151f5a6$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $35fc40caa151f5a6$var$getCleanedCode(code) {
    if (code && code.indexOf('_') > 0) return code.replace('_', '-');
    return code;
}
class $35fc40caa151f5a6$var$ResourceStore extends $35fc40caa151f5a6$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== 'string') path = path.concat(key);
        if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) path = lng.split('.');
        const result = $35fc40caa151f5a6$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
        return $35fc40caa151f5a6$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $35fc40caa151f5a6$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $35fc40caa151f5a6$var$getPath(this.data, path) || {};
        if (deep) $35fc40caa151f5a6$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $35fc40caa151f5a6$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $35fc40caa151f5a6$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $35fc40caa151f5a6$var$checkedLoadedFor = {};
class $35fc40caa151f5a6$var$Translator extends $35fc40caa151f5a6$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $35fc40caa151f5a6$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $35fc40caa151f5a6$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$35fc40caa151f5a6$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === '[object Array]';
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const hasDefaultValue = $35fc40caa151f5a6$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === 'string' ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $35fc40caa151f5a6$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: resolved,
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === 'string') keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$35fc40caa151f5a6$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $35fc40caa151f5a6$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $35fc40caa151f5a6$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $35fc40caa151f5a6$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $35fc40caa151f5a6$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $35fc40caa151f5a6$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $35fc40caa151f5a6$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === 'string' && code.indexOf('-') > -1) {
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $35fc40caa151f5a6$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $35fc40caa151f5a6$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $35fc40caa151f5a6$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if (typeof fallbacks === 'string') fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $35fc40caa151f5a6$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $35fc40caa151f5a6$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $35fc40caa151f5a6$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $35fc40caa151f5a6$var$intlVersions = [
    'v4'
];
const $35fc40caa151f5a6$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $35fc40caa151f5a6$var$createRules() {
    const rules = {};
    $35fc40caa151f5a6$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $35fc40caa151f5a6$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $35fc40caa151f5a6$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $35fc40caa151f5a6$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $35fc40caa151f5a6$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $35fc40caa151f5a6$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($35fc40caa151f5a6$var$getCleanedCode(code), {
                type: options.ordinal ? 'ordinal' : 'cardinal'
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$35fc40caa151f5a6$var$suffixesOrder[pluralCategory1] - $35fc40caa151f5a6$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$35fc40caa151f5a6$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $35fc40caa151f5a6$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $35fc40caa151f5a6$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === 'string') {
        path = $35fc40caa151f5a6$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $35fc40caa151f5a6$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $35fc40caa151f5a6$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $35fc40caa151f5a6$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $35fc40caa151f5a6$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $35fc40caa151f5a6$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
        this.suffix = iOpts.suffix ? $35fc40caa151f5a6$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
        this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
        this.nestingPrefix = iOpts.nestingPrefix ? $35fc40caa151f5a6$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $35fc40caa151f5a6$var$regexEscape('$t(');
        this.nestingSuffix = iOpts.nestingSuffix ? $35fc40caa151f5a6$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $35fc40caa151f5a6$var$regexEscape(')');
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, 'g');
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, '$$$$');
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $35fc40caa151f5a6$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($35fc40caa151f5a6$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === 'string' ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (typeof value !== 'string' && !this.useRawValueToEscape) value = $35fc40caa151f5a6$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== 'string') return value;
            if (typeof value !== 'string') value = $35fc40caa151f5a6$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $35fc40caa151f5a6$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(':');
                const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $35fc40caa151f5a6$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($35fc40caa151f5a6$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $35fc40caa151f5a6$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $35fc40caa151f5a6$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $35fc40caa151f5a6$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $35fc40caa151f5a6$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $35fc40caa151f5a6$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $35fc40caa151f5a6$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $35fc40caa151f5a6$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $35fc40caa151f5a6$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $35fc40caa151f5a6$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $35fc40caa151f5a6$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $35fc40caa151f5a6$var$Connector extends $35fc40caa151f5a6$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $35fc40caa151f5a6$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $35fc40caa151f5a6$var$pushPath(q.loaded, [
                lng
            ], ns);
            $35fc40caa151f5a6$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $35fc40caa151f5a6$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $35fc40caa151f5a6$var$transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function $35fc40caa151f5a6$var$noop() {}
function $35fc40caa151f5a6$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
class $35fc40caa151f5a6$var$I18n extends $35fc40caa151f5a6$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $35fc40caa151f5a6$var$transformOptions(options);
        this.services = {};
        this.logger = $35fc40caa151f5a6$var$baseLogger;
        this.modules = {
            external: []
        };
        $35fc40caa151f5a6$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === 'string') options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $35fc40caa151f5a6$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$35fc40caa151f5a6$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $35fc40caa151f5a6$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $35fc40caa151f5a6$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $35fc40caa151f5a6$var$Formatter;
            const lu = new $35fc40caa151f5a6$var$LanguageUtil(this.options);
            this.store = new $35fc40caa151f5a6$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $35fc40caa151f5a6$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $35fc40caa151f5a6$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $35fc40caa151f5a6$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $35fc40caa151f5a6$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $35fc40caa151f5a6$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $35fc40caa151f5a6$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $35fc40caa151f5a6$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $35fc40caa151f5a6$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === 'string' ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $35fc40caa151f5a6$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $35fc40caa151f5a6$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $35fc40caa151f5a6$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $35fc40caa151f5a6$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === 'string') fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $35fc40caa151f5a6$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === 'string') ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $35fc40caa151f5a6$var$defer();
        if (typeof lngs === 'string') lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $35fc40caa151f5a6$var$LanguageUtil($35fc40caa151f5a6$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $35fc40caa151f5a6$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $35fc40caa151f5a6$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $35fc40caa151f5a6$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $35fc40caa151f5a6$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $35fc40caa151f5a6$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $35fc40caa151f5a6$export$2e2bcd8739ae039 = $35fc40caa151f5a6$var$I18n.createInstance();
$35fc40caa151f5a6$export$2e2bcd8739ae039.createInstance = $35fc40caa151f5a6$var$I18n.createInstance;
const $35fc40caa151f5a6$export$99152e8d49ca4e7d = $35fc40caa151f5a6$export$2e2bcd8739ae039.createInstance;
const $35fc40caa151f5a6$export$147ec2801e896265 = $35fc40caa151f5a6$export$2e2bcd8739ae039.dir;
const $35fc40caa151f5a6$export$2cd8252107eb640b = $35fc40caa151f5a6$export$2e2bcd8739ae039.init;
const $35fc40caa151f5a6$export$d3d08d944062d7e = $35fc40caa151f5a6$export$2e2bcd8739ae039.loadResources;
const $35fc40caa151f5a6$export$a5d9bf5d83fcab09 = $35fc40caa151f5a6$export$2e2bcd8739ae039.reloadResources;
const $35fc40caa151f5a6$export$1f96ae73734a86cc = $35fc40caa151f5a6$export$2e2bcd8739ae039.use;
const $35fc40caa151f5a6$export$61465194746e7fd2 = $35fc40caa151f5a6$export$2e2bcd8739ae039.changeLanguage;
const $35fc40caa151f5a6$export$f90d180fc7da3b3b = $35fc40caa151f5a6$export$2e2bcd8739ae039.getFixedT;
const $35fc40caa151f5a6$export$625550452a3fa3ec = $35fc40caa151f5a6$export$2e2bcd8739ae039.t;
const $35fc40caa151f5a6$export$f7e9f41ea797a17 = $35fc40caa151f5a6$export$2e2bcd8739ae039.exists;
const $35fc40caa151f5a6$export$2b4b218e406d2d00 = $35fc40caa151f5a6$export$2e2bcd8739ae039.setDefaultNamespace;
const $35fc40caa151f5a6$export$93d9ee97c1ad3f31 = $35fc40caa151f5a6$export$2e2bcd8739ae039.hasLoadedNamespace;
const $35fc40caa151f5a6$export$83be934b53fff43b = $35fc40caa151f5a6$export$2e2bcd8739ae039.loadNamespaces;
const $35fc40caa151f5a6$export$8cd7e7a54fa865bc = $35fc40caa151f5a6$export$2e2bcd8739ae039.loadLanguages;

});

parcelRegister("f9hHD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0756db30bc844ba$export$2e2bcd8739ae039; });

var $k6pN0 = parcelRequire("k6pN0");

var $c97Ez = parcelRequire("c97Ez");
function $b0756db30bc844ba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b0756db30bc844ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b0756db30bc844ba$var$_typeof(obj);
}
function $b0756db30bc844ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b0756db30bc844ba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b0756db30bc844ba$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b0756db30bc844ba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b0756db30bc844ba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b0756db30bc844ba$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b0756db30bc844ba$var$_defineProperty(obj, key, value) {
    key = $b0756db30bc844ba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0756db30bc844ba$var$_toPropertyKey(arg) {
    var key = $b0756db30bc844ba$var$_toPrimitive(arg, "string");
    return $b0756db30bc844ba$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b0756db30bc844ba$var$_toPrimitive(input, hint) {
    if ($b0756db30bc844ba$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b0756db30bc844ba$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b0756db30bc844ba$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $b0756db30bc844ba$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $c97Ez.default),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $b0756db30bc844ba$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $b0756db30bc844ba$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    $b0756db30bc844ba$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $k6pN0.defaults)(options, this.options || {}, $b0756db30bc844ba$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $k6pN0.makePromise)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message && err.message.indexOf('Failed to fetch') > -1) return callback('failed loading ' + url + ': ' + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$b0756db30bc844ba$var$Backend.type = 'backend';
var $b0756db30bc844ba$export$2e2bcd8739ae039 = $b0756db30bc844ba$var$Backend;

});
parcelRegister("k6pN0", function(module, exports) {

$parcel$export(module.exports, "defaults", function () { return $ea285f6c31548a07$export$ebe90cb607ad99e; });
$parcel$export(module.exports, "hasXMLHttpRequest", function () { return $ea285f6c31548a07$export$87022daa49baf612; });
$parcel$export(module.exports, "makePromise", function () { return $ea285f6c31548a07$export$1625492ec82002b9; });
function $ea285f6c31548a07$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ea285f6c31548a07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ea285f6c31548a07$var$_typeof(obj);
}
var $ea285f6c31548a07$var$arr = [];
var $ea285f6c31548a07$var$each = $ea285f6c31548a07$var$arr.forEach;
var $ea285f6c31548a07$var$slice = $ea285f6c31548a07$var$arr.slice;
function $ea285f6c31548a07$export$ebe90cb607ad99e(obj) {
    $ea285f6c31548a07$var$each.call($ea285f6c31548a07$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $ea285f6c31548a07$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $ea285f6c31548a07$var$_typeof(XMLHttpRequest)) === 'object';
}
function $ea285f6c31548a07$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $ea285f6c31548a07$export$1625492ec82002b9(maybePromise) {
    if ($ea285f6c31548a07$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}

});

parcelRegister("c97Ez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d7c431a41ad9130$export$2e2bcd8739ae039; });

var $k6pN0 = parcelRequire("k6pN0");

var $dnk61 = parcelRequire("dnk61");
function $8d7c431a41ad9130$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8d7c431a41ad9130$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8d7c431a41ad9130$var$_typeof(obj);
}
var $8d7c431a41ad9130$var$fetchApi;
if (typeof fetch === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $8d7c431a41ad9130$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== 'undefined' && window.fetch) $8d7c431a41ad9130$var$fetchApi = window.fetch;
    else $8d7c431a41ad9130$var$fetchApi = fetch;
}
var $8d7c431a41ad9130$var$XmlHttpRequestApi;
if ((0, $k6pN0.hasXMLHttpRequest)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $8d7c431a41ad9130$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $8d7c431a41ad9130$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $8d7c431a41ad9130$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $8d7c431a41ad9130$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $8d7c431a41ad9130$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$8d7c431a41ad9130$var$fetchApi && $dnk61 && !$8d7c431a41ad9130$var$XmlHttpRequestApi && !$8d7c431a41ad9130$var$ActiveXObjectApi) $8d7c431a41ad9130$var$fetchApi = $dnk61.default || $dnk61;
if (typeof $8d7c431a41ad9130$var$fetchApi !== 'function') $8d7c431a41ad9130$var$fetchApi = undefined;
var $8d7c431a41ad9130$var$addQueryString = function addQueryString(url, params) {
    if (params && $8d7c431a41ad9130$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $8d7c431a41ad9130$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $8d7c431a41ad9130$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $8d7c431a41ad9130$var$omitFetchOptions = false;
var $8d7c431a41ad9130$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $8d7c431a41ad9130$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $k6pN0.defaults)({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $k6pN0.defaults)({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $8d7c431a41ad9130$var$omitFetchOptions ? {} : reqOptions);
    try {
        $8d7c431a41ad9130$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $8d7c431a41ad9130$var$fetchIt(url, fetchOptions, callback);
            $8d7c431a41ad9130$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $8d7c431a41ad9130$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $8d7c431a41ad9130$var$_typeof(payload) === 'object') payload = $8d7c431a41ad9130$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $8d7c431a41ad9130$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($8d7c431a41ad9130$var$XmlHttpRequestApi) x = new $8d7c431a41ad9130$var$XmlHttpRequestApi();
        else x = new $8d7c431a41ad9130$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $8d7c431a41ad9130$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($8d7c431a41ad9130$var$fetchApi && url.indexOf('file:') !== 0) return $8d7c431a41ad9130$var$requestWithFetch(options, url, payload, callback);
    if ((0, $k6pN0.hasXMLHttpRequest)() || typeof ActiveXObject === 'function') return $8d7c431a41ad9130$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $8d7c431a41ad9130$export$2e2bcd8739ae039 = $8d7c431a41ad9130$var$request;

});
parcelRegister("dnk61", function(module, exports) {
var $0dcf6f38d116e3b3$var$fetchApi;
if (typeof fetch === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $0dcf6f38d116e3b3$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== 'undefined' && window.fetch) $0dcf6f38d116e3b3$var$fetchApi = window.fetch;
    else $0dcf6f38d116e3b3$var$fetchApi = fetch;
}

if (typeof window === 'undefined' || typeof window.document === 'undefined') {
    var $0dcf6f38d116e3b3$var$f = $0dcf6f38d116e3b3$var$fetchApi || (parcelRequire("1J2dZ"));
    if ($0dcf6f38d116e3b3$var$f.default) $0dcf6f38d116e3b3$var$f = $0dcf6f38d116e3b3$var$f.default;
    module.exports.default = $0dcf6f38d116e3b3$var$f;
    module.exports = module.exports.default;
}

});
parcelRegister("1J2dZ", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});




parcelRegister("1wfes", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("8f7hb")).useTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("hbeiY")).initReactI18next; });

var $i5ARm = parcelRequire("i5ARm");

var $chcfl = parcelRequire("chcfl");

var $8f7hb = parcelRequire("8f7hb");

var $8ZmRw = parcelRequire("8ZmRw");

var $kT9Ab = parcelRequire("kT9Ab");

var $hj7pq = parcelRequire("hj7pq");

var $8lysl = parcelRequire("8lysl");

var $37o1p = parcelRequire("37o1p");

var $hbeiY = parcelRequire("hbeiY");

var $aQ1Xc = parcelRequire("aQ1Xc");

var $jATEn = parcelRequire("jATEn");

var $g0P2V = parcelRequire("g0P2V");
const $11b49863ce01d45d$export$324d90190a8b822a = ()=>'';
const $11b49863ce01d45d$export$2da9be4cfdb689b1 = ()=>'';
const $11b49863ce01d45d$export$98e628dec113755e = ()=>'';
const $11b49863ce01d45d$export$2e6c959c16ff56b8 = ()=>'';
const $11b49863ce01d45d$export$4e35d5c922a95490 = ()=>'';
const $11b49863ce01d45d$export$720a3b9db04b7a0f = ()=>'';

});
parcelRegister("i5ARm", function(module, exports) {

var $dvPqk = parcelRequire("dvPqk");

var $chcfl = parcelRequire("chcfl");
parcelRequire("g0P2V");
var $jATEn = parcelRequire("jATEn");
var $g0P2V = parcelRequire("g0P2V");
function $d2b5492d4433fe35$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $dvPqk.useContext)((0, $g0P2V.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $jATEn.getI18n)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $chcfl.Trans)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}

});
parcelRegister("chcfl", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $8f0092763fcf86f1$export$8d6a9236f2e3f2ce; });

var $17Nqw = parcelRequire("17Nqw");

var $dvPqk = parcelRequire("dvPqk");

var $aT1D9 = parcelRequire("aT1D9");

var $9eNzM = parcelRequire("9eNzM");

var $aQ1Xc = parcelRequire("aQ1Xc");

var $jATEn = parcelRequire("jATEn");
function $8f0092763fcf86f1$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $8f0092763fcf86f1$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $8f0092763fcf86f1$var$getAsArray(children) : children;
}
function $8f0092763fcf86f1$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every((child)=>(0, $dvPqk.isValidElement)(child));
}
function $8f0092763fcf86f1$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $8f0092763fcf86f1$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $8f0092763fcf86f1$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $8f0092763fcf86f1$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === 'string') stringNode += `${child}`;
        else if ((0, $dvPqk.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $8f0092763fcf86f1$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $9eNzM.warn)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === 'object') {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $9eNzM.warn)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $9eNzM.warn)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $8f0092763fcf86f1$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $8f0092763fcf86f1$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === 'string') return;
            if ($8f0092763fcf86f1$var$hasChildren(child)) getData($8f0092763fcf86f1$var$getChildren(child));
            else if (typeof child === 'object' && !(0, $dvPqk.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $aT1D9.default).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $8f0092763fcf86f1$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $8f0092763fcf86f1$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $dvPqk.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $dvPqk.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(c.type, (0, $17Nqw.default)({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $8f0092763fcf86f1$var$getAsArray(reactNode);
        const astNodes = $8f0092763fcf86f1$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $8f0092763fcf86f1$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $dvPqk.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $8f0092763fcf86f1$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === 'object' && child.dummy && !isElement;
                const isKnownComponent = typeof children === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($8f0092763fcf86f1$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $dvPqk.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $dvPqk.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === 'object' && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $dvPqk.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $8f0092763fcf86f1$var$getAsArray(children || []));
    return $8f0092763fcf86f1$var$getChildren(result[0]);
}
function $8f0092763fcf86f1$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $jATEn.getI18n)();
    if (!i18n) {
        (0, $9eNzM.warnOnce)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $aQ1Xc.getDefaults)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $8f0092763fcf86f1$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = $8f0092763fcf86f1$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $dvPqk.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("17Nqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d1cc90afe10a641$export$2e2bcd8739ae039; });
function $0d1cc90afe10a641$export$2e2bcd8739ae039() {
    return $0d1cc90afe10a641$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0d1cc90afe10a641$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("aT1D9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ed04e3c9fed68eb$export$2e2bcd8739ae039; });

var $kDH0U = parcelRequire("kDH0U");
var $7ed04e3c9fed68eb$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $7ed04e3c9fed68eb$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($kDH0U)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($7ed04e3c9fed68eb$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $7ed04e3c9fed68eb$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $7ed04e3c9fed68eb$var$i = /^\s*$/, $7ed04e3c9fed68eb$var$s = Object.create(null);
function $7ed04e3c9fed68eb$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($7ed04e3c9fed68eb$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $7ed04e3c9fed68eb$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $7ed04e3c9fed68eb$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($7ed04e3c9fed68eb$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $7ed04e3c9fed68eb$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $7ed04e3c9fed68eb$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $7ed04e3c9fed68eb$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $7ed04e3c9fed68eb$var$a("", t);
        }, "");
    }
};
var $7ed04e3c9fed68eb$export$2e2bcd8739ae039 = $7ed04e3c9fed68eb$var$c;

});
parcelRegister("kDH0U", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRegister("9eNzM", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $6b9be0a9aec243dd$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $6b9be0a9aec243dd$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $6b9be0a9aec243dd$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $6b9be0a9aec243dd$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $6b9be0a9aec243dd$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $6b9be0a9aec243dd$export$be63e0664592e141; });
function $6b9be0a9aec243dd$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $6b9be0a9aec243dd$var$alreadyWarned = {};
function $6b9be0a9aec243dd$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $6b9be0a9aec243dd$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $6b9be0a9aec243dd$var$alreadyWarned[args[0]] = new Date();
    $6b9be0a9aec243dd$export$c106dd0671a0fc2d(...args);
}
const $6b9be0a9aec243dd$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
function $6b9be0a9aec243dd$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $6b9be0a9aec243dd$var$loadedClb(i18n, cb));
}
function $6b9be0a9aec243dd$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === 'string') ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $6b9be0a9aec243dd$var$loadedClb(i18n, cb));
}
function $6b9be0a9aec243dd$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $6b9be0a9aec243dd$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $6b9be0a9aec243dd$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $6b9be0a9aec243dd$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $6b9be0a9aec243dd$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

});

parcelRegister("aQ1Xc", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $7e4046b6696fad16$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $7e4046b6696fad16$export$212bb2fc580a90a8; });

var $hdxpW = parcelRequire("hdxpW");
let $7e4046b6696fad16$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $hdxpW.unescape
};
function $7e4046b6696fad16$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $7e4046b6696fad16$var$defaultOptions = {
        ...$7e4046b6696fad16$var$defaultOptions,
        ...options
    };
}
function $7e4046b6696fad16$export$212bb2fc580a90a8() {
    return $7e4046b6696fad16$var$defaultOptions;
}

});
parcelRegister("hdxpW", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $c88d928deed594d8$export$e8bacd2802a88316; });
const $c88d928deed594d8$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $c88d928deed594d8$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $c88d928deed594d8$var$unescapeHtmlEntity = (m)=>$c88d928deed594d8$var$htmlEntities[m];
const $c88d928deed594d8$export$e8bacd2802a88316 = (text)=>text.replace($c88d928deed594d8$var$matchHtmlEntity, $c88d928deed594d8$var$unescapeHtmlEntity);

});


parcelRegister("jATEn", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $e43c8c1b814c2f8b$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $e43c8c1b814c2f8b$export$64af334f494c2f47; });
let $e43c8c1b814c2f8b$var$i18nInstance;
function $e43c8c1b814c2f8b$export$a039134f2fc7e0(instance) {
    $e43c8c1b814c2f8b$var$i18nInstance = instance;
}
function $e43c8c1b814c2f8b$export$64af334f494c2f47() {
    return $e43c8c1b814c2f8b$var$i18nInstance;
}

});


parcelRegister("g0P2V", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $ba843e270d6bab80$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $ba843e270d6bab80$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $ba843e270d6bab80$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("aQ1Xc")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("jATEn")).getI18n; });

var $dvPqk = parcelRequire("dvPqk");

var $aQ1Xc = parcelRequire("aQ1Xc");

var $jATEn = parcelRequire("jATEn");

var $hbeiY = parcelRequire("hbeiY");
const $ba843e270d6bab80$export$5603ab5ced17ce64 = (0, $dvPqk.createContext)();
class $ba843e270d6bab80$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $ba843e270d6bab80$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $ba843e270d6bab80$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $ba843e270d6bab80$export$704200e5d0b9e8f() {
    const i18n = (0, $jATEn.getI18n)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRegister("hbeiY", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $c81e8f6ab5053eab$export$ae7e14d40d89f296; });

var $aQ1Xc = parcelRequire("aQ1Xc");

var $jATEn = parcelRequire("jATEn");
const $c81e8f6ab5053eab$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $aQ1Xc.setDefaults)(instance.options.react);
        (0, $jATEn.setI18n)(instance);
    }
};

});



parcelRegister("8f7hb", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $60055e50633f638c$export$9fc83ad70ead8663; });

var $dvPqk = parcelRequire("dvPqk");
parcelRequire("g0P2V");
var $aQ1Xc = parcelRequire("aQ1Xc");
var $jATEn = parcelRequire("jATEn");
var $g0P2V = parcelRequire("g0P2V");

var $9eNzM = parcelRequire("9eNzM");
const $60055e50633f638c$var$usePrevious = (value, ignore)=>{
    const ref = (0, $dvPqk.useRef)();
    (0, $dvPqk.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $60055e50633f638c$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $dvPqk.useContext)((0, $g0P2V.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $jATEn.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $g0P2V.ReportNamespaces)();
    if (!i18n) {
        (0, $9eNzM.warnOnce)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $9eNzM.warnOnce)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $aQ1Xc.getDefaults)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $9eNzM.hasLoadedNamespace)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $dvPqk.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $60055e50633f638c$var$usePrevious(joinedNS);
    const isMounted = (0, $dvPqk.useRef)(true);
    (0, $dvPqk.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $9eNzM.loadLanguages)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $9eNzM.loadNamespaces)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $dvPqk.useRef)(true);
    (0, $dvPqk.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $9eNzM.loadLanguages)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $9eNzM.loadNamespaces)(i18n, namespaces, ()=>resolve());
    });
}

});

parcelRegister("8ZmRw", function(module, exports) {

var $dvPqk = parcelRequire("dvPqk");

var $8f7hb = parcelRequire("8f7hb");

var $9eNzM = parcelRequire("9eNzM");
function $68b5c131f9b64676$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $8f7hb.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $dvPqk.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $9eNzM.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $dvPqk.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $dvPqk.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRegister("kT9Ab", function(module, exports) {

var $8f7hb = parcelRequire("8f7hb");
function $f35060954361f581$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $8f7hb.useTranslation)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRegister("hj7pq", function(module, exports) {

var $dvPqk = parcelRequire("dvPqk");

var $g0P2V = parcelRequire("g0P2V");
function $c999f5484724b28d$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $dvPqk.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $dvPqk.createElement)((0, $g0P2V.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRegister("8lysl", function(module, exports) {

var $dvPqk = parcelRequire("dvPqk");

var $37o1p = parcelRequire("37o1p");

var $g0P2V = parcelRequire("g0P2V");

var $9eNzM = parcelRequire("9eNzM");
function $613b03321cf1bff7$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $37o1p.useSSR)(initialI18nStore, initialLanguage);
            return (0, $dvPqk.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $g0P2V.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $9eNzM.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRegister("37o1p", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $2454a8c25f0aecb1$export$3526fb65ade8d8b7; });

var $dvPqk = parcelRequire("dvPqk");
parcelRequire("g0P2V");
var $jATEn = parcelRequire("jATEn");
var $g0P2V = parcelRequire("g0P2V");
function $2454a8c25f0aecb1$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $dvPqk.useContext)((0, $g0P2V.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $jATEn.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});



parcelRegister("c3N6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91022741954fbde2$export$2e2bcd8739ae039; });
const $91022741954fbde2$var$localazyMetadata = {
    projectUrl: "https://localazy.com/p/tine-handel",
    baseLocale: "nb-NO",
    languages: [
        {
            language: "en",
            region: "US",
            script: "",
            isRtl: false,
            name: "American English",
            localizedName: "American English",
            pluralType: (n)=>{
                return n === 1 ? "one" : "other";
            }
        },
        {
            language: "nb",
            region: "NO",
            script: "",
            isRtl: false,
            name: "Norwegian Bokm\xe5l (Norway)",
            localizedName: "Norsk bokm\xe5l (Norge)",
            pluralType: (n)=>{
                return n === 1 ? "one" : "other";
            }
        }
    ],
    files: [
        {
            cdnHash: "ed13368406891cf5fa833d4b09428a6c673a523a",
            file: "translations.json",
            path: "",
            cdnFiles: {
                "en_US": "https://delivery.localazy.com/_a765905005502057668266b33190/_e0/ed13368406891cf5fa833d4b09428a6c673a523a/en-US/translations.json",
                "nb_NO": "https://delivery.localazy.com/_a765905005502057668266b33190/_e0/ed13368406891cf5fa833d4b09428a6c673a523a/nb-NO/translations.json"
            }
        }
    ]
};
var $91022741954fbde2$export$2e2bcd8739ae039 = $91022741954fbde2$var$localazyMetadata;

});


parcelRegister("gvoND", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdbf568b4a64817c$export$2e2bcd8739ae039; });

var $15TRa = parcelRequire("15TRa");

var $kneHr = parcelRequire("kneHr");

var $jf2w9 = parcelRequire("jf2w9");

var $3xOZa = parcelRequire("3xOZa");

var $Kk7R3 = parcelRequire("Kk7R3");

var $k5JR3 = parcelRequire("k5JR3");

var $6fuyt = parcelRequire("6fuyt");
const $fdbf568b4a64817c$var$toastStore = (0, $Kk7R3.makeAutoObservable)({
    toasts: [],
    addSuccess: (title, message)=>{
        $fdbf568b4a64817c$var$toastStore.addToast(title, message, "success", false);
    },
    addError: (title, message, gaErrorTracking, persist = false)=>{
        gaErrorTracking && (0, $6fuyt.sendErrorMessage)(gaErrorTracking);
        $fdbf568b4a64817c$var$toastStore.addToast(title, message, "error", persist);
    },
    hasDuplicate: (toast)=>{
        const search = {
            title: toast.title,
            message: toast.message,
            type: toast.type
        };
        const existing = (0, $jf2w9.default)($fdbf568b4a64817c$var$toastStore.toasts, search);
        return !(0, $3xOZa.default)(existing);
    },
    addToast: (title, message, type, persist, hideDelay, onClick)=>{
        const id = (0, $k5JR3.default)();
        const duration = (0, $kneHr.default)(hideDelay, message.length > 50 ? 5000 : 3000);
        const toast = {
            id: id,
            title: title,
            message: message,
            type: type,
            persist: persist,
            duration: duration,
            show: false,
            onClick: onClick
        };
        // If there is already a toast with this exact title, message and type, we just abort.
        if ($fdbf568b4a64817c$var$toastStore.hasDuplicate(toast)) return;
        $fdbf568b4a64817c$var$toastStore.toasts.push(toast);
        // Removes toast from list of toasts after the duration time
        if (toast.duration > 0 && !persist) // This toast actually cleans up the array 500 ms later, so we don't accumulate hidden Toast elements
        setTimeout((0, $Kk7R3.action)(()=>{
            (0, $15TRa.default)($fdbf568b4a64817c$var$toastStore.toasts, {
                id: id
            });
        }), duration + 500);
    },
    clearCompanySpecificData: ()=>{
        $fdbf568b4a64817c$var$toastStore.toasts = [];
    }
});
var $fdbf568b4a64817c$export$2e2bcd8739ae039 = $fdbf568b4a64817c$var$toastStore;

});


parcelRegister("iPn7G", function(module, exports) {

$parcel$export(module.exports, "setHiddenStatus", function () { return $2b12e695d1083eea$export$654d34eff0c3125; });
$parcel$export(module.exports, "searchCategoryRescursive", function () { return $2b12e695d1083eea$export$3e6fe9177afbe23c; });
$parcel$export(module.exports, "findCategory", function () { return $2b12e695d1083eea$export$93e9d221203aed67; });
$parcel$export(module.exports, "searchForCategoryProducts", function () { return $2b12e695d1083eea$export$bab33635a5e35b67; });
$parcel$export(module.exports, "updateSkusForCategory", function () { return $2b12e695d1083eea$export$829a317c2c382679; });

var $ioVMT = parcelRequire("ioVMT");

var $bVGbk = parcelRequire("bVGbk");

var $gtsdT = parcelRequire("gtsdT");

var $bZiDo = parcelRequire("bZiDo");

var $iX5v3 = parcelRequire("iX5v3");
const $2b12e695d1083eea$export$654d34eff0c3125 = (cat)=>{
    cat.visible = (0, $bVGbk.default)(cat.skus, (0, $bZiDo.default).assortment).length > 0;
    for (const subcat of cat.children)$2b12e695d1083eea$export$654d34eff0c3125(subcat);
};
const $2b12e695d1083eea$export$3e6fe9177afbe23c = (sku, cat, level, obj)=>{
    if (!(0, $ioVMT.default)(cat.skus, sku)) return [];
    const newObj = {
        ...obj ? obj : {},
        [`cat${level}`]: cat.url_key
    };
    if (cat.children.length === 0) return [
        newObj
    ];
    return cat.children.flatMap((subcat)=>$2b12e695d1083eea$export$3e6fe9177afbe23c(sku, subcat, level + 1, newObj));
};
const $2b12e695d1083eea$export$93e9d221203aed67 = (query, categories)=>{
    const { cat1: cat1, cat2: cat2, cat3: cat3 } = query;
    const category = categories.find((cat)=>cat.url_key === cat1);
    if (!category) return null;
    if (cat2) {
        const subCategory = category.children.find((cat)=>cat.url_key === cat2);
        if (!subCategory) return null;
        if (cat3) {
            const subSubCategory = subCategory.children.find((cat)=>cat.url_key === cat3);
            if (!subSubCategory) return null;
            return subSubCategory;
        }
        return subCategory;
    }
    return category;
};
const $2b12e695d1083eea$export$bab33635a5e35b67 = async (assortment, replacementProducts, algoliaClient, indexName, customerGroup)=>{
    const filters = (0, $iX5v3.createProductAlgoliaFilter)(assortment, replacementProducts, indexName, customerGroup);
    const searchParams = {
        clickAnalytics: true,
        hitsPerPage: 1000,
        filters: filters
    };
    try {
        const response = await algoliaClient.searchSingleIndex({
            indexName: indexName,
            searchParams: searchParams
        });
        return response.hits.map((hit)=>({
                sku: hit.sku,
                paths: hit.paths || []
            }));
    } catch (error) {
        (0, $gtsdT.logger).error("categories", "Error searching for category products:", error);
    }
    return [];
};
const $2b12e695d1083eea$export$829a317c2c382679 = (category, skusAndPaths, newProductSkus)=>{
    const path = category.fullUrl.replace(/\.html$/, "");
    if (path === "/produkter/nyheter") category.skus = skusAndPaths.filter((skuAndPath)=>newProductSkus.includes(skuAndPath.sku)).map((skuAndPath)=>skuAndPath.sku);
    else category.skus = skusAndPaths.filter((skuAndPath)=>skuAndPath.paths.includes(path)).map((skuAndPath)=>skuAndPath.sku);
    if (category.children?.length) for (const child of category.children)$2b12e695d1083eea$export$829a317c2c382679(child, skusAndPaths, newProductSkus);
};

});
parcelRegister("iX5v3", function(module, exports) {

$parcel$export(module.exports, "createProductAlgoliaFilter", function () { return $54db391289fc7ae6$export$38e1c91ff75eaeb3; });
$parcel$export(module.exports, "searchInDomain", function () { return $54db391289fc7ae6$export$489103f623233b18; });
$parcel$export(module.exports, "getLocalizedString", function () { return $54db391289fc7ae6$export$4e490aaac5c28cc3; });
$parcel$export(module.exports, "getMaxHitsForSearchDomain", function () { return $54db391289fc7ae6$export$1d39b479f85788f; });

var $iB77C = parcelRequire("iB77C");

var $jECH9 = parcelRequire("jECH9");
const $54db391289fc7ae6$var$CUSTOMER_GROUP_SALES_DATA_POSTFIX = "_customer_groups";
const $54db391289fc7ae6$export$38e1c91ff75eaeb3 = (assortment, replacementProducts, indexName, customerGroup)=>{
    const replacedProducts = replacementProducts.map((rp)=>rp.oldSku);
    const productLimitations = [
        ...assortment,
        ...replacedProducts
    ].map((sku)=>`sku:${sku}`).join(" OR ");
    // Only stores that use the new _customer_groups index should filter by customer group
    if (indexName.endsWith($54db391289fc7ae6$var$CUSTOMER_GROUP_SALES_DATA_POSTFIX)) {
        if (!productLimitations) return `customerGroup:${customerGroup}`;
        return `customerGroup:${customerGroup} AND (${productLimitations})`;
    }
    return productLimitations;
};
const $54db391289fc7ae6$var$createArticleAlgoliaFilter = (domainName)=>{
    return `fields.searchCollections.${0, $iB77C.DEFAULT_LOCALE}: ${domainName}`;
};
const $54db391289fc7ae6$var$createRestrictSearchableAttributes = (searchDomain, locale = "nb-NO")=>{
    if (searchDomain.type === "v2_article") return [
        "title",
        "preface",
        "body"
    ].map((name)=>`fields.${name}.${locale}`);
    return undefined;
};
const $54db391289fc7ae6$var$createAlgoliaSearchParams = (searchDomain, searchType, customerGroup, locale, assortment, replacementProducts, algoliaUserToken, hitsPerPage = 6)=>{
    const clickAnalytics = searchType !== "direct";
    const filters = (()=>{
        switch(searchDomain.type){
            case "product":
                return $54db391289fc7ae6$export$38e1c91ff75eaeb3(assortment, replacementProducts, searchDomain.indexName, customerGroup);
            case "v2_article":
                return $54db391289fc7ae6$var$createArticleAlgoliaFilter(searchDomain.name);
            case "recipe":
                return $54db391289fc7ae6$var$createArticleAlgoliaFilter("oppskrifter");
        }
        return "";
    })();
    const restrictSearchableAttributes = $54db391289fc7ae6$var$createRestrictSearchableAttributes(searchDomain, locale);
    const requestOptions = {
        clickAnalytics: clickAnalytics,
        filters: filters,
        hitsPerPage: searchType === (0, $jECH9.SEARCH_TYPE).Full ? 1000 : hitsPerPage
    };
    if (restrictSearchableAttributes) requestOptions.restrictSearchableAttributes = restrictSearchableAttributes;
    if (algoliaUserToken) requestOptions.userToken = algoliaUserToken;
    return requestOptions;
};
const $54db391289fc7ae6$export$489103f623233b18 = async (query, searchDomain, searchType, customerGroup, algoliaUserToken, prioritizeAgreementAssortment, assortment, replacementProducts, resolveProducts, filterHitsForSegment, locale = "nb-NO")=>{
    if (searchDomain.type === "product") {
        const hitsPerPage = prioritizeAgreementAssortment ? 1000 : 12;
        const searchParams = $54db391289fc7ae6$var$createAlgoliaSearchParams(searchDomain, searchType, customerGroup, locale, assortment, replacementProducts, algoliaUserToken, hitsPerPage);
        const response = await searchDomain.algoliaClient.searchSingleIndex({
            indexName: searchDomain.indexName,
            searchParams: {
                ...searchParams,
                query: query
            }
        });
        const products = resolveProducts(response.hits.map((h)=>h.sku));
        const hits = products.map((product)=>response.hits.find((hit)=>product.sku === hit.sku)).filter((hit)=>!!hit);
        return {
            name: searchDomain.name,
            searchDomainType: "product",
            hits: hits,
            queryID: response.queryID || "",
            products: products,
            query: query
        };
    }
    if (searchDomain.type === "v2_article") {
        const searchParams = $54db391289fc7ae6$var$createAlgoliaSearchParams(searchDomain, searchType, customerGroup, locale, assortment, replacementProducts, algoliaUserToken, 2);
        const response = await searchDomain.algoliaClient.searchSingleIndex({
            indexName: searchDomain.indexName,
            searchParams: {
                ...searchParams,
                query: query
            }
        });
        const hits = filterHitsForSegment(response.hits);
        const results = {
            name: searchDomain.name,
            searchDomainType: "v2_article",
            hits: hits,
            queryID: response.queryID || "",
            query: query,
            data: []
        };
        if (results.hits.length) results.data = hits.map((hit)=>({
                id: hit.objectID,
                imageId: hit.fields?.headerImage?.["nb-NO"]?.sys.id || "",
                callToAction: hit.fields?.callToAction?.["nb-NO"] || hit.fields?.title?.["nb-NO"] || "",
                subTitle: hit.fields?.callToActionSubTitle?.["nb-NO"]
            }));
        return results;
    }
    if (searchDomain.type === "recipe") {
        const searchParams = $54db391289fc7ae6$var$createAlgoliaSearchParams(searchDomain, searchType, customerGroup, locale, assortment, replacementProducts, algoliaUserToken, 2);
        const response = await searchDomain.algoliaClient.searchSingleIndex({
            indexName: searchDomain.indexName,
            searchParams: {
                ...searchParams,
                query: query
            }
        });
        const hits = [
            ...response.hits
        ];
        const results = {
            name: searchDomain.name,
            searchDomainType: "recipe",
            hits: hits,
            queryID: response.queryID || "",
            query: query,
            data: []
        };
        if (results.hits.length) // Recipes are only available in Norwegian, so we use "nb-NO" locale for fields
        results.data = results.hits.map((hit)=>({
                id: hit.objectID,
                recipe: hit.fields?.recipeData?.["nb-NO"],
                title: hit.fields?.title?.["nb-NO"]
            }));
        return results;
    }
    return {
        name: searchDomain.name,
        searchDomainType: searchDomain.type,
        hits: [],
        queryID: "",
        query: query
    };
};
const $54db391289fc7ae6$export$10332fb811242d46 = (obj, preferredLocale)=>(preferredLocale in obj ? obj[preferredLocale] : undefined) || obj[0, $iB77C.DEFAULT_LOCALE];
const $54db391289fc7ae6$export$4e490aaac5c28cc3 = $54db391289fc7ae6$export$10332fb811242d46;
const $54db391289fc7ae6$export$1d39b479f85788f = (searchDomainType, resultsWithHits, isLg, isXl)=>{
    const results = resultsWithHits.find((result)=>result.searchDomainType === searchDomainType);
    if (results) {
        if (searchDomainType === "product") {
            if (isXl) return resultsWithHits.length > 1 ? 12 : 15;
            if (isLg) return resultsWithHits.length > 1 ? 9 : 12;
            return resultsWithHits.length > 1 ? 5 : 8;
        }
        const productResults = resultsWithHits.find((result)=>result.searchDomainType === "product");
        const isNarrow = productResults ? resultsWithHits.length > 2 : resultsWithHits.length > 1;
        if (productResults) {
            if (isNarrow) return 2;
            return isXl ? 6 : 3;
        }
        if (isNarrow) return 4;
        return 8;
    }
    return 0;
};

});
parcelRegister("iB77C", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", function () { return $b8a0fe1698fa5810$export$1af4c7e47ad72f44; });
const $b8a0fe1698fa5810$export$1af4c7e47ad72f44 = "nb-NO";

});

parcelRegister("jECH9", function(module, exports) {

$parcel$export(module.exports, "SEARCH_TYPE", function () { return $ad1d600d0769a67a$export$71ce8fbad5957261; });
var $ad1d600d0769a67a$export$71ce8fbad5957261 = /*#__PURE__*/ function(SEARCH_TYPE) {
    SEARCH_TYPE["QuickSearch"] = "quick";
    SEARCH_TYPE["Full"] = "full";
    return SEARCH_TYPE;
}({});

});




parcelRegister("luszM", function(module, exports) {

$parcel$export(module.exports, "mapBadges", function () { return $6b1cf69424450a73$export$344c8d19433adfdd; });
$parcel$export(module.exports, "shouldShowExpiryNotice", function () { return $6b1cf69424450a73$export$5251b756438ddf5b; });
$parcel$export(module.exports, "SEASONAL_PRODUCTS", function () { return $6b1cf69424450a73$export$dd12f34b1e178660; });
$parcel$export(module.exports, "isNewProduct", function () { return $6b1cf69424450a73$export$3b69081fa3d0d9db; });
$parcel$export(module.exports, "mapLabels", function () { return $6b1cf69424450a73$export$6f4a42f2f0c926d4; });
$parcel$export(module.exports, "matchesFilter", function () { return $6b1cf69424450a73$export$61a680df798908b1; });
$parcel$export(module.exports, "buildFilter", function () { return $6b1cf69424450a73$export$c6228deca5711404; });
$parcel$export(module.exports, "getRelevantFilterSettings", function () { return $6b1cf69424450a73$export$6a964d059d742a02; });
$parcel$export(module.exports, "hasDiscount", function () { return $6b1cf69424450a73$export$ad37cd1a82407fe8; });
$parcel$export(module.exports, "isDistributionPack", function () { return $6b1cf69424450a73$export$90a48c7c6995983e; });
$parcel$export(module.exports, "fixDanglingUnits", function () { return $6b1cf69424450a73$export$885c878500d8d487; });
$parcel$export(module.exports, "prioritizeAgreementAssortment", function () { return $6b1cf69424450a73$export$e363e8c4cdb108a; });
$parcel$export(module.exports, "getBrandSort", function () { return $6b1cf69424450a73$export$30e8cedba0c42596; });

var $epcVC = parcelRequire("epcVC");
var $khZbR = parcelRequire("khZbR");
var $8l6c2 = parcelRequire("8l6c2");
var $5UIm0 = parcelRequire("5UIm0");
var $6OXuO = parcelRequire("6OXuO");

var $jvljM = parcelRequire("jvljM");
var $bEEBX = parcelRequire("bEEBX");
var $3xOZa = parcelRequire("3xOZa");
var $egoNX = parcelRequire("egoNX");
var $cYzPN = parcelRequire("cYzPN");
var $7FZkz = parcelRequire("7FZkz");

var $eN72F = parcelRequire("eN72F");

var $ioVMT = parcelRequire("ioVMT");

var $hCd6c = parcelRequire("hCd6c");

var $c3PBx = parcelRequire("c3PBx");

var $8aSS4 = parcelRequire("8aSS4");

var $5qbUf = parcelRequire("5qbUf");

var $5OqMf = parcelRequire("5OqMf");
/**
 * Takes a list of existing badges and adds another bedge if the product has the given attributes.
 */ const $6b1cf69424450a73$var$mapBadge = (existingBadges, product, certificationValue, badgeName, badgeKey)=>{
    if ((0, $bEEBX.default)(product.certifications)) return;
    const normalizedCerts = product.certifications.map((cert)=>cert?.toLowerCase() || "");
    if ((0, $ioVMT.default)(normalizedCerts, certificationValue.toLowerCase())) existingBadges.push({
        name: badgeName,
        key: badgeKey
    });
};
const $6b1cf69424450a73$export$344c8d19433adfdd = (product)=>{
    const badges = [];
    if (product.recyclingChargeBaseUnit === 2) badges.push({
        name: "Pant, kr 2",
        key: "pant_2kr"
    });
    if (product.recyclingChargeBaseUnit === 3) badges.push({
        name: "Pant, kr 3",
        key: "pant_3kr"
    });
    $6b1cf69424450a73$var$mapBadge(badges, product, "Nyt_Norge", "Nyt Norge", "nyt_norge");
    $6b1cf69424450a73$var$mapBadge(badges, product, "Nokkelhullet", "N\xf8kkelhull", "nokkelhullet");
    return badges;
};
const $6b1cf69424450a73$export$dac7a6a268035522 = (products)=>{
    const brands = new Set();
    for (const product of products)if (product.brand) brands.add(product.brand);
    return Array.from(brands);
};
const $6b1cf69424450a73$export$5251b756438ddf5b = (product)=>!(0, $bEEBX.default)(product.expiringFromDate) && product.expiringFromDate !== "" && (0, $khZbR.default)((0, $6OXuO.default)((0, $5UIm0.default)(product.expiringFromDate), 6));
const $6b1cf69424450a73$export$dd12f34b1e178660 = [
    "5778",
    "7110",
    "7106",
    "7109",
    "345",
    "102",
    "410",
    "805",
    "6896",
    "638",
    "8687",
    "8768",
    "6746",
    "6855",
    "6862",
    "6865",
    "6746",
    "2907",
    "2978",
    "8723",
    "8771",
    "8773",
    "8815",
    "8661",
    "5254",
    "8720",
    "8956"
];
const $6b1cf69424450a73$export$3b69081fa3d0d9db = (product)=>{
    if (!product.newUntilDate) return false;
    const newUntil = (0, $8l6c2.default)(product.newUntilDate, "dd.MM.yyyy", new Date());
    return (0, $epcVC.default)(newUntil);
};
const $6b1cf69424450a73$export$6f4a42f2f0c926d4 = (product)=>{
    const labels = [];
    // Label: Veievare - Prio: 1
    if (product.variableWeight) labels.push({
        text: "Veievare",
        color: "gray",
        position: "bottom-right",
        page: [
            (0, $5qbUf.PageType).ProductDetailsPage,
            (0, $5qbUf.PageType).ProductListPage
        ]
    });
    // Label: Nyhet - Prio: 2 (#c40076)
    if ($6b1cf69424450a73$export$3b69081fa3d0d9db(product)) labels.push({
        text: "Nyhet",
        color: "blue",
        position: "top-left",
        page: [
            (0, $5qbUf.PageType).ProductDetailsPage,
            (0, $5qbUf.PageType).ProductListPage
        ]
    });
    // Label: Siste sjanse - Prio: 3 - Show 4 weeks before expiry date (#c40076)
    if (!product.expired && !(0, $bEEBX.default)(product.expiringFromDate) && product.expiringFromDate.length > 0) {
        if ($6b1cf69424450a73$export$5251b756438ddf5b(product)) labels.push({
            text: "Siste sjanse",
            color: "red",
            position: "top-left",
            page: [
                (0, $5qbUf.PageType).ProductDetailsPage,
                (0, $5qbUf.PageType).ProductListPage
            ]
        });
    }
    // Label: Utgått - Prio: 3 - Show after product is expired
    if (product.expired && !(0, $ioVMT.default)($6b1cf69424450a73$export$dd12f34b1e178660, product.sku)) labels.push({
        text: "Utg\xe5tt",
        color: "red",
        position: "top-left",
        page: [
            (0, $5qbUf.PageType).ProductDetailsPage,
            (0, $5qbUf.PageType).ProductListPage
        ]
    });
    // Label: Avtalesortiment - Prio: 3 (#554494 + tag icon)
    if (product.inAgreementAssortment) labels.push({
        text: "Avtalesortiment",
        color: "gray",
        position: "bottom-left",
        page: [
            (0, $5qbUf.PageType).ProductListPage
        ]
    });
    // Label: Økologisk - Prio: 3 (#c40076)
    const lowercaseCertifications = product.certifications?.map((0, $7FZkz.default)) ?? [];
    if ((0, $ioVMT.default)(lowercaseCertifications, "eu_okologi") || (0, $ioVMT.default)(lowercaseCertifications, "debio")) labels.push({
        text: "\xd8kologisk",
        color: "green",
        position: "top-left",
        page: [
            (0, $5qbUf.PageType).ProductListPage,
            (0, $5qbUf.PageType).ProductDetailsPage
        ]
    });
    // Label: Egne frister (for minitanker) - Prio: 5 (#4d70bc)
    if (product.miniTank) labels.push({
        text: "Egne frister",
        color: "gray",
        position: "bottom-left",
        page: [
            (0, $5qbUf.PageType).ProductListPage,
            (0, $5qbUf.PageType).ProductDetailsPage
        ]
    });
    if ((0, $ioVMT.default)($6b1cf69424450a73$export$dd12f34b1e178660, product.sku)) labels.push({
        text: "Sesong",
        color: "moss",
        position: "top-left",
        page: [
            (0, $5qbUf.PageType).ProductListPage,
            (0, $5qbUf.PageType).ProductDetailsPage
        ]
    });
    return labels;
};
const $6b1cf69424450a73$export$61a680df798908b1 = (product, activeFilters)=>{
    return (0, $eN72F.default)(activeFilters, (selectedValues, field)=>{
        // Type-guards to make sure field name sent to filter function are "filterable"
        if (!(0, $5qbUf.hasKey)(product, field) || !(0, $5qbUf.isFilterAttribute)(field)) return false;
        if (!selectedValues?.length) return true;
        const productValue = product[field];
        return (0, $c3PBx.default)(selectedValues, (selectedValue)=>(0, $hCd6c.default)(productValue) ? (0, $ioVMT.default)(productValue, selectedValue) : productValue === selectedValue);
    });
};
const $6b1cf69424450a73$var$isMultiValueField = (field)=>[
        "certifications",
        "tastes",
        "tasteGroups",
        "allergyInfo"
    ].includes(field);
const $6b1cf69424450a73$export$c6228deca5711404 = (products, field, name)=>{
    if ((0, $3xOZa.default)(products)) return null;
    // Remove products that dont have this field set or has an empty array for this field
    const validProductsForFilters = products.filter((p)=>!(0, $bEEBX.default)(p[field]) && (p[field]?.length ?? 0) > 0);
    // If a field given is a field that can have multiple values, we split the product into multiple products, one for each value
    // in array (for instance, one products with two certifications turns into two separate products in this chain)
    // The filter excludes values that are falsey
    const skuAndFieldValues = validProductsForFilters.flatMap((p)=>$6b1cf69424450a73$var$isMultiValueField(field) ? (p[field] ?? []).map((c)=>({
                sku: p.sku,
                value: c
            })) : [
            {
                sku: p.sku,
                value: p[field]
            }
        ]).filter((skuAndFieldValue)=>skuAndFieldValue.value);
    // Group all products based on their value in field
    const groupedByValue = (0, $jvljM.default)(skuAndFieldValues, "value");
    const knownValues = $6b1cf69424450a73$export$b9de641fe24c14c9(field);
    const values = knownValues ? knownValues.filter((value)=>value in groupedByValue) : Object.keys(groupedByValue);
    const groupedByFieldValue = (0, $cYzPN.default)(groupedByValue, "sku");
    if ((0, $egoNX.default)(groupedByFieldValue).length === 0) return null;
    const optional = field === "customerType" ? {
        radioDefault: "Isbar"
    } : {};
    return {
        field: field,
        name: name,
        options: groupedByFieldValue,
        values: values,
        ...optional
    };
};
const $6b1cf69424450a73$export$6a964d059d742a02 = (fullSettings, effectiveFilters, products)=>{
    const relevantFilterSettings = fullSettings.map((settings)=>{
        if (settings.radioDefault) return settings;
        let testFilters = {
            ...effectiveFilters
        };
        const filterForSettings = effectiveFilters[settings.field];
        if (filterForSettings) {
            const { [settings.field]: _, ...otherFilters } = effectiveFilters;
            testFilters = otherFilters;
        }
        const productsFilteredOnOtherFilters = products.filter((product)=>$6b1cf69424450a73$export$61a680df798908b1(product, testFilters));
        return $6b1cf69424450a73$export$c6228deca5711404(productsFilteredOnOtherFilters, settings.field, settings.name);
    }).filter((f)=>f && f.values.length > 0 && f.values.length < 11 || f?.field === "tasteGroups" || f?.field === "brandGroup");
    const hasTastes = relevantFilterSettings.some((filterSetting)=>filterSetting.field === "tastes");
    const hasTastGroupsEffectiveFilter = (effectiveFilters.tasteGroups?.length || 0) > 0;
    return (0, $5qbUf.legalFilterKeys).map((key)=>relevantFilterSettings.find((filter)=>filter.field === key)).filter((filter)=>filter && !(hasTastes && !hasTastGroupsEffectiveFilter && filter.field === "tasteGroups") && !(hasTastGroupsEffectiveFilter && filter.field === "tastes"));
};
const $6b1cf69424450a73$export$ad37cd1a82407fe8 = (product)=>product.priceBeforeDiscount !== product.price;
const $6b1cf69424450a73$export$90a48c7c6995983e = (unit)=>(0, $ioVMT.default)([
        (0, $8aSS4.ORDER_UNIT).D,
        (0, $8aSS4.ORDER_UNIT).DFP
    ], unit);
const $6b1cf69424450a73$var$nbsp = String.fromCodePoint(0x00a0);
const $6b1cf69424450a73$var$_half = String.fromCodePoint(0x00bd); // ½
const $6b1cf69424450a73$export$885c878500d8d487 = (name)=>{
    return name ? name.trim().replace(/\s+(kg|g|l|ml|dl|liter|%)(\s|$)/gi, `${$6b1cf69424450a73$var$nbsp}$1$2`) : name;
};
function $6b1cf69424450a73$export$e363e8c4cdb108a(products, shouldPrioritize) {
    const safeProducts = products ?? [];
    return shouldPrioritize ? safeProducts.toSorted((a, b)=>Number(b.inAgreementAssortment) - Number(a.inAgreementAssortment)) : safeProducts;
}
const $6b1cf69424450a73$export$3dea766d36a8935f = (products, filters)=>{
    return products.filter((p)=>$6b1cf69424450a73$export$61a680df798908b1(p, filters));
};
const $6b1cf69424450a73$var$knownTINEProductBrandToBrand = {
    Litago: "Litago",
    Norvegia: "Norvegia",
    Jarlsberg: "Jarlsberg",
    "Sn\xf8frisk": "Snofrisk",
    Fryd: "Dovre",
    "Go'morgen": "GoMorgen",
    Fjordland: "Fjordland",
    Bremykt: "Fjordland",
    Brelett: "Fjordland",
    Noisy: "Noisy",
    Isklar: "Isklar",
    YT: "YT",
    Biola: "Biola",
    "Gryr\xae": "Gryr",
    "\xd8stavind": "Ostavind",
    Piano: "Piano",
    "TINE Kremost": "Kremgo",
    Kos: "Kos"
};
const $6b1cf69424450a73$var$knownTINEProductBrands = Object.keys($6b1cf69424450a73$var$knownTINEProductBrandToBrand);
const $6b1cf69424450a73$var$brandExceptions = {
    TINE: [
        "2195",
        "2182",
        "3076",
        "3078",
        "3081",
        "3095",
        "3096",
        "3100",
        "3150"
    ],
    Other: [
        "4565",
        "4580",
        "79"
    ]
};
const $6b1cf69424450a73$var$getBrandException = (sku)=>{
    return Object.keys($6b1cf69424450a73$var$brandExceptions).find((brand)=>$6b1cf69424450a73$var$brandExceptions[brand]?.includes(sku));
};
const $6b1cf69424450a73$var$tineBrandResolver = (product)=>{
    const { brand: brand, name: name, sku: sku } = product;
    const exceptionBrand = $6b1cf69424450a73$var$getBrandException(sku);
    if (exceptionBrand) return exceptionBrand;
    if (/yoplait/i.test(name)) return "Yoplait";
    if (brand) {
        if (brand === "Fjordland") {
            if (/kos/i.test(name)) return "Kos";
        }
        if ($6b1cf69424450a73$var$knownTINEProductBrands.includes(brand)) return $6b1cf69424450a73$var$knownTINEProductBrandToBrand[brand];
        if (/sunniva/i.test(brand)) return "Sunniva";
    }
    if (/selbu/i.test(name)) return "SelbuBlaa";
    if (!brand) {
        if (/(tine)|(norzola)|(taffel)|(ridder)/i.test(name)) return "TINE";
        if (/gryr/i.test(name)) return "Gryr";
        if (/norvegia/i.test(name)) return "Norvegia";
        return "Other";
    }
    if (brand === "Ostecompagniet") return "Other";
    return "TINE";
};
const $6b1cf69424450a73$var$diplomisBrandResolver = (_product)=>{
    return "Diplomis";
};
const $6b1cf69424450a73$var$leverantBrandResolver = (_product)=>{
    return "TINE";
};
const $6b1cf69424450a73$var$isdalenBrandResolver = (_product)=>{
    return "Kulinaris";
};
const $6b1cf69424450a73$var$brandsByStoreId = {
    tinehandel: (0, $5qbUf.brandsTINE),
    diplomis: (0, $5qbUf.brandsDiplomis),
    leverant: (0, $5qbUf.brandsLeverant),
    isdalen: (0, $5qbUf.brandsIsdalen)
};
const $6b1cf69424450a73$export$30e8cedba0c42596 = (storeId)=>{
    const brands = Array.from($6b1cf69424450a73$var$brandsByStoreId[storeId]);
    const indicesByValue = brands.map((value, index)=>({
            [value]: index
        })).reduce((0, $5OqMf.accumulate), {});
    const compare = (value1, value2)=>{
        if (value1 in indicesByValue) {
            if (value2 in indicesByValue) return indicesByValue[value1] - indicesByValue[value2];
            return -1;
        }
        if (value2 in indicesByValue) return 1;
        return value1 === value2 ? 0 : value1 < value2 ? -1 : 1;
    };
    return (brands)=>[
            ...brands
        ].sort(compare);
};
const $6b1cf69424450a73$export$db53a94ed5e23b60 = (storeId)=>{
    switch(storeId){
        case "tinehandel":
            return $6b1cf69424450a73$var$tineBrandResolver;
        case "diplomis":
            return $6b1cf69424450a73$var$diplomisBrandResolver;
        case "leverant":
            return $6b1cf69424450a73$var$leverantBrandResolver;
        case "isdalen":
            return $6b1cf69424450a73$var$isdalenBrandResolver;
        default:
            return $6b1cf69424450a73$var$tineBrandResolver;
    }
};
const $6b1cf69424450a73$var$weightRangeValues = [
    "under 200 g",
    "200 g - 399 g",
    "400 g - 599 g",
    "600 g - 999 g",
    "1 kg - 2 kg",
    "over 2 kg"
];
const $6b1cf69424450a73$var$weightRanges = {
    "under 200 g": [
        0,
        200
    ],
    "200 g - 399 g": [
        200,
        400
    ],
    "400 g - 599 g": [
        400,
        600
    ],
    "600 g - 999 g": [
        600,
        1000
    ],
    "1 kg - 2 kg": [
        1000,
        2001
    ],
    "over 2 kg": [
        2001,
        Number.MAX_SAFE_INTEGER
    ]
};
const $6b1cf69424450a73$export$1759cf656e29009b = (product)=>{
    const { weight: weight } = product;
    const gramWeight = weight * 1000;
    if (typeof weight !== "number" || weight < 0) return null;
    for (const rangeKey of $6b1cf69424450a73$var$weightRangeValues){
        const range = $6b1cf69424450a73$var$weightRanges[rangeKey];
        if (gramWeight >= range[0] && gramWeight < range[1]) return rangeKey;
    }
    return null;
};
const $6b1cf69424450a73$var$volumeRangeValues = [
    "Under 1/2 liter",
    "1/2 - under 1 liter",
    "1 liter",
    "1,5 / 1,75 liter",
    "2 - 5 liter",
    "10 liter",
    "Fra 100 liter"
];
const $6b1cf69424450a73$var$knownSizeToVolumeRangeValue = {
    "Opp til 1/2 liter": "Under 1/2 liter",
    "1/2 liter - 1 liter": "1/2 - under 1 liter",
    "1 liter": "1 liter",
    "1,5 liter": "1,5 / 1,75 liter",
    "1,75 liter": "1,5 / 1,75 liter",
    "2 liter - 5 liter": "2 - 5 liter",
    "10 liter": "10 liter",
    "Bag in box (10 liter)": "10 liter",
    "Fra 100 liter": "Fra 100 liter"
};
const $6b1cf69424450a73$var$allowConversionToVolumeRange = (product)=>{
    const { name: name } = product;
    return /biola/i.test(name) || /litago/i.test(name) || /yogh/i.test(name) || /pudding/i.test(name) || /kaffefløte/i.test(name) || /kaffemelk/i.test(name) || /cottage/i.test(name) || /kesam/i.test(name) || /kvarg/i.test(name);
};
const $6b1cf69424450a73$var$getVolumeFromPackaging = (packaging)=>{
    const res = /([\d,]+)\s?l/i.exec(packaging);
    if (res && res.length > 1) return Number(res[1].replace(",", "."));
};
const $6b1cf69424450a73$export$dec331567e383785 = (product)=>{
    const { size: size, weight: weight, packaging: packaging, sku: sku } = product;
    if ([
        "7147"
    ].includes(sku)) return "Under 1/2 liter";
    if ([
        "7231",
        "7232"
    ].includes(sku)) return "1 liter";
    const volumeRange = $6b1cf69424450a73$var$knownSizeToVolumeRangeValue[size];
    if (!volumeRange) {
        const knownSize = size;
        if ($6b1cf69424450a73$var$allowConversionToVolumeRange(product)) {
            if (knownSize === "Opp til 500 g") {
                if (weight >= 0.5) return "1/2 - under 1 liter";
                return "Under 1/2 liter";
            }
            if (knownSize === "500 g - 1 kg") {
                if (weight >= 1) return "1 liter";
                return "1/2 - under 1 liter";
            }
            if (weight < 0.5) return "Under 1/2 liter";
            if (weight >= 0.5 && weight <= 0.9) return "1/2 - under 1 liter";
            if (weight > 0.9 && weight < 1.1) return "1 liter";
            if (weight > 1.4 && weight < 1.8) return "1,5 / 1,75 liter";
            if (weight > 2 && weight < 5.5) return "2 - 5 liter";
            if (weight > 10 && weight < 11) return "10 liter";
            if (weight > 100) return "Fra 100 liter";
        }
        if (packaging) {
            const volumeFromPackaging = $6b1cf69424450a73$var$getVolumeFromPackaging(packaging);
            if (typeof volumeFromPackaging === "number") {
                if (volumeFromPackaging < 0.5) return "Under 1/2 liter";
                if (volumeFromPackaging < 1) return "1/2 - under 1 liter";
                if (volumeFromPackaging < 1.1) return "1 liter";
                if (volumeFromPackaging < 1.8) return "1,5 / 1,75 liter";
                if (volumeFromPackaging < 6) return "2 - 5 liter";
                if (volumeFromPackaging < 11) return "10 liter";
                if (volumeFromPackaging > 99) return "Fra 100 liter";
            }
        }
    }
    return volumeRange || null;
};
const $6b1cf69424450a73$var$sizeRangeValues = [
    "Under 1/2 kg/liter",
    "1/2 - under 1 kg/liter",
    "1 kg/liter",
    "Over 1 - 5 kg/liter",
    "Over 5 kg/liter"
];
const $6b1cf69424450a73$export$bbd070b72d41d82b = (product)=>{
    const { weight: weight, size: size } = product;
    const knownSize = size;
    if (knownSize === "Fra 100 liter" || knownSize === "Over 10 kg" || knownSize === "Bag in box (10 liter)" || knownSize === "5 kg - 10 kg") return "Over 5 kg/liter";
    if (knownSize === "1 kg - 5 kg" && weight >= 1.1) return "Over 1 - 5 kg/liter";
    if (!weight) return null;
    if (weight < 0.5) return "Under 1/2 kg/liter";
    if (weight < 1) return "1/2 - under 1 kg/liter";
    if (weight < 1.1) return "1 kg/liter";
    if (weight < 5.5) return "Over 1 - 5 kg/liter";
    return "Over 5 kg/liter";
};
const $6b1cf69424450a73$export$b9de641fe24c14c9 = (filterKey)=>{
    switch(filterKey){
        case "brandGroup":
            return [
                ...(0, $5qbUf.brandsTINE)
            ];
        case "weightRange":
            return $6b1cf69424450a73$var$weightRangeValues;
        case "volumeRange":
            return $6b1cf69424450a73$var$volumeRangeValues;
        case "sizeRange":
            return $6b1cf69424450a73$var$sizeRangeValues;
        case "tastes":
            return [
                ...$6b1cf69424450a73$export$e200e5a5fefae964
            ];
        case "tasteGroups":
            return [
                ...$6b1cf69424450a73$export$7be97fe0385d36b3
            ];
        case "allergyInfo":
            return [
                ...$6b1cf69424450a73$export$5724468473802905
            ];
        default:
            return null;
    }
};
const $6b1cf69424450a73$export$7be97fe0385d36b3 = [
    "Naturell",
    "Sjokolade",
    "Karamell",
    "Kaffe",
    "Vanilje",
    "Krydder / urter",
    "B\xe6r",
    "Frukt",
    "Gr\xf8nnsaker",
    "\xd8vrige"
];
const $6b1cf69424450a73$export$e200e5a5fefae964 = [
    "Naturell",
    "Sjokolade",
    "Karamell",
    "Kaffe",
    "Vanilje",
    "Chili",
    "Krydder",
    "Urter",
    "Pepper",
    "Gurkemeie",
    "Hvitl\xf8k",
    "Ramsl\xf8k",
    "Ingef\xe6r",
    "Spisskum",
    "Nellik",
    "Kanel",
    "Dill",
    "R\xf8de b\xe6r",
    "Bringeb\xe6r",
    "Jordb\xe6r",
    "Skogsb\xe6r",
    "Kirseb\xe6r",
    "Morell",
    "Bl\xe5b\xe6r",
    "Molte",
    "Bj\xf8rneb\xe6r",
    "Traneb\xe6r",
    "Rips",
    "Frukt",
    "Eple",
    "P\xe6re",
    "Appelsin",
    "Mandarin",
    "Sitron",
    "Lime",
    "Grapefrukt",
    "Banan",
    "Fersken",
    "Mango",
    "Granateple",
    "Pasjonsfrukt",
    "Ananas",
    "Tropisk",
    "Melon",
    "Vannmelon",
    "Guava",
    "Kokos",
    "Sviske",
    "Rabarbra",
    "Gr\xf8nnsaker",
    "Gresskar",
    "Tomat",
    "R\xf8dbet",
    "Gulrot",
    "Paprika",
    "Kantarell",
    "Honning",
    "Rom",
    "Mandel",
    "Pean\xf8tt",
    "Bacon",
    "Skinke"
];
const $6b1cf69424450a73$var$tasteToTasteGroup = {
    Naturell: "Naturell",
    Sjokolade: "Sjokolade",
    Karamell: "Karamell",
    Kaffe: "Kaffe",
    Vanilje: "Vanilje",
    Chili: "Krydder / urter",
    Krydder: "Krydder / urter",
    Urter: "Krydder / urter",
    Pepper: "Krydder / urter",
    Gurkemeie: "Krydder / urter",
    "Hvitl\xf8k": "Krydder / urter",
    "Ramsl\xf8k": "Krydder / urter",
    "Ingef\xe6r": "Krydder / urter",
    Spisskum: "Krydder / urter",
    Nellik: "Krydder / urter",
    Kanel: "Krydder / urter",
    Dill: "Krydder / urter",
    "R\xf8de b\xe6r": "B\xe6r",
    "Bringeb\xe6r": "B\xe6r",
    "Jordb\xe6r": "B\xe6r",
    "Skogsb\xe6r": "B\xe6r",
    "Kirseb\xe6r": "B\xe6r",
    Morell: "B\xe6r",
    "Bl\xe5b\xe6r": "B\xe6r",
    Molte: "B\xe6r",
    "Bj\xf8rneb\xe6r": "B\xe6r",
    "Traneb\xe6r": "B\xe6r",
    Rips: "B\xe6r",
    Frukt: "Frukt",
    Eple: "Frukt",
    "P\xe6re": "Frukt",
    Appelsin: "Frukt",
    Mandarin: "Frukt",
    Sitron: "Frukt",
    Lime: "Frukt",
    Grapefrukt: "Frukt",
    Banan: "Frukt",
    Fersken: "Frukt",
    Mango: "Frukt",
    Granateple: "Frukt",
    Pasjonsfrukt: "Frukt",
    Ananas: "Frukt",
    Tropisk: "Frukt",
    Melon: "Frukt",
    Vannmelon: "Frukt",
    Guava: "Frukt",
    Kokos: "Frukt",
    Sviske: "Frukt",
    Rabarbra: "Frukt",
    "Gr\xf8nnsaker": "Gr\xf8nnsaker",
    Gresskar: "Gr\xf8nnsaker",
    Tomat: "Gr\xf8nnsaker",
    "R\xf8dbet": "Gr\xf8nnsaker",
    Gulrot: "Gr\xf8nnsaker",
    Paprika: "Gr\xf8nnsaker",
    Kantarell: "Gr\xf8nnsaker",
    Honning: "\xd8vrige",
    Rom: "\xd8vrige",
    Mandel: "\xd8vrige",
    "Pean\xf8tt": "\xd8vrige",
    Bacon: "\xd8vrige",
    Skinke: "\xd8vrige"
};
const $6b1cf69424450a73$var$tasteRegExps = {
    Pasjonsfrukt: /pasjon/i,
    Rom: /\brom\b/i,
    Kaffe: /kaffe\b|kaffesmak|cappuccino/i,
    Sjokolade: /sjoko|kakao|mocha/i
};
const $6b1cf69424450a73$var$getTasteRegExp = (taste)=>{
    if (!$6b1cf69424450a73$var$tasteRegExps[taste]) $6b1cf69424450a73$var$tasteRegExps[taste] = new RegExp(taste, "i");
    return $6b1cf69424450a73$var$tasteRegExps[taste];
};
const $6b1cf69424450a73$var$hasTaste = (product, knownTaste)=>{
    const { taste: taste, name: name } = product;
    const re = $6b1cf69424450a73$var$getTasteRegExp(knownTaste);
    if (taste) {
        if (re.test(taste)) return true;
    }
    if (re.test(name)) return true;
    return false;
};
const $6b1cf69424450a73$export$f327a85858e5d054 = (product)=>{
    return $6b1cf69424450a73$export$e200e5a5fefae964.filter((taste)=>$6b1cf69424450a73$var$hasTaste(product, taste));
};
const $6b1cf69424450a73$export$f836a2ed474c46fe = (tastes)=>{
    const groups = new Set();
    for (const taste of tastes)groups.add($6b1cf69424450a73$var$tasteToTasteGroup[taste]);
    return Array.from(groups);
};
const $6b1cf69424450a73$export$8ebd94a13bbec81f = (product)=>{
    const exclude = [
        "8941",
        "8948",
        "8829",
        "8927",
        "8582"
    ];
    if (exclude.includes(product.sku)) return {
        tastes: [],
        tasteGroups: []
    };
    const tastes = $6b1cf69424450a73$export$f327a85858e5d054(product);
    const tasteGroups = $6b1cf69424450a73$export$f836a2ed474c46fe(tastes);
    return {
        tastes: tastes,
        tasteGroups: tasteGroups
    };
};
const $6b1cf69424450a73$export$5724468473802905 = [
    "Glutenfri",
    "Laktosefri",
    "Laktoseredusert",
    "Plantebasert"
];
const $6b1cf69424450a73$var$allergyInfoRegExpes = {
    Glutenfri: /glutenfri/i,
    Laktosefri: /laktosefri/i,
    Laktoseredusert: /laktoseredusert/i,
    Plantebasert: /plante/i
};
const $6b1cf69424450a73$export$f7346105b628b513 = (product)=>{
    const { searchWord: searchWord, name: name, description: description } = product;
    if (searchWord?.length) return $6b1cf69424450a73$export$5724468473802905.filter((value)=>searchWord.find((word)=>$6b1cf69424450a73$var$allergyInfoRegExpes[value].test(word)) || $6b1cf69424450a73$var$allergyInfoRegExpes[value].test(name) || $6b1cf69424450a73$var$allergyInfoRegExpes[value].test(description?.toString() || ""));
    return [];
};
const $6b1cf69424450a73$var$formats = [
    "Kuvert",
    "Bag-in-box",
    "Beger",
    "Skiver",
    "Blokk",
    "Spann",
    "Kartong",
    "Flaske",
    "Hjul",
    "Sprayboks",
    "Pose",
    "Pall",
    "Tank"
];
const $6b1cf69424450a73$var$formatRegExpes = {
    "Bag-in-box": /bag-in-box|\bbib\b/i,
    Skiver: /skive(r|t)/i
};
const $6b1cf69424450a73$var$getFormatRegExp = (format)=>{
    if (!$6b1cf69424450a73$var$formatRegExpes[format]) $6b1cf69424450a73$var$formatRegExpes[format] = new RegExp(format, "i");
    return $6b1cf69424450a73$var$formatRegExpes[format];
};
const $6b1cf69424450a73$export$f61ac8b6f1f46202 = (product)=>{
    const { packaging: packaging } = product;
    for (const format of $6b1cf69424450a73$var$formats){
        if (packaging?.match($6b1cf69424450a73$var$getFormatRegExp(format))) return format;
    }
    return null;
};

});
parcelRegister("6OXuO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f759040ab9f64e8$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $d2sDA = parcelRequire("d2sDA");

var $hFacL = parcelRequire("hFacL");
function $4f759040ab9f64e8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var amount = (0, $970db.default)(dirtyAmount);
    return (0, $d2sDA.default)(dirtyDate, -amount);
}

});

parcelRegister("cYzPN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9726e2998a007d2d$export$2e2bcd8739ae039; });

var $hiRHm = parcelRequire("hiRHm");

var $bGsl1 = parcelRequire("bGsl1");

var $aIIzU = parcelRequire("aIIzU");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9726e2998a007d2d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = (0, $aIIzU.default)(iteratee, 3);
    (0, $bGsl1.default)(object, function(value, key, object) {
        (0, $hiRHm.default)(result, key, iteratee(value, key, object));
    });
    return result;
}
var $9726e2998a007d2d$export$2e2bcd8739ae039 = $9726e2998a007d2d$var$mapValues;

});

parcelRegister("7FZkz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $596befc1596e2797$export$2e2bcd8739ae039; });

var $cQbRr = parcelRequire("cQbRr");
/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */ function $596befc1596e2797$var$toLower(value) {
    return (0, $cQbRr.default)(value).toLowerCase();
}
var $596befc1596e2797$export$2e2bcd8739ae039 = $596befc1596e2797$var$toLower;

});

parcelRegister("eN72F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac4b1ab0d3cc119b$export$2e2bcd8739ae039; });

var $7tXes = parcelRequire("7tXes");

var $h6FaX = parcelRequire("h6FaX");

var $aIIzU = parcelRequire("aIIzU");

var $hCd6c = parcelRequire("hCd6c");

var $e0K8B = parcelRequire("e0K8B");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $ac4b1ab0d3cc119b$var$every(collection, predicate, guard) {
    var func = (0, $hCd6c.default)(collection) ? (0, $7tXes.default) : (0, $h6FaX.default);
    if (guard && (0, $e0K8B.default)(collection, predicate, guard)) predicate = undefined;
    return func(collection, (0, $aIIzU.default)(predicate, 3));
}
var $ac4b1ab0d3cc119b$export$2e2bcd8739ae039 = $ac4b1ab0d3cc119b$var$every;

});
parcelRegister("7tXes", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57293022db8c6139$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $57293022db8c6139$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
var $57293022db8c6139$export$2e2bcd8739ae039 = $57293022db8c6139$var$arrayEvery;

});

parcelRegister("h6FaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c742efdb140f1194$export$2e2bcd8739ae039; });

var $7xRth = parcelRequire("7xRth");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $c742efdb140f1194$var$baseEvery(collection, predicate) {
    var result = true;
    (0, $7xRth.default)(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
var $c742efdb140f1194$export$2e2bcd8739ae039 = $c742efdb140f1194$var$baseEvery;

});


parcelRegister("5qbUf", function(module, exports) {

$parcel$export(module.exports, "PageType", function () { return $2130bb689341b2b1$export$8a1b881a780085ba; });
$parcel$export(module.exports, "legalFilterKeys", function () { return $2130bb689341b2b1$export$9d77ea2b305bc5df; });
$parcel$export(module.exports, "hasKey", function () { return $2130bb689341b2b1$export$94df19ecb868bc1a; });
$parcel$export(module.exports, "isFilterAttribute", function () { return $2130bb689341b2b1$export$eb62c78b447bf65; });
$parcel$export(module.exports, "brandsTINE", function () { return $2130bb689341b2b1$export$d533d0690bbcb5d3; });
$parcel$export(module.exports, "brandsLeverant", function () { return $2130bb689341b2b1$export$2e955794767d60c2; });
$parcel$export(module.exports, "brandsDiplomis", function () { return $2130bb689341b2b1$export$17d0dde091076aaa; });
$parcel$export(module.exports, "brandsIsdalen", function () { return $2130bb689341b2b1$export$51e59433201da718; });

var $ioVMT = parcelRequire("ioVMT");

var $bEEBX = parcelRequire("bEEBX");
var $2130bb689341b2b1$export$8a1b881a780085ba = /*#__PURE__*/ function(PageType) {
    PageType["ProductListPage"] = "plp";
    PageType["ProductDetailsPage"] = "pdp";
    return PageType;
}({});
const $2130bb689341b2b1$export$9d77ea2b305bc5df = [
    "brand",
    "brandGroup",
    "format",
    "certifications",
    "size",
    "taste",
    "type",
    "accessoryType",
    "customerType",
    "weightRange",
    "volumeRange",
    "sizeRange",
    "tasteGroups",
    "tastes",
    "allergyInfo"
];
function $2130bb689341b2b1$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $2130bb689341b2b1$export$eb62c78b447bf65(key) {
    return $2130bb689341b2b1$export$9d77ea2b305bc5df.includes(key);
}
function $2130bb689341b2b1$export$b9698883f9a65ecd(src) {
    if ((0, $bEEBX.default)(src)) return false;
    return (0, $ioVMT.default)(src, "<");
}
const $2130bb689341b2b1$export$d533d0690bbcb5d3 = [
    "TINE",
    "Litago",
    "Biola",
    "Norvegia",
    "Jarlsberg",
    "Ostavind",
    "Snofrisk",
    "Kremgo",
    "SelbuBlaa",
    "Dovre",
    "Gryr",
    "Iste",
    "Noisy",
    "Sunniva",
    "YT",
    "Fjordland",
    "Isklar",
    "Yoplait",
    "GoMorgen",
    "Piano",
    "Kos",
    "Other"
];
const $2130bb689341b2b1$export$2e955794767d60c2 = [
    "Leverant",
    "TINE"
];
const $2130bb689341b2b1$export$17d0dde091076aaa = [
    "Diplomis",
    "Lollipop",
    "Royal"
];
const $2130bb689341b2b1$export$51e59433201da718 = [
    "Kulinaris",
    "Nicks",
    "Tonitto"
];

});




parcelRegister("iJEB8", function(module, exports) {

$parcel$export(module.exports, "clearAllCompanySpecificStoreData", function () { return $88284a8a6423055b$export$d5b1118ac8cf2f91; });

var $Kk7R3 = parcelRequire("Kk7R3");

var $gWRRy = parcelRequire("gWRRy");

var $8Wejn = parcelRequire("8Wejn");

var $jQJ4P = parcelRequire("jQJ4P");

var $25aT1 = parcelRequire("25aT1");

var $jNvKP = parcelRequire("jNvKP");

var $29xOK = parcelRequire("29xOK");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $9Vhxl = parcelRequire("9Vhxl");

var $6Cvem = parcelRequire("6Cvem");

var $jAf35 = parcelRequire("jAf35");

var $hOaHV = parcelRequire("hOaHV");

var $biFcX = parcelRequire("biFcX");

var $1vlMv = parcelRequire("1vlMv");

var $2JqjA = parcelRequire("2JqjA");

var $1Bsfi = parcelRequire("1Bsfi");

var $7mifc = parcelRequire("7mifc");

var $jVrYh = parcelRequire("jVrYh");

var $bZiDo = parcelRequire("bZiDo");

var $i6TQx = parcelRequire("i6TQx");

var $44W8i = parcelRequire("44W8i");

var $hFzdq = parcelRequire("hFzdq");

var $5aUWQ = parcelRequire("5aUWQ");

var $a2SqC = parcelRequire("a2SqC");

var $bcbvQ = parcelRequire("bcbvQ");
const $88284a8a6423055b$export$d5b1118ac8cf2f91 = (0, $Kk7R3.action)(()=>{
    (0, $bcbvQ.default).clearCompanySpecificData();
    (0, $1vlMv.default).clearCompanySpecificData();
    (0, $i6TQx.default).clearCompanySpecificData();
    (0, $44W8i.default).clearCompanySpecificData();
    (0, $gWRRy.default).clearCompanySpecificData();
    (0, $bZiDo.default).clearCompanySpecificData();
    (0, $9Vhxl.default).clearCompanySpecificData();
    (0, $1Bsfi.default).clearCompanySpecificData();
    (0, $2JqjA.default).clearCompanySpecificData();
    (0, $jNvKP.default).clearCompanySpecificData();
    (0, $hOaHV.default).clearCompanySpecificData();
    (0, $9yKIH.default).clearCompanySpecificData();
    (0, $biFcX.default).clearCompanySpecificData();
    (0, $6Cvem.default).clearCompanySpecificData();
    (0, $hFzdq.default).clearCompanySpecificData();
    (0, $29xOK.default).clearCompanySpecificData();
    (0, $8Wejn.default).clearCompanySpecificData();
    (0, $7mifc.default).clearCompanySpecificData();
    (0, $25aT1.default).clearCompanySpecificData();
    (0, $jAf35.default).clearCompanySpecificData();
    (0, $a2SqC.default).clearCompanySpecificData();
    (0, $jlTfJ.default).clearCompanySpecificData();
    (0, $5aUWQ.default).clearCompanySpecificData();
    (0, $jVrYh.default).clearCompanySpecificData();
    (0, $jQJ4P.default).clearCompanySpecificData();
});

});
parcelRegister("gWRRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f355e93ad637ae28$export$2e2bcd8739ae039; });

var $bEEBX = parcelRequire("bEEBX");

var $jQCqo = parcelRequire("jQCqo");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");
const $f355e93ad637ae28$var$accessStore = (0, $Kk7R3.makeAutoObservable)({
    users: (0, $duLFK.initializeWithDefaultData)([]),
    pleaseWait: false,
    skeletonEstimate: 1,
    getUsers: async ()=>{
        const token = (0, $bcbvQ.default).getSessionToken();
        const url = `${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/company/${(0, $bcbvQ.default).currentCompany}/users`;
        (0, $duLFK.setAsWaitingForData)($f355e93ad637ae28$var$accessStore.users);
        if ((0, $bEEBX.default)(url) || (0, $bEEBX.default)(token)) {
            (0, $duLFK.setAsErrorOccured)($f355e93ad637ae28$var$accessStore.users, "Feil under henting av brukere. Pr\xf8v \xe5 logge ut og inn igjen.");
            return;
        }
        try {
            const users = await (0, $3Y1Wx.apiClient)(url, token).get().json();
            (0, $Kk7R3.runInAction)(()=>{
                (0, $duLFK.setAsDataAvailable)($f355e93ad637ae28$var$accessStore.users, (0, $jQCqo.default)(users, [
                    "email"
                ]));
                $f355e93ad637ae28$var$accessStore.skeletonEstimate = users.length;
            });
        } catch (err) {
            (0, $gtsdT.logger).warn("auth", "Unable to fetch users", err);
            (0, $duLFK.setAsErrorOccured)($f355e93ad637ae28$var$accessStore.users, `Kunne ikke hente brukere. Teknisk feil: ${err}`);
        }
    },
    removeUser: async (email)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) {
            (0, $gtsdT.logger).warn("auth", "Cannot remove users without being logged in");
            throw new Error("Cannot remove users without being logged in");
        }
        const url = `${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/company/${(0, $bcbvQ.default).currentCompany}/users`;
        const token = (0, $bcbvQ.default).getSessionToken();
        try {
            (0, $Kk7R3.runInAction)(()=>{
                $f355e93ad637ae28$var$accessStore.pleaseWait = true;
                $f355e93ad637ae28$var$accessStore.skeletonEstimate--;
            });
            await (0, $3Y1Wx.apiClient)(url, token).query({
                email: email
            }).delete().json();
            return;
        } finally{
            (0, $Kk7R3.runInAction)(()=>{
                $f355e93ad637ae28$var$accessStore.pleaseWait = false;
            });
        }
    },
    addUser: async (firstName, lastName, email)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) {
            (0, $gtsdT.logger).warn("auth", "Cannot add users without being logged in");
            throw new Error("Cannot add users without being logged in");
        }
        const url = `${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/company/${(0, $bcbvQ.default).currentCompany}/users`;
        const token = (0, $bcbvQ.default).getSessionToken();
        try {
            (0, $Kk7R3.runInAction)(()=>{
                $f355e93ad637ae28$var$accessStore.pleaseWait = true;
                $f355e93ad637ae28$var$accessStore.skeletonEstimate++;
            });
            await (0, $3Y1Wx.apiClient)(url, token).query({
                email: email,
                firstName: firstName,
                lastName: lastName
            }).post().json();
            return;
        } finally{
            (0, $Kk7R3.runInAction)(()=>{
                $f355e93ad637ae28$var$accessStore.pleaseWait = false;
            });
        }
    },
    changeDefaultUser: async (newDefaultUserID)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) {
            (0, $gtsdT.logger).warn("auth", "Cannot change default user without being logged in");
            throw new Error("Cannot change default user without being logged in");
        }
        const url = `${(0, $8ZCSm.API_HOST)}/api/auth/${(0, $isIf6.default).storeId}/company/${(0, $bcbvQ.default).currentCompany}/defaultuser/${newDefaultUserID}`;
        const token = (0, $bcbvQ.default).getSessionToken();
        try {
            (0, $Kk7R3.runInAction)(()=>{
                $f355e93ad637ae28$var$accessStore.pleaseWait = true;
            });
            await (0, $3Y1Wx.apiClient)(url, token).query({
                newDefaultUserID: newDefaultUserID
            }).post().json();
            return;
        } finally{
            (0, $Kk7R3.runInAction)(()=>{
                $f355e93ad637ae28$var$accessStore.pleaseWait = false;
            });
        }
    },
    clearCompanySpecificData: ()=>{
        $f355e93ad637ae28$var$accessStore.users = (0, $duLFK.initializeWithDefaultData)([]);
    }
});
var $f355e93ad637ae28$export$2e2bcd8739ae039 = $f355e93ad637ae28$var$accessStore;

});

parcelRegister("jQJ4P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b56b6bb3c99744$export$2e2bcd8739ae039; });

var $jf2w9 = parcelRequire("jf2w9");

var $bEEBX = parcelRequire("bEEBX");

var $gwaiZ = parcelRequire("gwaiZ");

var $Kk7R3 = parcelRequire("Kk7R3");

var $gtsdT = parcelRequire("gtsdT");

var $f2Bp8 = parcelRequire("f2Bp8");

var $bZiDo = parcelRequire("bZiDo");
const $c3b56b6bb3c99744$var$barcodeStore = (0, $Kk7R3.makeAutoObservable)({
    modalVisible: false,
    cameraStart: false,
    cameraLoading: true,
    selectedCamera: (0, $f2Bp8.getBarcodeDeviceId)(),
    cameras: [],
    focus: null,
    error: null,
    torch: null,
    barcodeFound: "",
    productsFound: [],
    qty: 1,
    hideModal: ()=>{
        $c3b56b6bb3c99744$var$barcodeStore.resetMatches();
        $c3b56b6bb3c99744$var$barcodeStore.cameraLoading = true;
        $c3b56b6bb3c99744$var$barcodeStore.cameraStart = false;
        $c3b56b6bb3c99744$var$barcodeStore.modalVisible = false;
        $c3b56b6bb3c99744$var$barcodeStore.error = null;
    },
    resetMatches: ()=>{
        $c3b56b6bb3c99744$var$barcodeStore.productsFound = [];
        $c3b56b6bb3c99744$var$barcodeStore.barcodeFound = "";
        $c3b56b6bb3c99744$var$barcodeStore.qty = 1;
    },
    handleMatch: (code)=>{
        (0, $gtsdT.logger).log("scanner", "Updating matched products with code: ", code);
        if ((0, $gwaiZ.default)($c3b56b6bb3c99744$var$barcodeStore.productsFound) === 0) {
            const productsFound = (0, $bZiDo.default).findProductsByEAN(code);
            $c3b56b6bb3c99744$var$barcodeStore.barcodeFound = code;
            $c3b56b6bb3c99744$var$barcodeStore.productsFound = productsFound;
            if ((0, $gwaiZ.default)(productsFound) > 0) {
                (0, $gtsdT.logger).log("scanner", "Found products, pausing video...");
                return true;
            }
        }
        (0, $gtsdT.logger).log("scanner", "Did not find products");
        return false;
    },
    parseCameraArray: (cameras)=>{
        $c3b56b6bb3c99744$var$barcodeStore.cameras = cameras.map((cam)=>({
                name: cam.label || cam.deviceId /* || cam.id*/ ,
                deviceId: cam.deviceId /* || cam.id*/ 
            }));
        (0, $gtsdT.logger).log("scanner", "Internal cameras list updated", $c3b56b6bb3c99744$var$barcodeStore.cameras);
    },
    selectCamera: (deviceId)=>{
        const foundCamera = (0, $jf2w9.default)($c3b56b6bb3c99744$var$barcodeStore.cameras, (cam)=>cam.deviceId === deviceId);
        if ((0, $bEEBX.default)(foundCamera)) {
            (0, $gtsdT.logger).warn("scanner", `Unable to switch to camera, [${deviceId}] not found.`, $c3b56b6bb3c99744$var$barcodeStore.cameras);
            return;
        }
        (0, $gtsdT.logger).log("scanner", "Switching to camera", foundCamera);
        (0, $f2Bp8.setBarcodeDeviceIdInStorage)(foundCamera.deviceId);
        $c3b56b6bb3c99744$var$barcodeStore.selectedCamera = foundCamera.deviceId;
    },
    getSelectedCamera: ()=>{
        return (0, $jf2w9.default)($c3b56b6bb3c99744$var$barcodeStore.cameras, (cam)=>cam.deviceId === $c3b56b6bb3c99744$var$barcodeStore.selectedCamera);
    },
    showModal: ()=>{
        $c3b56b6bb3c99744$var$barcodeStore.modalVisible = true;
        setTimeout($c3b56b6bb3c99744$var$barcodeStore.startCamera, 150);
    },
    hideLoader: ()=>{
        $c3b56b6bb3c99744$var$barcodeStore.cameraLoading = false;
    },
    startCamera: ()=>{
        (0, $gtsdT.logger).log("scanner", "Starting camera for barcode scanner...");
        $c3b56b6bb3c99744$var$barcodeStore.cameraStart = true;
    },
    clearCompanySpecificData: ()=>{
    // add methods to clear company specific data
    }
});
var $c3b56b6bb3c99744$export$2e2bcd8739ae039 = $c3b56b6bb3c99744$var$barcodeStore;

});
parcelRegister("gwaiZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c067a0ecb4179e04$export$2e2bcd8739ae039; });

var $5BZwQ = parcelRequire("5BZwQ");

var $3Q0KW = parcelRequire("3Q0KW");

var $7wVIe = parcelRequire("7wVIe");

var $gyNqR = parcelRequire("gyNqR");

var $lL8TL = parcelRequire("lL8TL");
/** `Object#toString` result references. */ var $c067a0ecb4179e04$var$mapTag = '[object Map]', $c067a0ecb4179e04$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $c067a0ecb4179e04$var$size(collection) {
    if (collection == null) return 0;
    if ((0, $7wVIe.default)(collection)) return (0, $gyNqR.default)(collection) ? (0, $lL8TL.default)(collection) : collection.length;
    var tag = (0, $3Q0KW.default)(collection);
    if (tag == $c067a0ecb4179e04$var$mapTag || tag == $c067a0ecb4179e04$var$setTag) return collection.size;
    return (0, $5BZwQ.default)(collection).length;
}
var $c067a0ecb4179e04$export$2e2bcd8739ae039 = $c067a0ecb4179e04$var$size;

});


parcelRegister("jNvKP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $664ebde941014134$export$2e2bcd8739ae039; });

var $kOl9R = parcelRequire("kOl9R");
var $g7Ysb = parcelRequire("g7Ysb");

var $bEEBX = parcelRequire("bEEBX");

var $15TRa = parcelRequire("15TRa");

var $Kk7R3 = parcelRequire("Kk7R3");

var $eH0sC = parcelRequire("eH0sC");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $7mifc = parcelRequire("7mifc");

var $fZvaD = parcelRequire("fZvaD");

var $d9z1Y = parcelRequire("d9z1Y");
const $664ebde941014134$var$findProductInNewClaimBySku = (querySku)=>$664ebde941014134$var$claimsStore.newClaim.data.Products.find((product)=>product.ProductItemID === querySku);
const $664ebde941014134$var$getPayloadFromState = (state, orderNumber)=>{
    const formPayload = (0, $eH0sC.serialize)(state, {
        indices: true
    });
    formPayload.set("posttoken", (0, $8ZCSm.SOLIDUM_POSTTOKEN) ?? "Missing Post Token");
    formPayload.set("postform", (0, $8ZCSm.SOLIDUM_POSTFORM) ?? "Missing Post Form");
    if ((0, $bEEBX.default)(state.image)) formPayload.delete("image");
    formPayload.set("ordernumber", orderNumber);
    formPayload.set("customerNumber", (0, $bcbvQ.default).currentCompany ?? "");
    (0, $gtsdT.logger).log("claims", "Built payload for claims", Object.fromEntries(formPayload.entries()));
    return formPayload;
};
const $664ebde941014134$var$defaultStart = (0, $g7Ysb.default)(new Date(), -12);
const $664ebde941014134$var$defaultEnd = (0, $g7Ysb.default)(new Date(), 0);
const $664ebde941014134$var$initialNewClaim = ()=>({
        Products: [],
        sender: "",
        email: "",
        telephone: "",
        Notes: "",
        image: null
    });
const $664ebde941014134$var$claimsStore = (0, $Kk7R3.makeAutoObservable)({
    eligibleOrders: (0, $duLFK.initializeWithDefaultData)([]),
    claims: (0, $duLFK.initializeWithDefaultData)([]),
    newClaim: (0, $duLFK.initializeWithDefaultData)($664ebde941014134$var$initialNewClaim()),
    filters: {
        isUnderProcess: null,
        orderNumber: "",
        dateRange: {
            from: $664ebde941014134$var$defaultStart,
            to: $664ebde941014134$var$defaultEnd
        }
    },
    filterAsPickerDates: ()=>{
        const res = [
            $664ebde941014134$var$claimsStore.filters.dateRange.from,
            $664ebde941014134$var$claimsStore.filters.dateRange.to
        ];
        return res.filter((date)=>date !== null);
    },
    /**
    * Fetches orders for the last 4 days (and a few days into the future, just in case) and
    * filters out those marked with "canSendComplaint".
    */ clearNewClaim: ()=>{
        $664ebde941014134$var$claimsStore.newClaim = (0, $duLFK.initializeWithDefaultData)($664ebde941014134$var$initialNewClaim());
    },
    fetchEligibleOrders: async ()=>{
        const filtersNeeded = {
            orderNumber: "",
            orderName: "",
            status: "",
            dateRange: {
                from: (0, $kOl9R.default)(new Date(), -4),
                to: (0, $kOl9R.default)(new Date(), 30)
            }
        };
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if ((0, $bEEBX.default)(customerNumber)) return Promise.reject("Need to be logged in to fetch eligible orders for claims");
        (0, $duLFK.setAsWaitingForData)($664ebde941014134$var$claimsStore.eligibleOrders);
        try {
            const possibleOrders = await (0, $fZvaD.fetchOrderListFromM3)((0, $isIf6.default).m3CompanyNumber, customerNumber, filtersNeeded);
            const eligible = [];
            for (const candicateOrderDetails of possibleOrders)if ("canSendComplaint" in candicateOrderDetails && candicateOrderDetails.canSendComplaint && !candicateOrderDetails.isTemporaryOrder) {
                (0, $7mifc.default).fetchOrderDetails(candicateOrderDetails.orderNumber);
                eligible.push(candicateOrderDetails);
            }
            (0, $duLFK.setAsDataAvailable)($664ebde941014134$var$claimsStore.eligibleOrders, eligible);
        } catch (err) {
            (0, $duLFK.setAsErrorOccured)($664ebde941014134$var$claimsStore.eligibleOrders, `${err}`);
        }
    },
    fetchClaims: async ()=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        (0, $duLFK.setAsWaitingForData)($664ebde941014134$var$claimsStore.claims);
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/claims/list/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).get().json().then((res)=>{
            const claims = res.map((0, $d9z1Y.splitClaimResponseIntoClaims));
            (0, $duLFK.setAsDataAvailable)($664ebde941014134$var$claimsStore.claims, claims);
        }).catch((errorObj)=>{
            (0, $duLFK.setAsErrorOccured)($664ebde941014134$var$claimsStore.claims, `${errorObj}`);
        });
    },
    submitClaim: async (orderNumber, values)=>{
        (0, $duLFK.setAsWaitingForData)($664ebde941014134$var$claimsStore.newClaim);
        const updatedClaimData = {
            Products: $664ebde941014134$var$claimsStore.newClaim.data.Products,
            sender: values.sender,
            email: values.email,
            telephone: values.telephone,
            Notes: values.Notes,
            image: values.image
        };
        const formPayload = $664ebde941014134$var$getPayloadFromState(updatedClaimData, orderNumber);
        // Copies data from store and adds required fields for order number and customer number
        (0, $gtsdT.logger).log("claims", `Sending claim for order number ${orderNumber}`, formPayload);
        try {
            const response = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/claims/file`, (0, $bcbvQ.default).getSessionToken()).body(formPayload).post().res();
            const data = await response.json();
            $664ebde941014134$var$claimsStore.clearNewClaim();
            return data?.solidumpost?.postId;
        } catch (_error) {
            const message = "Vi greier ikke \xe5 sende inn reklamasjonen din.";
            (0, $duLFK.setAsErrorOccured)($664ebde941014134$var$claimsStore.newClaim, message);
            return undefined;
        }
    },
    getCauses: ()=>[
            {
                code: "R01",
                label: "Kort holdbarhetsdato"
            },
            {
                code: "R02",
                label: "Kvalitetsfeil"
            },
            {
                code: "R04",
                label: "Transportskade"
            },
            {
                code: "R06",
                label: "For f\xe5 produkter levert"
            },
            {
                code: "R07",
                label: "Feil produkt levert"
            },
            {
                code: "U08",
                label: "Feil produkt bestilt"
            }
        ],
    updateProductCause: (querySku, code)=>{
        const existingProduct = $664ebde941014134$var$findProductInNewClaimBySku(querySku);
        if (!(0, $bEEBX.default)(existingProduct)) {
            existingProduct.Cause = code;
            switch(code){
                case "R01":
                    existingProduct.BestBeforeDate = existingProduct.BestBeforeDate ?? "";
                    existingProduct.ProductionNumber = undefined;
                    break;
                case "R02":
                    existingProduct.BestBeforeDate = existingProduct.BestBeforeDate ?? "";
                    existingProduct.ProductionNumber = existingProduct.ProductionNumber ?? "";
                    break;
                default:
                    existingProduct.BestBeforeDate = undefined;
                    existingProduct.ProductionNumber = undefined;
            }
        }
    },
    updateProductBestBeforeDate: (querySku, bestBefore)=>{
        const existingProduct = $664ebde941014134$var$findProductInNewClaimBySku(querySku);
        if (!(0, $bEEBX.default)(existingProduct)) existingProduct.BestBeforeDate = bestBefore;
    },
    updateProductProductionNumber: (querySku, productionNumber)=>{
        const existingProduct = $664ebde941014134$var$findProductInNewClaimBySku(querySku);
        if (!(0, $bEEBX.default)(existingProduct)) existingProduct.ProductionNumber = productionNumber;
    },
    updateProductQuantity: (querySku, amount)=>{
        const existingProduct = $664ebde941014134$var$findProductInNewClaimBySku(querySku);
        if (!(0, $bEEBX.default)(existingProduct)) existingProduct.ProductQuantity = amount;
    },
    addNewClaimProduct: (product, quantity, causeCode)=>{
        $664ebde941014134$var$claimsStore.newClaim.data.Products.push({
            ProductItemID: product.sku,
            ProductItemName: product.name,
            Cause: causeCode,
            ProductQuantity: quantity
        });
        $664ebde941014134$var$claimsStore.updateProductCause(product.sku, causeCode);
    },
    removeNewClaimProduct: (product)=>{
        (0, $15TRa.default)($664ebde941014134$var$claimsStore.newClaim.data.Products, {
            ProductItemID: product.sku
        });
    },
    clearCompanySpecificData: ()=>{
        $664ebde941014134$var$claimsStore.claims = (0, $duLFK.initializeWithDefaultData)([]);
        $664ebde941014134$var$claimsStore.eligibleOrders = (0, $duLFK.initializeWithDefaultData)([]);
        $664ebde941014134$var$claimsStore.newClaim = (0, $duLFK.initializeWithDefaultData)($664ebde941014134$var$initialNewClaim());
    }
});
var $664ebde941014134$export$2e2bcd8739ae039 = $664ebde941014134$var$claimsStore;

});
parcelRegister("eH0sC", function(module, exports) {
function $ab257048989940ce$var$isUndefined(value) {
    return value === undefined;
}
function $ab257048989940ce$var$isNull(value) {
    return value === null;
}
function $ab257048989940ce$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $ab257048989940ce$var$isObject(value) {
    return value === Object(value);
}
function $ab257048989940ce$var$isArray(value) {
    return Array.isArray(value);
}
function $ab257048989940ce$var$isDate(value) {
    return value instanceof Date;
}
function $ab257048989940ce$var$isBlob(value, isReactNative) {
    return isReactNative ? $ab257048989940ce$var$isObject(value) && !$ab257048989940ce$var$isUndefined(value.uri) : $ab257048989940ce$var$isObject(value) && typeof value.size === 'number' && typeof value.type === 'string' && typeof value.slice === 'function';
}
function $ab257048989940ce$var$isFile(value, isReactNative) {
    return $ab257048989940ce$var$isBlob(value, isReactNative) && typeof value.name === 'string' && ($ab257048989940ce$var$isObject(value.lastModifiedDate) || typeof value.lastModified === 'number');
}
function $ab257048989940ce$var$initCfg(value) {
    return $ab257048989940ce$var$isUndefined(value) ? false : value;
}
function $ab257048989940ce$var$serialize(obj, cfg, fd, pre) {
    cfg = cfg || {};
    fd = fd || new FormData();
    cfg.indices = $ab257048989940ce$var$initCfg(cfg.indices);
    cfg.nullsAsUndefineds = $ab257048989940ce$var$initCfg(cfg.nullsAsUndefineds);
    cfg.booleansAsIntegers = $ab257048989940ce$var$initCfg(cfg.booleansAsIntegers);
    cfg.allowEmptyArrays = $ab257048989940ce$var$initCfg(cfg.allowEmptyArrays);
    cfg.noAttributesWithArrayNotation = $ab257048989940ce$var$initCfg(cfg.noAttributesWithArrayNotation);
    cfg.noFilesWithArrayNotation = $ab257048989940ce$var$initCfg(cfg.noFilesWithArrayNotation);
    cfg.dotsForObjectNotation = $ab257048989940ce$var$initCfg(cfg.dotsForObjectNotation);
    const isReactNative = typeof fd.getParts === 'function';
    if ($ab257048989940ce$var$isUndefined(obj)) return fd;
    else if ($ab257048989940ce$var$isNull(obj)) {
        if (!cfg.nullsAsUndefineds) fd.append(pre, '');
    } else if ($ab257048989940ce$var$isBoolean(obj)) {
        if (cfg.booleansAsIntegers) fd.append(pre, obj ? 1 : 0);
        else fd.append(pre, obj);
    } else if ($ab257048989940ce$var$isArray(obj)) {
        if (obj.length) obj.forEach((value, index)=>{
            let key = pre + '[' + (cfg.indices ? index : '') + ']';
            if (cfg.noAttributesWithArrayNotation || cfg.noFilesWithArrayNotation && $ab257048989940ce$var$isFile(value, isReactNative)) key = pre;
            $ab257048989940ce$var$serialize(value, cfg, fd, key);
        });
        else if (cfg.allowEmptyArrays) fd.append(cfg.noAttributesWithArrayNotation ? pre : pre + '[]', '');
    } else if ($ab257048989940ce$var$isDate(obj)) fd.append(pre, obj.toISOString());
    else if ($ab257048989940ce$var$isObject(obj) && !$ab257048989940ce$var$isBlob(obj, isReactNative)) Object.keys(obj).forEach((prop)=>{
        const value = obj[prop];
        if ($ab257048989940ce$var$isArray(value)) while(prop.length > 2 && prop.lastIndexOf('[]') === prop.length - 2)prop = prop.substring(0, prop.length - 2);
        const key = pre ? cfg.dotsForObjectNotation ? pre + '.' + prop : pre + '[' + prop + ']' : prop;
        $ab257048989940ce$var$serialize(value, cfg, fd, key);
    });
    else fd.append(pre, obj);
    return fd;
}
module.exports = {
    serialize: $ab257048989940ce$var$serialize
};

});

parcelRegister("7mifc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16f1db7cbac7355c$export$2e2bcd8739ae039; });

var $bIbDp = parcelRequire("bIbDp");
var $g7Ysb = parcelRequire("g7Ysb");
var $hOtDP = parcelRequire("hOtDP");

var $2cUIA = parcelRequire("2cUIA");

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $bYgbs = parcelRequire("bYgbs");

var $6fuyt = parcelRequire("6fuyt");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $f2Bp8 = parcelRequire("f2Bp8");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $jnFMu = parcelRequire("jnFMu");

var $8Wejn = parcelRequire("8Wejn");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");

var $bZiDo = parcelRequire("bZiDo");

var $i6TQx = parcelRequire("i6TQx");

var $gvoND = parcelRequire("gvoND");

var $aBDYY = parcelRequire("aBDYY");

var $fZvaD = parcelRequire("fZvaD");
const $16f1db7cbac7355c$var$defaultStart = (0, $g7Ysb.default)(new Date(), -1);
const $16f1db7cbac7355c$var$defaultEnd = (0, $g7Ysb.default)(new Date(), 3);
const $16f1db7cbac7355c$var$INITIAL_FILTER_VALUES = {
    orderNumber: "",
    orderName: "",
    dateRange: {
        from: $16f1db7cbac7355c$var$defaultStart,
        to: $16f1db7cbac7355c$var$defaultEnd
    },
    status: ""
};
const $16f1db7cbac7355c$var$orderStore = (0, $Kk7R3.makeAutoObservable)({
    orderDetails: {},
    orderList: (0, $duLFK.initializeWithDefaultData)([]),
    filters: $16f1db7cbac7355c$var$INITIAL_FILTER_VALUES,
    deliveryNotesInfo: undefined,
    filterAsPickerDates: ()=>{
        const res = [
            $16f1db7cbac7355c$var$orderStore.filters.dateRange.from,
            $16f1db7cbac7355c$var$orderStore.filters.dateRange.to
        ];
        return res.filter((date)=>date !== null);
    },
    updateStatusFilter: (option)=>{
        $16f1db7cbac7355c$var$orderStore.filters.status = option.value;
    },
    updateDateFilter: (dates)=>{
        $16f1db7cbac7355c$var$orderStore.filters.dateRange.from = dates[0];
        if (dates.length === 2) $16f1db7cbac7355c$var$orderStore.filters.dateRange.to = dates[1];
        else $16f1db7cbac7355c$var$orderStore.filters.dateRange.to = null;
    },
    updateDeliveryNotesInfo: async (orderNumber)=>{
        const currentCompany = (0, $bcbvQ.default).currentCompany;
        if (currentCompany && (0, $bcbvQ.default).isLoggedIn()) try {
            const deliveryNotesInfo = await (0, $fZvaD.fetchDeliveryNotes)(orderNumber, currentCompany, (0, $isIf6.default).m3CompanyNumber, (0, $isIf6.default).m3DivisionNumber);
            if (deliveryNotesInfo?.deliveryNotes.length) $16f1db7cbac7355c$var$orderStore.deliveryNotesInfo = deliveryNotesInfo;
            else $16f1db7cbac7355c$var$orderStore.deliveryNotesInfo = undefined;
        } catch (_error) {
            $16f1db7cbac7355c$var$orderStore.deliveryNotesInfo = undefined;
        }
    },
    ensureOrderDetailsKeyAvailable: (orderNumber)=>{
        if (!(orderNumber in $16f1db7cbac7355c$var$orderStore.orderDetails) || (0, $bEEBX.default)($16f1db7cbac7355c$var$orderStore.orderDetails[orderNumber])) $16f1db7cbac7355c$var$orderStore.orderDetails[orderNumber] = (0, $duLFK.initializeWithDefaultData)(null);
    },
    getOrderDetails: (orderNumber)=>{
        $16f1db7cbac7355c$var$orderStore.ensureOrderDetailsKeyAvailable(orderNumber);
        return $16f1db7cbac7355c$var$orderStore.orderDetails[orderNumber];
    },
    fetchOrderDetails: async (orderNumber)=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)(orderNumber) || (0, $bEEBX.default)(customerNumber)) {
            (0, $gtsdT.logger).warn("order", "Order Details before logged in: ", orderNumber);
            return;
        }
        $16f1db7cbac7355c$var$orderStore.ensureOrderDetailsKeyAvailable(orderNumber);
        const orderEntry = $16f1db7cbac7355c$var$orderStore.orderDetails[orderNumber];
        (0, $duLFK.setAsWaitingForData)(orderEntry);
        try {
            const fetchedOrderDetails = await (0, $fZvaD.fetchOrderDetailsFromM3)((0, $isIf6.default).m3CompanyNumber, customerNumber, orderNumber);
            if ("orderNumber" in fetchedOrderDetails) {
                const commentObject = (0, $aBDYY.convertOrderCommentStringToObject)(fetchedOrderDetails.orderComment);
                const orderDetails = {
                    ...fetchedOrderDetails
                };
                (0, $2cUIA.default)(orderDetails.optimizedOrderLines, (orderLine)=>{
                    if (commentObject[orderLine.sku]) orderLine.appliedPromotionInformation = commentObject[orderLine.sku];
                });
                (0, $duLFK.setAsDataAvailable)(orderEntry, orderDetails);
            } else if ("Error_Code" in fetchedOrderDetails) {
                (0, $gtsdT.logger).warn("order", "An error occured while fetching order: ", fetchedOrderDetails.Error_Code);
                (0, $duLFK.setAsErrorOccured)(orderEntry, fetchedOrderDetails.Response);
            }
        } catch (err) {
            (0, $gtsdT.logger).warn("order", "An error occured while fetching order: ", err);
            (0, $duLFK.setAsErrorOccured)(orderEntry, `${err}`);
        }
    },
    deleteOrder: async (orderNumber)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)(orderNumber)) {
            (0, $gtsdT.logger).warn("order", "Unable to delete order, order number is missing");
            return;
        }
        return (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("orders")}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/customerOrder`, (0, $bcbvQ.default).getSessionToken()).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            orderNumber: orderNumber,
            typeOfOrder: "K"
        }).delete().json((res)=>{
            if (res.status !== true) throw res.Error_Code;
            $16f1db7cbac7355c$var$orderStore.fetchOrderDetails(orderNumber);
        });
    },
    updateOrderListUsingFilters: async ()=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)(customerNumber)) {
            (0, $gtsdT.logger).log("order", "Searching before logged in");
            return;
        }
        (0, $gtsdT.logger).log("order", `Fetching orders for customer ${customerNumber}`);
        (0, $duLFK.setAsWaitingForData)($16f1db7cbac7355c$var$orderStore.orderList);
        try {
            const orders = await (0, $fZvaD.fetchOrderListFromM3)((0, $isIf6.default).m3CompanyNumber, customerNumber, $16f1db7cbac7355c$var$orderStore.filters);
            (0, $gtsdT.logger).log("order", "fetchOrderListWithFilters: ", orders);
            (0, $duLFK.setAsDataAvailable)($16f1db7cbac7355c$var$orderStore.orderList, orders);
        } catch (err) {
            (0, $duLFK.setAsErrorOccured)($16f1db7cbac7355c$var$orderStore.orderList, `${err}`);
        }
    },
    submitNewOrder: async ()=>{
        (0, $76PCP.default).sendingOrder = true;
        let response;
        try {
            const allAvailable = await (0, $8Wejn.default).checkAvailability();
            if (!allAvailable) {
                (0, $gtsdT.logger).log("order", "Aborting order placement to resolve availability issues");
                (0, $76PCP.default).sendingOrder = false;
                throw new (0, $aMYzM.AvailabilityError)();
            }
            const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
            if ((0, $bEEBX.default)(currentDelivery)) throw new (0, $aMYzM.BackendIssueError)("Delivery day not available");
            const orderLines = [
                ...(0, $76PCP.default).items.map((i)=>({
                        sku: i.sku,
                        quantity: i.qty,
                        orderLineUnit: i.unit,
                        price: (0, $bZiDo.default).resolveSku(i.sku)?.price
                    })),
                ...(0, $76PCP.default).lostSales
            ];
            const promotionIds = (0, $i6TQx.default).availablePromotions.data.map((p)=>p.id);
            const cartId = (0, $f2Bp8.getCartIdFromStorage)();
            (0, $f2Bp8.setCartIdInStorage)(cartId);
            const order = {
                companyNumber: (0, $isIf6.default).m3CompanyNumber,
                customerNumber: (0, $bcbvQ.default).currentCompany || "",
                orderType: (0, $76PCP.default).orderType,
                customerWarehouse: (0, $jnFMu.getWarehouseId)((0, $bcbvQ.default).getCurrentCompany()),
                requestedDeliveryDate: (0, $4udGV.formatISODate)(currentDelivery.date),
                estimatedOrderAmount: 2500,
                promotionIds: promotionIds,
                ...(0, $76PCP.default).orderRefs,
                orderLines: orderLines,
                cartId: cartId
            };
            (0, $gtsdT.logger).log("order", "Starting order placement...");
            response = await (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("orders")}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/customerOrder`, (0, $bcbvQ.default).getSessionToken()).query({
                optimizeOrderLines: true
            }).content("application/json").post(order).json();
            (0, $6fuyt.sendPurchase)(response.map((o)=>o.orderNumber), [
                ...(0, $76PCP.default).items
            ], false);
            if ((0, $76PCP.default).editing) {
                const { orderNumber: orderNumber } = (0, $76PCP.default).editing;
                if (orderNumber && orderNumber !== response[0].orderNumber) {
                    (0, $76PCP.default).orderRefs.replacesOrderNumber = orderNumber;
                    await $16f1db7cbac7355c$var$orderStore.deleteOrder(orderNumber);
                }
            }
            (0, $76PCP.default).lostSales = [];
            (0, $gtsdT.logger).log("order", "Order submit response:", response);
        } catch (err) {
            if (!(err instanceof (0, $aMYzM.AvailabilityError))) (0, $gtsdT.logger).warn("order", "An unexpected error occured during availability check", err);
            throw err;
        } finally{
            (0, $76PCP.default).sendingOrder = false;
        }
        (0, $76PCP.default).emptyCart();
        (0, $9Vhxl.default).selectNextDeliveryDateForOrderType((0, $76PCP.default).orderType);
        (0, $f2Bp8.setCartIdInStorage)(null);
        return response.map((o)=>o.orderNumber);
    },
    submitOrderChanges: async ()=>{
        if ((0, $bEEBX.default)((0, $76PCP.default).editing) || (0, $bEEBX.default)((0, $76PCP.default).editing.orderNumber)) {
            (0, $gtsdT.logger).warn("order", "Cannot send order change when editing is nil");
            (0, $gvoND.default).addError("Uforutsett feil oppsto", "Vi greier ikke \xe5 sende inn ordren din.", {
                context: "order",
                text: "change_order_edit_mode_error"
            });
            return Promise.reject();
        }
        (0, $76PCP.default).sendingOrder = true;
        const allAvailable = await (0, $8Wejn.default).checkAvailability();
        if (!allAvailable) {
            (0, $gtsdT.logger).log("order", "Aborting order placement to resolve availability issues");
            (0, $76PCP.default).sendingOrder = false;
            throw new (0, $aMYzM.AvailabilityError)();
        }
        if ((0, $76PCP.default).isDeliveryDateChanged()) {
            const result = await $16f1db7cbac7355c$var$orderStore.submitNewOrder();
            (0, $76PCP.default).stopEditOrderMode();
            return result;
        }
        const payload = (0, $76PCP.default).generateChangeOrderPayload();
        if (payload === null) {
            (0, $76PCP.default).sendingOrder = false;
            return [
                (0, $76PCP.default).editing.orderNumber
            ];
        }
        let response;
        try {
            response = await (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("orders")}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/customerOrder`, (0, $bcbvQ.default).getSessionToken()).query({
                optimizeOrderLines: true
            }).content("application/json").put(payload).json();
            (0, $76PCP.default).lostSales = [];
            // Remove the cached order details so we are able to see the changes load in on the confirmation page
            delete $16f1db7cbac7355c$var$orderStore.orderDetails[(0, $76PCP.default).editing.orderNumber];
            (0, $76PCP.default).stopEditOrderMode();
            (0, $6fuyt.sendPurchase)(response.map((o)=>o.orderNumber), [
                ...(0, $76PCP.default).items
            ], true);
        } catch (err) {
            (0, $gtsdT.logger).warn("order", "An error occured during order update", err);
            throw err;
        } finally{
            (0, $76PCP.default).sendingOrder = false;
        }
        return response.map((o)=>o.orderNumber);
    },
    getPredefinedIntervals: ()=>{
        const now = new Date();
        const oneMonthLater = (0, $bIbDp.default)(now, {
            months: 1
        });
        return [
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        months: 1
                    }),
                    oneMonthLater
                ],
                text: "Siste m\xe5neden"
            },
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        months: 3
                    }),
                    oneMonthLater
                ],
                text: "Siste tre m\xe5neder"
            },
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        months: 6
                    }),
                    oneMonthLater
                ],
                text: "Siste halv\xe5ret"
            },
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        years: 1
                    }),
                    oneMonthLater
                ],
                text: "Siste \xe5ret"
            }
        ];
    },
    clearCompanySpecificData: ()=>{
        // add methods to clear company specific data
        $16f1db7cbac7355c$var$orderStore.orderList = (0, $duLFK.initializeWithDefaultData)([]);
        $16f1db7cbac7355c$var$orderStore.orderDetails = {};
        $16f1db7cbac7355c$var$orderStore.filters = $16f1db7cbac7355c$var$INITIAL_FILTER_VALUES;
        $16f1db7cbac7355c$var$orderStore.deliveryNotesInfo = undefined;
    }
});
var $16f1db7cbac7355c$export$2e2bcd8739ae039 = $16f1db7cbac7355c$var$orderStore;

});
parcelRegister("bIbDp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $886cd4283be3bc57$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");

var $kOl9R = parcelRequire("kOl9R");

var $g7Ysb = parcelRequire("g7Ysb");

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");
function $886cd4283be3bc57$export$2e2bcd8739ae039(dirtyDate, duration) {
    (0, $hFacL.default)(2, arguments);
    if (!duration || (0, $5PKFW.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, $970db.default)(duration.years) : 0;
    var months = duration.months ? (0, $970db.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $970db.default)(duration.weeks) : 0;
    var days = duration.days ? (0, $970db.default)(duration.days) : 0;
    var hours = duration.hours ? (0, $970db.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $970db.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $970db.default)(duration.seconds) : 0;
    // Add years and months
    var date = (0, $8pX4r.default)(dirtyDate);
    var dateWithMonths = months || years ? (0, $g7Ysb.default)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, $kOl9R.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}

});

parcelRegister("hOtDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf7e195c5df7a509$export$2e2bcd8739ae039; });

var $5PKFW = parcelRequire("5PKFW");

var $fE1mA = parcelRequire("fE1mA");

var $cm5GY = parcelRequire("cm5GY");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");
function $cf7e195c5df7a509$export$2e2bcd8739ae039(date, duration) {
    (0, $hFacL.default)(2, arguments);
    if (!duration || (0, $5PKFW.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, $970db.default)(duration.years) : 0;
    var months = duration.months ? (0, $970db.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $970db.default)(duration.weeks) : 0;
    var days = duration.days ? (0, $970db.default)(duration.days) : 0;
    var hours = duration.hours ? (0, $970db.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $970db.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $970db.default)(duration.seconds) : 0;
    // Subtract years and months
    var dateWithoutMonths = (0, $cm5GY.default)(date, months + years * 12);
    // Subtract weeks and days
    var dateWithoutDays = (0, $fE1mA.default)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

});
parcelRegister("fE1mA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b63ba62fd5d31123$export$2e2bcd8739ae039; });

var $kOl9R = parcelRequire("kOl9R");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");
function $b63ba62fd5d31123$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var amount = (0, $970db.default)(dirtyAmount);
    return (0, $kOl9R.default)(dirtyDate, -amount);
}

});

parcelRegister("cm5GY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8febf46dd6562f51$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $g7Ysb = parcelRequire("g7Ysb");

var $hFacL = parcelRequire("hFacL");
function $8febf46dd6562f51$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var amount = (0, $970db.default)(dirtyAmount);
    return (0, $g7Ysb.default)(dirtyDate, -amount);
}

});


parcelRegister("2cUIA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19b8b2c79597a36f$export$2e2bcd8739ae039; });

var $fo4tZ = parcelRequire("fo4tZ");

var $7xRth = parcelRequire("7xRth");

var $hwTha = parcelRequire("hwTha");

var $hCd6c = parcelRequire("hCd6c");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $19b8b2c79597a36f$var$forEach(collection, iteratee) {
    var func = (0, $hCd6c.default)(collection) ? (0, $fo4tZ.default) : (0, $7xRth.default);
    return func(collection, (0, $hwTha.default)(iteratee));
}
var $19b8b2c79597a36f$export$2e2bcd8739ae039 = $19b8b2c79597a36f$var$forEach;

});
parcelRegister("hwTha", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc304d74296513e5$export$2e2bcd8739ae039; });

var $jHP7K = parcelRequire("jHP7K");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $cc304d74296513e5$var$castFunction(value) {
    return typeof value == 'function' ? value : (0, $jHP7K.default);
}
var $cc304d74296513e5$export$2e2bcd8739ae039 = $cc304d74296513e5$var$castFunction;

});


parcelRegister("jnFMu", function(module, exports) {

$parcel$export(module.exports, "enhanceCompany", function () { return $e83854159d7cd853$export$9be36256bd477a5e; });
$parcel$export(module.exports, "getWarehouseId", function () { return $e83854159d7cd853$export$452d88c1e6b7f0a9; });

var $bEEBX = parcelRequire("bEEBX");

var $fj1oy = parcelRequire("fj1oy");
const $e83854159d7cd853$export$9be36256bd477a5e = (company)=>{
    return {
        ...company,
        chains: $e83854159d7cd853$var$businessLevelsToChains(company.businessLevels || {})
    };
};
const $e83854159d7cd853$var$chainLevels = [
    "level1",
    "level2",
    "level3",
    "level4"
];
const $e83854159d7cd853$var$businessLevelsToChains = (levels)=>{
    const chains = [];
    for (const chainLevel of $e83854159d7cd853$var$chainLevels)if (levels[chainLevel]) {
        const chain = $e83854159d7cd853$var$businessLevelToChain(levels[chainLevel], chainLevel);
        if (chain) chains.push(chain);
    }
    return chains;
};
const $e83854159d7cd853$var$businessLevelToChain = (businessLevel, level)=>{
    const [id, name] = businessLevel.split("|");
    if (id && name) return {
        level: level,
        id: id,
        name: name.replace(/\s+NIVÅ\s+\d+$/i, "")
    };
};
const $e83854159d7cd853$export$452d88c1e6b7f0a9 = (company)=>{
    if ((0, $bEEBX.default)(company) || (0, $bEEBX.default)(company.warehouse)) return "";
    return (0, $fj1oy.keepIdOnly)(company.warehouse);
};

});

parcelRegister("i6TQx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $123585b1174e4865$export$2e2bcd8739ae039; });

var $izjX7 = parcelRequire("izjX7");

var $d4mYJ = parcelRequire("d4mYJ");

var $5LjUB = parcelRequire("5LjUB");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $8aSS4 = parcelRequire("8aSS4");

var $duLFK = parcelRequire("duLFK");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $gvoND = parcelRequire("gvoND");
const $123585b1174e4865$var$promotionStore = (0, $Kk7R3.makeAutoObservable)({
    availablePromotions: (0, $duLFK.initializeWithDefaultData)([]),
    promotionDiscounts: (0, $duLFK.initializeWithDefaultData)([]),
    signUps: (0, $duLFK.initializeWithDefaultData)([]),
    isOrderTypeWithPromotions: ()=>{
        return (0, $76PCP.default).orderType === (0, $isIf6.default).defaultOrderType || (0, $76PCP.default).orderType === (0, $8aSS4.ORDERTYPE).HPN;
    },
    fetchAvailablePromotions: async ()=>{
        if (!(0, $biFcX.default).voucherifyAvailable || !$123585b1174e4865$var$promotionStore.isOrderTypeWithPromotions()) return;
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if (!customerNumber) {
            (0, $gtsdT.logger).warn("promotions", "Unable to fetch promotions when you are not logged in");
            return;
        }
        (0, $gtsdT.logger).log("promotions", `Fetching available promotions for ${(0, $bcbvQ.default).currentCompany}`);
        const abortController = (0, $duLFK.setAsWaitingForData)($123585b1174e4865$var$promotionStore.availablePromotions);
        try {
            const promotionsUrl = `${(0, $8ZCSm.API_HOST)}/api/discount/${(0, $isIf6.default).storeId}/${customerNumber}/availablePromotions`;
            const promotions = await (0, $3Y1Wx.apiClient)(promotionsUrl, (0, $bcbvQ.default).getSessionToken()).signal(abortController).get().json();
            (0, $gtsdT.logger).log("promotions", "Promotions available: ", promotions);
            (0, $duLFK.setAsDataAvailable)($123585b1174e4865$var$promotionStore.availablePromotions, promotions);
        } catch (returnObj) {
            const error = (0, $aMYzM.ensureError)(returnObj);
            (0, $gtsdT.logger).warn("promotions", "An error occured while fetching available promotions", error.message);
            (0, $duLFK.setAsErrorOccured)($123585b1174e4865$var$promotionStore.availablePromotions, error.message);
        }
    },
    getPromotionsBySku: (sku)=>{
        const promotionsApplicableToSku = $123585b1174e4865$var$promotionStore.availablePromotions.data.filter((promotion)=>promotion.products.includes(sku));
        if ((0, $izjX7.isEmptyArray)(promotionsApplicableToSku)) return [];
        const promotionDiscounts = $123585b1174e4865$var$promotionStore.promotionDiscounts.data;
        return promotionDiscounts.flatMap((promotionDiscount)=>{
            const availablePromotion = promotionsApplicableToSku.find((promotion)=>promotion.id === promotionDiscount.id);
            return availablePromotion ? [
                {
                    id: availablePromotion.id,
                    banner: availablePromotion.banner,
                    applicable: promotionDiscount.applicable,
                    inapplicableReason: promotionDiscount.inapplicableReason
                }
            ] : [];
        });
    },
    getPromotionBannerById: (promotionId)=>{
        return $123585b1174e4865$var$promotionStore.availablePromotions.data.find((promotion)=>promotion.id === promotionId)?.banner;
    },
    cartToVoucherifyItems: ()=>{
        const cart = (0, $76PCP.default).items;
        return cart.map((item)=>{
            const product = (0, $bZiDo.default).resolveSku(item.sku);
            return {
                sku: item.sku,
                qty: item.qty,
                price: product?.price ?? 0
            };
        });
    },
    fetchPromotionDiscountsWithoutDelay: async ()=>{
        if (!(0, $biFcX.default).voucherifyAvailable || !$123585b1174e4865$var$promotionStore.isOrderTypeWithPromotions() || $123585b1174e4865$var$promotionStore.availablePromotions.data.length === 0) return;
        const abortController = (0, $duLFK.setAsWaitingForData)($123585b1174e4865$var$promotionStore.promotionDiscounts);
        if ($123585b1174e4865$var$promotionStore.availablePromotions.data.length === 0) {
            (0, $gtsdT.logger).log("promotions", "No need to check discounts when there are no available promotions, aborting...");
            (0, $duLFK.setAsDataAvailable)($123585b1174e4865$var$promotionStore.promotionDiscounts, []);
            return;
        }
        const promotionDiscountsUrl = `${(0, $8ZCSm.API_HOST)}/api/discount/${(0, $isIf6.default).storeId}/${(0, $bcbvQ.default).currentCompany}/promotionDiscounts`;
        try {
            const promotionIds = $123585b1174e4865$var$promotionStore.availablePromotions.data.map((promotion)=>promotion.id);
            const promotionDiscounts = await (0, $3Y1Wx.apiClient)(promotionDiscountsUrl, (0, $bcbvQ.default).getSessionToken()).signal(abortController).post({
                items: $123585b1174e4865$var$promotionStore.cartToVoucherifyItems(),
                promotionIds: promotionIds
            }).json();
            (0, $gtsdT.logger).log("promotions", "Discounts: ", promotionDiscounts);
            (0, $duLFK.setAsDataAvailable)($123585b1174e4865$var$promotionStore.promotionDiscounts, promotionDiscounts);
        } catch (errorObj) {
            const error = (0, $aMYzM.ensureError)(errorObj);
            (0, $gtsdT.logger).warn("promotions", "An error occured while fetching promotion discounts", error.message);
            (0, $duLFK.setAsErrorOccured)($123585b1174e4865$var$promotionStore.promotionDiscounts, error.message);
        }
    },
    fetchPromotionDiscounts: (0, $d4mYJ.default)(()=>{
        $123585b1174e4865$var$promotionStore.fetchPromotionDiscountsWithoutDelay();
    }, 500),
    hasPromotionDiscount: (sku)=>{
        for (const promotion of $123585b1174e4865$var$promotionStore.promotionDiscounts.data){
            if (!promotion.applicable) continue;
            if (promotion.items.some((item)=>item.sku === sku)) return true;
        }
        return false;
    },
    getPromotionDiscount: (sku)=>{
        let discountAmount = 0;
        for (const promotion of $123585b1174e4865$var$promotionStore.promotionDiscounts.data){
            if (!promotion.applicable) continue;
            const discountInCurrentPromotion = promotion.items.find((item)=>item.sku === sku);
            if (discountInCurrentPromotion) discountAmount += discountInCurrentPromotion.discount;
        }
        return discountAmount;
    },
    getTotalPromotionDiscount: (promotionId)=>{
        const promotion = $123585b1174e4865$var$promotionStore.promotionDiscounts.data.find((promotion)=>promotion.id === promotionId);
        const discountForItems = promotion?.items.reduce((acc, item)=>acc + item.discount, 0) ?? 0;
        return discountForItems + (promotion?.orderLevelDiscount ?? 0);
    },
    getTotalPromotionDiscountForCart: ()=>{
        let totalDiscount = 0;
        for (const promotion of $123585b1174e4865$var$promotionStore.promotionDiscounts.data)totalDiscount += $123585b1174e4865$var$promotionStore.getTotalPromotionDiscount(promotion.id);
        return totalDiscount;
    },
    fetchSignUps: async ()=>{
        if ((0, $bcbvQ.default).currentCompany === null) {
            (0, $gtsdT.logger).warn("promotions", "Unable to fetch signups when you are not logged in");
            return;
        }
        const abortController = (0, $duLFK.setAsWaitingForData)($123585b1174e4865$var$promotionStore.signUps);
        const url = `${(0, $8ZCSm.API_HOST)}/api/discount/${(0, $isIf6.default).storeId}/${(0, $bcbvQ.default).currentCompany}/signup`;
        return (0, $3Y1Wx.apiClient)(url, (0, $bcbvQ.default).getSessionToken()).signal(abortController).get().json((signUps)=>{
            (0, $gtsdT.logger).log("promotions", "Signed up to: ", signUps);
            (0, $duLFK.setAsDataAvailable)($123585b1174e4865$var$promotionStore.signUps, signUps);
        }).catch((errObj)=>{
            const error = (0, $aMYzM.ensureError)(errObj);
            if (error instanceof DOMException && error.name === "AbortError") (0, $gtsdT.logger).log("promotions", "Aborted fetch of signups");
            else {
                (0, $gtsdT.logger).warn("promotions", "An error occured while fetching signups", error);
                (0, $duLFK.setAsErrorOccured)($123585b1174e4865$var$promotionStore.signUps, error.message);
            }
        });
    },
    isSignedUpTo: (promotionId)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bcbvQ.default).currentCompany === null) return false;
        return $123585b1174e4865$var$promotionStore.signUps.data.some((signUp)=>promotionId === signUp.signUpCode);
    },
    signUpToPromotion: async (promotionId, voucherifyEventName, dynamicsEventId, additionalData)=>{
        if ((0, $bcbvQ.default).currentCompany === null) {
            (0, $gtsdT.logger).warn("promotions", "Unable to sign up for promotions when you are not logged in");
            return;
        }
        const signUpApiUrl = `${(0, $8ZCSm.API_HOST)}/api/discount/${(0, $isIf6.default).storeId}/${(0, $bcbvQ.default).currentCompany}/signup/${promotionId}`;
        try {
            await (0, $3Y1Wx.apiClient)(signUpApiUrl, (0, $bcbvQ.default).getSessionToken()).post(additionalData).text();
        } catch (errObj) {
            const error = (0, $aMYzM.ensureError)(errObj);
            (0, $gtsdT.logger).warn("promotions", "An error occured while signing up for promotion", error.message);
            (0, $gvoND.default).addError("En uventet feil oppsto", "Vi greide ikke \xe5 melde deg p\xe5 kampanjen.", {
                context: "promotions",
                text: "promotion_signup_error"
            });
            return;
        }
        // Update local version of signups
        $123585b1174e4865$var$promotionStore.fetchSignUps();
        if (!(0, $5LjUB.default)(voucherifyEventName)) await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/discount/${(0, $isIf6.default).storeId}/${(0, $bcbvQ.default).currentCompany}/event`, (0, $bcbvQ.default).getSessionToken()).query({
            eventName: voucherifyEventName
        }).post().json();
        if (!(0, $5LjUB.default)(dynamicsEventId) && window.msdynmkt && (0, $8ZCSm.DYNAMICS_INGESTION_KEY)) {
            window.msdynmkt.setUser({
                authId: (0, $bcbvQ.default).currentCompany
            });
            window.msdynmkt.trackEvent({
                name: dynamicsEventId,
                ingestionKey: (0, $8ZCSm.DYNAMICS_INGESTION_KEY),
                version: "1.0.0"
            });
        }
    },
    clearDiscounts: ()=>{
        $123585b1174e4865$var$promotionStore.promotionDiscounts = (0, $duLFK.initializeWithDefaultData)([]);
    },
    clearCompanySpecificData () {
        $123585b1174e4865$var$promotionStore.signUps = (0, $duLFK.initializeWithDefaultData)([]);
        $123585b1174e4865$var$promotionStore.availablePromotions = (0, $duLFK.initializeWithDefaultData)([]);
        $123585b1174e4865$var$promotionStore.clearDiscounts();
    }
});
var $123585b1174e4865$export$2e2bcd8739ae039 = $123585b1174e4865$var$promotionStore;

});
parcelRegister("izjX7", function(module, exports) {

$parcel$export(module.exports, "isEmptyArray", function () { return $d84af90300d080fc$export$4c0262a4f954db45; });
$parcel$export(module.exports, "cn", function () { return $d84af90300d080fc$export$1343a74baacb0543; });
$parcel$export(module.exports, "formatCookingTime", function () { return $d84af90300d080fc$export$2e0e24f047f4d54a; });
function $d84af90300d080fc$export$4c0262a4f954db45(e) {
    return e.length === 0;
}
function $d84af90300d080fc$export$1caffd285d35b4e7(e) {
    if (!Array.isArray(e)) throw new Error("The input must be an array");
    return e.length > 0;
}
function $d84af90300d080fc$export$83b788b1a3698c03(e) {
    return !Array.isArray(e) && typeof e == "object" && e !== null ? Object.keys(e).length === 0 : !1;
}
function $d84af90300d080fc$export$e0287cc73292b477(e) {
    return typeof e == "object" && e !== null ? Object.keys(e).length > 0 : !1;
}
function $d84af90300d080fc$export$844ec244b1367d54(e) {
    return typeof e == "string";
}
function $d84af90300d080fc$export$c383cdd2a518017a(e) {
    return e.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
}
function $d84af90300d080fc$export$371e338370561054(e) {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(e);
}
const $d84af90300d080fc$export$4d668cb4983d67bd = (e)=>e.replace(/\s+/g, " ").trim(), $d84af90300d080fc$export$9a00dee1beb8f576 = (e)=>e.charAt(0).toUpperCase() + e.slice(1), $d84af90300d080fc$export$be4b07b680577747 = ()=>`grid-${Math.random().toString(36).substr(2, 9)}`;
function $d84af90300d080fc$export$d6781b696a0576d1(e) {
    return typeof e == "number" && isFinite(e);
}
function $d84af90300d080fc$var$te(e) {
    var t, o, r = "";
    if (typeof e == "string" || typeof e == "number") r += e;
    else if (typeof e == "object") {
        if (Array.isArray(e)) {
            var s = e.length;
            for(t = 0; t < s; t++)e[t] && (o = $d84af90300d080fc$var$te(e[t])) && (r && (r += " "), r += o);
        } else for(o in e)e[o] && (r && (r += " "), r += o);
    }
    return r;
}
function $d84af90300d080fc$var$le() {
    for(var e, t, o = 0, r = "", s = arguments.length; o < s; o++)(e = arguments[o]) && (t = $d84af90300d080fc$var$te(e)) && (r && (r += " "), r += t);
    return r;
}
const $d84af90300d080fc$var$Q = "-", $d84af90300d080fc$var$ce = (e)=>{
    const t = $d84af90300d080fc$var$ue(e), { conflictingClassGroups: o, conflictingClassGroupModifiers: r } = e;
    return {
        getClassGroupId: (a)=>{
            const i = a.split($d84af90300d080fc$var$Q);
            return i[0] === "" && i.length !== 1 && i.shift(), $d84af90300d080fc$var$oe(i, t) || $d84af90300d080fc$var$de(a);
        },
        getConflictingClassGroupIds: (a, i)=>{
            const c = o[a] || [];
            return i && r[a] ? [
                ...c,
                ...r[a]
            ] : c;
        }
    };
}, $d84af90300d080fc$var$oe = (e, t)=>{
    var a;
    if (e.length === 0) return t.classGroupId;
    const o = e[0], r = t.nextPart.get(o), s = r ? $d84af90300d080fc$var$oe(e.slice(1), r) : void 0;
    if (s) return s;
    if (t.validators.length === 0) return;
    const n = e.join($d84af90300d080fc$var$Q);
    return (a = t.validators.find(({ validator: i })=>i(n))) == null ? void 0 : a.classGroupId;
}, $d84af90300d080fc$var$D = /^\[(.+)\]$/, $d84af90300d080fc$var$de = (e)=>{
    if ($d84af90300d080fc$var$D.test(e)) {
        const t = $d84af90300d080fc$var$D.exec(e)[1], o = t == null ? void 0 : t.substring(0, t.indexOf(":"));
        if (o) return "arbitrary.." + o;
    }
}, $d84af90300d080fc$var$ue = (e)=>{
    const { theme: t, prefix: o } = e, r = {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
    };
    return $d84af90300d080fc$var$be(Object.entries(e.classGroups), o).forEach(([n, a])=>{
        $d84af90300d080fc$var$F(a, r, n, t);
    }), r;
}, $d84af90300d080fc$var$F = (e, t, o, r)=>{
    e.forEach((s)=>{
        if (typeof s == "string") {
            const n = s === "" ? t : $d84af90300d080fc$var$ee(t, s);
            n.classGroupId = o;
            return;
        }
        if (typeof s == "function") {
            if ($d84af90300d080fc$var$pe(s)) {
                $d84af90300d080fc$var$F(s(r), t, o, r);
                return;
            }
            t.validators.push({
                validator: s,
                classGroupId: o
            });
            return;
        }
        Object.entries(s).forEach(([n, a])=>{
            $d84af90300d080fc$var$F(a, $d84af90300d080fc$var$ee(t, n), o, r);
        });
    });
}, $d84af90300d080fc$var$ee = (e, t)=>{
    let o = e;
    return t.split($d84af90300d080fc$var$Q).forEach((r)=>{
        o.nextPart.has(r) || o.nextPart.set(r, {
            nextPart: /* @__PURE__ */ new Map(),
            validators: []
        }), o = o.nextPart.get(r);
    }), o;
}, $d84af90300d080fc$var$pe = (e)=>e.isThemeGetter, $d84af90300d080fc$var$be = (e, t)=>t ? e.map(([o, r])=>{
        const s = r.map((n)=>typeof n == "string" ? t + n : typeof n == "object" ? Object.fromEntries(Object.entries(n).map(([a, i])=>[
                    t + a,
                    i
                ])) : n);
        return [
            o,
            s
        ];
    }) : e, $d84af90300d080fc$var$fe = (e)=>{
    if (e < 1) return {
        get: ()=>{},
        set: ()=>{}
    };
    let t = 0, o = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
    const s = (n, a)=>{
        o.set(n, a), t++, t > e && (t = 0, r = o, o = /* @__PURE__ */ new Map());
    };
    return {
        get (n) {
            let a = o.get(n);
            if (a !== void 0) return a;
            if ((a = r.get(n)) !== void 0) return s(n, a), a;
        },
        set (n, a) {
            o.has(n) ? o.set(n, a) : s(n, a);
        }
    };
}, $d84af90300d080fc$var$ne = "!", $d84af90300d080fc$var$ge = (e)=>{
    const { separator: t, experimentalParseClassName: o } = e, r = t.length === 1, s = t[0], n = t.length, a = (i)=>{
        const c = [];
        let f = 0, m = 0, y;
        for(let p = 0; p < i.length; p++){
            let g = i[p];
            if (f === 0) {
                if (g === s && (r || i.slice(p, p + n) === t)) {
                    c.push(i.slice(m, p)), m = p + n;
                    continue;
                }
                if (g === "/") {
                    y = p;
                    continue;
                }
            }
            g === "[" ? f++ : g === "]" && f--;
        }
        const x = c.length === 0 ? i : i.substring(m), v = x.startsWith($d84af90300d080fc$var$ne), w = v ? x.substring(1) : x, b = y && y > m ? y - m : void 0;
        return {
            modifiers: c,
            hasImportantModifier: v,
            baseClassName: w,
            maybePostfixModifierPosition: b
        };
    };
    return o ? (i)=>o({
            className: i,
            parseClassName: a
        }) : a;
}, $d84af90300d080fc$var$me = (e)=>{
    if (e.length <= 1) return e;
    const t = [];
    let o = [];
    return e.forEach((r)=>{
        r[0] === "[" ? (t.push(...o.sort(), r), o = []) : o.push(r);
    }), t.push(...o.sort()), t;
}, $d84af90300d080fc$var$he = (e)=>({
        cache: $d84af90300d080fc$var$fe(e.cacheSize),
        parseClassName: $d84af90300d080fc$var$ge(e),
        ...$d84af90300d080fc$var$ce(e)
    }), $d84af90300d080fc$var$ye = /\s+/, $d84af90300d080fc$var$xe = (e, t)=>{
    const { parseClassName: o, getClassGroupId: r, getConflictingClassGroupIds: s } = t, n = [], a = e.trim().split($d84af90300d080fc$var$ye);
    let i = "";
    for(let c = a.length - 1; c >= 0; c -= 1){
        const f = a[c], { modifiers: m, hasImportantModifier: y, baseClassName: x, maybePostfixModifierPosition: v } = o(f);
        let w = !!v, b = r(w ? x.substring(0, v) : x);
        if (!b) {
            if (!w) {
                i = f + (i.length > 0 ? " " + i : i);
                continue;
            }
            if (b = r(x), !b) {
                i = f + (i.length > 0 ? " " + i : i);
                continue;
            }
            w = !1;
        }
        const p = $d84af90300d080fc$var$me(m).join(":"), g = y ? p + $d84af90300d080fc$var$ne : p, h = g + b;
        if (n.includes(h)) continue;
        n.push(h);
        const j = s(b, w);
        for(let A = 0; A < j.length; ++A){
            const T = j[A];
            n.push(g + T);
        }
        i = f + (i.length > 0 ? " " + i : i);
    }
    return i;
};
function $d84af90300d080fc$var$we() {
    let e = 0, t, o, r = "";
    for(; e < arguments.length;)(t = arguments[e++]) && (o = $d84af90300d080fc$var$se(t)) && (r && (r += " "), r += o);
    return r;
}
const $d84af90300d080fc$var$se = (e)=>{
    if (typeof e == "string") return e;
    let t, o = "";
    for(let r = 0; r < e.length; r++)e[r] && (t = $d84af90300d080fc$var$se(e[r])) && (o && (o += " "), o += t);
    return o;
};
function $d84af90300d080fc$var$ve(e, ...t) {
    let o, r, s, n = a;
    function a(c) {
        const f = t.reduce((m, y)=>y(m), e());
        return o = $d84af90300d080fc$var$he(f), r = o.cache.get, s = o.cache.set, n = i, i(c);
    }
    function i(c) {
        const f = r(c);
        if (f) return f;
        const m = $d84af90300d080fc$var$xe(c, o);
        return s(c, m), m;
    }
    return function() {
        return n($d84af90300d080fc$var$we.apply(null, arguments));
    };
}
const $d84af90300d080fc$var$d = (e)=>{
    const t = (o)=>o[e] || [];
    return t.isThemeGetter = !0, t;
}, $d84af90300d080fc$var$ie = /^\[(?:([a-z-]+):)?(.+)\]$/i, $d84af90300d080fc$var$Ce = /^\d+\/\d+$/, $d84af90300d080fc$var$$e = /* @__PURE__ */ new Set([
    "px",
    "full",
    "screen"
]), $d84af90300d080fc$var$ke = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $d84af90300d080fc$var$ze = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, $d84af90300d080fc$var$Se = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, $d84af90300d080fc$var$Ae = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, $d84af90300d080fc$var$Me = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, $d84af90300d080fc$var$$ = (e)=>$d84af90300d080fc$var$M(e) || $d84af90300d080fc$var$$e.has(e) || $d84af90300d080fc$var$Ce.test(e), $d84af90300d080fc$var$k = (e)=>$d84af90300d080fc$var$E(e, "length", $d84af90300d080fc$var$Ne), $d84af90300d080fc$var$M = (e)=>!!e && !Number.isNaN(Number(e)), $d84af90300d080fc$var$U = (e)=>$d84af90300d080fc$var$E(e, "number", $d84af90300d080fc$var$M), $d84af90300d080fc$var$I = (e)=>!!e && Number.isInteger(Number(e)), $d84af90300d080fc$var$Ee = (e)=>e.endsWith("%") && $d84af90300d080fc$var$M(e.slice(0, -1)), $d84af90300d080fc$var$l = (e)=>$d84af90300d080fc$var$ie.test(e), $d84af90300d080fc$var$z = (e)=>$d84af90300d080fc$var$ke.test(e), $d84af90300d080fc$var$Ge = /* @__PURE__ */ new Set([
    "length",
    "size",
    "percentage"
]), $d84af90300d080fc$var$je = (e)=>$d84af90300d080fc$var$E(e, $d84af90300d080fc$var$Ge, $d84af90300d080fc$var$ae), $d84af90300d080fc$var$Re = (e)=>$d84af90300d080fc$var$E(e, "position", $d84af90300d080fc$var$ae), $d84af90300d080fc$var$Ie = /* @__PURE__ */ new Set([
    "image",
    "url"
]), $d84af90300d080fc$var$Pe = (e)=>$d84af90300d080fc$var$E(e, $d84af90300d080fc$var$Ie, $d84af90300d080fc$var$Le), $d84af90300d080fc$var$Te = (e)=>$d84af90300d080fc$var$E(e, "", $d84af90300d080fc$var$Oe), $d84af90300d080fc$var$P = ()=>!0, $d84af90300d080fc$var$E = (e, t, o)=>{
    const r = $d84af90300d080fc$var$ie.exec(e);
    return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : o(r[2]) : !1;
}, $d84af90300d080fc$var$Ne = (e)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $d84af90300d080fc$var$ze.test(e) && !$d84af90300d080fc$var$Se.test(e), $d84af90300d080fc$var$ae = ()=>!1, $d84af90300d080fc$var$Oe = (e)=>$d84af90300d080fc$var$Ae.test(e), $d84af90300d080fc$var$Le = (e)=>$d84af90300d080fc$var$Me.test(e), $d84af90300d080fc$var$We = ()=>{
    const e = $d84af90300d080fc$var$d("colors"), t = $d84af90300d080fc$var$d("spacing"), o = $d84af90300d080fc$var$d("blur"), r = $d84af90300d080fc$var$d("brightness"), s = $d84af90300d080fc$var$d("borderColor"), n = $d84af90300d080fc$var$d("borderRadius"), a = $d84af90300d080fc$var$d("borderSpacing"), i = $d84af90300d080fc$var$d("borderWidth"), c = $d84af90300d080fc$var$d("contrast"), f = $d84af90300d080fc$var$d("grayscale"), m = $d84af90300d080fc$var$d("hueRotate"), y = $d84af90300d080fc$var$d("invert"), x = $d84af90300d080fc$var$d("gap"), v = $d84af90300d080fc$var$d("gradientColorStops"), w = $d84af90300d080fc$var$d("gradientColorStopPositions"), b = $d84af90300d080fc$var$d("inset"), p = $d84af90300d080fc$var$d("margin"), g = $d84af90300d080fc$var$d("opacity"), h = $d84af90300d080fc$var$d("padding"), j = $d84af90300d080fc$var$d("saturate"), A = $d84af90300d080fc$var$d("scale"), T = $d84af90300d080fc$var$d("sepia"), Z = $d84af90300d080fc$var$d("skew"), V = $d84af90300d080fc$var$d("space"), J = $d84af90300d080fc$var$d("translate"), L = ()=>[
            "auto",
            "contain",
            "none"
        ], W = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ], q = ()=>[
            "auto",
            $d84af90300d080fc$var$l,
            t
        ], u = ()=>[
            $d84af90300d080fc$var$l,
            t
        ], H = ()=>[
            "",
            $d84af90300d080fc$var$$,
            $d84af90300d080fc$var$k
        ], N = ()=>[
            "auto",
            $d84af90300d080fc$var$M,
            $d84af90300d080fc$var$l
        ], X = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ], O = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ], Y = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ], _ = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ], R = ()=>[
            "",
            "0",
            $d84af90300d080fc$var$l
        ], K = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ], C = ()=>[
            $d84af90300d080fc$var$M,
            $d84af90300d080fc$var$l
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $d84af90300d080fc$var$P
            ],
            spacing: [
                $d84af90300d080fc$var$$,
                $d84af90300d080fc$var$k
            ],
            blur: [
                "none",
                "",
                $d84af90300d080fc$var$z,
                $d84af90300d080fc$var$l
            ],
            brightness: C(),
            borderColor: [
                e
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $d84af90300d080fc$var$z,
                $d84af90300d080fc$var$l
            ],
            borderSpacing: u(),
            borderWidth: H(),
            contrast: C(),
            grayscale: R(),
            hueRotate: C(),
            invert: R(),
            gap: u(),
            gradientColorStops: [
                e
            ],
            gradientColorStopPositions: [
                $d84af90300d080fc$var$Ee,
                $d84af90300d080fc$var$k
            ],
            inset: q(),
            margin: q(),
            opacity: C(),
            padding: u(),
            saturate: C(),
            scale: C(),
            sepia: R(),
            skew: C(),
            space: u(),
            translate: u()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $d84af90300d080fc$var$z
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": K()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": K()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...X(),
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: W()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": W()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": W()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: L()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": L()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": L()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        b
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        b
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        b
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        b
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        b
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        b
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        b
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        b
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        b
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $d84af90300d080fc$var$I,
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: q()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: R()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: R()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $d84af90300d080fc$var$I,
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $d84af90300d080fc$var$P
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $d84af90300d080fc$var$I,
                                $d84af90300d080fc$var$l
                            ]
                        },
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": N()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": N()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $d84af90300d080fc$var$P
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $d84af90300d080fc$var$I,
                                $d84af90300d080fc$var$l
                            ]
                        },
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": N()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": N()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        x
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        x
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        x
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ..._()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ..._(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ..._(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        h
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        h
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        h
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        h
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        h
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        h
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        h
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        h
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        h
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        p
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        p
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        p
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        p
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        p
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        p
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        p
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        p
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        p
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        V
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        V
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $d84af90300d080fc$var$l,
                        t
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $d84af90300d080fc$var$l,
                        t,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $d84af90300d080fc$var$l,
                        t,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $d84af90300d080fc$var$z
                            ]
                        },
                        $d84af90300d080fc$var$z
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $d84af90300d080fc$var$l,
                        t,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $d84af90300d080fc$var$l,
                        t,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $d84af90300d080fc$var$l,
                        t,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $d84af90300d080fc$var$l,
                        t,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $d84af90300d080fc$var$z,
                        $d84af90300d080fc$var$k
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $d84af90300d080fc$var$U
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $d84af90300d080fc$var$P
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $d84af90300d080fc$var$M,
                        $d84af90300d080fc$var$U
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $d84af90300d080fc$var$$,
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        e
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        g
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        e
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        g
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...O(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $d84af90300d080fc$var$$,
                        $d84af90300d080fc$var$k
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $d84af90300d080fc$var$$,
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        e
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: u()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        g
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...X(),
                        $d84af90300d080fc$var$Re
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $d84af90300d080fc$var$je
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $d84af90300d080fc$var$Pe
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        e
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        w
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        w
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        w
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        v
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        v
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        v
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        n
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        i
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        i
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        i
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        g
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...O(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        i
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        i
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        g
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: O()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        s
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        s
                    ]
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-s": [
                {
                    "border-s": [
                        s
                    ]
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-e": [
                {
                    "border-e": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        s
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        s
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...O()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $d84af90300d080fc$var$$,
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $d84af90300d080fc$var$$,
                        $d84af90300d080fc$var$k
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        e
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: H()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        e
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        g
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $d84af90300d080fc$var$$,
                        $d84af90300d080fc$var$k
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        e
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $d84af90300d080fc$var$z,
                        $d84af90300d080fc$var$Te
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $d84af90300d080fc$var$P
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        g
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": [
                        ...Y(),
                        "plus-lighter",
                        "plus-darker"
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": Y()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        o
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        r
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        c
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $d84af90300d080fc$var$z,
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        f
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        m
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        y
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        j
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        T
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        o
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        r
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        c
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        f
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        m
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        y
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        g
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        j
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        T
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        a
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        a
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        a
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: C()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: C()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        A
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        A
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        A
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $d84af90300d080fc$var$I,
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        J
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        J
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        Z
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        Z
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        e
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        e
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": u()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": u()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": u()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": u()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": u()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": u()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": u()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": u()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": u()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": u()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": u()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": u()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": u()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": u()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": u()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": u()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": u()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": u()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $d84af90300d080fc$var$l
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        e,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $d84af90300d080fc$var$$,
                        $d84af90300d080fc$var$k,
                        $d84af90300d080fc$var$U
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        e,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-s",
                "border-color-e",
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}, $d84af90300d080fc$var$qe = /* @__PURE__ */ $d84af90300d080fc$var$ve($d84af90300d080fc$var$We), $d84af90300d080fc$var$_e = $d84af90300d080fc$var$le, $d84af90300d080fc$var$Ue = $d84af90300d080fc$var$qe;
function $d84af90300d080fc$export$1343a74baacb0543(...e) {
    return $d84af90300d080fc$var$Ue($d84af90300d080fc$var$_e(...e));
}
const $d84af90300d080fc$export$ff13e982ca5afe86 = {
    base: "0px",
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
}, $d84af90300d080fc$export$f8ab8cabd375f044 = {
    0: "0px",
    // 0px
    0.5: "0.125rem",
    // 2px
    1: "0.25rem",
    // 4px
    1.5: "0.375rem",
    // 6px
    2: "0.5rem",
    // 8px
    3: "0.75rem",
    // 12px
    4: "1rem",
    // 16px
    5: "1.25rem",
    // 20px
    6: "1.5rem",
    // 24px
    7: "1.75rem",
    // 28px
    8: "2rem",
    // 32px
    9: "2.25rem",
    // 36px
    10: "2.5rem",
    // 40px
    11: "2.75rem",
    // 44px
    12: "3rem",
    // 48px
    16: "4rem",
    // 64px
    20: "5rem",
    // 80px
    24: "6rem",
    // 96px
    32: "8rem",
    // 128px
    40: "10rem",
    // 160px
    48: "12rem",
    // 192px
    56: "14rem",
    // 224px
    64: "16rem"
}, $d84af90300d080fc$export$cebf4e2d9ff84da2 = {
    media: "",
    container: "@container"
}, $d84af90300d080fc$var$re = (e)=>{
    if (e.endsWith("px")) return parseInt(e);
    if (e in $d84af90300d080fc$export$ff13e982ca5afe86) return parseInt($d84af90300d080fc$export$ff13e982ca5afe86[e]);
    throw new Error(`Invalid breakpoint "${e}". Must be one of: base, sm, md, lg, xl, 2xl, or a pixel value ending in 'px'`);
}, $d84af90300d080fc$var$G = (e)=>e.sort((t, o)=>{
        if (t[0] === "base") return -1;
        if (o[0] === "base") return 1;
        try {
            const r = $d84af90300d080fc$var$re(t[0]), s = $d84af90300d080fc$var$re(o[0]);
            return r - s;
        } catch (r) {
            return console.error("Error sorting breakpoints:", r), 0;
        }
    }), $d84af90300d080fc$export$9aa644b0f609abad = (e, t)=>typeof e == "number" ? `grid-template-columns: repeat(${e}, minmax(0, 1fr));` : typeof e == "object" ? $d84af90300d080fc$var$G(Object.entries(e)).map(([r, s])=>{
        if (r === "base") return `grid-template-columns: repeat(${s}, minmax(0, 1fr));`;
        const n = t === "container", a = n ? "@container" : "@media", i = n ? r : $d84af90300d080fc$export$ff13e982ca5afe86[r], c = n ? `(min-width: ${r})` : `(min-width: ${i})`;
        return `${a} ${c} {
            grid-template-columns: repeat(${s}, minmax(0, 1fr));
          }`;
    }).join(" ") : "", $d84af90300d080fc$export$5a47a95fd30dc7a5 = (e, t)=>typeof e == "number" ? `grid-gap: ${$d84af90300d080fc$export$f8ab8cabd375f044[e]};` : typeof e == "object" ? $d84af90300d080fc$var$G(Object.entries(e)).map(([r, s])=>{
        if (r === "base" && s !== void 0) return `grid-gap: ${$d84af90300d080fc$export$f8ab8cabd375f044[s]};`;
        const n = t === "container", a = n ? "@container" : "@media", i = $d84af90300d080fc$export$ff13e982ca5afe86[r] || r, c = n ? `(min-width: ${i})` : `(min-width: ${i})`;
        return s !== void 0 ? `${a} ${c} {
              grid-gap: ${$d84af90300d080fc$export$f8ab8cabd375f044[s]};
            }` : "";
    }).join(" ") : "", $d84af90300d080fc$export$2bf77e6df997e036 = (e, t)=>e ? typeof e == "string" ? `align-items: ${e};` : typeof e == "object" ? $d84af90300d080fc$var$G(Object.entries(e)).map(([r, s])=>{
        if (r === "base" && s !== void 0) return `align-items: ${s};`;
        const n = t === "container", a = n ? "@container" : "@media", i = n ? r : $d84af90300d080fc$export$ff13e982ca5afe86[r], c = n ? `(min-width: ${r})` : `(min-width: ${i})`;
        return s !== void 0 ? `${a} ${c} {
              align-items: ${s};
            }` : "";
    }).join(" ") : "" : "", $d84af90300d080fc$export$9efada2cf4d2a4f1 = (e, t)=>e ? typeof e == "string" ? `justify-content: ${e};` : typeof e == "object" ? $d84af90300d080fc$var$G(Object.entries(e)).map(([r, s])=>{
        if (r === "base" && s !== void 0) return `justify-content: ${s};`;
        const n = t === "container", a = n ? "@container" : "@media", i = n ? r : $d84af90300d080fc$export$ff13e982ca5afe86[r], c = n ? `(min-width: ${r})` : `(min-width: ${i})`;
        return s !== void 0 ? `${a} ${c} {
              justify-content: ${s};
            }` : "";
    }).join(" ") : "" : "", $d84af90300d080fc$export$72aa988c7d20845d = (e)=>typeof e == "number" ? `grid-column: span ${e};` : typeof e == "object" ? $d84af90300d080fc$var$G(Object.entries(e)).map(([o, r])=>o === "base" ? `grid-column: span ${r};` : `@media ${`(min-width: ${$d84af90300d080fc$export$ff13e982ca5afe86[o] || o})`} {
            grid-column: span ${r};
          }`).join(" ") : "", $d84af90300d080fc$export$f9f469cd04db5798 = (e)=>e === void 0 ? "" : typeof e == "number" ? `order: ${e};` : typeof e == "object" ? $d84af90300d080fc$var$G(Object.entries(e)).map(([o, r])=>o === "base" ? `order: ${r};` : `@media ${`(min-width: ${$d84af90300d080fc$export$ff13e982ca5afe86[o] || o})`} {
            order: ${r};
          }`).join(" ") : "";
function $d84af90300d080fc$export$3dbc497a08afff6c() {
    return typeof window > "u" ? {
        width: 0,
        height: 0,
        devicePixelRatio: 1
    } : {
        width: window.innerWidth,
        height: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio
    };
}
function $d84af90300d080fc$export$2e0e24f047f4d54a(e, t = "no") {
    const o = typeof e == "string" ? parseInt(e, 10) : e;
    if (isNaN(o) || o < 0) throw new Error("Invalid input: Please provide a valid positive number or string representing minutes.");
    const r = Math.floor(o / 60), s = o % 60, n = t === "en" ? "h" : "t";
    if (r > 0 && s === 0) return `${r}${n}`;
    const a = r > 0 ? `${r}${n}` : "", i = `${s}min`;
    return r > 0 ? `${a} ${i}` : i;
}

});


parcelRegister("aBDYY", function(module, exports) {

$parcel$export(module.exports, "convertOrderCommentStringToObject", function () { return $2e94c2b1a259b5aa$export$1da3863affc88d34; });
const $2e94c2b1a259b5aa$export$1da3863affc88d34 = (orderCommentString)=>{
    if (!orderCommentString || !(orderCommentString.startsWith("dspde:") && orderCommentString.includes("\xa7"))) return {};
    const orderCommentMatrix = orderCommentString?.slice(6).split("|").map((item)=>item.split("\xa7"));
    return orderCommentMatrix?.reduce((acc, item)=>{
        if (acc[item[0]]) {
            acc[item[0]].push({
                appliedDiscount: Number(item[1].replace(",", ".")),
                discountName: item[2],
                discountId: item[3]
            });
            return acc;
        }
        acc[item[0]] = [
            {
                appliedDiscount: Number(item[1].replace(",", ".")),
                discountName: item[2],
                discountId: item[3]
            }
        ];
        return acc;
    }, {});
};

});


parcelRegister("d9z1Y", function(module, exports) {

$parcel$export(module.exports, "splitClaimResponseIntoClaims", function () { return $d93a52b1b237b3b6$export$5b4f519d84c7b695; });

var $5UIm0 = parcelRequire("5UIm0");

var $eN72F = parcelRequire("eN72F");
const $d93a52b1b237b3b6$export$5b4f519d84c7b695 = (claimResp)=>({
        key: claimResp.notes_unid,
        isApproved: (0, $eN72F.default)(claimResp.ordrelinjer, (orderLine)=>orderLine.godkjent),
        isUnderProcess: claimResp.status_reklamasjon === "Til godkjenning",
        orderNumber: claimResp.tine_ordrenr,
        dateCreated: (0, $5UIm0.default)(claimResp.opprettet.substring(0, claimResp.opprettet.indexOf("T"))),
        rawData: claimResp
    });

});


parcelRegister("29xOK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7c7305fb3d1d34$export$2e2bcd8739ae039; });

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $isIf6 = parcelRequire("isIf6");

var $gvoND = parcelRequire("gvoND");
const $bc7c7305fb3d1d34$var$contactFormStore = (0, $Kk7R3.makeAutoObservable)({
    submitContactForm: async (contactForm)=>{
        let result;
        const formatedForm = {
            ...contactForm
        };
        try {
            result = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}${(0, $isIf6.default).contactForm.apiPath}`).post(formatedForm).json();
        } catch (err) {
            (0, $gtsdT.logger).error("account", "Error while saving contact form:", err);
            (0, $gvoND.default).addError("Feil under sending av skjema", "Det oppsto en uforutsett feil under sending av skjema.", {
                context: "contact_form",
                text: "contact_form_error"
            });
        }
        return result;
    },
    clearCompanySpecificData: ()=>{
    // add methods to clear company specific data
    }
});
var $bc7c7305fb3d1d34$export$2e2bcd8739ae039 = $bc7c7305fb3d1d34$var$contactFormStore;

});

parcelRegister("jlTfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1180726d4efd10b6$export$2e2bcd8739ae039; });

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");

var $edW3j = parcelRequire("edW3j");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $5OqMf = parcelRequire("5OqMf");

var $duLFK = parcelRequire("duLFK");

var $f2Bp8 = parcelRequire("f2Bp8");

var $bcbvQ = parcelRequire("bcbvQ");

var $biFcX = parcelRequire("biFcX");

var $hgKgU = parcelRequire("hgKgU");

var $9yKIH = parcelRequire("9yKIH");
const $1180726d4efd10b6$var$CONTRACTUAL_RECOMMENDATIONS_TAG = "contractualRecommendationsArticle";
// Used to cache requests for imageWithFocus resources
const $1180726d4efd10b6$var$cachedImageWithFocusPromise = {};
const $1180726d4efd10b6$var$contentStore = (0, $Kk7R3.makeAutoObservable)({
    urlData: (0, $duLFK.initializeWithDefaultData)([]),
    fetchedContent: new Map(),
    sectionContent: {},
    sections: (0, $duLFK.initializeWithDefaultData)([]),
    productCategories: (0, $duLFK.initializeWithDefaultData)([]),
    mainMenuItems: [],
    contractualArticles: [],
    isPreviewMode: false,
    footerContent: (0, $duLFK.initializeWithDefaultData)(undefined),
    allPromotionArticleIds: [],
    viewedPromotionArticleIds: [],
    getCurrentWarnings: ()=>{
        const entriesArray = Array.from($1180726d4efd10b6$var$contentStore.fetchedContent.entries());
        return entriesArray.filter((kv)=>{
            const isWarning = kv[1].type === "warning";
            if (isWarning) {
                const visibleForCurrentSegment = (0, $9yKIH.default).isArticleVisible(kv[0]);
                return visibleForCurrentSegment;
            }
            return false;
        }).map((kv)=>kv[1].entry.data);
    },
    /**
    * Why a separate cache wrapper method?
    * This method stores the promise generated the first time a call is made to fetch a specific
    * imageWithFocus. If multiple components call this method at the same time with the same entryId,
    * they will all get the same promise and it will be resolved with one request. If the same
    * entryId is requested later within the same session, the already-resolved promise is returned and
    * response reused without calling the API again.
    */ getImageWithFocusUsingCache: (entryId)=>{
        if (Object.hasOwn($1180726d4efd10b6$var$cachedImageWithFocusPromise, entryId)) return $1180726d4efd10b6$var$cachedImageWithFocusPromise[entryId];
        const promise = $1180726d4efd10b6$var$contentStore.getImageWithFocus(entryId);
        $1180726d4efd10b6$var$cachedImageWithFocusPromise[entryId] = promise;
        return promise;
    },
    getImageWithFocus: async (entryId)=>{
        const entry = await (0, $hgKgU.contentfulClient)($1180726d4efd10b6$var$contentStore.isPreviewMode).withoutUnresolvableLinks.getEntry(entryId);
        if ((0, $bEEBX.default)(entry) || !entry.fields.image) throw new Error("Image with focus either unavailable or does not contain image info");
        const focalPoint = entry.fields.focalPoint;
        return {
            entryId: entryId,
            altText: entry.fields.altText,
            focalPoint: focalPoint.focalPoint,
            originalAssetUrl: entry.fields.image.fields.file?.url
        };
    },
    fillStore: async (location)=>{
        $1180726d4efd10b6$var$contentStore.isPreviewMode = location.split("/")[1] === (0, $hgKgU.PREVIEW_BASE_PATH);
        (0, $duLFK.setAsWaitingForData)($1180726d4efd10b6$var$contentStore.urlData);
        (0, $duLFK.setAsWaitingForData)($1180726d4efd10b6$var$contentStore.sections);
        (0, $duLFK.setAsWaitingForData)($1180726d4efd10b6$var$contentStore.footerContent);
        (0, $duLFK.setAsWaitingForData)($1180726d4efd10b6$var$contentStore.productCategories);
        try {
            const [sectionContent, articleContent, recipeContent, productCategoryContent, adventCalendarSlotContent, warningContent] = await Promise.all([
                (0, $hgKgU.getSectionsSlugsAndParents)($1180726d4efd10b6$var$contentStore.isPreviewMode),
                (0, $hgKgU.getArticleSlugsAndParents)($1180726d4efd10b6$var$contentStore.isPreviewMode),
                (0, $hgKgU.getRecipeSlugsAndParents)($1180726d4efd10b6$var$contentStore.isPreviewMode),
                (0, $hgKgU.getProductCategoryContent)($1180726d4efd10b6$var$contentStore.isPreviewMode),
                (0, $hgKgU.getAdventCalendarSlotSlugsAndParents)($1180726d4efd10b6$var$contentStore.isPreviewMode),
                (0, $hgKgU.getWarnings)($1180726d4efd10b6$var$contentStore.isPreviewMode)
            ]);
            const segmentedEntries = [
                ...articleContent,
                ...productCategoryContent,
                ...warningContent
            ];
            (0, $9yKIH.default).setArticleSegments(segmentedEntries);
            const sectionsRecipesAndArticles = [
                ...sectionContent,
                ...articleContent,
                ...recipeContent,
                ...adventCalendarSlotContent
            ];
            const allContent = sectionsRecipesAndArticles.map((0, $hgKgU.getUnprocessedUrlDataFromContent));
            const allUrlData = allContent.map((page)=>(0, $hgKgU.generateFullUrl)(page, allContent));
            (0, $Kk7R3.runInAction)(()=>{
                $1180726d4efd10b6$var$contentStore.mainMenuItems = sectionsRecipesAndArticles.flatMap((content)=>(0, $hgKgU.createMenuItem)(content, allUrlData));
                $1180726d4efd10b6$var$contentStore.contractualArticles = articleContent.filter((article)=>article.metadata.tags.some((tag)=>tag.sys.id === $1180726d4efd10b6$var$CONTRACTUAL_RECOMMENDATIONS_TAG));
                // Initialize all possible keys for content fetching in the future
                for (const data of allUrlData)$1180726d4efd10b6$var$contentStore.fetchedContent.set(data.id, {
                    type: data.type,
                    entry: (0, $duLFK.initializeWithDefaultData)({})
                });
                for (const warning of warningContent)$1180726d4efd10b6$var$contentStore.fetchedContent.set(warning.sys.id, {
                    type: "warning",
                    entry: (0, $duLFK.initializeWithDefaultData)(warning.fields)
                });
            });
            // Find content marked as main menu content
            const footerData = await (0, $hgKgU.getFooterContent)($1180726d4efd10b6$var$contentStore.isPreviewMode);
            (0, $duLFK.setAsDataAvailable)($1180726d4efd10b6$var$contentStore.footerContent, footerData[0]);
            (0, $duLFK.setAsDataAvailable)($1180726d4efd10b6$var$contentStore.productCategories, productCategoryContent);
            (0, $duLFK.setAsDataAvailable)($1180726d4efd10b6$var$contentStore.sections, sectionContent);
            (0, $duLFK.setAsDataAvailable)($1180726d4efd10b6$var$contentStore.urlData, allUrlData);
            const promotionSectionId = $1180726d4efd10b6$var$contentStore.getSectionIdFromSlug((0, $edW3j.PROMOTION_SECTION_SLUG));
            if (promotionSectionId) {
                await $1180726d4efd10b6$var$contentStore.fetchSectionContentForId(promotionSectionId);
                (0, $Kk7R3.runInAction)(()=>{
                    $1180726d4efd10b6$var$contentStore.allPromotionArticleIds = articleContent.filter((article)=>article.fields.visibleInSections?.includes(promotionSectionId)).map((article)=>article.sys.id);
                });
            }
        } catch (err) {
            (0, $gtsdT.logger).warn("contentful", "An error while building url data", err);
            const errorMsg = (0, $aMYzM.ensureError)(err).message;
            (0, $duLFK.setAsErrorOccured)($1180726d4efd10b6$var$contentStore.sections, errorMsg);
            (0, $duLFK.setAsErrorOccured)($1180726d4efd10b6$var$contentStore.urlData, errorMsg);
        }
    },
    fetchSectionContentForId: async (sectionId)=>{
        (0, $gtsdT.logger).log("contentful", `Fetching article list for section id ${sectionId}`);
        if (!$1180726d4efd10b6$var$contentStore.sectionContent[sectionId]) $1180726d4efd10b6$var$contentStore.setSectionContent(sectionId, (0, $duLFK.initializeWithDefaultData)([]));
        const sectionContent = $1180726d4efd10b6$var$contentStore.sectionContent[sectionId];
        (0, $duLFK.setAsWaitingForData)(sectionContent);
        try {
            const articles = await (0, $hgKgU.getArticlesInSection)(sectionId, $1180726d4efd10b6$var$contentStore.isPreviewMode);
            const recipes = await (0, $hgKgU.getRecipesInSection)(sectionId, $1180726d4efd10b6$var$contentStore.isPreviewMode);
            const content = [
                ...(0, $hgKgU.sortSectionContentEntries)(articles),
                ...(0, $hgKgU.sortSectionContentEntries)(recipes)
            ];
            (0, $duLFK.setAsDataAvailable)(sectionContent, content);
        } catch (err) {
            (0, $duLFK.setAsErrorOccured)(sectionContent, (0, $aMYzM.ensureError)(err).message);
        }
    },
    setSectionContent (sectionId, content) {
        $1180726d4efd10b6$var$contentStore.sectionContent[sectionId] = content;
    },
    fetchContentIfNotAlreadyInStore: async (id, type)=>{
        const content = $1180726d4efd10b6$var$contentStore.fetchedContent.get(id);
        if (!content || !(0, $duLFK.isDefaultData)(content.entry)) return;
        (0, $gtsdT.logger).log("contentful", `Starting full content fetch for id ${id} of type ${type}`);
        (0, $duLFK.setAsLoading)(content.entry);
        try {
            const result = await (0, $hgKgU.getFullContent)(id, $1180726d4efd10b6$var$contentStore.isPreviewMode);
            (0, $5OqMf.warnIfCyclicObject)(result);
            (0, $gtsdT.logger).log("contentful", `Full content results for ${id} (${type}):`, result);
            (0, $duLFK.setAsDataAvailable)(content.entry, result);
        } catch (err) {
            (0, $gtsdT.logger).warn("contentful", "Error during fetching full content", err);
            (0, $duLFK.setAsErrorOccured)(content.entry, (0, $aMYzM.ensureError)(err).message);
        }
    },
    getRichTextForProductCategory: (path)=>{
        if ((0, $duLFK.isDataAvailable)($1180726d4efd10b6$var$contentStore.productCategories)) {
            const entries = $1180726d4efd10b6$var$contentStore.productCategories.data;
            const filteredEntries = entries.filter((entry)=>{
                return (entry.fields?.categoryUrls?.includes(path) || entry.fields?.categoryPath === path) && (0, $9yKIH.default).isArticleVisible(entry.sys.id);
            });
            if (filteredEntries.length) return filteredEntries[0].fields.body;
        }
        return null;
    },
    getSectionIdFromSlug: (slug)=>{
        const sections = $1180726d4efd10b6$var$contentStore?.sections?.data;
        if (!sections) return;
        const sectionId = $1180726d4efd10b6$var$contentStore.sections.data.find((section)=>section.fields.slug === slug)?.sys.id;
        return sectionId;
    },
    getNewPromotionArticlesCount: ()=>{
        if ((0, $biFcX.default).newPromotionNotificationsEnabled === false || !(0, $bcbvQ.default).isLoggedIn()) return 0;
        const promotionId = $1180726d4efd10b6$var$contentStore.getSectionIdFromSlug((0, $edW3j.PROMOTION_SECTION_SLUG));
        if (!promotionId) return 0;
        const promotionArticlesCount = $1180726d4efd10b6$var$contentStore.allPromotionArticleIds.filter((articleId)=>(0, $9yKIH.default).isArticleVisible(articleId)).length;
        const viewedPromotionArticleCount = $1180726d4efd10b6$var$contentStore.viewedPromotionArticleIds.length;
        const notViewedPromotionArticleCount = promotionArticlesCount - viewedPromotionArticleCount;
        return notViewedPromotionArticleCount;
    },
    addViewedPromotionArticleId: (promotionArticleId)=>{
        if ($1180726d4efd10b6$var$contentStore.viewedPromotionArticleIds.includes(promotionArticleId)) return;
        const updatedViewedPromotionArticleIds = [
            ...$1180726d4efd10b6$var$contentStore.viewedPromotionArticleIds,
            promotionArticleId
        ];
        $1180726d4efd10b6$var$contentStore.viewedPromotionArticleIds = updatedViewedPromotionArticleIds;
        const companyId = (0, $bcbvQ.default).currentCompany;
        if (companyId) (0, $f2Bp8.setViewedPromotionArticlesInStorage)(companyId, updatedViewedPromotionArticleIds);
    },
    clearCompanySpecificData: ()=>{
    // add methods to clear company specific data
    }
});
var $1180726d4efd10b6$export$2e2bcd8739ae039 = $1180726d4efd10b6$var$contentStore;

});
parcelRegister("edW3j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PROMOTION_SECTION_SLUG", function () { return $e224471ad2be5cb6$export$45fcde77bc2392c; });
$parcel$export(module.exports, "default", function () { return $e224471ad2be5cb6$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $88FA0 = parcelRequire("88FA0");

var $aRSTV = parcelRequire("aRSTV");

var $duLFK = parcelRequire("duLFK");

var $3kQAm = parcelRequire("3kQAm");

var $4r4cM = parcelRequire("4r4cM");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $bZiDo = parcelRequire("bZiDo");

var $luszM = parcelRequire("luszM");

var $i6TQx = parcelRequire("i6TQx");

var $ca824 = parcelRequire("ca824");
const $e224471ad2be5cb6$export$45fcde77bc2392c = "kampanjer";
const $e224471ad2be5cb6$var$PromotionPage = ()=>{
    const promotionId = (0, $jlTfJ.default).getSectionIdFromSlug($e224471ad2be5cb6$export$45fcde77bc2392c);
    if (!promotionId) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                className: "mb-2",
                children: "Kampanjer"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
                height: 380
            })
        ]
    });
    // TODO: is it intentional that we update state here, in the render body?
    if (!(0, $jlTfJ.default).sectionContent[promotionId]) (0, $Kk7R3.runInAction)(()=>{
        (0, $jlTfJ.default).sectionContent[promotionId] = (0, $duLFK.initializeWithDefaultData)([]);
    });
    const allPromotionSectionContent = (0, $jlTfJ.default).sectionContent[promotionId];
    if ((0, $duLFK.isDefaultData)(allPromotionSectionContent)) (0, $jlTfJ.default).fetchSectionContentForId(promotionId);
    if ((0, $duLFK.isWaitingForData)(allPromotionSectionContent)) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                className: "mb-2",
                children: "Kampanjer"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
                height: 380
            })
        ]
    });
    if ((0, $duLFK.isErrorOccured)(allPromotionSectionContent)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
        showCloseButton: false,
        gaErrorTracking: {
            context: "promotions",
            text: "page_load_error"
        },
        children: "Det oppsto en uventet feil under lasting av siden"
    });
    const promotionArticles = allPromotionSectionContent.data.filter((object)=>{
        return object.sys.contentType.sys.id === "v2_article" && (0, $9yKIH.default).isArticleVisible(object.sys.id);
    });
    const allProductsInAssortment = (0, $bZiDo.default).products;
    const productsWithDiscount = allProductsInAssortment.filter((product)=>{
        return (0, $luszM.hasDiscount)(product) || (0, $i6TQx.default).getPromotionsBySku(product.sku).length > 0;
    });
    for (const promotionArticle of promotionArticles)(0, $jlTfJ.default).addViewedPromotionArticleId(promotionArticle.sys.id);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                className: "mb-2",
                children: "Kampanjer"
            }),
            promotionArticles.length === 0 && productsWithDiscount.length === 0 && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Ingen kampanjer tilgjengelig"
            }),
            promotionArticles.map((object, i)=>{
                const article = object;
                const imagePosition = i % 2 === 0 ? "Left" : "Right";
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ca824.default), {
                    article: article,
                    imagePosition: imagePosition
                }, `promotion-article-${article.fields.title}`);
            }),
            productsWithDiscount.length > 0 && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        className: "mb-2",
                        children: "Kampanjeprodukter"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                        products: productsWithDiscount,
                        listName: "Kampanjeprodukter",
                        listType: (0, $aRSTV.LIST_TYPE).CUSTOM,
                        context: "discounted-products"
                    })
                ]
            })
        ]
    });
};
var $e224471ad2be5cb6$export$2e2bcd8739ae039 = (0, $gBcml.observer)($e224471ad2be5cb6$var$PromotionPage);

});
parcelRegister("8TkRM", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return (parcelRequire("gBcml")).observer; });
parcelRequire("k5vjL");
parcelRequire("9l9XF");
var $im7eH = parcelRequire("im7eH");

var $hdymY = parcelRequire("hdymY");
parcelRequire("7DHNG");

var $bvFKR = parcelRequire("bvFKR");

var $4rH0h = parcelRequire("4rH0h");

var $aPf73 = parcelRequire("aPf73");

var $gBcml = parcelRequire("gBcml");

var $dgCXm = parcelRequire("dgCXm");

var $6pvW2 = parcelRequire("6pvW2");

var $4H9dM = parcelRequire("4H9dM");

var $30xMB = parcelRequire("30xMB");
var $6793a56eb81b017e$var$_a;
(0, $hdymY.observerBatching)((0, $im7eH.unstable_batchedUpdates));
var $6793a56eb81b017e$export$469d51fb8d268227 = ($6793a56eb81b017e$var$_a = (0, $aPf73.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && $6793a56eb81b017e$var$_a !== void 0 ? $6793a56eb81b017e$var$_a : function() {};
function $6793a56eb81b017e$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $bvFKR.useObserver)(fn, baseComponentName);
}
function $6793a56eb81b017e$export$7613124ee4202834(enable) {
    (0, $4rH0h.enableStaticRendering)(enable);
}

});
parcelRegister("k5vjL", function(module, exports) {

var $Kk7R3 = parcelRequire("Kk7R3");

var $dvPqk = parcelRequire("dvPqk");
if (!(0, $dvPqk.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $Kk7R3.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});

parcelRegister("9l9XF", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("im7eH")).unstable_batchedUpdates; });

var $im7eH = parcelRequire("im7eH");

});
parcelRegister("im7eH", function(module, exports) {
'use strict';
function $d5cfe501226e5648$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d5cfe501226e5648$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d5cfe501226e5648$var$checkDCE();

module.exports = (parcelRequire("dwXaM"));

});
parcelRegister("dwXaM", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9d9c2a020ee1de94$export$ae55be85d98224ed; }, function (v) { return $9d9c2a020ee1de94$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9d9c2a020ee1de94$export$d39a5bbd09211389; }, function (v) { return $9d9c2a020ee1de94$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9d9c2a020ee1de94$export$882461b6382ed46c; }, function (v) { return $9d9c2a020ee1de94$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9d9c2a020ee1de94$export$466bfc07425424d5; }, function (v) { return $9d9c2a020ee1de94$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9d9c2a020ee1de94$export$cd75ccfd720a3cd4; }, function (v) { return $9d9c2a020ee1de94$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9d9c2a020ee1de94$export$fa8d919ba61d84db; }, function (v) { return $9d9c2a020ee1de94$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9d9c2a020ee1de94$export$757ceba2d55c277e; }, function (v) { return $9d9c2a020ee1de94$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9d9c2a020ee1de94$export$b3890eb0ae9dca99; }, function (v) { return $9d9c2a020ee1de94$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9d9c2a020ee1de94$export$502457920280e6be; }, function (v) { return $9d9c2a020ee1de94$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9d9c2a020ee1de94$export$c78a37762a8d58e1; }, function (v) { return $9d9c2a020ee1de94$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9d9c2a020ee1de94$export$dc54d992c10e8a18; }, function (v) { return $9d9c2a020ee1de94$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9d9c2a020ee1de94$export$83d89fbfd8236492; }, function (v) { return $9d9c2a020ee1de94$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9d9c2a020ee1de94$export$ae55be85d98224ed;
var $9d9c2a020ee1de94$export$d39a5bbd09211389;
var $9d9c2a020ee1de94$export$882461b6382ed46c;
var $9d9c2a020ee1de94$export$466bfc07425424d5;
var $9d9c2a020ee1de94$export$cd75ccfd720a3cd4;
var $9d9c2a020ee1de94$export$fa8d919ba61d84db;
var $9d9c2a020ee1de94$export$757ceba2d55c277e;
var $9d9c2a020ee1de94$export$b3890eb0ae9dca99;
var $9d9c2a020ee1de94$export$502457920280e6be;
var $9d9c2a020ee1de94$export$c78a37762a8d58e1;
var $9d9c2a020ee1de94$export$dc54d992c10e8a18;
var $9d9c2a020ee1de94$export$83d89fbfd8236492;
'use strict';

var $dvPqk = parcelRequire("dvPqk");

var $bKjPo = parcelRequire("bKjPo");
function $9d9c2a020ee1de94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9d9c2a020ee1de94$var$da = new Set, $9d9c2a020ee1de94$var$ea = {};
function $9d9c2a020ee1de94$var$fa(a, b) {
    $9d9c2a020ee1de94$var$ha(a, b);
    $9d9c2a020ee1de94$var$ha(a + "Capture", b);
}
function $9d9c2a020ee1de94$var$ha(a, b) {
    $9d9c2a020ee1de94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9d9c2a020ee1de94$var$da.add(b[a]);
}
var $9d9c2a020ee1de94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9d9c2a020ee1de94$var$ja = Object.prototype.hasOwnProperty, $9d9c2a020ee1de94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9d9c2a020ee1de94$var$la = {}, $9d9c2a020ee1de94$var$ma = {};
function $9d9c2a020ee1de94$var$oa(a) {
    if ($9d9c2a020ee1de94$var$ja.call($9d9c2a020ee1de94$var$ma, a)) return !0;
    if ($9d9c2a020ee1de94$var$ja.call($9d9c2a020ee1de94$var$la, a)) return !1;
    if ($9d9c2a020ee1de94$var$ka.test(a)) return $9d9c2a020ee1de94$var$ma[a] = !0;
    $9d9c2a020ee1de94$var$la[a] = !0;
    return !1;
}
function $9d9c2a020ee1de94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9d9c2a020ee1de94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9d9c2a020ee1de94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9d9c2a020ee1de94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9d9c2a020ee1de94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9d9c2a020ee1de94$var$z[b] = new $9d9c2a020ee1de94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9d9c2a020ee1de94$var$ra = /[\-:]([a-z])/g;
function $9d9c2a020ee1de94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9d9c2a020ee1de94$var$ra, $9d9c2a020ee1de94$var$sa);
    $9d9c2a020ee1de94$var$z[b] = new $9d9c2a020ee1de94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9d9c2a020ee1de94$var$ra, $9d9c2a020ee1de94$var$sa);
    $9d9c2a020ee1de94$var$z[b] = new $9d9c2a020ee1de94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9d9c2a020ee1de94$var$ra, $9d9c2a020ee1de94$var$sa);
    $9d9c2a020ee1de94$var$z[b] = new $9d9c2a020ee1de94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9d9c2a020ee1de94$var$z.xlinkHref = new $9d9c2a020ee1de94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9d9c2a020ee1de94$var$z[a] = new $9d9c2a020ee1de94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9d9c2a020ee1de94$var$ta(a, b, c, d) {
    var e = $9d9c2a020ee1de94$var$z.hasOwnProperty(b) ? $9d9c2a020ee1de94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9d9c2a020ee1de94$var$qa(b, c, e, d) && (c = null), d || null === e ? $9d9c2a020ee1de94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9d9c2a020ee1de94$var$ua = $dvPqk.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9d9c2a020ee1de94$var$va = Symbol.for("react.element"), $9d9c2a020ee1de94$var$wa = Symbol.for("react.portal"), $9d9c2a020ee1de94$var$ya = Symbol.for("react.fragment"), $9d9c2a020ee1de94$var$za = Symbol.for("react.strict_mode"), $9d9c2a020ee1de94$var$Aa = Symbol.for("react.profiler"), $9d9c2a020ee1de94$var$Ba = Symbol.for("react.provider"), $9d9c2a020ee1de94$var$Ca = Symbol.for("react.context"), $9d9c2a020ee1de94$var$Da = Symbol.for("react.forward_ref"), $9d9c2a020ee1de94$var$Ea = Symbol.for("react.suspense"), $9d9c2a020ee1de94$var$Fa = Symbol.for("react.suspense_list"), $9d9c2a020ee1de94$var$Ga = Symbol.for("react.memo"), $9d9c2a020ee1de94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9d9c2a020ee1de94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9d9c2a020ee1de94$var$Ja = Symbol.iterator;
function $9d9c2a020ee1de94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9d9c2a020ee1de94$var$Ja && a[$9d9c2a020ee1de94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9d9c2a020ee1de94$var$A = Object.assign, $9d9c2a020ee1de94$var$La;
function $9d9c2a020ee1de94$var$Ma(a) {
    if (void 0 === $9d9c2a020ee1de94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9d9c2a020ee1de94$var$La = b && b[1] || "";
    }
    return "\n" + $9d9c2a020ee1de94$var$La + a;
}
var $9d9c2a020ee1de94$var$Na = !1;
function $9d9c2a020ee1de94$var$Oa(a, b) {
    if (!a || $9d9c2a020ee1de94$var$Na) return "";
    $9d9c2a020ee1de94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9d9c2a020ee1de94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9d9c2a020ee1de94$var$Ma(a) : "";
}
function $9d9c2a020ee1de94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9d9c2a020ee1de94$var$Ma(a.type);
        case 16:
            return $9d9c2a020ee1de94$var$Ma("Lazy");
        case 13:
            return $9d9c2a020ee1de94$var$Ma("Suspense");
        case 19:
            return $9d9c2a020ee1de94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9d9c2a020ee1de94$var$Oa(a.type, !1), a;
        case 11:
            return a = $9d9c2a020ee1de94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9d9c2a020ee1de94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9d9c2a020ee1de94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9d9c2a020ee1de94$var$ya:
            return "Fragment";
        case $9d9c2a020ee1de94$var$wa:
            return "Portal";
        case $9d9c2a020ee1de94$var$Aa:
            return "Profiler";
        case $9d9c2a020ee1de94$var$za:
            return "StrictMode";
        case $9d9c2a020ee1de94$var$Ea:
            return "Suspense";
        case $9d9c2a020ee1de94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9d9c2a020ee1de94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9d9c2a020ee1de94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9d9c2a020ee1de94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9d9c2a020ee1de94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9d9c2a020ee1de94$var$Qa(a.type) || "Memo";
        case $9d9c2a020ee1de94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9d9c2a020ee1de94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9d9c2a020ee1de94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9d9c2a020ee1de94$var$Qa(b);
        case 8:
            return b === $9d9c2a020ee1de94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9d9c2a020ee1de94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9d9c2a020ee1de94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9d9c2a020ee1de94$var$Ua(a) {
    var b = $9d9c2a020ee1de94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9d9c2a020ee1de94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9d9c2a020ee1de94$var$Ua(a));
}
function $9d9c2a020ee1de94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9d9c2a020ee1de94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9d9c2a020ee1de94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9d9c2a020ee1de94$var$Ya(a, b) {
    var c = b.checked;
    return $9d9c2a020ee1de94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9d9c2a020ee1de94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9d9c2a020ee1de94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9d9c2a020ee1de94$var$ab(a, b) {
    b = b.checked;
    null != b && $9d9c2a020ee1de94$var$ta(a, "checked", b, !1);
}
function $9d9c2a020ee1de94$var$bb(a, b) {
    $9d9c2a020ee1de94$var$ab(a, b);
    var c = $9d9c2a020ee1de94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9d9c2a020ee1de94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9d9c2a020ee1de94$var$cb(a, b.type, $9d9c2a020ee1de94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9d9c2a020ee1de94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9d9c2a020ee1de94$var$cb(a, b, c) {
    if ("number" !== b || $9d9c2a020ee1de94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9d9c2a020ee1de94$var$eb = Array.isArray;
function $9d9c2a020ee1de94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9d9c2a020ee1de94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9d9c2a020ee1de94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9d9c2a020ee1de94$var$p(91));
    return $9d9c2a020ee1de94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9d9c2a020ee1de94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9d9c2a020ee1de94$var$p(92));
            if ($9d9c2a020ee1de94$var$eb(c)) {
                if (1 < c.length) throw Error($9d9c2a020ee1de94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9d9c2a020ee1de94$var$Sa(c)
    };
}
function $9d9c2a020ee1de94$var$ib(a, b) {
    var c = $9d9c2a020ee1de94$var$Sa(b.value), d = $9d9c2a020ee1de94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9d9c2a020ee1de94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9d9c2a020ee1de94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9d9c2a020ee1de94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9d9c2a020ee1de94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9d9c2a020ee1de94$var$mb, $9d9c2a020ee1de94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9d9c2a020ee1de94$var$mb = $9d9c2a020ee1de94$var$mb || document.createElement("div");
        $9d9c2a020ee1de94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9d9c2a020ee1de94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9d9c2a020ee1de94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9d9c2a020ee1de94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9d9c2a020ee1de94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9d9c2a020ee1de94$var$pb).forEach(function(a) {
    $9d9c2a020ee1de94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9d9c2a020ee1de94$var$pb[b] = $9d9c2a020ee1de94$var$pb[a];
    });
});
function $9d9c2a020ee1de94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9d9c2a020ee1de94$var$pb.hasOwnProperty(a) && $9d9c2a020ee1de94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9d9c2a020ee1de94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9d9c2a020ee1de94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9d9c2a020ee1de94$var$tb = $9d9c2a020ee1de94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9d9c2a020ee1de94$var$ub(a, b) {
    if (b) {
        if ($9d9c2a020ee1de94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9d9c2a020ee1de94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9d9c2a020ee1de94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9d9c2a020ee1de94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9d9c2a020ee1de94$var$p(62));
    }
}
function $9d9c2a020ee1de94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9d9c2a020ee1de94$var$wb = null;
function $9d9c2a020ee1de94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9d9c2a020ee1de94$var$yb = null, $9d9c2a020ee1de94$var$zb = null, $9d9c2a020ee1de94$var$Ab = null;
function $9d9c2a020ee1de94$var$Bb(a) {
    if (a = $9d9c2a020ee1de94$var$Cb(a)) {
        if ("function" !== typeof $9d9c2a020ee1de94$var$yb) throw Error($9d9c2a020ee1de94$var$p(280));
        var b = a.stateNode;
        b && (b = $9d9c2a020ee1de94$var$Db(b), $9d9c2a020ee1de94$var$yb(a.stateNode, a.type, b));
    }
}
function $9d9c2a020ee1de94$var$Eb(a) {
    $9d9c2a020ee1de94$var$zb ? $9d9c2a020ee1de94$var$Ab ? $9d9c2a020ee1de94$var$Ab.push(a) : $9d9c2a020ee1de94$var$Ab = [
        a
    ] : $9d9c2a020ee1de94$var$zb = a;
}
function $9d9c2a020ee1de94$var$Fb() {
    if ($9d9c2a020ee1de94$var$zb) {
        var a = $9d9c2a020ee1de94$var$zb, b = $9d9c2a020ee1de94$var$Ab;
        $9d9c2a020ee1de94$var$Ab = $9d9c2a020ee1de94$var$zb = null;
        $9d9c2a020ee1de94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9d9c2a020ee1de94$var$Bb(b[a]);
    }
}
function $9d9c2a020ee1de94$var$Gb(a, b) {
    return a(b);
}
function $9d9c2a020ee1de94$var$Hb() {}
var $9d9c2a020ee1de94$var$Ib = !1;
function $9d9c2a020ee1de94$var$Jb(a, b, c) {
    if ($9d9c2a020ee1de94$var$Ib) return a(b, c);
    $9d9c2a020ee1de94$var$Ib = !0;
    try {
        return $9d9c2a020ee1de94$var$Gb(a, b, c);
    } finally{
        if ($9d9c2a020ee1de94$var$Ib = !1, null !== $9d9c2a020ee1de94$var$zb || null !== $9d9c2a020ee1de94$var$Ab) $9d9c2a020ee1de94$var$Hb(), $9d9c2a020ee1de94$var$Fb();
    }
}
function $9d9c2a020ee1de94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9d9c2a020ee1de94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9d9c2a020ee1de94$var$p(231, b, typeof c));
    return c;
}
var $9d9c2a020ee1de94$var$Lb = !1;
if ($9d9c2a020ee1de94$var$ia) try {
    var $9d9c2a020ee1de94$var$Mb = {};
    Object.defineProperty($9d9c2a020ee1de94$var$Mb, "passive", {
        get: function() {
            $9d9c2a020ee1de94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9d9c2a020ee1de94$var$Mb, $9d9c2a020ee1de94$var$Mb);
    window.removeEventListener("test", $9d9c2a020ee1de94$var$Mb, $9d9c2a020ee1de94$var$Mb);
} catch (a) {
    $9d9c2a020ee1de94$var$Lb = !1;
}
function $9d9c2a020ee1de94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9d9c2a020ee1de94$var$Ob = !1, $9d9c2a020ee1de94$var$Pb = null, $9d9c2a020ee1de94$var$Qb = !1, $9d9c2a020ee1de94$var$Rb = null, $9d9c2a020ee1de94$var$Sb = {
    onError: function(a) {
        $9d9c2a020ee1de94$var$Ob = !0;
        $9d9c2a020ee1de94$var$Pb = a;
    }
};
function $9d9c2a020ee1de94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9d9c2a020ee1de94$var$Ob = !1;
    $9d9c2a020ee1de94$var$Pb = null;
    $9d9c2a020ee1de94$var$Nb.apply($9d9c2a020ee1de94$var$Sb, arguments);
}
function $9d9c2a020ee1de94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9d9c2a020ee1de94$var$Tb.apply(this, arguments);
    if ($9d9c2a020ee1de94$var$Ob) {
        if ($9d9c2a020ee1de94$var$Ob) {
            var l = $9d9c2a020ee1de94$var$Pb;
            $9d9c2a020ee1de94$var$Ob = !1;
            $9d9c2a020ee1de94$var$Pb = null;
        } else throw Error($9d9c2a020ee1de94$var$p(198));
        $9d9c2a020ee1de94$var$Qb || ($9d9c2a020ee1de94$var$Qb = !0, $9d9c2a020ee1de94$var$Rb = l);
    }
}
function $9d9c2a020ee1de94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9d9c2a020ee1de94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9d9c2a020ee1de94$var$Xb(a) {
    if ($9d9c2a020ee1de94$var$Vb(a) !== a) throw Error($9d9c2a020ee1de94$var$p(188));
}
function $9d9c2a020ee1de94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9d9c2a020ee1de94$var$Vb(a);
        if (null === b) throw Error($9d9c2a020ee1de94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9d9c2a020ee1de94$var$Xb(e), a;
                if (f === d) return $9d9c2a020ee1de94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9d9c2a020ee1de94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9d9c2a020ee1de94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9d9c2a020ee1de94$var$p(190));
    }
    if (3 !== c.tag) throw Error($9d9c2a020ee1de94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9d9c2a020ee1de94$var$Zb(a) {
    a = $9d9c2a020ee1de94$var$Yb(a);
    return null !== a ? $9d9c2a020ee1de94$var$$b(a) : null;
}
function $9d9c2a020ee1de94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9d9c2a020ee1de94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9d9c2a020ee1de94$var$ac = $bKjPo.unstable_scheduleCallback, $9d9c2a020ee1de94$var$bc = $bKjPo.unstable_cancelCallback, $9d9c2a020ee1de94$var$cc = $bKjPo.unstable_shouldYield, $9d9c2a020ee1de94$var$dc = $bKjPo.unstable_requestPaint, $9d9c2a020ee1de94$var$B = $bKjPo.unstable_now, $9d9c2a020ee1de94$var$ec = $bKjPo.unstable_getCurrentPriorityLevel, $9d9c2a020ee1de94$var$fc = $bKjPo.unstable_ImmediatePriority, $9d9c2a020ee1de94$var$gc = $bKjPo.unstable_UserBlockingPriority, $9d9c2a020ee1de94$var$hc = $bKjPo.unstable_NormalPriority, $9d9c2a020ee1de94$var$ic = $bKjPo.unstable_LowPriority, $9d9c2a020ee1de94$var$jc = $bKjPo.unstable_IdlePriority, $9d9c2a020ee1de94$var$kc = null, $9d9c2a020ee1de94$var$lc = null;
function $9d9c2a020ee1de94$var$mc(a) {
    if ($9d9c2a020ee1de94$var$lc && "function" === typeof $9d9c2a020ee1de94$var$lc.onCommitFiberRoot) try {
        $9d9c2a020ee1de94$var$lc.onCommitFiberRoot($9d9c2a020ee1de94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9d9c2a020ee1de94$var$oc = Math.clz32 ? Math.clz32 : $9d9c2a020ee1de94$var$nc, $9d9c2a020ee1de94$var$pc = Math.log, $9d9c2a020ee1de94$var$qc = Math.LN2;
function $9d9c2a020ee1de94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9d9c2a020ee1de94$var$pc(a) / $9d9c2a020ee1de94$var$qc | 0) | 0;
}
var $9d9c2a020ee1de94$var$rc = 64, $9d9c2a020ee1de94$var$sc = 4194304;
function $9d9c2a020ee1de94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9d9c2a020ee1de94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9d9c2a020ee1de94$var$tc(h) : (f &= g, 0 !== f && (d = $9d9c2a020ee1de94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9d9c2a020ee1de94$var$tc(g) : 0 !== f && (d = $9d9c2a020ee1de94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9d9c2a020ee1de94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9d9c2a020ee1de94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9d9c2a020ee1de94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9d9c2a020ee1de94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9d9c2a020ee1de94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9d9c2a020ee1de94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9d9c2a020ee1de94$var$yc() {
    var a = $9d9c2a020ee1de94$var$rc;
    $9d9c2a020ee1de94$var$rc <<= 1;
    0 === ($9d9c2a020ee1de94$var$rc & 4194240) && ($9d9c2a020ee1de94$var$rc = 64);
    return a;
}
function $9d9c2a020ee1de94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9d9c2a020ee1de94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9d9c2a020ee1de94$var$oc(b);
    a[b] = c;
}
function $9d9c2a020ee1de94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9d9c2a020ee1de94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9d9c2a020ee1de94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9d9c2a020ee1de94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9d9c2a020ee1de94$var$C = 0;
function $9d9c2a020ee1de94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9d9c2a020ee1de94$var$Ec, $9d9c2a020ee1de94$var$Fc, $9d9c2a020ee1de94$var$Gc, $9d9c2a020ee1de94$var$Hc, $9d9c2a020ee1de94$var$Ic, $9d9c2a020ee1de94$var$Jc = !1, $9d9c2a020ee1de94$var$Kc = [], $9d9c2a020ee1de94$var$Lc = null, $9d9c2a020ee1de94$var$Mc = null, $9d9c2a020ee1de94$var$Nc = null, $9d9c2a020ee1de94$var$Oc = new Map, $9d9c2a020ee1de94$var$Pc = new Map, $9d9c2a020ee1de94$var$Qc = [], $9d9c2a020ee1de94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9d9c2a020ee1de94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9d9c2a020ee1de94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9d9c2a020ee1de94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9d9c2a020ee1de94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9d9c2a020ee1de94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9d9c2a020ee1de94$var$Pc.delete(b.pointerId);
    }
}
function $9d9c2a020ee1de94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9d9c2a020ee1de94$var$Cb(b), null !== b && $9d9c2a020ee1de94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9d9c2a020ee1de94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9d9c2a020ee1de94$var$Lc = $9d9c2a020ee1de94$var$Tc($9d9c2a020ee1de94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9d9c2a020ee1de94$var$Mc = $9d9c2a020ee1de94$var$Tc($9d9c2a020ee1de94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9d9c2a020ee1de94$var$Nc = $9d9c2a020ee1de94$var$Tc($9d9c2a020ee1de94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9d9c2a020ee1de94$var$Oc.set(f, $9d9c2a020ee1de94$var$Tc($9d9c2a020ee1de94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9d9c2a020ee1de94$var$Pc.set(f, $9d9c2a020ee1de94$var$Tc($9d9c2a020ee1de94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9d9c2a020ee1de94$var$Vc(a) {
    var b = $9d9c2a020ee1de94$var$Wc(a.target);
    if (null !== b) {
        var c = $9d9c2a020ee1de94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9d9c2a020ee1de94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9d9c2a020ee1de94$var$Ic(a.priority, function() {
                        $9d9c2a020ee1de94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9d9c2a020ee1de94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9d9c2a020ee1de94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9d9c2a020ee1de94$var$wb = d;
            c.target.dispatchEvent(d);
            $9d9c2a020ee1de94$var$wb = null;
        } else return b = $9d9c2a020ee1de94$var$Cb(c), null !== b && $9d9c2a020ee1de94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9d9c2a020ee1de94$var$Zc(a, b, c) {
    $9d9c2a020ee1de94$var$Xc(a) && c.delete(b);
}
function $9d9c2a020ee1de94$var$$c() {
    $9d9c2a020ee1de94$var$Jc = !1;
    null !== $9d9c2a020ee1de94$var$Lc && $9d9c2a020ee1de94$var$Xc($9d9c2a020ee1de94$var$Lc) && ($9d9c2a020ee1de94$var$Lc = null);
    null !== $9d9c2a020ee1de94$var$Mc && $9d9c2a020ee1de94$var$Xc($9d9c2a020ee1de94$var$Mc) && ($9d9c2a020ee1de94$var$Mc = null);
    null !== $9d9c2a020ee1de94$var$Nc && $9d9c2a020ee1de94$var$Xc($9d9c2a020ee1de94$var$Nc) && ($9d9c2a020ee1de94$var$Nc = null);
    $9d9c2a020ee1de94$var$Oc.forEach($9d9c2a020ee1de94$var$Zc);
    $9d9c2a020ee1de94$var$Pc.forEach($9d9c2a020ee1de94$var$Zc);
}
function $9d9c2a020ee1de94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9d9c2a020ee1de94$var$Jc || ($9d9c2a020ee1de94$var$Jc = !0, $bKjPo.unstable_scheduleCallback($bKjPo.unstable_NormalPriority, $9d9c2a020ee1de94$var$$c)));
}
function $9d9c2a020ee1de94$var$bd(a) {
    function b(b) {
        return $9d9c2a020ee1de94$var$ad(b, a);
    }
    if (0 < $9d9c2a020ee1de94$var$Kc.length) {
        $9d9c2a020ee1de94$var$ad($9d9c2a020ee1de94$var$Kc[0], a);
        for(var c = 1; c < $9d9c2a020ee1de94$var$Kc.length; c++){
            var d = $9d9c2a020ee1de94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9d9c2a020ee1de94$var$Lc && $9d9c2a020ee1de94$var$ad($9d9c2a020ee1de94$var$Lc, a);
    null !== $9d9c2a020ee1de94$var$Mc && $9d9c2a020ee1de94$var$ad($9d9c2a020ee1de94$var$Mc, a);
    null !== $9d9c2a020ee1de94$var$Nc && $9d9c2a020ee1de94$var$ad($9d9c2a020ee1de94$var$Nc, a);
    $9d9c2a020ee1de94$var$Oc.forEach(b);
    $9d9c2a020ee1de94$var$Pc.forEach(b);
    for(c = 0; c < $9d9c2a020ee1de94$var$Qc.length; c++)d = $9d9c2a020ee1de94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9d9c2a020ee1de94$var$Qc.length && (c = $9d9c2a020ee1de94$var$Qc[0], null === c.blockedOn);)$9d9c2a020ee1de94$var$Vc(c), null === c.blockedOn && $9d9c2a020ee1de94$var$Qc.shift();
}
var $9d9c2a020ee1de94$var$cd = $9d9c2a020ee1de94$var$ua.ReactCurrentBatchConfig, $9d9c2a020ee1de94$var$dd = !0;
function $9d9c2a020ee1de94$var$ed(a, b, c, d) {
    var e = $9d9c2a020ee1de94$var$C, f = $9d9c2a020ee1de94$var$cd.transition;
    $9d9c2a020ee1de94$var$cd.transition = null;
    try {
        $9d9c2a020ee1de94$var$C = 1, $9d9c2a020ee1de94$var$fd(a, b, c, d);
    } finally{
        $9d9c2a020ee1de94$var$C = e, $9d9c2a020ee1de94$var$cd.transition = f;
    }
}
function $9d9c2a020ee1de94$var$gd(a, b, c, d) {
    var e = $9d9c2a020ee1de94$var$C, f = $9d9c2a020ee1de94$var$cd.transition;
    $9d9c2a020ee1de94$var$cd.transition = null;
    try {
        $9d9c2a020ee1de94$var$C = 4, $9d9c2a020ee1de94$var$fd(a, b, c, d);
    } finally{
        $9d9c2a020ee1de94$var$C = e, $9d9c2a020ee1de94$var$cd.transition = f;
    }
}
function $9d9c2a020ee1de94$var$fd(a, b, c, d) {
    if ($9d9c2a020ee1de94$var$dd) {
        var e = $9d9c2a020ee1de94$var$Yc(a, b, c, d);
        if (null === e) $9d9c2a020ee1de94$var$hd(a, b, d, $9d9c2a020ee1de94$var$id, c), $9d9c2a020ee1de94$var$Sc(a, d);
        else if ($9d9c2a020ee1de94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9d9c2a020ee1de94$var$Sc(a, d), b & 4 && -1 < $9d9c2a020ee1de94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9d9c2a020ee1de94$var$Cb(e);
                null !== f && $9d9c2a020ee1de94$var$Ec(f);
                f = $9d9c2a020ee1de94$var$Yc(a, b, c, d);
                null === f && $9d9c2a020ee1de94$var$hd(a, b, d, $9d9c2a020ee1de94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9d9c2a020ee1de94$var$hd(a, b, d, null, c);
    }
}
var $9d9c2a020ee1de94$var$id = null;
function $9d9c2a020ee1de94$var$Yc(a, b, c, d) {
    $9d9c2a020ee1de94$var$id = null;
    a = $9d9c2a020ee1de94$var$xb(d);
    a = $9d9c2a020ee1de94$var$Wc(a);
    if (null !== a) {
        if (b = $9d9c2a020ee1de94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9d9c2a020ee1de94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9d9c2a020ee1de94$var$id = a;
    return null;
}
function $9d9c2a020ee1de94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9d9c2a020ee1de94$var$ec()){
                case $9d9c2a020ee1de94$var$fc:
                    return 1;
                case $9d9c2a020ee1de94$var$gc:
                    return 4;
                case $9d9c2a020ee1de94$var$hc:
                case $9d9c2a020ee1de94$var$ic:
                    return 16;
                case $9d9c2a020ee1de94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9d9c2a020ee1de94$var$kd = null, $9d9c2a020ee1de94$var$ld = null, $9d9c2a020ee1de94$var$md = null;
function $9d9c2a020ee1de94$var$nd() {
    if ($9d9c2a020ee1de94$var$md) return $9d9c2a020ee1de94$var$md;
    var a, b = $9d9c2a020ee1de94$var$ld, c = b.length, d, e = "value" in $9d9c2a020ee1de94$var$kd ? $9d9c2a020ee1de94$var$kd.value : $9d9c2a020ee1de94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9d9c2a020ee1de94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9d9c2a020ee1de94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9d9c2a020ee1de94$var$pd() {
    return !0;
}
function $9d9c2a020ee1de94$var$qd() {
    return !1;
}
function $9d9c2a020ee1de94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9d9c2a020ee1de94$var$pd : $9d9c2a020ee1de94$var$qd;
        this.isPropagationStopped = $9d9c2a020ee1de94$var$qd;
        return this;
    }
    $9d9c2a020ee1de94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9d9c2a020ee1de94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9d9c2a020ee1de94$var$pd);
        },
        persist: function() {},
        isPersistent: $9d9c2a020ee1de94$var$pd
    });
    return b;
}
var $9d9c2a020ee1de94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9d9c2a020ee1de94$var$td = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$sd), $9d9c2a020ee1de94$var$ud = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$sd, {
    view: 0,
    detail: 0
}), $9d9c2a020ee1de94$var$vd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$ud), $9d9c2a020ee1de94$var$wd, $9d9c2a020ee1de94$var$xd, $9d9c2a020ee1de94$var$yd, $9d9c2a020ee1de94$var$Ad = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9d9c2a020ee1de94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9d9c2a020ee1de94$var$yd && ($9d9c2a020ee1de94$var$yd && "mousemove" === a.type ? ($9d9c2a020ee1de94$var$wd = a.screenX - $9d9c2a020ee1de94$var$yd.screenX, $9d9c2a020ee1de94$var$xd = a.screenY - $9d9c2a020ee1de94$var$yd.screenY) : $9d9c2a020ee1de94$var$xd = $9d9c2a020ee1de94$var$wd = 0, $9d9c2a020ee1de94$var$yd = a);
        return $9d9c2a020ee1de94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9d9c2a020ee1de94$var$xd;
    }
}), $9d9c2a020ee1de94$var$Bd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Ad), $9d9c2a020ee1de94$var$Cd = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$Ad, {
    dataTransfer: 0
}), $9d9c2a020ee1de94$var$Dd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Cd), $9d9c2a020ee1de94$var$Ed = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$ud, {
    relatedTarget: 0
}), $9d9c2a020ee1de94$var$Fd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Ed), $9d9c2a020ee1de94$var$Gd = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9d9c2a020ee1de94$var$Hd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Gd), $9d9c2a020ee1de94$var$Id = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9d9c2a020ee1de94$var$Jd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Id), $9d9c2a020ee1de94$var$Kd = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$sd, {
    data: 0
}), $9d9c2a020ee1de94$var$Ld = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Kd), $9d9c2a020ee1de94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9d9c2a020ee1de94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9d9c2a020ee1de94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9d9c2a020ee1de94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9d9c2a020ee1de94$var$Od[a]) ? !!b[a] : !1;
}
function $9d9c2a020ee1de94$var$zd() {
    return $9d9c2a020ee1de94$var$Pd;
}
var $9d9c2a020ee1de94$var$Qd = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9d9c2a020ee1de94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9d9c2a020ee1de94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9d9c2a020ee1de94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9d9c2a020ee1de94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9d9c2a020ee1de94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9d9c2a020ee1de94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9d9c2a020ee1de94$var$Rd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Qd), $9d9c2a020ee1de94$var$Sd = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9d9c2a020ee1de94$var$Td = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Sd), $9d9c2a020ee1de94$var$Ud = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9d9c2a020ee1de94$var$zd
}), $9d9c2a020ee1de94$var$Vd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Ud), $9d9c2a020ee1de94$var$Wd = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9d9c2a020ee1de94$var$Xd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Wd), $9d9c2a020ee1de94$var$Yd = $9d9c2a020ee1de94$var$A({}, $9d9c2a020ee1de94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9d9c2a020ee1de94$var$Zd = $9d9c2a020ee1de94$var$rd($9d9c2a020ee1de94$var$Yd), $9d9c2a020ee1de94$var$$d = [
    9,
    13,
    27,
    32
], $9d9c2a020ee1de94$var$ae = $9d9c2a020ee1de94$var$ia && "CompositionEvent" in window, $9d9c2a020ee1de94$var$be = null;
$9d9c2a020ee1de94$var$ia && "documentMode" in document && ($9d9c2a020ee1de94$var$be = document.documentMode);
var $9d9c2a020ee1de94$var$ce = $9d9c2a020ee1de94$var$ia && "TextEvent" in window && !$9d9c2a020ee1de94$var$be, $9d9c2a020ee1de94$var$de = $9d9c2a020ee1de94$var$ia && (!$9d9c2a020ee1de94$var$ae || $9d9c2a020ee1de94$var$be && 8 < $9d9c2a020ee1de94$var$be && 11 >= $9d9c2a020ee1de94$var$be), $9d9c2a020ee1de94$var$ee = String.fromCharCode(32), $9d9c2a020ee1de94$var$fe = !1;
function $9d9c2a020ee1de94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9d9c2a020ee1de94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9d9c2a020ee1de94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9d9c2a020ee1de94$var$ie = !1;
function $9d9c2a020ee1de94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9d9c2a020ee1de94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9d9c2a020ee1de94$var$fe = !0;
            return $9d9c2a020ee1de94$var$ee;
        case "textInput":
            return a = b.data, a === $9d9c2a020ee1de94$var$ee && $9d9c2a020ee1de94$var$fe ? null : a;
        default:
            return null;
    }
}
function $9d9c2a020ee1de94$var$ke(a, b) {
    if ($9d9c2a020ee1de94$var$ie) return "compositionend" === a || !$9d9c2a020ee1de94$var$ae && $9d9c2a020ee1de94$var$ge(a, b) ? (a = $9d9c2a020ee1de94$var$nd(), $9d9c2a020ee1de94$var$md = $9d9c2a020ee1de94$var$ld = $9d9c2a020ee1de94$var$kd = null, $9d9c2a020ee1de94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9d9c2a020ee1de94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9d9c2a020ee1de94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9d9c2a020ee1de94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9d9c2a020ee1de94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9d9c2a020ee1de94$var$ne(a, b, c, d) {
    $9d9c2a020ee1de94$var$Eb(d);
    b = $9d9c2a020ee1de94$var$oe(b, "onChange");
    0 < b.length && (c = new $9d9c2a020ee1de94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9d9c2a020ee1de94$var$pe = null, $9d9c2a020ee1de94$var$qe = null;
function $9d9c2a020ee1de94$var$re(a) {
    $9d9c2a020ee1de94$var$se(a, 0);
}
function $9d9c2a020ee1de94$var$te(a) {
    var b = $9d9c2a020ee1de94$var$ue(a);
    if ($9d9c2a020ee1de94$var$Wa(b)) return a;
}
function $9d9c2a020ee1de94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9d9c2a020ee1de94$var$we = !1;
if ($9d9c2a020ee1de94$var$ia) {
    var $9d9c2a020ee1de94$var$xe;
    if ($9d9c2a020ee1de94$var$ia) {
        var $9d9c2a020ee1de94$var$ye = "oninput" in document;
        if (!$9d9c2a020ee1de94$var$ye) {
            var $9d9c2a020ee1de94$var$ze = document.createElement("div");
            $9d9c2a020ee1de94$var$ze.setAttribute("oninput", "return;");
            $9d9c2a020ee1de94$var$ye = "function" === typeof $9d9c2a020ee1de94$var$ze.oninput;
        }
        $9d9c2a020ee1de94$var$xe = $9d9c2a020ee1de94$var$ye;
    } else $9d9c2a020ee1de94$var$xe = !1;
    $9d9c2a020ee1de94$var$we = $9d9c2a020ee1de94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9d9c2a020ee1de94$var$Ae() {
    $9d9c2a020ee1de94$var$pe && ($9d9c2a020ee1de94$var$pe.detachEvent("onpropertychange", $9d9c2a020ee1de94$var$Be), $9d9c2a020ee1de94$var$qe = $9d9c2a020ee1de94$var$pe = null);
}
function $9d9c2a020ee1de94$var$Be(a) {
    if ("value" === a.propertyName && $9d9c2a020ee1de94$var$te($9d9c2a020ee1de94$var$qe)) {
        var b = [];
        $9d9c2a020ee1de94$var$ne(b, $9d9c2a020ee1de94$var$qe, a, $9d9c2a020ee1de94$var$xb(a));
        $9d9c2a020ee1de94$var$Jb($9d9c2a020ee1de94$var$re, b);
    }
}
function $9d9c2a020ee1de94$var$Ce(a, b, c) {
    "focusin" === a ? ($9d9c2a020ee1de94$var$Ae(), $9d9c2a020ee1de94$var$pe = b, $9d9c2a020ee1de94$var$qe = c, $9d9c2a020ee1de94$var$pe.attachEvent("onpropertychange", $9d9c2a020ee1de94$var$Be)) : "focusout" === a && $9d9c2a020ee1de94$var$Ae();
}
function $9d9c2a020ee1de94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9d9c2a020ee1de94$var$te($9d9c2a020ee1de94$var$qe);
}
function $9d9c2a020ee1de94$var$Ee(a, b) {
    if ("click" === a) return $9d9c2a020ee1de94$var$te(b);
}
function $9d9c2a020ee1de94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9d9c2a020ee1de94$var$te(b);
}
function $9d9c2a020ee1de94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9d9c2a020ee1de94$var$He = "function" === typeof Object.is ? Object.is : $9d9c2a020ee1de94$var$Ge;
function $9d9c2a020ee1de94$var$Ie(a, b) {
    if ($9d9c2a020ee1de94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9d9c2a020ee1de94$var$ja.call(b, e) || !$9d9c2a020ee1de94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9d9c2a020ee1de94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9d9c2a020ee1de94$var$Ke(a, b) {
    var c = $9d9c2a020ee1de94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9d9c2a020ee1de94$var$Je(c);
    }
}
function $9d9c2a020ee1de94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9d9c2a020ee1de94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9d9c2a020ee1de94$var$Me() {
    for(var a = window, b = $9d9c2a020ee1de94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9d9c2a020ee1de94$var$Xa(a.document);
    }
    return b;
}
function $9d9c2a020ee1de94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9d9c2a020ee1de94$var$Oe(a) {
    var b = $9d9c2a020ee1de94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9d9c2a020ee1de94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9d9c2a020ee1de94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9d9c2a020ee1de94$var$Ke(c, f);
                var g = $9d9c2a020ee1de94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9d9c2a020ee1de94$var$Pe = $9d9c2a020ee1de94$var$ia && "documentMode" in document && 11 >= document.documentMode, $9d9c2a020ee1de94$var$Qe = null, $9d9c2a020ee1de94$var$Re = null, $9d9c2a020ee1de94$var$Se = null, $9d9c2a020ee1de94$var$Te = !1;
function $9d9c2a020ee1de94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9d9c2a020ee1de94$var$Te || null == $9d9c2a020ee1de94$var$Qe || $9d9c2a020ee1de94$var$Qe !== $9d9c2a020ee1de94$var$Xa(d) || (d = $9d9c2a020ee1de94$var$Qe, "selectionStart" in d && $9d9c2a020ee1de94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9d9c2a020ee1de94$var$Se && $9d9c2a020ee1de94$var$Ie($9d9c2a020ee1de94$var$Se, d) || ($9d9c2a020ee1de94$var$Se = d, d = $9d9c2a020ee1de94$var$oe($9d9c2a020ee1de94$var$Re, "onSelect"), 0 < d.length && (b = new $9d9c2a020ee1de94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9d9c2a020ee1de94$var$Qe)));
}
function $9d9c2a020ee1de94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9d9c2a020ee1de94$var$We = {
    animationend: $9d9c2a020ee1de94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9d9c2a020ee1de94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9d9c2a020ee1de94$var$Ve("Animation", "AnimationStart"),
    transitionend: $9d9c2a020ee1de94$var$Ve("Transition", "TransitionEnd")
}, $9d9c2a020ee1de94$var$Xe = {}, $9d9c2a020ee1de94$var$Ye = {};
$9d9c2a020ee1de94$var$ia && ($9d9c2a020ee1de94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9d9c2a020ee1de94$var$We.animationend.animation, delete $9d9c2a020ee1de94$var$We.animationiteration.animation, delete $9d9c2a020ee1de94$var$We.animationstart.animation), "TransitionEvent" in window || delete $9d9c2a020ee1de94$var$We.transitionend.transition);
function $9d9c2a020ee1de94$var$Ze(a) {
    if ($9d9c2a020ee1de94$var$Xe[a]) return $9d9c2a020ee1de94$var$Xe[a];
    if (!$9d9c2a020ee1de94$var$We[a]) return a;
    var b = $9d9c2a020ee1de94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9d9c2a020ee1de94$var$Ye) return $9d9c2a020ee1de94$var$Xe[a] = b[c];
    return a;
}
var $9d9c2a020ee1de94$var$$e = $9d9c2a020ee1de94$var$Ze("animationend"), $9d9c2a020ee1de94$var$af = $9d9c2a020ee1de94$var$Ze("animationiteration"), $9d9c2a020ee1de94$var$bf = $9d9c2a020ee1de94$var$Ze("animationstart"), $9d9c2a020ee1de94$var$cf = $9d9c2a020ee1de94$var$Ze("transitionend"), $9d9c2a020ee1de94$var$df = new Map, $9d9c2a020ee1de94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9d9c2a020ee1de94$var$ff(a, b) {
    $9d9c2a020ee1de94$var$df.set(a, b);
    $9d9c2a020ee1de94$var$fa(b, [
        a
    ]);
}
for(var $9d9c2a020ee1de94$var$gf = 0; $9d9c2a020ee1de94$var$gf < $9d9c2a020ee1de94$var$ef.length; $9d9c2a020ee1de94$var$gf++){
    var $9d9c2a020ee1de94$var$hf = $9d9c2a020ee1de94$var$ef[$9d9c2a020ee1de94$var$gf], $9d9c2a020ee1de94$var$jf = $9d9c2a020ee1de94$var$hf.toLowerCase(), $9d9c2a020ee1de94$var$kf = $9d9c2a020ee1de94$var$hf[0].toUpperCase() + $9d9c2a020ee1de94$var$hf.slice(1);
    $9d9c2a020ee1de94$var$ff($9d9c2a020ee1de94$var$jf, "on" + $9d9c2a020ee1de94$var$kf);
}
$9d9c2a020ee1de94$var$ff($9d9c2a020ee1de94$var$$e, "onAnimationEnd");
$9d9c2a020ee1de94$var$ff($9d9c2a020ee1de94$var$af, "onAnimationIteration");
$9d9c2a020ee1de94$var$ff($9d9c2a020ee1de94$var$bf, "onAnimationStart");
$9d9c2a020ee1de94$var$ff("dblclick", "onDoubleClick");
$9d9c2a020ee1de94$var$ff("focusin", "onFocus");
$9d9c2a020ee1de94$var$ff("focusout", "onBlur");
$9d9c2a020ee1de94$var$ff($9d9c2a020ee1de94$var$cf, "onTransitionEnd");
$9d9c2a020ee1de94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9d9c2a020ee1de94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9d9c2a020ee1de94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9d9c2a020ee1de94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9d9c2a020ee1de94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9d9c2a020ee1de94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9d9c2a020ee1de94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9d9c2a020ee1de94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9d9c2a020ee1de94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9d9c2a020ee1de94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9d9c2a020ee1de94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9d9c2a020ee1de94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9d9c2a020ee1de94$var$lf));
function $9d9c2a020ee1de94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9d9c2a020ee1de94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9d9c2a020ee1de94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9d9c2a020ee1de94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9d9c2a020ee1de94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9d9c2a020ee1de94$var$Qb) throw a = $9d9c2a020ee1de94$var$Rb, $9d9c2a020ee1de94$var$Qb = !1, $9d9c2a020ee1de94$var$Rb = null, a;
}
function $9d9c2a020ee1de94$var$D(a, b) {
    var c = b[$9d9c2a020ee1de94$var$of];
    void 0 === c && (c = b[$9d9c2a020ee1de94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9d9c2a020ee1de94$var$pf(b, a, 2, !1), c.add(d));
}
function $9d9c2a020ee1de94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9d9c2a020ee1de94$var$pf(c, a, d, b);
}
var $9d9c2a020ee1de94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9d9c2a020ee1de94$var$sf(a) {
    if (!a[$9d9c2a020ee1de94$var$rf]) {
        a[$9d9c2a020ee1de94$var$rf] = !0;
        $9d9c2a020ee1de94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9d9c2a020ee1de94$var$mf.has(b) || $9d9c2a020ee1de94$var$qf(b, !1, a), $9d9c2a020ee1de94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9d9c2a020ee1de94$var$rf] || (b[$9d9c2a020ee1de94$var$rf] = !0, $9d9c2a020ee1de94$var$qf("selectionchange", !1, b));
    }
}
function $9d9c2a020ee1de94$var$pf(a, b, c, d) {
    switch($9d9c2a020ee1de94$var$jd(b)){
        case 1:
            var e = $9d9c2a020ee1de94$var$ed;
            break;
        case 4:
            e = $9d9c2a020ee1de94$var$gd;
            break;
        default:
            e = $9d9c2a020ee1de94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9d9c2a020ee1de94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9d9c2a020ee1de94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9d9c2a020ee1de94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9d9c2a020ee1de94$var$Jb(function() {
        var d = f, e = $9d9c2a020ee1de94$var$xb(c), g = [];
        a: {
            var h = $9d9c2a020ee1de94$var$df.get(a);
            if (void 0 !== h) {
                var k = $9d9c2a020ee1de94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9d9c2a020ee1de94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9d9c2a020ee1de94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9d9c2a020ee1de94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9d9c2a020ee1de94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9d9c2a020ee1de94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9d9c2a020ee1de94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9d9c2a020ee1de94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9d9c2a020ee1de94$var$Vd;
                        break;
                    case $9d9c2a020ee1de94$var$$e:
                    case $9d9c2a020ee1de94$var$af:
                    case $9d9c2a020ee1de94$var$bf:
                        k = $9d9c2a020ee1de94$var$Hd;
                        break;
                    case $9d9c2a020ee1de94$var$cf:
                        k = $9d9c2a020ee1de94$var$Xd;
                        break;
                    case "scroll":
                        k = $9d9c2a020ee1de94$var$vd;
                        break;
                    case "wheel":
                        k = $9d9c2a020ee1de94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9d9c2a020ee1de94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9d9c2a020ee1de94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9d9c2a020ee1de94$var$Kb(w, x), null != F && t.push($9d9c2a020ee1de94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9d9c2a020ee1de94$var$wb && (n = c.relatedTarget || c.fromElement) && ($9d9c2a020ee1de94$var$Wc(n) || n[$9d9c2a020ee1de94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9d9c2a020ee1de94$var$Wc(n) : null, null !== n && (J = $9d9c2a020ee1de94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9d9c2a020ee1de94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9d9c2a020ee1de94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9d9c2a020ee1de94$var$ue(k);
                        u = null == n ? h : $9d9c2a020ee1de94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9d9c2a020ee1de94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9d9c2a020ee1de94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9d9c2a020ee1de94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9d9c2a020ee1de94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9d9c2a020ee1de94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9d9c2a020ee1de94$var$vf(t);
                                x = $9d9c2a020ee1de94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9d9c2a020ee1de94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9d9c2a020ee1de94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9d9c2a020ee1de94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9d9c2a020ee1de94$var$ve;
                else if ($9d9c2a020ee1de94$var$me(h)) {
                    if ($9d9c2a020ee1de94$var$we) na = $9d9c2a020ee1de94$var$Fe;
                    else {
                        na = $9d9c2a020ee1de94$var$De;
                        var xa = $9d9c2a020ee1de94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9d9c2a020ee1de94$var$Ee);
                if (na && (na = na(a, d))) {
                    $9d9c2a020ee1de94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9d9c2a020ee1de94$var$cb(h, "number", h.value);
            }
            xa = d ? $9d9c2a020ee1de94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9d9c2a020ee1de94$var$me(xa) || "true" === xa.contentEditable) $9d9c2a020ee1de94$var$Qe = xa, $9d9c2a020ee1de94$var$Re = d, $9d9c2a020ee1de94$var$Se = null;
                    break;
                case "focusout":
                    $9d9c2a020ee1de94$var$Se = $9d9c2a020ee1de94$var$Re = $9d9c2a020ee1de94$var$Qe = null;
                    break;
                case "mousedown":
                    $9d9c2a020ee1de94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9d9c2a020ee1de94$var$Te = !1;
                    $9d9c2a020ee1de94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9d9c2a020ee1de94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9d9c2a020ee1de94$var$Ue(g, c, e);
            }
            var $a;
            if ($9d9c2a020ee1de94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9d9c2a020ee1de94$var$ie ? $9d9c2a020ee1de94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9d9c2a020ee1de94$var$de && "ko" !== c.locale && ($9d9c2a020ee1de94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9d9c2a020ee1de94$var$ie && ($a = $9d9c2a020ee1de94$var$nd()) : ($9d9c2a020ee1de94$var$kd = e, $9d9c2a020ee1de94$var$ld = "value" in $9d9c2a020ee1de94$var$kd ? $9d9c2a020ee1de94$var$kd.value : $9d9c2a020ee1de94$var$kd.textContent, $9d9c2a020ee1de94$var$ie = !0)), xa = $9d9c2a020ee1de94$var$oe(d, ba), 0 < xa.length && (ba = new $9d9c2a020ee1de94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9d9c2a020ee1de94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9d9c2a020ee1de94$var$ce ? $9d9c2a020ee1de94$var$je(a, c) : $9d9c2a020ee1de94$var$ke(a, c)) d = $9d9c2a020ee1de94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9d9c2a020ee1de94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9d9c2a020ee1de94$var$se(g, b);
    });
}
function $9d9c2a020ee1de94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9d9c2a020ee1de94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9d9c2a020ee1de94$var$Kb(a, c), null != f && d.unshift($9d9c2a020ee1de94$var$tf(a, f, e)), f = $9d9c2a020ee1de94$var$Kb(a, b), null != f && d.push($9d9c2a020ee1de94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9d9c2a020ee1de94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9d9c2a020ee1de94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9d9c2a020ee1de94$var$Kb(c, f), null != k && g.unshift($9d9c2a020ee1de94$var$tf(c, k, h))) : e || (k = $9d9c2a020ee1de94$var$Kb(c, f), null != k && g.push($9d9c2a020ee1de94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9d9c2a020ee1de94$var$xf = /\r\n?/g, $9d9c2a020ee1de94$var$yf = /\u0000|\uFFFD/g;
function $9d9c2a020ee1de94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9d9c2a020ee1de94$var$xf, "\n").replace($9d9c2a020ee1de94$var$yf, "");
}
function $9d9c2a020ee1de94$var$Af(a, b, c) {
    b = $9d9c2a020ee1de94$var$zf(b);
    if ($9d9c2a020ee1de94$var$zf(a) !== b && c) throw Error($9d9c2a020ee1de94$var$p(425));
}
function $9d9c2a020ee1de94$var$Bf() {}
var $9d9c2a020ee1de94$var$Cf = null, $9d9c2a020ee1de94$var$Df = null;
function $9d9c2a020ee1de94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9d9c2a020ee1de94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9d9c2a020ee1de94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9d9c2a020ee1de94$var$Hf = "function" === typeof Promise ? Promise : void 0, $9d9c2a020ee1de94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9d9c2a020ee1de94$var$Hf ? function(a) {
    return $9d9c2a020ee1de94$var$Hf.resolve(null).then(a).catch($9d9c2a020ee1de94$var$If);
} : $9d9c2a020ee1de94$var$Ff;
function $9d9c2a020ee1de94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9d9c2a020ee1de94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9d9c2a020ee1de94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9d9c2a020ee1de94$var$bd(b);
}
function $9d9c2a020ee1de94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9d9c2a020ee1de94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9d9c2a020ee1de94$var$Nf = Math.random().toString(36).slice(2), $9d9c2a020ee1de94$var$Of = "__reactFiber$" + $9d9c2a020ee1de94$var$Nf, $9d9c2a020ee1de94$var$Pf = "__reactProps$" + $9d9c2a020ee1de94$var$Nf, $9d9c2a020ee1de94$var$uf = "__reactContainer$" + $9d9c2a020ee1de94$var$Nf, $9d9c2a020ee1de94$var$of = "__reactEvents$" + $9d9c2a020ee1de94$var$Nf, $9d9c2a020ee1de94$var$Qf = "__reactListeners$" + $9d9c2a020ee1de94$var$Nf, $9d9c2a020ee1de94$var$Rf = "__reactHandles$" + $9d9c2a020ee1de94$var$Nf;
function $9d9c2a020ee1de94$var$Wc(a) {
    var b = a[$9d9c2a020ee1de94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9d9c2a020ee1de94$var$uf] || c[$9d9c2a020ee1de94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9d9c2a020ee1de94$var$Mf(a); null !== a;){
                if (c = a[$9d9c2a020ee1de94$var$Of]) return c;
                a = $9d9c2a020ee1de94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9d9c2a020ee1de94$var$Cb(a) {
    a = a[$9d9c2a020ee1de94$var$Of] || a[$9d9c2a020ee1de94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9d9c2a020ee1de94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9d9c2a020ee1de94$var$p(33));
}
function $9d9c2a020ee1de94$var$Db(a) {
    return a[$9d9c2a020ee1de94$var$Pf] || null;
}
var $9d9c2a020ee1de94$var$Sf = [], $9d9c2a020ee1de94$var$Tf = -1;
function $9d9c2a020ee1de94$var$Uf(a) {
    return {
        current: a
    };
}
function $9d9c2a020ee1de94$var$E(a) {
    0 > $9d9c2a020ee1de94$var$Tf || (a.current = $9d9c2a020ee1de94$var$Sf[$9d9c2a020ee1de94$var$Tf], $9d9c2a020ee1de94$var$Sf[$9d9c2a020ee1de94$var$Tf] = null, $9d9c2a020ee1de94$var$Tf--);
}
function $9d9c2a020ee1de94$var$G(a, b) {
    $9d9c2a020ee1de94$var$Tf++;
    $9d9c2a020ee1de94$var$Sf[$9d9c2a020ee1de94$var$Tf] = a.current;
    a.current = b;
}
var $9d9c2a020ee1de94$var$Vf = {}, $9d9c2a020ee1de94$var$H = $9d9c2a020ee1de94$var$Uf($9d9c2a020ee1de94$var$Vf), $9d9c2a020ee1de94$var$Wf = $9d9c2a020ee1de94$var$Uf(!1), $9d9c2a020ee1de94$var$Xf = $9d9c2a020ee1de94$var$Vf;
function $9d9c2a020ee1de94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9d9c2a020ee1de94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9d9c2a020ee1de94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9d9c2a020ee1de94$var$$f() {
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$Wf);
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$H);
}
function $9d9c2a020ee1de94$var$ag(a, b, c) {
    if ($9d9c2a020ee1de94$var$H.current !== $9d9c2a020ee1de94$var$Vf) throw Error($9d9c2a020ee1de94$var$p(168));
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$H, b);
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$Wf, c);
}
function $9d9c2a020ee1de94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9d9c2a020ee1de94$var$p(108, $9d9c2a020ee1de94$var$Ra(a) || "Unknown", e));
    return $9d9c2a020ee1de94$var$A({}, c, d);
}
function $9d9c2a020ee1de94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9d9c2a020ee1de94$var$Vf;
    $9d9c2a020ee1de94$var$Xf = $9d9c2a020ee1de94$var$H.current;
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$H, a);
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$Wf, $9d9c2a020ee1de94$var$Wf.current);
    return !0;
}
function $9d9c2a020ee1de94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9d9c2a020ee1de94$var$p(169));
    c ? (a = $9d9c2a020ee1de94$var$bg(a, b, $9d9c2a020ee1de94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$Wf), $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$H), $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$H, a)) : $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$Wf);
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$Wf, c);
}
var $9d9c2a020ee1de94$var$eg = null, $9d9c2a020ee1de94$var$fg = !1, $9d9c2a020ee1de94$var$gg = !1;
function $9d9c2a020ee1de94$var$hg(a) {
    null === $9d9c2a020ee1de94$var$eg ? $9d9c2a020ee1de94$var$eg = [
        a
    ] : $9d9c2a020ee1de94$var$eg.push(a);
}
function $9d9c2a020ee1de94$var$ig(a) {
    $9d9c2a020ee1de94$var$fg = !0;
    $9d9c2a020ee1de94$var$hg(a);
}
function $9d9c2a020ee1de94$var$jg() {
    if (!$9d9c2a020ee1de94$var$gg && null !== $9d9c2a020ee1de94$var$eg) {
        $9d9c2a020ee1de94$var$gg = !0;
        var a = 0, b = $9d9c2a020ee1de94$var$C;
        try {
            var c = $9d9c2a020ee1de94$var$eg;
            for($9d9c2a020ee1de94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9d9c2a020ee1de94$var$eg = null;
            $9d9c2a020ee1de94$var$fg = !1;
        } catch (e) {
            throw null !== $9d9c2a020ee1de94$var$eg && ($9d9c2a020ee1de94$var$eg = $9d9c2a020ee1de94$var$eg.slice(a + 1)), $9d9c2a020ee1de94$var$ac($9d9c2a020ee1de94$var$fc, $9d9c2a020ee1de94$var$jg), e;
        } finally{
            $9d9c2a020ee1de94$var$C = b, $9d9c2a020ee1de94$var$gg = !1;
        }
    }
    return null;
}
var $9d9c2a020ee1de94$var$kg = [], $9d9c2a020ee1de94$var$lg = 0, $9d9c2a020ee1de94$var$mg = null, $9d9c2a020ee1de94$var$ng = 0, $9d9c2a020ee1de94$var$og = [], $9d9c2a020ee1de94$var$pg = 0, $9d9c2a020ee1de94$var$qg = null, $9d9c2a020ee1de94$var$rg = 1, $9d9c2a020ee1de94$var$sg = "";
function $9d9c2a020ee1de94$var$tg(a, b) {
    $9d9c2a020ee1de94$var$kg[$9d9c2a020ee1de94$var$lg++] = $9d9c2a020ee1de94$var$ng;
    $9d9c2a020ee1de94$var$kg[$9d9c2a020ee1de94$var$lg++] = $9d9c2a020ee1de94$var$mg;
    $9d9c2a020ee1de94$var$mg = a;
    $9d9c2a020ee1de94$var$ng = b;
}
function $9d9c2a020ee1de94$var$ug(a, b, c) {
    $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg++] = $9d9c2a020ee1de94$var$rg;
    $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg++] = $9d9c2a020ee1de94$var$sg;
    $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg++] = $9d9c2a020ee1de94$var$qg;
    $9d9c2a020ee1de94$var$qg = a;
    var d = $9d9c2a020ee1de94$var$rg;
    a = $9d9c2a020ee1de94$var$sg;
    var e = 32 - $9d9c2a020ee1de94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9d9c2a020ee1de94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9d9c2a020ee1de94$var$rg = 1 << 32 - $9d9c2a020ee1de94$var$oc(b) + e | c << e | d;
        $9d9c2a020ee1de94$var$sg = f + a;
    } else $9d9c2a020ee1de94$var$rg = 1 << f | c << e | d, $9d9c2a020ee1de94$var$sg = a;
}
function $9d9c2a020ee1de94$var$vg(a) {
    null !== a.return && ($9d9c2a020ee1de94$var$tg(a, 1), $9d9c2a020ee1de94$var$ug(a, 1, 0));
}
function $9d9c2a020ee1de94$var$wg(a) {
    for(; a === $9d9c2a020ee1de94$var$mg;)$9d9c2a020ee1de94$var$mg = $9d9c2a020ee1de94$var$kg[--$9d9c2a020ee1de94$var$lg], $9d9c2a020ee1de94$var$kg[$9d9c2a020ee1de94$var$lg] = null, $9d9c2a020ee1de94$var$ng = $9d9c2a020ee1de94$var$kg[--$9d9c2a020ee1de94$var$lg], $9d9c2a020ee1de94$var$kg[$9d9c2a020ee1de94$var$lg] = null;
    for(; a === $9d9c2a020ee1de94$var$qg;)$9d9c2a020ee1de94$var$qg = $9d9c2a020ee1de94$var$og[--$9d9c2a020ee1de94$var$pg], $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg] = null, $9d9c2a020ee1de94$var$sg = $9d9c2a020ee1de94$var$og[--$9d9c2a020ee1de94$var$pg], $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg] = null, $9d9c2a020ee1de94$var$rg = $9d9c2a020ee1de94$var$og[--$9d9c2a020ee1de94$var$pg], $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg] = null;
}
var $9d9c2a020ee1de94$var$xg = null, $9d9c2a020ee1de94$var$yg = null, $9d9c2a020ee1de94$var$I = !1, $9d9c2a020ee1de94$var$zg = null;
function $9d9c2a020ee1de94$var$Ag(a, b) {
    var c = $9d9c2a020ee1de94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9d9c2a020ee1de94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9d9c2a020ee1de94$var$xg = a, $9d9c2a020ee1de94$var$yg = $9d9c2a020ee1de94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9d9c2a020ee1de94$var$xg = a, $9d9c2a020ee1de94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9d9c2a020ee1de94$var$qg ? {
                id: $9d9c2a020ee1de94$var$rg,
                overflow: $9d9c2a020ee1de94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9d9c2a020ee1de94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9d9c2a020ee1de94$var$xg = a, $9d9c2a020ee1de94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9d9c2a020ee1de94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9d9c2a020ee1de94$var$Eg(a) {
    if ($9d9c2a020ee1de94$var$I) {
        var b = $9d9c2a020ee1de94$var$yg;
        if (b) {
            var c = b;
            if (!$9d9c2a020ee1de94$var$Cg(a, b)) {
                if ($9d9c2a020ee1de94$var$Dg(a)) throw Error($9d9c2a020ee1de94$var$p(418));
                b = $9d9c2a020ee1de94$var$Lf(c.nextSibling);
                var d = $9d9c2a020ee1de94$var$xg;
                b && $9d9c2a020ee1de94$var$Cg(a, b) ? $9d9c2a020ee1de94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9d9c2a020ee1de94$var$I = !1, $9d9c2a020ee1de94$var$xg = a);
            }
        } else {
            if ($9d9c2a020ee1de94$var$Dg(a)) throw Error($9d9c2a020ee1de94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9d9c2a020ee1de94$var$I = !1;
            $9d9c2a020ee1de94$var$xg = a;
        }
    }
}
function $9d9c2a020ee1de94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9d9c2a020ee1de94$var$xg = a;
}
function $9d9c2a020ee1de94$var$Gg(a) {
    if (a !== $9d9c2a020ee1de94$var$xg) return !1;
    if (!$9d9c2a020ee1de94$var$I) return $9d9c2a020ee1de94$var$Fg(a), $9d9c2a020ee1de94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9d9c2a020ee1de94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9d9c2a020ee1de94$var$yg)) {
        if ($9d9c2a020ee1de94$var$Dg(a)) throw $9d9c2a020ee1de94$var$Hg(), Error($9d9c2a020ee1de94$var$p(418));
        for(; b;)$9d9c2a020ee1de94$var$Ag(a, b), b = $9d9c2a020ee1de94$var$Lf(b.nextSibling);
    }
    $9d9c2a020ee1de94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9d9c2a020ee1de94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9d9c2a020ee1de94$var$yg = $9d9c2a020ee1de94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9d9c2a020ee1de94$var$yg = null;
        }
    } else $9d9c2a020ee1de94$var$yg = $9d9c2a020ee1de94$var$xg ? $9d9c2a020ee1de94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9d9c2a020ee1de94$var$Hg() {
    for(var a = $9d9c2a020ee1de94$var$yg; a;)a = $9d9c2a020ee1de94$var$Lf(a.nextSibling);
}
function $9d9c2a020ee1de94$var$Ig() {
    $9d9c2a020ee1de94$var$yg = $9d9c2a020ee1de94$var$xg = null;
    $9d9c2a020ee1de94$var$I = !1;
}
function $9d9c2a020ee1de94$var$Jg(a) {
    null === $9d9c2a020ee1de94$var$zg ? $9d9c2a020ee1de94$var$zg = [
        a
    ] : $9d9c2a020ee1de94$var$zg.push(a);
}
var $9d9c2a020ee1de94$var$Kg = $9d9c2a020ee1de94$var$ua.ReactCurrentBatchConfig;
function $9d9c2a020ee1de94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9d9c2a020ee1de94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9d9c2a020ee1de94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9d9c2a020ee1de94$var$p(284));
        if (!c._owner) throw Error($9d9c2a020ee1de94$var$p(290, a));
    }
    return a;
}
function $9d9c2a020ee1de94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9d9c2a020ee1de94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9d9c2a020ee1de94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $9d9c2a020ee1de94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9d9c2a020ee1de94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9d9c2a020ee1de94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9d9c2a020ee1de94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9d9c2a020ee1de94$var$Ha && $9d9c2a020ee1de94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $9d9c2a020ee1de94$var$Lg(a, b, c), d.return = a, d;
        d = $9d9c2a020ee1de94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9d9c2a020ee1de94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9d9c2a020ee1de94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9d9c2a020ee1de94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9d9c2a020ee1de94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9d9c2a020ee1de94$var$va:
                    return c = $9d9c2a020ee1de94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $9d9c2a020ee1de94$var$Lg(a, null, b), c.return = a, c;
                case $9d9c2a020ee1de94$var$wa:
                    return b = $9d9c2a020ee1de94$var$Sg(b, a.mode, c), b.return = a, b;
                case $9d9c2a020ee1de94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9d9c2a020ee1de94$var$eb(b) || $9d9c2a020ee1de94$var$Ka(b)) return b = $9d9c2a020ee1de94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $9d9c2a020ee1de94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9d9c2a020ee1de94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9d9c2a020ee1de94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9d9c2a020ee1de94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9d9c2a020ee1de94$var$eb(c) || $9d9c2a020ee1de94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9d9c2a020ee1de94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9d9c2a020ee1de94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9d9c2a020ee1de94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9d9c2a020ee1de94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9d9c2a020ee1de94$var$eb(d) || $9d9c2a020ee1de94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9d9c2a020ee1de94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9d9c2a020ee1de94$var$I && $9d9c2a020ee1de94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9d9c2a020ee1de94$var$I && $9d9c2a020ee1de94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9d9c2a020ee1de94$var$I && $9d9c2a020ee1de94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9d9c2a020ee1de94$var$Ka(h);
        if ("function" !== typeof l) throw Error($9d9c2a020ee1de94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9d9c2a020ee1de94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9d9c2a020ee1de94$var$I && $9d9c2a020ee1de94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9d9c2a020ee1de94$var$I && $9d9c2a020ee1de94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9d9c2a020ee1de94$var$I && $9d9c2a020ee1de94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9d9c2a020ee1de94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9d9c2a020ee1de94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9d9c2a020ee1de94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9d9c2a020ee1de94$var$Ha && $9d9c2a020ee1de94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9d9c2a020ee1de94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9d9c2a020ee1de94$var$ya ? (d = $9d9c2a020ee1de94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9d9c2a020ee1de94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $9d9c2a020ee1de94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9d9c2a020ee1de94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9d9c2a020ee1de94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9d9c2a020ee1de94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9d9c2a020ee1de94$var$eb(f)) return n(a, d, f, h);
            if ($9d9c2a020ee1de94$var$Ka(f)) return t(a, d, f, h);
            $9d9c2a020ee1de94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9d9c2a020ee1de94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9d9c2a020ee1de94$var$Ug = $9d9c2a020ee1de94$var$Og(!0), $9d9c2a020ee1de94$var$Vg = $9d9c2a020ee1de94$var$Og(!1), $9d9c2a020ee1de94$var$Wg = $9d9c2a020ee1de94$var$Uf(null), $9d9c2a020ee1de94$var$Xg = null, $9d9c2a020ee1de94$var$Yg = null, $9d9c2a020ee1de94$var$Zg = null;
function $9d9c2a020ee1de94$var$$g() {
    $9d9c2a020ee1de94$var$Zg = $9d9c2a020ee1de94$var$Yg = $9d9c2a020ee1de94$var$Xg = null;
}
function $9d9c2a020ee1de94$var$ah(a) {
    var b = $9d9c2a020ee1de94$var$Wg.current;
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$Wg);
    a._currentValue = b;
}
function $9d9c2a020ee1de94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9d9c2a020ee1de94$var$ch(a, b) {
    $9d9c2a020ee1de94$var$Xg = a;
    $9d9c2a020ee1de94$var$Zg = $9d9c2a020ee1de94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9d9c2a020ee1de94$var$dh = !0), a.firstContext = null);
}
function $9d9c2a020ee1de94$var$eh(a) {
    var b = a._currentValue;
    if ($9d9c2a020ee1de94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9d9c2a020ee1de94$var$Yg) {
            if (null === $9d9c2a020ee1de94$var$Xg) throw Error($9d9c2a020ee1de94$var$p(308));
            $9d9c2a020ee1de94$var$Yg = a;
            $9d9c2a020ee1de94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9d9c2a020ee1de94$var$Yg = $9d9c2a020ee1de94$var$Yg.next = a;
    }
    return b;
}
var $9d9c2a020ee1de94$var$fh = null;
function $9d9c2a020ee1de94$var$gh(a) {
    null === $9d9c2a020ee1de94$var$fh ? $9d9c2a020ee1de94$var$fh = [
        a
    ] : $9d9c2a020ee1de94$var$fh.push(a);
}
function $9d9c2a020ee1de94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9d9c2a020ee1de94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9d9c2a020ee1de94$var$ih(a, d);
}
function $9d9c2a020ee1de94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9d9c2a020ee1de94$var$jh = !1;
function $9d9c2a020ee1de94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9d9c2a020ee1de94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9d9c2a020ee1de94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9d9c2a020ee1de94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9d9c2a020ee1de94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9d9c2a020ee1de94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9d9c2a020ee1de94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9d9c2a020ee1de94$var$ih(a, c);
}
function $9d9c2a020ee1de94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9d9c2a020ee1de94$var$Cc(a, c);
    }
}
function $9d9c2a020ee1de94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9d9c2a020ee1de94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $9d9c2a020ee1de94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9d9c2a020ee1de94$var$A({}, q, r);
                            break a;
                        case 2:
                            $9d9c2a020ee1de94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9d9c2a020ee1de94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9d9c2a020ee1de94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9d9c2a020ee1de94$var$p(191, e));
            e.call(d);
        }
    }
}
var $9d9c2a020ee1de94$var$th = {}, $9d9c2a020ee1de94$var$uh = $9d9c2a020ee1de94$var$Uf($9d9c2a020ee1de94$var$th), $9d9c2a020ee1de94$var$vh = $9d9c2a020ee1de94$var$Uf($9d9c2a020ee1de94$var$th), $9d9c2a020ee1de94$var$wh = $9d9c2a020ee1de94$var$Uf($9d9c2a020ee1de94$var$th);
function $9d9c2a020ee1de94$var$xh(a) {
    if (a === $9d9c2a020ee1de94$var$th) throw Error($9d9c2a020ee1de94$var$p(174));
    return a;
}
function $9d9c2a020ee1de94$var$yh(a, b) {
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$wh, b);
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$vh, a);
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$uh, $9d9c2a020ee1de94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9d9c2a020ee1de94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9d9c2a020ee1de94$var$lb(b, a);
    }
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$uh);
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$uh, b);
}
function $9d9c2a020ee1de94$var$zh() {
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$uh);
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$vh);
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$wh);
}
function $9d9c2a020ee1de94$var$Ah(a) {
    $9d9c2a020ee1de94$var$xh($9d9c2a020ee1de94$var$wh.current);
    var b = $9d9c2a020ee1de94$var$xh($9d9c2a020ee1de94$var$uh.current);
    var c = $9d9c2a020ee1de94$var$lb(b, a.type);
    b !== c && ($9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$vh, a), $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$uh, c));
}
function $9d9c2a020ee1de94$var$Bh(a) {
    $9d9c2a020ee1de94$var$vh.current === a && ($9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$uh), $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$vh));
}
var $9d9c2a020ee1de94$var$L = $9d9c2a020ee1de94$var$Uf(0);
function $9d9c2a020ee1de94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9d9c2a020ee1de94$var$Dh = [];
function $9d9c2a020ee1de94$var$Eh() {
    for(var a = 0; a < $9d9c2a020ee1de94$var$Dh.length; a++)$9d9c2a020ee1de94$var$Dh[a]._workInProgressVersionPrimary = null;
    $9d9c2a020ee1de94$var$Dh.length = 0;
}
var $9d9c2a020ee1de94$var$Fh = $9d9c2a020ee1de94$var$ua.ReactCurrentDispatcher, $9d9c2a020ee1de94$var$Gh = $9d9c2a020ee1de94$var$ua.ReactCurrentBatchConfig, $9d9c2a020ee1de94$var$Hh = 0, $9d9c2a020ee1de94$var$M = null, $9d9c2a020ee1de94$var$N = null, $9d9c2a020ee1de94$var$O = null, $9d9c2a020ee1de94$var$Ih = !1, $9d9c2a020ee1de94$var$Jh = !1, $9d9c2a020ee1de94$var$Kh = 0, $9d9c2a020ee1de94$var$Lh = 0;
function $9d9c2a020ee1de94$var$P() {
    throw Error($9d9c2a020ee1de94$var$p(321));
}
function $9d9c2a020ee1de94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9d9c2a020ee1de94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9d9c2a020ee1de94$var$Nh(a, b, c, d, e, f) {
    $9d9c2a020ee1de94$var$Hh = f;
    $9d9c2a020ee1de94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9d9c2a020ee1de94$var$Fh.current = null === a || null === a.memoizedState ? $9d9c2a020ee1de94$var$Oh : $9d9c2a020ee1de94$var$Ph;
    a = c(d, e);
    if ($9d9c2a020ee1de94$var$Jh) {
        f = 0;
        do {
            $9d9c2a020ee1de94$var$Jh = !1;
            $9d9c2a020ee1de94$var$Kh = 0;
            if (25 <= f) throw Error($9d9c2a020ee1de94$var$p(301));
            f += 1;
            $9d9c2a020ee1de94$var$O = $9d9c2a020ee1de94$var$N = null;
            b.updateQueue = null;
            $9d9c2a020ee1de94$var$Fh.current = $9d9c2a020ee1de94$var$Qh;
            a = c(d, e);
        }while ($9d9c2a020ee1de94$var$Jh);
    }
    $9d9c2a020ee1de94$var$Fh.current = $9d9c2a020ee1de94$var$Rh;
    b = null !== $9d9c2a020ee1de94$var$N && null !== $9d9c2a020ee1de94$var$N.next;
    $9d9c2a020ee1de94$var$Hh = 0;
    $9d9c2a020ee1de94$var$O = $9d9c2a020ee1de94$var$N = $9d9c2a020ee1de94$var$M = null;
    $9d9c2a020ee1de94$var$Ih = !1;
    if (b) throw Error($9d9c2a020ee1de94$var$p(300));
    return a;
}
function $9d9c2a020ee1de94$var$Sh() {
    var a = 0 !== $9d9c2a020ee1de94$var$Kh;
    $9d9c2a020ee1de94$var$Kh = 0;
    return a;
}
function $9d9c2a020ee1de94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9d9c2a020ee1de94$var$O ? $9d9c2a020ee1de94$var$M.memoizedState = $9d9c2a020ee1de94$var$O = a : $9d9c2a020ee1de94$var$O = $9d9c2a020ee1de94$var$O.next = a;
    return $9d9c2a020ee1de94$var$O;
}
function $9d9c2a020ee1de94$var$Uh() {
    if (null === $9d9c2a020ee1de94$var$N) {
        var a = $9d9c2a020ee1de94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9d9c2a020ee1de94$var$N.next;
    var b = null === $9d9c2a020ee1de94$var$O ? $9d9c2a020ee1de94$var$M.memoizedState : $9d9c2a020ee1de94$var$O.next;
    if (null !== b) $9d9c2a020ee1de94$var$O = b, $9d9c2a020ee1de94$var$N = a;
    else {
        if (null === a) throw Error($9d9c2a020ee1de94$var$p(310));
        $9d9c2a020ee1de94$var$N = a;
        a = {
            memoizedState: $9d9c2a020ee1de94$var$N.memoizedState,
            baseState: $9d9c2a020ee1de94$var$N.baseState,
            baseQueue: $9d9c2a020ee1de94$var$N.baseQueue,
            queue: $9d9c2a020ee1de94$var$N.queue,
            next: null
        };
        null === $9d9c2a020ee1de94$var$O ? $9d9c2a020ee1de94$var$M.memoizedState = $9d9c2a020ee1de94$var$O = a : $9d9c2a020ee1de94$var$O = $9d9c2a020ee1de94$var$O.next = a;
    }
    return $9d9c2a020ee1de94$var$O;
}
function $9d9c2a020ee1de94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9d9c2a020ee1de94$var$Wh(a) {
    var b = $9d9c2a020ee1de94$var$Uh(), c = b.queue;
    if (null === c) throw Error($9d9c2a020ee1de94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9d9c2a020ee1de94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9d9c2a020ee1de94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9d9c2a020ee1de94$var$M.lanes |= m;
                $9d9c2a020ee1de94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9d9c2a020ee1de94$var$He(d, b.memoizedState) || ($9d9c2a020ee1de94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9d9c2a020ee1de94$var$M.lanes |= f, $9d9c2a020ee1de94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9d9c2a020ee1de94$var$Xh(a) {
    var b = $9d9c2a020ee1de94$var$Uh(), c = b.queue;
    if (null === c) throw Error($9d9c2a020ee1de94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9d9c2a020ee1de94$var$He(f, b.memoizedState) || ($9d9c2a020ee1de94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9d9c2a020ee1de94$var$Yh() {}
function $9d9c2a020ee1de94$var$Zh(a, b) {
    var c = $9d9c2a020ee1de94$var$M, d = $9d9c2a020ee1de94$var$Uh(), e = b(), f = !$9d9c2a020ee1de94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9d9c2a020ee1de94$var$dh = !0);
    d = d.queue;
    $9d9c2a020ee1de94$var$$h($9d9c2a020ee1de94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9d9c2a020ee1de94$var$O && $9d9c2a020ee1de94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9d9c2a020ee1de94$var$bi(9, $9d9c2a020ee1de94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $9d9c2a020ee1de94$var$Q) throw Error($9d9c2a020ee1de94$var$p(349));
        0 !== ($9d9c2a020ee1de94$var$Hh & 30) || $9d9c2a020ee1de94$var$di(c, b, e);
    }
    return e;
}
function $9d9c2a020ee1de94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9d9c2a020ee1de94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9d9c2a020ee1de94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9d9c2a020ee1de94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9d9c2a020ee1de94$var$ei(b) && $9d9c2a020ee1de94$var$fi(a);
}
function $9d9c2a020ee1de94$var$ai(a, b, c) {
    return c(function() {
        $9d9c2a020ee1de94$var$ei(b) && $9d9c2a020ee1de94$var$fi(a);
    });
}
function $9d9c2a020ee1de94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9d9c2a020ee1de94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9d9c2a020ee1de94$var$fi(a) {
    var b = $9d9c2a020ee1de94$var$ih(a, 1);
    null !== b && $9d9c2a020ee1de94$var$gi(b, a, 1, -1);
}
function $9d9c2a020ee1de94$var$hi(a) {
    var b = $9d9c2a020ee1de94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9d9c2a020ee1de94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9d9c2a020ee1de94$var$ii.bind(null, $9d9c2a020ee1de94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9d9c2a020ee1de94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9d9c2a020ee1de94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9d9c2a020ee1de94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9d9c2a020ee1de94$var$ji() {
    return $9d9c2a020ee1de94$var$Uh().memoizedState;
}
function $9d9c2a020ee1de94$var$ki(a, b, c, d) {
    var e = $9d9c2a020ee1de94$var$Th();
    $9d9c2a020ee1de94$var$M.flags |= a;
    e.memoizedState = $9d9c2a020ee1de94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9d9c2a020ee1de94$var$li(a, b, c, d) {
    var e = $9d9c2a020ee1de94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9d9c2a020ee1de94$var$N) {
        var g = $9d9c2a020ee1de94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $9d9c2a020ee1de94$var$Mh(d, g.deps)) {
            e.memoizedState = $9d9c2a020ee1de94$var$bi(b, c, f, d);
            return;
        }
    }
    $9d9c2a020ee1de94$var$M.flags |= a;
    e.memoizedState = $9d9c2a020ee1de94$var$bi(1 | b, c, f, d);
}
function $9d9c2a020ee1de94$var$mi(a, b) {
    return $9d9c2a020ee1de94$var$ki(8390656, 8, a, b);
}
function $9d9c2a020ee1de94$var$$h(a, b) {
    return $9d9c2a020ee1de94$var$li(2048, 8, a, b);
}
function $9d9c2a020ee1de94$var$ni(a, b) {
    return $9d9c2a020ee1de94$var$li(4, 2, a, b);
}
function $9d9c2a020ee1de94$var$oi(a, b) {
    return $9d9c2a020ee1de94$var$li(4, 4, a, b);
}
function $9d9c2a020ee1de94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9d9c2a020ee1de94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9d9c2a020ee1de94$var$li(4, 4, $9d9c2a020ee1de94$var$pi.bind(null, b, a), c);
}
function $9d9c2a020ee1de94$var$ri() {}
function $9d9c2a020ee1de94$var$si(a, b) {
    var c = $9d9c2a020ee1de94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9d9c2a020ee1de94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9d9c2a020ee1de94$var$ti(a, b) {
    var c = $9d9c2a020ee1de94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9d9c2a020ee1de94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9d9c2a020ee1de94$var$ui(a, b, c) {
    if (0 === ($9d9c2a020ee1de94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $9d9c2a020ee1de94$var$dh = !0), a.memoizedState = c;
    $9d9c2a020ee1de94$var$He(c, b) || (c = $9d9c2a020ee1de94$var$yc(), $9d9c2a020ee1de94$var$M.lanes |= c, $9d9c2a020ee1de94$var$rh |= c, a.baseState = !0);
    return b;
}
function $9d9c2a020ee1de94$var$vi(a, b) {
    var c = $9d9c2a020ee1de94$var$C;
    $9d9c2a020ee1de94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9d9c2a020ee1de94$var$Gh.transition;
    $9d9c2a020ee1de94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9d9c2a020ee1de94$var$C = c, $9d9c2a020ee1de94$var$Gh.transition = d;
    }
}
function $9d9c2a020ee1de94$var$wi() {
    return $9d9c2a020ee1de94$var$Uh().memoizedState;
}
function $9d9c2a020ee1de94$var$xi(a, b, c) {
    var d = $9d9c2a020ee1de94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9d9c2a020ee1de94$var$zi(a)) $9d9c2a020ee1de94$var$Ai(b, c);
    else if (c = $9d9c2a020ee1de94$var$hh(a, b, c, d), null !== c) {
        var e = $9d9c2a020ee1de94$var$R();
        $9d9c2a020ee1de94$var$gi(c, a, d, e);
        $9d9c2a020ee1de94$var$Bi(c, b, d);
    }
}
function $9d9c2a020ee1de94$var$ii(a, b, c) {
    var d = $9d9c2a020ee1de94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9d9c2a020ee1de94$var$zi(a)) $9d9c2a020ee1de94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9d9c2a020ee1de94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9d9c2a020ee1de94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9d9c2a020ee1de94$var$hh(a, b, e, d);
        null !== c && (e = $9d9c2a020ee1de94$var$R(), $9d9c2a020ee1de94$var$gi(c, a, d, e), $9d9c2a020ee1de94$var$Bi(c, b, d));
    }
}
function $9d9c2a020ee1de94$var$zi(a) {
    var b = a.alternate;
    return a === $9d9c2a020ee1de94$var$M || null !== b && b === $9d9c2a020ee1de94$var$M;
}
function $9d9c2a020ee1de94$var$Ai(a, b) {
    $9d9c2a020ee1de94$var$Jh = $9d9c2a020ee1de94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9d9c2a020ee1de94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9d9c2a020ee1de94$var$Cc(a, c);
    }
}
var $9d9c2a020ee1de94$var$Rh = {
    readContext: $9d9c2a020ee1de94$var$eh,
    useCallback: $9d9c2a020ee1de94$var$P,
    useContext: $9d9c2a020ee1de94$var$P,
    useEffect: $9d9c2a020ee1de94$var$P,
    useImperativeHandle: $9d9c2a020ee1de94$var$P,
    useInsertionEffect: $9d9c2a020ee1de94$var$P,
    useLayoutEffect: $9d9c2a020ee1de94$var$P,
    useMemo: $9d9c2a020ee1de94$var$P,
    useReducer: $9d9c2a020ee1de94$var$P,
    useRef: $9d9c2a020ee1de94$var$P,
    useState: $9d9c2a020ee1de94$var$P,
    useDebugValue: $9d9c2a020ee1de94$var$P,
    useDeferredValue: $9d9c2a020ee1de94$var$P,
    useTransition: $9d9c2a020ee1de94$var$P,
    useMutableSource: $9d9c2a020ee1de94$var$P,
    useSyncExternalStore: $9d9c2a020ee1de94$var$P,
    useId: $9d9c2a020ee1de94$var$P,
    unstable_isNewReconciler: !1
}, $9d9c2a020ee1de94$var$Oh = {
    readContext: $9d9c2a020ee1de94$var$eh,
    useCallback: function(a, b) {
        $9d9c2a020ee1de94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9d9c2a020ee1de94$var$eh,
    useEffect: $9d9c2a020ee1de94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9d9c2a020ee1de94$var$ki(4194308, 4, $9d9c2a020ee1de94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9d9c2a020ee1de94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9d9c2a020ee1de94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9d9c2a020ee1de94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9d9c2a020ee1de94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9d9c2a020ee1de94$var$xi.bind(null, $9d9c2a020ee1de94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9d9c2a020ee1de94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9d9c2a020ee1de94$var$hi,
    useDebugValue: $9d9c2a020ee1de94$var$ri,
    useDeferredValue: function(a) {
        return $9d9c2a020ee1de94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $9d9c2a020ee1de94$var$hi(!1), b = a[0];
        a = $9d9c2a020ee1de94$var$vi.bind(null, a[1]);
        $9d9c2a020ee1de94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9d9c2a020ee1de94$var$M, e = $9d9c2a020ee1de94$var$Th();
        if ($9d9c2a020ee1de94$var$I) {
            if (void 0 === c) throw Error($9d9c2a020ee1de94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9d9c2a020ee1de94$var$Q) throw Error($9d9c2a020ee1de94$var$p(349));
            0 !== ($9d9c2a020ee1de94$var$Hh & 30) || $9d9c2a020ee1de94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9d9c2a020ee1de94$var$mi($9d9c2a020ee1de94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9d9c2a020ee1de94$var$bi(9, $9d9c2a020ee1de94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9d9c2a020ee1de94$var$Th(), b = $9d9c2a020ee1de94$var$Q.identifierPrefix;
        if ($9d9c2a020ee1de94$var$I) {
            var c = $9d9c2a020ee1de94$var$sg;
            var d = $9d9c2a020ee1de94$var$rg;
            c = (d & ~(1 << 32 - $9d9c2a020ee1de94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9d9c2a020ee1de94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9d9c2a020ee1de94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9d9c2a020ee1de94$var$Ph = {
    readContext: $9d9c2a020ee1de94$var$eh,
    useCallback: $9d9c2a020ee1de94$var$si,
    useContext: $9d9c2a020ee1de94$var$eh,
    useEffect: $9d9c2a020ee1de94$var$$h,
    useImperativeHandle: $9d9c2a020ee1de94$var$qi,
    useInsertionEffect: $9d9c2a020ee1de94$var$ni,
    useLayoutEffect: $9d9c2a020ee1de94$var$oi,
    useMemo: $9d9c2a020ee1de94$var$ti,
    useReducer: $9d9c2a020ee1de94$var$Wh,
    useRef: $9d9c2a020ee1de94$var$ji,
    useState: function() {
        return $9d9c2a020ee1de94$var$Wh($9d9c2a020ee1de94$var$Vh);
    },
    useDebugValue: $9d9c2a020ee1de94$var$ri,
    useDeferredValue: function(a) {
        var b = $9d9c2a020ee1de94$var$Uh();
        return $9d9c2a020ee1de94$var$ui(b, $9d9c2a020ee1de94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9d9c2a020ee1de94$var$Wh($9d9c2a020ee1de94$var$Vh)[0], b = $9d9c2a020ee1de94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9d9c2a020ee1de94$var$Yh,
    useSyncExternalStore: $9d9c2a020ee1de94$var$Zh,
    useId: $9d9c2a020ee1de94$var$wi,
    unstable_isNewReconciler: !1
}, $9d9c2a020ee1de94$var$Qh = {
    readContext: $9d9c2a020ee1de94$var$eh,
    useCallback: $9d9c2a020ee1de94$var$si,
    useContext: $9d9c2a020ee1de94$var$eh,
    useEffect: $9d9c2a020ee1de94$var$$h,
    useImperativeHandle: $9d9c2a020ee1de94$var$qi,
    useInsertionEffect: $9d9c2a020ee1de94$var$ni,
    useLayoutEffect: $9d9c2a020ee1de94$var$oi,
    useMemo: $9d9c2a020ee1de94$var$ti,
    useReducer: $9d9c2a020ee1de94$var$Xh,
    useRef: $9d9c2a020ee1de94$var$ji,
    useState: function() {
        return $9d9c2a020ee1de94$var$Xh($9d9c2a020ee1de94$var$Vh);
    },
    useDebugValue: $9d9c2a020ee1de94$var$ri,
    useDeferredValue: function(a) {
        var b = $9d9c2a020ee1de94$var$Uh();
        return null === $9d9c2a020ee1de94$var$N ? b.memoizedState = a : $9d9c2a020ee1de94$var$ui(b, $9d9c2a020ee1de94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9d9c2a020ee1de94$var$Xh($9d9c2a020ee1de94$var$Vh)[0], b = $9d9c2a020ee1de94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9d9c2a020ee1de94$var$Yh,
    useSyncExternalStore: $9d9c2a020ee1de94$var$Zh,
    useId: $9d9c2a020ee1de94$var$wi,
    unstable_isNewReconciler: !1
};
function $9d9c2a020ee1de94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $9d9c2a020ee1de94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9d9c2a020ee1de94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9d9c2a020ee1de94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9d9c2a020ee1de94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9d9c2a020ee1de94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9d9c2a020ee1de94$var$R(), e = $9d9c2a020ee1de94$var$yi(a), f = $9d9c2a020ee1de94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9d9c2a020ee1de94$var$nh(a, f, e);
        null !== b && ($9d9c2a020ee1de94$var$gi(b, a, e, d), $9d9c2a020ee1de94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9d9c2a020ee1de94$var$R(), e = $9d9c2a020ee1de94$var$yi(a), f = $9d9c2a020ee1de94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9d9c2a020ee1de94$var$nh(a, f, e);
        null !== b && ($9d9c2a020ee1de94$var$gi(b, a, e, d), $9d9c2a020ee1de94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9d9c2a020ee1de94$var$R(), d = $9d9c2a020ee1de94$var$yi(a), e = $9d9c2a020ee1de94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9d9c2a020ee1de94$var$nh(a, e, d);
        null !== b && ($9d9c2a020ee1de94$var$gi(b, a, d, c), $9d9c2a020ee1de94$var$oh(b, a, d));
    }
};
function $9d9c2a020ee1de94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9d9c2a020ee1de94$var$Ie(c, d) || !$9d9c2a020ee1de94$var$Ie(e, f) : !0;
}
function $9d9c2a020ee1de94$var$Gi(a, b, c) {
    var d = !1, e = $9d9c2a020ee1de94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9d9c2a020ee1de94$var$eh(f) : (e = $9d9c2a020ee1de94$var$Zf(b) ? $9d9c2a020ee1de94$var$Xf : $9d9c2a020ee1de94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9d9c2a020ee1de94$var$Yf(a, e) : $9d9c2a020ee1de94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9d9c2a020ee1de94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9d9c2a020ee1de94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9d9c2a020ee1de94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $9d9c2a020ee1de94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $9d9c2a020ee1de94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9d9c2a020ee1de94$var$eh(f) : (f = $9d9c2a020ee1de94$var$Zf(b) ? $9d9c2a020ee1de94$var$Xf : $9d9c2a020ee1de94$var$H.current, e.context = $9d9c2a020ee1de94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9d9c2a020ee1de94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9d9c2a020ee1de94$var$Ei.enqueueReplaceState(e, e.state, null), $9d9c2a020ee1de94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9d9c2a020ee1de94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $9d9c2a020ee1de94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9d9c2a020ee1de94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9d9c2a020ee1de94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9d9c2a020ee1de94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $9d9c2a020ee1de94$var$Ni(a, b, c) {
    c = $9d9c2a020ee1de94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9d9c2a020ee1de94$var$Oi || ($9d9c2a020ee1de94$var$Oi = !0, $9d9c2a020ee1de94$var$Pi = d);
        $9d9c2a020ee1de94$var$Li(a, b);
    };
    return c;
}
function $9d9c2a020ee1de94$var$Qi(a, b, c) {
    c = $9d9c2a020ee1de94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9d9c2a020ee1de94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9d9c2a020ee1de94$var$Li(a, b);
        "function" !== typeof d && (null === $9d9c2a020ee1de94$var$Ri ? $9d9c2a020ee1de94$var$Ri = new Set([
            this
        ]) : $9d9c2a020ee1de94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9d9c2a020ee1de94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9d9c2a020ee1de94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9d9c2a020ee1de94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $9d9c2a020ee1de94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9d9c2a020ee1de94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9d9c2a020ee1de94$var$mh(-1, 1), b.tag = 2, $9d9c2a020ee1de94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9d9c2a020ee1de94$var$Wi = $9d9c2a020ee1de94$var$ua.ReactCurrentOwner, $9d9c2a020ee1de94$var$dh = !1;
function $9d9c2a020ee1de94$var$Xi(a, b, c, d) {
    b.child = null === a ? $9d9c2a020ee1de94$var$Vg(b, null, c, d) : $9d9c2a020ee1de94$var$Ug(b, a.child, c, d);
}
function $9d9c2a020ee1de94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9d9c2a020ee1de94$var$ch(b, e);
    d = $9d9c2a020ee1de94$var$Nh(a, b, c, d, f, e);
    c = $9d9c2a020ee1de94$var$Sh();
    if (null !== a && !$9d9c2a020ee1de94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9d9c2a020ee1de94$var$Zi(a, b, e);
    $9d9c2a020ee1de94$var$I && c && $9d9c2a020ee1de94$var$vg(b);
    b.flags |= 1;
    $9d9c2a020ee1de94$var$Xi(a, b, d, e);
    return b.child;
}
function $9d9c2a020ee1de94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9d9c2a020ee1de94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9d9c2a020ee1de94$var$bj(a, b, f, d, e);
        a = $9d9c2a020ee1de94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9d9c2a020ee1de94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9d9c2a020ee1de94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $9d9c2a020ee1de94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9d9c2a020ee1de94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9d9c2a020ee1de94$var$Ie(f, d) && a.ref === b.ref) {
            if ($9d9c2a020ee1de94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9d9c2a020ee1de94$var$dh = !0);
            else return b.lanes = a.lanes, $9d9c2a020ee1de94$var$Zi(a, b, e);
        }
    }
    return $9d9c2a020ee1de94$var$cj(a, b, c, d, e);
}
function $9d9c2a020ee1de94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$ej, $9d9c2a020ee1de94$var$fj), $9d9c2a020ee1de94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$ej, $9d9c2a020ee1de94$var$fj), $9d9c2a020ee1de94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$ej, $9d9c2a020ee1de94$var$fj);
            $9d9c2a020ee1de94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$ej, $9d9c2a020ee1de94$var$fj), $9d9c2a020ee1de94$var$fj |= d;
    $9d9c2a020ee1de94$var$Xi(a, b, e, c);
    return b.child;
}
function $9d9c2a020ee1de94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9d9c2a020ee1de94$var$cj(a, b, c, d, e) {
    var f = $9d9c2a020ee1de94$var$Zf(c) ? $9d9c2a020ee1de94$var$Xf : $9d9c2a020ee1de94$var$H.current;
    f = $9d9c2a020ee1de94$var$Yf(b, f);
    $9d9c2a020ee1de94$var$ch(b, e);
    c = $9d9c2a020ee1de94$var$Nh(a, b, c, d, f, e);
    d = $9d9c2a020ee1de94$var$Sh();
    if (null !== a && !$9d9c2a020ee1de94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9d9c2a020ee1de94$var$Zi(a, b, e);
    $9d9c2a020ee1de94$var$I && d && $9d9c2a020ee1de94$var$vg(b);
    b.flags |= 1;
    $9d9c2a020ee1de94$var$Xi(a, b, c, e);
    return b.child;
}
function $9d9c2a020ee1de94$var$hj(a, b, c, d, e) {
    if ($9d9c2a020ee1de94$var$Zf(c)) {
        var f = !0;
        $9d9c2a020ee1de94$var$cg(b);
    } else f = !1;
    $9d9c2a020ee1de94$var$ch(b, e);
    if (null === b.stateNode) $9d9c2a020ee1de94$var$ij(a, b), $9d9c2a020ee1de94$var$Gi(b, c, d), $9d9c2a020ee1de94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9d9c2a020ee1de94$var$eh(l) : (l = $9d9c2a020ee1de94$var$Zf(c) ? $9d9c2a020ee1de94$var$Xf : $9d9c2a020ee1de94$var$H.current, l = $9d9c2a020ee1de94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9d9c2a020ee1de94$var$Hi(b, g, d, l);
        $9d9c2a020ee1de94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $9d9c2a020ee1de94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9d9c2a020ee1de94$var$Wf.current || $9d9c2a020ee1de94$var$jh ? ("function" === typeof m && ($9d9c2a020ee1de94$var$Di(b, c, m, d), k = b.memoizedState), (h = $9d9c2a020ee1de94$var$jh || $9d9c2a020ee1de94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9d9c2a020ee1de94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9d9c2a020ee1de94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9d9c2a020ee1de94$var$eh(k) : (k = $9d9c2a020ee1de94$var$Zf(c) ? $9d9c2a020ee1de94$var$Xf : $9d9c2a020ee1de94$var$H.current, k = $9d9c2a020ee1de94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9d9c2a020ee1de94$var$Hi(b, g, d, k);
        $9d9c2a020ee1de94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $9d9c2a020ee1de94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9d9c2a020ee1de94$var$Wf.current || $9d9c2a020ee1de94$var$jh ? ("function" === typeof y && ($9d9c2a020ee1de94$var$Di(b, c, y, d), n = b.memoizedState), (l = $9d9c2a020ee1de94$var$jh || $9d9c2a020ee1de94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9d9c2a020ee1de94$var$jj(a, b, c, d, f, e);
}
function $9d9c2a020ee1de94$var$jj(a, b, c, d, e, f) {
    $9d9c2a020ee1de94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9d9c2a020ee1de94$var$dg(b, c, !1), $9d9c2a020ee1de94$var$Zi(a, b, f);
    d = b.stateNode;
    $9d9c2a020ee1de94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9d9c2a020ee1de94$var$Ug(b, a.child, null, f), b.child = $9d9c2a020ee1de94$var$Ug(b, null, h, f)) : $9d9c2a020ee1de94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9d9c2a020ee1de94$var$dg(b, c, !0);
    return b.child;
}
function $9d9c2a020ee1de94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9d9c2a020ee1de94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9d9c2a020ee1de94$var$ag(a, b.context, !1);
    $9d9c2a020ee1de94$var$yh(a, b.containerInfo);
}
function $9d9c2a020ee1de94$var$lj(a, b, c, d, e) {
    $9d9c2a020ee1de94$var$Ig();
    $9d9c2a020ee1de94$var$Jg(e);
    b.flags |= 256;
    $9d9c2a020ee1de94$var$Xi(a, b, c, d);
    return b.child;
}
var $9d9c2a020ee1de94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9d9c2a020ee1de94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9d9c2a020ee1de94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $9d9c2a020ee1de94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, e & 1);
    if (null === a) {
        $9d9c2a020ee1de94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9d9c2a020ee1de94$var$pj(g, d, 0, null), a = $9d9c2a020ee1de94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9d9c2a020ee1de94$var$nj(c), b.memoizedState = $9d9c2a020ee1de94$var$mj, a) : $9d9c2a020ee1de94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9d9c2a020ee1de94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9d9c2a020ee1de94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9d9c2a020ee1de94$var$Pg(h, f) : (f = $9d9c2a020ee1de94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9d9c2a020ee1de94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9d9c2a020ee1de94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9d9c2a020ee1de94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9d9c2a020ee1de94$var$qj(a, b) {
    b = $9d9c2a020ee1de94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9d9c2a020ee1de94$var$sj(a, b, c, d) {
    null !== d && $9d9c2a020ee1de94$var$Jg(d);
    $9d9c2a020ee1de94$var$Ug(b, a.child, null, c);
    a = $9d9c2a020ee1de94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9d9c2a020ee1de94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9d9c2a020ee1de94$var$Ki(Error($9d9c2a020ee1de94$var$p(422))), $9d9c2a020ee1de94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9d9c2a020ee1de94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9d9c2a020ee1de94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9d9c2a020ee1de94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $9d9c2a020ee1de94$var$nj(g);
        b.memoizedState = $9d9c2a020ee1de94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9d9c2a020ee1de94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9d9c2a020ee1de94$var$p(419));
        d = $9d9c2a020ee1de94$var$Ki(f, d, void 0);
        return $9d9c2a020ee1de94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9d9c2a020ee1de94$var$dh || h) {
        d = $9d9c2a020ee1de94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9d9c2a020ee1de94$var$ih(a, e), $9d9c2a020ee1de94$var$gi(d, a, e, -1));
        }
        $9d9c2a020ee1de94$var$tj();
        d = $9d9c2a020ee1de94$var$Ki(Error($9d9c2a020ee1de94$var$p(421)));
        return $9d9c2a020ee1de94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9d9c2a020ee1de94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9d9c2a020ee1de94$var$yg = $9d9c2a020ee1de94$var$Lf(e.nextSibling);
    $9d9c2a020ee1de94$var$xg = b;
    $9d9c2a020ee1de94$var$I = !0;
    $9d9c2a020ee1de94$var$zg = null;
    null !== a && ($9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg++] = $9d9c2a020ee1de94$var$rg, $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg++] = $9d9c2a020ee1de94$var$sg, $9d9c2a020ee1de94$var$og[$9d9c2a020ee1de94$var$pg++] = $9d9c2a020ee1de94$var$qg, $9d9c2a020ee1de94$var$rg = a.id, $9d9c2a020ee1de94$var$sg = a.overflow, $9d9c2a020ee1de94$var$qg = b);
    b = $9d9c2a020ee1de94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9d9c2a020ee1de94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9d9c2a020ee1de94$var$bh(a.return, b, c);
}
function $9d9c2a020ee1de94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9d9c2a020ee1de94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9d9c2a020ee1de94$var$Xi(a, b, d.children, c);
    d = $9d9c2a020ee1de94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9d9c2a020ee1de94$var$vj(a, c, b);
            else if (19 === a.tag) $9d9c2a020ee1de94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9d9c2a020ee1de94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9d9c2a020ee1de94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9d9c2a020ee1de94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9d9c2a020ee1de94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $9d9c2a020ee1de94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9d9c2a020ee1de94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9d9c2a020ee1de94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9d9c2a020ee1de94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9d9c2a020ee1de94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9d9c2a020ee1de94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9d9c2a020ee1de94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9d9c2a020ee1de94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $9d9c2a020ee1de94$var$kj(b);
            $9d9c2a020ee1de94$var$Ig();
            break;
        case 5:
            $9d9c2a020ee1de94$var$Ah(b);
            break;
        case 1:
            $9d9c2a020ee1de94$var$Zf(b.type) && $9d9c2a020ee1de94$var$cg(b);
            break;
        case 4:
            $9d9c2a020ee1de94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, $9d9c2a020ee1de94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9d9c2a020ee1de94$var$oj(a, b, c);
                $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, $9d9c2a020ee1de94$var$L.current & 1);
                a = $9d9c2a020ee1de94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, $9d9c2a020ee1de94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9d9c2a020ee1de94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, $9d9c2a020ee1de94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9d9c2a020ee1de94$var$dj(a, b, c);
    }
    return $9d9c2a020ee1de94$var$Zi(a, b, c);
}
var $9d9c2a020ee1de94$var$zj, $9d9c2a020ee1de94$var$Aj, $9d9c2a020ee1de94$var$Bj, $9d9c2a020ee1de94$var$Cj;
$9d9c2a020ee1de94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9d9c2a020ee1de94$var$Aj = function() {};
$9d9c2a020ee1de94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9d9c2a020ee1de94$var$xh($9d9c2a020ee1de94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9d9c2a020ee1de94$var$Ya(a, e);
                d = $9d9c2a020ee1de94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9d9c2a020ee1de94$var$A({}, e, {
                    value: void 0
                });
                d = $9d9c2a020ee1de94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9d9c2a020ee1de94$var$gb(a, e);
                d = $9d9c2a020ee1de94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9d9c2a020ee1de94$var$Bf);
        }
        $9d9c2a020ee1de94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9d9c2a020ee1de94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9d9c2a020ee1de94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9d9c2a020ee1de94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9d9c2a020ee1de94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9d9c2a020ee1de94$var$Dj(a, b) {
    if (!$9d9c2a020ee1de94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9d9c2a020ee1de94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9d9c2a020ee1de94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $9d9c2a020ee1de94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9d9c2a020ee1de94$var$S(b), null;
        case 1:
            return $9d9c2a020ee1de94$var$Zf(b.type) && $9d9c2a020ee1de94$var$$f(), $9d9c2a020ee1de94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9d9c2a020ee1de94$var$zh();
            $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$Wf);
            $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$H);
            $9d9c2a020ee1de94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9d9c2a020ee1de94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9d9c2a020ee1de94$var$zg && ($9d9c2a020ee1de94$var$Fj($9d9c2a020ee1de94$var$zg), $9d9c2a020ee1de94$var$zg = null));
            $9d9c2a020ee1de94$var$Aj(a, b);
            $9d9c2a020ee1de94$var$S(b);
            return null;
        case 5:
            $9d9c2a020ee1de94$var$Bh(b);
            var e = $9d9c2a020ee1de94$var$xh($9d9c2a020ee1de94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9d9c2a020ee1de94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9d9c2a020ee1de94$var$p(166));
                    $9d9c2a020ee1de94$var$S(b);
                    return null;
                }
                a = $9d9c2a020ee1de94$var$xh($9d9c2a020ee1de94$var$uh.current);
                if ($9d9c2a020ee1de94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9d9c2a020ee1de94$var$Of] = b;
                    d[$9d9c2a020ee1de94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9d9c2a020ee1de94$var$D("cancel", d);
                            $9d9c2a020ee1de94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9d9c2a020ee1de94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9d9c2a020ee1de94$var$lf.length; e++)$9d9c2a020ee1de94$var$D($9d9c2a020ee1de94$var$lf[e], d);
                            break;
                        case "source":
                            $9d9c2a020ee1de94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9d9c2a020ee1de94$var$D("error", d);
                            $9d9c2a020ee1de94$var$D("load", d);
                            break;
                        case "details":
                            $9d9c2a020ee1de94$var$D("toggle", d);
                            break;
                        case "input":
                            $9d9c2a020ee1de94$var$Za(d, f);
                            $9d9c2a020ee1de94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9d9c2a020ee1de94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9d9c2a020ee1de94$var$hb(d, f), $9d9c2a020ee1de94$var$D("invalid", d);
                    }
                    $9d9c2a020ee1de94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9d9c2a020ee1de94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9d9c2a020ee1de94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9d9c2a020ee1de94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9d9c2a020ee1de94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9d9c2a020ee1de94$var$Va(d);
                            $9d9c2a020ee1de94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9d9c2a020ee1de94$var$Va(d);
                            $9d9c2a020ee1de94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9d9c2a020ee1de94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9d9c2a020ee1de94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9d9c2a020ee1de94$var$Of] = b;
                    a[$9d9c2a020ee1de94$var$Pf] = d;
                    $9d9c2a020ee1de94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9d9c2a020ee1de94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9d9c2a020ee1de94$var$D("cancel", a);
                                $9d9c2a020ee1de94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9d9c2a020ee1de94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9d9c2a020ee1de94$var$lf.length; e++)$9d9c2a020ee1de94$var$D($9d9c2a020ee1de94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9d9c2a020ee1de94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9d9c2a020ee1de94$var$D("error", a);
                                $9d9c2a020ee1de94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9d9c2a020ee1de94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9d9c2a020ee1de94$var$Za(a, d);
                                e = $9d9c2a020ee1de94$var$Ya(a, d);
                                $9d9c2a020ee1de94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9d9c2a020ee1de94$var$A({}, d, {
                                    value: void 0
                                });
                                $9d9c2a020ee1de94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9d9c2a020ee1de94$var$hb(a, d);
                                e = $9d9c2a020ee1de94$var$gb(a, d);
                                $9d9c2a020ee1de94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9d9c2a020ee1de94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9d9c2a020ee1de94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9d9c2a020ee1de94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9d9c2a020ee1de94$var$ob(a, k) : "number" === typeof k && $9d9c2a020ee1de94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9d9c2a020ee1de94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9d9c2a020ee1de94$var$D("scroll", a) : null != k && $9d9c2a020ee1de94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9d9c2a020ee1de94$var$Va(a);
                                $9d9c2a020ee1de94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9d9c2a020ee1de94$var$Va(a);
                                $9d9c2a020ee1de94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9d9c2a020ee1de94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9d9c2a020ee1de94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9d9c2a020ee1de94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9d9c2a020ee1de94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9d9c2a020ee1de94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9d9c2a020ee1de94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9d9c2a020ee1de94$var$p(166));
                c = $9d9c2a020ee1de94$var$xh($9d9c2a020ee1de94$var$wh.current);
                $9d9c2a020ee1de94$var$xh($9d9c2a020ee1de94$var$uh.current);
                if ($9d9c2a020ee1de94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9d9c2a020ee1de94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9d9c2a020ee1de94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9d9c2a020ee1de94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9d9c2a020ee1de94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9d9c2a020ee1de94$var$Of] = b, b.stateNode = d;
            }
            $9d9c2a020ee1de94$var$S(b);
            return null;
        case 13:
            $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9d9c2a020ee1de94$var$I && null !== $9d9c2a020ee1de94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9d9c2a020ee1de94$var$Hg(), $9d9c2a020ee1de94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9d9c2a020ee1de94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9d9c2a020ee1de94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9d9c2a020ee1de94$var$p(317));
                        f[$9d9c2a020ee1de94$var$Of] = b;
                    } else $9d9c2a020ee1de94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9d9c2a020ee1de94$var$S(b);
                    f = !1;
                } else null !== $9d9c2a020ee1de94$var$zg && ($9d9c2a020ee1de94$var$Fj($9d9c2a020ee1de94$var$zg), $9d9c2a020ee1de94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9d9c2a020ee1de94$var$L.current & 1) ? 0 === $9d9c2a020ee1de94$var$T && ($9d9c2a020ee1de94$var$T = 3) : $9d9c2a020ee1de94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9d9c2a020ee1de94$var$S(b);
            return null;
        case 4:
            return $9d9c2a020ee1de94$var$zh(), $9d9c2a020ee1de94$var$Aj(a, b), null === a && $9d9c2a020ee1de94$var$sf(b.stateNode.containerInfo), $9d9c2a020ee1de94$var$S(b), null;
        case 10:
            return $9d9c2a020ee1de94$var$ah(b.type._context), $9d9c2a020ee1de94$var$S(b), null;
        case 17:
            return $9d9c2a020ee1de94$var$Zf(b.type) && $9d9c2a020ee1de94$var$$f(), $9d9c2a020ee1de94$var$S(b), null;
        case 19:
            $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$L);
            f = b.memoizedState;
            if (null === f) return $9d9c2a020ee1de94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9d9c2a020ee1de94$var$Dj(f, !1);
                else {
                    if (0 !== $9d9c2a020ee1de94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9d9c2a020ee1de94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9d9c2a020ee1de94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, $9d9c2a020ee1de94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9d9c2a020ee1de94$var$B() > $9d9c2a020ee1de94$var$Gj && (b.flags |= 128, d = !0, $9d9c2a020ee1de94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9d9c2a020ee1de94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9d9c2a020ee1de94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9d9c2a020ee1de94$var$I) return $9d9c2a020ee1de94$var$S(b), null;
                    } else 2 * $9d9c2a020ee1de94$var$B() - f.renderingStartTime > $9d9c2a020ee1de94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $9d9c2a020ee1de94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9d9c2a020ee1de94$var$B(), b.sibling = null, c = $9d9c2a020ee1de94$var$L.current, $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$L, d ? c & 1 | 2 : c & 1), b;
            $9d9c2a020ee1de94$var$S(b);
            return null;
        case 22:
        case 23:
            return $9d9c2a020ee1de94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9d9c2a020ee1de94$var$fj & 1073741824) && ($9d9c2a020ee1de94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9d9c2a020ee1de94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9d9c2a020ee1de94$var$p(156, b.tag));
}
function $9d9c2a020ee1de94$var$Ij(a, b) {
    $9d9c2a020ee1de94$var$wg(b);
    switch(b.tag){
        case 1:
            return $9d9c2a020ee1de94$var$Zf(b.type) && $9d9c2a020ee1de94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9d9c2a020ee1de94$var$zh(), $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$Wf), $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$H), $9d9c2a020ee1de94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9d9c2a020ee1de94$var$Bh(b), null;
        case 13:
            $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9d9c2a020ee1de94$var$p(340));
                $9d9c2a020ee1de94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$L), null;
        case 4:
            return $9d9c2a020ee1de94$var$zh(), null;
        case 10:
            return $9d9c2a020ee1de94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $9d9c2a020ee1de94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9d9c2a020ee1de94$var$Jj = !1, $9d9c2a020ee1de94$var$U = !1, $9d9c2a020ee1de94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $9d9c2a020ee1de94$var$V = null;
function $9d9c2a020ee1de94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9d9c2a020ee1de94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9d9c2a020ee1de94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9d9c2a020ee1de94$var$W(a, b, d);
    }
}
var $9d9c2a020ee1de94$var$Nj = !1;
function $9d9c2a020ee1de94$var$Oj(a, b) {
    $9d9c2a020ee1de94$var$Cf = $9d9c2a020ee1de94$var$dd;
    a = $9d9c2a020ee1de94$var$Me();
    if ($9d9c2a020ee1de94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9d9c2a020ee1de94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9d9c2a020ee1de94$var$dd = !1;
    for($9d9c2a020ee1de94$var$V = b; null !== $9d9c2a020ee1de94$var$V;)if (b = $9d9c2a020ee1de94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9d9c2a020ee1de94$var$V = a;
    else for(; null !== $9d9c2a020ee1de94$var$V;){
        b = $9d9c2a020ee1de94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9d9c2a020ee1de94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9d9c2a020ee1de94$var$p(163));
            }
        } catch (F) {
            $9d9c2a020ee1de94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9d9c2a020ee1de94$var$V = a;
            break;
        }
        $9d9c2a020ee1de94$var$V = b.return;
    }
    n = $9d9c2a020ee1de94$var$Nj;
    $9d9c2a020ee1de94$var$Nj = !1;
    return n;
}
function $9d9c2a020ee1de94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9d9c2a020ee1de94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9d9c2a020ee1de94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9d9c2a020ee1de94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9d9c2a020ee1de94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9d9c2a020ee1de94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9d9c2a020ee1de94$var$Of], delete b[$9d9c2a020ee1de94$var$Pf], delete b[$9d9c2a020ee1de94$var$of], delete b[$9d9c2a020ee1de94$var$Qf], delete b[$9d9c2a020ee1de94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9d9c2a020ee1de94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9d9c2a020ee1de94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9d9c2a020ee1de94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9d9c2a020ee1de94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9d9c2a020ee1de94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9d9c2a020ee1de94$var$Vj(a, b, c), a = a.sibling; null !== a;)$9d9c2a020ee1de94$var$Vj(a, b, c), a = a.sibling;
}
function $9d9c2a020ee1de94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9d9c2a020ee1de94$var$Wj(a, b, c), a = a.sibling; null !== a;)$9d9c2a020ee1de94$var$Wj(a, b, c), a = a.sibling;
}
var $9d9c2a020ee1de94$var$X = null, $9d9c2a020ee1de94$var$Xj = !1;
function $9d9c2a020ee1de94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$9d9c2a020ee1de94$var$Zj(a, b, c), c = c.sibling;
}
function $9d9c2a020ee1de94$var$Zj(a, b, c) {
    if ($9d9c2a020ee1de94$var$lc && "function" === typeof $9d9c2a020ee1de94$var$lc.onCommitFiberUnmount) try {
        $9d9c2a020ee1de94$var$lc.onCommitFiberUnmount($9d9c2a020ee1de94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9d9c2a020ee1de94$var$U || $9d9c2a020ee1de94$var$Lj(c, b);
        case 6:
            var d = $9d9c2a020ee1de94$var$X, e = $9d9c2a020ee1de94$var$Xj;
            $9d9c2a020ee1de94$var$X = null;
            $9d9c2a020ee1de94$var$Yj(a, b, c);
            $9d9c2a020ee1de94$var$X = d;
            $9d9c2a020ee1de94$var$Xj = e;
            null !== $9d9c2a020ee1de94$var$X && ($9d9c2a020ee1de94$var$Xj ? (a = $9d9c2a020ee1de94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9d9c2a020ee1de94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9d9c2a020ee1de94$var$X && ($9d9c2a020ee1de94$var$Xj ? (a = $9d9c2a020ee1de94$var$X, c = c.stateNode, 8 === a.nodeType ? $9d9c2a020ee1de94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9d9c2a020ee1de94$var$Kf(a, c), $9d9c2a020ee1de94$var$bd(a)) : $9d9c2a020ee1de94$var$Kf($9d9c2a020ee1de94$var$X, c.stateNode));
            break;
        case 4:
            d = $9d9c2a020ee1de94$var$X;
            e = $9d9c2a020ee1de94$var$Xj;
            $9d9c2a020ee1de94$var$X = c.stateNode.containerInfo;
            $9d9c2a020ee1de94$var$Xj = !0;
            $9d9c2a020ee1de94$var$Yj(a, b, c);
            $9d9c2a020ee1de94$var$X = d;
            $9d9c2a020ee1de94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9d9c2a020ee1de94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9d9c2a020ee1de94$var$Mj(c, b, g) : 0 !== (f & 4) && $9d9c2a020ee1de94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9d9c2a020ee1de94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$9d9c2a020ee1de94$var$U && ($9d9c2a020ee1de94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9d9c2a020ee1de94$var$W(c, b, h);
            }
            $9d9c2a020ee1de94$var$Yj(a, b, c);
            break;
        case 21:
            $9d9c2a020ee1de94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9d9c2a020ee1de94$var$U = (d = $9d9c2a020ee1de94$var$U) || null !== c.memoizedState, $9d9c2a020ee1de94$var$Yj(a, b, c), $9d9c2a020ee1de94$var$U = d) : $9d9c2a020ee1de94$var$Yj(a, b, c);
            break;
        default:
            $9d9c2a020ee1de94$var$Yj(a, b, c);
    }
}
function $9d9c2a020ee1de94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9d9c2a020ee1de94$var$Kj);
        b.forEach(function(b) {
            var d = $9d9c2a020ee1de94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9d9c2a020ee1de94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9d9c2a020ee1de94$var$X = h.stateNode;
                        $9d9c2a020ee1de94$var$Xj = !1;
                        break a;
                    case 3:
                        $9d9c2a020ee1de94$var$X = h.stateNode.containerInfo;
                        $9d9c2a020ee1de94$var$Xj = !0;
                        break a;
                    case 4:
                        $9d9c2a020ee1de94$var$X = h.stateNode.containerInfo;
                        $9d9c2a020ee1de94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9d9c2a020ee1de94$var$X) throw Error($9d9c2a020ee1de94$var$p(160));
            $9d9c2a020ee1de94$var$Zj(f, g, e);
            $9d9c2a020ee1de94$var$X = null;
            $9d9c2a020ee1de94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9d9c2a020ee1de94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9d9c2a020ee1de94$var$dk(b, a), b = b.sibling;
}
function $9d9c2a020ee1de94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            if (d & 4) {
                try {
                    $9d9c2a020ee1de94$var$Pj(3, a, a.return), $9d9c2a020ee1de94$var$Qj(3, a);
                } catch (t) {
                    $9d9c2a020ee1de94$var$W(a, a.return, t);
                }
                try {
                    $9d9c2a020ee1de94$var$Pj(5, a, a.return);
                } catch (t) {
                    $9d9c2a020ee1de94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            d & 512 && null !== c && $9d9c2a020ee1de94$var$Lj(c, c.return);
            break;
        case 5:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            d & 512 && null !== c && $9d9c2a020ee1de94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9d9c2a020ee1de94$var$ob(e, "");
                } catch (t) {
                    $9d9c2a020ee1de94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9d9c2a020ee1de94$var$ab(e, f);
                    $9d9c2a020ee1de94$var$vb(h, g);
                    var l = $9d9c2a020ee1de94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9d9c2a020ee1de94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9d9c2a020ee1de94$var$nb(e, q) : "children" === m ? $9d9c2a020ee1de94$var$ob(e, q) : $9d9c2a020ee1de94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9d9c2a020ee1de94$var$bb(e, f);
                            break;
                        case "textarea":
                            $9d9c2a020ee1de94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9d9c2a020ee1de94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9d9c2a020ee1de94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9d9c2a020ee1de94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9d9c2a020ee1de94$var$Pf] = f;
                } catch (t) {
                    $9d9c2a020ee1de94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9d9c2a020ee1de94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9d9c2a020ee1de94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9d9c2a020ee1de94$var$bd(b.containerInfo);
            } catch (t) {
                $9d9c2a020ee1de94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            break;
        case 13:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9d9c2a020ee1de94$var$fk = $9d9c2a020ee1de94$var$B()));
            d & 4 && $9d9c2a020ee1de94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9d9c2a020ee1de94$var$U = (l = $9d9c2a020ee1de94$var$U) || m, $9d9c2a020ee1de94$var$ck(b, a), $9d9c2a020ee1de94$var$U = l) : $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9d9c2a020ee1de94$var$V = a, m = a.child; null !== m;){
                    for(q = $9d9c2a020ee1de94$var$V = m; null !== $9d9c2a020ee1de94$var$V;){
                        r = $9d9c2a020ee1de94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9d9c2a020ee1de94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $9d9c2a020ee1de94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9d9c2a020ee1de94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9d9c2a020ee1de94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9d9c2a020ee1de94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9d9c2a020ee1de94$var$V = y) : $9d9c2a020ee1de94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9d9c2a020ee1de94$var$rb("display", g));
                            } catch (t) {
                                $9d9c2a020ee1de94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9d9c2a020ee1de94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9d9c2a020ee1de94$var$ck(b, a);
            $9d9c2a020ee1de94$var$ek(a);
            d & 4 && $9d9c2a020ee1de94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $9d9c2a020ee1de94$var$ck(b, a), $9d9c2a020ee1de94$var$ek(a);
    }
}
function $9d9c2a020ee1de94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9d9c2a020ee1de94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9d9c2a020ee1de94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9d9c2a020ee1de94$var$ob(e, ""), d.flags &= -33);
                    var f = $9d9c2a020ee1de94$var$Uj(a);
                    $9d9c2a020ee1de94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9d9c2a020ee1de94$var$Uj(a);
                    $9d9c2a020ee1de94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($9d9c2a020ee1de94$var$p(161));
            }
        } catch (k) {
            $9d9c2a020ee1de94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9d9c2a020ee1de94$var$hk(a, b, c) {
    $9d9c2a020ee1de94$var$V = a;
    $9d9c2a020ee1de94$var$ik(a, b, c);
}
function $9d9c2a020ee1de94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9d9c2a020ee1de94$var$V;){
        var e = $9d9c2a020ee1de94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9d9c2a020ee1de94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9d9c2a020ee1de94$var$U;
                h = $9d9c2a020ee1de94$var$Jj;
                var l = $9d9c2a020ee1de94$var$U;
                $9d9c2a020ee1de94$var$Jj = g;
                if (($9d9c2a020ee1de94$var$U = k) && !l) for($9d9c2a020ee1de94$var$V = e; null !== $9d9c2a020ee1de94$var$V;)g = $9d9c2a020ee1de94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9d9c2a020ee1de94$var$jk(e) : null !== k ? (k.return = g, $9d9c2a020ee1de94$var$V = k) : $9d9c2a020ee1de94$var$jk(e);
                for(; null !== f;)$9d9c2a020ee1de94$var$V = f, $9d9c2a020ee1de94$var$ik(f, b, c), f = f.sibling;
                $9d9c2a020ee1de94$var$V = e;
                $9d9c2a020ee1de94$var$Jj = h;
                $9d9c2a020ee1de94$var$U = l;
            }
            $9d9c2a020ee1de94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9d9c2a020ee1de94$var$V = f) : $9d9c2a020ee1de94$var$kk(a, b, c);
    }
}
function $9d9c2a020ee1de94$var$kk(a) {
    for(; null !== $9d9c2a020ee1de94$var$V;){
        var b = $9d9c2a020ee1de94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9d9c2a020ee1de94$var$U || $9d9c2a020ee1de94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9d9c2a020ee1de94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9d9c2a020ee1de94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9d9c2a020ee1de94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9d9c2a020ee1de94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9d9c2a020ee1de94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9d9c2a020ee1de94$var$p(163));
                }
                $9d9c2a020ee1de94$var$U || b.flags & 512 && $9d9c2a020ee1de94$var$Rj(b);
            } catch (r) {
                $9d9c2a020ee1de94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9d9c2a020ee1de94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9d9c2a020ee1de94$var$V = c;
            break;
        }
        $9d9c2a020ee1de94$var$V = b.return;
    }
}
function $9d9c2a020ee1de94$var$gk(a) {
    for(; null !== $9d9c2a020ee1de94$var$V;){
        var b = $9d9c2a020ee1de94$var$V;
        if (b === a) {
            $9d9c2a020ee1de94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9d9c2a020ee1de94$var$V = c;
            break;
        }
        $9d9c2a020ee1de94$var$V = b.return;
    }
}
function $9d9c2a020ee1de94$var$jk(a) {
    for(; null !== $9d9c2a020ee1de94$var$V;){
        var b = $9d9c2a020ee1de94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9d9c2a020ee1de94$var$Qj(4, b);
                    } catch (k) {
                        $9d9c2a020ee1de94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9d9c2a020ee1de94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9d9c2a020ee1de94$var$Rj(b);
                    } catch (k) {
                        $9d9c2a020ee1de94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9d9c2a020ee1de94$var$Rj(b);
                    } catch (k) {
                        $9d9c2a020ee1de94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9d9c2a020ee1de94$var$W(b, b.return, k);
        }
        if (b === a) {
            $9d9c2a020ee1de94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9d9c2a020ee1de94$var$V = h;
            break;
        }
        $9d9c2a020ee1de94$var$V = b.return;
    }
}
var $9d9c2a020ee1de94$var$lk = Math.ceil, $9d9c2a020ee1de94$var$mk = $9d9c2a020ee1de94$var$ua.ReactCurrentDispatcher, $9d9c2a020ee1de94$var$nk = $9d9c2a020ee1de94$var$ua.ReactCurrentOwner, $9d9c2a020ee1de94$var$ok = $9d9c2a020ee1de94$var$ua.ReactCurrentBatchConfig, $9d9c2a020ee1de94$var$K = 0, $9d9c2a020ee1de94$var$Q = null, $9d9c2a020ee1de94$var$Y = null, $9d9c2a020ee1de94$var$Z = 0, $9d9c2a020ee1de94$var$fj = 0, $9d9c2a020ee1de94$var$ej = $9d9c2a020ee1de94$var$Uf(0), $9d9c2a020ee1de94$var$T = 0, $9d9c2a020ee1de94$var$pk = null, $9d9c2a020ee1de94$var$rh = 0, $9d9c2a020ee1de94$var$qk = 0, $9d9c2a020ee1de94$var$rk = 0, $9d9c2a020ee1de94$var$sk = null, $9d9c2a020ee1de94$var$tk = null, $9d9c2a020ee1de94$var$fk = 0, $9d9c2a020ee1de94$var$Gj = Infinity, $9d9c2a020ee1de94$var$uk = null, $9d9c2a020ee1de94$var$Oi = !1, $9d9c2a020ee1de94$var$Pi = null, $9d9c2a020ee1de94$var$Ri = null, $9d9c2a020ee1de94$var$vk = !1, $9d9c2a020ee1de94$var$wk = null, $9d9c2a020ee1de94$var$xk = 0, $9d9c2a020ee1de94$var$yk = 0, $9d9c2a020ee1de94$var$zk = null, $9d9c2a020ee1de94$var$Ak = -1, $9d9c2a020ee1de94$var$Bk = 0;
function $9d9c2a020ee1de94$var$R() {
    return 0 !== ($9d9c2a020ee1de94$var$K & 6) ? $9d9c2a020ee1de94$var$B() : -1 !== $9d9c2a020ee1de94$var$Ak ? $9d9c2a020ee1de94$var$Ak : $9d9c2a020ee1de94$var$Ak = $9d9c2a020ee1de94$var$B();
}
function $9d9c2a020ee1de94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9d9c2a020ee1de94$var$K & 2) && 0 !== $9d9c2a020ee1de94$var$Z) return $9d9c2a020ee1de94$var$Z & -$9d9c2a020ee1de94$var$Z;
    if (null !== $9d9c2a020ee1de94$var$Kg.transition) return 0 === $9d9c2a020ee1de94$var$Bk && ($9d9c2a020ee1de94$var$Bk = $9d9c2a020ee1de94$var$yc()), $9d9c2a020ee1de94$var$Bk;
    a = $9d9c2a020ee1de94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9d9c2a020ee1de94$var$jd(a.type);
    return a;
}
function $9d9c2a020ee1de94$var$gi(a, b, c, d) {
    if (50 < $9d9c2a020ee1de94$var$yk) throw $9d9c2a020ee1de94$var$yk = 0, $9d9c2a020ee1de94$var$zk = null, Error($9d9c2a020ee1de94$var$p(185));
    $9d9c2a020ee1de94$var$Ac(a, c, d);
    if (0 === ($9d9c2a020ee1de94$var$K & 2) || a !== $9d9c2a020ee1de94$var$Q) a === $9d9c2a020ee1de94$var$Q && (0 === ($9d9c2a020ee1de94$var$K & 2) && ($9d9c2a020ee1de94$var$qk |= c), 4 === $9d9c2a020ee1de94$var$T && $9d9c2a020ee1de94$var$Ck(a, $9d9c2a020ee1de94$var$Z)), $9d9c2a020ee1de94$var$Dk(a, d), 1 === c && 0 === $9d9c2a020ee1de94$var$K && 0 === (b.mode & 1) && ($9d9c2a020ee1de94$var$Gj = $9d9c2a020ee1de94$var$B() + 500, $9d9c2a020ee1de94$var$fg && $9d9c2a020ee1de94$var$jg());
}
function $9d9c2a020ee1de94$var$Dk(a, b) {
    var c = a.callbackNode;
    $9d9c2a020ee1de94$var$wc(a, b);
    var d = $9d9c2a020ee1de94$var$uc(a, a === $9d9c2a020ee1de94$var$Q ? $9d9c2a020ee1de94$var$Z : 0);
    if (0 === d) null !== c && $9d9c2a020ee1de94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9d9c2a020ee1de94$var$bc(c);
        if (1 === b) 0 === a.tag ? $9d9c2a020ee1de94$var$ig($9d9c2a020ee1de94$var$Ek.bind(null, a)) : $9d9c2a020ee1de94$var$hg($9d9c2a020ee1de94$var$Ek.bind(null, a)), $9d9c2a020ee1de94$var$Jf(function() {
            0 === ($9d9c2a020ee1de94$var$K & 6) && $9d9c2a020ee1de94$var$jg();
        }), c = null;
        else {
            switch($9d9c2a020ee1de94$var$Dc(d)){
                case 1:
                    c = $9d9c2a020ee1de94$var$fc;
                    break;
                case 4:
                    c = $9d9c2a020ee1de94$var$gc;
                    break;
                case 16:
                    c = $9d9c2a020ee1de94$var$hc;
                    break;
                case 536870912:
                    c = $9d9c2a020ee1de94$var$jc;
                    break;
                default:
                    c = $9d9c2a020ee1de94$var$hc;
            }
            c = $9d9c2a020ee1de94$var$Fk(c, $9d9c2a020ee1de94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9d9c2a020ee1de94$var$Gk(a, b) {
    $9d9c2a020ee1de94$var$Ak = -1;
    $9d9c2a020ee1de94$var$Bk = 0;
    if (0 !== ($9d9c2a020ee1de94$var$K & 6)) throw Error($9d9c2a020ee1de94$var$p(327));
    var c = a.callbackNode;
    if ($9d9c2a020ee1de94$var$Hk() && a.callbackNode !== c) return null;
    var d = $9d9c2a020ee1de94$var$uc(a, a === $9d9c2a020ee1de94$var$Q ? $9d9c2a020ee1de94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9d9c2a020ee1de94$var$Ik(a, d);
    else {
        b = d;
        var e = $9d9c2a020ee1de94$var$K;
        $9d9c2a020ee1de94$var$K |= 2;
        var f = $9d9c2a020ee1de94$var$Jk();
        if ($9d9c2a020ee1de94$var$Q !== a || $9d9c2a020ee1de94$var$Z !== b) $9d9c2a020ee1de94$var$uk = null, $9d9c2a020ee1de94$var$Gj = $9d9c2a020ee1de94$var$B() + 500, $9d9c2a020ee1de94$var$Kk(a, b);
        for(;;)try {
            $9d9c2a020ee1de94$var$Lk();
            break;
        } catch (h) {
            $9d9c2a020ee1de94$var$Mk(a, h);
        }
        $9d9c2a020ee1de94$var$$g();
        $9d9c2a020ee1de94$var$mk.current = f;
        $9d9c2a020ee1de94$var$K = e;
        null !== $9d9c2a020ee1de94$var$Y ? b = 0 : ($9d9c2a020ee1de94$var$Q = null, $9d9c2a020ee1de94$var$Z = 0, b = $9d9c2a020ee1de94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9d9c2a020ee1de94$var$xc(a), 0 !== e && (d = e, b = $9d9c2a020ee1de94$var$Nk(a, e)));
        if (1 === b) throw c = $9d9c2a020ee1de94$var$pk, $9d9c2a020ee1de94$var$Kk(a, 0), $9d9c2a020ee1de94$var$Ck(a, d), $9d9c2a020ee1de94$var$Dk(a, $9d9c2a020ee1de94$var$B()), c;
        if (6 === b) $9d9c2a020ee1de94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9d9c2a020ee1de94$var$Ok(e) && (b = $9d9c2a020ee1de94$var$Ik(a, d), 2 === b && (f = $9d9c2a020ee1de94$var$xc(a), 0 !== f && (d = f, b = $9d9c2a020ee1de94$var$Nk(a, f))), 1 === b)) throw c = $9d9c2a020ee1de94$var$pk, $9d9c2a020ee1de94$var$Kk(a, 0), $9d9c2a020ee1de94$var$Ck(a, d), $9d9c2a020ee1de94$var$Dk(a, $9d9c2a020ee1de94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9d9c2a020ee1de94$var$p(345));
                case 2:
                    $9d9c2a020ee1de94$var$Pk(a, $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$uk);
                    break;
                case 3:
                    $9d9c2a020ee1de94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $9d9c2a020ee1de94$var$fk + 500 - $9d9c2a020ee1de94$var$B(), 10 < b)) {
                        if (0 !== $9d9c2a020ee1de94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9d9c2a020ee1de94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9d9c2a020ee1de94$var$Ff($9d9c2a020ee1de94$var$Pk.bind(null, a, $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$uk), b);
                        break;
                    }
                    $9d9c2a020ee1de94$var$Pk(a, $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$uk);
                    break;
                case 4:
                    $9d9c2a020ee1de94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9d9c2a020ee1de94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9d9c2a020ee1de94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9d9c2a020ee1de94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9d9c2a020ee1de94$var$Ff($9d9c2a020ee1de94$var$Pk.bind(null, a, $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$uk), d);
                        break;
                    }
                    $9d9c2a020ee1de94$var$Pk(a, $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$uk);
                    break;
                case 5:
                    $9d9c2a020ee1de94$var$Pk(a, $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$uk);
                    break;
                default:
                    throw Error($9d9c2a020ee1de94$var$p(329));
            }
        }
    }
    $9d9c2a020ee1de94$var$Dk(a, $9d9c2a020ee1de94$var$B());
    return a.callbackNode === c ? $9d9c2a020ee1de94$var$Gk.bind(null, a) : null;
}
function $9d9c2a020ee1de94$var$Nk(a, b) {
    var c = $9d9c2a020ee1de94$var$sk;
    a.current.memoizedState.isDehydrated && ($9d9c2a020ee1de94$var$Kk(a, b).flags |= 256);
    a = $9d9c2a020ee1de94$var$Ik(a, b);
    2 !== a && (b = $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$tk = c, null !== b && $9d9c2a020ee1de94$var$Fj(b));
    return a;
}
function $9d9c2a020ee1de94$var$Fj(a) {
    null === $9d9c2a020ee1de94$var$tk ? $9d9c2a020ee1de94$var$tk = a : $9d9c2a020ee1de94$var$tk.push.apply($9d9c2a020ee1de94$var$tk, a);
}
function $9d9c2a020ee1de94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9d9c2a020ee1de94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9d9c2a020ee1de94$var$Ck(a, b) {
    b &= ~$9d9c2a020ee1de94$var$rk;
    b &= ~$9d9c2a020ee1de94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9d9c2a020ee1de94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9d9c2a020ee1de94$var$Ek(a) {
    if (0 !== ($9d9c2a020ee1de94$var$K & 6)) throw Error($9d9c2a020ee1de94$var$p(327));
    $9d9c2a020ee1de94$var$Hk();
    var b = $9d9c2a020ee1de94$var$uc(a, 0);
    if (0 === (b & 1)) return $9d9c2a020ee1de94$var$Dk(a, $9d9c2a020ee1de94$var$B()), null;
    var c = $9d9c2a020ee1de94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9d9c2a020ee1de94$var$xc(a);
        0 !== d && (b = d, c = $9d9c2a020ee1de94$var$Nk(a, d));
    }
    if (1 === c) throw c = $9d9c2a020ee1de94$var$pk, $9d9c2a020ee1de94$var$Kk(a, 0), $9d9c2a020ee1de94$var$Ck(a, b), $9d9c2a020ee1de94$var$Dk(a, $9d9c2a020ee1de94$var$B()), c;
    if (6 === c) throw Error($9d9c2a020ee1de94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9d9c2a020ee1de94$var$Pk(a, $9d9c2a020ee1de94$var$tk, $9d9c2a020ee1de94$var$uk);
    $9d9c2a020ee1de94$var$Dk(a, $9d9c2a020ee1de94$var$B());
    return null;
}
function $9d9c2a020ee1de94$var$Qk(a, b) {
    var c = $9d9c2a020ee1de94$var$K;
    $9d9c2a020ee1de94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9d9c2a020ee1de94$var$K = c, 0 === $9d9c2a020ee1de94$var$K && ($9d9c2a020ee1de94$var$Gj = $9d9c2a020ee1de94$var$B() + 500, $9d9c2a020ee1de94$var$fg && $9d9c2a020ee1de94$var$jg());
    }
}
function $9d9c2a020ee1de94$var$Rk(a) {
    null !== $9d9c2a020ee1de94$var$wk && 0 === $9d9c2a020ee1de94$var$wk.tag && 0 === ($9d9c2a020ee1de94$var$K & 6) && $9d9c2a020ee1de94$var$Hk();
    var b = $9d9c2a020ee1de94$var$K;
    $9d9c2a020ee1de94$var$K |= 1;
    var c = $9d9c2a020ee1de94$var$ok.transition, d = $9d9c2a020ee1de94$var$C;
    try {
        if ($9d9c2a020ee1de94$var$ok.transition = null, $9d9c2a020ee1de94$var$C = 1, a) return a();
    } finally{
        $9d9c2a020ee1de94$var$C = d, $9d9c2a020ee1de94$var$ok.transition = c, $9d9c2a020ee1de94$var$K = b, 0 === ($9d9c2a020ee1de94$var$K & 6) && $9d9c2a020ee1de94$var$jg();
    }
}
function $9d9c2a020ee1de94$var$Hj() {
    $9d9c2a020ee1de94$var$fj = $9d9c2a020ee1de94$var$ej.current;
    $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$ej);
}
function $9d9c2a020ee1de94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9d9c2a020ee1de94$var$Gf(c));
    if (null !== $9d9c2a020ee1de94$var$Y) for(c = $9d9c2a020ee1de94$var$Y.return; null !== c;){
        var d = c;
        $9d9c2a020ee1de94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9d9c2a020ee1de94$var$$f();
                break;
            case 3:
                $9d9c2a020ee1de94$var$zh();
                $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$Wf);
                $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$H);
                $9d9c2a020ee1de94$var$Eh();
                break;
            case 5:
                $9d9c2a020ee1de94$var$Bh(d);
                break;
            case 4:
                $9d9c2a020ee1de94$var$zh();
                break;
            case 13:
                $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$L);
                break;
            case 19:
                $9d9c2a020ee1de94$var$E($9d9c2a020ee1de94$var$L);
                break;
            case 10:
                $9d9c2a020ee1de94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $9d9c2a020ee1de94$var$Hj();
        }
        c = c.return;
    }
    $9d9c2a020ee1de94$var$Q = a;
    $9d9c2a020ee1de94$var$Y = a = $9d9c2a020ee1de94$var$Pg(a.current, null);
    $9d9c2a020ee1de94$var$Z = $9d9c2a020ee1de94$var$fj = b;
    $9d9c2a020ee1de94$var$T = 0;
    $9d9c2a020ee1de94$var$pk = null;
    $9d9c2a020ee1de94$var$rk = $9d9c2a020ee1de94$var$qk = $9d9c2a020ee1de94$var$rh = 0;
    $9d9c2a020ee1de94$var$tk = $9d9c2a020ee1de94$var$sk = null;
    if (null !== $9d9c2a020ee1de94$var$fh) {
        for(b = 0; b < $9d9c2a020ee1de94$var$fh.length; b++)if (c = $9d9c2a020ee1de94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9d9c2a020ee1de94$var$fh = null;
    }
    return a;
}
function $9d9c2a020ee1de94$var$Mk(a, b) {
    do {
        var c = $9d9c2a020ee1de94$var$Y;
        try {
            $9d9c2a020ee1de94$var$$g();
            $9d9c2a020ee1de94$var$Fh.current = $9d9c2a020ee1de94$var$Rh;
            if ($9d9c2a020ee1de94$var$Ih) {
                for(var d = $9d9c2a020ee1de94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9d9c2a020ee1de94$var$Ih = !1;
            }
            $9d9c2a020ee1de94$var$Hh = 0;
            $9d9c2a020ee1de94$var$O = $9d9c2a020ee1de94$var$N = $9d9c2a020ee1de94$var$M = null;
            $9d9c2a020ee1de94$var$Jh = !1;
            $9d9c2a020ee1de94$var$Kh = 0;
            $9d9c2a020ee1de94$var$nk.current = null;
            if (null === c || null === c.return) {
                $9d9c2a020ee1de94$var$T = 1;
                $9d9c2a020ee1de94$var$pk = b;
                $9d9c2a020ee1de94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9d9c2a020ee1de94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9d9c2a020ee1de94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9d9c2a020ee1de94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $9d9c2a020ee1de94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9d9c2a020ee1de94$var$Si(f, l, b);
                            $9d9c2a020ee1de94$var$tj();
                            break a;
                        }
                        k = Error($9d9c2a020ee1de94$var$p(426));
                    }
                } else if ($9d9c2a020ee1de94$var$I && h.mode & 1) {
                    var J = $9d9c2a020ee1de94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9d9c2a020ee1de94$var$Vi(J, g, h, f, b);
                        $9d9c2a020ee1de94$var$Jg($9d9c2a020ee1de94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $9d9c2a020ee1de94$var$Ji(k, h);
                4 !== $9d9c2a020ee1de94$var$T && ($9d9c2a020ee1de94$var$T = 2);
                null === $9d9c2a020ee1de94$var$sk ? $9d9c2a020ee1de94$var$sk = [
                    f
                ] : $9d9c2a020ee1de94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9d9c2a020ee1de94$var$Ni(f, k, b);
                            $9d9c2a020ee1de94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9d9c2a020ee1de94$var$Ri || !$9d9c2a020ee1de94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9d9c2a020ee1de94$var$Qi(f, h, b);
                                $9d9c2a020ee1de94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9d9c2a020ee1de94$var$Sk(c);
        } catch (na) {
            b = na;
            $9d9c2a020ee1de94$var$Y === c && null !== c && ($9d9c2a020ee1de94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9d9c2a020ee1de94$var$Jk() {
    var a = $9d9c2a020ee1de94$var$mk.current;
    $9d9c2a020ee1de94$var$mk.current = $9d9c2a020ee1de94$var$Rh;
    return null === a ? $9d9c2a020ee1de94$var$Rh : a;
}
function $9d9c2a020ee1de94$var$tj() {
    if (0 === $9d9c2a020ee1de94$var$T || 3 === $9d9c2a020ee1de94$var$T || 2 === $9d9c2a020ee1de94$var$T) $9d9c2a020ee1de94$var$T = 4;
    null === $9d9c2a020ee1de94$var$Q || 0 === ($9d9c2a020ee1de94$var$rh & 268435455) && 0 === ($9d9c2a020ee1de94$var$qk & 268435455) || $9d9c2a020ee1de94$var$Ck($9d9c2a020ee1de94$var$Q, $9d9c2a020ee1de94$var$Z);
}
function $9d9c2a020ee1de94$var$Ik(a, b) {
    var c = $9d9c2a020ee1de94$var$K;
    $9d9c2a020ee1de94$var$K |= 2;
    var d = $9d9c2a020ee1de94$var$Jk();
    if ($9d9c2a020ee1de94$var$Q !== a || $9d9c2a020ee1de94$var$Z !== b) $9d9c2a020ee1de94$var$uk = null, $9d9c2a020ee1de94$var$Kk(a, b);
    for(;;)try {
        $9d9c2a020ee1de94$var$Tk();
        break;
    } catch (e) {
        $9d9c2a020ee1de94$var$Mk(a, e);
    }
    $9d9c2a020ee1de94$var$$g();
    $9d9c2a020ee1de94$var$K = c;
    $9d9c2a020ee1de94$var$mk.current = d;
    if (null !== $9d9c2a020ee1de94$var$Y) throw Error($9d9c2a020ee1de94$var$p(261));
    $9d9c2a020ee1de94$var$Q = null;
    $9d9c2a020ee1de94$var$Z = 0;
    return $9d9c2a020ee1de94$var$T;
}
function $9d9c2a020ee1de94$var$Tk() {
    for(; null !== $9d9c2a020ee1de94$var$Y;)$9d9c2a020ee1de94$var$Uk($9d9c2a020ee1de94$var$Y);
}
function $9d9c2a020ee1de94$var$Lk() {
    for(; null !== $9d9c2a020ee1de94$var$Y && !$9d9c2a020ee1de94$var$cc();)$9d9c2a020ee1de94$var$Uk($9d9c2a020ee1de94$var$Y);
}
function $9d9c2a020ee1de94$var$Uk(a) {
    var b = $9d9c2a020ee1de94$var$Vk(a.alternate, a, $9d9c2a020ee1de94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9d9c2a020ee1de94$var$Sk(a) : $9d9c2a020ee1de94$var$Y = b;
    $9d9c2a020ee1de94$var$nk.current = null;
}
function $9d9c2a020ee1de94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9d9c2a020ee1de94$var$Ej(c, b, $9d9c2a020ee1de94$var$fj), null !== c) {
                $9d9c2a020ee1de94$var$Y = c;
                return;
            }
        } else {
            c = $9d9c2a020ee1de94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9d9c2a020ee1de94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9d9c2a020ee1de94$var$T = 6;
                $9d9c2a020ee1de94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9d9c2a020ee1de94$var$Y = b;
            return;
        }
        $9d9c2a020ee1de94$var$Y = b = a;
    }while (null !== b);
    0 === $9d9c2a020ee1de94$var$T && ($9d9c2a020ee1de94$var$T = 5);
}
function $9d9c2a020ee1de94$var$Pk(a, b, c) {
    var d = $9d9c2a020ee1de94$var$C, e = $9d9c2a020ee1de94$var$ok.transition;
    try {
        $9d9c2a020ee1de94$var$ok.transition = null, $9d9c2a020ee1de94$var$C = 1, $9d9c2a020ee1de94$var$Wk(a, b, c, d);
    } finally{
        $9d9c2a020ee1de94$var$ok.transition = e, $9d9c2a020ee1de94$var$C = d;
    }
    return null;
}
function $9d9c2a020ee1de94$var$Wk(a, b, c, d) {
    do $9d9c2a020ee1de94$var$Hk();
    while (null !== $9d9c2a020ee1de94$var$wk);
    if (0 !== ($9d9c2a020ee1de94$var$K & 6)) throw Error($9d9c2a020ee1de94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9d9c2a020ee1de94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9d9c2a020ee1de94$var$Bc(a, f);
    a === $9d9c2a020ee1de94$var$Q && ($9d9c2a020ee1de94$var$Y = $9d9c2a020ee1de94$var$Q = null, $9d9c2a020ee1de94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9d9c2a020ee1de94$var$vk || ($9d9c2a020ee1de94$var$vk = !0, $9d9c2a020ee1de94$var$Fk($9d9c2a020ee1de94$var$hc, function() {
        $9d9c2a020ee1de94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9d9c2a020ee1de94$var$ok.transition;
        $9d9c2a020ee1de94$var$ok.transition = null;
        var g = $9d9c2a020ee1de94$var$C;
        $9d9c2a020ee1de94$var$C = 1;
        var h = $9d9c2a020ee1de94$var$K;
        $9d9c2a020ee1de94$var$K |= 4;
        $9d9c2a020ee1de94$var$nk.current = null;
        $9d9c2a020ee1de94$var$Oj(a, c);
        $9d9c2a020ee1de94$var$dk(c, a);
        $9d9c2a020ee1de94$var$Oe($9d9c2a020ee1de94$var$Df);
        $9d9c2a020ee1de94$var$dd = !!$9d9c2a020ee1de94$var$Cf;
        $9d9c2a020ee1de94$var$Df = $9d9c2a020ee1de94$var$Cf = null;
        a.current = c;
        $9d9c2a020ee1de94$var$hk(c, a, e);
        $9d9c2a020ee1de94$var$dc();
        $9d9c2a020ee1de94$var$K = h;
        $9d9c2a020ee1de94$var$C = g;
        $9d9c2a020ee1de94$var$ok.transition = f;
    } else a.current = c;
    $9d9c2a020ee1de94$var$vk && ($9d9c2a020ee1de94$var$vk = !1, $9d9c2a020ee1de94$var$wk = a, $9d9c2a020ee1de94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($9d9c2a020ee1de94$var$Ri = null);
    $9d9c2a020ee1de94$var$mc(c.stateNode, d);
    $9d9c2a020ee1de94$var$Dk(a, $9d9c2a020ee1de94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9d9c2a020ee1de94$var$Oi) throw $9d9c2a020ee1de94$var$Oi = !1, a = $9d9c2a020ee1de94$var$Pi, $9d9c2a020ee1de94$var$Pi = null, a;
    0 !== ($9d9c2a020ee1de94$var$xk & 1) && 0 !== a.tag && $9d9c2a020ee1de94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9d9c2a020ee1de94$var$zk ? $9d9c2a020ee1de94$var$yk++ : ($9d9c2a020ee1de94$var$yk = 0, $9d9c2a020ee1de94$var$zk = a) : $9d9c2a020ee1de94$var$yk = 0;
    $9d9c2a020ee1de94$var$jg();
    return null;
}
function $9d9c2a020ee1de94$var$Hk() {
    if (null !== $9d9c2a020ee1de94$var$wk) {
        var a = $9d9c2a020ee1de94$var$Dc($9d9c2a020ee1de94$var$xk), b = $9d9c2a020ee1de94$var$ok.transition, c = $9d9c2a020ee1de94$var$C;
        try {
            $9d9c2a020ee1de94$var$ok.transition = null;
            $9d9c2a020ee1de94$var$C = 16 > a ? 16 : a;
            if (null === $9d9c2a020ee1de94$var$wk) var d = !1;
            else {
                a = $9d9c2a020ee1de94$var$wk;
                $9d9c2a020ee1de94$var$wk = null;
                $9d9c2a020ee1de94$var$xk = 0;
                if (0 !== ($9d9c2a020ee1de94$var$K & 6)) throw Error($9d9c2a020ee1de94$var$p(331));
                var e = $9d9c2a020ee1de94$var$K;
                $9d9c2a020ee1de94$var$K |= 4;
                for($9d9c2a020ee1de94$var$V = a.current; null !== $9d9c2a020ee1de94$var$V;){
                    var f = $9d9c2a020ee1de94$var$V, g = f.child;
                    if (0 !== ($9d9c2a020ee1de94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9d9c2a020ee1de94$var$V = l; null !== $9d9c2a020ee1de94$var$V;){
                                    var m = $9d9c2a020ee1de94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9d9c2a020ee1de94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9d9c2a020ee1de94$var$V = q;
                                    else for(; null !== $9d9c2a020ee1de94$var$V;){
                                        m = $9d9c2a020ee1de94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9d9c2a020ee1de94$var$Sj(m);
                                        if (m === l) {
                                            $9d9c2a020ee1de94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9d9c2a020ee1de94$var$V = r;
                                            break;
                                        }
                                        $9d9c2a020ee1de94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9d9c2a020ee1de94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9d9c2a020ee1de94$var$V = g;
                    else b: for(; null !== $9d9c2a020ee1de94$var$V;){
                        f = $9d9c2a020ee1de94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9d9c2a020ee1de94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9d9c2a020ee1de94$var$V = x;
                            break b;
                        }
                        $9d9c2a020ee1de94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9d9c2a020ee1de94$var$V = w; null !== $9d9c2a020ee1de94$var$V;){
                    g = $9d9c2a020ee1de94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9d9c2a020ee1de94$var$V = u;
                    else b: for(g = w; null !== $9d9c2a020ee1de94$var$V;){
                        h = $9d9c2a020ee1de94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9d9c2a020ee1de94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $9d9c2a020ee1de94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9d9c2a020ee1de94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9d9c2a020ee1de94$var$V = F;
                            break b;
                        }
                        $9d9c2a020ee1de94$var$V = h.return;
                    }
                }
                $9d9c2a020ee1de94$var$K = e;
                $9d9c2a020ee1de94$var$jg();
                if ($9d9c2a020ee1de94$var$lc && "function" === typeof $9d9c2a020ee1de94$var$lc.onPostCommitFiberRoot) try {
                    $9d9c2a020ee1de94$var$lc.onPostCommitFiberRoot($9d9c2a020ee1de94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9d9c2a020ee1de94$var$C = c, $9d9c2a020ee1de94$var$ok.transition = b;
        }
    }
    return !1;
}
function $9d9c2a020ee1de94$var$Xk(a, b, c) {
    b = $9d9c2a020ee1de94$var$Ji(c, b);
    b = $9d9c2a020ee1de94$var$Ni(a, b, 1);
    a = $9d9c2a020ee1de94$var$nh(a, b, 1);
    b = $9d9c2a020ee1de94$var$R();
    null !== a && ($9d9c2a020ee1de94$var$Ac(a, 1, b), $9d9c2a020ee1de94$var$Dk(a, b));
}
function $9d9c2a020ee1de94$var$W(a, b, c) {
    if (3 === a.tag) $9d9c2a020ee1de94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9d9c2a020ee1de94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9d9c2a020ee1de94$var$Ri || !$9d9c2a020ee1de94$var$Ri.has(d))) {
                a = $9d9c2a020ee1de94$var$Ji(c, a);
                a = $9d9c2a020ee1de94$var$Qi(b, a, 1);
                b = $9d9c2a020ee1de94$var$nh(b, a, 1);
                a = $9d9c2a020ee1de94$var$R();
                null !== b && ($9d9c2a020ee1de94$var$Ac(b, 1, a), $9d9c2a020ee1de94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9d9c2a020ee1de94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9d9c2a020ee1de94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $9d9c2a020ee1de94$var$Q === a && ($9d9c2a020ee1de94$var$Z & c) === c && (4 === $9d9c2a020ee1de94$var$T || 3 === $9d9c2a020ee1de94$var$T && ($9d9c2a020ee1de94$var$Z & 130023424) === $9d9c2a020ee1de94$var$Z && 500 > $9d9c2a020ee1de94$var$B() - $9d9c2a020ee1de94$var$fk ? $9d9c2a020ee1de94$var$Kk(a, 0) : $9d9c2a020ee1de94$var$rk |= c);
    $9d9c2a020ee1de94$var$Dk(a, b);
}
function $9d9c2a020ee1de94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9d9c2a020ee1de94$var$sc, $9d9c2a020ee1de94$var$sc <<= 1, 0 === ($9d9c2a020ee1de94$var$sc & 130023424) && ($9d9c2a020ee1de94$var$sc = 4194304)));
    var c = $9d9c2a020ee1de94$var$R();
    a = $9d9c2a020ee1de94$var$ih(a, b);
    null !== a && ($9d9c2a020ee1de94$var$Ac(a, b, c), $9d9c2a020ee1de94$var$Dk(a, c));
}
function $9d9c2a020ee1de94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9d9c2a020ee1de94$var$Yk(a, c);
}
function $9d9c2a020ee1de94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9d9c2a020ee1de94$var$p(314));
    }
    null !== d && d.delete(b);
    $9d9c2a020ee1de94$var$Yk(a, c);
}
var $9d9c2a020ee1de94$var$Vk;
$9d9c2a020ee1de94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9d9c2a020ee1de94$var$Wf.current) $9d9c2a020ee1de94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9d9c2a020ee1de94$var$dh = !1, $9d9c2a020ee1de94$var$yj(a, b, c);
            $9d9c2a020ee1de94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9d9c2a020ee1de94$var$dh = !1, $9d9c2a020ee1de94$var$I && 0 !== (b.flags & 1048576) && $9d9c2a020ee1de94$var$ug(b, $9d9c2a020ee1de94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9d9c2a020ee1de94$var$ij(a, b);
            a = b.pendingProps;
            var e = $9d9c2a020ee1de94$var$Yf(b, $9d9c2a020ee1de94$var$H.current);
            $9d9c2a020ee1de94$var$ch(b, c);
            e = $9d9c2a020ee1de94$var$Nh(null, b, d, a, e, c);
            var f = $9d9c2a020ee1de94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9d9c2a020ee1de94$var$Zf(d) ? (f = !0, $9d9c2a020ee1de94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9d9c2a020ee1de94$var$kh(b), e.updater = $9d9c2a020ee1de94$var$Ei, b.stateNode = e, e._reactInternals = b, $9d9c2a020ee1de94$var$Ii(b, d, a, c), b = $9d9c2a020ee1de94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $9d9c2a020ee1de94$var$I && f && $9d9c2a020ee1de94$var$vg(b), $9d9c2a020ee1de94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9d9c2a020ee1de94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9d9c2a020ee1de94$var$Zk(d);
                a = $9d9c2a020ee1de94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $9d9c2a020ee1de94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9d9c2a020ee1de94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9d9c2a020ee1de94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9d9c2a020ee1de94$var$$i(null, b, d, $9d9c2a020ee1de94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($9d9c2a020ee1de94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d9c2a020ee1de94$var$Ci(d, e), $9d9c2a020ee1de94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d9c2a020ee1de94$var$Ci(d, e), $9d9c2a020ee1de94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $9d9c2a020ee1de94$var$kj(b);
                if (null === a) throw Error($9d9c2a020ee1de94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9d9c2a020ee1de94$var$lh(a, b);
                $9d9c2a020ee1de94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9d9c2a020ee1de94$var$Ji(Error($9d9c2a020ee1de94$var$p(423)), b);
                        b = $9d9c2a020ee1de94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9d9c2a020ee1de94$var$Ji(Error($9d9c2a020ee1de94$var$p(424)), b);
                        b = $9d9c2a020ee1de94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($9d9c2a020ee1de94$var$yg = $9d9c2a020ee1de94$var$Lf(b.stateNode.containerInfo.firstChild), $9d9c2a020ee1de94$var$xg = b, $9d9c2a020ee1de94$var$I = !0, $9d9c2a020ee1de94$var$zg = null, c = $9d9c2a020ee1de94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9d9c2a020ee1de94$var$Ig();
                    if (d === e) {
                        b = $9d9c2a020ee1de94$var$Zi(a, b, c);
                        break a;
                    }
                    $9d9c2a020ee1de94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9d9c2a020ee1de94$var$Ah(b), null === a && $9d9c2a020ee1de94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9d9c2a020ee1de94$var$Ef(d, e) ? g = null : null !== f && $9d9c2a020ee1de94$var$Ef(d, f) && (b.flags |= 32), $9d9c2a020ee1de94$var$gj(a, b), $9d9c2a020ee1de94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $9d9c2a020ee1de94$var$Eg(b), null;
        case 13:
            return $9d9c2a020ee1de94$var$oj(a, b, c);
        case 4:
            return $9d9c2a020ee1de94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9d9c2a020ee1de94$var$Ug(b, null, d, c) : $9d9c2a020ee1de94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d9c2a020ee1de94$var$Ci(d, e), $9d9c2a020ee1de94$var$Yi(a, b, d, e, c);
        case 7:
            return $9d9c2a020ee1de94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9d9c2a020ee1de94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9d9c2a020ee1de94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9d9c2a020ee1de94$var$G($9d9c2a020ee1de94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9d9c2a020ee1de94$var$He(f.value, g)) {
                        if (f.children === e.children && !$9d9c2a020ee1de94$var$Wf.current) {
                            b = $9d9c2a020ee1de94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9d9c2a020ee1de94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9d9c2a020ee1de94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9d9c2a020ee1de94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9d9c2a020ee1de94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9d9c2a020ee1de94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9d9c2a020ee1de94$var$ch(b, c), e = $9d9c2a020ee1de94$var$eh(e), d = d(e), b.flags |= 1, $9d9c2a020ee1de94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9d9c2a020ee1de94$var$Ci(d, b.pendingProps), e = $9d9c2a020ee1de94$var$Ci(d.type, e), $9d9c2a020ee1de94$var$$i(a, b, d, e, c);
        case 15:
            return $9d9c2a020ee1de94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9d9c2a020ee1de94$var$Ci(d, e), $9d9c2a020ee1de94$var$ij(a, b), b.tag = 1, $9d9c2a020ee1de94$var$Zf(d) ? (a = !0, $9d9c2a020ee1de94$var$cg(b)) : a = !1, $9d9c2a020ee1de94$var$ch(b, c), $9d9c2a020ee1de94$var$Gi(b, d, e), $9d9c2a020ee1de94$var$Ii(b, d, e, c), $9d9c2a020ee1de94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $9d9c2a020ee1de94$var$xj(a, b, c);
        case 22:
            return $9d9c2a020ee1de94$var$dj(a, b, c);
    }
    throw Error($9d9c2a020ee1de94$var$p(156, b.tag));
};
function $9d9c2a020ee1de94$var$Fk(a, b) {
    return $9d9c2a020ee1de94$var$ac(a, b);
}
function $9d9c2a020ee1de94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9d9c2a020ee1de94$var$Bg(a, b, c, d) {
    return new $9d9c2a020ee1de94$var$$k(a, b, c, d);
}
function $9d9c2a020ee1de94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9d9c2a020ee1de94$var$Zk(a) {
    if ("function" === typeof a) return $9d9c2a020ee1de94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9d9c2a020ee1de94$var$Da) return 11;
        if (a === $9d9c2a020ee1de94$var$Ga) return 14;
    }
    return 2;
}
function $9d9c2a020ee1de94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $9d9c2a020ee1de94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9d9c2a020ee1de94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9d9c2a020ee1de94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9d9c2a020ee1de94$var$ya:
            return $9d9c2a020ee1de94$var$Tg(c.children, e, f, b);
        case $9d9c2a020ee1de94$var$za:
            g = 8;
            e |= 8;
            break;
        case $9d9c2a020ee1de94$var$Aa:
            return a = $9d9c2a020ee1de94$var$Bg(12, c, b, e | 2), a.elementType = $9d9c2a020ee1de94$var$Aa, a.lanes = f, a;
        case $9d9c2a020ee1de94$var$Ea:
            return a = $9d9c2a020ee1de94$var$Bg(13, c, b, e), a.elementType = $9d9c2a020ee1de94$var$Ea, a.lanes = f, a;
        case $9d9c2a020ee1de94$var$Fa:
            return a = $9d9c2a020ee1de94$var$Bg(19, c, b, e), a.elementType = $9d9c2a020ee1de94$var$Fa, a.lanes = f, a;
        case $9d9c2a020ee1de94$var$Ia:
            return $9d9c2a020ee1de94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9d9c2a020ee1de94$var$Ba:
                    g = 10;
                    break a;
                case $9d9c2a020ee1de94$var$Ca:
                    g = 9;
                    break a;
                case $9d9c2a020ee1de94$var$Da:
                    g = 11;
                    break a;
                case $9d9c2a020ee1de94$var$Ga:
                    g = 14;
                    break a;
                case $9d9c2a020ee1de94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9d9c2a020ee1de94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9d9c2a020ee1de94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9d9c2a020ee1de94$var$Tg(a, b, c, d) {
    a = $9d9c2a020ee1de94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9d9c2a020ee1de94$var$pj(a, b, c, d) {
    a = $9d9c2a020ee1de94$var$Bg(22, a, d, b);
    a.elementType = $9d9c2a020ee1de94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9d9c2a020ee1de94$var$Qg(a, b, c) {
    a = $9d9c2a020ee1de94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9d9c2a020ee1de94$var$Sg(a, b, c) {
    b = $9d9c2a020ee1de94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9d9c2a020ee1de94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9d9c2a020ee1de94$var$zc(0);
    this.expirationTimes = $9d9c2a020ee1de94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9d9c2a020ee1de94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9d9c2a020ee1de94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $9d9c2a020ee1de94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9d9c2a020ee1de94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9d9c2a020ee1de94$var$kh(f);
    return a;
}
function $9d9c2a020ee1de94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9d9c2a020ee1de94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9d9c2a020ee1de94$var$dl(a) {
    if (!a) return $9d9c2a020ee1de94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9d9c2a020ee1de94$var$Vb(a) !== a || 1 !== a.tag) throw Error($9d9c2a020ee1de94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9d9c2a020ee1de94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9d9c2a020ee1de94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9d9c2a020ee1de94$var$Zf(c)) return $9d9c2a020ee1de94$var$bg(a, c, b);
    }
    return b;
}
function $9d9c2a020ee1de94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $9d9c2a020ee1de94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $9d9c2a020ee1de94$var$dl(null);
    c = a.current;
    d = $9d9c2a020ee1de94$var$R();
    e = $9d9c2a020ee1de94$var$yi(c);
    f = $9d9c2a020ee1de94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9d9c2a020ee1de94$var$nh(c, f, e);
    a.current.lanes = e;
    $9d9c2a020ee1de94$var$Ac(a, e, d);
    $9d9c2a020ee1de94$var$Dk(a, d);
    return a;
}
function $9d9c2a020ee1de94$var$fl(a, b, c, d) {
    var e = b.current, f = $9d9c2a020ee1de94$var$R(), g = $9d9c2a020ee1de94$var$yi(e);
    c = $9d9c2a020ee1de94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9d9c2a020ee1de94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9d9c2a020ee1de94$var$nh(e, b, g);
    null !== a && ($9d9c2a020ee1de94$var$gi(a, e, g, f), $9d9c2a020ee1de94$var$oh(a, e, g));
    return g;
}
function $9d9c2a020ee1de94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9d9c2a020ee1de94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9d9c2a020ee1de94$var$il(a, b) {
    $9d9c2a020ee1de94$var$hl(a, b);
    (a = a.alternate) && $9d9c2a020ee1de94$var$hl(a, b);
}
function $9d9c2a020ee1de94$var$jl() {
    return null;
}
var $9d9c2a020ee1de94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9d9c2a020ee1de94$var$ll(a) {
    this._internalRoot = a;
}
$9d9c2a020ee1de94$var$ml.prototype.render = $9d9c2a020ee1de94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9d9c2a020ee1de94$var$p(409));
    $9d9c2a020ee1de94$var$fl(a, b, null, null);
};
$9d9c2a020ee1de94$var$ml.prototype.unmount = $9d9c2a020ee1de94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9d9c2a020ee1de94$var$Rk(function() {
            $9d9c2a020ee1de94$var$fl(null, a, null, null);
        });
        b[$9d9c2a020ee1de94$var$uf] = null;
    }
};
function $9d9c2a020ee1de94$var$ml(a) {
    this._internalRoot = a;
}
$9d9c2a020ee1de94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9d9c2a020ee1de94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9d9c2a020ee1de94$var$Qc.length && 0 !== b && b < $9d9c2a020ee1de94$var$Qc[c].priority; c++);
        $9d9c2a020ee1de94$var$Qc.splice(c, 0, a);
        0 === c && $9d9c2a020ee1de94$var$Vc(a);
    }
};
function $9d9c2a020ee1de94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9d9c2a020ee1de94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9d9c2a020ee1de94$var$pl() {}
function $9d9c2a020ee1de94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9d9c2a020ee1de94$var$gl(g);
                f.call(a);
            };
        }
        var g = $9d9c2a020ee1de94$var$el(b, d, a, 0, null, !1, !1, "", $9d9c2a020ee1de94$var$pl);
        a._reactRootContainer = g;
        a[$9d9c2a020ee1de94$var$uf] = g.current;
        $9d9c2a020ee1de94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9d9c2a020ee1de94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9d9c2a020ee1de94$var$gl(k);
            h.call(a);
        };
    }
    var k = $9d9c2a020ee1de94$var$bl(a, 0, !1, null, null, !1, !1, "", $9d9c2a020ee1de94$var$pl);
    a._reactRootContainer = k;
    a[$9d9c2a020ee1de94$var$uf] = k.current;
    $9d9c2a020ee1de94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9d9c2a020ee1de94$var$Rk(function() {
        $9d9c2a020ee1de94$var$fl(b, k, c, d);
    });
    return k;
}
function $9d9c2a020ee1de94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9d9c2a020ee1de94$var$gl(g);
                h.call(a);
            };
        }
        $9d9c2a020ee1de94$var$fl(b, g, a, e);
    } else g = $9d9c2a020ee1de94$var$ql(c, b, a, e, d);
    return $9d9c2a020ee1de94$var$gl(g);
}
$9d9c2a020ee1de94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9d9c2a020ee1de94$var$tc(b.pendingLanes);
                0 !== c && ($9d9c2a020ee1de94$var$Cc(b, c | 1), $9d9c2a020ee1de94$var$Dk(b, $9d9c2a020ee1de94$var$B()), 0 === ($9d9c2a020ee1de94$var$K & 6) && ($9d9c2a020ee1de94$var$Gj = $9d9c2a020ee1de94$var$B() + 500, $9d9c2a020ee1de94$var$jg()));
            }
            break;
        case 13:
            $9d9c2a020ee1de94$var$Rk(function() {
                var b = $9d9c2a020ee1de94$var$ih(a, 1);
                if (null !== b) {
                    var c = $9d9c2a020ee1de94$var$R();
                    $9d9c2a020ee1de94$var$gi(b, a, 1, c);
                }
            }), $9d9c2a020ee1de94$var$il(a, 1);
    }
};
$9d9c2a020ee1de94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9d9c2a020ee1de94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $9d9c2a020ee1de94$var$R();
            $9d9c2a020ee1de94$var$gi(b, a, 134217728, c);
        }
        $9d9c2a020ee1de94$var$il(a, 134217728);
    }
};
$9d9c2a020ee1de94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9d9c2a020ee1de94$var$yi(a), c = $9d9c2a020ee1de94$var$ih(a, b);
        if (null !== c) {
            var d = $9d9c2a020ee1de94$var$R();
            $9d9c2a020ee1de94$var$gi(c, a, b, d);
        }
        $9d9c2a020ee1de94$var$il(a, b);
    }
};
$9d9c2a020ee1de94$var$Hc = function() {
    return $9d9c2a020ee1de94$var$C;
};
$9d9c2a020ee1de94$var$Ic = function(a, b) {
    var c = $9d9c2a020ee1de94$var$C;
    try {
        return $9d9c2a020ee1de94$var$C = a, b();
    } finally{
        $9d9c2a020ee1de94$var$C = c;
    }
};
$9d9c2a020ee1de94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9d9c2a020ee1de94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9d9c2a020ee1de94$var$Db(d);
                        if (!e) throw Error($9d9c2a020ee1de94$var$p(90));
                        $9d9c2a020ee1de94$var$Wa(d);
                        $9d9c2a020ee1de94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9d9c2a020ee1de94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9d9c2a020ee1de94$var$fb(a, !!c.multiple, b, !1);
    }
};
$9d9c2a020ee1de94$var$Gb = $9d9c2a020ee1de94$var$Qk;
$9d9c2a020ee1de94$var$Hb = $9d9c2a020ee1de94$var$Rk;
var $9d9c2a020ee1de94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $9d9c2a020ee1de94$var$Cb,
        $9d9c2a020ee1de94$var$ue,
        $9d9c2a020ee1de94$var$Db,
        $9d9c2a020ee1de94$var$Eb,
        $9d9c2a020ee1de94$var$Fb,
        $9d9c2a020ee1de94$var$Qk
    ]
}, $9d9c2a020ee1de94$var$tl = {
    findFiberByHostInstance: $9d9c2a020ee1de94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $9d9c2a020ee1de94$var$ul = {
    bundleType: $9d9c2a020ee1de94$var$tl.bundleType,
    version: $9d9c2a020ee1de94$var$tl.version,
    rendererPackageName: $9d9c2a020ee1de94$var$tl.rendererPackageName,
    rendererConfig: $9d9c2a020ee1de94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9d9c2a020ee1de94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9d9c2a020ee1de94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9d9c2a020ee1de94$var$tl.findFiberByHostInstance || $9d9c2a020ee1de94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9d9c2a020ee1de94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9d9c2a020ee1de94$var$vl.isDisabled && $9d9c2a020ee1de94$var$vl.supportsFiber) try {
        $9d9c2a020ee1de94$var$kc = $9d9c2a020ee1de94$var$vl.inject($9d9c2a020ee1de94$var$ul), $9d9c2a020ee1de94$var$lc = $9d9c2a020ee1de94$var$vl;
    } catch (a) {}
}
$9d9c2a020ee1de94$export$ae55be85d98224ed = $9d9c2a020ee1de94$var$sl;
$9d9c2a020ee1de94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9d9c2a020ee1de94$var$nl(b)) throw Error($9d9c2a020ee1de94$var$p(200));
    return $9d9c2a020ee1de94$var$cl(a, b, null, c);
};
$9d9c2a020ee1de94$export$882461b6382ed46c = function(a, b) {
    if (!$9d9c2a020ee1de94$var$nl(a)) throw Error($9d9c2a020ee1de94$var$p(299));
    var c = !1, d = "", e = $9d9c2a020ee1de94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9d9c2a020ee1de94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$9d9c2a020ee1de94$var$uf] = b.current;
    $9d9c2a020ee1de94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9d9c2a020ee1de94$var$ll(b);
};
$9d9c2a020ee1de94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9d9c2a020ee1de94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9d9c2a020ee1de94$var$p(268, a));
    }
    a = $9d9c2a020ee1de94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9d9c2a020ee1de94$export$cd75ccfd720a3cd4 = function(a) {
    return $9d9c2a020ee1de94$var$Rk(a);
};
$9d9c2a020ee1de94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9d9c2a020ee1de94$var$ol(b)) throw Error($9d9c2a020ee1de94$var$p(200));
    return $9d9c2a020ee1de94$var$rl(null, a, b, !0, c);
};
$9d9c2a020ee1de94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9d9c2a020ee1de94$var$nl(a)) throw Error($9d9c2a020ee1de94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9d9c2a020ee1de94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9d9c2a020ee1de94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9d9c2a020ee1de94$var$uf] = b.current;
    $9d9c2a020ee1de94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9d9c2a020ee1de94$var$ml(b);
};
$9d9c2a020ee1de94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9d9c2a020ee1de94$var$ol(b)) throw Error($9d9c2a020ee1de94$var$p(200));
    return $9d9c2a020ee1de94$var$rl(null, a, b, !1, c);
};
$9d9c2a020ee1de94$export$502457920280e6be = function(a) {
    if (!$9d9c2a020ee1de94$var$ol(a)) throw Error($9d9c2a020ee1de94$var$p(40));
    return a._reactRootContainer ? ($9d9c2a020ee1de94$var$Rk(function() {
        $9d9c2a020ee1de94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9d9c2a020ee1de94$var$uf] = null;
        });
    }), !0) : !1;
};
$9d9c2a020ee1de94$export$c78a37762a8d58e1 = $9d9c2a020ee1de94$var$Qk;
$9d9c2a020ee1de94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9d9c2a020ee1de94$var$ol(c)) throw Error($9d9c2a020ee1de94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9d9c2a020ee1de94$var$p(38));
    return $9d9c2a020ee1de94$var$rl(a, b, c, !1, d);
};
$9d9c2a020ee1de94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bKjPo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1yhAO"));

});
parcelRegister("1yhAO", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $12169cff93c0fa73$export$c4744153514ff05d; }, function (v) { return $12169cff93c0fa73$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $12169cff93c0fa73$export$3e506c1ccc9cc1a7; }, function (v) { return $12169cff93c0fa73$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $12169cff93c0fa73$export$e26fe2ed2fa76875; }, function (v) { return $12169cff93c0fa73$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $12169cff93c0fa73$export$502329bbf4b505b1; }, function (v) { return $12169cff93c0fa73$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $12169cff93c0fa73$export$6e3807111c4874c4; }, function (v) { return $12169cff93c0fa73$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $12169cff93c0fa73$export$c27134553091fb3a; }, function (v) { return $12169cff93c0fa73$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $12169cff93c0fa73$export$33ee1acdc04fd2a2; }, function (v) { return $12169cff93c0fa73$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $12169cff93c0fa73$export$b00a404bbd5edef2; }, function (v) { return $12169cff93c0fa73$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $12169cff93c0fa73$export$8352ce38b91d0c62; }, function (v) { return $12169cff93c0fa73$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $12169cff93c0fa73$export$d66a1c1c77bd778b; }, function (v) { return $12169cff93c0fa73$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $12169cff93c0fa73$export$d3dfb8e4810cb555; }, function (v) { return $12169cff93c0fa73$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $12169cff93c0fa73$export$839f9183b0465a69; }, function (v) { return $12169cff93c0fa73$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $12169cff93c0fa73$export$72fdf0e06517287b; }, function (v) { return $12169cff93c0fa73$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $12169cff93c0fa73$export$4b844e58a3e414b4; }, function (v) { return $12169cff93c0fa73$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $12169cff93c0fa73$export$816d2913ae6b83b1; }, function (v) { return $12169cff93c0fa73$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $12169cff93c0fa73$export$61bcfe829111a1d0; }, function (v) { return $12169cff93c0fa73$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $12169cff93c0fa73$export$7ee8c9beb337bc3f; }, function (v) { return $12169cff93c0fa73$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $12169cff93c0fa73$export$b5836b71941fa3ed; }, function (v) { return $12169cff93c0fa73$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $12169cff93c0fa73$export$cf845f2c119da08a; }, function (v) { return $12169cff93c0fa73$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $12169cff93c0fa73$export$c4744153514ff05d;
var $12169cff93c0fa73$export$3e506c1ccc9cc1a7;
var $12169cff93c0fa73$export$e26fe2ed2fa76875;
var $12169cff93c0fa73$export$502329bbf4b505b1;
var $12169cff93c0fa73$export$6e3807111c4874c4;
var $12169cff93c0fa73$export$c27134553091fb3a;
var $12169cff93c0fa73$export$33ee1acdc04fd2a2;
var $12169cff93c0fa73$export$b00a404bbd5edef2;
var $12169cff93c0fa73$export$8352ce38b91d0c62;
var $12169cff93c0fa73$export$d66a1c1c77bd778b;
var $12169cff93c0fa73$export$d3dfb8e4810cb555;
var $12169cff93c0fa73$export$839f9183b0465a69;
var $12169cff93c0fa73$export$72fdf0e06517287b;
var $12169cff93c0fa73$export$4b844e58a3e414b4;
var $12169cff93c0fa73$export$816d2913ae6b83b1;
var $12169cff93c0fa73$export$61bcfe829111a1d0;
var $12169cff93c0fa73$export$7ee8c9beb337bc3f;
var $12169cff93c0fa73$export$b5836b71941fa3ed;
var $12169cff93c0fa73$export$cf845f2c119da08a;
'use strict';
function $12169cff93c0fa73$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $12169cff93c0fa73$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $12169cff93c0fa73$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $12169cff93c0fa73$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $12169cff93c0fa73$var$g(C, c)) n < e && 0 > $12169cff93c0fa73$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $12169cff93c0fa73$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $12169cff93c0fa73$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $12169cff93c0fa73$var$l = performance;
    $12169cff93c0fa73$export$c4744153514ff05d = function() {
        return $12169cff93c0fa73$var$l.now();
    };
} else {
    var $12169cff93c0fa73$var$p = Date, $12169cff93c0fa73$var$q = $12169cff93c0fa73$var$p.now();
    $12169cff93c0fa73$export$c4744153514ff05d = function() {
        return $12169cff93c0fa73$var$p.now() - $12169cff93c0fa73$var$q;
    };
}
var $12169cff93c0fa73$var$r = [], $12169cff93c0fa73$var$t = [], $12169cff93c0fa73$var$u = 1, $12169cff93c0fa73$var$v = null, $12169cff93c0fa73$var$y = 3, $12169cff93c0fa73$var$z = !1, $12169cff93c0fa73$var$A = !1, $12169cff93c0fa73$var$B = !1, $12169cff93c0fa73$var$D = "function" === typeof setTimeout ? setTimeout : null, $12169cff93c0fa73$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $12169cff93c0fa73$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $12169cff93c0fa73$var$G(a) {
    for(var b = $12169cff93c0fa73$var$h($12169cff93c0fa73$var$t); null !== b;){
        if (null === b.callback) $12169cff93c0fa73$var$k($12169cff93c0fa73$var$t);
        else if (b.startTime <= a) $12169cff93c0fa73$var$k($12169cff93c0fa73$var$t), b.sortIndex = b.expirationTime, $12169cff93c0fa73$var$f($12169cff93c0fa73$var$r, b);
        else break;
        b = $12169cff93c0fa73$var$h($12169cff93c0fa73$var$t);
    }
}
function $12169cff93c0fa73$var$H(a) {
    $12169cff93c0fa73$var$B = !1;
    $12169cff93c0fa73$var$G(a);
    if (!$12169cff93c0fa73$var$A) {
        if (null !== $12169cff93c0fa73$var$h($12169cff93c0fa73$var$r)) $12169cff93c0fa73$var$A = !0, $12169cff93c0fa73$var$I($12169cff93c0fa73$var$J);
        else {
            var b = $12169cff93c0fa73$var$h($12169cff93c0fa73$var$t);
            null !== b && $12169cff93c0fa73$var$K($12169cff93c0fa73$var$H, b.startTime - a);
        }
    }
}
function $12169cff93c0fa73$var$J(a, b) {
    $12169cff93c0fa73$var$A = !1;
    $12169cff93c0fa73$var$B && ($12169cff93c0fa73$var$B = !1, $12169cff93c0fa73$var$E($12169cff93c0fa73$var$L), $12169cff93c0fa73$var$L = -1);
    $12169cff93c0fa73$var$z = !0;
    var c = $12169cff93c0fa73$var$y;
    try {
        $12169cff93c0fa73$var$G(b);
        for($12169cff93c0fa73$var$v = $12169cff93c0fa73$var$h($12169cff93c0fa73$var$r); null !== $12169cff93c0fa73$var$v && (!($12169cff93c0fa73$var$v.expirationTime > b) || a && !$12169cff93c0fa73$var$M());){
            var d = $12169cff93c0fa73$var$v.callback;
            if ("function" === typeof d) {
                $12169cff93c0fa73$var$v.callback = null;
                $12169cff93c0fa73$var$y = $12169cff93c0fa73$var$v.priorityLevel;
                var e = d($12169cff93c0fa73$var$v.expirationTime <= b);
                b = $12169cff93c0fa73$export$c4744153514ff05d();
                "function" === typeof e ? $12169cff93c0fa73$var$v.callback = e : $12169cff93c0fa73$var$v === $12169cff93c0fa73$var$h($12169cff93c0fa73$var$r) && $12169cff93c0fa73$var$k($12169cff93c0fa73$var$r);
                $12169cff93c0fa73$var$G(b);
            } else $12169cff93c0fa73$var$k($12169cff93c0fa73$var$r);
            $12169cff93c0fa73$var$v = $12169cff93c0fa73$var$h($12169cff93c0fa73$var$r);
        }
        if (null !== $12169cff93c0fa73$var$v) var w = !0;
        else {
            var m = $12169cff93c0fa73$var$h($12169cff93c0fa73$var$t);
            null !== m && $12169cff93c0fa73$var$K($12169cff93c0fa73$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $12169cff93c0fa73$var$v = null, $12169cff93c0fa73$var$y = c, $12169cff93c0fa73$var$z = !1;
    }
}
var $12169cff93c0fa73$var$N = !1, $12169cff93c0fa73$var$O = null, $12169cff93c0fa73$var$L = -1, $12169cff93c0fa73$var$P = 5, $12169cff93c0fa73$var$Q = -1;
function $12169cff93c0fa73$var$M() {
    return $12169cff93c0fa73$export$c4744153514ff05d() - $12169cff93c0fa73$var$Q < $12169cff93c0fa73$var$P ? !1 : !0;
}
function $12169cff93c0fa73$var$R() {
    if (null !== $12169cff93c0fa73$var$O) {
        var a = $12169cff93c0fa73$export$c4744153514ff05d();
        $12169cff93c0fa73$var$Q = a;
        var b = !0;
        try {
            b = $12169cff93c0fa73$var$O(!0, a);
        } finally{
            b ? $12169cff93c0fa73$var$S() : ($12169cff93c0fa73$var$N = !1, $12169cff93c0fa73$var$O = null);
        }
    } else $12169cff93c0fa73$var$N = !1;
}
var $12169cff93c0fa73$var$S;
if ("function" === typeof $12169cff93c0fa73$var$F) $12169cff93c0fa73$var$S = function() {
    $12169cff93c0fa73$var$F($12169cff93c0fa73$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $12169cff93c0fa73$var$T = new MessageChannel, $12169cff93c0fa73$var$U = $12169cff93c0fa73$var$T.port2;
    $12169cff93c0fa73$var$T.port1.onmessage = $12169cff93c0fa73$var$R;
    $12169cff93c0fa73$var$S = function() {
        $12169cff93c0fa73$var$U.postMessage(null);
    };
} else $12169cff93c0fa73$var$S = function() {
    $12169cff93c0fa73$var$D($12169cff93c0fa73$var$R, 0);
};
function $12169cff93c0fa73$var$I(a) {
    $12169cff93c0fa73$var$O = a;
    $12169cff93c0fa73$var$N || ($12169cff93c0fa73$var$N = !0, $12169cff93c0fa73$var$S());
}
function $12169cff93c0fa73$var$K(a, b) {
    $12169cff93c0fa73$var$L = $12169cff93c0fa73$var$D(function() {
        a($12169cff93c0fa73$export$c4744153514ff05d());
    }, b);
}
$12169cff93c0fa73$export$3e506c1ccc9cc1a7 = 5;
$12169cff93c0fa73$export$e26fe2ed2fa76875 = 1;
$12169cff93c0fa73$export$502329bbf4b505b1 = 4;
$12169cff93c0fa73$export$6e3807111c4874c4 = 3;
$12169cff93c0fa73$export$c27134553091fb3a = null;
$12169cff93c0fa73$export$33ee1acdc04fd2a2 = 2;
$12169cff93c0fa73$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$12169cff93c0fa73$export$8352ce38b91d0c62 = function() {
    $12169cff93c0fa73$var$A || $12169cff93c0fa73$var$z || ($12169cff93c0fa73$var$A = !0, $12169cff93c0fa73$var$I($12169cff93c0fa73$var$J));
};
$12169cff93c0fa73$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $12169cff93c0fa73$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$12169cff93c0fa73$export$d3dfb8e4810cb555 = function() {
    return $12169cff93c0fa73$var$y;
};
$12169cff93c0fa73$export$839f9183b0465a69 = function() {
    return $12169cff93c0fa73$var$h($12169cff93c0fa73$var$r);
};
$12169cff93c0fa73$export$72fdf0e06517287b = function(a) {
    switch($12169cff93c0fa73$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $12169cff93c0fa73$var$y;
    }
    var c = $12169cff93c0fa73$var$y;
    $12169cff93c0fa73$var$y = b;
    try {
        return a();
    } finally{
        $12169cff93c0fa73$var$y = c;
    }
};
$12169cff93c0fa73$export$4b844e58a3e414b4 = function() {};
$12169cff93c0fa73$export$816d2913ae6b83b1 = function() {};
$12169cff93c0fa73$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $12169cff93c0fa73$var$y;
    $12169cff93c0fa73$var$y = a;
    try {
        return b();
    } finally{
        $12169cff93c0fa73$var$y = c;
    }
};
$12169cff93c0fa73$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $12169cff93c0fa73$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $12169cff93c0fa73$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $12169cff93c0fa73$var$f($12169cff93c0fa73$var$t, a), null === $12169cff93c0fa73$var$h($12169cff93c0fa73$var$r) && a === $12169cff93c0fa73$var$h($12169cff93c0fa73$var$t) && ($12169cff93c0fa73$var$B ? ($12169cff93c0fa73$var$E($12169cff93c0fa73$var$L), $12169cff93c0fa73$var$L = -1) : $12169cff93c0fa73$var$B = !0, $12169cff93c0fa73$var$K($12169cff93c0fa73$var$H, c - d))) : (a.sortIndex = e, $12169cff93c0fa73$var$f($12169cff93c0fa73$var$r, a), $12169cff93c0fa73$var$A || $12169cff93c0fa73$var$z || ($12169cff93c0fa73$var$A = !0, $12169cff93c0fa73$var$I($12169cff93c0fa73$var$J)));
    return a;
};
$12169cff93c0fa73$export$b5836b71941fa3ed = $12169cff93c0fa73$var$M;
$12169cff93c0fa73$export$cf845f2c119da08a = function(a) {
    var b = $12169cff93c0fa73$var$y;
    return function() {
        var c = $12169cff93c0fa73$var$y;
        $12169cff93c0fa73$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $12169cff93c0fa73$var$y = c;
        }
    };
};

});





parcelRegister("hdymY", function(module, exports) {

$parcel$export(module.exports, "observerBatching", function () { return $c88e4fa31c05077d$export$294943bbc3c74f4f; });

var $Kk7R3 = parcelRequire("Kk7R3");
function $c88e4fa31c05077d$export$fb2daceae6f5097a(callback) {
    callback();
}
function $c88e4fa31c05077d$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $c88e4fa31c05077d$export$fb2daceae6f5097a;
    (0, $Kk7R3.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $c88e4fa31c05077d$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("7DHNG", function(module, exports) {
var $58fe26bc7ee1c9b7$var$deprecatedMessages = [];
function $58fe26bc7ee1c9b7$export$be38475be17599d(msg) {
    if (!$58fe26bc7ee1c9b7$var$deprecatedMessages.includes(msg)) {
        $58fe26bc7ee1c9b7$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("bvFKR", function(module, exports) {

$parcel$export(module.exports, "useObserver", function () { return $8612fa98342ecabf$export$b9c7ecd090a87b14; });

var $Kk7R3 = parcelRequire("Kk7R3");

var $dvPqk = parcelRequire("dvPqk");

var $cCSLZ = parcelRequire("cCSLZ");

var $4rH0h = parcelRequire("4rH0h");

var $aPf73 = parcelRequire("aPf73");

var $2KJJ2 = parcelRequire("2KJJ2");
function $8612fa98342ecabf$var$createReaction(adm) {
    adm.reaction = new (0, $Kk7R3.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $8612fa98342ecabf$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $4rH0h.isUsingStaticRendering)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $aPf73.observerFinalizationRegistry).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $8612fa98342ecabf$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $8612fa98342ecabf$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $aPf73.observerFinalizationRegistry).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).useDebugValue(adm.reaction, (0, $cCSLZ.printDebugValue));
    (0, $2KJJ2.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}

});
parcelRegister("cCSLZ", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", function () { return $93138569419de2a7$export$ef795f1f307682c7; });

var $Kk7R3 = parcelRequire("Kk7R3");
function $93138569419de2a7$export$ef795f1f307682c7(v) {
    return (0, $Kk7R3.getDependencyTree)(v);
}

});

parcelRegister("4rH0h", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", function () { return $33cb0aa7e33960c4$export$5d52eaa7c0f24c9e; });
$parcel$export(module.exports, "isUsingStaticRendering", function () { return $33cb0aa7e33960c4$export$55979271896d643e; });
var $33cb0aa7e33960c4$var$globalIsUsingStaticRendering = false;
function $33cb0aa7e33960c4$export$5d52eaa7c0f24c9e(enable) {
    $33cb0aa7e33960c4$var$globalIsUsingStaticRendering = enable;
}
function $33cb0aa7e33960c4$export$55979271896d643e() {
    return $33cb0aa7e33960c4$var$globalIsUsingStaticRendering;
}

});

parcelRegister("aPf73", function(module, exports) {

$parcel$export(module.exports, "observerFinalizationRegistry", function () { return $7e1a63e07a7308a1$export$10e8a12fbfd8583c; });

var $3nCGr = parcelRequire("3nCGr");
var $7e1a63e07a7308a1$export$10e8a12fbfd8583c = new (0, $3nCGr.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

});
parcelRegister("3nCGr", function(module, exports) {

$parcel$export(module.exports, "UniversalFinalizationRegistry", function () { return $276186d63f918454$export$da5d55a244964b51; });
var $276186d63f918454$export$e901ba0ffe10ba41 = 10000;
var $276186d63f918454$export$1ae22ce5a82f26b6 = 10000;
var $276186d63f918454$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $276186d63f918454$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $276186d63f918454$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $276186d63f918454$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $276186d63f918454$export$b7a00d372cedeedd;

});



parcelRegister("gBcml", function(module, exports) {

$parcel$export(module.exports, "observer", function () { return $c159b056b7159129$export$b6ae1bc530f4c149; });

var $dvPqk = parcelRequire("dvPqk");

var $4rH0h = parcelRequire("4rH0h");

var $bvFKR = parcelRequire("bvFKR");
var $c159b056b7159129$var$_a, $c159b056b7159129$var$_b;
var $c159b056b7159129$var$warnObserverOptionsDeprecated = true;
var $c159b056b7159129$var$warnLegacyContextTypes = true;
var $c159b056b7159129$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $c159b056b7159129$var$isFunctionNameConfigurable = ($c159b056b7159129$var$_b = ($c159b056b7159129$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $c159b056b7159129$var$_a === void 0 ? void 0 : $c159b056b7159129$var$_a.configurable) !== null && $c159b056b7159129$var$_b !== void 0 ? $c159b056b7159129$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $c159b056b7159129$var$ReactForwardRefSymbol = $c159b056b7159129$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $dvPqk.forwardRef) === "function" && (0, $dvPqk.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $c159b056b7159129$var$ReactMemoSymbol = $c159b056b7159129$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $dvPqk.memo) === "function" && (0, $dvPqk.memo)(function(props) {
    return null;
})["$$typeof"];
function $c159b056b7159129$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($c159b056b7159129$var$ReactMemoSymbol && baseComponent["$$typeof"] === $c159b056b7159129$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $4rH0h.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($c159b056b7159129$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $c159b056b7159129$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $bvFKR.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($c159b056b7159129$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $dvPqk.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $dvPqk.memo)(observerComponent);
    $c159b056b7159129$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $c159b056b7159129$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $c159b056b7159129$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$c159b056b7159129$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("dgCXm", function(module, exports) {

var $bvFKR = parcelRequire("bvFKR");
function $9a8afce5f65d831d$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $bvFKR.useObserver)(component);
}
$9a8afce5f65d831d$export$c1cbdee04e18ea8b.displayName = "Observer";
function $9a8afce5f65d831d$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("6pvW2", function(module, exports) {

var $Kk7R3 = parcelRequire("Kk7R3");

var $dvPqk = parcelRequire("dvPqk");
function $4aadd98633c3bed6$export$aa207039f277c5f(initializer, annotations) {
    return (0, $dvPqk.useState)(function() {
        return (0, $Kk7R3.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("4H9dM", function(module, exports) {

var $Kk7R3 = parcelRequire("Kk7R3");

var $dvPqk = parcelRequire("dvPqk");
parcelRequire("7DHNG");

var $30xMB = parcelRequire("30xMB");
function $36b254bc5785789a$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $30xMB.useAsObservableSource)(current);
    return (0, $dvPqk.useState)(function() {
        return (0, $Kk7R3.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("30xMB", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", function () { return $230b93be14ef0ca1$export$e0ded3646391939c; });
parcelRequire("7DHNG");

var $Kk7R3 = parcelRequire("Kk7R3");

var $dvPqk = parcelRequire("dvPqk");
function $230b93be14ef0ca1$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $dvPqk.useState)(function() {
        return (0, $Kk7R3.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $Kk7R3.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});



parcelRegister("88FA0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ecf52f14f9c0ba5$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");
'use client';
/**
 * @internal
 */ const $5ecf52f14f9c0ba5$var$SkeletonThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createContext({});
/* eslint-disable react/no-array-index-key */ const $5ecf52f14f9c0ba5$var$defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function $5ecf52f14f9c0ba5$var$styleOptionsToCssProperties({ baseColor: baseColor, highlightColor: highlightColor, width: width, height: height, borderRadius: borderRadius, circle: circle, direction: direction, duration: duration, enableAnimation: enableAnimation = $5ecf52f14f9c0ba5$var$defaultEnableAnimation }) {
    const style = {};
    if (direction === 'rtl') style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number') style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation) style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number') style.width = width;
    if (typeof height === 'string' || typeof height === 'number') style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number') style.borderRadius = borderRadius;
    if (circle) style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined') style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined') style['--highlight-color'] = highlightColor;
    return style;
}
function $5ecf52f14f9c0ba5$export$2e2bcd8739ae039({ count: count = 1, wrapper: Wrapper, className: customClassName, containerClassName: containerClassName, containerTestId: containerTestId, circle: circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).useContext($5ecf52f14f9c0ba5$var$SkeletonThemeContext);
    const propsStyleOptions = {
        ...originalPropsStyleOptions
    };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions))if (typeof value === 'undefined') delete propsStyleOptions[key];
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle: circle
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...$5ecf52f14f9c0ba5$var$styleOptionsToCssProperties(styleOptions)
    };
    let className = 'react-loading-skeleton';
    if (customClassName) className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for(let i = 0; i < countCeil; i++){
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number' ? width * fractionalPart : `calc(${width} * ${fractionalPart})`;
            thisStyle = {
                ...thisStyle,
                width: fractionalWidth
            };
        }
        const skeletonSpan = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement("span", {
            className: className,
            style: thisStyle,
            key: i
        }, "\u200C");
        if (inline) elements.push(skeletonSpan);
        else // Without the <br />, the skeleton lines will all run together if
        // `width` is specified
        elements.push((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Fragment, {
            key: i
        }, skeletonSpan, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement("br", null)));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement("span", {
        className: containerClassName,
        "data-testid": containerTestId,
        "aria-live": "polite",
        "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : $5ecf52f14f9c0ba5$var$defaultEnableAnimation
    }, Wrapper ? elements.map((el, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(Wrapper, {
            key: i
        }, el)) : elements);
}
function $5ecf52f14f9c0ba5$export$978f2619783614a7({ children: children, ...styleOptions }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($5ecf52f14f9c0ba5$var$SkeletonThemeContext.Provider, {
        value: styleOptions
    }, children);
}

});

parcelRegister("aRSTV", function(module, exports) {

$parcel$export(module.exports, "LIST_TYPE", function () { return $11e47bc899efd499$export$22c50a44ec8aa5dd; });
var $11e47bc899efd499$export$22c50a44ec8aa5dd = /*#__PURE__*/ function(LIST_TYPE) {
    LIST_TYPE["CATEGORY"] = "category";
    LIST_TYPE["CUSTOM"] = "custom";
    LIST_TYPE["SEARCH"] = "search";
    LIST_TYPE["CART"] = "cart";
    LIST_TYPE["AVAILABILITY_CHECK"] = "availability_check";
    LIST_TYPE["FAVORITES"] = "favorites";
    LIST_TYPE["ORDER"] = "order";
    LIST_TYPE["RELATED_PRODUCTS"] = "related_products";
    LIST_TYPE["BARCODE"] = "barcode";
    LIST_TYPE["RECOMMENDATIONS"] = "recommendations";
    LIST_TYPE["CONTRACTUAL_PRODUCTS"] = "contractual_products";
    LIST_TYPE["RECIPE"] = "recipe";
    LIST_TYPE["EXPIRED"] = "expired";
    LIST_TYPE["LAST_CHANCE"] = "last_chance";
    return LIST_TYPE;
}({});

});

parcelRegister("3kQAm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1537fc37765d4f4e$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");

var $izjX7 = parcelRequire("izjX7");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gtsdT = parcelRequire("gtsdT");

var $bZiDo = parcelRequire("bZiDo");

var $cLLe3 = parcelRequire("cLLe3");

var $ipfF8 = parcelRequire("ipfF8");
const $1537fc37765d4f4e$var$ProductList = ({ heading: heading, subtitle: subtitle, products: products, skus: skus = [], count: count, buttonText: buttonText, buttonUrl: buttonUrl, listName: listName, listType: listType, context: context, callbacks: callbacks = {} })=>{
    const resolvedProducts = !(0, $bEEBX.default)(products) ? products : (0, $bZiDo.default).resolveSkus(skus);
    if (resolvedProducts.length === 0) {
        (0, $gtsdT.logger).log("products", "No products resolved: ", skus, resolvedProducts);
        return null;
    }
    const visibleSlice = !(0, $bEEBX.default)(count) ? resolvedProducts.slice(0, count) : resolvedProducts;
    const hasSubtitle = !(0, $bEEBX.default)(subtitle);
    const listInformation = {
        type: listType,
        name: listName,
        length: visibleSlice.length
    };
    const standardArticleTileStyle = (0, $izjX7.cn)("h-auto", "basis-full min-[240px]:basis-[156px] min-[375px]:basis-[171px] min-[424px]:basis-[49%] min-[585px]:basis-[32%] md:basis-[24%] lg:basis-[19.2%] xl:basis-[16%]", "min-[240px]:max-w-40 min-[375px]:max-w-44 min-[424px]:max-w-[49%] min-[585px]:max-w-[32%] md:max-w-[24%] lg:max-w-[19.2%] xl:max-w-[16%]");
    if (context === "standard-article") return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "mx-auto w-3/4 max-w-[848px] text-center",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        className: "mb-4",
                        children: heading
                    }),
                    hasSubtitle && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        className: "mb-4",
                        children: subtitle
                    }),
                    buttonUrl && buttonText && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        to: buttonUrl,
                        variant: "secondary",
                        children: buttonText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "flex flex-shrink grow flex-row flex-wrap justify-center gap-2",
                children: visibleSlice.map((product, i)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $ipfF8.default), {
                        product: product,
                        callbacks: callbacks,
                        listInformation: listInformation,
                        className: standardArticleTileStyle,
                        position: i + 1
                    }, product.sku))
            })
        ]
    });
    const gridProps = {
        type: "container",
        cols: {
            base: 1,
            "300px": 2,
            "530px": 3,
            "750px": 4,
            "950px": 5,
            "1180px": 6
        },
        gap: {
            base: 1,
            "300px": 2
        }
    };
    const productGrid = /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid), {
        ...gridProps,
        children: visibleSlice.map((product, i)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $ipfF8.default), {
                product: product,
                callbacks: callbacks,
                listInformation: listInformation,
                position: i + 1
            }, product.sku))
    });
    if (context === "category" || context === "search") return productGrid;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "w-full",
        children: [
            !(0, $bEEBX.default)(heading) && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "max-w-[680px]",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: heading
                    }),
                    hasSubtitle && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        children: subtitle
                    }),
                    buttonUrl && buttonText && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        to: buttonUrl,
                        variant: "secondary",
                        children: buttonText
                    })
                ]
            }),
            productGrid
        ]
    });
};
var $1537fc37765d4f4e$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1537fc37765d4f4e$var$ProductList);

});
parcelRegister("3lzdj", function(module, exports) {

$parcel$export(module.exports, "Grid", function () { return $26fea5f5cca73fdf$export$ef2184bd89960b14; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $lLmwf = parcelRequire("lLmwf");
const $26fea5f5cca73fdf$var$S = {
    media: "",
    container: "@container"
};
function $26fea5f5cca73fdf$export$ef2184bd89960b14({ cols: f = 12, gap: g = 4, align: u, justify: v, type: e = "media", className: i, overflow: $ = "visible", children: o, ...n }) {
    const r = (0, $dvPqk.useMemo)((0, $6sMuH.generateUniqueClassName), []), t = (0, $6sMuH.generateGridColstyles)(f, e), l = (0, $6sMuH.generateGridGapStyles)(g, e), a = (0, $6sMuH.generateGridAlignStyles)(u, e), c = (0, $6sMuH.generateGridJustifyStyles)(v, e), C = e === "container", G = {
        visible: "overflow-visible",
        hidden: "overflow-hidden",
        auto: "overflow-auto",
        scroll: "overflow-scroll"
    };
    return C ? /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: "@container",
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: (0, $6sMuH.cn)("grid", G[$], r, $26fea5f5cca73fdf$var$S[e], i),
                ...n,
                children: o
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("style", {
                children: `.${r} { ${t} ${l} ${a} ${c} }`
            })
        ]
    }) : /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: (0, $6sMuH.cn)("grid", r, $26fea5f5cca73fdf$var$S[e], i),
                ...n,
                children: o
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("style", {
                children: `.${r} { ${t} ${l} ${a} ${c} }`
            })
        ]
    });
}
$26fea5f5cca73fdf$export$ef2184bd89960b14.Col = (0, $lLmwf.GridCol);

});
parcelRegister("6sMuH", function(module, exports) {

$parcel$export(module.exports, "isEmptyArray", function () { return $4b4af98a0b03702b$export$4c0262a4f954db45; });
$parcel$export(module.exports, "generateUniqueClassName", function () { return $4b4af98a0b03702b$export$be4b07b680577747; });
$parcel$export(module.exports, "cn", function () { return $4b4af98a0b03702b$export$1343a74baacb0543; });
$parcel$export(module.exports, "generateGridColstyles", function () { return $4b4af98a0b03702b$export$9aa644b0f609abad; });
$parcel$export(module.exports, "generateGridGapStyles", function () { return $4b4af98a0b03702b$export$5a47a95fd30dc7a5; });
$parcel$export(module.exports, "generateGridAlignStyles", function () { return $4b4af98a0b03702b$export$2bf77e6df997e036; });
$parcel$export(module.exports, "generateGridJustifyStyles", function () { return $4b4af98a0b03702b$export$9efada2cf4d2a4f1; });
$parcel$export(module.exports, "generateGridColSpanStyles", function () { return $4b4af98a0b03702b$export$72aa988c7d20845d; });
$parcel$export(module.exports, "generateGridColOrderStyles", function () { return $4b4af98a0b03702b$export$f9f469cd04db5798; });
$parcel$export(module.exports, "getScreenSize", function () { return $4b4af98a0b03702b$export$3dbc497a08afff6c; });
function $4b4af98a0b03702b$export$4c0262a4f954db45(e) {
    return e.length === 0;
}
const $4b4af98a0b03702b$export$be4b07b680577747 = ()=>`grid-${Math.random().toString(36).substr(2, 9)}`;
function $4b4af98a0b03702b$var$oe(e) {
    var o, r, t = "";
    if (typeof e == "string" || typeof e == "number") t += e;
    else if (typeof e == "object") {
        if (Array.isArray(e)) {
            var s = e.length;
            for(o = 0; o < s; o++)e[o] && (r = $4b4af98a0b03702b$var$oe(e[o])) && (t && (t += " "), t += r);
        } else for(r in e)e[r] && (t && (t += " "), t += r);
    }
    return t;
}
function $4b4af98a0b03702b$var$le() {
    for(var e, o, r = 0, t = "", s = arguments.length; r < s; r++)(e = arguments[r]) && (o = $4b4af98a0b03702b$var$oe(e)) && (t && (t += " "), t += o);
    return t;
}
const $4b4af98a0b03702b$var$K = "-", $4b4af98a0b03702b$var$de = (e)=>{
    const o = $4b4af98a0b03702b$var$pe(e), { conflictingClassGroups: r, conflictingClassGroupModifiers: t } = e;
    return {
        getClassGroupId: (s)=>{
            const n = s.split($4b4af98a0b03702b$var$K);
            return n[0] === "" && n.length !== 1 && n.shift(), $4b4af98a0b03702b$var$te(n, o) || $4b4af98a0b03702b$var$ce(s);
        },
        getConflictingClassGroupIds: (s, n)=>{
            const l = r[s] || [];
            return n && t[s] ? [
                ...l,
                ...t[s]
            ] : l;
        }
    };
}, $4b4af98a0b03702b$var$te = (e, o)=>{
    var r;
    if (e.length === 0) return o.classGroupId;
    const t = e[0], s = o.nextPart.get(t), n = s ? $4b4af98a0b03702b$var$te(e.slice(1), s) : void 0;
    if (n) return n;
    if (o.validators.length === 0) return;
    const l = e.join($4b4af98a0b03702b$var$K);
    return (r = o.validators.find(({ validator: i })=>i(l))) == null ? void 0 : r.classGroupId;
}, $4b4af98a0b03702b$var$Z = /^\[(.+)\]$/, $4b4af98a0b03702b$var$ce = (e)=>{
    if ($4b4af98a0b03702b$var$Z.test(e)) {
        const o = $4b4af98a0b03702b$var$Z.exec(e)[1], r = o == null ? void 0 : o.substring(0, o.indexOf(":"));
        if (r) return "arbitrary.." + r;
    }
}, $4b4af98a0b03702b$var$pe = (e)=>{
    const { theme: o, prefix: r } = e, t = {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
    };
    return $4b4af98a0b03702b$var$be(Object.entries(e.classGroups), r).forEach(([s, n])=>{
        $4b4af98a0b03702b$var$J(n, t, s, o);
    }), t;
}, $4b4af98a0b03702b$var$J = (e, o, r, t)=>{
    e.forEach((s)=>{
        if (typeof s == "string") {
            const n = s === "" ? o : $4b4af98a0b03702b$var$ee(o, s);
            n.classGroupId = r;
            return;
        }
        if (typeof s == "function") {
            if ($4b4af98a0b03702b$var$ue(s)) {
                $4b4af98a0b03702b$var$J(s(t), o, r, t);
                return;
            }
            o.validators.push({
                validator: s,
                classGroupId: r
            });
            return;
        }
        Object.entries(s).forEach(([n, l])=>{
            $4b4af98a0b03702b$var$J(l, $4b4af98a0b03702b$var$ee(o, n), r, t);
        });
    });
}, $4b4af98a0b03702b$var$ee = (e, o)=>{
    let r = e;
    return o.split($4b4af98a0b03702b$var$K).forEach((t)=>{
        r.nextPart.has(t) || r.nextPart.set(t, {
            nextPart: /* @__PURE__ */ new Map(),
            validators: []
        }), r = r.nextPart.get(t);
    }), r;
}, $4b4af98a0b03702b$var$ue = (e)=>e.isThemeGetter, $4b4af98a0b03702b$var$be = (e, o)=>o ? e.map(([r, t])=>{
        const s = t.map((n)=>typeof n == "string" ? o + n : typeof n == "object" ? Object.fromEntries(Object.entries(n).map(([l, i])=>[
                    o + l,
                    i
                ])) : n);
        return [
            r,
            s
        ];
    }) : e, $4b4af98a0b03702b$var$me = (e)=>{
    if (e < 1) return {
        get: ()=>{},
        set: ()=>{}
    };
    let o = 0, r = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
    const s = (n, l)=>{
        r.set(n, l), o++, o > e && (o = 0, t = r, r = /* @__PURE__ */ new Map());
    };
    return {
        get (n) {
            let l = r.get(n);
            if (l !== void 0) return l;
            if ((l = t.get(n)) !== void 0) return s(n, l), l;
        },
        set (n, l) {
            r.has(n) ? r.set(n, l) : s(n, l);
        }
    };
}, $4b4af98a0b03702b$var$ne = "!", $4b4af98a0b03702b$var$fe = (e)=>{
    const { separator: o, experimentalParseClassName: r } = e, t = o.length === 1, s = o[0], n = o.length, l = (i)=>{
        const b = [];
        let m = 0, g = 0, y;
        for(let p = 0; p < i.length; p++){
            let f = i[p];
            if (m === 0) {
                if (f === s && (t || i.slice(p, p + n) === o)) {
                    b.push(i.slice(g, p)), g = p + n;
                    continue;
                }
                if (f === "/") {
                    y = p;
                    continue;
                }
            }
            f === "[" ? m++ : f === "]" && m--;
        }
        const x = b.length === 0 ? i : i.substring(g), v = x.startsWith($4b4af98a0b03702b$var$ne), w = v ? x.substring(1) : x, u = y && y > g ? y - g : void 0;
        return {
            modifiers: b,
            hasImportantModifier: v,
            baseClassName: w,
            maybePostfixModifierPosition: u
        };
    };
    return r ? (i)=>r({
            className: i,
            parseClassName: l
        }) : l;
}, $4b4af98a0b03702b$var$ge = (e)=>{
    if (e.length <= 1) return e;
    const o = [];
    let r = [];
    return e.forEach((t)=>{
        t[0] === "[" ? (o.push(...r.sort(), t), r = []) : r.push(t);
    }), o.push(...r.sort()), o;
}, $4b4af98a0b03702b$var$he = (e)=>({
        cache: $4b4af98a0b03702b$var$me(e.cacheSize),
        parseClassName: $4b4af98a0b03702b$var$fe(e),
        ...$4b4af98a0b03702b$var$de(e)
    }), $4b4af98a0b03702b$var$ye = /\s+/, $4b4af98a0b03702b$var$xe = (e, o)=>{
    const { parseClassName: r, getClassGroupId: t, getConflictingClassGroupIds: s } = o, n = [], l = e.trim().split($4b4af98a0b03702b$var$ye);
    let i = "";
    for(let b = l.length - 1; b >= 0; b -= 1){
        const m = l[b], { modifiers: g, hasImportantModifier: y, baseClassName: x, maybePostfixModifierPosition: v } = r(m);
        let w = !!v, u = t(w ? x.substring(0, v) : x);
        if (!u) {
            if (!w) {
                i = m + (i.length > 0 ? " " + i : i);
                continue;
            }
            if (u = t(x), !u) {
                i = m + (i.length > 0 ? " " + i : i);
                continue;
            }
            w = !1;
        }
        const p = $4b4af98a0b03702b$var$ge(g).join(":"), f = y ? p + $4b4af98a0b03702b$var$ne : p, h = f + u;
        if (n.includes(h)) continue;
        n.push(h);
        const N = s(u, w);
        for(let G = 0; G < N.length; ++G){
            const R = N[G];
            n.push(f + R);
        }
        i = m + (i.length > 0 ? " " + i : i);
    }
    return i;
};
function $4b4af98a0b03702b$var$we() {
    let e = 0, o, r, t = "";
    for(; e < arguments.length;)(o = arguments[e++]) && (r = $4b4af98a0b03702b$var$se(o)) && (t && (t += " "), t += r);
    return t;
}
const $4b4af98a0b03702b$var$se = (e)=>{
    if (typeof e == "string") return e;
    let o, r = "";
    for(let t = 0; t < e.length; t++)e[t] && (o = $4b4af98a0b03702b$var$se(e[t])) && (r && (r += " "), r += o);
    return r;
};
function $4b4af98a0b03702b$var$ve(e, ...o) {
    let r, t, s, n = l;
    function l(b) {
        const m = o.reduce((g, y)=>y(g), e());
        return r = $4b4af98a0b03702b$var$he(m), t = r.cache.get, s = r.cache.set, n = i, i(b);
    }
    function i(b) {
        const m = t(b);
        if (m) return m;
        const g = $4b4af98a0b03702b$var$xe(b, r);
        return s(b, g), g;
    }
    return function() {
        return n($4b4af98a0b03702b$var$we.apply(null, arguments));
    };
}
const $4b4af98a0b03702b$var$d = (e)=>{
    const o = (r)=>r[e] || [];
    return o.isThemeGetter = !0, o;
}, $4b4af98a0b03702b$var$ie = /^\[(?:([a-z-]+):)?(.+)\]$/i, $4b4af98a0b03702b$var$ke = /^\d+\/\d+$/, $4b4af98a0b03702b$var$$e = /* @__PURE__ */ new Set([
    "px",
    "full",
    "screen"
]), $4b4af98a0b03702b$var$je = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, $4b4af98a0b03702b$var$ze = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, $4b4af98a0b03702b$var$Ce = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, $4b4af98a0b03702b$var$Ge = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, $4b4af98a0b03702b$var$Se = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, $4b4af98a0b03702b$var$$ = (e)=>$4b4af98a0b03702b$var$S(e) || $4b4af98a0b03702b$var$$e.has(e) || $4b4af98a0b03702b$var$ke.test(e), $4b4af98a0b03702b$var$j = (e)=>$4b4af98a0b03702b$var$P(e, "length", $4b4af98a0b03702b$var$We), $4b4af98a0b03702b$var$S = (e)=>!!e && !Number.isNaN(Number(e)), $4b4af98a0b03702b$var$B = (e)=>$4b4af98a0b03702b$var$P(e, "number", $4b4af98a0b03702b$var$S), $4b4af98a0b03702b$var$O = (e)=>!!e && Number.isInteger(Number(e)), $4b4af98a0b03702b$var$Pe = (e)=>e.endsWith("%") && $4b4af98a0b03702b$var$S(e.slice(0, -1)), $4b4af98a0b03702b$var$a = (e)=>$4b4af98a0b03702b$var$ie.test(e), $4b4af98a0b03702b$var$z = (e)=>$4b4af98a0b03702b$var$je.test(e), $4b4af98a0b03702b$var$Ie = /* @__PURE__ */ new Set([
    "length",
    "size",
    "percentage"
]), $4b4af98a0b03702b$var$Ne = (e)=>$4b4af98a0b03702b$var$P(e, $4b4af98a0b03702b$var$Ie, $4b4af98a0b03702b$var$ae), $4b4af98a0b03702b$var$Me = (e)=>$4b4af98a0b03702b$var$P(e, "position", $4b4af98a0b03702b$var$ae), $4b4af98a0b03702b$var$Oe = /* @__PURE__ */ new Set([
    "image",
    "url"
]), $4b4af98a0b03702b$var$Ee = (e)=>$4b4af98a0b03702b$var$P(e, $4b4af98a0b03702b$var$Oe, $4b4af98a0b03702b$var$qe), $4b4af98a0b03702b$var$Re = (e)=>$4b4af98a0b03702b$var$P(e, "", $4b4af98a0b03702b$var$Ae), $4b4af98a0b03702b$var$E = ()=>!0, $4b4af98a0b03702b$var$P = (e, o, r)=>{
    const t = $4b4af98a0b03702b$var$ie.exec(e);
    return t ? t[1] ? typeof o == "string" ? t[1] === o : o.has(t[1]) : r(t[2]) : !1;
}, $4b4af98a0b03702b$var$We = (e)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $4b4af98a0b03702b$var$ze.test(e) && !$4b4af98a0b03702b$var$Ce.test(e), $4b4af98a0b03702b$var$ae = ()=>!1, $4b4af98a0b03702b$var$Ae = (e)=>$4b4af98a0b03702b$var$Ge.test(e), $4b4af98a0b03702b$var$qe = (e)=>$4b4af98a0b03702b$var$Se.test(e), $4b4af98a0b03702b$var$Te = ()=>{
    const e = $4b4af98a0b03702b$var$d("colors"), o = $4b4af98a0b03702b$var$d("spacing"), r = $4b4af98a0b03702b$var$d("blur"), t = $4b4af98a0b03702b$var$d("brightness"), s = $4b4af98a0b03702b$var$d("borderColor"), n = $4b4af98a0b03702b$var$d("borderRadius"), l = $4b4af98a0b03702b$var$d("borderSpacing"), i = $4b4af98a0b03702b$var$d("borderWidth"), b = $4b4af98a0b03702b$var$d("contrast"), m = $4b4af98a0b03702b$var$d("grayscale"), g = $4b4af98a0b03702b$var$d("hueRotate"), y = $4b4af98a0b03702b$var$d("invert"), x = $4b4af98a0b03702b$var$d("gap"), v = $4b4af98a0b03702b$var$d("gradientColorStops"), w = $4b4af98a0b03702b$var$d("gradientColorStopPositions"), u = $4b4af98a0b03702b$var$d("inset"), p = $4b4af98a0b03702b$var$d("margin"), f = $4b4af98a0b03702b$var$d("opacity"), h = $4b4af98a0b03702b$var$d("padding"), N = $4b4af98a0b03702b$var$d("saturate"), G = $4b4af98a0b03702b$var$d("scale"), R = $4b4af98a0b03702b$var$d("sepia"), L = $4b4af98a0b03702b$var$d("skew"), V = $4b4af98a0b03702b$var$d("space"), D = $4b4af98a0b03702b$var$d("translate"), q = ()=>[
            "auto",
            "contain",
            "none"
        ], T = ()=>[
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ], _ = ()=>[
            "auto",
            $4b4af98a0b03702b$var$a,
            o
        ], c = ()=>[
            $4b4af98a0b03702b$var$a,
            o
        ], F = ()=>[
            "",
            $4b4af98a0b03702b$var$$,
            $4b4af98a0b03702b$var$j
        ], W = ()=>[
            "auto",
            $4b4af98a0b03702b$var$S,
            $4b4af98a0b03702b$var$a
        ], Q = ()=>[
            "bottom",
            "center",
            "left",
            "left-bottom",
            "left-top",
            "right",
            "right-bottom",
            "right-top",
            "top"
        ], A = ()=>[
            "solid",
            "dashed",
            "dotted",
            "double",
            "none"
        ], X = ()=>[
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ], U = ()=>[
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch"
        ], M = ()=>[
            "",
            "0",
            $4b4af98a0b03702b$var$a
        ], Y = ()=>[
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ], k = ()=>[
            $4b4af98a0b03702b$var$S,
            $4b4af98a0b03702b$var$a
        ];
    return {
        cacheSize: 500,
        separator: ":",
        theme: {
            colors: [
                $4b4af98a0b03702b$var$E
            ],
            spacing: [
                $4b4af98a0b03702b$var$$,
                $4b4af98a0b03702b$var$j
            ],
            blur: [
                "none",
                "",
                $4b4af98a0b03702b$var$z,
                $4b4af98a0b03702b$var$a
            ],
            brightness: k(),
            borderColor: [
                e
            ],
            borderRadius: [
                "none",
                "",
                "full",
                $4b4af98a0b03702b$var$z,
                $4b4af98a0b03702b$var$a
            ],
            borderSpacing: c(),
            borderWidth: F(),
            contrast: k(),
            grayscale: M(),
            hueRotate: k(),
            invert: M(),
            gap: c(),
            gradientColorStops: [
                e
            ],
            gradientColorStopPositions: [
                $4b4af98a0b03702b$var$Pe,
                $4b4af98a0b03702b$var$j
            ],
            inset: _(),
            margin: _(),
            opacity: k(),
            padding: c(),
            saturate: k(),
            scale: k(),
            sepia: M(),
            skew: k(),
            space: c(),
            translate: c()
        },
        classGroups: {
            // Layout
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        "video",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */ container: [
                "container"
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $4b4af98a0b03702b$var$z
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ "break-after": [
                {
                    "break-after": Y()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ "break-before": [
                {
                    "break-before": Y()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ "object-position": [
                {
                    object: [
                        ...Q(),
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: T()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-x": [
                {
                    "overflow-x": T()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ "overflow-y": [
                {
                    "overflow-y": T()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: q()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-x": [
                {
                    "overscroll-x": q()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ "overscroll-y": [
                {
                    "overscroll-y": q()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: [
                        u
                    ]
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-x": [
                {
                    "inset-x": [
                        u
                    ]
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ "inset-y": [
                {
                    "inset-y": [
                        u
                    ]
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: [
                        u
                    ]
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: [
                        u
                    ]
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: [
                        u
                    ]
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: [
                        u
                    ]
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: [
                        u
                    ]
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: [
                        u
                    ]
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        "auto",
                        $4b4af98a0b03702b$var$O,
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            // Flexbox and Grid
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: _()
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ "flex-wrap": [
                {
                    flex: [
                        "wrap",
                        "wrap-reverse",
                        "nowrap"
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        "1",
                        "auto",
                        "initial",
                        "none",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: M()
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: M()
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        "first",
                        "last",
                        "none",
                        $4b4af98a0b03702b$var$O,
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ "grid-cols": [
                {
                    "grid-cols": [
                        $4b4af98a0b03702b$var$E
                    ]
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start-end": [
                {
                    col: [
                        "auto",
                        {
                            span: [
                                "full",
                                $4b4af98a0b03702b$var$O,
                                $4b4af98a0b03702b$var$a
                            ]
                        },
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-start": [
                {
                    "col-start": W()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ "col-end": [
                {
                    "col-end": W()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ "grid-rows": [
                {
                    "grid-rows": [
                        $4b4af98a0b03702b$var$E
                    ]
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start-end": [
                {
                    row: [
                        "auto",
                        {
                            span: [
                                $4b4af98a0b03702b$var$O,
                                $4b4af98a0b03702b$var$a
                            ]
                        },
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-start": [
                {
                    "row-start": W()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ "row-end": [
                {
                    "row-end": W()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ "auto-cols": [
                {
                    "auto-cols": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ "auto-rows": [
                {
                    "auto-rows": [
                        "auto",
                        "min",
                        "max",
                        "fr",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: [
                        x
                    ]
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ "gap-x": [
                {
                    "gap-x": [
                        x
                    ]
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ "gap-y": [
                {
                    "gap-y": [
                        x
                    ]
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ "justify-content": [
                {
                    justify: [
                        "normal",
                        ...U()
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ "justify-items": [
                {
                    "justify-items": [
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ "justify-self": [
                {
                    "justify-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ "align-content": [
                {
                    content: [
                        "normal",
                        ...U(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ "align-items": [
                {
                    items: [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ "align-self": [
                {
                    self: [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ "place-content": [
                {
                    "place-content": [
                        ...U(),
                        "baseline"
                    ]
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ "place-items": [
                {
                    "place-items": [
                        "start",
                        "end",
                        "center",
                        "baseline",
                        "stretch"
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ "place-self": [
                {
                    "place-self": [
                        "auto",
                        "start",
                        "end",
                        "center",
                        "stretch"
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: [
                        h
                    ]
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: [
                        h
                    ]
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: [
                        h
                    ]
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: [
                        h
                    ]
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: [
                        h
                    ]
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: [
                        h
                    ]
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: [
                        h
                    ]
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: [
                        h
                    ]
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: [
                        h
                    ]
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: [
                        p
                    ]
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: [
                        p
                    ]
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: [
                        p
                    ]
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: [
                        p
                    ]
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: [
                        p
                    ]
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: [
                        p
                    ]
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: [
                        p
                    ]
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: [
                        p
                    ]
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: [
                        p
                    ]
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */ "space-x": [
                {
                    "space-x": [
                        V
                    ]
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */ "space-y": [
                {
                    "space-y": [
                        V
                    ]
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */ "space-y-reverse": [
                "space-y-reverse"
            ],
            // Sizing
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svw",
                        "lvw",
                        "dvw",
                        $4b4af98a0b03702b$var$a,
                        o
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ "min-w": [
                {
                    "min-w": [
                        $4b4af98a0b03702b$var$a,
                        o,
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ "max-w": [
                {
                    "max-w": [
                        $4b4af98a0b03702b$var$a,
                        o,
                        "none",
                        "full",
                        "min",
                        "max",
                        "fit",
                        "prose",
                        {
                            screen: [
                                $4b4af98a0b03702b$var$z
                            ]
                        },
                        $4b4af98a0b03702b$var$z
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        $4b4af98a0b03702b$var$a,
                        o,
                        "auto",
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ "min-h": [
                {
                    "min-h": [
                        $4b4af98a0b03702b$var$a,
                        o,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ "max-h": [
                {
                    "max-h": [
                        $4b4af98a0b03702b$var$a,
                        o,
                        "min",
                        "max",
                        "fit",
                        "svh",
                        "lvh",
                        "dvh"
                    ]
                }
            ],
            /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */ size: [
                {
                    size: [
                        $4b4af98a0b03702b$var$a,
                        o,
                        "auto",
                        "min",
                        "max",
                        "fit"
                    ]
                }
            ],
            // Typography
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ "font-size": [
                {
                    text: [
                        "base",
                        $4b4af98a0b03702b$var$z,
                        $4b4af98a0b03702b$var$j
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ "font-weight": [
                {
                    font: [
                        "thin",
                        "extralight",
                        "light",
                        "normal",
                        "medium",
                        "semibold",
                        "bold",
                        "extrabold",
                        "black",
                        $4b4af98a0b03702b$var$B
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ "font-family": [
                {
                    font: [
                        $4b4af98a0b03702b$var$E
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-normal": [
                "normal-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-ordinal": [
                "ordinal"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractons"
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        "tighter",
                        "tight",
                        "normal",
                        "wide",
                        "wider",
                        "widest",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ "line-clamp": [
                {
                    "line-clamp": [
                        "none",
                        $4b4af98a0b03702b$var$S,
                        $4b4af98a0b03702b$var$B
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        "none",
                        "tight",
                        "snug",
                        "normal",
                        "relaxed",
                        "loose",
                        $4b4af98a0b03702b$var$$,
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ "list-image": [
                {
                    "list-image": [
                        "none",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ "list-style-type": [
                {
                    list: [
                        "none",
                        "disc",
                        "decimal",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */ "placeholder-color": [
                {
                    placeholder: [
                        e
                    ]
                }
            ],
            /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */ "placeholder-opacity": [
                {
                    "placeholder-opacity": [
                        f
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ "text-color": [
                {
                    text: [
                        e
                    ]
                }
            ],
            /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */ "text-opacity": [
                {
                    "text-opacity": [
                        f
                    ]
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ "text-decoration-style": [
                {
                    decoration: [
                        ...A(),
                        "wavy"
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ "text-decoration-thickness": [
                {
                    decoration: [
                        "auto",
                        "from-font",
                        $4b4af98a0b03702b$var$$,
                        $4b4af98a0b03702b$var$j
                    ]
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ "underline-offset": [
                {
                    "underline-offset": [
                        "auto",
                        $4b4af98a0b03702b$var$$,
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ "text-decoration-color": [
                {
                    decoration: [
                        e
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: c()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        "none",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            // Backgrounds
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */ "bg-opacity": [
                {
                    "bg-opacity": [
                        f
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ "bg-position": [
                {
                    bg: [
                        ...Q(),
                        $4b4af98a0b03702b$var$Me
                    ]
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ "bg-repeat": [
                {
                    bg: [
                        "no-repeat",
                        {
                            repeat: [
                                "",
                                "x",
                                "y",
                                "round",
                                "space"
                            ]
                        }
                    ]
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ "bg-size": [
                {
                    bg: [
                        "auto",
                        "cover",
                        "contain",
                        $4b4af98a0b03702b$var$Ne
                    ]
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            "gradient-to": [
                                "t",
                                "tr",
                                "r",
                                "br",
                                "b",
                                "bl",
                                "l",
                                "tl"
                            ]
                        },
                        $4b4af98a0b03702b$var$Ee
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ "bg-color": [
                {
                    bg: [
                        e
                    ]
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from-pos": [
                {
                    from: [
                        w
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via-pos": [
                {
                    via: [
                        w
                    ]
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to-pos": [
                {
                    to: [
                        w
                    ]
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-from": [
                {
                    from: [
                        v
                    ]
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-via": [
                {
                    via: [
                        v
                    ]
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ "gradient-to": [
                {
                    to: [
                        v
                    ]
                }
            ],
            // Borders
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-s": [
                {
                    "rounded-s": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-e": [
                {
                    "rounded-e": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-t": [
                {
                    "rounded-t": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-r": [
                {
                    "rounded-r": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-b": [
                {
                    "rounded-b": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-l": [
                {
                    "rounded-l": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ss": [
                {
                    "rounded-ss": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-se": [
                {
                    "rounded-se": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-ee": [
                {
                    "rounded-ee": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-es": [
                {
                    "rounded-es": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tl": [
                {
                    "rounded-tl": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-tr": [
                {
                    "rounded-tr": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-br": [
                {
                    "rounded-br": [
                        n
                    ]
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ "rounded-bl": [
                {
                    "rounded-bl": [
                        n
                    ]
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w": [
                {
                    border: [
                        i
                    ]
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-x": [
                {
                    "border-x": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-y": [
                {
                    "border-y": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-s": [
                {
                    "border-s": [
                        i
                    ]
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-e": [
                {
                    "border-e": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-t": [
                {
                    "border-t": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-r": [
                {
                    "border-r": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-b": [
                {
                    "border-b": [
                        i
                    ]
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ "border-w-l": [
                {
                    "border-l": [
                        i
                    ]
                }
            ],
            /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */ "border-opacity": [
                {
                    "border-opacity": [
                        f
                    ]
                }
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ "border-style": [
                {
                    border: [
                        ...A(),
                        "hidden"
                    ]
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x": [
                {
                    "divide-x": [
                        i
                    ]
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y": [
                {
                    "divide-y": [
                        i
                    ]
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */ "divide-opacity": [
                {
                    "divide-opacity": [
                        f
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */ "divide-style": [
                {
                    divide: A()
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color": [
                {
                    border: [
                        s
                    ]
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-x": [
                {
                    "border-x": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-y": [
                {
                    "border-y": [
                        s
                    ]
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-s": [
                {
                    "border-s": [
                        s
                    ]
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-e": [
                {
                    "border-e": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-t": [
                {
                    "border-t": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-r": [
                {
                    "border-r": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-b": [
                {
                    "border-b": [
                        s
                    ]
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ "border-color-l": [
                {
                    "border-l": [
                        s
                    ]
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ "divide-color": [
                {
                    divide: [
                        s
                    ]
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ "outline-style": [
                {
                    outline: [
                        "",
                        ...A()
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ "outline-offset": [
                {
                    "outline-offset": [
                        $4b4af98a0b03702b$var$$,
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ "outline-w": [
                {
                    outline: [
                        $4b4af98a0b03702b$var$$,
                        $4b4af98a0b03702b$var$j
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ "outline-color": [
                {
                    outline: [
                        e
                    ]
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w": [
                {
                    ring: F()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */ "ring-w-inset": [
                "ring-inset"
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */ "ring-color": [
                {
                    ring: [
                        e
                    ]
                }
            ],
            /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */ "ring-opacity": [
                {
                    "ring-opacity": [
                        f
                    ]
                }
            ],
            /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */ "ring-offset-w": [
                {
                    "ring-offset": [
                        $4b4af98a0b03702b$var$$,
                        $4b4af98a0b03702b$var$j
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */ "ring-offset-color": [
                {
                    "ring-offset": [
                        e
                    ]
                }
            ],
            // Effects
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        "",
                        "inner",
                        "none",
                        $4b4af98a0b03702b$var$z,
                        $4b4af98a0b03702b$var$Re
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */ "shadow-color": [
                {
                    shadow: [
                        $4b4af98a0b03702b$var$E
                    ]
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        f
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ "mix-blend": [
                {
                    "mix-blend": [
                        ...X(),
                        "plus-lighter",
                        "plus-darker"
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ "bg-blend": [
                {
                    "bg-blend": X()
                }
            ],
            // Filters
            /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: [
                        r
                    ]
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        t
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        b
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        $4b4af98a0b03702b$var$z,
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        m
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ "hue-rotate": [
                {
                    "hue-rotate": [
                        g
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        y
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        N
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        R
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none"
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ "backdrop-blur": [
                {
                    "backdrop-blur": [
                        r
                    ]
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        t
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        b
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        m
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        g
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        y
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        f
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        N
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        R
                    ]
                }
            ],
            // Tables
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing": [
                {
                    "border-spacing": [
                        l
                    ]
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-x": [
                {
                    "border-spacing-x": [
                        l
                    ]
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ "border-spacing-y": [
                {
                    "border-spacing-y": [
                        l
                    ]
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            // Transitions and Animation
            /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        "none",
                        "all",
                        "",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: k()
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        "linear",
                        "in",
                        "out",
                        "in-out",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: k()
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        "none",
                        "spin",
                        "ping",
                        "pulse",
                        "bounce",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            // Transforms
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        "",
                        "gpu",
                        "none"
                    ]
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: [
                        G
                    ]
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ "scale-x": [
                {
                    "scale-x": [
                        G
                    ]
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ "scale-y": [
                {
                    "scale-y": [
                        G
                    ]
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: [
                        $4b4af98a0b03702b$var$O,
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ "translate-x": [
                {
                    "translate-x": [
                        D
                    ]
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ "translate-y": [
                {
                    "translate-y": [
                        D
                    ]
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ "skew-x": [
                {
                    "skew-x": [
                        L
                    ]
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ "skew-y": [
                {
                    "skew-y": [
                        L
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ "transform-origin": [
                {
                    origin: [
                        "center",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left",
                        "top-left",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            // Interactivity
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: [
                        "auto",
                        e
                    ]
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ "caret-color": [
                {
                    caret: [
                        e
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ "pointer-events": [
                {
                    "pointer-events": [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        "none",
                        "y",
                        "x",
                        ""
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-m": [
                {
                    "scroll-m": c()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mx": [
                {
                    "scroll-mx": c()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-my": [
                {
                    "scroll-my": c()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ms": [
                {
                    "scroll-ms": c()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-me": [
                {
                    "scroll-me": c()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mt": [
                {
                    "scroll-mt": c()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mr": [
                {
                    "scroll-mr": c()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-mb": [
                {
                    "scroll-mb": c()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ "scroll-ml": [
                {
                    "scroll-ml": c()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-p": [
                {
                    "scroll-p": c()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-px": [
                {
                    "scroll-px": c()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-py": [
                {
                    "scroll-py": c()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-ps": [
                {
                    "scroll-ps": c()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pe": [
                {
                    "scroll-pe": c()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pt": [
                {
                    "scroll-pt": c()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pr": [
                {
                    "scroll-pr": c()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pb": [
                {
                    "scroll-pb": c()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ "scroll-pl": [
                {
                    "scroll-pl": c()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        $4b4af98a0b03702b$var$a
                    ]
                }
            ],
            // SVG
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        e,
                        "none"
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ "stroke-w": [
                {
                    stroke: [
                        $4b4af98a0b03702b$var$$,
                        $4b4af98a0b03702b$var$j,
                        $4b4af98a0b03702b$var$B
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        e,
                        "none"
                    ]
                }
            ],
            // Accessibility
            /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-s",
                "border-w-e",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-s",
                "border-color-e",
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        }
    };
}, $4b4af98a0b03702b$var$_e = /* @__PURE__ */ $4b4af98a0b03702b$var$ve($4b4af98a0b03702b$var$Te), $4b4af98a0b03702b$var$Ue = $4b4af98a0b03702b$var$le, $4b4af98a0b03702b$var$Be = $4b4af98a0b03702b$var$_e;
function $4b4af98a0b03702b$export$1343a74baacb0543(...e) {
    return $4b4af98a0b03702b$var$Be($4b4af98a0b03702b$var$Ue(...e));
}
const $4b4af98a0b03702b$export$ff13e982ca5afe86 = {
    base: "0px",
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
}, $4b4af98a0b03702b$export$f8ab8cabd375f044 = {
    0: "0px",
    // 0px
    0.5: "0.125rem",
    // 2px
    1: "0.25rem",
    // 4px
    1.5: "0.375rem",
    // 6px
    2: "0.5rem",
    // 8px
    3: "0.75rem",
    // 12px
    4: "1rem",
    // 16px
    5: "1.25rem",
    // 20px
    6: "1.5rem",
    // 24px
    7: "1.75rem",
    // 28px
    8: "2rem",
    // 32px
    9: "2.25rem",
    // 36px
    10: "2.5rem",
    // 40px
    11: "2.75rem",
    // 44px
    12: "3rem",
    // 48px
    16: "4rem",
    // 64px
    20: "5rem",
    // 80px
    24: "6rem",
    // 96px
    32: "8rem",
    // 128px
    40: "10rem",
    // 160px
    48: "12rem",
    // 192px
    56: "14rem",
    // 224px
    64: "16rem"
}, $4b4af98a0b03702b$var$re = (e)=>{
    if (e.endsWith("px")) return parseInt(e);
    if (e in $4b4af98a0b03702b$export$ff13e982ca5afe86) return parseInt($4b4af98a0b03702b$export$ff13e982ca5afe86[e]);
    throw new Error(`Invalid breakpoint "${e}". Must be one of: base, sm, md, lg, xl, 2xl, or a pixel value ending in 'px'`);
}, $4b4af98a0b03702b$var$I = (e)=>e.sort((o, r)=>{
        if (o[0] === "base") return -1;
        if (r[0] === "base") return 1;
        try {
            const t = $4b4af98a0b03702b$var$re(o[0]), s = $4b4af98a0b03702b$var$re(r[0]);
            return t - s;
        } catch (t) {
            return console.error("Error sorting breakpoints:", t), 0;
        }
    }), $4b4af98a0b03702b$export$9aa644b0f609abad = (e, o)=>typeof e == "number" ? `grid-template-columns: repeat(${e}, minmax(0, 1fr));` : typeof e == "object" ? $4b4af98a0b03702b$var$I(Object.entries(e)).map(([r, t])=>{
        if (r === "base") return `grid-template-columns: repeat(${t}, minmax(0, 1fr));`;
        const s = o === "container", n = s ? "@container" : "@media", l = s ? r : $4b4af98a0b03702b$export$ff13e982ca5afe86[r], i = s ? `(min-width: ${r})` : `(min-width: ${l})`;
        return `${n} ${i} {
            grid-template-columns: repeat(${t}, minmax(0, 1fr));
          }`;
    }).join(" ") : "", $4b4af98a0b03702b$export$5a47a95fd30dc7a5 = (e, o)=>typeof e == "number" ? `grid-gap: ${$4b4af98a0b03702b$export$f8ab8cabd375f044[e]};` : typeof e == "object" ? $4b4af98a0b03702b$var$I(Object.entries(e)).map(([r, t])=>{
        if (r === "base" && t !== void 0) return `grid-gap: ${$4b4af98a0b03702b$export$f8ab8cabd375f044[t]};`;
        const s = o === "container", n = s ? "@container" : "@media", l = $4b4af98a0b03702b$export$ff13e982ca5afe86[r] || r, i = s ? `(min-width: ${l})` : `(min-width: ${l})`;
        return t !== void 0 ? `${n} ${i} {
              grid-gap: ${$4b4af98a0b03702b$export$f8ab8cabd375f044[t]};
            }` : "";
    }).join(" ") : "", $4b4af98a0b03702b$export$2bf77e6df997e036 = (e, o)=>e ? typeof e == "string" ? `align-items: ${e};` : typeof e == "object" ? $4b4af98a0b03702b$var$I(Object.entries(e)).map(([r, t])=>{
        if (r === "base" && t !== void 0) return `align-items: ${t};`;
        const s = o === "container", n = s ? "@container" : "@media", l = s ? r : $4b4af98a0b03702b$export$ff13e982ca5afe86[r], i = s ? `(min-width: ${r})` : `(min-width: ${l})`;
        return t !== void 0 ? `${n} ${i} {
              align-items: ${t};
            }` : "";
    }).join(" ") : "" : "", $4b4af98a0b03702b$export$9efada2cf4d2a4f1 = (e, o)=>e ? typeof e == "string" ? `justify-content: ${e};` : typeof e == "object" ? $4b4af98a0b03702b$var$I(Object.entries(e)).map(([r, t])=>{
        if (r === "base" && t !== void 0) return `justify-content: ${t};`;
        const s = o === "container", n = s ? "@container" : "@media", l = s ? r : $4b4af98a0b03702b$export$ff13e982ca5afe86[r], i = s ? `(min-width: ${r})` : `(min-width: ${l})`;
        return t !== void 0 ? `${n} ${i} {
              justify-content: ${t};
            }` : "";
    }).join(" ") : "" : "", $4b4af98a0b03702b$export$72aa988c7d20845d = (e)=>typeof e == "number" ? `grid-column: span ${e};` : typeof e == "object" ? $4b4af98a0b03702b$var$I(Object.entries(e)).map(([o, r])=>o === "base" ? `grid-column: span ${r};` : `@media ${`(min-width: ${$4b4af98a0b03702b$export$ff13e982ca5afe86[o] || o})`} {
            grid-column: span ${r};
          }`).join(" ") : "", $4b4af98a0b03702b$export$f9f469cd04db5798 = (e)=>e === void 0 ? "" : typeof e == "number" ? `order: ${e};` : typeof e == "object" ? $4b4af98a0b03702b$var$I(Object.entries(e)).map(([o, r])=>o === "base" ? `order: ${r};` : `@media ${`(min-width: ${$4b4af98a0b03702b$export$ff13e982ca5afe86[o] || o})`} {
            order: ${r};
          }`).join(" ") : "";
function $4b4af98a0b03702b$export$3dbc497a08afff6c() {
    return typeof window > "u" ? {
        width: 0,
        height: 0,
        devicePixelRatio: 1
    } : {
        width: window.innerWidth,
        height: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio
    };
}

});

parcelRegister("lLmwf", function(module, exports) {

$parcel$export(module.exports, "GridCol", function () { return $fd7f749d01e347ec$export$1b5689fc8adf2f5e; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");
function $fd7f749d01e347ec$export$1b5689fc8adf2f5e({ className: s, children: t, order: o, span: a, ...n }) {
    const e = (0, $dvPqk.useMemo)((0, $6sMuH.generateUniqueClassName), []), l = (0, $6sMuH.generateGridColSpanStyles)(a), i = (0, $6sMuH.generateGridColOrderStyles)(o);
    return /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: (0, $6sMuH.cn)(e, s),
                ...n,
                children: t
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("style", {
                children: `
        .${e} {
          ${l}
          ${i}
        }
      `
            })
        ]
    });
}

});


parcelRegister("cLLe3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676c9bb19de70178$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $cGjF4 = parcelRequire("cGjF4");

var $dvPqk = parcelRequire("dvPqk");

var $7nQ1B = parcelRequire("7nQ1B");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");
const $676c9bb19de70178$var$Button = /*#__PURE__*/ (0, $dvPqk.forwardRef)(({ size: size = "compact", iconPosition: iconPosition = "right", className: className = "", onClick: onClick, to: to, trackingName: trackingName, children: children, ...rest }, ref)=>{
    const buttonName = trackingName ?? children?.toString();
    const handleClick = (e)=>{
        (0, $6fuyt.sendButtonClick)(buttonName);
        if (to && !(0, $5OqMf.isExternalLink)(to)) {
            (0, $7nQ1B.navigate)(to);
            e.preventDefault();
        }
        onClick?.(e);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
        size: size,
        iconPosition: iconPosition,
        className: className,
        onClick: handleClick,
        to: to,
        ...rest,
        ref: ref,
        children: children
    });
});
var $676c9bb19de70178$export$2e2bcd8739ae039 = $676c9bb19de70178$var$Button;

});
parcelRegister("cGjF4", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $93b8a8a22c5bccb3$export$353f5b6fc5456de1; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $cWjYx = parcelRequire("cWjYx");
const $93b8a8a22c5bccb3$export$353f5b6fc5456de1 = (0, $dvPqk.forwardRef)(({ children: l, variant: s = "primary", size: u = "regular", disabled: g = !1, type: a, className: p, icon: e, iconPosition: d = "left", loading: o = !1, to: v, as: n = "button", ...b }, x)=>{
    let t;
    a !== void 0 ? t = a : n === "button" ? t = "button" : t = void 0;
    const i = {};
    t !== void 0 && (i.type = t), n !== "button" && "role" in b && (i.role = b.role);
    const y = {
        primary: (0, $6sMuH.cn)(// Colors
        "text-button-primary-text bg-button-primary-bg fill-button-primary-text", // Border
        "border-button-primary-bg", // Hover
        "hover:bg-button-primary-bg-hover hover:border-button-primary-bg-hover"),
        secondary: (0, $6sMuH.cn)(// Colors
        "text-button-secondary-text bg-button-secondary-bg fill-button-secondary-text", // Border
        "border-button-secondary-border", // Hover
        "hover:bg-button-secondary-bg-hover hover:border-button-secondary-border"),
        tertiary: (0, $6sMuH.cn)(// Colors
        "text-button-tertiary-text fill-tertiary-text bg-button-tertiary-bg", // Border
        "border-transparent", // Hover
        "hover:bg-button-tertiary-bg-hover hover:underline hover:border-button-tertiary-bg-hover"),
        destructive: (0, $6sMuH.cn)(// Colors
        "text-ink-brand-inverted fill-ink-brand-inverted bg-button-danger-bg", // Border
        " border-button-danger-bg", // Hover
        "hover:bg-error-800 hover:border-error-800")
    }[s], f = {
        compact: "text-sm px-button-compact-padding-x py-button-compact-padding-y [&>svg]:w-[20px] [&>svg]:h-[20px] [&>svg]:-m-1",
        regular: "text-base px-button-regular-padding-x py-button-regular-padding-y [&>svg]:w-[20px] [&>svg]:h-[20px] [&>svg]:-m-1",
        full: "text-base w-full px-button-regular-padding-x py-button-regular-padding-y [&>svg]:w-[20px] [&>svg]:h-[20px] [&>svg]:-m-1",
        iconOnly: "p-2 [&>svg]:w-[28px] [&>svg]:h-[28px] [&>svg]:-m-0.5"
    }[u];
    return /* @__PURE__ */ (0, $7YWoO.jsxs)(n, {
        ...n !== "button" ? {
            href: v
        } : {},
        ref: x,
        ...i,
        ...b,
        className: (0, $6sMuH.cn)(y, f, // focus
        "focus-visible:ring-2 focus-visible:ring-information-600 focus-visible:outline-none", // Disabled
        "disabled:text-ink-disabled disabled:border-button-disabled-bg disabled:bg-button-disabled-bg disabled:cursor-not-allowed disabled:no-underline [&>svg]:disabled:fill-ink-disabled", // Base
        "cursor-pointer leading-none border-2 no-underline rounded-button inline-flex justify-center items-center gap-x-2", p),
        disabled: g || o,
        children: [
            e && d === "left" && !o ? e : null,
            o ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cWjYx.default), {
                className: "animate-spin fill-ink-disabled"
            }) : null,
            l,
            e && d === "right" && !o ? e : null
        ]
    });
});
$93b8a8a22c5bccb3$export$353f5b6fc5456de1.displayName = "Button";

});
parcelRegister("cWjYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ba658aa82e131a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $96ba658aa82e131a$export$2e2bcd8739ae039 = (e)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, e, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.01,
                d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M4.592 12a7.408 7.408 0 1 0 14.816 0 7.408 7.408 0 0 0-14.816 0"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "inherit",
                d: "M8.019 3.929a9 9 0 1 1-4.531 10.993l1.868-.64A7.025 7.025 0 1 0 8.892 5.7z"
            })
        ]
    }));

});



parcelRegister("ipfF8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfcc7093040f8b05$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $1A6xS = parcelRequire("1A6xS");

var $izjX7 = parcelRequire("izjX7");

var $ioVMT = parcelRequire("ioVMT");
var $aQzCo = parcelRequire("aQzCo");

var $f3hTG = parcelRequire("f3hTG");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $2vDqE = parcelRequire("2vDqE");

var $g9Bxb = parcelRequire("g9Bxb");

var $6fuyt = parcelRequire("6fuyt");

var $5qbUf = parcelRequire("5qbUf");

var $5OqMf = parcelRequire("5OqMf");

var $bcbvQ = parcelRequire("bcbvQ");

var $bZiDo = parcelRequire("bZiDo");

var $luszM = parcelRequire("luszM");

var $i6TQx = parcelRequire("i6TQx");

var $a2SqC = parcelRequire("a2SqC");

var $isIf6 = parcelRequire("isIf6");

var $27iE3 = parcelRequire("27iE3");

var $h5LDr = parcelRequire("h5LDr");

var $cLLe3 = parcelRequire("cLLe3");

var $lAgRA = parcelRequire("lAgRA");

var $bO7t0 = parcelRequire("bO7t0");

var $03mes = parcelRequire("03mes");

var $3muLR = parcelRequire("3muLR");

var $f7kjZ = parcelRequire("f7kjZ");
const $bfcc7093040f8b05$var$ranges = {
    thin: [
        0,
        190
    ],
    normal: [
        190
    ]
};
const $bfcc7093040f8b05$var$ProductTile = ({ product: product, listInformation: listInformation, position: position, className: className = "", callbacks: callbacks = {} })=>{
    const imageRef = (0, $dvPqk.useRef)(null);
    const tileRef = (0, $dvPqk.useRef)(null);
    const { ref: containerRef, size: currentContainerSize } = (0, $2vDqE.default)($bfcc7093040f8b05$var$ranges);
    const tileState = (0, $dvPqk.useMemo)(()=>(0, $Kk7R3.makeAutoObservable)({
            qty: 1,
            hovering: false,
            hasReportedVisibility: false
        }), []);
    const trackImpression = (0, $Kk7R3.action)((isVisible)=>{
        if (isVisible && !tileState.hasReportedVisibility) {
            (0, $6fuyt.queueImpression)(product, listInformation.name, position);
            // Allow other consumers to insert their own callback
            if ((0, $f3hTG.default)(callbacks.impression)) callbacks.impression(product, listInformation.name, position);
            tileState.hasReportedVisibility = true;
        }
    });
    const { ref: ref } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    const checkIfWarn = (0, $Kk7R3.action)(()=>{
        tileState.hovering = !(0, $bcbvQ.default).isLoggedIn();
    });
    const removeWarning = (0, $Kk7R3.action)(()=>{
        tileState.hovering = false;
    });
    const trackClick = ()=>{
        (0, $6fuyt.sendProductClick)(product, listInformation, position);
        // Allow other consumers to insert their own callback
        if ((0, $f3hTG.default)(callbacks.click)) callbacks.click(product, listInformation.name, position);
    };
    const handleQuantityChange = (0, $Kk7R3.action)((qty)=>{
        tileState.qty = qty;
        return qty;
    });
    const seasonalProduct = (0, $ioVMT.default)((0, $luszM.SEASONAL_PRODUCTS), product.sku);
    const stepperAndButtonContainer = (0, $izjX7.cn)("flex w-full items-center justify-stretch gap-1", {
        "flex-col gap-2": currentContainerSize === "thin"
    });
    const inputStepper = (0, $izjX7.cn)("flex-grow self-center [&>button]:h-[43px] [&>button]:w-[43px] disabled:[&>button]:bg-transparent [&>div]:h-[43px] [&>div]:min-w-[30px] [&>div]:max-w-[120px] [&>div]:flex-grow [&>div]:overflow-hidden", {
        "w-full [&>button]:flex-grow-0 [&>div]:max-w-[120px] [&>div]:flex-grow": currentContainerSize === "thin"
    });
    const outerClassName = (0, $izjX7.cn)("h-full rounded-lg shadow-sm hover:shadow-md", className);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ref: ref,
        className: outerClassName,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            ref: containerRef,
            className: "h-full min-h-[340px]",
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                ref: tileRef,
                className: (0, $izjX7.cn)("group relative flex min-h-full flex-col justify-between rounded-lg bg-base-0 p-3", {
                    "z-10 shadow-xl": tileState.hovering
                }),
                onMouseEnter: checkIfWarn,
                onMouseLeave: removeWarning,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                        className: "absolute right-0 flex flex-col",
                                        children: [
                                            !product.expired && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bO7t0.default), {
                                                sku: product.sku,
                                                listInformation: listInformation,
                                                position: position
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $h5LDr.default), {
                                                badges: product.badges,
                                                page: (0, $5qbUf.PageType).ProductListPage
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $03mes.default), {
                                        labels: product.labels,
                                        page: (0, $5qbUf.PageType).ProductListPage
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
                                        tabIndex: -1,
                                        to: (0, $bZiDo.default).getUrl(product),
                                        onClick: trackClick,
                                        "data-testid": "product-link",
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                                                alt: `Bilde av ${product.name}`,
                                                ref: imageRef,
                                                loading: "lazy",
                                                className: "mx-auto my-4 block aspect-square w-7/12 p-1 group-hover:p-0 group-hover:transition-[padding] group-hover:duration-150",
                                                src: (0, $g9Bxb.productImageUrl)(product.sku, 130)
                                            }),
                                            (0, $i6TQx.default).getPromotionsBySku(product.sku).map((promotion)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $f7kjZ.default), {
                                                    size: "small",
                                                    children: promotion.banner
                                                }, promotion.banner))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "mb-1 text-sm/[16px] font-medium",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                                    to: (0, $bZiDo.default).getUrl(product),
                                    onClick: trackClick,
                                    children: product.name
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: "mb-3 text-xxs text-base-600",
                                children: [
                                    "Art.nr. ",
                                    product.sku
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex flex-col justify-end",
                        children: [
                            (0, $bcbvQ.default).isLoggedIn() && !product.expired && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lAgRA.default), {
                                        className: "mb-1",
                                        price: product.priceBeforeDiscount ?? product.price ?? 0,
                                        newPrice: product.price ?? 0,
                                        postPriceDetail: (0, $5OqMf.formatUnit)(product.unit)
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                        className: "flex flex-col gap-1 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3muLR.default), {
                                                className: "text-xxs text-base-600",
                                                product: product
                                            }),
                                            (0, $aQzCo.default)(product.comparisonPrice) && (0, $isIf6.default).showComparisonPrice && !!product.comparisonUnit && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                                className: "mb-1 text-xxs text-base-600",
                                                children: [
                                                    (0, $5OqMf.formatPrice)(product.comparisonPrice),
                                                    " per ",
                                                    product.comparisonUnit?.toLowerCase()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !product.expired && (0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: stepperAndButtonContainer,
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1A6xS.InputStepper), {
                                        className: inputStepper,
                                        value: tileState.qty,
                                        onChange: handleQuantityChange,
                                        min: 1
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $27iE3.default), {
                                        product: product,
                                        qty: tileState.qty,
                                        imageRefFn: ()=>imageRef,
                                        callbacks: callbacks,
                                        listInformation: listInformation,
                                        position: position,
                                        size: currentContainerSize === "thin" ? "regular" : "iconOnly",
                                        className: currentContainerSize === "thin" ? "w-full" : ""
                                    })
                                ]
                            }),
                            !(0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                className: "mt-4",
                                variant: "tertiary",
                                size: "compact",
                                onClick: (0, $a2SqC.default).showLoginModal,
                                children: "Logg inn for kj\xf8p"
                            }),
                            product.expired && (0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: "text-xs",
                                children: seasonalProduct ? "Denne varen er utg\xe5tt for sesongen" : "Denne varen er utg\xe5tt fra sortimentet"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $bfcc7093040f8b05$export$2e2bcd8739ae039 = (0, $gBcml.observer)($bfcc7093040f8b05$var$ProductTile);

});
parcelRegister("1A6xS", function(module, exports) {

$parcel$export(module.exports, "InputStepper", function () { return $126e3aff7a11df54$export$67f30e8858cbcab1; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $cGjF4 = parcelRequire("cGjF4");

var $3SASj = parcelRequire("3SASj");

var $2QiYM = parcelRequire("2QiYM");

var $dJUDs = parcelRequire("dJUDs");
const $126e3aff7a11df54$var$i = (r, n, a = !1)=>typeof r > "u" ? "" : typeof r == "string" && a ? r : typeof r == "object" ? r[n] ?? "" : "";
function $126e3aff7a11df54$export$67f30e8858cbcab1({ value: r = 1, className: n, onChange: a, min: o, max: u, size: d = "regular", onPlusClick: s, onMinusClick: g, ...w }) {
    const [l, m] = (0, $dvPqk.useState)(r), [x, f] = (0, $dvPqk.useState)(r.toString());
    (0, $dvPqk.useEffect)(()=>{
        m(r), f(r.toString());
    }, [
        r
    ]);
    const b = (0, $dvPqk.useCallback)((t)=>{
        let e = t(l);
        if (isNaN(e) && (e = 1), o !== void 0 && e < o && (e = o), u !== void 0 && e > u && (e = u), e === l) {
            f(e.toString());
            return;
        }
        if (typeof a == "function") {
            const y = a(e);
            typeof y == "number" && (e = y);
        }
        m(e), f(e.toString());
    }, [
        l,
        a,
        o,
        u
    ]), h = ()=>{
        typeof s == "function" && s() === !1 || b((t)=>t + 1);
    }, V = ()=>{
        typeof g == "function" && g() === !1 || b((t)=>t - 1);
    }, k = {
        compact: "w-32 max-w-36",
        regular: "w-44 max-w-40",
        large: "w-48 max-w-48"
    }[d], I = {
        compact: "[&_input]:h-8 [&_input]:text-sm",
        regular: "h-[42px]",
        large: "h-[51px] [&_input]:text-xl [&_input]:font-bold"
    }[d], v = {
        compact: "h-8 w-10",
        regular: "w-12",
        large: "w-14"
    }[d];
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)(// Layout
        "grid gap-0 grid-cols-[max-content_auto_max-content] ", // Border and shape
        "border border-solid border-ink-brand-default rounded-button", k, $126e3aff7a11df54$var$i(n, "container", !0)),
        ...w,
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                "aria-label": "Minske antall",
                className: (0, $6sMuH.cn)(// Shape
                "border-0 hover:border-0 rounded-r-none", // Disabled override color
                "[&:disabled]:bg-surface-default", v, $126e3aff7a11df54$var$i(n, "button"), $126e3aff7a11df54$var$i(n, "decrease")),
                disabled: o !== void 0 && l <= o,
                onClick: V,
                size: d === "regular" ? "regular" : "compact",
                variant: "tertiary",
                children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $2QiYM.default), {})
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                "aria-label": "Antall",
                className: (0, $6sMuH.cn)(// Size
                "w-full [&>div]:h-full [&_input]:h-full", I, // Border
                "border-x border-y-0 border-ink-brand-default border-solid", // Descendant input element styling
                "[&_input]:text-center [&_input]:rounded-none [&_input]:border-0 [&_input]:px-0 [&_input]:active:border-0 [&_input]:focus:border-0", $126e3aff7a11df54$var$i(n, "input")),
                inputMode: "numeric",
                label: "",
                onBlur: (t)=>{
                    b(()=>parseInt(t.target.value, 10));
                },
                onChange: (t)=>{
                    f(t.target.value);
                },
                onFocus: (t)=>{
                    t.target.select();
                },
                type: "number",
                value: x
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                "aria-label": "\xd8ke antall",
                className: (0, $6sMuH.cn)(// Shape
                "border-0 hover:border-0 rounded-l-none", // Disabled override color
                "[&:disabled]:bg-surface-default", v, $126e3aff7a11df54$var$i(n, "button"), $126e3aff7a11df54$var$i(n, "increase")),
                disabled: u !== void 0 && l >= u,
                onClick: h,
                size: d === "regular" ? "regular" : "compact",
                variant: "tertiary",
                children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $dJUDs.default), {})
            })
        ]
    });
}
$126e3aff7a11df54$export$67f30e8858cbcab1.displayName = "InputStepper";

});
parcelRegister("3SASj", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $2d3304dded668db2$export$f5b8910cec6cf069; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $eVBn0 = parcelRequire("eVBn0");

var $lFdyG = parcelRequire("lFdyG");

var $hjaY7 = parcelRequire("hjaY7");

var $7nVb7 = parcelRequire("7nVb7");

var $LvizG = parcelRequire("LvizG");
const $2d3304dded668db2$export$f5b8910cec6cf069 = (0, $dvPqk.forwardRef)(({ description: b = "", disabled: p = !1, errorMessage: c = "", hideLabel: m = !1, label: n = "", placeholder: g = "", showErrorMessage: t = !1, type: i = "text", icon: r, iconPosition: a = "left", tooltipPosition: h = "right", tooltipText: v, className: x, inputSize: s = "regular", ...k }, w)=>{
    const [o, N] = (0, $dvPqk.useState)(!1), f = (0, $dvPqk.useId)(), y = i === "password" && o ? "text" : i, S = ()=>{
        N(!o);
    }, C = {
        compact: "text-xs leading-none",
        regular: "text-base"
    }, l = s === "compact" ? 16 : 20;
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("flex flex-col gap-y-2 w-full", x),
        children: [
            n ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lFdyG.FormDetails), {
                description: b,
                id: f,
                isLabelHidden: m,
                label: n,
                tooltipPosition: h,
                tooltipText: v
            }) : null,
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: "relative flex items-center fill-ink-brand-default",
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)("input", {
                        id: f,
                        placeholder: g,
                        ref: w,
                        type: y,
                        ...k,
                        className: (0, $6sMuH.cn)(// basic layout
                        "block w-full relative transition-all p-2 text-ink-brand-default fill-ink-brand-default rounded placeholder:text-ink-disabled", // border
                        "border-2 border-ink-disabled hover:border-ink-brand-default focus-visible:ring-offset-1 focus-visible:ring-offset-ink-brand-default", // focus
                        "focus-visible:border-ink-brand-default focus-visible:ring-2 focus-visible:ring-information-600 focus-visible:outline-none", // Invalid state
                        "data-[invalid]:border-error-600 data-[invalid]:data-[hover]:border-error-600", t && "!border-error-600", i === "file" && "p-0 border-0 file:rounded-button file:mr-5 file:border-button-primary-bg file:px-button-regular-padding-x file:py-button-regular-padding-y file:border-solid file:text-button-primary-text file:bg-button-primary-bg hover:file:cursor-pointer", p && "bg-base-100 cursor-not-allowed pointer-events-none", // Icon position
                        i === "password" && "pr-16", r && a === "left" && "pl-10", r && a === "right" && "pr-8", r && a === "right" && t && "pr-16", // Size classes
                        C[s])
                    }),
                    r && a === "left" ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "absolute left-2",
                        children: r
                    }) : null,
                    t ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "absolute right-2",
                        children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hjaY7.default), {
                            className: "fill-error-600",
                            height: l,
                            width: l
                        })
                    }) : null,
                    r && a === "right" ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: (0, $6sMuH.cn)("absolute", t ? "right-8" : "right-2"),
                        children: r
                    }) : null,
                    i === "password" ? /* @__PURE__ */ (0, $7YWoO.jsx)("button", {
                        "aria-checked": o,
                        className: (0, $6sMuH.cn)("absolute bg-transparent border-none cursor-pointer fill-ink-brand-default", t ? "right-8" : "right-2"),
                        onClick: S,
                        role: "switch",
                        type: "button",
                        children: o ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $7nVb7.default), {
                            height: l,
                            width: l
                        }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $LvizG.default), {
                            height: l,
                            width: l
                        })
                    }) : null
                ]
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $eVBn0.FormError), {
                errorMessage: c,
                showErrorMessage: t
            })
        ]
    });
});
$2d3304dded668db2$export$f5b8910cec6cf069.displayName = "Input";

});
parcelRegister("eVBn0", function(module, exports) {

$parcel$export(module.exports, "FormError", function () { return $ade3607ee444269d$export$942b2219c902021e; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $hjaY7 = parcelRequire("hjaY7");
function $ade3607ee444269d$export$942b2219c902021e({ errorMessage: r, showErrorMessage: i = !1 }) {
    return typeof r != "string" || !r.trim() ? null : /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        "aria-live": "polite",
        "aria-relevant": "additions removals",
        className: (0, $6sMuH.cn)(i ? "flex" : "hidden", "items-start gap-1 p-1 text-sm border-0 border-l-2 bg-error-100 border-l-error-600"),
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hjaY7.default), {
                className: "w-4 mt-0.5 flex-shrink-0 h-4 fill-error-600"
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                className: "mb-0 text-ink-brand-default",
                children: r
            })
        ]
    });
}
$ade3607ee444269d$export$942b2219c902021e.displayName = "FormError";

});
parcelRegister("hjaY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c99cb823d8efee36$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $c99cb823d8efee36$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M8.695 16.5 12 13.195l3.305 3.305 1.195-1.195L13.195 12 16.5 8.695 15.305 7.5 12 10.805 8.695 7.5 7.5 8.695 10.805 12 7.5 15.305zM12 21a8.8 8.8 0 0 1-3.492-.703 9.1 9.1 0 0 1-2.871-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 12q0-1.875.703-3.504a9.072 9.072 0 0 1 4.805-4.793A8.8 8.8 0 0 1 12 3q1.875 0 3.504.703a9.1 9.1 0 0 1 4.793 4.793A8.75 8.75 0 0 1 21 12a8.8 8.8 0 0 1-.703 3.492 9.07 9.07 0 0 1-4.793 4.805A8.75 8.75 0 0 1 12 21m0-1.687q3.047 0 5.18-2.133T19.313 12 17.18 6.82 12 4.687 6.82 6.82 4.687 12t2.133 5.18T12 19.313"
        })
    }));

});


parcelRegister("lFdyG", function(module, exports) {

$parcel$export(module.exports, "FormDetails", function () { return $fc57f1b58c0fa361$export$443f5ca0846c685b; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $jOVmP = parcelRequire("jOVmP");
function $fc57f1b58c0fa361$export$443f5ca0846c685b({ className: n, description: r = "", id: a, isLabelHidden: o = !1, isDisabled: s = !1, label: t, tooltipPosition: d = "right", tooltipText: m = "" }) {
    const f = a ?? (typeof t == "string" ? t : void 0);
    return /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: (0, $6sMuH.cn)("flex items-center gap-x-2", n),
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)("label", {
                        className: (0, $6sMuH.cn)("text-ink-default font-semibold text-sm", o && "sr-only", s && "text-ink-disabled"),
                        htmlFor: f,
                        children: t
                    }),
                    m ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $jOVmP.Tooltip), {
                        tooltipPosition: d,
                        tooltipText: m
                    }) : null
                ]
            }),
            r ? /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                className: (0, $6sMuH.cn)("text-sm text-ink-default mb-0", s && "text-ink-disabled"),
                children: r
            }) : null
        ]
    });
}
$fc57f1b58c0fa361$export$443f5ca0846c685b.displayName = "FormDetails";

});
parcelRegister("jOVmP", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $e6df2fc4bbe92a97$export$28c660c63b792dea; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $65O2X = parcelRequire("65O2X");

var $gfKH3 = parcelRequire("gfKH3");
function $e6df2fc4bbe92a97$var$$({ iconVariant: n }) {
    const t = "cursor-pointer fill-surface-action";
    switch(n){
        case "help":
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $65O2X.default), {
                className: t,
                height: 20,
                width: 20
            });
        case "information":
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $gfKH3.default), {
                className: t,
                height: 20,
                width: 20
            });
        default:
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $65O2X.default), {
                className: t,
                height: 20,
                width: 20
            });
    }
}
function $e6df2fc4bbe92a97$export$28c660c63b792dea({ tooltipText: n, tooltipPosition: t = "bottom", iconVariant: b = "help", children: r, offsetX: i = 0, offsetY: c = 0, isVisible: l = !0 }) {
    const a = (0, $dvPqk.useRef)(null), u = (0, $dvPqk.useId)(), m = ()=>{
        a.current && l && (a.current.style.visibility = "visible");
    }, s = ()=>{
        a.current && (a.current.style.visibility = "hidden");
    };
    (0, $dvPqk.useEffect)(()=>{
        const o = (g)=>{
            g.key === "Escape" && s();
        };
        return document.addEventListener("keydown", o), ()=>{
            document.removeEventListener("keydown", o);
        };
    }, []);
    const h = (o)=>{
        switch(o){
            case "top":
                return "bottom-6 left-1/2 transform -translate-x-1/2";
            case "bottom":
                return "top-7 left-1/2 transform -translate-x-1/2";
            case "left":
                return "right-7 top-1/2 transform -translate-y-1/2";
            case "right":
                return "left-7 top-1/2 transform -translate-y-1/2";
            default:
                return "bottom-full left-1/2 transform -translate-x-1/2";
        }
    }, x = (o)=>{
        switch(o){
            case "top":
                return "bottom-[-6px] left-1/2 transform -translate-x-1/2";
            case "right":
                return "left-[-12px] top-1/2 transform -translate-y-1/2 rotate-90";
            case "bottom":
                return "top-[-6px] left-1/2 transform -translate-x-1/2 rotate-180";
            case "left":
                return "right-[-12px] top-1/2 transform -translate-y-1/2 rotate-[270deg]";
            default:
                return "bottom-full left-1/2 transform -translate-x-1/2";
        }
    };
    return !l && r ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: r
    }) : l ? /* @__PURE__ */ (0, $7YWoO.jsxs)(r ? "div" : "button", {
        "aria-describedby": u,
        "aria-label": r ? void 0 : "Tooltip",
        className: `relative flex items-center ${r ? "inline-block" : "p-0 bg-transparent border-none"} max-w-max group`,
        onBlur: s,
        onFocus: m,
        onMouseEnter: m,
        onMouseLeave: s,
        type: r ? void 0 : "button",
        children: [
            r || /* @__PURE__ */ (0, $7YWoO.jsx)($e6df2fc4bbe92a97$var$$, {
                iconVariant: b
            }),
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: `absolute invisible z-10 p-2 w-max text-sm whitespace-normal rounded shadow-lg max-w-44 text-ink-brand-inverted group-focus:visible group-hover:visible bg-surface-action base-0 ${h(t)}`,
                id: u,
                onBlur: s,
                ref: a,
                role: "tooltip",
                style: {
                    transform: t === "top" || t === "bottom" ? `translate(calc(-50% + ${i}px), ${c}px)` : `translate(${i}px, calc(-50% + ${c}px))`
                },
                children: [
                    n || null,
                    /* @__PURE__ */ (0, $7YWoO.jsx)("svg", {
                        className: `absolute w-6 h-3 ${x(t)}`,
                        fill: "none",
                        viewBox: "0 0 24 12",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /* @__PURE__ */ (0, $7YWoO.jsx)("path", {
                            className: "fill-surface-action",
                            d: "M12 12L0 0h24L12 12z"
                        })
                    })
                ]
            })
        ]
    }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {});
}
$e6df2fc4bbe92a97$export$28c660c63b792dea.displayName = "Tooltip";

});
parcelRegister("65O2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46fa07f6560ae608$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $46fa07f6560ae608$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M12 17.625q.469 0 .797-.328.328-.329.328-.797t-.328-.797a1.09 1.09 0 0 0-.797-.328q-.468 0-.797.328a1.09 1.09 0 0 0-.328.797q0 .469.328.797.329.328.797.328m-.844-3.586h1.711q0-.867.152-1.23.153-.364.739-.926.82-.797 1.137-1.36a2.5 2.5 0 0 0 .316-1.242q0-1.29-.879-2.097-.879-.81-2.238-.809-1.196 0-2.074.633a3.3 3.3 0 0 0-1.23 1.71l1.523.634q.21-.657.667-1.02t1.067-.363q.656 0 1.078.375t.422.984q0 .54-.363.961a9 9 0 0 1-.809.82q-.82.75-1.02 1.23-.199.482-.199 1.7M12 21a8.8 8.8 0 0 1-3.492-.703 9.1 9.1 0 0 1-2.871-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 12q0-1.875.703-3.504a9.072 9.072 0 0 1 4.805-4.793A8.8 8.8 0 0 1 12 3q1.875 0 3.504.703a9.1 9.1 0 0 1 4.793 4.793A8.75 8.75 0 0 1 21 12a8.8 8.8 0 0 1-.703 3.492 9.07 9.07 0 0 1-4.793 4.805A8.75 8.75 0 0 1 12 21m0-1.687q3.047 0 5.18-2.133T19.313 12 17.18 6.82 12 4.687 6.82 6.82 4.687 12t2.133 5.18T12 19.313"
        })
    }));

});

parcelRegister("gfKH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd524467e6fa9ec4$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $bd524467e6fa9ec4$export$2e2bcd8739ae039 = (e)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, e, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M11.156 16.5h1.688v-5.625h-1.688zm.84-7.312q.356 0 .602-.242a.8.8 0 0 0 .246-.597.83.83 0 0 0-.241-.603.8.8 0 0 0-.598-.246.83.83 0 0 0-.603.241.8.8 0 0 0-.246.598q0 .356.241.602t.598.246M12.005 21a8.8 8.8 0 0 1-3.498-.703 9.1 9.1 0 0 1-2.871-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 11.99q0-1.864.703-3.493a9.075 9.075 0 0 1 4.804-4.793A8.8 8.8 0 0 1 12.01 3q1.864 0 3.493.703a9.093 9.093 0 0 1 4.793 4.798A8.7 8.7 0 0 1 21 11.993a8.8 8.8 0 0 1-.703 3.5 9.1 9.1 0 0 1-1.934 2.87 9.1 9.1 0 0 1-2.864 1.934 8.7 8.7 0 0 1-3.492.703M12 19.313q3.047 0 5.18-2.133T19.313 12 17.18 6.82 12 4.687 6.82 6.82 4.687 12t2.133 5.18T12 19.313"
        })
    }));

});



parcelRegister("7nVb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $560708d1f50b651b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $560708d1f50b651b$export$2e2bcd8739ae039 = (e)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, e, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m15.523 12.74-1.528-1.529a1.92 1.92 0 0 0-.568-1.615q-.665-.678-1.602-.58l-1.53-1.528q.322-.124.667-.185.345-.062.69-.062 1.726 0 2.934 1.208 1.208 1.209 1.208 2.935 0 .345-.061.69-.062.345-.21.666m3.28 3.28-1.283-1.283a12 12 0 0 0 1.616-1.517 8.2 8.2 0 0 0 1.22-1.836 9.1 9.1 0 0 0-3.563-3.909 9.8 9.8 0 0 0-5.14-1.417q-.643 0-1.258.074-.616.074-1.209.246l-1.43-1.43a8.8 8.8 0 0 1 1.911-.518 13 13 0 0 1 1.985-.148q3.525 0 6.448 1.911 2.922 1.911 4.204 5.19a9.9 9.9 0 0 1-1.442 2.553q-.9 1.146-2.06 2.083m-.05 4.98-3.205-3.206a11.1 11.1 0 0 1-3.896.69q-3.526 0-6.448-1.91Q2.281 14.663 1 11.384q.543-1.405 1.43-2.565a12 12 0 0 1 2.071-2.096L2.036 4.258 3.293 3l16.718 16.743zM5.76 8.005q-.863.69-1.603 1.517a7.3 7.3 0 0 0-1.208 1.862 9.1 9.1 0 0 0 3.563 3.908 9.8 9.8 0 0 0 5.141 1.418q.642 0 1.258-.087.616-.085 1.233-.234l-1.11-1.11a4.3 4.3 0 0 1-.69.185 4 4 0 0 1-.69.062q-1.728 0-2.935-1.208-1.209-1.209-1.208-2.934 0-.345.086-.69.085-.346.16-.691z"
        })
    }));

});

parcelRegister("LvizG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ecab260f04e6fd$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $08ecab260f04e6fd$export$2e2bcd8739ae039 = (e)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, e, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M12.5 16.083q1.701 0 2.892-1.19Q16.583 13.7 16.583 12t-1.19-2.892Q14.2 7.917 12.5 7.917t-2.892 1.19Q8.417 10.3 8.417 12t1.19 2.892q1.192 1.191 2.893 1.191m0-1.75a2.25 2.25 0 0 1-1.653-.68 2.25 2.25 0 0 1-.68-1.653q0-.973.68-1.653a2.25 2.25 0 0 1 1.653-.68q.973 0 1.653.68a2.25 2.25 0 0 1 .68 1.653q0 .973-.68 1.653a2.25 2.25 0 0 1-1.653.68m0 4.667q-3.465 0-6.315-1.908Q3.336 15.183 2 12q1.337-3.184 4.185-5.092Q9.035 5 12.5 5t6.314 1.908Q21.665 8.817 23 12q-1.336 3.184-4.186 5.092Q15.967 19 12.5 19m0-1.75q2.723 0 5.031-1.41A9.43 9.43 0 0 0 21.08 12a9.43 9.43 0 0 0-3.549-3.84A9.5 9.5 0 0 0 12.5 6.75q-2.722 0-5.031 1.41A9.43 9.43 0 0 0 3.92 12a9.43 9.43 0 0 0 3.549 3.84 9.5 9.5 0 0 0 5.031 1.41"
        })
    }));

});


parcelRegister("2QiYM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $211f29044c4ba050$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $211f29044c4ba050$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M2.75 12.479v-2.396h16.5v2.396z"
        })
    }));

});

parcelRegister("dJUDs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a00b68f742f90908$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $a00b68f742f90908$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M9.763 12.238H2.75V9.762h7.012V2.75h2.476v7.012h7.012v2.476h-7.012v7.012H9.762z"
        })
    }));

});


parcelRegister("aQzCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5a63c4f4d694dc$export$2e2bcd8739ae039; });

var $65ROZ = parcelRequire("65ROZ");

var $bBbWb = parcelRequire("bBbWb");
/** `Object#toString` result references. */ var $7e5a63c4f4d694dc$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $7e5a63c4f4d694dc$var$isNumber(value) {
    return typeof value == 'number' || (0, $bBbWb.default)(value) && (0, $65ROZ.default)(value) == $7e5a63c4f4d694dc$var$numberTag;
}
var $7e5a63c4f4d694dc$export$2e2bcd8739ae039 = $7e5a63c4f4d694dc$var$isNumber;

});

parcelRegister("blzR8", function(module, exports) {

$parcel$export(module.exports, "useInView", function () { return $8790f3bf4d6be86c$export$2f62ee6831462844; });

var $dvPqk = parcelRequire("dvPqk");
function $8790f3bf4d6be86c$var$_extends() {
    $8790f3bf4d6be86c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8790f3bf4d6be86c$var$_extends.apply(this, arguments);
}
function $8790f3bf4d6be86c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8790f3bf4d6be86c$var$observerMap = new Map();
const $8790f3bf4d6be86c$var$RootIds = new WeakMap();
let $8790f3bf4d6be86c$var$rootId = 0;
let $8790f3bf4d6be86c$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $8790f3bf4d6be86c$export$2ef3a60ee1f37bec(inView) {
    $8790f3bf4d6be86c$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $8790f3bf4d6be86c$var$getRootId(root) {
    if (!root) return '0';
    if ($8790f3bf4d6be86c$var$RootIds.has(root)) return $8790f3bf4d6be86c$var$RootIds.get(root);
    $8790f3bf4d6be86c$var$rootId += 1;
    $8790f3bf4d6be86c$var$RootIds.set(root, $8790f3bf4d6be86c$var$rootId.toString());
    return $8790f3bf4d6be86c$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $8790f3bf4d6be86c$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== undefined).map((key)=>{
        return `${key}_${key === 'root' ? $8790f3bf4d6be86c$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $8790f3bf4d6be86c$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    let id = $8790f3bf4d6be86c$var$optionsToId(options);
    let instance = $8790f3bf4d6be86c$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        const elements = new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $8790f3bf4d6be86c$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $8790f3bf4d6be86c$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $8790f3bf4d6be86c$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{
        // Nothing to cleanup
        };
    }
    // An observer with the same options can be reused, so lets use this fact
    const { id: id, observer: observer, elements: elements } = $8790f3bf4d6be86c$var$createObserver(options);
    // Register the callback listener for this element
    let callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $8790f3bf4d6be86c$var$observerMap.delete(id);
        }
    };
}
const $8790f3bf4d6be86c$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $8790f3bf4d6be86c$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ class $8790f3bf4d6be86c$export$a62107ca74432f44 extends $dvPqk.Component {
    constructor(props){
        super(props);
        this.node = null;
        this._unobserveCb = null;
        this.handleNode = (node)=>{
            if (this.node) {
                // Clear the old observer, before we start observing a new element
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                this.setState({
                    inView: !!this.props.initialInView,
                    entry: undefined
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        };
        this.handleChange = (inView, entry)=>{
            if (inView && this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            this.unobserve();
            if (!$8790f3bf4d6be86c$var$isPlainChildren(this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) // If the user is actively listening for onChange, always trigger it
            this.props.onChange(inView, entry);
        };
        this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
    }
    componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
        this.node = null;
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $8790f3bf4d6be86c$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        if (!$8790f3bf4d6be86c$var$isPlainChildren(this.props)) {
            const { inView: inView, entry: entry } = this.state;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const _this$props = this.props, { children: children, as: as } = _this$props, props = $8790f3bf4d6be86c$var$_objectWithoutPropertiesLoose(_this$props, $8790f3bf4d6be86c$var$_excluded);
        return $dvPqk.createElement(as || 'div', $8790f3bf4d6be86c$var$_extends({
            ref: this.handleNode
        }, props), children);
    }
}
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $8790f3bf4d6be86c$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _state$entry;
    const [ref, setRef] = $dvPqk.useState(null);
    const callback = $dvPqk.useRef();
    const [state, setState] = $dvPqk.useState({
        inView: !!initialInView,
        entry: undefined
    });
    // Store the onChange callback in a `ref`, so we can access the latest instance
    // inside the `useEffect`, but without triggering a rerender.
    callback.current = onChange;
    $dvPqk.useEffect(()=>{
        // Ensure we have node ref, and that we shouldn't skip observing
        if (skip || !ref) return;
        let unobserve;
        unobserve = $8790f3bf4d6be86c$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve();
                unobserve = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
    const previousEntryTarget = $dvPqk.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: undefined
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("8kt8E", function(module, exports) {

$parcel$export(module.exports, "useParams", function () { return $6106cb4a60fd5110$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useLocation", function () { return $6106cb4a60fd5110$export$45d76561a5302f2b; });
$parcel$export(module.exports, "Router", function () { return $6106cb4a60fd5110$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "useSearchParams", function () { return $6106cb4a60fd5110$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "Route", function () { return $6106cb4a60fd5110$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Link", function () { return $6106cb4a60fd5110$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "Switch", function () { return $6106cb4a60fd5110$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "Redirect", function () { return $6106cb4a60fd5110$export$2d8d895a0a0f636e; });

var $7XWmi = parcelRequire("7XWmi");

var $7nQ1B = parcelRequire("7nQ1B");
parcelRequire("fqosc");
var $dvPqk = parcelRequire("dvPqk");
var $fqosc = parcelRequire("fqosc");
/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ const $6106cb4a60fd5110$var$_relativePath = (base, path)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
/**
 * When basepath is `undefined` or '/' it is ignored (we assume it's empty string)
 */ const $6106cb4a60fd5110$var$baseDefaults = (base = "")=>base === "/" ? "" : base;
const $6106cb4a60fd5110$var$absolutePath = (to, base)=>to[0] === "~" ? to.slice(1) : $6106cb4a60fd5110$var$baseDefaults(base) + to;
const $6106cb4a60fd5110$var$relativePath = (base = "", path)=>$6106cb4a60fd5110$var$_relativePath($6106cb4a60fd5110$var$unescape($6106cb4a60fd5110$var$baseDefaults(base)), $6106cb4a60fd5110$var$unescape(path));
/*
 * Removes leading question mark
 */ const $6106cb4a60fd5110$var$stripQm = (str)=>str[0] === "?" ? str.slice(1) : str;
/*
 * decodes escape sequences such as %20
 */ const $6106cb4a60fd5110$var$unescape = (str)=>{
    try {
        return decodeURI(str);
    } catch (_e) {
        // fail-safe mode: if string can't be decoded do nothing
        return str;
    }
};
const $6106cb4a60fd5110$var$sanitizeSearch = (search)=>$6106cb4a60fd5110$var$unescape($6106cb4a60fd5110$var$stripQm(search));
/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const $6106cb4a60fd5110$var$defaultRouter = {
    hook: (0, $7nQ1B.useBrowserLocation),
    searchHook: (0, $7nQ1B.useSearch),
    parser: (0, $7XWmi.parse),
    base: "",
    // this option is used to override the current location during SSR
    ssrPath: undefined,
    ssrSearch: undefined,
    // optional context to track render state during SSR
    ssrContext: undefined,
    // customizes how `href` props are transformed for <Link />
    hrefs: (x)=>x
};
const $6106cb4a60fd5110$var$RouterCtx = (0, $dvPqk.createContext)($6106cb4a60fd5110$var$defaultRouter);
// gets the closest parent router from the context
const $6106cb4a60fd5110$export$9a302a45f65d0572 = ()=>(0, $dvPqk.useContext)($6106cb4a60fd5110$var$RouterCtx);
/**
 * Parameters context. Used by `useParams()` to get the
 * matched params from the innermost `Route` component.
 */ const $6106cb4a60fd5110$var$Params0 = {}, $6106cb4a60fd5110$var$ParamsCtx = (0, $dvPqk.createContext)($6106cb4a60fd5110$var$Params0);
const $6106cb4a60fd5110$export$99eaa27ddbbb95ef = ()=>(0, $dvPqk.useContext)($6106cb4a60fd5110$var$ParamsCtx);
/*
 * Part 1, Hooks API: useRoute and useLocation
 */ // Internal version of useLocation to avoid redundant useRouter calls
const $6106cb4a60fd5110$var$useLocationFromRouter = (router)=>{
    const [location, navigate] = router.hook(router);
    // the function reference should stay the same between re-renders, so that
    // it can be passed down as an element prop without any performance concerns.
    // (This is achieved via `useEvent`.)
    return [
        $6106cb4a60fd5110$var$relativePath(router.base, location),
        (0, $fqosc.useEvent)((to, navOpts)=>navigate($6106cb4a60fd5110$var$absolutePath(to, router.base), navOpts))
    ];
};
const $6106cb4a60fd5110$export$45d76561a5302f2b = ()=>$6106cb4a60fd5110$var$useLocationFromRouter($6106cb4a60fd5110$export$9a302a45f65d0572());
const $6106cb4a60fd5110$export$bd221a7c56b93941 = ()=>{
    const router = $6106cb4a60fd5110$export$9a302a45f65d0572();
    return $6106cb4a60fd5110$var$sanitizeSearch(router.searchHook(router));
};
const $6106cb4a60fd5110$export$b4ee0d6794375c82 = (parser, route, path, loose)=>{
    // if the input is a regexp, skip parsing
    const { pattern: pattern, keys: keys } = route instanceof RegExp ? {
        keys: false,
        pattern: route
    } : parser(route || "*", loose);
    // array destructuring loses keys, so this is done in two steps
    const result = pattern.exec(path) || [];
    // when parser is in "loose" mode, `$base` is equal to the
    // first part of the route that matches the pattern
    // (e.g. for pattern `/a/:b` and path `/a/1/2/3` the `$base` is `a/1`)
    // we use this for route nesting
    const [$base, ...matches] = result;
    return $base !== undefined ? [
        true,
        (()=>{
            // for regex paths, `keys` will always be false
            // an object with parameters matched, e.g. { foo: "bar" } for "/:foo"
            // we "zip" two arrays here to construct the object
            // ["foo"], ["bar"] → { foo: "bar" }
            const groups = keys !== false ? Object.fromEntries(keys.map((key, i)=>[
                    key,
                    matches[i]
                ])) : result.groups;
            // convert the array to an instance of object
            // this makes it easier to integrate with the existing param implementation
            let obj = {
                ...matches
            };
            // merge named capture groups with matches array
            groups && Object.assign(obj, groups);
            return obj;
        })(),
        // the third value if only present when parser is in "loose" mode,
        // so that we can extract the base path for nested routes
        ...loose ? [
            $base
        ] : []
    ] : [
        false,
        null
    ];
};
const $6106cb4a60fd5110$export$3f79f0b98112cf57 = (pattern)=>$6106cb4a60fd5110$export$b4ee0d6794375c82($6106cb4a60fd5110$export$9a302a45f65d0572().parser, pattern, $6106cb4a60fd5110$export$45d76561a5302f2b()[0]);
/*
 * Part 2, Low Carb Router API: Router, Route, Link, Switch
 */ const $6106cb4a60fd5110$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    // the router we will inherit from - it is the closest router in the tree,
    // unless the custom `hook` is provided (in that case it's the default one)
    const parent_ = $6106cb4a60fd5110$export$9a302a45f65d0572();
    const parent = props.hook ? $6106cb4a60fd5110$var$defaultRouter : parent_;
    // holds to the context value: the router object
    let value = parent;
    // when `ssrPath` contains a `?` character, we can extract the search from it
    const [path, search] = props.ssrPath?.split("?") ?? [];
    if (search) props.ssrSearch = search, props.ssrPath = path;
    // hooks can define their own `href` formatter (e.g. for hash location)
    props.hrefs = props.hrefs ?? props.hook?.hrefs;
    // what is happening below: to avoid unnecessary rerenders in child components,
    // we ensure that the router object reference is stable, unless there are any
    // changes that require reload (e.g. `base` prop changes -> all components that
    // get the router from the context should rerender, even if the component is memoized).
    // the expected behaviour is:
    //
    //   1) when the resulted router is no different from the parent, use parent
    //   2) if the custom `hook` prop is provided, we always inherit from the
    //      default router instead. this resets all previously overridden options.
    //   3) when the router is customized here, it should stay stable between renders
    let ref = (0, $dvPqk.useRef)({}), prev = ref.current, next = prev;
    for(let k in parent){
        const option = k === "base" ? /* base is special case, it is appended to the parent's base */ parent[k] + (props[k] || "") : props[k] || parent[k];
        if (prev === next && option !== next[k]) ref.current = next = {
            ...next
        };
        next[k] = option;
        // the new router is no different from the parent, use parent
        if (option !== parent[k]) value = next;
    }
    return (0, $dvPqk.createElement)($6106cb4a60fd5110$var$RouterCtx.Provider, {
        value: value,
        children: children
    });
};
const $6106cb4a60fd5110$var$h_route = ({ children: children, component: component }, params)=>{
    // React-Router style `component` prop
    if (component) return (0, $dvPqk.createElement)(component, {
        params: params
    });
    // support render prop or plain children
    return typeof children === "function" ? children(params) : children;
};
// Cache params object between renders if values are shallow equal
const $6106cb4a60fd5110$var$useCachedParams = (value)=>{
    let prev = (0, $dvPqk.useRef)($6106cb4a60fd5110$var$Params0);
    const curr = prev.current;
    return prev.current = // Update cache if number of params changed or any value changed
    Object.keys(value).length !== Object.keys(curr).length || Object.entries(value).some(([k, v])=>v !== curr[k]) ? value // Return new value if there are changes
     : curr; // Return cached value if nothing changed
};
function $6106cb4a60fd5110$export$f1a78c17382fe22a() {
    const [location, navigate] = $6106cb4a60fd5110$export$45d76561a5302f2b();
    const search = $6106cb4a60fd5110$export$bd221a7c56b93941();
    const searchParams = (0, $dvPqk.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
    // cached value before next render, so you can call setSearchParams multiple times
    let tempSearchParams = searchParams;
    const setSearchParams = (0, $fqosc.useEvent)((nextInit, options)=>{
        tempSearchParams = new URLSearchParams(typeof nextInit === "function" ? nextInit(tempSearchParams) : nextInit);
        navigate(location + "?" + tempSearchParams, options);
    });
    return [
        searchParams,
        setSearchParams
    ];
}
const $6106cb4a60fd5110$export$e7b0ac011bb776c6 = ({ path: path, nest: nest, match: match, ...renderProps })=>{
    const router = $6106cb4a60fd5110$export$9a302a45f65d0572();
    const [location] = $6106cb4a60fd5110$var$useLocationFromRouter(router);
    const [matches, routeParams, base] = // `match` is a special prop to give up control to the parent,
    // it is used by the `Switch` to avoid double matching
    match ?? $6106cb4a60fd5110$export$b4ee0d6794375c82(router.parser, path, location, nest);
    // when `routeParams` is `null` (there was no match), the argument
    // below becomes {...null} = {}, see the Object Spread specs
    // https://tc39.es/proposal-object-rest-spread/#AbstractOperations-CopyDataProperties
    const params = $6106cb4a60fd5110$var$useCachedParams({
        ...$6106cb4a60fd5110$export$99eaa27ddbbb95ef(),
        ...routeParams
    });
    if (!matches) return null;
    const children = base ? (0, $dvPqk.createElement)($6106cb4a60fd5110$export$55185c17a0fcbe46, {
        base: base
    }, $6106cb4a60fd5110$var$h_route(renderProps, params)) : $6106cb4a60fd5110$var$h_route(renderProps, params);
    return (0, $dvPqk.createElement)($6106cb4a60fd5110$var$ParamsCtx.Provider, {
        value: params,
        children: children
    });
};
const $6106cb4a60fd5110$export$a6c7ac8248d6e38a = (0, $dvPqk.forwardRef)((props, ref)=>{
    const router = $6106cb4a60fd5110$export$9a302a45f65d0572();
    const [currentPath, navigate] = $6106cb4a60fd5110$var$useLocationFromRouter(router);
    const { to: to = "", href: targetPath = to, onClick: _onClick, asChild: asChild, children: children, className: cls, replace: /* eslint-disable no-unused-vars */ replace /* ignore nav props */ , state: state /* ignore nav props */ , /* eslint-enable no-unused-vars */ ...restProps } = props;
    const onClick = (0, $fqosc.useEvent)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        _onClick?.(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(targetPath, props);
        }
    });
    // handle nested routers and absolute paths
    const href = router.hrefs(targetPath[0] === "~" ? targetPath.slice(1) : router.base + targetPath, router // pass router as a second argument for convinience
    );
    return asChild && (0, $dvPqk.isValidElement)(children) ? (0, $dvPqk.cloneElement)(children, {
        onClick: onClick,
        href: href
    }) : (0, $dvPqk.createElement)("a", {
        ...restProps,
        onClick: onClick,
        href: href,
        // `className` can be a function to apply the class if this link is active
        className: cls?.call ? cls(currentPath === targetPath) : cls,
        children: children,
        ref: ref
    });
});
const $6106cb4a60fd5110$var$flattenChildren = (children)=>Array.isArray(children) ? children.flatMap((c)=>$6106cb4a60fd5110$var$flattenChildren(c && c.type === (0, $dvPqk.Fragment) ? c.props.children : c)) : [
        children
    ];
const $6106cb4a60fd5110$export$b5d5cf8927ab7262 = ({ children: children, location: location })=>{
    const router = $6106cb4a60fd5110$export$9a302a45f65d0572();
    const [originalLocation] = $6106cb4a60fd5110$var$useLocationFromRouter(router);
    for (const element of $6106cb4a60fd5110$var$flattenChildren(children)){
        let match = 0;
        if ((0, $dvPqk.isValidElement)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = $6106cb4a60fd5110$export$b4ee0d6794375c82(router.parser, element.props.path, location || originalLocation, element.props.nest))[0]) return (0, $dvPqk.cloneElement)(element, {
            match: match
        });
    }
    return null;
};
const $6106cb4a60fd5110$export$2d8d895a0a0f636e = (props)=>{
    const { to: to, href: href = to } = props;
    const router = $6106cb4a60fd5110$export$9a302a45f65d0572();
    const [, navigate] = $6106cb4a60fd5110$var$useLocationFromRouter(router);
    const redirect = (0, $fqosc.useEvent)(()=>navigate(to || href, props));
    const { ssrContext: ssrContext } = router;
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, $fqosc.useIsomorphicLayoutEffect)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (ssrContext) ssrContext.redirectTo = to;
    return null;
};

});
parcelRegister("7XWmi", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $a3a597e5e6138697$export$98e6a39c04603d36; });
/**
 * @param {string|RegExp} input The route pattern
 * @param {boolean} [loose] Allow open-ended matching. Ignored with `RegExp` input.
 */ function $a3a597e5e6138697$export$98e6a39c04603d36(input, loose) {
    if (input instanceof RegExp) return {
        keys: false,
        pattern: input
    };
    var c, o, tmp, ext, keys = [], pattern = '', arr = input.split('/');
    arr[0] || arr.shift();
    while(tmp = arr.shift()){
        c = tmp[0];
        if (c === '*') {
            keys.push(c);
            pattern += tmp[1] === '?' ? '(?:/(.*))?' : '/(.*)';
        } else if (c === ':') {
            o = tmp.indexOf('?', 1);
            ext = tmp.indexOf('.', 1);
            keys.push(tmp.substring(1, !!~o ? o : !!~ext ? ext : tmp.length));
            pattern += !!~o && !~ext ? '(?:/([^/]+?))?' : '/([^/]+?)';
            if (!!~ext) pattern += (!!~o ? '?' : '') + '\\' + tmp.substring(ext);
        } else pattern += '/' + tmp;
    }
    return {
        keys: keys,
        pattern: new RegExp('^' + pattern + (loose ? '(?=$|\/)' : '\/?$'), 'i')
    };
}
var $a3a597e5e6138697$var$RGX = /(\/|^)([:*][^/]*?)(\?)?(?=[/.]|$)/g;
function $a3a597e5e6138697$export$a976684a0efeb93f(route, values) {
    return route.replace($a3a597e5e6138697$var$RGX, (x, lead, key, optional)=>{
        x = values[key == '*' ? key : key.substring(1)];
        return x ? '/' + x : optional || key == '*' ? '' : '/' + key;
    });
}

});


parcelRegister("2vDqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d81e60fd9b52a36c$export$2e2bcd8739ae039; });

var $d4mYJ = parcelRequire("d4mYJ");

var $dvPqk = parcelRequire("dvPqk");
const $d81e60fd9b52a36c$var$widthFromBoxSize = (size)=>Array.isArray(size) ? $d81e60fd9b52a36c$var$widthFromBoxSize(size[0] || {
        blockSize: 0,
        inlineSize: 0
    }) : size.inlineSize;
const $d81e60fd9b52a36c$var$externalWidthFromEntry = (entry)=>{
    return entry.borderBoxSize ? $d81e60fd9b52a36c$var$widthFromBoxSize(entry.borderBoxSize) : entry.contentRect.width;
};
const $d81e60fd9b52a36c$var$sizeFromWidthFactory = (widthRanges)=>(width)=>{
        const roundedWidth = Math.floor(width + 0.5);
        for (const [key, value] of Object.entries(widthRanges)){
            const range = value;
            const [start, end] = range;
            if (typeof end === "number") {
                if (roundedWidth <= end && roundedWidth >= start) return key;
            } else {
                if (roundedWidth >= start) return key;
            }
        }
        return undefined;
    };
/*
 *
 * useContainerWidths provides a value that is derived from the border-box width of an HTMLElement.  Internally, the hook instantiates a ResizeObserver that
 * will update the value whenever the element's width crosses the defined threshold values.
 *
 */ const $d81e60fd9b52a36c$var$useContainerWidth = (ranges)=>{
    const [size, setSize] = (0, $dvPqk.useState)();
    const ref = (0, $dvPqk.useRef)(null);
    const observerRef = (0, $dvPqk.useRef)();
    const handleResize = (0, $dvPqk.useCallback)((0, $d4mYJ.default)(([entry])=>{
        const sizeFromWidth = $d81e60fd9b52a36c$var$sizeFromWidthFactory(ranges);
        const width = $d81e60fd9b52a36c$var$externalWidthFromEntry(entry);
        const nextSize = sizeFromWidth(width);
        if (nextSize && nextSize !== size) setSize(nextSize);
    }, 10), [
        ranges
    ]);
    (0, $dvPqk.useLayoutEffect)(()=>{
        if (!observerRef.current) observerRef.current = new ResizeObserver(handleResize);
        if (ref.current) observerRef.current.observe(ref.current, {
            box: "border-box"
        });
        return ()=>{
            observerRef.current?.disconnect();
            observerRef.current = undefined;
        };
    }, [
        ranges,
        observerRef,
        ref
    ]);
    return {
        size: size,
        ref: ref
    };
};
var $d81e60fd9b52a36c$export$2e2bcd8739ae039 = $d81e60fd9b52a36c$var$useContainerWidth;

});

parcelRegister("g9Bxb", function(module, exports) {

$parcel$export(module.exports, "productImageUrl", function () { return $b4cf120200f9d0a4$export$3ed86bf8a3e4d8d; });

var $l9SHq = parcelRequire("l9SHq");

var $isIf6 = parcelRequire("isIf6");
const $b4cf120200f9d0a4$var$fallbackSize = {
    size: 750,
    id: "fullscreen"
};
// Array of available Papirfly APS sizes, should be ordered by size in ascending order.
const $b4cf120200f9d0a4$var$availableImageSize = [
    {
        size: 48,
        id: "thumb_small"
    },
    {
        size: 76,
        id: "thumb_large"
    },
    {
        size: 160,
        id: "small"
    },
    {
        size: 240,
        id: "medium"
    },
    {
        size: 380,
        id: "large"
    },
    $b4cf120200f9d0a4$var$fallbackSize
];
const $b4cf120200f9d0a4$var$siteNamePrefix = (0, $l9SHq.default)((0, $isIf6.default).siteName);
const $b4cf120200f9d0a4$export$3ed86bf8a3e4d8d = (sku, size = 380)=>{
    const sizeToUse = $b4cf120200f9d0a4$var$availableImageSize.find((imgSize)=>imgSize.size >= size) ?? $b4cf120200f9d0a4$var$fallbackSize;
    return `https://aps.brandmaster.com/v03/product/${(0, $isIf6.default).papirflyApsCustomerId}/${(0, $isIf6.default).papirflyApsImagePrefix}${sku}/${sizeToUse.id}/hovedbilde/${$b4cf120200f9d0a4$var$siteNamePrefix}_artnr_${sku}__${sizeToUse.id}.png`;
};

});
parcelRegister("l9SHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f674de65d74cb6bb$export$2e2bcd8739ae039; });

var $8Yap5 = parcelRequire("8Yap5");
/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $f674de65d74cb6bb$var$snakeCase = (0, $8Yap5.default)(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
var $f674de65d74cb6bb$export$2e2bcd8739ae039 = $f674de65d74cb6bb$var$snakeCase;

});
parcelRegister("8Yap5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $687bff47283171d1$export$2e2bcd8739ae039; });

var $jK0JZ = parcelRequire("jK0JZ");

var $aGYg9 = parcelRequire("aGYg9");

var $9slHK = parcelRequire("9slHK");
/** Used to compose unicode capture groups. */ var $687bff47283171d1$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $687bff47283171d1$var$reApos = RegExp($687bff47283171d1$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $687bff47283171d1$var$createCompounder(callback) {
    return function(string) {
        return (0, $jK0JZ.default)((0, $9slHK.default)((0, $aGYg9.default)(string).replace($687bff47283171d1$var$reApos, '')), callback, '');
    };
}
var $687bff47283171d1$export$2e2bcd8739ae039 = $687bff47283171d1$var$createCompounder;

});
parcelRegister("jK0JZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5f2e349a48884b2$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $e5f2e349a48884b2$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
var $e5f2e349a48884b2$export$2e2bcd8739ae039 = $e5f2e349a48884b2$var$arrayReduce;

});

parcelRegister("aGYg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c8c91e8ebdf09a1$export$2e2bcd8739ae039; });

var $8gR05 = parcelRequire("8gR05");

var $cQbRr = parcelRequire("cQbRr");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $7c8c91e8ebdf09a1$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $7c8c91e8ebdf09a1$var$rsComboMarksRange = '\\u0300-\\u036f', $7c8c91e8ebdf09a1$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7c8c91e8ebdf09a1$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7c8c91e8ebdf09a1$var$rsComboRange = $7c8c91e8ebdf09a1$var$rsComboMarksRange + $7c8c91e8ebdf09a1$var$reComboHalfMarksRange + $7c8c91e8ebdf09a1$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $7c8c91e8ebdf09a1$var$rsCombo = '[' + $7c8c91e8ebdf09a1$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $7c8c91e8ebdf09a1$var$reComboMark = RegExp($7c8c91e8ebdf09a1$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $7c8c91e8ebdf09a1$var$deburr(string) {
    string = (0, $cQbRr.default)(string);
    return string && string.replace($7c8c91e8ebdf09a1$var$reLatin, (0, $8gR05.default)).replace($7c8c91e8ebdf09a1$var$reComboMark, '');
}
var $7c8c91e8ebdf09a1$export$2e2bcd8739ae039 = $7c8c91e8ebdf09a1$var$deburr;

});
parcelRegister("8gR05", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6058ee1fd44b77dc$export$2e2bcd8739ae039; });

var $1dFqQ = parcelRequire("1dFqQ");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $6058ee1fd44b77dc$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $6058ee1fd44b77dc$var$deburrLetter = (0, $1dFqQ.default)($6058ee1fd44b77dc$var$deburredLetters);
var $6058ee1fd44b77dc$export$2e2bcd8739ae039 = $6058ee1fd44b77dc$var$deburrLetter;

});
parcelRegister("1dFqQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e3724d95591bec8$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $0e3724d95591bec8$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
var $0e3724d95591bec8$export$2e2bcd8739ae039 = $0e3724d95591bec8$var$basePropertyOf;

});



parcelRegister("9slHK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e2790b002805beb$export$2e2bcd8739ae039; });

var $aWqw0 = parcelRequire("aWqw0");

var $8Np9J = parcelRequire("8Np9J");

var $cQbRr = parcelRequire("cQbRr");

var $inmCG = parcelRequire("inmCG");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $6e2790b002805beb$var$words(string, pattern, guard) {
    string = (0, $cQbRr.default)(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return (0, $8Np9J.default)(string) ? (0, $inmCG.default)(string) : (0, $aWqw0.default)(string);
    return string.match(pattern) || [];
}
var $6e2790b002805beb$export$2e2bcd8739ae039 = $6e2790b002805beb$var$words;

});
parcelRegister("aWqw0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f73e38be3342c0d$export$2e2bcd8739ae039; });
/** Used to match words composed of alphanumeric characters. */ var $7f73e38be3342c0d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7f73e38be3342c0d$var$asciiWords(string) {
    return string.match($7f73e38be3342c0d$var$reAsciiWord) || [];
}
var $7f73e38be3342c0d$export$2e2bcd8739ae039 = $7f73e38be3342c0d$var$asciiWords;

});

parcelRegister("8Np9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $667669c467156d5e$export$2e2bcd8739ae039; });
/** Used to detect strings that need a more robust regexp to match words. */ var $667669c467156d5e$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $667669c467156d5e$var$hasUnicodeWord(string) {
    return $667669c467156d5e$var$reHasUnicodeWord.test(string);
}
var $667669c467156d5e$export$2e2bcd8739ae039 = $667669c467156d5e$var$hasUnicodeWord;

});

parcelRegister("inmCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60bec66f7893e1d$export$2e2bcd8739ae039; });
/** Used to compose unicode character classes. */ var $d60bec66f7893e1d$var$rsAstralRange = '\\ud800-\\udfff', $d60bec66f7893e1d$var$rsComboMarksRange = '\\u0300-\\u036f', $d60bec66f7893e1d$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $d60bec66f7893e1d$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $d60bec66f7893e1d$var$rsComboRange = $d60bec66f7893e1d$var$rsComboMarksRange + $d60bec66f7893e1d$var$reComboHalfMarksRange + $d60bec66f7893e1d$var$rsComboSymbolsRange, $d60bec66f7893e1d$var$rsDingbatRange = '\\u2700-\\u27bf', $d60bec66f7893e1d$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $d60bec66f7893e1d$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $d60bec66f7893e1d$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $d60bec66f7893e1d$var$rsPunctuationRange = '\\u2000-\\u206f', $d60bec66f7893e1d$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $d60bec66f7893e1d$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $d60bec66f7893e1d$var$rsVarRange = '\\ufe0e\\ufe0f', $d60bec66f7893e1d$var$rsBreakRange = $d60bec66f7893e1d$var$rsMathOpRange + $d60bec66f7893e1d$var$rsNonCharRange + $d60bec66f7893e1d$var$rsPunctuationRange + $d60bec66f7893e1d$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $d60bec66f7893e1d$var$rsApos = "['\u2019]", $d60bec66f7893e1d$var$rsBreak = '[' + $d60bec66f7893e1d$var$rsBreakRange + ']', $d60bec66f7893e1d$var$rsCombo = '[' + $d60bec66f7893e1d$var$rsComboRange + ']', $d60bec66f7893e1d$var$rsDigits = '\\d+', $d60bec66f7893e1d$var$rsDingbat = '[' + $d60bec66f7893e1d$var$rsDingbatRange + ']', $d60bec66f7893e1d$var$rsLower = '[' + $d60bec66f7893e1d$var$rsLowerRange + ']', $d60bec66f7893e1d$var$rsMisc = '[^' + $d60bec66f7893e1d$var$rsAstralRange + $d60bec66f7893e1d$var$rsBreakRange + $d60bec66f7893e1d$var$rsDigits + $d60bec66f7893e1d$var$rsDingbatRange + $d60bec66f7893e1d$var$rsLowerRange + $d60bec66f7893e1d$var$rsUpperRange + ']', $d60bec66f7893e1d$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $d60bec66f7893e1d$var$rsModifier = '(?:' + $d60bec66f7893e1d$var$rsCombo + '|' + $d60bec66f7893e1d$var$rsFitz + ')', $d60bec66f7893e1d$var$rsNonAstral = '[^' + $d60bec66f7893e1d$var$rsAstralRange + ']', $d60bec66f7893e1d$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $d60bec66f7893e1d$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $d60bec66f7893e1d$var$rsUpper = '[' + $d60bec66f7893e1d$var$rsUpperRange + ']', $d60bec66f7893e1d$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $d60bec66f7893e1d$var$rsMiscLower = '(?:' + $d60bec66f7893e1d$var$rsLower + '|' + $d60bec66f7893e1d$var$rsMisc + ')', $d60bec66f7893e1d$var$rsMiscUpper = '(?:' + $d60bec66f7893e1d$var$rsUpper + '|' + $d60bec66f7893e1d$var$rsMisc + ')', $d60bec66f7893e1d$var$rsOptContrLower = '(?:' + $d60bec66f7893e1d$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $d60bec66f7893e1d$var$rsOptContrUpper = '(?:' + $d60bec66f7893e1d$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $d60bec66f7893e1d$var$reOptMod = $d60bec66f7893e1d$var$rsModifier + '?', $d60bec66f7893e1d$var$rsOptVar = '[' + $d60bec66f7893e1d$var$rsVarRange + ']?', $d60bec66f7893e1d$var$rsOptJoin = '(?:' + $d60bec66f7893e1d$var$rsZWJ + '(?:' + [
    $d60bec66f7893e1d$var$rsNonAstral,
    $d60bec66f7893e1d$var$rsRegional,
    $d60bec66f7893e1d$var$rsSurrPair
].join('|') + ')' + $d60bec66f7893e1d$var$rsOptVar + $d60bec66f7893e1d$var$reOptMod + ')*', $d60bec66f7893e1d$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $d60bec66f7893e1d$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $d60bec66f7893e1d$var$rsSeq = $d60bec66f7893e1d$var$rsOptVar + $d60bec66f7893e1d$var$reOptMod + $d60bec66f7893e1d$var$rsOptJoin, $d60bec66f7893e1d$var$rsEmoji = '(?:' + [
    $d60bec66f7893e1d$var$rsDingbat,
    $d60bec66f7893e1d$var$rsRegional,
    $d60bec66f7893e1d$var$rsSurrPair
].join('|') + ')' + $d60bec66f7893e1d$var$rsSeq;
/** Used to match complex or compound words. */ var $d60bec66f7893e1d$var$reUnicodeWord = RegExp([
    $d60bec66f7893e1d$var$rsUpper + '?' + $d60bec66f7893e1d$var$rsLower + '+' + $d60bec66f7893e1d$var$rsOptContrLower + '(?=' + [
        $d60bec66f7893e1d$var$rsBreak,
        $d60bec66f7893e1d$var$rsUpper,
        '$'
    ].join('|') + ')',
    $d60bec66f7893e1d$var$rsMiscUpper + '+' + $d60bec66f7893e1d$var$rsOptContrUpper + '(?=' + [
        $d60bec66f7893e1d$var$rsBreak,
        $d60bec66f7893e1d$var$rsUpper + $d60bec66f7893e1d$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $d60bec66f7893e1d$var$rsUpper + '?' + $d60bec66f7893e1d$var$rsMiscLower + '+' + $d60bec66f7893e1d$var$rsOptContrLower,
    $d60bec66f7893e1d$var$rsUpper + '+' + $d60bec66f7893e1d$var$rsOptContrUpper,
    $d60bec66f7893e1d$var$rsOrdUpper,
    $d60bec66f7893e1d$var$rsOrdLower,
    $d60bec66f7893e1d$var$rsDigits,
    $d60bec66f7893e1d$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $d60bec66f7893e1d$var$unicodeWords(string) {
    return string.match($d60bec66f7893e1d$var$reUnicodeWord) || [];
}
var $d60bec66f7893e1d$export$2e2bcd8739ae039 = $d60bec66f7893e1d$var$unicodeWords;

});





parcelRegister("27iE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d51a3c2e0000772$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $b3yR7 = parcelRequire("b3yR7");

var $cGjF4 = parcelRequire("cGjF4");

var $izjX7 = parcelRequire("izjX7");

var $f3hTG = parcelRequire("f3hTG");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $a2SqC = parcelRequire("a2SqC");
const $2d51a3c2e0000772$var$AddToCartButton = ({ product: product, qty: qty, callbacks: callbacks, listInformation: listInformation, position: position, imageRefFn: imageRefFn, className: className, size: size = "iconOnly" })=>{
    const addToCart = ()=>{
        if ((0, $bcbvQ.default).isLoggedIn()) {
            const imageRef = imageRefFn();
            if ((0, $76PCP.default).addToCart(product.sku, qty)) {
                // If the add to cart action is successful
                (0, $6fuyt.sendAddToCart)([
                    {
                        sku: product.sku,
                        qty: qty,
                        position: position
                    }
                ], listInformation);
                if (!(0, $bEEBX.default)(imageRef)) (0, $a2SqC.default).addFlyingProduct(product.sku, imageRef);
                // Allow other consumers to insert their own callback
                if (!(0, $bEEBX.default)(callbacks) && (0, $f3hTG.default)(callbacks.addToCart)) callbacks.addToCart(product, listInformation.name, position);
            } else (0, $gtsdT.logger).warn("cart", "An unexpected error occured");
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
        size: size,
        className: (0, $izjX7.cn)("print:hidden", className),
        "aria-label": "Add to cart",
        onClick: addToCart,
        "data-testid": "add-to-cart-button",
        icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3yR7.default), {})
    });
};
var $2d51a3c2e0000772$export$2e2bcd8739ae039 = (0, $gBcml.observer)($2d51a3c2e0000772$var$AddToCartButton);

});
parcelRegister("b3yR7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80cb0324f08e2b57$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $80cb0324f08e2b57$var$SvgShoppingCart = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M7.386 19.25q-.64 0-1.091-.456T5.844 17.7t.455-1.092q.457-.45 1.096-.45.64 0 1.091.455.451.456.451 1.096t-.455 1.09q-.457.453-1.096.452m9.281 0q-.64 0-1.09-.456-.453-.456-.452-1.095 0-.64.456-1.092.456-.45 1.095-.45.64 0 1.092.455.45.456.45 1.096t-.455 1.09q-.456.453-1.096.452M7.154 6.36l1.784 4.124h6.466l1.762-4.125zm-.666-1.548H19.53l-3.115 7.22H8.53l-.902 1.546h10.592v1.547H4.963l2.45-4.254-2.815-6.574H2.75V2.75h2.857z"
        })
    }));
var $80cb0324f08e2b57$export$2e2bcd8739ae039 = $80cb0324f08e2b57$var$SvgShoppingCart;

});


parcelRegister("h5LDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ba532bec3872e82$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $c6AbN = parcelRequire("c6AbN");
var $5QeLx = parcelRequire("5QeLx");
var $5tfik = parcelRequire("5tfik");
var $c39Gl = parcelRequire("c39Gl");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $5qbUf = parcelRequire("5qbUf");
const $1ba532bec3872e82$var$badgeIconMap = {
    nokkelhullet: (0, $c6AbN.default),
    nyt_norge: (0, $5QeLx.default),
    pant_2kr: (0, $5tfik.default),
    pant_3kr: (0, $c39Gl.default)
};
const $1ba532bec3872e82$var$Badges = ({ badges: badges, page: page })=>{
    if ((0, $bEEBX.default)(badges) || badges.length === 0) return null;
    const iconClass = page === (0, $5qbUf.PageType).ProductDetailsPage ? "w-10 h-10" : "w-8 h-8";
    const outerClass = page === (0, $5qbUf.PageType).ProductDetailsPage ? "right-[-7px] top-7 w-10" : "-right-[3px] top-7 w-8";
    const visibleBadges = badges.slice(0, 3); // Show max 3 badges
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: outerClass,
        children: visibleBadges.map((b)=>{
            const IconComponent = $1ba532bec3872e82$var$badgeIconMap[b.key];
            return IconComponent ? /*#__PURE__*/ (0, $7YWoO.jsx)(IconComponent, {
                className: iconClass
            }, b.key) : null;
        })
    });
};
var $1ba532bec3872e82$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1ba532bec3872e82$var$Badges);

});
parcelRegister("c6AbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d021e06c1a07bd1$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $8d021e06c1a07bd1$var$SvgNokkelhull = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "url(#nokkelhull_svg__a)",
                d: "M3 3h18v18H3z"
            }),
            (0, $7YWoO.jsxs)("defs", {
                children: [
                    (0, $7YWoO.jsx)("pattern", {
                        id: "nokkelhull_svg__a",
                        width: 1,
                        height: 1,
                        patternContentUnits: "objectBoundingBox",
                        children: (0, $7YWoO.jsx)("use", {
                            xlinkHref: "#nokkelhull_svg__b",
                            transform: "scale(.00196)"
                        })
                    }),
                    (0, $7YWoO.jsx)("image", {
                        xlinkHref: "data:image/png;base64,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",
                        id: "nokkelhull_svg__b",
                        width: 511,
                        height: 511,
                        preserveAspectRatio: "none"
                    })
                ]
            })
        ]
    }));
var $8d021e06c1a07bd1$export$2e2bcd8739ae039 = $8d021e06c1a07bd1$var$SvgNokkelhull;

});

parcelRegister("5QeLx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440d4339b5005466$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $440d4339b5005466$var$SvgNytNorge = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M7.34 3a3.413 3.413 0 0 0-3.403 3.403V21H16.67a3.41 3.41 0 0 0 3.393-3.403V3z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#79B61D",
                d: "M7.34 4.092a2.315 2.315 0 0 0-2.315 2.315v7.459h11.768a2.217 2.217 0 0 0 2.175-2.213V4.092z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#E31919",
                d: "M16.67 19.908a2.315 2.315 0 0 0 2.315-2.315V14.93h-7.462v4.977z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M7.969 10.343h.405v2.049a.4.4 0 0 1-.436.42.51.51 0 0 1-.507-.31l-.6-1.254q.02.095.025.193v1.35h-.398v-2.448h.386l1.001 2.074c.043.094.132.083.132 0zM9.532 10.692c-.166 0-.25.085-.25.276v1.2c0 .193.084.276.25.276h.488c.165 0 .248-.085.248-.276v-1.2c0-.193-.083-.276-.248-.276zm1.142.233v1.266a.56.56 0 0 1-.625.6H9.5a.557.557 0 0 1-.618-.6v-1.266a.56.56 0 0 1 .618-.578h.551a.56.56 0 0 1 .626.578M12.389 11.396a.31.31 0 0 0 .173-.249v-.18c0-.192-.085-.275-.25-.275h-.722v1.23zm-1.202-1.053h1.157a.56.56 0 0 1 .626.579v.262a.55.55 0 0 1-.276.438l-.386.25.696.919h-.463l-.548-.708-.407.268v.44h-.4zM15.219 11.352v.839a.56.56 0 0 1-.623.6h-.552a.56.56 0 0 1-.62-.6v-1.266a.56.56 0 0 1 .62-.578h.965v.349h-.932c-.164 0-.249.085-.249.276v1.2c0 .193.085.276.249.276h.488c.166 0 .25-.085.25-.276v-.405h-.578v-.415zM9.124 5.24v3.245c0 .089-.088.102-.13 0L7.45 5.232h-.984V9.56h.91V6.988l.965 2.087a.83.83 0 0 0 .727.515h.124q.111 0 .22-.025a.86.86 0 0 0 .376-.181.82.82 0 0 0 .272-.648V5.24zM17.117 12.453h-.76c-.164 0-.25-.085-.25-.275v-.406h1.01v-.42h-1.01v-.386c0-.193.086-.276.25-.276h.76v-.347h-.793a.56.56 0 0 0-.62.579v1.265a.56.56 0 0 0 .62.6h.793zM15.076 5.253v.917h1.079v3.405h.933V6.17h1.071v-.917zM11.71 5.26l.852 1.604.928-1.605h1.11l-1.517 2.628v1.672h-.972V7.887l-1.513-2.628z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#E31919",
                d: "M7.93 14.93H5.03v4.978H7.93z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#004495",
                d: "M10.46 14.93H8.99v4.978h1.47z"
            })
        ]
    }));
var $440d4339b5005466$export$2e2bcd8739ae039 = $440d4339b5005466$var$SvgNytNorge;

});

parcelRegister("5tfik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fbb8666fcedea9a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $3fbb8666fcedea9a$var$SvgPant2Kr = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M19.415 3H5v19h14.415z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M5.613 3.613h1.39V3H5v19h10.186v-.613H5.613zM9.229 3v.613h9.573v17.774h-1.39V22h2.003V3z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M8.394 18.064c-.065.07-.158.115-.346.115h-.497v-.713h.497c.188 0 .281.046.346.114a.36.36 0 0 1 .094.245.34.34 0 0 1-.094.24m-.321-1.086h-1.07v2.85h.548v-1.16h.522c.366 0 .586-.09.74-.253a.86.86 0 0 0 .225-.59.86.86 0 0 0-.224-.59c-.16-.168-.375-.257-.741-.257M10.412 17.866l.362.842h-.724zm-.57 1.331h1.144l.269.631h.574l-1.221-2.85h-.387l-1.222 2.85h.574zM12.584 16.978h-.386v2.85h.55v-1.857l1.588 1.857h.386v-2.85h-.55v1.856zM17.413 16.978h-2.057v.488h.754v2.362h.55v-2.362h.753zM17.413 14.872H7.003v.283h10.41zM9.886 7.3a2.435 2.435 0 0 1 2.338-1.713c1.27 0 2.37.952 2.37 2.285 0 .898-.456 1.554-.953 2.125l-1.576 1.83h2.58v1.27H9.835v-.847l2.601-2.95c.571-.646.73-1.069.73-1.45 0-.518-.402-.994-.963-.994-.497 0-.857.339-1.005.836z"
            })
        ]
    }));
var $3fbb8666fcedea9a$export$2e2bcd8739ae039 = $3fbb8666fcedea9a$var$SvgPant2Kr;

});

parcelRegister("c39Gl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c5d467bd95b2ac6$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $8c5d467bd95b2ac6$var$SvgPant3Kr = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M19.415 3H5v19h14.415z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M5.613 3.613h1.39V3H5v19h10.186v-.613H5.613zM9.228 3v.613h9.574v17.774h-1.39V22h2.003V3z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M8.394 18.064c-.065.07-.159.115-.346.115h-.497v-.713h.497c.187 0 .28.046.346.114a.35.35 0 0 1 .094.245.34.34 0 0 1-.094.24m-.321-1.086h-1.07v2.85h.548v-1.16h.522c.366 0 .586-.09.74-.253a.86.86 0 0 0 .225-.59.86.86 0 0 0-.224-.59c-.16-.168-.375-.257-.741-.257M10.412 17.866l.362.842h-.724zm-.57 1.33h1.144l.269.632h.574l-1.221-2.85h-.387l-1.222 2.85h.574zM12.585 16.978h-.387v2.85h.55v-1.857l1.587 1.857h.387v-2.85h-.55v1.856zM17.413 16.978h-2.056v.488h.753v2.362h.55v-2.362h.753zM17.413 14.872H7.003v.283h10.41zM10.628 11.226c.307.433.815.74 1.375.74.698 0 1.386-.55 1.386-1.343 0-.772-.635-1.354-1.46-1.354-.296 0-.613.073-.888.211v-.846l1.385-1.639H9.951v-1.27h4.495v.847l-1.343 1.65c1.015.39 1.713 1.28 1.713 2.4 0 1.566-1.227 2.613-2.76 2.613-.92 0-1.798-.413-2.454-1.153z"
            })
        ]
    }));
var $8c5d467bd95b2ac6$export$2e2bcd8739ae039 = $8c5d467bd95b2ac6$var$SvgPant3Kr;

});


parcelRegister("lAgRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59bb0e379edfa4e5$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $hGi4c = parcelRequire("hGi4c");

var $5OqMf = parcelRequire("5OqMf");
const $59bb0e379edfa4e5$var$DisplayPrice = ({ price: price, newPrice: newPrice, className: className, postPriceDetail: postPriceDetail })=>{
    // Sometimes the discounted price decimals have different rounding than the full price, so we check if the difference is small
    const isDiscounted = price - newPrice >= 1;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: className,
        children: [
            isDiscounted && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "text-sm text-muted line-through",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("strong", {
                    children: (0, $5OqMf.formatPrice)(price)
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: `font-bold leading-4 ${isDiscounted ? "text-promotion" : ""}`,
                children: [
                    (0, $5OqMf.formatPrice)(newPrice),
                    postPriceDetail && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
                        bgColor: "#fafafa",
                        className: "text-ink-brand-default relative top-[-2px] ml-2 inline-block text-xs font-normal",
                        children: postPriceDetail
                    })
                ]
            })
        ]
    });
};
var $59bb0e379edfa4e5$export$2e2bcd8739ae039 = $59bb0e379edfa4e5$var$DisplayPrice;

});
parcelRegister("hGi4c", function(module, exports) {

$parcel$export(module.exports, "Tag", function () { return $cdf45f97088c97b0$export$3288d34c523a1192; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");
function $cdf45f97088c97b0$export$3288d34c523a1192({ children: n, size: o = "regular", outlined: t = !1, bgColor: a, lip: l = "none", variant: e, textColor: s, borderColor: i, className: d, icon: r, ...g }) {
    const p = {
        upperLeft: "rounded-tl-none",
        upperRight: "rounded-tr-none",
        lowerLeft: "rounded-bl-none",
        lowerRight: "rounded-br-none",
        none: ""
    }[l], c = {
        regular: "text-sm px-2 py-1",
        small: "text-xs px-1 py-0.5",
        large: "text-lg px-3 py-2"
    }[o], m = {
        success: "bg-success-100",
        warning: "bg-warning-100",
        error: "bg-error-100",
        information: "bg-information-100",
        base: "bg-base-50"
    }[e || "information"];
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("w-fit items-center flex gap-1 rounded-lg select-none whitespace-pre font-medium text-ink-brand-default", p, c, t ? "border" : "border border-base-transparent", m, d, {
            ...g
        }),
        style: {
            backgroundColor: a,
            borderColor: i,
            color: s
        },
        children: [
            r && (0, $dvPqk.isValidElement)(r) ? (0, $dvPqk.cloneElement)(r, {
                style: {
                    fill: e === "base" ? "var(--color-ink-brand-default)" : `var(--color-${e}-600)`,
                    width: "var(--spacing-4)",
                    height: "var(--spacing-4)"
                }
            }) : null,
            n
        ]
    });
}
$cdf45f97088c97b0$export$3288d34c523a1192.displayName = "Tag";

});


parcelRegister("bO7t0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $947ddd4ec7a78ab1$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $gri2z = parcelRequire("gri2z");
var $kbwK7 = parcelRequire("kbwK7");

var $9AGLN = parcelRequire("9AGLN");

var $gwaiZ = parcelRequire("gwaiZ");

var $jQCqo = parcelRequire("jQCqo");

var $gIlix = parcelRequire("gIlix");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $6fuyt = parcelRequire("6fuyt");

var $bcbvQ = parcelRequire("bcbvQ");

var $hOaHV = parcelRequire("hOaHV");

var $bZiDo = parcelRequire("bZiDo");

var $cLLe3 = parcelRequire("cLLe3");

var $6e7IR = parcelRequire("6e7IR");
const $947ddd4ec7a78ab1$var$FavoriteHeartIcon = /*#__PURE__*/ (0, $dvPqk.forwardRef)(({ isFavorite: isFavorite, onClick: onClick, disabled: disabled = false }, ref)=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            !disabled && /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
                type: "button",
                onClick: onClick,
                "data-testid": "favorite-icon-button",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    ref: ref,
                    children: isFavorite ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kbwK7.default), {
                        className: "fill-favorite"
                    }) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gri2z.default), {
                        className: "hover:fill-favorite"
                    })
                })
            }),
            disabled && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "cursor-not-allowed",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gri2z.default), {
                    className: "fill-base-300"
                })
            })
        ]
    }));
const $947ddd4ec7a78ab1$var$Favorite = ({ sku: sku, listInformation: listInformation, position: position })=>{
    const [show, setShow] = (0, $dvPqk.useState)(false);
    const isFavorite = (0, $hOaHV.default).isFavorite(sku);
    const isLoggedIn = (0, $bcbvQ.default).isLoggedIn();
    const hasMultipleLists = (0, $gwaiZ.default)((0, $hOaHV.default).allFavoriteLists) > 1;
    const parentRef = (0, $dvPqk.useRef)(null);
    const handleClick = ()=>{
        if (isLoggedIn) isFavorite ? (0, $hOaHV.default).removeFavorite(sku) : addFavorite(sku);
    };
    if (!isLoggedIn) return /*#__PURE__*/ (0, $7YWoO.jsx)($947ddd4ec7a78ab1$var$FavoriteHeartIcon, {
        disabled: true,
        isFavorite: isFavorite
    });
    const addFavorite = (sku, listId)=>{
        const product = (0, $bZiDo.default).resolveSku(sku);
        if (product) {
            (0, $hOaHV.default).addFavorite(sku, listId);
            (0, $6fuyt.sendAddItemsToFavoriteList)([
                product
            ], listInformation, position);
        }
    };
    if (hasMultipleLists) {
        const lists = (0, $jQCqo.default)((0, $gIlix.default)((0, $hOaHV.default).allFavoriteLists), "name");
        const favoriteListPicker = /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                    className: "px-4 py-2 bg-base-100",
                    children: "Velg liste"
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "p-4",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                            className: "list-none ps-0",
                            children: lists.map((list)=>{
                                const checked = typeof list.items[sku] === "number" && list.items[sku] > 0;
                                return /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9AGLN.Checkbox), {
                                        className: "mb-2 min-h-6 text-start",
                                        label: list.listName,
                                        isChecked: checked,
                                        onChange: ()=>checked ? (0, $hOaHV.default).removeFavorite(sku, list.id) : addFavorite(sku, list.id)
                                    })
                                }, list.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "flex justify-center mt-2",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                "data-testid": "add-to-favorite-list-popover-button",
                                onClick: ()=>setShow(false),
                                children: "OK"
                            })
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6e7IR.Popover), {
            open: show,
            onOpenChange: setShow,
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6e7IR.PopoverTrigger), {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "flex justify-center mb-1",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)($947ddd4ec7a78ab1$var$FavoriteHeartIcon, {
                            onClick: ()=>setShow(!show),
                            isFavorite: isFavorite,
                            ref: parentRef
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6e7IR.PopoverContent), {
                    children: favoriteListPicker
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)($947ddd4ec7a78ab1$var$FavoriteHeartIcon, {
        isFavorite: isFavorite,
        onClick: handleClick
    });
};
var $947ddd4ec7a78ab1$export$2e2bcd8739ae039 = (0, $gBcml.observer)($947ddd4ec7a78ab1$var$Favorite);

});
parcelRegister("gri2z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf7d2968afddef1a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $bf7d2968afddef1a$var$SvgHeart = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m11.931 21-1.293-1.164a129 129 0 0 1-4.267-3.944Q4.689 14.25 3.72 12.97q-.97-1.281-1.345-2.34A6.5 6.5 0 0 1 2 8.456q0-2.302 1.578-3.88Q5.155 3 7.457 3q1.268 0 2.457.543 1.19.543 2.017 1.526a5.7 5.7 0 0 1 2.017-1.526A5.86 5.86 0 0 1 16.405 3q2.302 0 3.88 1.578 1.577 1.577 1.577 3.879a6.5 6.5 0 0 1-.362 2.146q-.361 1.035-1.332 2.302-.969 1.267-2.664 2.936a139 139 0 0 1-4.332 4.047zm0-2.509a126 126 0 0 0 3.957-3.66q1.551-1.512 2.47-2.637.918-1.125 1.28-2.004A4.5 4.5 0 0 0 20 8.457q0-1.525-1.035-2.56t-2.56-1.035q-.905 0-1.694.375-.788.376-1.358 1.047l-.905 1.06h-1.034l-.905-1.06a3.96 3.96 0 0 0-1.384-1.047 3.95 3.95 0 0 0-1.668-.375q-1.525 0-2.56 1.035t-1.035 2.56q0 .854.336 1.694t1.229 1.952 2.457 2.638a135 135 0 0 0 4.047 3.75"
        })
    }));
var $bf7d2968afddef1a$export$2e2bcd8739ae039 = $bf7d2968afddef1a$var$SvgHeart;

});

parcelRegister("kbwK7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb1e3bc2bcea5a01$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $eb1e3bc2bcea5a01$var$SvgHeartFilled = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m11.931 21-1.293-1.164a129 129 0 0 1-4.267-3.944Q4.689 14.25 3.72 12.97q-.97-1.281-1.345-2.34A6.5 6.5 0 0 1 2 8.456q0-2.302 1.578-3.88Q5.155 3 7.457 3q1.268 0 2.457.543 1.19.543 2.017 1.526a5.7 5.7 0 0 1 2.017-1.526A5.86 5.86 0 0 1 16.405 3q2.302 0 3.88 1.578 1.577 1.577 1.577 3.879a6.5 6.5 0 0 1-.362 2.146q-.361 1.035-1.332 2.302-.969 1.267-2.664 2.936a139 139 0 0 1-4.332 4.047z"
        })
    }));
var $eb1e3bc2bcea5a01$export$2e2bcd8739ae039 = $eb1e3bc2bcea5a01$var$SvgHeartFilled;

});

parcelRegister("9AGLN", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $6fb8a7162d519983$export$48513f6b9f8ce62d; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $eVBn0 = parcelRequire("eVBn0");

var $cs25D = parcelRequire("cs25D");
function $6fb8a7162d519983$export$48513f6b9f8ce62d({ isChecked: n, description: a, label: i = "", errorMessage: s = "", showErrorMessage: c = !1, isDisabled: e = !1, variant: l = "default", onChange: u = ()=>null, centerAlign: f = !1, className: b }) {
    const d = (0, $dvPqk.useId)(), h = {
        default: "border-base-400 bg-base-0 group-hover:border-surface-action group-hover:bg-surface-default-hover group-hover:checked:bg-surface-action checked:border-surface-action checked:bg-surface-action",
        inverted: "border-surface-default group-hover:border-surface-default checked:bg-base-0 checked:border-surface-default group-hover:bg-surface-default"
    }[l], k = {
        default: "text-ink-default",
        inverted: "text-ink-brand-inverted"
    }[l], p = {
        default: "peer-checked:fill-ink-brand-inverted",
        inverted: "peer-checked:fill-ink-brand-default"
    }[l];
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: (0, $6sMuH.cn)("text-ink-default flex items-start gap-2 text-base rounded ring-information-600 group [&:has(:focus-visible)]:ring", e && "!text-ink-disabled", f && "items-center", b),
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                        className: (0, $6sMuH.cn)("relative w-6 h-6 flex shrink-0 justify-center items-center rounded", e && "cursor-not-allowed"),
                        children: [
                            /* @__PURE__ */ (0, $7YWoO.jsx)("input", {
                                checked: n,
                                className: (0, $6sMuH.cn)("w-full h-full absolute m-0 transition-colors peer rounded appearance-none cursor-pointer", // border
                                "border-2", // focus
                                "focus:outline-none", // Checked
                                h, // Disabled
                                e && "!cursor-not-allowed bg-base-50 border-ink-disabled group-hover:!border-base-400 group-hover:bg-base-50 checked:bg-base-50 checked:border-base-200", // Invalid state
                                c && "!border-ink-error group-hover:!border-ink-error !bg-surface-error"),
                                disabled: e,
                                id: d,
                                onChange: u,
                                type: "checkbox"
                            }),
                            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cs25D.default), {
                                className: (0, $6sMuH.cn)("pointer-events-none absolute peer-checked:block fill-ink-brand-default hidden", p, e && "fill-ink-disabled", c && "!fill-ink-error"),
                                height: 16,
                                width: 16
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                        className: (0, $6sMuH.cn)("flex flex-col gap-1 ", k, e && "text-ink-disabled"),
                        children: [
                            /* @__PURE__ */ (0, $7YWoO.jsx)("label", {
                                className: (0, $6sMuH.cn)("w-fit", e ? "cursor-not-allowed" : "cursor-pointer"),
                                htmlFor: d,
                                children: i
                            }),
                            a ? /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                className: "text-sm mb-0",
                                children: a
                            }) : null
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $eVBn0.FormError), {
                errorMessage: s,
                showErrorMessage: c
            })
        ]
    });
}
$6fb8a7162d519983$export$48513f6b9f8ce62d.displayName = "Checkbox";

});
parcelRegister("cs25D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9109b8967234318c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $9109b8967234318c$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M8.933 20 2 13.026l2.051-2.052 4.882 4.841L20.79 4l2.051 2.092z"
        })
    }));

});


parcelRegister("hOaHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d03a4333b75480$export$2e2bcd8739ae039; });

var $jf2w9 = parcelRequire("jf2w9");

var $2Vh19 = parcelRequire("2Vh19");

var $ioVMT = parcelRequire("ioVMT");

var $k2XjZ = parcelRequire("k2XjZ");

var $bEEBX = parcelRequire("bEEBX");

var $3xOZa = parcelRequire("3xOZa");

var $loTcB = parcelRequire("loTcB");

var $egoNX = parcelRequire("egoNX");

var $kalVm = parcelRequire("kalVm");

var $eoV8o = parcelRequire("eoV8o");

var $hQjjC = parcelRequire("hQjjC");

var $gIlix = parcelRequire("gIlix");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $bZiDo = parcelRequire("bZiDo");

var $gvoND = parcelRequire("gvoND");
const $27d03a4333b75480$var$isAbleToAddFavorite = (list)=>{
    if (!(0, $bcbvQ.default).isLoggedIn()) {
        (0, $gtsdT.logger).warn("favorites", "Attempting to add favorite without being logged in");
        return false;
    }
    if (!list) {
        (0, $gtsdT.logger).warn("favorites", "Unable to find list to add favorite to");
        return false;
    }
    return true;
};
const $27d03a4333b75480$var$isFavoriteInList = (sku, listId)=>{
    const list = $27d03a4333b75480$var$favoriteStore.getFavoriteListById(listId);
    return !!list && (0, $ioVMT.default)(list.sequence, sku);
};
const $27d03a4333b75480$var$getUrl = (customerNumber)=>{
    return `${0, $8ZCSm.API_HOST}/api/auth/${(0, $isIf6.default).storeId}/favorites/${customerNumber}`;
};
const $27d03a4333b75480$var$favoriteStore = (0, $Kk7R3.makeAutoObservable)({
    allFavoriteLists: {},
    allSkus: [],
    checkedListItems: {},
    currentFavoriteList: {},
    isFavorite: (sku)=>{
        return (0, $ioVMT.default)($27d03a4333b75480$var$favoriteStore.allSkus, sku);
    },
    addFavorite: (0, $Kk7R3.action)((sku, listId, qty = 1)=>{
        const favoriteLists = (0, $gIlix.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists);
        const list = (0, $bEEBX.default)(listId) ? (0, $gIlix.default)(favoriteLists)[0] : $27d03a4333b75480$var$favoriteStore.getFavoriteListById(listId);
        if ($27d03a4333b75480$var$isAbleToAddFavorite(list) && !!list) {
            list.items[sku] = qty;
            list.sequence.push(sku);
            $27d03a4333b75480$var$favoriteStore.saveFavorites(list.id);
        } else if (!listId && !favoriteLists.length) $27d03a4333b75480$var$favoriteStore.createNewListInStorage("Mine favoritter").then((list)=>{
            list.items[sku] = qty;
            list.sequence.push(sku);
            $27d03a4333b75480$var$favoriteStore.saveFavorites(list.id);
        });
    }),
    addMultipleFavorites: (0, $Kk7R3.action)((skus, listId, items)=>{
        const list = (0, $bEEBX.default)(listId) ? (0, $gIlix.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists)[0] : $27d03a4333b75480$var$favoriteStore.getFavoriteListById(listId);
        if ($27d03a4333b75480$var$isAbleToAddFavorite(list) && !!list) {
            for (const sku of skus)if (!$27d03a4333b75480$var$isFavoriteInList(sku, listId)) {
                const newItem = {
                    [sku]: items[sku]
                };
                list.items = {
                    ...list.items,
                    ...newItem
                };
                list.sequence.push(sku);
            } else list.items[sku] = list.items[sku] + items[sku];
            $27d03a4333b75480$var$favoriteStore.saveFavorites(list.id);
        }
    }),
    removeFavorite: (0, $Kk7R3.action)((sku, listId)=>{
        if (!(0, $bcbvQ.default).isLoggedIn()) {
            (0, $gtsdT.logger).warn("favorites", "Attempting to remove favorite without being logged in");
            return;
        }
        if (!(0, $bEEBX.default)(listId)) {
            // If listId is specified, remove SKU from specific list only
            const list = $27d03a4333b75480$var$favoriteStore.getFavoriteListById(listId);
            if (!list) {
                (0, $gtsdT.logger).warn("favorites", "Unable to find list to remove favorite from");
                return;
            }
            (0, $hQjjC.default)(list.items, sku);
            (0, $kalVm.default)(list.sequence, sku);
            $27d03a4333b75480$var$favoriteStore.saveFavorites(list.id, true);
            (0, $6fuyt.sendRemoveItemFromFavoriteList)(sku, list.listName, list.sequence.indexOf(sku) + 1);
        } else {
            // If no listId is specified, remove it from all lists
            for (const list of (0, $gIlix.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists))if ((0, $2Vh19.default)(list.items, sku)) {
                (0, $hQjjC.default)(list.items, sku);
                (0, $kalVm.default)(list.sequence, sku);
                $27d03a4333b75480$var$favoriteStore.saveFavorites(list.id, false);
                (0, $6fuyt.sendRemoveItemFromFavoriteList)(sku, list.listName, list.sequence.indexOf(sku) + 1);
            }
            // Manual sync since we might have changed several lists
            $27d03a4333b75480$var$favoriteStore.syncAllSkus();
        }
    }),
    syncAllSkus: (0, $Kk7R3.action)(()=>{
        const allSkus = (0, $gIlix.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists).flatMap((fl)=>(0, $egoNX.default)(fl.items));
        $27d03a4333b75480$var$favoriteStore.allSkus = (0, $eoV8o.default)(allSkus);
    }),
    getFavoriteListById: (id)=>(0, $jf2w9.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists, {
            id: id
        }),
    getFavoriteListByName: (name)=>{
        const favoriteList = (0, $gIlix.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists);
        return favoriteList.find((favorite)=>favorite.listName === name);
    },
    createNewListInStorage: (listName)=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if ((0, $bEEBX.default)(customerNumber)) {
            (0, $gtsdT.logger).warn("favorites", "Attempting to create list before customer number is available", (0, $bcbvQ.default).user);
            return Promise.reject("Not logged in, unable to create new list");
        }
        return (0, $3Y1Wx.apiClient)($27d03a4333b75480$var$getUrl(customerNumber), (0, $bcbvQ.default).getSessionToken()).query({
            listName: listName
        }).post().json((0, $Kk7R3.action)((list)=>{
            $27d03a4333b75480$var$favoriteStore.allFavoriteLists[list.id] = list;
            (0, $gtsdT.logger).log("favorites", "Created new list: ", listName);
            return list;
        }));
    },
    changeListNameInStorage: (listId, newListName)=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if ((0, $bEEBX.default)(customerNumber)) {
            (0, $gtsdT.logger).warn("favorites", "Attempting to change list name before customer number is available", (0, $bcbvQ.default).user);
            return Promise.reject("Not logged in, unable to change list name");
        }
        return (0, $3Y1Wx.apiClient)(`${$27d03a4333b75480$var$getUrl(customerNumber)}/${listId}/name`, (0, $bcbvQ.default).getSessionToken()).put(newListName).json((0, $Kk7R3.action)((list)=>{
            $27d03a4333b75480$var$favoriteStore.allFavoriteLists[list.id].listName = list.listName;
            (0, $gtsdT.logger).log("favorites", "Changed list name: ", newListName);
        })).catch((res)=>{
            (0, $gtsdT.logger).error("favorites", "Error during changing of list name", res);
            (0, $gvoND.default).addError("Feil under endring av navn", "Det oppsto en uforutsett feil under endring av navn p\xe5 listen.", {
                context: "favorite_lists",
                text: "edit_name_error"
            });
        });
    },
    deleteList: (listId)=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if ((0, $bEEBX.default)(customerNumber)) {
            (0, $gtsdT.logger).warn("favorites", "Attempting to delete favorites before customer number is available", (0, $bcbvQ.default).user);
            return Promise.reject("Not logged in, unabel to delete list");
        }
        return (0, $3Y1Wx.apiClient)(`${$27d03a4333b75480$var$getUrl(customerNumber)}/${listId}`, (0, $bcbvQ.default).getSessionToken()).delete().text((0, $Kk7R3.action)(()=>{
            (0, $hQjjC.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists, listId);
            $27d03a4333b75480$var$favoriteStore.syncAllSkus();
        }));
    },
    loadFavorites: async ()=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if ((0, $bEEBX.default)(customerNumber)) {
            (0, $gtsdT.logger).warn("favorites", "Attempting to load favorites before customer number is available", (0, $bcbvQ.default).user);
            return Promise.reject();
        }
        (0, $gtsdT.logger).log("favorites", `Fetching favorites for customer number ${customerNumber}`);
        try {
            const favorites = await (0, $3Y1Wx.apiClient)($27d03a4333b75480$var$getUrl(customerNumber), (0, $bcbvQ.default).getSessionToken()).get().json();
            (0, $Kk7R3.runInAction)(()=>{
                for (const favorite of favorites){
                    favorite.items = Object.keys(favorite.items).map((sku)=>({
                            sku: (0, $bZiDo.default).replacementFor(sku) || sku,
                            qty: favorite.items[sku]
                        })).map((item)=>({
                            [item.sku]: item.qty
                        })).reduce((0, $5OqMf.accumulate), {});
                    favorite.sequence = favorite.sequence.map((sku)=>(0, $bZiDo.default).replacementFor(sku) || sku);
                }
                $27d03a4333b75480$var$favoriteStore.allFavoriteLists = (0, $loTcB.default)(favorites, "id");
                // Ensure sequence is unique, which should clean up old duplicates
                for (const key of Object.keys($27d03a4333b75480$var$favoriteStore.allFavoriteLists))$27d03a4333b75480$var$favoriteStore.allFavoriteLists[key].sequence = (0, $eoV8o.default)($27d03a4333b75480$var$favoriteStore.allFavoriteLists[key].sequence);
                $27d03a4333b75480$var$favoriteStore.syncAllSkus();
            });
            (0, $gtsdT.logger).log("favorites", "Favorites loaded: ", $27d03a4333b75480$var$favoriteStore.allFavoriteLists);
        } catch (err) {
            (0, $gtsdT.logger).error("favorites", "Error during loading of favorites", err);
            (0, $gvoND.default).addError("Feil under lasting av favoritter", "Det oppsto en uforutsett feil under lasting av favoritter.", {
                context: "favorite_lists",
                text: "fetch_favorite_lists_error"
            });
        }
    },
    saveFavorites: async (listId, performSync = true)=>{
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        if ((0, $bEEBX.default)(customerNumber)) {
            (0, $gtsdT.logger).warn("favorites", "Attempting to save favorites before customer number is available", (0, $bcbvQ.default).user);
            return Promise.reject("Not logged in, unable to save favorites");
        }
        const list = $27d03a4333b75480$var$favoriteStore.getFavoriteListById(listId);
        if ((0, $3xOZa.default)(list)) {
            (0, $gtsdT.logger).warn("favorites", `Unable to find favorite list with id ${listId}`);
            return Promise.reject();
        }
        if (performSync) $27d03a4333b75480$var$favoriteStore.syncAllSkus();
        return (0, $3Y1Wx.apiClient)(`${$27d03a4333b75480$var$getUrl(customerNumber)}/${listId}`, (0, $bcbvQ.default).getSessionToken()).put(list).json((0, $Kk7R3.action)((res)=>{
            list.listName = res.listName;
            const itemsChanged = !(0, $k2XjZ.default)(list.items, res.items);
            if (itemsChanged) {
                list.items = res.items;
                if (performSync) $27d03a4333b75480$var$favoriteStore.syncAllSkus();
            }
        })).catch((res)=>{
            (0, $gtsdT.logger).error("favorites", "Unable to save favorites", res);
            (0, $gvoND.default).addError("Feil under lagring", "Vi greide dessverre ikke \xe5 lagre endringen i favorittlister. Pr\xf8v igjen senere.", {
                context: "favorite_lists",
                text: "add_favorite_error"
            });
        });
    },
    clearCompanySpecificData () {
        (0, $Kk7R3.runInAction)(()=>{
            $27d03a4333b75480$var$favoriteStore.allFavoriteLists = {};
            $27d03a4333b75480$var$favoriteStore.syncAllSkus();
        });
    }
});
var $27d03a4333b75480$export$2e2bcd8739ae039 = $27d03a4333b75480$var$favoriteStore;

});
parcelRegister("k2XjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e982028dbaec0aa4$export$2e2bcd8739ae039; });

var $2h5cw = parcelRequire("2h5cw");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $e982028dbaec0aa4$var$isEqual(value, other) {
    return (0, $2h5cw.default)(value, other);
}
var $e982028dbaec0aa4$export$2e2bcd8739ae039 = $e982028dbaec0aa4$var$isEqual;

});

parcelRegister("loTcB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f946a8e55065c14f$export$2e2bcd8739ae039; });

var $hiRHm = parcelRequire("hiRHm");

var $2Dr72 = parcelRequire("2Dr72");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $f946a8e55065c14f$var$keyBy = (0, $2Dr72.default)(function(result, value, key) {
    (0, $hiRHm.default)(result, key, value);
});
var $f946a8e55065c14f$export$2e2bcd8739ae039 = $f946a8e55065c14f$var$keyBy;

});


parcelRegister("6e7IR", function(module, exports) {

$parcel$export(module.exports, "Popover", function () { return $2d34b4a617edb856$export$5b6b19405a83ff9d; });
$parcel$export(module.exports, "PopoverTrigger", function () { return $2d34b4a617edb856$export$7dacb05d26466c3; });
$parcel$export(module.exports, "PopoverContent", function () { return $2d34b4a617edb856$export$d7e1f420b25549ff; });
// This file based on the React Example provided by Floating UI documentation
// https://floating-ui.com/docs/popover
// https://codesandbox.io/p/sandbox/distracted-swirles-jo1pvu

var $7YWoO = parcelRequire("7YWoO");

var $2sXUk = parcelRequire("2sXUk");
var $3cSFY = parcelRequire("3cSFY");
var $eVT1x = parcelRequire("eVT1x");
var $2sXUk = parcelRequire("2sXUk");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");
const $2d34b4a617edb856$var$ARROW_HEIGHT = 7;
const $2d34b4a617edb856$var$GAP = 2;
function $2d34b4a617edb856$export$542a6fd13ac93354({ initialOpen: initialOpen = false, placement: placement = "bottom", modal: modal, open: controlledOpen, onOpenChange: setControlledOpen, noFlip: noFlip = false } = {}) {
    const [uncontrolledOpen, setUncontrolledOpen] = (0, $dvPqk.useState)(initialOpen);
    const [labelId, setLabelId] = (0, $dvPqk.useState)();
    const [descriptionId, setDescriptionId] = (0, $dvPqk.useState)();
    const arrowRef = (0, $dvPqk.useRef)(null);
    const open = controlledOpen ?? uncontrolledOpen;
    const setOpen = setControlledOpen ?? setUncontrolledOpen;
    const middleware = [
        (0, $2sXUk.offset)($2d34b4a617edb856$var$ARROW_HEIGHT + $2d34b4a617edb856$var$GAP)
    ];
    if (!noFlip) {
        middleware.push((0, $2sXUk.flip)({
            crossAxis: placement.includes("-"),
            fallbackAxisSideDirection: "end",
            padding: 5
        }));
        middleware.push((0, $2sXUk.shift)({
            padding: 5
        }));
        middleware.push((0, $2sXUk.arrow)({
            element: arrowRef
        }));
    }
    const data = (0, $eVT1x.useFloating)({
        placement: placement,
        open: open,
        onOpenChange: setOpen,
        whileElementsMounted: (0, $3cSFY.autoUpdate),
        middleware: middleware
    });
    const context = data.context;
    const click = (0, $eVT1x.useClick)(context, {
        enabled: controlledOpen == null
    });
    const dismiss = (0, $eVT1x.useDismiss)(context);
    const role = (0, $eVT1x.useRole)(context);
    const interactions = (0, $eVT1x.useInteractions)([
        click,
        dismiss,
        role
    ]);
    return (0, $dvPqk.useMemo)(()=>({
            open: open,
            setOpen: setOpen,
            ...interactions,
            ...data,
            modal: modal,
            labelId: labelId,
            descriptionId: descriptionId,
            setLabelId: setLabelId,
            setDescriptionId: setDescriptionId,
            arrowRef: arrowRef
        }), [
        open,
        setOpen,
        interactions,
        data,
        modal,
        labelId,
        descriptionId,
        arrowRef
    ]);
}
const $2d34b4a617edb856$var$PopoverContext = /*#__PURE__*/ (0, $dvPqk.createContext)(null);
const $2d34b4a617edb856$export$1468d0761b26e6c8 = ()=>{
    const context = (0, $dvPqk.useContext)($2d34b4a617edb856$var$PopoverContext);
    if (context == null) throw new Error("Popover components must be wrapped in <Popover />");
    return context;
};
function $2d34b4a617edb856$export$5b6b19405a83ff9d({ children: children, modal: modal = false, ...restOptions }) {
    // This can accept any props as options, e.g. `placement`,
    // or other positioning options.
    const popover = $2d34b4a617edb856$export$542a6fd13ac93354({
        modal: modal,
        ...restOptions
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)($2d34b4a617edb856$var$PopoverContext.Provider, {
        value: popover,
        children: children
    });
}
const $2d34b4a617edb856$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $dvPqk.forwardRef)(function PopoverTrigger({ children: children, asChild: asChild = false, ...props }, propRef) {
    const context = $2d34b4a617edb856$export$1468d0761b26e6c8();
    const childrenRef = children?.ref;
    const ref = (0, $eVT1x.useMergeRefs)([
        context.refs.setReference,
        propRef,
        childrenRef
    ]);
    // `asChild` allows the user to pass any element as the anchor
    if (asChild && /*#__PURE__*/ (0, $dvPqk.isValidElement)(children)) return /*#__PURE__*/ (0, $dvPqk.cloneElement)(children, context.getReferenceProps({
        ref: ref,
        ...props,
        ...children.props,
        "data-state": context.open ? "open" : "closed"
    }));
    return /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
        ref: ref,
        type: "button",
        // The user can style the trigger based on the state
        "data-state": context.open ? "open" : "closed",
        ...context.getReferenceProps(props),
        children: children
    });
});
const $2d34b4a617edb856$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $dvPqk.forwardRef)(function PopoverContent({ style: style, ...props }, propRef) {
    const { context: floatingContext, ...context } = $2d34b4a617edb856$export$1468d0761b26e6c8();
    const ref = (0, $eVT1x.useMergeRefs)([
        context.refs.setFloating,
        propRef
    ]);
    if (!floatingContext.open) return null;
    const arrowClasses = (0, $izjX7.cn)("fill-base-0 [&>path:first-of-type]:stroke-ink-border-subtle [&>path:last-of-type]:stroke-base-0");
    const floatingClasses = (0, $izjX7.cn)("bg-base-0 border border-solid border-ink-border-subtle rounded-lg shadow-lg z-50", props.className || "");
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eVT1x.FloatingPortal), {
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eVT1x.FloatingFocusManager), {
            context: floatingContext,
            modal: context.modal,
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                ref: ref,
                style: {
                    ...context.floatingStyles,
                    ...style
                },
                "aria-labelledby": context.labelId,
                "aria-describedby": context.descriptionId,
                "data-info": "popover",
                ...context.getFloatingProps(props),
                className: floatingClasses,
                children: [
                    props.children,
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eVT1x.FloatingArrow), {
                        context: floatingContext,
                        ref: context.arrowRef,
                        className: arrowClasses,
                        strokeWidth: 1
                    })
                ]
            })
        })
    });
});
const $2d34b4a617edb856$export$4d25df1629c5c0e8 = /*#__PURE__*/ (0, $dvPqk.forwardRef)(function PopoverHeading(props, ref) {
    const { setLabelId: setLabelId } = $2d34b4a617edb856$export$1468d0761b26e6c8();
    const id = (0, $eVT1x.useId)();
    // Only sets `aria-labelledby` on the Popover root element
    // if this component is mounted inside it.
    (0, $dvPqk.useLayoutEffect)(()=>{
        setLabelId(id);
        return ()=>setLabelId(undefined);
    }, [
        id,
        setLabelId
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
        ...props,
        ref: ref,
        id: id,
        children: props.children
    });
});
const $2d34b4a617edb856$export$39a373e70f52f23b = /*#__PURE__*/ (0, $dvPqk.forwardRef)(function PopoverDescription(props, ref) {
    const { setDescriptionId: setDescriptionId } = $2d34b4a617edb856$export$1468d0761b26e6c8();
    const id = (0, $eVT1x.useId)();
    // Only sets `aria-describedby` on the Popover root element
    // if this component is mounted inside it.
    (0, $dvPqk.useLayoutEffect)(()=>{
        setDescriptionId(id);
        return ()=>setDescriptionId(undefined);
    }, [
        id,
        setDescriptionId
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
        ...props,
        ref: ref,
        id: id
    });
});
const $2d34b4a617edb856$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $dvPqk.forwardRef)(function PopoverClose(props, ref) {
    const { setOpen: setOpen } = $2d34b4a617edb856$export$1468d0761b26e6c8();
    return /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
        type: "button",
        ref: ref,
        ...props,
        onClick: (event)=>{
            props.onClick?.(event);
            setOpen(false);
        }
    });
});

});
parcelRegister("2sXUk", function(module, exports) {

$parcel$export(module.exports, "useFloating", function () { return $306229cf27e72ac6$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "offset", function () { return $306229cf27e72ac6$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $306229cf27e72ac6$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $306229cf27e72ac6$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $306229cf27e72ac6$export$346677f925de839c; });
$parcel$export(module.exports, "arrow", function () { return $306229cf27e72ac6$export$f2120bbfa5450bd2; });

var $3cSFY = parcelRequire("3cSFY");
var $gI3vG = parcelRequire("gI3vG");

var $dvPqk = parcelRequire("dvPqk");

var $im7eH = parcelRequire("im7eH");
var $306229cf27e72ac6$var$isClient = typeof document !== 'undefined';
var $306229cf27e72ac6$var$noop = function noop() {};
var $306229cf27e72ac6$var$index = $306229cf27e72ac6$var$isClient ? (0, $dvPqk.useLayoutEffect) : $306229cf27e72ac6$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $306229cf27e72ac6$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$306229cf27e72ac6$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$306229cf27e72ac6$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $306229cf27e72ac6$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $306229cf27e72ac6$var$roundByDPR(element, value) {
    const dpr = $306229cf27e72ac6$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $306229cf27e72ac6$var$useLatestRef(value) {
    const ref = $dvPqk.useRef(value);
    $306229cf27e72ac6$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $306229cf27e72ac6$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $dvPqk.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $dvPqk.useState(middleware);
    if (!$306229cf27e72ac6$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $dvPqk.useState(null);
    const [_floating, _setFloating] = $dvPqk.useState(null);
    const setReference = $dvPqk.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $dvPqk.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $dvPqk.useRef(null);
    const floatingRef = $dvPqk.useRef(null);
    const dataRef = $dvPqk.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $306229cf27e72ac6$var$useLatestRef(whileElementsMounted);
    const platformRef = $306229cf27e72ac6$var$useLatestRef(platform);
    const openRef = $306229cf27e72ac6$var$useLatestRef(open);
    const update = $dvPqk.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $3cSFY.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$306229cf27e72ac6$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $im7eH.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $306229cf27e72ac6$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $dvPqk.useRef(false);
    $306229cf27e72ac6$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $306229cf27e72ac6$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $dvPqk.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $dvPqk.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $dvPqk.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $306229cf27e72ac6$var$roundByDPR(elements.floating, data.x);
        const y = $306229cf27e72ac6$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$306229cf27e72ac6$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $dvPqk.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $306229cf27e72ac6$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $3cSFY.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $3cSFY.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $306229cf27e72ac6$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $3cSFY.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $306229cf27e72ac6$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $3cSFY.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $306229cf27e72ac6$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $3cSFY.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $306229cf27e72ac6$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $3cSFY.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $306229cf27e72ac6$export$346677f925de839c = (options, deps)=>({
        ...(0, $3cSFY.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $306229cf27e72ac6$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $3cSFY.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $306229cf27e72ac6$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $3cSFY.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $306229cf27e72ac6$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $3cSFY.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $306229cf27e72ac6$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$306229cf27e72ac6$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});
parcelRegister("3cSFY", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $4050b89e5df48127$export$deee3a793edee05f; });
$parcel$export(module.exports, "detectOverflow", function () { return $4050b89e5df48127$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "offset", function () { return $4050b89e5df48127$export$cc800923e997bb8; });
$parcel$export(module.exports, "autoPlacement", function () { return $4050b89e5df48127$export$91fb6ecbd551914; });
$parcel$export(module.exports, "shift", function () { return $4050b89e5df48127$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $4050b89e5df48127$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $4050b89e5df48127$export$346677f925de839c; });
$parcel$export(module.exports, "hide", function () { return $4050b89e5df48127$export$fe8985bb6374093c; });
$parcel$export(module.exports, "arrow", function () { return $4050b89e5df48127$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "inline", function () { return $4050b89e5df48127$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "limitShift", function () { return $4050b89e5df48127$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "computePosition", function () { return $4050b89e5df48127$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return (parcelRequire("gI3vG")).getOverflowAncestors; });

var $cHP7K = parcelRequire("cHP7K");
var $cZP7r = parcelRequire("cZP7r");

var $cZP7r = parcelRequire("cZP7r");

var $gI3vG = parcelRequire("gI3vG");
function $4050b89e5df48127$var$getCssDimensions(element) {
    const css = (0, $gI3vG.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $gI3vG.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cZP7r.round)(width) !== offsetWidth || (0, $cZP7r.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $4050b89e5df48127$var$unwrapElement(element) {
    return !(0, $gI3vG.isElement)(element) ? element.contextElement : element;
}
function $4050b89e5df48127$var$getScale(element) {
    const domElement = $4050b89e5df48127$var$unwrapElement(element);
    if (!(0, $gI3vG.isHTMLElement)(domElement)) return (0, $cZP7r.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $4050b89e5df48127$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cZP7r.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cZP7r.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $4050b89e5df48127$var$noOffsets = /*#__PURE__*/ (0, $cZP7r.createCoords)(0);
function $4050b89e5df48127$var$getVisualOffsets(element) {
    const win = (0, $gI3vG.getWindow)(element);
    if (!(0, $gI3vG.isWebKit)() || !win.visualViewport) return $4050b89e5df48127$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $4050b89e5df48127$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $gI3vG.getWindow)(element)) return false;
    return isFixed;
}
function $4050b89e5df48127$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $4050b89e5df48127$var$unwrapElement(element);
    let scale = (0, $cZP7r.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $gI3vG.isElement)(offsetParent)) scale = $4050b89e5df48127$var$getScale(offsetParent);
        } else scale = $4050b89e5df48127$var$getScale(element);
    }
    const visualOffsets = $4050b89e5df48127$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $4050b89e5df48127$var$getVisualOffsets(domElement) : (0, $cZP7r.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $gI3vG.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $gI3vG.isElement)(offsetParent) ? (0, $gI3vG.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $gI3vG.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $4050b89e5df48127$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $gI3vG.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $gI3vG.getWindow)(currentIFrame);
            currentIFrame = (0, $gI3vG.getFrameElement)(currentWin);
        }
    }
    return (0, $cZP7r.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $4050b89e5df48127$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $gI3vG.getNodeScroll)(element).scrollLeft;
    if (!rect) return $4050b89e5df48127$var$getBoundingClientRect((0, $gI3vG.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $4050b89e5df48127$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $4050b89e5df48127$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $4050b89e5df48127$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $gI3vG.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $gI3vG.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cZP7r.createCoords)(1);
    const offsets = (0, $cZP7r.createCoords)(0);
    const isOffsetParentAnElement = (0, $gI3vG.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gI3vG.getNodeName)(offsetParent) !== 'body' || (0, $gI3vG.isOverflowElement)(documentElement)) scroll = (0, $gI3vG.getNodeScroll)(offsetParent);
        if ((0, $gI3vG.isHTMLElement)(offsetParent)) {
            const offsetRect = $4050b89e5df48127$var$getBoundingClientRect(offsetParent);
            scale = $4050b89e5df48127$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4050b89e5df48127$var$getHTMLOffset(documentElement, scroll, true) : (0, $cZP7r.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $4050b89e5df48127$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $4050b89e5df48127$var$getDocumentRect(element) {
    const html = (0, $gI3vG.getDocumentElement)(element);
    const scroll = (0, $gI3vG.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cZP7r.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cZP7r.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $4050b89e5df48127$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $gI3vG.getComputedStyle)(body).direction === 'rtl') x += (0, $cZP7r.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4050b89e5df48127$var$getViewportRect(element, strategy) {
    const win = (0, $gI3vG.getWindow)(element);
    const html = (0, $gI3vG.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $gI3vG.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $4050b89e5df48127$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $4050b89e5df48127$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $4050b89e5df48127$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $gI3vG.isHTMLElement)(element) ? $4050b89e5df48127$var$getScale(element) : (0, $cZP7r.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4050b89e5df48127$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $4050b89e5df48127$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $4050b89e5df48127$var$getDocumentRect((0, $gI3vG.getDocumentElement)(element));
    else if ((0, $gI3vG.isElement)(clippingAncestor)) rect = $4050b89e5df48127$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $4050b89e5df48127$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cZP7r.rectToClientRect)(rect);
}
function $4050b89e5df48127$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $gI3vG.getParentNode)(element);
    if (parentNode === stopNode || !(0, $gI3vG.isElement)(parentNode) || (0, $gI3vG.isLastTraversableNode)(parentNode)) return false;
    return (0, $gI3vG.getComputedStyle)(parentNode).position === 'fixed' || $4050b89e5df48127$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $4050b89e5df48127$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $gI3vG.getOverflowAncestors)(element, [], false).filter((el)=>(0, $gI3vG.isElement)(el) && (0, $gI3vG.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $gI3vG.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $gI3vG.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $gI3vG.isElement)(currentNode) && !(0, $gI3vG.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $gI3vG.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $gI3vG.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $4050b89e5df48127$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $gI3vG.isOverflowElement)(currentNode) && !currentNodeIsContaining && $4050b89e5df48127$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $gI3vG.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $4050b89e5df48127$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $gI3vG.isTopLayer)(element) ? [] : $4050b89e5df48127$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $4050b89e5df48127$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cZP7r.max)(rect.top, accRect.top);
        accRect.right = (0, $cZP7r.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cZP7r.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cZP7r.max)(rect.left, accRect.left);
        return accRect;
    }, $4050b89e5df48127$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $4050b89e5df48127$var$getDimensions(element) {
    const { width: width, height: height } = $4050b89e5df48127$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $4050b89e5df48127$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $gI3vG.isHTMLElement)(offsetParent);
    const documentElement = (0, $gI3vG.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $4050b89e5df48127$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cZP7r.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $4050b89e5df48127$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $gI3vG.getNodeName)(offsetParent) !== 'body' || (0, $gI3vG.isOverflowElement)(documentElement)) scroll = (0, $gI3vG.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $4050b89e5df48127$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4050b89e5df48127$var$getHTMLOffset(documentElement, scroll) : (0, $cZP7r.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $4050b89e5df48127$var$isStaticPositioned(element) {
    return (0, $gI3vG.getComputedStyle)(element).position === 'static';
}
function $4050b89e5df48127$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $gI3vG.isHTMLElement)(element) || (0, $gI3vG.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $gI3vG.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $4050b89e5df48127$var$getOffsetParent(element, polyfill) {
    const win = (0, $gI3vG.getWindow)(element);
    if ((0, $gI3vG.isTopLayer)(element)) return win;
    if (!(0, $gI3vG.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $gI3vG.getParentNode)(element);
        while(svgOffsetParent && !(0, $gI3vG.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $gI3vG.isElement)(svgOffsetParent) && !$4050b89e5df48127$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $gI3vG.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $4050b89e5df48127$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $gI3vG.isTableElement)(offsetParent) && $4050b89e5df48127$var$isStaticPositioned(offsetParent))offsetParent = $4050b89e5df48127$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $gI3vG.isLastTraversableNode)(offsetParent) && $4050b89e5df48127$var$isStaticPositioned(offsetParent) && !(0, $gI3vG.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $gI3vG.getContainingBlock)(element) || win;
}
const $4050b89e5df48127$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $4050b89e5df48127$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $4050b89e5df48127$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $4050b89e5df48127$var$isRTL(element) {
    return (0, $gI3vG.getComputedStyle)(element).direction === 'rtl';
}
const $4050b89e5df48127$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $4050b89e5df48127$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $gI3vG.getDocumentElement,
    getClippingRect: $4050b89e5df48127$var$getClippingRect,
    getOffsetParent: $4050b89e5df48127$var$getOffsetParent,
    getElementRects: $4050b89e5df48127$var$getElementRects,
    getClientRects: $4050b89e5df48127$var$getClientRects,
    getDimensions: $4050b89e5df48127$var$getDimensions,
    getScale: $4050b89e5df48127$var$getScale,
    isElement: $gI3vG.isElement,
    isRTL: $4050b89e5df48127$var$isRTL
};
function $4050b89e5df48127$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $4050b89e5df48127$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $gI3vG.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cZP7r.floor)(top);
        const insetRight = (0, $cZP7r.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cZP7r.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cZP7r.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cZP7r.max)(0, (0, $cZP7r.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$4050b89e5df48127$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $4050b89e5df48127$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $4050b89e5df48127$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $gI3vG.getOverflowAncestors)(referenceEl) : [],
        ...(0, $gI3vG.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $4050b89e5df48127$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $4050b89e5df48127$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $4050b89e5df48127$var$getBoundingClientRect(reference);
        if (prevRefRect && !$4050b89e5df48127$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $4050b89e5df48127$export$37b6bde19b108ecc = (0, $cHP7K.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4050b89e5df48127$export$cc800923e997bb8 = (0, $cHP7K.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4050b89e5df48127$export$91fb6ecbd551914 = (0, $cHP7K.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4050b89e5df48127$export$fba63a578e423eb = (0, $cHP7K.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4050b89e5df48127$export$8a83211c878a3f1f = (0, $cHP7K.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4050b89e5df48127$export$346677f925de839c = (0, $cHP7K.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4050b89e5df48127$export$fe8985bb6374093c = (0, $cHP7K.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4050b89e5df48127$export$f2120bbfa5450bd2 = (0, $cHP7K.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4050b89e5df48127$export$18c8ad048e32c7d5 = (0, $cHP7K.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4050b89e5df48127$export$7bf07e38f3dc4b69 = (0, $cHP7K.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $4050b89e5df48127$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $4050b89e5df48127$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cHP7K.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cHP7K", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $ed885246843e927f$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $ed885246843e927f$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $ed885246843e927f$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $ed885246843e927f$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $ed885246843e927f$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $ed885246843e927f$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $ed885246843e927f$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $ed885246843e927f$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $ed885246843e927f$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $ed885246843e927f$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $ed885246843e927f$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("cZP7r")).rectToClientRect; });

var $cZP7r = parcelRequire("cZP7r");
function $ed885246843e927f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cZP7r.getSideAxis)(placement);
    const alignmentAxis = (0, $cZP7r.getAlignmentAxis)(placement);
    const alignLength = (0, $cZP7r.getAxisLength)(alignmentAxis);
    const side = (0, $cZP7r.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cZP7r.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $ed885246843e927f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $ed885246843e927f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $ed885246843e927f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $ed885246843e927f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cZP7r.evaluate)(options, state);
    const paddingObject = (0, $cZP7r.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cZP7r.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cZP7r.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $ed885246843e927f$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cZP7r.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cZP7r.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cZP7r.getAlignmentAxis)(placement);
            const length = (0, $cZP7r.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cZP7r.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cZP7r.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cZP7r.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cZP7r.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $ed885246843e927f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cZP7r.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cZP7r.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cZP7r.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cZP7r.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cZP7r.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $ed885246843e927f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cZP7r.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cZP7r.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cZP7r.placements) ? $ed885246843e927f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $ed885246843e927f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cZP7r.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cZP7r.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cZP7r.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cZP7r.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $ed885246843e927f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cZP7r.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cZP7r.getSide)(placement);
            const initialSideAxis = (0, $cZP7r.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cZP7r.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cZP7r.getOppositePlacement)(initialPlacement)
            ] : (0, $cZP7r.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cZP7r.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $ed885246843e927f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cZP7r.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $cZP7r.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $cZP7r.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cZP7r.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $ed885246843e927f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $ed885246843e927f$var$isAnySideFullyClipped(overflow) {
    return (0, $cZP7r.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $ed885246843e927f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cZP7r.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $ed885246843e927f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $ed885246843e927f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $ed885246843e927f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $ed885246843e927f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $ed885246843e927f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $ed885246843e927f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $ed885246843e927f$var$getBoundingRect(rects) {
    const minX = (0, $cZP7r.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cZP7r.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cZP7r.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cZP7r.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $ed885246843e927f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cZP7r.rectToClientRect)($ed885246843e927f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $ed885246843e927f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cZP7r.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $ed885246843e927f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cZP7r.rectToClientRect)($ed885246843e927f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cZP7r.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cZP7r.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cZP7r.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cZP7r.getSide)(placement) === 'left';
                    const maxRight = (0, $cZP7r.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cZP7r.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $ed885246843e927f$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $ed885246843e927f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cZP7r.getSide)(placement);
    const alignment = (0, $cZP7r.getAlignment)(placement);
    const isVertical = (0, $cZP7r.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $ed885246843e927f$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cZP7r.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $ed885246843e927f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $ed885246843e927f$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $ed885246843e927f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cZP7r.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $ed885246843e927f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cZP7r.getSideAxis)((0, $cZP7r.getSide)(placement));
            const mainAxis = (0, $cZP7r.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cZP7r.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cZP7r.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $ed885246843e927f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cZP7r.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cZP7r.getSideAxis)(placement);
            const mainAxis = (0, $cZP7r.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cZP7r.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $ed885246843e927f$var$originSides.has((0, $cZP7r.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $ed885246843e927f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cZP7r.evaluate)(options, state);
            const overflow = await $ed885246843e927f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cZP7r.getSide)(placement);
            const alignment = (0, $cZP7r.getAlignment)(placement);
            const isYAxis = (0, $cZP7r.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cZP7r.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cZP7r.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cZP7r.max)(overflow.left, 0);
                const xMax = (0, $cZP7r.max)(overflow.right, 0);
                const yMin = (0, $cZP7r.max)(overflow.top, 0);
                const yMax = (0, $cZP7r.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cZP7r.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cZP7r.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cZP7r", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $abb407ded599f7a6$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $abb407ded599f7a6$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $abb407ded599f7a6$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $abb407ded599f7a6$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $abb407ded599f7a6$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $abb407ded599f7a6$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $abb407ded599f7a6$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $abb407ded599f7a6$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $abb407ded599f7a6$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $abb407ded599f7a6$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $abb407ded599f7a6$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $abb407ded599f7a6$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $abb407ded599f7a6$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $abb407ded599f7a6$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $abb407ded599f7a6$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $abb407ded599f7a6$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $abb407ded599f7a6$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $abb407ded599f7a6$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $abb407ded599f7a6$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $abb407ded599f7a6$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $abb407ded599f7a6$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $abb407ded599f7a6$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $abb407ded599f7a6$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $abb407ded599f7a6$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $abb407ded599f7a6$export$803cd8101b6c182b = /*#__PURE__*/ $abb407ded599f7a6$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $abb407ded599f7a6$export$27b07d8a310ed8b5[0], side + "-" + $abb407ded599f7a6$export$27b07d8a310ed8b5[1]), []);
const $abb407ded599f7a6$export$96ec731ed4dcb222 = Math.min;
const $abb407ded599f7a6$export$8960430cfd85939f = Math.max;
const $abb407ded599f7a6$export$2077e0241d6afd3c = Math.round;
const $abb407ded599f7a6$export$a3fe094919f356fd = Math.floor;
const $abb407ded599f7a6$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $abb407ded599f7a6$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $abb407ded599f7a6$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $abb407ded599f7a6$export$7d15b64cf5a3a4c4(start, value, end) {
    return $abb407ded599f7a6$export$8960430cfd85939f(start, $abb407ded599f7a6$export$96ec731ed4dcb222(value, end));
}
function $abb407ded599f7a6$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $abb407ded599f7a6$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $abb407ded599f7a6$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $abb407ded599f7a6$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $abb407ded599f7a6$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $abb407ded599f7a6$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $abb407ded599f7a6$export$f28e8f882010718a(placement) {
    return $abb407ded599f7a6$var$yAxisSides.has($abb407ded599f7a6$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $abb407ded599f7a6$export$2b57e0052a6d6d4c(placement) {
    return $abb407ded599f7a6$export$8a000a963141ac32($abb407ded599f7a6$export$f28e8f882010718a(placement));
}
function $abb407ded599f7a6$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $abb407ded599f7a6$export$f0989780f32bfcda(placement);
    const alignmentAxis = $abb407ded599f7a6$export$2b57e0052a6d6d4c(placement);
    const length = $abb407ded599f7a6$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $abb407ded599f7a6$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $abb407ded599f7a6$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $abb407ded599f7a6$export$496432a3699e50b1(placement) {
    const oppositePlacement = $abb407ded599f7a6$export$9c5e28bad23365fa(placement);
    return [
        $abb407ded599f7a6$export$2b182c584985588b(placement),
        oppositePlacement,
        $abb407ded599f7a6$export$2b182c584985588b(oppositePlacement)
    ];
}
function $abb407ded599f7a6$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$abb407ded599f7a6$var$oppositeAlignmentMap[alignment]);
}
const $abb407ded599f7a6$var$lrPlacement = [
    'left',
    'right'
];
const $abb407ded599f7a6$var$rlPlacement = [
    'right',
    'left'
];
const $abb407ded599f7a6$var$tbPlacement = [
    'top',
    'bottom'
];
const $abb407ded599f7a6$var$btPlacement = [
    'bottom',
    'top'
];
function $abb407ded599f7a6$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $abb407ded599f7a6$var$rlPlacement : $abb407ded599f7a6$var$lrPlacement;
            return isStart ? $abb407ded599f7a6$var$lrPlacement : $abb407ded599f7a6$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $abb407ded599f7a6$var$tbPlacement : $abb407ded599f7a6$var$btPlacement;
        default:
            return [];
    }
}
function $abb407ded599f7a6$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $abb407ded599f7a6$export$f0989780f32bfcda(placement);
    let list = $abb407ded599f7a6$var$getSideList($abb407ded599f7a6$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($abb407ded599f7a6$export$2b182c584985588b));
    }
    return list;
}
function $abb407ded599f7a6$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$abb407ded599f7a6$var$oppositeSideMap[side]);
}
function $abb407ded599f7a6$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $abb407ded599f7a6$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $abb407ded599f7a6$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $abb407ded599f7a6$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("gI3vG", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $50a7bd44d29852b8$export$651544f548703224; });
$parcel$export(module.exports, "isNode", function () { return $50a7bd44d29852b8$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "getWindow", function () { return $50a7bd44d29852b8$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $50a7bd44d29852b8$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $50a7bd44d29852b8$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $50a7bd44d29852b8$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $50a7bd44d29852b8$export$af51f0f06c0f328a; });
$parcel$export(module.exports, "isOverflowElement", function () { return $50a7bd44d29852b8$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $50a7bd44d29852b8$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $50a7bd44d29852b8$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $50a7bd44d29852b8$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $50a7bd44d29852b8$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $50a7bd44d29852b8$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $50a7bd44d29852b8$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $50a7bd44d29852b8$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $50a7bd44d29852b8$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $50a7bd44d29852b8$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $50a7bd44d29852b8$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $50a7bd44d29852b8$export$7bf1f8740e3e34af; });
function $50a7bd44d29852b8$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $50a7bd44d29852b8$export$651544f548703224(node) {
    if ($50a7bd44d29852b8$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $50a7bd44d29852b8$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $50a7bd44d29852b8$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($50a7bd44d29852b8$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $50a7bd44d29852b8$export$8ee0fc9ee280b4ee(value) {
    if (!$50a7bd44d29852b8$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $50a7bd44d29852b8$export$38b2d434cce3ea22(value).Node;
}
function $50a7bd44d29852b8$export$45a5e7f76e0caa8d(value) {
    if (!$50a7bd44d29852b8$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $50a7bd44d29852b8$export$38b2d434cce3ea22(value).Element;
}
function $50a7bd44d29852b8$export$1b3bfaa9684536aa(value) {
    if (!$50a7bd44d29852b8$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $50a7bd44d29852b8$export$38b2d434cce3ea22(value).HTMLElement;
}
function $50a7bd44d29852b8$export$af51f0f06c0f328a(value) {
    if (!$50a7bd44d29852b8$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $50a7bd44d29852b8$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $50a7bd44d29852b8$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $50a7bd44d29852b8$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $50a7bd44d29852b8$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$50a7bd44d29852b8$var$invalidOverflowDisplayValues.has(display);
}
const $50a7bd44d29852b8$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $50a7bd44d29852b8$export$71535ffaa902797f(element) {
    return $50a7bd44d29852b8$var$tableElements.has($50a7bd44d29852b8$export$651544f548703224(element));
}
const $50a7bd44d29852b8$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $50a7bd44d29852b8$export$89e651af02346cd4(element) {
    return $50a7bd44d29852b8$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $50a7bd44d29852b8$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $50a7bd44d29852b8$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $50a7bd44d29852b8$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $50a7bd44d29852b8$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $50a7bd44d29852b8$export$78551043582a6a98();
    const css = $50a7bd44d29852b8$export$45a5e7f76e0caa8d(elementOrCss) ? $50a7bd44d29852b8$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $50a7bd44d29852b8$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $50a7bd44d29852b8$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $50a7bd44d29852b8$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $50a7bd44d29852b8$export$940d8225183e1404(element) {
    let currentNode = $50a7bd44d29852b8$export$4e12058fc4d51d56(element);
    while($50a7bd44d29852b8$export$1b3bfaa9684536aa(currentNode) && !$50a7bd44d29852b8$export$d1162fb0b6d4cd51(currentNode)){
        if ($50a7bd44d29852b8$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($50a7bd44d29852b8$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $50a7bd44d29852b8$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $50a7bd44d29852b8$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $50a7bd44d29852b8$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $50a7bd44d29852b8$export$d1162fb0b6d4cd51(node) {
    return $50a7bd44d29852b8$var$lastTraversableNodeNames.has($50a7bd44d29852b8$export$651544f548703224(node));
}
function $50a7bd44d29852b8$export$3735103072e4a80(element) {
    return $50a7bd44d29852b8$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $50a7bd44d29852b8$export$dc8fc79fa2800137(element) {
    if ($50a7bd44d29852b8$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $50a7bd44d29852b8$export$4e12058fc4d51d56(node) {
    if ($50a7bd44d29852b8$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $50a7bd44d29852b8$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $50a7bd44d29852b8$export$e495491855dc5418(node);
    return $50a7bd44d29852b8$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $50a7bd44d29852b8$export$7cd01a57c8ca906c(node) {
    const parentNode = $50a7bd44d29852b8$export$4e12058fc4d51d56(node);
    if ($50a7bd44d29852b8$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($50a7bd44d29852b8$export$1b3bfaa9684536aa(parentNode) && $50a7bd44d29852b8$export$989e911fa9af580a(parentNode)) return parentNode;
    return $50a7bd44d29852b8$export$7cd01a57c8ca906c(parentNode);
}
function $50a7bd44d29852b8$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $50a7bd44d29852b8$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $50a7bd44d29852b8$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $50a7bd44d29852b8$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $50a7bd44d29852b8$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $50a7bd44d29852b8$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $50a7bd44d29852b8$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $50a7bd44d29852b8$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});



parcelRegister("eVT1x", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $e5b99cab3fa7a544$export$74665b213cb5c4cf; });
$parcel$export(module.exports, "useId", function () { return $e5b99cab3fa7a544$export$f680877a34711e37; });
$parcel$export(module.exports, "FloatingArrow", function () { return $e5b99cab3fa7a544$export$33511391554732bc; });
$parcel$export(module.exports, "FloatingPortal", function () { return $e5b99cab3fa7a544$export$31fa5d718fa2ac09; });
$parcel$export(module.exports, "FloatingFocusManager", function () { return $e5b99cab3fa7a544$export$8aeee49171ded61a; });
$parcel$export(module.exports, "useClick", function () { return $e5b99cab3fa7a544$export$98524f11226063fc; });
$parcel$export(module.exports, "useDismiss", function () { return $e5b99cab3fa7a544$export$fcdf1ba5fafc089b; });
$parcel$export(module.exports, "useFloating", function () { return $e5b99cab3fa7a544$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "useInteractions", function () { return $e5b99cab3fa7a544$export$a519f7794e446ddd; });
$parcel$export(module.exports, "useRole", function () { return $e5b99cab3fa7a544$export$f66572793fa256a1; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("2sXUk")).offset; });

var $dvPqk = parcelRequire("dvPqk");

var $5dAgE = parcelRequire("5dAgE");

var $7YWoO = parcelRequire("7YWoO");

var $gI3vG = parcelRequire("gI3vG");

var $4504l = parcelRequire("4504l");

var $im7eH = parcelRequire("im7eH");

var $2sXUk = parcelRequire("2sXUk");
var $3cSFY = parcelRequire("3cSFY");
var $gI3vG = parcelRequire("gI3vG");

var $cZP7r = parcelRequire("cZP7r");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $e5b99cab3fa7a544$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $dvPqk.useRef(undefined);
    const refEffect = $dvPqk.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $dvPqk.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $e5b99cab3fa7a544$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $e5b99cab3fa7a544$var$FloatingListContext = /*#__PURE__*/ $dvPqk.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $e5b99cab3fa7a544$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $dvPqk.useState(()=>new Set());
    const register = $dvPqk.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $dvPqk.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $dvPqk.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($e5b99cab3fa7a544$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FloatingListContext.Provider, {
        value: $dvPqk.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $e5b99cab3fa7a544$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $dvPqk.useContext($e5b99cab3fa7a544$var$FloatingListContext);
    const [index, setIndex] = $dvPqk.useState(null);
    const componentRef = $dvPqk.useRef(null);
    const ref = $dvPqk.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $dvPqk.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $e5b99cab3fa7a544$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $e5b99cab3fa7a544$var$ACTIVE_KEY = 'active';
const $e5b99cab3fa7a544$var$SELECTED_KEY = 'selected';
const $e5b99cab3fa7a544$var$ARROW_LEFT = 'ArrowLeft';
const $e5b99cab3fa7a544$var$ARROW_RIGHT = 'ArrowRight';
const $e5b99cab3fa7a544$var$ARROW_UP = 'ArrowUp';
const $e5b99cab3fa7a544$var$ARROW_DOWN = 'ArrowDown';
function $e5b99cab3fa7a544$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $dvPqk.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ...computedProps
    });
}
const $e5b99cab3fa7a544$var$CompositeContext = /*#__PURE__*/ $dvPqk.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $e5b99cab3fa7a544$var$horizontalKeys = [
    $e5b99cab3fa7a544$var$ARROW_LEFT,
    $e5b99cab3fa7a544$var$ARROW_RIGHT
];
const $e5b99cab3fa7a544$var$verticalKeys = [
    $e5b99cab3fa7a544$var$ARROW_UP,
    $e5b99cab3fa7a544$var$ARROW_DOWN
];
const $e5b99cab3fa7a544$var$allKeys = [
    ...$e5b99cab3fa7a544$var$horizontalKeys,
    ...$e5b99cab3fa7a544$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $e5b99cab3fa7a544$export$43586241d9db0c6d = /*#__PURE__*/ $dvPqk.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $dvPqk.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $5dAgE.useEffectEvent)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $dvPqk.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $dvPqk.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$e5b99cab3fa7a544$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $5dAgE.getMinListIndex)(elementsRef, disabledIndices);
        const maxIndex = (0, $5dAgE.getMaxListIndex)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $e5b99cab3fa7a544$var$ARROW_LEFT : $e5b99cab3fa7a544$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $e5b99cab3fa7a544$var$ARROW_RIGHT : $e5b99cab3fa7a544$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $5dAgE.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $5dAgE.isListIndexDisabled)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $5dAgE.isListIndexDisabled)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $5dAgE.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $5dAgE.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, $5dAgE.isListIndexDisabled)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $5dAgE.getGridCellIndexOfCorner)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $e5b99cab3fa7a544$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $e5b99cab3fa7a544$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $e5b99cab3fa7a544$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $e5b99cab3fa7a544$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $e5b99cab3fa7a544$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $e5b99cab3fa7a544$var$allKeys : ({
            horizontal: $e5b99cab3fa7a544$var$horizontalKeys,
            vertical: $e5b99cab3fa7a544$var$verticalKeys,
            both: $e5b99cab3fa7a544$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $5dAgE.findNonDisabledListIndex)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $5dAgE.isIndexOutOfListBounds)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $e5b99cab3fa7a544$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $e5b99cab3fa7a544$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $dvPqk.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $dvPqk.useContext($e5b99cab3fa7a544$var$CompositeContext);
    const { ref: ref, index: index } = $e5b99cab3fa7a544$export$dcdc7ff5149f7d1a();
    const mergedRef = $e5b99cab3fa7a544$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $e5b99cab3fa7a544$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $e5b99cab3fa7a544$var$SafeReact = {
    ...$dvPqk
};
let $e5b99cab3fa7a544$var$serverHandoffComplete = false;
let $e5b99cab3fa7a544$var$count = 0;
const $e5b99cab3fa7a544$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $e5b99cab3fa7a544$var$count++;
function $e5b99cab3fa7a544$var$useFloatingId() {
    const [id, setId] = $dvPqk.useState(()=>$e5b99cab3fa7a544$var$serverHandoffComplete ? $e5b99cab3fa7a544$var$genId() : undefined);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (id == null) setId($e5b99cab3fa7a544$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dvPqk.useEffect(()=>{
        $e5b99cab3fa7a544$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $e5b99cab3fa7a544$var$useReactId = $e5b99cab3fa7a544$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $e5b99cab3fa7a544$export$f680877a34711e37 = $e5b99cab3fa7a544$var$useReactId || $e5b99cab3fa7a544$var$useFloatingId;
let $e5b99cab3fa7a544$var$devMessageSet;
function $e5b99cab3fa7a544$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $e5b99cab3fa7a544$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $e5b99cab3fa7a544$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $e5b99cab3fa7a544$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $e5b99cab3fa7a544$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $e5b99cab3fa7a544$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $e5b99cab3fa7a544$export$33511391554732bc = /*#__PURE__*/ $dvPqk.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $e5b99cab3fa7a544$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $dvPqk.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!floating) return;
        const isRTL = (0, $gI3vG.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $7YWoO.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function $e5b99cab3fa7a544$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $e5b99cab3fa7a544$var$FloatingNodeContext = /*#__PURE__*/ $dvPqk.createContext(null);
const $e5b99cab3fa7a544$var$FloatingTreeContext = /*#__PURE__*/ $dvPqk.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $e5b99cab3fa7a544$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $dvPqk.useContext($e5b99cab3fa7a544$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $e5b99cab3fa7a544$export$db0c2a7c7a2a4f69 = ()=>$dvPqk.useContext($e5b99cab3fa7a544$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $e5b99cab3fa7a544$export$9b136e0e758a42f4(customParentId) {
    const id = $e5b99cab3fa7a544$export$f680877a34711e37();
    const tree = $e5b99cab3fa7a544$export$db0c2a7c7a2a4f69();
    const reactParentId = $e5b99cab3fa7a544$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $e5b99cab3fa7a544$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $e5b99cab3fa7a544$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FloatingNodeContext.Provider, {
        value: $dvPqk.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $e5b99cab3fa7a544$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $dvPqk.useRef([]);
    const addNode = $dvPqk.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $dvPqk.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $dvPqk.useState(()=>$e5b99cab3fa7a544$var$createEventEmitter());
    return /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FloatingTreeContext.Provider, {
        value: $dvPqk.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $e5b99cab3fa7a544$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $e5b99cab3fa7a544$var$safePolygonIdentifier = /*#__PURE__*/ $e5b99cab3fa7a544$var$createAttribute('safe-polygon');
function $e5b99cab3fa7a544$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $5dAgE.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $e5b99cab3fa7a544$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $e5b99cab3fa7a544$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $e5b99cab3fa7a544$export$db0c2a7c7a2a4f69();
    const parentId = $e5b99cab3fa7a544$export$165209eae06d3488();
    const handleCloseRef = (0, $5dAgE.useLatestRef)(handleClose);
    const delayRef = (0, $5dAgE.useLatestRef)(delay);
    const openRef = (0, $5dAgE.useLatestRef)(open);
    const restMsRef = (0, $5dAgE.useLatestRef)(restMs);
    const pointerTypeRef = $dvPqk.useRef();
    const timeoutRef = $dvPqk.useRef(-1);
    const handlerRef = $dvPqk.useRef();
    const restTimeoutRef = $dvPqk.useRef(-1);
    const blockMouseMoveRef = $dvPqk.useRef(true);
    const performedPointerEventsMutationRef = $dvPqk.useRef(false);
    const unbindMouseMoveRef = $dvPqk.useRef(()=>{});
    const restTimeoutPendingRef = $dvPqk.useRef(false);
    const isHoverOpen = (0, $5dAgE.useEffectEvent)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $dvPqk.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
                $e5b99cab3fa7a544$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $dvPqk.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $5dAgE.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $dvPqk.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $e5b99cab3fa7a544$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $5dAgE.useEffectEvent)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $5dAgE.useEffectEvent)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $5dAgE.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($e5b99cab3fa7a544$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $5dAgE.useEffectEvent)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $dvPqk.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $5dAgE.isMouseLikePointerType)(pointerTypeRef.current) || $e5b99cab3fa7a544$var$getRestMs(restMsRef.current) > 0 && !$e5b99cab3fa7a544$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $e5b99cab3fa7a544$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $5dAgE.getDocument)(elements.floating);
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $5dAgE.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $gI3vG.isElement)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $gI3vG.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $5dAgE.getDocument)(elements.floating).body;
                body.setAttribute($e5b99cab3fa7a544$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $dvPqk.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $dvPqk.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $5dAgE.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || $e5b99cab3fa7a544$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $e5b99cab3fa7a544$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $e5b99cab3fa7a544$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $e5b99cab3fa7a544$var$NOOP = ()=>{};
const $e5b99cab3fa7a544$var$FloatingDelayGroupContext = /*#__PURE__*/ $dvPqk.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $e5b99cab3fa7a544$var$NOOP,
    setState: $e5b99cab3fa7a544$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $e5b99cab3fa7a544$export$e2411914b150383d = ()=>$dvPqk.useContext($e5b99cab3fa7a544$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $e5b99cab3fa7a544$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $dvPqk.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $dvPqk.useRef(null);
    const setCurrentId = $dvPqk.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FloatingDelayGroupContext.Provider, {
        value: $dvPqk.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $e5b99cab3fa7a544$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $e5b99cab3fa7a544$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $e5b99cab3fa7a544$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (setCurrentId === $e5b99cab3fa7a544$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $e5b99cab3fa7a544$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $dvPqk.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $e5b99cab3fa7a544$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $dvPqk.useRef(delay);
    const initialDelayRef = $dvPqk.useRef(delay);
    const currentIdRef = $dvPqk.useRef(null);
    const currentContextRef = $dvPqk.useRef(null);
    const timeoutIdRef = $dvPqk.useRef(-1);
    return /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$NextFloatingDelayGroupContext.Provider, {
        value: $dvPqk.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $e5b99cab3fa7a544$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $dvPqk.useContext($e5b99cab3fa7a544$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $dvPqk.useState(false);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $e5b99cab3fa7a544$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $dvPqk.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $e5b99cab3fa7a544$var$rafId = 0;
function $e5b99cab3fa7a544$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($e5b99cab3fa7a544$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $e5b99cab3fa7a544$var$rafId = requestAnimationFrame(exec);
}
function $e5b99cab3fa7a544$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $gI3vG.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $e5b99cab3fa7a544$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $e5b99cab3fa7a544$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const $e5b99cab3fa7a544$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $e5b99cab3fa7a544$var$getCounterMap(control) {
    if (control === 'inert') return $e5b99cab3fa7a544$var$counters.inert;
    if (control === 'aria-hidden') return $e5b99cab3fa7a544$var$counters['aria-hidden'];
    return $e5b99cab3fa7a544$var$counters.none;
}
let $e5b99cab3fa7a544$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $e5b99cab3fa7a544$var$markerMap = {};
let $e5b99cab3fa7a544$var$lockCount$1 = 0;
const $e5b99cab3fa7a544$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
const $e5b99cab3fa7a544$var$unwrapHost = (node)=>node && (node.host || $e5b99cab3fa7a544$var$unwrapHost(node.parentNode));
const $e5b99cab3fa7a544$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $e5b99cab3fa7a544$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $e5b99cab3fa7a544$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $e5b99cab3fa7a544$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$e5b99cab3fa7a544$var$markerMap[markerName]) $e5b99cab3fa7a544$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $e5b99cab3fa7a544$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $gI3vG.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterMap = $e5b99cab3fa7a544$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $e5b99cab3fa7a544$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $e5b99cab3fa7a544$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = $e5b99cab3fa7a544$var$getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$e5b99cab3fa7a544$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $e5b99cab3fa7a544$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $e5b99cab3fa7a544$var$lockCount$1--;
        if (!$e5b99cab3fa7a544$var$lockCount$1) {
            $e5b99cab3fa7a544$var$counters.inert = new WeakMap();
            $e5b99cab3fa7a544$var$counters['aria-hidden'] = new WeakMap();
            $e5b99cab3fa7a544$var$counters.none = new WeakMap();
            $e5b99cab3fa7a544$var$uncontrolledElementsSet = new WeakSet();
            $e5b99cab3fa7a544$var$markerMap = {};
        }
    };
}
function $e5b99cab3fa7a544$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $e5b99cab3fa7a544$var$getDocument(avoidElements[0]).body;
    return $e5b99cab3fa7a544$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const $e5b99cab3fa7a544$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const $e5b99cab3fa7a544$var$FocusGuard = /*#__PURE__*/ $dvPqk.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $dvPqk.useState();
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if ((0, $5dAgE.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$e5b99cab3fa7a544$var$createAttribute('focus-guard')]: '',
        style: $e5b99cab3fa7a544$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
        ...props,
        ...restProps
    });
});
const $e5b99cab3fa7a544$var$PortalContext = /*#__PURE__*/ $dvPqk.createContext(null);
const $e5b99cab3fa7a544$var$attr = /*#__PURE__*/ $e5b99cab3fa7a544$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $e5b99cab3fa7a544$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $e5b99cab3fa7a544$export$f680877a34711e37();
    const portalContext = $e5b99cab3fa7a544$var$usePortalContext();
    const [portalNode, setPortalNode] = $dvPqk.useState(null);
    const portalNodeRef = $dvPqk.useRef(null);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($e5b99cab3fa7a544$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $gI3vG.isNode)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($e5b99cab3fa7a544$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $e5b99cab3fa7a544$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $e5b99cab3fa7a544$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $dvPqk.useState(null);
    const beforeOutsideRef = $dvPqk.useRef(null);
    const afterOutsideRef = $dvPqk.useRef(null);
    const beforeInsideRef = $dvPqk.useRef(null);
    const afterInsideRef = $dvPqk.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $dvPqk.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $5dAgE.isOutsideEvent)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, $5dAgE.enableFocusInside) : (0, $5dAgE.disableFocusInside);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $dvPqk.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $5dAgE.enableFocusInside)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)($e5b99cab3fa7a544$var$PortalContext.Provider, {
        value: $dvPqk.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $5dAgE.isOutsideEvent)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $5dAgE.getPreviousTabbable)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $e5b99cab3fa7a544$var$HIDDEN_STYLES
            }),
            portalNode && /*#__PURE__*/ $im7eH.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $5dAgE.isOutsideEvent)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $5dAgE.getNextTabbable)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const $e5b99cab3fa7a544$var$usePortalContext = ()=>$dvPqk.useContext($e5b99cab3fa7a544$var$PortalContext);
function $e5b99cab3fa7a544$var$useLiteMergeRefs(refs) {
    return $dvPqk.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $e5b99cab3fa7a544$var$LIST_LIMIT = 20;
let $e5b99cab3fa7a544$var$previouslyFocusedElements = [];
function $e5b99cab3fa7a544$var$clearDisconnectedPreviouslyFocusedElements() {
    $e5b99cab3fa7a544$var$previouslyFocusedElements = $e5b99cab3fa7a544$var$previouslyFocusedElements.filter((el)=>el.isConnected);
}
function $e5b99cab3fa7a544$var$addPreviouslyFocusedElement(element) {
    $e5b99cab3fa7a544$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $gI3vG.getNodeName)(element) !== 'body') {
        $e5b99cab3fa7a544$var$previouslyFocusedElements.push(element);
        if ($e5b99cab3fa7a544$var$previouslyFocusedElements.length > $e5b99cab3fa7a544$var$LIST_LIMIT) $e5b99cab3fa7a544$var$previouslyFocusedElements = $e5b99cab3fa7a544$var$previouslyFocusedElements.slice(-20);
    }
}
function $e5b99cab3fa7a544$var$getPreviouslyFocusedElement() {
    $e5b99cab3fa7a544$var$clearDisconnectedPreviouslyFocusedElements();
    return $e5b99cab3fa7a544$var$previouslyFocusedElements[$e5b99cab3fa7a544$var$previouslyFocusedElements.length - 1];
}
function $e5b99cab3fa7a544$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $5dAgE.getTabbableOptions)();
    if ((0, $4504l.isTabbable)(container, tabbableOptions)) return container;
    return (0, $4504l.tabbable)(container, tabbableOptions)[0] || container;
}
function $e5b99cab3fa7a544$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, $5dAgE.getTabbableOptions)();
    const focusableElements = (0, $4504l.focusable)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $4504l.isTabbable)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const $e5b99cab3fa7a544$var$VisuallyHiddenDismiss = /*#__PURE__*/ $dvPqk.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $e5b99cab3fa7a544$var$HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $e5b99cab3fa7a544$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $5dAgE.useEffectEvent)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $5dAgE.useEffectEvent)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $5dAgE.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $e5b99cab3fa7a544$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $5dAgE.useLatestRef)(order);
    const initialFocusRef = (0, $5dAgE.useLatestRef)(initialFocus);
    const returnFocusRef = (0, $5dAgE.useLatestRef)(returnFocus);
    const tree = $e5b99cab3fa7a544$export$db0c2a7c7a2a4f69();
    const portalContext = $e5b99cab3fa7a544$var$usePortalContext();
    const startDismissButtonRef = $dvPqk.useRef(null);
    const endDismissButtonRef = $dvPqk.useRef(null);
    const preventReturnFocusRef = $dvPqk.useRef(false);
    const isPointerDownRef = $dvPqk.useRef(false);
    const tabbableIndexRef = $dvPqk.useRef(-1);
    const blurTimeoutRef = $dvPqk.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $5dAgE.getFloatingFocusElement)(floating);
    const getTabbableContent = (0, $5dAgE.useEffectEvent)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $4504l.tabbable)(container, (0, $5dAgE.getTabbableOptions)()) : [];
    });
    const getTabbableElements = (0, $5dAgE.useEffectEvent)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $dvPqk.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $5dAgE.contains)(floatingFocusElement, (0, $5dAgE.activeElement)((0, $5dAgE.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $5dAgE.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $5dAgE.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $5dAgE.stopEvent)(event);
                    if (event.shiftKey) $e5b99cab3fa7a544$var$enqueueFocus(els[els.length - 1]);
                    else $e5b99cab3fa7a544$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $5dAgE.stopEvent)(event);
                    $e5b99cab3fa7a544$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $5dAgE.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $dvPqk.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $5dAgE.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $dvPqk.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $5dAgE.getTarget)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $5dAgE.contains)(domReference, relatedTarget) || (0, $5dAgE.contains)(floating, relatedTarget) || (0, $5dAgE.contains)(relatedTarget, floating) || (0, $5dAgE.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($e5b99cab3fa7a544$var$createAttribute('focus-guard')) || tree && ((0, $5dAgE.getNodeChildren)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $5dAgE.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $5dAgE.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $5dAgE.getNodeAncestors)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $5dAgE.getFloatingFocusElement)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $e5b99cab3fa7a544$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $5dAgE.activeElement)((0, $5dAgE.getDocument)(floatingFocusElement)) === (0, $5dAgE.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $gI3vG.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $gI3vG.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $e5b99cab3fa7a544$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $gI3vG.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = $dvPqk.useRef(null);
    const afterGuardRef = $dvPqk.useRef(null);
    const mergedBeforeGuardRef = $e5b99cab3fa7a544$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $e5b99cab3fa7a544$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $dvPqk.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $e5b99cab3fa7a544$var$createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, $5dAgE.getNodeAncestors)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, $5dAgE.isTypeableCombobox)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $e5b99cab3fa7a544$var$markOthers(insideElements, !useInert, useInert) : $e5b99cab3fa7a544$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (disabled || !(0, $gI3vG.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $5dAgE.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $5dAgE.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $5dAgE.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $e5b99cab3fa7a544$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, $5dAgE.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $5dAgE.activeElement)(doc);
        $e5b99cab3fa7a544$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $5dAgE.isVirtualClick)(event) || (0, $5dAgE.isVirtualPointerEvent)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $e5b99cab3fa7a544$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || $e5b99cab3fa7a544$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $5dAgE.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $5dAgE.contains)(floating, activeEl) || tree && (0, $5dAgE.getNodeChildren)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, $5dAgE.contains)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $e5b99cab3fa7a544$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $gI3vG.isHTMLElement)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $dvPqk.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask($e5b99cab3fa7a544$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $e5b99cab3fa7a544$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $e5b99cab3fa7a544$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $5dAgE.isOutsideEvent)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $5dAgE.getNextTabbable)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $7YWoO.jsx)($e5b99cab3fa7a544$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $e5b99cab3fa7a544$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $5dAgE.isOutsideEvent)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $5dAgE.getPreviousTabbable)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $e5b99cab3fa7a544$var$lockCount = 0;
const $e5b99cab3fa7a544$var$scrollbarProperty = '--floating-ui-scrollbar-width';
function $e5b99cab3fa7a544$var$enableScrollLock() {
    const platform = (0, $5dAgE.getPlatform)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty($e5b99cab3fa7a544$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        bodyStyle.removeProperty($e5b99cab3fa7a544$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $e5b99cab3fa7a544$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $e5b99cab3fa7a544$export$a35954495955337b = /*#__PURE__*/ $dvPqk.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!lockScroll) return;
        $e5b99cab3fa7a544$var$lockCount++;
        if ($e5b99cab3fa7a544$var$lockCount === 1) $e5b99cab3fa7a544$var$cleanup = $e5b99cab3fa7a544$var$enableScrollLock();
        return ()=>{
            $e5b99cab3fa7a544$var$lockCount--;
            if ($e5b99cab3fa7a544$var$lockCount === 0) $e5b99cab3fa7a544$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function $e5b99cab3fa7a544$var$isButtonTarget(event) {
    return (0, $gI3vG.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function $e5b99cab3fa7a544$var$isAnchorTarget(event) {
    return (0, $gI3vG.isHTMLElement)(event.target) && event.target.tagName === 'A';
}
function $e5b99cab3fa7a544$var$isSpaceIgnored(element) {
    return (0, $5dAgE.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $e5b99cab3fa7a544$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $dvPqk.useRef();
    const didKeyDownRef = $dvPqk.useRef(false);
    const reference = $dvPqk.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $5dAgE.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $5dAgE.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $e5b99cab3fa7a544$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$e5b99cab3fa7a544$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($e5b99cab3fa7a544$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $e5b99cab3fa7a544$var$isButtonTarget(event) || $e5b99cab3fa7a544$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $e5b99cab3fa7a544$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $e5b99cab3fa7a544$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $e5b99cab3fa7a544$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $dvPqk.useRef(false);
    const cleanupListenerRef = $dvPqk.useRef(null);
    const [pointerType, setPointerType] = $dvPqk.useState();
    const [reactive, setReactive] = $dvPqk.useState([]);
    const setReference = (0, $5dAgE.useEffectEvent)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$e5b99cab3fa7a544$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($e5b99cab3fa7a544$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $5dAgE.useEffectEvent)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $5dAgE.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $dvPqk.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $gI3vG.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $5dAgE.getTarget)(event);
            if (!(0, $5dAgE.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $e5b99cab3fa7a544$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $dvPqk.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $dvPqk.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $dvPqk.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $dvPqk.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $e5b99cab3fa7a544$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $e5b99cab3fa7a544$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $e5b99cab3fa7a544$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $e5b99cab3fa7a544$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $e5b99cab3fa7a544$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $5dAgE.useEffectEvent)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = $dvPqk.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $e5b99cab3fa7a544$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $e5b99cab3fa7a544$var$normalizeProp(capture);
    const isComposingRef = $dvPqk.useRef(false);
    const closeOnEscapeKeyDown = (0, $5dAgE.useEffectEvent)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $5dAgE.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $5dAgE.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, $5dAgE.useEffectEvent)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $5dAgE.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $5dAgE.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, $5dAgE.useEffectEvent)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $5dAgE.getTarget)(event);
        const inertSelector = "[" + $e5b99cab3fa7a544$var$createAttribute('inert') + "]";
        const markers = (0, $5dAgE.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $gI3vG.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $gI3vG.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $gI3vG.getParentNode)(targetRootAncestor);
            if ((0, $gI3vG.isLastTraversableNode)(nextParent) || !(0, $gI3vG.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $gI3vG.isElement)(target) && !(0, $5dAgE.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $5dAgE.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $5dAgE.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $gI3vG.isHTMLElement)(target) && floating) {
            const lastTraversableNode = (0, $gI3vG.isLastTraversableNode)(target);
            const style = (0, $gI3vG.getComputedStyle)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $5dAgE.getNodeChildren)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $5dAgE.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $5dAgE.isEventTargetWithin)(event, elements.floating) || (0, $5dAgE.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $5dAgE.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, $5dAgE.useEffectEvent)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $5dAgE.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $5dAgE.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $dvPqk.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $gI3vG.isWebKit)() ? 5 : 0);
        }
        const doc = (0, $5dAgE.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $gI3vG.isElement)(elements.domReference)) ancestors = (0, $gI3vG.getOverflowAncestors)(elements.domReference);
            if ((0, $gI3vG.isElement)(elements.floating)) ancestors = ancestors.concat((0, $gI3vG.getOverflowAncestors)(elements.floating));
            if (!(0, $gI3vG.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $gI3vG.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $dvPqk.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $dvPqk.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [$e5b99cab3fa7a544$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, 'reference-press');
                },
                ...referencePressEvent !== 'click' && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, 'reference-press');
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $dvPqk.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$e5b99cab3fa7a544$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $e5b99cab3fa7a544$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $e5b99cab3fa7a544$export$f680877a34711e37();
    const dataRef = $dvPqk.useRef({});
    const [events] = $dvPqk.useState(()=>$e5b99cab3fa7a544$var$createEventEmitter());
    const nested = $e5b99cab3fa7a544$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $dvPqk.useState(elementsProp.reference);
    const onOpenChange = (0, $5dAgE.useEffectEvent)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $dvPqk.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $dvPqk.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $dvPqk.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $e5b99cab3fa7a544$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $e5b99cab3fa7a544$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $dvPqk.useState(null);
    const [positionReference, _setPositionReference] = $dvPqk.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $dvPqk.useRef(null);
    const tree = $e5b99cab3fa7a544$export$db0c2a7c7a2a4f69();
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $2sXUk.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $dvPqk.useCallback((node)=>{
        const computedPositionReference = (0, $gI3vG.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $dvPqk.useCallback((node)=>{
        if ((0, $gI3vG.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $gI3vG.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $gI3vG.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $dvPqk.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $dvPqk.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $dvPqk.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $dvPqk.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $e5b99cab3fa7a544$var$isMacSafari() {
    return (0, $5dAgE.isMac)() && (0, $5dAgE.isSafari)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $e5b99cab3fa7a544$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $dvPqk.useRef(false);
    const timeoutRef = $dvPqk.useRef(-1);
    const keyboardModalityRef = $dvPqk.useRef(true);
    $dvPqk.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $gI3vG.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $gI3vG.isHTMLElement)(elements.domReference) && elements.domReference === (0, $5dAgE.activeElement)((0, $5dAgE.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($e5b99cab3fa7a544$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if ($e5b99cab3fa7a544$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $dvPqk.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $dvPqk.useEffect(()=>{
        return ()=>{
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $dvPqk.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $5dAgE.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $gI3vG.isElement)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($e5b99cab3fa7a544$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $5dAgE.isTypeableElement)(target)) return;
                    } else if (!(0, $5dAgE.matchesFocusVisible)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $gI3vG.isElement)(relatedTarget) && relatedTarget.hasAttribute($e5b99cab3fa7a544$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $5dAgE.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $5dAgE.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $5dAgE.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $e5b99cab3fa7a544$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$e5b99cab3fa7a544$var$ACTIVE_KEY]: _, [$e5b99cab3fa7a544$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [$e5b99cab3fa7a544$var$FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $e5b99cab3fa7a544$var$ACTIVE_KEY,
                    $e5b99cab3fa7a544$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $e5b99cab3fa7a544$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $dvPqk.useCallback((userProps)=>$e5b99cab3fa7a544$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $dvPqk.useCallback((userProps)=>$e5b99cab3fa7a544$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $dvPqk.useCallback((userProps)=>$e5b99cab3fa7a544$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $dvPqk.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $e5b99cab3fa7a544$var$ESCAPE = 'Escape';
function $e5b99cab3fa7a544$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $e5b99cab3fa7a544$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $e5b99cab3fa7a544$var$ARROW_UP || key === $e5b99cab3fa7a544$var$ARROW_DOWN;
    const horizontal = key === $e5b99cab3fa7a544$var$ARROW_LEFT || key === $e5b99cab3fa7a544$var$ARROW_RIGHT;
    return $e5b99cab3fa7a544$var$doSwitch(orientation, vertical, horizontal);
}
function $e5b99cab3fa7a544$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $e5b99cab3fa7a544$var$ARROW_DOWN;
    const horizontal = rtl ? key === $e5b99cab3fa7a544$var$ARROW_LEFT : key === $e5b99cab3fa7a544$var$ARROW_RIGHT;
    return $e5b99cab3fa7a544$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $e5b99cab3fa7a544$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $e5b99cab3fa7a544$var$ARROW_LEFT : key === $e5b99cab3fa7a544$var$ARROW_RIGHT;
    const horizontal = key === $e5b99cab3fa7a544$var$ARROW_DOWN;
    return $e5b99cab3fa7a544$var$doSwitch(orientation, vertical, horizontal);
}
function $e5b99cab3fa7a544$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $e5b99cab3fa7a544$var$ARROW_RIGHT : key === $e5b99cab3fa7a544$var$ARROW_LEFT;
    const horizontal = key === $e5b99cab3fa7a544$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $e5b99cab3fa7a544$var$ESCAPE;
    return $e5b99cab3fa7a544$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $e5b99cab3fa7a544$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $5dAgE.getFloatingFocusElement)(elements.floating);
    const floatingFocusElementRef = (0, $5dAgE.useLatestRef)(floatingFocusElement);
    const parentId = $e5b99cab3fa7a544$export$165209eae06d3488();
    const tree = $e5b99cab3fa7a544$export$db0c2a7c7a2a4f69();
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $5dAgE.useEffectEvent)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $5dAgE.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = $dvPqk.useRef(focusItemOnOpen);
    const indexRef = $dvPqk.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $dvPqk.useRef(null);
    const isPointerModalityRef = $dvPqk.useRef(true);
    const previousOnNavigateRef = $dvPqk.useRef(onNavigate);
    const previousMountedRef = $dvPqk.useRef(!!elements.floating);
    const previousOpenRef = $dvPqk.useRef(open);
    const forceSyncFocusRef = $dvPqk.useRef(false);
    const forceScrollIntoViewRef = $dvPqk.useRef(false);
    const disabledIndicesRef = (0, $5dAgE.useLatestRef)(disabledIndices);
    const latestOpenRef = (0, $5dAgE.useLatestRef)(open);
    const scrollItemIntoViewRef = (0, $5dAgE.useLatestRef)(scrollItemIntoView);
    const selectedIndexRef = (0, $5dAgE.useLatestRef)(selectedIndex);
    const [activeId, setActiveId] = $dvPqk.useState();
    const [virtualId, setVirtualId] = $dvPqk.useState();
    const focusItem = (0, $5dAgE.useEffectEvent)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $e5b99cab3fa7a544$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $e5b99cab3fa7a544$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $5dAgE.getMinListIndex)(listRef, disabledIndicesRef.current) : (0, $5dAgE.getMaxListIndex)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $5dAgE.isIndexOutOfListBounds)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $5dAgE.activeElement)((0, $5dAgE.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $5dAgE.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $dvPqk.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget: currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType: pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $dvPqk.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $5dAgE.useEffectEvent)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $e5b99cab3fa7a544$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$e5b99cab3fa7a544$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $5dAgE.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $gI3vG.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $5dAgE.getMinListIndex)(listRef, disabledIndices);
        const maxIndex = (0, $5dAgE.getMaxListIndex)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $5dAgE.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $5dAgE.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $5dAgE.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $5dAgE.isListIndexDisabled)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $5dAgE.isListIndexDisabled)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $5dAgE.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $5dAgE.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index)=>(0, $5dAgE.isListIndexDisabled)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $5dAgE.getGridCellIndexOfCorner)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $e5b99cab3fa7a544$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $e5b99cab3fa7a544$var$ARROW_LEFT : $e5b99cab3fa7a544$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($e5b99cab3fa7a544$var$isMainOrientationKey(event.key, orientation)) {
            (0, $5dAgE.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $5dAgE.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $e5b99cab3fa7a544$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($e5b99cab3fa7a544$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $5dAgE.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $5dAgE.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $5dAgE.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $5dAgE.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $5dAgE.isIndexOutOfListBounds)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $dvPqk.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $dvPqk.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $dvPqk.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $5dAgE.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $5dAgE.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $e5b99cab3fa7a544$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $e5b99cab3fa7a544$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $e5b99cab3fa7a544$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $e5b99cab3fa7a544$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $5dAgE.getDeepestNode)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $5dAgE.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $5dAgE.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $e5b99cab3fa7a544$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $5dAgE.stopEvent)(event);
                        if (open) {
                            indexRef.current = (0, $5dAgE.getMinListIndex)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $5dAgE.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $e5b99cab3fa7a544$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $e5b99cab3fa7a544$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const defaultReferenceId = $e5b99cab3fa7a544$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $dvPqk.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $5dAgE.getFloatingFocusElement)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $e5b99cab3fa7a544$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $e5b99cab3fa7a544$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $dvPqk.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $dvPqk.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $dvPqk.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return {
                    ...commonProps,
                    'aria-selected': selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $e5b99cab3fa7a544$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $e5b99cab3fa7a544$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $e5b99cab3fa7a544$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $dvPqk.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $dvPqk.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $e5b99cab3fa7a544$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $dvPqk.useState('unmounted');
    const isMounted = $e5b99cab3fa7a544$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $im7eH.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $e5b99cab3fa7a544$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $dvPqk.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $dvPqk.useState(()=>({
            ...$e5b99cab3fa7a544$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$e5b99cab3fa7a544$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $e5b99cab3fa7a544$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $5dAgE.useLatestRef)(unstable_initial);
    const openRef = (0, $5dAgE.useLatestRef)(unstable_open);
    const closeRef = (0, $5dAgE.useLatestRef)(unstable_close);
    const commonRef = (0, $5dAgE.useLatestRef)(unstable_common);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        const initialStyles = $e5b99cab3fa7a544$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $e5b99cab3fa7a544$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $e5b99cab3fa7a544$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $e5b99cab3fa7a544$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($e5b99cab3fa7a544$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($e5b99cab3fa7a544$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $e5b99cab3fa7a544$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $dvPqk.useRef(-1);
    const stringRef = $dvPqk.useRef('');
    const prevIndexRef = $dvPqk.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $dvPqk.useRef(null);
    const onMatch = (0, $5dAgE.useEffectEvent)(unstable_onMatch);
    const onTypingChange = (0, $5dAgE.useEffectEvent)(unstable_onTypingChange);
    const findMatchRef = (0, $5dAgE.useLatestRef)(findMatch);
    const ignoreKeysRef = (0, $5dAgE.useLatestRef)(ignoreKeys);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        if (open) {
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $5dAgE.useModernLayoutEffect)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $5dAgE.useEffectEvent)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $5dAgE.useEffectEvent)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $5dAgE.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $5dAgE.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $dvPqk.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $dvPqk.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $e5b99cab3fa7a544$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $e5b99cab3fa7a544$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $cZP7r.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $2sXUk.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $3cSFY.detectOverflow)($e5b99cab3fa7a544$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $3cSFY.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, $cZP7r.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $cZP7r.round);
            const maxHeight = rounder((0, $cZP7r.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $cZP7r.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $cZP7r.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $im7eH.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $3cSFY.detectOverflow)($e5b99cab3fa7a544$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $e5b99cab3fa7a544$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $5dAgE.useEffectEvent)(unstable_onChange);
    const controlledScrollingRef = $dvPqk.useRef(false);
    const prevScrollTopRef = $dvPqk.useRef(null);
    const initialOverflowRef = $dvPqk.useRef(null);
    $dvPqk.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $im7eH.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $5dAgE.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $dvPqk.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $im7eH.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $dvPqk.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $e5b99cab3fa7a544$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$e5b99cab3fa7a544$var$getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function $e5b99cab3fa7a544$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $e5b99cab3fa7a544$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $e5b99cab3fa7a544$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $e5b99cab3fa7a544$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $e5b99cab3fa7a544$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $e5b99cab3fa7a544$var$contains(elements.floating, target);
            const isOverReferenceEl = $e5b99cab3fa7a544$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $e5b99cab3fa7a544$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $gI3vG.isElement)(event.relatedTarget) && $e5b99cab3fa7a544$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $e5b99cab3fa7a544$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($e5b99cab3fa7a544$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$e5b99cab3fa7a544$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("5dAgE", function(module, exports) {

$parcel$export(module.exports, "getPlatform", function () { return $3d15ad243be857fa$export$867a782338812cb4; });
$parcel$export(module.exports, "getUserAgent", function () { return $3d15ad243be857fa$export$7935961ef7719cb0; });
$parcel$export(module.exports, "isSafari", function () { return $3d15ad243be857fa$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isMac", function () { return $3d15ad243be857fa$export$9ac100e40613ea10; });
$parcel$export(module.exports, "activeElement", function () { return $3d15ad243be857fa$export$da980962bd2147a4; });
$parcel$export(module.exports, "contains", function () { return $3d15ad243be857fa$export$2344b14b097df817; });
$parcel$export(module.exports, "getTarget", function () { return $3d15ad243be857fa$export$c22522a4dfa48e9c; });
$parcel$export(module.exports, "isEventTargetWithin", function () { return $3d15ad243be857fa$export$43c3154d5bf2c6c2; });
$parcel$export(module.exports, "isRootElement", function () { return $3d15ad243be857fa$export$7b296c28e0fa3aed; });
$parcel$export(module.exports, "getDocument", function () { return $3d15ad243be857fa$export$f65ca476c09acec0; });
$parcel$export(module.exports, "isTypeableElement", function () { return $3d15ad243be857fa$export$42ad131c32f0fb8d; });
$parcel$export(module.exports, "isTypeableCombobox", function () { return $3d15ad243be857fa$export$259ba5ae38188551; });
$parcel$export(module.exports, "matchesFocusVisible", function () { return $3d15ad243be857fa$export$65750043c2fb2f40; });
$parcel$export(module.exports, "getFloatingFocusElement", function () { return $3d15ad243be857fa$export$9b0901b5e9b45fc7; });
$parcel$export(module.exports, "getNodeChildren", function () { return $3d15ad243be857fa$export$1f1998cc3c6b56fb; });
$parcel$export(module.exports, "getDeepestNode", function () { return $3d15ad243be857fa$export$e7e88d43cb97db79; });
$parcel$export(module.exports, "getNodeAncestors", function () { return $3d15ad243be857fa$export$5d8eb345316b65c0; });
$parcel$export(module.exports, "stopEvent", function () { return $3d15ad243be857fa$export$7ae4cd3a66c1e050; });
$parcel$export(module.exports, "isReactEvent", function () { return $3d15ad243be857fa$export$94781ce41a161222; });
$parcel$export(module.exports, "isVirtualClick", function () { return $3d15ad243be857fa$export$60278871457622de; });
$parcel$export(module.exports, "isVirtualPointerEvent", function () { return $3d15ad243be857fa$export$29bf1b5f2c56cf63; });
$parcel$export(module.exports, "isMouseLikePointerType", function () { return $3d15ad243be857fa$export$81cf264172d31e51; });
$parcel$export(module.exports, "useModernLayoutEffect", function () { return $3d15ad243be857fa$export$bb3b3b3acfd7447f; });
$parcel$export(module.exports, "useLatestRef", function () { return $3d15ad243be857fa$export$bcd07ba85a740103; });
$parcel$export(module.exports, "useEffectEvent", function () { return $3d15ad243be857fa$export$7f54fc3180508a52; });
$parcel$export(module.exports, "isIndexOutOfListBounds", function () { return $3d15ad243be857fa$export$75effb89758ec596; });
$parcel$export(module.exports, "getMinListIndex", function () { return $3d15ad243be857fa$export$53f691ee0acc6058; });
$parcel$export(module.exports, "findNonDisabledListIndex", function () { return $3d15ad243be857fa$export$3fc3ea4a67cf714; });
$parcel$export(module.exports, "getMaxListIndex", function () { return $3d15ad243be857fa$export$b585558af466e926; });
$parcel$export(module.exports, "isListIndexDisabled", function () { return $3d15ad243be857fa$export$446656ed0410fd9; });
$parcel$export(module.exports, "getGridNavigatedIndex", function () { return $3d15ad243be857fa$export$342fcce33a2688bc; });
$parcel$export(module.exports, "createGridCellMap", function () { return $3d15ad243be857fa$export$5334c96856356f08; });
$parcel$export(module.exports, "getGridCellIndexOfCorner", function () { return $3d15ad243be857fa$export$dab2b2ce7761f8e4; });
$parcel$export(module.exports, "getGridCellIndices", function () { return $3d15ad243be857fa$export$50d8709b2ccc23f9; });
$parcel$export(module.exports, "getTabbableOptions", function () { return $3d15ad243be857fa$export$6324a2bbae6a332f; });
$parcel$export(module.exports, "getNextTabbable", function () { return $3d15ad243be857fa$export$28f33206776129a7; });
$parcel$export(module.exports, "getPreviousTabbable", function () { return $3d15ad243be857fa$export$2e5518c3303f364a; });
$parcel$export(module.exports, "isOutsideEvent", function () { return $3d15ad243be857fa$export$6e0c4e272f3faa2; });
$parcel$export(module.exports, "disableFocusInside", function () { return $3d15ad243be857fa$export$3995dd353b80da11; });
$parcel$export(module.exports, "enableFocusInside", function () { return $3d15ad243be857fa$export$a65f4028abb17f36; });

var $gI3vG = parcelRequire("gI3vG");

var $dvPqk = parcelRequire("dvPqk");

var $cZP7r = parcelRequire("cZP7r");

var $4504l = parcelRequire("4504l");
// Avoid Chrome DevTools blue warning.
function $3d15ad243be857fa$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $3d15ad243be857fa$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $3d15ad243be857fa$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $3d15ad243be857fa$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($3d15ad243be857fa$export$867a782338812cb4()) || re.test($3d15ad243be857fa$export$7935961ef7719cb0());
}
function $3d15ad243be857fa$export$9ac100e40613ea10() {
    return $3d15ad243be857fa$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $3d15ad243be857fa$export$c8f880a2d81914c4() {
    return $3d15ad243be857fa$export$7935961ef7719cb0().includes('jsdom/');
}
const $3d15ad243be857fa$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $3d15ad243be857fa$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $3d15ad243be857fa$var$ARROW_LEFT = 'ArrowLeft';
const $3d15ad243be857fa$var$ARROW_RIGHT = 'ArrowRight';
const $3d15ad243be857fa$var$ARROW_UP = 'ArrowUp';
const $3d15ad243be857fa$var$ARROW_DOWN = 'ArrowDown';
function $3d15ad243be857fa$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $3d15ad243be857fa$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $gI3vG.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $3d15ad243be857fa$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $3d15ad243be857fa$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $3d15ad243be857fa$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $3d15ad243be857fa$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $3d15ad243be857fa$export$42ad131c32f0fb8d(element) {
    return (0, $gI3vG.isHTMLElement)(element) && element.matches($3d15ad243be857fa$var$TYPEABLE_SELECTOR);
}
function $3d15ad243be857fa$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $3d15ad243be857fa$export$42ad131c32f0fb8d(element);
}
function $3d15ad243be857fa$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $3d15ad243be857fa$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $3d15ad243be857fa$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($3d15ad243be857fa$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $3d15ad243be857fa$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $3d15ad243be857fa$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$3d15ad243be857fa$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $3d15ad243be857fa$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $3d15ad243be857fa$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $3d15ad243be857fa$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3d15ad243be857fa$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $3d15ad243be857fa$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $3d15ad243be857fa$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($3d15ad243be857fa$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $3d15ad243be857fa$export$29bf1b5f2c56cf63(event) {
    if ($3d15ad243be857fa$export$c8f880a2d81914c4()) return false;
    return !$3d15ad243be857fa$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $3d15ad243be857fa$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $3d15ad243be857fa$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $3d15ad243be857fa$var$isClient = typeof document !== 'undefined';
var $3d15ad243be857fa$var$noop = function noop() {};
var $3d15ad243be857fa$export$bb3b3b3acfd7447f = $3d15ad243be857fa$var$isClient ? (0, $dvPqk.useLayoutEffect) : $3d15ad243be857fa$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $3d15ad243be857fa$var$SafeReact = {
    ...$dvPqk
};
function $3d15ad243be857fa$export$bcd07ba85a740103(value) {
    const ref = $dvPqk.useRef(value);
    $3d15ad243be857fa$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $3d15ad243be857fa$var$useInsertionEffect = $3d15ad243be857fa$var$SafeReact.useInsertionEffect;
const $3d15ad243be857fa$var$useSafeInsertionEffect = $3d15ad243be857fa$var$useInsertionEffect || ((fn)=>fn());
function $3d15ad243be857fa$export$7f54fc3180508a52(callback) {
    const ref = $dvPqk.useRef(()=>{});
    $3d15ad243be857fa$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $dvPqk.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $3d15ad243be857fa$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3d15ad243be857fa$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3d15ad243be857fa$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3d15ad243be857fa$export$b585558af466e926(listRef, disabledIndices) {
    return $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $3d15ad243be857fa$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $3d15ad243be857fa$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $3d15ad243be857fa$var$ARROW_UP) {
        stop && $3d15ad243be857fa$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($3d15ad243be857fa$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $3d15ad243be857fa$var$ARROW_DOWN) {
        stop && $3d15ad243be857fa$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($3d15ad243be857fa$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $cZP7r.floor)(prevIndex / cols);
        if (event.key === (rtl ? $3d15ad243be857fa$var$ARROW_LEFT : $3d15ad243be857fa$var$ARROW_RIGHT)) {
            stop && $3d15ad243be857fa$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $3d15ad243be857fa$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($3d15ad243be857fa$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $3d15ad243be857fa$var$ARROW_RIGHT : $3d15ad243be857fa$var$ARROW_LEFT)) {
            stop && $3d15ad243be857fa$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $3d15ad243be857fa$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($3d15ad243be857fa$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $cZP7r.floor)(maxIndex / cols) === prevRow;
        if ($3d15ad243be857fa$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $3d15ad243be857fa$var$ARROW_RIGHT : $3d15ad243be857fa$var$ARROW_LEFT) ? maxIndex : $3d15ad243be857fa$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $3d15ad243be857fa$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $3d15ad243be857fa$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $3d15ad243be857fa$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $3d15ad243be857fa$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const $3d15ad243be857fa$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $3d15ad243be857fa$var$getTabbableIn(container, dir) {
    const list = (0, $4504l.tabbable)(container, $3d15ad243be857fa$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $3d15ad243be857fa$export$da980962bd2147a4($3d15ad243be857fa$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $3d15ad243be857fa$export$28f33206776129a7(referenceElement) {
    return $3d15ad243be857fa$var$getTabbableIn($3d15ad243be857fa$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $3d15ad243be857fa$export$2e5518c3303f364a(referenceElement) {
    return $3d15ad243be857fa$var$getTabbableIn($3d15ad243be857fa$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $3d15ad243be857fa$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$3d15ad243be857fa$export$2344b14b097df817(containerElement, relatedTarget);
}
function $3d15ad243be857fa$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $4504l.tabbable)(container, $3d15ad243be857fa$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $3d15ad243be857fa$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}

});
parcelRegister("4504l", function(module, exports) {

$parcel$export(module.exports, "getTabIndex", function () { return $2f87aec23cdc7c74$export$a4672efddb4181b8; });
$parcel$export(module.exports, "tabbable", function () { return $2f87aec23cdc7c74$export$17100aea90429aa7; });
$parcel$export(module.exports, "focusable", function () { return $2f87aec23cdc7c74$export$ecc6d1fcdff4f700; });
$parcel$export(module.exports, "isTabbable", function () { return $2f87aec23cdc7c74$export$bebd5a1431fec25d; });
$parcel$export(module.exports, "isFocusable", function () { return $2f87aec23cdc7c74$export$4c063cf1350e6fed; });
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $2f87aec23cdc7c74$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $2f87aec23cdc7c74$var$candidateSelector = /* #__PURE__ */ $2f87aec23cdc7c74$var$candidateSelectors.join(',');
var $2f87aec23cdc7c74$var$NoElement = typeof Element === 'undefined';
var $2f87aec23cdc7c74$var$matches = $2f87aec23cdc7c74$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $2f87aec23cdc7c74$var$getRootNode = !$2f87aec23cdc7c74$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $2f87aec23cdc7c74$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $2f87aec23cdc7c74$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $2f87aec23cdc7c74$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($2f87aec23cdc7c74$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($2f87aec23cdc7c74$var$candidateSelector));
    if (includeContainer && $2f87aec23cdc7c74$var$matches.call(el, $2f87aec23cdc7c74$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $2f87aec23cdc7c74$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($2f87aec23cdc7c74$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $2f87aec23cdc7c74$var$matches.call(element, $2f87aec23cdc7c74$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$2f87aec23cdc7c74$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $2f87aec23cdc7c74$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $2f87aec23cdc7c74$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $2f87aec23cdc7c74$var$isContentEditable(node)) && !$2f87aec23cdc7c74$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $2f87aec23cdc7c74$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $2f87aec23cdc7c74$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$2f87aec23cdc7c74$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $2f87aec23cdc7c74$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $2f87aec23cdc7c74$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $2f87aec23cdc7c74$var$isHiddenInput = function isHiddenInput(node) {
    return $2f87aec23cdc7c74$var$isInput(node) && node.type === 'hidden';
};
var $2f87aec23cdc7c74$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $2f87aec23cdc7c74$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $2f87aec23cdc7c74$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $2f87aec23cdc7c74$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $2f87aec23cdc7c74$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $2f87aec23cdc7c74$var$isRadio = function isRadio(node) {
    return $2f87aec23cdc7c74$var$isInput(node) && node.type === 'radio';
};
var $2f87aec23cdc7c74$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $2f87aec23cdc7c74$var$isRadio(node) && !$2f87aec23cdc7c74$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $2f87aec23cdc7c74$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $2f87aec23cdc7c74$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $2f87aec23cdc7c74$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $2f87aec23cdc7c74$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $2f87aec23cdc7c74$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $2f87aec23cdc7c74$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($2f87aec23cdc7c74$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $2f87aec23cdc7c74$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $2f87aec23cdc7c74$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($2f87aec23cdc7c74$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $2f87aec23cdc7c74$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $2f87aec23cdc7c74$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $2f87aec23cdc7c74$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $2f87aec23cdc7c74$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $2f87aec23cdc7c74$var$isInert(node) || $2f87aec23cdc7c74$var$isHiddenInput(node) || $2f87aec23cdc7c74$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $2f87aec23cdc7c74$var$isDetailsWithSummary(node) || $2f87aec23cdc7c74$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $2f87aec23cdc7c74$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($2f87aec23cdc7c74$var$isNonTabbableRadio(node) || $2f87aec23cdc7c74$export$a4672efddb4181b8(node) < 0 || !$2f87aec23cdc7c74$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $2f87aec23cdc7c74$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $2f87aec23cdc7c74$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $2f87aec23cdc7c74$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($2f87aec23cdc7c74$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $2f87aec23cdc7c74$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $2f87aec23cdc7c74$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $2f87aec23cdc7c74$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $2f87aec23cdc7c74$var$isValidShadowRootTabbable
    });
    else candidates = $2f87aec23cdc7c74$var$getCandidates(container, options.includeContainer, $2f87aec23cdc7c74$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $2f87aec23cdc7c74$var$sortByOrder(candidates);
};
var $2f87aec23cdc7c74$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $2f87aec23cdc7c74$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $2f87aec23cdc7c74$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $2f87aec23cdc7c74$var$getCandidates(container, options.includeContainer, $2f87aec23cdc7c74$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $2f87aec23cdc7c74$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($2f87aec23cdc7c74$var$matches.call(node, $2f87aec23cdc7c74$var$candidateSelector) === false) return false;
    return $2f87aec23cdc7c74$var$isNodeMatchingSelectorTabbable(options, node);
};
var $2f87aec23cdc7c74$var$focusableCandidateSelector = /* #__PURE__ */ $2f87aec23cdc7c74$var$candidateSelectors.concat('iframe').join(',');
var $2f87aec23cdc7c74$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($2f87aec23cdc7c74$var$matches.call(node, $2f87aec23cdc7c74$var$focusableCandidateSelector) === false) return false;
    return $2f87aec23cdc7c74$var$isNodeMatchingSelectorFocusable(options, node);
};

});





parcelRegister("03mes", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2e66addc0f9babd$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $hGi4c = parcelRequire("hGi4c");

var $jvljM = parcelRequire("jvljM");

var $ioVMT = parcelRequire("ioVMT");

var $fZZFo = parcelRequire("fZZFo");

var $gwaiZ = parcelRequire("gwaiZ");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $f2e66addc0f9babd$var$mapLabelTextColor = (label)=>{
    if (label.color === "red") return "var(--color-tine-red-600)";
    if (label.color === "blue") return "var(--color-tine-blue-500)";
    if (label.color === "green") return "var(--color-forest-green-900)";
    if (label.color === "gray") return "var(--color-base-700)";
    if (label.color === "moss") return "var(--color-moss-green-900)";
    return "var(--color-base-700)";
};
const $f2e66addc0f9babd$var$LabelComponent = ({ label: label })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
        variant: "base",
        textColor: $f2e66addc0f9babd$var$mapLabelTextColor(label),
        children: label.text
    });
};
const $f2e66addc0f9babd$var$positionStyles = {
    "top-left": "left-0 top-0",
    "top-right": "right-0 top-0",
    "bottom-left": "left-0 bottom-2",
    "bottom-right": "right-0 bottom-2"
};
const $f2e66addc0f9babd$var$Labels = ({ labels: labels, page: page, className: className = "" })=>{
    const relevantLabels = (0, $jvljM.default)(labels.filter((l)=>(0, $ioVMT.default)(l.page, page)), "position");
    if ((0, $gwaiZ.default)(relevantLabels) === 0) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: (0, $fZZFo.default)(relevantLabels, (labels, position)=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: `absolute flex flex-col ${$f2e66addc0f9babd$var$positionStyles[position]} ${className}`,
                children: labels.map((label, index)=>/*#__PURE__*/ (0, $7YWoO.jsx)($f2e66addc0f9babd$var$LabelComponent, {
                        label: label
                    }, `${label.text}${index + 1}`))
            }, position))
    });
};
var $f2e66addc0f9babd$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f2e66addc0f9babd$var$Labels);

});
parcelRegister("fZZFo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba5c6339a4d7897c$export$2e2bcd8739ae039; });

var $dqScn = parcelRequire("dqScn");

var $aIIzU = parcelRequire("aIIzU");

var $3DdyA = parcelRequire("3DdyA");

var $hCd6c = parcelRequire("hCd6c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $ba5c6339a4d7897c$var$map(collection, iteratee) {
    var func = (0, $hCd6c.default)(collection) ? (0, $dqScn.default) : (0, $3DdyA.default);
    return func(collection, (0, $aIIzU.default)(iteratee, 3));
}
var $ba5c6339a4d7897c$export$2e2bcd8739ae039 = $ba5c6339a4d7897c$var$map;

});


parcelRegister("3muLR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4077bd0d42f46b86$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $bEEBX = parcelRequire("bEEBX");

var $aQzCo = parcelRequire("aQzCo");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $5OqMf = parcelRequire("5OqMf");
const $4077bd0d42f46b86$var$PricePerItem = ({ product: product, className: className = "" })=>{
    const amount = product.unit === "STK" || (0, $bEEBX.default)(product?.conversionFactor) || !(0, $aQzCo.default)(product.conversionFactor) ? 1 : product.conversionFactor;
    const baseUnit = (0, $5OqMf.translateBaseUnit)(product.baseUnit, amount);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: className,
        children: [
            amount.toFixed(0),
            " ",
            baseUnit,
            " ",
            !(0, $bEEBX.default)(product.price) ? `\xe1 ${(0, $5OqMf.formatPrice)(product.price / amount)}` : ""
        ]
    });
};
var $4077bd0d42f46b86$export$2e2bcd8739ae039 = (0, $gBcml.observer)($4077bd0d42f46b86$var$PricePerItem);

});

parcelRegister("f7kjZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0434a4ae04473584$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
const $0434a4ae04473584$var$PriceBomb = ({ size: size, children: children })=>{
    const priceBombClasses = "flex aspect-square rounded-[50%] absolute bg-promotion text-base-0 font-semibold text-center justify-center items-center cursor-default";
    const priceBombSize = {
        small: "w-[36%] max-w-24 bottom-5 left-[10%] p-1 text-xs",
        large: "w-[30%] max-w-40 bottom-[10%] left-[10%] p-5 text-2xl"
    }[size];
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: (0, $izjX7.cn)(priceBombClasses, priceBombSize),
        children: children
    });
};
var $0434a4ae04473584$export$2e2bcd8739ae039 = $0434a4ae04473584$var$PriceBomb;

});



parcelRegister("4r4cM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03ecd93eed2d03ab$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $ezbi8 = parcelRequire("ezbi8");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $6fuyt = parcelRequire("6fuyt");

var $cLLe3 = parcelRequire("cLLe3");
const $03ecd93eed2d03ab$var$ErrorAlertWithOptionalTracking = ({ title: title, show: show = true, fullWidth: fullWidth, maxWidth: maxWidth, showCloseButton: showCloseButton, cta: cta, ctaText: ctaText, ariaLive: ariaLive, onClose: onClose, onRetry: onRetry, gaErrorTracking: gaErrorTracking, className: className, children: children })=>{
    (0, $dvPqk.useEffect)(()=>{
        show && gaErrorTracking && (0, $6fuyt.sendErrorMessage)(gaErrorTracking);
    }, [
        show
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $ezbi8.Alert), {
        variant: "error",
        title: title,
        show: show,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        showCloseButton: showCloseButton,
        cta: cta,
        ctaText: ctaText,
        ariaLive: ariaLive,
        onClose: onClose,
        className: className,
        children: [
            children,
            onRetry && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                variant: "secondary",
                size: "compact",
                className: "mt-2 block",
                onClick: onRetry,
                children: "Pr\xf8v p\xe5 nytt?"
            })
        ]
    });
};
var $03ecd93eed2d03ab$export$2e2bcd8739ae039 = (0, $gBcml.observer)($03ecd93eed2d03ab$var$ErrorAlertWithOptionalTracking);

});
parcelRegister("ezbi8", function(module, exports) {

$parcel$export(module.exports, "Alert", function () { return $a9ad17ce106d3c0c$export$caec2af78bcc877f; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $4rjCr = parcelRequire("4rjCr");

var $7gQuG = parcelRequire("7gQuG");

var $gfKH3 = parcelRequire("gfKH3");

var $b5EqG = parcelRequire("b5EqG");

var $8ynNM = parcelRequire("8ynNM");

var $3njAg = parcelRequire("3njAg");

var $50k7Y = parcelRequire("50k7Y");
function $a9ad17ce106d3c0c$var$m({ iconVariant: n, CustomIcon: a }) {
    const e = "w-7 flex-shrink-0";
    if (a) return /* @__PURE__ */ (0, $7YWoO.jsx)(a, {
        className: e
    });
    switch(n){
        case "information":
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $gfKH3.default), {
                className: (0, $6sMuH.cn)(e, "fill-information-600")
            });
        case "error":
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $50k7Y.default), {
                className: (0, $6sMuH.cn)(e, "fill-error-600")
            });
        case "warning":
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $3njAg.default), {
                className: (0, $6sMuH.cn)(e, "fill-warning-600")
            });
        case "success":
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $8ynNM.default), {
                className: (0, $6sMuH.cn)(e, "fill-success-600")
            });
        case "tip":
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $b5EqG.default), {
                className: e
            });
        default:
            return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $gfKH3.default), {
                className: e
            });
    }
}
function $a9ad17ce106d3c0c$export$caec2af78bcc877f({ children: n, title: a, variant: e = "information", ariaLive: f = "polite", customIcon: i, fullWidth: s = !1, show: u = !0, showCloseButton: d = !0, onClose: g, maxWidth: p, cta: o, className: x, ctaText: N }) {
    const b = {
        information: "bg-surface-information",
        warning: "bg-surface-warning",
        error: "bg-surface-error",
        success: "bg-surface-success",
        tip: "bg-surface-tip rounded-lg"
    }[e];
    return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: u ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
            "aria-live": f,
            className: (0, $6sMuH.cn)("p-4 flex @container rounded", b, s ? "max-w-none" : "max-w-[500px]", x),
            children: /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: "flex flex-col gap-4 mx-auto w-full",
                style: s ? void 0 : {
                    maxWidth: p
                },
                children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                    className: "flex gap-x-2 items-start w-full",
                    children: [
                        i ? /* @__PURE__ */ (0, $7YWoO.jsx)($a9ad17ce106d3c0c$var$m, {
                            CustomIcon: i
                        }) : /* @__PURE__ */ (0, $7YWoO.jsx)($a9ad17ce106d3c0c$var$m, {
                            iconVariant: e
                        }),
                        /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                            className: "flex flex-col gap-y-2",
                            children: [
                                a ? /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                                    className: "mb-0 font-semibold text-regular leading-normal @sm:text-lg",
                                    children: a
                                }) : null,
                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    className: "text-base leading-normal",
                                    children: n
                                }),
                                o ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                                        href: o,
                                        children: N
                                    })
                                }) : null
                            ]
                        }),
                        d ? /* @__PURE__ */ (0, $7YWoO.jsx)("button", {
                            "aria-label": "Lukk",
                            className: "p-0 ml-auto bg-transparent border-none cursor-pointer fill-ink-brand-default",
                            onClick: g,
                            type: "button",
                            children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $7gQuG.default), {})
                        }) : null
                    ]
                })
            })
        }) : null
    });
}
$a9ad17ce106d3c0c$export$caec2af78bcc877f.displayName = "Alert";

});
parcelRegister("4rjCr", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $33b8e6fd67c8eb51$export$a6c7ac8248d6e38a; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
function $33b8e6fd67c8eb51$export$a6c7ac8248d6e38a({ href: t = "", variant: s = "default", children: a, icon: e = null, iconPosition: n = "right", noUnderline: o = !1, className: d, as: i = "a", ...u }) {
    const f = {
        default: "text-link-default *:fill-text-ink-brand-default",
        inverted: "hover:text-link-default-inverted-hover *:fill-link-inverted text-link-inverted *:hover:fill-link-inverted-hover"
    }[s], v = i === "a", l = !!e;
    return /* @__PURE__ */ (0, $7YWoO.jsx)(i, {
        href: t,
        ...u,
        className: (0, $6sMuH.cn)(// common
        "rounded underline-offset-2 underline hover:no-underline", // focus
        "focus-visible:ring-2  focus-visible:ring-information-600 focus-visible:outline-none", f, v && "inline-flex items-center flex-wrap", // for hasIcon
        l && "gap-x-1 no-underline hover:!underline", // for noUnderline
        o && "no-underline hover:!no-underline", // for override
        d),
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("span", {
            className: (0, $6sMuH.cn)(l && "[&>svg]:size-5 [&>svg]:inline"),
            children: [
                n === "left" ? e : null,
                a,
                n === "right" ? e : null
            ]
        })
    });
}
$33b8e6fd67c8eb51$export$a6c7ac8248d6e38a.displayName = "Link";

});

parcelRegister("7gQuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54b2bf34a4b4ad4a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $54b2bf34a4b4ad4a$export$2e2bcd8739ae039 = (l)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, l, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M5.7 20 4 18.3l6.3-6.3L4 5.7 5.7 4l6.3 6.3L18.3 4 20 5.7 13.7 12l6.3 6.3-1.7 1.7-6.3-6.3z"
        })
    }));

});

parcelRegister("b5EqG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $812f85bf0d8fa03e$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $812f85bf0d8fa03e$export$2e2bcd8739ae039 = (l)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, l, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            fillRule: "evenodd",
            d: "M22.5 10.874a5.256 5.256 0 0 0-5.747-5.226 5.25 5.25 0 0 0-9.508 0A5.25 5.25 0 0 0 4.5 15.616v5.759H19.5v-1.841h-.002v-3.917a5.26 5.26 0 0 0 3-4.743m-4.5 9H6v-3.805a5 5 0 0 0 .75.055h10.5a5 5 0 0 0 .75-.055zm-.75-5.25h-1.29l.517-2.068a.75.75 0 0 0-1.455-.364l-.609 2.432H12.75v-2.25a.75.75 0 1 0-1.5 0v2.25H9.585l-.608-2.432a.75.75 0 1 0-1.455.364l.516 2.068H6.75a3.75 3.75 0 0 1 0-7.5h.055a5 5 0 0 0-.055.75.75.75 0 0 0 1.5 0 3.75 3.75 0 0 1 7.5 0 .75.75 0 1 0 1.5 0q0-.377-.054-.75h.054a3.75 3.75 0 1 1 0 7.5",
            clipRule: "evenodd"
        })
    }));

});

parcelRegister("8ynNM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63a3f63ecb8cc7d3$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $63a3f63ecb8cc7d3$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m10.805 15.375 5.578-5.555-1.195-1.195-4.383 4.36-1.992-1.97-1.196 1.196zM12 21a8.8 8.8 0 0 1-3.492-.703 9.1 9.1 0 0 1-2.871-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 12q0-1.875.703-3.504a9.072 9.072 0 0 1 4.805-4.793A8.8 8.8 0 0 1 12 3q1.875 0 3.504.703a9.1 9.1 0 0 1 4.793 4.793A8.75 8.75 0 0 1 21 12a8.8 8.8 0 0 1-.703 3.492 9.07 9.07 0 0 1-4.793 4.805A8.75 8.75 0 0 1 12 21m0-1.687q3.047 0 5.18-2.133T19.313 12 17.18 6.82 12 4.687 6.82 6.82 4.687 12t2.133 5.18T12 19.313"
        })
    }));

});

parcelRegister("3njAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2752b607169b3815$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $2752b607169b3815$export$2e2bcd8739ae039 = (i)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, i, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M1.2 21 12 3l10.8 18zm3.175-1.8h15.25L12 6.5zm7.62-1.2a.88.88 0 0 0 .643-.257.86.86 0 0 0 .262-.638.88.88 0 0 0-.257-.643.86.86 0 0 0-.638-.262.88.88 0 0 0-.643.257.86.86 0 0 0-.262.638q0 .38.257.643a.86.86 0 0 0 .638.262m-.895-3h1.8v-4.8h-1.8z"
        })
    }));

});

parcelRegister("50k7Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a4c90bd1c755347$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $3a4c90bd1c755347$export$2e2bcd8739ae039 = (r)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, r, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M12 16.821a.93.93 0 0 0 .683-.28.93.93 0 0 0 .281-.684.93.93 0 0 0-.281-.683.93.93 0 0 0-.683-.281.93.93 0 0 0-.683.281.93.93 0 0 0-.281.683.93.93 0 0 0 .281.683.93.93 0 0 0 .683.281m-.964-3.535h1.928V6.857h-1.928zM8.276 21 3 15.696v-7.42L8.277 3h7.446L21 8.277v7.446L15.696 21zm.804-1.929h5.84l4.151-4.151V9.08L14.893 4.93H9.08L4.93 9.08v5.84z"
        })
    }));

});



parcelRegister("ca824", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c1296fabe718452$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $i4tzf = parcelRequire("i4tzf");

var $dvPqk = parcelRequire("dvPqk");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $65KWP = parcelRequire("65KWP");

var $jlTfJ = parcelRequire("jlTfJ");
const $6c1296fabe718452$var$PromotionTeaser = ({ article: article, imagePosition: imagePosition })=>{
    const [image, setImage] = (0, $dvPqk.useState)();
    const id = article.sys.id;
    const title = article.fields.title || "";
    const description = article.fields.preface || "";
    const ctaLabel = article.fields.callToActionSubTitle || article.fields.title || "";
    const urlData = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.id === id);
    const url = `/${urlData?.fullUrl}`;
    const teaserImage = article.fields.headerImage;
    const contentType = article.sys.contentType.sys.id;
    (0, $dvPqk.useEffect)(()=>{
        const fetchImage = async ()=>{
            if (teaserImage.fields && (0, $jlTfJ.default).isPreviewMode) {
                const image = (0, $65KWP.fromContentToImageWithFocus)(teaserImage);
                setImage(image);
            } else {
                const imageWithFocus = await (0, $jlTfJ.default).getImageWithFocusUsingCache(teaserImage.sys.id);
                setImage(imageWithFocus);
            }
        };
        fetchImage();
    }, [
        id
    ]);
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(title, contentType);
    };
    const { ref: viewRef } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ref: viewRef,
        className: "relative",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: "relative py-8 lg:py-10",
            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $i4tzf.SectionCard), {
                title: title,
                description: description,
                image: image?.originalAssetUrl,
                imageAlt: title,
                ctaLabel: ctaLabel,
                href: url,
                linkComponent: (0, $8kt8E.Link),
                backgroundColor: "transparent",
                buttonVariant: "primary",
                isImageFlipped: imagePosition === "Right",
                className: "[&_strong]:font-semibold",
                onCtaClick: ()=>(0, $6fuyt.sendSelectTeaser)(title, contentType, undefined, url),
                defaultTagVariant: "information"
            })
        })
    });
};
var $6c1296fabe718452$export$2e2bcd8739ae039 = $6c1296fabe718452$var$PromotionTeaser;

});
parcelRegister("i4tzf", function(module, exports) {

$parcel$export(module.exports, "SectionCard", function () { return $d27f89354f7f2f7e$export$69ed894a7932b604; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $hGi4c = parcelRequire("hGi4c");

var $4rjCr = parcelRequire("4rjCr");
const $d27f89354f7f2f7e$var$o = (l, d, s = !1)=>typeof l > "u" ? "" : typeof l == "string" && s ? l : typeof l == "object" ? l[d] ?? "" : "";
function $d27f89354f7f2f7e$export$69ed894a7932b604({ title: l, description: d, image: s, imageAlt: j, backgroundColor: g = "transparent", isImageFlipped: k = !1, tags: u, defaultTagVariant: w = "base", defaultTagProps: y, className: n, linkComponent: b = "a", headingLevel: z = "h2", // New button props
primaryCtaLabel: h, primaryCtaHref: $, onPrimaryCtaClick: C, secondaryCtaLabel: m, secondaryCtaHref: E, onSecondaryCtaClick: N, // Legacy props (for backward compatibility)
href: P, ctaLabel: x, onCtaClick: T, buttonVariant: V = "secondary", ...A }) {
    const H = g !== "transparent", q = {
        white: "bg-surface-default",
        transparent: "bg-base-transparent"
    }[g], v = (0, $6sMuH.cn)(// Colors
    "text-button-primary-text bg-button-primary-bg fill-button-primary-text", // Border
    "border-button-primary-bg", // Hover
    "hover:bg-button-primary-bg-hover hover:border-button-primary-bg-hover"), B = (0, $6sMuH.cn)(// Colors
    "text-button-secondary-text bg-button-secondary-bg fill-button-secondary-text", // Border
    "border-button-secondary-border", // Hover
    "hover:bg-button-secondary-bg-hover hover:border-button-secondary-border"), D = {
        primary: v,
        secondary: B
    }[V], F = ()=>!u || u.length === 0 ? null : /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
            className: (0, $6sMuH.cn)("flex gap-x-2", $d27f89354f7f2f7e$var$o(n, "tags")),
            children: u.map((t, i)=>{
                if (!t) return null;
                if ((0, $dvPqk.isValidElement)(t)) return (0, $dvPqk.cloneElement)(t, {
                    key: `tag-${i}`
                });
                if (typeof t == "string") return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
                    variant: w,
                    ...y || {},
                    children: t
                }, `tag-${i}`);
                const { text: c, ...a } = t;
                return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
                    ...y || {},
                    ...a,
                    children: c
                }, `tag-${i}`);
            })
        }), G = ()=>{
        const t = !!h, i = !!m, c = !!x && !t && !i;
        if (!t && !i && !c) return null;
        const a = (0, $6sMuH.cn)("text-base px-button-regular-padding-x py-button-regular-padding-y [&>svg]:w-[20px] [&>svg]:h-[20px] [&>svg]:-m-1", // focus
        "focus-visible:ring-2 focus-visible:ring-information-600 focus-visible:outline-none", // Disabled
        "disabled:text-ink-disabled disabled:border-button-disabled-bg disabled:bg-button-disabled-bg disabled:cursor-not-allowed disabled:no-underline [&>svg]:disabled:fill-ink-disabled", // Base
        "cursor-pointer leading-none border-2 no-underline rounded-button inline-flex justify-center items-center gap-x-2");
        return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
            className: (0, $6sMuH.cn)("flex gap-x-3 items-center", $d27f89354f7f2f7e$var$o(n, "buttons")),
            children: [
                c ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                    as: b,
                    className: (0, $6sMuH.cn)(a, D, $d27f89354f7f2f7e$var$o(n, "cta")),
                    href: P,
                    onClick: T,
                    children: x
                }) : null,
                i ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                    as: b,
                    className: (0, $6sMuH.cn)(a, B, $d27f89354f7f2f7e$var$o(n, "secondaryButton")),
                    href: E,
                    onClick: N,
                    children: m
                }) : null,
                t ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                    as: b,
                    className: (0, $6sMuH.cn)(a, v, $d27f89354f7f2f7e$var$o(n, "primaryButton")),
                    href: $,
                    onClick: C,
                    children: h
                }) : null
            ]
        });
    }, I = z;
    return /* @__PURE__ */ (0, $7YWoO.jsx)("article", {
        className: (0, $6sMuH.cn)("rounded-card-lg overflow-clip @container", q, $d27f89354f7f2f7e$var$o(n, "container", !0)),
        ...A,
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
            className: (0, $6sMuH.cn)("grid grid-cols-12 gap-5 size-full ring "),
            children: [
                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                    className: (0, $6sMuH.cn)("col-span-full aspect-video @xl:col-span-6 size-full relative bg-base-50", k ? "@xl:order-1" : "order-0", !H && "rounded-card-lg overflow-clip", $d27f89354f7f2f7e$var$o(n, "image")),
                    children: typeof s == "string" ? /* @__PURE__ */ (0, $7YWoO.jsx)("img", {
                        alt: j,
                        className: "size-full inset-0 absolute object-cover",
                        src: s
                    }) : /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "w-full h-full",
                        children: s
                    })
                }),
                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                    className: (0, $6sMuH.cn)("flex col-span-full @xl:col-span-6 flex-col gap-4 items-start justify-center", $d27f89354f7f2f7e$var$o(n, "content")),
                    children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                        className: "p-4 @2xl:p-10 space-y-8",
                        children: [
                            l ? /* @__PURE__ */ (0, $7YWoO.jsx)(I, {
                                className: (0, $6sMuH.cn)("text-2xl text-ink-brand-default m-0 line-clamp-2 @xl:line-clamp-3", $d27f89354f7f2f7e$var$o(n, "title")),
                                children: /* @__PURE__ */ (0, $7YWoO.jsx)("strong", {
                                    children: l
                                })
                            }) : null,
                            F(),
                            d ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                className: (0, $6sMuH.cn)("line-clamp-2 @xl:line-clamp-4", $d27f89354f7f2f7e$var$o(n, "description")),
                                children: d
                            }) : null,
                            G()
                        ]
                    })
                })
            ]
        })
    });
}
$d27f89354f7f2f7e$export$69ed894a7932b604.displayName = "SectionCard";

});

parcelRegister("65KWP", function(module, exports) {

$parcel$export(module.exports, "generateSizesFromMaxSize", function () { return $8ceb1819142c2c8b$export$3d30e9e7288ed7df; });
$parcel$export(module.exports, "createSourceSet", function () { return $8ceb1819142c2c8b$export$3616ab55478d910c; });
$parcel$export(module.exports, "fromContentToImageWithFocus", function () { return $8ceb1819142c2c8b$export$6a348164eb36c90f; });
$parcel$export(module.exports, "createCloudinaryUrl", function () { return $8ceb1819142c2c8b$export$48ff2bc8d8787a91; });

var $aQzCo = parcelRequire("aQzCo");
var $gyNqR = parcelRequire("gyNqR");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");
const $8ceb1819142c2c8b$export$3d30e9e7288ed7df = (xxlWidth, xxlHeight)=>{
    const result = [];
    const aspectRatio = xxlHeight / xxlWidth;
    const fullWidth = 1250;
    const breakpointMobile = 995;
    const breakpointLowest = 580;
    // Size for xxl desktop users
    result.push({
        minWidth: fullWidth,
        width: xxlWidth,
        height: xxlHeight
    });
    // This is usually images transition into full width regardless of layout
    result.push({
        maxWidth: fullWidth,
        minWidth: breakpointLowest,
        width: Math.ceil(xxlWidth * (breakpointMobile / fullWidth)),
        height: Math.ceil(xxlHeight * (breakpointMobile / fullWidth))
    });
    // Fallback for small browsers under 500 px width
    result.push({
        width: breakpointLowest,
        height: Math.ceil(breakpointLowest * aspectRatio)
    });
    return result;
};
const $8ceb1819142c2c8b$export$6365b86438881493 = (imageSpec)=>{
    const queryParts = [];
    if ((0, $aQzCo.default)(imageSpec.minWidth)) queryParts.push(`(min-width: ${imageSpec.minWidth}px)`);
    if ((0, $aQzCo.default)(imageSpec.maxWidth)) queryParts.push(`(max-width: ${imageSpec.maxWidth}px)`);
    return queryParts.join(" and ");
};
const $8ceb1819142c2c8b$export$3616ab55478d910c = (imageSpecs, urlFactory)=>imageSpecs.map((imageSpec)=>({
            width: imageSpec.width,
            height: imageSpec.height,
            media: $8ceb1819142c2c8b$export$6365b86438881493(imageSpec),
            url: urlFactory(imageSpec.width, imageSpec.height)
        })).filter((item)=>(0, $gyNqR.default)(item.url));
const $8ceb1819142c2c8b$export$6a348164eb36c90f = (image)=>{
    if (!image.fields.image || !image.fields.altText || !image.fields.focalPoint) return undefined;
    const focalPoint = image.fields.focalPoint;
    return {
        entryId: image.sys.id,
        altText: image.fields.altText,
        focalPoint: focalPoint.focalPoint,
        originalAssetUrl: image.fields.image.fields.file?.url
    };
};
const $8ceb1819142c2c8b$export$48ff2bc8d8787a91 = (image, width, height, cloudinaryMapping)=>{
    const validWidth = Math.round(width);
    const validHeight = Math.round(height);
    if (image.focalPoint === null) (0, $gtsdT.logger).warn("utils", `Focal point is null, using default focal point for image ${image.entryId}`);
    const validFocalPointX = image.focalPoint !== null ? Math.round(image.focalPoint.x) : validWidth / 2;
    const validFocalPointY = image.focalPoint !== null ? Math.round(image.focalPoint.y) : validHeight / 2;
    const cloudiaryBaseUrl = "https://res.cloudinary.com/tine-products/image/upload";
    const transformations = `c_fill,g_xy_center,w_${validWidth},h_${validHeight},x_${validFocalPointX},y_${validFocalPointY}/f_auto`;
    const filepath = image.originalAssetUrl?.replace(`//images.ctfassets.net/${(0, $8ZCSm.CONTENTFUL_SPACE)}/`, "");
    return `${cloudiaryBaseUrl}/${transformations}/${cloudinaryMapping}/${filepath}`;
};

});



parcelRegister("hgKgU", function(module, exports) {

$parcel$export(module.exports, "PREVIEW_BASE_PATH", function () { return $0021dea44d42b77d$export$d4e7cf85e830c084; });
$parcel$export(module.exports, "contentfulClient", function () { return $0021dea44d42b77d$export$ee2b5e97418a314d; });
$parcel$export(module.exports, "getArticleSlugsAndParents", function () { return $0021dea44d42b77d$export$171d8f79e64c6d2f; });
$parcel$export(module.exports, "getRecipeSlugsAndParents", function () { return $0021dea44d42b77d$export$a50050b167ee2170; });
$parcel$export(module.exports, "getAdventCalendarSlotSlugsAndParents", function () { return $0021dea44d42b77d$export$be4137f029255acf; });
$parcel$export(module.exports, "getArticlesInSection", function () { return $0021dea44d42b77d$export$d97409d13691926a; });
$parcel$export(module.exports, "getRecipesInSection", function () { return $0021dea44d42b77d$export$e14ac9e865c02e78; });
$parcel$export(module.exports, "getFooterContent", function () { return $0021dea44d42b77d$export$16c696b382a4600b; });
$parcel$export(module.exports, "getSectionsSlugsAndParents", function () { return $0021dea44d42b77d$export$b8a8005a743c0044; });
$parcel$export(module.exports, "getFullContent", function () { return $0021dea44d42b77d$export$e6200fd9e8db94e2; });
$parcel$export(module.exports, "getUnprocessedUrlDataFromContent", function () { return $0021dea44d42b77d$export$2096e465e0ecc233; });
$parcel$export(module.exports, "generateFullUrl", function () { return $0021dea44d42b77d$export$67a343b63f37e37f; });
$parcel$export(module.exports, "getWarnings", function () { return $0021dea44d42b77d$export$86d329c847012ae2; });
$parcel$export(module.exports, "createMenuItem", function () { return $0021dea44d42b77d$export$9acd0d4601f4f0b7; });
$parcel$export(module.exports, "getProductCategoryContent", function () { return $0021dea44d42b77d$export$386c9ce4f0639b92; });
$parcel$export(module.exports, "sortSectionContentEntries", function () { return $0021dea44d42b77d$export$7675d887dbe15262; });

var $547r2 = parcelRequire("547r2");

var $3xOZa = parcelRequire("3xOZa");

var $8ZCSm = parcelRequire("8ZCSm");
const $0021dea44d42b77d$export$d4e7cf85e830c084 = "_preview";
const $0021dea44d42b77d$export$ee2b5e97418a314d = (isPreviewMode)=>isPreviewMode ? (0, $547r2.createClient)({
        host: "preview.contentful.com",
        space: (0, $8ZCSm.CONTENTFUL_SPACE) ?? "",
        accessToken: (0, $8ZCSm.CONTENTFUL_PREVIEWTOKEN) ?? "",
        environment: (0, $8ZCSm.CONTENTFUL_ENV)
    }) : (0, $547r2.createClient)({
        space: (0, $8ZCSm.CONTENTFUL_SPACE) ?? "",
        accessToken: (0, $8ZCSm.CONTENTFUL_READTOKEN) ?? "",
        environment: (0, $8ZCSm.CONTENTFUL_ENV)
    });
const $0021dea44d42b77d$export$171d8f79e64c6d2f = (isPreviewMode)=>$0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "v2_article",
        select: [
            "sys.contentType",
            "metadata.tags",
            "fields.title",
            "fields.slug",
            "fields.parentId",
            "fields.excludeSegments",
            "fields.includeSegments",
            "fields.visibleInSections"
        ],
        include: 1,
        limit: 1000
    }).then((response)=>response.items);
const $0021dea44d42b77d$export$a50050b167ee2170 = (isPreviewMode)=>$0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "recipe",
        select: [
            "sys.contentType",
            "metadata.tags",
            "fields.title",
            "fields.slug",
            "fields.parentId",
            "fields.visibleInSections"
        ],
        include: 1,
        limit: 1000
    }).then((response)=>response.items);
const $0021dea44d42b77d$export$be4137f029255acf = (isPreviewMode)=>$0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "adventCalendarSlot",
        select: [
            "sys.contentType",
            "metadata.tags",
            "fields.title",
            "fields.slug",
            "fields.parentId"
        ],
        include: 1,
        limit: 1000
    }).then((response)=>response.items);
const $0021dea44d42b77d$export$d97409d13691926a = (sectionId, isPreviewMode)=>$0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).getEntries({
        content_type: "v2_article",
        "fields.visibleInSections": sectionId,
        select: [
            "fields.title",
            "fields.callToAction",
            "fields.callToActionSubTitle",
            "fields.preface",
            "fields.headerImage",
            "fields.orderPriority",
            "sys.contentType"
        ],
        include: 0
    }).then((response)=>response.items);
const $0021dea44d42b77d$export$e14ac9e865c02e78 = (sectionId, isPreviewMode)=>$0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).getEntries({
        content_type: "recipe",
        "fields.visibleInSections": sectionId,
        select: [
            "fields.title",
            "fields.recipeData",
            "fields.orderPriority",
            "sys.contentType"
        ],
        include: 0
    }).then((response)=>response.items);
const $0021dea44d42b77d$export$16c696b382a4600b = (isPreviewMode)=>$0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "footer",
        select: [
            "fields.contactNumber",
            "fields.columnCustomerServiceLabel",
            "fields.openingHours",
            "fields.linksRichText",
            "fields.column2label",
            "fields.column2links",
            "fields.column3label",
            "fields.column3links",
            "fields.column4label",
            "fields.column4links",
            "fields.termsAndConditions"
        ],
        include: 1,
        limit: 1
    }).then((response)=>response.items);
const $0021dea44d42b77d$export$b8a8005a743c0044 = (isPreviewMode)=>$0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "v2_section",
        select: [
            "sys.contentType",
            "metadata.tags",
            "fields.title",
            "fields.slug",
            "fields.parentId",
            "fields.description",
            "fields.icon"
        ],
        include: 0
    }).then((response)=>response.items);
const $0021dea44d42b77d$var$_buildFullUrlFromParent = (page)=>{
    const parent = page.fields.parent;
    const slug = page.fields.slug;
    return parent ? `${$0021dea44d42b77d$var$_buildFullUrlFromParent(parent)}/${slug}` : slug;
};
const $0021dea44d42b77d$var$isArticleContent = (content)=>{
    if (!content) return false;
    return content.sys.type === "Entry" && content.sys.contentType.sys.id === "v2_article";
};
const $0021dea44d42b77d$var$isListContent = (content)=>{
    if (!content) return false;
    return content.sys.type === "Entry" && content.sys.contentType.sys.id === "callToActionList";
};
const $0021dea44d42b77d$var$isTextAndImageContent = (content)=>{
    if (!content) return false;
    return content.sys.type === "Entry" && content.sys.contentType.sys.id === "v2_textAndImage";
};
// Recursively goes through a deep content object and clears the body property for all entries beyond a certain level of "fields" properties.
const $0021dea44d42b77d$var$removeBodyBeyondNeededLevel = (content)=>{
    for (const child of content.fields.body.content){
        // If the embedded entry is a list, we need to check each included item
        if (child.nodeType === "embedded-entry-block") {
            const embeddedEntry = child.data.target;
            // If the embedded entry is an article, we don't need body to actually show teaser
            if ($0021dea44d42b77d$var$isArticleContent(embeddedEntry)) embeddedEntry.fields.body.content = [];
            // If the embedded entry is a list, we need to check each item in the list and remove any bodies inside articles
            if ($0021dea44d42b77d$var$isListContent(embeddedEntry) && embeddedEntry.fields.contentList) {
                for (const listItem of embeddedEntry.fields.contentList)if ($0021dea44d42b77d$var$isArticleContent(listItem)) listItem.fields.body.content = [];
            }
            // If the embedded entry is a text and image content, we need to check its paragraphs and remove bodies from linked articles
            if ($0021dea44d42b77d$var$isTextAndImageContent(embeddedEntry) && embeddedEntry.fields.text) {
                const paragraphs = embeddedEntry.fields.text.content.filter((item)=>item.nodeType === "paragraph");
                for (const paragraphEntry of paragraphs)$0021dea44d42b77d$var$removeBodyFromLinksInParagraphs(paragraphEntry.content);
            }
        }
        // If the child is a paragraph, we need to check for links and remove bodies from linked articles
        if (child.nodeType === "paragraph") $0021dea44d42b77d$var$removeBodyFromLinksInParagraphs(child.content);
    }
    return content;
};
const $0021dea44d42b77d$var$removeBodyFromLinksInParagraphs = (block)=>{
    const links = block.filter((c)=>c.nodeType === "entry-hyperlink");
    for (const link of links)if (link.data?.target && $0021dea44d42b77d$var$isArticleContent(link.data.target)) link.data.target.fields.body.content = [];
};
const $0021dea44d42b77d$export$e6200fd9e8db94e2 = async (id, isPreviewMode)=>{
    const content = await $0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).getEntry(id, {
        include: 3
    });
    if ($0021dea44d42b77d$var$isArticleContent(content)) $0021dea44d42b77d$var$removeBodyBeyondNeededLevel(content);
    return content;
};
const $0021dea44d42b77d$export$10119ba01bac6d8c = async (ids, isPreviewMode)=>{
    const entries = await $0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "v2_article",
        "sys.id[in]": ids
    });
    return entries.items;
};
const $0021dea44d42b77d$export$ebf01906f5b403d8 = async (ids, isPreviewMode)=>{
    const entries = await $0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).getEntries({
        content_type: "recipe",
        "sys.id[in]": ids
    });
    return entries.items;
};
const $0021dea44d42b77d$export$2096e465e0ecc233 = (content)=>{
    const baseData = {
        id: content.sys.id,
        title: content.fields.title ?? "Uten tittel",
        slug: content.fields.slug ?? content.sys.id,
        type: content.sys.contentType.sys.id,
        parentId: content.fields.parentId
    };
    if ("visibleInSections" in content.fields) return {
        ...baseData,
        visibleInSections: content.fields.visibleInSections
    };
    return baseData;
};
const $0021dea44d42b77d$export$7a2a09e5c37d09a7 = (builtUrl, parentId, allPages)=>{
    if ((0, $3xOZa.default)(parentId)) return builtUrl;
    const parent = allPages.find((possibleParent)=>possibleParent.id === parentId);
    if ((0, $3xOZa.default)(parent)) return builtUrl;
    return $0021dea44d42b77d$export$7a2a09e5c37d09a7(`${parent.slug}/${builtUrl}`, parent.parentId, allPages);
};
const $0021dea44d42b77d$export$67a343b63f37e37f = (page, allPages)=>{
    const fullUrl = $0021dea44d42b77d$export$7a2a09e5c37d09a7(page.slug, page.parentId, allPages);
    return {
        ...page,
        fullUrl: fullUrl
    };
};
const $0021dea44d42b77d$export$86d329c847012ae2 = async (isPreviewMode)=>{
    const entries = await $0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "warning",
        include: 1
    });
    return entries.items;
};
const $0021dea44d42b77d$export$49d99620f1f86dfb = (content)=>{
    const MAIN_MENU_TAG = "visibleInMainMenu";
    return content.metadata.tags.filter((tag)=>tag.sys.id === MAIN_MENU_TAG).length > 0;
};
const $0021dea44d42b77d$export$9acd0d4601f4f0b7 = (content, allUrlData)=>{
    // Is this content even tagged to be featured in the main menu?
    if (!$0021dea44d42b77d$export$49d99620f1f86dfb(content)) return [];
    const urlForMenuItem = allUrlData.find((urlData)=>urlData.id === content.sys.id)?.fullUrl;
    // If we are unable to generate a proper URL for the content, we skip it
    if ((0, $3xOZa.default)(urlForMenuItem)) return [];
    return [
        {
            title: content.fields.title,
            id: content.sys.id,
            url: urlForMenuItem.startsWith("/") ? urlForMenuItem : `/${urlForMenuItem}`,
            contentType: content.sys.contentType.sys.id
        }
    ];
};
const $0021dea44d42b77d$export$386c9ce4f0639b92 = async (isPreviewMode)=>{
    const { items: items } = await $0021dea44d42b77d$export$ee2b5e97418a314d(isPreviewMode).withoutUnresolvableLinks.getEntries({
        content_type: "productCategory",
        include: 3
    });
    // Sort items ordered by 1)segmented include, 2)segmented exclude, 3) non-segmented.
    // Product category page displays only the first item.
    return items.sort((item1, item2)=>{
        if (item1.fields.includeSegments && !item2.fields.includeSegments) return -1;
        if (!item1.fields.includeSegments && item2.fields.includeSegments) return 1;
        if (item1.fields.excludeSegments && !item2.fields.excludeSegments) return -1;
        if (!item1.fields.excludeSegments && item2.fields.excludeSegments) return 1;
        return 0;
    });
};
const $0021dea44d42b77d$var$sectionEntryComparator = (entry1, entry2)=>{
    const orderPriority1 = entry1.fields.orderPriority || 5;
    const orderPriority2 = entry2.fields.orderPriority || 5;
    return orderPriority1 - orderPriority2;
};
const $0021dea44d42b77d$export$7675d887dbe15262 = (entries)=>{
    return entries.sort($0021dea44d42b77d$var$sectionEntryComparator);
};

});
parcelRegister("547r2", function(module, exports) {

var $k90pP = parcelRequire("k90pP");
var $3b0317eee2d59c32$require$Buffer = $k90pP.Buffer;
!function(e, t) {
    module.exports = t();
}(self, function() {
    return function() {
        var e = {
            581: function(e, t, n) {
                e.exports = function() {
                    "use strict";
                    var e = Function.prototype.toString, t = Object.create, r = Object.defineProperty, o = Object.getOwnPropertyDescriptor, i = Object.getOwnPropertyNames, s = Object.getOwnPropertySymbols, a = Object.getPrototypeOf, c = Object.prototype, u = c.hasOwnProperty, l = c.propertyIsEnumerable, f = "function" == typeof s, p = "function" == typeof WeakMap, d = function() {
                        if (p) return function() {
                            return new WeakMap;
                        };
                        var e = function() {
                            function e() {
                                this._keys = [], this._values = [];
                            }
                            return e.prototype.has = function(e) {
                                return !!~this._keys.indexOf(e);
                            }, e.prototype.get = function(e) {
                                return this._values[this._keys.indexOf(e)];
                            }, e.prototype.set = function(e, t) {
                                this._keys.push(e), this._values.push(t);
                            }, e;
                        }();
                        return function() {
                            return new e;
                        };
                    }(), h = function(n, r) {
                        var o = n.__proto__ || a(n);
                        if (!o) return t(null);
                        var i = o.constructor;
                        if (i === r.Object) return o === r.Object.prototype ? {} : t(o);
                        if (~e.call(i).indexOf("[native code]")) try {
                            return new i;
                        } catch (e) {}
                        return t(o);
                    }, y = function(e, t, n, r) {
                        var o = h(e, t);
                        for(var i in r.set(e, o), e)u.call(e, i) && (o[i] = n(e[i], r));
                        if (f) for(var a = s(e), c = 0, p = a.length, d = void 0; c < p; ++c)d = a[c], l.call(e, d) && (o[d] = n(e[d], r));
                        return o;
                    }, m = function(e, t, n, a) {
                        var c = h(e, t);
                        a.set(e, c);
                        for(var u = f ? i(e).concat(s(e)) : i(e), l = 0, p = u.length, d = void 0, y = void 0; l < p; ++l)if ("callee" !== (d = u[l]) && "caller" !== d) {
                            if (y = o(e, d)) {
                                y.get || y.set || (y.value = n(e[d], a));
                                try {
                                    r(c, d, y);
                                } catch (e) {
                                    c[d] = y.value;
                                }
                            } else c[d] = n(e[d], a);
                        }
                        return c;
                    }, g = Array.isArray, b = Object.getPrototypeOf, v = function() {
                        return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : (console && console.error && console.error('Unable to locate global object, returning "this".'), this);
                    }();
                    function w(e, t) {
                        var n = !(!t || !t.isStrict), r = t && t.realm || v, o = n ? m : y, i = function(e, t) {
                            if (!e || "object" != typeof e) return e;
                            if (t.has(e)) return t.get(e);
                            var s, a, c, u = e.__proto__ || b(e), l = u && u.constructor;
                            if (!l || l === r.Object) return o(e, r, i, t);
                            if (g(e)) {
                                if (n) return m(e, r, i, t);
                                s = new l, t.set(e, s);
                                for(var f = 0, p = e.length; f < p; ++f)s[f] = i(e[f], t);
                                return s;
                            }
                            if (e instanceof r.Date) return new l(e.getTime());
                            if (e instanceof r.RegExp) return (s = new l(e.source, e.flags || (a = e, c = "", a.global && (c += "g"), a.ignoreCase && (c += "i"), a.multiline && (c += "m"), a.unicode && (c += "u"), a.sticky && (c += "y"), c))).lastIndex = e.lastIndex, s;
                            if (r.Map && e instanceof r.Map) return s = new l, t.set(e, s), e.forEach(function(e, n) {
                                s.set(n, i(e, t));
                            }), s;
                            if (r.Set && e instanceof r.Set) return s = new l, t.set(e, s), e.forEach(function(e) {
                                s.add(i(e, t));
                            }), s;
                            if (r.Blob && e instanceof r.Blob) return e.slice(0, e.size, e.type);
                            if (r.Buffer && r.Buffer.isBuffer(e)) return s = r.Buffer.allocUnsafe ? r.Buffer.allocUnsafe(e.length) : new l(e.length), t.set(e, s), e.copy(s), s;
                            if (r.ArrayBuffer) {
                                if (r.ArrayBuffer.isView(e)) return s = new l(e.buffer.slice(0)), t.set(e, s), s;
                                if (e instanceof r.ArrayBuffer) return s = e.slice(0), t.set(e, s), s;
                            }
                            return "function" == typeof e.then || e instanceof Error || r.WeakMap && e instanceof r.WeakMap || r.WeakSet && e instanceof r.WeakSet ? e : o(e, r, i, t);
                        };
                        return i(e, d());
                    }
                    return w.default = w, w.strict = function(e, t) {
                        return w(e, {
                            isStrict: !0,
                            realm: t ? t.realm : void 0
                        });
                    }, w;
                }();
            },
            784: function(e, t) {
                function n(e, t) {
                    var n = [], r = [];
                    return null == t && (t = function(e, t) {
                        return n[0] === t ? "[Circular ~]" : "[Circular ~." + r.slice(0, n.indexOf(t)).join(".") + "]";
                    }), function(o, i) {
                        if (n.length > 0) {
                            var s = n.indexOf(this);
                            ~s ? n.splice(s + 1) : n.push(this), ~s ? r.splice(s, 1 / 0, o) : r.push(o), ~n.indexOf(i) && (i = t.call(this, o, i));
                        } else n.push(i);
                        return null == e ? i : e.call(this, o, i);
                    };
                }
                (e.exports = function(e, t, r, o) {
                    return JSON.stringify(e, n(t, o), r);
                }).getSerialize = n;
            },
            261: function(e) {
                var t, n, r = Function.prototype, o = Object.prototype, i = r.toString, s = o.hasOwnProperty, a = i.call(Object), c = o.toString, u = (t = Object.getPrototypeOf, n = Object, function(e) {
                    return t(n(e));
                });
                e.exports = function(e) {
                    if (!function(e) {
                        return !!e && "object" == typeof e;
                    }(e) || "[object Object]" != c.call(e) || function(e) {
                        var t = !1;
                        if (null != e && "function" != typeof e.toString) try {
                            t = !!(e + "");
                        } catch (e) {}
                        return t;
                    }(e)) return !1;
                    var t = u(e);
                    if (null === t) return !0;
                    var n = s.call(t, "constructor") && t.constructor;
                    return "function" == typeof n && n instanceof n && i.call(n) == a;
                };
            },
            451: function(e) {
                var t = Object.prototype.toString, n = Array.isArray;
                e.exports = function(e) {
                    return "string" == typeof e || !n(e) && function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object String]" == t.call(e);
                };
            },
            930: function(e) {
                "use strict";
                class t extends Error {
                    constructor(){
                        super("Throttled function aborted"), this.name = "AbortError";
                    }
                }
                e.exports = ({ limit: e, interval: n, strict: r })=>{
                    if (!Number.isFinite(e)) throw new TypeError("Expected `limit` to be a finite number");
                    if (!Number.isFinite(n)) throw new TypeError("Expected `interval` to be a finite number");
                    const o = new Map;
                    let i = 0, s = 0;
                    const a = [], c = r ? function() {
                        const t = Date.now();
                        if (a.length < e) return a.push(t), 0;
                        const r = a.shift() + n;
                        return t >= r ? (a.push(t), 0) : (a.push(r), r - t);
                    } : function() {
                        const t = Date.now();
                        return t - i > n ? (s = 1, i = t, 0) : (s < e ? s++ : (i += n, s = 1), i - t);
                    };
                    return (e)=>{
                        const n = function(...t) {
                            if (!n.isEnabled) return (async ()=>e.apply(this, t))();
                            let r;
                            return new Promise((n, i)=>{
                                r = setTimeout(()=>{
                                    n(e.apply(this, t)), o.delete(r);
                                }, c()), o.set(r, i);
                            });
                        };
                        return n.abort = ()=>{
                            for (const e of o.keys())clearTimeout(e), o.get(e)(new t);
                            o.clear(), a.splice(0, a.length);
                        }, n.isEnabled = !0, n;
                    };
                }, e.exports.AbortError = t;
            }
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e[r].call(i.exports, i, i.exports, n), i.exports;
        }
        n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e, t) {
            for(var r in t)n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            function e(e, t) {
                return function() {
                    return e.apply(t, arguments);
                };
            }
            n.r(r), n.d(r, {
                createClient: function() {
                    return Ft;
                },
                createGlobalOptions: function() {
                    return dt;
                }
            });
            const { toString: t } = Object.prototype, { getPrototypeOf: o } = Object, i = (s = Object.create(null), (e)=>{
                const n = t.call(e);
                return s[n] || (s[n] = n.slice(8, -1).toLowerCase());
            });
            var s;
            const a = (e)=>(e = e.toLowerCase(), (t)=>i(t) === e), c = (e)=>(t)=>typeof t === e, { isArray: u } = Array, l = c("undefined"), f = a("ArrayBuffer"), p = c("string"), d = c("function"), h = c("number"), y = (e)=>null !== e && "object" == typeof e, m = (e)=>{
                if ("object" !== i(e)) return !1;
                const t = o(e);
                return !(null !== t && t !== Object.prototype && null !== Object.getPrototypeOf(t) || Symbol.toStringTag in e || Symbol.iterator in e);
            }, g = a("Date"), b = a("File"), v = a("Blob"), w = a("FileList"), O = a("URLSearchParams");
            function E(e, t, { allOwnKeys: n = !1 } = {}) {
                if (null == e) return;
                let r, o;
                if ("object" != typeof e && (e = [
                    e
                ]), u(e)) for(r = 0, o = e.length; r < o; r++)t.call(null, e[r], r, e);
                else {
                    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
                    let s;
                    for(r = 0; r < i; r++)s = o[r], t.call(null, e[s], s, e);
                }
            }
            function S(e, t) {
                t = t.toLowerCase();
                const n = Object.keys(e);
                let r, o = n.length;
                for(; o-- > 0;)if (r = n[o], t === r.toLowerCase()) return r;
                return null;
            }
            const x = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : $parcel$global, A = (e)=>!l(e) && e !== x, j = (T = "undefined" != typeof Uint8Array && o(Uint8Array), (e)=>T && e instanceof T);
            var T;
            const R = a("HTMLFormElement"), L = (({ hasOwnProperty: e })=>(t, n)=>e.call(t, n))(Object.prototype), k = a("RegExp"), P = (e, t)=>{
                const n = Object.getOwnPropertyDescriptors(e), r = {};
                E(n, (n, o)=>{
                    !1 !== t(n, o, e) && (r[o] = n);
                }), Object.defineProperties(e, r);
            }, U = "abcdefghijklmnopqrstuvwxyz", _ = "0123456789", N = {
                DIGIT: _,
                ALPHA: U,
                ALPHA_DIGIT: U + U.toUpperCase() + _
            }, C = a("AsyncFunction");
            var B = {
                isArray: u,
                isArrayBuffer: f,
                isBuffer: function(e) {
                    return null !== e && !l(e) && null !== e.constructor && !l(e.constructor) && d(e.constructor.isBuffer) && e.constructor.isBuffer(e);
                },
                isFormData: (e)=>{
                    let t;
                    return e && ("function" == typeof FormData && e instanceof FormData || d(e.append) && ("formdata" === (t = i(e)) || "object" === t && d(e.toString) && "[object FormData]" === e.toString()));
                },
                isArrayBufferView: function(e) {
                    let t;
                    return t = "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && f(e.buffer), t;
                },
                isString: p,
                isNumber: h,
                isBoolean: (e)=>!0 === e || !1 === e,
                isObject: y,
                isPlainObject: m,
                isUndefined: l,
                isDate: g,
                isFile: b,
                isBlob: v,
                isRegExp: k,
                isFunction: d,
                isStream: (e)=>y(e) && d(e.pipe),
                isURLSearchParams: O,
                isTypedArray: j,
                isFileList: w,
                forEach: E,
                merge: function e() {
                    const { caseless: t } = A(this) && this || {}, n = {}, r = (r, o)=>{
                        const i = t && S(n, o) || o;
                        m(n[i]) && m(r) ? n[i] = e(n[i], r) : m(r) ? n[i] = e({}, r) : u(r) ? n[i] = r.slice() : n[i] = r;
                    };
                    for(let e = 0, t = arguments.length; e < t; e++)arguments[e] && E(arguments[e], r);
                    return n;
                },
                extend: (t, n, r, { allOwnKeys: o } = {})=>(E(n, (n, o)=>{
                        r && d(n) ? t[o] = e(n, r) : t[o] = n;
                    }, {
                        allOwnKeys: o
                    }), t),
                trim: (e)=>e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""),
                stripBOM: (e)=>(65279 === e.charCodeAt(0) && (e = e.slice(1)), e),
                inherits: (e, t, n, r)=>{
                    e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
                        value: t.prototype
                    }), n && Object.assign(e.prototype, n);
                },
                toFlatObject: (e, t, n, r)=>{
                    let i, s, a;
                    const c = {};
                    if (t = t || {}, null == e) return t;
                    do {
                        for(i = Object.getOwnPropertyNames(e), s = i.length; s-- > 0;)a = i[s], r && !r(a, e, t) || c[a] || (t[a] = e[a], c[a] = !0);
                        e = !1 !== n && o(e);
                    }while (e && (!n || n(e, t)) && e !== Object.prototype);
                    return t;
                },
                kindOf: i,
                kindOfTest: a,
                endsWith: (e, t, n)=>{
                    e = String(e), (void 0 === n || n > e.length) && (n = e.length), n -= t.length;
                    const r = e.indexOf(t, n);
                    return -1 !== r && r === n;
                },
                toArray: (e)=>{
                    if (!e) return null;
                    if (u(e)) return e;
                    let t = e.length;
                    if (!h(t)) return null;
                    const n = new Array(t);
                    for(; t-- > 0;)n[t] = e[t];
                    return n;
                },
                forEachEntry: (e, t)=>{
                    const n = (e && e[Symbol.iterator]).call(e);
                    let r;
                    for(; (r = n.next()) && !r.done;){
                        const n = r.value;
                        t.call(e, n[0], n[1]);
                    }
                },
                matchAll: (e, t)=>{
                    let n;
                    const r = [];
                    for(; null !== (n = e.exec(t));)r.push(n);
                    return r;
                },
                isHTMLForm: R,
                hasOwnProperty: L,
                hasOwnProp: L,
                reduceDescriptors: P,
                freezeMethods: (e)=>{
                    P(e, (t, n)=>{
                        if (d(e) && -1 !== [
                            "arguments",
                            "caller",
                            "callee"
                        ].indexOf(n)) return !1;
                        const r = e[n];
                        d(r) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set || (t.set = ()=>{
                            throw Error("Can not rewrite read-only method '" + n + "'");
                        }));
                    });
                },
                toObjectSet: (e, t)=>{
                    const n = {}, r = (e)=>{
                        e.forEach((e)=>{
                            n[e] = !0;
                        });
                    };
                    return u(e) ? r(e) : r(String(e).split(t)), n;
                },
                toCamelCase: (e)=>e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
                        return t.toUpperCase() + n;
                    }),
                noop: ()=>{},
                toFiniteNumber: (e, t)=>(e = +e, Number.isFinite(e) ? e : t),
                findKey: S,
                global: x,
                isContextDefined: A,
                ALPHABET: N,
                generateString: (e = 16, t = N.ALPHA_DIGIT)=>{
                    let n = "";
                    const { length: r } = t;
                    for(; e--;)n += t[Math.random() * r | 0];
                    return n;
                },
                isSpecCompliantForm: function(e) {
                    return !!(e && d(e.append) && "FormData" === e[Symbol.toStringTag] && e[Symbol.iterator]);
                },
                toJSONObject: (e)=>{
                    const t = new Array(10), n = (e, r)=>{
                        if (y(e)) {
                            if (t.indexOf(e) >= 0) return;
                            if (!("toJSON" in e)) {
                                t[r] = e;
                                const o = u(e) ? [] : {};
                                return E(e, (e, t)=>{
                                    const i = n(e, r + 1);
                                    !l(i) && (o[t] = i);
                                }), t[r] = void 0, o;
                            }
                        }
                        return e;
                    };
                    return n(e, 0);
                },
                isAsyncFn: C,
                isThenable: (e)=>e && (y(e) || d(e)) && d(e.then) && d(e.catch)
            };
            function D(e, t, n, r, o) {
                Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = (new Error).stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
            }
            B.inherits(D, Error, {
                toJSON: function() {
                    return {
                        message: this.message,
                        name: this.name,
                        description: this.description,
                        number: this.number,
                        fileName: this.fileName,
                        lineNumber: this.lineNumber,
                        columnNumber: this.columnNumber,
                        stack: this.stack,
                        config: B.toJSONObject(this.config),
                        code: this.code,
                        status: this.response && this.response.status ? this.response.status : null
                    };
                }
            });
            const F = D.prototype, I = {};
            [
                "ERR_BAD_OPTION_VALUE",
                "ERR_BAD_OPTION",
                "ECONNABORTED",
                "ETIMEDOUT",
                "ERR_NETWORK",
                "ERR_FR_TOO_MANY_REDIRECTS",
                "ERR_DEPRECATED",
                "ERR_BAD_RESPONSE",
                "ERR_BAD_REQUEST",
                "ERR_CANCELED",
                "ERR_NOT_SUPPORT",
                "ERR_INVALID_URL"
            ].forEach((e)=>{
                I[e] = {
                    value: e
                };
            }), Object.defineProperties(D, I), Object.defineProperty(F, "isAxiosError", {
                value: !0
            }), D.from = (e, t, n, r, o, i)=>{
                const s = Object.create(F);
                return B.toFlatObject(e, s, function(e) {
                    return e !== Error.prototype;
                }, (e)=>"isAxiosError" !== e), D.call(s, e.message, t, n, r, o), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
            };
            var q = D;
            function M(e) {
                return B.isPlainObject(e) || B.isArray(e);
            }
            function z(e) {
                return B.endsWith(e, "[]") ? e.slice(0, -2) : e;
            }
            function W(e, t, n) {
                return e ? e.concat(t).map(function(e, t) {
                    return e = z(e), !n && t ? "[" + e + "]" : e;
                }).join(n ? "." : "") : t;
            }
            const H = B.toFlatObject(B, {}, null, function(e) {
                return /^is[A-Z]/.test(e);
            });
            var $ = function(e, t, n) {
                if (!B.isObject(e)) throw new TypeError("target must be an object");
                t = t || new FormData;
                const r = (n = B.toFlatObject(n, {
                    metaTokens: !0,
                    dots: !1,
                    indexes: !1
                }, !1, function(e, t) {
                    return !B.isUndefined(t[e]);
                })).metaTokens, o = n.visitor || u, i = n.dots, s = n.indexes, a = (n.Blob || "undefined" != typeof Blob && Blob) && B.isSpecCompliantForm(t);
                if (!B.isFunction(o)) throw new TypeError("visitor must be a function");
                function c(e) {
                    if (null === e) return "";
                    if (B.isDate(e)) return e.toISOString();
                    if (!a && B.isBlob(e)) throw new q("Blob is not supported. Use a Buffer instead.");
                    return B.isArrayBuffer(e) || B.isTypedArray(e) ? a && "function" == typeof Blob ? new Blob([
                        e
                    ]) : $3b0317eee2d59c32$require$Buffer.from(e) : e;
                }
                function u(e, n, o) {
                    let a = e;
                    if (e && !o && "object" == typeof e) {
                        if (B.endsWith(n, "{}")) n = r ? n : n.slice(0, -2), e = JSON.stringify(e);
                        else if (B.isArray(e) && function(e) {
                            return B.isArray(e) && !e.some(M);
                        }(e) || (B.isFileList(e) || B.endsWith(n, "[]")) && (a = B.toArray(e))) return n = z(n), a.forEach(function(e, r) {
                            !B.isUndefined(e) && null !== e && t.append(!0 === s ? W([
                                n
                            ], r, i) : null === s ? n : n + "[]", c(e));
                        }), !1;
                    }
                    return !!M(e) || (t.append(W(o, n, i), c(e)), !1);
                }
                const l = [], f = Object.assign(H, {
                    defaultVisitor: u,
                    convertValue: c,
                    isVisitable: M
                });
                if (!B.isObject(e)) throw new TypeError("data must be an object");
                return function e(n, r) {
                    if (!B.isUndefined(n)) {
                        if (-1 !== l.indexOf(n)) throw Error("Circular reference detected in " + r.join("."));
                        l.push(n), B.forEach(n, function(n, i) {
                            !0 === (!(B.isUndefined(n) || null === n) && o.call(t, n, B.isString(i) ? i.trim() : i, r, f)) && e(n, r ? r.concat(i) : [
                                i
                            ]);
                        }), l.pop();
                    }
                }(e), t;
            };
            function J(e) {
                const t = {
                    "!": "%21",
                    "'": "%27",
                    "(": "%28",
                    ")": "%29",
                    "~": "%7E",
                    "%20": "+",
                    "%00": "\0"
                };
                return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(e) {
                    return t[e];
                });
            }
            function K(e, t) {
                this._pairs = [], e && $(e, this, t);
            }
            const G = K.prototype;
            G.append = function(e, t) {
                this._pairs.push([
                    e,
                    t
                ]);
            }, G.toString = function(e) {
                const t = e ? function(t) {
                    return e.call(this, t, J);
                } : J;
                return this._pairs.map(function(e) {
                    return t(e[0]) + "=" + t(e[1]);
                }, "").join("&");
            };
            var V = K;
            function X(e) {
                return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
            }
            function Q(e, t, n) {
                if (!t) return e;
                const r = n && n.encode || X, o = n && n.serialize;
                let i;
                if (i = o ? o(t, n) : B.isURLSearchParams(t) ? t.toString() : new V(t, n).toString(r), i) {
                    const t = e.indexOf("#");
                    -1 !== t && (e = e.slice(0, t)), e += (-1 === e.indexOf("?") ? "?" : "&") + i;
                }
                return e;
            }
            var Z = class {
                constructor(){
                    this.handlers = [];
                }
                use(e, t, n) {
                    return this.handlers.push({
                        fulfilled: e,
                        rejected: t,
                        synchronous: !!n && n.synchronous,
                        runWhen: n ? n.runWhen : null
                    }), this.handlers.length - 1;
                }
                eject(e) {
                    this.handlers[e] && (this.handlers[e] = null);
                }
                clear() {
                    this.handlers && (this.handlers = []);
                }
                forEach(e) {
                    B.forEach(this.handlers, function(t) {
                        null !== t && e(t);
                    });
                }
            }, Y = {
                silentJSONParsing: !0,
                forcedJSONParsing: !0,
                clarifyTimeoutError: !1
            }, ee = {
                isBrowser: !0,
                classes: {
                    URLSearchParams: "undefined" != typeof URLSearchParams ? URLSearchParams : V,
                    FormData: "undefined" != typeof FormData ? FormData : null,
                    Blob: "undefined" != typeof Blob ? Blob : null
                },
                isStandardBrowserEnv: (()=>{
                    let e;
                    return ("undefined" == typeof navigator || "ReactNative" !== (e = navigator.product) && "NativeScript" !== e && "NS" !== e) && "undefined" != typeof window && "undefined" != typeof document;
                })(),
                isStandardBrowserWebWorkerEnv: "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && "function" == typeof self.importScripts,
                protocols: [
                    "http",
                    "https",
                    "file",
                    "blob",
                    "url",
                    "data"
                ]
            }, te = function(e) {
                function t(e, n, r, o) {
                    let i = e[o++];
                    const s = Number.isFinite(+i), a = o >= e.length;
                    return i = !i && B.isArray(r) ? r.length : i, a ? (B.hasOwnProp(r, i) ? r[i] = [
                        r[i],
                        n
                    ] : r[i] = n, !s) : (r[i] && B.isObject(r[i]) || (r[i] = []), t(e, n, r[i], o) && B.isArray(r[i]) && (r[i] = function(e) {
                        const t = {}, n = Object.keys(e);
                        let r;
                        const o = n.length;
                        let i;
                        for(r = 0; r < o; r++)i = n[r], t[i] = e[i];
                        return t;
                    }(r[i])), !s);
                }
                if (B.isFormData(e) && B.isFunction(e.entries)) {
                    const n = {};
                    return B.forEachEntry(e, (e, r)=>{
                        t(function(e) {
                            return B.matchAll(/\w+|\[(\w*)]/g, e).map((e)=>"[]" === e[0] ? "" : e[1] || e[0]);
                        }(e), r, n, 0);
                    }), n;
                }
                return null;
            };
            const ne = {
                "Content-Type": void 0
            }, re = {
                transitional: Y,
                adapter: [
                    "xhr",
                    "http"
                ],
                transformRequest: [
                    function(e, t) {
                        const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, o = B.isObject(e);
                        if (o && B.isHTMLForm(e) && (e = new FormData(e)), B.isFormData(e)) return r && r ? JSON.stringify(te(e)) : e;
                        if (B.isArrayBuffer(e) || B.isBuffer(e) || B.isStream(e) || B.isFile(e) || B.isBlob(e)) return e;
                        if (B.isArrayBufferView(e)) return e.buffer;
                        if (B.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
                        let i;
                        if (o) {
                            if (n.indexOf("application/x-www-form-urlencoded") > -1) return (function(e, t) {
                                return $(e, new ee.classes.URLSearchParams, Object.assign({
                                    visitor: function(e, t, n, r) {
                                        return ee.isNode && B.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
                                    }
                                }, t));
                            })(e, this.formSerializer).toString();
                            if ((i = B.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
                                const t = this.env && this.env.FormData;
                                return $(i ? {
                                    "files[]": e
                                } : e, t && new t, this.formSerializer);
                            }
                        }
                        return o || r ? (t.setContentType("application/json", !1), function(e, t, n) {
                            if (B.isString(e)) try {
                                return (0, JSON.parse)(e), B.trim(e);
                            } catch (e) {
                                if ("SyntaxError" !== e.name) throw e;
                            }
                            return (0, JSON.stringify)(e);
                        }(e)) : e;
                    }
                ],
                transformResponse: [
                    function(e) {
                        const t = this.transitional || re.transitional, n = t && t.forcedJSONParsing, r = "json" === this.responseType;
                        if (e && B.isString(e) && (n && !this.responseType || r)) {
                            const n = !(t && t.silentJSONParsing) && r;
                            try {
                                return JSON.parse(e);
                            } catch (e) {
                                if (n) {
                                    if ("SyntaxError" === e.name) throw q.from(e, q.ERR_BAD_RESPONSE, this, null, this.response);
                                    throw e;
                                }
                            }
                        }
                        return e;
                    }
                ],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
                env: {
                    FormData: ee.classes.FormData,
                    Blob: ee.classes.Blob
                },
                validateStatus: function(e) {
                    return e >= 200 && e < 300;
                },
                headers: {
                    common: {
                        Accept: "application/json, text/plain, */*"
                    }
                }
            };
            B.forEach([
                "delete",
                "get",
                "head"
            ], function(e) {
                re.headers[e] = {};
            }), B.forEach([
                "post",
                "put",
                "patch"
            ], function(e) {
                re.headers[e] = B.merge(ne);
            });
            var oe = re;
            const ie = B.toObjectSet([
                "age",
                "authorization",
                "content-length",
                "content-type",
                "etag",
                "expires",
                "from",
                "host",
                "if-modified-since",
                "if-unmodified-since",
                "last-modified",
                "location",
                "max-forwards",
                "proxy-authorization",
                "referer",
                "retry-after",
                "user-agent"
            ]), se = Symbol("internals");
            function ae(e) {
                return e && String(e).trim().toLowerCase();
            }
            function ce(e) {
                return !1 === e || null == e ? e : B.isArray(e) ? e.map(ce) : String(e);
            }
            function ue(e, t, n, r, o) {
                return B.isFunction(r) ? r.call(this, t, n) : (o && (t = n), B.isString(t) ? B.isString(r) ? -1 !== t.indexOf(r) : B.isRegExp(r) ? r.test(t) : void 0 : void 0);
            }
            class le {
                constructor(e){
                    e && this.set(e);
                }
                set(e, t, n) {
                    const r = this;
                    function o(e, t, n) {
                        const o = ae(t);
                        if (!o) throw new Error("header name must be a non-empty string");
                        const i = B.findKey(r, o);
                        (!i || void 0 === r[i] || !0 === n || void 0 === n && !1 !== r[i]) && (r[i || t] = ce(e));
                    }
                    const i = (e, t)=>B.forEach(e, (e, n)=>o(e, n, t));
                    return B.isPlainObject(e) || e instanceof this.constructor ? i(e, t) : B.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim()) ? i(((e)=>{
                        const t = {};
                        let n, r, o;
                        return e && e.split("\n").forEach(function(e) {
                            o = e.indexOf(":"), n = e.substring(0, o).trim().toLowerCase(), r = e.substring(o + 1).trim(), !n || t[n] && ie[n] || ("set-cookie" === n ? t[n] ? t[n].push(r) : t[n] = [
                                r
                            ] : t[n] = t[n] ? t[n] + ", " + r : r);
                        }), t;
                    })(e), t) : null != e && o(t, e, n), this;
                }
                get(e, t) {
                    if (e = ae(e)) {
                        const n = B.findKey(this, e);
                        if (n) {
                            const e = this[n];
                            if (!t) return e;
                            if (!0 === t) return function(e) {
                                const t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
                                let r;
                                for(; r = n.exec(e);)t[r[1]] = r[2];
                                return t;
                            }(e);
                            if (B.isFunction(t)) return t.call(this, e, n);
                            if (B.isRegExp(t)) return t.exec(e);
                            throw new TypeError("parser must be boolean|regexp|function");
                        }
                    }
                }
                has(e, t) {
                    if (e = ae(e)) {
                        const n = B.findKey(this, e);
                        return !(!n || void 0 === this[n] || t && !ue(0, this[n], n, t));
                    }
                    return !1;
                }
                delete(e, t) {
                    const n = this;
                    let r = !1;
                    function o(e) {
                        if (e = ae(e)) {
                            const o = B.findKey(n, e);
                            !o || t && !ue(0, n[o], o, t) || (delete n[o], r = !0);
                        }
                    }
                    return B.isArray(e) ? e.forEach(o) : o(e), r;
                }
                clear(e) {
                    const t = Object.keys(this);
                    let n = t.length, r = !1;
                    for(; n--;){
                        const o = t[n];
                        e && !ue(0, this[o], o, e, !0) || (delete this[o], r = !0);
                    }
                    return r;
                }
                normalize(e) {
                    const t = this, n = {};
                    return B.forEach(this, (r, o)=>{
                        const i = B.findKey(n, o);
                        if (i) return t[i] = ce(r), void delete t[o];
                        const s = e ? function(e) {
                            return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n)=>t.toUpperCase() + n);
                        }(o) : String(o).trim();
                        s !== o && delete t[o], t[s] = ce(r), n[s] = !0;
                    }), this;
                }
                concat(...e) {
                    return this.constructor.concat(this, ...e);
                }
                toJSON(e) {
                    const t = Object.create(null);
                    return B.forEach(this, (n, r)=>{
                        null != n && !1 !== n && (t[r] = e && B.isArray(n) ? n.join(", ") : n);
                    }), t;
                }
                [Symbol.iterator]() {
                    return Object.entries(this.toJSON())[Symbol.iterator]();
                }
                toString() {
                    return Object.entries(this.toJSON()).map(([e, t])=>e + ": " + t).join("\n");
                }
                get [Symbol.toStringTag]() {
                    return "AxiosHeaders";
                }
                static from(e) {
                    return e instanceof this ? e : new this(e);
                }
                static concat(e, ...t) {
                    const n = new this(e);
                    return t.forEach((e)=>n.set(e)), n;
                }
                static accessor(e) {
                    const t = (this[se] = this[se] = {
                        accessors: {}
                    }).accessors, n = this.prototype;
                    function r(e) {
                        const r = ae(e);
                        t[r] || (function(e, t) {
                            const n = B.toCamelCase(" " + t);
                            [
                                "get",
                                "set",
                                "has"
                            ].forEach((r)=>{
                                Object.defineProperty(e, r + n, {
                                    value: function(e, n, o) {
                                        return this[r].call(this, t, e, n, o);
                                    },
                                    configurable: !0
                                });
                            });
                        }(n, e), t[r] = !0);
                    }
                    return B.isArray(e) ? e.forEach(r) : r(e), this;
                }
            }
            le.accessor([
                "Content-Type",
                "Content-Length",
                "Accept",
                "Accept-Encoding",
                "User-Agent",
                "Authorization"
            ]), B.freezeMethods(le.prototype), B.freezeMethods(le);
            var fe = le;
            function pe(e, t) {
                const n = this || oe, r = t || n, o = fe.from(r.headers);
                let i = r.data;
                return B.forEach(e, function(e) {
                    i = e.call(n, i, o.normalize(), t ? t.status : void 0);
                }), o.normalize(), i;
            }
            function de(e) {
                return !(!e || !e.__CANCEL__);
            }
            function he(e, t, n) {
                q.call(this, null == e ? "canceled" : e, q.ERR_CANCELED, t, n), this.name = "CanceledError";
            }
            B.inherits(he, q, {
                __CANCEL__: !0
            });
            var ye = he, me = ee.isStandardBrowserEnv ? {
                write: function(e, t, n, r, o, i) {
                    const s = [];
                    s.push(e + "=" + encodeURIComponent(t)), B.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), B.isString(r) && s.push("path=" + r), B.isString(o) && s.push("domain=" + o), !0 === i && s.push("secure"), document.cookie = s.join("; ");
                },
                read: function(e) {
                    const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
                    return t ? decodeURIComponent(t[3]) : null;
                },
                remove: function(e) {
                    this.write(e, "", Date.now() - 864e5);
                }
            } : {
                write: function() {},
                read: function() {
                    return null;
                },
                remove: function() {}
            };
            function ge(e, t) {
                return e && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t) ? function(e, t) {
                    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
                }(e, t) : t;
            }
            var be = ee.isStandardBrowserEnv ? function() {
                const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
                let n;
                function r(n) {
                    let r = n;
                    return e && (t.setAttribute("href", r), r = t.href), t.setAttribute("href", r), {
                        href: t.href,
                        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
                        host: t.host,
                        search: t.search ? t.search.replace(/^\?/, "") : "",
                        hash: t.hash ? t.hash.replace(/^#/, "") : "",
                        hostname: t.hostname,
                        port: t.port,
                        pathname: "/" === t.pathname.charAt(0) ? t.pathname : "/" + t.pathname
                    };
                }
                return n = r(window.location.href), function(e) {
                    const t = B.isString(e) ? r(e) : e;
                    return t.protocol === n.protocol && t.host === n.host;
                };
            }() : function() {
                return !0;
            };
            function ve(e, t) {
                let n = 0;
                const r = function(e, t) {
                    e = e || 10;
                    const n = new Array(e), r = new Array(e);
                    let o, i = 0, s = 0;
                    return t = void 0 !== t ? t : 1e3, function(a) {
                        const c = Date.now(), u = r[s];
                        o || (o = c), n[i] = a, r[i] = c;
                        let l = s, f = 0;
                        for(; l !== i;)f += n[l++], l %= e;
                        if (i = (i + 1) % e, i === s && (s = (s + 1) % e), c - o < t) return;
                        const p = u && c - u;
                        return p ? Math.round(1e3 * f / p) : void 0;
                    };
                }(50, 250);
                return (o)=>{
                    const i = o.loaded, s = o.lengthComputable ? o.total : void 0, a = i - n, c = r(a);
                    n = i;
                    const u = {
                        loaded: i,
                        total: s,
                        progress: s ? i / s : void 0,
                        bytes: a,
                        rate: c || void 0,
                        estimated: c && s && i <= s ? (s - i) / c : void 0,
                        event: o
                    };
                    u[t ? "download" : "upload"] = !0, e(u);
                };
            }
            const we = {
                http: null,
                xhr: "undefined" != typeof XMLHttpRequest && function(e) {
                    return new Promise(function(t, n) {
                        let r = e.data;
                        const o = fe.from(e.headers).normalize(), i = e.responseType;
                        let s;
                        function a() {
                            e.cancelToken && e.cancelToken.unsubscribe(s), e.signal && e.signal.removeEventListener("abort", s);
                        }
                        B.isFormData(r) && (ee.isStandardBrowserEnv || ee.isStandardBrowserWebWorkerEnv ? o.setContentType(!1) : o.setContentType("multipart/form-data;", !1));
                        let c = new XMLHttpRequest;
                        if (e.auth) {
                            const t = e.auth.username || "", n = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
                            o.set("Authorization", "Basic " + btoa(t + ":" + n));
                        }
                        const u = ge(e.baseURL, e.url);
                        function l() {
                            if (!c) return;
                            const r = fe.from("getAllResponseHeaders" in c && c.getAllResponseHeaders());
                            !function(e, t, n) {
                                const r = n.config.validateStatus;
                                n.status && r && !r(n.status) ? t(new q("Request failed with status code " + n.status, [
                                    q.ERR_BAD_REQUEST,
                                    q.ERR_BAD_RESPONSE
                                ][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : e(n);
                            }(function(e) {
                                t(e), a();
                            }, function(e) {
                                n(e), a();
                            }, {
                                data: i && "text" !== i && "json" !== i ? c.response : c.responseText,
                                status: c.status,
                                statusText: c.statusText,
                                headers: r,
                                config: e,
                                request: c
                            }), c = null;
                        }
                        if (c.open(e.method.toUpperCase(), Q(u, e.params, e.paramsSerializer), !0), c.timeout = e.timeout, "onloadend" in c ? c.onloadend = l : c.onreadystatechange = function() {
                            c && 4 === c.readyState && (0 !== c.status || c.responseURL && 0 === c.responseURL.indexOf("file:")) && setTimeout(l);
                        }, c.onabort = function() {
                            c && (n(new q("Request aborted", q.ECONNABORTED, e, c)), c = null);
                        }, c.onerror = function() {
                            n(new q("Network Error", q.ERR_NETWORK, e, c)), c = null;
                        }, c.ontimeout = function() {
                            let t = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
                            const r = e.transitional || Y;
                            e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(new q(t, r.clarifyTimeoutError ? q.ETIMEDOUT : q.ECONNABORTED, e, c)), c = null;
                        }, ee.isStandardBrowserEnv) {
                            const t = (e.withCredentials || be(u)) && e.xsrfCookieName && me.read(e.xsrfCookieName);
                            t && o.set(e.xsrfHeaderName, t);
                        }
                        void 0 === r && o.setContentType(null), "setRequestHeader" in c && B.forEach(o.toJSON(), function(e, t) {
                            c.setRequestHeader(t, e);
                        }), B.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), i && "json" !== i && (c.responseType = e.responseType), "function" == typeof e.onDownloadProgress && c.addEventListener("progress", ve(e.onDownloadProgress, !0)), "function" == typeof e.onUploadProgress && c.upload && c.upload.addEventListener("progress", ve(e.onUploadProgress)), (e.cancelToken || e.signal) && (s = (t)=>{
                            c && (n(!t || t.type ? new ye(null, e, c) : t), c.abort(), c = null);
                        }, e.cancelToken && e.cancelToken.subscribe(s), e.signal && (e.signal.aborted ? s() : e.signal.addEventListener("abort", s)));
                        const f = function(e) {
                            const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
                            return t && t[1] || "";
                        }(u);
                        f && -1 === ee.protocols.indexOf(f) ? n(new q("Unsupported protocol " + f + ":", q.ERR_BAD_REQUEST, e)) : c.send(r || null);
                    });
                }
            };
            B.forEach(we, (e, t)=>{
                if (e) {
                    try {
                        Object.defineProperty(e, "name", {
                            value: t
                        });
                    } catch (e) {}
                    Object.defineProperty(e, "adapterName", {
                        value: t
                    });
                }
            });
            function Oe(e) {
                if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new ye(null, e);
            }
            function Ee(e) {
                return Oe(e), e.headers = fe.from(e.headers), e.data = pe.call(e, e.transformRequest), -1 !== [
                    "post",
                    "put",
                    "patch"
                ].indexOf(e.method) && e.headers.setContentType("application/x-www-form-urlencoded", !1), ((e)=>{
                    e = B.isArray(e) ? e : [
                        e
                    ];
                    const { length: t } = e;
                    let n, r;
                    for(let o = 0; o < t && (n = e[o], !(r = B.isString(n) ? we[n.toLowerCase()] : n)); o++);
                    if (!r) {
                        if (!1 === r) throw new q(`Adapter ${n} is not supported by the environment`, "ERR_NOT_SUPPORT");
                        throw new Error(B.hasOwnProp(we, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`);
                    }
                    if (!B.isFunction(r)) throw new TypeError("adapter is not a function");
                    return r;
                })(e.adapter || oe.adapter)(e).then(function(t) {
                    return Oe(e), t.data = pe.call(e, e.transformResponse, t), t.headers = fe.from(t.headers), t;
                }, function(t) {
                    return de(t) || (Oe(e), t && t.response && (t.response.data = pe.call(e, e.transformResponse, t.response), t.response.headers = fe.from(t.response.headers))), Promise.reject(t);
                });
            }
            const Se = (e)=>e instanceof fe ? e.toJSON() : e;
            function xe(e, t) {
                t = t || {};
                const n = {};
                function r(e, t, n) {
                    return B.isPlainObject(e) && B.isPlainObject(t) ? B.merge.call({
                        caseless: n
                    }, e, t) : B.isPlainObject(t) ? B.merge({}, t) : B.isArray(t) ? t.slice() : t;
                }
                function o(e, t, n) {
                    return B.isUndefined(t) ? B.isUndefined(e) ? void 0 : r(void 0, e, n) : r(e, t, n);
                }
                function i(e, t) {
                    if (!B.isUndefined(t)) return r(void 0, t);
                }
                function s(e, t) {
                    return B.isUndefined(t) ? B.isUndefined(e) ? void 0 : r(void 0, e) : r(void 0, t);
                }
                function a(n, o, i) {
                    return i in t ? r(n, o) : i in e ? r(void 0, n) : void 0;
                }
                const c = {
                    url: i,
                    method: i,
                    data: i,
                    baseURL: s,
                    transformRequest: s,
                    transformResponse: s,
                    paramsSerializer: s,
                    timeout: s,
                    timeoutMessage: s,
                    withCredentials: s,
                    adapter: s,
                    responseType: s,
                    xsrfCookieName: s,
                    xsrfHeaderName: s,
                    onUploadProgress: s,
                    onDownloadProgress: s,
                    decompress: s,
                    maxContentLength: s,
                    maxBodyLength: s,
                    beforeRedirect: s,
                    transport: s,
                    httpAgent: s,
                    httpsAgent: s,
                    cancelToken: s,
                    socketPath: s,
                    responseEncoding: s,
                    validateStatus: a,
                    headers: (e, t)=>o(Se(e), Se(t), !0)
                };
                return B.forEach(Object.keys(Object.assign({}, e, t)), function(r) {
                    const i = c[r] || o, s = i(e[r], t[r], r);
                    B.isUndefined(s) && i !== a || (n[r] = s);
                }), n;
            }
            const Ae = {};
            [
                "object",
                "boolean",
                "number",
                "function",
                "string",
                "symbol"
            ].forEach((e, t)=>{
                Ae[e] = function(n) {
                    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
                };
            });
            const je = {};
            Ae.transitional = function(e, t, n) {
                function r(e, t) {
                    return "[Axios v1.4.0] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
                }
                return (n, o, i)=>{
                    if (!1 === e) throw new q(r(o, " has been removed" + (t ? " in " + t : "")), q.ERR_DEPRECATED);
                    return t && !je[o] && (je[o] = !0, console.warn(r(o, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, o, i);
                };
            };
            var Te = {
                assertOptions: function(e, t, n) {
                    if ("object" != typeof e) throw new q("options must be an object", q.ERR_BAD_OPTION_VALUE);
                    const r = Object.keys(e);
                    let o = r.length;
                    for(; o-- > 0;){
                        const i = r[o], s = t[i];
                        if (s) {
                            const t = e[i], n = void 0 === t || s(t, i, e);
                            if (!0 !== n) throw new q("option " + i + " must be " + n, q.ERR_BAD_OPTION_VALUE);
                        } else if (!0 !== n) throw new q("Unknown option " + i, q.ERR_BAD_OPTION);
                    }
                },
                validators: Ae
            };
            const Re = Te.validators;
            class Le {
                constructor(e){
                    this.defaults = e, this.interceptors = {
                        request: new Z,
                        response: new Z
                    };
                }
                request(e, t) {
                    "string" == typeof e ? (t = t || {}).url = e : t = e || {}, t = xe(this.defaults, t);
                    const { transitional: n, paramsSerializer: r, headers: o } = t;
                    let i;
                    void 0 !== n && Te.assertOptions(n, {
                        silentJSONParsing: Re.transitional(Re.boolean),
                        forcedJSONParsing: Re.transitional(Re.boolean),
                        clarifyTimeoutError: Re.transitional(Re.boolean)
                    }, !1), null != r && (B.isFunction(r) ? t.paramsSerializer = {
                        serialize: r
                    } : Te.assertOptions(r, {
                        encode: Re.function,
                        serialize: Re.function
                    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase(), i = o && B.merge(o.common, o[t.method]), i && B.forEach([
                        "delete",
                        "get",
                        "head",
                        "post",
                        "put",
                        "patch",
                        "common"
                    ], (e)=>{
                        delete o[e];
                    }), t.headers = fe.concat(i, o);
                    const s = [];
                    let a = !0;
                    this.interceptors.request.forEach(function(e) {
                        "function" == typeof e.runWhen && !1 === e.runWhen(t) || (a = a && e.synchronous, s.unshift(e.fulfilled, e.rejected));
                    });
                    const c = [];
                    let u;
                    this.interceptors.response.forEach(function(e) {
                        c.push(e.fulfilled, e.rejected);
                    });
                    let l, f = 0;
                    if (!a) {
                        const e = [
                            Ee.bind(this),
                            void 0
                        ];
                        for(e.unshift.apply(e, s), e.push.apply(e, c), l = e.length, u = Promise.resolve(t); f < l;)u = u.then(e[f++], e[f++]);
                        return u;
                    }
                    l = s.length;
                    let p = t;
                    for(f = 0; f < l;){
                        const e = s[f++], t = s[f++];
                        try {
                            p = e(p);
                        } catch (e) {
                            t.call(this, e);
                            break;
                        }
                    }
                    try {
                        u = Ee.call(this, p);
                    } catch (e) {
                        return Promise.reject(e);
                    }
                    for(f = 0, l = c.length; f < l;)u = u.then(c[f++], c[f++]);
                    return u;
                }
                getUri(e) {
                    return Q(ge((e = xe(this.defaults, e)).baseURL, e.url), e.params, e.paramsSerializer);
                }
            }
            B.forEach([
                "delete",
                "get",
                "head",
                "options"
            ], function(e) {
                Le.prototype[e] = function(t, n) {
                    return this.request(xe(n || {}, {
                        method: e,
                        url: t,
                        data: (n || {}).data
                    }));
                };
            }), B.forEach([
                "post",
                "put",
                "patch"
            ], function(e) {
                function t(t) {
                    return function(n, r, o) {
                        return this.request(xe(o || {}, {
                            method: e,
                            headers: t ? {
                                "Content-Type": "multipart/form-data"
                            } : {},
                            url: n,
                            data: r
                        }));
                    };
                }
                Le.prototype[e] = t(), Le.prototype[e + "Form"] = t(!0);
            });
            var ke = Le;
            class Pe {
                constructor(e){
                    if ("function" != typeof e) throw new TypeError("executor must be a function.");
                    let t;
                    this.promise = new Promise(function(e) {
                        t = e;
                    });
                    const n = this;
                    this.promise.then((e)=>{
                        if (!n._listeners) return;
                        let t = n._listeners.length;
                        for(; t-- > 0;)n._listeners[t](e);
                        n._listeners = null;
                    }), this.promise.then = (e)=>{
                        let t;
                        const r = new Promise((e)=>{
                            n.subscribe(e), t = e;
                        }).then(e);
                        return r.cancel = function() {
                            n.unsubscribe(t);
                        }, r;
                    }, e(function(e, r, o) {
                        n.reason || (n.reason = new ye(e, r, o), t(n.reason));
                    });
                }
                throwIfRequested() {
                    if (this.reason) throw this.reason;
                }
                subscribe(e) {
                    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [
                        e
                    ];
                }
                unsubscribe(e) {
                    if (!this._listeners) return;
                    const t = this._listeners.indexOf(e);
                    -1 !== t && this._listeners.splice(t, 1);
                }
                static source() {
                    let e;
                    return {
                        token: new Pe(function(t) {
                            e = t;
                        }),
                        cancel: e
                    };
                }
            }
            var Ue = Pe;
            const _e = {
                Continue: 100,
                SwitchingProtocols: 101,
                Processing: 102,
                EarlyHints: 103,
                Ok: 200,
                Created: 201,
                Accepted: 202,
                NonAuthoritativeInformation: 203,
                NoContent: 204,
                ResetContent: 205,
                PartialContent: 206,
                MultiStatus: 207,
                AlreadyReported: 208,
                ImUsed: 226,
                MultipleChoices: 300,
                MovedPermanently: 301,
                Found: 302,
                SeeOther: 303,
                NotModified: 304,
                UseProxy: 305,
                Unused: 306,
                TemporaryRedirect: 307,
                PermanentRedirect: 308,
                BadRequest: 400,
                Unauthorized: 401,
                PaymentRequired: 402,
                Forbidden: 403,
                NotFound: 404,
                MethodNotAllowed: 405,
                NotAcceptable: 406,
                ProxyAuthenticationRequired: 407,
                RequestTimeout: 408,
                Conflict: 409,
                Gone: 410,
                LengthRequired: 411,
                PreconditionFailed: 412,
                PayloadTooLarge: 413,
                UriTooLong: 414,
                UnsupportedMediaType: 415,
                RangeNotSatisfiable: 416,
                ExpectationFailed: 417,
                ImATeapot: 418,
                MisdirectedRequest: 421,
                UnprocessableEntity: 422,
                Locked: 423,
                FailedDependency: 424,
                TooEarly: 425,
                UpgradeRequired: 426,
                PreconditionRequired: 428,
                TooManyRequests: 429,
                RequestHeaderFieldsTooLarge: 431,
                UnavailableForLegalReasons: 451,
                InternalServerError: 500,
                NotImplemented: 501,
                BadGateway: 502,
                ServiceUnavailable: 503,
                GatewayTimeout: 504,
                HttpVersionNotSupported: 505,
                VariantAlsoNegotiates: 506,
                InsufficientStorage: 507,
                LoopDetected: 508,
                NotExtended: 510,
                NetworkAuthenticationRequired: 511
            };
            Object.entries(_e).forEach(([e, t])=>{
                _e[t] = e;
            });
            var Ne = _e;
            const Ce = function t(n) {
                const r = new ke(n), o = e(ke.prototype.request, r);
                return B.extend(o, ke.prototype, r, {
                    allOwnKeys: !0
                }), B.extend(o, r, null, {
                    allOwnKeys: !0
                }), o.create = function(e) {
                    return t(xe(n, e));
                }, o;
            }(oe);
            Ce.Axios = ke, Ce.CanceledError = ye, Ce.CancelToken = Ue, Ce.isCancel = de, Ce.VERSION = "1.4.0", Ce.toFormData = $, Ce.AxiosError = q, Ce.Cancel = Ce.CanceledError, Ce.all = function(e) {
                return Promise.all(e);
            }, Ce.spread = function(e) {
                return function(t) {
                    return e.apply(null, t);
                };
            }, Ce.isAxiosError = function(e) {
                return B.isObject(e) && !0 === e.isAxiosError;
            }, Ce.mergeConfig = xe, Ce.AxiosHeaders = fe, Ce.formToJSON = (e)=>te(B.isHTMLForm(e) ? new FormData(e) : e), Ce.HttpStatusCode = Ne, Ce.default = Ce;
            var Be = Ce, De = n(581), Fe = n.n(De), Ie = n(451), qe = n.n(Ie), Me = n(930), ze = n.n(Me), We = n(261), He = n.n(We);
            function $e(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(e);
                    t && (r = r.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function Je(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? $e(Object(n), !0).forEach(function(t) {
                        Ve(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $e(Object(n)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                }
                return e;
            }
            function Ke(e) {
                return Ke = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, Ke(e);
            }
            function Ge() {
                Ge = function(e, t) {
                    return new n(e, void 0, t);
                };
                var e = RegExp.prototype, t = new WeakMap;
                function n(e, r, o) {
                    var i = new RegExp(e, r);
                    return t.set(i, o || t.get(e)), Xe(i, n.prototype);
                }
                function r(e, n) {
                    var r = t.get(n);
                    return Object.keys(r).reduce(function(t, n) {
                        var o = r[n];
                        if ("number" == typeof o) t[n] = e[o];
                        else {
                            for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                            t[n] = e[o[i]];
                        }
                        return t;
                    }, Object.create(null));
                }
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && Xe(e, t);
                }(n, RegExp), n.prototype.exec = function(t) {
                    var n = e.exec.call(this, t);
                    if (n) {
                        n.groups = r(n, this);
                        var o = n.indices;
                        o && (o.groups = r(o, this));
                    }
                    return n;
                }, n.prototype[Symbol.replace] = function(n, o) {
                    if ("string" == typeof o) {
                        var i = t.get(this);
                        return e[Symbol.replace].call(this, n, o.replace(/\$<([^>]+)>/g, function(e, t) {
                            var n = i[t];
                            return "$" + (Array.isArray(n) ? n.join("$") : n);
                        }));
                    }
                    if ("function" == typeof o) {
                        var s = this;
                        return e[Symbol.replace].call(this, n, function() {
                            var e = arguments;
                            return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(r(e, s)), o.apply(this, e);
                        });
                    }
                    return e[Symbol.replace].call(this, n, o);
                }, Ge.apply(this, arguments);
            }
            function Ve(e, t, n) {
                return (t = function(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var n = e[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var r = n.call(e, "string");
                            if ("object" != typeof r) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" == typeof t ? t : String(t);
                }(t)) in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            function Xe(e, t) {
                return Xe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                }, Xe(e, t);
            }
            function Qe(e, t) {
                if (e) {
                    if ("string" == typeof e) return Ze(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ze(e, t) : void 0;
                }
            }
            function Ze(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
                return r;
            }
            function Ye() {}
            var et = function(e) {
                return new Promise(function(t) {
                    setTimeout(t, e);
                });
            }, tt = function(e) {
                return Math.pow(Math.SQRT2, e);
            }, nt = Ge(/(\d+)(%)/, {
                value: 1
            });
            function rt(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 7, n = t;
                if (nt.test(e)) {
                    var r, o = null === (r = e.match(nt)) || void 0 === r ? void 0 : r.groups;
                    if (o && o.value) {
                        var i = parseInt(o.value) / 100;
                        n = Math.round(t * i);
                    }
                }
                return Math.min(30, Math.max(1, n));
            }
            function ot(e, t) {
                return t("info", "Throttle request to ".concat(e, "/s")), ze()({
                    limit: e,
                    interval: 1e3,
                    strict: !1
                });
            }
            var it = function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "auto", n = e.defaults.logHandler, r = void 0 === n ? Ye : n, o = qe()(t) ? rt(t) : rt("auto", t), i = ot(o, r), s = !1, a = e.interceptors.request.use(function(e) {
                    return i(function() {
                        return e;
                    })();
                }, function(e) {
                    return Promise.reject(e);
                }), c = e.interceptors.response.use(function(n) {
                    if (!s && qe()(t) && ("auto" === t || nt.test(t)) && n.headers && n.headers["x-contentful-ratelimit-second-limit"]) {
                        var c = parseInt(n.headers["x-contentful-ratelimit-second-limit"]), u = rt(t, c);
                        u !== o && (a && e.interceptors.request.eject(a), o = u, i = ot(u, r), a = e.interceptors.request.use(function(e) {
                            return i(function() {
                                return e;
                            })();
                        }, function(e) {
                            return Promise.reject(e);
                        })), s = !0;
                    }
                    return n;
                }, function(e) {
                    return Promise.reject(e);
                });
                return function() {
                    e.interceptors.request.eject(a), e.interceptors.response.eject(c);
                };
            }, st = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
            function at(e, t) {
                var n = Je(Je({}, {
                    insecure: !1,
                    retryOnError: !0,
                    logHandler: function(e, t) {
                        if ("error" === e && t) {
                            var n = [
                                t.name,
                                t.message
                            ].filter(function(e) {
                                return e;
                            }).join(" - ");
                            return console.error("[error] ".concat(n)), void console.error(t);
                        }
                        console.log("[".concat(e, "] ").concat(t));
                    },
                    headers: {},
                    httpAgent: !1,
                    httpsAgent: !1,
                    timeout: 3e4,
                    throttle: 0,
                    basePath: "",
                    adapter: void 0,
                    maxContentLength: 1073741824,
                    maxBodyLength: 1073741824
                }), t);
                if (!n.accessToken) {
                    var r = new TypeError("Expected parameter accessToken");
                    throw n.logHandler("error", r), r;
                }
                var o, i, s = n.insecure ? "http" : "https", a = n.space ? "".concat(n.space, "/") : "", c = n.defaultHostname, u = n.insecure ? 80 : 443;
                if (n.host && st.test(n.host)) {
                    var l = n.host.split(":");
                    if (2 === l.length) {
                        var f = (i = 2, function(e) {
                            if (Array.isArray(e)) return e;
                        }(o = l) || function(e, t) {
                            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                            if (null != n) {
                                var r, o, i, s, a = [], c = !0, u = !1;
                                try {
                                    if (i = (n = n.call(e)).next, 0 === t) {
                                        if (Object(n) !== n) return;
                                        c = !1;
                                    } else for(; !(c = (r = i.call(n)).done) && (a.push(r.value), a.length !== t); c = !0);
                                } catch (e) {
                                    u = !0, o = e;
                                } finally{
                                    try {
                                        if (!c && null != n.return && (s = n.return(), Object(s) !== s)) return;
                                    } finally{
                                        if (u) throw o;
                                    }
                                }
                                return a;
                            }
                        }(o, i) || Qe(o, i) || function() {
                            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }());
                        c = f[0], u = f[1];
                    } else c = l[0];
                }
                n.basePath && (n.basePath = "/".concat(n.basePath.split("/").filter(Boolean).join("/")));
                var p = t.baseURL || "".concat(s, "://").concat(c, ":").concat(u).concat(n.basePath, "/spaces/").concat(a);
                n.headers.Authorization || "function" == typeof n.accessToken || (n.headers.Authorization = "Bearer " + n.accessToken);
                var d = {
                    baseURL: p,
                    headers: n.headers,
                    httpAgent: n.httpAgent,
                    httpsAgent: n.httpsAgent,
                    proxy: n.proxy,
                    timeout: n.timeout,
                    adapter: n.adapter,
                    maxContentLength: n.maxContentLength,
                    maxBodyLength: n.maxBodyLength,
                    logHandler: n.logHandler,
                    responseLogger: n.responseLogger,
                    requestLogger: n.requestLogger,
                    retryOnError: n.retryOnError
                }, h = e.create(d);
                return h.httpClientParams = t, h.cloneWithNewParams = function(n) {
                    return at(e, Je(Je({}, Fe()(t)), n));
                }, n.onBeforeRequest && h.interceptors.request.use(n.onBeforeRequest), "function" == typeof n.accessToken && function(e, t) {
                    e.interceptors.request.use(function(e) {
                        return t().then(function(t) {
                            return e.headers.set("Authorization", "Bearer ".concat(t)), e;
                        });
                    });
                }(h, n.accessToken), n.throttle && it(h, n.throttle), function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5, n = e.defaults, r = n.responseLogger, o = void 0 === r ? Ye : r, i = n.requestLogger, s = void 0 === i ? Ye : i;
                    e.interceptors.request.use(function(e) {
                        return s(e), e;
                    }, function(e) {
                        return s(e), Promise.reject(e);
                    }), e.interceptors.response.use(function(e) {
                        return o(e), e;
                    }, function(n) {
                        var r = n.response, i = n.config;
                        if (o(n), !i || !e.defaults.retryOnError) return Promise.reject(n);
                        var s = i.attempts || 1;
                        if (s > t) return n.attempts = i.attempts, Promise.reject(n);
                        var a = null, c = tt(s);
                        return r ? r.status >= 500 && r.status < 600 ? a = "Server ".concat(r.status) : 429 === r.status && (a = "Rate limit", r.headers && n.response.headers["x-contentful-ratelimit-reset"] && (c = r.headers["x-contentful-ratelimit-reset"])) : a = "Connection", a ? (c = Math.floor(1e3 * c + 200 * Math.random() + 500), e.defaults.logHandler("warning", "".concat(a, " error occurred. Waiting for ").concat(c, " ms before retrying...")), i.attempts = s + 1, delete i.httpAgent, delete i.httpsAgent, et(c).then(function() {
                            return e(i);
                        })) : Promise.reject(n);
                    });
                }(h, n.retryLimit), n.onError && h.interceptors.response.use(function(e) {
                    return e;
                }, n.onError), h;
            }
            function ct(e) {
                var t = e.query, n = {};
                return delete t.resolveLinks, n.params = Fe()(t), n;
            }
            function ut(e) {
                var t, n = function(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = Qe(e))) {
                            n && (e = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, s = !0, a = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return s = e.done, e;
                        },
                        e: function(e) {
                            a = !0, i = e;
                        },
                        f: function() {
                            try {
                                s || null == n.return || n.return();
                            } finally{
                                if (a) throw i;
                            }
                        }
                    };
                }(Object.getOwnPropertyNames(e));
                try {
                    for(n.s(); !(t = n.n()).done;){
                        var r = e[t.value];
                        r && "object" === Ke(r) && ut(r);
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                return Object.freeze(e);
            }
            function lt() {
                var e = window;
                if (!e) return null;
                var t = e.navigator.userAgent, n = e.navigator.platform;
                return -1 !== [
                    "Macintosh",
                    "MacIntel",
                    "MacPPC",
                    "Mac68K"
                ].indexOf(n) ? "macOS" : -1 !== [
                    "iPhone",
                    "iPad",
                    "iPod"
                ].indexOf(n) ? "iOS" : -1 !== [
                    "Win32",
                    "Win64",
                    "Windows",
                    "WinCE"
                ].indexOf(n) ? "Windows" : /Android/.test(t) ? "Android" : /Linux/.test(n) ? "Linux" : null;
            }
            function ft(e) {
                return Object.defineProperty(e, "toPlainObject", {
                    enumerable: !1,
                    configurable: !1,
                    writable: !1,
                    value: function() {
                        return Fe()(this);
                    }
                });
            }
            function pt(e) {
                var t, n = e.config, r = e.response;
                if (n && n.headers && n.headers.Authorization) {
                    var o = "...".concat(n.headers.Authorization.toString().substr(-5));
                    n.headers.Authorization = "Bearer ".concat(o);
                }
                if (!He()(r) || !He()(n)) throw e;
                var i, s = null == r ? void 0 : r.data, a = {
                    status: null == r ? void 0 : r.status,
                    statusText: null == r ? void 0 : r.statusText,
                    message: "",
                    details: {}
                };
                n && He()(n) && (a.request = {
                    url: n.url,
                    headers: n.headers,
                    method: n.method,
                    payloadData: n.data
                }), s && "object" === Ke(s) && ("requestId" in s && (a.requestId = s.requestId || "UNKNOWN"), "message" in s && (a.message = s.message || ""), "details" in s && (a.details = s.details || {}), t = null === (i = s.sys) || void 0 === i ? void 0 : i.id);
                var c = new Error;
                c.name = t && "Unknown" !== t ? t : "".concat(null == r ? void 0 : r.status, " ").concat(null == r ? void 0 : r.statusText);
                try {
                    c.message = JSON.stringify(a, null, "  ");
                } catch (e) {
                    var u;
                    c.message = null !== (u = null == a ? void 0 : a.message) && void 0 !== u ? u : "";
                }
                throw c;
            }
            function dt(e) {
                return function(t) {
                    return Object.assign({}, e, t);
                };
            }
            var ht = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            function yt(e) {
                if (Array.isArray(e)) {
                    for(var t = 0, n = Array(e.length); t < e.length; t++)n[t] = e[t];
                    return n;
                }
                return Array.from(e);
            }
            var mt = {}, gt = function(e, t) {
                var n = t.entryId, r = t.linkType, o = t.spaceId, i = t.environmentId;
                return o && i ? e.get(o + "!" + i + "!" + r + "!" + n) : e.get(r + "!" + n);
            }, bt = function(e, t) {
                var n = t.sys, r = n.type, o = n.linkType;
                if ("ResourceLink" === r) {
                    var i = function(e) {
                        var t = /.*:spaces\/([^/]+)(?:\/environments\/([^/]+))?\/entries\/([^/]+)$/;
                        if (t.test(e)) {
                            var n = function(e, t) {
                                if (Array.isArray(e)) return e;
                                if (Symbol.iterator in Object(e)) return function(e, t) {
                                    var n = [], r = !0, o = !1, i = void 0;
                                    try {
                                        for(var s, a = e[Symbol.iterator](); !(r = (s = a.next()).done) && (n.push(s.value), !t || n.length !== t); r = !0);
                                    } catch (e) {
                                        o = !0, i = e;
                                    } finally{
                                        try {
                                            !r && a.return && a.return();
                                        } finally{
                                            if (o) throw i;
                                        }
                                    }
                                    return n;
                                }(e, t);
                                throw new TypeError("Invalid attempt to destructure non-iterable instance");
                            }(e.match(t), 4), r = (n[0], n[1]), o = n[2];
                            return {
                                spaceId: r,
                                environmentId: void 0 === o ? "master" : o,
                                entryId: n[3]
                            };
                        }
                    }(t.sys.urn), s = i.spaceId, a = i.environmentId, c = i.entryId, u = o.split(":")[1];
                    return gt(e, {
                        linkType: u,
                        entryId: c,
                        spaceId: s,
                        environmentId: a
                    }) || mt;
                }
                var l = t.sys.id;
                return gt(e, {
                    linkType: o,
                    entryId: l
                }) || mt;
            }, vt = function e(t, n, r, o) {
                if (n(t)) return r(t);
                if (t && "object" === (void 0 === t ? "undefined" : ht(t))) {
                    for(var i in t)t.hasOwnProperty(i) && (t[i] = e(t[i], n, r, o));
                    o && (t = function(e) {
                        if (Array.isArray(e)) return e.filter(function(e) {
                            return e !== mt;
                        });
                        for(var t in e)e[t] === mt && delete e[t];
                        return e;
                    }(t));
                }
                return t;
            }, wt = function(e, t) {
                if (t = t || {}, !e.items) return [];
                var n = Fe()(e), r = Object.keys(n.includes || {}).reduce(function(t, n) {
                    return [].concat(yt(t), yt(e.includes[n]));
                }, []), o = [].concat(yt(n.items), yt(r)).filter(function(e) {
                    return Boolean(e.sys);
                }), i = new Map(o.reduce(function(e, t) {
                    var n, r = (n = t.sys, n.space && n.environment ? [
                        n.type + "!" + n.id,
                        n.space.sys.id + "!" + n.environment.sys.id + "!" + n.type + "!" + n.id
                    ] : [
                        n.type + "!" + n.id
                    ]).map(function(e) {
                        return [
                            e,
                            t
                        ];
                    });
                    return e.push.apply(e, yt(r)), e;
                }, []));
                return o.forEach(function(e) {
                    var n = function(e, t) {
                        return Array.isArray(t) ? Object.keys(e).filter(function(e) {
                            return -1 !== t.indexOf(e);
                        }).reduce(function(t, n) {
                            return t[n] = e[n], t;
                        }, {}) : e;
                    }(e, t.itemEntryPoints);
                    Object.assign(e, vt(n, function(e) {
                        var t;
                        return (t = e) && t.sys && "Link" === t.sys.type || function(e) {
                            return e && e.sys && "ResourceLink" === e.sys.type;
                        }(e);
                    }, function(e) {
                        return function(e, t, n) {
                            var r = bt(e, t);
                            return r === mt ? n ? r : t : r;
                        }(i, e, t.removeUnresolved);
                    }, t.removeUnresolved));
                }), n.items;
            }, Ot = n(784), Et = n.n(Ot);
            function St(e) {
                return Object.defineProperty(e, "stringifySafe", {
                    enumerable: !1,
                    configurable: !1,
                    writable: !1,
                    value: function(e = null, t = "") {
                        return Et()(this, e, t, (e, t)=>({
                                sys: {
                                    type: "Link",
                                    linkType: "Entry",
                                    id: t.sys.id,
                                    circular: !0
                                }
                            }));
                    }
                });
            }
            async function xt(e, t, n) {
                if (!t || !t.initial && !t.nextSyncToken && !t.nextPageToken) throw new Error("Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing");
                if (t.content_type && !t.type) t.type = "Entry";
                else if (t.content_type && t.type && "Entry" !== t.type) throw new Error("When using the `content_type` filter your `type` parameter cannot be different from `Entry`.");
                const { withoutLinkResolution: r, withoutUnresolvableLinks: o, paginate: i } = {
                    withoutLinkResolution: !1,
                    withoutUnresolvableLinks: !1,
                    paginate: !0,
                    ...n
                }, s = await At(e, [], t, {
                    paginate: i
                });
                r || (s.items = wt(s, {
                    removeUnresolved: o,
                    itemEntryPoints: [
                        "fields"
                    ]
                }));
                const a = function(e) {
                    const t = (e)=>(t, n)=>(n.sys.type === e && t.push(ft(n)), t);
                    return {
                        entries: e.reduce(t("Entry"), []),
                        assets: e.reduce(t("Asset"), []),
                        deletedEntries: e.reduce(t("DeletedEntry"), []),
                        deletedAssets: e.reduce(t("DeletedAsset"), [])
                    };
                }(s.items);
                var c;
                return s.nextSyncToken && (a.nextSyncToken = s.nextSyncToken), s.nextPageToken && (a.nextPageToken = s.nextPageToken), ut((c = St(ft(a))).sys || {}), c;
            }
            async function At(e, t, n, { paginate: r }) {
                const o = (i = n).nextPageToken ? {
                    sync_token: i.nextPageToken
                } : i.nextSyncToken ? {
                    sync_token: i.nextSyncToken
                } : i.sync_token ? {
                    sync_token: i.sync_token
                } : i;
                var i;
                const s = (await e.get("sync", ct({
                    query: o
                }))).data || {};
                return t = t.concat(s.items || []), s.nextPageUrl ? r ? (delete o.initial, o.sync_token = jt(s.nextPageUrl), At(e, t, o, {
                    paginate: r
                })) : {
                    items: t,
                    nextPageToken: jt(s.nextPageUrl)
                } : s.nextSyncUrl ? {
                    items: t,
                    nextSyncToken: jt(s.nextSyncUrl)
                } : {
                    items: []
                };
            }
            function jt(e) {
                const t = e.split("?");
                return t.length > 0 ? t[1].replace("sync_token=", "") : "";
            }
            function Tt(e) {
                const t = {};
                let n = !1;
                for(const r in e)Array.isArray(e[r]) && (t[r] = e[r].join(","), n = !0);
                return n ? {
                    ...e,
                    ...t
                } : e;
            }
            function Rt(e) {
                if (!e.select) return e;
                const t = Array.isArray(e.select) ? e.select : e.select.split(",").map((e)=>e.trim()), n = new Set(t);
                return n.has("sys") ? e : (n.add("sys.id"), n.add("sys.type"), {
                    ...e,
                    select: [
                        ...n
                    ].join(",")
                });
            }
            function Lt(e, { resolveLinks: t, removeUnresolved: n }) {
                const r = St(e);
                return t && (r.items = wt(r, {
                    removeUnresolved: n,
                    itemEntryPoints: [
                        "fields"
                    ]
                })), r;
            }
            class kt extends Error {
                constructor(e, t){
                    super(`Invalid "${e}" provided, ` + t), this.name = "ValidationError";
                }
            }
            function Pt(e, t) {
                t ? function(e) {
                    if (e.locale) throw new kt("locale", "The `locale` parameter is not allowed");
                }(e) : function(e) {
                    if ("*" === e.locale) throw new kt("locale", "The use of locale='*' is no longer supported.To fetch an entry in all existing locales, \n      use client.withAllLocales instead of the locale='*' parameter.");
                }(e);
            }
            function Ut(e) {
                if ("resolveLinks" in e) throw new kt("resolveLinks", "The use of the 'resolveLinks' parameter is no longer supported. By default, links are resolved. \n      If you do not want to resolve links, use client.withoutLinkResolution.");
            }
            function _t(e) {
                if ("removeUnresolved" in e) throw new kt("removeUnresolved", "The use of the 'removeUnresolved' parameter is no longer supported. By default, unresolved links are kept as link objects.\n      If you do not want to include unresolved links, use client.withoutUnresolvableLinks.");
            }
            function Nt(e) {
                for(const t in e){
                    const n = e[t];
                    if ("object" == typeof n && null !== n && !Array.isArray(n)) throw new Error(`Objects are not supported as value for the "${t}" query parameter.`);
                }
            }
            class Ct extends Error {
                sys;
                details;
                constructor(e, t, n){
                    super("The resource could not be found."), this.sys = {
                        type: "Error",
                        id: "NotFound"
                    }, this.details = {
                        type: "Entry",
                        id: e,
                        environment: t,
                        space: n
                    };
                }
            }
            function Bt({ http: e, getGlobalOptions: t }, n) {
                const r = (e = "unknown")=>new Ct(e, t().environment, t().space), o = (e)=>{
                    let n = "space" === e ? t().spaceBaseUrl : t().environmentBaseUrl;
                    if (!n) throw new Error("Please define baseUrl for " + e);
                    return n.endsWith("/") || (n += "/"), n;
                };
                async function i({ context: t, path: n, config: r }) {
                    const i = o(t);
                    try {
                        return (await e.get(i + n, r)).data;
                    } catch (e) {
                        pt(e);
                    }
                }
                async function s(e, t) {
                    const { withoutLinkResolution: n, withoutUnresolvableLinks: r } = t;
                    try {
                        return Lt(await i({
                            context: "environment",
                            path: "entries",
                            config: ct({
                                query: Tt(Rt(e))
                            })
                        }), {
                            resolveLinks: !n ?? !0,
                            removeUnresolved: r ?? !1
                        });
                    } catch (e) {
                        pt(e);
                    }
                }
                return {
                    version: "10.6.5",
                    getSpace: async function() {
                        return i({
                            context: "space",
                            path: ""
                        });
                    },
                    getContentType: async function(e) {
                        return i({
                            context: "environment",
                            path: `content_types/${e}`
                        });
                    },
                    getContentTypes: async function(e = {}) {
                        return i({
                            context: "environment",
                            path: "content_types",
                            config: ct({
                                query: e
                            })
                        });
                    },
                    getAsset: async function(e, t = {}) {
                        return async function(e, t, n = {
                            withAllLocales: !1,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !1
                        }) {
                            const { withAllLocales: r } = n;
                            Pt(t, r), Nt(t);
                            return async function(e, t) {
                                try {
                                    return i({
                                        context: "environment",
                                        path: `assets/${e}`,
                                        config: ct({
                                            query: Rt(t)
                                        })
                                    });
                                } catch (e) {
                                    pt(e);
                                }
                            }(e, r ? {
                                ...t,
                                locale: "*"
                            } : t);
                        }(e, t, n);
                    },
                    getAssets: async function(e = {}) {
                        return async function(e, t = {
                            withAllLocales: !1,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !1
                        }) {
                            const { withAllLocales: n } = t;
                            Pt(e, n), Nt(e);
                            return async function(e) {
                                try {
                                    return i({
                                        context: "environment",
                                        path: "assets",
                                        config: ct({
                                            query: Tt(Rt(e))
                                        })
                                    });
                                } catch (e) {
                                    pt(e);
                                }
                            }(n ? {
                                ...e,
                                locale: "*"
                            } : e);
                        }(e, n);
                    },
                    getTag: async function(e) {
                        return i({
                            context: "environment",
                            path: `tags/${e}`
                        });
                    },
                    getTags: async function(e = {}) {
                        return Nt(e), i({
                            context: "environment",
                            path: "tags",
                            config: ct({
                                query: Tt(Rt(e))
                            })
                        });
                    },
                    getLocales: async function(e = {}) {
                        return Nt(e), i({
                            context: "environment",
                            path: "locales",
                            config: ct({
                                query: Rt(e)
                            })
                        });
                    },
                    parseEntries: function(e) {
                        return function(e, t = {
                            withAllLocales: !1,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !1
                        }) {
                            return function(e, t) {
                                const { withoutLinkResolution: n, withoutUnresolvableLinks: r } = t;
                                return Lt(e, {
                                    resolveLinks: !n ?? !0,
                                    removeUnresolved: r ?? !1
                                });
                            }(e, t);
                        }(e, n);
                    },
                    sync: async function(r, o = {
                        paginate: !0
                    }) {
                        return async function(n, r, o = {
                            withAllLocales: !1,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !1
                        }) {
                            Ut(n), _t(n);
                            const i = {
                                ...r,
                                ...o
                            };
                            return function(e) {
                                e.defaults.baseURL = t().environmentBaseUrl;
                            }(e), xt(e, n, i);
                        }(r, o, n);
                    },
                    getEntry: async function(e, t = {}) {
                        return async function(e, t, n = {
                            withAllLocales: !1,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !1
                        }) {
                            const { withAllLocales: o } = n;
                            return Pt(t, o), Ut(t), _t(t), Nt(t), async function(e, t, n) {
                                if (!e) throw r(e);
                                try {
                                    const o = await s({
                                        "sys.id": e,
                                        ...t
                                    }, n);
                                    if (o.items.length > 0) return o.items[0];
                                    throw r(e);
                                } catch (e) {
                                    pt(e);
                                }
                            }(e, o ? {
                                ...t,
                                locale: "*"
                            } : t, n);
                        }(e, t, n);
                    },
                    getEntries: async function(e = {}) {
                        return async function(e, t = {
                            withAllLocales: !1,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !1
                        }) {
                            const { withAllLocales: n } = t;
                            return Pt(e, n), Ut(e), _t(e), Nt(e), s(n ? {
                                ...e,
                                locale: "*"
                            } : e, t);
                        }(e, n);
                    },
                    createAssetKey: async function(t) {
                        try {
                            const e = Math.floor(Date.now() / 1e3);
                            !function(e, t, n) {
                                if (n = n || {}, "number" != typeof t) throw new kt(e, `only numeric values are allowed for timestamps, provided type was "${typeof t}"`);
                                if (n.maximum && t > n.maximum) throw new kt(e, `value (${t}) cannot be further in the future than expected maximum (${n.maximum})`);
                                if (n.now && t < n.now) throw new kt(e, `value (${t}) cannot be in the past, current time was ${n.now}`);
                            }("expiresAt", t, {
                                maximum: e + 172800,
                                now: e
                            });
                        } catch (e) {
                            pt(e);
                        }
                        return async function({ context: t, path: n, data: r, config: i }) {
                            const s = o(t);
                            try {
                                return (await e.post(s + n, r, i)).data;
                            } catch (e) {
                                pt(e);
                            }
                        }({
                            context: "environment",
                            path: "asset_keys",
                            data: {
                                expiresAt: t
                            }
                        });
                    }
                };
            }
            const Dt = ({ http: e, getGlobalOptions: t })=>{
                function n(r) {
                    return function({ http: e, getGlobalOptions: t }, n, r) {
                        const o = Bt({
                            http: e,
                            getGlobalOptions: t
                        }, n);
                        return Object.defineProperty(o, "withAllLocales", {
                            get: ()=>r({
                                    ...n,
                                    withAllLocales: !0
                                })
                        }), Object.defineProperty(o, "withoutLinkResolution", {
                            get: ()=>r({
                                    ...n,
                                    withoutLinkResolution: !0
                                })
                        }), Object.defineProperty(o, "withoutUnresolvableLinks", {
                            get: ()=>r({
                                    ...n,
                                    withoutUnresolvableLinks: !0
                                })
                        }), Object.create(o);
                    }({
                        http: e,
                        getGlobalOptions: t
                    }, r, n);
                }
                return {
                    ...Bt({
                        http: e,
                        getGlobalOptions: t
                    }, {
                        withoutLinkResolution: !1,
                        withAllLocales: !1,
                        withoutUnresolvableLinks: !1
                    }),
                    get withAllLocales () {
                        return n({
                            withAllLocales: !0,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !1
                        });
                    },
                    get withoutLinkResolution () {
                        return n({
                            withAllLocales: !1,
                            withoutLinkResolution: !0,
                            withoutUnresolvableLinks: !1
                        });
                    },
                    get withoutUnresolvableLinks () {
                        return n({
                            withAllLocales: !1,
                            withoutLinkResolution: !1,
                            withoutUnresolvableLinks: !0
                        });
                    }
                };
            };
            function Ft(e) {
                if (!e.accessToken) throw new TypeError("Expected parameter accessToken");
                if (!e.space) throw new TypeError("Expected parameter space");
                Ut(e), _t(e);
                const t = {
                    resolveLinks: !0,
                    removeUnresolved: !1,
                    defaultHostname: "cdn.contentful.com",
                    environment: "master",
                    ...e
                }, n = function(e, t, n, r) {
                    var o = [];
                    t && o.push("app ".concat(t)), n && o.push("integration ".concat(n)), r && o.push("feature " + r), o.push("sdk ".concat(e));
                    var i = null;
                    try {
                        "undefined" != typeof window && "navigator" in window && "product" in window.navigator && "ReactNative" === window.navigator.product ? (i = lt(), o.push("platform ReactNative")) : (i = lt(), o.push("platform browser"));
                    } catch (e) {
                        i = null;
                    }
                    return i && o.push("os ".concat(i)), "".concat(o.filter(function(e) {
                        return "" !== e;
                    }).join("; "), ";");
                }("contentful.js/10.6.5", t.application, t.integration);
                t.headers = {
                    ...t.headers,
                    "Content-Type": "application/vnd.contentful.delivery.v1+json",
                    "X-Contentful-User-Agent": n
                };
                const r = at(Be, t);
                if (!r.defaults.baseURL) throw new Error("Please define a baseURL");
                const o = dt({
                    space: t.space,
                    environment: t.environment,
                    spaceBaseUrl: r.defaults.baseURL,
                    environmentBaseUrl: `${r.defaults.baseURL}environments/${t.environment}`
                });
                return r.defaults.baseURL = o({}).environmentBaseUrl, Dt({
                    http: r,
                    getGlobalOptions: o
                });
            }
        }(), r;
    }();
});

});
parcelRegister("k90pP", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $eaa4f86d35a184a8$export$a143d493d941bafc; }, function (v) { return $eaa4f86d35a184a8$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $eaa4f86d35a184a8$export$f99ded8fe4b79145; }, function (v) { return $eaa4f86d35a184a8$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $eaa4f86d35a184a8$export$a143d493d941bafc;
var $eaa4f86d35a184a8$export$e4cf37d7f6fb9e0a;
var $eaa4f86d35a184a8$export$f99ded8fe4b79145;
var $eaa4f86d35a184a8$export$599f31c3813fae4d;
'use strict';

var $kojg4 = parcelRequire("kojg4");

var $lH2re = parcelRequire("lH2re");
var $eaa4f86d35a184a8$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$eaa4f86d35a184a8$export$a143d493d941bafc = $eaa4f86d35a184a8$var$Buffer;
$eaa4f86d35a184a8$export$e4cf37d7f6fb9e0a = $eaa4f86d35a184a8$var$SlowBuffer;
$eaa4f86d35a184a8$export$f99ded8fe4b79145 = 50;
var $eaa4f86d35a184a8$var$K_MAX_LENGTH = 0x7fffffff;
$eaa4f86d35a184a8$export$599f31c3813fae4d = $eaa4f86d35a184a8$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $eaa4f86d35a184a8$var$Buffer.TYPED_ARRAY_SUPPORT = $eaa4f86d35a184a8$var$typedArraySupport();
if (!$eaa4f86d35a184a8$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $eaa4f86d35a184a8$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($eaa4f86d35a184a8$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($eaa4f86d35a184a8$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $eaa4f86d35a184a8$var$createBuffer(length) {
    if (length > $eaa4f86d35a184a8$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $eaa4f86d35a184a8$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $eaa4f86d35a184a8$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $eaa4f86d35a184a8$var$allocUnsafe(arg);
    }
    return $eaa4f86d35a184a8$var$from(arg, encodingOrOffset, length);
}
$eaa4f86d35a184a8$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $eaa4f86d35a184a8$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $eaa4f86d35a184a8$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $eaa4f86d35a184a8$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($eaa4f86d35a184a8$var$isInstance(value, ArrayBuffer) || value && $eaa4f86d35a184a8$var$isInstance(value.buffer, ArrayBuffer)) return $eaa4f86d35a184a8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($eaa4f86d35a184a8$var$isInstance(value, SharedArrayBuffer) || value && $eaa4f86d35a184a8$var$isInstance(value.buffer, SharedArrayBuffer))) return $eaa4f86d35a184a8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $eaa4f86d35a184a8$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $eaa4f86d35a184a8$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $eaa4f86d35a184a8$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $eaa4f86d35a184a8$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $eaa4f86d35a184a8$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($eaa4f86d35a184a8$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($eaa4f86d35a184a8$var$Buffer, Uint8Array);
function $eaa4f86d35a184a8$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $eaa4f86d35a184a8$var$alloc(size, fill, encoding) {
    $eaa4f86d35a184a8$var$assertSize(size);
    if (size <= 0) return $eaa4f86d35a184a8$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $eaa4f86d35a184a8$var$createBuffer(size).fill(fill, encoding) : $eaa4f86d35a184a8$var$createBuffer(size).fill(fill);
    return $eaa4f86d35a184a8$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $eaa4f86d35a184a8$var$Buffer.alloc = function(size, fill, encoding) {
    return $eaa4f86d35a184a8$var$alloc(size, fill, encoding);
};
function $eaa4f86d35a184a8$var$allocUnsafe(size) {
    $eaa4f86d35a184a8$var$assertSize(size);
    return $eaa4f86d35a184a8$var$createBuffer(size < 0 ? 0 : $eaa4f86d35a184a8$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $eaa4f86d35a184a8$var$Buffer.allocUnsafe = function(size) {
    return $eaa4f86d35a184a8$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $eaa4f86d35a184a8$var$Buffer.allocUnsafeSlow = function(size) {
    return $eaa4f86d35a184a8$var$allocUnsafe(size);
};
function $eaa4f86d35a184a8$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$eaa4f86d35a184a8$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $eaa4f86d35a184a8$var$byteLength(string, encoding) | 0;
    var buf = $eaa4f86d35a184a8$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $eaa4f86d35a184a8$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $eaa4f86d35a184a8$var$checked(array.length) | 0;
    var buf = $eaa4f86d35a184a8$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $eaa4f86d35a184a8$var$fromArrayView(arrayView) {
    if ($eaa4f86d35a184a8$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $eaa4f86d35a184a8$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $eaa4f86d35a184a8$var$fromArrayLike(arrayView);
}
function $eaa4f86d35a184a8$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $eaa4f86d35a184a8$var$Buffer.prototype);
    return buf;
}
function $eaa4f86d35a184a8$var$fromObject(obj) {
    if ($eaa4f86d35a184a8$var$Buffer.isBuffer(obj)) {
        var len = $eaa4f86d35a184a8$var$checked(obj.length) | 0;
        var buf = $eaa4f86d35a184a8$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $eaa4f86d35a184a8$var$numberIsNaN(obj.length)) return $eaa4f86d35a184a8$var$createBuffer(0);
        return $eaa4f86d35a184a8$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $eaa4f86d35a184a8$var$fromArrayLike(obj.data);
}
function $eaa4f86d35a184a8$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $eaa4f86d35a184a8$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $eaa4f86d35a184a8$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $eaa4f86d35a184a8$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $eaa4f86d35a184a8$var$Buffer.alloc(+length);
}
$eaa4f86d35a184a8$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $eaa4f86d35a184a8$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$eaa4f86d35a184a8$var$Buffer.compare = function compare(a, b) {
    if ($eaa4f86d35a184a8$var$isInstance(a, Uint8Array)) a = $eaa4f86d35a184a8$var$Buffer.from(a, a.offset, a.byteLength);
    if ($eaa4f86d35a184a8$var$isInstance(b, Uint8Array)) b = $eaa4f86d35a184a8$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(a) || !$eaa4f86d35a184a8$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$eaa4f86d35a184a8$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$eaa4f86d35a184a8$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $eaa4f86d35a184a8$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $eaa4f86d35a184a8$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($eaa4f86d35a184a8$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $eaa4f86d35a184a8$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $eaa4f86d35a184a8$var$byteLength(string, encoding) {
    if ($eaa4f86d35a184a8$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $eaa4f86d35a184a8$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $eaa4f86d35a184a8$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $eaa4f86d35a184a8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $eaa4f86d35a184a8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$eaa4f86d35a184a8$var$Buffer.byteLength = $eaa4f86d35a184a8$var$byteLength;
function $eaa4f86d35a184a8$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $eaa4f86d35a184a8$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $eaa4f86d35a184a8$var$utf8Slice(this, start, end);
        case 'ascii':
            return $eaa4f86d35a184a8$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $eaa4f86d35a184a8$var$latin1Slice(this, start, end);
        case 'base64':
            return $eaa4f86d35a184a8$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $eaa4f86d35a184a8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$eaa4f86d35a184a8$var$Buffer.prototype._isBuffer = true;
function $eaa4f86d35a184a8$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$eaa4f86d35a184a8$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$eaa4f86d35a184a8$var$swap(this, i, i + 1);
    return this;
};
$eaa4f86d35a184a8$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $eaa4f86d35a184a8$var$swap(this, i, i + 3);
        $eaa4f86d35a184a8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$eaa4f86d35a184a8$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $eaa4f86d35a184a8$var$swap(this, i, i + 7);
        $eaa4f86d35a184a8$var$swap(this, i + 1, i + 6);
        $eaa4f86d35a184a8$var$swap(this, i + 2, i + 5);
        $eaa4f86d35a184a8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$eaa4f86d35a184a8$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $eaa4f86d35a184a8$var$utf8Slice(this, 0, length);
    return $eaa4f86d35a184a8$var$slowToString.apply(this, arguments);
};
$eaa4f86d35a184a8$var$Buffer.prototype.toLocaleString = $eaa4f86d35a184a8$var$Buffer.prototype.toString;
$eaa4f86d35a184a8$var$Buffer.prototype.equals = function equals(b) {
    if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $eaa4f86d35a184a8$var$Buffer.compare(this, b) === 0;
};
$eaa4f86d35a184a8$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $eaa4f86d35a184a8$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($eaa4f86d35a184a8$var$customInspectSymbol) $eaa4f86d35a184a8$var$Buffer.prototype[$eaa4f86d35a184a8$var$customInspectSymbol] = $eaa4f86d35a184a8$var$Buffer.prototype.inspect;
$eaa4f86d35a184a8$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($eaa4f86d35a184a8$var$isInstance(target, Uint8Array)) target = $eaa4f86d35a184a8$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $eaa4f86d35a184a8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($eaa4f86d35a184a8$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $eaa4f86d35a184a8$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($eaa4f86d35a184a8$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $eaa4f86d35a184a8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $eaa4f86d35a184a8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $eaa4f86d35a184a8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$eaa4f86d35a184a8$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$eaa4f86d35a184a8$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $eaa4f86d35a184a8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$eaa4f86d35a184a8$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $eaa4f86d35a184a8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $eaa4f86d35a184a8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($eaa4f86d35a184a8$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $eaa4f86d35a184a8$var$utf8Write(buf, string, offset, length) {
    return $eaa4f86d35a184a8$var$blitBuffer($eaa4f86d35a184a8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $eaa4f86d35a184a8$var$asciiWrite(buf, string, offset, length) {
    return $eaa4f86d35a184a8$var$blitBuffer($eaa4f86d35a184a8$var$asciiToBytes(string), buf, offset, length);
}
function $eaa4f86d35a184a8$var$base64Write(buf, string, offset, length) {
    return $eaa4f86d35a184a8$var$blitBuffer($eaa4f86d35a184a8$var$base64ToBytes(string), buf, offset, length);
}
function $eaa4f86d35a184a8$var$ucs2Write(buf, string, offset, length) {
    return $eaa4f86d35a184a8$var$blitBuffer($eaa4f86d35a184a8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$eaa4f86d35a184a8$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $eaa4f86d35a184a8$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $eaa4f86d35a184a8$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $eaa4f86d35a184a8$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $eaa4f86d35a184a8$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $eaa4f86d35a184a8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$eaa4f86d35a184a8$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $eaa4f86d35a184a8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kojg4.fromByteArray(buf);
    else return $kojg4.fromByteArray(buf.slice(start, end));
}
function $eaa4f86d35a184a8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $eaa4f86d35a184a8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $eaa4f86d35a184a8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $eaa4f86d35a184a8$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $eaa4f86d35a184a8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $eaa4f86d35a184a8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $eaa4f86d35a184a8$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $eaa4f86d35a184a8$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $eaa4f86d35a184a8$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $eaa4f86d35a184a8$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $eaa4f86d35a184a8$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$eaa4f86d35a184a8$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $eaa4f86d35a184a8$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $eaa4f86d35a184a8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$eaa4f86d35a184a8$var$Buffer.prototype.readUintLE = $eaa4f86d35a184a8$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readUintBE = $eaa4f86d35a184a8$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readUint8 = $eaa4f86d35a184a8$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$eaa4f86d35a184a8$var$Buffer.prototype.readUint16LE = $eaa4f86d35a184a8$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readUint16BE = $eaa4f86d35a184a8$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$eaa4f86d35a184a8$var$Buffer.prototype.readUint32LE = $eaa4f86d35a184a8$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readUint32BE = $eaa4f86d35a184a8$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$eaa4f86d35a184a8$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$eaa4f86d35a184a8$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$eaa4f86d35a184a8$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 4, this.length);
    return $lH2re.read(this, offset, true, 23, 4);
};
$eaa4f86d35a184a8$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 4, this.length);
    return $lH2re.read(this, offset, false, 23, 4);
};
$eaa4f86d35a184a8$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 8, this.length);
    return $lH2re.read(this, offset, true, 52, 8);
};
$eaa4f86d35a184a8$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkOffset(offset, 8, this.length);
    return $lH2re.read(this, offset, false, 52, 8);
};
function $eaa4f86d35a184a8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$eaa4f86d35a184a8$var$Buffer.prototype.writeUintLE = $eaa4f86d35a184a8$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $eaa4f86d35a184a8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeUintBE = $eaa4f86d35a184a8$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $eaa4f86d35a184a8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeUint8 = $eaa4f86d35a184a8$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeUint16LE = $eaa4f86d35a184a8$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeUint16BE = $eaa4f86d35a184a8$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeUint32LE = $eaa4f86d35a184a8$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeUint32BE = $eaa4f86d35a184a8$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $eaa4f86d35a184a8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $eaa4f86d35a184a8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $eaa4f86d35a184a8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $eaa4f86d35a184a8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $lH2re.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$eaa4f86d35a184a8$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $eaa4f86d35a184a8$var$writeFloat(this, value, offset, true, noAssert);
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $eaa4f86d35a184a8$var$writeFloat(this, value, offset, false, noAssert);
};
function $eaa4f86d35a184a8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $eaa4f86d35a184a8$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $lH2re.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$eaa4f86d35a184a8$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $eaa4f86d35a184a8$var$writeDouble(this, value, offset, true, noAssert);
};
$eaa4f86d35a184a8$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $eaa4f86d35a184a8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$eaa4f86d35a184a8$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$eaa4f86d35a184a8$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$eaa4f86d35a184a8$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$eaa4f86d35a184a8$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $eaa4f86d35a184a8$var$Buffer.isBuffer(val) ? val : $eaa4f86d35a184a8$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $eaa4f86d35a184a8$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $eaa4f86d35a184a8$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($eaa4f86d35a184a8$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $eaa4f86d35a184a8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $eaa4f86d35a184a8$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $eaa4f86d35a184a8$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $eaa4f86d35a184a8$var$base64ToBytes(str) {
    return $kojg4.toByteArray($eaa4f86d35a184a8$var$base64clean(str));
}
function $eaa4f86d35a184a8$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $eaa4f86d35a184a8$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $eaa4f86d35a184a8$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $eaa4f86d35a184a8$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kojg4", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $ed84fcd6f11079a9$export$d622b2ad8d90c771; }, function (v) { return $ed84fcd6f11079a9$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $ed84fcd6f11079a9$export$6100ba28696e12de; }, function (v) { return $ed84fcd6f11079a9$export$6100ba28696e12de = v; });
var $ed84fcd6f11079a9$export$a48f0734ac7c2329;
var $ed84fcd6f11079a9$export$d622b2ad8d90c771;
var $ed84fcd6f11079a9$export$6100ba28696e12de;
'use strict';
$ed84fcd6f11079a9$export$a48f0734ac7c2329 = $ed84fcd6f11079a9$var$byteLength;
$ed84fcd6f11079a9$export$d622b2ad8d90c771 = $ed84fcd6f11079a9$var$toByteArray;
$ed84fcd6f11079a9$export$6100ba28696e12de = $ed84fcd6f11079a9$var$fromByteArray;
var $ed84fcd6f11079a9$var$lookup = [];
var $ed84fcd6f11079a9$var$revLookup = [];
var $ed84fcd6f11079a9$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $ed84fcd6f11079a9$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $ed84fcd6f11079a9$var$i = 0, $ed84fcd6f11079a9$var$len = $ed84fcd6f11079a9$var$code.length; $ed84fcd6f11079a9$var$i < $ed84fcd6f11079a9$var$len; ++$ed84fcd6f11079a9$var$i){
    $ed84fcd6f11079a9$var$lookup[$ed84fcd6f11079a9$var$i] = $ed84fcd6f11079a9$var$code[$ed84fcd6f11079a9$var$i];
    $ed84fcd6f11079a9$var$revLookup[$ed84fcd6f11079a9$var$code.charCodeAt($ed84fcd6f11079a9$var$i)] = $ed84fcd6f11079a9$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ed84fcd6f11079a9$var$revLookup['-'.charCodeAt(0)] = 62;
$ed84fcd6f11079a9$var$revLookup['_'.charCodeAt(0)] = 63;
function $ed84fcd6f11079a9$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ed84fcd6f11079a9$var$byteLength(b64) {
    var lens = $ed84fcd6f11079a9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ed84fcd6f11079a9$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ed84fcd6f11079a9$var$toByteArray(b64) {
    var tmp;
    var lens = $ed84fcd6f11079a9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ed84fcd6f11079a9$var$Arr($ed84fcd6f11079a9$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i)] << 18 | $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i)] << 2 | $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i)] << 10 | $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ed84fcd6f11079a9$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ed84fcd6f11079a9$var$tripletToBase64(num) {
    return $ed84fcd6f11079a9$var$lookup[num >> 18 & 0x3F] + $ed84fcd6f11079a9$var$lookup[num >> 12 & 0x3F] + $ed84fcd6f11079a9$var$lookup[num >> 6 & 0x3F] + $ed84fcd6f11079a9$var$lookup[num & 0x3F];
}
function $ed84fcd6f11079a9$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ed84fcd6f11079a9$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $ed84fcd6f11079a9$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ed84fcd6f11079a9$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ed84fcd6f11079a9$var$lookup[tmp >> 2] + $ed84fcd6f11079a9$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ed84fcd6f11079a9$var$lookup[tmp >> 10] + $ed84fcd6f11079a9$var$lookup[tmp >> 4 & 0x3F] + $ed84fcd6f11079a9$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("lH2re", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $fcaf814d13bcaa22$export$aafa59e2e03f2942; }, function (v) { return $fcaf814d13bcaa22$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $fcaf814d13bcaa22$export$68d8715fc104d294; }, function (v) { return $fcaf814d13bcaa22$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $fcaf814d13bcaa22$export$aafa59e2e03f2942;
var $fcaf814d13bcaa22$export$68d8715fc104d294;
$fcaf814d13bcaa22$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$fcaf814d13bcaa22$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("6Cvem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf01d55710175f55$export$2e2bcd8739ae039; });

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $gtsdT = parcelRequire("gtsdT");

var $bYgbs = parcelRequire("bYgbs");

var $5OqMf = parcelRequire("5OqMf");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $bcbvQ = parcelRequire("bcbvQ");
const $cf01d55710175f55$var$deliveryWindowStore = (0, $Kk7R3.makeAutoObservable)({
    windows: (0, $duLFK.initializeWithDefaultData)([]),
    windowsTableData: (0, $duLFK.initializeWithDefaultData)([]),
    fetchWindows: async ()=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) {
            (0, $gtsdT.logger).warn("delivery", "Fetch delivery windows called without being logged in or without a current company");
            return;
        }
        const transitionedSuccessfully = (0, $duLFK.setAsLoading)($cf01d55710175f55$var$deliveryWindowStore.windows);
        if (!transitionedSuccessfully) {
            (0, $gtsdT.logger).log("delivery", "Already fetching delivery windows... aborting!");
            return;
        }
        (0, $duLFK.setAsLoading)($cf01d55710175f55$var$deliveryWindowStore.windowsTableData);
        const url = `${(0, $bYgbs.getBaseUrl)("deliveryWindows")}/api/deliverywindow/${(0, $bcbvQ.default).currentCompany}/delivery-windows`;
        //const resp: DeliveryWindowResponse = await;
        (0, $3Y1Wx.apiClient)(url, (0, $bcbvQ.default).getSessionToken()).get().notFound(()=>{
            (0, $gtsdT.logger).log("delivery", "No delivery windows found for customer");
            (0, $duLFK.setAsDataAvailable)($cf01d55710175f55$var$deliveryWindowStore.windows, []);
            (0, $duLFK.setAsDataAvailable)($cf01d55710175f55$var$deliveryWindowStore.windowsTableData, []);
        }).json((resp)=>{
            const storeData = resp.deliveries.map((delivery)=>({
                    time: delivery.deliveryWindows.map((window)=>`${window.start} - ${window.stop}`).join(", "),
                    weekday: (0, $5OqMf.translateWeekday)(delivery.day)
                }));
            const windowsData = resp.deliveries.map((delivery)=>({
                    day: (0, $4udGV.englishDayToDay)(delivery.day),
                    periods: delivery.deliveryWindows
                })).filter((windowsData)=>typeof windowsData.day === "number");
            (0, $duLFK.setAsDataAvailable)($cf01d55710175f55$var$deliveryWindowStore.windows, storeData);
            (0, $duLFK.setAsDataAvailable)($cf01d55710175f55$var$deliveryWindowStore.windowsTableData, windowsData);
        }).catch((err)=>{
            (0, $gtsdT.logger).warn("delivery", "Failed to fetch delivery windows", err);
            (0, $duLFK.setAsErrorOccured)($cf01d55710175f55$var$deliveryWindowStore.windows, `${err}`);
            (0, $duLFK.setAsErrorOccured)($cf01d55710175f55$var$deliveryWindowStore.windowsTableData, `${err}`);
        });
    },
    clearCompanySpecificData: ()=>{
        $cf01d55710175f55$var$deliveryWindowStore.windows = (0, $duLFK.initializeWithDefaultData)([]);
        $cf01d55710175f55$var$deliveryWindowStore.windowsTableData = (0, $duLFK.initializeWithDefaultData)([]);
    }
});
var $cf01d55710175f55$export$2e2bcd8739ae039 = $cf01d55710175f55$var$deliveryWindowStore;

});

parcelRegister("jAf35", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2234b5cb9e1eb518$export$2e2bcd8739ae039; });

var $bEEBX = parcelRequire("bEEBX");

var $d4mYJ = parcelRequire("d4mYJ");

var $kneHr = parcelRequire("kneHr");

var $jf2w9 = parcelRequire("jf2w9");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");

var $bZiDo = parcelRequire("bZiDo");
const $2234b5cb9e1eb518$var$INITIAL_DELIVERY_FEE_DATA = (0, $duLFK.initializeWithDefaultData)({
    currentFee: null,
    nextFee: null
});
const $2234b5cb9e1eb518$var$deliveryFeeStore = (0, $Kk7R3.makeAutoObservable)({
    deliveryFee: $2234b5cb9e1eb518$var$INITIAL_DELIVERY_FEE_DATA,
    isDeliveryFeeEnabled: ()=>{
        return (0, $isIf6.default).deliveryFee.enabled && (0, $76PCP.default).orderType === (0, $isIf6.default).defaultOrderType;
    },
    currentDeliveryCharge: ()=>{
        return $2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee.data;
    },
    recalculateDeliveryCharge: ()=>{
        $2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee.data = {
            currentFee: null,
            nextFee: null
        };
        (0, $duLFK.setAsWaitingForData)($2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee);
        $2234b5cb9e1eb518$var$deliveryFeeStore.fetchDeliveryFee();
    },
    fetchDeliveryFee: (0, $d4mYJ.default)(()=>$2234b5cb9e1eb518$var$deliveryFeeStore.fetchDeliveryFeeWithoutDelay(), 500),
    fetchDeliveryFeeWithoutDelay: async ()=>{
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if (!$2234b5cb9e1eb518$var$deliveryFeeStore.isDeliveryFeeEnabled() || (0, $bEEBX.default)(currentDelivery)) {
            (0, $duLFK.setAsDataAvailable)($2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee, {
                currentFee: null,
                nextFee: null
            });
            return Promise.resolve();
        }
        const orderLines = (0, $76PCP.default).items.map((ci)=>({
                sku: ci.sku,
                qty: ci.qty,
                unit: ci.unit,
                orderLineTotal: (0, $kneHr.default)((0, $bZiDo.default).resolveSku(ci.sku)?.price, 0) * ci.qty
            }));
        if ((0, $76PCP.default).lostSales) for (const lostSale of (0, $76PCP.default).lostSales){
            const product = (0, $bZiDo.default).resolveSku(lostSale.sku);
            if (product) {
                const orderLine = {
                    orderLineTotal: Number(((product.price || 0) * lostSale.quantity).toFixed(2)),
                    sku: lostSale.sku,
                    qty: lostSale.quantity,
                    unit: product.unit
                };
                orderLines.push(orderLine);
            }
        }
        const totalPrice = orderLines.reduce((total, line)=>line.orderLineTotal + total, 0);
        const payload = {
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            deliveryDate: (0, $4udGV.formatISODate)(currentDelivery.date),
            totalPrice: totalPrice,
            orderType: (0, $76PCP.default).orderType,
            orderLines: orderLines
        };
        try {
            const controller = $2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee.abortController;
            const response = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/deliveryFeeInfo`, (0, $bcbvQ.default).getSessionToken(), controller).content("application/json").post(payload).json();
            const currentFee = (0, $jf2w9.default)(response.feeTypes, (ft)=>!(0, $bEEBX.default)(ft.limitMin) && !(0, $bEEBX.default)(ft.limitMax) && ft.limitMin < totalPrice && totalPrice <= ft.limitMax);
            const nextFee = (0, $jf2w9.default)(response.feeTypes, (ft)=>!(0, $bEEBX.default)(ft.limitMin) && ft.limitMin > totalPrice);
            (0, $duLFK.setAsDataAvailable)($2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee, {
                currentFee: (0, $kneHr.default)(currentFee, {
                    fee: 0
                }),
                nextFee: nextFee ?? null
            });
            (0, $gtsdT.logger).log("delivery", "Recalculated delivery fees: ", $2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee.data);
        } catch (err) {
            (0, $gtsdT.logger).warn("delivery", "Was not able to recalculate delivery fees.", err);
            (0, $duLFK.setAsErrorOccured)($2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee, `${err}`);
        }
    },
    clearCompanySpecificData: ()=>{
        $2234b5cb9e1eb518$var$deliveryFeeStore.deliveryFee = $2234b5cb9e1eb518$var$INITIAL_DELIVERY_FEE_DATA;
    }
});
var $2234b5cb9e1eb518$export$2e2bcd8739ae039 = $2234b5cb9e1eb518$var$deliveryFeeStore;

});

parcelRegister("1vlMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdd19ed0be1aa213$export$2e2bcd8739ae039; });

var $bIbDp = parcelRequire("bIbDp");
var $hOtDP = parcelRequire("hOtDP");

var $5LjUB = parcelRequire("5LjUB");

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $bYgbs = parcelRequire("bYgbs");

var $5WT79 = parcelRequire("5WT79");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");
const $bdd19ed0be1aa213$var$emptyDefaultFilters = {
    invoiceNumber: "",
    dueDate: {
        from: (0, $hOtDP.default)(new Date(), {
            months: 6
        }),
        to: (0, $bIbDp.default)(new Date(), {
            months: 2
        })
    },
    priceRange: {
        min: "",
        max: ""
    },
    statusKey: ""
};
const $bdd19ed0be1aa213$var$invoiceStore = (0, $Kk7R3.makeAutoObservable)({
    invoiceList: (0, $duLFK.initializeWithDefaultData)([]),
    filters: $bdd19ed0be1aa213$var$emptyDefaultFilters,
    fetch: async (url, params)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        (0, $duLFK.setAsWaitingForData)($bdd19ed0be1aa213$var$invoiceStore.invoiceList);
        try {
            const invoices = await (0, $3Y1Wx.apiClient)(url, (0, $bcbvQ.default).getSessionToken()).query(params).get().json();
            const filteredInvoices = invoices.filter((invoice)=>"status" in params ? invoice.status === params.status : true);
            (0, $duLFK.setAsDataAvailable)($bdd19ed0be1aa213$var$invoiceStore.invoiceList, filteredInvoices);
        } catch (errorObj) {
            (0, $duLFK.setAsErrorOccured)($bdd19ed0be1aa213$var$invoiceStore.invoiceList, `${errorObj}`);
        }
    },
    getStatuses: ()=>[
            {
                value: (0, $5WT79.INVOICE_STATUS).None,
                label: "Alle",
                color: "base"
            },
            {
                value: (0, $5WT79.INVOICE_STATUS).Paid,
                label: "Betalt",
                color: "success"
            },
            {
                value: (0, $5WT79.INVOICE_STATUS).PastDue,
                label: "Forfalt",
                color: "error"
            },
            {
                value: (0, $5WT79.INVOICE_STATUS).ReminderSent,
                label: "P\xe5minnelse sendt",
                color: "information"
            },
            {
                value: (0, $5WT79.INVOICE_STATUS).Unpaid,
                label: "Ubetalt",
                color: "warning"
            },
            {
                value: (0, $5WT79.INVOICE_STATUS).Credit,
                label: "Kreditert",
                color: "success"
            }
        ],
    getPredefindedIntervals: ()=>{
        const now = new Date();
        const oneMonthLater = (0, $bIbDp.default)(now, {
            months: 1
        });
        return [
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        months: 1
                    }),
                    oneMonthLater
                ],
                text: "Siste m\xe5neden"
            },
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        months: 3
                    }),
                    oneMonthLater
                ],
                text: "Siste tre m\xe5neder"
            },
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        months: 6
                    }),
                    oneMonthLater
                ],
                text: "Siste halv\xe5ret"
            },
            {
                value: [
                    (0, $hOtDP.default)(now, {
                        years: 1
                    }),
                    oneMonthLater
                ],
                text: "Siste \xe5ret"
            }
        ];
    },
    fetchInvoices: async (queryParams)=>{
        await $bdd19ed0be1aa213$var$invoiceStore.fetch(`${(0, $bYgbs.getBaseUrl)("invoices")}/api/invoices/customer/${(0, $bcbvQ.default).currentCompany}`, queryParams);
    },
    searchInvoices: async ()=>{
        const invoiceNumber = $bdd19ed0be1aa213$var$invoiceStore.filters.invoiceNumber;
        const dueDates = $bdd19ed0be1aa213$var$invoiceStore.filters.dueDate;
        const fromInvoiceAmount = $bdd19ed0be1aa213$var$invoiceStore.filters.priceRange.min;
        const toInvoiceAmount = $bdd19ed0be1aa213$var$invoiceStore.filters.priceRange.max;
        const status = $bdd19ed0be1aa213$var$invoiceStore.filters.statusKey;
        const commonParameters = {
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            division: (0, $isIf6.default).m3DivisionNumber
        };
        const queryParams = !(0, $bEEBX.default)(invoiceNumber) && !(0, $5LjUB.default)(invoiceNumber) ? {
            invoiceNumber: invoiceNumber,
            ...commonParameters
        } : {
            ...commonParameters,
            ...dueDates?.from && {
                fromDueDate: (0, $4udGV.formatISODate)(dueDates.from)
            },
            ...dueDates?.to && {
                toDueDate: (0, $4udGV.formatISODate)(dueDates.to)
            },
            ...fromInvoiceAmount && {
                fromInvoiceAmount: Number.parseInt(fromInvoiceAmount)
            },
            ...toInvoiceAmount && {
                toInvoiceAmount: Number.parseInt(toInvoiceAmount)
            },
            ...status && status !== (0, $5WT79.INVOICE_STATUS).None && {
                status: status
            }
        };
        await $bdd19ed0be1aa213$var$invoiceStore.fetchInvoices(queryParams);
    },
    updateInvoiceNumberFilter: (invoiceNumber)=>{
        $bdd19ed0be1aa213$var$invoiceStore.filters.invoiceNumber = invoiceNumber.target.value;
    },
    updateDueDateFilter: (dates)=>{
        if (dates.length >= 1) $bdd19ed0be1aa213$var$invoiceStore.filters.dueDate.from = dates[0];
        if (dates.length >= 2) $bdd19ed0be1aa213$var$invoiceStore.filters.dueDate.to = dates[1];
    },
    updateMinPriceFilter: (minPrice)=>{
        $bdd19ed0be1aa213$var$invoiceStore.filters.priceRange.min = minPrice.target.value;
    },
    updateMaxPriceFilter: (maxPrice)=>{
        $bdd19ed0be1aa213$var$invoiceStore.filters.priceRange.max = maxPrice.target.value;
    },
    updateStatusFilter: (statusKey)=>{
        $bdd19ed0be1aa213$var$invoiceStore.filters.statusKey = statusKey;
    },
    clearCompanySpecificData () {
        $bdd19ed0be1aa213$var$invoiceStore.invoiceList = (0, $duLFK.initializeWithDefaultData)([]);
        $bdd19ed0be1aa213$var$invoiceStore.filters = $bdd19ed0be1aa213$var$emptyDefaultFilters;
    }
});
var $bdd19ed0be1aa213$export$2e2bcd8739ae039 = $bdd19ed0be1aa213$var$invoiceStore;

});
parcelRegister("5WT79", function(module, exports) {

$parcel$export(module.exports, "INVOICE_STATUS", function () { return $f51ecb17df533d22$export$3cbec208fdb9aee3; });
var $f51ecb17df533d22$export$3cbec208fdb9aee3 = /*#__PURE__*/ function(INVOICE_STATUS) {
    INVOICE_STATUS["PastDue"] = "PAST_DUE";
    INVOICE_STATUS["Unpaid"] = "UNPAID";
    INVOICE_STATUS["ReminderSent"] = "REMINDER_SENT";
    INVOICE_STATUS["Paid"] = "PAID";
    INVOICE_STATUS["Credit"] = "CREDIT";
    INVOICE_STATUS["None"] = "NONE";
    return INVOICE_STATUS;
}({});

});


parcelRegister("2JqjA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb2d6c4f2a7755f5$export$2e2bcd8739ae039; });

var $W1btl = parcelRequire("W1btl");

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $3oCZd = parcelRequire("3oCZd");
const $fb2d6c4f2a7755f5$var$notificationsStore = (0, $Kk7R3.makeAutoObservable)({
    notifications: (0, $duLFK.initializeWithDefaultData)([]),
    oldNotifications: (0, $duLFK.initializeWithDefaultData)([]),
    fetchNotifications: async ()=>{
        const transitionedSuccessfully = (0, $duLFK.setAsWaitingForData)($fb2d6c4f2a7755f5$var$notificationsStore.notifications);
        if (!transitionedSuccessfully || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/notifications/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).get().json().then((res)=>{
            const sortedResult = (0, $W1btl.default)(res.payload, [
                "added"
            ], [
                "desc"
            ]);
            (0, $duLFK.setAsDataAvailable)($fb2d6c4f2a7755f5$var$notificationsStore.notifications, sortedResult);
        }).catch((errorObject)=>{
            (0, $duLFK.setAsErrorOccured)($fb2d6c4f2a7755f5$var$notificationsStore.notifications, `${errorObject}`);
        });
    },
    fetchOldNotifications: async ()=>{
        const transitionedSuccessfully = (0, $duLFK.setAsWaitingForData)($fb2d6c4f2a7755f5$var$notificationsStore.oldNotifications);
        if (!transitionedSuccessfully || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/notifications/${(0, $bcbvQ.default).currentCompany}/archive`, (0, $bcbvQ.default).getSessionToken()).get().json().then((res)=>{
            const result = (0, $3oCZd.filterOldNotifications)(res.payload, $fb2d6c4f2a7755f5$var$notificationsStore.notifications.data);
            const sortedResult = (0, $W1btl.default)(result, [
                "added"
            ], [
                "desc"
            ]);
            (0, $duLFK.setAsDataAvailable)($fb2d6c4f2a7755f5$var$notificationsStore.oldNotifications, sortedResult);
        }).catch((errorObject)=>{
            (0, $duLFK.setAsErrorOccured)($fb2d6c4f2a7755f5$var$notificationsStore.oldNotifications, `${errorObject}`);
        });
    },
    clearCompanySpecificData: ()=>{
        $fb2d6c4f2a7755f5$var$notificationsStore.notifications = (0, $duLFK.initializeWithDefaultData)([]);
        $fb2d6c4f2a7755f5$var$notificationsStore.oldNotifications = (0, $duLFK.initializeWithDefaultData)([]);
    }
});
var $fb2d6c4f2a7755f5$export$2e2bcd8739ae039 = $fb2d6c4f2a7755f5$var$notificationsStore;

});
parcelRegister("W1btl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ae65604e62ea2a8$export$2e2bcd8739ae039; });

var $cjhTv = parcelRequire("cjhTv");

var $hCd6c = parcelRequire("hCd6c");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $0ae65604e62ea2a8$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!(0, $hCd6c.default)(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!(0, $hCd6c.default)(orders)) orders = orders == null ? [] : [
        orders
    ];
    return (0, $cjhTv.default)(collection, iteratees, orders);
}
var $0ae65604e62ea2a8$export$2e2bcd8739ae039 = $0ae65604e62ea2a8$var$orderBy;

});

parcelRegister("3oCZd", function(module, exports) {

$parcel$export(module.exports, "filterOldNotifications", function () { return $9f9fda1f551cdefe$export$1629064413cbe922; });
$parcel$export(module.exports, "getNotificationsTrackingText", function () { return $9f9fda1f551cdefe$export$af1e8eab06304886; });
const $9f9fda1f551cdefe$export$1629064413cbe922 = (notifications, activeNotifications)=>notifications.filter((notification)=>!activeNotifications.some((activeNotification)=>notification.id === activeNotification.id));
const $9f9fda1f551cdefe$export$af1e8eab06304886 = (menuItemName, notificationsCount, newPromotionArticlesCount)=>{
    if (notificationsCount > 0 && menuItemName === "Varslinger" || newPromotionArticlesCount > 0 && menuItemName === "Kampanjer") return `${menuItemName} med varsel`;
    return menuItemName;
};

});


parcelRegister("1Bsfi", function(module, exports) {

$parcel$export(module.exports, "NEW_RECIPIENT", function () { return $732f6950db4385d5$export$d8dd483edb2c02b8; });
$parcel$export(module.exports, "default", function () { return $732f6950db4385d5$export$2e2bcd8739ae039; });

var $biFcX = parcelRequire("biFcX");

var $eI1up = parcelRequire("eI1up");

var $79pz9 = parcelRequire("79pz9");
const $732f6950db4385d5$export$d8dd483edb2c02b8 = Symbol("NEW_RECIPIENT");
const $732f6950db4385d5$var$recipientsStore = {
    get recipients () {
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).recipients;
        return (0, $79pz9.default).recipients;
    },
    get categories () {
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).categories;
        return (0, $79pz9.default).categories;
    },
    get currentlyEditingId () {
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).currentlyEditingId;
        return (0, $79pz9.default).currentlyEditingId;
    },
    set currentlyEditingId (value){
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) (0, $eI1up.default).currentlyEditingId = value;
        else (0, $79pz9.default).currentlyEditingId = value;
    },
    get currentlyDeletingId () {
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).currentlyDeletingId;
        return (0, $79pz9.default).currentlyDeletingId;
    },
    set currentlyDeletingId (value){
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) (0, $eI1up.default).currentlyDeletingId = value;
        else (0, $79pz9.default).currentlyDeletingId = value;
    },
    get requestProgress () {
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).requestProgress;
        return (0, $79pz9.default).requestProgress;
    },
    fetchRecipients: async ()=>{
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).fetchRecipients();
        return (0, $79pz9.default).fetchRecipients();
    },
    saveNewRecipient: async (recipient)=>{
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).saveNewRecipient(recipient);
        return (0, $79pz9.default).saveNewRecipient(recipient);
    },
    updateRecipient: async (recipient)=>{
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).updateRecipient(recipient);
        return (0, $79pz9.default).updateRecipient(recipient);
    },
    deleteRecipient: async ()=>{
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).deleteRecipient();
        return (0, $79pz9.default).deleteRecipient();
    },
    getNotificationCategoryName: (queryId)=>{
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).getNotificationCategoryName(queryId);
        return (0, $79pz9.default).getNotificationCategoryName(queryId);
    },
    setModalVisibility: (modalType, recipientId)=>{
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).setModalVisibility(modalType, recipientId);
        return (0, $79pz9.default).setModalVisibility(modalType, recipientId);
    },
    clearCompanySpecificData: ()=>{
        if ((0, $biFcX.default).useDynamicsForNotificationProfiles) return (0, $eI1up.default).clearCompanySpecificData();
        return (0, $79pz9.default).clearCompanySpecificData();
    }
};
var $732f6950db4385d5$export$2e2bcd8739ae039 = $732f6950db4385d5$var$recipientsStore;

});
parcelRegister("eI1up", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c236c8075b9ad953$export$2e2bcd8739ae039; });

var $jf2w9 = parcelRequire("jf2w9");

var $bEEBX = parcelRequire("bEEBX");

var $eoV8o = parcelRequire("eoV8o");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $gtsdT = parcelRequire("gtsdT");

var $bYgbs = parcelRequire("bYgbs");

var $iKCNd = parcelRequire("iKCNd");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $1Bsfi = parcelRequire("1Bsfi");

var $5gB3P = parcelRequire("5gB3P");
const $c236c8075b9ad953$var$dynamicsRecipientsStore = (0, $Kk7R3.makeAutoObservable)({
    recipients: (0, $duLFK.initializeWithDefaultData)([]),
    categories: (0, $duLFK.initializeWithDefaultData)([]),
    currentlyEditingId: null,
    currentlyDeletingId: null,
    requestProgress: (0, $duLFK.initializeWithDefaultData)(false),
    fetchRecipients: async ()=>{
        const abortController = (0, $duLFK.setAsWaitingForData)($c236c8075b9ad953$var$dynamicsRecipientsStore.recipients);
        (0, $duLFK.setAsWaitingForData)($c236c8075b9ad953$var$dynamicsRecipientsStore.categories);
        if ((0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("notification_profiles")}/api/notification_profiles/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).signal(abortController).get().json().then((res)=>{
            const response = res;
            const recipients = response.ProfileList.map((profile)=>({
                    profileId: profile.Id,
                    firstName: profile.FirstName ?? "",
                    lastName: profile.LastName ?? "",
                    email: profile.Email ?? "",
                    mobile: profile.Mobile ?? "",
                    emailNotifications: profile.EmailNotifications,
                    smsNotifications: profile.SmsNotifications,
                    allNotifications: (0, $eoV8o.default)([
                        ...profile.EmailNotifications,
                        ...profile.SmsNotifications
                    ])
                }));
            const categories = response.SubscriptionInformation.map((category)=>({
                    id: category.Id,
                    name: category.NameNo ?? category.Name ?? "Ukjent kategori"
                }));
            (0, $duLFK.setAsDataAvailable)($c236c8075b9ad953$var$dynamicsRecipientsStore.recipients, recipients);
            (0, $duLFK.setAsDataAvailable)($c236c8075b9ad953$var$dynamicsRecipientsStore.categories, categories);
        }).catch((errorObject)=>{
            const wretchError = (0, $3Y1Wx.ensureWretchError)(errorObject);
            if (wretchError) (0, $gtsdT.logger).log("recipients", "A request failure occurred while fetching recipients: ", wretchError);
            else (0, $gtsdT.logger).log("recipients", "An error occurred while fetching recipients: ", errorObject);
            (0, $duLFK.setAsErrorOccured)($c236c8075b9ad953$var$dynamicsRecipientsStore.recipients, `${errorObject}`);
            (0, $duLFK.setAsErrorOccured)($c236c8075b9ad953$var$dynamicsRecipientsStore.categories, `${errorObject}`);
        });
    },
    saveNewRecipient: async (recipient)=>{
        const transitionedSuccessfully = (0, $duLFK.setAsWaitingForData)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress);
        if (!transitionedSuccessfully || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany) || $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyEditingId !== (0, $1Bsfi.NEW_RECIPIENT)) return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("notification_profiles")}/api/notification_profiles/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).json((0, $5gB3P.toApiRecipient)(recipient)).post().res((res)=>{
            (0, $duLFK.setAsDataAvailable)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress, res.success);
            $c236c8075b9ad953$var$dynamicsRecipientsStore.fetchRecipients();
            $c236c8075b9ad953$var$dynamicsRecipientsStore.setModalVisibility((0, $iKCNd.RECIPIENT_MODAL).NONE);
        }).catch((errorObject)=>{
            (0, $duLFK.setAsErrorOccured)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress, `${errorObject}`);
        });
    },
    updateRecipient: async (recipient)=>{
        const transitionedSuccessfully = (0, $duLFK.setAsWaitingForData)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress);
        if (!transitionedSuccessfully || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany) || typeof $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyEditingId !== "string") return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("notification_profiles")}/api/notification_profiles/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).json((0, $5gB3P.toApiRecipient)(recipient)).put().res((res)=>{
            (0, $duLFK.setAsDataAvailable)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress, res.success);
            $c236c8075b9ad953$var$dynamicsRecipientsStore.fetchRecipients();
            $c236c8075b9ad953$var$dynamicsRecipientsStore.setModalVisibility((0, $iKCNd.RECIPIENT_MODAL).NONE);
        }).catch((errorObject)=>{
            (0, $duLFK.setAsErrorOccured)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress, `${errorObject}`);
        });
    },
    deleteRecipient: async ()=>{
        const transitionedSuccessfully = (0, $duLFK.setAsWaitingForData)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress);
        if (!transitionedSuccessfully || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany) || $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyDeletingId === null) return Promise.reject();
        return (0, $3Y1Wx.apiClient)(`${(0, $bYgbs.getBaseUrl)("notification_profiles")}/api/notification_profiles/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).json((0, $5gB3P.getDeleteRequestData)($c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyDeletingId)).delete().res((res)=>{
            (0, $duLFK.setAsDataAvailable)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress, res.success);
            $c236c8075b9ad953$var$dynamicsRecipientsStore.fetchRecipients();
            $c236c8075b9ad953$var$dynamicsRecipientsStore.setModalVisibility((0, $iKCNd.RECIPIENT_MODAL).NONE);
        }).catch((errorObject)=>{
            (0, $duLFK.setAsErrorOccured)($c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress, `${errorObject}`);
        });
    },
    getNotificationCategoryName: (queryId)=>(0, $jf2w9.default)($c236c8075b9ad953$var$dynamicsRecipientsStore.categories.data, (category)=>category.id === queryId)?.name,
    setModalVisibility: (0, $Kk7R3.action)((modalType, recipientId)=>{
        $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyDeletingId = null;
        $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyEditingId = null;
        $c236c8075b9ad953$var$dynamicsRecipientsStore.requestProgress = (0, $duLFK.initializeWithDefaultData)(false);
        if (modalType === (0, $iKCNd.RECIPIENT_MODAL).DELETE && recipientId) $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyDeletingId = recipientId;
        else if (modalType === (0, $iKCNd.RECIPIENT_MODAL).ADD) $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyEditingId = (0, $1Bsfi.NEW_RECIPIENT);
        else if (modalType === (0, $iKCNd.RECIPIENT_MODAL).EDIT && recipientId) $c236c8075b9ad953$var$dynamicsRecipientsStore.currentlyEditingId = recipientId;
    }),
    clearCompanySpecificData: ()=>{
        $c236c8075b9ad953$var$dynamicsRecipientsStore.recipients = (0, $duLFK.initializeWithDefaultData)([]);
        $c236c8075b9ad953$var$dynamicsRecipientsStore.categories = (0, $duLFK.initializeWithDefaultData)([]);
    }
});
var $c236c8075b9ad953$export$2e2bcd8739ae039 = $c236c8075b9ad953$var$dynamicsRecipientsStore;

});
parcelRegister("iKCNd", function(module, exports) {

$parcel$export(module.exports, "RECIPIENT_MODAL", function () { return $8ab1b5a2fcbebdb0$export$3d162f00576eebc6; });
var $8ab1b5a2fcbebdb0$export$3d162f00576eebc6 = /*#__PURE__*/ function(RECIPIENT_MODAL) {
    RECIPIENT_MODAL["NONE"] = "NONE";
    RECIPIENT_MODAL["ADD"] = "ADD";
    RECIPIENT_MODAL["EDIT"] = "EDIT";
    RECIPIENT_MODAL["DELETE"] = "DELETE";
    return RECIPIENT_MODAL;
}({});

});

parcelRegister("5gB3P", function(module, exports) {

$parcel$export(module.exports, "toApiRecipient", function () { return $8b5f941fe0667807$export$cee1f28b5801c72f; });
$parcel$export(module.exports, "getDeleteRequestData", function () { return $8b5f941fe0667807$export$426c18827be0b3d3; });
$parcel$export(module.exports, "sanitizePhoneNumber", function () { return $8b5f941fe0667807$export$bdf2363efaa77dc8; });
$parcel$export(module.exports, "mapFromLegacyRecipient", function () { return $8b5f941fe0667807$export$6e9d7722dd8d1981; });
$parcel$export(module.exports, "mapToLegacyRecipient", function () { return $8b5f941fe0667807$export$7935140eb3e15ce3; });

var $eoV8o = parcelRequire("eoV8o");

var $5LjUB = parcelRequire("5LjUB");
const $8b5f941fe0667807$export$cee1f28b5801c72f = (recipient)=>{
    return {
        Id: recipient.profileId,
        FirstName: recipient.firstName,
        LastName: recipient.lastName,
        Email: recipient.email,
        Mobile: recipient.mobile,
        EmailNotifications: recipient.emailNotifications,
        SmsNotifications: recipient.smsNotifications
    };
};
const $8b5f941fe0667807$export$426c18827be0b3d3 = (profileId)=>({
        ProfileId: [
            profileId
        ]
    });
const $8b5f941fe0667807$export$bdf2363efaa77dc8 = (phone)=>{
    let sanitized = phone.replaceAll(/[^0-9\\+]+/g, "");
    sanitized = sanitized.replaceAll(/[\\ \\-_]+/g, "");
    if (sanitized.startsWith("00") && sanitized.length > 8) sanitized = `+${sanitized.substring(2)}`;
    if (sanitized.startsWith("47") && sanitized.length === 10) sanitized = `+${sanitized}`;
    if (!sanitized.startsWith("+") && sanitized.length === 8) sanitized = `+47${sanitized}`;
    return sanitized;
};
const $8b5f941fe0667807$export$6e9d7722dd8d1981 = (recipient)=>{
    const name = recipient.name || "";
    const nameSplit = name.lastIndexOf(" ");
    const firstName = name.substring(0, nameSplit);
    const lastName = name.substring(nameSplit + 1);
    return {
        profileId: recipient.id ?? "",
        firstName: firstName,
        lastName: lastName,
        email: recipient.email,
        mobile: recipient.mobile,
        emailNotifications: recipient.emailNotifications,
        smsNotifications: recipient.smsNotifications,
        allNotifications: (0, $eoV8o.default)([
            ...recipient.emailNotifications,
            ...recipient.smsNotifications
        ])
    };
};
const $8b5f941fe0667807$export$7935140eb3e15ce3 = (recipient)=>({
        id: !(0, $5LjUB.default)(recipient.profileId) ? recipient.profileId : null,
        name: `${recipient.firstName} ${recipient.lastName}`,
        email: recipient.email,
        mobile: recipient.mobile,
        emailNotifications: recipient.emailNotifications,
        smsNotifications: recipient.smsNotifications
    });

});


parcelRegister("79pz9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56708650d6a5297a$export$2e2bcd8739ae039; });

var $jf2w9 = parcelRequire("jf2w9");

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $iKCNd = parcelRequire("iKCNd");

var $duLFK = parcelRequire("duLFK");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $1Bsfi = parcelRequire("1Bsfi");

var $5gB3P = parcelRequire("5gB3P");
const $56708650d6a5297a$var$categories = (0, $isIf6.default).notifications.categories;
const $56708650d6a5297a$var$legacyRecipientsStore = (0, $Kk7R3.makeAutoObservable)({
    recipients: (0, $duLFK.initializeWithDefaultData)([]),
    categories: (0, $duLFK.initializeWithDefaultData)([]),
    currentlyEditingId: null,
    currentlyDeletingId: null,
    requestProgress: (0, $duLFK.initializeWithDefaultData)(false),
    fetchRecipients: async ()=>{
        // Directly set this as data available, since we don't have dynamic categories in the legacy system
        (0, $duLFK.setAsWaitingForData)($56708650d6a5297a$var$legacyRecipientsStore.categories);
        (0, $duLFK.setAsDataAvailable)($56708650d6a5297a$var$legacyRecipientsStore.categories, $56708650d6a5297a$var$categories);
        (0, $duLFK.setAsWaitingForData)($56708650d6a5297a$var$legacyRecipientsStore.recipients);
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/notification_contacts/${(0, $bcbvQ.default).currentCompany}`, (0, $bcbvQ.default).getSessionToken()).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            division: (0, $isIf6.default).m3DivisionNumber
        }).get().json((res)=>{
            const recipients = res.payload.map((0, $5gB3P.mapFromLegacyRecipient));
            (0, $duLFK.setAsDataAvailable)($56708650d6a5297a$var$legacyRecipientsStore.recipients, recipients);
        }).catch((errorObject)=>{
            (0, $gtsdT.logger).warn("recipients", "Unable to fetch recipients", errorObject);
            (0, $duLFK.setAsErrorOccured)($56708650d6a5297a$var$legacyRecipientsStore.recipients, (0, $aMYzM.ensureError)(errorObject).message);
        });
    },
    saveNewRecipient: async (recipient)=>{
        if ((0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        const recipients = [
            ...$56708650d6a5297a$var$legacyRecipientsStore.recipients.data,
            recipient
        ];
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        return $56708650d6a5297a$var$legacyRecipientsStore.saveInternalState(customerNumber, recipients);
    },
    updateRecipient: async (currentRecipient)=>{
        if ((0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        const recipients = $56708650d6a5297a$var$legacyRecipientsStore.recipients.data.map((recipient)=>recipient.profileId === currentRecipient.profileId ? currentRecipient : recipient);
        return $56708650d6a5297a$var$legacyRecipientsStore.saveInternalState(customerNumber, recipients);
    },
    deleteRecipient: async ()=>{
        if ((0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) return Promise.reject();
        const customerNumber = (0, $bcbvQ.default).currentCompany;
        const recipients = $56708650d6a5297a$var$legacyRecipientsStore.recipients.data.filter((recipient)=>recipient.profileId !== $56708650d6a5297a$var$legacyRecipientsStore.currentlyDeletingId);
        return $56708650d6a5297a$var$legacyRecipientsStore.saveInternalState(customerNumber, recipients);
    },
    saveInternalState: (customerNumber, recipients)=>{
        const abortController = (0, $duLFK.setAsWaitingForData)($56708650d6a5297a$var$legacyRecipientsStore.requestProgress);
        const payload = recipients.map((0, $5gB3P.mapToLegacyRecipient));
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/notification_contacts/${customerNumber}`, (0, $bcbvQ.default).getSessionToken()).signal(abortController).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            division: (0, $isIf6.default).m3DivisionNumber
        }).post(payload).res((res)=>{
            (0, $duLFK.setAsDataAvailable)($56708650d6a5297a$var$legacyRecipientsStore.requestProgress, res.success);
            $56708650d6a5297a$var$legacyRecipientsStore.fetchRecipients();
            (0, $1Bsfi.default).setModalVisibility((0, $iKCNd.RECIPIENT_MODAL).NONE);
        }).catch((err)=>{
            (0, $duLFK.setAsErrorOccured)($56708650d6a5297a$var$legacyRecipientsStore.requestProgress, (0, $aMYzM.ensureError)(err).message);
        });
    },
    getNotificationCategoryName: (queryId)=>(0, $jf2w9.default)($56708650d6a5297a$var$legacyRecipientsStore.categories.data, (category)=>category.id === queryId)?.name,
    setModalVisibility: (0, $Kk7R3.action)((modalType, recipientId)=>{
        $56708650d6a5297a$var$legacyRecipientsStore.currentlyDeletingId = null;
        $56708650d6a5297a$var$legacyRecipientsStore.currentlyEditingId = null;
        $56708650d6a5297a$var$legacyRecipientsStore.requestProgress = (0, $duLFK.initializeWithDefaultData)(false);
        if (modalType === (0, $iKCNd.RECIPIENT_MODAL).DELETE && recipientId) $56708650d6a5297a$var$legacyRecipientsStore.currentlyDeletingId = recipientId;
        else if (modalType === (0, $iKCNd.RECIPIENT_MODAL).ADD) (0, $1Bsfi.default).currentlyEditingId = (0, $1Bsfi.NEW_RECIPIENT);
        else if (modalType === (0, $iKCNd.RECIPIENT_MODAL).EDIT && recipientId) (0, $1Bsfi.default).currentlyEditingId = recipientId;
    }),
    clearCompanySpecificData: ()=>{
        $56708650d6a5297a$var$legacyRecipientsStore.recipients = (0, $duLFK.initializeWithDefaultData)([]);
        $56708650d6a5297a$var$legacyRecipientsStore.categories = (0, $duLFK.initializeWithDefaultData)([]);
    }
});
var $56708650d6a5297a$export$2e2bcd8739ae039 = $56708650d6a5297a$var$legacyRecipientsStore;

});


parcelRegister("jVrYh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a09003c515020b29$export$2e2bcd8739ae039; });

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");
const $a09003c515020b29$var$powerBiStore = (0, $Kk7R3.makeAutoObservable)({
    embedData: {},
    getEmbedToken: (reportName)=>{
        if (!$a09003c515020b29$var$powerBiStore.embedData[reportName]) $a09003c515020b29$var$powerBiStore.embedData[reportName] = (0, $duLFK.initializeWithDefaultData)(null);
        return $a09003c515020b29$var$powerBiStore.embedData[reportName];
    },
    generateEmbedToken: async (reportName)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) {
            (0, $gtsdT.logger).warn("account", "Not logged in or no company selected, skipping PowerBI token generation.");
            return;
        }
        const entry = $a09003c515020b29$var$powerBiStore.embedData[reportName];
        if (!entry) {
            (0, $gtsdT.logger).warn("account", "Do not call generateEmbedToken directly, use getEmbedToken to allow store to be initialized properly.");
            return;
        }
        const abortController = (0, $duLFK.setAsWaitingForData)(entry);
        try {
            const url = `${(0, $8ZCSm.API_HOST)}/api/powerbi/${(0, $isIf6.default).storeId}/${reportName}/${(0, $bcbvQ.default).currentCompany}`;
            const embedData = await (0, $3Y1Wx.apiClient)(url, (0, $bcbvQ.default).getSessionToken()).signal(abortController).get().json();
            if (embedData.expiration) {
                const fullEmbedData = {
                    ...embedData,
                    expirationDate: new Date(embedData.expiration)
                };
                (0, $duLFK.setAsDataAvailable)(entry, fullEmbedData);
            } else (0, $duLFK.setAsErrorOccured)(entry, "Unknown object returned from server");
        } catch (err) {
            (0, $duLFK.setAsErrorOccured)(entry, (0, $aMYzM.ensureError)(err).message);
        }
    },
    clearCompanySpecificData: ()=>{
        $a09003c515020b29$var$powerBiStore.embedData = {};
    }
});
var $a09003c515020b29$export$2e2bcd8739ae039 = $a09003c515020b29$var$powerBiStore;

});

parcelRegister("hFzdq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $983df3a4b211697c$export$2e2bcd8739ae039; });

var $ir4nw = parcelRequire("ir4nw");

var $lscH2 = parcelRequire("lscH2");
var $6Nv9Y = parcelRequire("6Nv9Y");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $jECH9 = parcelRequire("jECH9");

var $5OqMf = parcelRequire("5OqMf");

var $fj1oy = parcelRequire("fj1oy");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $9yKIH = parcelRequire("9yKIH");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $iX5v3 = parcelRequire("iX5v3");
const $983df3a4b211697c$var$algoliaClient = (0, $ir4nw.algoliasearch)((0, $isIf6.default).searchConfig.algoliaConfig.appId, (0, $isIf6.default).searchConfig.algoliaConfig.searchApiKey);
const $983df3a4b211697c$var$searchDomains = (0, $isIf6.default).searchConfig.searchDomains.map((domain)=>({
        ...domain,
        algoliaClient: $983df3a4b211697c$var$algoliaClient
    }));
let $983df3a4b211697c$var$queueTimeout;
const $983df3a4b211697c$var$searchStore = (0, $Kk7R3.makeAutoObservable)({
    query: "",
    eventQueue: [],
    quick: {
        results: [],
        resultsFor: ""
    },
    full: {
        results: [],
        resultsFor: ""
    },
    totalHits: 0,
    async performSearches (type, locale) {
        const query = $983df3a4b211697c$var$searchStore.query;
        const company = (0, $bcbvQ.default).getCurrentCompany();
        const customerGroup = (0, $biFcX.default).searchResultsSortedByCustomerGroupSales && company ? (0, $fj1oy.keepIdOnly)(company.customerGroup) : "default";
        const algoliaUserToken = (0, $bcbvQ.default).isLoggedIn() ? (0, $bcbvQ.default).getAlgoliaUserToken() : undefined;
        const results = await Promise.all($983df3a4b211697c$var$searchDomains.map((searchDomain)=>(0, $iX5v3.searchInDomain)(query, searchDomain, type, customerGroup, algoliaUserToken, (0, $biFcX.default).prioritizeAgreementAssortment, (0, $bZiDo.default).assortment, (0, $bZiDo.default).replacementProducts, (skus)=>(0, $bZiDo.default).resolveSkus(skus, true, false), (0, $9yKIH.filterHitsVisibleForSegment), locale)));
        if (query === $983df3a4b211697c$var$searchStore.query) (0, $Kk7R3.runInAction)(()=>{
            $983df3a4b211697c$var$searchStore[type].results = results;
            $983df3a4b211697c$var$searchStore[type].resultsFor = query;
            $983df3a4b211697c$var$searchStore.totalHits = results.reduce((total, result)=>total + result.hits.length, 0);
            const searchType = type === "full" ? "static" : "dynamic";
            (0, $6fuyt.sendSearch)(searchType, this.totalHits, query);
        });
    },
    clear: (field = (0, $jECH9.SEARCH_TYPE).QuickSearch, includeQuery = false)=>{
        $983df3a4b211697c$var$searchStore[field].results = [];
        if (includeQuery) $983df3a4b211697c$var$searchStore.query = "";
    },
    /**
    * @param sku {string}
    * @param position {number | null}
    * @param fromSearch {boolean}
    * @param type {"quick" | "direct"}
    */ reportAlgoliaClick: (id, index, queryID = "", position = null, fromSearch = false, type = "direct")=>{
        const eventName = fromSearch ? "Clicked From Search" : "Clicked";
        $983df3a4b211697c$var$searchStore.reportEvent("click", eventName, id, position, type, index, queryID);
    },
    reportAlgoliaAddToCart: (sku, index, queryID = "", fromSearch = false, type = "direct")=>{
        const eventName = fromSearch ? "Added To Cart From Search" : "Added to cart";
        $983df3a4b211697c$var$searchStore.reportEvent("conversion", eventName, sku, null, type, index, queryID);
    },
    reportDetailsViewed: (sku, index, queryID = "")=>{
        $983df3a4b211697c$var$searchStore.reportEvent("view", "Product Viewed", sku, null, null, index, queryID);
    },
    reportArticleViewed: (id, index, queryID = "")=>{
        $983df3a4b211697c$var$searchStore.reportEvent("view", "Article Viewed", id, null, null, index, queryID);
    },
    reportEvent: (eventType, eventName, id, position, _type, index, queryID)=>{
        if (!(0, $bcbvQ.default).isLoggedIn()) return;
        const userToken = (0, $bcbvQ.default).getAlgoliaUserToken();
        const event = {
            eventType: eventType,
            eventName: eventName,
            objectIDs: (0, $5OqMf.forceArray)(id),
            index: index,
            queryID: queryID,
            userToken: userToken,
            timestamp: (0, $lscH2.default)((0, $6Nv9Y.default)(new Date(), 5)) * 1000
        };
        if (position != null) event.positions = [
            position
        ];
        $983df3a4b211697c$var$searchStore.queueEvent(event);
    },
    queueEvent: (eventsToQueue)=>{
        const eventArray = (0, $5OqMf.forceArray)(eventsToQueue);
        for (const event of eventArray)$983df3a4b211697c$var$searchStore.eventQueue.push(event);
        (0, $gtsdT.logger).log("search", `Algolia event(s) queued, current queue size: ${$983df3a4b211697c$var$searchStore.eventQueue.length}`, eventsToQueue);
        if ($983df3a4b211697c$var$searchStore.eventQueue.length > 25) $983df3a4b211697c$var$searchStore.sendQueue();
        else {
            if ($983df3a4b211697c$var$queueTimeout != null) clearTimeout($983df3a4b211697c$var$queueTimeout);
            $983df3a4b211697c$var$queueTimeout = window.setTimeout($983df3a4b211697c$var$searchStore.sendQueue, 30000);
        }
    },
    sendQueue: ()=>{
        if ($983df3a4b211697c$var$searchStore.eventQueue.length === 0) return;
        clearTimeout($983df3a4b211697c$var$queueTimeout);
        // Retrieve the queue contents current being processed, and empty the actual queue.
        // If the request fails we return these events to the queue.
        const queueContents = [
            ...$983df3a4b211697c$var$searchStore.eventQueue
        ];
        $983df3a4b211697c$var$searchStore.eventQueue = [];
        (0, $gtsdT.logger).log("search", `Sending ${queueContents.length} events to Algolia`);
        return (0, $3Y1Wx.apiClient)("https://insights.algolia.io/1/events").headers({
            "X-Algolia-Application-Id": (0, $isIf6.default).searchConfig.algoliaConfig.appId,
            "X-Algolia-API-Key": (0, $isIf6.default).searchConfig.algoliaConfig.searchApiKey
        }).post({
            events: queueContents
        }).json(()=>{
            (0, $gtsdT.logger).log("search", `${queueContents.length} events reported to Algolia`);
        }).catch((err)=>{
            (0, $gtsdT.logger).warn("search", `${queueContents.length} events where rejected by Algolia error!`, err);
        });
    },
    clearCompanySpecificData: ()=>{
    // add methods to clear company specific data
    }
});
var $983df3a4b211697c$export$2e2bcd8739ae039 = $983df3a4b211697c$var$searchStore;

});
parcelRegister("lscH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9e60f1c9b1df927$export$2e2bcd8739ae039; });

var $9Gpfz = parcelRequire("9Gpfz");

var $hFacL = parcelRequire("hFacL");
function $f9e60f1c9b1df927$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    return Math.floor((0, $9Gpfz.default)(dirtyDate) / 1000);
}

});
parcelRegister("9Gpfz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70cb9f6f095b224b$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $70cb9f6f095b224b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});


parcelRegister("6Nv9Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f2f7d612746cf56$export$2e2bcd8739ae039; });

var $8dTE1 = parcelRequire("8dTE1");

var $hFacL = parcelRequire("hFacL");

var $970db = parcelRequire("970db");
function $4f2f7d612746cf56$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var amount = (0, $970db.default)(dirtyAmount);
    return (0, $8dTE1.default)(dirtyDate, -amount);
}

});
parcelRegister("8dTE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fcab37e130a15de$export$2e2bcd8739ae039; });

var $970db = parcelRequire("970db");

var $eOaNI = parcelRequire("eOaNI");

var $hFacL = parcelRequire("hFacL");
var $5fcab37e130a15de$var$MILLISECONDS_IN_MINUTE = 60000;
function $5fcab37e130a15de$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $hFacL.default)(2, arguments);
    var amount = (0, $970db.default)(dirtyAmount);
    return (0, $eOaNI.default)(dirtyDate, amount * $5fcab37e130a15de$var$MILLISECONDS_IN_MINUTE);
}

});



parcelRegister("5aUWQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02dbabd62cd97d6e$export$2e2bcd8739ae039; });

var $7c65l = parcelRequire("7c65l");

var $i3YG6 = parcelRequire("i3YG6");

var $5LjUB = parcelRequire("5LjUB");

var $bEEBX = parcelRequire("bEEBX");

var $kalVm = parcelRequire("kalVm");

var $15TRa = parcelRequire("15TRa");

var $jQCqo = parcelRequire("jQCqo");

var $eoV8o = parcelRequire("eoV8o");

var $Kk7R3 = parcelRequire("Kk7R3");

var $3Y1Wx = parcelRequire("3Y1Wx");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $isIf6 = parcelRequire("isIf6");

var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");
/**
 * This generic function constructs the resulting type by defining that it will always be
 * whatever type is sent in unioned with M3AugementedSuscription
 * This allows us to use the function in two cases separate cases with correct type inferance:
 *
 * M3SubscriptionRawListed -> M3SubscriptionListed
 * M3SubscriptionRaw -> M3Subscription
 */ const $02dbabd62cd97d6e$var$augmentSubscription = (sub)=>{
    return {
        ...sub,
        id: sub.orderNumber,
        active: sub.orderStatus === "20",
        name: (0, $4udGV.generateSubscriptionName)(sub.deliveryWeekdayNumber, sub.deliveryIntervalDays)
    };
};
const $02dbabd62cd97d6e$var$subscriptionStore = (0, $Kk7R3.makeAutoObservable)({
    selectedInterval: 7,
    subscriptionsList: (0, $duLFK.initializeWithDefaultData)([]),
    subscriptionDetails: {},
    fetchingAllPlannedDeliveries: false,
    plannedDeliveries: {},
    daysLoading: [],
    ensureSubscriptionDetailsKeyAvailable: (orderNumber)=>{
        if (!(orderNumber in $02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails) || (0, $bEEBX.default)($02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails[orderNumber])) $02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails[orderNumber] = (0, $duLFK.initializeWithDefaultData)(null);
    },
    getSubscriptionDetails: (orderNumber)=>{
        $02dbabd62cd97d6e$var$subscriptionStore.ensureSubscriptionDetailsKeyAvailable(orderNumber);
        return $02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails[orderNumber];
    },
    fetchSubscriptionList: ()=>{
        if (!(0, $bcbvQ.default).currentCompany) {
            (0, $gtsdT.logger).warn("subscription", "Not able to fetch subscription list before user is logged in");
            return Promise.reject();
        }
        (0, $duLFK.setAsWaitingForData)($02dbabd62cd97d6e$var$subscriptionStore.subscriptionsList);
        return (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/subscriptionOrderList`, (0, $bcbvQ.default).getSessionToken()).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany
        }).get().json((res)=>{
            const sortedResult = (0, $jQCqo.default)(res, "deliveryWeekdayNumber");
            (0, $duLFK.setAsDataAvailable)($02dbabd62cd97d6e$var$subscriptionStore.subscriptionsList, sortedResult.map($02dbabd62cd97d6e$var$augmentSubscription));
        }).catch((err)=>{
            (0, $gtsdT.logger).warn("subscription", "Unable to fetch subscription list", err);
            (0, $duLFK.setAsErrorOccured)($02dbabd62cd97d6e$var$subscriptionStore.subscriptionsList, `${err}`);
        });
    },
    fetchSubscriptionDetails: async (orderNumber)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)(orderNumber)) {
            (0, $gtsdT.logger).warn("subscription", "Subscription Details before logged in: ", orderNumber);
            return Promise.reject();
        }
        const key = $02dbabd62cd97d6e$var$subscriptionStore.getDetailsEntryKey(orderNumber);
        const order = $02dbabd62cd97d6e$var$subscriptionStore.getSubscriptionDetails(key);
        (0, $duLFK.setAsWaitingForData)(order);
        try {
            const orderDetails = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/subscriptionOrder`, (0, $bcbvQ.default).getSessionToken()).query({
                companyNumber: (0, $isIf6.default).m3CompanyNumber,
                customerNumber: (0, $bcbvQ.default).currentCompany,
                orderNumber: orderNumber
            }).get().json();
            if ("Error_Code" in orderDetails && typeof orderDetails.Error_Code === "string") {
                (0, $duLFK.setAsErrorOccured)(order, orderDetails.Error_Code);
                return null;
            }
            (0, $duLFK.setAsDataAvailable)(order, $02dbabd62cd97d6e$var$augmentSubscription(orderDetails));
            return orderDetails;
        } catch (err) {
            (0, $gtsdT.logger).warn("subscription", "Unable to fetch subscription details", err);
            (0, $duLFK.setAsErrorOccured)(order, `${err}`);
            return null;
        }
    },
    fetchAllPlannedDeliveries: ()=>{
        (0, $Kk7R3.runInAction)(()=>{
            $02dbabd62cd97d6e$var$subscriptionStore.fetchingAllPlannedDeliveries = true;
        });
        return $02dbabd62cd97d6e$var$subscriptionStore.fetchPlannedDeliveries().finally((0, $Kk7R3.action)(()=>{
            $02dbabd62cd97d6e$var$subscriptionStore.fetchingAllPlannedDeliveries = false;
        }));
    },
    getDetailsEntryKey: (orderNumber, date)=>orderNumber + (!(0, $bEEBX.default)(date) ? `-${date}` : ""),
    fetchInstanceOrder: async (orderNumber, date)=>{
        if (!(0, $bcbvQ.default).isLoggedIn()) {
            (0, $gtsdT.logger).warn("subscription", "Subscription Next Deliveries before logged in: ", orderNumber);
            return Promise.reject();
        }
        if ((0, $5LjUB.default)(orderNumber)) {
            (0, $gtsdT.logger).warn("subscription", "No order number specified for subscription instance fetch");
            return Promise.reject();
        }
        // Convert date to M3 format
        const requestedDeliveryDate = date instanceof Date ? (0, $4udGV.formatM3Date)(date) : date;
        const key = $02dbabd62cd97d6e$var$subscriptionStore.getDetailsEntryKey(orderNumber, requestedDeliveryDate);
        const instanceEntry = $02dbabd62cd97d6e$var$subscriptionStore.getSubscriptionDetails(key);
        const params = {
            optimizeOrderLines: true,
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            requestedDeliveryDate: requestedDeliveryDate,
            orderNumber: orderNumber
        };
        (0, $duLFK.setAsWaitingForData)(instanceEntry);
        try {
            const instanceDetails = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/changedSubscriptionOrderDelivery`, (0, $bcbvQ.default).getSessionToken()).query(params).get().json();
            // Check if API completed successfully
            if ("orderNumber" in instanceDetails) {
                (0, $duLFK.setAsDataAvailable)(instanceEntry, {
                    ...$02dbabd62cd97d6e$var$augmentSubscription(instanceDetails),
                    success: true,
                    id: key
                });
                return instanceDetails;
            }
            if (!instanceDetails || "Error_Code" in instanceDetails) {
                (0, $gtsdT.logger).warn("subscription", "An error occured while fetching", instanceDetails);
                (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(new Error(`Unable to fetch subscription confirmation ${key}: ${instanceDetails.Error_Code}`));
                (0, $duLFK.setAsErrorOccured)(instanceEntry, "Unable to fetch subscription instance details");
                return Promise.reject("An error occured");
            }
            return instanceDetails;
        } catch (err) {
            (0, $duLFK.setAsErrorOccured)(instanceEntry, `Unable to fetch subscription instance details: ${err}`);
            return Promise.reject(`An error occured while fetching instance details: ${err}`);
        }
    },
    fetchPlannedDeliveries: async (m3Date = null, orderNumber = null)=>{
        if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) {
            (0, $gtsdT.logger).warn("subscription", "Subscription Next Deliveries before logged in: ", orderNumber);
            return;
        }
        const payload = {
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            typeOfOrder: "F"
        };
        if (!(0, $bEEBX.default)(orderNumber)) payload.orderNumber = orderNumber;
        if (!(0, $bEEBX.default)(m3Date)) {
            payload.fromDate = m3Date;
            payload.toDate = m3Date;
        }
        const deliveries = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/customerOrderList`, (0, $bcbvQ.default).getSessionToken()).query(payload).get().json();
        (0, $gtsdT.logger).log("subscription", "Got result for planned deliveries", deliveries);
        const orderNumbers = (0, $eoV8o.default)(deliveries.map((d)=>d.orderNumber));
        (0, $Kk7R3.runInAction)(()=>{
            for (const orderNo of orderNumbers)if ((0, $bEEBX.default)(m3Date) || (0, $bEEBX.default)($02dbabd62cd97d6e$var$subscriptionStore.plannedDeliveries[orderNo])) $02dbabd62cd97d6e$var$subscriptionStore.plannedDeliveries[orderNo] = [];
            else (0, $15TRa.default)($02dbabd62cd97d6e$var$subscriptionStore.plannedDeliveries[orderNo], (d)=>d.deliveryDate === m3Date);
            if (deliveries.length === 0 && !(0, $bEEBX.default)(orderNumber)) $02dbabd62cd97d6e$var$subscriptionStore.plannedDeliveries[orderNumber] = [];
            for (const d of deliveries)$02dbabd62cd97d6e$var$subscriptionStore.plannedDeliveries[d.orderNumber].push({
                deliveryDate: d.deliveryDate,
                paused: d.typeOfOrder === "S",
                changed: d.typeOfOrder === "I"
            });
        });
        if (!(0, $bEEBX.default)(orderNumber)) (0, $gtsdT.logger).log("subscription", `Loaded ${deliveries.length} planned deliveries for subscription ${orderNumber} from server`);
        else (0, $gtsdT.logger).log("subscription", `Loaded ${deliveries.length} planned deliveries from ${orderNumbers.length} orderNumbers from server`);
    },
    togglePauseDay: async (m3Date, toggleTo)=>{
        if ((0, $bEEBX.default)(m3Date)) {
            (0, $gtsdT.logger).warn("subscription", "Unable to toggle pause date without date");
            return Promise.reject("Det oppsto en feil");
        }
        (0, $gtsdT.logger).log("subscription", "Adding loading day");
        (0, $Kk7R3.runInAction)(()=>{
            $02dbabd62cd97d6e$var$subscriptionStore.daysLoading = [
                ...$02dbabd62cd97d6e$var$subscriptionStore.daysLoading,
                m3Date
            ];
        });
        const pauseDayUrl = `${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/cancellationDate`;
        const req = (0, $3Y1Wx.apiClient)(pauseDayUrl, (0, $bcbvQ.default).getSessionToken()).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            date: m3Date
        });
        const returnObj = toggleTo ? req.post() : req.delete();
        await returnObj.json().then(async ()=>{
            (0, $gtsdT.logger).log("subscription", "Fetching planned deliveries");
            await $02dbabd62cd97d6e$var$subscriptionStore.fetchPlannedDeliveries(m3Date);
        }).finally((0, $Kk7R3.action)(()=>{
            (0, $gtsdT.logger).log("subscription", "Removing loading day");
            $02dbabd62cd97d6e$var$subscriptionStore.daysLoading = [
                ...(0, $kalVm.default)($02dbabd62cd97d6e$var$subscriptionStore.daysLoading, m3Date)
            ];
        }));
    },
    submitInstanceChanges: async ()=>{
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if (currentDelivery === null) return Promise.reject("Unable to determine current delivery");
        if ((0, $76PCP.default).editing === null || (0, $bEEBX.default)((0, $76PCP.default).editing.orderNumber)) return Promise.reject("Not currently editing an order, unable to submit changes.");
        (0, $76PCP.default).sendingOrder = true;
        const payload = (0, $76PCP.default).generateChangeOrderPayload();
        if (payload === null) {
            (0, $76PCP.default).sendingOrder = false;
            (0, $76PCP.default).stopEditOrderMode();
            return [
                (0, $76PCP.default).editing.orderNumber
            ];
        }
        payload.deliveryDate = (0, $4udGV.formatISODate)(currentDelivery.date);
        let response;
        try {
            response = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/changedSubscriptionOrderDelivery`, (0, $bcbvQ.default).getSessionToken()).query({
                optimizeOrderLines: true
            }).content("application/json").put(payload).json();
            // Remove the cached order details so we are able to see the changes load in on the confirmation page
            delete $02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails[(0, $76PCP.default).editing.orderNumber];
        } catch (err) {
            (0, $gtsdT.logger).warn("subscription", "An error occured during order update", err);
            throw err;
        } finally{
            (0, $76PCP.default).sendingOrder = false;
        }
        if ("@type" in response) throw new Error(`${response["@type"]}: ${response.Message}`);
        (0, $76PCP.default).stopEditOrderMode();
        return [
            response.orderNumber
        ];
    },
    // Instance orders are planned deliveries for a subscription on a specific date that differs from the rest of the subscription
    submitNewInstanceOrder: async ()=>{
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if (currentDelivery === null) return Promise.reject("Unable to determine current delivery");
        if ((0, $76PCP.default).editing === null || (0, $bEEBX.default)((0, $76PCP.default).editing.orderNumber)) return Promise.reject("Not currently editing an order, unable to submit changes.");
        (0, $Kk7R3.runInAction)(()=>{
            (0, $76PCP.default).sendingOrder = true;
        });
        const instanceOrder = {
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            orderNumber: (0, $76PCP.default).editing.orderNumber,
            validFromDate: (0, $4udGV.formatISODate)(currentDelivery.date),
            estimatedOrderAmount: 2500,
            orderLines: (0, $76PCP.default).items.map((i)=>({
                    sku: i.sku,
                    quantity: i.qty,
                    orderLineUnit: i.unit
                }))
        };
        let response;
        try {
            response = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/changedSubscriptionOrderDelivery`, (0, $bcbvQ.default).getSessionToken()).query({
                optimizeOrderLines: true
            }).content("application/json").post(instanceOrder).json();
            // Remove the cached order details so we are able to see the changes load in on the confirmation page
            (0, $Kk7R3.runInAction)(()=>{
                if ((0, $76PCP.default).editing?.orderNumber) delete $02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails[(0, $76PCP.default).editing.orderNumber];
            });
        } catch (err) {
            (0, $gtsdT.logger).warn("subscription", "An error occured during order update", err);
            throw err;
        } finally{
            (0, $Kk7R3.runInAction)(()=>{
                (0, $76PCP.default).sendingOrder = false;
            });
        }
        if ("Error_Code" in response) throw new Error(`${response.Response}: ${response.Error_Code}`);
        (0, $76PCP.default).stopEditOrderMode();
        return [
            response.orderNumber
        ];
    },
    submitSubscriptionChanges: async ()=>{
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if (currentDelivery === null) return Promise.reject("Unable to determine current delivery");
        if ((0, $76PCP.default).editing === null || (0, $bEEBX.default)((0, $76PCP.default).editing.orderNumber)) return Promise.reject("Not currently editing an order, unable to submit changes.");
        (0, $76PCP.default).sendingOrder = true;
        const payload = (0, $76PCP.default).generateChangeOrderPayload();
        if (payload === null) {
            (0, $76PCP.default).sendingOrder = false;
            (0, $76PCP.default).stopEditOrderMode();
            return [
                (0, $76PCP.default).editing.orderNumber
            ];
        }
        let response;
        try {
            response = await (0, $3Y1Wx.apiClient)(`${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/subscriptionOrder`, (0, $bcbvQ.default).getSessionToken()).query({
                optimizeOrderLines: true,
                keepInstances: true
            }).content("application/json").put(payload).json();
            if ("orderNumber" in response) (0, $6fuyt.sendPurchase)(response.orderNumber, [
                ...(0, $76PCP.default).items
            ], true);
            // Remove the cached order details so we are able to see the changes load in on the confirmation page
            delete $02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails[(0, $76PCP.default).editing.orderNumber];
        } catch (err) {
            (0, $gtsdT.logger).warn("subscription", "An error occured during order update", err);
            throw err;
        } finally{
            (0, $76PCP.default).sendingOrder = false;
        }
        if ("Error_Code" in response) throw new Error(`${response.Response}: ${response.Error_Code}`);
        (0, $76PCP.default).stopEditOrderMode();
        return [
            response.orderNumber
        ];
    },
    submitNewSubscription: async ()=>{
        (0, $76PCP.default).sendingOrder = true;
        const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
        if ((0, $bEEBX.default)(currentDelivery)) return Promise.reject("Current delivery is not available, unable to create new subscription");
        const firstDeliveryDate = (0, $4udGV.formatISODate)(currentDelivery.date);
        const deliveryWeekdayNumber = (0, $i3YG6.default)(currentDelivery.date, "i");
        const deliveryIntervalDays = currentDelivery.interval;
        const subscription = {
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            firstDeliveryDate: firstDeliveryDate,
            validFromDate: firstDeliveryDate,
            validToDate: "",
            deliveryWeekdayNumber: deliveryWeekdayNumber,
            deliveryIntervalDays: deliveryIntervalDays,
            estimatedOrderAmount: 2500,
            ...(0, $76PCP.default).orderRefs,
            orderLines: (0, $76PCP.default).items.map((i)=>({
                    sku: i.sku,
                    quantity: i.qty,
                    orderLineUnit: i.unit
                }))
        };
        const createOrderUrl = `${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/subscriptionOrder?optimizeOrderLines=true`;
        let response;
        try {
            (0, $gtsdT.logger).log("subscription", "Starting subscription creation...", subscription);
            response = await (0, $3Y1Wx.apiClient)(createOrderUrl, (0, $bcbvQ.default).getSessionToken()).content("application/json").post(subscription).json();
            if ("orderNumber" in response) (0, $6fuyt.sendPurchase)(response.orderNumber, [
                ...(0, $76PCP.default).items
            ], false);
        } catch (err) {
            (0, $gtsdT.logger).warn("subscription", "Unable to create subscription", err);
            throw err;
        } finally{
            (0, $Kk7R3.runInAction)(()=>{
                (0, $76PCP.default).sendingOrder = false;
            });
        }
        if ("Error_Code" in response) throw new Error(`${response.Response}: ${response.Error_Code}`);
        (0, $76PCP.default).emptyCart();
        (0, $76PCP.default).resetOrderRefs();
        (0, $76PCP.default).changeOrderType((0, $isIf6.default).defaultOrderType);
        return [
            response.orderNumber
        ];
    },
    changeSubscriptionStatus: async (orderNumber, newStatus)=>{
        const statusUrl = `${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/subscriptionOrderStatus`;
        const resp = await (0, $3Y1Wx.apiClient)(statusUrl, (0, $bcbvQ.default).getSessionToken()).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            orderNumber: orderNumber,
            activate: newStatus
        }).put().json();
        if ("Message" in resp) {
            (0, $gtsdT.logger).warn("subscription", "Error when changing subscription status: ", resp);
            throw new Error(`Unable to change status for subscription: ${resp.Message}`);
        }
        return resp.success;
    },
    deleteInstanceOrder: async (orderNumber, deliveryDate)=>{
        const deleteInstanceUrl = `${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/changedSubscriptionOrderDelivery`;
        const response = await (0, $3Y1Wx.apiClient)(deleteInstanceUrl, (0, $bcbvQ.default).getSessionToken()).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            orderNumber: orderNumber,
            deliveryDate: deliveryDate
        }).delete().json();
        if ("Error_Code" in response) throw new Error(`Unable to delete subscription ${response.Error_Code}`);
        return response.status;
    },
    deleteSubscription: async (orderNumber)=>{
        const deleteUrl = `${(0, $8ZCSm.API_HOST)}/api/${(0, $isIf6.default).tipApiPrefix}tip/API/subscriptionOrder`;
        const response = await (0, $3Y1Wx.apiClient)(deleteUrl, (0, $bcbvQ.default).getSessionToken()).query({
            companyNumber: (0, $isIf6.default).m3CompanyNumber,
            customerNumber: (0, $bcbvQ.default).currentCompany,
            orderNumber: orderNumber
        }).delete().json();
        if ("Error_Code" in response) throw new Error(`Unable to delete subscription ${response.Error_Code}`);
        (0, $Kk7R3.runInAction)(()=>{
            $02dbabd62cd97d6e$var$subscriptionStore.subscriptionsList.data = $02dbabd62cd97d6e$var$subscriptionStore.subscriptionsList.data.filter((subscription)=>subscription.orderNumber !== orderNumber);
        });
        return response.status;
    },
    clearCompanySpecificData: ()=>{
        // add methods to clear company specific data
        $02dbabd62cd97d6e$var$subscriptionStore.selectedInterval = 7;
        $02dbabd62cd97d6e$var$subscriptionStore.subscriptionsList = (0, $duLFK.initializeWithDefaultData)([]);
        $02dbabd62cd97d6e$var$subscriptionStore.subscriptionDetails = {};
        $02dbabd62cd97d6e$var$subscriptionStore.fetchingAllPlannedDeliveries = false;
        $02dbabd62cd97d6e$var$subscriptionStore.plannedDeliveries = {};
        $02dbabd62cd97d6e$var$subscriptionStore.daysLoading = [];
    }
});
var $02dbabd62cd97d6e$export$2e2bcd8739ae039 = $02dbabd62cd97d6e$var$subscriptionStore;

});



parcelRegister("8z7vy", function(module, exports) {

$parcel$export(module.exports, "SIXTY_MINUTES", function () { return $7e018f69ff7c061d$export$6e95838a7b84060; });
$parcel$export(module.exports, "TEN_MINUTES", function () { return $7e018f69ff7c061d$export$1658ad0f470aba83; });
$parcel$export(module.exports, "MORE_THAN_SIXTY_MINUTES", function () { return $7e018f69ff7c061d$export$a7044fdc104b069a; });
$parcel$export(module.exports, "parse2022DeliveryDates", function () { return $7e018f69ff7c061d$export$587135fc2313a75b; });
$parcel$export(module.exports, "parse2022DeliveryDatesForSubscription", function () { return $7e018f69ff7c061d$export$710717bf5223e425; });
$parcel$export(module.exports, "parse2022PickupDates", function () { return $7e018f69ff7c061d$export$27546bed6e4b3262; });
$parcel$export(module.exports, "formatTimePeriod", function () { return $7e018f69ff7c061d$export$34698684c4bef161; });

var $epcVC = parcelRequire("epcVC");
var $5UIm0 = parcelRequire("5UIm0");
var $2BBSn = parcelRequire("2BBSn");
const $7e018f69ff7c061d$export$6e95838a7b84060 = 3600000;
const $7e018f69ff7c061d$export$1658ad0f470aba83 = 600000;
const $7e018f69ff7c061d$export$a7044fdc104b069a = Number.MAX_SAFE_INTEGER;
const $7e018f69ff7c061d$export$587135fc2313a75b = (resp)=>{
    return resp.deliveryDates.filter((d)=>(0, $epcVC.default)((0, $2BBSn.default)(d.deadline))).map((d)=>({
            date: (0, $5UIm0.default)(d.deliveryDate),
            deadline: (0, $2BBSn.default)(d.deadline),
            price: 0
        }));
};
const $7e018f69ff7c061d$export$710717bf5223e425 = (resp)=>{
    return resp.deliveryDates.filter((d)=>d.subscriptionDeadline !== null && (0, $epcVC.default)((0, $2BBSn.default)(d.subscriptionDeadline))).map((d)=>({
            date: (0, $5UIm0.default)(d.deliveryDate),
            deadline: (0, $2BBSn.default)(d.subscriptionDeadline),
            price: 0
        }));
};
const $7e018f69ff7c061d$export$27546bed6e4b3262 = (pickupData)=>{
    return pickupData.pickupAt.map((pickupAlt)=>({
            date: (0, $2BBSn.default)(pickupAlt.pickupAfter),
            deadline: (0, $2BBSn.default)(pickupAlt.orderBefore),
            price: 0
        }));
};
const $7e018f69ff7c061d$var$toMinutesAndSeconds = (periodInMilliseconds)=>{
    const minutes = Math.floor(periodInMilliseconds / 60000);
    const seconds = Math.floor(periodInMilliseconds % 60000 / 1000);
    return {
        minutes: minutes,
        seconds: seconds
    };
};
const $7e018f69ff7c061d$export$34698684c4bef161 = (periodInMilliseconds)=>{
    if (periodInMilliseconds > 0) {
        if (periodInMilliseconds === $7e018f69ff7c061d$export$a7044fdc104b069a) return "mer enn 60 min";
        const { minutes: minutes, seconds: seconds } = $7e018f69ff7c061d$var$toMinutesAndSeconds(periodInMilliseconds);
        return `${minutes} min ${seconds} sek`;
    }
    return "";
};

});




parcelRegister("345Ip", function(module, exports) {

$parcel$export(module.exports, "getCartTotal", function () { return $7f2ae34c3053841b$export$aaf082081ea7a6cb; });

var $bEEBX = parcelRequire("bEEBX");
var $3xOZa = parcelRequire("3xOZa");
var $loTcB = parcelRequire("loTcB");
var $dmVvg = parcelRequire("dmVvg");

var $bZiDo = parcelRequire("bZiDo");

var $luszM = parcelRequire("luszM");
const $7f2ae34c3053841b$export$aaf082081ea7a6cb = (cartItems, beforeDiscount)=>{
    const skusInCart = cartItems.map((i)=>i.sku);
    const productsIncart = (0, $bZiDo.default).resolveSkus(skusInCart);
    const productsBySku = (0, $loTcB.default)(productsIncart, "sku");
    const productPrice = (sku)=>{
        const product = productsBySku[sku];
        if (beforeDiscount) return !(0, $bEEBX.default)(product) && !(0, $bEEBX.default)(product.priceBeforeDiscount) ? product.priceBeforeDiscount : 0;
        return !(0, $bEEBX.default)(product) && !(0, $bEEBX.default)(product.price) ? product.price : 0;
    };
    return {
        total: (0, $dmVvg.default)(cartItems, (i)=>i.qty * productPrice(i.sku)),
        recyclingCharge: (0, $dmVvg.default)(cartItems, (i)=>{
            if ((0, $3xOZa.default)(productsBySku[i.sku])) return 0;
            const item = productsBySku[i.sku];
            return ((0, $luszM.isDistributionPack)(i.unit) ? item.conversionFactor * i.qty : i.qty) * item.recyclingChargeBaseUnit;
        })
    };
};

});



parcelRegister("ljb3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f833f250caf16811$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $f833f250caf16811$var$SvgCheckCircle = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m10.805 15.375 5.578-5.555-1.195-1.195-4.383 4.36-1.992-1.97-1.196 1.196zM12 21a8.8 8.8 0 0 1-3.492-.703 9.1 9.1 0 0 1-2.871-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 12q0-1.875.703-3.504a9.072 9.072 0 0 1 4.805-4.793A8.8 8.8 0 0 1 12 3q1.875 0 3.504.703a9.1 9.1 0 0 1 4.793 4.793A8.75 8.75 0 0 1 21 12a8.8 8.8 0 0 1-.703 3.492 9.07 9.07 0 0 1-4.793 4.805A8.75 8.75 0 0 1 12 21m0-1.687q3.047 0 5.18-2.133T19.313 12 17.18 6.82 12 4.687 6.82 6.82 4.687 12t2.133 5.18T12 19.313"
        })
    }));
var $f833f250caf16811$export$2e2bcd8739ae039 = $f833f250caf16811$var$SvgCheckCircle;

});

parcelRegister("j6ChH", function(module, exports) {

$parcel$export(module.exports, "Helmet", function () { return $de8c4659880a1d67$export$dcef8f9bb9a41431; });

var $657Mh = parcelRequire("657Mh");

var $2i3N2 = parcelRequire("2i3N2");

var $42ikU = parcelRequire("42ikU");

var $dvPqk = parcelRequire("dvPqk");

var $7uQzJ = parcelRequire("7uQzJ");
var $de8c4659880a1d67$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $de8c4659880a1d67$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $de8c4659880a1d67$var$VALID_TAG_NAMES = Object.keys($de8c4659880a1d67$var$TAG_NAMES).map(function(name) {
    return $de8c4659880a1d67$var$TAG_NAMES[name];
});
var $de8c4659880a1d67$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $de8c4659880a1d67$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $de8c4659880a1d67$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $de8c4659880a1d67$var$HTML_TAG_MAP = Object.keys($de8c4659880a1d67$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$de8c4659880a1d67$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $de8c4659880a1d67$var$SELF_CLOSING_TAGS = [
    $de8c4659880a1d67$var$TAG_NAMES.NOSCRIPT,
    $de8c4659880a1d67$var$TAG_NAMES.SCRIPT,
    $de8c4659880a1d67$var$TAG_NAMES.STYLE
];
var $de8c4659880a1d67$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $de8c4659880a1d67$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $de8c4659880a1d67$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $de8c4659880a1d67$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $de8c4659880a1d67$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $de8c4659880a1d67$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $de8c4659880a1d67$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $de8c4659880a1d67$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $de8c4659880a1d67$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $de8c4659880a1d67$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $de8c4659880a1d67$var$getInnermostProperty(propsList, $de8c4659880a1d67$var$TAG_NAMES.TITLE);
    var innermostTemplate = $de8c4659880a1d67$var$getInnermostProperty(propsList, $de8c4659880a1d67$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $de8c4659880a1d67$var$getInnermostProperty(propsList, $de8c4659880a1d67$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $de8c4659880a1d67$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $de8c4659880a1d67$var$getInnermostProperty(propsList, $de8c4659880a1d67$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $de8c4659880a1d67$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $de8c4659880a1d67$var$_extends({}, tagAttrs, current);
    }, {});
};
var $de8c4659880a1d67$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$de8c4659880a1d67$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$de8c4659880a1d67$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $de8c4659880a1d67$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $de8c4659880a1d67$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $de8c4659880a1d67$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $de8c4659880a1d67$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $de8c4659880a1d67$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $de8c4659880a1d67$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $de8c4659880a1d67$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $de8c4659880a1d67$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($7uQzJ)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $de8c4659880a1d67$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $de8c4659880a1d67$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $de8c4659880a1d67$var$getBaseTagFromPropsList([
            $de8c4659880a1d67$var$TAG_PROPERTIES.HREF,
            $de8c4659880a1d67$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $de8c4659880a1d67$var$getAttributesFromPropsList($de8c4659880a1d67$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $de8c4659880a1d67$var$getInnermostProperty(propsList, $de8c4659880a1d67$var$HELMET_PROPS.DEFER),
        encode: $de8c4659880a1d67$var$getInnermostProperty(propsList, $de8c4659880a1d67$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $de8c4659880a1d67$var$getAttributesFromPropsList($de8c4659880a1d67$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $de8c4659880a1d67$var$getTagsFromPropsList($de8c4659880a1d67$var$TAG_NAMES.LINK, [
            $de8c4659880a1d67$var$TAG_PROPERTIES.REL,
            $de8c4659880a1d67$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $de8c4659880a1d67$var$getTagsFromPropsList($de8c4659880a1d67$var$TAG_NAMES.META, [
            $de8c4659880a1d67$var$TAG_PROPERTIES.NAME,
            $de8c4659880a1d67$var$TAG_PROPERTIES.CHARSET,
            $de8c4659880a1d67$var$TAG_PROPERTIES.HTTPEQUIV,
            $de8c4659880a1d67$var$TAG_PROPERTIES.PROPERTY,
            $de8c4659880a1d67$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $de8c4659880a1d67$var$getTagsFromPropsList($de8c4659880a1d67$var$TAG_NAMES.NOSCRIPT, [
            $de8c4659880a1d67$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $de8c4659880a1d67$var$getOnChangeClientState(propsList),
        scriptTags: $de8c4659880a1d67$var$getTagsFromPropsList($de8c4659880a1d67$var$TAG_NAMES.SCRIPT, [
            $de8c4659880a1d67$var$TAG_PROPERTIES.SRC,
            $de8c4659880a1d67$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $de8c4659880a1d67$var$getTagsFromPropsList($de8c4659880a1d67$var$TAG_NAMES.STYLE, [
            $de8c4659880a1d67$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $de8c4659880a1d67$var$getTitleFromPropsList(propsList),
        titleAttributes: $de8c4659880a1d67$var$getAttributesFromPropsList($de8c4659880a1d67$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $de8c4659880a1d67$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $de8c4659880a1d67$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $de8c4659880a1d67$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $de8c4659880a1d67$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $de8c4659880a1d67$var$rafPolyfill : $parcel$global.requestAnimationFrame || $de8c4659880a1d67$var$rafPolyfill;
var $de8c4659880a1d67$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $de8c4659880a1d67$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $de8c4659880a1d67$var$cafPolyfill;
var $de8c4659880a1d67$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $de8c4659880a1d67$var$_helmetCallback = null;
var $de8c4659880a1d67$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($de8c4659880a1d67$var$_helmetCallback) $de8c4659880a1d67$var$cancelAnimationFrame($de8c4659880a1d67$var$_helmetCallback);
    if (newState.defer) $de8c4659880a1d67$var$_helmetCallback = $de8c4659880a1d67$var$requestAnimationFrame(function() {
        $de8c4659880a1d67$var$commitTagChanges(newState, function() {
            $de8c4659880a1d67$var$_helmetCallback = null;
        });
    });
    else {
        $de8c4659880a1d67$var$commitTagChanges(newState);
        $de8c4659880a1d67$var$_helmetCallback = null;
    }
};
var $de8c4659880a1d67$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $de8c4659880a1d67$var$updateAttributes($de8c4659880a1d67$var$TAG_NAMES.BODY, bodyAttributes);
    $de8c4659880a1d67$var$updateAttributes($de8c4659880a1d67$var$TAG_NAMES.HTML, htmlAttributes);
    $de8c4659880a1d67$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $de8c4659880a1d67$var$updateTags($de8c4659880a1d67$var$TAG_NAMES.BASE, baseTag),
        linkTags: $de8c4659880a1d67$var$updateTags($de8c4659880a1d67$var$TAG_NAMES.LINK, linkTags),
        metaTags: $de8c4659880a1d67$var$updateTags($de8c4659880a1d67$var$TAG_NAMES.META, metaTags),
        noscriptTags: $de8c4659880a1d67$var$updateTags($de8c4659880a1d67$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $de8c4659880a1d67$var$updateTags($de8c4659880a1d67$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $de8c4659880a1d67$var$updateTags($de8c4659880a1d67$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $de8c4659880a1d67$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $de8c4659880a1d67$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $de8c4659880a1d67$var$flattenArray(title);
    $de8c4659880a1d67$var$updateAttributes($de8c4659880a1d67$var$TAG_NAMES.TITLE, attributes);
};
var $de8c4659880a1d67$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($de8c4659880a1d67$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($de8c4659880a1d67$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($de8c4659880a1d67$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($de8c4659880a1d67$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $de8c4659880a1d67$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($de8c4659880a1d67$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $de8c4659880a1d67$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $de8c4659880a1d67$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $de8c4659880a1d67$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($de8c4659880a1d67$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $de8c4659880a1d67$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $de8c4659880a1d67$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $de8c4659880a1d67$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $de8c4659880a1d67$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $de8c4659880a1d67$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $de8c4659880a1d67$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $de8c4659880a1d67$var$HELMET_ATTRIBUTE + "=\"true\">" + $de8c4659880a1d67$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $de8c4659880a1d67$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $de8c4659880a1d67$var$TAG_PROPERTIES.INNER_HTML || attribute === $de8c4659880a1d67$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $de8c4659880a1d67$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $de8c4659880a1d67$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $de8c4659880a1d67$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $de8c4659880a1d67$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$de8c4659880a1d67$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $de8c4659880a1d67$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$de8c4659880a1d67$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $de8c4659880a1d67$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$de8c4659880a1d67$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $de8c4659880a1d67$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($de8c4659880a1d67$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $de8c4659880a1d67$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$de8c4659880a1d67$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $de8c4659880a1d67$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $de8c4659880a1d67$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $de8c4659880a1d67$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(type, mappedTag);
    });
};
var $de8c4659880a1d67$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $de8c4659880a1d67$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $de8c4659880a1d67$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $de8c4659880a1d67$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $de8c4659880a1d67$var$ATTRIBUTE_NAMES.BODY:
        case $de8c4659880a1d67$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $de8c4659880a1d67$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $de8c4659880a1d67$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $de8c4659880a1d67$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $de8c4659880a1d67$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $de8c4659880a1d67$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$TAG_NAMES.META, metaTags, encode),
        noscript: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $de8c4659880a1d67$var$getMethodsForTag($de8c4659880a1d67$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $de8c4659880a1d67$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $de8c4659880a1d67$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $de8c4659880a1d67$var$classCallCheck(this, HelmetWrapper);
            return $de8c4659880a1d67$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($42ikU)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $de8c4659880a1d67$var$TAG_NAMES.SCRIPT:
                case $de8c4659880a1d67$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $de8c4659880a1d67$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $de8c4659880a1d67$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $de8c4659880a1d67$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $de8c4659880a1d67$var$TAG_NAMES.TITLE:
                    return $de8c4659880a1d67$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $de8c4659880a1d67$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $de8c4659880a1d67$var$TAG_NAMES.BODY:
                    return $de8c4659880a1d67$var$_extends({}, newProps, {
                        bodyAttributes: $de8c4659880a1d67$var$_extends({}, newChildProps)
                    });
                case $de8c4659880a1d67$var$TAG_NAMES.HTML:
                    return $de8c4659880a1d67$var$_extends({}, newProps, {
                        htmlAttributes: $de8c4659880a1d67$var$_extends({}, newChildProps)
                    });
            }
            return $de8c4659880a1d67$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $de8c4659880a1d67$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $de8c4659880a1d67$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $de8c4659880a1d67$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $de8c4659880a1d67$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $de8c4659880a1d67$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $de8c4659880a1d67$var$TAG_NAMES.LINK:
                    case $de8c4659880a1d67$var$TAG_NAMES.META:
                    case $de8c4659880a1d67$var$TAG_NAMES.NOSCRIPT:
                    case $de8c4659880a1d67$var$TAG_NAMES.SCRIPT:
                    case $de8c4659880a1d67$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $de8c4659880a1d67$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $de8c4659880a1d67$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(Component, newProps);
        };
        $de8c4659880a1d67$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($657Mh))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $de8c4659880a1d67$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $de8c4659880a1d67$var$NullComponent = function NullComponent() {
    return null;
};
var $de8c4659880a1d67$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($2i3N2)))($de8c4659880a1d67$var$reducePropsToState, $de8c4659880a1d67$var$handleClientStateChange, $de8c4659880a1d67$var$mapStateOnServer)($de8c4659880a1d67$var$NullComponent);
var $de8c4659880a1d67$export$dcef8f9bb9a41431 = $de8c4659880a1d67$var$Helmet($de8c4659880a1d67$var$HelmetSideEffects);
$de8c4659880a1d67$export$dcef8f9bb9a41431.renderStatic = $de8c4659880a1d67$export$dcef8f9bb9a41431.rewind;
var $de8c4659880a1d67$export$2e2bcd8739ae039 = $de8c4659880a1d67$export$dcef8f9bb9a41431;

});
parcelRegister("657Mh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $46d93e35c3db651d$var$ReactIs, $46d93e35c3db651d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("bJlVW"))();

});
parcelRegister("bJlVW", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $49bF1 = parcelRequire("49bF1");
function $88a4e939f51f592d$var$emptyFunction() {}
function $88a4e939f51f592d$var$emptyFunctionWithReset() {}
$88a4e939f51f592d$var$emptyFunctionWithReset.resetWarningCache = $88a4e939f51f592d$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $49bF1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $88a4e939f51f592d$var$emptyFunctionWithReset,
        resetWarningCache: $88a4e939f51f592d$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("49bF1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $30510c41fb16f9ec$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $30510c41fb16f9ec$var$ReactPropTypesSecret;

});



parcelRegister("2i3N2", function(module, exports) {
'use strict';
function $1ab033d418857f0b$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $dvPqk = parcelRequire("dvPqk");
var $1ab033d418857f0b$var$React__default = $1ab033d418857f0b$var$_interopDefault($dvPqk);
function $1ab033d418857f0b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ab033d418857f0b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $1ab033d418857f0b$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $1ab033d418857f0b$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $1ab033d418857f0b$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $1ab033d418857f0b$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($dvPqk.PureComponent);
        $1ab033d418857f0b$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $1ab033d418857f0b$var$_defineProperty(SideEffect, "canUseDOM", $1ab033d418857f0b$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $1ab033d418857f0b$var$withSideEffect;

});

parcelRegister("42ikU", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $2f0592832996a7a9$var$hasElementType = typeof Element !== 'undefined';
var $2f0592832996a7a9$var$hasMap = typeof Map === 'function';
var $2f0592832996a7a9$var$hasSet = typeof Set === 'function';
var $2f0592832996a7a9$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $2f0592832996a7a9$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$2f0592832996a7a9$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($2f0592832996a7a9$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$2f0592832996a7a9$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($2f0592832996a7a9$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($2f0592832996a7a9$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($2f0592832996a7a9$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$2f0592832996a7a9$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $2f0592832996a7a9$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("7uQzJ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $57541e19f23668c2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $57541e19f23668c2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $57541e19f23668c2$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $57541e19f23668c2$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $57541e19f23668c2$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $57541e19f23668c2$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $57541e19f23668c2$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($57541e19f23668c2$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($57541e19f23668c2$var$getOwnPropertySymbols) {
            symbols = $57541e19f23668c2$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($57541e19f23668c2$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("iklLr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b0827b3e86f4221$export$2e2bcd8739ae039; });

var $kalVm = parcelRequire("kalVm");

var $dvPqk = parcelRequire("dvPqk");

var $bcbvQ = parcelRequire("bcbvQ");

var $gtsdT = parcelRequire("gtsdT");
const $5b0827b3e86f4221$var$useLoginRequired = (feature)=>{
    (0, $dvPqk.useEffect)(()=>{
        if (feature === "NOT_REQUIRED") return;
        (0, $gtsdT.logger).log("auth", `LOGIN REQUIRED: Added ${feature}`);
        (0, $bcbvQ.default).currentlyRequiresLogin.push(feature);
        return ()=>{
            (0, $gtsdT.logger).log("auth", `LOGIN REQUIRED: Removed ${feature}`);
            (0, $kalVm.default)((0, $bcbvQ.default).currentlyRequiresLogin, feature);
        };
    }, [
        feature
    ]);
};
var $5b0827b3e86f4221$export$2e2bcd8739ae039 = $5b0827b3e86f4221$var$useLoginRequired;

});

parcelRegister("hNpRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $920e2f82844bb7dc$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $88FA0 = parcelRequire("88FA0");

var $duLFK = parcelRequire("duLFK");

var $lKrOo = parcelRequire("lKrOo");

var $jlTfJ = parcelRequire("jlTfJ");

var $1qZrx = parcelRequire("1qZrx");

var $4r4cM = parcelRequire("4r4cM");

var $9Vrue = parcelRequire("9Vrue");
const $920e2f82844bb7dc$var$NOT_LOGGED_IN_SLUG = "not_logged_in";
const $920e2f82844bb7dc$var$NotLoggedIn = ()=>{
    const isLoggingIn = (0, $lKrOo.default).isLoggingIn();
    if (isLoggingIn) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {
        label: "Venter p\xe5 innlogging..."
    });
    if ((0, $duLFK.isWaitingForData)((0, $jlTfJ.default).urlData) || (0, $duLFK.isDefaultData)((0, $jlTfJ.default).urlData)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
        height: 380
    });
    if ((0, $duLFK.isDataAvailable)((0, $jlTfJ.default).urlData)) {
        const urlData = (0, $jlTfJ.default).urlData.data.find((data)=>data.slug === $920e2f82844bb7dc$var$NOT_LOGGED_IN_SLUG);
        if (!urlData) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
            showCloseButton: false,
            gaErrorTracking: {
                context: "not_logged_in_page",
                text: "slug_not_found_error"
            },
            className: "w-full h-fit",
            children: "Du m\xe5 logge inn for \xe5 se denne siden."
        });
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1qZrx.default), {
            id: urlData.id
        });
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
        showCloseButton: false,
        gaErrorTracking: {
            context: "not_logged_in_page",
            text: "page_load_error"
        },
        children: "Det oppsto en uventet feil under lasting av siden."
    });
};
var $920e2f82844bb7dc$export$2e2bcd8739ae039 = (0, $gBcml.observer)($920e2f82844bb7dc$var$NotLoggedIn);

});
parcelRegister("1qZrx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c471f6ee21586fe$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $iklLr = parcelRequire("iklLr");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $4r4cM = parcelRequire("4r4cM");

var $fGZ1g = parcelRequire("fGZ1g");

var $hNpRa = parcelRequire("hNpRa");

var $4rV5w = parcelRequire("4rV5w");
/**
 * When we want to show a Contentful content, this wrapper makes sure that
 * we load the desired content from Contentful into the store and shows
 * a skeleton until it is properly loaded.
 */ const $6c471f6ee21586fe$var$CmsContentFetchWrapper = ({ id: id })=>{
    const content = (0, $jlTfJ.default).fetchedContent.get(id);
    const articleVisibility = (0, $9yKIH.default).getArticleVisibility(id);
    (0, $dvPqk.useEffect)(()=>{
        (0, $gtsdT.logger).log("contentful", `Fetch wrapper for ${id}`, content);
    }, [
        id,
        content
    ]);
    (0, $iklLr.default)(content?.type === "v2_article" && articleVisibility === "requiresLogin" ? "SEGMENTED_CONTENT" : "NOT_REQUIRED");
    if (content?.type === "v2_article") {
        if (articleVisibility === "hidden") return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fGZ1g.default), {});
        if (articleVisibility === "requiresLogin") return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hNpRa.default), {});
    }
    if (!content) return;
    (0, $jlTfJ.default).fetchContentIfNotAlreadyInStore(id, content.type);
    if ((0, $duLFK.isDefaultData)(content.entry) || (0, $duLFK.isWaitingForData)(content.entry)) return;
    if ((0, $duLFK.isDataAvailable)(content.entry)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4rV5w.default), {
        entryId: id,
        content: content.entry.data,
        type: content.type,
        context: "content"
    });
    if ((0, $duLFK.isErrorOccured)(content.entry)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
        showCloseButton: false,
        gaErrorTracking: {
            context: "cms_content",
            text: "fetch_content_error"
        },
        children: "Det oppsto en feil under henting av innholdet"
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fGZ1g.default), {});
};
var $6c471f6ee21586fe$export$2e2bcd8739ae039 = (0, $gBcml.observer)($6c471f6ee21586fe$var$CmsContentFetchWrapper);

});
parcelRegister("fGZ1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $443a0c1564fd2f99$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $j6ChH = parcelRequire("j6ChH");

var $88FA0 = parcelRequire("88FA0");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $duLFK = parcelRequire("duLFK");

var $jlTfJ = parcelRequire("jlTfJ");

var $1qZrx = parcelRequire("1qZrx");

var $4r4cM = parcelRequire("4r4cM");
const $443a0c1564fd2f99$export$46cda065b4d637d7 = "404";
const $443a0c1564fd2f99$var$NotFound = ()=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j6ChH.Helmet), {
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("meta", {
                    name: "robots",
                    content: "noindex, nofollow"
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($443a0c1564fd2f99$var$NotFoundContent, {})
        ]
    });
const $443a0c1564fd2f99$var$NotFoundContent = ()=>{
    const [location, _] = (0, $8kt8E.useLocation)();
    (0, $dvPqk.useEffect)(()=>{
        (0, $6fuyt.sendPageNotFound)(location);
    }, [
        location
    ]);
    if ((0, $duLFK.isWaitingForData)((0, $jlTfJ.default).urlData) || (0, $duLFK.isDefaultData)((0, $jlTfJ.default).urlData)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
        height: 380
    });
    if ((0, $duLFK.isDataAvailable)((0, $jlTfJ.default).urlData)) {
        const urlData = (0, $jlTfJ.default).urlData.data.find((data)=>data.slug === $443a0c1564fd2f99$export$46cda065b4d637d7);
        if (!urlData) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
            showCloseButton: false,
            gaErrorTracking: {
                context: "page_not_found",
                text: "slug_not_found_error"
            },
            children: "Denne siden eksisterer ikke. Pr\xf8v en annen side."
        });
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1qZrx.default), {
            id: urlData.id
        });
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
        showCloseButton: false,
        gaErrorTracking: {
            context: "page_not_found",
            text: "page_load_error"
        },
        children: "Det oppsto en uventet feil under lasting av siden."
    });
};
var $443a0c1564fd2f99$export$2e2bcd8739ae039 = (0, $gBcml.observer)($443a0c1564fd2f99$var$NotFound);

});

parcelRegister("4rV5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0d6e0a958dda67$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $6jZ7E = parcelRequire("6jZ7E");

var $cwSVZ = parcelRequire("cwSVZ");

var $lLWDg = parcelRequire("lLWDg");

var $aUIXP = parcelRequire("aUIXP");

var $e2HE4 = parcelRequire("e2HE4");

var $bATQI = parcelRequire("bATQI");

var $roYxg = parcelRequire("roYxg");

var $5Xl3D = parcelRequire("5Xl3D");

var $kNMWS = parcelRequire("kNMWS");

var $fpr9Z = parcelRequire("fpr9Z");

var $eADXL = parcelRequire("eADXL");

var $aFpyD = parcelRequire("aFpyD");

var $9o9dF = parcelRequire("9o9dF");

var $LJVQK = parcelRequire("LJVQK");

var $aLOhe = parcelRequire("aLOhe");

var $jnpfY = parcelRequire("jnpfY");
const $8b0d6e0a958dda67$var$CmsEmbeddedEntry = ({ content: content, type: type, entryId: entryId, context: context })=>{
    switch(type){
        case "imageWithFocus":
            {
                const imageEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
                    width: 1250,
                    ratio: "16x9",
                    entryId: entryId,
                    imageFromParent: imageEntry,
                    placement: "belowFold"
                });
            }
        case "v2_textAndImage":
            {
                const textAndImageEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jnpfY.default), {
                    content: textAndImageEntry
                });
            }
        case "largeTeaser":
            {
                const largeTeaserEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9o9dF.default), {
                    content: largeTeaserEntry
                });
            }
        case "informationBox":
            {
                const informationBoxEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6jZ7E.default), {
                    content: informationBoxEntry
                });
            }
        case "logos":
            {
                const logosEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cwSVZ.default), {
                    content: logosEntry
                });
            }
        case "productList":
            {
                const productListEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $roYxg.default), {
                    content: productListEntry,
                    context: context
                });
            }
        case "automaticGeneratedProductList":
            {
                const automaticProductListEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $e2HE4.default), {
                    content: automaticProductListEntry,
                    context: context
                });
            }
        case "callToActionList":
            {
                const cmsListEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bATQI.default), {
                    content: cmsListEntry
                });
            }
        case "v2_article":
            {
                const articleEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aUIXP.default), {
                    id: entryId,
                    article: articleEntry
                });
            }
        case "adventCalendarSlot":
            {
                const adventCalendarEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lLWDg.default), {
                    adventCalendarArticleContent: adventCalendarEntry
                });
            }
        case "contestForm":
            {
                const contestFormEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fpr9Z.default), {
                    id: entryId,
                    entry: contestFormEntry
                });
            }
        case "v2_section":
            {
                const sectionEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aLOhe.default), {
                    id: entryId,
                    section: sectionEntry
                });
            }
        case "recipe":
            {
                const recipeEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $LJVQK.default), {
                    id: entryId,
                    recipeEntry: recipeEntry
                });
            }
        case "imageLink":
            {
                const imageLinkEntry = content;
                const target = imageLinkEntry.fields.entry;
                const imageWithFocus = imageLinkEntry.fields.image;
                const title = imageLinkEntry.fields.text;
                const subTitle = imageLinkEntry.fields.caption;
                if (imageWithFocus) {
                    const id = target.sys.id;
                    const type = target.sys.contentType.sys.id === "v2_article" ? "article" : "recipe";
                    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eADXL.default), {
                        id: id,
                        type: type,
                        imageWithFocusId: imageWithFocus.sys.id,
                        title: title,
                        subTitle: subTitle
                    });
                }
                return null;
            }
        case "youtubeVideo":
            {
                const youtubeEntry = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kNMWS.default), {
                    content: youtubeEntry
                });
            }
        case "signupButton":
            {
                const campaignSignup = content;
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5Xl3D.default), {
                    content: campaignSignup
                });
            }
        default:
            return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                children: [
                    "Fant ikke visningen for innhold av typen ",
                    type
                ]
            });
    }
};
var $8b0d6e0a958dda67$export$2e2bcd8739ae039 = (0, $gBcml.observer)($8b0d6e0a958dda67$var$CmsEmbeddedEntry);

});
parcelRegister("6jZ7E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af411de182e9ba18$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $cLfby = parcelRequire("cLfby");

var $cZSqT = parcelRequire("cZSqT");
const $af411de182e9ba18$var$CmsInformationBox = ({ content: content })=>{
    const { fields: fields } = content;
    const { theme: theme, title: title, body: body } = fields;
    const informationBoxTheme = theme === "B\xe6rekraft" ? "sustainable" : "main";
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cZSqT.default), {
        theme: informationBoxTheme,
        title: title,
        className: "mt-6",
        children: body && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLfby.default), {
            document: body,
            variant: "informationBox",
            context: "information-box",
            trackingLocationName: "Information box"
        })
    });
};
var $af411de182e9ba18$export$2e2bcd8739ae039 = $af411de182e9ba18$var$CmsInformationBox;

});
parcelRegister("cLfby", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a99fd4f671e3f4$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $7qw1I = parcelRequire("7qw1I");

var $d5xW5 = parcelRequire("d5xW5");

var $izjX7 = parcelRequire("izjX7");

var $jlTfJ = parcelRequire("jlTfJ");

var $8ri8d = parcelRequire("8ri8d");

var $6pY3b = parcelRequire("6pY3b");

var $cGvcF = parcelRequire("cGvcF");

var $4rV5w = parcelRequire("4rV5w");

var $d59hY = parcelRequire("d59hY");
const $05a99fd4f671e3f4$var$contentBlock = {
    simple: "my-8",
    standard: "my-16",
    informationBox: "my-0"
};
const $05a99fd4f671e3f4$var$RichTextRenderer = ({ document: document, variant: variant = "standard", context: context, trackingLocationName: trackingLocationName })=>{
    const textNodeRenderer = (tag)=>(node, children)=>{
            const isListTag = tag === "ul" || tag === "ol";
            const isTableTag = tag === "table";
            const isListItem = tag === "li";
            const isHorizontalRule = tag === "hr";
            const isBlockQuote = tag === "blockquote";
            const Tag = tag;
            const listElementStyle = (0, $izjX7.cn)("pl-6", {
                "[&>li]:list-decimal": tag === "ol",
                "[&>li]:list-disc": tag === "ul"
            });
            if (isListItem) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $d59hY.RichTextListItem), {
                node: node,
                customRenderNodes: assetAndEntryRenderNodes
            });
            if (context === "category-content" && tag === "p" && (!children || Array.isArray(children) && (children.length === 0 || children.every((child)=>!child)))) // don't render empty paragraphs in category content
            return null;
            return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $d59hY.RichTextColumn), {
                children: [
                    isListTag && /*#__PURE__*/ (0, $7YWoO.jsx)(Tag, {
                        className: listElementStyle,
                        children: children
                    }),
                    isTableTag && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $d59hY.RichTextTable), {
                        table: node,
                        customRenderNodes: assetAndEntryRenderNodes
                    }),
                    isHorizontalRule && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ri8d.default), {}),
                    isBlockQuote && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGvcF.default), {
                        children: children
                    }),
                    !isListTag && !isTableTag && !isHorizontalRule && !isBlockQuote && /*#__PURE__*/ (0, $7YWoO.jsx)(Tag, {
                        children: children
                    })
                ]
            });
        };
    const textRenderNodes = {
        [(0, $d5xW5.BLOCKS).PARAGRAPH]: textNodeRenderer("p"),
        [(0, $d5xW5.BLOCKS).HEADING_2]: textNodeRenderer("h2"),
        [(0, $d5xW5.BLOCKS).HEADING_3]: textNodeRenderer("h3"),
        [(0, $d5xW5.BLOCKS).HEADING_4]: textNodeRenderer("h4"),
        [(0, $d5xW5.BLOCKS).HEADING_5]: textNodeRenderer("h5"),
        [(0, $d5xW5.BLOCKS).HEADING_6]: textNodeRenderer("h6"),
        [(0, $d5xW5.BLOCKS).UL_LIST]: textNodeRenderer("ul"),
        [(0, $d5xW5.BLOCKS).OL_LIST]: textNodeRenderer("ol"),
        [(0, $d5xW5.BLOCKS).TABLE]: textNodeRenderer("table"),
        [(0, $d5xW5.BLOCKS).HR]: textNodeRenderer("hr"),
        [(0, $d5xW5.BLOCKS).QUOTE]: textNodeRenderer("blockquote")
    };
    const assetAndEntryRenderNodes = {
        [(0, $d5xW5.BLOCKS).LIST_ITEM]: textNodeRenderer("li"),
        [(0, $d5xW5.BLOCKS).EMBEDDED_ENTRY]: (node)=>{
            if (!node.data?.target?.fields) return null;
            const nodeId = node.data.target.sys.id;
            const nodeType = node.data.target.sys.contentType.sys.id;
            return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: (0, $izjX7.cn)($05a99fd4f671e3f4$var$contentBlock[variant], "first:mt-0 last:mb-0"),
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4rV5w.default), {
                    entryId: nodeId,
                    content: node.data.target,
                    type: nodeType,
                    context: context
                })
            });
        },
        [(0, $d5xW5.BLOCKS).EMBEDDED_ASSET]: (node)=>{
            if (!node.data?.target?.fields?.file?.details?.image) return null;
            return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: (0, $izjX7.cn)($05a99fd4f671e3f4$var$contentBlock[variant], "max-w-4xl mx-auto space-y-2"),
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                        src: `https://${node.data.target.fields.file.url}`,
                        height: node.data.target.fields.file.details.image.height,
                        width: node.data.target.fields.file.details.image.width,
                        alt: node.data.target.fields.title,
                        className: "size-full rounded-lg",
                        loading: "lazy"
                    }),
                    node.data.target.fields.description && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        className: "text-sm italic",
                        children: node.data.target.fields.description
                    })
                ]
            });
        },
        [(0, $d5xW5.INLINES).ASSET_HYPERLINK]: (node, children)=>{
            const url = node.data.target.fields.file.url;
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.DownloadLink), {
                href: url,
                children: children
            });
        },
        [(0, $d5xW5.INLINES).HYPERLINK]: (node, children)=>{
            const url = node.data.uri;
            if (url.startsWith("/")) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                href: url,
                children: children
            });
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.ExternalLink), {
                href: url,
                children: children
            });
        },
        [(0, $d5xW5.INLINES).ENTRY_HYPERLINK]: (node, children)=>{
            const nodeId = node.data.target.sys.id;
            const existingContent = (0, $jlTfJ.default).urlData.data.find((data)=>data.id === nodeId);
            if (existingContent) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                href: `/${existingContent.fullUrl}`,
                trackingLocationName: trackingLocationName,
                children: children
            });
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
                children: children
            });
        }
    };
    const customRenderOptions = {
        renderNode: {
            ...textRenderNodes,
            ...assetAndEntryRenderNodes
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: (0, $7qw1I.documentToReactComponents)(document, customRenderOptions)
    });
};
var $05a99fd4f671e3f4$export$2e2bcd8739ae039 = $05a99fd4f671e3f4$var$RichTextRenderer;

});
parcelRegister("7qw1I", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $5683cded33f69e52$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $dvPqk = parcelRequire("dvPqk");
var $5683cded33f69e52$var$React__default = $5683cded33f69e52$var$_interopDefault($dvPqk);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $5683cded33f69e52$var$__assign = function() {
    $5683cded33f69e52$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5683cded33f69e52$var$__assign.apply(this, arguments);
};
var $5683cded33f69e52$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $5683cded33f69e52$var$unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function $5683cded33f69e52$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $5683cded33f69e52$var$blocks = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.BLOCKS = void 0;
    /**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var BLOCKS;
    (function(BLOCKS) {
        BLOCKS["DOCUMENT"] = "document";
        BLOCKS["PARAGRAPH"] = "paragraph";
        BLOCKS["HEADING_1"] = "heading-1";
        BLOCKS["HEADING_2"] = "heading-2";
        BLOCKS["HEADING_3"] = "heading-3";
        BLOCKS["HEADING_4"] = "heading-4";
        BLOCKS["HEADING_5"] = "heading-5";
        BLOCKS["HEADING_6"] = "heading-6";
        BLOCKS["OL_LIST"] = "ordered-list";
        BLOCKS["UL_LIST"] = "unordered-list";
        BLOCKS["LIST_ITEM"] = "list-item";
        BLOCKS["HR"] = "hr";
        BLOCKS["QUOTE"] = "blockquote";
        BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
        BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
        BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
        BLOCKS["TABLE"] = "table";
        BLOCKS["TABLE_ROW"] = "table-row";
        BLOCKS["TABLE_CELL"] = "table-cell";
        BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
    })(BLOCKS = exports1.BLOCKS || (exports1.BLOCKS = {}));
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$blocks);
var $5683cded33f69e52$var$blocks_1 = $5683cded33f69e52$var$blocks.BLOCKS;
var $5683cded33f69e52$var$inlines = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.INLINES = void 0;
    /**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */ var INLINES;
    (function(INLINES) {
        INLINES["HYPERLINK"] = "hyperlink";
        INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
        INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
        INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
        INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
        INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    })(INLINES = exports1.INLINES || (exports1.INLINES = {}));
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$inlines);
var $5683cded33f69e52$var$inlines_1 = $5683cded33f69e52$var$inlines.INLINES;
var $5683cded33f69e52$var$marks = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    /**
 * Map of all Contentful marks.
 */ var MARKS;
    (function(MARKS) {
        MARKS["BOLD"] = "bold";
        MARKS["ITALIC"] = "italic";
        MARKS["UNDERLINE"] = "underline";
        MARKS["CODE"] = "code";
        MARKS["SUPERSCRIPT"] = "superscript";
        MARKS["SUBSCRIPT"] = "subscript";
    })(MARKS || (MARKS = {}));
    exports1.default = MARKS;
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$marks);
var $5683cded33f69e52$var$schemaConstraints = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    var __spreadArray = $5683cded33f69e52$var$commonjsGlobal && $5683cded33f69e52$var$commonjsGlobal.__spreadArray || function(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };
    var __importDefault = $5683cded33f69e52$var$commonjsGlobal && $5683cded33f69e52$var$commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    var _a;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.V1_MARKS = exports1.V1_NODE_TYPES = exports1.TEXT_CONTAINERS = exports1.HEADINGS = exports1.CONTAINERS = exports1.VOID_BLOCKS = exports1.TABLE_BLOCKS = exports1.LIST_ITEM_BLOCKS = exports1.TOP_LEVEL_BLOCKS = void 0;
    var marks_1 = __importDefault($5683cded33f69e52$var$marks);
    /**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ exports1.TOP_LEVEL_BLOCKS = [
        $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_1,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_2,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_3,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_4,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_5,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_6,
        $5683cded33f69e52$var$blocks.BLOCKS.OL_LIST,
        $5683cded33f69e52$var$blocks.BLOCKS.UL_LIST,
        $5683cded33f69e52$var$blocks.BLOCKS.HR,
        $5683cded33f69e52$var$blocks.BLOCKS.QUOTE,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ENTRY,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ASSET,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_RESOURCE,
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE
    ];
    /**
 * Array of all allowed block types inside list items
 */ exports1.LIST_ITEM_BLOCKS = [
        $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_1,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_2,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_3,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_4,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_5,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_6,
        $5683cded33f69e52$var$blocks.BLOCKS.OL_LIST,
        $5683cded33f69e52$var$blocks.BLOCKS.UL_LIST,
        $5683cded33f69e52$var$blocks.BLOCKS.HR,
        $5683cded33f69e52$var$blocks.BLOCKS.QUOTE,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ENTRY,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ASSET,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_RESOURCE
    ];
    exports1.TABLE_BLOCKS = [
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE,
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE_ROW,
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE_CELL,
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE_HEADER_CELL
    ];
    /**
 * Array of all void block types
 */ exports1.VOID_BLOCKS = [
        $5683cded33f69e52$var$blocks.BLOCKS.HR,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ENTRY,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ASSET,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_RESOURCE
    ];
    /**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ exports1.CONTAINERS = (_a = {}, _a[$5683cded33f69e52$var$blocks.BLOCKS.OL_LIST] = [
        $5683cded33f69e52$var$blocks.BLOCKS.LIST_ITEM
    ], _a[$5683cded33f69e52$var$blocks.BLOCKS.UL_LIST] = [
        $5683cded33f69e52$var$blocks.BLOCKS.LIST_ITEM
    ], _a[$5683cded33f69e52$var$blocks.BLOCKS.LIST_ITEM] = exports1.LIST_ITEM_BLOCKS, _a[$5683cded33f69e52$var$blocks.BLOCKS.QUOTE] = [
        $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH
    ], _a[$5683cded33f69e52$var$blocks.BLOCKS.TABLE] = [
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE_ROW
    ], _a[$5683cded33f69e52$var$blocks.BLOCKS.TABLE_ROW] = [
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE_CELL,
        $5683cded33f69e52$var$blocks.BLOCKS.TABLE_HEADER_CELL
    ], _a[$5683cded33f69e52$var$blocks.BLOCKS.TABLE_CELL] = [
        $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH
    ], _a[$5683cded33f69e52$var$blocks.BLOCKS.TABLE_HEADER_CELL] = [
        $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH
    ], _a);
    /**
 * Array of all heading levels
 */ exports1.HEADINGS = [
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_1,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_2,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_3,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_4,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_5,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_6
    ];
    /**
 * Array of all block types that may contain text and inline nodes.
 */ exports1.TEXT_CONTAINERS = __spreadArray([
        $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH
    ], exports1.HEADINGS, true);
    /**
 * Node types before `tables` release.
 */ exports1.V1_NODE_TYPES = [
        $5683cded33f69e52$var$blocks.BLOCKS.DOCUMENT,
        $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_1,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_2,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_3,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_4,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_5,
        $5683cded33f69e52$var$blocks.BLOCKS.HEADING_6,
        $5683cded33f69e52$var$blocks.BLOCKS.OL_LIST,
        $5683cded33f69e52$var$blocks.BLOCKS.UL_LIST,
        $5683cded33f69e52$var$blocks.BLOCKS.LIST_ITEM,
        $5683cded33f69e52$var$blocks.BLOCKS.HR,
        $5683cded33f69e52$var$blocks.BLOCKS.QUOTE,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ENTRY,
        $5683cded33f69e52$var$blocks.BLOCKS.EMBEDDED_ASSET,
        $5683cded33f69e52$var$inlines.INLINES.HYPERLINK,
        $5683cded33f69e52$var$inlines.INLINES.ENTRY_HYPERLINK,
        $5683cded33f69e52$var$inlines.INLINES.ASSET_HYPERLINK,
        $5683cded33f69e52$var$inlines.INLINES.EMBEDDED_ENTRY,
        'text'
    ];
    /**
 * Marks before `superscript` & `subscript` release.
 */ exports1.V1_MARKS = [
        marks_1.default.BOLD,
        marks_1.default.CODE,
        marks_1.default.ITALIC,
        marks_1.default.UNDERLINE
    ];
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$schemaConstraints);
var $5683cded33f69e52$var$schemaConstraints_1 = $5683cded33f69e52$var$schemaConstraints.V1_MARKS;
var $5683cded33f69e52$var$schemaConstraints_2 = $5683cded33f69e52$var$schemaConstraints.V1_NODE_TYPES;
var $5683cded33f69e52$var$schemaConstraints_3 = $5683cded33f69e52$var$schemaConstraints.TEXT_CONTAINERS;
var $5683cded33f69e52$var$schemaConstraints_4 = $5683cded33f69e52$var$schemaConstraints.HEADINGS;
var $5683cded33f69e52$var$schemaConstraints_5 = $5683cded33f69e52$var$schemaConstraints.CONTAINERS;
var $5683cded33f69e52$var$schemaConstraints_6 = $5683cded33f69e52$var$schemaConstraints.VOID_BLOCKS;
var $5683cded33f69e52$var$schemaConstraints_7 = $5683cded33f69e52$var$schemaConstraints.TABLE_BLOCKS;
var $5683cded33f69e52$var$schemaConstraints_8 = $5683cded33f69e52$var$schemaConstraints.LIST_ITEM_BLOCKS;
var $5683cded33f69e52$var$schemaConstraints_9 = $5683cded33f69e52$var$schemaConstraints.TOP_LEVEL_BLOCKS;
var $5683cded33f69e52$var$types = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$types);
var $5683cded33f69e52$var$nodeTypes = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$nodeTypes);
var $5683cded33f69e52$var$emptyDocument = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    /**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ var EMPTY_DOCUMENT = {
        nodeType: $5683cded33f69e52$var$blocks.BLOCKS.DOCUMENT,
        data: {},
        content: [
            {
                nodeType: $5683cded33f69e52$var$blocks.BLOCKS.PARAGRAPH,
                data: {},
                content: [
                    {
                        nodeType: 'text',
                        value: '',
                        marks: [],
                        data: {}
                    }
                ]
            }
        ]
    };
    exports1.default = EMPTY_DOCUMENT;
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$emptyDocument);
var $5683cded33f69e52$var$helpers = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.isText = exports1.isBlock = exports1.isInline = void 0;
    /**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function hasValue(obj, value) {
        for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
            var key = _a[_i];
            if (value === obj[key]) return true;
        }
        return false;
    }
    /**
 * Checks if the node is an instance of Inline.
 */ function isInline(node) {
        return hasValue($5683cded33f69e52$var$inlines.INLINES, node.nodeType);
    }
    exports1.isInline = isInline;
    /**
 * Checks if the node is an instance of Block.
 */ function isBlock(node) {
        return hasValue($5683cded33f69e52$var$blocks.BLOCKS, node.nodeType);
    }
    exports1.isBlock = isBlock;
    /**
 * Checks if the node is an instance of Text.
 */ function isText(node) {
        return node.nodeType === 'text';
    }
    exports1.isText = isText;
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$helpers);
var $5683cded33f69e52$var$helpers_1 = $5683cded33f69e52$var$helpers.isText;
var $5683cded33f69e52$var$helpers_2 = $5683cded33f69e52$var$helpers.isBlock;
var $5683cded33f69e52$var$helpers_3 = $5683cded33f69e52$var$helpers.isInline;
var $5683cded33f69e52$var$dist = $5683cded33f69e52$var$createCommonjsModule(function(module, exports1) {
    var __createBinding = $5683cded33f69e52$var$commonjsGlobal && $5683cded33f69e52$var$commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m[k];
            }
        };
        Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var __setModuleDefault = $5683cded33f69e52$var$commonjsGlobal && $5683cded33f69e52$var$commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
        Object.defineProperty(o, "default", {
            enumerable: true,
            value: v
        });
    } : function(o, v) {
        o["default"] = v;
    });
    var __exportStar = $5683cded33f69e52$var$commonjsGlobal && $5683cded33f69e52$var$commonjsGlobal.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
    };
    var __importStar = $5683cded33f69e52$var$commonjsGlobal && $5683cded33f69e52$var$commonjsGlobal.__importStar || function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
    };
    var __importDefault = $5683cded33f69e52$var$commonjsGlobal && $5683cded33f69e52$var$commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.helpers = exports1.EMPTY_DOCUMENT = exports1.MARKS = exports1.INLINES = exports1.BLOCKS = void 0;
    Object.defineProperty(exports1, "BLOCKS", {
        enumerable: true,
        get: function() {
            return $5683cded33f69e52$var$blocks.BLOCKS;
        }
    });
    Object.defineProperty(exports1, "INLINES", {
        enumerable: true,
        get: function() {
            return $5683cded33f69e52$var$inlines.INLINES;
        }
    });
    Object.defineProperty(exports1, "MARKS", {
        enumerable: true,
        get: function() {
            return __importDefault($5683cded33f69e52$var$marks).default;
        }
    });
    __exportStar($5683cded33f69e52$var$schemaConstraints, exports1);
    __exportStar($5683cded33f69e52$var$types, exports1);
    __exportStar($5683cded33f69e52$var$nodeTypes, exports1);
    Object.defineProperty(exports1, "EMPTY_DOCUMENT", {
        enumerable: true,
        get: function() {
            return __importDefault($5683cded33f69e52$var$emptyDocument).default;
        }
    });
    var helpers$1 = __importStar($5683cded33f69e52$var$helpers);
    exports1.helpers = helpers$1;
});
$5683cded33f69e52$var$unwrapExports($5683cded33f69e52$var$dist);
var $5683cded33f69e52$var$dist_1 = $5683cded33f69e52$var$dist.helpers;
var $5683cded33f69e52$var$dist_2 = $5683cded33f69e52$var$dist.EMPTY_DOCUMENT;
var $5683cded33f69e52$var$dist_3 = $5683cded33f69e52$var$dist.MARKS;
var $5683cded33f69e52$var$dist_4 = $5683cded33f69e52$var$dist.INLINES;
var $5683cded33f69e52$var$dist_5 = $5683cded33f69e52$var$dist.BLOCKS;
function $5683cded33f69e52$var$appendKeyToValidElement(element, key) {
    if ($dvPqk.isValidElement(element) && element.key === null) return $dvPqk.cloneElement(element, {
        key: key
    });
    return element;
}
function $5683cded33f69e52$var$nodeListToReactComponents(nodes, options) {
    return nodes.map(function(node, index) {
        return $5683cded33f69e52$var$appendKeyToValidElement($5683cded33f69e52$var$nodeToReactComponent(node, options), index);
    });
}
function $5683cded33f69e52$var$nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText, preserveWhitespace = options.preserveWhitespace;
    if ($5683cded33f69e52$var$dist_1.isText(node)) {
        var nodeValue = renderText ? renderText(node.value) : node.value;
        if (preserveWhitespace) {
            // Preserve multiple spaces.
            nodeValue = nodeValue.replace(/ {2,}/g, function(match) {
                return '&nbsp;'.repeat(match.length);
            });
            // Preserve line breaks.
            var lines_1 = nodeValue.split('\n');
            var jsxLines_1 = [];
            lines_1.forEach(function(line, index) {
                jsxLines_1.push(line);
                if (index !== lines_1.length - 1) jsxLines_1.push($5683cded33f69e52$var$React__default.createElement("br", null));
            });
            nodeValue = jsxLines_1;
        }
        return node.marks.reduce(function(value, mark) {
            if (!renderMark[mark.type]) return value;
            return renderMark[mark.type](value);
        }, nodeValue);
    } else {
        var children = $5683cded33f69e52$var$nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) return $5683cded33f69e52$var$React__default.createElement($5683cded33f69e52$var$React__default.Fragment, null, children);
        return renderNode[node.nodeType](node, children);
    }
}
var $5683cded33f69e52$var$_a, $5683cded33f69e52$var$_b;
var $5683cded33f69e52$var$defaultNodeRenderers = ($5683cded33f69e52$var$_a = {}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.DOCUMENT] = function(node, children) {
    return children;
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.PARAGRAPH] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("p", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.HEADING_1] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("h1", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.HEADING_2] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("h2", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.HEADING_3] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("h3", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.HEADING_4] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("h4", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.HEADING_5] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("h5", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.HEADING_6] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("h6", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.EMBEDDED_ENTRY] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("div", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.EMBEDDED_RESOURCE] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("div", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.UL_LIST] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("ul", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.OL_LIST] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("ol", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.LIST_ITEM] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("li", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.QUOTE] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("blockquote", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.HR] = function() {
    return $5683cded33f69e52$var$React__default.createElement("hr", null);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.TABLE] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("table", null, $5683cded33f69e52$var$React__default.createElement("tbody", null, children));
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.TABLE_ROW] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("tr", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.TABLE_HEADER_CELL] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("th", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_5.TABLE_CELL] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("td", null, children);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_4.ASSET_HYPERLINK] = function(node) {
    return $5683cded33f69e52$var$defaultInline($5683cded33f69e52$var$dist_4.ASSET_HYPERLINK, node);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_4.ENTRY_HYPERLINK] = function(node) {
    return $5683cded33f69e52$var$defaultInline($5683cded33f69e52$var$dist_4.ENTRY_HYPERLINK, node);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_4.RESOURCE_HYPERLINK] = function(node) {
    return $5683cded33f69e52$var$defaultInlineResource($5683cded33f69e52$var$dist_4.RESOURCE_HYPERLINK, node);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_4.EMBEDDED_ENTRY] = function(node) {
    return $5683cded33f69e52$var$defaultInline($5683cded33f69e52$var$dist_4.EMBEDDED_ENTRY, node);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_4.EMBEDDED_RESOURCE] = function(node, children) {
    return $5683cded33f69e52$var$defaultInlineResource($5683cded33f69e52$var$dist_4.EMBEDDED_RESOURCE, node);
}, $5683cded33f69e52$var$_a[$5683cded33f69e52$var$dist_4.HYPERLINK] = function(node, children) {
    return $5683cded33f69e52$var$React__default.createElement("a", {
        href: node.data.uri
    }, children);
}, $5683cded33f69e52$var$_a);
var $5683cded33f69e52$var$defaultMarkRenderers = ($5683cded33f69e52$var$_b = {}, $5683cded33f69e52$var$_b[$5683cded33f69e52$var$dist_3.BOLD] = function(text) {
    return $5683cded33f69e52$var$React__default.createElement("b", null, text);
}, $5683cded33f69e52$var$_b[$5683cded33f69e52$var$dist_3.ITALIC] = function(text) {
    return $5683cded33f69e52$var$React__default.createElement("i", null, text);
}, $5683cded33f69e52$var$_b[$5683cded33f69e52$var$dist_3.UNDERLINE] = function(text) {
    return $5683cded33f69e52$var$React__default.createElement("u", null, text);
}, $5683cded33f69e52$var$_b[$5683cded33f69e52$var$dist_3.CODE] = function(text) {
    return $5683cded33f69e52$var$React__default.createElement("code", null, text);
}, $5683cded33f69e52$var$_b[$5683cded33f69e52$var$dist_3.SUPERSCRIPT] = function(text) {
    return $5683cded33f69e52$var$React__default.createElement("sup", null, text);
}, $5683cded33f69e52$var$_b[$5683cded33f69e52$var$dist_3.SUBSCRIPT] = function(text) {
    return $5683cded33f69e52$var$React__default.createElement("sub", null, text);
}, $5683cded33f69e52$var$_b);
function $5683cded33f69e52$var$defaultInline(type, node) {
    return $5683cded33f69e52$var$React__default.createElement("span", {
        key: node.data.target.sys.id
    }, "type: ", node.nodeType, " id: ", node.data.target.sys.id);
}
function $5683cded33f69e52$var$defaultInlineResource(type, node) {
    return $5683cded33f69e52$var$React__default.createElement("span", {
        key: node.data.target.sys.urn
    }, "type: ", node.nodeType, " urn: ", node.data.target.sys.urn);
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */ function $5683cded33f69e52$var$documentToReactComponents(richTextDocument, options) {
    if (options === void 0) options = {};
    if (!richTextDocument) return null;
    return $5683cded33f69e52$var$nodeToReactComponent(richTextDocument, {
        renderNode: $5683cded33f69e52$var$__assign($5683cded33f69e52$var$__assign({}, $5683cded33f69e52$var$defaultNodeRenderers), options.renderNode),
        renderMark: $5683cded33f69e52$var$__assign($5683cded33f69e52$var$__assign({}, $5683cded33f69e52$var$defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
        preserveWhitespace: options.preserveWhitespace
    });
}
module.exports.documentToReactComponents = $5683cded33f69e52$var$documentToReactComponents;

});

parcelRegister("d5xW5", function(module, exports) {
"use strict";
var $987610ef04abe6fb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $987610ef04abe6fb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $987610ef04abe6fb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $987610ef04abe6fb$var$__createBinding(exports1, m, p);
};
var $987610ef04abe6fb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $987610ef04abe6fb$var$__createBinding(result, mod, k);
    }
    $987610ef04abe6fb$var$__setModuleDefault(result, mod);
    return result;
};
var $987610ef04abe6fb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.helpers = module.exports.EMPTY_DOCUMENT = module.exports.MARKS = module.exports.INLINES = module.exports.BLOCKS = void 0;

var $7TbCc = parcelRequire("7TbCc");
Object.defineProperty(module.exports, "BLOCKS", {
    enumerable: true,
    get: function() {
        return $7TbCc.BLOCKS;
    }
});

var $7KvAg = parcelRequire("7KvAg");
Object.defineProperty(module.exports, "INLINES", {
    enumerable: true,
    get: function() {
        return $7KvAg.INLINES;
    }
});

var $5z2mb = parcelRequire("5z2mb");
Object.defineProperty(module.exports, "MARKS", {
    enumerable: true,
    get: function() {
        return $987610ef04abe6fb$var$__importDefault($5z2mb).default;
    }
});

$987610ef04abe6fb$var$__exportStar((parcelRequire("lJbHf")), module.exports);

$987610ef04abe6fb$var$__exportStar((parcelRequire("aMJoW")), module.exports);

$987610ef04abe6fb$var$__exportStar((parcelRequire("9TIvB")), module.exports);

var $3cH7r = parcelRequire("3cH7r");
Object.defineProperty(module.exports, "EMPTY_DOCUMENT", {
    enumerable: true,
    get: function() {
        return $987610ef04abe6fb$var$__importDefault($3cH7r).default;
    }
});

var $987610ef04abe6fb$var$helpers = $987610ef04abe6fb$var$__importStar((parcelRequire("4WCWK")));
module.exports.helpers = $987610ef04abe6fb$var$helpers;

});
parcelRegister("7TbCc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $5be6adf49dd57566$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($5be6adf49dd57566$var$BLOCKS = module.exports.BLOCKS || (module.exports.BLOCKS = {}));

});

parcelRegister("7KvAg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */ var $5a455434a2391365$var$INLINES;
(function(INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
})($5a455434a2391365$var$INLINES = module.exports.INLINES || (module.exports.INLINES = {}));

});

parcelRegister("5z2mb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Map of all Contentful marks.
 */ var $40d20ca3f86880eb$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})($40d20ca3f86880eb$var$MARKS || ($40d20ca3f86880eb$var$MARKS = {}));
module.exports.default = $40d20ca3f86880eb$var$MARKS;

});

parcelRegister("lJbHf", function(module, exports) {
"use strict";
var $fd16dfa0e638e0f2$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $fd16dfa0e638e0f2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $fd16dfa0e638e0f2$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1_MARKS = module.exports.V1_NODE_TYPES = module.exports.TEXT_CONTAINERS = module.exports.HEADINGS = module.exports.CONTAINERS = module.exports.VOID_BLOCKS = module.exports.TABLE_BLOCKS = module.exports.LIST_ITEM_BLOCKS = module.exports.TOP_LEVEL_BLOCKS = void 0;

var $7TbCc = parcelRequire("7TbCc");

var $7KvAg = parcelRequire("7KvAg");

var $fd16dfa0e638e0f2$var$marks_1 = $fd16dfa0e638e0f2$var$__importDefault((parcelRequire("5z2mb")));
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ module.exports.TOP_LEVEL_BLOCKS = [
    $7TbCc.BLOCKS.PARAGRAPH,
    $7TbCc.BLOCKS.HEADING_1,
    $7TbCc.BLOCKS.HEADING_2,
    $7TbCc.BLOCKS.HEADING_3,
    $7TbCc.BLOCKS.HEADING_4,
    $7TbCc.BLOCKS.HEADING_5,
    $7TbCc.BLOCKS.HEADING_6,
    $7TbCc.BLOCKS.OL_LIST,
    $7TbCc.BLOCKS.UL_LIST,
    $7TbCc.BLOCKS.HR,
    $7TbCc.BLOCKS.QUOTE,
    $7TbCc.BLOCKS.EMBEDDED_ENTRY,
    $7TbCc.BLOCKS.EMBEDDED_ASSET,
    $7TbCc.BLOCKS.EMBEDDED_RESOURCE,
    $7TbCc.BLOCKS.TABLE
];
/**
 * Array of all allowed block types inside list items
 */ module.exports.LIST_ITEM_BLOCKS = [
    $7TbCc.BLOCKS.PARAGRAPH,
    $7TbCc.BLOCKS.HEADING_1,
    $7TbCc.BLOCKS.HEADING_2,
    $7TbCc.BLOCKS.HEADING_3,
    $7TbCc.BLOCKS.HEADING_4,
    $7TbCc.BLOCKS.HEADING_5,
    $7TbCc.BLOCKS.HEADING_6,
    $7TbCc.BLOCKS.OL_LIST,
    $7TbCc.BLOCKS.UL_LIST,
    $7TbCc.BLOCKS.HR,
    $7TbCc.BLOCKS.QUOTE,
    $7TbCc.BLOCKS.EMBEDDED_ENTRY,
    $7TbCc.BLOCKS.EMBEDDED_ASSET,
    $7TbCc.BLOCKS.EMBEDDED_RESOURCE
];
module.exports.TABLE_BLOCKS = [
    $7TbCc.BLOCKS.TABLE,
    $7TbCc.BLOCKS.TABLE_ROW,
    $7TbCc.BLOCKS.TABLE_CELL,
    $7TbCc.BLOCKS.TABLE_HEADER_CELL
];
/**
 * Array of all void block types
 */ module.exports.VOID_BLOCKS = [
    $7TbCc.BLOCKS.HR,
    $7TbCc.BLOCKS.EMBEDDED_ENTRY,
    $7TbCc.BLOCKS.EMBEDDED_ASSET,
    $7TbCc.BLOCKS.EMBEDDED_RESOURCE
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ module.exports.CONTAINERS = ($fd16dfa0e638e0f2$var$_a = {}, $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.OL_LIST] = [
    $7TbCc.BLOCKS.LIST_ITEM
], $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.UL_LIST] = [
    $7TbCc.BLOCKS.LIST_ITEM
], $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.LIST_ITEM] = module.exports.LIST_ITEM_BLOCKS, $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.QUOTE] = [
    $7TbCc.BLOCKS.PARAGRAPH
], $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.TABLE] = [
    $7TbCc.BLOCKS.TABLE_ROW
], $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.TABLE_ROW] = [
    $7TbCc.BLOCKS.TABLE_CELL,
    $7TbCc.BLOCKS.TABLE_HEADER_CELL
], $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.TABLE_CELL] = [
    $7TbCc.BLOCKS.PARAGRAPH
], $fd16dfa0e638e0f2$var$_a[$7TbCc.BLOCKS.TABLE_HEADER_CELL] = [
    $7TbCc.BLOCKS.PARAGRAPH
], $fd16dfa0e638e0f2$var$_a);
/**
 * Array of all heading levels
 */ module.exports.HEADINGS = [
    $7TbCc.BLOCKS.HEADING_1,
    $7TbCc.BLOCKS.HEADING_2,
    $7TbCc.BLOCKS.HEADING_3,
    $7TbCc.BLOCKS.HEADING_4,
    $7TbCc.BLOCKS.HEADING_5,
    $7TbCc.BLOCKS.HEADING_6
];
/**
 * Array of all block types that may contain text and inline nodes.
 */ module.exports.TEXT_CONTAINERS = $fd16dfa0e638e0f2$var$__spreadArray([
    $7TbCc.BLOCKS.PARAGRAPH
], module.exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */ module.exports.V1_NODE_TYPES = [
    $7TbCc.BLOCKS.DOCUMENT,
    $7TbCc.BLOCKS.PARAGRAPH,
    $7TbCc.BLOCKS.HEADING_1,
    $7TbCc.BLOCKS.HEADING_2,
    $7TbCc.BLOCKS.HEADING_3,
    $7TbCc.BLOCKS.HEADING_4,
    $7TbCc.BLOCKS.HEADING_5,
    $7TbCc.BLOCKS.HEADING_6,
    $7TbCc.BLOCKS.OL_LIST,
    $7TbCc.BLOCKS.UL_LIST,
    $7TbCc.BLOCKS.LIST_ITEM,
    $7TbCc.BLOCKS.HR,
    $7TbCc.BLOCKS.QUOTE,
    $7TbCc.BLOCKS.EMBEDDED_ENTRY,
    $7TbCc.BLOCKS.EMBEDDED_ASSET,
    $7KvAg.INLINES.HYPERLINK,
    $7KvAg.INLINES.ENTRY_HYPERLINK,
    $7KvAg.INLINES.ASSET_HYPERLINK,
    $7KvAg.INLINES.EMBEDDED_ENTRY,
    'text'
];
/**
 * Marks before `superscript` & `subscript` release.
 */ module.exports.V1_MARKS = [
    $fd16dfa0e638e0f2$var$marks_1.default.BOLD,
    $fd16dfa0e638e0f2$var$marks_1.default.CODE,
    $fd16dfa0e638e0f2$var$marks_1.default.ITALIC,
    $fd16dfa0e638e0f2$var$marks_1.default.UNDERLINE
];

});

parcelRegister("aMJoW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9TIvB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3cH7r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7TbCc = parcelRequire("7TbCc");
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ var $2553f09d99fc253b$var$EMPTY_DOCUMENT = {
    nodeType: $7TbCc.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $7TbCc.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
module.exports.default = $2553f09d99fc253b$var$EMPTY_DOCUMENT;

});

parcelRegister("4WCWK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isText = module.exports.isBlock = module.exports.isInline = void 0;

var $7TbCc = parcelRequire("7TbCc");

var $7KvAg = parcelRequire("7KvAg");
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $399aca27765f17c8$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $399aca27765f17c8$var$isInline(node) {
    return $399aca27765f17c8$var$hasValue($7KvAg.INLINES, node.nodeType);
}
module.exports.isInline = $399aca27765f17c8$var$isInline;
/**
 * Checks if the node is an instance of Block.
 */ function $399aca27765f17c8$var$isBlock(node) {
    return $399aca27765f17c8$var$hasValue($7TbCc.BLOCKS, node.nodeType);
}
module.exports.isBlock = $399aca27765f17c8$var$isBlock;
/**
 * Checks if the node is an instance of Text.
 */ function $399aca27765f17c8$var$isText(node) {
    return node.nodeType === 'text';
}
module.exports.isText = $399aca27765f17c8$var$isText;

});


parcelRegister("8ri8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $537c582fb34c8377$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $537c582fb34c8377$var$Divider = ({ className: className = "", margin: margin = "md" })=>{
    const lineSeparatorStyle = "border-solid border-0 border-t border-ink-border-subtle";
    const lineMargin = {
        sm: "my-4",
        md: "my-6",
        lg: "my-8",
        none: ""
    }[margin];
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: (0, $izjX7.cn)(className, lineSeparatorStyle, lineMargin)
    });
};
var $537c582fb34c8377$export$2e2bcd8739ae039 = (0, $gBcml.observer)($537c582fb34c8377$var$Divider);

});

parcelRegister("6pY3b", function(module, exports) {

$parcel$export(module.exports, "InternalLink", function () { return $cc59f3c5564a23bd$export$f35822977cb6df33; });
$parcel$export(module.exports, "ExternalLink", function () { return $cc59f3c5564a23bd$export$b2bf131c9f9cce5d; });
$parcel$export(module.exports, "DownloadLink", function () { return $cc59f3c5564a23bd$export$e4b4308b0fcf57cc; });
$parcel$export(module.exports, "WouterLinkWithTracking", function () { return $cc59f3c5564a23bd$export$6b22534301dacda5; });

var $7YWoO = parcelRequire("7YWoO");

var $1CHsm = parcelRequire("1CHsm");
var $8VZKJ = parcelRequire("8VZKJ");

var $4rjCr = parcelRequire("4rjCr");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");
const $cc59f3c5564a23bd$export$f35822977cb6df33 = ({ href: href = "", variant: variant = "default", children: children, icon: icon = null, iconPosition: iconPosition = "left", className: className = "", trackingLocationName: trackingLocationName, onClick: onClick, ...props })=>{
    const linkName = props.linkName || children?.toString();
    const handleClick = (e)=>{
        (0, $6fuyt.sendInternalLinkClick)(href, trackingLocationName, linkName);
        if (typeof onClick === "function") onClick(e);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
        href: href,
        ...props,
        asChild: true,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
            as: "a",
            className: className,
            variant: variant,
            icon: icon,
            iconPosition: iconPosition,
            "aria-label": `G\xe5 til ${href}`,
            children: children
        })
    });
};
const $cc59f3c5564a23bd$export$b2bf131c9f9cce5d = ({ href: href = "", variant: variant = "default", children: children, className: className = "", ...props })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
        href: href,
        as: "a",
        target: "_blank",
        rel: "noopener noreferrer",
        icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8VZKJ.default), {}),
        className: className,
        variant: variant,
        iconPosition: "right",
        "aria-label": `G\xe5 til ${href}`,
        ...props,
        children: children
    });
};
const $cc59f3c5564a23bd$export$e4b4308b0fcf57cc = ({ href: href = "", variant: variant = "default", children: children, className: className = "", ...props })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        variant: variant,
        icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1CHsm.default), {}),
        iconPosition: "right",
        "aria-label": `Last ned ${href}`,
        ...props,
        children: children
    });
};
const $cc59f3c5564a23bd$export$6b22534301dacda5 = ({ trackingLocationName: trackingLocationName, linkName: linkName, children: children, onClick: onClick, ...props })=>{
    const ref = (0, $dvPqk.useRef)(null);
    const [text, setText] = (0, $dvPqk.useState)(undefined);
    (0, $dvPqk.useEffect)(()=>{
        if (ref.current) setText(ref.current.innerText);
    }, []);
    const name = linkName || text;
    const handleClick = (e)=>{
        if (name && props.to) (0, $6fuyt.sendInternalLinkClick)(props.to, trackingLocationName, name);
        onClick?.(e);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
        ...props,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
            ref: ref,
            children: children
        })
    });
};

});
parcelRegister("1CHsm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12eb0c9d263284ae$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $12eb0c9d263284ae$var$SvgDownload = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m12 16-4-4 1.063-1.062 2.187 2.187V6h1.5v7.125l2.188-2.187L16 12zm-6 3v-3h1.5v1.5h9V16H18v3z"
        })
    }));
var $12eb0c9d263284ae$export$2e2bcd8739ae039 = $12eb0c9d263284ae$var$SvgDownload;

});

parcelRegister("8VZKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68138c6acfe0230a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $68138c6acfe0230a$var$SvgOpenInNew = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M5 19V5h7v1.5H6.5v11h11V12H19v7zm5.063-4L9 13.938 16.438 6.5H14V5h5v5h-1.5V7.563z"
        })
    }));
var $68138c6acfe0230a$export$2e2bcd8739ae039 = $68138c6acfe0230a$var$SvgOpenInNew;

});


parcelRegister("cGvcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $080765fb7c347936$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $080765fb7c347936$var$Quote = ({ children: children })=>{
    const quoteComponentStyle = "my-16 flex flex-col items-center gap-4 md:gap-5";
    const doubleQuotationMarkStyle = "h-12 text-8xl md:text-9xl font-bold font-['InaiMathi']";
    const quoteStyle = "text-center text-2xl md:text-2xl font-semibold [&_p]:mb-0 [&>div]:mx-0 [&>div]:w-full [&>div]:max-w-xl";
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("blockquote", {
        className: (0, $izjX7.cn)(quoteComponentStyle, quoteStyle),
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                className: doubleQuotationMarkStyle,
                children: "\u201C"
            }),
            children
        ]
    });
};
var $080765fb7c347936$export$2e2bcd8739ae039 = (0, $gBcml.observer)($080765fb7c347936$var$Quote);

});

parcelRegister("d59hY", function(module, exports) {

$parcel$export(module.exports, "RichTextColumn", function () { return $f1251e419f64a047$export$274c1e029793021f; });
$parcel$export(module.exports, "RichTextListItem", function () { return $f1251e419f64a047$export$e2ab555281f42013; });
$parcel$export(module.exports, "RichTextTable", function () { return $f1251e419f64a047$export$56696c7fda8d1cd; });

var $7YWoO = parcelRequire("7YWoO");

var $7qw1I = parcelRequire("7qw1I");

var $d5xW5 = parcelRequire("d5xW5");

var $cR6lR = parcelRequire("cR6lR");
var $aqsnV = parcelRequire("aqsnV");
var $4Y3YK = parcelRequire("4Y3YK");
var $l83zr = parcelRequire("l83zr");
var $2RPNt = parcelRequire("2RPNt");
var $gVtxS = parcelRequire("gVtxS");

var $dvPqk = parcelRequire("dvPqk");

var $5OqMf = parcelRequire("5OqMf");
const $f1251e419f64a047$export$274c1e029793021f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "w-full max-w-2xl mx-auto text-md md:text-lg",
        children: children
    });
};
const $f1251e419f64a047$export$e2ab555281f42013 = ({ node: node, customRenderNodes: customRenderNodes })=>{
    const listItemDocument = {
        nodeType: (0, $d5xW5.BLOCKS).DOCUMENT,
        content: [
            {
                nodeType: (0, $d5xW5.BLOCKS).EMBEDDED_RESOURCE,
                content: node.content,
                data: {}
            }
        ],
        data: {}
    };
    const customRenderOptions = {
        renderNode: {
            ...customRenderNodes
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
        className: "list-outside",
        children: (0, $7qw1I.documentToReactComponents)(listItemDocument, customRenderOptions)
    });
};
const $f1251e419f64a047$export$56696c7fda8d1cd = ({ table: table, customRenderNodes: customRenderNodes })=>{
    const toBlockOrInline = (item)=>{
        if ("content" in item) return item;
        return undefined;
    };
    const hasHeader = table.content.map((rows)=>toBlockOrInline(rows)?.content.find((cell)=>cell.nodeType === "table-header-cell"));
    const headerRow = hasHeader ? toBlockOrInline(table.content[0])?.content : undefined;
    const tableRows = hasHeader ? table.content.slice(1) : table.content;
    const getHeaderName = (index)=>{
        const headerCell = headerRow && toBlockOrInline(headerRow[index]);
        const headerContent = headerCell && getCellContent(headerCell);
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).isValidElement(headerContent)) return (0, $5OqMf.extractTextFromReactNode)(headerContent);
        return "";
    };
    const getCellContent = (cell)=>{
        const tableCellDocument = {
            nodeType: (0, $d5xW5.BLOCKS).DOCUMENT,
            content: [
                {
                    nodeType: (0, $d5xW5.BLOCKS).EMBEDDED_RESOURCE,
                    content: cell.content,
                    data: {}
                }
            ],
            data: {}
        };
        const customRenderOptions = {
            renderNode: {
                ...customRenderNodes
            }
        };
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
            children: (0, $7qw1I.documentToReactComponents)(tableCellDocument, customRenderOptions)
        });
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $cR6lR.Table), {
        fullWidth: true,
        className: "my-8",
        children: [
            headerRow && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $l83zr.TableHeader), {
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gVtxS.TableRow), {
                    children: headerRow.map((_, cellIndex)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $2RPNt.TableHeaderCell), {
                            id: cellIndex.toString(),
                            children: getHeaderName(cellIndex)
                        }, `${cellIndex + 1}`))
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aqsnV.TableBody), {
                children: tableRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $gVtxS.TableRow), {
                        children: row.content.map((cell, cellIndex)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Y3YK.TableCell), {
                                headers: getHeaderName(cellIndex),
                                children: getCellContent(cell)
                            }, `${cellIndex + 1}`))
                    }, `${rowIndex + 1}`))
            })
        ]
    });
};

});
parcelRegister("cR6lR", function(module, exports) {

$parcel$export(module.exports, "Table", function () { return $95bf5c8e7a95a4c7$export$54ec01a60f47d33d; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");
function $95bf5c8e7a95a4c7$export$54ec01a60f47d33d({ className: t, children: d, fullWidth: e, transparent: b = !1, stickyHeader: r = !1, ref: l, ...f }) {
    const s = (0, $dvPqk.useRef)(null);
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)(e ? "w-full" : "w-fit", r ? "" : "overflow-x-hidden", "border border-ink-border-default rounded-md", t),
        children: /* @__PURE__ */ (0, $7YWoO.jsx)("table", {
            cellSpacing: 0,
            className: (0, $6sMuH.cn)("text-left table-fixed max-lg:w-full border-collapse border-ink-border-subtle", e ? "w-full" : "w-auto", b ? "bg-transparent" : "bg-surface-default", {
                "overflow-y-auto [&>thead]:sticky [&>thead]:top-0 [&>thead]:z-10 [&>thead]:border-b-ink-border-subtle": r
            }),
            ref: l || s,
            ...f,
            children: d
        })
    });
}
$95bf5c8e7a95a4c7$export$54ec01a60f47d33d.displayName = "Table";

});

parcelRegister("aqsnV", function(module, exports) {

$parcel$export(module.exports, "TableBody", function () { return $797259bf2adea9b4$export$76ccd210b9029917; });

var $7YWoO = parcelRequire("7YWoO");
function $797259bf2adea9b4$export$76ccd210b9029917({ children: o, className: e, ref: r, ...t }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)("tbody", {
        className: e,
        ref: r,
        ...t,
        children: o
    });
}
$797259bf2adea9b4$export$76ccd210b9029917.displayName = "TableBody";

});

parcelRegister("4Y3YK", function(module, exports) {

$parcel$export(module.exports, "TableCell", function () { return $39dfda1d80e05cdb$export$1e4baea7053fc0e3; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
function $39dfda1d80e05cdb$export$1e4baea7053fc0e3({ children: l, className: r, colSpan: o, headers: e, ref: t, ...a }) {
    const m = e.length > 0;
    return /* @__PURE__ */ (0, $7YWoO.jsx)("td", {
        className: (0, $6sMuH.cn)([
            "p-4",
            "align-top",
            "break-words"
        ], [
            "max-lg:grid",
            "max-lg:font-medium"
        ], [
            "max-lg:border",
            "max-lg:border-transparent",
            "max-lg:last:border-b-0",
            "max-lg:border-b-ink-border-subtle"
        ], m ? [
            "max-lg:grid-cols-2",
            "max-lg:before:content-[attr(headers)]",
            "max-lg:before:text-ink-brand-default",
            "max-lg:before:font-normal",
            "max-lg:before:hyphens-auto",
            "max-lg:before:mr-1"
        ] : [
            "max-lg:grid-cols-1",
            "max-lg:justify-items-end",
            "max-lg:before:content-none"
        ], r),
        colSpan: o,
        headers: e,
        ref: t,
        ...a,
        children: l
    });
}
$39dfda1d80e05cdb$export$1e4baea7053fc0e3.displayName = "TableCell";

});

parcelRegister("l83zr", function(module, exports) {

$parcel$export(module.exports, "TableHeader", function () { return $f61d1d60e131c04c$export$f850895b287ef28e; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
function $f61d1d60e131c04c$export$f850895b287ef28e({ children: e, className: r, ref: a, ...o }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)("thead", {
        className: (0, $6sMuH.cn)("font-semibold text-ink-brand-default bg-surface-default-hover max-lg:text-clip max-lg:h-[1px] max-lg:w-[1px] max-lg:absolute max-lg:overflow-hidden max-lg:m-[-1px] border-base-transparent border-x-0 border-t-0 border-b-[1.5px] border-b-ink-border-subtle", r),
        ref: a,
        ...o,
        children: e
    });
}
$f61d1d60e131c04c$export$f850895b287ef28e.displayName = "TableHeader";

});

parcelRegister("2RPNt", function(module, exports) {

$parcel$export(module.exports, "TableHeaderCell", function () { return $2168b5d2a4d12c2e$export$9e1517a3035b3e5c; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $cGjF4 = parcelRequire("cGjF4");

var $fUVHS = parcelRequire("fUVHS");

var $fSQNW = parcelRequire("fSQNW");
function $2168b5d2a4d12c2e$export$9e1517a3035b3e5c({ children: n, className: r, id: s, sortable: t = !1, sort: e, onSortClick: i, ref: l, ...m }) {
    const c = e === "ascending" || e === "descending" ? ({
        ascending: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fSQNW.default), {}),
        descending: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fSQNW.default), {
            className: "rotate-180"
        })
    })[e] : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fUVHS.default), {});
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("th", {
        "aria-sort": e,
        className: (0, $6sMuH.cn)("p-4 text-sm max-lg:hidden table-cell", t && "", e && "", r),
        "data-cell": n,
        id: s,
        ref: l,
        scope: "row",
        ...m,
        children: [
            t ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                className: "font-semibold text-sm bg-base-transparent !p-1 [&>svg]:flex-shrink-0",
                icon: c,
                iconPosition: "right",
                onClick: i,
                variant: "tertiary",
                children: n
            }) : null,
            !t && n
        ]
    });
}
$2168b5d2a4d12c2e$export$9e1517a3035b3e5c.displayName = "TableHeaderCell";

});
parcelRegister("fUVHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02fd8fe484197ccf$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $02fd8fe484197ccf$export$2e2bcd8739ae039 = (l)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, l, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M8.656 13.125v-6.89l-2.46 2.46L5 7.5 9.5 3 14 7.5l-1.195 1.195-2.461-2.46v6.89zM15.125 21l-4.5-4.5 1.195-1.195 2.461 2.46v-6.89h1.688v6.89l2.46-2.46 1.196 1.195z"
        })
    }));

});

parcelRegister("fSQNW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b904dc0a3412c36c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $b904dc0a3412c36c$export$2e2bcd8739ae039 = (r)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, r, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m12 15-5-5h10z"
        })
    }));

});


parcelRegister("gVtxS", function(module, exports) {

$parcel$export(module.exports, "TableRow", function () { return $c528e34d65bfe0e7$export$b05581f4e764e162; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
function $c528e34d65bfe0e7$export$b05581f4e764e162({ children: r, className: e, ref: o, ...t }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)("tr", {
        className: (0, $6sMuH.cn)(// Base styles
        "text-sm", // Border styles
        "border-b", "border-b-ink-border-subtle", "last:border-b-0", // Mobile-specific borders
        "even:max-lg:border-t", "even:max-lg:border-t-ink-border-subtle", // Hover state
        "hover:bg-surface-default-hover", // Mobile first row special case
        "max-lg:first-of-type:[&_td]:bg-surface-default-hover", "max-lg:first-of-type:[&_td]:border-[1.5px]", e),
        ref: o,
        ...t,
        children: r
    });
}
$c528e34d65bfe0e7$export$b05581f4e764e162.displayName = "TableRow";

});



parcelRegister("cZSqT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed5ab96c224f1129$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $2iR6d = parcelRequire("2iR6d");

var $izjX7 = parcelRequire("izjX7");

var $isIf6 = parcelRequire("isIf6");
const $ed5ab96c224f1129$var$InformationBox = ({ theme: theme, title: title, className: className, children: children })=>{
    const commonClasses = "flex flex-col rounded-lg gap-4 relative";
    // There is less padding-bottom because the richtext always ends with a <p> tag, which adds padding-bottom.
    const placementClasses = "max-w-2xl w-full mx-0 md:mx-auto px-6 pt-11 pb-4 md:px-12 md:pb-12 md:pt-16";
    const themeClasses = {
        main: "text-ink-brand-default bg-surface-default-hover",
        christmas: "text-ink-brand-inverted [&_label]:text-base-0 bg-christmas pt-6 md:pt-6",
        sustainable: "text-ink-brand-default bg-surface-tip"
    }[theme];
    const flowersClasses = {
        main: "absolute left-0 -top-8",
        christmas: "",
        sustainable: "absolute left-0 -top-8"
    }[theme];
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: (0, $izjX7.cn)(className, commonClasses, placementClasses, themeClasses),
        children: [
            (0, $isIf6.default).storeId === "tinehandel" && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: (0, $izjX7.cn)("w-full flex justify-center items-center", flowersClasses),
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2iR6d.default), {
                        height: 32,
                        width: 32
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2iR6d.default), {
                        height: 64,
                        width: 64
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2iR6d.default), {
                        height: 32,
                        width: 32
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        className: "text-center text-3xl",
                        children: title
                    }),
                    children && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "my-6 w-full flex justify-center",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("hr", {
                                    className: "border w-11"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "text-lg",
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ed5ab96c224f1129$export$2e2bcd8739ae039 = $ed5ab96c224f1129$var$InformationBox;

});
parcelRegister("2iR6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad673a353d7850f$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $1ad673a353d7850f$var$SvgFlower = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "inherit",
                d: "M5.326 6.034c.247-.02.5-.012.75.03V6.06a3 3 0 0 1-.029-.75q.002-.068.007-.126c.03-.219.068-.404-.082-.554a.47.47 0 0 0-.725.595l-.005.004.005.004-.008.003a.472.472 0 0 0-.594.724c.15.15.335.111.554.084a1 1 0 0 1 .127-.01m12.651-.844q.008.058.008.125.03.373-.03.75h.004q.376-.06.75-.028.068.001.125.008c.219.03.405.068.556-.082a.47.47 0 0 0-.287-.801.47.47 0 0 0-.308.077l-.004-.004-.004.004-.003-.007a.472.472 0 0 0-.725-.595c-.15.147-.11.333-.082.553m.717 12.778c-.247.02-.5.012-.75-.03v.003q.062.379.029.752a1 1 0 0 1-.009.125c-.028.219-.067.404.082.556a.472.472 0 0 0 .726-.595l.005-.004-.005-.005.007-.003a.472.472 0 0 0 .697-.57.5.5 0 0 0-.102-.152c-.15-.15-.335-.111-.554-.084q-.057.006-.126.007"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "inherit",
                d: "M17.377 17.708a.27.27 0 0 1 .334-.333v-.001a2.58 2.58 0 0 0 2.549-.645 2.567 2.567 0 0 0 .003-3.633c-2.614-2.616-4.659 1.486-7.326-1.083l-.01-.009.008-.007c2.672-2.572 4.711 1.535 7.329-1.077a2.567 2.567 0 0 0-2.543-4.281.27.27 0 0 1-.333-.333h-.003a2.56 2.56 0 0 0-.645-2.546 2.57 2.57 0 0 0-3.635-.001c-2.617 2.607 1.486 4.65-1.086 7.315l-.009.01-.007-.007c-2.572-2.67 1.538-4.71-1.076-7.324a2.573 2.573 0 0 0-3.636-.002 2.57 2.57 0 0 0-.65 2.545.271.271 0 0 1-.333.333v.002a2.58 2.58 0 0 0-2.549.646 2.567 2.567 0 0 0-.003 3.633c2.614 2.613 4.658-1.486 7.325 1.081l.009.01-.006.006c-2.672 2.572-4.711-1.535-7.33 1.077a2.567 2.567 0 0 0 2.544 4.281.27.27 0 0 1 .333.333l.002.001a2.57 2.57 0 0 0 4.281 2.547c2.618-2.61-1.486-4.654 1.086-7.319l.01-.01.007.006c2.574 2.67-1.538 4.708 1.076 7.323a2.573 2.573 0 0 0 4.31-1.178 2.56 2.56 0 0 0-.026-1.36M9.159 9.415C7.507 7.762 7.54 7.729 7.639 7.629c.1-.099.133-.132 1.786 1.52 1.652 1.653 1.619 1.686 1.518 1.785-.1.1-.132.134-1.784-1.52m.262 5.436c-1.655 1.651-1.69 1.617-1.788 1.518-.1-.101-.133-.134 1.522-1.785 1.654-1.65 1.687-1.617 1.788-1.517.098.099.133.134-1.522 1.784m5.443-5.433c-1.654 1.651-1.687 1.618-1.787 1.518s-.134-.133 1.522-1.785c1.655-1.651 1.688-1.617 1.787-1.517.1.099.133.134-1.522 1.784m-.27 5.436c-1.652-1.652-1.62-1.686-1.52-1.786s.134-.132 1.786 1.52c1.651 1.652 1.618 1.685 1.519 1.785s-.133.134-1.786-1.52"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "inherit",
                d: "M6.043 18.814a2 2 0 0 1-.009-.126c-.02-.247-.011-.5.03-.75h-.002q-.379.062-.752.029-.063 0-.125-.009c-.22-.029-.405-.067-.556.082a.47.47 0 0 0 .287.802.47.47 0 0 0 .307-.077l.005.004.004-.004.003.007a.472.472 0 0 0 .724.595c.15-.149.111-.335.084-.553"
            })
        ]
    }));
var $1ad673a353d7850f$export$2e2bcd8739ae039 = $1ad673a353d7850f$var$SvgFlower;

});



parcelRegister("cwSVZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f8fc585c3dca423$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $im5sL = parcelRequire("im5sL");

var $ltkat = parcelRequire("ltkat");
var $bku7t = parcelRequire("bku7t");
var $9RFMZ = parcelRequire("9RFMZ");
var $hVdnz = parcelRequire("hVdnz");
var $hU8Lt = parcelRequire("hU8Lt");
var $3DyOn = parcelRequire("3DyOn");
var $kejni = parcelRequire("kejni");
var $ew9jz = parcelRequire("ew9jz");
var $gvO8F = parcelRequire("gvO8F");
var $cQFu4 = parcelRequire("cQFu4");
var $lqY6u = parcelRequire("lqY6u");
var $9Ypw5 = parcelRequire("9Ypw5");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $dZidx = parcelRequire("dZidx");
const $2f8fc585c3dca423$var$LogoList = ({ content: content })=>{
    const title = content.fields.title;
    const logos = content.fields.logos;
    const linkText = content.fields.linkText;
    const linkUrl = content.fields.linkUrl;
    const backgroundColor = content.fields.background;
    const logoClasses = "w-16 lg:w-24";
    const contentType = content.sys.contentType.sys.id;
    const logoComponents = {
        Norvegia: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ew9jz.default), {
            className: logoClasses
        }),
        Jarlsberg: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hU8Lt.default), {
            className: logoClasses
        }),
        Sunniva: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lqY6u.default), {
            className: logoClasses
        }),
        Iste: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hVdnz.default), {
            className: logoClasses
        }),
        Yt: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Ypw5.default), {
            className: logoClasses
        }),
        Selbu: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gvO8F.default), {
            className: logoClasses
        }),
        Biola: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ltkat.default), {
            className: logoClasses
        }),
        Snofrisk: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cQFu4.default), {
            className: logoClasses
        }),
        Dovre: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bku7t.default), {
            className: logoClasses
        }),
        Litago: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3DyOn.default), {
            className: logoClasses
        }),
        Noisy: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kejni.default), {
            className: logoClasses
        }),
        Gryr: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9RFMZ.default), {
            className: logoClasses
        })
    };
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(title, contentType);
    };
    const { ref: viewRef } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    const handleClickLogoLink = ()=>{
        (0, $6fuyt.sendSelectTeaser)(title, contentType, undefined, `/${linkUrl}`);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        ref: viewRef,
        className: "relative flex flex-col w-full",
        children: [
            backgroundColor && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dZidx.default), {
                color: "bg-infoBoxBackground"
            }),
            title && /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                className: "px-10 pt-8 text-xl font-semibold text-center lg:pt-12 lg:text-2xl",
                children: title
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "flex max-w-[800px] flex-wrap items-center justify-center gap-10 self-center px-10 py-10 lg:px-0 lg:py-12",
                children: Object.keys(logoComponents).map((logoName)=>logos.includes(logoName) ? /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: logoComponents[logoName]
                    }, logoName) : null)
            }),
            linkUrl && linkText && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
                to: linkUrl,
                onClick: handleClickLogoLink,
                className: "flex flex-row items-center justify-center pb-8 lg:pb-12",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                        className: "text-base",
                        children: linkText
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $im5sL.default), {})
                ]
            })
        ]
    });
};
var $2f8fc585c3dca423$export$2e2bcd8739ae039 = $2f8fc585c3dca423$var$LogoList;

});
parcelRegister("im5sL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5ce84eadbbff875$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $d5ce84eadbbff875$var$SvgArrowForward = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M15.125 12.75H6v-1.5h9.125l-4.187-4.187L12 6l6 6-6 6-1.062-1.062z"
        })
    }));
var $d5ce84eadbbff875$export$2e2bcd8739ae039 = $d5ce84eadbbff875$var$SvgArrowForward;

});

parcelRegister("ltkat", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1bf3559d9d3ffe$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $fa1bf3559d9d3ffe$var$SvgBiola = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("defs", {
                children: (0, $7YWoO.jsx)("clipPath", {
                    id: "biola_svg__a",
                    clipPathUnits: "userSpaceOnUse",
                    children: (0, $7YWoO.jsx)("path", {
                        d: "M0 170.079h283.465V0H0Z"
                    })
                })
            }),
            (0, $7YWoO.jsxs)("g", {
                clipPath: "url(#biola_svg__a)",
                transform: "matrix(1.12873 0 0 -1.12873 -59.807 196.344)",
                children: [
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0q-.178 0-.49-.024l.123.099c.606.44 5.584 4.322 5.766 12.572.129 4.994-2.353 8.286-7.181 9.52l-1.165.298-.045.007a11 11 0 0 1-1.286.148l-.059.007c-.129.018-.614.073-1.347.073-4.326 0-15.203-1.749-22.706-17.947l-.077-.18.025.169c.931 5.624 1.455 9.637 1.592 12.27a4.85 4.85 0 0 1-4.835 5.213 4.855 4.855 0 0 1-4.743-3.88l-.002-.014c-.913-3.451-1.697-10.449-2.159-19.208-.285-5.425-.211-18.021-.131-21.871v-.02a4 4 0 0 1 .012-.561c.208-2.491 2.325-4.44 4.823-4.44q.203 0 .407.016c2.191.184 3.984 1.82 4.364 3.952l.004.02c.268 1.186.609 3.175.968 5.279l.012.063c.357 2.076.728 4.22 1.02 5.531 1.316 5.885 3.87 12.142 6.832 16.739 3.734 5.787 7.961 8.847 12.224 8.847.377 0 .758-.024 1.131-.071 1.129-.145 1.925-.728 2.247-1.644.579-1.665-.386-4.117-2.463-6.248-.637-.654-1.326-1.319-1.994-1.965-3.271-3.162-6.655-6.432-5.45-9.787.538-1.504 1.88-2.234 4.1-2.234 1.29 0 2.693.228 4.047.448 1.18.191 2.294.372 3.19.372.524 0 .93-.063 1.242-.191.699-.287 1.639-1.135 1.985-2.577.408-1.703.108-4.644-3.627-8.987-8.325-9.165-15.471-10.406-19.767-11.154-.492-.085-1.002-.173-1.451-.267a4.854 4.854 0 0 1-3.775-5.721 4.87 4.87 0 0 1 4.66-3.867l.086-.009h.059c.052.002.122.004.2.011 7.54.584 16.611 5.25 19.064 6.882 4.239 2.826 11.617 9.012 13.38 18.719 1.023 5.647.41 9.868-1.828 12.548C4.671-.299 1.33 0 0 0",
                        style: {
                            fill: "#1d1d1b",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(95.46 93.422)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0q-.178 0-.49-.024l.123.099c.606.44 5.584 4.322 5.766 12.572.129 4.994-2.353 8.286-7.181 9.52l-1.165.298-.045.007a11 11 0 0 1-1.286.148l-.059.007c-.129.018-.614.073-1.347.073-4.326 0-15.203-1.749-22.706-17.947l-.077-.18.025.169c.931 5.624 1.455 9.637 1.592 12.27a4.85 4.85 0 0 1-4.835 5.213 4.855 4.855 0 0 1-4.743-3.88l-.002-.014c-.913-3.451-1.697-10.449-2.159-19.208-.285-5.425-.211-18.021-.131-21.871v-.02a4 4 0 0 1 .012-.561c.208-2.491 2.325-4.44 4.823-4.44q.203 0 .407.016c2.191.184 3.984 1.82 4.364 3.952l.004.02c.268 1.186.609 3.175.968 5.279l.012.063c.357 2.076.728 4.22 1.02 5.531 1.316 5.885 3.87 12.142 6.832 16.739 3.734 5.787 7.961 8.847 12.224 8.847.377 0 .758-.024 1.131-.071 1.129-.145 1.925-.728 2.247-1.644.579-1.665-.386-4.117-2.463-6.248-.637-.654-1.326-1.319-1.994-1.965-3.271-3.162-6.655-6.432-5.45-9.787.538-1.504 1.88-2.234 4.1-2.234 1.29 0 2.693.228 4.047.448 1.18.191 2.294.372 3.19.372.524 0 .93-.063 1.242-.191.699-.287 1.639-1.135 1.985-2.577.408-1.703.108-4.644-3.627-8.987-8.325-9.165-15.471-10.406-19.767-11.154-.492-.085-1.002-.173-1.451-.267a4.854 4.854 0 0 1-3.775-5.721 4.87 4.87 0 0 1 4.66-3.867l.086-.009h.059c.052.002.122.004.2.011 7.54.584 16.611 5.25 19.064 6.882 4.239 2.826 11.617 9.012 13.38 18.719 1.023 5.647.41 9.868-1.828 12.548C4.671-.299 1.33 0 0 0Z",
                        style: {
                            fill: "none",
                            stroke: "#1d1d1b",
                            strokeWidth: 0.5,
                            strokeLinecap: "butt",
                            strokeLinejoin: "miter",
                            strokeMiterlimit: 10,
                            strokeDasharray: "none",
                            strokeOpacity: 1
                        },
                        transform: "translate(95.46 93.422)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c1.684 0 3.243.659 4.387 1.856 1.148 1.199 1.736 2.789 1.661 4.477-.155 3.473-3.109 6.297-6.58 6.297-1.688 0-3.246-.658-4.389-1.855-1.147-1.199-1.735-2.789-1.66-4.477C-6.427 2.826-3.479 0 0 0",
                        style: {
                            fill: "#1d1d1b",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(122.168 101.894)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c1.684 0 3.243.659 4.387 1.856 1.148 1.199 1.736 2.789 1.661 4.477-.155 3.473-3.109 6.297-6.58 6.297-1.688 0-3.246-.658-4.389-1.855-1.147-1.199-1.735-2.789-1.66-4.477C-6.427 2.826-3.479 0 0 0Z",
                        style: {
                            fill: "none",
                            stroke: "#1d1d1b",
                            strokeWidth: 0.5,
                            strokeLinecap: "butt",
                            strokeLinejoin: "miter",
                            strokeMiterlimit: 10,
                            strokeDasharray: "none",
                            strokeOpacity: 1
                        },
                        transform: "translate(122.168 101.894)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-1.302-4.681-3.459-6.957-6.593-6.957q-.322.002-.664.032c-4.806 1.421-4.489 7.967-3.646 11.237l.011.04c.074.342 1.898 8.391 7.324 8.391l.128-.001c.977-.071 1.919-.686 2.657-1.731C.939 8.57 1.232 4.453 0 0m-57.224-2.751c-2.182-6.528-5.34-7.282-7.522-7.282-.36 0-.737.026-1.12.082l-.037.008c-1.572.525-2.744 1.506-3.488 2.917-1.993 3.779-.284 9.413-.212 9.65l.011.037c.099.359 2.455 8.765 8.422 8.765.156 0 .316-.006.444-.016l.012-.001c1.204-.138 2.322-.909 3.144-2.17 1.807-2.768 1.936-7.252.346-11.99m27.553 33.726c2.274 5.87 4.658 7.951 6.011 7.951q.328 0 .637-.138l.05-.023.053-.018c1.355-.458.953-3.734.383-5.69l-.013-.048-.01-.05c-.106-.526-2.607-12.719-10.744-20.002.323 6.331 1.631 12.85 3.633 18.018m50.88-34.984c-.736 1.621-2.279 2.667-3.933 2.667a3.8 3.8 0 0 1-1.656-.375l-.027-.014-.03-.016c-1.691-.929-2.433-1.259-3.227-1.259q-.104 0-.212.007c-.79.061-1.358.335-1.741.835-1.198 1.593-.448 5.263.346 9.15.895 4.385 1.91 9.354-.002 11.997-.78 1.074-1.992 1.714-3.604 1.902a5 5 0 0 1-.493.028c-1.444 0-3.019-.754-3.647-2.414-1.466 1.832-3.919 2.941-6.607 2.941a10 10 0 0 1-1.29-.085c-12.482-1.673-16.157-15.579-15.58-24.516l.01-.149-.065-.158q-.016-.038-.035-.077a65 65 0 0 0-1.313-1.245l-.036-.036c-.104-.102-2.525-2.512-5.285-2.512-1.517 0-2.798.682-3.927 2.097-1.239 1.518-2.069 3.871-2.541 7.189l-.002.006.511.383c4.566 3.392 10.249 7.616 16.61 21.275 5.311 11.396 3.824 17.75 1.64 21.072-1.923 2.928-5.219 4.676-8.821 4.676-1.217 0-2.398-.214-3.411-.621-6.446-2.588-10.391-8.973-13.616-22.041l-.008-.031c-.024-.107-2.3-11.25-2.054-20.4l.002-.004c-2.635-1.775-4.562-2.555-4.629-2.582l-.152-.058v.058c.006.23.017.522.021.605l.002.022v.046c.002.3-.019 7.4-4.416 11.846-2.352 2.376-5.536 3.582-9.467 3.582-.308 0-.622-.008-.933-.023l-.055-.003C-75.661 18.501-80.36 3.884-79.485-6.096l.002-.005-.004-.001a5 5 0 0 0-.294-.168l-.037-.022-.04-.024c-.264-.173-1.662-1.033-3.176-1.033-1.917 0-3.196 1.423-3.698 4.114-.705 3.783.796 9.94 2.004 14.892.451 1.841.839 3.432 1.067 4.692.516 2.592-1.167 5.219-3.751 5.857a4.8 4.8 0 0 1-1.155.142 4.56 4.56 0 0 1-3.829-2.057c-1.737-2.71-2.43-6.248-2.454-6.382l-.002-.021c-.14-.606-2.43-10.658-2.044-16.907.001-.062.007-.148.009-.272.256-6.931 3.044-11.365 8.033-12.817l.008-.002a10.5 10.5 0 0 1 3.394-.545c4.527 0 8.593 2.604 9.042 2.901l.039.026.034.027c.038.029.103.081.177.133l.019.015.022-.039c.175-.322.405-.646.553-.831.156-.198 3.841-4.825 9.796-4.825a13 13 0 0 1 1 .041c6.691.572 13.375 6.101 15.55 12.859 1.424.516 4.339 1.772 7.37 3.313l.034.018.007-.052c.501-2.704 1.421-5.155 2.736-7.285 1.473-2.386 4.727-6.389 9.96-6.389 2.991 0 6.179 1.325 9.504 3.958.63.518 1.328 1.132 2.049 1.793.164-.254.373-.582.601-.906l.025-.038.03-.034c.659-.803 4.211-4.816 9.257-4.816.299 0 .602.015.9.043 3.948.364 8.15 2.835 10.836 6.34 1.931-2.341 4.437-3.579 7.273-3.579 2.084 0 4.26.677 6.13 1.906 1.832 1.205 3.343 2.946 3.859 4.44.431 1.152.38 2.474-.142 3.627",
                        style: {
                            fill: "#1d1d1b",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(204.682 70.3)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-1.302-4.681-3.459-6.957-6.593-6.957q-.322.002-.664.032c-4.806 1.421-4.489 7.967-3.646 11.237l.011.04c.074.342 1.898 8.391 7.324 8.391l.128-.001c.977-.071 1.919-.686 2.657-1.731C.939 8.57 1.232 4.453 0 0Zm-57.224-2.751c-2.182-6.528-5.34-7.282-7.522-7.282-.36 0-.737.026-1.12.082l-.037.008c-1.572.525-2.744 1.506-3.488 2.917-1.993 3.779-.284 9.413-.212 9.65l.011.037c.099.359 2.455 8.765 8.422 8.765.156 0 .316-.006.444-.016l.012-.001c1.204-.138 2.322-.909 3.144-2.17 1.807-2.768 1.936-7.252.346-11.99zm27.553 33.726c2.274 5.87 4.658 7.951 6.011 7.951q.328 0 .637-.138l.05-.023.053-.018c1.355-.458.953-3.734.383-5.69l-.013-.048-.01-.05c-.106-.526-2.607-12.719-10.744-20.002.323 6.331 1.631 12.85 3.633 18.018zm50.88-34.984c-.736 1.621-2.279 2.667-3.933 2.667a3.8 3.8 0 0 1-1.656-.375l-.027-.014-.03-.016c-1.691-.929-2.433-1.259-3.227-1.259q-.104 0-.212.007c-.79.061-1.358.335-1.741.835-1.198 1.593-.448 5.263.346 9.15.895 4.385 1.91 9.354-.002 11.997-.78 1.074-1.992 1.714-3.604 1.902a5 5 0 0 1-.493.028c-1.444 0-3.019-.754-3.647-2.414-1.466 1.832-3.919 2.941-6.607 2.941a10 10 0 0 1-1.29-.085c-12.482-1.673-16.157-15.579-15.58-24.516l.01-.149-.065-.158q-.016-.038-.035-.077a65 65 0 0 0-1.313-1.245l-.036-.036c-.104-.102-2.525-2.512-5.285-2.512-1.517 0-2.798.682-3.927 2.097-1.239 1.518-2.069 3.871-2.541 7.189l-.002.006.511.383c4.566 3.392 10.249 7.616 16.61 21.275 5.311 11.396 3.824 17.75 1.64 21.072-1.923 2.928-5.219 4.676-8.821 4.676-1.217 0-2.398-.214-3.411-.621-6.446-2.588-10.391-8.973-13.616-22.041l-.008-.031c-.024-.107-2.3-11.25-2.054-20.4l.002-.004c-2.635-1.775-4.562-2.555-4.629-2.582l-.152-.058v.058c.006.23.017.522.021.605l.002.022v.046c.002.3-.019 7.4-4.416 11.846-2.352 2.376-5.536 3.582-9.467 3.582-.308 0-.622-.008-.933-.023l-.055-.003C-75.661 18.501-80.36 3.884-79.485-6.096l.002-.005-.004-.001a5 5 0 0 0-.294-.168l-.037-.022-.04-.024c-.264-.173-1.662-1.033-3.176-1.033-1.917 0-3.196 1.423-3.698 4.114-.705 3.783.796 9.94 2.004 14.892.451 1.841.839 3.432 1.067 4.692.516 2.592-1.167 5.219-3.751 5.857a4.8 4.8 0 0 1-1.155.142 4.56 4.56 0 0 1-3.829-2.057c-1.737-2.71-2.43-6.248-2.454-6.382l-.002-.021c-.14-.606-2.43-10.658-2.044-16.907.001-.062.007-.148.009-.272.256-6.931 3.044-11.365 8.033-12.817l.008-.002a10.5 10.5 0 0 1 3.394-.545c4.527 0 8.593 2.604 9.042 2.901l.039.026.034.027c.038.029.103.081.177.133l.019.015.022-.039c.175-.322.405-.646.553-.831.156-.198 3.841-4.825 9.796-4.825a13 13 0 0 1 1 .041c6.691.572 13.375 6.101 15.55 12.859 1.424.516 4.339 1.772 7.37 3.313l.034.018.007-.052c.501-2.704 1.421-5.155 2.736-7.285 1.473-2.386 4.727-6.389 9.96-6.389 2.991 0 6.179 1.325 9.504 3.958.63.518 1.328 1.132 2.049 1.793.164-.254.373-.582.601-.906l.025-.038.03-.034c.659-.803 4.211-4.816 9.257-4.816.299 0 .602.015.9.043 3.948.364 8.15 2.835 10.836 6.34 1.931-2.341 4.437-3.579 7.273-3.579 2.084 0 4.26.677 6.13 1.906 1.832 1.205 3.343 2.946 3.859 4.44.431 1.152.38 2.474-.142 3.627z",
                        style: {
                            fill: "none",
                            stroke: "#1d1d1b",
                            strokeWidth: 0.5,
                            strokeLinecap: "butt",
                            strokeLinejoin: "miter",
                            strokeMiterlimit: 10,
                            strokeDasharray: "none",
                            strokeOpacity: 1
                        },
                        transform: "translate(204.682 70.3)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c2.052-.006 3.603-1.664 3.51-3.858C3.421-6.087 1.731-7.725-.318-7.72c-2.078.006-3.631 1.652-3.538 3.883C-3.766-1.644-2.078.005 0 0m-.352-8.492c2.473-.006 4.665 1.949 4.775 4.633C4.532-1.201 2.502.766.034.772a4.797 4.797 0 0 1-4.802-4.607C-4.879-6.52-2.849-8.484-.352-8.492",
                        style: {
                            fill: "#1d1d1b",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(222.32 103.776)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m0 0 1.078-.003c.551-.002 1.137-.127 1.107-.788-.033-.819-.635-.868-1.306-.866l-.949.002zm-.099-2.341.911-.002 1.286-2.32.887-.002-1.388 2.356c.771.096 1.376.511 1.415 1.466C3.056.213 2.462.68 1.226.683L-.768.688l-.219-5.342.795-.002z",
                        style: {
                            fill: "#1d1d1b",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(221.283 101.903)"
                    })
                ]
            })
        ]
    }));
var $fa1bf3559d9d3ffe$export$2e2bcd8739ae039 = $fa1bf3559d9d3ffe$var$SvgBiola;

});

parcelRegister("bku7t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83f8ed13f3a8511b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $83f8ed13f3a8511b$var$SvgDovreYsteri = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            d: "M68.32 407.51c-4.258-1.163-8.035-3.862-10.418-7.447-1.758-2.645-2.54-4.725-2.783-7.41l-.202-2.223-3.535.092c-1.944.05-5.192.307-7.217.57-4.825.628-5.6.63-5.99.018-.463-.725.423-1.577 2.269-2.182 2.092-.686 3.115-1.477 3.743-2.899.632-1.427 1.197-6.524 1.26-11.359l.043-3.388-5.093-9.72c-2.802-5.348-5.42-10.053-5.82-10.459s-1.409-.937-2.242-1.183c-1.832-.54-2.391-1.218-1.632-1.978.43-.43 1.254-.552 4.709-.698 2.303-.098 5.347-.357 6.764-.575 1.874-.289 2.666-.308 2.902-.073.51.511.034 1.464-.933 1.864-1.08.448-2.042 1.616-2.042 2.48 0 .878 7.827 16.218 8.276 16.218.377 0 9.112-14.321 10.6-17.38 1.464-3.009.924-4.856-1.422-4.865-2.304-.009-3.19-.71-2.175-1.724.434-.434 1.239-.578 4.191-.75 2.01-.118 4.715-.388 6.011-.6 2.548-.417 3.388-.237 3.388.727 0 .39-.457.806-1.431 1.299-.787.399-2.013 1.377-2.725 2.174-1.383 1.548-14.836 23.62-15.129 24.822-.34 1.394-.963 12.644-.76 13.741.407 2.211 1.085 2.891 3.062 3.073l1.135.104.655-1.8c1.35-3.71 3.545-6.422 6.208-7.668 2.827-1.323 5.89-.648 7.43 1.636.778 1.155.839 2 .247 3.416-1.214 2.906-5.835 2.847-6.969-.088-.22-.571-.353-.625-.862-.353-.89.476-2.246 2.484-2.954 4.372-.506 1.35-.605 2.166-.525 4.331.088 2.385.215 2.905 1.204 4.903 3.456 6.99 11.744 9.605 18.39 5.802 4.19-2.398 6.624-6.613 6.61-11.447-.014-4.218-1.822-8.01-5.622-11.794-2.312-2.302-2.869-2.68-6.91-4.692-3.59-1.787-4.73-2.515-6.218-3.977-1.003-.984-2.207-2.518-2.675-3.41-.789-1.5-.851-1.857-.851-4.86 0-2.89.084-3.42.78-4.904 2.3-4.908 7.572-6.914 13.823-5.26 3.89 1.03 4.047 1.04 4.847.288 1.262-1.186 1.465-.566 1.465 4.476 0 4.436-.012 4.518-.651 4.61-.55.077-.795-.224-1.561-1.914-1.663-3.668-5.036-5.986-8.71-5.986-4.371 0-7.244 4.139-5.996 8.636.532 1.914 2.283 3.318 6.87 5.509 2.286 1.092 4.929 2.45 5.873 3.02 9.32 5.618 13.836 13.92 12.146 22.33-1.305 6.494-5.896 11.882-11.955 14.028-2.771.982-8.257 1.247-10.892.527m105.521-31.087c-2.219-.397-5.556-1.754-7.518-3.056-3.635-2.413-7.373-7.581-11.834-16.366-1.532-3.017-3.088-5.765-3.457-6.107-.69-.64-1.273-.763-3.339-.707-2.2.06-2.273.22-2.688 5.967-.523 7.25-.353 7.68 3.295 8.35 1.454.268 1.783.436 1.859.954.137.944-.59 1.158-4.658 1.371-2.025.106-5.067.39-6.76.63-1.815.258-3.186.33-3.341.173-.525-.524-.036-1.334 1.264-2.094 1.666-.974 2.548-2.265 2.768-4.054.094-.768.523-6.604.952-12.97.833-12.342.817-12.747-.55-13.305-.366-.15-1.304-.356-2.083-.458-1.562-.205-2.044-.787-1.282-1.549.358-.358 1.368-.527 4.1-.686 1.995-.117 5.146-.442 7.004-.724 4.27-.647 8.523-.65 10.28-.008 3.045 1.113 4.516 3.258 4.537 6.613.022 3.713-1.689 6.684-5.117 8.884-.817.524-1.447 1.035-1.4 1.136s.7 1.11 1.449 2.244 2.391 4.05 3.649 6.481c3.47 6.707 4.582 8.366 7.363 10.999 5.155 4.88 10.24 5.958 15.61 3.308 3.966-1.956 6.851-5.756 7.514-9.894.626-3.911-1.129-8.467-3.914-10.166-1.2-.731-1.39-.726-1.39.038 0 .34-.451 1.07-1.002 1.62-.883.883-1.184 1.002-2.534 1.002s-1.65-.12-2.533-1.002c-.84-.839-1.002-1.214-1.002-2.313 0-3.683 4.308-5.529 8.393-3.596 3.901 1.845 7.23 7.542 7.216 12.349-.02 6.94-5.668 14.363-12.575 16.53-1.773.556-6.219.774-8.276.406zm-21.776-29.049c3.045-.894 4.516-2.761 4.83-6.13.45-4.825-1.895-7.793-6.175-7.809-2.182-.008-3.548.56-3.976 1.651-.346.885-.948 7.825-.948 10.928 0 1.156.131 1.859.368 1.965.585.261 4.22-.111 5.901-.605m-65.668 26.854c-.306-.795.122-1.256 1.63-1.758 1.87-.62 2.847-1.758 3.23-3.762.423-2.219 1.898-24.811 1.667-25.54-.154-.487-.438-.607-1.425-.605-2.303.003-6.751.819-7.537 1.38-.42.302-1.332 1.704-2.025 3.118-.95 1.935-1.404 2.57-1.841 2.57-.751 0-.748-.556.027-4.949.35-1.978.786-3.585 1.025-3.77.23-.177 1.994-.407 3.923-.51 4.85-.262 16.012-1.293 19.967-1.846 1.805-.253 3.661-.416 4.124-.363l.842.096.083 3.418c.068 2.819 0 3.485-.381 3.802-.618.513-.993.115-1.59-1.685-.38-1.145-.683-1.515-1.606-1.966-1.034-.505-1.416-.527-4.236-.242-1.704.173-3.24.456-3.415.63-.18.18-.6 4.27-.979 9.521-.996 13.844-1.133 17.363-.709 18.156.436.813 1.987 1.507 3.373 1.507 1.378 0 1.948.257 1.948.879 0 .98-.778 1.184-5.629 1.472-2.656.157-5.624.421-6.596.586-2.508.425-3.67.383-3.87-.139m22.199-2.98c-.117-.116-.212-.514-.212-.885 0-.51.339-.84 1.399-1.362 2.374-1.17 2.376-1.18 3.34-15.044.465-6.673.848-12.88.851-13.794.008-2.124-.59-2.933-2.345-3.173-.766-.105-1.397-.385-1.594-.707-.61-.998.375-1.279 5.193-1.482 2.473-.104 7.546-.44 11.272-.745s6.875-.497 6.997-.426c.121.07.22 1.76.22 3.757 0 2.866-.092 3.706-.441 3.995-.595.494-1.326-.1-1.326-1.079 0-1.159-1.067-2.93-1.973-3.273-1.558-.59-2.378-.648-5.281-.37-3.638.349-4.678.702-5.078 1.722-.282.718-.924 7.987-.924 10.462 0 .56.166 1.078.368 1.151.203.074 1.562.018 3.02-.124 3.746-.364 5.026-1.054 6.186-3.334.494-.972 1.094-1.767 1.333-1.767.514 0 .545 1.448.16 7.45-.216 3.363-.33 3.957-.8 4.21-.607.324-.783.035-1.412-2.308-.546-2.033-1.174-2.268-5.07-1.9-2.065.194-3.43.462-3.692.724-.298.298-.524 1.998-.796 5.986-.38 5.56-.275 7.357.46 7.823 1.188.753 7.01-.155 9.66-1.506 1.696-.866 3.463-2.528 4.644-4.368 1.19-1.856 2.05-2.01 1.903-.342-.123 1.402-1.82 4.933-3.034 6.315-1.683 1.917-2.632 2.165-12.449 3.253-4.894.542-9.23 1.068-9.633 1.17-.404.101-.83.088-.946-.028m56.532-8.89c-.32-.518.143-1.241 1.103-1.725 1.655-.834 2.5-1.865 2.837-3.461.458-2.17 1.768-22.662 1.511-23.649-.249-.957-1.76-1.858-3.132-1.866-1.214-.007-1.723-.384-1.494-1.106.245-.774.964-.944 3.998-.944 1.377 0 4.053-.219 5.946-.485 1.893-.267 3.65-.405 3.903-.308.855.328.484 1.103-.798 1.67-1.88.831-2.548 1.701-2.848 3.71-.143.956-.563 6.466-.934 12.244-.53 8.274-.6 10.669-.325 11.27.41.902 1.726 1.542 3.69 1.796 1.326.172 1.411.234 1.326.973-.109.942-.504 1.028-7.014 1.529-2.35.18-5.016.401-5.927.49-.99.098-1.73.042-1.842-.139M5.426 346.976c-.416-.673.282-1.53 1.919-2.356 1.84-.929 2.96-2.156 3.494-3.828.337-1.056 2.395-29.042 2.472-33.616.064-3.812-.536-4.473-4.454-4.905-1.676-.185-1.97-.305-2.045-.831-.156-1.096.596-1.326 5.246-1.604 2.454-.147 7.07-.624 10.257-1.059 7.01-.957 13.134-1.075 16.547-.317 7.135 1.583 11.89 6.294 13.417 13.289 1.09 4.995.085 12.744-2.332 17.975-2.27 4.914-6.211 9.432-10.377 11.897-4.364 2.582-9.192 3.645-18.972 4.177-5.79.315-9.362.665-12.128 1.19-1.922.364-2.814.36-3.044-.012m25.04-4.41c5.873-1.656 10.204-5.037 12.771-9.972 3.81-7.325 3.79-18.03-.046-24.457-1.18-1.976-4.182-4.818-6.136-5.808-3.41-1.728-8.633-2.35-13.135-1.567-2.241.39-3.481 1.303-3.887 2.86-.415 1.592-2.448 31.603-2.332 34.424.112 2.723.6 3.69 2.33 4.608.881.468 1.531.518 5.133.39 2.269-.08 4.655-.296 5.303-.478m42.66-5.292c-4.654-.74-8.859-2.715-11.97-5.624-3.69-3.45-5.704-7.892-6.006-13.246-.363-6.451 1.817-12.17 6.408-16.814 1.787-1.808 2.767-2.517 5.008-3.623 3.627-1.791 6.287-2.354 10.15-2.146 3.752.203 6.086.803 9.525 2.45 9.004 4.312 12.813 14.605 9.298 25.122-2.108 6.307-7.852 11.72-14.257 13.432-2.027.543-6.142.77-8.155.45m5.243-2.085c5.4-1.024 9.33-5.104 11.217-11.643.579-2.006.676-3.023.679-7.057.002-5.193-.332-7.006-1.924-10.42-1.91-4.095-4.62-6.618-8.314-7.74-1.629-.495-2.59-.59-5.036-.5-2.69.1-3.236.217-4.967 1.07-3.554 1.75-6.238 5.35-7.664 10.285-.579 2.002-.664 2.977-.666 7.6l-.002 5.302 1.04 2.946c2.097 5.939 5.14 8.873 10.385 10.013 2.288.497 3.25.523 5.251.144zm29.172-2.697c-.775-2.076-8.658-23.915-10.365-28.717-1.103-3.104-2.202-6.02-2.441-6.48-.652-1.253-1.675-2.073-3.039-2.435-1.27-.337-1.693-.83-1.28-1.498.289-.468 2.612-.832 5.448-.854 1.134-.01 3.808-.302 5.941-.652s4.099-.551 4.366-.448c.299.114.45.44.392.844-.077.54-.438.747-2.004 1.156-2.325.607-3.245 1.511-3.245 3.192 0 .993 1.915 6.719 8.01 23.95.985 2.784 1.257 3.153 1.865 2.528.68-.7 9.234-19.255 10.187-22.1 1.053-3.143 1.01-4.44-.184-5.478-.608-.527-1.12-.663-2.514-.663-1.545 0-1.751-.068-1.751-.578 0-.937.95-1.201 5.383-1.499 2.305-.155 4.967-.422 5.917-.594 1.985-.359 2.545-.232 2.545.577 0 .395-.318.68-1.012.91-2.252.743-2.918 1.901-11.684 20.326-9.143 19.22-9.824 20.416-10.535 18.513m50.08-3.945c-2.323-1.179-3.676-3.237-8.182-12.44-3.746-7.653-3.989-8.065-5.023-8.497-1.657-.692-5.152-.227-5.678.755-.155.29-.492 3.435-.748 6.99-.563 7.799-.458 8.414 1.608 9.456.723.365 1.791.663 2.374.663 1.425 0 2.32.659 1.878 1.382-.26.424-.888.576-3.093.745-1.522.117-4.889.438-7.481.712-6.336.671-6.169.674-6.279-.1-.073-.518.2-.796 1.361-1.385 1.863-.944 2.855-2.138 3.253-3.915.459-2.046 2.234-29.808 1.99-31.11-.247-1.314-1.124-1.971-2.892-2.166-2.238-.246-2.588-.379-2.588-.981 0-.878.732-1.087 4.566-1.306 1.944-.112 5.987-.541 8.984-.955 5.53-.764 8.512-.794 10.91-.11 1.82.519 3.717 1.94 4.604 3.448.767 1.306.836 1.663.836 4.368 0 2.567-.1 3.158-.777 4.601-.426.91-1.288 2.226-1.914 2.922-1.01 1.123-3.956 3.284-4.91 3.603-.218.072.015.536.606 1.21.527.6 2.665 4.526 4.75 8.724 2.086 4.197 4.203 8.19 4.705 8.873 1.572 2.138 2.952 2.73 4.604 1.978 1.1-.502 1.589.056.929 1.063-.747 1.14-2.719 2.005-4.9 2.148-1.648.108-2.135.014-3.493-.676m-11.045-24.023c2.172-.671 3.918-2.065 4.912-3.922.547-1.023.641-1.674.641-4.44 0-2.758-.094-3.414-.636-4.418-1.403-2.6-3.463-3.748-6.728-3.748-2.674 0-4.159.6-4.69 1.896-.228.555-.595 3.796-.86 7.594-.587 8.39-.687 8.125 2.955 7.83 1.374-.112 3.357-.468 4.406-.792m14.243 17.622c0-.546.325-.99 1.162-1.587 1.307-.933 2.236-2.39 2.502-3.923.229-1.318 1.932-26.155 1.933-28.192 0-2.753-.739-3.49-3.89-3.874-1.416-.173-1.56-.258-1.56-.927 0-.715.077-.742 2.652-.949 8.158-.654 10.985-.928 17.64-1.71 4.031-.475 7.428-.802 7.55-.727.33.205.306 7.816-.028 8.44-.428.8-1.116.661-1.325-.267-1.086-4.823-1.784-5.264-7.913-4.998-2.116.091-4.364.342-4.997.557-2.038.692-2.182 1.123-2.683 8.025-.245 3.389-.37 6.405-.275 6.702.14.442.476.538 1.845.531 2.893-.016 5.956-.542 7.222-1.24.953-.526 1.434-1.106 2.26-2.729 1.277-2.51 1.934-2.717 1.869-.588-.201 6.618-.528 11.113-.838 11.537-.615.841-1.179.244-1.573-1.665-.252-1.217-.63-2.085-1.126-2.58-.74-.74-.778-.745-4.139-.544-1.866.111-3.784.281-4.263.377-1.54.308-1.712.947-2.225 8.246-.411 5.837-.418 6.843-.055 7.6.645 1.347 1.559 1.683 4.028 1.481 6.255-.51 10.68-2.786 13.499-6.945.798-1.177 1.583-2.112 1.745-2.077 1.098.238-1.173 6.25-3.214 8.51-1.924 2.13-5.093 2.98-11.221 3.011-2.583.013-7.451.414-12.888 1.061-1.675.2-1.694.193-1.694-.556z",
            style: {
                fill: "#000",
                strokeWidth: 0.29458177
            },
            transform: "translate(0 -244.083)"
        })
    }));
var $83f8ed13f3a8511b$export$2e2bcd8739ae039 = $83f8ed13f3a8511b$var$SvgDovreYsteri;

});

parcelRegister("9RFMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72e97abedff69b47$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $72e97abedff69b47$var$SvgGryr = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsxs)("defs", {
                children: [
                    (0, $7YWoO.jsx)("clipPath", {
                        id: "gryr_svg__a",
                        clipPathUnits: "userSpaceOnUse",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M0 841.89h1496.693V0H0Z"
                        })
                    }),
                    (0, $7YWoO.jsx)("clipPath", {
                        id: "gryr_svg__b",
                        clipPathUnits: "userSpaceOnUse",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M602.509 622.599h379.328V214.662H602.509Z"
                        })
                    })
                ]
            }),
            (0, $7YWoO.jsxs)("g", {
                clipPath: "url(#gryr_svg__a)",
                transform: "matrix(.39655 0 0 -.39655 -199.493 266.009)",
                children: [
                    (0, $7YWoO.jsxs)("g", {
                        clipPath: "url(#gryr_svg__b)",
                        style: {
                            opacity: 0.80000299
                        },
                        children: [
                            (0, $7YWoO.jsx)("path", {
                                d: "M0 0c26.994 27.332 90.541 38.309 66.798 108.205C16.117 89.081-15.009 52.048 0 0",
                                style: {
                                    fill: "#37b0c9",
                                    fillOpacity: 1,
                                    fillRule: "nonzero",
                                    stroke: "none"
                                },
                                transform: "translate(606.294 231.165)"
                            }),
                            (0, $7YWoO.jsx)("path", {
                                d: "M0 0c15.586 45.223 1.418 75.998-42.413 95.151C-79.23 36.689-27.708 25.267 0 0",
                                style: {
                                    fill: "#37b0c9",
                                    fillOpacity: 1,
                                    fillRule: "nonzero",
                                    stroke: "none"
                                },
                                transform: "translate(737.851 214.662)"
                            }),
                            (0, $7YWoO.jsx)("path", {
                                d: "M0 0c-31.8 40.007 2.129 65.299 23.963 84.901C39.701 50.975 32.402 18.314 0 0",
                                style: {
                                    fill: "#37b0c9",
                                    fillOpacity: 1,
                                    fillRule: "nonzero",
                                    stroke: "none"
                                },
                                transform: "translate(897.613 537.698)"
                            }),
                            (0, $7YWoO.jsx)("path", {
                                d: "M0 0c-4.887 30.81-41.948 54.514-77.938 41.026C-73.593-4.615-37.583-.202 0 0",
                                style: {
                                    fill: "#37b0c9",
                                    fillOpacity: 1,
                                    fillRule: "nonzero",
                                    stroke: "none"
                                },
                                transform: "translate(809.2 272.471)"
                            }),
                            (0, $7YWoO.jsx)("path", {
                                d: "M0 0c-61.101-1.093-58.273 38.492-68.611 71.119C-16.618 76.896-4.486 30.103 0 0",
                                style: {
                                    fill: "#37b0c9",
                                    fillOpacity: 1,
                                    fillRule: "nonzero",
                                    stroke: "none"
                                },
                                transform: "translate(699.151 492.98)"
                            }),
                            (0, $7YWoO.jsx)("path", {
                                d: "M0 0c7.857-24.565 25.742-53.511-9.674-81.754C-33.103-62.094-28.202-15.692 0 0",
                                style: {
                                    fill: "#37b0c9",
                                    fillOpacity: 1,
                                    fillRule: "nonzero",
                                    stroke: "none"
                                },
                                transform: "translate(727.475 574.774)"
                            }),
                            (0, $7YWoO.jsx)("path", {
                                d: "M0 0c13.581 32.916 38.422 73.933 93.578 54.152C69.04 22.518 66.152-16.766 0 0",
                                style: {
                                    fill: "#37b0c9",
                                    fillOpacity: 1,
                                    fillRule: "nonzero",
                                    stroke: "none"
                                },
                                transform: "translate(888.259 494.21)"
                            })
                        ]
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m0 0-.92-.644c-.121-.11-16.899-11.519-40.395-11.519-1.778 0-3.6.065-5.413.194C-66.915-10.53-85.29-1.611-98.467 13.147c-14.166 15.864-20.778 36.537-19.121 59.782 1.577 22.126 10.206 41.112 24.955 54.906 14.674 13.725 33.955 20.98 55.761 20.98a99 99 0 0 0 7.01-.252c26.052-1.857 44.677-13.099 49.655-17.274 5.179-4.397 5.568-7.987 1.473-13.71l-6.481-8.775c-2.701-3.66-5.011-4.083-6.514-4.083-1.996 0-4.376.858-7.276 2.624-8.054 4.901-16.452 9.385-30.566 10.391-1.691.12-3.374.181-5.003.181-21.393 0-45.1-11.889-47.478-45.258-1.045-14.666 3.134-28.245 11.768-38.237 8.256-9.556 19.954-15.328 32.94-16.253a61 61 0 0 1 4.335-.156c21.09 0 31.423 11.253 31.853 11.732l.612.683L.498 45.041l-13.022.928c-3.296.235-5.707 1.207-7.166 2.89-1.459 1.682-2.079 4.206-1.844 7.502l.625 8.775c.44 6.179 3.325 9.058 9.079 9.058.425 0 34.161-2.39 34.161-2.39 6.618-.471 9.481-3.773 9.009-10.392L26.785-2.346c-.44-6.18-3.325-9.058-9.078-9.058-.425 0-8.738.577-8.738.577-5.984.427-9.51 3.374-9.202 7.693z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(633.218 361.071)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m0 0-14.655.415c-6.633.188-9.635 3.365-9.447 9.998l1.54 54.358-42.916 82.155c-1.787 3.298-2.154 6.112-1.054 7.959 1.063 1.785 3.568 2.767 7.055 2.767q.266 0 .537-.007l17.811-.505c5.909-.168 9.432-2.57 11.783-8.033l13.149-29.951c4.766-10.948 9.28-23.113 9.321-23.235l1.807-5.19.912-.026 2.076 4.942c.048.12 5.19 12.149 10.572 22.817l14.594 29.154c2.578 5.163 6.05 7.365 11.612 7.365q.3 0 .607-.009l17.812-.504c3.682-.104 6.378-1.248 7.397-3.136 1.029-1.908.512-4.714-1.456-7.901l-47.52-79.628-1.54-54.359C9.814 2.996 6.814-.008.555-.008Q.281-.008 0 0",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(828.376 381.453)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-1.797-12.256-9.621-19.285-21.466-19.285-1.528 0-3.13.122-4.762.361l-19.612 2.875 6.47 44.134 15.819-2.319c7.015-1.029 11.765-2.492 15.39-4.742C1.027 15.725 1.028 7.007 0 0m34.781-2.592c3.104 21.176-4.664 38.676-21.321 48.017-6.503 3.68-14.231 5.779-29.533 8.023l-43.295 6.347c-.857.126-1.677.19-2.439.19-3.161 0-7.49-.872-8.594-8.402L-90.196-83.433c-.963-6.565 1.647-10.071 8.212-11.034l14.505-2.127a17 17 0 0 1 2.439-.189c3.161 0 7.491.871 8.595 8.402l6.474 44.16 22.555-3.307 17.561-50.017c2.132-5.637 5.351-8.281 11.112-9.126l16.961-2.487a16.6 16.6 0 0 1 2.384-.184c1.873 0 4.368.387 5.616 2.227 1.166 1.72 1.081 4.489-.256 7.846L9.227-54.892C6.538-47.958 4.784-44.78 4.769-44.751l-.446.795.001.004c-.912 1.533-1.52 2.266-1.52 2.266l1.956.702.001.004 1.559.524c16.644 5.583 26.287 23.041 28.461 37.864",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(943.13 421.898)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c1.96-12.231-3.397-21.282-14.698-24.833a33 33 0 0 0-4.651-1.083l-19.572-3.137-7.057 44.044 15.786 2.53c7.001 1.121 11.971 1.149 16.103.089C-3.734 15.31-1.12 6.993 0 0m33.958 7.954C30.572 29.087 17.915 43.453-.777 47.371c-7.306 1.561-15.309 1.247-30.58-1.2l-43.206-6.924a17 17 0 0 1-2.384-.55c-3.015-.948-6.884-3.077-5.68-10.592l21.591-134.74c1.05-6.552 4.591-9.115 11.142-8.065l14.476 2.32c.855.137 1.657.322 2.384.551 3.016.947 6.885 3.076 5.68 10.591l-7.062 44.07 22.509 3.607 31.748-42.452c3.724-4.739 7.588-6.296 13.337-5.375l16.926 2.712c.833.134 1.617.315 2.329.539 1.787.562 4.052 1.679 4.691 3.809.596 1.99-.315 4.606-2.597 7.408L25.259-49.601c-4.644 5.808-7.27 8.315-7.294 8.337l-.663.626-.001.004c-1.33 1.189-2.129 1.706-2.129 1.706l1.656 1.256-.001.004 1.331.967c14.204 10.317 18.171 29.862 15.8 44.655",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(755.248 435.749)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c2.361 0 3.522 1.587 3.522 3.794S2.361 7.51.116 7.51h-3.445V0Zm-10.104 11.188c0 1.394.736 2.129 2.129 2.129h9.369c5.38 0 9.019-3.949 9.019-9.523 0-5.575-3.639-9.601-9.019-9.601h-4.723v-6.426c0-1.393-.736-2.129-2.129-2.129h-2.517c-1.393 0-2.129.736-2.129 2.129z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(565.594 607.685)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 1.394.736 2.129 2.129 2.129h2.517c1.393 0 2.129-.735 2.129-2.129v-19.743h9.174c1.394 0 2.13-.736 2.13-2.129v-1.549c0-1.393-.736-2.129-2.13-2.129H2.129C.736-25.55 0-24.814 0-23.421Z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(581.271 618.873)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m0 0-1.549 5.381c-.503 1.742-1.122 4.761-1.122 4.761h-.078s-.619-3.019-1.122-4.761L-5.458 0Zm-6.852 14.71c.387 1.2 1.161 1.742 2.4 1.742h3.484c1.239 0 2.013-.542 2.4-1.742L9.445-8.788c.504-1.471-.193-2.439-1.741-2.439H5.148c-1.238 0-2.013.581-2.399 1.781L1.587-5.42h-8.633l-1.161-4.026c-.348-1.2-1.123-1.781-2.361-1.781h-2.556c-1.548 0-2.245.968-1.741 2.439z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(616.962 604.55)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 1.394.736 2.129 2.129 2.129h3.02c1.2 0 1.974-.426 2.555-1.432l6.813-11.498c1.084-1.819 2.323-4.722 2.323-4.722h.077s-.31 2.98-.31 4.722V0c0 1.394.736 2.129 2.13 2.129h2.516c1.393 0 2.129-.735 2.129-2.129v-23.421c0-1.393-.736-2.129-2.129-2.129h-3.02c-1.161 0-1.935.426-2.516 1.432L8.865-12.659c-1.084 1.82-2.323 4.723-2.323 4.723h-.077s.31-2.981.31-4.723v-10.762c0-1.393-.736-2.129-2.129-2.129H2.129C.736-25.55 0-24.814 0-23.421Z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(630.936 618.873)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h-6.271C-7.665 0-8.4.735-8.4 2.129v1.549c0 1.393.735 2.129 2.129 2.129h19.316c1.394 0 2.13-.736 2.13-2.129V2.129C15.175.735 14.439 0 13.045 0H6.774v-19.743c0-1.394-.735-2.129-2.129-2.129H2.129C.735-21.872 0-21.137 0-19.743Z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(667.556 615.195)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 1.394.736 2.129 2.129 2.129h13.085c1.393 0 2.129-.735 2.129-2.129v-1.549c0-1.393-.736-2.129-2.129-2.129H6.775V-8.71h6.309c1.395 0 2.13-.736 2.13-2.129v-1.549c0-1.393-.735-2.129-2.13-2.129H6.775v-5.226h8.981c1.393 0 2.129-.736 2.129-2.129v-1.549c0-1.393-.736-2.129-2.129-2.129H2.129C.736-25.55 0-24.814 0-23.421Z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(687.375 618.873)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c1.974 0 2.942 1.355 2.942 2.903S2.013 5.729.039 5.729h-4.103V0Zm-.581 11.149c1.704 0 2.439 1.239 2.439 2.555 0 1.277-.735 2.361-2.555 2.361h-3.367v-4.916zm-10.258 8.594c0 1.394.735 2.129 2.129 2.129h8.052c5.536 0 9.407-2.477 9.407-7.239 0-2.322-1.123-4.684-3.213-5.884v-.078c3.174-.967 4.336-3.793 4.336-6.232 0-6.039-5.033-8.246-10.53-8.246H-8.71c-1.394 0-2.129.736-2.129 2.129z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(722.795 599.13)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m0 0-1.549 5.381c-.503 1.742-1.123 4.761-1.123 4.761h-.077s-.62-3.019-1.123-4.761L-5.459 0Zm-6.853 14.71c.388 1.2 1.162 1.742 2.4 1.742h3.484c1.24 0 2.014-.542 2.401-1.742L9.445-8.788c.503-1.471-.193-2.439-1.742-2.439H5.148c-1.239 0-2.013.581-2.4 1.781L1.586-5.42h-8.632l-1.162-4.026c-.348-1.2-1.122-1.781-2.361-1.781h-2.555c-1.548 0-2.245.968-1.742 2.439z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(750.55 604.55)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m0 0 1.201 1.742c.774 1.123 1.664 1.2 2.942.503.89-.464 2.632-1.703 5.033-1.703 2.012 0 2.941.852 2.941 1.936 0 3.909-12.232 3.29-12.232 11.961 0 5.11 4.258 8.478 9.871 8.478 3.213 0 6.155-1.123 7.471-2.051 1.123-.813 1.239-1.781.658-2.904l-.929-1.819c-.774-1.51-1.819-1.278-2.903-.736-1.278.619-2.555 1.278-4.375 1.278-2.129 0-3.02-.852-3.02-1.936 0-4.026 12.234-3.058 12.234-11.807 0-4.645-3.484-8.632-9.716-8.632-3.872 0-7.318 1.586-8.788 2.748C-.426-2.284-1.006-1.432 0 0",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(763.053 598.55)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 1.394.735 2.129 2.129 2.129h13.084c1.394 0 2.129-.735 2.129-2.129v-1.549c0-1.393-.735-2.129-2.129-2.129H6.774V-8.71h6.31c1.395 0 2.129-.736 2.129-2.129v-1.549c0-1.393-.734-2.129-2.129-2.129h-6.31v-5.226h8.982c1.392 0 2.129-.736 2.129-2.129v-1.549c0-1.393-.737-2.129-2.129-2.129H2.129C.735-25.55 0-24.814 0-23.421Z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(788.408 618.873)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c2.168 0 3.523 1.2 3.523 3.407 0 1.393-.348 2.438-1.626 2.942-.62.271-1.432.387-2.555.387h-2.283V0Zm-9.717 10.414c0 1.393.737 2.128 2.13 2.128h7.51c2.826 0 4.181-.193 5.382-.658 3.134-1.199 5.109-4.026 5.109-8.051 0-2.943-1.393-6.156-4.143-7.549v-.078s.387-.503 1.045-1.664l3.95-7.123c.851-1.471.193-2.555-1.471-2.555H6.853c-1.162 0-1.936.464-2.517 1.51L.232-5.807h-3.173v-7.2c0-1.394-.737-2.129-2.129-2.129h-2.517c-1.393 0-2.13.735-2.13 2.129z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(822.705 608.46)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h-6.271C-7.666 0-8.4.735-8.4 2.129v1.549c0 1.393.734 2.129 2.129 2.129h19.316c1.394 0 2.129-.736 2.129-2.129V2.129C15.174.735 14.439 0 13.045 0H6.773v-19.743c0-1.394-.734-2.129-2.128-2.129H2.129C.734-21.872 0-21.137 0-19.743Z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(845.12 615.195)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c5.178 0 9.152 4.303 9.152 9.736 0 5.397-3.974 9.663-9.152 9.663-5.068 0-8.971-4.266-8.971-9.663C-8.971 4.303-5.068 0 0 0m.004 22.589c7.056 0 12.68-5.728 12.68-12.855C12.684 2.609 7.06-3.19.004-3.19c-6.917 0-12.541 5.799-12.541 12.924 0 7.127 5.624 12.855 12.541 12.855",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(982.422 467.414)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h1.227C2.28 0 2.908.655 2.908 1.751c0 1.09-.587 1.716-1.611 1.716H0Zm4.581-6.07c-1.009 0-1.599.387-1.974 1.292L1.453-1.947H0v-2.485C0-5.565-.462-6.07-1.498-6.07h-.209c-1.036 0-1.498.505-1.498 1.638v8.278c0 1.102.536 1.638 1.638 1.638h3.772c2.454 0 3.978-1.431 3.978-3.733 0-1.912-1.437-2.724-1.822-2.837l-.203-.059-.234-.048.34-.457v.001c-.001 0 .146-.141.377-.605l1.015-1.959c.33-.628.406-1.175.209-1.501-.178-.294-.55-.356-.831-.356Z",
                        style: {
                            fill: "#201751",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(981.374 477.529)"
                    })
                ]
            })
        ]
    }));
var $72e97abedff69b47$export$2e2bcd8739ae039 = $72e97abedff69b47$var$SvgGryr;

});

parcelRegister("hVdnz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0c22362a3638323$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $d0c22362a3638323$var$SvgIste = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("defs", {
                children: (0, $7YWoO.jsx)("clipPath", {
                    id: "iste_svg__a",
                    clipPathUnits: "userSpaceOnUse",
                    children: (0, $7YWoO.jsx)("path", {
                        d: "M0 2324.69V0h2375.58v2324.69z"
                    })
                })
            }),
            (0, $7YWoO.jsxs)("g", {
                clipPath: "url(#iste_svg__a)",
                transform: "matrix(.08173 0 0 -.08173 2.927 194.994)",
                children: [
                    (0, $7YWoO.jsx)("path", {
                        d: "m2213.84 1385.54-797.95 780.92c-125.9 123.16-330.05 123.16-455.921 0L162.02 1385.54c-125.946-123.19-125.946-322.95 0-446.149l797.949-780.879c125.871-123.192 330.021-123.192 455.921 0l797.95 780.879c125.94 123.199 125.94 322.959 0 446.149",
                        style: {
                            fill: "#231f20",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M1725.51 1539.95c.57 10.55 1.13 22.26 1.34 31.03h.2c1.96-8.32 4.78-17.38 8.15-27.31l11.36-33.39h6.88l12.4 34.01c3.54 9.61 6.48 18.46 8.87 26.69h.33c-.11-8.77.53-20.48 1.02-30.3l1.8-30.84h8.87l-4.39 70.2h-11.55l-12.57-33.97c-3.13-8.77-5.59-16.53-7.39-23.66h-.34c-1.72 7.33-4.12 15.09-7.07 23.66l-11.98 33.97h-11.56l-4.88-70.2h8.61zm-47.2-30.11h9.2v62.51h21.47v7.69h-52v-7.69h21.33zM970.922 1172.5c-62.738 23.16-75.57 33.13-75.57 62.91 0 34.32 26.746 54.16 73.226 54.16 30.25 0 70.912-9.9 113.962-27.63 1.6-.48 7.53-3.03 13.97-5.09l42.07 88.97c-5.04 3.43-10.46 6.29-13.03 7.8-39.51 22.09-110.48 38.69-163.909 38.69-118.637 0-202.313-72.92-202.313-174.48 0-37.55 12.77-71.8 36.027-96.13 22.129-25.36 46.504-37.55 127.868-67.43 73.316-26.45 87.207-37.48 87.207-68.379 0-33.2-26.758-55.289-66.239-55.289-43.046 0-93.039 14.429-153.468 45.339-2.325 1.399-10.375 6.231-16.352 9.418l-37.777-99.48c5.191-3.899 11.605-7.629 15.761-10.481 59.286-30.918 136.02-50.769 203.473-50.769 115.102 0 193.002 70.66 193.002 173.402 0 37.519-12.82 71.729-34.9 98.309-25.57 28.71-48.84 41.97-143.008 76.16m685.288-1.09c10.43 88.38 36.04 122.59 95.33 122.59 56.96 0 79.09-33.14 81.38-122.59zm326.74-71.8c0 194.39-74.47 292.7-224.44 292.7-148.84 0-246.5-114.9-246.5-288.28 0-181.132 88.35-279.401 252.29-279.401 49.99 0 94.22 7.742 140.71 24.32 26.46 9.379 52.03 20.539 69.18 30.942l-45.52 99.711c-8.05-3.883-16.99-8.481-20.19-10.293-44.17-22.149-87.18-33.149-130.16-33.149-82.6 0-122.11 44.16-124.47 135.86h328.68c.24 6.48.42 15.56.42 27.59m-373.29 480.43h-518.61v-128.11h166.3V721.609h156.94v730.321h161.39zM402.371 1274.1h104.66V843.391h143.008v530.129H402.371Zm173.274 343.54c-51.184 0-91.86-38.7-91.86-86.2 0-48.55 40.676-87.21 90.68-87.21 51.152 0 91.828 38.66 91.828 87.21 0 47.5-40.676 86.2-90.648 86.2",
                        style: {
                            fill: "#fff",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m2156.42 951.84-753.3-737.16c-118.83-116.34-311.55-116.34-430.448 0L219.391 951.84c-118.891 116.35-118.891 304.93 0 421.22l753.281 737.19c118.898 116.25 311.618 116.25 430.448 0l753.3-737.19c118.9-116.29 118.9-304.87 0-421.22m83.38 531.82-723.57 708.19c-181.03 177.12-475.6 177.12-656.664 0l-723.597-708.19C48.309 1397.88 0 1283.81 0 1162.47-.04 1041.12 48.309 927 135.969 841.129L859.566 133.07C947.27 47.2 1063.91 0 1187.91 0c123.98 0 240.62 47.2 328.32 133.07l723.57 708.059c181.03 177.201 181.03 465.461 0 642.531",
                        style: {
                            fill: "#fff",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    })
                ]
            })
        ]
    }));
var $d0c22362a3638323$export$2e2bcd8739ae039 = $d0c22362a3638323$var$SvgIste;

});

parcelRegister("hU8Lt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d08e772320117970$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $d08e772320117970$var$SvgJarlsberg = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                d: "M0 182.32A182.31 182.31 0 0 1 182.34 0C283 0 364.59 81.62 364.59 182.32S283 364.59 182.34 364.59 0 283 0 182.32",
                style: {
                    fill: "#f2c75c"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M182.32 115.77a66.4 66.4 0 0 1 52.13 25.28 2.84 2.84 0 0 0 2.22 1.09h90.49a2.84 2.84 0 0 0 2.72-3.66C311 74.87 252 28.35 182.34 28.35S53.64 74.87 34.72 138.48a2.84 2.84 0 0 0 2.71 3.66h90.5a2.84 2.84 0 0 0 2.22-1.09 66.46 66.46 0 0 1 52.17-25.28m-.04 133.05a66.42 66.42 0 0 1-52.14-25.28 2.84 2.84 0 0 0-2.22-1.09H37.43a2.84 2.84 0 0 0-2.71 3.66c18.91 63.61 77.89 110.14 147.53 110.14S311 289.72 329.88 226.11a2.84 2.84 0 0 0-2.72-3.66h-90.49a2.84 2.84 0 0 0-2.22 1.09 66.46 66.46 0 0 1-52.17 25.28",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M295.48 95.39c-12.29-4.86-32-4.27-46.41 8.5-8.2 7.22-13.29 16.49-16 29.18l-.07.34h-.35c-2.7.19-6-1.16-8.93-3.61-.32-.28-.63-.56-.93-.85a12.5 12.5 0 0 1-3.93-7.16v-.34l.32-.12c12-4.86 20.32-11.45 26-20.74 10.13-16.42 7.38-35.9.51-47.19C232.51 54.61 215.21 64 208 81.9c-4.06 10.13-4.43 20.71-1.17 33.28l.08.33-.29.17a12.56 12.56 0 0 1-8.2 1.08c-.09 0-.91-.17-1.23-.25-3.65-.87-6.68-2.74-8.12-5l-.18-.29.22-.26c8.57-9.75 13-19.36 13.93-30.24 1.66-19.23-9.56-35.38-20.78-42.37-11.22 7-22.45 23.14-20.79 42.37.94 10.88 5.36 20.49 13.93 30.24l.23.26-.19.29c-1.44 2.26-4.47 4.13-8.12 5-.31.08-1.13.23-1.23.25a12.54 12.54 0 0 1-8.19-1.08l-.3-.17.09-.33c3.31-12.57 2.93-23.18-1.14-33.28-7.17-17.9-24.46-27.29-37.63-28.48-6.87 11.29-9.62 30.77.52 47.19 5.72 9.29 14 15.88 26 20.74l.32.12v.34a12.45 12.45 0 0 1-3.94 7.16c-.3.29-.6.57-.92.85-2.89 2.45-6.23 3.8-8.94 3.61h-.34l-.07-.34c-2.75-12.69-7.84-22-16-29.18-14.47-12.77-34.13-13.36-46.42-8.5-1 13.18 5.26 31.81 21.7 41.91 9.3 5.72 19.65 7.88 32.59 6.79a41.7 41.7 0 0 0 9.18-2.06 38.3 38.3 0 0 0 11.58-6.54l.69-.55a38.6 38.6 0 0 0 9.29-11.07l.15-.28h.32a37 37 0 0 0 10.88-.17c.24 0 2.25-.42 2.94-.58.2 0 2.26-.57 2.66-.68l1.15-.34a37 37 0 0 0 9.79-4.74l.27-.18.26.18a37.2 37.2 0 0 0 9.8 4.74l1.14.34c.4.11 2.47.64 2.67.68.68.16 2.69.54 2.94.58a37 37 0 0 0 10.88.17h.31l.16.28a38.6 38.6 0 0 0 9.29 11.07l.69.55A38.3 38.3 0 0 0 232 142a41.5 41.5 0 0 0 9.17 2.06c12.94 1.09 23.3-1.07 32.6-6.79 16.46-10.07 22.77-28.7 21.71-41.88m-175.86 37.86c-9.13-.73-16.73-2.88-22.57-6.37-7.81-4.65-13.19-12-16.47-22.54l-.18-.6h.6c11 0 19.64 3 26.38 9.15 5 4.59 9.32 11.22 12.68 19.73l.27.68zm28.06-23.64-.06.74-.62-.35c-7.83-4.76-13.65-10.09-17.29-15.84-4.88-7.67-6.37-16.68-4.56-27.55l.1-.61.56.28c9.81 5 16.16 11.57 19.43 20.05 2.44 6.33 3.26 14.17 2.44 23.28m34.62-7.5-.39-.62c-4.85-7.78-7.64-15.16-8.31-21.94-.9-9 1.82-17.76 8.33-26.64l.37-.51.37.51c6.5 8.88 9.23 17.6 8.33 26.64-.67 6.78-3.47 14.16-8.31 21.94zm34.7 8.24-.07-.74c-.82-9.11 0-17 2.45-23.32 3.27-8.48 9.63-15 19.43-20.05l.56-.28.1.61c1.81 10.87.32 19.88-4.55 27.55-3.65 5.75-9.47 11.08-17.29 15.84zm67-6c-3.27 10.51-8.66 17.89-16.46 22.54-5.85 3.49-13.44 5.64-22.58 6.37l-.73.06.27-.68c3.37-8.51 7.64-15.14 12.69-19.73 6.73-6.1 15.36-9.1 26.37-9.15h.63z",
                style: {
                    fill: "#01426a"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M184.46 46.94a2.17 2.17 0 1 1-2.17-2.17 2.16 2.16 0 0 1 2.17 2.17m-4.33 60.63a2.17 2.17 0 1 1 2.17 2.17 2.16 2.16 0 0 1-2.17-2.17",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M184.46 46.94a2.17 2.17 0 1 1-2.17-2.17 2.16 2.16 0 0 1 2.17 2.17m-4.33 60.63a2.17 2.17 0 1 1 2.17 2.17 2.16 2.16 0 0 1-2.17-2.17M124.72 60.1a2.17 2.17 0 1 1-2.92-1 2.17 2.17 0 0 1 2.92 1m23.42 56.1a2.17 2.17 0 1 1 2.92 1 2.17 2.17 0 0 1-2.92-1",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M124.72 60.1a2.17 2.17 0 1 1-2.92-1 2.17 2.17 0 0 1 2.92 1m23.42 56.1a2.17 2.17 0 1 1 2.92 1 2.17 2.17 0 0 1-2.92-1M77.29 98.75a2.17 2.17 0 1 1-3 .46 2.16 2.16 0 0 1 3-.46m46.17 39.55a2.17 2.17 0 1 1 3-.46 2.16 2.16 0 0 1-3 .46",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M77.29 98.75a2.17 2.17 0 1 1-3 .46 2.16 2.16 0 0 1 3-.46m46.17 39.55a2.17 2.17 0 1 1 3-.46 2.16 2.16 0 0 1-3 .46m120.28-76.23a2.17 2.17 0 1 1-1-2.91 2.15 2.15 0 0 1 1 2.91m-31.16 52.2a2.17 2.17 0 1 1 1 2.91 2.16 2.16 0 0 1-1-2.91",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M243.74 62.07a2.17 2.17 0 1 1-1-2.91 2.15 2.15 0 0 1 1 2.91m-31.16 52.2a2.17 2.17 0 1 1 1 2.91 2.16 2.16 0 0 1-1-2.91m77.28-12a2.16 2.16 0 0 1-3-.46 2.17 2.17 0 0 1 3.49-2.58 2.16 2.16 0 0 1-.45 3m-51.36 32.62a2.17 2.17 0 1 1-.45 3 2.17 2.17 0 0 1 .45-3",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M289.86 102.27a2.16 2.16 0 0 1-3-.46 2.17 2.17 0 0 1 3.49-2.58 2.16 2.16 0 0 1-.45 3m-51.36 32.62a2.17 2.17 0 1 1-.45 3 2.17 2.17 0 0 1 .45-3",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M69.11 269.2c12.29 4.86 32 4.27 46.42-8.5 8.19-7.22 13.28-16.49 16-29.18l.07-.34h.34c2.71-.19 6.05 1.16 8.94 3.61.32.28.62.56.92.85a12.45 12.45 0 0 1 3.94 7.16v.34l-.32.12c-12 4.86-20.32 11.45-26 20.74-10.14 16.42-7.39 35.9-.52 47.19 13.17-1.19 30.46-10.57 37.63-28.48 4.07-10.13 4.44-20.71 1.18-33.27l-.09-.34.3-.17a12.54 12.54 0 0 1 8.19-1.08l1.23.25c3.65.87 6.68 2.74 8.12 5l.19.28-.23.26c-8.57 9.76-13 19.37-13.93 30.24-1.66 19.23 9.57 35.38 20.79 42.37 11.22-7 22.44-23.14 20.78-42.37-.93-10.87-5.36-20.48-13.93-30.24l-.22-.26.18-.28c1.44-2.27 4.47-4.14 8.12-5l1.23-.25a12.56 12.56 0 0 1 8.2 1.08l.29.17-.08.34C203.61 262 204 272.56 208 282.69c7.17 17.91 24.47 27.29 37.63 28.48 6.87-11.29 9.62-30.77-.51-47.19-5.73-9.29-14-15.88-26-20.74l-.32-.12v-.34a12.5 12.5 0 0 1 3.93-7.16c.3-.29.61-.57.93-.85 2.89-2.45 6.23-3.8 8.93-3.61h.35l.07.34c2.74 12.69 7.83 22 16 29.18 14.46 12.77 34.12 13.36 46.41 8.5 1.06-13.17-5.25-31.81-21.69-41.91-9.3-5.72-19.66-7.88-32.6-6.79a41.5 41.5 0 0 0-9.17 2.06 38.2 38.2 0 0 0-11.58 6.55l-.69.54a38.6 38.6 0 0 0-9.29 11.07l-.16.28h-.31a37 37 0 0 0-10.88.17c-.25 0-2.26.42-2.94.58-.2 0-2.27.57-2.67.69s-.84.24-1.14.34a37.2 37.2 0 0 0-9.8 4.74l-.26.19-.27-.19a37 37 0 0 0-9.79-4.74c-.3-.1-.72-.22-1.15-.34s-2.46-.65-2.66-.69c-.69-.16-2.7-.54-2.94-.58a37 37 0 0 0-10.88-.17h-.32l-.15-.28a38.6 38.6 0 0 0-9.29-11.07l-.69-.54a38.2 38.2 0 0 0-11.58-6.55 41.7 41.7 0 0 0-9.18-2.06c-12.94-1.09-23.29 1.07-32.59 6.79C74.37 237.39 68.06 256 69.11 269.2M245 231.34c9.14.73 16.73 2.88 22.58 6.37 7.8 4.65 13.19 12 16.46 22.54l.19.6h-.63c-11-.06-19.64-3.06-26.37-9.16-5-4.58-9.32-11.22-12.69-19.72l-.27-.69zM216.91 255l.07-.73.63.38c7.82 4.77 13.64 10.1 17.29 15.84 4.87 7.67 6.36 16.68 4.55 27.55l-.1.62-.56-.29c-9.8-5-16.16-11.57-19.43-20.05-2.44-6.39-3.27-14.23-2.45-23.32m-34.61 7.5.39.63c4.84 7.78 7.64 15.15 8.3 21.93.91 9-1.82 17.76-8.32 26.64l-.37.51-.37-.51c-6.51-8.88-9.23-17.6-8.33-26.64.67-6.78 3.46-14.15 8.31-21.93zm-34.68-8.23.06.73c.82 9.11 0 17-2.45 23.32-3.27 8.48-9.62 15-19.43 20.05l-.56.29-.1-.62c-1.81-10.87-.32-19.88 4.56-27.55 3.64-5.74 9.46-11.07 17.29-15.84zm-67 6c3.28-10.51 8.66-17.89 16.47-22.54 5.84-3.49 13.44-5.64 22.57-6.37l.73-.06-.27.69c-3.36 8.5-7.63 15.14-12.68 19.72-6.74 6.1-15.37 9.1-26.38 9.16h-.66Z",
                style: {
                    fill: "#01426a"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M180.13 317.66a2.17 2.17 0 1 1 2.18 2.16 2.17 2.17 0 0 1-2.18-2.16m4.34-60.66a2.17 2.17 0 1 1-2.18-2.17 2.17 2.17 0 0 1 2.18 2.17",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M180.13 317.66a2.17 2.17 0 1 1 2.18 2.16 2.17 2.17 0 0 1-2.18-2.16m4.34-60.66a2.17 2.17 0 1 1-2.18-2.17 2.17 2.17 0 0 1 2.18 2.17m55.41 47.49a2.17 2.17 0 1 1 2.91.95 2.16 2.16 0 0 1-2.91-.95m-23.42-56.1a2.17 2.17 0 1 1-2.92-.95 2.17 2.17 0 0 1 2.92.95",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M239.88 304.49a2.17 2.17 0 1 1 2.91.95 2.16 2.16 0 0 1-2.91-.95m-23.42-56.1a2.17 2.17 0 1 1-2.92-.95 2.17 2.17 0 0 1 2.92.95m70.84 17.45a2.17 2.17 0 1 1 3-.46 2.17 2.17 0 0 1-3 .46m-46.16-39.55a2.17 2.17 0 1 1-3 .46 2.16 2.16 0 0 1 3-.46",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M287.3 265.84a2.17 2.17 0 1 1 3-.46 2.17 2.17 0 0 1-3 .46m-46.16-39.55a2.17 2.17 0 1 1-3 .46 2.16 2.16 0 0 1 3-.46m-120.29 76.23a2.17 2.17 0 1 1 1 2.91 2.17 2.17 0 0 1-1-2.91m31.15-52.2a2.17 2.17 0 1 1-1-2.91 2.16 2.16 0 0 1 1 2.91",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M120.85 302.52a2.17 2.17 0 1 1 1 2.91 2.17 2.17 0 0 1-1-2.91m31.15-52.2a2.17 2.17 0 1 1-1-2.91 2.16 2.16 0 0 1 1 2.91m-77.27 12a2.17 2.17 0 1 1-.44 3 2.17 2.17 0 0 1 .44-3m51.32-32.58a2.17 2.17 0 1 1 .45-3 2.15 2.15 0 0 1-.45 3",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M74.73 262.32a2.17 2.17 0 1 1-.44 3 2.17 2.17 0 0 1 .44-3m51.32-32.58a2.17 2.17 0 1 1 .45-3 2.15 2.15 0 0 1-.45 3",
                style: {
                    fill: "#c8102e"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M350.54 199.21a4.5 4.5 0 1 0 4.31 4.5 4.41 4.41 0 0 0-4.31-4.5m0 8.43a3.93 3.93 0 1 1 3.77-3.93 3.85 3.85 0 0 1-3.77 3.93M351 204a1.3 1.3 0 0 0 1.25-1.31c0-.77-.58-1.26-1.54-1.26h-1.91v4.73h.56v-2.06h.26c1 0 1.27.2 2.09 2.06h.68c-.68-1.72-.8-1.82-1.39-2.16m-.86-.38h-.75v-1.7h.83c1 0 1.36.18 1.36.82s-.41.84-1.47.84zm-118.79-22.89c4.45-1.23 7.15-4.56 7.15-10 0-7.92-6-10.72-11.18-10.72H207.1v2.57c2.66 0 3.91 1.89 3.91 5.27v28.88c0 3.38-1.24 5.26-3.91 5.26v2.57h21.22c6.94 0 11.65-4.88 11.65-12.11.03-6.6-3.17-10.45-8.62-11.72m-12.1-17.5h3.42c4.75 0 8.32 2.83 8.32 7.76 0 5.68-3.32 8.44-8.39 8.44h-3.35zm4.86 38.18h-4.85v-18.78h3.67c5.46 0 8.86 2.89 8.86 9.08 0 6.53-3.09 9.7-7.68 9.7M54 162.58c-3.42 0-5.31 2.62-5.31 6.67v26.15c0 11.07-7.22 18.76-17.7 18.76-5.91 0-10.71-1.62-13.58-4.58a11.1 11.1 0 0 1-3.13-8.27 6.59 6.59 0 0 1 6.61-6.55 6.2 6.2 0 0 1 4.47 1.82 6 6 0 0 1 1.76 4.19 6.26 6.26 0 0 1-5.88 6.23c.4.73 2.7 4.36 8.51 4.1 6.4-.3 9.92-5.19 9.92-13.78v-28.07c0-4.05-1.86-6.67-5.27-6.67V160H54Zm215.86 30.06h2.57v11.91h-29.81V202c2.61 0 3.92-2 3.92-5.26v-28.89c0-3.38-1.24-5.27-3.91-5.27V160h27.09v9.91h-2.56c0-4.54-1.9-6.67-5.36-6.67h-7v17.16h4.73c3.11 0 5-1.49 5-4.59h2.57v12.37h-2.57c0-3.1-1.88-4.59-5-4.59h-4.73v13.12c0 3.12 1.53 5 4.55 5h2.4c5.25-.01 8.08-3.14 8.08-9.07zM332 182.7v2.57a3.8 3.8 0 0 1 2.48 1c.83.83 1.21 2.15 1.21 4.26v10.62a10.94 10.94 0 0 1-4.85.46c-7.48-.68-9.85-11-9.61-19.69.33-11.68 4-18.59 10-19.16 4.88-.46 8.8 3.73 10.08 9.57h2.57V160h-2.57c-.68 1.06-2 1.18-3.6.45a15.2 15.2 0 0 0-7.83-1.62c-10.54.61-17.5 9.68-17.63 23-.06 6.89 1.26 12.3 4.46 16.76-1.45 1.58-2.29 3.09-4.4 3.09a4.8 4.8 0 0 1-4.08-2.46c0-.08-4.65-8.47-4.85-8.85-1.54-2.8-3.58-4.93-6.48-5.71 1.46-.26 10.13-2.05 10.13-12.38 0-7.59-4.54-12.29-11.87-12.29H275v2.57c2.7 0 4 1.9 4 5.28v28.88c0 3.35-1.31 5.1-4 5.23v2.59h16.31V202c-2.76 0-4-1.91-4-5.25v-10.92h1a5.22 5.22 0 0 1 4.83 3l6.43 11.34c2 3.37 5.18 5.31 9.73 5.31s7.07-2.35 9.3-4.65c2.7 2.6 6.44 4.65 13.13 4.65A21.2 21.2 0 0 0 344 202v-11.43c0-2.46.5-5 3.77-5.28v-2.59zm-41.18-.12h-3.51v-19.35h3c2.54 0 8.45.89 8.45 9.13.04 6.5-2.86 10.22-7.93 10.22zM161 204.56h6.52c3.3 0 6.85-1.81 6.85-5.87a6 6 0 0 0-1.55-4.22 5.83 5.83 0 0 0-4.37-1.75h-.17a6 6 0 0 0-5.13 2.93 13 13 0 0 0-1.3 3.21 4.27 4.27 0 0 1-4.1 3.13h-4.59c-3 0-4.54-1.57-4.54-4.68v-29.44c0-3.28 1.41-5.29 4.19-5.29V160h-16.53v2.57c2.75 0 4.09 1.94 4.09 5.27v29.46c0 3.64-1.47 4.68-4.65 4.68h-1.81c-2.06 0-3.3-.73-4.43-2.77l-4.83-8.82c-1.53-2.81-3.57-4.94-6.47-5.72 1.46-.25 10.13-2.05 10.13-12.38 0-7.59-4.55-12.29-11.87-12.29H96.28v2.57c2.69 0 4 1.9 4 5.28v28.88c0 3.48-1.4 5.25-4.26 5.25h-.77c-1.4 0-3.92-.62-5.12-5.09-.32-1.21-8.31-29.55-10.39-36.89H64.22v2.57c1.6 0 2.43.4 3 1.25a5.06 5.06 0 0 1 .29 4.23c-.47 1.6-7.64 25.65-8.58 28.7-1.07 3.46-2.82 5.23-5.78 5.23v2.57h14.26V202a5.4 5.4 0 0 1-3.89-1.47c-.43-.58-1.06-1.89-.38-4.19.12-.4 2-6.87 2-6.87h14.17l1.53 5.75c.57 2.28.38 4.11-.56 5.32-.76 1-1.57 1.46-3.6 1.46v2.57h35.91V202c-2.76 0-4-1.91-4-5.25v-10.92h1a5.22 5.22 0 0 1 4.83 3c3.4 6.09 5.82 10.36 6.44 11.34 2 3.15 4.68 4.42 9.36 4.42H161Zm-94.92-18.27 6.48-22.07 5.9 22.07zm46-3.71h-3.52v-19.34h3c2.54 0 8.45.88 8.45 9.12-.01 6.5-2.88 10.22-7.94 10.22zm92 21.77c-.19 5-4.14 18-20 18.09h-.22c-12.85 0-19.19-7.42-21.13-14.83H167a15.85 15.85 0 0 0 15.42 11.31c8.54 0 12.77-5.9 13.17-11.75.5-7.28-4.52-10.32-8.18-12.54-.13-.07-12.68-7.41-14-8.23-5-3.2-7.63-8-7.25-13.09.66-8.72 8.12-14.58 18.57-14.58a22 22 0 0 1 8.73 1.71 6.6 6.6 0 0 0 2.35.72 1.63 1.63 0 0 0 1.57-1.15h2.61v13.14h-2.71c-.35-9-8.06-11.45-12.57-11.4-6.1.07-10.44 3.6-10.57 8.35-.12 4.09 2.07 6.34 5.65 8.64 1.56 1 14.08 8.32 14.18 8.38 7.2 4.22 10.4 9.69 10.13 17.23z",
                style: {
                    fill: "#01426a"
                },
                transform: "matrix(.52225 0 0 .52225 4.796 4.796)"
            })
        ]
    }));
var $d08e772320117970$export$2e2bcd8739ae039 = $d08e772320117970$var$SvgJarlsberg;

});

parcelRegister("3DyOn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a6004784b90ece4$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $2a6004784b90ece4$var$SvgLitago = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            d: "M164.394 363.827c-1.852-.14-4.509-.734-6.205-1.39-6.515-2.515-10.842-7.976-11.91-15.029-.793-5.243.294-10.48 3.028-14.584 3.094-4.644 7.721-7.537 13.414-8.387 1.496-.223 4.845-.228 6.572-.009 2.695.341 4.915.992 7.13 2.089 1.867.925 3.21 1.894 4.739 3.42 2.805 2.799 4.527 6.284 5.297 10.723.283 1.634.256 5.333-.053 7.021-.885 4.848-3.165 8.837-6.717 11.755-3.97 3.261-9.44 4.831-15.295 4.391zm3.102-8.204c2.777-.398 4.732-1.43 6.427-3.392 2.066-2.392 3.114-6.705 2.497-10.279-.84-4.866-3.503-8.327-7.24-9.407-1.042-.302-3.338-.411-4.543-.217-1.11.18-2.518.68-3.444 1.223-.896.527-2.302 1.84-2.966 2.77-2.702 3.784-2.818 10.471-.257 14.734 2.096 3.487 5.542 5.14 9.526 4.568m-44.852 7.94c-8.45-.787-14.09-6.357-15.642-15.447-.316-1.852-.38-4.78-.148-6.695 1.03-8.476 6.233-14.564 13.994-16.378 3.236-.757 7.306-.738 10.84.05 4.996 1.115 8.935 3.463 10.24 6.104.387.782.42.92.412 1.727-.016 1.638-.844 2.947-2.334 3.693-1.006.503-1.76.646-3.092.587-1.38-.061-2.177-.323-3.8-1.248-2.915-1.663-3.753-1.932-6.007-1.93-1.236.001-1.698.049-2.446.249-3.164.847-5.256 3.196-6.024 6.763-.296 1.376-.312 4.404-.03 5.717.483 2.254 1.293 3.882 2.567 5.166 1.494 1.504 3.044 2.168 5.284 2.263 1.103.047 1.454.02 2.23-.177 1.7-.43 3.734-1.682 4.279-2.635.198-.347.207-.43.08-.736-.08-.195-.243-.367-.374-.395-2.894-.625-3.974-1.036-4.833-1.84-2.029-1.898-1.598-5.197.839-6.432a9.3 9.3 0 0 1 1.405-.521c.766-.212 1.166-.234 4.916-.273 3.346-.034 4.225-.012 4.87.123 2.303.482 3.853 2.007 4.328 4.26.238 1.129.24 12.13.002 13.043-.648 2.488-2.713 3.907-5.444 3.74a12.7 12.7 0 0 1-2.069-.352c-1.726-.463-2.409-.408-4.785.387-3.498 1.17-6 1.49-9.258 1.187m-65.864-.274c-1.666-.328-2.123-.505-2.975-1.147-1.089-.822-1.767-2.218-1.975-4.065-.066-.591-.11-4.992-.11-11.108-.002-11.104.004-11-.643-11.808-.688-.86-1.214-1.03-3.713-1.19-1.678-.108-2.39-.272-3.412-.788-.896-.452-1.536-1.085-1.95-1.926-.334-.68-.354-.786-.354-1.919 0-1.07.031-1.265.29-1.817.589-1.256 1.668-2.066 3.313-2.487.812-.208 1.242-.215 12.445-.213 12.848.002 12.435-.02 13.912.707.982.483 1.713 1.205 2.147 2.121.301.637.335.812.334 1.742 0 .935-.034 1.105-.347 1.766a4.28 4.28 0 0 1-2.026 2.038c-1.024.498-1.816.663-3.713.77-1.572.088-1.787.125-2.34.402-.709.354-1.22.97-1.501 1.806-.175.52-.196 1.488-.254 11.616-.059 10.162-.08 11.103-.258 11.703-.619 2.089-2.005 3.32-4.171 3.706-.791.141-2.202.189-2.699.09m-18.858-.22c-1.363-.484-2.168-1.88-3.443-5.972-.448-1.437-1.77-5.699-2.94-9.47-1.17-3.773-2.866-9.235-3.77-12.14-.904-2.903-1.684-5.6-1.734-5.993-.283-2.196.765-3.608 3.215-4.336 2.19-.651 3.753-.256 4.757 1.203.9 1.306.739.825 6.659 19.895 3.907 12.587 3.686 11.81 3.692 12.974.004.842-.032 1.009-.351 1.658-.545 1.106-1.443 1.741-3.038 2.15-.984.25-2.383.265-3.047.03m-29.968-.54c-1.513-.237-2.297-.576-3.084-1.333-.932-.897-1.376-2.055-1.378-3.596 0-1.103 1.79-26.29 1.952-27.447.16-1.147.8-2.42 1.564-3.119 1.162-1.06 2.595-1.51 4.539-1.422 1.927.087 3.257.686 4.163 1.876.626.822.85 1.678.85 3.255 0 .724-.02 1.413-.045 1.533s-.077.757-.119 1.415a44 44 0 0 1-.116 1.524c-.022.18-.07.768-.105 1.307-.059.89-.182 2.544-.329 4.409-.15 1.905-.271 3.656-.333 4.79a46 46 0 0 1-.106 1.578c-.02.18-.043 1.227-.05 2.326-.013 1.961-.008 2.011.28 2.597.212.436.386.637.642.744.61.255 2.086.379 5.284.444 1.941.04 3.384.119 3.854.213 1.544.307 2.768 1.117 3.393 2.245.298.54.319.652.319 1.78 0 1.17-.011 1.224-.41 2.03-.658 1.334-1.745 2.185-3.4 2.664-.592.171-1.428.191-8.873.21-4.52.01-8.342 0-8.492-.024m63.69-.217c-2.028-.545-2.876-2.248-2.138-4.29.39-1.075 13.511-28.883 13.964-29.59.911-1.426 2.455-2.493 3.956-2.735.908-.147 3.548-.148 4.463-.001 1.534.244 2.93 1.258 3.668 2.661.189.36 1.38 3.789 2.646 7.62 1.267 3.833 3.456 10.444 4.866 14.693l2.562 7.725-.045.938c-.051 1.077-.333 1.693-1.04 2.277-.779.642-1.43.815-3.076.819-1.27.004-1.58-.033-2.28-.262-1.187-.389-1.956-1.02-2.863-2.348-.408-.598-.99-1.37-1.292-1.716-1.111-1.27-1.722-1.386-7.331-1.386-4.61 0-5.116.059-6.538.758-.915.45-1.346.84-2.23 2.017-.424.563-1.002 1.222-1.284 1.465-.714.612-1.786 1.147-2.713 1.354-.961.216-2.497.216-3.296.001zm18.018-12.294c1.382-.355 2.14-.9 2.688-1.932.2-.377.243-.627.238-1.385-.006-.791-.12-1.346-.785-3.824-.427-1.594-.883-3.18-1.012-3.525-.299-.8-.868-1.44-1.362-1.533-.778-.146-2.007.764-2.612 1.934-.088.17-.751 1.864-1.474 3.765-1.12 2.944-1.316 3.551-1.325 4.108-.023 1.333.77 2.094 2.592 2.486.552.12 2.45.06 3.052-.094m100.617-15.57a4.86 4.86 0 0 1-2.379-1.347c-1.98-1.98-2.004-5.157-.053-7.108 1.1-1.1 2.292-1.553 3.9-1.483.893.04 1.114.092 1.862.447 1.813.862 2.904 2.627 2.899 4.694-.004 1.786-1.13 3.568-2.76 4.367-1.217.597-2.25.725-3.469.43m2.915-1.015c1.248-.584 2.11-1.682 2.395-3.053.397-1.906-.563-3.848-2.333-4.718-.664-.327-.798-.353-1.808-.353-.95 0-1.168.036-1.702.287-1.108.52-1.934 1.474-2.328 2.692-.272.844-.19 2.15.19 2.978.33.717 1.13 1.62 1.77 1.995a4.15 4.15 0 0 0 3.816.172m-3.435-3.872v-2.783h1.267c1.489 0 1.886.163 2.228.915.379.835.166 1.624-.555 2.054l-.41.244.64 1.129c.353.62.64 1.15.64 1.176s-.206.032-.46.013l-.46-.033-.603-1.089c-.582-1.048-.619-1.09-1.006-1.122l-.402-.034-.03 1.123-.032 1.122-.408.034-.408.033zm2.555-.493c.274-.258.362-.74.208-1.142-.11-.29-.645-.494-1.287-.494h-.605v1.985l.704-.045c.553-.036.764-.1.98-.304",
            style: {
                fill: "#964709",
                fillOpacity: 1,
                strokeWidth: 0.10886529
            },
            transform: "translate(0 -244.083)"
        })
    }));
var $2a6004784b90ece4$export$2e2bcd8739ae039 = $2a6004784b90ece4$var$SvgLitago;

});

parcelRegister("kejni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba424df5ba8e1f2$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $eba424df5ba8e1f2$var$SvgNoisy = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            d: "M167.273 381.334c-1.318-.26-2.354-1.388-2.989-3.256-.414-1.22-.583-2.5-.583-4.406 0-3.542.652-6.872 2.138-10.916.907-2.469 1.41-4.12 1.482-4.862.045-.464.016-.594-.245-1.124-.345-.702-1.398-1.806-3.467-3.634-4.5-3.977-10.685-10.305-13.497-13.81-1.637-2.039-2.935-4.293-3.361-5.837-.556-2.008-.239-3.466 1.032-4.749 1.131-1.14 2.191-1.652 3.43-1.657.855-.003 1.448.184 2.438.768.786.464 2.33 2.054 3.308 3.405 2.772 3.834 6.966 10.486 10.747 17.044.665 1.153 1.262 2.153 1.328 2.222.168.176.302-.116.77-1.675 1.595-5.31 4.174-12.7 5.79-16.588.798-1.921 2.32-5.003 3.173-6.429 1.332-2.225 2.61-3.7 3.67-4.235.503-.255.61-.274 1.543-.274.896 0 1.058.026 1.52.243 2.214 1.038 2.649 3.42 1.397 7.658-.48 1.622-1.527 4.2-2.926 7.201-3.269 7.01-6.28 14.767-8.5 21.903-1.011 3.247-1.487 5.025-2.66 9.94-1.811 7.596-2.882 10.912-4 12.393-.313.414-.842.792-1.068.763a13 13 0 0 1-.47-.088m-44.451-11.614c-3.646-.511-6.09-1.784-7.012-3.652-.35-.71-.432-1.858-.186-2.6.324-.974 1.43-1.732 3.233-2.215 1.444-.387 2.98-.634 7.975-1.285 1.755-.228 3.929-.54 4.831-.695 6.379-1.087 9.83-2.661 10.915-4.978.273-.583.415-1.45.309-1.875-.032-.124-.343-.533-.693-.907-1.016-1.088-1.397-1.19-5.837-1.572-5.227-.45-8.15-.902-10.95-1.693-6.526-1.844-10.06-5.548-10.35-10.846-.256-4.665 3.048-8.897 9.314-11.933 2.179-1.055 4.036-1.726 6.563-2.37 2.394-.611 5.177-.983 6.536-.874 2.754.222 5.467 2.324 5.907 4.577.272 1.394-.506 2.704-2.096 3.532-.917.478-1.76.746-3.475 1.106-5.502 1.156-9.865 3.42-11.646 6.043-.455.67-.708 1.237-.879 1.967-.16.69-.093.816.615 1.151 1.287.609 3.333.908 10.279 1.503 6.553.562 9.6 1.33 12.212 3.078.815.545 1.915 1.63 2.442 2.406.843 1.24 1.517 2.9 1.9 4.677.257 1.184.237 3.185-.04 4.147-1.184 4.11-5.763 7.857-12.847 10.514-3.156 1.183-6.547 2.05-10.458 2.672-1.548.246-5.191.314-6.562.122m-85.13-1.221c-2.35-.686-4.665-3.102-6.554-6.838-1.187-2.35-1.972-4.375-4.704-12.13-3.897-11.064-5.27-14.458-6.27-15.494-.252-.263-.52-.457-.63-.457-.442 0-.97.988-1.434 2.682-.567 2.07-.855 3.612-1.503 8.073-.902 6.204-1.06 7.236-1.472 9.662-.81 4.768-2.07 10.494-2.605 11.838-.792 1.995-2.026 2.79-3.356 2.164-1.246-.586-2.461-2.671-3.154-5.411-1.176-4.654-.25-18.816 1.832-28.008.923-4.074 1.978-7.472 3.255-10.478 1.152-2.714 2.556-4.496 4.175-5.298l.805-.4h1.1c.974 0 1.165.027 1.649.232 1.832.773 3.532 2.614 5.185 5.614 1.822 3.305 3.94 8.586 5.697 14.207 1.85 5.917 2.473 7.618 3.739 10.22.815 1.676 1.381 2.598 1.916 3.116 1.044 1.014 1.704.657 2.741-1.485 2.951-6.094 5.231-16.404 7.105-32.131.51-4.277.633-5.052.974-6.141 1-3.187 3.392-5.1 5.272-4.216.697.328 1.267.972 1.785 2.017.52 1.048.784 2.014 1.15 4.206.245 1.474.255 1.655.247 4.498-.016 5.237-.612 12.062-1.535 17.554-1.026 6.107-3.434 16.1-4.93 20.454-1.366 3.982-3.22 7.756-4.725 9.623-1.672 2.075-3.745 2.913-5.755 2.327m31.514-.655c-6.489-.627-12.232-6.166-13.65-13.164-.457-2.261-.523-4.899-.18-7.246.674-4.604 2.881-9.373 6.376-13.774 3.728-4.697 8.052-7.073 12.066-6.633 2.049.226 3.632 1.206 4.353 2.698.22.456.256.641.26 1.349.006 1.406-.13 1.587-4.552 6.06-4.28 4.331-5.634 5.88-7.206 8.25-2.63 3.963-3.395 7.399-2.349 10.554.757 2.28 2.18 3.883 3.776 4.251 1.827.421 5.023-.704 7.695-2.71 4.92-3.692 8.576-11.048 8.937-17.981.105-2.01-.171-3.49-.928-4.981-.577-1.135-1.212-2.032-2.377-3.359-1.188-1.354-1.847-2.25-2.173-2.956-.257-.558-.273-.657-.273-1.736 0-1.14.001-1.147.344-1.84.509-1.029 1.385-1.712 2.537-1.978.586-.135 1.981-.116 2.696.036 3.82.813 7.266 4.19 8.452 8.281 1.253 4.323.74 10.604-1.369 16.759-2.004 5.853-4.925 10.926-8.21 14.26-3.39 3.442-7.404 5.462-11.65 5.863-1.109.105-1.469.104-2.575-.003zm118.921-.65c-.823-.29-1.343-.615-1.945-1.218-1.305-1.304-1.738-3.386-1.072-5.14.697-1.834 2.533-3.102 4.49-3.102 2.76 0 4.913 2.132 4.906 4.858-.004 1.879-1.063 3.54-2.782 4.365-.789.378-.824.386-1.904.415-.96.026-1.176.003-1.693-.179m3.217-1.102c1.558-.77 2.477-2.494 2.18-4.09-.323-1.737-1.577-2.989-3.285-3.282-1.165-.2-2.349.174-3.249 1.025-.858.812-1.232 1.687-1.232 2.884 0 1.642 1.048 3.096 2.632 3.65.498.173.75.205 1.436.181.746-.026.904-.065 1.518-.368m-3.107-.903c-.08-.08-.11-.78-.11-2.579s.03-2.5.11-2.58c.071-.07.443-.109 1.063-.109.852 0 .995.024 1.34.227a1.65 1.65 0 0 1 .257 2.687l-.318.28.471.836c.394.698.459.876.391 1.07-.09.26-.5.366-.715.187-.069-.057-.356-.51-.638-1.009-.467-.825-.536-.905-.78-.905h-.27v.893c0 .965-.06 1.112-.455 1.112-.13 0-.286-.05-.346-.11m2.077-3.125c.299-.318.284-.744-.035-1.018-.194-.167-.355-.213-.744-.213h-.496v1.458h.53c.449 0 .565-.035.745-.227m-86.29 3.193c-.511-.16-1.217-.62-1.591-1.036-1.538-1.712-2.329-4.934-2.713-11.053-.31-4.938-.349-16.27-.063-18.631.397-3.27 1.041-5.22 2.122-6.414 1.752-1.937 4.79-1.568 6.28.762.655 1.023 1.076 2.446 1.336 4.513.173 1.381.145 7.213-.05 10.527-.655 11.084-1.476 17.212-2.67 19.91-.323.731-.637 1.092-1.16 1.336-.52.242-.917.265-1.491.086m.933-45.343c-1.132-.277-2.372-1.587-3.02-3.194-.523-1.292-.612-1.833-.618-3.739-.005-1.558.02-1.878.202-2.593.42-1.657 1.246-2.888 2.28-3.395.449-.22.622-.254 1.293-.249 1.306.01 2.392.523 3.562 1.68.926.916 1.197 1.48 1.25 2.602.05 1.064-.104 1.669-.799 3.14a31 31 0 0 0-.993 2.436c-.25.713-.586 1.568-.744 1.9-.576 1.207-1.364 1.668-2.413 1.412",
            style: {
                fill: "#000",
                strokeWidth: 0.0911452
            },
            transform: "translate(0 -244.083)"
        })
    }));
var $eba424df5ba8e1f2$export$2e2bcd8739ae039 = $eba424df5ba8e1f2$var$SvgNoisy;

});

parcelRegister("ew9jz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a91b4790f4b2d1a0$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $a91b4790f4b2d1a0$var$SvgNorvegia = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                d: "M169.836 2081.51c52.852-127.51 230.789-486.27 591.355-582.63 361.909-96.66 693.919 124.78 803.079 208.87-52.8 127.57-230.62 486.58-591.172 583.23-360.422 96.57-693.711-125.32-803.262-209.47m777.859-752.13c-72.257 0-147.265 8.74-223.972 29.21-516.235 137.97-701.817 700.03-709.465 723.89L0 2126.95l34.55 31.41c18.536 16.86 459.981 411.19 976.13 272.87 516.1-138.34 701.5-700.54 709.13-724.41l14.25-44.5-34.6-31.39c-15.77-14.32-337.85-301.55-751.765-301.55",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M2081.66 3185.24c-127.42-52.79-486.4-230.74-582.8-591.4-96.21-360.5 125.04-693.5 209.03-803.04 127.67 52.85 486.49 230.66 583.09 591.11 96.99 361.87-125.07 694.16-209.32 803.33m-419.33-1564.28-31.39 34.6c-16.81 18.52-410.12 459.57-272.37 975.74 137.99 516.22 700.07 701.83 723.94 709.48l44.47 14.25 31.41-34.56c16.85-18.54 411.17-460.02 272.84-976.15-138.32-516.08-700.54-701.48-724.4-709.11z",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M1790.81 1647.13c52.85-127.67 230.67-486.48 591.11-583.09 361.79-97.009 694.15 125.07 803.32 209.33-52.78 127.41-230.72 486.38-591.39 582.78-360.48 96.23-693.5-125.02-803.04-209.02m777.75-752.712c-72.34 0-147.43 8.781-224.23 29.371-516.08 138.341-701.48 700.531-709.12 724.381l-14.24 44.5 34.6 31.4c18.52 16.81 459.59 410.16 975.75 272.36 516.23-137.98 701.81-700.05 709.45-723.91l14.26-44.46-34.55-31.42c-15.78-14.34-338.06-302.222-751.92-302.222",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M1647.15 1564.19c-127.67-52.84-486.5-230.64-583.11-591.081-96.599-360.437 125.31-693.718 209.47-803.281 127.51 52.852 486.28 230.793 582.64 591.352 96.23 360.49-125.02 693.48-209 803.01M1228.06 0l-31.41 34.55c-16.86 18.552-411.181 460.02-272.861 976.14 138.341 516.08 700.551 701.46 724.411 709.1l44.5 14.24 31.39-34.59c16.81-18.53 410.13-459.56 272.35-975.729-137.97-516.231-700.05-701.813-723.91-709.45z",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M169.719 1273.61c109.422-83.93 442.996-305.84 803.551-208.97 361.75 97.3 538.56 455.04 591.04 582.44-109.5 84.08-442.98 306.07-803.58 209.52-361.875-96.95-538.601-455.43-591.011-582.99m616.48-378.692c-413.64 0-735.808 287.342-751.601 301.662L.02 1227.97l14.218 44.48c7.625 23.87 192.782 586.12 708.926 724.4 516.136 138.25 957.766-255.95 976.316-272.8l34.59-31.41-14.27-44.49c-7.63-23.81-192.92-584.96-708.84-723.74-76.944-20.66-152.269-29.492-224.761-29.492",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M1273.64 3185.32c-83.95-109.42-305.859-443.02-209.01-803.57 96.92-360.29 455.04-538.05 582.56-590.93 84.13 109.6 305.96 443 209.4 803.45-96.94 361.89-455.4 538.64-582.95 591.05m419.02-1564.36-44.49 14.27c-23.82 7.63-584.98 192.94-723.768 708.83-138.601 516.05 255.378 957.83 272.208 976.39l31.39 34.58 44.48-14.23c23.87-7.62 586.09-192.8 724.37-708.96 138.25-516.09-255.93-957.75-272.78-976.29z",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M1790.82 1707.85c109.6-84.14 442.99-306 803.46-209.43 361.87 96.95 538.61 455.41 591.03 582.97-109.42 83.95-443.05 305.85-803.56 208.99-360.31-96.9-538.06-455.02-590.93-582.53m616.87-379.02c-413.96 0-736.35 287.78-752.14 302.13l-34.59 31.41 14.26 44.49c7.63 23.82 192.92 584.99 708.83 723.74 516.1 138.6 957.83-255.35 976.38-272.18l34.58-31.38-14.22-44.49c-7.63-23.86-192.8-586.1-708.94-724.39-76.74-20.54-151.87-29.33-224.16-29.33",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M1707.86 1564.21c-84.14-109.6-305.98-443.02-209.43-803.491 96.57-360.418 455.39-538.098 583.04-590.899 84.02 109.532 305.76 443.032 208.92 803.442-96.91 360.318-455.02 538.078-582.53 590.948M2127.04.02l-44.48 14.218c-23.87 7.633-586.1 192.813-724.39 708.91-138.24 516.122 255.96 957.792 272.81 976.342l31.41 34.58 44.49-14.26c23.81-7.64 584.97-192.93 723.73-708.85 138.64-516.019-255.35-957.812-272.18-976.358z",
                style: {
                    fill: "#c4193b",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M395.309 1371.73v612.09c0 45.07 35.539 81.61 79.367 81.61H2880.39c43.82 0 79.39-36.54 79.39-81.61v-612.09c0-45.04-35.57-81.62-79.39-81.62H474.676c-43.828 0-79.367 36.58-79.367 81.62",
                style: {
                    fill: "#223162",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M640.809 1811.57h43.562l143.352-185.02v185.02h46.25v-267.58h-39.375l-147.551 190.36v-190.36h-46.238zM1160.62 1677v.77c0 51.99-37.83 95.17-90.97 95.17-53.12 0-90.201-42.41-90.201-94.41v-.76c0-51.98 37.831-94.79 90.981-94.79 53.12 0 90.19 42.05 90.19 94.02m-230.499 0v.77c0 75.31 58.109 138.38 140.309 138.38 82.17 0 139.52-62.31 139.52-137.62v-.76c0-75.3-58.11-138.37-140.3-138.37-82.181 0-139.529 62.31-139.529 137.6M1382.67 1678.93c33.65 0 55.06 17.57 55.06 44.71v.76c0 28.68-20.65 44.36-55.43 44.36h-68.42v-89.83zm-115.81 132.64h119.27c33.64 0 60.02-9.95 77.22-26.76 14.13-14.55 22.16-34.41 22.16-57.73v-.77c0-43.96-26.37-70.33-63.45-81.03l72.23-101.29h-55.81l-65.73 93.26h-58.87v-93.26h-47.02zM1514.53 1811.57h51.99l80.66-205.66 80.27 205.66h50.84l-110.86-269.49h-41.65zM1816.5 1811.57h198.38v-42.06h-151.37v-69.56h134.17v-42.05h-134.17v-71.85h153.28v-42.06H1816.5zM2062.64 1677v.77c0 74.92 57.34 138.38 137.99 138.38 46.63 0 75.3-13 102.83-36.32l-29.82-35.55c-20.64 17.6-40.89 28.66-74.92 28.66-49.31 0-86.76-43.18-86.76-94.41v-.76c0-55.03 36.3-95.55 90.97-95.55 25.22 0 48.16 8.02 64.61 20.25v50.07h-68.44v40.91h113.92v-112.37c-26.37-22.57-64.22-41.68-111.62-41.68-83.71 0-138.76 59.63-138.76 137.6M2376.81 1543.99h47.031v267.582h-47.031ZM2643.99 1650.24l-46.24 107.06-45.88-107.06zm-67.27 163.23h43.57l117.74-269.48h-49.69l-27.14 64.59h-126.53l-27.52-64.59h-48.17zM2738.85 1758.1c-16.13 0-28.77 12.71-28.77 29.17 0 16.08 12.91 29.17 28.77 29.17 16.16 0 28.79-12.74 28.79-29.17 0-16.09-12.92-29.17-28.79-29.17m0 64.04c-19.11 0-34.67-15.65-34.67-35.06 0-19.14 15.56-34.69 34.67-34.69 19.14 0 34.69 15.65 34.69 35.06 0 19.13-15.55 34.69-34.69 34.69",
                style: {
                    fill: "#fff",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M2740.6 1788.05c4.46 0 6.96 2.32 6.96 5.61 0 3.67-2.5 5.61-6.96 5.61h-8.31v-11.22zm-14.89 17.01h15.48c7.54 0 13.15-3.66 13.15-10.82 0-5.63-3.29-9.1-7.94-10.46l9.09-12.97h-7.93l-8.13 11.82h-7.14v-11.82h-6.58z",
                style: {
                    fill: "#fff",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(.0581 0 0 -.0581 2.545 197.455)"
            })
        ]
    }));
var $a91b4790f4b2d1a0$export$2e2bcd8739ae039 = $a91b4790f4b2d1a0$var$SvgNorvegia;

});

parcelRegister("gvO8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0566f20b1b20e14$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $c0566f20b1b20e14$var$SvgSelbuBlaa = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsxs)("defs", {
                children: [
                    (0, $7YWoO.jsx)("clipPath", {
                        id: "selbu_blaa_svg__a",
                        clipPathUnits: "userSpaceOnUse",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M0 595.276h841.89V0H0Z"
                        })
                    }),
                    (0, $7YWoO.jsx)("clipPath", {
                        id: "selbu_blaa_svg__b",
                        clipPathUnits: "userSpaceOnUse",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M250.753 450.86h52.231v-52.166h-52.231z"
                        })
                    }),
                    (0, $7YWoO.jsx)("clipPath", {
                        id: "selbu_blaa_svg__c",
                        clipPathUnits: "userSpaceOnUse",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M250.693 509.165h52.166v-52.231h-52.166z"
                        })
                    }),
                    (0, $7YWoO.jsx)("clipPath", {
                        id: "selbu_blaa_svg__d",
                        clipPathUnits: "userSpaceOnUse",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M296.199 463.846h19.817v-19.817h-19.817z"
                        })
                    })
                ]
            }),
            (0, $7YWoO.jsxs)("g", {
                clipPath: "url(#selbu_blaa_svg__a)",
                transform: "matrix(.31768 0 0 -.31768 -39.09 203.562)",
                children: [
                    (0, $7YWoO.jsx)("path", {
                        d: "M322.506 437.884h-6.157v6.172h6.157zm6.537-6.54h-6.219v6.226h6.219zm6.703-.308c0-1.956.026-3.844-.035-5.729-.007-.231-.478-.629-.745-.638-1.655-.056-3.314-.012-4.971-.026-.527-.004-.71.215-.706.728.017 1.857.006 3.715.006 5.665zm-25.937 13.298c0 2.068-.34-17.502-.34-26.306h6.608v-6.405h6.554v-6.716h6.465v-6.212h6.709c0 .36.018 16.838-.023 24.69-.005.968.276 1.149 1.197 1.147 7.987-.016 15.974.028 23.961.056.232 0 .464.024.76.039v6.569h-6.163v6.518h-6.558v6.545h-6.541v6.601h-26.254s-.142-.466-.138-.67c.039-1.754.026-3.509-.011-5.262-.004-.201-.243-.566-.38-.569-1.941-.037-3.883-.025-5.846-.025M316.397 469.971h6.172v-6.157h-6.172zm6.486 6.538h6.226v-6.22h-6.226zm6.534 6.702c1.957 0 3.845.027 5.73-.035.23-.007.628-.479.638-.745.055-1.655.011-3.314.026-4.971.004-.528-.215-.711-.728-.706-1.857.016-3.714.006-5.666.006zm-13.297-25.937c-2.068 0 17.502-.34 26.306-.34v6.608h6.405v6.554h6.716v6.465h6.213v6.709c-.361 0-16.84.018-24.691-.023-.968-.006-1.15.276-1.148 1.198.016 7.986-.027 15.973-.055 23.96 0 .232-.024.464-.039.76h-6.569v-6.163h-6.518v-6.558h-6.546v-6.54h-6.6v-26.255s.466-.143.67-.139c1.754.041 3.508.027 5.262-.01.201-.004.566-.244.569-.38.037-1.941.025-3.883.025-5.846",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("g", {
                        clipPath: "url(#selbu_blaa_svg__b)",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M296.104 437.884h-6.157v6.172h6.157zm-6.475-6.54h-6.22v6.226h6.22zm-6.472-.308c0-1.95-.01-3.808.007-5.665.004-.513-.179-.732-.706-.728-1.657.014-3.316-.03-4.971.026-.267.009-.738.407-.746.638-.061 1.885-.034 3.773-.034 5.729zm13.641 13.323c-.136.003-.376.368-.381.569-.036 1.753-.05 3.508-.01 5.262.005.204-.138.67-.138.67h-26.255v-6.601h-6.54v-6.545h-6.558v-6.518h-6.163v-6.569c.296-.015.528-.039.76-.039 7.987-.028 15.973-.072 23.961-.056.921.002 1.202-.179 1.197-1.147-.041-7.852-.023-24.33-.023-24.69h6.708v6.212h6.465v6.716h6.555v6.405h6.608c0 8.804-.34 28.374-.34 26.306-1.963 0-3.905-.012-5.846.025",
                            style: {
                                fill: "#f39000",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            }
                        })
                    }),
                    (0, $7YWoO.jsx)("g", {
                        clipPath: "url(#selbu_blaa_svg__c)",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M296.056 463.814h-6.172v6.157h6.172zm-6.486 6.475h-6.227v6.22h6.227zm-6.535 6.471c-1.951 0-3.808.01-5.665-.006-.514-.005-.732.178-.727.706.013 1.657-.031 3.316.025 4.971.009.266.407.738.638.745 1.885.062 3.773.035 5.729.035zm13.323-13.64c.003.136.368.376.569.38a118 118 0 0 0 5.261.01c.205-.004.671.139.671.139v26.255h-6.601v6.54h-6.545v6.558h-6.518v6.163h-6.569c-.016-.296-.039-.528-.04-.76-.027-7.987-.07-15.974-.055-23.96.002-.922-.179-1.204-1.147-1.198-7.852.041-24.33.023-24.691.023v-6.709h6.213v-6.465h6.716v-6.554h6.404v-6.608c8.805 0 28.374.34 26.307.34 0 1.963-.012 3.905.025 5.846",
                            style: {
                                fill: "#f39000",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            }
                        })
                    }),
                    (0, $7YWoO.jsx)("g", {
                        clipPath: "url(#selbu_blaa_svg__d)",
                        children: (0, $7YWoO.jsx)("path", {
                            d: "M0 0h-6.548v6.548h-6.721V0h-6.548v-6.72h6.548v-6.549h6.721v6.549H0Z",
                            style: {
                                fill: "#f39000",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            transform: "translate(316.016 457.298)"
                        })
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0v8.913c0 .219-.075.47-.175.605l-7.35 13.07h3.185c1.885-3.548 4.943-9.082 5.872-10.86 1.745 3.257 4.055 7.437 5.894 10.86h2.971L2.93 9.458c-.111-.145-.133-.308-.133-.551V0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(139.269 149.656)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c.312-1.912 1.725-2.972 3.729-2.972 2.294 0 3.197 1.219 3.197 2.634 0 1.5-1.054 2.283-3.869 3.045C-.985 3.805-2.054 5.28-2.054 7.502c0 2.189 1.499 4.621 5.564 4.621 4 0 5.561-2.217 5.779-4.769H6.628c-.268 1.346-.97 2.654-3.241 2.654-1.871 0-2.737-.911-2.737-2.28 0-1.242.623-1.909 3.423-2.645C8.298 3.957 9.642 2.519 9.642-.112c0-3.08-2.44-4.976-6.001-4.976C.21-5.088-2.365-3.465-2.683 0z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(150.39 154.45)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h2.66v4.822h2.696V0h3.346v-2.229H5.356v-10.38c0-1.387.347-1.972 1.763-1.972.456 0 .923.042 1.287.107v-2.036c-.641-.231-1.591-.285-2.17-.285-2.412 0-3.576.921-3.576 3.674v10.892H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(160.65 166.245)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-.087 2.821-1.218 4.95-4.096 4.95-3.285 0-4.063-2.972-4.214-4.95Zm-8.375-1.988c-.021-3.321 1.394-5.827 4.322-5.827 2.667 0 3.489 1.873 3.802 2.741h2.674c-.546-2.07-2.163-5.003-6.607-5.003-5.189 0-6.953 4.085-6.953 8.662 0 4.072 2 8.569 7.107 8.569 5.199 0 6.712-4.056 6.712-7.883 0-.092-.011-1.155-.023-1.259z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(181.363 159.418)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h2.66v4.822h2.696V0h3.346v-2.229H5.356v-10.38c0-1.387.347-1.972 1.763-1.972.456 0 .923.042 1.287.107v-2.036c-.641-.231-1.591-.285-2.17-.285-2.412 0-3.576.921-3.576 3.674v10.892H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(184.862 166.245)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M202.854 166.245h2.708v-16.589h-2.708zm0 7.238h2.708v-3.523h-2.708z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c.442-2.931 2.423-4.345 5.104-4.345 2.71 0 4.496 1.385 4.496 3.9 0 2.501-1.18 3.56-5.143 4.792-4.729 1.439-6.538 3.009-6.538 6.249 0 3.588 2.707 5.909 6.908 5.909 4.862 0 6.932-2.865 7.172-6.055H9.217c-.347 2.308-1.667 3.772-4.464 3.772-2.648 0-3.965-1.294-3.965-3.368 0-2.12 1.176-2.956 4.801-4.05 5.567-1.69 6.915-3.823 6.915-6.935 0-3.758-2.6-6.499-7.523-6.499C.295-6.63-2.47-4.113-2.795 0z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(218.557 156.034)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-.087 2.821-1.218 4.95-4.096 4.95-3.285 0-4.063-2.972-4.214-4.95Zm-8.375-1.988c-.021-3.321 1.394-5.827 4.322-5.827 2.667 0 3.489 1.873 3.802 2.741h2.674c-.546-2.07-2.163-5.003-6.607-5.003-5.189 0-6.953 4.085-6.953 8.662 0 4.072 2 8.569 7.107 8.569 5.199 0 6.712-4.056 6.712-7.883 0-.092-.011-1.155-.023-1.259z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(244.12 159.418)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M249.643 173.483h2.708v-23.826h-2.708z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 3.505-1.393 5.857-4.255 5.857-3.28 0-4.455-2.123-4.455-6.055 0-4.046.926-6.453 4.37-6.453C-1.364-6.651 0-3.896 0 0m-11.262 15.13h2.708V5.589c.72 1.331 2.249 2.631 4.972 2.631 4.027 0 6.364-3.311 6.364-8.108 0-5.043-2.127-9.103-6.87-9.103-2.548 0-3.869 1.099-4.489 2.403.01-.672-.044-1.416-.11-2.108h-2.64c.033.924.065 2.659.065 4.696z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(267.557 158.353)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0-2.075.032-3.892.065-4.69h-2.619c-.098.46-.131 1.473-.142 2.636-.753-1.787-2.437-2.931-4.866-2.931-2.595 0-5.078 1.246-5.078 5.713v11.17h2.697V1.259c0-2.145.684-3.891 3.198-3.891 2.368 0 3.995 1.596 3.995 5.255v9.275H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(285.74 154.347)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M296.923 166.245h2.708v-16.589h-2.708zm0 7.238h2.708v-3.523h-2.708z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h-6.609v2.42H9.459V0h-6.63v-20.168H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(315.499 169.824)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 2.645-.021 4.811-.065 5.631h2.661c.055-.783.067-1.841.067-3.364C3.44 4.324 5.27 5.893 8.03 5.936V3.11C4.299 2.976 2.708.78 2.708-2.798v-8.16H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(324.047 160.614)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0-3.843 1.651-6.604 4.657-6.604 3.107 0 4.578 2.606 4.578 6.645 0 3.738-1.616 6.19-4.645 6.179C1.651 6.208 0 3.738 0 0m-.319-8.783h-1.706L9.169 8.321h1.792zM11.926.052c0-4.815-2.105-8.851-7.411-8.851-5.156 0-7.196 4.203-7.196 8.775 0 4.39 2.389 8.426 7.404 8.426 4.697 0 7.203-3.547 7.203-8.35",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(335.414 158.17)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 3.458-.033 4.483-.065 5.193h2.661c.044-.315.121-1.909.1-2.6.687 1.487 2.175 2.928 4.89 2.928 3.072 0 5.28-1.733 5.28-6.214v-10.703h-2.728v10.283c0 2.412-.816 4.26-3.287 4.26-2.962 0-4.143-2.196-4.143-5.675v-8.868H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(350.158 161.052)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0-4.033 1.74-6.359 4.349-6.359 3.572 0 4.307 2.708 4.307 6.599 0 4.607-1.329 5.952-4.134 5.952C1.764 6.192 0 3.957 0 0m11.262 15.443V-4.06c0-1.596.011-3.299.065-4.323H8.665c-.044.437-.1 1.482-.1 2.447-.87-1.923-2.218-2.752-4.943-2.752-4.298 0-6.428 3.626-6.428 8.567 0 4.789 2.485 8.654 6.981 8.654 2.677 0 3.934-1.071 4.379-1.988v8.898z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(368.617 158.04)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-.087 2.821-1.218 4.95-4.096 4.95-3.285 0-4.063-2.972-4.214-4.95Zm-8.375-1.988c-.021-3.321 1.394-5.827 4.322-5.827 2.667 0 3.489 1.873 3.802 2.741h2.674c-.546-2.07-2.163-5.003-6.607-5.003-5.189 0-6.953 4.085-6.953 8.662 0 4.072 2 8.569 7.107 8.569 5.199 0 6.712-4.056 6.712-7.883 0-.092-.011-1.155-.023-1.259z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(393.911 159.418)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M399.434 173.483h2.708v-23.826h-2.708z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h-2.628c-4.018 0-4.773-1.631-4.773-3.143 0-1.617.98-2.956 3.07-2.956C-1.073-6.099 0-3.902 0-.339zm2.594-4.36c0-1.145.107-2.807.25-3.681H.378a15 15 0 0 0-.241 2.564C-.498-7.145-2.174-8.336-4.88-8.336c-4.051 0-5.293 2.732-5.293 5.033 0 2.497 1.612 5.268 7.553 5.268h2.541v1.61c0 1.573-.446 3.198-3.26 3.198-2.414 0-3.251-1.108-3.529-2.938h-2.651c.249 2.776 1.852 5.04 6.266 5.04 3.468 0 5.847-1.395 5.847-5.174z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(415.088 157.697)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0-3.849 1.631-6.07 4.263-6.07 3.17 0 4.284 1.975 4.284 6.145 0 4.147-.919 6.08-4.144 6.08C1.653 6.155 0 3.856 0 0m11.119-7.139c0-5.171-2.074-8.094-7.112-8.094-4.846 0-6.313 2.598-6.551 4.96H.141c.367-1.845 1.856-2.743 3.97-2.743 3.558 0 4.368 2.328 4.368 5.95v1.361c-.85-1.855-2.308-2.728-4.872-2.728-3.899 0-6.424 3.258-6.424 8.399 0 5.377 2.987 8.552 6.803 8.552 2.619 0 3.981-1.076 4.416-2.359 0 .708.088 1.653.133 2.031h2.65a137 137 0 0 1-.066-4.809Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(423.35 158.055)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h2.674C14.972-22.313 32.35-44.884 51.867-44.884c10.694 0 19.784 6.32 19.784 18.991 0 31.953-70.047 27.27-70.047 78.781 0 22.862 16.042 41.869 54.273 41.869 8.288 0 27.538-1.928 43.58-11.569l2.406 11.569h2.673V46.276h-2.673C84.752 84.289 72.988 91.16 59.353 91.16c-12.298 0-16.041-9.074-16.041-14.859 0-33.881 70.314-32.779 70.314-78.78 0-30.851-24.062-46.001-57.214-46.001-9.892 0-31.013 1.927-51.332 13.221L2.674-48.48H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(132.983 277.404)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c.535 1.652 1.07 14.244 1.07 20.305 0 15.7-3.209 43.781-16.843 43.781-16.844 0-22.191-27.175-22.459-64.086zm40.638-55.171c-9.892-8.814-25.933-20.934-56.144-20.934-43.312 0-70.582 28.372-70.582 71.894 0 48.204 37.162 71.343 70.315 71.343 29.141 0 60.154-14.874 60.154-57.295 0-4.132-.534-11.294-1.337-14.048h-81.276c0-49.583 15.774-64.102 38.5-64.102 17.378 0 31.28 9.089 40.37 18.18z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(328.328 262.86)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0v-3.628h-74.479V0h14.514v200.979h-14.514v3.628h59.965V0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(442.639 245.99)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c4.01-2.204 9.09-3.581 14.971-3.581 17.645 0 25.399 18.684 25.399 60.553s-4.812 60.553-19.785 60.553C13.366 117.525 0 111.74 0 81.99Zm-45.451-14.646v207.36h-14.514v3.628H0v-93.644c6.95 21.485 26.2 25.892 37.161 25.892 34.222 0 51.066-24.515 51.066-71.618 0-41.319-19.517-71.618-53.739-71.618-10.962 0-24.33 4.13-34.488 11.017l-42.777-11.017z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(492.39 213.087)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-9.357-24.516-25.666-33.605-44.113-33.605-22.725 0-39.57 14.599-39.57 44.899v91.955h-13.099v3.629h58.551V4.133c0-13.774 6.684-19.008 16.041-19.008C-14.972-14.875 0-9.089 0 16.804v86.445h-18.714v3.629h64.165V-27.223h12.833v-3.628H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(676.152 180.947)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 12.641-2.873 18.497-9.007 18.497-7.556 0-10.046-6.929-10.046-19.733 0-12.114 1.921-19.557 9.348-19.557C-3.175-20.793 0-14.235 0 0m-25.862 44.516h7.071V17.408c1.553 3.858 4.964 7.541 11.671 7.541 9.377 0 14.316-8.081 14.316-24.814 0-15.594-4.053-27.345-15.675-27.345-6.26 0-9.067 3.222-10.545 6.77a81 81 0 0 0-.256-5.938h-6.679c.097 2.685.097 7.666.097 13.866z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(618.626 330.727)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M632.424 375.243h7.071v-70.894h-7.071z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0 2.313-1.285 4.755-4.241 4.755-2.928 0-4.303-2.149-4.303-4.591 0-2.342 1.314-4.72 4.303-4.72C-1.382-4.556 0-2.313 0 0m-12.856 0c0 4.728 3.138 8.653 8.552 8.653C1.14 8.653 4.375 4.962 4.375.1c0-4.898-3.4-8.589-8.582-8.589-5.38 0-8.649 3.89-8.649 8.489M3.055-41.211c-1.223.199-2.564.264-4.854.264-8.71 0-12.272-4.303-12.272-9.923 0-4.653 2.38-8.94 7.626-8.94 7.166 0 9.5 5.218 9.5 15.854zM9.83-56.204c0-3.162.255-7.332.387-8.921H3.743c-.256 1.125-.483 3.83-.483 5.739-1.808-4.116-5.497-6.635-11.586-6.635-9.415 0-12.811 7.581-12.811 14.599 0 9.246 6.063 16.163 18.911 16.163 2.296 0 3.677 0 5.116-.164v6.728c0 3.945-.728 8.933-7.365 8.933-7.186 0-7.641-5.297-7.931-8.682h-6.831c.193 7.217 3.548 14.646 14.996 14.646 9.52 0 14.071-4.757 14.071-14.072z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(666.904 369.473)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h-3.132v1.273h7.583V0H1.319v-8.746H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(728.356 166.545)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0h1.964l3.091-7.585h.055L8.173 0h1.965v-10.02H8.819v8.237h-.028L5.509-10.02h-.88L1.346-1.783h-.027v-8.237H0Z",
                        style: {
                            fill: "#f39000",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(733.769 167.819)"
                    })
                ]
            })
        ]
    }));
var $c0566f20b1b20e14$export$2e2bcd8739ae039 = $c0566f20b1b20e14$var$SvgSelbuBlaa;

});

parcelRegister("cQFu4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95aa853b29afb9d2$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $95aa853b29afb9d2$var$SvgSnofrisk = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("defs", {
                children: (0, $7YWoO.jsx)("clipPath", {
                    id: "snofrisk_svg__a",
                    clipPathUnits: "userSpaceOnUse",
                    children: (0, $7YWoO.jsx)("path", {
                        d: "M0 841.89h595.28V0H0Z"
                    })
                })
            }),
            (0, $7YWoO.jsxs)("g", {
                clipPath: "url(#snofrisk_svg__a)",
                transform: "matrix(.5097 0 0 -.5097 -58.749 310.776)",
                children: [
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0v10.647c0 9.246-4.794 19.422-21.73 19.422-16.931 0-23.488-10.161-23.488-22.859s4.09-18.907 9.734-25.965c5.643-7.055 15.869-14.891 19.609-20.599 2.822-4.293 4.162-8.616 4.162-14.336 0-8.081-7.232-11.932-13.189-11.345-5.197.503-12.048 3.805-12.347 12.842-.28 8.373 3.119 12.505 4.568 13.546.277.211.337.147-.191.262-2.649.591-11.068-.952-14.724-6.927-2.981-4.869-4.002-11.142-1.837-17.693 2.163-6.557 9.423-14.709 25.085-14.709 17.152 0 26.54 10.986 26.54 25.94s-6.632 21.446-17.356 32.17C-25.891-8.877-30.51-5.207-30.751 7.492c-.071 3.949 1.688 11.006 8.528 11.006 7.624 0 7.829-5.269 7.829-8.181V0Z",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(176.882 406.85)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c.002.193 0 42.939 0 45.767 0 6.775-3.382 18.061-15.804 18.061-12.418 0-17.006-11.101-17.006-11.101l.019 10.254h-12.738v-75.065h13.547v55.593c0 3.781 2.774 9.88 9.549 9.88 6.769 0 8.794-6.695 8.794-9.381V-1.158",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(231.317 342.61)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-3.44 0-5.932 1.272-7.426 3.489L9.411 45.265V9.406C9.411 4.327 5.838 0 0 0m-9.03 49.302c0 6.202 4.897 9.027 9.03 9.027 3.064 0 5.437-1.225 7.04-2.936L-9.03 14.909Zm25.282 12.929 4.235 10.51-6.562.012-2.828-7.131c-3.214 1.549-6.996 2.491-11.281 2.491-9.034 0-22.953-5.645-22.953-20.887V10.353c0-5.194 2.459-10.266 6.771-13.953l-3.951-9.947h6.021l2.745 6.804C-8.309-8.297-4.483-9.22-.184-9.22c13.922 0 23.137 8.653 23.137 20.322v37.627c0 4.697-2.402 9.735-6.701 13.502",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(263.295 338.705)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-8.652 0-20.319-3.949-20.319-20.504v-12.849h-9.971v-9.709h9.595v-65.683H-6.77v65.683H6.396v9.591H-6.398v14.844c0 3.58 1.879 8.097 6.776 8.097 4.465 0 5.478-3.933 5.478-6.191 0-2.103-.016-4.009-1.607-6.474-.168-.219-.036-.399.265-.36 3.303.392 5.275.351 8.068 3.336 2.631 2.831 2.837 5.028 2.837 8.351C15.419-7.613 10.586 0 0 0",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(318.877 439.202)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M388.209 330.441h-13.928v75.067h13.928z",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0a8.276 8.276 0 0 0-8.276-8.28A8.275 8.275 0 0 0-16.552 0 8.275 8.275 0 1 0 0 0",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(389.332 428.086)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-.686-1.176-2.498-3.396-5.405-3.396-2.266 0-4.014 1.788-4.385 5.167-.376 3.391-.586 12.612-.586 16.755 0 4.138-1.526 11.849-13.003 13.169 0 0-2.258-.192-.757 1.875 1.501 2.074 20.133 29.916 20.133 29.916l-13.924-.186-19.568-31.162v64.843h-13.547V-11.77h13.547v39.842c2.29-.17 8.427-.984 11.124-5.039 3.385-5.072 2.658-10.34 2.658-15.233 0-8.316.522-14.667 5.41-18.33 2.381-1.792 5.676-2.18 8.689-2.18 2.957 0 11.162 2.437 9.932 12.674C.305.105.165.28 0 0",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(496.188 342.212)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0-4.433.84-11.198 8.495-11.559.189-.004.52-.16.128-.557-1.147-1.142-4.524-2.468-7.027-2.468-4.238 0-15.027.605-15.238 13.548",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(231.3 342.904)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-12.234 7.897-14.49 11.664-14.49 15.988 0 4.335 3.571 7.908 8.464 7.908 4.891 0 8.277-3.067 8.277-6.774V9.406h11.828v7.716c0 4.516-2.425 16.371-19.541 16.371-10.906 0-21.988-5.088-21.988-17.688 0-12.038 7.694-16.933 12.206-20.137 4.52-3.195 18.486-10.329 18.441-20.504-.038-8.558-9.787-8.467-9.787-8.467s-10.345-.227-10.345 9.971c0 5.739 2.025 8.498 3.161 9.579q.278.25.327.386c-1.669-.027-12.872-.659-13.968-12.83-.915-10.247 5.898-14.911 12.5-16.896 2.419-.591 5.23-.931 8.512-.931 18.812 0 22.582 12.227 22.582 20.878C16.179-14.49 12.225-7.903 0 0",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(423.188 373.325)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c.481 0 .917-.053 1.331-.125C9.238-1.01 8.889-10.484 5.89-12.106c-.082-.039 12.076.735 11.329 12.269-.374 5.763-3.71 8.281-6.874 9.373-1.491.459-3.208.704-5.198.686-12.414-.1-16.223-11.381-16.223-11.381l.016 10.241h-12.733v-75.07h13.549v48.989C-10.244-11.622-8.844 0 0 0",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        },
                        transform: "translate(353.206 396.46)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c0-.192-.01-.387-.01-.576-.15-.59-.309-1.237-.457-1.822-.004-.392-.012-.787-.017-1.165-.225-.577-.505-1.43-.75-2.114-.286-.754-.601-3.003-1.439-3.041-.493.298-1.708.08-2.182.398-.051.08-.032.061-.069.213.225.378.029.886.174 1.385.237.88.491 1.854.762 2.692.145.452-.02.789.16 1.234.752 1.908 1.341 3.944 2.121 5.73.132.314.014.494.146.799.388.868.896 1.653 1.282 2.608.075.038.151.045.227.065 0-.745.248-1.268.408-1.891.083-.361.006-1.025.06-1.316C.481 2.717.132.471 0 0m12.965 37.813c1.757-.754 1.748-.754 1.893.558C7.243 43.502 2.79 54.756-2.147 62.361c.004.854-1.639 2.864-2.149 3.376-11.917 12-2.247 5.093-1.219 10.893-1.92 1.318-3.96-.082-5.996-.074-.792 3.481 9.431 4.805 10.024 4.634-3.96 4.268-9.539 3.693-14.478.747-1.222-2.587-4.474 1.502-6.167 2.269-5.947 2.696-8.033-9.967-6.94-11.523-1.038-.741-1.143-.377-2.197-1.32.089-.302 4.802-3.861 2.431-8.641-1.819-3.755-7.274-6.801-4.525-11.441-.171-4.412 11.595-1.047 9.954-10.009-.872-4.804 5.35.552 6.503 10.914 1.527 2.603 2.832 1.022 2.664 1.006 2.043-5.061 7.25-12.335.945-16.546-4.489-3.112-11.666-13.339-10.261-20.053 1.434-6.816 6.427-11.765 8.704-18.642.927-2.751 2.407-10.22 6.135-10.372 5.36-2.251 2.519 7.697 5.836-.007C.844-21.137 6.317 4.63 6.092 3.937c3.497 10.515 6.891 15.833 7.074 27.094 3.308-.01.034-1.344 3.791-.631.004 2.501-3.729 4.609-3.992 7.413",
                        style: {
                            fill: "#fff",
                            fillOpacity: 1,
                            fillRule: "evenodd",
                            stroke: "none"
                        },
                        transform: "translate(421.812 416.809)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-.652.331-2.295 1.605-2.295 2.259-.547 1.099-1.795 3.29-1.913 4.577 1.266-.124 4.483-.918 2.06.308-1.952.985-3.027 2.59-4.123 4.421-2.394 4.004-5.341 7.458-8.142 11.157-1.421 1.861-2.337 4.12-3.554 6.12-.412.645-1.443 1.533-1.424 2.274-.652 1.261-1.806 2.482-2.527 3.851-.974 1.855-2.124 3.835-4.146 4.703 0 .069.306 1.507-.65-.289-.7-1.319-1.187-1.995-2.272-3.076 1.929-1.672 3.005-4.714 3.964-6.979 1.718-4.086 3.11-8.328 4.236-12.618 1.098-4.093 2.028-8.333 2.164-12.586.075-2.109.175-5.922-2.159-7.018 1.923-.163 3.857-.032 5.783-.176-1.894-1.632-4.773-1.425-6.939-2.57 2.641-.777 5.524.027 8.138-.892-3.033-.565-4.578-3.066-4.513-6.029.037-1.279.988-2.976-.119-3.588-1.528-.845-2.953-1.914-3.999-3.323-1.674-2.242-2.005-5.013-1.839-7.729.075-1.402.265-2.793.466-4.188.125-.925.988-3.691.574-4.497.419.821.17 2.64.215 3.548.102 1.897.186 3.794.32 5.691.083 1.22.903 1.528 1.875 2.389.51.454 1.061 1.174 1.627 1.548.535.369 2.064-.208 2.28.577-1.074-3.88-3.115-7.868-3.676-11.867.223 1.572 1.213 3.479 1.805 4.966.389.978.953 3.926 1.981 4.255.005-1.558.581-2.914.371-4.526a36 36 0 0 0-.789-4.293c-.01-1.595-.696-3.019-1.128-4.55-.478-1.76-1.301-2.01-3.047-1.439q.065-.834.088-1.683c.293.028 1.242.071 1.428-.284.205-.179-.099-2.18-.051-2.553.123-.937 1.098-1.453 1.949-1.582 1.347-.204 1.577.63 2.575 1.071 1.066.468 1.794 2.682 2.092 3.764.487 1.754 1.078 3.603 1.164 5.431.318 6.389 3.182 11.719 5.726 17.423C-4.12-12.829-4.104-4.995-4.014.686-3.276.226.124-1.188 0-1.059",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "evenodd",
                            stroke: "none"
                        },
                        transform: "translate(438.389 447.618)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-.304-.471.16-2.433.245-3.086C.558-5.383.172-8.37-.429-10.57c-.328-1.18-.132-2.446-.569-3.629-.449-1.22-1.274-2.802-1.32-4.078-1.446-3.104-2.98-6.179-4.303-9.332-.006-2.18-1.032-4.995-1.462-7.23-.586-3.051-.697-5.964-2.338-8.74 0-1.052-1.384-2.142-2.409-2.212-.658.694-.896 1.578-.635 2.547.623 2.221 1.72 4.379 2.407 6.646 1.001 3.305 3.181 12.525-1.303 14.141-2.138.764-4.343-1.676-5.41-3.137-1.429-2.009-2.106-5.221-2.102-7.667.012-2.69.239-5.494.843-8.112.189-.811.253-2.398.11-3.21-1.072-.368-2.031.105-2.679.971-1.474 1.962-.29 4.284-.369 6.488-.089 2.512-.024 5.416-.543 7.869-.795 3.689-1.595 6.838-3.578 10.103-1.537 2.542-2.081 5.217-1.594 8.185.247 1.465.777 2.835 1.135 4.279.298 1.148-.213 1.168-.768.511-1.258-1.516-1.636-3.892-1.879-5.827-.392-3.24.647-5.666 2.253-8.394-.005-.882 1.115-1.968 1.462-2.894.4-1.051.46-2.169.838-3.2.917-2.463.952-5.4.979-8.016.017-.746.188-4.385.584-5.784.169-.336.293-.553.329-.553-.124.001-.232.213-.329.553-.632 1.256-1.936 4.283-2.018 4.81-.377 2.399-1.817 5.214-3.089 7.189-.663 1.028-1.063 2.169-1.797 3.169-.679.93-1.555 1.655-2.21 2.616-1.514 2.276-2.611 4.737-2.312 7.517.186 1.624.804 3.157 1.36 4.688.343.945.282 1.891.724 2.782.007 1.263.727 4.362 1.564 5.575 1.666 2.471 4.181 3.783 6.367 5.697 2.852 2.481-.145-2.186 1.962-1.503 1.836 4.417 2.133 10.139-.267 14.452-.702 1.278-1.116 2.687-1.916 3.905-.772 1.176-.683 1.143-.11 2.261 1.211 2.346 1.104 3.948-.582 6.059-1.102 1.381-1.08.126-.579-.781.47-.813 1.081-1.695 1.019-2.691-.171-2.444-2.658-2.993-4.067-4.467-1.571-1.633-1.022-4.791-1.56-6.882-.487-1.872-1.682-4.803-3.847-5.348.026 1.536.226 2.79-.639 4.188-.838 1.362-2.036 2.802-1.287 4.32.646 1.307-1.605.255-2.078.135-1.038-.249-2.66-.731-3.395.405.6.279 2.39.174 2.481 1.1-.67.254-2.099-.11-2.891-.063-1.196.079-1.947.101-2.755 1.086-1.669 2.055.202 4.409 1.562 5.925 1.768 2.001 3.735 4.425 4.27 7.121.621 3.119-.833 4.501-2.667 6.564.611.208 1.406-.344 1.849.222.345.442-.005.914.003 1.412.012 1.349.077 2.719.342 4.043.39 1.966 1.27 5.218 3.179 6.324 2.09 1.128 4.56-.979 5.957-2.343.663-.659-.612-1.284-1.238-.914-1.101.625-2.212.617-3.101-.206-1.642-1.527-.906-4.783 1.569-3.735 2.054.874 3.387 2.958 5.124 4.391 1.887 1.501 4.291 2.909 6.812 3.205 1.158.132 2.397.016 3.531-.213.75-.158 2.805-.945 3.017-1.749-1.939.003-5.439-.099-7.028-1.33-1.15-.887-1.916-1.829-2.98-2.712-.922-.769-.922-.991-1.993-1.537-1.064-.481-2.194-1.308-2.854-2.271-.768-1.134.314-1.553 1.116-.738 1.903 1.919 4.753 3.187 7.538 2.635.709-.136 1.443-.189 2.167-.254-.006-.832-3.149-2.691-3.924-3.002-1.088-.427-2.388-.228-3.5-.078-.305.044-1.292-.2-1.578-.372-.389-.479-.682-1.96.358-1.272.009.127 1.24.28 1.574.28 1.73-.459 3.679.693 5.081-.643.512-.48 2.344-3.483 2.683-3.49 1.932-2.676 3.596-6.132 5.55-9.007 1.204-1.847 1.844-3.986 3.513-5.53 1.452-1.353 2.692-3.385 3.885-5.004.847-1.139 1.764-2.351 2.354-3.627.214-.468 1.439-2.857 1.772-2.977.16-.055 2.202-2.122 2.275-2.344-1.926.006-1.281-1.078-.831-2.526.51-1.648 2.205-3.086 2.597-4.718C2.188-.459.697 1.043 0 0m-15.99-40.16c-.051.142-.063.284-.073.528.129.212.01.583.093.897.231.874.336 1.9.63 2.818.31.939.575 2.162.94 3.052 0 .144.004.291.004.446.586 1.171 1.049 2.575 1.544 3.775.178.445.122.76.324 1.189.217.497.685 1.001.899 1.472.191.414.107.69.389.959 1.136-3.407-.122-9.166-1.136-12.279-.235-.705-.708-3.032-1.311-3.183-.376.253-1.87.364-2.303.326m-1.175 2.107c-.068-.277-.003-.629-.072-.825-.136.047-.076.023-.15.086-.174.259.054.76-.063 1.11-.133.409-.291 1.173-.415 1.651.005.723.017 1.435.019 2.166-.111.572.036 1.491.185 2.002.25.939.073 2.072.406 2.908.022.037.217.122.228.151v.516c.147.404.458.833.617 1.184q.002.141.004.3c.052 0 .102-.01.149-.01.205.294.254.605.464.897.095.064.198.143.305.22.004.088.004.189.004.289.117.181.463.202.596.359.1.142.052.331.15.453.446.496 1.367.93 2.259.947.207-.214.37-.16.435-.535-.174-.146-.523-.619-.611-.816-.01-.146-.01-.293-.01-.449-.065-.103-.52-.385-.599-.506a8 8 0 0 0-.084-.524c-.043-.081-.256-.109-.298-.217 0-.234-.005-.449-.01-.675-.095-.277-.426-.563-.531-.809-.159-.382-.087-.645-.247-1.045-.446-1.155-1.039-2.509-1.456-3.698-.224-.625-.106-1.144-.319-1.784-.331-.994-.662-2.285-.956-3.346M4.915.034C3.932 1.655 2.241 3.571 1.917 5.5c.729-.03 1.978-.308 2.617.186.655.619.221 1.085-.507 1.201C2.073 8.032.893 9.208-.194 11.208c-.492.906-2.388 2.879-2.441 3.86-.051.825-1.548 2.109-2.065 2.733-.472.562-.975 1.87-1.601 2.187-.914.451-2.181 2.72-2.787 3.501-1.246 1.629-2.028 3.77-3.196 5.517-1.532 2.277-2.976 4.618-4.379 6.969-.629 1.051-1.203 2.058-2.056 2.944-.462.496-1.517.859-1.84 1.371 1.993.389 2.773 2.814 3.946 4.043-.842 1.559-4.912 1.021-6.338.835.327 1.723 3.921 3.021 5.348 3.344 1.24-.022 5.373-.319 4.56 1.832-.717 1.907-4.342 2.7-6.087 2.83-2.906.193-5.569-.883-8.068-2.221-1.789-.984-.981-1.527-2.854-.175-1.645 1.195-3.139 2.393-5.277 2.284-1.649-.09-2.434-1.371-3.284-2.59-.699-.976-1.153-1.922-1.333-3.097-.061-.406-.179-1.662-.361-2.042-.472-1.025-.714-3.103-.312-4.169.352-.946-2.027-.264-2.652-1.216-.701-1.069 1.281-1.335 1.893-1.748.708-.478 1.045-1.271 1.227-2.063.369-1.635.205-3.609-.569-5.107-1.42-2.7-3.816-4.405-5.392-7.08-.836-1.451-.195-4.006.936-5.099 1.131-1.088 2.446-.894 3.405-2.039a2.84 2.84 0 0 1 2.958-.857c1.85.576 1.228-.169 1.951-1.58.419-.795 1.197-1.596 1.533-2.48.336-.877-.364-4.408.168-4.682.679-.359 2.815.915 3.352 1.398 2.478 2.212 2.708 4.716 3.399 7.734.396 1.752-.107 2.798 1.314 4.151.766.734 1.542 1.121 1.719-.254.966-1.599 1.61-3.389 2.367-5.178.806-1.929 1.88-5.531.969-7.592-.894-1.964-2.998-2.874-4.561-4.099-2.641-2.059-4.861-3.96-5.821-7.261-.809-2.768-1.284-5.373-2.28-8.067-.899-2.453-1.036-5.496.204-7.849.762-1.438 1.316-2.971 2.474-4.149.93-.939 1.946-2.316 2.446-3.537 1.187-2.82 2.601-5.513 3.412-8.57.334-1.25.461-2.989 1.319-3.991.133-.155 1.668-1.674 1.534-1.816.085.042.18.087.268.132-.442-.288.742-1.783 1.093-2.279.945-1.289 2.33-2.336 4.025-1.927 1.633.397.896 3.431 2.637 3.407 1.678-.014.335-2.167 1.135-3.422 1.125-1.775 2.839-1.154 4.256-.201.694.464 1.012 1.06 1.376 1.807.342.682.913.246 1.401.847 1.382 1.726.713 6.067.964 8.199.518 4.179 1.614 8.238 3.349 11.885C-1.367-20.47-.156-17.574.786-14.37c.705 2.366.805 4.884 1.198 7.335.154.993.207 1.981.302 2.982.062.637-.458 2.156-.098 2.622 1.261-.419 2.475-.817 3.805-.571.301.589-.727 1.463-1.078 2.036",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "evenodd",
                            stroke: "none"
                        },
                        transform: "translate(433.046 448.72)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c.121-.334.198-.665.121-.969-.14-.554.085-.964-.231-1.489.021-.735-.452-1.337-.907-1.556-.201-.028-.407-.292-.593-.315-.267-.116-.383-.316-.76-.112-.17.067-.151.131-.292.22.017 1.391.277 2.475.939 3.193.355.379.964.703 1.22 1.185.13.011.29.04.431.051C-.038.137-.021.06 0 0",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "evenodd",
                            stroke: "none"
                        },
                        transform: "translate(401.317 482.28)"
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M0 0c-3.261 0-5.866 2.645-5.866 5.889A5.855 5.855 0 0 0 0 11.778c3.254 0 5.902-2.623 5.902-5.889C5.902 2.645 3.254 0 0 0m0 10.809a4.907 4.907 0 0 1-4.904-4.92c0-2.71 2.196-4.91 4.904-4.91 2.725 0 4.928 2.2 4.928 4.91A4.916 4.916 0 0 1 0 10.809m.135-4.27c.759 0 1.298.287 1.298.952 0 .568-.456.939-1.139.939h-1.639V6.539Zm-2.508 2.747H.433c1.568 0 2.089-.968 2.089-1.661 0-1.024-.735-1.757-1.81-1.826v-.031c.543-.178.954-.724 1.473-1.576l.777-1.225H1.704l-.542.987C.351 5.373.044 5.649-.741 5.649h-.604V2.967h-1.028z",
                        style: {
                            fill: "#002f87",
                            fillOpacity: 1,
                            fillRule: "evenodd",
                            stroke: "none"
                        },
                        transform: "translate(476.71 426.325)"
                    })
                ]
            })
        ]
    }));
var $95aa853b29afb9d2$export$2e2bcd8739ae039 = $95aa853b29afb9d2$var$SvgSnofrisk;

});

parcelRegister("lqY6u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9aaa60116caa8db$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $f9aaa60116caa8db$var$SvgSunniva = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                d: "M13.337 159.48c6.74 0 9.772-4.381 9.772-9.324 0-11.12-10.11-18.872-9.997-30.891 0-6.74 5.617-13.48 14.49-13.48 5.28 0 9.998 3.258 9.998 8.537 0 1.46-.45 3.707-2.022 3.707-.898 0-1.685-.674-1.685-2.022 0-.898.45-1.91.45-2.696 0-2.134-1.685-5.391-6.74-5.504-3.932 0-7.19 2.36-7.19 7.414 0 11.346 9.998 18.872 9.998 30.105s-8.537 16.288-16.4 16.288c-8.987 0-12.694-6.628-12.694-12.694 0-9.548 6.29-13.592 8.313-13.592 1.235 0 2.022.674 2.022 1.798 0 3.594-8.2 3.033-8.2 12.131-.113 4.381 2.695 10.222 9.885 10.222m79.305-12.919c-2.808 4.157-5.504 7.077-9.548 6.965-2.471 0-4.605-1.46-4.605-5.504 0-3.033 2.47-11.683 2.47-14.716 0-1.348-.336-2.696-2.246-2.696-2.808 0-5.84 3.595-6.74 8.425l-1.91 11.683c-.224 1.01-.112 1.572 0 2.134-1.347.337-2.47.45-3.818.45-2.696 0-3.033-1.798-2.809-3.483l.45-2.808c-2.36 3.482-6.066 6.515-9.773 6.515-2.92 0-4.381-2.134-4.606-4.83-1.685 2.583-4.718 4.942-8.425 4.942-4.38 0-6.29-2.583-6.29-7.301 0-3.595 1.797-11.57 2.246-13.705s.45-3.931-.112-5.054c1.348-.45 2.808-.787 4.156-.787 1.798 0 3.146.674 3.146 2.808 0 3.033-2.584 12.806-2.584 17.3 0 1.572.786 2.695 2.134 2.695 2.921 0 5.954-3.594 6.853-8.424l1.46-8.425c.337-2.135.45-3.932-.112-5.055 1.347-.45 2.808-.786 4.493-.786 1.797 0 2.92.674 2.92 2.47 0 1.236-.224 2.36-.561 4.27l-2.247 12.693c-.112.786-.337 2.022-.337 2.471 0 .674.225 1.236 1.123 1.236 1.573 0 4.718-2.472 7.077-6.179l1.91-11.12c.337-2.135.45-3.932-.112-5.055 1.348-.45 2.92-.786 4.043-.786 1.798 0 2.921 1.235 2.921 2.92 0 .674-.112 1.123-.225 1.91 1.46-2.135 4.381-5.055 8.65-5.055 3.37 0 5.953 2.359 5.953 6.29 0 4.494-2.359 12.47-2.359 15.053 0 1.235.562 1.685 1.348 1.685 1.91 0 4.381-3.483 6.628-7.414l1.685-9.548c.337-2.135.45-3.932-.112-5.055 1.348-.45 2.92-.786 4.044-.786 1.797 0 2.92 1.235 2.92 2.92 0 .674-.112 1.123-.225 1.91 1.46-2.135 4.381-5.055 8.65-5.055 3.37 0 5.953 2.359 5.953 6.29 0 4.494-2.358 12.47-2.358 15.053 0 1.235.561 1.685 1.348 1.685 1.797 0 4.043-3.033 6.065-6.515l1.91-10.447c.45-2.135.45-3.932-.112-5.055 1.348-.45 2.808-.786 4.156-.786 1.797 0 3.145.674 3.145 2.808 0 1.235-.224 2.359-.561 4.268l-2.135 12.357c-.112.786-.337 2.022-.337 2.471 0 .674.225 1.236 1.124 1.236 1.685 0 5.953-4.718 7.638-9.66 1.236-3.82 3.595-6.965 5.504-8.875-1.123-.225-2.022-1.01-3.707-1.01-1.797 0-2.696.673-3.707 1.909-.337-2.472.9-5.73 5.392-5.73 1.348 0 2.92.563 4.157.563 1.123 0 1.91-.113 3.033-.562.786 5.167-4.943 9.66-5.055 18.31 0 3.482 1.685 5.167 3.819 5.167 5.504 0 9.211-8.088 9.211-15.39 0-6.852-3.707-8.536-3.707-10.895 0-1.348.786-2.247 2.247-2.247 2.359 0 4.268 4.269 4.268 10.896 0 10.222-4.605 20.894-14.041 20.894-5.729 0-7.976-3.82-8.2-7.639-2.584 4.269-6.178 7.639-9.998 7.639-2.696 0-4.83-1.798-4.718-5.055v-1.348c-2.696 3.819-5.28 6.403-9.098 6.403-2.472 0-4.606-1.46-4.606-5.505 0-3.033 2.471-11.682 2.471-14.715 0-1.348-.337-2.696-2.246-2.696-2.809 0-5.842 3.595-6.74 8.425l-1.573 11.795c-.224 1.01-.112 1.572 0 2.134-1.348.337-2.471.45-3.82.45-2.695 0-3.032-1.798-2.807-3.483zm36.845-30.89c2.246 0 3.37 1.572 3.37 3.37a3.79 3.79 0 0 1-3.82 3.819c-1.684 0-3.37-1.236-3.37-3.37 0-2.36 1.798-3.82 3.82-3.82m45.382 34.373c-1.124 1.685-3.146 3.594-7.19 3.594-5.84 0-8.424-4.268-8.424-9.548 0-8.312 6.065-17.299 15.164-17.299 2.696 0 4.493 1.011 6.628 1.011 1.348 0 2.022-.112 3.37-.561l-3.258 18.983c-.225.9-.337 1.685-.337 2.472 0 1.123.45 1.797 1.348 1.797 2.022 0 3.595-2.696 3.37-5.954l1.685-.337c.45 3.932-1.348 9.436-7.639 9.324-2.583.112-4.156-1.46-4.717-3.482m-8.65-5.28c0 3.595 1.123 5.841 3.595 5.841 2.583 0 4.493-2.808 5.28-7.301l2.358-13.368c-.674-.449-1.46-.674-2.471-.674-4.044.113-8.65 6.066-8.762 15.502m21.905-21.455c0-2.92 2.359-5.28 5.28-5.28 2.92 0 5.279 2.36 5.279 5.28s-2.36 5.28-5.28 5.28c-3.033 0-5.28-2.36-5.28-5.28m9.885 0c0-2.584-2.022-4.718-4.606-4.718s-4.605 2.134-4.718 4.718c0 2.584 2.022 4.718 4.606 4.718 2.696 0 4.718-2.134 4.718-4.718m-6.628-2.808h2.472c1.123 0 2.021.561 2.021 1.685 0 .898-.561 1.46-1.235 1.685l1.46 2.022h-1.236l-1.235-1.798h-1.123v1.798h-1.011zm2.247 2.696c.674 0 1.123-.337 1.123-.9 0-.56-.337-.898-1.123-.898h-1.348v1.798z"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M120.7 139.9c1.3-3.8 2-7.8 2-12 .1-20.6-16.6-37.4-37.2-37.5C64.8 90.3 48 107 48 127.7c0 9.4 3.4 18 9.1 24.5l19.5.1z",
                style: {
                    fill: "#fdc543"
                },
                transform: "matrix(1.12331 0 0 1.12331 1.205 -63.16)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M99.8 128.4c37 .1 52.4 24.6 52.6 30 0 .8-.6.8-.8 0-1.7-6.2-9.7-17.2-25.1-17.2-23-.1-34 13-57 12.9-14.4 0-33.9-6.6-39.1-12.3l11.3 2.6z",
                style: {
                    fill: "#64ad30"
                },
                transform: "matrix(1.12331 0 0 1.12331 1.205 -63.16)"
            }),
            (0, $7YWoO.jsx)("path", {
                d: "M30.4 141.9c-.3-.3 0-.9.5-.6 2.1 1.1 4.9 1.8 9.5 1.8 19.8 0 30.8-14.8 59.4-14.7 13.1 0 27.1 5.7 32.7 10-2.8-.8-5.6-1.1-7.9-1.1-2.4 0-4.6.1-6.7.4-2.7-1.7-10-3.5-15.8-3.5-14.9 0-26 8.7-36 8.6-3.3 0-5.2-.5-7.8-1.3-.8-.2-.8.3-.3.6 2.7 1.6 6.3 2.8 11 2.8 10.2 0 24.1-8.9 36.7-8.8 5.1 0 9 .8 11.1 1.6-19.7 2.5-29 13.9-53.4 13.8-10.1.1-25.1-4-33-9.6",
                style: {
                    fill: "#296d2f"
                },
                transform: "matrix(1.12331 0 0 1.12331 1.205 -63.16)"
            })
        ]
    }));
var $f9aaa60116caa8db$export$2e2bcd8739ae039 = $f9aaa60116caa8db$var$SvgSunniva;

});

parcelRegister("9Ypw5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742d82b0225980ff$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $742d82b0225980ff$var$SvgYt = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 200",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("defs", {
                children: (0, $7YWoO.jsx)("clipPath", {
                    id: "yt_svg__a",
                    clipPathUnits: "userSpaceOnUse",
                    children: (0, $7YWoO.jsx)("path", {
                        d: "M0 0h2849v2873.91H0Z"
                    })
                })
            }),
            (0, $7YWoO.jsxs)("g", {
                clipPath: "url(#yt_svg__a)",
                transform: "matrix(.06815 0 0 -.06815 2.922 197.926)",
                children: [
                    (0, $7YWoO.jsx)("path", {
                        d: "M2849.06 0H.313L0 2873.91h2849.06z",
                        style: {
                            fill: "#332d85",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M439.723 1058.73V804.988h433.875l185.772 351.152zM1877.55 1284.74l117.06-479.752h430.37v565.802z",
                        style: {
                            fill: "#ed1c24",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "m1059.37 1156.14 159.15-351.152h431.14l227.89 479.752z",
                        style: {
                            fill: "#1f59ab",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    }),
                    (0, $7YWoO.jsx)("path", {
                        d: "M2374.03 2027.66H1334.24l-288.17-416.01c-134.836 194.64-331.179 478.04-331.179 478.04l-289.68-174.67 448.387-647.28V804.988h344.922v462.752l303.52 438.12h127.62V804.988h344.95v900.872h379.42zM2325.63 927.922H2315v-18.953h10.63c6.08 0 10.28 4.179 10.28 9.461 0 5.308-4.2 9.492-10.28 9.492m10.28-53.043-12.86 24.922H2315v-24.922h-11.56v62.832h23.62c11.91 0 20.27-8.832 20.27-19.281 0-8.821-5.48-14.61-12.38-17.032l13.96-26.519zm-12.22 78.742c-26.03 0-46.61-20.883-46.61-47.383 0-26.519 20.58-47.41 46.61-47.41 26.06 0 46.46 20.891 46.46 47.41 0 26.5-20.4 47.383-46.46 47.383m0-105.543c-32.15 0-58.21 26-58.21 58.16 0 32.141 26.06 58.141 58.21 58.141s58.2-26 58.2-58.141c0-32.16-26.05-58.16-58.2-58.16",
                        style: {
                            fill: "#fff",
                            fillOpacity: 1,
                            fillRule: "nonzero",
                            stroke: "none"
                        }
                    })
                ]
            })
        ]
    }));
var $742d82b0225980ff$export$2e2bcd8739ae039 = $742d82b0225980ff$var$SvgYt;

});

parcelRegister("dZidx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b1a8f297fc93c25$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
/**
 * FullWidthBackground Component
 *
 * This component creates a full-width background that spans the entire viewport
 * width, regardless of the parent container's width. It is designed to be used
 * in a layout where a background color or image is desired to extend beyond the
 * confines of the container.
 *
 * @param {string} color - The Tailwind CSS class for the background color.
 *
 * @returns {JSX.Element} The rendered FullWidthBackground component.
 *
 * @example
 * // Usage in a parent component
 * import FullWidthBackground from '../FullWidthBackground';
 *
 * <div className="relative">
 *    {someCondition && <FullWidthBackground color="bg-some-color" />}
 * </div>
 *
 * @note
 * Ensure that the parent container has `relative` positioning to correctly
 * align the absolute positioning of this component.
 *
 * w-[calc(100vw-15px)] is used to account for the scrollbar width in the viewport.
 */ const $4b1a8f297fc93c25$var$FullWidthBackground = ({ color: color })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: (0, $izjX7.cn)(color, "absolute left-1/2 -z-10 h-full w-[calc(100vw-15px)] -translate-x-1/2 transform")
    });
};
var $4b1a8f297fc93c25$export$2e2bcd8739ae039 = $4b1a8f297fc93c25$var$FullWidthBackground;

});


parcelRegister("lLWDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1519b8479b36db8e$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $ieURW = parcelRequire("ieURW");

var $3lzdj = parcelRequire("3lzdj");
var $jOOuf = parcelRequire("jOOuf");

var $fdAV1 = parcelRequire("fdAV1");
var $5UIm0 = parcelRequire("5UIm0");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $4udGV = parcelRequire("4udGV");

var $cZSqT = parcelRequire("cZSqT");

var $6pY3b = parcelRequire("6pY3b");

var $fpr9Z = parcelRequire("fpr9Z");

var $cLfby = parcelRequire("cLfby");

var $lrIVV = parcelRequire("lrIVV");

const $1519b8479b36db8e$var$calendarFooterImage = new URL((parcelRequire("9dYL1"))).toString();
const $1519b8479b36db8e$var$AdventCalendarArticle = ({ adventCalendarArticleContent: adventCalendarArticleContent, isPreview: isPreview = false })=>{
    const prizeImage = adventCalendarArticleContent.fields?.prizeImage;
    const prizeText = adventCalendarArticleContent.fields?.prizeText;
    const title = adventCalendarArticleContent.fields?.title;
    const date = adventCalendarArticleContent.fields.date ? (0, $5UIm0.default)(adventCalendarArticleContent.fields.date) : undefined;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lrIVV.AdventCalendarHeader), {})
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "relative flex justify-center pb-4 sm:pb-8",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "absolute left-0 top-0",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                            href: "/julekalender",
                            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ieURW.default), {}),
                            children: "Tilbake til julekalenderen"
                        })
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                        className: "pt-16 font-suomi text-6xl font-medium sm:pt-0",
                        children: date ? `${(0, $fdAV1.default)(date)}. desember` : title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                children: date && (0, $4udGV.isDateInTheFuture)(date) && !isPreview && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    children: "Denne luken er ikke \xe5pen enn\xe5. G\xe5 tilbake til julekalenderen og pr\xf8v en annen luke."
                })
            }),
            (date && !(0, $4udGV.isDateInTheFuture)(date) || isPreview || !date) && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                children: [
                    adventCalendarArticleContent.fields.question && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                        className: "pb-16",
                        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $cZSqT.default), {
                            theme: "christmas",
                            title: "Delta i dagens luke og vinn fine premier",
                            className: "w-[400px]",
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
                                    cols: {
                                        base: 12
                                    },
                                    gap: 4,
                                    className: "py-7",
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                            span: {
                                                base: 3
                                            },
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                                className: "aspect-square",
                                                children: prizeImage ? /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                                                    className: "h-full w-full rounded-lg object-cover",
                                                    src: prizeImage?.fields.file?.url,
                                                    alt: prizeText || "Premie"
                                                }) : /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                                    className: "h-full w-full rounded-lg bg-base-200"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                            span: {
                                                base: 9
                                            },
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                                className: "text-sm",
                                                children: prizeText
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fpr9Z.default), {
                                    id: adventCalendarArticleContent.fields.question?.sys.id,
                                    entry: adventCalendarArticleContent.fields.question,
                                    slug: adventCalendarArticleContent.fields.slug,
                                    trackingFormName: "Lukep\xe5melding julekalender"
                                })
                            ]
                        })
                    }),
                    adventCalendarArticleContent.fields.body && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "pb-12",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLfby.default), {
                            context: "standard-article",
                            document: adventCalendarArticleContent.fields.body,
                            trackingLocationName: "Advent calendar article"
                        }, JSON.stringify(adventCalendarArticleContent.fields.body))
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                            className: "h-full w-full",
                            src: $1519b8479b36db8e$var$calendarFooterImage,
                            alt: "Julekalender-footer"
                        })
                    })
                ]
            })
        ]
    });
};
var $1519b8479b36db8e$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1519b8479b36db8e$var$AdventCalendarArticle);

});
parcelRegister("ieURW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d475a5d361a8bab9$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $d475a5d361a8bab9$var$SvgArrowBack = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m8.875 12.75 4.188 4.188L12 18l-6-6 6-6 1.063 1.063-4.188 4.187H18v1.5z"
        })
    }));
var $d475a5d361a8bab9$export$2e2bcd8739ae039 = $d475a5d361a8bab9$var$SvgArrowBack;

});

parcelRegister("jOOuf", function(module, exports) {

$parcel$export(module.exports, "Group", function () { return $e6d9d97596c6b69a$export$eb2fcfdbd7ba97d4; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
const $e6d9d97596c6b69a$var$f = {
    start: "items-start",
    center: "items-center",
    end: "items-end",
    between: "items-between",
    around: "items-around",
    evenly: "items-evenly"
}, $e6d9d97596c6b69a$var$u = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
    between: "justify-between",
    around: "justify-around",
    evenly: "justify-evenly"
}, $e6d9d97596c6b69a$var$w = {
    nowrap: "flex-nowrap",
    wrap: "flex-wrap",
    "wrap-reverse": "flex-wrap-reverse"
}, $e6d9d97596c6b69a$var$c = {
    0: "gap-0",
    1: "gap-1",
    2: "gap-2",
    3: "gap-3",
    4: "gap-4",
    5: "gap-5",
    6: "gap-6",
    8: "gap-8",
    10: "gap-10",
    12: "gap-12",
    16: "gap-16",
    20: "gap-20",
    24: "gap-24",
    32: "gap-32",
    40: "gap-40",
    48: "gap-48",
    56: "gap-56",
    64: "gap-64"
};
function $e6d9d97596c6b69a$export$eb2fcfdbd7ba97d4({ children: e, align: a = "center", gap: t = 4, grow: r = !1, justify: n = "center", wrap: p = "nowrap", className: s = "", ...o }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)("flex flex-row", r ? "[&>*]:grow grow" : "", $e6d9d97596c6b69a$var$f[a], $e6d9d97596c6b69a$var$u[n], $e6d9d97596c6b69a$var$w[p], $e6d9d97596c6b69a$var$c[t], s),
        ...o,
        children: e
    });
}
$e6d9d97596c6b69a$export$eb2fcfdbd7ba97d4.displayName = "Group";

});

parcelRegister("fdAV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b144b52c9364440e$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hFacL = parcelRequire("hFacL");
function $b144b52c9364440e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("fpr9Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efa8fc477b00e481$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $4OT0V = parcelRequire("4OT0V");

var $epcVC = parcelRequire("epcVC");
var $5UIm0 = parcelRequire("5UIm0");

var $gyNqR = parcelRequire("gyNqR");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $4udGV = parcelRequire("4udGV");

var $195xf = parcelRequire("195xf");

var $bcbvQ = parcelRequire("bcbvQ");

var $i6TQx = parcelRequire("i6TQx");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");

var $iVdQg = parcelRequire("iVdQg");
const $efa8fc477b00e481$var$CorrectAnswer = (0, $gBcml.observer)(({ signUpCode: signUpCode, answer: answer, companyName: companyName, slug: slug, trackingFormName: trackingFormName })=>{
    const isSignedUp = (0, $i6TQx.default).isSignedUpTo(signUpCode);
    if (!(0, $bcbvQ.default).isLoggedIn()) return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("h2", {
                children: [
                    answer,
                    " er riktig! "
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Du m\xe5 logge inn for \xe5 delta."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                variant: "secondary",
                onClick: ()=>(0, $a2SqC.default).showLoginModal(),
                children: "Logg inn"
            })
        ]
    });
    if (isSignedUp) return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("h2", {
                children: [
                    answer,
                    " er riktig!"
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                children: [
                    companyName,
                    " er n\xe5 med i trekningen for denne konkurransen."
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Vi vil ta kontakt med vinneren s\xe5 fort konkurransen er over."
            })
        ]
    });
    const handleSignup = (payload)=>{
        (0, $i6TQx.default).signUpToPromotion(signUpCode, "", "", payload);
    };
    const { currentCompany: currentCompany } = (0, $bcbvQ.default);
    const descriptionValue = {
        description: slug || ""
    };
    if (currentCompany) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("h2", {
                children: [
                    answer,
                    " er riktig!"
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Fyll ut navn og e-postadresse for \xe5 delta i trekningen"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $iVdQg.default), {
                values: {
                    company: currentCompany,
                    ...descriptionValue
                },
                mappings: (0, $195xf.getCaptureMappings)("slot"),
                config: (0, $195xf.getCaptureConfig)("slot"),
                buttonText: "Delta i trekningen",
                onSignup: handleSignup,
                buttonVariant: "secondary",
                trackingFormName: trackingFormName
            })
        ]
    });
});
const $efa8fc477b00e481$var$WrongAnswer = (0, $gBcml.observer)(()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
        children: "Feil svar. Pr\xf8v igjen!"
    });
});
const $efa8fc477b00e481$var$NotAvailableYet = (0, $gBcml.observer)(({ date: date })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                children: "Dette sp\xf8rsm\xe5let er ikke tilgjengelig enda."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                children: [
                    "Du kan delta p\xe5 denne f.o.m. ",
                    (0, $4udGV.formatDate)(date, true, true, false),
                    "."
                ]
            })
        ]
    });
});
const $efa8fc477b00e481$var$ContestForm = ({ entry: entry, slug: slug, trackingFormName: trackingFormName })=>{
    const options = entry.fields.options.map((option)=>({
            label: option,
            value: option
        }));
    const company = (0, $bcbvQ.default).getCurrentCompany();
    const companyName = company?.name || "Ditt selskap";
    const [answer, setAnswer] = (0, $dvPqk.useState)(options[0].value);
    const [hasAnswered, setHasAnswered] = (0, $dvPqk.useState)(false);
    const storeAnswer = (e)=>{
        setAnswer(e.target.value);
        setHasAnswered(false);
    };
    const checkAnswer = ()=>{
        setHasAnswered(true);
    };
    const isSignedUp = (0, $i6TQx.default).isSignedUpTo(entry.fields.signUpCode);
    if ((0, $gyNqR.default)(entry.fields.validFrom) && (0, $epcVC.default)((0, $5UIm0.default)(entry.fields.validFrom))) return /*#__PURE__*/ (0, $7YWoO.jsx)($efa8fc477b00e481$var$NotAvailableYet, {
        date: entry.fields.validFrom
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                className: "text-xl",
                children: entry.fields.question
            }),
            isSignedUp || hasAnswered && answer === entry.fields.correctOption ? /*#__PURE__*/ (0, $7YWoO.jsx)($efa8fc477b00e481$var$CorrectAnswer, {
                answer: entry.fields.correctOption,
                signUpCode: entry.fields.signUpCode,
                slug: slug,
                companyName: companyName,
                trackingFormName: trackingFormName
            }) : /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4OT0V.RadioGroup), {
                        label: "Velg et alternativ:",
                        options: options,
                        onChange: storeAnswer,
                        className: "pb-2"
                    }),
                    hasAnswered && answer !== entry.fields.correctOption && /*#__PURE__*/ (0, $7YWoO.jsx)($efa8fc477b00e481$var$WrongAnswer, {}),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "flex flex-row justify-center",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                            variant: "secondary",
                            onClick: checkAnswer,
                            disabled: hasAnswered || isSignedUp,
                            children: "Sjekk svar"
                        })
                    })
                ]
            })
        ]
    });
};
var $efa8fc477b00e481$export$2e2bcd8739ae039 = (0, $gBcml.observer)($efa8fc477b00e481$var$ContestForm);

});
parcelRegister("4OT0V", function(module, exports) {

$parcel$export(module.exports, "RadioGroup", function () { return $38268193dcb81351$export$a98f0dcb43a68a25; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $lDdsZ = parcelRequire("lDdsZ");
function $38268193dcb81351$export$a98f0dcb43a68a25({ className: f, label: n, onChange: h = ()=>null, options: i, value: t, initialValue: b, horizontal: m = !1, name: c }) {
    const [v, x] = (0, $dvPqk.useState)(b ?? i[0].value), u = t !== void 0, o = u ? t : v;
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: f,
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $lDdsZ.RadioGroup), {
            name: c,
            onChange: (e)=>{
                u || x(e), h({
                    target: {
                        value: e,
                        name: c,
                        type: "radio",
                        checked: !0
                    }
                });
            },
            value: o,
            children: [
                n ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lDdsZ.RadioGroup).Label, {
                    className: "font-bold",
                    children: n
                }) : null,
                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                    className: (0, $6sMuH.cn)("mt-4 flex flex-col gap-y-3", m && "flex-row gap-x-4 flex-wrap"),
                    children: i.map((e)=>/* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lDdsZ.RadioGroup).Option, {
                                    className: (0, $6sMuH.cn)("flex items-center", e.disabled ? "cursor-not-allowed" : "cursor-pointer"),
                                    disabled: e.disabled,
                                    value: e.value,
                                    children: ({ checked: d })=>/* @__PURE__ */ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                                            children: [
                                                /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    className: (0, $6sMuH.cn)("flex items-center justify-center h-6 w-6 rounded-full mr-2 relative shrink-0 border-2", d ? "border-surface-action" : "border-ink-default", e.disabled ? "bg-surface-disabled border-ink-disabled" : "bg-surface-default hover:bg-surface-default-hover"),
                                                    children: d ? /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                                        className: (0, $6sMuH.cn)("block h-3.5 w-3.5 rounded-full", e.disabled ? "bg-ink-disabled" : "bg-surface-action")
                                                    }) : null
                                                }),
                                                /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lDdsZ.RadioGroup).Label, {
                                                    as: "span",
                                                    className: (0, $6sMuH.cn)("font-sans font-normal text-base leading-6 flex-1", e.disabled ? "text-ink-disabled cursor-not-allowed" : "text-ink-default cursor-pointer"),
                                                    children: e.label
                                                })
                                            ]
                                        })
                                }),
                                o === e.value && e.children ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    className: "mt-2",
                                    children: e.children
                                }) : null
                            ]
                        }, e.value))
                })
            ]
        })
    });
}
$38268193dcb81351$export$a98f0dcb43a68a25.displayName = "RadioGroup";

});
parcelRegister("lDdsZ", function(module, exports) {

$parcel$export(module.exports, "RadioGroup", function () { return $fbf7afa7b9d0b1be$export$a98f0dcb43a68a25; });

var $dvPqk = parcelRequire("dvPqk");

var $gfl5j = parcelRequire("gfl5j");

var $iJZQ7 = parcelRequire("iJZQ7");

var $jzfk4 = parcelRequire("jzfk4");

var $2ATfN = parcelRequire("2ATfN");

var $gps2w = parcelRequire("gps2w");

var $eqquT = parcelRequire("eqquT");

var $f7O15 = parcelRequire("f7O15");

var $9O4MK = parcelRequire("9O4MK");

var $ld2X6 = parcelRequire("ld2X6");

var $8CvXL = parcelRequire("8CvXL");

var $hvflL = parcelRequire("hvflL");

var $aFXmw = parcelRequire("aFXmw");

var $jQKuj = parcelRequire("jQKuj");

var $eRLkK = parcelRequire("eRLkK");

var $ae7L7 = parcelRequire("ae7L7");

var $bnLGb = parcelRequire("bnLGb");

var $1w8VW = parcelRequire("1w8VW");

var $kotPE = parcelRequire("kotPE");

var $b3KIl = parcelRequire("b3KIl");
var $fbf7afa7b9d0b1be$var$we = ((r)=>(r[r.RegisterOption = 0] = "RegisterOption", r[r.UnregisterOption = 1] = "UnregisterOption", r))($fbf7afa7b9d0b1be$var$we || {});
let $fbf7afa7b9d0b1be$var$Oe = {
    0 (r, t) {
        let o = [
            ...r.options,
            {
                id: t.id,
                element: t.element,
                propsRef: t.propsRef
            }
        ];
        return {
            ...r,
            options: (0, $ae7L7.sortByDomNode)(o, (d)=>d.element.current)
        };
    },
    1 (r, t) {
        let o = r.options.slice(), d = r.options.findIndex((c)=>c.id === t.id);
        return d === -1 ? r : (o.splice(d, 1), {
            ...r,
            options: o
        });
    }
}, $fbf7afa7b9d0b1be$var$H = (0, $dvPqk.createContext)(null);
$fbf7afa7b9d0b1be$var$H.displayName = "RadioGroupDataContext";
function $fbf7afa7b9d0b1be$var$te(r) {
    let t = (0, $dvPqk.useContext)($fbf7afa7b9d0b1be$var$H);
    if (t === null) {
        let o = new Error(`<${r} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $fbf7afa7b9d0b1be$var$te), o;
    }
    return t;
}
let $fbf7afa7b9d0b1be$var$K = (0, $dvPqk.createContext)(null);
$fbf7afa7b9d0b1be$var$K.displayName = "RadioGroupActionsContext";
function $fbf7afa7b9d0b1be$var$oe(r) {
    let t = (0, $dvPqk.useContext)($fbf7afa7b9d0b1be$var$K);
    if (t === null) {
        let o = new Error(`<${r} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $fbf7afa7b9d0b1be$var$oe), o;
    }
    return t;
}
function $fbf7afa7b9d0b1be$var$Ce(r, t) {
    return (0, $1w8VW.match)(t.type, $fbf7afa7b9d0b1be$var$Oe, r, t);
}
let $fbf7afa7b9d0b1be$var$De = "div";
function $fbf7afa7b9d0b1be$var$Ge(r, t) {
    let o = (0, $9O4MK.useId)(), { id: d = `headlessui-radiogroup-${o}`, value: c, defaultValue: f, form: A, name: I, onChange: h, by: T = (e, n)=>e === n, disabled: y = !1, ...W } = r, v = (0, $eqquT.useEvent)(typeof T == "string" ? (e, n)=>{
        let i = T;
        return (e == null ? void 0 : e[i]) === (n == null ? void 0 : n[i]);
    } : T), [w, O] = (0, $dvPqk.useReducer)($fbf7afa7b9d0b1be$var$Ce, {
        options: []
    }), l = w.options, [L, P] = (0, $jzfk4.useLabels)(), [b, C] = (0, $gfl5j.useDescriptions)(), D = (0, $dvPqk.useRef)(null), M = (0, $hvflL.useSyncRefs)(D, t), [s, x] = (0, $2ATfN.useControllable)(c, h, f), u = (0, $dvPqk.useMemo)(()=>l.find((e)=>!e.propsRef.current.disabled), [
        l
    ]), R = (0, $dvPqk.useMemo)(()=>l.some((e)=>v(e.propsRef.current.value, s)), [
        l,
        s
    ]), p = (0, $eqquT.useEvent)((e)=>{
        var n;
        if (y || v(e, s)) return !1;
        let i = (n = l.find((g)=>v(g.propsRef.current.value, e))) == null ? void 0 : n.propsRef.current;
        return i != null && i.disabled ? !1 : (x == null || x(e), !0);
    });
    (0, $aFXmw.useTreeWalker)({
        container: D.current,
        accept (e) {
            return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (e) {
            e.setAttribute("role", "none");
        }
    });
    let _ = (0, $eqquT.useEvent)((e)=>{
        let n = D.current;
        if (!n) return;
        let i = (0, $kotPE.getOwnerDocument)(n), g = l.filter((a)=>a.propsRef.current.disabled === !1).map((a)=>a.element.current);
        switch(e.key){
            case (0, $iJZQ7.Keys).Enter:
                (0, $bnLGb.attemptSubmit)(e.currentTarget);
                break;
            case (0, $iJZQ7.Keys).ArrowLeft:
            case (0, $iJZQ7.Keys).ArrowUp:
                if (e.preventDefault(), e.stopPropagation(), (0, $ae7L7.focusIn)(g, (0, $ae7L7.Focus).Previous | (0, $ae7L7.Focus).WrapAround) === (0, $ae7L7.FocusResult).Success) {
                    let a = l.find((G)=>G.element.current === (i == null ? void 0 : i.activeElement));
                    a && p(a.propsRef.current.value);
                }
                break;
            case (0, $iJZQ7.Keys).ArrowRight:
            case (0, $iJZQ7.Keys).ArrowDown:
                if (e.preventDefault(), e.stopPropagation(), (0, $ae7L7.focusIn)(g, (0, $ae7L7.Focus).Next | (0, $ae7L7.Focus).WrapAround) === (0, $ae7L7.FocusResult).Success) {
                    let a = l.find((G)=>G.element.current === (i == null ? void 0 : i.activeElement));
                    a && p(a.propsRef.current.value);
                }
                break;
            case (0, $iJZQ7.Keys).Space:
                {
                    e.preventDefault(), e.stopPropagation();
                    let a = l.find((G)=>G.element.current === (i == null ? void 0 : i.activeElement));
                    a && p(a.propsRef.current.value);
                }
                break;
        }
    }), m = (0, $eqquT.useEvent)((e)=>(O({
            type: 0,
            ...e
        }), ()=>O({
                type: 1,
                id: e.id
            }))), S = (0, $dvPqk.useMemo)(()=>({
            value: s,
            firstOption: u,
            containsCheckedOption: R,
            disabled: y,
            compare: v,
            ...w
        }), [
        s,
        u,
        R,
        y,
        v,
        w
    ]), ae = (0, $dvPqk.useMemo)(()=>({
            registerOption: m,
            change: p
        }), [
        m,
        p
    ]), ie = {
        ref: M,
        id: d,
        role: "radiogroup",
        "aria-labelledby": L,
        "aria-describedby": b,
        onKeyDown: _
    }, ne = (0, $dvPqk.useMemo)(()=>({
            value: s
        }), [
        s
    ]), N = (0, $dvPqk.useRef)(null), le = (0, $gps2w.useDisposables)();
    return (0, $dvPqk.useEffect)(()=>{
        N.current && f !== void 0 && le.addEventListener(N.current, "reset", ()=>{
            p(f);
        });
    }, [
        N,
        p
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(C, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(P, {
        name: "RadioGroup.Label"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($fbf7afa7b9d0b1be$var$K.Provider, {
        value: ae
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($fbf7afa7b9d0b1be$var$H.Provider, {
        value: S
    }, I != null && s != null && (0, $bnLGb.objectToFormEntries)({
        [I]: s
    }).map(([e, n], i)=>(0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $jQKuj.Hidden), {
            features: (0, $jQKuj.Features).Hidden,
            ref: i === 0 ? (g)=>{
                var a;
                N.current = (a = g == null ? void 0 : g.closest("form")) != null ? a : null;
            } : void 0,
            ...(0, $b3KIl.compact)({
                key: e,
                as: "input",
                type: "radio",
                checked: n != null,
                hidden: !0,
                readOnly: !0,
                form: A,
                disabled: y,
                name: e,
                value: n
            })
        })), (0, $b3KIl.render)({
        ourProps: ie,
        theirProps: W,
        slot: ne,
        defaultTag: $fbf7afa7b9d0b1be$var$De,
        name: "RadioGroup"
    })))));
}
var $fbf7afa7b9d0b1be$var$Ae = ((r)=>(r[r.Empty = 1] = "Empty", r[r.Active = 2] = "Active", r))($fbf7afa7b9d0b1be$var$Ae || {});
let $fbf7afa7b9d0b1be$var$Ie = "div";
function $fbf7afa7b9d0b1be$var$Le(r, t) {
    var o;
    let d = (0, $9O4MK.useId)(), { id: c = `headlessui-radiogroup-option-${d}`, value: f, disabled: A = !1, ...I } = r, h = (0, $dvPqk.useRef)(null), T = (0, $hvflL.useSyncRefs)(h, t), [y, W] = (0, $jzfk4.useLabels)(), [v, w] = (0, $gfl5j.useDescriptions)(), { addFlag: O, removeFlag: l, hasFlag: L } = (0, $f7O15.useFlags)(1), P = (0, $8CvXL.useLatestValue)({
        value: f,
        disabled: A
    }), b = $fbf7afa7b9d0b1be$var$te("RadioGroup.Option"), C = $fbf7afa7b9d0b1be$var$oe("RadioGroup.Option");
    (0, $ld2X6.useIsoMorphicEffect)(()=>C.registerOption({
            id: c,
            element: h,
            propsRef: P
        }), [
        c,
        C,
        h,
        P
    ]);
    let D = (0, $eqquT.useEvent)((m)=>{
        var S;
        if ((0, $eRLkK.isDisabledReactIssue7711)(m.currentTarget)) return m.preventDefault();
        C.change(f) && (O(2), (S = h.current) == null || S.focus());
    }), M = (0, $eqquT.useEvent)((m)=>{
        if ((0, $eRLkK.isDisabledReactIssue7711)(m.currentTarget)) return m.preventDefault();
        O(2);
    }), s = (0, $eqquT.useEvent)(()=>l(2)), x = ((o = b.firstOption) == null ? void 0 : o.id) === c, u = b.disabled || A, R = b.compare(b.value, f), p = {
        ref: T,
        id: c,
        role: "radio",
        "aria-checked": R ? "true" : "false",
        "aria-labelledby": y,
        "aria-describedby": v,
        "aria-disabled": u ? !0 : void 0,
        tabIndex: u ? -1 : R || !b.containsCheckedOption && x ? 0 : -1,
        onClick: u ? void 0 : D,
        onFocus: u ? void 0 : M,
        onBlur: u ? void 0 : s
    }, _ = (0, $dvPqk.useMemo)(()=>({
            checked: R,
            disabled: u,
            active: L(2)
        }), [
        R,
        u,
        L
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(w, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(W, {
        name: "RadioGroup.Label"
    }, (0, $b3KIl.render)({
        ourProps: p,
        theirProps: I,
        slot: _,
        defaultTag: $fbf7afa7b9d0b1be$var$Ie,
        name: "RadioGroup.Option"
    })));
}
let $fbf7afa7b9d0b1be$var$Pe = (0, $b3KIl.forwardRefWithAs)($fbf7afa7b9d0b1be$var$Ge), $fbf7afa7b9d0b1be$var$xe = (0, $b3KIl.forwardRefWithAs)($fbf7afa7b9d0b1be$var$Le), $fbf7afa7b9d0b1be$export$a98f0dcb43a68a25 = Object.assign($fbf7afa7b9d0b1be$var$Pe, {
    Option: $fbf7afa7b9d0b1be$var$xe,
    Label: (0, $jzfk4.Label),
    Description: (0, $gfl5j.Description)
});

});
parcelRegister("gfl5j", function(module, exports) {

$parcel$export(module.exports, "useDescriptions", function () { return $bd3e6707e4fcd372$export$babde88292020af7; });
$parcel$export(module.exports, "Description", function () { return $bd3e6707e4fcd372$export$393edc798c47379d; });

var $dvPqk = parcelRequire("dvPqk");

var $eqquT = parcelRequire("eqquT");

var $9O4MK = parcelRequire("9O4MK");

var $ld2X6 = parcelRequire("ld2X6");

var $hvflL = parcelRequire("hvflL");

var $b3KIl = parcelRequire("b3KIl");
let $bd3e6707e4fcd372$var$u = (0, $dvPqk.createContext)(null);
function $bd3e6707e4fcd372$var$c() {
    let o = (0, $dvPqk.useContext)($bd3e6707e4fcd372$var$u);
    if (o === null) {
        let r = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(r, $bd3e6707e4fcd372$var$c), r;
    }
    return o;
}
function $bd3e6707e4fcd372$export$babde88292020af7() {
    let [o, r] = (0, $dvPqk.useState)([]);
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $dvPqk.useMemo)(()=>function(e) {
                let s = (0, $eqquT.useEvent)((t)=>(r((n)=>[
                            ...n,
                            t
                        ]), ()=>r((n)=>{
                            let i = n.slice(), l = i.indexOf(t);
                            return l !== -1 && i.splice(l, 1), i;
                        }))), a = (0, $dvPqk.useMemo)(()=>({
                        register: s,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    s,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($bd3e6707e4fcd372$var$u.Provider, {
                    value: a
                }, e.children);
            }, [
            r
        ])
    ];
}
let $bd3e6707e4fcd372$var$C = "p";
function $bd3e6707e4fcd372$var$D(o, r) {
    let e = (0, $9O4MK.useId)(), { id: s = `headlessui-description-${e}`, ...a } = o, t = $bd3e6707e4fcd372$var$c(), n = (0, $hvflL.useSyncRefs)(r);
    (0, $ld2X6.useIsoMorphicEffect)(()=>t.register(s), [
        s,
        t.register
    ]);
    let i = {
        ref: n,
        ...t.props,
        id: s
    };
    return (0, $b3KIl.render)({
        ourProps: i,
        theirProps: a,
        slot: t.slot || {},
        defaultTag: $bd3e6707e4fcd372$var$C,
        name: t.name || "Description"
    });
}
let $bd3e6707e4fcd372$var$I = (0, $b3KIl.forwardRefWithAs)($bd3e6707e4fcd372$var$D), $bd3e6707e4fcd372$export$393edc798c47379d = Object.assign($bd3e6707e4fcd372$var$I, {});

});
parcelRegister("eqquT", function(module, exports) {

$parcel$export(module.exports, "useEvent", function () { return $a8080c36aaa9e8c2$export$90fc3a17d93f704c; });

var $dvPqk = parcelRequire("dvPqk");

var $8CvXL = parcelRequire("8CvXL");
let $a8080c36aaa9e8c2$export$90fc3a17d93f704c = function(t) {
    let e = (0, $8CvXL.useLatestValue)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};

});
parcelRegister("8CvXL", function(module, exports) {

$parcel$export(module.exports, "useLatestValue", function () { return $646aaa7f950324f3$export$86c4283a11f23f95; });

var $dvPqk = parcelRequire("dvPqk");

var $ld2X6 = parcelRequire("ld2X6");
function $646aaa7f950324f3$export$86c4283a11f23f95(r) {
    let t = (0, $dvPqk.useRef)(r);
    return (0, $ld2X6.useIsoMorphicEffect)(()=>{
        t.current = r;
    }, [
        r
    ]), t;
}

});
parcelRegister("ld2X6", function(module, exports) {

$parcel$export(module.exports, "useIsoMorphicEffect", function () { return $f70d1a2256868d23$export$ce5ed857c741fd71; });

var $dvPqk = parcelRequire("dvPqk");

var $dWhVx = parcelRequire("dWhVx");
let $f70d1a2256868d23$export$ce5ed857c741fd71 = (e, o)=>{
    (0, $dWhVx.env).isServer ? (0, $dvPqk.useEffect)(e, o) : (0, $dvPqk.useLayoutEffect)(e, o);
};

});
parcelRegister("dWhVx", function(module, exports) {

$parcel$export(module.exports, "env", function () { return $a25e99113f0ea0c5$export$a7b6bc01c63cdfc3; });
var $a25e99113f0ea0c5$var$i = Object.defineProperty, $a25e99113f0ea0c5$var$s = (t, e, r)=>e in t ? $a25e99113f0ea0c5$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $a25e99113f0ea0c5$var$n = (t, e, r)=>($a25e99113f0ea0c5$var$s(t, typeof e != "symbol" ? e + "" : e, r), r);
class $a25e99113f0ea0c5$var$d {
    constructor(){
        $a25e99113f0ea0c5$var$n(this, "current", this.detect()), $a25e99113f0ea0c5$var$n(this, "handoffState", "pending"), $a25e99113f0ea0c5$var$n(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window > "u" || typeof document > "u" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $a25e99113f0ea0c5$export$a7b6bc01c63cdfc3 = new $a25e99113f0ea0c5$var$d();

});




parcelRegister("9O4MK", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $723c7ed36113f521$export$f680877a34711e37; });

var $dvPqk = parcelRequire("dvPqk");

var $dWhVx = parcelRequire("dWhVx");

var $ld2X6 = parcelRequire("ld2X6");

var $fFyW3 = parcelRequire("fFyW3");
var $723c7ed36113f521$var$r;
let $723c7ed36113f521$export$f680877a34711e37 = ($723c7ed36113f521$var$r = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).useId) != null ? $723c7ed36113f521$var$r : function() {
    let l = (0, $fFyW3.useServerHandoffComplete)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).useState(l ? ()=>(0, $dWhVx.env).nextId() : null);
    return (0, $ld2X6.useIsoMorphicEffect)(()=>{
        e === null && u((0, $dWhVx.env).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};

});
parcelRegister("fFyW3", function(module, exports) {

$parcel$export(module.exports, "useServerHandoffComplete", function () { return $b685c8cd070fc401$export$44ab2b9f2d09b0fa; });

var $dvPqk = parcelRequire("dvPqk");

var $dWhVx = parcelRequire("dWhVx");
function $b685c8cd070fc401$var$r() {
    let n = typeof document > "u";
    return "useSyncExternalStore" in $dvPqk ? ((e)=>e.useSyncExternalStore)($dvPqk)(()=>()=>{}, ()=>!1, ()=>!n) : !1;
}
function $b685c8cd070fc401$export$44ab2b9f2d09b0fa() {
    let n = $b685c8cd070fc401$var$r(), [e, o] = $dvPqk.useState((0, $dWhVx.env).isHandoffComplete);
    return e && (0, $dWhVx.env).isHandoffComplete === !1 && o(!1), $dvPqk.useEffect(()=>{
        e !== !0 && o(!0);
    }, [
        e
    ]), $dvPqk.useEffect(()=>(0, $dWhVx.env).handoff(), []), n ? !1 : e;
}

});


parcelRegister("hvflL", function(module, exports) {

$parcel$export(module.exports, "optionalRef", function () { return $cbe13d20d94678a3$export$7029785b750eb74; });
$parcel$export(module.exports, "useSyncRefs", function () { return $cbe13d20d94678a3$export$f6a25a78204acc7e; });

var $dvPqk = parcelRequire("dvPqk");

var $eqquT = parcelRequire("eqquT");
let $cbe13d20d94678a3$var$t = Symbol();
function $cbe13d20d94678a3$export$7029785b750eb74(e, o = !0) {
    return Object.assign(e, {
        [$cbe13d20d94678a3$var$t]: o
    });
}
function $cbe13d20d94678a3$export$f6a25a78204acc7e(...e) {
    let o = (0, $dvPqk.useRef)(e);
    (0, $dvPqk.useEffect)(()=>{
        o.current = e;
    }, [
        e
    ]);
    let u = (0, $eqquT.useEvent)((n)=>{
        for (let r of o.current)r != null && (typeof r == "function" ? r(n) : r.current = n);
    });
    return e.every((n)=>n == null || (n == null ? void 0 : n[$cbe13d20d94678a3$var$t])) ? void 0 : u;
}

});

parcelRegister("b3KIl", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return $80d435feee903a2c$export$617d79dae526d2cf; });
$parcel$export(module.exports, "RenderStrategy", function () { return $80d435feee903a2c$export$80c0a745e59f7989; });
$parcel$export(module.exports, "render", function () { return $80d435feee903a2c$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "compact", function () { return $80d435feee903a2c$export$8e16b83750b44988; });
$parcel$export(module.exports, "useMergeRefsFn", function () { return $80d435feee903a2c$export$81218df071161f0a; });
$parcel$export(module.exports, "forwardRefWithAs", function () { return $80d435feee903a2c$export$e43f39796049410c; });

var $dvPqk = parcelRequire("dvPqk");

var $9I7vs = parcelRequire("9I7vs");

var $1w8VW = parcelRequire("1w8VW");
var $80d435feee903a2c$export$617d79dae526d2cf = ((e)=>(e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))($80d435feee903a2c$export$617d79dae526d2cf || {}), $80d435feee903a2c$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($80d435feee903a2c$export$80c0a745e59f7989 || {});
function $80d435feee903a2c$export$b3890eb0ae9dca99({ ourProps: e, theirProps: n, slot: t, defaultTag: r, features: a, visible: f = !0, name: i, mergeRefs: l }) {
    l = l ?? $80d435feee903a2c$var$T;
    let s = $80d435feee903a2c$var$j(n, e);
    if (f) return $80d435feee903a2c$var$g(s, t, r, i, l);
    let m = a ?? 0;
    if (m & 2) {
        let { static: o = !1, ...d } = s;
        if (o) return $80d435feee903a2c$var$g(d, t, r, i, l);
    }
    if (m & 1) {
        let { unmount: o = !0, ...d } = s;
        return (0, $1w8VW.match)(o ? 0 : 1, {
            0 () {
                return null;
            },
            1 () {
                return $80d435feee903a2c$var$g({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, t, r, i, l);
            }
        });
    }
    return $80d435feee903a2c$var$g(s, t, r, i, l);
}
function $80d435feee903a2c$var$g(e, n = {}, t, r, a) {
    let { as: f = t, children: i, refName: l = "ref", ...s } = $80d435feee903a2c$var$v(e, [
        "unmount",
        "static"
    ]), m = e.ref !== void 0 ? {
        [l]: e.ref
    } : {}, o = typeof i == "function" ? i(n) : i;
    "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(n));
    let d = {};
    if (n) {
        let u = !1, p = [];
        for (let [h, c] of Object.entries(n))typeof c == "boolean" && (u = !0), c === !0 && p.push(h);
        u && (d["data-headlessui-state"] = p.join(" "));
    }
    if (f === (0, $dvPqk.Fragment) && Object.keys($80d435feee903a2c$export$8e16b83750b44988(s)).length > 0) {
        if (!(0, $dvPqk.isValidElement)(o) || Array.isArray(o) && o.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${r} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((c)=>`  - ${c}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((c)=>`  - ${c}`).join(`
`)
        ].join(`
`));
        let u = o.props, p = typeof (u == null ? void 0 : u.className) == "function" ? (...c)=>(0, $9I7vs.classNames)(u == null ? void 0 : u.className(...c), s.className) : (0, $9I7vs.classNames)(u == null ? void 0 : u.className, s.className), h = p ? {
            className: p
        } : {};
        return (0, $dvPqk.cloneElement)(o, Object.assign({}, $80d435feee903a2c$var$j(o.props, $80d435feee903a2c$export$8e16b83750b44988($80d435feee903a2c$var$v(s, [
            "ref"
        ]))), d, m, {
            ref: a(o.ref, m.ref)
        }, h));
    }
    return (0, $dvPqk.createElement)(f, Object.assign({}, $80d435feee903a2c$var$v(s, [
        "ref"
    ]), f !== (0, $dvPqk.Fragment) && m, f !== (0, $dvPqk.Fragment) && d), o);
}
function $80d435feee903a2c$export$81218df071161f0a() {
    let e = (0, $dvPqk.useRef)([]), n = (0, $dvPqk.useCallback)((t)=>{
        for (let r of e.current)r != null && (typeof r == "function" ? r(t) : r.current = t);
    }, []);
    return (...t)=>{
        if (!t.every((r)=>r == null)) return e.current = t, n;
    };
}
function $80d435feee903a2c$var$T(...e) {
    return e.every((n)=>n == null) ? void 0 : (n)=>{
        for (let t of e)t != null && (typeof t == "function" ? t(n) : t.current = n);
    };
}
function $80d435feee903a2c$var$j(...e) {
    if (e.length === 0) return {};
    if (e.length === 1) return e[0];
    let n = {}, t = {};
    for (let r of e)for(let a in r)a.startsWith("on") && typeof r[a] == "function" ? (t[a] != null || (t[a] = []), t[a].push(r[a])) : n[a] = r[a];
    if (n.disabled || n["aria-disabled"]) return Object.assign(n, Object.fromEntries(Object.keys(t).map((r)=>[
            r,
            void 0
        ])));
    for(let r in t)Object.assign(n, {
        [r] (a, ...f) {
            let i = t[r];
            for (let l of i){
                if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
                l(a, ...f);
            }
        }
    });
    return n;
}
function $80d435feee903a2c$export$e43f39796049410c(e) {
    var n;
    return Object.assign((0, $dvPqk.forwardRef)(e), {
        displayName: (n = e.displayName) != null ? n : e.name
    });
}
function $80d435feee903a2c$export$8e16b83750b44988(e) {
    let n = Object.assign({}, e);
    for(let t in n)n[t] === void 0 && delete n[t];
    return n;
}
function $80d435feee903a2c$var$v(e, n = []) {
    let t = Object.assign({}, e);
    for (let r of n)r in t && delete t[r];
    return t;
}

});
parcelRegister("9I7vs", function(module, exports) {

$parcel$export(module.exports, "classNames", function () { return $711e0bbac2c7e05d$export$ce4ab0c55987d1ff; });
function $711e0bbac2c7e05d$export$ce4ab0c55987d1ff(...e) {
    return Array.from(new Set(e.flatMap((t)=>typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}

});

parcelRegister("1w8VW", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $11afb5a3bac24ab1$export$4659b591c19bdf3d; });
function $11afb5a3bac24ab1$export$4659b591c19bdf3d(r, t, ...n) {
    if (r in t) {
        let e = t[r];
        return typeof e == "function" ? e(...n) : e;
    }
    let a = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(a, $11afb5a3bac24ab1$export$4659b591c19bdf3d), a;
}

});



parcelRegister("iJZQ7", function(module, exports) {

$parcel$export(module.exports, "Keys", function () { return $da4c6608f2ccd6c9$export$4b0075e5ea5e1f26; });
var $da4c6608f2ccd6c9$export$4b0075e5ea5e1f26 = ((e)=>(e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))($da4c6608f2ccd6c9$export$4b0075e5ea5e1f26 || {});

});

parcelRegister("jzfk4", function(module, exports) {

$parcel$export(module.exports, "useLabels", function () { return $e3ed2bf9d2c30df2$export$d6875122194c7b44; });
$parcel$export(module.exports, "Label", function () { return $e3ed2bf9d2c30df2$export$b04be29aa201d4f5; });

var $dvPqk = parcelRequire("dvPqk");

var $eqquT = parcelRequire("eqquT");

var $9O4MK = parcelRequire("9O4MK");

var $ld2X6 = parcelRequire("ld2X6");

var $hvflL = parcelRequire("hvflL");

var $b3KIl = parcelRequire("b3KIl");
let $e3ed2bf9d2c30df2$var$p = (0, $dvPqk.createContext)(null);
function $e3ed2bf9d2c30df2$var$c() {
    let o = (0, $dvPqk.useContext)($e3ed2bf9d2c30df2$var$p);
    if (o === null) {
        let r = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(r, $e3ed2bf9d2c30df2$var$c), r;
    }
    return o;
}
function $e3ed2bf9d2c30df2$export$d6875122194c7b44() {
    let [o, r] = (0, $dvPqk.useState)([]);
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $dvPqk.useMemo)(()=>function(e) {
                let s = (0, $eqquT.useEvent)((n)=>(r((t)=>[
                            ...t,
                            n
                        ]), ()=>r((t)=>{
                            let a = t.slice(), l = a.indexOf(n);
                            return l !== -1 && a.splice(l, 1), a;
                        }))), i = (0, $dvPqk.useMemo)(()=>({
                        register: s,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    s,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($e3ed2bf9d2c30df2$var$p.Provider, {
                    value: i
                }, e.children);
            }, [
            r
        ])
    ];
}
let $e3ed2bf9d2c30df2$var$x = "label";
function $e3ed2bf9d2c30df2$var$L(o, r) {
    let e = (0, $9O4MK.useId)(), { id: s = `headlessui-label-${e}`, passive: i = !1, ...n } = o, t = $e3ed2bf9d2c30df2$var$c(), a = (0, $hvflL.useSyncRefs)(r);
    (0, $ld2X6.useIsoMorphicEffect)(()=>t.register(s), [
        s,
        t.register
    ]);
    let l = {
        ref: a,
        ...t.props,
        id: s
    };
    return i && ("onClick" in l && (delete l.htmlFor, delete l.onClick), "onClick" in n && delete n.onClick), (0, $b3KIl.render)({
        ourProps: l,
        theirProps: n,
        slot: t.slot || {},
        defaultTag: $e3ed2bf9d2c30df2$var$x,
        name: t.name || "Label"
    });
}
let $e3ed2bf9d2c30df2$var$S = (0, $b3KIl.forwardRefWithAs)($e3ed2bf9d2c30df2$var$L), $e3ed2bf9d2c30df2$export$b04be29aa201d4f5 = Object.assign($e3ed2bf9d2c30df2$var$S, {});

});

parcelRegister("2ATfN", function(module, exports) {

$parcel$export(module.exports, "useControllable", function () { return $1e39cdd172efbabb$export$454217e89aea72b; });

var $dvPqk = parcelRequire("dvPqk");

var $eqquT = parcelRequire("eqquT");
function $1e39cdd172efbabb$export$454217e89aea72b(r, t, a) {
    let [i, d] = (0, $dvPqk.useState)(a), e = r !== void 0, n = (0, $dvPqk.useRef)(e), u = (0, $dvPqk.useRef)(!1), c = (0, $dvPqk.useRef)(!1);
    return e && !n.current && !u.current ? (u.current = !0, n.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && n.current && !c.current && (c.current = !0, n.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? r : i,
        (0, $eqquT.useEvent)((l)=>(e || d(l), t == null ? void 0 : t(l)))
    ];
}

});

parcelRegister("gps2w", function(module, exports) {

$parcel$export(module.exports, "useDisposables", function () { return $bf24bb407119a1bf$export$fd183955ff4b45d9; });

var $dvPqk = parcelRequire("dvPqk");

var $bVyso = parcelRequire("bVyso");
function $bf24bb407119a1bf$export$fd183955ff4b45d9() {
    let [s] = (0, $dvPqk.useState)((0, $bVyso.disposables));
    return (0, $dvPqk.useEffect)(()=>()=>s.dispose(), [
        s
    ]), s;
}

});
parcelRegister("bVyso", function(module, exports) {

$parcel$export(module.exports, "disposables", function () { return $8aefbf0770a173b9$export$12b26c28a05aa001; });

var $9vMZh = parcelRequire("9vMZh");
function $8aefbf0770a173b9$export$12b26c28a05aa001() {
    let s = [], r = {
        addEventListener (e, t, n, i) {
            return e.addEventListener(t, n, i), r.add(()=>e.removeEventListener(t, n, i));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $9vMZh.microTask)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, n) {
            let i = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: n
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: i
                });
            });
        },
        group (e) {
            let t = $8aefbf0770a173b9$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return s.push(e), ()=>{
                let t = s.indexOf(e);
                if (t >= 0) for (let n of s.splice(t, 1))n();
            };
        },
        dispose () {
            for (let e of s.splice(0))e();
        }
    };
    return r;
}

});
parcelRegister("9vMZh", function(module, exports) {

$parcel$export(module.exports, "microTask", function () { return $6ecd0229a97622d9$export$a5ff0d6a738703ca; });
function $6ecd0229a97622d9$export$a5ff0d6a738703ca(t) {
    typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((e)=>setTimeout(()=>{
            throw e;
        }));
}

});



parcelRegister("f7O15", function(module, exports) {

$parcel$export(module.exports, "useFlags", function () { return $b02e4eaea8ad7fc2$export$2879604e6aec4ab; });

var $dvPqk = parcelRequire("dvPqk");

var $54Iyk = parcelRequire("54Iyk");
function $b02e4eaea8ad7fc2$export$2879604e6aec4ab(s = 0) {
    let [l, r] = (0, $dvPqk.useState)(s), a = (0, $54Iyk.useIsMounted)(), u = (0, $dvPqk.useCallback)((e)=>{
        a.current && r((t)=>t | e);
    }, [
        l,
        a
    ]), g = (0, $dvPqk.useCallback)((e)=>!!(l & e), [
        l
    ]), n = (0, $dvPqk.useCallback)((e)=>{
        a.current && r((t)=>t & ~e);
    }, [
        r,
        a
    ]), c = (0, $dvPqk.useCallback)((e)=>{
        a.current && r((t)=>t ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: u,
        hasFlag: g,
        removeFlag: n,
        toggleFlag: c
    };
}

});
parcelRegister("54Iyk", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", function () { return $3b1fe2b76aad4e6c$export$80c2a3957bcb42ea; });

var $dvPqk = parcelRequire("dvPqk");

var $ld2X6 = parcelRequire("ld2X6");
function $3b1fe2b76aad4e6c$export$80c2a3957bcb42ea() {
    let e = (0, $dvPqk.useRef)(!1);
    return (0, $ld2X6.useIsoMorphicEffect)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}

});


parcelRegister("aFXmw", function(module, exports) {

$parcel$export(module.exports, "useTreeWalker", function () { return $7c5bc7d5811ce394$export$b0abce39eb34b36; });

var $dvPqk = parcelRequire("dvPqk");

var $kotPE = parcelRequire("kotPE");

var $ld2X6 = parcelRequire("ld2X6");
function $7c5bc7d5811ce394$export$b0abce39eb34b36({ container: e, accept: r, walk: t, enabled: c = !0 }) {
    let o = (0, $dvPqk.useRef)(r), n = (0, $dvPqk.useRef)(t);
    (0, $dvPqk.useEffect)(()=>{
        o.current = r, n.current = t;
    }, [
        r,
        t
    ]), (0, $ld2X6.useIsoMorphicEffect)(()=>{
        if (!e || !c) return;
        let u = (0, $kotPE.getOwnerDocument)(e);
        if (!u) return;
        let f = o.current, l = n.current, s = Object.assign((p)=>f(p), {
            acceptNode: f
        }), a = u.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, s, !1);
        for(; a.nextNode();)l(a.currentNode);
    }, [
        e,
        c,
        o,
        n
    ]);
}

});
parcelRegister("kotPE", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", function () { return $ed8d3095803a95e7$export$b204af158042fbac; });

var $dWhVx = parcelRequire("dWhVx");
function $ed8d3095803a95e7$export$b204af158042fbac(e) {
    return (0, $dWhVx.env).isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}

});


parcelRegister("jQKuj", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return $e736ef288e524adf$export$617d79dae526d2cf; });
$parcel$export(module.exports, "Hidden", function () { return $e736ef288e524adf$export$8dc98ba7eadeaa56; });

var $b3KIl = parcelRequire("b3KIl");
let $e736ef288e524adf$var$s = "div";
var $e736ef288e524adf$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($e736ef288e524adf$export$617d79dae526d2cf || {});
function $e736ef288e524adf$var$p(e, a) {
    var i;
    let { features: d = 1, ...r } = e, n = {
        ref: a,
        "aria-hidden": (d & 2) === 2 ? !0 : (i = r["aria-hidden"]) != null ? i : void 0,
        hidden: (d & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(d & 4) === 4 && (d & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $b3KIl.render)({
        ourProps: n,
        theirProps: r,
        slot: {},
        defaultTag: $e736ef288e524adf$var$s,
        name: "Hidden"
    });
}
let $e736ef288e524adf$export$8dc98ba7eadeaa56 = (0, $b3KIl.forwardRefWithAs)($e736ef288e524adf$var$p);

});

parcelRegister("eRLkK", function(module, exports) {

$parcel$export(module.exports, "isDisabledReactIssue7711", function () { return $ad2abb663789135e$export$db61f031a278447c; });
function $ad2abb663789135e$export$db61f031a278447c(n) {
    let e = n.parentElement, t = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (t = e), e = e.parentElement;
    let l = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return l && $ad2abb663789135e$var$i(t) ? !1 : l;
}
function $ad2abb663789135e$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

});

parcelRegister("ae7L7", function(module, exports) {

$parcel$export(module.exports, "Focus", function () { return $77213af968a6de26$export$807a7eae502106e7; });
$parcel$export(module.exports, "FocusResult", function () { return $77213af968a6de26$export$abf286375dfa6dbd; });
$parcel$export(module.exports, "FocusableMode", function () { return $77213af968a6de26$export$27112a34f2f8402d; });
$parcel$export(module.exports, "isFocusableElement", function () { return $77213af968a6de26$export$ff1ec1c740b3c8d5; });
$parcel$export(module.exports, "focusElement", function () { return $77213af968a6de26$export$5fed9cc43865dc7e; });
$parcel$export(module.exports, "sortByDomNode", function () { return $77213af968a6de26$export$20305e96f91bf103; });
$parcel$export(module.exports, "focusIn", function () { return $77213af968a6de26$export$82e1f4f412218a1d; });

var $1w8VW = parcelRequire("1w8VW");

var $kotPE = parcelRequire("kotPE");
let $77213af968a6de26$var$d = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $77213af968a6de26$export$807a7eae502106e7 = ((e)=>(e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))($77213af968a6de26$export$807a7eae502106e7 || {}), $77213af968a6de26$export$abf286375dfa6dbd = ((e)=>(e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))($77213af968a6de26$export$abf286375dfa6dbd || {}), $77213af968a6de26$var$h = ((e)=>(e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))($77213af968a6de26$var$h || {});
function $77213af968a6de26$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($77213af968a6de26$var$d)).sort((t, r)=>Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $77213af968a6de26$export$27112a34f2f8402d = ((e)=>(e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))($77213af968a6de26$export$27112a34f2f8402d || {});
function $77213af968a6de26$export$ff1ec1c740b3c8d5(e, t = 0) {
    var r;
    return e === ((r = (0, $kotPE.getOwnerDocument)(e)) == null ? void 0 : r.body) ? !1 : (0, $1w8VW.match)(t, {
        0 () {
            return e.matches($77213af968a6de26$var$d);
        },
        1 () {
            let o = e;
            for(; o !== null;){
                if (o.matches($77213af968a6de26$var$d)) return !0;
                o = o.parentElement;
            }
            return !1;
        }
    });
}
var $77213af968a6de26$var$p = ((e)=>(e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))($77213af968a6de26$var$p || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $77213af968a6de26$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $77213af968a6de26$var$w = [
    "textarea",
    "input"
].join(",");
function $77213af968a6de26$var$O(e) {
    var t, r;
    return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, $77213af968a6de26$var$w)) != null ? r : !1;
}
function $77213af968a6de26$export$20305e96f91bf103(e, t = (r)=>r) {
    return e.slice().sort((r, o)=>{
        let l = t(r), i = t(o);
        if (l === null || i === null) return 0;
        let n = l.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $77213af968a6de26$export$82e1f4f412218a1d(e, t, { sorted: r = !0, relativeTo: o = null, skipElements: l = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? r ? $77213af968a6de26$export$20305e96f91bf103(e) : e : $77213af968a6de26$export$433aaa1f216cf32d(e);
    l.length > 0 && n.length > 1 && (n = n.filter((u)=>!l.includes(u))), o = o ?? i.activeElement;
    let m = (()=>{
        if (t & 5) return 1;
        if (t & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), f = (()=>{
        if (t & 1) return 0;
        if (t & 2) return Math.max(0, n.indexOf(o)) - 1;
        if (t & 4) return Math.max(0, n.indexOf(o)) + 1;
        if (t & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), E = t & 32 ? {
        preventScroll: !0
    } : {}, c = 0, a = n.length, s;
    do {
        if (c >= a || c + a <= 0) return 0;
        let u = f + c;
        if (t & 16) u = (u + a) % a;
        else {
            if (u < 0) return 3;
            if (u >= a) return 1;
        }
        s = n[u], s == null || s.focus(E), c += m;
    }while (s !== i.activeElement);
    return t & 6 && $77213af968a6de26$var$O(s) && s.select(), 2;
}

});

parcelRegister("bnLGb", function(module, exports) {

$parcel$export(module.exports, "objectToFormEntries", function () { return $8496d3d5c559c7da$export$bc22b3e852574dab; });
$parcel$export(module.exports, "attemptSubmit", function () { return $8496d3d5c559c7da$export$ee02894bdc79dd36; });
function $8496d3d5c559c7da$export$bc22b3e852574dab(n = {}, t = null, e = []) {
    for (let [o, r] of Object.entries(n))$8496d3d5c559c7da$var$l(e, $8496d3d5c559c7da$var$u(t, o), r);
    return e;
}
function $8496d3d5c559c7da$var$u(n, t) {
    return n ? n + "[" + t + "]" : t;
}
function $8496d3d5c559c7da$var$l(n, t, e) {
    if (Array.isArray(e)) for (let [o, r] of e.entries())$8496d3d5c559c7da$var$l(n, $8496d3d5c559c7da$var$u(t, o.toString()), r);
    else e instanceof Date ? n.push([
        t,
        e.toISOString()
    ]) : typeof e == "boolean" ? n.push([
        t,
        e ? "1" : "0"
    ]) : typeof e == "string" ? n.push([
        t,
        e
    ]) : typeof e == "number" ? n.push([
        t,
        `${e}`
    ]) : e == null ? n.push([
        t,
        ""
    ]) : $8496d3d5c559c7da$export$bc22b3e852574dab(e, t, n);
}
function $8496d3d5c559c7da$export$ee02894bdc79dd36(n) {
    var t, e;
    let o = (t = n == null ? void 0 : n.form) != null ? t : n.closest("form");
    if (o) {
        for (let r of o.elements)if (r !== n && (r.tagName === "INPUT" && r.type === "submit" || r.tagName === "BUTTON" && r.type === "submit" || r.nodeName === "INPUT" && r.type === "image")) {
            r.click();
            return;
        }
        (e = o.requestSubmit) == null || e.call(o);
    }
}

});



parcelRegister("195xf", function(module, exports) {

$parcel$export(module.exports, "getCaptureMappings", function () { return $a56348601d93a330$export$f14c18b3058c0d97; });
$parcel$export(module.exports, "dynamicsEndpoint", function () { return $a56348601d93a330$export$40f9e16d03b9f0fa; });
$parcel$export(module.exports, "scriptUrl", function () { return $a56348601d93a330$export$a5b7d6dd0c69eeb3; });
$parcel$export(module.exports, "getCaptureConfig", function () { return $a56348601d93a330$export$98fd37f51b127b25; });

var $8ZCSm = parcelRequire("8ZCSm");
const $a56348601d93a330$export$f14c18b3058c0d97 = (type)=>{
    if ([
        "slot",
        "main"
    ].includes(type)) return [
        {
            FormFieldName: "company",
            DataverseFieldName: "ava_parentaccountidstringvalue",
            label: "",
            hidden: true
        },
        {
            FormFieldName: "description",
            DataverseFieldName: type === "main" ? "subject" : "description",
            label: "",
            hidden: true
        },
        {
            FormFieldName: "firstname",
            DataverseFieldName: "firstname",
            label: "Fornavn",
            validation: "mandatory"
        },
        {
            FormFieldName: "lastname",
            DataverseFieldName: "lastname",
            label: "Etternavn",
            validation: "mandatory"
        },
        {
            FormFieldName: "email",
            DataverseFieldName: "emailaddress1",
            label: "E-post",
            validation: "email"
        }
    ];
    return [];
};
const $a56348601d93a330$var$isProd = (0, $8ZCSm.ENV_NAME) === "prod";
const $a56348601d93a330$var$dynamicsOrg = $a56348601d93a330$var$isProd ? "1e640fbe-4ea8-4ae5-a093-a84e6f604838" : "d266f74e-f7eb-43f2-8753-984c8a77eac6";
const $a56348601d93a330$export$40f9e16d03b9f0fa = `https://public-eur.mkt.dynamics.com/api/v1.0/orgs/${$a56348601d93a330$var$dynamicsOrg}/landingpageforms`;
const $a56348601d93a330$export$a5b7d6dd0c69eeb3 = "https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormCapture/FormCapture.bundle.js";
const $a56348601d93a330$export$98fd37f51b127b25 = (type)=>{
    return ({
        slot: {
            FormId: $a56348601d93a330$var$isProd ? "4c53cb58-1987-ef11-ac21-6045bddd37a5" : "84cc9f07-8f6e-ef11-a671-6045bd8f5d4f",
            FormApiUrl: $a56348601d93a330$export$40f9e16d03b9f0fa
        },
        main: {
            FormId: $a56348601d93a330$var$isProd ? "70637140-7659-ef11-bfe3-000d3ab0cc72" : "56486e50-9b5f-ef11-bfe3-000d3a273416",
            FormApiUrl: $a56348601d93a330$export$40f9e16d03b9f0fa
        }
    })[type];
};

});

parcelRegister("iVdQg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d015220cbbf0c914$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $7c65l = parcelRequire("7c65l");

var $3SASj = parcelRequire("3SASj");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");

var $j6ChH = parcelRequire("j6ChH");

var $gCpkF = parcelRequire("gCpkF");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $195xf = parcelRequire("195xf");

var $cLLe3 = parcelRequire("cLLe3");
const $d015220cbbf0c914$var$SignupForm = ({ values: values, mappings: mappings, buttonText: buttonText, config: config, disabled: disabled = false, buttonVariant: buttonVariant = "primary", trackingFormName: trackingFormName, children: children, onSignup: onSignup })=>{
    const initialValues = mappings.reduce((acc, mapping)=>{
        acc[mapping.FormFieldName] = values[mapping.FormFieldName] || "";
        return acc;
    }, {});
    const [currentValues, setCurrentValues] = (0, $dvPqk.useState)(initialValues);
    const [errors, setErrors] = (0, $dvPqk.useState)({});
    const [signingUp, setSigningUp] = (0, $dvPqk.useState)(false);
    const handleSignup = async (e)=>{
        if (signingUp) return;
        setSigningUp(true);
        e.preventDefault();
        const payload = {};
        for (const formElement of e.currentTarget.elements){
            if (formElement instanceof HTMLInputElement || formElement instanceof HTMLSelectElement || formElement instanceof HTMLTextAreaElement) {
                if (formElement.value) payload[formElement.name] = formElement.value;
            }
        }
        const form = e.currentTarget;
        let error;
        if (form) try {
            const serializedForm = window.d365mktformcapture.serializeForm(form, mappings);
            const dynamicsPayload = serializedForm.SerializedForm.build();
            await window.d365mktformcapture.submitForm(config, dynamicsPayload);
        } catch (err) {
            error = typeof err === "string" || err instanceof Error ? err : "D365 form capture submission error";
            (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(error, (e)=>{
                e.context = "Signup form capture";
                e.addMetadata("signup", {
                    payload: payload,
                    mappings: mappings
                });
            });
            (0, $gtsdT.logger).error("contentful", err);
        }
        if (error) {
            if (error instanceof Error) payload.d365Error = error.message;
            else if (typeof error === "string") payload.d365Error = error;
            else payload.d365Error = "D365 form capture failed";
        }
        if (onSignup) onSignup(payload);
        (0, $6fuyt.sendSignup)(trackingFormName);
        setSigningUp(false);
    };
    const validateValue = (validationType, value)=>{
        if (value.length > 50) return "Maksimalt 50 tegn er tillatt.";
        if (validationType !== "email") {
            const allowedChars = /^[a-zA-Z0-9æøåÆØÅäöüÄÖÜéèêÉÈÊçÇñÑ\s]*$/;
            if (!allowedChars.test(value)) return "Spesialtegn er ikke tillatt.";
        }
        return validationType === "email" && !(0, (/*@__PURE__*/$parcel$interopDefault($gCpkF)))(value) ? "Skriv inn gyldig e-postadresse." : validationType === "mandatory" && !value ? "Feltet m\xe5 fylles." : "";
    };
    const handleChange = (e)=>{
        const { value: value, name: name } = e.target;
        const values = {
            ...currentValues,
            [name]: value
        };
        setCurrentValues(values);
    };
    const handleBlur = (e)=>{
        const { value: value, name: name } = e.target;
        const mapping = mappings.find((mapping)=>mapping.FormFieldName === name);
        if (mapping?.validation) {
            const error = validateValue(mapping.validation, value);
            setErrors({
                ...errors,
                [name]: error
            });
        }
    };
    const buttonDisabled = (0, $dvPqk.useMemo)(()=>{
        return disabled || !mappings.every((mapping)=>{
            if (mapping.validation) return !validateValue(mapping.validation, currentValues[mapping.FormFieldName] || "");
            return true;
        });
    }, [
        disabled,
        mappings,
        currentValues
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j6ChH.Helmet), {
                children: !window.d365mktformcapture && /*#__PURE__*/ (0, $7YWoO.jsx)("script", {
                    src: (0, $195xf.scriptUrl),
                    onError: ()=>{
                        const error = new Error("Error loading script");
                        (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(error, (e)=>{
                            e.context = "Dynamics Form Capture script load";
                            e.addMetadata("signup", {
                                scriptUrl: (0, $195xf.scriptUrl)
                            });
                        });
                        (0, $gtsdT.logger).error("contentful", "Kunne ikke laste Dynamics Form Capture script");
                    }
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("form", {
                onSubmit: handleSignup,
                children: [
                    mappings.map((mapping)=>{
                        const props = {
                            value: currentValues[mapping.FormFieldName] || ""
                        };
                        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                            ...props,
                            label: mapping.label,
                            name: mapping.FormFieldName,
                            onChange: handleChange,
                            disabled: mapping.hidden,
                            onBlur: handleBlur,
                            errorMessage: errors[mapping.FormFieldName],
                            showErrorMessage: !!errors[mapping.FormFieldName],
                            className: (0, $izjX7.cn)("mb-2", {
                                hidden: mapping.hidden
                            })
                        }, mapping.FormFieldName);
                    }),
                    children,
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        variant: buttonVariant,
                        className: "mt-3",
                        disabled: buttonDisabled,
                        loading: signingUp,
                        type: "submit",
                        children: buttonText
                    })
                ]
            })
        ]
    });
};
var $d015220cbbf0c914$export$2e2bcd8739ae039 = $d015220cbbf0c914$var$SignupForm;

});
parcelRegister("gCpkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c193d86a618464e4$var$isEmail;

var $c193d86a618464e4$var$_assertString = $c193d86a618464e4$var$_interopRequireDefault((parcelRequire("iD5DL")));

var $c193d86a618464e4$var$_isByteLength = $c193d86a618464e4$var$_interopRequireDefault((parcelRequire("dmtVT")));

var $c193d86a618464e4$var$_isFQDN = $c193d86a618464e4$var$_interopRequireDefault((parcelRequire("3frsH")));

var $c193d86a618464e4$var$_isIP = $c193d86a618464e4$var$_interopRequireDefault((parcelRequire("6VyEK")));

var $c193d86a618464e4$var$_merge = $c193d86a618464e4$var$_interopRequireDefault((parcelRequire("2O07u")));
function $c193d86a618464e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c193d86a618464e4$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: '',
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $c193d86a618464e4$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $c193d86a618464e4$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $c193d86a618464e4$var$gmailUserPart = /^[a-z\d]+$/;
var $c193d86a618464e4$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $c193d86a618464e4$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $c193d86a618464e4$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $c193d86a618464e4$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $c193d86a618464e4$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1'); // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
     // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
         // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $c193d86a618464e4$var$isEmail(str, options) {
    (0, $c193d86a618464e4$var$_assertString.default)(str);
    options = (0, $c193d86a618464e4$var$_merge.default)(options, $c193d86a618464e4$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($c193d86a618464e4$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1]; // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, '').replace(/(^<|>$)/g, ''); // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(' ')) display_name = display_name.slice(0, -1);
            if (!$c193d86a618464e4$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $c193d86a618464e4$var$defaultMaxEmailLength) return false;
    var parts = str.split('@');
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join('@');
    if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase(); // Removing sub-address from username before gmail validation
        var username = user.split('+')[0]; // Dots are not included in gmail length restriction
        if (!(0, $c193d86a618464e4$var$_isByteLength.default)(username.replace(/\./g, ''), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split('.');
        for(var i = 0; i < _user_parts.length; i++){
            if (!$c193d86a618464e4$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $c193d86a618464e4$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $c193d86a618464e4$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $c193d86a618464e4$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $c193d86a618464e4$var$_isIP.default)(domain)) {
            if (!domain.startsWith('[') || !domain.endsWith(']')) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $c193d86a618464e4$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $c193d86a618464e4$var$quotedEmailUserUtf8.test(user) : $c193d86a618464e4$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $c193d86a618464e4$var$emailUserUtf8Part : $c193d86a618464e4$var$emailUserPart;
    var user_parts = user.split('.');
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("iD5DL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d9003e8d5dafaef8$var$assertString;
function $d9003e8d5dafaef8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d9003e8d5dafaef8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d9003e8d5dafaef8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d9003e8d5dafaef8$var$_typeof(obj);
}
function $d9003e8d5dafaef8$var$assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;
    if (!isString) {
        var invalidType = $d9003e8d5dafaef8$var$_typeof(input);
        if (input === null) invalidType = 'null';
        else if (invalidType === 'object') invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dmtVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ba48c701a6141e3$var$isByteLength;

var $9ba48c701a6141e3$var$_assertString = $9ba48c701a6141e3$var$_interopRequireDefault((parcelRequire("iD5DL")));
function $9ba48c701a6141e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ba48c701a6141e3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9ba48c701a6141e3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9ba48c701a6141e3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9ba48c701a6141e3$var$_typeof(obj);
}
/* eslint-disable prefer-rest-params */ function $9ba48c701a6141e3$var$isByteLength(str, options) {
    (0, $9ba48c701a6141e3$var$_assertString.default)(str);
    var min;
    var max;
    if ($9ba48c701a6141e3$var$_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("3frsH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25d8132ffb843e38$var$isFQDN;

var $25d8132ffb843e38$var$_assertString = $25d8132ffb843e38$var$_interopRequireDefault((parcelRequire("iD5DL")));

var $25d8132ffb843e38$var$_merge = $25d8132ffb843e38$var$_interopRequireDefault((parcelRequire("2O07u")));
function $25d8132ffb843e38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $25d8132ffb843e38$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $25d8132ffb843e38$var$isFQDN(str, options) {
    (0, $25d8132ffb843e38$var$_assertString.default)(str);
    options = (0, $25d8132ffb843e38$var$_merge.default)(options, $25d8132ffb843e38$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === '.') str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf('*.') === 0) str = str.substring(2);
    var parts = str.split('.');
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
         // disallow spaces
        if (/\s/.test(tld)) return false;
    } // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
         // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
         // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("2O07u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20b05816a76e13aa$var$merge;
function $20b05816a76e13aa$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === 'undefined') obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("6VyEK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50b2f2f340bd4e0d$var$isIP;

var $50b2f2f340bd4e0d$var$_assertString = $50b2f2f340bd4e0d$var$_interopRequireDefault((parcelRequire("iD5DL")));
function $50b2f2f340bd4e0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $50b2f2f340bd4e0d$var$IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var $50b2f2f340bd4e0d$var$IPv4AddressFormat = "(".concat($50b2f2f340bd4e0d$var$IPv4SegmentFormat, "[.]){3}").concat($50b2f2f340bd4e0d$var$IPv4SegmentFormat);
var $50b2f2f340bd4e0d$var$IPv4AddressRegExp = new RegExp("^".concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "$"));
var $50b2f2f340bd4e0d$var$IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var $50b2f2f340bd4e0d$var$IPv6AddressRegExp = new RegExp('^(' + "(?:".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, ":){7}(?:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, ":){6}(?:").concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "|:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, ":){5}(?::").concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "|(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, ":){4}(?:(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){0,1}:").concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "|(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, ":){3}(?:(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){0,2}:").concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "|(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, ":){2}(?:(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){0,3}:").concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "|(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, ":){1}(?:(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){0,4}:").concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "|(:").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){0,5}:").concat($50b2f2f340bd4e0d$var$IPv4AddressFormat, "|(?::").concat($50b2f2f340bd4e0d$var$IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');
function $50b2f2f340bd4e0d$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, $50b2f2f340bd4e0d$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $50b2f2f340bd4e0d$var$isIP(str, 4) || $50b2f2f340bd4e0d$var$isIP(str, 6);
    if (version === '4') return $50b2f2f340bd4e0d$var$IPv4AddressRegExp.test(str);
    if (version === '6') return $50b2f2f340bd4e0d$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});




parcelRegister("lrIVV", function(module, exports) {

$parcel$export(module.exports, "AdventCalendarHeader", function () { return $e75a7aa76830c871$export$e5b0cfdc6be70c99; });

var $7YWoO = parcelRequire("7YWoO");

const $e75a7aa76830c871$var$calendarHeader = new URL((parcelRequire("l2t4r"))).toString();

const $e75a7aa76830c871$var$calendarHeaderMobile = new URL((parcelRequire("fmu9w"))).toString();
const $e75a7aa76830c871$export$e5b0cfdc6be70c99 = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                className: "w-full h-full hidden sm:block",
                src: $e75a7aa76830c871$var$calendarHeader,
                alt: "Julekalender-header"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                className: "w-full h-full block sm:hidden",
                src: $e75a7aa76830c871$var$calendarHeaderMobile,
                alt: "Julekalender-header-mobil"
            })
        ]
    });
};

});
parcelRegister("l2t4r", function(module, exports) {
module.exports = $parcel$resolve("jfhKr");

});

parcelRegister("fmu9w", function(module, exports) {
module.exports = $parcel$resolve("ffzN1");

});


parcelRegister("9dYL1", function(module, exports) {
module.exports = $parcel$resolve("ho149");

});


parcelRegister("aUIXP", function(module, exports) {

$parcel$export(module.exports, "prefaceFont", function () { return $8a082304c89c5c95$export$d8fab2452028e2ef; });
$parcel$export(module.exports, "default", function () { return $8a082304c89c5c95$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");

var $j6ChH = parcelRequire("j6ChH");

var $8kt8E = parcelRequire("8kt8E");

var $edW3j = parcelRequire("edW3j");

var $bcbvQ = parcelRequire("bcbvQ");

var $jlTfJ = parcelRequire("jlTfJ");

var $isIf6 = parcelRequire("isIf6");

var $bUlre = parcelRequire("bUlre");

var $cLfby = parcelRequire("cLfby");

var $aszsA = parcelRequire("aszsA");

var $hX0dq = parcelRequire("hX0dq");

var $lNalp = parcelRequire("lNalp");
const $8a082304c89c5c95$export$d8fab2452028e2ef = "text-lg font-light leading-relaxed tracking-normal";
const $8a082304c89c5c95$var$Article = ({ article: article, id: id })=>{
    // Defaults to false, unless a parent is wraps this component with <BodyOnlyContext.Provider value={true} />
    const articleType = article.fields.articleType;
    const [fullUrl] = (0, $8kt8E.useLocation)();
    const articleVariantMap = {
        "Standard-utseende": "standard",
        "Stort bilde, header og ingress": "standard",
        "Uten bilde, header og ingress": "simple",
        "Enkel tittel og ingress": "simple"
    }[articleType ?? "Standard-utseende"];
    const articleVariant = articleVariantMap === "standard" ? "standard" : "simple";
    const entryContext = articleVariant === "simple" ? "simple-article" : "standard-article";
    const seoMetaDescription = article.fields.metaDescription || article.fields.preface;
    const title = article.fields.metaTitle || `${article.fields.title} - ${(0, $isIf6.default).siteName}`;
    (0, $dvPqk.useEffect)(()=>{
        if (!article.sys.id) return;
        const cleanedFullUrl = fullUrl.startsWith("/") ? fullUrl.slice(1) : fullUrl;
        if (!cleanedFullUrl.startsWith((0, $edW3j.PROMOTION_SECTION_SLUG))) return;
        (0, $jlTfJ.default).addViewedPromotionArticleId(article.sys.id);
    }, [
        article.sys.id,
        fullUrl
    ]);
    const heroComponents = {
        "Enkel tittel og ingress": (0, $hX0dq.default),
        "Stort bilde, header og ingress": (0, $aszsA.default),
        "Standard-utseende": (0, $lNalp.default),
        "Uten bilde, header og ingress": null
    };
    const HeroComponent = articleType ? heroComponents[articleType] : (0, $lNalp.default);
    const showBreadcrumb = HeroComponent && !(0, $bcbvQ.default).currentlyRequiresLogin.includes("ACCOUNT_PAGES");
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $j6ChH.Helmet), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("title", {
                        children: title
                    }),
                    !!seoMetaDescription && /*#__PURE__*/ (0, $7YWoO.jsx)("meta", {
                        name: "description",
                        content: seoMetaDescription
                    })
                ]
            }),
            showBreadcrumb && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bUlre.default), {}),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: (0, $izjX7.cn)({
                    "lg:px-[--article-px]": articleVariant === "standard"
                }),
                children: [
                    HeroComponent && /*#__PURE__*/ (0, $7YWoO.jsx)(HeroComponent, {
                        article: article,
                        id: id
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLfby.default), {
                            variant: articleVariant,
                            document: article.fields.body,
                            context: entryContext,
                            trackingLocationName: "Article"
                        })
                    })
                ]
            })
        ]
    });
};
var $8a082304c89c5c95$export$2e2bcd8739ae039 = $8a082304c89c5c95$var$Article;

});
parcelRegister("bUlre", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e350747edaa9d3b9$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $b3J4G = parcelRequire("b3J4G");

var $ghmTa = parcelRequire("ghmTa");

var $8kt8E = parcelRequire("8kt8E");

var $gtsdT = parcelRequire("gtsdT");

var $duLFK = parcelRequire("duLFK");

var $jlTfJ = parcelRequire("jlTfJ");
const $e350747edaa9d3b9$var$ContentBreadcrumb = ()=>{
    const [fullUrl] = (0, $8kt8E.useLocation)();
    if (!(0, $duLFK.isDataAvailable)((0, $jlTfJ.default).urlData)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3J4G.default), {
        className: "animate-spin"
    });
    if (!fullUrl) {
        (0, $gtsdT.logger).log("contentful", "Missing parameter 'fullUrl' when rendering breadcrumbs for content");
        return null;
    }
    if (fullUrl === "/") return null;
    const cleanedFullUrl = fullUrl.startsWith("/") ? fullUrl.slice(1) : fullUrl;
    if (cleanedFullUrl.includes("julekalender")) return null;
    const urlData = (0, $jlTfJ.default).urlData.data.find((data)=>data.slug === cleanedFullUrl || data.fullUrl === cleanedFullUrl);
    const splittedSlugList = urlData?.fullUrl.split("/") ?? cleanedFullUrl.split("/");
    const breadcrumbItems = splittedSlugList.map((slug, index, arr)=>{
        const urlData = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.slug === slug);
        return {
            label: urlData?.title || "",
            href: `/${urlData?.fullUrl}`,
            current: index === arr.length - 1,
            as: (0, $8kt8E.Link)
        };
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "mb-4 mt-2 print:hidden",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ghmTa.Breadcrumbs), {
            items: breadcrumbItems
        })
    });
};
var $e350747edaa9d3b9$export$2e2bcd8739ae039 = $e350747edaa9d3b9$var$ContentBreadcrumb;

});
parcelRegister("b3J4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80d2f061c05c2a98$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $80d2f061c05c2a98$var$SvgSpinner = (props)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.01,
                d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M4.592 12a7.408 7.408 0 1 0 14.816 0 7.408 7.408 0 0 0-14.816 0"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "inherit",
                d: "M8.019 3.929a9 9 0 1 1-4.531 10.993l1.868-.64A7.025 7.025 0 1 0 8.892 5.7z"
            })
        ]
    }));
var $80d2f061c05c2a98$export$2e2bcd8739ae039 = $80d2f061c05c2a98$var$SvgSpinner;

});

parcelRegister("ghmTa", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $bd9ffd1dee6ba03a$export$2dc68d50d56fbbd; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $4rjCr = parcelRequire("4rjCr");

var $Vdcm1 = parcelRequire("Vdcm1");
const $bd9ffd1dee6ba03a$var$l = (e, d, f = !1)=>typeof e > "u" ? "" : typeof e == "string" && f ? e : typeof e == "object" ? e[d] ?? "" : "";
function $bd9ffd1dee6ba03a$export$2dc68d50d56fbbd({ items: e = [], variant: d = "default", homeLink: f, className: r, homeLinkLabel: s, homePath: p = "/" }) {
    const o = {
        default: "fill-link-default",
        inverted: "fill-link-inverted"
    }[d], m = {
        default: "text-link-default",
        inverted: "text-link-inverted"
    }[d];
    return /* @__PURE__ */ (0, $7YWoO.jsx)("nav", {
        "aria-label": "Breadcrumb",
        className: (0, $6sMuH.cn)("flex", $bd9ffd1dee6ba03a$var$l(r, "container", !0)),
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("ol", {
            className: (0, $6sMuH.cn)("flex flex-wrap items-center p-0 m-0 list-none group", "[&>*:nth-last-child(2)]:inline-block [&>*]:hidden md:[&>*]:flex [&>li:nth-last-child(2)>div>svg]:rotate-180 md:[&>li:nth-last-child(2)>div>svg]:rotate-0", $bd9ffd1dee6ba03a$var$l(r, "list")),
            children: [
                f || s ? /* @__PURE__ */ (0, $7YWoO.jsx)("li", {
                    className: $bd9ffd1dee6ba03a$var$l(r, "item"),
                    children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                        className: (0, $6sMuH.cn)("flex items-center"),
                        children: [
                            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                                className: $bd9ffd1dee6ba03a$var$l(r, "link"),
                                href: p,
                                variant: d,
                                children: s
                            }),
                            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $Vdcm1.default), {
                                className: (0, $6sMuH.cn)(o, $bd9ffd1dee6ba03a$var$l(r, "divider"))
                            })
                        ]
                    })
                }, "home") : null,
                e.map((n)=>{
                    const v = e.indexOf(n) === 0, a = e.indexOf(n) === e.length - 1;
                    return /* @__PURE__ */ (0, $7YWoO.jsx)("li", {
                        className: $bd9ffd1dee6ba03a$var$l(r, "item"),
                        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                            className: (0, $6sMuH.cn)("flex items-center"),
                            children: [
                                /* @__PURE__ */ (0, $7YWoO.jsx)((0, $Vdcm1.default), {
                                    className: (0, $6sMuH.cn)(o, v ? "hidden" : "", $bd9ffd1dee6ba03a$var$l(r, "divider"))
                                }),
                                !a && /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                                    "aria-current": n.current ? "page" : void 0,
                                    as: n.as,
                                    className: (0, $6sMuH.cn)("underline", $bd9ffd1dee6ba03a$var$l(r, "link")),
                                    href: n.href,
                                    variant: d,
                                    children: n.label
                                }),
                                a ? /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                                    className: (0, $6sMuH.cn)("m-0", m, $bd9ffd1dee6ba03a$var$l(r, "currentPage")),
                                    children: n.label
                                }) : null
                            ]
                        })
                    }, n.href);
                })
            ]
        })
    });
}
$bd9ffd1dee6ba03a$export$2dc68d50d56fbbd.displayName = "Breadcrumbs";

});
parcelRegister("Vdcm1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0abf8fe2c858752d$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $0abf8fe2c858752d$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M13.938 12 10 8.063 11.063 7l5 5-5 5L10 15.938z"
        })
    }));

});



parcelRegister("aszsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c174be391af44539$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $8ICkW = parcelRequire("8ICkW");

var $izjX7 = parcelRequire("izjX7");

var $aFpyD = parcelRequire("aFpyD");

var $aUIXP = parcelRequire("aUIXP");

var $4fOOV = parcelRequire("4fOOV");
const $c174be391af44539$var$LargeImageArticleHeader = ({ article: article, id: id })=>{
    const inspectorProps = (0, $8ICkW.useContentfulInspectorMode)();
    const headerImage = article.fields.headerImage || undefined;
    const { title: title, preface: preface } = article.fields;
    const headerBoxPaddingStyle = "px-4 md:px-20 pt-4 lg:pt-8 pb-4 lg:pb-12";
    const headerBoxPlacementStyle = "relative z-10 mx-auto max-w-4xl -mt-8 md:-mt-24";
    const headerBoxContentStyle = "flex flex-col items-center justify-center gap-4 sm:gap-8 text-center bg-surface-default-hover rounded-lg";
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "mb-8",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "w-full",
            children: [
                headerImage && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
                        width: 1250,
                        ratio: "21x9",
                        entryId: headerImage.sys.id,
                        placement: "aboveFold",
                        className: "rounded-md object-cover",
                        ...inspectorProps({
                            entryId: id,
                            fieldId: "headerImage"
                        }),
                        imageFromParent: headerImage
                    }, JSON.stringify(headerImage))
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: "px-3",
                    children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: (0, $izjX7.cn)(headerBoxContentStyle, headerBoxPaddingStyle, headerBoxPlacementStyle),
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                                className: "text-3xl lg:text-4xl font-bold text-blue-900 mb-0 mt-2",
                                ...inspectorProps({
                                    entryId: id,
                                    fieldId: "title"
                                }),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: (0, $izjX7.cn)((0, $aUIXP.prefaceFont), "mb-0"),
                                ...inspectorProps({
                                    entryId: id,
                                    fieldId: "preface"
                                }),
                                children: preface
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4fOOV.default), {
                                createdAt: article.sys.createdAt,
                                updatedAt: article.sys.updatedAt
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $c174be391af44539$export$2e2bcd8739ae039 = $c174be391af44539$var$LargeImageArticleHeader;

});
parcelRegister("8ICkW", function(module, exports) {

$parcel$export(module.exports, "ContentfulLivePreviewProvider", function () { return $65902bb2629655bb$export$55e1c59fd28c749a; });
$parcel$export(module.exports, "useContentfulLiveUpdates", function () { return $65902bb2629655bb$export$60c5f805ef59b21d; });
$parcel$export(module.exports, "useContentfulInspectorMode", function () { return $65902bb2629655bb$export$4a0ed0d286662dca; });

var $dvPqk = parcelRequire("dvPqk");

var $cXOgh = parcelRequire("cXOgh");
var $65902bb2629655bb$var$Mr = {
    exports: {}
}, $65902bb2629655bb$var$Me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $65902bb2629655bb$var$Jr;
function $65902bb2629655bb$var$Mt() {
    if ($65902bb2629655bb$var$Jr) return $65902bb2629655bb$var$Me;
    $65902bb2629655bb$var$Jr = 1;
    var d = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))), v = Symbol.for("react.element"), P = Symbol.for("react.fragment"), x = Object.prototype.hasOwnProperty, A = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, I = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function U(j, _, Y) {
        var w, F = {}, H = null, ie = null;
        Y !== void 0 && (H = "" + Y), _.key !== void 0 && (H = "" + _.key), _.ref !== void 0 && (ie = _.ref);
        for(w in _)x.call(_, w) && !I.hasOwnProperty(w) && (F[w] = _[w]);
        if (j && j.defaultProps) for(w in _ = j.defaultProps, _)F[w] === void 0 && (F[w] = _[w]);
        return {
            $$typeof: v,
            type: j,
            key: H,
            ref: ie,
            props: F,
            _owner: A.current
        };
    }
    return $65902bb2629655bb$var$Me.Fragment = P, $65902bb2629655bb$var$Me.jsx = U, $65902bb2629655bb$var$Me.jsxs = U, $65902bb2629655bb$var$Me;
}
var $65902bb2629655bb$var$$e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $65902bb2629655bb$var$Xr;
function $65902bb2629655bb$var$$t() {
    return $65902bb2629655bb$var$Xr || ($65902bb2629655bb$var$Xr = 1), $65902bb2629655bb$var$$e;
}
$65902bb2629655bb$var$Mr.exports = $65902bb2629655bb$var$Mt();
var $65902bb2629655bb$var$Ut = $65902bb2629655bb$var$Mr.exports, $65902bb2629655bb$var$Tr = {
    exports: {}
};
$65902bb2629655bb$var$Tr.exports;
(function(d, v) {
    var P = 200, x = "__lodash_hash_undefined__", A = 1, I = 2, U = 9007199254740991, j = "[object Arguments]", _ = "[object Array]", Y = "[object AsyncFunction]", w = "[object Boolean]", F = "[object Date]", H = "[object Error]", ie = "[object Function]", Ue = "[object GeneratorFunction]", de = "[object Map]", Ne = "[object Number]", X = "[object Null]", E = "[object Object]", We = "[object Promise]", Rr = "[object Proxy]", Ye = "[object RegExp]", pe = "[object Set]", ze = "[object String]", wr = "[object Symbol]", Be = "[object Undefined]", we = "[object WeakMap]", Ge = "[object ArrayBuffer]", oe = "[object DataView]", z = "[object Float32Array]", k = "[object Float64Array]", se = "[object Int8Array]", qe = "[object Int16Array]", He = "[object Int32Array]", Ke = "[object Uint8Array]", ke = "[object Uint8ClampedArray]", Ve = "[object Uint16Array]", Je = "[object Uint32Array]", Xe = /[\\^$.*+?()[\]{}|]/g, Ze = /^\[object .+?Constructor\]$/, Cr = /^(?:0|[1-9]\d*)$/, g = {};
    g[z] = g[k] = g[se] = g[qe] = g[He] = g[Ke] = g[ke] = g[Ve] = g[Je] = !0, g[j] = g[_] = g[Ge] = g[w] = g[oe] = g[F] = g[H] = g[ie] = g[de] = g[Ne] = g[E] = g[Ye] = g[pe] = g[ze] = g[we] = !1;
    var ve = typeof (0, $cXOgh.c) == "object" && (0, $cXOgh.c) && (0, $cXOgh.c).Object === Object && (0, $cXOgh.c), Ce = typeof self == "object" && self && self.Object === Object && self, L = ve || Ce || Function("return this")(), ge = v && !v.nodeType && v, ue = ge && !0 && d && !d.nodeType && d, Qe = ue && ue.exports === ge, _e = Qe && ve.process, er = function() {
        try {
            return _e && _e.binding && _e.binding("util");
        } catch  {}
    }(), rr = er && er.isTypedArray;
    function he(e, t) {
        for(var n = -1, o = e == null ? 0 : e.length, h = 0, u = []; ++n < o;){
            var T = e[n];
            t(T, n, e) && (u[h++] = T);
        }
        return u;
    }
    function ye(e, t) {
        for(var n = -1, o = t.length, h = e.length; ++n < o;)e[h + n] = t[n];
        return e;
    }
    function tr(e, t) {
        for(var n = -1, o = e == null ? 0 : e.length; ++n < o;)if (t(e[n], n, e)) return !0;
        return !1;
    }
    function nr(e, t) {
        for(var n = -1, o = Array(e); ++n < e;)o[n] = t(n);
        return o;
    }
    function be(e) {
        return function(t) {
            return e(t);
        };
    }
    function Sr(e, t) {
        return e.has(t);
    }
    function Or(e, t) {
        return e == null ? void 0 : e[t];
    }
    function Se(e) {
        var t = -1, n = Array(e.size);
        return e.forEach(function(o, h) {
            n[++t] = [
                h,
                o
            ];
        }), n;
    }
    function Pr(e, t) {
        return function(n) {
            return e(t(n));
        };
    }
    function xr(e) {
        var t = -1, n = Array(e.size);
        return e.forEach(function(o) {
            n[++t] = o;
        }), n;
    }
    var ar = Array.prototype, ir = Function.prototype, K = Object.prototype, Oe = L["__core-js_shared__"], Pe = ir.toString, M = K.hasOwnProperty, Ee = function() {
        var e = /[^.]+$/.exec(Oe && Oe.keys && Oe.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
    }(), or = K.toString, Ar = RegExp("^" + Pe.call(M).replace(Xe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), sr = Qe ? L.Buffer : void 0, me = L.Symbol, ur = L.Uint8Array, fr = K.propertyIsEnumerable, jr = ar.splice, B = me ? me.toStringTag : void 0, xe = Object.getOwnPropertySymbols, Z = sr ? sr.isBuffer : void 0, Ae = Pr(Object.keys, Object), fe = Re(L, "DataView"), Q = Re(L, "Map"), je = Re(L, "Promise"), Te = Re(L, "Set"), De = Re(L, "WeakMap"), ee = Re(Object, "create"), lr = le(fe), Dr = le(Q), Ir = le(je), cr = le(Te), Fr = le(De), dr = me ? me.prototype : void 0, Ie = dr ? dr.valueOf : void 0;
    function V(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for(this.clear(); ++t < n;){
            var o = e[t];
            this.set(o[0], o[1]);
        }
    }
    function r() {
        this.__data__ = ee ? ee(null) : {}, this.size = 0;
    }
    function a(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
    }
    function i(e) {
        var t = this.__data__;
        if (ee) {
            var n = t[e];
            return n === x ? void 0 : n;
        }
        return M.call(t, e) ? t[e] : void 0;
    }
    function s(e) {
        var t = this.__data__;
        return ee ? t[e] !== void 0 : M.call(t, e);
    }
    function p(e, t) {
        var n = this.__data__;
        return this.size += this.has(e) ? 0 : 1, n[e] = ee && t === void 0 ? x : t, this;
    }
    V.prototype.clear = r, V.prototype.delete = a, V.prototype.get = i, V.prototype.has = s, V.prototype.set = p;
    function l(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for(this.clear(); ++t < n;){
            var o = e[t];
            this.set(o[0], o[1]);
        }
    }
    function c() {
        this.__data__ = [], this.size = 0;
    }
    function f(e) {
        var t = this.__data__, n = gr(t, e);
        if (n < 0) return !1;
        var o = t.length - 1;
        return n == o ? t.pop() : jr.call(t, n, 1), --this.size, !0;
    }
    function S(e) {
        var t = this.__data__, n = gr(t, e);
        return n < 0 ? void 0 : t[n][1];
    }
    function y(e) {
        return gr(this.__data__, e) > -1;
    }
    function m(e, t) {
        var n = this.__data__, o = gr(n, e);
        return o < 0 ? (++this.size, n.push([
            e,
            t
        ])) : n[o][1] = t, this;
    }
    l.prototype.clear = c, l.prototype.delete = f, l.prototype.get = S, l.prototype.has = y, l.prototype.set = m;
    function R(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for(this.clear(); ++t < n;){
            var o = e[t];
            this.set(o[0], o[1]);
        }
    }
    function re() {
        this.size = 0, this.__data__ = {
            hash: new V(),
            map: new (Q || l)(),
            string: new V()
        };
    }
    function pr(e) {
        var t = _r(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
    }
    function G(e) {
        return _r(this, e).get(e);
    }
    function et(e) {
        return _r(this, e).has(e);
    }
    function rt(e, t) {
        var n = _r(this, e), o = n.size;
        return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
    }
    R.prototype.clear = re, R.prototype.delete = pr, R.prototype.get = G, R.prototype.has = et, R.prototype.set = rt;
    function vr(e) {
        var t = -1, n = e == null ? 0 : e.length;
        for(this.__data__ = new R(); ++t < n;)this.add(e[t]);
    }
    function tt(e) {
        return this.__data__.set(e, x), this;
    }
    function nt(e) {
        return this.__data__.has(e);
    }
    vr.prototype.add = vr.prototype.push = tt, vr.prototype.has = nt;
    function te(e) {
        var t = this.__data__ = new l(e);
        this.size = t.size;
    }
    function at() {
        this.__data__ = new l(), this.size = 0;
    }
    function it(e) {
        var t = this.__data__, n = t.delete(e);
        return this.size = t.size, n;
    }
    function ot(e) {
        return this.__data__.get(e);
    }
    function st(e) {
        return this.__data__.has(e);
    }
    function ut(e, t) {
        var n = this.__data__;
        if (n instanceof l) {
            var o = n.__data__;
            if (!Q || o.length < P - 1) return o.push([
                e,
                t
            ]), this.size = ++n.size, this;
            n = this.__data__ = new R(o);
        }
        return n.set(e, t), this.size = n.size, this;
    }
    te.prototype.clear = at, te.prototype.delete = it, te.prototype.get = ot, te.prototype.has = st, te.prototype.set = ut;
    function ft(e, t) {
        var n = hr(e), o = !n && wt(e), h = !n && !o && Lr(e), u = !n && !o && !h && kr(e), T = n || o || h || u, C = T ? nr(e.length, String) : [], O = C.length;
        for(var b in e)(t || M.call(e, b)) && !(T && // Safari 9 has enumerable `arguments.length` in strict mode.
        (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        h && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        u && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
        bt(b, O))) && C.push(b);
        return C;
    }
    function gr(e, t) {
        for(var n = e.length; n--;)if (Gr(e[n][0], t)) return n;
        return -1;
    }
    function lt(e, t, n) {
        var o = t(e);
        return hr(e) ? o : ye(o, n(e));
    }
    function Fe(e) {
        return e == null ? e === void 0 ? Be : X : B && B in Object(e) ? ht(e) : Rt(e);
    }
    function Wr(e) {
        return Le(e) && Fe(e) == j;
    }
    function Yr(e, t, n, o, h) {
        return e === t ? !0 : e == null || t == null || !Le(e) && !Le(t) ? e !== e && t !== t : ct(e, t, n, o, Yr, h);
    }
    function ct(e, t, n, o, h, u) {
        var T = hr(e), C = hr(t), O = T ? _ : ne(e), b = C ? _ : ne(t);
        O = O == j ? E : O, b = b == j ? E : b;
        var $ = O == E, q = b == E, D = O == b;
        if (D && Lr(e)) {
            if (!Lr(t)) return !1;
            T = !0, $ = !1;
        }
        if (D && !$) return u || (u = new te()), T || kr(e) ? zr(e, t, n, o, h, u) : gt(e, t, O, n, o, h, u);
        if (!(n & A)) {
            var N = $ && M.call(e, "__wrapped__"), W = q && M.call(t, "__wrapped__");
            if (N || W) {
                var ae = N ? e.value() : e, J = W ? t.value() : t;
                return u || (u = new te()), h(ae, J, n, o, u);
            }
        }
        return D ? (u || (u = new te()), _t(e, t, n, o, h, u)) : !1;
    }
    function dt(e) {
        if (!Kr(e) || mt(e)) return !1;
        var t = qr(e) ? Ar : Ze;
        return t.test(le(e));
    }
    function pt(e) {
        return Le(e) && Hr(e.length) && !!g[Fe(e)];
    }
    function vt(e) {
        if (!Tt(e)) return Ae(e);
        var t = [];
        for(var n in Object(e))M.call(e, n) && n != "constructor" && t.push(n);
        return t;
    }
    function zr(e, t, n, o, h, u) {
        var T = n & A, C = e.length, O = t.length;
        if (C != O && !(T && O > C)) return !1;
        var b = u.get(e);
        if (b && u.get(t)) return b == t;
        var $ = -1, q = !0, D = n & I ? new vr() : void 0;
        for(u.set(e, t), u.set(t, e); ++$ < C;){
            var N = e[$], W = t[$];
            if (o) var ae = T ? o(W, N, $, t, e, u) : o(N, W, $, e, t, u);
            if (ae !== void 0) {
                if (ae) continue;
                q = !1;
                break;
            }
            if (D) {
                if (!tr(t, function(J, ce) {
                    if (!Sr(D, ce) && (N === J || h(N, J, n, o, u))) return D.push(ce);
                })) {
                    q = !1;
                    break;
                }
            } else if (!(N === W || h(N, W, n, o, u))) {
                q = !1;
                break;
            }
        }
        return u.delete(e), u.delete(t), q;
    }
    function gt(e, t, n, o, h, u, T) {
        switch(n){
            case oe:
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;
            case Ge:
                return !(e.byteLength != t.byteLength || !u(new ur(e), new ur(t)));
            case w:
            case F:
            case Ne:
                return Gr(+e, +t);
            case H:
                return e.name == t.name && e.message == t.message;
            case Ye:
            case ze:
                return e == t + "";
            case de:
                var C = Se;
            case pe:
                var O = o & A;
                if (C || (C = xr), e.size != t.size && !O) return !1;
                var b = T.get(e);
                if (b) return b == t;
                o |= I, T.set(e, t);
                var $ = zr(C(e), C(t), o, h, u, T);
                return T.delete(e), $;
            case wr:
                if (Ie) return Ie.call(e) == Ie.call(t);
        }
        return !1;
    }
    function _t(e, t, n, o, h, u) {
        var T = n & A, C = Br(e), O = C.length, b = Br(t), $ = b.length;
        if (O != $ && !T) return !1;
        for(var q = O; q--;){
            var D = C[q];
            if (!(T ? D in t : M.call(t, D))) return !1;
        }
        var N = u.get(e);
        if (N && u.get(t)) return N == t;
        var W = !0;
        u.set(e, t), u.set(t, e);
        for(var ae = T; ++q < O;){
            D = C[q];
            var J = e[D], ce = t[D];
            if (o) var Vr = T ? o(ce, J, D, t, e, u) : o(J, ce, D, e, t, u);
            if (!(Vr === void 0 ? J === ce || h(J, ce, n, o, u) : Vr)) {
                W = !1;
                break;
            }
            ae || (ae = D == "constructor");
        }
        if (W && !ae) {
            var yr = e.constructor, br = t.constructor;
            yr != br && "constructor" in e && "constructor" in t && !(typeof yr == "function" && yr instanceof yr && typeof br == "function" && br instanceof br) && (W = !1);
        }
        return u.delete(e), u.delete(t), W;
    }
    function Br(e) {
        return lt(e, Ot, yt);
    }
    function _r(e, t) {
        var n = e.__data__;
        return Et(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
    }
    function Re(e, t) {
        var n = Or(e, t);
        return dt(n) ? n : void 0;
    }
    function ht(e) {
        var t = M.call(e, B), n = e[B];
        try {
            e[B] = void 0;
            var o = !0;
        } catch  {}
        var h = or.call(e);
        return o && (t ? e[B] = n : delete e[B]), h;
    }
    var yt = xe ? function(e) {
        return e == null ? [] : (e = Object(e), he(xe(e), function(t) {
            return fr.call(e, t);
        }));
    } : Pt, ne = Fe;
    (fe && ne(new fe(new ArrayBuffer(1))) != oe || Q && ne(new Q()) != de || je && ne(je.resolve()) != We || Te && ne(new Te()) != pe || De && ne(new De()) != we) && (ne = function(e) {
        var t = Fe(e), n = t == E ? e.constructor : void 0, o = n ? le(n) : "";
        if (o) switch(o){
            case lr:
                return oe;
            case Dr:
                return de;
            case Ir:
                return We;
            case cr:
                return pe;
            case Fr:
                return we;
        }
        return t;
    });
    function bt(e, t) {
        return t = t ?? U, !!t && (typeof e == "number" || Cr.test(e)) && e > -1 && e % 1 == 0 && e < t;
    }
    function Et(e) {
        var t = typeof e;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
    }
    function mt(e) {
        return !!Ee && Ee in e;
    }
    function Tt(e) {
        var t = e && e.constructor, n = typeof t == "function" && t.prototype || K;
        return e === n;
    }
    function Rt(e) {
        return or.call(e);
    }
    function le(e) {
        if (e != null) {
            try {
                return Pe.call(e);
            } catch  {}
            try {
                return e + "";
            } catch  {}
        }
        return "";
    }
    function Gr(e, t) {
        return e === t || e !== e && t !== t;
    }
    var wt = Wr(function() {
        return arguments;
    }()) ? Wr : function(e) {
        return Le(e) && M.call(e, "callee") && !fr.call(e, "callee");
    }, hr = Array.isArray;
    function Ct(e) {
        return e != null && Hr(e.length) && !qr(e);
    }
    var Lr = Z || xt;
    function St(e, t) {
        return Yr(e, t);
    }
    function qr(e) {
        if (!Kr(e)) return !1;
        var t = Fe(e);
        return t == ie || t == Ue || t == Y || t == Rr;
    }
    function Hr(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= U;
    }
    function Kr(e) {
        var t = typeof e;
        return e != null && (t == "object" || t == "function");
    }
    function Le(e) {
        return e != null && typeof e == "object";
    }
    var kr = rr ? be(rr) : pt;
    function Ot(e) {
        return Ct(e) ? ft(e) : vt(e);
    }
    function Pt() {
        return [];
    }
    function xt() {
        return !1;
    }
    d.exports = St;
})($65902bb2629655bb$var$Tr, $65902bb2629655bb$var$Tr.exports);
var $65902bb2629655bb$var$Nt = $65902bb2629655bb$var$Tr.exports;
const $65902bb2629655bb$var$Wt = /* @__PURE__ */ (0, $cXOgh.g)($65902bb2629655bb$var$Nt);
function $65902bb2629655bb$export$8944d495961f539b(d) {
    const v = (0, $dvPqk.useRef)(d), P = (0, $dvPqk.useRef)(0);
    return $65902bb2629655bb$var$Wt(d, v.current) || (v.current = d, P.current += 1), (0, $dvPqk.useMemo)(()=>v.current, [
        P.current
    ]);
}
function $65902bb2629655bb$export$ca1c804c960fa94d(d, v) {
    return (0, $dvPqk.useEffect)(d, $65902bb2629655bb$export$8944d495961f539b(v));
}
const $65902bb2629655bb$var$Nr = (0, $dvPqk.createContext)(null);
function $65902bb2629655bb$export$55e1c59fd28c749a({ children: d, locale: v, debugMode: P = !1, enableInspectorMode: x = !0, enableLiveUpdates: A = !0, targetOrigin: I }) {
    if (!v) throw new Error('ContentfulLivePreviewProvider have to be called with a locale property (for example: `<ContentfulLivePreviewProvider locale="en-US">{children}</ContentfulLivePreviewProvider>`');
    (0, $cXOgh.C).init({
        locale: v,
        debugMode: P,
        enableInspectorMode: x,
        enableLiveUpdates: A,
        targetOrigin: I
    });
    const U = (0, $dvPqk.useMemo)(()=>({
            locale: v,
            debugMode: P,
            enableInspectorMode: x,
            enableLiveUpdates: A,
            targetOrigin: I
        }), [
        v,
        P,
        x,
        A,
        I
    ]);
    return /* @__PURE__ */ $65902bb2629655bb$var$Ut.jsx($65902bb2629655bb$var$Nr.Provider, {
        value: U,
        children: d
    });
}
function $65902bb2629655bb$export$60c5f805ef59b21d(d, v, P = !1) {
    const [x, A] = (0, $dvPqk.useState)({
        data: d,
        version: 1
    }), I = (0, $dvPqk.useRef)(d), U = (0, $dvPqk.useRef)((0, $cXOgh.d)(A)), j = (0, $dvPqk.useContext)($65902bb2629655bb$var$Nr), _ = typeof v == "object" ? v : {
        locale: v,
        skip: P
    }, Y = (0, $dvPqk.useMemo)(()=>j && !j.enableLiveUpdates || _.skip ? !1 : !!(Array.isArray(d) && d.length || d && typeof d == "object" && Object.keys(d).length), [
        j,
        _.skip,
        d
    ]);
    return $65902bb2629655bb$export$ca1c804c960fa94d(()=>{
        if (I.current !== d && (A({
            data: d,
            version: 1
        }), I.current = d), !!Y) return (0, $cXOgh.C).subscribe("edit", {
            data: d,
            locale: _.locale,
            query: _.query,
            callback: (w)=>{
                U.current((F)=>({
                        data: w,
                        version: F.version + 1
                    }));
            }
        });
    }, [
        d,
        Y,
        _.locale,
        _.query
    ]), x.data;
}
function $65902bb2629655bb$export$4a0ed0d286662dca(d) {
    const v = (0, $dvPqk.useContext)($65902bb2629655bb$var$Nr);
    return (0, $dvPqk.useCallback)((P)=>v != null && v.enableInspectorMode ? (0, $cXOgh.C).getProps({
            ...d,
            ...P
        }) : null, [
        v == null ? void 0 : v.enableInspectorMode,
        d
    ]);
}

});
parcelRegister("cXOgh", function(module, exports) {

$parcel$export(module.exports, "d", function () { return $9701fb9bf3a0da8e$export$4368d992c4eafac0; });
$parcel$export(module.exports, "c", function () { return $9701fb9bf3a0da8e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "g", function () { return $9701fb9bf3a0da8e$export$39b482c5e57630a8; });
$parcel$export(module.exports, "C", function () { return $9701fb9bf3a0da8e$export$e7094788287c5e9b; });
var $9701fb9bf3a0da8e$var$Be = Object.defineProperty;
var $9701fb9bf3a0da8e$var$me = (t, e, i)=>e in t ? $9701fb9bf3a0da8e$var$Be(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : t[e] = i;
var $9701fb9bf3a0da8e$var$f = (t, e, i)=>($9701fb9bf3a0da8e$var$me(t, typeof e != "symbol" ? e + "" : e, i), i);
const $9701fb9bf3a0da8e$var$ne = "2.12.1";
let $9701fb9bf3a0da8e$var$re = !1;
function $9701fb9bf3a0da8e$var$Z(t) {
    $9701fb9bf3a0da8e$var$re = t;
}
const $9701fb9bf3a0da8e$var$K = (t)=>(...e)=>{
        $9701fb9bf3a0da8e$var$re && console[t](...e);
    }, $9701fb9bf3a0da8e$var$h = {
    error: $9701fb9bf3a0da8e$var$K("error"),
    warn: $9701fb9bf3a0da8e$var$K("warn"),
    log: $9701fb9bf3a0da8e$var$K("log")
}, $9701fb9bf3a0da8e$var$ve = /* @__PURE__ */ new Set([
    "Symbol",
    "Text",
    "Integer",
    "Number",
    "Boolean",
    "Date",
    "Location",
    "Object"
]);
function $9701fb9bf3a0da8e$var$P({ dataFromPreviewApp: t, updateFromEntryEditor: e, name: i }) {
    var n;
    t[i] = ((n = e.fields) == null ? void 0 : n[i]) ?? null;
}
function $9701fb9bf3a0da8e$var$ae(t) {
    var e;
    return !!($9701fb9bf3a0da8e$var$ve.has(t.type) || t.type === "Array" && ((e = t.items) == null ? void 0 : e.type) === "Symbol");
}
const $9701fb9bf3a0da8e$var$B = 10, $9701fb9bf3a0da8e$export$61196ced6d74a310 = "live-preview-editor", $9701fb9bf3a0da8e$export$407448d2b89b1813 = "live-preview-sdk";
function $9701fb9bf3a0da8e$var$g(t, e, i) {
    const n = {
        ...e,
        method: t,
        from: "live-preview",
        source: $9701fb9bf3a0da8e$export$407448d2b89b1813,
        location: window.location.href,
        version: $9701fb9bf3a0da8e$var$ne
    };
    $9701fb9bf3a0da8e$var$h.log("Send message", n), i.forEach((s)=>{
        var r;
        (r = window.top) == null || r.postMessage(n, s);
    });
}
function $9701fb9bf3a0da8e$export$4368d992c4eafac0(t, e = 100) {
    let i;
    return (...n)=>{
        clearTimeout(i), i = setTimeout(()=>{
            t.apply(this, n);
        }, e);
    };
}
class $9701fb9bf3a0da8e$var$Ue {
    constructor(e, i){
        $9701fb9bf3a0da8e$var$f(this, "storageKey");
        $9701fb9bf3a0da8e$var$f(this, "value");
        this.storageKey = e, this.value = this.restoreSessionData() || i;
    }
    getKey(e, i) {
        return `${e}-${i}`;
    }
    restoreSessionData() {
        try {
            const e = window.sessionStorage.getItem(this.storageKey), i = e ? JSON.parse(e) : null;
            return Array.isArray(i) ? new Map(i) : null;
        } catch  {
            return null;
        }
    }
    get(e, i) {
        return this.value.get(this.getKey(e, i));
    }
    set(e, i, n) {
        this.value.set(this.getKey(e, i), n);
        try {
            window.sessionStorage.setItem(this.storageKey, JSON.stringify(Array.from(this.value.entries())));
        } catch  {
            $9701fb9bf3a0da8e$var$h.warn(`StorageMap: Failed to set data for key "${e}" in sessionStorage`);
        }
    }
    clear() {
        this.value.clear();
        try {
            window.sessionStorage.removeItem(this.storageKey);
        } catch  {
            $9701fb9bf3a0da8e$var$h.warn("StorageMap: Failed to clear data from sessionStorage");
        }
    }
}
function $9701fb9bf3a0da8e$var$Me(t) {
    if (!t) return t;
    try {
        const e = new URL(t, "https://images.ctfassets.net");
        return e.protocol = "https:", e.href;
    } catch (e) {
        return $9701fb9bf3a0da8e$var$h.error(`Recevied invalid asset url "${t}"`, e), t;
    }
}
function $9701fb9bf3a0da8e$var$V(t) {
    if (typeof structuredClone == "function") return structuredClone(t);
    try {
        return JSON.parse(JSON.stringify(t));
    } catch (e) {
        return $9701fb9bf3a0da8e$var$h.warn("Failed to clone data, updates are done on the original one", t, e), t;
    }
}
function $9701fb9bf3a0da8e$var$Ge() {
    var t;
    try {
        return ((t = window.top) == null ? void 0 : t.location.href) !== window.location.href;
    } catch  {
        return !0;
    }
}
function $9701fb9bf3a0da8e$var$He() {
    return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function $9701fb9bf3a0da8e$var$ke(t, e = 500) {
    let i = window.location.href;
    const s = setInterval(()=>{
        const r = window.location.href;
        r !== i && (i = r, t(r));
    }, e);
    return ()=>clearInterval(s);
}
function $9701fb9bf3a0da8e$var$oe(t, e) {
    if (!e.length) return t;
    try {
        const [i, ...n] = e;
        return $9701fb9bf3a0da8e$var$oe(t[i], n);
    } catch  {
        return;
    }
}
function $9701fb9bf3a0da8e$var$U(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
class $9701fb9bf3a0da8e$var$Ye {
    get entities() {
        return [
            ...this.entryMap.values(),
            ...this.assetMap.values()
        ];
    }
    updateEntity(e) {
        this.addEntity(e);
    }
    getValue(e, i) {
        e.sys.type;
        const n = this.getEntity(e.sys.linkType, e.sys.id);
        if (!n) {
            console.warn(`Unresolved entity reference: ${e}`);
            return;
        }
        return $9701fb9bf3a0da8e$var$oe(n, i);
    }
    getEntitiesFromMap(e, i) {
        const n = [], s = [];
        for (const r of i){
            const o = this.getEntity(e, r);
            o ? n.push(o) : s.push(r);
        }
        return {
            resolved: n,
            missing: s
        };
    }
    addEntity(e) {
        this.isAsset(e) ? this.assetMap.set(e.sys.id, e) : this.entryMap.set(e.sys.id, e);
    }
    async fetchAsset(e) {
        const { resolved: i, missing: n } = this.getEntitiesFromMap("Asset", [
            e
        ]);
        if (n.length) {
            console.warn(`Asset "${e}" is not in the store`);
            return;
        }
        return i[0];
    }
    async fetchAssets(e) {
        const { resolved: i, missing: n } = this.getEntitiesFromMap("Asset", e);
        if (n.length) throw new Error(`Missing assets in the store (${n.join(",")})`);
        return i;
    }
    async fetchEntry(e) {
        const { resolved: i, missing: n } = this.getEntitiesFromMap("Entry", [
            e
        ]);
        if (n.length) {
            console.warn(`Entry "${e}" is not in the store`);
            return;
        }
        return i[0];
    }
    async fetchEntries(e) {
        const { resolved: i, missing: n } = this.getEntitiesFromMap("Entry", e);
        if (n.length) throw new Error(`Missing assets in the store (${n.join(",")})`);
        return i;
    }
    isAsset(e) {
        return e.sys.type === "Asset";
    }
    getEntity(e, i) {
        return e === "Asset" ? this.assetMap.get(i) : this.entryMap.get(i);
    }
    constructor({ entities: e, locale: i }){
        $9701fb9bf3a0da8e$var$U(this, "locale", void 0), $9701fb9bf3a0da8e$var$U(this, "entryMap", /* @__PURE__ */ new Map()), $9701fb9bf3a0da8e$var$U(this, "assetMap", /* @__PURE__ */ new Map()), this.locale = i;
        for (const n of e)this.addEntity(n);
    }
}
function $9701fb9bf3a0da8e$var$A(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
var $9701fb9bf3a0da8e$export$56c0d5a1e737357d;
(function(t) {
    t.REQUEST_ENTITIES = "REQUEST_ENTITIES", t.REQUESTED_ENTITIES = "REQUESTED_ENTITIES";
})($9701fb9bf3a0da8e$export$56c0d5a1e737357d || ($9701fb9bf3a0da8e$export$56c0d5a1e737357d = {}));
class $9701fb9bf3a0da8e$var$je extends $9701fb9bf3a0da8e$var$Ye {
    cleanupPromise(e) {
        setTimeout(()=>{
            this.requestCache.delete(e);
        }, 300);
    }
    getCacheId(e) {
        return e.length === 1 ? e[0] : e.join(this.cacheIdSeperator);
    }
    async fetchEntity(e, i) {
        const { missing: n, resolved: s } = this.getEntitiesFromMap(e, i);
        if (n.length === 0) return s;
        const r = this.getCacheId(n), o = this.requestCache.get(r);
        if (o) return o;
        const a = new Promise((E, u)=>{
            const c = this.subscribe("REQUESTED_ENTITIES", (y)=>{
                n.every((_)=>y.entities.find((O)=>O.sys.id === _)) && (clearTimeout(d), E(y.entities), this.cleanupPromise(r), i.forEach((_)=>this.cleanupPromise(_)), c());
            }), d = setTimeout(()=>{
                u(new Error("Request for entities timed out")), c();
            }, this.timeoutDuration);
            this.sendMessage("REQUEST_ENTITIES", {
                entityIds: n,
                entityType: e,
                locale: this.locale
            });
        });
        return this.requestCache.set(r, a), i.forEach((E)=>{
            this.requestCache.set(E, a);
        }), (await a).forEach((E)=>{
            this.addEntity(E);
        }), this.getEntitiesFromMap(e, i).resolved;
    }
    async fetchAsset(e) {
        try {
            return (await this.fetchAssets([
                e
            ]))[0];
        } catch  {
            console.warn(`Failed to request asset ${e}`);
            return;
        }
    }
    fetchAssets(e) {
        return this.fetchEntity("Asset", e);
    }
    async fetchEntry(e) {
        try {
            return (await this.fetchEntries([
                e
            ]))[0];
        } catch (i) {
            console.warn(`Failed to request entry ${e}`, i);
            return;
        }
    }
    fetchEntries(e) {
        return this.fetchEntity("Entry", e);
    }
    constructor({ entities: e, locale: i, sendMessage: n, subscribe: s, timeoutDuration: r = 3e3 }){
        super({
            entities: e,
            locale: i
        }), $9701fb9bf3a0da8e$var$A(this, "requestCache", /* @__PURE__ */ new Map()), $9701fb9bf3a0da8e$var$A(this, "sendMessage", void 0), $9701fb9bf3a0da8e$var$A(this, "subscribe", void 0), $9701fb9bf3a0da8e$var$A(this, "timeoutDuration", void 0), $9701fb9bf3a0da8e$var$A(this, "cacheIdSeperator", ","), this.sendMessage = n, this.subscribe = s, this.timeoutDuration = r;
    }
}
const $9701fb9bf3a0da8e$var$H = "Collection";
function $9701fb9bf3a0da8e$var$m(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
}
function $9701fb9bf3a0da8e$var$$(t) {
    return `${t}${$9701fb9bf3a0da8e$var$H}`;
}
function $9701fb9bf3a0da8e$var$Pe(t) {
    if (t.endsWith($9701fb9bf3a0da8e$var$H)) return $9701fb9bf3a0da8e$var$m(t.replace($9701fb9bf3a0da8e$var$H, ""));
}
const $9701fb9bf3a0da8e$var$b = "Asset";
function $9701fb9bf3a0da8e$var$R(t) {
    return !!(t && typeof t == "object" && "sys" in t && t.sys.id);
}
const $9701fb9bf3a0da8e$var$M = {};
function $9701fb9bf3a0da8e$var$J(t, e) {
    return $9701fb9bf3a0da8e$var$M[t] || ($9701fb9bf3a0da8e$var$M[t] = new $9701fb9bf3a0da8e$var$je({
        entities: [],
        sendMessage: e,
        subscribe: (i, n)=>{
            const s = (r)=>{
                typeof r.data != "object" || !r.data || r.data.from === "live-preview" && r.data.method === i && n(r.data);
            };
            return window.addEventListener("message", s), ()=>window.removeEventListener("message", s);
        },
        locale: t
    })), $9701fb9bf3a0da8e$var$M[t];
}
async function $9701fb9bf3a0da8e$var$z({ entityReferenceMap: t, referenceId: e, isAsset: i, locale: n, sendMessage: s }) {
    var a, l, E;
    const r = t.get(e);
    if (r) return {
        reference: r,
        typeName: "contentType" in r.sys && (E = (l = (a = r.sys) == null ? void 0 : a.contentType) == null ? void 0 : l.sys) != null && E.id ? $9701fb9bf3a0da8e$var$m(r.sys.contentType.sys.id) : $9701fb9bf3a0da8e$var$b
    };
    if (i) {
        const u = await $9701fb9bf3a0da8e$var$J(n, s).fetchAsset(e);
        if (!u) throw new Error(`Unknown reference ${e}`);
        return {
            reference: u,
            typeName: $9701fb9bf3a0da8e$var$b
        };
    }
    const o = await $9701fb9bf3a0da8e$var$J(n, s).fetchEntry(e);
    if (!o) throw new Error(`Unknown reference ${e}`);
    return {
        reference: o,
        typeName: $9701fb9bf3a0da8e$var$m(o.sys.contentType.sys.id)
    };
}
function $9701fb9bf3a0da8e$var$Ve(t) {
    return typeof t.data != "object" || !t.data ? !1 : "from" in t.data && t.data.from === "live-preview" || "source" in t.data && t.data.source === $9701fb9bf3a0da8e$export$61196ced6d74a310;
}
var $9701fb9bf3a0da8e$var$L = /* @__PURE__ */ ((t)=>(t.FIELD_ID = "data-contentful-field-id", t.ENTRY_ID = "data-contentful-entry-id", t.LOCALE = "data-contentful-locale", t))($9701fb9bf3a0da8e$var$L || {}), $9701fb9bf3a0da8e$export$9bb611d729802a56 = /* @__PURE__ */ ((t)=>(t.MOUSE_MOVE = "MOUSE_MOVE", t.SCROLL_START = "SCROLL_START", t.SCROLL_END = "SCROLL_END", t.RESIZE_START = "RESIZE_START", t.RESIZE_END = "RESIZE_END", t.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", t.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", t))($9701fb9bf3a0da8e$export$9bb611d729802a56 || {});
function $9701fb9bf3a0da8e$var$G(t, e) {
    const i = t.getAttribute($9701fb9bf3a0da8e$var$L.FIELD_ID), n = t.getAttribute($9701fb9bf3a0da8e$var$L.ENTRY_ID), s = t.getAttribute($9701fb9bf3a0da8e$var$L.LOCALE) ?? e;
    return !i || !n || !s ? null : {
        fieldId: i,
        entryId: n,
        locale: s
    };
}
function $9701fb9bf3a0da8e$var$k() {
    return [
        ...document.querySelectorAll(`[${$9701fb9bf3a0da8e$var$L.ENTRY_ID}]`)
    ];
}
function $9701fb9bf3a0da8e$var$le() {
    return [
        ...new Set($9701fb9bf3a0da8e$var$k().map((t)=>t.getAttribute($9701fb9bf3a0da8e$var$L.ENTRY_ID)).filter(Boolean))
    ];
}
class $9701fb9bf3a0da8e$var$$e {
    constructor({ locale: e, targetOrigin: i }){
        $9701fb9bf3a0da8e$var$f(this, "defaultLocale");
        $9701fb9bf3a0da8e$var$f(this, "targetOrigin");
        $9701fb9bf3a0da8e$var$f(this, "isScrolling", !1);
        $9701fb9bf3a0da8e$var$f(this, "scrollTimeout");
        $9701fb9bf3a0da8e$var$f(this, "isResizing", !1);
        $9701fb9bf3a0da8e$var$f(this, "resizeTimeout");
        $9701fb9bf3a0da8e$var$f(this, "hoveredElement");
        $9701fb9bf3a0da8e$var$f(this, "taggedElements", []);
        this.defaultLocale = e, this.targetOrigin = i, this.addHoverListener = this.addHoverListener.bind(this), this.addScrollListener = this.addScrollListener.bind(this), this.addMutationListener = this.addMutationListener.bind(this), this.addResizeListener = this.addResizeListener.bind(this), this.handleTaggedElement = this.handleTaggedElement.bind(this), this.sendAllElements = this.sendAllElements.bind(this), this.addHoverListener(), this.addScrollListener(), this.addMutationListener(), this.addResizeListener();
    }
    // Handles incoming messages from Contentful
    receiveMessage(e) {
        if (e.method === $9701fb9bf3a0da8e$export$9bb611d729802a56.INSPECTOR_MODE_CHANGED) {
            const { isInspectorActive: i } = e;
            i && this.sendAllElements();
        }
    }
    /** Checks if the hovered element is an tagged entry and then sends it to the editor */ addHoverListener() {
        const e = (i)=>{
            const n = i.composedPath();
            for (const s of n){
                const r = s;
                if (r.nodeName === "BODY") break;
                if (typeof (r == null ? void 0 : r.getAttribute) == "function" && this.handleTaggedElement(r)) return;
            }
            this.hoveredElement && (this.hoveredElement = void 0, $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$9bb611d729802a56.MOUSE_MOVE, {
                element: null
            }, this.targetOrigin));
        };
        return window.addEventListener("mouseover", e), ()=>window.removeEventListener("mouseover", e);
    }
    /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */ addScrollListener() {
        const e = ()=>{
            this.isScrolling || (this.isScrolling = !0, $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$9bb611d729802a56.SCROLL_START, {}, this.targetOrigin)), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(()=>{
                this.isScrolling = !1, $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$9bb611d729802a56.SCROLL_END, {}, this.targetOrigin), this.sendAllElements(), this.hoveredElement && this.handleTaggedElement(this.hoveredElement);
            }, 150);
        };
        return window.addEventListener("scroll", e), ()=>window.removeEventListener("scroll", e);
    }
    /** Detects DOM changes and sends the tagged elements to the editor */ addMutationListener() {
        const e = new MutationObserver(()=>{
            var n;
            const i = $9701fb9bf3a0da8e$var$k().filter((s)=>!!$9701fb9bf3a0da8e$var$G(s));
            ((n = this.taggedElements) == null ? void 0 : n.length) !== i.length && this.sendAllElements();
        });
        return e.observe(document.body, {
            attributes: !0,
            attributeFilter: [
                $9701fb9bf3a0da8e$var$L.ENTRY_ID,
                $9701fb9bf3a0da8e$var$L.FIELD_ID,
                $9701fb9bf3a0da8e$var$L.LOCALE
            ],
            childList: !0,
            subtree: !0
        }), ()=>e.disconnect();
    }
    /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */ addResizeListener() {
        const e = new ResizeObserver(()=>{
            this.isResizing || (this.isResizing = !0, $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$9bb611d729802a56.RESIZE_START, {}, this.targetOrigin)), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(()=>{
                this.isResizing = !1, $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$9bb611d729802a56.RESIZE_END, {}, this.targetOrigin), this.sendAllElements(), this.hoveredElement && this.handleTaggedElement(this.hoveredElement);
            }, 150);
        });
        return e.observe(document.body), ()=>e.disconnect();
    }
    /**
   * Validates if the element has the inspector mode attributes
   * and sends it then to the editor
   */ handleTaggedElement(e) {
        const i = $9701fb9bf3a0da8e$var$G(e, this.defaultLocale);
        return i ? (this.hoveredElement = e, $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$9bb611d729802a56.MOUSE_MOVE, {
            element: {
                attributes: i,
                coordinates: e.getBoundingClientRect()
            }
        }, this.targetOrigin), !0) : !1;
    }
    /**
   * Finds all elements that have all inspector mode attributes
   * and sends them to the editor
   */ sendAllElements() {
        const e = $9701fb9bf3a0da8e$var$k().filter((i)=>!!$9701fb9bf3a0da8e$var$G(i, this.defaultLocale));
        this.taggedElements = e, $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$9bb611d729802a56.TAGGED_ELEMENTS, {
            elements: e.map((i)=>({
                    coordinates: i.getBoundingClientRect()
                }))
        }, this.targetOrigin);
    }
}
var $9701fb9bf3a0da8e$export$db3b6bfb95261072 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $9701fb9bf3a0da8e$export$39b482c5e57630a8(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $9701fb9bf3a0da8e$var$D = {}, $9701fb9bf3a0da8e$var$C = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.BLOCKS = void 0, function(e) {
        e.DOCUMENT = "document", e.PARAGRAPH = "paragraph", e.HEADING_1 = "heading-1", e.HEADING_2 = "heading-2", e.HEADING_3 = "heading-3", e.HEADING_4 = "heading-4", e.HEADING_5 = "heading-5", e.HEADING_6 = "heading-6", e.OL_LIST = "ordered-list", e.UL_LIST = "unordered-list", e.LIST_ITEM = "list-item", e.HR = "hr", e.QUOTE = "blockquote", e.EMBEDDED_ENTRY = "embedded-entry-block", e.EMBEDDED_ASSET = "embedded-asset-block", e.EMBEDDED_RESOURCE = "embedded-resource-block", e.TABLE = "table", e.TABLE_ROW = "table-row", e.TABLE_CELL = "table-cell", e.TABLE_HEADER_CELL = "table-header-cell";
    }(t.BLOCKS || (t.BLOCKS = {}));
})($9701fb9bf3a0da8e$var$C);
var $9701fb9bf3a0da8e$var$v = {};
(function(t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.INLINES = void 0, function(e) {
        e.HYPERLINK = "hyperlink", e.ENTRY_HYPERLINK = "entry-hyperlink", e.ASSET_HYPERLINK = "asset-hyperlink", e.RESOURCE_HYPERLINK = "resource-hyperlink", e.EMBEDDED_ENTRY = "embedded-entry-inline", e.EMBEDDED_RESOURCE = "embedded-resource-inline";
    }(t.INLINES || (t.INLINES = {}));
})($9701fb9bf3a0da8e$var$v);
var $9701fb9bf3a0da8e$var$w = {};
Object.defineProperty($9701fb9bf3a0da8e$var$w, "__esModule", {
    value: !0
});
var $9701fb9bf3a0da8e$var$Y;
(function(t) {
    t.BOLD = "bold", t.ITALIC = "italic", t.UNDERLINE = "underline", t.CODE = "code", t.SUPERSCRIPT = "superscript", t.SUBSCRIPT = "subscript";
})($9701fb9bf3a0da8e$var$Y || ($9701fb9bf3a0da8e$var$Y = {}));
$9701fb9bf3a0da8e$var$w.default = $9701fb9bf3a0da8e$var$Y;
var $9701fb9bf3a0da8e$var$ce = {};
(function(t) {
    var e = $9701fb9bf3a0da8e$export$db3b6bfb95261072 && $9701fb9bf3a0da8e$export$db3b6bfb95261072.__spreadArray || function(a, l, E) {
        if (E || arguments.length === 2) for(var u = 0, c = l.length, d; u < c; u++)(d || !(u in l)) && (d || (d = Array.prototype.slice.call(l, 0, u)), d[u] = l[u]);
        return a.concat(d || Array.prototype.slice.call(l));
    }, i = $9701fb9bf3a0da8e$export$db3b6bfb95261072 && $9701fb9bf3a0da8e$export$db3b6bfb95261072.__importDefault || function(a) {
        return a && a.__esModule ? a : {
            default: a
        };
    }, n;
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.V1_MARKS = t.V1_NODE_TYPES = t.TEXT_CONTAINERS = t.HEADINGS = t.CONTAINERS = t.VOID_BLOCKS = t.TABLE_BLOCKS = t.LIST_ITEM_BLOCKS = t.TOP_LEVEL_BLOCKS = void 0;
    var s = $9701fb9bf3a0da8e$var$C, r = $9701fb9bf3a0da8e$var$v, o = i($9701fb9bf3a0da8e$var$w);
    t.TOP_LEVEL_BLOCKS = [
        s.BLOCKS.PARAGRAPH,
        s.BLOCKS.HEADING_1,
        s.BLOCKS.HEADING_2,
        s.BLOCKS.HEADING_3,
        s.BLOCKS.HEADING_4,
        s.BLOCKS.HEADING_5,
        s.BLOCKS.HEADING_6,
        s.BLOCKS.OL_LIST,
        s.BLOCKS.UL_LIST,
        s.BLOCKS.HR,
        s.BLOCKS.QUOTE,
        s.BLOCKS.EMBEDDED_ENTRY,
        s.BLOCKS.EMBEDDED_ASSET,
        s.BLOCKS.EMBEDDED_RESOURCE,
        s.BLOCKS.TABLE
    ], t.LIST_ITEM_BLOCKS = [
        s.BLOCKS.PARAGRAPH,
        s.BLOCKS.HEADING_1,
        s.BLOCKS.HEADING_2,
        s.BLOCKS.HEADING_3,
        s.BLOCKS.HEADING_4,
        s.BLOCKS.HEADING_5,
        s.BLOCKS.HEADING_6,
        s.BLOCKS.OL_LIST,
        s.BLOCKS.UL_LIST,
        s.BLOCKS.HR,
        s.BLOCKS.QUOTE,
        s.BLOCKS.EMBEDDED_ENTRY,
        s.BLOCKS.EMBEDDED_ASSET,
        s.BLOCKS.EMBEDDED_RESOURCE
    ], t.TABLE_BLOCKS = [
        s.BLOCKS.TABLE,
        s.BLOCKS.TABLE_ROW,
        s.BLOCKS.TABLE_CELL,
        s.BLOCKS.TABLE_HEADER_CELL
    ], t.VOID_BLOCKS = [
        s.BLOCKS.HR,
        s.BLOCKS.EMBEDDED_ENTRY,
        s.BLOCKS.EMBEDDED_ASSET,
        s.BLOCKS.EMBEDDED_RESOURCE
    ], t.CONTAINERS = (n = {}, n[s.BLOCKS.OL_LIST] = [
        s.BLOCKS.LIST_ITEM
    ], n[s.BLOCKS.UL_LIST] = [
        s.BLOCKS.LIST_ITEM
    ], n[s.BLOCKS.LIST_ITEM] = t.LIST_ITEM_BLOCKS, n[s.BLOCKS.QUOTE] = [
        s.BLOCKS.PARAGRAPH
    ], n[s.BLOCKS.TABLE] = [
        s.BLOCKS.TABLE_ROW
    ], n[s.BLOCKS.TABLE_ROW] = [
        s.BLOCKS.TABLE_CELL,
        s.BLOCKS.TABLE_HEADER_CELL
    ], n[s.BLOCKS.TABLE_CELL] = [
        s.BLOCKS.PARAGRAPH
    ], n[s.BLOCKS.TABLE_HEADER_CELL] = [
        s.BLOCKS.PARAGRAPH
    ], n), t.HEADINGS = [
        s.BLOCKS.HEADING_1,
        s.BLOCKS.HEADING_2,
        s.BLOCKS.HEADING_3,
        s.BLOCKS.HEADING_4,
        s.BLOCKS.HEADING_5,
        s.BLOCKS.HEADING_6
    ], t.TEXT_CONTAINERS = e([
        s.BLOCKS.PARAGRAPH
    ], t.HEADINGS, !0), t.V1_NODE_TYPES = [
        s.BLOCKS.DOCUMENT,
        s.BLOCKS.PARAGRAPH,
        s.BLOCKS.HEADING_1,
        s.BLOCKS.HEADING_2,
        s.BLOCKS.HEADING_3,
        s.BLOCKS.HEADING_4,
        s.BLOCKS.HEADING_5,
        s.BLOCKS.HEADING_6,
        s.BLOCKS.OL_LIST,
        s.BLOCKS.UL_LIST,
        s.BLOCKS.LIST_ITEM,
        s.BLOCKS.HR,
        s.BLOCKS.QUOTE,
        s.BLOCKS.EMBEDDED_ENTRY,
        s.BLOCKS.EMBEDDED_ASSET,
        r.INLINES.HYPERLINK,
        r.INLINES.ENTRY_HYPERLINK,
        r.INLINES.ASSET_HYPERLINK,
        r.INLINES.EMBEDDED_ENTRY,
        "text"
    ], t.V1_MARKS = [
        o.default.BOLD,
        o.default.CODE,
        o.default.ITALIC,
        o.default.UNDERLINE
    ];
})($9701fb9bf3a0da8e$var$ce);
var $9701fb9bf3a0da8e$var$ue = {};
Object.defineProperty($9701fb9bf3a0da8e$var$ue, "__esModule", {
    value: !0
});
var $9701fb9bf3a0da8e$var$Ee = {};
Object.defineProperty($9701fb9bf3a0da8e$var$Ee, "__esModule", {
    value: !0
});
var $9701fb9bf3a0da8e$var$Q = {};
Object.defineProperty($9701fb9bf3a0da8e$var$Q, "__esModule", {
    value: !0
});
var $9701fb9bf3a0da8e$var$x = $9701fb9bf3a0da8e$var$C, $9701fb9bf3a0da8e$var$ze = {
    nodeType: $9701fb9bf3a0da8e$var$x.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $9701fb9bf3a0da8e$var$x.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: "text",
                    value: "",
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
$9701fb9bf3a0da8e$var$Q.default = $9701fb9bf3a0da8e$var$ze;
var $9701fb9bf3a0da8e$var$N = {};
Object.defineProperty($9701fb9bf3a0da8e$var$N, "__esModule", {
    value: !0
});
$9701fb9bf3a0da8e$var$N.isText = $9701fb9bf3a0da8e$var$N.isBlock = $9701fb9bf3a0da8e$var$N.isInline = void 0;
var $9701fb9bf3a0da8e$var$Qe = $9701fb9bf3a0da8e$var$C, $9701fb9bf3a0da8e$var$Fe = $9701fb9bf3a0da8e$var$v;
function $9701fb9bf3a0da8e$var$de(t, e) {
    for(var i = 0, n = Object.keys(t); i < n.length; i++){
        var s = n[i];
        if (e === t[s]) return !0;
    }
    return !1;
}
function $9701fb9bf3a0da8e$var$We(t) {
    return $9701fb9bf3a0da8e$var$de($9701fb9bf3a0da8e$var$Fe.INLINES, t.nodeType);
}
$9701fb9bf3a0da8e$var$N.isInline = $9701fb9bf3a0da8e$var$We;
function $9701fb9bf3a0da8e$var$qe(t) {
    return $9701fb9bf3a0da8e$var$de($9701fb9bf3a0da8e$var$Qe.BLOCKS, t.nodeType);
}
$9701fb9bf3a0da8e$var$N.isBlock = $9701fb9bf3a0da8e$var$qe;
function $9701fb9bf3a0da8e$var$Ze(t) {
    return t.nodeType === "text";
}
$9701fb9bf3a0da8e$var$N.isText = $9701fb9bf3a0da8e$var$Ze;
(function(t) {
    var e = $9701fb9bf3a0da8e$export$db3b6bfb95261072 && $9701fb9bf3a0da8e$export$db3b6bfb95261072.__createBinding || (Object.create ? function(c, d, y, _) {
        _ === void 0 && (_ = y);
        var O = Object.getOwnPropertyDescriptor(d, y);
        (!O || ("get" in O ? !d.__esModule : O.writable || O.configurable)) && (O = {
            enumerable: !0,
            get: function() {
                return d[y];
            }
        }), Object.defineProperty(c, _, O);
    } : function(c, d, y, _) {
        _ === void 0 && (_ = y), c[_] = d[y];
    }), i = $9701fb9bf3a0da8e$export$db3b6bfb95261072 && $9701fb9bf3a0da8e$export$db3b6bfb95261072.__setModuleDefault || (Object.create ? function(c, d) {
        Object.defineProperty(c, "default", {
            enumerable: !0,
            value: d
        });
    } : function(c, d) {
        c.default = d;
    }), n = $9701fb9bf3a0da8e$export$db3b6bfb95261072 && $9701fb9bf3a0da8e$export$db3b6bfb95261072.__exportStar || function(c, d) {
        for(var y in c)y !== "default" && !Object.prototype.hasOwnProperty.call(d, y) && e(d, c, y);
    }, s = $9701fb9bf3a0da8e$export$db3b6bfb95261072 && $9701fb9bf3a0da8e$export$db3b6bfb95261072.__importStar || function(c) {
        if (c && c.__esModule) return c;
        var d = {};
        if (c != null) for(var y in c)y !== "default" && Object.prototype.hasOwnProperty.call(c, y) && e(d, c, y);
        return i(d, c), d;
    }, r = $9701fb9bf3a0da8e$export$db3b6bfb95261072 && $9701fb9bf3a0da8e$export$db3b6bfb95261072.__importDefault || function(c) {
        return c && c.__esModule ? c : {
            default: c
        };
    };
    Object.defineProperty(t, "__esModule", {
        value: !0
    }), t.helpers = t.EMPTY_DOCUMENT = t.MARKS = t.INLINES = t.BLOCKS = void 0;
    var o = $9701fb9bf3a0da8e$var$C;
    Object.defineProperty(t, "BLOCKS", {
        enumerable: !0,
        get: function() {
            return o.BLOCKS;
        }
    });
    var a = $9701fb9bf3a0da8e$var$v;
    Object.defineProperty(t, "INLINES", {
        enumerable: !0,
        get: function() {
            return a.INLINES;
        }
    });
    var l = $9701fb9bf3a0da8e$var$w;
    Object.defineProperty(t, "MARKS", {
        enumerable: !0,
        get: function() {
            return r(l).default;
        }
    }), n($9701fb9bf3a0da8e$var$ce, t), n($9701fb9bf3a0da8e$var$ue, t), n($9701fb9bf3a0da8e$var$Ee, t);
    var E = $9701fb9bf3a0da8e$var$Q;
    Object.defineProperty(t, "EMPTY_DOCUMENT", {
        enumerable: !0,
        get: function() {
            return r(E).default;
        }
    });
    var u = s($9701fb9bf3a0da8e$var$N);
    t.helpers = u;
})($9701fb9bf3a0da8e$var$D);
function $9701fb9bf3a0da8e$var$ee(t) {
    return !t || typeof t != "object" || !("sys" in t) ? !1 : t.sys.type !== "ResourceLink";
}
function $9701fb9bf3a0da8e$var$te(t) {
    return !t || typeof t != "object" || !("sys" in t) ? !1 : t.sys.type === "ResourceLink";
}
function $9701fb9bf3a0da8e$var$F(t) {
    if (!t || typeof t != "object") return !1;
    const e = t;
    return e.content && e.nodeType === $9701fb9bf3a0da8e$var$D.BLOCKS.DOCUMENT;
}
const $9701fb9bf3a0da8e$var$fe = [
    $9701fb9bf3a0da8e$var$D.BLOCKS.EMBEDDED_ENTRY,
    $9701fb9bf3a0da8e$var$D.BLOCKS.EMBEDDED_ASSET,
    $9701fb9bf3a0da8e$var$D.INLINES.EMBEDDED_ENTRY,
    $9701fb9bf3a0da8e$var$D.INLINES.ENTRY_HYPERLINK,
    $9701fb9bf3a0da8e$var$D.INLINES.ASSET_HYPERLINK
];
function $9701fb9bf3a0da8e$var$he(t) {
    return t.sys && "linkType" in t.sys && t.sys.linkType === $9701fb9bf3a0da8e$var$b;
}
function $9701fb9bf3a0da8e$var$Xe(t, e) {
    return t.name.value === "items" && $9701fb9bf3a0da8e$var$Pe(e) || t.name.value;
}
function $9701fb9bf3a0da8e$var$ye(t, e) {
    var n, s;
    const i = [];
    for (const r of t)r.kind === "Field" && (i.push({
        name: r.name.value,
        alias: (n = r.alias) == null ? void 0 : n.value,
        __typename: e
    }), (s = r.selectionSet) != null && s.selections && i.push(...$9701fb9bf3a0da8e$var$ye(r.selectionSet.selections, $9701fb9bf3a0da8e$var$Xe(r, e))));
    return i;
}
function $9701fb9bf3a0da8e$var$Je(t) {
    var n;
    const e = [];
    for (const s of t.definitions)if (s.kind === "OperationDefinition" || s.kind === "FragmentDefinition") {
        const r = "typeCondition" in s ? s.typeCondition.name.value : (n = s.name) == null ? void 0 : n.value;
        if (!r) {
            $9701fb9bf3a0da8e$var$h.warn("Could not generate __typename for query definition", s);
            continue;
        }
        for (const o of s.selectionSet.selections)o.kind === "Field" && e.push(...$9701fb9bf3a0da8e$var$ye(s.selectionSet.selections, r));
    }
    const i = /* @__PURE__ */ new Map();
    for (const { __typename: s, alias: r, name: o } of e){
        const a = i.get(s) || {
            alias: /* @__PURE__ */ new Map(),
            fields: /* @__PURE__ */ new Set()
        };
        a.fields.add(o), r && a.alias.set(o, r), i.set(s, a);
    }
    return i;
}
function $9701fb9bf3a0da8e$var$_e(t, e, i) {
    if (!i) return !0;
    const n = i.get(e);
    return n ? n.fields.has(t) || n.fields.has($9701fb9bf3a0da8e$var$$(t)) : !1;
}
function $9701fb9bf3a0da8e$var$W(t, e, i) {
    var s;
    const n = (s = i == null ? void 0 : i.get(e)) == null ? void 0 : s.alias;
    if (!n) return t;
    for(const r in t){
        const o = n == null ? void 0 : n.get(r);
        o !== r && (t[o] = t[r]);
    }
    return t;
}
function $9701fb9bf3a0da8e$var$Se(t, e, i) {
    var n, s;
    try {
        const r = e.fields.file, o = r == null ? void 0 : r.details, a = {
            ...t,
            // GraphQL flattens some information
            // and as the live updates are coming from the CMA, we need to transform them
            title: e.fields.title,
            description: e.fields.description,
            contentType: r == null ? void 0 : r.contentType,
            url: $9701fb9bf3a0da8e$var$Me(r == null ? void 0 : r.url),
            // Note: video has no `width` and `height`
            width: (n = o == null ? void 0 : o.image) == null ? void 0 : n.width,
            height: (s = o == null ? void 0 : o.image) == null ? void 0 : s.height
        };
        return $9701fb9bf3a0da8e$var$W(a, $9701fb9bf3a0da8e$var$b, i);
    } catch (r) {
        return $9701fb9bf3a0da8e$var$h.warn("Failed update asset", {
            dataFromPreviewApp: t,
            updateFromEntryEditor: e
        }, r), t;
    }
}
async function $9701fb9bf3a0da8e$var$xe({ contentType: t, dataFromPreviewApp: e, updateFromEntryEditor: i, locale: n, entityReferenceMap: s, gqlParams: r, sendMessage: o }) {
    var E;
    if (e.sys.id !== i.sys.id) return e;
    const a = $9701fb9bf3a0da8e$var$V(e), l = $9701fb9bf3a0da8e$var$m(t.sys.id);
    for (const u of t.fields){
        const c = u.apiName ?? u.name;
        $9701fb9bf3a0da8e$var$_e(c, l, r) && ($9701fb9bf3a0da8e$var$ae(u) ? $9701fb9bf3a0da8e$var$P({
            dataFromPreviewApp: a,
            updateFromEntryEditor: i,
            name: c
        }) : u.type === "RichText" ? await $9701fb9bf3a0da8e$var$et({
            dataFromPreviewApp: a,
            updateFromEntryEditor: i,
            entityReferenceMap: s,
            name: c,
            locale: n,
            gqlParams: r,
            sendMessage: o
        }) : u.type === "Link" ? await $9701fb9bf3a0da8e$var$pe({
            dataFromPreviewApp: a,
            updateFromEntryEditor: i,
            name: c,
            locale: n,
            entityReferenceMap: s,
            gqlParams: r,
            sendMessage: o
        }) : u.type === "Array" && ((E = u.items) == null ? void 0 : E.type) === "Link" && await $9701fb9bf3a0da8e$var$Ie({
            dataFromPreviewApp: a,
            updateFromEntryEditor: i,
            name: c,
            locale: n,
            entityReferenceMap: s,
            gqlParams: r,
            sendMessage: o
        }));
    }
    return $9701fb9bf3a0da8e$var$W(a, l, r);
}
function $9701fb9bf3a0da8e$var$ie(t) {
    return Object.values(t).every((e)=>e.length === 0);
}
async function $9701fb9bf3a0da8e$var$Le(t, e, i, n, s, r, o) {
    if ($9701fb9bf3a0da8e$var$fe.includes(t.nodeType)) {
        if (t.data && t.data.target && t.data.target.sys) {
            const a = {
                sys: {
                    ...t.data.target.sys,
                    type: "Link",
                    linkType: t.data.target.sys.type
                }
            };
            let l;
            if (t.data.target.sys.linkType === "Entry" ? l = await $9701fb9bf3a0da8e$var$Oe({
                referenceFromPreviewApp: null,
                updatedReference: a,
                entityReferenceMap: n,
                locale: s,
                gqlParams: o,
                sendMessage: r
            }) : t.data.target.sys.linkType === "Asset" && (l = await $9701fb9bf3a0da8e$var$De({
                referenceFromPreviewApp: null,
                updatedReference: a,
                entityReferenceMap: n,
                locale: s,
                gqlParams: o,
                sendMessage: r
            })), l) switch(t.nodeType){
                case $9701fb9bf3a0da8e$var$D.BLOCKS.EMBEDDED_ENTRY:
                    e.block.push(l);
                    break;
                case $9701fb9bf3a0da8e$var$D.BLOCKS.EMBEDDED_ASSET:
                    i.block.push(l);
                    break;
                case $9701fb9bf3a0da8e$var$D.INLINES.EMBEDDED_ENTRY:
                    e.inline.push(l);
                    break;
                case $9701fb9bf3a0da8e$var$D.INLINES.ENTRY_HYPERLINK:
                    e.hyperlink.push(l);
                    break;
                case $9701fb9bf3a0da8e$var$D.INLINES.ASSET_HYPERLINK:
                    i.hyperlink.push(l);
                    break;
                default:
                    $9701fb9bf3a0da8e$var$h.warn("Unhandled nodeType in embedded entries in rich text", {
                        nodeType: t.nodeType,
                        ref: l
                    });
            }
        }
    } else if (t.content) for (const a of t.content)await $9701fb9bf3a0da8e$var$Le(a, e, i, n, s, r, o);
}
async function $9701fb9bf3a0da8e$var$Te(t, e, i, n, s) {
    const r = {
        block: [],
        inline: [],
        hyperlink: []
    }, o = {
        block: [],
        inline: [],
        hyperlink: []
    };
    if (t) for (const a of t.content)await $9701fb9bf3a0da8e$var$Le(a, r, o, e, i, n, s);
    return {
        entries: $9701fb9bf3a0da8e$var$ie(r) ? {
            block: [],
            inline: [],
            hyperlink: []
        } : r,
        assets: $9701fb9bf3a0da8e$var$ie(o) ? {
            block: [],
            inline: [],
            hyperlink: []
        } : o
    };
}
async function $9701fb9bf3a0da8e$var$et({ dataFromPreviewApp: t, updateFromEntryEditor: e, name: i, locale: n, entityReferenceMap: s, gqlParams: r, sendMessage: o }) {
    var a;
    t[i] || (t[i] = {}), t[i].json = ((a = e == null ? void 0 : e.fields) == null ? void 0 : a[i]) || null, t[i].links = await $9701fb9bf3a0da8e$var$Te(t[i].json, s, n, o, r);
}
async function $9701fb9bf3a0da8e$var$De({ referenceFromPreviewApp: t, updatedReference: e, entityReferenceMap: i, locale: n, gqlParams: s, sendMessage: r }) {
    const { reference: o } = await $9701fb9bf3a0da8e$var$z({
        entityReferenceMap: i,
        referenceId: e.sys.id,
        isAsset: !0,
        locale: n,
        sendMessage: r
    });
    return $9701fb9bf3a0da8e$var$Se({
        ...t,
        ...e,
        __typename: $9701fb9bf3a0da8e$var$b
    }, o, s);
}
async function $9701fb9bf3a0da8e$var$Oe({ referenceFromPreviewApp: t, updatedReference: e, entityReferenceMap: i, locale: n, gqlParams: s, sendMessage: r }) {
    var E;
    const { reference: o, typeName: a } = await $9701fb9bf3a0da8e$var$z({
        entityReferenceMap: i,
        referenceId: e.sys.id,
        locale: n,
        sendMessage: r
    }), l = {
        ...t,
        ...e,
        __typename: a
    };
    for(const u in o.fields){
        if (!$9701fb9bf3a0da8e$var$_e(u, a, s)) continue;
        const c = o.fields[u];
        if (c && typeof c == "object") $9701fb9bf3a0da8e$var$F(c) && (l[u] = {
            json: c
        }, l[u].links = await $9701fb9bf3a0da8e$var$Te(c, i, n, r, s)), "sys" in c && (l[u] = c, await $9701fb9bf3a0da8e$var$pe({
            dataFromPreviewApp: l,
            updateFromEntryEditor: o,
            locale: n,
            entityReferenceMap: i,
            name: u,
            gqlParams: s,
            sendMessage: r
        }));
        else if (Array.isArray(c) && (E = c[0]) != null && E.sys) {
            const d = $9701fb9bf3a0da8e$var$$(u);
            l[d] = {
                items: c
            }, await $9701fb9bf3a0da8e$var$Ie({
                dataFromPreviewApp: l,
                updateFromEntryEditor: o,
                locale: n,
                entityReferenceMap: i,
                name: u,
                gqlParams: s,
                sendMessage: r
            });
        } else l[u] = c;
    }
    return $9701fb9bf3a0da8e$var$W(l, a, s);
}
async function $9701fb9bf3a0da8e$var$ge({ referenceFromPreviewApp: t, updatedReference: e, entityReferenceMap: i, locale: n, gqlParams: s, sendMessage: r }) {
    return e ? t && t.__typename ? t : e.__typename ? e : $9701fb9bf3a0da8e$var$he(e) ? $9701fb9bf3a0da8e$var$De({
        referenceFromPreviewApp: t,
        updatedReference: e,
        entityReferenceMap: i,
        locale: n,
        gqlParams: s,
        sendMessage: r
    }) : $9701fb9bf3a0da8e$var$Oe({
        referenceFromPreviewApp: t,
        updatedReference: e,
        entityReferenceMap: i,
        locale: n,
        gqlParams: s,
        sendMessage: r
    }) : null;
}
async function $9701fb9bf3a0da8e$var$pe({ dataFromPreviewApp: t, updateFromEntryEditor: e, name: i, locale: n, entityReferenceMap: s, gqlParams: r, sendMessage: o }) {
    var l;
    const a = (l = e == null ? void 0 : e.fields) == null ? void 0 : l[i];
    t[i] = await $9701fb9bf3a0da8e$var$ge({
        referenceFromPreviewApp: t[i],
        updatedReference: a,
        entityReferenceMap: s,
        locale: n,
        gqlParams: r,
        sendMessage: o
    });
}
async function $9701fb9bf3a0da8e$var$Ie({ dataFromPreviewApp: t, updateFromEntryEditor: e, name: i, locale: n, entityReferenceMap: s, gqlParams: r, sendMessage: o }) {
    var u;
    const a = $9701fb9bf3a0da8e$var$$(i), l = ((u = e == null ? void 0 : e.fields) == null ? void 0 : u[i]) || [], E = await Promise.all(l.map(async (c)=>{
        var _, O;
        const d = (O = (_ = t[a]) == null ? void 0 : _.items) == null ? void 0 : O.find((Re)=>Re.sys.id === c.sys.id);
        return await $9701fb9bf3a0da8e$var$ge({
            referenceFromPreviewApp: d,
            updatedReference: c,
            entityReferenceMap: s,
            locale: n,
            gqlParams: r,
            sendMessage: o
        });
    }));
    t[a] || (t[a] = {
        items: []
    }), t[a].items = E.filter(Boolean);
}
function $9701fb9bf3a0da8e$var$j(t) {
    if (Array.isArray(t)) {
        for (const e of t){
            const i = $9701fb9bf3a0da8e$var$j(e);
            if (Object.values(i).includes(!0)) return i;
        }
        return {
            isGQL: !1,
            sysId: null,
            isREST: !1
        };
    } else {
        const e = Object.hasOwn(t, "__typename"), i = Object.hasOwn(t, "sys") ? t.sys.id : null, n = Object.hasOwn(t, "fields");
        return e || i || n ? {
            isGQL: e,
            sysId: i,
            isREST: n
        } : $9701fb9bf3a0da8e$var$j(Object.values(t));
    }
}
function $9701fb9bf3a0da8e$var$tt(t) {
    const { isGQL: e, sysId: i, isREST: n } = $9701fb9bf3a0da8e$var$j(t);
    return i ? !e && !n ? ($9701fb9bf3a0da8e$var$h.error('For live updates as a basic requirement the provided data must include the "fields" property for REST or "__typename" for Graphql, otherwise the data will be treated as invalid and live updates are not applied.', t), {
        isValid: !1,
        sysId: i,
        isGQL: e,
        isREST: n
    }) : {
        isGQL: e,
        isREST: n,
        sysId: i,
        isValid: !0
    } : ($9701fb9bf3a0da8e$var$h.error('Live Updates requires the "sys.id" to be present on the provided data', t), {
        isValid: !1,
        sysId: i,
        isGQL: e,
        isREST: n
    });
}
var $9701fb9bf3a0da8e$export$8b22cf2602fb60ce = /* @__PURE__ */ ((t)=>(t.CONNECTED = "CONNECTED", t.DISCONNECTED = "DISCONNECTED", t.ERROR = "ERROR", t.IFRAME_CONNECTED = "IFRAME_CONNECTED", t.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", t.URL_CHANGED = "URL_CHANGED", t.SUBSCRIBED = "SUBSCRIBED", t.ENTRY_UPDATED = "ENTRY_UPDATED", t.ENTRY_SAVED = "ENTRY_SAVED", t.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", t.ENTITY_NOT_KNOWN = "ENTITY_NOT_KNOWN", t.UNKNOWN_REFERENCE_LOADED = "UNKNOWN_REFERENCE_LOADED", t))($9701fb9bf3a0da8e$export$8b22cf2602fb60ce || {});
function $9701fb9bf3a0da8e$export$ae1af26003f05816(t, e, i, n) {
    $9701fb9bf3a0da8e$var$g("TAGGED_FIELD_CLICKED", {
        action: "TAGGED_FIELD_CLICKED",
        fieldId: t,
        entryId: e,
        locale: i
    }, n);
}
function $9701fb9bf3a0da8e$var$st(t, e) {
    return t.name === "Asset" ? e.id : e.apiName || e.name;
}
async function $9701fb9bf3a0da8e$var$q(t, e, i, n, s, r, o) {
    let a;
    const l = "urn" in e.sys ? e.sys.urn : e.sys.id;
    if (r.has(l)) $9701fb9bf3a0da8e$var$h.warn("Detected a circular reference, stopping recursion"), a = r.get(l);
    else {
        const { reference: u } = await $9701fb9bf3a0da8e$var$z({
            entityReferenceMap: n,
            referenceId: e.sys.id,
            ...$9701fb9bf3a0da8e$var$he(e) ? {
                isAsset: !0
            } : void 0,
            locale: i,
            sendMessage: o
        });
        a = u, r.set(l, u);
    }
    if (!a) return t;
    const E = $9701fb9bf3a0da8e$var$V(a);
    for(const u in a.fields){
        const c = a.fields[u];
        if ($9701fb9bf3a0da8e$var$ee(c) && s < $9701fb9bf3a0da8e$var$B) await $9701fb9bf3a0da8e$var$Ae(E, a, i, u, n, s + 1, r, o);
        else if (Array.isArray(c) && $9701fb9bf3a0da8e$var$ee(c[0]) && s < $9701fb9bf3a0da8e$var$B) await $9701fb9bf3a0da8e$var$Ne(E, a, i, u, n, s + 1, r, o);
        else if ($9701fb9bf3a0da8e$var$F(c)) await $9701fb9bf3a0da8e$var$Ce(E, a, u, i, n, s + 1, r, o);
        else {
            if ($9701fb9bf3a0da8e$var$te(c) || Array.isArray(c) && $9701fb9bf3a0da8e$var$te(c[0])) return $9701fb9bf3a0da8e$var$h.warn("Detected a resource link, support is still under development."), E;
            $9701fb9bf3a0da8e$var$P({
                dataFromPreviewApp: E.fields,
                updateFromEntryEditor: a,
                name: u
            });
        }
    }
    return E;
}
async function $9701fb9bf3a0da8e$var$Ne(t, e, i, n, s, r, o, a) {
    var l;
    if (!((l = e.fields) != null && l[n])) {
        delete t.fields[n];
        return;
    }
    return t.fields[n] = await Promise.all(e.fields[n].map((E, u)=>{
        var c;
        return $9701fb9bf3a0da8e$var$q((c = t.fields[n]) == null ? void 0 : c[u], E, i, s, r + 1, o, a);
    })).then((E)=>E.filter(Boolean)), t;
}
async function $9701fb9bf3a0da8e$var$Ae(t, e, i, n, s, r, o, a) {
    var E;
    const l = (E = e == null ? void 0 : e.fields) == null ? void 0 : E[n];
    if (!l) {
        delete t.fields[n];
        return;
    }
    return t.fields[n] = await $9701fb9bf3a0da8e$var$q(t.fields[n], l, i, s, r + 1, o, a), t;
}
async function $9701fb9bf3a0da8e$var$be(t, e, i, n, s, r) {
    var o;
    if ($9701fb9bf3a0da8e$var$fe.includes(t.nodeType) && t.data && t.data.target && t.data.target.sys && (t.data.target.sys.linkType === "Entry" || t.data.target.sys.linkType === "Asset")) {
        const l = {
            sys: {
                id: ((o = t.data.target) == null ? void 0 : o.sys.id) || "",
                type: "Link",
                linkType: t.data.target.sys.linkType
            }
        };
        t.data.target = await $9701fb9bf3a0da8e$var$q(void 0, l, i, e, n + 1, s, r);
    }
    if (t.content) for (const a of t.content)await $9701fb9bf3a0da8e$var$be(a, e, i, n + 1, s, r);
}
async function $9701fb9bf3a0da8e$var$Ce(t, e, i, n, s, r, o, a) {
    var E;
    const l = (E = e.fields) == null ? void 0 : E[i];
    if ($9701fb9bf3a0da8e$var$F(l)) {
        t.fields[i] = l;
        for (const u of l.content)await $9701fb9bf3a0da8e$var$be(u, s, n, r, o, a);
    }
}
async function $9701fb9bf3a0da8e$var$nt(t, e, i, n, s, r, o, a) {
    var l;
    if (e.sys.id !== i.sys.id) return e;
    for (const E of t.fields){
        const u = $9701fb9bf3a0da8e$var$st(t, E);
        if ($9701fb9bf3a0da8e$var$ae(E) || E.type === "File") $9701fb9bf3a0da8e$var$P({
            dataFromPreviewApp: e.fields,
            updateFromEntryEditor: i,
            name: u
        });
        else if (E.type === "Link" && r < $9701fb9bf3a0da8e$var$B) await $9701fb9bf3a0da8e$var$Ae(e, i, n, u, s, r + 1, o, a);
        else if (E.type === "Array" && ((l = E.items) == null ? void 0 : l.type) === "Link" && r < $9701fb9bf3a0da8e$var$B) await $9701fb9bf3a0da8e$var$Ne(e, i, n, u, s, r + 1, o, a);
        else if (E.type === "RichText") await $9701fb9bf3a0da8e$var$Ce(e, i, u, n, s, r, o, a);
        else if (E.type === "ResourceLink") return $9701fb9bf3a0da8e$var$h.warn("Detected a resource link, support is still under development."), e;
    }
    return e;
}
class $9701fb9bf3a0da8e$var$rt {
    constructor({ locale: e, targetOrigin: i }){
        $9701fb9bf3a0da8e$var$f(this, "subscriptions", /* @__PURE__ */ new Map());
        $9701fb9bf3a0da8e$var$f(this, "storage");
        $9701fb9bf3a0da8e$var$f(this, "defaultLocale");
        $9701fb9bf3a0da8e$var$f(this, "sendMessage");
        this.defaultLocale = e, this.sendMessage = (n, s)=>$9701fb9bf3a0da8e$var$g(n, s, i), this.storage = new $9701fb9bf3a0da8e$var$Ue("live-updates", /* @__PURE__ */ new Map()), window.addEventListener("beforeunload", ()=>this.clearStorage());
    }
    async mergeEntity({ contentType: e, dataFromPreviewApp: i, entityReferenceMap: n, locale: s, updateFromEntryEditor: r, gqlParams: o }) {
        return "__typename" in i ? {
            data: await (i.__typename === "Asset" ? $9701fb9bf3a0da8e$var$Se(i, r, o) : $9701fb9bf3a0da8e$var$xe({
                contentType: e,
                dataFromPreviewApp: i,
                updateFromEntryEditor: r,
                locale: s,
                entityReferenceMap: n,
                gqlParams: o,
                sendMessage: this.sendMessage
            })),
            updated: !0
        } : this.isCfEntity(i) ? {
            data: await $9701fb9bf3a0da8e$var$nt(e, i, r, s, n, 0, /* @__PURE__ */ new Map(), this.sendMessage),
            updated: !0
        } : {
            updated: !1,
            data: i
        };
    }
    /**
   * Merges the `dataFromPreviewApp` together with the `updateFromEntryEditor`
   * If there is not direct match, it will try to merge things together recursively
   * caches the result if cache is enabled and the entity has a `sys.id`.
   * Caching should not be enabled for every entry,
   * because nested references could be merged differently together and this could solve to data loss.
   */ async mergeNestedReference({ dataFromPreviewApp: e, ...i }, n) {
        const s = $9701fb9bf3a0da8e$var$R(e) && e.sys.id, r = n && s;
        let o = !1, a = (r ? this.storage.get(s, i.locale) : void 0) || e;
        if ($9701fb9bf3a0da8e$var$R(a) && s === i.updateFromEntryEditor.sys.id) {
            const l = await this.mergeEntity({
                ...i,
                dataFromPreviewApp: a
            });
            a = l.data, o = l.updated;
        } else for(const l in a)if (a[l] && typeof a[l] == "object") {
            const E = await this.merge({
                ...i,
                dataFromPreviewApp: a[l]
            }, !1);
            a[l] = E.data, o = o || E.updated;
        }
        return r && this.storage.set(s, i.locale, a), {
            data: a,
            updated: o
        };
    }
    async merge({ dataFromPreviewApp: e, ...i }, n = !0) {
        if (Array.isArray(e)) {
            const s = [];
            let r = !1;
            for (const o of e){
                const a = await this.mergeNestedReference({
                    ...i,
                    dataFromPreviewApp: o
                }, n);
                s.push(a.data), r = r || a.updated;
            }
            return {
                data: s,
                updated: r
            };
        }
        return this.mergeNestedReference({
            ...i,
            dataFromPreviewApp: e
        }, n);
    }
    isCfEntity(e) {
        return $9701fb9bf3a0da8e$var$R(e) && "fields" in e;
    }
    /** Receives the data from the message event handler and calls the subscriptions */ async receiveMessage(e) {
        if ("action" in e && e.action === "ENTRY_UPDATED" || e.method === $9701fb9bf3a0da8e$export$8b22cf2602fb60ce.ENTRY_UPDATED) {
            const { entity: i, contentType: n, entityReferenceMap: s } = e;
            await Promise.all([
                ...this.subscriptions
            ].map(async ([, r])=>{
                try {
                    const { updated: o, data: a } = await this.merge({
                        // Clone the original data on the top level,
                        // to prevent cloning multiple times (time)
                        // or modifying the original data (failure potential)
                        dataFromPreviewApp: $9701fb9bf3a0da8e$var$V(r.data),
                        locale: r.locale || this.defaultLocale,
                        updateFromEntryEditor: i,
                        contentType: n,
                        entityReferenceMap: s,
                        gqlParams: r.gqlParams
                    });
                    o && r.callback(a);
                } catch (o) {
                    this.sendErrorMessage({
                        message: o.message,
                        payload: {
                            data: r.data,
                            update: i
                        },
                        type: "SUBSCRIPTION_UPDATE_FAILED"
                    }), $9701fb9bf3a0da8e$var$h.error("Failed to apply live update", {
                        error: o,
                        subscribedData: r.data,
                        updateFromEditor: i
                    });
                }
            }));
        }
    }
    async restore(e, i, n) {
        if (!e) return;
        const s = (a)=>{
            if ($9701fb9bf3a0da8e$var$R(a)) {
                const l = this.storage.get(a.sys.id, i);
                if (l) return l;
            }
            return a;
        };
        let r;
        if (Array.isArray(e)) r = e.map(s);
        else {
            const a = s(e);
            a !== e && (r = a);
        }
        const o = this.subscriptions.get(n);
        o && r && o.callback(r);
    }
    clearStorage() {
        this.storage.clear();
    }
    sendErrorMessage(e) {
        this.sendMessage($9701fb9bf3a0da8e$export$8b22cf2602fb60ce.ERROR, e);
    }
    /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */ subscribe(e) {
        const { isGQL: i, isValid: n, sysId: s, isREST: r } = $9701fb9bf3a0da8e$var$tt(e.data);
        if (!n) return this.sendErrorMessage({
            message: "Failed to subscribe",
            payload: {
                isGQL: i,
                isValid: n,
                sysId: s,
                isREST: r
            },
            type: "SUBSCRIPTION_SETUP_FAILED"
        }), ()=>{};
        const o = $9701fb9bf3a0da8e$var$He(), a = e.locale || this.defaultLocale;
        return this.subscriptions.set(o, {
            ...e,
            sysId: s,
            gqlParams: e.query ? $9701fb9bf3a0da8e$var$Je(e.query) : void 0
        }), setTimeout(()=>{
            this.restore(e.data, a, o);
        }, 0), this.sendMessage($9701fb9bf3a0da8e$export$8b22cf2602fb60ce.SUBSCRIBED, {
            action: $9701fb9bf3a0da8e$export$8b22cf2602fb60ce.SUBSCRIBED,
            type: i ? "GQL" : "REST",
            locale: a,
            entryId: s,
            event: "edit"
        }), ()=>{
            this.subscriptions.delete(o);
        };
    }
}
class $9701fb9bf3a0da8e$var$at {
    constructor({ locale: e }){
        $9701fb9bf3a0da8e$var$f(this, "locale");
        $9701fb9bf3a0da8e$var$f(this, "subscription");
        this.locale = e;
    }
    subscribe(e) {
        return this.subscription && $9701fb9bf3a0da8e$var$h.log("There is already a subscription for the save event, the existing one will be replaced."), this.subscription = e, ()=>{
            this.subscription = void 0;
        };
    }
    receiveMessage(e) {
        if (e.method === $9701fb9bf3a0da8e$export$8b22cf2602fb60ce.ENTRY_SAVED && this.subscription) {
            const { entity: i } = e;
            $9701fb9bf3a0da8e$var$le().includes(i.sys.id) && this.subscription(i);
        }
    }
}
const $9701fb9bf3a0da8e$export$e7c866399fa523f5 = $9701fb9bf3a0da8e$var$ne, $9701fb9bf3a0da8e$var$ot = [
    "https://app.contentful.com",
    "https://app.eu.contentful.com"
], $9701fb9bf3a0da8e$var$T = class T {
    // Static method to initialize the LivePreview SDK
    static init(e) {
        if (typeof e != "object" || !(e != null && e.locale)) throw new Error("Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)");
        const { debugMode: i, enableInspectorMode: n, enableLiveUpdates: s, locale: r, targetOrigin: o = $9701fb9bf3a0da8e$var$ot } = e;
        if (typeof window < "u") {
            if (!$9701fb9bf3a0da8e$var$Ge()) return this.liveUpdatesEnabled = !1, Promise.resolve(null);
            if (i && $9701fb9bf3a0da8e$var$Z(i), typeof n == "boolean" && (this.inspectorModeEnabled = n), typeof s == "boolean" && (this.liveUpdatesEnabled = s), this.locale = r, this.targetOrigin = Array.isArray(o) ? o : [
                o
            ], this.initialized) return $9701fb9bf3a0da8e$var$h.log("You have already initialized the Live Preview SDK."), Promise.resolve(T.inspectorMode);
            this.inspectorModeEnabled && (this.inspectorMode = new $9701fb9bf3a0da8e$var$$e({
                locale: r,
                targetOrigin: this.targetOrigin
            })), this.liveUpdatesEnabled && (this.liveUpdates = new $9701fb9bf3a0da8e$var$rt({
                locale: r,
                targetOrigin: this.targetOrigin
            }), this.saveEvent = new $9701fb9bf3a0da8e$var$at({
                locale: r
            })), window.addEventListener("message", (l)=>{
                var E, u, c;
                if ($9701fb9bf3a0da8e$var$Ve(l)) {
                    if ($9701fb9bf3a0da8e$var$h.log("Received message", l.data), "action" in l.data && l.data.action === "DEBUG_MODE_ENABLED" || l.data.method === $9701fb9bf3a0da8e$export$8b22cf2602fb60ce.DEBUG_MODE_ENABLED) {
                        $9701fb9bf3a0da8e$var$Z(!0);
                        return;
                    }
                    this.inspectorModeEnabled && ((E = this.inspectorMode) == null || E.receiveMessage(l.data)), this.liveUpdatesEnabled && ((u = this.liveUpdates) == null || u.receiveMessage(l.data), (c = this.saveEvent) == null || c.receiveMessage(l.data));
                }
            }), $9701fb9bf3a0da8e$var$ke(()=>{
                $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$8b22cf2602fb60ce.URL_CHANGED, {
                    action: $9701fb9bf3a0da8e$export$8b22cf2602fb60ce.URL_CHANGED,
                    taggedElementCount: document.querySelectorAll(`[${$9701fb9bf3a0da8e$var$L.ENTRY_ID}]`).length
                }, this.targetOrigin);
            });
            const a = document.querySelectorAll(`[${$9701fb9bf3a0da8e$var$L.ENTRY_ID}]`).length;
            return $9701fb9bf3a0da8e$var$g($9701fb9bf3a0da8e$export$8b22cf2602fb60ce.CONNECTED, {
                action: $9701fb9bf3a0da8e$export$8b22cf2602fb60ce.CONNECTED,
                connected: !0,
                tags: a,
                taggedElementCount: a,
                locale: this.locale,
                isInspectorEnabled: this.inspectorModeEnabled,
                isLiveUpdatesEnabled: this.liveUpdatesEnabled
            }, this.targetOrigin), this.initialized = !0, Promise.resolve(T.inspectorMode);
        }
    }
    static subscribe(e, i) {
        if (!this.liveUpdatesEnabled) return ()=>{};
        const n = typeof e == "string" ? e : "edit", s = typeof e == "object" ? e : i;
        if (n === "save") {
            if (!this.saveEvent) throw new Error("Save event is not initialized, please call `ContentfulLivePreview.init()` first.");
            return this.saveEvent.subscribe(s.callback);
        }
        if (!this.liveUpdates) throw new Error("Live updates are not initialized, please call `ContentfulLivePreview.init()` first.");
        return this.liveUpdates.subscribe(s);
    }
    // Static method to render live preview data-attributes to HTML element output
    static getProps({ fieldId: e, entryId: i, locale: n }) {
        return this.inspectorModeEnabled ? !e || !i ? ($9701fb9bf3a0da8e$var$h.warn("Missing property for inspector mode", {
            fieldId: e,
            entryId: i
        }), null) : {
            [$9701fb9bf3a0da8e$var$L.FIELD_ID]: e,
            [$9701fb9bf3a0da8e$var$L.ENTRY_ID]: i,
            [$9701fb9bf3a0da8e$var$L.LOCALE]: n
        } : null;
    }
    static toggleInspectorMode() {
        return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
    }
    static toggleLiveUpdatesMode() {
        return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
    }
    static openEntryInEditor({ fieldId: e, entryId: i, locale: n }) {
        (!e || !i) && $9701fb9bf3a0da8e$var$h.error("Please provide field id and entry id to openEntryInEditor."), $9701fb9bf3a0da8e$export$ae1af26003f05816(e, i, n || this.locale, this.targetOrigin);
    }
    /**
   * Returns a list of tagged entries on the page
   */ static getEntryList() {
        return $9701fb9bf3a0da8e$var$le();
    }
};
$9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "initialized", !1), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "inspectorMode", null), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "liveUpdates", null), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "saveEvent", null), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "inspectorModeEnabled", !0), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "liveUpdatesEnabled", !0), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "locale"), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "sendMessage"), $9701fb9bf3a0da8e$var$f($9701fb9bf3a0da8e$var$T, "targetOrigin");
let $9701fb9bf3a0da8e$export$e7094788287c5e9b = $9701fb9bf3a0da8e$var$T;

});


parcelRegister("aFpyD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c104d4bbf0e8f7c7$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $ezbi8 = parcelRequire("ezbi8");

var $izjX7 = parcelRequire("izjX7");

var $3xOZa = parcelRequire("3xOZa");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $88FA0 = parcelRequire("88FA0");

var $gtsdT = parcelRequire("gtsdT");

var $65KWP = parcelRequire("65KWP");

var $jlTfJ = parcelRequire("jlTfJ");

var $isIf6 = parcelRequire("isIf6");
/**
 * ImageWithFocus is a component that renders an image with focus point.
 *
 * It uses the Contentful API to fetch the image data, and then renders the image using the Cloudinary API.
 *
 * The image is rendered using the &lt;picture&gt; tag, with <source> tags for each media query.
 * The &lt;img&gt; tag is also rendered last, and is used as a fallback for browsers that do not
 * support <picture>. The loading attribute on &lt;img&gt; tag is also used to specify the loading strategy for the image.
 *
 * &lt;img&gt; is the tag actually being displayed in the browser. For more information about how <picture>
 * works, see https://stackoverflow.com/a/60405256
 *
 * @param entryId The Contentful Entry ID for the ImageWithFocus content
 * @param width The width of the image on desktop, full width is typically 1250px
 * @param ratio The aspect ratio of the image, 3x2, 16x9, 21x9 or 32x9
 * @param placement Whether the image is likely to be above or below the fold in the current layout, used to determine loading strategy
 * @param className Additional classes to apply to the image
 * @constructor
 */ const $c104d4bbf0e8f7c7$var$ImageWithFocus = ({ entryId: entryId, width: width, ratio: ratio, placement: placement, className: className, imageFromParent: imageFromParent, ...rest })=>{
    const [image, setImage] = (0, $dvPqk.useState)();
    (0, $dvPqk.useEffect)(()=>{
        const fetchImage = async ()=>{
            if (!entryId) return;
            if (imageFromParent?.fields && (0, $jlTfJ.default).isPreviewMode) {
                const image = (0, $65KWP.fromContentToImageWithFocus)(imageFromParent);
                setImage(image);
            } else {
                const imageWithFocus = await (0, $jlTfJ.default).getImageWithFocusUsingCache(entryId);
                setImage(imageWithFocus);
            }
        };
        fetchImage();
    }, [
        entryId
    ]);
    const imageClassName = (0, $izjX7.cn)(className, "size-full rounded-md");
    if ((0, $3xOZa.default)(entryId)) {
        (0, $gtsdT.logger).warn("contentful", "Attempting to insert ImageWithFocus with undefined entryId");
        return null;
    }
    const height = {
        "32x9": Math.round((width ?? 0) * 9 / 32),
        "16x9": Math.round((width ?? 0) * 9 / 16),
        "21x9": Math.round((width ?? 0) * 9 / 21),
        "3x2": Math.round((width ?? 0) * 2 / 3)
    }[ratio];
    const preferredLoadingStrategy = placement === "aboveFold" ? "eager" : "lazy";
    if ((0, $jlTfJ.default).isPreviewMode && (0, $3xOZa.default)(image)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
        variant: "information",
        showCloseButton: false,
        children: "Bildet dukker opp n\xe5r alle feltene p\xe5 bildet er fylt ut"
    });
    if ((0, $3xOZa.default)(image) || (0, $3xOZa.default)(image.originalAssetUrl)) // Image data not fetched from Contentful yet...
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: `ratio ratio-${ratio}`,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
            width: width,
            height: height
        })
    });
    const sizes = (0, $65KWP.generateSizesFromMaxSize)(width, height);
    const urlFactory = (width, height)=>(0, $65KWP.createCloudinaryUrl)(image, width, height, (0, $isIf6.default).contentImages.cloudinaryMapping) || "";
    const sourceSetItems = (0, $65KWP.createSourceSet)(sizes, urlFactory);
    const itemsForSourceTags = sourceSetItems.filter((sourceSetItem)=>sourceSetItem.media.length > 0);
    const itemForImgTag = sourceSetItems.find((sourceSetItem)=>sourceSetItem.media.length === 0);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("picture", {
            children: [
                itemsForSourceTags.map((sourceSetItem)=>/*#__PURE__*/ (0, $7YWoO.jsx)("source", {
                        srcSet: sourceSetItem.url,
                        media: sourceSetItem.media,
                        width: sourceSetItem.width,
                        height: sourceSetItem.height
                    }, sourceSetItem.media + sourceSetItem.width)),
                itemForImgTag && /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                    ...rest,
                    className: imageClassName,
                    alt: image.altText,
                    src: itemForImgTag.url,
                    width: itemForImgTag.width,
                    height: itemForImgTag.height,
                    loading: preferredLoadingStrategy
                })
            ]
        })
    });
};
var $c104d4bbf0e8f7c7$export$2e2bcd8739ae039 = (0, $gBcml.observer)($c104d4bbf0e8f7c7$var$ImageWithFocus);

});

parcelRegister("4fOOV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc0c00aabf5d8f62$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
const $cc0c00aabf5d8f62$var$PublishDate = ({ createdAt: createdAt, updatedAt: updatedAt, className: className })=>/*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
        className: (0, $izjX7.cn)("text-sm lg:text-lg font-light", className),
        children: [
            "Publisert ",
            new Date(createdAt).toLocaleDateString("no-NO"),
            " | Oppdatert ",
            new Date(updatedAt).toLocaleDateString("no-NO")
        ]
    });
var $cc0c00aabf5d8f62$export$2e2bcd8739ae039 = $cc0c00aabf5d8f62$var$PublishDate;

});


parcelRegister("hX0dq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61449d4724d3f3f2$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $8ICkW = parcelRequire("8ICkW");

var $izjX7 = parcelRequire("izjX7");

var $aUIXP = parcelRequire("aUIXP");
const $61449d4724d3f3f2$var$SimpleArticleHero = ({ article: article, id: id })=>{
    const inspectorProps = (0, $8ICkW.useContentfulInspectorMode)();
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                className: "mt-2 mb-6",
                ...inspectorProps({
                    entryId: id,
                    fieldId: "title"
                }),
                children: article.fields.title
            }),
            article.fields.preface && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                className: (0, $izjX7.cn)((0, $aUIXP.prefaceFont), "mb-6 font-normal"),
                ...inspectorProps({
                    entryId: id,
                    fieldId: "preface"
                }),
                children: article.fields.preface
            })
        ]
    });
};
var $61449d4724d3f3f2$export$2e2bcd8739ae039 = $61449d4724d3f3f2$var$SimpleArticleHero;

});

parcelRegister("lNalp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5a3b2328c33e147$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $8ICkW = parcelRequire("8ICkW");

var $fqWHZ = parcelRequire("fqWHZ");

var $izjX7 = parcelRequire("izjX7");

var $dZidx = parcelRequire("dZidx");

var $aFpyD = parcelRequire("aFpyD");

var $aUIXP = parcelRequire("aUIXP");

var $4fOOV = parcelRequire("4fOOV");
const $e5a3b2328c33e147$var$StandardArticleHero = ({ article: article, id: id })=>{
    const inspectorProps = (0, $8ICkW.useContentfulInspectorMode)();
    const headerImage = article.fields.headerImage || undefined;
    const { title: title, preface: preface } = article.fields;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "relative mb-10",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dZidx.default), {
                color: "bg-infoBoxBackground"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
                className: "relative w-full md:flex-row py-8 lg:py-16 md:gap-10",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
                        justify: "center",
                        align: "start",
                        className: "md:w-1/2 md:gap-8",
                        gap: 5,
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                                className: "text-3xl lg:text-5xl mb-0",
                                ...inspectorProps({
                                    entryId: id,
                                    fieldId: "title"
                                }),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: (0, $izjX7.cn)((0, $aUIXP.prefaceFont), "mb-0"),
                                ...inspectorProps({
                                    entryId: id,
                                    fieldId: "preface"
                                }),
                                children: preface
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4fOOV.default), {
                                createdAt: article.sys.createdAt,
                                updatedAt: article.sys.updatedAt,
                                className: "mb-0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "md:w-1/2",
                        children: headerImage && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
                                width: 1250,
                                ratio: "3x2",
                                entryId: headerImage.sys.id,
                                placement: "aboveFold",
                                className: "rounded-md object-cover",
                                ...inspectorProps({
                                    entryId: id,
                                    fieldId: "headerImage"
                                }),
                                imageFromParent: headerImage
                            }, headerImage.sys.id)
                        })
                    })
                ]
            })
        ]
    });
};
var $e5a3b2328c33e147$export$2e2bcd8739ae039 = $e5a3b2328c33e147$var$StandardArticleHero;

});
parcelRegister("fqWHZ", function(module, exports) {

$parcel$export(module.exports, "Stack", function () { return $b3c6d2fd79aad10b$export$694e0d28c7ffc90c; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
const $b3c6d2fd79aad10b$var$o = {
    start: "items-start",
    center: "items-center",
    end: "items-end",
    between: "items-between",
    around: "items-around",
    evenly: "items-evenly",
    stretch: "items-stretch"
}, $b3c6d2fd79aad10b$var$f = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
    between: "justify-between",
    around: "justify-around",
    evenly: "justify-evenly",
    stretch: "justify-stretch"
}, $b3c6d2fd79aad10b$var$S = {
    nowrap: "flex-nowrap",
    wrap: "flex-wrap",
    "wrap-reverse": "flex-wrap-reverse"
}, $b3c6d2fd79aad10b$var$l = {
    0: "gap-0",
    1: "gap-1",
    2: "gap-2",
    3: "gap-3",
    4: "gap-4",
    5: "gap-5",
    6: "gap-6",
    8: "gap-8",
    10: "gap-10",
    12: "gap-12",
    16: "gap-16",
    20: "gap-20",
    24: "gap-24",
    32: "gap-32",
    40: "gap-40",
    48: "gap-48",
    56: "gap-56",
    64: "gap-64"
};
function $b3c6d2fd79aad10b$export$694e0d28c7ffc90c({ children: e, align: t = "center", gap: a = 4, grow: r = !1, justify: s = "center", wrap: n = "nowrap", className: p = "", ...c }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)("flex flex-col", r && "grow", $b3c6d2fd79aad10b$var$o[t], $b3c6d2fd79aad10b$var$f[s], $b3c6d2fd79aad10b$var$S[n], $b3c6d2fd79aad10b$var$l[a], p),
        ...c,
        children: e
    });
}
$b3c6d2fd79aad10b$export$694e0d28c7ffc90c.displayName = "Stack";

});



parcelRegister("e2HE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9714006efcb229e9$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $aRSTV = parcelRequire("aRSTV");

var $bcbvQ = parcelRequire("bcbvQ");

var $hOaHV = parcelRequire("hOaHV");

var $bZiDo = parcelRequire("bZiDo");

var $luszM = parcelRequire("luszM");

var $j5K5X = parcelRequire("j5K5X");

var $3kQAm = parcelRequire("3kQAm");

var $4r4cM = parcelRequire("4r4cM");

var $3VAM4 = parcelRequire("3VAM4");

var $lrKDY = parcelRequire("lrKDY");
const $9714006efcb229e9$var$CmsAutomaticProductList = ({ content: content, context: context })=>{
    const title = content.fields.title;
    const type = content.fields.type;
    const productCount = content.fields.productCount;
    const numberOfProducts = productCount === "Ubegrenset" ? Number.MAX_SAFE_INTEGER : productCount ? Number.parseInt(productCount) : content.fields.numberOfProducts || Number.MAX_SAFE_INTEGER;
    if (!(0, $bcbvQ.default).isLoggedIn()) return null;
    switch(type){
        case "User Favorites":
            {
                const skus = (0, $bZiDo.default).resolveSkus((0, $hOaHV.default).allSkus, true).map((product)=>product.sku);
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                    skus: skus.slice(0, numberOfProducts),
                    buttonUrl: "/customer/favorites",
                    listName: "Mine Favoritter (CMS Block)",
                    listType: (0, $aRSTV.LIST_TYPE).RECOMMENDATIONS,
                    heading: title,
                    context: context
                });
            }
        case "Contractual Recommendations - Should Buy":
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j5K5X.default), {
                heading: title,
                count: numberOfProducts,
                type: "shouldBuy"
            });
        case "Contractual Recommendations - Full List":
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j5K5X.default), {
                heading: title,
                count: numberOfProducts,
                type: "fullList"
            });
        case "User Favorites And Subscriptions":
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3VAM4.default), {
                heading: title
            });
        case "Recommendations":
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lrKDY.default), {
                heading: null,
                count: numberOfProducts
            });
        case "Expired":
            {
                const expiredProducts = (0, $bZiDo.default).replacementProducts.map((product)=>product.oldSku);
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                    skus: expiredProducts,
                    heading: title,
                    listName: "Expired products",
                    listType: (0, $aRSTV.LIST_TYPE).EXPIRED,
                    context: "expired-products"
                });
            }
        case "Last Chance":
            {
                const lastChanceProducts = (0, $bZiDo.default).products.filter((product)=>(0, $luszM.shouldShowExpiryNotice)(product)).map((product)=>product.sku);
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                    skus: lastChanceProducts,
                    heading: title,
                    listName: "Last chance",
                    listType: (0, $aRSTV.LIST_TYPE).LAST_CHANCE,
                    context: "last-chance-products"
                });
            }
        default:
            return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $4r4cM.default), {
                showCloseButton: false,
                gaErrorTracking: {
                    context: "cms_content",
                    text: "products_error"
                },
                children: [
                    "Det opppsto en uventet feil under visning av innhold ",
                    content.sys.id
                ]
            });
    }
};
var $9714006efcb229e9$export$2e2bcd8739ae039 = (0, $gBcml.observer)($9714006efcb229e9$var$CmsAutomaticProductList);

});
parcelRegister("j5K5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f56d9d8df02d946$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $aRSTV = parcelRequire("aRSTV");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $44W8i = parcelRequire("44W8i");

var $3kQAm = parcelRequire("3kQAm");

var $9Vrue = parcelRequire("9Vrue");
const $3f56d9d8df02d946$var$ContractualProductList = ({ heading: heading, count: count, type: type })=>{
    if (!(0, $bcbvQ.default).isLoggedIn()) return null;
    if ((0, $duLFK.isDefaultData)((0, $44W8i.default).contractualRecommendations)) (0, $44W8i.default).getContractualRecommendations();
    if ((0, $duLFK.isLoading)((0, $44W8i.default).contractualRecommendations)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {});
    const data = (0, $44W8i.default).contractualRecommendations.data;
    const skus = type === "shouldBuy" ? data?.shouldBuy || [] : [
        ...data?.voluntaryProducts || [],
        ...data?.contractualObligatedProducts.map((p)=>p.sku) || []
    ];
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
        skus: skus,
        heading: heading,
        count: count,
        listName: "Avtalt Sortiment",
        listType: (0, $aRSTV.LIST_TYPE).CONTRACTUAL_PRODUCTS,
        context: "contractual-products"
    });
};
var $3f56d9d8df02d946$export$2e2bcd8739ae039 = (0, $gBcml.observer)($3f56d9d8df02d946$var$ContractualProductList);

});
parcelRegister("9Vrue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f44db6be61ab5508$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $b3J4G = parcelRequire("b3J4G");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $kUJJo = parcelRequire("kUJJo");
const $f44db6be61ab5508$var$Loading = ({ simple: simple = false, modal: modal = false, label: label = null, className: className = "", delay: delay = true })=>{
    const [isVisible, setVisible] = (0, $dvPqk.useState)(!delay);
    (0, $dvPqk.useEffect)(()=>{
        if (!delay) return;
        const timerId = setTimeout(()=>{
            setVisible(true);
        }, 150);
        return ()=>{
            clearTimeout(timerId);
        };
    }, [
        delay
    ]);
    if (!isVisible) return null;
    if (simple) return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3J4G.default), {
                className: (0, $izjX7.cn)("inline-block animate-spin mr-2")
            }),
            label && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                children: label
            })
        ]
    });
    if (modal) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kUJJo.default), {
        TitleIcon: ()=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3J4G.default), {
                className: "h-5 w-5 animate-spin"
            }),
        name: "Vennligst vent",
        isOpen: true,
        title: "Vennligst vent",
        showCloseButton: false,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: "flex items-center gap-2",
            children: label && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                children: label
            })
        })
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: `flex justify-center ${className}`,
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: (0, $izjX7.cn)("flex gap-2 text-center"),
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3J4G.default), {
                    className: (0, $izjX7.cn)("animate-spin", {
                        "w-1/12": label
                    })
                }),
                label && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                    children: label
                })
            ]
        })
    });
};
var $f44db6be61ab5508$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f44db6be61ab5508$var$Loading);

});
parcelRegister("kUJJo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b4991a45edb5062$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $34rNI = parcelRequire("34rNI");

var $dvPqk = parcelRequire("dvPqk");

var $6fuyt = parcelRequire("6fuyt");
const $7b4991a45edb5062$var$Modal = ({ name: name, title: title, TitleIcon: TitleIcon, isOpen: isOpen, onClose: onClose, size: size, zIndex: zIndex, children: children, ...other })=>{
    (0, $dvPqk.useEffect)(()=>{
        if (!isOpen || !name) return;
        (0, $6fuyt.sendModal)(name);
    }, [
        isOpen,
        name
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $34rNI.Modal), {
        TitleIcon: TitleIcon,
        isOpen: isOpen,
        title: title,
        onClose: onClose,
        size: size,
        zIndex: zIndex,
        ...other,
        children: children
    });
};
var $7b4991a45edb5062$export$2e2bcd8739ae039 = $7b4991a45edb5062$var$Modal;

});
parcelRegister("34rNI", function(module, exports) {

$parcel$export(module.exports, "Modal", function () { return $23c74f7821df599c$export$2b77a92f1a5ad772; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $cGjF4 = parcelRequire("cGjF4");

var $7gQuG = parcelRequire("7gQuG");

var $e8Vqd = parcelRequire("e8Vqd");

var $lOgwy = parcelRequire("lOgwy");
const $23c74f7821df599c$var$g = {
    sm: "max-w-sm md:max-w-md md:min-w-sm",
    md: "max-w-md md:max-w-lg md:min-w-md",
    lg: "max-w-lg md:max-w-xl md:min-w-lg",
    xl: "max-w-2xl md:max-w-3xl md:min-w-xl",
    "2xl": "max-w-3xl md:max-w-4xl md:min-w-2xl"
}, $23c74f7821df599c$var$t = (e, r, n = !1)=>typeof e > "u" ? "" : typeof e == "string" && n ? e : typeof e == "object" ? e[r] ?? "" : "";
function $23c74f7821df599c$export$2b77a92f1a5ad772({ className: e, title: r, TitleIcon: n, description: p, children: f, footer: m, isOpen: u, onClose: x = ()=>{}, size: y = "lg", zIndex: d = 50, showCloseButton: h = !0, showBackdrop: v = !0 }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $e8Vqd.Transition), {
        appear: !0,
        as: (0, $dvPqk.Fragment),
        show: u,
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $lOgwy.Dialog), {
            className: "relative",
            onClose: x,
            open: u,
            children: [
                v ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $e8Vqd.Transition).Child, {
                    as: (0, $dvPqk.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, $6sMuH.cn)("fixed inset-0 bg-base-900 opacity-50", $23c74f7821df599c$var$t(e, "backdrop")),
                        style: {
                            zIndex: d - 1
                        }
                    })
                }) : null,
                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                    className: "fixed inset-0 flex items-center justify-center p-4",
                    style: {
                        zIndex: d
                    },
                    children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $e8Vqd.Transition).Child, {
                        as: (0, $dvPqk.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "ease-in duration-300",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $lOgwy.Dialog).Panel, {
                            className: (0, $6sMuH.cn)("transition-all rounded-md w-full bg-base-0", "flex flex-col max-h-[90vh]", $23c74f7821df599c$var$g[y], $23c74f7821df599c$var$t(e, "container", !0)),
                            style: {
                                zIndex: d
                            },
                            children: [
                                /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                                    className: (0, $6sMuH.cn)("p-6 pb-4", $23c74f7821df599c$var$t(e, "header")),
                                    children: [
                                        /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                                            className: "flex items-center justify-between",
                                            children: [
                                                r ? /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $lOgwy.Dialog).Title, {
                                                    className: (0, $6sMuH.cn)("flex gap-2 mb-0", $23c74f7821df599c$var$t(e, "title")),
                                                    children: [
                                                        n ? /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                                            children: /* @__PURE__ */ (0, $7YWoO.jsx)(n, {
                                                                className: "size-6"
                                                            })
                                                        }) : null,
                                                        /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                                            className: "font-bold",
                                                            children: r
                                                        })
                                                    ]
                                                }) : null,
                                                h ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                                    "aria-label": "Close",
                                                    className: $23c74f7821df599c$var$t(e, "closeButton"),
                                                    icon: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $7gQuG.default), {}),
                                                    onClick: x,
                                                    size: "iconOnly",
                                                    type: "button",
                                                    variant: "tertiary"
                                                }) : null
                                            ]
                                        }),
                                        p ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lOgwy.Dialog).Description, {
                                            className: (0, $6sMuH.cn)("mt-4", $23c74f7821df599c$var$t(e, "description")),
                                            children: p
                                        }) : null
                                    ]
                                }),
                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    className: (0, $6sMuH.cn)("overflow-y-auto flex-1", $23c74f7821df599c$var$t(e, "content")),
                                    children: /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                        className: (0, $6sMuH.cn)("px-6", m ? "py-2" : "py-2 pb-6"),
                                        children: f
                                    })
                                }),
                                m ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    className: (0, $6sMuH.cn)("p-6 pt-4", $23c74f7821df599c$var$t(e, "footer")),
                                    children: m
                                }) : null
                            ]
                        })
                    })
                })
            ]
        })
    });
}
$23c74f7821df599c$export$2b77a92f1a5ad772.displayName = "Modal";

});
parcelRegister("e8Vqd", function(module, exports) {

$parcel$export(module.exports, "Transition", function () { return $a4be5ad7d02a2398$export$be58926105124dd4; });

var $dvPqk = parcelRequire("dvPqk");

var $gps2w = parcelRequire("gps2w");

var $eqquT = parcelRequire("eqquT");

var $f7O15 = parcelRequire("f7O15");

var $54Iyk = parcelRequire("54Iyk");

var $ld2X6 = parcelRequire("ld2X6");

var $8CvXL = parcelRequire("8CvXL");

var $fFyW3 = parcelRequire("fFyW3");

var $hvflL = parcelRequire("hvflL");

var $f7fpv = parcelRequire("f7fpv");

var $gKPjJ = parcelRequire("gKPjJ");

var $9I7vs = parcelRequire("9I7vs");

var $1w8VW = parcelRequire("1w8VW");

var $b3KIl = parcelRequire("b3KIl");
function $a4be5ad7d02a2398$var$g(e = "") {
    return e.split(/\s+/).filter((t)=>t.length > 1);
}
let $a4be5ad7d02a2398$var$I = (0, $dvPqk.createContext)(null);
$a4be5ad7d02a2398$var$I.displayName = "TransitionContext";
var $a4be5ad7d02a2398$var$$e = ((e)=>(e.Visible = "visible", e.Hidden = "hidden", e))($a4be5ad7d02a2398$var$$e || {});
function $a4be5ad7d02a2398$var$Ce() {
    let e = (0, $dvPqk.useContext)($a4be5ad7d02a2398$var$I);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function $a4be5ad7d02a2398$var$Ne() {
    let e = (0, $dvPqk.useContext)($a4be5ad7d02a2398$var$V);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
let $a4be5ad7d02a2398$var$V = (0, $dvPqk.createContext)(null);
$a4be5ad7d02a2398$var$V.displayName = "NestingContext";
function $a4be5ad7d02a2398$var$_(e) {
    return "children" in e ? $a4be5ad7d02a2398$var$_(e.children) : e.current.filter(({ el: t })=>t.current !== null).filter(({ state: t })=>t === "visible").length > 0;
}
function $a4be5ad7d02a2398$var$se(e, t) {
    let i = (0, $8CvXL.useLatestValue)(e), l = (0, $dvPqk.useRef)([]), L = (0, $54Iyk.useIsMounted)(), R = (0, $gps2w.useDisposables)(), m = (0, $eqquT.useEvent)((s, n = (0, $b3KIl.RenderStrategy).Hidden)=>{
        let a = l.current.findIndex(({ el: r })=>r === s);
        a !== -1 && ((0, $1w8VW.match)(n, {
            [(0, $b3KIl.RenderStrategy).Unmount] () {
                l.current.splice(a, 1);
            },
            [(0, $b3KIl.RenderStrategy).Hidden] () {
                l.current[a].state = "hidden";
            }
        }), R.microTask(()=>{
            var r;
            !$a4be5ad7d02a2398$var$_(l) && L.current && ((r = i.current) == null || r.call(i));
        }));
    }), N = (0, $eqquT.useEvent)((s)=>{
        let n = l.current.find(({ el: a })=>a === s);
        return n ? n.state !== "visible" && (n.state = "visible") : l.current.push({
            el: s,
            state: "visible"
        }), ()=>m(s, (0, $b3KIl.RenderStrategy).Unmount);
    }), v = (0, $dvPqk.useRef)([]), h = (0, $dvPqk.useRef)(Promise.resolve()), u = (0, $dvPqk.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), p = (0, $eqquT.useEvent)((s, n, a)=>{
        v.current.splice(0), t && (t.chains.current[n] = t.chains.current[n].filter(([r])=>r !== s)), t == null || t.chains.current[n].push([
            s,
            new Promise((r)=>{
                v.current.push(r);
            })
        ]), t == null || t.chains.current[n].push([
            s,
            new Promise((r)=>{
                Promise.all(u.current[n].map(([P, F])=>F)).then(()=>r());
            })
        ]), n === "enter" ? h.current = h.current.then(()=>t == null ? void 0 : t.wait.current).then(()=>a(n)) : a(n);
    }), c = (0, $eqquT.useEvent)((s, n, a)=>{
        Promise.all(u.current[n].splice(0).map(([r, P])=>P)).then(()=>{
            var r;
            (r = v.current.shift()) == null || r();
        }).then(()=>a(n));
    });
    return (0, $dvPqk.useMemo)(()=>({
            children: l,
            register: N,
            unregister: m,
            onStart: p,
            onStop: c,
            wait: h,
            chains: u
        }), [
        N,
        m,
        l,
        p,
        c,
        u,
        h
    ]);
}
function $a4be5ad7d02a2398$var$Pe() {}
let $a4be5ad7d02a2398$var$Fe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $a4be5ad7d02a2398$var$ee(e) {
    var t;
    let i = {};
    for (let l of $a4be5ad7d02a2398$var$Fe)i[l] = (t = e[l]) != null ? t : $a4be5ad7d02a2398$var$Pe;
    return i;
}
function $a4be5ad7d02a2398$var$Se(e) {
    let t = (0, $dvPqk.useRef)($a4be5ad7d02a2398$var$ee(e));
    return (0, $dvPqk.useEffect)(()=>{
        t.current = $a4be5ad7d02a2398$var$ee(e);
    }, [
        e
    ]), t;
}
let $a4be5ad7d02a2398$var$Le = "div", $a4be5ad7d02a2398$var$oe = (0, $b3KIl.Features).RenderStrategy;
function $a4be5ad7d02a2398$var$Re(e, t) {
    var i, l;
    let { beforeEnter: L, afterEnter: R, beforeLeave: m, afterLeave: N, enter: v, enterFrom: h, enterTo: u, entered: p, leave: c, leaveFrom: s, leaveTo: n, ...a } = e, r = (0, $dvPqk.useRef)(null), P = (0, $hvflL.useSyncRefs)(r, t), F = (i = a.unmount) == null || i ? (0, $b3KIl.RenderStrategy).Unmount : (0, $b3KIl.RenderStrategy).Hidden, { show: o, appear: w, initial: W } = $a4be5ad7d02a2398$var$Ce(), [$, j] = (0, $dvPqk.useState)(o ? "visible" : "hidden"), Y = $a4be5ad7d02a2398$var$Ne(), { register: D, unregister: H } = Y;
    (0, $dvPqk.useEffect)(()=>D(r), [
        D,
        r
    ]), (0, $dvPqk.useEffect)(()=>{
        if (F === (0, $b3KIl.RenderStrategy).Hidden && r.current) {
            if (o && $ !== "visible") {
                j("visible");
                return;
            }
            return (0, $1w8VW.match)($, {
                hidden: ()=>H(r),
                visible: ()=>D(r)
            });
        }
    }, [
        $,
        r,
        D,
        H,
        o,
        F
    ]);
    let k = (0, $8CvXL.useLatestValue)({
        base: $a4be5ad7d02a2398$var$g(a.className),
        enter: $a4be5ad7d02a2398$var$g(v),
        enterFrom: $a4be5ad7d02a2398$var$g(h),
        enterTo: $a4be5ad7d02a2398$var$g(u),
        entered: $a4be5ad7d02a2398$var$g(p),
        leave: $a4be5ad7d02a2398$var$g(c),
        leaveFrom: $a4be5ad7d02a2398$var$g(s),
        leaveTo: $a4be5ad7d02a2398$var$g(n)
    }), M = $a4be5ad7d02a2398$var$Se({
        beforeEnter: L,
        afterEnter: R,
        beforeLeave: m,
        afterLeave: N
    }), q = (0, $fFyW3.useServerHandoffComplete)();
    (0, $dvPqk.useEffect)(()=>{
        if (q && $ === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        r,
        $,
        q
    ]);
    let ce = W && !w, J = w && o && W, de = !q || ce ? "idle" : o ? "enter" : "leave", x = (0, $f7O15.useFlags)(0), fe = (0, $eqquT.useEvent)((b)=>(0, $1w8VW.match)(b, {
            enter: ()=>{
                x.addFlag((0, $gKPjJ.State).Opening), M.current.beforeEnter();
            },
            leave: ()=>{
                x.addFlag((0, $gKPjJ.State).Closing), M.current.beforeLeave();
            },
            idle: ()=>{}
        })), me = (0, $eqquT.useEvent)((b)=>(0, $1w8VW.match)(b, {
            enter: ()=>{
                x.removeFlag((0, $gKPjJ.State).Opening), M.current.afterEnter();
            },
            leave: ()=>{
                x.removeFlag((0, $gKPjJ.State).Closing), M.current.afterLeave();
            },
            idle: ()=>{}
        })), U = $a4be5ad7d02a2398$var$se(()=>{
        j("hidden"), H(r);
    }, Y), B = (0, $dvPqk.useRef)(!1);
    (0, $f7fpv.useTransition)({
        immediate: J,
        container: r,
        classes: k,
        direction: de,
        onStart: (0, $8CvXL.useLatestValue)((b)=>{
            B.current = !0, U.onStart(r, b, fe);
        }),
        onStop: (0, $8CvXL.useLatestValue)((b)=>{
            B.current = !1, U.onStop(r, b, me), b === "leave" && !$a4be5ad7d02a2398$var$_(U) && (j("hidden"), H(r));
        })
    });
    let S = a, ve = {
        ref: P
    };
    return J ? S = {
        ...S,
        className: (0, $9I7vs.classNames)(a.className, ...k.current.enter, ...k.current.enterFrom)
    } : B.current && (S.className = (0, $9I7vs.classNames)(a.className, (l = r.current) == null ? void 0 : l.className), S.className === "" && delete S.className), (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($a4be5ad7d02a2398$var$V.Provider, {
        value: U
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $gKPjJ.OpenClosedProvider), {
        value: (0, $1w8VW.match)($, {
            visible: (0, $gKPjJ.State).Open,
            hidden: (0, $gKPjJ.State).Closed
        }) | x.flags
    }, (0, $b3KIl.render)({
        ourProps: ve,
        theirProps: S,
        defaultTag: $a4be5ad7d02a2398$var$Le,
        features: $a4be5ad7d02a2398$var$oe,
        visible: $ === "visible",
        name: "Transition.Child"
    })));
}
function $a4be5ad7d02a2398$var$xe(e, t) {
    let { show: i, appear: l = !1, unmount: L = !0, ...R } = e, m = (0, $dvPqk.useRef)(null), N = (0, $hvflL.useSyncRefs)(m, t);
    (0, $fFyW3.useServerHandoffComplete)();
    let v = (0, $gKPjJ.useOpenClosed)();
    if (i === void 0 && v !== null && (i = (v & (0, $gKPjJ.State).Open) === (0, $gKPjJ.State).Open), ![
        !0,
        !1
    ].includes(i)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [h, u] = (0, $dvPqk.useState)(i ? "visible" : "hidden"), p = $a4be5ad7d02a2398$var$se(()=>{
        u("hidden");
    }), [c, s] = (0, $dvPqk.useState)(!0), n = (0, $dvPqk.useRef)([
        i
    ]);
    (0, $ld2X6.useIsoMorphicEffect)(()=>{
        c !== !1 && n.current[n.current.length - 1] !== i && (n.current.push(i), s(!1));
    }, [
        n,
        i
    ]);
    let a = (0, $dvPqk.useMemo)(()=>({
            show: i,
            appear: l,
            initial: c
        }), [
        i,
        l,
        c
    ]);
    (0, $dvPqk.useEffect)(()=>{
        if (i) u("visible");
        else if (!$a4be5ad7d02a2398$var$_(p)) u("hidden");
        else {
            let o = m.current;
            if (!o) return;
            let w = o.getBoundingClientRect();
            w.x === 0 && w.y === 0 && w.width === 0 && w.height === 0 && u("hidden");
        }
    }, [
        i,
        p
    ]);
    let r = {
        unmount: L
    }, P = (0, $eqquT.useEvent)(()=>{
        var o;
        c && s(!1), (o = e.beforeEnter) == null || o.call(e);
    }), F = (0, $eqquT.useEvent)(()=>{
        var o;
        c && s(!1), (o = e.beforeLeave) == null || o.call(e);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($a4be5ad7d02a2398$var$V.Provider, {
        value: p
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($a4be5ad7d02a2398$var$I.Provider, {
        value: a
    }, (0, $b3KIl.render)({
        ourProps: {
            ...r,
            as: (0, $dvPqk.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($a4be5ad7d02a2398$var$ue, {
                ref: N,
                ...r,
                ...R,
                beforeEnter: P,
                beforeLeave: F
            })
        },
        theirProps: {},
        defaultTag: (0, $dvPqk.Fragment),
        features: $a4be5ad7d02a2398$var$oe,
        visible: h === "visible",
        name: "Transition"
    })));
}
function $a4be5ad7d02a2398$var$Oe(e, t) {
    let i = (0, $dvPqk.useContext)($a4be5ad7d02a2398$var$I) !== null, l = (0, $gKPjJ.useOpenClosed)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Fragment, null, !i && l ? (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($a4be5ad7d02a2398$var$G, {
        ref: t,
        ...e
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($a4be5ad7d02a2398$var$ue, {
        ref: t,
        ...e
    }));
}
let $a4be5ad7d02a2398$var$G = (0, $b3KIl.forwardRefWithAs)($a4be5ad7d02a2398$var$xe), $a4be5ad7d02a2398$var$ue = (0, $b3KIl.forwardRefWithAs)($a4be5ad7d02a2398$var$Re), $a4be5ad7d02a2398$var$ye = (0, $b3KIl.forwardRefWithAs)($a4be5ad7d02a2398$var$Oe), $a4be5ad7d02a2398$export$be58926105124dd4 = Object.assign($a4be5ad7d02a2398$var$G, {
    Child: $a4be5ad7d02a2398$var$ye,
    Root: $a4be5ad7d02a2398$var$G
});

});
parcelRegister("f7fpv", function(module, exports) {

$parcel$export(module.exports, "useTransition", function () { return $b013769ecf7c6786$export$7b286972b8d8ccbf; });

var $5Xs9F = parcelRequire("5Xs9F");

var $bVyso = parcelRequire("bVyso");

var $gps2w = parcelRequire("gps2w");

var $54Iyk = parcelRequire("54Iyk");

var $ld2X6 = parcelRequire("ld2X6");

var $8CvXL = parcelRequire("8CvXL");
function $b013769ecf7c6786$export$7b286972b8d8ccbf({ immediate: t, container: n, direction: s, classes: a, onStart: u, onStop: c }) {
    let p = (0, $54Iyk.useIsMounted)(), d = (0, $gps2w.useDisposables)(), r = (0, $8CvXL.useLatestValue)(s);
    (0, $ld2X6.useIsoMorphicEffect)(()=>{
        t && (r.current = "enter");
    }, [
        t
    ]), (0, $ld2X6.useIsoMorphicEffect)(()=>{
        let e = (0, $bVyso.disposables)();
        d.add(e.dispose);
        let o = n.current;
        if (o && r.current !== "idle" && p.current) return e.dispose(), u.current(r.current), e.add((0, $5Xs9F.transition)(o, a.current, r.current === "enter", ()=>{
            e.dispose(), c.current(r.current);
        })), e.dispose;
    }, [
        s
    ]);
}

});
parcelRegister("5Xs9F", function(module, exports) {

$parcel$export(module.exports, "transition", function () { return $45684d6c1cae1c8e$export$66bb15e2994e6a26; });

var $bVyso = parcelRequire("bVyso");

var $1w8VW = parcelRequire("1w8VW");

var $03eZX = parcelRequire("03eZX");
function $45684d6c1cae1c8e$var$m(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $45684d6c1cae1c8e$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $45684d6c1cae1c8e$var$g(t, e) {
    let a = (0, $bVyso.disposables)();
    if (!t) return a.dispose;
    let { transitionDuration: l, transitionDelay: s } = getComputedStyle(t), [d, p] = [
        l,
        s
    ].map((i)=>{
        let [r = 0] = i.split(",").filter(Boolean).map((n)=>n.includes("ms") ? parseFloat(n) : parseFloat(n) * 1e3).sort((n, f)=>f - n);
        return r;
    }), o = d + p;
    if (o !== 0) {
        a.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, o), r.addEventListener(t, "transitionrun", (n)=>{
                n.target === n.currentTarget && r.dispose();
            });
        });
        let i = a.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), i());
        });
    } else e();
    return a.add(()=>e()), a.dispose;
}
function $45684d6c1cae1c8e$export$66bb15e2994e6a26(t, e, a, l) {
    let s = a ? "enter" : "leave", d = (0, $bVyso.disposables)(), p = l !== void 0 ? (0, $03eZX.once)(l) : ()=>{};
    s === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let o = (0, $1w8VW.match)(s, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), i = (0, $1w8VW.match)(s, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $1w8VW.match)(s, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $45684d6c1cae1c8e$var$v(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $45684d6c1cae1c8e$var$m(t, ...e.base, ...o, ...r), d.nextFrame(()=>{
        $45684d6c1cae1c8e$var$v(t, ...e.base, ...o, ...r), $45684d6c1cae1c8e$var$m(t, ...e.base, ...o, ...i), $45684d6c1cae1c8e$var$g(t, ()=>($45684d6c1cae1c8e$var$v(t, ...e.base, ...o), $45684d6c1cae1c8e$var$m(t, ...e.base, ...e.entered), p()));
    }), d.dispose;
}

});
parcelRegister("03eZX", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $009bea4a65d90372$export$d2de3aaeafa91619; });
function $009bea4a65d90372$export$d2de3aaeafa91619(l) {
    let e = {
        called: !1
    };
    return (...c)=>{
        if (!e.called) return e.called = !0, l(...c);
    };
}

});



parcelRegister("gKPjJ", function(module, exports) {

$parcel$export(module.exports, "State", function () { return $c328bfc3f00898a7$export$7254cc27399e90bd; });
$parcel$export(module.exports, "useOpenClosed", function () { return $c328bfc3f00898a7$export$fc6fdf0ecf360e; });
$parcel$export(module.exports, "OpenClosedProvider", function () { return $c328bfc3f00898a7$export$2a0ed818b175f558; });

var $dvPqk = parcelRequire("dvPqk");
let $c328bfc3f00898a7$var$n = (0, $dvPqk.createContext)(null);
$c328bfc3f00898a7$var$n.displayName = "OpenClosedContext";
var $c328bfc3f00898a7$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($c328bfc3f00898a7$export$7254cc27399e90bd || {});
function $c328bfc3f00898a7$export$fc6fdf0ecf360e() {
    return (0, $dvPqk.useContext)($c328bfc3f00898a7$var$n);
}
function $c328bfc3f00898a7$export$2a0ed818b175f558({ value: e, children: t }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($c328bfc3f00898a7$var$n.Provider, {
        value: e
    }, t);
}

});


parcelRegister("lOgwy", function(module, exports) {

$parcel$export(module.exports, "Dialog", function () { return $fe0b15d5ecc6d9c3$export$3ddf2d174ce01153; });

var $dvPqk = parcelRequire("dvPqk");

var $bTyoj = parcelRequire("bTyoj");

var $3qOSj = parcelRequire("3qOSj");

var $fwHoq = parcelRequire("fwHoq");

var $eqquT = parcelRequire("eqquT");

var $frh3X = parcelRequire("frh3X");

var $9O4MK = parcelRequire("9O4MK");

var $4UJ5c = parcelRequire("4UJ5c");

var $kNa7k = parcelRequire("kNa7k");

var $4vdOn = parcelRequire("4vdOn");

var $bY06o = parcelRequire("bY06o");

var $fFyW3 = parcelRequire("fFyW3");

var $hvflL = parcelRequire("hvflL");

var $gKPjJ = parcelRequire("gKPjJ");

var $i9i7B = parcelRequire("i9i7B");

var $dcmqG = parcelRequire("dcmqG");

var $eRLkK = parcelRequire("eRLkK");

var $1w8VW = parcelRequire("1w8VW");

var $b3KIl = parcelRequire("b3KIl");

var $gfl5j = parcelRequire("gfl5j");

var $iJZQ7 = parcelRequire("iJZQ7");
var $fe0b15d5ecc6d9c3$var$Fe = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($fe0b15d5ecc6d9c3$var$Fe || {}), $fe0b15d5ecc6d9c3$var$Me = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($fe0b15d5ecc6d9c3$var$Me || {});
let $fe0b15d5ecc6d9c3$var$Ne = {
    0 (e, o) {
        return e.titleId === o.id ? e : {
            ...e,
            titleId: o.id
        };
    }
}, $fe0b15d5ecc6d9c3$var$M = (0, $dvPqk.createContext)(null);
$fe0b15d5ecc6d9c3$var$M.displayName = "DialogContext";
function $fe0b15d5ecc6d9c3$var$R(e) {
    let o = (0, $dvPqk.useContext)($fe0b15d5ecc6d9c3$var$M);
    if (o === null) {
        let l = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $fe0b15d5ecc6d9c3$var$R), l;
    }
    return o;
}
function $fe0b15d5ecc6d9c3$var$Ye(e, o, l = ()=>[
        document.body
    ]) {
    (0, $fwHoq.useDocumentOverflowLockedEffect)(e, o, (i)=>{
        var r;
        return {
            containers: [
                ...(r = i.containers) != null ? r : [],
                l
            ]
        };
    });
}
function $fe0b15d5ecc6d9c3$var$xe(e, o) {
    return (0, $1w8VW.match)(o.type, $fe0b15d5ecc6d9c3$var$Ne, e, o);
}
let $fe0b15d5ecc6d9c3$var$Be = "div", $fe0b15d5ecc6d9c3$var$Le = (0, $b3KIl.Features).RenderStrategy | (0, $b3KIl.Features).Static;
function $fe0b15d5ecc6d9c3$var$Ue(e, o) {
    let l = (0, $9O4MK.useId)(), { id: i = `headlessui-dialog-${l}`, open: r, onClose: a, initialFocus: s, role: n = "dialog", __demoMode: f = !1, ...E } = e, [c, U] = (0, $dvPqk.useState)(0), _ = (0, $dvPqk.useRef)(!1);
    n = function() {
        return n === "dialog" || n === "alertdialog" ? n : (_.current || (_.current = !0, console.warn(`Invalid role [${n}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let y = (0, $gKPjJ.useOpenClosed)();
    r === void 0 && y !== null && (r = (y & (0, $gKPjJ.State).Open) === (0, $gKPjJ.State).Open);
    let g = (0, $dvPqk.useRef)(null), ee = (0, $hvflL.useSyncRefs)(g, o), v = (0, $4vdOn.useOwnerDocument)(g), H = e.hasOwnProperty("open") || y !== null, j = e.hasOwnProperty("onClose");
    if (!H && !j) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!H) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!j) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof r != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${r}`);
    if (typeof a != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${a}`);
    let u = r ? 0 : 1, [S, te] = (0, $dvPqk.useReducer)($fe0b15d5ecc6d9c3$var$xe, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $dvPqk.createRef)()
    }), h = (0, $eqquT.useEvent)(()=>a(!1)), q = (0, $eqquT.useEvent)((t)=>te({
            type: 0,
            id: t
        })), k = (0, $fFyW3.useServerHandoffComplete)() ? f ? !1 : u === 0 : !1, O = c > 1, G = (0, $dvPqk.useContext)($fe0b15d5ecc6d9c3$var$M) !== null, [oe, re] = (0, $3qOSj.useNestedPortals)(), ae = {
        get current () {
            var t;
            return (t = S.panelRef.current) != null ? t : g.current;
        }
    }, { resolveContainers: N, mainTreeNodeRef: I, MainTreeNode: le } = (0, $bY06o.useRootContainers)({
        portals: oe,
        defaultContainers: [
            ae
        ]
    }), ne = O ? "parent" : "leaf", W = y !== null ? (y & (0, $gKPjJ.State).Closing) === (0, $gKPjJ.State).Closing : !1, ie = G || W ? !1 : k, se = (0, $dvPqk.useCallback)(()=>{
        var t, m;
        return (m = Array.from((t = v == null ? void 0 : v.querySelectorAll("body > *")) != null ? t : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(I.current) && d instanceof HTMLElement)) != null ? m : null;
    }, [
        I
    ]);
    (0, $4UJ5c.useInert)(se, ie);
    let ue = O ? !0 : k, de = (0, $dvPqk.useCallback)(()=>{
        var t, m;
        return (m = Array.from((t = v == null ? void 0 : v.querySelectorAll("[data-headlessui-portal]")) != null ? t : []).find((d)=>d.contains(I.current) && d instanceof HTMLElement)) != null ? m : null;
    }, [
        I
    ]);
    (0, $4UJ5c.useInert)(de, ue), (0, $kNa7k.useOutsideClick)(N, (t)=>{
        t.preventDefault(), h();
    }, !(!k || O));
    let pe = !(O || u !== 0);
    (0, $frh3X.useEventListener)(v == null ? void 0 : v.defaultView, "keydown", (t)=>{
        pe && (t.defaultPrevented || t.key === (0, $iJZQ7.Keys).Escape && (t.preventDefault(), t.stopPropagation(), h()));
    }), $fe0b15d5ecc6d9c3$var$Ye(v, !(W || u !== 0 || G), N), (0, $dvPqk.useEffect)(()=>{
        if (u !== 0 || !g.current) return;
        let t = new ResizeObserver((m)=>{
            for (let d of m){
                let A = d.target.getBoundingClientRect();
                A.x === 0 && A.y === 0 && A.width === 0 && A.height === 0 && h();
            }
        });
        return t.observe(g.current), ()=>t.disconnect();
    }, [
        u,
        g,
        h
    ]);
    let [ce, fe] = (0, $gfl5j.useDescriptions)(), me = (0, $dvPqk.useMemo)(()=>[
            {
                dialogState: u,
                close: h,
                setTitleId: q
            },
            S
        ], [
        u,
        S,
        h,
        q
    ]), z = (0, $dvPqk.useMemo)(()=>({
            open: u === 0
        }), [
        u
    ]), ge = {
        ref: ee,
        id: i,
        role: n,
        "aria-modal": u === 0 ? !0 : void 0,
        "aria-labelledby": S.titleId,
        "aria-describedby": ce
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $dcmqG.StackProvider), {
        type: "Dialog",
        enabled: u === 0,
        element: g,
        onUpdate: (0, $eqquT.useEvent)((t, m)=>{
            m === "Dialog" && (0, $1w8VW.match)(t, {
                [(0, $dcmqG.StackMessage).Add]: ()=>U((d)=>d + 1),
                [(0, $dcmqG.StackMessage).Remove]: ()=>U((d)=>d - 1)
            });
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $i9i7B.ForcePortalRoot), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $3qOSj.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($fe0b15d5ecc6d9c3$var$M.Provider, {
        value: me
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $3qOSj.Portal).Group, {
        target: g
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $i9i7B.ForcePortalRoot), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(fe, {
        slot: z,
        name: "Dialog.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $bTyoj.FocusTrap), {
        initialFocus: s,
        containers: N,
        features: k ? (0, $1w8VW.match)(ne, {
            parent: (0, $bTyoj.FocusTrap).features.RestoreFocus,
            leaf: (0, $bTyoj.FocusTrap).features.All & ~(0, $bTyoj.FocusTrap).features.FocusLock
        }) : (0, $bTyoj.FocusTrap).features.None
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(re, null, (0, $b3KIl.render)({
        ourProps: ge,
        theirProps: E,
        slot: z,
        defaultTag: $fe0b15d5ecc6d9c3$var$Be,
        features: $fe0b15d5ecc6d9c3$var$Le,
        visible: u === 0,
        name: "Dialog"
    }))))))))), (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(le, null));
}
let $fe0b15d5ecc6d9c3$var$_e = "div";
function $fe0b15d5ecc6d9c3$var$He(e, o) {
    let l = (0, $9O4MK.useId)(), { id: i = `headlessui-dialog-overlay-${l}`, ...r } = e, [{ dialogState: a, close: s }] = $fe0b15d5ecc6d9c3$var$R("Dialog.Overlay"), n = (0, $hvflL.useSyncRefs)(o), f = (0, $eqquT.useEvent)((c)=>{
        if (c.target === c.currentTarget) {
            if ((0, $eRLkK.isDisabledReactIssue7711)(c.currentTarget)) return c.preventDefault();
            c.preventDefault(), c.stopPropagation(), s();
        }
    }), E = (0, $dvPqk.useMemo)(()=>({
            open: a === 0
        }), [
        a
    ]);
    return (0, $b3KIl.render)({
        ourProps: {
            ref: n,
            id: i,
            "aria-hidden": !0,
            onClick: f
        },
        theirProps: r,
        slot: E,
        defaultTag: $fe0b15d5ecc6d9c3$var$_e,
        name: "Dialog.Overlay"
    });
}
let $fe0b15d5ecc6d9c3$var$je = "div";
function $fe0b15d5ecc6d9c3$var$qe(e, o) {
    let l = (0, $9O4MK.useId)(), { id: i = `headlessui-dialog-backdrop-${l}`, ...r } = e, [{ dialogState: a }, s] = $fe0b15d5ecc6d9c3$var$R("Dialog.Backdrop"), n = (0, $hvflL.useSyncRefs)(o);
    (0, $dvPqk.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let f = (0, $dvPqk.useMemo)(()=>({
            open: a === 0
        }), [
        a
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $i9i7B.ForcePortalRoot), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $3qOSj.Portal), null, (0, $b3KIl.render)({
        ourProps: {
            ref: n,
            id: i,
            "aria-hidden": !0
        },
        theirProps: r,
        slot: f,
        defaultTag: $fe0b15d5ecc6d9c3$var$je,
        name: "Dialog.Backdrop"
    })));
}
let $fe0b15d5ecc6d9c3$var$Ge = "div";
function $fe0b15d5ecc6d9c3$var$We(e, o) {
    let l = (0, $9O4MK.useId)(), { id: i = `headlessui-dialog-panel-${l}`, ...r } = e, [{ dialogState: a }, s] = $fe0b15d5ecc6d9c3$var$R("Dialog.Panel"), n = (0, $hvflL.useSyncRefs)(o, s.panelRef), f = (0, $dvPqk.useMemo)(()=>({
            open: a === 0
        }), [
        a
    ]), E = (0, $eqquT.useEvent)((c)=>{
        c.stopPropagation();
    });
    return (0, $b3KIl.render)({
        ourProps: {
            ref: n,
            id: i,
            onClick: E
        },
        theirProps: r,
        slot: f,
        defaultTag: $fe0b15d5ecc6d9c3$var$Ge,
        name: "Dialog.Panel"
    });
}
let $fe0b15d5ecc6d9c3$var$ze = "h2";
function $fe0b15d5ecc6d9c3$var$Je(e, o) {
    let l = (0, $9O4MK.useId)(), { id: i = `headlessui-dialog-title-${l}`, ...r } = e, [{ dialogState: a, setTitleId: s }] = $fe0b15d5ecc6d9c3$var$R("Dialog.Title"), n = (0, $hvflL.useSyncRefs)(o);
    (0, $dvPqk.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let f = (0, $dvPqk.useMemo)(()=>({
            open: a === 0
        }), [
        a
    ]);
    return (0, $b3KIl.render)({
        ourProps: {
            ref: n,
            id: i
        },
        theirProps: r,
        slot: f,
        defaultTag: $fe0b15d5ecc6d9c3$var$ze,
        name: "Dialog.Title"
    });
}
let $fe0b15d5ecc6d9c3$var$Ke = (0, $b3KIl.forwardRefWithAs)($fe0b15d5ecc6d9c3$var$Ue), $fe0b15d5ecc6d9c3$var$Ve = (0, $b3KIl.forwardRefWithAs)($fe0b15d5ecc6d9c3$var$qe), $fe0b15d5ecc6d9c3$var$Xe = (0, $b3KIl.forwardRefWithAs)($fe0b15d5ecc6d9c3$var$We), $fe0b15d5ecc6d9c3$var$Qe = (0, $b3KIl.forwardRefWithAs)($fe0b15d5ecc6d9c3$var$He), $fe0b15d5ecc6d9c3$var$Ze = (0, $b3KIl.forwardRefWithAs)($fe0b15d5ecc6d9c3$var$Je), $fe0b15d5ecc6d9c3$export$3ddf2d174ce01153 = Object.assign($fe0b15d5ecc6d9c3$var$Ke, {
    Backdrop: $fe0b15d5ecc6d9c3$var$Ve,
    Panel: $fe0b15d5ecc6d9c3$var$Xe,
    Overlay: $fe0b15d5ecc6d9c3$var$Qe,
    Title: $fe0b15d5ecc6d9c3$var$Ze,
    Description: (0, $gfl5j.Description)
});

});
parcelRegister("bTyoj", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", function () { return $8a8f821a39b22cb4$export$34eba2437817a67b; });

var $dvPqk = parcelRequire("dvPqk");

var $gps2w = parcelRequire("gps2w");

var $eqquT = parcelRequire("eqquT");

var $frh3X = parcelRequire("frh3X");

var $54Iyk = parcelRequire("54Iyk");

var $kYIzf = parcelRequire("kYIzf");

var $4vdOn = parcelRequire("4vdOn");

var $fFyW3 = parcelRequire("fFyW3");

var $hvflL = parcelRequire("hvflL");

var $b4lDg = parcelRequire("b4lDg");

var $78heA = parcelRequire("78heA");

var $jQKuj = parcelRequire("jQKuj");

var $lx9M1 = parcelRequire("lx9M1");

var $ae7L7 = parcelRequire("ae7L7");

var $1w8VW = parcelRequire("1w8VW");

var $9vMZh = parcelRequire("9vMZh");

var $b3KIl = parcelRequire("b3KIl");
function $8a8f821a39b22cb4$var$M(e) {
    if (!e) return /* @__PURE__ */ new Set();
    if (typeof e == "function") return new Set(e());
    let r = /* @__PURE__ */ new Set();
    for (let t of e.current)t.current instanceof HTMLElement && r.add(t.current);
    return r;
}
let $8a8f821a39b22cb4$var$z = "div";
var $8a8f821a39b22cb4$var$A = ((e)=>(e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))($8a8f821a39b22cb4$var$A || {});
function $8a8f821a39b22cb4$var$G(e, r) {
    let t = (0, $dvPqk.useRef)(null), n = (0, $hvflL.useSyncRefs)(t, r), { initialFocus: a, containers: l, features: o = 30, ...u } = e;
    (0, $fFyW3.useServerHandoffComplete)() || (o = 1);
    let f = (0, $4vdOn.useOwnerDocument)(t);
    $8a8f821a39b22cb4$var$V({
        ownerDocument: f
    }, !!(o & 16));
    let c = $8a8f821a39b22cb4$var$X({
        ownerDocument: f,
        container: t,
        initialFocus: a
    }, !!(o & 2));
    $8a8f821a39b22cb4$var$Y({
        ownerDocument: f,
        container: t,
        containers: l,
        previousActiveElement: c
    }, !!(o & 8));
    let D = (0, $b4lDg.useTabDirection)(), L = (0, $eqquT.useEvent)((s)=>{
        let m = t.current;
        m && ((p)=>p())(()=>{
            (0, $1w8VW.match)(D.current, {
                [(0, $b4lDg.Direction).Forwards]: ()=>{
                    (0, $ae7L7.focusIn)(m, (0, $ae7L7.Focus).First, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                },
                [(0, $b4lDg.Direction).Backwards]: ()=>{
                    (0, $ae7L7.focusIn)(m, (0, $ae7L7.Focus).Last, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                }
            });
        });
    }), S = (0, $gps2w.useDisposables)(), w = (0, $dvPqk.useRef)(!1), P = {
        ref: n,
        onKeyDown (s) {
            s.key == "Tab" && (w.current = !0, S.requestAnimationFrame(()=>{
                w.current = !1;
            }));
        },
        onBlur (s) {
            let m = $8a8f821a39b22cb4$var$M(l);
            t.current instanceof HTMLElement && m.add(t.current);
            let p = s.relatedTarget;
            p instanceof HTMLElement && p.dataset.headlessuiFocusGuard !== "true" && ($8a8f821a39b22cb4$var$R(m, p) || (w.current ? (0, $ae7L7.focusIn)(t.current, (0, $1w8VW.match)(D.current, {
                [(0, $b4lDg.Direction).Forwards]: ()=>(0, $ae7L7.Focus).Next,
                [(0, $b4lDg.Direction).Backwards]: ()=>(0, $ae7L7.Focus).Previous
            }) | (0, $ae7L7.Focus).WrapAround, {
                relativeTo: s.target
            }) : s.target instanceof HTMLElement && (0, $ae7L7.focusElement)(s.target)));
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Fragment, null, !!(o & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $jQKuj.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: L,
        features: (0, $jQKuj.Features).Focusable
    }), (0, $b3KIl.render)({
        ourProps: P,
        theirProps: u,
        defaultTag: $8a8f821a39b22cb4$var$z,
        name: "FocusTrap"
    }), !!(o & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $jQKuj.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: L,
        features: (0, $jQKuj.Features).Focusable
    }));
}
let $8a8f821a39b22cb4$var$K = (0, $b3KIl.forwardRefWithAs)($8a8f821a39b22cb4$var$G), $8a8f821a39b22cb4$export$34eba2437817a67b = Object.assign($8a8f821a39b22cb4$var$K, {
    features: $8a8f821a39b22cb4$var$A
});
function $8a8f821a39b22cb4$var$Q(e = !0) {
    let r = (0, $dvPqk.useRef)((0, $lx9M1.history).slice());
    return (0, $78heA.useWatch)(([t], [n])=>{
        n === !0 && t === !1 && (0, $9vMZh.microTask)(()=>{
            r.current.splice(0);
        }), n === !1 && t === !0 && (r.current = (0, $lx9M1.history).slice());
    }, [
        e,
        (0, $lx9M1.history),
        r
    ]), (0, $eqquT.useEvent)(()=>{
        var t;
        return (t = r.current.find((n)=>n != null && n.isConnected)) != null ? t : null;
    });
}
function $8a8f821a39b22cb4$var$V({ ownerDocument: e }, r) {
    let t = $8a8f821a39b22cb4$var$Q(r);
    (0, $78heA.useWatch)(()=>{
        r || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && (0, $ae7L7.focusElement)(t());
    }, [
        r
    ]), (0, $kYIzf.useOnUnmount)(()=>{
        r && (0, $ae7L7.focusElement)(t());
    });
}
function $8a8f821a39b22cb4$var$X({ ownerDocument: e, container: r, initialFocus: t }, n) {
    let a = (0, $dvPqk.useRef)(null), l = (0, $54Iyk.useIsMounted)();
    return (0, $78heA.useWatch)(()=>{
        if (!n) return;
        let o = r.current;
        o && (0, $9vMZh.microTask)(()=>{
            if (!l.current) return;
            let u = e == null ? void 0 : e.activeElement;
            if (t != null && t.current) {
                if ((t == null ? void 0 : t.current) === u) {
                    a.current = u;
                    return;
                }
            } else if (o.contains(u)) {
                a.current = u;
                return;
            }
            t != null && t.current ? (0, $ae7L7.focusElement)(t.current) : (0, $ae7L7.focusIn)(o, (0, $ae7L7.Focus).First) === (0, $ae7L7.FocusResult).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), a.current = e == null ? void 0 : e.activeElement;
        });
    }, [
        n
    ]), a;
}
function $8a8f821a39b22cb4$var$Y({ ownerDocument: e, container: r, containers: t, previousActiveElement: n }, a) {
    let l = (0, $54Iyk.useIsMounted)();
    (0, $frh3X.useEventListener)(e == null ? void 0 : e.defaultView, "focus", (o)=>{
        if (!a || !l.current) return;
        let u = $8a8f821a39b22cb4$var$M(t);
        r.current instanceof HTMLElement && u.add(r.current);
        let f = n.current;
        if (!f) return;
        let c = o.target;
        c && c instanceof HTMLElement ? $8a8f821a39b22cb4$var$R(u, c) ? (n.current = c, (0, $ae7L7.focusElement)(c)) : (o.preventDefault(), o.stopPropagation(), (0, $ae7L7.focusElement)(f)) : (0, $ae7L7.focusElement)(n.current);
    }, !0);
}
function $8a8f821a39b22cb4$var$R(e, r) {
    for (let t of e)if (t.contains(r)) return !0;
    return !1;
}

});
parcelRegister("frh3X", function(module, exports) {

$parcel$export(module.exports, "useEventListener", function () { return $b3d69cf97226e5e9$export$7080b3e976bc91ab; });

var $dvPqk = parcelRequire("dvPqk");

var $8CvXL = parcelRequire("8CvXL");
function $b3d69cf97226e5e9$export$7080b3e976bc91ab(e, t, i, r) {
    let n = (0, $8CvXL.useLatestValue)(i);
    (0, $dvPqk.useEffect)(()=>{
        e = e ?? window;
        function s(o) {
            n.current(o);
        }
        return e.addEventListener(t, s, r), ()=>e.removeEventListener(t, s, r);
    }, [
        e,
        t,
        r
    ]);
}

});

parcelRegister("kYIzf", function(module, exports) {

$parcel$export(module.exports, "useOnUnmount", function () { return $f45bfb6c4474bddb$export$cd059ee7fd0e9f3d; });

var $dvPqk = parcelRequire("dvPqk");

var $9vMZh = parcelRequire("9vMZh");

var $eqquT = parcelRequire("eqquT");
function $f45bfb6c4474bddb$export$cd059ee7fd0e9f3d(t) {
    let e = (0, $eqquT.useEvent)(t), r = (0, $dvPqk.useRef)(!1);
    (0, $dvPqk.useEffect)(()=>(r.current = !1, ()=>{
            r.current = !0, (0, $9vMZh.microTask)(()=>{
                r.current && e();
            });
        }), [
        e
    ]);
}

});

parcelRegister("4vdOn", function(module, exports) {

$parcel$export(module.exports, "useOwnerDocument", function () { return $3474c55d1985fdf4$export$dd9fbcea3de0ae36; });

var $dvPqk = parcelRequire("dvPqk");

var $kotPE = parcelRequire("kotPE");
function $3474c55d1985fdf4$export$dd9fbcea3de0ae36(...o) {
    return (0, $dvPqk.useMemo)(()=>(0, $kotPE.getOwnerDocument)(...o), [
        ...o
    ]);
}

});

parcelRegister("b4lDg", function(module, exports) {

$parcel$export(module.exports, "Direction", function () { return $80f0d921747c215b$export$cacd6541cfeeb6c1; });
$parcel$export(module.exports, "useTabDirection", function () { return $80f0d921747c215b$export$19b797546aece48f; });

var $dvPqk = parcelRequire("dvPqk");

var $038zg = parcelRequire("038zg");
var $80f0d921747c215b$export$cacd6541cfeeb6c1 = ((e)=>(e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))($80f0d921747c215b$export$cacd6541cfeeb6c1 || {});
function $80f0d921747c215b$export$19b797546aece48f() {
    let e = (0, $dvPqk.useRef)(0);
    return (0, $038zg.useWindowEvent)("keydown", (r)=>{
        r.key === "Tab" && (e.current = r.shiftKey ? 1 : 0);
    }, !0), e;
}

});
parcelRegister("038zg", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", function () { return $0096ed4b6893d09b$export$ee579bb285b8d4aa; });

var $dvPqk = parcelRequire("dvPqk");

var $8CvXL = parcelRequire("8CvXL");
function $0096ed4b6893d09b$export$ee579bb285b8d4aa(e, o, t) {
    let r = (0, $8CvXL.useLatestValue)(o);
    (0, $dvPqk.useEffect)(()=>{
        function n(s) {
            r.current(s);
        }
        return window.addEventListener(e, n, t), ()=>window.removeEventListener(e, n, t);
    }, [
        e,
        t
    ]);
}

});


parcelRegister("78heA", function(module, exports) {

$parcel$export(module.exports, "useWatch", function () { return $5316a620826e62a2$export$3c773aa2b84f29e0; });

var $dvPqk = parcelRequire("dvPqk");

var $eqquT = parcelRequire("eqquT");
function $5316a620826e62a2$export$3c773aa2b84f29e0(o, e) {
    let r = (0, $dvPqk.useRef)([]), t = (0, $eqquT.useEvent)(o);
    (0, $dvPqk.useEffect)(()=>{
        let f = [
            ...r.current
        ];
        for (let [n, u] of e.entries())if (r.current[n] !== u) {
            let s = t(e, f);
            return r.current = e, s;
        }
    }, [
        t,
        ...e
    ]);
}

});

parcelRegister("lx9M1", function(module, exports) {

$parcel$export(module.exports, "history", function () { return $fad442db3d5812d0$export$55abd4691b317664; });

var $lNkLN = parcelRequire("lNkLN");
let $fad442db3d5812d0$export$55abd4691b317664 = [];
(0, $lNkLN.onDocumentReady)(()=>{
    function e(n) {
        n.target instanceof HTMLElement && n.target !== document.body && $fad442db3d5812d0$export$55abd4691b317664[0] !== n.target && ($fad442db3d5812d0$export$55abd4691b317664.unshift(n.target), $fad442db3d5812d0$export$55abd4691b317664 = $fad442db3d5812d0$export$55abd4691b317664.filter((d)=>d != null && d.isConnected), $fad442db3d5812d0$export$55abd4691b317664.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});

});
parcelRegister("lNkLN", function(module, exports) {

$parcel$export(module.exports, "onDocumentReady", function () { return $fdde49118a624c63$export$a6a2315df743a26b; });
function $fdde49118a624c63$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", e), e());
}

});



parcelRegister("3qOSj", function(module, exports) {

$parcel$export(module.exports, "useNestedPortals", function () { return $27fb43857a2eb130$export$26b8c35244a70b37; });
$parcel$export(module.exports, "Portal", function () { return $27fb43857a2eb130$export$602eac185826482c; });

var $dvPqk = parcelRequire("dvPqk");

var $im7eH = parcelRequire("im7eH");

var $eqquT = parcelRequire("eqquT");

var $ld2X6 = parcelRequire("ld2X6");

var $kYIzf = parcelRequire("kYIzf");

var $4vdOn = parcelRequire("4vdOn");

var $fFyW3 = parcelRequire("fFyW3");

var $hvflL = parcelRequire("hvflL");

var $i9i7B = parcelRequire("i9i7B");

var $dWhVx = parcelRequire("dWhVx");

var $b3KIl = parcelRequire("b3KIl");
function $27fb43857a2eb130$var$_(a) {
    let l = (0, $i9i7B.usePortalRoot)(), u = (0, $dvPqk.useContext)($27fb43857a2eb130$var$x), e = (0, $4vdOn.useOwnerDocument)(a), [o, n] = (0, $dvPqk.useState)(()=>{
        if (!l && u !== null || (0, $dWhVx.env).isServer) return null;
        let r = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (r) return r;
        if (e === null) return null;
        let t = e.createElement("div");
        return t.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(t);
    });
    return (0, $dvPqk.useEffect)(()=>{
        o !== null && (e != null && e.body.contains(o) || e == null || e.body.appendChild(o));
    }, [
        o,
        e
    ]), (0, $dvPqk.useEffect)(()=>{
        l || u !== null && n(u.current);
    }, [
        u,
        n,
        l
    ]), o;
}
let $27fb43857a2eb130$var$j = (0, $dvPqk.Fragment);
function $27fb43857a2eb130$var$w(a, l) {
    let u = a, e = (0, $dvPqk.useRef)(null), o = (0, $hvflL.useSyncRefs)((0, $hvflL.optionalRef)((s)=>{
        e.current = s;
    }), l), n = (0, $4vdOn.useOwnerDocument)(e), r = $27fb43857a2eb130$var$_(e), [t] = (0, $dvPqk.useState)(()=>{
        var s;
        return (0, $dWhVx.env).isServer ? null : (s = n == null ? void 0 : n.createElement("div")) != null ? s : null;
    }), i = (0, $dvPqk.useContext)($27fb43857a2eb130$var$f), N = (0, $fFyW3.useServerHandoffComplete)();
    return (0, $ld2X6.useIsoMorphicEffect)(()=>{
        !r || !t || r.contains(t) || (t.setAttribute("data-headlessui-portal", ""), r.appendChild(t));
    }, [
        r,
        t
    ]), (0, $ld2X6.useIsoMorphicEffect)(()=>{
        if (t && i) return i.register(t);
    }, [
        i,
        t
    ]), (0, $kYIzf.useOnUnmount)(()=>{
        var s;
        !r || !t || (t instanceof Node && r.contains(t) && r.removeChild(t), r.childNodes.length <= 0 && ((s = r.parentElement) == null || s.removeChild(r)));
    }), N ? !r || !t ? null : (0, $im7eH.createPortal)((0, $b3KIl.render)({
        ourProps: {
            ref: o
        },
        theirProps: u,
        defaultTag: $27fb43857a2eb130$var$j,
        name: "Portal"
    }), t) : null;
}
let $27fb43857a2eb130$var$D = (0, $dvPqk.Fragment), $27fb43857a2eb130$var$x = (0, $dvPqk.createContext)(null);
function $27fb43857a2eb130$var$F(a, l) {
    let { target: u, ...e } = a, o = {
        ref: (0, $hvflL.useSyncRefs)(l)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($27fb43857a2eb130$var$x.Provider, {
        value: u
    }, (0, $b3KIl.render)({
        ourProps: o,
        theirProps: e,
        defaultTag: $27fb43857a2eb130$var$D,
        name: "Popover.Group"
    }));
}
let $27fb43857a2eb130$var$f = (0, $dvPqk.createContext)(null);
function $27fb43857a2eb130$export$26b8c35244a70b37() {
    let a = (0, $dvPqk.useContext)($27fb43857a2eb130$var$f), l = (0, $dvPqk.useRef)([]), u = (0, $eqquT.useEvent)((n)=>(l.current.push(n), a && a.register(n), ()=>e(n))), e = (0, $eqquT.useEvent)((n)=>{
        let r = l.current.indexOf(n);
        r !== -1 && l.current.splice(r, 1), a && a.unregister(n);
    }), o = (0, $dvPqk.useMemo)(()=>({
            register: u,
            unregister: e,
            portals: l
        }), [
        u,
        e,
        l
    ]);
    return [
        l,
        (0, $dvPqk.useMemo)(()=>function({ children: n }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($27fb43857a2eb130$var$f.Provider, {
                    value: o
                }, n);
            }, [
            o
        ])
    ];
}
let $27fb43857a2eb130$var$G = (0, $b3KIl.forwardRefWithAs)($27fb43857a2eb130$var$w), $27fb43857a2eb130$var$M = (0, $b3KIl.forwardRefWithAs)($27fb43857a2eb130$var$F), $27fb43857a2eb130$export$602eac185826482c = Object.assign($27fb43857a2eb130$var$G, {
    Group: $27fb43857a2eb130$var$M
});

});
parcelRegister("i9i7B", function(module, exports) {

$parcel$export(module.exports, "usePortalRoot", function () { return $d3671fd7f45582a8$export$6ecd3efa4eebe261; });
$parcel$export(module.exports, "ForcePortalRoot", function () { return $d3671fd7f45582a8$export$8f2af6644e3a3c93; });

var $dvPqk = parcelRequire("dvPqk");
let $d3671fd7f45582a8$var$t = (0, $dvPqk.createContext)(!1);
function $d3671fd7f45582a8$export$6ecd3efa4eebe261() {
    return (0, $dvPqk.useContext)($d3671fd7f45582a8$var$t);
}
function $d3671fd7f45582a8$export$8f2af6644e3a3c93(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($d3671fd7f45582a8$var$t.Provider, {
        value: e.force
    }, e.children);
}

});


parcelRegister("fwHoq", function(module, exports) {

$parcel$export(module.exports, "useDocumentOverflowLockedEffect", function () { return $b4db8116819c4743$export$bb0ae4a42bcd9e0; });

var $dNTaN = parcelRequire("dNTaN");

var $ld2X6 = parcelRequire("ld2X6");

var $fYdmP = parcelRequire("fYdmP");
function $b4db8116819c4743$export$bb0ae4a42bcd9e0(o, r, f) {
    let e = (0, $dNTaN.useStore)((0, $fYdmP.overflows)), s = o ? e.get(o) : void 0, i = s ? s.count > 0 : !1;
    return (0, $ld2X6.useIsoMorphicEffect)(()=>{
        if (!(!o || !r)) return (0, $fYdmP.overflows).dispatch("PUSH", o, f), ()=>(0, $fYdmP.overflows).dispatch("POP", o, f);
    }, [
        r,
        o
    ]), i;
}

});
parcelRegister("dNTaN", function(module, exports) {

$parcel$export(module.exports, "useStore", function () { return $a0caa6300e415459$export$6ccbb43953eebf8; });

var $6fXuD = parcelRequire("6fXuD");
function $a0caa6300e415459$export$6ccbb43953eebf8(e) {
    return (0, $6fXuD.useSyncExternalStore)(e.subscribe, e.getSnapshot, e.getSnapshot);
}

});
parcelRegister("6fXuD", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $48e24ae1f56de3bd$export$306c0aa65ff9ec16; });

var $dvPqk = parcelRequire("dvPqk");

var $9zfJK = parcelRequire("9zfJK");

var $gAMXb = parcelRequire("gAMXb");
const $48e24ae1f56de3bd$var$r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", $48e24ae1f56de3bd$var$a = !$48e24ae1f56de3bd$var$r, $48e24ae1f56de3bd$var$d = $48e24ae1f56de3bd$var$a ? (0, $gAMXb.useSyncExternalStore) : (0, $9zfJK.useSyncExternalStore), $48e24ae1f56de3bd$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $dvPqk ? ((n)=>n.useSyncExternalStore)($dvPqk) : $48e24ae1f56de3bd$var$d;

});
parcelRegister("9zfJK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $6f7396f5b385ca3c$export$306c0aa65ff9ec16; });

var $dvPqk = parcelRequire("dvPqk");
function $6f7396f5b385ca3c$var$r(t, n) {
    return t === n && (t !== 0 || 1 / t === 1 / n) || t !== t && n !== n;
}
const $6f7396f5b385ca3c$var$i = typeof Object.is == "function" ? Object.is : $6f7396f5b385ca3c$var$r, { useState: $6f7396f5b385ca3c$var$f, useEffect: $6f7396f5b385ca3c$var$p, useLayoutEffect: $6f7396f5b385ca3c$var$S, useDebugValue: $6f7396f5b385ca3c$var$h } = $dvPqk;
function $6f7396f5b385ca3c$export$306c0aa65ff9ec16(t, n, c) {
    const u = n(), [{ inst: s }, e] = $6f7396f5b385ca3c$var$f({
        inst: {
            value: u,
            getSnapshot: n
        }
    });
    return $6f7396f5b385ca3c$var$S(()=>{
        s.value = u, s.getSnapshot = n, $6f7396f5b385ca3c$var$o(s) && e({
            inst: s
        });
    }, [
        t,
        u,
        n
    ]), $6f7396f5b385ca3c$var$p(()=>($6f7396f5b385ca3c$var$o(s) && e({
            inst: s
        }), t(()=>{
            $6f7396f5b385ca3c$var$o(s) && e({
                inst: s
            });
        })), [
        t
    ]), $6f7396f5b385ca3c$var$h(u), u;
}
function $6f7396f5b385ca3c$var$o(t) {
    const n = t.getSnapshot, c = t.value;
    try {
        const u = n();
        return !$6f7396f5b385ca3c$var$i(c, u);
    } catch  {
        return !0;
    }
}

});

parcelRegister("gAMXb", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $c145fb4ff530abfe$export$306c0aa65ff9ec16; });
function $c145fb4ff530abfe$export$306c0aa65ff9ec16(r, n, t) {
    return n();
}

});



parcelRegister("fYdmP", function(module, exports) {

$parcel$export(module.exports, "overflows", function () { return $ba06d412e693fd86$export$a4161f418919b5aa; });

var $bVyso = parcelRequire("bVyso");

var $gm0wF = parcelRequire("gm0wF");

var $l1q80 = parcelRequire("l1q80");

var $8Mv1W = parcelRequire("8Mv1W");

var $6ms7O = parcelRequire("6ms7O");
function $ba06d412e693fd86$var$m(e) {
    let o = {};
    for (let t of e)Object.assign(o, t(o));
    return o;
}
let $ba06d412e693fd86$export$a4161f418919b5aa = (0, $gm0wF.createStore)(()=>/* @__PURE__ */ new Map(), {
    PUSH (e, o) {
        var t;
        let r = (t = this.get(e)) != null ? t : {
            doc: e,
            count: 0,
            d: (0, $bVyso.disposables)(),
            meta: /* @__PURE__ */ new Set()
        };
        return r.count++, r.meta.add(o), this.set(e, r), this;
    },
    POP (e, o) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(o)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: o, meta: t }) {
        let r = {
            doc: e,
            d: o,
            meta: $ba06d412e693fd86$var$m(t)
        }, a = [
            (0, $8Mv1W.handleIOSLocking)(),
            (0, $l1q80.adjustScrollbarPadding)(),
            (0, $6ms7O.preventScroll)()
        ];
        a.forEach(({ before: l })=>l == null ? void 0 : l(r)), a.forEach(({ after: l })=>l == null ? void 0 : l(r));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$ba06d412e693fd86$export$a4161f418919b5aa.subscribe(()=>{
    let e = $ba06d412e693fd86$export$a4161f418919b5aa.getSnapshot(), o = /* @__PURE__ */ new Map();
    for (let [t] of e)o.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let r = o.get(t.doc) === "hidden", a = t.count !== 0;
        (a && !r || !a && r) && $ba06d412e693fd86$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $ba06d412e693fd86$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});

});
parcelRegister("gm0wF", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $be7f1bdd73950cc2$export$f51a9068ac82ea43; });
function $be7f1bdd73950cc2$export$f51a9068ac82ea43(n, c) {
    let t = n(), r = /* @__PURE__ */ new Set();
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return r.add(e), ()=>r.delete(e);
        },
        dispatch (e, ...l) {
            let a = c[e].call(t, ...l);
            a && (t = a, r.forEach((o)=>o()));
        }
    };
}

});

parcelRegister("l1q80", function(module, exports) {

$parcel$export(module.exports, "adjustScrollbarPadding", function () { return $f4ddf574d3816aae$export$110627fb35ef9205; });
function $f4ddf574d3816aae$export$110627fb35ef9205() {
    let n;
    return {
        before ({ doc: e }) {
            var d;
            let t = e.documentElement;
            n = ((d = e.defaultView) != null ? d : window).innerWidth - t.clientWidth;
        },
        after ({ doc: e, d: d }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, i = n - l;
            d.style(t, "paddingRight", `${i}px`);
        }
    };
}

});

parcelRegister("8Mv1W", function(module, exports) {

$parcel$export(module.exports, "handleIOSLocking", function () { return $664ae06b58e83e0c$export$e3a523dfabf27286; });

var $bVyso = parcelRequire("bVyso");

var $hnTrz = parcelRequire("hnTrz");
function $664ae06b58e83e0c$export$e3a523dfabf27286() {
    return (0, $hnTrz.isIOS)() ? {
        before ({ doc: o, d: n, meta: c }) {
            function r(s) {
                return c.containers.flatMap((a)=>a()).some((a)=>a.contains(s));
            }
            n.microTask(()=>{
                var s;
                if (window.getComputedStyle(o.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $bVyso.disposables)();
                    t.style(o.documentElement, "scrollBehavior", "auto"), n.add(()=>n.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, l = null;
                n.addEventListener(o, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: d } = new URL(e.href), i = o.querySelector(d);
                        i && !r(i) && (l = i);
                    } catch  {}
                }, !0), n.addEventListener(o, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (r(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && r(e.parentElement);)e = e.parentElement;
                            n.style(e, "overscrollBehavior", "contain");
                        } else n.style(t.target, "touchAction", "none");
                    }
                }), n.addEventListener(o, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (r(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), n.add(()=>{
                    var t;
                    let e = (t = window.scrollY) != null ? t : window.pageYOffset;
                    a !== e && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}

});
parcelRegister("hnTrz", function(module, exports) {

$parcel$export(module.exports, "isIOS", function () { return $ca7f97964f5d8b86$export$fedb369cb70207f1; });
$parcel$export(module.exports, "isMobile", function () { return $ca7f97964f5d8b86$export$d0a8044dce8ff2fc; });
function $ca7f97964f5d8b86$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $ca7f97964f5d8b86$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $ca7f97964f5d8b86$export$d0a8044dce8ff2fc() {
    return $ca7f97964f5d8b86$export$fedb369cb70207f1() || $ca7f97964f5d8b86$export$a11b0059900ceec8();
}

});


parcelRegister("6ms7O", function(module, exports) {

$parcel$export(module.exports, "preventScroll", function () { return $4a1a9d3188353e96$export$d8b6ff28805e84e9; });
function $4a1a9d3188353e96$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

});



parcelRegister("4UJ5c", function(module, exports) {

$parcel$export(module.exports, "useInert", function () { return $393f5cec1c28669a$export$bbe4e2927a3450da; });

var $ld2X6 = parcelRequire("ld2X6");
let $393f5cec1c28669a$var$a = /* @__PURE__ */ new Map(), $393f5cec1c28669a$var$t = /* @__PURE__ */ new Map();
function $393f5cec1c28669a$export$bbe4e2927a3450da(r, u = !0) {
    (0, $ld2X6.useIsoMorphicEffect)(()=>{
        var d;
        if (!u) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function o() {
            var f;
            if (!e) return;
            let n = (f = $393f5cec1c28669a$var$t.get(e)) != null ? f : 1;
            if (n === 1 ? $393f5cec1c28669a$var$t.delete(e) : $393f5cec1c28669a$var$t.set(e, n - 1), n !== 1) return;
            let i = $393f5cec1c28669a$var$a.get(e);
            i && (i["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", i["aria-hidden"]), e.inert = i.inert, $393f5cec1c28669a$var$a.delete(e));
        }
        let l = (d = $393f5cec1c28669a$var$t.get(e)) != null ? d : 0;
        return $393f5cec1c28669a$var$t.set(e, l + 1), l !== 0 || ($393f5cec1c28669a$var$a.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), o;
    }, [
        r,
        u
    ]);
}

});

parcelRegister("kNa7k", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", function () { return $f2303b565706b753$export$71b2224f1ce5e08e; });

var $dvPqk = parcelRequire("dvPqk");

var $ae7L7 = parcelRequire("ae7L7");

var $hnTrz = parcelRequire("hnTrz");

var $aLkk9 = parcelRequire("aLkk9");

var $038zg = parcelRequire("038zg");
function $f2303b565706b753$export$71b2224f1ce5e08e(m, d, a = !0) {
    let l = (0, $dvPqk.useRef)(!1);
    (0, $dvPqk.useEffect)(()=>{
        requestAnimationFrame(()=>{
            l.current = a;
        });
    }, [
        a
    ]);
    function i(t, r) {
        if (!l.current || t.defaultPrevented) return;
        let e = r(t);
        if (e === null || !e.getRootNode().contains(e) || !e.isConnected) return;
        let f = function o(n) {
            return typeof n == "function" ? o(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(m);
        for (let o of f){
            if (o === null) continue;
            let n = o instanceof HTMLElement ? o : o.current;
            if (n != null && n.contains(e) || t.composed && t.composedPath().includes(n)) return;
        }
        return !(0, $ae7L7.isFocusableElement)(e, (0, $ae7L7.FocusableMode).Loose) && e.tabIndex !== -1 && t.preventDefault(), d(t, e);
    }
    let u = (0, $dvPqk.useRef)(null);
    (0, $aLkk9.useDocumentEvent)("pointerdown", (t)=>{
        var r, e;
        l.current && (u.current = ((e = (r = t.composedPath) == null ? void 0 : r.call(t)) == null ? void 0 : e[0]) || t.target);
    }, !0), (0, $aLkk9.useDocumentEvent)("mousedown", (t)=>{
        var r, e;
        l.current && (u.current = ((e = (r = t.composedPath) == null ? void 0 : r.call(t)) == null ? void 0 : e[0]) || t.target);
    }, !0), (0, $aLkk9.useDocumentEvent)("click", (t)=>{
        (0, $hnTrz.isMobile)() || u.current && (i(t, ()=>u.current), u.current = null);
    }, !0), (0, $aLkk9.useDocumentEvent)("touchend", (t)=>i(t, ()=>t.target instanceof HTMLElement ? t.target : null), !0), (0, $038zg.useWindowEvent)("blur", (t)=>i(t, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

});
parcelRegister("aLkk9", function(module, exports) {

$parcel$export(module.exports, "useDocumentEvent", function () { return $7d5e0f196e423271$export$55d2b5df396a097b; });

var $dvPqk = parcelRequire("dvPqk");

var $8CvXL = parcelRequire("8CvXL");
function $7d5e0f196e423271$export$55d2b5df396a097b(e, o, t) {
    let r = (0, $8CvXL.useLatestValue)(o);
    (0, $dvPqk.useEffect)(()=>{
        function n(u) {
            r.current(u);
        }
        return document.addEventListener(e, n, t), ()=>document.removeEventListener(e, n, t);
    }, [
        e,
        t
    ]);
}

});


parcelRegister("bY06o", function(module, exports) {

$parcel$export(module.exports, "useRootContainers", function () { return $8b65609484754685$export$445f2d1a3d9b1b9f; });

var $dvPqk = parcelRequire("dvPqk");

var $jQKuj = parcelRequire("jQKuj");

var $eqquT = parcelRequire("eqquT");

var $4vdOn = parcelRequire("4vdOn");
function $8b65609484754685$export$445f2d1a3d9b1b9f({ defaultContainers: o = [], portals: s, mainTreeNodeRef: r } = {}) {
    var a;
    let n = (0, $dvPqk.useRef)((a = r == null ? void 0 : r.current) != null ? a : null), i = (0, $4vdOn.useOwnerDocument)(n), f = (0, $eqquT.useEvent)(()=>{
        var u, l, c;
        let t = [];
        for (let e of o)e !== null && (e instanceof HTMLElement ? t.push(e) : "current" in e && e.current instanceof HTMLElement && t.push(e.current));
        if (s != null && s.current) for (let e of s.current)t.push(e);
        for (let e of (u = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? u : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(n.current) || e.contains((c = (l = n.current) == null ? void 0 : l.getRootNode()) == null ? void 0 : c.host) || t.some((N)=>e.contains(N)) || t.push(e));
        return t;
    });
    return {
        resolveContainers: f,
        contains: (0, $eqquT.useEvent)((u)=>f().some((l)=>l.contains(u))),
        mainTreeNodeRef: n,
        MainTreeNode: (0, $dvPqk.useMemo)(()=>function() {
                return r != null ? null : (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $jQKuj.Hidden), {
                    features: (0, $jQKuj.Features).Hidden,
                    ref: n
                });
            }, [
            n,
            r
        ])
    };
}
function $8b65609484754685$export$64db24433d7f4942() {
    let o = (0, $dvPqk.useRef)(null);
    return {
        mainTreeNodeRef: o,
        MainTreeNode: (0, $dvPqk.useMemo)(()=>function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $jQKuj.Hidden), {
                    features: (0, $jQKuj.Features).Hidden,
                    ref: o
                });
            }, [
            o
        ])
    };
}

});

parcelRegister("dcmqG", function(module, exports) {

$parcel$export(module.exports, "StackMessage", function () { return $99bdcb620335e40f$export$2dd25ef07fea092e; });
$parcel$export(module.exports, "StackProvider", function () { return $99bdcb620335e40f$export$4aac1a6640027f56; });

var $dvPqk = parcelRequire("dvPqk");

var $eqquT = parcelRequire("eqquT");

var $ld2X6 = parcelRequire("ld2X6");
let $99bdcb620335e40f$var$l = (0, $dvPqk.createContext)(()=>{});
$99bdcb620335e40f$var$l.displayName = "StackContext";
var $99bdcb620335e40f$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($99bdcb620335e40f$export$2dd25ef07fea092e || {});
function $99bdcb620335e40f$export$59510f5936c4d8c4() {
    return (0, $dvPqk.useContext)($99bdcb620335e40f$var$l);
}
function $99bdcb620335e40f$export$4aac1a6640027f56({ children: e, onUpdate: s, type: r, element: a, enabled: n }) {
    let d = $99bdcb620335e40f$export$59510f5936c4d8c4(), o = (0, $eqquT.useEvent)((...t)=>{
        s == null || s(...t), d(...t);
    });
    return (0, $ld2X6.useIsoMorphicEffect)(()=>{
        let t = n === void 0 || n === !0;
        return t && o(0, r, a), ()=>{
            t && o(1, r, a);
        };
    }, [
        o,
        r,
        a,
        n
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($99bdcb620335e40f$var$l.Provider, {
        value: o
    }, e);
}

});






parcelRegister("3VAM4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f93e4ecda8deb1e4$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $aRSTV = parcelRequire("aRSTV");

var $bcbvQ = parcelRequire("bcbvQ");

var $hOaHV = parcelRequire("hOaHV");

var $3kQAm = parcelRequire("3kQAm");

var $5ogfk = parcelRequire("5ogfk");
const $f93e4ecda8deb1e4$var$FavoritesAndSubscriptionsWidget = ({ heading: heading })=>{
    if (!(0, $bcbvQ.default).isLoggedIn()) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5ogfk.default), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                heading: heading,
                count: 4,
                skus: (0, $hOaHV.default).allSkus.slice(0, 4),
                buttonText: "Favorittlister",
                buttonUrl: "/customer/favorites",
                listName: "Mine Favoritter (CMS Block)",
                listType: (0, $aRSTV.LIST_TYPE).CUSTOM,
                context: "favorites-and-subscriptions"
            })
        ]
    });
};
var $f93e4ecda8deb1e4$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f93e4ecda8deb1e4$var$FavoritesAndSubscriptionsWidget);

});
parcelRegister("5ogfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51c49aab512d3345$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $duLFK = parcelRequire("duLFK");

var $5aUWQ = parcelRequire("5aUWQ");

var $9Vrue = parcelRequire("9Vrue");

var $6r4MQ = parcelRequire("6r4MQ");

var $jSWI5 = parcelRequire("jSWI5");

var $aPlU5 = parcelRequire("aPlU5");
const $51c49aab512d3345$var$ShortcutBoxes = ()=>{
    if ((0, $duLFK.isDefaultData)((0, $5aUWQ.default).subscriptionsList) || (0, $duLFK.isWaitingForData)((0, $5aUWQ.default).subscriptionsList)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {
        label: "Laster informasjon om abonnement"
    });
    const hasSubscriptions = (0, $5aUWQ.default).subscriptionsList.data.length > 0;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex h-full flex-col",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                className: "mb-6",
                children: "Snarveier"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "mb-2 flex flex-col items-stretch md:flex-row",
                children: [
                    hasSubscriptions ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6r4MQ.default), {}) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aPlU5.default), {}),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jSWI5.default), {})
                ]
            })
        ]
    });
};
var $51c49aab512d3345$export$2e2bcd8739ae039 = (0, $gBcml.observer)($51c49aab512d3345$var$ShortcutBoxes);

});
parcelRegister("6r4MQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ff4f0e7d75e9ccf$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $gtsdT = parcelRequire("gtsdT");

var $76PCP = parcelRequire("76PCP");

var $5aUWQ = parcelRequire("5aUWQ");

var $cLLe3 = parcelRequire("cLLe3");

var $aBy60 = parcelRequire("aBy60");

var $9Vrue = parcelRequire("9Vrue");

var $6erqj = parcelRequire("6erqj");
const $1ff4f0e7d75e9ccf$var$ShortcutChangeSubscription = ()=>{
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    const [showModal, setShowModal] = (0, $dvPqk.useState)(false);
    const startEdit = (orderNumber)=>{
        if ((0, $bEEBX.default)(orderNumber)) {
            (0, $gtsdT.logger).warn("subscription", "Missing order number when starting edit of subscription");
            return;
        }
        setShowModal(true);
        (0, $5aUWQ.default).fetchSubscriptionDetails(orderNumber).then((subscription)=>{
            if (subscription !== null) {
                setShowModal(false);
                (0, $76PCP.default).startEditSubscriptionMode(subscription);
                redirectTo("/checkout/cart");
            }
        });
    };
    const options = (0, $5aUWQ.default).subscriptionsList.data.map((sub)=>({
            label: sub.name,
            value: sub.orderNumber
        }));
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            showModal && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {
                modal: true,
                label: "Henter abonnementsdetaljer..."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6erqj.default), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                        children: "Mine abonnement"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        children: "Se oversikt over dine abonnement, eller velg et abonnement for \xe5 endre alle fremtidige leveringer."
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        to: "/customer/subscriptions",
                        variant: "secondary",
                        className: "my-2",
                        children: "Alle abonnement"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aBy60.default), {
                        label: "",
                        options: options,
                        value: {
                            label: "Endre abonnement",
                            value: "",
                            isDisabled: true
                        },
                        onChange: (option)=>startEdit(option.value || null),
                        zOnOpen: 30
                    })
                ]
            })
        ]
    });
};
var $1ff4f0e7d75e9ccf$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1ff4f0e7d75e9ccf$var$ShortcutChangeSubscription);

});
parcelRegister("aBy60", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbc6b202b18a77f7$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $1Q5Iy = parcelRequire("1Q5Iy");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");
const $cbc6b202b18a77f7$var$zStyle = {
    0: "!z-0",
    10: "!z-10",
    20: "!z-20",
    30: "!z-30",
    40: "!z-40",
    50: "!z-50",
    auto: "!z-auto"
};
const $cbc6b202b18a77f7$var$SelectWapper = ({ zOnOpen: zOnOpen = 0, className: className = "", ...props })=>{
    const ref = (0, $dvPqk.useRef)(null);
    const [open, setOpen] = (0, $dvPqk.useState)(false);
    const selectClassName = (0, $izjX7.cn)(className, {
        [$cbc6b202b18a77f7$var$zStyle[zOnOpen]]: open
    });
    (0, $dvPqk.useEffect)(()=>{
        const mutationCallback = ()=>{
            if (ref.current) {
                const ul = ref.current.querySelector("ul");
                if (ul) {
                    setOpen(true);
                    return;
                }
            }
            setOpen(false);
        };
        let observer = null;
        if (ref.current) {
            observer = new MutationObserver(mutationCallback);
            observer.observe(ref.current, {
                subtree: true,
                childList: true
            });
        }
        return ()=>{
            if (observer) observer.disconnect();
        };
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ref: ref,
        className: "w-full",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1Q5Iy.Select), {
            ...props,
            className: selectClassName
        })
    });
};
var $cbc6b202b18a77f7$export$2e2bcd8739ae039 = $cbc6b202b18a77f7$var$SelectWapper;

});
parcelRegister("1Q5Iy", function(module, exports) {

$parcel$export(module.exports, "Select", function () { return $156f15262ca292c0$export$ef9b1a59e592288f; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $lFdyG = parcelRequire("lFdyG");

var $eVBn0 = parcelRequire("eVBn0");

var $f9y8a = parcelRequire("f9y8a");

var $gOPk0 = parcelRequire("gOPk0");
const $156f15262ca292c0$var$J = {
    24: "max-h-24",
    32: "max-h-32",
    40: "max-h-40",
    48: "max-h-48",
    56: "max-h-56",
    64: "max-h-64",
    72: "max-h-72",
    80: "max-h-80",
    96: "max-h-96"
};
function $156f15262ca292c0$export$ef9b1a59e592288f({ label: v, isLabelHidden: c = !1, className: g, value: p, options: t, description: k, onChange: y, isDisabled: n, placeholder: S = "Select", tooltipPosition: N = "right", tooltipText: w = "", errorMessage: O = "", showErrorMessage: f = !1, required: j, optGroup: h = !1, isNative: I = !1, isScrollable: T = !1, maxHeight: $ = 48, ...s }) {
    var A;
    const b = (0, $dvPqk.useId)(), m = Array.isArray(t[0]) || (A = t[0]) != null && A.options ? t.flatMap((r)=>r.options) : t;
    if ((0, $6sMuH.isEmptyArray)(m)) return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("h2", {
                children: "Error:"
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                children: "No options, or invalid options provided."
            })
        ]
    });
    const { label: z = "" } = p;
    return I ? /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("flex flex-col gap-2 full relative", c && "gap-0", g),
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lFdyG.FormDetails), {
                description: k,
                id: b,
                isDisabled: n,
                isLabelHidden: c,
                label: v,
                tooltipPosition: N,
                tooltipText: w
            }),
            /* @__PURE__ */ (0, $7YWoO.jsxs)("select", {
                className: (0, $6sMuH.cn)("w-full p-2 rounded border border-ink-brand-default text-base transition-all ease-in-out duration-200 cursor-pointer", "hover:border-ink-brand-default-TODO:fix-hover focus:border-ink-brand-default-TODO:fix-focus focus:ring-2 focus:ring-information-600 focus:outline-none", n && "!bg-base-50 !text-ink-disabled !cursor-not-allowed", f && "!border-error-600"),
                disabled: n,
                id: b,
                onChange: (r)=>{
                    const e = m.find((a)=>a.value === r.target.value);
                    e && y(e);
                },
                ...s,
                children: [
                    h ? Array.isArray(t) && t.map((r, e)=>/* @__PURE__ */ (0, $7YWoO.jsx)("optgroup", {
                            label: r.optGroupLabel || r.label,
                            children: r.options.map((a)=>/* @__PURE__ */ (0, $7YWoO.jsx)("option", {
                                    disabled: a.isDisabled,
                                    value: a.value,
                                    children: a.label
                                }, a.id))
                        }, `group-${e}`)) : null,
                    !h && m.map((r)=>/* @__PURE__ */ (0, $7YWoO.jsx)("option", {
                            disabled: r.isDisabled,
                            value: r.value,
                            children: r.label
                        }, r.id))
                ]
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $eVBn0.FormError), {
                errorMessage: O,
                showErrorMessage: f
            })
        ]
    }) : /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("flex flex-col gap-2 full relative", g),
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $f9y8a.Listbox), {
                disabled: n,
                onChange: y,
                value: p,
                children: ({ open: r })=>/* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                        className: (0, $6sMuH.cn)("flex relative flex-col w-full gap-2", c && "gap-0", r && "z-10"),
                        onBlur: (e)=>{
                            !e.currentTarget.contains(e.relatedTarget) && s.onBlur && s.onBlur(e);
                        },
                        children: [
                            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lFdyG.FormDetails), {
                                description: k,
                                id: b,
                                isDisabled: n,
                                isLabelHidden: c,
                                label: v,
                                tooltipPosition: N,
                                tooltipText: w
                            }),
                            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                                className: (0, $6sMuH.cn)("relative w-full bg-surface-default", r && "drop-shadow-lg"),
                                children: [
                                    /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $f9y8a.Listbox).Button, {
                                        "aria-required": j,
                                        className: (0, $6sMuH.cn)("text-left w-full cursor-pointer text-base p-2 transition-all ease-in-out rounded duration-200 flex items-center justify-between", "border-ink-disabled border-2 hover:border-ink-brand-default", // focus
                                        "focus-visible:ring-2 focus-visible:ring-information-600 focus-visible:outline-none", r ? "bg-surface-action text-ink-brand-inverted border-surface-action rounded-b-none" : "bg-surface-default border-surface-ink-brand-default rounded text-ink-default", n && "!bg-base-50 !text-ink-disabled !cursor-not-allowed ", f && "!border-error-600"),
                                        id: b,
                                        children: [
                                            z || S,
                                            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $gOPk0.default), {
                                                "aria-hidden": "true",
                                                className: (0, $6sMuH.cn)("transition-all ease-in-out duration-300 text-base w-5 h-5", r ? "rotate-180 fill-ink-brand-inverted" : "text-ink-default rotate-0 fill-ink-brand-default", n && "fill-ink-disabled")
                                            })
                                        ]
                                    }),
                                    /* @__PURE__ */ (0, $7YWoO.jsx)((0, $f9y8a.Listbox).Options, {
                                        className: (0, $6sMuH.cn)(// basic layout
                                        "absolute z-10 block left-0 right-0 w-full rounded-b bg-surface-default m-0 p-0 focus:outline-none", // whether the select should scroll or extend
                                        T ? `overflow-y-auto ${$156f15262ca292c0$var$J[$]}` : "overflow-clip", // reset
                                        "list-none"),
                                        onFocus: (e)=>{
                                            s.onFocus && s.onFocus(e);
                                        },
                                        children: h && Array.isArray(t) ? t.map((e, a)=>/* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                                                children: [
                                                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                                        className: "px-2 py-1 text-sm font-semibold text-ink-light",
                                                        children: e.optGroupLabel || e.label
                                                    }),
                                                    e.options.map((o)=>/* @__PURE__ */ (0, $7YWoO.jsx)((0, $f9y8a.Listbox).Option, {
                                                            disabled: o.isDisabled,
                                                            value: o,
                                                            children: ({ selected: x, active: q, disabled: C })=>/* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                                                    className: (0, $6sMuH.cn)("relative flex cursor-default select-none p-2 text-base pl-4", (x || q) && "bg-surface-default-hover cursor-pointer", C && "text-ink-disabled cursor-not-allowed bg-base-50"),
                                                                    children: /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                                                        children: o.label
                                                                    })
                                                                })
                                                        }, o.id))
                                                ]
                                            }, `group-${a}`)) : m.map((e)=>/* @__PURE__ */ (0, $7YWoO.jsx)((0, $f9y8a.Listbox).Option, {
                                                disabled: e.isDisabled,
                                                value: e,
                                                children: ({ selected: a, active: o, disabled: x })=>/* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                                        className: (0, $6sMuH.cn)("relative flex cursor-default select-none p-2 text-base", (a || o) && "bg-surface-default-hover cursor-pointer", x && "text-ink-disabled cursor-not-allowed bg-base-50"),
                                                        children: /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                                            children: e.label
                                                        })
                                                    })
                                            }, e.id))
                                    })
                                ]
                            })
                        ]
                    })
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $eVBn0.FormError), {
                errorMessage: O,
                showErrorMessage: f
            })
        ]
    });
}
$156f15262ca292c0$export$ef9b1a59e592288f.displayName = "Select";

});
parcelRegister("f9y8a", function(module, exports) {

$parcel$export(module.exports, "Listbox", function () { return $b0822beb482f3a52$export$8bad31ff872c7659; });

var $dvPqk = parcelRequire("dvPqk");

var $cJ1XS = parcelRequire("cJ1XS");

var $2ATfN = parcelRequire("2ATfN");

var $gps2w = parcelRequire("gps2w");

var $eqquT = parcelRequire("eqquT");

var $9O4MK = parcelRequire("9O4MK");

var $ld2X6 = parcelRequire("ld2X6");

var $8CvXL = parcelRequire("8CvXL");

var $kNa7k = parcelRequire("kNa7k");

var $j8VJ1 = parcelRequire("j8VJ1");

var $hvflL = parcelRequire("hvflL");

var $1QVGU = parcelRequire("1QVGU");

var $j8bzA = parcelRequire("j8bzA");

var $jQKuj = parcelRequire("jQKuj");

var $gKPjJ = parcelRequire("gKPjJ");

var $eRLkK = parcelRequire("eRLkK");

var $3iXMk = parcelRequire("3iXMk");

var $bVyso = parcelRequire("bVyso");

var $ae7L7 = parcelRequire("ae7L7");

var $bnLGb = parcelRequire("bnLGb");

var $1w8VW = parcelRequire("1w8VW");

var $kotPE = parcelRequire("kotPE");

var $b3KIl = parcelRequire("b3KIl");

var $iJZQ7 = parcelRequire("iJZQ7");
var $b0822beb482f3a52$var$Be = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($b0822beb482f3a52$var$Be || {}), $b0822beb482f3a52$var$Ue = ((e)=>(e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))($b0822beb482f3a52$var$Ue || {}), $b0822beb482f3a52$var$Ne = ((e)=>(e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))($b0822beb482f3a52$var$Ne || {}), $b0822beb482f3a52$var$Ve = ((e)=>(e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.RegisterLabel = 7] = "RegisterLabel", e))($b0822beb482f3a52$var$Ve || {});
function $b0822beb482f3a52$var$G(e, i = (a)=>a) {
    let a = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = (0, $ae7L7.sortByDomNode)(i(e.options.slice()), (u)=>u.dataRef.current.domRef.current), l = a ? r.indexOf(a) : null;
    return l === -1 && (l = null), {
        options: r,
        activeOptionIndex: l
    };
}
let $b0822beb482f3a52$var$ze = {
    1 (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : {
            ...e,
            activeOptionIndex: null,
            listboxState: 1
        };
    },
    0 (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        let i = e.activeOptionIndex, { isSelected: a } = e.dataRef.current, r = e.options.findIndex((l)=>a(l.dataRef.current.value));
        return r !== -1 && (i = r), {
            ...e,
            listboxState: 0,
            activeOptionIndex: i
        };
    },
    2 (e, i) {
        var a;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let r = $b0822beb482f3a52$var$G(e), l = (0, $3iXMk.calculateActiveIndex)(i, {
            resolveItems: ()=>r.options,
            resolveActiveIndex: ()=>r.activeOptionIndex,
            resolveId: (u)=>u.id,
            resolveDisabled: (u)=>u.dataRef.current.disabled
        });
        return {
            ...e,
            ...r,
            searchQuery: "",
            activeOptionIndex: l,
            activationTrigger: (a = i.trigger) != null ? a : 1
        };
    },
    3: (e, i)=>{
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let a = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + i.value.toLowerCase(), l = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + a).concat(e.options.slice(0, e.activeOptionIndex + a)) : e.options).find((t)=>{
            var n;
            return !t.dataRef.current.disabled && ((n = t.dataRef.current.textValue) == null ? void 0 : n.startsWith(r));
        }), u = l ? e.options.indexOf(l) : -1;
        return u === -1 || u === e.activeOptionIndex ? {
            ...e,
            searchQuery: r
        } : {
            ...e,
            searchQuery: r,
            activeOptionIndex: u,
            activationTrigger: 1
        };
    },
    4 (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : {
            ...e,
            searchQuery: ""
        };
    },
    5: (e, i)=>{
        let a = {
            id: i.id,
            dataRef: i.dataRef
        }, r = $b0822beb482f3a52$var$G(e, (l)=>[
                ...l,
                a
            ]);
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(i.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(a)), {
            ...e,
            ...r
        };
    },
    6: (e, i)=>{
        let a = $b0822beb482f3a52$var$G(e, (r)=>{
            let l = r.findIndex((u)=>u.id === i.id);
            return l !== -1 && r.splice(l, 1), r;
        });
        return {
            ...e,
            ...a,
            activationTrigger: 1
        };
    },
    7: (e, i)=>({
            ...e,
            labelId: i.id
        })
}, $b0822beb482f3a52$var$J = (0, $dvPqk.createContext)(null);
$b0822beb482f3a52$var$J.displayName = "ListboxActionsContext";
function $b0822beb482f3a52$var$F(e) {
    let i = (0, $dvPqk.useContext)($b0822beb482f3a52$var$J);
    if (i === null) {
        let a = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(a, $b0822beb482f3a52$var$F), a;
    }
    return i;
}
let $b0822beb482f3a52$var$X = (0, $dvPqk.createContext)(null);
$b0822beb482f3a52$var$X.displayName = "ListboxDataContext";
function $b0822beb482f3a52$var$A(e) {
    let i = (0, $dvPqk.useContext)($b0822beb482f3a52$var$X);
    if (i === null) {
        let a = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(a, $b0822beb482f3a52$var$A), a;
    }
    return i;
}
function $b0822beb482f3a52$var$He(e, i) {
    return (0, $1w8VW.match)(i.type, $b0822beb482f3a52$var$ze, e, i);
}
let $b0822beb482f3a52$var$Ke = (0, $dvPqk.Fragment);
function $b0822beb482f3a52$var$We(e, i) {
    let { value: a, defaultValue: r, form: l, name: u, onChange: t, by: n = (s, d)=>s === d, disabled: f = !1, horizontal: m = !1, multiple: g = !1, ...y } = e;
    const $ = m ? "horizontal" : "vertical";
    let I = (0, $hvflL.useSyncRefs)(i), [O = g ? [] : void 0, h] = (0, $2ATfN.useControllable)(a, t, r), [b, o] = (0, $dvPqk.useReducer)($b0822beb482f3a52$var$He, {
        dataRef: (0, $dvPqk.createRef)(),
        listboxState: 1,
        options: [],
        searchQuery: "",
        labelId: null,
        activeOptionIndex: null,
        activationTrigger: 1
    }), v = (0, $dvPqk.useRef)({
        static: !1,
        hold: !1
    }), M = (0, $dvPqk.useRef)(null), Q = (0, $dvPqk.useRef)(null), W = (0, $dvPqk.useRef)(null), R = (0, $eqquT.useEvent)(typeof n == "string" ? (s, d)=>{
        let S = n;
        return (s == null ? void 0 : s[S]) === (d == null ? void 0 : d[S]);
    } : n), T = (0, $dvPqk.useCallback)((s)=>(0, $1w8VW.match)(c.mode, {
            1: ()=>O.some((d)=>R(d, s)),
            0: ()=>R(O, s)
        }), [
        O
    ]), c = (0, $dvPqk.useMemo)(()=>({
            ...b,
            value: O,
            disabled: f,
            mode: g ? 1 : 0,
            orientation: $,
            compare: R,
            isSelected: T,
            optionsPropsRef: v,
            labelRef: M,
            buttonRef: Q,
            optionsRef: W
        }), [
        O,
        f,
        g,
        b
    ]);
    (0, $ld2X6.useIsoMorphicEffect)(()=>{
        b.dataRef.current = c;
    }, [
        c
    ]), (0, $kNa7k.useOutsideClick)([
        c.buttonRef,
        c.optionsRef
    ], (s, d)=>{
        var S;
        o({
            type: 1
        }), (0, $ae7L7.isFocusableElement)(d, (0, $ae7L7.FocusableMode).Loose) || (s.preventDefault(), (S = c.buttonRef.current) == null || S.focus());
    }, c.listboxState === 0);
    let re = (0, $dvPqk.useMemo)(()=>({
            open: c.listboxState === 0,
            disabled: f,
            value: O
        }), [
        c,
        f,
        O
    ]), ne = (0, $eqquT.useEvent)((s)=>{
        let d = c.options.find((S)=>S.id === s);
        d && j(d.dataRef.current.value);
    }), ie = (0, $eqquT.useEvent)(()=>{
        if (c.activeOptionIndex !== null) {
            let { dataRef: s, id: d } = c.options[c.activeOptionIndex];
            j(s.current.value), o({
                type: 2,
                focus: (0, $3iXMk.Focus).Specific,
                id: d
            });
        }
    }), ae = (0, $eqquT.useEvent)(()=>o({
            type: 0
        })), le = (0, $eqquT.useEvent)(()=>o({
            type: 1
        })), se = (0, $eqquT.useEvent)((s, d, S)=>s === (0, $3iXMk.Focus).Specific ? o({
            type: 2,
            focus: (0, $3iXMk.Focus).Specific,
            id: d,
            trigger: S
        }) : o({
            type: 2,
            focus: s,
            trigger: S
        })), ue = (0, $eqquT.useEvent)((s, d)=>(o({
            type: 5,
            id: s,
            dataRef: d
        }), ()=>o({
                type: 6,
                id: s
            }))), de = (0, $eqquT.useEvent)((s)=>(o({
            type: 7,
            id: s
        }), ()=>o({
                type: 7,
                id: null
            }))), j = (0, $eqquT.useEvent)((s)=>(0, $1w8VW.match)(c.mode, {
            0 () {
                return h == null ? void 0 : h(s);
            },
            1 () {
                let d = c.value.slice(), S = d.findIndex((U)=>R(U, s));
                return S === -1 ? d.push(s) : d.splice(S, 1), h == null ? void 0 : h(d);
            }
        })), pe = (0, $eqquT.useEvent)((s)=>o({
            type: 3,
            value: s
        })), ce = (0, $eqquT.useEvent)(()=>o({
            type: 4
        })), fe = (0, $dvPqk.useMemo)(()=>({
            onChange: j,
            registerOption: ue,
            registerLabel: de,
            goToOption: se,
            closeListbox: le,
            openListbox: ae,
            selectActiveOption: ie,
            selectOption: ne,
            search: pe,
            clearSearch: ce
        }), []), be = {
        ref: I
    }, B = (0, $dvPqk.useRef)(null), ve = (0, $gps2w.useDisposables)();
    return (0, $dvPqk.useEffect)(()=>{
        B.current && r !== void 0 && ve.addEventListener(B.current, "reset", ()=>{
            h == null || h(r);
        });
    }, [
        B,
        h
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($b0822beb482f3a52$var$J.Provider, {
        value: fe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($b0822beb482f3a52$var$X.Provider, {
        value: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $gKPjJ.OpenClosedProvider), {
        value: (0, $1w8VW.match)(c.listboxState, {
            0: (0, $gKPjJ.State).Open,
            1: (0, $gKPjJ.State).Closed
        })
    }, u != null && O != null && (0, $bnLGb.objectToFormEntries)({
        [u]: O
    }).map(([s, d], S)=>(0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $jQKuj.Hidden), {
            features: (0, $jQKuj.Features).Hidden,
            ref: S === 0 ? (U)=>{
                var Y;
                B.current = (Y = U == null ? void 0 : U.closest("form")) != null ? Y : null;
            } : void 0,
            ...(0, $b3KIl.compact)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: l,
                disabled: f,
                name: s,
                value: d
            })
        })), (0, $b3KIl.render)({
        ourProps: be,
        theirProps: y,
        slot: re,
        defaultTag: $b0822beb482f3a52$var$Ke,
        name: "Listbox"
    }))));
}
let $b0822beb482f3a52$var$je = "button";
function $b0822beb482f3a52$var$Ge(e, i) {
    var a;
    let r = (0, $9O4MK.useId)(), { id: l = `headlessui-listbox-button-${r}`, ...u } = e, t = $b0822beb482f3a52$var$A("Listbox.Button"), n = $b0822beb482f3a52$var$F("Listbox.Button"), f = (0, $hvflL.useSyncRefs)(t.buttonRef, i), m = (0, $gps2w.useDisposables)(), g = (0, $eqquT.useEvent)((b)=>{
        switch(b.key){
            case (0, $iJZQ7.Keys).Space:
            case (0, $iJZQ7.Keys).Enter:
            case (0, $iJZQ7.Keys).ArrowDown:
                b.preventDefault(), n.openListbox(), m.nextFrame(()=>{
                    t.value || n.goToOption((0, $3iXMk.Focus).First);
                });
                break;
            case (0, $iJZQ7.Keys).ArrowUp:
                b.preventDefault(), n.openListbox(), m.nextFrame(()=>{
                    t.value || n.goToOption((0, $3iXMk.Focus).Last);
                });
                break;
        }
    }), y = (0, $eqquT.useEvent)((b)=>{
        switch(b.key){
            case (0, $iJZQ7.Keys).Space:
                b.preventDefault();
                break;
        }
    }), $ = (0, $eqquT.useEvent)((b)=>{
        if ((0, $eRLkK.isDisabledReactIssue7711)(b.currentTarget)) return b.preventDefault();
        t.listboxState === 0 ? (n.closeListbox(), m.nextFrame(()=>{
            var o;
            return (o = t.buttonRef.current) == null ? void 0 : o.focus({
                preventScroll: !0
            });
        })) : (b.preventDefault(), n.openListbox());
    }), I = (0, $cJ1XS.useComputed)(()=>{
        if (t.labelId) return [
            t.labelId,
            l
        ].join(" ");
    }, [
        t.labelId,
        l
    ]), O = (0, $dvPqk.useMemo)(()=>({
            open: t.listboxState === 0,
            disabled: t.disabled,
            value: t.value
        }), [
        t
    ]), h = {
        ref: f,
        id: l,
        type: (0, $j8VJ1.useResolveButtonType)(e, t.buttonRef),
        "aria-haspopup": "listbox",
        "aria-controls": (a = t.optionsRef.current) == null ? void 0 : a.id,
        "aria-expanded": t.listboxState === 0,
        "aria-labelledby": I,
        disabled: t.disabled,
        onKeyDown: g,
        onKeyUp: y,
        onClick: $
    };
    return (0, $b3KIl.render)({
        ourProps: h,
        theirProps: u,
        slot: O,
        defaultTag: $b0822beb482f3a52$var$je,
        name: "Listbox.Button"
    });
}
let $b0822beb482f3a52$var$qe = "label";
function $b0822beb482f3a52$var$Je(e, i) {
    let a = (0, $9O4MK.useId)(), { id: r = `headlessui-listbox-label-${a}`, ...l } = e, u = $b0822beb482f3a52$var$A("Listbox.Label"), t = $b0822beb482f3a52$var$F("Listbox.Label"), n = (0, $hvflL.useSyncRefs)(u.labelRef, i);
    (0, $ld2X6.useIsoMorphicEffect)(()=>t.registerLabel(r), [
        r
    ]);
    let f = (0, $eqquT.useEvent)(()=>{
        var g;
        return (g = u.buttonRef.current) == null ? void 0 : g.focus({
            preventScroll: !0
        });
    }), m = (0, $dvPqk.useMemo)(()=>({
            open: u.listboxState === 0,
            disabled: u.disabled
        }), [
        u
    ]);
    return (0, $b3KIl.render)({
        ourProps: {
            ref: n,
            id: r,
            onClick: f
        },
        theirProps: l,
        slot: m,
        defaultTag: $b0822beb482f3a52$var$qe,
        name: "Listbox.Label"
    });
}
let $b0822beb482f3a52$var$Xe = "ul", $b0822beb482f3a52$var$Ye = (0, $b3KIl.Features).RenderStrategy | (0, $b3KIl.Features).Static;
function $b0822beb482f3a52$var$_e(e, i) {
    var a;
    let r = (0, $9O4MK.useId)(), { id: l = `headlessui-listbox-options-${r}`, ...u } = e, t = $b0822beb482f3a52$var$A("Listbox.Options"), n = $b0822beb482f3a52$var$F("Listbox.Options"), f = (0, $hvflL.useSyncRefs)(t.optionsRef, i), m = (0, $gps2w.useDisposables)(), g = (0, $gps2w.useDisposables)(), y = (0, $gKPjJ.useOpenClosed)(), $ = y !== null ? (y & (0, $gKPjJ.State).Open) === (0, $gKPjJ.State).Open : t.listboxState === 0;
    (0, $dvPqk.useEffect)(()=>{
        var o;
        let v = t.optionsRef.current;
        v && t.listboxState === 0 && v !== ((o = (0, $kotPE.getOwnerDocument)(v)) == null ? void 0 : o.activeElement) && v.focus({
            preventScroll: !0
        });
    }, [
        t.listboxState,
        t.optionsRef
    ]);
    let I = (0, $eqquT.useEvent)((o)=>{
        switch(g.dispose(), o.key){
            case (0, $iJZQ7.Keys).Space:
                if (t.searchQuery !== "") return o.preventDefault(), o.stopPropagation(), n.search(o.key);
            case (0, $iJZQ7.Keys).Enter:
                if (o.preventDefault(), o.stopPropagation(), t.activeOptionIndex !== null) {
                    let { dataRef: v } = t.options[t.activeOptionIndex];
                    n.onChange(v.current.value);
                }
                t.mode === 0 && (n.closeListbox(), (0, $bVyso.disposables)().nextFrame(()=>{
                    var v;
                    return (v = t.buttonRef.current) == null ? void 0 : v.focus({
                        preventScroll: !0
                    });
                }));
                break;
            case (0, $1w8VW.match)(t.orientation, {
                vertical: (0, $iJZQ7.Keys).ArrowDown,
                horizontal: (0, $iJZQ7.Keys).ArrowRight
            }):
                return o.preventDefault(), o.stopPropagation(), n.goToOption((0, $3iXMk.Focus).Next);
            case (0, $1w8VW.match)(t.orientation, {
                vertical: (0, $iJZQ7.Keys).ArrowUp,
                horizontal: (0, $iJZQ7.Keys).ArrowLeft
            }):
                return o.preventDefault(), o.stopPropagation(), n.goToOption((0, $3iXMk.Focus).Previous);
            case (0, $iJZQ7.Keys).Home:
            case (0, $iJZQ7.Keys).PageUp:
                return o.preventDefault(), o.stopPropagation(), n.goToOption((0, $3iXMk.Focus).First);
            case (0, $iJZQ7.Keys).End:
            case (0, $iJZQ7.Keys).PageDown:
                return o.preventDefault(), o.stopPropagation(), n.goToOption((0, $3iXMk.Focus).Last);
            case (0, $iJZQ7.Keys).Escape:
                return o.preventDefault(), o.stopPropagation(), n.closeListbox(), m.nextFrame(()=>{
                    var v;
                    return (v = t.buttonRef.current) == null ? void 0 : v.focus({
                        preventScroll: !0
                    });
                });
            case (0, $iJZQ7.Keys).Tab:
                o.preventDefault(), o.stopPropagation();
                break;
            default:
                o.key.length === 1 && (n.search(o.key), g.setTimeout(()=>n.clearSearch(), 350));
                break;
        }
    }), O = (0, $cJ1XS.useComputed)(()=>{
        var o;
        return (o = t.buttonRef.current) == null ? void 0 : o.id;
    }, [
        t.buttonRef.current
    ]), h = (0, $dvPqk.useMemo)(()=>({
            open: t.listboxState === 0
        }), [
        t
    ]), b = {
        "aria-activedescendant": t.activeOptionIndex === null || (a = t.options[t.activeOptionIndex]) == null ? void 0 : a.id,
        "aria-multiselectable": t.mode === 1 ? !0 : void 0,
        "aria-labelledby": O,
        "aria-orientation": t.orientation,
        id: l,
        onKeyDown: I,
        role: "listbox",
        tabIndex: 0,
        ref: f
    };
    return (0, $b3KIl.render)({
        ourProps: b,
        theirProps: u,
        slot: h,
        defaultTag: $b0822beb482f3a52$var$Xe,
        features: $b0822beb482f3a52$var$Ye,
        visible: $,
        name: "Listbox.Options"
    });
}
let $b0822beb482f3a52$var$Ze = "li";
function $b0822beb482f3a52$var$et(e, i) {
    let a = (0, $9O4MK.useId)(), { id: r = `headlessui-listbox-option-${a}`, disabled: l = !1, value: u, ...t } = e, n = $b0822beb482f3a52$var$A("Listbox.Option"), f = $b0822beb482f3a52$var$F("Listbox.Option"), m = n.activeOptionIndex !== null ? n.options[n.activeOptionIndex].id === r : !1, g = n.isSelected(u), y = (0, $dvPqk.useRef)(null), $ = (0, $1QVGU.useTextValue)(y), I = (0, $8CvXL.useLatestValue)({
        disabled: l,
        value: u,
        domRef: y,
        get textValue () {
            return $();
        }
    }), O = (0, $hvflL.useSyncRefs)(i, y);
    (0, $ld2X6.useIsoMorphicEffect)(()=>{
        if (n.listboxState !== 0 || !m || n.activationTrigger === 0) return;
        let R = (0, $bVyso.disposables)();
        return R.requestAnimationFrame(()=>{
            var T, c;
            (c = (T = y.current) == null ? void 0 : T.scrollIntoView) == null || c.call(T, {
                block: "nearest"
            });
        }), R.dispose;
    }, [
        y,
        m,
        n.listboxState,
        n.activationTrigger,
        n.activeOptionIndex
    ]), (0, $ld2X6.useIsoMorphicEffect)(()=>f.registerOption(r, I), [
        I,
        r
    ]);
    let h = (0, $eqquT.useEvent)((R)=>{
        if (l) return R.preventDefault();
        f.onChange(u), n.mode === 0 && (f.closeListbox(), (0, $bVyso.disposables)().nextFrame(()=>{
            var T;
            return (T = n.buttonRef.current) == null ? void 0 : T.focus({
                preventScroll: !0
            });
        }));
    }), b = (0, $eqquT.useEvent)(()=>{
        if (l) return f.goToOption((0, $3iXMk.Focus).Nothing);
        f.goToOption((0, $3iXMk.Focus).Specific, r);
    }), o = (0, $j8bzA.useTrackedPointer)(), v = (0, $eqquT.useEvent)((R)=>o.update(R)), M = (0, $eqquT.useEvent)((R)=>{
        o.wasMoved(R) && (l || m || f.goToOption((0, $3iXMk.Focus).Specific, r, 0));
    }), Q = (0, $eqquT.useEvent)((R)=>{
        o.wasMoved(R) && (l || m && f.goToOption((0, $3iXMk.Focus).Nothing));
    }), W = (0, $dvPqk.useMemo)(()=>({
            active: m,
            selected: g,
            disabled: l
        }), [
        m,
        g,
        l
    ]);
    return (0, $b3KIl.render)({
        ourProps: {
            id: r,
            ref: O,
            role: "option",
            tabIndex: l === !0 ? void 0 : -1,
            "aria-disabled": l === !0 ? !0 : void 0,
            "aria-selected": g,
            disabled: void 0,
            onClick: h,
            onFocus: b,
            onPointerEnter: v,
            onMouseEnter: v,
            onPointerMove: M,
            onMouseMove: M,
            onPointerLeave: Q,
            onMouseLeave: Q
        },
        theirProps: t,
        slot: W,
        defaultTag: $b0822beb482f3a52$var$Ze,
        name: "Listbox.Option"
    });
}
let $b0822beb482f3a52$var$tt = (0, $b3KIl.forwardRefWithAs)($b0822beb482f3a52$var$We), $b0822beb482f3a52$var$ot = (0, $b3KIl.forwardRefWithAs)($b0822beb482f3a52$var$Ge), $b0822beb482f3a52$var$rt = (0, $b3KIl.forwardRefWithAs)($b0822beb482f3a52$var$Je), $b0822beb482f3a52$var$nt = (0, $b3KIl.forwardRefWithAs)($b0822beb482f3a52$var$_e), $b0822beb482f3a52$var$it = (0, $b3KIl.forwardRefWithAs)($b0822beb482f3a52$var$et), $b0822beb482f3a52$export$8bad31ff872c7659 = Object.assign($b0822beb482f3a52$var$tt, {
    Button: $b0822beb482f3a52$var$ot,
    Label: $b0822beb482f3a52$var$rt,
    Options: $b0822beb482f3a52$var$nt,
    Option: $b0822beb482f3a52$var$it
});

});
parcelRegister("cJ1XS", function(module, exports) {

$parcel$export(module.exports, "useComputed", function () { return $943b362bd73f2721$export$e3d20747ab930783; });

var $dvPqk = parcelRequire("dvPqk");

var $ld2X6 = parcelRequire("ld2X6");

var $8CvXL = parcelRequire("8CvXL");
function $943b362bd73f2721$export$e3d20747ab930783(t, o) {
    let [s, r] = (0, $dvPqk.useState)(t), e = (0, $8CvXL.useLatestValue)(t);
    return (0, $ld2X6.useIsoMorphicEffect)(()=>r(e.current), [
        e,
        r,
        ...o
    ]), s;
}

});

parcelRegister("j8VJ1", function(module, exports) {

$parcel$export(module.exports, "useResolveButtonType", function () { return $defb8aaf2b20a4b4$export$53652b2b272efe9c; });

var $dvPqk = parcelRequire("dvPqk");

var $ld2X6 = parcelRequire("ld2X6");
function $defb8aaf2b20a4b4$var$u(t) {
    var e;
    if (t.type) return t.type;
    let n = (e = t.as) != null ? e : "button";
    if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function $defb8aaf2b20a4b4$export$53652b2b272efe9c(t, e) {
    let [n, r] = (0, $dvPqk.useState)(()=>$defb8aaf2b20a4b4$var$u(t));
    return (0, $ld2X6.useIsoMorphicEffect)(()=>{
        r($defb8aaf2b20a4b4$var$u(t));
    }, [
        t.type,
        t.as
    ]), (0, $ld2X6.useIsoMorphicEffect)(()=>{
        n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && r("button");
    }, [
        n,
        e
    ]), n;
}

});

parcelRegister("1QVGU", function(module, exports) {

$parcel$export(module.exports, "useTextValue", function () { return $159766078f1a1299$export$f6862afd851a1cf4; });

var $dvPqk = parcelRequire("dvPqk");

var $jT9Yo = parcelRequire("jT9Yo");

var $eqquT = parcelRequire("eqquT");
function $159766078f1a1299$export$f6862afd851a1cf4(i) {
    let r = (0, $dvPqk.useRef)(""), t = (0, $dvPqk.useRef)("");
    return (0, $eqquT.useEvent)(()=>{
        let e = i.current;
        if (!e) return "";
        let u = e.innerText;
        if (r.current === u) return t.current;
        let n = (0, $jT9Yo.getTextValue)(e).trim().toLowerCase();
        return r.current = u, t.current = n, n;
    });
}

});
parcelRegister("jT9Yo", function(module, exports) {

$parcel$export(module.exports, "getTextValue", function () { return $e7aae3d5ae530f97$export$6ca03cb7b75bfa13; });
let $e7aae3d5ae530f97$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $e7aae3d5ae530f97$var$o(t) {
    var l, u;
    let n = (l = t.innerText) != null ? l : "", i = t.cloneNode(!0);
    if (!(i instanceof HTMLElement)) return n;
    let r = !1;
    for (let f of i.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), r = !0;
    let e = r ? (u = i.innerText) != null ? u : "" : n;
    return $e7aae3d5ae530f97$var$a.test(e) && (e = e.replace($e7aae3d5ae530f97$var$a, "")), e;
}
function $e7aae3d5ae530f97$export$6ca03cb7b75bfa13(t) {
    let l = t.getAttribute("aria-label");
    if (typeof l == "string") return l.trim();
    let u = t.getAttribute("aria-labelledby");
    if (u) {
        let n = u.split(" ").map((i)=>{
            let r = document.getElementById(i);
            if (r) {
                let e = r.getAttribute("aria-label");
                return typeof e == "string" ? e.trim() : $e7aae3d5ae530f97$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (n.length > 0) return n.join(", ");
    }
    return $e7aae3d5ae530f97$var$o(t).trim();
}

});


parcelRegister("j8bzA", function(module, exports) {

$parcel$export(module.exports, "useTrackedPointer", function () { return $ded7bdcf13d80628$export$24ebee078bde85c3; });

var $dvPqk = parcelRequire("dvPqk");
function $ded7bdcf13d80628$var$n(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $ded7bdcf13d80628$export$24ebee078bde85c3() {
    let e = (0, $dvPqk.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let t = $ded7bdcf13d80628$var$n(r);
            return e.current[0] === t[0] && e.current[1] === t[1] ? !1 : (e.current = t, !0);
        },
        update (r) {
            e.current = $ded7bdcf13d80628$var$n(r);
        }
    };
}

});

parcelRegister("3iXMk", function(module, exports) {

$parcel$export(module.exports, "Focus", function () { return $26816c490d65caa9$export$807a7eae502106e7; });
$parcel$export(module.exports, "calculateActiveIndex", function () { return $26816c490d65caa9$export$c6b4626b54936d5e; });
function $26816c490d65caa9$var$o(r) {
    throw new Error("Unexpected object: " + r);
}
var $26816c490d65caa9$export$807a7eae502106e7 = ((r)=>(r[r.First = 0] = "First", r[r.Previous = 1] = "Previous", r[r.Next = 2] = "Next", r[r.Last = 3] = "Last", r[r.Specific = 4] = "Specific", r[r.Nothing = 5] = "Nothing", r))($26816c490d65caa9$export$807a7eae502106e7 || {});
function $26816c490d65caa9$export$c6b4626b54936d5e(r, l) {
    let t = l.resolveItems();
    if (t.length <= 0) return null;
    let s = l.resolveActiveIndex(), n = s ?? -1;
    switch(r.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!l.resolveDisabled(t[e], e, t)) return e;
            return s;
        case 1:
            for(let e = n - 1; e >= 0; --e)if (!l.resolveDisabled(t[e], e, t)) return e;
            return s;
        case 2:
            for(let e = n + 1; e < t.length; ++e)if (!l.resolveDisabled(t[e], e, t)) return e;
            return s;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!l.resolveDisabled(t[e], e, t)) return e;
            return s;
        case 4:
            for(let e = 0; e < t.length; ++e)if (l.resolveId(t[e], e, t) === r.id) return e;
            return s;
        case 5:
            return null;
        default:
            $26816c490d65caa9$var$o(r);
    }
}

});


parcelRegister("gOPk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3e9203ec97c5ffd$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $c3e9203ec97c5ffd$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m12 15.031-5-5L8.063 8.97 12 12.906l3.938-3.937L17 10.03z"
        })
    }));

});



parcelRegister("6erqj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbb31d0d9353b51b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $bbb31d0d9353b51b$var$ShortcutBox = ({ className: className = "", children: children })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: `m-1 shrink bg-surface-default p-3 ${className}`,
        children: children
    });
};
var $bbb31d0d9353b51b$export$2e2bcd8739ae039 = (0, $gBcml.observer)($bbb31d0d9353b51b$var$ShortcutBox);

});


parcelRegister("jSWI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b9c948b278778d0$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $bEEBX = parcelRequire("bEEBX");

var $jQCqo = parcelRequire("jQCqo");

var $gIlix = parcelRequire("gIlix");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $gtsdT = parcelRequire("gtsdT");

var $hOaHV = parcelRequire("hOaHV");

var $bZiDo = parcelRequire("bZiDo");

var $gvoND = parcelRequire("gvoND");

var $aBy60 = parcelRequire("aBy60");

var $6erqj = parcelRequire("6erqj");
const $9b9c948b278778d0$var$ShortcutFavoritesToCart = ()=>{
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    const addListToCart = (listId)=>{
        if ((0, $bEEBX.default)(listId)) {
            (0, $gtsdT.logger).warn("favorites", "Missing listId for change event");
            return;
        }
        const list = (0, $hOaHV.default).getFavoriteListById(listId);
        if (!list) {
            (0, $gtsdT.logger).warn("favorites", "Unable to find favorite list when adding to cart", {
                list: list,
                listId: listId,
                favorites: (0, $hOaHV.default).allFavoriteLists
            });
            (0, $gvoND.default).addError("En feil oppsto", "Finner ikke favorittlisten", {
                context: "favorite_list",
                text: "list_not_found_error"
            });
            return;
        }
        (0, $gtsdT.logger).log("favorites", "Adding favorite list to cart: ", list);
        const products = (0, $bZiDo.default).resolveSkus(list.sequence);
        if (products.length !== list.sequence.length) {
            (0, $gvoND.default).addError("Sjekk listen for utilgjengelig produkter", "Favorittlisten inneholder produkter som ikke lenger er tilgjengelig. Fjern disse for \xe5 bruke funksjonen p\xe5 forsiden.", {
                context: "favorite_list",
                text: "unavailable_items_error"
            });
            redirectTo(`/customer/favorites/${listId}`);
            return;
        }
        const itemsNotAddedToCart = list.sequence.filter((sku)=>!products.some((product)=>sku === product.sku));
        if (products.length === 0) (0, $gvoND.default).addError("Ingen varer lagt i handlekurven", `Ingen varer fra favorittlisten '${list.listName}' kunne legges i handlekurven.`, {
            context: "favorite_list",
            text: "no_items_added_to_cart_error"
        });
        else if (products.length !== list.sequence.length) {
            (0, $gvoND.default).addError("Noen varer kunne ikke legges i handlekurven", `Varen${itemsNotAddedToCart.length > 1 ? "e" : ""} ${itemsNotAddedToCart.join(", ")} fra favorittlisten '${list.listName}' kunne ikke legges i handlekurven. Resten har blitt lagt til.`, {
                context: "favorite_list",
                text: "some_items_not_added_to_cart_error"
            });
            redirectTo("/checkout/cart");
        } else {
            (0, $gvoND.default).addSuccess("Varer lagt i handlekurven", `Varene fra favorittlisten '${list.listName}' er lagt i handlekurven.`);
            redirectTo("/checkout/cart");
        }
    };
    const sortedFavoriteLists = (0, $jQCqo.default)((0, $gIlix.default)((0, $hOaHV.default).allFavoriteLists), "listName");
    const options = sortedFavoriteLists.map((list)=>({
            label: list.listName,
            value: list.id
        }));
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6erqj.default), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                children: "Legg favorittliste i handlekurven"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Velg en favorittliste og den vil bli lagt direkte i handlekurven."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aBy60.default), {
                label: "",
                options: options,
                value: {
                    value: "",
                    label: "Velg favorittliste"
                },
                onChange: (option)=>option.value && addListToCart(option.value),
                zOnOpen: 30
            })
        ]
    });
};
var $9b9c948b278778d0$export$2e2bcd8739ae039 = (0, $gBcml.observer)($9b9c948b278778d0$var$ShortcutFavoritesToCart);

});

parcelRegister("aPlU5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69f6120d0398ce7f$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8aSS4 = parcelRequire("8aSS4");

var $76PCP = parcelRequire("76PCP");

var $isIf6 = parcelRequire("isIf6");

var $cLLe3 = parcelRequire("cLLe3");

var $6erqj = parcelRequire("6erqj");
const $69f6120d0398ce7f$var$ShortcutNewSubscription = ()=>{
    const handleStart = ()=>{
        (0, $76PCP.default).changeOrderType((0, $8aSS4.ORDERTYPE).WAS);
    };
    const handleAbort = ()=>{
        (0, $76PCP.default).changeOrderType((0, $isIf6.default).defaultOrderType);
    };
    if ((0, $76PCP.default).orderType === (0, $8aSS4.ORDERTYPE).WAS) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6erqj.default), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                children: "Velg abonnementets startdato i kassen"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Legg varer i handlekurven, g\xe5 til kassen og velg ukedag abonnementet skal leveres. Send inn ordren for \xe5 starte abonnementet."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                variant: "secondary",
                onClick: handleAbort,
                children: "Tilbake til engangsordre"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6erqj.default), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
                children: "Start nytt abonnement"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "\xd8nsker du \xe5 sette opp en levering som gjentas automatisk?"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                onClick: handleStart,
                children: "Start abonnement"
            })
        ]
    });
};
var $69f6120d0398ce7f$export$2e2bcd8739ae039 = (0, $gBcml.observer)($69f6120d0398ce7f$var$ShortcutNewSubscription);

});



parcelRegister("lrKDY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7ca04f38acffb3c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $jOOuf = parcelRequire("jOOuf");

var $agWqs = parcelRequire("agWqs");

var $bVGbk = parcelRequire("bVGbk");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $gtsdT = parcelRequire("gtsdT");

var $aRSTV = parcelRequire("aRSTV");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $44W8i = parcelRequire("44W8i");

var $3kQAm = parcelRequire("3kQAm");
const $e7ca04f38acffb3c$var$Recommendations = ({ heading: heading = null, count: count = 6, className: className = "" })=>{
    const isLoggedIn = (0, $bcbvQ.default).isLoggedIn();
    (0, $dvPqk.useEffect)(()=>{
        if (isLoggedIn) {
            if ((0, $duLFK.isDefaultData)((0, $44W8i.default).recommendations)) (0, $44W8i.default).getRecommendations();
        }
    }, [
        isLoggedIn
    ]);
    if (!(0, $bcbvQ.default).isLoggedIn() || (0, $44W8i.default).recommendations.data === null) // This components should only be displayed when customer is logged in
    return null;
    const recommendationToUse = (0, $biFcX.default).recommendationType;
    if (recommendationToUse === "OFF") return null;
    const recommended = (0, $44W8i.default).recommendations.data[recommendationToUse];
    if ((0, $bEEBX.default)(recommended)) // If we don't have any recommendations available, we can just hide the component
    return null;
    const skusInRecommendation = recommended.skus.map((suggestion)=>suggestion.sku);
    const inAssortment = (0, $bVGbk.default)(skusInRecommendation, (0, $bZiDo.default).assortment);
    if (inAssortment.length === 0) {
        (0, $gtsdT.logger).log("products", "None of the recommendation are in the assortment. Hiding module...");
        return null;
    }
    const callbacks = {
        addToCart: (product)=>{
            (0, $44W8i.default).sendRecommendationFeedback(recommended.producedBy, product.sku, "ADD_TO_CART");
        },
        click: (product)=>{
            (0, $44W8i.default).sendRecommendationFeedback(recommended.producedBy, product.sku, "VIEW_DETAILS");
        },
        impression: (product)=>{
            (0, $44W8i.default).sendRecommendationFeedback(recommended.producedBy, product.sku, "IMPRESSION");
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: className,
        id: `recommendation_${recommended.producedBy}`.toLowerCase(),
        children: [
            heading !== null && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                justify: "start",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                    className: "pb-2",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                justify: "start",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $agWqs.Interweave), {
                        content: recommended.reason
                    })
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
                justify: "start",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                    skus: inAssortment,
                    count: count,
                    callbacks: callbacks,
                    listName: `Produktanbefalinger (${recommendationToUse})`,
                    listType: (0, $aRSTV.LIST_TYPE).RECOMMENDATIONS,
                    context: "recommendations"
                })
            })
        ]
    });
};
var $e7ca04f38acffb3c$export$2e2bcd8739ae039 = (0, $gBcml.observer)($e7ca04f38acffb3c$var$Recommendations);

});
parcelRegister("agWqs", function(module, exports) {

$parcel$export(module.exports, "Interweave", function () { return $77a8b823e7e4586c$export$61a91e0722c8b868; });

var $ezUrO = parcelRequire("ezUrO");

var $dvPqk = parcelRequire("dvPqk");

var $hmsmH = parcelRequire("hmsmH");
function $77a8b823e7e4586c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $77a8b823e7e4586c$var$INVALID_STYLES = /(url|image|image-set)\(/i;
class $77a8b823e7e4586c$var$StyleFilter extends (0, $ezUrO.F) {
    attribute(name, value) {
        if (name === 'style') Object.keys(value).forEach((key)=>{
            if (String(value[key]).match($77a8b823e7e4586c$var$INVALID_STYLES)) // eslint-disable-next-line no-param-reassign
            delete value[key];
        });
         // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return value;
    }
}
/* eslint-disable no-bitwise, no-cond-assign, complexity, @typescript-eslint/no-unsafe-return */ const $77a8b823e7e4586c$var$ELEMENT_NODE = 1;
const $77a8b823e7e4586c$var$TEXT_NODE = 3;
const $77a8b823e7e4586c$var$INVALID_ROOTS = /^<(!doctype|(html|head|body)(\s|>))/i;
const $77a8b823e7e4586c$var$ALLOWED_ATTRS = /^(aria-|data-|\w+:)/iu;
const $77a8b823e7e4586c$var$OPEN_TOKEN = /{{{(\w+)\/?}}}/;
function $77a8b823e7e4586c$var$createDocument() {
    // Maybe SSR? Just do nothing instead of crashing!
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;
    return document.implementation.createHTMLDocument('Interweave');
}
class $77a8b823e7e4586c$export$7acfa6ed01010e37 {
    constructor(markup, props = {}, matchers = [], filters = []){
        var _props$allowList;
        $77a8b823e7e4586c$var$_defineProperty(this, "allowed", void 0);
        $77a8b823e7e4586c$var$_defineProperty(this, "banned", void 0);
        $77a8b823e7e4586c$var$_defineProperty(this, "blocked", void 0);
        $77a8b823e7e4586c$var$_defineProperty(this, "container", void 0);
        $77a8b823e7e4586c$var$_defineProperty(this, "content", []);
        $77a8b823e7e4586c$var$_defineProperty(this, "props", void 0);
        $77a8b823e7e4586c$var$_defineProperty(this, "matchers", void 0);
        $77a8b823e7e4586c$var$_defineProperty(this, "filters", void 0);
        $77a8b823e7e4586c$var$_defineProperty(this, "keyIndex", void 0);
        this.props = props;
        this.matchers = matchers;
        this.filters = [
            ...filters,
            new $77a8b823e7e4586c$var$StyleFilter()
        ];
        this.keyIndex = -1;
        this.container = this.createContainer(markup || '');
        this.allowed = new Set((_props$allowList = props.allowList) !== null && _props$allowList !== void 0 ? _props$allowList : (0, $ezUrO.A));
        this.banned = new Set((0, $ezUrO.B));
        this.blocked = new Set(props.blockList);
    }
    /**
   * Loop through and apply all registered attribute filters.
   */ applyAttributeFilters(name, value) {
        return this.filters.reduce((nextValue, filter)=>nextValue !== null && typeof filter.attribute === 'function' ? filter.attribute(name, nextValue) : nextValue, value);
    }
    /**
   * Loop through and apply all registered node filters.
   */ applyNodeFilters(name, node) {
        // Allow null to be returned
        return this.filters.reduce((nextNode, filter)=>nextNode !== null && typeof filter.node === 'function' ? filter.node(name, nextNode) : nextNode, node);
    }
    /**
   * Loop through and apply all registered matchers to the string.
   * If a match is found, create a React element, and build a new array.
   * This array allows React to interpolate and render accordingly.
   */ applyMatchers(string, parentConfig) {
        const elements = {};
        const { props: props } = this;
        let matchedString = string;
        let elementIndex = 0;
        let parts = null;
        this.matchers.forEach((matcher)=>{
            const tagName = matcher.asTag().toLowerCase();
            const config = this.getTagConfig(tagName); // Skip matchers that have been disabled from props or are not supported
            if (props[matcher.inverseName] || !this.isTagAllowed(tagName)) return;
             // Skip matchers in which the child cannot be rendered
            if (!this.canRenderChild(parentConfig, config)) return;
             // Continuously trigger the matcher until no matches are found
            let tokenizedString = '';
            while(matchedString && (parts = matcher.match(matchedString))){
                const { index: index, length: length, match: match, valid: valid, void: isVoid, ...partProps } = parts;
                const tokenName = matcher.propName + String(elementIndex); // Piece together a new string with interpolated tokens
                if (index > 0) tokenizedString += matchedString.slice(0, index);
                if (valid) {
                    tokenizedString += isVoid ? `{{{${tokenName}/}}}` : `{{{${tokenName}}}}${match}{{{/${tokenName}}}}`;
                    this.keyIndex += 1;
                    elementIndex += 1;
                    elements[tokenName] = {
                        children: match,
                        matcher: matcher,
                        props: {
                            ...props,
                            ...partProps,
                            key: this.keyIndex
                        }
                    };
                } else tokenizedString += match;
                 // Reduce the string being matched against,
                // otherwise we end up in an infinite loop!
                if (matcher.greedy) {
                    matchedString = tokenizedString + matchedString.slice(index + length);
                    tokenizedString = '';
                } else // eslint-disable-next-line unicorn/explicit-length-check
                matchedString = matchedString.slice(index + (length || match.length));
            } // Update the matched string with the tokenized string,
            // so that the next matcher can apply to it.
            if (!matcher.greedy) matchedString = tokenizedString + matchedString;
        });
        if (elementIndex === 0) return string;
        return this.replaceTokens(matchedString, elements);
    }
    /**
   * Determine whether the child can be rendered within the parent.
   */ canRenderChild(parentConfig, childConfig) {
        if (!parentConfig.tagName || !childConfig.tagName) return false;
         // No children
        if (parentConfig.void) return false;
         // Valid children
        if (parentConfig.children.length > 0) return parentConfig.children.includes(childConfig.tagName);
        if (parentConfig.invalid.length > 0 && parentConfig.invalid.includes(childConfig.tagName)) return false;
         // Valid parent
        if (childConfig.parent.length > 0) return childConfig.parent.includes(parentConfig.tagName);
         // Self nesting
        if (!parentConfig.self && parentConfig.tagName === childConfig.tagName) return false;
         // Content category type
        return Boolean(parentConfig && parentConfig.content & childConfig.type);
    }
    /**
   * Convert line breaks in a string to HTML `<br/>` tags.
   * If the string contains HTML, we should not convert anything,
   * as line breaks should be handled by `<br/>`s in the markup itself.
   */ convertLineBreaks(markup) {
        const { noHtml: noHtml, disableLineBreaks: disableLineBreaks } = this.props;
        if (noHtml || disableLineBreaks || markup.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi)) return markup;
         // Replace carriage returns
        let nextMarkup = markup.replace(/\r\n/g, '\n'); // Replace long line feeds
        nextMarkup = nextMarkup.replace(/\n{3,}/g, '\n\n\n'); // Replace line feeds with `<br/>`s
        nextMarkup = nextMarkup.replace(/\n/g, '<br/>');
        return nextMarkup;
    }
    /**
   * Create a detached HTML document that allows for easy HTML
   * parsing while not triggering scripts or loading external
   * resources.
   */ createContainer(markup) {
        var _this$props$container;
        const factory = typeof $parcel$global !== 'undefined' && $parcel$global.INTERWEAVE_SSR_POLYFILL || $77a8b823e7e4586c$var$createDocument;
        const doc = factory();
        if (!doc) return undefined;
        const tag = (_this$props$container = this.props.containerTagName) !== null && _this$props$container !== void 0 ? _this$props$container : 'body';
        const el = tag === 'body' || tag === 'fragment' ? doc.body : doc.createElement(tag);
        if (markup.match($77a8b823e7e4586c$var$INVALID_ROOTS)) ;
        else el.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? (0, (/*@__PURE__*/$parcel$interopDefault($hmsmH)))(markup) : markup);
        return el;
    }
    /**
   * Convert an elements attribute map to an object map.
   * Returns null if no attributes are defined.
   */ extractAttributes(node) {
        const { allowAttributes: allowAttributes } = this.props;
        const attributes = {};
        let count = 0;
        if (node.nodeType !== $77a8b823e7e4586c$var$ELEMENT_NODE || !node.attributes) return null;
         // @ts-expect-error Cant type iterator
        [
            ...node.attributes
        ].forEach((attr)=>{
            const { name: name, value: value } = attr;
            const newName = name.toLowerCase();
            const filter = (0, $ezUrO.a)[newName] || (0, $ezUrO.a)[name]; // Verify the node is safe from attacks
            if (!this.isSafe(node)) return;
             // Do not allow denied attributes, excluding ARIA attributes
            // Do not allow events or XSS injections
            if (!newName.match($77a8b823e7e4586c$var$ALLOWED_ATTRS) && (!allowAttributes && (!filter || filter === (0, $ezUrO.b)) || newName.startsWith('on') || value.replace(/(\s|\0|&#x0([9AD]);)/, '').match(/(javascript|vbscript|livescript|xss):/i))) return;
             // Apply attribute filters
            let newValue = newName === 'style' ? this.extractStyleAttribute(node) : value; // Cast to boolean
            if (filter === (0, $ezUrO.d)) newValue = true; // Cast to number
            else if (filter === (0, $ezUrO.e)) newValue = Number.parseFloat(String(newValue)); // Cast to string
            else if (filter !== (0, $ezUrO.f)) newValue = String(newValue);
            attributes[(0, $ezUrO.c)[newName] || newName] = this.applyAttributeFilters(newName, newValue);
            count += 1;
        });
        if (count === 0) return null;
        return attributes;
    }
    /**
   * Extract the style attribute as an object and remove values that allow for attack vectors.
   */ extractStyleAttribute(node) {
        const styles = {}; // eslint-disable-next-line unicorn/prefer-spread
        Array.from(node.style).forEach((key)=>{
            const value = node.style[key];
            if (typeof value === 'string' || typeof value === 'number') styles[key.replace(/-([a-z])/g, (match, letter)=>String(letter).toUpperCase())] = value;
        });
        return styles;
    }
    /**
   * Return configuration for a specific tag.
   */ getTagConfig(tagName) {
        const common = {
            children: [],
            content: 0,
            invalid: [],
            parent: [],
            self: true,
            tagName: '',
            type: 0,
            void: false
        }; // Only spread when a tag config exists,
        // otherwise we use the empty `tagName`
        // for parent config inheritance.
        if ((0, $ezUrO.T)[tagName]) return {
            ...common,
            ...(0, $ezUrO.T)[tagName],
            tagName: tagName
        };
        return common;
    }
    /**
   * Verify that a node is safe from XSS and injection attacks.
   */ isSafe(node) {
        // URLs should only support HTTP, email and phone numbers
        if (typeof HTMLAnchorElement !== 'undefined' && node instanceof HTMLAnchorElement) {
            const href = node.getAttribute('href'); // Fragment protocols start with about:
            // So let's just allow them
            if (href !== null && href !== void 0 && href.startsWith('#')) return true;
            const protocol = node.protocol.toLowerCase();
            return protocol === ':' || protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:' || protocol === 'tel:';
        }
        return true;
    }
    /**
   * Verify that an HTML tag is allowed to render.
   */ isTagAllowed(tagName) {
        if (this.banned.has(tagName) || this.blocked.has(tagName)) return false;
         // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return this.props.allowElements || this.allowed.has(tagName);
    }
    /**
   * Parse the markup by injecting it into a detached document,
   * while looping over all child nodes and generating an
   * array to interpolate into JSX.
   */ parse() {
        if (!this.container) return [];
        return this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase()));
    }
    /**
   * Loop over the nodes children and generate a
   * list of text nodes and React elements.
   */ parseNode(parentNode, parentConfig) {
        const { noHtml: noHtml, noHtmlExceptMatchers: noHtmlExceptMatchers, allowElements: allowElements, transform: transform, transformOnlyAllowList: transformOnlyAllowList } = this.props;
        let content = [];
        let mergedText = ''; // @ts-expect-error Cant type iterator
        [
            ...parentNode.childNodes
        ].forEach((node)=>{
            // Create React elements from HTML elements
            if (node.nodeType === $77a8b823e7e4586c$var$ELEMENT_NODE) {
                const tagName = node.nodeName.toLowerCase();
                const config = this.getTagConfig(tagName); // Persist any previous text
                if (mergedText) {
                    content.push(mergedText);
                    mergedText = '';
                } // Apply node filters first
                const nextNode = this.applyNodeFilters(tagName, node);
                if (!nextNode) return;
                 // Apply transformation second
                let children;
                if (transform && !(transformOnlyAllowList && !this.isTagAllowed(tagName))) {
                    this.keyIndex += 1;
                    const key = this.keyIndex; // Must occur after key is set
                    children = this.parseNode(nextNode, config);
                    const transformed = transform(nextNode, children, config);
                    if (transformed === null) return;
                    if (typeof transformed !== 'undefined') {
                        content.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).cloneElement(transformed, {
                            key: key
                        }));
                        return;
                    } // Reset as we're not using the transformation
                    this.keyIndex = key - 1;
                } // Never allow these tags (except via a transformer)
                if (this.banned.has(tagName)) return;
                 // Only render when the following criteria is met:
                //  - HTML has not been disabled
                //  - Tag is allowed
                //  - Child is valid within the parent
                if (!(noHtml || noHtmlExceptMatchers && tagName !== 'br') && this.isTagAllowed(tagName) && (allowElements || this.canRenderChild(parentConfig, config))) {
                    var _children;
                    this.keyIndex += 1; // Build the props as it makes it easier to test
                    const attributes = this.extractAttributes(nextNode);
                    const elementProps = {
                        tagName: tagName
                    };
                    if (attributes) elementProps.attributes = attributes;
                    if (config.void) elementProps.selfClose = config.void;
                    content.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $ezUrO.E), {
                        ...elementProps,
                        key: this.keyIndex
                    }, (_children = children) !== null && _children !== void 0 ? _children : this.parseNode(nextNode, config))); // Render the children of the current element only.
                // Important: If the current element is not allowed,
                // use the parent element for the next scope.
                } else content = [
                    ...content,
                    ...this.parseNode(nextNode, config.tagName ? config : parentConfig)
                ];
                 // Apply matchers if a text node
            } else if (node.nodeType === $77a8b823e7e4586c$var$TEXT_NODE) {
                const text = noHtml && !noHtmlExceptMatchers ? node.textContent : this.applyMatchers(node.textContent || '', parentConfig);
                if (Array.isArray(text)) content = [
                    ...content,
                    ...text
                ];
                else mergedText += text;
            }
        });
        if (mergedText) content.push(mergedText);
        return content;
    }
    /**
   * Deconstruct the string into an array, by replacing custom tokens with React elements,
   * so that React can render it correctly.
   */ replaceTokens(tokenizedString, elements) {
        if (!tokenizedString.includes('{{{')) return tokenizedString;
        const nodes = [];
        let text = tokenizedString;
        let open = null; // Find an open token tag
        while(open = text.match($77a8b823e7e4586c$var$OPEN_TOKEN)){
            const [match, tokenName] = open;
            const startIndex = open.index;
            const isVoid = match.includes('/');
            if (startIndex > 0) {
                nodes.push(text.slice(0, startIndex)); // Reduce text so that the closing tag will be found after the opening
                text = text.slice(startIndex);
            }
            const { children: children, matcher: matcher, props: elementProps } = elements[tokenName];
            let endIndex; // Use tag as-is if void
            if (isVoid) {
                endIndex = match.length;
                nodes.push(matcher.createElement(children, elementProps)); // Find the closing tag if not void
            } else {
                const close = text.match(new RegExp(`{{{/${tokenName}}}}`));
                endIndex = close.index + close[0].length;
                nodes.push(matcher.createElement(this.replaceTokens(text.slice(match.length, close.index), elements), elementProps));
            } // Reduce text for the next interation
            text = text.slice(endIndex);
        } // Extra the remaining text
        if (text.length > 0) nodes.push(text);
         // Reduce to a string if possible
        if (nodes.length === 0) return '';
        if (nodes.length === 1 && typeof nodes[0] === 'string') return nodes[0];
        return nodes;
    }
}
/* eslint-disable react/jsx-fragments */ function $77a8b823e7e4586c$export$b925b7ba50a6200f(props) {
    var _ref;
    const { attributes: attributes, className: className, containerTagName: containerTagName, content: content, emptyContent: emptyContent, parsedContent: parsedContent, tagName: tagName, noWrap: baseNoWrap } = props;
    const tag = (_ref = containerTagName !== null && containerTagName !== void 0 ? containerTagName : tagName) !== null && _ref !== void 0 ? _ref : 'span';
    const noWrap = tag === 'fragment' ? true : baseNoWrap;
    let mainContent;
    if (parsedContent) mainContent = parsedContent;
    else {
        const markup = new $77a8b823e7e4586c$export$7acfa6ed01010e37(content !== null && content !== void 0 ? content : '', props).parse();
        if (markup.length > 0) mainContent = markup;
    }
    if (!mainContent) mainContent = emptyContent;
    if (noWrap) // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Fragment, null, mainContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $ezUrO.E), {
        attributes: attributes,
        className: className,
        tagName: tag
    }, mainContent);
}
/* eslint-disable promise/prefer-await-to-callbacks */ function $77a8b823e7e4586c$export$61a91e0722c8b868(props) {
    const { attributes: attributes, className: className, content: content = '', disableFilters: disableFilters = false, disableMatchers: disableMatchers = false, emptyContent: emptyContent = null, filters: filters = [], matchers: matchers = [], onAfterParse: onAfterParse = null, onBeforeParse: onBeforeParse = null, tagName: tagName = 'span', noWrap: noWrap = false, ...parserProps } = props;
    const allMatchers = disableMatchers ? [] : matchers;
    const allFilters = disableFilters ? [] : filters;
    const beforeCallbacks = onBeforeParse ? [
        onBeforeParse
    ] : [];
    const afterCallbacks = onAfterParse ? [
        onAfterParse
    ] : []; // Inherit callbacks from matchers
    allMatchers.forEach((matcher)=>{
        if (matcher.onBeforeParse) beforeCallbacks.push(matcher.onBeforeParse.bind(matcher));
        if (matcher.onAfterParse) afterCallbacks.push(matcher.onAfterParse.bind(matcher));
    }); // Trigger before callbacks
    const markup = beforeCallbacks.reduce((string, callback)=>{
        const nextString = callback(string, props);
        return nextString;
    }, content !== null && content !== void 0 ? content : ''); // Parse the markup
    const parser = new $77a8b823e7e4586c$export$7acfa6ed01010e37(markup, parserProps, allMatchers, allFilters); // Trigger after callbacks
    const nodes = afterCallbacks.reduce((parserNodes, callback)=>{
        const nextNodes = callback(parserNodes, props);
        return nextNodes;
    }, parser.parse());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($77a8b823e7e4586c$export$b925b7ba50a6200f, {
        attributes: attributes,
        className: className // eslint-disable-next-line react/destructuring-assignment
        ,
        containerTagName: props.containerTagName,
        emptyContent: emptyContent,
        noWrap: noWrap,
        parsedContent: nodes.length === 0 ? undefined : nodes,
        tagName: tagName
    });
}

});
parcelRegister("ezUrO", function(module, exports) {

$parcel$export(module.exports, "T", function () { return $a9d01ee0059463f4$export$971d5caa766a69d7; });
$parcel$export(module.exports, "B", function () { return $a9d01ee0059463f4$export$ef35774e6d314e91; });
$parcel$export(module.exports, "A", function () { return $a9d01ee0059463f4$export$ebd11618f299a286; });
$parcel$export(module.exports, "b", function () { return $a9d01ee0059463f4$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "e", function () { return $a9d01ee0059463f4$export$f1e1789686576879; });
$parcel$export(module.exports, "d", function () { return $a9d01ee0059463f4$export$4368d992c4eafac0; });
$parcel$export(module.exports, "f", function () { return $a9d01ee0059463f4$export$2d1720544b23b823; });
$parcel$export(module.exports, "a", function () { return $a9d01ee0059463f4$export$407448d2b89b1813; });
$parcel$export(module.exports, "c", function () { return $a9d01ee0059463f4$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $a9d01ee0059463f4$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "F", function () { return $a9d01ee0059463f4$export$d66501df72047452; });

var $dvPqk = parcelRequire("dvPqk");
function $a9d01ee0059463f4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/* eslint-disable no-bitwise, no-magic-numbers, sort-keys */ // https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories
const $a9d01ee0059463f4$export$39b482c5e57630a8 = 1;
const $a9d01ee0059463f4$export$dda1d9f60106f0e9 = 2;
const $a9d01ee0059463f4$export$23f2a1d2818174ef = 4;
const $a9d01ee0059463f4$export$35e795649ee09318 = 8;
const $a9d01ee0059463f4$export$342063e11d6c3cad = 16;
const $a9d01ee0059463f4$export$882b5998b3b9117c = 32;
const $a9d01ee0059463f4$export$953cecd6e717a553 = 64; // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $a9d01ee0059463f4$var$tagConfigs = {
    a: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318,
        self: false,
        type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318 | $a9d01ee0059463f4$export$882b5998b3b9117c | $a9d01ee0059463f4$export$953cecd6e717a553
    },
    address: {
        invalid: [
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'address',
            'article',
            'aside',
            'section',
            'div',
            'header',
            'footer'
        ],
        self: false
    },
    audio: {
        children: [
            'track',
            'source'
        ]
    },
    br: {
        type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318,
        void: true
    },
    body: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$dda1d9f60106f0e9 | $a9d01ee0059463f4$export$23f2a1d2818174ef | $a9d01ee0059463f4$export$35e795649ee09318 | $a9d01ee0059463f4$export$342063e11d6c3cad | $a9d01ee0059463f4$export$882b5998b3b9117c | $a9d01ee0059463f4$export$953cecd6e717a553
    },
    button: {
        content: $a9d01ee0059463f4$export$35e795649ee09318,
        type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318 | $a9d01ee0059463f4$export$882b5998b3b9117c | $a9d01ee0059463f4$export$953cecd6e717a553
    },
    caption: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8,
        parent: [
            'table'
        ]
    },
    col: {
        parent: [
            'colgroup'
        ],
        void: true
    },
    colgroup: {
        children: [
            'col'
        ],
        parent: [
            'table'
        ]
    },
    details: {
        children: [
            'summary'
        ],
        type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$882b5998b3b9117c | $a9d01ee0059463f4$export$953cecd6e717a553
    },
    dd: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8,
        parent: [
            'dl'
        ]
    },
    dl: {
        children: [
            'dt',
            'dd'
        ],
        type: $a9d01ee0059463f4$export$39b482c5e57630a8
    },
    dt: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8,
        invalid: [
            'footer',
            'header'
        ],
        parent: [
            'dl'
        ]
    },
    figcaption: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8,
        parent: [
            'figure'
        ]
    },
    footer: {
        invalid: [
            'footer',
            'header'
        ]
    },
    header: {
        invalid: [
            'footer',
            'header'
        ]
    },
    hr: {
        type: $a9d01ee0059463f4$export$39b482c5e57630a8,
        void: true
    },
    img: {
        void: true
    },
    li: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8,
        parent: [
            'ul',
            'ol',
            'menu'
        ]
    },
    main: {
        self: false
    },
    ol: {
        children: [
            'li'
        ],
        type: $a9d01ee0059463f4$export$39b482c5e57630a8
    },
    picture: {
        children: [
            'source',
            'img'
        ],
        type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318 | $a9d01ee0059463f4$export$342063e11d6c3cad
    },
    rb: {
        parent: [
            'ruby',
            'rtc'
        ]
    },
    rp: {
        parent: [
            'ruby',
            'rtc'
        ]
    },
    rt: {
        content: $a9d01ee0059463f4$export$35e795649ee09318,
        parent: [
            'ruby',
            'rtc'
        ]
    },
    rtc: {
        content: $a9d01ee0059463f4$export$35e795649ee09318,
        parent: [
            'ruby'
        ]
    },
    ruby: {
        children: [
            'rb',
            'rp',
            'rt',
            'rtc'
        ]
    },
    source: {
        parent: [
            'audio',
            'video',
            'picture'
        ],
        void: true
    },
    summary: {
        content: $a9d01ee0059463f4$export$35e795649ee09318,
        parent: [
            'details'
        ]
    },
    table: {
        children: [
            'caption',
            'colgroup',
            'thead',
            'tbody',
            'tfoot',
            'tr'
        ],
        type: $a9d01ee0059463f4$export$39b482c5e57630a8
    },
    tbody: {
        parent: [
            'table'
        ],
        children: [
            'tr'
        ]
    },
    td: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8,
        parent: [
            'tr'
        ]
    },
    tfoot: {
        parent: [
            'table'
        ],
        children: [
            'tr'
        ]
    },
    th: {
        content: $a9d01ee0059463f4$export$39b482c5e57630a8,
        parent: [
            'tr'
        ]
    },
    thead: {
        parent: [
            'table'
        ],
        children: [
            'tr'
        ]
    },
    tr: {
        parent: [
            'table',
            'tbody',
            'thead',
            'tfoot'
        ],
        children: [
            'th',
            'td'
        ]
    },
    track: {
        parent: [
            'audio',
            'video'
        ],
        void: true
    },
    ul: {
        children: [
            'li'
        ],
        type: $a9d01ee0059463f4$export$39b482c5e57630a8
    },
    video: {
        children: [
            'track',
            'source'
        ]
    },
    wbr: {
        type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318,
        void: true
    }
};
function $a9d01ee0059463f4$var$createConfigBuilder(config) {
    return (tagName)=>{
        $a9d01ee0059463f4$var$tagConfigs[tagName] = {
            ...config,
            ...$a9d01ee0059463f4$var$tagConfigs[tagName]
        };
    };
}
[
    'address',
    'main',
    'div',
    'figure',
    'p',
    'pre'
].forEach($a9d01ee0059463f4$var$createConfigBuilder({
    content: $a9d01ee0059463f4$export$39b482c5e57630a8,
    type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$953cecd6e717a553
}));
[
    'abbr',
    'b',
    'bdi',
    'bdo',
    'cite',
    'code',
    'data',
    'dfn',
    'em',
    'i',
    'kbd',
    'mark',
    'q',
    'ruby',
    'samp',
    'strong',
    'sub',
    'sup',
    'time',
    'u',
    'var'
].forEach($a9d01ee0059463f4$var$createConfigBuilder({
    content: $a9d01ee0059463f4$export$35e795649ee09318,
    type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318 | $a9d01ee0059463f4$export$953cecd6e717a553
}));
[
    'p',
    'pre'
].forEach($a9d01ee0059463f4$var$createConfigBuilder({
    content: $a9d01ee0059463f4$export$35e795649ee09318,
    type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$953cecd6e717a553
}));
[
    's',
    'small',
    'span',
    'del',
    'ins'
].forEach($a9d01ee0059463f4$var$createConfigBuilder({
    content: $a9d01ee0059463f4$export$35e795649ee09318,
    type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318
}));
[
    'article',
    'aside',
    'footer',
    'header',
    'nav',
    'section',
    'blockquote'
].forEach($a9d01ee0059463f4$var$createConfigBuilder({
    content: $a9d01ee0059463f4$export$39b482c5e57630a8,
    type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$dda1d9f60106f0e9 | $a9d01ee0059463f4$export$953cecd6e717a553
}));
[
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
].forEach($a9d01ee0059463f4$var$createConfigBuilder({
    content: $a9d01ee0059463f4$export$35e795649ee09318,
    type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$23f2a1d2818174ef | $a9d01ee0059463f4$export$953cecd6e717a553
}));
[
    'audio',
    'canvas',
    'iframe',
    'img',
    'video'
].forEach($a9d01ee0059463f4$var$createConfigBuilder({
    type: $a9d01ee0059463f4$export$39b482c5e57630a8 | $a9d01ee0059463f4$export$35e795649ee09318 | $a9d01ee0059463f4$export$342063e11d6c3cad | $a9d01ee0059463f4$export$953cecd6e717a553
})); // Disable this map from being modified
const $a9d01ee0059463f4$export$971d5caa766a69d7 = Object.freeze($a9d01ee0059463f4$var$tagConfigs); // Tags that should never be allowed, even if the allow list is disabled
const $a9d01ee0059463f4$export$ef35774e6d314e91 = [
    'applet',
    'base',
    'body',
    'command',
    'embed',
    'frame',
    'frameset',
    'head',
    'html',
    'link',
    'meta',
    'noscript',
    'object',
    'script',
    'style',
    'title'
];
const $a9d01ee0059463f4$export$ebd11618f299a286 = Object.keys($a9d01ee0059463f4$export$971d5caa766a69d7).filter((tag)=>tag !== 'canvas' && tag !== 'iframe'); // Filters apply to HTML attributes
const $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5 = 1;
const $a9d01ee0059463f4$export$8b22cf2602fb60ce = 2;
const $a9d01ee0059463f4$export$f1e1789686576879 = 3;
const $a9d01ee0059463f4$export$4368d992c4eafac0 = 4;
const $a9d01ee0059463f4$export$2d1720544b23b823 = 5; // Attributes not listed here will be denied
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
const $a9d01ee0059463f4$export$407448d2b89b1813 = Object.freeze({
    alt: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    cite: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    class: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    colspan: $a9d01ee0059463f4$export$f1e1789686576879,
    controls: $a9d01ee0059463f4$export$4368d992c4eafac0,
    datetime: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    default: $a9d01ee0059463f4$export$4368d992c4eafac0,
    disabled: $a9d01ee0059463f4$export$4368d992c4eafac0,
    dir: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    height: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    href: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    id: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    kind: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    label: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    lang: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    loading: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    loop: $a9d01ee0059463f4$export$4368d992c4eafac0,
    media: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    muted: $a9d01ee0059463f4$export$4368d992c4eafac0,
    poster: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    rel: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    role: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    rowspan: $a9d01ee0059463f4$export$f1e1789686576879,
    scope: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    sizes: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    span: $a9d01ee0059463f4$export$f1e1789686576879,
    start: $a9d01ee0059463f4$export$f1e1789686576879,
    style: $a9d01ee0059463f4$export$2d1720544b23b823,
    src: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    srclang: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    srcset: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    tabindex: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    target: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    title: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    type: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5,
    width: $a9d01ee0059463f4$export$7ccc53e8f1e7dfc5
}); // Attributes to camel case for React props
const $a9d01ee0059463f4$export$db3b6bfb95261072 = Object.freeze({
    class: 'className',
    colspan: 'colSpan',
    datetime: 'dateTime',
    rowspan: 'rowSpan',
    srclang: 'srcLang',
    srcset: 'srcSet',
    tabindex: 'tabIndex'
});
function $a9d01ee0059463f4$export$71511d61b312f219() {
    $a9d01ee0059463f4$export$71511d61b312f219 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9d01ee0059463f4$export$71511d61b312f219.apply(this, arguments);
}
function $a9d01ee0059463f4$export$a9c23c6ac3fc3eca({ attributes: attributes = {}, className: className, children: children = null, selfClose: selfClose = false, tagName: tagName }) {
    const Tag = tagName;
    return selfClose ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(Tag, $a9d01ee0059463f4$export$71511d61b312f219({
        className: className
    }, attributes)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(Tag, $a9d01ee0059463f4$export$71511d61b312f219({
        className: className
    }, attributes), children);
}
class $a9d01ee0059463f4$export$d66501df72047452 {
    /**
   * Filter and clean an HTML attribute value.
   */ attribute(name, value) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return value;
    }
    /**
   * Filter and clean an HTML node.
   */ node(name, node) {
        return node;
    }
}
/**
 * Trigger the actual pattern match and package the matched
 * response through a callback.
 */ function $a9d01ee0059463f4$export$ae1af26003f05816(string, pattern, process, isVoid = false) {
    const matches = string.match(pattern instanceof RegExp ? pattern : new RegExp(pattern, 'i'));
    if (!matches) return null;
    return {
        match: matches[0],
        void: isVoid,
        ...process(matches),
        index: matches.index,
        length: matches[0].length,
        valid: true
    };
}
class $a9d01ee0059463f4$export$3a1a48c8f6ef640e {
    constructor(name, options, factory){
        $a9d01ee0059463f4$var$_defineProperty(this, "greedy", false);
        $a9d01ee0059463f4$var$_defineProperty(this, "options", void 0);
        $a9d01ee0059463f4$var$_defineProperty(this, "propName", void 0);
        $a9d01ee0059463f4$var$_defineProperty(this, "inverseName", void 0);
        $a9d01ee0059463f4$var$_defineProperty(this, "factory", void 0);
        this.options = {
            ...options
        };
        this.propName = name;
        this.inverseName = `no${name.charAt(0).toUpperCase() + name.slice(1)}`;
        this.factory = factory !== null && factory !== void 0 ? factory : null;
    }
    /**
   * Attempts to create a React element using a custom user provided factory,
   * or the default matcher factory.
   */ createElement(children, props) {
        const element = this.factory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(this.factory, props, children) : this.replaceWith(children, props);
        return element;
    }
    /**
   * Trigger the actual pattern match and package the matched
   * response through a callback.
   */ doMatch(string, pattern, callback, isVoid = false) {
        return $a9d01ee0059463f4$export$ae1af26003f05816(string, pattern, callback, isVoid);
    }
    /**
   * Callback triggered before parsing.
   */ onBeforeParse(content, props) {
        return content;
    }
    /**
   * Callback triggered after parsing.
   */ onAfterParse(content, props) {
        return content;
    }
}

});

parcelRegister("hmsmH", function(module, exports) {
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */ 'use strict';
/**
 * Module variables.
 * @private
 */ var $ca3a7e77f19c7f51$var$matchHtmlRegExp = /["'&<>]/;
/**
 * Module exports.
 * @public
 */ module.exports = $ca3a7e77f19c7f51$var$escapeHtml;
/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */ function $ca3a7e77f19c7f51$var$escapeHtml(string) {
    var str = '' + string;
    var match = $ca3a7e77f19c7f51$var$matchHtmlRegExp.exec(str);
    if (!match) return str;
    var escape;
    var html = '';
    var index = 0;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escape = '&quot;';
                break;
            case 38:
                escape = '&amp;';
                break;
            case 39:
                escape = '&#39;';
                break;
            case 60:
                escape = '&lt;';
                break;
            case 62:
                escape = '&gt;';
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.substring(lastIndex, index);
        lastIndex = index + 1;
        html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

});




parcelRegister("bATQI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c212e5e27d00fd9$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $dwVdc = parcelRequire("dwVdc");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $9ekB6 = parcelRequire("9ekB6");

var $fj1oy = parcelRequire("fj1oy");

var $9yKIH = parcelRequire("9yKIH");

var $be63f = parcelRequire("be63f");

var $7zL3a = parcelRequire("7zL3a");

var $8hcvy = parcelRequire("8hcvy");

var $5dMkK = parcelRequire("5dMkK");

var $9EGa7 = parcelRequire("9EGa7");
const $0c212e5e27d00fd9$var$CmsList = ({ content: content })=>{
    const isVisible = (0, $fj1oy.getModuleVisibility)(content, (0, $9yKIH.default).currentCustomerProperties);
    const contentList = content.fields.contentList?.filter((content)=>content?.sys?.contentType?.sys?.id !== undefined);
    const uniqueContentList = (0, $dwVdc.default)(contentList, (entry)=>entry?.sys.id);
    if (!isVisible || !contentList || uniqueContentList.length === 0) return null;
    const contentType = content.sys.contentType.sys.id;
    const title = content.fields.title;
    const trackingListName = content.fields.internalName;
    const id = content.sys.id;
    if (uniqueContentList.length === 0) return null;
    if (uniqueContentList?.every((0, $9ekB6.isTeaser))) {
        const maxVisible = content.fields.maxVisible;
        const articleTeaserView = content.fields.articleTeaserView;
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5dMkK.default), {
            teaserList: uniqueContentList,
            id: id,
            title: title,
            maxVisible: maxVisible,
            trackingListName: trackingListName,
            articleTeaserView: articleTeaserView
        });
    }
    if (uniqueContentList?.every((0, $9ekB6.isRecipe))) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8hcvy.default), {
        recipeList: uniqueContentList,
        id: id,
        title: title,
        trackingListName: trackingListName
    });
    if (uniqueContentList?.every((0, $9ekB6.isAccordion))) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $be63f.default), {
        accordionList: uniqueContentList,
        title: title
    });
    if (uniqueContentList?.every((0, $9ekB6.isUsp))) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9EGa7.default), {
        uspList: uniqueContentList,
        trackingListName: trackingListName,
        contentType: contentType
    });
    if (uniqueContentList?.every((0, $9ekB6.isAdventCalendarSlot))) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7zL3a.default), {
        adventCalendar: uniqueContentList,
        trackingListName: title
    });
    return null;
};
var $0c212e5e27d00fd9$export$2e2bcd8739ae039 = (0, $gBcml.observer)($0c212e5e27d00fd9$var$CmsList);

});
parcelRegister("dwVdc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d9aa49e404c02a6$export$2e2bcd8739ae039; });

var $aIIzU = parcelRequire("aIIzU");

var $ftwd4 = parcelRequire("ftwd4");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $9d9aa49e404c02a6$var$uniqBy(array, iteratee) {
    return array && array.length ? (0, $ftwd4.default)(array, (0, $aIIzU.default)(iteratee, 2)) : [];
}
var $9d9aa49e404c02a6$export$2e2bcd8739ae039 = $9d9aa49e404c02a6$var$uniqBy;

});

parcelRegister("9ekB6", function(module, exports) {

$parcel$export(module.exports, "isTeaser", function () { return $2a5ebd2f3a9ec536$export$46e512ecfa181352; });
$parcel$export(module.exports, "isArticle", function () { return $2a5ebd2f3a9ec536$export$2e0c96db5eac891d; });
$parcel$export(module.exports, "isImageLink", function () { return $2a5ebd2f3a9ec536$export$d1b86f6d3ed73ad4; });
$parcel$export(module.exports, "isImageLinkToUrl", function () { return $2a5ebd2f3a9ec536$export$34d8d98ff0b8c06e; });
$parcel$export(module.exports, "isRecipe", function () { return $2a5ebd2f3a9ec536$export$299d75f2b0c76b3a; });
$parcel$export(module.exports, "isAdventCalendarSlot", function () { return $2a5ebd2f3a9ec536$export$810a2ff7fb3a5f74; });
$parcel$export(module.exports, "isAccordion", function () { return $2a5ebd2f3a9ec536$export$1c0d983369520a98; });
$parcel$export(module.exports, "isUsp", function () { return $2a5ebd2f3a9ec536$export$c1fdb66cdabe866f; });
const $2a5ebd2f3a9ec536$export$46e512ecfa181352 = (entry)=>{
    return $2a5ebd2f3a9ec536$export$2e0c96db5eac891d(entry) || $2a5ebd2f3a9ec536$export$d1b86f6d3ed73ad4(entry) || $2a5ebd2f3a9ec536$export$34d8d98ff0b8c06e(entry);
};
const $2a5ebd2f3a9ec536$export$d1b86f6d3ed73ad4 = (entry)=>{
    return entry?.sys?.contentType?.sys?.id === "imageLink";
};
const $2a5ebd2f3a9ec536$export$34d8d98ff0b8c06e = (entry)=>{
    return entry?.sys?.contentType?.sys?.id === "imageLinkToUrl";
};
const $2a5ebd2f3a9ec536$export$2e0c96db5eac891d = (entry)=>{
    return entry?.sys?.contentType?.sys?.id === "v2_article";
};
const $2a5ebd2f3a9ec536$export$299d75f2b0c76b3a = (entry)=>{
    return entry?.sys?.contentType?.sys?.id === "recipe";
};
const $2a5ebd2f3a9ec536$export$810a2ff7fb3a5f74 = (entry)=>{
    return entry?.sys?.contentType?.sys?.id === "adventCalendarSlot";
};
const $2a5ebd2f3a9ec536$export$1c0d983369520a98 = (entry)=>{
    return entry?.sys?.contentType?.sys?.id === "accordion";
};
const $2a5ebd2f3a9ec536$export$c1fdb66cdabe866f = (entry)=>{
    return entry?.sys?.contentType?.sys?.id === "usp";
};

});

parcelRegister("be63f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffcfb51197a09223$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $fqWHZ = parcelRequire("fqWHZ");

var $dPUHA = parcelRequire("dPUHA");
const $ffcfb51197a09223$var$AccordionList = ({ accordionList: accordionList, title: title })=>{
    const listClassName = "divide-x-0 divide-y divide-ink-border-subtle divide-solid list-none ps-0 w-full";
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                className: "mb-4 h-5 text-start w-full text-lg/7  mx-0 md:w-3/4 md:mx-auto max-w-[848px]",
                children: title
            }),
            accordionList.map((accordionContent)=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: "w-full mx-0 md:w-3/4 md:mx-auto max-w-[848px]",
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fqWHZ.Stack), {
                        gap: 6,
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                            className: listClassName,
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dPUHA.default), {
                                    accordionContent: accordionContent
                                })
                            })
                        })
                    })
                }, `accordion-${accordionContent.sys.id}`))
        ]
    });
};
var $ffcfb51197a09223$export$2e2bcd8739ae039 = $ffcfb51197a09223$var$AccordionList;

});
parcelRegister("dPUHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ad85509135c1f38$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $eYDe5 = parcelRequire("eYDe5");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $6fuyt = parcelRequire("6fuyt");

var $cLfby = parcelRequire("cLfby");
const $8ad85509135c1f38$var$CmsAccordion = ({ accordionContent: accordionContent })=>{
    const title = accordionContent.fields.title;
    const content = accordionContent.fields.content;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eYDe5.Accordion), {
        onOpenChange: (isOpen)=>isOpen && (0, $6fuyt.sendAccordionClick)(title),
        label: title,
        borderVariant: "none",
        className: "mb-2",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLfby.default), {
            document: content,
            context: "simple-article",
            variant: "simple"
        })
    });
};
var $8ad85509135c1f38$export$2e2bcd8739ae039 = (0, $gBcml.observer)($8ad85509135c1f38$var$CmsAccordion);

});
parcelRegister("eYDe5", function(module, exports) {

$parcel$export(module.exports, "Accordion", function () { return $ae7518d110b70501$export$a766cd26d0d69044; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $e8Vqd = parcelRequire("e8Vqd");

var $fTRJ4 = parcelRequire("fTRJ4");

var $gOPk0 = parcelRequire("gOPk0");
const $ae7518d110b70501$var$u = (e, o, i = !1)=>typeof e > "u" ? "" : typeof e == "string" && i ? e : typeof e == "object" ? e[o] ?? "" : "";
function $ae7518d110b70501$export$a766cd26d0d69044({ label: e, children: o, variant: i = "regular", borderVariant: b = "separator", borderColorClass: a = "border-ink-border-subtle", defaultOpen: m, iconPosition: f = "left", isOpen: d, onOpenChange: s, onClick: l, className: c }) {
    const B = {
        regular: "px-8 py-5",
        compact: "p-3"
    }[i], R = {
        regular: "px-8 py-4",
        compact: "p-3"
    }[i], T = {
        none: "",
        separator: (0, $6sMuH.cn)("border-x-0", "odd:border-b-0 even:border-b-0", "last-of-type:border-b last-of-type:border-b-ink-border-subtle", "border-t border-t-ink-border-subtle", a),
        bordered: (0, $6sMuH.cn)("border-2 rounded-lg overflow-hidden", a)
    }[b], S = (0, $6sMuH.cn)("max-w-[800px]", // Border
    T, // Focus
    "[&:has(:focus-visible)]:ring-2 ring-information-600", $ae7518d110b70501$var$u(c, "container", !0)), p = {
        enter: "transition-all duration-200",
        enterFrom: "opacity-0 max-h-0",
        enterTo: "opacity-100 max-h-[1000px]",
        leave: "transition-all duration-200",
        leaveFrom: "opacity-100 max-h-[1000px]",
        leaveTo: "opacity-0 max-h-0"
    }, A = (t)=>(0, $6sMuH.cn)(// Base
        "group flex w-full transition-all justify-between text-left cursor-pointer", B, // Border
        "border-none", // Colors
        "text-base-900 hover:bg-surface-default-hover", t ? "bg-surface-default-hover" : "bg-base-0", // Focus
        "focus:outline-none", $ae7518d110b70501$var$u(c, "button")), j = (0, $6sMuH.cn)("text-base text-ink-default bg-base-0 origin-top transition z-0", R, $ae7518d110b70501$var$u(c, "panel")), h = (0, $dvPqk.useRef)(void 0);
    if (typeof d == "boolean") {
        const t = (x)=>{
            s == null || s(!d), l == null || l(!d, x);
        };
        return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
            className: S,
            children: /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $e8Vqd.Transition), {
                ...p,
                show: !0,
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)($ae7518d110b70501$var$w, {
                        className: A(d),
                        customClassName: c,
                        iconPosition: f,
                        onClick: t,
                        open: d,
                        children: e
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "overflow-hidden",
                        children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $e8Vqd.Transition), {
                            ...p,
                            show: d,
                            children: /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                className: j,
                                children: o
                            })
                        })
                    })
                ]
            })
        });
    }
    return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fTRJ4.Disclosure), {
        defaultOpen: m,
        children: ({ open: t })=>{
            s && h.current !== t && (h.current !== void 0 && s(t), h.current = t);
            const x = (k)=>{
                l == null || l(!t, k);
            };
            return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: S,
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fTRJ4.Disclosure).Button, {
                        as: $ae7518d110b70501$var$w,
                        className: A(t),
                        customClassName: c,
                        iconPosition: f,
                        onClick: x,
                        open: t,
                        children: e
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "overflow-hidden",
                        children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $e8Vqd.Transition), {
                            ...p,
                            children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fTRJ4.Disclosure).Panel, {
                                className: j,
                                children: o
                            })
                        })
                    })
                ]
            });
        }
    });
}
$ae7518d110b70501$export$a766cd26d0d69044.displayName = "Accordion";
function $ae7518d110b70501$var$N({ open: e, customClassName: o }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $gOPk0.default), {
        className: (0, $6sMuH.cn)("fill-ink-brand-default w-6 h-6 transition-transform rounded-button group-hover:bg-button-tertiary-bg-hover flex-shrink-0", e && "rotate-180", $ae7518d110b70501$var$u(o, "icon"))
    });
}
const $ae7518d110b70501$var$w = (0, $dvPqk.forwardRef)(({ iconPosition: e, className: o, open: i, children: b, customClassName: a, ...m }, f)=>/* @__PURE__ */ (0, $7YWoO.jsx)("button", {
        className: o,
        type: "button",
        ...m,
        ref: f,
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
            className: (0, $6sMuH.cn)("flex items-center gap-x-4 w-full", e === "right" && "justify-between"),
            children: [
                e === "left" && /* @__PURE__ */ (0, $7YWoO.jsx)($ae7518d110b70501$var$N, {
                    customClassName: a,
                    open: i
                }),
                /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                    className: (0, $6sMuH.cn)("flex-grow text-base font-semibold text-ink-default", $ae7518d110b70501$var$u(a, "label")),
                    children: b
                }),
                e === "right" && /* @__PURE__ */ (0, $7YWoO.jsx)($ae7518d110b70501$var$N, {
                    customClassName: a,
                    open: i
                })
            ]
        })
    }));
$ae7518d110b70501$var$w.displayName = "AccordionButton";

});
parcelRegister("fTRJ4", function(module, exports) {

$parcel$export(module.exports, "Disclosure", function () { return $b935aaec62dbb03c$export$74a362b31437ec83; });

var $dvPqk = parcelRequire("dvPqk");

var $eqquT = parcelRequire("eqquT");

var $9O4MK = parcelRequire("9O4MK");

var $j8VJ1 = parcelRequire("j8VJ1");

var $hvflL = parcelRequire("hvflL");

var $gKPjJ = parcelRequire("gKPjJ");

var $eRLkK = parcelRequire("eRLkK");

var $1w8VW = parcelRequire("1w8VW");

var $kotPE = parcelRequire("kotPE");

var $b3KIl = parcelRequire("b3KIl");

var $eLiTr = parcelRequire("eLiTr");

var $iJZQ7 = parcelRequire("iJZQ7");
var $b935aaec62dbb03c$var$z = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($b935aaec62dbb03c$var$z || {}), $b935aaec62dbb03c$var$G = ((e)=>(e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.LinkPanel = 4] = "LinkPanel", e[e.UnlinkPanel = 5] = "UnlinkPanel", e))($b935aaec62dbb03c$var$G || {});
let $b935aaec62dbb03c$var$J = {
    0: (e)=>({
            ...e,
            disclosureState: (0, $1w8VW.match)(e.disclosureState, {
                0: 1,
                1: 0
            })
        }),
    1: (e)=>e.disclosureState === 1 ? e : {
            ...e,
            disclosureState: 1
        },
    4 (e) {
        return e.linkedPanel === !0 ? e : {
            ...e,
            linkedPanel: !0
        };
    },
    5 (e) {
        return e.linkedPanel === !1 ? e : {
            ...e,
            linkedPanel: !1
        };
    },
    2 (e, t) {
        return e.buttonId === t.buttonId ? e : {
            ...e,
            buttonId: t.buttonId
        };
    },
    3 (e, t) {
        return e.panelId === t.panelId ? e : {
            ...e,
            panelId: t.panelId
        };
    }
}, $b935aaec62dbb03c$var$B = (0, $dvPqk.createContext)(null);
$b935aaec62dbb03c$var$B.displayName = "DisclosureContext";
function $b935aaec62dbb03c$var$x(e) {
    let t = (0, $dvPqk.useContext)($b935aaec62dbb03c$var$B);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $b935aaec62dbb03c$var$x), o;
    }
    return t;
}
let $b935aaec62dbb03c$var$K = (0, $dvPqk.createContext)(null);
$b935aaec62dbb03c$var$K.displayName = "DisclosureAPIContext";
function $b935aaec62dbb03c$var$_(e) {
    let t = (0, $dvPqk.useContext)($b935aaec62dbb03c$var$K);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $b935aaec62dbb03c$var$_), o;
    }
    return t;
}
let $b935aaec62dbb03c$var$M = (0, $dvPqk.createContext)(null);
$b935aaec62dbb03c$var$M.displayName = "DisclosurePanelContext";
function $b935aaec62dbb03c$var$X() {
    return (0, $dvPqk.useContext)($b935aaec62dbb03c$var$M);
}
function $b935aaec62dbb03c$var$ee(e, t) {
    return (0, $1w8VW.match)(t.type, $b935aaec62dbb03c$var$J, e, t);
}
let $b935aaec62dbb03c$var$te = (0, $dvPqk.Fragment);
function $b935aaec62dbb03c$var$ne(e, t) {
    let { defaultOpen: o = !1, ...u } = e, f = (0, $dvPqk.useRef)(null), n = (0, $hvflL.useSyncRefs)(t, (0, $hvflL.optionalRef)((a)=>{
        f.current = a;
    }, e.as === void 0 || e.as === (0, $dvPqk.Fragment))), r = (0, $dvPqk.useRef)(null), d = (0, $dvPqk.useRef)(null), s = (0, $dvPqk.useReducer)($b935aaec62dbb03c$var$ee, {
        disclosureState: o ? 0 : 1,
        linkedPanel: !1,
        buttonRef: d,
        panelRef: r,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: p, buttonId: i }, P] = s, c = (0, $eqquT.useEvent)((a)=>{
        P({
            type: 1
        });
        let I = (0, $kotPE.getOwnerDocument)(f);
        if (!I || !i) return;
        let l = a ? a instanceof HTMLElement ? a : a.current instanceof HTMLElement ? a.current : I.getElementById(i) : I.getElementById(i);
        l == null || l.focus();
    }), y = (0, $dvPqk.useMemo)(()=>({
            close: c
        }), [
        c
    ]), m = (0, $dvPqk.useMemo)(()=>({
            open: p === 0,
            close: c
        }), [
        p,
        c
    ]), C = {
        ref: n
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($b935aaec62dbb03c$var$B.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($b935aaec62dbb03c$var$K.Provider, {
        value: y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $gKPjJ.OpenClosedProvider), {
        value: (0, $1w8VW.match)(p, {
            0: (0, $gKPjJ.State).Open,
            1: (0, $gKPjJ.State).Closed
        })
    }, (0, $b3KIl.render)({
        ourProps: C,
        theirProps: u,
        slot: m,
        defaultTag: $b935aaec62dbb03c$var$te,
        name: "Disclosure"
    }))));
}
let $b935aaec62dbb03c$var$re = "button";
function $b935aaec62dbb03c$var$le(e, t) {
    let o = (0, $9O4MK.useId)(), { id: u = `headlessui-disclosure-button-${o}`, ...f } = e, [n, r] = $b935aaec62dbb03c$var$x("Disclosure.Button"), d = $b935aaec62dbb03c$var$X(), s = d === null ? !1 : d === n.panelId, p = (0, $dvPqk.useRef)(null), i = (0, $hvflL.useSyncRefs)(p, t, s ? null : n.buttonRef), P = (0, $b3KIl.useMergeRefsFn)();
    (0, $dvPqk.useEffect)(()=>{
        if (!s) return r({
            type: 2,
            buttonId: u
        }), ()=>{
            r({
                type: 2,
                buttonId: null
            });
        };
    }, [
        u,
        r,
        s
    ]);
    let c = (0, $eqquT.useEvent)((l)=>{
        var D;
        if (s) {
            if (n.disclosureState === 1) return;
            switch(l.key){
                case (0, $iJZQ7.Keys).Space:
                case (0, $iJZQ7.Keys).Enter:
                    l.preventDefault(), l.stopPropagation(), r({
                        type: 0
                    }), (D = n.buttonRef.current) == null || D.focus();
                    break;
            }
        } else switch(l.key){
            case (0, $iJZQ7.Keys).Space:
            case (0, $iJZQ7.Keys).Enter:
                l.preventDefault(), l.stopPropagation(), r({
                    type: 0
                });
                break;
        }
    }), y = (0, $eqquT.useEvent)((l)=>{
        switch(l.key){
            case (0, $iJZQ7.Keys).Space:
                l.preventDefault();
                break;
        }
    }), m = (0, $eqquT.useEvent)((l)=>{
        var D;
        (0, $eRLkK.isDisabledReactIssue7711)(l.currentTarget) || e.disabled || (s ? (r({
            type: 0
        }), (D = n.buttonRef.current) == null || D.focus()) : r({
            type: 0
        }));
    }), C = (0, $dvPqk.useMemo)(()=>({
            open: n.disclosureState === 0
        }), [
        n
    ]), a = (0, $j8VJ1.useResolveButtonType)(e, p), I = s ? {
        ref: i,
        type: a,
        onKeyDown: c,
        onClick: m
    } : {
        ref: i,
        id: u,
        type: a,
        "aria-expanded": n.disclosureState === 0,
        "aria-controls": n.linkedPanel ? n.panelId : void 0,
        onKeyDown: c,
        onKeyUp: y,
        onClick: m
    };
    return (0, $b3KIl.render)({
        mergeRefs: P,
        ourProps: I,
        theirProps: f,
        slot: C,
        defaultTag: $b935aaec62dbb03c$var$re,
        name: "Disclosure.Button"
    });
}
let $b935aaec62dbb03c$var$oe = "div", $b935aaec62dbb03c$var$se = (0, $b3KIl.Features).RenderStrategy | (0, $b3KIl.Features).Static;
function $b935aaec62dbb03c$var$ae(e, t) {
    let o = (0, $9O4MK.useId)(), { id: u = `headlessui-disclosure-panel-${o}`, ...f } = e, [n, r] = $b935aaec62dbb03c$var$x("Disclosure.Panel"), { close: d } = $b935aaec62dbb03c$var$_("Disclosure.Panel"), s = (0, $b3KIl.useMergeRefsFn)(), p = (0, $hvflL.useSyncRefs)(t, n.panelRef, (m)=>{
        (0, $eLiTr.startTransition)(()=>r({
                type: m ? 4 : 5
            }));
    });
    (0, $dvPqk.useEffect)(()=>(r({
            type: 3,
            panelId: u
        }), ()=>{
            r({
                type: 3,
                panelId: null
            });
        }), [
        u,
        r
    ]);
    let i = (0, $gKPjJ.useOpenClosed)(), P = i !== null ? (i & (0, $gKPjJ.State).Open) === (0, $gKPjJ.State).Open : n.disclosureState === 0, c = (0, $dvPqk.useMemo)(()=>({
            open: n.disclosureState === 0,
            close: d
        }), [
        n,
        d
    ]), y = {
        ref: p,
        id: u
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($b935aaec62dbb03c$var$M.Provider, {
        value: n.panelId
    }, (0, $b3KIl.render)({
        mergeRefs: s,
        ourProps: y,
        theirProps: f,
        slot: c,
        defaultTag: $b935aaec62dbb03c$var$oe,
        features: $b935aaec62dbb03c$var$se,
        visible: P,
        name: "Disclosure.Panel"
    }));
}
let $b935aaec62dbb03c$var$ue = (0, $b3KIl.forwardRefWithAs)($b935aaec62dbb03c$var$ne), $b935aaec62dbb03c$var$ie = (0, $b3KIl.forwardRefWithAs)($b935aaec62dbb03c$var$le), $b935aaec62dbb03c$var$ce = (0, $b3KIl.forwardRefWithAs)($b935aaec62dbb03c$var$ae), $b935aaec62dbb03c$export$74a362b31437ec83 = Object.assign($b935aaec62dbb03c$var$ue, {
    Button: $b935aaec62dbb03c$var$ie,
    Panel: $b935aaec62dbb03c$var$ce
});

});
parcelRegister("eLiTr", function(module, exports) {

$parcel$export(module.exports, "startTransition", function () { return $abf41c461880605e$export$7568632d0d33d16d; });

var $dvPqk = parcelRequire("dvPqk");
var $abf41c461880605e$var$t;
let $abf41c461880605e$export$7568632d0d33d16d = ($abf41c461880605e$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).startTransition) != null ? $abf41c461880605e$var$t : function(a) {
    a();
};

});





parcelRegister("7zL3a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e3c5a55094f21e3$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $903du = parcelRequire("903du");
const $3e3c5a55094f21e3$var$AdventCalendar = ({ adventCalendar: adventCalendar, trackingListName: trackingListName })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid), {
        cols: {
            base: 2,
            sm: 3,
            md: 4,
            xl: 5
        },
        gap: 4,
        children: adventCalendar.map((adventCalendarSlot)=>{
            if (adventCalendarSlot.fields.slotImage) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $903du.default), {
                content: adventCalendarSlot,
                trackingListName: trackingListName
            }, `advent-calendar-slot-${adventCalendarSlot.sys.id}`);
            return null;
        })
    });
};
var $3e3c5a55094f21e3$export$2e2bcd8739ae039 = (0, $gBcml.observer)($3e3c5a55094f21e3$var$AdventCalendar);

});
parcelRegister("903du", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53936737e8e1d311$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $f3OQA = parcelRequire("f3OQA");
var $5UIm0 = parcelRequire("5UIm0");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $4udGV = parcelRequire("4udGV");

var $jlTfJ = parcelRequire("jlTfJ");

var $i6TQx = parcelRequire("i6TQx");
const $53936737e8e1d311$var$SLOT_COMMON_STYLES = {
    base: "w-full rounded-lg",
    behindSlotImage: "absolute left-0 top-0 -z-10 h-full object-cover visible"
};
const $53936737e8e1d311$var$AdventCalendarSlot = ({ content: content, trackingListName: trackingListName })=>{
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    const [shouldShakeSlot, setShouldShakeSlot] = (0, $dvPqk.useState)(false);
    const [isOpen, setIsOpen] = (0, $dvPqk.useState)(false);
    const date = (0, $5UIm0.default)(content.fields.date || "");
    const slotId = content.sys.id;
    const url = `/${(0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.id === content.sys.id)?.fullUrl}`;
    const slotImage = content.fields.slotImage;
    const behindSlotImage = content.fields.behindSlotImage;
    const contentType = "adventCalendarSlot";
    const signUpCode = `julekalender-2024-${content.fields.slug}`;
    const isSignedUp = (0, $i6TQx.default).isSignedUpTo(signUpCode);
    const isSlotOpenedOrOutdated = isSignedUp || (0, $4udGV.isDateInThePast)(date);
    function goToCalendarSlot() {
        if (isSlotOpenedOrOutdated) redirectTo(url);
        else // Wait for the animation to finish before redirecting
        setTimeout(()=>{
            redirectTo(url);
        }, 700);
    }
    function shakeCalendarSlot() {
        setShouldShakeSlot(true);
        setTimeout(()=>{
            setShouldShakeSlot(false);
        }, 500);
    }
    function handleClickImageLink() {
        if (!(0, $4udGV.isDateInTheFuture)(date)) {
            (0, $jlTfJ.default).fetchContentIfNotAlreadyInStore(slotId, "adventCalendarSlot");
            (0, $6fuyt.sendSelectTeaser)(signUpCode, contentType, trackingListName, url);
            setIsOpen(true);
            goToCalendarSlot();
        } else shakeCalendarSlot();
    }
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(signUpCode, contentType, trackingListName);
    };
    const { ref: viewRef } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: slotImage && // biome-ignore lint/a11y/noStaticElementInteractions: should be a button
        // biome-ignore lint/a11y/useAriaPropsSupportedByRole: should be a button
        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            ref: viewRef,
            onClick: ()=>handleClickImageLink(),
            className: (0, $izjX7.cn)($53936737e8e1d311$var$SLOT_COMMON_STYLES.base, "relative h-auto hover:cursor-pointer", {
                "[&>img:first-child]:hover:hover-calendar-slot": isSlotOpenedOrOutdated
            }),
            "aria-expanded": isOpen,
            "aria-label": `Kalenderluke ${content.fields.date?.slice(-2)} ${isSlotOpenedOrOutdated ? "\xe5pen" : "lukket"} `,
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                    alt: "",
                    className: (0, $izjX7.cn)($53936737e8e1d311$var$SLOT_COMMON_STYLES.base, "z-0 block aspect-square h-auto origin-left overflow-hidden object-cover transition-transform duration-500 ease-[cubic-bezier(0.42,0,0.58,1)]", {
                        "dsp-shake-calendar-slot": shouldShakeSlot,
                        "opened-calendar-slot": isSlotOpenedOrOutdated,
                        "open-calendar-slot": isOpen && (0, $f3OQA.default)(date) && !isSignedUp
                    }),
                    src: slotImage.fields.file?.url
                }),
                behindSlotImage?.fields.file ? /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                    alt: "",
                    className: (0, $izjX7.cn)($53936737e8e1d311$var$SLOT_COMMON_STYLES.base, $53936737e8e1d311$var$SLOT_COMMON_STYLES.behindSlotImage, "brightness-50", {
                        "hidden opacity-0": !isOpen && !isSlotOpenedOrOutdated && !(0, $f3OQA.default)(date)
                    }),
                    src: behindSlotImage.fields.file?.url
                }) : /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: (0, $izjX7.cn)($53936737e8e1d311$var$SLOT_COMMON_STYLES, $53936737e8e1d311$var$SLOT_COMMON_STYLES.behindSlotImage, "bg-ink-brand-subtle", {
                        "hidden opacity-0": !isOpen && !isSlotOpenedOrOutdated && !(0, $f3OQA.default)(date)
                    })
                })
            ]
        })
    });
};
var $53936737e8e1d311$export$2e2bcd8739ae039 = (0, $gBcml.observer)($53936737e8e1d311$var$AdventCalendarSlot);

});


parcelRegister("8hcvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f33dd8a476426dc$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3ofZR = parcelRequire("3ofZR");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $kbPiX = parcelRequire("kbPiX");
const $0f33dd8a476426dc$var$RecipeList = ({ recipeList: recipeList, title: title, trackingListName: trackingListName })=>{
    if (recipeList.length) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            title && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "mb-4",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3ofZR.GridSimple), {
                cols: {
                    base: 2,
                    md: 3,
                    lg: 4
                },
                gap: {
                    base: 4,
                    sm: 6
                },
                children: recipeList.map((recipe)=>{
                    if (recipe.fields?.recipeData) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kbPiX.default), {
                        id: recipe.sys.id,
                        recipe: recipe.fields.recipeData,
                        trackingListName: trackingListName
                    }, `recipe-teaser-${recipe.sys.id}`);
                    return null;
                })
            })
        ]
    });
};
var $0f33dd8a476426dc$export$2e2bcd8739ae039 = (0, $gBcml.observer)($0f33dd8a476426dc$var$RecipeList);

});
parcelRegister("3ofZR", function(module, exports) {

$parcel$export(module.exports, "GridSimple", function () { return $2780059a94843a53$export$1489c20e597967fd; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");
const $2780059a94843a53$var$m = {
    media: "",
    container: "@container"
};
function $2780059a94843a53$export$1489c20e597967fd({ cols: d = 3, gap: S = 4, type: e = "media", className: n, children: s, ...a }) {
    const i = (0, $dvPqk.useMemo)((0, $6sMuH.generateUniqueClassName), []), t = (0, $6sMuH.generateGridColstyles)(d, e), o = (0, $6sMuH.generateGridGapStyles)(S, e);
    return e === "container" ? /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: "@container",
        ...a,
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: (0, $6sMuH.cn)("grid", i, $2780059a94843a53$var$m[e], n),
                children: s
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("style", {
                children: `.${i} { ${t} ${o} }`
            })
        ]
    }) : /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: (0, $6sMuH.cn)("grid", i, $2780059a94843a53$var$m[e], n),
                ...a,
                children: s
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("style", {
                children: `.${i} { ${t} ${o} }`
            })
        ]
    });
}
$2780059a94843a53$export$1489c20e597967fd.displayName = "GridSimple";

});

parcelRegister("kbPiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b3a8d9004f48866$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $hGZvy = parcelRequire("hGZvy");

var $izjX7 = parcelRequire("izjX7");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $hV6j4 = parcelRequire("hV6j4");

var $BjdTh = parcelRequire("BjdTh");

var $jlTfJ = parcelRequire("jlTfJ");
const $8b3a8d9004f48866$var$RecipeTeaser = ({ trackingListName: trackingListName, id: id, recipe: recipe, title: title })=>{
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(titleText, "recipe", trackingListName);
    };
    const { ref: ref } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    const locale = (0, $BjdTh.default)();
    const urlData = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.id === id);
    if (!recipe) return null;
    const titleText = recipe.displayName || title || "Uten tittel";
    const difficultyText = (0, $hV6j4.difficultyTexts)[locale][recipe.difficulty];
    const { image: image, workTime: workTime = 0 } = recipe;
    const formatedWorkTime = (0, $izjX7.formatCookingTime)(workTime || 0);
    const url = image?.url || "";
    function handleClickRecipeTeaser() {
        (0, $6fuyt.sendSelectTeaser)(title, "recipe", trackingListName, url);
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
            to: `/${urlData?.fullUrl}`,
            onClick: handleClickRecipeTeaser,
            asChild: true,
            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                image: `${url.replace("%width%", "600").replace("%height%", `${Math.round(337.5)}`)}`,
                aspectRatio: "16/9",
                title: titleText,
                time: {
                    label: formatedWorkTime ?? ""
                },
                tag: difficultyText
            })
        })
    });
};
var $8b3a8d9004f48866$export$2e2bcd8739ae039 = $8b3a8d9004f48866$var$RecipeTeaser;

});
parcelRegister("hGZvy", function(module, exports) {

$parcel$export(module.exports, "RecipeCard", function () { return $ce16122171219e5f$export$6d5cb399979bb8ba; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $hGi4c = parcelRequire("hGi4c");

var $89i0n = parcelRequire("89i0n");

var $82MrC = parcelRequire("82MrC");
const $ce16122171219e5f$export$6d5cb399979bb8ba = (0, $dvPqk.forwardRef)(({ title: a = "", image: t, tag: l, defaultTagVariant: y = "information", defaultTagProps: g, time: i, rating: v, as: d = "a", compactRating: b = !1, href: c = "", to: o = "", className: k = "", horizontal: f, description: w, amountOfRatings: z, inverted: u, aspectRatio: h, headingLevel: S = "h2", ...j }, E)=>{
    const [R, T] = (0, $dvPqk.useState)((0, $6sMuH.getScreenSize)());
    function m() {
        T((0, $6sMuH.getScreenSize)());
    }
    (0, $dvPqk.useEffect)(()=>{
        if (typeof window < "u") return m(), window.addEventListener("resize", m), ()=>{
            window.removeEventListener("resize", m);
        };
    }, []);
    const s = R.width <= 768;
    let x = {};
    d === "a" && c ? x = {
        href: c
    } : d !== "a" && o && (x = {
        to: o
    });
    const L = !!(c || o), B = ()=>{
        if (!l) return null;
        if ((0, $dvPqk.isValidElement)(l)) return l;
        if (typeof l == "string") return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
            size: s ? "small" : "regular",
            variant: y,
            ...g || {},
            children: l
        });
        const { text: M, ...P } = l;
        return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
            size: s ? "small" : "regular",
            ...g || {},
            ...P,
            children: M
        });
    }, C = ()=>i ? /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $hGi4c.Tag), {
            icon: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $82MrC.default), {}),
            size: s ? "small" : "regular",
            variant: "base",
            children: [
                i.label,
                " ",
                i.suffix ? i.suffix : null
            ]
        }) : null, H = S;
    return /* @__PURE__ */ (0, $7YWoO.jsx)(d, {
        ref: E,
        ...x,
        className: (0, $6sMuH.cn)("shadow-md block relative no-underline @container rounded-card-lg w-full overflow-clip min-h-full max-w-96 bg-base-0 group", k, f ? "max-w-none " : ""),
        ...j,
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
            className: (0, $6sMuH.cn)("flex", f ? "flex-row" : "flex-col"),
            children: [
                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                    className: (0, $6sMuH.cn)("w-full relative bg-base-0 overflow-hidden"),
                    style: {
                        aspectRatio: h || "5/4"
                    },
                    children: typeof t == "string" ? /* @__PURE__ */ (0, $7YWoO.jsx)("img", {
                        alt: a,
                        className: "size-full absolute inset-0 object-cover group-hover:scale-105 transition-all duration-300",
                        src: t
                    }) : /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "w-full h-full",
                        children: t
                    })
                }),
                /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                    className: (0, $6sMuH.cn)("flex flex-col px-2 py-3 @sm:py-5 @xl:p-10", f ? "gap-4" : "gap-2", u ? "bg-surface-default-inverted text-ink-brand-inverted" : "bg-base-0 text-ink-brand-default"),
                    children: [
                        /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                            className: "flex items justify-between gap-2 w-full @md:flex-col-reverse @md:gap-6",
                            children: [
                                /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                                    className: "flex items-center gap-x-2",
                                    children: [
                                        C(),
                                        B()
                                    ]
                                }),
                                v ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $89i0n.Rating), {
                                    amountOfRatings: z,
                                    inverted: u,
                                    isCompact: b || s,
                                    rating: v
                                }) : null
                            ]
                        }),
                        /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                            className: "flex w-full gap-2 justify-between items-start flex-col @lg:gap-6",
                            children: [
                                a ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    className: (0, $6sMuH.cn)("no-underline w-full text-left outline-none focus-visible:ring rounded", u ? "text-ink-brand-inverted" : "text-ink-brand-default", L && "group-hover:underline"),
                                    children: /* @__PURE__ */ (0, $7YWoO.jsx)(H, {
                                        className: "text-pretty m-0 line-clamp-2 font-medium text-base @md:text-lg @lg:text-3xl",
                                        children: a
                                    })
                                }) : null,
                                w ? /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                                    className: "hidden text-ink-brand-default @xl:block",
                                    children: w
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
$ce16122171219e5f$export$6d5cb399979bb8ba.displayName = "RecipeCard";

});
parcelRegister("89i0n", function(module, exports) {

$parcel$export(module.exports, "Rating", function () { return $5eed216ad8ff38dc$export$8ba663d22f9191ae; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $98GGA = parcelRequire("98GGA");

var $6BDa0 = parcelRequire("6BDa0");

var $dgRRs = parcelRequire("dgRRs");
function $5eed216ad8ff38dc$var$A(o) {
    return o >= 5 ? (0, $98GGA.default) : o >= 1.5 ? (0, $dgRRs.default) : (0, $6BDa0.default);
}
function $5eed216ad8ff38dc$export$8ba663d22f9191ae({ rating: o, isCompact: I = !1, maxRating: v = 5, amountOfRatings: p = 0, className: $ = "", inverted: s, interactive: h = !1, onRatingChange: S, oneTimeRating: m = !1, hasRated: b = !1 }) {
    const [k, y] = (0, $dvPqk.useState)(null), [P, w] = (0, $dvPqk.useState)(b);
    (0, $dvPqk.useEffect)(()=>{
        w(b);
    }, [
        b
    ]);
    const x = b || P, l = h && !(m && x), u = k !== null ? k : o, C = s ? "white" : "currentColor";
    if (I) {
        const r = $5eed216ad8ff38dc$var$A(u);
        return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
            className: (0, $6sMuH.cn)("flex items-center", s ? "text-ink-brand-inverted" : "text-ink-brand-default", $),
            children: [
                /* @__PURE__ */ (0, $7YWoO.jsx)(r, {
                    fill: C
                }),
                /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                    className: "ordinal flex items-center gap-x-1",
                    children: [
                        u ? /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                            className: (0, $6sMuH.cn)("inline-block", s ? "text-ink-brand-inverted" : "text-ink-brand-default"),
                            children: u.toFixed(1)
                        }) : null,
                        p ? /* @__PURE__ */ (0, $7YWoO.jsxs)("span", {
                            className: (0, $6sMuH.cn)("inline-block text-xs", s ? "text-ink-brand-inverted" : "text-ink-subtle"),
                            children: [
                                "(",
                                p,
                                ")"
                            ]
                        }) : null
                    ]
                })
            ]
        });
    }
    const g = (r)=>{
        l && y(r + 1);
    }, j = ()=>{
        l && y(null);
    }, M = (r)=>{
        if (l && S) {
            const n = r + 1;
            S(n), m && w(!0);
        }
    }, D = (r)=>{
        const t = {
            ...h ? {
                height: 30,
                width: 30
            } : {},
            fill: C
        };
        if (l && k !== null) return r < k ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $98GGA.default), {
            ...t
        }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $6BDa0.default), {
            ...t
        });
        if (o === 5) return r < 5 ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $98GGA.default), {
            ...t
        }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $6BDa0.default), {
            ...t
        });
        const d = Math.floor(o), N = o - d;
        return N >= 0.1 && N <= 0.5 ? r < d ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $98GGA.default), {
            ...t
        }) : r === d ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $dgRRs.default), {
            ...t
        }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $6BDa0.default), {
            ...t
        }) : N > 0.5 ? r < d + 1 ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $98GGA.default), {
            ...t
        }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $6BDa0.default), {
            ...t
        }) : r < d ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $98GGA.default), {
            ...t
        }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $6BDa0.default), {
            ...t
        });
    };
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: "flex items-center gap-1",
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: (0, $6sMuH.cn)("flex", h ? "cursor-pointer gap-3" : "gap-1", s ? "text-ink-brand-inverted" : "text-ink-brand-default", m && x ? "opacity-90" : ""),
                onMouseLeave: j,
                children: Array.from({
                    length: v
                }, (r, n)=>/* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                        "aria-label": l ? `Rate ${n + 1} out of ${v}` : void 0,
                        className: (0, $6sMuH.cn)("text-yellow-500", m && x ? "cursor-default" : ""),
                        onClick: ()=>{
                            l && M(n);
                        },
                        onKeyDown: (t)=>{
                            l && (t.key === "Enter" || t.key === " ") && (t.preventDefault(), M(n));
                        },
                        onMouseEnter: ()=>{
                            l && g(n);
                        },
                        role: l ? "button" : void 0,
                        tabIndex: l ? 0 : void 0,
                        children: D(n)
                    }, `star-${n}-${v}`))
            }),
            !h && /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: "ordinal flex items-center gap-x-1",
                children: [
                    u ? /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                        className: (0, $6sMuH.cn)("inline-block", s ? "text-ink-brand-inverted" : "text-ink-brand-default"),
                        children: u.toFixed(1)
                    }) : null,
                    p ? /* @__PURE__ */ (0, $7YWoO.jsxs)("span", {
                        className: (0, $6sMuH.cn)("inline-block", s ? "text-ink-brand-inverted" : "text-ink-subtle"),
                        children: [
                            "(",
                            p,
                            ")"
                        ]
                    }) : null
                ]
            })
        ]
    });
}

});
parcelRegister("98GGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a75f8e9da18b943$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $6a75f8e9da18b943$export$2e2bcd8739ae039 = (l)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, l, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m5.675 21 1.575-6.65L2 9.875l6.9-.6L11.6 3l2.7 6.3 6.9.575-5.25 4.475L17.525 21 11.6 17.475z"
        })
    }));

});

parcelRegister("6BDa0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf493323ef97d77$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $4cf493323ef97d77$export$2e2bcd8739ae039 = (e)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, e, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m8.4 17.275 3.2-1.9 3.225 1.9-.85-3.6L16.75 11.3l-3.675-.325L11.6 7.55l-1.475 3.425-3.675.325 2.8 2.375zM5.675 21l1.575-6.65L2 9.875l6.9-.6L11.6 3l2.7 6.3 6.9.575-5.25 4.475L17.525 21 11.6 17.475z"
        })
    }));

});

parcelRegister("dgRRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a968cae2936299f$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $9a968cae2936299f$export$2e2bcd8739ae039 = (e)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, e, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M11.6 7.55v7.825l3.225 1.9-.85-3.6L16.75 11.3l-3.675-.325zM5.675 21l1.575-6.65L2 9.875l6.9-.6L11.6 3l2.7 6.3 6.9.575-5.25 4.475L17.525 21 11.6 17.475z"
        })
    }));

});


parcelRegister("82MrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db416b8424386b3$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $5db416b8424386b3$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m15.14 15.984 1.196-1.195-3.492-3.492V6.375h-1.688V12zM12 21a8.8 8.8 0 0 1-3.497-.703 9.1 9.1 0 0 1-2.866-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 11.99q0-1.864.703-3.505a8.9 8.9 0 0 1 1.934-2.859 9.2 9.2 0 0 1 2.87-1.922A8.8 8.8 0 0 1 12.01 3q1.864 0 3.505.709a9.1 9.1 0 0 1 2.854 1.924 9.1 9.1 0 0 1 1.922 2.857A8.8 8.8 0 0 1 21 12q0 1.86-.703 3.497a9.2 9.2 0 0 1-1.922 2.866 8.9 8.9 0 0 1-2.862 1.934A8.8 8.8 0 0 1 12 21m.011-1.687q3.035 0 5.168-2.145t2.134-5.18q0-3.033-2.134-5.167t-5.168-2.133q-3.035 0-5.179 2.133t-2.144 5.168 2.144 5.179 5.18 2.145"
        })
    }));

});


parcelRegister("hV6j4", function(module, exports) {

$parcel$export(module.exports, "difficultyTexts", function () { return $12b9c295db4dfc5d$export$ae84fd1e1ce50f14; });
const $12b9c295db4dfc5d$export$cc88a037ad030d60 = (entry)=>{
    const jsonRecipe = entry.fields.recipeData;
    if (jsonRecipe && !Array.isArray(jsonRecipe)) {
        if ("name" in jsonRecipe && "description" in jsonRecipe && "displayName" in jsonRecipe && "difficulty" in jsonRecipe) return jsonRecipe;
    }
};
const $12b9c295db4dfc5d$export$ae84fd1e1ce50f14 = {
    "nb-NO": {
        easy: "Enkel",
        medium: "Medium",
        difficult: "Utfordrende"
    },
    "en-US": {
        easy: "Easy",
        medium: "Medium",
        difficult: "Challenging"
    }
};

});

parcelRegister("BjdTh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82da45428003f6d9$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");

var $aRCaF = parcelRequire("aRCaF");
const $82da45428003f6d9$var$useSupportedLocale = ()=>{
    return (0, $dvPqk.useMemo)(()=>(0, $aRCaF.default).language?.startsWith("en") ? "en-US" : "nb-NO", [
        (0, $aRCaF.default).language
    ]);
};
var $82da45428003f6d9$export$2e2bcd8739ae039 = $82da45428003f6d9$var$useSupportedLocale;

});



parcelRegister("5dMkK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfe2af0ba795a2c8$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $1987g = parcelRequire("1987g");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $9ekB6 = parcelRequire("9ekB6");

var $fj1oy = parcelRequire("fj1oy");

var $9yKIH = parcelRequire("9yKIH");

var $4AGFR = parcelRequire("4AGFR");

var $eADXL = parcelRequire("eADXL");

var $cY4OY = parcelRequire("cY4OY");

var $fy1tN = parcelRequire("fy1tN");
const $cfe2af0ba795a2c8$var$TeaserList = ({ teaserList: teaserList, id: id, title: title, maxVisible: maxVisible, trackingListName: trackingListName, articleTeaserView: articleTeaserView = "Teaser" })=>{
    const isLargerThanSm = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).sm);
    const isLargerThanMd = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).md);
    const segmentedTeaserList = teaserList.filter((entry)=>{
        if ((0, $9ekB6.isArticle)(entry)) return (0, $9yKIH.default).isArticleVisible(entry.sys.id);
        if ((0, $9ekB6.isImageLink)(entry)) {
            if (entry.fields.entry) return (0, $9yKIH.default).isArticleVisible(entry.fields.entry.sys.id);
        }
        if ((0, $9ekB6.isImageLinkToUrl)(entry)) return (0, $fj1oy.getModuleVisibility)(entry, (0, $9yKIH.default).currentCustomerProperties);
        return false;
    });
    const visibleTeaserList = (0, $1987g.default)(segmentedTeaserList, maxVisible ?? segmentedTeaserList.length);
    const shouldShowSubtitle = visibleTeaserList.length === 1 || visibleTeaserList.length === 2 && isLargerThanMd || !isLargerThanSm;
    if (visibleTeaserList.length === 0) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "mb-4",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cY4OY.default), {
                id: id,
                children: visibleTeaserList.map((entry)=>{
                    if (articleTeaserView === "Kort med ingress") return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4AGFR.default), {
                        entry: entry,
                        trackingListName: trackingListName
                    }, `content-card-link-${entry.sys.id}`);
                    if ((0, $9ekB6.isArticle)(entry)) {
                        if (entry.fields.headerImage) {
                            const ctaTitle = entry.fields.callToAction ?? entry.fields.title;
                            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eADXL.default), {
                                id: entry.sys.id,
                                type: "article",
                                imageWithFocusId: entry.fields.headerImage.sys.id,
                                title: ctaTitle,
                                subTitle: entry.fields.callToActionSubTitle,
                                trackingListName: trackingListName
                            }, `cta-${entry.sys.id}`);
                        }
                    } else if ((0, $9ekB6.isImageLink)(entry)) {
                        const entryImageLink = entry.fields.entry;
                        const image = entry.fields.image;
                        if (entryImageLink && image) {
                            const subTitle = shouldShowSubtitle ? entry.fields.caption : "";
                            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eADXL.default), {
                                id: entryImageLink.sys.id,
                                type: "article",
                                imageWithFocusId: image.sys.id,
                                title: entry.fields.text,
                                subTitle: subTitle,
                                trackingListName: trackingListName
                            }, `image-link-${entryImageLink.sys.id}`);
                        }
                    } else if ((0, $9ekB6.isImageLinkToUrl)(entry)) {
                        const image = entry.fields.image;
                        const url = entry.fields.url;
                        const linkTitle = entry.fields.text;
                        const subTitle = shouldShowSubtitle ? entry.fields.caption : "";
                        if (image) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fy1tN.default), {
                            imageWithFocusId: image.sys.id,
                            title: linkTitle,
                            subTitle: subTitle,
                            url: url,
                            trackingListName: trackingListName
                        }, `image-link-to-url-${entry.sys.id}`);
                    } else return null;
                })
            })
        ]
    });
};
var $cfe2af0ba795a2c8$export$2e2bcd8739ae039 = (0, $gBcml.observer)($cfe2af0ba795a2c8$var$TeaserList);

});
parcelRegister("gUV6W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7eccc83485cb5cf$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");
function $b7eccc83485cb5cf$var$useMediaQuery(query) {
    const getMatches = (query)=>{
        // Prevents SSR issues
        if (typeof window !== "undefined") return window.matchMedia(query).matches;
        return false;
    };
    const [matches, setMatches] = (0, $dvPqk.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0, $dvPqk.useEffect)(()=>{
        const matchMedia = window.matchMedia(query);
        // Triggered at the first client-side load and if query changes
        handleChange();
        // Listen matchMedia
        if (matchMedia.addEventListener) matchMedia.addEventListener("change", handleChange);
        else if (matchMedia.addListener) matchMedia.addListener(handleChange);
        return ()=>{
            if (matchMedia.removeEventListener) matchMedia.removeEventListener("change", handleChange);
            else if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
var $b7eccc83485cb5cf$export$2e2bcd8739ae039 = $b7eccc83485cb5cf$var$useMediaQuery;

});

parcelRegister("4AGFR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df3d276dbd2278c1$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izAr1 = parcelRequire("izAr1");

var $dvPqk = parcelRequire("dvPqk");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");

var $9ekB6 = parcelRequire("9ekB6");

var $jlTfJ = parcelRequire("jlTfJ");

var $aFpyD = parcelRequire("aFpyD");
const $df3d276dbd2278c1$var$ContentCardLink = ({ entry: entry, trackingListName: trackingListName = "contentCardLink" })=>{
    const [cardWidth, setCardWidth] = (0, $dvPqk.useState)(0);
    const cardRef = (0, $dvPqk.useRef)(null);
    const _id = entry.sys.id;
    const type = (0, $9ekB6.isArticle)(entry) ? "article" : "url";
    const title = (0, $9ekB6.isArticle)(entry) ? entry.fields.callToAction ?? entry.fields.title : entry.fields.text ?? "";
    const description = (0, $9ekB6.isArticle)(entry) ? entry.fields.preface ?? "" : entry.fields.caption ?? "";
    const image = (0, $9ekB6.isArticle)(entry) ? entry.fields.headerImage : entry.fields.image;
    let url = "";
    if ((0, $9ekB6.isImageLinkToUrl)(entry)) url = entry.fields.url;
    else {
        const entryId = (0, $9ekB6.isImageLink)(entry) ? entry.fields.entry?.sys.id : entry.sys.id;
        const urlData = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.id === entryId);
        url = urlData?.fullUrl ? `/${urlData.fullUrl}` : "#";
    }
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(title, type, trackingListName);
    };
    const combinedRef = (el)=>{
        cardRef.current = el;
        viewRef(el);
    };
    (0, $dvPqk.useLayoutEffect)(()=>{
        if (!cardRef.current) return;
        const node = cardRef.current;
        setCardWidth(node.offsetWidth);
        const resizeObserver = new window.ResizeObserver((entries)=>{
            for (const entry of entries)if (entry.target === node && entry.contentRect) setCardWidth(entry.contentRect.width);
        });
        resizeObserver.observe(node);
        return ()=>resizeObserver.disconnect();
    }, [
        cardRef.current
    ]);
    const { ref: viewRef } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    function handleClickImageLink() {
        (0, $6fuyt.sendSelectTeaser)(title, type, trackingListName, url);
    }
    return(// biome-ignore lint/a11y/noStaticElementInteractions: should be a button
    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ref: combinedRef,
        className: "w-full",
        onClick: handleClickImageLink,
        children: cardWidth >= 640 ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $izAr1.Card), {
            to: url,
            href: url,
            as: (0, $5OqMf.isExternalLink)(url) ? "a" : (0, $8kt8E.Link),
            className: "flex flex-col h-full",
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $izAr1.Card).Layout, {
                direction: "horizontal",
                className: "flex-1 [&_img]:rounded-none",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "w-1/2 overflow-hidden",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
                            width: 800,
                            ratio: "16x9",
                            entryId: image?.sys.id || entry.sys.id,
                            imageFromParent: image,
                            placement: "aboveFold",
                            className: "transition-transform duration-300 group-hover:scale-105"
                        })
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $izAr1.Card).Content, {
                        className: "justify-center @sm:p-8",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $izAr1.Card).Title, {
                                className: "line-clamp-none",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $izAr1.Card).Description, {
                                children: description
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $izAr1.Card), {
            to: url,
            href: url,
            as: (0, $5OqMf.isExternalLink)(url) ? "a" : (0, $8kt8E.Link),
            className: "flex flex-col h-full",
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $izAr1.Card).Layout, {
                direction: "vertical",
                className: "flex-1 [&_img]:rounded-none",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "overflow-hidden",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
                            width: 800,
                            ratio: "16x9",
                            entryId: image?.sys.id || entry.sys.id,
                            imageFromParent: image,
                            placement: "aboveFold",
                            className: "transition-transform duration-300 group-hover:scale-105"
                        })
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $izAr1.Card).Content, {
                        className: "@sm:p-8",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $izAr1.Card).Title, {
                                className: "line-clamp-none",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $izAr1.Card).Description, {
                                children: description
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var $df3d276dbd2278c1$export$2e2bcd8739ae039 = $df3d276dbd2278c1$var$ContentCardLink;

});
parcelRegister("izAr1", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $d857c2163c87db04$export$60332b2344f7fe41; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $kqYoE = parcelRequire("kqYoE");

var $gPgVw = parcelRequire("gPgVw");

var $liyCG = parcelRequire("liyCG");

var $0ojYX = parcelRequire("0ojYX");

var $5DqK4 = parcelRequire("5DqK4");

var $hG6Wu = parcelRequire("hG6Wu");
const $d857c2163c87db04$var$c = (0, $dvPqk.forwardRef)(({ variant: i = "default", hasBorder: u = !0, as: C, href: t, to: e, className: b, children: s, ...f }, y)=>{
    const o = !!(t || e), a = C ?? (o ? "a" : "article"), g = t && a === "a" ? {
        href: t
    } : e && a !== "a" ? {
        to: e
    } : {}, x = {
        default: `bg-surface-default text-ink-default ${u ? "border border-ink-border-subtle hover:border-ink-border-default" : ""}`,
        inverted: "bg-button-primary-bg text-button-primary-text",
        transparent: "bg-base-transparent"
    };
    let d = s;
    const r = (0, $dvPqk.Children).toArray(s), k = r.some((m)=>(0, $dvPqk.isValidElement)(m) && m.type.displayName === "CardLayout"), v = r.length === 2 && (0, $dvPqk.isValidElement)(r[0]) && (0, $dvPqk.isValidElement)(r[1]) && r[0].type.displayName === "CardImage" && r[1].type.displayName === "CardContent";
    return !k && v && (d = /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $5DqK4.CardLayout), {
        direction: "responsive",
        children: [
            r[0],
            r[1]
        ]
    })), /* @__PURE__ */ (0, $7YWoO.jsx)((0, $gPgVw.CardContext).Provider, {
        value: {
            variant: i,
            isLink: o
        },
        children: /* @__PURE__ */ (0, $7YWoO.jsx)(a, {
            className: (0, $6sMuH.cn)("@container rounded-card-lg overflow-clip block no-underline", x[i], o && "group", b),
            ref: y,
            ...g,
            ...f,
            children: d
        })
    });
});
$d857c2163c87db04$var$c.displayName = "Card";
const $d857c2163c87db04$var$E = Object.assign($d857c2163c87db04$var$c, {
    Layout: (0, $5DqK4.CardLayout),
    Image: (0, $0ojYX.CardImage),
    Content: (0, $kqYoE.CardContent),
    Title: (0, $hG6Wu.CardTitle),
    Description: (0, $liyCG.CardDescription)
}), $d857c2163c87db04$export$60332b2344f7fe41 = $d857c2163c87db04$var$E;

});
parcelRegister("kqYoE", function(module, exports) {

$parcel$export(module.exports, "CardContent", function () { return $ee0515db90449d02$export$64ef9b8c11710c47; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $gPgVw = parcelRequire("gPgVw");
function $ee0515db90449d02$export$64ef9b8c11710c47({ padding: t = "responsive", className: e, children: s }) {
    const { direction: r } = (0, $dvPqk.useContext)((0, $gPgVw.CardContext)), o = {
        small: "p-3",
        medium: "p-4",
        large: "p-5",
        responsive: "p-4 @sm:p-5"
    }, n = {
        horizontal: "justify-center",
        responsive: "justify-start @md:justify-center",
        vertical: "justify-start"
    }[r];
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)("flex flex-col gap-2 flex-1", o[t], n, e),
        children: s
    });
}
$ee0515db90449d02$export$64ef9b8c11710c47.displayName = "CardContent";

});
parcelRegister("gPgVw", function(module, exports) {

$parcel$export(module.exports, "CardContext", function () { return $c3fe8a0e14fb738a$export$d0b2ee33ebf7d64; });

var $dvPqk = parcelRequire("dvPqk");
const $c3fe8a0e14fb738a$export$d0b2ee33ebf7d64 = (0, $dvPqk.createContext)({});

});


parcelRegister("liyCG", function(module, exports) {

$parcel$export(module.exports, "CardDescription", function () { return $f81622cac7ad2d1d$export$16e0ed4cb97c00d4; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
function $f81622cac7ad2d1d$export$16e0ed4cb97c00d4({ lines: e = 4, hideOnMobile: l = !1, className: m, children: a }) {
    const c = {
        0: "",
        1: "line-clamp-1",
        2: "line-clamp-2",
        3: "line-clamp-3",
        4: "line-clamp-4",
        5: "line-clamp-5",
        6: "line-clamp-6"
    }, n = e >= 0 && e <= 6 ? e : 4;
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)("text-sm @sm:text-base", c[n], l && "hidden @sm:block", m),
        children: a
    });
}

});

parcelRegister("0ojYX", function(module, exports) {

$parcel$export(module.exports, "CardImage", function () { return $0012dde76cb91a5e$export$8a8c015277a3d77a; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $gPgVw = parcelRequire("gPgVw");
function $0012dde76cb91a5e$export$8a8c015277a3d77a({ src: t, alt: o = "", aspectRatio: s = "5/4", className: l, children: n, responsive: m = !0 }) {
    const { isLink: c, direction: a } = (0, $dvPqk.useContext)((0, $gPgVw.CardContext)), f = {
        square: "1/1",
        video: "16/9",
        "1/1": "1/1",
        "5/4": "5/4",
        "4/3": "4/3",
        "3/2": "3/2",
        "16/9": "16/9"
    };
    let e;
    return a === "vertical" ? e = [
        "flex-shrink-0",
        "w-full"
    ] : a === "horizontal" ? e = [
        "flex-shrink-0",
        "w-1/2",
        "aspect-square"
    ] : m && (e = [
        "w-full",
        "aspect-square",
        "@md:w-1/2",
        "@md:aspect-video"
    ]), /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)("relative overflow-hidden", e, l),
        style: {
            aspectRatio: f[s]
        },
        children: t ? /* @__PURE__ */ (0, $7YWoO.jsx)("img", {
            alt: o,
            className: (0, $6sMuH.cn)("size-full absolute inset-0 object-cover", c && "group-hover:scale-105 transition-transform duration-300"),
            src: t
        }) : n
    });
}
$0012dde76cb91a5e$export$8a8c015277a3d77a.displayName = "CardImage";

});

parcelRegister("5DqK4", function(module, exports) {

$parcel$export(module.exports, "CardLayout", function () { return $41a556b302d3078c$export$21e76ed09a093e97; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $gPgVw = parcelRequire("gPgVw");
function $41a556b302d3078c$export$21e76ed09a093e97({ direction: o = "responsive", className: t, children: l }) {
    const s = (0, $dvPqk.useContext)((0, $gPgVw.CardContext)), n = {
        vertical: "flex-col",
        horizontal: "flex-row",
        responsive: "flex-col @md:flex-row"
    };
    return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $gPgVw.CardContext).Provider, {
        value: {
            ...s,
            direction: o
        },
        children: /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
            className: (0, $6sMuH.cn)("flex h-full", n[o], t),
            children: l
        })
    });
}

});

parcelRegister("hG6Wu", function(module, exports) {

$parcel$export(module.exports, "CardTitle", function () { return $cdebbe89de26a1c7$export$474db65c3c394e1c; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $gPgVw = parcelRequire("gPgVw");
function $cdebbe89de26a1c7$export$474db65c3c394e1c({ as: t = "h3", size: n = "responsive", className: l, children: i, lines: e = 2 }) {
    const { isLink: r, variant: a } = (0, $dvPqk.useContext)((0, $gPgVw.CardContext)), m = {
        small: "text-base",
        medium: "text-lg",
        large: "text-xl",
        responsive: "text-lg @sm:text-xl"
    }, s = {
        0: "",
        1: "line-clamp-1",
        2: "line-clamp-2",
        3: "line-clamp-3",
        4: "line-clamp-4",
        5: "line-clamp-5",
        6: "line-clamp-6"
    }, o = e >= 0 && e <= 6 ? e : 2;
    return /* @__PURE__ */ (0, $7YWoO.jsx)(t, {
        className: (0, $6sMuH.cn)("leading-tight m-0 font-medium", m[n], a === "inverted" ? "text-ink-brand-inverted" : "text-ink-brand-default", s[o], r && "group-hover:underline underline-offset-2", l),
        children: i
    });
}

});



parcelRegister("eADXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $799ada598191b9f6$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $fy1tN = parcelRequire("fy1tN");
const $799ada598191b9f6$var$EntryImageLink = ({ id: id, type: type, imageWithFocusId: imageWithFocusId, title: title, subTitle: subTitle, trackingListName: trackingListName })=>{
    if (!(0, $9yKIH.default).isArticleVisible(id)) return null;
    if (!imageWithFocusId) return null;
    const urlData = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.id === id);
    const url = `/${urlData?.fullUrl}`;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fy1tN.default), {
        url: url,
        type: type,
        imageWithFocusId: imageWithFocusId,
        title: title,
        subTitle: subTitle,
        trackingListName: trackingListName
    });
};
var $799ada598191b9f6$export$2e2bcd8739ae039 = (0, $gBcml.observer)($799ada598191b9f6$var$EntryImageLink);

});
parcelRegister("fy1tN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7659a687486e1c22$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $im5sL = parcelRequire("im5sL");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $2vDqE = parcelRequire("2vDqE");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $aFpyD = parcelRequire("aFpyD");
const $7659a687486e1c22$var$ranges = {
    small: [
        0,
        700
    ],
    large: [
        700
    ]
};
const $7659a687486e1c22$var$UrlImageLink = ({ url: url, imageWithFocusId: imageWithFocusId, title: title, subTitle: subTitle, trackingListName: trackingListName, type: type = "url" })=>{
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(title, type, trackingListName);
    };
    const { ref: viewRef } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    const { ref: containerRef, size: currentContainerSize } = (0, $2vDqE.default)($7659a687486e1c22$var$ranges);
    const largeContainer = currentContainerSize === "large";
    const width = largeContainer ? 1200 : 800;
    const ratio = largeContainer ? "32x9" : "16x9";
    const hasSubTitle = !!subTitle;
    const hasTitle = !!title;
    const hasText = hasTitle || hasSubTitle;
    const hasOnlySubTitle = hasSubTitle && !hasTitle;
    const subTitleStyle = "p-0 m-0 text-[0.67em] overflow-hidden text-ellipsis whitespace-nowrap hidden @[500px]:inline rounded";
    const gradientStyle = (0, $izjX7.cn)("bg-gradient-to-b from-[#0000] from-55% to-[#232323ab] to-100% shadow-[#00000080] text-shadow hover:from-[#00000024] hover:to-[#232323ab]", {
        "from-65%": largeContainer
    });
    const titlesTextStyle = "text-base text-balance @[360px]:text-xl @[500px]:text-2xl @[700px]:text-3xl";
    const gradientOverlayStyle = (0, $izjX7.cn)("absolute inset-0 hidden rounded", titlesTextStyle, gradientStyle, {
        block: hasTitle,
        "@[500px]:block": hasOnlySubTitle
    });
    const titlesContainerStyle = "absolute bottom-0 rounded p-4 text-base-0 @[360px]:pb-5 @[500px]:pb-6 @[700px]:w-full @[700px]:px-16 @[700px]:pb-10 @[700px]:text-center";
    const titleStyle = (0, $izjX7.cn)(titlesTextStyle, "m-0 p-0");
    const ariaLabel = `G\xe5 til ${title ?? url}`;
    if (!imageWithFocusId) {
        (0, $gtsdT.logger).warn("contentful", `No image specified for UrlImageLink to ${url}`);
        return null;
    }
    function handleClickImageLink() {
        (0, $6fuyt.sendSelectTeaser)(title, type, trackingListName, url);
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ref: viewRef,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            ref: containerRef,
            className: "relative @container",
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
                "aria-label": ariaLabel,
                to: url,
                onClick: ()=>handleClickImageLink(),
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
                        width: width,
                        entryId: imageWithFocusId,
                        placement: "belowFold",
                        ratio: ratio,
                        className: "rounded-1"
                    }),
                    hasText && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: gradientOverlayStyle,
                        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: titlesContainerStyle,
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                                    className: titleStyle,
                                    children: title
                                }),
                                !!subTitle && /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                                    className: subTitleStyle,
                                    children: [
                                        subTitle,
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $im5sL.default), {
                                            className: "inline"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $7659a687486e1c22$export$2e2bcd8739ae039 = (0, $gBcml.observer)($7659a687486e1c22$var$UrlImageLink);

});


parcelRegister("cY4OY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5129735ca9777fef$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");
const $5129735ca9777fef$var$TeaserListLayoutRow = ({ nodes: nodes })=>{
    const columns = nodes.length ? nodes.length > 4 ? 4 : nodes.length : 1;
    const classNames = (0, $izjX7.cn)("mb-4 last:mb-0", {
        "flex items-stretch flex-row gap-4 [&>*]:sm:w-1/2": columns > 1,
        "[&>*]:md:w-1/2": columns === 2,
        "[&>*]:md:w-1/3": columns === 3,
        "[&>*]:md:w-1/4": columns === 4
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: classNames,
        children: nodes
    });
};
const $5129735ca9777fef$var$rowLength = (count, isSm, isMd, isLg)=>{
    if (!isSm) return 1;
    if (!isMd) return 2;
    if (!isLg) return 3;
    return count % 3 || !(count % 4) ? 4 : 3;
};
const $5129735ca9777fef$var$TeaserListLayout = ({ children: children, id: id })=>{
    const isSm = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).sm);
    const isMd = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).md);
    const isLg = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).lg);
    const nodes = (0, $dvPqk.Children).map(children, (child)=>child);
    const count = nodes?.length || 0;
    const defaultRowLength = $5129735ca9777fef$var$rowLength(count, isSm, isMd, isLg);
    let currentRow = [];
    const nodeRows = [];
    // The following logic is to ensure the lovely pyramid layout where the fewest columns are on top
    if (defaultRowLength >= 2) {
        for (const node of nodes?.reverse() || []){
            if (currentRow.length === defaultRowLength) {
                nodeRows.unshift(currentRow);
                currentRow = [];
            }
            currentRow.unshift(node);
        }
        if (currentRow.length) nodeRows.unshift(currentRow);
    } else {
        for (const node of nodes || []){
            if (currentRow.length === defaultRowLength) {
                nodeRows.push(currentRow);
                currentRow = [];
            }
            currentRow.push(node);
        }
        if (currentRow.length) nodeRows.push(currentRow);
    }
    if (defaultRowLength > 2 && nodeRows.length > 1 && nodeRows[0].length === 1) nodeRows[0].push(nodeRows[1].shift());
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: nodeRows.map((nodeRow, i)=>/*#__PURE__*/ (0, $7YWoO.jsx)($5129735ca9777fef$var$TeaserListLayoutRow, {
                nodes: nodeRow
            }, `teaser-list-layout-row-${id}-${i + 1}`))
    });
};
var $5129735ca9777fef$export$2e2bcd8739ae039 = $5129735ca9777fef$var$TeaserListLayout;

});


parcelRegister("9EGa7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bda46faad8b0681e$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $hCN2j = parcelRequire("hCN2j");
const $bda46faad8b0681e$var$UspList = ({ uspList: uspList, contentType: contentType, trackingListName: trackingListName })=>{
    // A USP list should always have either 3 or 4 USPs
    const threeUsps = uspList.length === 3;
    const fourUsps = uspList.length === 4;
    const uspListClasses = (0, $izjX7.cn)("relative flex flex-col items-center justify-between gap-4 lg:flex-row lg:gap-8 lg:py-8", {
        "xl:px-12": threeUsps,
        "xl:px-10": fourUsps
    });
    if (uspList.length > 4 || uspList.length < 3) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: uspListClasses,
        children: uspList.map((usp)=>{
            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hCN2j.default), {
                usp: usp,
                threeUsps: threeUsps,
                fourUsps: fourUsps,
                trackingListName: trackingListName,
                contentType: contentType
            }, usp.sys.id);
        })
    });
};
var $bda46faad8b0681e$export$2e2bcd8739ae039 = $bda46faad8b0681e$var$UspList;

});
parcelRegister("hCN2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4e2c8c5b8a6a125$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $hA2CZ = parcelRequire("hA2CZ");
var $f8ra1 = parcelRequire("f8ra1");
var $62JH9 = parcelRequire("62JH9");
var $49omM = parcelRequire("49omM");
var $b3yR7 = parcelRequire("b3yR7");
var $kJSNS = parcelRequire("kJSNS");
var $1KGvE = parcelRequire("1KGvE");

var $izjX7 = parcelRequire("izjX7");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");
const $d4e2c8c5b8a6a125$var$Usp = ({ usp: usp, threeUsps: threeUsps, fourUsps: fourUsps, trackingListName: trackingListName, contentType: contentType })=>{
    const uspTitle = usp.fields.title;
    const uspUrl = usp.fields.url;
    const uspIcon = usp.fields.icon;
    const uspDescription = usp.fields.description;
    const uspIconClasses = (0, $izjX7.cn)("flex size-12 items-center justify-center rounded-[50%] bg-infoBoxBackground", {
        "lg:size-16": threeUsps,
        "lg:size-14": fourUsps
    });
    const uspTitleCLasses = (0, $izjX7.cn)("m-0 text-lg font-semibold", {
        "lg:text-xl": threeUsps
    });
    const uspDescriptionCLasses = (0, $izjX7.cn)("text-base", {
        "lg:text-lg": threeUsps
    });
    const iconClass = (0, $izjX7.cn)("size-8", {
        "lg:size-12": threeUsps,
        "lg:size-10": fourUsps
    });
    const uspLinkClasses = "flex w-80 flex-col items-center justify-center gap-2 lg:gap-4 rounded-lg p-2 text-center hover:bg-infoBoxBackground hover:no-underline lg:p-4";
    const icons = {
        IconSupport: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kJSNS.default), {
            className: iconClass
        }),
        IconFood: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $62JH9.default), {
            className: iconClass
        }),
        IconLeaf: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $49omM.default), {
            className: iconClass
        }),
        IconShoppingCart: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3yR7.default), {
            className: iconClass
        }),
        IconTruck: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1KGvE.default), {
            className: iconClass
        }),
        IconChef: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f8ra1.default), {
            className: iconClass
        }),
        IconBoil: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hA2CZ.default), {
            className: iconClass
        })
    };
    const handleClickUsp = ()=>{
        (0, $6fuyt.sendSelectTeaser)(uspTitle, contentType, trackingListName, `/${uspUrl}`);
    };
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(uspTitle, contentType, trackingListName);
    };
    const { ref: viewRef } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
        onClick: ()=>handleClickUsp(),
        ref: viewRef,
        to: uspUrl,
        className: uspLinkClasses,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: uspIconClasses,
                children: icons[uspIcon]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                className: uspTitleCLasses,
                children: uspTitle
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                className: uspDescriptionCLasses,
                children: uspDescription
            })
        ]
    }, usp.sys.id);
};
var $d4e2c8c5b8a6a125$export$2e2bcd8739ae039 = $d4e2c8c5b8a6a125$var$Usp;

});
parcelRegister("hA2CZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccc7d651450d44ad$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $ccc7d651450d44ad$var$SvgBoil = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M8.615 3a3.092 3.092 0 0 0 0 6.185h1.413c.36 0 .701.092.997.277h1.864c-.535-.97-1.634-1.616-2.861-1.616H8.615c-.923 0-1.707-.904-1.707-1.846s.784-1.615 1.707-1.615zm4.477.462c0 .923-.784 1.707-1.707 1.707v1.385a3.67 3.67 0 0 1 3.59 2.908h1.413a5.12 5.12 0 0 0-2.834-3.804 3.07 3.07 0 0 0 .923-2.196zM4 10.846v1.846h1.846v6.462c0 1.024.83 1.846 1.846 1.846h9.231a1.84 1.84 0 0 0 1.846-1.846v-6.462h1.846v-1.846zm3.692 1.846h9.231v6.462h-9.23z"
        })
    }));
var $ccc7d651450d44ad$export$2e2bcd8739ae039 = $ccc7d651450d44ad$var$SvgBoil;

});

parcelRegister("f8ra1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b04cabe9f5d80d62$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $b04cabe9f5d80d62$var$SvgChef = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            fillRule: "evenodd",
            d: "M22.5 10.874a5.256 5.256 0 0 0-5.747-5.226 5.25 5.25 0 0 0-9.508 0A5.25 5.25 0 0 0 4.5 15.616v5.759H19.5v-1.841h-.002v-3.917a5.26 5.26 0 0 0 3-4.743m-4.5 9H6v-3.805a5 5 0 0 0 .75.055h10.5a5 5 0 0 0 .75-.055zm-.75-5.25h-1.29l.517-2.068a.75.75 0 0 0-1.455-.364l-.609 2.432H12.75v-2.25a.75.75 0 1 0-1.5 0v2.25H9.585l-.608-2.432a.75.75 0 1 0-1.455.364l.516 2.068H6.75a3.75 3.75 0 0 1 0-7.5h.055a5 5 0 0 0-.055.75.75.75 0 0 0 1.5 0 3.75 3.75 0 0 1 7.5 0 .75.75 0 1 0 1.5 0q0-.377-.054-.75h.054a3.75 3.75 0 1 1 0 7.5",
            clipRule: "evenodd"
        })
    }));
var $b04cabe9f5d80d62$export$2e2bcd8739ae039 = $b04cabe9f5d80d62$var$SvgChef;

});

parcelRegister("62JH9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4666600bfa120820$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $4666600bfa120820$var$SvgFood = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M16.938 22q-2.11 0-3.586-1.477-1.477-1.477-1.477-3.585 0-2.11 1.477-3.586 1.477-1.477 3.585-1.477 2.11 0 3.586 1.477Q22 14.829 22 16.937q0 2.11-1.477 3.586Q19.046 22 16.938 22m0-1.687q1.406 0 2.39-.985.984-.984.985-2.39 0-1.407-.985-2.391-.984-.985-2.39-.985t-2.391.985-.985 2.39.985 2.391 2.39.985M4 20.875v-9.047L6.25 6.25H5.125V4H13v2.25h-1.125l1.898 4.734a4 4 0 0 0-.738.446q-.34.259-.668.562L10.07 6.25H8.078l-2.39 5.953v6.985h4.898q.117.468.375.867t.492.82zM16.375 10.75q-.944 0-1.598-.651a2.17 2.17 0 0 1-.652-1.594q0-.942.652-1.599a2.17 2.17 0 0 1 1.598-.656zq0-.944.652-1.598a2.17 2.17 0 0 1 1.598-.652q.945 0 1.598.652.652.653.652 1.598z"
        })
    }));
var $4666600bfa120820$export$2e2bcd8739ae039 = $4666600bfa120820$var$SvgFood;

});

parcelRegister("49omM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $305ae758e18ed8f9$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $305ae758e18ed8f9$var$SvgLeaf = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M5.784 18.503a8.3 8.3 0 0 1-1.832-2.74 8.3 8.3 0 0 1-.638-3.198q0-1.887.638-3.565a8.7 8.7 0 0 1 1.86-2.955 8.6 8.6 0 0 1 2.177-1.679q1.207-.652 2.9-.985t4.01-.374 5.479.18q.278 3.58.305 6.02.028 2.443-.236 4.135-.263 1.692-.86 2.844a8.7 8.7 0 0 1-1.595 2.15q-1.276 1.305-2.836 1.984a7.9 7.9 0 0 1-3.185.68 9 9 0 0 1-3.371-.638 8.3 8.3 0 0 1-2.816-1.86m2.857-.333q.777.416 1.61.638a6 6 0 0 0 1.72.194 6.1 6.1 0 0 0 2.386-.54q1.138-.514 2.22-1.54a5.7 5.7 0 0 0 1.193-1.693q.471-.999.707-2.442t.25-3.343q.015-1.9-.18-4.37a35 35 0 0 0-3.87-.111q-1.762.055-3.178.347-1.414.291-2.47.818-1.054.527-1.747 1.276a7.5 7.5 0 0 0-1.457 2.303 6.97 6.97 0 0 0-.097 4.994 7.1 7.1 0 0 0 1.22 2.11 14.7 14.7 0 0 1 2.873-4.08 17 17 0 0 1 4.148-3.051q-2.164 1.914-3.427 3.981a16.7 16.7 0 0 0-1.9 4.509"
        })
    }));
var $305ae758e18ed8f9$export$2e2bcd8739ae039 = $305ae758e18ed8f9$var$SvgLeaf;

});

parcelRegister("kJSNS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1928577a87cbf35$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $f1928577a87cbf35$var$SvgSupport = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M10.714 21v-1.929h8.357V11.92q0-2.947-2.056-5.023t-5.01-2.076q-2.951 0-5.014 2.076Q4.93 8.973 4.93 11.92V18H1.714v-5.679H3l.08-1.366q.241-1.687 1.018-3.147a9.2 9.2 0 0 1 1.969-2.531 9 9 0 0 1 2.718-1.674A8.7 8.7 0 0 1 12 3q1.688 0 3.209.604 1.52.604 2.719 1.674a9.2 9.2 0 0 1 1.974 2.517 9.4 9.4 0 0 1 1.018 3.134L21 12.32h1.286V18H21v3zm-1.601-7.071a.95.95 0 0 1-.689-.276.92.92 0 0 1-.281-.683q0-.408.275-.689A.92.92 0 0 1 9.102 12q.406 0 .688.276a.92.92 0 0 1 .281.683.95.95 0 0 1-.275.688.92.92 0 0 1-.683.282m5.786 0a.95.95 0 0 1-.69-.276.92.92 0 0 1-.28-.683q0-.408.275-.689a.92.92 0 0 1 .683-.281q.408 0 .689.276a.92.92 0 0 1 .281.683.95.95 0 0 1-.275.688.92.92 0 0 1-.684.282m-8.658-1.34q-.24-2.598 1.492-4.486 1.733-1.89 4.32-1.889 2.197 0 3.817 1.473t1.862 3.67a7.3 7.3 0 0 1-4.138-1.245 8.44 8.44 0 0 1-2.88-3.255 8.1 8.1 0 0 1-1.54 3.415 7.6 7.6 0 0 1-2.933 2.317"
        })
    }));
var $f1928577a87cbf35$export$2e2bcd8739ae039 = $f1928577a87cbf35$var$SvgSupport;

});

parcelRegister("1KGvE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146b0fd4a41a5f09$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $146b0fd4a41a5f09$var$SvgTruck = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M6.48 19a2.7 2.7 0 0 1-1.983-.817A2.7 2.7 0 0 1 3.68 16.2H2V5h14.56v3.36h2.8l2.8 3.92v3.92h-1.68a2.7 2.7 0 0 1-.817 1.983A2.7 2.7 0 0 1 17.68 19a2.7 2.7 0 0 1-1.983-.817 2.7 2.7 0 0 1-.817-1.983h-5.6a2.7 2.7 0 0 1-.817 1.983A2.7 2.7 0 0 1 6.48 19m0-1.68q.476 0 .798-.322T7.6 16.2t-.322-.798a1.08 1.08 0 0 0-.798-.322q-.476 0-.798.322t-.322.798.322.798.798.322m-2.8-2.8h.56q.396-.537.98-.828a2.8 2.8 0 0 1 1.26-.292q.677 0 1.26.292.583.291.969.828h6.171V6.68H3.68zm14 2.8q.475 0 .798-.322.322-.322.322-.798t-.322-.798a1.08 1.08 0 0 0-.798-.322q-.475 0-.798.322-.322.322-.322.798t.322.798.798.322m-1.12-4.48h3.92l-1.983-2.8H16.56z"
        })
    }));
var $146b0fd4a41a5f09$export$2e2bcd8739ae039 = $146b0fd4a41a5f09$var$SvgTruck;

});




parcelRegister("roYxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fb1f2deb1447090$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $8ICkW = parcelRequire("8ICkW");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $aRSTV = parcelRequire("aRSTV");

var $fj1oy = parcelRequire("fj1oy");

var $9yKIH = parcelRequire("9yKIH");

var $bZiDo = parcelRequire("bZiDo");

var $3kQAm = parcelRequire("3kQAm");
const $2fb1f2deb1447090$var$CmsManualProductList = ({ content: content, context: context })=>{
    const inspectorProps = (0, $8ICkW.useContentfulInspectorMode)();
    if (!content.fields) return null;
    const isVisible = (0, $fj1oy.getModuleVisibility)(content, (0, $9yKIH.default).currentCustomerProperties);
    if (!isVisible) return null;
    const allSkus = content.fields.skus ? [
        ...content.fields.skus
    ] : [];
    const title = content.fields.title;
    const subtitle = content.fields.subtitle;
    const entryId = content.sys.id;
    const productCount = content.fields.productCount;
    const products = (0, $bZiDo.default).resolveSkus(allSkus, true);
    const skus = products.map((product)=>product.sku);
    let numberOfProducts = productCount === "Ubegrenset" ? skus.length : productCount ? Number.parseInt(productCount) : skus.length;
    numberOfProducts = Math.min(numberOfProducts, skus.length);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ...inspectorProps({
            entryId: entryId,
            fieldId: "entry"
        }),
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
            heading: title,
            subtitle: subtitle,
            listName: content.fields.title ?? `ProductListWithoutName-${content.sys.id}`,
            listType: (0, $aRSTV.LIST_TYPE).CUSTOM,
            count: numberOfProducts,
            context: context,
            skus: skus
        })
    });
};
var $2fb1f2deb1447090$export$2e2bcd8739ae039 = (0, $gBcml.observer)($2fb1f2deb1447090$var$CmsManualProductList);

});

parcelRegister("5Xl3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe156b43f267e765$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $98BXU = parcelRequire("98BXU");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gtsdT = parcelRequire("gtsdT");

var $195xf = parcelRequire("195xf");

var $fj1oy = parcelRequire("fj1oy");

var $bcbvQ = parcelRequire("bcbvQ");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $i6TQx = parcelRequire("i6TQx");

var $hMEeW = parcelRequire("hMEeW");
const $fe156b43f267e765$var$CmsPromotionSignup = ({ content: content })=>{
    const company = (0, $bcbvQ.default).getCurrentCompany();
    const user = (0, $bcbvQ.default).user;
    const isVisible = (0, $fj1oy.getModuleVisibility)(content, (0, $9yKIH.default).currentCustomerProperties);
    if (!isVisible) return null;
    const loggedIn = (0, $jlTfJ.default).isPreviewMode ? true : (0, $bcbvQ.default).isLoggedIn();
    if (!loggedIn) return content.fields.notLoggedInText ? /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
        children: content.fields.notLoggedInText
    }) : null;
    const promotionId = content.fields.promotionId;
    const currentlySignedup = (0, $i6TQx.default).isSignedUpTo(promotionId);
    const dynamicsEventId = content.fields.dynamicsEventId || "";
    const voucherifyEventName = content.fields.voucherifyEventName || "";
    const fields = Array.isArray(content.fields.additionalFields) ? content.fields.additionalFields : [];
    const mapping = Array.isArray(content.fields.dynamicsMapping) ? content.fields.dynamicsMapping : [];
    const dynamicsConfig = {
        FormApiUrl: (0, $195xf.dynamicsEndpoint),
        FormId: dynamicsEventId
    };
    const columnStyle = "w-full mx-auto max-w-md";
    const signup = async (values)=>{
        try {
            await (0, $i6TQx.default).signUpToPromotion(promotionId, voucherifyEventName, dynamicsEventId, values);
            await (0, $i6TQx.default).fetchAvailablePromotions();
            await (0, $i6TQx.default).fetchPromotionDiscountsWithoutDelay();
            return true;
        } catch (err) {
            (0, $gtsdT.logger).warn("contentful", "Error signing up to promotion", err);
            return false;
        }
    };
    if (!currentlySignedup && company && user) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: (0, $izjX7.cn)(columnStyle, "px-2 text-center"),
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hMEeW.default), {
            additionalFields: fields,
            dynamicsMapping: mapping,
            dynamicsConfig: dynamicsConfig,
            buttonText: content.fields.buttonText,
            signup: signup,
            company: company,
            user: user
        })
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: columnStyle,
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
            className: "px-2 py-6 text-center",
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $98BXU.default), {
                    className: "inline-block",
                    fill: "green"
                }),
                " ",
                content.fields.alreadySignedUpFeedback
            ]
        })
    });
};
var $fe156b43f267e765$export$2e2bcd8739ae039 = (0, $gBcml.observer)($fe156b43f267e765$var$CmsPromotionSignup);

});
parcelRegister("98BXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a724f84715f3211$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $6a724f84715f3211$var$SvgCheckCircleFilled = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m10.805 15.375 5.578-5.555-1.195-1.195-4.383 4.36-1.992-1.97-1.196 1.196zM12 21a8.8 8.8 0 0 1-3.492-.703 9.1 9.1 0 0 1-2.871-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 12q0-1.875.703-3.504a9.072 9.072 0 0 1 4.805-4.793A8.8 8.8 0 0 1 12 3q1.875 0 3.504.703a9.1 9.1 0 0 1 4.793 4.793A8.75 8.75 0 0 1 21 12a8.8 8.8 0 0 1-.703 3.492 9.07 9.07 0 0 1-4.793 4.805A8.75 8.75 0 0 1 12 21"
        })
    }));
var $6a724f84715f3211$export$2e2bcd8739ae039 = $6a724f84715f3211$var$SvgCheckCircleFilled;

});

parcelRegister("hMEeW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9f6ad983b0025b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $7c65l = parcelRequire("7c65l");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $j6ChH = parcelRequire("j6ChH");

var $gtsdT = parcelRequire("gtsdT");

var $195xf = parcelRequire("195xf");

var $cLLe3 = parcelRequire("cLLe3");

var $3Uk2n = parcelRequire("3Uk2n");

var $a7WSl = parcelRequire("a7WSl");

var $6Fwsu = parcelRequire("6Fwsu");
const $3c9f6ad983b0025b$var$DYNAMICS_B2B_CUSTOMER_RELATIONSHIP_CODE = "809020003";
const $3c9f6ad983b0025b$var$getCaptureMappings = (mappingsFromContentful, additionalFields)=>{
    const visibleFieldNames = additionalFields.map((field)=>field.key);
    const mappingData = [
        ...mappingsFromContentful,
        {
            key: "customertypecode",
            value: "customertypecode"
        }
    ];
    return mappingData.map((mapping)=>{
        const captureMapping = {
            DataverseFieldName: mapping.value,
            FormFieldName: mapping.key,
            label: ""
        };
        if (visibleFieldNames.includes(mapping.key)) captureMapping.label = mapping.value;
        return captureMapping;
    });
};
const $3c9f6ad983b0025b$var$CmsPromotionSignupForm = ({ additionalFields: additionalFields, dynamicsMapping: dynamicsMapping, dynamicsConfig: dynamicsConfig, buttonText: buttonText, company: company, user: user, signup: signup })=>{
    const formRef = (0, $dvPqk.useRef)(null);
    const [loading, setLoading] = (0, $dvPqk.useState)(false);
    const currentCompany = company;
    const currentUser = user;
    const handleSubmit = async (validatedFormFields)=>{
        let error;
        const captureMappings = $3c9f6ad983b0025b$var$getCaptureMappings(dynamicsMapping, additionalFields);
        const form = formRef.current;
        try {
            setLoading(true);
            const signedUp = await signup(validatedFormFields);
            if (signedUp && form && dynamicsMapping.length) {
                const serializedForm = window.d365mktformcapture.serializeForm(form, captureMappings);
                const dynamicsPayload = serializedForm.SerializedForm.build();
                await window.d365mktformcapture.submitForm(dynamicsConfig, dynamicsPayload);
            }
            return {
                resetFormFields: true
            };
        } catch (err) {
            error = typeof err === "string" || err instanceof Error ? err : "D365 form capture submission error";
            (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(error, (e)=>{
                e.context = "Promotion signup form capture";
                e.addMetadata("signup", {
                    payload: validatedFormFields,
                    mappings: captureMappings
                });
            });
            (0, $gtsdT.logger).warn("contentful", err);
            return {
                resetFormFields: false
            };
        } finally{
            setLoading(false);
        }
    };
    const getValidatorProp = (fieldName)=>/email/i.test(fieldName) ? {
            validator: (0, $3Uk2n.validateEmail)
        } : /phone/i.test(fieldName) ? {
            validator: (0, $3Uk2n.validatePhone)
        } : {};
    const visibleFieldNames = additionalFields.map((field)=>field.key);
    const hiddenFields = dynamicsMapping.filter((mapping)=>!visibleFieldNames.includes(mapping.key));
    const getValueForHiddenField = (fieldName)=>{
        if (fieldName.includes(".")) {
            const [type, property, ..._] = fieldName.split(".");
            if (type === "company") {
                if (property in currentCompany && typeof currentCompany[property] === "string") return currentCompany[property];
            }
            if (type === "user") {
                if (property in currentUser && typeof currentUser[property] === "string") return currentUser[property];
            }
        }
        return "";
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j6ChH.Helmet), {
                children: !window.d365mktformcapture && /*#__PURE__*/ (0, $7YWoO.jsx)("script", {
                    src: (0, $195xf.scriptUrl),
                    onError: ()=>{
                        const error = new Error("Error loading script");
                        (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(error, (e)=>{
                            e.context = "Dynamics Form Capture script load";
                            e.addMetadata("signup", {
                                scriptUrl: (0, $195xf.scriptUrl)
                            });
                        });
                        (0, $gtsdT.logger).warn("contentful", "Error loading Dynamics Form Capture script");
                    }
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $a7WSl.default), {
                onSubmit: handleSubmit,
                ref: formRef,
                children: [
                    additionalFields.map((field)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $6Fwsu.default), {
                            initialValue: "",
                            name: `${field.key}`,
                            label: field.value,
                            required: true,
                            className: "mb-4",
                            ...getValidatorProp(field.key)
                        }, field.key)),
                    hiddenFields.map((hiddenField)=>/*#__PURE__*/ (0, $7YWoO.jsx)("input", {
                            name: hiddenField.key,
                            hidden: true,
                            value: getValueForHiddenField(hiddenField.key)
                        }, hiddenField.key)),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("input", {
                        name: "customertypecode",
                        hidden: true,
                        value: $3c9f6ad983b0025b$var$DYNAMICS_B2B_CUSTOMER_RELATIONSHIP_CODE
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        type: "submit",
                        className: (0, $izjX7.cn)({
                            "mt-4": additionalFields.length > 0
                        }),
                        variant: "primary",
                        size: "regular",
                        loading: loading,
                        children: buttonText
                    })
                ]
            })
        ]
    });
};
var $3c9f6ad983b0025b$export$2e2bcd8739ae039 = (0, $gBcml.observer)($3c9f6ad983b0025b$var$CmsPromotionSignupForm);

});
parcelRegister("3Uk2n", function(module, exports) {

$parcel$export(module.exports, "validateEmail", function () { return $02e5e93c88fdb049$export$18148d12c805c5b0; });
$parcel$export(module.exports, "validatePhone", function () { return $02e5e93c88fdb049$export$375cde19889b052f; });
$parcel$export(module.exports, "validateNotEmpty", function () { return $02e5e93c88fdb049$export$2c76a21508e6b639; });
$parcel$export(module.exports, "validateFileUpload", function () { return $02e5e93c88fdb049$export$eaad298437c58212; });
$parcel$export(module.exports, "validateFavoriteListName", function () { return $02e5e93c88fdb049$export$695a3f32adcc1982; });
$parcel$export(module.exports, "validateNameLength", function () { return $02e5e93c88fdb049$export$74a404107dac0c7e; });
$parcel$export(module.exports, "validateChecked", function () { return $02e5e93c88fdb049$export$1f92e636c7e4857f; });
$parcel$export(module.exports, "validateOtpCode", function () { return $02e5e93c88fdb049$export$36fe979f2016df37; });
$parcel$export(module.exports, "validatePassword", function () { return $02e5e93c88fdb049$export$4d2a7159fda5dc93; });
$parcel$export(module.exports, "useRepeatedPasswordValidator", function () { return $02e5e93c88fdb049$export$78ddd8a358830335; });

var $f2ROJ = parcelRequire("f2ROJ");
const $02e5e93c88fdb049$export$18148d12c805c5b0 = (value, required)=>{
    const requiredPhoneSchema = (0, $f2ROJ.z).string().nonempty({
        message: "E-postadresse er p\xe5krevd"
    }).email({
        message: "E-postadressen er ikke gyldig"
    });
    const optionalPhoneSchema = (0, $f2ROJ.z).union([
        (0, $f2ROJ.z).string().email({
            message: "E-postadressen er ikke gyldig"
        }),
        (0, $f2ROJ.z).literal("")
    ]);
    const schema = required ? requiredPhoneSchema : optionalPhoneSchema;
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
const $02e5e93c88fdb049$export$375cde19889b052f = (value, required)=>{
    const requiredTelefonSchema = (0, $f2ROJ.z).string().nonempty({
        message: "Telefonnummer er p\xe5krevd"
    }).min(8, {
        message: "Telefonnummeret er ikke gyldig"
    });
    const optionalPhoneSchema = (0, $f2ROJ.z).union([
        (0, $f2ROJ.z).string().regex(/^[\d+]+$/, {
            message: "Telefonnummeret er ikke gyldig"
        }).min(8, {
            message: "Telefonnummeret er ikke gyldig"
        }),
        (0, $f2ROJ.z).literal("")
    ]);
    const schema = required ? requiredTelefonSchema : optionalPhoneSchema;
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
const $02e5e93c88fdb049$export$2c76a21508e6b639 = (value, required)=>{
    if (!required) return "";
    const schema = (0, $f2ROJ.z).string().nonempty({
        message: "Feltet kan ikke v\xe6re tomt"
    });
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
const $02e5e93c88fdb049$export$eaad298437c58212 = (value, required)=>{
    const requiredFileUploadSchema = (0, $f2ROJ.z).instanceof(File).refine((file)=>file.size > 0, {
        message: "Feltet kan ikke v\xe6re tomt"
    }).refine((file)=>[
            "application/pdf",
            "application/txt",
            "image/png",
            "image/jpeg",
            "image/jpg",
            "image/svg+xml",
            "image/gif"
        ].includes(file.type), {
        message: "Ikke gyldig filtype"
    });
    const optionalFileUploadSchema = (0, $f2ROJ.z).union([
        (0, $f2ROJ.z).instanceof(File).refine((file)=>[
                "application/pdf",
                "application/txt",
                "image/png",
                "image/jpeg",
                "image/jpg",
                "image/svg+xml",
                "image/gif"
            ].includes(file.type), {
            message: "Ikke gyldig filtype"
        }),
        (0, $f2ROJ.z).literal(null)
    ]);
    const schema = required ? requiredFileUploadSchema : optionalFileUploadSchema;
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
const $02e5e93c88fdb049$export$695a3f32adcc1982 = (value, required)=>{
    const requiredFavoriteListSchema = (0, $f2ROJ.z).string().nonempty({
        message: "Det m\xe5 v\xe6re mellom 1 og 30 tegn i navnet"
    }).max(30, {
        message: "Det kan ikke v\xe6re flere enn 30 tegn i navnet"
    });
    const optionalFavoriteListSchema = (0, $f2ROJ.z).union([
        (0, $f2ROJ.z).string().max(30, {
            message: "Det kan ikke v\xe6re flere enn 30 tegn i navnet"
        }),
        (0, $f2ROJ.z).literal("")
    ]);
    const schema = required ? requiredFavoriteListSchema : optionalFavoriteListSchema;
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
const $02e5e93c88fdb049$export$74a404107dac0c7e = (value, required)=>{
    const requiredNameSchema = (0, $f2ROJ.z).string().nonempty({
        message: "Vennligst oppi navn p\xe5 mottaker"
    }).max(50, {
        message: "Det kan ikke v\xe6re flere enn 50 tegn i navnet"
    });
    const optionalNameSchema = (0, $f2ROJ.z).union([
        (0, $f2ROJ.z).string().max(50, {
            message: "Det kan ikke v\xe6re flere enn 50 tegn i navnet"
        }),
        (0, $f2ROJ.z).literal("")
    ]);
    const schema = required ? requiredNameSchema : optionalNameSchema;
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
const $02e5e93c88fdb049$export$1f92e636c7e4857f = (value, required)=>{
    return !value && required ? "Dette feltet m\xe5 v\xe6re avkrysset" : "";
};
const $02e5e93c88fdb049$export$36fe979f2016df37 = (value)=>{
    const schema = (0, $f2ROJ.z).string().nonempty({
        message: "Vennligst oppgi engangskode"
    }).length(6, {
        message: "Engangskoden m\xe5 v\xe6re 6 siffer"
    }).regex(/^[0-9]+$/, {
        message: "Engangskoden kan kun inneholde siffer"
    });
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
const $02e5e93c88fdb049$export$4d2a7159fda5dc93 = (value)=>{
    const schema = (0, $f2ROJ.z).string().nonempty({
        message: "Vennligst oppgi passord"
    }).min(8, {
        message: "Passordet m\xe5 v\xe6re minst 8 tegn"
    });
    const result = schema.safeParse(value);
    return result.error?.errors[0].message ?? "";
};
function $02e5e93c88fdb049$export$78ddd8a358830335(password) {
    return (value)=>{
        const schema = (0, $f2ROJ.z).string().refine((val)=>val === password, {
            message: "Passordene m\xe5 v\xe6re like"
        });
        const result = schema.safeParse(value);
        return result.error?.errors[0].message ?? "";
    };
}

});
parcelRegister("f2ROJ", function(module, exports) {

$parcel$export(module.exports, "z", function () { return $6aa0b58e1a1efbf1$export$2e2bcd8739ae039; });
var $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($6aa0b58e1a1efbf1$export$7debb50ef11d5e0b || ($6aa0b58e1a1efbf1$export$7debb50ef11d5e0b = {}));
var $6aa0b58e1a1efbf1$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($6aa0b58e1a1efbf1$export$4aa2142c225fd5c7 || ($6aa0b58e1a1efbf1$export$4aa2142c225fd5c7 = {}));
const $6aa0b58e1a1efbf1$export$5716da67bfaa244d = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.undefined;
        case "string":
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $6aa0b58e1a1efbf1$export$5716da67bfaa244d.nan : $6aa0b58e1a1efbf1$export$5716da67bfaa244d.number;
        case "boolean":
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.boolean;
        case "function":
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.function;
        case "bigint":
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.array;
            if (data === null) return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.date;
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object;
        default:
            return $6aa0b58e1a1efbf1$export$5716da67bfaa244d.unknown;
    }
};
const $6aa0b58e1a1efbf1$export$5ba560653e4a1035 = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $6aa0b58e1a1efbf1$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $6aa0b58e1a1efbf1$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $6aa0b58e1a1efbf1$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$6aa0b58e1a1efbf1$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $6aa0b58e1a1efbf1$export$f98dac4b251ab333(issues);
    return error;
};
const $6aa0b58e1a1efbf1$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $6aa0b58e1a1efbf1$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $6aa0b58e1a1efbf1$var$overrideErrorMap = $6aa0b58e1a1efbf1$export$341b0b6e0a6f5099;
function $6aa0b58e1a1efbf1$export$1097a8289cfd22d7(map) {
    $6aa0b58e1a1efbf1$var$overrideErrorMap = map;
}
function $6aa0b58e1a1efbf1$export$32f27c719778d4c4() {
    return $6aa0b58e1a1efbf1$var$overrideErrorMap;
}
const $6aa0b58e1a1efbf1$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $6aa0b58e1a1efbf1$export$1526d2e05f74572 = [];
function $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $6aa0b58e1a1efbf1$export$32f27c719778d4c4();
    const issue = $6aa0b58e1a1efbf1$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $6aa0b58e1a1efbf1$export$341b0b6e0a6f5099 ? undefined : $6aa0b58e1a1efbf1$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $6aa0b58e1a1efbf1$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $6aa0b58e1a1efbf1$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $6aa0b58e1a1efbf1$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $6aa0b58e1a1efbf1$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $6aa0b58e1a1efbf1$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $6aa0b58e1a1efbf1$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6aa0b58e1a1efbf1$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6aa0b58e1a1efbf1$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $6aa0b58e1a1efbf1$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($6aa0b58e1a1efbf1$var$errorUtil || ($6aa0b58e1a1efbf1$var$errorUtil = {}));
var $6aa0b58e1a1efbf1$var$_ZodEnum_cache, $6aa0b58e1a1efbf1$var$_ZodNativeEnum_cache;
class $6aa0b58e1a1efbf1$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $6aa0b58e1a1efbf1$var$handleResult = (ctx, result)=>{
    if ($6aa0b58e1a1efbf1$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $6aa0b58e1a1efbf1$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $6aa0b58e1a1efbf1$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($6aa0b58e1a1efbf1$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $6aa0b58e1a1efbf1$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $6aa0b58e1a1efbf1$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$6aa0b58e1a1efbf1$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($6aa0b58e1a1efbf1$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $6aa0b58e1a1efbf1$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $6aa0b58e1a1efbf1$export$a60af00cc0ce2582({
            schema: this,
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $6aa0b58e1a1efbf1$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $6aa0b58e1a1efbf1$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $6aa0b58e1a1efbf1$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $6aa0b58e1a1efbf1$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $6aa0b58e1a1efbf1$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $6aa0b58e1a1efbf1$export$a60af00cc0ce2582({
            ...$6aa0b58e1a1efbf1$var$processCreateParams(this._def),
            schema: this,
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $6aa0b58e1a1efbf1$export$bb19b37874861e7e({
            ...$6aa0b58e1a1efbf1$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $6aa0b58e1a1efbf1$export$66b0c798a395271f({
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$6aa0b58e1a1efbf1$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $6aa0b58e1a1efbf1$export$75a44ec6249ac76b({
            ...$6aa0b58e1a1efbf1$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $6aa0b58e1a1efbf1$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $6aa0b58e1a1efbf1$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $6aa0b58e1a1efbf1$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $6aa0b58e1a1efbf1$var$cuid2Regex = /^[0-9a-z]+$/;
const $6aa0b58e1a1efbf1$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $6aa0b58e1a1efbf1$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $6aa0b58e1a1efbf1$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $6aa0b58e1a1efbf1$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $6aa0b58e1a1efbf1$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $6aa0b58e1a1efbf1$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $6aa0b58e1a1efbf1$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $6aa0b58e1a1efbf1$var$emojiRegex;
// faster, simpler, safer
const $6aa0b58e1a1efbf1$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $6aa0b58e1a1efbf1$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $6aa0b58e1a1efbf1$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $6aa0b58e1a1efbf1$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $6aa0b58e1a1efbf1$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $6aa0b58e1a1efbf1$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $6aa0b58e1a1efbf1$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $6aa0b58e1a1efbf1$var$dateRegex = new RegExp(`^${$6aa0b58e1a1efbf1$var$dateRegexSource}$`);
function $6aa0b58e1a1efbf1$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $6aa0b58e1a1efbf1$var$timeRegex(args) {
    return new RegExp(`^${$6aa0b58e1a1efbf1$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $6aa0b58e1a1efbf1$export$a4b563879add27a(args) {
    let regex = `${$6aa0b58e1a1efbf1$var$dateRegexSource}T${$6aa0b58e1a1efbf1$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $6aa0b58e1a1efbf1$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $6aa0b58e1a1efbf1$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $6aa0b58e1a1efbf1$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $6aa0b58e1a1efbf1$var$isValidJWT(jwt, alg) {
    if (!$6aa0b58e1a1efbf1$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $6aa0b58e1a1efbf1$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $6aa0b58e1a1efbf1$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $6aa0b58e1a1efbf1$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $6aa0b58e1a1efbf1$export$1230eb29b8d3b502 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const status = new $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$6aa0b58e1a1efbf1$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$6aa0b58e1a1efbf1$var$emojiRegex) $6aa0b58e1a1efbf1$var$emojiRegex = new RegExp($6aa0b58e1a1efbf1$var$_emojiRegex, "u");
                if (!$6aa0b58e1a1efbf1$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$6aa0b58e1a1efbf1$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$6aa0b58e1a1efbf1$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$6aa0b58e1a1efbf1$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$6aa0b58e1a1efbf1$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$6aa0b58e1a1efbf1$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $6aa0b58e1a1efbf1$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $6aa0b58e1a1efbf1$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $6aa0b58e1a1efbf1$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$6aa0b58e1a1efbf1$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$6aa0b58e1a1efbf1$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$6aa0b58e1a1efbf1$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$6aa0b58e1a1efbf1$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$6aa0b58e1a1efbf1$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$6aa0b58e1a1efbf1$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_string,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $6aa0b58e1a1efbf1$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$6aa0b58e1a1efbf1$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $6aa0b58e1a1efbf1$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $6aa0b58e1a1efbf1$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $6aa0b58e1a1efbf1$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $6aa0b58e1a1efbf1$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$6aa0b58e1a1efbf1$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $6aa0b58e1a1efbf1$export$1230eb29b8d3b502({
        checks: [],
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $6aa0b58e1a1efbf1$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $6aa0b58e1a1efbf1$export$5b070a55c0c43e09 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($6aa0b58e1a1efbf1$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $6aa0b58e1a1efbf1$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $6aa0b58e1a1efbf1$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$6aa0b58e1a1efbf1$export$5b070a55c0c43e09.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$5b070a55c0c43e09({
        checks: [],
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$67d741fd70ff98f4 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
            code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
            expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $6aa0b58e1a1efbf1$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $6aa0b58e1a1efbf1$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $6aa0b58e1a1efbf1$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$6aa0b58e1a1efbf1$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $6aa0b58e1a1efbf1$export$67d741fd70ff98f4({
        checks: [],
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$723d146f80596191 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
}
$6aa0b58e1a1efbf1$export$723d146f80596191.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$723d146f80596191({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$e974be33bdc55521 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_date
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const status = new $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $6aa0b58e1a1efbf1$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$6aa0b58e1a1efbf1$export$e974be33bdc55521.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodDate,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$bcc3b40f6b638044 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
}
$6aa0b58e1a1efbf1$export$bcc3b40f6b638044.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$bcc3b40f6b638044({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodSymbol,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$4e780e961c30340d extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
}
$6aa0b58e1a1efbf1$export$4e780e961c30340d.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$4e780e961c30340d({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodUndefined,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$a96281f914484f2d extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
}
$6aa0b58e1a1efbf1$export$a96281f914484f2d.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$a96281f914484f2d({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodNull,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$b9d1edb536b4e4eb extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
}
$6aa0b58e1a1efbf1$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$b9d1edb536b4e4eb({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodAny,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$ef3b1bb1630977ae extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
}
$6aa0b58e1a1efbf1$export$ef3b1bb1630977ae.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$ef3b1bb1630977ae({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodUnknown,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
            code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
            expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
    }
}
$6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodNever,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$7d39f5df85f21031 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
}
$6aa0b58e1a1efbf1$export$7d39f5df85f21031.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$7d39f5df85f21031({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodVoid,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$7acfc3e64785411 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.array) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big : $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $6aa0b58e1a1efbf1$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $6aa0b58e1a1efbf1$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $6aa0b58e1a1efbf1$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$6aa0b58e1a1efbf1$export$7acfc3e64785411.create = (schema, params)=>{
    return new $6aa0b58e1a1efbf1$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodArray,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
function $6aa0b58e1a1efbf1$var$deepPartialify(schema) {
    if (schema instanceof $6aa0b58e1a1efbf1$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8.create($6aa0b58e1a1efbf1$var$deepPartialify(fieldSchema));
        }
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $6aa0b58e1a1efbf1$export$7acfc3e64785411) return new $6aa0b58e1a1efbf1$export$7acfc3e64785411({
        ...schema._def,
        type: $6aa0b58e1a1efbf1$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8) return $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8.create($6aa0b58e1a1efbf1$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $6aa0b58e1a1efbf1$export$aaac0b8b429cef5) return $6aa0b58e1a1efbf1$export$aaac0b8b429cef5.create($6aa0b58e1a1efbf1$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3) return $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$6aa0b58e1a1efbf1$var$deepPartialify(item)));
    else return schema;
}
class $6aa0b58e1a1efbf1$export$736315c5b55efbad extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                        code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $6aa0b58e1a1efbf1$var$errorUtil.errToObj;
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $6aa0b58e1a1efbf1$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $6aa0b58e1a1efbf1$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $6aa0b58e1a1efbf1$var$createZodEnum($6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$6aa0b58e1a1efbf1$export$736315c5b55efbad.create = (shape, params)=>{
    return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5.create(),
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodObject,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
$6aa0b58e1a1efbf1$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5.create(),
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodObject,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
$6aa0b58e1a1efbf1$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $6aa0b58e1a1efbf1$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5.create(),
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodObject,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$a8b236cb5070a311 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $6aa0b58e1a1efbf1$export$f98dac4b251ab333(result.ctx.common.issues));
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $6aa0b58e1a1efbf1$export$f98dac4b251ab333(issues));
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$6aa0b58e1a1efbf1$export$a8b236cb5070a311.create = (types, params)=>{
    return new $6aa0b58e1a1efbf1$export$a8b236cb5070a311({
        options: types,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodUnion,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $6aa0b58e1a1efbf1$var$getDiscriminator = (type)=>{
    if (type instanceof $6aa0b58e1a1efbf1$export$378d0cfce37406e6) return $6aa0b58e1a1efbf1$var$getDiscriminator(type.schema);
    else if (type instanceof $6aa0b58e1a1efbf1$export$a60af00cc0ce2582) return $6aa0b58e1a1efbf1$var$getDiscriminator(type.innerType());
    else if (type instanceof $6aa0b58e1a1efbf1$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $6aa0b58e1a1efbf1$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $6aa0b58e1a1efbf1$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $6aa0b58e1a1efbf1$export$bb19b37874861e7e) return $6aa0b58e1a1efbf1$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $6aa0b58e1a1efbf1$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $6aa0b58e1a1efbf1$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8) return [
        undefined,
        ...$6aa0b58e1a1efbf1$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $6aa0b58e1a1efbf1$export$aaac0b8b429cef5) return [
        null,
        ...$6aa0b58e1a1efbf1$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $6aa0b58e1a1efbf1$export$66b0c798a395271f) return $6aa0b58e1a1efbf1$var$getDiscriminator(type.unwrap());
    else if (type instanceof $6aa0b58e1a1efbf1$export$5d1f7ef05c4e493a) return $6aa0b58e1a1efbf1$var$getDiscriminator(type.unwrap());
    else if (type instanceof $6aa0b58e1a1efbf1$export$75a44ec6249ac76b) return $6aa0b58e1a1efbf1$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $6aa0b58e1a1efbf1$export$5ef2424805ac76a3 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $6aa0b58e1a1efbf1$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $6aa0b58e1a1efbf1$export$5ef2424805ac76a3({
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
        });
    }
}
function $6aa0b58e1a1efbf1$var$mergeValues(a, b) {
    const aType = $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(a);
    const bType = $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object && bType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object) {
        const bKeys = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $6aa0b58e1a1efbf1$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.array && bType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $6aa0b58e1a1efbf1$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.date && bType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $6aa0b58e1a1efbf1$export$c02deaf0bb5203d4 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($6aa0b58e1a1efbf1$export$afa861e3c5730743(parsedLeft) || $6aa0b58e1a1efbf1$export$afa861e3c5730743(parsedRight)) return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
            const merged = $6aa0b58e1a1efbf1$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
            }
            if ($6aa0b58e1a1efbf1$export$910b6cdd390341b3(parsedLeft) || $6aa0b58e1a1efbf1$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$6aa0b58e1a1efbf1$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $6aa0b58e1a1efbf1$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodIntersection,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.array) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$a2acc09968cb4b7f extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $6aa0b58e1a1efbf1$export$19342e026b58ebb7) return new $6aa0b58e1a1efbf1$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodRecord,
            ...$6aa0b58e1a1efbf1$var$processCreateParams(third)
        });
        return new $6aa0b58e1a1efbf1$export$a2acc09968cb4b7f({
            keyType: $6aa0b58e1a1efbf1$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodRecord,
            ...$6aa0b58e1a1efbf1$var$processCreateParams(second)
        });
    }
}
class $6aa0b58e1a1efbf1$export$163b6a2b712d9542 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.map) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$6aa0b58e1a1efbf1$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $6aa0b58e1a1efbf1$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodMap,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$977057706f816712 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.set) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $6aa0b58e1a1efbf1$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $6aa0b58e1a1efbf1$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $6aa0b58e1a1efbf1$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $6aa0b58e1a1efbf1$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$6aa0b58e1a1efbf1$export$977057706f816712.create = (valueType, params)=>{
    return new $6aa0b58e1a1efbf1$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodSet,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$d4602ba55673f53c extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.function) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $6aa0b58e1a1efbf1$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $6aa0b58e1a1efbf1$export$32f27c719778d4c4(),
                    $6aa0b58e1a1efbf1$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $6aa0b58e1a1efbf1$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $6aa0b58e1a1efbf1$export$32f27c719778d4c4(),
                    $6aa0b58e1a1efbf1$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $6aa0b58e1a1efbf1$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $6aa0b58e1a1efbf1$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $6aa0b58e1a1efbf1$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $6aa0b58e1a1efbf1$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $6aa0b58e1a1efbf1$export$d4602ba55673f53c({
            ...this._def,
            args: $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3.create(items).rest($6aa0b58e1a1efbf1$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $6aa0b58e1a1efbf1$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $6aa0b58e1a1efbf1$export$d4602ba55673f53c({
            args: args ? args : $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3.create([]).rest($6aa0b58e1a1efbf1$export$ef3b1bb1630977ae.create()),
            returns: returns || $6aa0b58e1a1efbf1$export$ef3b1bb1630977ae.create(),
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodFunction,
            ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
        });
    }
}
class $6aa0b58e1a1efbf1$export$378d0cfce37406e6 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$6aa0b58e1a1efbf1$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $6aa0b58e1a1efbf1$export$378d0cfce37406e6({
        getter: getter,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodLazy,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$7e44096782a165d3 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$6aa0b58e1a1efbf1$export$7e44096782a165d3.create = (value, params)=>{
    return new $6aa0b58e1a1efbf1$export$7e44096782a165d3({
        value: value,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodLiteral,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
function $6aa0b58e1a1efbf1$var$createZodEnum(values, params) {
    return new $6aa0b58e1a1efbf1$export$d325d1f0e1c20179({
        values: values,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodEnum,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
}
class $6aa0b58e1a1efbf1$export$d325d1f0e1c20179 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $6aa0b58e1a1efbf1$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                expected: $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        if (!$6aa0b58e1a1efbf1$var$__classPrivateFieldGet(this, $6aa0b58e1a1efbf1$var$_ZodEnum_cache, "f")) $6aa0b58e1a1efbf1$var$__classPrivateFieldSet(this, $6aa0b58e1a1efbf1$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$6aa0b58e1a1efbf1$var$__classPrivateFieldGet(this, $6aa0b58e1a1efbf1$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $6aa0b58e1a1efbf1$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $6aa0b58e1a1efbf1$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$6aa0b58e1a1efbf1$var$_ZodEnum_cache = new WeakMap();
$6aa0b58e1a1efbf1$export$d325d1f0e1c20179.create = $6aa0b58e1a1efbf1$var$createZodEnum;
class $6aa0b58e1a1efbf1$export$370b2e8d6d6f5c56 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $6aa0b58e1a1efbf1$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.string && ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.number) {
            const expectedValues = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                expected: $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        if (!$6aa0b58e1a1efbf1$var$__classPrivateFieldGet(this, $6aa0b58e1a1efbf1$var$_ZodNativeEnum_cache, "f")) $6aa0b58e1a1efbf1$var$__classPrivateFieldSet(this, $6aa0b58e1a1efbf1$var$_ZodNativeEnum_cache, new Set($6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$6aa0b58e1a1efbf1$var$__classPrivateFieldGet(this, $6aa0b58e1a1efbf1$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$6aa0b58e1a1efbf1$var$_ZodNativeEnum_cache = new WeakMap();
$6aa0b58e1a1efbf1$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $6aa0b58e1a1efbf1$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodNativeEnum,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$3f196b0127d6e50a extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$6aa0b58e1a1efbf1$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $6aa0b58e1a1efbf1$export$3f196b0127d6e50a({
        type: schema,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodPromise,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$a60af00cc0ce2582 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $6aa0b58e1a1efbf1$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $6aa0b58e1a1efbf1$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $6aa0b58e1a1efbf1$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $6aa0b58e1a1efbf1$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$6aa0b58e1a1efbf1$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$6aa0b58e1a1efbf1$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$6aa0b58e1a1efbf1$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $6aa0b58e1a1efbf1$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
$6aa0b58e1a1efbf1$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $6aa0b58e1a1efbf1$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodEffects,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.undefined) return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$6aa0b58e1a1efbf1$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodOptional,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$aaac0b8b429cef5 extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.null) return $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$6aa0b58e1a1efbf1$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $6aa0b58e1a1efbf1$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodNullable,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$bb19b37874861e7e extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $6aa0b58e1a1efbf1$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$6aa0b58e1a1efbf1$export$bb19b37874861e7e.create = (type, params)=>{
    return new $6aa0b58e1a1efbf1$export$bb19b37874861e7e({
        innerType: type,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$75a44ec6249ac76b extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($6aa0b58e1a1efbf1$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $6aa0b58e1a1efbf1$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $6aa0b58e1a1efbf1$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$6aa0b58e1a1efbf1$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $6aa0b58e1a1efbf1$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
class $6aa0b58e1a1efbf1$export$26ccfa0145e8511f extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $6aa0b58e1a1efbf1$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $6aa0b58e1a1efbf1$export$db7caee60e5d514d(ctx, {
                code: $6aa0b58e1a1efbf1$export$5ba560653e4a1035.invalid_type,
                expected: $6aa0b58e1a1efbf1$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$6aa0b58e1a1efbf1$export$26ccfa0145e8511f.create = (params)=>{
    return new $6aa0b58e1a1efbf1$export$26ccfa0145e8511f({
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodNaN,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
const $6aa0b58e1a1efbf1$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $6aa0b58e1a1efbf1$export$66b0c798a395271f extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $6aa0b58e1a1efbf1$export$a3c3ef8a0e95c6da extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $6aa0b58e1a1efbf1$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $6aa0b58e1a1efbf1$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $6aa0b58e1a1efbf1$export$5d1f7ef05c4e493a extends $6aa0b58e1a1efbf1$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($6aa0b58e1a1efbf1$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $6aa0b58e1a1efbf1$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$6aa0b58e1a1efbf1$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $6aa0b58e1a1efbf1$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $6aa0b58e1a1efbf1$export$558106ce543bd011.ZodReadonly,
        ...$6aa0b58e1a1efbf1$var$processCreateParams(params)
    });
};
function $6aa0b58e1a1efbf1$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $6aa0b58e1a1efbf1$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $6aa0b58e1a1efbf1$export$b9d1edb536b4e4eb.create();
}
const $6aa0b58e1a1efbf1$export$1ee8ee30835eab8b = {
    object: $6aa0b58e1a1efbf1$export$736315c5b55efbad.lazycreate
};
var $6aa0b58e1a1efbf1$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($6aa0b58e1a1efbf1$export$558106ce543bd011 || ($6aa0b58e1a1efbf1$export$558106ce543bd011 = {}));
const $6aa0b58e1a1efbf1$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$6aa0b58e1a1efbf1$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $6aa0b58e1a1efbf1$export$22b082955e083ec3 = $6aa0b58e1a1efbf1$export$1230eb29b8d3b502.create;
const $6aa0b58e1a1efbf1$export$98e628dec113755e = $6aa0b58e1a1efbf1$export$5b070a55c0c43e09.create;
const $6aa0b58e1a1efbf1$export$9e06de0973666692 = $6aa0b58e1a1efbf1$export$26ccfa0145e8511f.create;
const $6aa0b58e1a1efbf1$export$a0f65b52274bcc00 = $6aa0b58e1a1efbf1$export$67d741fd70ff98f4.create;
const $6aa0b58e1a1efbf1$export$4a21f16c33752377 = $6aa0b58e1a1efbf1$export$723d146f80596191.create;
const $6aa0b58e1a1efbf1$export$324d90190a8b822a = $6aa0b58e1a1efbf1$export$e974be33bdc55521.create;
const $6aa0b58e1a1efbf1$export$8f701197936bc2a6 = $6aa0b58e1a1efbf1$export$bcc3b40f6b638044.create;
const $6aa0b58e1a1efbf1$export$1db45310990710a5 = $6aa0b58e1a1efbf1$export$4e780e961c30340d.create;
const $6aa0b58e1a1efbf1$export$7b1b591b262c240 = $6aa0b58e1a1efbf1$export$a96281f914484f2d.create;
const $6aa0b58e1a1efbf1$export$4154a199d7d90455 = $6aa0b58e1a1efbf1$export$b9d1edb536b4e4eb.create;
const $6aa0b58e1a1efbf1$export$19282c40b967aec6 = $6aa0b58e1a1efbf1$export$ef3b1bb1630977ae.create;
const $6aa0b58e1a1efbf1$export$b3e22bcfd64c1022 = $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5.create;
const $6aa0b58e1a1efbf1$export$490e536ee7389aeb = $6aa0b58e1a1efbf1$export$7d39f5df85f21031.create;
const $6aa0b58e1a1efbf1$export$2f23118c22fb2630 = $6aa0b58e1a1efbf1$export$7acfc3e64785411.create;
const $6aa0b58e1a1efbf1$export$be5493f9613cbbe = $6aa0b58e1a1efbf1$export$736315c5b55efbad.create;
const $6aa0b58e1a1efbf1$export$8fb0df5f40d0b477 = $6aa0b58e1a1efbf1$export$736315c5b55efbad.strictCreate;
const $6aa0b58e1a1efbf1$export$971dd5b0dfd021b6 = $6aa0b58e1a1efbf1$export$a8b236cb5070a311.create;
const $6aa0b58e1a1efbf1$export$4b888e40c4ee26dd = $6aa0b58e1a1efbf1$export$5ef2424805ac76a3.create;
const $6aa0b58e1a1efbf1$export$bc86dfbf7795668c = $6aa0b58e1a1efbf1$export$c02deaf0bb5203d4.create;
const $6aa0b58e1a1efbf1$export$65e3907585753458 = $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3.create;
const $6aa0b58e1a1efbf1$export$e5185e241753e543 = $6aa0b58e1a1efbf1$export$a2acc09968cb4b7f.create;
const $6aa0b58e1a1efbf1$export$871de8747c9eaa88 = $6aa0b58e1a1efbf1$export$163b6a2b712d9542.create;
const $6aa0b58e1a1efbf1$export$adaa4cf7ef1b65be = $6aa0b58e1a1efbf1$export$977057706f816712.create;
const $6aa0b58e1a1efbf1$export$44e51c8aac7c2deb = $6aa0b58e1a1efbf1$export$d4602ba55673f53c.create;
const $6aa0b58e1a1efbf1$export$488013bae63b21da = $6aa0b58e1a1efbf1$export$378d0cfce37406e6.create;
const $6aa0b58e1a1efbf1$export$c8ec6e1ec9fefcb0 = $6aa0b58e1a1efbf1$export$7e44096782a165d3.create;
const $6aa0b58e1a1efbf1$export$78a99c8d44d72635 = $6aa0b58e1a1efbf1$export$d325d1f0e1c20179.create;
const $6aa0b58e1a1efbf1$export$6fe7eca19ebe5199 = $6aa0b58e1a1efbf1$export$370b2e8d6d6f5c56.create;
const $6aa0b58e1a1efbf1$export$c957ef27a0ebfd4 = $6aa0b58e1a1efbf1$export$3f196b0127d6e50a.create;
const $6aa0b58e1a1efbf1$export$dc573d8a6576cdb3 = $6aa0b58e1a1efbf1$export$a60af00cc0ce2582.create;
const $6aa0b58e1a1efbf1$export$516e28dec6a4b6d4 = $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8.create;
const $6aa0b58e1a1efbf1$export$133fc36489ac9add = $6aa0b58e1a1efbf1$export$aaac0b8b429cef5.create;
const $6aa0b58e1a1efbf1$export$fc37fe19dfda43ee = $6aa0b58e1a1efbf1$export$a60af00cc0ce2582.createWithPreprocess;
const $6aa0b58e1a1efbf1$export$43f28b24e1eb8181 = $6aa0b58e1a1efbf1$export$a3c3ef8a0e95c6da.create;
const $6aa0b58e1a1efbf1$export$3b3d07727c5b702c = ()=>$6aa0b58e1a1efbf1$export$22b082955e083ec3().optional();
const $6aa0b58e1a1efbf1$export$eb150471a61fced6 = ()=>$6aa0b58e1a1efbf1$export$98e628dec113755e().optional();
const $6aa0b58e1a1efbf1$export$269251733cdcbbf1 = ()=>$6aa0b58e1a1efbf1$export$4a21f16c33752377().optional();
const $6aa0b58e1a1efbf1$export$8c14e57e778d3873 = {
    string: (arg)=>$6aa0b58e1a1efbf1$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$6aa0b58e1a1efbf1$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$6aa0b58e1a1efbf1$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$6aa0b58e1a1efbf1$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$6aa0b58e1a1efbf1$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $6aa0b58e1a1efbf1$export$96c94437c95d7862 = $6aa0b58e1a1efbf1$export$9a105a556e65c2c0;
var $6aa0b58e1a1efbf1$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $6aa0b58e1a1efbf1$export$341b0b6e0a6f5099,
    setErrorMap: $6aa0b58e1a1efbf1$export$1097a8289cfd22d7,
    getErrorMap: $6aa0b58e1a1efbf1$export$32f27c719778d4c4,
    makeIssue: $6aa0b58e1a1efbf1$export$244a85fde9c419ed,
    EMPTY_PATH: $6aa0b58e1a1efbf1$export$1526d2e05f74572,
    addIssueToContext: $6aa0b58e1a1efbf1$export$db7caee60e5d514d,
    ParseStatus: $6aa0b58e1a1efbf1$export$5b20a5c3d05c1f6f,
    INVALID: $6aa0b58e1a1efbf1$export$9a105a556e65c2c0,
    DIRTY: $6aa0b58e1a1efbf1$export$325a211da9693fcf,
    OK: $6aa0b58e1a1efbf1$export$c6813a8d51f77eaf,
    isAborted: $6aa0b58e1a1efbf1$export$afa861e3c5730743,
    isDirty: $6aa0b58e1a1efbf1$export$910b6cdd390341b3,
    isValid: $6aa0b58e1a1efbf1$export$1ea939691cdc45b8,
    isAsync: $6aa0b58e1a1efbf1$export$aefee5ebe1dcfd9e,
    get util () {
        return $6aa0b58e1a1efbf1$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $6aa0b58e1a1efbf1$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $6aa0b58e1a1efbf1$export$5716da67bfaa244d,
    getParsedType: $6aa0b58e1a1efbf1$export$3e9057828ebd5c7a,
    ZodType: $6aa0b58e1a1efbf1$export$19342e026b58ebb7,
    datetimeRegex: $6aa0b58e1a1efbf1$export$a4b563879add27a,
    ZodString: $6aa0b58e1a1efbf1$export$1230eb29b8d3b502,
    ZodNumber: $6aa0b58e1a1efbf1$export$5b070a55c0c43e09,
    ZodBigInt: $6aa0b58e1a1efbf1$export$67d741fd70ff98f4,
    ZodBoolean: $6aa0b58e1a1efbf1$export$723d146f80596191,
    ZodDate: $6aa0b58e1a1efbf1$export$e974be33bdc55521,
    ZodSymbol: $6aa0b58e1a1efbf1$export$bcc3b40f6b638044,
    ZodUndefined: $6aa0b58e1a1efbf1$export$4e780e961c30340d,
    ZodNull: $6aa0b58e1a1efbf1$export$a96281f914484f2d,
    ZodAny: $6aa0b58e1a1efbf1$export$b9d1edb536b4e4eb,
    ZodUnknown: $6aa0b58e1a1efbf1$export$ef3b1bb1630977ae,
    ZodNever: $6aa0b58e1a1efbf1$export$1e576a20c3ce9fb5,
    ZodVoid: $6aa0b58e1a1efbf1$export$7d39f5df85f21031,
    ZodArray: $6aa0b58e1a1efbf1$export$7acfc3e64785411,
    ZodObject: $6aa0b58e1a1efbf1$export$736315c5b55efbad,
    ZodUnion: $6aa0b58e1a1efbf1$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $6aa0b58e1a1efbf1$export$5ef2424805ac76a3,
    ZodIntersection: $6aa0b58e1a1efbf1$export$c02deaf0bb5203d4,
    ZodTuple: $6aa0b58e1a1efbf1$export$e2a18bb771d8e6a3,
    ZodRecord: $6aa0b58e1a1efbf1$export$a2acc09968cb4b7f,
    ZodMap: $6aa0b58e1a1efbf1$export$163b6a2b712d9542,
    ZodSet: $6aa0b58e1a1efbf1$export$977057706f816712,
    ZodFunction: $6aa0b58e1a1efbf1$export$d4602ba55673f53c,
    ZodLazy: $6aa0b58e1a1efbf1$export$378d0cfce37406e6,
    ZodLiteral: $6aa0b58e1a1efbf1$export$7e44096782a165d3,
    ZodEnum: $6aa0b58e1a1efbf1$export$d325d1f0e1c20179,
    ZodNativeEnum: $6aa0b58e1a1efbf1$export$370b2e8d6d6f5c56,
    ZodPromise: $6aa0b58e1a1efbf1$export$3f196b0127d6e50a,
    ZodEffects: $6aa0b58e1a1efbf1$export$a60af00cc0ce2582,
    ZodTransformer: $6aa0b58e1a1efbf1$export$a60af00cc0ce2582,
    ZodOptional: $6aa0b58e1a1efbf1$export$aa56fec1e9d629b8,
    ZodNullable: $6aa0b58e1a1efbf1$export$aaac0b8b429cef5,
    ZodDefault: $6aa0b58e1a1efbf1$export$bb19b37874861e7e,
    ZodCatch: $6aa0b58e1a1efbf1$export$75a44ec6249ac76b,
    ZodNaN: $6aa0b58e1a1efbf1$export$26ccfa0145e8511f,
    BRAND: $6aa0b58e1a1efbf1$export$cf2deea74cde46b4,
    ZodBranded: $6aa0b58e1a1efbf1$export$66b0c798a395271f,
    ZodPipeline: $6aa0b58e1a1efbf1$export$a3c3ef8a0e95c6da,
    ZodReadonly: $6aa0b58e1a1efbf1$export$5d1f7ef05c4e493a,
    custom: $6aa0b58e1a1efbf1$export$4c00f665f0d4b443,
    Schema: $6aa0b58e1a1efbf1$export$19342e026b58ebb7,
    ZodSchema: $6aa0b58e1a1efbf1$export$19342e026b58ebb7,
    late: $6aa0b58e1a1efbf1$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $6aa0b58e1a1efbf1$export$558106ce543bd011;
    },
    coerce: $6aa0b58e1a1efbf1$export$8c14e57e778d3873,
    any: $6aa0b58e1a1efbf1$export$4154a199d7d90455,
    array: $6aa0b58e1a1efbf1$export$2f23118c22fb2630,
    bigint: $6aa0b58e1a1efbf1$export$a0f65b52274bcc00,
    boolean: $6aa0b58e1a1efbf1$export$4a21f16c33752377,
    date: $6aa0b58e1a1efbf1$export$324d90190a8b822a,
    discriminatedUnion: $6aa0b58e1a1efbf1$export$4b888e40c4ee26dd,
    effect: $6aa0b58e1a1efbf1$export$dc573d8a6576cdb3,
    'enum': $6aa0b58e1a1efbf1$export$78a99c8d44d72635,
    'function': $6aa0b58e1a1efbf1$export$44e51c8aac7c2deb,
    'instanceof': $6aa0b58e1a1efbf1$export$3d916e7c22dbd8b5,
    intersection: $6aa0b58e1a1efbf1$export$bc86dfbf7795668c,
    lazy: $6aa0b58e1a1efbf1$export$488013bae63b21da,
    literal: $6aa0b58e1a1efbf1$export$c8ec6e1ec9fefcb0,
    map: $6aa0b58e1a1efbf1$export$871de8747c9eaa88,
    nan: $6aa0b58e1a1efbf1$export$9e06de0973666692,
    nativeEnum: $6aa0b58e1a1efbf1$export$6fe7eca19ebe5199,
    never: $6aa0b58e1a1efbf1$export$b3e22bcfd64c1022,
    'null': $6aa0b58e1a1efbf1$export$7b1b591b262c240,
    nullable: $6aa0b58e1a1efbf1$export$133fc36489ac9add,
    number: $6aa0b58e1a1efbf1$export$98e628dec113755e,
    object: $6aa0b58e1a1efbf1$export$be5493f9613cbbe,
    oboolean: $6aa0b58e1a1efbf1$export$269251733cdcbbf1,
    onumber: $6aa0b58e1a1efbf1$export$eb150471a61fced6,
    optional: $6aa0b58e1a1efbf1$export$516e28dec6a4b6d4,
    ostring: $6aa0b58e1a1efbf1$export$3b3d07727c5b702c,
    pipeline: $6aa0b58e1a1efbf1$export$43f28b24e1eb8181,
    preprocess: $6aa0b58e1a1efbf1$export$fc37fe19dfda43ee,
    promise: $6aa0b58e1a1efbf1$export$c957ef27a0ebfd4,
    record: $6aa0b58e1a1efbf1$export$e5185e241753e543,
    set: $6aa0b58e1a1efbf1$export$adaa4cf7ef1b65be,
    strictObject: $6aa0b58e1a1efbf1$export$8fb0df5f40d0b477,
    string: $6aa0b58e1a1efbf1$export$22b082955e083ec3,
    symbol: $6aa0b58e1a1efbf1$export$8f701197936bc2a6,
    transformer: $6aa0b58e1a1efbf1$export$dc573d8a6576cdb3,
    tuple: $6aa0b58e1a1efbf1$export$65e3907585753458,
    'undefined': $6aa0b58e1a1efbf1$export$1db45310990710a5,
    union: $6aa0b58e1a1efbf1$export$971dd5b0dfd021b6,
    unknown: $6aa0b58e1a1efbf1$export$19282c40b967aec6,
    'void': $6aa0b58e1a1efbf1$export$490e536ee7389aeb,
    NEVER: $6aa0b58e1a1efbf1$export$96c94437c95d7862,
    ZodIssueCode: $6aa0b58e1a1efbf1$export$5ba560653e4a1035,
    quotelessJson: $6aa0b58e1a1efbf1$export$913eddeaf297cfea,
    ZodError: $6aa0b58e1a1efbf1$export$f98dac4b251ab333
});

});


parcelRegister("a7WSl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $929a7719d4d1be59$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $f18bP = parcelRequire("f18bP");
const $929a7719d4d1be59$var$ValidatedForm = /*#__PURE__*/ (0, $dvPqk.forwardRef)(({ children: children, onSubmit: onSubmit, ...props }, ref)=>{
    const [formValues, setFormValues] = (0, $dvPqk.useState)({});
    const [initialValues, setInitialValues] = (0, $dvPqk.useState)({});
    const [isFormValid, setIsFormValid] = (0, $dvPqk.useState)(true);
    //this function is passed to the children components and updates the formValues state here
    const updateFormValues = (value)=>{
        setFormValues((prevFormValues)=>{
            const formvalue = prevFormValues[value.name];
            if (formvalue) {
                const updatedFormValues = {
                    ...prevFormValues,
                    [value.name]: value
                };
                return updatedFormValues;
            }
            return prevFormValues;
        });
    };
    const registerField = (value)=>{
        setFormValues((prevFormValues)=>{
            const formvalue = prevFormValues[value.name];
            if (formvalue) throw new Error(`Field with name ${value.name} already exists. Field names must be unique`);
            const updatedFormValues = {
                ...prevFormValues,
                [value.name]: value
            };
            return updatedFormValues;
        });
        setInitialValues((prevInitial)=>({
                ...prevInitial,
                [value.name]: prevInitial[value.name] ?? value
            }));
    };
    const unregisterField = (name)=>{
        setFormValues((prevFormValues)=>{
            const formvalue = prevFormValues[name];
            if (formvalue) {
                const updatedFormValues = {
                    ...prevFormValues
                };
                delete updatedFormValues[name];
                return updatedFormValues;
            }
            return prevFormValues;
        });
    };
    const validateForm = ()=>{
        const hasErrors = Object.values(formValues).some((value)=>value.error !== "");
        setIsFormValid(!hasErrors);
        return !hasErrors;
    };
    const resetForm = ()=>{
        setFormValues(initialValues);
    };
    const submitform = async (e)=>{
        e.preventDefault();
        if (!validateForm()) return;
        const formValuestoSubmit = {};
        for (const value of Object.values(formValues))formValuestoSubmit[value.name] = value.value;
        const result = await onSubmit(formValuestoSubmit);
        if (result.resetFormFields) resetForm();
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)("form", {
        onSubmit: submitform,
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f18bP.FormContext).Provider, {
            value: {
                updateFormValues: updateFormValues,
                registerField: registerField,
                unregisterField: unregisterField,
                formValues: formValues,
                isFormValid: isFormValid
            },
            children: children
        })
    });
});
var $929a7719d4d1be59$export$2e2bcd8739ae039 = $929a7719d4d1be59$var$ValidatedForm;

});
parcelRegister("f18bP", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $e1ecfa955cc6c66c$export$c24727297075ec6a; });

var $dvPqk = parcelRequire("dvPqk");
const $e1ecfa955cc6c66c$export$c24727297075ec6a = /*#__PURE__*/ (0, $dvPqk.createContext)({
    updateFormValues: (_value)=>{},
    registerField: (_value)=>{},
    unregisterField: (_value)=>{},
    isFormValid: true,
    formValues: {}
});

});


parcelRegister("6Fwsu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c4bb798f0625e82$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3SASj = parcelRequire("3SASj");

var $dvPqk = parcelRequire("dvPqk");

var $f18bP = parcelRequire("f18bP");

var $3Uk2n = parcelRequire("3Uk2n");

var $4xmiN = parcelRequire("4xmiN");

var $8qXJp = parcelRequire("8qXJp");
const $2c4bb798f0625e82$var$ValidatedInput = ({ initialValue: initialValue, validator: validator = (0, $3Uk2n.validateNotEmpty), label: label, name: name, type: type = "text", required: required = false, ...inputProps })=>{
    const [showError, setShowError] = (0, $dvPqk.useState)(false);
    const { updateFormValues: updateFormValues, formValues: formValues } = (0, $dvPqk.useContext)((0, $f18bP.FormContext));
    const hasMoreThanOneField = Object.keys(formValues).length > 1;
    const handleChange = (e)=>{
        const { value: value } = e.target;
        setShowError(false);
        updateFormValues({
            ...formValues[name],
            value: value,
            error: validator(value, required)
        });
    };
    const handleBlur = (e)=>{
        const { value: value } = e.target;
        const error = validator(value, required);
        setShowError(!!error);
        updateFormValues({
            ...formValues[name],
            value: value,
            error: validator(value, required)
        });
    };
    (0, $8qXJp.default)(name, initialValue, validator, required);
    (0, $4xmiN.default)(setShowError, validator, name, required);
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
        ...inputProps,
        value: formValues[name]?.value || "",
        name: name,
        type: type,
        label: required && hasMoreThanOneField ? `${label} *` : label,
        onFocus: ()=>setShowError(false),
        onChange: handleChange,
        onBlur: handleBlur,
        errorMessage: formValues[name]?.error,
        showErrorMessage: showError
    });
};
var $2c4bb798f0625e82$export$2e2bcd8739ae039 = $2c4bb798f0625e82$var$ValidatedInput;

});
parcelRegister("4xmiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $395a85e2fd6b75ab$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");

var $f18bP = parcelRequire("f18bP");
// Create a placeholder FormContext (replace with your actual form context)
/**
 * Custom hook to manage error visibility based on form validity from context.
 * @param {Function} setShowError - Function to update error visibility.
 */ const $395a85e2fd6b75ab$var$useFormError = (setShowError, validator, name, required)=>{
    const { isFormValid: isFormValid, formValues: formValues } = (0, $dvPqk.useContext)((0, $f18bP.FormContext)); // Access formValid from context
    const isInitialRender = (0, $dvPqk.useRef)(true); // Ref to track initial render
    (0, $dvPqk.useEffect)(()=>{
        if (isInitialRender.current) {
            isInitialRender.current = false; // Mark initial render as complete
            return; // Skip the effect logic on the initial render
        }
        // Update `setShowError` when `formValid` changes
        if (!isFormValid) setShowError((_c)=>{
            return !!validator(formValues[name].value, required);
        });
    }, [
        isFormValid
    ]);
};
var $395a85e2fd6b75ab$export$2e2bcd8739ae039 = $395a85e2fd6b75ab$var$useFormError;

});

parcelRegister("8qXJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d94ef8b6d2c90888$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");

var $f18bP = parcelRequire("f18bP");
const $d94ef8b6d2c90888$var$useRegisterfield = (name, initialValue, validator, required)=>{
    const { registerField: registerField, unregisterField: unregisterField } = (0, $dvPqk.useContext)((0, $f18bP.FormContext));
    (0, $dvPqk.useEffect)(()=>{
        registerField({
            name: name,
            value: initialValue,
            error: validator(initialValue, required)
        });
        return ()=>{
            unregisterField(name);
        };
    }, []);
};
var $d94ef8b6d2c90888$export$2e2bcd8739ae039 = $d94ef8b6d2c90888$var$useRegisterfield;

});




parcelRegister("kNMWS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fe6690390c54bb2$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lgHX0 = parcelRequire("lgHX0");

var $izjX7 = parcelRequire("izjX7");

var $65KWP = parcelRequire("65KWP");

var $isIf6 = parcelRequire("isIf6");

var $cLfby = parcelRequire("cLfby");
const $7fe6690390c54bb2$var$TextAndYoutube = ({ content: content })=>{
    const { fields: fields } = content;
    const { text: text, videoPosition: videoPosition, ...fieldsWithoutTextAndPosition } = fields;
    const { youtubeId: youtubeId } = fieldsWithoutTextAndPosition;
    const videoContent = {
        fields: fieldsWithoutTextAndPosition,
        metadata: content.metadata,
        sys: content.sys
    };
    const className = (0, $izjX7.cn)("flex flex-col items-center justify-center gap-6", "lg:flex-row lg:items-start", {
        "lg:flex-row": videoPosition === "Left",
        "lg:flex-row-reverse": videoPosition === "Right"
    });
    const childClassName = "lg:w-1/2";
    const videoClassName = (0, $izjX7.cn)(childClassName, "lg:pt-1");
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: videoClassName,
                children: !!youtubeId && /*#__PURE__*/ (0, $7YWoO.jsx)($7fe6690390c54bb2$var$CmsYoutubeContent, {
                    content: videoContent
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: childClassName,
                children: !!text && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLfby.default), {
                    document: text,
                    context: "youtube"
                })
            })
        ]
    });
};
const $7fe6690390c54bb2$var$CmsYoutubeContent = ({ content: content })=>{
    const { image: image, youtubeId: youtubeId } = content.fields;
    let poster;
    if (image) {
        const imageData = (0, $65KWP.fromContentToImageWithFocus)(image);
        poster = imageData ? (0, $65KWP.createCloudinaryUrl)(imageData, 1250, Math.round(703.125), (0, $isIf6.default).contentImages.cloudinaryMapping) : "";
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lgHX0.VideoPlayer), {
        videoId: youtubeId,
        poster: poster
    });
};
const $7fe6690390c54bb2$var$CmsYoutube = ({ content: content })=>{
    const { text: text, videoPosition: videoPosition } = content.fields;
    if (text && videoPosition) return /*#__PURE__*/ (0, $7YWoO.jsx)($7fe6690390c54bb2$var$TextAndYoutube, {
        content: content
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "lg:mx-auto max-w-4xl",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)($7fe6690390c54bb2$var$CmsYoutubeContent, {
            content: content
        })
    });
};
var $7fe6690390c54bb2$export$2e2bcd8739ae039 = $7fe6690390c54bb2$var$CmsYoutube;

});
parcelRegister("lgHX0", function(module, exports) {

$parcel$export(module.exports, "VideoPlayer", function () { return $f7bd2f497ab3d6ed$export$f503bc85d719e8b0; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $41vNj = parcelRequire("41vNj");

var $7BC0a = parcelRequire("7BC0a");

var $ai6sm = parcelRequire("ai6sm");

var $cGjF4 = parcelRequire("cGjF4");

var $fqmDC = parcelRequire("fqmDC");
function $f7bd2f497ab3d6ed$export$f503bc85d719e8b0({ videoId: s, poster: c, width: l = "100%" }) {
    const { playerRef: t, isPlaying: u, hasStarted: d, duration: p, currentTime: v, isLoading: b, loadedFraction: w, playButtonText: m, handleReady: P, handleStateChange: k, seekTo: E, startSeeking: x, seekWhileDragging: S, endSeeking: L } = (0, $7BC0a.useYouTubePlayer)(), [a, N] = (0, $dvPqk.useState)(!1), [g, V] = (0, $dvPqk.useState)({
        isIPhone: !1
    }), [F, I] = (0, $dvPqk.useState)(!1);
    (0, $dvPqk.useEffect)(()=>{
        if (I(!0), window != null && window.navigator) {
            const e = window.navigator.userAgent;
            V({
                isIPhone: e.includes("iPhone")
            });
        }
    }, []), (0, $dvPqk.useEffect)(()=>{
        const e = ()=>{
            const B = !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement || document.mozFullScreenElement);
            N(B);
        };
        return document.addEventListener("fullscreenchange", e), document.addEventListener("webkitfullscreenchange", e), document.addEventListener("msfullscreenchange", e), document.addEventListener("mozfullscreenchange", e), ()=>{
            document.removeEventListener("fullscreenchange", e), document.removeEventListener("webkitfullscreenchange", e), document.removeEventListener("msfullscreenchange", e), document.removeEventListener("mozfullscreenchange", e);
        };
    }, []);
    const z = ()=>{
        t.current && (u ? t.current.pauseVideo() : t.current.playVideo());
    }, T = ()=>{
        t.current && (g.isIPhone && t.current.loadVideoById({
            videoId: s,
            startSeconds: 0
        }), setTimeout(()=>{
            var e;
            (e = t.current) == null || e.playVideo();
        }, 100));
    }, f = !!(c && !d);
    return F ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        "aria-label": "Video player",
        className: (0, $6sMuH.cn)("video-player-container mx-auto w-full max-w-4xl", a && "fixed inset-0 max-w-none bg-black m-0 flex items-center justify-center"),
        role: "region",
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
            className: (0, $6sMuH.cn)("relative overflow-hidden bg-black", d ? "rounded-t-lg" : "rounded-lg", a && "rounded-none"),
            style: {
                width: typeof l == "number" ? `${l}px` : l
            },
            children: [
                /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                    className: "relative",
                    style: {
                        paddingBottom: "56.25%"
                    },
                    children: [
                        f ? /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                            className: "absolute inset-0 z-20 -mb-11 bg-black",
                            children: [
                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    "aria-label": "Video thumbnail image",
                                    className: "absolute inset-0 bg-cover bg-center",
                                    role: "img",
                                    style: {
                                        backgroundImage: `url(${c})`
                                    }
                                }),
                                /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                    "aria-label": `Play video: ${m}`,
                                    className: "absolute bottom-7 left-6 z-20",
                                    icon: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fqmDC.default), {}),
                                    iconPosition: "left",
                                    onClick: T,
                                    size: "regular",
                                    variant: "primary",
                                    children: m
                                })
                            ]
                        }) : null,
                        /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                            className: (0, $6sMuH.cn)("absolute inset-0 z-10", f ? "invisible" : ""),
                            children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $41vNj.default), {
                                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                allowFullScreen: !0,
                                className: "absolute inset-0 w-full h-full",
                                onReady: P,
                                onStateChange: k,
                                opts: {
                                    width: "100%",
                                    height: "100%",
                                    playerVars: {
                                        autoplay: 0,
                                        controls: 0,
                                        modestbranding: 1,
                                        rel: 0,
                                        fs: 1,
                                        playsinline: g.isIPhone ? 0 : 1,
                                        // Iphone don't support fullscreen, so we need to use the native player controls
                                        enablejsapi: 1,
                                        showinfo: 0,
                                        iv_load_policy: 3
                                    }
                                },
                                title: "YouTube video player",
                                videoId: s
                            })
                        }),
                        b ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                            "aria-label": "Loading video",
                            className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                            role: "status",
                            children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                "aria-label": "Loading",
                                loading: !0,
                                size: "iconOnly",
                                variant: "primary"
                            })
                        }) : null
                    ]
                }),
                /* @__PURE__ */ (0, $7YWoO.jsx)((0, $ai6sm.VideoControls), {
                    currentTime: v,
                    duration: p,
                    isFullscreen: a,
                    isPlaying: u,
                    loadedFraction: w,
                    onDragEnd: L,
                    onDragStart: x,
                    onDragging: S,
                    onPlayPause: z,
                    onSeek: E,
                    player: t.current
                })
            ]
        })
    }) : /* @__PURE__ */ (0, $7YWoO.jsx)("div", {});
}
$f7bd2f497ab3d6ed$export$f503bc85d719e8b0.displayName = "VideoPlayer";

});
parcelRegister("41vNj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2edfeb1ddf38b862$export$2e2bcd8739ae039; });

var $bdLDo = parcelRequire("bdLDo");

var $dvPqk = parcelRequire("dvPqk");

var $lKBCu = parcelRequire("lKBCu");

var $d37n1 = parcelRequire("d37n1");
var $2edfeb1ddf38b862$var$m = Object.defineProperty, $2edfeb1ddf38b862$var$C = Object.defineProperties, $2edfeb1ddf38b862$var$E = Object.getOwnPropertyDescriptors, $2edfeb1ddf38b862$var$f = Object.getOwnPropertySymbols, $2edfeb1ddf38b862$var$I = Object.prototype.hasOwnProperty, $2edfeb1ddf38b862$var$N = Object.prototype.propertyIsEnumerable, $2edfeb1ddf38b862$var$v = (r, e, t)=>e in r ? $2edfeb1ddf38b862$var$m(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $2edfeb1ddf38b862$var$c = (r, e)=>{
    for(var t in e || (e = {}))$2edfeb1ddf38b862$var$I.call(e, t) && $2edfeb1ddf38b862$var$v(r, t, e[t]);
    if ($2edfeb1ddf38b862$var$f) for (var t of $2edfeb1ddf38b862$var$f(e))$2edfeb1ddf38b862$var$N.call(e, t) && $2edfeb1ddf38b862$var$v(r, t, e[t]);
    return r;
}, $2edfeb1ddf38b862$var$P = (r, e)=>$2edfeb1ddf38b862$var$C(r, $2edfeb1ddf38b862$var$E(e)), $2edfeb1ddf38b862$var$A = (r, e, t)=>new Promise((a, i)=>{
        var o = (l)=>{
            try {
                p(t.next(l));
            } catch (h) {
                i(h);
            }
        }, n = (l)=>{
            try {
                p(t.throw(l));
            } catch (h) {
                i(h);
            }
        }, p = (l)=>l.done ? a(l.value) : Promise.resolve(l.value).then(o, n);
        p((t = t.apply(r, e)).next());
    });
function $2edfeb1ddf38b862$var$S(r, e) {
    var t, a;
    if (r.videoId !== e.videoId) return !0;
    const i = ((t = r.opts) == null ? void 0 : t.playerVars) || {}, o = ((a = e.opts) == null ? void 0 : a.playerVars) || {};
    return i.start !== o.start || i.end !== o.end;
}
function $2edfeb1ddf38b862$var$_(r = {}) {
    return $2edfeb1ddf38b862$var$P($2edfeb1ddf38b862$var$c({}, r), {
        height: 0,
        width: 0,
        playerVars: $2edfeb1ddf38b862$var$P($2edfeb1ddf38b862$var$c({}, r.playerVars), {
            autoplay: 0,
            start: 0,
            end: 0
        })
    });
}
function $2edfeb1ddf38b862$var$V(r, e) {
    return r.videoId !== e.videoId || !(0, $lKBCu.default)($2edfeb1ddf38b862$var$_(r.opts), $2edfeb1ddf38b862$var$_(e.opts));
}
function $2edfeb1ddf38b862$var$w(r, e) {
    var t, a, i, o;
    return r.id !== e.id || r.className !== e.className || ((t = r.opts) == null ? void 0 : t.width) !== ((a = e.opts) == null ? void 0 : a.width) || ((i = r.opts) == null ? void 0 : i.height) !== ((o = e.opts) == null ? void 0 : o.height) || r.iframeClassName !== e.iframeClassName || r.title !== e.title;
}
var $2edfeb1ddf38b862$var$O = {
    videoId: "",
    id: "",
    className: "",
    iframeClassName: "",
    style: {},
    title: "",
    loading: void 0,
    opts: {},
    onReady: ()=>{},
    onError: ()=>{},
    onPlay: ()=>{},
    onPause: ()=>{},
    onEnd: ()=>{},
    onStateChange: ()=>{},
    onPlaybackRateChange: ()=>{},
    onPlaybackQualityChange: ()=>{}
}, $2edfeb1ddf38b862$var$R = {
    videoId: (0, $bdLDo.default).string,
    id: (0, $bdLDo.default).string,
    className: (0, $bdLDo.default).string,
    iframeClassName: (0, $bdLDo.default).string,
    style: (0, $bdLDo.default).object,
    title: (0, $bdLDo.default).string,
    loading: (0, $bdLDo.default).oneOf([
        "lazy",
        "eager"
    ]),
    opts: (0, $bdLDo.default).objectOf((0, $bdLDo.default).any),
    onReady: (0, $bdLDo.default).func,
    onError: (0, $bdLDo.default).func,
    onPlay: (0, $bdLDo.default).func,
    onPause: (0, $bdLDo.default).func,
    onEnd: (0, $bdLDo.default).func,
    onStateChange: (0, $bdLDo.default).func,
    onPlaybackRateChange: (0, $bdLDo.default).func,
    onPlaybackQualityChange: (0, $bdLDo.default).func
}, $2edfeb1ddf38b862$var$d = class extends (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Component {
    constructor(r){
        super(r), this.destroyPlayerPromise = void 0, this.onPlayerReady = (e)=>{
            var t, a;
            return (a = (t = this.props).onReady) == null ? void 0 : a.call(t, e);
        }, this.onPlayerError = (e)=>{
            var t, a;
            return (a = (t = this.props).onError) == null ? void 0 : a.call(t, e);
        }, this.onPlayerStateChange = (e)=>{
            var t, a, i, o, n, p, l, h;
            switch((a = (t = this.props).onStateChange) == null || a.call(t, e), e.data){
                case $2edfeb1ddf38b862$var$d.PlayerState.ENDED:
                    (o = (i = this.props).onEnd) == null || o.call(i, e);
                    break;
                case $2edfeb1ddf38b862$var$d.PlayerState.PLAYING:
                    (p = (n = this.props).onPlay) == null || p.call(n, e);
                    break;
                case $2edfeb1ddf38b862$var$d.PlayerState.PAUSED:
                    (h = (l = this.props).onPause) == null || h.call(l, e);
                    break;
            }
        }, this.onPlayerPlaybackRateChange = (e)=>{
            var t, a;
            return (a = (t = this.props).onPlaybackRateChange) == null ? void 0 : a.call(t, e);
        }, this.onPlayerPlaybackQualityChange = (e)=>{
            var t, a;
            return (a = (t = this.props).onPlaybackQualityChange) == null ? void 0 : a.call(t, e);
        }, this.destroyPlayer = ()=>this.internalPlayer ? (this.destroyPlayerPromise = this.internalPlayer.destroy().then(()=>this.destroyPlayerPromise = void 0), this.destroyPlayerPromise) : Promise.resolve(), this.createPlayer = ()=>{
            if (typeof document > "u") return;
            if (this.destroyPlayerPromise) {
                this.destroyPlayerPromise.then(this.createPlayer);
                return;
            }
            const e = $2edfeb1ddf38b862$var$P($2edfeb1ddf38b862$var$c({}, this.props.opts), {
                videoId: this.props.videoId
            });
            this.internalPlayer = (0, $d37n1.default)(this.container, e), this.internalPlayer.on("ready", this.onPlayerReady), this.internalPlayer.on("error", this.onPlayerError), this.internalPlayer.on("stateChange", this.onPlayerStateChange), this.internalPlayer.on("playbackRateChange", this.onPlayerPlaybackRateChange), this.internalPlayer.on("playbackQualityChange", this.onPlayerPlaybackQualityChange), (this.props.title || this.props.loading) && this.internalPlayer.getIframe().then((t)=>{
                this.props.title && t.setAttribute("title", this.props.title), this.props.loading && t.setAttribute("loading", this.props.loading);
            });
        }, this.resetPlayer = ()=>this.destroyPlayer().then(this.createPlayer), this.updatePlayer = ()=>{
            var e;
            (e = this.internalPlayer) == null || e.getIframe().then((t)=>{
                this.props.id ? t.setAttribute("id", this.props.id) : t.removeAttribute("id"), this.props.iframeClassName ? t.setAttribute("class", this.props.iframeClassName) : t.removeAttribute("class"), this.props.opts && this.props.opts.width ? t.setAttribute("width", this.props.opts.width.toString()) : t.removeAttribute("width"), this.props.opts && this.props.opts.height ? t.setAttribute("height", this.props.opts.height.toString()) : t.removeAttribute("height"), this.props.title ? t.setAttribute("title", this.props.title) : t.setAttribute("title", "YouTube video player"), this.props.loading ? t.setAttribute("loading", this.props.loading) : t.removeAttribute("loading");
            });
        }, this.getInternalPlayer = ()=>this.internalPlayer, this.updateVideo = ()=>{
            var e, t, a, i;
            if (typeof this.props.videoId > "u" || this.props.videoId === null) {
                (e = this.internalPlayer) == null || e.stopVideo();
                return;
            }
            let o = !1;
            const n = {
                videoId: this.props.videoId
            };
            if ((t = this.props.opts) != null && t.playerVars && (o = this.props.opts.playerVars.autoplay === 1, "start" in this.props.opts.playerVars && (n.startSeconds = this.props.opts.playerVars.start), "end" in this.props.opts.playerVars && (n.endSeconds = this.props.opts.playerVars.end)), o) {
                (a = this.internalPlayer) == null || a.loadVideoById(n);
                return;
            }
            (i = this.internalPlayer) == null || i.cueVideoById(n);
        }, this.refContainer = (e)=>{
            this.container = e;
        }, this.container = null, this.internalPlayer = null;
    }
    componentDidMount() {
        this.createPlayer();
    }
    componentDidUpdate(r) {
        return $2edfeb1ddf38b862$var$A(this, null, function*() {
            $2edfeb1ddf38b862$var$w(r, this.props) && this.updatePlayer(), $2edfeb1ddf38b862$var$V(r, this.props) && (yield this.resetPlayer()), $2edfeb1ddf38b862$var$S(r, this.props) && this.updateVideo();
        });
    }
    componentWillUnmount() {
        this.destroyPlayer();
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement("div", {
            className: this.props.className,
            style: this.props.style
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement("div", {
            id: this.props.id,
            className: this.props.iframeClassName,
            ref: this.refContainer
        }));
    }
}, $2edfeb1ddf38b862$var$y = $2edfeb1ddf38b862$var$d;
$2edfeb1ddf38b862$var$y.propTypes = $2edfeb1ddf38b862$var$R;
$2edfeb1ddf38b862$var$y.defaultProps = $2edfeb1ddf38b862$var$O;
$2edfeb1ddf38b862$var$y.PlayerState = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
};
var $2edfeb1ddf38b862$export$2e2bcd8739ae039 = $2edfeb1ddf38b862$var$y;

});
parcelRegister("bdLDo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82b5dbca1965e092$export$2e2bcd8739ae039; });

var $ehcVV = parcelRequire("ehcVV");

var $adYUx = parcelRequire("adYUx");



var $b0XQ4 = parcelRequire("b0XQ4");
var $82b5dbca1965e092$var$s, $82b5dbca1965e092$var$i;
(0, $adYUx.__module).exports = (0, $b0XQ4.__require)()();
var $82b5dbca1965e092$var$m = (0, $adYUx.__module).exports;
const $82b5dbca1965e092$export$2e2bcd8739ae039 = /* @__PURE__ */ (0, $ehcVV.getDefaultExportFromCjs)($82b5dbca1965e092$var$m);

});
parcelRegister("ehcVV", function(module, exports) {

$parcel$export(module.exports, "getDefaultExportFromCjs", function () { return $a64caf7f798de63b$export$22b09f878622677a; });
function $a64caf7f798de63b$export$22b09f878622677a(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

});

parcelRegister("adYUx", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $771a5de5f3deaab6$export$5edeffb658f039f4; });
var $771a5de5f3deaab6$export$5edeffb658f039f4 = {
    exports: {}
};

});

parcelRegister("b0XQ4", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $804e1c87fd19669b$export$b88c30a9414655a0; });

var $gtrea = parcelRequire("gtrea");
var $804e1c87fd19669b$var$o, $804e1c87fd19669b$var$p;
function $804e1c87fd19669b$export$b88c30a9414655a0() {
    if ($804e1c87fd19669b$var$p) return $804e1c87fd19669b$var$o;
    $804e1c87fd19669b$var$p = 1;
    var c = (0, $gtrea.__require)();
    function n() {}
    function i() {}
    return i.resetWarningCache = n, $804e1c87fd19669b$var$o = function() {
        function e(h, y, m, f, l, s) {
            if (s !== c) {
                var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw a.name = "Invariant Violation", a;
            }
        }
        e.isRequired = e;
        function r() {
            return e;
        }
        var t = {
            array: e,
            bigint: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: r,
            element: e,
            elementType: e,
            instanceOf: r,
            node: e,
            objectOf: r,
            oneOf: r,
            oneOfType: r,
            shape: r,
            exact: r,
            checkPropTypes: i,
            resetWarningCache: n
        };
        return t.PropTypes = t, t;
    }, $804e1c87fd19669b$var$o;
}

});
parcelRegister("gtrea", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $bfe479946450607d$export$b88c30a9414655a0; });
var $bfe479946450607d$var$e, $bfe479946450607d$var$r;
function $bfe479946450607d$export$b88c30a9414655a0() {
    if ($bfe479946450607d$var$r) return $bfe479946450607d$var$e;
    $bfe479946450607d$var$r = 1;
    var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    return $bfe479946450607d$var$e = t, $bfe479946450607d$var$e;
}

});



parcelRegister("lKBCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd5b135df639ce22$export$2e2bcd8739ae039; });

var $ehcVV = parcelRequire("ehcVV");
var $fd5b135df639ce22$var$c = function u(r, t) {
    if (r === t) return !0;
    if (r && t && typeof r == "object" && typeof t == "object") {
        if (r.constructor !== t.constructor) return !1;
        var f, e, o;
        if (Array.isArray(r)) {
            if (f = r.length, f != t.length) return !1;
            for(e = f; e-- !== 0;)if (!u(r[e], t[e])) return !1;
            return !0;
        }
        if (r.constructor === RegExp) return r.source === t.source && r.flags === t.flags;
        if (r.valueOf !== Object.prototype.valueOf) return r.valueOf() === t.valueOf();
        if (r.toString !== Object.prototype.toString) return r.toString() === t.toString();
        if (o = Object.keys(r), f = o.length, f !== Object.keys(t).length) return !1;
        for(e = f; e-- !== 0;)if (!Object.prototype.hasOwnProperty.call(t, o[e])) return !1;
        for(e = f; e-- !== 0;){
            var n = o[e];
            if (!u(r[n], t[n])) return !1;
        }
        return !0;
    }
    return r !== r && t !== t;
};
const $fd5b135df639ce22$export$2e2bcd8739ae039 = /* @__PURE__ */ (0, $ehcVV.getDefaultExportFromCjs)($fd5b135df639ce22$var$c);

});

parcelRegister("d37n1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $980145c48804ec79$export$2e2bcd8739ae039; });

var $ehcVV = parcelRequire("ehcVV");

var $6n4hZ = parcelRequire("6n4hZ");

var $5fX0w = parcelRequire("5fX0w");

var $6uirF = parcelRequire("6uirF");

var $KZsuI = parcelRequire("KZsuI");
(function(l, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
        return typeof e;
    } : function(e) {
        return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, y = (0, $5fX0w.s), d = o(y), v = (0, $6uirF.l), m = o(v), c = (0, $KZsuI.Y), i = o(c);
    function o(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    var n = void 0;
    t.default = function(e) {
        var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = (0, d.default)();
        if (n || (n = (0, m.default)(r)), u.events) throw new Error("Event handlers cannot be overwritten.");
        if (typeof e == "string" && !document.getElementById(e)) throw new Error('Element "' + e + '" does not exist.');
        u.events = i.default.proxyEvents(r);
        var g = new Promise(function(s) {
            if ((typeof e > "u" ? "undefined" : p(e)) === "object" && e.playVideo instanceof Function) {
                var P = e;
                s(P);
            } else n.then(function(x) {
                var w = new x.Player(e, u);
                return r.on("ready", function() {
                    s(w);
                }), null;
            });
        }), a = i.default.promisifyPlayer(g, _);
        return a.on = r.on, a.off = r.off, a;
    }, l.exports = t.default;
})((0, $6n4hZ.__module), (0, $6n4hZ.__module).exports);
var $980145c48804ec79$var$S = (0, $6n4hZ.__module).exports;
const $980145c48804ec79$export$2e2bcd8739ae039 = /* @__PURE__ */ (0, $ehcVV.getDefaultExportFromCjs)($980145c48804ec79$var$S);

});
parcelRegister("6n4hZ", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $4a3837d0cef3d12e$export$5edeffb658f039f4; });
var $4a3837d0cef3d12e$export$5edeffb658f039f4 = {
    exports: {}
};

});

parcelRegister("5fX0w", function(module, exports) {

$parcel$export(module.exports, "s", function () { return $3d3c20161c802f33$export$2408f22a0fab9ae5; });
var $3d3c20161c802f33$var$f;
/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/ $3d3c20161c802f33$var$f = function() {
    var t = {}, r = {};
    return t.on = function(n, e) {
        var i = {
            name: n,
            handler: e
        };
        return r[n] = r[n] || [], r[n].unshift(i), i;
    }, t.off = function(n) {
        var e = r[n.name].indexOf(n);
        e !== -1 && r[n.name].splice(e, 1);
    }, t.trigger = function(n, e) {
        var i = r[n], s;
        if (i) for(s = i.length; s--;)i[s].handler(e);
    }, t;
};
var $3d3c20161c802f33$export$2408f22a0fab9ae5 = $3d3c20161c802f33$var$f;

});

parcelRegister("6uirF", function(module, exports) {

$parcel$export(module.exports, "l", function () { return $4b93da434d4001f1$export$882b5998b3b9117c; });

var $fXT1q = parcelRequire("fXT1q");

var $bhOsn = parcelRequire("bhOsn");
(function(n, o) {
    Object.defineProperty(o, "__esModule", {
        value: !0
    });
    var u = (0, $bhOsn.l), d = f(u);
    function f(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    o.default = function(e) {
        var l = new Promise(function(t) {
            if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
                t(window.YT);
                return;
            } else {
                var w = window.location.protocol === "http:" ? "http:" : "https:";
                (0, d.default)(w + "//www.youtube.com/iframe_api", function(a) {
                    a && e.trigger("error", a);
                });
            }
            var i = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function() {
                i && i(), t(window.YT);
            };
        });
        return l;
    }, n.exports = o.default;
})((0, $fXT1q.__module), (0, $fXT1q.__module).exports);
var $4b93da434d4001f1$export$882b5998b3b9117c = (0, $fXT1q.__module).exports;

});
parcelRegister("fXT1q", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $b9f70befc80a5e85$export$5edeffb658f039f4; });
var $b9f70befc80a5e85$export$5edeffb658f039f4 = {
    exports: {}
};

});

parcelRegister("bhOsn", function(module, exports) {

$parcel$export(module.exports, "l", function () { return $83786bdefd1b1977$export$882b5998b3b9117c; });
var $83786bdefd1b1977$export$882b5998b3b9117c = function(a, n, r) {
    var o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("script");
    typeof n == "function" && (r = n, n = {}), n = n || {}, r = r || function() {}, e.type = n.type || "text/javascript", e.charset = n.charset || "utf8", e.async = "async" in n ? !!n.async : !0, e.src = a, n.attrs && $83786bdefd1b1977$var$l(e, n.attrs), n.text && (e.text = "" + n.text);
    var d = "onload" in e ? $83786bdefd1b1977$var$i : $83786bdefd1b1977$var$u;
    d(e, r), e.onload || $83786bdefd1b1977$var$i(e, r), o.appendChild(e);
};
function $83786bdefd1b1977$var$l(t, a) {
    for(var n in a)t.setAttribute(n, a[n]);
}
function $83786bdefd1b1977$var$i(t, a) {
    t.onload = function() {
        this.onerror = this.onload = null, a(null, t);
    }, t.onerror = function() {
        this.onerror = this.onload = null, a(new Error("Failed to load " + this.src), t);
    };
}
function $83786bdefd1b1977$var$u(t, a) {
    t.onreadystatechange = function() {
        this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, a(null, t));
    };
}

});


parcelRegister("KZsuI", function(module, exports) {

$parcel$export(module.exports, "Y", function () { return $08d3f86329f72faa$export$8743009a87fcb00f; });

var $4ZvnN = parcelRequire("4ZvnN");

var $4Hkgp = parcelRequire("4Hkgp");

var $aV7Cz = parcelRequire("aV7Cz");

var $e694T = parcelRequire("e694T");

var $2abqa = parcelRequire("2abqa");
(function(A, S) {
    Object.defineProperty(S, "__esModule", {
        value: !0
    });
    var M = (0, $4Hkgp.b), T = d(M), w = (0, $aV7Cz.f), F = d(w), Y = (0, $e694T.e), L = d(Y), O = (0, $2abqa.F), E = d(O);
    function d(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    }
    var q = (0, T.default)("youtube-player"), h = {};
    h.proxyEvents = function(t) {
        var p = {}, s = function(l) {
            var e = "on" + l.slice(0, 1).toUpperCase() + l.slice(1);
            p[e] = function(n) {
                q('event "%s"', e, n), t.trigger(l, n);
            };
        }, v = !0, u = !1, c = void 0;
        try {
            for(var i = L.default[Symbol.iterator](), f; !(v = (f = i.next()).done); v = !0){
                var g = f.value;
                s(g);
            }
        } catch (y) {
            u = !0, c = y;
        } finally{
            try {
                !v && i.return && i.return();
            } finally{
                if (u) throw c;
            }
        }
        return p;
    }, h.promisifyPlayer = function(t) {
        var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = {}, v = function(e) {
            p && E.default[e] ? s[e] = function() {
                for(var n = arguments.length, m = Array(n), a = 0; a < n; a++)m[a] = arguments[a];
                return t.then(function(r) {
                    var o = E.default[e], I = r.getPlayerState(), x = r[e].apply(r, m);
                    return o.stateChangeRequired || // eslint-disable-next-line no-extra-parens
                    Array.isArray(o.acceptableStates) && o.acceptableStates.indexOf(I) === -1 ? new Promise(function(_) {
                        var N = function C() {
                            var D = r.getPlayerState(), P = void 0;
                            typeof o.timeout == "number" && (P = setTimeout(function() {
                                r.removeEventListener("onStateChange", C), _();
                            }, o.timeout)), Array.isArray(o.acceptableStates) && o.acceptableStates.indexOf(D) !== -1 && (r.removeEventListener("onStateChange", C), clearTimeout(P), _());
                        };
                        r.addEventListener("onStateChange", N);
                    }).then(function() {
                        return x;
                    }) : x;
                });
            } : s[e] = function() {
                for(var n = arguments.length, m = Array(n), a = 0; a < n; a++)m[a] = arguments[a];
                return t.then(function(r) {
                    return r[e].apply(r, m);
                });
            };
        }, u = !0, c = !1, i = void 0;
        try {
            for(var f = F.default[Symbol.iterator](), g; !(u = (g = f.next()).done); u = !0){
                var y = g.value;
                v(y);
            }
        } catch (l) {
            c = !0, i = l;
        } finally{
            try {
                !u && f.return && f.return();
            } finally{
                if (c) throw i;
            }
        }
        return s;
    }, S.default = h, A.exports = S.default;
})((0, $4ZvnN.__module), (0, $4ZvnN.__module).exports);
var $08d3f86329f72faa$export$8743009a87fcb00f = (0, $4ZvnN.__module).exports;

});
parcelRegister("4ZvnN", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $3a2533e34332c211$export$5edeffb658f039f4; });
var $3a2533e34332c211$export$5edeffb658f039f4 = {
    exports: {}
};

});

parcelRegister("4Hkgp", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $36bae58424c15f53$export$8b22cf2602fb60ce; });

var $ho4Sq = parcelRequire("ho4Sq");

var $buWEr = parcelRequire("buWEr");
(function(u, o) {
    o = u.exports = (0, $buWEr.d), o.log = f, o.formatArgs = l, o.save = g, o.load = t, o.useColors = d, o.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : m(), o.colors = [
        "lightseagreen",
        "forestgreen",
        "goldenrod",
        "dodgerblue",
        "darkorchid",
        "crimson"
    ];
    function d() {
        return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
        typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
        typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
        typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    o.formatters.j = function(e) {
        try {
            return JSON.stringify(e);
        } catch (n) {
            return "[UnexpectedJSONParseError]: " + n.message;
        }
    };
    function l(e) {
        var n = this.useColors;
        if (e[0] = (n ? "%c" : "") + this.namespace + (n ? " %c" : " ") + e[0] + (n ? "%c " : " ") + "+" + o.humanize(this.diff), !!n) {
            var c = "color: " + this.color;
            e.splice(1, 0, c, "color: inherit");
            var i = 0, a = 0;
            e[0].replace(/%[a-zA-Z%]/g, function(s) {
                s !== "%%" && (i++, s === "%c" && (a = i));
            }), e.splice(a, 0, c);
        }
    }
    function f() {
        return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function g(e) {
        try {
            e == null ? o.storage.removeItem("debug") : o.storage.debug = e;
        } catch  {}
    }
    function t() {
        var e;
        try {
            e = o.storage.debug;
        } catch  {}
        return e, e;
    }
    o.enable(t());
    function m() {
        try {
            return window.localStorage;
        } catch  {}
    }
})((0, $ho4Sq.__module), (0, $ho4Sq.__module).exports);
var $36bae58424c15f53$export$8b22cf2602fb60ce = (0, $ho4Sq.__module).exports;

});
parcelRegister("ho4Sq", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $ca8875fc8bd4f25f$export$5edeffb658f039f4; });
var $ca8875fc8bd4f25f$export$5edeffb658f039f4 = {
    exports: {}
};

});

parcelRegister("buWEr", function(module, exports) {

$parcel$export(module.exports, "d", function () { return $85effdff89b6c36a$export$4368d992c4eafac0; });

var $gfoAg = parcelRequire("gfoAg");

var $ke54k = parcelRequire("ke54k");
(function(b, n) {
    n = b.exports = g.debug = g.default = g, n.coerce = k, n.disable = h, n.enable = v, n.enabled = m, n.humanize = (0, $ke54k.m), n.names = [], n.skips = [], n.formatters = {};
    var o;
    function d(r) {
        var e = 0, f;
        for(f in r)e = (e << 5) - e + r.charCodeAt(f), e |= 0;
        return n.colors[Math.abs(e) % n.colors.length];
    }
    function g(r) {
        function e() {
            if (e.enabled) {
                var f = e, l = +/* @__PURE__ */ new Date(), y = l - (o || l);
                f.diff = y, f.prev = o, f.curr = l, o = l;
                for(var i = new Array(arguments.length), u = 0; u < i.length; u++)i[u] = arguments[u];
                i[0] = n.coerce(i[0]), typeof i[0] != "string" && i.unshift("%O");
                var a = 0;
                i[0] = i[0].replace(/%([a-zA-Z%])/g, function(t, A) {
                    if (t === "%%") return t;
                    a++;
                    var s = n.formatters[A];
                    if (typeof s == "function") {
                        var C = i[a];
                        t = s.call(f, C), i.splice(a, 1), a--;
                    }
                    return t;
                }), n.formatArgs.call(f, i);
                var w = e.log || n.log || console.log.bind(console);
                w.apply(f, i);
            }
        }
        return e.namespace = r, e.enabled = n.enabled(r), e.useColors = n.useColors(), e.color = d(r), typeof n.init == "function" && n.init(e), e;
    }
    function v(r) {
        n.save(r), n.names = [], n.skips = [];
        for(var e = (typeof r == "string" ? r : "").split(/[\s,]+/), f = e.length, l = 0; l < f; l++)e[l] && (r = e[l].replace(/\*/g, ".*?"), r[0] === "-" ? n.skips.push(new RegExp("^" + r.substr(1) + "$")) : n.names.push(new RegExp("^" + r + "$")));
    }
    function h() {
        n.enable("");
    }
    function m(r) {
        var e, f;
        for(e = 0, f = n.skips.length; e < f; e++)if (n.skips[e].test(r)) return !1;
        for(e = 0, f = n.names.length; e < f; e++)if (n.names[e].test(r)) return !0;
        return !1;
    }
    function k(r) {
        return r instanceof Error ? r.stack || r.message : r;
    }
})((0, $gfoAg.__module), (0, $gfoAg.__module).exports);
var $85effdff89b6c36a$export$4368d992c4eafac0 = (0, $gfoAg.__module).exports;

});
parcelRegister("gfoAg", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $bd411deb93126137$export$5edeffb658f039f4; });
var $bd411deb93126137$export$5edeffb658f039f4 = {
    exports: {}
};

});

parcelRegister("ke54k", function(module, exports) {

$parcel$export(module.exports, "m", function () { return $eb990bfdbe3f09c3$export$953cecd6e717a553; });
var $eb990bfdbe3f09c3$var$a = 1e3, $eb990bfdbe3f09c3$var$n = $eb990bfdbe3f09c3$var$a * 60, $eb990bfdbe3f09c3$var$t = $eb990bfdbe3f09c3$var$n * 60, $eb990bfdbe3f09c3$var$c = $eb990bfdbe3f09c3$var$t * 24, $eb990bfdbe3f09c3$var$o = $eb990bfdbe3f09c3$var$c * 365.25, $eb990bfdbe3f09c3$export$953cecd6e717a553 = function(e, r) {
    r = r || {};
    var s = typeof e;
    if (s === "string" && e.length > 0) return $eb990bfdbe3f09c3$var$d(e);
    if (s === "number" && isNaN(e) === !1) return r.long ? $eb990bfdbe3f09c3$var$h(e) : $eb990bfdbe3f09c3$var$f(e);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
};
function $eb990bfdbe3f09c3$var$d(e) {
    if (e = String(e), !(e.length > 100)) {
        var r = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);
        if (r) {
            var s = parseFloat(r[1]), i = (r[2] || "ms").toLowerCase();
            switch(i){
                case "years":
                case "year":
                case "yrs":
                case "yr":
                case "y":
                    return s * $eb990bfdbe3f09c3$var$o;
                case "days":
                case "day":
                case "d":
                    return s * $eb990bfdbe3f09c3$var$c;
                case "hours":
                case "hour":
                case "hrs":
                case "hr":
                case "h":
                    return s * $eb990bfdbe3f09c3$var$t;
                case "minutes":
                case "minute":
                case "mins":
                case "min":
                case "m":
                    return s * $eb990bfdbe3f09c3$var$n;
                case "seconds":
                case "second":
                case "secs":
                case "sec":
                case "s":
                    return s * $eb990bfdbe3f09c3$var$a;
                case "milliseconds":
                case "millisecond":
                case "msecs":
                case "msec":
                case "ms":
                    return s;
                default:
                    return;
            }
        }
    }
}
function $eb990bfdbe3f09c3$var$f(e) {
    return e >= $eb990bfdbe3f09c3$var$c ? Math.round(e / $eb990bfdbe3f09c3$var$c) + "d" : e >= $eb990bfdbe3f09c3$var$t ? Math.round(e / $eb990bfdbe3f09c3$var$t) + "h" : e >= $eb990bfdbe3f09c3$var$n ? Math.round(e / $eb990bfdbe3f09c3$var$n) + "m" : e >= $eb990bfdbe3f09c3$var$a ? Math.round(e / $eb990bfdbe3f09c3$var$a) + "s" : e + "ms";
}
function $eb990bfdbe3f09c3$var$h(e) {
    return $eb990bfdbe3f09c3$var$u(e, $eb990bfdbe3f09c3$var$c, "day") || $eb990bfdbe3f09c3$var$u(e, $eb990bfdbe3f09c3$var$t, "hour") || $eb990bfdbe3f09c3$var$u(e, $eb990bfdbe3f09c3$var$n, "minute") || $eb990bfdbe3f09c3$var$u(e, $eb990bfdbe3f09c3$var$a, "second") || e + " ms";
}
function $eb990bfdbe3f09c3$var$u(e, r, s) {
    if (!(e < r)) return e < r * 1.5 ? Math.floor(e / r) + " " + s : Math.ceil(e / r) + " " + s + "s";
}

});



parcelRegister("aV7Cz", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $7f3523a7a05653a4$export$2d1720544b23b823; });

var $jaPSS = parcelRequire("jaPSS");
(function(a, e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.default = [
        "cueVideoById",
        "loadVideoById",
        "cueVideoByUrl",
        "loadVideoByUrl",
        "playVideo",
        "pauseVideo",
        "stopVideo",
        "getVideoLoadedFraction",
        "cuePlaylist",
        "loadPlaylist",
        "nextVideo",
        "previousVideo",
        "playVideoAt",
        "setShuffle",
        "setLoop",
        "getPlaylist",
        "getPlaylistIndex",
        "setOption",
        "mute",
        "unMute",
        "isMuted",
        "setVolume",
        "getVolume",
        "seekTo",
        "getPlayerState",
        "getPlaybackRate",
        "setPlaybackRate",
        "getAvailablePlaybackRates",
        "getPlaybackQuality",
        "setPlaybackQuality",
        "getAvailableQualityLevels",
        "getCurrentTime",
        "getDuration",
        "removeEventListener",
        "getVideoUrl",
        "getVideoEmbedCode",
        "getOptions",
        "getOption",
        "addEventListener",
        "destroy",
        "setSize",
        "getIframe"
    ], a.exports = e.default;
})((0, $jaPSS.__module), (0, $jaPSS.__module).exports);
var $7f3523a7a05653a4$export$2d1720544b23b823 = (0, $jaPSS.__module).exports;

});
parcelRegister("jaPSS", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $df57329a34ca5590$export$5edeffb658f039f4; });
var $df57329a34ca5590$export$5edeffb658f039f4 = {
    exports: {}
};

});


parcelRegister("e694T", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $a438aae963d7b5a5$export$f1e1789686576879; });

var $9Vss4 = parcelRequire("9Vss4");
(function(t, e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.default = [
        "ready",
        "stateChange",
        "playbackQualityChange",
        "playbackRateChange",
        "error",
        "apiChange",
        "volumeChange"
    ], t.exports = e.default;
})((0, $9Vss4.__module), (0, $9Vss4.__module).exports);
var $a438aae963d7b5a5$export$f1e1789686576879 = (0, $9Vss4.__module).exports;

});
parcelRegister("9Vss4", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $739f81da8ab31a42$export$5edeffb658f039f4; });
var $739f81da8ab31a42$export$5edeffb658f039f4 = {
    exports: {}
};

});


parcelRegister("2abqa", function(module, exports) {

$parcel$export(module.exports, "F", function () { return $19355fe70dc333e8$export$d66501df72047452; });

var $d51hB = parcelRequire("d51hB");

var $ab6lx = parcelRequire("ab6lx");
(function(r, a) {
    Object.defineProperty(a, "__esModule", {
        value: !0
    });
    var l = (0, $ab6lx.P), e = s(l);
    function s(t) {
        return t && t.__esModule ? t : {
            default: t
        };
    }
    a.default = {
        pauseVideo: {
            acceptableStates: [
                e.default.ENDED,
                e.default.PAUSED
            ],
            stateChangeRequired: !1
        },
        playVideo: {
            acceptableStates: [
                e.default.ENDED,
                e.default.PLAYING
            ],
            stateChangeRequired: !1
        },
        seekTo: {
            acceptableStates: [
                e.default.ENDED,
                e.default.PLAYING,
                e.default.PAUSED
            ],
            stateChangeRequired: !0,
            // TRICKY: `seekTo` may not cause a state change if no buffering is
            // required.
            timeout: 3e3
        }
    }, r.exports = a.default;
})((0, $d51hB.__module), (0, $d51hB.__module).exports);
var $19355fe70dc333e8$export$d66501df72047452 = (0, $d51hB.__module).exports;

});
parcelRegister("d51hB", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $985cbcbd73723c05$export$5edeffb658f039f4; });
var $985cbcbd73723c05$export$5edeffb658f039f4 = {
    exports: {}
};

});

parcelRegister("ab6lx", function(module, exports) {

$parcel$export(module.exports, "P", function () { return $768fdaba59fdaf4b$export$56c0d5a1e737357d; });

var $9d3Qv = parcelRequire("9d3Qv");
(function(r, e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.default = {
        BUFFERING: 3,
        ENDED: 0,
        PAUSED: 2,
        PLAYING: 1,
        UNSTARTED: -1,
        VIDEO_CUED: 5
    }, r.exports = e.default;
})((0, $9d3Qv.__module), (0, $9d3Qv.__module).exports);
var $768fdaba59fdaf4b$export$56c0d5a1e737357d = (0, $9d3Qv.__module).exports;

});
parcelRegister("9d3Qv", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $6b484fac16fa8a8d$export$5edeffb658f039f4; });
var $6b484fac16fa8a8d$export$5edeffb658f039f4 = {
    exports: {}
};

});






parcelRegister("7BC0a", function(module, exports) {

$parcel$export(module.exports, "useYouTubePlayer", function () { return $5899776d2a3ebd40$export$98d30036e10fc900; });

var $dvPqk = parcelRequire("dvPqk");

var $41vNj = parcelRequire("41vNj");
function $5899776d2a3ebd40$export$98d30036e10fc900() {
    const [u, d] = (0, $dvPqk.useState)(!1), [g, T] = (0, $dvPqk.useState)(!1), [k, I] = (0, $dvPqk.useState)(0), [m, c] = (0, $dvPqk.useState)(0), [y, S] = (0, $dvPqk.useState)(!0), [p, v] = (0, $dvPqk.useState)(0), [P, h] = (0, $dvPqk.useState)("Laster..."), [L, i] = (0, $dvPqk.useState)(!1), l = (0, $dvPqk.useRef)(!1), t = (0, $dvPqk.useRef)(null), n = (0, $dvPqk.useRef)(), a = (0, $dvPqk.useRef)(), R = ()=>{
        n.current && clearInterval(n.current), n.current = setInterval(()=>{
            if (t.current && !L) {
                const e = t.current.getCurrentTime();
                c(e);
            }
        }, 20);
    }, f = ()=>{
        n.current && clearInterval(n.current);
    }, V = ()=>{
        a.current && clearInterval(a.current), a.current = setInterval(()=>{
            if (t.current) {
                const e = t.current.getVideoLoadedFraction();
                v(e);
            }
        }, 100);
    }, x = (e)=>{
        t.current = e.target, S(!1), V();
        const s = e.target.getDuration();
        I(s);
        const B = Math.max(1, Math.floor(s / 60));
        h(`Spill av filmen \u{2022} ${B} min`);
    }, C = (e)=>{
        const s = e.data === (0, $41vNj.default).PlayerState.PLAYING;
        d(s), s ? (T(!0), R()) : f();
    }, D = (e)=>{
        t.current && (c(e), t.current.seekTo(e, !0));
    }, F = ()=>{
        i(!0), l.current = u, t.current && t.current.pauseVideo();
    }, Y = (e)=>{
        t.current && (c(e), t.current.seekTo(e, !0), t.current.pauseVideo());
    }, b = (e)=>{
        t.current && (c(e), t.current.seekTo(e, !0), l.current && t.current.playVideo(), i(!1));
    };
    return (0, $dvPqk.useEffect)(()=>()=>{
            f(), a.current && clearInterval(a.current);
        }, []), {
        playerRef: t,
        isPlaying: u,
        hasStarted: g,
        duration: k,
        currentTime: m,
        isLoading: y,
        loadedFraction: p,
        playButtonText: P,
        handleReady: x,
        handleStateChange: C,
        seekTo: D,
        startSeeking: F,
        seekWhileDragging: Y,
        endSeeking: b
    };
}

});

parcelRegister("ai6sm", function(module, exports) {

$parcel$export(module.exports, "VideoControls", function () { return $77e097eb583f4a2c$export$b4317712fcdf3ab9; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $laJlO = parcelRequire("laJlO");

var $fqmDC = parcelRequire("fqmDC");

var $2rwok = parcelRequire("2rwok");

var $7nwbD = parcelRequire("7nwbD");

var $lBgZM = parcelRequire("lBgZM");

var $4Ys1E = parcelRequire("4Ys1E");
function $77e097eb583f4a2c$export$b4317712fcdf3ab9({ player: r, isPlaying: N, duration: a, currentTime: c, loadedFraction: L, onPlayPause: W, onSeek: S, onDragStart: U, onDragging: V, onDragEnd: P, isFullscreen: m }) {
    var O;
    const [i, Y] = (0, $dvPqk.useState)(100), [o, w] = (0, $dvPqk.useState)(!1), [H, I] = (0, $dvPqk.useState)(!1), [f, $] = (0, $dvPqk.useState)(!1), [h, E] = (0, $dvPqk.useState)(null), R = (0, $dvPqk.useRef)(null), k = (0, $dvPqk.useRef)(null), y = (0, $dvPqk.useRef)(null), G = (0, $dvPqk.useRef)(null), v = (0, $dvPqk.useRef)(), C = (e)=>{
        const t = Math.floor(e / 60), l = Math.floor(e % 60);
        return `${t}:${l.toString().padStart(2, "0")}`;
    }, x = (0, $dvPqk.useCallback)((e)=>{
        if (!R.current || !a) return 0;
        const t = R.current.getBoundingClientRect(), u = t.width - 16, s = (e - t.left) / u;
        return Math.min(Math.max(s, 0), 1);
    }, [
        a
    ]), q = (e)=>{
        const t = x(e);
        E(t), $(!0), U(), V(t * a);
    }, z = (e)=>{
        if (e.buttons === 1) q(e.clientX);
        else {
            const t = x(e.clientX);
            S(t * a);
        }
    }, J = (e)=>{
        e.preventDefault(), q(e.touches[0].clientX);
    }, D = (0, $dvPqk.useCallback)((e)=>{
        if (!r) return;
        const t = Math.max(0, Math.min(100, e));
        r.setVolume(t), Y(t), t === 0 ? (w(!0), r.mute()) : o && (w(!1), r.unMute());
    }, [
        r,
        o
    ]), X = (e)=>{
        if (!r) return;
        let t = i;
        const l = e.shiftKey ? 10 : 5;
        switch(e.key){
            case "ArrowUp":
                e.preventDefault(), t = Math.min(i + l, 100), D(t);
                break;
            case "ArrowDown":
                e.preventDefault(), t = Math.max(i - l, 0), D(t);
                break;
            case "m":
                e.preventDefault(), A();
                break;
        }
    }, A = (0, $dvPqk.useCallback)(()=>{
        r && (o ? (r.unMute(), r.setVolume(i), w(!1)) : (r.mute(), w(!0)));
    }, [
        r,
        o,
        i
    ]), Q = (0, $dvPqk.useCallback)(()=>{
        var t;
        const e = (t = r == null ? void 0 : r.getIframe()) == null ? void 0 : t.closest(".video-player-container");
        e && (document.fullscreenElement ? document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.mozCancelFullScreen && document.mozCancelFullScreen() : e.requestFullscreen ? e.requestFullscreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen ? e.msRequestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : r && r.playVideo());
    }, [
        r
    ]);
    (0, $dvPqk.useEffect)(()=>{
        m && y.current && y.current.focus();
    }, [
        m
    ]), (0, $dvPqk.useEffect)(()=>{
        const e = (s)=>{
            if (f) {
                const p = x(s);
                E(p), V(p * a);
            }
        }, t = ()=>{
            f && h !== null && (P(h * a), $(!1), E(null));
        }, l = (s)=>{
            e(s.clientX);
        }, u = (s)=>{
            s.preventDefault(), e(s.touches[0].clientX);
        };
        return f && (document.addEventListener("mousemove", l), document.addEventListener("mouseup", t), document.addEventListener("touchmove", u, {
            passive: !1
        }), document.addEventListener("touchend", t), document.addEventListener("touchcancel", t)), ()=>{
            document.removeEventListener("mousemove", l), document.removeEventListener("mouseup", t), document.removeEventListener("touchmove", u), document.removeEventListener("touchend", t), document.removeEventListener("touchcancel", t);
        };
    }, [
        f,
        h,
        a,
        V,
        P,
        x
    ]);
    const Z = ()=>f && h !== null ? `${h * 100}%` : a - c <= 1 ? "100%" : `${c / a * 100}%`, _ = ()=>{
        v.current && clearTimeout(v.current), v.current = setTimeout(()=>{
            I(!1);
        }, 300);
    }, ee = ()=>{
        v.current && clearTimeout(v.current), I(!0);
    }, te = (e)=>{
        var s, p;
        if (!((s = k.current) == null ? void 0 : s.getBoundingClientRect())) return;
        const l = (p = k.current) == null ? void 0 : p.querySelector('input[type="range"]'), u = l == null ? void 0 : l.getBoundingClientRect();
        u && e.clientX >= u.left && e.clientX <= u.right && e.clientY >= u.top && e.clientY <= u.bottom || _();
    }, B = Z(), j = ((O = navigator == null ? void 0 : navigator.userAgentData) == null ? void 0 : O.platform) || (navigator == null ? void 0 : navigator.platform) || "unknown", K = j === "MacIntel" && navigator.maxTouchPoints > 0 || j === "iPad", ne = /iPhone|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        "aria-label": "Video controls",
        className: (0, $6sMuH.cn)("bg-surface-default-inverted px-1 rounded-b-lg flex items-center gap-2", "relative", m && "fixed bottom-0 left-0 right-0 rounded-none z-50 p-2"),
        role: "toolbar",
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: "flex items-center gap-1",
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)("button", {
                        "aria-label": N ? "Pause (Space)" : "Play (Space)",
                        "aria-pressed": N,
                        className: "bg-transparent p-2",
                        onClick: W,
                        ref: y,
                        type: "button",
                        children: N ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $laJlO.default), {
                            "aria-hidden": "true",
                            className: "fill-surface-default"
                        }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $fqmDC.default), {
                            "aria-hidden": "true",
                            className: "fill-surface-default"
                        })
                    }),
                    !ne && !K ? /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                        "aria-label": "Volume controls",
                        className: "relative",
                        onMouseEnter: ee,
                        onMouseLeave: te,
                        ref: k,
                        role: "group",
                        children: [
                            /* @__PURE__ */ (0, $7YWoO.jsx)("button", {
                                "aria-controls": "volume-slider",
                                "aria-label": o ? "Unmute (M)" : "Mute (M)",
                                "aria-pressed": o,
                                className: "bg-transparent p-2",
                                onClick: A,
                                onKeyDown: X,
                                type: "button",
                                children: o ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $2rwok.default), {
                                    "aria-hidden": "true",
                                    className: "fill-surface-default"
                                }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $7nwbD.default), {
                                    "aria-hidden": "true",
                                    className: "fill-surface-default"
                                })
                            }),
                            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                className: (0, $6sMuH.cn)("absolute left-2 bottom-full rounded-t-sm", "bg-surface-default-inverted p-2", "transition-all duration-200 z-50", H ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-2 pointer-events-none"),
                                children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                                    className: "flex items-center justify-center h-24 relative",
                                    children: [
                                        /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                                            className: "relative w-1 h-full bg-ink-brand-subtle/30 rounded-full ring-1 ring-surface-default",
                                            children: [
                                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                                    "aria-hidden": "true",
                                                    className: "absolute bottom-0 w-full bg-surface-default rounded-full",
                                                    style: {
                                                        height: `${o ? 0 : i}%`
                                                    }
                                                }),
                                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                                    "aria-hidden": "true",
                                                    className: "absolute w-3 h-3 bg-button-primary-bg border-2 border-surface-default rounded-full left-1/2 transform -translate-x-1/2 shadow-md hover:scale-110 transition-transform",
                                                    style: {
                                                        bottom: `${o ? 0 : i}%`,
                                                        transform: "translateX(-50%) translateY(50%)"
                                                    }
                                                })
                                            ]
                                        }),
                                        /* @__PURE__ */ (0, $7YWoO.jsx)("input", {
                                            "aria-label": "Volume (Up/Down arrows to adjust, M to mute)",
                                            "aria-valuemax": 100,
                                            "aria-valuemin": 0,
                                            "aria-valuenow": o ? 0 : i,
                                            "aria-valuetext": `Volume ${o ? 0 : i}%`,
                                            className: "absolute w-24 opacity-0 cursor-pointer",
                                            id: "volume-slider",
                                            max: "100",
                                            min: "0",
                                            onChange: (e)=>{
                                                D(parseInt(e.target.value));
                                            },
                                            onKeyDown: X,
                                            ref: G,
                                            style: {
                                                transform: "rotate(-90deg)",
                                                transformOrigin: "center"
                                            },
                                            type: "range",
                                            value: o ? 0 : i
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: "flex flex-grow items-center gap-2",
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        "aria-label": "Video progress",
                        "aria-valuemax": a,
                        "aria-valuemin": 0,
                        "aria-valuenow": c,
                        "aria-valuetext": `${C(c)} of ${C(a)}`,
                        className: "flex-1 cursor-pointer px-2",
                        onKeyDown: (e)=>{
                            e.key === "Enter" || e.key === " " ? (e.preventDefault(), z(e)) : e.key === "ArrowRight" ? S(Math.min(c + 5, a)) : e.key === "ArrowLeft" && S(Math.max(c - 5, 0));
                        },
                        onMouseDown: z,
                        onTouchStart: J,
                        ref: R,
                        role: "slider",
                        tabIndex: 0,
                        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                            className: "h-1 relative rounded-full",
                            children: [
                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: "absolute inset-0 bg-ink-brand-subtle opacity-30 rounded-full"
                                }),
                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    "aria-label": "Loaded portion",
                                    "aria-valuemax": 100,
                                    "aria-valuemin": 0,
                                    "aria-valuenow": Math.round(L * 100),
                                    className: "absolute left-0 top-0 h-full rounded-full bg-surface-default opacity-50 z-0",
                                    role: "progressbar",
                                    style: {
                                        width: `${Math.min(L * 100, 100)}%`
                                    }
                                }),
                                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: "relative h-full rounded-full bg-surface-default z-10",
                                    style: {
                                        width: B
                                    },
                                    children: /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                        "aria-hidden": "true",
                                        className: (0, $6sMuH.cn)("absolute top-1/2 w-4 h-4 -translate-y-1/2 bg-button-primary-bg rounded-full border-2 border-surface-default", B === "100%" ? "right-0" : "-right-2")
                                    })
                                })
                            ]
                        })
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "text-surface-default w-12 text-sm whitespace-nowrap",
                        role: "timer",
                        children: C(c)
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("button", {
                "aria-label": m ? "Exit full screen (F)" : "Enter full screen (F)",
                "aria-pressed": m,
                className: "bg-transparent p-2",
                onClick: Q,
                type: "button",
                children: m ? !K && /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lBgZM.default), {
                    "aria-hidden": "true",
                    className: "fill-surface-default"
                }) : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4Ys1E.default), {
                    "aria-hidden": "true",
                    className: "fill-surface-default"
                })
            })
        ]
    });
}

});
parcelRegister("laJlO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69db5e09a83b53f$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $f69db5e09a83b53f$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M15 21V3h6v18zM3 21V3h6v18z"
        })
    }));

});

parcelRegister("fqmDC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3aad8231017e1b7$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $b3aad8231017e1b7$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M5.576 22V2L21.03 12z"
        })
    }));

});

parcelRegister("2rwok", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c773aaa55377d07$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $1c773aaa55377d07$export$2e2bcd8739ae039 = (l)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, l, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m19.416 22.842-3.025-3.025a8.3 8.3 0 0 1-1.325.687q-.7.288-1.45.463v-2.05q.35-.126.687-.25.338-.126.638-.3l-3.325-3.325v5.2l-5-5h-4v-6h3.2l-4.8-4.8 1.4-1.4 18.4 18.4zm-.2-5.8-1.45-1.45a6.8 6.8 0 0 0 .637-1.625q.213-.85.213-1.75 0-2.35-1.375-4.2t-3.625-2.5v-2.05q3.1.7 5.05 3.137t1.95 5.613q0 1.325-.363 2.55a8.8 8.8 0 0 1-1.037 2.275m-3.35-3.35-2.25-2.25v-3.25a4.15 4.15 0 0 1 1.837 1.65 4.57 4.57 0 0 1 .6 3.137q-.063.363-.187.713m-4.25-4.25-2.6-2.6 2.6-2.6zm-2 5.95v-2.35l-1.8-1.8h-3.2v2h2.85z"
        })
    }));

});

parcelRegister("7nwbD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55f3a5fb9f0df9f4$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $55f3a5fb9f0df9f4$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M13.616 21.07v-2.05q2.25-.65 3.625-2.5t1.375-4.2-1.375-4.2-3.625-2.5V3.57q3.1.7 5.05 3.137t1.95 5.613-1.95 5.612-5.05 3.138m-11-5.725v-6h4l5-5v16l-5-5zm11 1v-8.05a4.15 4.15 0 0 1 1.837 1.65q.663 1.1.663 2.4 0 1.275-.663 2.362a4.17 4.17 0 0 1-1.837 1.638m-4-7.15-2.15 2.15h-2.85v2h2.85l2.15 2.15z"
        })
    }));

});

parcelRegister("lBgZM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb9a3c98c8421fde$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $fb9a3c98c8421fde$export$2e2bcd8739ae039 = (l)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, l, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M3.99 21 3 20.01l6.59-6.589H4.895V12H12v7.105h-1.421V14.41zM12 12V4.895h1.421V9.59L20.011 3l.989.99-6.59 6.589h4.695V12z"
        })
    }));

});

parcelRegister("4Ys1E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39f281504f4f3d9b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $39f281504f4f3d9b$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M3 21v-7.941h1.588v5.247L18.306 4.588H13.06V3H21v7.941h-1.588V5.694L5.694 19.412h5.247V21z"
        })
    }));

});




parcelRegister("9o9dF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a0c117deea047eb$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $i4tzf = parcelRequire("i4tzf");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $blzR8 = parcelRequire("blzR8");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");

var $fj1oy = parcelRequire("fj1oy");

var $9yKIH = parcelRequire("9yKIH");

var $dZidx = parcelRequire("dZidx");
const $7a0c117deea047eb$var$LargeTeaser = ({ content: content })=>{
    const trackImpression = (isVisible)=>{
        if (isVisible) (0, $6fuyt.sendViewTeaser)(title, contentType);
    };
    const { ref: viewRef } = (0, $blzR8.useInView)({
        triggerOnce: true,
        onChange: trackImpression
    });
    const isVisible = (0, $fj1oy.getModuleVisibility)(content, (0, $9yKIH.default).currentCustomerProperties);
    if (!isVisible) return null;
    const title = content.fields.title;
    const description = content.fields.description;
    const image = content.fields.image;
    const primaryButtonText = content.fields.buttonText;
    const primaryButtonLink = content.fields.buttonLink ?? "";
    const secondaryButtonText = content.fields.buttonText2;
    const secondaryButtonLink = content.fields.buttonLink2 ?? "";
    const themeBackground = content.fields.background;
    const imagePosition = content.fields.imagePosition;
    const contentType = content.sys.contentType.sys.id;
    const LinkComponent = (0, $5OqMf.isExternalLink)(primaryButtonLink) || (0, $5OqMf.isExternalLink)(secondaryButtonLink) ? "a" : (0, $8kt8E.Link);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        ref: viewRef,
        className: "relative",
        children: [
            themeBackground && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dZidx.default), {
                color: "bg-infoBoxBackground"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "relative py-8 lg:py-10",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $i4tzf.SectionCard), {
                    title: title,
                    description: description,
                    image: image?.fields.file?.url,
                    imageAlt: image?.fields.title,
                    primaryCtaLabel: primaryButtonText,
                    primaryCtaHref: primaryButtonLink,
                    secondaryCtaLabel: secondaryButtonText,
                    secondaryCtaHref: secondaryButtonLink,
                    linkComponent: LinkComponent,
                    backgroundColor: "transparent",
                    isImageFlipped: imagePosition === "Right",
                    className: "[&_strong]:font-semibold",
                    onPrimaryCtaClick: ()=>(0, $6fuyt.sendSelectTeaser)(title, contentType, undefined, `/${primaryButtonLink}`),
                    onSecondaryCtaClick: ()=>(0, $6fuyt.sendSelectTeaser)(title, contentType, undefined, `/${secondaryButtonLink}`)
                })
            })
        ]
    });
};
var $7a0c117deea047eb$export$2e2bcd8739ae039 = (0, $gBcml.observer)($7a0c117deea047eb$var$LargeTeaser);

});

parcelRegister("LJVQK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7591bf1a28d7a76b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $j6ChH = parcelRequire("j6ChH");

var $iOmZY = parcelRequire("iOmZY");

var $isIf6 = parcelRequire("isIf6");

var $bUlre = parcelRequire("bUlre");

var $kKz9I = parcelRequire("kKz9I");

var $9XaVa = parcelRequire("9XaVa");
const $7591bf1a28d7a76b$var$Recipe = ({ recipeEntry: recipeEntry })=>{
    const dataFromContentful = recipeEntry.fields.recipeData;
    const recipe = dataFromContentful && !Array.isArray(dataFromContentful) ? dataFromContentful : undefined;
    if (!recipe) return null;
    const canonical = (0, $iOmZY.canonicalRecipeUrl)(recipe);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bUlre.default), {}),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $j6ChH.Helmet), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("title", {
                        children: `${recipe.displayName} - ${(0, $isIf6.default).siteName}`
                    }),
                    !!canonical && /*#__PURE__*/ (0, $7YWoO.jsx)("link", {
                        rel: "canonical",
                        href: canonical
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9XaVa.default), {
                recipe: recipe
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kKz9I.default), {
                recipe: recipe
            })
        ]
    });
};
var $7591bf1a28d7a76b$export$2e2bcd8739ae039 = (0, $gBcml.observer)($7591bf1a28d7a76b$var$Recipe);

});
parcelRegister("iOmZY", function(module, exports) {

$parcel$export(module.exports, "canonicalRecipeUrl", function () { return $b79724743cb7de61$export$9e9f5c96453673d9; });
const $b79724743cb7de61$var$tineRecipeUrl = (path, name)=>`https://www.tine.no/oppskrifter/${path}/${name}`;
const $b79724743cb7de61$export$9e9f5c96453673d9 = (recipe)=>{
    const { name: name, categories: categories, publicUrls: publicUrls } = recipe;
    // If categories, componse a recipe url from category levels available
    if (name && categories) {
        const { level1: level1, level2: level2 } = categories;
        if (level2) return $b79724743cb7de61$var$tineRecipeUrl(level2.slug, name);
        return $b79724743cb7de61$var$tineRecipeUrl(level1.slug, name);
    }
    // If no categories, use the first public url
    if (publicUrls && publicUrls.length > 0) return publicUrls[0].value;
    return "";
};

});

parcelRegister("kKz9I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c493b0d8af117ae$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8NE0j = parcelRequire("8NE0j");

var $adguP = parcelRequire("adguP");

var $23Emj = parcelRequire("23Emj");
const $9c493b0d8af117ae$var$onDesktop = (cols)=>({
        base: 1,
        lg: cols
    });
const $9c493b0d8af117ae$var$IngredientsAndInstructions = ({ recipe: recipe })=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
        cols: {
            base: 1,
            lg: 12
        },
        gap: 12,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                span: $9c493b0d8af117ae$var$onDesktop(4),
                className: "print:col-span-4",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8NE0j.default), {
                    recipe: recipe
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                span: $9c493b0d8af117ae$var$onDesktop(8),
                className: "print:col-span-8",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $adguP.default), {
                        stepGroups: recipe.stepGroups,
                        tip: recipe.tip
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $23Emj.default), {
                        recipe: recipe
                    })
                ]
            })
        ]
    });
var $9c493b0d8af117ae$export$2e2bcd8739ae039 = (0, $gBcml.observer)($9c493b0d8af117ae$var$IngredientsAndInstructions);

});
parcelRegister("8NE0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $377fd4c07d1a9bb9$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $jOOuf = parcelRequire("jOOuf");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $eucAq = parcelRequire("eucAq");

var $jO0Og = parcelRequire("jO0Og");

var $ajMyh = parcelRequire("ajMyh");
const $377fd4c07d1a9bb9$var$Ingredients = ({ recipe: recipe })=>{
    const { multipliable: multipliable, ingredientGroups: ingredientGroups, portions: portions } = recipe;
    const [multiplier, setMultiplier] = (0, $dvPqk.useState)(1);
    const showPortionsControl = !!portions && !!multipliable;
    const currentPortions = (0, $dvPqk.useMemo)(()=>showPortionsControl ? Math.floor(portions * multiplier) : portions || 4, [
        multiplier
    ]);
    const handlePortionsControlChange = (newPortions)=>{
        const multiplier = newPortions / (portions || 4);
        setMultiplier(multiplier);
    };
    const portionsText = portions ? portions === 1 ? "1 porsjon" : `${portions} porsjoner` : "";
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                className: "mb-4",
                children: "Ingredienser"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $eucAq.default), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            showPortionsControl && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                                justify: "between",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                        className: "text-sm font-semibold",
                                        children: "Antall porsjoner"
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ajMyh.default), {
                                        portions: currentPortions,
                                        onChange: handlePortionsControlChange
                                    })
                                ]
                            }),
                            portions && !showPortionsControl && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: "text-sm font-semibold",
                                children: portionsText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "flex flex-col gap-8",
                        children: ingredientGroups.map((ingredientGroup, i)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $jO0Og.default), {
                                ingredientGroup: ingredientGroup,
                                multiplier: multiplier
                            }, `${recipe.recipeId}-${i}`))
                    })
                ]
            })
        ]
    });
};
var $377fd4c07d1a9bb9$export$2e2bcd8739ae039 = (0, $gBcml.observer)($377fd4c07d1a9bb9$var$Ingredients);

});
parcelRegister("eucAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62e388cc918f1d3e$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
const $62e388cc918f1d3e$var$WhiteSheet = ({ className: className = "", padding: padding = "md", children: children })=>{
    const whiteSheet = "bg-surface-default basis-0 rounded-md";
    const sheetPadding = {
        sm: "p-4",
        md: "p-6",
        lg: "p-8",
        none: ""
    }[padding];
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: (0, $izjX7.cn)(className, whiteSheet, sheetPadding),
        children: children
    });
};
var $62e388cc918f1d3e$export$2e2bcd8739ae039 = $62e388cc918f1d3e$var$WhiteSheet;

});

parcelRegister("jO0Og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bdf0824938e3d01$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $fqWHZ = parcelRequire("fqWHZ");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $6TlV8 = parcelRequire("6TlV8");
const $7bdf0824938e3d01$var$IngredientGroup = ({ ingredientGroup: ingredientGroup, multiplier: multiplier = 1 })=>{
    const { name: name, ingredientLines: ingredientLines } = ingredientGroup;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            !!name && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                className: "text-sm font-semibold",
                children: name
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fqWHZ.Stack), {
                align: "start",
                gap: 0,
                className: "divide-x-0 divide-y divide-solid divide-ink-border-subtle",
                children: ingredientLines.map((ingredientLine, i)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $6TlV8.default), {
                        ingredientLine: ingredientLine,
                        multiplier: multiplier
                    }, `${ingredientLine.ingredient.singular}-${i}`))
            })
        ]
    });
};
var $7bdf0824938e3d01$export$2e2bcd8739ae039 = (0, $gBcml.observer)($7bdf0824938e3d01$var$IngredientGroup);

});
parcelRegister("6TlV8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12df94d2d1f80ed6$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");

var $izjX7 = parcelRequire("izjX7");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $bZiDo = parcelRequire("bZiDo");

var $6pY3b = parcelRequire("6pY3b");

var $7nXeP = parcelRequire("7nXeP");
const $12df94d2d1f80ed6$var$styles = {
    row: (0, $izjX7.cn)("w-full text-sm"),
    cell: (0, $izjX7.cn)("p-2")
};
// This is added because the unit "stykk" deviates from all other units in the recipe database. It's actually
// the only unit that makes sense. The other units have "dl" in both plural and singular form, and "desiliter"
// in the abbrev field. This is a quick fix. Should probably have been fixed in the database, but we now
// have many frontends that rely on this behavior so its hard to change.
const $12df94d2d1f80ed6$var$shortenStykkUnit = (unit)=>{
    return unit === "stykk" ? "stk" : unit;
};
const $12df94d2d1f80ed6$var$IngredientLine = ({ ingredientLine: ingredientLine, multiplier: multiplier })=>{
    const { amount: amount, ingredient: ingredient, unit: unit, preText: preText, postText: postText } = ingredientLine;
    const singleItem = amount === 1;
    const unitName = $12df94d2d1f80ed6$var$shortenStykkUnit(singleItem ? unit.singular : unit.plural);
    const ingredientName = singleItem ? ingredient.singular : ingredient.plural || ingredient.singular;
    const product = (0, $bZiDo.default).resolveSku(ingredient.articleNo);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
        cols: 12,
        gap: 0,
        className: $12df94d2d1f80ed6$var$styles.row,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                span: 3,
                className: (0, $izjX7.cn)($12df94d2d1f80ed6$var$styles.cell, "text-nowrap text-right"),
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7nXeP.default), {
                        amount: amount,
                        multiplier: multiplier
                    }),
                    " ",
                    unitName
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                span: 9,
                className: (0, $izjX7.cn)($12df94d2d1f80ed6$var$styles.cell),
                children: [
                    preText,
                    " ",
                    !(0, $bEEBX.default)(product) ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                        href: (0, $bZiDo.default).getUrl(product),
                        children: ingredientName
                    }) : ingredientName,
                    " ",
                    postText
                ]
            })
        ]
    });
};
var $12df94d2d1f80ed6$export$2e2bcd8739ae039 = (0, $gBcml.observer)($12df94d2d1f80ed6$var$IngredientLine);

});
parcelRegister("7nXeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cedc6b5b0e7034a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $BjdTh = parcelRequire("BjdTh");
const $8cedc6b5b0e7034a$var$replacements = [
    {
        from: ",25",
        to: "\xbc"
    },
    {
        from: ",75",
        to: "\xbe"
    },
    {
        from: ",33",
        to: "\u2153"
    },
    {
        from: ",67",
        to: "\u2154"
    },
    {
        from: ",5",
        to: "\xbd"
    }
];
/**
 * Find the closest third or quarter to the given amount
 */ const $8cedc6b5b0e7034a$var$closestRound = (amount)=>{
    const quarter = Math.ceil(amount * 4) / 4;
    const third = Math.ceil(amount * 3) / 3;
    if (Math.abs(amount - quarter) < Math.abs(amount - third)) return quarter;
    return third;
};
const $8cedc6b5b0e7034a$var$AmountDisplay = ({ amount: amount, multiplier: multiplier })=>{
    const locale = (0, $BjdTh.default)();
    const totalAmount = amount * multiplier;
    const formatter = new Intl.NumberFormat(locale, {
        maximumFractionDigits: totalAmount > 50 ? 0 : 2
    });
    const roundedAmount = $8cedc6b5b0e7034a$var$closestRound(totalAmount);
    let prettyAmount = formatter.format(roundedAmount);
    for (const replacement of $8cedc6b5b0e7034a$var$replacements){
        prettyAmount = prettyAmount.replace(new RegExp(`0${replacement.from}$`), replacement.to);
        prettyAmount = prettyAmount.replace(new RegExp(`${replacement.from}$`), replacement.to);
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: prettyAmount
    });
};
var $8cedc6b5b0e7034a$export$2e2bcd8739ae039 = (0, $gBcml.observer)($8cedc6b5b0e7034a$var$AmountDisplay);

});



parcelRegister("ajMyh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fe0ec70f5070335$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $1A6xS = parcelRequire("1A6xS");
const $9fe0ec70f5070335$var$IngredientsPortionsControl = ({ portions: portions, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "mb-3 inline-block",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1A6xS.InputStepper), {
            value: portions,
            min: 1,
            size: "compact",
            onChange: onChange
        })
    });
};
var $9fe0ec70f5070335$export$2e2bcd8739ae039 = $9fe0ec70f5070335$var$IngredientsPortionsControl;

});


parcelRegister("adguP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0faa57c66aae1762$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $5OqMf = parcelRequire("5OqMf");

var $eucAq = parcelRequire("eucAq");

var $1qAeV = parcelRequire("1qAeV");

var $irKYQ = parcelRequire("irKYQ");
// Function that takes an array of step groups and returns an array of steps and headers so we can easily enumerate them all
const $0faa57c66aae1762$var$generateStepsAndHeaders = (stepGroups)=>{
    const stepsAndHeaders = [];
    for (const stepGroup of stepGroups){
        if (stepGroup.name) stepsAndHeaders.push({
            heading: stepGroup.name
        });
        for (const step of stepGroup.steps)stepsAndHeaders.push(step);
    }
    return stepsAndHeaders;
};
const $0faa57c66aae1762$var$Instructions = ({ stepGroups: stepGroups, tip: tip })=>{
    const stepsAndHeaders = $0faa57c66aae1762$var$generateStepsAndHeaders(stepGroups);
    let stepNumber = 0;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                className: "mb-4",
                children: "Slik gj\xf8r du"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $eucAq.default), {
                className: "mb-12",
                children: [
                    stepsAndHeaders.map((item, i)=>{
                        if ("heading" in item) return /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                            className: "mb-6 mt-8",
                            children: item.heading
                        }, `heading-${i + 1}`);
                        if ("instruction" in item) {
                            stepNumber++;
                            return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1qAeV.default), {
                                stepNumber: stepNumber,
                                step: item
                            }, `step-${i + 1}`);
                        }
                        return /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                            children: [
                                "Unknown item: ",
                                JSON.stringify(item)
                            ]
                        }, JSON.stringify(item));
                    }),
                    (0, $5OqMf.hasContent)(tip) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $irKYQ.default), {
                        title: "Tips",
                        tip: tip,
                        variant: "tip"
                    })
                ]
            })
        ]
    });
};
var $0faa57c66aae1762$export$2e2bcd8739ae039 = $0faa57c66aae1762$var$Instructions;

});
parcelRegister("1qAeV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a28292ee3e6072b$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $jOOuf = parcelRequire("jOOuf");

var $izjX7 = parcelRequire("izjX7");

var $5OqMf = parcelRequire("5OqMf");

var $irKYQ = parcelRequire("irKYQ");

var $lhCMw = parcelRequire("lhCMw");
const $0a28292ee3e6072b$var$Step = ({ step: step, stepNumber: stepNumber })=>{
    const { instruction: instruction, video: video, tip: tip } = step;
    const styles = (0, $izjX7.cn)({
        "mb-6": (0, $5OqMf.hasContent)(tip),
        "mb-12": !(0, $5OqMf.hasContent)(tip)
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                align: "start",
                justify: "start",
                gap: 0,
                className: styles,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "mr-7 flex min-h-9 min-w-9 items-center justify-center rounded-[50%] bg-surface-default-inverted font-semibold text-ink-brand-inverted",
                        children: stepNumber
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "mt-[6px]",
                        children: instruction
                    })
                ]
            }),
            (0, $5OqMf.hasContent)(tip) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $irKYQ.default), {
                className: "mb-12 ml-16",
                tip: tip,
                variant: "information",
                lightbulbIcon: true
            }),
            (0, $5OqMf.hasContent)(video) && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "py-3",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lhCMw.default), {
                    video: video
                })
            })
        ]
    });
};
var $0a28292ee3e6072b$export$2e2bcd8739ae039 = $0a28292ee3e6072b$var$Step;

});
parcelRegister("irKYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9349f248fc2b4990$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $hbrH7 = parcelRequire("hbrH7");

var $ezbi8 = parcelRequire("ezbi8");

var $izjX7 = parcelRequire("izjX7");

var $j9RzS = parcelRequire("j9RzS");
const $9349f248fc2b4990$var$StepTip = ({ tip: tip, variant: variant, title: title, lightbulbIcon: lightbulbIcon, className: className })=>{
    if (tip) {
        if (tip.includes("data-unresolved-url")) return null;
        const styles = (0, $izjX7.cn)("mt-2", className);
        const cleanedTip = tip.replace(/(<([^>]+)>)/gi, "").replace("&nbsp;", " ");
        if ((0, $j9RzS.default)(cleanedTip).length === 0) // If there is no content left after removing html tags, don't who alert container
        return null;
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
            variant: variant,
            title: title,
            fullWidth: true,
            showCloseButton: false,
            className: styles,
            customIcon: lightbulbIcon ? (0, $hbrH7.default) : undefined,
            children: cleanedTip
        });
    }
    return null;
};
var $9349f248fc2b4990$export$2e2bcd8739ae039 = $9349f248fc2b4990$var$StepTip;

});
parcelRegister("hbrH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c828f245a9aeab88$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $c828f245a9aeab88$var$SvgLightbulb = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M11.546 21q-.591 0-1.114-.284a1.77 1.77 0 0 1-.773-.807H7.727v-5.045a6.25 6.25 0 0 1-2.011-2.318 6.5 6.5 0 0 1-.716-3q0-2.728 1.91-4.637Q8.817 3 11.545 3q2.727 0 4.636 1.91 1.91 1.908 1.909 4.635 0 1.591-.716 3a6.25 6.25 0 0 1-2.011 2.319v5.045h-1.955q-.25.523-.761.807-.512.285-1.102.284m-2.182-2.727h4.363v-1.091H9.364zm0-2.182h4.363V15H9.364zM8.5 13.364H11v-2.5L8.977 8.84l.773-.773 1.796 1.796 1.795-1.796.773.773-2.023 2.023v2.5h2.5a5.2 5.2 0 0 0 1.364-1.694q.5-.988.5-2.125 0-2.045-1.432-3.477-1.433-1.431-3.477-1.432-2.046 0-3.478 1.432Q6.637 7.5 6.636 9.545q0 1.114.5 2.114A5.14 5.14 0 0 0 8.5 13.364"
        })
    }));
var $c828f245a9aeab88$export$2e2bcd8739ae039 = $c828f245a9aeab88$var$SvgLightbulb;

});


parcelRegister("lhCMw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b2c739b9b55c1e4$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lgHX0 = parcelRequire("lgHX0");

var $5OqMf = parcelRequire("5OqMf");
const $4b2c739b9b55c1e4$var$StepVideo = ({ video: video })=>{
    if (video) {
        const { url: url } = video;
        if (url) {
            const id = (0, $5OqMf.getYoutubeVideoIdFromURL)(url);
            if (id) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lgHX0.VideoPlayer), {
                videoId: id
            });
        }
    }
    return null;
};
var $4b2c739b9b55c1e4$export$2e2bcd8739ae039 = $4b2c739b9b55c1e4$var$StepVideo;

});



parcelRegister("23Emj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f06cf904bbe854d9$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $aRSTV = parcelRequire("aRSTV");

var $bZiDo = parcelRequire("bZiDo");

var $3kQAm = parcelRequire("3kQAm");
// This product list should be left aligned to work with the design on the rest of the page
const $f06cf904bbe854d9$var$RecipeProductList = ({ recipe: recipe })=>{
    const { ingredientGroups: ingredientGroups } = recipe;
    const skus = ingredientGroups.flatMap((ingredientGroup)=>ingredientGroup.ingredientLines.map((ingredientLine)=>ingredientLine.ingredient)).filter((ingredient)=>ingredient.articleNo).map((ingredient)=>ingredient.articleNo || "");
    const uniqueSkus = [
        ...new Set(skus)
    ].filter((sku)=>!(0, $bEEBX.default)((0, $bZiDo.default).resolveSku(sku)));
    if (uniqueSkus.length > 0) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
        skus: uniqueSkus,
        listName: "Tine-produkter i oppskrift",
        listType: (0, $aRSTV.LIST_TYPE).RECIPE,
        heading: "Du vil trenge",
        context: "recipe"
    });
    return null;
};
var $f06cf904bbe854d9$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f06cf904bbe854d9$var$RecipeProductList);

});


parcelRegister("9XaVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f744a741fafe5123$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");
var $lgHX0 = parcelRequire("lgHX0");

var $izjX7 = parcelRequire("izjX7");

var $5OqMf = parcelRequire("5OqMf");

var $b0pIv = parcelRequire("b0pIv");

var $cZFWp = parcelRequire("cZFWp");
const $f744a741fafe5123$var$urlForWidthAndHeight = (urlTemplate, width, height)=>{
    return urlTemplate.replace("%height%", height.toFixed(0)).replace("%width%", width.toFixed(0));
};
const $f744a741fafe5123$var$RecipeHeaderAndImage = ({ recipe: recipe })=>{
    const { video: video } = recipe;
    const youtubeId = (0, $5OqMf.getYoutubeVideoIdFromURL)(video?.url || "");
    const hasVideo = !!youtubeId;
    const imageUrl = recipe?.image?.url ? $f744a741fafe5123$var$urlForWidthAndHeight(recipe.image.url, 1250, Math.round(703.125)) : "";
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
        cols: {
            base: 1,
            lg: 12
        },
        gap: 12,
        className: "mb-16",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                order: {
                    base: 1,
                    lg: 0
                },
                span: {
                    base: 1,
                    lg: 4
                },
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b0pIv.default), {
                    recipe: recipe
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                order: {
                    base: 0,
                    lg: 1
                },
                span: {
                    base: 1,
                    lg: 8
                },
                className: (0, $izjX7.cn)({
                    "flex items-center justify-center": !hasVideo,
                    "cursor-pointer": hasVideo
                }),
                children: [
                    !hasVideo && (0, $5OqMf.hasContent)(recipe.image?.url) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cZFWp.default), {
                        width: 1250,
                        className: "rounded-lg print:hidden",
                        placement: "aboveFold",
                        ratio: "16x9",
                        title: recipe.image?.title,
                        url: recipe.image.url,
                        sourceWidth: recipe.image.sourceWidth || undefined,
                        sourceHeight: recipe.image.sourceHeight || undefined
                    }),
                    hasVideo && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lgHX0.VideoPlayer), {
                        videoId: youtubeId,
                        poster: imageUrl
                    })
                ]
            })
        ]
    });
};
var $f744a741fafe5123$export$2e2bcd8739ae039 = $f744a741fafe5123$var$RecipeHeaderAndImage;

});
parcelRegister("b0pIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c51be7b06e3863c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $jOOuf = parcelRequire("jOOuf");
var $fqWHZ = parcelRequire("fqWHZ");

var $3D8st = parcelRequire("3D8st");

var $lVfKV = parcelRequire("lVfKV");
const $4c51be7b06e3863c$var$RecipeHeader = ({ recipe: recipe })=>{
    const { displayName: displayName, description: description, difficulty: difficulty, workTime: workTime, workTimeRange: workTimeRange } = recipe;
    const displayDescription = description.replace(/&nbsp;/i, " ");
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
        align: "start",
        justify: "center",
        className: "h-full",
        gap: 1,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                children: displayName
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                justify: "start",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lVfKV.default), {
                        workTime: workTime,
                        workTimeRange: workTimeRange
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3D8st.default), {
                        difficulty: difficulty
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                className: "text-xl",
                children: displayDescription
            })
        ]
    });
};
var $4c51be7b06e3863c$export$2e2bcd8739ae039 = $4c51be7b06e3863c$var$RecipeHeader;

});
parcelRegister("3D8st", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd7a461779494e27$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $hGi4c = parcelRequire("hGi4c");

var $hV6j4 = parcelRequire("hV6j4");

var $BjdTh = parcelRequire("BjdTh");
const $dd7a461779494e27$var$RecipeDifficulty = ({ difficulty: difficulty })=>{
    const locale = (0, $BjdTh.default)();
    const text = (0, $hV6j4.difficultyTexts)[locale][difficulty];
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
        variant: "base",
        children: text
    });
};
var $dd7a461779494e27$export$2e2bcd8739ae039 = $dd7a461779494e27$var$RecipeDifficulty;

});

parcelRegister("lVfKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57216d672f522267$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $hGi4c = parcelRequire("hGi4c");
const $57216d672f522267$var$RecipePreparationTime = ({ workTime: workTime, workTimeRange: workTimeRange })=>{
    if (typeof workTime === "number" && Number.isInteger(workTime)) {
        const text = typeof workTimeRange === "number" && Number.isInteger(workTimeRange) && workTimeRange > workTime ? `${workTime} - ${workTimeRange} min` : `${workTime} min`;
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
            variant: "base",
            children: text
        });
    }
    return null;
};
var $57216d672f522267$export$2e2bcd8739ae039 = $57216d672f522267$var$RecipePreparationTime;

});


parcelRegister("cZFWp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5e1f5474ba6ee56$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $65KWP = parcelRequire("65KWP");
const $c5e1f5474ba6ee56$var$urlForWidthAndHeight = (urlTemplate, width, height)=>{
    return urlTemplate.replace("%height%", height.toFixed(0)).replace("%width%", width.toFixed(0));
};
const $c5e1f5474ba6ee56$var$calculateHeight = (width, ratio)=>{
    return ratio === "32x9" ? Math.round((width ?? 0) * 9 / 32) : ratio === "16x9" ? Math.round((width ?? 0) * 9 / 16) : Math.round((width ?? 0) * 9 / 21);
};
const $c5e1f5474ba6ee56$var$RecipeImage = ({ url: url, width: width, ratio: ratio, placement: placement, title: title, sourceHeight: sourceHeight, sourceWidth: sourceWidth, className: className = "", ...rest })=>{
    const height = $c5e1f5474ba6ee56$var$calculateHeight(width, ratio);
    let maxWidth = width;
    let maxHeight = height;
    if (sourceWidth && sourceHeight) {
        if (sourceWidth < maxWidth || sourceHeight < maxHeight) {
            maxWidth = sourceWidth;
            maxHeight = $c5e1f5474ba6ee56$var$calculateHeight(maxWidth, ratio);
            if (maxHeight > sourceHeight) {
                maxWidth = sourceWidth * sourceHeight / maxHeight;
                maxHeight = sourceHeight;
            }
        }
    }
    const sizes = (0, $65KWP.generateSizesFromMaxSize)(maxWidth, maxHeight);
    const sourceSetItems = (0, $65KWP.createSourceSet)(sizes, (width, height)=>$c5e1f5474ba6ee56$var$urlForWidthAndHeight(url, width, height));
    const itemsForSourceTags = sourceSetItems.filter((sourceSetItem)=>sourceSetItem.media.length > 0);
    const itemForImgTag = sourceSetItems.find((sourceSetItem)=>sourceSetItem.media.length === 0);
    const preferredLoadingStrategy = placement === "aboveFold" ? "eager" : "lazy";
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("picture", {
            children: [
                itemsForSourceTags.map((sourceSetItem)=>/*#__PURE__*/ (0, $7YWoO.jsx)("source", {
                        srcSet: sourceSetItem.url,
                        media: sourceSetItem.media,
                        width: sourceSetItem.width,
                        height: sourceSetItem.height
                    }, sourceSetItem.media + sourceSetItem.width)),
                itemForImgTag && /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                    ...rest,
                    className: `h-full w-full rounded ${className}`,
                    alt: title,
                    src: itemForImgTag.url,
                    width: itemForImgTag.width,
                    height: itemForImgTag.height,
                    loading: preferredLoadingStrategy
                })
            ]
        })
    });
};
var $c5e1f5474ba6ee56$export$2e2bcd8739ae039 = $c5e1f5474ba6ee56$var$RecipeImage;

});



parcelRegister("aLOhe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04350ffc4b48b318$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");

var $8hgoS = parcelRequire("8hgoS");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $j6ChH = parcelRequire("j6ChH");

var $88FA0 = parcelRequire("88FA0");

var $duLFK = parcelRequire("duLFK");

var $jlTfJ = parcelRequire("jlTfJ");

var $isIf6 = parcelRequire("isIf6");

var $lcnZZ = parcelRequire("lcnZZ");

var $bUlre = parcelRequire("bUlre");

var $kbPiX = parcelRequire("kbPiX");

var $5klIC = parcelRequire("5klIC");
const $04350ffc4b48b318$var$Section = ({ id: id, section: section })=>{
    if (!(0, $jlTfJ.default).sectionContent[id]) (0, $Kk7R3.runInAction)(()=>{
        (0, $jlTfJ.default).sectionContent[id] = (0, $duLFK.initializeWithDefaultData)([]);
    });
    const sectionContent = (0, $jlTfJ.default).sectionContent[id];
    if ((0, $duLFK.isDefaultData)(sectionContent)) (0, $jlTfJ.default).fetchSectionContentForId(id);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bUlre.default), {}),
            !!section.fields.title && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j6ChH.Helmet), {
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("title", {
                    children: `${section.fields.title} - ${(0, $isIf6.default).siteName}`
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5klIC.default), {}),
            (0, $duLFK.isDataAvailable)(sectionContent) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid), {
                cols: {
                    base: 1,
                    sm: 2,
                    md: 3,
                    lg: 4
                },
                gap: 4,
                children: sectionContent.data.map((object)=>{
                    if (object.sys.contentType.sys.id === "recipe") {
                        const recipeContent = object;
                        const id = recipeContent.sys.id;
                        const recipe = recipeContent.fields.recipeData;
                        const title = recipeContent.fields.title;
                        if (recipe) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kbPiX.default), {
                            id: id,
                            recipe: recipe,
                            title: title
                        }, `recipe-teaser-${object.sys.id}`);
                    } else {
                        const article = object;
                        const id = article.sys.id;
                        const callToAction = article.fields.callToAction || article.fields.title || "";
                        const imageId = article.fields.headerImage?.sys.id || "";
                        const subTitle = article.fields.callToActionSubTitle;
                        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lcnZZ.default), {
                            id: id,
                            callToAction: callToAction,
                            imageId: imageId,
                            subTitle: subTitle
                        }, `cta-${id}`);
                    }
                })
            }),
            ((0, $duLFK.isDefaultData)(sectionContent) || (0, $duLFK.isWaitingForData)(sectionContent)) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid), {
                cols: 4,
                gap: 4,
                children: (0, $8hgoS.default)(6).map((x)=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
                            width: "100%",
                            style: {
                                paddingBottom: "56.24%"
                            }
                        })
                    }, `skeleton${x}`))
            })
        ]
    });
};
var $04350ffc4b48b318$export$2e2bcd8739ae039 = (0, $gBcml.observer)($04350ffc4b48b318$var$Section);

});
parcelRegister("8hgoS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $606ca200e600e0ae$export$2e2bcd8739ae039; });

var $96UMd = parcelRequire("96UMd");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $606ca200e600e0ae$var$range = (0, $96UMd.default)();
var $606ca200e600e0ae$export$2e2bcd8739ae039 = $606ca200e600e0ae$var$range;

});
parcelRegister("96UMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a20b74366b33304$export$2e2bcd8739ae039; });

var $j4NzT = parcelRequire("j4NzT");

var $e0K8B = parcelRequire("e0K8B");

var $9dNfM = parcelRequire("9dNfM");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $6a20b74366b33304$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && (0, $e0K8B.default)(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = (0, $9dNfM.default)(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = (0, $9dNfM.default)(end);
        step = step === undefined ? start < end ? 1 : -1 : (0, $9dNfM.default)(step);
        return (0, $j4NzT.default)(start, end, step, fromRight);
    };
}
var $6a20b74366b33304$export$2e2bcd8739ae039 = $6a20b74366b33304$var$createRange;

});
parcelRegister("j4NzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de34d92d85edacc3$export$2e2bcd8739ae039; });
/* Built-in method references for those with the same name as other `lodash` methods. */ var $de34d92d85edacc3$var$nativeCeil = Math.ceil, $de34d92d85edacc3$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $de34d92d85edacc3$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $de34d92d85edacc3$var$nativeMax($de34d92d85edacc3$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
var $de34d92d85edacc3$export$2e2bcd8739ae039 = $de34d92d85edacc3$var$baseRange;

});



parcelRegister("lcnZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09684257ffaaa87f$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $9yKIH = parcelRequire("9yKIH");

var $eADXL = parcelRequire("eADXL");
const $09684257ffaaa87f$var$CallToAction = ({ id: id, imageId: imageId, callToAction: callToAction, subTitle: subTitle })=>{
    if (!(0, $9yKIH.default).isArticleVisible(id)) return null;
    if (!imageId) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eADXL.default), {
        id: id,
        type: "article",
        imageWithFocusId: imageId,
        title: callToAction,
        subTitle: subTitle
    });
};
var $09684257ffaaa87f$export$2e2bcd8739ae039 = (0, $gBcml.observer)($09684257ffaaa87f$var$CallToAction);

});

parcelRegister("5klIC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $383d320dd2a68d0d$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");
var $jOOuf = parcelRequire("jOOuf");

var $izjX7 = parcelRequire("izjX7");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $duLFK = parcelRequire("duLFK");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $95N1g = parcelRequire("95N1g");
const $383d320dd2a68d0d$var$sectionHasContent = (sectionId)=>{
    return (0, $jlTfJ.default).urlData.data.some((urlData)=>urlData.visibleInSections?.includes(sectionId) && (urlData.type !== "v2_article" || (0, $9yKIH.default).isArticleVisible(urlData.id)));
};
const $383d320dd2a68d0d$var$mainSectionStyles = (active)=>(0, $izjX7.cn)("h-full rounded bg-surface-default p-4 shadow-sm hover:bg-surface-default-hover", {
        "bg-surface-default-hover": active
    });
const $383d320dd2a68d0d$var$MainSection = (0, $gBcml.observer)(({ section: section, active: active, label: label })=>{
    const sectionId = section?.sys.id || "";
    const urlData = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.id === sectionId);
    if (!$383d320dd2a68d0d$var$sectionHasContent(sectionId)) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
            to: `/${urlData?.fullUrl}`,
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: $383d320dd2a68d0d$var$mainSectionStyles(active),
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "font-bold",
                        children: section?.fields.title ?? label
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "text-sm",
                        children: section?.fields.description
                    })
                ]
            })
        })
    });
});
const $383d320dd2a68d0d$var$TagSection = (0, $gBcml.observer)(({ section: section, label: label, active: active })=>{
    const sectionId = section?.sys.id || "";
    const urlData = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.id === sectionId);
    if (!$383d320dd2a68d0d$var$sectionHasContent(sectionId)) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $95N1g.default), {
        url: `/${urlData?.fullUrl}`,
        label: label ?? section?.fields.title ?? "Mangler tittel",
        isActive: active
    });
});
const $383d320dd2a68d0d$var$SectionNavigator = ()=>{
    const { fullUrl: fullUrl } = (0, $8kt8E.useParams)();
    const rootNodeSlug = fullUrl?.split("/")[0];
    const mainSectionSlug = fullUrl?.split("/")[1];
    const tagSectionSlug = fullUrl?.split("/")[2];
    if ((0, $bEEBX.default)(rootNodeSlug)) return "Unable to determine current root node";
    if (!(0, $duLFK.isDataAvailable)((0, $jlTfJ.default).urlData) || !(0, $duLFK.isDataAvailable)((0, $jlTfJ.default).sections)) return null;
    const rootNode = (0, $jlTfJ.default).urlData.data.find((urlData)=>urlData.fullUrl === rootNodeSlug);
    const mainSections = (0, $jlTfJ.default).sections.data.filter((section)=>section.fields.parentId === rootNode?.id);
    const selectedMainSection = mainSections.find((section)=>section.fields.slug === mainSectionSlug);
    const tags = selectedMainSection ? (0, $jlTfJ.default).sections.data.filter((section)=>section.fields.parentId === selectedMainSection.sys.id) : [];
    const selectedTagSection = tags.find((section)=>section.fields.slug === tagSectionSlug);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid), {
                cols: {
                    base: 1,
                    sm: 2,
                    md: 3,
                    lg: 4
                },
                gap: 4,
                className: "mb-3",
                children: mainSections.map((section)=>/*#__PURE__*/ (0, $7YWoO.jsx)($383d320dd2a68d0d$var$MainSection, {
                        active: section.fields.slug === mainSectionSlug,
                        section: section
                    }, section.sys.id))
            }),
            tags.length > 0 && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                className: "mb-5",
                justify: "start",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)($383d320dd2a68d0d$var$TagSection, {
                        label: "Alle",
                        section: selectedMainSection,
                        active: (0, $bEEBX.default)(selectedTagSection)
                    }),
                    tags.map((tag)=>/*#__PURE__*/ (0, $7YWoO.jsx)($383d320dd2a68d0d$var$TagSection, {
                            active: tag.fields.slug === tagSectionSlug,
                            section: tag
                        }, tag.sys.id))
                ]
            })
        ]
    });
};
var $383d320dd2a68d0d$export$2e2bcd8739ae039 = (0, $gBcml.observer)($383d320dd2a68d0d$var$SectionNavigator);

});
parcelRegister("95N1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45e432903c173039$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $6pY3b = parcelRequire("6pY3b");
const $45e432903c173039$var$styles = (isActive, invertedHover)=>(0, $izjX7.cn)("text-nowrap rounded-lg border border-solid border-ink-border-subtle", "px-4 py-2 text-sm", {
        "hover:bg-surface-default-hover bg-surface-default": !invertedHover,
        "bg-surface-default-hover hover:bg-surface-default": invertedHover,
        "bg-button-primary-bg hover:bg-button-primary-bg-hover !text-button-primary-text": isActive
    });
const $45e432903c173039$var$TagLink = ({ url: url, label: label, isActive: isActive = false, className: className = "", linkClassName: linkClassName = "", trackingLocationName: trackingLocationName, linkName: linkName, onClick: onClick, invertedHover: invertedHover = false })=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.WouterLinkWithTracking), {
        to: url,
        className: linkClassName,
        trackingLocationName: trackingLocationName,
        linkName: linkName,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: (0, $izjX7.cn)($45e432903c173039$var$styles(isActive, invertedHover), className),
            children: label
        })
    });
var $45e432903c173039$export$2e2bcd8739ae039 = $45e432903c173039$var$TagLink;

});



parcelRegister("jnpfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29a57ba6876f9ffc$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $8ICkW = parcelRequire("8ICkW");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $fj1oy = parcelRequire("fj1oy");

var $9yKIH = parcelRequire("9yKIH");

var $aFpyD = parcelRequire("aFpyD");

var $cLfby = parcelRequire("cLfby");
const $29a57ba6876f9ffc$var$TextAndImage = ({ content: content })=>{
    const inspectorProps = (0, $8ICkW.useContentfulInspectorMode)();
    const isVisible = (0, $fj1oy.getModuleVisibility)(content, (0, $9yKIH.default).currentCustomerProperties);
    if (!isVisible) return null;
    if (!content.fields) return null;
    const entryId = content.sys.id;
    const image = content.fields.image;
    const imagePosition = content.fields.imagePosition;
    const ratio = content.fields.imageSize ?? "Standard";
    const className = (0, $izjX7.cn)("flex flex-col items-center justify-center gap-6", "lg:flex-row", {
        "lg:flex-row": imagePosition === "Left",
        "lg:flex-row-reverse": imagePosition === "Right"
    });
    const childClassName = "lg:w-1/2";
    const imageClassName = (0, $izjX7.cn)(childClassName, "lg:pt-1", {
        "lg:w-1/3": ratio === "Liten",
        "lg:w-1/2": ratio === "Standard",
        "lg:w-2/3": ratio === "Stor"
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: (0, $izjX7.cn)("w-full max-w-2xl", imageClassName),
                ...inspectorProps({
                    entryId: entryId,
                    fieldId: "image"
                }),
                children: image && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
                    width: 800,
                    ratio: "16x9",
                    entryId: image.sys.id,
                    imageFromParent: image,
                    placement: "belowFold"
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: childClassName,
                ...inspectorProps({
                    entryId: entryId,
                    fieldId: "text"
                }),
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLfby.default), {
                    document: content.fields.text,
                    context: "text-and-image",
                    trackingLocationName: "Text and image"
                })
            })
        ]
    });
};
var $29a57ba6876f9ffc$export$2e2bcd8739ae039 = (0, $gBcml.observer)($29a57ba6876f9ffc$var$TextAndImage);

});




parcelRegister("gb3X9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4df7ddb070c130d$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $9NHzr = parcelRequire("9NHzr");
var $ix4Rx = parcelRequire("ix4Rx");

var $ezbi8 = parcelRequire("ezbi8");

var $izjX7 = parcelRequire("izjX7");

var $khZbR = parcelRequire("khZbR");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $jBO4C = parcelRequire("jBO4C");

var $bHFuk = parcelRequire("bHFuk");

var $jSUEQ = parcelRequire("jSUEQ");

var $dvPqk = parcelRequire("dvPqk");

var $88FA0 = parcelRequire("88FA0");

var $6BXy7 = parcelRequire("6BXy7");

var $gtsdT = parcelRequire("gtsdT");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $duLFK = parcelRequire("duLFK");

var $cLLe3 = parcelRequire("cLLe3");

var $jVrYh = parcelRequire("jVrYh");
const $d4df7ddb070c130d$var$isEmbedTokenExpired = (embedData)=>{
    if (!embedData) return false;
    const expirationData = embedData.expirationDate;
    return expirationData && (0, $khZbR.default)(expirationData);
};
const $d4df7ddb070c130d$var$PowerBIReport = ({ title: title, reportName: reportName, mobileHeightRatio: mobileHeightRatio })=>{
    const [expanded, setExpanded] = (0, $dvPqk.useState)(false);
    const embedData = (0, $jVrYh.default).getEmbedToken(reportName);
    const isExpired = $d4df7ddb070c130d$var$isEmbedTokenExpired(embedData.data);
    (0, $6BXy7.default)(()=>{
        (0, $jVrYh.default).generateEmbedToken(reportName);
    });
    (0, $dvPqk.useEffect)(()=>{
        if ((0, $duLFK.isDataAvailable)(embedData) && isExpired) {
            (0, $gtsdT.logger).log("account", `Embed token for ${reportName} has expired. Fetching new token...`);
            (0, $jVrYh.default).generateEmbedToken(reportName);
        }
    }, [
        isExpired
    ]);
    (0, $dvPqk.useEffect)(()=>{
        const { classList: classList } = document.getElementsByTagName("body")[0];
        if (expanded) classList.add("overflow-hidden");
        else classList.remove("overflow-hidden");
        return ()=>{
            classList.remove("overflow-hidden");
        };
    }, [
        expanded
    ]);
    const toggleExpanded = ()=>setExpanded(!expanded);
    const isMobile = !(0, $gUV6W.default)((0, $5OqMf.mediaQueries).md) && mobileHeightRatio !== false;
    if (!(0, $duLFK.isDataAvailable)(embedData) || !embedData.data) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
                height: 38,
                className: "mb-2"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
                height: 380
            })
        ]
    });
    const data = embedData.data;
    const embedUrl = `https://app.powerbi.com/reportEmbed?reportId=${data.reportId}&groupId=${data.workspaceId}&config=${data.token}`;
    const ExpandCollapseIcon = expanded ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9NHzr.default), {}) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ix4Rx.default), {});
    const h1Class = expanded ? "m-4" : "mb-6";
    const buttonClass = expanded ? "mr-4" : "";
    const containerClasses = (0, $izjX7.cn)("keyfigures", {
        "hidden sm:block": !mobileHeightRatio,
        "fixed inset-0 z-[200] bg-surface-default": expanded
    });
    const mobileWarningClasses = (0, $izjX7.cn)({
        "block sm:hidden": !mobileHeightRatio,
        hidden: mobileHeightRatio
    });
    const reportSizeClasses = (0, $izjX7.cn)("w-full md:aspect-[16/10] md:w-full", {
        "aspect-[4/1]": mobileHeightRatio === 0.25,
        "aspect-[4/2]": mobileHeightRatio === 0.5,
        "aspect-[4/3]": mobileHeightRatio === 0.75,
        "aspect-square": mobileHeightRatio === 1,
        "aspect-[4/5]": mobileHeightRatio === 1.25,
        "aspect-[2/3]": mobileHeightRatio === 1.5,
        "aspect-[4/7]": mobileHeightRatio === 1.75,
        "aspect-[1/2]": mobileHeightRatio === 2,
        "aspect-[1/3]": mobileHeightRatio === 3,
        "aspect-[1/4]": mobileHeightRatio === 4
    });
    const internalSizeClasses = (0, $izjX7.cn)("h-full");
    const layoutType = isMobile ? {
        layoutType: (0, $jSUEQ.LayoutType).MobilePortrait
    } : {};
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: containerClasses,
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "keyfigures-container",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                                    className: h1Class,
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                    className: (0, $izjX7.cn)("print:hidden", buttonClass),
                                    icon: ExpandCollapseIcon,
                                    size: "compact",
                                    variant: "tertiary",
                                    onClick: toggleExpanded,
                                    children: expanded ? "Lukk fullskjerm" : "Vis fullskjerm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: reportSizeClasses,
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bHFuk.PowerBIEmbed), {
                                cssClassName: internalSizeClasses,
                                embedConfig: {
                                    type: "report",
                                    id: data.reportId,
                                    embedUrl: embedUrl,
                                    permissions: (0, $jBO4C.models).Permissions.Read,
                                    accessToken: data.token,
                                    tokenType: (0, $jBO4C.models).TokenType.Embed,
                                    settings: {
                                        panes: {
                                            filters: {
                                                expanded: false,
                                                visible: false
                                            },
                                            pageNavigation: {
                                                visible: false
                                            }
                                        },
                                        background: (0, $jBO4C.models).BackgroundType.Default,
                                        ...layoutType
                                    }
                                }
                            }, "keyfigures-embed")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: mobileWarningClasses,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                        className: "mb-6",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
                        showCloseButton: false,
                        fullWidth: true,
                        variant: "information",
                        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                            className: "mb-0",
                            children: [
                                title,
                                " er dessverre kun tilgjengelig p\xe5 st\xf8rre skjerm."
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $d4df7ddb070c130d$export$2e2bcd8739ae039 = (0, $gBcml.observer)($d4df7ddb070c130d$var$PowerBIReport);

});
parcelRegister("9NHzr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $722a7ce36347bf29$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $722a7ce36347bf29$var$SvgClose = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M5.7 20 4 18.3l6.3-6.3L4 5.7 5.7 4l6.3 6.3L18.3 4 20 5.7 13.7 12l6.3 6.3-1.7 1.7-6.3-6.3z"
        })
    }));
var $722a7ce36347bf29$export$2e2bcd8739ae039 = $722a7ce36347bf29$var$SvgClose;

});

parcelRegister("ix4Rx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7df14a975522403$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $d7df14a975522403$var$SvgExpandAll = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M11.75 20 7 15.25l1.063-1.062 3.687 3.687 3.688-3.687L16.5 15.25zM8.063 9.813 7 8.75 11.75 4l4.75 4.75-1.062 1.063-3.688-3.688z"
        })
    }));
var $d7df14a975522403$export$2e2bcd8739ae039 = $d7df14a975522403$var$SvgExpandAll;

});

parcelRegister("jBO4C", function(module, exports) {
// powerbi-client v2.23.1
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, ()=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./node_modules/http-post-message/dist/httpPostMessage.js": /*!****************************************************************!*\
  !*** ./node_modules/http-post-message/dist/httpPostMessage.js ***!
  \****************************************************************/ /***/ function(module1) {
                /*! http-post-message v0.2.3 | (c) 2016 Microsoft Corporation MIT */ (function webpackUniversalModuleDefinition(root, factory) {
                    module1.exports = factory();
                })(this, function() {
                    return /******/ function(modules) {
                        /******/ // The module cache
                        /******/ var installedModules = {};
                        /******/ /******/ // The require function
                        /******/ function __nested_webpack_require_626__(moduleId) {
                            /******/ /******/ // Check if module is in cache
                            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                            /******/ /******/ // Create a new module (and put it into the cache)
                            /******/ var module1 = installedModules[moduleId] = {
                                /******/ exports: {},
                                /******/ id: moduleId,
                                /******/ loaded: false
                            };
                            /******/ /******/ // Execute the module function
                            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __nested_webpack_require_626__);
                            /******/ /******/ // Flag the module as loaded
                            /******/ module1.loaded = true;
                            /******/ /******/ // Return the exports of the module
                            /******/ return module1.exports;
                        /******/ }
                        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
                        /******/ __nested_webpack_require_626__.m = modules;
                        /******/ /******/ // expose the module cache
                        /******/ __nested_webpack_require_626__.c = installedModules;
                        /******/ /******/ // __webpack_public_path__
                        /******/ __nested_webpack_require_626__.p = "";
                        /******/ /******/ // Load entry module and return exports
                        /******/ return __nested_webpack_require_626__(0);
                    /******/ }([
                        /* 0 */ /***/ function(module1, exports) {
                            "use strict";
                            var HttpPostMessage = function() {
                                function HttpPostMessage(windowPostMessageProxy, defaultHeaders, defaultTargetWindow) {
                                    if (defaultHeaders === void 0) defaultHeaders = {};
                                    this.defaultHeaders = defaultHeaders;
                                    this.defaultTargetWindow = defaultTargetWindow;
                                    this.windowPostMessageProxy = windowPostMessageProxy;
                                }
                                // TODO: See if it's possible to share tracking properties interface?
                                // The responsibility of knowing how to configure windowPostMessageProxy for http should
                                // live in this http class, but the configuration would need ITrackingProperties
                                // interface which lives in WindowPostMessageProxy. Use <any> type as workaround
                                HttpPostMessage.addTrackingProperties = function(message, trackingProperties) {
                                    message.headers = message.headers || {};
                                    if (trackingProperties && trackingProperties.id) message.headers.id = trackingProperties.id;
                                    return message;
                                };
                                HttpPostMessage.getTrackingProperties = function(message) {
                                    return {
                                        id: message.headers && message.headers.id
                                    };
                                };
                                HttpPostMessage.isErrorMessage = function(message) {
                                    if (typeof (message && message.statusCode) !== 'number') return false;
                                    return !(200 <= message.statusCode && message.statusCode < 300);
                                };
                                HttpPostMessage.prototype.get = function(url, headers, targetWindow) {
                                    if (headers === void 0) headers = {};
                                    if (targetWindow === void 0) targetWindow = this.defaultTargetWindow;
                                    return this.send({
                                        method: "GET",
                                        url: url,
                                        headers: headers
                                    }, targetWindow);
                                };
                                HttpPostMessage.prototype.post = function(url, body, headers, targetWindow) {
                                    if (headers === void 0) headers = {};
                                    if (targetWindow === void 0) targetWindow = this.defaultTargetWindow;
                                    return this.send({
                                        method: "POST",
                                        url: url,
                                        headers: headers,
                                        body: body
                                    }, targetWindow);
                                };
                                HttpPostMessage.prototype.put = function(url, body, headers, targetWindow) {
                                    if (headers === void 0) headers = {};
                                    if (targetWindow === void 0) targetWindow = this.defaultTargetWindow;
                                    return this.send({
                                        method: "PUT",
                                        url: url,
                                        headers: headers,
                                        body: body
                                    }, targetWindow);
                                };
                                HttpPostMessage.prototype.patch = function(url, body, headers, targetWindow) {
                                    if (headers === void 0) headers = {};
                                    if (targetWindow === void 0) targetWindow = this.defaultTargetWindow;
                                    return this.send({
                                        method: "PATCH",
                                        url: url,
                                        headers: headers,
                                        body: body
                                    }, targetWindow);
                                };
                                HttpPostMessage.prototype.delete = function(url, body, headers, targetWindow) {
                                    if (body === void 0) body = null;
                                    if (headers === void 0) headers = {};
                                    if (targetWindow === void 0) targetWindow = this.defaultTargetWindow;
                                    return this.send({
                                        method: "DELETE",
                                        url: url,
                                        headers: headers,
                                        body: body
                                    }, targetWindow);
                                };
                                HttpPostMessage.prototype.send = function(request, targetWindow) {
                                    if (targetWindow === void 0) targetWindow = this.defaultTargetWindow;
                                    request.headers = this.assign({}, this.defaultHeaders, request.headers);
                                    if (!targetWindow) throw new Error("target window is not provided.  You must either provide the target window explicitly as argument to request, or specify default target window when constructing instance of this class.");
                                    return this.windowPostMessageProxy.postMessage(targetWindow, request);
                                };
                                /**
	     * Object.assign() polyfill
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	     */ HttpPostMessage.prototype.assign = function(target) {
                                    var sources = [];
                                    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
                                    if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
                                    var output = Object(target);
                                    sources.forEach(function(source) {
                                        if (source !== undefined && source !== null) {
                                            for(var nextKey in source)if (Object.prototype.hasOwnProperty.call(source, nextKey)) output[nextKey] = source[nextKey];
                                        }
                                    });
                                    return output;
                                };
                                return HttpPostMessage;
                            }();
                            exports.HttpPostMessage = HttpPostMessage;
                        /***/ }
                    ]);
                });
            //# sourceMappingURL=httpPostMessage.js.map
            /***/ },
            /***/ "./node_modules/powerbi-models/dist/models.js": /*!****************************************************!*\
  !*** ./node_modules/powerbi-models/dist/models.js ***!
  \****************************************************/ /***/ function(module1) {
                // powerbi-models v1.15.2
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                (function webpackUniversalModuleDefinition(root, factory) {
                    module1.exports = factory();
                })(this, ()=>{
                    return /******/ (()=>{
                        /******/ var __webpack_modules__ = [
                            /* 0 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_612__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.CommonErrorCodes = exports.BookmarksPlayMode = exports.ExportDataType = exports.QnaMode = exports.PageNavigationPosition = exports.BrowserPrintAdjustmentsMode = exports.AggregateFunction = exports.DataCacheMode = exports.CredentialType = exports.isPercentOfGrandTotal = exports.isColumnAggr = exports.isHierarchyLevelAggr = exports.isHierarchyLevel = exports.isColumn = exports.isMeasure = exports.getFilterType = exports.isBasicFilterWithKeys = exports.isFilterKeyColumnsTarget = exports.HierarchyIdentityFilter = exports.HierarchyFilter = exports.AdvancedFilter = exports.TupleFilter = exports.IdentityFilter = exports.BasicFilterWithKeys = exports.BasicFilter = exports.RelativeTimeFilter = exports.RelativeDateFilter = exports.TopNFilter = exports.IncludeExcludeFilter = exports.NotSupportedFilter = exports.Filter = exports.RelativeDateOperators = exports.RelativeDateFilterTimeUnit = exports.FilterType = exports.FiltersLevel = exports.FiltersOperations = exports.MenuLocation = exports.ContrastMode = exports.TokenType = exports.ViewMode = exports.Permissions = exports.SectionVisibility = exports.ReportAlignment = exports.HyperlinkClickBehavior = exports.LayoutType = exports.VisualContainerDisplayMode = exports.BackgroundType = exports.DisplayOption = exports.PageSizeType = exports.TraceType = void 0;
                                exports.validateExportDataRequest = exports.validateQnaInterpretInputData = exports.validateLoadQnaConfiguration = exports.validateSaveAsParameters = exports.validateUpdateFiltersRequest = exports.validateFilter = exports.validatePage = exports.validateTileLoad = exports.validateDashboardLoad = exports.validateQuickCreate = exports.validateCreateReport = exports.validatePaginatedReportLoad = exports.validateReportLoad = exports.validateMenuGroupExtension = exports.validateExtension = exports.validateCustomPageSize = exports.validateVisualizationsPane = exports.validateSyncSlicersPane = exports.validateSelectionPane = exports.validatePageNavigationPane = exports.validateFieldsPane = exports.validateFiltersPane = exports.validateBookmarksPane = exports.validatePanes = exports.validateSettings = exports.validateCaptureBookmarkRequest = exports.validateApplyBookmarkStateRequest = exports.validateApplyBookmarkByNameRequest = exports.validateAddBookmarkRequest = exports.validatePlayBookmarkRequest = exports.validateSlicerState = exports.validateSlicer = exports.validateVisualSelector = exports.isIExtensionArray = exports.isIExtensions = exports.isGroupedMenuExtension = exports.isFlatMenuExtension = exports.isReportFiltersArray = exports.isOnLoadFilters = exports.VisualDataRoleKindPreference = exports.VisualDataRoleKind = exports.CommandDisplayOption = exports.SlicerTargetSelector = exports.VisualTypeSelector = exports.VisualSelector = exports.PageSelector = exports.Selector = exports.SortDirection = exports.LegendPosition = exports.TextAlignment = void 0;
                                exports.validatePrintSettings = exports.validateZoomLevel = exports.validateCustomTheme = exports.validateCommandsSettings = exports.validateVisualSettings = exports.validateVisualHeader = void 0;
                                var validator_1 = __nested_webpack_require_612__(1);
                                var TraceType;
                                (function(TraceType) {
                                    TraceType[TraceType["Information"] = 0] = "Information";
                                    TraceType[TraceType["Verbose"] = 1] = "Verbose";
                                    TraceType[TraceType["Warning"] = 2] = "Warning";
                                    TraceType[TraceType["Error"] = 3] = "Error";
                                    TraceType[TraceType["ExpectedError"] = 4] = "ExpectedError";
                                    TraceType[TraceType["UnexpectedError"] = 5] = "UnexpectedError";
                                    TraceType[TraceType["Fatal"] = 6] = "Fatal";
                                })(TraceType = exports.TraceType || (exports.TraceType = {}));
                                var PageSizeType;
                                (function(PageSizeType) {
                                    PageSizeType[PageSizeType["Widescreen"] = 0] = "Widescreen";
                                    PageSizeType[PageSizeType["Standard"] = 1] = "Standard";
                                    PageSizeType[PageSizeType["Cortana"] = 2] = "Cortana";
                                    PageSizeType[PageSizeType["Letter"] = 3] = "Letter";
                                    PageSizeType[PageSizeType["Custom"] = 4] = "Custom";
                                    PageSizeType[PageSizeType["Mobile"] = 5] = "Mobile";
                                })(PageSizeType = exports.PageSizeType || (exports.PageSizeType = {}));
                                var DisplayOption;
                                (function(DisplayOption) {
                                    DisplayOption[DisplayOption["FitToPage"] = 0] = "FitToPage";
                                    DisplayOption[DisplayOption["FitToWidth"] = 1] = "FitToWidth";
                                    DisplayOption[DisplayOption["ActualSize"] = 2] = "ActualSize";
                                })(DisplayOption = exports.DisplayOption || (exports.DisplayOption = {}));
                                var BackgroundType;
                                (function(BackgroundType) {
                                    BackgroundType[BackgroundType["Default"] = 0] = "Default";
                                    BackgroundType[BackgroundType["Transparent"] = 1] = "Transparent";
                                })(BackgroundType = exports.BackgroundType || (exports.BackgroundType = {}));
                                var VisualContainerDisplayMode;
                                (function(VisualContainerDisplayMode) {
                                    VisualContainerDisplayMode[VisualContainerDisplayMode["Visible"] = 0] = "Visible";
                                    VisualContainerDisplayMode[VisualContainerDisplayMode["Hidden"] = 1] = "Hidden";
                                })(VisualContainerDisplayMode = exports.VisualContainerDisplayMode || (exports.VisualContainerDisplayMode = {}));
                                var LayoutType;
                                (function(LayoutType) {
                                    LayoutType[LayoutType["Master"] = 0] = "Master";
                                    LayoutType[LayoutType["Custom"] = 1] = "Custom";
                                    LayoutType[LayoutType["MobilePortrait"] = 2] = "MobilePortrait";
                                    LayoutType[LayoutType["MobileLandscape"] = 3] = "MobileLandscape";
                                })(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
                                var HyperlinkClickBehavior;
                                (function(HyperlinkClickBehavior) {
                                    HyperlinkClickBehavior[HyperlinkClickBehavior["Navigate"] = 0] = "Navigate";
                                    HyperlinkClickBehavior[HyperlinkClickBehavior["NavigateAndRaiseEvent"] = 1] = "NavigateAndRaiseEvent";
                                    HyperlinkClickBehavior[HyperlinkClickBehavior["RaiseEvent"] = 2] = "RaiseEvent";
                                })(HyperlinkClickBehavior = exports.HyperlinkClickBehavior || (exports.HyperlinkClickBehavior = {}));
                                var ReportAlignment;
                                (function(ReportAlignment) {
                                    ReportAlignment[ReportAlignment["Left"] = 0] = "Left";
                                    ReportAlignment[ReportAlignment["Center"] = 1] = "Center";
                                    ReportAlignment[ReportAlignment["Right"] = 2] = "Right";
                                    ReportAlignment[ReportAlignment["None"] = 3] = "None";
                                })(ReportAlignment = exports.ReportAlignment || (exports.ReportAlignment = {}));
                                var SectionVisibility;
                                (function(SectionVisibility) {
                                    SectionVisibility[SectionVisibility["AlwaysVisible"] = 0] = "AlwaysVisible";
                                    SectionVisibility[SectionVisibility["HiddenInViewMode"] = 1] = "HiddenInViewMode";
                                })(SectionVisibility = exports.SectionVisibility || (exports.SectionVisibility = {}));
                                var Permissions;
                                (function(Permissions) {
                                    Permissions[Permissions["Read"] = 0] = "Read";
                                    Permissions[Permissions["ReadWrite"] = 1] = "ReadWrite";
                                    Permissions[Permissions["Copy"] = 2] = "Copy";
                                    Permissions[Permissions["Create"] = 4] = "Create";
                                    Permissions[Permissions["All"] = 7] = "All";
                                })(Permissions = exports.Permissions || (exports.Permissions = {}));
                                var ViewMode;
                                (function(ViewMode) {
                                    ViewMode[ViewMode["View"] = 0] = "View";
                                    ViewMode[ViewMode["Edit"] = 1] = "Edit";
                                })(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
                                var TokenType;
                                (function(TokenType) {
                                    TokenType[TokenType["Aad"] = 0] = "Aad";
                                    TokenType[TokenType["Embed"] = 1] = "Embed";
                                })(TokenType = exports.TokenType || (exports.TokenType = {}));
                                var ContrastMode;
                                (function(ContrastMode) {
                                    ContrastMode[ContrastMode["None"] = 0] = "None";
                                    ContrastMode[ContrastMode["HighContrast1"] = 1] = "HighContrast1";
                                    ContrastMode[ContrastMode["HighContrast2"] = 2] = "HighContrast2";
                                    ContrastMode[ContrastMode["HighContrastBlack"] = 3] = "HighContrastBlack";
                                    ContrastMode[ContrastMode["HighContrastWhite"] = 4] = "HighContrastWhite";
                                })(ContrastMode = exports.ContrastMode || (exports.ContrastMode = {}));
                                var MenuLocation;
                                (function(MenuLocation) {
                                    MenuLocation[MenuLocation["Bottom"] = 0] = "Bottom";
                                    MenuLocation[MenuLocation["Top"] = 1] = "Top";
                                })(MenuLocation = exports.MenuLocation || (exports.MenuLocation = {}));
                                var FiltersOperations;
                                (function(FiltersOperations) {
                                    FiltersOperations[FiltersOperations["RemoveAll"] = 0] = "RemoveAll";
                                    FiltersOperations[FiltersOperations["ReplaceAll"] = 1] = "ReplaceAll";
                                    FiltersOperations[FiltersOperations["Add"] = 2] = "Add";
                                    FiltersOperations[FiltersOperations["Replace"] = 3] = "Replace";
                                })(FiltersOperations = exports.FiltersOperations || (exports.FiltersOperations = {}));
                                var FiltersLevel;
                                (function(FiltersLevel) {
                                    FiltersLevel[FiltersLevel["Report"] = 0] = "Report";
                                    FiltersLevel[FiltersLevel["Page"] = 1] = "Page";
                                    FiltersLevel[FiltersLevel["Visual"] = 2] = "Visual";
                                })(FiltersLevel = exports.FiltersLevel || (exports.FiltersLevel = {}));
                                var FilterType;
                                (function(FilterType) {
                                    FilterType[FilterType["Advanced"] = 0] = "Advanced";
                                    FilterType[FilterType["Basic"] = 1] = "Basic";
                                    FilterType[FilterType["Unknown"] = 2] = "Unknown";
                                    FilterType[FilterType["IncludeExclude"] = 3] = "IncludeExclude";
                                    FilterType[FilterType["RelativeDate"] = 4] = "RelativeDate";
                                    FilterType[FilterType["TopN"] = 5] = "TopN";
                                    FilterType[FilterType["Tuple"] = 6] = "Tuple";
                                    FilterType[FilterType["RelativeTime"] = 7] = "RelativeTime";
                                    FilterType[FilterType["Identity"] = 8] = "Identity";
                                    FilterType[FilterType["Hierarchy"] = 9] = "Hierarchy";
                                    FilterType[FilterType["HierarchyIdentity"] = 10] = "HierarchyIdentity";
                                })(FilterType = exports.FilterType || (exports.FilterType = {}));
                                var RelativeDateFilterTimeUnit;
                                (function(RelativeDateFilterTimeUnit) {
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Days"] = 0] = "Days";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Weeks"] = 1] = "Weeks";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarWeeks"] = 2] = "CalendarWeeks";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Months"] = 3] = "Months";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarMonths"] = 4] = "CalendarMonths";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Years"] = 5] = "Years";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarYears"] = 6] = "CalendarYears";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Minutes"] = 7] = "Minutes";
                                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Hours"] = 8] = "Hours";
                                })(RelativeDateFilterTimeUnit = exports.RelativeDateFilterTimeUnit || (exports.RelativeDateFilterTimeUnit = {}));
                                var RelativeDateOperators;
                                (function(RelativeDateOperators) {
                                    RelativeDateOperators[RelativeDateOperators["InLast"] = 0] = "InLast";
                                    RelativeDateOperators[RelativeDateOperators["InThis"] = 1] = "InThis";
                                    RelativeDateOperators[RelativeDateOperators["InNext"] = 2] = "InNext";
                                })(RelativeDateOperators = exports.RelativeDateOperators || (exports.RelativeDateOperators = {}));
                                var Filter = /** @class */ function() {
                                    function Filter(target, filterType) {
                                        this.target = target;
                                        this.filterType = filterType;
                                    }
                                    Filter.prototype.toJSON = function() {
                                        var filter = {
                                            $schema: this.schemaUrl,
                                            target: this.target,
                                            filterType: this.filterType
                                        };
                                        // Add displaySettings only when defined
                                        if (this.displaySettings !== undefined) filter.displaySettings = this.displaySettings;
                                        return filter;
                                    };
                                    return Filter;
                                }();
                                exports.Filter = Filter;
                                var NotSupportedFilter = /** @class */ function(_super) {
                                    __extends(NotSupportedFilter, _super);
                                    function NotSupportedFilter(target, message, notSupportedTypeName) {
                                        var _this = _super.call(this, target, FilterType.Unknown) || this;
                                        _this.message = message;
                                        _this.notSupportedTypeName = notSupportedTypeName;
                                        _this.schemaUrl = NotSupportedFilter.schemaUrl;
                                        return _this;
                                    }
                                    NotSupportedFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.message = this.message;
                                        filter.notSupportedTypeName = this.notSupportedTypeName;
                                        return filter;
                                    };
                                    NotSupportedFilter.schemaUrl = "http://powerbi.com/product/schema#notSupported";
                                    return NotSupportedFilter;
                                }(Filter);
                                exports.NotSupportedFilter = NotSupportedFilter;
                                var IncludeExcludeFilter = /** @class */ function(_super) {
                                    __extends(IncludeExcludeFilter, _super);
                                    function IncludeExcludeFilter(target, isExclude, values) {
                                        var _this = _super.call(this, target, FilterType.IncludeExclude) || this;
                                        _this.target = target;
                                        _this.values = values;
                                        _this.isExclude = isExclude;
                                        _this.schemaUrl = IncludeExcludeFilter.schemaUrl;
                                        return _this;
                                    }
                                    IncludeExcludeFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.isExclude = this.isExclude;
                                        filter.values = this.values;
                                        return filter;
                                    };
                                    IncludeExcludeFilter.schemaUrl = "http://powerbi.com/product/schema#includeExclude";
                                    return IncludeExcludeFilter;
                                }(Filter);
                                exports.IncludeExcludeFilter = IncludeExcludeFilter;
                                var TopNFilter = /** @class */ function(_super) {
                                    __extends(TopNFilter, _super);
                                    function TopNFilter(target, operator, itemCount, orderBy) {
                                        var _this = _super.call(this, target, FilterType.TopN) || this;
                                        _this.operator = operator;
                                        _this.itemCount = itemCount;
                                        _this.schemaUrl = TopNFilter.schemaUrl;
                                        _this.orderBy = orderBy;
                                        return _this;
                                    }
                                    TopNFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.operator = this.operator;
                                        filter.itemCount = this.itemCount;
                                        filter.orderBy = this.orderBy;
                                        return filter;
                                    };
                                    TopNFilter.schemaUrl = "http://powerbi.com/product/schema#topN";
                                    return TopNFilter;
                                }(Filter);
                                exports.TopNFilter = TopNFilter;
                                var RelativeDateFilter = /** @class */ function(_super) {
                                    __extends(RelativeDateFilter, _super);
                                    function RelativeDateFilter(target, operator, timeUnitsCount, timeUnitType, includeToday) {
                                        var _this = _super.call(this, target, FilterType.RelativeDate) || this;
                                        _this.operator = operator;
                                        _this.timeUnitsCount = timeUnitsCount;
                                        _this.timeUnitType = timeUnitType;
                                        _this.includeToday = includeToday;
                                        _this.schemaUrl = RelativeDateFilter.schemaUrl;
                                        return _this;
                                    }
                                    RelativeDateFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.operator = this.operator;
                                        filter.timeUnitsCount = this.timeUnitsCount;
                                        filter.timeUnitType = this.timeUnitType;
                                        filter.includeToday = this.includeToday;
                                        return filter;
                                    };
                                    RelativeDateFilter.schemaUrl = "http://powerbi.com/product/schema#relativeDate";
                                    return RelativeDateFilter;
                                }(Filter);
                                exports.RelativeDateFilter = RelativeDateFilter;
                                var RelativeTimeFilter = /** @class */ function(_super) {
                                    __extends(RelativeTimeFilter, _super);
                                    function RelativeTimeFilter(target, operator, timeUnitsCount, timeUnitType) {
                                        var _this = _super.call(this, target, FilterType.RelativeTime) || this;
                                        _this.operator = operator;
                                        _this.timeUnitsCount = timeUnitsCount;
                                        _this.timeUnitType = timeUnitType;
                                        _this.schemaUrl = RelativeTimeFilter.schemaUrl;
                                        return _this;
                                    }
                                    RelativeTimeFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.operator = this.operator;
                                        filter.timeUnitsCount = this.timeUnitsCount;
                                        filter.timeUnitType = this.timeUnitType;
                                        return filter;
                                    };
                                    RelativeTimeFilter.schemaUrl = "http://powerbi.com/product/schema#relativeTime";
                                    return RelativeTimeFilter;
                                }(Filter);
                                exports.RelativeTimeFilter = RelativeTimeFilter;
                                var BasicFilter = /** @class */ function(_super) {
                                    __extends(BasicFilter, _super);
                                    function BasicFilter(target, operator) {
                                        var values = [];
                                        for(var _i = 2; _i < arguments.length; _i++)values[_i - 2] = arguments[_i];
                                        var _this = _super.call(this, target, FilterType.Basic) || this;
                                        _this.operator = operator;
                                        _this.schemaUrl = BasicFilter.schemaUrl;
                                        if (values.length === 0 && operator !== "All") throw new Error("values must be a non-empty array unless your operator is \"All\".");
                                        /**
         * Accept values as array instead of as individual arguments
         * new BasicFilter('a', 'b', 1, 2);
         * new BasicFilter('a', 'b', [1,2]);
         */ if (Array.isArray(values[0])) // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                                        _this.values = values[0];
                                        else _this.values = values;
                                        return _this;
                                    }
                                    BasicFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.operator = this.operator;
                                        filter.values = this.values;
                                        filter.requireSingleSelection = !!this.requireSingleSelection;
                                        return filter;
                                    };
                                    BasicFilter.schemaUrl = "http://powerbi.com/product/schema#basic";
                                    return BasicFilter;
                                }(Filter);
                                exports.BasicFilter = BasicFilter;
                                var BasicFilterWithKeys = /** @class */ function(_super) {
                                    __extends(BasicFilterWithKeys, _super);
                                    function BasicFilterWithKeys(target, operator, values, keyValues) {
                                        var _this = _super.call(this, target, operator, values) || this;
                                        _this.keyValues = keyValues;
                                        _this.target = target;
                                        var numberOfKeys = target.keys ? target.keys.length : 0;
                                        if (numberOfKeys > 0 && !keyValues) throw new Error("You should pass the values to be filtered for each key. You passed: no values and ".concat(numberOfKeys, " keys"));
                                        if (numberOfKeys === 0 && keyValues && keyValues.length > 0) throw new Error("You passed key values but your target object doesn't contain the keys to be filtered");
                                        for(var _i = 0, _a = _this.keyValues; _i < _a.length; _i++){
                                            var keyValue = _a[_i];
                                            if (keyValue) {
                                                var lengthOfArray = keyValue.length;
                                                if (lengthOfArray !== numberOfKeys) throw new Error("Each tuple of key values should contain a value for each of the keys. You passed: ".concat(lengthOfArray, " values and ").concat(numberOfKeys, " keys"));
                                            }
                                        }
                                        return _this;
                                    }
                                    BasicFilterWithKeys.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.keyValues = this.keyValues;
                                        return filter;
                                    };
                                    return BasicFilterWithKeys;
                                }(BasicFilter);
                                exports.BasicFilterWithKeys = BasicFilterWithKeys;
                                var IdentityFilter = /** @class */ function(_super) {
                                    __extends(IdentityFilter, _super);
                                    function IdentityFilter(target, operator) {
                                        var _this = _super.call(this, target, FilterType.Identity) || this;
                                        _this.operator = operator;
                                        _this.schemaUrl = IdentityFilter.schemaUrl;
                                        return _this;
                                    }
                                    IdentityFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.operator = this.operator;
                                        filter.target = this.target;
                                        return filter;
                                    };
                                    IdentityFilter.schemaUrl = "http://powerbi.com/product/schema#identity";
                                    return IdentityFilter;
                                }(Filter);
                                exports.IdentityFilter = IdentityFilter;
                                var TupleFilter = /** @class */ function(_super) {
                                    __extends(TupleFilter, _super);
                                    function TupleFilter(target, operator, values) {
                                        var _this = _super.call(this, target, FilterType.Tuple) || this;
                                        _this.operator = operator;
                                        _this.schemaUrl = TupleFilter.schemaUrl;
                                        _this.values = values;
                                        return _this;
                                    }
                                    TupleFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.operator = this.operator;
                                        filter.values = this.values;
                                        filter.target = this.target;
                                        return filter;
                                    };
                                    TupleFilter.schemaUrl = "http://powerbi.com/product/schema#tuple";
                                    return TupleFilter;
                                }(Filter);
                                exports.TupleFilter = TupleFilter;
                                var AdvancedFilter = /** @class */ function(_super) {
                                    __extends(AdvancedFilter, _super);
                                    function AdvancedFilter(target, logicalOperator) {
                                        var conditions = [];
                                        for(var _i = 2; _i < arguments.length; _i++)conditions[_i - 2] = arguments[_i];
                                        var _this = _super.call(this, target, FilterType.Advanced) || this;
                                        _this.schemaUrl = AdvancedFilter.schemaUrl;
                                        // Guard statements
                                        if (typeof logicalOperator !== "string" || logicalOperator.length === 0) // TODO: It would be nicer to list out the possible logical operators.
                                        throw new Error("logicalOperator must be a valid operator, You passed: ".concat(logicalOperator));
                                        _this.logicalOperator = logicalOperator;
                                        var extractedConditions;
                                        /**
         * Accept conditions as array instead of as individual arguments
         * new AdvancedFilter('a', 'b', "And", { value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" });
         * new AdvancedFilter('a', 'b', "And", [{ value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" }]);
         */ if (Array.isArray(conditions[0])) // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                                        extractedConditions = conditions[0];
                                        else extractedConditions = conditions;
                                        if (extractedConditions.length > 2) throw new Error("AdvancedFilters may not have more than two conditions. You passed: ".concat(conditions.length));
                                        if (extractedConditions.length === 1 && logicalOperator !== "And") throw new Error("Logical Operator must be \"And\" when there is only one condition provided");
                                        _this.conditions = extractedConditions;
                                        return _this;
                                    }
                                    AdvancedFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.logicalOperator = this.logicalOperator;
                                        filter.conditions = this.conditions;
                                        return filter;
                                    };
                                    AdvancedFilter.schemaUrl = "http://powerbi.com/product/schema#advanced";
                                    return AdvancedFilter;
                                }(Filter);
                                exports.AdvancedFilter = AdvancedFilter;
                                var HierarchyFilter = /** @class */ function(_super) {
                                    __extends(HierarchyFilter, _super);
                                    function HierarchyFilter(target, hierarchyData) {
                                        var _this = _super.call(this, target, FilterType.Hierarchy) || this;
                                        _this.schemaUrl = HierarchyFilter.schemaUrl;
                                        _this.hierarchyData = hierarchyData;
                                        return _this;
                                    }
                                    HierarchyFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.hierarchyData = this.hierarchyData;
                                        filter.target = this.target;
                                        return filter;
                                    };
                                    HierarchyFilter.schemaUrl = "http://powerbi.com/product/schema#hierarchy";
                                    return HierarchyFilter;
                                }(Filter);
                                exports.HierarchyFilter = HierarchyFilter;
                                var HierarchyIdentityFilter = /** @class */ function(_super) {
                                    __extends(HierarchyIdentityFilter, _super);
                                    function HierarchyIdentityFilter(target, hierarchyData) {
                                        var _this = _super.call(this, target, FilterType.HierarchyIdentity) || this;
                                        _this.schemaUrl = HierarchyIdentityFilter.schemaUrl;
                                        _this.hierarchyData = hierarchyData;
                                        return _this;
                                    }
                                    HierarchyIdentityFilter.prototype.toJSON = function() {
                                        var filter = _super.prototype.toJSON.call(this);
                                        filter.hierarchyData = this.hierarchyData;
                                        filter.target = this.target;
                                        return filter;
                                    };
                                    HierarchyIdentityFilter.schemaUrl = "http://powerbi.com/product/schema#hierarchyIdentity";
                                    return HierarchyIdentityFilter;
                                }(Filter);
                                exports.HierarchyIdentityFilter = HierarchyIdentityFilter;
                                function isFilterKeyColumnsTarget(target) {
                                    return isColumn(target) && !!target.keys;
                                }
                                exports.isFilterKeyColumnsTarget = isFilterKeyColumnsTarget;
                                function isBasicFilterWithKeys(filter) {
                                    return getFilterType(filter) === FilterType.Basic && !!filter.keyValues;
                                }
                                exports.isBasicFilterWithKeys = isBasicFilterWithKeys;
                                function getFilterType(filter) {
                                    if (filter.filterType) return filter.filterType;
                                    var basicFilter = filter;
                                    var advancedFilter = filter;
                                    if (typeof basicFilter.operator === "string" && Array.isArray(basicFilter.values)) return FilterType.Basic;
                                    else if (typeof advancedFilter.logicalOperator === "string" && Array.isArray(advancedFilter.conditions)) return FilterType.Advanced;
                                    else return FilterType.Unknown;
                                }
                                exports.getFilterType = getFilterType;
                                function isMeasure(arg) {
                                    return arg.table !== undefined && arg.measure !== undefined;
                                }
                                exports.isMeasure = isMeasure;
                                function isColumn(arg) {
                                    return !!(arg.table && arg.column && !arg.aggregationFunction);
                                }
                                exports.isColumn = isColumn;
                                function isHierarchyLevel(arg) {
                                    return !!(arg.table && arg.hierarchy && arg.hierarchyLevel && !arg.aggregationFunction);
                                }
                                exports.isHierarchyLevel = isHierarchyLevel;
                                function isHierarchyLevelAggr(arg) {
                                    return !!(arg.table && arg.hierarchy && arg.hierarchyLevel && arg.aggregationFunction);
                                }
                                exports.isHierarchyLevelAggr = isHierarchyLevelAggr;
                                function isColumnAggr(arg) {
                                    return !!(arg.table && arg.column && arg.aggregationFunction);
                                }
                                exports.isColumnAggr = isColumnAggr;
                                function isPercentOfGrandTotal(arg) {
                                    return !!arg.percentOfGrandTotal;
                                }
                                exports.isPercentOfGrandTotal = isPercentOfGrandTotal;
                                var CredentialType;
                                (function(CredentialType) {
                                    CredentialType[CredentialType["NoConnection"] = 0] = "NoConnection";
                                    CredentialType[CredentialType["OnBehalfOf"] = 1] = "OnBehalfOf";
                                    CredentialType[CredentialType["Anonymous"] = 2] = "Anonymous";
                                })(CredentialType = exports.CredentialType || (exports.CredentialType = {}));
                                var DataCacheMode;
                                (function(DataCacheMode) {
                                    DataCacheMode[DataCacheMode["Import"] = 0] = "Import";
                                    DataCacheMode[DataCacheMode["DirectQuery"] = 1] = "DirectQuery";
                                })(DataCacheMode = exports.DataCacheMode || (exports.DataCacheMode = {}));
                                var AggregateFunction;
                                (function(AggregateFunction) {
                                    AggregateFunction[AggregateFunction["Default"] = 1] = "Default";
                                    AggregateFunction[AggregateFunction["None"] = 2] = "None";
                                    AggregateFunction[AggregateFunction["Sum"] = 3] = "Sum";
                                    AggregateFunction[AggregateFunction["Min"] = 4] = "Min";
                                    AggregateFunction[AggregateFunction["Max"] = 5] = "Max";
                                    AggregateFunction[AggregateFunction["Count"] = 6] = "Count";
                                    AggregateFunction[AggregateFunction["Average"] = 7] = "Average";
                                    AggregateFunction[AggregateFunction["DistinctCount"] = 8] = "DistinctCount";
                                })(AggregateFunction = exports.AggregateFunction || (exports.AggregateFunction = {}));
                                var BrowserPrintAdjustmentsMode;
                                (function(BrowserPrintAdjustmentsMode) {
                                    BrowserPrintAdjustmentsMode[BrowserPrintAdjustmentsMode["Default"] = 0] = "Default";
                                    BrowserPrintAdjustmentsMode[BrowserPrintAdjustmentsMode["NoAdjustments"] = 1] = "NoAdjustments";
                                })(BrowserPrintAdjustmentsMode = exports.BrowserPrintAdjustmentsMode || (exports.BrowserPrintAdjustmentsMode = {}));
                                var PageNavigationPosition;
                                (function(PageNavigationPosition) {
                                    PageNavigationPosition[PageNavigationPosition["Bottom"] = 0] = "Bottom";
                                    PageNavigationPosition[PageNavigationPosition["Left"] = 1] = "Left";
                                })(PageNavigationPosition = exports.PageNavigationPosition || (exports.PageNavigationPosition = {}));
                                var QnaMode;
                                (function(QnaMode) {
                                    QnaMode[QnaMode["Interactive"] = 0] = "Interactive";
                                    QnaMode[QnaMode["ResultOnly"] = 1] = "ResultOnly";
                                })(QnaMode = exports.QnaMode || (exports.QnaMode = {}));
                                var ExportDataType;
                                (function(ExportDataType) {
                                    ExportDataType[ExportDataType["Summarized"] = 0] = "Summarized";
                                    ExportDataType[ExportDataType["Underlying"] = 1] = "Underlying";
                                })(ExportDataType = exports.ExportDataType || (exports.ExportDataType = {}));
                                var BookmarksPlayMode;
                                (function(BookmarksPlayMode) {
                                    BookmarksPlayMode[BookmarksPlayMode["Off"] = 0] = "Off";
                                    BookmarksPlayMode[BookmarksPlayMode["Presentation"] = 1] = "Presentation";
                                })(BookmarksPlayMode = exports.BookmarksPlayMode || (exports.BookmarksPlayMode = {}));
                                // This is not an enum because enum strings require
                                // us to upgrade typeScript version and change SDK build definition
                                exports.CommonErrorCodes = {
                                    TokenExpired: 'TokenExpired',
                                    NotFound: 'PowerBIEntityNotFound',
                                    InvalidParameters: 'Invalid parameters',
                                    LoadReportFailed: 'LoadReportFailed',
                                    NotAuthorized: 'PowerBINotAuthorizedException',
                                    FailedToLoadModel: 'ExplorationContainer_FailedToLoadModel_DefaultDetails'
                                };
                                exports.TextAlignment = {
                                    Left: 'left',
                                    Center: 'center',
                                    Right: 'right'
                                };
                                exports.LegendPosition = {
                                    Top: 'Top',
                                    Bottom: 'Bottom',
                                    Right: 'Right',
                                    Left: 'Left',
                                    TopCenter: 'TopCenter',
                                    BottomCenter: 'BottomCenter',
                                    RightCenter: 'RightCenter',
                                    LeftCenter: 'LeftCenter'
                                };
                                var SortDirection;
                                (function(SortDirection) {
                                    SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
                                    SortDirection[SortDirection["Descending"] = 2] = "Descending";
                                })(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
                                var Selector = /** @class */ function() {
                                    function Selector(schema) {
                                        this.$schema = schema;
                                    }
                                    Selector.prototype.toJSON = function() {
                                        return {
                                            $schema: this.$schema
                                        };
                                    };
                                    return Selector;
                                }();
                                exports.Selector = Selector;
                                var PageSelector = /** @class */ function(_super) {
                                    __extends(PageSelector, _super);
                                    function PageSelector(pageName) {
                                        var _this = _super.call(this, PageSelector.schemaUrl) || this;
                                        _this.pageName = pageName;
                                        return _this;
                                    }
                                    PageSelector.prototype.toJSON = function() {
                                        var selector = _super.prototype.toJSON.call(this);
                                        selector.pageName = this.pageName;
                                        return selector;
                                    };
                                    PageSelector.schemaUrl = "http://powerbi.com/product/schema#pageSelector";
                                    return PageSelector;
                                }(Selector);
                                exports.PageSelector = PageSelector;
                                var VisualSelector = /** @class */ function(_super) {
                                    __extends(VisualSelector, _super);
                                    function VisualSelector(visualName) {
                                        var _this = _super.call(this, VisualSelector.schemaUrl) || this;
                                        _this.visualName = visualName;
                                        return _this;
                                    }
                                    VisualSelector.prototype.toJSON = function() {
                                        var selector = _super.prototype.toJSON.call(this);
                                        selector.visualName = this.visualName;
                                        return selector;
                                    };
                                    VisualSelector.schemaUrl = "http://powerbi.com/product/schema#visualSelector";
                                    return VisualSelector;
                                }(Selector);
                                exports.VisualSelector = VisualSelector;
                                var VisualTypeSelector = /** @class */ function(_super) {
                                    __extends(VisualTypeSelector, _super);
                                    function VisualTypeSelector(visualType) {
                                        var _this = _super.call(this, VisualSelector.schemaUrl) || this;
                                        _this.visualType = visualType;
                                        return _this;
                                    }
                                    VisualTypeSelector.prototype.toJSON = function() {
                                        var selector = _super.prototype.toJSON.call(this);
                                        selector.visualType = this.visualType;
                                        return selector;
                                    };
                                    VisualTypeSelector.schemaUrl = "http://powerbi.com/product/schema#visualTypeSelector";
                                    return VisualTypeSelector;
                                }(Selector);
                                exports.VisualTypeSelector = VisualTypeSelector;
                                var SlicerTargetSelector = /** @class */ function(_super) {
                                    __extends(SlicerTargetSelector, _super);
                                    function SlicerTargetSelector(target) {
                                        var _this = _super.call(this, VisualSelector.schemaUrl) || this;
                                        _this.target = target;
                                        return _this;
                                    }
                                    SlicerTargetSelector.prototype.toJSON = function() {
                                        var selector = _super.prototype.toJSON.call(this);
                                        selector.target = this.target;
                                        return selector;
                                    };
                                    SlicerTargetSelector.schemaUrl = "http://powerbi.com/product/schema#slicerTargetSelector";
                                    return SlicerTargetSelector;
                                }(Selector);
                                exports.SlicerTargetSelector = SlicerTargetSelector;
                                var CommandDisplayOption;
                                (function(CommandDisplayOption) {
                                    CommandDisplayOption[CommandDisplayOption["Enabled"] = 0] = "Enabled";
                                    CommandDisplayOption[CommandDisplayOption["Disabled"] = 1] = "Disabled";
                                    CommandDisplayOption[CommandDisplayOption["Hidden"] = 2] = "Hidden";
                                })(CommandDisplayOption = exports.CommandDisplayOption || (exports.CommandDisplayOption = {}));
                                /*
 * Visual CRUD
 */ var VisualDataRoleKind;
                                (function(VisualDataRoleKind) {
                                    // Indicates that the role should be bound to something that evaluates to a grouping of values.
                                    VisualDataRoleKind[VisualDataRoleKind["Grouping"] = 0] = "Grouping";
                                    // Indicates that the role should be bound to something that evaluates to a single value in a scope.
                                    VisualDataRoleKind[VisualDataRoleKind["Measure"] = 1] = "Measure";
                                    // Indicates that the role can be bound to either Grouping or Measure.
                                    VisualDataRoleKind[VisualDataRoleKind["GroupingOrMeasure"] = 2] = "GroupingOrMeasure";
                                })(VisualDataRoleKind = exports.VisualDataRoleKind || (exports.VisualDataRoleKind = {}));
                                // Indicates the visual preference on Grouping or Measure. Only applicable if kind is GroupingOrMeasure.
                                var VisualDataRoleKindPreference;
                                (function(VisualDataRoleKindPreference) {
                                    VisualDataRoleKindPreference[VisualDataRoleKindPreference["Measure"] = 0] = "Measure";
                                    VisualDataRoleKindPreference[VisualDataRoleKindPreference["Grouping"] = 1] = "Grouping";
                                })(VisualDataRoleKindPreference = exports.VisualDataRoleKindPreference || (exports.VisualDataRoleKindPreference = {}));
                                function isOnLoadFilters(filters) {
                                    return filters && !isReportFiltersArray(filters);
                                }
                                exports.isOnLoadFilters = isOnLoadFilters;
                                function isReportFiltersArray(filters) {
                                    return Array.isArray(filters);
                                }
                                exports.isReportFiltersArray = isReportFiltersArray;
                                function isFlatMenuExtension(menuExtension) {
                                    return menuExtension && !isGroupedMenuExtension(menuExtension);
                                }
                                exports.isFlatMenuExtension = isFlatMenuExtension;
                                function isGroupedMenuExtension(menuExtension) {
                                    return menuExtension && !!menuExtension.groupName;
                                }
                                exports.isGroupedMenuExtension = isGroupedMenuExtension;
                                function isIExtensions(extensions) {
                                    return extensions && !isIExtensionArray(extensions);
                                }
                                exports.isIExtensions = isIExtensions;
                                function isIExtensionArray(extensions) {
                                    return Array.isArray(extensions);
                                }
                                exports.isIExtensionArray = isIExtensionArray;
                                function normalizeError(error) {
                                    var message = error.message;
                                    if (!message) message = "".concat(error.path, " is invalid. Not meeting ").concat(error.keyword, " constraint");
                                    return {
                                        message: message
                                    };
                                }
                                function validateVisualSelector(input) {
                                    var errors = validator_1.Validators.visualSelectorValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateVisualSelector = validateVisualSelector;
                                function validateSlicer(input) {
                                    var errors = validator_1.Validators.slicerValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateSlicer = validateSlicer;
                                function validateSlicerState(input) {
                                    var errors = validator_1.Validators.slicerStateValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateSlicerState = validateSlicerState;
                                function validatePlayBookmarkRequest(input) {
                                    var errors = validator_1.Validators.playBookmarkRequestValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validatePlayBookmarkRequest = validatePlayBookmarkRequest;
                                function validateAddBookmarkRequest(input) {
                                    var errors = validator_1.Validators.addBookmarkRequestValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateAddBookmarkRequest = validateAddBookmarkRequest;
                                function validateApplyBookmarkByNameRequest(input) {
                                    var errors = validator_1.Validators.applyBookmarkByNameRequestValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateApplyBookmarkByNameRequest = validateApplyBookmarkByNameRequest;
                                function validateApplyBookmarkStateRequest(input) {
                                    var errors = validator_1.Validators.applyBookmarkStateRequestValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateApplyBookmarkStateRequest = validateApplyBookmarkStateRequest;
                                function validateCaptureBookmarkRequest(input) {
                                    var errors = validator_1.Validators.captureBookmarkRequestValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateCaptureBookmarkRequest = validateCaptureBookmarkRequest;
                                function validateSettings(input) {
                                    var errors = validator_1.Validators.settingsValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateSettings = validateSettings;
                                function validatePanes(input) {
                                    var errors = validator_1.Validators.reportPanesValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validatePanes = validatePanes;
                                function validateBookmarksPane(input) {
                                    var errors = validator_1.Validators.bookmarksPaneValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateBookmarksPane = validateBookmarksPane;
                                function validateFiltersPane(input) {
                                    var errors = validator_1.Validators.filtersPaneValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateFiltersPane = validateFiltersPane;
                                function validateFieldsPane(input) {
                                    var errors = validator_1.Validators.fieldsPaneValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateFieldsPane = validateFieldsPane;
                                function validatePageNavigationPane(input) {
                                    var errors = validator_1.Validators.pageNavigationPaneValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validatePageNavigationPane = validatePageNavigationPane;
                                function validateSelectionPane(input) {
                                    var errors = validator_1.Validators.selectionPaneValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateSelectionPane = validateSelectionPane;
                                function validateSyncSlicersPane(input) {
                                    var errors = validator_1.Validators.syncSlicersPaneValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateSyncSlicersPane = validateSyncSlicersPane;
                                function validateVisualizationsPane(input) {
                                    var errors = validator_1.Validators.visualizationsPaneValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateVisualizationsPane = validateVisualizationsPane;
                                function validateCustomPageSize(input) {
                                    var errors = validator_1.Validators.customPageSizeValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateCustomPageSize = validateCustomPageSize;
                                function validateExtension(input) {
                                    var errors = validator_1.Validators.extensionValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateExtension = validateExtension;
                                function validateMenuGroupExtension(input) {
                                    var errors = validator_1.Validators.menuGroupExtensionValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateMenuGroupExtension = validateMenuGroupExtension;
                                function validateReportLoad(input) {
                                    var errors = validator_1.Validators.reportLoadValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateReportLoad = validateReportLoad;
                                function validatePaginatedReportLoad(input) {
                                    var errors = validator_1.Validators.paginatedReportLoadValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validatePaginatedReportLoad = validatePaginatedReportLoad;
                                function validateCreateReport(input) {
                                    var errors = validator_1.Validators.reportCreateValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateCreateReport = validateCreateReport;
                                function validateQuickCreate(input) {
                                    var errors = validator_1.Validators.quickCreateValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateQuickCreate = validateQuickCreate;
                                function validateDashboardLoad(input) {
                                    var errors = validator_1.Validators.dashboardLoadValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateDashboardLoad = validateDashboardLoad;
                                function validateTileLoad(input) {
                                    var errors = validator_1.Validators.tileLoadValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateTileLoad = validateTileLoad;
                                function validatePage(input) {
                                    var errors = validator_1.Validators.pageValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validatePage = validatePage;
                                function validateFilter(input) {
                                    var errors = validator_1.Validators.filterValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateFilter = validateFilter;
                                function validateUpdateFiltersRequest(input) {
                                    var errors = validator_1.Validators.updateFiltersRequestValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateUpdateFiltersRequest = validateUpdateFiltersRequest;
                                function validateSaveAsParameters(input) {
                                    var errors = validator_1.Validators.saveAsParametersValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateSaveAsParameters = validateSaveAsParameters;
                                function validateLoadQnaConfiguration(input) {
                                    var errors = validator_1.Validators.loadQnaValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateLoadQnaConfiguration = validateLoadQnaConfiguration;
                                function validateQnaInterpretInputData(input) {
                                    var errors = validator_1.Validators.qnaInterpretInputDataValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateQnaInterpretInputData = validateQnaInterpretInputData;
                                function validateExportDataRequest(input) {
                                    var errors = validator_1.Validators.exportDataRequestValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateExportDataRequest = validateExportDataRequest;
                                function validateVisualHeader(input) {
                                    var errors = validator_1.Validators.visualHeaderValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateVisualHeader = validateVisualHeader;
                                function validateVisualSettings(input) {
                                    var errors = validator_1.Validators.visualSettingsValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateVisualSettings = validateVisualSettings;
                                function validateCommandsSettings(input) {
                                    var errors = validator_1.Validators.commandsSettingsValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateCommandsSettings = validateCommandsSettings;
                                function validateCustomTheme(input) {
                                    var errors = validator_1.Validators.customThemeValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateCustomTheme = validateCustomTheme;
                                function validateZoomLevel(input) {
                                    var errors = validator_1.Validators.zoomLevelValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validateZoomLevel = validateZoomLevel;
                                function validatePrintSettings(input) {
                                    var errors = validator_1.Validators.printSettingsValidator.validate(input);
                                    return errors ? errors.map(normalizeError) : undefined;
                                }
                                exports.validatePrintSettings = validatePrintSettings;
                            /***/ },
                            /* 1 */ /***/ (__unused_webpack_module, exports, __nested_webpack_require_47160__)=>{
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.Validators = void 0;
                                var barsValidator_1 = __nested_webpack_require_47160__(2);
                                var bookmarkValidator_1 = __nested_webpack_require_47160__(5);
                                var commandsSettingsValidator_1 = __nested_webpack_require_47160__(6);
                                var customThemeValidator_1 = __nested_webpack_require_47160__(7);
                                var dashboardLoadValidator_1 = __nested_webpack_require_47160__(8);
                                var datasetBindingValidator_1 = __nested_webpack_require_47160__(9);
                                var exportDataValidator_1 = __nested_webpack_require_47160__(10);
                                var extensionsValidator_1 = __nested_webpack_require_47160__(11);
                                var filtersValidator_1 = __nested_webpack_require_47160__(12);
                                var layoutValidator_1 = __nested_webpack_require_47160__(13);
                                var pageValidator_1 = __nested_webpack_require_47160__(14);
                                var panesValidator_1 = __nested_webpack_require_47160__(15);
                                var qnaValidator_1 = __nested_webpack_require_47160__(16);
                                var reportCreateValidator_1 = __nested_webpack_require_47160__(17);
                                var reportLoadValidator_1 = __nested_webpack_require_47160__(18);
                                var paginatedReportLoadValidator_1 = __nested_webpack_require_47160__(19);
                                var saveAsParametersValidator_1 = __nested_webpack_require_47160__(20);
                                var selectorsValidator_1 = __nested_webpack_require_47160__(21);
                                var settingsValidator_1 = __nested_webpack_require_47160__(22);
                                var slicersValidator_1 = __nested_webpack_require_47160__(23);
                                var tileLoadValidator_1 = __nested_webpack_require_47160__(24);
                                var visualSettingsValidator_1 = __nested_webpack_require_47160__(25);
                                var anyOfValidator_1 = __nested_webpack_require_47160__(26);
                                var fieldForbiddenValidator_1 = __nested_webpack_require_47160__(27);
                                var fieldRequiredValidator_1 = __nested_webpack_require_47160__(28);
                                var mapValidator_1 = __nested_webpack_require_47160__(29);
                                var typeValidator_1 = __nested_webpack_require_47160__(4);
                                var parameterPanelValidator_1 = __nested_webpack_require_47160__(30);
                                var datasetCreateConfigValidator_1 = __nested_webpack_require_47160__(31);
                                var quickCreateValidator_1 = __nested_webpack_require_47160__(32);
                                var printSettingsValidator_1 = __nested_webpack_require_47160__(33);
                                var paginatedReportDatasetBindingValidator_1 = __nested_webpack_require_47160__(34);
                                exports.Validators = {
                                    addBookmarkRequestValidator: new bookmarkValidator_1.AddBookmarkRequestValidator(),
                                    advancedFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        0
                                    ]),
                                    advancedFilterValidator: new filtersValidator_1.AdvancedFilterValidator(),
                                    anyArrayValidator: new typeValidator_1.ArrayValidator([
                                        new anyOfValidator_1.AnyOfValidator([
                                            new typeValidator_1.StringValidator(),
                                            new typeValidator_1.NumberValidator(),
                                            new typeValidator_1.BooleanValidator()
                                        ])
                                    ]),
                                    anyFilterValidator: new anyOfValidator_1.AnyOfValidator([
                                        new filtersValidator_1.BasicFilterValidator(),
                                        new filtersValidator_1.AdvancedFilterValidator(),
                                        new filtersValidator_1.IncludeExcludeFilterValidator(),
                                        new filtersValidator_1.NotSupportedFilterValidator(),
                                        new filtersValidator_1.RelativeDateFilterValidator(),
                                        new filtersValidator_1.TopNFilterValidator(),
                                        new filtersValidator_1.RelativeTimeFilterValidator(),
                                        new filtersValidator_1.HierarchyFilterValidator()
                                    ]),
                                    anyValueValidator: new anyOfValidator_1.AnyOfValidator([
                                        new typeValidator_1.StringValidator(),
                                        new typeValidator_1.NumberValidator(),
                                        new typeValidator_1.BooleanValidator()
                                    ]),
                                    actionBarValidator: new barsValidator_1.ActionBarValidator(),
                                    statusBarValidator: new barsValidator_1.StatusBarValidator(),
                                    applyBookmarkByNameRequestValidator: new bookmarkValidator_1.ApplyBookmarkByNameRequestValidator(),
                                    applyBookmarkStateRequestValidator: new bookmarkValidator_1.ApplyBookmarkStateRequestValidator(),
                                    applyBookmarkValidator: new anyOfValidator_1.AnyOfValidator([
                                        new bookmarkValidator_1.ApplyBookmarkByNameRequestValidator(),
                                        new bookmarkValidator_1.ApplyBookmarkStateRequestValidator()
                                    ]),
                                    backgroundValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    basicFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        1
                                    ]),
                                    basicFilterValidator: new filtersValidator_1.BasicFilterValidator(),
                                    booleanArrayValidator: new typeValidator_1.BooleanArrayValidator(),
                                    booleanValidator: new typeValidator_1.BooleanValidator(),
                                    bookmarksPaneValidator: new panesValidator_1.BookmarksPaneValidator(),
                                    captureBookmarkOptionsValidator: new bookmarkValidator_1.CaptureBookmarkOptionsValidator(),
                                    captureBookmarkRequestValidator: new bookmarkValidator_1.CaptureBookmarkRequestValidator(),
                                    columnSchemaArrayValidator: new typeValidator_1.ArrayValidator([
                                        new datasetCreateConfigValidator_1.ColumnSchemaValidator()
                                    ]),
                                    commandDisplayOptionValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    commandExtensionSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                                        new selectorsValidator_1.VisualSelectorValidator(),
                                        new selectorsValidator_1.VisualTypeSelectorValidator()
                                    ]),
                                    commandExtensionArrayValidator: new typeValidator_1.ArrayValidator([
                                        new extensionsValidator_1.CommandExtensionValidator()
                                    ]),
                                    commandExtensionValidator: new extensionsValidator_1.CommandExtensionValidator(),
                                    commandsSettingsArrayValidator: new typeValidator_1.ArrayValidator([
                                        new commandsSettingsValidator_1.CommandsSettingsValidator()
                                    ]),
                                    commandsSettingsValidator: new commandsSettingsValidator_1.CommandsSettingsValidator(),
                                    conditionItemValidator: new filtersValidator_1.ConditionItemValidator(),
                                    contrastModeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ]),
                                    credentialDetailsValidator: new mapValidator_1.MapValidator([
                                        new typeValidator_1.StringValidator()
                                    ], [
                                        new typeValidator_1.StringValidator()
                                    ]),
                                    credentialsValidator: new datasetCreateConfigValidator_1.CredentialsValidator(),
                                    credentialTypeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    customLayoutDisplayOptionValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    customLayoutValidator: new layoutValidator_1.CustomLayoutValidator(),
                                    customPageSizeValidator: new pageValidator_1.CustomPageSizeValidator(),
                                    customThemeValidator: new customThemeValidator_1.CustomThemeValidator(),
                                    dashboardLoadValidator: new dashboardLoadValidator_1.DashboardLoadValidator(),
                                    dataCacheModeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    datasetBindingValidator: new datasetBindingValidator_1.DatasetBindingValidator(),
                                    datasetCreateConfigValidator: new datasetCreateConfigValidator_1.DatasetCreateConfigValidator(),
                                    datasourceConnectionConfigValidator: new datasetCreateConfigValidator_1.DatasourceConnectionConfigValidator(),
                                    displayStateModeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    displayStateValidator: new layoutValidator_1.DisplayStateValidator(),
                                    exportDataRequestValidator: new exportDataValidator_1.ExportDataRequestValidator(),
                                    extensionArrayValidator: new typeValidator_1.ArrayValidator([
                                        new extensionsValidator_1.ExtensionValidator()
                                    ]),
                                    extensionsValidator: new anyOfValidator_1.AnyOfValidator([
                                        new typeValidator_1.ArrayValidator([
                                            new extensionsValidator_1.ExtensionValidator()
                                        ]),
                                        new extensionsValidator_1.ExtensionsValidator()
                                    ]),
                                    extensionPointsValidator: new extensionsValidator_1.ExtensionPointsValidator(),
                                    extensionValidator: new extensionsValidator_1.ExtensionValidator(),
                                    fieldForbiddenValidator: new fieldForbiddenValidator_1.FieldForbiddenValidator(),
                                    fieldRequiredValidator: new fieldRequiredValidator_1.FieldRequiredValidator(),
                                    fieldsPaneValidator: new panesValidator_1.FieldsPaneValidator(),
                                    filterColumnTargetValidator: new filtersValidator_1.FilterColumnTargetValidator(),
                                    filterDisplaySettingsValidator: new filtersValidator_1.FilterDisplaySettingsValidator(),
                                    filterConditionsValidator: new typeValidator_1.ArrayValidator([
                                        new filtersValidator_1.ConditionItemValidator()
                                    ]),
                                    filterHierarchyTargetValidator: new filtersValidator_1.FilterHierarchyTargetValidator(),
                                    filterMeasureTargetValidator: new filtersValidator_1.FilterMeasureTargetValidator(),
                                    filterTargetValidator: new anyOfValidator_1.AnyOfValidator([
                                        new filtersValidator_1.FilterColumnTargetValidator(),
                                        new filtersValidator_1.FilterHierarchyTargetValidator(),
                                        new filtersValidator_1.FilterMeasureTargetValidator(),
                                        new typeValidator_1.ArrayValidator([
                                            new anyOfValidator_1.AnyOfValidator([
                                                new filtersValidator_1.FilterColumnTargetValidator(),
                                                new filtersValidator_1.FilterHierarchyTargetValidator(),
                                                new filtersValidator_1.FilterMeasureTargetValidator(),
                                                new filtersValidator_1.FilterKeyColumnsTargetValidator(),
                                                new filtersValidator_1.FilterKeyHierarchyTargetValidator(),
                                                new typeValidator_1.ArrayValidator([
                                                    new anyOfValidator_1.AnyOfValidator([
                                                        new filtersValidator_1.FilterColumnTargetValidator(),
                                                        new filtersValidator_1.FilterHierarchyTargetValidator(),
                                                        new filtersValidator_1.FilterMeasureTargetValidator(),
                                                        new filtersValidator_1.FilterKeyColumnsTargetValidator(),
                                                        new filtersValidator_1.FilterKeyHierarchyTargetValidator()
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    filterValidator: new filtersValidator_1.FilterValidator(),
                                    filterTypeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        9
                                    ]),
                                    filtersArrayValidator: new typeValidator_1.ArrayValidator([
                                        new filtersValidator_1.FilterValidator()
                                    ]),
                                    filtersOperationsUpdateValidator: new typeValidator_1.EnumValidator([
                                        1,
                                        2,
                                        3
                                    ]),
                                    filtersOperationsRemoveAllValidator: new typeValidator_1.EnumValidator([
                                        0
                                    ]),
                                    filtersPaneValidator: new panesValidator_1.FiltersPaneValidator(),
                                    hyperlinkClickBehaviorValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    includeExcludeFilterValidator: new filtersValidator_1.IncludeExcludeFilterValidator(),
                                    includeExludeFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        3
                                    ]),
                                    includeExcludeFilterValuesValidator: new typeValidator_1.ArrayValidator([
                                        new anyOfValidator_1.AnyOfValidator([
                                            new typeValidator_1.StringValidator(),
                                            new typeValidator_1.NumberValidator(),
                                            new typeValidator_1.BooleanValidator(),
                                            new typeValidator_1.ArrayValidator([
                                                new typeValidator_1.ArrayValidator([
                                                    new filtersValidator_1.IncludeExcludePointValueValidator()
                                                ])
                                            ])
                                        ])
                                    ]),
                                    hierarchyFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        9
                                    ]),
                                    hierarchyFilterValuesValidator: new typeValidator_1.ArrayValidator([
                                        new filtersValidator_1.HierarchyFilterNodeValidator()
                                    ]),
                                    layoutTypeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3
                                    ]),
                                    loadQnaValidator: new qnaValidator_1.LoadQnaValidator(),
                                    menuExtensionValidator: new anyOfValidator_1.AnyOfValidator([
                                        new extensionsValidator_1.FlatMenuExtensionValidator(),
                                        new extensionsValidator_1.GroupedMenuExtensionValidator()
                                    ]),
                                    menuGroupExtensionArrayValidator: new typeValidator_1.ArrayValidator([
                                        new extensionsValidator_1.MenuGroupExtensionValidator()
                                    ]),
                                    menuGroupExtensionValidator: new extensionsValidator_1.MenuGroupExtensionValidator(),
                                    menuLocationValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    notSupportedFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        2
                                    ]),
                                    notSupportedFilterValidator: new filtersValidator_1.NotSupportedFilterValidator(),
                                    numberArrayValidator: new typeValidator_1.NumberArrayValidator(),
                                    numberValidator: new typeValidator_1.NumberValidator(),
                                    onLoadFiltersBaseValidator: new anyOfValidator_1.AnyOfValidator([
                                        new filtersValidator_1.OnLoadFiltersBaseValidator(),
                                        new filtersValidator_1.OnLoadFiltersBaseRemoveOperationValidator()
                                    ]),
                                    pageLayoutValidator: new mapValidator_1.MapValidator([
                                        new typeValidator_1.StringValidator()
                                    ], [
                                        new layoutValidator_1.VisualLayoutValidator()
                                    ]),
                                    pageNavigationPaneValidator: new panesValidator_1.PageNavigationPaneValidator(),
                                    pageNavigationPositionValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    pageSizeTypeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ]),
                                    pageSizeValidator: new pageValidator_1.PageSizeValidator(),
                                    pageValidator: new pageValidator_1.PageValidator(),
                                    pageViewFieldValidator: new pageValidator_1.PageViewFieldValidator(),
                                    pagesLayoutValidator: new mapValidator_1.MapValidator([
                                        new typeValidator_1.StringValidator()
                                    ], [
                                        new layoutValidator_1.PageLayoutValidator()
                                    ]),
                                    paginatedReportCommandsValidator: new commandsSettingsValidator_1.PaginatedReportCommandsValidator(),
                                    paginatedReportDatasetBindingArrayValidator: new typeValidator_1.ArrayValidator([
                                        new paginatedReportDatasetBindingValidator_1.PaginatedReportDatasetBindingValidator()
                                    ]),
                                    paginatedReportLoadValidator: new paginatedReportLoadValidator_1.PaginatedReportLoadValidator(),
                                    paginatedReportsettingsValidator: new settingsValidator_1.PaginatedReportSettingsValidator(),
                                    parameterValuesArrayValidator: new typeValidator_1.ArrayValidator([
                                        new paginatedReportLoadValidator_1.ReportParameterFieldsValidator()
                                    ]),
                                    parametersPanelValidator: new parameterPanelValidator_1.ParametersPanelValidator(),
                                    permissionsValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        4,
                                        7
                                    ]),
                                    playBookmarkRequestValidator: new bookmarkValidator_1.PlayBookmarkRequestValidator(),
                                    printSettingsValidator: new printSettingsValidator_1.PrintSettingsValidator(),
                                    qnaInterpretInputDataValidator: new qnaValidator_1.QnaInterpretInputDataValidator(),
                                    qnaPanesValidator: new panesValidator_1.QnaPanesValidator(),
                                    qnaSettingValidator: new qnaValidator_1.QnaSettingsValidator(),
                                    quickCreateValidator: new quickCreateValidator_1.QuickCreateValidator(),
                                    rawDataValidator: new typeValidator_1.ArrayValidator([
                                        new typeValidator_1.ArrayValidator([
                                            new typeValidator_1.StringValidator()
                                        ])
                                    ]),
                                    relativeDateFilterOperatorValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    relativeDateFilterTimeUnitTypeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]),
                                    relativeDateFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        4
                                    ]),
                                    relativeDateFilterValidator: new filtersValidator_1.RelativeDateFilterValidator(),
                                    relativeDateTimeFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        4,
                                        7
                                    ]),
                                    relativeDateTimeFilterUnitTypeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]),
                                    relativeTimeFilterTimeUnitTypeValidator: new typeValidator_1.EnumValidator([
                                        7,
                                        8
                                    ]),
                                    relativeTimeFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        7
                                    ]),
                                    relativeTimeFilterValidator: new filtersValidator_1.RelativeTimeFilterValidator(),
                                    reportBarsValidator: new barsValidator_1.ReportBarsValidator(),
                                    reportCreateValidator: new reportCreateValidator_1.ReportCreateValidator(),
                                    reportLoadFiltersValidator: new anyOfValidator_1.AnyOfValidator([
                                        new typeValidator_1.ArrayValidator([
                                            new filtersValidator_1.FilterValidator()
                                        ]),
                                        new filtersValidator_1.OnLoadFiltersValidator()
                                    ]),
                                    reportLoadValidator: new reportLoadValidator_1.ReportLoadValidator(),
                                    reportPanesValidator: new panesValidator_1.ReportPanesValidator(),
                                    saveAsParametersValidator: new saveAsParametersValidator_1.SaveAsParametersValidator(),
                                    selectionPaneValidator: new panesValidator_1.SelectionPaneValidator(),
                                    settingsValidator: new settingsValidator_1.SettingsValidator(),
                                    singleCommandSettingsValidator: new commandsSettingsValidator_1.SingleCommandSettingsValidator(),
                                    slicerSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                                        new selectorsValidator_1.VisualSelectorValidator(),
                                        new selectorsValidator_1.SlicerTargetSelectorValidator()
                                    ]),
                                    slicerStateValidator: new slicersValidator_1.SlicerStateValidator(),
                                    slicerTargetValidator: new anyOfValidator_1.AnyOfValidator([
                                        new filtersValidator_1.FilterColumnTargetValidator(),
                                        new filtersValidator_1.FilterHierarchyTargetValidator(),
                                        new filtersValidator_1.FilterMeasureTargetValidator(),
                                        new filtersValidator_1.FilterKeyColumnsTargetValidator(),
                                        new filtersValidator_1.FilterKeyHierarchyTargetValidator()
                                    ]),
                                    slicerValidator: new slicersValidator_1.SlicerValidator(),
                                    stringArrayValidator: new typeValidator_1.StringArrayValidator(),
                                    stringValidator: new typeValidator_1.StringValidator(),
                                    syncSlicersPaneValidator: new panesValidator_1.SyncSlicersPaneValidator(),
                                    tableDataArrayValidator: new typeValidator_1.ArrayValidator([
                                        new datasetCreateConfigValidator_1.TableDataValidator()
                                    ]),
                                    tableSchemaListValidator: new typeValidator_1.ArrayValidator([
                                        new datasetCreateConfigValidator_1.TableSchemaValidator()
                                    ]),
                                    tileLoadValidator: new tileLoadValidator_1.TileLoadValidator(),
                                    tokenTypeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    topNFilterTypeValidator: new typeValidator_1.EnumValidator([
                                        5
                                    ]),
                                    topNFilterValidator: new filtersValidator_1.TopNFilterValidator(),
                                    updateFiltersRequestValidator: new anyOfValidator_1.AnyOfValidator([
                                        new filtersValidator_1.UpdateFiltersRequestValidator(),
                                        new filtersValidator_1.RemoveFiltersRequestValidator()
                                    ]),
                                    viewModeValidator: new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    visualCommandSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                                        new selectorsValidator_1.VisualSelectorValidator(),
                                        new selectorsValidator_1.VisualTypeSelectorValidator()
                                    ]),
                                    visualHeaderSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                                        new selectorsValidator_1.VisualSelectorValidator(),
                                        new selectorsValidator_1.VisualTypeSelectorValidator()
                                    ]),
                                    visualHeaderSettingsValidator: new visualSettingsValidator_1.VisualHeaderSettingsValidator(),
                                    visualHeaderValidator: new visualSettingsValidator_1.VisualHeaderValidator(),
                                    visualHeadersValidator: new typeValidator_1.ArrayValidator([
                                        new visualSettingsValidator_1.VisualHeaderValidator()
                                    ]),
                                    visualizationsPaneValidator: new panesValidator_1.VisualizationsPaneValidator(),
                                    visualLayoutValidator: new layoutValidator_1.VisualLayoutValidator(),
                                    visualSelectorValidator: new selectorsValidator_1.VisualSelectorValidator(),
                                    visualSettingsValidator: new visualSettingsValidator_1.VisualSettingsValidator(),
                                    visualTypeSelectorValidator: new selectorsValidator_1.VisualTypeSelectorValidator(),
                                    zoomLevelValidator: new typeValidator_1.RangeValidator(0.25, 4)
                                };
                            /***/ },
                            /* 2 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_65027__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.StatusBarValidator = exports.ActionBarValidator = exports.ReportBarsValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_65027__(3);
                                var typeValidator_1 = __nested_webpack_require_65027__(4);
                                var validator_1 = __nested_webpack_require_65027__(1);
                                var ReportBarsValidator = /** @class */ function(_super) {
                                    __extends(ReportBarsValidator, _super);
                                    function ReportBarsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ReportBarsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "actionBar",
                                                validators: [
                                                    validator_1.Validators.actionBarValidator
                                                ]
                                            },
                                            {
                                                field: "statusBar",
                                                validators: [
                                                    validator_1.Validators.statusBarValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ReportBarsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ReportBarsValidator = ReportBarsValidator;
                                var ActionBarValidator = /** @class */ function(_super) {
                                    __extends(ActionBarValidator, _super);
                                    function ActionBarValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ActionBarValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ActionBarValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ActionBarValidator = ActionBarValidator;
                                var StatusBarValidator = /** @class */ function(_super) {
                                    __extends(StatusBarValidator, _super);
                                    function StatusBarValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    StatusBarValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return StatusBarValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.StatusBarValidator = StatusBarValidator;
                            /***/ },
                            /* 3 */ /***/ (__unused_webpack_module, exports)=>{
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.MultipleFieldsValidator = void 0;
                                var MultipleFieldsValidator = /** @class */ function() {
                                    function MultipleFieldsValidator(fieldValidatorsPairs) {
                                        this.fieldValidatorsPairs = fieldValidatorsPairs;
                                    }
                                    MultipleFieldsValidator.prototype.validate = function(input, path, field) {
                                        if (!this.fieldValidatorsPairs) return null;
                                        var fieldsPath = path ? path + "." + field : field;
                                        for(var _i = 0, _a = this.fieldValidatorsPairs; _i < _a.length; _i++){
                                            var fieldValidators = _a[_i];
                                            for(var _b = 0, _c = fieldValidators.validators; _b < _c.length; _b++){
                                                var validator = _c[_b];
                                                var errors = validator.validate(input[fieldValidators.field], fieldsPath, fieldValidators.field);
                                                if (errors) return errors;
                                            }
                                        }
                                        return null;
                                    };
                                    return MultipleFieldsValidator;
                                }();
                                exports.MultipleFieldsValidator = MultipleFieldsValidator;
                            /***/ },
                            /* 4 */ /***/ function(__unused_webpack_module, exports) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.RangeValidator = exports.NumberArrayValidator = exports.BooleanArrayValidator = exports.StringArrayValidator = exports.EnumValidator = exports.SchemaValidator = exports.ValueValidator = exports.NumberValidator = exports.BooleanValidator = exports.StringValidator = exports.TypeValidator = exports.ArrayValidator = exports.ObjectValidator = void 0;
                                var ObjectValidator = /** @class */ function() {
                                    function ObjectValidator() {}
                                    ObjectValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        if (typeof input !== "object" || Array.isArray(input)) return [
                                            {
                                                message: field !== undefined ? field + " must be an object" : "input must be an object",
                                                path: path,
                                                keyword: "type"
                                            }
                                        ];
                                        return null;
                                    };
                                    return ObjectValidator;
                                }();
                                exports.ObjectValidator = ObjectValidator;
                                var ArrayValidator = /** @class */ function() {
                                    function ArrayValidator(itemValidators) {
                                        this.itemValidators = itemValidators;
                                    }
                                    ArrayValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        if (!Array.isArray(input)) return [
                                            {
                                                message: field + " property is invalid",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "type"
                                            }
                                        ];
                                        for(var i = 0; i < input.length; i++){
                                            var fieldsPath = (path ? path + "." : "") + field + "." + i.toString();
                                            for(var _i = 0, _a = this.itemValidators; _i < _a.length; _i++){
                                                var validator = _a[_i];
                                                var errors = validator.validate(input[i], fieldsPath, field);
                                                if (errors) return [
                                                    {
                                                        message: field + " property is invalid",
                                                        path: (path ? path + "." : "") + field,
                                                        keyword: "type"
                                                    }
                                                ];
                                            }
                                        }
                                        return null;
                                    };
                                    return ArrayValidator;
                                }();
                                exports.ArrayValidator = ArrayValidator;
                                var TypeValidator = /** @class */ function() {
                                    function TypeValidator(expectedType) {
                                        this.expectedType = expectedType;
                                    }
                                    TypeValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        if (!(typeof input === this.expectedType)) return [
                                            {
                                                message: field + " must be a " + this.expectedType,
                                                path: (path ? path + "." : "") + field,
                                                keyword: "type"
                                            }
                                        ];
                                        return null;
                                    };
                                    return TypeValidator;
                                }();
                                exports.TypeValidator = TypeValidator;
                                var StringValidator = /** @class */ function(_super) {
                                    __extends(StringValidator, _super);
                                    function StringValidator() {
                                        return _super.call(this, "string") || this;
                                    }
                                    return StringValidator;
                                }(TypeValidator);
                                exports.StringValidator = StringValidator;
                                var BooleanValidator = /** @class */ function(_super) {
                                    __extends(BooleanValidator, _super);
                                    function BooleanValidator() {
                                        return _super.call(this, "boolean") || this;
                                    }
                                    return BooleanValidator;
                                }(TypeValidator);
                                exports.BooleanValidator = BooleanValidator;
                                var NumberValidator = /** @class */ function(_super) {
                                    __extends(NumberValidator, _super);
                                    function NumberValidator() {
                                        return _super.call(this, "number") || this;
                                    }
                                    return NumberValidator;
                                }(TypeValidator);
                                exports.NumberValidator = NumberValidator;
                                var ValueValidator = /** @class */ function() {
                                    function ValueValidator(possibleValues) {
                                        this.possibleValues = possibleValues;
                                    }
                                    ValueValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        if (this.possibleValues.indexOf(input) < 0) return [
                                            {
                                                message: field + " property is invalid",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "invalid"
                                            }
                                        ];
                                        return null;
                                    };
                                    return ValueValidator;
                                }();
                                exports.ValueValidator = ValueValidator;
                                var SchemaValidator = /** @class */ function(_super) {
                                    __extends(SchemaValidator, _super);
                                    function SchemaValidator(schemaValue) {
                                        var _this = _super.call(this, [
                                            schemaValue
                                        ]) || this;
                                        _this.schemaValue = schemaValue;
                                        return _this;
                                    }
                                    SchemaValidator.prototype.validate = function(input, path, field) {
                                        return _super.prototype.validate.call(this, input, path, field);
                                    };
                                    return SchemaValidator;
                                }(ValueValidator);
                                exports.SchemaValidator = SchemaValidator;
                                var EnumValidator = /** @class */ function(_super) {
                                    __extends(EnumValidator, _super);
                                    function EnumValidator(possibleValues) {
                                        var _this = _super.call(this) || this;
                                        _this.possibleValues = possibleValues;
                                        return _this;
                                    }
                                    EnumValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var valueValidator = new ValueValidator(this.possibleValues);
                                        return valueValidator.validate(input, path, field);
                                    };
                                    return EnumValidator;
                                }(NumberValidator);
                                exports.EnumValidator = EnumValidator;
                                var StringArrayValidator = /** @class */ function(_super) {
                                    __extends(StringArrayValidator, _super);
                                    function StringArrayValidator() {
                                        return _super.call(this, [
                                            new StringValidator()
                                        ]) || this;
                                    }
                                    StringArrayValidator.prototype.validate = function(input, path, field) {
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return [
                                            {
                                                message: field + " must be an array of strings",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "type"
                                            }
                                        ];
                                        return null;
                                    };
                                    return StringArrayValidator;
                                }(ArrayValidator);
                                exports.StringArrayValidator = StringArrayValidator;
                                var BooleanArrayValidator = /** @class */ function(_super) {
                                    __extends(BooleanArrayValidator, _super);
                                    function BooleanArrayValidator() {
                                        return _super.call(this, [
                                            new BooleanValidator()
                                        ]) || this;
                                    }
                                    BooleanArrayValidator.prototype.validate = function(input, path, field) {
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return [
                                            {
                                                message: field + " must be an array of booleans",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "type"
                                            }
                                        ];
                                        return null;
                                    };
                                    return BooleanArrayValidator;
                                }(ArrayValidator);
                                exports.BooleanArrayValidator = BooleanArrayValidator;
                                var NumberArrayValidator = /** @class */ function(_super) {
                                    __extends(NumberArrayValidator, _super);
                                    function NumberArrayValidator() {
                                        return _super.call(this, [
                                            new NumberValidator()
                                        ]) || this;
                                    }
                                    NumberArrayValidator.prototype.validate = function(input, path, field) {
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return [
                                            {
                                                message: field + " must be an array of numbers",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "type"
                                            }
                                        ];
                                        return null;
                                    };
                                    return NumberArrayValidator;
                                }(ArrayValidator);
                                exports.NumberArrayValidator = NumberArrayValidator;
                                var RangeValidator = /** @class */ function(_super) {
                                    __extends(RangeValidator, _super);
                                    function RangeValidator(minValue, maxValue) {
                                        var _this = _super.call(this) || this;
                                        _this.minValue = minValue;
                                        _this.maxValue = maxValue;
                                        return _this;
                                    }
                                    RangeValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        // input is a number, now check if it's in the given range
                                        if (input > this.maxValue || input < this.minValue) return [
                                            {
                                                message: field + " must be a number between " + this.minValue.toString() + " and " + this.maxValue.toString(),
                                                path: (path ? path + "." : "") + field,
                                                keyword: "range"
                                            }
                                        ];
                                        return null;
                                    };
                                    return RangeValidator;
                                }(NumberValidator);
                                exports.RangeValidator = RangeValidator;
                            /***/ },
                            /* 5 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_80906__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.CaptureBookmarkRequestValidator = exports.CaptureBookmarkOptionsValidator = exports.ApplyBookmarkStateRequestValidator = exports.ApplyBookmarkByNameRequestValidator = exports.AddBookmarkRequestValidator = exports.PlayBookmarkRequestValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_80906__(3);
                                var typeValidator_1 = __nested_webpack_require_80906__(4);
                                var validator_1 = __nested_webpack_require_80906__(1);
                                var PlayBookmarkRequestValidator = /** @class */ function(_super) {
                                    __extends(PlayBookmarkRequestValidator, _super);
                                    function PlayBookmarkRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PlayBookmarkRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "playMode",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    new typeValidator_1.EnumValidator([
                                                        0,
                                                        1
                                                    ])
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PlayBookmarkRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PlayBookmarkRequestValidator = PlayBookmarkRequestValidator;
                                var AddBookmarkRequestValidator = /** @class */ function(_super) {
                                    __extends(AddBookmarkRequestValidator, _super);
                                    function AddBookmarkRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    AddBookmarkRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "state",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "displayName",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "apply",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return AddBookmarkRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.AddBookmarkRequestValidator = AddBookmarkRequestValidator;
                                var ApplyBookmarkByNameRequestValidator = /** @class */ function(_super) {
                                    __extends(ApplyBookmarkByNameRequestValidator, _super);
                                    function ApplyBookmarkByNameRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ApplyBookmarkByNameRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ApplyBookmarkByNameRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ApplyBookmarkByNameRequestValidator = ApplyBookmarkByNameRequestValidator;
                                var ApplyBookmarkStateRequestValidator = /** @class */ function(_super) {
                                    __extends(ApplyBookmarkStateRequestValidator, _super);
                                    function ApplyBookmarkStateRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ApplyBookmarkStateRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "state",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ApplyBookmarkStateRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ApplyBookmarkStateRequestValidator = ApplyBookmarkStateRequestValidator;
                                var CaptureBookmarkOptionsValidator = /** @class */ function(_super) {
                                    __extends(CaptureBookmarkOptionsValidator, _super);
                                    function CaptureBookmarkOptionsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CaptureBookmarkOptionsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "personalizeVisuals",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "allPages",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CaptureBookmarkOptionsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.CaptureBookmarkOptionsValidator = CaptureBookmarkOptionsValidator;
                                var CaptureBookmarkRequestValidator = /** @class */ function(_super) {
                                    __extends(CaptureBookmarkRequestValidator, _super);
                                    function CaptureBookmarkRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CaptureBookmarkRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "options",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.captureBookmarkOptionsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CaptureBookmarkRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.CaptureBookmarkRequestValidator = CaptureBookmarkRequestValidator;
                            /***/ },
                            /* 6 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_89382__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.PaginatedReportCommandsValidator = exports.SingleCommandSettingsValidator = exports.CommandsSettingsValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_89382__(3);
                                var typeValidator_1 = __nested_webpack_require_89382__(4);
                                var validator_1 = __nested_webpack_require_89382__(1);
                                var CommandsSettingsValidator = /** @class */ function(_super) {
                                    __extends(CommandsSettingsValidator, _super);
                                    function CommandsSettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CommandsSettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "copy",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "drill",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "drillthrough",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "expandCollapse",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "exportData",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "includeExclude",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "removeVisual",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "search",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "seeData",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "sort",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "spotlight",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "insightsAnalysis",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "addComment",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "groupVisualContainers",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "summarize",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "clearSelection",
                                                validators: [
                                                    validator_1.Validators.singleCommandSettingsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CommandsSettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.CommandsSettingsValidator = CommandsSettingsValidator;
                                var SingleCommandSettingsValidator = /** @class */ function(_super) {
                                    __extends(SingleCommandSettingsValidator, _super);
                                    function SingleCommandSettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SingleCommandSettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "displayOption",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.commandDisplayOptionValidator
                                                ]
                                            },
                                            {
                                                field: "selector",
                                                validators: [
                                                    validator_1.Validators.visualCommandSelectorValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SingleCommandSettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SingleCommandSettingsValidator = SingleCommandSettingsValidator;
                                var PaginatedReportCommandsValidator = /** @class */ function(_super) {
                                    __extends(PaginatedReportCommandsValidator, _super);
                                    function PaginatedReportCommandsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PaginatedReportCommandsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "parameterPanel",
                                                validators: [
                                                    validator_1.Validators.parametersPanelValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PaginatedReportCommandsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PaginatedReportCommandsValidator = PaginatedReportCommandsValidator;
                            /***/ },
                            /* 7 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_96415__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.CustomThemeValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_96415__(3);
                                var typeValidator_1 = __nested_webpack_require_96415__(4);
                                var CustomThemeValidator = /** @class */ function(_super) {
                                    __extends(CustomThemeValidator, _super);
                                    function CustomThemeValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CustomThemeValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "themeJson",
                                                validators: [
                                                    new typeValidator_1.ObjectValidator()
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CustomThemeValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.CustomThemeValidator = CustomThemeValidator;
                            /***/ },
                            /* 8 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_98569__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.DashboardLoadValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_98569__(3);
                                var typeValidator_1 = __nested_webpack_require_98569__(4);
                                var validator_1 = __nested_webpack_require_98569__(1);
                                var DashboardLoadValidator = /** @class */ function(_super) {
                                    __extends(DashboardLoadValidator, _super);
                                    function DashboardLoadValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    DashboardLoadValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "pageView",
                                                validators: [
                                                    validator_1.Validators.pageViewFieldValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    validator_1.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "embedUrl",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return DashboardLoadValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.DashboardLoadValidator = DashboardLoadValidator;
                            /***/ },
                            /* 9 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_101568__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.DatasetBindingValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_101568__(3);
                                var typeValidator_1 = __nested_webpack_require_101568__(4);
                                var validator_1 = __nested_webpack_require_101568__(1);
                                var DatasetBindingValidator = /** @class */ function(_super) {
                                    __extends(DatasetBindingValidator, _super);
                                    function DatasetBindingValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    DatasetBindingValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        if (!input["datasetId"] && !input["paginatedReportBindings"]) return [
                                            {
                                                message: "datasetBinding cannot be empty",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "invalid"
                                            }
                                        ];
                                        var fields = [
                                            {
                                                field: "datasetId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "paginatedReportBindings",
                                                validators: [
                                                    validator_1.Validators.paginatedReportDatasetBindingArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return DatasetBindingValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.DatasetBindingValidator = DatasetBindingValidator;
                            /***/ },
                            /* 10 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_104264__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.ExportDataRequestValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_104264__(3);
                                var typeValidator_1 = __nested_webpack_require_104264__(4);
                                var ExportDataRequestValidator = /** @class */ function(_super) {
                                    __extends(ExportDataRequestValidator, _super);
                                    function ExportDataRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ExportDataRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "rows",
                                                validators: [
                                                    new typeValidator_1.NumberValidator()
                                                ]
                                            },
                                            {
                                                field: "exportDataType",
                                                validators: [
                                                    new typeValidator_1.EnumValidator([
                                                        0,
                                                        1
                                                    ])
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ExportDataRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ExportDataRequestValidator = ExportDataRequestValidator;
                            /***/ },
                            /* 11 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_106608__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.ExtensionsValidator = exports.MenuGroupExtensionValidator = exports.ExtensionValidator = exports.CommandExtensionValidator = exports.ExtensionItemValidator = exports.ExtensionPointsValidator = exports.GroupedMenuExtensionValidator = exports.FlatMenuExtensionValidator = exports.MenuExtensionBaseValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_106608__(3);
                                var typeValidator_1 = __nested_webpack_require_106608__(4);
                                var validator_1 = __nested_webpack_require_106608__(1);
                                var MenuExtensionBaseValidator = /** @class */ function(_super) {
                                    __extends(MenuExtensionBaseValidator, _super);
                                    function MenuExtensionBaseValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    MenuExtensionBaseValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "title",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "icon",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return MenuExtensionBaseValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.MenuExtensionBaseValidator = MenuExtensionBaseValidator;
                                var FlatMenuExtensionValidator = /** @class */ function(_super) {
                                    __extends(FlatMenuExtensionValidator, _super);
                                    function FlatMenuExtensionValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FlatMenuExtensionValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "menuLocation",
                                                validators: [
                                                    validator_1.Validators.menuLocationValidator
                                                ]
                                            },
                                            {
                                                field: "groupName",
                                                validators: [
                                                    validator_1.Validators.fieldForbiddenValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FlatMenuExtensionValidator;
                                }(MenuExtensionBaseValidator);
                                exports.FlatMenuExtensionValidator = FlatMenuExtensionValidator;
                                var GroupedMenuExtensionValidator = /** @class */ function(_super) {
                                    __extends(GroupedMenuExtensionValidator, _super);
                                    function GroupedMenuExtensionValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    GroupedMenuExtensionValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "groupName",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "menuLocation",
                                                validators: [
                                                    validator_1.Validators.fieldForbiddenValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return GroupedMenuExtensionValidator;
                                }(MenuExtensionBaseValidator);
                                exports.GroupedMenuExtensionValidator = GroupedMenuExtensionValidator;
                                var ExtensionPointsValidator = /** @class */ function(_super) {
                                    __extends(ExtensionPointsValidator, _super);
                                    function ExtensionPointsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ExtensionPointsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visualContextMenu",
                                                validators: [
                                                    validator_1.Validators.menuExtensionValidator
                                                ]
                                            },
                                            {
                                                field: "visualOptionsMenu",
                                                validators: [
                                                    validator_1.Validators.menuExtensionValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ExtensionPointsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ExtensionPointsValidator = ExtensionPointsValidator;
                                var ExtensionItemValidator = /** @class */ function(_super) {
                                    __extends(ExtensionItemValidator, _super);
                                    function ExtensionItemValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ExtensionItemValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "extend",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.extensionPointsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ExtensionItemValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ExtensionItemValidator = ExtensionItemValidator;
                                var CommandExtensionValidator = /** @class */ function(_super) {
                                    __extends(CommandExtensionValidator, _super);
                                    function CommandExtensionValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CommandExtensionValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "title",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "icon",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "selector",
                                                validators: [
                                                    validator_1.Validators.commandExtensionSelectorValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CommandExtensionValidator;
                                }(ExtensionItemValidator);
                                exports.CommandExtensionValidator = CommandExtensionValidator;
                                var ExtensionValidator = /** @class */ function(_super) {
                                    __extends(ExtensionValidator, _super);
                                    function ExtensionValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ExtensionValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "command",
                                                validators: [
                                                    validator_1.Validators.commandExtensionValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ExtensionValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ExtensionValidator = ExtensionValidator;
                                var MenuGroupExtensionValidator = /** @class */ function(_super) {
                                    __extends(MenuGroupExtensionValidator, _super);
                                    function MenuGroupExtensionValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    MenuGroupExtensionValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "title",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "menuLocation",
                                                validators: [
                                                    validator_1.Validators.menuLocationValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return MenuGroupExtensionValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.MenuGroupExtensionValidator = MenuGroupExtensionValidator;
                                var ExtensionsValidator = /** @class */ function(_super) {
                                    __extends(ExtensionsValidator, _super);
                                    function ExtensionsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ExtensionsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "commands",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.commandExtensionArrayValidator
                                                ]
                                            },
                                            {
                                                field: "groups",
                                                validators: [
                                                    validator_1.Validators.menuGroupExtensionArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ExtensionsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ExtensionsValidator = ExtensionsValidator;
                            /***/ },
                            /* 12 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_119099__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.OnLoadFiltersValidator = exports.OnLoadFiltersBaseRemoveOperationValidator = exports.OnLoadFiltersBaseValidator = exports.ConditionItemValidator = exports.RemoveFiltersRequestValidator = exports.UpdateFiltersRequestValidator = exports.FilterValidator = exports.IncludeExcludePointValueValidator = exports.HierarchyFilterNodeValidator = exports.HierarchyFilterValidator = exports.IncludeExcludeFilterValidator = exports.NotSupportedFilterValidator = exports.TopNFilterValidator = exports.RelativeTimeFilterValidator = exports.RelativeDateFilterValidator = exports.RelativeDateTimeFilterValidator = exports.AdvancedFilterValidator = exports.BasicFilterValidator = exports.FilterValidatorBase = exports.FilterDisplaySettingsValidator = exports.FilterMeasureTargetValidator = exports.FilterKeyHierarchyTargetValidator = exports.FilterHierarchyTargetValidator = exports.FilterKeyColumnsTargetValidator = exports.FilterColumnTargetValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_119099__(3);
                                var typeValidator_1 = __nested_webpack_require_119099__(4);
                                var validator_1 = __nested_webpack_require_119099__(1);
                                var FilterColumnTargetValidator = /** @class */ function(_super) {
                                    __extends(FilterColumnTargetValidator, _super);
                                    function FilterColumnTargetValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterColumnTargetValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "table",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "column",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FilterColumnTargetValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.FilterColumnTargetValidator = FilterColumnTargetValidator;
                                var FilterKeyColumnsTargetValidator = /** @class */ function(_super) {
                                    __extends(FilterKeyColumnsTargetValidator, _super);
                                    function FilterKeyColumnsTargetValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterKeyColumnsTargetValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "keys",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FilterKeyColumnsTargetValidator;
                                }(FilterColumnTargetValidator);
                                exports.FilterKeyColumnsTargetValidator = FilterKeyColumnsTargetValidator;
                                var FilterHierarchyTargetValidator = /** @class */ function(_super) {
                                    __extends(FilterHierarchyTargetValidator, _super);
                                    function FilterHierarchyTargetValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterHierarchyTargetValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "table",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "hierarchy",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "hierarchyLevel",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FilterHierarchyTargetValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.FilterHierarchyTargetValidator = FilterHierarchyTargetValidator;
                                var FilterKeyHierarchyTargetValidator = /** @class */ function(_super) {
                                    __extends(FilterKeyHierarchyTargetValidator, _super);
                                    function FilterKeyHierarchyTargetValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterKeyHierarchyTargetValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "keys",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FilterKeyHierarchyTargetValidator;
                                }(FilterHierarchyTargetValidator);
                                exports.FilterKeyHierarchyTargetValidator = FilterKeyHierarchyTargetValidator;
                                var FilterMeasureTargetValidator = /** @class */ function(_super) {
                                    __extends(FilterMeasureTargetValidator, _super);
                                    function FilterMeasureTargetValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterMeasureTargetValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "table",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "measure",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FilterMeasureTargetValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.FilterMeasureTargetValidator = FilterMeasureTargetValidator;
                                var FilterDisplaySettingsValidator = /** @class */ function(_super) {
                                    __extends(FilterDisplaySettingsValidator, _super);
                                    function FilterDisplaySettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterDisplaySettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "isLockedInViewMode",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "isHiddenInViewMode",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "displayName",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FilterDisplaySettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.FilterDisplaySettingsValidator = FilterDisplaySettingsValidator;
                                var FilterValidatorBase = /** @class */ function(_super) {
                                    __extends(FilterValidatorBase, _super);
                                    function FilterValidatorBase() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterValidatorBase.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "target",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filterTargetValidator
                                                ]
                                            },
                                            {
                                                field: "$schema",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.filterTypeValidator
                                                ]
                                            },
                                            {
                                                field: "displaySettings",
                                                validators: [
                                                    validator_1.Validators.filterDisplaySettingsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FilterValidatorBase;
                                }(typeValidator_1.ObjectValidator);
                                exports.FilterValidatorBase = FilterValidatorBase;
                                var BasicFilterValidator = /** @class */ function(_super) {
                                    __extends(BasicFilterValidator, _super);
                                    function BasicFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    BasicFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "operator",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "values",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.anyArrayValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.basicFilterTypeValidator
                                                ]
                                            },
                                            {
                                                field: "requireSingleSelection",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return BasicFilterValidator;
                                }(FilterValidatorBase);
                                exports.BasicFilterValidator = BasicFilterValidator;
                                var AdvancedFilterValidator = /** @class */ function(_super) {
                                    __extends(AdvancedFilterValidator, _super);
                                    function AdvancedFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    AdvancedFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "logicalOperator",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "conditions",
                                                validators: [
                                                    validator_1.Validators.filterConditionsValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.advancedFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return AdvancedFilterValidator;
                                }(FilterValidatorBase);
                                exports.AdvancedFilterValidator = AdvancedFilterValidator;
                                var RelativeDateTimeFilterValidator = /** @class */ function(_super) {
                                    __extends(RelativeDateTimeFilterValidator, _super);
                                    function RelativeDateTimeFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    RelativeDateTimeFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "operator",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.relativeDateFilterOperatorValidator
                                                ]
                                            },
                                            {
                                                field: "timeUnitsCount",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "timeUnitType",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.relativeDateTimeFilterUnitTypeValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.relativeDateTimeFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return RelativeDateTimeFilterValidator;
                                }(FilterValidatorBase);
                                exports.RelativeDateTimeFilterValidator = RelativeDateTimeFilterValidator;
                                var RelativeDateFilterValidator = /** @class */ function(_super) {
                                    __extends(RelativeDateFilterValidator, _super);
                                    function RelativeDateFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    RelativeDateFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "includeToday",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "timeUnitType",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.relativeDateFilterTimeUnitTypeValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.relativeDateFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return RelativeDateFilterValidator;
                                }(RelativeDateTimeFilterValidator);
                                exports.RelativeDateFilterValidator = RelativeDateFilterValidator;
                                var RelativeTimeFilterValidator = /** @class */ function(_super) {
                                    __extends(RelativeTimeFilterValidator, _super);
                                    function RelativeTimeFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    RelativeTimeFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "timeUnitType",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.relativeTimeFilterTimeUnitTypeValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.relativeTimeFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return RelativeTimeFilterValidator;
                                }(RelativeDateTimeFilterValidator);
                                exports.RelativeTimeFilterValidator = RelativeTimeFilterValidator;
                                var TopNFilterValidator = /** @class */ function(_super) {
                                    __extends(TopNFilterValidator, _super);
                                    function TopNFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    TopNFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "operator",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "itemCount",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.topNFilterTypeValidator
                                                ]
                                            },
                                            {
                                                field: "orderBy",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filterTargetValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return TopNFilterValidator;
                                }(FilterValidatorBase);
                                exports.TopNFilterValidator = TopNFilterValidator;
                                var NotSupportedFilterValidator = /** @class */ function(_super) {
                                    __extends(NotSupportedFilterValidator, _super);
                                    function NotSupportedFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    NotSupportedFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "message",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "notSupportedTypeName",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.notSupportedFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return NotSupportedFilterValidator;
                                }(FilterValidatorBase);
                                exports.NotSupportedFilterValidator = NotSupportedFilterValidator;
                                var IncludeExcludeFilterValidator = /** @class */ function(_super) {
                                    __extends(IncludeExcludeFilterValidator, _super);
                                    function IncludeExcludeFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    IncludeExcludeFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "isExclude",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "values",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.includeExcludeFilterValuesValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.includeExludeFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return IncludeExcludeFilterValidator;
                                }(FilterValidatorBase);
                                exports.IncludeExcludeFilterValidator = IncludeExcludeFilterValidator;
                                var HierarchyFilterValidator = /** @class */ function(_super) {
                                    __extends(HierarchyFilterValidator, _super);
                                    function HierarchyFilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    HierarchyFilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "hierarchyData",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.hierarchyFilterValuesValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    validator_1.Validators.hierarchyFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return HierarchyFilterValidator;
                                }(FilterValidatorBase);
                                exports.HierarchyFilterValidator = HierarchyFilterValidator;
                                var HierarchyFilterNodeValidator = /** @class */ function(_super) {
                                    __extends(HierarchyFilterNodeValidator, _super);
                                    function HierarchyFilterNodeValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    HierarchyFilterNodeValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "value",
                                                validators: [
                                                    validator_1.Validators.anyValueValidator
                                                ]
                                            },
                                            {
                                                field: "keyValues",
                                                validators: [
                                                    validator_1.Validators.anyArrayValidator
                                                ]
                                            },
                                            {
                                                field: "children",
                                                validators: [
                                                    validator_1.Validators.hierarchyFilterValuesValidator
                                                ]
                                            },
                                            {
                                                field: "operator",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return HierarchyFilterNodeValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.HierarchyFilterNodeValidator = HierarchyFilterNodeValidator;
                                var IncludeExcludePointValueValidator = /** @class */ function(_super) {
                                    __extends(IncludeExcludePointValueValidator, _super);
                                    function IncludeExcludePointValueValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    IncludeExcludePointValueValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "value",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.anyValueValidator
                                                ]
                                            },
                                            {
                                                field: "keyValues",
                                                validators: [
                                                    validator_1.Validators.anyArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return IncludeExcludePointValueValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.IncludeExcludePointValueValidator = IncludeExcludePointValueValidator;
                                var FilterValidator = /** @class */ function(_super) {
                                    __extends(FilterValidator, _super);
                                    function FilterValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FilterValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        return validator_1.Validators.anyFilterValidator.validate(input, path, field);
                                    };
                                    return FilterValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.FilterValidator = FilterValidator;
                                var UpdateFiltersRequestValidator = /** @class */ function(_super) {
                                    __extends(UpdateFiltersRequestValidator, _super);
                                    function UpdateFiltersRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    UpdateFiltersRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "filtersOperation",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filtersOperationsUpdateValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return UpdateFiltersRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.UpdateFiltersRequestValidator = UpdateFiltersRequestValidator;
                                var RemoveFiltersRequestValidator = /** @class */ function(_super) {
                                    __extends(RemoveFiltersRequestValidator, _super);
                                    function RemoveFiltersRequestValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    RemoveFiltersRequestValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "filtersOperation",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filtersOperationsRemoveAllValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.fieldForbiddenValidator,
                                                    validator_1.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return RemoveFiltersRequestValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.RemoveFiltersRequestValidator = RemoveFiltersRequestValidator;
                                var ConditionItemValidator = /** @class */ function(_super) {
                                    __extends(ConditionItemValidator, _super);
                                    function ConditionItemValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ConditionItemValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "value",
                                                validators: [
                                                    validator_1.Validators.anyValueValidator
                                                ]
                                            },
                                            {
                                                field: "operator",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ConditionItemValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ConditionItemValidator = ConditionItemValidator;
                                var OnLoadFiltersBaseValidator = /** @class */ function(_super) {
                                    __extends(OnLoadFiltersBaseValidator, _super);
                                    function OnLoadFiltersBaseValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    OnLoadFiltersBaseValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "operation",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filtersOperationsUpdateValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return OnLoadFiltersBaseValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.OnLoadFiltersBaseValidator = OnLoadFiltersBaseValidator;
                                var OnLoadFiltersBaseRemoveOperationValidator = /** @class */ function(_super) {
                                    __extends(OnLoadFiltersBaseRemoveOperationValidator, _super);
                                    function OnLoadFiltersBaseRemoveOperationValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    OnLoadFiltersBaseRemoveOperationValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "operation",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.filtersOperationsRemoveAllValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.fieldForbiddenValidator,
                                                    validator_1.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return OnLoadFiltersBaseRemoveOperationValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.OnLoadFiltersBaseRemoveOperationValidator = OnLoadFiltersBaseRemoveOperationValidator;
                                var OnLoadFiltersValidator = /** @class */ function(_super) {
                                    __extends(OnLoadFiltersValidator, _super);
                                    function OnLoadFiltersValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    OnLoadFiltersValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "allPages",
                                                validators: [
                                                    validator_1.Validators.onLoadFiltersBaseValidator
                                                ]
                                            },
                                            {
                                                field: "currentPage",
                                                validators: [
                                                    validator_1.Validators.onLoadFiltersBaseValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return OnLoadFiltersValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.OnLoadFiltersValidator = OnLoadFiltersValidator;
                            /***/ },
                            /* 13 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_154405__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.PageLayoutValidator = exports.DisplayStateValidator = exports.VisualLayoutValidator = exports.CustomLayoutValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_154405__(3);
                                var typeValidator_1 = __nested_webpack_require_154405__(4);
                                var validator_1 = __nested_webpack_require_154405__(1);
                                var CustomLayoutValidator = /** @class */ function(_super) {
                                    __extends(CustomLayoutValidator, _super);
                                    function CustomLayoutValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CustomLayoutValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "pageSize",
                                                validators: [
                                                    validator_1.Validators.pageSizeValidator
                                                ]
                                            },
                                            {
                                                field: "displayOption",
                                                validators: [
                                                    validator_1.Validators.customLayoutDisplayOptionValidator
                                                ]
                                            },
                                            {
                                                field: "pagesLayout",
                                                validators: [
                                                    validator_1.Validators.pagesLayoutValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CustomLayoutValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.CustomLayoutValidator = CustomLayoutValidator;
                                var VisualLayoutValidator = /** @class */ function(_super) {
                                    __extends(VisualLayoutValidator, _super);
                                    function VisualLayoutValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    VisualLayoutValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "x",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "y",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "z",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "width",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "height",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "displayState",
                                                validators: [
                                                    validator_1.Validators.displayStateValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return VisualLayoutValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.VisualLayoutValidator = VisualLayoutValidator;
                                var DisplayStateValidator = /** @class */ function(_super) {
                                    __extends(DisplayStateValidator, _super);
                                    function DisplayStateValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    DisplayStateValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "mode",
                                                validators: [
                                                    validator_1.Validators.displayStateModeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return DisplayStateValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.DisplayStateValidator = DisplayStateValidator;
                                var PageLayoutValidator = /** @class */ function(_super) {
                                    __extends(PageLayoutValidator, _super);
                                    function PageLayoutValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PageLayoutValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visualsLayout",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.pageLayoutValidator
                                                ]
                                            },
                                            {
                                                field: "defaultLayout",
                                                validators: [
                                                    validator_1.Validators.visualLayoutValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PageLayoutValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PageLayoutValidator = PageLayoutValidator;
                            /***/ },
                            /* 14 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_160884__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.PageViewFieldValidator = exports.PageValidator = exports.CustomPageSizeValidator = exports.PageSizeValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_160884__(3);
                                var typeValidator_1 = __nested_webpack_require_160884__(4);
                                var validator_1 = __nested_webpack_require_160884__(1);
                                var PageSizeValidator = /** @class */ function(_super) {
                                    __extends(PageSizeValidator, _super);
                                    function PageSizeValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PageSizeValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "type",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.pageSizeTypeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PageSizeValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PageSizeValidator = PageSizeValidator;
                                var CustomPageSizeValidator = /** @class */ function(_super) {
                                    __extends(CustomPageSizeValidator, _super);
                                    function CustomPageSizeValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CustomPageSizeValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "width",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "height",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CustomPageSizeValidator;
                                }(PageSizeValidator);
                                exports.CustomPageSizeValidator = CustomPageSizeValidator;
                                var PageValidator = /** @class */ function(_super) {
                                    __extends(PageValidator, _super);
                                    function PageValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PageValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PageValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PageValidator = PageValidator;
                                var PageViewFieldValidator = /** @class */ function(_super) {
                                    __extends(PageViewFieldValidator, _super);
                                    function PageViewFieldValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PageViewFieldValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var possibleValues = [
                                            "actualSize",
                                            "fitToWidth",
                                            "oneColumn"
                                        ];
                                        if (possibleValues.indexOf(input) < 0) return [
                                            {
                                                message: "pageView must be a string with one of the following values: \"actualSize\", \"fitToWidth\", \"oneColumn\""
                                            }
                                        ];
                                        return null;
                                    };
                                    return PageViewFieldValidator;
                                }(typeValidator_1.StringValidator);
                                exports.PageViewFieldValidator = PageViewFieldValidator;
                            /***/ },
                            /* 15 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_166324__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.VisualizationsPaneValidator = exports.SyncSlicersPaneValidator = exports.SelectionPaneValidator = exports.PageNavigationPaneValidator = exports.FiltersPaneValidator = exports.FieldsPaneValidator = exports.BookmarksPaneValidator = exports.QnaPanesValidator = exports.ReportPanesValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_166324__(3);
                                var typeValidator_1 = __nested_webpack_require_166324__(4);
                                var validator_1 = __nested_webpack_require_166324__(1);
                                var ReportPanesValidator = /** @class */ function(_super) {
                                    __extends(ReportPanesValidator, _super);
                                    function ReportPanesValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ReportPanesValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "bookmarks",
                                                validators: [
                                                    validator_1.Validators.bookmarksPaneValidator
                                                ]
                                            },
                                            {
                                                field: "fields",
                                                validators: [
                                                    validator_1.Validators.fieldsPaneValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.filtersPaneValidator
                                                ]
                                            },
                                            {
                                                field: "pageNavigation",
                                                validators: [
                                                    validator_1.Validators.pageNavigationPaneValidator
                                                ]
                                            },
                                            {
                                                field: "selection",
                                                validators: [
                                                    validator_1.Validators.selectionPaneValidator
                                                ]
                                            },
                                            {
                                                field: "syncSlicers",
                                                validators: [
                                                    validator_1.Validators.syncSlicersPaneValidator
                                                ]
                                            },
                                            {
                                                field: "visualizations",
                                                validators: [
                                                    validator_1.Validators.visualizationsPaneValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ReportPanesValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ReportPanesValidator = ReportPanesValidator;
                                var QnaPanesValidator = /** @class */ function(_super) {
                                    __extends(QnaPanesValidator, _super);
                                    function QnaPanesValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    QnaPanesValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.filtersPaneValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return QnaPanesValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.QnaPanesValidator = QnaPanesValidator;
                                var BookmarksPaneValidator = /** @class */ function(_super) {
                                    __extends(BookmarksPaneValidator, _super);
                                    function BookmarksPaneValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    BookmarksPaneValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return BookmarksPaneValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.BookmarksPaneValidator = BookmarksPaneValidator;
                                var FieldsPaneValidator = /** @class */ function(_super) {
                                    __extends(FieldsPaneValidator, _super);
                                    function FieldsPaneValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FieldsPaneValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "expanded",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FieldsPaneValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.FieldsPaneValidator = FieldsPaneValidator;
                                var FiltersPaneValidator = /** @class */ function(_super) {
                                    __extends(FiltersPaneValidator, _super);
                                    function FiltersPaneValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    FiltersPaneValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "expanded",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return FiltersPaneValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.FiltersPaneValidator = FiltersPaneValidator;
                                var PageNavigationPaneValidator = /** @class */ function(_super) {
                                    __extends(PageNavigationPaneValidator, _super);
                                    function PageNavigationPaneValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PageNavigationPaneValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "position",
                                                validators: [
                                                    validator_1.Validators.pageNavigationPositionValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PageNavigationPaneValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PageNavigationPaneValidator = PageNavigationPaneValidator;
                                var SelectionPaneValidator = /** @class */ function(_super) {
                                    __extends(SelectionPaneValidator, _super);
                                    function SelectionPaneValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SelectionPaneValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SelectionPaneValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SelectionPaneValidator = SelectionPaneValidator;
                                var SyncSlicersPaneValidator = /** @class */ function(_super) {
                                    __extends(SyncSlicersPaneValidator, _super);
                                    function SyncSlicersPaneValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SyncSlicersPaneValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SyncSlicersPaneValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SyncSlicersPaneValidator = SyncSlicersPaneValidator;
                                var VisualizationsPaneValidator = /** @class */ function(_super) {
                                    __extends(VisualizationsPaneValidator, _super);
                                    function VisualizationsPaneValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    VisualizationsPaneValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "expanded",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return VisualizationsPaneValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.VisualizationsPaneValidator = VisualizationsPaneValidator;
                            /***/ },
                            /* 16 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_178070__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.QnaInterpretInputDataValidator = exports.QnaSettingsValidator = exports.LoadQnaValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_178070__(3);
                                var typeValidator_1 = __nested_webpack_require_178070__(4);
                                var validator_1 = __nested_webpack_require_178070__(1);
                                var LoadQnaValidator = /** @class */ function(_super) {
                                    __extends(LoadQnaValidator, _super);
                                    function LoadQnaValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    LoadQnaValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasetIds",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringArrayValidator
                                                ]
                                            },
                                            {
                                                field: "question",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "viewMode",
                                                validators: [
                                                    validator_1.Validators.viewModeValidator
                                                ]
                                            },
                                            {
                                                field: "settings",
                                                validators: [
                                                    validator_1.Validators.qnaSettingValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    validator_1.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return LoadQnaValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.LoadQnaValidator = LoadQnaValidator;
                                var QnaSettingsValidator = /** @class */ function(_super) {
                                    __extends(QnaSettingsValidator, _super);
                                    function QnaSettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    QnaSettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "filterPaneEnabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "hideErrors",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "panes",
                                                validators: [
                                                    validator_1.Validators.qnaPanesValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return QnaSettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.QnaSettingsValidator = QnaSettingsValidator;
                                var QnaInterpretInputDataValidator = /** @class */ function(_super) {
                                    __extends(QnaInterpretInputDataValidator, _super);
                                    function QnaInterpretInputDataValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    QnaInterpretInputDataValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "datasetIds",
                                                validators: [
                                                    validator_1.Validators.stringArrayValidator
                                                ]
                                            },
                                            {
                                                field: "question",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return QnaInterpretInputDataValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.QnaInterpretInputDataValidator = QnaInterpretInputDataValidator;
                            /***/ },
                            /* 17 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_183781__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.ReportCreateValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_183781__(3);
                                var typeValidator_1 = __nested_webpack_require_183781__(4);
                                var validator_1 = __nested_webpack_require_183781__(1);
                                var ReportCreateValidator = /** @class */ function(_super) {
                                    __extends(ReportCreateValidator, _super);
                                    function ReportCreateValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ReportCreateValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasetId",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    validator_1.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "theme",
                                                validators: [
                                                    validator_1.Validators.customThemeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ReportCreateValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ReportCreateValidator = ReportCreateValidator;
                            /***/ },
                            /* 18 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_186639__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.ReportLoadValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_186639__(3);
                                var typeValidator_1 = __nested_webpack_require_186639__(4);
                                var validator_1 = __nested_webpack_require_186639__(1);
                                var ReportLoadValidator = /** @class */ function(_super) {
                                    __extends(ReportLoadValidator, _super);
                                    function ReportLoadValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ReportLoadValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "settings",
                                                validators: [
                                                    validator_1.Validators.settingsValidator
                                                ]
                                            },
                                            {
                                                field: "pageName",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.reportLoadFiltersValidator
                                                ]
                                            },
                                            {
                                                field: "permissions",
                                                validators: [
                                                    validator_1.Validators.permissionsValidator
                                                ]
                                            },
                                            {
                                                field: "viewMode",
                                                validators: [
                                                    validator_1.Validators.viewModeValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    validator_1.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "bookmark",
                                                validators: [
                                                    validator_1.Validators.applyBookmarkValidator
                                                ]
                                            },
                                            {
                                                field: "theme",
                                                validators: [
                                                    validator_1.Validators.customThemeValidator
                                                ]
                                            },
                                            {
                                                field: "embedUrl",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasetBinding",
                                                validators: [
                                                    validator_1.Validators.datasetBindingValidator
                                                ]
                                            },
                                            {
                                                field: "contrastMode",
                                                validators: [
                                                    validator_1.Validators.contrastModeValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ReportLoadValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ReportLoadValidator = ReportLoadValidator;
                            /***/ },
                            /* 19 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_190760__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.ReportParameterFieldsValidator = exports.PaginatedReportLoadValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_190760__(3);
                                var typeValidator_1 = __nested_webpack_require_190760__(4);
                                var validator_1 = __nested_webpack_require_190760__(1);
                                var PaginatedReportLoadValidator = /** @class */ function(_super) {
                                    __extends(PaginatedReportLoadValidator, _super);
                                    function PaginatedReportLoadValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PaginatedReportLoadValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "settings",
                                                validators: [
                                                    validator_1.Validators.paginatedReportsettingsValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    validator_1.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "embedUrl",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "type",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "parameterValues",
                                                validators: [
                                                    validator_1.Validators.parameterValuesArrayValidator
                                                ]
                                            },
                                            {
                                                field: "datasetBindings",
                                                validators: [
                                                    validator_1.Validators.paginatedReportDatasetBindingArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PaginatedReportLoadValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PaginatedReportLoadValidator = PaginatedReportLoadValidator;
                                var ReportParameterFieldsValidator = /** @class */ function() {
                                    function ReportParameterFieldsValidator() {}
                                    ReportParameterFieldsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "value",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ReportParameterFieldsValidator;
                                }();
                                exports.ReportParameterFieldsValidator = ReportParameterFieldsValidator;
                            /***/ },
                            /* 20 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_195256__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.SaveAsParametersValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_195256__(3);
                                var typeValidator_1 = __nested_webpack_require_195256__(4);
                                var validator_1 = __nested_webpack_require_195256__(1);
                                var SaveAsParametersValidator = /** @class */ function(_super) {
                                    __extends(SaveAsParametersValidator, _super);
                                    function SaveAsParametersValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SaveAsParametersValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SaveAsParametersValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SaveAsParametersValidator = SaveAsParametersValidator;
                            /***/ },
                            /* 21 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_197537__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.SlicerTargetSelectorValidator = exports.VisualTypeSelectorValidator = exports.VisualSelectorValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_197537__(3);
                                var typeValidator_1 = __nested_webpack_require_197537__(4);
                                var typeValidator_2 = __nested_webpack_require_197537__(4);
                                var validator_1 = __nested_webpack_require_197537__(1);
                                var VisualSelectorValidator = /** @class */ function(_super) {
                                    __extends(VisualSelectorValidator, _super);
                                    function VisualSelectorValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    VisualSelectorValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                // Not required for this selector only - Backward compatibility
                                                field: "$schema",
                                                validators: [
                                                    validator_1.Validators.stringValidator,
                                                    new typeValidator_2.SchemaValidator("http://powerbi.com/product/schema#visualSelector")
                                                ]
                                            },
                                            {
                                                field: "visualName",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return VisualSelectorValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.VisualSelectorValidator = VisualSelectorValidator;
                                var VisualTypeSelectorValidator = /** @class */ function(_super) {
                                    __extends(VisualTypeSelectorValidator, _super);
                                    function VisualTypeSelectorValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    VisualTypeSelectorValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "$schema",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator,
                                                    new typeValidator_2.SchemaValidator("http://powerbi.com/product/schema#visualTypeSelector")
                                                ]
                                            },
                                            {
                                                field: "visualType",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return VisualTypeSelectorValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.VisualTypeSelectorValidator = VisualTypeSelectorValidator;
                                var SlicerTargetSelectorValidator = /** @class */ function(_super) {
                                    __extends(SlicerTargetSelectorValidator, _super);
                                    function SlicerTargetSelectorValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SlicerTargetSelectorValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "$schema",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator,
                                                    new typeValidator_2.SchemaValidator("http://powerbi.com/product/schema#slicerTargetSelector")
                                                ]
                                            },
                                            {
                                                field: "target",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.slicerTargetValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SlicerTargetSelectorValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SlicerTargetSelectorValidator = SlicerTargetSelectorValidator;
                            /***/ },
                            /* 22 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_202995__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.PaginatedReportSettingsValidator = exports.SettingsValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_202995__(3);
                                var typeValidator_1 = __nested_webpack_require_202995__(4);
                                var validator_1 = __nested_webpack_require_202995__(1);
                                var SettingsValidator = /** @class */ function(_super) {
                                    __extends(SettingsValidator, _super);
                                    function SettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "filterPaneEnabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "navContentPaneEnabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "bookmarksPaneEnabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "useCustomSaveAsDialog",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "extensions",
                                                validators: [
                                                    validator_1.Validators.extensionsValidator
                                                ]
                                            },
                                            {
                                                field: "layoutType",
                                                validators: [
                                                    validator_1.Validators.layoutTypeValidator
                                                ]
                                            },
                                            {
                                                field: "customLayout",
                                                validators: [
                                                    validator_1.Validators.customLayoutValidator
                                                ]
                                            },
                                            {
                                                field: "background",
                                                validators: [
                                                    validator_1.Validators.backgroundValidator
                                                ]
                                            },
                                            {
                                                field: "visualSettings",
                                                validators: [
                                                    validator_1.Validators.visualSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "hideErrors",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "commands",
                                                validators: [
                                                    validator_1.Validators.commandsSettingsArrayValidator
                                                ]
                                            },
                                            {
                                                field: "hyperlinkClickBehavior",
                                                validators: [
                                                    validator_1.Validators.hyperlinkClickBehaviorValidator
                                                ]
                                            },
                                            {
                                                field: "bars",
                                                validators: [
                                                    validator_1.Validators.reportBarsValidator
                                                ]
                                            },
                                            {
                                                field: "panes",
                                                validators: [
                                                    validator_1.Validators.reportPanesValidator
                                                ]
                                            },
                                            {
                                                field: "personalBookmarksEnabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "persistentFiltersEnabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "visualRenderedEvents",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "authoringHintsEnabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "printSettings",
                                                validators: [
                                                    validator_1.Validators.printSettingsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SettingsValidator = SettingsValidator;
                                var PaginatedReportSettingsValidator = /** @class */ function(_super) {
                                    __extends(PaginatedReportSettingsValidator, _super);
                                    function PaginatedReportSettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PaginatedReportSettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "commands",
                                                validators: [
                                                    validator_1.Validators.paginatedReportCommandsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PaginatedReportSettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PaginatedReportSettingsValidator = PaginatedReportSettingsValidator;
                            /***/ },
                            /* 23 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_208991__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.SlicerStateValidator = exports.SlicerValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_208991__(3);
                                var typeValidator_1 = __nested_webpack_require_208991__(4);
                                var validator_1 = __nested_webpack_require_208991__(1);
                                var SlicerValidator = /** @class */ function(_super) {
                                    __extends(SlicerValidator, _super);
                                    function SlicerValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SlicerValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "selector",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.slicerSelectorValidator
                                                ]
                                            },
                                            {
                                                field: "state",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.slicerStateValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SlicerValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SlicerValidator = SlicerValidator;
                                var SlicerStateValidator = /** @class */ function(_super) {
                                    __extends(SlicerStateValidator, _super);
                                    function SlicerStateValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    SlicerStateValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "filters",
                                                validators: [
                                                    validator_1.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return SlicerStateValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.SlicerStateValidator = SlicerStateValidator;
                            /***/ },
                            /* 24 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_212421__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.TileLoadValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_212421__(3);
                                var typeValidator_1 = __nested_webpack_require_212421__(4);
                                var validator_1 = __nested_webpack_require_212421__(1);
                                var TileLoadValidator = /** @class */ function(_super) {
                                    __extends(TileLoadValidator, _super);
                                    function TileLoadValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    TileLoadValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "dashboardId",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "pageView",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    validator_1.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "width",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "height",
                                                validators: [
                                                    validator_1.Validators.numberValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return TileLoadValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.TileLoadValidator = TileLoadValidator;
                            /***/ },
                            /* 25 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_215693__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.VisualHeaderValidator = exports.VisualHeaderSettingsValidator = exports.VisualSettingsValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_215693__(3);
                                var typeValidator_1 = __nested_webpack_require_215693__(4);
                                var validator_1 = __nested_webpack_require_215693__(1);
                                var VisualSettingsValidator = /** @class */ function(_super) {
                                    __extends(VisualSettingsValidator, _super);
                                    function VisualSettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    VisualSettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visualHeaders",
                                                validators: [
                                                    validator_1.Validators.visualHeadersValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return VisualSettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.VisualSettingsValidator = VisualSettingsValidator;
                                var VisualHeaderSettingsValidator = /** @class */ function(_super) {
                                    __extends(VisualHeaderSettingsValidator, _super);
                                    function VisualHeaderSettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    VisualHeaderSettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return VisualHeaderSettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.VisualHeaderSettingsValidator = VisualHeaderSettingsValidator;
                                var VisualHeaderValidator = /** @class */ function(_super) {
                                    __extends(VisualHeaderValidator, _super);
                                    function VisualHeaderValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    VisualHeaderValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "settings",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.visualHeaderSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "selector",
                                                validators: [
                                                    validator_1.Validators.visualHeaderSelectorValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return VisualHeaderValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.VisualHeaderValidator = VisualHeaderValidator;
                            /***/ },
                            /* 26 */ /***/ (__unused_webpack_module, exports)=>{
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.AnyOfValidator = void 0;
                                var AnyOfValidator = /** @class */ function() {
                                    function AnyOfValidator(validators) {
                                        this.validators = validators;
                                    }
                                    AnyOfValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var valid = false;
                                        for(var _i = 0, _a = this.validators; _i < _a.length; _i++){
                                            var validator = _a[_i];
                                            var errors = validator.validate(input, path, field);
                                            if (!errors) {
                                                valid = true;
                                                break;
                                            }
                                        }
                                        if (!valid) return [
                                            {
                                                message: field + " property is invalid",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "invalid"
                                            }
                                        ];
                                        return null;
                                    };
                                    return AnyOfValidator;
                                }();
                                exports.AnyOfValidator = AnyOfValidator;
                            /***/ },
                            /* 27 */ /***/ (__unused_webpack_module, exports)=>{
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.FieldForbiddenValidator = void 0;
                                var FieldForbiddenValidator = /** @class */ function() {
                                    function FieldForbiddenValidator() {}
                                    FieldForbiddenValidator.prototype.validate = function(input, path, field) {
                                        if (input !== undefined) return [
                                            {
                                                message: field + " is forbidden",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "forbidden"
                                            }
                                        ];
                                        return null;
                                    };
                                    return FieldForbiddenValidator;
                                }();
                                exports.FieldForbiddenValidator = FieldForbiddenValidator;
                            /***/ },
                            /* 28 */ /***/ (__unused_webpack_module, exports)=>{
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.FieldRequiredValidator = void 0;
                                var FieldRequiredValidator = /** @class */ function() {
                                    function FieldRequiredValidator() {}
                                    FieldRequiredValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return [
                                            {
                                                message: field + " is required",
                                                path: (path ? path + "." : "") + field,
                                                keyword: "required"
                                            }
                                        ];
                                        return null;
                                    };
                                    return FieldRequiredValidator;
                                }();
                                exports.FieldRequiredValidator = FieldRequiredValidator;
                            /***/ },
                            /* 29 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_223102__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.MapValidator = void 0;
                                var typeValidator_1 = __nested_webpack_require_223102__(4);
                                var MapValidator = /** @class */ function(_super) {
                                    __extends(MapValidator, _super);
                                    function MapValidator(keyValidators, valueValidators) {
                                        var _this = _super.call(this) || this;
                                        _this.keyValidators = keyValidators;
                                        _this.valueValidators = valueValidators;
                                        return _this;
                                    }
                                    MapValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        for(var key in input)if (input.hasOwnProperty(key)) {
                                            var fieldsPath = (path ? path + "." : "") + field + "." + key;
                                            for(var _i = 0, _a = this.keyValidators; _i < _a.length; _i++){
                                                var keyValidator = _a[_i];
                                                errors = keyValidator.validate(key, fieldsPath, field);
                                                if (errors) return errors;
                                            }
                                            for(var _b = 0, _c = this.valueValidators; _b < _c.length; _b++){
                                                var valueValidator = _c[_b];
                                                errors = valueValidator.validate(input[key], fieldsPath, field);
                                                if (errors) return errors;
                                            }
                                        }
                                        return null;
                                    };
                                    return MapValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.MapValidator = MapValidator;
                            /***/ },
                            /* 30 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_225786__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.ParametersPanelValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_225786__(3);
                                var typeValidator_1 = __nested_webpack_require_225786__(4);
                                var validator_1 = __nested_webpack_require_225786__(1);
                                var ParametersPanelValidator = /** @class */ function(_super) {
                                    __extends(ParametersPanelValidator, _super);
                                    function ParametersPanelValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ParametersPanelValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "expanded",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "enabled",
                                                validators: [
                                                    validator_1.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ParametersPanelValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ParametersPanelValidator = ParametersPanelValidator;
                            /***/ },
                            /* 31 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_228154__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.TableDataValidator = exports.TableSchemaValidator = exports.ColumnSchemaValidator = exports.CredentialsValidator = exports.DatasourceConnectionConfigValidator = exports.DatasetCreateConfigValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_228154__(3);
                                var typeValidator_1 = __nested_webpack_require_228154__(4);
                                var validator_1 = __nested_webpack_require_228154__(1);
                                var DatasetCreateConfigValidator = /** @class */ function(_super) {
                                    __extends(DatasetCreateConfigValidator, _super);
                                    function DatasetCreateConfigValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    DatasetCreateConfigValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "locale",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "mashupDocument",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasourceConnectionConfig",
                                                validators: [
                                                    validator_1.Validators.datasourceConnectionConfigValidator
                                                ]
                                            },
                                            {
                                                field: "tableSchemaList",
                                                validators: [
                                                    validator_1.Validators.tableSchemaListValidator
                                                ]
                                            },
                                            {
                                                field: "data",
                                                validators: [
                                                    validator_1.Validators.tableDataArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        errors = multipleFieldsValidator.validate(input, path, field);
                                        if (errors) return errors;
                                        if (input["datasourceConnectionConfig"] && input["mashupDocument"] == null) return [
                                            {
                                                message: "mashupDocument cannot be empty when datasourceConnectionConfig is presented"
                                            }
                                        ];
                                        if (input["data"] && input["tableSchemaList"] == null) return [
                                            {
                                                message: "tableSchemaList cannot be empty when data is provided"
                                            }
                                        ];
                                        if (input["data"] == null && input["mashupDocument"] == null) return [
                                            {
                                                message: "At least one of data or mashupDocument must be provided"
                                            }
                                        ];
                                    };
                                    return DatasetCreateConfigValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.DatasetCreateConfigValidator = DatasetCreateConfigValidator;
                                var DatasourceConnectionConfigValidator = /** @class */ function(_super) {
                                    __extends(DatasourceConnectionConfigValidator, _super);
                                    function DatasourceConnectionConfigValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    DatasourceConnectionConfigValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "dataCacheMode",
                                                validators: [
                                                    validator_1.Validators.dataCacheModeValidator
                                                ]
                                            },
                                            {
                                                field: "credentials",
                                                validators: [
                                                    validator_1.Validators.credentialsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return DatasourceConnectionConfigValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.DatasourceConnectionConfigValidator = DatasourceConnectionConfigValidator;
                                var CredentialsValidator = /** @class */ function(_super) {
                                    __extends(CredentialsValidator, _super);
                                    function CredentialsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    CredentialsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "credentialType",
                                                validators: [
                                                    validator_1.Validators.credentialTypeValidator
                                                ]
                                            },
                                            {
                                                field: "credentialDetails",
                                                validators: [
                                                    validator_1.Validators.credentialDetailsValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return CredentialsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.CredentialsValidator = CredentialsValidator;
                                var ColumnSchemaValidator = /** @class */ function(_super) {
                                    __extends(ColumnSchemaValidator, _super);
                                    function ColumnSchemaValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    ColumnSchemaValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "displayName",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "dataType",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return ColumnSchemaValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.ColumnSchemaValidator = ColumnSchemaValidator;
                                var TableSchemaValidator = /** @class */ function(_super) {
                                    __extends(TableSchemaValidator, _super);
                                    function TableSchemaValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    TableSchemaValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "columns",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.columnSchemaArrayValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return TableSchemaValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.TableSchemaValidator = TableSchemaValidator;
                                var TableDataValidator = /** @class */ function(_super) {
                                    __extends(TableDataValidator, _super);
                                    function TableDataValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    TableDataValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "name",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "rows",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.rawDataValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return TableDataValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.TableDataValidator = TableDataValidator;
                            /***/ },
                            /* 32 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_238209__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.QuickCreateValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_238209__(3);
                                var typeValidator_1 = __nested_webpack_require_238209__(4);
                                var validator_1 = __nested_webpack_require_238209__(1);
                                var QuickCreateValidator = /** @class */ function(_super) {
                                    __extends(QuickCreateValidator, _super);
                                    function QuickCreateValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    QuickCreateValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    validator_1.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "theme",
                                                validators: [
                                                    validator_1.Validators.customThemeValidator
                                                ]
                                            },
                                            {
                                                field: "datasetCreateConfig",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.datasetCreateConfigValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return QuickCreateValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.QuickCreateValidator = QuickCreateValidator;
                            /***/ },
                            /* 33 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_241082__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.PrintSettingsValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_241082__(3);
                                var typeValidator_1 = __nested_webpack_require_241082__(4);
                                var PrintSettingsValidator = /** @class */ function(_super) {
                                    __extends(PrintSettingsValidator, _super);
                                    function PrintSettingsValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PrintSettingsValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "browserPrintAdjustmentsMode",
                                                validators: [
                                                    new typeValidator_1.EnumValidator([
                                                        0,
                                                        1
                                                    ])
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PrintSettingsValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PrintSettingsValidator = PrintSettingsValidator;
                            /***/ },
                            /* 34 */ /***/ function(__unused_webpack_module, exports, __nested_webpack_require_243275__) {
                                // Copyright (c) Microsoft Corporation.
                                // Licensed under the MIT License.
                                var __extends = this && this.__extends || function() {
                                    var extendStatics = function(d, b) {
                                        extendStatics = Object.setPrototypeOf || ({
                                            __proto__: []
                                        }) instanceof Array && function(d, b) {
                                            d.__proto__ = b;
                                        } || function(d, b) {
                                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                                        };
                                        return extendStatics(d, b);
                                    };
                                    return function(d, b) {
                                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                                        extendStatics(d, b);
                                        function __() {
                                            this.constructor = d;
                                        }
                                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                                    };
                                }();
                                Object.defineProperty(exports, "__esModule", {
                                    value: true
                                });
                                exports.PaginatedReportDatasetBindingValidator = void 0;
                                var multipleFieldsValidator_1 = __nested_webpack_require_243275__(3);
                                var typeValidator_1 = __nested_webpack_require_243275__(4);
                                var validator_1 = __nested_webpack_require_243275__(1);
                                var PaginatedReportDatasetBindingValidator = /** @class */ function(_super) {
                                    __extends(PaginatedReportDatasetBindingValidator, _super);
                                    function PaginatedReportDatasetBindingValidator() {
                                        return _super !== null && _super.apply(this, arguments) || this;
                                    }
                                    PaginatedReportDatasetBindingValidator.prototype.validate = function(input, path, field) {
                                        if (input == null) return null;
                                        var errors = _super.prototype.validate.call(this, input, path, field);
                                        if (errors) return errors;
                                        var fields = [
                                            {
                                                field: "sourceDatasetId",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "targetDatasetId",
                                                validators: [
                                                    validator_1.Validators.fieldRequiredValidator,
                                                    validator_1.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                                        return multipleFieldsValidator.validate(input, path, field);
                                    };
                                    return PaginatedReportDatasetBindingValidator;
                                }(typeValidator_1.ObjectValidator);
                                exports.PaginatedReportDatasetBindingValidator = PaginatedReportDatasetBindingValidator;
                            /***/ }
                        ];
                        /************************************************************************/ /******/ // The module cache
                        /******/ var __webpack_module_cache__ = {};
                        /******/ /******/ // The require function
                        /******/ function __nested_webpack_require_246021__(moduleId) {
                            /******/ // Check if module is in cache
                            /******/ var cachedModule = __webpack_module_cache__[moduleId];
                            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
                            /******/ // Create a new module (and put it into the cache)
                            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                                /******/ // no module.id needed
                                /******/ // no module.loaded needed
                                /******/ exports: {}
                            };
                            /******/ /******/ // Execute the module function
                            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __nested_webpack_require_246021__);
                            /******/ /******/ // Return the exports of the module
                            /******/ return module1.exports;
                        /******/ }
                        /******/ /************************************************************************/ /******/ /******/ // startup
                        /******/ // Load entry module and return exports
                        /******/ // This entry module is referenced by other modules so it can't be inlined
                        /******/ var __nested_webpack_exports__ = __nested_webpack_require_246021__(0);
                        /******/ /******/ return __nested_webpack_exports__;
                    /******/ })();
                });
            //# sourceMappingURL=models.js.map
            /***/ },
            /***/ "./node_modules/powerbi-router/dist/router.js": /*!****************************************************!*\
  !*** ./node_modules/powerbi-router/dist/router.js ***!
  \****************************************************/ /***/ function(module1) {
                /*! powerbi-router v0.1.5 | (c) 2016 Microsoft Corporation MIT */ (function webpackUniversalModuleDefinition(root, factory) {
                    module1.exports = factory();
                })(this, function() {
                    return /******/ function(modules) {
                        /******/ // The module cache
                        /******/ var installedModules = {};
                        /******/ /******/ // The require function
                        /******/ function __nested_webpack_require_617__(moduleId) {
                            /******/ /******/ // Check if module is in cache
                            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                            /******/ /******/ // Create a new module (and put it into the cache)
                            /******/ var module1 = installedModules[moduleId] = {
                                /******/ exports: {},
                                /******/ id: moduleId,
                                /******/ loaded: false
                            };
                            /******/ /******/ // Execute the module function
                            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __nested_webpack_require_617__);
                            /******/ /******/ // Flag the module as loaded
                            /******/ module1.loaded = true;
                            /******/ /******/ // Return the exports of the module
                            /******/ return module1.exports;
                        /******/ }
                        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
                        /******/ __nested_webpack_require_617__.m = modules;
                        /******/ /******/ // expose the module cache
                        /******/ __nested_webpack_require_617__.c = installedModules;
                        /******/ /******/ // __webpack_public_path__
                        /******/ __nested_webpack_require_617__.p = "";
                        /******/ /******/ // Load entry module and return exports
                        /******/ return __nested_webpack_require_617__(0);
                    /******/ }([
                        /* 0 */ /***/ function(module1, exports, __nested_webpack_require_1897__) {
                            "use strict";
                            var RouteRecognizer = __nested_webpack_require_1897__(1);
                            var Router = function() {
                                function Router(handlers) {
                                    this.handlers = handlers;
                                    /**
	         * TODO: look at generating the router dynamically based on list of supported http methods
	         * instead of hardcoding the creation of these and the methods.
	         */ this.getRouteRecognizer = new RouteRecognizer();
                                    this.patchRouteRecognizer = new RouteRecognizer();
                                    this.postRouteRecognizer = new RouteRecognizer();
                                    this.putRouteRecognizer = new RouteRecognizer();
                                    this.deleteRouteRecognizer = new RouteRecognizer();
                                }
                                Router.prototype.get = function(url, handler) {
                                    this.registerHandler(this.getRouteRecognizer, "GET", url, handler);
                                    return this;
                                };
                                Router.prototype.patch = function(url, handler) {
                                    this.registerHandler(this.patchRouteRecognizer, "PATCH", url, handler);
                                    return this;
                                };
                                Router.prototype.post = function(url, handler) {
                                    this.registerHandler(this.postRouteRecognizer, "POST", url, handler);
                                    return this;
                                };
                                Router.prototype.put = function(url, handler) {
                                    this.registerHandler(this.putRouteRecognizer, "PUT", url, handler);
                                    return this;
                                };
                                Router.prototype.delete = function(url, handler) {
                                    this.registerHandler(this.deleteRouteRecognizer, "DELETE", url, handler);
                                    return this;
                                };
                                /**
	     * TODO: This method could use some refactoring.  There is conflict of interest between keeping clean separation of test and handle method
	     * Test method only returns boolean indicating if request can be handled, and handle method has opportunity to modify response and return promise of it.
	     * In the case of the router with route-recognizer where handlers are associated with routes, this already guarantees that only one handler is selected and makes the test method feel complicated
	     * Will leave as is an investigate cleaner ways at later time.
	     */ Router.prototype.registerHandler = function(routeRecognizer, method, url, handler) {
                                    var routeRecognizerHandler = function(request) {
                                        var response = new Response();
                                        return Promise.resolve(handler(request, response)).then(function(x) {
                                            return response;
                                        });
                                    };
                                    routeRecognizer.add([
                                        {
                                            path: url,
                                            handler: routeRecognizerHandler
                                        }
                                    ]);
                                    var internalHandler = {
                                        test: function(request) {
                                            if (request.method !== method) return false;
                                            var matchingRoutes = routeRecognizer.recognize(request.url);
                                            if (matchingRoutes === undefined) return false;
                                            /**
	                 * Copy parameters from recognized route to the request so they can be used within the handler function
	                 * This isn't ideal because it is side affect which modifies the request instead of strictly testing for true or false
	                 * but I don't see a better place to put this.  If we move it between the call to test and the handle it becomes part of the window post message proxy
	                 * even though it's responsibility is related to routing.
	                 */ var route = matchingRoutes[0];
                                            request.params = route.params;
                                            request.queryParams = matchingRoutes.queryParams;
                                            request.handler = route.handler;
                                            return true;
                                        },
                                        handle: function(request) {
                                            return request.handler(request);
                                        }
                                    };
                                    this.handlers.addHandler(internalHandler);
                                };
                                return Router;
                            }();
                            exports.Router = Router;
                            var Response = function() {
                                function Response() {
                                    this.statusCode = 200;
                                    this.headers = {};
                                    this.body = null;
                                }
                                Response.prototype.send = function(statusCode, body) {
                                    this.statusCode = statusCode;
                                    this.body = body;
                                };
                                return Response;
                            }();
                            exports.Response = Response;
                        /***/ },
                        /* 1 */ /***/ function(module1, exports, __nested_webpack_require_6218__) {
                            var __WEBPACK_AMD_DEFINE_RESULT__; /* WEBPACK VAR INJECTION */ 
                            (function(module1) {
                                (function() {
                                    "use strict";
                                    function $$route$recognizer$dsl$$Target(path, matcher, delegate) {
                                        this.path = path;
                                        this.matcher = matcher;
                                        this.delegate = delegate;
                                    }
                                    $$route$recognizer$dsl$$Target.prototype = {
                                        to: function(target, callback) {
                                            var delegate = this.delegate;
                                            if (delegate && delegate.willAddRoute) target = delegate.willAddRoute(this.matcher.target, target);
                                            this.matcher.add(this.path, target);
                                            if (callback) {
                                                if (callback.length === 0) throw new Error("You must have an argument in the function passed to `to`");
                                                this.matcher.addChild(this.path, target, callback, this.delegate);
                                            }
                                            return this;
                                        }
                                    };
                                    function $$route$recognizer$dsl$$Matcher(target) {
                                        this.routes = {};
                                        this.children = {};
                                        this.target = target;
                                    }
                                    $$route$recognizer$dsl$$Matcher.prototype = {
                                        add: function(path, handler) {
                                            this.routes[path] = handler;
                                        },
                                        addChild: function(path, target, callback, delegate) {
                                            var matcher = new $$route$recognizer$dsl$$Matcher(target);
                                            this.children[path] = matcher;
                                            var match = $$route$recognizer$dsl$$generateMatch(path, matcher, delegate);
                                            if (delegate && delegate.contextEntered) delegate.contextEntered(target, match);
                                            callback(match);
                                        }
                                    };
                                    function $$route$recognizer$dsl$$generateMatch(startingPath, matcher, delegate) {
                                        return function(path, nestedCallback) {
                                            var fullPath = startingPath + path;
                                            if (nestedCallback) nestedCallback($$route$recognizer$dsl$$generateMatch(fullPath, matcher, delegate));
                                            else return new $$route$recognizer$dsl$$Target(startingPath + path, matcher, delegate);
                                        };
                                    }
                                    function $$route$recognizer$dsl$$addRoute(routeArray, path, handler) {
                                        var len = 0;
                                        for(var i = 0; i < routeArray.length; i++)len += routeArray[i].path.length;
                                        path = path.substr(len);
                                        var route = {
                                            path: path,
                                            handler: handler
                                        };
                                        routeArray.push(route);
                                    }
                                    function $$route$recognizer$dsl$$eachRoute(baseRoute, matcher, callback, binding) {
                                        var routes = matcher.routes;
                                        for(var path in routes)if (routes.hasOwnProperty(path)) {
                                            var routeArray = baseRoute.slice();
                                            $$route$recognizer$dsl$$addRoute(routeArray, path, routes[path]);
                                            if (matcher.children[path]) $$route$recognizer$dsl$$eachRoute(routeArray, matcher.children[path], callback, binding);
                                            else callback.call(binding, routeArray);
                                        }
                                    }
                                    var $$route$recognizer$dsl$$default = function(callback, addRouteCallback) {
                                        var matcher = new $$route$recognizer$dsl$$Matcher();
                                        callback($$route$recognizer$dsl$$generateMatch("", matcher, this.delegate));
                                        $$route$recognizer$dsl$$eachRoute([], matcher, function(route) {
                                            if (addRouteCallback) addRouteCallback(this, route);
                                            else this.add(route);
                                        }, this);
                                    };
                                    var $$route$recognizer$$specials = [
                                        '/',
                                        '.',
                                        '*',
                                        '+',
                                        '?',
                                        '|',
                                        '(',
                                        ')',
                                        '[',
                                        ']',
                                        '{',
                                        '}',
                                        '\\'
                                    ];
                                    var $$route$recognizer$$escapeRegex = new RegExp('(\\' + $$route$recognizer$$specials.join('|\\') + ')', 'g');
                                    function $$route$recognizer$$isArray(test) {
                                        return Object.prototype.toString.call(test) === "[object Array]";
                                    }
                                    // A Segment represents a segment in the original route description.
                                    // Each Segment type provides an `eachChar` and `regex` method.
                                    //
                                    // The `eachChar` method invokes the callback with one or more character
                                    // specifications. A character specification consumes one or more input
                                    // characters.
                                    //
                                    // The `regex` method returns a regex fragment for the segment. If the
                                    // segment is a dynamic of star segment, the regex fragment also includes
                                    // a capture.
                                    //
                                    // A character specification contains:
                                    //
                                    // * `validChars`: a String with a list of all valid characters, or
                                    // * `invalidChars`: a String with a list of all invalid characters
                                    // * `repeat`: true if the character specification can repeat
                                    function $$route$recognizer$$StaticSegment(string) {
                                        this.string = string;
                                    }
                                    $$route$recognizer$$StaticSegment.prototype = {
                                        eachChar: function(currentState) {
                                            var string = this.string, ch;
                                            for(var i = 0; i < string.length; i++){
                                                ch = string.charAt(i);
                                                currentState = currentState.put({
                                                    invalidChars: undefined,
                                                    repeat: false,
                                                    validChars: ch
                                                });
                                            }
                                            return currentState;
                                        },
                                        regex: function() {
                                            return this.string.replace($$route$recognizer$$escapeRegex, '\\$1');
                                        },
                                        generate: function() {
                                            return this.string;
                                        }
                                    };
                                    function $$route$recognizer$$DynamicSegment(name) {
                                        this.name = name;
                                    }
                                    $$route$recognizer$$DynamicSegment.prototype = {
                                        eachChar: function(currentState) {
                                            return currentState.put({
                                                invalidChars: "/",
                                                repeat: true,
                                                validChars: undefined
                                            });
                                        },
                                        regex: function() {
                                            return "([^/]+)";
                                        },
                                        generate: function(params) {
                                            return params[this.name];
                                        }
                                    };
                                    function $$route$recognizer$$StarSegment(name) {
                                        this.name = name;
                                    }
                                    $$route$recognizer$$StarSegment.prototype = {
                                        eachChar: function(currentState) {
                                            return currentState.put({
                                                invalidChars: "",
                                                repeat: true,
                                                validChars: undefined
                                            });
                                        },
                                        regex: function() {
                                            return "(.+)";
                                        },
                                        generate: function(params) {
                                            return params[this.name];
                                        }
                                    };
                                    function $$route$recognizer$$EpsilonSegment() {}
                                    $$route$recognizer$$EpsilonSegment.prototype = {
                                        eachChar: function(currentState) {
                                            return currentState;
                                        },
                                        regex: function() {
                                            return "";
                                        },
                                        generate: function() {
                                            return "";
                                        }
                                    };
                                    function $$route$recognizer$$parse(route, names, specificity) {
                                        // normalize route as not starting with a "/". Recognition will
                                        // also normalize.
                                        if (route.charAt(0) === "/") route = route.substr(1);
                                        var segments = route.split("/");
                                        var results = new Array(segments.length);
                                        // A routes has specificity determined by the order that its different segments
                                        // appear in. This system mirrors how the magnitude of numbers written as strings
                                        // works.
                                        // Consider a number written as: "abc". An example would be "200". Any other number written
                                        // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
                                        // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
                                        // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
                                        // leading symbol, "1".
                                        // The rule is that symbols to the left carry more weight than symbols to the right
                                        // when a number is written out as a string. In the above strings, the leading digit
                                        // represents how many 100's are in the number, and it carries more weight than the middle
                                        // number which represents how many 10's are in the number.
                                        // This system of number magnitude works well for route specificity, too. A route written as
                                        // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
                                        // `x`, irrespective of the other parts.
                                        // Because of this similarity, we assign each type of segment a number value written as a
                                        // string. We can find the specificity of compound routes by concatenating these strings
                                        // together, from left to right. After we have looped through all of the segments,
                                        // we convert the string to a number.
                                        specificity.val = '';
                                        for(var i = 0; i < segments.length; i++){
                                            var segment = segments[i], match;
                                            if (match = segment.match(/^:([^\/]+)$/)) {
                                                results[i] = new $$route$recognizer$$DynamicSegment(match[1]);
                                                names.push(match[1]);
                                                specificity.val += '3';
                                            } else if (match = segment.match(/^\*([^\/]+)$/)) {
                                                results[i] = new $$route$recognizer$$StarSegment(match[1]);
                                                specificity.val += '1';
                                                names.push(match[1]);
                                            } else if (segment === "") {
                                                results[i] = new $$route$recognizer$$EpsilonSegment();
                                                specificity.val += '2';
                                            } else {
                                                results[i] = new $$route$recognizer$$StaticSegment(segment);
                                                specificity.val += '4';
                                            }
                                        }
                                        specificity.val = +specificity.val;
                                        return results;
                                    }
                                    // A State has a character specification and (`charSpec`) and a list of possible
                                    // subsequent states (`nextStates`).
                                    //
                                    // If a State is an accepting state, it will also have several additional
                                    // properties:
                                    //
                                    // * `regex`: A regular expression that is used to extract parameters from paths
                                    //   that reached this accepting state.
                                    // * `handlers`: Information on how to convert the list of captures into calls
                                    //   to registered handlers with the specified parameters
                                    // * `types`: How many static, dynamic or star segments in this route. Used to
                                    //   decide which route to use if multiple registered routes match a path.
                                    //
                                    // Currently, State is implemented naively by looping over `nextStates` and
                                    // comparing a character specification against a character. A more efficient
                                    // implementation would use a hash of keys pointing at one or more next states.
                                    function $$route$recognizer$$State(charSpec) {
                                        this.charSpec = charSpec;
                                        this.nextStates = [];
                                        this.charSpecs = {};
                                        this.regex = undefined;
                                        this.handlers = undefined;
                                        this.specificity = undefined;
                                    }
                                    $$route$recognizer$$State.prototype = {
                                        get: function(charSpec) {
                                            if (this.charSpecs[charSpec.validChars]) return this.charSpecs[charSpec.validChars];
                                            var nextStates = this.nextStates;
                                            for(var i = 0; i < nextStates.length; i++){
                                                var child = nextStates[i];
                                                var isEqual = child.charSpec.validChars === charSpec.validChars;
                                                isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;
                                                if (isEqual) {
                                                    this.charSpecs[charSpec.validChars] = child;
                                                    return child;
                                                }
                                            }
                                        },
                                        put: function(charSpec) {
                                            var state;
                                            // If the character specification already exists in a child of the current
                                            // state, just return that state.
                                            if (state = this.get(charSpec)) return state;
                                            // Make a new state for the character spec
                                            state = new $$route$recognizer$$State(charSpec);
                                            // Insert the new state as a child of the current state
                                            this.nextStates.push(state);
                                            // If this character specification repeats, insert the new state as a child
                                            // of itself. Note that this will not trigger an infinite loop because each
                                            // transition during recognition consumes a character.
                                            if (charSpec.repeat) state.nextStates.push(state);
                                            // Return the new state
                                            return state;
                                        },
                                        // Find a list of child states matching the next character
                                        match: function(ch) {
                                            var nextStates = this.nextStates, child, charSpec, chars;
                                            var returned = [];
                                            for(var i = 0; i < nextStates.length; i++){
                                                child = nextStates[i];
                                                charSpec = child.charSpec;
                                                if (typeof (chars = charSpec.validChars) !== 'undefined') {
                                                    if (chars.indexOf(ch) !== -1) returned.push(child);
                                                } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
                                                    if (chars.indexOf(ch) === -1) returned.push(child);
                                                }
                                            }
                                            return returned;
                                        }
                                    };
                                    // Sort the routes by specificity
                                    function $$route$recognizer$$sortSolutions(states) {
                                        return states.sort(function(a, b) {
                                            return b.specificity.val - a.specificity.val;
                                        });
                                    }
                                    function $$route$recognizer$$recognizeChar(states, ch) {
                                        var nextStates = [];
                                        for(var i = 0, l = states.length; i < l; i++){
                                            var state = states[i];
                                            nextStates = nextStates.concat(state.match(ch));
                                        }
                                        return nextStates;
                                    }
                                    var $$route$recognizer$$oCreate = Object.create || function(proto) {
                                        function F() {}
                                        F.prototype = proto;
                                        return new F();
                                    };
                                    function $$route$recognizer$$RecognizeResults(queryParams) {
                                        this.queryParams = queryParams || {};
                                    }
                                    $$route$recognizer$$RecognizeResults.prototype = $$route$recognizer$$oCreate({
                                        splice: Array.prototype.splice,
                                        slice: Array.prototype.slice,
                                        push: Array.prototype.push,
                                        length: 0,
                                        queryParams: null
                                    });
                                    function $$route$recognizer$$findHandler(state, path, queryParams) {
                                        var handlers = state.handlers, regex = state.regex;
                                        var captures = path.match(regex), currentCapture = 1;
                                        var result = new $$route$recognizer$$RecognizeResults(queryParams);
                                        result.length = handlers.length;
                                        for(var i = 0; i < handlers.length; i++){
                                            var handler = handlers[i], names = handler.names, params = {};
                                            for(var j = 0; j < names.length; j++)params[names[j]] = captures[currentCapture++];
                                            result[i] = {
                                                handler: handler.handler,
                                                params: params,
                                                isDynamic: !!names.length
                                            };
                                        }
                                        return result;
                                    }
                                    function $$route$recognizer$$decodeQueryParamPart(part) {
                                        // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
                                        part = part.replace(/\+/gm, '%20');
                                        var result;
                                        try {
                                            result = decodeURIComponent(part);
                                        } catch (error) {
                                            result = '';
                                        }
                                        return result;
                                    }
                                    // The main interface
                                    var $$route$recognizer$$RouteRecognizer = function() {
                                        this.rootState = new $$route$recognizer$$State();
                                        this.names = {};
                                    };
                                    $$route$recognizer$$RouteRecognizer.prototype = {
                                        add: function(routes, options) {
                                            var currentState = this.rootState, regex = "^", specificity = {}, handlers = new Array(routes.length), allSegments = [], name;
                                            var isEmpty = true;
                                            for(var i = 0; i < routes.length; i++){
                                                var route = routes[i], names = [];
                                                var segments = $$route$recognizer$$parse(route.path, names, specificity);
                                                allSegments = allSegments.concat(segments);
                                                for(var j = 0; j < segments.length; j++){
                                                    var segment = segments[j];
                                                    if (segment instanceof $$route$recognizer$$EpsilonSegment) continue;
                                                    isEmpty = false;
                                                    // Add a "/" for the new segment
                                                    currentState = currentState.put({
                                                        invalidChars: undefined,
                                                        repeat: false,
                                                        validChars: "/"
                                                    });
                                                    regex += "/";
                                                    // Add a representation of the segment to the NFA and regex
                                                    currentState = segment.eachChar(currentState);
                                                    regex += segment.regex();
                                                }
                                                var handler = {
                                                    handler: route.handler,
                                                    names: names
                                                };
                                                handlers[i] = handler;
                                            }
                                            if (isEmpty) {
                                                currentState = currentState.put({
                                                    invalidChars: undefined,
                                                    repeat: false,
                                                    validChars: "/"
                                                });
                                                regex += "/";
                                            }
                                            currentState.handlers = handlers;
                                            currentState.regex = new RegExp(regex + "$");
                                            currentState.specificity = specificity;
                                            if (name = options && options.as) this.names[name] = {
                                                segments: allSegments,
                                                handlers: handlers
                                            };
                                        },
                                        handlersFor: function(name) {
                                            var route = this.names[name];
                                            if (!route) throw new Error("There is no route named " + name);
                                            var result = new Array(route.handlers.length);
                                            for(var i = 0; i < route.handlers.length; i++)result[i] = route.handlers[i];
                                            return result;
                                        },
                                        hasRoute: function(name) {
                                            return !!this.names[name];
                                        },
                                        generate: function(name, params) {
                                            var route = this.names[name], output = "";
                                            if (!route) throw new Error("There is no route named " + name);
                                            var segments = route.segments;
                                            for(var i = 0; i < segments.length; i++){
                                                var segment = segments[i];
                                                if (segment instanceof $$route$recognizer$$EpsilonSegment) continue;
                                                output += "/";
                                                output += segment.generate(params);
                                            }
                                            if (output.charAt(0) !== '/') output = '/' + output;
                                            if (params && params.queryParams) output += this.generateQueryString(params.queryParams, route.handlers);
                                            return output;
                                        },
                                        generateQueryString: function(params, handlers) {
                                            var pairs = [];
                                            var keys = [];
                                            for(var key in params)if (params.hasOwnProperty(key)) keys.push(key);
                                            keys.sort();
                                            for(var i = 0; i < keys.length; i++){
                                                key = keys[i];
                                                var value = params[key];
                                                if (value == null) continue;
                                                var pair = encodeURIComponent(key);
                                                if ($$route$recognizer$$isArray(value)) for(var j = 0; j < value.length; j++){
                                                    var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
                                                    pairs.push(arrayPair);
                                                }
                                                else {
                                                    pair += "=" + encodeURIComponent(value);
                                                    pairs.push(pair);
                                                }
                                            }
                                            if (pairs.length === 0) return '';
                                            return "?" + pairs.join("&");
                                        },
                                        parseQueryString: function(queryString) {
                                            var pairs = queryString.split("&"), queryParams = {};
                                            for(var i = 0; i < pairs.length; i++){
                                                var pair = pairs[i].split('='), key = $$route$recognizer$$decodeQueryParamPart(pair[0]), keyLength = key.length, isArray = false, value;
                                                if (pair.length === 1) value = 'true';
                                                else {
                                                    //Handle arrays
                                                    if (keyLength > 2 && key.slice(keyLength - 2) === '[]') {
                                                        isArray = true;
                                                        key = key.slice(0, keyLength - 2);
                                                        if (!queryParams[key]) queryParams[key] = [];
                                                    }
                                                    value = pair[1] ? $$route$recognizer$$decodeQueryParamPart(pair[1]) : '';
                                                }
                                                if (isArray) queryParams[key].push(value);
                                                else queryParams[key] = value;
                                            }
                                            return queryParams;
                                        },
                                        recognize: function(path) {
                                            var states = [
                                                this.rootState
                                            ], pathLen, i, l, queryStart, queryParams = {}, isSlashDropped = false;
                                            queryStart = path.indexOf('?');
                                            if (queryStart !== -1) {
                                                var queryString = path.substr(queryStart + 1, path.length);
                                                path = path.substr(0, queryStart);
                                                queryParams = this.parseQueryString(queryString);
                                            }
                                            path = decodeURI(path);
                                            if (path.charAt(0) !== "/") path = "/" + path;
                                            pathLen = path.length;
                                            if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
                                                path = path.substr(0, pathLen - 1);
                                                isSlashDropped = true;
                                            }
                                            for(i = 0; i < path.length; i++){
                                                states = $$route$recognizer$$recognizeChar(states, path.charAt(i));
                                                if (!states.length) break;
                                            }
                                            var solutions = [];
                                            for(i = 0; i < states.length; i++)if (states[i].handlers) solutions.push(states[i]);
                                            states = $$route$recognizer$$sortSolutions(solutions);
                                            var state = solutions[0];
                                            if (state && state.handlers) {
                                                // if a trailing slash was dropped and a star segment is the last segment
                                                // specified, put the trailing slash back
                                                if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") path = path + "/";
                                                return $$route$recognizer$$findHandler(state, path, queryParams);
                                            }
                                        }
                                    };
                                    $$route$recognizer$$RouteRecognizer.prototype.map = $$route$recognizer$dsl$$default;
                                    $$route$recognizer$$RouteRecognizer.VERSION = '0.1.11';
                                    var $$route$recognizer$$default = $$route$recognizer$$RouteRecognizer;
                                    /* global define:true module:true window: true */ if (__nested_webpack_require_6218__(3)['amd']) __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                                        return $$route$recognizer$$default;
                                    }).call(exports, __nested_webpack_require_6218__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                                    else if (typeof module1 !== 'undefined' && module1['exports']) module1['exports'] = $$route$recognizer$$default;
                                    else if (typeof this !== 'undefined') this['RouteRecognizer'] = $$route$recognizer$$default;
                                }).call(this);
                            //# sourceMappingURL=route-recognizer.js.map
                            /* WEBPACK VAR INJECTION */ }).call(exports, __nested_webpack_require_6218__(2)(module1));
                        /***/ },
                        /* 2 */ /***/ function(module1, exports) {
                            module1.exports = function(module1) {
                                if (!module1.webpackPolyfill) {
                                    module1.deprecate = function() {};
                                    module1.paths = [];
                                    // module.parent = undefined by default
                                    module1.children = [];
                                    module1.webpackPolyfill = 1;
                                }
                                return module1;
                            };
                        /***/ },
                        /* 3 */ /***/ function(module1, exports) {
                            module1.exports = function() {
                                throw new Error("define cannot be used indirect");
                            };
                        /***/ }
                    ]);
                });
            //# sourceMappingURL=router.js.map
            /***/ },
            /***/ "./src/FilterBuilders/advancedFilterBuilder.ts": /*!*****************************************************!*\
  !*** ./src/FilterBuilders/advancedFilterBuilder.ts ***!
  \*****************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AdvancedFilterBuilder = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var filterBuilder_1 = __webpack_require__(/*! ./filterBuilder */ "./src/FilterBuilders/filterBuilder.ts");
                /**
 * Power BI Advanced filter builder component
 *
 * @export
 * @class AdvancedFilterBuilder
 * @extends {FilterBuilder}
 */ var AdvancedFilterBuilder = /** @class */ function(_super) {
                    __extends(AdvancedFilterBuilder, _super);
                    function AdvancedFilterBuilder() {
                        var _this = _super !== null && _super.apply(this, arguments) || this;
                        _this.conditions = [];
                        return _this;
                    }
                    /**
     * Sets And as logical operator for Advanced filter
     *
     * ```javascript
     *
     * const advancedFilterBuilder = new AdvancedFilterBuilder().and();
     * ```
     *
     * @returns {AdvancedFilterBuilder}
     */ AdvancedFilterBuilder.prototype.and = function() {
                        this.logicalOperator = "And";
                        return this;
                    };
                    /**
     * Sets Or as logical operator for Advanced filter
     *
     * ```javascript
     *
     * const advancedFilterBuilder = new AdvancedFilterBuilder().or();
     * ```
     *
     * @returns {AdvancedFilterBuilder}
     */ AdvancedFilterBuilder.prototype.or = function() {
                        this.logicalOperator = "Or";
                        return this;
                    };
                    /**
     * Adds a condition in Advanced filter
     *
     * ```javascript
     *
     * // Add two conditions
     * const advancedFilterBuilder = new AdvancedFilterBuilder().addCondition("Contains", "Wash").addCondition("Contains", "Park");
     * ```
     *
     * @returns {AdvancedFilterBuilder}
     */ AdvancedFilterBuilder.prototype.addCondition = function(operator, value) {
                        var condition = {
                            operator: operator,
                            value: value
                        };
                        this.conditions.push(condition);
                        return this;
                    };
                    /**
     * Creates Advanced filter
     *
     * ```javascript
     *
     * const advancedFilterBuilder = new AdvancedFilterBuilder().build();
     * ```
     *
     * @returns {AdvancedFilter}
     */ AdvancedFilterBuilder.prototype.build = function() {
                        var advancedFilter = new powerbi_models_1.AdvancedFilter(this.target, this.logicalOperator, this.conditions);
                        return advancedFilter;
                    };
                    return AdvancedFilterBuilder;
                }(filterBuilder_1.FilterBuilder);
                exports.AdvancedFilterBuilder = AdvancedFilterBuilder;
            /***/ },
            /***/ "./src/FilterBuilders/basicFilterBuilder.ts": /*!**************************************************!*\
  !*** ./src/FilterBuilders/basicFilterBuilder.ts ***!
  \**************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BasicFilterBuilder = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var filterBuilder_1 = __webpack_require__(/*! ./filterBuilder */ "./src/FilterBuilders/filterBuilder.ts");
                /**
 * Power BI Basic filter builder component
 *
 * @export
 * @class BasicFilterBuilder
 * @extends {FilterBuilder}
 */ var BasicFilterBuilder = /** @class */ function(_super) {
                    __extends(BasicFilterBuilder, _super);
                    function BasicFilterBuilder() {
                        var _this = _super !== null && _super.apply(this, arguments) || this;
                        _this.isRequireSingleSelection = false;
                        return _this;
                    }
                    /**
     * Sets In as operator for Basic filter
     *
     * ```javascript
     *
     * const basicFilterBuilder = new BasicFilterBuilder().in([values]);
     * ```
     *
     * @returns {BasicFilterBuilder}
     */ BasicFilterBuilder.prototype.in = function(values) {
                        this.operator = "In";
                        this.values = values;
                        return this;
                    };
                    /**
     * Sets NotIn as operator for Basic filter
     *
     * ```javascript
     *
     * const basicFilterBuilder = new BasicFilterBuilder().notIn([values]);
     * ```
     *
     * @returns {BasicFilterBuilder}
     */ BasicFilterBuilder.prototype.notIn = function(values) {
                        this.operator = "NotIn";
                        this.values = values;
                        return this;
                    };
                    /**
     * Sets All as operator for Basic filter
     *
     * ```javascript
     *
     * const basicFilterBuilder = new BasicFilterBuilder().all();
     * ```
     *
     * @returns {BasicFilterBuilder}
     */ BasicFilterBuilder.prototype.all = function() {
                        this.operator = "All";
                        this.values = [];
                        return this;
                    };
                    /**
     * Sets required single selection property for Basic filter
     *
     * ```javascript
     *
     * const basicFilterBuilder = new BasicFilterBuilder().requireSingleSelection(isRequireSingleSelection);
     * ```
     *
     * @returns {BasicFilterBuilder}
     */ BasicFilterBuilder.prototype.requireSingleSelection = function(isRequireSingleSelection) {
                        if (isRequireSingleSelection === void 0) isRequireSingleSelection = false;
                        this.isRequireSingleSelection = isRequireSingleSelection;
                        return this;
                    };
                    /**
     * Creates Basic filter
     *
     * ```javascript
     *
     * const basicFilterBuilder = new BasicFilterBuilder().build();
     * ```
     *
     * @returns {BasicFilter}
     */ BasicFilterBuilder.prototype.build = function() {
                        var basicFilter = new powerbi_models_1.BasicFilter(this.target, this.operator, this.values);
                        basicFilter.requireSingleSelection = this.isRequireSingleSelection;
                        return basicFilter;
                    };
                    return BasicFilterBuilder;
                }(filterBuilder_1.FilterBuilder);
                exports.BasicFilterBuilder = BasicFilterBuilder;
            /***/ },
            /***/ "./src/FilterBuilders/filterBuilder.ts": /*!*********************************************!*\
  !*** ./src/FilterBuilders/filterBuilder.ts ***!
  \*********************************************/ /***/ (__unused_webpack_module, exports)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FilterBuilder = void 0;
                /**
 * Generic filter builder for BasicFilter, AdvancedFilter, RelativeDate, RelativeTime and TopN
 *
 * @class
 */ var FilterBuilder = /** @class */ function() {
                    function FilterBuilder() {}
                    /**
     * Sets target property for filter with target object
     *
     * ```javascript
     * const target = {
     *  table: 'table1',
     *  column: 'column1'
     * };
     *
     * const filterBuilder = new FilterBuilder().withTargetObject(target);
     * ```
     *
     * @returns {FilterBuilder}
     */ FilterBuilder.prototype.withTargetObject = function(target) {
                        this.target = target;
                        return this;
                    };
                    /**
     * Sets target property for filter with column target object
     *
     * ```
     * const filterBuilder = new FilterBuilder().withColumnTarget(tableName, columnName);
     * ```
     *
     * @returns {FilterBuilder}
     */ FilterBuilder.prototype.withColumnTarget = function(tableName, columnName) {
                        this.target = {
                            table: tableName,
                            column: columnName
                        };
                        return this;
                    };
                    /**
     * Sets target property for filter with measure target object
     *
     * ```
     * const filterBuilder = new FilterBuilder().withMeasureTarget(tableName, measure);
     * ```
     *
     * @returns {FilterBuilder}
     */ FilterBuilder.prototype.withMeasureTarget = function(tableName, measure) {
                        this.target = {
                            table: tableName,
                            measure: measure
                        };
                        return this;
                    };
                    /**
     * Sets target property for filter with hierarchy level target object
     *
     * ```
     * const filterBuilder = new FilterBuilder().withHierarchyLevelTarget(tableName, hierarchy, hierarchyLevel);
     * ```
     *
     * @returns {FilterBuilder}
     */ FilterBuilder.prototype.withHierarchyLevelTarget = function(tableName, hierarchy, hierarchyLevel) {
                        this.target = {
                            table: tableName,
                            hierarchy: hierarchy,
                            hierarchyLevel: hierarchyLevel
                        };
                        return this;
                    };
                    /**
     * Sets target property for filter with column aggregation target object
     *
     * ```
     * const filterBuilder = new FilterBuilder().withColumnAggregation(tableName, columnName, aggregationFunction);
     * ```
     *
     * @returns {FilterBuilder}
     */ FilterBuilder.prototype.withColumnAggregation = function(tableName, columnName, aggregationFunction) {
                        this.target = {
                            table: tableName,
                            column: columnName,
                            aggregationFunction: aggregationFunction
                        };
                        return this;
                    };
                    /**
     * Sets target property for filter with hierarchy level aggregation target object
     *
     * ```
     * const filterBuilder = new FilterBuilder().withHierarchyLevelAggregationTarget(tableName, hierarchy, hierarchyLevel, aggregationFunction);
     * ```
     *
     * @returns {FilterBuilder}
     */ FilterBuilder.prototype.withHierarchyLevelAggregationTarget = function(tableName, hierarchy, hierarchyLevel, aggregationFunction) {
                        this.target = {
                            table: tableName,
                            hierarchy: hierarchy,
                            hierarchyLevel: hierarchyLevel,
                            aggregationFunction: aggregationFunction
                        };
                        return this;
                    };
                    return FilterBuilder;
                }();
                exports.FilterBuilder = FilterBuilder;
            /***/ },
            /***/ "./src/FilterBuilders/index.ts": /*!*************************************!*\
  !*** ./src/FilterBuilders/index.ts ***!
  \*************************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RelativeTimeFilterBuilder = exports.RelativeDateFilterBuilder = exports.TopNFilterBuilder = exports.AdvancedFilterBuilder = exports.BasicFilterBuilder = void 0;
                var basicFilterBuilder_1 = __webpack_require__(/*! ./basicFilterBuilder */ "./src/FilterBuilders/basicFilterBuilder.ts");
                Object.defineProperty(exports, "BasicFilterBuilder", {
                    enumerable: true,
                    get: function() {
                        return basicFilterBuilder_1.BasicFilterBuilder;
                    }
                });
                var advancedFilterBuilder_1 = __webpack_require__(/*! ./advancedFilterBuilder */ "./src/FilterBuilders/advancedFilterBuilder.ts");
                Object.defineProperty(exports, "AdvancedFilterBuilder", {
                    enumerable: true,
                    get: function() {
                        return advancedFilterBuilder_1.AdvancedFilterBuilder;
                    }
                });
                var topNFilterBuilder_1 = __webpack_require__(/*! ./topNFilterBuilder */ "./src/FilterBuilders/topNFilterBuilder.ts");
                Object.defineProperty(exports, "TopNFilterBuilder", {
                    enumerable: true,
                    get: function() {
                        return topNFilterBuilder_1.TopNFilterBuilder;
                    }
                });
                var relativeDateFilterBuilder_1 = __webpack_require__(/*! ./relativeDateFilterBuilder */ "./src/FilterBuilders/relativeDateFilterBuilder.ts");
                Object.defineProperty(exports, "RelativeDateFilterBuilder", {
                    enumerable: true,
                    get: function() {
                        return relativeDateFilterBuilder_1.RelativeDateFilterBuilder;
                    }
                });
                var relativeTimeFilterBuilder_1 = __webpack_require__(/*! ./relativeTimeFilterBuilder */ "./src/FilterBuilders/relativeTimeFilterBuilder.ts");
                Object.defineProperty(exports, "RelativeTimeFilterBuilder", {
                    enumerable: true,
                    get: function() {
                        return relativeTimeFilterBuilder_1.RelativeTimeFilterBuilder;
                    }
                });
            /***/ },
            /***/ "./src/FilterBuilders/relativeDateFilterBuilder.ts": /*!*********************************************************!*\
  !*** ./src/FilterBuilders/relativeDateFilterBuilder.ts ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RelativeDateFilterBuilder = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var filterBuilder_1 = __webpack_require__(/*! ./filterBuilder */ "./src/FilterBuilders/filterBuilder.ts");
                /**
 * Power BI Relative Date filter builder component
 *
 * @export
 * @class RelativeDateFilterBuilder
 * @extends {FilterBuilder}
 */ var RelativeDateFilterBuilder = /** @class */ function(_super) {
                    __extends(RelativeDateFilterBuilder, _super);
                    function RelativeDateFilterBuilder() {
                        var _this = _super !== null && _super.apply(this, arguments) || this;
                        _this.isTodayIncluded = true;
                        return _this;
                    }
                    /**
     * Sets inLast as operator for Relative Date filter
     *
     * ```javascript
     *
     * const relativeDateFilterBuilder = new RelativeDateFilterBuilder().inLast(timeUnitsCount, timeUnitType);
     * ```
     *
     * @param {number} timeUnitsCount - The amount of time units
     * @param {RelativeDateFilterTimeUnit} timeUnitType - Defines the unit of time the filter is using
     * @returns {RelativeDateFilterBuilder}
     */ RelativeDateFilterBuilder.prototype.inLast = function(timeUnitsCount, timeUnitType) {
                        this.operator = powerbi_models_1.RelativeDateOperators.InLast;
                        this.timeUnitsCount = timeUnitsCount;
                        this.timeUnitType = timeUnitType;
                        return this;
                    };
                    /**
     * Sets inThis as operator for Relative Date filter
     *
     * ```javascript
     *
     * const relativeDateFilterBuilder = new RelativeDateFilterBuilder().inThis(timeUnitsCount, timeUnitType);
     * ```
     *
     * @param {number} timeUnitsCount - The amount of time units
     * @param {RelativeDateFilterTimeUnit} timeUnitType - Defines the unit of time the filter is using
     * @returns {RelativeDateFilterBuilder}
     */ RelativeDateFilterBuilder.prototype.inThis = function(timeUnitsCount, timeUnitType) {
                        this.operator = powerbi_models_1.RelativeDateOperators.InThis;
                        this.timeUnitsCount = timeUnitsCount;
                        this.timeUnitType = timeUnitType;
                        return this;
                    };
                    /**
     * Sets inNext as operator for Relative Date filter
     *
     * ```javascript
     *
     * const relativeDateFilterBuilder = new RelativeDateFilterBuilder().inNext(timeUnitsCount, timeUnitType);
     * ```
     *
     * @param {number} timeUnitsCount - The amount of time units
     * @param {RelativeDateFilterTimeUnit} timeUnitType - Defines the unit of time the filter is using
     * @returns {RelativeDateFilterBuilder}
     */ RelativeDateFilterBuilder.prototype.inNext = function(timeUnitsCount, timeUnitType) {
                        this.operator = powerbi_models_1.RelativeDateOperators.InNext;
                        this.timeUnitsCount = timeUnitsCount;
                        this.timeUnitType = timeUnitType;
                        return this;
                    };
                    /**
     * Sets includeToday for Relative Date filter
     *
     * ```javascript
     *
     * const relativeDateFilterBuilder = new RelativeDateFilterBuilder().includeToday(includeToday);
     * ```
     *
     * @param {boolean} includeToday - Denotes if today is included or not
     * @returns {RelativeDateFilterBuilder}
     */ RelativeDateFilterBuilder.prototype.includeToday = function(includeToday) {
                        this.isTodayIncluded = includeToday;
                        return this;
                    };
                    /**
     * Creates Relative Date filter
     *
     * ```javascript
     *
     * const relativeDateFilterBuilder = new RelativeDateFilterBuilder().build();
     * ```
     *
     * @returns {RelativeDateFilter}
     */ RelativeDateFilterBuilder.prototype.build = function() {
                        var relativeDateFilter = new powerbi_models_1.RelativeDateFilter(this.target, this.operator, this.timeUnitsCount, this.timeUnitType, this.isTodayIncluded);
                        return relativeDateFilter;
                    };
                    return RelativeDateFilterBuilder;
                }(filterBuilder_1.FilterBuilder);
                exports.RelativeDateFilterBuilder = RelativeDateFilterBuilder;
            /***/ },
            /***/ "./src/FilterBuilders/relativeTimeFilterBuilder.ts": /*!*********************************************************!*\
  !*** ./src/FilterBuilders/relativeTimeFilterBuilder.ts ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RelativeTimeFilterBuilder = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var filterBuilder_1 = __webpack_require__(/*! ./filterBuilder */ "./src/FilterBuilders/filterBuilder.ts");
                /**
 * Power BI Relative Time filter builder component
 *
 * @export
 * @class RelativeTimeFilterBuilder
 * @extends {FilterBuilder}
 */ var RelativeTimeFilterBuilder = /** @class */ function(_super) {
                    __extends(RelativeTimeFilterBuilder, _super);
                    function RelativeTimeFilterBuilder() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    /**
     * Sets inLast as operator for Relative Time filter
     *
     * ```javascript
     *
     * const relativeTimeFilterBuilder = new RelativeTimeFilterBuilder().inLast(timeUnitsCount, timeUnitType);
     * ```
     *
     * @param {number} timeUnitsCount - The amount of time units
     * @param {RelativeDateFilterTimeUnit} timeUnitType - Defines the unit of time the filter is using
     * @returns {RelativeTimeFilterBuilder}
     */ RelativeTimeFilterBuilder.prototype.inLast = function(timeUnitsCount, timeUnitType) {
                        this.operator = powerbi_models_1.RelativeDateOperators.InLast;
                        this.timeUnitsCount = timeUnitsCount;
                        this.timeUnitType = timeUnitType;
                        return this;
                    };
                    /**
     * Sets inThis as operator for Relative Time filter
     *
     * ```javascript
     *
     * const relativeTimeFilterBuilder = new RelativeTimeFilterBuilder().inThis(timeUnitsCount, timeUnitType);
     * ```
     *
     * @param {number} timeUnitsCount - The amount of time units
     * @param {RelativeDateFilterTimeUnit} timeUnitType - Defines the unit of time the filter is using
     * @returns {RelativeTimeFilterBuilder}
     */ RelativeTimeFilterBuilder.prototype.inThis = function(timeUnitsCount, timeUnitType) {
                        this.operator = powerbi_models_1.RelativeDateOperators.InThis;
                        this.timeUnitsCount = timeUnitsCount;
                        this.timeUnitType = timeUnitType;
                        return this;
                    };
                    /**
     * Sets inNext as operator for Relative Time filter
     *
     * ```javascript
     *
     * const relativeTimeFilterBuilder = new RelativeTimeFilterBuilder().inNext(timeUnitsCount, timeUnitType);
     * ```
     *
     * @param {number} timeUnitsCount - The amount of time units
     * @param {RelativeDateFilterTimeUnit} timeUnitType - Defines the unit of time the filter is using
     * @returns {RelativeTimeFilterBuilder}
     */ RelativeTimeFilterBuilder.prototype.inNext = function(timeUnitsCount, timeUnitType) {
                        this.operator = powerbi_models_1.RelativeDateOperators.InNext;
                        this.timeUnitsCount = timeUnitsCount;
                        this.timeUnitType = timeUnitType;
                        return this;
                    };
                    /**
     * Creates Relative Time filter
     *
     * ```javascript
     *
     * const relativeTimeFilterBuilder = new RelativeTimeFilterBuilder().build();
     * ```
     *
     * @returns {RelativeTimeFilter}
     */ RelativeTimeFilterBuilder.prototype.build = function() {
                        var relativeTimeFilter = new powerbi_models_1.RelativeTimeFilter(this.target, this.operator, this.timeUnitsCount, this.timeUnitType);
                        return relativeTimeFilter;
                    };
                    return RelativeTimeFilterBuilder;
                }(filterBuilder_1.FilterBuilder);
                exports.RelativeTimeFilterBuilder = RelativeTimeFilterBuilder;
            /***/ },
            /***/ "./src/FilterBuilders/topNFilterBuilder.ts": /*!*************************************************!*\
  !*** ./src/FilterBuilders/topNFilterBuilder.ts ***!
  \*************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TopNFilterBuilder = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var filterBuilder_1 = __webpack_require__(/*! ./filterBuilder */ "./src/FilterBuilders/filterBuilder.ts");
                /**
 * Power BI Top N filter builder component
 *
 * @export
 * @class TopNFilterBuilder
 * @extends {FilterBuilder}
 */ var TopNFilterBuilder = /** @class */ function(_super) {
                    __extends(TopNFilterBuilder, _super);
                    function TopNFilterBuilder() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    /**
     * Sets Top as operator for Top N filter
     *
     * ```javascript
     *
     * const topNFilterBuilder = new TopNFilterBuilder().top(itemCount);
     * ```
     *
     * @returns {TopNFilterBuilder}
     */ TopNFilterBuilder.prototype.top = function(itemCount) {
                        this.operator = "Top";
                        this.itemCount = itemCount;
                        return this;
                    };
                    /**
     * Sets Bottom as operator for Top N filter
     *
     * ```javascript
     *
     * const topNFilterBuilder = new TopNFilterBuilder().bottom(itemCount);
     * ```
     *
     * @returns {TopNFilterBuilder}
     */ TopNFilterBuilder.prototype.bottom = function(itemCount) {
                        this.operator = "Bottom";
                        this.itemCount = itemCount;
                        return this;
                    };
                    /**
     * Sets order by for Top N filter
     *
     * ```javascript
     *
     * const topNFilterBuilder = new TopNFilterBuilder().orderByTarget(target);
     * ```
     *
     * @returns {TopNFilterBuilder}
     */ TopNFilterBuilder.prototype.orderByTarget = function(target) {
                        this.orderByTargetValue = target;
                        return this;
                    };
                    /**
     * Creates Top N filter
     *
     * ```javascript
     *
     * const topNFilterBuilder = new TopNFilterBuilder().build();
     * ```
     *
     * @returns {TopNFilter}
     */ TopNFilterBuilder.prototype.build = function() {
                        var topNFilter = new powerbi_models_1.TopNFilter(this.target, this.operator, this.itemCount, this.orderByTargetValue);
                        return topNFilter;
                    };
                    return TopNFilterBuilder;
                }(filterBuilder_1.FilterBuilder);
                exports.TopNFilterBuilder = TopNFilterBuilder;
            /***/ },
            /***/ "./src/bookmarksManager.ts": /*!*********************************!*\
  !*** ./src/bookmarksManager.ts ***!
  \*********************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BookmarksManager = void 0;
                var util_1 = __webpack_require__(/*! ./util */ "./src/util.ts");
                var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.ts");
                /**
 * Manages report bookmarks.
 *
 * @export
 * @class BookmarksManager
 * @implements {IBookmarksManager}
 */ var BookmarksManager = /** @class */ function() {
                    /**
     * @hidden
     */ function BookmarksManager(service, config, iframe) {
                        this.service = service;
                        this.config = config;
                        this.iframe = iframe;
                    }
                    /**
     * Gets bookmarks that are defined in the report.
     *
     * ```javascript
     * // Gets bookmarks that are defined in the report
     * bookmarksManager.getBookmarks()
     *   .then(bookmarks => {
     *     ...
     *   });
     * ```
     *
     * @returns {Promise<IReportBookmark[]>}
     */ BookmarksManager.prototype.getBookmarks = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/report/bookmarks", {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_1 = _a.sent();
                                        throw response_1.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Apply bookmark by name.
     *
     * ```javascript
     * bookmarksManager.apply(bookmarkName)
     * ```
     *
     * @param {string} bookmarkName The name of the bookmark to be applied
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ BookmarksManager.prototype.apply = function(bookmarkName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var request, response_2;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        request = {
                                            name: bookmarkName
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/bookmarks/applyByName", request, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_2 = _a.sent();
                                        throw response_2.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Play bookmarks: Enter or Exit bookmarks presentation mode.
     *
     * ```javascript
     * // Enter presentation mode.
     * bookmarksManager.play(BookmarksPlayMode.Presentation)
     * ```
     *
     * @param {BookmarksPlayMode} playMode Play mode can be either `Presentation` or `Off`
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ BookmarksManager.prototype.play = function(playMode) {
                        return __awaiter(this, void 0, void 0, function() {
                            var playBookmarkRequest, response_3;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        playBookmarkRequest = {
                                            playMode: playMode
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/bookmarks/play", playBookmarkRequest, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_3 = _a.sent();
                                        throw response_3.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Capture bookmark from current state.
     *
     * ```javascript
     * bookmarksManager.capture(options)
     * ```
     *
     * @param {ICaptureBookmarkOptions} [options] Options for bookmark capturing
     * @returns {Promise<IReportBookmark>}
     */ BookmarksManager.prototype.capture = function(options) {
                        return __awaiter(this, void 0, void 0, function() {
                            var request, response, response_4;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        request = {
                                            options: options || {}
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/bookmarks/capture", request, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_4 = _a.sent();
                                        throw response_4.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Apply bookmark state.
     *
     * ```javascript
     * bookmarksManager.applyState(bookmarkState)
     * ```
     *
     * @param {string} state A base64 bookmark state to be applied
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ BookmarksManager.prototype.applyState = function(state) {
                        return __awaiter(this, void 0, void 0, function() {
                            var request, response_5;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        request = {
                                            state: state
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/bookmarks/applyState", request, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_5 = _a.sent();
                                        throw response_5.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return BookmarksManager;
                }();
                exports.BookmarksManager = BookmarksManager;
            /***/ },
            /***/ "./src/config.ts": /*!***********************!*\
  !*** ./src/config.ts ***!
  \***********************/ /***/ (__unused_webpack_module, exports)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /** @ignore */ /** */ var config = {
                    version: '2.23.1',
                    type: 'js'
                };
                exports["default"] = config;
            /***/ },
            /***/ "./src/create.ts": /*!***********************!*\
  !*** ./src/create.ts ***!
  \***********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Create = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
                var utils = __webpack_require__(/*! ./util */ "./src/util.ts");
                /**
 * A Power BI Report creator component
 *
 * @export
 * @class Create
 * @extends {Embed}
 */ var Create = /** @class */ function(_super) {
                    __extends(Create, _super);
                    /*
     * @hidden
     */ function Create(service, element, config, phasedRender, isBootstrap) {
                        return _super.call(this, service, element, config, /* iframe */ undefined, phasedRender, isBootstrap) || this;
                    }
                    /**
     * Gets the dataset ID from the first available location: createConfig or embed url.
     *
     * @returns {string}
     */ Create.prototype.getId = function() {
                        var datasetId = this.createConfig && this.createConfig.datasetId ? this.createConfig.datasetId : Create.findIdFromEmbedUrl(this.config.embedUrl);
                        if (typeof datasetId !== 'string' || datasetId.length === 0) throw new Error('Dataset id is required, but it was not found. You must provide an id either as part of embed configuration.');
                        return datasetId;
                    };
                    /**
     * Validate create report configuration.
     */ Create.prototype.validate = function(config) {
                        return (0, powerbi_models_1.validateCreateReport)(config);
                    };
                    /**
     * Handle config changes.
     *
     * @hidden
     * @returns {void}
     */ Create.prototype.configChanged = function(isBootstrap) {
                        if (isBootstrap) return;
                        var config = this.config;
                        this.createConfig = {
                            accessToken: config.accessToken,
                            datasetId: config.datasetId || this.getId(),
                            groupId: config.groupId,
                            settings: config.settings,
                            tokenType: config.tokenType,
                            theme: config.theme
                        };
                    };
                    /**
     * @hidden
     * @returns {string}
     */ Create.prototype.getDefaultEmbedUrlEndpoint = function() {
                        return "reportEmbed";
                    };
                    /**
     * checks if the report is saved.
     *
     * ```javascript
     * report.isSaved()
     * ```
     *
     * @returns {Promise<boolean>}
     */ Create.prototype.isSaved = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            utils.isSavedInternal(this.service.hpm, this.config.uniqueId, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Adds the ability to get datasetId from url.
     * (e.g. http://embedded.powerbi.com/appTokenReportEmbed?datasetId=854846ed-2106-4dc2-bc58-eb77533bf2f1).
     *
     * By extracting the ID we can ensure that the ID is always explicitly provided as part of the create configuration.
     *
     * @static
     * @param {string} url
     * @returns {string}
     * @hidden
     */ Create.findIdFromEmbedUrl = function(url) {
                        var datasetIdRegEx = /datasetId="?([^&]+)"?/;
                        var datasetIdMatch = url.match(datasetIdRegEx);
                        var datasetId;
                        if (datasetIdMatch) datasetId = datasetIdMatch[1];
                        return datasetId;
                    };
                    /**
     * Sends create configuration data.
     *
     * ```javascript
     * create ({
     *   datasetId: '5dac7a4a-4452-46b3-99f6-a25915e0fe55',
     *   accessToken: 'eyJ0eXA ... TaE2rTSbmg',
     * ```
     *
     * @hidden
     * @returns {Promise<void>}
     */ Create.prototype.create = function() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var errors, headers, response, response_1;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        errors = (0, powerbi_models_1.validateCreateReport)(this.createConfig);
                                        if (errors) throw errors;
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        headers = {
                                            uid: this.config.uniqueId,
                                            sdkSessionId: this.service.getSdkSessionId()
                                        };
                                        if (!!((_a = this.eventHooks) === null || _a === void 0 ? void 0 : _a.accessTokenProvider)) headers.tokenProviderSupplied = true;
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/create", this.createConfig, headers, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_1 = _b.sent();
                                        throw response_1.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return Create;
                }(embed_1.Embed);
                exports.Create = Create;
            /***/ },
            /***/ "./src/dashboard.ts": /*!**************************!*\
  !*** ./src/dashboard.ts ***!
  \**************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Dashboard = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
                /**
 * A Power BI Dashboard embed component
 *
 * @export
 * @class Dashboard
 * @extends {Embed}
 * @implements {IDashboardNode}
 */ var Dashboard = /** @class */ function(_super) {
                    __extends(Dashboard, _super);
                    /**
     * Creates an instance of a Power BI Dashboard.
     *
     * @param {service.Service} service
     * @hidden
     * @param {HTMLElement} element
     */ function Dashboard(service, element, config, phasedRender, isBootstrap) {
                        var _this = _super.call(this, service, element, config, /* iframe */ undefined, phasedRender, isBootstrap) || this;
                        _this.loadPath = "/dashboard/load";
                        _this.phasedLoadPath = "/dashboard/prepare";
                        Array.prototype.push.apply(_this.allowedEvents, Dashboard.allowedEvents);
                        return _this;
                    }
                    /**
     * This adds backwards compatibility for older config which used the dashboardId query param to specify dashboard id.
     * E.g. https://powerbi-df.analysis-df.windows.net/dashboardEmbedHost?dashboardId=e9363c62-edb6-4eac-92d3-2199c5ca2a9e
     *
     * By extracting the id we can ensure id is always explicitly provided as part of the load configuration.
     *
     * @hidden
     * @static
     * @param {string} url
     * @returns {string}
     */ Dashboard.findIdFromEmbedUrl = function(url) {
                        var dashboardIdRegEx = /dashboardId="?([^&]+)"?/;
                        var dashboardIdMatch = url.match(dashboardIdRegEx);
                        var dashboardId;
                        if (dashboardIdMatch) dashboardId = dashboardIdMatch[1];
                        return dashboardId;
                    };
                    /**
     * Get dashboard id from first available location: options, attribute, embed url.
     *
     * @returns {string}
     */ Dashboard.prototype.getId = function() {
                        var config = this.config;
                        var dashboardId = config.id || this.element.getAttribute(Dashboard.dashboardIdAttribute) || Dashboard.findIdFromEmbedUrl(config.embedUrl);
                        if (typeof dashboardId !== 'string' || dashboardId.length === 0) throw new Error("Dashboard id is required, but it was not found. You must provide an id either as part of embed configuration or as attribute '".concat(Dashboard.dashboardIdAttribute, "'."));
                        return dashboardId;
                    };
                    /**
     * Validate load configuration.
     *
     * @hidden
     */ Dashboard.prototype.validate = function(baseConfig) {
                        var config = baseConfig;
                        var error = (0, powerbi_models_1.validateDashboardLoad)(config);
                        return error ? error : this.validatePageView(config.pageView);
                    };
                    /**
     * Handle config changes.
     *
     * @hidden
     * @returns {void}
     */ Dashboard.prototype.configChanged = function(isBootstrap) {
                        if (isBootstrap) return;
                        // Populate dashboard id into config object.
                        this.config.id = this.getId();
                    };
                    /**
     * @hidden
     * @returns {string}
     */ Dashboard.prototype.getDefaultEmbedUrlEndpoint = function() {
                        return "dashboardEmbed";
                    };
                    /**
     * Validate that pageView has a legal value: if page view is defined it must have one of the values defined in PageView
     *
     * @hidden
     */ Dashboard.prototype.validatePageView = function(pageView) {
                        if (pageView && pageView !== "fitToWidth" && pageView !== "oneColumn" && pageView !== "actualSize") return [
                            {
                                message: "pageView must be one of the followings: fitToWidth, oneColumn, actualSize"
                            }
                        ];
                    };
                    /** @hidden */ Dashboard.allowedEvents = [
                        "tileClicked",
                        "error"
                    ];
                    /** @hidden */ Dashboard.dashboardIdAttribute = 'powerbi-dashboard-id';
                    /** @hidden */ Dashboard.typeAttribute = 'powerbi-type';
                    /** @hidden */ Dashboard.type = "Dashboard";
                    return Dashboard;
                }(embed_1.Embed);
                exports.Dashboard = Dashboard;
            /***/ },
            /***/ "./src/embed.ts": /*!**********************!*\
  !*** ./src/embed.ts ***!
  \**********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Embed = void 0;
                var models = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var sdkConfig = __webpack_require__(/*! ./config */ "./src/config.ts");
                var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.ts");
                var util_1 = __webpack_require__(/*! ./util */ "./src/util.ts");
                /**
 * Base class for all Power BI embed components
 *
 * @export
 * @abstract
 * @hidden
 * @class Embed
 */ var Embed = /** @class */ function() {
                    /**
     * Creates an instance of Embed.
     *
     * Note: there is circular reference between embeds and the service, because
     * the service has a list of all embeds on the host page, and each embed has a reference to the service that created it.
     *
     * @param {service.Service} service
     * @param {HTMLElement} element
     * @param {IEmbedConfigurationBase} config
     * @hidden
     */ function Embed(service, element, config, iframe, phasedRender, isBootstrap) {
                        /** @hidden */ this.allowedEvents = [];
                        if ((0, util_1.autoAuthInEmbedUrl)(config.embedUrl)) throw new Error(errors_1.EmbedUrlNotSupported);
                        Array.prototype.push.apply(this.allowedEvents, Embed.allowedEvents);
                        this.eventHandlers = [];
                        this.service = service;
                        this.element = element;
                        this.iframe = iframe;
                        this.iframeLoaded = false;
                        this.embedtype = config.type.toLowerCase();
                        this.commands = [];
                        this.groups = [];
                        this.populateConfig(config, isBootstrap);
                        if ((0, util_1.isCreate)(this.embedtype)) this.setIframe(false, phasedRender, isBootstrap);
                        else this.setIframe(true, phasedRender, isBootstrap);
                    }
                    /**
     * Create is not supported by default
     *
     * @hidden
     * @returns {Promise<void>}
     */ Embed.prototype.create = function() {
                        throw new Error("no create support");
                    };
                    /**
     * Saves Report.
     *
     * @returns {Promise<void>}
     */ Embed.prototype.save = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post('/report/save', null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_1 = _a.sent();
                                        throw response_1.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * SaveAs Report.
     *
     * @returns {Promise<void>}
     */ Embed.prototype.saveAs = function(saveAsParameters) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_2;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post('/report/saveAs', saveAsParameters, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_2 = _a.sent();
                                        throw response_2.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Get the correlationId for the current embed session.
     *
     * ```javascript
     * // Get the correlationId for the current embed session
     * report.getCorrelationId()
     *   .then(correlationId => {
     *     ...
     *   });
     * ```
     *
     * @returns {Promise<string>}
     */ Embed.prototype.getCorrelationId = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_3;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/getCorrelationId", {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_3 = _a.sent();
                                        throw response_3.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Sends load configuration data.
     *
     * ```javascript
     * report.load({
     *   type: 'report',
     *   id: '5dac7a4a-4452-46b3-99f6-a25915e0fe55',
     *   accessToken: 'eyJ0eXA ... TaE2rTSbmg',
     *   settings: {
     *     navContentPaneEnabled: false
     *   },
     *   pageName: "DefaultPage",
     *   filters: [
     *     {
     *        ...  DefaultReportFilter ...
     *     }
     *   ]
     * })
     *   .catch(error => { ... });
     * ```
     *
     * @hidden
     * @param {models.ILoadConfiguration} config
     * @param {boolean} phasedRender
     * @returns {Promise<void>}
     */ Embed.prototype.load = function(phasedRender) {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var path, headers, timeNow, response, response_4;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        if (!this.config.accessToken) {
                                            console.debug("Power BI SDK iframe is loaded but powerbi.embed is not called yet.");
                                            return [
                                                2 /*return*/ 
                                            ];
                                        }
                                        if (!this.iframeLoaded) {
                                            console.debug("Power BI SDK is trying to post /report/load before iframe is ready.");
                                            return [
                                                2 /*return*/ 
                                            ];
                                        }
                                        path = phasedRender && this.config.type === 'report' ? this.phasedLoadPath : this.loadPath;
                                        headers = {
                                            uid: this.config.uniqueId,
                                            sdkSessionId: this.service.getSdkSessionId(),
                                            bootstrapped: this.config.bootstrapped,
                                            sdkVersion: sdkConfig.default.version
                                        };
                                        if (!!((_a = this.eventHooks) === null || _a === void 0 ? void 0 : _a.accessTokenProvider)) headers.tokenProviderSupplied = true;
                                        timeNow = new Date();
                                        if (this.lastLoadRequest && (0, util_1.getTimeDiffInMilliseconds)(this.lastLoadRequest, timeNow) < 100) {
                                            console.debug("Power BI SDK sent more than two /report/load requests in the last 100ms interval.");
                                            return [
                                                2 /*return*/ 
                                            ];
                                        }
                                        this.lastLoadRequest = timeNow;
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post(path, this.config, headers, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_4 = _b.sent();
                                        throw response_4.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Removes one or more event handlers from the list of handlers.
     * If a reference to the existing handle function is specified, remove the specific handler.
     * If the handler is not specified, remove all handlers for the event name specified.
     *
     * ```javascript
     * report.off('pageChanged')
     *
     * or
     *
     * const logHandler = function (event) {
     *    console.log(event);
     * };
     *
     * report.off('pageChanged', logHandler);
     * ```
     *
     * @template T
     * @param {string} eventName
     * @param {IEventHandler<T>} [handler]
     */ Embed.prototype.off = function(eventName, handler) {
                        var _this = this;
                        var fakeEvent = {
                            name: eventName,
                            type: null,
                            id: null,
                            value: null
                        };
                        if (handler) {
                            (0, util_1.remove)(function(eventHandler) {
                                return eventHandler.test(fakeEvent) && eventHandler.handle === handler;
                            }, this.eventHandlers);
                            this.element.removeEventListener(eventName, handler);
                        } else {
                            var eventHandlersToRemove = this.eventHandlers.filter(function(eventHandler) {
                                return eventHandler.test(fakeEvent);
                            });
                            eventHandlersToRemove.forEach(function(eventHandlerToRemove) {
                                (0, util_1.remove)(function(eventHandler) {
                                    return eventHandler === eventHandlerToRemove;
                                }, _this.eventHandlers);
                                _this.element.removeEventListener(eventName, eventHandlerToRemove.handle);
                            });
                        }
                    };
                    /**
     * Adds an event handler for a specific event.
     *
     * ```javascript
     * report.on('pageChanged', (event) => {
     *   console.log('PageChanged: ', event.page.name);
     * });
     * ```
     *
     * @template T
     * @param {string} eventName
     * @param {service.IEventHandler<T>} handler
     */ Embed.prototype.on = function(eventName, handler) {
                        if (this.allowedEvents.indexOf(eventName) === -1) throw new Error("eventName must be one of ".concat(this.allowedEvents, ". You passed: ").concat(eventName));
                        this.eventHandlers.push({
                            test: function(event) {
                                return event.name === eventName;
                            },
                            handle: handler
                        });
                        this.element.addEventListener(eventName, handler);
                    };
                    /**
     * Reloads embed using existing configuration.
     * E.g. For reports this effectively clears all filters and makes the first page active which simulates resetting a report back to loaded state.
     *
     * ```javascript
     * report.reload();
     * ```
     */ Embed.prototype.reload = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.load()
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Set accessToken.
     *
     * @returns {Promise<void>}
     */ Embed.prototype.setAccessToken = function(accessToken) {
                        return __awaiter(this, void 0, void 0, function() {
                            var embedType, response, response_5;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!accessToken) throw new Error("Access token cannot be empty");
                                        embedType = this.config.type;
                                        embedType = embedType === 'create' || embedType === 'visual' || embedType === 'qna' || embedType === 'quickCreate' ? 'report' : embedType;
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post('/' + embedType + '/token', accessToken, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        this.config.accessToken = accessToken;
                                        this.element.setAttribute(Embed.accessTokenAttribute, accessToken);
                                        this.service.accessToken = accessToken;
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_5 = _a.sent();
                                        throw response_5.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets an access token from the first available location: config, attribute, global.
     *
     * @private
     * @param {string} globalAccessToken
     * @returns {string}
     * @hidden
     */ Embed.prototype.getAccessToken = function(globalAccessToken) {
                        var accessToken = this.config.accessToken || this.element.getAttribute(Embed.accessTokenAttribute) || globalAccessToken;
                        if (!accessToken) throw new Error("No access token was found for element. You must specify an access token directly on the element using attribute '".concat(Embed.accessTokenAttribute, "' or specify a global token at: powerbi.accessToken."));
                        return accessToken;
                    };
                    /**
     * Populate config for create and load
     *
     * @hidden
     * @param {IEmbedConfiguration}
     * @returns {void}
     */ Embed.prototype.populateConfig = function(config, isBootstrap) {
                        var _this = this;
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                        if (this.bootstrapConfig) {
                            this.config = (0, util_1.assign)({}, this.bootstrapConfig, config);
                            // reset bootstrapConfig because we do not want to merge it in re-embed scenario.
                            this.bootstrapConfig = null;
                        } else // Copy config - important for multiple iframe scenario.
                        // Otherwise, if a user uses the same config twice, same unique Id which will be used in different iframes.
                        this.config = (0, util_1.assign)({}, config);
                        this.config.embedUrl = this.getEmbedUrl(isBootstrap);
                        this.config.groupId = this.getGroupId();
                        this.addLocaleToEmbedUrl(config);
                        this.config.uniqueId = this.getUniqueId();
                        var extensions = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.extensions;
                        this.commands = (_c = extensions === null || extensions === void 0 ? void 0 : extensions.commands) !== null && _c !== void 0 ? _c : [];
                        this.groups = (_d = extensions === null || extensions === void 0 ? void 0 : extensions.groups) !== null && _d !== void 0 ? _d : [];
                        this.initialLayoutType = (_g = (_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.layoutType) !== null && _g !== void 0 ? _g : models.LayoutType.Master;
                        // Adding commands in extensions array to this.commands
                        var extensionsArray = (_j = (_h = this.config) === null || _h === void 0 ? void 0 : _h.settings) === null || _j === void 0 ? void 0 : _j.extensions;
                        if (Array.isArray(extensionsArray)) {
                            this.commands = [];
                            extensionsArray.map(function(extension) {
                                if (extension === null || extension === void 0 ? void 0 : extension.command) _this.commands.push(extension.command);
                            });
                        }
                        if (isBootstrap) {
                            // save current config in bootstrapConfig to be able to merge it on next call to powerbi.embed
                            this.bootstrapConfig = this.config;
                            this.bootstrapConfig.bootstrapped = true;
                        } else this.config.accessToken = this.getAccessToken(this.service.accessToken);
                        this.eventHooks = this.config.eventHooks;
                        this.validateEventHooks(this.eventHooks);
                        delete this.config.eventHooks;
                        this.configChanged(isBootstrap);
                    };
                    /**
     * Validate EventHooks
     *
     * @private
     * @param {models.EventHooks} eventHooks
     * @hidden
     */ Embed.prototype.validateEventHooks = function(eventHooks) {
                        if (!eventHooks) return;
                        for(var key in eventHooks){
                            if (eventHooks.hasOwnProperty(key) && typeof eventHooks[key] !== 'function') throw new Error(key + " must be a function");
                        }
                        var applicationContextProvider = eventHooks.applicationContextProvider;
                        if (!!applicationContextProvider) {
                            if (this.embedtype.toLowerCase() !== "report") throw new Error("applicationContextProvider is only supported in report embed");
                            this.config.embedUrl = (0, util_1.addParamToUrl)(this.config.embedUrl, "registerQueryCallback", "true");
                        }
                        var accessTokenProvider = eventHooks.accessTokenProvider;
                        if (!!accessTokenProvider) {
                            if ([
                                'create',
                                'quickcreate',
                                'report'
                            ].indexOf(this.embedtype.toLowerCase()) === -1 || this.config.tokenType !== models.TokenType.Aad) throw new Error("accessTokenProvider is only supported in report SaaS embed");
                        }
                    };
                    /**
     * Adds locale parameters to embedUrl
     *
     * @private
     * @param {IEmbedConfiguration | models.ICommonEmbedConfiguration} config
     * @hidden
     */ Embed.prototype.addLocaleToEmbedUrl = function(config) {
                        if (!config.settings) return;
                        var localeSettings = config.settings.localeSettings;
                        if (localeSettings && localeSettings.language) this.config.embedUrl = (0, util_1.addParamToUrl)(this.config.embedUrl, 'language', localeSettings.language);
                        if (localeSettings && localeSettings.formatLocale) this.config.embedUrl = (0, util_1.addParamToUrl)(this.config.embedUrl, 'formatLocale', localeSettings.formatLocale);
                    };
                    /**
     * Gets an embed url from the first available location: options, attribute.
     *
     * @private
     * @returns {string}
     * @hidden
     */ Embed.prototype.getEmbedUrl = function(isBootstrap) {
                        var embedUrl = this.config.embedUrl || this.element.getAttribute(Embed.embedUrlAttribute);
                        if (isBootstrap && !embedUrl) // Prepare flow, embed url was not provided, use hostname to build embed url.
                        embedUrl = this.getDefaultEmbedUrl(this.config.hostname);
                        if (typeof embedUrl !== 'string' || embedUrl.length === 0) throw new Error("Embed Url is required, but it was not found. You must provide an embed url either as part of embed configuration or as attribute '".concat(Embed.embedUrlAttribute, "'."));
                        return embedUrl;
                    };
                    /**
     * @hidden
     */ Embed.prototype.getDefaultEmbedUrl = function(hostname) {
                        if (!hostname) hostname = Embed.defaultEmbedHostName;
                        var endpoint = this.getDefaultEmbedUrlEndpoint();
                        // Trim spaces to fix user mistakes.
                        hostname = hostname.toLowerCase().trim();
                        if (hostname.indexOf("https://") === 0) return "".concat(hostname, "/").concat(endpoint);
                        return "https://".concat(hostname, "/").concat(endpoint);
                    };
                    /**
     * Gets a unique ID from the first available location: options, attribute.
     * If neither is provided generate a unique string.
     *
     * @private
     * @returns {string}
     * @hidden
     */ Embed.prototype.getUniqueId = function() {
                        return this.config.uniqueId || this.element.getAttribute(Embed.nameAttribute) || (0, util_1.createRandomString)();
                    };
                    /**
     * Gets the group ID from the first available location: options, embeddedUrl.
     *
     * @private
     * @returns {string}
     * @hidden
     */ Embed.prototype.getGroupId = function() {
                        return this.config.groupId || Embed.findGroupIdFromEmbedUrl(this.config.embedUrl);
                    };
                    /**
     * Requests the browser to render the component's iframe in fullscreen mode.
     */ Embed.prototype.fullscreen = function() {
                        var requestFullScreen = this.iframe.requestFullscreen || this.iframe.msRequestFullscreen || this.iframe.mozRequestFullScreen || this.iframe.webkitRequestFullscreen;
                        requestFullScreen.call(this.iframe);
                    };
                    /**
     * Requests the browser to exit fullscreen mode.
     */ Embed.prototype.exitFullscreen = function() {
                        if (!this.isFullscreen(this.iframe)) return;
                        var exitFullscreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;
                        exitFullscreen.call(document);
                    };
                    /**
     * Returns true if the iframe is rendered in fullscreen mode,
     * otherwise returns false.
     *
     * @private
     * @param {HTMLIFrameElement} iframe
     * @returns {boolean}
     * @hidden
     */ Embed.prototype.isFullscreen = function(iframe) {
                        var options = [
                            'fullscreenElement',
                            'webkitFullscreenElement',
                            'mozFullscreenScreenElement',
                            'msFullscreenElement'
                        ];
                        return options.some(function(option) {
                            return document[option] === iframe;
                        });
                    };
                    /**
     * Sets Iframe for embed
     *
     * @hidden
     */ Embed.prototype.setIframe = function(isLoad, phasedRender, isBootstrap) {
                        var _this = this;
                        if (!this.iframe) {
                            var iframeContent = document.createElement("iframe");
                            var embedUrl = this.config.uniqueId ? (0, util_1.addParamToUrl)(this.config.embedUrl, 'uid', this.config.uniqueId) : this.config.embedUrl;
                            if (!(0, util_1.validateEmbedUrl)(embedUrl)) throw new Error(errors_1.invalidEmbedUrlErrorMessage);
                            iframeContent.style.width = '100%';
                            iframeContent.style.height = '100%';
                            iframeContent.setAttribute("src", embedUrl);
                            iframeContent.setAttribute("scrolling", "no");
                            iframeContent.setAttribute("allowfullscreen", "true");
                            var node = this.element;
                            while(node.firstChild)node.removeChild(node.firstChild);
                            node.appendChild(iframeContent);
                            this.iframe = node.firstChild;
                        }
                        if (isLoad) {
                            if (!isBootstrap) {
                                // Validate config if it's not a bootstrap case.
                                var errors = this.validate(this.config);
                                if (errors) throw errors;
                            }
                            this.iframe.addEventListener('load', function() {
                                _this.iframeLoaded = true;
                                _this.load(phasedRender);
                            }, false);
                            if (this.service.getNumberOfComponents() <= Embed.maxFrontLoadTimes) {
                                this.frontLoadHandler = function() {
                                    _this.frontLoadSendConfig(_this.config);
                                };
                                // 'ready' event is fired by the embedded element (not by the iframe)
                                this.element.addEventListener('ready', this.frontLoadHandler, false);
                            }
                        } else this.iframe.addEventListener('load', function() {
                            return _this.create();
                        }, false);
                    };
                    /**
     * Set the component title for accessibility. In case of iframes, this method will change the iframe title.
     */ Embed.prototype.setComponentTitle = function(title) {
                        if (!this.iframe) return;
                        if (title == null) this.iframe.removeAttribute("title");
                        else this.iframe.setAttribute("title", title);
                    };
                    /**
     * Sets element's tabindex attribute
     */ Embed.prototype.setComponentTabIndex = function(tabIndex) {
                        if (!this.element) return;
                        this.element.setAttribute("tabindex", tabIndex == null ? "0" : tabIndex.toString());
                    };
                    /**
     * Removes element's tabindex attribute
     */ Embed.prototype.removeComponentTabIndex = function(_tabIndex) {
                        if (!this.element) return;
                        this.element.removeAttribute("tabindex");
                    };
                    /**
     * Adds the ability to get groupId from url.
     * By extracting the ID we can ensure that the ID is always explicitly provided as part of the load configuration.
     *
     * @hidden
     * @static
     * @param {string} url
     * @returns {string}
     */ Embed.findGroupIdFromEmbedUrl = function(url) {
                        var groupIdRegEx = /groupId="?([^&]+)"?/;
                        var groupIdMatch = url.match(groupIdRegEx);
                        var groupId;
                        if (groupIdMatch) groupId = groupIdMatch[1];
                        return groupId;
                    };
                    /**
     * Sends the config for front load calls, after 'ready' message is received from the iframe
     *
     * @hidden
     */ Embed.prototype.frontLoadSendConfig = function(config) {
                        return __awaiter(this, void 0, void 0, function() {
                            var errors, response, response_6;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!config.accessToken) return [
                                            2 /*return*/ 
                                        ];
                                        errors = this.validate(config);
                                        if (errors) throw errors;
                                        // contentWindow must be initialized
                                        if (this.iframe.contentWindow == null) return [
                                            2 /*return*/ 
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/frontload/config", config, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_6 = _a.sent();
                                        throw response_6.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /** @hidden */ Embed.allowedEvents = [
                        "loaded",
                        "saved",
                        "rendered",
                        "saveAsTriggered",
                        "error",
                        "dataSelected",
                        "buttonClicked",
                        "info"
                    ];
                    /** @hidden */ Embed.accessTokenAttribute = 'powerbi-access-token';
                    /** @hidden */ Embed.embedUrlAttribute = 'powerbi-embed-url';
                    /** @hidden */ Embed.nameAttribute = 'powerbi-name';
                    /** @hidden */ Embed.typeAttribute = 'powerbi-type';
                    /** @hidden */ Embed.defaultEmbedHostName = "https://app.powerbi.com";
                    /** @hidden */ Embed.maxFrontLoadTimes = 2;
                    return Embed;
                }();
                exports.Embed = Embed;
            /***/ },
            /***/ "./src/errors.ts": /*!***********************!*\
  !*** ./src/errors.ts ***!
  \***********************/ /***/ (__unused_webpack_module, exports)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.invalidEmbedUrlErrorMessage = exports.EmbedUrlNotSupported = exports.APINotSupportedForRDLError = void 0;
                exports.APINotSupportedForRDLError = "This API is currently not supported for RDL reports";
                exports.EmbedUrlNotSupported = "Embed URL is invalid for this scenario. Please use Power BI REST APIs to get the valid URL";
                exports.invalidEmbedUrlErrorMessage = "Invalid embed URL detected. Either URL hostname or protocol are invalid. Please use Power BI REST APIs to get the valid URL";
            /***/ },
            /***/ "./src/factories.ts": /*!**************************!*\
  !*** ./src/factories.ts ***!
  \**************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.routerFactory = exports.wpmpFactory = exports.hpmFactory = void 0;
                /**
 * TODO: Need to find better place for these factory functions or refactor how we handle dependency injection
 */ var window_post_message_proxy_1 = __webpack_require__(/*! window-post-message-proxy */ "./node_modules/window-post-message-proxy/dist/windowPostMessageProxy.js");
                var http_post_message_1 = __webpack_require__(/*! http-post-message */ "./node_modules/http-post-message/dist/httpPostMessage.js");
                var powerbi_router_1 = __webpack_require__(/*! powerbi-router */ "./node_modules/powerbi-router/dist/router.js");
                var config_1 = __webpack_require__(/*! ./config */ "./src/config.ts");
                var hpmFactory = function(wpmp, defaultTargetWindow, sdkVersion, sdkType, sdkWrapperVersion) {
                    if (sdkVersion === void 0) sdkVersion = config_1.default.version;
                    if (sdkType === void 0) sdkType = config_1.default.type;
                    return new http_post_message_1.HttpPostMessage(wpmp, {
                        'x-sdk-type': sdkType,
                        'x-sdk-version': sdkVersion,
                        'x-sdk-wrapper-version': sdkWrapperVersion
                    }, defaultTargetWindow);
                };
                exports.hpmFactory = hpmFactory;
                var wpmpFactory = function(name, logMessages, eventSourceOverrideWindow) {
                    return new window_post_message_proxy_1.WindowPostMessageProxy({
                        processTrackingProperties: {
                            addTrackingProperties: http_post_message_1.HttpPostMessage.addTrackingProperties,
                            getTrackingProperties: http_post_message_1.HttpPostMessage.getTrackingProperties
                        },
                        isErrorMessage: http_post_message_1.HttpPostMessage.isErrorMessage,
                        suppressWarnings: true,
                        name: name,
                        logMessages: logMessages,
                        eventSourceOverrideWindow: eventSourceOverrideWindow
                    });
                };
                exports.wpmpFactory = wpmpFactory;
                var routerFactory = function(wpmp) {
                    return new powerbi_router_1.Router(wpmp);
                };
                exports.routerFactory = routerFactory;
            /***/ },
            /***/ "./src/page.ts": /*!*********************!*\
  !*** ./src/page.ts ***!
  \*********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Page = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var visualDescriptor_1 = __webpack_require__(/*! ./visualDescriptor */ "./src/visualDescriptor.ts");
                var util_1 = __webpack_require__(/*! ./util */ "./src/util.ts");
                var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.ts");
                /**
 * A Power BI report page
 *
 * @export
 * @class Page
 * @implements {IPageNode}
 * @implements {IFilterable}
 */ var Page = /** @class */ function() {
                    /**
     * Creates an instance of a Power BI report page.
     *
     * @param {IReportNode} report
     * @param {string} name
     * @param {string} [displayName]
     * @param {boolean} [isActivePage]
     * @param {SectionVisibility} [visibility]
     * @hidden
     */ function Page(report, name, displayName, isActivePage, visibility, defaultSize, defaultDisplayOption, mobileSize, background, wallpaper) {
                        this.report = report;
                        this.name = name;
                        this.displayName = displayName;
                        this.isActive = isActivePage;
                        this.visibility = visibility;
                        this.defaultSize = defaultSize;
                        this.mobileSize = mobileSize;
                        this.defaultDisplayOption = defaultDisplayOption;
                        this.background = background;
                        this.wallpaper = wallpaper;
                    }
                    /**
     * Get insights for report page
     *
     * ```javascript
     * page.getSmartNarrativeInsights();
     * ```
     *
     * @returns {Promise<ISmartNarratives>}
     */ Page.prototype.getSmartNarrativeInsights = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.report.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.get("/report/pages/".concat(this.name, "/smartNarrativeInsights"), {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_1 = _a.sent();
                                        throw response_1.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets all page level filters within the report.
     *
     * ```javascript
     * page.getFilters()
     *  .then(filters => { ... });
     * ```
     *
     * @returns {(Promise<IFilter[]>)}
     */ Page.prototype.getFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_2;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.get("/report/pages/".concat(this.name, "/filters"), {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_2 = _a.sent();
                                        throw response_2.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Update the filters for the current page according to the operation: Add, replace all, replace by target or remove.
     *
     * ```javascript
     * page.updateFilters(FiltersOperations.Add, filters)
     *   .catch(errors => { ... });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.updateFilters = function(operation, filters) {
                        return __awaiter(this, void 0, void 0, function() {
                            var updateFiltersRequest, response_3;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        updateFiltersRequest = {
                                            filtersOperation: operation,
                                            filters: filters
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.post("/report/pages/".concat(this.name, "/filters"), updateFiltersRequest, {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_3 = _a.sent();
                                        throw response_3.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Removes all filters from this page of the report.
     *
     * ```javascript
     * page.removeFilters();
     * ```
     *
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.removeFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.updateFilters(powerbi_models_1.FiltersOperations.RemoveAll)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Sets all filters on the current page.
     *
     * ```javascript
     * page.setFilters(filters)
     *   .catch(errors => { ... });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.setFilters = function(filters) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response_4;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.put("/report/pages/".concat(this.name, "/filters"), filters, {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 2:
                                        response_4 = _a.sent();
                                        throw response_4.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Delete the page from the report
     *
     * ```javascript
     * // Delete the page from the report
     * page.delete();
     * ```
     *
     * @returns {Promise<void>}
     */ Page.prototype.delete = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_5;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.delete("/report/pages/".concat(this.name), {}, {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_5 = _a.sent();
                                        throw response_5.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Makes the current page the active page of the report.
     *
     * ```javascript
     * page.setActive();
     * ```
     *
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.setActive = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var page, response_6;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        page = {
                                            name: this.name,
                                            displayName: null,
                                            isActive: true
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.put('/report/pages/active', page, {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_6 = _a.sent();
                                        throw response_6.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Set displayName to the current page.
     *
     * ```javascript
     * page.setName(displayName);
     * ```
     *
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.setDisplayName = function(displayName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var page, response_7;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        page = {
                                            name: this.name,
                                            displayName: displayName
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.put("/report/pages/".concat(this.name, "/name"), page, {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_7 = _a.sent();
                                        throw response_7.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets all the visuals on the page.
     *
     * ```javascript
     * page.getVisuals()
     *   .then(visuals => { ... });
     * ```
     *
     * @returns {Promise<VisualDescriptor[]>}
     */ Page.prototype.getVisuals = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_8;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.report.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.get("/report/pages/".concat(this.name, "/visuals"), {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body.map(function(visual) {
                                                return new visualDescriptor_1.VisualDescriptor(_this, visual.name, visual.title, visual.type, visual.layout);
                                            })
                                        ];
                                    case 3:
                                        response_8 = _a.sent();
                                        throw response_8.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets a visual by name on the page.
     *
     * ```javascript
     * page.getVisualByName(visualName: string)
     *  .then(visual => {
     *      ...
     *  });
     * ```
     *
     * @param {string} visualName
     * @returns {Promise<VisualDescriptor>}
     */ Page.prototype.getVisualByName = function(visualName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, visual, response_9;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.report.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.get("/report/pages/".concat(this.name, "/visuals"), {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        visual = response.body.find(function(v) {
                                            return v.name === visualName;
                                        });
                                        if (!visual) return [
                                            2 /*return*/ ,
                                            Promise.reject(powerbi_models_1.CommonErrorCodes.NotFound)
                                        ];
                                        return [
                                            2 /*return*/ ,
                                            new visualDescriptor_1.VisualDescriptor(this, visual.name, visual.title, visual.type, visual.layout)
                                        ];
                                    case 3:
                                        response_9 = _a.sent();
                                        throw response_9.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Updates the display state of a visual in a page.
     *
     * ```javascript
     * page.setVisualDisplayState(visualName, displayState)
     *   .catch(error => { ... });
     * ```
     *
     * @param {string} visualName
     * @param {VisualContainerDisplayMode} displayState
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.setVisualDisplayState = function(visualName, displayState) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pageName, report;
                            return __generator(this, function(_a) {
                                pageName = this.name;
                                report = this.report;
                                return [
                                    2 /*return*/ ,
                                    report.setVisualDisplayState(pageName, visualName, displayState)
                                ];
                            });
                        });
                    };
                    /**
     * Updates the position of a visual in a page.
     *
     * ```javascript
     * page.moveVisual(visualName, x, y, z)
     *   .catch(error => { ... });
     * ```
     *
     * @param {string} visualName
     * @param {number} x
     * @param {number} y
     * @param {number} z
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.moveVisual = function(visualName, x, y, z) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pageName, report;
                            return __generator(this, function(_a) {
                                pageName = this.name;
                                report = this.report;
                                return [
                                    2 /*return*/ ,
                                    report.moveVisual(pageName, visualName, x, y, z)
                                ];
                            });
                        });
                    };
                    /**
     * Resize a visual in a page.
     *
     * ```javascript
     * page.resizeVisual(visualName, width, height)
     *   .catch(error => { ... });
     * ```
     *
     * @param {string} visualName
     * @param {number} width
     * @param {number} height
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.resizeVisual = function(visualName, width, height) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pageName, report;
                            return __generator(this, function(_a) {
                                pageName = this.name;
                                report = this.report;
                                return [
                                    2 /*return*/ ,
                                    report.resizeVisual(pageName, visualName, width, height)
                                ];
                            });
                        });
                    };
                    /**
     * Updates the size of active page.
     *
     * ```javascript
     * page.resizePage(pageSizeType, width, height)
     *   .catch(error => { ... });
     * ```
     *
     * @param {PageSizeType} pageSizeType
     * @param {number} width
     * @param {number} height
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Page.prototype.resizePage = function(pageSizeType, width, height) {
                        return __awaiter(this, void 0, void 0, function() {
                            var report;
                            return __generator(this, function(_a) {
                                if (!this.isActive) return [
                                    2 /*return*/ ,
                                    Promise.reject('Cannot resize the page. Only the active page can be resized')
                                ];
                                report = this.report;
                                return [
                                    2 /*return*/ ,
                                    report.resizeActivePage(pageSizeType, width, height)
                                ];
                            });
                        });
                    };
                    /**
     * Gets the list of slicer visuals on the page.
     *
     * ```javascript
     * page.getSlicers()
     *  .then(slicers => {
     *      ...
     *  });
     * ```
     *
     * @returns {Promise<IVisual[]>}
     */ Page.prototype.getSlicers = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_10;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.report.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.get("/report/pages/".concat(this.name, "/visuals"), {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body.filter(function(visual) {
                                                return visual.type === 'slicer';
                                            }).map(function(visual) {
                                                return new visualDescriptor_1.VisualDescriptor(_this, visual.name, visual.title, visual.type, visual.layout);
                                            })
                                        ];
                                    case 3:
                                        response_10 = _a.sent();
                                        throw response_10.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Checks if page has layout.
     *
     * ```javascript
     * page.hasLayout(layoutType)
     *  .then(hasLayout: boolean => { ... });
     * ```
     *
     * @returns {(Promise<boolean>)}
     */ Page.prototype.hasLayout = function(layoutType) {
                        return __awaiter(this, void 0, void 0, function() {
                            var layoutTypeEnum, response, response_11;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.report.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        layoutTypeEnum = powerbi_models_1.LayoutType[layoutType];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.report.service.hpm.get("/report/pages/".concat(this.name, "/layoutTypes/").concat(layoutTypeEnum), {
                                                uid: this.report.config.uniqueId
                                            }, this.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_11 = _a.sent();
                                        throw response_11.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return Page;
                }();
                exports.Page = Page;
            /***/ },
            /***/ "./src/qna.ts": /*!********************!*\
  !*** ./src/qna.ts ***!
  \********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Qna = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
                /**
 * The Power BI Q&A embed component
 *
 * @export
 * @class Qna
 * @extends {Embed}
 */ var Qna = /** @class */ function(_super) {
                    __extends(Qna, _super);
                    /**
     * @hidden
     */ function Qna(service, element, config, phasedRender, isBootstrap) {
                        var _this = _super.call(this, service, element, config, /* iframe */ undefined, phasedRender, isBootstrap) || this;
                        _this.loadPath = "/qna/load";
                        _this.phasedLoadPath = "/qna/prepare";
                        Array.prototype.push.apply(_this.allowedEvents, Qna.allowedEvents);
                        return _this;
                    }
                    /**
     * The ID of the Q&A embed component
     *
     * @returns {string}
     */ Qna.prototype.getId = function() {
                        return null;
                    };
                    /**
     * Change the question of the Q&A embed component
     *
     * @param {string} question - question which will render Q&A data
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Qna.prototype.setQuestion = function(question) {
                        return __awaiter(this, void 0, void 0, function() {
                            var qnaData, response_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        qnaData = {
                                            question: question
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post('/qna/interpret', qnaData, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_1 = _a.sent();
                                        throw response_1.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Handle config changes.
     *
     * @returns {void}
     */ Qna.prototype.configChanged = function(_isBootstrap) {
                    // Nothing to do in Q&A embed.
                    };
                    /**
     * @hidden
     * @returns {string}
     */ Qna.prototype.getDefaultEmbedUrlEndpoint = function() {
                        return "qnaEmbed";
                    };
                    /**
     * Validate load configuration.
     */ Qna.prototype.validate = function(config) {
                        return (0, powerbi_models_1.validateLoadQnaConfiguration)(config);
                    };
                    /** @hidden */ Qna.type = "Qna";
                    /** @hidden */ Qna.allowedEvents = [
                        "loaded",
                        "visualRendered"
                    ];
                    return Qna;
                }(embed_1.Embed);
                exports.Qna = Qna;
            /***/ },
            /***/ "./src/quickCreate.ts": /*!****************************!*\
  !*** ./src/quickCreate.ts ***!
  \****************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.QuickCreate = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
                /**
 * A Power BI Quick Create component
 *
 * @export
 * @class QuickCreate
 * @extends {Embed}
 */ var QuickCreate = /** @class */ function(_super) {
                    __extends(QuickCreate, _super);
                    /*
     * @hidden
     */ function QuickCreate(service, element, config, phasedRender, isBootstrap) {
                        var _this = _super.call(this, service, element, config, /* iframe */ undefined, phasedRender, isBootstrap) || this;
                        service.router.post("/reports/".concat(_this.config.uniqueId, "/eventHooks/:eventName"), function(req, _res) {
                            return __awaiter(_this, void 0, void 0, function() {
                                var _a;
                                var _b;
                                return __generator(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            _a = req.params.eventName;
                                            switch(_a){
                                                case "newAccessToken":
                                                    return [
                                                        3 /*break*/ ,
                                                        1
                                                    ];
                                            }
                                            return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 1:
                                            req.body = req.body || {};
                                            req.body.report = this;
                                            return [
                                                4 /*yield*/ ,
                                                service.invokeSDKHook((_b = this.eventHooks) === null || _b === void 0 ? void 0 : _b.accessTokenProvider, req, _res)
                                            ];
                                        case 2:
                                            _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        return _this;
                    }
                    /**
     * Override the getId abstract function
     * QuickCreate does not need any ID
     *
     * @returns {string}
     */ QuickCreate.prototype.getId = function() {
                        return null;
                    };
                    /**
     * Validate create report configuration.
     */ QuickCreate.prototype.validate = function(config) {
                        return (0, powerbi_models_1.validateQuickCreate)(config);
                    };
                    /**
     * Handle config changes.
     *
     * @hidden
     * @returns {void}
     */ QuickCreate.prototype.configChanged = function(isBootstrap) {
                        if (isBootstrap) return;
                        this.createConfig = this.config;
                    };
                    /**
     * @hidden
     * @returns {string}
     */ QuickCreate.prototype.getDefaultEmbedUrlEndpoint = function() {
                        return "quickCreate";
                    };
                    /**
     * Sends quickCreate configuration data.
     *
     * ```javascript
     * quickCreate({
     *   accessToken: 'eyJ0eXA ... TaE2rTSbmg',
     *   datasetCreateConfig: {}})
     * ```
     *
     * @hidden
     * @param {IQuickCreateConfiguration} createConfig
     * @returns {Promise<void>}
     */ QuickCreate.prototype.create = function() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function() {
                            var errors, headers, response, response_1;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        errors = (0, powerbi_models_1.validateQuickCreate)(this.createConfig);
                                        if (errors) throw errors;
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        headers = {
                                            uid: this.config.uniqueId,
                                            sdkSessionId: this.service.getSdkSessionId()
                                        };
                                        if (!!((_a = this.eventHooks) === null || _a === void 0 ? void 0 : _a.accessTokenProvider)) headers.tokenProviderSupplied = true;
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/quickcreate", this.createConfig, headers, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_1 = _b.sent();
                                        throw response_1.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return QuickCreate;
                }(embed_1.Embed);
                exports.QuickCreate = QuickCreate;
            /***/ },
            /***/ "./src/report.ts": /*!***********************!*\
  !*** ./src/report.ts ***!
  \***********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Report = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
                var util_1 = __webpack_require__(/*! ./util */ "./src/util.ts");
                var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.ts");
                var page_1 = __webpack_require__(/*! ./page */ "./src/page.ts");
                var bookmarksManager_1 = __webpack_require__(/*! ./bookmarksManager */ "./src/bookmarksManager.ts");
                /**
 * The Power BI Report embed component
 *
 * @export
 * @class Report
 * @extends {Embed}
 * @implements {IReportNode}
 * @implements {IFilterable}
 */ var Report = /** @class */ function(_super) {
                    __extends(Report, _super);
                    /**
     * Creates an instance of a Power BI Report.
     *
     * @param {Service} service
     * @param {HTMLElement} element
     * @param {IEmbedConfiguration} config
     * @hidden
     */ function Report(service, element, baseConfig, phasedRender, isBootstrap, iframe) {
                        var _this = this;
                        var config = baseConfig;
                        _this = _super.call(this, service, element, config, iframe, phasedRender, isBootstrap) || this;
                        _this.loadPath = "/report/load";
                        _this.phasedLoadPath = "/report/prepare";
                        Array.prototype.push.apply(_this.allowedEvents, Report.allowedEvents);
                        _this.bookmarksManager = new bookmarksManager_1.BookmarksManager(service, config, _this.iframe);
                        service.router.post("/reports/".concat(_this.config.uniqueId, "/eventHooks/:eventName"), function(req, _res) {
                            return __awaiter(_this, void 0, void 0, function() {
                                var _a;
                                var _b, _c;
                                return __generator(this, function(_d) {
                                    switch(_d.label){
                                        case 0:
                                            _a = req.params.eventName;
                                            switch(_a){
                                                case "preQuery":
                                                    return [
                                                        3 /*break*/ ,
                                                        1
                                                    ];
                                                case "newAccessToken":
                                                    return [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                            }
                                            return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 1:
                                            req.body = req.body || {};
                                            req.body.report = this;
                                            return [
                                                4 /*yield*/ ,
                                                service.invokeSDKHook((_b = this.eventHooks) === null || _b === void 0 ? void 0 : _b.applicationContextProvider, req, _res)
                                            ];
                                        case 2:
                                            _d.sent();
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 3:
                                            req.body = req.body || {};
                                            req.body.report = this;
                                            return [
                                                4 /*yield*/ ,
                                                service.invokeSDKHook((_c = this.eventHooks) === null || _c === void 0 ? void 0 : _c.accessTokenProvider, req, _res)
                                            ];
                                        case 4:
                                            _d.sent();
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 6:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        return _this;
                    }
                    /**
     * Adds backwards compatibility for the previous load configuration, which used the reportId query parameter to specify the report ID
     * (e.g. http://embedded.powerbi.com/appTokenReportEmbed?reportId=854846ed-2106-4dc2-bc58-eb77533bf2f1).
     *
     * By extracting the ID we can ensure that the ID is always explicitly provided as part of the load configuration.
     *
     * @hidden
     * @static
     * @param {string} url
     * @returns {string}
     */ Report.findIdFromEmbedUrl = function(url) {
                        var reportIdRegEx = /reportId="?([^&]+)"?/;
                        var reportIdMatch = url.match(reportIdRegEx);
                        var reportId;
                        if (reportIdMatch) reportId = reportIdMatch[1];
                        return reportId;
                    };
                    /**
     * Render a preloaded report, using phased embedding API
     *
     * ```javascript
     * // Load report
     * var report = powerbi.load(element, config);
     *
     * ...
     *
     * // Render report
     * report.render()
     * ```
     *
     * @returns {Promise<void>}
     */ Report.prototype.render = function(config) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/render", config, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_1 = _a.sent();
                                        throw response_1.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Add an empty page to the report
     *
     * ```javascript
     * // Add a page to the report with "Sales" as the page display name
     * report.addPage("Sales");
     * ```
     *
     * @returns {Promise<Page>}
     */ Report.prototype.addPage = function(displayName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var request, response, page, response_2;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        request = {
                                            displayName: displayName
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/addPage", request, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        page = response.body;
                                        return [
                                            2 /*return*/ ,
                                            new page_1.Page(this, page.name, page.displayName, page.isActive, page.visibility, page.defaultSize, page.defaultDisplayOption)
                                        ];
                                    case 3:
                                        response_2 = _a.sent();
                                        throw response_2.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Delete a page from a report
     *
     * ```javascript
     * // Delete a page from a report by pageName (PageName is different than the display name and can be acquired from the getPages API)
     * report.deletePage("ReportSection145");
     * ```
     *
     * @returns {Promise<void>}
     */ Report.prototype.deletePage = function(pageName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_3;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.delete("/report/pages/".concat(pageName), {}, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_3 = _a.sent();
                                        throw response_3.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Rename a page from a report
     *
     * ```javascript
     * // Rename a page from a report by changing displayName (pageName is different from the display name and can be acquired from the getPages API)
     * report.renamePage("ReportSection145", "Sales");
     * ```
     *
     * @returns {Promise<void>}
     */ Report.prototype.renamePage = function(pageName, displayName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var page, response, response_4;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        page = {
                                            name: pageName,
                                            displayName: displayName
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.put("/report/pages/".concat(pageName, "/name"), page, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_4 = _a.sent();
                                        throw response_4.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets filters that are applied at the report level.
     *
     * ```javascript
     * // Get filters applied at report level
     * report.getFilters()
     *   .then(filters => {
     *     ...
     *   });
     * ```
     *
     * @returns {Promise<IFilter[]>}
     */ Report.prototype.getFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_5;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/report/filters", {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_5 = _a.sent();
                                        throw response_5.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Update the filters at the report level according to the operation: Add, replace all, replace by target or remove.
     *
     * ```javascript
     * report.updateFilters(FiltersOperations.Add, filters)
     *   .catch(errors => { ... });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.updateFilters = function(operation, filters) {
                        return __awaiter(this, void 0, void 0, function() {
                            var updateFiltersRequest, response_6;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        updateFiltersRequest = {
                                            filtersOperation: operation,
                                            filters: filters
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/filters", updateFiltersRequest, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_6 = _a.sent();
                                        throw response_6.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Removes all filters at the report level.
     *
     * ```javascript
     * report.removeFilters();
     * ```
     *
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.removeFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                    2 /*return*/ ,
                                    Promise.reject(errors_1.APINotSupportedForRDLError)
                                ];
                                return [
                                    2 /*return*/ ,
                                    this.updateFilters(powerbi_models_1.FiltersOperations.RemoveAll)
                                ];
                            });
                        });
                    };
                    /**
     * Sets filters at the report level.
     *
     * ```javascript
     * const filters: [
     *    ...
     * ];
     *
     * report.setFilters(filters)
     *  .catch(errors => {
     *    ...
     *  });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.setFilters = function(filters) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response_7;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.put("/report/filters", filters, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_7 = _a.sent();
                                        throw response_7.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets the report ID from the first available location: options, attribute, embed url.
     *
     * @returns {string}
     */ Report.prototype.getId = function() {
                        var config = this.config;
                        var reportId = config.id || this.element.getAttribute(Report.reportIdAttribute) || Report.findIdFromEmbedUrl(config.embedUrl);
                        if (typeof reportId !== 'string' || reportId.length === 0) throw new Error("Report id is required, but it was not found. You must provide an id either as part of embed configuration or as attribute '".concat(Report.reportIdAttribute, "'."));
                        return reportId;
                    };
                    /**
     * Gets the list of pages within the report.
     *
     * ```javascript
     * report.getPages()
     *  .then(pages => {
     *      ...
     *  });
     * ```
     *
     * @returns {Promise<Page[]>}
     */ Report.prototype.getPages = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_8;
                            var _this = this;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get('/report/pages', {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body.map(function(page) {
                                                return new page_1.Page(_this, page.name, page.displayName, page.isActive, page.visibility, page.defaultSize, page.defaultDisplayOption, page.mobileSize, page.background, page.wallpaper);
                                            })
                                        ];
                                    case 3:
                                        response_8 = _a.sent();
                                        throw response_8.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets a report page by its name.
     *
     * ```javascript
     * report.getPageByName(pageName)
     *  .then(page => {
     *      ...
     *  });
     * ```
     *
     * @param {string} pageName
     * @returns {Promise<Page>}
     */ Report.prototype.getPageByName = function(pageName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, page, response_9;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/report/pages", {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        page = response.body.find(function(p) {
                                            return p.name === pageName;
                                        });
                                        if (!page) return [
                                            2 /*return*/ ,
                                            Promise.reject(powerbi_models_1.CommonErrorCodes.NotFound)
                                        ];
                                        return [
                                            2 /*return*/ ,
                                            new page_1.Page(this, page.name, page.displayName, page.isActive, page.visibility, page.defaultSize, page.defaultDisplayOption, page.mobileSize, page.background, page.wallpaper)
                                        ];
                                    case 3:
                                        response_9 = _a.sent();
                                        throw response_9.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets the active report page.
     *
     * ```javascript
     * report.getActivePage()
     *  .then(activePage => {
     *      ...
     *  });
     * ```
     *
     * @returns {Promise<Page>}
     */ Report.prototype.getActivePage = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, activePage, response_10;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get('/report/pages', {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        activePage = response.body.find(function(page) {
                                            return page.isActive;
                                        });
                                        return [
                                            2 /*return*/ ,
                                            new page_1.Page(this, activePage.name, activePage.displayName, activePage.isActive, activePage.visibility, activePage.defaultSize, activePage.defaultDisplayOption, activePage.mobileSize, activePage.background, activePage.wallpaper)
                                        ];
                                    case 3:
                                        response_10 = _a.sent();
                                        throw response_10.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Creates an instance of a Page.
     *
     * Normally you would get Page objects by calling `report.getPages()`, but in the case
     * that the page name is known and you want to perform an action on a page without having to retrieve it
     * you can create it directly.
     *
     * Note: Because you are creating the page manually there is no guarantee that the page actually exists in the report, and subsequent requests could fail.
     *
     * @param {string} name
     * @param {string} [displayName]
     * @param {boolean} [isActive]
     * @returns {Page}
     * @hidden
     */ Report.prototype.page = function(name, displayName, isActive, visibility) {
                        return new page_1.Page(this, name, displayName, isActive, visibility);
                    };
                    /**
     * Prints the active page of the report by invoking `window.print()` on the embed iframe component.
     */ Report.prototype.print = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_11;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post('/report/print', null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_11 = _a.sent();
                                        throw response_11.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Sets the active page of the report.
     *
     * ```javascript
     * report.setPage("page2")
     *  .catch(error => { ... });
     * ```
     *
     * @param {string} pageName
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.setPage = function(pageName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var page, response_12;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        page = {
                                            name: pageName,
                                            displayName: null,
                                            isActive: true
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.put('/report/pages/active', page, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_12 = _a.sent();
                                        throw response_12.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Updates visibility settings for the filter pane and the page navigation pane.
     *
     * ```javascript
     * const newSettings = {
     *   panes: {
     *     filters: {
     *       visible: false
     *     }
     *   }
     * };
     *
     * report.updateSettings(newSettings)
     *   .catch(error => { ... });
     * ```
     *
     * @param {ISettings} settings
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.updateSettings = function(settings) {
                        var _a, _b;
                        return __awaiter(this, void 0, void 0, function() {
                            var response, extension, extensionsArray, response_13;
                            var _this = this;
                            return __generator(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl) && settings.customLayout != null) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.patch('/report/settings', settings, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _c.sent();
                                        extension = settings === null || settings === void 0 ? void 0 : settings.extensions;
                                        this.commands = (_a = extension === null || extension === void 0 ? void 0 : extension.commands) !== null && _a !== void 0 ? _a : this.commands;
                                        this.groups = (_b = extension === null || extension === void 0 ? void 0 : extension.groups) !== null && _b !== void 0 ? _b : this.groups;
                                        extensionsArray = settings === null || settings === void 0 ? void 0 : settings.extensions;
                                        if (Array.isArray(extensionsArray)) {
                                            this.commands = [];
                                            extensionsArray.map(function(extensionElement) {
                                                if (extensionElement === null || extensionElement === void 0 ? void 0 : extensionElement.command) _this.commands.push(extensionElement.command);
                                            });
                                        }
                                        return [
                                            2 /*return*/ ,
                                            response
                                        ];
                                    case 3:
                                        response_13 = _c.sent();
                                        throw response_13.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Validate load configuration.
     *
     * @hidden
     */ Report.prototype.validate = function(config) {
                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return (0, powerbi_models_1.validatePaginatedReportLoad)(config);
                        return (0, powerbi_models_1.validateReportLoad)(config);
                    };
                    /**
     * Handle config changes.
     *
     * @returns {void}
     */ Report.prototype.configChanged = function(isBootstrap) {
                        var config = this.config;
                        if (this.isMobileSettings(config.settings)) config.embedUrl = (0, util_1.addParamToUrl)(config.embedUrl, "isMobile", "true");
                        // Calculate settings from HTML element attributes if available.
                        var filterPaneEnabledAttribute = this.element.getAttribute(Report.filterPaneEnabledAttribute);
                        var navContentPaneEnabledAttribute = this.element.getAttribute(Report.navContentPaneEnabledAttribute);
                        var elementAttrSettings = {
                            filterPaneEnabled: filterPaneEnabledAttribute == null ? undefined : filterPaneEnabledAttribute !== "false",
                            navContentPaneEnabled: navContentPaneEnabledAttribute == null ? undefined : navContentPaneEnabledAttribute !== "false"
                        };
                        // Set the settings back into the config.
                        this.config.settings = (0, util_1.assign)({}, elementAttrSettings, config.settings);
                        if (isBootstrap) return;
                        config.id = this.getId();
                    };
                    /**
     * @hidden
     * @returns {string}
     */ Report.prototype.getDefaultEmbedUrlEndpoint = function() {
                        return "reportEmbed";
                    };
                    /**
     * Switch Report view mode.
     *
     * @returns {Promise<void>}
     */ Report.prototype.switchMode = function(viewMode) {
                        return __awaiter(this, void 0, void 0, function() {
                            var newMode, url, response, response_14;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (typeof viewMode === "string") newMode = viewMode;
                                        else newMode = this.viewModeToString(viewMode);
                                        url = '/report/switchMode/' + newMode;
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post(url, null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_14 = _a.sent();
                                        throw response_14.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Refreshes data sources for the report.
     *
     * ```javascript
     * report.refresh();
     * ```
     */ Report.prototype.refresh = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_15;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post('/report/refresh', null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_15 = _a.sent();
                                        throw response_15.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * checks if the report is saved.
     *
     * ```javascript
     * report.isSaved()
     * ```
     *
     * @returns {Promise<boolean>}
     */ Report.prototype.isSaved = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            (0, util_1.isSavedInternal)(this.service.hpm, this.config.uniqueId, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Apply a theme to the report
     *
     * ```javascript
     * report.applyTheme(theme);
     * ```
     */ Report.prototype.applyTheme = function(theme) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.applyThemeInternal(theme)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Reset and apply the default theme of the report
     *
     * ```javascript
     * report.resetTheme();
     * ```
     */ Report.prototype.resetTheme = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this.applyThemeInternal({})
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * get the theme of the report
     *
     * ```javascript
     * report.getTheme();
     * ```
     */ Report.prototype.getTheme = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_16;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/report/theme", {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_16 = _a.sent();
                                        throw response_16.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Reset user's filters, slicers, and other data view changes to the default state of the report
     *
     * ```javascript
     * report.resetPersistentFilters();
     * ```
     */ Report.prototype.resetPersistentFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response_17;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.delete("/report/userState", null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 2:
                                        response_17 = _a.sent();
                                        throw response_17.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Save user's filters, slicers, and other data view changes of the report
     *
     * ```javascript
     * report.savePersistentFilters();
     * ```
     */ Report.prototype.savePersistentFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response_18;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/userState", null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 2:
                                        response_18 = _a.sent();
                                        throw response_18.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Returns if there are user's filters, slicers, or other data view changes applied on the report.
     * If persistent filters is disable, returns false.
     *
     * ```javascript
     * report.arePersistentFiltersApplied();
     * ```
     *
     * @returns {Promise<boolean>}
     */ Report.prototype.arePersistentFiltersApplied = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_19;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/report/isUserStateApplied", {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_19 = _a.sent();
                                        throw response_19.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Remove context menu extension command.
     *
     * ```javascript
     * report.removeContextMenuCommand(commandName, contextMenuTitle)
     *  .catch(error => {
     *      ...
     *  });
     * ```
     *
     * @param {string} commandName
     * @param {string} contextMenuTitle
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.removeContextMenuCommand = function(commandName, contextMenuTitle) {
                        return __awaiter(this, void 0, void 0, function() {
                            var commandCopy, indexOfCommand, newSetting;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        commandCopy = JSON.parse(JSON.stringify(this.commands));
                                        indexOfCommand = this.findCommandMenuIndex("visualContextMenu", commandCopy, commandName, contextMenuTitle);
                                        if (indexOfCommand === -1) throw powerbi_models_1.CommonErrorCodes.NotFound;
                                        // Delete the context menu and not the entire command, since command can have option menu as well.
                                        delete commandCopy[indexOfCommand].extend.visualContextMenu;
                                        newSetting = {
                                            extensions: {
                                                commands: commandCopy,
                                                groups: this.groups
                                            }
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.updateSettings(newSetting)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Add context menu extension command.
     *
     * ```javascript
     * report.addContextMenuCommand(commandName, commandTitle, contextMenuTitle, menuLocation, visualName, visualType, groupName)
     *  .catch(error => {
     *      ...
     *  });
     * ```
     *
     * @param {string} commandName
     * @param {string} commandTitle
     * @param {string} contextMenuTitle
     * @param {MenuLocation} menuLocation
     * @param {string} visualName
     * @param {string} visualType
     * @param {string} groupName
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.addContextMenuCommand = function(commandName, commandTitle, contextMenuTitle, menuLocation, visualName, visualType, groupName) {
                        if (contextMenuTitle === void 0) contextMenuTitle = commandTitle;
                        if (menuLocation === void 0) menuLocation = powerbi_models_1.MenuLocation.Bottom;
                        if (visualName === void 0) visualName = undefined;
                        if (groupName === void 0) groupName = undefined;
                        return __awaiter(this, void 0, void 0, function() {
                            var newCommands, newSetting;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        newCommands = this.createMenuCommand("visualContextMenu", commandName, commandTitle, contextMenuTitle, menuLocation, visualName, visualType, groupName);
                                        newSetting = {
                                            extensions: {
                                                commands: newCommands,
                                                groups: this.groups
                                            }
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.updateSettings(newSetting)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Remove options menu extension command.
     *
     * ```javascript
     * report.removeOptionsMenuCommand(commandName, optionsMenuTitle)
     *  .then({
     *      ...
     *  });
     * ```
     *
     * @param {string} commandName
     * @param {string} optionsMenuTitle
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.removeOptionsMenuCommand = function(commandName, optionsMenuTitle) {
                        return __awaiter(this, void 0, void 0, function() {
                            var commandCopy, indexOfCommand, newSetting;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        commandCopy = JSON.parse(JSON.stringify(this.commands));
                                        indexOfCommand = this.findCommandMenuIndex("visualOptionsMenu", commandCopy, commandName, optionsMenuTitle);
                                        if (indexOfCommand === -1) throw powerbi_models_1.CommonErrorCodes.NotFound;
                                        // Delete the context options and not the entire command, since command can have context menu as well.
                                        delete commandCopy[indexOfCommand].extend.visualOptionsMenu;
                                        delete commandCopy[indexOfCommand].icon;
                                        newSetting = {
                                            extensions: {
                                                commands: commandCopy,
                                                groups: this.groups
                                            }
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.updateSettings(newSetting)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Add options menu extension command.
     *
     * ```javascript
     * report.addOptionsMenuCommand(commandName, commandTitle, optionsMenuTitle, menuLocation, visualName, visualType, groupName, commandIcon)
     *  .catch(error => {
     *      ...
     *  });
     * ```
     *
     * @param {string} commandName
     * @param {string} commandTitle
     * @param {string} optionMenuTitle
     * @param {MenuLocation} menuLocation
     * @param {string} visualName
     * @param {string} visualType
     * @param {string} groupName
     * @param {string} commandIcon
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.addOptionsMenuCommand = function(commandName, commandTitle, optionsMenuTitle, menuLocation, visualName, visualType, groupName, commandIcon) {
                        if (optionsMenuTitle === void 0) optionsMenuTitle = commandTitle;
                        if (menuLocation === void 0) menuLocation = powerbi_models_1.MenuLocation.Bottom;
                        if (visualName === void 0) visualName = undefined;
                        if (visualType === void 0) visualType = undefined;
                        if (groupName === void 0) groupName = undefined;
                        if (commandIcon === void 0) commandIcon = undefined;
                        return __awaiter(this, void 0, void 0, function() {
                            var newCommands, newSetting;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        newCommands = this.createMenuCommand("visualOptionsMenu", commandName, commandTitle, optionsMenuTitle, menuLocation, visualName, visualType, groupName, commandIcon);
                                        newSetting = {
                                            extensions: {
                                                commands: newCommands,
                                                groups: this.groups
                                            }
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.updateSettings(newSetting)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Updates the display state of a visual in a page.
     *
     * ```javascript
     * report.setVisualDisplayState(pageName, visualName, displayState)
     *   .catch(error => { ... });
     * ```
     *
     * @param {string} pageName
     * @param {string} visualName
     * @param {VisualContainerDisplayMode} displayState
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.setVisualDisplayState = function(pageName, visualName, displayState) {
                        return __awaiter(this, void 0, void 0, function() {
                            var visualLayout, newSettings;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        // Check if page name and visual name are valid
                                        return [
                                            4 /*yield*/ ,
                                            this.validateVisual(pageName, visualName)
                                        ];
                                    case 1:
                                        // Check if page name and visual name are valid
                                        _a.sent();
                                        visualLayout = {
                                            displayState: {
                                                mode: displayState
                                            }
                                        };
                                        newSettings = this.buildLayoutSettingsObject(pageName, visualName, visualLayout);
                                        return [
                                            2 /*return*/ ,
                                            this.updateSettings(newSettings)
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Resize a visual in a page.
     *
     * ```javascript
     * report.resizeVisual(pageName, visualName, width, height)
     *   .catch(error => { ... });
     * ```
     *
     * @param {string} pageName
     * @param {string} visualName
     * @param {number} width
     * @param {number} height
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.resizeVisual = function(pageName, visualName, width, height) {
                        return __awaiter(this, void 0, void 0, function() {
                            var visualLayout, newSettings;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        // Check if page name and visual name are valid
                                        return [
                                            4 /*yield*/ ,
                                            this.validateVisual(pageName, visualName)
                                        ];
                                    case 1:
                                        // Check if page name and visual name are valid
                                        _a.sent();
                                        visualLayout = {
                                            width: width,
                                            height: height
                                        };
                                        newSettings = this.buildLayoutSettingsObject(pageName, visualName, visualLayout);
                                        return [
                                            2 /*return*/ ,
                                            this.updateSettings(newSettings)
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Updates the size of active page in report.
     *
     * ```javascript
     * report.resizeActivePage(pageSizeType, width, height)
     *   .catch(error => { ... });
     * ```
     *
     * @param {PageSizeType} pageSizeType
     * @param {number} width
     * @param {number} height
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.resizeActivePage = function(pageSizeType, width, height) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pageSize, newSettings;
                            return __generator(this, function(_a) {
                                pageSize = {
                                    type: pageSizeType,
                                    width: width,
                                    height: height
                                };
                                newSettings = {
                                    layoutType: powerbi_models_1.LayoutType.Custom,
                                    customLayout: {
                                        pageSize: pageSize
                                    }
                                };
                                return [
                                    2 /*return*/ ,
                                    this.updateSettings(newSettings)
                                ];
                            });
                        });
                    };
                    /**
     * Updates the position of a visual in a page.
     *
     * ```javascript
     * report.moveVisual(pageName, visualName, x, y, z)
     *   .catch(error => { ... });
     * ```
     *
     * @param {string} pageName
     * @param {string} visualName
     * @param {number} x
     * @param {number} y
     * @param {number} z
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.moveVisual = function(pageName, visualName, x, y, z) {
                        return __awaiter(this, void 0, void 0, function() {
                            var visualLayout, newSettings;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        // Check if page name and visual name are valid
                                        return [
                                            4 /*yield*/ ,
                                            this.validateVisual(pageName, visualName)
                                        ];
                                    case 1:
                                        // Check if page name and visual name are valid
                                        _a.sent();
                                        visualLayout = {
                                            x: x,
                                            y: y,
                                            z: z
                                        };
                                        newSettings = this.buildLayoutSettingsObject(pageName, visualName, visualLayout);
                                        return [
                                            2 /*return*/ ,
                                            this.updateSettings(newSettings)
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Updates the report layout
     *
     * ```javascript
     * report.switchLayout(layoutType);
     * ```
     *
     * @param {LayoutType} layoutType
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Report.prototype.switchLayout = function(layoutType) {
                        return __awaiter(this, void 0, void 0, function() {
                            var isInitialMobileSettings, isPassedMobileSettings, newSetting, response;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        isInitialMobileSettings = this.isMobileSettings({
                                            layoutType: this.initialLayoutType
                                        });
                                        isPassedMobileSettings = this.isMobileSettings({
                                            layoutType: layoutType
                                        });
                                        // Check if both passed layout and initial layout are of same type.
                                        if (isInitialMobileSettings !== isPassedMobileSettings) throw "Switching between mobile and desktop layouts is not supported. Please reset the embed container and re-embed with required layout.";
                                        newSetting = {
                                            layoutType: layoutType
                                        };
                                        return [
                                            4 /*yield*/ ,
                                            this.updateSettings(newSetting)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        this.initialLayoutType = layoutType;
                                        return [
                                            2 /*return*/ ,
                                            response
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * @hidden
     */ Report.prototype.createMenuCommand = function(type, commandName, commandTitle, menuTitle, menuLocation, visualName, visualType, groupName, icon) {
                        var newCommandObj = {
                            name: commandName,
                            title: commandTitle,
                            extend: {}
                        };
                        newCommandObj.extend[type] = {
                            title: menuTitle,
                            menuLocation: menuLocation
                        };
                        if (type === "visualOptionsMenu") newCommandObj.icon = icon;
                        if (groupName) {
                            var extend = newCommandObj.extend[type];
                            delete extend.menuLocation;
                            var groupExtend = newCommandObj.extend[type];
                            groupExtend.groupName = groupName;
                        }
                        if (visualName) newCommandObj.selector = {
                            $schema: "http://powerbi.com/product/schema#visualSelector",
                            visualName: visualName
                        };
                        if (visualType) newCommandObj.selector = {
                            $schema: "http://powerbi.com/product/schema#visualTypeSelector",
                            visualType: visualType
                        };
                        return __spreadArray(__spreadArray([], this.commands, true), [
                            newCommandObj
                        ], false);
                    };
                    /**
     * @hidden
     */ Report.prototype.findCommandMenuIndex = function(type, commands, commandName, menuTitle) {
                        var indexOfCommand = -1;
                        commands.some(function(activeMenuCommand, index) {
                            return activeMenuCommand.name === commandName && activeMenuCommand.extend[type] && activeMenuCommand.extend[type].title === menuTitle ? (indexOfCommand = index, true) : false;
                        });
                        return indexOfCommand;
                    };
                    /**
     * @hidden
     */ Report.prototype.buildLayoutSettingsObject = function(pageName, visualName, visualLayout) {
                        // Create new settings object with custom layout type
                        var newSettings = {
                            layoutType: powerbi_models_1.LayoutType.Custom,
                            customLayout: {
                                pagesLayout: {}
                            }
                        };
                        newSettings.customLayout.pagesLayout[pageName] = {
                            visualsLayout: {}
                        };
                        newSettings.customLayout.pagesLayout[pageName].visualsLayout[visualName] = visualLayout;
                        return newSettings;
                    };
                    /**
     * @hidden
     */ Report.prototype.validateVisual = function(pageName, visualName) {
                        return __awaiter(this, void 0, void 0, function() {
                            var page;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.getPageByName(pageName)
                                        ];
                                    case 1:
                                        page = _a.sent();
                                        return [
                                            4 /*yield*/ ,
                                            page.getVisualByName(visualName)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * @hidden
     */ Report.prototype.applyThemeInternal = function(theme) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_20;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.put('/report/theme', theme, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_20 = _a.sent();
                                        throw response_20.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * @hidden
     */ Report.prototype.viewModeToString = function(viewMode) {
                        var mode;
                        switch(viewMode){
                            case powerbi_models_1.ViewMode.Edit:
                                mode = "edit";
                                break;
                            case powerbi_models_1.ViewMode.View:
                                mode = "view";
                                break;
                        }
                        return mode;
                    };
                    /**
     * @hidden
     */ Report.prototype.isMobileSettings = function(settings) {
                        return settings && (settings.layoutType === powerbi_models_1.LayoutType.MobileLandscape || settings.layoutType === powerbi_models_1.LayoutType.MobilePortrait);
                    };
                    /**
     * Return the current zoom level of the report.
     *
     * @returns {Promise<number>}
     */ Report.prototype.getZoom = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_21;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/report/zoom", {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_21 = _a.sent();
                                        throw response_21.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Sets the report's zoom level.
     *
     * @param zoomLevel zoom level to set
     */ Report.prototype.setZoom = function(zoomLevel) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.updateSettings({
                                                zoomLevel: zoomLevel
                                            })
                                        ];
                                    case 1:
                                        _a.sent();
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Closes all open context menus and tooltips.
     *
     * ```javascript
     * report.closeAllOverlays()
     *  .then(() => {
     *      ...
     *  });
     * ```
     *
     * @returns {Promise<void>}
     */ Report.prototype.closeAllOverlays = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, error_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post('/report/closeAllOverlays', null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        error_1 = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(error_1)
                                        ];
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Clears selected not popped out visuals, if flag is passed, all visuals selections will be cleared.
     *
     * ```javascript
     * report.clearSelectedVisuals()
     *  .then(() => {
     *      ...
     *  });
     * ```
     *
     * @param {Boolean} [clearPopOutState=false]
     *    If false / undefined visuals selection will not be cleared if one of visuals
     *    is in popped out state (in focus, show as table, spotlight...)
     * @returns {Promise<void>}
     */ Report.prototype.clearSelectedVisuals = function(clearPopOutState) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, error_2;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        clearPopOutState = clearPopOutState === true;
                                        if ((0, util_1.isRDLEmbed)(this.config.embedUrl)) return [
                                            2 /*return*/ ,
                                            Promise.reject(errors_1.APINotSupportedForRDLError)
                                        ];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post("/report/clearSelectedVisuals/".concat(clearPopOutState.toString()), null, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        error_2 = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(error_2)
                                        ];
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /** @hidden */ Report.allowedEvents = [
                        "filtersApplied",
                        "pageChanged",
                        "commandTriggered",
                        "swipeStart",
                        "swipeEnd",
                        "bookmarkApplied",
                        "dataHyperlinkClicked",
                        "visualRendered",
                        "visualClicked",
                        "selectionChanged",
                        "renderingStarted",
                        "blur"
                    ];
                    /** @hidden */ Report.reportIdAttribute = 'powerbi-report-id';
                    /** @hidden */ Report.filterPaneEnabledAttribute = 'powerbi-settings-filter-pane-enabled';
                    /** @hidden */ Report.navContentPaneEnabledAttribute = 'powerbi-settings-nav-content-pane-enabled';
                    /** @hidden */ Report.typeAttribute = 'powerbi-type';
                    /** @hidden */ Report.type = "Report";
                    return Report;
                }(embed_1.Embed);
                exports.Report = Report;
            /***/ },
            /***/ "./src/service.ts": /*!************************!*\
  !*** ./src/service.ts ***!
  \************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __assign = this && this.__assign || function() {
                    __assign = Object.assign || function(t) {
                        for(var s, i = 1, n = arguments.length; i < n; i++){
                            s = arguments[i];
                            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                        }
                        return t;
                    };
                    return __assign.apply(this, arguments);
                };
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Service = void 0;
                var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
                var report_1 = __webpack_require__(/*! ./report */ "./src/report.ts");
                var create_1 = __webpack_require__(/*! ./create */ "./src/create.ts");
                var dashboard_1 = __webpack_require__(/*! ./dashboard */ "./src/dashboard.ts");
                var tile_1 = __webpack_require__(/*! ./tile */ "./src/tile.ts");
                var page_1 = __webpack_require__(/*! ./page */ "./src/page.ts");
                var qna_1 = __webpack_require__(/*! ./qna */ "./src/qna.ts");
                var visual_1 = __webpack_require__(/*! ./visual */ "./src/visual.ts");
                var utils = __webpack_require__(/*! ./util */ "./src/util.ts");
                var quickCreate_1 = __webpack_require__(/*! ./quickCreate */ "./src/quickCreate.ts");
                var sdkConfig = __webpack_require__(/*! ./config */ "./src/config.ts");
                var errors_1 = __webpack_require__(/*! ./errors */ "./src/errors.ts");
                /**
 * The Power BI Service embed component, which is the entry point to embed all other Power BI components into your application
 *
 * @export
 * @class Service
 * @implements {IService}
 */ var Service = /** @class */ function() {
                    /**
     * Creates an instance of a Power BI Service.
     *
     * @param {IHpmFactory} hpmFactory The http post message factory used in the postMessage communication layer
     * @param {IWpmpFactory} wpmpFactory The window post message factory used in the postMessage communication layer
     * @param {IRouterFactory} routerFactory The router factory used in the postMessage communication layer
     * @param {IServiceConfiguration} [config={}]
     * @hidden
     */ function Service(hpmFactory, wpmpFactory, routerFactory, config) {
                        if (config === void 0) config = {};
                        var _this = this;
                        /**
         * @hidden
         */ this.registeredComponents = {};
                        this.wpmp = wpmpFactory(config.wpmpName, config.logMessages);
                        this.hpm = hpmFactory(this.wpmp, null, config.version, config.type, config.sdkWrapperVersion);
                        this.router = routerFactory(this.wpmp);
                        this.uniqueSessionId = utils.generateUUID();
                        /**
         * Adds handler for report events.
         */ this.router.post("/reports/:uniqueId/events/:eventName", function(req, _res) {
                            var event = {
                                type: 'report',
                                id: req.params.uniqueId,
                                name: req.params.eventName,
                                value: req.body
                            };
                            _this.handleEvent(event);
                        });
                        this.router.post("/reports/:uniqueId/pages/:pageName/events/:eventName", function(req, _res) {
                            var event = {
                                type: 'report',
                                id: req.params.uniqueId,
                                name: req.params.eventName,
                                value: req.body
                            };
                            _this.handleEvent(event);
                        });
                        this.router.post("/reports/:uniqueId/pages/:pageName/visuals/:visualName/events/:eventName", function(req, _res) {
                            var event = {
                                type: 'report',
                                id: req.params.uniqueId,
                                name: req.params.eventName,
                                value: req.body
                            };
                            _this.handleEvent(event);
                        });
                        this.router.post("/dashboards/:uniqueId/events/:eventName", function(req, _res) {
                            var event = {
                                type: 'dashboard',
                                id: req.params.uniqueId,
                                name: req.params.eventName,
                                value: req.body
                            };
                            _this.handleEvent(event);
                        });
                        this.router.post("/tile/:uniqueId/events/:eventName", function(req, _res) {
                            var event = {
                                type: 'tile',
                                id: req.params.uniqueId,
                                name: req.params.eventName,
                                value: req.body
                            };
                            _this.handleEvent(event);
                        });
                        /**
         * Adds handler for Q&A events.
         */ this.router.post("/qna/:uniqueId/events/:eventName", function(req, _res) {
                            var event = {
                                type: 'qna',
                                id: req.params.uniqueId,
                                name: req.params.eventName,
                                value: req.body
                            };
                            _this.handleEvent(event);
                        });
                        /**
         * Adds handler for front load 'ready' message.
         */ this.router.post("/ready/:uniqueId", function(req, _res) {
                            var event = {
                                type: 'report',
                                id: req.params.uniqueId,
                                name: 'ready',
                                value: req.body
                            };
                            _this.handleEvent(event);
                        });
                        this.embeds = [];
                        // TODO: Change when Object.assign is available.
                        this.config = utils.assign({}, Service.defaultConfig, config);
                        if (this.config.autoEmbedOnContentLoaded) this.enableAutoEmbed();
                    }
                    /**
     * Creates new report
     *
     * @param {HTMLElement} element
     * @param {IEmbedConfiguration} [config={}]
     * @returns {Embed}
     */ Service.prototype.createReport = function(element, config) {
                        config.type = 'create';
                        var powerBiElement = element;
                        var component = new create_1.Create(this, powerBiElement, config);
                        powerBiElement.powerBiEmbed = component;
                        this.addOrOverwriteEmbed(component, element);
                        return component;
                    };
                    /**
     * Creates new dataset
     *
     * @param {HTMLElement} element
     * @param {IEmbedConfiguration} [config={}]
     * @returns {Embed}
     */ Service.prototype.quickCreate = function(element, config) {
                        config.type = 'quickCreate';
                        var powerBiElement = element;
                        var component = new quickCreate_1.QuickCreate(this, powerBiElement, config);
                        powerBiElement.powerBiEmbed = component;
                        this.addOrOverwriteEmbed(component, element);
                        return component;
                    };
                    /**
     * TODO: Add a description here
     *
     * @param {HTMLElement} [container]
     * @param {IEmbedConfiguration} [config=undefined]
     * @returns {Embed[]}
     * @hidden
     */ Service.prototype.init = function(container, config) {
                        var _this = this;
                        if (config === void 0) config = undefined;
                        container = container && container instanceof HTMLElement ? container : document.body;
                        var elements = Array.prototype.slice.call(container.querySelectorAll("[".concat(embed_1.Embed.embedUrlAttribute, "]")));
                        return elements.map(function(element) {
                            return _this.embed(element, config);
                        });
                    };
                    /**
     * Given a configuration based on an HTML element,
     * if the component has already been created and attached to the element, reuses the component instance and existing iframe,
     * otherwise creates a new component instance.
     *
     * @param {HTMLElement} element
     * @param {IEmbedConfigurationBase} [config={}]
     * @returns {Embed}
     */ Service.prototype.embed = function(element, config) {
                        if (config === void 0) config = {};
                        return this.embedInternal(element, config);
                    };
                    /**
     * Given a configuration based on an HTML element,
     * if the component has already been created and attached to the element, reuses the component instance and existing iframe,
     * otherwise creates a new component instance.
     * This is used for the phased embedding API, once element is loaded successfully, one can call 'render' on it.
     *
     * @param {HTMLElement} element
     * @param {IEmbedConfigurationBase} [config={}]
     * @returns {Embed}
     */ Service.prototype.load = function(element, config) {
                        if (config === void 0) config = {};
                        return this.embedInternal(element, config, /* phasedRender */ true, /* isBootstrap */ false);
                    };
                    /**
     * Given an HTML element and entityType, creates a new component instance, and bootstrap the iframe for embedding.
     *
     * @param {HTMLElement} element
     * @param {IBootstrapEmbedConfiguration} config: a bootstrap config which is an embed config without access token.
     */ Service.prototype.bootstrap = function(element, config) {
                        return this.embedInternal(element, config, /* phasedRender */ false, /* isBootstrap */ true);
                    };
                    /** @hidden */ Service.prototype.embedInternal = function(element, config, phasedRender, isBootstrap) {
                        if (config === void 0) config = {};
                        var component;
                        var powerBiElement = element;
                        if (powerBiElement.powerBiEmbed) {
                            if (isBootstrap) throw new Error("Attempted to bootstrap element ".concat(element.outerHTML, ", but the element is already a powerbi element."));
                            component = this.embedExisting(powerBiElement, config, phasedRender);
                        } else component = this.embedNew(powerBiElement, config, phasedRender, isBootstrap);
                        return component;
                    };
                    /** @hidden */ Service.prototype.getNumberOfComponents = function() {
                        if (!this.embeds) return 0;
                        return this.embeds.length;
                    };
                    /** @hidden */ Service.prototype.getSdkSessionId = function() {
                        return this.uniqueSessionId;
                    };
                    /**
     * Returns the Power BI Client SDK version
     *
     * @hidden
     */ Service.prototype.getSDKVersion = function() {
                        return sdkConfig.default.version;
                    };
                    /**
     * Given a configuration based on a Power BI element, saves the component instance that reference the element for later lookup.
     *
     * @private
     * @param {IPowerBiElement} element
     * @param {IEmbedConfigurationBase} config
     * @param {boolean} phasedRender
     * @param {boolean} isBootstrap
     * @returns {Embed}
     * @hidden
     */ Service.prototype.embedNew = function(element, config, phasedRender, isBootstrap) {
                        var componentType = config.type || element.getAttribute(embed_1.Embed.typeAttribute);
                        if (!componentType) {
                            var scrubbedConfig = __assign(__assign({}, config), {
                                accessToken: ""
                            });
                            throw new Error("Attempted to embed using config ".concat(JSON.stringify(scrubbedConfig), " on element ").concat(element.outerHTML, ", but could not determine what type of component to embed. You must specify a type in the configuration or as an attribute such as '").concat(embed_1.Embed.typeAttribute, "=\"").concat(report_1.Report.type.toLowerCase(), "\"'."));
                        }
                        // Saves the type as part of the configuration so that it can be referenced later at a known location.
                        config.type = componentType;
                        var component = this.createEmbedComponent(componentType, element, config, phasedRender, isBootstrap);
                        element.powerBiEmbed = component;
                        this.addOrOverwriteEmbed(component, element);
                        return component;
                    };
                    /**
     * Given component type, creates embed component instance
     *
     * @private
     * @param {string} componentType
     * @param {HTMLElement} element
     * @param {IEmbedConfigurationBase} config
     * @param {boolean} phasedRender
     * @param {boolean} isBootstrap
     * @returns {Embed}
     * @hidden
     */ Service.prototype.createEmbedComponent = function(componentType, element, config, phasedRender, isBootstrap) {
                        var Component = utils.find(function(embedComponent) {
                            return componentType === embedComponent.type.toLowerCase();
                        }, Service.components);
                        if (Component) return new Component(this, element, config, phasedRender, isBootstrap);
                        // If component type is not legacy, search in registered components
                        var registeredComponent = utils.find(function(registeredComponentType) {
                            return componentType.toLowerCase() === registeredComponentType.toLowerCase();
                        }, Object.keys(this.registeredComponents));
                        if (!registeredComponent) throw new Error("Attempted to embed component of type: ".concat(componentType, " but did not find any matching component.  Please verify the type you specified is intended."));
                        return this.registeredComponents[registeredComponent](this, element, config, phasedRender, isBootstrap);
                    };
                    /**
     * Given an element that already contains an embed component, load with a new configuration.
     *
     * @private
     * @param {IPowerBiElement} element
     * @param {IEmbedConfigurationBase} config
     * @returns {Embed}
     * @hidden
     */ Service.prototype.embedExisting = function(element, config, phasedRender) {
                        var component = utils.find(function(x) {
                            return x.element === element;
                        }, this.embeds);
                        if (!component) {
                            var scrubbedConfig = __assign(__assign({}, config), {
                                accessToken: ""
                            });
                            throw new Error("Attempted to embed using config ".concat(JSON.stringify(scrubbedConfig), " on element ").concat(element.outerHTML, " which already has embedded component associated, but could not find the existing component in the list of active components. This could indicate the embeds list is out of sync with the DOM, or the component is referencing the incorrect HTML element."));
                        }
                        // TODO: Multiple embedding to the same iframe is not supported in QnA
                        if (config.type && config.type.toLowerCase() === "qna") return this.embedNew(element, config);
                        /**
         * TODO: Dynamic embed type switching could be supported but there is work needed to prepare the service state and DOM cleanup.
         * remove all event handlers from the DOM, then reset the element to initial state which removes iframe, and removes from list of embeds
         * then we can call the embedNew function which would allow setting the proper embedUrl and construction of object based on the new type.
         */ if (typeof config.type === "string" && config.type !== component.config.type) {
                            /**
             * When loading report after create we want to use existing Iframe to optimize load period
             */ if (config.type === "report" && utils.isCreate(component.config.type)) {
                                var report = new report_1.Report(this, element, config, /* phasedRender */ false, /* isBootstrap */ false, element.powerBiEmbed.iframe);
                                component.populateConfig(config, /* isBootstrap */ false);
                                report.load();
                                element.powerBiEmbed = report;
                                this.addOrOverwriteEmbed(component, element);
                                return report;
                            }
                            var scrubbedConfig = __assign(__assign({}, config), {
                                accessToken: ""
                            });
                            throw new Error("Embedding on an existing element with a different type than the previous embed object is not supported.  Attempted to embed using config ".concat(JSON.stringify(scrubbedConfig), " on element ").concat(element.outerHTML, ", but the existing element contains an embed of type: ").concat(this.config.type, " which does not match the new type: ").concat(config.type));
                        }
                        component.populateConfig(config, /* isBootstrap */ false);
                        component.load(phasedRender);
                        return component;
                    };
                    /**
     * Adds an event handler for DOMContentLoaded, which searches the DOM for elements that have the 'powerbi-embed-url' attribute,
     * and automatically attempts to embed a powerbi component based on information from other powerbi-* attributes.
     *
     * Note: Only runs if `config.autoEmbedOnContentLoaded` is true when the service is created.
     * This handler is typically useful only for applications that are rendered on the server so that all required data is available when the handler is called.
     *
     * @hidden
     */ Service.prototype.enableAutoEmbed = function() {
                        var _this = this;
                        window.addEventListener('DOMContentLoaded', function(_event) {
                            return _this.init(document.body);
                        }, false);
                    };
                    /**
     * Returns an instance of the component associated with the element.
     *
     * @param {HTMLElement} element
     * @returns {(Report | Tile)}
     */ Service.prototype.get = function(element) {
                        var powerBiElement = element;
                        if (!powerBiElement.powerBiEmbed) throw new Error("You attempted to get an instance of powerbi component associated with element: ".concat(element.outerHTML, " but there was no associated instance."));
                        return powerBiElement.powerBiEmbed;
                    };
                    /**
     * Finds an embed instance by the name or unique ID that is provided.
     *
     * @param {string} uniqueId
     * @returns {(Report | Tile)}
     * @hidden
     */ Service.prototype.find = function(uniqueId) {
                        return utils.find(function(x) {
                            return x.config.uniqueId === uniqueId;
                        }, this.embeds);
                    };
                    /**
     * Removes embed components whose container element is same as the given element
     *
     * @param {Embed} component
     * @param {HTMLElement} element
     * @returns {void}
     * @hidden
     */ Service.prototype.addOrOverwriteEmbed = function(component, element) {
                        // remove embeds over the same div element.
                        this.embeds = this.embeds.filter(function(embed) {
                            return embed.element !== element;
                        });
                        this.embeds.push(component);
                    };
                    /**
     * Given an HTML element that has a component embedded within it, removes the component from the list of embedded components, removes the association between the element and the component, and removes the iframe.
     *
     * @param {HTMLElement} element
     * @returns {void}
     */ Service.prototype.reset = function(element) {
                        var powerBiElement = element;
                        if (!powerBiElement.powerBiEmbed) return;
                        /** Removes the element frontLoad listener if exists. */ var embedElement = powerBiElement.powerBiEmbed;
                        if (embedElement.frontLoadHandler) embedElement.element.removeEventListener('ready', embedElement.frontLoadHandler, false);
                        /** Removes all event handlers. */ embedElement.allowedEvents.forEach(function(eventName) {
                            embedElement.off(eventName);
                        });
                        /** Removes the component from an internal list of components. */ utils.remove(function(x) {
                            return x === powerBiElement.powerBiEmbed;
                        }, this.embeds);
                        /** Deletes a property from the HTML element. */ delete powerBiElement.powerBiEmbed;
                        /** Removes the iframe from the element. */ var iframe = element.querySelector('iframe');
                        if (iframe) {
                            if (iframe.remove !== undefined) iframe.remove();
                            else /** Workaround for IE: unhandled rejection TypeError: object doesn't support property or method 'remove' */ iframe.parentElement.removeChild(iframe);
                        }
                    };
                    /**
     * handles tile events
     *
     * @param {IEvent<any>} event
     * @hidden
     */ Service.prototype.handleTileEvents = function(event) {
                        if (event.type === 'tile') this.handleEvent(event);
                    };
                    Service.prototype.invokeSDKHook = function(hook, req, res) {
                        return __awaiter(this, void 0, void 0, function() {
                            var result, error_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!hook) {
                                            res.send(404, null);
                                            return [
                                                2 /*return*/ 
                                            ];
                                        }
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            hook(req.body)
                                        ];
                                    case 2:
                                        result = _a.sent();
                                        res.send(200, result);
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 3:
                                        error_1 = _a.sent();
                                        res.send(400, null);
                                        console.error(error_1);
                                        return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Given an event object, finds the embed component with the matching type and ID, and invokes its handleEvent method with the event object.
     *
     * @private
     * @param {IEvent<any>} event
     * @hidden
     */ Service.prototype.handleEvent = function(event) {
                        var embed = utils.find(function(embed) {
                            return embed.config.uniqueId === event.id;
                        }, this.embeds);
                        if (embed) {
                            var value = event.value;
                            if (event.name === 'pageChanged') {
                                var pageKey = 'newPage';
                                var page = value[pageKey];
                                if (!page) throw new Error("Page model not found at 'event.value.".concat(pageKey, "'."));
                                value[pageKey] = new page_1.Page(embed, page.name, page.displayName, true);
                            }
                            utils.raiseCustomEvent(embed.element, event.name, value);
                        }
                    };
                    /**
     * API for warm starting powerbi embedded endpoints.
     * Use this API to preload Power BI Embedded in the background.
     *
     * @public
     * @param {IEmbedConfigurationBase} [config={}]
     * @param {HTMLElement} [element=undefined]
     */ Service.prototype.preload = function(config, element) {
                        if (!utils.validateEmbedUrl(config.embedUrl)) throw new Error(errors_1.invalidEmbedUrlErrorMessage);
                        var iframeContent = document.createElement("iframe");
                        iframeContent.setAttribute("style", "display:none;");
                        iframeContent.setAttribute("src", config.embedUrl);
                        iframeContent.setAttribute("scrolling", "no");
                        iframeContent.setAttribute("allowfullscreen", "false");
                        var node = element;
                        if (!node) node = document.getElementsByTagName("body")[0];
                        node.appendChild(iframeContent);
                        iframeContent.onload = function() {
                            utils.raiseCustomEvent(iframeContent, "preloaded", {});
                        };
                        return iframeContent;
                    };
                    /**
     * Use this API to set SDK info
     *
     * @hidden
     * @param {string} type
     * @returns {void}
     */ Service.prototype.setSdkInfo = function(type, version) {
                        this.hpm.defaultHeaders['x-sdk-type'] = type;
                        this.hpm.defaultHeaders['x-sdk-wrapper-version'] = version;
                    };
                    /**
     * API for registering external components
     *
     * @hidden
     * @param {string} componentType
     * @param {EmbedComponentFactory} embedComponentFactory
     * @param {string[]} routerEventUrls
     */ Service.prototype.register = function(componentType, embedComponentFactory, routerEventUrls) {
                        var _this = this;
                        if (utils.find(function(embedComponent) {
                            return componentType.toLowerCase() === embedComponent.type.toLowerCase();
                        }, Service.components)) throw new Error('The component name is reserved. Cannot register a component with this name.');
                        if (utils.find(function(registeredComponentType) {
                            return componentType.toLowerCase() === registeredComponentType.toLowerCase();
                        }, Object.keys(this.registeredComponents))) throw new Error('A component with this type is already registered.');
                        this.registeredComponents[componentType] = embedComponentFactory;
                        routerEventUrls.forEach(function(url) {
                            if (!url.includes(':uniqueId') || !url.includes(':eventName')) throw new Error('Invalid router event URL');
                            _this.router.post(url, function(req, _res) {
                                var event = {
                                    type: componentType,
                                    id: req.params.uniqueId,
                                    name: req.params.eventName,
                                    value: req.body
                                };
                                _this.handleEvent(event);
                            });
                        });
                    };
                    /**
     * A list of components that this service can embed
     */ Service.components = [
                        tile_1.Tile,
                        report_1.Report,
                        dashboard_1.Dashboard,
                        qna_1.Qna,
                        visual_1.Visual
                    ];
                    /**
     * The default configuration for the service
     */ Service.defaultConfig = {
                        autoEmbedOnContentLoaded: false,
                        onError: function() {
                            var args = [];
                            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                            return console.log(args[0], args.slice(1));
                        }
                    };
                    return Service;
                }();
                exports.Service = Service;
            /***/ },
            /***/ "./src/tile.ts": /*!*********************!*\
  !*** ./src/tile.ts ***!
  \*********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Tile = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
                /**
 * The Power BI tile embed component
 *
 * @export
 * @class Tile
 * @extends {Embed}
 */ var Tile = /** @class */ function(_super) {
                    __extends(Tile, _super);
                    /**
     * @hidden
     */ function Tile(service, element, baseConfig, phasedRender, isBootstrap) {
                        var _this = this;
                        var config = baseConfig;
                        _this = _super.call(this, service, element, config, /* iframe */ undefined, phasedRender, isBootstrap) || this;
                        _this.loadPath = "/tile/load";
                        Array.prototype.push.apply(_this.allowedEvents, Tile.allowedEvents);
                        return _this;
                    }
                    /**
     * The ID of the tile
     *
     * @returns {string}
     */ Tile.prototype.getId = function() {
                        var config = this.config;
                        var tileId = config.id || Tile.findIdFromEmbedUrl(this.config.embedUrl);
                        if (typeof tileId !== 'string' || tileId.length === 0) throw new Error("Tile id is required, but it was not found. You must provide an id either as part of embed configuration.");
                        return tileId;
                    };
                    /**
     * Validate load configuration.
     */ Tile.prototype.validate = function(config) {
                        var embedConfig = config;
                        return (0, powerbi_models_1.validateTileLoad)(embedConfig);
                    };
                    /**
     * Handle config changes.
     *
     * @returns {void}
     */ Tile.prototype.configChanged = function(isBootstrap) {
                        if (isBootstrap) return;
                        // Populate tile id into config object.
                        this.config.id = this.getId();
                    };
                    /**
     * @hidden
     * @returns {string}
     */ Tile.prototype.getDefaultEmbedUrlEndpoint = function() {
                        return "tileEmbed";
                    };
                    /**
     * Adds the ability to get tileId from url.
     * By extracting the ID we can ensure that the ID is always explicitly provided as part of the load configuration.
     *
     * @hidden
     * @static
     * @param {string} url
     * @returns {string}
     */ Tile.findIdFromEmbedUrl = function(url) {
                        var tileIdRegEx = /tileId="?([^&]+)"?/;
                        var tileIdMatch = url.match(tileIdRegEx);
                        var tileId;
                        if (tileIdMatch) tileId = tileIdMatch[1];
                        return tileId;
                    };
                    /** @hidden */ Tile.type = "Tile";
                    /** @hidden */ Tile.allowedEvents = [
                        "tileClicked",
                        "tileLoaded"
                    ];
                    return Tile;
                }(embed_1.Embed);
                exports.Tile = Tile;
            /***/ },
            /***/ "./src/util.ts": /*!*********************!*\
  !*** ./src/util.ts ***!
  \*********************/ /***/ function(__unused_webpack_module, exports) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.validateEmbedUrl = exports.isCreate = exports.getTimeDiffInMilliseconds = exports.getRandomValue = exports.autoAuthInEmbedUrl = exports.isRDLEmbed = exports.isSavedInternal = exports.addParamToUrl = exports.generateUUID = exports.createRandomString = exports.assign = exports.remove = exports.find = exports.findIndex = exports.raiseCustomEvent = void 0;
                /**
 * @hidden
 */ var allowedPowerBiHostsRegex = new RegExp(/(.+\.powerbi\.com$)|(.+\.fabric\.microsoft\.com$)|(.+\.analysis\.windows-int\.net$)|(.+\.analysis-df\.windows\.net$)/);
                /**
 * @hidden
 */ var allowedPowerBiHostsSovRegex = new RegExp(/^app\.powerbi\.cn$|^app(\.mil\.|\.high\.|\.)powerbigov\.us$|^app\.powerbi\.eaglex\.ic\.gov$|^app\.powerbi\.microsoft\.scloud$/);
                /**
 * @hidden
 */ var expectedEmbedUrlProtocol = "https:";
                /**
 * Raises a custom event with event data on the specified HTML element.
 *
 * @export
 * @param {HTMLElement} element
 * @param {string} eventName
 * @param {*} eventData
 */ function raiseCustomEvent(element, eventName, eventData) {
                    var customEvent;
                    if (typeof CustomEvent === 'function') customEvent = new CustomEvent(eventName, {
                        detail: eventData,
                        bubbles: true,
                        cancelable: true
                    });
                    else {
                        customEvent = document.createEvent('CustomEvent');
                        customEvent.initCustomEvent(eventName, true, true, eventData);
                    }
                    element.dispatchEvent(customEvent);
                }
                exports.raiseCustomEvent = raiseCustomEvent;
                /**
 * Finds the index of the first value in an array that matches the specified predicate.
 *
 * @export
 * @template T
 * @param {(x: T) => boolean} predicate
 * @param {T[]} xs
 * @returns {number}
 */ function findIndex(predicate, xs) {
                    if (!Array.isArray(xs)) throw new Error("You attempted to call find with second parameter that was not an array. You passed: ".concat(xs));
                    var index;
                    xs.some(function(x, i) {
                        if (predicate(x)) {
                            index = i;
                            return true;
                        }
                    });
                    return index;
                }
                exports.findIndex = findIndex;
                /**
 * Finds the first value in an array that matches the specified predicate.
 *
 * @export
 * @template T
 * @param {(x: T) => boolean} predicate
 * @param {T[]} xs
 * @returns {T}
 */ function find(predicate, xs) {
                    var index = findIndex(predicate, xs);
                    return xs[index];
                }
                exports.find = find;
                function remove(predicate, xs) {
                    var index = findIndex(predicate, xs);
                    xs.splice(index, 1);
                }
                exports.remove = remove;
                // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
                // TODO: replace in favor of using polyfill
                /**
 * Copies the values of all enumerable properties from one or more source objects to a target object, and returns the target object.
 *
 * @export
 * @param {any} args
 * @returns
 */ function assign() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var target = args[0];
                    'use strict';
                    if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
                    var output = Object(target);
                    for(var index = 1; index < arguments.length; index++){
                        var source = arguments[index];
                        if (source !== undefined && source !== null) {
                            for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
                        }
                    }
                    return output;
                }
                exports.assign = assign;
                /**
 * Generates a random 5 to 6 character string.
 *
 * @export
 * @returns {string}
 */ function createRandomString() {
                    return getRandomValue().toString(36).substring(1);
                }
                exports.createRandomString = createRandomString;
                /**
 * Generates a 20 character uuid.
 *
 * @export
 * @returns {string}
 */ function generateUUID() {
                    var d = new Date().getTime();
                    if (typeof performance !== 'undefined' && typeof performance.now === 'function') d += performance.now();
                    return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(_c) {
                        // Generate a random number, scaled from 0 to 15.
                        var r = getRandomValue() % 16;
                        // Shift 4 times to divide by 16
                        d >>= 4;
                        return r.toString(16);
                    });
                }
                exports.generateUUID = generateUUID;
                /**
 * Adds a parameter to the given url
 *
 * @export
 * @param {string} url
 * @param {string} paramName
 * @param {string} value
 * @returns {string}
 */ function addParamToUrl(url, paramName, value) {
                    var parameterPrefix = url.indexOf('?') > 0 ? '&' : '?';
                    url += parameterPrefix + paramName + '=' + value;
                    return url;
                }
                exports.addParamToUrl = addParamToUrl;
                /**
 * Checks if the report is saved.
 *
 * @export
 * @param {HttpPostMessage} hpm
 * @param {string} uid
 * @param {Window} contentWindow
 * @returns {Promise<boolean>}
 */ function isSavedInternal(hpm, uid, contentWindow) {
                    return __awaiter(this, void 0, void 0, function() {
                        var response, response_1;
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        hpm.get('/report/hasUnsavedChanges', {
                                            uid: uid
                                        }, contentWindow)
                                    ];
                                case 1:
                                    response = _a.sent();
                                    return [
                                        2 /*return*/ ,
                                        !response.body
                                    ];
                                case 2:
                                    response_1 = _a.sent();
                                    throw response_1.body;
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }
                exports.isSavedInternal = isSavedInternal;
                /**
 * Checks if the embed url is for RDL report.
 *
 * @export
 * @param {string} embedUrl
 * @returns {boolean}
 */ function isRDLEmbed(embedUrl) {
                    return embedUrl && embedUrl.toLowerCase().indexOf("/rdlembed?") >= 0;
                }
                exports.isRDLEmbed = isRDLEmbed;
                /**
 * Checks if the embed url contains autoAuth=true.
 *
 * @export
 * @param {string} embedUrl
 * @returns {boolean}
 */ function autoAuthInEmbedUrl(embedUrl) {
                    return embedUrl && decodeURIComponent(embedUrl).toLowerCase().indexOf("autoauth=true") >= 0;
                }
                exports.autoAuthInEmbedUrl = autoAuthInEmbedUrl;
                /**
 * Returns random number
 */ function getRandomValue() {
                    // window.msCrypto for IE
                    var cryptoObj = window.crypto || window.msCrypto;
                    var randomValueArray = new Uint32Array(1);
                    cryptoObj.getRandomValues(randomValueArray);
                    return randomValueArray[0];
                }
                exports.getRandomValue = getRandomValue;
                /**
 * Returns the time interval between two dates in milliseconds
 *
 * @export
 * @param {Date} start
 * @param {Date} end
 * @returns {number}
 */ function getTimeDiffInMilliseconds(start, end) {
                    return Math.abs(start.getTime() - end.getTime());
                }
                exports.getTimeDiffInMilliseconds = getTimeDiffInMilliseconds;
                /**
 * Checks if the embed type is for create
 *
 * @export
 * @param {string} embedType
 * @returns {boolean}
 */ function isCreate(embedType) {
                    return embedType === 'create' || embedType === 'quickcreate';
                }
                exports.isCreate = isCreate;
                /**
 * Checks if the embedUrl has an allowed power BI domain
 * @hidden
 */ function validateEmbedUrl(embedUrl) {
                    if (embedUrl) {
                        var url = void 0;
                        try {
                            url = new URL(embedUrl.toLowerCase());
                        } catch (e) {
                            // invalid URL
                            return false;
                        }
                        return url.protocol === expectedEmbedUrlProtocol && (allowedPowerBiHostsRegex.test(url.hostname) || allowedPowerBiHostsSovRegex.test(url.hostname));
                    }
                }
                exports.validateEmbedUrl = validateEmbedUrl;
            /***/ },
            /***/ "./src/visual.ts": /*!***********************!*\
  !*** ./src/visual.ts ***!
  \***********************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Visual = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                var report_1 = __webpack_require__(/*! ./report */ "./src/report.ts");
                var visualDescriptor_1 = __webpack_require__(/*! ./visualDescriptor */ "./src/visualDescriptor.ts");
                /**
 * The Power BI Visual embed component
 *
 * @export
 * @class Visual
 */ var Visual = /** @class */ function(_super) {
                    __extends(Visual, _super);
                    /**
     * Creates an instance of a Power BI Single Visual.
     *
     * @param {Service} service
     * @param {HTMLElement} element
     * @param {IEmbedConfiguration} config
     * @hidden
     */ function Visual(service, element, baseConfig, phasedRender, isBootstrap, iframe) {
                        return _super.call(this, service, element, baseConfig, phasedRender, isBootstrap, iframe) || this;
                    }
                    /**
     * @hidden
     */ Visual.prototype.load = function(phasedRender) {
                        var config = this.config;
                        if (!config.accessToken) // bootstrap flow.
                        return;
                        if (typeof config.pageName !== 'string' || config.pageName.length === 0) throw new Error("Page name is required when embedding a visual.");
                        if (typeof config.visualName !== 'string' || config.visualName.length === 0) throw new Error("Visual name is required, but it was not found. You must provide a visual name as part of embed configuration.");
                        // calculate custom layout settings and override config.
                        var width = config.width ? config.width : this.iframe.offsetWidth;
                        var height = config.height ? config.height : this.iframe.offsetHeight;
                        var pageSize = {
                            type: powerbi_models_1.PageSizeType.Custom,
                            width: width,
                            height: height
                        };
                        var pagesLayout = {};
                        pagesLayout[config.pageName] = {
                            defaultLayout: {
                                displayState: {
                                    mode: powerbi_models_1.VisualContainerDisplayMode.Hidden
                                }
                            },
                            visualsLayout: {}
                        };
                        pagesLayout[config.pageName].visualsLayout[config.visualName] = {
                            displayState: {
                                mode: powerbi_models_1.VisualContainerDisplayMode.Visible
                            },
                            x: 1,
                            y: 1,
                            z: 1,
                            width: pageSize.width,
                            height: pageSize.height
                        };
                        config.settings = config.settings || {};
                        config.settings.filterPaneEnabled = false;
                        config.settings.navContentPaneEnabled = false;
                        config.settings.layoutType = powerbi_models_1.LayoutType.Custom;
                        config.settings.customLayout = {
                            displayOption: powerbi_models_1.DisplayOption.FitToPage,
                            pageSize: pageSize,
                            pagesLayout: pagesLayout
                        };
                        this.config = config;
                        return _super.prototype.load.call(this, phasedRender);
                    };
                    /**
     * Gets the list of pages within the report - not supported in visual
     *
     * @returns {Promise<Page[]>}
     */ Visual.prototype.getPages = function() {
                        throw Visual.GetPagesNotSupportedError;
                    };
                    /**
     * Sets the active page of the report - not supported in visual
     *
     * @param {string} pageName
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Visual.prototype.setPage = function(_pageName) {
                        throw Visual.SetPageNotSupportedError;
                    };
                    /**
     * Render a preloaded report, using phased embedding API
     *
     * @hidden
     * @returns {Promise<void>}
     */ Visual.prototype.render = function(_config) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                throw Visual.RenderNotSupportedError;
                            });
                        });
                    };
                    /**
     * Gets the embedded visual descriptor object that contains the visual name, type, etc.
     *
     * ```javascript
     * visual.getVisualDescriptor()
     *   .then(visualDetails => { ... });
     * ```
     *
     * @returns {Promise<VisualDescriptor>}
     */ Visual.prototype.getVisualDescriptor = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var config, response, embeddedVisuals, visualNotFoundError, embeddedVisual, currentPage, response_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        config = this.config;
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get("/report/pages/".concat(config.pageName, "/visuals"), {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        embeddedVisuals = response.body.filter(function(pageVisual) {
                                            return pageVisual.name === config.visualName;
                                        });
                                        if (embeddedVisuals.length === 0) {
                                            visualNotFoundError = {
                                                message: "visualNotFound",
                                                detailedMessage: "Visual not found"
                                            };
                                            throw visualNotFoundError;
                                        }
                                        embeddedVisual = embeddedVisuals[0];
                                        currentPage = this.page(config.pageName);
                                        return [
                                            2 /*return*/ ,
                                            new visualDescriptor_1.VisualDescriptor(currentPage, embeddedVisual.name, embeddedVisual.title, embeddedVisual.type, embeddedVisual.layout)
                                        ];
                                    case 3:
                                        response_1 = _a.sent();
                                        throw response_1.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Gets filters that are applied to the filter level.
     * Default filter level is visual level.
     *
     * ```javascript
     * visual.getFilters(filtersLevel)
     *   .then(filters => {
     *     ...
     *   });
     * ```
     *
     * @returns {Promise<IFilter[]>}
     */ Visual.prototype.getFilters = function(filtersLevel) {
                        return __awaiter(this, void 0, void 0, function() {
                            var url, response, response_2;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        url = this.getFiltersLevelUrl(filtersLevel);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.get(url, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_2 = _a.sent();
                                        throw response_2.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Updates filters at the filter level.
     * Default filter level is visual level.
     *
     * ```javascript
     * const filters: [
     *    ...
     * ];
     *
     * visual.updateFilters(FiltersOperations.Add, filters, filtersLevel)
     *  .catch(errors => {
     *    ...
     *  });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Visual.prototype.updateFilters = function(operation, filters, filtersLevel) {
                        return __awaiter(this, void 0, void 0, function() {
                            var updateFiltersRequest, url, response_3;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        updateFiltersRequest = {
                                            filtersOperation: operation,
                                            filters: filters
                                        };
                                        url = this.getFiltersLevelUrl(filtersLevel);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.post(url, updateFiltersRequest, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_3 = _a.sent();
                                        throw response_3.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Sets filters at the filter level.
     * Default filter level is visual level.
     *
     * ```javascript
     * const filters: [
     *    ...
     * ];
     *
     * visual.setFilters(filters, filtersLevel)
     *  .catch(errors => {
     *    ...
     *  });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Visual.prototype.setFilters = function(filters, filtersLevel) {
                        return __awaiter(this, void 0, void 0, function() {
                            var url, response_4;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        url = this.getFiltersLevelUrl(filtersLevel);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.service.hpm.put(url, filters, {
                                                uid: this.config.uniqueId
                                            }, this.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_4 = _a.sent();
                                        throw response_4.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Removes all filters from the current filter level.
     * Default filter level is visual level.
     *
     * ```javascript
     * visual.removeFilters(filtersLevel);
     * ```
     *
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ Visual.prototype.removeFilters = function(filtersLevel) {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.updateFilters(powerbi_models_1.FiltersOperations.RemoveAll, undefined, filtersLevel)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * @hidden
     */ Visual.prototype.getFiltersLevelUrl = function(filtersLevel) {
                        var config = this.config;
                        switch(filtersLevel){
                            case powerbi_models_1.FiltersLevel.Report:
                                return "/report/filters";
                            case powerbi_models_1.FiltersLevel.Page:
                                return "/report/pages/".concat(config.pageName, "/filters");
                            default:
                                return "/report/pages/".concat(config.pageName, "/visuals/").concat(config.visualName, "/filters");
                        }
                    };
                    /** @hidden */ Visual.type = "visual";
                    /** @hidden */ Visual.GetPagesNotSupportedError = "Get pages is not supported while embedding a visual.";
                    /** @hidden */ Visual.SetPageNotSupportedError = "Set page is not supported while embedding a visual.";
                    /** @hidden */ Visual.RenderNotSupportedError = "render is not supported while embedding a visual.";
                    return Visual;
                }(report_1.Report);
                exports.Visual = Visual;
            /***/ },
            /***/ "./src/visualDescriptor.ts": /*!*********************************!*\
  !*** ./src/visualDescriptor.ts ***!
  \*********************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                var __generator = this && this.__generator || function(thisArg, body) {
                    var _ = {
                        label: 0,
                        sent: function() {
                            if (t[0] & 1) throw t[1];
                            return t[1];
                        },
                        trys: [],
                        ops: []
                    }, f, y, t, g;
                    return g = {
                        next: verb(0),
                        "throw": verb(1),
                        "return": verb(2)
                    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                        return this;
                    }), g;
                    function verb(n) {
                        return function(v) {
                            return step([
                                n,
                                v
                            ]);
                        };
                    }
                    function step(op) {
                        if (f) throw new TypeError("Generator is already executing.");
                        while(_)try {
                            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                            if (y = 0, t) op = [
                                op[0] & 2,
                                t.value
                            ];
                            switch(op[0]){
                                case 0:
                                case 1:
                                    t = op;
                                    break;
                                case 4:
                                    _.label++;
                                    return {
                                        value: op[1],
                                        done: false
                                    };
                                case 5:
                                    _.label++;
                                    y = op[1];
                                    op = [
                                        0
                                    ];
                                    continue;
                                case 7:
                                    op = _.ops.pop();
                                    _.trys.pop();
                                    continue;
                                default:
                                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                        _ = 0;
                                        continue;
                                    }
                                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                        _.label = op[1];
                                        break;
                                    }
                                    if (op[0] === 6 && _.label < t[1]) {
                                        _.label = t[1];
                                        t = op;
                                        break;
                                    }
                                    if (t && _.label < t[2]) {
                                        _.label = t[2];
                                        _.ops.push(op);
                                        break;
                                    }
                                    if (t[2]) _.ops.pop();
                                    _.trys.pop();
                                    continue;
                            }
                            op = body.call(thisArg, _);
                        } catch (e) {
                            op = [
                                6,
                                e
                            ];
                            y = 0;
                        } finally{
                            f = t = 0;
                        }
                        if (op[0] & 5) throw op[1];
                        return {
                            value: op[0] ? op[1] : void 0,
                            done: true
                        };
                    }
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VisualDescriptor = void 0;
                var powerbi_models_1 = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
                /**
 * A Power BI visual within a page
 *
 * @export
 * @class VisualDescriptor
 * @implements {IVisualNode}
 */ var VisualDescriptor = /** @class */ function() {
                    /**
     * @hidden
     */ function VisualDescriptor(page, name, title, type, layout) {
                        this.name = name;
                        this.title = title;
                        this.type = type;
                        this.layout = layout;
                        this.page = page;
                    }
                    /**
     * Gets all visual level filters of the current visual.
     *
     * ```javascript
     * visual.getFilters()
     *  .then(filters => { ... });
     * ```
     *
     * @returns {(Promise<IFilter[]>)}
     */ VisualDescriptor.prototype.getFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_1;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.get("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/filters"), {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_1 = _a.sent();
                                        throw response_1.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Update the filters for the current visual according to the operation: Add, replace all, replace by target or remove.
     *
     * ```javascript
     * visual.updateFilters(FiltersOperations.Add, filters)
     *   .catch(errors => { ... });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ VisualDescriptor.prototype.updateFilters = function(operation, filters) {
                        return __awaiter(this, void 0, void 0, function() {
                            var updateFiltersRequest, response_2;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        updateFiltersRequest = {
                                            filtersOperation: operation,
                                            filters: filters
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.post("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/filters"), updateFiltersRequest, {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 3:
                                        response_2 = _a.sent();
                                        throw response_2.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Removes all filters from the current visual.
     *
     * ```javascript
     * visual.removeFilters();
     * ```
     *
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ VisualDescriptor.prototype.removeFilters = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            this.updateFilters(powerbi_models_1.FiltersOperations.RemoveAll)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Sets the filters on the current visual to 'filters'.
     *
     * ```javascript
     * visual.setFilters(filters);
     *   .catch(errors => { ... });
     * ```
     *
     * @param {(IFilter[])} filters
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ VisualDescriptor.prototype.setFilters = function(filters) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response_3;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.put("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/filters"), filters, {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 2:
                                        response_3 = _a.sent();
                                        throw response_3.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Exports Visual data.
     * Can export up to 30K rows.
     *
     * @param rows: Optional. Default value is 30K, maximum value is 30K as well.
     * @param exportDataType: Optional. Default is ExportDataType.Summarized.
     * ```javascript
     * visual.exportData()
     *  .then(data => { ... });
     * ```
     *
     * @returns {(Promise<IExportDataResult>)}
     */ VisualDescriptor.prototype.exportData = function(exportDataType, rows) {
                        return __awaiter(this, void 0, void 0, function() {
                            var exportDataRequestBody, response, response_4;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        exportDataRequestBody = {
                                            rows: rows,
                                            exportDataType: exportDataType
                                        };
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.post("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/exportData"), exportDataRequestBody, {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 2:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 3:
                                        response_4 = _a.sent();
                                        throw response_4.body;
                                    case 4:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Set slicer state.
     * Works only for visuals of type slicer.
     *
     * @param state: A new state which contains the slicer filters.
     * ```javascript
     * visual.setSlicerState()
     *  .then(() => { ... });
     * ```
     */ VisualDescriptor.prototype.setSlicerState = function(state) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response_5;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.put("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/slicer"), state, {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 2:
                                        response_5 = _a.sent();
                                        throw response_5.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Get slicer state.
     * Works only for visuals of type slicer.
     *
     * ```javascript
     * visual.getSlicerState()
     *  .then(state => { ... });
     * ```
     *
     * @returns {(Promise<ISlicerState>)}
     */ VisualDescriptor.prototype.getSlicerState = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_6;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.get("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/slicer"), {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_6 = _a.sent();
                                        throw response_6.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Clone existing visual to a new instance.
     *
     * @returns {(Promise<ICloneVisualResponse>)}
     */ VisualDescriptor.prototype.clone = function(request) {
                        if (request === void 0) request = {};
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_7;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.post("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/clone"), request, {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_7 = _a.sent();
                                        throw response_7.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Sort a visual by dataField and direction.
     *
     * @param request: Sort by visual request.
     *
     * ```javascript
     * visual.sortBy(request)
     *  .then(() => { ... });
     * ```
     */ VisualDescriptor.prototype.sortBy = function(request) {
                        return __awaiter(this, void 0, void 0, function() {
                            var response_8;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.put("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/sortBy"), request, {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        return [
                                            2 /*return*/ ,
                                            _a.sent()
                                        ];
                                    case 2:
                                        response_8 = _a.sent();
                                        throw response_8.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    /**
     * Updates the position of a visual.
     *
     * ```javascript
     * visual.moveVisual(x, y, z)
     *   .catch(error => { ... });
     * ```
     *
     * @param {number} x
     * @param {number} y
     * @param {number} z
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ VisualDescriptor.prototype.moveVisual = function(x, y, z) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pageName, visualName, report;
                            return __generator(this, function(_a) {
                                pageName = this.page.name;
                                visualName = this.name;
                                report = this.page.report;
                                return [
                                    2 /*return*/ ,
                                    report.moveVisual(pageName, visualName, x, y, z)
                                ];
                            });
                        });
                    };
                    /**
     * Updates the display state of a visual.
     *
     * ```javascript
     * visual.setVisualDisplayState(displayState)
     *   .catch(error => { ... });
     * ```
     *
     * @param {VisualContainerDisplayMode} displayState
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ VisualDescriptor.prototype.setVisualDisplayState = function(displayState) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pageName, visualName, report;
                            return __generator(this, function(_a) {
                                pageName = this.page.name;
                                visualName = this.name;
                                report = this.page.report;
                                return [
                                    2 /*return*/ ,
                                    report.setVisualDisplayState(pageName, visualName, displayState)
                                ];
                            });
                        });
                    };
                    /**
     * Resize a visual.
     *
     * ```javascript
     * visual.resizeVisual(width, height)
     *   .catch(error => { ... });
     * ```
     *
     * @param {number} width
     * @param {number} height
     * @returns {Promise<IHttpPostMessageResponse<void>>}
     */ VisualDescriptor.prototype.resizeVisual = function(width, height) {
                        return __awaiter(this, void 0, void 0, function() {
                            var pageName, visualName, report;
                            return __generator(this, function(_a) {
                                pageName = this.page.name;
                                visualName = this.name;
                                report = this.page.report;
                                return [
                                    2 /*return*/ ,
                                    report.resizeVisual(pageName, visualName, width, height)
                                ];
                            });
                        });
                    };
                    /**
     * Get insights for single visual
     *
     * ```javascript
     * visual.getSmartNarrativeInsights();
     * ```
     *
     * @returns {Promise<ISmartNarratives>}
     */ VisualDescriptor.prototype.getSmartNarrativeInsights = function() {
                        return __awaiter(this, void 0, void 0, function() {
                            var response, response_9;
                            return __generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        _a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            this.page.report.service.hpm.get("/report/pages/".concat(this.page.name, "/visuals/").concat(this.name, "/smartNarrativeInsights"), {
                                                uid: this.page.report.config.uniqueId
                                            }, this.page.report.iframe.contentWindow)
                                        ];
                                    case 1:
                                        response = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            response.body
                                        ];
                                    case 2:
                                        response_9 = _a.sent();
                                        throw response_9.body;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        });
                    };
                    return VisualDescriptor;
                }();
                exports.VisualDescriptor = VisualDescriptor;
            /***/ },
            /***/ "./node_modules/window-post-message-proxy/dist/windowPostMessageProxy.js": /*!*******************************************************************************!*\
  !*** ./node_modules/window-post-message-proxy/dist/windowPostMessageProxy.js ***!
  \*******************************************************************************/ /***/ (module1)=>{
                /*! For license information please see windowPostMessageProxy.js.LICENSE.txt */ !function(e, r) {
                    module1.exports = r();
                }(self, ()=>(()=>{
                        "use strict";
                        var e = {};
                        return (()=>{
                            var r = e;
                            Object.defineProperty(r, "__esModule", {
                                value: !0
                            }), r.WindowPostMessageProxy = void 0;
                            var s = function() {
                                function e(r) {
                                    void 0 === r && (r = {
                                        processTrackingProperties: {
                                            addTrackingProperties: e.defaultAddTrackingProperties,
                                            getTrackingProperties: e.defaultGetTrackingProperties
                                        },
                                        isErrorMessage: e.defaultIsErrorMessage,
                                        receiveWindow: window,
                                        name: e.createRandomString()
                                    });
                                    var s = this;
                                    this.pendingRequestPromises = {}, this.addTrackingProperties = r.processTrackingProperties && r.processTrackingProperties.addTrackingProperties || e.defaultAddTrackingProperties, this.getTrackingProperties = r.processTrackingProperties && r.processTrackingProperties.getTrackingProperties || e.defaultGetTrackingProperties, this.isErrorMessage = r.isErrorMessage || e.defaultIsErrorMessage, this.receiveWindow = r.receiveWindow || window, this.name = r.name || e.createRandomString(), this.logMessages = r.logMessages || !1, this.eventSourceOverrideWindow = r.eventSourceOverrideWindow, this.suppressWarnings = r.suppressWarnings || !1, this.logMessages && console.log("new WindowPostMessageProxy created with name: ".concat(this.name, " receiving on window: ").concat(this.receiveWindow.document.title)), this.handlers = [], this.windowMessageHandler = function(e) {
                                        return s.onMessageReceived(e);
                                    }, this.start();
                                }
                                return e.defaultAddTrackingProperties = function(r, s) {
                                    return r[e.messagePropertyName] = s, r;
                                }, e.defaultGetTrackingProperties = function(r) {
                                    return r[e.messagePropertyName];
                                }, e.defaultIsErrorMessage = function(e) {
                                    return !!e.error;
                                }, e.createDeferred = function() {
                                    var e = {
                                        resolve: null,
                                        reject: null,
                                        promise: null
                                    }, r = new Promise(function(r, s) {
                                        e.resolve = r, e.reject = s;
                                    });
                                    return e.promise = r, e;
                                }, e.createRandomString = function() {
                                    var e = window.crypto || window.msCrypto, r = new Uint32Array(1);
                                    return e.getRandomValues(r), r[0].toString(36).substring(1);
                                }, e.prototype.addHandler = function(e) {
                                    this.handlers.push(e);
                                }, e.prototype.removeHandler = function(e) {
                                    var r = this.handlers.indexOf(e);
                                    if (-1 === r) throw new Error("You attempted to remove a handler but no matching handler was found.");
                                    this.handlers.splice(r, 1);
                                }, e.prototype.start = function() {
                                    this.receiveWindow.addEventListener("message", this.windowMessageHandler);
                                }, e.prototype.stop = function() {
                                    this.receiveWindow.removeEventListener("message", this.windowMessageHandler);
                                }, e.prototype.postMessage = function(r, s) {
                                    var n = {
                                        id: e.createRandomString()
                                    };
                                    this.addTrackingProperties(s, n), this.logMessages && (console.log("".concat(this.name, " Posting message:")), console.log(JSON.stringify(s, null, "  "))), r.postMessage(s, "*");
                                    var o = e.createDeferred();
                                    return this.pendingRequestPromises[n.id] = o, o.promise;
                                }, e.prototype.sendResponse = function(e, r, s) {
                                    this.addTrackingProperties(r, s), this.logMessages && (console.log("".concat(this.name, " Sending response:")), console.log(JSON.stringify(r, null, "  "))), e.postMessage(r, "*");
                                }, e.prototype.onMessageReceived = function(e) {
                                    var r = this;
                                    this.logMessages && (console.log("".concat(this.name, " Received message:")), console.log("type: ".concat(e.type)), console.log(JSON.stringify(e.data, null, "  ")));
                                    var s = this.eventSourceOverrideWindow || e.source;
                                    if (s) {
                                        var n = e.data;
                                        if ("object" == typeof n) {
                                            var o, t;
                                            try {
                                                o = this.getTrackingProperties(n);
                                            } catch (e) {
                                                this.suppressWarnings || console.warn("Proxy(".concat(this.name, "): Error occurred when attempting to get tracking properties from incoming message:"), JSON.stringify(n, null, "  "), "Error: ", e);
                                            }
                                            if (o && (t = this.pendingRequestPromises[o.id]), t) {
                                                var i = !0;
                                                try {
                                                    i = this.isErrorMessage(n);
                                                } catch (e) {
                                                    console.warn("Proxy(".concat(this.name, ") Error occurred when trying to determine if message is consider an error response. Message: "), JSON.stringify(n, null, ""), "Error: ", e);
                                                }
                                                i ? t.reject(n) : t.resolve(n), delete this.pendingRequestPromises[o.id];
                                            } else this.handlers.some(function(e) {
                                                var t = !1;
                                                try {
                                                    t = e.test(n);
                                                } catch (e) {
                                                    r.suppressWarnings || console.warn("Proxy(".concat(r.name, "): Error occurred when handler was testing incoming message:"), JSON.stringify(n, null, "  "), "Error: ", e);
                                                }
                                                if (t) {
                                                    var i = void 0;
                                                    try {
                                                        i = Promise.resolve(e.handle(n));
                                                    } catch (e) {
                                                        r.suppressWarnings || console.warn("Proxy(".concat(r.name, "): Error occurred when handler was processing incoming message:"), JSON.stringify(n, null, "  "), "Error: ", e), i = Promise.resolve();
                                                    }
                                                    return i.then(function(e) {
                                                        if (!e) {
                                                            var t = "Handler for message: ".concat(JSON.stringify(n, null, "  "), " did not return a response message. The default response message will be returned instead.");
                                                            r.suppressWarnings || console.warn("Proxy(".concat(r.name, "): ").concat(t)), e = {
                                                                warning: t
                                                            };
                                                        }
                                                        r.sendResponse(s, e, o);
                                                    }), !0;
                                                }
                                            }) || this.suppressWarnings || console.warn("Proxy(".concat(this.name, ") did not handle message. Handlers: ").concat(this.handlers.length, "  Message: ").concat(JSON.stringify(n, null, ""), "."));
                                        } else this.suppressWarnings || console.warn("Proxy(".concat(this.name, "): Received message that was not an object. Discarding message"));
                                    }
                                }, e.messagePropertyName = "windowPostMessageProxy", e;
                            }();
                            r.WindowPostMessageProxy = s;
                        })(), e;
                    })());
            //# sourceMappingURL=windowPostMessageProxy.js.map
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            /*!*******************************!*\
  !*** ./src/powerbi-client.ts ***!
  \*******************************/ // Copyright (c) Microsoft Corporation.
            // Licensed under the MIT License.
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.RelativeTimeFilterBuilder = exports.RelativeDateFilterBuilder = exports.TopNFilterBuilder = exports.AdvancedFilterBuilder = exports.BasicFilterBuilder = exports.Create = exports.QuickCreate = exports.VisualDescriptor = exports.Visual = exports.Qna = exports.Page = exports.Embed = exports.Tile = exports.Dashboard = exports.Report = exports.models = exports.factories = exports.service = void 0;
            /**
 * @hidden
 */ var models = __webpack_require__(/*! powerbi-models */ "./node_modules/powerbi-models/dist/models.js");
            exports.models = models;
            var service = __webpack_require__(/*! ./service */ "./src/service.ts");
            exports.service = service;
            var factories = __webpack_require__(/*! ./factories */ "./src/factories.ts");
            exports.factories = factories;
            var report_1 = __webpack_require__(/*! ./report */ "./src/report.ts");
            Object.defineProperty(exports, "Report", {
                enumerable: true,
                get: function() {
                    return report_1.Report;
                }
            });
            var dashboard_1 = __webpack_require__(/*! ./dashboard */ "./src/dashboard.ts");
            Object.defineProperty(exports, "Dashboard", {
                enumerable: true,
                get: function() {
                    return dashboard_1.Dashboard;
                }
            });
            var tile_1 = __webpack_require__(/*! ./tile */ "./src/tile.ts");
            Object.defineProperty(exports, "Tile", {
                enumerable: true,
                get: function() {
                    return tile_1.Tile;
                }
            });
            var embed_1 = __webpack_require__(/*! ./embed */ "./src/embed.ts");
            Object.defineProperty(exports, "Embed", {
                enumerable: true,
                get: function() {
                    return embed_1.Embed;
                }
            });
            var page_1 = __webpack_require__(/*! ./page */ "./src/page.ts");
            Object.defineProperty(exports, "Page", {
                enumerable: true,
                get: function() {
                    return page_1.Page;
                }
            });
            var qna_1 = __webpack_require__(/*! ./qna */ "./src/qna.ts");
            Object.defineProperty(exports, "Qna", {
                enumerable: true,
                get: function() {
                    return qna_1.Qna;
                }
            });
            var visual_1 = __webpack_require__(/*! ./visual */ "./src/visual.ts");
            Object.defineProperty(exports, "Visual", {
                enumerable: true,
                get: function() {
                    return visual_1.Visual;
                }
            });
            var visualDescriptor_1 = __webpack_require__(/*! ./visualDescriptor */ "./src/visualDescriptor.ts");
            Object.defineProperty(exports, "VisualDescriptor", {
                enumerable: true,
                get: function() {
                    return visualDescriptor_1.VisualDescriptor;
                }
            });
            var quickCreate_1 = __webpack_require__(/*! ./quickCreate */ "./src/quickCreate.ts");
            Object.defineProperty(exports, "QuickCreate", {
                enumerable: true,
                get: function() {
                    return quickCreate_1.QuickCreate;
                }
            });
            var create_1 = __webpack_require__(/*! ./create */ "./src/create.ts");
            Object.defineProperty(exports, "Create", {
                enumerable: true,
                get: function() {
                    return create_1.Create;
                }
            });
            var FilterBuilders_1 = __webpack_require__(/*! ./FilterBuilders */ "./src/FilterBuilders/index.ts");
            Object.defineProperty(exports, "BasicFilterBuilder", {
                enumerable: true,
                get: function() {
                    return FilterBuilders_1.BasicFilterBuilder;
                }
            });
            Object.defineProperty(exports, "AdvancedFilterBuilder", {
                enumerable: true,
                get: function() {
                    return FilterBuilders_1.AdvancedFilterBuilder;
                }
            });
            Object.defineProperty(exports, "TopNFilterBuilder", {
                enumerable: true,
                get: function() {
                    return FilterBuilders_1.TopNFilterBuilder;
                }
            });
            Object.defineProperty(exports, "RelativeDateFilterBuilder", {
                enumerable: true,
                get: function() {
                    return FilterBuilders_1.RelativeDateFilterBuilder;
                }
            });
            Object.defineProperty(exports, "RelativeTimeFilterBuilder", {
                enumerable: true,
                get: function() {
                    return FilterBuilders_1.RelativeTimeFilterBuilder;
                }
            });
            /**
 * Makes Power BI available to the global object for use in applications that don't have module loading support.
 *
 * Note: create an instance of the class with the default configuration for normal usage, or save the class so that you can create an instance of the service.
 */ var powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
            // powerBI SDK may use Power BI object under different key, in order to avoid name collisions
            if (window.powerbi && window.powerBISDKGlobalServiceInstanceName) window[window.powerBISDKGlobalServiceInstanceName] = powerbi;
            else // Default to Power BI.
            window.powerbi = powerbi;
        })();
        /******/ return __webpack_exports__;
    /******/ })();
}); //# sourceMappingURL=powerbi.js.map
 // SIG // Begin signature block
 // SIG // MIIr5QYJKoZIhvcNAQcCoIIr1jCCK9ICAQExDzANBglg
 // SIG // hkgBZQMEAgEFADB3BgorBgEEAYI3AgEEoGkwZzAyBgor
 // SIG // BgEEAYI3AgEeMCQCAQEEEBDgyQbOONQRoqMAEEvTUJAC
 // SIG // AQACAQACAQACAQACAQAwMTANBglghkgBZQMEAgEFAAQg
 // SIG // t5JYF1iPbd+3ZVCrBFh3RJqMcAkMZYhryNBr+nQaMxCg
 // SIG // ghFuMIIIfjCCB2agAwIBAgITNgAAAd9zgZcWvjL9DQAC
 // SIG // AAAB3zANBgkqhkiG9w0BAQsFADBBMRMwEQYKCZImiZPy
 // SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRUw
 // SIG // EwYDVQQDEwxBTUUgQ1MgQ0EgMDEwHhcNMjQwMTIwMDEz
 // SIG // MzQ0WhcNMjUwMTE5MDEzMzQ0WjAkMSIwIAYDVQQDExlN
 // SIG // aWNyb3NvZnQgQXp1cmUgQ29kZSBTaWduMIIBIjANBgkq
 // SIG // hkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1bnAJpGyFqbK
 // SIG // WMrMsnUMskYdi/KuYoGBXMtrw5PMRr1TEQYccGzrCSBH
 // SIG // dMGPDe1lP8YJGDJ0rDOL5nNgePQxnawI0iam7MdM3/gy
 // SIG // xY6wSE1HnHUYZatFShl/FG1TpINGiHxTS0bOA0qwmWId
 // SIG // us8gfKpC/41Jgew4XARIYYDpV0UOCx51L+6n/ol6g7sB
 // SIG // c/bVEwIfCRrIC0QStKErEX1AfhSRdislMc5nhVySohMp
 // SIG // 7Fs+JKqDPdWoNWMNFPHdHvkYACotxbdXFwPt6ijOiNR9
 // SIG // dXvzXSI4e6E4b6wbXxJ4MJcG0xdymTh3YSwRWdfFOL/F
 // SIG // Xk5W+K/eN+OgmNvkip0GuwIDAQABo4IFijCCBYYwKQYJ
 // SIG // KwYBBAGCNxUKBBwwGjAMBgorBgEEAYI3WwEBMAoGCCsG
 // SIG // AQUFBwMDMD0GCSsGAQQBgjcVBwQwMC4GJisGAQQBgjcV
 // SIG // CIaQ4w2E1bR4hPGLPoWb3RbOnRKBYIPdzWaGlIwyAgFk
 // SIG // AgEOMIICdgYIKwYBBQUHAQEEggJoMIICZDBiBggrBgEF
 // SIG // BQcwAoZWaHR0cDovL2NybC5taWNyb3NvZnQuY29tL3Br
 // SIG // aWluZnJhL0NlcnRzL0JZMlBLSUNTQ0EwMS5BTUUuR0JM
 // SIG // X0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYIKwYB
 // SIG // BQUHMAKGRmh0dHA6Ly9jcmwxLmFtZS5nYmwvYWlhL0JZ
 // SIG // MlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIwQ0El
 // SIG // MjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6Ly9j
 // SIG // cmwyLmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5BTUUu
 // SIG // R0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYI
 // SIG // KwYBBQUHMAKGRmh0dHA6Ly9jcmwzLmFtZS5nYmwvYWlh
 // SIG // L0JZMlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIw
 // SIG // Q0ElMjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6
 // SIG // Ly9jcmw0LmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5B
 // SIG // TUUuR0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQw
 // SIG // ga0GCCsGAQUFBzAChoGgbGRhcDovLy9DTj1BTUUlMjBD
 // SIG // UyUyMENBJTIwMDEsQ049QUlBLENOPVB1YmxpYyUyMEtl
 // SIG // eSUyMFNlcnZpY2VzLENOPVNlcnZpY2VzLENOPUNvbmZp
 // SIG // Z3VyYXRpb24sREM9QU1FLERDPUdCTD9jQUNlcnRpZmlj
 // SIG // YXRlP2Jhc2U/b2JqZWN0Q2xhc3M9Y2VydGlmaWNhdGlv
 // SIG // bkF1dGhvcml0eTAdBgNVHQ4EFgQUju4tKpnu7Y7YxY8r
 // SIG // iI5ZhjOnGwkwDgYDVR0PAQH/BAQDAgeAMEUGA1UdEQQ+
 // SIG // MDykOjA4MR4wHAYDVQQLExVNaWNyb3NvZnQgQ29ycG9y
 // SIG // YXRpb24xFjAUBgNVBAUTDTIzNjE2Nys1MDE5NzAwggHm
 // SIG // BgNVHR8EggHdMIIB2TCCAdWgggHRoIIBzYY/aHR0cDov
 // SIG // L2NybC5taWNyb3NvZnQuY29tL3BraWluZnJhL0NSTC9B
 // SIG // TUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRwOi8v
 // SIG // Y3JsMS5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENBJTIw
 // SIG // MDEoMikuY3JshjFodHRwOi8vY3JsMi5hbWUuZ2JsL2Ny
 // SIG // bC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRw
 // SIG // Oi8vY3JsMy5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENB
 // SIG // JTIwMDEoMikuY3JshjFodHRwOi8vY3JsNC5hbWUuZ2Js
 // SIG // L2NybC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshoG9
 // SIG // bGRhcDovLy9DTj1BTUUlMjBDUyUyMENBJTIwMDEoMiks
 // SIG // Q049QlkyUEtJQ1NDQTAxLENOPUNEUCxDTj1QdWJsaWMl
 // SIG // MjBLZXklMjBTZXJ2aWNlcyxDTj1TZXJ2aWNlcyxDTj1D
 // SIG // b25maWd1cmF0aW9uLERDPUFNRSxEQz1HQkw/Y2VydGlm
 // SIG // aWNhdGVSZXZvY2F0aW9uTGlzdD9iYXNlP29iamVjdENs
 // SIG // YXNzPWNSTERpc3RyaWJ1dGlvblBvaW50MB8GA1UdIwQY
 // SIG // MBaAFJZRhOBrb3v+2Aarw/KF5imuavnUMB8GA1UdJQQY
 // SIG // MBYGCisGAQQBgjdbAQEGCCsGAQUFBwMDMA0GCSqGSIb3
 // SIG // DQEBCwUAA4IBAQCXv2FzUgqF4rS3/1+aXyWaXqd3LI3a
 // SIG // pgYIPvCq/vvFzI1sHZuLYi2rCTFDwoJqeTWJ98AuBnnx
 // SIG // mMHxe15thTEkdoukFB44oBrugY3VkIeBMBmjaly5F5VD
 // SIG // O1sNmdCq0baQi9egwjkzWbghTwMrUhxbJD1q6+qtxAbo
 // SIG // jOj+VS4BUiogMXLp5XSaK26wa72UmYm9TiDcxRgELM1E
 // SIG // dMraL1uhTqfrqFYYkAqpzoXgtaaZ2T7LO7516KIMjtMY
 // SIG // EluNG0ZZbRn8J5TndyGf+N2To+V3nkoYOdks1RIsmK2Y
 // SIG // w9ezEjc0DNSSiNO/prQAuw/nmf/oNqTP/daB3Kw6vTau
 // SIG // EK0tMIII6DCCBtCgAwIBAgITHwAAAFHqj/accwyoOwAA
 // SIG // AAAAUTANBgkqhkiG9w0BAQsFADA8MRMwEQYKCZImiZPy
 // SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRAw
 // SIG // DgYDVQQDEwdhbWVyb290MB4XDTIxMDUyMTE4NDQxNFoX
 // SIG // DTI2MDUyMTE4NTQxNFowQTETMBEGCgmSJomT8ixkARkW
 // SIG // A0dCTDETMBEGCgmSJomT8ixkARkWA0FNRTEVMBMGA1UE
 // SIG // AxMMQU1FIENTIENBIDAxMIIBIjANBgkqhkiG9w0BAQEF
 // SIG // AAOCAQ8AMIIBCgKCAQEAyZpSCX0Bno1W1yqXMhT6BUlJ
 // SIG // ZWpa4p3xFeiTHO4vm2Q6C/azR5xwxnyYHrkSGDtS2P9X
 // SIG // +KDE64V20mmEQkubxnPNeOVnE2RvdPGxgwlq+BhS3ONd
 // SIG // VsQPj79q7XgHM9HhzB9+qk0PC9KN1zm9p/seyiRS6JF1
 // SIG // dbOqRf1pUl7FAVxmgiCFgV8hHIb/rDPXig7FDi3S0yEx
 // SIG // 2CUDVpIq8jEhG8anUFE1WYxM+ni0S5KHwwKPKV4qyGDo
 // SIG // DO+9AmDoma3Chyu5WDlW5cdtqXTWsGPE3umtnX6Amlld
 // SIG // UFLms4OVR4guKf+n5LIBCC6bTiocfXPomqYjYTKx7AGM
 // SIG // faVLaaXmhQIDAQABo4IE3DCCBNgwEgYJKwYBBAGCNxUB
 // SIG // BAUCAwIAAjAjBgkrBgEEAYI3FQIEFgQUEmgkQiFHy9Rr
 // SIG // vjHPIKTACyN/P0cwHQYDVR0OBBYEFJZRhOBrb3v+2Aar
 // SIG // w/KF5imuavnUMIIBBAYDVR0lBIH8MIH5BgcrBgEFAgMF
 // SIG // BggrBgEFBQcDAQYIKwYBBQUHAwIGCisGAQQBgjcUAgEG
 // SIG // CSsGAQQBgjcVBgYKKwYBBAGCNwoDDAYJKwYBBAGCNxUG
 // SIG // BggrBgEFBQcDCQYIKwYBBQUIAgIGCisGAQQBgjdAAQEG
 // SIG // CysGAQQBgjcKAwQBBgorBgEEAYI3CgMEBgkrBgEEAYI3
 // SIG // FQUGCisGAQQBgjcUAgIGCisGAQQBgjcUAgMGCCsGAQUF
 // SIG // BwMDBgorBgEEAYI3WwEBBgorBgEEAYI3WwIBBgorBgEE
 // SIG // AYI3WwMBBgorBgEEAYI3WwUBBgorBgEEAYI3WwQBBgor
 // SIG // BgEEAYI3WwQCMBkGCSsGAQQBgjcUAgQMHgoAUwB1AGIA
 // SIG // QwBBMAsGA1UdDwQEAwIBhjASBgNVHRMBAf8ECDAGAQH/
 // SIG // AgEAMB8GA1UdIwQYMBaAFCleUV5krjS566ycDaeMdQHR
 // SIG // CQsoMIIBaAYDVR0fBIIBXzCCAVswggFXoIIBU6CCAU+G
 // SIG // MWh0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9wa2lpbmZy
 // SIG // YS9jcmwvYW1lcm9vdC5jcmyGI2h0dHA6Ly9jcmwyLmFt
 // SIG // ZS5nYmwvY3JsL2FtZXJvb3QuY3JshiNodHRwOi8vY3Js
 // SIG // My5hbWUuZ2JsL2NybC9hbWVyb290LmNybIYjaHR0cDov
 // SIG // L2NybDEuYW1lLmdibC9jcmwvYW1lcm9vdC5jcmyGgaps
 // SIG // ZGFwOi8vL0NOPWFtZXJvb3QsQ049QU1FUm9vdCxDTj1D
 // SIG // RFAsQ049UHVibGljJTIwS2V5JTIwU2VydmljZXMsQ049
 // SIG // U2VydmljZXMsQ049Q29uZmlndXJhdGlvbixEQz1BTUUs
 // SIG // REM9R0JMP2NlcnRpZmljYXRlUmV2b2NhdGlvbkxpc3Q/
 // SIG // YmFzZT9vYmplY3RDbGFzcz1jUkxEaXN0cmlidXRpb25Q
 // SIG // b2ludDCCAasGCCsGAQUFBwEBBIIBnTCCAZkwRwYIKwYB
 // SIG // BQUHMAKGO2h0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9w
 // SIG // a2lpbmZyYS9jZXJ0cy9BTUVSb290X2FtZXJvb3QuY3J0
 // SIG // MDcGCCsGAQUFBzAChitodHRwOi8vY3JsMi5hbWUuZ2Js
 // SIG // L2FpYS9BTUVSb290X2FtZXJvb3QuY3J0MDcGCCsGAQUF
 // SIG // BzAChitodHRwOi8vY3JsMy5hbWUuZ2JsL2FpYS9BTUVS
 // SIG // b290X2FtZXJvb3QuY3J0MDcGCCsGAQUFBzAChitodHRw
 // SIG // Oi8vY3JsMS5hbWUuZ2JsL2FpYS9BTUVSb290X2FtZXJv
 // SIG // b3QuY3J0MIGiBggrBgEFBQcwAoaBlWxkYXA6Ly8vQ049
 // SIG // YW1lcm9vdCxDTj1BSUEsQ049UHVibGljJTIwS2V5JTIw
 // SIG // U2VydmljZXMsQ049U2VydmljZXMsQ049Q29uZmlndXJh
 // SIG // dGlvbixEQz1BTUUsREM9R0JMP2NBQ2VydGlmaWNhdGU/
 // SIG // YmFzZT9vYmplY3RDbGFzcz1jZXJ0aWZpY2F0aW9uQXV0
 // SIG // aG9yaXR5MA0GCSqGSIb3DQEBCwUAA4ICAQBQECO3Tw/o
 // SIG // 317Rrd7yadqcswPx1LvIYymkaTN6KcmuRt6HKa0Xe73U
 // SIG // x2/AQ30TfgA9GBJngweRykKBusRzyOU17iIubJvy3gA2
 // SIG // 1dwtqtB0DsoEv1U/ptVu2v++doTCJ/i+GbssVXkgaX8H
 // SIG // +6EOGEmT4evp4GbwR4HwWlc+Dvf8HH8PdUA2Z04CvcwI
 // SIG // fckSipbNm84jxJ8XjmTFTWscldL9edj2NsY6iGnyJFIy
 // SIG // ur2PS7VRYyV3p1VAJp91gj1jRQtWEyCB8P5g9nE3z8u0
 // SIG // ANaU/hjwEQCrdGyravWgnf2JtG+bT26YAokbc8m+32zU
 // SIG // tXRO+NK3tAjhOu2FdsG3qNrF4sc7y37R/C+7Pcb/cFfh
 // SIG // ttqsirepZii4xStcjMODYuXzGm3IJs0b0owHG6oKd7ZO
 // SIG // GvHpmmh9K8/DLriD/sq8bURD10qi/wuW8zM7IpLg1vcR
 // SIG // 9dIK2mc0pj44pc6UX0XbttP/VEJgu3lT2eI9VjWtaKjx
 // SIG // 38xE9woSMyekPRtzTwgfuysF9DkJisr+yA4po/FPxpbB
 // SIG // w9c/hBf32DH/GFxteS2pmjgKIbMP8sDukmEq3lVvuWNJ
 // SIG // sybrZwQvQpvaM49fv+JKpLK5YWYEfwksYRR9wU8Hh/ID
 // SIG // 9hRCEkbUoQ2W7mMpsp2Nbp/kcn4ivfolUy3Q9Yf0scsQ
 // SIG // 6WTLYpm+AoCUJTGCGc8wghnLAgEBMFgwQTETMBEGCgmS
 // SIG // JomT8ixkARkWA0dCTDETMBEGCgmSJomT8ixkARkWA0FN
 // SIG // RTEVMBMGA1UEAxMMQU1FIENTIENBIDAxAhM2AAAB33OB
 // SIG // lxa+Mv0NAAIAAAHfMA0GCWCGSAFlAwQCAQUAoIGuMBkG
 // SIG // CSqGSIb3DQEJAzEMBgorBgEEAYI3AgEEMBwGCisGAQQB
 // SIG // gjcCAQsxDjAMBgorBgEEAYI3AgEVMC8GCSqGSIb3DQEJ
 // SIG // BDEiBCCer3r1vfNnR/zZ+B4+vdKNmsF/RaLwn86Mpr1z
 // SIG // mSD6aDBCBgorBgEEAYI3AgEMMTQwMqAUgBIATQBpAGMA
 // SIG // cgBvAHMAbwBmAHShGoAYaHR0cDovL3d3dy5taWNyb3Nv
 // SIG // ZnQuY29tMA0GCSqGSIb3DQEBAQUABIIBAAbc/k6jSUOa
 // SIG // CnAlkbT7043MLWIsix6cKZQFwZRuTPMcSBoEoOtz1gKX
 // SIG // gUR3TdPkT6IpjuDCIHr39ixLY2JfHvpbnjHWyKpcvaPi
 // SIG // 8vGRBP1UXXTFwNmkk8jP8pmL4A6wtegm+VzrDekWQHAH
 // SIG // kPZloumfeYSv+qJKAk4HlhOlKUXdA2mBw1Eu9mUNl4Xt
 // SIG // Si4Qu7vintSrJeLDyT4q+qZdqyy8Q/ziA/kDV/nVNACk
 // SIG // pHoU8gnTzrK3g7OT9UHw/cUUyMkp41WODs0+Sys+EEop
 // SIG // qVsqLpVOB08uumRq2B90r/Ir1yI0/RsKfgaLM0s/ZsZI
 // SIG // TRl3NQ+Y3+hMWZz6+nQnkXOhgheXMIIXkwYKKwYBBAGC
 // SIG // NwMDATGCF4Mwghd/BgkqhkiG9w0BBwKgghdwMIIXbAIB
 // SIG // AzEPMA0GCWCGSAFlAwQCAQUAMIIBUgYLKoZIhvcNAQkQ
 // SIG // AQSgggFBBIIBPTCCATkCAQEGCisGAQQBhFkKAwEwMTAN
 // SIG // BglghkgBZQMEAgEFAAQg4F2B7VzFdqdHHaCeSm3985Ji
 // SIG // KquTuJ0BWafHLn++Jz0CBmX8aMlS0xgTMjAyNDA0MDEw
 // SIG // ODM3MjUuODA1WjAEgAIB9KCB0aSBzjCByzELMAkGA1UE
 // SIG // BhMCVVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNV
 // SIG // BAcTB1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBD
 // SIG // b3Jwb3JhdGlvbjElMCMGA1UECxMcTWljcm9zb2Z0IEFt
 // SIG // ZXJpY2EgT3BlcmF0aW9uczEnMCUGA1UECxMeblNoaWVs
 // SIG // ZCBUU1MgRVNOOjg5MDAtMDVFMC1EOTQ3MSUwIwYDVQQD
 // SIG // ExxNaWNyb3NvZnQgVGltZS1TdGFtcCBTZXJ2aWNloIIR
 // SIG // 7TCCByAwggUIoAMCAQICEzMAAAHt4V/L1felXXMAAQAA
 // SIG // Ae0wDQYJKoZIhvcNAQELBQAwfDELMAkGA1UEBhMCVVMx
 // SIG // EzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNVBAcTB1Jl
 // SIG // ZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jwb3Jh
 // SIG // dGlvbjEmMCQGA1UEAxMdTWljcm9zb2Z0IFRpbWUtU3Rh
 // SIG // bXAgUENBIDIwMTAwHhcNMjMxMjA2MTg0NTQxWhcNMjUw
 // SIG // MzA1MTg0NTQxWjCByzELMAkGA1UEBhMCVVMxEzARBgNV
 // SIG // BAgTCldhc2hpbmd0b24xEDAOBgNVBAcTB1JlZG1vbmQx
 // SIG // HjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jwb3JhdGlvbjEl
 // SIG // MCMGA1UECxMcTWljcm9zb2Z0IEFtZXJpY2EgT3BlcmF0
 // SIG // aW9uczEnMCUGA1UECxMeblNoaWVsZCBUU1MgRVNOOjg5
 // SIG // MDAtMDVFMC1EOTQ3MSUwIwYDVQQDExxNaWNyb3NvZnQg
 // SIG // VGltZS1TdGFtcCBTZXJ2aWNlMIICIjANBgkqhkiG9w0B
 // SIG // AQEFAAOCAg8AMIICCgKCAgEAqDDCbJK66mqcnC8TwtR+
 // SIG // 8w+4PPDaWxGkOko3EyEW8wlcmEDbM/E2i9aahUxADy9V
 // SIG // +6Iy+PxGhFvlIzambP2sjMluGCKRT2T9seBQTFQnXbHh
 // SIG // dovmjDIwx4tC3E0GcTNrN5hTKwmQFkny2F2AyIphQc/I
 // SIG // 9KC1hst1YC5gUyjOMS6r+w2VM/AdkqAJmxLaetp4EpdI
 // SIG // TqDe90hcBPmNuErxkDFocpKRvr1w8HKVr8A3vk4J6y0e
 // SIG // wE0RVzeSUtunZtssukmBTEWJzBN3TBwkP1ECEEDQvJy5
 // SIG // iL3SpAKFhDF7SbBhKN0KzNktkgb+D6R0c0bpM07T/lAH
 // SIG // HhsTPScq8FED+TghJlumHIRMkQ0sD+IVPX+wdAModeD8
 // SIG // PbyaO43sDY3jDyJJp3si0otK7r9qMf8URrXCfcgTQuQW
 // SIG // kZLY8+7LT2qI0fjwwNn7gbQqPMSpZLed5lG+wGPgmRx6
 // SIG // oS5u+qXTBegR79k78JVQXkETdtl42lVUcAoI4CZzXsLe
 // SIG // z3o3K6VJ9Khy4C6vtQTdQ82LpFpE6+8E9M5dIl6/jbal
 // SIG // JFkjp1kX3vDdtbQerr91ZFvJxXQobW22Wc9uKXi7SRGb
 // SIG // jazfF3/T0zzM2VwyQSNRHIkf/dUHBqGRZlWxVW9q1CAL
 // SIG // NNfmZHsL24ZhlQ3n1/aGRuPyuIBlLE701vq9SWTMVE9j
 // SIG // MKkCAwEAAaOCAUkwggFFMB0GA1UdDgQWBBTOG/Ds994Q
 // SIG // KgRHypQGX9DSoeAiGTAfBgNVHSMEGDAWgBSfpxVdAF5i
 // SIG // XYP05dJlpxtTNRnpcjBfBgNVHR8EWDBWMFSgUqBQhk5o
 // SIG // dHRwOi8vd3d3Lm1pY3Jvc29mdC5jb20vcGtpb3BzL2Ny
 // SIG // bC9NaWNyb3NvZnQlMjBUaW1lLVN0YW1wJTIwUENBJTIw
 // SIG // MjAxMCgxKS5jcmwwbAYIKwYBBQUHAQEEYDBeMFwGCCsG
 // SIG // AQUFBzAChlBodHRwOi8vd3d3Lm1pY3Jvc29mdC5jb20v
 // SIG // cGtpb3BzL2NlcnRzL01pY3Jvc29mdCUyMFRpbWUtU3Rh
 // SIG // bXAlMjBQQ0ElMjAyMDEwKDEpLmNydDAMBgNVHRMBAf8E
 // SIG // AjAAMBYGA1UdJQEB/wQMMAoGCCsGAQUFBwMIMA4GA1Ud
 // SIG // DwEB/wQEAwIHgDANBgkqhkiG9w0BAQsFAAOCAgEAndYC
 // SIG // tkXfnhi9Hh4vohOv6g2PLG27DuHpmp3KeijzfsauWQGr
 // SIG // YgUeI5kUYZvvVYpNBaNAy1ovzdvGxSO3V2MNPad7woqW
 // SIG // 48uBKIn5tDbne/+FN9Ivfu0b1u1zkN68d+/lO76vZZOs
 // SIG // mKRgjadI5SdfPPwrkT4KiZ36uRHXmnx9gKBuOoSlk3ge
 // SIG // w7l2rBrerKSTnpxnnUq3t+DFmankyENK2jiLWZxbhg8u
 // SIG // PsaA9akc9kFvrtoAh2hvAEI4WFDOLk4vbepLbY+nO12p
 // SIG // q9s61rnHg4c+7Ci7bS0ye8LOWKwNiPHE5WzAH9iltBlY
 // SIG // ym2Bnfi2RnbhCu/+37OBlJDKnOdRbDXRtZ/s4HO8x7tq
 // SIG // BhnggYOLPGUdGRcse47IJvbEhQikOQrGwL5a/+tDXZOU
 // SIG // 3jEfCbNpDVInLtgqmdN/N907L04JO4g9Si4H0tehxL4z
 // SIG // epuFSiSoIyeziSc2m7UuCUIFJyayGX8qLJOA9fK2Z4va
 // SIG // VMDdN1oE5nddFk8ImTruIPFJ+oinDzGP4hak7uJ7ZMxV
 // SIG // MQQaWxRupNQiDWZqIqxFpgrRt5cmdiHXZo7SHn05CLxl
 // SIG // m+Ccc8+5dpvxNpBjosQyR7GoWVZsLKDb4cuZLv4p1Pvn
 // SIG // Vx88PoZb6k0hU/PayBVYXJrFjwyTzUUkqTIaCd91dmWv
 // SIG // 5ZCnG5FDNEm0IEvarHcwggdxMIIFWaADAgECAhMzAAAA
 // SIG // FcXna54Cm0mZAAAAAAAVMA0GCSqGSIb3DQEBCwUAMIGI
 // SIG // MQswCQYDVQQGEwJVUzETMBEGA1UECBMKV2FzaGluZ3Rv
 // SIG // bjEQMA4GA1UEBxMHUmVkbW9uZDEeMBwGA1UEChMVTWlj
 // SIG // cm9zb2Z0IENvcnBvcmF0aW9uMTIwMAYDVQQDEylNaWNy
 // SIG // b3NvZnQgUm9vdCBDZXJ0aWZpY2F0ZSBBdXRob3JpdHkg
 // SIG // MjAxMDAeFw0yMTA5MzAxODIyMjVaFw0zMDA5MzAxODMy
 // SIG // MjVaMHwxCzAJBgNVBAYTAlVTMRMwEQYDVQQIEwpXYXNo
 // SIG // aW5ndG9uMRAwDgYDVQQHEwdSZWRtb25kMR4wHAYDVQQK
 // SIG // ExVNaWNyb3NvZnQgQ29ycG9yYXRpb24xJjAkBgNVBAMT
 // SIG // HU1pY3Jvc29mdCBUaW1lLVN0YW1wIFBDQSAyMDEwMIIC
 // SIG // IjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA5OGm
 // SIG // TOe0ciELeaLL1yR5vQ7VgtP97pwHB9KpbE51yMo1V/YB
 // SIG // f2xK4OK9uT4XYDP/XE/HZveVU3Fa4n5KWv64NmeFRiMM
 // SIG // tY0Tz3cywBAY6GB9alKDRLemjkZrBxTzxXb1hlDcwUTI
 // SIG // cVxRMTegCjhuje3XD9gmU3w5YQJ6xKr9cmmvHaus9ja+
 // SIG // NSZk2pg7uhp7M62AW36MEBydUv626GIl3GoPz130/o5T
 // SIG // z9bshVZN7928jaTjkY+yOSxRnOlwaQ3KNi1wjjHINSi9
 // SIG // 47SHJMPgyY9+tVSP3PoFVZhtaDuaRr3tpK56KTesy+uD
 // SIG // RedGbsoy1cCGMFxPLOJiss254o2I5JasAUq7vnGpF1tn
 // SIG // YN74kpEeHT39IM9zfUGaRnXNxF803RKJ1v2lIH1+/Nme
 // SIG // Rd+2ci/bfV+AutuqfjbsNkz2K26oElHovwUDo9Fzpk03
 // SIG // dJQcNIIP8BDyt0cY7afomXw/TNuvXsLz1dhzPUNOwTM5
 // SIG // TI4CvEJoLhDqhFFG4tG9ahhaYQFzymeiXtcodgLiMxhy
 // SIG // 16cg8ML6EgrXY28MyTZki1ugpoMhXV8wdJGUlNi5UPkL
 // SIG // iWHzNgY1GIRH29wb0f2y1BzFa/ZcUlFdEtsluq9QBXps
 // SIG // xREdcu+N+VLEhReTwDwV2xo3xwgVGD94q0W29R6HXtqP
 // SIG // nhZyacaue7e3PmriLq0CAwEAAaOCAd0wggHZMBIGCSsG
 // SIG // AQQBgjcVAQQFAgMBAAEwIwYJKwYBBAGCNxUCBBYEFCqn
 // SIG // Uv5kxJq+gpE8RjUpzxD/LwTuMB0GA1UdDgQWBBSfpxVd
 // SIG // AF5iXYP05dJlpxtTNRnpcjBcBgNVHSAEVTBTMFEGDCsG
 // SIG // AQQBgjdMg30BATBBMD8GCCsGAQUFBwIBFjNodHRwOi8v
 // SIG // d3d3Lm1pY3Jvc29mdC5jb20vcGtpb3BzL0RvY3MvUmVw
 // SIG // b3NpdG9yeS5odG0wEwYDVR0lBAwwCgYIKwYBBQUHAwgw
 // SIG // GQYJKwYBBAGCNxQCBAweCgBTAHUAYgBDAEEwCwYDVR0P
 // SIG // BAQDAgGGMA8GA1UdEwEB/wQFMAMBAf8wHwYDVR0jBBgw
 // SIG // FoAU1fZWy4/oolxiaNE9lJBb186aGMQwVgYDVR0fBE8w
 // SIG // TTBLoEmgR4ZFaHR0cDovL2NybC5taWNyb3NvZnQuY29t
 // SIG // L3BraS9jcmwvcHJvZHVjdHMvTWljUm9vQ2VyQXV0XzIw
 // SIG // MTAtMDYtMjMuY3JsMFoGCCsGAQUFBwEBBE4wTDBKBggr
 // SIG // BgEFBQcwAoY+aHR0cDovL3d3dy5taWNyb3NvZnQuY29t
 // SIG // L3BraS9jZXJ0cy9NaWNSb29DZXJBdXRfMjAxMC0wNi0y
 // SIG // My5jcnQwDQYJKoZIhvcNAQELBQADggIBAJ1VffwqreEs
 // SIG // H2cBMSRb4Z5yS/ypb+pcFLY+TkdkeLEGk5c9MTO1OdfC
 // SIG // cTY/2mRsfNB1OW27DzHkwo/7bNGhlBgi7ulmZzpTTd2Y
 // SIG // urYeeNg2LpypglYAA7AFvonoaeC6Ce5732pvvinLbtg/
 // SIG // SHUB2RjebYIM9W0jVOR4U3UkV7ndn/OOPcbzaN9l9qRW
 // SIG // qveVtihVJ9AkvUCgvxm2EhIRXT0n4ECWOKz3+SmJw7wX
 // SIG // sFSFQrP8DJ6LGYnn8AtqgcKBGUIZUnWKNsIdw2FzLixr
 // SIG // e24/LAl4FOmRsqlb30mjdAy87JGA0j3mSj5mO0+7hvoy
 // SIG // GtmW9I/2kQH2zsZ0/fZMcm8Qq3UwxTSwethQ/gpY3UA8
 // SIG // x1RtnWN0SCyxTkctwRQEcb9k+SS+c23Kjgm9swFXSVRk
 // SIG // 2XPXfx5bRAGOWhmRaw2fpCjcZxkoJLo4S5pu+yFUa2pF
 // SIG // EUep8beuyOiJXk+d0tBMdrVXVAmxaQFEfnyhYWxz/gq7
 // SIG // 7EFmPWn9y8FBSX5+k77L+DvktxW/tM4+pTFRhLy/AsGC
 // SIG // onsXHRWJjXD+57XQKBqJC4822rpM+Zv/Cuk0+CQ1Zyvg
 // SIG // DbjmjJnW4SLq8CdCPSWU5nR0W2rRnj7tfqAxM328y+l7
 // SIG // vzhwRNGQ8cirOoo6CGJ/2XBjU02N7oJtpQUQwXEGahC0
 // SIG // HVUzWLOhcGbyoYIDUDCCAjgCAQEwgfmhgdGkgc4wgcsx
 // SIG // CzAJBgNVBAYTAlVTMRMwEQYDVQQIEwpXYXNoaW5ndG9u
 // SIG // MRAwDgYDVQQHEwdSZWRtb25kMR4wHAYDVQQKExVNaWNy
 // SIG // b3NvZnQgQ29ycG9yYXRpb24xJTAjBgNVBAsTHE1pY3Jv
 // SIG // c29mdCBBbWVyaWNhIE9wZXJhdGlvbnMxJzAlBgNVBAsT
 // SIG // Hm5TaGllbGQgVFNTIEVTTjo4OTAwLTA1RTAtRDk0NzEl
 // SIG // MCMGA1UEAxMcTWljcm9zb2Z0IFRpbWUtU3RhbXAgU2Vy
 // SIG // dmljZaIjCgEBMAcGBSsOAwIaAxUA7h2sikwmmLGMSYfq
 // SIG // Fk8erlTxcPmggYMwgYCkfjB8MQswCQYDVQQGEwJVUzET
 // SIG // MBEGA1UECBMKV2FzaGluZ3RvbjEQMA4GA1UEBxMHUmVk
 // SIG // bW9uZDEeMBwGA1UEChMVTWljcm9zb2Z0IENvcnBvcmF0
 // SIG // aW9uMSYwJAYDVQQDEx1NaWNyb3NvZnQgVGltZS1TdGFt
 // SIG // cCBQQ0EgMjAxMDANBgkqhkiG9w0BAQsFAAIFAOm0vjYw
 // SIG // IhgPMjAyNDA0MDEwNTAxNDJaGA8yMDI0MDQwMjA1MDE0
 // SIG // MlowdzA9BgorBgEEAYRZCgQBMS8wLTAKAgUA6bS+NgIB
 // SIG // ADAKAgEAAgIsswIB/zAHAgEAAgIUQDAKAgUA6bYPtgIB
 // SIG // ADA2BgorBgEEAYRZCgQCMSgwJjAMBgorBgEEAYRZCgMC
 // SIG // oAowCAIBAAIDB6EgoQowCAIBAAIDAYagMA0GCSqGSIb3
 // SIG // DQEBCwUAA4IBAQBtpH28I0HEsrGQSvPkm0PmZm2mUIez
 // SIG // RxyXL36HnWFAKO4yFNmNYv6I0+y3W+CVKZl23k7c7Rgf
 // SIG // CBE/TZ4VSevIr5oGz/WyShvDRvXuky2fPxrOAbMgdXu7
 // SIG // 3WfbE/MefrkonnKDzHITdkUJUO2bvS9HCPA6DNOBDd68
 // SIG // UYo65CEnFDhhOinGhshJ9CVu/25IPrpmsfLvvpLTJyID
 // SIG // osRsaOH8aQZ4Ar0RSf80qLs/TlhV6qHoKfCbAdExxuFb
 // SIG // ZXyJLIEzf2RAiR56X1wqjJHtp0KjBODMk+acuXQ40NrZ
 // SIG // 7KZxYxtprndybh64jY4HZOGH0lQG8WAdDa9L39zaXNb5
 // SIG // HKt+MYIEDTCCBAkCAQEwgZMwfDELMAkGA1UEBhMCVVMx
 // SIG // EzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNVBAcTB1Jl
 // SIG // ZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jwb3Jh
 // SIG // dGlvbjEmMCQGA1UEAxMdTWljcm9zb2Z0IFRpbWUtU3Rh
 // SIG // bXAgUENBIDIwMTACEzMAAAHt4V/L1felXXMAAQAAAe0w
 // SIG // DQYJYIZIAWUDBAIBBQCgggFKMBoGCSqGSIb3DQEJAzEN
 // SIG // BgsqhkiG9w0BCRABBDAvBgkqhkiG9w0BCQQxIgQgMdPQ
 // SIG // R1PfELC+JLGZhaxfN5qA7KjhCJxmivM0F7TeHYgwgfoG
 // SIG // CyqGSIb3DQEJEAIvMYHqMIHnMIHkMIG9BCCNLg1oNAhb
 // SIG // HisStwNepdcKyMK7Eg612esUn9BeMWzKOTCBmDCBgKR+
 // SIG // MHwxCzAJBgNVBAYTAlVTMRMwEQYDVQQIEwpXYXNoaW5n
 // SIG // dG9uMRAwDgYDVQQHEwdSZWRtb25kMR4wHAYDVQQKExVN
 // SIG // aWNyb3NvZnQgQ29ycG9yYXRpb24xJjAkBgNVBAMTHU1p
 // SIG // Y3Jvc29mdCBUaW1lLVN0YW1wIFBDQSAyMDEwAhMzAAAB
 // SIG // 7eFfy9X3pV1zAAEAAAHtMCIEILPtHAVJ5UwJmHojQs2S
 // SIG // iJK33qNMza5IfJmPliDvzAQKMA0GCSqGSIb3DQEBCwUA
 // SIG // BIICAI8DvyPx796H8Sv1YHRhYJAF9U+v5+w0Wq9nqnPW
 // SIG // iFYC/Y7AeleAFrvPElRENZtr9dikp+my9wXVYs3JCu+w
 // SIG // o+YU4AjPZUlmAo6Bpb9wHd7SxqpMc7gcIZXGWPztkQ/j
 // SIG // cEZmDoXsFsb5QVMyGOGKMJW7/XF/fAiWeNruxgiIWg/v
 // SIG // KPEvahGbOYutXZSj5dinZwGPHqzf6py92HWOv/aBD4pX
 // SIG // UXV6JI0r+8VFwe09kFOBjB2dfWMoZX2MX9HzHF1esVxZ
 // SIG // pFjwc5sqeHP/+aNSzTlwTjmVh0JLCmTK/wm41nue5/FX
 // SIG // 07LnW48Qjj47yCA22QRoO0o1zKHtkXXC0qdi7BSirRgm
 // SIG // 8fk+Z6oMAHPoXAIGyPBOmnH1j24OBiIP/UBJlg65lbel
 // SIG // wRx/SP79+TuDckaG7PrTbkOchY0ONm4Xxm/QsOFoa85d
 // SIG // IeO/1ouwoJGBiTw2hrj/eCwPvhdWrZEsWQeDmyhOICcI
 // SIG // +dotONu3FLQzq7ZZyB739Jll4LOTFBz4NE3NtBq+oHtj
 // SIG // WbpbC36OYhSiLdUwgIyyx+po1/s7qoBYGq3gOwjlm06f
 // SIG // Fdmovun/1MU9+JMxZtmgfjFdl1HVQmhW6lIaSY57FNjD
 // SIG // KDCJ9vOtj9y1LifkOUZroSV26VRU6Vr3HhvsdIv5uz6B
 // SIG // QP02Ut7WoLN4M4A2X98JYZq7WSpm
 // SIG // End signature block

});

parcelRegister("bHFuk", function(module, exports) {



!function(t, a) {
    module.exports = a((parcelRequire("dvPqk")), (parcelRequire("jBO4C")), (parcelRequire("3bj33")));
}(self, (t, a, e)=>(()=>{
        var r = {
            149: function(t) {
                var a;
                a = ()=>(()=>{
                        var t = [
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.TextAlignment = a.CommonErrorCodes = a.BookmarksPlayMode = a.ExportDataType = a.QnaMode = a.PageNavigationPosition = a.BrowserPrintAdjustmentsMode = a.AggregateFunction = a.DataCacheMode = a.CredentialType = a.isPercentOfGrandTotal = a.isColumnAggr = a.isHierarchyLevelAggr = a.isHierarchyLevel = a.isColumn = a.isMeasure = a.getFilterType = a.isBasicFilterWithKeys = a.isFilterKeyColumnsTarget = a.HierarchyFilter = a.AdvancedFilter = a.TupleFilter = a.IdentityFilter = a.BasicFilterWithKeys = a.BasicFilter = a.RelativeTimeFilter = a.RelativeDateFilter = a.TopNFilter = a.IncludeExcludeFilter = a.NotSupportedFilter = a.Filter = a.RelativeDateOperators = a.RelativeDateFilterTimeUnit = a.FilterType = a.FiltersLevel = a.FiltersOperations = a.MenuLocation = a.ContrastMode = a.TokenType = a.ViewMode = a.Permissions = a.SectionVisibility = a.ReportAlignment = a.HyperlinkClickBehavior = a.LayoutType = a.VisualContainerDisplayMode = a.BackgroundType = a.DisplayOption = a.PageSizeType = a.TraceType = void 0, a.validateVisualHeader = a.validateExportDataRequest = a.validateQnaInterpretInputData = a.validateLoadQnaConfiguration = a.validateSaveAsParameters = a.validateUpdateFiltersRequest = a.validateFilter = a.validatePage = a.validateTileLoad = a.validateDashboardLoad = a.validateQuickCreate = a.validateCreateReport = a.validatePaginatedReportLoad = a.validateReportLoad = a.validateMenuGroupExtension = a.validateExtension = a.validateCustomPageSize = a.validateVisualizationsPane = a.validateSyncSlicersPane = a.validateSelectionPane = a.validatePageNavigationPane = a.validateFieldsPane = a.validateFiltersPane = a.validateBookmarksPane = a.validatePanes = a.validateSettings = a.validateCaptureBookmarkRequest = a.validateApplyBookmarkStateRequest = a.validateApplyBookmarkByNameRequest = a.validateAddBookmarkRequest = a.validatePlayBookmarkRequest = a.validateSlicerState = a.validateSlicer = a.validateVisualSelector = a.isIExtensionArray = a.isIExtensions = a.isGroupedMenuExtension = a.isFlatMenuExtension = a.isReportFiltersArray = a.isOnLoadFilters = a.VisualDataRoleKindPreference = a.VisualDataRoleKind = a.CommandDisplayOption = a.SlicerTargetSelector = a.VisualTypeSelector = a.VisualSelector = a.PageSelector = a.Selector = a.SortDirection = a.LegendPosition = void 0, a.validatePrintSettings = a.validateZoomLevel = a.validateCustomTheme = a.validateCommandsSettings = a.validateVisualSettings = void 0;
                                var o, l, n, d, s, u, p, c, f, V, v, y, h, m, g, w, b, O, _, S = e(1);
                                (_ = a.TraceType || (a.TraceType = {}))[_.Information = 0] = "Information", _[_.Verbose = 1] = "Verbose", _[_.Warning = 2] = "Warning", _[_.Error = 3] = "Error", _[_.ExpectedError = 4] = "ExpectedError", _[_.UnexpectedError = 5] = "UnexpectedError", _[_.Fatal = 6] = "Fatal", (O = a.PageSizeType || (a.PageSizeType = {}))[O.Widescreen = 0] = "Widescreen", O[O.Standard = 1] = "Standard", O[O.Cortana = 2] = "Cortana", O[O.Letter = 3] = "Letter", O[O.Custom = 4] = "Custom", O[O.Mobile = 5] = "Mobile", (b = a.DisplayOption || (a.DisplayOption = {}))[b.FitToPage = 0] = "FitToPage", b[b.FitToWidth = 1] = "FitToWidth", b[b.ActualSize = 2] = "ActualSize", (w = a.BackgroundType || (a.BackgroundType = {}))[w.Default = 0] = "Default", w[w.Transparent = 1] = "Transparent", (g = a.VisualContainerDisplayMode || (a.VisualContainerDisplayMode = {}))[g.Visible = 0] = "Visible", g[g.Hidden = 1] = "Hidden", (m = a.LayoutType || (a.LayoutType = {}))[m.Master = 0] = "Master", m[m.Custom = 1] = "Custom", m[m.MobilePortrait = 2] = "MobilePortrait", m[m.MobileLandscape = 3] = "MobileLandscape", (h = a.HyperlinkClickBehavior || (a.HyperlinkClickBehavior = {}))[h.Navigate = 0] = "Navigate", h[h.NavigateAndRaiseEvent = 1] = "NavigateAndRaiseEvent", h[h.RaiseEvent = 2] = "RaiseEvent", (y = a.ReportAlignment || (a.ReportAlignment = {}))[y.Left = 0] = "Left", y[y.Center = 1] = "Center", y[y.Right = 2] = "Right", y[y.None = 3] = "None", (v = a.SectionVisibility || (a.SectionVisibility = {}))[v.AlwaysVisible = 0] = "AlwaysVisible", v[v.HiddenInViewMode = 1] = "HiddenInViewMode", (V = a.Permissions || (a.Permissions = {}))[V.Read = 0] = "Read", V[V.ReadWrite = 1] = "ReadWrite", V[V.Copy = 2] = "Copy", V[V.Create = 4] = "Create", V[V.All = 7] = "All", (f = a.ViewMode || (a.ViewMode = {}))[f.View = 0] = "View", f[f.Edit = 1] = "Edit", (c = a.TokenType || (a.TokenType = {}))[c.Aad = 0] = "Aad", c[c.Embed = 1] = "Embed", (p = a.ContrastMode || (a.ContrastMode = {}))[p.None = 0] = "None", p[p.HighContrast1 = 1] = "HighContrast1", p[p.HighContrast2 = 2] = "HighContrast2", p[p.HighContrastBlack = 3] = "HighContrastBlack", p[p.HighContrastWhite = 4] = "HighContrastWhite", (u = a.MenuLocation || (a.MenuLocation = {}))[u.Bottom = 0] = "Bottom", u[u.Top = 1] = "Top", (s = a.FiltersOperations || (a.FiltersOperations = {}))[s.RemoveAll = 0] = "RemoveAll", s[s.ReplaceAll = 1] = "ReplaceAll", s[s.Add = 2] = "Add", s[s.Replace = 3] = "Replace", (d = a.FiltersLevel || (a.FiltersLevel = {}))[d.Report = 0] = "Report", d[d.Page = 1] = "Page", d[d.Visual = 2] = "Visual", function(t) {
                                    t[t.Advanced = 0] = "Advanced", t[t.Basic = 1] = "Basic", t[t.Unknown = 2] = "Unknown", t[t.IncludeExclude = 3] = "IncludeExclude", t[t.RelativeDate = 4] = "RelativeDate", t[t.TopN = 5] = "TopN", t[t.Tuple = 6] = "Tuple", t[t.RelativeTime = 7] = "RelativeTime", t[t.Identity = 8] = "Identity", t[t.Hierarchy = 9] = "Hierarchy";
                                }(o = a.FilterType || (a.FilterType = {})), (n = a.RelativeDateFilterTimeUnit || (a.RelativeDateFilterTimeUnit = {}))[n.Days = 0] = "Days", n[n.Weeks = 1] = "Weeks", n[n.CalendarWeeks = 2] = "CalendarWeeks", n[n.Months = 3] = "Months", n[n.CalendarMonths = 4] = "CalendarMonths", n[n.Years = 5] = "Years", n[n.CalendarYears = 6] = "CalendarYears", n[n.Minutes = 7] = "Minutes", n[n.Hours = 8] = "Hours", (l = a.RelativeDateOperators || (a.RelativeDateOperators = {}))[l.InLast = 0] = "InLast", l[l.InThis = 1] = "InThis", l[l.InNext = 2] = "InNext";
                                var F = function() {
                                    function t(t, a) {
                                        this.target = t, this.filterType = a;
                                    }
                                    return t.prototype.toJSON = function() {
                                        var t = {
                                            $schema: this.schemaUrl,
                                            target: this.target,
                                            filterType: this.filterType
                                        };
                                        return void 0 !== this.displaySettings && (t.displaySettings = this.displaySettings), t;
                                    }, t;
                                }();
                                a.Filter = F;
                                var T = function(t) {
                                    function a(e, r, i) {
                                        var l = t.call(this, e, o.Unknown) || this;
                                        return l.message = r, l.notSupportedTypeName = i, l.schemaUrl = a.schemaUrl, l;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.message = this.message, a.notSupportedTypeName = this.notSupportedTypeName, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#notSupported", a;
                                }(F);
                                a.NotSupportedFilter = T;
                                var P = function(t) {
                                    function a(e, r, i) {
                                        var l = t.call(this, e, o.IncludeExclude) || this;
                                        return l.values = i, l.isExclude = r, l.schemaUrl = a.schemaUrl, l;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.isExclude = this.isExclude, a.values = this.values, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#includeExclude", a;
                                }(F);
                                a.IncludeExcludeFilter = P;
                                var C = function(t) {
                                    function a(e, r, i, l) {
                                        var n = t.call(this, e, o.TopN) || this;
                                        return n.operator = r, n.itemCount = i, n.schemaUrl = a.schemaUrl, n.orderBy = l, n;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.operator = this.operator, a.itemCount = this.itemCount, a.orderBy = this.orderBy, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#topN", a;
                                }(F);
                                a.TopNFilter = C;
                                var R = function(t) {
                                    function a(e, r, i, l, n) {
                                        var d = t.call(this, e, o.RelativeDate) || this;
                                        return d.operator = r, d.timeUnitsCount = i, d.timeUnitType = l, d.includeToday = n, d.schemaUrl = a.schemaUrl, d;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.operator = this.operator, a.timeUnitsCount = this.timeUnitsCount, a.timeUnitType = this.timeUnitType, a.includeToday = this.includeToday, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#relativeDate", a;
                                }(F);
                                a.RelativeDateFilter = R;
                                var k = function(t) {
                                    function a(e, r, i, l) {
                                        var n = t.call(this, e, o.RelativeTime) || this;
                                        return n.operator = r, n.timeUnitsCount = i, n.timeUnitType = l, n.schemaUrl = a.schemaUrl, n;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.operator = this.operator, a.timeUnitsCount = this.timeUnitsCount, a.timeUnitType = this.timeUnitType, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#relativeTime", a;
                                }(F);
                                a.RelativeTimeFilter = k;
                                var M = function(t) {
                                    function a(e, r) {
                                        for(var i = [], l = 2; l < arguments.length; l++)i[l - 2] = arguments[l];
                                        var n = t.call(this, e, o.Basic) || this;
                                        if (n.operator = r, n.schemaUrl = a.schemaUrl, 0 === i.length && "All" !== r) throw new Error('values must be a non-empty array unless your operator is "All".');
                                        return Array.isArray(i[0]) ? n.values = i[0] : n.values = i, n;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.operator = this.operator, a.values = this.values, a.requireSingleSelection = !!this.requireSingleSelection, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#basic", a;
                                }(F);
                                a.BasicFilter = M;
                                var A = function(t) {
                                    function a(a, e, r, i) {
                                        var o = t.call(this, a, e, r) || this;
                                        o.keyValues = i, o.target = a;
                                        var l = a.keys ? a.keys.length : 0;
                                        if (l > 0 && !i) throw new Error("You should pass the values to be filtered for each key. You passed: no values and ".concat(l, " keys"));
                                        if (0 === l && i && i.length > 0) throw new Error("You passed key values but your target object doesn't contain the keys to be filtered");
                                        for(var n = 0, d = o.keyValues; n < d.length; n++){
                                            var s = d[n];
                                            if (s) {
                                                var u = s.length;
                                                if (u !== l) throw new Error("Each tuple of key values should contain a value for each of the keys. You passed: ".concat(u, " values and ").concat(l, " keys"));
                                            }
                                        }
                                        return o;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.keyValues = this.keyValues, a;
                                    }, a;
                                }(M);
                                a.BasicFilterWithKeys = A;
                                var j = function(t) {
                                    function a(e, r) {
                                        var i = t.call(this, e, o.Identity) || this;
                                        return i.operator = r, i.schemaUrl = a.schemaUrl, i;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.operator = this.operator, a.target = this.target, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#identity", a;
                                }(F);
                                a.IdentityFilter = j;
                                var E = function(t) {
                                    function a(e, r, i) {
                                        var l = t.call(this, e, o.Tuple) || this;
                                        return l.operator = r, l.schemaUrl = a.schemaUrl, l.values = i, l;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.operator = this.operator, a.values = this.values, a.target = this.target, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#tuple", a;
                                }(F);
                                a.TupleFilter = E;
                                var x = function(t) {
                                    function a(e, r) {
                                        for(var i = [], l = 2; l < arguments.length; l++)i[l - 2] = arguments[l];
                                        var n, d = t.call(this, e, o.Advanced) || this;
                                        if (d.schemaUrl = a.schemaUrl, "string" != typeof r || 0 === r.length) throw new Error("logicalOperator must be a valid operator, You passed: ".concat(r));
                                        if (d.logicalOperator = r, (n = Array.isArray(i[0]) ? i[0] : i).length > 2) throw new Error("AdvancedFilters may not have more than two conditions. You passed: ".concat(i.length));
                                        if (1 === n.length && "And" !== r) throw new Error('Logical Operator must be "And" when there is only one condition provided');
                                        return d.conditions = n, d;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.logicalOperator = this.logicalOperator, a.conditions = this.conditions, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#advanced", a;
                                }(F);
                                a.AdvancedFilter = x;
                                var q, B, D, N, L, U, H, I, z, J = function(t) {
                                    function a(e, r) {
                                        var i = t.call(this, e, o.Hierarchy) || this;
                                        return i.schemaUrl = a.schemaUrl, i.hierarchyData = r, i;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.hierarchyData = this.hierarchyData, a.target = this.target, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#hierarchy", a;
                                }(F);
                                function Q(t) {
                                    if (t.filterType) return t.filterType;
                                    var a = t, e = t;
                                    return "string" == typeof a.operator && Array.isArray(a.values) ? o.Basic : "string" == typeof e.logicalOperator && Array.isArray(e.conditions) ? o.Advanced : o.Unknown;
                                }
                                function G(t) {
                                    return !(!t.table || !t.column || t.aggregationFunction);
                                }
                                a.HierarchyFilter = J, a.isFilterKeyColumnsTarget = function(t) {
                                    return G(t) && !!t.keys;
                                }, a.isBasicFilterWithKeys = function(t) {
                                    return Q(t) === o.Basic && !!t.keyValues;
                                }, a.getFilterType = Q, a.isMeasure = function(t) {
                                    return void 0 !== t.table && void 0 !== t.measure;
                                }, a.isColumn = G, a.isHierarchyLevel = function(t) {
                                    return !(!(t.table && t.hierarchy && t.hierarchyLevel) || t.aggregationFunction);
                                }, a.isHierarchyLevelAggr = function(t) {
                                    return !!(t.table && t.hierarchy && t.hierarchyLevel && t.aggregationFunction);
                                }, a.isColumnAggr = function(t) {
                                    return !!(t.table && t.column && t.aggregationFunction);
                                }, a.isPercentOfGrandTotal = function(t) {
                                    return !!t.percentOfGrandTotal;
                                }, (z = a.CredentialType || (a.CredentialType = {}))[z.NoConnection = 0] = "NoConnection", z[z.OnBehalfOf = 1] = "OnBehalfOf", z[z.Anonymous = 2] = "Anonymous", (I = a.DataCacheMode || (a.DataCacheMode = {}))[I.Import = 0] = "Import", I[I.DirectQuery = 1] = "DirectQuery", (H = a.AggregateFunction || (a.AggregateFunction = {}))[H.Default = 1] = "Default", H[H.None = 2] = "None", H[H.Sum = 3] = "Sum", H[H.Min = 4] = "Min", H[H.Max = 5] = "Max", H[H.Count = 6] = "Count", H[H.Average = 7] = "Average", H[H.DistinctCount = 8] = "DistinctCount", (U = a.BrowserPrintAdjustmentsMode || (a.BrowserPrintAdjustmentsMode = {}))[U.Default = 0] = "Default", U[U.NoAdjustments = 1] = "NoAdjustments", (L = a.PageNavigationPosition || (a.PageNavigationPosition = {}))[L.Bottom = 0] = "Bottom", L[L.Left = 1] = "Left", (N = a.QnaMode || (a.QnaMode = {}))[N.Interactive = 0] = "Interactive", N[N.ResultOnly = 1] = "ResultOnly", (D = a.ExportDataType || (a.ExportDataType = {}))[D.Summarized = 0] = "Summarized", D[D.Underlying = 1] = "Underlying", (B = a.BookmarksPlayMode || (a.BookmarksPlayMode = {}))[B.Off = 0] = "Off", B[B.Presentation = 1] = "Presentation", a.CommonErrorCodes = {
                                    TokenExpired: "TokenExpired",
                                    NotFound: "PowerBIEntityNotFound",
                                    InvalidParameters: "Invalid parameters",
                                    LoadReportFailed: "LoadReportFailed",
                                    NotAuthorized: "PowerBINotAuthorizedException",
                                    FailedToLoadModel: "ExplorationContainer_FailedToLoadModel_DefaultDetails"
                                }, a.TextAlignment = {
                                    Left: "left",
                                    Center: "center",
                                    Right: "right"
                                }, a.LegendPosition = {
                                    Top: "Top",
                                    Bottom: "Bottom",
                                    Right: "Right",
                                    Left: "Left",
                                    TopCenter: "TopCenter",
                                    BottomCenter: "BottomCenter",
                                    RightCenter: "RightCenter",
                                    LeftCenter: "LeftCenter"
                                }, (q = a.SortDirection || (a.SortDirection = {}))[q.Ascending = 1] = "Ascending", q[q.Descending = 2] = "Descending";
                                var W = function() {
                                    function t(t) {
                                        this.$schema = t;
                                    }
                                    return t.prototype.toJSON = function() {
                                        return {
                                            $schema: this.$schema
                                        };
                                    }, t;
                                }();
                                a.Selector = W;
                                var K = function(t) {
                                    function a(e) {
                                        var r = t.call(this, a.schemaUrl) || this;
                                        return r.pageName = e, r;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.pageName = this.pageName, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#pageSelector", a;
                                }(W);
                                a.PageSelector = K;
                                var Y = function(t) {
                                    function a(e) {
                                        var r = t.call(this, a.schemaUrl) || this;
                                        return r.visualName = e, r;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.visualName = this.visualName, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#visualSelector", a;
                                }(W);
                                a.VisualSelector = Y;
                                var $ = function(t) {
                                    function a(a) {
                                        var e = t.call(this, Y.schemaUrl) || this;
                                        return e.visualType = a, e;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.visualType = this.visualType, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#visualTypeSelector", a;
                                }(W);
                                a.VisualTypeSelector = $;
                                var Z, X, tt, at = function(t) {
                                    function a(a) {
                                        var e = t.call(this, Y.schemaUrl) || this;
                                        return e.target = a, e;
                                    }
                                    return i(a, t), a.prototype.toJSON = function() {
                                        var a = t.prototype.toJSON.call(this);
                                        return a.target = this.target, a;
                                    }, a.schemaUrl = "http://powerbi.com/product/schema#slicerTargetSelector", a;
                                }(W);
                                function et(t) {
                                    return Array.isArray(t);
                                }
                                function rt(t) {
                                    return t && !!t.groupName;
                                }
                                function it(t) {
                                    return Array.isArray(t);
                                }
                                function ot(t) {
                                    var a = t.message;
                                    return a || (a = "".concat(t.path, " is invalid. Not meeting ").concat(t.keyword, " constraint")), {
                                        message: a
                                    };
                                }
                                a.SlicerTargetSelector = at, (tt = a.CommandDisplayOption || (a.CommandDisplayOption = {}))[tt.Enabled = 0] = "Enabled", tt[tt.Disabled = 1] = "Disabled", tt[tt.Hidden = 2] = "Hidden", (X = a.VisualDataRoleKind || (a.VisualDataRoleKind = {}))[X.Grouping = 0] = "Grouping", X[X.Measure = 1] = "Measure", X[X.GroupingOrMeasure = 2] = "GroupingOrMeasure", (Z = a.VisualDataRoleKindPreference || (a.VisualDataRoleKindPreference = {}))[Z.Measure = 0] = "Measure", Z[Z.Grouping = 1] = "Grouping", a.isOnLoadFilters = function(t) {
                                    return t && !et(t);
                                }, a.isReportFiltersArray = et, a.isFlatMenuExtension = function(t) {
                                    return t && !rt(t);
                                }, a.isGroupedMenuExtension = rt, a.isIExtensions = function(t) {
                                    return t && !it(t);
                                }, a.isIExtensionArray = it, a.validateVisualSelector = function(t) {
                                    var a = S.Validators.visualSelectorValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateSlicer = function(t) {
                                    var a = S.Validators.slicerValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateSlicerState = function(t) {
                                    var a = S.Validators.slicerStateValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validatePlayBookmarkRequest = function(t) {
                                    var a = S.Validators.playBookmarkRequestValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateAddBookmarkRequest = function(t) {
                                    var a = S.Validators.addBookmarkRequestValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateApplyBookmarkByNameRequest = function(t) {
                                    var a = S.Validators.applyBookmarkByNameRequestValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateApplyBookmarkStateRequest = function(t) {
                                    var a = S.Validators.applyBookmarkStateRequestValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateCaptureBookmarkRequest = function(t) {
                                    var a = S.Validators.captureBookmarkRequestValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateSettings = function(t) {
                                    var a = S.Validators.settingsValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validatePanes = function(t) {
                                    var a = S.Validators.reportPanesValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateBookmarksPane = function(t) {
                                    var a = S.Validators.bookmarksPaneValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateFiltersPane = function(t) {
                                    var a = S.Validators.filtersPaneValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateFieldsPane = function(t) {
                                    var a = S.Validators.fieldsPaneValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validatePageNavigationPane = function(t) {
                                    var a = S.Validators.pageNavigationPaneValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateSelectionPane = function(t) {
                                    var a = S.Validators.selectionPaneValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateSyncSlicersPane = function(t) {
                                    var a = S.Validators.syncSlicersPaneValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateVisualizationsPane = function(t) {
                                    var a = S.Validators.visualizationsPaneValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateCustomPageSize = function(t) {
                                    var a = S.Validators.customPageSizeValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateExtension = function(t) {
                                    var a = S.Validators.extensionValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateMenuGroupExtension = function(t) {
                                    var a = S.Validators.menuGroupExtensionValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateReportLoad = function(t) {
                                    var a = S.Validators.reportLoadValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validatePaginatedReportLoad = function(t) {
                                    var a = S.Validators.paginatedReportLoadValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateCreateReport = function(t) {
                                    var a = S.Validators.reportCreateValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateQuickCreate = function(t) {
                                    var a = S.Validators.quickCreateValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateDashboardLoad = function(t) {
                                    var a = S.Validators.dashboardLoadValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateTileLoad = function(t) {
                                    var a = S.Validators.tileLoadValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validatePage = function(t) {
                                    var a = S.Validators.pageValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateFilter = function(t) {
                                    var a = S.Validators.filterValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateUpdateFiltersRequest = function(t) {
                                    var a = S.Validators.updateFiltersRequestValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateSaveAsParameters = function(t) {
                                    var a = S.Validators.saveAsParametersValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateLoadQnaConfiguration = function(t) {
                                    var a = S.Validators.loadQnaValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateQnaInterpretInputData = function(t) {
                                    var a = S.Validators.qnaInterpretInputDataValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateExportDataRequest = function(t) {
                                    var a = S.Validators.exportDataRequestValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateVisualHeader = function(t) {
                                    var a = S.Validators.visualHeaderValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateVisualSettings = function(t) {
                                    var a = S.Validators.visualSettingsValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateCommandsSettings = function(t) {
                                    var a = S.Validators.commandsSettingsValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateCustomTheme = function(t) {
                                    var a = S.Validators.customThemeValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validateZoomLevel = function(t) {
                                    var a = S.Validators.zoomLevelValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                }, a.validatePrintSettings = function(t) {
                                    var a = S.Validators.printSettingsValidator.validate(t);
                                    return a ? a.map(ot) : void 0;
                                };
                            },
                            (t, a, e)=>{
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.Validators = void 0;
                                var r = e(2), i = e(5), o = e(6), l = e(7), n = e(8), d = e(9), s = e(10), u = e(11), p = e(12), c = e(13), f = e(14), V = e(15), v = e(16), y = e(17), h = e(18), m = e(19), g = e(20), w = e(21), b = e(22), O = e(23), _ = e(24), S = e(25), F = e(26), T = e(27), P = e(28), C = e(29), R = e(4), k = e(30), M = e(31), A = e(32), j = e(33);
                                a.Validators = {
                                    addBookmarkRequestValidator: new i.AddBookmarkRequestValidator,
                                    advancedFilterTypeValidator: new R.EnumValidator([
                                        0
                                    ]),
                                    advancedFilterValidator: new p.AdvancedFilterValidator,
                                    anyArrayValidator: new R.ArrayValidator([
                                        new F.AnyOfValidator([
                                            new R.StringValidator,
                                            new R.NumberValidator,
                                            new R.BooleanValidator
                                        ])
                                    ]),
                                    anyFilterValidator: new F.AnyOfValidator([
                                        new p.BasicFilterValidator,
                                        new p.AdvancedFilterValidator,
                                        new p.IncludeExcludeFilterValidator,
                                        new p.NotSupportedFilterValidator,
                                        new p.RelativeDateFilterValidator,
                                        new p.TopNFilterValidator,
                                        new p.RelativeTimeFilterValidator,
                                        new p.HierarchyFilterValidator
                                    ]),
                                    anyValueValidator: new F.AnyOfValidator([
                                        new R.StringValidator,
                                        new R.NumberValidator,
                                        new R.BooleanValidator
                                    ]),
                                    actionBarValidator: new r.ActionBarValidator,
                                    statusBarValidator: new r.StatusBarValidator,
                                    applyBookmarkByNameRequestValidator: new i.ApplyBookmarkByNameRequestValidator,
                                    applyBookmarkStateRequestValidator: new i.ApplyBookmarkStateRequestValidator,
                                    applyBookmarkValidator: new F.AnyOfValidator([
                                        new i.ApplyBookmarkByNameRequestValidator,
                                        new i.ApplyBookmarkStateRequestValidator
                                    ]),
                                    backgroundValidator: new R.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    basicFilterTypeValidator: new R.EnumValidator([
                                        1
                                    ]),
                                    basicFilterValidator: new p.BasicFilterValidator,
                                    booleanArrayValidator: new R.BooleanArrayValidator,
                                    booleanValidator: new R.BooleanValidator,
                                    bookmarksPaneValidator: new V.BookmarksPaneValidator,
                                    captureBookmarkOptionsValidator: new i.CaptureBookmarkOptionsValidator,
                                    captureBookmarkRequestValidator: new i.CaptureBookmarkRequestValidator,
                                    columnSchemaArrayValidator: new R.ArrayValidator([
                                        new M.ColumnSchemaValidator
                                    ]),
                                    commandDisplayOptionValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    commandExtensionSelectorValidator: new F.AnyOfValidator([
                                        new w.VisualSelectorValidator,
                                        new w.VisualTypeSelectorValidator
                                    ]),
                                    commandExtensionArrayValidator: new R.ArrayValidator([
                                        new u.CommandExtensionValidator
                                    ]),
                                    commandExtensionValidator: new u.CommandExtensionValidator,
                                    commandsSettingsArrayValidator: new R.ArrayValidator([
                                        new o.CommandsSettingsValidator
                                    ]),
                                    commandsSettingsValidator: new o.CommandsSettingsValidator,
                                    conditionItemValidator: new p.ConditionItemValidator,
                                    contrastModeValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ]),
                                    credentialDetailsValidator: new C.MapValidator([
                                        new R.StringValidator
                                    ], [
                                        new R.StringValidator
                                    ]),
                                    credentialsValidator: new M.CredentialsValidator,
                                    credentialTypeValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    customLayoutDisplayOptionValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    customLayoutValidator: new c.CustomLayoutValidator,
                                    customPageSizeValidator: new f.CustomPageSizeValidator,
                                    customThemeValidator: new l.CustomThemeValidator,
                                    dashboardLoadValidator: new n.DashboardLoadValidator,
                                    dataCacheModeValidator: new R.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    datasetBindingValidator: new d.DatasetBindingValidator,
                                    datasetCreateConfigValidator: new M.DatasetCreateConfigValidator,
                                    datasourceConnectionConfigValidator: new M.DatasourceConnectionConfigValidator,
                                    displayStateModeValidator: new R.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    displayStateValidator: new c.DisplayStateValidator,
                                    exportDataRequestValidator: new s.ExportDataRequestValidator,
                                    extensionArrayValidator: new R.ArrayValidator([
                                        new u.ExtensionValidator
                                    ]),
                                    extensionsValidator: new F.AnyOfValidator([
                                        new R.ArrayValidator([
                                            new u.ExtensionValidator
                                        ]),
                                        new u.ExtensionsValidator
                                    ]),
                                    extensionPointsValidator: new u.ExtensionPointsValidator,
                                    extensionValidator: new u.ExtensionValidator,
                                    fieldForbiddenValidator: new T.FieldForbiddenValidator,
                                    fieldRequiredValidator: new P.FieldRequiredValidator,
                                    fieldsPaneValidator: new V.FieldsPaneValidator,
                                    filterColumnTargetValidator: new p.FilterColumnTargetValidator,
                                    filterDisplaySettingsValidator: new p.FilterDisplaySettingsValidator,
                                    filterConditionsValidator: new R.ArrayValidator([
                                        new p.ConditionItemValidator
                                    ]),
                                    filterHierarchyTargetValidator: new p.FilterHierarchyTargetValidator,
                                    filterMeasureTargetValidator: new p.FilterMeasureTargetValidator,
                                    filterTargetValidator: new F.AnyOfValidator([
                                        new p.FilterColumnTargetValidator,
                                        new p.FilterHierarchyTargetValidator,
                                        new p.FilterMeasureTargetValidator,
                                        new R.ArrayValidator([
                                            new F.AnyOfValidator([
                                                new p.FilterColumnTargetValidator,
                                                new p.FilterHierarchyTargetValidator,
                                                new p.FilterMeasureTargetValidator,
                                                new p.FilterKeyColumnsTargetValidator,
                                                new p.FilterKeyHierarchyTargetValidator
                                            ])
                                        ])
                                    ]),
                                    filterValidator: new p.FilterValidator,
                                    filterTypeValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        9
                                    ]),
                                    filtersArrayValidator: new R.ArrayValidator([
                                        new p.FilterValidator
                                    ]),
                                    filtersOperationsUpdateValidator: new R.EnumValidator([
                                        1,
                                        2,
                                        3
                                    ]),
                                    filtersOperationsRemoveAllValidator: new R.EnumValidator([
                                        0
                                    ]),
                                    filtersPaneValidator: new V.FiltersPaneValidator,
                                    hyperlinkClickBehaviorValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    includeExcludeFilterValidator: new p.IncludeExcludeFilterValidator,
                                    includeExludeFilterTypeValidator: new R.EnumValidator([
                                        3
                                    ]),
                                    hierarchyFilterTypeValidator: new R.EnumValidator([
                                        9
                                    ]),
                                    hierarchyFilterValuesValidator: new R.ArrayValidator([
                                        new p.HierarchyFilterNodeValidator
                                    ]),
                                    layoutTypeValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3
                                    ]),
                                    loadQnaValidator: new v.LoadQnaValidator,
                                    menuExtensionValidator: new F.AnyOfValidator([
                                        new u.FlatMenuExtensionValidator,
                                        new u.GroupedMenuExtensionValidator
                                    ]),
                                    menuGroupExtensionArrayValidator: new R.ArrayValidator([
                                        new u.MenuGroupExtensionValidator
                                    ]),
                                    menuGroupExtensionValidator: new u.MenuGroupExtensionValidator,
                                    menuLocationValidator: new R.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    notSupportedFilterTypeValidator: new R.EnumValidator([
                                        2
                                    ]),
                                    notSupportedFilterValidator: new p.NotSupportedFilterValidator,
                                    numberArrayValidator: new R.NumberArrayValidator,
                                    numberValidator: new R.NumberValidator,
                                    onLoadFiltersBaseValidator: new F.AnyOfValidator([
                                        new p.OnLoadFiltersBaseValidator,
                                        new p.OnLoadFiltersBaseRemoveOperationValidator
                                    ]),
                                    pageLayoutValidator: new C.MapValidator([
                                        new R.StringValidator
                                    ], [
                                        new c.VisualLayoutValidator
                                    ]),
                                    pageNavigationPaneValidator: new V.PageNavigationPaneValidator,
                                    pageNavigationPositionValidator: new R.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    pageSizeTypeValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ]),
                                    pageSizeValidator: new f.PageSizeValidator,
                                    pageValidator: new f.PageValidator,
                                    pageViewFieldValidator: new f.PageViewFieldValidator,
                                    pagesLayoutValidator: new C.MapValidator([
                                        new R.StringValidator
                                    ], [
                                        new c.PageLayoutValidator
                                    ]),
                                    paginatedReportCommandsValidator: new o.PaginatedReportCommandsValidator,
                                    paginatedReportLoadValidator: new m.PaginatedReportLoadValidator,
                                    paginatedReportsettingsValidator: new b.PaginatedReportSettingsValidator,
                                    parameterValuesArrayValidator: new R.ArrayValidator([
                                        new m.ReportParameterFieldsValidator
                                    ]),
                                    parametersPanelValidator: new k.ParametersPanelValidator,
                                    permissionsValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        4,
                                        7
                                    ]),
                                    playBookmarkRequestValidator: new i.PlayBookmarkRequestValidator,
                                    printSettingsValidator: new j.PrintSettingsValidator,
                                    qnaInterpretInputDataValidator: new v.QnaInterpretInputDataValidator,
                                    qnaPanesValidator: new V.QnaPanesValidator,
                                    qnaSettingValidator: new v.QnaSettingsValidator,
                                    quickCreateValidator: new A.QuickCreateValidator,
                                    rawDataValidator: new R.ArrayValidator([
                                        new R.ArrayValidator([
                                            new R.StringValidator
                                        ])
                                    ]),
                                    relativeDateFilterOperatorValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2
                                    ]),
                                    relativeDateFilterTimeUnitTypeValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]),
                                    relativeDateFilterTypeValidator: new R.EnumValidator([
                                        4
                                    ]),
                                    relativeDateFilterValidator: new p.RelativeDateFilterValidator,
                                    relativeDateTimeFilterTypeValidator: new R.EnumValidator([
                                        4,
                                        7
                                    ]),
                                    relativeDateTimeFilterUnitTypeValidator: new R.EnumValidator([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]),
                                    relativeTimeFilterTimeUnitTypeValidator: new R.EnumValidator([
                                        7,
                                        8
                                    ]),
                                    relativeTimeFilterTypeValidator: new R.EnumValidator([
                                        7
                                    ]),
                                    relativeTimeFilterValidator: new p.RelativeTimeFilterValidator,
                                    reportBarsValidator: new r.ReportBarsValidator,
                                    reportCreateValidator: new y.ReportCreateValidator,
                                    reportLoadFiltersValidator: new F.AnyOfValidator([
                                        new R.ArrayValidator([
                                            new p.FilterValidator
                                        ]),
                                        new p.OnLoadFiltersValidator
                                    ]),
                                    reportLoadValidator: new h.ReportLoadValidator,
                                    reportPanesValidator: new V.ReportPanesValidator,
                                    saveAsParametersValidator: new g.SaveAsParametersValidator,
                                    selectionPaneValidator: new V.SelectionPaneValidator,
                                    settingsValidator: new b.SettingsValidator,
                                    singleCommandSettingsValidator: new o.SingleCommandSettingsValidator,
                                    slicerSelectorValidator: new F.AnyOfValidator([
                                        new w.VisualSelectorValidator,
                                        new w.SlicerTargetSelectorValidator
                                    ]),
                                    slicerStateValidator: new O.SlicerStateValidator,
                                    slicerTargetValidator: new F.AnyOfValidator([
                                        new p.FilterColumnTargetValidator,
                                        new p.FilterHierarchyTargetValidator,
                                        new p.FilterMeasureTargetValidator,
                                        new p.FilterKeyColumnsTargetValidator,
                                        new p.FilterKeyHierarchyTargetValidator
                                    ]),
                                    slicerValidator: new O.SlicerValidator,
                                    stringArrayValidator: new R.StringArrayValidator,
                                    stringValidator: new R.StringValidator,
                                    syncSlicersPaneValidator: new V.SyncSlicersPaneValidator,
                                    tableDataArrayValidator: new R.ArrayValidator([
                                        new M.TableDataValidator
                                    ]),
                                    tableSchemaListValidator: new R.ArrayValidator([
                                        new M.TableSchemaValidator
                                    ]),
                                    tileLoadValidator: new _.TileLoadValidator,
                                    tokenTypeValidator: new R.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    topNFilterTypeValidator: new R.EnumValidator([
                                        5
                                    ]),
                                    topNFilterValidator: new p.TopNFilterValidator,
                                    updateFiltersRequestValidator: new F.AnyOfValidator([
                                        new p.UpdateFiltersRequestValidator,
                                        new p.RemoveFiltersRequestValidator
                                    ]),
                                    viewModeValidator: new R.EnumValidator([
                                        0,
                                        1
                                    ]),
                                    visualCommandSelectorValidator: new F.AnyOfValidator([
                                        new w.VisualSelectorValidator,
                                        new w.VisualTypeSelectorValidator
                                    ]),
                                    visualHeaderSelectorValidator: new F.AnyOfValidator([
                                        new w.VisualSelectorValidator,
                                        new w.VisualTypeSelectorValidator
                                    ]),
                                    visualHeaderSettingsValidator: new S.VisualHeaderSettingsValidator,
                                    visualHeaderValidator: new S.VisualHeaderValidator,
                                    visualHeadersValidator: new R.ArrayValidator([
                                        new S.VisualHeaderValidator
                                    ]),
                                    visualizationsPaneValidator: new V.VisualizationsPaneValidator,
                                    visualLayoutValidator: new c.VisualLayoutValidator,
                                    visualSelectorValidator: new w.VisualSelectorValidator,
                                    visualSettingsValidator: new S.VisualSettingsValidator,
                                    visualTypeSelectorValidator: new w.VisualTypeSelectorValidator,
                                    zoomLevelValidator: new R.RangeValidator(.25, 4)
                                };
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.StatusBarValidator = a.ActionBarValidator = a.ReportBarsValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "actionBar",
                                                validators: [
                                                    n.Validators.actionBarValidator
                                                ]
                                            },
                                            {
                                                field: "statusBar",
                                                validators: [
                                                    n.Validators.statusBarValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ReportBarsValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ActionBarValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.StatusBarValidator = u;
                            },
                            (t, a)=>{
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.MultipleFieldsValidator = void 0;
                                var e = function() {
                                    function t(t) {
                                        this.fieldValidatorsPairs = t;
                                    }
                                    return t.prototype.validate = function(t, a, e) {
                                        if (!this.fieldValidatorsPairs) return null;
                                        for(var r = a ? a + "." + e : e, i = 0, o = this.fieldValidatorsPairs; i < o.length; i++)for(var l = o[i], n = 0, d = l.validators; n < d.length; n++){
                                            var s = d[n].validate(t[l.field], r, l.field);
                                            if (s) return s;
                                        }
                                        return null;
                                    }, t;
                                }();
                                a.MultipleFieldsValidator = e;
                            },
                            function(t, a) {
                                var e, r = this && this.__extends || (e = function(t, a) {
                                    return e = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, e(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function r() {
                                        this.constructor = t;
                                    }
                                    e(t, a), t.prototype = null === a ? Object.create(a) : (r.prototype = a.prototype, new r);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.RangeValidator = a.NumberArrayValidator = a.BooleanArrayValidator = a.StringArrayValidator = a.EnumValidator = a.SchemaValidator = a.ValueValidator = a.NumberValidator = a.BooleanValidator = a.StringValidator = a.TypeValidator = a.ArrayValidator = a.ObjectValidator = void 0;
                                var i = function() {
                                    function t() {}
                                    return t.prototype.validate = function(t, a, e) {
                                        return null == t ? null : "object" != typeof t || Array.isArray(t) ? [
                                            {
                                                message: void 0 !== e ? e + " must be an object" : "input must be an object",
                                                path: a,
                                                keyword: "type"
                                            }
                                        ] : null;
                                    }, t;
                                }();
                                a.ObjectValidator = i;
                                var o = function() {
                                    function t(t) {
                                        this.itemValidators = t;
                                    }
                                    return t.prototype.validate = function(t, a, e) {
                                        if (null == t) return null;
                                        if (!Array.isArray(t)) return [
                                            {
                                                message: e + " property is invalid",
                                                path: (a ? a + "." : "") + e,
                                                keyword: "type"
                                            }
                                        ];
                                        for(var r = 0; r < t.length; r++)for(var i = (a ? a + "." : "") + e + "." + r.toString(), o = 0, l = this.itemValidators; o < l.length; o++)if (l[o].validate(t[r], i, e)) return [
                                            {
                                                message: e + " property is invalid",
                                                path: (a ? a + "." : "") + e,
                                                keyword: "type"
                                            }
                                        ];
                                        return null;
                                    }, t;
                                }();
                                a.ArrayValidator = o;
                                var l = function() {
                                    function t(t) {
                                        this.expectedType = t;
                                    }
                                    return t.prototype.validate = function(t, a, e) {
                                        return null == t ? null : typeof t !== this.expectedType ? [
                                            {
                                                message: e + " must be a " + this.expectedType,
                                                path: (a ? a + "." : "") + e,
                                                keyword: "type"
                                            }
                                        ] : null;
                                    }, t;
                                }();
                                a.TypeValidator = l;
                                var n = function(t) {
                                    function a() {
                                        return t.call(this, "string") || this;
                                    }
                                    return r(a, t), a;
                                }(l);
                                a.StringValidator = n;
                                var d = function(t) {
                                    function a() {
                                        return t.call(this, "boolean") || this;
                                    }
                                    return r(a, t), a;
                                }(l);
                                a.BooleanValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return t.call(this, "number") || this;
                                    }
                                    return r(a, t), a;
                                }(l);
                                a.NumberValidator = s;
                                var u = function() {
                                    function t(t) {
                                        this.possibleValues = t;
                                    }
                                    return t.prototype.validate = function(t, a, e) {
                                        return null == t ? null : this.possibleValues.indexOf(t) < 0 ? [
                                            {
                                                message: e + " property is invalid",
                                                path: (a ? a + "." : "") + e,
                                                keyword: "invalid"
                                            }
                                        ] : null;
                                    }, t;
                                }();
                                a.ValueValidator = u;
                                var p = function(t) {
                                    function a(a) {
                                        var e = t.call(this, [
                                            a
                                        ]) || this;
                                        return e.schemaValue = a, e;
                                    }
                                    return r(a, t), a.prototype.validate = function(a, e, r) {
                                        return t.prototype.validate.call(this, a, e, r);
                                    }, a;
                                }(u);
                                a.SchemaValidator = p;
                                var c = function(t) {
                                    function a(a) {
                                        var e = t.call(this) || this;
                                        return e.possibleValues = a, e;
                                    }
                                    return r(a, t), a.prototype.validate = function(a, e, r) {
                                        return null == a ? null : t.prototype.validate.call(this, a, e, r) || new u(this.possibleValues).validate(a, e, r);
                                    }, a;
                                }(s);
                                a.EnumValidator = c;
                                var f = function(t) {
                                    function a() {
                                        return t.call(this, [
                                            new n
                                        ]) || this;
                                    }
                                    return r(a, t), a.prototype.validate = function(a, e, r) {
                                        return t.prototype.validate.call(this, a, e, r) ? [
                                            {
                                                message: r + " must be an array of strings",
                                                path: (e ? e + "." : "") + r,
                                                keyword: "type"
                                            }
                                        ] : null;
                                    }, a;
                                }(o);
                                a.StringArrayValidator = f;
                                var V = function(t) {
                                    function a() {
                                        return t.call(this, [
                                            new d
                                        ]) || this;
                                    }
                                    return r(a, t), a.prototype.validate = function(a, e, r) {
                                        return t.prototype.validate.call(this, a, e, r) ? [
                                            {
                                                message: r + " must be an array of booleans",
                                                path: (e ? e + "." : "") + r,
                                                keyword: "type"
                                            }
                                        ] : null;
                                    }, a;
                                }(o);
                                a.BooleanArrayValidator = V;
                                var v = function(t) {
                                    function a() {
                                        return t.call(this, [
                                            new s
                                        ]) || this;
                                    }
                                    return r(a, t), a.prototype.validate = function(a, e, r) {
                                        return t.prototype.validate.call(this, a, e, r) ? [
                                            {
                                                message: r + " must be an array of numbers",
                                                path: (e ? e + "." : "") + r,
                                                keyword: "type"
                                            }
                                        ] : null;
                                    }, a;
                                }(o);
                                a.NumberArrayValidator = v;
                                var y = function(t) {
                                    function a(a, e) {
                                        var r = t.call(this) || this;
                                        return r.minValue = a, r.maxValue = e, r;
                                    }
                                    return r(a, t), a.prototype.validate = function(a, e, r) {
                                        return null == a ? null : t.prototype.validate.call(this, a, e, r) || (a > this.maxValue || a < this.minValue ? [
                                            {
                                                message: r + " must be a number between " + this.minValue.toString() + " and " + this.maxValue.toString(),
                                                path: (e ? e + "." : "") + r,
                                                keyword: "range"
                                            }
                                        ] : null);
                                    }, a;
                                }(s);
                                a.RangeValidator = y;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.CaptureBookmarkRequestValidator = a.CaptureBookmarkOptionsValidator = a.ApplyBookmarkStateRequestValidator = a.ApplyBookmarkByNameRequestValidator = a.AddBookmarkRequestValidator = a.PlayBookmarkRequestValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var d = [
                                            {
                                                field: "playMode",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    new l.EnumValidator([
                                                        0,
                                                        1
                                                    ])
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(d).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PlayBookmarkRequestValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "state",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "displayName",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "apply",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.AddBookmarkRequestValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ApplyBookmarkByNameRequestValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "state",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ApplyBookmarkStateRequestValidator = p;
                                var c = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "personalizeVisuals",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "allPages",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.CaptureBookmarkOptionsValidator = c;
                                var f = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "options",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.captureBookmarkOptionsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.CaptureBookmarkRequestValidator = f;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.PaginatedReportCommandsValidator = a.SingleCommandSettingsValidator = a.CommandsSettingsValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "copy",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "drill",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "drillthrough",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "expandCollapse",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "exportData",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "includeExclude",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "removeVisual",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "search",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "seeData",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "sort",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "spotlight",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "insightsAnalysis",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "addComment",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "groupVisualContainers",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "summarize",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "clearSelection",
                                                validators: [
                                                    n.Validators.singleCommandSettingsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.CommandsSettingsValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "displayOption",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.commandDisplayOptionValidator
                                                ]
                                            },
                                            {
                                                field: "selector",
                                                validators: [
                                                    n.Validators.visualCommandSelectorValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SingleCommandSettingsValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "parameterPanel",
                                                validators: [
                                                    n.Validators.parametersPanelValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PaginatedReportCommandsValidator = u;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.CustomThemeValidator = void 0;
                                var o = e(3), l = e(4), n = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var n = [
                                            {
                                                field: "themeJson",
                                                validators: [
                                                    new l.ObjectValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(n).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.CustomThemeValidator = n;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.DashboardLoadValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "pageView",
                                                validators: [
                                                    n.Validators.pageViewFieldValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    n.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "embedUrl",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.DashboardLoadValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.DatasetBindingValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "datasetId",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.DatasetBindingValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.ExportDataRequestValidator = void 0;
                                var o = e(3), l = e(4), n = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var n = [
                                            {
                                                field: "rows",
                                                validators: [
                                                    new l.NumberValidator
                                                ]
                                            },
                                            {
                                                field: "exportDataType",
                                                validators: [
                                                    new l.EnumValidator([
                                                        0,
                                                        1
                                                    ])
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(n).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ExportDataRequestValidator = n;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.ExtensionsValidator = a.MenuGroupExtensionValidator = a.ExtensionValidator = a.CommandExtensionValidator = a.ExtensionItemValidator = a.ExtensionPointsValidator = a.GroupedMenuExtensionValidator = a.FlatMenuExtensionValidator = a.MenuExtensionBaseValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "title",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "icon",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.MenuExtensionBaseValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "menuLocation",
                                                validators: [
                                                    n.Validators.menuLocationValidator
                                                ]
                                            },
                                            {
                                                field: "groupName",
                                                validators: [
                                                    n.Validators.fieldForbiddenValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(d);
                                a.FlatMenuExtensionValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "groupName",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "menuLocation",
                                                validators: [
                                                    n.Validators.fieldForbiddenValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(d);
                                a.GroupedMenuExtensionValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visualContextMenu",
                                                validators: [
                                                    n.Validators.menuExtensionValidator
                                                ]
                                            },
                                            {
                                                field: "visualOptionsMenu",
                                                validators: [
                                                    n.Validators.menuExtensionValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ExtensionPointsValidator = p;
                                var c = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "extend",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.extensionPointsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ExtensionItemValidator = c;
                                var f = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "title",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "icon",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "selector",
                                                validators: [
                                                    n.Validators.commandExtensionSelectorValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(c);
                                a.CommandExtensionValidator = f;
                                var V = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "command",
                                                validators: [
                                                    n.Validators.commandExtensionValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ExtensionValidator = V;
                                var v = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "title",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "menuLocation",
                                                validators: [
                                                    n.Validators.menuLocationValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.MenuGroupExtensionValidator = v;
                                var y = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "commands",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.commandExtensionArrayValidator
                                                ]
                                            },
                                            {
                                                field: "groups",
                                                validators: [
                                                    n.Validators.menuGroupExtensionArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ExtensionsValidator = y;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.OnLoadFiltersValidator = a.OnLoadFiltersBaseRemoveOperationValidator = a.OnLoadFiltersBaseValidator = a.ConditionItemValidator = a.RemoveFiltersRequestValidator = a.UpdateFiltersRequestValidator = a.FilterValidator = a.HierarchyFilterNodeValidator = a.HierarchyFilterValidator = a.IncludeExcludeFilterValidator = a.NotSupportedFilterValidator = a.TopNFilterValidator = a.RelativeTimeFilterValidator = a.RelativeDateFilterValidator = a.RelativeDateTimeFilterValidator = a.AdvancedFilterValidator = a.BasicFilterValidator = a.FilterValidatorBase = a.FilterDisplaySettingsValidator = a.FilterMeasureTargetValidator = a.FilterKeyHierarchyTargetValidator = a.FilterHierarchyTargetValidator = a.FilterKeyColumnsTargetValidator = a.FilterColumnTargetValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "table",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "column",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FilterColumnTargetValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "keys",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(d);
                                a.FilterKeyColumnsTargetValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "table",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "hierarchy",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "hierarchyLevel",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FilterHierarchyTargetValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "keys",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(u);
                                a.FilterKeyHierarchyTargetValidator = p;
                                var c = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "table",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "measure",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FilterMeasureTargetValidator = c;
                                var f = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "isLockedInViewMode",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "isHiddenInViewMode",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "displayName",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FilterDisplaySettingsValidator = f;
                                var V = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "target",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filterTargetValidator
                                                ]
                                            },
                                            {
                                                field: "$schema",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.filterTypeValidator
                                                ]
                                            },
                                            {
                                                field: "displaySettings",
                                                validators: [
                                                    n.Validators.filterDisplaySettingsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FilterValidatorBase = V;
                                var v = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "operator",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "values",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.anyArrayValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.basicFilterTypeValidator
                                                ]
                                            },
                                            {
                                                field: "requireSingleSelection",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(V);
                                a.BasicFilterValidator = v;
                                var y = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "logicalOperator",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "conditions",
                                                validators: [
                                                    n.Validators.filterConditionsValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.advancedFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(V);
                                a.AdvancedFilterValidator = y;
                                var h = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "operator",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.relativeDateFilterOperatorValidator
                                                ]
                                            },
                                            {
                                                field: "timeUnitsCount",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "timeUnitType",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.relativeDateTimeFilterUnitTypeValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.relativeDateTimeFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(V);
                                a.RelativeDateTimeFilterValidator = h;
                                var m = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "includeToday",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "timeUnitType",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.relativeDateFilterTimeUnitTypeValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.relativeDateFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(h);
                                a.RelativeDateFilterValidator = m;
                                var g = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "timeUnitType",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.relativeTimeFilterTimeUnitTypeValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.relativeTimeFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(h);
                                a.RelativeTimeFilterValidator = g;
                                var w = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "operator",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "itemCount",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.topNFilterTypeValidator
                                                ]
                                            },
                                            {
                                                field: "orderBy",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filterTargetValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(V);
                                a.TopNFilterValidator = w;
                                var b = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "message",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "notSupportedTypeName",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.notSupportedFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(V);
                                a.NotSupportedFilterValidator = b;
                                var O = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "isExclude",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "values",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.anyArrayValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.includeExludeFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(V);
                                a.IncludeExcludeFilterValidator = O;
                                var _ = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "hierarchyData",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.hierarchyFilterValuesValidator
                                                ]
                                            },
                                            {
                                                field: "filterType",
                                                validators: [
                                                    n.Validators.hierarchyFilterTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(V);
                                a.HierarchyFilterValidator = _;
                                var S = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "value",
                                                validators: [
                                                    n.Validators.anyValueValidator
                                                ]
                                            },
                                            {
                                                field: "keyValues",
                                                validators: [
                                                    n.Validators.anyArrayValidator
                                                ]
                                            },
                                            {
                                                field: "children",
                                                validators: [
                                                    n.Validators.hierarchyFilterValuesValidator
                                                ]
                                            },
                                            {
                                                field: "operator",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.HierarchyFilterNodeValidator = S;
                                var F = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        return null == a ? null : t.prototype.validate.call(this, a, e, r) || n.Validators.anyFilterValidator.validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FilterValidator = F;
                                var T = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "filtersOperation",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filtersOperationsUpdateValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.UpdateFiltersRequestValidator = T;
                                var P = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "filtersOperation",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filtersOperationsRemoveAllValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.fieldForbiddenValidator,
                                                    n.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.RemoveFiltersRequestValidator = P;
                                var C = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "value",
                                                validators: [
                                                    n.Validators.anyValueValidator
                                                ]
                                            },
                                            {
                                                field: "operator",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ConditionItemValidator = C;
                                var R = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "operation",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filtersOperationsUpdateValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.OnLoadFiltersBaseValidator = R;
                                var k = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "operation",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.filtersOperationsRemoveAllValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.fieldForbiddenValidator,
                                                    n.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.OnLoadFiltersBaseRemoveOperationValidator = k;
                                var M = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "allPages",
                                                validators: [
                                                    n.Validators.onLoadFiltersBaseValidator
                                                ]
                                            },
                                            {
                                                field: "currentPage",
                                                validators: [
                                                    n.Validators.onLoadFiltersBaseValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.OnLoadFiltersValidator = M;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.PageLayoutValidator = a.DisplayStateValidator = a.VisualLayoutValidator = a.CustomLayoutValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "pageSize",
                                                validators: [
                                                    n.Validators.pageSizeValidator
                                                ]
                                            },
                                            {
                                                field: "displayOption",
                                                validators: [
                                                    n.Validators.customLayoutDisplayOptionValidator
                                                ]
                                            },
                                            {
                                                field: "pagesLayout",
                                                validators: [
                                                    n.Validators.pagesLayoutValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.CustomLayoutValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "x",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "y",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "z",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "width",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "height",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "displayState",
                                                validators: [
                                                    n.Validators.displayStateValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.VisualLayoutValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "mode",
                                                validators: [
                                                    n.Validators.displayStateModeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.DisplayStateValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visualsLayout",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.pageLayoutValidator
                                                ]
                                            },
                                            {
                                                field: "defaultLayout",
                                                validators: [
                                                    n.Validators.visualLayoutValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PageLayoutValidator = p;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.PageViewFieldValidator = a.PageValidator = a.CustomPageSizeValidator = a.PageSizeValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "type",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.pageSizeTypeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PageSizeValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "width",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "height",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(d);
                                a.CustomPageSizeValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PageValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        return null == a ? null : t.prototype.validate.call(this, a, e, r) || ([
                                            "actualSize",
                                            "fitToWidth",
                                            "oneColumn"
                                        ].indexOf(a) < 0 ? [
                                            {
                                                message: 'pageView must be a string with one of the following values: "actualSize", "fitToWidth", "oneColumn"'
                                            }
                                        ] : null);
                                    }, a;
                                }(l.StringValidator);
                                a.PageViewFieldValidator = p;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.VisualizationsPaneValidator = a.SyncSlicersPaneValidator = a.SelectionPaneValidator = a.PageNavigationPaneValidator = a.FiltersPaneValidator = a.FieldsPaneValidator = a.BookmarksPaneValidator = a.QnaPanesValidator = a.ReportPanesValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "bookmarks",
                                                validators: [
                                                    n.Validators.bookmarksPaneValidator
                                                ]
                                            },
                                            {
                                                field: "fields",
                                                validators: [
                                                    n.Validators.fieldsPaneValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.filtersPaneValidator
                                                ]
                                            },
                                            {
                                                field: "pageNavigation",
                                                validators: [
                                                    n.Validators.pageNavigationPaneValidator
                                                ]
                                            },
                                            {
                                                field: "selection",
                                                validators: [
                                                    n.Validators.selectionPaneValidator
                                                ]
                                            },
                                            {
                                                field: "syncSlicers",
                                                validators: [
                                                    n.Validators.syncSlicersPaneValidator
                                                ]
                                            },
                                            {
                                                field: "visualizations",
                                                validators: [
                                                    n.Validators.visualizationsPaneValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ReportPanesValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.filtersPaneValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.QnaPanesValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.BookmarksPaneValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "expanded",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FieldsPaneValidator = p;
                                var c = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "expanded",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.FiltersPaneValidator = c;
                                var f = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "position",
                                                validators: [
                                                    n.Validators.pageNavigationPositionValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PageNavigationPaneValidator = f;
                                var V = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SelectionPaneValidator = V;
                                var v = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SyncSlicersPaneValidator = v;
                                var y = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "expanded",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.VisualizationsPaneValidator = y;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.QnaInterpretInputDataValidator = a.QnaSettingsValidator = a.LoadQnaValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasetIds",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringArrayValidator
                                                ]
                                            },
                                            {
                                                field: "question",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "viewMode",
                                                validators: [
                                                    n.Validators.viewModeValidator
                                                ]
                                            },
                                            {
                                                field: "settings",
                                                validators: [
                                                    n.Validators.qnaSettingValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    n.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.LoadQnaValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "filterPaneEnabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "hideErrors",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "panes",
                                                validators: [
                                                    n.Validators.qnaPanesValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.QnaSettingsValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "datasetIds",
                                                validators: [
                                                    n.Validators.stringArrayValidator
                                                ]
                                            },
                                            {
                                                field: "question",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.QnaInterpretInputDataValidator = u;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.ReportCreateValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasetId",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    n.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "theme",
                                                validators: [
                                                    n.Validators.customThemeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ReportCreateValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.ReportLoadValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "settings",
                                                validators: [
                                                    n.Validators.settingsValidator
                                                ]
                                            },
                                            {
                                                field: "pageName",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.reportLoadFiltersValidator
                                                ]
                                            },
                                            {
                                                field: "permissions",
                                                validators: [
                                                    n.Validators.permissionsValidator
                                                ]
                                            },
                                            {
                                                field: "viewMode",
                                                validators: [
                                                    n.Validators.viewModeValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    n.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "bookmark",
                                                validators: [
                                                    n.Validators.applyBookmarkValidator
                                                ]
                                            },
                                            {
                                                field: "theme",
                                                validators: [
                                                    n.Validators.customThemeValidator
                                                ]
                                            },
                                            {
                                                field: "embedUrl",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasetBinding",
                                                validators: [
                                                    n.Validators.datasetBindingValidator
                                                ]
                                            },
                                            {
                                                field: "contrastMode",
                                                validators: [
                                                    n.Validators.contrastModeValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ReportLoadValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.ReportParameterFieldsValidator = a.PaginatedReportLoadValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "settings",
                                                validators: [
                                                    n.Validators.paginatedReportsettingsValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    n.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "embedUrl",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "type",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "parameterValues",
                                                validators: [
                                                    n.Validators.parameterValuesArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PaginatedReportLoadValidator = d;
                                var s = function() {
                                    function t() {}
                                    return t.prototype.validate = function(t, a, e) {
                                        if (null == t) return null;
                                        var r = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "value",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(r).validate(t, a, e);
                                    }, t;
                                }();
                                a.ReportParameterFieldsValidator = s;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.SaveAsParametersValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SaveAsParametersValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.SlicerTargetSelectorValidator = a.VisualTypeSelectorValidator = a.VisualSelectorValidator = void 0;
                                var o = e(3), l = e(4), n = e(4), d = e(1), s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "$schema",
                                                validators: [
                                                    d.Validators.stringValidator,
                                                    new n.SchemaValidator("http://powerbi.com/product/schema#visualSelector")
                                                ]
                                            },
                                            {
                                                field: "visualName",
                                                validators: [
                                                    d.Validators.fieldRequiredValidator,
                                                    d.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.VisualSelectorValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "$schema",
                                                validators: [
                                                    d.Validators.fieldRequiredValidator,
                                                    d.Validators.stringValidator,
                                                    new n.SchemaValidator("http://powerbi.com/product/schema#visualTypeSelector")
                                                ]
                                            },
                                            {
                                                field: "visualType",
                                                validators: [
                                                    d.Validators.fieldRequiredValidator,
                                                    d.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.VisualTypeSelectorValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "$schema",
                                                validators: [
                                                    d.Validators.fieldRequiredValidator,
                                                    d.Validators.stringValidator,
                                                    new n.SchemaValidator("http://powerbi.com/product/schema#slicerTargetSelector")
                                                ]
                                            },
                                            {
                                                field: "target",
                                                validators: [
                                                    d.Validators.fieldRequiredValidator,
                                                    d.Validators.slicerTargetValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SlicerTargetSelectorValidator = p;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.PaginatedReportSettingsValidator = a.SettingsValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "filterPaneEnabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "navContentPaneEnabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "bookmarksPaneEnabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "useCustomSaveAsDialog",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "extensions",
                                                validators: [
                                                    n.Validators.extensionsValidator
                                                ]
                                            },
                                            {
                                                field: "layoutType",
                                                validators: [
                                                    n.Validators.layoutTypeValidator
                                                ]
                                            },
                                            {
                                                field: "customLayout",
                                                validators: [
                                                    n.Validators.customLayoutValidator
                                                ]
                                            },
                                            {
                                                field: "background",
                                                validators: [
                                                    n.Validators.backgroundValidator
                                                ]
                                            },
                                            {
                                                field: "visualSettings",
                                                validators: [
                                                    n.Validators.visualSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "hideErrors",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "commands",
                                                validators: [
                                                    n.Validators.commandsSettingsArrayValidator
                                                ]
                                            },
                                            {
                                                field: "hyperlinkClickBehavior",
                                                validators: [
                                                    n.Validators.hyperlinkClickBehaviorValidator
                                                ]
                                            },
                                            {
                                                field: "bars",
                                                validators: [
                                                    n.Validators.reportBarsValidator
                                                ]
                                            },
                                            {
                                                field: "panes",
                                                validators: [
                                                    n.Validators.reportPanesValidator
                                                ]
                                            },
                                            {
                                                field: "personalBookmarksEnabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "persistentFiltersEnabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "visualRenderedEvents",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "authoringHintsEnabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "printSettings",
                                                validators: [
                                                    n.Validators.printSettingsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SettingsValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "commands",
                                                validators: [
                                                    n.Validators.paginatedReportCommandsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PaginatedReportSettingsValidator = s;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.SlicerStateValidator = a.SlicerValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "selector",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.slicerSelectorValidator
                                                ]
                                            },
                                            {
                                                field: "state",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.slicerStateValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SlicerValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "filters",
                                                validators: [
                                                    n.Validators.filtersArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.SlicerStateValidator = s;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.TileLoadValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "id",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "dashboardId",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "pageView",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    n.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "width",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            },
                                            {
                                                field: "height",
                                                validators: [
                                                    n.Validators.numberValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.TileLoadValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.VisualHeaderValidator = a.VisualHeaderSettingsValidator = a.VisualSettingsValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visualHeaders",
                                                validators: [
                                                    n.Validators.visualHeadersValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.VisualSettingsValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "visible",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.VisualHeaderSettingsValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "settings",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.visualHeaderSettingsValidator
                                                ]
                                            },
                                            {
                                                field: "selector",
                                                validators: [
                                                    n.Validators.visualHeaderSelectorValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.VisualHeaderValidator = u;
                            },
                            (t, a)=>{
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.AnyOfValidator = void 0;
                                var e = function() {
                                    function t(t) {
                                        this.validators = t;
                                    }
                                    return t.prototype.validate = function(t, a, e) {
                                        if (null == t) return null;
                                        for(var r = !1, i = 0, o = this.validators; i < o.length; i++)if (!o[i].validate(t, a, e)) {
                                            r = !0;
                                            break;
                                        }
                                        return r ? null : [
                                            {
                                                message: e + " property is invalid",
                                                path: (a ? a + "." : "") + e,
                                                keyword: "invalid"
                                            }
                                        ];
                                    }, t;
                                }();
                                a.AnyOfValidator = e;
                            },
                            (t, a)=>{
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.FieldForbiddenValidator = void 0;
                                var e = function() {
                                    function t() {}
                                    return t.prototype.validate = function(t, a, e) {
                                        return void 0 !== t ? [
                                            {
                                                message: e + " is forbidden",
                                                path: (a ? a + "." : "") + e,
                                                keyword: "forbidden"
                                            }
                                        ] : null;
                                    }, t;
                                }();
                                a.FieldForbiddenValidator = e;
                            },
                            (t, a)=>{
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.FieldRequiredValidator = void 0;
                                var e = function() {
                                    function t() {}
                                    return t.prototype.validate = function(t, a, e) {
                                        return null == t ? [
                                            {
                                                message: e + " is required",
                                                path: (a ? a + "." : "") + e,
                                                keyword: "required"
                                            }
                                        ] : null;
                                    }, t;
                                }();
                                a.FieldRequiredValidator = e;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.MapValidator = void 0;
                                var o = function(t) {
                                    function a(a, e) {
                                        var r = t.call(this) || this;
                                        return r.keyValidators = a, r.valueValidators = e, r;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        for(var o in a)if (a.hasOwnProperty(o)) {
                                            for(var l = (e ? e + "." : "") + r + "." + o, n = 0, d = this.keyValidators; n < d.length; n++)if (i = d[n].validate(o, l, r)) return i;
                                            for(var s = 0, u = this.valueValidators; s < u.length; s++)if (i = u[s].validate(a[o], l, r)) return i;
                                        }
                                        return null;
                                    }, a;
                                }(e(4).ObjectValidator);
                                a.MapValidator = o;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.ParametersPanelValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "expanded",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            },
                                            {
                                                field: "enabled",
                                                validators: [
                                                    n.Validators.booleanValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ParametersPanelValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.TableDataValidator = a.TableSchemaValidator = a.ColumnSchemaValidator = a.CredentialsValidator = a.DatasourceConnectionConfigValidator = a.DatasetCreateConfigValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "locale",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "mashupDocument",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "datasourceConnectionConfig",
                                                validators: [
                                                    n.Validators.datasourceConnectionConfigValidator
                                                ]
                                            },
                                            {
                                                field: "tableSchemaList",
                                                validators: [
                                                    n.Validators.tableSchemaListValidator
                                                ]
                                            },
                                            {
                                                field: "data",
                                                validators: [
                                                    n.Validators.tableDataArrayValidator
                                                ]
                                            }
                                        ];
                                        return (i = new o.MultipleFieldsValidator(l).validate(a, e, r)) || (a.datasourceConnectionConfig && null == a.mashupDocument ? [
                                            {
                                                message: "mashupDocument cannot be empty when datasourceConnectionConfig is presented"
                                            }
                                        ] : a.data && null == a.tableSchemaList ? [
                                            {
                                                message: "tableSchemaList cannot be empty when data is provided"
                                            }
                                        ] : null == a.data && null == a.mashupDocument ? [
                                            {
                                                message: "At least one of data or mashupDocument must be provided"
                                            }
                                        ] : void 0);
                                    }, a;
                                }(l.ObjectValidator);
                                a.DatasetCreateConfigValidator = d;
                                var s = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "dataCacheMode",
                                                validators: [
                                                    n.Validators.dataCacheModeValidator
                                                ]
                                            },
                                            {
                                                field: "credentials",
                                                validators: [
                                                    n.Validators.credentialsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.DatasourceConnectionConfigValidator = s;
                                var u = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "credentialType",
                                                validators: [
                                                    n.Validators.credentialTypeValidator
                                                ]
                                            },
                                            {
                                                field: "credentialDetails",
                                                validators: [
                                                    n.Validators.credentialDetailsValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.CredentialsValidator = u;
                                var p = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "displayName",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "dataType",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.ColumnSchemaValidator = p;
                                var c = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "columns",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.columnSchemaArrayValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.TableSchemaValidator = c;
                                var f = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "name",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "rows",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.rawDataValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.TableDataValidator = f;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.QuickCreateValidator = void 0;
                                var o = e(3), l = e(4), n = e(1), d = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var l = [
                                            {
                                                field: "accessToken",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "groupId",
                                                validators: [
                                                    n.Validators.stringValidator
                                                ]
                                            },
                                            {
                                                field: "tokenType",
                                                validators: [
                                                    n.Validators.tokenTypeValidator
                                                ]
                                            },
                                            {
                                                field: "theme",
                                                validators: [
                                                    n.Validators.customThemeValidator
                                                ]
                                            },
                                            {
                                                field: "datasetCreateConfig",
                                                validators: [
                                                    n.Validators.fieldRequiredValidator,
                                                    n.Validators.datasetCreateConfigValidator
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(l).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.QuickCreateValidator = d;
                            },
                            function(t, a, e) {
                                var r, i = this && this.__extends || (r = function(t, a) {
                                    return r = Object.setPrototypeOf || ({
                                        __proto__: []
                                    }) instanceof Array && function(t, a) {
                                        t.__proto__ = a;
                                    } || function(t, a) {
                                        for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                                    }, r(t, a);
                                }, function(t, a) {
                                    if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
                                    function e() {
                                        this.constructor = t;
                                    }
                                    r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e);
                                });
                                Object.defineProperty(a, "__esModule", {
                                    value: !0
                                }), a.PrintSettingsValidator = void 0;
                                var o = e(3), l = e(4), n = function(t) {
                                    function a() {
                                        return null !== t && t.apply(this, arguments) || this;
                                    }
                                    return i(a, t), a.prototype.validate = function(a, e, r) {
                                        if (null == a) return null;
                                        var i = t.prototype.validate.call(this, a, e, r);
                                        if (i) return i;
                                        var n = [
                                            {
                                                field: "browserPrintAdjustmentsMode",
                                                validators: [
                                                    new l.EnumValidator([
                                                        0,
                                                        1
                                                    ])
                                                ]
                                            }
                                        ];
                                        return new o.MultipleFieldsValidator(n).validate(a, e, r);
                                    }, a;
                                }(l.ObjectValidator);
                                a.PrintSettingsValidator = n;
                            }
                        ], a = {}, e = function e(r) {
                            var i = a[r];
                            if (void 0 !== i) return i.exports;
                            var o = a[r] = {
                                exports: {}
                            };
                            return t[r].call(o.exports, o, o.exports, e), o.exports;
                        }(0);
                        return e;
                    })(), t.exports = a();
            },
            890: (t)=>{
                "use strict";
                t.exports = e;
            },
            719: (t)=>{
                "use strict";
                t.exports = a;
            },
            156: (a)=>{
                "use strict";
                a.exports = t;
            }
        }, i = {};
        function o(t) {
            var a = i[t];
            if (void 0 !== a) return a.exports;
            var e = i[t] = {
                exports: {}
            };
            return r[t].call(e.exports, e, e.exports, o), e.exports;
        }
        o.n = (t)=>{
            var a = t && t.__esModule ? ()=>t.default : ()=>t;
            return o.d(a, {
                a: a
            }), a;
        }, o.d = (t, a)=>{
            for(var e in a)o.o(a, e) && !o.o(t, e) && Object.defineProperty(t, e, {
                enumerable: !0,
                get: a[e]
            });
        }, o.o = (t, a)=>Object.prototype.hasOwnProperty.call(t, a), o.r = (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var l = {};
        return (()=>{
            "use strict";
            o.r(l), o.d(l, {
                EmbedType: ()=>a,
                PowerBIEmbed: ()=>f
            });
            var t, a, e = o(156), r = o(719), i = o(149), n = o(890), d = o.n(n), s = (t = function(a, e) {
                return t = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, a) {
                    t.__proto__ = a;
                } || function(t, a) {
                    for(var e in a)Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                }, t(a, e);
            }, function(a, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
                function r() {
                    this.constructor = a;
                }
                t(a, e), a.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
            }), u = function(t, a, e, r) {
                return new (e || (e = Promise))(function(i, o) {
                    function l(t) {
                        try {
                            d(r.next(t));
                        } catch (t) {
                            o(t);
                        }
                    }
                    function n(t) {
                        try {
                            d(r.throw(t));
                        } catch (t) {
                            o(t);
                        }
                    }
                    function d(t) {
                        var a;
                        t.done ? i(t.value) : (a = t.value, a instanceof e ? a : new e(function(t) {
                            t(a);
                        })).then(l, n);
                    }
                    d((r = r.apply(t, a || [])).next());
                });
            }, p = function(t, a) {
                var e, r, i, o, l = {
                    label: 0,
                    sent: function() {
                        if (1 & i[0]) throw i[1];
                        return i[1];
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: n(0),
                    throw: n(1),
                    return: n(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                    return this;
                }), o;
                function n(n) {
                    return function(d) {
                        return function(n) {
                            if (e) throw new TypeError("Generator is already executing.");
                            for(; o && (o = 0, n[0] && (l = 0)), l;)try {
                                if (e = 1, r && (i = 2 & n[0] ? r.return : n[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, n[1])).done) return i;
                                switch(r = 0, i && (n = [
                                    2 & n[0],
                                    i.value
                                ]), n[0]){
                                    case 0:
                                    case 1:
                                        i = n;
                                        break;
                                    case 4:
                                        return l.label++, {
                                            value: n[1],
                                            done: !1
                                        };
                                    case 5:
                                        l.label++, r = n[1], n = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        n = l.ops.pop(), l.trys.pop();
                                        continue;
                                    default:
                                        if (!((i = (i = l.trys).length > 0 && i[i.length - 1]) || 6 !== n[0] && 2 !== n[0])) {
                                            l = 0;
                                            continue;
                                        }
                                        if (3 === n[0] && (!i || n[1] > i[0] && n[1] < i[3])) {
                                            l.label = n[1];
                                            break;
                                        }
                                        if (6 === n[0] && l.label < i[1]) {
                                            l.label = i[1], i = n;
                                            break;
                                        }
                                        if (i && l.label < i[2]) {
                                            l.label = i[2], l.ops.push(n);
                                            break;
                                        }
                                        i[2] && l.ops.pop(), l.trys.pop();
                                        continue;
                                }
                                n = a.call(t, l);
                            } catch (t) {
                                n = [
                                    6,
                                    t
                                ], r = 0;
                            } finally{
                                e = i = 0;
                            }
                            if (5 & n[0]) throw n[1];
                            return {
                                value: n[0] ? n[1] : void 0,
                                done: !0
                            };
                        }([
                            n,
                            d
                        ]);
                    };
                }
            }, c = function(t, a, e) {
                if (e || 2 === arguments.length) for(var r, i = 0, o = a.length; i < o; i++)!r && i in a || (r || (r = Array.prototype.slice.call(a, 0, i)), r[i] = a[i]);
                return t.concat(r || Array.prototype.slice.call(a));
            };
            !function(t) {
                t.Create = "create", t.Report = "report", t.Dashboard = "dashboard", t.Tile = "tile", t.Qna = "qna", t.Visual = "visual";
            }(a || (a = {}));
            var f = function(t) {
                function o(a) {
                    var i = t.call(this, a) || this;
                    return i.containerRef = e.createRef(), i.prevEventHandlerMapString = "", i.props.service ? i.powerbi = i.props.service : i.powerbi = new r.service.Service(r.factories.hpmFactory, r.factories.wpmpFactory, r.factories.routerFactory), i.powerbi.setSdkInfo("powerbi-client-react", "1.4.0"), i;
                }
                return s(o, t), Object.defineProperty(o.prototype, "embed", {
                    get: function() {
                        return this._embed;
                    },
                    set: function(t) {
                        this._embed = t, this.invokeGetEmbedCallback();
                    },
                    enumerable: !1,
                    configurable: !0
                }), o.prototype.componentDidMount = function() {
                    this.containerRef.current && (this.props.embedConfig.accessToken && this.props.embedConfig.embedUrl ? this.embedEntity() : this.embed = this.powerbi.bootstrap(this.containerRef.current, this.props.embedConfig)), this.props.eventHandlers && this.embed && this.setEventHandlers(this.embed, this.props.eventHandlers);
                }, o.prototype.componentDidUpdate = function(t) {
                    return u(this, void 0, void 0, function() {
                        var e, r, o, l;
                        return p(this, function(n) {
                            switch(n.label){
                                case 0:
                                    return this.embedOrUpdateAccessToken(t), this.props.eventHandlers && this.embed && this.setEventHandlers(this.embed, this.props.eventHandlers), d()(this.props.embedConfig.settings, t.embedConfig.settings) ? [
                                        3,
                                        2
                                    ] : [
                                        4,
                                        this.updateSettings()
                                    ];
                                case 1:
                                    n.sent(), n.label = 2;
                                case 2:
                                    if (this.props.embedConfig.type !== a.Report) return [
                                        3,
                                        11
                                    ];
                                    n.label = 3;
                                case 3:
                                    return n.trys.push([
                                        3,
                                        10,
                                        ,
                                        11
                                    ]), e = this.props.embedConfig, r = e.filters, o = t.embedConfig, e.pageName && e.pageName !== o.pageName ? [
                                        4,
                                        this.embed.setPage(e.pageName)
                                    ] : [
                                        3,
                                        5
                                    ];
                                case 4:
                                    n.sent(), n.label = 5;
                                case 5:
                                    return !r || d()(r, o.filters) ? [
                                        3,
                                        7
                                    ] : [
                                        4,
                                        this.embed.updateFilters(i.FiltersOperations.Replace, r)
                                    ];
                                case 6:
                                    return n.sent(), [
                                        3,
                                        9
                                    ];
                                case 7:
                                    return r || !o.filters ? [
                                        3,
                                        9
                                    ] : [
                                        4,
                                        this.embed.updateFilters(i.FiltersOperations.RemoveAll)
                                    ];
                                case 8:
                                    n.sent(), n.label = 9;
                                case 9:
                                    return [
                                        3,
                                        11
                                    ];
                                case 10:
                                    return l = n.sent(), console.error(l), [
                                        3,
                                        11
                                    ];
                                case 11:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, o.prototype.componentWillUnmount = function() {
                    this.containerRef.current && this.powerbi.reset(this.containerRef.current), this.prevEventHandlerMapString = "";
                }, o.prototype.render = function() {
                    return e.createElement("div", {
                        ref: this.containerRef,
                        className: this.props.cssClassName
                    });
                }, o.prototype.embedEntity = function() {
                    this.containerRef.current && (this.props.phasedEmbedding && this.props.embedConfig.type === a.Report ? this.embed = this.powerbi.load(this.containerRef.current, this.props.embedConfig) : (this.props.phasedEmbedding && console.error("Phased embedding is not supported for type ".concat(this.props.embedConfig.type)), this.props.embedConfig.type === a.Create ? this.embed = this.powerbi.createReport(this.containerRef.current, this.props.embedConfig) : this.embed = this.powerbi.embed(this.containerRef.current, this.props.embedConfig)));
                }, o.prototype.embedOrUpdateAccessToken = function(t) {
                    return u(this, void 0, void 0, function() {
                        var a;
                        return p(this, function(e) {
                            switch(e.label){
                                case 0:
                                    return this.props.embedConfig.accessToken && this.props.embedConfig.embedUrl ? !this.containerRef.current || t.embedConfig.accessToken && this.props.embedConfig.embedUrl === t.embedConfig.embedUrl ? [
                                        3,
                                        1
                                    ] : (this.embedEntity(), [
                                        3,
                                        5
                                    ]) : [
                                        2
                                    ];
                                case 1:
                                    if (this.props.embedConfig.accessToken === t.embedConfig.accessToken || this.props.embedConfig.embedUrl !== t.embedConfig.embedUrl || !this.embed) return [
                                        3,
                                        5
                                    ];
                                    e.label = 2;
                                case 2:
                                    return e.trys.push([
                                        2,
                                        4,
                                        ,
                                        5
                                    ]), [
                                        4,
                                        this.embed.setAccessToken(this.props.embedConfig.accessToken)
                                    ];
                                case 3:
                                    return e.sent(), [
                                        3,
                                        5
                                    ];
                                case 4:
                                    return a = e.sent(), console.error("setAccessToken error:\n", a), [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, o.prototype.setEventHandlers = function(t, e) {
                    var i = this, o = function(t) {
                        if (!t) return "";
                        var a = Array.from(t);
                        return JSON.stringify(a.map(function(t) {
                            return [
                                t[0],
                                t[1] ? t[1].toString() : ""
                            ];
                        }));
                    }(this.props.eventHandlers);
                    if (this.prevEventHandlerMapString !== o) {
                        this.prevEventHandlerMapString = o;
                        var l = r.Embed.allowedEvents, n = t.embedtype;
                        switch(n){
                            case a.Create:
                                break;
                            case a.Report:
                                l = c(c([], l, !0), r.Report.allowedEvents, !0);
                                break;
                            case a.Dashboard:
                                l = c(c([], l, !0), r.Dashboard.allowedEvents, !0);
                                break;
                            case a.Tile:
                                l = c(c([], l, !0), r.Tile.allowedEvents, !0);
                                break;
                            case a.Qna:
                                l = c(c([], l, !0), r.Qna.allowedEvents, !0);
                                break;
                            case a.Visual:
                                l = c(c([], l, !0), r.Visual.allowedEvents, !0);
                                break;
                            default:
                                console.error("Invalid embed type ".concat(n));
                        }
                        var d = [];
                        e.forEach(function(a, e) {
                            l.includes(e) ? (t.off(e), a && t.on(e, function(t) {
                                a(t, i.embed);
                            })) : d.push(e);
                        }), d.length && console.error("Following events are invalid: ".concat(d.join(",")));
                    }
                }, o.prototype.invokeGetEmbedCallback = function() {
                    this.props.getEmbeddedComponent && this.embed && this.props.getEmbeddedComponent(this.embed);
                }, o.prototype.updateSettings = function() {
                    return u(this, void 0, void 0, function() {
                        var t, e;
                        return p(this, function(r) {
                            switch(r.label){
                                case 0:
                                    if (!this.embed || !this.props.embedConfig.settings) return [
                                        2
                                    ];
                                    switch(this.props.embedConfig.type){
                                        case a.Report:
                                            return [
                                                3,
                                                1
                                            ];
                                        case a.Dashboard:
                                        case a.Tile:
                                        case a.Qna:
                                        case a.Visual:
                                            return [
                                                3,
                                                6
                                            ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 1:
                                    t = this.props.embedConfig.settings, r.label = 2;
                                case 2:
                                    return r.trys.push([
                                        2,
                                        4,
                                        ,
                                        5
                                    ]), [
                                        4,
                                        this.embed.updateSettings(t)
                                    ];
                                case 3:
                                    return r.sent(), [
                                        3,
                                        5
                                    ];
                                case 4:
                                    return e = r.sent(), console.error("Error in method updateSettings: ".concat(e)), [
                                        3,
                                        5
                                    ];
                                case 5:
                                case 6:
                                    return [
                                        3,
                                        8
                                    ];
                                case 7:
                                    console.error("Invalid embed type ".concat(this.props.embedConfig.type)), r.label = 8;
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, o;
            }(e.Component);
        })(), l;
    })()); //# sourceMappingURL=powerbi-client-react.js.map
 // SIG // Begin signature block
 // SIG // MIIrdwYJKoZIhvcNAQcCoIIraDCCK2QCAQExDzANBglg
 // SIG // hkgBZQMEAgEFADB3BgorBgEEAYI3AgEEoGkwZzAyBgor
 // SIG // BgEEAYI3AgEeMCQCAQEEEBDgyQbOONQRoqMAEEvTUJAC
 // SIG // AQACAQACAQACAQACAQAwMTANBglghkgBZQMEAgEFAAQg
 // SIG // bAE2PHOCwmymcwYlXV9p4at/rhXPgIPeia11/PQSumig
 // SIG // ghFuMIIIfjCCB2agAwIBAgITNgAAAahTK9ZQq6y5UwAC
 // SIG // AAABqDANBgkqhkiG9w0BAQsFADBBMRMwEQYKCZImiZPy
 // SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRUw
 // SIG // EwYDVQQDEwxBTUUgQ1MgQ0EgMDEwHhcNMjIwNjEwMTgy
 // SIG // NzAzWhcNMjMwNjEwMTgyNzAzWjAkMSIwIAYDVQQDExlN
 // SIG // aWNyb3NvZnQgQXp1cmUgQ29kZSBTaWduMIIBIjANBgkq
 // SIG // hkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnEdeHxP889b7
 // SIG // mrwL0Z0koWl4LoJ+zeHJ7UDmhaQAxyRIIw9tXSK910U/
 // SIG // pTle2lfbvL9vZR1U8zyRwy6WaVNT/rh+wOm9AKqrsbaB
 // SIG // qlCsTRliD/TIgibyDuKIf/aV+Aok1yvoWVg2eNn/06XE
 // SIG // bXA/k554/MzRFwxHJNnO9dGc8hke+UZxb94AZB6JWfXQ
 // SIG // 3xzYYQtPQmVsTI2iQ/aDYkkS+nIgs/IjbConhB93V4oc
 // SIG // 4rL8r9C5D29kDOZRQ2Y2/1eqXV5wb7QSdahpxk3457cf
 // SIG // caTGsmz6nPQq7DqO9RqDO5dYD22V5bGQkf5wMhC0jlQq
 // SIG // 1qFAhbD3nkXka5eErruzcwIDAQABo4IFijCCBYYwKQYJ
 // SIG // KwYBBAGCNxUKBBwwGjAMBgorBgEEAYI3WwEBMAoGCCsG
 // SIG // AQUFBwMDMD0GCSsGAQQBgjcVBwQwMC4GJisGAQQBgjcV
 // SIG // CIaQ4w2E1bR4hPGLPoWb3RbOnRKBYIPdzWaGlIwyAgFk
 // SIG // AgEMMIICdgYIKwYBBQUHAQEEggJoMIICZDBiBggrBgEF
 // SIG // BQcwAoZWaHR0cDovL2NybC5taWNyb3NvZnQuY29tL3Br
 // SIG // aWluZnJhL0NlcnRzL0JZMlBLSUNTQ0EwMS5BTUUuR0JM
 // SIG // X0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYIKwYB
 // SIG // BQUHMAKGRmh0dHA6Ly9jcmwxLmFtZS5nYmwvYWlhL0JZ
 // SIG // MlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIwQ0El
 // SIG // MjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6Ly9j
 // SIG // cmwyLmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5BTUUu
 // SIG // R0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYI
 // SIG // KwYBBQUHMAKGRmh0dHA6Ly9jcmwzLmFtZS5nYmwvYWlh
 // SIG // L0JZMlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIw
 // SIG // Q0ElMjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6
 // SIG // Ly9jcmw0LmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5B
 // SIG // TUUuR0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQw
 // SIG // ga0GCCsGAQUFBzAChoGgbGRhcDovLy9DTj1BTUUlMjBD
 // SIG // UyUyMENBJTIwMDEsQ049QUlBLENOPVB1YmxpYyUyMEtl
 // SIG // eSUyMFNlcnZpY2VzLENOPVNlcnZpY2VzLENOPUNvbmZp
 // SIG // Z3VyYXRpb24sREM9QU1FLERDPUdCTD9jQUNlcnRpZmlj
 // SIG // YXRlP2Jhc2U/b2JqZWN0Q2xhc3M9Y2VydGlmaWNhdGlv
 // SIG // bkF1dGhvcml0eTAdBgNVHQ4EFgQUUchb+1j7hxhVLQdr
 // SIG // TBwsRVxqi/IwDgYDVR0PAQH/BAQDAgeAMEUGA1UdEQQ+
 // SIG // MDykOjA4MR4wHAYDVQQLExVNaWNyb3NvZnQgQ29ycG9y
 // SIG // YXRpb24xFjAUBgNVBAUTDTIzNjE2Nys0NzA4NjAwggHm
 // SIG // BgNVHR8EggHdMIIB2TCCAdWgggHRoIIBzYY/aHR0cDov
 // SIG // L2NybC5taWNyb3NvZnQuY29tL3BraWluZnJhL0NSTC9B
 // SIG // TUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRwOi8v
 // SIG // Y3JsMS5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENBJTIw
 // SIG // MDEoMikuY3JshjFodHRwOi8vY3JsMi5hbWUuZ2JsL2Ny
 // SIG // bC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRw
 // SIG // Oi8vY3JsMy5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENB
 // SIG // JTIwMDEoMikuY3JshjFodHRwOi8vY3JsNC5hbWUuZ2Js
 // SIG // L2NybC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshoG9
 // SIG // bGRhcDovLy9DTj1BTUUlMjBDUyUyMENBJTIwMDEoMiks
 // SIG // Q049QlkyUEtJQ1NDQTAxLENOPUNEUCxDTj1QdWJsaWMl
 // SIG // MjBLZXklMjBTZXJ2aWNlcyxDTj1TZXJ2aWNlcyxDTj1D
 // SIG // b25maWd1cmF0aW9uLERDPUFNRSxEQz1HQkw/Y2VydGlm
 // SIG // aWNhdGVSZXZvY2F0aW9uTGlzdD9iYXNlP29iamVjdENs
 // SIG // YXNzPWNSTERpc3RyaWJ1dGlvblBvaW50MB8GA1UdIwQY
 // SIG // MBaAFJZRhOBrb3v+2Aarw/KF5imuavnUMB8GA1UdJQQY
 // SIG // MBYGCisGAQQBgjdbAQEGCCsGAQUFBwMDMA0GCSqGSIb3
 // SIG // DQEBCwUAA4IBAQAOoFAbE6qv+1RAKHjMn56sREYNiKvh
 // SIG // i11baGKOgpeVXuKztX5x9fQ2/DpXdUOkVe0w6cVoute2
 // SIG // 4WQACXKU+8ANjEMqaJq5DqsR52Q86V6LvjUQwMSfNgnj
 // SIG // nb+mktUX1s8gNAQ2NUWsqG+Q0cmKbEGNFjnbsFvCKgDH
 // SIG // OFHVJaYb5tNCU0nkWkMn1aA0y78u2wLvaQhSSx3I2A8O
 // SIG // WLXWXahlAhV8ZEF04UatM/QwA5DubCgiUwK/TCXfRohY
 // SIG // IouOD4h4MQ533o0sC3kVzvhSXdk2DXmgyBqzHrP+tJPQ
 // SIG // A8IK5AJweyeJrKpdN39ZxV961rru4GXgQMfZ4L6+5v09
 // SIG // zP/7MIII6DCCBtCgAwIBAgITHwAAAFHqj/accwyoOwAA
 // SIG // AAAAUTANBgkqhkiG9w0BAQsFADA8MRMwEQYKCZImiZPy
 // SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRAw
 // SIG // DgYDVQQDEwdhbWVyb290MB4XDTIxMDUyMTE4NDQxNFoX
 // SIG // DTI2MDUyMTE4NTQxNFowQTETMBEGCgmSJomT8ixkARkW
 // SIG // A0dCTDETMBEGCgmSJomT8ixkARkWA0FNRTEVMBMGA1UE
 // SIG // AxMMQU1FIENTIENBIDAxMIIBIjANBgkqhkiG9w0BAQEF
 // SIG // AAOCAQ8AMIIBCgKCAQEAyZpSCX0Bno1W1yqXMhT6BUlJ
 // SIG // ZWpa4p3xFeiTHO4vm2Q6C/azR5xwxnyYHrkSGDtS2P9X
 // SIG // +KDE64V20mmEQkubxnPNeOVnE2RvdPGxgwlq+BhS3ONd
 // SIG // VsQPj79q7XgHM9HhzB9+qk0PC9KN1zm9p/seyiRS6JF1
 // SIG // dbOqRf1pUl7FAVxmgiCFgV8hHIb/rDPXig7FDi3S0yEx
 // SIG // 2CUDVpIq8jEhG8anUFE1WYxM+ni0S5KHwwKPKV4qyGDo
 // SIG // DO+9AmDoma3Chyu5WDlW5cdtqXTWsGPE3umtnX6Amlld
 // SIG // UFLms4OVR4guKf+n5LIBCC6bTiocfXPomqYjYTKx7AGM
 // SIG // faVLaaXmhQIDAQABo4IE3DCCBNgwEgYJKwYBBAGCNxUB
 // SIG // BAUCAwIAAjAjBgkrBgEEAYI3FQIEFgQUEmgkQiFHy9Rr
 // SIG // vjHPIKTACyN/P0cwHQYDVR0OBBYEFJZRhOBrb3v+2Aar
 // SIG // w/KF5imuavnUMIIBBAYDVR0lBIH8MIH5BgcrBgEFAgMF
 // SIG // BggrBgEFBQcDAQYIKwYBBQUHAwIGCisGAQQBgjcUAgEG
 // SIG // CSsGAQQBgjcVBgYKKwYBBAGCNwoDDAYJKwYBBAGCNxUG
 // SIG // BggrBgEFBQcDCQYIKwYBBQUIAgIGCisGAQQBgjdAAQEG
 // SIG // CysGAQQBgjcKAwQBBgorBgEEAYI3CgMEBgkrBgEEAYI3
 // SIG // FQUGCisGAQQBgjcUAgIGCisGAQQBgjcUAgMGCCsGAQUF
 // SIG // BwMDBgorBgEEAYI3WwEBBgorBgEEAYI3WwIBBgorBgEE
 // SIG // AYI3WwMBBgorBgEEAYI3WwUBBgorBgEEAYI3WwQBBgor
 // SIG // BgEEAYI3WwQCMBkGCSsGAQQBgjcUAgQMHgoAUwB1AGIA
 // SIG // QwBBMAsGA1UdDwQEAwIBhjASBgNVHRMBAf8ECDAGAQH/
 // SIG // AgEAMB8GA1UdIwQYMBaAFCleUV5krjS566ycDaeMdQHR
 // SIG // CQsoMIIBaAYDVR0fBIIBXzCCAVswggFXoIIBU6CCAU+G
 // SIG // MWh0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9wa2lpbmZy
 // SIG // YS9jcmwvYW1lcm9vdC5jcmyGI2h0dHA6Ly9jcmwyLmFt
 // SIG // ZS5nYmwvY3JsL2FtZXJvb3QuY3JshiNodHRwOi8vY3Js
 // SIG // My5hbWUuZ2JsL2NybC9hbWVyb290LmNybIYjaHR0cDov
 // SIG // L2NybDEuYW1lLmdibC9jcmwvYW1lcm9vdC5jcmyGgaps
 // SIG // ZGFwOi8vL0NOPWFtZXJvb3QsQ049QU1FUm9vdCxDTj1D
 // SIG // RFAsQ049UHVibGljJTIwS2V5JTIwU2VydmljZXMsQ049
 // SIG // U2VydmljZXMsQ049Q29uZmlndXJhdGlvbixEQz1BTUUs
 // SIG // REM9R0JMP2NlcnRpZmljYXRlUmV2b2NhdGlvbkxpc3Q/
 // SIG // YmFzZT9vYmplY3RDbGFzcz1jUkxEaXN0cmlidXRpb25Q
 // SIG // b2ludDCCAasGCCsGAQUFBwEBBIIBnTCCAZkwRwYIKwYB
 // SIG // BQUHMAKGO2h0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9w
 // SIG // a2lpbmZyYS9jZXJ0cy9BTUVSb290X2FtZXJvb3QuY3J0
 // SIG // MDcGCCsGAQUFBzAChitodHRwOi8vY3JsMi5hbWUuZ2Js
 // SIG // L2FpYS9BTUVSb290X2FtZXJvb3QuY3J0MDcGCCsGAQUF
 // SIG // BzAChitodHRwOi8vY3JsMy5hbWUuZ2JsL2FpYS9BTUVS
 // SIG // b290X2FtZXJvb3QuY3J0MDcGCCsGAQUFBzAChitodHRw
 // SIG // Oi8vY3JsMS5hbWUuZ2JsL2FpYS9BTUVSb290X2FtZXJv
 // SIG // b3QuY3J0MIGiBggrBgEFBQcwAoaBlWxkYXA6Ly8vQ049
 // SIG // YW1lcm9vdCxDTj1BSUEsQ049UHVibGljJTIwS2V5JTIw
 // SIG // U2VydmljZXMsQ049U2VydmljZXMsQ049Q29uZmlndXJh
 // SIG // dGlvbixEQz1BTUUsREM9R0JMP2NBQ2VydGlmaWNhdGU/
 // SIG // YmFzZT9vYmplY3RDbGFzcz1jZXJ0aWZpY2F0aW9uQXV0
 // SIG // aG9yaXR5MA0GCSqGSIb3DQEBCwUAA4ICAQBQECO3Tw/o
 // SIG // 317Rrd7yadqcswPx1LvIYymkaTN6KcmuRt6HKa0Xe73U
 // SIG // x2/AQ30TfgA9GBJngweRykKBusRzyOU17iIubJvy3gA2
 // SIG // 1dwtqtB0DsoEv1U/ptVu2v++doTCJ/i+GbssVXkgaX8H
 // SIG // +6EOGEmT4evp4GbwR4HwWlc+Dvf8HH8PdUA2Z04CvcwI
 // SIG // fckSipbNm84jxJ8XjmTFTWscldL9edj2NsY6iGnyJFIy
 // SIG // ur2PS7VRYyV3p1VAJp91gj1jRQtWEyCB8P5g9nE3z8u0
 // SIG // ANaU/hjwEQCrdGyravWgnf2JtG+bT26YAokbc8m+32zU
 // SIG // tXRO+NK3tAjhOu2FdsG3qNrF4sc7y37R/C+7Pcb/cFfh
 // SIG // ttqsirepZii4xStcjMODYuXzGm3IJs0b0owHG6oKd7ZO
 // SIG // GvHpmmh9K8/DLriD/sq8bURD10qi/wuW8zM7IpLg1vcR
 // SIG // 9dIK2mc0pj44pc6UX0XbttP/VEJgu3lT2eI9VjWtaKjx
 // SIG // 38xE9woSMyekPRtzTwgfuysF9DkJisr+yA4po/FPxpbB
 // SIG // w9c/hBf32DH/GFxteS2pmjgKIbMP8sDukmEq3lVvuWNJ
 // SIG // sybrZwQvQpvaM49fv+JKpLK5YWYEfwksYRR9wU8Hh/ID
 // SIG // 9hRCEkbUoQ2W7mMpsp2Nbp/kcn4ivfolUy3Q9Yf0scsQ
 // SIG // 6WTLYpm+AoCUJTGCGWEwghldAgEBMFgwQTETMBEGCgmS
 // SIG // JomT8ixkARkWA0dCTDETMBEGCgmSJomT8ixkARkWA0FN
 // SIG // RTEVMBMGA1UEAxMMQU1FIENTIENBIDAxAhM2AAABqFMr
 // SIG // 1lCrrLlTAAIAAAGoMA0GCWCGSAFlAwQCAQUAoIGuMBkG
 // SIG // CSqGSIb3DQEJAzEMBgorBgEEAYI3AgEEMBwGCisGAQQB
 // SIG // gjcCAQsxDjAMBgorBgEEAYI3AgEVMC8GCSqGSIb3DQEJ
 // SIG // BDEiBCBV0Dhhtfo0TkDtyKfR6QFOGidHffJUkINPWmnO
 // SIG // Xr+2YjBCBgorBgEEAYI3AgEMMTQwMqAUgBIATQBpAGMA
 // SIG // cgBvAHMAbwBmAHShGoAYaHR0cDovL3d3dy5taWNyb3Nv
 // SIG // ZnQuY29tMA0GCSqGSIb3DQEBAQUABIIBAB8FfDz5dqQy
 // SIG // t9oqLe4TYqJx0aaAyUNphkg/f7cTHbadNd5dNMQSWIxh
 // SIG // +r92ciQA8+4AJOQipEMcogYXskL0TpOdSeaCssjW4Ier
 // SIG // 1xjImkfsPrZfhsd+hYcLGbUAccPe5/AA59+OLuMqpcyx
 // SIG // EJD/TTCnip53f18aiszxUUIpux4LcBpzH4Pnl/LSlUH9
 // SIG // a8meZDfghtJhUzIVysgN8IJB/Ml/6FJAcj35knbFsWC0
 // SIG // Fk3mZS0dP/9WuheHgD690TW54RTzvhc+3fIFQy+a38qb
 // SIG // PqyiFhfSdphvKVLFLeEbBUquRTC/IeVUC53gnbepD/1S
 // SIG // YlIIoqP5hCGJlKi2pfE3YW2hghcpMIIXJQYKKwYBBAGC
 // SIG // NwMDATGCFxUwghcRBgkqhkiG9w0BBwKgghcCMIIW/gIB
 // SIG // AzEPMA0GCWCGSAFlAwQCAQUAMIIBWQYLKoZIhvcNAQkQ
 // SIG // AQSgggFIBIIBRDCCAUACAQEGCisGAQQBhFkKAwEwMTAN
 // SIG // BglghkgBZQMEAgEFAAQgv8M6oE5px8xVRDowVGTfIB6P
 // SIG // QBkwdJfTCaFc6ouX74ECBmQa7ot+9RgTMjAyMzA0MTkw
 // SIG // OTMxMDcuMTg3WjAEgAIB9KCB2KSB1TCB0jELMAkGA1UE
 // SIG // BhMCVVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNV
 // SIG // BAcTB1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBD
 // SIG // b3Jwb3JhdGlvbjEtMCsGA1UECxMkTWljcm9zb2Z0IEly
 // SIG // ZWxhbmQgT3BlcmF0aW9ucyBMaW1pdGVkMSYwJAYDVQQL
 // SIG // Ex1UaGFsZXMgVFNTIEVTTjoyQUQ0LTRCOTItRkEwMTEl
 // SIG // MCMGA1UEAxMcTWljcm9zb2Z0IFRpbWUtU3RhbXAgU2Vy
 // SIG // dmljZaCCEXgwggcnMIIFD6ADAgECAhMzAAABscqQQ+4L
 // SIG // 8AOrAAEAAAGxMA0GCSqGSIb3DQEBCwUAMHwxCzAJBgNV
 // SIG // BAYTAlVTMRMwEQYDVQQIEwpXYXNoaW5ndG9uMRAwDgYD
 // SIG // VQQHEwdSZWRtb25kMR4wHAYDVQQKExVNaWNyb3NvZnQg
 // SIG // Q29ycG9yYXRpb24xJjAkBgNVBAMTHU1pY3Jvc29mdCBU
 // SIG // aW1lLVN0YW1wIFBDQSAyMDEwMB4XDTIyMDkyMDIwMjE1
 // SIG // OVoXDTIzMTIxNDIwMjE1OVowgdIxCzAJBgNVBAYTAlVT
 // SIG // MRMwEQYDVQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdS
 // SIG // ZWRtb25kMR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9y
 // SIG // YXRpb24xLTArBgNVBAsTJE1pY3Jvc29mdCBJcmVsYW5k
 // SIG // IE9wZXJhdGlvbnMgTGltaXRlZDEmMCQGA1UECxMdVGhh
 // SIG // bGVzIFRTUyBFU046MkFENC00QjkyLUZBMDExJTAjBgNV
 // SIG // BAMTHE1pY3Jvc29mdCBUaW1lLVN0YW1wIFNlcnZpY2Uw
 // SIG // ggIiMA0GCSqGSIb3DQEBAQUAA4ICDwAwggIKAoICAQCG
 // SIG // oqs+1ewbx+yDjDxHgzNlMAqTPC8QFD3ie1L7vatEYgwX
 // SIG // QYLIQv0g63t/2CQahqZ9u2u11jjL4ogVHzDX3+dTcSha
 // SIG // El+thqat+mC0WZNoTdcIoKwjuues+aVU4yad0PI3WACV
 // SIG // 967iXmt3HH04MQIE91L/7D+MNPsmQGGtiWWpVdzAYCBY
 // SIG // t1cChQOApUHK/leEqRs6s/H2qmm5mMqbid+WZ/Bv9tNa
 // SIG // QDdowxDru0GgwtKxsg3cEk1Zl3BzOOhBVejdhevZ8H49
 // SIG // g2Ye+IJwNQwezRXGZ/uL9ZKkFp+wMwSfpZjsbyq1EZVf
 // SIG // 7tfTMNWD/s1UMsyp+f+K/77mEkY/7YWa/hZmQFLUwGnC
 // SIG // 86LgRDbmkgbjmNZN99HjKfJ53UjVLFI4/55+4HHRas3U
 // SIG // DbnSW/l8ZkcIvS8IwNP/D5TrCk2fF8OhBFj1S3zaI0rl
 // SIG // qWTE2jM8/8M0j6eSdNpKWJpHZedJcMhkSzuV+4liDSpq
 // SIG // F8knUJkXYhjE5L0UrVysSKBJvxCcQmiPpOEt/gVilgtO
 // SIG // xFeU91Bu8GxW+C374G22ijOfB8rQMow5zvXxItL66fCR
 // SIG // U7RoXbcIRBJK2jLRlbfgr5xtGZR+Jr6T0T7iW6hOdPXu
 // SIG // gqph8M07lGTxTBVryZ+Hz79Hd9lrPY79mGJhP9FkdX1C
 // SIG // 7Pk8caVoJ9c9DwDrMUmUTwIDAQABo4IBSTCCAUUwHQYD
 // SIG // VR0OBBYEFPSbZ5HvDa2EivXxZ6FRNKa9DjmTMB8GA1Ud
 // SIG // IwQYMBaAFJ+nFV0AXmJdg/Tl0mWnG1M1GelyMF8GA1Ud
 // SIG // HwRYMFYwVKBSoFCGTmh0dHA6Ly93d3cubWljcm9zb2Z0
 // SIG // LmNvbS9wa2lvcHMvY3JsL01pY3Jvc29mdCUyMFRpbWUt
 // SIG // U3RhbXAlMjBQQ0ElMjAyMDEwKDEpLmNybDBsBggrBgEF
 // SIG // BQcBAQRgMF4wXAYIKwYBBQUHMAKGUGh0dHA6Ly93d3cu
 // SIG // bWljcm9zb2Z0LmNvbS9wa2lvcHMvY2VydHMvTWljcm9z
 // SIG // b2Z0JTIwVGltZS1TdGFtcCUyMFBDQSUyMDIwMTAoMSku
 // SIG // Y3J0MAwGA1UdEwEB/wQCMAAwFgYDVR0lAQH/BAwwCgYI
 // SIG // KwYBBQUHAwgwDgYDVR0PAQH/BAQDAgeAMA0GCSqGSIb3
 // SIG // DQEBCwUAA4ICAQDY5zeSaqXlUoSK0CGgEJzVTr9XAxJg
 // SIG // pA+qELn1/TRjl9vCcP4HZBrTCcmoANJVW7psEJWuSz4Q
 // SIG // ZuS4yFFv+WmIc0pWe5cXg8pMOe8KdgKqDACZu213F7Sb
 // SIG // fx8mkZTd+YQIQVfg5hpwSEXBOQtm0hRWN2rA+dClEgj5
 // SIG // ipf9DRWnT3qDam4+WVJ2vFQHzEg7HcXssY7PK//Vaasv
 // SIG // JYCFQaka17Rbep9fhhaSftgIz7KXzzu2PmP6M7+XUxGL
 // SIG // puXgyw3Q9bYUJh5FvLNAQQ2yDk93fnVnTxE5H+dHzP5w
 // SIG // C5DBHb2KNoMoiazkhtGvWdkv+pmyQVK4K5ID6dh4y5Mn
 // SIG // EeDYcJeu3oQIVsSRig9oEZPPE9iily4kRwKGE2VaR24J
 // SIG // GC7KQSybPQu+2ZLsV7ryDhmiHexCQgTlUTCcoLcfBV6a
 // SIG // Ert41hHWrtFgTF8YVQMxB07u1Cltw8PihoFu0UZYa7ef
 // SIG // PUivJaz0rzzOjz56hBX+j1LE1TtGzpMypwt0zoLouCYZ
 // SIG // VpYooLRLYNUpTzMXHTLnPbmHVkntf9mFpq/Wa1dUbr6U
 // SIG // kiryS0mA5Tn+mia6Z1+2CizEaMinc05HL18NSWX4pCXh
 // SIG // iY30bNnE9iSG4jRBiuIubK0G1Qr4Ar3WFRFWV1VtSM/y
 // SIG // ySyvV2yJDDI5hAiRLGtO6GnSnDuHnfb2OmGARjCCB3Ew
 // SIG // ggVZoAMCAQICEzMAAAAVxedrngKbSZkAAAAAABUwDQYJ
 // SIG // KoZIhvcNAQELBQAwgYgxCzAJBgNVBAYTAlVTMRMwEQYD
 // SIG // VQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25k
 // SIG // MR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24x
 // SIG // MjAwBgNVBAMTKU1pY3Jvc29mdCBSb290IENlcnRpZmlj
 // SIG // YXRlIEF1dGhvcml0eSAyMDEwMB4XDTIxMDkzMDE4MjIy
 // SIG // NVoXDTMwMDkzMDE4MzIyNVowfDELMAkGA1UEBhMCVVMx
 // SIG // EzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNVBAcTB1Jl
 // SIG // ZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jwb3Jh
 // SIG // dGlvbjEmMCQGA1UEAxMdTWljcm9zb2Z0IFRpbWUtU3Rh
 // SIG // bXAgUENBIDIwMTAwggIiMA0GCSqGSIb3DQEBAQUAA4IC
 // SIG // DwAwggIKAoICAQDk4aZM57RyIQt5osvXJHm9DtWC0/3u
 // SIG // nAcH0qlsTnXIyjVX9gF/bErg4r25PhdgM/9cT8dm95VT
 // SIG // cVrifkpa/rg2Z4VGIwy1jRPPdzLAEBjoYH1qUoNEt6aO
 // SIG // RmsHFPPFdvWGUNzBRMhxXFExN6AKOG6N7dcP2CZTfDlh
 // SIG // AnrEqv1yaa8dq6z2Nr41JmTamDu6GnszrYBbfowQHJ1S
 // SIG // /rboYiXcag/PXfT+jlPP1uyFVk3v3byNpOORj7I5LFGc
 // SIG // 6XBpDco2LXCOMcg1KL3jtIckw+DJj361VI/c+gVVmG1o
 // SIG // O5pGve2krnopN6zL64NF50ZuyjLVwIYwXE8s4mKyzbni
 // SIG // jYjklqwBSru+cakXW2dg3viSkR4dPf0gz3N9QZpGdc3E
 // SIG // XzTdEonW/aUgfX782Z5F37ZyL9t9X4C626p+Nuw2TPYr
 // SIG // bqgSUei/BQOj0XOmTTd0lBw0gg/wEPK3Rxjtp+iZfD9M
 // SIG // 269ewvPV2HM9Q07BMzlMjgK8QmguEOqEUUbi0b1qGFph
 // SIG // AXPKZ6Je1yh2AuIzGHLXpyDwwvoSCtdjbwzJNmSLW6Cm
 // SIG // gyFdXzB0kZSU2LlQ+QuJYfM2BjUYhEfb3BvR/bLUHMVr
 // SIG // 9lxSUV0S2yW6r1AFemzFER1y7435UsSFF5PAPBXbGjfH
 // SIG // CBUYP3irRbb1Hode2o+eFnJpxq57t7c+auIurQIDAQAB
 // SIG // o4IB3TCCAdkwEgYJKwYBBAGCNxUBBAUCAwEAATAjBgkr
 // SIG // BgEEAYI3FQIEFgQUKqdS/mTEmr6CkTxGNSnPEP8vBO4w
 // SIG // HQYDVR0OBBYEFJ+nFV0AXmJdg/Tl0mWnG1M1GelyMFwG
 // SIG // A1UdIARVMFMwUQYMKwYBBAGCN0yDfQEBMEEwPwYIKwYB
 // SIG // BQUHAgEWM2h0dHA6Ly93d3cubWljcm9zb2Z0LmNvbS9w
 // SIG // a2lvcHMvRG9jcy9SZXBvc2l0b3J5Lmh0bTATBgNVHSUE
 // SIG // DDAKBggrBgEFBQcDCDAZBgkrBgEEAYI3FAIEDB4KAFMA
 // SIG // dQBiAEMAQTALBgNVHQ8EBAMCAYYwDwYDVR0TAQH/BAUw
 // SIG // AwEB/zAfBgNVHSMEGDAWgBTV9lbLj+iiXGJo0T2UkFvX
 // SIG // zpoYxDBWBgNVHR8ETzBNMEugSaBHhkVodHRwOi8vY3Js
 // SIG // Lm1pY3Jvc29mdC5jb20vcGtpL2NybC9wcm9kdWN0cy9N
 // SIG // aWNSb29DZXJBdXRfMjAxMC0wNi0yMy5jcmwwWgYIKwYB
 // SIG // BQUHAQEETjBMMEoGCCsGAQUFBzAChj5odHRwOi8vd3d3
 // SIG // Lm1pY3Jvc29mdC5jb20vcGtpL2NlcnRzL01pY1Jvb0Nl
 // SIG // ckF1dF8yMDEwLTA2LTIzLmNydDANBgkqhkiG9w0BAQsF
 // SIG // AAOCAgEAnVV9/Cqt4SwfZwExJFvhnnJL/Klv6lwUtj5O
 // SIG // R2R4sQaTlz0xM7U518JxNj/aZGx80HU5bbsPMeTCj/ts
 // SIG // 0aGUGCLu6WZnOlNN3Zi6th542DYunKmCVgADsAW+iehp
 // SIG // 4LoJ7nvfam++Kctu2D9IdQHZGN5tggz1bSNU5HhTdSRX
 // SIG // ud2f8449xvNo32X2pFaq95W2KFUn0CS9QKC/GbYSEhFd
 // SIG // PSfgQJY4rPf5KYnDvBewVIVCs/wMnosZiefwC2qBwoEZ
 // SIG // QhlSdYo2wh3DYXMuLGt7bj8sCXgU6ZGyqVvfSaN0DLzs
 // SIG // kYDSPeZKPmY7T7uG+jIa2Zb0j/aRAfbOxnT99kxybxCr
 // SIG // dTDFNLB62FD+CljdQDzHVG2dY3RILLFORy3BFARxv2T5
 // SIG // JL5zbcqOCb2zAVdJVGTZc9d/HltEAY5aGZFrDZ+kKNxn
 // SIG // GSgkujhLmm77IVRrakURR6nxt67I6IleT53S0Ex2tVdU
 // SIG // CbFpAUR+fKFhbHP+CrvsQWY9af3LwUFJfn6Tvsv4O+S3
 // SIG // Fb+0zj6lMVGEvL8CwYKiexcdFYmNcP7ntdAoGokLjzba
 // SIG // ukz5m/8K6TT4JDVnK+ANuOaMmdbhIurwJ0I9JZTmdHRb
 // SIG // atGePu1+oDEzfbzL6Xu/OHBE0ZDxyKs6ijoIYn/ZcGNT
 // SIG // TY3ugm2lBRDBcQZqELQdVTNYs6FwZvKhggLUMIICPQIB
 // SIG // ATCCAQChgdikgdUwgdIxCzAJBgNVBAYTAlVTMRMwEQYD
 // SIG // VQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25k
 // SIG // MR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24x
 // SIG // LTArBgNVBAsTJE1pY3Jvc29mdCBJcmVsYW5kIE9wZXJh
 // SIG // dGlvbnMgTGltaXRlZDEmMCQGA1UECxMdVGhhbGVzIFRT
 // SIG // UyBFU046MkFENC00QjkyLUZBMDExJTAjBgNVBAMTHE1p
 // SIG // Y3Jvc29mdCBUaW1lLVN0YW1wIFNlcnZpY2WiIwoBATAH
 // SIG // BgUrDgMCGgMVAO1ksb6kA2wO78suvU59MD+QRscroIGD
 // SIG // MIGApH4wfDELMAkGA1UEBhMCVVMxEzARBgNVBAgTCldh
 // SIG // c2hpbmd0b24xEDAOBgNVBAcTB1JlZG1vbmQxHjAcBgNV
 // SIG // BAoTFU1pY3Jvc29mdCBDb3Jwb3JhdGlvbjEmMCQGA1UE
 // SIG // AxMdTWljcm9zb2Z0IFRpbWUtU3RhbXAgUENBIDIwMTAw
 // SIG // DQYJKoZIhvcNAQEFBQACBQDn6QKSMCIYDzIwMjMwNDE4
 // SIG // MTk1MDQyWhgPMjAyMzA0MTkxOTUwNDJaMHQwOgYKKwYB
 // SIG // BAGEWQoEATEsMCowCgIFAOfpApICAQAwBwIBAAICKLkw
 // SIG // BwIBAAICOgUwCgIFAOfqVBICAQAwNgYKKwYBBAGEWQoE
 // SIG // AjEoMCYwDAYKKwYBBAGEWQoDAqAKMAgCAQACAwehIKEK
 // SIG // MAgCAQACAwGGoDANBgkqhkiG9w0BAQUFAAOBgQCfKvql
 // SIG // CK9u+N7JzCvKHyeGiAoEjyNV41XfRatJkAkMsz3XDckF
 // SIG // r96U6BR7UM4vl2nQzktP5dGehLN4GvwdhC3dFfT5s022
 // SIG // I9KZ2FhzYjkzh9HW+C2Tjerog+iVsqF2lUMmD+NLEbcx
 // SIG // y3i6bZSvsI+P95fTLXJQiqYba+P8yYfbojGCBA0wggQJ
 // SIG // AgEBMIGTMHwxCzAJBgNVBAYTAlVTMRMwEQYDVQQIEwpX
 // SIG // YXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25kMR4wHAYD
 // SIG // VQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24xJjAkBgNV
 // SIG // BAMTHU1pY3Jvc29mdCBUaW1lLVN0YW1wIFBDQSAyMDEw
 // SIG // AhMzAAABscqQQ+4L8AOrAAEAAAGxMA0GCWCGSAFlAwQC
 // SIG // AQUAoIIBSjAaBgkqhkiG9w0BCQMxDQYLKoZIhvcNAQkQ
 // SIG // AQQwLwYJKoZIhvcNAQkEMSIEIDsFZ9jUii/A9YGeqKSQ
 // SIG // grveMsxzyYMV7yTNMh/TczfHMIH6BgsqhkiG9w0BCRAC
 // SIG // LzGB6jCB5zCB5DCBvQQgg+0NixRb36ng6MvYKbt+benW
 // SIG // Hq6wztHDE5TiKJs0z2wwgZgwgYCkfjB8MQswCQYDVQQG
 // SIG // EwJVUzETMBEGA1UECBMKV2FzaGluZ3RvbjEQMA4GA1UE
 // SIG // BxMHUmVkbW9uZDEeMBwGA1UEChMVTWljcm9zb2Z0IENv
 // SIG // cnBvcmF0aW9uMSYwJAYDVQQDEx1NaWNyb3NvZnQgVGlt
 // SIG // ZS1TdGFtcCBQQ0EgMjAxMAITMwAAAbHKkEPuC/ADqwAB
 // SIG // AAABsTAiBCDC6WTFT+ptAw1HVkJmEXU5x863yFd/LUvm
 // SIG // RbBqYvtkCDANBgkqhkiG9w0BAQsFAASCAgBJzkCUTj11
 // SIG // UzPhMzwnKQjatmxn+0sbKvznREQ9pzISTTMPGooRa4yP
 // SIG // GHTlulNuT0txqGMF3vIC2xIlMuh0QdsFJHXqgQHRI+i9
 // SIG // 5jjHPqLre0hieOECsgKErM66sWmMNSb4tknOGwTZpZdY
 // SIG // lWx59ABCYUShYb3jLd47cYPBFqdI2pQuoZ/l43pvxKzT
 // SIG // oUhoBihb5T8XNBN9oA4t13djye7WUPAD2HpL+oS/8zUH
 // SIG // E7/u/Q9Tzu7It4elJ1vRfjUGr4KUisbceYyTF6npQwt6
 // SIG // Asi1tErQQef12y8cdvDKwRjrlWZBpLNVgSUW9sES3zSO
 // SIG // SgSGfh0QcaauOhbKjM9iz5h0ledOVrwfQ/wo4RS1XPr0
 // SIG // s91E8VLQEDCaewdko4y6tdylymtQ2NzaoqjPupKhHn/2
 // SIG // wTdV60Q6LD1A6tgx4AAIRDaxTK0JwvYk5cFMCmMXPL7i
 // SIG // Vb5QRW6JB8adyzkKqBudGjSOI3TXl/0S+g3bXgmTnyu6
 // SIG // WpwFDgsx0PnM/Tf8+Fq0fkTwJzi0/c1Sl9zwmEEyAap9
 // SIG // tt3IjiAN7eTO62rzyM7e8sWc/SqgI28pKZ43G5IuTj58
 // SIG // VlVBamlXRaSpJuQL67g/plhlRh7KEEY6b+1dw+RbGL6K
 // SIG // p9xQzJtyUPyghwqxsTF3k4pQjKBUz4pVikhJN4fc/WYa
 // SIG // vGirK9YD9b7Udg==
 // SIG // End signature block

});
parcelRegister("3bj33", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});


parcelRegister("jSUEQ", function(module, exports) {
// powerbi-models v1.15.2
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, ()=>{
    return /******/ (()=>{
        /******/ var __webpack_modules__ = [
            /* 0 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CommonErrorCodes = exports.BookmarksPlayMode = exports.ExportDataType = exports.QnaMode = exports.PageNavigationPosition = exports.BrowserPrintAdjustmentsMode = exports.AggregateFunction = exports.DataCacheMode = exports.CredentialType = exports.isPercentOfGrandTotal = exports.isColumnAggr = exports.isHierarchyLevelAggr = exports.isHierarchyLevel = exports.isColumn = exports.isMeasure = exports.getFilterType = exports.isBasicFilterWithKeys = exports.isFilterKeyColumnsTarget = exports.HierarchyIdentityFilter = exports.HierarchyFilter = exports.AdvancedFilter = exports.TupleFilter = exports.IdentityFilter = exports.BasicFilterWithKeys = exports.BasicFilter = exports.RelativeTimeFilter = exports.RelativeDateFilter = exports.TopNFilter = exports.IncludeExcludeFilter = exports.NotSupportedFilter = exports.Filter = exports.RelativeDateOperators = exports.RelativeDateFilterTimeUnit = exports.FilterType = exports.FiltersLevel = exports.FiltersOperations = exports.MenuLocation = exports.ContrastMode = exports.TokenType = exports.ViewMode = exports.Permissions = exports.SectionVisibility = exports.ReportAlignment = exports.HyperlinkClickBehavior = exports.LayoutType = exports.VisualContainerDisplayMode = exports.BackgroundType = exports.DisplayOption = exports.PageSizeType = exports.TraceType = void 0;
                exports.validateExportDataRequest = exports.validateQnaInterpretInputData = exports.validateLoadQnaConfiguration = exports.validateSaveAsParameters = exports.validateUpdateFiltersRequest = exports.validateFilter = exports.validatePage = exports.validateTileLoad = exports.validateDashboardLoad = exports.validateQuickCreate = exports.validateCreateReport = exports.validatePaginatedReportLoad = exports.validateReportLoad = exports.validateMenuGroupExtension = exports.validateExtension = exports.validateCustomPageSize = exports.validateVisualizationsPane = exports.validateSyncSlicersPane = exports.validateSelectionPane = exports.validatePageNavigationPane = exports.validateFieldsPane = exports.validateFiltersPane = exports.validateBookmarksPane = exports.validatePanes = exports.validateSettings = exports.validateCaptureBookmarkRequest = exports.validateApplyBookmarkStateRequest = exports.validateApplyBookmarkByNameRequest = exports.validateAddBookmarkRequest = exports.validatePlayBookmarkRequest = exports.validateSlicerState = exports.validateSlicer = exports.validateVisualSelector = exports.isIExtensionArray = exports.isIExtensions = exports.isGroupedMenuExtension = exports.isFlatMenuExtension = exports.isReportFiltersArray = exports.isOnLoadFilters = exports.VisualDataRoleKindPreference = exports.VisualDataRoleKind = exports.CommandDisplayOption = exports.SlicerTargetSelector = exports.VisualTypeSelector = exports.VisualSelector = exports.PageSelector = exports.Selector = exports.SortDirection = exports.LegendPosition = exports.TextAlignment = void 0;
                exports.validatePrintSettings = exports.validateZoomLevel = exports.validateCustomTheme = exports.validateCommandsSettings = exports.validateVisualSettings = exports.validateVisualHeader = void 0;
                var validator_1 = __webpack_require__(1);
                var TraceType;
                (function(TraceType) {
                    TraceType[TraceType["Information"] = 0] = "Information";
                    TraceType[TraceType["Verbose"] = 1] = "Verbose";
                    TraceType[TraceType["Warning"] = 2] = "Warning";
                    TraceType[TraceType["Error"] = 3] = "Error";
                    TraceType[TraceType["ExpectedError"] = 4] = "ExpectedError";
                    TraceType[TraceType["UnexpectedError"] = 5] = "UnexpectedError";
                    TraceType[TraceType["Fatal"] = 6] = "Fatal";
                })(TraceType = exports.TraceType || (exports.TraceType = {}));
                var PageSizeType;
                (function(PageSizeType) {
                    PageSizeType[PageSizeType["Widescreen"] = 0] = "Widescreen";
                    PageSizeType[PageSizeType["Standard"] = 1] = "Standard";
                    PageSizeType[PageSizeType["Cortana"] = 2] = "Cortana";
                    PageSizeType[PageSizeType["Letter"] = 3] = "Letter";
                    PageSizeType[PageSizeType["Custom"] = 4] = "Custom";
                    PageSizeType[PageSizeType["Mobile"] = 5] = "Mobile";
                })(PageSizeType = exports.PageSizeType || (exports.PageSizeType = {}));
                var DisplayOption;
                (function(DisplayOption) {
                    DisplayOption[DisplayOption["FitToPage"] = 0] = "FitToPage";
                    DisplayOption[DisplayOption["FitToWidth"] = 1] = "FitToWidth";
                    DisplayOption[DisplayOption["ActualSize"] = 2] = "ActualSize";
                })(DisplayOption = exports.DisplayOption || (exports.DisplayOption = {}));
                var BackgroundType;
                (function(BackgroundType) {
                    BackgroundType[BackgroundType["Default"] = 0] = "Default";
                    BackgroundType[BackgroundType["Transparent"] = 1] = "Transparent";
                })(BackgroundType = exports.BackgroundType || (exports.BackgroundType = {}));
                var VisualContainerDisplayMode;
                (function(VisualContainerDisplayMode) {
                    VisualContainerDisplayMode[VisualContainerDisplayMode["Visible"] = 0] = "Visible";
                    VisualContainerDisplayMode[VisualContainerDisplayMode["Hidden"] = 1] = "Hidden";
                })(VisualContainerDisplayMode = exports.VisualContainerDisplayMode || (exports.VisualContainerDisplayMode = {}));
                var LayoutType;
                (function(LayoutType) {
                    LayoutType[LayoutType["Master"] = 0] = "Master";
                    LayoutType[LayoutType["Custom"] = 1] = "Custom";
                    LayoutType[LayoutType["MobilePortrait"] = 2] = "MobilePortrait";
                    LayoutType[LayoutType["MobileLandscape"] = 3] = "MobileLandscape";
                })(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
                var HyperlinkClickBehavior;
                (function(HyperlinkClickBehavior) {
                    HyperlinkClickBehavior[HyperlinkClickBehavior["Navigate"] = 0] = "Navigate";
                    HyperlinkClickBehavior[HyperlinkClickBehavior["NavigateAndRaiseEvent"] = 1] = "NavigateAndRaiseEvent";
                    HyperlinkClickBehavior[HyperlinkClickBehavior["RaiseEvent"] = 2] = "RaiseEvent";
                })(HyperlinkClickBehavior = exports.HyperlinkClickBehavior || (exports.HyperlinkClickBehavior = {}));
                var ReportAlignment;
                (function(ReportAlignment) {
                    ReportAlignment[ReportAlignment["Left"] = 0] = "Left";
                    ReportAlignment[ReportAlignment["Center"] = 1] = "Center";
                    ReportAlignment[ReportAlignment["Right"] = 2] = "Right";
                    ReportAlignment[ReportAlignment["None"] = 3] = "None";
                })(ReportAlignment = exports.ReportAlignment || (exports.ReportAlignment = {}));
                var SectionVisibility;
                (function(SectionVisibility) {
                    SectionVisibility[SectionVisibility["AlwaysVisible"] = 0] = "AlwaysVisible";
                    SectionVisibility[SectionVisibility["HiddenInViewMode"] = 1] = "HiddenInViewMode";
                })(SectionVisibility = exports.SectionVisibility || (exports.SectionVisibility = {}));
                var Permissions;
                (function(Permissions) {
                    Permissions[Permissions["Read"] = 0] = "Read";
                    Permissions[Permissions["ReadWrite"] = 1] = "ReadWrite";
                    Permissions[Permissions["Copy"] = 2] = "Copy";
                    Permissions[Permissions["Create"] = 4] = "Create";
                    Permissions[Permissions["All"] = 7] = "All";
                })(Permissions = exports.Permissions || (exports.Permissions = {}));
                var ViewMode;
                (function(ViewMode) {
                    ViewMode[ViewMode["View"] = 0] = "View";
                    ViewMode[ViewMode["Edit"] = 1] = "Edit";
                })(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
                var TokenType;
                (function(TokenType) {
                    TokenType[TokenType["Aad"] = 0] = "Aad";
                    TokenType[TokenType["Embed"] = 1] = "Embed";
                })(TokenType = exports.TokenType || (exports.TokenType = {}));
                var ContrastMode;
                (function(ContrastMode) {
                    ContrastMode[ContrastMode["None"] = 0] = "None";
                    ContrastMode[ContrastMode["HighContrast1"] = 1] = "HighContrast1";
                    ContrastMode[ContrastMode["HighContrast2"] = 2] = "HighContrast2";
                    ContrastMode[ContrastMode["HighContrastBlack"] = 3] = "HighContrastBlack";
                    ContrastMode[ContrastMode["HighContrastWhite"] = 4] = "HighContrastWhite";
                })(ContrastMode = exports.ContrastMode || (exports.ContrastMode = {}));
                var MenuLocation;
                (function(MenuLocation) {
                    MenuLocation[MenuLocation["Bottom"] = 0] = "Bottom";
                    MenuLocation[MenuLocation["Top"] = 1] = "Top";
                })(MenuLocation = exports.MenuLocation || (exports.MenuLocation = {}));
                var FiltersOperations;
                (function(FiltersOperations) {
                    FiltersOperations[FiltersOperations["RemoveAll"] = 0] = "RemoveAll";
                    FiltersOperations[FiltersOperations["ReplaceAll"] = 1] = "ReplaceAll";
                    FiltersOperations[FiltersOperations["Add"] = 2] = "Add";
                    FiltersOperations[FiltersOperations["Replace"] = 3] = "Replace";
                })(FiltersOperations = exports.FiltersOperations || (exports.FiltersOperations = {}));
                var FiltersLevel;
                (function(FiltersLevel) {
                    FiltersLevel[FiltersLevel["Report"] = 0] = "Report";
                    FiltersLevel[FiltersLevel["Page"] = 1] = "Page";
                    FiltersLevel[FiltersLevel["Visual"] = 2] = "Visual";
                })(FiltersLevel = exports.FiltersLevel || (exports.FiltersLevel = {}));
                var FilterType;
                (function(FilterType) {
                    FilterType[FilterType["Advanced"] = 0] = "Advanced";
                    FilterType[FilterType["Basic"] = 1] = "Basic";
                    FilterType[FilterType["Unknown"] = 2] = "Unknown";
                    FilterType[FilterType["IncludeExclude"] = 3] = "IncludeExclude";
                    FilterType[FilterType["RelativeDate"] = 4] = "RelativeDate";
                    FilterType[FilterType["TopN"] = 5] = "TopN";
                    FilterType[FilterType["Tuple"] = 6] = "Tuple";
                    FilterType[FilterType["RelativeTime"] = 7] = "RelativeTime";
                    FilterType[FilterType["Identity"] = 8] = "Identity";
                    FilterType[FilterType["Hierarchy"] = 9] = "Hierarchy";
                    FilterType[FilterType["HierarchyIdentity"] = 10] = "HierarchyIdentity";
                })(FilterType = exports.FilterType || (exports.FilterType = {}));
                var RelativeDateFilterTimeUnit;
                (function(RelativeDateFilterTimeUnit) {
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Days"] = 0] = "Days";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Weeks"] = 1] = "Weeks";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarWeeks"] = 2] = "CalendarWeeks";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Months"] = 3] = "Months";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarMonths"] = 4] = "CalendarMonths";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Years"] = 5] = "Years";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["CalendarYears"] = 6] = "CalendarYears";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Minutes"] = 7] = "Minutes";
                    RelativeDateFilterTimeUnit[RelativeDateFilterTimeUnit["Hours"] = 8] = "Hours";
                })(RelativeDateFilterTimeUnit = exports.RelativeDateFilterTimeUnit || (exports.RelativeDateFilterTimeUnit = {}));
                var RelativeDateOperators;
                (function(RelativeDateOperators) {
                    RelativeDateOperators[RelativeDateOperators["InLast"] = 0] = "InLast";
                    RelativeDateOperators[RelativeDateOperators["InThis"] = 1] = "InThis";
                    RelativeDateOperators[RelativeDateOperators["InNext"] = 2] = "InNext";
                })(RelativeDateOperators = exports.RelativeDateOperators || (exports.RelativeDateOperators = {}));
                var Filter = /** @class */ function() {
                    function Filter(target, filterType) {
                        this.target = target;
                        this.filterType = filterType;
                    }
                    Filter.prototype.toJSON = function() {
                        var filter = {
                            $schema: this.schemaUrl,
                            target: this.target,
                            filterType: this.filterType
                        };
                        // Add displaySettings only when defined
                        if (this.displaySettings !== undefined) filter.displaySettings = this.displaySettings;
                        return filter;
                    };
                    return Filter;
                }();
                exports.Filter = Filter;
                var NotSupportedFilter = /** @class */ function(_super) {
                    __extends(NotSupportedFilter, _super);
                    function NotSupportedFilter(target, message, notSupportedTypeName) {
                        var _this = _super.call(this, target, FilterType.Unknown) || this;
                        _this.message = message;
                        _this.notSupportedTypeName = notSupportedTypeName;
                        _this.schemaUrl = NotSupportedFilter.schemaUrl;
                        return _this;
                    }
                    NotSupportedFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.message = this.message;
                        filter.notSupportedTypeName = this.notSupportedTypeName;
                        return filter;
                    };
                    NotSupportedFilter.schemaUrl = "http://powerbi.com/product/schema#notSupported";
                    return NotSupportedFilter;
                }(Filter);
                exports.NotSupportedFilter = NotSupportedFilter;
                var IncludeExcludeFilter = /** @class */ function(_super) {
                    __extends(IncludeExcludeFilter, _super);
                    function IncludeExcludeFilter(target, isExclude, values) {
                        var _this = _super.call(this, target, FilterType.IncludeExclude) || this;
                        _this.target = target;
                        _this.values = values;
                        _this.isExclude = isExclude;
                        _this.schemaUrl = IncludeExcludeFilter.schemaUrl;
                        return _this;
                    }
                    IncludeExcludeFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.isExclude = this.isExclude;
                        filter.values = this.values;
                        return filter;
                    };
                    IncludeExcludeFilter.schemaUrl = "http://powerbi.com/product/schema#includeExclude";
                    return IncludeExcludeFilter;
                }(Filter);
                exports.IncludeExcludeFilter = IncludeExcludeFilter;
                var TopNFilter = /** @class */ function(_super) {
                    __extends(TopNFilter, _super);
                    function TopNFilter(target, operator, itemCount, orderBy) {
                        var _this = _super.call(this, target, FilterType.TopN) || this;
                        _this.operator = operator;
                        _this.itemCount = itemCount;
                        _this.schemaUrl = TopNFilter.schemaUrl;
                        _this.orderBy = orderBy;
                        return _this;
                    }
                    TopNFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.operator = this.operator;
                        filter.itemCount = this.itemCount;
                        filter.orderBy = this.orderBy;
                        return filter;
                    };
                    TopNFilter.schemaUrl = "http://powerbi.com/product/schema#topN";
                    return TopNFilter;
                }(Filter);
                exports.TopNFilter = TopNFilter;
                var RelativeDateFilter = /** @class */ function(_super) {
                    __extends(RelativeDateFilter, _super);
                    function RelativeDateFilter(target, operator, timeUnitsCount, timeUnitType, includeToday) {
                        var _this = _super.call(this, target, FilterType.RelativeDate) || this;
                        _this.operator = operator;
                        _this.timeUnitsCount = timeUnitsCount;
                        _this.timeUnitType = timeUnitType;
                        _this.includeToday = includeToday;
                        _this.schemaUrl = RelativeDateFilter.schemaUrl;
                        return _this;
                    }
                    RelativeDateFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.operator = this.operator;
                        filter.timeUnitsCount = this.timeUnitsCount;
                        filter.timeUnitType = this.timeUnitType;
                        filter.includeToday = this.includeToday;
                        return filter;
                    };
                    RelativeDateFilter.schemaUrl = "http://powerbi.com/product/schema#relativeDate";
                    return RelativeDateFilter;
                }(Filter);
                exports.RelativeDateFilter = RelativeDateFilter;
                var RelativeTimeFilter = /** @class */ function(_super) {
                    __extends(RelativeTimeFilter, _super);
                    function RelativeTimeFilter(target, operator, timeUnitsCount, timeUnitType) {
                        var _this = _super.call(this, target, FilterType.RelativeTime) || this;
                        _this.operator = operator;
                        _this.timeUnitsCount = timeUnitsCount;
                        _this.timeUnitType = timeUnitType;
                        _this.schemaUrl = RelativeTimeFilter.schemaUrl;
                        return _this;
                    }
                    RelativeTimeFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.operator = this.operator;
                        filter.timeUnitsCount = this.timeUnitsCount;
                        filter.timeUnitType = this.timeUnitType;
                        return filter;
                    };
                    RelativeTimeFilter.schemaUrl = "http://powerbi.com/product/schema#relativeTime";
                    return RelativeTimeFilter;
                }(Filter);
                exports.RelativeTimeFilter = RelativeTimeFilter;
                var BasicFilter = /** @class */ function(_super) {
                    __extends(BasicFilter, _super);
                    function BasicFilter(target, operator) {
                        var values = [];
                        for(var _i = 2; _i < arguments.length; _i++)values[_i - 2] = arguments[_i];
                        var _this = _super.call(this, target, FilterType.Basic) || this;
                        _this.operator = operator;
                        _this.schemaUrl = BasicFilter.schemaUrl;
                        if (values.length === 0 && operator !== "All") throw new Error("values must be a non-empty array unless your operator is \"All\".");
                        /**
         * Accept values as array instead of as individual arguments
         * new BasicFilter('a', 'b', 1, 2);
         * new BasicFilter('a', 'b', [1,2]);
         */ if (Array.isArray(values[0])) // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                        _this.values = values[0];
                        else _this.values = values;
                        return _this;
                    }
                    BasicFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.operator = this.operator;
                        filter.values = this.values;
                        filter.requireSingleSelection = !!this.requireSingleSelection;
                        return filter;
                    };
                    BasicFilter.schemaUrl = "http://powerbi.com/product/schema#basic";
                    return BasicFilter;
                }(Filter);
                exports.BasicFilter = BasicFilter;
                var BasicFilterWithKeys = /** @class */ function(_super) {
                    __extends(BasicFilterWithKeys, _super);
                    function BasicFilterWithKeys(target, operator, values, keyValues) {
                        var _this = _super.call(this, target, operator, values) || this;
                        _this.keyValues = keyValues;
                        _this.target = target;
                        var numberOfKeys = target.keys ? target.keys.length : 0;
                        if (numberOfKeys > 0 && !keyValues) throw new Error("You should pass the values to be filtered for each key. You passed: no values and ".concat(numberOfKeys, " keys"));
                        if (numberOfKeys === 0 && keyValues && keyValues.length > 0) throw new Error("You passed key values but your target object doesn't contain the keys to be filtered");
                        for(var _i = 0, _a = _this.keyValues; _i < _a.length; _i++){
                            var keyValue = _a[_i];
                            if (keyValue) {
                                var lengthOfArray = keyValue.length;
                                if (lengthOfArray !== numberOfKeys) throw new Error("Each tuple of key values should contain a value for each of the keys. You passed: ".concat(lengthOfArray, " values and ").concat(numberOfKeys, " keys"));
                            }
                        }
                        return _this;
                    }
                    BasicFilterWithKeys.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.keyValues = this.keyValues;
                        return filter;
                    };
                    return BasicFilterWithKeys;
                }(BasicFilter);
                exports.BasicFilterWithKeys = BasicFilterWithKeys;
                var IdentityFilter = /** @class */ function(_super) {
                    __extends(IdentityFilter, _super);
                    function IdentityFilter(target, operator) {
                        var _this = _super.call(this, target, FilterType.Identity) || this;
                        _this.operator = operator;
                        _this.schemaUrl = IdentityFilter.schemaUrl;
                        return _this;
                    }
                    IdentityFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.operator = this.operator;
                        filter.target = this.target;
                        return filter;
                    };
                    IdentityFilter.schemaUrl = "http://powerbi.com/product/schema#identity";
                    return IdentityFilter;
                }(Filter);
                exports.IdentityFilter = IdentityFilter;
                var TupleFilter = /** @class */ function(_super) {
                    __extends(TupleFilter, _super);
                    function TupleFilter(target, operator, values) {
                        var _this = _super.call(this, target, FilterType.Tuple) || this;
                        _this.operator = operator;
                        _this.schemaUrl = TupleFilter.schemaUrl;
                        _this.values = values;
                        return _this;
                    }
                    TupleFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.operator = this.operator;
                        filter.values = this.values;
                        filter.target = this.target;
                        return filter;
                    };
                    TupleFilter.schemaUrl = "http://powerbi.com/product/schema#tuple";
                    return TupleFilter;
                }(Filter);
                exports.TupleFilter = TupleFilter;
                var AdvancedFilter = /** @class */ function(_super) {
                    __extends(AdvancedFilter, _super);
                    function AdvancedFilter(target, logicalOperator) {
                        var conditions = [];
                        for(var _i = 2; _i < arguments.length; _i++)conditions[_i - 2] = arguments[_i];
                        var _this = _super.call(this, target, FilterType.Advanced) || this;
                        _this.schemaUrl = AdvancedFilter.schemaUrl;
                        // Guard statements
                        if (typeof logicalOperator !== "string" || logicalOperator.length === 0) // TODO: It would be nicer to list out the possible logical operators.
                        throw new Error("logicalOperator must be a valid operator, You passed: ".concat(logicalOperator));
                        _this.logicalOperator = logicalOperator;
                        var extractedConditions;
                        /**
         * Accept conditions as array instead of as individual arguments
         * new AdvancedFilter('a', 'b', "And", { value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" });
         * new AdvancedFilter('a', 'b', "And", [{ value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" }]);
         */ if (Array.isArray(conditions[0])) // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                        extractedConditions = conditions[0];
                        else extractedConditions = conditions;
                        if (extractedConditions.length > 2) throw new Error("AdvancedFilters may not have more than two conditions. You passed: ".concat(conditions.length));
                        if (extractedConditions.length === 1 && logicalOperator !== "And") throw new Error("Logical Operator must be \"And\" when there is only one condition provided");
                        _this.conditions = extractedConditions;
                        return _this;
                    }
                    AdvancedFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.logicalOperator = this.logicalOperator;
                        filter.conditions = this.conditions;
                        return filter;
                    };
                    AdvancedFilter.schemaUrl = "http://powerbi.com/product/schema#advanced";
                    return AdvancedFilter;
                }(Filter);
                exports.AdvancedFilter = AdvancedFilter;
                var HierarchyFilter = /** @class */ function(_super) {
                    __extends(HierarchyFilter, _super);
                    function HierarchyFilter(target, hierarchyData) {
                        var _this = _super.call(this, target, FilterType.Hierarchy) || this;
                        _this.schemaUrl = HierarchyFilter.schemaUrl;
                        _this.hierarchyData = hierarchyData;
                        return _this;
                    }
                    HierarchyFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.hierarchyData = this.hierarchyData;
                        filter.target = this.target;
                        return filter;
                    };
                    HierarchyFilter.schemaUrl = "http://powerbi.com/product/schema#hierarchy";
                    return HierarchyFilter;
                }(Filter);
                exports.HierarchyFilter = HierarchyFilter;
                var HierarchyIdentityFilter = /** @class */ function(_super) {
                    __extends(HierarchyIdentityFilter, _super);
                    function HierarchyIdentityFilter(target, hierarchyData) {
                        var _this = _super.call(this, target, FilterType.HierarchyIdentity) || this;
                        _this.schemaUrl = HierarchyIdentityFilter.schemaUrl;
                        _this.hierarchyData = hierarchyData;
                        return _this;
                    }
                    HierarchyIdentityFilter.prototype.toJSON = function() {
                        var filter = _super.prototype.toJSON.call(this);
                        filter.hierarchyData = this.hierarchyData;
                        filter.target = this.target;
                        return filter;
                    };
                    HierarchyIdentityFilter.schemaUrl = "http://powerbi.com/product/schema#hierarchyIdentity";
                    return HierarchyIdentityFilter;
                }(Filter);
                exports.HierarchyIdentityFilter = HierarchyIdentityFilter;
                function isFilterKeyColumnsTarget(target) {
                    return isColumn(target) && !!target.keys;
                }
                exports.isFilterKeyColumnsTarget = isFilterKeyColumnsTarget;
                function isBasicFilterWithKeys(filter) {
                    return getFilterType(filter) === FilterType.Basic && !!filter.keyValues;
                }
                exports.isBasicFilterWithKeys = isBasicFilterWithKeys;
                function getFilterType(filter) {
                    if (filter.filterType) return filter.filterType;
                    var basicFilter = filter;
                    var advancedFilter = filter;
                    if (typeof basicFilter.operator === "string" && Array.isArray(basicFilter.values)) return FilterType.Basic;
                    else if (typeof advancedFilter.logicalOperator === "string" && Array.isArray(advancedFilter.conditions)) return FilterType.Advanced;
                    else return FilterType.Unknown;
                }
                exports.getFilterType = getFilterType;
                function isMeasure(arg) {
                    return arg.table !== undefined && arg.measure !== undefined;
                }
                exports.isMeasure = isMeasure;
                function isColumn(arg) {
                    return !!(arg.table && arg.column && !arg.aggregationFunction);
                }
                exports.isColumn = isColumn;
                function isHierarchyLevel(arg) {
                    return !!(arg.table && arg.hierarchy && arg.hierarchyLevel && !arg.aggregationFunction);
                }
                exports.isHierarchyLevel = isHierarchyLevel;
                function isHierarchyLevelAggr(arg) {
                    return !!(arg.table && arg.hierarchy && arg.hierarchyLevel && arg.aggregationFunction);
                }
                exports.isHierarchyLevelAggr = isHierarchyLevelAggr;
                function isColumnAggr(arg) {
                    return !!(arg.table && arg.column && arg.aggregationFunction);
                }
                exports.isColumnAggr = isColumnAggr;
                function isPercentOfGrandTotal(arg) {
                    return !!arg.percentOfGrandTotal;
                }
                exports.isPercentOfGrandTotal = isPercentOfGrandTotal;
                var CredentialType;
                (function(CredentialType) {
                    CredentialType[CredentialType["NoConnection"] = 0] = "NoConnection";
                    CredentialType[CredentialType["OnBehalfOf"] = 1] = "OnBehalfOf";
                    CredentialType[CredentialType["Anonymous"] = 2] = "Anonymous";
                })(CredentialType = exports.CredentialType || (exports.CredentialType = {}));
                var DataCacheMode;
                (function(DataCacheMode) {
                    DataCacheMode[DataCacheMode["Import"] = 0] = "Import";
                    DataCacheMode[DataCacheMode["DirectQuery"] = 1] = "DirectQuery";
                })(DataCacheMode = exports.DataCacheMode || (exports.DataCacheMode = {}));
                var AggregateFunction;
                (function(AggregateFunction) {
                    AggregateFunction[AggregateFunction["Default"] = 1] = "Default";
                    AggregateFunction[AggregateFunction["None"] = 2] = "None";
                    AggregateFunction[AggregateFunction["Sum"] = 3] = "Sum";
                    AggregateFunction[AggregateFunction["Min"] = 4] = "Min";
                    AggregateFunction[AggregateFunction["Max"] = 5] = "Max";
                    AggregateFunction[AggregateFunction["Count"] = 6] = "Count";
                    AggregateFunction[AggregateFunction["Average"] = 7] = "Average";
                    AggregateFunction[AggregateFunction["DistinctCount"] = 8] = "DistinctCount";
                })(AggregateFunction = exports.AggregateFunction || (exports.AggregateFunction = {}));
                var BrowserPrintAdjustmentsMode;
                (function(BrowserPrintAdjustmentsMode) {
                    BrowserPrintAdjustmentsMode[BrowserPrintAdjustmentsMode["Default"] = 0] = "Default";
                    BrowserPrintAdjustmentsMode[BrowserPrintAdjustmentsMode["NoAdjustments"] = 1] = "NoAdjustments";
                })(BrowserPrintAdjustmentsMode = exports.BrowserPrintAdjustmentsMode || (exports.BrowserPrintAdjustmentsMode = {}));
                var PageNavigationPosition;
                (function(PageNavigationPosition) {
                    PageNavigationPosition[PageNavigationPosition["Bottom"] = 0] = "Bottom";
                    PageNavigationPosition[PageNavigationPosition["Left"] = 1] = "Left";
                })(PageNavigationPosition = exports.PageNavigationPosition || (exports.PageNavigationPosition = {}));
                var QnaMode;
                (function(QnaMode) {
                    QnaMode[QnaMode["Interactive"] = 0] = "Interactive";
                    QnaMode[QnaMode["ResultOnly"] = 1] = "ResultOnly";
                })(QnaMode = exports.QnaMode || (exports.QnaMode = {}));
                var ExportDataType;
                (function(ExportDataType) {
                    ExportDataType[ExportDataType["Summarized"] = 0] = "Summarized";
                    ExportDataType[ExportDataType["Underlying"] = 1] = "Underlying";
                })(ExportDataType = exports.ExportDataType || (exports.ExportDataType = {}));
                var BookmarksPlayMode;
                (function(BookmarksPlayMode) {
                    BookmarksPlayMode[BookmarksPlayMode["Off"] = 0] = "Off";
                    BookmarksPlayMode[BookmarksPlayMode["Presentation"] = 1] = "Presentation";
                })(BookmarksPlayMode = exports.BookmarksPlayMode || (exports.BookmarksPlayMode = {}));
                // This is not an enum because enum strings require
                // us to upgrade typeScript version and change SDK build definition
                exports.CommonErrorCodes = {
                    TokenExpired: 'TokenExpired',
                    NotFound: 'PowerBIEntityNotFound',
                    InvalidParameters: 'Invalid parameters',
                    LoadReportFailed: 'LoadReportFailed',
                    NotAuthorized: 'PowerBINotAuthorizedException',
                    FailedToLoadModel: 'ExplorationContainer_FailedToLoadModel_DefaultDetails'
                };
                exports.TextAlignment = {
                    Left: 'left',
                    Center: 'center',
                    Right: 'right'
                };
                exports.LegendPosition = {
                    Top: 'Top',
                    Bottom: 'Bottom',
                    Right: 'Right',
                    Left: 'Left',
                    TopCenter: 'TopCenter',
                    BottomCenter: 'BottomCenter',
                    RightCenter: 'RightCenter',
                    LeftCenter: 'LeftCenter'
                };
                var SortDirection;
                (function(SortDirection) {
                    SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
                    SortDirection[SortDirection["Descending"] = 2] = "Descending";
                })(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
                var Selector = /** @class */ function() {
                    function Selector(schema) {
                        this.$schema = schema;
                    }
                    Selector.prototype.toJSON = function() {
                        return {
                            $schema: this.$schema
                        };
                    };
                    return Selector;
                }();
                exports.Selector = Selector;
                var PageSelector = /** @class */ function(_super) {
                    __extends(PageSelector, _super);
                    function PageSelector(pageName) {
                        var _this = _super.call(this, PageSelector.schemaUrl) || this;
                        _this.pageName = pageName;
                        return _this;
                    }
                    PageSelector.prototype.toJSON = function() {
                        var selector = _super.prototype.toJSON.call(this);
                        selector.pageName = this.pageName;
                        return selector;
                    };
                    PageSelector.schemaUrl = "http://powerbi.com/product/schema#pageSelector";
                    return PageSelector;
                }(Selector);
                exports.PageSelector = PageSelector;
                var VisualSelector = /** @class */ function(_super) {
                    __extends(VisualSelector, _super);
                    function VisualSelector(visualName) {
                        var _this = _super.call(this, VisualSelector.schemaUrl) || this;
                        _this.visualName = visualName;
                        return _this;
                    }
                    VisualSelector.prototype.toJSON = function() {
                        var selector = _super.prototype.toJSON.call(this);
                        selector.visualName = this.visualName;
                        return selector;
                    };
                    VisualSelector.schemaUrl = "http://powerbi.com/product/schema#visualSelector";
                    return VisualSelector;
                }(Selector);
                exports.VisualSelector = VisualSelector;
                var VisualTypeSelector = /** @class */ function(_super) {
                    __extends(VisualTypeSelector, _super);
                    function VisualTypeSelector(visualType) {
                        var _this = _super.call(this, VisualSelector.schemaUrl) || this;
                        _this.visualType = visualType;
                        return _this;
                    }
                    VisualTypeSelector.prototype.toJSON = function() {
                        var selector = _super.prototype.toJSON.call(this);
                        selector.visualType = this.visualType;
                        return selector;
                    };
                    VisualTypeSelector.schemaUrl = "http://powerbi.com/product/schema#visualTypeSelector";
                    return VisualTypeSelector;
                }(Selector);
                exports.VisualTypeSelector = VisualTypeSelector;
                var SlicerTargetSelector = /** @class */ function(_super) {
                    __extends(SlicerTargetSelector, _super);
                    function SlicerTargetSelector(target) {
                        var _this = _super.call(this, VisualSelector.schemaUrl) || this;
                        _this.target = target;
                        return _this;
                    }
                    SlicerTargetSelector.prototype.toJSON = function() {
                        var selector = _super.prototype.toJSON.call(this);
                        selector.target = this.target;
                        return selector;
                    };
                    SlicerTargetSelector.schemaUrl = "http://powerbi.com/product/schema#slicerTargetSelector";
                    return SlicerTargetSelector;
                }(Selector);
                exports.SlicerTargetSelector = SlicerTargetSelector;
                var CommandDisplayOption;
                (function(CommandDisplayOption) {
                    CommandDisplayOption[CommandDisplayOption["Enabled"] = 0] = "Enabled";
                    CommandDisplayOption[CommandDisplayOption["Disabled"] = 1] = "Disabled";
                    CommandDisplayOption[CommandDisplayOption["Hidden"] = 2] = "Hidden";
                })(CommandDisplayOption = exports.CommandDisplayOption || (exports.CommandDisplayOption = {}));
                /*
 * Visual CRUD
 */ var VisualDataRoleKind;
                (function(VisualDataRoleKind) {
                    // Indicates that the role should be bound to something that evaluates to a grouping of values.
                    VisualDataRoleKind[VisualDataRoleKind["Grouping"] = 0] = "Grouping";
                    // Indicates that the role should be bound to something that evaluates to a single value in a scope.
                    VisualDataRoleKind[VisualDataRoleKind["Measure"] = 1] = "Measure";
                    // Indicates that the role can be bound to either Grouping or Measure.
                    VisualDataRoleKind[VisualDataRoleKind["GroupingOrMeasure"] = 2] = "GroupingOrMeasure";
                })(VisualDataRoleKind = exports.VisualDataRoleKind || (exports.VisualDataRoleKind = {}));
                // Indicates the visual preference on Grouping or Measure. Only applicable if kind is GroupingOrMeasure.
                var VisualDataRoleKindPreference;
                (function(VisualDataRoleKindPreference) {
                    VisualDataRoleKindPreference[VisualDataRoleKindPreference["Measure"] = 0] = "Measure";
                    VisualDataRoleKindPreference[VisualDataRoleKindPreference["Grouping"] = 1] = "Grouping";
                })(VisualDataRoleKindPreference = exports.VisualDataRoleKindPreference || (exports.VisualDataRoleKindPreference = {}));
                function isOnLoadFilters(filters) {
                    return filters && !isReportFiltersArray(filters);
                }
                exports.isOnLoadFilters = isOnLoadFilters;
                function isReportFiltersArray(filters) {
                    return Array.isArray(filters);
                }
                exports.isReportFiltersArray = isReportFiltersArray;
                function isFlatMenuExtension(menuExtension) {
                    return menuExtension && !isGroupedMenuExtension(menuExtension);
                }
                exports.isFlatMenuExtension = isFlatMenuExtension;
                function isGroupedMenuExtension(menuExtension) {
                    return menuExtension && !!menuExtension.groupName;
                }
                exports.isGroupedMenuExtension = isGroupedMenuExtension;
                function isIExtensions(extensions) {
                    return extensions && !isIExtensionArray(extensions);
                }
                exports.isIExtensions = isIExtensions;
                function isIExtensionArray(extensions) {
                    return Array.isArray(extensions);
                }
                exports.isIExtensionArray = isIExtensionArray;
                function normalizeError(error) {
                    var message = error.message;
                    if (!message) message = "".concat(error.path, " is invalid. Not meeting ").concat(error.keyword, " constraint");
                    return {
                        message: message
                    };
                }
                function validateVisualSelector(input) {
                    var errors = validator_1.Validators.visualSelectorValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateVisualSelector = validateVisualSelector;
                function validateSlicer(input) {
                    var errors = validator_1.Validators.slicerValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateSlicer = validateSlicer;
                function validateSlicerState(input) {
                    var errors = validator_1.Validators.slicerStateValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateSlicerState = validateSlicerState;
                function validatePlayBookmarkRequest(input) {
                    var errors = validator_1.Validators.playBookmarkRequestValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validatePlayBookmarkRequest = validatePlayBookmarkRequest;
                function validateAddBookmarkRequest(input) {
                    var errors = validator_1.Validators.addBookmarkRequestValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateAddBookmarkRequest = validateAddBookmarkRequest;
                function validateApplyBookmarkByNameRequest(input) {
                    var errors = validator_1.Validators.applyBookmarkByNameRequestValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateApplyBookmarkByNameRequest = validateApplyBookmarkByNameRequest;
                function validateApplyBookmarkStateRequest(input) {
                    var errors = validator_1.Validators.applyBookmarkStateRequestValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateApplyBookmarkStateRequest = validateApplyBookmarkStateRequest;
                function validateCaptureBookmarkRequest(input) {
                    var errors = validator_1.Validators.captureBookmarkRequestValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateCaptureBookmarkRequest = validateCaptureBookmarkRequest;
                function validateSettings(input) {
                    var errors = validator_1.Validators.settingsValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateSettings = validateSettings;
                function validatePanes(input) {
                    var errors = validator_1.Validators.reportPanesValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validatePanes = validatePanes;
                function validateBookmarksPane(input) {
                    var errors = validator_1.Validators.bookmarksPaneValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateBookmarksPane = validateBookmarksPane;
                function validateFiltersPane(input) {
                    var errors = validator_1.Validators.filtersPaneValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateFiltersPane = validateFiltersPane;
                function validateFieldsPane(input) {
                    var errors = validator_1.Validators.fieldsPaneValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateFieldsPane = validateFieldsPane;
                function validatePageNavigationPane(input) {
                    var errors = validator_1.Validators.pageNavigationPaneValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validatePageNavigationPane = validatePageNavigationPane;
                function validateSelectionPane(input) {
                    var errors = validator_1.Validators.selectionPaneValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateSelectionPane = validateSelectionPane;
                function validateSyncSlicersPane(input) {
                    var errors = validator_1.Validators.syncSlicersPaneValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateSyncSlicersPane = validateSyncSlicersPane;
                function validateVisualizationsPane(input) {
                    var errors = validator_1.Validators.visualizationsPaneValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateVisualizationsPane = validateVisualizationsPane;
                function validateCustomPageSize(input) {
                    var errors = validator_1.Validators.customPageSizeValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateCustomPageSize = validateCustomPageSize;
                function validateExtension(input) {
                    var errors = validator_1.Validators.extensionValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateExtension = validateExtension;
                function validateMenuGroupExtension(input) {
                    var errors = validator_1.Validators.menuGroupExtensionValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateMenuGroupExtension = validateMenuGroupExtension;
                function validateReportLoad(input) {
                    var errors = validator_1.Validators.reportLoadValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateReportLoad = validateReportLoad;
                function validatePaginatedReportLoad(input) {
                    var errors = validator_1.Validators.paginatedReportLoadValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validatePaginatedReportLoad = validatePaginatedReportLoad;
                function validateCreateReport(input) {
                    var errors = validator_1.Validators.reportCreateValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateCreateReport = validateCreateReport;
                function validateQuickCreate(input) {
                    var errors = validator_1.Validators.quickCreateValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateQuickCreate = validateQuickCreate;
                function validateDashboardLoad(input) {
                    var errors = validator_1.Validators.dashboardLoadValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateDashboardLoad = validateDashboardLoad;
                function validateTileLoad(input) {
                    var errors = validator_1.Validators.tileLoadValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateTileLoad = validateTileLoad;
                function validatePage(input) {
                    var errors = validator_1.Validators.pageValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validatePage = validatePage;
                function validateFilter(input) {
                    var errors = validator_1.Validators.filterValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateFilter = validateFilter;
                function validateUpdateFiltersRequest(input) {
                    var errors = validator_1.Validators.updateFiltersRequestValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateUpdateFiltersRequest = validateUpdateFiltersRequest;
                function validateSaveAsParameters(input) {
                    var errors = validator_1.Validators.saveAsParametersValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateSaveAsParameters = validateSaveAsParameters;
                function validateLoadQnaConfiguration(input) {
                    var errors = validator_1.Validators.loadQnaValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateLoadQnaConfiguration = validateLoadQnaConfiguration;
                function validateQnaInterpretInputData(input) {
                    var errors = validator_1.Validators.qnaInterpretInputDataValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateQnaInterpretInputData = validateQnaInterpretInputData;
                function validateExportDataRequest(input) {
                    var errors = validator_1.Validators.exportDataRequestValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateExportDataRequest = validateExportDataRequest;
                function validateVisualHeader(input) {
                    var errors = validator_1.Validators.visualHeaderValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateVisualHeader = validateVisualHeader;
                function validateVisualSettings(input) {
                    var errors = validator_1.Validators.visualSettingsValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateVisualSettings = validateVisualSettings;
                function validateCommandsSettings(input) {
                    var errors = validator_1.Validators.commandsSettingsValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateCommandsSettings = validateCommandsSettings;
                function validateCustomTheme(input) {
                    var errors = validator_1.Validators.customThemeValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateCustomTheme = validateCustomTheme;
                function validateZoomLevel(input) {
                    var errors = validator_1.Validators.zoomLevelValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validateZoomLevel = validateZoomLevel;
                function validatePrintSettings(input) {
                    var errors = validator_1.Validators.printSettingsValidator.validate(input);
                    return errors ? errors.map(normalizeError) : undefined;
                }
                exports.validatePrintSettings = validatePrintSettings;
            /***/ },
            /* 1 */ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Validators = void 0;
                var barsValidator_1 = __webpack_require__(2);
                var bookmarkValidator_1 = __webpack_require__(5);
                var commandsSettingsValidator_1 = __webpack_require__(6);
                var customThemeValidator_1 = __webpack_require__(7);
                var dashboardLoadValidator_1 = __webpack_require__(8);
                var datasetBindingValidator_1 = __webpack_require__(9);
                var exportDataValidator_1 = __webpack_require__(10);
                var extensionsValidator_1 = __webpack_require__(11);
                var filtersValidator_1 = __webpack_require__(12);
                var layoutValidator_1 = __webpack_require__(13);
                var pageValidator_1 = __webpack_require__(14);
                var panesValidator_1 = __webpack_require__(15);
                var qnaValidator_1 = __webpack_require__(16);
                var reportCreateValidator_1 = __webpack_require__(17);
                var reportLoadValidator_1 = __webpack_require__(18);
                var paginatedReportLoadValidator_1 = __webpack_require__(19);
                var saveAsParametersValidator_1 = __webpack_require__(20);
                var selectorsValidator_1 = __webpack_require__(21);
                var settingsValidator_1 = __webpack_require__(22);
                var slicersValidator_1 = __webpack_require__(23);
                var tileLoadValidator_1 = __webpack_require__(24);
                var visualSettingsValidator_1 = __webpack_require__(25);
                var anyOfValidator_1 = __webpack_require__(26);
                var fieldForbiddenValidator_1 = __webpack_require__(27);
                var fieldRequiredValidator_1 = __webpack_require__(28);
                var mapValidator_1 = __webpack_require__(29);
                var typeValidator_1 = __webpack_require__(4);
                var parameterPanelValidator_1 = __webpack_require__(30);
                var datasetCreateConfigValidator_1 = __webpack_require__(31);
                var quickCreateValidator_1 = __webpack_require__(32);
                var printSettingsValidator_1 = __webpack_require__(33);
                var paginatedReportDatasetBindingValidator_1 = __webpack_require__(34);
                exports.Validators = {
                    addBookmarkRequestValidator: new bookmarkValidator_1.AddBookmarkRequestValidator(),
                    advancedFilterTypeValidator: new typeValidator_1.EnumValidator([
                        0
                    ]),
                    advancedFilterValidator: new filtersValidator_1.AdvancedFilterValidator(),
                    anyArrayValidator: new typeValidator_1.ArrayValidator([
                        new anyOfValidator_1.AnyOfValidator([
                            new typeValidator_1.StringValidator(),
                            new typeValidator_1.NumberValidator(),
                            new typeValidator_1.BooleanValidator()
                        ])
                    ]),
                    anyFilterValidator: new anyOfValidator_1.AnyOfValidator([
                        new filtersValidator_1.BasicFilterValidator(),
                        new filtersValidator_1.AdvancedFilterValidator(),
                        new filtersValidator_1.IncludeExcludeFilterValidator(),
                        new filtersValidator_1.NotSupportedFilterValidator(),
                        new filtersValidator_1.RelativeDateFilterValidator(),
                        new filtersValidator_1.TopNFilterValidator(),
                        new filtersValidator_1.RelativeTimeFilterValidator(),
                        new filtersValidator_1.HierarchyFilterValidator()
                    ]),
                    anyValueValidator: new anyOfValidator_1.AnyOfValidator([
                        new typeValidator_1.StringValidator(),
                        new typeValidator_1.NumberValidator(),
                        new typeValidator_1.BooleanValidator()
                    ]),
                    actionBarValidator: new barsValidator_1.ActionBarValidator(),
                    statusBarValidator: new barsValidator_1.StatusBarValidator(),
                    applyBookmarkByNameRequestValidator: new bookmarkValidator_1.ApplyBookmarkByNameRequestValidator(),
                    applyBookmarkStateRequestValidator: new bookmarkValidator_1.ApplyBookmarkStateRequestValidator(),
                    applyBookmarkValidator: new anyOfValidator_1.AnyOfValidator([
                        new bookmarkValidator_1.ApplyBookmarkByNameRequestValidator(),
                        new bookmarkValidator_1.ApplyBookmarkStateRequestValidator()
                    ]),
                    backgroundValidator: new typeValidator_1.EnumValidator([
                        0,
                        1
                    ]),
                    basicFilterTypeValidator: new typeValidator_1.EnumValidator([
                        1
                    ]),
                    basicFilterValidator: new filtersValidator_1.BasicFilterValidator(),
                    booleanArrayValidator: new typeValidator_1.BooleanArrayValidator(),
                    booleanValidator: new typeValidator_1.BooleanValidator(),
                    bookmarksPaneValidator: new panesValidator_1.BookmarksPaneValidator(),
                    captureBookmarkOptionsValidator: new bookmarkValidator_1.CaptureBookmarkOptionsValidator(),
                    captureBookmarkRequestValidator: new bookmarkValidator_1.CaptureBookmarkRequestValidator(),
                    columnSchemaArrayValidator: new typeValidator_1.ArrayValidator([
                        new datasetCreateConfigValidator_1.ColumnSchemaValidator()
                    ]),
                    commandDisplayOptionValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2
                    ]),
                    commandExtensionSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                        new selectorsValidator_1.VisualSelectorValidator(),
                        new selectorsValidator_1.VisualTypeSelectorValidator()
                    ]),
                    commandExtensionArrayValidator: new typeValidator_1.ArrayValidator([
                        new extensionsValidator_1.CommandExtensionValidator()
                    ]),
                    commandExtensionValidator: new extensionsValidator_1.CommandExtensionValidator(),
                    commandsSettingsArrayValidator: new typeValidator_1.ArrayValidator([
                        new commandsSettingsValidator_1.CommandsSettingsValidator()
                    ]),
                    commandsSettingsValidator: new commandsSettingsValidator_1.CommandsSettingsValidator(),
                    conditionItemValidator: new filtersValidator_1.ConditionItemValidator(),
                    contrastModeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2,
                        3,
                        4
                    ]),
                    credentialDetailsValidator: new mapValidator_1.MapValidator([
                        new typeValidator_1.StringValidator()
                    ], [
                        new typeValidator_1.StringValidator()
                    ]),
                    credentialsValidator: new datasetCreateConfigValidator_1.CredentialsValidator(),
                    credentialTypeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2
                    ]),
                    customLayoutDisplayOptionValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2
                    ]),
                    customLayoutValidator: new layoutValidator_1.CustomLayoutValidator(),
                    customPageSizeValidator: new pageValidator_1.CustomPageSizeValidator(),
                    customThemeValidator: new customThemeValidator_1.CustomThemeValidator(),
                    dashboardLoadValidator: new dashboardLoadValidator_1.DashboardLoadValidator(),
                    dataCacheModeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1
                    ]),
                    datasetBindingValidator: new datasetBindingValidator_1.DatasetBindingValidator(),
                    datasetCreateConfigValidator: new datasetCreateConfigValidator_1.DatasetCreateConfigValidator(),
                    datasourceConnectionConfigValidator: new datasetCreateConfigValidator_1.DatasourceConnectionConfigValidator(),
                    displayStateModeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1
                    ]),
                    displayStateValidator: new layoutValidator_1.DisplayStateValidator(),
                    exportDataRequestValidator: new exportDataValidator_1.ExportDataRequestValidator(),
                    extensionArrayValidator: new typeValidator_1.ArrayValidator([
                        new extensionsValidator_1.ExtensionValidator()
                    ]),
                    extensionsValidator: new anyOfValidator_1.AnyOfValidator([
                        new typeValidator_1.ArrayValidator([
                            new extensionsValidator_1.ExtensionValidator()
                        ]),
                        new extensionsValidator_1.ExtensionsValidator()
                    ]),
                    extensionPointsValidator: new extensionsValidator_1.ExtensionPointsValidator(),
                    extensionValidator: new extensionsValidator_1.ExtensionValidator(),
                    fieldForbiddenValidator: new fieldForbiddenValidator_1.FieldForbiddenValidator(),
                    fieldRequiredValidator: new fieldRequiredValidator_1.FieldRequiredValidator(),
                    fieldsPaneValidator: new panesValidator_1.FieldsPaneValidator(),
                    filterColumnTargetValidator: new filtersValidator_1.FilterColumnTargetValidator(),
                    filterDisplaySettingsValidator: new filtersValidator_1.FilterDisplaySettingsValidator(),
                    filterConditionsValidator: new typeValidator_1.ArrayValidator([
                        new filtersValidator_1.ConditionItemValidator()
                    ]),
                    filterHierarchyTargetValidator: new filtersValidator_1.FilterHierarchyTargetValidator(),
                    filterMeasureTargetValidator: new filtersValidator_1.FilterMeasureTargetValidator(),
                    filterTargetValidator: new anyOfValidator_1.AnyOfValidator([
                        new filtersValidator_1.FilterColumnTargetValidator(),
                        new filtersValidator_1.FilterHierarchyTargetValidator(),
                        new filtersValidator_1.FilterMeasureTargetValidator(),
                        new typeValidator_1.ArrayValidator([
                            new anyOfValidator_1.AnyOfValidator([
                                new filtersValidator_1.FilterColumnTargetValidator(),
                                new filtersValidator_1.FilterHierarchyTargetValidator(),
                                new filtersValidator_1.FilterMeasureTargetValidator(),
                                new filtersValidator_1.FilterKeyColumnsTargetValidator(),
                                new filtersValidator_1.FilterKeyHierarchyTargetValidator(),
                                new typeValidator_1.ArrayValidator([
                                    new anyOfValidator_1.AnyOfValidator([
                                        new filtersValidator_1.FilterColumnTargetValidator(),
                                        new filtersValidator_1.FilterHierarchyTargetValidator(),
                                        new filtersValidator_1.FilterMeasureTargetValidator(),
                                        new filtersValidator_1.FilterKeyColumnsTargetValidator(),
                                        new filtersValidator_1.FilterKeyHierarchyTargetValidator()
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    filterValidator: new filtersValidator_1.FilterValidator(),
                    filterTypeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        9
                    ]),
                    filtersArrayValidator: new typeValidator_1.ArrayValidator([
                        new filtersValidator_1.FilterValidator()
                    ]),
                    filtersOperationsUpdateValidator: new typeValidator_1.EnumValidator([
                        1,
                        2,
                        3
                    ]),
                    filtersOperationsRemoveAllValidator: new typeValidator_1.EnumValidator([
                        0
                    ]),
                    filtersPaneValidator: new panesValidator_1.FiltersPaneValidator(),
                    hyperlinkClickBehaviorValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2
                    ]),
                    includeExcludeFilterValidator: new filtersValidator_1.IncludeExcludeFilterValidator(),
                    includeExludeFilterTypeValidator: new typeValidator_1.EnumValidator([
                        3
                    ]),
                    includeExcludeFilterValuesValidator: new typeValidator_1.ArrayValidator([
                        new anyOfValidator_1.AnyOfValidator([
                            new typeValidator_1.StringValidator(),
                            new typeValidator_1.NumberValidator(),
                            new typeValidator_1.BooleanValidator(),
                            new typeValidator_1.ArrayValidator([
                                new typeValidator_1.ArrayValidator([
                                    new filtersValidator_1.IncludeExcludePointValueValidator()
                                ])
                            ])
                        ])
                    ]),
                    hierarchyFilterTypeValidator: new typeValidator_1.EnumValidator([
                        9
                    ]),
                    hierarchyFilterValuesValidator: new typeValidator_1.ArrayValidator([
                        new filtersValidator_1.HierarchyFilterNodeValidator()
                    ]),
                    layoutTypeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2,
                        3
                    ]),
                    loadQnaValidator: new qnaValidator_1.LoadQnaValidator(),
                    menuExtensionValidator: new anyOfValidator_1.AnyOfValidator([
                        new extensionsValidator_1.FlatMenuExtensionValidator(),
                        new extensionsValidator_1.GroupedMenuExtensionValidator()
                    ]),
                    menuGroupExtensionArrayValidator: new typeValidator_1.ArrayValidator([
                        new extensionsValidator_1.MenuGroupExtensionValidator()
                    ]),
                    menuGroupExtensionValidator: new extensionsValidator_1.MenuGroupExtensionValidator(),
                    menuLocationValidator: new typeValidator_1.EnumValidator([
                        0,
                        1
                    ]),
                    notSupportedFilterTypeValidator: new typeValidator_1.EnumValidator([
                        2
                    ]),
                    notSupportedFilterValidator: new filtersValidator_1.NotSupportedFilterValidator(),
                    numberArrayValidator: new typeValidator_1.NumberArrayValidator(),
                    numberValidator: new typeValidator_1.NumberValidator(),
                    onLoadFiltersBaseValidator: new anyOfValidator_1.AnyOfValidator([
                        new filtersValidator_1.OnLoadFiltersBaseValidator(),
                        new filtersValidator_1.OnLoadFiltersBaseRemoveOperationValidator()
                    ]),
                    pageLayoutValidator: new mapValidator_1.MapValidator([
                        new typeValidator_1.StringValidator()
                    ], [
                        new layoutValidator_1.VisualLayoutValidator()
                    ]),
                    pageNavigationPaneValidator: new panesValidator_1.PageNavigationPaneValidator(),
                    pageNavigationPositionValidator: new typeValidator_1.EnumValidator([
                        0,
                        1
                    ]),
                    pageSizeTypeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2,
                        3,
                        4,
                        5
                    ]),
                    pageSizeValidator: new pageValidator_1.PageSizeValidator(),
                    pageValidator: new pageValidator_1.PageValidator(),
                    pageViewFieldValidator: new pageValidator_1.PageViewFieldValidator(),
                    pagesLayoutValidator: new mapValidator_1.MapValidator([
                        new typeValidator_1.StringValidator()
                    ], [
                        new layoutValidator_1.PageLayoutValidator()
                    ]),
                    paginatedReportCommandsValidator: new commandsSettingsValidator_1.PaginatedReportCommandsValidator(),
                    paginatedReportDatasetBindingArrayValidator: new typeValidator_1.ArrayValidator([
                        new paginatedReportDatasetBindingValidator_1.PaginatedReportDatasetBindingValidator()
                    ]),
                    paginatedReportLoadValidator: new paginatedReportLoadValidator_1.PaginatedReportLoadValidator(),
                    paginatedReportsettingsValidator: new settingsValidator_1.PaginatedReportSettingsValidator(),
                    parameterValuesArrayValidator: new typeValidator_1.ArrayValidator([
                        new paginatedReportLoadValidator_1.ReportParameterFieldsValidator()
                    ]),
                    parametersPanelValidator: new parameterPanelValidator_1.ParametersPanelValidator(),
                    permissionsValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2,
                        4,
                        7
                    ]),
                    playBookmarkRequestValidator: new bookmarkValidator_1.PlayBookmarkRequestValidator(),
                    printSettingsValidator: new printSettingsValidator_1.PrintSettingsValidator(),
                    qnaInterpretInputDataValidator: new qnaValidator_1.QnaInterpretInputDataValidator(),
                    qnaPanesValidator: new panesValidator_1.QnaPanesValidator(),
                    qnaSettingValidator: new qnaValidator_1.QnaSettingsValidator(),
                    quickCreateValidator: new quickCreateValidator_1.QuickCreateValidator(),
                    rawDataValidator: new typeValidator_1.ArrayValidator([
                        new typeValidator_1.ArrayValidator([
                            new typeValidator_1.StringValidator()
                        ])
                    ]),
                    relativeDateFilterOperatorValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2
                    ]),
                    relativeDateFilterTimeUnitTypeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6
                    ]),
                    relativeDateFilterTypeValidator: new typeValidator_1.EnumValidator([
                        4
                    ]),
                    relativeDateFilterValidator: new filtersValidator_1.RelativeDateFilterValidator(),
                    relativeDateTimeFilterTypeValidator: new typeValidator_1.EnumValidator([
                        4,
                        7
                    ]),
                    relativeDateTimeFilterUnitTypeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8
                    ]),
                    relativeTimeFilterTimeUnitTypeValidator: new typeValidator_1.EnumValidator([
                        7,
                        8
                    ]),
                    relativeTimeFilterTypeValidator: new typeValidator_1.EnumValidator([
                        7
                    ]),
                    relativeTimeFilterValidator: new filtersValidator_1.RelativeTimeFilterValidator(),
                    reportBarsValidator: new barsValidator_1.ReportBarsValidator(),
                    reportCreateValidator: new reportCreateValidator_1.ReportCreateValidator(),
                    reportLoadFiltersValidator: new anyOfValidator_1.AnyOfValidator([
                        new typeValidator_1.ArrayValidator([
                            new filtersValidator_1.FilterValidator()
                        ]),
                        new filtersValidator_1.OnLoadFiltersValidator()
                    ]),
                    reportLoadValidator: new reportLoadValidator_1.ReportLoadValidator(),
                    reportPanesValidator: new panesValidator_1.ReportPanesValidator(),
                    saveAsParametersValidator: new saveAsParametersValidator_1.SaveAsParametersValidator(),
                    selectionPaneValidator: new panesValidator_1.SelectionPaneValidator(),
                    settingsValidator: new settingsValidator_1.SettingsValidator(),
                    singleCommandSettingsValidator: new commandsSettingsValidator_1.SingleCommandSettingsValidator(),
                    slicerSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                        new selectorsValidator_1.VisualSelectorValidator(),
                        new selectorsValidator_1.SlicerTargetSelectorValidator()
                    ]),
                    slicerStateValidator: new slicersValidator_1.SlicerStateValidator(),
                    slicerTargetValidator: new anyOfValidator_1.AnyOfValidator([
                        new filtersValidator_1.FilterColumnTargetValidator(),
                        new filtersValidator_1.FilterHierarchyTargetValidator(),
                        new filtersValidator_1.FilterMeasureTargetValidator(),
                        new filtersValidator_1.FilterKeyColumnsTargetValidator(),
                        new filtersValidator_1.FilterKeyHierarchyTargetValidator()
                    ]),
                    slicerValidator: new slicersValidator_1.SlicerValidator(),
                    stringArrayValidator: new typeValidator_1.StringArrayValidator(),
                    stringValidator: new typeValidator_1.StringValidator(),
                    syncSlicersPaneValidator: new panesValidator_1.SyncSlicersPaneValidator(),
                    tableDataArrayValidator: new typeValidator_1.ArrayValidator([
                        new datasetCreateConfigValidator_1.TableDataValidator()
                    ]),
                    tableSchemaListValidator: new typeValidator_1.ArrayValidator([
                        new datasetCreateConfigValidator_1.TableSchemaValidator()
                    ]),
                    tileLoadValidator: new tileLoadValidator_1.TileLoadValidator(),
                    tokenTypeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1
                    ]),
                    topNFilterTypeValidator: new typeValidator_1.EnumValidator([
                        5
                    ]),
                    topNFilterValidator: new filtersValidator_1.TopNFilterValidator(),
                    updateFiltersRequestValidator: new anyOfValidator_1.AnyOfValidator([
                        new filtersValidator_1.UpdateFiltersRequestValidator(),
                        new filtersValidator_1.RemoveFiltersRequestValidator()
                    ]),
                    viewModeValidator: new typeValidator_1.EnumValidator([
                        0,
                        1
                    ]),
                    visualCommandSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                        new selectorsValidator_1.VisualSelectorValidator(),
                        new selectorsValidator_1.VisualTypeSelectorValidator()
                    ]),
                    visualHeaderSelectorValidator: new anyOfValidator_1.AnyOfValidator([
                        new selectorsValidator_1.VisualSelectorValidator(),
                        new selectorsValidator_1.VisualTypeSelectorValidator()
                    ]),
                    visualHeaderSettingsValidator: new visualSettingsValidator_1.VisualHeaderSettingsValidator(),
                    visualHeaderValidator: new visualSettingsValidator_1.VisualHeaderValidator(),
                    visualHeadersValidator: new typeValidator_1.ArrayValidator([
                        new visualSettingsValidator_1.VisualHeaderValidator()
                    ]),
                    visualizationsPaneValidator: new panesValidator_1.VisualizationsPaneValidator(),
                    visualLayoutValidator: new layoutValidator_1.VisualLayoutValidator(),
                    visualSelectorValidator: new selectorsValidator_1.VisualSelectorValidator(),
                    visualSettingsValidator: new visualSettingsValidator_1.VisualSettingsValidator(),
                    visualTypeSelectorValidator: new selectorsValidator_1.VisualTypeSelectorValidator(),
                    zoomLevelValidator: new typeValidator_1.RangeValidator(0.25, 4)
                };
            /***/ },
            /* 2 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatusBarValidator = exports.ActionBarValidator = exports.ReportBarsValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var ReportBarsValidator = /** @class */ function(_super) {
                    __extends(ReportBarsValidator, _super);
                    function ReportBarsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ReportBarsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "actionBar",
                                validators: [
                                    validator_1.Validators.actionBarValidator
                                ]
                            },
                            {
                                field: "statusBar",
                                validators: [
                                    validator_1.Validators.statusBarValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ReportBarsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ReportBarsValidator = ReportBarsValidator;
                var ActionBarValidator = /** @class */ function(_super) {
                    __extends(ActionBarValidator, _super);
                    function ActionBarValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ActionBarValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ActionBarValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ActionBarValidator = ActionBarValidator;
                var StatusBarValidator = /** @class */ function(_super) {
                    __extends(StatusBarValidator, _super);
                    function StatusBarValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    StatusBarValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return StatusBarValidator;
                }(typeValidator_1.ObjectValidator);
                exports.StatusBarValidator = StatusBarValidator;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MultipleFieldsValidator = void 0;
                var MultipleFieldsValidator = /** @class */ function() {
                    function MultipleFieldsValidator(fieldValidatorsPairs) {
                        this.fieldValidatorsPairs = fieldValidatorsPairs;
                    }
                    MultipleFieldsValidator.prototype.validate = function(input, path, field) {
                        if (!this.fieldValidatorsPairs) return null;
                        var fieldsPath = path ? path + "." + field : field;
                        for(var _i = 0, _a = this.fieldValidatorsPairs; _i < _a.length; _i++){
                            var fieldValidators = _a[_i];
                            for(var _b = 0, _c = fieldValidators.validators; _b < _c.length; _b++){
                                var validator = _c[_b];
                                var errors = validator.validate(input[fieldValidators.field], fieldsPath, fieldValidators.field);
                                if (errors) return errors;
                            }
                        }
                        return null;
                    };
                    return MultipleFieldsValidator;
                }();
                exports.MultipleFieldsValidator = MultipleFieldsValidator;
            /***/ },
            /* 4 */ /***/ function(__unused_webpack_module, exports) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RangeValidator = exports.NumberArrayValidator = exports.BooleanArrayValidator = exports.StringArrayValidator = exports.EnumValidator = exports.SchemaValidator = exports.ValueValidator = exports.NumberValidator = exports.BooleanValidator = exports.StringValidator = exports.TypeValidator = exports.ArrayValidator = exports.ObjectValidator = void 0;
                var ObjectValidator = /** @class */ function() {
                    function ObjectValidator() {}
                    ObjectValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        if (typeof input !== "object" || Array.isArray(input)) return [
                            {
                                message: field !== undefined ? field + " must be an object" : "input must be an object",
                                path: path,
                                keyword: "type"
                            }
                        ];
                        return null;
                    };
                    return ObjectValidator;
                }();
                exports.ObjectValidator = ObjectValidator;
                var ArrayValidator = /** @class */ function() {
                    function ArrayValidator(itemValidators) {
                        this.itemValidators = itemValidators;
                    }
                    ArrayValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        if (!Array.isArray(input)) return [
                            {
                                message: field + " property is invalid",
                                path: (path ? path + "." : "") + field,
                                keyword: "type"
                            }
                        ];
                        for(var i = 0; i < input.length; i++){
                            var fieldsPath = (path ? path + "." : "") + field + "." + i.toString();
                            for(var _i = 0, _a = this.itemValidators; _i < _a.length; _i++){
                                var validator = _a[_i];
                                var errors = validator.validate(input[i], fieldsPath, field);
                                if (errors) return [
                                    {
                                        message: field + " property is invalid",
                                        path: (path ? path + "." : "") + field,
                                        keyword: "type"
                                    }
                                ];
                            }
                        }
                        return null;
                    };
                    return ArrayValidator;
                }();
                exports.ArrayValidator = ArrayValidator;
                var TypeValidator = /** @class */ function() {
                    function TypeValidator(expectedType) {
                        this.expectedType = expectedType;
                    }
                    TypeValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        if (!(typeof input === this.expectedType)) return [
                            {
                                message: field + " must be a " + this.expectedType,
                                path: (path ? path + "." : "") + field,
                                keyword: "type"
                            }
                        ];
                        return null;
                    };
                    return TypeValidator;
                }();
                exports.TypeValidator = TypeValidator;
                var StringValidator = /** @class */ function(_super) {
                    __extends(StringValidator, _super);
                    function StringValidator() {
                        return _super.call(this, "string") || this;
                    }
                    return StringValidator;
                }(TypeValidator);
                exports.StringValidator = StringValidator;
                var BooleanValidator = /** @class */ function(_super) {
                    __extends(BooleanValidator, _super);
                    function BooleanValidator() {
                        return _super.call(this, "boolean") || this;
                    }
                    return BooleanValidator;
                }(TypeValidator);
                exports.BooleanValidator = BooleanValidator;
                var NumberValidator = /** @class */ function(_super) {
                    __extends(NumberValidator, _super);
                    function NumberValidator() {
                        return _super.call(this, "number") || this;
                    }
                    return NumberValidator;
                }(TypeValidator);
                exports.NumberValidator = NumberValidator;
                var ValueValidator = /** @class */ function() {
                    function ValueValidator(possibleValues) {
                        this.possibleValues = possibleValues;
                    }
                    ValueValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        if (this.possibleValues.indexOf(input) < 0) return [
                            {
                                message: field + " property is invalid",
                                path: (path ? path + "." : "") + field,
                                keyword: "invalid"
                            }
                        ];
                        return null;
                    };
                    return ValueValidator;
                }();
                exports.ValueValidator = ValueValidator;
                var SchemaValidator = /** @class */ function(_super) {
                    __extends(SchemaValidator, _super);
                    function SchemaValidator(schemaValue) {
                        var _this = _super.call(this, [
                            schemaValue
                        ]) || this;
                        _this.schemaValue = schemaValue;
                        return _this;
                    }
                    SchemaValidator.prototype.validate = function(input, path, field) {
                        return _super.prototype.validate.call(this, input, path, field);
                    };
                    return SchemaValidator;
                }(ValueValidator);
                exports.SchemaValidator = SchemaValidator;
                var EnumValidator = /** @class */ function(_super) {
                    __extends(EnumValidator, _super);
                    function EnumValidator(possibleValues) {
                        var _this = _super.call(this) || this;
                        _this.possibleValues = possibleValues;
                        return _this;
                    }
                    EnumValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var valueValidator = new ValueValidator(this.possibleValues);
                        return valueValidator.validate(input, path, field);
                    };
                    return EnumValidator;
                }(NumberValidator);
                exports.EnumValidator = EnumValidator;
                var StringArrayValidator = /** @class */ function(_super) {
                    __extends(StringArrayValidator, _super);
                    function StringArrayValidator() {
                        return _super.call(this, [
                            new StringValidator()
                        ]) || this;
                    }
                    StringArrayValidator.prototype.validate = function(input, path, field) {
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return [
                            {
                                message: field + " must be an array of strings",
                                path: (path ? path + "." : "") + field,
                                keyword: "type"
                            }
                        ];
                        return null;
                    };
                    return StringArrayValidator;
                }(ArrayValidator);
                exports.StringArrayValidator = StringArrayValidator;
                var BooleanArrayValidator = /** @class */ function(_super) {
                    __extends(BooleanArrayValidator, _super);
                    function BooleanArrayValidator() {
                        return _super.call(this, [
                            new BooleanValidator()
                        ]) || this;
                    }
                    BooleanArrayValidator.prototype.validate = function(input, path, field) {
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return [
                            {
                                message: field + " must be an array of booleans",
                                path: (path ? path + "." : "") + field,
                                keyword: "type"
                            }
                        ];
                        return null;
                    };
                    return BooleanArrayValidator;
                }(ArrayValidator);
                exports.BooleanArrayValidator = BooleanArrayValidator;
                var NumberArrayValidator = /** @class */ function(_super) {
                    __extends(NumberArrayValidator, _super);
                    function NumberArrayValidator() {
                        return _super.call(this, [
                            new NumberValidator()
                        ]) || this;
                    }
                    NumberArrayValidator.prototype.validate = function(input, path, field) {
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return [
                            {
                                message: field + " must be an array of numbers",
                                path: (path ? path + "." : "") + field,
                                keyword: "type"
                            }
                        ];
                        return null;
                    };
                    return NumberArrayValidator;
                }(ArrayValidator);
                exports.NumberArrayValidator = NumberArrayValidator;
                var RangeValidator = /** @class */ function(_super) {
                    __extends(RangeValidator, _super);
                    function RangeValidator(minValue, maxValue) {
                        var _this = _super.call(this) || this;
                        _this.minValue = minValue;
                        _this.maxValue = maxValue;
                        return _this;
                    }
                    RangeValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        // input is a number, now check if it's in the given range
                        if (input > this.maxValue || input < this.minValue) return [
                            {
                                message: field + " must be a number between " + this.minValue.toString() + " and " + this.maxValue.toString(),
                                path: (path ? path + "." : "") + field,
                                keyword: "range"
                            }
                        ];
                        return null;
                    };
                    return RangeValidator;
                }(NumberValidator);
                exports.RangeValidator = RangeValidator;
            /***/ },
            /* 5 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CaptureBookmarkRequestValidator = exports.CaptureBookmarkOptionsValidator = exports.ApplyBookmarkStateRequestValidator = exports.ApplyBookmarkByNameRequestValidator = exports.AddBookmarkRequestValidator = exports.PlayBookmarkRequestValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var PlayBookmarkRequestValidator = /** @class */ function(_super) {
                    __extends(PlayBookmarkRequestValidator, _super);
                    function PlayBookmarkRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PlayBookmarkRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "playMode",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ])
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PlayBookmarkRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PlayBookmarkRequestValidator = PlayBookmarkRequestValidator;
                var AddBookmarkRequestValidator = /** @class */ function(_super) {
                    __extends(AddBookmarkRequestValidator, _super);
                    function AddBookmarkRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    AddBookmarkRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "state",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "displayName",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "apply",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return AddBookmarkRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.AddBookmarkRequestValidator = AddBookmarkRequestValidator;
                var ApplyBookmarkByNameRequestValidator = /** @class */ function(_super) {
                    __extends(ApplyBookmarkByNameRequestValidator, _super);
                    function ApplyBookmarkByNameRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ApplyBookmarkByNameRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ApplyBookmarkByNameRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ApplyBookmarkByNameRequestValidator = ApplyBookmarkByNameRequestValidator;
                var ApplyBookmarkStateRequestValidator = /** @class */ function(_super) {
                    __extends(ApplyBookmarkStateRequestValidator, _super);
                    function ApplyBookmarkStateRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ApplyBookmarkStateRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "state",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ApplyBookmarkStateRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ApplyBookmarkStateRequestValidator = ApplyBookmarkStateRequestValidator;
                var CaptureBookmarkOptionsValidator = /** @class */ function(_super) {
                    __extends(CaptureBookmarkOptionsValidator, _super);
                    function CaptureBookmarkOptionsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CaptureBookmarkOptionsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "personalizeVisuals",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "allPages",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CaptureBookmarkOptionsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.CaptureBookmarkOptionsValidator = CaptureBookmarkOptionsValidator;
                var CaptureBookmarkRequestValidator = /** @class */ function(_super) {
                    __extends(CaptureBookmarkRequestValidator, _super);
                    function CaptureBookmarkRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CaptureBookmarkRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "options",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.captureBookmarkOptionsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CaptureBookmarkRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.CaptureBookmarkRequestValidator = CaptureBookmarkRequestValidator;
            /***/ },
            /* 6 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PaginatedReportCommandsValidator = exports.SingleCommandSettingsValidator = exports.CommandsSettingsValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var CommandsSettingsValidator = /** @class */ function(_super) {
                    __extends(CommandsSettingsValidator, _super);
                    function CommandsSettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CommandsSettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "copy",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "drill",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "drillthrough",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "expandCollapse",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "exportData",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "includeExclude",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "removeVisual",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "search",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "seeData",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "sort",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "spotlight",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "insightsAnalysis",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "addComment",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "groupVisualContainers",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "summarize",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            },
                            {
                                field: "clearSelection",
                                validators: [
                                    validator_1.Validators.singleCommandSettingsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CommandsSettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.CommandsSettingsValidator = CommandsSettingsValidator;
                var SingleCommandSettingsValidator = /** @class */ function(_super) {
                    __extends(SingleCommandSettingsValidator, _super);
                    function SingleCommandSettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SingleCommandSettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "displayOption",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.commandDisplayOptionValidator
                                ]
                            },
                            {
                                field: "selector",
                                validators: [
                                    validator_1.Validators.visualCommandSelectorValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SingleCommandSettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SingleCommandSettingsValidator = SingleCommandSettingsValidator;
                var PaginatedReportCommandsValidator = /** @class */ function(_super) {
                    __extends(PaginatedReportCommandsValidator, _super);
                    function PaginatedReportCommandsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PaginatedReportCommandsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "parameterPanel",
                                validators: [
                                    validator_1.Validators.parametersPanelValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PaginatedReportCommandsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PaginatedReportCommandsValidator = PaginatedReportCommandsValidator;
            /***/ },
            /* 7 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CustomThemeValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var CustomThemeValidator = /** @class */ function(_super) {
                    __extends(CustomThemeValidator, _super);
                    function CustomThemeValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CustomThemeValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "themeJson",
                                validators: [
                                    new typeValidator_1.ObjectValidator()
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CustomThemeValidator;
                }(typeValidator_1.ObjectValidator);
                exports.CustomThemeValidator = CustomThemeValidator;
            /***/ },
            /* 8 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DashboardLoadValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var DashboardLoadValidator = /** @class */ function(_super) {
                    __extends(DashboardLoadValidator, _super);
                    function DashboardLoadValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    DashboardLoadValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "accessToken",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "id",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "groupId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "pageView",
                                validators: [
                                    validator_1.Validators.pageViewFieldValidator
                                ]
                            },
                            {
                                field: "tokenType",
                                validators: [
                                    validator_1.Validators.tokenTypeValidator
                                ]
                            },
                            {
                                field: "embedUrl",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return DashboardLoadValidator;
                }(typeValidator_1.ObjectValidator);
                exports.DashboardLoadValidator = DashboardLoadValidator;
            /***/ },
            /* 9 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DatasetBindingValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var DatasetBindingValidator = /** @class */ function(_super) {
                    __extends(DatasetBindingValidator, _super);
                    function DatasetBindingValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    DatasetBindingValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        if (!input["datasetId"] && !input["paginatedReportBindings"]) return [
                            {
                                message: "datasetBinding cannot be empty",
                                path: (path ? path + "." : "") + field,
                                keyword: "invalid"
                            }
                        ];
                        var fields = [
                            {
                                field: "datasetId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "paginatedReportBindings",
                                validators: [
                                    validator_1.Validators.paginatedReportDatasetBindingArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return DatasetBindingValidator;
                }(typeValidator_1.ObjectValidator);
                exports.DatasetBindingValidator = DatasetBindingValidator;
            /***/ },
            /* 10 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ExportDataRequestValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var ExportDataRequestValidator = /** @class */ function(_super) {
                    __extends(ExportDataRequestValidator, _super);
                    function ExportDataRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ExportDataRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "rows",
                                validators: [
                                    new typeValidator_1.NumberValidator()
                                ]
                            },
                            {
                                field: "exportDataType",
                                validators: [
                                    new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ])
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ExportDataRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ExportDataRequestValidator = ExportDataRequestValidator;
            /***/ },
            /* 11 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ExtensionsValidator = exports.MenuGroupExtensionValidator = exports.ExtensionValidator = exports.CommandExtensionValidator = exports.ExtensionItemValidator = exports.ExtensionPointsValidator = exports.GroupedMenuExtensionValidator = exports.FlatMenuExtensionValidator = exports.MenuExtensionBaseValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var MenuExtensionBaseValidator = /** @class */ function(_super) {
                    __extends(MenuExtensionBaseValidator, _super);
                    function MenuExtensionBaseValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    MenuExtensionBaseValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "title",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "icon",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return MenuExtensionBaseValidator;
                }(typeValidator_1.ObjectValidator);
                exports.MenuExtensionBaseValidator = MenuExtensionBaseValidator;
                var FlatMenuExtensionValidator = /** @class */ function(_super) {
                    __extends(FlatMenuExtensionValidator, _super);
                    function FlatMenuExtensionValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FlatMenuExtensionValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "menuLocation",
                                validators: [
                                    validator_1.Validators.menuLocationValidator
                                ]
                            },
                            {
                                field: "groupName",
                                validators: [
                                    validator_1.Validators.fieldForbiddenValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FlatMenuExtensionValidator;
                }(MenuExtensionBaseValidator);
                exports.FlatMenuExtensionValidator = FlatMenuExtensionValidator;
                var GroupedMenuExtensionValidator = /** @class */ function(_super) {
                    __extends(GroupedMenuExtensionValidator, _super);
                    function GroupedMenuExtensionValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    GroupedMenuExtensionValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "groupName",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "menuLocation",
                                validators: [
                                    validator_1.Validators.fieldForbiddenValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return GroupedMenuExtensionValidator;
                }(MenuExtensionBaseValidator);
                exports.GroupedMenuExtensionValidator = GroupedMenuExtensionValidator;
                var ExtensionPointsValidator = /** @class */ function(_super) {
                    __extends(ExtensionPointsValidator, _super);
                    function ExtensionPointsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ExtensionPointsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visualContextMenu",
                                validators: [
                                    validator_1.Validators.menuExtensionValidator
                                ]
                            },
                            {
                                field: "visualOptionsMenu",
                                validators: [
                                    validator_1.Validators.menuExtensionValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ExtensionPointsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ExtensionPointsValidator = ExtensionPointsValidator;
                var ExtensionItemValidator = /** @class */ function(_super) {
                    __extends(ExtensionItemValidator, _super);
                    function ExtensionItemValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ExtensionItemValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "extend",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.extensionPointsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ExtensionItemValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ExtensionItemValidator = ExtensionItemValidator;
                var CommandExtensionValidator = /** @class */ function(_super) {
                    __extends(CommandExtensionValidator, _super);
                    function CommandExtensionValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CommandExtensionValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "title",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "icon",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "selector",
                                validators: [
                                    validator_1.Validators.commandExtensionSelectorValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CommandExtensionValidator;
                }(ExtensionItemValidator);
                exports.CommandExtensionValidator = CommandExtensionValidator;
                var ExtensionValidator = /** @class */ function(_super) {
                    __extends(ExtensionValidator, _super);
                    function ExtensionValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ExtensionValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "command",
                                validators: [
                                    validator_1.Validators.commandExtensionValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ExtensionValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ExtensionValidator = ExtensionValidator;
                var MenuGroupExtensionValidator = /** @class */ function(_super) {
                    __extends(MenuGroupExtensionValidator, _super);
                    function MenuGroupExtensionValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    MenuGroupExtensionValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "title",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "menuLocation",
                                validators: [
                                    validator_1.Validators.menuLocationValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return MenuGroupExtensionValidator;
                }(typeValidator_1.ObjectValidator);
                exports.MenuGroupExtensionValidator = MenuGroupExtensionValidator;
                var ExtensionsValidator = /** @class */ function(_super) {
                    __extends(ExtensionsValidator, _super);
                    function ExtensionsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ExtensionsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "commands",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.commandExtensionArrayValidator
                                ]
                            },
                            {
                                field: "groups",
                                validators: [
                                    validator_1.Validators.menuGroupExtensionArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ExtensionsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ExtensionsValidator = ExtensionsValidator;
            /***/ },
            /* 12 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OnLoadFiltersValidator = exports.OnLoadFiltersBaseRemoveOperationValidator = exports.OnLoadFiltersBaseValidator = exports.ConditionItemValidator = exports.RemoveFiltersRequestValidator = exports.UpdateFiltersRequestValidator = exports.FilterValidator = exports.IncludeExcludePointValueValidator = exports.HierarchyFilterNodeValidator = exports.HierarchyFilterValidator = exports.IncludeExcludeFilterValidator = exports.NotSupportedFilterValidator = exports.TopNFilterValidator = exports.RelativeTimeFilterValidator = exports.RelativeDateFilterValidator = exports.RelativeDateTimeFilterValidator = exports.AdvancedFilterValidator = exports.BasicFilterValidator = exports.FilterValidatorBase = exports.FilterDisplaySettingsValidator = exports.FilterMeasureTargetValidator = exports.FilterKeyHierarchyTargetValidator = exports.FilterHierarchyTargetValidator = exports.FilterKeyColumnsTargetValidator = exports.FilterColumnTargetValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var FilterColumnTargetValidator = /** @class */ function(_super) {
                    __extends(FilterColumnTargetValidator, _super);
                    function FilterColumnTargetValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterColumnTargetValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "table",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "column",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FilterColumnTargetValidator;
                }(typeValidator_1.ObjectValidator);
                exports.FilterColumnTargetValidator = FilterColumnTargetValidator;
                var FilterKeyColumnsTargetValidator = /** @class */ function(_super) {
                    __extends(FilterKeyColumnsTargetValidator, _super);
                    function FilterKeyColumnsTargetValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterKeyColumnsTargetValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "keys",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FilterKeyColumnsTargetValidator;
                }(FilterColumnTargetValidator);
                exports.FilterKeyColumnsTargetValidator = FilterKeyColumnsTargetValidator;
                var FilterHierarchyTargetValidator = /** @class */ function(_super) {
                    __extends(FilterHierarchyTargetValidator, _super);
                    function FilterHierarchyTargetValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterHierarchyTargetValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "table",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "hierarchy",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "hierarchyLevel",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FilterHierarchyTargetValidator;
                }(typeValidator_1.ObjectValidator);
                exports.FilterHierarchyTargetValidator = FilterHierarchyTargetValidator;
                var FilterKeyHierarchyTargetValidator = /** @class */ function(_super) {
                    __extends(FilterKeyHierarchyTargetValidator, _super);
                    function FilterKeyHierarchyTargetValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterKeyHierarchyTargetValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "keys",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FilterKeyHierarchyTargetValidator;
                }(FilterHierarchyTargetValidator);
                exports.FilterKeyHierarchyTargetValidator = FilterKeyHierarchyTargetValidator;
                var FilterMeasureTargetValidator = /** @class */ function(_super) {
                    __extends(FilterMeasureTargetValidator, _super);
                    function FilterMeasureTargetValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterMeasureTargetValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "table",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "measure",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FilterMeasureTargetValidator;
                }(typeValidator_1.ObjectValidator);
                exports.FilterMeasureTargetValidator = FilterMeasureTargetValidator;
                var FilterDisplaySettingsValidator = /** @class */ function(_super) {
                    __extends(FilterDisplaySettingsValidator, _super);
                    function FilterDisplaySettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterDisplaySettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "isLockedInViewMode",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "isHiddenInViewMode",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "displayName",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FilterDisplaySettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.FilterDisplaySettingsValidator = FilterDisplaySettingsValidator;
                var FilterValidatorBase = /** @class */ function(_super) {
                    __extends(FilterValidatorBase, _super);
                    function FilterValidatorBase() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterValidatorBase.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "target",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filterTargetValidator
                                ]
                            },
                            {
                                field: "$schema",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.filterTypeValidator
                                ]
                            },
                            {
                                field: "displaySettings",
                                validators: [
                                    validator_1.Validators.filterDisplaySettingsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FilterValidatorBase;
                }(typeValidator_1.ObjectValidator);
                exports.FilterValidatorBase = FilterValidatorBase;
                var BasicFilterValidator = /** @class */ function(_super) {
                    __extends(BasicFilterValidator, _super);
                    function BasicFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    BasicFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "operator",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "values",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.anyArrayValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.basicFilterTypeValidator
                                ]
                            },
                            {
                                field: "requireSingleSelection",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return BasicFilterValidator;
                }(FilterValidatorBase);
                exports.BasicFilterValidator = BasicFilterValidator;
                var AdvancedFilterValidator = /** @class */ function(_super) {
                    __extends(AdvancedFilterValidator, _super);
                    function AdvancedFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    AdvancedFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "logicalOperator",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "conditions",
                                validators: [
                                    validator_1.Validators.filterConditionsValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.advancedFilterTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return AdvancedFilterValidator;
                }(FilterValidatorBase);
                exports.AdvancedFilterValidator = AdvancedFilterValidator;
                var RelativeDateTimeFilterValidator = /** @class */ function(_super) {
                    __extends(RelativeDateTimeFilterValidator, _super);
                    function RelativeDateTimeFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    RelativeDateTimeFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "operator",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.relativeDateFilterOperatorValidator
                                ]
                            },
                            {
                                field: "timeUnitsCount",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "timeUnitType",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.relativeDateTimeFilterUnitTypeValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.relativeDateTimeFilterTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return RelativeDateTimeFilterValidator;
                }(FilterValidatorBase);
                exports.RelativeDateTimeFilterValidator = RelativeDateTimeFilterValidator;
                var RelativeDateFilterValidator = /** @class */ function(_super) {
                    __extends(RelativeDateFilterValidator, _super);
                    function RelativeDateFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    RelativeDateFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "includeToday",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "timeUnitType",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.relativeDateFilterTimeUnitTypeValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.relativeDateFilterTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return RelativeDateFilterValidator;
                }(RelativeDateTimeFilterValidator);
                exports.RelativeDateFilterValidator = RelativeDateFilterValidator;
                var RelativeTimeFilterValidator = /** @class */ function(_super) {
                    __extends(RelativeTimeFilterValidator, _super);
                    function RelativeTimeFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    RelativeTimeFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "timeUnitType",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.relativeTimeFilterTimeUnitTypeValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.relativeTimeFilterTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return RelativeTimeFilterValidator;
                }(RelativeDateTimeFilterValidator);
                exports.RelativeTimeFilterValidator = RelativeTimeFilterValidator;
                var TopNFilterValidator = /** @class */ function(_super) {
                    __extends(TopNFilterValidator, _super);
                    function TopNFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    TopNFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "operator",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "itemCount",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.topNFilterTypeValidator
                                ]
                            },
                            {
                                field: "orderBy",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filterTargetValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return TopNFilterValidator;
                }(FilterValidatorBase);
                exports.TopNFilterValidator = TopNFilterValidator;
                var NotSupportedFilterValidator = /** @class */ function(_super) {
                    __extends(NotSupportedFilterValidator, _super);
                    function NotSupportedFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    NotSupportedFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "message",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "notSupportedTypeName",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.notSupportedFilterTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return NotSupportedFilterValidator;
                }(FilterValidatorBase);
                exports.NotSupportedFilterValidator = NotSupportedFilterValidator;
                var IncludeExcludeFilterValidator = /** @class */ function(_super) {
                    __extends(IncludeExcludeFilterValidator, _super);
                    function IncludeExcludeFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    IncludeExcludeFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "isExclude",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "values",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.includeExcludeFilterValuesValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.includeExludeFilterTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return IncludeExcludeFilterValidator;
                }(FilterValidatorBase);
                exports.IncludeExcludeFilterValidator = IncludeExcludeFilterValidator;
                var HierarchyFilterValidator = /** @class */ function(_super) {
                    __extends(HierarchyFilterValidator, _super);
                    function HierarchyFilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    HierarchyFilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "hierarchyData",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.hierarchyFilterValuesValidator
                                ]
                            },
                            {
                                field: "filterType",
                                validators: [
                                    validator_1.Validators.hierarchyFilterTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return HierarchyFilterValidator;
                }(FilterValidatorBase);
                exports.HierarchyFilterValidator = HierarchyFilterValidator;
                var HierarchyFilterNodeValidator = /** @class */ function(_super) {
                    __extends(HierarchyFilterNodeValidator, _super);
                    function HierarchyFilterNodeValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    HierarchyFilterNodeValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "value",
                                validators: [
                                    validator_1.Validators.anyValueValidator
                                ]
                            },
                            {
                                field: "keyValues",
                                validators: [
                                    validator_1.Validators.anyArrayValidator
                                ]
                            },
                            {
                                field: "children",
                                validators: [
                                    validator_1.Validators.hierarchyFilterValuesValidator
                                ]
                            },
                            {
                                field: "operator",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return HierarchyFilterNodeValidator;
                }(typeValidator_1.ObjectValidator);
                exports.HierarchyFilterNodeValidator = HierarchyFilterNodeValidator;
                var IncludeExcludePointValueValidator = /** @class */ function(_super) {
                    __extends(IncludeExcludePointValueValidator, _super);
                    function IncludeExcludePointValueValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    IncludeExcludePointValueValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "value",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.anyValueValidator
                                ]
                            },
                            {
                                field: "keyValues",
                                validators: [
                                    validator_1.Validators.anyArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return IncludeExcludePointValueValidator;
                }(typeValidator_1.ObjectValidator);
                exports.IncludeExcludePointValueValidator = IncludeExcludePointValueValidator;
                var FilterValidator = /** @class */ function(_super) {
                    __extends(FilterValidator, _super);
                    function FilterValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FilterValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        return validator_1.Validators.anyFilterValidator.validate(input, path, field);
                    };
                    return FilterValidator;
                }(typeValidator_1.ObjectValidator);
                exports.FilterValidator = FilterValidator;
                var UpdateFiltersRequestValidator = /** @class */ function(_super) {
                    __extends(UpdateFiltersRequestValidator, _super);
                    function UpdateFiltersRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    UpdateFiltersRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "filtersOperation",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filtersOperationsUpdateValidator
                                ]
                            },
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filtersArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return UpdateFiltersRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.UpdateFiltersRequestValidator = UpdateFiltersRequestValidator;
                var RemoveFiltersRequestValidator = /** @class */ function(_super) {
                    __extends(RemoveFiltersRequestValidator, _super);
                    function RemoveFiltersRequestValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    RemoveFiltersRequestValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "filtersOperation",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filtersOperationsRemoveAllValidator
                                ]
                            },
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.fieldForbiddenValidator,
                                    validator_1.Validators.filtersArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return RemoveFiltersRequestValidator;
                }(typeValidator_1.ObjectValidator);
                exports.RemoveFiltersRequestValidator = RemoveFiltersRequestValidator;
                var ConditionItemValidator = /** @class */ function(_super) {
                    __extends(ConditionItemValidator, _super);
                    function ConditionItemValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ConditionItemValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "value",
                                validators: [
                                    validator_1.Validators.anyValueValidator
                                ]
                            },
                            {
                                field: "operator",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ConditionItemValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ConditionItemValidator = ConditionItemValidator;
                var OnLoadFiltersBaseValidator = /** @class */ function(_super) {
                    __extends(OnLoadFiltersBaseValidator, _super);
                    function OnLoadFiltersBaseValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    OnLoadFiltersBaseValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "operation",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filtersOperationsUpdateValidator
                                ]
                            },
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filtersArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return OnLoadFiltersBaseValidator;
                }(typeValidator_1.ObjectValidator);
                exports.OnLoadFiltersBaseValidator = OnLoadFiltersBaseValidator;
                var OnLoadFiltersBaseRemoveOperationValidator = /** @class */ function(_super) {
                    __extends(OnLoadFiltersBaseRemoveOperationValidator, _super);
                    function OnLoadFiltersBaseRemoveOperationValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    OnLoadFiltersBaseRemoveOperationValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "operation",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.filtersOperationsRemoveAllValidator
                                ]
                            },
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.fieldForbiddenValidator,
                                    validator_1.Validators.filtersArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return OnLoadFiltersBaseRemoveOperationValidator;
                }(typeValidator_1.ObjectValidator);
                exports.OnLoadFiltersBaseRemoveOperationValidator = OnLoadFiltersBaseRemoveOperationValidator;
                var OnLoadFiltersValidator = /** @class */ function(_super) {
                    __extends(OnLoadFiltersValidator, _super);
                    function OnLoadFiltersValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    OnLoadFiltersValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "allPages",
                                validators: [
                                    validator_1.Validators.onLoadFiltersBaseValidator
                                ]
                            },
                            {
                                field: "currentPage",
                                validators: [
                                    validator_1.Validators.onLoadFiltersBaseValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return OnLoadFiltersValidator;
                }(typeValidator_1.ObjectValidator);
                exports.OnLoadFiltersValidator = OnLoadFiltersValidator;
            /***/ },
            /* 13 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PageLayoutValidator = exports.DisplayStateValidator = exports.VisualLayoutValidator = exports.CustomLayoutValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var CustomLayoutValidator = /** @class */ function(_super) {
                    __extends(CustomLayoutValidator, _super);
                    function CustomLayoutValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CustomLayoutValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "pageSize",
                                validators: [
                                    validator_1.Validators.pageSizeValidator
                                ]
                            },
                            {
                                field: "displayOption",
                                validators: [
                                    validator_1.Validators.customLayoutDisplayOptionValidator
                                ]
                            },
                            {
                                field: "pagesLayout",
                                validators: [
                                    validator_1.Validators.pagesLayoutValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CustomLayoutValidator;
                }(typeValidator_1.ObjectValidator);
                exports.CustomLayoutValidator = CustomLayoutValidator;
                var VisualLayoutValidator = /** @class */ function(_super) {
                    __extends(VisualLayoutValidator, _super);
                    function VisualLayoutValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    VisualLayoutValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "x",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "y",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "z",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "width",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "height",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "displayState",
                                validators: [
                                    validator_1.Validators.displayStateValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return VisualLayoutValidator;
                }(typeValidator_1.ObjectValidator);
                exports.VisualLayoutValidator = VisualLayoutValidator;
                var DisplayStateValidator = /** @class */ function(_super) {
                    __extends(DisplayStateValidator, _super);
                    function DisplayStateValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    DisplayStateValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "mode",
                                validators: [
                                    validator_1.Validators.displayStateModeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return DisplayStateValidator;
                }(typeValidator_1.ObjectValidator);
                exports.DisplayStateValidator = DisplayStateValidator;
                var PageLayoutValidator = /** @class */ function(_super) {
                    __extends(PageLayoutValidator, _super);
                    function PageLayoutValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PageLayoutValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visualsLayout",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.pageLayoutValidator
                                ]
                            },
                            {
                                field: "defaultLayout",
                                validators: [
                                    validator_1.Validators.visualLayoutValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PageLayoutValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PageLayoutValidator = PageLayoutValidator;
            /***/ },
            /* 14 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PageViewFieldValidator = exports.PageValidator = exports.CustomPageSizeValidator = exports.PageSizeValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var PageSizeValidator = /** @class */ function(_super) {
                    __extends(PageSizeValidator, _super);
                    function PageSizeValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PageSizeValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "type",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.pageSizeTypeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PageSizeValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PageSizeValidator = PageSizeValidator;
                var CustomPageSizeValidator = /** @class */ function(_super) {
                    __extends(CustomPageSizeValidator, _super);
                    function CustomPageSizeValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CustomPageSizeValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "width",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "height",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CustomPageSizeValidator;
                }(PageSizeValidator);
                exports.CustomPageSizeValidator = CustomPageSizeValidator;
                var PageValidator = /** @class */ function(_super) {
                    __extends(PageValidator, _super);
                    function PageValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PageValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PageValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PageValidator = PageValidator;
                var PageViewFieldValidator = /** @class */ function(_super) {
                    __extends(PageViewFieldValidator, _super);
                    function PageViewFieldValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PageViewFieldValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var possibleValues = [
                            "actualSize",
                            "fitToWidth",
                            "oneColumn"
                        ];
                        if (possibleValues.indexOf(input) < 0) return [
                            {
                                message: "pageView must be a string with one of the following values: \"actualSize\", \"fitToWidth\", \"oneColumn\""
                            }
                        ];
                        return null;
                    };
                    return PageViewFieldValidator;
                }(typeValidator_1.StringValidator);
                exports.PageViewFieldValidator = PageViewFieldValidator;
            /***/ },
            /* 15 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VisualizationsPaneValidator = exports.SyncSlicersPaneValidator = exports.SelectionPaneValidator = exports.PageNavigationPaneValidator = exports.FiltersPaneValidator = exports.FieldsPaneValidator = exports.BookmarksPaneValidator = exports.QnaPanesValidator = exports.ReportPanesValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var ReportPanesValidator = /** @class */ function(_super) {
                    __extends(ReportPanesValidator, _super);
                    function ReportPanesValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ReportPanesValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "bookmarks",
                                validators: [
                                    validator_1.Validators.bookmarksPaneValidator
                                ]
                            },
                            {
                                field: "fields",
                                validators: [
                                    validator_1.Validators.fieldsPaneValidator
                                ]
                            },
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.filtersPaneValidator
                                ]
                            },
                            {
                                field: "pageNavigation",
                                validators: [
                                    validator_1.Validators.pageNavigationPaneValidator
                                ]
                            },
                            {
                                field: "selection",
                                validators: [
                                    validator_1.Validators.selectionPaneValidator
                                ]
                            },
                            {
                                field: "syncSlicers",
                                validators: [
                                    validator_1.Validators.syncSlicersPaneValidator
                                ]
                            },
                            {
                                field: "visualizations",
                                validators: [
                                    validator_1.Validators.visualizationsPaneValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ReportPanesValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ReportPanesValidator = ReportPanesValidator;
                var QnaPanesValidator = /** @class */ function(_super) {
                    __extends(QnaPanesValidator, _super);
                    function QnaPanesValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    QnaPanesValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.filtersPaneValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return QnaPanesValidator;
                }(typeValidator_1.ObjectValidator);
                exports.QnaPanesValidator = QnaPanesValidator;
                var BookmarksPaneValidator = /** @class */ function(_super) {
                    __extends(BookmarksPaneValidator, _super);
                    function BookmarksPaneValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    BookmarksPaneValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return BookmarksPaneValidator;
                }(typeValidator_1.ObjectValidator);
                exports.BookmarksPaneValidator = BookmarksPaneValidator;
                var FieldsPaneValidator = /** @class */ function(_super) {
                    __extends(FieldsPaneValidator, _super);
                    function FieldsPaneValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FieldsPaneValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "expanded",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FieldsPaneValidator;
                }(typeValidator_1.ObjectValidator);
                exports.FieldsPaneValidator = FieldsPaneValidator;
                var FiltersPaneValidator = /** @class */ function(_super) {
                    __extends(FiltersPaneValidator, _super);
                    function FiltersPaneValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FiltersPaneValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "expanded",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return FiltersPaneValidator;
                }(typeValidator_1.ObjectValidator);
                exports.FiltersPaneValidator = FiltersPaneValidator;
                var PageNavigationPaneValidator = /** @class */ function(_super) {
                    __extends(PageNavigationPaneValidator, _super);
                    function PageNavigationPaneValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PageNavigationPaneValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "position",
                                validators: [
                                    validator_1.Validators.pageNavigationPositionValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PageNavigationPaneValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PageNavigationPaneValidator = PageNavigationPaneValidator;
                var SelectionPaneValidator = /** @class */ function(_super) {
                    __extends(SelectionPaneValidator, _super);
                    function SelectionPaneValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SelectionPaneValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SelectionPaneValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SelectionPaneValidator = SelectionPaneValidator;
                var SyncSlicersPaneValidator = /** @class */ function(_super) {
                    __extends(SyncSlicersPaneValidator, _super);
                    function SyncSlicersPaneValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SyncSlicersPaneValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SyncSlicersPaneValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SyncSlicersPaneValidator = SyncSlicersPaneValidator;
                var VisualizationsPaneValidator = /** @class */ function(_super) {
                    __extends(VisualizationsPaneValidator, _super);
                    function VisualizationsPaneValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    VisualizationsPaneValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "expanded",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return VisualizationsPaneValidator;
                }(typeValidator_1.ObjectValidator);
                exports.VisualizationsPaneValidator = VisualizationsPaneValidator;
            /***/ },
            /* 16 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.QnaInterpretInputDataValidator = exports.QnaSettingsValidator = exports.LoadQnaValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var LoadQnaValidator = /** @class */ function(_super) {
                    __extends(LoadQnaValidator, _super);
                    function LoadQnaValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    LoadQnaValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "accessToken",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "datasetIds",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringArrayValidator
                                ]
                            },
                            {
                                field: "question",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "viewMode",
                                validators: [
                                    validator_1.Validators.viewModeValidator
                                ]
                            },
                            {
                                field: "settings",
                                validators: [
                                    validator_1.Validators.qnaSettingValidator
                                ]
                            },
                            {
                                field: "tokenType",
                                validators: [
                                    validator_1.Validators.tokenTypeValidator
                                ]
                            },
                            {
                                field: "groupId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return LoadQnaValidator;
                }(typeValidator_1.ObjectValidator);
                exports.LoadQnaValidator = LoadQnaValidator;
                var QnaSettingsValidator = /** @class */ function(_super) {
                    __extends(QnaSettingsValidator, _super);
                    function QnaSettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    QnaSettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "filterPaneEnabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "hideErrors",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "panes",
                                validators: [
                                    validator_1.Validators.qnaPanesValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return QnaSettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.QnaSettingsValidator = QnaSettingsValidator;
                var QnaInterpretInputDataValidator = /** @class */ function(_super) {
                    __extends(QnaInterpretInputDataValidator, _super);
                    function QnaInterpretInputDataValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    QnaInterpretInputDataValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "datasetIds",
                                validators: [
                                    validator_1.Validators.stringArrayValidator
                                ]
                            },
                            {
                                field: "question",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return QnaInterpretInputDataValidator;
                }(typeValidator_1.ObjectValidator);
                exports.QnaInterpretInputDataValidator = QnaInterpretInputDataValidator;
            /***/ },
            /* 17 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ReportCreateValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var ReportCreateValidator = /** @class */ function(_super) {
                    __extends(ReportCreateValidator, _super);
                    function ReportCreateValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ReportCreateValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "accessToken",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "datasetId",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "groupId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "tokenType",
                                validators: [
                                    validator_1.Validators.tokenTypeValidator
                                ]
                            },
                            {
                                field: "theme",
                                validators: [
                                    validator_1.Validators.customThemeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ReportCreateValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ReportCreateValidator = ReportCreateValidator;
            /***/ },
            /* 18 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ReportLoadValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var ReportLoadValidator = /** @class */ function(_super) {
                    __extends(ReportLoadValidator, _super);
                    function ReportLoadValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ReportLoadValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "accessToken",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "id",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "groupId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "settings",
                                validators: [
                                    validator_1.Validators.settingsValidator
                                ]
                            },
                            {
                                field: "pageName",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.reportLoadFiltersValidator
                                ]
                            },
                            {
                                field: "permissions",
                                validators: [
                                    validator_1.Validators.permissionsValidator
                                ]
                            },
                            {
                                field: "viewMode",
                                validators: [
                                    validator_1.Validators.viewModeValidator
                                ]
                            },
                            {
                                field: "tokenType",
                                validators: [
                                    validator_1.Validators.tokenTypeValidator
                                ]
                            },
                            {
                                field: "bookmark",
                                validators: [
                                    validator_1.Validators.applyBookmarkValidator
                                ]
                            },
                            {
                                field: "theme",
                                validators: [
                                    validator_1.Validators.customThemeValidator
                                ]
                            },
                            {
                                field: "embedUrl",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "datasetBinding",
                                validators: [
                                    validator_1.Validators.datasetBindingValidator
                                ]
                            },
                            {
                                field: "contrastMode",
                                validators: [
                                    validator_1.Validators.contrastModeValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ReportLoadValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ReportLoadValidator = ReportLoadValidator;
            /***/ },
            /* 19 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ReportParameterFieldsValidator = exports.PaginatedReportLoadValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var PaginatedReportLoadValidator = /** @class */ function(_super) {
                    __extends(PaginatedReportLoadValidator, _super);
                    function PaginatedReportLoadValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PaginatedReportLoadValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "accessToken",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "id",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "groupId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "settings",
                                validators: [
                                    validator_1.Validators.paginatedReportsettingsValidator
                                ]
                            },
                            {
                                field: "tokenType",
                                validators: [
                                    validator_1.Validators.tokenTypeValidator
                                ]
                            },
                            {
                                field: "embedUrl",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "type",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "parameterValues",
                                validators: [
                                    validator_1.Validators.parameterValuesArrayValidator
                                ]
                            },
                            {
                                field: "datasetBindings",
                                validators: [
                                    validator_1.Validators.paginatedReportDatasetBindingArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PaginatedReportLoadValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PaginatedReportLoadValidator = PaginatedReportLoadValidator;
                var ReportParameterFieldsValidator = /** @class */ function() {
                    function ReportParameterFieldsValidator() {}
                    ReportParameterFieldsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "value",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ReportParameterFieldsValidator;
                }();
                exports.ReportParameterFieldsValidator = ReportParameterFieldsValidator;
            /***/ },
            /* 20 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SaveAsParametersValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var SaveAsParametersValidator = /** @class */ function(_super) {
                    __extends(SaveAsParametersValidator, _super);
                    function SaveAsParametersValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SaveAsParametersValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SaveAsParametersValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SaveAsParametersValidator = SaveAsParametersValidator;
            /***/ },
            /* 21 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SlicerTargetSelectorValidator = exports.VisualTypeSelectorValidator = exports.VisualSelectorValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var typeValidator_2 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var VisualSelectorValidator = /** @class */ function(_super) {
                    __extends(VisualSelectorValidator, _super);
                    function VisualSelectorValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    VisualSelectorValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                // Not required for this selector only - Backward compatibility
                                field: "$schema",
                                validators: [
                                    validator_1.Validators.stringValidator,
                                    new typeValidator_2.SchemaValidator("http://powerbi.com/product/schema#visualSelector")
                                ]
                            },
                            {
                                field: "visualName",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return VisualSelectorValidator;
                }(typeValidator_1.ObjectValidator);
                exports.VisualSelectorValidator = VisualSelectorValidator;
                var VisualTypeSelectorValidator = /** @class */ function(_super) {
                    __extends(VisualTypeSelectorValidator, _super);
                    function VisualTypeSelectorValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    VisualTypeSelectorValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "$schema",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator,
                                    new typeValidator_2.SchemaValidator("http://powerbi.com/product/schema#visualTypeSelector")
                                ]
                            },
                            {
                                field: "visualType",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return VisualTypeSelectorValidator;
                }(typeValidator_1.ObjectValidator);
                exports.VisualTypeSelectorValidator = VisualTypeSelectorValidator;
                var SlicerTargetSelectorValidator = /** @class */ function(_super) {
                    __extends(SlicerTargetSelectorValidator, _super);
                    function SlicerTargetSelectorValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SlicerTargetSelectorValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "$schema",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator,
                                    new typeValidator_2.SchemaValidator("http://powerbi.com/product/schema#slicerTargetSelector")
                                ]
                            },
                            {
                                field: "target",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.slicerTargetValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SlicerTargetSelectorValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SlicerTargetSelectorValidator = SlicerTargetSelectorValidator;
            /***/ },
            /* 22 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PaginatedReportSettingsValidator = exports.SettingsValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var SettingsValidator = /** @class */ function(_super) {
                    __extends(SettingsValidator, _super);
                    function SettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "filterPaneEnabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "navContentPaneEnabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "bookmarksPaneEnabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "useCustomSaveAsDialog",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "extensions",
                                validators: [
                                    validator_1.Validators.extensionsValidator
                                ]
                            },
                            {
                                field: "layoutType",
                                validators: [
                                    validator_1.Validators.layoutTypeValidator
                                ]
                            },
                            {
                                field: "customLayout",
                                validators: [
                                    validator_1.Validators.customLayoutValidator
                                ]
                            },
                            {
                                field: "background",
                                validators: [
                                    validator_1.Validators.backgroundValidator
                                ]
                            },
                            {
                                field: "visualSettings",
                                validators: [
                                    validator_1.Validators.visualSettingsValidator
                                ]
                            },
                            {
                                field: "hideErrors",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "commands",
                                validators: [
                                    validator_1.Validators.commandsSettingsArrayValidator
                                ]
                            },
                            {
                                field: "hyperlinkClickBehavior",
                                validators: [
                                    validator_1.Validators.hyperlinkClickBehaviorValidator
                                ]
                            },
                            {
                                field: "bars",
                                validators: [
                                    validator_1.Validators.reportBarsValidator
                                ]
                            },
                            {
                                field: "panes",
                                validators: [
                                    validator_1.Validators.reportPanesValidator
                                ]
                            },
                            {
                                field: "personalBookmarksEnabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "persistentFiltersEnabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "visualRenderedEvents",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "authoringHintsEnabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "printSettings",
                                validators: [
                                    validator_1.Validators.printSettingsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SettingsValidator = SettingsValidator;
                var PaginatedReportSettingsValidator = /** @class */ function(_super) {
                    __extends(PaginatedReportSettingsValidator, _super);
                    function PaginatedReportSettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PaginatedReportSettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "commands",
                                validators: [
                                    validator_1.Validators.paginatedReportCommandsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PaginatedReportSettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PaginatedReportSettingsValidator = PaginatedReportSettingsValidator;
            /***/ },
            /* 23 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SlicerStateValidator = exports.SlicerValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var SlicerValidator = /** @class */ function(_super) {
                    __extends(SlicerValidator, _super);
                    function SlicerValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SlicerValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "selector",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.slicerSelectorValidator
                                ]
                            },
                            {
                                field: "state",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.slicerStateValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SlicerValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SlicerValidator = SlicerValidator;
                var SlicerStateValidator = /** @class */ function(_super) {
                    __extends(SlicerStateValidator, _super);
                    function SlicerStateValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    SlicerStateValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "filters",
                                validators: [
                                    validator_1.Validators.filtersArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return SlicerStateValidator;
                }(typeValidator_1.ObjectValidator);
                exports.SlicerStateValidator = SlicerStateValidator;
            /***/ },
            /* 24 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TileLoadValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var TileLoadValidator = /** @class */ function(_super) {
                    __extends(TileLoadValidator, _super);
                    function TileLoadValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    TileLoadValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "accessToken",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "id",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "dashboardId",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "groupId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "pageView",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "tokenType",
                                validators: [
                                    validator_1.Validators.tokenTypeValidator
                                ]
                            },
                            {
                                field: "width",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            },
                            {
                                field: "height",
                                validators: [
                                    validator_1.Validators.numberValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return TileLoadValidator;
                }(typeValidator_1.ObjectValidator);
                exports.TileLoadValidator = TileLoadValidator;
            /***/ },
            /* 25 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VisualHeaderValidator = exports.VisualHeaderSettingsValidator = exports.VisualSettingsValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var VisualSettingsValidator = /** @class */ function(_super) {
                    __extends(VisualSettingsValidator, _super);
                    function VisualSettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    VisualSettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visualHeaders",
                                validators: [
                                    validator_1.Validators.visualHeadersValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return VisualSettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.VisualSettingsValidator = VisualSettingsValidator;
                var VisualHeaderSettingsValidator = /** @class */ function(_super) {
                    __extends(VisualHeaderSettingsValidator, _super);
                    function VisualHeaderSettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    VisualHeaderSettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "visible",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return VisualHeaderSettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.VisualHeaderSettingsValidator = VisualHeaderSettingsValidator;
                var VisualHeaderValidator = /** @class */ function(_super) {
                    __extends(VisualHeaderValidator, _super);
                    function VisualHeaderValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    VisualHeaderValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "settings",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.visualHeaderSettingsValidator
                                ]
                            },
                            {
                                field: "selector",
                                validators: [
                                    validator_1.Validators.visualHeaderSelectorValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return VisualHeaderValidator;
                }(typeValidator_1.ObjectValidator);
                exports.VisualHeaderValidator = VisualHeaderValidator;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnyOfValidator = void 0;
                var AnyOfValidator = /** @class */ function() {
                    function AnyOfValidator(validators) {
                        this.validators = validators;
                    }
                    AnyOfValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var valid = false;
                        for(var _i = 0, _a = this.validators; _i < _a.length; _i++){
                            var validator = _a[_i];
                            var errors = validator.validate(input, path, field);
                            if (!errors) {
                                valid = true;
                                break;
                            }
                        }
                        if (!valid) return [
                            {
                                message: field + " property is invalid",
                                path: (path ? path + "." : "") + field,
                                keyword: "invalid"
                            }
                        ];
                        return null;
                    };
                    return AnyOfValidator;
                }();
                exports.AnyOfValidator = AnyOfValidator;
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FieldForbiddenValidator = void 0;
                var FieldForbiddenValidator = /** @class */ function() {
                    function FieldForbiddenValidator() {}
                    FieldForbiddenValidator.prototype.validate = function(input, path, field) {
                        if (input !== undefined) return [
                            {
                                message: field + " is forbidden",
                                path: (path ? path + "." : "") + field,
                                keyword: "forbidden"
                            }
                        ];
                        return null;
                    };
                    return FieldForbiddenValidator;
                }();
                exports.FieldForbiddenValidator = FieldForbiddenValidator;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports)=>{
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FieldRequiredValidator = void 0;
                var FieldRequiredValidator = /** @class */ function() {
                    function FieldRequiredValidator() {}
                    FieldRequiredValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return [
                            {
                                message: field + " is required",
                                path: (path ? path + "." : "") + field,
                                keyword: "required"
                            }
                        ];
                        return null;
                    };
                    return FieldRequiredValidator;
                }();
                exports.FieldRequiredValidator = FieldRequiredValidator;
            /***/ },
            /* 29 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MapValidator = void 0;
                var typeValidator_1 = __webpack_require__(4);
                var MapValidator = /** @class */ function(_super) {
                    __extends(MapValidator, _super);
                    function MapValidator(keyValidators, valueValidators) {
                        var _this = _super.call(this) || this;
                        _this.keyValidators = keyValidators;
                        _this.valueValidators = valueValidators;
                        return _this;
                    }
                    MapValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        for(var key in input)if (input.hasOwnProperty(key)) {
                            var fieldsPath = (path ? path + "." : "") + field + "." + key;
                            for(var _i = 0, _a = this.keyValidators; _i < _a.length; _i++){
                                var keyValidator = _a[_i];
                                errors = keyValidator.validate(key, fieldsPath, field);
                                if (errors) return errors;
                            }
                            for(var _b = 0, _c = this.valueValidators; _b < _c.length; _b++){
                                var valueValidator = _c[_b];
                                errors = valueValidator.validate(input[key], fieldsPath, field);
                                if (errors) return errors;
                            }
                        }
                        return null;
                    };
                    return MapValidator;
                }(typeValidator_1.ObjectValidator);
                exports.MapValidator = MapValidator;
            /***/ },
            /* 30 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ParametersPanelValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var ParametersPanelValidator = /** @class */ function(_super) {
                    __extends(ParametersPanelValidator, _super);
                    function ParametersPanelValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ParametersPanelValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "expanded",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            },
                            {
                                field: "enabled",
                                validators: [
                                    validator_1.Validators.booleanValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ParametersPanelValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ParametersPanelValidator = ParametersPanelValidator;
            /***/ },
            /* 31 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TableDataValidator = exports.TableSchemaValidator = exports.ColumnSchemaValidator = exports.CredentialsValidator = exports.DatasourceConnectionConfigValidator = exports.DatasetCreateConfigValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var DatasetCreateConfigValidator = /** @class */ function(_super) {
                    __extends(DatasetCreateConfigValidator, _super);
                    function DatasetCreateConfigValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    DatasetCreateConfigValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "locale",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "mashupDocument",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "datasourceConnectionConfig",
                                validators: [
                                    validator_1.Validators.datasourceConnectionConfigValidator
                                ]
                            },
                            {
                                field: "tableSchemaList",
                                validators: [
                                    validator_1.Validators.tableSchemaListValidator
                                ]
                            },
                            {
                                field: "data",
                                validators: [
                                    validator_1.Validators.tableDataArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        errors = multipleFieldsValidator.validate(input, path, field);
                        if (errors) return errors;
                        if (input["datasourceConnectionConfig"] && input["mashupDocument"] == null) return [
                            {
                                message: "mashupDocument cannot be empty when datasourceConnectionConfig is presented"
                            }
                        ];
                        if (input["data"] && input["tableSchemaList"] == null) return [
                            {
                                message: "tableSchemaList cannot be empty when data is provided"
                            }
                        ];
                        if (input["data"] == null && input["mashupDocument"] == null) return [
                            {
                                message: "At least one of data or mashupDocument must be provided"
                            }
                        ];
                    };
                    return DatasetCreateConfigValidator;
                }(typeValidator_1.ObjectValidator);
                exports.DatasetCreateConfigValidator = DatasetCreateConfigValidator;
                var DatasourceConnectionConfigValidator = /** @class */ function(_super) {
                    __extends(DatasourceConnectionConfigValidator, _super);
                    function DatasourceConnectionConfigValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    DatasourceConnectionConfigValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "dataCacheMode",
                                validators: [
                                    validator_1.Validators.dataCacheModeValidator
                                ]
                            },
                            {
                                field: "credentials",
                                validators: [
                                    validator_1.Validators.credentialsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return DatasourceConnectionConfigValidator;
                }(typeValidator_1.ObjectValidator);
                exports.DatasourceConnectionConfigValidator = DatasourceConnectionConfigValidator;
                var CredentialsValidator = /** @class */ function(_super) {
                    __extends(CredentialsValidator, _super);
                    function CredentialsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    CredentialsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "credentialType",
                                validators: [
                                    validator_1.Validators.credentialTypeValidator
                                ]
                            },
                            {
                                field: "credentialDetails",
                                validators: [
                                    validator_1.Validators.credentialDetailsValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return CredentialsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.CredentialsValidator = CredentialsValidator;
                var ColumnSchemaValidator = /** @class */ function(_super) {
                    __extends(ColumnSchemaValidator, _super);
                    function ColumnSchemaValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ColumnSchemaValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "displayName",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "dataType",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return ColumnSchemaValidator;
                }(typeValidator_1.ObjectValidator);
                exports.ColumnSchemaValidator = ColumnSchemaValidator;
                var TableSchemaValidator = /** @class */ function(_super) {
                    __extends(TableSchemaValidator, _super);
                    function TableSchemaValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    TableSchemaValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "columns",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.columnSchemaArrayValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return TableSchemaValidator;
                }(typeValidator_1.ObjectValidator);
                exports.TableSchemaValidator = TableSchemaValidator;
                var TableDataValidator = /** @class */ function(_super) {
                    __extends(TableDataValidator, _super);
                    function TableDataValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    TableDataValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "name",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "rows",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.rawDataValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return TableDataValidator;
                }(typeValidator_1.ObjectValidator);
                exports.TableDataValidator = TableDataValidator;
            /***/ },
            /* 32 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.QuickCreateValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var QuickCreateValidator = /** @class */ function(_super) {
                    __extends(QuickCreateValidator, _super);
                    function QuickCreateValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    QuickCreateValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "accessToken",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "groupId",
                                validators: [
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "tokenType",
                                validators: [
                                    validator_1.Validators.tokenTypeValidator
                                ]
                            },
                            {
                                field: "theme",
                                validators: [
                                    validator_1.Validators.customThemeValidator
                                ]
                            },
                            {
                                field: "datasetCreateConfig",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.datasetCreateConfigValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return QuickCreateValidator;
                }(typeValidator_1.ObjectValidator);
                exports.QuickCreateValidator = QuickCreateValidator;
            /***/ },
            /* 33 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PrintSettingsValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var PrintSettingsValidator = /** @class */ function(_super) {
                    __extends(PrintSettingsValidator, _super);
                    function PrintSettingsValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PrintSettingsValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "browserPrintAdjustmentsMode",
                                validators: [
                                    new typeValidator_1.EnumValidator([
                                        0,
                                        1
                                    ])
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PrintSettingsValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PrintSettingsValidator = PrintSettingsValidator;
            /***/ },
            /* 34 */ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                // Copyright (c) Microsoft Corporation.
                // Licensed under the MIT License.
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PaginatedReportDatasetBindingValidator = void 0;
                var multipleFieldsValidator_1 = __webpack_require__(3);
                var typeValidator_1 = __webpack_require__(4);
                var validator_1 = __webpack_require__(1);
                var PaginatedReportDatasetBindingValidator = /** @class */ function(_super) {
                    __extends(PaginatedReportDatasetBindingValidator, _super);
                    function PaginatedReportDatasetBindingValidator() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    PaginatedReportDatasetBindingValidator.prototype.validate = function(input, path, field) {
                        if (input == null) return null;
                        var errors = _super.prototype.validate.call(this, input, path, field);
                        if (errors) return errors;
                        var fields = [
                            {
                                field: "sourceDatasetId",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            },
                            {
                                field: "targetDatasetId",
                                validators: [
                                    validator_1.Validators.fieldRequiredValidator,
                                    validator_1.Validators.stringValidator
                                ]
                            }
                        ];
                        var multipleFieldsValidator = new multipleFieldsValidator_1.MultipleFieldsValidator(fields);
                        return multipleFieldsValidator.validate(input, path, field);
                    };
                    return PaginatedReportDatasetBindingValidator;
                }(typeValidator_1.ObjectValidator);
                exports.PaginatedReportDatasetBindingValidator = PaginatedReportDatasetBindingValidator;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(0);
        /******/ /******/ return __webpack_exports__;
    /******/ })();
}); //# sourceMappingURL=models.js.map
 // SIG // Begin signature block
 // SIG // MIIreAYJKoZIhvcNAQcCoIIraTCCK2UCAQExDzANBglg
 // SIG // hkgBZQMEAgEFADB3BgorBgEEAYI3AgEEoGkwZzAyBgor
 // SIG // BgEEAYI3AgEeMCQCAQEEEBDgyQbOONQRoqMAEEvTUJAC
 // SIG // AQACAQACAQACAQACAQAwMTANBglghkgBZQMEAgEFAAQg
 // SIG // MwL/tGu4f/dhr3gVOxM8t9Nr0kVsURXdWFmzt2Tv2Syg
 // SIG // ghFuMIIIfjCCB2agAwIBAgITNgAAAd9zgZcWvjL9DQAC
 // SIG // AAAB3zANBgkqhkiG9w0BAQsFADBBMRMwEQYKCZImiZPy
 // SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRUw
 // SIG // EwYDVQQDEwxBTUUgQ1MgQ0EgMDEwHhcNMjQwMTIwMDEz
 // SIG // MzQ0WhcNMjUwMTE5MDEzMzQ0WjAkMSIwIAYDVQQDExlN
 // SIG // aWNyb3NvZnQgQXp1cmUgQ29kZSBTaWduMIIBIjANBgkq
 // SIG // hkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1bnAJpGyFqbK
 // SIG // WMrMsnUMskYdi/KuYoGBXMtrw5PMRr1TEQYccGzrCSBH
 // SIG // dMGPDe1lP8YJGDJ0rDOL5nNgePQxnawI0iam7MdM3/gy
 // SIG // xY6wSE1HnHUYZatFShl/FG1TpINGiHxTS0bOA0qwmWId
 // SIG // us8gfKpC/41Jgew4XARIYYDpV0UOCx51L+6n/ol6g7sB
 // SIG // c/bVEwIfCRrIC0QStKErEX1AfhSRdislMc5nhVySohMp
 // SIG // 7Fs+JKqDPdWoNWMNFPHdHvkYACotxbdXFwPt6ijOiNR9
 // SIG // dXvzXSI4e6E4b6wbXxJ4MJcG0xdymTh3YSwRWdfFOL/F
 // SIG // Xk5W+K/eN+OgmNvkip0GuwIDAQABo4IFijCCBYYwKQYJ
 // SIG // KwYBBAGCNxUKBBwwGjAMBgorBgEEAYI3WwEBMAoGCCsG
 // SIG // AQUFBwMDMD0GCSsGAQQBgjcVBwQwMC4GJisGAQQBgjcV
 // SIG // CIaQ4w2E1bR4hPGLPoWb3RbOnRKBYIPdzWaGlIwyAgFk
 // SIG // AgEOMIICdgYIKwYBBQUHAQEEggJoMIICZDBiBggrBgEF
 // SIG // BQcwAoZWaHR0cDovL2NybC5taWNyb3NvZnQuY29tL3Br
 // SIG // aWluZnJhL0NlcnRzL0JZMlBLSUNTQ0EwMS5BTUUuR0JM
 // SIG // X0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYIKwYB
 // SIG // BQUHMAKGRmh0dHA6Ly9jcmwxLmFtZS5nYmwvYWlhL0JZ
 // SIG // MlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIwQ0El
 // SIG // MjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6Ly9j
 // SIG // cmwyLmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5BTUUu
 // SIG // R0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYI
 // SIG // KwYBBQUHMAKGRmh0dHA6Ly9jcmwzLmFtZS5nYmwvYWlh
 // SIG // L0JZMlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIw
 // SIG // Q0ElMjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6
 // SIG // Ly9jcmw0LmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5B
 // SIG // TUUuR0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQw
 // SIG // ga0GCCsGAQUFBzAChoGgbGRhcDovLy9DTj1BTUUlMjBD
 // SIG // UyUyMENBJTIwMDEsQ049QUlBLENOPVB1YmxpYyUyMEtl
 // SIG // eSUyMFNlcnZpY2VzLENOPVNlcnZpY2VzLENOPUNvbmZp
 // SIG // Z3VyYXRpb24sREM9QU1FLERDPUdCTD9jQUNlcnRpZmlj
 // SIG // YXRlP2Jhc2U/b2JqZWN0Q2xhc3M9Y2VydGlmaWNhdGlv
 // SIG // bkF1dGhvcml0eTAdBgNVHQ4EFgQUju4tKpnu7Y7YxY8r
 // SIG // iI5ZhjOnGwkwDgYDVR0PAQH/BAQDAgeAMEUGA1UdEQQ+
 // SIG // MDykOjA4MR4wHAYDVQQLExVNaWNyb3NvZnQgQ29ycG9y
 // SIG // YXRpb24xFjAUBgNVBAUTDTIzNjE2Nys1MDE5NzAwggHm
 // SIG // BgNVHR8EggHdMIIB2TCCAdWgggHRoIIBzYY/aHR0cDov
 // SIG // L2NybC5taWNyb3NvZnQuY29tL3BraWluZnJhL0NSTC9B
 // SIG // TUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRwOi8v
 // SIG // Y3JsMS5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENBJTIw
 // SIG // MDEoMikuY3JshjFodHRwOi8vY3JsMi5hbWUuZ2JsL2Ny
 // SIG // bC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRw
 // SIG // Oi8vY3JsMy5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENB
 // SIG // JTIwMDEoMikuY3JshjFodHRwOi8vY3JsNC5hbWUuZ2Js
 // SIG // L2NybC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshoG9
 // SIG // bGRhcDovLy9DTj1BTUUlMjBDUyUyMENBJTIwMDEoMiks
 // SIG // Q049QlkyUEtJQ1NDQTAxLENOPUNEUCxDTj1QdWJsaWMl
 // SIG // MjBLZXklMjBTZXJ2aWNlcyxDTj1TZXJ2aWNlcyxDTj1D
 // SIG // b25maWd1cmF0aW9uLERDPUFNRSxEQz1HQkw/Y2VydGlm
 // SIG // aWNhdGVSZXZvY2F0aW9uTGlzdD9iYXNlP29iamVjdENs
 // SIG // YXNzPWNSTERpc3RyaWJ1dGlvblBvaW50MB8GA1UdIwQY
 // SIG // MBaAFJZRhOBrb3v+2Aarw/KF5imuavnUMB8GA1UdJQQY
 // SIG // MBYGCisGAQQBgjdbAQEGCCsGAQUFBwMDMA0GCSqGSIb3
 // SIG // DQEBCwUAA4IBAQCXv2FzUgqF4rS3/1+aXyWaXqd3LI3a
 // SIG // pgYIPvCq/vvFzI1sHZuLYi2rCTFDwoJqeTWJ98AuBnnx
 // SIG // mMHxe15thTEkdoukFB44oBrugY3VkIeBMBmjaly5F5VD
 // SIG // O1sNmdCq0baQi9egwjkzWbghTwMrUhxbJD1q6+qtxAbo
 // SIG // jOj+VS4BUiogMXLp5XSaK26wa72UmYm9TiDcxRgELM1E
 // SIG // dMraL1uhTqfrqFYYkAqpzoXgtaaZ2T7LO7516KIMjtMY
 // SIG // EluNG0ZZbRn8J5TndyGf+N2To+V3nkoYOdks1RIsmK2Y
 // SIG // w9ezEjc0DNSSiNO/prQAuw/nmf/oNqTP/daB3Kw6vTau
 // SIG // EK0tMIII6DCCBtCgAwIBAgITHwAAAFHqj/accwyoOwAA
 // SIG // AAAAUTANBgkqhkiG9w0BAQsFADA8MRMwEQYKCZImiZPy
 // SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRAw
 // SIG // DgYDVQQDEwdhbWVyb290MB4XDTIxMDUyMTE4NDQxNFoX
 // SIG // DTI2MDUyMTE4NTQxNFowQTETMBEGCgmSJomT8ixkARkW
 // SIG // A0dCTDETMBEGCgmSJomT8ixkARkWA0FNRTEVMBMGA1UE
 // SIG // AxMMQU1FIENTIENBIDAxMIIBIjANBgkqhkiG9w0BAQEF
 // SIG // AAOCAQ8AMIIBCgKCAQEAyZpSCX0Bno1W1yqXMhT6BUlJ
 // SIG // ZWpa4p3xFeiTHO4vm2Q6C/azR5xwxnyYHrkSGDtS2P9X
 // SIG // +KDE64V20mmEQkubxnPNeOVnE2RvdPGxgwlq+BhS3ONd
 // SIG // VsQPj79q7XgHM9HhzB9+qk0PC9KN1zm9p/seyiRS6JF1
 // SIG // dbOqRf1pUl7FAVxmgiCFgV8hHIb/rDPXig7FDi3S0yEx
 // SIG // 2CUDVpIq8jEhG8anUFE1WYxM+ni0S5KHwwKPKV4qyGDo
 // SIG // DO+9AmDoma3Chyu5WDlW5cdtqXTWsGPE3umtnX6Amlld
 // SIG // UFLms4OVR4guKf+n5LIBCC6bTiocfXPomqYjYTKx7AGM
 // SIG // faVLaaXmhQIDAQABo4IE3DCCBNgwEgYJKwYBBAGCNxUB
 // SIG // BAUCAwIAAjAjBgkrBgEEAYI3FQIEFgQUEmgkQiFHy9Rr
 // SIG // vjHPIKTACyN/P0cwHQYDVR0OBBYEFJZRhOBrb3v+2Aar
 // SIG // w/KF5imuavnUMIIBBAYDVR0lBIH8MIH5BgcrBgEFAgMF
 // SIG // BggrBgEFBQcDAQYIKwYBBQUHAwIGCisGAQQBgjcUAgEG
 // SIG // CSsGAQQBgjcVBgYKKwYBBAGCNwoDDAYJKwYBBAGCNxUG
 // SIG // BggrBgEFBQcDCQYIKwYBBQUIAgIGCisGAQQBgjdAAQEG
 // SIG // CysGAQQBgjcKAwQBBgorBgEEAYI3CgMEBgkrBgEEAYI3
 // SIG // FQUGCisGAQQBgjcUAgIGCisGAQQBgjcUAgMGCCsGAQUF
 // SIG // BwMDBgorBgEEAYI3WwEBBgorBgEEAYI3WwIBBgorBgEE
 // SIG // AYI3WwMBBgorBgEEAYI3WwUBBgorBgEEAYI3WwQBBgor
 // SIG // BgEEAYI3WwQCMBkGCSsGAQQBgjcUAgQMHgoAUwB1AGIA
 // SIG // QwBBMAsGA1UdDwQEAwIBhjASBgNVHRMBAf8ECDAGAQH/
 // SIG // AgEAMB8GA1UdIwQYMBaAFCleUV5krjS566ycDaeMdQHR
 // SIG // CQsoMIIBaAYDVR0fBIIBXzCCAVswggFXoIIBU6CCAU+G
 // SIG // MWh0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9wa2lpbmZy
 // SIG // YS9jcmwvYW1lcm9vdC5jcmyGI2h0dHA6Ly9jcmwyLmFt
 // SIG // ZS5nYmwvY3JsL2FtZXJvb3QuY3JshiNodHRwOi8vY3Js
 // SIG // My5hbWUuZ2JsL2NybC9hbWVyb290LmNybIYjaHR0cDov
 // SIG // L2NybDEuYW1lLmdibC9jcmwvYW1lcm9vdC5jcmyGgaps
 // SIG // ZGFwOi8vL0NOPWFtZXJvb3QsQ049QU1FUm9vdCxDTj1D
 // SIG // RFAsQ049UHVibGljJTIwS2V5JTIwU2VydmljZXMsQ049
 // SIG // U2VydmljZXMsQ049Q29uZmlndXJhdGlvbixEQz1BTUUs
 // SIG // REM9R0JMP2NlcnRpZmljYXRlUmV2b2NhdGlvbkxpc3Q/
 // SIG // YmFzZT9vYmplY3RDbGFzcz1jUkxEaXN0cmlidXRpb25Q
 // SIG // b2ludDCCAasGCCsGAQUFBwEBBIIBnTCCAZkwRwYIKwYB
 // SIG // BQUHMAKGO2h0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9w
 // SIG // a2lpbmZyYS9jZXJ0cy9BTUVSb290X2FtZXJvb3QuY3J0
 // SIG // MDcGCCsGAQUFBzAChitodHRwOi8vY3JsMi5hbWUuZ2Js
 // SIG // L2FpYS9BTUVSb290X2FtZXJvb3QuY3J0MDcGCCsGAQUF
 // SIG // BzAChitodHRwOi8vY3JsMy5hbWUuZ2JsL2FpYS9BTUVS
 // SIG // b290X2FtZXJvb3QuY3J0MDcGCCsGAQUFBzAChitodHRw
 // SIG // Oi8vY3JsMS5hbWUuZ2JsL2FpYS9BTUVSb290X2FtZXJv
 // SIG // b3QuY3J0MIGiBggrBgEFBQcwAoaBlWxkYXA6Ly8vQ049
 // SIG // YW1lcm9vdCxDTj1BSUEsQ049UHVibGljJTIwS2V5JTIw
 // SIG // U2VydmljZXMsQ049U2VydmljZXMsQ049Q29uZmlndXJh
 // SIG // dGlvbixEQz1BTUUsREM9R0JMP2NBQ2VydGlmaWNhdGU/
 // SIG // YmFzZT9vYmplY3RDbGFzcz1jZXJ0aWZpY2F0aW9uQXV0
 // SIG // aG9yaXR5MA0GCSqGSIb3DQEBCwUAA4ICAQBQECO3Tw/o
 // SIG // 317Rrd7yadqcswPx1LvIYymkaTN6KcmuRt6HKa0Xe73U
 // SIG // x2/AQ30TfgA9GBJngweRykKBusRzyOU17iIubJvy3gA2
 // SIG // 1dwtqtB0DsoEv1U/ptVu2v++doTCJ/i+GbssVXkgaX8H
 // SIG // +6EOGEmT4evp4GbwR4HwWlc+Dvf8HH8PdUA2Z04CvcwI
 // SIG // fckSipbNm84jxJ8XjmTFTWscldL9edj2NsY6iGnyJFIy
 // SIG // ur2PS7VRYyV3p1VAJp91gj1jRQtWEyCB8P5g9nE3z8u0
 // SIG // ANaU/hjwEQCrdGyravWgnf2JtG+bT26YAokbc8m+32zU
 // SIG // tXRO+NK3tAjhOu2FdsG3qNrF4sc7y37R/C+7Pcb/cFfh
 // SIG // ttqsirepZii4xStcjMODYuXzGm3IJs0b0owHG6oKd7ZO
 // SIG // GvHpmmh9K8/DLriD/sq8bURD10qi/wuW8zM7IpLg1vcR
 // SIG // 9dIK2mc0pj44pc6UX0XbttP/VEJgu3lT2eI9VjWtaKjx
 // SIG // 38xE9woSMyekPRtzTwgfuysF9DkJisr+yA4po/FPxpbB
 // SIG // w9c/hBf32DH/GFxteS2pmjgKIbMP8sDukmEq3lVvuWNJ
 // SIG // sybrZwQvQpvaM49fv+JKpLK5YWYEfwksYRR9wU8Hh/ID
 // SIG // 9hRCEkbUoQ2W7mMpsp2Nbp/kcn4ivfolUy3Q9Yf0scsQ
 // SIG // 6WTLYpm+AoCUJTGCGWIwghleAgEBMFgwQTETMBEGCgmS
 // SIG // JomT8ixkARkWA0dCTDETMBEGCgmSJomT8ixkARkWA0FN
 // SIG // RTEVMBMGA1UEAxMMQU1FIENTIENBIDAxAhM2AAAB33OB
 // SIG // lxa+Mv0NAAIAAAHfMA0GCWCGSAFlAwQCAQUAoIGuMBkG
 // SIG // CSqGSIb3DQEJAzEMBgorBgEEAYI3AgEEMBwGCisGAQQB
 // SIG // gjcCAQsxDjAMBgorBgEEAYI3AgEVMC8GCSqGSIb3DQEJ
 // SIG // BDEiBCC3oAvWj8W35XCGz6mfgvuaIDOaSXvP1W3rFrPd
 // SIG // AOh/bzBCBgorBgEEAYI3AgEMMTQwMqAUgBIATQBpAGMA
 // SIG // cgBvAHMAbwBmAHShGoAYaHR0cDovL3d3dy5taWNyb3Nv
 // SIG // ZnQuY29tMA0GCSqGSIb3DQEBAQUABIIBAH+QbSXUtg4a
 // SIG // 1DpnczlSYMWv9IBjG6D/if62zIqGmL0+uLeJryRfcW1I
 // SIG // AP8F/i8LvWbtodi6cANj2DSmm3tZQ4ynfUkdQTza1zEM
 // SIG // tbZuCZk9w3X+ToN1tfLiWxqWnRQl+RPJ83+OrlP55pAq
 // SIG // Ryg1Mfm6lVs9q3FmhPRyWEaPyH8BDBIDss80A+1Hv5mt
 // SIG // d2fhe8rR+/+bNhdrR9AcAU1eTP4R9x/IZL0ZlxqwMP8h
 // SIG // e/juk00nO5gkakd6+SuHBqNOh4Sak9eBvai/3kU/Pslx
 // SIG // qnn/f1vDjXxx554VyA/0WkKXh1G/4yf1v5JTqNC/etNK
 // SIG // X8AOamhT9a08WNVMC4XQMZmhghcqMIIXJgYKKwYBBAGC
 // SIG // NwMDATGCFxYwghcSBgkqhkiG9w0BBwKgghcDMIIW/wIB
 // SIG // AzEPMA0GCWCGSAFlAwQCAQUAMIIBWQYLKoZIhvcNAQkQ
 // SIG // AQSgggFIBIIBRDCCAUACAQEGCisGAQQBhFkKAwEwMTAN
 // SIG // BglghkgBZQMEAgEFAAQgiRIZEQCbpfMTea7mD6b6LEjM
 // SIG // OeXK5udPpePql6WE5/MCBmXxz4wKeRgTMjAyNDAzMjEx
 // SIG // NTA2MzEuMzEyWjAEgAIB9KCB2KSB1TCB0jELMAkGA1UE
 // SIG // BhMCVVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNV
 // SIG // BAcTB1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBD
 // SIG // b3Jwb3JhdGlvbjEtMCsGA1UECxMkTWljcm9zb2Z0IEly
 // SIG // ZWxhbmQgT3BlcmF0aW9ucyBMaW1pdGVkMSYwJAYDVQQL
 // SIG // Ex1UaGFsZXMgVFNTIEVTTjo4RDQxLTRCRjctQjNCNzEl
 // SIG // MCMGA1UEAxMcTWljcm9zb2Z0IFRpbWUtU3RhbXAgU2Vy
 // SIG // dmljZaCCEXkwggcnMIIFD6ADAgECAhMzAAAB49+9m5oc
 // SIG // aIMiAAEAAAHjMA0GCSqGSIb3DQEBCwUAMHwxCzAJBgNV
 // SIG // BAYTAlVTMRMwEQYDVQQIEwpXYXNoaW5ndG9uMRAwDgYD
 // SIG // VQQHEwdSZWRtb25kMR4wHAYDVQQKExVNaWNyb3NvZnQg
 // SIG // Q29ycG9yYXRpb24xJjAkBgNVBAMTHU1pY3Jvc29mdCBU
 // SIG // aW1lLVN0YW1wIFBDQSAyMDEwMB4XDTIzMTAxMjE5MDcy
 // SIG // OVoXDTI1MDExMDE5MDcyOVowgdIxCzAJBgNVBAYTAlVT
 // SIG // MRMwEQYDVQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdS
 // SIG // ZWRtb25kMR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9y
 // SIG // YXRpb24xLTArBgNVBAsTJE1pY3Jvc29mdCBJcmVsYW5k
 // SIG // IE9wZXJhdGlvbnMgTGltaXRlZDEmMCQGA1UECxMdVGhh
 // SIG // bGVzIFRTUyBFU046OEQ0MS00QkY3LUIzQjcxJTAjBgNV
 // SIG // BAMTHE1pY3Jvc29mdCBUaW1lLVN0YW1wIFNlcnZpY2Uw
 // SIG // ggIiMA0GCSqGSIb3DQEBAQUAA4ICDwAwggIKAoICAQC+
 // SIG // pA1oHkafn8UgVA+jf8rhCaV4IMwXjRuSgfDPQGyFnhKJ
 // SIG // CYDoIZTIPCZqpDbAeFpdTRF0e3C+r5TwrFhizIcqprHE
 // SIG // Lt+v/Idm8ek1ODPHVWRHeleFPpfYKbXvlRfdZDiN+Xzq
 // SIG // ienkAzMEgUOXPRJTxVIo0wO81e2OT0WK0uBS/aePeE4n
 // SIG // QqQRB+TegDubvMDQP4yjveGZH44Lu7CxfElHa3NRkTRJ
 // SIG // NhfdS96cUft9hbLkE2YvIaraxaRDkcW8koIkAT93B+3z
 // SIG // 5XjdTcp4TEX+k+1wtS9D0cisvTGekwVq7th3lor5MSLn
 // SIG // tZy0G/zv59I9kFXeNmX9AK1wf1aueIEPCSL1B9HG78lj
 // SIG // PD6JoRYuqthe4XuN44a8cr59V4tacBzlbGx9umMQyk1s
 // SIG // ZdtIX0C3c8+EVU6PHBUTHUAsZSpEp6HD1qn1f+B+QD0j
 // SIG // 15NK/AnP3DJr2t4OBL7qReBK20jtFDZwkb+1A8ZUhosI
 // SIG // hpJp8ud5qrQGezS3j4RbcH8aegEyKI5fCV469/m50FlA
 // SIG // gwneTmqeeHxnhmFPCsTqIZs+tOAYE9eHt7EVgAaVvqF2
 // SIG // EgshUN0mUN/yzU1W8vRDbLhIdlCECllO5b+3Iawaxwg8
 // SIG // NIzPlsDo2FEu2MTAIWksjmoaW7nQC70VF6UIRCxaDurT
 // SIG // sf+uoc6oI0kzhGN6buOgRQIDAQABo4IBSTCCAUUwHQYD
 // SIG // VR0OBBYEFLGuDWa+NRW3oWfGPnqdptmImKkDMB8GA1Ud
 // SIG // IwQYMBaAFJ+nFV0AXmJdg/Tl0mWnG1M1GelyMF8GA1Ud
 // SIG // HwRYMFYwVKBSoFCGTmh0dHA6Ly93d3cubWljcm9zb2Z0
 // SIG // LmNvbS9wa2lvcHMvY3JsL01pY3Jvc29mdCUyMFRpbWUt
 // SIG // U3RhbXAlMjBQQ0ElMjAyMDEwKDEpLmNybDBsBggrBgEF
 // SIG // BQcBAQRgMF4wXAYIKwYBBQUHMAKGUGh0dHA6Ly93d3cu
 // SIG // bWljcm9zb2Z0LmNvbS9wa2lvcHMvY2VydHMvTWljcm9z
 // SIG // b2Z0JTIwVGltZS1TdGFtcCUyMFBDQSUyMDIwMTAoMSku
 // SIG // Y3J0MAwGA1UdEwEB/wQCMAAwFgYDVR0lAQH/BAwwCgYI
 // SIG // KwYBBQUHAwgwDgYDVR0PAQH/BAQDAgeAMA0GCSqGSIb3
 // SIG // DQEBCwUAA4ICAQC3vpsuqdTTzBFtbe9GvGNoRsY+rIg0
 // SIG // rpRgLOFMZpH88TAInOI9Phkz2x8ZNfd5kNBUT2vXbW0W
 // SIG // 2ns1dBi5BLFFkxhdrT+lrA3Zef5Q+MFEO+gKxTnp3AqS
 // SIG // ubLxNLDtBcoayR2cTCwjnJb3erwCDzpGQGIoQR/0V3Mc
 // SIG // 24pYjgq//98O0RJ7C7jqf+75VyQLBs5iXrAT/9BEasYy
 // SIG // rnT1rgRs/6nUZSbTpeZ7/TWZMi4oOA+YcvadhHNc2qLY
 // SIG // i4h5yfZpbCRHFA4WI/D52JyY47Asb/sic2qNmlB4iEMz
 // SIG // GxavjNPHPLgRH/rN+2G2UO1wBccHthFSQFMKVo5rSd29
 // SIG // 80lkzJhVrpxa9mi5Or1XktLtTMhHxL/tGw5Pjd45rAsG
 // SIG // y5DPRWg4u6th7VJ98+pOwJxE3NvHQLy3/4qKlK1WE8Aa
 // SIG // 20R+F1RRL2iEPou3rA0InFltXQgwPyd8TqAhAlevOtdY
 // SIG // 64mo33VYPKNFqfhQoOQgFLbJYDhbomFC4HMZ6s5Jj9ou
 // SIG // fGRGtK5uC2cphwc7CDFNMjJrlZgJGMW3RA4uV6pWSLqT
 // SIG // 6apg+v3y4w+Lm9EhBLbTqYNJ6dK2vzDQn7/7VYSbc+cI
 // SIG // IhCCl/rOGpGsC32PtesQweuDZtB6BrPxsvNt7pSJuBsq
 // SIG // 1HKTWcZ17xOjmTIyP1dQIEgIPFP4XjFrmU1lVDCCB3Ew
 // SIG // ggVZoAMCAQICEzMAAAAVxedrngKbSZkAAAAAABUwDQYJ
 // SIG // KoZIhvcNAQELBQAwgYgxCzAJBgNVBAYTAlVTMRMwEQYD
 // SIG // VQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25k
 // SIG // MR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24x
 // SIG // MjAwBgNVBAMTKU1pY3Jvc29mdCBSb290IENlcnRpZmlj
 // SIG // YXRlIEF1dGhvcml0eSAyMDEwMB4XDTIxMDkzMDE4MjIy
 // SIG // NVoXDTMwMDkzMDE4MzIyNVowfDELMAkGA1UEBhMCVVMx
 // SIG // EzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNVBAcTB1Jl
 // SIG // ZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jwb3Jh
 // SIG // dGlvbjEmMCQGA1UEAxMdTWljcm9zb2Z0IFRpbWUtU3Rh
 // SIG // bXAgUENBIDIwMTAwggIiMA0GCSqGSIb3DQEBAQUAA4IC
 // SIG // DwAwggIKAoICAQDk4aZM57RyIQt5osvXJHm9DtWC0/3u
 // SIG // nAcH0qlsTnXIyjVX9gF/bErg4r25PhdgM/9cT8dm95VT
 // SIG // cVrifkpa/rg2Z4VGIwy1jRPPdzLAEBjoYH1qUoNEt6aO
 // SIG // RmsHFPPFdvWGUNzBRMhxXFExN6AKOG6N7dcP2CZTfDlh
 // SIG // AnrEqv1yaa8dq6z2Nr41JmTamDu6GnszrYBbfowQHJ1S
 // SIG // /rboYiXcag/PXfT+jlPP1uyFVk3v3byNpOORj7I5LFGc
 // SIG // 6XBpDco2LXCOMcg1KL3jtIckw+DJj361VI/c+gVVmG1o
 // SIG // O5pGve2krnopN6zL64NF50ZuyjLVwIYwXE8s4mKyzbni
 // SIG // jYjklqwBSru+cakXW2dg3viSkR4dPf0gz3N9QZpGdc3E
 // SIG // XzTdEonW/aUgfX782Z5F37ZyL9t9X4C626p+Nuw2TPYr
 // SIG // bqgSUei/BQOj0XOmTTd0lBw0gg/wEPK3Rxjtp+iZfD9M
 // SIG // 269ewvPV2HM9Q07BMzlMjgK8QmguEOqEUUbi0b1qGFph
 // SIG // AXPKZ6Je1yh2AuIzGHLXpyDwwvoSCtdjbwzJNmSLW6Cm
 // SIG // gyFdXzB0kZSU2LlQ+QuJYfM2BjUYhEfb3BvR/bLUHMVr
 // SIG // 9lxSUV0S2yW6r1AFemzFER1y7435UsSFF5PAPBXbGjfH
 // SIG // CBUYP3irRbb1Hode2o+eFnJpxq57t7c+auIurQIDAQAB
 // SIG // o4IB3TCCAdkwEgYJKwYBBAGCNxUBBAUCAwEAATAjBgkr
 // SIG // BgEEAYI3FQIEFgQUKqdS/mTEmr6CkTxGNSnPEP8vBO4w
 // SIG // HQYDVR0OBBYEFJ+nFV0AXmJdg/Tl0mWnG1M1GelyMFwG
 // SIG // A1UdIARVMFMwUQYMKwYBBAGCN0yDfQEBMEEwPwYIKwYB
 // SIG // BQUHAgEWM2h0dHA6Ly93d3cubWljcm9zb2Z0LmNvbS9w
 // SIG // a2lvcHMvRG9jcy9SZXBvc2l0b3J5Lmh0bTATBgNVHSUE
 // SIG // DDAKBggrBgEFBQcDCDAZBgkrBgEEAYI3FAIEDB4KAFMA
 // SIG // dQBiAEMAQTALBgNVHQ8EBAMCAYYwDwYDVR0TAQH/BAUw
 // SIG // AwEB/zAfBgNVHSMEGDAWgBTV9lbLj+iiXGJo0T2UkFvX
 // SIG // zpoYxDBWBgNVHR8ETzBNMEugSaBHhkVodHRwOi8vY3Js
 // SIG // Lm1pY3Jvc29mdC5jb20vcGtpL2NybC9wcm9kdWN0cy9N
 // SIG // aWNSb29DZXJBdXRfMjAxMC0wNi0yMy5jcmwwWgYIKwYB
 // SIG // BQUHAQEETjBMMEoGCCsGAQUFBzAChj5odHRwOi8vd3d3
 // SIG // Lm1pY3Jvc29mdC5jb20vcGtpL2NlcnRzL01pY1Jvb0Nl
 // SIG // ckF1dF8yMDEwLTA2LTIzLmNydDANBgkqhkiG9w0BAQsF
 // SIG // AAOCAgEAnVV9/Cqt4SwfZwExJFvhnnJL/Klv6lwUtj5O
 // SIG // R2R4sQaTlz0xM7U518JxNj/aZGx80HU5bbsPMeTCj/ts
 // SIG // 0aGUGCLu6WZnOlNN3Zi6th542DYunKmCVgADsAW+iehp
 // SIG // 4LoJ7nvfam++Kctu2D9IdQHZGN5tggz1bSNU5HhTdSRX
 // SIG // ud2f8449xvNo32X2pFaq95W2KFUn0CS9QKC/GbYSEhFd
 // SIG // PSfgQJY4rPf5KYnDvBewVIVCs/wMnosZiefwC2qBwoEZ
 // SIG // QhlSdYo2wh3DYXMuLGt7bj8sCXgU6ZGyqVvfSaN0DLzs
 // SIG // kYDSPeZKPmY7T7uG+jIa2Zb0j/aRAfbOxnT99kxybxCr
 // SIG // dTDFNLB62FD+CljdQDzHVG2dY3RILLFORy3BFARxv2T5
 // SIG // JL5zbcqOCb2zAVdJVGTZc9d/HltEAY5aGZFrDZ+kKNxn
 // SIG // GSgkujhLmm77IVRrakURR6nxt67I6IleT53S0Ex2tVdU
 // SIG // CbFpAUR+fKFhbHP+CrvsQWY9af3LwUFJfn6Tvsv4O+S3
 // SIG // Fb+0zj6lMVGEvL8CwYKiexcdFYmNcP7ntdAoGokLjzba
 // SIG // ukz5m/8K6TT4JDVnK+ANuOaMmdbhIurwJ0I9JZTmdHRb
 // SIG // atGePu1+oDEzfbzL6Xu/OHBE0ZDxyKs6ijoIYn/ZcGNT
 // SIG // TY3ugm2lBRDBcQZqELQdVTNYs6FwZvKhggLVMIICPgIB
 // SIG // ATCCAQChgdikgdUwgdIxCzAJBgNVBAYTAlVTMRMwEQYD
 // SIG // VQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25k
 // SIG // MR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24x
 // SIG // LTArBgNVBAsTJE1pY3Jvc29mdCBJcmVsYW5kIE9wZXJh
 // SIG // dGlvbnMgTGltaXRlZDEmMCQGA1UECxMdVGhhbGVzIFRT
 // SIG // UyBFU046OEQ0MS00QkY3LUIzQjcxJTAjBgNVBAMTHE1p
 // SIG // Y3Jvc29mdCBUaW1lLVN0YW1wIFNlcnZpY2WiIwoBATAH
 // SIG // BgUrDgMCGgMVAD2Il7vDkUOIbynLhOxitAjoMVp6oIGD
 // SIG // MIGApH4wfDELMAkGA1UEBhMCVVMxEzARBgNVBAgTCldh
 // SIG // c2hpbmd0b24xEDAOBgNVBAcTB1JlZG1vbmQxHjAcBgNV
 // SIG // BAoTFU1pY3Jvc29mdCBDb3Jwb3JhdGlvbjEmMCQGA1UE
 // SIG // AxMdTWljcm9zb2Z0IFRpbWUtU3RhbXAgUENBIDIwMTAw
 // SIG // DQYJKoZIhvcNAQEFBQACBQDppi9YMCIYDzIwMjQwMzIx
 // SIG // MTIwMDI0WhgPMjAyNDAzMjIxMjAwMjRaMHUwOwYKKwYB
 // SIG // BAGEWQoEATEtMCswCgIFAOmmL1gCAQAwCAIBAAIDAIr8
 // SIG // MAcCAQACAlsQMAoCBQDpp4DYAgEAMDYGCisGAQQBhFkK
 // SIG // BAIxKDAmMAwGCisGAQQBhFkKAwKgCjAIAgEAAgMHoSCh
 // SIG // CjAIAgEAAgMBhqAwDQYJKoZIhvcNAQEFBQADgYEAXxtC
 // SIG // QhsIs3i3cDZZ0AvijAZ7yDQhh2CWDwAvtI3D/b+TsXTS
 // SIG // gn5GiUcSBQnhgxmQPkW6B7Ad1D7f2x+pmWmlrgCZp7Jn
 // SIG // lvac0WwWSsdLaeVS1mCsVKobp8WZ3X/sto4bV8NQcSQQ
 // SIG // d67rqC2iRkbVM1PSFcT6VmHKRTfcOHatsHQxggQNMIIE
 // SIG // CQIBATCBkzB8MQswCQYDVQQGEwJVUzETMBEGA1UECBMK
 // SIG // V2FzaGluZ3RvbjEQMA4GA1UEBxMHUmVkbW9uZDEeMBwG
 // SIG // A1UEChMVTWljcm9zb2Z0IENvcnBvcmF0aW9uMSYwJAYD
 // SIG // VQQDEx1NaWNyb3NvZnQgVGltZS1TdGFtcCBQQ0EgMjAx
 // SIG // MAITMwAAAePfvZuaHGiDIgABAAAB4zANBglghkgBZQME
 // SIG // AgEFAKCCAUowGgYJKoZIhvcNAQkDMQ0GCyqGSIb3DQEJ
 // SIG // EAEEMC8GCSqGSIb3DQEJBDEiBCAprdBPDwqal6VpAAOV
 // SIG // i+J92DiJe6lERu9UeZxt4Qn0QzCB+gYLKoZIhvcNAQkQ
 // SIG // Ai8xgeowgecwgeQwgb0EIDPUI6vlsP5k90SBCNa9wha4
 // SIG // MlxBt2Crw12PTHIy5iYqMIGYMIGApH4wfDELMAkGA1UE
 // SIG // BhMCVVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNV
 // SIG // BAcTB1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBD
 // SIG // b3Jwb3JhdGlvbjEmMCQGA1UEAxMdTWljcm9zb2Z0IFRp
 // SIG // bWUtU3RhbXAgUENBIDIwMTACEzMAAAHj372bmhxogyIA
 // SIG // AQAAAeMwIgQgfAfgbQHUyCCwG8I1CtfFUY+J5pYJIHw3
 // SIG // 3qm3nzXXMpEwDQYJKoZIhvcNAQELBQAEggIAOQSUw4z9
 // SIG // Dc/eTPbnSMOKo4RhCpQ8rBBnu5MUon6DOIpHS5E+xv/N
 // SIG // /AtZ9HY/VhlH6MmAJgImbvqh9+KopJwEpfOfSyQNALTM
 // SIG // mjgYmGErF53TeYSDPDfN7l3r4Fd3Lu237/L4niMEOKNs
 // SIG // LbBouy6UUKCQ78iKwiKCGMAXq9cVKba7FLiuVKNMXoBB
 // SIG // +imsivm6pU92eg/+/iEzHrTSgWh6nRSWK74mSd9rza8o
 // SIG // Idp/DKUQPOpB+m4dQEB43+ixdXBZ3+yCSZvreiGwR8vR
 // SIG // PfonLWxkcE425RRTLTut4yXaOs5fhDZfY5ho13mgYWAD
 // SIG // KbqIij2ZuvLCMugRFbL2ypMk0xHpA9DSWLuJE25EBe0y
 // SIG // +WPMtjDDC4Vlv9Iao58tZPkFUh0i5br2bu9J+4YPOaI0
 // SIG // mIi/auJA7imf1pm2y6FrDYTbp+0bAR3ePZsKgQm8hgYW
 // SIG // XnJ/I1Mx1NeGTuC0VSMU9/0eFNWzOwdzzGCMxG8pOO34
 // SIG // K9UuDaRgNpoo+RXp1vNa7NnJ3ifiaeHx8V2mEhqX5gig
 // SIG // QTHdGpkqPoKBdu9aLxprB+DPzHkAbb+F0Xd9ElnFU/0Z
 // SIG // VlyVQ8rawejf7dtVFNV+jRX4ET/2qSauKAmweOlncur7
 // SIG // XufbM4VHBBnZyDqQAkK+kwjsQ/2ALvgxlQDYZVfQTsCT
 // SIG // sI4ez1LRm+bvHRs=
 // SIG // End signature block

});

parcelRegister("6BXy7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b643ef0331ac3ea4$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");

var $bcbvQ = parcelRequire("bcbvQ");
// Ensures that effect runs when isLoggedIn changes, but only when it changes to true.
const $b643ef0331ac3ea4$var$useWhenLoggedIn = (callback, additionalDeps = [])=>{
    const isLoggedIn = (0, $bcbvQ.default).isLoggedIn();
    (0, $dvPqk.useEffect)(()=>{
        if ((0, $bcbvQ.default).isLoggedIn()) callback();
    }, [
        ...additionalDeps,
        isLoggedIn
    ]);
};
var $b643ef0331ac3ea4$export$2e2bcd8739ae039 = $b643ef0331ac3ea4$var$useWhenLoggedIn;

});


parcelRegister("cY4Gr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $970eb8b4416ff122$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $970eb8b4416ff122$var$SvgUser = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M12.237 11.621q-1.778 0-3.044-1.266T7.926 7.31t1.267-3.045T12.237 3t3.044 1.266 1.266 3.045-1.266 3.044-3.044 1.266M3 21v-2.738q0-.905.491-1.675A3.3 3.3 0 0 1 4.805 15.4a18 18 0 0 1 3.684-1.343 15.95 15.95 0 0 1 7.496 0q1.859.448 3.684 1.343a3.3 3.3 0 0 1 1.313 1.186q.492.77.492 1.675V21zm1.847-1.847h14.78v-.89q0-.375-.217-.694a1.64 1.64 0 0 0-.589-.52 15.8 15.8 0 0 0-3.246-1.187 14 14 0 0 0-6.677 0q-1.653.404-3.245 1.187a1.64 1.64 0 0 0-.589.52 1.2 1.2 0 0 0-.217.693zm7.39-9.38q1.016 0 1.74-.723a2.37 2.37 0 0 0 .723-1.74q0-1.015-.723-1.74a2.37 2.37 0 0 0-1.74-.723q-1.016 0-1.74.724a2.37 2.37 0 0 0-.723 1.74q0 1.015.723 1.74a2.37 2.37 0 0 0 1.74.723"
        })
    }));
var $970eb8b4416ff122$export$2e2bcd8739ae039 = $970eb8b4416ff122$var$SvgUser;

});

parcelRegister("2nIQC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cddc8603c585a58c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $9H7St = parcelRequire("9H7St");

var $f18bP = parcelRequire("f18bP");

var $3Uk2n = parcelRequire("3Uk2n");

var $6Fwsu = parcelRequire("6Fwsu");
const $cddc8603c585a58c$var$strengthBarPropsByLocale = {
    "nb-NO": {
        scoreWords: [
            "veldig svakt",
            "svakt",
            "ok",
            "bra",
            "sterkt"
        ],
        shortScoreWord: [
            "for kort"
        ]
    },
    "en-US": {}
};
const $cddc8603c585a58c$var$PasswordField = ({ label: label = "Nytt passord", name: name, validator: validator, hasStrengthBar: hasStrengthBar = true, locale: locale = "nb-NO" })=>{
    const strengthBarProps = $cddc8603c585a58c$var$strengthBarPropsByLocale[locale];
    const { formValues: formValues } = (0, $dvPqk.useContext)((0, $f18bP.FormContext));
    const passwordValue = formValues ? formValues[name]?.value : "";
    const allValidators = (value)=>{
        const validatedPassword = (0, $3Uk2n.validatePassword)(value);
        if (validatedPassword.length > 0) return validatedPassword;
        if (validator) return validator(value);
        return "";
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "pb-2",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6Fwsu.default), {
                name: name,
                type: "password",
                label: label,
                initialValue: "",
                validator: allValidators,
                required: true
            }),
            hasStrengthBar && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "pt-1",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9H7St))), {
                    ...strengthBarProps,
                    password: passwordValue,
                    minLength: 8
                })
            })
        ]
    });
};
var $cddc8603c585a58c$export$2e2bcd8739ae039 = $cddc8603c585a58c$var$PasswordField;

});
parcelRegister("9H7St", function(module, exports) {
"use strict";
function $70ee3d84ec5f3050$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $dvPqk = parcelRequire("dvPqk");
var $70ee3d84ec5f3050$var$React__default = $70ee3d84ec5f3050$var$_interopDefault($dvPqk), $70ee3d84ec5f3050$var$extendStatics = function(e, a) {
    return ($70ee3d84ec5f3050$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, a) {
        e.__proto__ = a;
    } || function(e, a) {
        for(var i in a)a.hasOwnProperty(i) && (e[i] = a[i]);
    })(e, a);
};
function $70ee3d84ec5f3050$var$__extends(e, a) {
    function i() {
        this.constructor = e;
    }
    $70ee3d84ec5f3050$var$extendStatics(e, a), e.prototype = null === a ? Object.create(a) : (i.prototype = a.prototype, new i);
}
var $70ee3d84ec5f3050$var$frequency_lists, $70ee3d84ec5f3050$var$adjacency_graphs, $70ee3d84ec5f3050$var$BRUTEFORCE_CARDINALITY, $70ee3d84ec5f3050$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE, $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR, $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR, $70ee3d84ec5f3050$var$adjacency_graphs$1, $70ee3d84ec5f3050$var$calc_average_degree, $70ee3d84ec5f3050$var$k, $70ee3d84ec5f3050$var$scoring, $70ee3d84ec5f3050$var$v, $70ee3d84ec5f3050$var$__assign = function() {
    return ($70ee3d84ec5f3050$var$__assign = Object.assign || function(e) {
        for(var a, i = 1, r = arguments.length; i < r; i++)for(var n in a = arguments[i])Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
        return e;
    }).apply(this, arguments);
}, $70ee3d84ec5f3050$var$frequency_lists_1 = $70ee3d84ec5f3050$var$frequency_lists = {
    passwords: "123456,password,12345678,qwerty,123456789,12345,1234,111111,1234567,dragon,123123,baseball,abc123,football,monkey,letmein,shadow,master,696969,mustang,666666,qwertyuiop,123321,1234567890,pussy,superman,654321,1qaz2wsx,7777777,fuckyou,qazwsx,jordan,123qwe,000000,killer,trustno1,hunter,harley,zxcvbnm,asdfgh,buster,batman,soccer,tigger,charlie,sunshine,iloveyou,fuckme,ranger,hockey,computer,starwars,asshole,pepper,klaster,112233,zxcvbn,freedom,princess,maggie,pass,ginger,11111111,131313,fuck,love,cheese,159753,summer,chelsea,dallas,biteme,matrix,yankees,6969,corvette,austin,access,thunder,merlin,secret,diamond,hello,hammer,fucker,1234qwer,silver,gfhjkm,internet,samantha,golfer,scooter,test,orange,cookie,q1w2e3r4t5,maverick,sparky,phoenix,mickey,bigdog,snoopy,guitar,whatever,chicken,camaro,mercedes,peanut,ferrari,falcon,cowboy,welcome,sexy,samsung,steelers,smokey,dakota,arsenal,boomer,eagles,tigers,marina,nascar,booboo,gateway,yellow,porsche,monster,spider,diablo,hannah,bulldog,junior,london,purple,compaq,lakers,iceman,qwer1234,hardcore,cowboys,money,banana,ncc1701,boston,tennis,q1w2e3r4,coffee,scooby,123654,nikita,yamaha,mother,barney,brandy,chester,fuckoff,oliver,player,forever,rangers,midnight,chicago,bigdaddy,redsox,angel,badboy,fender,jasper,slayer,rabbit,natasha,marine,bigdick,wizard,marlboro,raiders,prince,casper,fishing,flower,jasmine,iwantu,panties,adidas,winter,winner,gandalf,password1,enter,ghbdtn,1q2w3e4r,golden,cocacola,jordan23,winston,madison,angels,panther,blowme,sexsex,bigtits,spanky,bitch,sophie,asdfasdf,horny,thx1138,toyota,tiger,dick,canada,12344321,blowjob,8675309,muffin,liverpoo,apples,qwerty123,passw0rd,abcd1234,pokemon,123abc,slipknot,qazxsw,123456a,scorpion,qwaszx,butter,startrek,rainbow,asdfghjkl,razz,newyork,redskins,gemini,cameron,qazwsxedc,florida,liverpool,turtle,sierra,viking,booger,butthead,doctor,rocket,159357,dolphins,captain,bandit,jaguar,packers,pookie,peaches,789456,asdf,dolphin,helpme,blue,theman,maxwell,qwertyui,shithead,lovers,maddog,giants,nirvana,metallic,hotdog,rosebud,mountain,warrior,stupid,elephant,suckit,success,bond007,jackass,alexis,porn,lucky,scorpio,samson,q1w2e3,azerty,rush2112,driver,freddy,1q2w3e4r5t,sydney,gators,dexter,red123,123456q,12345a,bubba,creative,voodoo,golf,trouble,america,nissan,gunner,garfield,bullshit,asdfghjk,5150,fucking,apollo,1qazxsw2,2112,eminem,legend,airborne,bear,beavis,apple,brooklyn,godzilla,skippy,4815162342,buddy,qwert,kitten,magic,shelby,beaver,phantom,asdasd,xavier,braves,darkness,blink182,copper,platinum,qweqwe,tomcat,01012011,girls,bigboy,102030,animal,police,online,11223344,voyager,lifehack,12qwaszx,fish,sniper,315475,trinity,blazer,heaven,lover,snowball,playboy,loveme,bubbles,hooters,cricket,willow,donkey,topgun,nintendo,saturn,destiny,pakistan,pumpkin,digital,sergey,redwings,explorer,tits,private,runner,therock,guinness,lasvegas,beatles,789456123,fire,cassie,christin,qwerty1,celtic,asdf1234,andrey,broncos,007007,babygirl,eclipse,fluffy,cartman,michigan,carolina,testing,alexande,birdie,pantera,cherry,vampire,mexico,dickhead,buffalo,genius,montana,beer,minecraft,maximus,flyers,lovely,stalker,metallica,doggie,snickers,speedy,bronco,lol123,paradise,yankee,horses,magnum,dreams,147258369,lacrosse,ou812,goober,enigma,qwertyu,scotty,pimpin,bollocks,surfer,cock,poohbear,genesis,star,asd123,qweasdzxc,racing,hello1,hawaii,eagle1,viper,poopoo,einstein,boobies,12345q,bitches,drowssap,simple,badger,alaska,action,jester,drummer,111222,spitfire,forest,maryjane,champion,diesel,svetlana,friday,hotrod,147258,chevy,lucky1,westside,security,google,badass,tester,shorty,thumper,hitman,mozart,zaq12wsx,boobs,reddog,010203,lizard,a123456,123456789a,ruslan,eagle,1232323q,scarface,qwerty12,147852,a12345,buddha,porno,420420,spirit,money1,stargate,qwe123,naruto,mercury,liberty,12345qwert,semperfi,suzuki,popcorn,spooky,marley,scotland,kitty,cherokee,vikings,simpsons,rascal,qweasd,hummer,loveyou,michael1,patches,russia,jupiter,penguin,passion,cumshot,vfhbyf,honda,vladimir,sandman,passport,raider,bastard,123789,infinity,assman,bulldogs,fantasy,sucker,1234554321,horney,domino,budlight,disney,ironman,usuckballz1,softball,brutus,redrum,bigred,mnbvcxz,fktrcfylh,karina,marines,digger,kawasaki,cougar,fireman,oksana,monday,cunt,justice,nigger,super,wildcats,tinker,logitech,dancer,swordfis,avalon,everton,alexandr,motorola,patriots,hentai,madonna,pussy1,ducati,colorado,connor,juventus,galore,smooth,freeuser,warcraft,boogie,titanic,wolverin,elizabet,arizona,valentin,saints,asdfg,accord,test123,password123,christ,yfnfif,stinky,slut,spiderma,naughty,chopper,hello123,ncc1701d,extreme,skyline,poop,zombie,pearljam,123qweasd,froggy,awesome,vision,pirate,fylhtq,dreamer,bullet,predator,empire,123123a,kirill,charlie1,panthers,penis,skipper,nemesis,rasdzv3,peekaboo,rolltide,cardinal,psycho,danger,mookie,happy1,wanker,chevelle,manutd,goblue,9379992,hobbes,vegeta,fyfcnfcbz,852456,picard,159951,windows,loverboy,victory,vfrcbv,bambam,serega,123654789,turkey,tweety,galina,hiphop,rooster,changeme,berlin,taurus,suckme,polina,electric,avatar,134679,maksim,raptor,alpha1,hendrix,newport,bigcock,brazil,spring,a1b2c3,madmax,alpha,britney,sublime,darkside,bigman,wolfpack,classic,hercules,ronaldo,letmein1,1q2w3e,741852963,spiderman,blizzard,123456789q,cheyenne,cjkysirj,tiger1,wombat,bubba1,pandora,zxc123,holiday,wildcat,devils,horse,alabama,147852369,caesar,12312,buddy1,bondage,pussycat,pickle,shaggy,catch22,leather,chronic,a1b2c3d4,admin,qqq111,qaz123,airplane,kodiak,freepass,billybob,sunset,katana,phpbb,chocolat,snowman,angel1,stingray,firebird,wolves,zeppelin,detroit,pontiac,gundam,panzer,vagina,outlaw,redhead,tarheels,greenday,nastya,01011980,hardon,engineer,dragon1,hellfire,serenity,cobra,fireball,lickme,darkstar,1029384756,01011,mustang1,flash,124578,strike,beauty,pavilion,01012000,bobafett,dbrnjhbz,bigmac,bowling,chris1,ytrewq,natali,pyramid,rulez,welcome1,dodgers,apache,swimming,whynot,teens,trooper,fuckit,defender,precious,135790,packard,weasel,popeye,lucifer,cancer,icecream,142536,raven,swordfish,presario,viktor,rockstar,blonde,james1,wutang,spike,pimp,atlanta,airforce,thailand,casino,lennon,mouse,741852,hacker,bluebird,hawkeye,456123,theone,catfish,sailor,goldfish,nfnmzyf,tattoo,pervert,barbie,maxima,nipples,machine,trucks,wrangler,rocks,tornado,lights,cadillac,bubble,pegasus,madman,longhorn,browns,target,666999,eatme,qazwsx123,microsoft,dilbert,christia,baller,lesbian,shooter,xfiles,seattle,qazqaz,cthutq,amateur,prelude,corona,freaky,malibu,123qweasdzxc,assassin,246810,atlantis,integra,pussies,iloveu,lonewolf,dragons,monkey1,unicorn,software,bobcat,stealth,peewee,openup,753951,srinivas,zaqwsx,valentina,shotgun,trigger,veronika,bruins,coyote,babydoll,joker,dollar,lestat,rocky1,hottie,random,butterfly,wordpass,smiley,sweety,snake,chipper,woody,samurai,devildog,gizmo,maddie,soso123aljg,mistress,freedom1,flipper,express,hjvfirf,moose,cessna,piglet,polaris,teacher,montreal,cookies,wolfgang,scully,fatboy,wicked,balls,tickle,bunny,dfvgbh,foobar,transam,pepsi,fetish,oicu812,basketba,toshiba,hotstuff,sunday,booty,gambit,31415926,impala,stephani,jessica1,hooker,lancer,knicks,shamrock,fuckyou2,stinger,314159,redneck,deftones,squirt,siemens,blaster,trucker,subaru,renegade,ibanez,manson,swinger,reaper,blondie,mylove,galaxy,blahblah,enterpri,travel,1234abcd,babylon5,indiana,skeeter,master1,sugar,ficken,smoke,bigone,sweetpea,fucked,trfnthbyf,marino,escort,smitty,bigfoot,babes,larisa,trumpet,spartan,valera,babylon,asdfghj,yankees1,bigboobs,stormy,mister,hamlet,aardvark,butterfl,marathon,paladin,cavalier,manchester,skater,indigo,hornet,buckeyes,01011990,indians,karate,hesoyam,toronto,diamonds,chiefs,buckeye,1qaz2wsx3edc,highland,hotsex,charger,redman,passwor,maiden,drpepper,storm,pornstar,garden,12345678910,pencil,sherlock,timber,thuglife,insane,pizza,jungle,jesus1,aragorn,1a2b3c,hamster,david1,triumph,techno,lollol,pioneer,catdog,321654,fktrctq,morpheus,141627,pascal,shadow1,hobbit,wetpussy,erotic,consumer,blabla,justme,stones,chrissy,spartak,goforit,burger,pitbull,adgjmptw,italia,barcelona,hunting,colors,kissme,virgin,overlord,pebbles,sundance,emerald,doggy,racecar,irina,element,1478963,zipper,alpine,basket,goddess,poison,nipple,sakura,chichi,huskers,13579,pussys,q12345,ultimate,ncc1701e,blackie,nicola,rommel,matthew1,caserta,omega,geronimo,sammy1,trojan,123qwe123,philips,nugget,tarzan,chicks,aleksandr,bassman,trixie,portugal,anakin,dodger,bomber,superfly,madness,q1w2e3r4t5y6,loser,123asd,fatcat,ybrbnf,soldier,warlock,wrinkle1,desire,sexual,babe,seminole,alejandr,951753,11235813,westham,andrei,concrete,access14,weed,letmein2,ladybug,naked,christop,trombone,tintin,bluesky,rhbcnbyf,qazxswedc,onelove,cdtnkfyf,whore,vfvjxrf,titans,stallion,truck,hansolo,blue22,smiles,beagle,panama,kingkong,flatron,inferno,mongoose,connect,poiuyt,snatch,qawsed,juice,blessed,rocker,snakes,turbo,bluemoon,sex4me,finger,jamaica,a1234567,mulder,beetle,fuckyou1,passat,immortal,plastic,123454321,anthony1,whiskey,dietcoke,suck,spunky,magic1,monitor,cactus,exigen,planet,ripper,teen,spyder,apple1,nolimit,hollywoo,sluts,sticky,trunks,1234321,14789632,pickles,sailing,bonehead,ghbdtnbr,delta,charlott,rubber,911911,112358,molly1,yomama,hongkong,jumper,william1,ilovesex,faster,unreal,cumming,memphis,1123581321,nylons,legion,sebastia,shalom,pentium,geheim,werewolf,funtime,ferret,orion,curious,555666,niners,cantona,sprite,philly,pirates,abgrtyu,lollipop,eternity,boeing,super123,sweets,cooldude,tottenha,green1,jackoff,stocking,7895123,moomoo,martini,biscuit,drizzt,colt45,fossil,makaveli,snapper,satan666,maniac,salmon,patriot,verbatim,nasty,shasta,asdzxc,shaved,blackcat,raistlin,qwerty12345,punkrock,cjkywt,01012010,4128,waterloo,crimson,twister,oxford,musicman,seinfeld,biggie,condor,ravens,megadeth,wolfman,cosmos,sharks,banshee,keeper,foxtrot,gn56gn56,skywalke,velvet,black1,sesame,dogs,squirrel,privet,sunrise,wolverine,sucks,legolas,grendel,ghost,cats,carrot,frosty,lvbnhbq,blades,stardust,frog,qazwsxed,121314,coolio,brownie,groovy,twilight,daytona,vanhalen,pikachu,peanuts,licker,hershey,jericho,intrepid,ninja,1234567a,zaq123,lobster,goblin,punisher,strider,shogun,kansas,amadeus,seven7,jason1,neptune,showtime,muscle,oldman,ekaterina,rfrfirf,getsome,showme,111222333,obiwan,skittles,danni,tanker,maestro,tarheel,anubis,hannibal,anal,newlife,gothic,shark,fighter,blue123,blues,123456z,princes,slick,chaos,thunder1,sabine,1q2w3e4r5t6y,python,test1,mirage,devil,clover,tequila,chelsea1,surfing,delete,potato,chubby,panasonic,sandiego,portland,baggins,fusion,sooners,blackdog,buttons,californ,moscow,playtime,mature,1a2b3c4d,dagger,dima,stimpy,asdf123,gangster,warriors,iverson,chargers,byteme,swallow,liquid,lucky7,dingdong,nymets,cracker,mushroom,456852,crusader,bigguy,miami,dkflbvbh,bugger,nimrod,tazman,stranger,newpass,doodle,powder,gotcha,guardian,dublin,slapshot,septembe,147896325,pepsi1,milano,grizzly,woody1,knights,photos,2468,nookie,charly,rammstein,brasil,123321123,scruffy,munchkin,poopie,123098,kittycat,latino,walnut,1701,thegame,viper1,1passwor,kolobok,picasso,robert1,barcelon,bananas,trance,auburn,coltrane,eatshit,goodluck,starcraft,wheels,parrot,postal,blade,wisdom,pink,gorilla,katerina,pass123,andrew1,shaney14,dumbass,osiris,fuck_inside,oakland,discover,ranger1,spanking,lonestar,bingo,meridian,ping,heather1,dookie,stonecol,megaman,192837465,rjntyjr,ledzep,lowrider,25802580,richard1,firefly,griffey,racerx,paradox,ghjcnj,gangsta,zaq1xsw2,tacobell,weezer,sirius,halflife,buffett,shiloh,123698745,vertigo,sergei,aliens,sobaka,keyboard,kangaroo,sinner,soccer1,0.0.000,bonjour,socrates,chucky,hotboy,sprint,0007,sarah1,scarlet,celica,shazam,formula1,sommer,trebor,qwerasdf,jeep,mailcreated5240,bollox,asshole1,fuckface,honda1,rebels,vacation,lexmark,penguins,12369874,ragnarok,formula,258456,tempest,vfhecz,tacoma,qwertz,colombia,flames,rockon,duck,prodigy,wookie,dodgeram,mustangs,123qaz,sithlord,smoker,server,bang,incubus,scoobydo,oblivion,molson,kitkat,titleist,rescue,zxcv1234,carpet,1122,bigballs,tardis,jimbob,xanadu,blueeyes,shaman,mersedes,pooper,pussy69,golfing,hearts,mallard,12312312,kenwood,patrick1,dogg,cowboys1,oracle,123zxc,nuttertools,102938,topper,1122334455,shemale,sleepy,gremlin,yourmom,123987,gateway1,printer,monkeys,peterpan,mikey,kingston,cooler,analsex,jimbo,pa55word,asterix,freckles,birdman,frank1,defiant,aussie,stud,blondes,tatyana,445566,aspirine,mariners,jackal,deadhead,katrin,anime,rootbeer,frogger,polo,scooter1,hallo,noodles,thomas1,parola,shaolin,celine,11112222,plymouth,creampie,justdoit,ohyeah,fatass,assfuck,amazon,1234567q,kisses,magnus,camel,nopass,bosco,987456,6751520,harley1,putter,champs,massive,spidey,lightnin,camelot,letsgo,gizmodo,aezakmi,bones,caliente,12121,goodtime,thankyou,raiders1,brucelee,redalert,aquarius,456654,catherin,smokin,pooh,mypass,astros,roller,porkchop,sapphire,qwert123,kevin1,a1s2d3f4,beckham,atomic,rusty1,vanilla,qazwsxedcrfv,hunter1,kaktus,cxfcnmt,blacky,753159,elvis1,aggies,blackjac,bangkok,scream,123321q,iforgot,power1,kasper,abc12,buster1,slappy,shitty,veritas,chevrole,amber1,01012001,vader,amsterdam,jammer,primus,spectrum,eduard,granny,horny1,sasha1,clancy,usa123,satan,diamond1,hitler,avenger,1221,spankme,123456qwerty,simba,smudge,scrappy,labrador,john316,syracuse,front242,falcons,husker,candyman,commando,gator,pacman,delta1,pancho,krishna,fatman,clitoris,pineappl,lesbians,8j4ye3uz,barkley,vulcan,punkin,boner,celtics,monopoly,flyboy,romashka,hamburg,123456aa,lick,gangbang,223344,area51,spartans,aaa111,tricky,snuggles,drago,homerun,vectra,homer1,hermes,topcat,cuddles,infiniti,1234567890q,cosworth,goose,phoenix1,killer1,ivanov,bossman,qawsedrf,peugeot,exigent,doberman,durango,brandon1,plumber,telefon,horndog,laguna,rbhbkk,dawg,webmaster,breeze,beast,porsche9,beefcake,leopard,redbull,oscar1,topdog,godsmack,theking,pics,omega1,speaker,viktoria,fuckers,bowler,starbuck,gjkbyf,valhalla,anarchy,blacks,herbie,kingpin,starfish,nokia,loveit,achilles,906090,labtec,ncc1701a,fitness,jordan1,brando,arsenal1,bull,kicker,napass,desert,sailboat,bohica,tractor,hidden,muppet,jackson1,jimmy1,terminator,phillies,pa55w0rd,terror,farside,swingers,legacy,frontier,butthole,doughboy,jrcfyf,tuesday,sabbath,daniel1,nebraska,homers,qwertyuio,azamat,fallen,agent007,striker,camels,iguana,looker,pinkfloy,moloko,qwerty123456,dannyboy,luckydog,789654,pistol,whocares,charmed,skiing,select,franky,puppy,daniil,vladik,vette,vfrcbvrf,ihateyou,nevada,moneys,vkontakte,mandingo,puppies,666777,mystic,zidane,kotenok,dilligaf,budman,bunghole,zvezda,123457,triton,golfball,technics,trojans,panda,laptop,rookie,01011991,15426378,aberdeen,gustav,jethro,enterprise,igor,stripper,filter,hurrican,rfnthbyf,lespaul,gizmo1,butch,132435,dthjybrf,1366613,excalibu,963852,nofear,momoney,possum,cutter,oilers,moocow,cupcake,gbpltw,batman1,splash,svetik,super1,soleil,bogdan,melissa1,vipers,babyboy,tdutybq,lancelot,ccbill,keystone,passwort,flamingo,firefox,dogman,vortex,rebel,noodle,raven1,zaphod,killme,pokemon1,coolman,danila,designer,skinny,kamikaze,deadman,gopher,doobie,warhammer,deeznuts,freaks,engage,chevy1,steve1,apollo13,poncho,hammers,azsxdc,dracula,000007,sassy,bitch1,boots,deskjet,12332,macdaddy,mighty,rangers1,manchest,sterlin,casey1,meatball,mailman,sinatra,cthulhu,summer1,bubbas,cartoon,bicycle,eatpussy,truelove,sentinel,tolkien,breast,capone,lickit,summit,123456k,peter1,daisy1,kitty1,123456789z,crazy1,jamesbon,texas1,sexygirl,362436,sonic,billyboy,redhot,microsof,microlab,daddy1,rockets,iloveyo,fernand,gordon24,danie,cutlass,polska,star69,titties,pantyhos,01011985,thekid,aikido,gofish,mayday,1234qwe,coke,anfield,sony,lansing,smut,scotch,sexx,catman,73501505,hustler,saun,dfkthbz,passwor1,jenny1,azsxdcfv,cheers,irish1,gabrie,tinman,orioles,1225,charlton,fortuna,01011970,airbus,rustam,xtreme,bigmoney,zxcasd,retard,grumpy,huskies,boxing,4runner,kelly1,ultima,warlord,fordf150,oranges,rotten,asdfjkl,superstar,denali,sultan,bikini,saratoga,thor,figaro,sixers,wildfire,vladislav,128500,sparta,mayhem,greenbay,chewie,music1,number1,cancun,fabie,mellon,poiuytrewq,cloud9,crunch,bigtime,chicken1,piccolo,bigbird,321654987,billy1,mojo,01011981,maradona,sandro,chester1,bizkit,rjirfrgbde,789123,rightnow,jasmine1,hyperion,treasure,meatloaf,armani,rovers,jarhead,01011986,cruise,coconut,dragoon,utopia,davids,cosmo,rfhbyf,reebok,1066,charli,giorgi,sticks,sayang,pass1234,exodus,anaconda,zaqxsw,illini,woofwoof,emily1,sandy1,packer,poontang,govols,jedi,tomato,beaner,cooter,creamy,lionking,happy123,albatros,poodle,kenworth,dinosaur,greens,goku,happyday,eeyore,tsunami,cabbage,holyshit,turkey50,memorex,chaser,bogart,orgasm,tommy1,volley,whisper,knopka,ericsson,walleye,321123,pepper1,katie1,chickens,tyler1,corrado,twisted,100000,zorro,clemson,zxcasdqwe,tootsie,milana,zenith,fktrcfylhf,shania,frisco,polniypizdec0211,crazybab,junebug,fugazi,rereirf,vfvekz,1001,sausage,vfczyz,koshka,clapton,justin1,anhyeuem,condom,fubar,hardrock,skywalker,tundra,cocks,gringo,150781,canon,vitalik,aspire,stocks,samsung1,applepie,abc12345,arjay,gandalf1,boob,pillow,sparkle,gmoney,rockhard,lucky13,samiam,everest,hellyeah,bigsexy,skorpion,rfrnec,hedgehog,australi,candle,slacker,dicks,voyeur,jazzman,america1,bobby1,br0d3r,wolfie,vfksirf,1qa2ws3ed,13243546,fright,yosemite,temp,karolina,fart,barsik,surf,cheetah,baddog,deniska,starship,bootie,milena,hithere,kume,greatone,dildo,50cent,0.0.0.000,albion,amanda1,midget,lion,maxell,football1,cyclone,freeporn,nikola,bonsai,kenshin,slider,balloon,roadkill,killbill,222333,jerkoff,78945612,dinamo,tekken,rambler,goliath,cinnamon,malaka,backdoor,fiesta,packers1,rastaman,fletch,sojdlg123aljg,stefano,artemis,calico,nyjets,damnit,robotech,duchess,rctybz,hooter,keywest,18436572,hal9000,mechanic,pingpong,operator,presto,sword,rasputin,spank,bristol,faggot,shado,963852741,amsterda,321456,wibble,carrera,alibaba,majestic,ramses,duster,route66,trident,clipper,steeler,wrestlin,divine,kipper,gotohell,kingfish,snake1,passwords,buttman,pompey,viagra,zxcvbnm1,spurs,332211,slutty,lineage2,oleg,macross,pooter,brian1,qwert1,charles1,slave,jokers,yzerman,swimmer,ne1469,nwo4life,solnce,seamus,lolipop,pupsik,moose1,ivanova,secret1,matador,love69,420247,ktyjxrf,subway,cinder,vermont,pussie,chico,florian,magick,guiness,allsop,ghetto,flash1,a123456789,typhoon,dfkthf,depeche,skydive,dammit,seeker,fuckthis,crysis,kcj9wx5n,umbrella,r2d2c3po,123123q,snoopdog,critter,theboss,ding,162534,splinter,kinky,cyclops,jayhawk,456321,caramel,qwer123,underdog,caveman,onlyme,grapes,feather,hotshot,fuckher,renault,george1,sex123,pippen,000001,789987,floppy,cunts,megapass,1000,pornos,usmc,kickass,great1,quattro,135246,wassup,helloo,p0015123,nicole1,chivas,shannon1,bullseye,java,fishes,blackhaw,jamesbond,tunafish,juggalo,dkflbckfd,123789456,dallas1,translator,122333,beanie,alucard,gfhjkm123,supersta,magicman,ashley1,cohiba,xbox360,caligula,12131415,facial,7753191,dfktynbyf,cobra1,cigars,fang,klingon,bob123,safari,looser,10203,deepthroat,malina,200000,tazmania,gonzo,goalie,jacob1,monaco,cruiser,misfit,vh5150,tommyboy,marino13,yousuck,sharky,vfhufhbnf,horizon,absolut,brighton,123456r,death1,kungfu,maxx,forfun,mamapapa,enter1,budweise,banker,getmoney,kostya,qazwsx12,bigbear,vector,fallout,nudist,gunners,royals,chainsaw,scania,trader,blueboy,walrus,eastside,kahuna,qwerty1234,love123,steph,01011989,cypress,champ,undertaker,ybrjkfq,europa,snowboar,sabres,moneyman,chrisbln,minime,nipper,groucho,whitey,viewsonic,penthous,wolf359,fabric,flounder,coolguy,whitesox,passme,smegma,skidoo,thanatos,fucku2,snapple,dalejr,mondeo,thesims,mybaby,panasoni,sinbad,thecat,topher,frodo,sneakers,q123456,z1x2c3,alfa,chicago1,taylor1,ghjcnjnfr,cat123,olivier,cyber,titanium,0420,madison1,jabroni,dang,hambone,intruder,holly1,gargoyle,sadie1,static,poseidon,studly,newcastl,sexxxx,poppy,johannes,danzig,beastie,musica,buckshot,sunnyday,adonis,bluedog,bonkers,2128506,chrono,compute,spawn,01011988,turbo1,smelly,wapbbs,goldstar,ferrari1,778899,quantum,pisces,boomboom,gunnar,1024,test1234,florida1,nike,superman1,multiplelo,custom,motherlode,1qwerty,westwood,usnavy,apple123,daewoo,korn,stereo,sasuke,sunflowe,watcher,dharma,555777,mouse1,assholes,babyblue,123qwerty,marius,walmart,snoop,starfire,tigger1,paintbal,knickers,aaliyah,lokomotiv,theend,winston1,sapper,rover,erotica,scanner,racer,zeus,sexy69,doogie,bayern,joshua1,newbie,scott1,losers,droopy,outkast,martin1,dodge1,wasser,ufkbyf,rjycnfynby,thirteen,12345z,112211,hotred,deejay,hotpussy,192837,jessic,philippe,scout,panther1,cubbies,havefun,magpie,fghtkm,avalanch,newyork1,pudding,leonid,harry1,cbr600,audia4,bimmer,fucku,01011984,idontknow,vfvfgfgf,1357,aleksey,builder,01011987,zerocool,godfather,mylife,donuts,allmine,redfish,777888,sascha,nitram,bounce,333666,smokes,1x2zkg8w,rodman,stunner,zxasqw12,hoosier,hairy,beretta,insert,123456s,rtyuehe,francesc,tights,cheese1,micron,quartz,hockey1,gegcbr,searay,jewels,bogey,paintball,celeron,padres,bing,syncmaster,ziggy,simon1,beaches,prissy,diehard,orange1,mittens,aleksandra,queens,02071986,biggles,thongs,southpark,artur,twinkle,gretzky,rabota,cambiami,monalisa,gollum,chuckles,spike1,gladiator,whisky,spongebob,sexy1,03082006,mazafaka,meathead,4121,ou8122,barefoot,12345678q,cfitymrf,bigass,a1s2d3,kosmos,blessing,titty,clevelan,terrapin,ginger1,johnboy,maggot,clarinet,deeznutz,336699,stumpy,stoney,footbal,traveler,volvo,bucket,snapon,pianoman,hawkeyes,futbol,casanova,tango,goodboy,scuba,honey1,sexyman,warthog,mustard,abc1234,nickel,10203040,meowmeow,1012,boricua,prophet,sauron,12qwas,reefer,andromeda,crystal1,joker1,90210,goofy,loco,lovesex,triangle,whatsup,mellow,bengals,monster1,maste,01011910,lover1,love1,123aaa,sunshin,smeghead,hokies,sting,welder,rambo,cerberus,bunny1,rockford,monke,1q2w3e4r5,goldwing,gabriell,buzzard,crjhgbjy,james007,rainman,groove,tiberius,purdue,nokia6300,hayabusa,shou,jagger,diver,zigzag,poochie,usarmy,phish,redwood,redwing,12345679,salamander,silver1,abcd123,sputnik,boobie,ripple,eternal,12qw34er,thegreat,allstar,slinky,gesperrt,mishka,whiskers,pinhead,overkill,sweet1,rhfcjnrf,montgom240,sersolution,jamie1,starman,proxy,swords,nikolay,bacardi,rasta,badgirl,rebecca1,wildman,penny1,spaceman,1007,10101,logan1,hacked,bulldog1,helmet,windsor,buffy1,runescape,trapper,123451,banane,dbrnjh,ripken,12345qwe,frisky,shun,fester,oasis,lightning,ib6ub9,cicero,kool,pony,thedog,784512,01011992,megatron,illusion,edward1,napster,11223,squash,roadking,woohoo,19411945,hoosiers,01091989,tracker,bagira,midway,leavemealone,br549,14725836,235689,menace,rachel1,feng,laser,stoned,realmadrid,787898,balloons,tinkerbell,5551212,maria1,pobeda,heineken,sonics,moonlight,optimus,comet,orchid,02071982,jaybird,kashmir,12345678a,chuang,chunky,peach,mortgage,rulezzz,saleen,chuckie,zippy,fishing1,gsxr750,doghouse,maxim,reader,shai,buddah,benfica,chou,salomon,meister,eraser,blackbir,bigmike,starter,pissing,angus,deluxe,eagles1,hardcock,135792468,mian,seahawks,godfathe,bookworm,gregor,intel,talisman,blackjack,babyface,hawaiian,dogfood,zhong,01011975,sancho,ludmila,medusa,mortimer,123456654321,roadrunn,just4me,stalin,01011993,handyman,alphabet,pizzas,calgary,clouds,password2,cgfhnfr,f**k,cubswin,gong,lexus,max123,xxx123,digital1,gfhjkm1,7779311,missy1,michae,beautifu,gator1,1005,pacers,buddie,chinook,heckfy,dutchess,sally1,breasts,beowulf,darkman,jenn,tiffany1,zhei,quan,qazwsx1,satana,shang,idontkno,smiths,puddin,nasty1,teddybea,valkyrie,passwd,chao,boxster,killers,yoda,cheater,inuyasha,beast1,wareagle,foryou,dragonball,mermaid,bhbirf,teddy1,dolphin1,misty1,delphi,gromit,sponge,qazzaq,fytxrf,gameover,diao,sergi,beamer,beemer,kittykat,rancid,manowar,adam12,diggler,assword,austin1,wishbone,gonavy,sparky1,fisting,thedude,sinister,1213,venera,novell,salsero,jayden,fuckoff1,linda1,vedder,02021987,1pussy,redline,lust,jktymrf,02011985,dfcbkbq,dragon12,chrome,gamecube,titten,cong,bella1,leng,02081988,eureka,bitchass,147369,banner,lakota,123321a,mustafa,preacher,hotbox,02041986,z1x2c3v4,playstation,01011977,claymore,electra,checkers,zheng,qing,armagedon,02051986,wrestle,svoboda,bulls,nimbus,alenka,madina,newpass6,onetime,aa123456,bartman,02091987,silverad,electron,12345t,devil666,oliver1,skylar,rhtdtlrj,gobucks,johann,12011987,milkman,02101985,camper,thunderb,bigbutt,jammin,davide,cheeks,goaway,lighter,claudi,thumbs,pissoff,ghostrider,cocaine,teng,squall,lotus,hootie,blackout,doitnow,subzero,02031986,marine1,02021988,pothead,123456qw,skate,1369,peng,antoni,neng,miao,bcfields,1492,marika,794613,musashi,tulips,nong,piao,chai,ruan,southpar,02061985,nude,mandarin,654123,ninjas,cannabis,jetski,xerxes,zhuang,kleopatra,dickie,bilbo,pinky,morgan1,1020,1017,dieter,baseball1,tottenham,quest,yfnfkmz,dirtbike,1234567890a,mango,jackson5,ipswich,iamgod,02011987,tdutybz,modena,qiao,slippery,qweasd123,bluefish,samtron,toon,111333,iscool,02091986,petrov,fuzzy,zhou,1357924680,mollydog,deng,02021986,1236987,pheonix,zhun,ghblehjr,othello,starcraf,000111,sanfran,a11111,cameltoe,badman,vasilisa,jiang,1qaz2ws,luan,sveta,12qw12,akira,chuai,369963,cheech,beatle,pickup,paloma,01011983,caravan,elizaveta,gawker,banzai,pussey,mullet,seng,bingo1,bearcat,flexible,farscape,borussia,zhuai,templar,guitar1,toolman,yfcntymrf,chloe1,xiang,slave1,guai,nuggets,02081984,mantis,slim,scorpio1,fyutkbyf,thedoors,02081987,02061986,123qq123,zappa,fergie,7ugd5hip2j,huai,asdfzxcv,sunflower,pussyman,deadpool,bigtit,01011982,love12,lassie,skyler,gatorade,carpedie,jockey,mancity,spectre,02021984,cameron1,artemka,reng,02031984,iomega,jing,moritz,spice,rhino,spinner,heater,zhai,hover,talon,grease,qiong,corleone,ltybcrf,tian,cowboy1,hippie,chimera,ting,alex123,02021985,mickey1,corsair,sonoma,aaron1,xxxpass,bacchus,webmaste,chuo,xyz123,chrysler,spurs1,artem,shei,cosmic,01020304,deutsch,gabriel1,123455,oceans,987456321,binladen,latinas,a12345678,speedo,buttercu,02081989,21031988,merlot,millwall,ceng,kotaku,jiong,dragonba,2580,stonecold,snuffy,01011999,02011986,hellos,blaze,maggie1,slapper,istanbul,bonjovi,babylove,mazda,bullfrog,phoeni,meng,porsche1,nomore,02061989,bobdylan,capslock,orion1,zaraza,teddybear,ntktajy,myname,rong,wraith,mets,niao,02041984,smokie,chevrolet,dialog,gfhjkmgfhjkm,dotcom,vadim,monarch,athlon,mikey1,hamish,pian,liang,coolness,chui,thoma,ramones,ciccio,chippy,eddie1,house1,ning,marker,cougars,jackpot,barbados,reds,pdtplf,knockers,cobalt,amateurs,dipshit,napoli,kilroy,pulsar,jayhawks,daemon,alexey,weng,shuang,9293709b13,shiner,eldorado,soulmate,mclaren,golfer1,andromed,duan,50spanks,sexyboy,dogshit,02021983,shuo,kakashka,syzygy,111111a,yeahbaby,qiang,netscape,fulham,120676,gooner,zhui,rainbow6,laurent,dog123,halifax,freeway,carlitos,147963,eastwood,microphone,monkey12,1123,persik,coldbeer,geng,nuan,danny1,fgtkmcby,entropy,gadget,just4fun,sophi,baggio,carlito,1234567891,02021989,02041983,specialk,piramida,suan,bigblue,salasana,hopeful,mephisto,bailey1,hack,annie1,generic,violetta,spencer1,arcadia,02051983,hondas,9562876,trainer,jones1,smashing,liao,159632,iceberg,rebel1,snooker,temp123,zang,matteo,fastball,q2w3e4r5,bamboo,fuckyo,shutup,astro,buddyboy,nikitos,redbird,maxxxx,shitface,02031987,kuai,kissmyass,sahara,radiohea,1234asdf,wildcard,maxwell1,patric,plasma,heynow,bruno1,shao,bigfish,misfits,sassy1,sheng,02011988,02081986,testpass,nanook,cygnus,licking,slavik,pringles,xing,1022,ninja1,submit,dundee,tiburon,pinkfloyd,yummy,shuai,guang,chopin,obelix,insomnia,stroker,1a2s3d4f,1223,playboy1,lazarus,jorda,spider1,homerj,sleeper,02041982,darklord,cang,02041988,02041987,tripod,magician,jelly,telephon,15975,vsjasnel12,pasword,iverson3,pavlov,homeboy,gamecock,amigo,brodie,budapest,yjdsqgfhjkm,reckless,02011980,pang,tiger123,2469,mason1,orient,01011979,zong,cdtnbr,maksimka,1011,bushido,taxman,giorgio,sphinx,kazantip,02101984,concorde,verizon,lovebug,georg,sam123,seadoo,qazwsxedc123,jiao,jezebel,pharmacy,abnormal,jellybea,maxime,puffy,islander,bunnies,jiggaman,drakon,010180,pluto,zhjckfd,12365,classics,crusher,mordor,hooligan,strawberry,02081985,scrabble,hawaii50,1224,wg8e3wjf,cthtuf,premium,arrow,123456qwe,mazda626,ramrod,tootie,rhjrjlbk,ghost1,1211,bounty,niang,02071984,goat,killer12,sweetnes,porno1,masamune,426hemi,corolla,mariposa,hjccbz,doomsday,bummer,blue12,zhao,bird33,excalibur,samsun,kirsty,buttfuck,kfhbcf,zhuo,marcello,ozzy,02021982,dynamite,655321,master12,123465,lollypop,stepan,1qa2ws,spiker,goirish,callum,michael2,moonbeam,attila,henry1,lindros,andrea1,sporty,lantern,12365478,nextel,violin,volcom,998877,water1,imation,inspiron,dynamo,citadel,placebo,clowns,tiao,02061988,tripper,dabears,haggis,merlin1,02031985,anthrax,amerika,iloveme,vsegda,burrito,bombers,snowboard,forsaken,katarina,a1a2a3,woofer,tigger2,fullmoon,tiger2,spock,hannah1,snoopy1,sexxxy,sausages,stanislav,cobain,robotics,exotic,green123,mobydick,senators,pumpkins,fergus,asddsa,147741,258852,windsurf,reddevil,vfitymrf,nevermind,nang,woodland,4417,mick,shui,q1q2q3,wingman,69696,superb,zuan,ganesh,pecker,zephyr,anastasiya,icu812,larry1,02081982,broker,zalupa,mihail,vfibyf,dogger,7007,paddle,varvara,schalke,1z2x3c,presiden,yankees2,tuning,poopy,02051982,concord,vanguard,stiffy,rjhjktdf,felix1,wrench,firewall,boxer,bubba69,popper,02011984,temppass,gobears,cuan,tipper,fuckme1,kamila,thong,puss,bigcat,drummer1,02031982,sowhat,digimon,tigers1,rang,jingle,bian,uranus,soprano,mandy1,dusty1,fandango,aloha,pumpkin1,postman,02061980,dogcat,bombay,pussy123,onetwo,highheel,pippo,julie1,laura1,pepito,beng,smokey1,stylus,stratus,reload,duckie,karen1,jimbo1,225588,369258,krusty,snappy,asdf12,electro,111qqq,kuang,fishin,clit,abstr,christma,qqqqq1,1234560,carnage,guyver,boxers,kittens,zeng,1000000,qwerty11,toaster,cramps,yugioh,02061987,icehouse,zxcvbnm123,pineapple,namaste,harrypotter,mygirl,falcon1,earnhard,fender1,spikes,nutmeg,01081989,dogboy,02091983,369852,softail,mypassword,prowler,bigboss,1112,harvest,heng,jubilee,killjoy,basset,keng,zaqxswcde,redsox1,biao,titan,misfit99,robot,wifey,kidrock,02101987,gameboy,enrico,1z2x3c4v,broncos1,arrows,havana,banger,cookie1,chriss,123qw,platypus,cindy1,lumber,pinball,foxy,london1,1023,05051987,02041985,password12,superma,longbow,radiohead,nigga,12051988,spongebo,qwert12345,abrakadabra,dodgers1,02101989,chillin,niceguy,pistons,hookup,santafe,bigben,jets,1013,vikings1,mankind,viktoriya,beardog,hammer1,02071980,reddwarf,magelan,longjohn,jennife,gilles,carmex2,02071987,stasik,bumper,doofus,slamdunk,pixies,garion,steffi,alessandro,beerman,niceass,warrior1,honolulu,134679852,visa,johndeer,mother1,windmill,boozer,oatmeal,aptiva,busty,delight,tasty,slick1,bergkamp,badgers,guitars,puffin,02091981,nikki1,irishman,miller1,zildjian,123000,airwolf,magnet,anai,install,02041981,02061983,astra,romans,megan1,mudvayne,freebird,muscles,dogbert,02091980,02091984,snowflak,01011900,mang,joseph1,nygiants,playstat,junior1,vjcrdf,qwer12,webhompas,giraffe,pelican,jefferso,comanche,bruiser,monkeybo,kjkszpj,123456l,micro,albany,02051987,angel123,epsilon,aladin,death666,hounddog,josephin,altima,chilly,02071988,78945,ultra,02041979,gasman,thisisit,pavel,idunno,kimmie,05051985,paulie,ballin,medion,moondog,manolo,pallmall,climber,fishbone,genesis1,153624,toffee,tbone,clippers,krypton,jerry1,picturs,compass,111111q,02051988,1121,02081977,sairam,getout,333777,cobras,22041987,bigblock,severin,booster,norwich,whiteout,ctrhtn,123456m,02061984,hewlett,shocker,fuckinside,02031981,chase1,white1,versace,123456789s,basebal,iloveyou2,bluebell,08031986,anthon,stubby,foreve,undertak,werder,saiyan,mama123,medic,chipmunk,mike123,mazdarx7,qwe123qwe,bowwow,kjrjvjnbd,celeb,choochoo,demo,lovelife,02051984,colnago,lithium,02051989,15051981,zzzxxx,welcom,anastasi,fidelio,franc,26061987,roadster,stone55,drifter,hookem,hellboy,1234qw,cbr900rr,sinned,good123654,storm1,gypsy,zebra,zachary1,toejam,buceta,02021979,testing1,redfox,lineage,mike1,highbury,koroleva,nathan1,washingt,02061982,02091985,vintage,redbaron,dalshe,mykids,11051987,macbeth,julien,james123,krasotka,111000,10011986,987123,pipeline,tatarin,sensei,codered,komodo,frogman,7894561230,nascar24,juicy,01031988,redrose,mydick,pigeon,tkbpfdtnf,smirnoff,1215,spam,winner1,flyfish,moskva,81fukkc,21031987,olesya,starligh,summer99,13041988,fishhead,freesex,super12,06061986,azazel,scoobydoo,02021981,cabron,yogibear,sheba1,konstantin,tranny,chilli,terminat,ghbywtccf,slowhand,soccer12,cricket1,fuckhead,1002,seagull,achtung,blam,bigbob,bdsm,nostromo,survivor,cnfybckfd,lemonade,boomer1,rainbow1,rober,irinka,cocksuck,peaches1,itsme,sugar1,zodiac,upyours,dinara,135791,sunny1,chiara,johnson1,02041989,solitude,habibi,sushi,markiz,smoke1,rockies,catwoman,johnny1,qwerty7,bearcats,username,01011978,wanderer,ohshit,02101986,sigma,stephen1,paradigm,02011989,flanker,sanity,jsbach,spotty,bologna,fantasia,chevys,borabora,cocker,74108520,123ewq,12021988,01061990,gtnhjdbx,02071981,01011960,sundevil,3000gt,mustang6,gagging,maggi,armstron,yfnfkb,13041987,revolver,02021976,trouble1,madcat,jeremy1,jackass1,volkswag,30051985,corndog,pool6123,marines1,03041991,pizza1,piggy,sissy,02031979,sunfire,angelus,undead,24061986,14061991,wildbill,shinobi,45m2do5bs,123qwer,21011989,cleopatr,lasvega,hornets,amorcit,11081989,coventry,nirvana1,destin,sidekick,20061988,02081983,gbhfvblf,sneaky,bmw325,22021989,nfytxrf,sekret,kalina,zanzibar,hotone,qazws,wasabi,heidi1,highlander,blues1,hitachi,paolo,23041987,slayer1,simba1,02011981,tinkerbe,kieran,01121986,172839,boiler,1125,bluesman,waffle,asdfgh01,threesom,conan,1102,reflex,18011987,nautilus,everlast,fatty,vader1,01071986,cyborg,ghbdtn123,birddog,rubble,02071983,suckers,02021973,skyhawk,12qw12qw,dakota1,joebob,nokia6233,woodie,longdong,lamer,troll,ghjcnjgfhjkm,420000,boating,nitro,armada,messiah,1031,penguin1,02091989,americ,02071989,redeye,asdqwe123,07071987,monty1,goten,spikey,sonata,635241,tokiohotel,sonyericsson,citroen,compaq1,1812,umpire,belmont,jonny,pantera1,nudes,palmtree,14111986,fenway,bighead,razor,gryphon,andyod22,aaaaa1,taco,10031988,enterme,malachi,dogface,reptile,01041985,dindom,handball,marseille,candy1,19101987,torino,tigge,matthias,viewsoni,13031987,stinker,evangelion,24011985,123456123,rampage,sandrine,02081980,thecrow,astral,28041987,sprinter,private1,seabee,shibby,02101988,25081988,fearless,junkie,01091987,aramis,antelope,draven,fuck1,mazda6,eggman,02021990,barselona,buddy123,19061987,fyfnjkbq,nancy1,12121990,10071987,sluggo,kille,hotties,irishka,zxcasdqwe123,shamus,fairlane,honeybee,soccer10,13061986,fantomas,17051988,10051987,20111986,gladiato,karachi,gambler,gordo,01011995,biatch,matthe,25800852,papito,excite,buffalo1,bobdole,cheshire,player1,28021992,thewho,10101986,pinky1,mentor,tomahawk,brown1,03041986,bismillah,bigpoppa,ijrjkfl,01121988,runaway,08121986,skibum,studman,helper,squeak,holycow,manfred,harlem,glock,gideon,987321,14021985,yellow1,wizard1,margarit,success1,medved,sf49ers,lambda,pasadena,johngalt,quasar,1776,02031980,coldplay,amand,playa,bigpimp,04041991,capricorn,elefant,sweetness,bruce1,luca,dominik,10011990,biker,09051945,datsun,elcamino,trinitro,malice,audi,voyager1,02101983,joe123,carpente,spartan1,mario1,glamour,diaper,12121985,22011988,winter1,asimov,callisto,nikolai,pebble,02101981,vendetta,david123,boytoy,11061985,02031989,iloveyou1,stupid1,cayman,casper1,zippo,yamahar1,wildwood,foxylady,calibra,02041980,27061988,dungeon,leedsutd,30041986,11051990,bestbuy,antares,dominion,24680,01061986,skillet,enforcer,derparol,01041988,196969,29071983,f00tball,purple1,mingus,25031987,21031990,remingto,giggles,klaste,3x7pxr,01011994,coolcat,29051989,megane,20031987,02051980,04041988,synergy,0000007,macman,iforget,adgjmp,vjqgfhjkm,28011987,rfvfcenhf,16051989,25121987,16051987,rogue,mamamia,08051990,20091991,1210,carnival,bolitas,paris1,dmitriy,dimas,05051989,papillon,knuckles,29011985,hola,tophat,28021990,100500,cutiepie,devo,415263,ducks,ghjuhfvvf,asdqwe,22021986,freefall,parol,02011983,zarina,buste,vitamin,warez,bigones,17061988,baritone,jamess,twiggy,mischief,bitchy,hetfield,1003,dontknow,grinch,sasha_007,18061990,12031985,12031987,calimero,224466,letmei,15011987,acmilan,alexandre,02031977,08081988,whiteboy,21051991,barney1,02071978,money123,18091985,bigdawg,02031988,cygnusx1,zoloto,31011987,firefigh,blowfish,screamer,lfybbk,20051988,chelse,11121986,01031989,harddick,sexylady,30031988,02041974,auditt,pizdec,kojak,kfgjxrf,20091988,123456ru,wp2003wp,1204,15051990,slugger,kordell1,03031986,swinging,01011974,02071979,rockie,dimples,1234123,1dragon,trucking,rusty2,roger1,marijuana,kerouac,02051978,08031985,paco,thecure,keepout,kernel,noname123,13121985,francisc,bozo,02011982,22071986,02101979,obsidian,12345qw,spud,tabasco,02051985,jaguars,dfktynby,kokomo,popova,notused,sevens,4200,magneto,02051976,roswell,15101986,21101986,lakeside,bigbang,aspen,little1,14021986,loki,suckmydick,strawber,carlos1,nokian73,dirty1,joshu,25091987,16121987,02041975,advent,17011987,slimshady,whistler,10101990,stryker,22031984,15021985,01031985,blueball,26031988,ksusha,bahamut,robocop,w_pass,chris123,impreza,prozac,bookie,bricks,13021990,alice1,cassandr,11111q,john123,4ever,korova,02051973,142857,25041988,paramedi,eclipse1,salope,07091990,1124,darkangel,23021986,999666,nomad,02051981,smackdow,01021990,yoyoma,argentin,moonligh,57chevy,bootys,hardone,capricor,galant,spanker,dkflbr,24111989,magpies,krolik,21051988,cevthrb,cheddar,22041988,bigbooty,scuba1,qwedsa,duffman,bukkake,acura,johncena,sexxy,p@ssw0rd,258369,cherries,12345s,asgard,leopold,fuck123,mopar,lalakers,dogpound,matrix1,crusty,spanner,kestrel,fenris,universa,peachy,assasin,lemmein,eggplant,hejsan,canucks,wendy1,doggy1,aikman,tupac,turnip,godlike,fussball,golden1,19283746,april1,django,petrova,captain1,vincent1,ratman,taekwondo,chocha,serpent,perfect1,capetown,vampir,amore,gymnast,timeout,nbvjatq,blue32,ksenia,k.lvbkf,nazgul,budweiser,clutch,mariya,sylveste,02051972,beaker,cartman1,q11111,sexxx,forever1,loser1,marseill,magellan,vehpbr,sexgod,jktxrf,hallo123,132456,liverpool1,southpaw,seneca,camden,357159,camero,tenchi,johndoe,145236,roofer,741963,vlad,02041978,fktyrf,zxcv123,wingnut,wolfpac,notebook,pufunga7782,brandy1,biteme1,goodgirl,redhat,02031978,challeng,millenium,hoops,maveric,noname,angus1,gaell,onion,olympus,sabrina1,ricard,sixpack,gratis,gagged,camaross,hotgirls,flasher,02051977,bubba123,goldfing,moonshin,gerrard,volkov,sonyfuck,mandrake,258963,tracer,lakers1,asians,susan1,money12,helmut,boater,diablo2,1234zxcv,dogwood,bubbles1,happy2,randy1,aries,beach1,marcius2,navigator,goodie,hellokitty,fkbyjxrf,earthlink,lookout,jumbo,opendoor,stanley1,marie1,12345m,07071977,ashle,wormix,murzik,02081976,lakewood,bluejays,loveya,commande,gateway2,peppe,01011976,7896321,goth,oreo,slammer,rasmus,faith1,knight1,stone1,redskin,ironmaiden,gotmilk,destiny1,dejavu,1master,midnite,timosha,espresso,delfin,toriamos,oberon,ceasar,markie,1a2s3d,ghhh47hj7649,vjkjrj,daddyo,dougie,disco,auggie,lekker,therock1,ou8123,start1,noway,p4ssw0rd,shadow12,333444,saigon,2fast4u,capecod,23skidoo,qazxcv,beater,bremen,aaasss,roadrunner,peace1,12345qwer,02071975,platon,bordeaux,vbkfirf,135798642,test12,supernov,beatles1,qwert40,optimist,vanessa1,prince1,ilovegod,nightwish,natasha1,alchemy,bimbo,blue99,patches1,gsxr1000,richar,hattrick,hott,solaris,proton,nevets,enternow,beavis1,amigos,159357a,ambers,lenochka,147896,suckdick,shag,intercourse,blue1234,spiral,02061977,tosser,ilove,02031975,cowgirl,canuck,q2w3e4,munch,spoons,waterboy,123567,evgeniy,savior,zasada,redcar,mamacita,terefon,globus,doggies,htubcnhfwbz,1008,cuervo,suslik,azertyui,limewire,houston1,stratfor,steaua,coors,tennis1,12345qwerty,stigmata,derf,klondike,patrici,marijuan,hardball,odyssey,nineinch,boston1,pass1,beezer,sandr,charon,power123,a1234,vauxhall,875421,awesome1,reggae,boulder,funstuff,iriska,krokodil,rfntymrf,sterva,champ1,bball,peeper,m123456,toolbox,cabernet,sheepdog,magic32,pigpen,02041977,holein1,lhfrjy,banan,dabomb,natalie1,jennaj,montana1,joecool,funky,steven1,ringo,junio,sammy123,qqqwww,baltimor,footjob,geezer,357951,mash4077,cashmone,pancake,monic,grandam,bongo,yessir,gocubs,nastia,vancouve,barley,dragon69,watford,ilikepie,02071976,laddie,123456789m,hairball,toonarmy,pimpdadd,cvthnm,hunte,davinci,lback,sophie1,firenze,q1234567,admin1,bonanza,elway7,daman,strap,azert,wxcvbn,afrika,theforce,123456t,idefix,wolfen,houdini,scheisse,default,beech,maserati,02061976,sigmachi,dylan1,bigdicks,eskimo,mizzou,02101976,riccardo,egghead,111777,kronos,ghbrjk,chaos1,jomama,rfhnjirf,rodeo,dolemite,cafc91,nittany,pathfind,mikael,password9,vqsablpzla,purpl,gabber,modelsne,myxworld,hellsing,punker,rocknrol,fishon,fuck69,02041976,lolol,twinkie,tripleh,cirrus,redbone,killer123,biggun,allegro,gthcbr,smith1,wanking,bootsy,barry1,mohawk,koolaid,5329,futurama,samoht,klizma,996633,lobo,honeys,peanut1,556677,zxasqw,joemama,javelin,samm,223322,sandra1,flicks,montag,nataly,3006,tasha1,1235789,dogbone,poker1,p0o9i8u7,goodday,smoothie,toocool,max333,metroid,archange,vagabond,billabon,22061941,tyson1,02031973,darkange,skateboard,evolutio,morrowind,wizards,frodo1,rockin,cumslut,plastics,zaqwsxcde,5201314,doit,outback,bumble,dominiqu,persona,nevermore,alinka,02021971,forgetit,sexo,all4one,c2h5oh,petunia,sheeba,kenny1,elisabet,aolsucks,woodstoc,pumper,02011975,fabio,granada,scrapper,123459,minimoni,q123456789,breaker,1004,02091976,ncc74656,slimshad,friendster,austin31,wiseguy,donner,dilbert1,132465,blackbird,buffet,jellybean,barfly,behappy,01011971,carebear,fireblad,02051975,boxcar,cheeky,kiteboy,hello12,panda1,elvisp,opennow,doktor,alex12,02101977,pornking,flamengo,02091975,snowbird,lonesome,robin1,11111a,weed420,baracuda,bleach,12345abc,nokia1,metall,singapor,mariner,herewego,dingo,tycoon,cubs,blunts,proview,123456789d,kamasutra,lagnaf,vipergts,navyseal,starwar,masterbate,wildone,peterbil,cucumber,butkus,123qwert,climax,deniro,gotribe,cement,scooby1,summer69,harrier,shodan,newyear,02091977,starwars1,romeo1,sedona,harald,doubled,sasha123,bigguns,salami,awnyce,kiwi,homemade,pimping,azzer,bradley1,warhamme,linkin,dudeman,qwe321,pinnacle,maxdog,flipflop,lfitymrf,fucker1,acidburn,esquire,sperma,fellatio,jeepster,thedon,sexybitch,pookey,spliff,widget,vfntvfnbrf,trinity1,mutant,samuel1,meliss,gohome,1q2q3q,mercede,comein,grin,cartoons,paragon,henrik,rainyday,pacino,senna,bigdog1,alleycat,12345qaz,narnia,mustang2,tanya1,gianni,apollo11,wetter,clovis,escalade,rainbows,freddy1,smart1,daisydog,s123456,cocksucker,pushkin,lefty,sambo,fyutkjxtr,hiziad,boyz,whiplash,orchard,newark,adrenalin,1598753,bootsie,chelle,trustme,chewy,golfgti,tuscl,ambrosia,5wr2i7h8,penetration,shonuf,jughead,payday,stickman,gotham,kolokol,johnny5,kolbasa,stang,puppydog,charisma,gators1,mone,jakarta,draco,nightmar,01011973,inlove,laetitia,02091973,tarpon,nautica,meadow,0192837465,luckyone,14881488,chessie,goldeney,tarakan,69camaro,bungle,wordup,interne,fuckme2,515000,dragonfl,sprout,02081974,gerbil,bandit1,02071971,melanie1,phialpha,camber,kathy1,adriano,gonzo1,10293847,bigjohn,bismarck,7777777a,scamper,12348765,rabbits,222777,bynthytn,dima123,alexander1,mallorca,dragster,favorite6,beethove,burner,cooper1,fosters,hello2,normandy,777999,sebring,1michael,lauren1,blake1,killa,02091971,nounours,trumpet1,thumper1,playball,xantia,rugby1,rocknroll,guillaum,angela1,strelok,prosper,buttercup,masterp,dbnfkbr,cambridg,venom,treefrog,lumina,1234566,supra,sexybabe,freee,shen,frogs,driller,pavement,grace1,dicky,checker,smackdown,pandas,cannibal,asdffdsa,blue42,zyjxrf,nthvbyfnjh,melrose,neon,jabber,gamma,369258147,aprilia,atticus,benessere,catcher,skipper1,azertyuiop,sixty9,thierry,treetop,jello,melons,123456789qwe,tantra,buzzer,catnip,bouncer,computer1,sexyone,ananas,young1,olenka,sexman,mooses,kittys,sephiroth,contra,hallowee,skylark,sparkles,777333,1qazxsw23edc,lucas1,q1w2e3r,gofast,hannes,amethyst,ploppy,flower2,hotass,amatory,volleyba,dixie1,bettyboo,ticklish,02061974,frenchy,phish1,murphy1,trustno,02061972,leinad,mynameis,spooge,jupiter1,hyundai,frosch,junkmail,abacab,marbles,32167,casio,sunshine1,wayne1,longhair,caster,snicker,02101973,gannibal,skinhead,hansol,gatsby,segblue2,montecar,plato,gumby,kaboom,matty,bosco1,888999,jazzy,panter,jesus123,charlie2,giulia,candyass,sex69,travis1,farmboy,special1,02041973,letsdoit,password01,allison1,abcdefg1,notredam,ilikeit,789654123,liberty1,rugger,uptown,alcatraz,123456w,airman,007bond,navajo,kenobi,terrier,stayout,grisha,frankie1,fluff,1qazzaq1,1234561,virginie,1234568,tango1,werdna,octopus,fitter,dfcbkbcf,blacklab,115599,montrose,allen1,supernova,frederik,ilovepussy,justice1,radeon,playboy2,blubber,sliver,swoosh,motocros,lockdown,pearls,thebear,istheman,pinetree,biit,1234rewq,rustydog,tampabay,titts,babycake,jehovah,vampire1,streaming,collie,camil,fidelity,calvin1,stitch,gatit,restart,puppy1,budgie,grunt,capitals,hiking,dreamcas,zorro1,321678,riffraff,makaka,playmate,napalm,rollin,amstel,zxcvb123,samanth,rumble,fuckme69,jimmys,951357,pizzaman,1234567899,tralala,delpiero,alexi,yamato,itisme,1million,vfndtq,kahlua,londo,wonderboy,carrots,tazz,ratboy,rfgecnf,02081973,nico,fujitsu,tujhrf,sergbest,blobby,02051970,sonic1,1357911,smirnov,video1,panhead,bucky,02031974,44332211,duffer,cashmoney,left4dead,bagpuss,salman,01011972,titfuck,66613666,england1,malish,dresden,lemans,darina,zapper,123456as,123456qqq,met2002,02041972,redstar,blue23,1234509876,pajero,booyah,please1,tetsuo,semper,finder,hanuman,sunlight,123456n,02061971,treble,cupoi,password99,dimitri,3ip76k2,popcorn1,lol12345,stellar,nympho,shark1,keith1,saskia,bigtruck,revoluti,rambo1,asd222,feelgood,phat,gogators,bismark,cola,puck,furball,burnout,slonik,bowtie,mommy1,icecube,fabienn,mouser,papamama,rolex,giants1,blue11,trooper1,momdad,iklo,morten,rhubarb,gareth,123456d,blitz,canada1,r2d2,brest,tigercat,usmarine,lilbit,benny1,azrael,lebowski,12345r,madagaskar,begemot,loverman,dragonballz,italiano,mazda3,naughty1,onions,diver1,cyrano,capcom,asdfg123,forlife,fisherman,weare138,requiem,mufasa,alpha123,piercing,hellas,abracadabra,duckman,caracas,macintos,02011971,jordan2,crescent,fduecn,hogtied,eatmenow,ramjet,18121812,kicksass,whatthe,discus,rfhfvtkmrf,rufus1,sqdwfe,mantle,vegitto,trek,dan123,paladin1,rudeboy,liliya,lunchbox,riversid,acapulco,libero,dnsadm,maison,toomuch,boobear,hemlock,sextoy,pugsley,misiek,athome,migue,altoids,marcin,123450,rhfcfdbwf,jeter2,rhinos,rjhjkm,mercury1,ronaldinho,shampoo,makayla,kamilla,masterbating,tennesse,holger,john1,matchbox,hores,poptart,parlament,goodyear,asdfgh1,02081970,hardwood,alain,erection,hfytnrb,highlife,implants,benjami,dipper,jeeper,bendover,supersonic,babybear,laserjet,gotenks,bama,natedogg,aol123,pokemo,rabbit1,raduga,sopranos,cashflow,menthol,pharao,hacking,334455,ghjcnbnenrf,lizzy,muffin1,pooky,penis1,flyer,gramma,dipset,becca,ireland1,diana1,donjuan,pong,ziggy1,alterego,simple1,cbr900,logger,111555,claudia1,cantona7,matisse,ljxtymrf,victori,harle,mamas,encore,mangos,iceman1,diamon,alexxx,tiamat,5000,desktop,mafia,smurf,princesa,shojou,blueberr,welkom,maximka,123890,123q123,tammy1,bobmarley,clips,demon666,ismail,termite,laser1,missie,altair,donna1,bauhaus,trinitron,mogwai,flyers88,juniper,nokia5800,boroda,jingles,qwerasdfzxcv,shakur,777666,legos,mallrats,1qazxsw,goldeneye,tamerlan,julia1,backbone,spleen,49ers,shady,darkone,medic1,justi,giggle,cloudy,aisan,douche,parkour,bluejay,huskers1,redwine,1qw23er4,satchmo,1231234,nineball,stewart1,ballsack,probes,kappa,amiga,flipper1,dortmund,963258,trigun,1237895,homepage,blinky,screwy,gizzmo,belkin,chemist,coolhand,chachi,braves1,thebest,greedisgood,pro100,banana1,101091m,123456g,wonderfu,barefeet,8inches,1111qqqq,kcchiefs,qweasdzxc123,metal1,jennifer1,xian,asdasd123,pollux,cheerleaers,fruity,mustang5,turbos,shopper,photon,espana,hillbill,oyster,macaroni,gigabyte,jesper,motown,tuxedo,buster12,triplex,cyclones,estrell,mortis,holla,456987,fiddle,sapphic,jurassic,thebeast,ghjcnjq,baura,spock1,metallica1,karaoke,nemrac58,love1234,02031970,flvbybcnhfnjh,frisbee,diva,ajax,feathers,flower1,soccer11,allday,mierda,pearl1,amature,marauder,333555,redheads,womans,egorka,godbless,159263,nimitz,aaaa1111,sashka,madcow,socce,greywolf,baboon,pimpdaddy,123456789r,reloaded,lancia,rfhfylfi,dicker,placid,grimace,22446688,olemiss,whores,culinary,wannabe,maxi,1234567aa,amelie,riley1,trample,phantom1,baberuth,bramble,asdfqwer,vides,4you,abc123456,taichi,aztnm,smother,outsider,hakr,blackhawk,bigblack,girlie,spook,valeriya,gianluca,freedo,1q2q3q4q,handbag,lavalamp,cumm,pertinant,whatup,nokia123,redlight,patrik,111aaa,poppy1,dfytxrf,aviator,sweeps,kristin1,cypher,elway,yinyang,access1,poophead,tucson,noles1,monterey,waterfal,dank,dougal,918273,suede,minnesot,legman,bukowski,ganja,mammoth,riverrat,asswipe,daredevi,lian,arizona1,kamikadze,alex1234,smile1,angel2,55bgates,bellagio,0001,wanrltw,stiletto,lipton,arsena,biohazard,bbking,chappy,tetris,as123456,darthvad,lilwayne,nopassword,7412369,123456789987654321,natchez,glitter,14785236,mytime,rubicon,moto,pyon,wazzup,tbird,shane1,nightowl,getoff,beckham7,trueblue,hotgirl,nevermin,deathnote,13131,taffy,bigal,copenhag,apricot,gallaries,dtkjcbgtl,totoro,onlyone,civicsi,jesse1,baby123,sierra1,festus,abacus,sickboy,fishtank,fungus,charle,golfpro,teensex,mario66,seaside,aleksei,rosewood,blackberry,1020304050,bedlam,schumi,deerhunt,contour,darkelf,surveyor,deltas,pitchers,741258963,dipstick,funny1,lizzard,112233445566,jupiter2,softtail,titman,greenman,z1x2c3v4b5,smartass,12345677,notnow,myworld,nascar1,chewbacc,nosferatu,downhill,dallas22,kuan,blazers,whales,soldat,craving,powerman,yfcntyf,hotrats,cfvceyu,qweasdzx,princess1,feline,qqwwee,chitown,1234qaz,mastermind,114477,dingbat,care1839,standby,kismet,atreides,dogmeat,icarus,monkeyboy,alex1,mouses,nicetits,sealteam,chopper1,crispy,winter99,rrpass1,myporn,myspace1,corazo,topolino,ass123,lawman,muffy,orgy,1love,passord,hooyah,ekmzyf,pretzel,amonra,nestle,01011950,jimbeam,happyman,z12345,stonewal,helios,manunited,harcore,dick1,gaymen,2hot4u,light1,qwerty13,kakashi,pjkjnj,alcatel,taylo,allah,buddydog,ltkmaby,mongo,blonds,start123,audia6,123456v,civilwar,bellaco,turtles,mustan,deadspin,aaa123,fynjirf,lucky123,tortoise,amor,summe,waterski,zulu,drag0n,dtxyjcnm,gizmos,strife,interacial,pusyy,goose1,bear1,equinox,matri,jaguar1,tobydog,sammys,nachos,traktor,bryan1,morgoth,444555,dasani,miami1,mashka,xxxxxx1,ownage,nightwin,hotlips,passmast,cool123,skolko,eldiablo,manu,1357908642,screwyou,badabing,foreplay,hydro,kubrick,seductive,demon1,comeon,galileo,aladdin,metoo,happines,902100,mizuno,caddy,bizzare,girls1,redone,ohmygod,sable,bonovox,girlies,hamper,opus,gizmodo1,aaabbb,pizzahut,999888,rocky2,anton1,kikimora,peavey,ocelot,a1a2a3a4,2wsx3edc,jackie1,solace,sprocket,galary,chuck1,volvo1,shurik,poop123,locutus,virago,wdtnjxtr,tequier,bisexual,doodles,makeitso,fishy,789632145,nothing1,fishcake,sentry,libertad,oaktree,fivestar,adidas1,vegitta,mississi,spiffy,carme,neutron,vantage,agassi,boners,123456789v,hilltop,taipan,barrage,kenneth1,fister,martian,willem,lfybkf,bluestar,moonman,ntktdbpjh,paperino,bikers,daffy,benji,quake,dragonfly,suckcock,danilka,lapochka,belinea,calypso,asshol,camero1,abraxas,mike1234,womam,q1q2q3q4q5,youknow,maxpower,pic's,audi80,sonora,raymond1,tickler,tadpole,belair,crazyman,finalfantasy,999000,jonatha,paisley,kissmyas,morgana,monste,mantra,spunk,magic123,jonesy,mark1,alessand,741258,baddest,ghbdtnrfrltkf,zxccxz,tictac,augustin,racers,7grout,foxfire,99762000,openit,nathanie,1z2x3c4v5b,seadog,gangbanged,lovehate,hondacbr,harpoon,mamochka,fisherma,bismilla,locust,wally1,spiderman1,saffron,utjhubq,123456987,20spanks,safeway,pisser,bdfyjd,kristen1,bigdick1,magenta,vfhujif,anfisa,friday13,qaz123wsx,0987654321q,tyrant,guan,meggie,kontol,nurlan,ayanami,rocket1,yaroslav,websol76,mutley,hugoboss,websolutions,elpaso,gagarin,badboys,sephirot,918273645,newuser,qian,edcrfv,booger1,852258,lockout,timoxa94,mazda323,firedog,sokolova,skydiver,jesus777,1234567890z,soulfly,canary,malinka,guillerm,hookers,dogfart,surfer1,osprey,india123,rhjkbr,stoppedby,nokia5530,123456789o,blue1,werter,divers,3000,123456f,alpina,cali,whoknows,godspeed,986532,foreskin,fuzzy1,heyyou,didier,slapnuts,fresno,rosebud1,sandman1,bears1,blade1,honeybun,queen1,baronn,pakista,philipp,9111961,topsecret,sniper1,214365,slipper,letsfuck,pippen33,godawgs,mousey,qw123456,scrotum,loveis,lighthou,bp2002,nancy123,jeffrey1,susieq,buddy2,ralphie,trout1,willi,antonov,sluttey,rehbwf,marty1,darian,losangeles,letme1n,12345d,pusssy,godiva,ender,golfnut,leonidas,a1b2c3d4e5,puffer,general1,wizzard,lehjxrf,racer1,bigbucks,cool12,buddys,zinger,esprit,vbienrf,josep,tickling,froggie,987654321a,895623,daddys,crumbs,gucci,mikkel,opiate,tracy1,christophe,came11,777555,petrovich,humbug,dirtydog,allstate,horatio,wachtwoord,creepers,squirts,rotary,bigd,georgia1,fujifilm,2sweet,dasha,yorkie,slimjim,wiccan,kenzie,system1,skunk,b12345,getit,pommes,daredevil,sugars,bucker,piston,lionheart,1bitch,515051,catfight,recon,icecold,fantom,vodafone,kontakt,boris1,vfcnth,canine,01011961,valleywa,faraon,chickenwing101,qq123456,livewire,livelife,roosters,jeepers,ilya1234,coochie,pavlik,dewalt,dfhdfhf,architec,blackops,1qaz2wsx3edc4rfv,rhfcjnf,wsxedc,teaser,sebora,25252,rhino1,ankara,swifty,decimal,redleg,shanno,nermal,candies,smirnova,dragon01,photo1,ranetki,a1s2d3f4g5,axio,wertzu,maurizio,6uldv8,zxcvasdf,punkass,flowe,graywolf,peddler,3rjs1la7qe,mpegs,seawolf,ladyboy,pianos,piggies,vixen,alexus,orpheus,gdtrfb,z123456,macgyver,hugetits,ralph1,flathead,maurici,mailru,goofball,nissan1,nikon,stopit,odin,big1,smooch,reboot,famil,bullit,anthony7,gerhard,methos,124038,morena,eagle2,jessica2,zebras,getlost,gfynthf,123581321,sarajevo,indon,comets,tatjana,rfgbnjirf,joystick,batman12,123456c,sabre,beerme,victory1,kitties,1475369,badboy1,booboo1,comcast,slava,squid,saxophon,lionhear,qaywsx,bustle,nastena,roadway,loader,hillside,starlight,24681012,niggers,access99,bazooka,molly123,blackice,bandi,cocacol,nfhfrfy,timur,muschi,horse1,quant4307s,squerting,oscars,mygirls,flashman,tangerin,goofy1,p0o9i8,housewifes,newness,monkey69,escorpio,password11,hippo,warcraft3,qazxsw123,qpalzm,ribbit,ghbdtndctv,bogota,star123,258000,lincoln1,bigjim,lacoste,firestorm,legenda,indain,ludacris,milamber,1009,evangeli,letmesee,a111111,hooters1,bigred1,shaker,husky,a4tech,cnfkrth,argyle,rjhjdf,nataha,0o9i8u7y,gibson1,sooners1,glendale,archery,hoochie,stooge,aaaaaa1,scorpions,school1,vegas1,rapier,mike23,bassoon,groupd2013,macaco,baker1,labia,freewill,santiag,silverado,butch1,vflfufcrfh,monica1,rugrat,cornhole,aerosmit,bionicle,gfgfvfvf,daniel12,virgo,fmale,favorite2,detroit1,pokey,shredder,baggies,wednesda,cosmo1,mimosa,sparhawk,firehawk,romario,911turbo,funtimes,fhntvrf,nexus6,159753456,timothy1,bajingan,terry1,frenchie,raiden,1mustang,babemagnet,74123698,nadejda,truffles,rapture,douglas1,lamborghini,motocross,rjcvjc,748596,skeeter1,dante1,angel666,telecom,carsten,pietro,bmw318,astro1,carpediem,samir,orang,helium,scirocco,fuzzball,rushmore,rebelz,hotspur,lacrimosa,chevys10,madonna1,domenico,yfnfirf,jachin,shelby1,bloke,dawgs,dunhill,atlanta1,service1,mikado,devilman,angelit,reznor,euphoria,lesbain,checkmat,browndog,phreak,blaze1,crash1,farida,mutter,luckyme,horsemen,vgirl,jediknig,asdas,cesare,allnight,rockey,starlite,truck1,passfan,close-up,samue,cazzo,wrinkles,homely,eatme1,sexpot,snapshot,dima1995,asthma,thetruth,ducky,blender,priyanka,gaucho,dutchman,sizzle,kakarot,651550,passcode,justinbieber,666333,elodie,sanjay,110442,alex01,lotus1,2300mj,lakshmi,zoomer,quake3,12349876,teapot,12345687,ramada,pennywis,striper,pilot1,chingon,optima,nudity,ethan1,euclid,beeline,loyola,biguns,zaq12345,bravo1,disney1,buffa,assmunch,vivid,6661313,wellingt,aqwzsx,madala11,9874123,sigmar,pictere,tiptop,bettyboop,dinero,tahiti,gregory1,bionic,speed1,fubar1,lexus1,denis1,hawthorn,saxman,suntzu,bernhard,dominika,camaro1,hunter12,balboa,bmw2002,seville,diablo1,vfhbyjxrf,1234abc,carling,lockerroom,punani,darth,baron1,vaness,1password,libido,picher,232425,karamba,futyn007,daydream,11001001,dragon123,friends1,bopper,rocky123,chooch,asslover,shimmer,riddler,openme,tugboat,sexy123,midori,gulnara,christo,swatch,laker,offroad,puddles,hackers,mannheim,manager1,horseman,roman1,dancer1,komputer,pictuers,nokia5130,ejaculation,lioness,123456y,evilone,nastenka,pushok,javie,lilman,3141592,mjolnir,toulouse,pussy2,bigworm,smoke420,fullback,extensa,dreamcast,belize,delboy,willie1,casablanca,csyjxtr,ricky1,bonghit,salvator,basher,pussylover,rosie1,963258741,vivitron,cobra427,meonly,armageddon,myfriend,zardoz,qwedsazxc,kraken,fzappa,starfox,333999,illmatic,capoeira,weenie,ramzes,freedom2,toasty,pupkin,shinigami,fhvfutljy,nocturne,churchil,thumbnils,tailgate,neworder,sexymama,goarmy,cerebus,michelle1,vbifyz,surfsup,earthlin,dabulls,basketbal,aligator,mojojojo,saibaba,welcome2,wifes,wdtnjr,12345w,slasher,papabear,terran,footman,hocke,153759,texans,tom123,sfgiants,billabong,aassdd,monolith,xxx777,l3tm31n,ticktock,newone,hellno,japanees,contortionist,admin123,scout1,alabama1,divx1,rochard,privat,radar1,bigdad,fhctybq,tortuga,citrus,avanti,fantasy1,woodstock,s12345,fireman1,embalmer,woodwork,bonzai,konyor,newstart,jigga,panorama,goats,smithy,rugrats,hotmama,daedalus,nonstop,fruitbat,lisenok,quaker,violator,12345123,my3sons,cajun,fraggle,gayboy,oldfart,vulva,knickerless,orgasms,undertow,binky,litle,kfcnjxrf,masturbation,bunnie,alexis1,planner,transexual,sparty,leeloo,monies,fozzie,stinger1,landrove,anakonda,scoobie,yamaha1,henti,star12,rfhlbyfk,beyonce,catfood,cjytxrf,zealots,strat,fordtruc,archangel,silvi,sativa,boogers,miles1,bigjoe,tulip,petite,greentea,shitter,jonboy,voltron,morticia,evanescence,3edc4rfv,longshot,windows1,serge,aabbcc,starbucks,sinful,drywall,prelude1,www123,camel1,homebrew,marlins,123412,letmeinn,domini,swampy,plokij,fordf350,webcam,michele1,bolivi,27731828,wingzero,qawsedrftg,shinji,sverige,jasper1,piper1,cummer,iiyama,gocats,amour,alfarome,jumanji,mike69,fantasti,1monkey,w00t88,shawn1,lorien,1a2s3d4f5g,koleso,murph,natascha,sunkist,kennwort,emine,grinder,m12345,q1q2q3q4,cheeba,money2,qazwsxedc1,diamante,prosto,pdiddy,stinky1,gabby1,luckys,franci,pornographic,moochie,gfhjdjp,samdog,empire1,comicbookdb,emili,motdepasse,iphone,braveheart,reeses,nebula,sanjose,bubba2,kickflip,arcangel,superbow,porsche911,xyzzy,nigger1,dagobert,devil1,alatam,monkey2,barbara1,12345v,vfpfafrf,alessio,babemagn,aceman,arrakis,kavkaz,987789,jasons,berserk,sublime1,rogue1,myspace,buckwhea,csyekz,pussy4me,vette1,boots1,boingo,arnaud,budlite,redstorm,paramore,becky1,imtheman,chango,marley1,milkyway,666555,giveme,mahalo,lux2000,lucian,paddy,praxis,shimano,bigpenis,creeper,newproject2004,rammstei,j3qq4h7h2v,hfljcnm,lambchop,anthony2,bugman,gfhjkm12,dreamer1,stooges,cybersex,diamant,cowboyup,maximus1,sentra,615243,goethe,manhatta,fastcar,selmer,1213141516,yfnfitymrf,denni,chewey,yankee1,elektra,123456789p,trousers,fishface,topspin,orwell,vorona,sodapop,motherfu,ibilltes,forall,kookie,ronald1,balrog,maximilian,mypasswo,sonny1,zzxxcc,tkfkdg,magoo,mdogg,heeled,gitara,lesbos,marajade,tippy,morozova,enter123,lesbean,pounded,asd456,fialka,scarab,sharpie,spanky1,gstring,sachin,12345asd,princeto,hellohel,ursitesux,billows,1234kekc,kombat,cashew,duracell,kseniya,sevenof9,kostik,arthur1,corvet07,rdfhnbhf,songoku,tiberian,needforspeed,1qwert,dropkick,kevin123,panache,libra,a123456a,kjiflm,vfhnsirf,cntgfy,iamcool,narut,buffer,sk8ordie,urlaub,fireblade,blanked,marishka,gemini1,altec,gorillaz,chief1,revival47,ironman1,space1,ramstein,doorknob,devilmaycry,nemesis1,sosiska,pennstat,monday1,pioner,shevchenko,detectiv,evildead,blessed1,aggie,coffees,tical,scotts,bullwink,marsel,krypto,adrock,rjitxrf,asmodeus,rapunzel,theboys,hotdogs,deepthro,maxpayne,veronic,fyyeirf,otter,cheste,abbey1,thanos,bedrock,bartok,google1,xxxzzz,rodent,montecarlo,hernande,mikayla,123456789l,bravehea,12locked,ltymub,pegasus1,ameteur,saltydog,faisal,milfnew,momsuck,everques,ytngfhjkz,m0nkey,businessbabe,cooki,custard,123456ab,lbvjxrf,outlaws,753357,qwerty78,udacha,insider,chees,fuckmehard,shotokan,katya,seahorse,vtldtlm,turtle1,mike12,beebop,heathe,everton1,darknes,barnie,rbcekz,alisher,toohot,theduke,555222,reddog1,breezy,bulldawg,monkeyman,baylee,losangel,mastermi,apollo1,aurelie,zxcvb12345,cayenne,bastet,wsxzaq,geibcnbr,yello,fucmy69,redwall,ladybird,bitchs,cccccc1,rktjgfnhf,ghjdthrf,quest1,oedipus,linus,impalass,fartman,12345k,fokker,159753a,optiplex,bbbbbb1,realtor,slipkno,santacru,rowdy,jelena,smeller,3984240,ddddd1,sexyme,janet1,3698741,eatme69,cazzone,today1,poobear,ignatius,master123,newpass1,heather2,snoopdogg,blondinka,pass12,honeydew,fuckthat,890098890,lovem,goldrush,gecko,biker1,llama,pendejo,avalanche,fremont,snowman1,gandolf,chowder,1a2b3c4d5e,flyguy,magadan,1fuck,pingvin,nokia5230,ab1234,lothar,lasers,bignuts,renee1,royboy,skynet,12340987,1122334,dragrace,lovely1,22334455,booter,12345612,corvett,123456qq,capital1,videoes,funtik,wyvern,flange,sammydog,hulkster,13245768,not4you,vorlon,omegared,l58jkdjp!,filippo,123mudar,samadams,petrus,chris12,charlie123,123456789123,icetea,sunderla,adrian1,123qweas,kazanova,aslan,monkey123,fktyeirf,goodsex,123ab,lbtest,banaan,bluenose,837519,asd12345,waffenss,whateve,1a2a3a4a,trailers,vfhbirf,bhbcrf,klaatu,turk182,monsoon,beachbum,sunbeam,succes,clyde1,viking1,rawhide,bubblegum,princ,mackenzi,hershey1,222555,dima55,niggaz,manatee,aquila,anechka,pamel,bugsbunn,lovel,sestra,newport1,althor,hornyman,wakeup,zzz111,phishy,cerber,torrent,thething,solnishko,babel,buckeye1,peanu,ethernet,uncencored,baraka,665544,chris2,rb26dett,willy1,choppers,texaco,biggirl,123456b,anna2614,sukebe,caralho,callofduty,rt6ytere,jesus7,angel12,1money,timelord,allblack,pavlova,romanov,tequiero,yitbos,lookup,bulls23,snowflake,dickweed,barks,lever,irisha,firestar,fred1234,ghjnjnbg,danman,gatito,betty1,milhouse,kbctyjr,masterbaiting,delsol,papit,doggys,123698741,bdfyjdf,invictus,bloods,kayla1,yourmama,apple2,angelok,bigboy1,pontiac1,verygood,yeshua,twins2,porn4me,141516,rasta69,james2,bosshog,candys,adventur,stripe,djkjlz,dokken,austin316,skins,hogwarts,vbhevbh,navigato,desperado,xxx666,cneltyn,vasiliy,hazmat,daytek,eightbal,fred1,four20,74227422,fabia,aerosmith,manue,wingchun,boohoo,hombre,sanity72,goatboy,fuckm,partizan,avrora,utahjazz,submarin,pussyeat,heinlein,control1,costaric,smarty,chuan,triplets,snowy,snafu,teacher1,vangogh,vandal,evergree,cochise,qwerty99,pyramid1,saab900,sniffer,qaz741,lebron23,mark123,wolvie,blackbelt,yoshi,feeder,janeway,nutella,fuking,asscock,deepak,poppie,bigshow,housewife,grils,tonto,cynthia1,temptress,irakli,belle1,russell1,manders,frank123,seabass,gforce,songbird,zippy1,naught,brenda1,chewy1,hotshit,topaz,43046721,girfriend,marinka,jakester,thatsme,planeta,falstaff,patrizia,reborn,riptide,cherry1,shuan,nogard,chino,oasis1,qwaszx12,goodlife,davis1,1911a1,harrys,shitfuck,12345678900,russian7,007700,bulls1,porshe,danil,dolphi,river1,sabaka,gobigred,deborah1,volkswagen,miamo,alkaline,muffdive,1letmein,fkbyrf,goodguy,hallo1,nirvan,ozzie,cannonda,cvbhyjdf,marmite,germany1,joeblow,radio1,love11,raindrop,159852,jacko,newday,fathead,elvis123,caspe,citibank,sports1,deuce,boxter,fakepass,golfman,snowdog,birthday4,nonmembe,niklas,parsifal,krasota,theshit,1235813,maganda,nikita1,omicron,cassie1,columbo,buick,sigma1,thistle,bassin,rickster,apteka,sienna,skulls,miamor,coolgirl,gravis,1qazxc,virgini,hunter2,akasha,batma,motorcyc,bambino,tenerife,fordf250,zhuan,iloveporn,markiza,hotbabes,becool,fynjybyf,wapapapa,forme,mamont,pizda,dragonz,sharon1,scrooge,mrbill,pfloyd,leeroy,natedog,ishmael,777111,tecumseh,carajo,nfy.irf,0000000000o,blackcock,fedorov,antigone,feanor,novikova,bobert,peregrin,spartan117,pumkin,rayman,manuals,tooltime,555333,bonethug,marina1,bonnie1,tonyhawk,laracroft,mahalkita,18273645,terriers,gamer,hoser,littlema,molotok,glennwei,lemon1,caboose,tater,12345654321,brians,fritz1,mistral,jigsaw,fuckshit,hornyguy,southside,edthom,antonio1,bobmarle,pitures,ilikesex,crafty,nexus,boarder,fulcrum,astonvil,yanks1,yngwie,account1,zooropa,hotlegs,sammi,gumbo,rover1,perkele,maurolarastefy,lampard,357753,barracud,dmband,abcxyz,pathfinder,335577,yuliya,micky,jayman,asdfg12345,1596321,halcyon,rerfhtre,feniks,zaxscd,gotyoass,jaycee,samson1,jamesb,vibrate,grandpri,camino,colossus,davidb,mamo4ka,nicky1,homer123,pinguin,watermelon,shadow01,lasttime,glider,823762,helen1,pyramids,tulane,osama,rostov,john12,scoote,bhbyrf,gohan,galeries,joyful,bigpussy,tonka,mowgli,astalavista,zzz123,leafs,dalejr8,unicorn1,777000,primal,bigmama,okmijn,killzone,qaz12345,snookie,zxcvvcxz,davidc,epson,rockman,ceaser,beanbag,katten,3151020,duckhunt,segreto,matros,ragnar,699669,sexsexse,123123z,fuckyeah,bigbutts,gbcmrf,element1,marketin,saratov,elbereth,blaster1,yamahar6,grime,masha,juneau,1230123,pappy,lindsay1,mooner,seattle1,katzen,lucent,polly1,lagwagon,pixie,misiaczek,666666a,smokedog,lakers24,eyeball,ironhors,ametuer,volkodav,vepsrf,kimmy,gumby1,poi098,ovation,1q2w3,drinker,penetrating,summertime,1dallas,prima,modles,takamine,hardwork,macintosh,tahoe,passthie,chiks,sundown,flowers1,boromir,music123,phaedrus,albert1,joung,malakas,gulliver,parker1,balder,sonne,jessie1,domainlock2005,express1,vfkbyf,youandme,raketa,koala,dhjnvytyjub,nhfrnjh,testibil,ybrbnjc,987654321q,axeman,pintail,pokemon123,dogggg,shandy,thesaint,11122233,x72jhhu3z,theclash,raptors,zappa1,djdjxrf,hell666,friday1,vivaldi,pluto1,lance1,guesswho,jeadmi,corgan,skillz,skippy1,mango1,gymnastic,satori,362514,theedge,cxfcnkbdfz,sparkey,deicide,bagels,lololol,lemmings,r4e3w2q1,silve,staind,schnuffi,dazzle,basebal1,leroy1,bilbo1,luckie,qwerty2,goodfell,hermione,peaceout,davidoff,yesterda,killah,flippy,chrisb,zelda1,headless,muttley,fuckof,tittys,catdaddy,photog,beeker,reaver,ram1500,yorktown,bolero,tryagain,arman,chicco,learjet,alexei,jenna1,go2hell,12s3t4p55,momsanaladventure,mustang9,protoss,rooter,ginola,dingo1,mojave,erica1,1qazse4,marvin1,redwolf,sunbird,dangerou,maciek,girsl,hawks1,packard1,excellen,dashka,soleda,toonces,acetate,nacked,jbond007,alligator,debbie1,wellhung,monkeyma,supers,rigger,larsson,vaseline,rjnzhf,maripos,123456asd,cbr600rr,doggydog,cronic,jason123,trekker,flipmode,druid,sonyvaio,dodges,mayfair,mystuff,fun4me,samanta,sofiya,magics,1ranger,arcane,sixtynin,222444,omerta,luscious,gbyudby,bobcats,envision,chance1,seaweed,holdem,tomate,mensch,slicer,acura1,goochi,qweewq,punter,repoman,tomboy,never1,cortina,gomets,147896321,369852147,dogma,bhjxrf,loglatin,eragon,strato,gazelle,growler,885522,klaudia,payton34,fuckem,butchie,scorpi,lugano,123456789k,nichola,chipper1,spide,uhbujhbq,rsalinas,vfylfhby,longhorns,bugatti,everquest,!qaz2wsx,blackass,999111,snakeman,p455w0rd,fanatic,family1,pfqxbr,777vlad,mysecret,marat,phoenix2,october1,genghis,panties1,cooker,citron,ace123,1234569,gramps,blackcoc,kodiak1,hickory,ivanhoe,blackboy,escher,sincity,beaks,meandyou,spaniel,canon1,timmy1,lancaste,polaroid,edinburg,fuckedup,hotman,cueball,golfclub,gopack,bookcase,worldcup,dkflbvbhjdbx,twostep,17171717aa,letsplay,zolushka,stella1,pfkegf,kingtut,67camaro,barracuda,wiggles,gjhjkm,prancer,patata,kjifhf,theman1,romanova,sexyass,copper1,dobber,sokolov,pomidor,algernon,cadman,amoremio,william2,silly1,bobbys,hercule,hd764nw5d7e1vb1,defcon,deutschland,robinhood,alfalfa,machoman,lesbens,pandora1,easypay,tomservo,nadezhda,goonies,saab9000,jordyn,f15eagle,dbrecz,12qwerty,greatsex,thrawn,blunted,baywatch,doggystyle,loloxx,chevy2,january1,kodak,bushel,78963214,ub6ib9,zz8807zpl,briefs,hawker,224488,first1,bonzo,brent1,erasure,69213124,sidewind,soccer13,622521,mentos,kolibri,onepiece,united1,ponyboy,keksa12,wayer,mypussy,andrej,mischa,mille,bruno123,garter,bigpun,talgat,familia,jazzy1,mustang8,newjob,747400,bobber,blackbel,hatteras,ginge,asdfjkl;,camelot1,blue44,rebbyt34,ebony1,vegas123,myboys,aleksander,ijrjkflrf,lopata,pilsner,lotus123,m0nk3y,andreev,freiheit,balls1,drjynfrnt,mazda1,waterpolo,shibumi,852963,123bbb,cezer121,blondie1,volkova,rattler,kleenex,ben123,sanane,happydog,satellit,qazplm,qazwsxedcrfvtgb,meowmix,badguy,facefuck,spice1,blondy,major1,25000,anna123,654321a,sober1,deathrow,patterso,china1,naruto1,hawkeye1,waldo1,butchy,crayon,5tgb6yhn,klopik,crocodil,mothra,imhorny,pookie1,splatter,slippy,lizard1,router,buratino,yahweh,123698,dragon11,123qwe456,peepers,trucker1,ganjaman,1hxboqg2,cheyanne,storys,sebastie,zztop,maddison,4rfv3edc,darthvader,jeffro,iloveit,victor1,hotty,delphin,lifeisgood,gooseman,shifty,insertions,dude123,abrupt,123masha,boogaloo,chronos,stamford,pimpster,kthjxrf,getmein,amidala,flubber,fettish,grapeape,dantes,oralsex,jack1,foxcg33,winchest,francis1,getin,archon,cliffy,blueman,1basebal,sport1,emmitt22,porn123,bignasty,morga,123hfjdk147,ferrar,juanito,fabiol,caseydog,steveo,peternorth,paroll,kimchi,bootleg,gaijin,secre,acacia,eatme2,amarillo,monkey11,rfhfgep,tylers,a1a2a3a4a5,sweetass,blower,rodina,babushka,camilo,cimbom,tiffan,vfnbkmlf,ohbaby,gotigers,lindsey1,dragon13,romulus,qazxsw12,zxcvbn1,dropdead,hitman47,snuggle,eleven11,bloopers,357mag,avangard,bmw320,ginscoot,dshade,masterkey,voodoo1,rootedit,caramba,leahcim,hannover,8phrowz622,tim123,cassius,000000a,angelito,zzzzz1,badkarma,star1,malaga,glenwood,footlove,golf1,summer12,helpme1,fastcars,titan1,police1,polinka,k.jdm,marusya,augusto,shiraz,pantyhose,donald1,blaise,arabella,brigada,c3por2d2,peter01,marco1,hellow,dillweed,uzumymw,geraldin,loveyou2,toyota1,088011,gophers,indy500,slainte,5hsu75kpot,teejay,renat,racoon,sabrin,angie1,shiznit,harpua,sexyred,latex,tucker1,alexandru,wahoo,teamwork,deepblue,goodison,rundmc,r2d2c3p0,puppys,samba,ayrton,boobed,999777,topsecre,blowme1,123321z,loudog,random1,pantie,drevil,mandolin,121212q,hottub,brother1,failsafe,spade1,matvey,open1234,carmen1,priscill,schatzi,kajak,gooddog,trojans1,gordon1,kayak,calamity,argent,ufhvjybz,seviyi,penfold,assface,dildos,hawkwind,crowbar,yanks,ruffles,rastus,luv2epus,open123,aquafina,dawns,jared1,teufel,12345c,vwgolf,pepsi123,amores,passwerd,01478520,boliva,smutty,headshot,password3,davidd,zydfhm,gbgbcmrf,pornpass,insertion,ceckbr,test2,car123,checkit,dbnfkbq,niggas,nyyankee,muskrat,nbuhtyjr,gunner1,ocean1,fabienne,chrissy1,wendys,loveme89,batgirl,cerveza,igorek,steel1,ragman,boris123,novifarm,sexy12,qwerty777,mike01,giveitup,123456abc,fuckall,crevice,hackerz,gspot,eight8,assassins,texass,swallows,123458,baldur,moonshine,labatt,modem,sydney1,voland,dbnfkz,hotchick,jacker,princessa,dawgs1,holiday1,booper,reliant,miranda1,jamaica1,andre1,badnaamhere,barnaby,tiger7,david12,margaux,corsica,085tzzqi,universi,thewall,nevermor,martin6,qwerty77,cipher,apples1,0102030405,seraphim,black123,imzadi,gandon,ducati99,1shadow,dkflbvbhjdyf,44magnum,bigbad,feedme,samantha1,ultraman,redneck1,jackdog,usmc0311,fresh1,monique1,tigre,alphaman,cool1,greyhoun,indycar,crunchy,55chevy,carefree,willow1,063dyjuy,xrated,assclown,federica,hilfiger,trivia,bronco1,mamita,100200300,simcity,lexingky,akatsuki,retsam,johndeere,abudfv,raster,elgato,businka,satanas,mattingl,redwing1,shamil,patate,mannn,moonstar,evil666,b123456,bowl300,tanechka,34523452,carthage,babygir,santino,bondarenko,jesuss,chico1,numlock,shyguy,sound1,kirby1,needit,mostwanted,427900,funky1,steve123,passions,anduril,kermit1,prospero,lusty,barakuda,dream1,broodwar,porky,christy1,mahal,yyyyyy1,allan1,1sexy,flintsto,capri,cumeater,heretic,robert2,hippos,blindax,marykay,collecti,kasumi,1qaz!qaz,112233q,123258,chemistr,coolboy,0o9i8u,kabuki,righton,tigress,nessie,sergej,andrew12,yfafyz,ytrhjvfyn,angel7,victo,mobbdeep,lemming,transfor,1725782,myhouse,aeynbr,muskie,leno4ka,westham1,cvbhyjd,daffodil,pussylicker,pamela1,stuffer,warehous,tinker1,2w3e4r,pluton,louise1,polarbea,253634,prime1,anatoliy,januar,wysiwyg,cobraya,ralphy,whaler,xterra,cableguy,112233a,porn69,jamesd,aqualung,jimmy123,lumpy,luckyman,kingsize,golfing1,alpha7,leeds1,marigold,lol1234,teabag,alex11,10sne1,saopaulo,shanny,roland1,basser,3216732167,carol1,year2005,morozov,saturn1,joseluis,bushed,redrock,memnoch,lalaland,indiana1,lovegod,gulnaz,buffalos,loveyou1,anteater,pattaya,jaydee,redshift,bartek,summerti,coffee1,ricochet,incest,schastie,rakkaus,h2opolo,suikoden,perro,dance1,loveme1,whoopass,vladvlad,boober,flyers1,alessia,gfcgjhn,pipers,papaya,gunsling,coolone,blackie1,gonads,gfhjkzytn,foxhound,qwert12,gangrel,ghjvtntq,bluedevi,mywife,summer01,hangman,licorice,patter,vfr750,thorsten,515253,ninguna,dakine,strange1,mexic,vergeten,12345432,8phrowz624,stampede,floyd1,sailfish,raziel,ananda,giacomo,freeme,crfprf,74185296,allstars,master01,solrac,gfnhbjn,bayliner,bmw525,3465xxx,catter,single1,michael3,pentium4,nitrox,mapet123456,halibut,killroy,xxxxx1,phillip1,poopsie,arsenalfc,buffys,kosova,all4me,32165498,arslan,opensesame,brutis,charles2,pochta,nadegda,backspac,mustang0,invis,gogeta,654321q,adam25,niceday,truckin,gfdkbr,biceps,sceptre,bigdave,lauras,user345,sandys,shabba,ratdog,cristiano,natha,march13,gumball,getsdown,wasdwasd,redhead1,dddddd1,longlegs,13572468,starsky,ducksoup,bunnys,omsairam,whoami,fred123,danmark,flapper,swanky,lakings,yfhenj,asterios,rainier,searcher,dapper,ltdjxrf,horsey,seahawk,shroom,tkfkdgo,aquaman,tashkent,number9,messi10,1asshole,milenium,illumina,vegita,jodeci,buster01,bareback,goldfinger,fire1,33rjhjds,sabian,thinkpad,smooth1,sully,bonghits,sushi1,magnavox,colombi,voiture,limpone,oldone,aruba,rooster1,zhenya,nomar5,touchdow,limpbizkit,rhfcfdxbr,baphomet,afrodita,bball1,madiso,ladles,lovefeet,matthew2,theworld,thunderbird,dolly1,123rrr,forklift,alfons,berkut,speedy1,saphire,oilman,creatine,pussylov,bastard1,456258,wicked1,filimon,skyline1,fucing,yfnfkbz,hot123,abdulla,nippon,nolimits,billiard,booty1,buttplug,westlife,coolbean,aloha1,lopas,asasin,1212121,october2,whodat,good4u,d12345,kostas,ilya1992,regal,pioneer1,volodya,focus1,bastos,nbvjif,fenix,anita1,vadimka,nickle,jesusc,123321456,teste,christ1,essendon,evgenii,celticfc,adam1,forumwp,lovesme,26exkp,chillout,burly,thelast1,marcus1,metalgear,test11,ronaldo7,socrate,world1,franki,mommie,vicecity,postov1000,charlie3,oldschool,333221,legoland,antoshka,counterstrike,buggy,mustang3,123454,qwertzui,toons,chesty,bigtoe,tigger12,limpopo,rerehepf,diddle,nokia3250,solidsnake,conan1,rockroll,963369,titanic1,qwezxc,cloggy,prashant,katharin,maxfli,takashi,cumonme,michael9,mymother,pennstate,khalid,48151623,fightclub,showboat,mateusz,elrond,teenie,arrow1,mammamia,dustydog,dominator,erasmus,zxcvb1,1a2a3a,bones1,dennis1,galaxie,pleaseme,whatever1,junkyard,galadriel,charlies,2wsxzaq1,crimson1,behemoth,teres,master11,fairway,shady1,pass99,1batman,joshua12,baraban,apelsin,mousepad,melon,twodogs,123321qwe,metalica,ryjgrf,pipiska,rerfhfxf,lugnut,cretin,iloveu2,powerade,aaaaaaa1,omanko,kovalenko,isabe,chobits,151nxjmt,shadow11,zcxfcnkbdf,gy3yt2rgls,vfhbyrf,159753123,bladerunner,goodone,wonton,doodie,333666999,fuckyou123,kitty123,chisox,orlando1,skateboa,red12345,destroye,snoogans,satan1,juancarlo,goheels,jetson,scottt,fuckup,aleksa,gfhfljrc,passfind,oscar123,derrick1,hateme,viper123,pieman,audi100,tuffy,andover,shooter1,10000,makarov,grant1,nighthaw,13576479,browneye,batigol,nfvfhf,chocolate1,7hrdnw23,petter,bantam,morlii,jediknight,brenden,argonaut,goodstuf,wisconsi,315920,abigail1,dirtbag,splurge,k123456,lucky777,valdepen,gsxr600,322223,ghjnjrjk,zaq1xsw2cde3,schwanz,walter1,letmein22,nomads,124356,codeblue,nokian70,fucke,footbal1,agyvorc,aztecs,passw0r,smuggles,femmes,ballgag,krasnodar,tamuna,schule,sixtynine,empires,erfolg,dvader,ladygaga,elite1,venezuel,nitrous,kochamcie,olivia1,trustn01,arioch,sting1,131415,tristar,555000,maroon,135799,marsik,555556,fomoco,natalka,cwoui,tartan,davecole,nosferat,hotsauce,dmitry,horus,dimasik,skazka,boss302,bluebear,vesper,ultras,tarantul,asd123asd,azteca,theflash,8ball,1footbal,titlover,lucas123,number6,sampson1,789852,party1,dragon99,adonai,carwash,metropol,psychnau,vthctltc,hounds,firework,blink18,145632,wildcat1,satchel,rice80,ghtktcnm,sailor1,cubano,anderso,rocks1,mike11,famili,dfghjc,besiktas,roygbiv,nikko,bethan,minotaur,rakesh,orange12,hfleuf,jackel,myangel,favorite7,1478520,asssss,agnieszka,haley1,raisin,htubyf,1buster,cfiekz,derevo,1a2a3a4a5a,baltika,raffles,scruffy1,clitlick,louis1,buddha1,fy.nrf,walker1,makoto,shadow2,redbeard,vfvfvskfhfve,mycock,sandydog,lineman,network1,favorite8,longdick,mustangg,mavericks,indica,1killer,cisco1,angelofwar,blue69,brianna1,bubbaa,slayer666,level42,baldrick,brutus1,lowdown,haribo,lovesexy,500000,thissuck,picker,stephy,1fuckme,characte,telecast,1bigdog,repytwjdf,thematrix,hammerhe,chucha,ganesha,gunsmoke,georgi,sheltie,1harley,knulla,sallas,westie,dragon7,conker,crappie,margosha,lisboa,3e2w1q,shrike,grifter,ghjcnjghjcnj,asdfg1,mnbvcxz1,myszka,posture,boggie,rocketman,flhtyfkby,twiztid,vostok,pi314159,force1,televizor,gtkmvtym,samhain,imcool,jadzia,dreamers,strannik,k2trix,steelhea,nikitin,commodor,brian123,chocobo,whopper,ibilljpf,megafon,ararat,thomas12,ghbrjkbcn,q1234567890,hibernia,kings1,jim123,redfive,68camaro,iawgk2,xavier1,1234567u,d123456,ndirish,airborn,halfmoon,fluffy1,ranchero,sneaker,soccer2,passion1,cowman,birthday1,johnn,razzle,glock17,wsxqaz,nubian,lucky2,jelly1,henderso,eric1,123123e,boscoe01,fuck0ff,simpson1,sassie,rjyjgkz,nascar3,watashi,loredana,janus,wilso,conman,david2,mothe,iloveher,snikers,davidj,fkmnthyfnbdf,mettss,ratfink,123456h,lostsoul,sweet16,brabus,wobble,petra1,fuckfest,otters,sable1,svetka,spartacu,bigstick,milashka,1lover,pasport,champagn,papichul,hrvatska,hondacivic,kevins,tacit,moneybag,gohogs,rasta1,246813579,ytyfdbcnm,gubber,darkmoon,vitaliy,233223,playboys,tristan1,joyce1,oriflame,mugwump,access2,autocad,thematri,qweqwe123,lolwut,ibill01,multisyn,1233211,pelikan,rob123,chacal,1234432,griffon,pooch,dagestan,geisha,satriani,anjali,rocketma,gixxer,pendrago,vincen,hellokit,killyou,ruger,doodah,bumblebe,badlands,galactic,emachines,foghorn,jackso,jerem,avgust,frontera,123369,daisymae,hornyboy,welcome123,tigger01,diabl,angel13,interex,iwantsex,rockydog,kukolka,sawdust,online1,3234412,bigpapa,jewboy,3263827,dave123,riches,333222,tony1,toggle,farter,124816,tities,balle,brasilia,southsid,micke,ghbdtn12,patit,ctdfcnjgjkm,olds442,zzzzzz1,nelso,gremlins,gypsy1,carter1,slut69,farcry,7415963,michael8,birdie1,charl,123456789abc,100001,aztec,sinjin,bigpimpi,closeup,atlas1,nvidia,doggone,classic1,manana,malcolm1,rfkbyf,hotbabe,rajesh,dimebag,ganjubas,rodion,jagr68,seren,syrinx,funnyman,karapuz,123456789n,bloomin,admin18533362,biggdogg,ocarina,poopy1,hellome,internet1,booties,blowjobs,matt1,donkey1,swede,1jennife,evgeniya,lfhbyf,coach1,444777,green12,patryk,pinewood,justin12,271828,89600506779,notredame,tuborg,lemond,sk8ter,million1,wowser,pablo1,st0n3,jeeves,funhouse,hiroshi,gobucs,angeleye,bereza,winter12,catalin,qazedc,andros,ramazan,vampyre,sweethea,imperium,murat,jamest,flossy,sandeep,morgen,salamandra,bigdogg,stroller,njdevils,nutsack,vittorio,%%passwo,playful,rjyatnrf,tookie,ubnfhf,michi,777444,shadow13,devils1,radiance,toshiba1,beluga,amormi,dandfa,trust1,killemall,smallville,polgara,billyb,landscap,steves,exploite,zamboni,damage11,dzxtckfd,trader12,pokey1,kobe08,damager,egorov,dragon88,ckfdbr,lisa69,blade2,audis4,nelson1,nibbles,23176djivanfros,mutabor,artofwar,matvei,metal666,hrfzlz,schwinn,poohbea,seven77,thinker,123456789qwerty,sobriety,jakers,karamelka,vbkfyf,volodin,iddqd,dale03,roberto1,lizaveta,qqqqqq1,cathy1,08154711,davidm,quixote,bluenote,tazdevil,katrina1,bigfoot1,bublik,marma,olechka,fatpussy,marduk,arina,nonrev67,qqqq1111,camill,wtpfhm,truffle,fairview,mashina,voltaire,qazxswedcvfr,dickface,grassy,lapdance,bosstone,crazy8,yackwin,mobil,danielit,mounta1n,player69,bluegill,mewtwo,reverb,cnthdf,pablito,a123321,elena1,warcraft1,orland,ilovemyself,rfntyjr,joyride,schoo,dthjxrf,thetachi,goodtimes,blacksun,humpty,chewbacca,guyute,123xyz,lexicon,blue45,qwe789,galatasaray,centrino,hendrix1,deimos,saturn5,craig1,vlad1996,sarah123,tupelo,ljrnjh,hotwife,bingos,1231231,nicholas1,flamer,pusher,1233210,heart1,hun999,jiggy,giddyup,oktober,123456zxc,budda,galahad,glamur,samwise,oneton,bugsbunny,dominic1,scooby2,freetime,internat,159753852,sc00ter,wantit,mazinger,inflames,laracrof,greedo,014789,godofwar,repytwjd,water123,fishnet,venus1,wallace1,tenpin,paula1,1475963,mania,novikov,qwertyasdfgh,goldmine,homies,777888999,8balls,holeinon,paper1,samael,013579,mansur,nikit,ak1234,blueline,polska1,hotcock,laredo,windstar,vbkbwbz,raider1,newworld,lfybkrf,catfish1,shorty1,piranha,treacle,royale,2234562,smurfs,minion,cadence,flapjack,123456p,sydne,135531,robinhoo,nasdaq,decatur,cyberonline,newage,gemstone,jabba,touchme,hooch,pigdog,indahous,fonzie,zebra1,juggle,patrick2,nihongo,hitomi,oldnavy,qwerfdsa,ukraina,shakti,allure,kingrich,diane1,canad,piramide,hottie1,clarion,college1,5641110,connect1,therion,clubber,velcro,dave1,astra1,13579-,astroboy,skittle,isgreat,photoes,cvzefh1gkc,001100,2cool4u,7555545,ginger12,2wsxcde3,camaro69,invader,domenow,asd1234,colgate,qwertasdfg,jack123,pass01,maxman,bronte,whkzyc,peter123,bogie,yecgaa,abc321,1qay2wsx,enfield,camaroz2,trashman,bonefish,system32,azsxdcfvgb,peterose,iwantyou,dick69,temp1234,blastoff,capa200,connie1,blazin,12233445,sexybaby,123456j,brentfor,pheasant,hommer,jerryg,thunders,august1,lager,kapusta,boobs1,nokia5300,rocco1,xytfu7,stars1,tugger,123sas,blingbling,1bubba,0wnsyo0,1george,baile,richard2,habana,1diamond,sensatio,1golfer,maverick1,1chris,clinton1,michael7,dragons1,sunrise1,pissant,fatim,mopar1,levani,rostik,pizzapie,987412365,oceans11,748159263,cum4me,palmetto,4r3e2w1q,paige1,muncher,arsehole,kratos,gaffer,banderas,billys,prakash,crabby,bungie,silver12,caddis,spawn1,xboxlive,sylvania,littlebi,524645,futura,valdemar,isacs155,prettygirl,big123,555444,slimer,chicke,newstyle,skypilot,sailormoon,fatluvr69,jetaime,sitruc,jesuschrist,sameer,bear12,hellion,yendor,country1,etnies,conejo,jedimast,darkknight,toobad,yxcvbn,snooks,porn4life,calvary,alfaromeo,ghostman,yannick,fnkfynblf,vatoloco,homebase,5550666,barret,1111111111zz,odysseus,edwardss,favre4,jerrys,crybaby,xsw21qaz,firestor,spanks,indians1,squish,kingair,babycakes,haters,sarahs,212223,teddyb,xfactor,cumload,rhapsody,death123,three3,raccoon,thomas2,slayer66,1q2q3q4q5q,thebes,mysterio,thirdeye,orkiox.,nodoubt,bugsy,schweiz,dima1996,angels1,darkwing,jeronimo,moonpie,ronaldo9,peaches2,mack10,manish,denise1,fellowes,carioca,taylor12,epaulson,makemoney,oc247ngucz,kochanie,3edcvfr4,vulture,1qw23e,1234567z,munchie,picard1,xthtgfirf,sportste,psycho1,tahoe1,creativ,perils,slurred,hermit,scoob,diesel1,cards1,wipeout,weeble,integra1,out3xf,powerpc,chrism,kalle,ariadne,kailua,phatty,dexter1,fordman,bungalow,paul123,compa,train1,thejoker,jys6wz,pussyeater,eatmee,sludge,dominus,denisa,tagheuer,yxcvbnm,bill1,ghfdlf,300zx,nikita123,carcass,semaj,ramone,muenchen,animal1,greeny,annemari,dbrf134,jeepcj7,mollys,garten,sashok,ironmaid,coyotes,astoria,george12,westcoast,primetim,123456o,panchito,rafae,japan1,framer,auralo,tooshort,egorova,qwerty22,callme,medicina,warhawk,w1w2w3w4,cristia,merli,alex22,kawaii,chatte,wargames,utvols,muaddib,trinket,andreas1,jjjjj1,cleric,scooters,cuntlick,gggggg1,slipknot1,235711,handcuff,stussy,guess1,leiceste,ppppp1,passe,lovegun,chevyman,hugecock,driver1,buttsex,psychnaut1,cyber1,black2,alpha12,melbourn,man123,metalman,yjdsqujl,blondi,bungee,freak1,stomper,caitlin1,nikitina,flyaway,prikol,begood,desperad,aurelius,john1234,whosyourdaddy,slimed123,bretagne,den123,hotwheel,king123,roodypoo,izzicam,save13tx,warpten,nokia3310,samolet,ready1,coopers,scott123,bonito,1aaaaa,yomomma,dawg1,rache,itworks,asecret,fencer,451236,polka,olivetti,sysadmin,zepplin,sanjuan,479373,lickem,hondacrx,pulamea,future1,naked1,sexyguy,w4g8at,lollol1,declan,runner1,rumple,daddy123,4snz9g,grandprix,calcio,whatthefuck,nagrom,asslick,pennst,negrit,squiggy,1223334444,police22,giovann,toronto1,tweet,yardbird,seagate,truckers,554455,scimitar,pescator,slydog,gaysex,dogfish,fuck777,12332112,qazxswed,morkovka,daniela1,imback,horny69,789123456,123456789w,jimmy2,bagger,ilove69,nikolaus,atdhfkm,rebirth,1111aaaa,pervasive,gjgeufq,dte4uw,gfhnbpfy,skeletor,whitney1,walkman,delorean,disco1,555888,as1234,ishikawa,fuck12,reaper1,dmitrii,bigshot,morrisse,purgen,qwer4321,itachi,willys,123123qwe,kisska,roma123,trafford,sk84life,326159487,pedros,idiom,plover,bebop,159875321,jailbird,arrowhea,qwaszx123,zaxscdvf,catlover,bakers,13579246,bones69,vermont1,helloyou,simeon,chevyz71,funguy,stargaze,parolparol,steph1,bubby,apathy,poppet,laxman,kelly123,goodnews,741236,boner1,gaetano,astonvilla,virtua,luckyboy,rocheste,hello2u,elohim,trigger1,cstrike,pepsicola,miroslav,96385274,fistfuck,cheval,magyar,svetlanka,lbfyjxrf,mamedov,123123123q,ronaldo1,scotty1,1nicole,pittbull,fredd,bbbbb1,dagwood,gfhkfvtyn,ghblehrb,logan5,1jordan,sexbomb,omega2,montauk,258741,dtythf,gibbon,winamp,thebomb,millerli,852654,gemin,baldy,halflife2,dragon22,mulberry,morrigan,hotel6,zorglub,surfin,951159,excell,arhangel,emachine,moses1,968574,reklama,bulldog2,cuties,barca,twingo,saber,elite11,redtruck,casablan,ashish,moneyy,pepper12,cnhtktw,rjcnbr,arschloch,phenix,cachorro,sunita,madoka,joselui,adams1,mymoney,hemicuda,fyutkjr,jake12,chicas,eeeee1,sonnyboy,smarties,birdy,kitten1,cnfcbr,island1,kurosaki,taekwond,konfetka,bennett1,omega3,jackson2,fresca,minako,octavian,kban667,feyenoord,muaythai,jakedog,fktrcfylhjdyf,1357911q,phuket,sexslave,fktrcfylhjdbx,asdfjk,89015173454,qwerty00,kindbud,eltoro,sex6969,nyknicks,12344321q,caballo,evenflow,hoddle,love22,metro1,mahalko,lawdog,tightass,manitou,buckie,whiskey1,anton123,335533,password4,primo,ramair,timbo,brayden,stewie,pedro1,yorkshir,ganster,hellothe,tippy1,direwolf,genesi,rodrig,enkeli,vaz21099,sorcerer,winky,oneshot,boggle,serebro,badger1,japanes,comicbook,kamehame,alcat,denis123,echo45,sexboy,gr8ful,hondo,voetbal,blue33,2112rush,geneviev,danni1,moosey,polkmn,matthew7,ironhead,hot2trot,ashley12,sweeper,imogen,blue21,retep,stealth1,guitarra,bernard1,tatian,frankfur,vfnhbwf,slacking,haha123,963741,asdasdas,katenok,airforce1,123456789qaz,shotgun1,12qwasz,reggie1,sharo,976431,pacifica,dhip6a,neptun,kardon,spooky1,beaut,555555a,toosweet,tiedup,11121314,startac,lover69,rediska,pirata,vfhrbp,1234qwerty,energize,hansolo1,playbo,larry123,oemdlg,cnjvfnjkju,a123123,alexan,gohawks,antonius,fcbayern,mambo,yummy1,kremlin,ellen1,tremere,vfiekz,bellevue,charlie9,izabella,malishka,fermat,rotterda,dawggy,becket,chasey,kramer1,21125150,lolit,cabrio,schlong,arisha,verity,3some,favorit,maricon,travelle,hotpants,red1234,garrett1,home123,knarf,seven777,figment,asdewq,canseco,good2go,warhol,thomas01,pionee,al9agd,panacea,chevy454,brazzers,oriole,azerty123,finalfan,patricio,northsta,rebelde,bulldo,stallone,boogie1,7uftyx,cfhfnjd,compusa,cornholi,config,deere,hoopster,sepultura,grasshop,babygurl,lesbo,diceman,proverbs,reddragon,nurbek,tigerwoo,superdup,buzzsaw,kakaroto,golgo13,edwar,123qaz123,butter1,sssss1,texas2,respekt,ou812ic,123456qaz,55555a,doctor1,mcgwire,maria123,aol999,cinders,aa1234,joness,ghbrjkmyj,makemone,sammyboy,567765,380zliki,theraven,testme,mylene,elvira26,indiglo,tiramisu,shannara,baby1,123666,gfhreh,papercut,johnmish,orange8,bogey1,mustang7,bagpipes,dimarik,vsijyjr,4637324,ravage,cogito,seven11,natashka,warzone,hr3ytm,4free,bigdee,000006,243462536,bigboi,123333,trouts,sandy123,szevasz,monica2,guderian,newlife1,ratchet,r12345,razorbac,12345i,piazza31,oddjob,beauty1,fffff1,anklet,nodrog,pepit,olivi,puravida,robert12,transam1,portman,bubbadog,steelers1,wilson1,eightball,mexico1,superboy,4rfv5tgb,mzepab,samurai1,fuckslut,colleen1,girdle,vfrcbvec,q1w2e3r4t,soldier1,19844891,alyssa1,a12345a,fidelis,skelter,nolove,mickeymouse,frehley,password69,watermel,aliska,soccer15,12345e,ladybug1,abulafia,adagio,tigerlil,takehana,hecate,bootneck,junfan,arigato,wonkette,bobby123,trustnoone,phantasm,132465798,brianjo,w12345,t34vfrc1991,deadeye,1robert,1daddy,adida,check1,grimlock,muffi,airwalk,prizrak,onclick,longbeac,ernie1,eadgbe,moore1,geniu,shadow123,bugaga,jonathan1,cjrjkjdf,orlova,buldog,talon1,westport,aenima,541233432442,barsuk,chicago2,kellys,hellbent,toughguy,iskander,skoal,whatisit,jake123,scooter2,fgjrfkbgcbc,ghandi,love13,adelphia,vjhrjdrf,adrenali,niunia,jemoeder,rainbo,all4u8,anime1,freedom7,seraph,789321,tommys,antman,firetruc,neogeo,natas,bmwm3,froggy1,paul1,mamit,bayview,gateways,kusanagi,ihateu,frederi,rock1,centurion,grizli,biggin,fish1,stalker1,3girls,ilovepor,klootzak,lollo,redsox04,kirill123,jake1,pampers,vasya,hammers1,teacup,towing,celtic1,ishtar,yingyang,4904s677075,dahc1,patriot1,patrick9,redbirds,doremi,rebecc,yoohoo,makarova,epiphone,rfgbnfy,milesd,blister,chelseafc,katana1,blackrose,1james,primrose,shock5,hard1,scooby12,c6h12o6,dustoff,boing,chisel,kamil,1william,defiant1,tyvugq,mp8o6d,aaa340,nafets,sonnet,flyhigh,242526,crewcom,love23,strike1,stairway,katusha,salamand,cupcake1,password0,007james,sunnie,multisync,harley01,tequila1,fred12,driver8,q8zo8wzq,hunter01,mozzer,temporar,eatmeraw,mrbrownxx,kailey,sycamore,flogger,tincup,rahasia,ganymede,bandera,slinger,1111122222,vander,woodys,1cowboy,khaled,jamies,london12,babyboo,tzpvaw,diogenes,budice,mavrick,135797531,cheeta,macros,squonk,blackber,topfuel,apache1,falcon16,darkjedi,cheeze,vfhvtkfl,sparco,change1,gfhfif,freestyl,kukuruza,loveme2,12345f,kozlov,sherpa,marbella,44445555,bocephus,1winner,alvar,hollydog,gonefish,iwantin,barman,godislove,amanda18,rfpfynbg,eugen,abcdef1,redhawk,thelema,spoonman,baller1,harry123,475869,tigerman,cdtnjxrf,marillio,scribble,elnino,carguy,hardhead,l2g7k3,troopers,selen,dragon76,antigua,ewtosi,ulysse,astana,paroli,cristo,carmex,marjan,bassfish,letitbe,kasparov,jay123,19933991,blue13,eyecandy,scribe,mylord,ukflbjkec,ellie1,beaver1,destro,neuken,halfpint,ameli,lilly1,satanic,xngwoj,12345trewq,asdf1,bulldogg,asakura,jesucrist,flipside,packers4,biggy,kadett,biteme69,bobdog,silverfo,saint1,bobbo,packman,knowledg,foolio,fussbal,12345g,kozerog,westcoas,minidisc,nbvcxw,martini1,alastair,rasengan,superbee,memento,porker,lena123,florenc,kakadu,bmw123,getalife,bigsky,monkee,people1,schlampe,red321,memyself,0147896325,12345678900987654321,soccer14,realdeal,gfgjxrf,bella123,juggs,doritos,celtics1,peterbilt,ghbdtnbrb,gnusmas,xcountry,ghbdtn1,batman99,deusex,gtnhjdf,blablabl,juster,marimba,love2,rerjkrf,alhambra,micros,siemens1,assmaste,moonie,dashadasha,atybrc,eeeeee1,wildrose,blue55,davidl,xrp23q,skyblue,leo123,ggggg1,bestfriend,franny,1234rmvb,fun123,rules1,sebastien,chester2,hakeem,winston2,fartripper,atlant,07831505,iluvsex,q1a2z3,larrys,009900,ghjkju,capitan,rider1,qazxsw21,belochka,andy123,hellya,chicca,maximal,juergen,password1234,howard1,quetzal,daniel123,qpwoeiruty,123555,bharat,ferrari3,numbnuts,savant,ladydog,phipsi,lovepussy,etoile,power2,mitten,britneys,chilidog,08522580,2fchbg,kinky1,bluerose,loulo,ricardo1,doqvq3,kswbdu,013cpfza,timoha,ghbdtnghbdtn,3stooges,gearhead,browns1,g00ber,super7,greenbud,kitty2,pootie,toolshed,gamers,coffe,ibill123,freelove,anasazi,sister1,jigger,natash,stacy1,weronika,luzern,soccer7,hoopla,dmoney,valerie1,canes,razdvatri,washere,greenwoo,rfhjkbyf,anselm,pkxe62,maribe,daniel2,maxim1,faceoff,carbine,xtkjdtr,buddy12,stratos,jumpman,buttocks,aqswdefr,pepsis,sonechka,steeler1,lanman,nietzsch,ballz,biscuit1,wrxsti,goodfood,juventu,federic,mattman,vika123,strelec,jledfyxbr,sideshow,4life,fredderf,bigwilly,12347890,12345671,sharik,bmw325i,fylhtqrf,dannon4,marky,mrhappy,drdoom,maddog1,pompier,cerbera,goobers,howler,jenny69,evely,letitrid,cthuttdyf,felip,shizzle,golf12,t123456,yamah,bluearmy,squishy,roxan,10inches,dollface,babygirl1,blacksta,kaneda,lexingto,canadien,222888,kukushka,sistema,224422,shadow69,ppspankp,mellons,barbie1,free4all,alfa156,lostone,2w3e4r5t,painkiller,robbie1,binger,8dihc6,jaspe,rellik,quark,sogood,hoopstar,number2,snowy1,dad2ownu,cresta,qwe123asd,hjvfyjdf,gibsonsg,qbg26i,dockers,grunge,duckling,lfiekz,cuntsoup,kasia1,1tigger,woaini,reksio,tmoney,firefighter,neuron,audia3,woogie,powerboo,powermac,fatcock,12345666,upnfmc,lustful,porn1,gotlove,amylee,kbytqrf,11924704,25251325,sarasota,sexme,ozzie1,berliner,nigga1,guatemal,seagulls,iloveyou!,chicken2,qwerty21,010203040506,1pillow,libby1,vodoley,backlash,piglets,teiubesc,019283,vonnegut,perico,thunde,buckey,gtxtymrf,manunite,iiiii1,lost4815162342,madonn,270873_,britney1,kevlar,piano1,boondock,colt1911,salamat,doma77ns,anuradha,cnhjqrf,rottweil,newmoon,topgun1,mauser,fightclu,birthday21,reviewpa,herons,aassddff,lakers32,melissa2,vredina,jiujitsu,mgoblue,shakey,moss84,12345zxcvb,funsex,benji1,garci,113322,chipie,windex,nokia5310,pwxd5x,bluemax,cosita,chalupa,trotsky,new123,g3ujwg,newguy,canabis,gnaget,happydays,felixx,1patrick,cumface,sparkie,kozlova,123234,newports,broncos7,golf18,recycle,hahah,harrypot,cachondo,open4me,miria,guessit,pepsione,knocker,usmc1775,countach,playe,wiking,landrover,cracksevi,drumline,a7777777,smile123,manzana,panty,liberta,pimp69,dolfan,quality1,schnee,superson,elaine22,webhompass,mrbrownx,deepsea,4wheel,mamasita,rockport,rollie,myhome,jordan12,kfvgjxrf,hockey12,seagrave,ford1,chelsea2,samsara,marissa1,lamesa,mobil1,piotrek,tommygun,yyyyy1,wesley1,billy123,homersim,julies,amanda12,shaka,maldini,suzenet,springst,iiiiii1,yakuza,111111aa,westwind,helpdesk,annamari,bringit,hopefull,hhhhhhh1,saywhat,mazdarx8,bulova,jennife1,baikal,gfhjkmxbr,victoria1,gizmo123,alex99,defjam,2girls,sandrock,positivo,shingo,syncmast,opensesa,silicone,fuckina,senna1,karlos,duffbeer,montagne,gehrig,thetick,pepino,hamburge,paramedic,scamp,smokeweed,fabregas,phantoms,venom121293,2583458,badone,porno69,manwhore,vfvf123,notagain,vbktyf,rfnthbyrf,wildblue,kelly001,dragon66,camell,curtis1,frolova,1212123,dothedew,tyler123,reddrago,planetx,promethe,gigolo,1001001,thisone,eugeni,blackshe,cruzazul,incognito,puller,joonas,quick1,spirit1,gazza,zealot,gordito,hotrod1,mitch1,pollito,hellcat,mythos,duluth,383pdjvl,easy123,hermos,binkie,its420,lovecraf,darien,romina,doraemon,19877891,syclone,hadoken,transpor,ichiro,intell,gargamel,dragon2,wavpzt,557744,rjw7x4,jennys,kickit,rjynfrn,likeit,555111,corvus,nec3520,133113,mookie1,bochum,samsung2,locoman0,154ugeiu,vfvfbgfgf,135792,[start],tenni,20001,vestax,hufmqw,neveragain,wizkid,kjgfnf,nokia6303,tristen,saltanat,louie1,gandalf2,sinfonia,alpha3,tolstoy,ford150,f00bar,1hello,alici,lol12,riker1,hellou,333888,1hunter,qw1234,vibrator,mets86,43211234,gonzale,cookies1,sissy1,john11,bubber,blue01,cup2006,gtkmvtyb,nazareth,heybaby,suresh,teddie,mozilla,rodeo1,madhouse,gamera,123123321,naresh,dominos,foxtrot1,taras,powerup,kipling,jasonb,fidget,galena,meatman,alpacino,bookmark,farting,humper,titsnass,gorgon,castaway,dianka,anutka,gecko1,fucklove,connery,wings1,erika1,peoria,moneymaker,ichabod,heaven1,paperboy,phaser,breakers,nurse1,westbrom,alex13,brendan1,123asd123,almera,grubber,clarkie,thisisme,welkom01,51051051051,crypto,freenet,pflybwf,black12,testme2,changeit,autobahn,attica,chaoss,denver1,tercel,gnasher23,master2,vasilii,sherman1,gomer,bigbuck,derek1,qwerzxcv,jumble,dragon23,art131313,numark,beasty,cxfcnmttcnm,updown,starion,glist,sxhq65,ranger99,monkey7,shifter,wolves1,4r5t6y,phone1,favorite5,skytommy,abracada,1martin,102030405060,gatech,giulio,blacktop,cheer1,africa1,grizzly1,inkjet,shemales,durango1,booner,11223344q,supergirl,vanyarespekt,dickless,srilanka,weaponx,6string,nashvill,spicey,boxer1,fabien,2sexy2ho,bowhunt,jerrylee,acrobat,tawnee,ulisse,nolimit8,l8g3bkde,pershing,gordo1,allover,gobrowns,123432,123444,321456987,spoon1,hhhhh1,sailing1,gardenia,teache,sexmachine,tratata,pirate1,niceone,jimbos,314159265,qsdfgh,bobbyy,ccccc1,carla1,vjkjltw,savana,biotech,frigid,123456789g,dragon10,yesiam,alpha06,oakwood,tooter,winsto,radioman,vavilon,asnaeb,google123,nariman,kellyb,dthyjcnm,password6,parol1,golf72,skate1,lthtdj,1234567890s,kennet,rossia,lindas,nataliya,perfecto,eminem1,kitana,aragorn1,rexona,arsenalf,planot,coope,testing123,timex,blackbox,bullhead,barbarian,dreamon,polaris1,cfvjktn,frdfhbev,gametime,slipknot666,nomad1,hfgcjlbz,happy69,fiddler,brazil1,joeboy,indianali,113355,obelisk,telemark,ghostrid,preston1,anonim,wellcome,verizon1,sayangku,censor,timeport,dummies,adult1,nbnfybr,donger,thales,iamgay,sexy1234,deadlift,pidaras,doroga,123qwe321,portuga,asdfgh12,happys,cadr14nu,pi3141,maksik,dribble,cortland,darken,stepanova,bommel,tropic,sochi2014,bluegras,shahid,merhaba,nacho,2580456,orange44,kongen,3cudjz,78girl,my3kids,marcopol,deadmeat,gabbie,saruman,jeepman,freddie1,katie123,master99,ronal,ballbag,centauri,killer7,xqgann,pinecone,jdeere,geirby,aceshigh,55832811,pepsimax,rayden,razor1,tallyho,ewelina,coldfire,florid,glotest,999333,sevenup,bluefin,limaperu,apostol,bobbins,charmed1,michelin,sundin,centaur,alphaone,christof,trial1,lions1,45645,just4you,starflee,vicki1,cougar1,green2,jellyfis,batman69,games1,hihje863,crazyzil,w0rm1,oklick,dogbite,yssup,sunstar,paprika,postov10,124578963,x24ik3,kanada,buckster,iloveamy,bear123,smiler,nx74205,ohiostat,spacey,bigbill,doudo,nikolaeva,hcleeb,sex666,mindy1,buster11,deacons,boness,njkcnsq,candy2,cracker1,turkey1,qwertyu1,gogreen,tazzzz,edgewise,ranger01,qwerty6,blazer1,arian,letmeinnow,cigar1,jjjjjj1,grigio,frien,tenchu,f9lmwd,imissyou,filipp,heathers,coolie,salem1,woodduck,scubadiv,123kat,raffaele,nikolaev,dapzu455,skooter,9inches,lthgfhjkm,gr8one,ffffff1,zujlrf,amanda69,gldmeo,m5wkqf,rfrltkf,televisi,bonjou,paleale,stuff1,cumalot,fuckmenow,climb7,mark1234,t26gn4,oneeye,george2,utyyflbq,hunting1,tracy71,ready2go,hotguy,accessno,charger1,rudedog,kmfdm,goober1,sweetie1,wtpmjgda,dimensio,ollie1,pickles1,hellraiser,mustdie,123zzz,99887766,stepanov,verdun,tokenbad,anatol,bartende,cidkid86,onkelz,timmie,mooseman,patch1,12345678c,marta1,dummy1,bethany1,myfamily,history1,178500,lsutiger,phydeaux,moren,dbrnjhjdbx,gnbxrf,uniden,drummers,abpbrf,godboy,daisy123,hogan1,ratpack,irland,tangerine,greddy,flore,sqrunch,billyjoe,q55555,clemson1,98745632,marios,ishot,angelin,access12,naruto12,lolly,scxakv,austin12,sallad,cool99,rockit,mongo1,mark22,ghbynth,ariadna,senha,docto,tyler2,mobius,hammarby,192168,anna12,claire1,pxx3eftp,secreto,greeneye,stjabn,baguvix,satana666,rhbcnbyjxrf,dallastx,garfiel,michaelj,1summer,montan,1234ab,filbert,squids,fastback,lyudmila,chucho,eagleone,kimberle,ar3yuk3,jake01,nokids,soccer22,1066ad,ballon,cheeto,review69,madeira,taylor2,sunny123,chubbs,lakeland,striker1,porche,qwertyu8,digiview,go1234,ferari,lovetits,aditya,minnow,green3,matman,cellphon,fortytwo,minni,pucara,69a20a,roman123,fuente,12e3e456,paul12,jacky,demian,littleman,jadakiss,vlad1997,franca,282860,midian,nunzio,xaccess2,colibri,jessica0,revilo,654456,harvey1,wolf1,macarena,corey1,husky1,arsen,milleniu,852147,crowes,redcat,combat123654,hugger,psalms,quixtar,ilovemom,toyot,ballss,ilovekim,serdar,james23,avenger1,serendip,malamute,nalgas,teflon,shagger,letmein6,vyjujnjxbt,assa1234,student1,dixiedog,gznybwf13,fuckass,aq1sw2de3,robroy,hosehead,sosa21,123345,ias100,teddy123,poppin,dgl70460,zanoza,farhan,quicksilver,1701d,tajmahal,depechemode,paulchen,angler,tommy2,recoil,megamanx,scarecro,nicole2,152535,rfvtgb,skunky,fatty1,saturno,wormwood,milwauke,udbwsk,sexlover,stefa,7bgiqk,gfnhbr,omar10,bratan,lbyfvj,slyfox,forest1,jambo,william3,tempus,solitari,lucydog,murzilka,qweasdzxc1,vehpbkrf,12312345,fixit,woobie,andre123,123456789x,lifter,zinaida,soccer17,andone,foxbat,torsten,apple12,teleport,123456i,leglover,bigcocks,vologda,dodger1,martyn,d6o8pm,naciona,eagleeye,maria6,rimshot,bentley1,octagon,barbos,masaki,gremio,siemen,s1107d,mujeres,bigtits1,cherr,saints1,mrpink,simran,ghzybr,ferrari2,secret12,tornado1,kocham,picolo,deneme,onelove1,rolan,fenster,1fuckyou,cabbie,pegaso,nastyboy,password5,aidana,mine2306,mike13,wetone,tigger69,ytreza,bondage1,myass,golova,tolik,happyboy,poilkj,nimda2k,rammer,rubies,hardcore1,jetset,hoops1,jlaudio,misskitt,1charlie,google12,theone1,phred,porsch,aalborg,luft4,charlie5,password7,gnosis,djgabbab,1daniel,vinny,borris,cumulus,member1,trogdor,darthmau,andrew2,ktjybl,relisys,kriste,rasta220,chgobndg,weener,qwerty66,fritter,followme,freeman1,ballen,blood1,peache,mariso,trevor1,biotch,gtfullam,chamonix,friendste,alligato,misha1,1soccer,18821221,venkat,superd,molotov,bongos,mpower,acun3t1x,dfcmrf,h4x3d,rfhfufylf,tigran,booyaa,plastic1,monstr,rfnhby,lookatme,anabolic,tiesto,simon123,soulman,canes1,skyking,tomcat1,madona,bassline,dasha123,tarheel1,dutch1,xsw23edc,qwerty123456789,imperator,slaveboy,bateau,paypal,house123,pentax,wolf666,drgonzo,perros,digger1,juninho,hellomoto,bladerun,zzzzzzz1,keebler,take8422,fffffff1,ginuwine,israe,caesar1,crack1,precious1,garand,magda1,zigazaga,321ewq,johnpaul,mama1234,iceman69,sanjeev,treeman,elric,rebell,1thunder,cochon,deamon,zoltan,straycat,uhbyuj,luvfur,mugsy,primer,wonder1,teetime,candycan,pfchfytw,fromage,gitler,salvatio,piggy1,23049307,zafira,chicky,sergeev,katze,bangers,andriy,jailbait,vaz2107,ghbhjlf,dbjktnnf,aqswde,zaratustra,asroma,1pepper,alyss,kkkkk1,ryan1,radish,cozumel,waterpol,pentium1,rosebowl,farmall,steinway,dbrekz,baranov,jkmuf,another1,chinacat,qqqqqqq1,hadrian,devilmaycry4,ratbag,teddy2,love21,pullings,packrat,robyn1,boobo,qw12er34,tribe1,rosey,celestia,nikkie,fortune12,olga123,danthema,gameon,vfrfhjys,dilshod,henry14,jenova,redblue,chimaera,pennywise,sokrates,danimal,qqaazz,fuaqz4,killer2,198200,tbone1,kolyan,wabbit,lewis1,maxtor,egoist,asdfas,spyglass,omegas,jack12,nikitka,esperanz,doozer,matematika,wwwww1,ssssss1,poiu0987,suchka,courtney1,gungho,alpha2,fktyjxrf,summer06,bud420,devildriver,heavyd,saracen,foucault,choclate,rjdfktyrj,goblue1,monaro,jmoney,dcpugh,efbcapa201,qqh92r,pepsicol,bbb747,ch5nmk,honeyb,beszoptad,tweeter,intheass,iseedeadpeople,123dan,89231243658s,farside1,findme,smiley1,55556666,sartre,ytcnjh,kacper,costarica,134679258,mikeys,nolimit9,vova123,withyou,5rxypn,love143,freebie,rescue1,203040,michael6,12monkey,redgreen,steff,itstime,naveen,good12345,acidrain,1dawg,miramar,playas,daddio,orion2,852741,studmuff,kobe24,senha123,stephe,mehmet,allalone,scarface1,helloworld,smith123,blueyes,vitali,memphis1,mybitch,colin1,159874,1dick,podaria,d6wnro,brahms,f3gh65,dfcbkmtd,xxxman,corran,ugejvp,qcfmtz,marusia,totem,arachnid,matrix2,antonell,fgntrf,zemfira,christos,surfing1,naruto123,plato1,56qhxs,madzia,vanille,043aaa,asq321,mutton,ohiostate,golde,cdznjckfd,rhfcysq,green5,elephan,superdog,jacqueli,bollock,lolitas,nick12,1orange,maplelea,july23,argento,waldorf,wolfer,pokemon12,zxcvbnmm,flicka,drexel,outlawz,harrie,atrain,juice2,falcons1,charlie6,19391945,tower1,dragon21,hotdamn,dirtyboy,love4ever,1ginger,thunder2,virgo1,alien1,bubblegu,4wwvte,123456789qqq,realtime,studio54,passss,vasilek,awsome,giorgia,bigbass,2002tii,sunghile,mosdef,simbas,count0,uwrl7c,summer05,lhepmz,ranger21,sugarbea,principe,5550123,tatanka,9638v,cheerios,majere,nomercy,jamesbond007,bh90210,7550055,jobber,karaganda,pongo,trickle,defamer,6chid8,1q2a3z,tuscan,nick123,.adgjm,loveyo,hobbes1,note1234,shootme,171819,loveporn,9788960,monty123,fabrice,macduff,monkey13,shadowfa,tweeker,hanna1,madball,telnet,loveu2,qwedcxzas,thatsit,vfhcbr,ptfe3xxp,gblfhfcs,ddddddd1,hakkinen,liverune,deathsta,misty123,suka123,recon1,inferno1,232629,polecat,sanibel,grouch,hitech,hamradio,rkfdbfnehf,vandam,nadin,fastlane,shlong,iddqdidkfa,ledzeppelin,sexyfeet,098123,stacey1,negras,roofing,lucifer1,ikarus,tgbyhn,melnik,barbaria,montego,twisted1,bigal1,jiggle,darkwolf,acerview,silvio,treetops,bishop1,iwanna,pornsite,happyme,gfccdjhl,114411,veritech,batterse,casey123,yhntgb,mailto,milli,guster,q12345678,coronet,sleuth,fuckmeha,armadill,kroshka,geordie,lastochka,pynchon,killall,tommy123,sasha1996,godslove,hikaru,clticic,cornbrea,vfkmdbyf,passmaster,123123123a,souris,nailer,diabolo,skipjack,martin12,hinata,mof6681,brookie,dogfight,johnso,karpov,326598,rfvbrflpt,travesti,caballer,galaxy1,wotan,antoha,art123,xakep1234,ricflair,pervert1,p00kie,ambulanc,santosh,berserker,larry33,bitch123,a987654321,dogstar,angel22,cjcbcrf,redhouse,toodles,gold123,hotspot,kennedy1,glock21,chosen1,schneide,mainman,taffy1,3ki42x,4zqauf,ranger2,4meonly,year2000,121212a,kfylsi,netzwerk,diese,picasso1,rerecz,225522,dastan,swimmer1,brooke1,blackbea,oneway,ruslana,dont4get,phidelt,chrisp,gjyxbr,xwing,kickme,shimmy,kimmy1,4815162342lost,qwerty5,fcporto,jazzbo,mierd,252627,basses,sr20det,00133,florin,howdy1,kryten,goshen,koufax,cichlid,imhotep,andyman,wrest666,saveme,dutchy,anonymou,semprini,siempre,mocha1,forest11,wildroid,aspen1,sesam,kfgekz,cbhbec,a55555,sigmanu,slash1,giggs11,vatech,marias,candy123,jericho1,kingme,123a123,drakula,cdjkjxm,mercur,oneman,hoseman,plumper,ilovehim,lancers,sergey1,takeshi,goodtogo,cranberr,ghjcnj123,harvick,qazxs,1972chev,horsesho,freedom3,letmein7,saitek,anguss,vfvfgfgfz,300000,elektro,toonporn,999111999q,mamuka,q9umoz,edelweis,subwoofer,bayside,disturbe,volition,lucky3,12345678z,3mpz4r,march1,atlantida,strekoza,seagrams,090909t,yy5rbfsc,jack1234,sammy12,sampras,mark12,eintrach,chaucer,lllll1,nochance,whitepower,197000,lbvekz,passer,torana,12345as,pallas,koolio,12qw34,nokia8800,findout,1thomas,mmmmm1,654987,mihaela,chinaman,superduper,donnas,ringo1,jeroen,gfdkjdf,professo,cdtnrf,tranmere,tanstaaf,himera,ukflbfnjh,667788,alex32,joschi,w123456,okidoki,flatline,papercli,super8,doris1,2good4u,4z34l0ts,pedigree,freeride,gsxr1100,wulfgar,benjie,ferdinan,king1,charlie7,djdxbr,fhntvbq,ripcurl,2wsx1qaz,kingsx,desade,sn00py,loveboat,rottie,evgesha,4money,dolittle,adgjmpt,buzzers,brett1,makita,123123qweqwe,rusalka,sluts1,123456e,jameson1,bigbaby,1z2z3z,ckjybr,love4u,fucker69,erhfbyf,jeanluc,farhad,fishfood,merkin,giant1,golf69,rfnfcnhjaf,camera1,stromb,smoothy,774411,nylon,juice1,rfn.irf,newyor,123456789t,marmot,star11,jennyff,jester1,hisashi,kumquat,alex777,helicopt,merkur,dehpye,cummin,zsmj2v,kristjan,april12,englan,honeypot,badgirls,uzumaki,keines,p12345,guita,quake1,duncan1,juicer,milkbone,hurtme,123456789b,qq123456789,schwein,p3wqaw,54132442,qwertyytrewq,andreeva,ruffryde,punkie,abfkrf,kristinka,anna1987,ooooo1,335533aa,umberto,amber123,456123789,456789123,beelch,manta,peeker,1112131415,3141592654,gipper,wrinkle5,katies,asd123456,james11,78n3s5af,michael0,daboss,jimmyb,hotdog1,david69,852123,blazed,sickan,eljefe,2n6wvq,gobills,rfhfcm,squeaker,cabowabo,luebri,karups,test01,melkor,angel777,smallvil,modano,olorin,4rkpkt,leslie1,koffie,shadows1,littleon,amiga1,topeka,summer20,asterix1,pitstop,aloysius,k12345,magazin,joker69,panocha,pass1word,1233214,ironpony,368ejhih,88keys,pizza123,sonali,57np39,quake2,1234567890qw,1020304,sword1,fynjif,abcde123,dfktyjr,rockys,grendel1,harley12,kokakola,super2,azathoth,lisa123,shelley1,girlss,ibragim,seven1,jeff24,1bigdick,dragan,autobot,t4nvp7,omega123,900000,hecnfv,889988,nitro1,doggie1,fatjoe,811pahc,tommyt,savage1,pallino,smitty1,jg3h4hfn,jamielee,1qazwsx,zx123456,machine1,asdfgh123,guinnes,789520,sharkman,jochen,legend1,sonic2,extreme1,dima12,photoman,123459876,nokian95,775533,vaz2109,april10,becks,repmvf,pooker,qwer12345,themaster,nabeel,monkey10,gogetit,hockey99,bbbbbbb1,zinedine,dolphin2,anelka,1superma,winter01,muggsy,horny2,669966,kuleshov,jesusis,calavera,bullet1,87t5hdf,sleepers,winkie,vespa,lightsab,carine,magister,1spider,shitbird,salavat,becca1,wc18c2,shirak,galactus,zaskar,barkley1,reshma,dogbreat,fullsail,asasa,boeder,12345ta,zxcvbnm12,lepton,elfquest,tony123,vkaxcs,savatage,sevilia1,badkitty,munkey,pebbles1,diciembr,qapmoc,gabriel2,1qa2ws3e,cbcmrb,welldone,nfyufh,kaizen,jack11,manisha,grommit,g12345,maverik,chessman,heythere,mixail,jjjjjjj1,sylvia1,fairmont,harve,skully,global1,youwish,pikachu1,badcat,zombie1,49527843,ultra1,redrider,offsprin,lovebird,153426,stymie,aq1sw2,sorrento,0000001,r3ady41t,webster1,95175,adam123,coonass,159487,slut1,gerasim,monkey99,slutwife,159963,1pass1page,hobiecat,bigtymer,all4you,maggie2,olamide,comcast1,infinit,bailee,vasileva,.ktxrf,asdfghjkl1,12345678912,setter,fuckyou7,nnagqx,lifesuck,draken,austi,feb2000,cable1,1234qwerasdf,hax0red,zxcv12,vlad7788,nosaj,lenovo,underpar,huskies1,lovegirl,feynman,suerte,babaloo,alskdjfhg,oldsmobi,bomber1,redrover,pupuce,methodman,phenom,cutegirl,countyli,gretsch,godisgood,bysunsu,hardhat,mironova,123qwe456rty,rusty123,salut,187211,555666777,11111z,mahesh,rjntyjxtr,br00klyn,dunce1,timebomb,bovine,makelove,littlee,shaven,rizwan,patrick7,42042042,bobbijo,rustem,buttmunc,dongle,tiger69,bluecat,blackhol,shirin,peaces,cherub,cubase,longwood,lotus7,gwju3g,bruin,pzaiu8,green11,uyxnyd,seventee,dragon5,tinkerbel,bluess,bomba,fedorova,joshua2,bodyshop,peluche,gbpacker,shelly1,d1i2m3a4,ghtpbltyn,talons,sergeevna,misato,chrisc,sexmeup,brend,olddog,davros,hazelnut,bridget1,hzze929b,readme,brethart,wild1,ghbdtnbr1,nortel,kinger,royal1,bucky1,allah1,drakkar,emyeuanh,gallaghe,hardtime,jocker,tanman,flavio,abcdef123,leviatha,squid1,skeet,sexse,123456x,mom4u4mm,lilred,djljktq,ocean11,cadaver,baxter1,808state,fighton,primavera,1andrew,moogle,limabean,goddess1,vitalya,blue56,258025,bullride,cicci,1234567d,connor1,gsxr11,oliveoil,leonard1,legsex,gavrik,rjnjgtc,mexicano,2bad4u,goodfellas,ornw6d,mancheste,hawkmoon,zlzfrh,schorsch,g9zns4,bashful,rossi46,stephie,rfhfntkm,sellout,123fuck,stewar1,solnze,00007,thor5200,compaq12,didit,bigdeal,hjlbyf,zebulon,wpf8eu,kamran,emanuele,197500,carvin,ozlq6qwm,3syqo15hil,pennys,epvjb6,asdfghjkl123,198000,nfbcbz,jazzer,asfnhg66,zoloft,albundy,aeiou,getlaid,planet1,gjkbyjxrf,alex2000,brianb,moveon,maggie11,eieio,vcradq,shaggy1,novartis,cocoloco,dunamis,554uzpad,sundrop,1qwertyu,alfie,feliks,briand,123www,red456,addams,fhntv1998,goodhead,theway,javaman,angel01,stratoca,lonsdale,15987532,bigpimpin,skater1,issue43,muffie,yasmina,slowride,crm114,sanity729,himmel,carolcox,bustanut,parabola,masterlo,computador,crackhea,dynastar,rockbott,doggysty,wantsome,bigten,gaelle,juicy1,alaska1,etower,sixnine,suntan,froggies,nokia7610,hunter11,njnets,alicante,buttons1,diosesamo,elizabeth1,chiron,trustnoo,amatuers,tinytim,mechta,sammy2,cthulu,trs8f7,poonam,m6cjy69u35,cookie12,blue25,jordans,santa1,kalinka,mikey123,lebedeva,12345689,kissss,queenbee,vjybnjh,ghostdog,cuckold,bearshare,rjcntyrj,alinochka,ghjcnjrdfibyj,aggie1,teens1,3qvqod,dauren,tonino,hpk2qc,iqzzt580,bears85,nascar88,theboy,njqcw4,masyanya,pn5jvw,intranet,lollone,shadow99,00096462,techie,cvtifhbrb,redeemed,gocanes,62717315,topman,intj3a,cobrajet,antivirus,whyme,berserke,ikilz083,airedale,brandon2,hopkig,johanna1,danil8098,gojira,arthu,vision1,pendragon,milen,chrissie,vampiro,mudder,chris22,blowme69,omega7,surfers,goterps,italy1,baseba11,diego1,gnatsum,birdies,semenov,joker123,zenit2011,wojtek,cab4ma99,watchmen,damia,forgotte,fdm7ed,strummer,freelanc,cingular,orange77,mcdonalds,vjhjpjdf,kariya,tombston,starlet,hawaii1,dantheman,megabyte,nbvjirf,anjing,ybrjkftdbx,hotmom,kazbek,pacific1,sashimi,asd12,coorslig,yvtte545,kitte,elysium,klimenko,cobblers,kamehameha,only4me,redriver,triforce,sidorov,vittoria,fredi,dank420,m1234567,fallout2,989244342a,crazy123,crapola,servus,volvos,1scooter,griffin1,autopass,ownzyou,deviant,george01,2kgwai,boeing74,simhrq,hermosa,hardcor,griffy,rolex1,hackme,cuddles1,master3,bujhtr,aaron123,popolo,blader,1sexyred,gerry1,cronos,ffvdj474,yeehaw,bob1234,carlos2,mike77,buckwheat,ramesh,acls2h,monster2,montess,11qq22ww,lazer,zx123456789,chimpy,masterch,sargon,lochness,archana,1234qwert,hbxfhl,sarahb,altoid,zxcvbn12,dakot,caterham,dolomite,chazz,r29hqq,longone,pericles,grand1,sherbert,eagle3,pudge,irontree,synapse,boome,nogood,summer2,pooki,gangsta1,mahalkit,elenka,lbhtrnjh,dukedog,19922991,hopkins1,evgenia,domino1,x123456,manny1,tabbycat,drake1,jerico,drahcir,kelly2,708090a,facesit,11c645df,mac123,boodog,kalani,hiphop1,critters,hellothere,tbirds,valerka,551scasi,love777,paloalto,mrbrown,duke3d,killa1,arcturus,spider12,dizzy1,smudger,goddog,75395,spammy,1357997531,78678,datalife,zxcvbn123,1122112211,london22,23dp4x,rxmtkp,biggirls,ownsu,lzbs2twz,sharps,geryfe,237081a,golakers,nemesi,sasha1995,pretty1,mittens1,d1lakiss,speedrac,gfhjkmm,sabbat,hellrais,159753258,qwertyuiop123,playgirl,crippler,salma,strat1,celest,hello5,omega5,cheese12,ndeyl5,edward12,soccer3,cheerio,davido,vfrcbr,gjhjctyjr,boscoe,inessa,shithole,ibill,qwepoi,201jedlz,asdlkj,davidk,spawn2,ariel1,michael4,jamie123,romantik,micro1,pittsbur,canibus,katja,muhtar,thomas123,studboy,masahiro,rebrov,patrick8,hotboys,sarge1,1hammer,nnnnn1,eistee,datalore,jackdani,sasha2010,mwq6qlzo,cmfnpu,klausi,cnhjbntkm,andrzej,ilovejen,lindaa,hunter123,vvvvv1,novembe,hamster1,x35v8l,lacey1,1silver,iluvporn,valter,herson,alexsandr,cojones,backhoe,womens,777angel,beatit,klingon1,ta8g4w,luisito,benedikt,maxwel,inspecto,zaq12ws,wladimir,bobbyd,peterj,asdfg12,hellspawn,bitch69,nick1234,golfer23,sony123,jello1,killie,chubby1,kodaira52,yanochka,buckfast,morris1,roaddogg,snakeeye,sex1234,mike22,mmouse,fucker11,dantist,brittan,vfrfhjdf,doc123,plokijuh,emerald1,batman01,serafim,elementa,soccer9,footlong,cthuttdbx,hapkido,eagle123,getsmart,getiton,batman2,masons,mastiff,098890,cfvfhf,james7,azalea,sherif,saun24865709,123red,cnhtrjpf,martina1,pupper,michael5,alan12,shakir,devin1,ha8fyp,palom,mamulya,trippy,deerhunter,happyone,monkey77,3mta3,123456789f,crownvic,teodor,natusik,0137485,vovchik,strutter,triumph1,cvetok,moremone,sonnen,screwbal,akira1,sexnow,pernille,independ,poopies,samapi,kbcbxrf,master22,swetlana,urchin,viper2,magica,slurpee,postit,gilgames,kissarmy,clubpenguin,limpbizk,timber1,celin,lilkim,fuckhard,lonely1,mom123,goodwood,extasy,sdsadee23,foxglove,malibog,clark1,casey2,shell1,odense,balefire,dcunited,cubbie,pierr,solei,161718,bowling1,areyukesc,batboy,r123456,1pionee,marmelad,maynard1,cn42qj,cfvehfq,heathrow,qazxcvbn,connecti,secret123,newfie,xzsawq21,tubitzen,nikusha,enigma1,yfcnz123,1austin,michaelc,splunge,wanger,phantom2,jason2,pain4me,primetime21,babes1,liberte,sugarray,undergro,zonker,labatts,djhjyf,watch1,eagle5,madison2,cntgfirf,sasha2,masterca,fiction7,slick50,bruins1,sagitari,12481632,peniss,insuranc,2b8riedt,12346789,mrclean,ssptx452,tissot,q1w2e3r4t5y6u7,avatar1,comet1,spacer,vbrjkf,pass11,wanker1,14vbqk9p,noshit,money4me,sayana,fish1234,seaways,pipper,romeo123,karens,wardog,ab123456,gorilla1,andrey123,lifesucks,jamesr,4wcqjn,bearman,glock22,matt11,dflbvrf,barbi,maine1,dima1997,sunnyboy,6bjvpe,bangkok1,666666q,rafiki,letmein0,0raziel0,dalla,london99,wildthin,patrycja,skydog,qcactw,tmjxn151,yqlgr667,jimmyd,stripclub,deadwood,863abgsg,horses1,qn632o,scatman,sonia1,subrosa,woland,kolya,charlie4,moleman,j12345,summer11,angel11,blasen,sandal,mynewpas,retlaw,cambria,mustang4,nohack04,kimber45,fatdog,maiden1,bigload,necron,dupont24,ghost123,turbo2,.ktymrf,radagast,balzac,vsevolod,pankaj,argentum,2bigtits,mamabear,bumblebee,mercury7,maddie1,chomper,jq24nc,snooky,pussylic,1lovers,taltos,warchild,diablo66,jojo12,sumerki,aventura,gagger,annelies,drumset,cumshots,azimut,123580,clambake,bmw540,birthday54,psswrd,paganini,wildwest,filibert,teaseme,1test,scampi,thunder5,antosha,purple12,supersex,hhhhhh1,brujah,111222333a,13579a,bvgthfnjh,4506802a,killians,choco,qqqwwweee,raygun,1grand,koetsu13,sharp1,mimi92139,fastfood,idontcare,bluered,chochoz,4z3al0ts,target1,sheffiel,labrat,stalingrad,147123,cubfan,corvett1,holden1,snapper1,4071505,amadeo,pollo,desperados,lovestory,marcopolo,mumbles,familyguy,kimchee,marcio,support1,tekila,shygirl1,trekkie,submissi,ilaria,salam,loveu,wildstar,master69,sales1,netware,homer2,arseniy,gerrity1,raspberr,atreyu,stick1,aldric,tennis12,matahari,alohomora,dicanio,michae1,michaeld,666111,luvbug,boyscout,esmerald,mjordan,admiral1,steamboa,616913,ybhdfyf,557711,555999,sunray,apokalipsis,theroc,bmw330,buzzy,chicos,lenusik,shadowma,eagles05,444222,peartree,qqq123,sandmann,spring1,430799,phatass,andi03,binky1,arsch,bamba,kenny123,fabolous,loser123,poop12,maman,phobos,tecate,myxworld4,metros,cocorico,nokia6120,johnny69,hater,spanked,313233,markos,love2011,mozart1,viktoriy,reccos,331234,hornyone,vitesse,1um83z,55555q,proline,v12345,skaven,alizee,bimini,fenerbahce,543216,zaqqaz,poi123,stabilo,brownie1,1qwerty1,dinesh,baggins1,1234567t,davidkin,friend1,lietuva,octopuss,spooks,12345qq,myshit,buttface,paradoxx,pop123,golfin,sweet69,rfghbp,sambuca,kayak1,bogus1,girlz,dallas12,millers,123456zx,operatio,pravda,eternal1,chase123,moroni,proust,blueduck,harris1,redbarch,996699,1010101,mouche,millenni,1123456,score1,1234565,1234576,eae21157,dave12,pussyy,gfif1991,1598741,hoppy,darrian,snoogins,fartface,ichbins,vfkbyrf,rusrap,2741001,fyfrjylf,aprils,favre,thisis,bannana,serval,wiggum,satsuma,matt123,ivan123,gulmira,123zxc123,oscar2,acces,annie2,dragon0,emiliano,allthat,pajaro,amandine,rawiswar,sinead,tassie,karma1,piggys,nokias,orions,origami,type40,mondo,ferrets,monker,biteme2,gauntlet,arkham,ascona,ingram01,klem1,quicksil,bingo123,blue66,plazma,onfire,shortie,spjfet,123963,thered,fire777,lobito,vball,1chicken,moosehea,elefante,babe23,jesus12,parallax,elfstone,number5,shrooms,freya,hacker1,roxette,snoops,number7,fellini,dtlmvf,chigger,mission1,mitsubis,kannan,whitedog,james01,ghjgecr,rfnfgekmnf,everythi,getnaked,prettybo,sylvan,chiller,carrera4,cowbo,biochem,azbuka,qwertyuiop1,midnight1,informat,audio1,alfred1,0range,sucker1,scott2,russland,1eagle,torben,djkrjlfd,rocky6,maddy1,bonobo,portos,chrissi,xjznq5,dexte,vdlxuc,teardrop,pktmxr,iamtheone,danijela,eyphed,suzuki1,etvww4,redtail,ranger11,mowerman,asshole2,coolkid,adriana1,bootcamp,longcut,evets,npyxr5,bighurt,bassman1,stryder,giblet,nastja,blackadd,topflite,wizar,cumnow,technolo,bassboat,bullitt,kugm7b,maksimus,wankers,mine12,sunfish,pimpin1,shearer9,user1,vjzgjxnf,tycobb,80070633pc,stanly,vitaly,shirley1,cinzia,carolyn1,angeliqu,teamo,qdarcv,aa123321,ragdoll,bonit,ladyluck,wiggly,vitara,jetbalance,12345600,ozzman,dima12345,mybuddy,shilo,satan66,erebus,warrio,090808qwe,stupi,bigdan,paul1234,chiapet,brooks1,philly1,dually,gowest,farmer1,1qa2ws3ed4rf,alberto1,beachboy,barne,aa12345,aliyah,radman,benson1,dfkthbq,highball,bonou2,i81u812,workit,darter,redhook,csfbr5yy,buttlove,episode1,ewyuza,porthos,lalal,abcd12,papero,toosexy,keeper1,silver7,jujitsu,corset,pilot123,simonsay,pinggolf,katerinka,kender,drunk1,fylhjvtlf,rashmi,nighthawk,maggy,juggernaut,larryb,cabibble,fyabcf,247365,gangstar,jaybee,verycool,123456789qw,forbidde,prufrock,12345zxc,malaika,blackbur,docker,filipe,koshechka,gemma1,djamaal,dfcbkmtdf,gangst,9988aa,ducks1,pthrfkj,puertorico,muppets,griffins,whippet,sauber,timofey,larinso,123456789zxc,quicken,qsefth,liteon,headcase,bigdadd,zxc321,maniak,jamesc,bassmast,bigdogs,1girls,123xxx,trajan,lerochka,noggin,mtndew,04975756,domin,wer123,fumanchu,lambada,thankgod,june22,kayaking,patchy,summer10,timepass,poiu1234,kondor,kakka,lament,zidane10,686xqxfg,l8v53x,caveman1,nfvthkfy,holymoly,pepita,alex1996,mifune,fighter1,asslicker,jack22,abc123abc,zaxxon,midnigh,winni,psalm23,punky,monkey22,password13,mymusic,justyna,annushka,lucky5,briann,495rus19,withlove,almaz,supergir,miata,bingbong,bradpitt,kamasutr,yfgjktjy,vanman,pegleg,amsterdam1,123a321,letmein9,shivan,korona,bmw520,annette1,scotsman,gandal,welcome12,sc00by,qpwoei,fred69,m1sf1t,hamburg1,1access,dfkmrbhbz,excalibe,boobies1,fuckhole,karamel,starfuck,star99,breakfas,georgiy,ywvxpz,smasher,fatcat1,allanon,12345n,coondog,whacko,avalon1,scythe,saab93,timon,khorne,atlast,nemisis,brady12,blenheim,52678677,mick7278,9skw5g,fleetwoo,ruger1,kissass,pussy7,scruff,12345l,bigfun,vpmfsz,yxkck878,evgeny,55667788,lickher,foothill,alesis,poppies,77777778,californi,mannie,bartjek,qhxbij,thehulk,xirt2k,angelo4ek,rfkmrekznjh,tinhorse,1david,sparky12,night1,luojianhua,bobble,nederland,rosemari,travi,minou,ciscokid,beehive,565hlgqo,alpine1,samsung123,trainman,xpress,logistic,vw198m2n,hanter,zaqwsx123,qwasz,mariachi,paska,kmg365,kaulitz,sasha12,north1,polarbear,mighty1,makeksa11,123456781,one4all,gladston,notoriou,polniypizdec110211,gosia,grandad,xholes,timofei,invalidp,speaker1,zaharov,maggiema,loislane,gonoles,br5499,discgolf,kaskad,snooper,newman1,belial,demigod,vicky1,pridurok,alex1990,tardis1,cruzer,hornie,sacramen,babycat,burunduk,mark69,oakland1,me1234,gmctruck,extacy,sexdog,putang,poppen,billyd,1qaz2w,loveable,gimlet,azwebitalia,ragtop,198500,qweas,mirela,rock123,11bravo,sprewell,tigrenok,jaredleto,vfhbif,blue2,rimjob,catwalk,sigsauer,loqse,doromich,jack01,lasombra,jonny5,newpassword,profesor,garcia1,123as123,croucher,demeter,4_life,rfhfvtkm,superman2,rogues,assword1,russia1,jeff1,mydream,z123456789,rascal1,darre,kimberl,pickle1,ztmfcq,ponchik,lovesporn,hikari,gsgba368,pornoman,chbjun,choppy,diggity,nightwolf,viktori,camar,vfhecmrf,alisa1,minstrel,wishmaster,mulder1,aleks,gogirl,gracelan,8womys,highwind,solstice,dbrnjhjdyf,nightman,pimmel,beertje,ms6nud,wwfwcw,fx3tuo,poopface,asshat,dirtyd,jiminy,luv2fuck,ptybnxtvgbjy,dragnet,pornogra,10inch,scarlet1,guido1,raintree,v123456,1aaaaaaa,maxim1935,hotwater,gadzooks,playaz,harri,brando1,defcon1,ivanna,123654a,arsenal2,candela,nt5d27,jaime1,duke1,burton1,allstar1,dragos,newpoint,albacore,1236987z,verygoodbot,1wildcat,fishy1,ptktysq,chris11,puschel,itdxtyrj,7kbe9d,serpico,jazzie,1zzzzz,kindbuds,wenef45313,1compute,tatung,sardor,gfyfcjybr,test99,toucan,meteora,lysander,asscrack,jowgnx,hevnm4,suckthis,masha123,karinka,marit,oqglh565,dragon00,vvvbbb,cheburashka,vfrfrf,downlow,unforgiven,p3e85tr,kim123,sillyboy,gold1,golfvr6,quicksan,irochka,froglegs,shortsto,caleb1,tishka,bigtitts,smurfy,bosto,dropzone,nocode,jazzbass,digdug,green7,saltlake,therat,dmitriev,lunita,deaddog,summer0,1212qq,bobbyg,mty3rh,isaac1,gusher,helloman,sugarbear,corvair,extrem,teatime,tujazopi,titanik,efyreg,jo9k2jw2,counchac,tivoli,utjvtnhbz,bebit,jacob6,clayton1,incubus1,flash123,squirter,dima2010,cock1,rawks,komatsu,forty2,98741236,cajun1,madelein,mudhoney,magomed,q111111,qaswed,consense,12345b,bakayaro,silencer,zoinks,bigdic,werwolf,pinkpuss,96321478,alfie1,ali123,sarit,minette,musics,chato,iaapptfcor,cobaka,strumpf,datnigga,sonic123,yfnecbr,vjzctvmz,pasta1,tribbles,crasher,htlbcrf,1tiger,shock123,bearshar,syphon,a654321,cubbies1,jlhanes,eyespy,fucktheworld,carrie1,bmw325is,suzuk,mander,dorina,mithril,hondo1,vfhnbyb,sachem,newton1,12345x,7777755102q,230857z,xxxsex,scubapro,hayastan,spankit,delasoul,searock6,fallout3,nilrem,24681357,pashka,voluntee,pharoh,willo,india1,badboy69,roflmao,gunslinger,lovergir,mama12,melange,640xwfkv,chaton,darkknig,bigman1,aabbccdd,harleyd,birdhouse,giggsy,hiawatha,tiberium,joker7,hello1234,sloopy,tm371855,greendog,solar1,bignose,djohn11,espanol,oswego,iridium,kavitha,pavell,mirjam,cyjdsvujljv,alpha5,deluge,hamme,luntik,turismo,stasya,kjkbnf,caeser,schnecke,tweety1,tralfaz,lambrett,prodigy1,trstno1,pimpshit,werty1,karman,bigboob,pastel,blackmen,matthew8,moomin,q1w2e,gilly,primaver,jimmyg,house2,elviss,15975321,1jessica,monaliza,salt55,vfylfhbyrf,harley11,tickleme,murder1,nurgle,kickass1,theresa1,fordtruck,pargolf,managua,inkognito,sherry1,gotit,friedric,metro2033,slk230,freeport,cigarett,492529,vfhctkm,thebeach,twocats,bakugan,yzerman1,charlieb,motoko,skiman,1234567w,pussy3,love77,asenna,buffie,260zntpc,kinkos,access20,mallard1,fuckyou69,monami,rrrrr1,bigdog69,mikola,1boomer,godzila,ginger2,dima2000,skorpion39,dima1234,hawkdog79,warrior2,ltleirf,supra1,jerusale,monkey01,333z333,666888,kelsey1,w8gkz2x1,fdfnfh,msnxbi,qwe123rty,mach1,monkey3,123456789qq,c123456,nezabudka,barclays,nisse,dasha1,12345678987654321,dima1993,oldspice,frank2,rabbitt,prettyboy,ov3ajy,iamthema,kawasak,banjo1,gtivr6,collants,gondor,hibees,cowboys2,codfish,buster2,purzel,rubyred,kayaker,bikerboy,qguvyt,masher,sseexx,kenshiro,moonglow,semenova,rosari,eduard1,deltaforce,grouper,bongo1,tempgod,1taylor,goldsink,qazxsw1,1jesus,m69fg2w,maximili,marysia,husker1,kokanee,sideout,googl,south1,plumber1,trillian,00001,1357900,farkle,1xxxxx,pascha,emanuela,bagheera,hound1,mylov,newjersey,swampfox,sakic19,torey,geforce,wu4etd,conrail,pigman,martin2,ber02,nascar2,angel69,barty,kitsune,cornet,yes90125,goomba,daking,anthea,sivart,weather1,ndaswf,scoubidou,masterchief,rectum,3364068,oranges1,copter,1samanth,eddies,mimoza,ahfywbz,celtic88,86mets,applemac,amanda11,taliesin,1angel,imhere,london11,bandit12,killer666,beer1,06225930,psylocke,james69,schumach,24pnz6kc,endymion,wookie1,poiu123,birdland,smoochie,lastone,rclaki,olive1,pirat,thunder7,chris69,rocko,151617,djg4bb4b,lapper,ajcuivd289,colole57,shadow7,dallas21,ajtdmw,executiv,dickies,omegaman,jason12,newhaven,aaaaaas,pmdmscts,s456123789,beatri,applesauce,levelone,strapon,benladen,creaven,ttttt1,saab95,f123456,pitbul,54321a,sex12345,robert3,atilla,mevefalkcakk,1johnny,veedub,lilleke,nitsuj,5t6y7u8i,teddys,bluefox,nascar20,vwjetta,buffy123,playstation3,loverr,qweasd12,lover2,telekom,benjamin1,alemania,neutrino,rockz,valjean,testicle,trinity3,realty,firestarter,794613852,ardvark,guadalup,philmont,arnold1,holas,zw6syj,birthday299,dover1,sexxy1,gojets,741236985,cance,blue77,xzibit,qwerty88,komarova,qweszxc,footer,rainger,silverst,ghjcnb,catmando,tatooine,31217221027711,amalgam,69dude,qwerty321,roscoe1,74185,cubby,alfa147,perry1,darock,katmandu,darknight,knicks1,freestuff,45454,kidman,4tlved,axlrose,cutie1,quantum1,joseph10,ichigo,pentium3,rfhectkm,rowdy1,woodsink,justforfun,sveta123,pornografia,mrbean,bigpig,tujheirf,delta9,portsmou,hotbod,kartal,10111213,fkbyf001,pavel1,pistons1,necromancer,verga,c7lrwu,doober,thegame1,hatesyou,sexisfun,1melissa,tuczno18,bowhunte,gobama,scorch,campeon,bruce2,fudge1,herpderp,bacon1,redsky,blackeye,19966991,19992000,ripken8,masturba,34524815,primax,paulina1,vp6y38,427cobra,4dwvjj,dracon,fkg7h4f3v6,longview,arakis,panama1,honda2,lkjhgfdsaz,razors,steels,fqkw5m,dionysus,mariajos,soroka,enriqu,nissa,barolo,king1234,hshfd4n279,holland1,flyer1,tbones,343104ky,modems,tk421,ybrbnrf,pikapp,sureshot,wooddoor,florida2,mrbungle,vecmrf,catsdogs,axolotl,nowayout,francoi,chris21,toenail,hartland,asdjkl,nikkii,onlyyou,buckskin,fnord,flutie,holen1,rincewind,lefty1,ducky1,199000,fvthbrf,redskin1,ryno23,lostlove,19mtpgam19,abercrom,benhur,jordan11,roflcopter,ranma,phillesh,avondale,igromania,p4ssword,jenny123,tttttt1,spycams,cardigan,2112yyz,sleepy1,paris123,mopars,lakers34,hustler1,james99,matrix3,popimp,12pack,eggbert,medvedev,testit,performa,logitec,marija,sexybeast,supermanboy,iwantit,rjktcj,jeffer,svarog,halo123,whdbtp,nokia3230,heyjoe,marilyn1,speeder,ibxnsm,prostock,bennyboy,charmin,codydog,parol999,ford9402,jimmer,crayola,159357258,alex77,joey1,cayuga,phish420,poligon,specops,tarasova,caramelo,draconis,dimon,cyzkhw,june29,getbent,1guitar,jimjam,dictiona,shammy,flotsam,0okm9ijn,crapper,technic,fwsadn,rhfdxtyrj,zaq11qaz,anfield1,159753q,curious1,hip-hop,1iiiii,gfhjkm2,cocteau,liveevil,friskie,crackhead,b1afra,elektrik,lancer1,b0ll0cks,jasond,z1234567,tempest1,alakazam,asdfasd,duffy1,oneday,dinkle,qazedctgb,kasimir,happy7,salama,hondaciv,nadezda,andretti,cannondale,sparticu,znbvjd,blueice,money01,finster,eldar,moosie,pappa,delta123,neruda,bmw330ci,jeanpaul,malibu1,alevtina,sobeit,travolta,fullmetal,enamorad,mausi,boston12,greggy,smurf1,ratrace,ichiban,ilovepus,davidg,wolf69,villa1,cocopuff,football12,starfury,zxc12345,forfree,fairfiel,dreams1,tayson,mike2,dogday,hej123,oldtimer,sanpedro,clicker,mollycat,roadstar,golfe,lvbnhbq1,topdevice,a1b2c,sevastopol,calli,milosc,fire911,pink123,team3x,nolimit5,snickers1,annies,09877890,jewel1,steve69,justin11,autechre,killerbe,browncow,slava1,christer,fantomen,redcloud,elenberg,beautiful1,passw0rd1,nazira,advantag,cockring,chaka,rjpzdrf,99941,az123456,biohazar,energie,bubble1,bmw323,tellme,printer1,glavine,1starwar,coolbeans,april17,carly1,quagmire,admin2,djkujuhfl,pontoon,texmex,carlos12,thermo,vaz2106,nougat,bob666,1hockey,1john,cricke,qwerty10,twinz,totalwar,underwoo,tijger,lildevil,123q321,germania,freddd,1scott,beefy,5t4r3e2w1q,fishbait,nobby,hogger,dnstuff,jimmyc,redknapp,flame1,tinfloor,balla,nfnfhby,yukon1,vixens,batata,danny123,1zxcvbnm,gaetan,homewood,greats,tester1,green99,1fucker,sc0tland,starss,glori,arnhem,goatman,1234asd,supertra,bill123,elguapo,sexylegs,jackryan,usmc69,innow,roaddog,alukard,winter11,crawler,gogiants,rvd420,alessandr,homegrow,gobbler,esteba,valeriy,happy12,1joshua,hawking,sicnarf,waynes,iamhappy,bayadera,august2,sashas,gotti,dragonfire,pencil1,halogen,borisov,bassingw,15975346,zachar,sweetp,soccer99,sky123,flipyou,spots3,xakepy,cyclops1,dragon77,rattolo58,motorhea,piligrim,helloween,dmb2010,supermen,shad0w,eatcum,sandokan,pinga,ufkfrnbrf,roksana,amista,pusser,sony1234,azerty1,1qasw2,ghbdt,q1w2e3r4t5y6u7i8,ktutylf,brehznev,zaebali,shitass,creosote,gjrtvjy,14938685,naughtyboy,pedro123,21crack,maurice1,joesakic,nicolas1,matthew9,lbyfhf,elocin,hfcgbplzq,pepper123,tiktak,mycroft,ryan11,firefly1,arriva,cyecvevhbr,loreal,peedee,jessica8,lisa01,anamari,pionex,ipanema,airbag,frfltvbz,123456789aa,epwr49,casper12,sweethear,sanandreas,wuschel,cocodog,france1,119911,redroses,erevan,xtvgbjy,bigfella,geneve,volvo850,evermore,amy123,moxie,celebs,geeman,underwor,haslo1,joy123,hallow,chelsea0,12435687,abarth,12332145,tazman1,roshan,yummie,genius1,chrisd,ilovelife,seventy7,qaz1wsx2,rocket88,gaurav,bobbyboy,tauchen,roberts1,locksmit,masterof,www111,d9ungl,volvos40,asdasd1,golfers,jillian1,7xm5rq,arwpls4u,gbhcf2,elloco,football2,muerte,bob101,sabbath1,strider1,killer66,notyou,lawnboy,de7mdf,johnnyb,voodoo2,sashaa,homedepo,bravos,nihao123,braindea,weedhead,rajeev,artem1,camille1,rockss,bobbyb,aniston,frnhbcf,oakridge,biscayne,cxfcnm,dressage,jesus3,kellyann,king69,juillet,holliste,h00ters,ripoff,123645,1999ar,eric12,123777,tommi,dick12,bilder,chris99,rulezz,getpaid,chicubs,ender1,byajhvfnbrf,milkshak,sk8board,freakshow,antonella,monolit,shelb,hannah01,masters1,pitbull1,1matthew,luvpussy,agbdlcid,panther2,alphas,euskadi,8318131,ronnie1,7558795,sweetgirl,cookie59,sequoia,5552555,ktyxbr,4500455,money7,severus,shinobu,dbityrf,phisig,rogue2,fractal,redfred,sebastian1,nelli,b00mer,cyberman,zqjphsyf6ctifgu,oldsmobile,redeemer,pimpi,lovehurts,1slayer,black13,rtynfdh,airmax,g00gle,1panther,artemon,nopasswo,fuck1234,luke1,trinit,666000,ziadma,oscardog,davex,hazel1,isgood,demond,james5,construc,555551,january2,m1911a1,flameboy,merda,nathan12,nicklaus,dukester,hello99,scorpio7,leviathan,dfcbktr,pourquoi,vfrcbv123,shlomo,rfcgth,rocky3,ignatz,ajhneyf,roger123,squeek,4815162342a,biskit,mossimo,soccer21,gridlock,lunker,popstar,ghhh47hj764,chutney,nitehawk,vortec,gamma1,codeman,dragula,kappasig,rainbow2,milehigh,blueballs,ou8124me,rulesyou,collingw,mystere,aster,astrovan,firetruck,fische,crawfish,hornydog,morebeer,tigerpaw,radost,144000,1chance,1234567890qwe,gracie1,myopia,oxnard,seminoles,evgeni,edvard,partytim,domani,tuffy1,jaimatadi,blackmag,kzueirf,peternor,mathew1,maggie12,henrys,k1234567,fasted,pozitiv,cfdtkbq,jessica7,goleafs,bandito,girl78,sharingan,skyhigh,bigrob,zorros,poopers,oldschoo,pentium2,gripper,norcal,kimba,artiller,moneymak,00197400,272829,shadow1212,thebull,handbags,all4u2c,bigman2,civics,godisgoo,section8,bandaid,suzanne1,zorba,159123,racecars,i62gbq,rambo123,ironroad,johnson2,knobby,twinboys,sausage1,kelly69,enter2,rhjirf,yessss,james12,anguilla,boutit,iggypop,vovochka,06060,budwiser,romuald,meditate,good1,sandrin,herkules,lakers8,honeybea,11111111a,miche,rangers9,lobster1,seiko,belova,midcon,mackdadd,bigdaddy1,daddie,sepultur,freddy12,damon1,stormy1,hockey2,bailey12,hedimaptfcor,dcowboys,sadiedog,thuggin,horny123,josie1,nikki2,beaver69,peewee1,mateus,viktorija,barrys,cubswin1,matt1234,timoxa,rileydog,sicilia,luckycat,candybar,julian1,abc456,pussylip,phase1,acadia,catty,246800,evertonf,bojangle,qzwxec,nikolaj,fabrizi,kagome,noncapa0,marle,popol,hahaha1,cossie,carla10,diggers,spankey,sangeeta,cucciolo,breezer,starwar1,cornholio,rastafari,spring99,yyyyyyy1,webstar,72d5tn,sasha1234,inhouse,gobuffs,civic1,redstone,234523,minnie1,rivaldo,angel5,sti2000,xenocide,11qq11,1phoenix,herman1,holly123,tallguy,sharks1,madri,superbad,ronin,jalal123,hardbody,1234567r,assman1,vivahate,buddylee,38972091,bonds25,40028922,qrhmis,wp2005,ceejay,pepper01,51842543,redrum1,renton,varadero,tvxtjk7r,vetteman,djhvbrc,curly1,fruitcak,jessicas,maduro,popmart,acuari,dirkpitt,buick1,bergerac,golfcart,pdtpljxrf,hooch1,dudelove,d9ebk7,123452000,afdjhbn,greener,123455432,parachut,mookie12,123456780,jeepcj5,potatoe,sanya,qwerty2010,waqw3p,gotika,freaky1,chihuahu,buccanee,ecstacy,crazyboy,slickric,blue88,fktdnbyf,2004rj,delta4,333222111,calient,ptbdhw,1bailey,blitz1,sheila1,master23,hoagie,pyf8ah,orbita,daveyboy,prono1,delta2,heman,1horny,tyrik123,ostrov,md2020,herve,rockfish,el546218,rfhbyjxrf,chessmaster,redmoon,lenny1,215487,tomat,guppy,amekpass,amoeba,my3girls,nottingh,kavita,natalia1,puccini,fabiana,8letters,romeos,netgear,casper2,taters,gowings,iforgot1,pokesmot,pollit,lawrun,petey1,rosebuds,007jr,gthtcnhjqrf,k9dls02a,neener,azertyu,duke11,manyak,tiger01,petros,supermar,mangas,twisty,spotter,takagi,dlanod,qcmfd454,tusymo,zz123456,chach,navyblue,gilbert1,2kash6zq,avemaria,1hxboqg2s,viviane,lhbjkjubz2957704,nowwowtg,1a2b3c4,m0rn3,kqigb7,superpuper,juehtw,gethigh,theclown,makeme,pradeep,sergik,deion21,nurik,devo2706,nbvibt,roman222,kalima,nevaeh,martin7,anathema,florian1,tamwsn3sja,dinmamma,133159,123654q,slicks,pnp0c08,yojimbo,skipp,kiran,pussyfuck,teengirl,apples12,myballs,angeli,1234a,125678,opelastra,blind1,armagedd,fish123,pitufo,chelseaf,thedevil,nugget1,cunt69,beetle1,carter15,apolon,collant,password00,fishboy,djkrjdf,deftone,celti,three11,cyrus1,lefthand,skoal1,ferndale,aries1,fred01,roberta1,chucks,cornbread,lloyd1,icecrea,cisco123,newjerse,vfhrbpf,passio,volcom1,rikimaru,yeah11,djembe,facile,a1l2e3x4,batman7,nurbol,lorenzo1,monica69,blowjob1,998899,spank1,233391,n123456,1bear,bellsout,999998,celtic67,sabre1,putas,y9enkj,alfabeta,heatwave,honey123,hard4u,insane1,xthysq,magnum1,lightsaber,123qweqwe,fisher1,pixie1,precios,benfic,thegirls,bootsman,4321rewq,nabokov,hightime,djghjc,1chelsea,junglist,august16,t3fkvkmj,1232123,lsdlsd12,chuckie1,pescado,granit,toogood,cathouse,natedawg,bmw530,123kid,hajime,198400,engine1,wessonnn,kingdom1,novembre,1rocks,kingfisher,qwerty89,jordan22,zasranec,megat,sucess,installutil,fetish01,yanshi1982,1313666,1314520,clemence,wargod,time1,newzealand,snaker,13324124,cfrehf,hepcat,mazahaka,bigjay,denisov,eastwest,1yellow,mistydog,cheetos,1596357,ginger11,mavrik,bubby1,bhbyf,pyramide,giusepp,luthien,honda250,andrewjackie,kentavr,lampoon,zaq123wsx,sonicx,davidh,1ccccc,gorodok,windsong,programm,blunt420,vlad1995,zxcvfdsa,tarasov,mrskin,sachas,mercedes1,koteczek,rawdog,honeybear,stuart1,kaktys,richard7,55555n,azalia,hockey10,scouter,francy,1xxxxxx,julie456,tequilla,penis123,schmoe,tigerwoods,1ferrari,popov,snowdrop,matthieu,smolensk,cornflak,jordan01,love2000,23wesdxc,kswiss,anna2000,geniusnet,baby2000,33ds5x,waverly,onlyone4,networkingpe,raven123,blesse,gocards,wow123,pjflkork,juicey,poorboy,freeee,billybo,shaheen,zxcvbnm.,berlit,truth1,gepard,ludovic,gunther1,bobby2,bob12345,sunmoon,septembr,bigmac1,bcnjhbz,seaking,all4u,12qw34er56ty,bassie,nokia5228,7355608,sylwia,charvel,billgate,davion,chablis,catsmeow,kjiflrf,amylynn,rfvbkkf,mizredhe,handjob,jasper12,erbol,solara,bagpipe,biffer,notime,erlan,8543852,sugaree,oshkosh,fedora,bangbus,5lyedn,longball,teresa1,bootyman,aleksand,qazwsxedc12,nujbhc,tifosi,zpxvwy,lights1,slowpoke,tiger12,kstate,password10,alex69,collins1,9632147,doglover,baseball2,security1,grunts,orange2,godloves,213qwe879,julieb,1qazxsw23edcvfr4,noidea,8uiazp,betsy1,junior2,parol123,123456zz,piehonkii,kanker,bunky,hingis,reese1,qaz123456,sidewinder,tonedup,footsie,blackpoo,jalapeno,mummy1,always1,josh1,rockyboy,plucky,chicag,nadroj,blarney,blood123,wheaties,packer1,ravens1,mrjones,gfhjkm007,anna2010,awatar,guitar12,hashish,scale1,tomwaits,amrita,fantasma,rfpfym,pass2,tigris,bigair,slicker,sylvi,shilpa,cindylou,archie1,bitches1,poppys,ontime,horney1,camaroz28,alladin,bujhm,cq2kph,alina1,wvj5np,1211123a,tetons,scorelan,concordi,morgan2,awacs,shanty,tomcat14,andrew123,bear69,vitae,fred99,chingy,octane,belgario,fatdaddy,rhodan,password23,sexxes,boomtown,joshua01,war3demo,my2kids,buck1,hot4you,monamour,12345aa,yumiko,parool,carlton1,neverland,rose12,right1,sociald,grouse,brandon0,cat222,alex00,civicex,bintang,malkav,arschloc,dodgeviper,qwerty666,goduke,dante123,boss1,ontheroc,corpsman,love14,uiegu451,hardtail,irondoor,ghjrehfnehf,36460341,konijn,h2slca,kondom25,123456ss,cfytxrf,btnjey,nando,freemail,comander,natas666,siouxsie,hummer1,biomed,dimsum,yankees0,diablo666,lesbian1,pot420,jasonm,glock23,jennyb,itsmine,lena2010,whattheh,beandip,abaddon,kishore,signup,apogee,biteme12,suzieq,vgfun4,iseeyou,rifleman,qwerta,4pussy,hawkman,guest1,june17,dicksuck,bootay,cash12,bassale,ktybyuhfl,leetch,nescafe,7ovtgimc,clapton1,auror,boonie,tracker1,john69,bellas,cabinboy,yonkers,silky1,ladyffesta,drache,kamil1,davidp,bad123,snoopy12,sanche,werthvfy,achille,nefertiti,gerald1,slage33,warszawa,macsan26,mason123,kotopes,welcome8,nascar99,kiril,77778888,hairy1,monito,comicsans,81726354,killabee,arclight,yuo67,feelme,86753099,nnssnn,monday12,88351132,88889999,websters,subito,asdf12345,vaz2108,zvbxrpl,159753456852,rezeda,multimed,noaccess,henrique,tascam,captiva,zadrot,hateyou,sophie12,123123456,snoop1,charlie8,birmingh,hardline,libert,azsxdcf,89172735872,rjpthju,bondar,philips1,olegnaruto,myword,yakman,stardog,banana12,1234567890w,farout,annick,duke01,rfj422,billard,glock19,shaolin1,master10,cinderel,deltaone,manning1,biggreen,sidney1,patty1,goforit1,766rglqy,sevendus,aristotl,armagedo,blumen,gfhfyjz,kazakov,lekbyxxx,accord1,idiota,soccer16,texas123,victoire,ololo,chris01,bobbbb,299792458,eeeeeee1,confiden,07070,clarks,techno1,kayley,stang1,wwwwww1,uuuuu1,neverdie,jasonr,cavscout,481516234,mylove1,shaitan,1qazxcvb,barbaros,123456782000,123wer,thissucks,7seven,227722,faerie,hayduke,dbacks,snorkel,zmxncbv,tiger99,unknown1,melmac,polo1234,sssssss1,1fire,369147,bandung,bluejean,nivram,stanle,ctcnhf,soccer20,blingbli,dirtball,alex2112,183461,skylin,boobman,geronto,brittany1,yyz2112,gizmo69,ktrcec,dakota12,chiken,sexy11,vg08k714,bernadet,1bulldog,beachs,hollyb,maryjoy,margo1,danielle1,chakra,alexand,hullcity,matrix12,sarenna,pablos,antler,supercar,chomsky,german1,airjordan,545ettvy,camaron,flight1,netvideo,tootall,valheru,481516,1234as,skimmer,redcross,inuyash,uthvfy,1012nw,edoardo,bjhgfi,golf11,9379992a,lagarto,socball,boopie,krazy,.adgjmptw,gaydar,kovalev,geddylee,firstone,turbodog,loveee,135711,badbo,trapdoor,opopop11,danny2,max2000,526452,kerry1,leapfrog,daisy2,134kzbip,1andrea,playa1,peekab00,heskey,pirrello,gsewfmck,dimon4ik,puppie,chelios,554433,hypnodanny,fantik,yhwnqc,ghbdtngjrf,anchorag,buffett1,fanta,sappho,024680,vialli,chiva,lucylu,hashem,exbntkm,thema,23jordan,jake11,wildside,smartie,emerica,2wj2k9oj,ventrue,timoth,lamers,baerchen,suspende,boobis,denman85,1adam12,otello,king12,dzakuni,qsawbbs,isgay,porno123,jam123,daytona1,tazzie,bunny123,amaterasu,jeffre,crocus,mastercard,bitchedup,chicago7,aynrand,intel1,tamila,alianza,mulch,merlin12,rose123,alcapone,mircea,loveher,joseph12,chelsea6,dorothy1,wolfgar,unlimite,arturik,qwerty3,paddy1,piramid,linda123,cooool,millie1,warlock1,forgotit,tort02,ilikeyou,avensis,loveislife,dumbass1,clint1,2110se,drlove,olesia,kalinina,sergey123,123423,alicia1,markova,tri5a3,media1,willia1,xxxxxxx1,beercan,smk7366,jesusislord,motherfuck,smacker,birthday5,jbaby,harley2,hyper1,a9387670a,honey2,corvet,gjmptw,rjhjkmbien,apollon,madhuri,3a5irt,cessna17,saluki,digweed,tamia1,yja3vo,cfvlehfr,1111111q,martyna,stimpy1,anjana,yankeemp,jupiler,idkfa,1blue,fromv,afric,3xbobobo,liverp00l,nikon1,amadeus1,acer123,napoleo,david7,vbhjckfdf,mojo69,percy1,pirates1,grunt1,alenushka,finbar,zsxdcf,mandy123,1fred,timewarp,747bbb,druids,julia123,123321qq,spacebar,dreads,fcbarcelona,angela12,anima,christopher1,stargazer,123123s,hockey11,brewski,marlbor,blinker,motorhead,damngood,werthrf,letmein3,moremoney,killer99,anneke,eatit,pilatus,andrew01,fiona1,maitai,blucher,zxgdqn,e5pftu,nagual,panic1,andron,openwide,alphabeta,alison1,chelsea8,fende,mmm666,1shot2,a19l1980,123456@,1black,m1chael,vagner,realgood,maxxx,vekmnbr,stifler,2509mmh,tarkan,sherzod,1234567b,gunners1,artem2010,shooby,sammie1,p123456,piggie,abcde12345,nokia6230,moldir,piter,1qaz3edc,frequenc,acuransx,1star,nikeair,alex21,dapimp,ranjan,ilovegirls,anastasiy,berbatov,manso,21436587,leafs1,106666,angelochek,ingodwetrust,123456aaa,deano,korsar,pipetka,thunder9,minka,himura,installdevic,1qqqqq,digitalprodu,suckmeoff,plonker,headers,vlasov,ktr1996,windsor1,mishanya,garfield1,korvin,littlebit,azaz09,vandamme,scripto,s4114d,passward,britt1,r1chard,ferrari5,running1,7xswzaq,falcon2,pepper76,trademan,ea53g5,graham1,volvos80,reanimator,micasa,1234554321q,kairat,escorpion,sanek94,karolina1,kolovrat,karen2,1qaz@wsx,racing1,splooge,sarah2,deadman1,creed1,nooner,minicoop,oceane,room112,charme,12345ab,summer00,wetcunt,drewman,nastyman,redfire,appels,merlin69,dolfin,bornfree,diskette,ohwell,12345678qwe,jasont,madcap,cobra2,dolemit1,whatthehell,juanit,voldemar,rocke,bianc,elendil,vtufgjkbc,hotwheels,spanis,sukram,pokerface,k1ller,freakout,dontae,realmadri,drumss,gorams,258789,snakey,jasonn,whitewolf,befree,johnny99,pooka,theghost,kennys,vfvektxrf,toby1,jumpman23,deadlock,barbwire,stellina,alexa1,dalamar,mustanggt,northwes,tesoro,chameleo,sigtau,satoshi,george11,hotcum,cornell1,golfer12,geek01d,trololo,kellym,megapolis,pepsi2,hea666,monkfish,blue52,sarajane,bowler1,skeets,ddgirls,hfccbz,bailey01,isabella1,dreday,moose123,baobab,crushme,000009,veryhot,roadie,meanone,mike18,henriett,dohcvtec,moulin,gulnur,adastra,angel9,western1,natura,sweetpe,dtnfkm,marsbar,daisys,frogger1,virus1,redwood1,streetball,fridolin,d78unhxq,midas,michelob,cantik,sk2000,kikker,macanudo,rambone,fizzle,20000,peanuts1,cowpie,stone32,astaroth,dakota01,redso,mustard1,sexylove,giantess,teaparty,bobbin,beerbong,monet1,charles3,anniedog,anna1988,cameleon,longbeach,tamere,qpful542,mesquite,waldemar,12345zx,iamhere,lowboy,canard,granp,daisymay,love33,moosejaw,nivek,ninjaman,shrike01,aaa777,88002000600,vodolei,bambush,falcor,harley69,alphaomega,severine,grappler,bosox,twogirls,gatorman,vettes,buttmunch,chyna,excelsio,crayfish,birillo,megumi,lsia9dnb9y,littlebo,stevek,hiroyuki,firehous,master5,briley2,gangste,chrisk,camaleon,bulle,troyboy,froinlaven,mybutt,sandhya,rapala,jagged,crazycat,lucky12,jetman,wavmanuk,1heather,beegee,negril,mario123,funtime1,conehead,abigai,mhorgan,patagoni,travel1,backspace,frenchfr,mudcat,dashenka,baseball3,rustys,741852kk,dickme,baller23,griffey1,suckmycock,fuhrfzgc,jenny2,spuds,berlin1,justfun,icewind,bumerang,pavlusha,minecraft123,shasta1,ranger12,123400,twisters,buthead,miked,finance1,dignity7,hello9,lvjdp383,jgthfnjh,dalmatio,paparoach,miller31,2bornot2b,fathe,monterre,theblues,satans,schaap,jasmine2,sibelius,manon,heslo,jcnhjd,shane123,natasha2,pierrot,bluecar,iloveass,harriso,red12,london20,job314,beholder,reddawg,fuckyou!,pussylick,bologna1,austintx,ole4ka,blotto,onering,jearly,balbes,lightbul,bighorn,crossfir,lee123,prapor,1ashley,gfhjkm22,wwe123,09090,sexsite,marina123,jagua,witch1,schmoo,parkview,dragon3,chilango,ultimo,abramova,nautique,2bornot2,duende,1arthur,nightwing,surfboar,quant4307,15s9pu03,karina1,shitball,walleye1,wildman1,whytesha,1morgan,my2girls,polic,baranova,berezuckiy,kkkkkk1,forzima,fornow,qwerty02,gokart,suckit69,davidlee,whatnow,edgard,tits1,bayshore,36987412,ghbphfr,daddyy,explore1,zoidberg,5qnzjx,morgane,danilov,blacksex,mickey12,balsam,83y6pv,sarahc,slaye,all4u2,slayer69,nadia1,rlzwp503,4cranker,kaylie,numberon,teremok,wolf12,deeppurple,goodbeer,aaa555,66669999,whatif,harmony1,ue8fpw,3tmnej,254xtpss,dusty197,wcksdypk,zerkalo,dfnheirf,motorol,digita,whoareyou,darksoul,manics,rounders,killer11,d2000lb,cegthgfhjkm,catdog1,beograd,pepsico,julius1,123654987,softbal,killer23,weasel1,lifeson,q123456q,444555666,bunches,andy1,darby1,service01,bear11,jordan123,amega,duncan21,yensid,lerxst,rassvet,bronco2,fortis,pornlove,paiste,198900,asdflkjh,1236547890,futur,eugene1,winnipeg261,fk8bhydb,seanjohn,brimston,matthe1,bitchedu,crisco,302731,roxydog,woodlawn,volgograd,ace1210,boy4u2ownnyc,laura123,pronger,parker12,z123456z,andrew13,longlife,sarang,drogba,gobruins,soccer4,holida,espace,almira,murmansk,green22,safina,wm00022,1chevy,schlumpf,doroth,ulises,golf99,hellyes,detlef,mydog,erkina,bastardo,mashenka,sucram,wehttam,generic1,195000,spaceboy,lopas123,scammer,skynyrd,daddy2,titani,ficker,cr250r,kbnthfnehf,takedown,sticky1,davidruiz,desant,nremtp,painter1,bogies,agamemno,kansas1,smallfry,archi,2b4dnvsx,1player,saddie,peapod,6458zn7a,qvw6n2,gfxqx686,twice2,sh4d0w3d,mayfly,375125,phitau,yqmbevgk,89211375759,kumar1,pfhfpf,toyboy,way2go,7pvn4t,pass69,chipster,spoony,buddycat,diamond3,rincewin,hobie,david01,billbo,hxp4life,matild,pokemon2,dimochka,clown1,148888,jenmt3,cuxldv,cqnwhy,cde34rfv,simone1,verynice,toobig,pasha123,mike00,maria2,lolpop,firewire,dragon9,martesana,a1234567890,birthday3,providen,kiska,pitbulls,556655,misawa,damned69,martin11,goldorak,gunship,glory1,winxclub,sixgun,splodge,agent1,splitter,dome69,ifghjb,eliza1,snaiper,wutang36,phoenix7,666425,arshavin,paulaner,namron,m69fg1w,qwert1234,terrys,zesyrmvu,joeman,scoots,dwml9f,625vrobg,sally123,gostoso,symow8,pelota,c43qpul5rz,majinbuu,lithium1,bigstuff,horndog1,kipelov,kringle,1beavis,loshara,octobe,jmzacf,12342000,qw12qw,runescape1,chargers1,krokus,piknik,jessy,778811,gjvbljh,474jdvff,pleaser,misskitty,breaker1,7f4df451,dayan,twinky,yakumo,chippers,matia,tanith,len2ski1,manni,nichol1,f00b4r,nokia3110,standart,123456789i,shami,steffie,larrywn,chucker,john99,chamois,jjjkkk,penmouse,ktnj2010,gooners,hemmelig,rodney1,merlin01,bearcat1,1yyyyy,159753z,1fffff,1ddddd,thomas11,gjkbyrf,ivanka,f1f2f3,petrovna,phunky,conair,brian2,creative1,klipsch,vbitymrf,freek,breitlin,cecili,westwing,gohabsgo,tippmann,1steve,quattro6,fatbob,sp00ky,rastas,1123581,redsea,rfnmrf,jerky1,1aaaaaa,spk666,simba123,qwert54321,123abcd,beavis69,fyfyfc,starr1,1236547,peanutbutter,sintra,12345abcde,1357246,abcde1,climbon,755dfx,mermaids,monte1,serkan,geilesau,777win,jasonc,parkside,imagine1,rockhead,producti,playhard,principa,spammer,gagher,escada,tsv1860,dbyjuhfl,cruiser1,kennyg,montgome,2481632,pompano,cum123,angel6,sooty,bear01,april6,bodyhamm,pugsly,getrich,mikes,pelusa,fosgate,jasonp,rostislav,kimberly1,128mo,dallas11,gooner1,manuel1,cocacola1,imesh,5782790,password8,daboys,1jones,intheend,e3w2q1,whisper1,madone,pjcgujrat,1p2o3i,jamesp,felicida,nemrac,phikap,firecat,jrcfyjxrf,matt12,bigfan,doedel,005500,jasonx,1234567k,badfish,goosey,utjuhfabz,wilco,artem123,igor123,spike123,jor23dan,dga9la,v2jmsz,morgan12,avery1,dogstyle,natasa,221195ws,twopac,oktober7,karthik,poop1,mightymo,davidr,zermatt,jehova,aezakmi1,dimwit,monkey5,serega123,qwerty111,blabl,casey22,boy123,1clutch,asdfjkl1,hariom,bruce10,jeep95,1smith,sm9934,karishma,bazzzz,aristo,669e53e1,nesterov,kill666,fihdfv,1abc2,anna1,silver11,mojoman,telefono,goeagles,sd3lpgdr,rfhfynby,melinda1,llcoolj,idteul,bigchief,rocky13,timberwo,ballers,gatekeep,kashif,hardass,anastasija,max777,vfuyjkbz,riesling,agent99,kappas,dalglish,tincan,orange3,turtoise,abkbvjy,mike24,hugedick,alabala,geolog,aziza,devilboy,habanero,waheguru,funboy,freedom5,natwest,seashore,impaler,qwaszx1,pastas,bmw535,tecktonik,mika00,jobsearc,pinche,puntang,aw96b6,1corvett,skorpio,foundati,zzr1100,gembird,vfnhjcrby,soccer18,vaz2110,peterp,archer1,cross1,samedi,dima1992,hunter99,lipper,hotbody,zhjckfdf,ducati1,trailer1,04325956,cheryl1,benetton,kononenko,sloneczko,rfgtkmrf,nashua,balalaika,ampere,eliston,dorsai,digge,flyrod,oxymoron,minolta,ironmike,majortom,karimov,fortun,putaria,an83546921an13,blade123,franchis,mxaigtg5,dynxyu,devlt4,brasi,terces,wqmfuh,nqdgxz,dale88,minchia,seeyou,housepen,1apple,1buddy,mariusz,bighouse,tango2,flimflam,nicola1,qwertyasd,tomek1,shumaher,kartoshka,bassss,canaries,redman1,123456789as,preciosa,allblacks,navidad,tommaso,beaudog,forrest1,green23,ryjgjxrf,go4it,ironman2,badnews,butterba,1grizzly,isaeva,rembrand,toront,1richard,bigjon,yfltymrf,1kitty,4ng62t,littlejo,wolfdog,ctvtyjd,spain1,megryan,tatertot,raven69,4809594q,tapout,stuntman,a131313,lagers,hotstuf,lfdbl11,stanley2,advokat,boloto,7894561,dooker,adxel187,cleodog,4play,0p9o8i,masterb,bimota,charlee,toystory,6820055,6666667,crevette,6031769,corsa,bingoo,dima1990,tennis11,samuri,avocado,melissa6,unicor,habari,metart,needsex,cockman,hernan,3891576,3334444,amigo1,gobuffs2,mike21,allianz,2835493,179355,midgard,joey123,oneluv,ellis1,towncar,shonuff,scouse,tool69,thomas19,chorizo,jblaze,lisa1,dima1999,sophia1,anna1989,vfvekbxrf,krasavica,redlegs,jason25,tbontb,katrine,eumesmo,vfhufhbnrf,1654321,asdfghj1,motdepas,booga,doogle,1453145,byron1,158272,kardinal,tanne,fallen1,abcd12345,ufyljy,n12345,kucing,burberry,bodger,1234578,februar,1234512,nekkid,prober,harrison1,idlewild,rfnz90,foiegras,pussy21,bigstud,denzel,tiffany2,bigwill,1234567890zzz,hello69,compute1,viper9,hellspaw,trythis,gococks,dogballs,delfi,lupine,millenia,newdelhi,charlest,basspro,1mike,joeblack,975310,1rosebud,batman11,misterio,fucknut,charlie0,august11,juancho,ilonka,jigei743ks,adam1234,889900,goonie,alicat,ggggggg1,1zzzzzzz,sexywife,northstar,chris23,888111,containe,trojan1,jason5,graikos,1ggggg,1eeeee,tigers01,indigo1,hotmale,jacob123,mishima,richard3,cjxb2014,coco123,meagain,thaman,wallst,edgewood,bundas,1power,matilda1,maradon,hookedup,jemima,r3vi3wpass,2004-10-,mudman,taz123,xswzaq,emerson1,anna21,warlord1,toering,pelle,tgwdvu,masterb8,wallstre,moppel,priora,ghjcnjrdfif,yoland,12332100,1j9e7f6f,jazzzz,yesman,brianm,42qwerty42,12345698,darkmanx,nirmal,john31,bb123456,neuspeed,billgates,moguls,fj1200,hbhlair,shaun1,ghbdfn,305pwzlr,nbu3cd,susanb,pimpdad,mangust6403,joedog,dawidek,gigante,708090,703751,700007,ikalcr,tbivbn,697769,marvi,iyaayas,karen123,jimmyboy,dozer1,e6z8jh,bigtime1,getdown,kevin12,brookly,zjduc3,nolan1,cobber,yr8wdxcq,liebe,m1garand,blah123,616879,action1,600000,sumitomo,albcaz,asian1,557799,dave69,556699,sasa123,streaker,michel1,karate1,buddy7,daulet,koks888,roadtrip,wapiti,oldguy,illini1,1234qq,mrspock,kwiatek,buterfly,august31,jibxhq,jackin,taxicab,tristram,talisker,446655,444666,chrisa,freespace,vfhbfyyf,chevell,444333,notyours,442244,christian1,seemore,sniper12,marlin1,joker666,multik,devilish,crf450,cdfoli,eastern1,asshead,duhast,voyager2,cyberia,1wizard,cybernet,iloveme1,veterok,karandash,392781,looksee,diddy,diabolic,foofight,missey,herbert1,bmw318i,premier1,zsfmpv,eric1234,dun6sm,fuck11,345543,spudman,lurker,bitem,lizzy1,ironsink,minami,339311,s7fhs127,sterne,332233,plankton,galax,azuywe,changepa,august25,mouse123,sikici,killer69,xswqaz,quovadis,gnomik,033028pw,777777a,barrakuda,spawn666,goodgod,slurp,morbius,yelnats,cujo31,norman1,fastone,earwig,aureli,wordlife,bnfkbz,yasmi,austin123,timberla,missy2,legalize,netcom,liljon,takeit,georgin,987654321z,warbird,vitalina,all4u3,mmmmmm1,bichon,ellobo,wahoos,fcazmj,aksarben,lodoss,satnam,vasili,197800,maarten,sam138989,0u812,ankita,walte,prince12,anvils,bestia,hoschi,198300,univer,jack10,ktyecbr,gr00vy,hokie,wolfman1,fuckwit,geyser,emmanue,ybrjkftd,qwerty33,karat,dblock,avocat,bobbym,womersle,1please,nostra,dayana,billyray,alternat,iloveu1,qwerty69,rammstein1,mystikal,winne,drawde,executor,craxxxs,ghjcnjnf,999888777,welshman,access123,963214785,951753852,babe69,fvcnthlfv,****me,666999666,testing2,199200,nintendo64,oscarr,guido8,zhanna,gumshoe,jbird,159357456,pasca,123452345,satan6,mithrand,fhbirf,aa1111aa,viggen,ficktjuv,radial9,davids1,rainbow7,futuro,hipho,platin,poppy123,rhenjq,fulle,rosit,chicano,scrumpy,lumpy1,seifer,uvmrysez,autumn1,xenon,susie1,7u8i9o0p,gamer1,sirene,muffy1,monkeys1,kalinin,olcrackmaster,hotmove,uconn,gshock,merson,lthtdyz,pizzaboy,peggy1,pistache,pinto1,fishka,ladydi,pandor,baileys,hungwell,redboy,rookie1,amanda01,passwrd,clean1,matty1,tarkus,jabba1,bobster,beer30,solomon1,moneymon,sesamo,fred11,sunnysid,jasmine5,thebears,putamadre,workhard,flashbac,counter1,liefde,magnat,corky1,green6,abramov,lordik,univers,shortys,david3,vip123,gnarly,1234567s,billy2,honkey,deathstar,grimmy,govinda,direktor,12345678s,linus1,shoppin,rekbrjdf,santeria,prett,berty75,mohican,daftpunk,uekmyfhf,chupa,strats,ironbird,giants56,salisbur,koldun,summer04,pondscum,jimmyj,miata1,george3,redshoes,weezie,bartman1,0p9o8i7u,s1lver,dorkus,125478,omega9,sexisgood,mancow,patric1,jetta1,074401,ghjuhtcc,gfhjk,bibble,terry2,123213,medicin,rebel2,hen3ry,4freedom,aldrin,lovesyou,browny,renwod,winnie1,belladon,1house,tyghbn,blessme,rfhfrfnbwf,haylee,deepdive,booya,phantasy,gansta,cock69,4mnveh,gazza1,redapple,structur,anakin1,manolito,steve01,poolman,chloe123,vlad1998,qazwsxe,pushit,random123,ontherocks,o236nq,brain1,dimedrol,agape,rovnogod,1balls,knigh,alliso,love01,wolf01,flintstone,beernuts,tuffguy,isengard,highfive,alex23,casper99,rubina,getreal,chinita,italian1,airsoft,qwerty23,muffdiver,willi1,grace123,orioles1,redbull1,chino1,ziggy123,breadman,estefan,ljcneg,gotoit,logan123,wideglid,mancity1,treess,qwe123456,kazumi,qweasdqwe,oddworld,naveed,protos,towson,a801016,godislov,at_asp,bambam1,soccer5,dark123,67vette,carlos123,hoser1,scouser,wesdxc,pelus,dragon25,pflhjn,abdula,1freedom,policema,tarkin,eduardo1,mackdad,gfhjkm11,lfplhfgthvf,adilet,zzzzxxxx,childre,samarkand,cegthgegth,shama,fresher,silvestr,greaser,allout,plmokn,sexdrive,nintendo1,fantasy7,oleander,fe126fd,crumpet,pingzing,dionis,hipster,yfcnz,requin,calliope,jerome1,housecat,abc123456789,doghot,snake123,augus,brillig,chronic1,gfhjkbot,expediti,noisette,master7,caliban,whitetai,favorite3,lisamari,educatio,ghjhjr,saber1,zcegth,1958proman,vtkrbq,milkdud,imajica,thehip,bailey10,hockey19,dkflbdjcnjr,j123456,bernar,aeiouy,gamlet,deltachi,endzone,conni,bcgfybz,brandi1,auckland2010,7653ajl1,mardigra,testuser,bunko18,camaro67,36936,greenie,454dfmcq,6xe8j2z4,mrgreen,ranger5,headhunt,banshee1,moonunit,zyltrc,hello3,pussyboy,stoopid,tigger11,yellow12,drums1,blue02,kils123,junkman,banyan,jimmyjam,tbbucs,sportster,badass1,joshie,braves10,lajolla,1amanda,antani,78787,antero,19216801,chich,rhett32,sarahm,beloit,sucker69,corkey,nicosnn,rccola,caracol,daffyduc,bunny2,mantas,monkies,hedonist,cacapipi,ashton1,sid123,19899891,patche,greekgod,cbr1000,leader1,19977991,ettore,chongo,113311,picass,cfif123,rhtfnbd,frances1,andy12,minnette,bigboy12,green69,alices,babcia,partyboy,javabean,freehand,qawsed123,xxx111,harold1,passwo,jonny1,kappa1,w2dlww3v5p,1merlin,222999,tomjones,jakeman,franken,markhegarty,john01,carole1,daveman,caseys,apeman,mookey,moon123,claret,titans1,residentevil,campari,curitiba,dovetail,aerostar,jackdaniels,basenji,zaq12w,glencoe,biglove,goober12,ncc170,far7766,monkey21,eclipse9,1234567v,vanechka,aristote,grumble,belgorod,abhishek,neworleans,pazzword,dummie,sashadog,diablo11,mst3000,koala1,maureen1,jake99,isaiah1,funkster,gillian1,ekaterina20,chibears,astra123,4me2no,winte,skippe,necro,windows9,vinograd,demolay,vika2010,quiksilver,19371ayj,dollar1,shecky,qzwxecrv,butterfly1,merrill1,scoreland,1crazy,megastar,mandragora,track1,dedhed,jacob2,newhope,qawsedrftgyh,shack1,samvel,gatita,shyster,clara1,telstar,office1,crickett,truls,nirmala,joselito,chrisl,lesnik,aaaabbbb,austin01,leto2010,bubbie,aaa12345,widder,234432,salinger,mrsmith,qazsedcft,newshoes,skunks,yt1300,bmw316,arbeit,smoove,123321qweewq,123qazwsx,22221111,seesaw,0987654321a,peach1,1029384756q,sereda,gerrard8,shit123,batcave,energy1,peterb,mytruck,peter12,alesya,tomato1,spirou,laputaxx,magoo1,omgkremidia,knight12,norton1,vladislava,shaddy,austin11,jlbyjxrf,kbdthgekm,punheta,fetish69,exploiter,roger2,manstein,gtnhjd,32615948worms,dogbreath,ujkjdjkjvrf,vodka1,ripcord,fatrat,kotek1,tiziana,larrybir,thunder3,nbvfnb,9kyq6fge,remembe,likemike,gavin1,shinigam,yfcnfcmz,13245678,jabbar,vampyr,ane4ka,lollipo,ashwin,scuderia,limpdick,deagle,3247562,vishenka,fdhjhf,alex02,volvov70,mandys,bioshock,caraca,tombraider,matrix69,jeff123,13579135,parazit,black3,noway1,diablos,hitmen,garden1,aminor,decembe,august12,b00ger,006900,452073t,schach,hitman1,mariner1,vbnmrf,paint1,742617000027,bitchboy,pfqxjyjr,5681392,marryher,sinnet,malik1,muffin12,aninha,piolin,lady12,traffic1,cbvjyf,6345789,june21,ivan2010,ryan123,honda99,gunny,coorslight,asd321,hunter69,7224763,sonofgod,dolphins1,1dolphin,pavlenko,woodwind,lovelov,pinkpant,gblfhfcbyf,hotel1,justinbiebe,vinter,jeff1234,mydogs,1pizza,boats1,parrothe,shawshan,brooklyn1,cbrown,1rocky,hemi426,dragon64,redwings1,porsches,ghostly,hubbahub,buttnut,b929ezzh,sorokina,flashg,fritos,b7mguk,metatron,treehous,vorpal,8902792,marcu,free123,labamba,chiefs1,zxc123zxc,keli_14,hotti,1steeler,money4,rakker,foxwoods,free1,ahjkjd,sidorova,snowwhit,neptune1,mrlover,trader1,nudelamb,baloo,power7,deltasig,bills1,trevo,7gorwell,nokia6630,nokia5320,madhatte,1cowboys,manga1,namtab,sanjar,fanny1,birdman1,adv12775,carlo1,dude1998,babyhuey,nicole11,madmike,ubvyfpbz,qawsedr,lifetec,skyhook,stalker123,toolong,robertso,ripazha,zippy123,1111111a,manol,dirtyman,analslut,jason3,dutches,minhasenha,cerise,fenrir,jayjay1,flatbush,franka,bhbyjxrf,26429vadim,lawntrax,198700,fritzy,nikhil,ripper1,harami,truckman,nemvxyheqdd5oqxyxyzi,gkfytnf,bugaboo,cableman,hairpie,xplorer,movado,hotsex69,mordred,ohyeah1,patrick3,frolov,katieh,4311111q,mochaj,presari,bigdo,753951852,freedom4,kapitan,tomas1,135795,sweet123,pokers,shagme,tane4ka,sentinal,ufgyndmv,jonnyb,skate123,123456798,123456788,very1,gerrit,damocles,dollarbi,caroline1,lloyds,pizdets,flatland,92702689,dave13,meoff,ajnjuhfabz,achmed,madison9,744744z,amonte,avrillavigne,elaine1,norma1,asseater,everlong,buddy23,cmgang1,trash1,mitsu,flyman,ulugbek,june27,magistr,fittan,sebora64,dingos,sleipnir,caterpil,cindys,212121qaz,partys,dialer,gjytltkmybr,qweqaz,janvier,rocawear,lostboy,aileron,sweety1,everest1,pornman,boombox,potter1,blackdic,44448888,eric123,112233aa,2502557i,novass,nanotech,yourname,x12345,indian1,15975300,1234567l,carla51,chicago0,coleta,cxzdsaewq,qqwweerr,marwan,deltic,hollys,qwerasd,pon32029,rainmake,nathan0,matveeva,legioner,kevink,riven,tombraid,blitzen,a54321,jackyl,chinese1,shalimar,oleg1995,beaches1,tommylee,eknock,berli,monkey23,badbob,pugwash,likewhoa,jesus2,yujyd360,belmar,shadow22,utfp5e,angelo1,minimax,pooder,cocoa1,moresex,tortue,lesbia,panthe,snoopy2,drumnbass,alway,gmcz71,6jhwmqku,leppard,dinsdale,blair1,boriqua,money111,virtuagirl,267605,rattlesn,1sunshin,monica12,veritas1,newmexic,millertime,turandot,rfvxfnrf,jaydog,kakawka,bowhunter,booboo12,deerpark,erreway,taylorma,rfkbybyf,wooglin,weegee,rexdog,iamhorny,cazzo1,vhou812,bacardi1,dctktyyfz,godpasi,peanut12,bertha1,fuckyoubitch,ghosty,altavista,jertoot,smokeit,ghjcnbvtyz,fhnehxbr,rolsen,qazxcdews,maddmaxx,redrocke,qazokm,spencer2,thekiller,asdf11,123sex,tupac1,p1234567,dbrown,1biteme,tgo4466,316769,sunghi,shakespe,frosty1,gucci1,arcana,bandit01,lyubov,poochy,dartmout,magpies1,sunnyd,mouseman,summer07,chester7,shalini,danbury,pigboy,dave99,deniss,harryb,ashley11,pppppp1,01081988m,balloon1,tkachenko,bucks1,master77,pussyca,tricky1,zzxxccvv,zoulou,doomer,mukesh,iluv69,supermax,todays,thefox,don123,dontask,diplom,piglett,shiney,fahbrf,qaz12wsx,temitope,reggin,project1,buffy2,inside1,lbpfqyth,vanilla1,lovecock,u4slpwra,fylh.irf,123211,7ertu3ds,necroman,chalky,artist1,simpso,4x7wjr,chaos666,lazyacres,harley99,ch33s3,marusa,eagle7,dilligas,computadora,lucky69,denwer,nissan350z,unforgiv,oddball,schalke0,aztec1,borisova,branden1,parkave,marie123,germa,lafayett,878kckxy,405060,cheeseca,bigwave,fred22,andreea,poulet,mercutio,psycholo,andrew88,o4izdmxu,sanctuar,newhome,milion,suckmydi,rjvgm.nth,warior,goodgame,1qwertyuiop,6339cndh,scorpio2,macker,southbay,crabcake,toadie,paperclip,fatkid,maddo,cliff1,rastafar,maries,twins1,geujdrf,anjela,wc4fun,dolina,mpetroff,rollout,zydeco,shadow3,pumpki,steeda,volvo240,terras,blowjo,blue2000,incognit,badmojo,gambit1,zhukov,station1,aaronb,graci,duke123,clipper1,qazxsw2,ledzeppe,kukareku,sexkitte,cinco,007008,lakers12,a1234b,acmilan1,afhfjy,starrr,slutty3,phoneman,kostyan,bonzo1,sintesi07,ersatz,cloud1,nephilim,nascar03,rey619,kairos,123456789e,hardon1,boeing1,juliya,hfccdtn,vgfun8,polizei,456838,keithb,minouche,ariston,savag,213141,clarkken,microwav,london2,santacla,campeo,qr5mx7,464811,mynuts,bombo,1mickey,lucky8,danger1,ironside,carter12,wyatt1,borntorun,iloveyou123,jose1,pancake1,tadmichaels,monsta,jugger,hunnie,triste,heat7777,ilovejesus,queeny,luckycharm,lieben,gordolee85,jtkirk,forever21,jetlag,skylane,taucher,neworlea,holera,000005,anhnhoem,melissa7,mumdad,massimiliano,dima1994,nigel1,madison3,slicky,shokolad,serenit,jmh1978,soccer123,chris3,drwho,rfpzdrf,1qasw23ed,free4me,wonka,sasquatc,sanan,maytag,verochka,bankone,molly12,monopoli,xfqybr,lamborgini,gondolin,candycane,needsome,jb007,scottie1,brigit,0147258369,kalamazo,lololyo123,bill1234,ilovejes,lol123123,popkorn,april13,567rntvm,downunde,charle1,angelbab,guildwars,homeworld,qazxcvbnm,superma1,dupa123,kryptoni,happyy,artyom,stormie,cool11,calvin69,saphir,konovalov,jansport,october8,liebling,druuna,susans,megans,tujhjdf,wmegrfux,jumbo1,ljb4dt7n,012345678910,kolesnik,speculum,at4gftlw,kurgan,93pn75,cahek0980,dallas01,godswill,fhifdby,chelsea4,jump23,barsoom,catinhat,urlacher,angel99,vidadi1,678910,lickme69,topaz1,westend,loveone,c12345,gold12,alex1959,mamon,barney12,1maggie,alex12345,lp2568cskt,s1234567,gjikbdctyf,anthony0,browns99,chips1,sunking,widespre,lalala1,tdutif,fucklife,master00,alino4ka,stakan,blonde1,phoebus,tenore,bvgthbz,brunos,suzjv8,uvdwgt,revenant,1banana,veroniqu,sexfun,sp1der,4g3izhox,isakov,shiva1,scooba,bluefire,wizard12,dimitris,funbags,perseus,hoodoo,keving,malboro,157953,a32tv8ls,latics,animate,mossad,yejntb,karting,qmpq39zr,busdrive,jtuac3my,jkne9y,sr20dett,4gxrzemq,keylargo,741147,rfktylfhm,toast1,skins1,xcalibur,gattone,seether,kameron,glock9mm,julio1,delenn,gameday,tommyd,str8edge,bulls123,66699,carlsberg,woodbird,adnama,45auto,codyman,truck2,1w2w3w4w,pvjegu,method1,luetdi,41d8cd98f00b,bankai,5432112345,94rwpe,reneee,chrisx,melvins,775577,sam2000,scrappy1,rachid,grizzley,margare,morgan01,winstons,gevorg,gonzal,crawdad,gfhfdjp,babilon,noneya,pussy11,barbell,easyride,c00li0,777771,311music,karla1,golions,19866891,peejay,leadfoot,hfvbkm,kr9z40sy,cobra123,isotwe,grizz,sallys,****you,aaa123a,dembel,foxs14,hillcres,webman,mudshark,alfredo1,weeded,lester1,hovepark,ratface,000777fffa,huskie,wildthing,elbarto,waikiki,masami,call911,goose2,regin,dovajb,agricola,cjytxrj,andy11,penny123,family01,a121212,1braves,upupa68,happy100,824655,cjlove,firsttim,kalel,redhair,dfhtymt,sliders,bananna,loverbo,fifa2008,crouton,chevy350,panties2,kolya1,alyona,hagrid,spagetti,q2w3e4r,867530,narkoman,nhfdvfnjkju123,1ccccccc,napolean,0072563,allay,w8sted,wigwam,jamesk,state1,parovoz,beach69,kevinb,rossella,logitech1,celula,gnocca,canucks1,loginova,marlboro1,aaaa1,kalleanka,mester,mishutka,milenko,alibek,jersey1,peterc,1mouse,nedved,blackone,ghfplybr,682regkh,beejay,newburgh,ruffian,clarets,noreaga,xenophon,hummerh2,tenshi,smeagol,soloyo,vfhnby,ereiamjh,ewq321,goomie,sportin,cellphone,sonnie,jetblack,saudan,gblfhfc,matheus,uhfvjnf,alicja,jayman1,devon1,hexagon,bailey2,vtufajy,yankees7,salty1,908070,killemal,gammas,eurocard,sydney12,tuesday1,antietam,wayfarer,beast666,19952009sa,aq12ws,eveli,hockey21,haloreach,dontcare,xxxx1,andrea11,karlmarx,jelszo,tylerb,protools,timberwolf,ruffneck,pololo,1bbbbb,waleed,sasami,twinss,fairlady,illuminati,alex007,sucks1,homerjay,scooter7,tarbaby,barmaley,amistad,vanes,randers,tigers12,dreamer2,goleafsg,googie,bernie1,as12345,godeep,james3,phanto,gwbush,cumlover,2196dc,studioworks,995511,golf56,titova,kaleka,itali,socks1,kurwamac,daisuke,hevonen,woody123,daisie,wouter,henry123,gostosa,guppie,porpoise,iamsexy,276115,paula123,1020315,38gjgeuftd,rjrfrjkf,knotty,idiot1,sasha12345,matrix13,securit,radical1,ag764ks,jsmith,coolguy1,secretar,juanas,sasha1988,itout,00000001,tiger11,1butthea,putain,cavalo,basia1,kobebryant,1232323,12345asdfg,sunsh1ne,cyfqgth,tomkat,dorota,dashit,pelmen,5t6y7u,whipit,smokeone,helloall,bonjour1,snowshoe,nilknarf,x1x2x3,lammas,1234599,lol123456,atombomb,ironchef,noclue,alekseev,gwbush1,silver2,12345678m,yesican,fahjlbnf,chapstic,alex95,open1,tiger200,lisichka,pogiako,cbr929,searchin,tanya123,alex1973,phil413,alex1991,dominati,geckos,freddi,silenthill,egroeg,vorobey,antoxa,dark666,shkola,apple22,rebellio,shamanking,7f8srt,cumsucker,partagas,bill99,22223333,arnster55,fucknuts,proxima,silversi,goblues,parcells,vfrcbvjdf,piloto,avocet,emily2,1597530,miniskir,himitsu,pepper2,juiceman,venom1,bogdana,jujube,quatro,botafogo,mama2010,junior12,derrickh,asdfrewq,miller2,chitarra,silverfox,napol,prestigio,devil123,mm111qm,ara123,max33484,sex2000,primo1,sephan,anyuta,alena2010,viborg,verysexy,hibiscus,terps,josefin,oxcart,spooker,speciali,raffaello,partyon,vfhvtkflrf,strela,a123456z,worksuck,glasss,lomonosov,dusty123,dukeblue,1winter,sergeeva,lala123,john22,cmc09,sobolev,bettylou,dannyb,gjkrjdybr,hagakure,iecnhbr,awsedr,pmdmsctsk,costco,alekseeva,fktrcttd,bazuka,flyingv,garuda,buffy16,gutierre,beer12,stomatolog,ernies,palmeiras,golf123,love269,n.kmgfy,gjkysqgbpltw,youare,joeboo,baksik,lifeguar,111a111,nascar8,mindgame,dude1,neopets,frdfkfyu,june24,phoenix8,penelopa,merlin99,mercenar,badluck,mishel,bookert,deadsexy,power9,chinchil,1234567m,alex10,skunk1,rfhkcjy,sammycat,wright1,randy2,marakesh,temppassword,elmer251,mooki,patrick0,bonoedge,1tits,chiar,kylie1,graffix,milkman1,cornel,mrkitty,nicole12,ticketmaster,beatles4,number20,ffff1,terps1,superfre,yfdbufnjh,jake1234,flblfc,1111qq,zanuda,jmol01,wpoolejr,polopol,nicolett,omega13,cannonba,123456789.,sandy69,ribeye,bo243ns,marilena,bogdan123,milla,redskins1,19733791,alias1,movie1,ducat,marzena,shadowru,56565,coolman1,pornlover,teepee,spiff,nafanya,gateway3,fuckyou0,hasher,34778,booboo69,staticx,hang10,qq12345,garnier,bosco123,1234567qw,carson1,samso,1xrg4kcq,cbr929rr,allan123,motorbik,andrew22,pussy101,miroslava,cytujdbr,camp0017,cobweb,snusmumrik,salmon1,cindy2,aliya,serendipity,co437at,tincouch,timmy123,hunter22,st1100,vvvvvv1,blanka,krondor,sweeti,nenit,kuzmich,gustavo1,bmw320i,alex2010,trees1,kyliem,essayons,april26,kumari,sprin,fajita,appletre,fghbjhb,1green,katieb,steven2,corrado1,satelite,1michell,123456789c,cfkfvfylhf,acurarsx,slut543,inhere,bob2000,pouncer,k123456789,fishie,aliso,audia8,bluetick,soccer69,jordan99,fromhell,mammoth1,fighting54,mike25,pepper11,extra1,worldwid,chaise,vfr800,sordfish,almat,nofate,listopad,hellgate,dctvghbdf,jeremia,qantas,lokiju,honker,sprint1,maral,triniti,compaq3,sixsix6,married1,loveman,juggalo1,repvtyrj,zxcasdqw,123445,whore1,123678,monkey6,west123,warcraf,pwnage,mystery1,creamyou,ant123,rehjgfnrf,corona1,coleman1,steve121,alderaan,barnaul,celeste1,junebug1,bombshel,gretzky9,tankist,targa,cachou,vaz2101,playgolf,boneyard,strateg,romawka,iforgotit,pullup,garbage1,irock,archmage,shaft1,oceano,sadies,alvin1,135135ab,psalm69,lmfao,ranger02,zaharova,33334444,perkman,realman,salguod,cmoney,astonmartin,glock1,greyfox,viper99,helpm,blackdick,46775575,family5,shazbot,dewey1,qwertyas,shivani,black22,mailman1,greenday1,57392632,red007,stanky,sanchez1,tysons,daruma,altosax,krayzie,85852008,1forever,98798798,irock.,123456654,142536789,ford22,brick1,michela,preciou,crazy4u,01telemike01,nolife,concac,safety1,annie123,brunswic,destini,123456qwer,madison0,snowball1,137946,1133557799,jarule,scout2,songohan,thedead,00009999,murphy01,spycam,hirsute,aurinko,associat,1miller,baklan,hermes1,2183rm,martie,kangoo,shweta,yvonne1,westsid,jackpot1,rotciv,maratik,fabrika,claude1,nursultan,noentry,ytnhjufnm,electra1,ghjcnjnfr1,puneet,smokey01,integrit,bugeye,trouble2,14071789,paul01,omgwtf,dmh415,ekilpool,yourmom1,moimeme,sparky11,boludo,ruslan123,kissme1,demetrio,appelsin,asshole3,raiders2,bunns,fynjybj,billygoa,p030710p$e4o,macdonal,248ujnfk,acorns,schmidt1,sparrow1,vinbylrj,weasle,jerom,ycwvrxxh,skywalk,gerlinde,solidus,postal1,poochie1,1charles,rhianna,terorist,rehnrf,omgwtfbbq,assfucke,deadend,zidan,jimboy,vengence,maroon5,7452tr,dalejr88,sombra,anatole,elodi,amazonas,147789,q12345q,gawker1,juanma,kassidy,greek1,bruces,bilbob,mike44,0o9i8u7y6t,kaligula,agentx,familie,anders1,pimpjuice,0128um,birthday10,lawncare,hownow,grandorgue,juggerna,scarfac,kensai,swatteam,123four,motorbike,repytxbr,other1,celicagt,pleomax,gen0303,godisgreat,icepick,lucifer666,heavy1,tea4two,forsure,02020,shortdog,webhead,chris13,palenque,3techsrl,knights1,orenburg,prong,nomarg,wutang1,80637852730,laika,iamfree,12345670,pillow1,12343412,bigears,peterg,stunna,rocky5,12123434,damir,feuerwehr,7418529630,danone,yanina,valenci,andy69,111222q,silvia1,1jjjjj,loveforever,passwo1,stratocaster,8928190a,motorolla,lateralu,ujujkm,chubba,ujkjdf,signon,123456789zx,serdce,stevo,wifey200,ololo123,popeye1,1pass,central1,melena,luxor,nemezida,poker123,ilovemusic,qaz1234,noodles1,lakeshow,amarill,ginseng,billiam,trento,321cba,fatback,soccer33,master13,marie2,newcar,bigtop,dark1,camron,nosgoth,155555,biglou,redbud,jordan7,159789,diversio,actros,dazed,drizzit,hjcnjd,wiktoria,justic,gooses,luzifer,darren1,chynna,tanuki,11335577,icculus,boobss,biggi,firstson,ceisi123,gatewa,hrothgar,jarhead1,happyjoy,felipe1,bebop1,medman,athena1,boneman,keiths,djljgfl,dicklick,russ120,mylady,zxcdsa,rock12,bluesea,kayaks,provista,luckies,smile4me,bootycal,enduro,123123f,heartbre,ern3sto,apple13,bigpappa,fy.njxrf,bigtom,cool69,perrito,quiet1,puszek,cious,cruella,temp1,david26,alemap,aa123123,teddies,tricolor,smokey12,kikiriki,mickey01,robert01,super5,ranman,stevenso,deliciou,money777,degauss,mozar,susanne1,asdasd12,shitbag,mommy123,wrestle1,imfree,fuckyou12,barbaris,florent,ujhijr,f8yruxoj,tefjps,anemone,toltec,2gether,left4dead2,ximen,gfkmvf,dunca,emilys,diana123,16473a,mark01,bigbro,annarbor,nikita2000,11aa11,tigres,llllll1,loser2,fbi11213,jupite,qwaszxqw,macabre,123ert,rev2000,mooooo,klapaucius,bagel1,chiquit,iyaoyas,bear101,irocz28,vfktymrfz,smokey2,love99,rfhnbyf,dracul,keith123,slicko,peacock1,orgasmic,thesnake,solder,wetass,doofer,david5,rhfcyjlfh,swanny,tammys,turkiye,tubaman,estefani,firehose,funnyguy,servo,grace17,pippa1,arbiter,jimmy69,nfymrf,asdf67nm,rjcnzy,demon123,thicknes,sexysex,kristall,michail,encarta,banderos,minty,marchenko,de1987ma,mo5kva,aircav,naomi1,bonni,tatoo,cronaldo,49ers1,mama1963,1truck,telecaster,punksnotdead,erotik,1eagles,1fender,luv269,acdeehan,tanner1,freema,1q3e5t7u,linksys,tiger6,megaman1,neophyte,australia1,mydaddy,1jeffrey,fgdfgdfg,gfgekz,1986irachka,keyman,m0b1l3,dfcz123,mikeyg,playstation2,abc125,slacker1,110491g,lordsoth,bhavani,ssecca,dctvghbdtn,niblick,hondacar,baby01,worldcom,4034407,51094didi,3657549,3630000,3578951,sweetpussy,majick,supercoo,robert11,abacabb,panda123,gfhjkm13,ford4x4,zippo1,lapin,1726354,lovesong,dude11,moebius,paravoz,1357642,matkhau,solnyshko,daniel4,multiplelog,starik,martusia,iamtheman,greentre,jetblue,motorrad,vfrcbvev,redoak,dogma1,gnorman,komlos,tonka1,1010220,666satan,losenord,lateralus,absinthe,command1,jigga1,iiiiiii1,pants1,jungfrau,926337,ufhhbgjnnth,yamakasi,888555,sunny7,gemini69,alone1,zxcvbnmz,cabezon,skyblues,zxc1234,456123a,zero00,caseih,azzurra,legolas1,menudo,murcielago,785612,779977,benidorm,viperman,dima1985,piglet1,hemligt,hotfeet,7elephants,hardup,gamess,a000000,267ksyjf,kaitlynn,sharkie,sisyphus,yellow22,667766,redvette,666420,mets69,ac2zxdty,hxxrvwcy,cdavis,alan1,noddy,579300,druss,eatshit1,555123,appleseed,simpleplan,kazak,526282,fynfyfyfhbde,birthday6,dragon6,1pookie,bluedevils,omg123,hj8z6e,x5dxwp,455445,batman23,termin,chrisbrown,animals1,lucky9,443322,kzktxrf,takayuki,fermer,assembler,zomu9q,sissyboy,sergant,felina,nokia6230i,eminem12,croco,hunt4red,festina,darknigh,cptnz062,ndshnx4s,twizzler,wnmaz7sd,aamaax,gfhfcjkmrf,alabama123,barrynov,happy5,punt0it,durandal,8xuuobe4,cmu9ggzh,bruno12,316497,crazyfrog,vfvfktyf,apple3,kasey1,mackdaddy,anthon1,sunnys,angel3,cribbage,moon1,donal,bryce1,pandabear,mwss474,whitesta,freaker,197100,bitche,p2ssw0rd,turnb,tiktonik,moonlite,ferret1,jackas,ferrum,bearclaw,liberty2,1diablo,caribe,snakeeyes,janbam,azonic,rainmaker,vetalik,bigeasy,baby1234,sureno13,blink1,kluivert,calbears,lavanda,198600,dhtlbyf,medvedeva,fox123,whirling,bonscott,freedom9,october3,manoman,segredo,cerulean,robinso,bsmith,flatus,dannon,password21,rrrrrr1,callista,romai,rainman1,trantor,mickeymo,bulldog7,g123456,pavlin,pass22,snowie,hookah,7ofnine,bubba22,cabible,nicerack,moomoo1,summer98,yoyo123,milan1,lieve27,mustang69,jackster,exocet,nadege,qaz12,bahama,watson1,libras,eclipse2,bahram,bapezm,up9x8rww,ghjcnjz,themaste,deflep27,ghost16,gattaca,fotograf,junior123,gilber,gbjyth,8vjzus,rosco1,begonia,aldebara,flower12,novastar,buzzman,manchild,lopez1,mama11,william7,yfcnz1,blackstar,spurs123,moom4242,1amber,iownyou,tightend,07931505,paquito,1johnson,smokepot,pi31415,snowmass,ayacdc,jessicam,giuliana,5tgbnhy6,harlee,giuli,bigwig,tentacle,scoubidou2,benelli,vasilina,nimda,284655,jaihind,lero4ka,1tommy,reggi,ididit,jlbyjxtcndj,mike26,qbert,wweraw,lukasz,loosee123,palantir,flint1,mapper,baldie,saturne,virgin1,meeeee,elkcit,iloveme2,blue15,themoon,radmir,number3,shyanne,missle,hannelor,jasmina,karin1,lewie622,ghjcnjqgfhjkm,blasters,oiseau,sheela,grinders,panget,rapido,positiv,twink,fltkbyf,kzsfj874,daniel01,enjoyit,nofags,doodad,rustler,squealer,fortunat,peace123,khushi,devils2,7inches,candlebo,topdawg,armen,soundman,zxcqweasd,april7,gazeta,netman,hoppers,bear99,ghbjhbntn,mantle7,bigbo,harpo,jgordon,bullshi,vinny1,krishn,star22,thunderc,galinka,phish123,tintable,nightcrawler,tigerboy,rbhgbx,messi,basilisk,masha1998,nina123,yomamma,kayla123,geemoney,0000000000d,motoman,a3jtni,ser123,owen10,italien,vintelok,12345rewq,nightime,jeepin,ch1tt1ck,mxyzptlk,bandido,ohboy,doctorj,hussar,superted,parfilev,grundle,1jack,livestrong,chrisj,matthew3,access22,moikka,fatone,miguelit,trivium,glenn1,smooches,heiko,dezember,spaghett,stason,molokai,bossdog,guitarma,waderh,boriska,photosho,path13,hfrtnf,audre,junior24,monkey24,silke,vaz21093,bigblue1,trident1,candide,arcanum,klinker,orange99,bengals1,rosebu,mjujuj,nallepuh,mtwapa1a,ranger69,level1,bissjop,leica,1tiffany,rutabega,elvis77,kellie1,sameas,barada,karabas,frank12,queenb,toutoune,surfcity,samanth1,monitor1,littledo,kazakova,fodase,mistral1,april22,carlit,shakal,batman123,fuckoff2,alpha01,5544332211,buddy3,towtruck,kenwood1,vfiekmrf,jkl123,pypsik,ranger75,sitges,toyman,bartek1,ladygirl,booman,boeing77,installsqlst,222666,gosling,bigmack,223311,bogos,kevin2,gomez1,xohzi3g4,kfnju842,klubnika,cubalibr,123456789101,kenpo,0147852369,raptor1,tallulah,boobys,jjones,1q2s3c,moogie,vid2600,almas,wombat1,extra300,xfiles1,green77,sexsex1,heyjude,sammyy,missy123,maiyeuem,nccpl25282,thicluv,sissie,raven3,fldjrfn,buster22,broncos2,laurab,letmein4,harrydog,solovey,fishlips,asdf4321,ford123,superjet,norwegen,movieman,psw333333,intoit,postbank,deepwate,ola123,geolog323,murphys,eshort,a3eilm2s2y,kimota,belous,saurus,123321qaz,i81b4u,aaa12,monkey20,buckwild,byabybnb,mapleleafs,yfcnzyfcnz,baby69,summer03,twista,246890,246824,ltcnhjth,z1z2z3,monika1,sad123,uto29321,bathory,villan,funkey,poptarts,spam967888,705499fh,sebast,porn1234,earn381,1porsche,whatthef,123456789y,polo12,brillo,soreilly,waters1,eudora,allochka,is_a_bot,winter00,bassplay,531879fiz,onemore,bjarne,red911,kot123,artur1,qazxdr,c0rvette,diamond7,matematica,klesko,beaver12,2enter,seashell,panam,chaching,edward2,browni,xenogear,cornfed,aniram,chicco22,darwin1,ancella2,sophie2,vika1998,anneli,shawn41,babie,resolute,pandora2,william8,twoone,coors1,jesusis1,teh012,cheerlea,renfield,tessa1,anna1986,madness1,bkmlfh,19719870,liebherr,ck6znp42,gary123,123654z,alsscan,eyedoc,matrix7,metalgea,chinito,4iter,falcon11,7jokx7b9du,bigfeet,tassadar,retnuh,muscle1,klimova,darion,batistuta,bigsur,1herbier,noonie,ghjrehjh,karimova,faustus,snowwhite,1manager,dasboot,michael12,analfuck,inbed,dwdrums,jaysoncj,maranell,bsheep75,164379,rolodex,166666,rrrrrrr1,almaz666,167943,russel1,negrito,alianz,goodpussy,veronik,1w2q3r4e,efremov,emb377,sdpass,william6,alanfahy,nastya1995,panther5,automag,123qwe12,vfvf2011,fishe,1peanut,speedie,qazwsx1234,pass999,171204j,ketamine,sheena1,energizer,usethis1,123abc123,buster21,thechamp,flvbhfk,frank69,chane,hopeful1,claybird,pander,anusha,bigmaxxx,faktor,housebed,dimidrol,bigball,shashi,derby1,fredy,dervish,bootycall,80988218126,killerb,cheese2,pariss,mymail,dell123,catbert,christa1,chevytru,gjgjdf,00998877,overdriv,ratten,golf01,nyyanks,dinamite,bloembol,gismo,magnus1,march2,twinkles,ryan22,duckey,118a105b,kitcat,brielle,poussin,lanzarot,youngone,ssvegeta,hero63,battle1,kiler,fktrcfylh1,newera,vika1996,dynomite,oooppp,beer4me,foodie,ljhjuf,sonshine,godess,doug1,constanc,thinkbig,steve2,damnyou,autogod,www333,kyle1,ranger7,roller1,harry2,dustin1,hopalong,tkachuk,b00bies,bill2,deep111,stuffit,fire69,redfish1,andrei123,graphix,1fishing,kimbo1,mlesp31,ifufkbyf,gurkan,44556,emily123,busman,and123,8546404,paladine,1world,bulgakov,4294967296,bball23,1wwwww,mycats,elain,delta6,36363,emilyb,color1,6060842,cdtnkfyrf,hedonism,gfgfrfhkj,5551298,scubad,gostate,sillyme,hdbiker,beardown,fishers,sektor,00000007,newbaby,rapid1,braves95,gator2,nigge,anthony3,sammmy,oou812,heffer,phishin,roxanne1,yourass,hornet1,albator,2521659,underwat,tanusha,dianas,3f3fpht7op,dragon20,bilbobag,cheroke,radiatio,dwarf1,majik,33st33,dochka,garibald,robinh,sham69,temp01,wakeboar,violet1,1w2w3w,registr,tonite,maranello,1593570,parolamea,galatasara,loranthos,1472583,asmodean,1362840,scylla,doneit,jokerr,porkypig,kungen,mercator,koolhaas,come2me,debbie69,calbear,liverpoolfc,yankees4,12344321a,kennyb,madma,85200258,dustin23,thomas13,tooling,mikasa,mistic,crfnbyf,112233445,sofia1,heinz57,colts1,price1,snowey,joakim,mark11,963147,cnhfcnm,kzinti,1bbbbbbb,rubberdu,donthate,rupert1,sasha1992,regis1,nbuhbwf,fanboy,sundial,sooner1,wayout,vjnjhjkf,deskpro,arkangel,willie12,mikeyb,celtic1888,luis1,buddy01,duane1,grandma1,aolcom,weeman,172839456,basshead,hornball,magnu,pagedown,molly2,131517,rfvtgbyhn,astonmar,mistery,madalina,cash1,1happy,shenlong,matrix01,nazarova,369874125,800500,webguy,rse2540,ashley2,briank,789551,786110,chunli,j0nathan,greshnik,courtne,suckmyco,mjollnir,789632147,asdfg1234,754321,odelay,ranma12,zebedee,artem777,bmw318is,butt1,rambler1,yankees9,alabam,5w76rnqp,rosies,mafioso,studio1,babyruth,tranzit,magical123,gfhjkm135,12345$,soboleva,709394,ubique,drizzt1,elmers,teamster,pokemons,1472583690,1597532486,shockers,merckx,melanie2,ttocs,clarisse,earth1,dennys,slobber,flagman,farfalla,troika,4fa82hyx,hakan,x4ww5qdr,cumsuck,leather1,forum1,july20,barbel,zodiak,samuel12,ford01,rushfan,bugsy1,invest1,tumadre,screwme,a666666,money5,henry8,tiddles,sailaway,starburs,100years,killer01,comando,hiromi,ranetka,thordog,blackhole,palmeira,verboten,solidsna,q1w1e1,humme,kevinc,gbrfxe,gevaudan,hannah11,peter2,vangar,sharky7,talktome,jesse123,chuchi,pammy,!qazxsw2,siesta,twenty1,wetwilly,477041,natural1,sun123,daniel3,intersta,shithead1,hellyea,bonethugs,solitair,bubbles2,father1,nick01,444000,adidas12,dripik,cameron2,442200,a7nz8546,respublika,fkojn6gb,428054,snoppy,rulez1,haslo,rachael1,purple01,zldej102,ab12cd34,cytuehjxrf,madhu,astroman,preteen,handsoff,mrblonde,biggio,testin,vfdhif,twolves,unclesam,asmara,kpydskcw,lg2wmgvr,grolsch,biarritz,feather1,williamm,s62i93,bone1,penske,337733,336633,taurus1,334433,billet,diamondd,333000,nukem,fishhook,godogs,thehun,lena1982,blue00,smelly1,unb4g9ty,65pjv22,applegat,mikehunt,giancarlo,krillin,felix123,december1,soapy,46doris,nicole23,bigsexy1,justin10,pingu,bambou,falcon12,dgthtl,1surfer,qwerty01,estrellit,nfqcjy,easygo,konica,qazqwe,1234567890m,stingers,nonrev,3e4r5t,champio,bbbbbb99,196400,allen123,seppel,simba2,rockme,zebra3,tekken3,endgame,sandy2,197300,fitte,monkey00,eldritch,littleone,rfyfgkz,1member,66chevy,oohrah,cormac,hpmrbm41,197600,grayfox,elvis69,celebrit,maxwell7,rodders,krist,1camaro,broken1,kendall1,silkcut,katenka,angrick,maruni,17071994a,tktyf,kruemel,snuffles,iro4ka,baby12,alexis01,marryme,vlad1994,forward1,culero,badaboom,malvin,hardtoon,hatelove,molley,knopo4ka,duchess1,mensuck,cba321,kickbutt,zastava,wayner,fuckyou6,eddie123,cjkysir,john33,dragonfi,cody1,jabell,cjhjrf,badseed,sweden1,marihuana,brownlov,elland,nike1234,kwiettie,jonnyboy,togepi,billyk,robert123,bb334,florenci,ssgoku,198910,bristol1,bob007,allister,yjdujhjl,gauloise,198920,bellaboo,9lives,aguilas,wltfg4ta,foxyroxy,rocket69,fifty50,babalu,master21,malinois,kaluga,gogosox,obsessio,yeahrigh,panthers1,capstan,liza2000,leigh1,paintball1,blueskie,cbr600f3,bagdad,jose98,mandreki,shark01,wonderbo,muledeer,xsvnd4b2,hangten,200001,grenden,anaell,apa195,model1,245lufpq,zip100,ghjcgtrn,wert1234,misty2,charro,juanjose,fkbcrf,frostbit,badminto,buddyy,1doctor,vanya,archibal,parviz,spunky1,footboy,dm6tzsgp,legola,samadhi,poopee,ytdxz2ca,hallowboy,dposton,gautie,theworm,guilherme,dopehead,iluvtits,bobbob1,ranger6,worldwar,lowkey,chewbaca,oooooo99,ducttape,dedalus,celular,8i9o0p,borisenko,taylor01,111111z,arlingto,p3nnywiz,rdgpl3ds,boobless,kcmfwesg,blacksab,mother2,markus1,leachim,secret2,s123456789,1derful,espero,russell2,tazzer,marykate,freakme,mollyb,lindros8,james00,gofaster,stokrotka,kilbosik,aquamann,pawel1,shedevil,mousie,slot2009,october6,146969,mm259up,brewcrew,choucho,uliana,sexfiend,fktirf,pantss,vladimi,starz,sheeps,12341234q,bigun,tiggers,crjhjcnm,libtech,pudge1,home12,zircon,klaus1,jerry2,pink1,lingus,monkey66,dumass,polopolo09,feuerweh,rjyatnf,chessy,beefer,shamen,poohbear1,4jjcho,bennevis,fatgirls,ujnbrf,cdexswzaq,9noize9,rich123,nomoney,racecar1,hacke,clahay,acuario,getsum,hondacrv,william0,cheyenn,techdeck,atljhjdf,wtcacq,suger,fallenangel,bammer,tranquil,carla123,relayer,lespaul1,portvale,idontno,bycnbnen,trooper2,gennadiy,pompon,billbob,amazonka,akitas,chinatow,atkbrc,busters,fitness1,cateye,selfok2013,1murphy,fullhous,mucker,bajskorv,nectarin,littlebitch,love24,feyenoor,bigal37,lambo1,pussybitch,icecube1,biged,kyocera,ltybcjdf,boodle,theking1,gotrice,sunset1,abm1224,fromme,sexsells,inheat,kenya1,swinger1,aphrodit,kurtcobain,rhind101,poidog,poiulkjh,kuzmina,beantown,tony88,stuttgar,drumer,joaqui,messenge,motorman,amber2,nicegirl,rachel69,andreia,faith123,studmuffin,jaiden,red111,vtkmybr,gamecocks,gumper,bosshogg,4me2know,tokyo1,kleaner,roadhog,fuckmeno,phoenix3,seeme,buttnutt,boner69,andreyka,myheart,katerin,rugburn,jvtuepip,dc3ubn,chile1,ashley69,happy99,swissair,balls2,fylhttdf,jimboo,55555d,mickey11,voronin,m7hsqstm,stufff,merete,weihnachte,dowjones,baloo1,freeones,bears34,auburn1,beverl,timberland,1elvis,guinness1,bombadil,flatron1,logging7,telefoon,merl1n,masha1,andrei1,cowabung,yousuck1,1matrix,peopl,asd123qwe,sweett,mirror1,torrente,joker12,diamond6,jackaroo,00000a,millerlite,ironhorse,2twins,stryke,gggg1,zzzxxxccc,roosevel,8363eddy,angel21,depeche1,d0ct0r,blue14,areyou,veloce,grendal,frederiksberg,cbcntvf,cb207sl,sasha2000,was.here,fritzz,rosedale,spinoza,cokeisit,gandalf3,skidmark,ashley01,12345j,1234567890qaz,sexxxxxx,beagles,lennart,12345789,pass10,politic,max007,gcheckou,12345611,tiffy,lightman,mushin,velosiped,brucewayne,gauthie,elena123,greenegg,h2oski,clocker,nitemare,123321s,megiddo,cassidy1,david13,boywonde,flori,peggy12,pgszt6md,batterie,redlands,scooter6,bckhere,trueno,bailey11,maxwell2,bandana,timoth1,startnow,ducati74,tiern,maxine1,blackmetal,suzyq,balla007,phatfarm,kirsten1,titmouse,benhogan,culito,forbin,chess1,warren1,panman,mickey7,24lover,dascha,speed2,redlion,andrew10,johnwayn,nike23,chacha1,bendog,bullyboy,goldtree,spookie,tigger99,1cookie,poutine,cyclone1,woodpony,camaleun,bluesky1,dfadan,eagles20,lovergirl,peepshow,mine1,dima1989,rjdfkmxer,11111aaaaa,machina,august17,1hhhhh,0773417k,1monster,freaksho,jazzmin,davidw,kurupt,chumly,huggies,sashenka,ccccccc1,bridge1,giggalo,cincinna,pistol1,hello22,david77,lightfoo,lucky6,jimmy12,261397,lisa12,tabaluga,mysite,belo4ka,greenn,eagle99,punkrawk,salvado,slick123,wichsen,knight99,dummys,fefolico,contrera,kalle1,anna1984,delray,robert99,garena,pretende,racefan,alons,serenada,ludmilla,cnhtkjr,l0swf9gx,hankster,dfktynbyrf,sheep1,john23,cv141ab,kalyani,944turbo,crystal2,blackfly,zrjdktdf,eus1sue1,mario5,riverplate,harddriv,melissa3,elliott1,sexybitc,cnhfyybr,jimdavis,bollix,beta1,amberlee,skywalk1,natala,1blood,brattax,shitty1,gb15kv99,ronjon,rothmans,thedoc,joey21,hotboi,firedawg,bimbo38,jibber,aftermat,nomar,01478963,phishing,domodo,anna13,materia,martha1,budman1,gunblade,exclusiv,sasha1997,anastas,rebecca2,fackyou,kallisti,fuckmyass,norseman,ipswich1,151500,1edward,intelinside,darcy1,bcrich,yjdjcnbf,failte,buzzzz,cream1,tatiana1,7eleven,green8,153351,1a2s3d4f5g6h,154263,milano1,bambi1,bruins77,rugby2,jamal1,bolita,sundaypunch,bubba12,realmadr,vfyxtcnth,iwojima,notlob,black666,valkiria,nexus1,millerti,birthday100,swiss1,appollo,gefest,greeneyes,celebrat,tigerr,slava123,izumrud,bubbabub,legoman,joesmith,katya123,sweetdream,john44,wwwwwww1,oooooo1,socal,lovespor,s5r8ed67s,258147,heidis,cowboy22,wachovia,michaelb,qwe1234567,i12345,255225,goldie1,alfa155,45colt,safeu851,antonova,longtong,1sparky,gfvznm,busen,hjlbjy,whateva,rocky4,cokeman,joshua3,kekskek1,sirocco,jagman,123456qwert,phinupi,thomas10,loller,sakur,vika2011,fullred,mariska,azucar,ncstate,glenn74,halima,aleshka,ilovemylife,verlaat,baggie,scoubidou6,phatboy,jbruton,scoop1,barney11,blindman,def456,maximus2,master55,nestea,11223355,diego123,sexpistols,sniffy,philip1,f12345,prisonbreak,nokia2700,ajnjuhfa,yankees3,colfax,ak470000,mtnman,bdfyeirf,fotball,ichbin,trebla,ilusha,riobravo,beaner1,thoradin,polkaudi,kurosawa,honda123,ladybu,valerik,poltava,saviola,fuckyouguys,754740g0,anallove,microlab1,juris01,ncc1864,garfild,shania1,qagsud,makarenko,cindy69,lebedev,andrew11,johnnybo,groovy1,booster1,sanders1,tommyb,johnson4,kd189nlcih,hondaman,vlasova,chick1,sokada,sevisgur,bear2327,chacho,sexmania,roma1993,hjcnbckfd,valley1,howdie,tuppence,jimandanne,strike3,y4kuz4,nhfnfnf,tsubasa,19955991,scabby,quincunx,dima1998,uuuuuu1,logica,skinner1,pinguino,lisa1234,xpressmusic,getfucked,qqqq1,bbbb1,matulino,ulyana,upsman,johnsmith,123579,co2000,spanner1,todiefor,mangoes,isabel1,123852,negra,snowdon,nikki123,bronx1,booom,ram2500,chuck123,fireboy,creek1,batman13,princesse,az12345,maksat,1knight,28infern,241455,r7112s,muselman,mets1986,katydid,vlad777,playme,kmfdm1,asssex,1prince,iop890,bigbroth,mollymoo,waitron,lizottes,125412,juggler,quinta,0sister0,zanardi,nata123,heckfyxbr,22q04w90e,engine2,nikita95,zamira,hammer22,lutscher,carolina1,zz6319,sanman,vfuflfy,buster99,rossco,kourniko,aggarwal,tattoo1,janice1,finger1,125521,19911992,shdwlnds,rudenko,vfvfgfgf123,galatea,monkeybu,juhani,premiumcash,classact,devilmay,helpme2,knuddel,hardpack,ramil,perrit,basil1,zombie13,stockcar,tos8217,honeypie,nowayman,alphadog,melon1,talula,125689,tiribon12,tornike,haribol,telefone,tiger22,sucka,lfytxrf,chicken123,muggins,a23456,b1234567,lytdybr,otter1,pippa,vasilisk,cooking1,helter,78978,bestboy,viper7,ahmed1,whitewol,mommys,apple5,shazam1,chelsea7,kumiko,masterma,rallye,bushmast,jkz123,entrar,andrew6,nathan01,alaric,tavasz,heimdall,gravy1,jimmy99,cthlwt,powerr,gthtrhtcnjr,canesfan,sasha11,ybrbnf_25,august9,brucie,artichok,arnie1,superdude,tarelka,mickey22,dooper,luners,holeshot,good123,gettysbu,bicho,hammer99,divine5,1zxcvbn,stronzo,q22222,disne,bmw750il,godhead,hallodu,aerith,nastik,differen,cestmoi,amber69,5string,pornosta,dirtygirl,ginger123,formel1,scott12,honda200,hotspurs,johnatha,firstone123,lexmark1,msconfig,karlmasc,l123456,123qweasdzx,baldman,sungod,furka,retsub,9811020,ryder1,tcglyued,astron,lbvfcbr,minddoc,dirt49,baseball12,tbear,simpl,schuey,artimus,bikman,plat1num,quantex,gotyou,hailey1,justin01,ellada,8481068,000002,manimal,dthjybxrf,buck123,dick123,6969696,nospam,strong1,kodeord,bama12,123321w,superman123,gladiolus,nintend,5792076,dreamgirl,spankme1,gautam,arianna1,titti,tetas,cool1234,belladog,importan,4206969,87e5nclizry,teufelo7,doller,yfl.irf,quaresma,3440172,melis,bradle,nnmaster,fast1,iverso,blargh,lucas12,chrisg,iamsam,123321az,tomjerry,kawika,2597174,standrew,billyg,muskan,gizmodo2,rz93qpmq,870621345,sathya,qmezrxg4,januari,marthe,moom4261,cum2me,hkger286,lou1988,suckit1,croaker,klaudia1,753951456,aidan1,fsunoles,romanenko,abbydog,isthebes,akshay,corgi,fuck666,walkman555,ranger98,scorpian,hardwareid,bluedragon,fastman,2305822q,iddqdiddqd,1597532,gopokes,zvfrfcb,w1234567,sputnik1,tr1993,pa$$w0rd,2i5fdruv,havvoc,1357913,1313131,bnm123,cowd00d,flexscan,thesims2,boogiema,bigsexxy,powerstr,ngc4565,joshman,babyboy1,123jlb,funfunfu,qwe456,honor1,puttana,bobbyj,daniel21,pussy12,shmuck,1232580,123578951,maxthedo,hithere1,bond0007,gehenna,nomames,blueone,r1234567,bwana,gatinho,1011111,torrents,cinta,123451234,tiger25,money69,edibey,pointman,mmcm19,wales1,caffreys,phaedra,bloodlus,321ret32,rufuss,tarbit,joanna1,102030405,stickboy,lotrfotr34,jamshid,mclarenf1,ataman,99ford,yarrak,logan2,ironlung,pushistik,dragoon1,unclebob,tigereye,pinokio,tylerj,mermaid1,stevie1,jaylen,888777,ramana,roman777,brandon7,17711771s,thiago,luigi1,edgar1,brucey,videogam,classi,birder,faramir,twiddle,cubalibre,grizzy,fucky,jjvwd4,august15,idinahui,ranita,nikita1998,123342,w1w2w3,78621323,4cancel,789963,(null,vassago,jaydog472,123452,timt42,canada99,123589,rebenok,htyfnf,785001,osipov,maks123,neverwinter,love2010,777222,67390436,eleanor1,bykemo,aquemini,frogg,roboto,thorny,shipmate,logcabin,66005918,nokian,gonzos,louisian,1abcdefg,triathlo,ilovemar,couger,letmeino,supera,runvs,fibonacci,muttly,58565254,5thgbqi,vfnehsv,electr,jose12,artemis1,newlove,thd1shr,hawkey,grigoryan,saisha,tosca,redder,lifesux,temple1,bunnyman,thekids,sabbeth,tarzan1,182838,158uefas,dell50,1super,666222,47ds8x,jackhamm,mineonly,rfnfhbyf,048ro,665259,kristina1,bombero,52545856,secure1,bigloser,peterk,alex2,51525354,anarchy1,superx,teenslut,money23,sigmapi,sanfrancisco,acme34,private5,eclips,qwerttrewq,axelle,kokain,hardguy,peter69,jesuschr,dyanna,dude69,sarah69,toyota91,amberr,45645645,bugmenot,bigted,44556677,556644,wwr8x9pu,alphaome,harley13,kolia123,wejrpfpu,revelati,nairda,sodoff,cityboy,pinkpussy,dkalis,miami305,wow12345,triplet,tannenbau,asdfasdf1,darkhors,527952,retired1,soxfan,nfyz123,37583867,goddes,515069,gxlmxbewym,1warrior,36925814,dmb2011,topten,karpova,89876065093rax,naturals,gateway9,cepseoun,turbot,493949,cock22,italia1,sasafras,gopnik,stalke,1qazxdr5,wm2006,ace1062,alieva,blue28,aracel,sandia,motoguzz,terri1,emmajane,conej,recoba,alex1995,jerkyboy,cowboy12,arenrone,precisio,31415927,scsa316,panzer1,studly1,powerhou,bensam,mashoutq,billee,eeyore1,reape,thebeatl,rul3z,montesa,doodle1,cvzefh1gk,424365,a159753,zimmerma,gumdrop,ashaman,grimreap,icandoit,borodina,branca,dima2009,keywest1,vaders,bubluk,diavolo,assss,goleta,eatass,napster1,382436,369741,5411pimo,lenchik,pikach,gilgamesh,kalimera,singer1,gordon2,rjycnbnewbz,maulwurf,joker13,2much4u,bond00,alice123,robotec,fuckgirl,zgjybz,redhorse,margaret1,brady1,pumpkin2,chinky,fourplay,1booger,roisin,1brandon,sandan,blackheart,cheez,blackfin,cntgfyjdf,mymoney1,09080706,goodboss,sebring1,rose1,kensingt,bigboner,marcus12,ym3cautj,struppi,thestone,lovebugs,stater,silver99,forest99,qazwsx12345,vasile,longboar,mkonji,huligan,rhfcbdfz,airmail,porn11,1ooooo,sofun,snake2,msouthwa,dougla,1iceman,shahrukh,sharona,dragon666,france98,196800,196820,ps253535,zjses9evpa,sniper01,design1,konfeta,jack99,drum66,good4you,station2,brucew,regedit,school12,mvtnr765,pub113,fantas,tiburon1,king99,ghjcnjgbpltw,checkito,308win,1ladybug,corneliu,svetasveta,197430,icicle,imaccess,ou81269,jjjdsl,brandon6,bimbo1,smokee,piccolo1,3611jcmg,children2,cookie2,conor1,darth1,margera,aoi856,paully,ou812345,sklave,eklhigcz,30624700,amazing1,wahooo,seau55,1beer,apples2,chulo,dolphin9,heather6,198206,198207,hergood,miracle1,njhyflj,4real,milka,silverfi,fabfive,spring12,ermine,mammy,jumpjet,adilbek,toscana,caustic,hotlove,sammy69,lolita1,byoung,whipme,barney01,mistys,tree1,buster3,kaylin,gfccgjhn,132333,aishiteru,pangaea,fathead1,smurph,198701,ryslan,gasto,xexeylhf,anisimov,chevyss,saskatoo,brandy12,tweaker,irish123,music2,denny1,palpatin,outlaw1,lovesuck,woman1,mrpibb,diadora,hfnfneq,poulette,harlock,mclaren1,cooper12,newpass3,bobby12,rfgecnfcerf,alskdjfh,mini14,dukers,raffael,199103,cleo123,1234567qwertyu,mossberg,scoopy,dctulf,starline,hjvjxrf,misfits1,rangers2,bilbos,blackhea,pappnase,atwork,purple2,daywalker,summoner,1jjjjjjj,swansong,chris10,laluna,12345qqq,charly1,lionsden,money99,silver33,hoghead,bdaddy,199430,saisg002,nosaints,tirpitz,1gggggg,jason13,kingss,ernest1,0cdh0v99ue,pkunzip,arowana,spiri,deskjet1,armine,lances,magic2,thetaxi,14159265,cacique,14142135,orange10,richard0,backdraf,255ooo,humtum,kohsamui,c43dae874d,wrestling1,cbhtym,sorento,megha,pepsiman,qweqwe12,bliss7,mario64,korolev,balls123,schlange,gordit,optiquest,fatdick,fish99,richy,nottoday,dianne1,armyof1,1234qwerasdfzxcv,bbonds,aekara,lidiya,baddog1,yellow5,funkie,ryan01,greentree,gcheckout,marshal1,liliput,000000z,rfhbyrf,gtogto43,rumpole,tarado,marcelit,aqwzsxedc,kenshin1,sassydog,system12,belly1,zilla,kissfan,tools1,desember,donsdad,nick11,scorpio6,poopoo1,toto99,steph123,dogfuck,rocket21,thx113,dude12,sanek,sommar,smacky,pimpsta,letmego,k1200rs,lytghjgtnhjdcr,abigale,buddog,deles,baseball9,roofus,carlsbad,hamzah,hereiam,genial,schoolgirlie,yfz450,breads,piesek,washear,chimay,apocalyp,nicole18,gfgf1234,gobulls,dnevnik,wonderwall,beer1234,1moose,beer69,maryann1,adpass,mike34,birdcage,hottuna,gigant,penquin,praveen,donna123,123lol123,thesame,fregat,adidas11,selrahc,pandoras,test3,chasmo,111222333000,pecos,daniel11,ingersol,shana1,mama12345,cessna15,myhero,1simpson,nazarenko,cognit,seattle2,irina1,azfpc310,rfycthdf,hardy1,jazmyn,sl1200,hotlanta,jason22,kumar123,sujatha,fsd9shtyu,highjump,changer,entertai,kolding,mrbig,sayuri,eagle21,qwertzu,jorge1,0101dd,bigdong,ou812a,sinatra1,htcnjhfy,oleg123,videoman,pbyfblf,tv612se,bigbird1,kenaidog,gunite,silverma,ardmore,123123qq,hotbot,cascada,cbr600f4,harakiri,chico123,boscos,aaron12,glasgow1,kmn5hc,lanfear,1light,liveoak,fizika,ybrjkftdyf,surfside,intermilan,multipas,redcard,72chevy,balata,coolio1,schroede,kanat,testerer,camion,kierra,hejmeddig,antonio2,tornados,isidor,pinkey,n8skfswa,ginny1,houndog,1bill,chris25,hastur,1marine,greatdan,french1,hatman,123qqq,z1z2z3z4,kicker1,katiedog,usopen,smith22,mrmagoo,1234512i,assa123,7seven7,monster7,june12,bpvtyf,149521,guenter,alex1985,voronina,mbkugegs,zaqwsxcderfv,rusty5,mystic1,master0,abcdef12,jndfkb,r4zpm3,cheesey,skripka,blackwhite,sharon69,dro8smwq,lektor,techman,boognish,deidara,heckfyf,quietkey,authcode,monkey4,jayboy,pinkerto,merengue,chulita,bushwick,turambar,kittykit,joseph2,dad123,kristo,pepote,scheiss,hambone1,bigballa,restaura,tequil,111luzer,euro2000,motox,denhaag,chelsi,flaco1,preeti,lillo,1001sin,passw,august24,beatoff,555555d,willis1,kissthis,qwertyz,rvgmw2gl,iloveboobies,timati,kimbo,msinfo,dewdrop,sdbaker,fcc5nky2,messiah1,catboy,small1,chode,beastie1,star77,hvidovre,short1,xavie,dagobah,alex1987,papageno,dakota2,toonami,fuerte,jesus33,lawina,souppp,dirtybir,chrish,naturist,channel1,peyote,flibble,gutentag,lactate,killem,zucchero,robinho,ditka,grumpy1,avr7000,boxxer,topcop,berry1,mypass1,beverly1,deuce1,9638527410,cthuttdf,kzkmrf,lovethem,band1t,cantona1,purple11,apples123,wonderwo,123a456,fuzzie,lucky99,dancer2,hoddling,rockcity,winner12,spooty,mansfiel,aimee1,287hf71h,rudiger,culebra,god123,agent86,daniel0,bunky1,notmine,9ball,goofus,puffy1,xyh28af4,kulikov,bankshot,vurdf5i2,kevinm,ercole,sexygirls,razvan,october7,goater,lollie,raissa,thefrog,mdmaiwa3,mascha,jesussaves,union1,anthony9,crossroa,brother2,areyuke,rodman91,toonsex,dopeman,gericom,vaz2115,cockgobbler,12356789,12345699,signatur,alexandra1,coolwhip,erwin1,awdrgyjilp,pens66,ghjrjgtyrj,linkinpark,emergenc,psych0,blood666,bootmort,wetworks,piroca,johnd,iamthe1,supermario,homer69,flameon,image1,bebert,fylhtq1,annapoli,apple11,hockey22,10048,indahouse,mykiss,1penguin,markp,misha123,foghat,march11,hank1,santorin,defcon4,tampico,vbnhjafy,robert22,bunkie,athlon64,sex777,nextdoor,koskesh,lolnoob,seemnemaailm,black23,march15,yeehaa,chiqui,teagan,siegheil,monday2,cornhusk,mamusia,chilis,sthgrtst,feldspar,scottm,pugdog,rfghjy,micmac,gtnhjdyf,terminato,1jackson,kakosja,bogomol,123321aa,rkbvtyrj,tresor,tigertig,fuckitall,vbkkbjy,caramon,zxc12,balin,dildo1,soccer09,avata,abby123,cheetah1,marquise,jennyc,hondavfr,tinti,anna1985,dennis2,jorel,mayflowe,icema,hal2000,nikkis,bigmouth,greenery,nurjan,leonov,liberty7,fafnir,larionov,sat321321,byteme1,nausicaa,hjvfynbrf,everto,zebra123,sergio1,titone,wisdom1,kahala,104328q,marcin1,salima,pcitra,1nnnnn,nalini,galvesto,neeraj,rick1,squeeky,agnes1,jitterbu,agshar,maria12,0112358,traxxas,stivone,prophet1,bananza,sommer1,canoneos,hotfun,redsox11,1bigmac,dctdjkjl,legion1,everclea,valenok,black9,danny001,roxie1,1theman,mudslide,july16,lechef,chula,glamis,emilka,canbeef,ioanna,cactus1,rockshox,im2cool,ninja9,thvfrjdf,june28,milo17,missyou,micky1,nbibyf,nokiaa,goldi,mattias,fuckthem,asdzxc123,ironfist,junior01,nesta,crazzy,killswit,hygge,zantac,kazama,melvin1,allston,maandag,hiccup,prototyp,specboot,dwl610,hello6,159456,baldhead,redwhite,calpoly,whitetail,agile1,cousteau,matt01,aust1n,malcolmx,gjlfhjr,semperf1,ferarri,a1b2c3d,vangelis,mkvdari,bettis36,andzia,comand,tazzman,morgaine,pepluv,anna1990,inandout,anetka,anna1997,wallpape,moonrake,huntress,hogtie,cameron7,sammy7,singe11,clownboy,newzeala,wilmar,safrane,rebeld,poopi,granat,hammertime,nermin,11251422,xyzzy1,bogeys,jkmxbr,fktrcfyl,11223311,nfyrbcn,11223300,powerpla,zoedog,ybrbnbyf,zaphod42,tarawa,jxfhjdfirf,dude1234,g5wks9,goobe,czekolada,blackros,amaranth,medical1,thereds,julija,nhecsyfujkjdt,promopas,buddy4,marmalad,weihnachten,tronic,letici,passthief,67mustan,ds7zamnw,morri,w8woord,cheops,pinarell,sonofsam,av473dv,sf161pn,5c92v5h6,purple13,tango123,plant1,1baby,xufrgemw,fitta,1rangers,spawns,kenned,taratata,19944991,11111118,coronas,4ebouux8,roadrash,corvette1,dfyjdf846,marley12,qwaszxerdfcv,68stang,67stang,racin,ellehcim,sofiko,nicetry,seabass1,jazzman1,zaqwsx1,laz2937,uuuuuuu1,vlad123,rafale,j1234567,223366,nnnnnn1,226622,junkfood,asilas,cer980,daddymac,persepho,neelam,00700,shithappens,255555,qwertyy,xbox36,19755791,qweasd1,bearcub,jerryb,a1b1c1,polkaudio,basketball1,456rty,1loveyou,marcus2,mama1961,palace1,transcend,shuriken,sudhakar,teenlove,anabelle,matrix99,pogoda,notme,bartend,jordana,nihaoma,ataris,littlegi,ferraris,redarmy,giallo,fastdraw,accountbloc,peludo,pornostar,pinoyako,cindee,glassjaw,dameon,johnnyd,finnland,saudade,losbravo,slonko,toplay,smalltit,nicksfun,stockhol,penpal,caraj,divedeep,cannibus,poppydog,pass88,viktory,walhalla,arisia,lucozade,goldenbo,tigers11,caball,ownage123,tonna,handy1,johny,capital5,faith2,stillher,brandan,pooky1,antananarivu,hotdick,1justin,lacrimos,goathead,bobrik,cgtwbfkbcn,maywood,kamilek,gbplf123,gulnar,beanhead,vfvjyn,shash,viper69,ttttttt1,hondacr,kanako,muffer,dukies,justin123,agapov58,mushka,bad11bad,muleman,jojo123,andreika,makeit,vanill,boomers,bigals,merlin11,quacker,aurelien,spartak1922,ligeti,diana2,lawnmowe,fortune1,awesom,rockyy,anna1994,oinker,love88,eastbay,ab55484,poker0,ozzy666,papasmurf,antihero,photogra,ktm250,painkill,jegr2d2,p3orion,canman,dextur,qwest123,samboy,yomismo,sierra01,herber,vfrcbvvfrcbv,gloria1,llama1,pie123,bobbyjoe,buzzkill,skidrow,grabber,phili,javier1,9379992q,geroin,oleg1994,sovereig,rollover,zaq12qaz,battery1,killer13,alina123,groucho1,mario12,peter22,butterbean,elise1,lucycat,neo123,ferdi,golfer01,randie,gfhfyjbr,ventura1,chelsea3,pinoy,mtgox,yrrim7,shoeman,mirko,ffggyyo,65mustan,ufdibyjd,john55,suckfuck,greatgoo,fvfnjhb,mmmnnn,love20,1bullshi,sucesso,easy1234,robin123,rockets1,diamondb,wolfee,nothing0,joker777,glasnost,richar1,guille,sayan,koresh,goshawk,alexx,batman21,a123456b,hball,243122,rockandr,coolfool,isaia,mary1,yjdbrjdf,lolopc,cleocat,cimbo,lovehina,8vfhnf,passking,bonapart,diamond2,bigboys,kreator,ctvtyjdf,sassy123,shellac,table54781,nedkelly,philbert,sux2bu,nomis,sparky99,python1,littlebear,numpty,silmaril,sweeet,jamesw,cbufhtnf,peggysue,wodahs,luvsex,wizardry,venom123,love4you,bama1,samat,reviewpass,ned467,cjkjdtq,mamula,gijoe,amersham,devochka,redhill,gisel,preggo,polock,cando,rewster,greenlantern,panasonik,dave1234,mikeee,1carlos,miledi,darkness1,p0o9i8u7y6,kathryn1,happyguy,dcp500,assmaster,sambuka,sailormo,antonio3,logans,18254288,nokiax2,qwertzuiop,zavilov,totti,xenon1,edward11,targa1,something1,tony_t,q1w2e3r4t5y6u7i8o9p0,02551670,vladimir1,monkeybutt,greenda,neel21,craiger,saveliy,dei008,honda450,fylhtq95,spike2,fjnq8915,passwordstandard,vova12345,talonesi,richi,gigemags,pierre1,westin,trevoga,dorothee,bastogne,25563o,brandon3,truegrit,krimml,iamgreat,servis,a112233,paulinka,azimuth,corperfmonsy,358hkyp,homerun1,dogbert1,eatmyass,cottage1,savina,baseball7,bigtex,gimmesum,asdcxz,lennon1,a159357,1bastard,413276191q,pngfilt,pchealth,netsnip,bodiroga,1matt,webtvs,ravers,adapters,siddis,mashamasha,coffee2,myhoney,anna1982,marcia1,fairchil,maniek,iloveluc,batmonh,wildon,bowie1,netnwlnk,fancy1,tom204,olga1976,vfif123,queens1,ajax01,lovess,mockba,icam4usb,triada,odinthor,rstlne,exciter,sundog,anchorat,girls69,nfnmzyrf,soloma,gti16v,shadowman,ottom,rataros,tonchin,vishal,chicken0,pornlo,christiaan,volante,likesit,mariupol,runfast,gbpltw123,missys,villevalo,kbpjxrf,ghibli,calla,cessna172,kinglear,dell11,swift1,walera,1cricket,pussy5,turbo911,tucke,maprchem56458,rosehill,thekiwi1,ygfxbkgt,mandarinka,98xa29,magnit,cjfrf,paswoord,grandam1,shenmue,leedsuni,hatrick,zagadka,angeldog,michaell,dance123,koichi,bballs,29palms,xanth,228822,ppppppp1,1kkkkk,1lllll,mynewbots,spurss,madmax1,224455,city1,mmmmmmm1,nnnnnnn1,biedronka,thebeatles,elessar,f14tomcat,jordan18,bobo123,ayi000,tedbear,86chevyx,user123,bobolink,maktub,elmer1,flyfishi,franco1,gandalf0,traxdata,david21,enlighte,dmitrij,beckys,1giants,flippe,12345678w,jossie,rugbyman,snowcat,rapeme,peanut11,gemeni,udders,techn9ne,armani1,chappie,war123,vakantie,maddawg,sewanee,jake5253,tautt1,anthony5,letterma,jimbo2,kmdtyjr,hextall,jessica6,amiga500,hotcunt,phoenix9,veronda,saqartvelo,scubas,sixer3,williamj,nightfal,shihan,melnikova,kosssss,handily,killer77,jhrl0821,march17,rushman,6gcf636i,metoyou,irina123,mine11,primus1,formatters,matthew5,infotech,gangster1,jordan45,moose69,kompas,motoxxx,greatwhi,cobra12,kirpich,weezer1,hello23,montse,tracy123,connecte,cjymrf,hemingwa,azreal,gundam00,mobila,boxman,slayers1,ravshan,june26,fktrcfylhjd,bermuda1,tylerd,maersk,qazwsx11,eybdthcbntn,ash123,camelo,kat123,backd00r,cheyenne1,1king,jerkin,tnt123,trabant,warhammer40k,rambos,punto,home77,pedrito,1frank,brille,guitarman,george13,rakas,tgbxtcrbq,flute1,bananas1,lovezp1314,thespot,postie,buster69,sexytime,twistys,zacharia,sportage,toccata,denver7,terry123,bogdanova,devil69,higgins1,whatluck,pele10,kkk666,jeffery1,1qayxsw2,riptide1,chevy11,munchy,lazer1,hooker1,ghfgjh,vergesse,playgrou,4077mash,gusev,humpin,oneputt,hydepark,monster9,tiger8,tangsoo,guy123,hesoyam1,uhtqneyu,thanku,lomond,ortezza,kronik,geetha,rabbit66,killas,qazxswe,alabaste,1234567890qwerty,capone1,andrea12,geral,beatbox,slutfuck,booyaka,jasmine7,ostsee,maestro1,beatme,tracey1,buster123,donaldduck,ironfish,happy6,konnichi,gintonic,momoney1,dugan1,today2,enkidu,destiny2,trim7gun,katuha,fractals,morganstanley,polkadot,gotime,prince11,204060,fifa2010,bobbyt,seemee,amanda10,airbrush,bigtitty,heidie,layla1,cotton1,5speed,fyfnjkmtdyf,flynavy,joxury8f,meeko,akuma,dudley1,flyboy1,moondog1,trotters,mariami,signin,chinna,legs11,pussy4,1s1h1e1f1,felici,optimus1,iluvu,marlins1,gavaec,balance1,glock40,london01,kokot,southwes,comfort1,sammy11,rockbottom,brianc,litebeer,homero,chopsuey,greenlan,charit,freecell,hampster,smalldog,viper12,blofeld,1234567890987654321,realsex,romann,cartman2,cjdthitycndj,nelly1,bmw528,zwezda,masterba,jeep99,turtl,america2,sunburst,sanyco,auntjudy,125wm,blue10,qwsazx,cartma,toby12,robbob,red222,ilovecock,losfix16,1explore,helge,vaz2114,whynotme,baba123,mugen,1qazwsxedc,albertjr,0101198,sextime,supras,nicolas2,wantsex,pussy6,checkm8,winam,24gordon,misterme,curlew,gbljhfcs,medtech,franzi,butthea,voivod,blackhat,egoiste,pjkeirf,maddog69,pakalolo,hockey4,igor1234,rouges,snowhite,homefree,sexfreak,acer12,dsmith,blessyou,199410,vfrcbvjd,falco02,belinda1,yaglasph,april21,groundho,jasmin1,nevergiveup,elvir,gborv526,c00kie,emma01,awesome2,larina,mike12345,maximu,anupam,bltynbabrfwbz,tanushka,sukkel,raptor22,josh12,schalke04,cosmodog,fuckyou8,busybee,198800,bijoux,frame1,blackmor,giveit,issmall,bear13,123-123,bladez,littlegirl,ultra123,fletch1,flashnet,loploprock,rkelly,12step,lukas1,littlewhore,cuntfinger,stinkyfinger,laurenc,198020,n7td4bjl,jackie69,camel123,ben1234,1gateway,adelheid,fatmike,thuglove,zzaaqq,chivas1,4815162342q,mamadou,nadano,james22,benwin,andrea99,rjirf,michou,abkbgg,d50gnn,aaazzz,a123654,blankman,booboo11,medicus,bigbone,197200,justine1,bendix,morphius,njhvjp,44mag,zsecyus56,goodbye1,nokiadermo,a333444,waratsea,4rzp8ab7,fevral,brillian,kirbys,minim,erathia,grazia,zxcvb1234,dukey,snaggle,poppi,hymen,1video,dune2000,jpthjdf,cvbn123,zcxfcnkbdfz,astonv,ginnie,316271,engine3,pr1ncess,64chevy,glass1,laotzu,hollyy,comicbooks,assasins,nuaddn9561,scottsda,hfcnfvfy,accobra,7777777z,werty123,metalhead,romanson,redsand,365214,shalo,arsenii,1989cc,sissi,duramax,382563,petera,414243,mamapap,jollymon,field1,fatgirl,janets,trompete,matchbox20,rambo2,nepenthe,441232,qwertyuiop10,bozo123,phezc419hv,romantika,lifestyl,pengui,decembre,demon6,panther6,444888,scanman,ghjcnjabkz,pachanga,buzzword,indianer,spiderman3,tony12,startre,frog1,fyutk,483422,tupacshakur,albert12,1drummer,bmw328i,green17,aerdna,invisibl,summer13,calimer,mustaine,lgnu9d,morefun,hesoyam123,escort1,scrapland,stargat,barabbas,dead13,545645,mexicali,sierr,gfhfpbn,gonchar,moonstafa,searock,counte,foster1,jayhawk1,floren,maremma,nastya2010,softball1,adaptec,halloo,barrabas,zxcasd123,hunny,mariana1,kafedra,freedom0,green420,vlad1234,method7,665566,tooting,hallo12,davinchi,conducto,medias,666444,invernes,madhatter,456asd,12345678i,687887,le33px,spring00,help123,bellybut,billy5,vitalik1,river123,gorila,bendis,power666,747200,footslav,acehigh,qazxswedc123,q1a1z1,richard9,peterburg,tabletop,gavrilov,123qwe1,kolosov,fredrau,run4fun,789056,jkbvgbflf,chitra,87654321q,steve22,wideopen,access88,surfe,tdfyutkbjy,impossib,kevin69,880888,cantina,887766,wxcvb,dontforg,qwer1209,asslicke,mamma123,indig,arkasha,scrapp,morelia,vehxbr,jones2,scratch1,cody11,cassie12,gerbera,dontgotm,underhil,maks2010,hollywood1,hanibal,elena2010,jason11,1010321,stewar,elaman,fireplug,goodby,sacrific,babyphat,bobcat12,bruce123,1233215,tony45,tiburo,love15,bmw750,wallstreet,2h0t4me,1346795,lamerz,munkee,134679q,granvill,1512198,armastus,aiden1,pipeutvj,g1234567,angeleyes,usmc1,102030q,putangina,brandnew,shadowfax,eagles12,1falcon,brianw,lokomoti,2022958,scooper,pegas,jabroni1,2121212,buffal,siffredi,wewiz,twotone,rosebudd,nightwis,carpet1,mickey2,2525252,sleddog,red333,jamesm,2797349,jeff12,onizuka,felixxxx,rf6666,fine1,ohlala,forplay,chicago5,muncho,scooby11,ptichka,johnnn,19851985p,dogphil3650,totenkopf,monitor2,macross7,3816778,dudder,semaj1,bounder,racerx1,5556633,7085506,ofclr278,brody1,7506751,nantucke,hedj2n4q,drew1,aessedai,trekbike,pussykat,samatron,imani,9124852,wiley1,dukenukem,iampurehaha2,9556035,obvious1,mccool24,apache64,kravchenko,justforf,basura,jamese,s0ccer,safado,darksta,surfer69,damian1,gjpbnbd,gunny1,wolley,sananton,zxcvbn123456,odt4p6sv8,sergei1,modem1,mansikka,zzzz1,rifraf,dima777,mary69,looking4,donttell,red100,ninjutsu,uaeuaeman,bigbri,brasco,queenas8151,demetri,angel007,bubbl,kolort,conny,antonia1,avtoritet,kaka22,kailayu,sassy2,wrongway,chevy3,1nascar,patriots1,chrisrey,mike99,sexy22,chkdsk,sd3utre7,padawan,a6pihd,doming,mesohorny,tamada,donatello,emma22,eather,susan69,pinky123,stud69,fatbitch,pilsbury,thc420,lovepuss,1creativ,golf1234,hurryup,1honda,huskerdu,marino1,gowron,girl1,fucktoy,gtnhjpfdjlcr,dkjfghdk,pinkfl,loreli,7777777s,donkeykong,rockytop,staples1,sone4ka,xxxjay,flywheel,toppdogg,bigbubba,aaa123456,2letmein,shavkat,paule,dlanor,adamas,0147852,aassaa,dixon1,bmw328,mother12,ilikepussy,holly2,tsmith,excaliber,fhutynbyf,nicole3,tulipan,emanue,flyvholm,currahee,godsgift,antonioj,torito,dinky1,sanna,yfcnzvjz,june14,anime123,123321456654,hanswurst,bandman,hello101,xxxyyy,chevy69,technica,tagada,arnol,v00d00,lilone,filles,drumandbass,dinamit,a1234a,eatmeat,elway07,inout,james6,dawid1,thewolf,diapason,yodaddy,qscwdv,fuckit1,liljoe,sloeber,simbacat,sascha1,qwe1234,1badger,prisca,angel17,gravedig,jakeyboy,longboard,truskawka,golfer11,pyramid7,highspee,pistola,theriver,hammer69,1packers,dannyd,alfonse,qwertgfdsa,11119999,basket1,ghjtrn,saralee,12inches,paolo1,zse4xdr5,taproot,sophieh6,grizzlie,hockey69,danang,biggums,hotbitch,5alive,beloved1,bluewave,dimon95,koketka,multiscan,littleb,leghorn,poker2,delite,skyfir,bigjake,persona1,amberdog,hannah12,derren,ziffle,1sarah,1assword,sparky01,seymur,tomtom1,123321qw,goskins,soccer19,luvbekki,bumhole,2balls,1muffin,borodin,monkey9,yfeiybrb,1alex,betmen,freder,nigger123,azizbek,gjkzrjdf,lilmike,1bigdadd,1rock,taganrog,snappy1,andrey1,kolonka,bunyan,gomango,vivia,clarkkent,satur,gaudeamus,mantaray,1month,whitehea,fargus,andrew99,ray123,redhawks,liza2009,qw12345,den12345,vfhnsyjdf,147258369a,mazepa,newyorke,1arsenal,hondas2000,demona,fordgt,steve12,birthday2,12457896,dickster,edcwsxqaz,sahalin,pantyman,skinny1,hubertus,cumshot1,chiro,kappaman,mark3434,canada12,lichking,bonkers1,ivan1985,sybase,valmet,doors1,deedlit,kyjelly,bdfysx,ford11,throatfuck,backwood,fylhsq,lalit,boss429,kotova,bricky,steveh,joshua19,kissa,imladris,star1234,lubimka,partyman,crazyd,tobias1,ilike69,imhome,whome,fourstar,scanner1,ujhjl312,anatoli,85bears,jimbo69,5678ytr,potapova,nokia7070,sunday1,kalleank,1996gta,refinnej,july1,molodec,nothanks,enigm,12play,sugardog,nhfkbdfkb,larousse,cannon1,144444,qazxcdew,stimorol,jhereg,spawn7,143000,fearme,hambur,merlin21,dobie,is3yeusc,partner1,dekal,varsha,478jfszk,flavi,hippo1,9hmlpyjd,july21,7imjfstw,lexxus,truelov,nokia5200,carlos6,anais,mudbone,anahit,taylorc,tashas,larkspur,animal2000,nibiru,jan123,miyvarxar,deflep,dolore,communit,ifoptfcor,laura2,anadrol,mamaliga,mitzi1,blue92,april15,matveev,kajlas,wowlook1,1flowers,shadow14,alucard1,1golf,bantha,scotlan,singapur,mark13,manchester1,telus01,superdav,jackoff1,madnes,bullnuts,world123,clitty,palmer1,david10,spider10,sargsyan,rattlers,david4,windows2,sony12,visigoth,qqqaaa,penfloor,cabledog,camilla1,natasha123,eagleman,softcore,bobrov,dietmar,divad,sss123,d1234567,tlbyjhju,1q1q1q1,paraiso,dav123,lfiekmrf,drachen,lzhan16889,tplate,gfghbrf,casio1,123boots1,123test,sys64738,heavymetal,andiamo,meduza,soarer,coco12,negrita,amigas,heavymet,bespin,1asdfghj,wharfrat,wetsex,tight1,janus1,sword123,ladeda,dragon98,austin2,atep1,jungle1,12345abcd,lexus300,pheonix1,alex1974,123qw123,137955,bigtim,shadow88,igor1994,goodjob,arzen,champ123,121ebay,changeme1,brooksie,frogman1,buldozer,morrowin,achim,trish1,lasse,festiva,bubbaman,scottb,kramit,august22,tyson123,passsword,oompah,al123456,fucking1,green45,noodle1,looking1,ashlynn,al1716,stang50,coco11,greese,bob111,brennan1,jasonj,1cherry,1q2345,1xxxxxxx,fifa2011,brondby,zachar1,satyam,easy1,magic7,1rainbow,cheezit,1eeeeeee,ashley123,assass1,amanda123,jerbear,1bbbbbb,azerty12,15975391,654321z,twinturb,onlyone1,denis1988,6846kg3r,jumbos,pennydog,dandelion,haileris,epervier,snoopy69,afrodite,oldpussy,green55,poopypan,verymuch,katyusha,recon7,mine69,tangos,contro,blowme2,jade1,skydive1,fiveiron,dimo4ka,bokser,stargirl,fordfocus,tigers2,platina,baseball11,raque,pimper,jawbreak,buster88,walter34,chucko,penchair,horizon1,thecure1,scc1975,adrianna1,kareta,duke12,krille,dumbfuck,cunt1,aldebaran,laverda,harumi,knopfler,pongo1,pfhbyf,dogman1,rossigno,1hardon,scarlets,nuggets1,ibelieve,akinfeev,xfhkbr,athene,falcon69,happie,billly,nitsua,fiocco,qwerty09,gizmo2,slava2,125690,doggy123,craigs,vader123,silkeborg,124365,peterm,123978,krakatoa,123699,123592,kgvebmqy,pensacol,d1d2d3,snowstor,goldenboy,gfg65h7,ev700,church1,orange11,g0dz1ll4,chester3,acheron,cynthi,hotshot1,jesuschris,motdepass,zymurgy,one2one,fietsbel,harryp,wisper,pookster,nn527hp,dolla,milkmaid,rustyboy,terrell1,epsilon1,lillian1,dale3,crhbgrf,maxsim,selecta,mamada,fatman1,ufkjxrf,shinchan,fuckuall,women1,000008,bossss,greta1,rbhjxrf,mamasboy,purple69,felicidade,sexy21,cathay,hunglow,splatt,kahless,shopping1,1gandalf,themis,delta7,moon69,blue24,parliame,mamma1,miyuki,2500hd,jackmeof,razer,rocker1,juvis123,noremac,boing747,9z5ve9rrcz,icewater,titania,alley1,moparman,christo1,oliver2,vinicius,tigerfan,chevyy,joshua99,doda99,matrixx,ekbnrf,jackfrost,viper01,kasia,cnfhsq,triton1,ssbt8ae2,rugby8,ramman,1lucky,barabash,ghtlfntkm,junaid,apeshit,enfant,kenpo1,shit12,007000,marge1,shadow10,qwerty789,richard8,vbitkm,lostboys,jesus4me,richard4,hifive,kolawole,damilola,prisma,paranoya,prince2,lisaann,happyness,cardss,methodma,supercop,a8kd47v5,gamgee,polly123,irene1,number8,hoyasaxa,1digital,matthew0,dclxvi,lisica,roy123,2468013579,sparda,queball,vaffanculo,pass1wor,repmvbx,999666333,freedom8,botanik,777555333,marcos1,lubimaya,flash2,einstei,08080,123456789j,159951159,159357123,carrot1,alina1995,sanjos,dilara,mustang67,wisteria,jhnjgtl12,98766789,darksun,arxangel,87062134,creativ1,malyshka,fuckthemall,barsic,rocksta,2big4u,5nizza,genesis2,romance1,ofcourse,1horse,latenite,cubana,sactown,789456123a,milliona,61808861,57699434,imperia,bubba11,yellow3,change12,55495746,flappy,jimbo123,19372846,19380018,cutlass1,craig123,klepto,beagle1,solus,51502112,pasha1,19822891,46466452,19855891,petshop,nikolaevna,119966,nokia6131,evenpar,hoosier1,contrasena,jawa350,gonzo123,mouse2,115511,eetfuk,gfhfvgfvgfv,1crystal,sofaking,coyote1,kwiatuszek,fhrflbq,valeria1,anthro,0123654789,alltheway,zoltar,maasikas,wildchil,fredonia,earlgrey,gtnhjczy,matrix123,solid1,slavko,12monkeys,fjdksl,inter1,nokia6500,59382113kevinp,spuddy,cachero,coorslit,password!,kiba1z,karizma,vova1994,chicony,english1,bondra12,1rocket,hunden,jimbob1,zpflhjn1,th0mas,deuce22,meatwad,fatfree,congas,sambora,cooper2,janne,clancy1,stonie,busta,kamaz,speedy2,jasmine3,fahayek,arsenal0,beerss,trixie1,boobs69,luansantana,toadman,control2,ewing33,maxcat,mama1964,diamond4,tabaco,joshua0,piper2,music101,guybrush,reynald,pincher,katiebug,starrs,pimphard,frontosa,alex97,cootie,clockwor,belluno,skyeseth,booty69,chaparra,boochie,green4,bobcat1,havok,saraann,pipeman,aekdb,jumpshot,wintermu,chaika,1chester,rjnjatq,emokid,reset1,regal1,j0shua,134679a,asmodey,sarahh,zapidoo,ciccione,sosexy,beckham23,hornets1,alex1971,delerium,manageme,connor11,1rabbit,sane4ek,caseyboy,cbljhjdf,redsox20,tttttt99,haustool,ander,pantera6,passwd1,journey1,9988776655,blue135,writerspace,xiaoyua123,justice2,niagra,cassis,scorpius,bpgjldsgjldthnf,gamemaster,bloody1,retrac,stabbin,toybox,fight1,ytpyf.,glasha,va2001,taylor11,shameles,ladylove,10078,karmann,rodeos,eintritt,lanesra,tobasco,jnrhjqcz,navyman,pablit,leshka,jessica3,123vika,alena1,platinu,ilford,storm7,undernet,sasha777,1legend,anna2002,kanmax1994,porkpie,thunder0,gundog,pallina,easypass,duck1,supermom,roach1,twincam,14028,tiziano,qwerty32,123654789a,evropa,shampoo1,yfxfkmybr,cubby1,tsunami1,fktrcttdf,yasacrac,17098,happyhap,bullrun,rodder,oaktown,holde,isbest,taylor9,reeper,hammer11,julias,rolltide1,compaq123,fourx4,subzero1,hockey9,7mary3,busines,ybrbnjcbr,wagoneer,danniash,portishead,digitex,alex1981,david11,infidel,1snoopy,free30,jaden,tonto1,redcar27,footie,moskwa,thomas21,hammer12,burzum,cosmo123,50000,burltree,54343,54354,vwpassat,jack5225,cougars1,burlpony,blackhorse,alegna,petert,katemoss,ram123,nels0n,ferrina,angel77,cstock,1christi,dave55,abc123a,alex1975,av626ss,flipoff,folgore,max1998,science1,si711ne,yams7,wifey1,sveiks,cabin1,volodia,ox3ford,cartagen,platini,picture1,sparkle1,tiedomi,service321,wooody,christi1,gnasher,brunob,hammie,iraffert,bot2010,dtcyeirf,1234567890p,cooper11,alcoholi,savchenko,adam01,chelsea5,niewiem,icebear,lllooottt,ilovedick,sweetpus,money8,cookie13,rfnthbyf1988,booboo2,angus123,blockbus,david9,chica1,nazaret,samsung9,smile4u,daystar,skinnass,john10,thegirl,sexybeas,wasdwasd1,sigge1,1qa2ws3ed4rf5tg,czarny,ripley1,chris5,ashley19,anitha,pokerman,prevert,trfnthby,tony69,georgia2,stoppedb,qwertyuiop12345,miniclip,franky1,durdom,cabbages,1234567890o,delta5,liudmila,nhfycajhvths,court1,josiew,abcd1,doghead,diman,masiania,songline,boogle,triston,deepika,sexy4me,grapple,spacebal,ebonee,winter0,smokewee,nargiza,dragonla,sassys,andy2000,menards,yoshio,massive1,suckmy1k,passat99,sexybo,nastya1996,isdead,stratcat,hokuto,infix,pidoras,daffyduck,cumhard,baldeagl,kerberos,yardman,shibainu,guitare,cqub6553,tommyy,bk.irf,bigfoo,hecto,july27,james4,biggus,esbjerg,isgod,1irish,phenmarr,jamaic,roma1990,diamond0,yjdbrjd,girls4me,tampa1,kabuto,vaduz,hanse,spieng,dianochka,csm101,lorna1,ogoshi,plhy6hql,2wsx4rfv,cameron0,adebayo,oleg1996,sharipov,bouboule,hollister1,frogss,yeababy,kablam,adelante,memem,howies,thering,cecilia1,onetwo12,ojp123456,jordan9,msorcloledbr,neveraga,evh5150,redwin,1august,canno,1mercede,moody1,mudbug,chessmas,tiikeri,stickdaddy77,alex15,kvartira,7654321a,lollol123,qwaszxedc,algore,solana,vfhbyfvfhbyf,blue72,misha1111,smoke20,junior13,mogli,threee,shannon2,fuckmylife,kevinh,saransk,karenw,isolde,sekirarr,orion123,thomas0,debra1,laketaho,alondra,curiva,jazz1234,1tigers,jambos,lickme2,suomi,gandalf7,028526,zygote,brett123,br1ttany,supafly,159000,kingrat,luton1,cool-ca,bocman,thomasd,skiller,katter,mama777,chanc,tomass,1rachel,oldno7,rfpfyjdf,bigkev,yelrah,primas,osito,kipper1,msvcr71,bigboy11,thesun,noskcaj,chicc,sonja1,lozinka,mobile1,1vader,ummagumma,waves1,punter12,tubgtn,server1,irina1991,magic69,dak001,pandemonium,dead1,berlingo,cherrypi,1montana,lohotron,chicklet,asdfgh123456,stepside,ikmvw103,icebaby,trillium,1sucks,ukrnet,glock9,ab12345,thepower,robert8,thugstools,hockey13,buffon,livefree,sexpics,dessar,ja0000,rosenrot,james10,1fish,svoloch,mykitty,muffin11,evbukb,shwing,artem1992,andrey1992,sheldon1,passpage,nikita99,fubar123,vannasx,eight888,marial,max2010,express2,violentj,2ykn5ccf,spartan11,brenda69,jackiech,abagail,robin2,grass1,andy76,bell1,taison,superme,vika1995,xtr451,fred20,89032073168,denis1984,2000jeep,weetabix,199020,daxter,tevion,panther8,h9iymxmc,bigrig,kalambur,tsalagi,12213443,racecar02,jeffrey4,nataxa,bigsam,purgator,acuracl,troutbum,potsmoke,jimmyz,manutd1,nytimes,pureevil,bearss,cool22,dragonage,nodnarb,dbrbyu,4seasons,freude,elric1,werule,hockey14,12758698,corkie,yeahright,blademan,tafkap,clave,liziko,hofner,jeffhardy,nurich,runne,stanisla,lucy1,monk3y,forzaroma,eric99,bonaire,blackwoo,fengshui,1qaz0okm,newmoney,pimpin69,07078,anonymer,laptop1,cherry12,ace111,salsa1,wilbur1,doom12,diablo23,jgtxzbhr,under1,honda01,breadfan,megan2,juancarlos,stratus1,ackbar,love5683,happytim,lambert1,cbljhtyrj,komarov,spam69,nfhtkrf,brownn,sarmat,ifiksr,spike69,hoangen,angelz,economia,tanzen,avogadro,1vampire,spanners,mazdarx,queequeg,oriana,hershil,sulaco,joseph11,8seconds,aquariu,cumberla,heather9,anthony8,burton12,crystal0,maria3,qazwsxc,snow123,notgood,198520,raindog,heehaw,consulta,dasein,miller01,cthulhu1,dukenuke,iubire,baytown,hatebree,198505,sistem,lena12,welcome01,maraca,middleto,sindhu,mitsou,phoenix5,vovan,donaldo,dylandog,domovoy,lauren12,byrjuybnj,123llll,stillers,sanchin,tulpan,smallvill,1mmmmm,patti1,folgers,mike31,colts18,123456rrr,njkmrjz,phoenix0,biene,ironcity,kasperok,password22,fitnes,matthew6,spotligh,bujhm123,tommycat,hazel5,guitar11,145678,vfcmrf,compass1,willee,1barney,jack2000,littleminge,shemp,derrek,xxx12345,littlefuck,spuds1,karolinka,camneely,qwertyu123,142500,brandon00,munson15,falcon3,passssap,z3cn2erv,goahead,baggio10,141592,denali1,37kazoo,copernic,123456789asd,orange88,bravada,rush211,197700,pablo123,uptheass,samsam1,demoman,mattylad10,heydude,mister2,werken,13467985,marantz,a22222,f1f2f3f4,fm12mn12,gerasimova,burrito1,sony1,glenny,baldeagle,rmfidd,fenomen,verbati,forgetme,5element,wer138,chanel1,ooicu812,10293847qp,minicooper,chispa,myturn,deisel,vthrehbq,boredboi4u,filatova,anabe,poiuyt1,barmalei,yyyy1,fourkids,naumenko,bangbros,pornclub,okaykk,euclid90,warrior3,kornet,palevo,patatina,gocart,antanta,jed1054,clock1,111111w,dewars,mankind1,peugeot406,liten,tahira,howlin,naumov,rmracing,corone,cunthole,passit,rock69,jaguarxj,bumsen,197101,sweet2,197010,whitecat,sawadee,money100,yfhrjnbrb,andyboy,9085603566,trace1,fagget,robot1,angel20,6yhn7ujm,specialinsta,kareena,newblood,chingada,boobies2,bugger1,squad51,133andre,call06,ashes1,ilovelucy,success2,kotton,cavalla,philou,deebee,theband,nine09,artefact,196100,kkkkkkk1,nikolay9,onelov,basia,emilyann,sadman,fkrjujkbr,teamomuch,david777,padrino,money21,firdaus,orion3,chevy01,albatro,erdfcv,2legit,sarah7,torock,kevinn,holio,soloy,enron714,starfleet,qwer11,neverman,doctorwh,lucy11,dino12,trinity7,seatleon,o123456,pimpman,1asdfgh,snakebit,chancho,prorok,bleacher,ramire,darkseed,warhorse,michael123,1spanky,1hotdog,34erdfcv,n0th1ng,dimanche,repmvbyf,michaeljackson,login1,icequeen,toshiro,sperme,racer2,veget,birthday26,daniel9,lbvekmrf,charlus,bryan123,wspanic,schreibe,1andonly,dgoins,kewell,apollo12,egypt1,fernie,tiger21,aa123456789,blowj,spandau,bisquit,12345678d,deadmau5,fredie,311420,happyface,samant,gruppa,filmstar,andrew17,bakesale,sexy01,justlook,cbarkley,paul11,bloodred,rideme,birdbath,nfkbcvfy,jaxson,sirius1,kristof,virgos,nimrod1,hardc0re,killerbee,1abcdef,pitcher1,justonce,vlada,dakota99,vespucci,wpass,outside1,puertori,rfvbkf,teamlosi,vgfun2,porol777,empire11,20091989q,jasong,webuivalidat,escrima,lakers08,trigger2,addpass,342500,mongini,dfhtybr,horndogg,palermo1,136900,babyblu,alla98,dasha2010,jkelly,kernow,yfnecz,rockhopper,toeman,tlaloc,silver77,dave01,kevinr,1234567887654321,135642,me2you,8096468644q,remmus,spider7,jamesa,jilly,samba1,drongo,770129ji,supercat,juntas,tema1234,esthe,1234567892000,drew11,qazqaz123,beegees,blome,rattrace,howhigh,tallboy,rufus2,sunny2,sou812,miller12,indiana7,irnbru,patch123,letmeon,welcome5,nabisco,9hotpoin,hpvteb,lovinit,stormin,assmonke,trill,atlanti,money1234,cubsfan,mello1,stars2,ueptkm,agate,dannym88,lover123,wordz,worldnet,julemand,chaser1,s12345678,pissword,cinemax,woodchuc,point1,hotchkis,packers2,bananana,kalender,420666,penguin8,awo8rx3wa8t,hoppie,metlife,ilovemyfamily,weihnachtsbau,pudding1,luckystr,scully1,fatboy1,amizade,dedham,jahbless,blaat,surrende,****er,1panties,bigasses,ghjuhfvbcn,asshole123,dfktyrb,likeme,nickers,plastik,hektor,deeman,muchacha,cerebro,santana5,testdrive,dracula1,canalc,l1750sq,savannah1,murena,1inside,pokemon00,1iiiiiii,jordan20,sexual1,mailliw,calipso,014702580369,1zzzzzz,1jjjjjj,break1,15253545,yomama1,katinka,kevin11,1ffffff,martijn,sslazio,daniel5,porno2,nosmas,leolion,jscript,15975312,pundai,kelli1,kkkddd,obafgkm,marmaris,lilmama,london123,rfhfnt,elgordo,talk87,daniel7,thesims3,444111,bishkek,afrika2002,toby22,1speedy,daishi,2children,afroman,qqqqwwww,oldskool,hawai,v55555,syndicat,pukimak,fanatik,tiger5,parker01,bri5kev6,timexx,wartburg,love55,ecosse,yelena03,madinina,highway1,uhfdbwfgf,karuna,buhjvfybz,wallie,46and2,khalif,europ,qaz123wsx456,bobbybob,wolfone,falloutboy,manning18,scuba10,schnuff,ihateyou1,lindam,sara123,popcor,fallengun,divine1,montblanc,qwerty8,rooney10,roadrage,bertie1,latinus,lexusis,rhfvfnjhcr,opelgt,hitme,agatka,1yamaha,dmfxhkju,imaloser,michell1,sb211st,silver22,lockedup,andrew9,monica01,sassycat,dsobwick,tinroof,ctrhtnyj,bultaco,rhfcyjzhcr,aaaassss,14ss88,joanne1,momanddad,ahjkjdf,yelhsa,zipdrive,telescop,500600,1sexsex,facial1,motaro,511647,stoner1,temujin,elephant1,greatman,honey69,kociak,ukqmwhj6,altezza,cumquat,zippos,kontiki,123max,altec1,bibigon,tontos,qazsew,nopasaran,militar,supratt,oglala,kobayash,agathe,yawetag,dogs1,cfiekmrf,megan123,jamesdea,porosenok,tiger23,berger1,hello11,seemann,stunner1,walker2,imissu,jabari,minfd,lollol12,hjvfy,1-oct,stjohns,2278124q,123456789qwer,alex1983,glowworm,chicho,mallards,bluedevil,explorer1,543211,casita,1time,lachesis,alex1982,airborn1,dubesor,changa,lizzie1,captaink,socool,bidule,march23,1861brr,k.ljxrf,watchout,fotze,1brian,keksa2,aaaa1122,matrim,providian,privado,dreame,merry1,aregdone,davidt,nounour,twenty2,play2win,artcast2,zontik,552255,shit1,sluggy,552861,dr8350,brooze,alpha69,thunder6,kamelia2011,caleb123,mmxxmm,jamesh,lfybkjd,125267,125000,124536,bliss1,dddsss,indonesi,bob69,123888,tgkbxfgy,gerar,themack,hijodeputa,good4now,ddd123,clk430,kalash,tolkien1,132forever,blackb,whatis,s1s2s3s4,lolkin09,yamahar,48n25rcc,djtiesto,111222333444555,bigbull,blade55,coolbree,kelse,ichwill,yamaha12,sakic,bebeto,katoom,donke,sahar,wahine,645202,god666,berni,starwood,june15,sonoio,time123,llbean,deadsoul,lazarev,cdtnf,ksyusha,madarchod,technik,jamesy,4speed,tenorsax,legshow,yoshi1,chrisbl,44e3ebda,trafalga,heather7,serafima,favorite4,havefun1,wolve,55555r,james13,nosredna,bodean,jlettier,borracho,mickael,marinus,brutu,sweet666,kiborg,rollrock,jackson6,macross1,ousooner,9085084232,takeme,123qwaszx,firedept,vfrfhjd,jackfros,123456789000,briane,cookie11,baby22,bobby18,gromova,systemofadown,martin01,silver01,pimaou,darthmaul,hijinx,commo,chech,skyman,sunse,2vrd6,vladimirovna,uthvfybz,nicole01,kreker,bobo1,v123456789,erxtgb,meetoo,drakcap,vfvf12,misiek1,butane,network2,flyers99,riogrand,jennyk,e12345,spinne,avalon11,lovejone,studen,maint,porsche2,qwerty100,chamberl,bluedog1,sungam,just4u,andrew23,summer22,ludic,musiclover,aguil,beardog1,libertin,pippo1,joselit,patito,bigberth,digler,sydnee,jockstra,poopo,jas4an,nastya123,profil,fuesse,default1,titan2,mendoz,kpcofgs,anamika,brillo021,bomberman,guitar69,latching,69pussy,blues2,phelge,ninja123,m7n56xo,qwertasd,alex1976,cunningh,estrela,gladbach,marillion,mike2000,258046,bypop,muffinman,kd5396b,zeratul,djkxbwf,john77,sigma2,1linda,selur,reppep,quartz1,teen1,freeclus,spook1,kudos4ever,clitring,sexiness,blumpkin,macbook,tileman,centra,escaflowne,pentable,shant,grappa,zverev,1albert,lommerse,coffee11,777123,polkilo,muppet1,alex74,lkjhgfdsazx,olesica,april14,ba25547,souths,jasmi,arashi,smile2,2401pedro,mybabe,alex111,quintain,pimp1,tdeir8b2,makenna,122333444455555,%e2%82%ac,tootsie1,pass111,zaqxsw123,gkfdfybt,cnfnbcnbrf,usermane,iloveyou12,hard69,osasuna,firegod,arvind,babochka,kiss123,cookie123,julie123,kamakazi,dylan2,223355,tanguy,nbhtqa,tigger13,tubby1,makavel,asdflkj,sambo1,mononoke,mickeys,gayguy,win123,green33,wcrfxtvgbjy,bigsmall,1newlife,clove,babyfac,bigwaves,mama1970,shockwav,1friday,bassey,yarddog,codered1,victory7,bigrick,kracker,gulfstre,chris200,sunbanna,bertuzzi,begemotik,kuolema,pondus,destinee,123456789zz,abiodun,flopsy,amadeusptfcor,geronim,yggdrasi,contex,daniel6,suck1,adonis1,moorea,el345612,f22raptor,moviebuf,raunchy,6043dkf,zxcvbnm123456789,eric11,deadmoin,ratiug,nosliw,fannies,danno,888889,blank1,mikey2,gullit,thor99,mamiya,ollieb,thoth,dagger1,websolutionssu,bonker,prive,1346798520,03038,q1234q,mommy2,contax,zhipo,gwendoli,gothic1,1234562000,lovedick,gibso,digital2,space199,b26354,987654123,golive,serious1,pivkoo,better1,824358553,794613258,nata1980,logout,fishpond,buttss,squidly,good4me,redsox19,jhonny,zse45rdx,matrixxx,honey12,ramina,213546879,motzart,fall99,newspape,killit,gimpy,photowiz,olesja,thebus,marco123,147852963,bedbug,147369258,hellbound,gjgjxrf,123987456,lovehurt,five55,hammer01,1234554321a,alina2011,peppino,ang238,questor,112358132,alina1994,alina1998,money77,bobjones,aigerim,cressida,madalena,420smoke,tinchair,raven13,mooser,mauric,lovebu,adidas69,krypton1,1111112,loveline,divin,voshod,michaelm,cocotte,gbkbuhbv,76689295,kellyj,rhonda1,sweetu70,steamforums,geeque,nothere,124c41,quixotic,steam181,1169900,rfcgthcrbq,rfvbkm,sexstuff,1231230,djctvm,rockstar1,fulhamfc,bhecbr,rfntyf,quiksilv,56836803,jedimaster,pangit,gfhjkm777,tocool,1237654,stella12,55378008,19216811,potte,fender12,mortalkombat,ball1,nudegirl,palace22,rattrap,debeers,lickpussy,jimmy6,not4u2c,wert12,bigjuggs,sadomaso,1357924,312mas,laser123,arminia,branford,coastie,mrmojo,19801982,scott11,banaan123,ingres,300zxtt,hooters6,sweeties,19821983,19831985,19833891,sinnfein,welcome4,winner69,killerman,tachyon,tigre1,nymets1,kangol,martinet,sooty1,19921993,789qwe,harsingh,1597535,thecount,phantom3,36985214,lukas123,117711,pakistan1,madmax11,willow01,19932916,fucker12,flhrci,opelagila,theword,ashley24,tigger3,crazyj,rapide,deadfish,allana,31359092,sasha1993,sanders2,discman,zaq!2wsx,boilerma,mickey69,jamesg,babybo,jackson9,orion7,alina2010,indien,breeze1,atease,warspite,bazongaz,1celtic,asguard,mygal,fitzgera,1secret,duke33,cyklone,dipascuc,potapov,1escobar2,c0l0rad0,kki177hk,1little,macondo,victoriya,peter7,red666,winston6,kl?benhavn,muneca,jackme,jennan,happylife,am4h39d8nh,bodybuil,201980,dutchie,biggame,lapo4ka,rauchen,black10,flaquit,water12,31021364,command2,lainth88,mazdamx5,typhon,colin123,rcfhlfc,qwaszx11,g0away,ramir,diesirae,hacked1,cessna1,woodfish,enigma2,pqnr67w5,odgez8j3,grisou,hiheels,5gtgiaxm,2580258,ohotnik,transits,quackers,serjik,makenzie,mdmgatew,bryana,superman12,melly,lokit,thegod,slickone,fun4all,netpass,penhorse,1cooper,nsync,asdasd22,otherside,honeydog,herbie1,chiphi,proghouse,l0nd0n,shagg,select1,frost1996,casper123,countr,magichat,greatzyo,jyothi,3bears,thefly,nikkita,fgjcnjk,nitros,hornys,san123,lightspe,maslova,kimber1,newyork2,spammm,mikejone,pumpk1n,bruiser1,bacons,prelude9,boodie,dragon4,kenneth2,love98,power5,yodude,pumba,thinline,blue30,sexxybj,2dumb2live,matt21,forsale,1carolin,innova,ilikeporn,rbgtkjd,a1s2d3f,wu9942,ruffus,blackboo,qwerty999,draco1,marcelin,hideki,gendalf,trevon,saraha,cartmen,yjhbkmcr,time2go,fanclub,ladder1,chinni,6942987,united99,lindac,quadra,paolit,mainstre,beano002,lincoln7,bellend,anomie,8520456,bangalor,goodstuff,chernov,stepashka,gulla,mike007,frasse,harley03,omnislash,8538622,maryjan,sasha2011,gineok,8807031,hornier,gopinath,princesit,bdr529,godown,bosslady,hakaone,1qwe2,madman1,joshua11,lovegame,bayamon,jedi01,stupid12,sport123,aaa666,tony44,collect1,charliem,chimaira,cx18ka,trrim777,chuckd,thedream,redsox99,goodmorning,delta88,iloveyou11,newlife2,figvam,chicago3,jasonk,12qwer,9875321,lestat1,satcom,conditio,capri50,sayaka,9933162,trunks1,chinga,snooch,alexand1,findus,poekie,cfdbyf,kevind,mike1969,fire13,leftie,bigtuna,chinnu,silence1,celos1,blackdra,alex24,gfgfif,2boobs,happy8,enolagay,sataniv1993,turner1,dylans,peugeo,sasha1994,hoppel,conno,moonshot,santa234,meister1,008800,hanako,tree123,qweras,gfitymrf,reggie31,august29,supert,joshua10,akademia,gbljhfc,zorro123,nathalia,redsox12,hfpdjl,mishmash,nokiae51,nyyankees,tu190022,strongbo,none1,not4u2no,katie2,popart,harlequi,santan,michal1,1therock,screwu,csyekmrf,olemiss1,tyrese,hoople,sunshin1,cucina,starbase,topshelf,fostex,california1,castle1,symantec,pippolo,babare,turntabl,1angela,moo123,ipvteb,gogolf,alex88,cycle1,maxie1,phase2,selhurst,furnitur,samfox,fromvermine,shaq34,gators96,captain2,delonge,tomatoe,bisous,zxcvbnma,glacius,pineapple1,cannelle,ganibal,mko09ijn,paraklast1974,hobbes12,petty43,artema,junior8,mylover,1234567890d,fatal1ty,prostreet,peruan,10020,nadya,caution1,marocas,chanel5,summer08,metal123,111lox,scrapy,thatguy,eddie666,washingto,yannis,minnesota_hp,lucky4,playboy6,naumova,azzurro,patat,dale33,pa55wd,speedster,zemanova,saraht,newto,tony22,qscesz,arkady,1oliver,death6,vkfwx046,antiflag,stangs,jzf7qf2e,brianp,fozzy,cody123,startrek1,yoda123,murciela,trabajo,lvbnhbtdf,canario,fliper,adroit,henry5,goducks,papirus,alskdj,soccer6,88mike,gogetter,tanelorn,donking,marky1,leedsu,badmofo,al1916,wetdog,akmaral,pallet,april24,killer00,nesterova,rugby123,coffee12,browseui,ralliart,paigow,calgary1,armyman,vtldtltd,frodo2,frxtgb,iambigal,benno,jaytee,2hot4you,askar,bigtee,brentwoo,palladin,eddie2,al1916w,horosho,entrada,ilovetits,venture1,dragon19,jayde,chuvak,jamesl,fzr600,brandon8,vjqvbh,snowbal,snatch1,bg6njokf,pudder,karolin,candoo,pfuflrf,satchel1,manteca,khongbiet,critter1,partridg,skyclad,bigdon,ginger69,brave1,anthony4,spinnake,chinadol,passout,cochino,nipples1,15058,lopesk,sixflags,lloo999,parkhead,breakdance,cia123,fidodido,yuitre12,fooey,artem1995,gayathri,medin,nondriversig,l12345,bravo7,happy13,kazuya,camster,alex1998,luckyy,zipcode,dizzle,boating1,opusone,newpassw,movies23,kamikazi,zapato,bart316,cowboys0,corsair1,kingshit,hotdog12,rolyat,h200svrm,qwerty4,boofer,rhtyltkm,chris999,vaz21074,simferopol,pitboss,love3,britania,tanyshka,brause,123qwerty123,abeille,moscow1,ilkaev,manut,process1,inetcfg,dragon05,fortknox,castill,rynner,mrmike,koalas,jeebus,stockpor,longman,juanpabl,caiman,roleplay,jeremi,26058,prodojo,002200,magical1,black5,bvlgari,doogie1,cbhtqa,mahina,a1s2d3f4g5h6,jblpro,usmc01,bismilah,guitar01,april9,santana1,1234aa,monkey14,sorokin,evan1,doohan,animalsex,pfqxtyjr,dimitry,catchme,chello,silverch,glock45,dogleg,litespee,nirvana9,peyton18,alydar,warhamer,iluvme,sig229,minotavr,lobzik,jack23,bushwack,onlin,football123,joshua5,federov,winter2,bigmax,fufnfrhbcnb,hfpldfnhb,1dakota,f56307,chipmonk,4nick8,praline,vbhjh123,king11,22tango,gemini12,street1,77879,doodlebu,homyak,165432,chuluthu,trixi,karlito,salom,reisen,cdtnkzxjr,pookie11,tremendo,shazaam,welcome0,00000ty,peewee51,pizzle,gilead,bydand,sarvar,upskirt,legends1,freeway1,teenfuck,ranger9,darkfire,dfymrf,hunt0802,justme1,buffy1ma,1harry,671fsa75yt,burrfoot,budster,pa437tu,jimmyp,alina2006,malacon,charlize,elway1,free12,summer02,gadina,manara,gomer1,1cassie,sanja,kisulya,money3,pujols,ford50,midiland,turga,orange6,demetriu,freakboy,orosie1,radio123,open12,vfufpby,mustek,chris33,animes,meiling,nthtvjr,jasmine9,gfdkjd,oligarh,marimar,chicago9,.kzirf,bugssgub,samuraix,jackie01,pimpjuic,macdad,cagiva,vernost,willyboy,fynjyjdf,tabby1,privet123,torres9,retype,blueroom,raven11,q12we3,alex1989,bringiton,ridered,kareltje,ow8jtcs8t,ciccia,goniners,countryb,24688642,covingto,24861793,beyblade,vikin,badboyz,wlafiga,walstib,mirand,needajob,chloes,balaton,kbpfdtnf,freyja,bond9007,gabriel12,stormbri,hollage,love4eve,fenomeno,darknite,dragstar,kyle123,milfhunter,ma123123123,samia,ghislain,enrique1,ferien12,xjy6721,natalie2,reglisse,wilson2,wesker,rosebud7,amazon1,robertr,roykeane,xtcnth,mamatata,crazyc,mikie,savanah,blowjob69,jackie2,forty1,1coffee,fhbyjxrf,bubbah,goteam,hackedit,risky1,logoff,h397pnvr,buck13,robert23,bronc,st123st,godflesh,pornog,iamking,cisco69,septiembr,dale38,zhongguo,tibbar,panther9,buffa1,bigjohn1,mypuppy,vehvfycr,april16,shippo,fire1234,green15,q123123,gungadin,steveg,olivier1,chinaski,magnoli,faithy,storm12,toadfrog,paul99,78791,august20,automati,squirtle,cheezy,positano,burbon,nunya,llebpmac,kimmi,turtle2,alan123,prokuror,violin1,durex,pussygal,visionar,trick1,chicken6,29024,plowboy,rfybreks,imbue,sasha13,wagner1,vitalogy,cfymrf,thepro,26028,gorbunov,dvdcom,letmein5,duder,fastfun,pronin,libra1,conner1,harley20,stinker1,20068,20038,amitech,syoung,dugway,18068,welcome7,jimmypag,anastaci,kafka1,pfhfnecnhf,catsss,campus100,shamal,nacho1,fire12,vikings2,brasil1,rangerover,mohamma,peresvet,14058,cocomo,aliona,14038,qwaser,vikes,cbkmdf,skyblue1,ou81234,goodlove,dfkmltvfh,108888,roamer,pinky2,static1,zxcv4321,barmen,rock22,shelby2,morgans,1junior,pasword1,logjam,fifty5,nhfrnjhbcn,chaddy,philli,nemesis2,ingenier,djkrjd,ranger3,aikman8,knothead,daddy69,love007,vsythb,ford350,tiger00,renrut,owen11,energy12,march14,alena123,robert19,carisma,orange22,murphy11,podarok,prozak,kfgeirf,wolf13,lydia1,shazza,parasha,akimov,tobbie,pilote,heather4,baster,leones,gznfxjr,megama,987654321g,bullgod,boxster1,minkey,wombats,vergil,colegiata,lincol,smoothe,pride1,carwash1,latrell,bowling3,fylhtq123,pickwick,eider,bubblebox,bunnies1,loquit,slipper1,nutsac,purina,xtutdfhf,plokiju,1qazxs,uhjpysq,zxcvbasdfg,enjoy1,1pumpkin,phantom7,mama22,swordsma,wonderbr,dogdays,milker,u23456,silvan,dfkthbr,slagelse,yeahman,twothree,boston11,wolf100,dannyg,troll1,fynjy123,ghbcnfd,bftest,ballsdeep,bobbyorr,alphasig,cccdemo,fire123,norwest,claire2,august10,lth1108,problemas,sapito,alex06,1rusty,maccom,goirish1,ohyes,bxdumb,nabila,boobear1,rabbit69,princip,alexsander,travail,chantal1,dogggy,greenpea,diablo69,alex2009,bergen09,petticoa,classe,ceilidh,vlad2011,kamakiri,lucidity,qaz321,chileno,cexfhf,99ranger,mcitra,estoppel,volvos60,carter80,webpass,temp12,touareg,fcgbhby,bubba8,sunitha,200190ru,bitch2,shadow23,iluvit,nicole0,ruben1,nikki69,butttt,shocker1,souschef,lopotok01,kantot,corsano,cfnfyf,riverat,makalu,swapna,all4u9,cdtnkfy,ntktgepbr,ronaldo99,thomasj,bmw540i,chrisw,boomba,open321,z1x2c3v4b5n6m7,gaviota,iceman44,frosya,chris100,chris24,cosette,clearwat,micael,boogyman,pussy9,camus1,chumpy,heccrbq,konoplya,chester8,scooter5,ghjgfufylf,giotto,koolkat,zero000,bonita1,ckflrbq,j1964,mandog,18n28n24a,renob,head1,shergar,ringo123,tanita,sex4free,johnny12,halberd,reddevils,biolog,dillinge,fatb0y,c00per,hyperlit,wallace2,spears1,vitamine,buheirf,sloboda,alkash,mooman,marion1,arsenal7,sunder,nokia5610,edifier,pippone,fyfnjkmtdbx,fujimo,pepsi12,kulikova,bolat,duetto,daimon,maddog01,timoshka,ezmoney,desdemon,chesters,aiden,hugues,patrick5,aikman08,robert4,roenick,nyranger,writer1,36169544,foxmulder,118801,kutter,shashank,jamjar,118811,119955,aspirina,dinkus,1sailor,nalgene,19891959,snarf,allie1,cracky,resipsa,45678912,kemerovo,19841989,netware1,alhimik,19801984,nicole123,19761977,51501984,malaka1,montella,peachfuz,jethro1,cypress1,henkie,holdon,esmith,55443322,1friend,quique,bandicoot,statistika,great123,death13,ucht36,master4,67899876,bobsmith,nikko1,jr1234,hillary1,78978978,rsturbo,lzlzdfcz,bloodlust,shadow00,skagen,bambina,yummies,88887777,91328378,matthew4,itdoes,98256518,102938475,alina2002,123123789,fubared,dannys,123456321,nikifor,suck69,newmexico,scubaman,rhbcnb,fifnfy,puffdadd,159357852,dtheyxbr,theman22,212009164,prohor,shirle,nji90okm,newmedia,goose5,roma1995,letssee,iceman11,aksana,wirenut,pimpdady,1212312121,tamplier,pelican1,domodedovo,1928374655,fiction6,duckpond,ybrecz,thwack,onetwo34,gunsmith,murphydo,fallout1,spectre1,jabberwo,jgjesq,turbo6,bobo12,redryder,blackpus,elena1971,danilova,antoin,bobo1234,bobob,bobbobbo,dean1,222222a,jesusgod,matt23,musical1,darkmage,loppol,werrew,josepha,rebel12,toshka,gadfly,hawkwood,alina12,dnomyar,sexaddict,dangit,cool23,yocrack,archimed,farouk,nhfkzkz,lindalou,111zzzzz,ghjatccjh,wethepeople,m123456789,wowsers,kbkbxrf,bulldog5,m_roesel,sissinit,yamoon6,123ewqasd,dangel,miruvor79,kaytee,falcon7,bandit11,dotnet,dannii,arsenal9,miatamx5,1trouble,strip4me,dogpile,sexyred1,rjdfktdf,google10,shortman,crystal7,awesome123,cowdog,haruka,birthday28,jitter,diabolik,boomer12,dknight,bluewate,hockey123,crm0624,blueboys,willy123,jumpup,google2,cobra777,llabesab,vicelord,hopper1,gerryber,remmah,j10e5d4,qqqqqqw,agusti,fre_ak8yj,nahlik,redrobin,scott3,epson1,dumpy,bundao,aniolek,hola123,jergens,itsasecret,maxsam,bluelight,mountai1,bongwater,1london,pepper14,freeuse,dereks,qweqw,fordgt40,rfhfdfy,raider12,hunnybun,compac,splicer,megamon,tuffgong,gymnast1,butter11,modaddy,wapbbs_1,dandelio,soccer77,ghjnbdjcnjzybt,123xyi2,fishead,x002tp00,whodaman,555aaa,oussama,brunodog,technici,pmtgjnbl,qcxdw8ry,schweden,redsox3,throbber,collecto,japan10,dbm123dm,hellhoun,tech1,deadzone,kahlan,wolf123,dethklok,xzsawq,bigguy1,cybrthc,chandle,buck01,qq123123,secreta,williams1,c32649135,delta12,flash33,123joker,spacejam,polopo,holycrap,daman1,tummybed,financia,nusrat,euroline,magicone,jimkirk,ameritec,daniel26,sevenn,topazz,kingpins,dima1991,macdog,spencer5,oi812,geoffre,music11,baffle,123569,usagi,cassiope,polla,lilcrowe,thecakeisalie,vbhjndjhtw,vthokies,oldmans,sophie01,ghoster,penny2,129834,locutus1,meesha,magik,jerry69,daddysgirl,irondesk,andrey12,jasmine123,vepsrfyn,likesdick,1accord,jetboat,grafix,tomuch,showit,protozoa,mosias98,taburetka,blaze420,esenin,anal69,zhv84kv,puissant,charles0,aishwarya,babylon6,bitter1,lenina,raleigh1,lechat,access01,kamilka,fynjy,sparkplu,daisy3112,choppe,zootsuit,1234567j,rubyrose,gorilla9,nightshade,alternativa,cghfdjxybr,snuggles1,10121v,vova1992,leonardo1,dave2,matthewd,vfhfnbr,1986mets,nobull,bacall,mexican1,juanjo,mafia1,boomer22,soylent,edwards1,jordan10,blackwid,alex86,gemini13,lunar2,dctvcjcfnm,malaki,plugger,eagles11,snafu2,1shelly,cintaku,hannah22,tbird1,maks5843,irish88,homer22,amarok,fktrcfylhjdf,lincoln2,acess,gre69kik,need4speed,hightech,core2duo,blunt1,ublhjgjybrf,dragon33,1autopas,autopas1,wwww1,15935746,daniel20,2500aa,massim,1ggggggg,96ford,hardcor1,cobra5,blackdragon,vovan_lt,orochimaru,hjlbntkb,qwertyuiop12,tallen,paradoks,frozenfish,ghjuhfvvbcn,gerri1,nuggett,camilit,doright,trans1,serena1,catch2,bkmyeh,fireston,afhvfwtdn,purple3,figure8,fuckya,scamp1,laranja,ontheoutside,louis123,yellow7,moonwalk,mercury2,tolkein,raide,amenra,a13579,dranreb,5150vh,harish,tracksta,sexking,ozzmosis,katiee,alomar,matrix19,headroom,jahlove,ringding,apollo8,132546,132613,12345672000,saretta,135798,136666,thomas7,136913,onetwothree,hockey33,calida,nefertit,bitwise,tailhook,boop4,kfgecbr,bujhmbujhm,metal69,thedark,meteoro,felicia1,house12,tinuviel,istina,vaz2105,pimp13,toolfan,nina1,tuesday2,maxmotives,lgkp500,locksley,treech,darling1,kurama,aminka,ramin,redhed,dazzler,jager1,stpiliot,cardman,rfvtym,cheeser,14314314,paramoun,samcat,plumpy,stiffie,vsajyjr,panatha,qqq777,car12345,098poi,asdzx,keegan1,furelise,kalifornia,vbhjckfd,beast123,zcfvfzkexifz,harry5,1birdie,96328i,escola,extra330,henry12,gfhfyjqz,14u2nv,max1234,templar1,1dave,02588520,catrin,pangolin,marhaba,latin1,amorcito,dave22,escape1,advance1,yasuhiro,grepw,meetme,orange01,ernes,erdna,zsergn,nautica1,justinb,soundwav,miasma,greg78,nadine1,sexmad,lovebaby,promo1,excel1,babys,dragonma,camry1,sonnenschein,farooq,wazzkaprivet,magal,katinas,elvis99,redsox24,rooney1,chiefy,peggys,aliev,pilsung,mudhen,dontdoit,dennis12,supercal,energia,ballsout,funone,claudiu,brown2,amoco,dabl1125,philos,gjdtkbntkm,servette,13571113,whizzer,nollie,13467982,upiter,12string,bluejay1,silkie,william4,kosta1,143333,connor12,sustanon,06068,corporat,ssnake,laurita,king10,tahoes,arsenal123,sapato,charless,jeanmarc,levent,algerie,marine21,jettas,winsome,dctvgbplf,1701ab,xxxp455w0rd5,lllllll1,ooooooo1,monalis,koufax32,anastasya,debugger,sarita2,jason69,ufkxjyjr,gjlcnfdf,1jerry,daniel10,balinor,sexkitten,death2,qwertasdfgzxcvb,s9te949f,vegeta1,sysman,maxxam,dimabilan,mooose,ilovetit,june23,illest,doesit,mamou,abby12,longjump,transalp,moderato,littleguy,magritte,dilnoza,hawaiiguy,winbig,nemiroff,kokaine,admira,myemail,dream2,browneyes,destiny7,dragonss,suckme1,asa123,andranik,suckem,fleshbot,dandie,timmys,scitra,timdog,hasbeen,guesss,smellyfe,arachne,deutschl,harley88,birthday27,nobody1,papasmur,home1,jonass,bunia3,epatb1,embalm,vfvekmrf,apacer,12345656,estreet,weihnachtsbaum,mrwhite,admin12,kristie1,kelebek,yoda69,socken,tima123,bayern1,fktrcfylth,tamiya,99strenght,andy01,denis2011,19delta,stokecit,aotearoa,stalker2,nicnac,conrad1,popey,agusta,bowl36,1bigfish,mossyoak,1stunner,getinnow,jessejames,gkfnjy,drako,1nissan,egor123,hotness,1hawaii,zxc123456,cantstop,1peaches,madlen,west1234,jeter1,markis,judit,attack1,artemi,silver69,153246,crazy2,green9,yoshimi,1vette,chief123,jasper2,1sierra,twentyon,drstrang,aspirant,yannic,jenna123,bongtoke,slurpy,1sugar,civic97,rusty21,shineon,james19,anna12345,wonderwoman,1kevin,karol1,kanabis,wert21,fktif6115,evil1,kakaha,54gv768,826248s,tyrone1,1winston,sugar2,falcon01,adelya,mopar440,zasxcd,leecher,kinkysex,mercede1,travka,11234567,rebon,geekboy".split(","),
    english_wikipedia: "the,of,and,in,was,is,for,as,on,with,by,he,at,from,his,an,were,are,which,doc,https,also,or,has,had,first,one,their,its,after,new,who,they,two,her,she,been,other,when,time,during,there,into,school,more,may,years,over,only,year,most,would,world,city,some,where,between,later,three,state,such,then,national,used,made,known,under,many,university,united,while,part,season,team,these,american,than,film,second,born,south,became,states,war,through,being,including,both,before,north,high,however,people,family,early,history,album,area,them,series,against,until,since,district,county,name,work,life,group,music,following,number,company,several,four,called,played,released,career,league,game,government,house,each,based,day,same,won,use,station,club,international,town,located,population,general,college,east,found,age,march,end,september,began,home,public,church,line,june,river,member,system,place,century,band,july,york,january,october,song,august,best,former,british,party,named,held,village,show,local,november,took,service,december,built,another,major,within,along,members,five,single,due,although,small,old,left,final,large,include,building,served,president,received,games,death,february,main,third,set,children,own,order,species,park,law,air,published,road,died,book,men,women,army,often,according,education,central,country,division,english,top,included,development,french,community,among,water,play,side,list,times,near,late,form,original,different,center,power,led,students,german,moved,court,six,land,council,island,u.s.,record,million,research,art,established,award,street,military,television,given,region,support,western,production,non,political,point,cup,period,business,title,started,various,election,using,england,role,produced,become,program,works,field,total,office,class,written,association,radio,union,level,championship,director,few,force,created,department,founded,services,married,though,per,n't,site,open,act,short,society,version,royal,present,northern,worked,professional,full,returned,joined,story,france,european,currently,language,social,california,india,days,design,st.,further,round,australia,wrote,san,project,control,southern,railway,board,popular,continued,free,battle,considered,video,common,position,living,half,playing,recorded,red,post,described,average,records,special,modern,appeared,announced,areas,rock,release,elected,others,example,term,opened,similar,formed,route,census,current,schools,originally,lake,developed,race,himself,forces,addition,information,upon,province,match,event,songs,result,events,win,eastern,track,lead,teams,science,human,construction,minister,germany,awards,available,throughout,training,style,body,museum,australian,health,seven,signed,chief,eventually,appointed,sea,centre,debut,tour,points,media,light,range,character,across,features,families,largest,indian,network,less,performance,players,refer,europe,sold,festival,usually,taken,despite,designed,committee,process,return,official,episode,institute,stage,followed,performed,japanese,personal,thus,arts,space,low,months,includes,china,study,middle,magazine,leading,japan,groups,aircraft,featured,federal,civil,rights,model,coach,canadian,books,remained,eight,type,independent,completed,capital,academy,instead,kingdom,organization,countries,studies,competition,sports,size,above,section,finished,gold,involved,reported,management,systems,industry,directed,market,fourth,movement,technology,bank,ground,campaign,base,lower,sent,rather,added,provided,coast,grand,historic,valley,conference,bridge,winning,approximately,films,chinese,awarded,degree,russian,shows,native,female,replaced,municipality,square,studio,medical,data,african,successful,mid,bay,attack,previous,operations,spanish,theatre,student,republic,beginning,provide,ship,primary,owned,writing,tournament,culture,introduced,texas,related,natural,parts,governor,reached,ireland,units,senior,decided,italian,whose,higher,africa,standard,income,professor,placed,regional,los,buildings,championships,active,novel,energy,generally,interest,via,economic,previously,stated,itself,channel,below,operation,leader,traditional,trade,structure,limited,runs,prior,regular,famous,saint,navy,foreign,listed,artist,catholic,airport,results,parliament,collection,unit,officer,goal,attended,command,staff,commission,lived,location,plays,commercial,places,foundation,significant,older,medal,self,scored,companies,highway,activities,programs,wide,musical,notable,library,numerous,paris,towards,individual,allowed,plant,property,annual,contract,whom,highest,initially,required,earlier,assembly,artists,rural,seat,practice,defeated,ended,soviet,length,spent,manager,press,associated,author,issues,additional,characters,lord,zealand,policy,engine,township,noted,historical,complete,financial,religious,mission,contains,nine,recent,represented,pennsylvania,administration,opening,secretary,lines,report,executive,youth,closed,theory,writer,italy,angeles,appearance,feature,queen,launched,legal,terms,entered,issue,edition,singer,greek,majority,background,source,anti,cultural,complex,changes,recording,stadium,islands,operated,particularly,basketball,month,uses,port,castle,mostly,names,fort,selected,increased,status,earth,subsequently,pacific,cover,variety,certain,goals,remains,upper,congress,becoming,studied,irish,nature,particular,loss,caused,chart,dr.,forced,create,era,retired,material,review,rate,singles,referred,larger,individuals,shown,provides,products,speed,democratic,poland,parish,olympics,cities,themselves,temple,wing,genus,households,serving,cost,wales,stations,passed,supported,view,cases,forms,actor,male,matches,males,stars,tracks,females,administrative,median,effect,biography,train,engineering,camp,offered,chairman,houses,mainly,19th,surface,therefore,nearly,score,ancient,subject,prime,seasons,claimed,experience,specific,jewish,failed,overall,believed,plot,troops,greater,spain,consists,broadcast,heavy,increase,raised,separate,campus,1980s,appears,presented,lies,composed,recently,influence,fifth,nations,creek,references,elections,britain,double,cast,meaning,earned,carried,producer,latter,housing,brothers,attempt,article,response,border,remaining,nearby,direct,ships,value,workers,politician,academic,label,1970s,commander,rule,fellow,residents,authority,editor,transport,dutch,projects,responsible,covered,territory,flight,races,defense,tower,emperor,albums,facilities,daily,stories,assistant,managed,primarily,quality,function,proposed,distribution,conditions,prize,journal,code,vice,newspaper,corps,highly,constructed,mayor,critical,secondary,corporation,rugby,regiment,ohio,appearances,serve,allow,nation,multiple,discovered,directly,scene,levels,growth,elements,acquired,1990s,officers,physical,20th,latin,host,jersey,graduated,arrived,issued,literature,metal,estate,vote,immediately,quickly,asian,competed,extended,produce,urban,1960s,promoted,contemporary,global,formerly,appear,industrial,types,opera,ministry,soldiers,commonly,mass,formation,smaller,typically,drama,shortly,density,senate,effects,iran,polish,prominent,naval,settlement,divided,basis,republican,languages,distance,treatment,continue,product,mile,sources,footballer,format,clubs,leadership,initial,offers,operating,avenue,officially,columbia,grade,squadron,fleet,percent,farm,leaders,agreement,likely,equipment,website,mount,grew,method,transferred,intended,renamed,iron,asia,reserve,capacity,politics,widely,activity,advanced,relations,scottish,dedicated,crew,founder,episodes,lack,amount,build,efforts,concept,follows,ordered,leaves,positive,economy,entertainment,affairs,memorial,ability,illinois,communities,color,text,railroad,scientific,focus,comedy,serves,exchange,environment,cars,direction,organized,firm,description,agency,analysis,purpose,destroyed,reception,planned,revealed,infantry,architecture,growing,featuring,household,candidate,removed,situated,models,knowledge,solo,technical,organizations,assigned,conducted,participated,largely,purchased,register,gained,combined,headquarters,adopted,potential,protection,scale,approach,spread,independence,mountains,titled,geography,applied,safety,mixed,accepted,continues,captured,rail,defeat,principal,recognized,lieutenant,mentioned,semi,owner,joint,liberal,actress,traffic,creation,basic,notes,unique,supreme,declared,simply,plants,sales,massachusetts,designated,parties,jazz,compared,becomes,resources,titles,concert,learning,remain,teaching,versions,content,alongside,revolution,sons,block,premier,impact,champions,districts,generation,estimated,volume,image,sites,account,roles,sport,quarter,providing,zone,yard,scoring,classes,presence,performances,representatives,hosted,split,taught,origin,olympic,claims,critics,facility,occurred,suffered,municipal,damage,defined,resulted,respectively,expanded,platform,draft,opposition,expected,educational,ontario,climate,reports,atlantic,surrounding,performing,reduced,ranked,allows,birth,nominated,younger,newly,kong,positions,theater,philadelphia,heritage,finals,disease,sixth,laws,reviews,constitution,tradition,swedish,theme,fiction,rome,medicine,trains,resulting,existing,deputy,environmental,labour,classical,develop,fans,granted,receive,alternative,begins,nuclear,fame,buried,connected,identified,palace,falls,letters,combat,sciences,effort,villages,inspired,regions,towns,conservative,chosen,animals,labor,attacks,materials,yards,steel,representative,orchestra,peak,entitled,officials,returning,reference,northwest,imperial,convention,examples,ocean,publication,painting,subsequent,frequently,religion,brigade,fully,sides,acts,cemetery,relatively,oldest,suggested,succeeded,achieved,application,programme,cells,votes,promotion,graduate,armed,supply,flying,communist,figures,literary,netherlands,korea,worldwide,citizens,1950s,faculty,draw,stock,seats,occupied,methods,unknown,articles,claim,holds,authorities,audience,sweden,interview,obtained,covers,settled,transfer,marked,allowing,funding,challenge,southeast,unlike,crown,rise,portion,transportation,sector,phase,properties,edge,tropical,standards,institutions,philosophy,legislative,hills,brand,fund,conflict,unable,founding,refused,attempts,metres,permanent,starring,applications,creating,effective,aired,extensive,employed,enemy,expansion,billboard,rank,battalion,multi,vehicle,fought,alliance,category,perform,federation,poetry,bronze,bands,entry,vehicles,bureau,maximum,billion,trees,intelligence,greatest,screen,refers,commissioned,gallery,injury,confirmed,setting,treaty,adult,americans,broadcasting,supporting,pilot,mobile,writers,programming,existence,squad,minnesota,copies,korean,provincial,sets,defence,offices,agricultural,internal,core,northeast,retirement,factory,actions,prevent,communications,ending,weekly,containing,functions,attempted,interior,weight,bowl,recognition,incorporated,increasing,ultimately,documentary,derived,attacked,lyrics,mexican,external,churches,centuries,metropolitan,selling,opposed,personnel,mill,visited,presidential,roads,pieces,norwegian,controlled,18th,rear,influenced,wrestling,weapons,launch,composer,locations,developing,circuit,specifically,studios,shared,canal,wisconsin,publishing,approved,domestic,consisted,determined,comic,establishment,exhibition,southwest,fuel,electronic,cape,converted,educated,melbourne,hits,wins,producing,norway,slightly,occur,surname,identity,represent,constituency,funds,proved,links,structures,athletic,birds,contest,users,poet,institution,display,receiving,rare,contained,guns,motion,piano,temperature,publications,passenger,contributed,toward,cathedral,inhabitants,architect,exist,athletics,muslim,courses,abandoned,signal,successfully,disambiguation,tennessee,dynasty,heavily,maryland,jews,representing,budget,weather,missouri,introduction,faced,pair,chapel,reform,height,vietnam,occurs,motor,cambridge,lands,focused,sought,patients,shape,invasion,chemical,importance,communication,selection,regarding,homes,voivodeship,maintained,borough,failure,aged,passing,agriculture,oregon,teachers,flow,philippines,trail,seventh,portuguese,resistance,reaching,negative,fashion,scheduled,downtown,universities,trained,skills,scenes,views,notably,typical,incident,candidates,engines,decades,composition,commune,chain,inc.,austria,sale,values,employees,chamber,regarded,winners,registered,task,investment,colonial,swiss,user,entirely,flag,stores,closely,entrance,laid,journalist,coal,equal,causes,turkish,quebec,techniques,promote,junction,easily,dates,kentucky,singapore,residence,violence,advance,survey,humans,expressed,passes,streets,distinguished,qualified,folk,establish,egypt,artillery,visual,improved,actual,finishing,medium,protein,switzerland,productions,operate,poverty,neighborhood,organisation,consisting,consecutive,sections,partnership,extension,reaction,factor,costs,bodies,device,ethnic,racial,flat,objects,chapter,improve,musicians,courts,controversy,membership,merged,wars,expedition,interests,arab,comics,gain,describes,mining,bachelor,crisis,joining,decade,1930s,distributed,habitat,routes,arena,cycle,divisions,briefly,vocals,directors,degrees,object,recordings,installed,adjacent,demand,voted,causing,businesses,ruled,grounds,starred,drawn,opposite,stands,formal,operates,persons,counties,compete,wave,israeli,ncaa,resigned,brief,greece,combination,demographics,historian,contain,commonwealth,musician,collected,argued,louisiana,session,cabinet,parliamentary,electoral,loan,profit,regularly,conservation,islamic,purchase,17th,charts,residential,earliest,designs,paintings,survived,moth,items,goods,grey,anniversary,criticism,images,discovery,observed,underground,progress,additionally,participate,thousands,reduce,elementary,owners,stating,iraq,resolution,capture,tank,rooms,hollywood,finance,queensland,reign,maintain,iowa,landing,broad,outstanding,circle,path,manufacturing,assistance,sequence,gmina,crossing,leads,universal,shaped,kings,attached,medieval,ages,metro,colony,affected,scholars,oklahoma,coastal,soundtrack,painted,attend,definition,meanwhile,purposes,trophy,require,marketing,popularity,cable,mathematics,mississippi,represents,scheme,appeal,distinct,factors,acid,subjects,roughly,terminal,economics,senator,diocese,prix,contrast,argentina,czech,wings,relief,stages,duties,16th,novels,accused,whilst,equivalent,charged,measure,documents,couples,request,danish,defensive,guide,devices,statistics,credited,tries,passengers,allied,frame,puerto,peninsula,concluded,instruments,wounded,differences,associate,forests,afterwards,replace,requirements,aviation,solution,offensive,ownership,inner,legislation,hungarian,contributions,actors,translated,denmark,steam,depending,aspects,assumed,injured,severe,admitted,determine,shore,technique,arrival,measures,translation,debuted,delivered,returns,rejected,separated,visitors,damaged,storage,accompanied,markets,industries,losses,gulf,charter,strategy,corporate,socialist,somewhat,significantly,physics,mounted,satellite,experienced,constant,relative,pattern,restored,belgium,connecticut,partners,harvard,retained,networks,protected,mode,artistic,parallel,collaboration,debate,involving,journey,linked,salt,authors,components,context,occupation,requires,occasionally,policies,tamil,ottoman,revolutionary,hungary,poem,versus,gardens,amongst,audio,makeup,frequency,meters,orthodox,continuing,suggests,legislature,coalition,guitarist,eighth,classification,practices,soil,tokyo,instance,limit,coverage,considerable,ranking,colleges,cavalry,centers,daughters,twin,equipped,broadway,narrow,hosts,rates,domain,boundary,arranged,12th,whereas,brazilian,forming,rating,strategic,competitions,trading,covering,baltimore,commissioner,infrastructure,origins,replacement,praised,disc,collections,expression,ukraine,driven,edited,austrian,solar,ensure,premiered,successor,wooden,operational,hispanic,concerns,rapid,prisoners,childhood,meets,influential,tunnel,employment,tribe,qualifying,adapted,temporary,celebrated,appearing,increasingly,depression,adults,cinema,entering,laboratory,script,flows,romania,accounts,fictional,pittsburgh,achieve,monastery,franchise,formally,tools,newspapers,revival,sponsored,processes,vienna,springs,missions,classified,13th,annually,branches,lakes,gender,manner,advertising,normally,maintenance,adding,characteristics,integrated,decline,modified,strongly,critic,victims,malaysia,arkansas,nazi,restoration,powered,monument,hundreds,depth,15th,controversial,admiral,criticized,brick,honorary,initiative,output,visiting,birmingham,progressive,existed,carbon,1920s,credits,colour,rising,hence,defeating,superior,filmed,listing,column,surrounded,orleans,principles,territories,struck,participation,indonesia,movements,index,commerce,conduct,constitutional,spiritual,ambassador,vocal,completion,edinburgh,residing,tourism,finland,bears,medals,resident,themes,visible,indigenous,involvement,basin,electrical,ukrainian,concerts,boats,styles,processing,rival,drawing,vessels,experimental,declined,touring,supporters,compilation,coaching,cited,dated,roots,string,explained,transit,traditionally,poems,minimum,representation,14th,releases,effectively,architectural,triple,indicated,greatly,elevation,clinical,printed,10th,proposal,peaked,producers,romanized,rapidly,stream,innings,meetings,counter,householder,honour,lasted,agencies,document,exists,surviving,experiences,honors,landscape,hurricane,harbor,panel,competing,profile,vessel,farmers,lists,revenue,exception,customers,11th,participants,wildlife,utah,bible,gradually,preserved,replacing,symphony,begun,longest,siege,provinces,mechanical,genre,transmission,agents,executed,videos,benefits,funded,rated,instrumental,ninth,similarly,dominated,destruction,passage,technologies,thereafter,outer,facing,affiliated,opportunities,instrument,governments,scholar,evolution,channels,shares,sessions,widespread,occasions,engineers,scientists,signing,battery,competitive,alleged,eliminated,supplies,judges,hampshire,regime,portrayed,penalty,taiwan,denied,submarine,scholarship,substantial,transition,victorian,http,nevertheless,filed,supports,continental,tribes,ratio,doubles,useful,honours,blocks,principle,retail,departure,ranks,patrol,yorkshire,vancouver,inter,extent,afghanistan,strip,railways,component,organ,symbol,categories,encouraged,abroad,civilian,periods,traveled,writes,struggle,immediate,recommended,adaptation,egyptian,graduating,assault,drums,nomination,historically,voting,allies,detailed,achievement,percentage,arabic,assist,frequent,toured,apply,and/or,intersection,maine,touchdown,throne,produces,contribution,emerged,obtain,archbishop,seek,researchers,remainder,populations,clan,finnish,overseas,fifa,licensed,chemistry,festivals,mediterranean,injuries,animated,seeking,publisher,volumes,limits,venue,jerusalem,generated,trials,islam,youngest,ruling,glasgow,germans,songwriter,persian,municipalities,donated,viewed,belgian,cooperation,posted,tech,dual,volunteer,settlers,commanded,claiming,approval,delhi,usage,terminus,partly,electricity,locally,editions,premiere,absence,belief,traditions,statue,indicate,manor,stable,attributed,possession,managing,viewers,chile,overview,seed,regulations,essential,minority,cargo,segment,endemic,forum,deaths,monthly,playoffs,erected,practical,machines,suburb,relation,mrs.,descent,indoor,continuous,characterized,solutions,caribbean,rebuilt,serbian,summary,contested,psychology,pitch,attending,muhammad,tenure,drivers,diameter,assets,venture,punk,airlines,concentration,athletes,volunteers,pages,mines,influences,sculpture,protest,ferry,behalf,drafted,apparent,furthermore,ranging,romanian,democracy,lanka,significance,linear,d.c.,certified,voters,recovered,tours,demolished,boundaries,assisted,identify,grades,elsewhere,mechanism,1940s,reportedly,aimed,conversion,suspended,photography,departments,beijing,locomotives,publicly,dispute,magazines,resort,conventional,platforms,internationally,capita,settlements,dramatic,derby,establishing,involves,statistical,implementation,immigrants,exposed,diverse,layer,vast,ceased,connections,belonged,interstate,uefa,organised,abuse,deployed,cattle,partially,filming,mainstream,reduction,automatic,rarely,subsidiary,decides,merger,comprehensive,displayed,amendment,guinea,exclusively,manhattan,concerning,commons,radical,serbia,baptist,buses,initiated,portrait,harbour,choir,citizen,sole,unsuccessful,manufactured,enforcement,connecting,increases,patterns,sacred,muslims,clothing,hindu,unincorporated,sentenced,advisory,tanks,campaigns,fled,repeated,remote,rebellion,implemented,texts,fitted,tribute,writings,sufficient,ministers,21st,devoted,jurisdiction,coaches,interpretation,pole,businessman,peru,sporting,prices,cuba,relocated,opponent,arrangement,elite,manufacturer,responded,suitable,distinction,calendar,dominant,tourist,earning,prefecture,ties,preparation,anglo,pursue,worship,archaeological,chancellor,bangladesh,scores,traded,lowest,horror,outdoor,biology,commented,specialized,loop,arriving,farming,housed,historians,'the,patent,pupils,christianity,opponents,athens,northwestern,maps,promoting,reveals,flights,exclusive,lions,norfolk,hebrew,extensively,eldest,shops,acquisition,virtual,renowned,margin,ongoing,essentially,iranian,alternate,sailed,reporting,conclusion,originated,temperatures,exposure,secured,landed,rifle,framework,identical,martial,focuses,topics,ballet,fighters,belonging,wealthy,negotiations,evolved,bases,oriented,acres,democrat,heights,restricted,vary,graduation,aftermath,chess,illness,participating,vertical,collective,immigration,demonstrated,leaf,completing,organic,missile,leeds,eligible,grammar,confederate,improvement,congressional,wealth,cincinnati,spaces,indicates,corresponding,reaches,repair,isolated,taxes,congregation,ratings,leagues,diplomatic,submitted,winds,awareness,photographs,maritime,nigeria,accessible,animation,restaurants,philippine,inaugural,dismissed,armenian,illustrated,reservoir,speakers,programmes,resource,genetic,interviews,camps,regulation,computers,preferred,travelled,comparison,distinctive,recreation,requested,southeastern,dependent,brisbane,breeding,playoff,expand,bonus,gauge,departed,qualification,inspiration,shipping,slaves,variations,shield,theories,munich,recognised,emphasis,favour,variable,seeds,undergraduate,territorial,intellectual,qualify,mini,banned,pointed,democrats,assessment,judicial,examination,attempting,objective,partial,characteristic,hardware,pradesh,execution,ottawa,metre,drum,exhibitions,withdrew,attendance,phrase,journalism,logo,measured,error,christians,trio,protestant,theology,respective,atmosphere,buddhist,substitute,curriculum,fundamental,outbreak,rabbi,intermediate,designation,globe,liberation,simultaneously,diseases,experiments,locomotive,difficulties,mainland,nepal,relegated,contributing,database,developments,veteran,carries,ranges,instruction,lodge,protests,obama,newcastle,experiment,physician,describing,challenges,corruption,delaware,adventures,ensemble,succession,renaissance,tenth,altitude,receives,approached,crosses,syria,croatia,warsaw,professionals,improvements,worn,airline,compound,permitted,preservation,reducing,printing,scientist,activist,comprises,sized,societies,enters,ruler,gospel,earthquake,extend,autonomous,croatian,serial,decorated,relevant,ideal,grows,grass,tier,towers,wider,welfare,columns,alumni,descendants,interface,reserves,banking,colonies,manufacturers,magnetic,closure,pitched,vocalist,preserve,enrolled,cancelled,equation,2000s,nickname,bulgaria,heroes,exile,mathematical,demands,input,structural,tube,stem,approaches,argentine,axis,manuscript,inherited,depicted,targets,visits,veterans,regard,removal,efficiency,organisations,concepts,lebanon,manga,petersburg,rally,supplied,amounts,yale,tournaments,broadcasts,signals,pilots,azerbaijan,architects,enzyme,literacy,declaration,placing,batting,incumbent,bulgarian,consistent,poll,defended,landmark,southwestern,raid,resignation,travels,casualties,prestigious,namely,aims,recipient,warfare,readers,collapse,coached,controls,volleyball,coup,lesser,verse,pairs,exhibited,proteins,molecular,abilities,integration,consist,aspect,advocate,administered,governing,hospitals,commenced,coins,lords,variation,resumed,canton,artificial,elevated,palm,difficulty,civic,efficient,northeastern,inducted,radiation,affiliate,boards,stakes,byzantine,consumption,freight,interaction,oblast,numbered,seminary,contracts,extinct,predecessor,bearing,cultures,functional,neighboring,revised,cylinder,grants,narrative,reforms,athlete,tales,reflect,presidency,compositions,specialist,cricketer,founders,sequel,widow,disbanded,associations,backed,thereby,pitcher,commanding,boulevard,singers,crops,militia,reviewed,centres,waves,consequently,fortress,tributary,portions,bombing,excellence,nest,payment,mars,plaza,unity,victories,scotia,farms,nominations,variant,attacking,suspension,installation,graphics,estates,comments,acoustic,destination,venues,surrender,retreat,libraries,quarterback,customs,berkeley,collaborated,gathered,syndrome,dialogue,recruited,shanghai,neighbouring,psychological,saudi,moderate,exhibit,innovation,depot,binding,brunswick,situations,certificate,actively,shakespeare,editorial,presentation,ports,relay,nationalist,methodist,archives,experts,maintains,collegiate,bishops,maintaining,temporarily,embassy,essex,wellington,connects,reformed,bengal,recalled,inches,doctrine,deemed,legendary,reconstruction,statements,palestinian,meter,achievements,riders,interchange,spots,auto,accurate,chorus,dissolved,missionary,thai,operators,e.g.,generations,failing,delayed,cork,nashville,perceived,venezuela,cult,emerging,tomb,abolished,documented,gaining,canyon,episcopal,stored,assists,compiled,kerala,kilometers,mosque,grammy,theorem,unions,segments,glacier,arrives,theatrical,circulation,conferences,chapters,displays,circular,authored,conductor,fewer,dimensional,nationwide,liga,yugoslavia,peer,vietnamese,fellowship,armies,regardless,relating,dynamic,politicians,mixture,serie,somerset,imprisoned,posts,beliefs,beta,layout,independently,electronics,provisions,fastest,logic,headquartered,creates,challenged,beaten,appeals,plains,protocol,graphic,accommodate,iraqi,midfielder,span,commentary,freestyle,reflected,palestine,lighting,burial,virtually,backing,prague,tribal,heir,identification,prototype,criteria,dame,arch,tissue,footage,extending,procedures,predominantly,updated,rhythm,preliminary,cafe,disorder,prevented,suburbs,discontinued,retiring,oral,followers,extends,massacre,journalists,conquest,larvae,pronounced,behaviour,diversity,sustained,addressed,geographic,restrictions,voiced,milwaukee,dialect,quoted,grid,nationally,nearest,roster,twentieth,separation,indies,manages,citing,intervention,guidance,severely,migration,artwork,focusing,rivals,trustees,varied,enabled,committees,centered,skating,slavery,cardinals,forcing,tasks,auckland,youtube,argues,colored,advisor,mumbai,requiring,theological,registration,refugees,nineteenth,survivors,runners,colleagues,priests,contribute,variants,workshop,concentrated,creator,lectures,temples,exploration,requirement,interactive,navigation,companion,perth,allegedly,releasing,citizenship,observation,stationed,ph.d.,sheep,breed,discovers,encourage,kilometres,journals,performers,isle,saskatchewan,hybrid,hotels,lancashire,dubbed,airfield,anchor,suburban,theoretical,sussex,anglican,stockholm,permanently,upcoming,privately,receiver,optical,highways,congo,colours,aggregate,authorized,repeatedly,varies,fluid,innovative,transformed,praise,convoy,demanded,discography,attraction,export,audiences,ordained,enlisted,occasional,westminster,syrian,heavyweight,bosnia,consultant,eventual,improving,aires,wickets,epic,reactions,scandal,i.e.,discrimination,buenos,patron,investors,conjunction,testament,construct,encountered,celebrity,expanding,georgian,brands,retain,underwent,algorithm,foods,provision,orbit,transformation,associates,tactical,compact,varieties,stability,refuge,gathering,moreover,manila,configuration,gameplay,discipline,entity,comprising,composers,skill,monitoring,ruins,museums,sustainable,aerial,altered,codes,voyage,friedrich,conflicts,storyline,travelling,conducting,merit,indicating,referendum,currency,encounter,particles,automobile,workshops,acclaimed,inhabited,doctorate,cuban,phenomenon,dome,enrollment,tobacco,governance,trend,equally,manufacture,hydrogen,grande,compensation,download,pianist,grain,shifted,neutral,evaluation,define,cycling,seized,array,relatives,motors,firms,varying,automatically,restore,nicknamed,findings,governed,investigate,manitoba,administrator,vital,integral,indonesian,confusion,publishers,enable,geographical,inland,naming,civilians,reconnaissance,indianapolis,lecturer,deer,tourists,exterior,rhode,bassist,symbols,scope,ammunition,yuan,poets,punjab,nursing,cent,developers,estimates,presbyterian,nasa,holdings,generate,renewed,computing,cyprus,arabia,duration,compounds,gastropod,permit,valid,touchdowns,facade,interactions,mineral,practiced,allegations,consequence,goalkeeper,baronet,copyright,uprising,carved,targeted,competitors,mentions,sanctuary,fees,pursued,tampa,chronicle,capabilities,specified,specimens,toll,accounting,limestone,staged,upgraded,philosophical,streams,guild,revolt,rainfall,supporter,princeton,terrain,hometown,probability,assembled,paulo,surrey,voltage,developer,destroyer,floors,lineup,curve,prevention,potentially,onwards,trips,imposed,hosting,striking,strict,admission,apartments,solely,utility,proceeded,observations,euro,incidents,vinyl,profession,haven,distant,expelled,rivalry,runway,torpedo,zones,shrine,dimensions,investigations,lithuania,idaho,pursuit,copenhagen,considerably,locality,wireless,decrease,genes,thermal,deposits,hindi,habitats,withdrawn,biblical,monuments,casting,plateau,thesis,managers,flooding,assassination,acknowledged,interim,inscription,guided,pastor,finale,insects,transported,activists,marshal,intensity,airing,cardiff,proposals,lifestyle,prey,herald,capitol,aboriginal,measuring,lasting,interpreted,occurring,desired,drawings,healthcare,panels,elimination,oslo,ghana,blog,sabha,intent,superintendent,governors,bankruptcy,p.m.,equity,disk,layers,slovenia,prussia,quartet,mechanics,graduates,politically,monks,screenplay,nato,absorbed,topped,petition,bold,morocco,exhibits,canterbury,publish,rankings,crater,dominican,enhanced,planes,lutheran,governmental,joins,collecting,brussels,unified,streak,strategies,flagship,surfaces,oval,archive,etymology,imprisonment,instructor,noting,remix,opposing,servant,rotation,width,trans,maker,synthesis,excess,tactics,snail,ltd.,lighthouse,sequences,cornwall,plantation,mythology,performs,foundations,populated,horizontal,speedway,activated,performer,diving,conceived,edmonton,subtropical,environments,prompted,semifinals,caps,bulk,treasury,recreational,telegraph,continent,portraits,relegation,catholics,graph,velocity,rulers,endangered,secular,observer,learns,inquiry,idol,dictionary,certification,estimate,cluster,armenia,observatory,revived,nadu,consumers,hypothesis,manuscripts,contents,arguments,editing,trails,arctic,essays,belfast,acquire,promotional,undertaken,corridor,proceedings,antarctic,millennium,labels,delegates,vegetation,acclaim,directing,substance,outcome,diploma,philosopher,malta,albanian,vicinity,degc,legends,regiments,consent,terrorist,scattered,presidents,gravity,orientation,deployment,duchy,refuses,estonia,crowned,separately,renovation,rises,wilderness,objectives,agreements,empress,slopes,inclusion,equality,decree,ballot,criticised,rochester,recurring,struggled,disabled,henri,poles,prussian,convert,bacteria,poorly,sudan,geological,wyoming,consistently,minimal,withdrawal,interviewed,proximity,repairs,initiatives,pakistani,republicans,propaganda,viii,abstract,commercially,availability,mechanisms,naples,discussions,underlying,lens,proclaimed,advised,spelling,auxiliary,attract,lithuanian,editors,o'brien,accordance,measurement,novelist,ussr,formats,councils,contestants,indie,facebook,parishes,barrier,battalions,sponsor,consulting,terrorism,implement,uganda,crucial,unclear,notion,distinguish,collector,attractions,filipino,ecology,investments,capability,renovated,iceland,albania,accredited,scouts,armor,sculptor,cognitive,errors,gaming,condemned,successive,consolidated,baroque,entries,regulatory,reserved,treasurer,variables,arose,technological,rounded,provider,rhine,agrees,accuracy,genera,decreased,frankfurt,ecuador,edges,particle,rendered,calculated,careers,faction,rifles,americas,gaelic,portsmouth,resides,merchants,fiscal,premises,coin,draws,presenter,acceptance,ceremonies,pollution,consensus,membrane,brigadier,nonetheless,genres,supervision,predicted,magnitude,finite,differ,ancestry,vale,delegation,removing,proceeds,placement,emigrated,siblings,molecules,payments,considers,demonstration,proportion,newer,valve,achieving,confederation,continuously,luxury,notre,introducing,coordinates,charitable,squadrons,disorders,geometry,winnipeg,ulster,loans,longtime,receptor,preceding,belgrade,mandate,wrestler,neighbourhood,factories,buddhism,imported,sectors,protagonist,steep,elaborate,prohibited,artifacts,prizes,pupil,cooperative,sovereign,subspecies,carriers,allmusic,nationals,settings,autobiography,neighborhoods,analog,facilitate,voluntary,jointly,newfoundland,organizing,raids,exercises,nobel,machinery,baltic,crop,granite,dense,websites,mandatory,seeks,surrendered,anthology,comedian,bombs,slot,synopsis,critically,arcade,marking,equations,halls,indo,inaugurated,embarked,speeds,clause,invention,premiership,likewise,presenting,demonstrate,designers,organize,examined,km/h,bavaria,troop,referee,detection,zurich,prairie,rapper,wingspan,eurovision,luxembourg,slovakia,inception,disputed,mammals,entrepreneur,makers,evangelical,yield,clergy,trademark,defunct,allocated,depicting,volcanic,batted,conquered,sculptures,providers,reflects,armoured,locals,walt,herzegovina,contracted,entities,sponsorship,prominence,flowing,ethiopia,marketed,corporations,withdraw,carnegie,induced,investigated,portfolio,flowering,opinions,viewing,classroom,donations,bounded,perception,leicester,fruits,charleston,academics,statute,complaints,smallest,deceased,petroleum,resolved,commanders,algebra,southampton,modes,cultivation,transmitter,spelled,obtaining,sizes,acre,pageant,bats,abbreviated,correspondence,barracks,feast,tackles,raja,derives,geology,disputes,translations,counted,constantinople,seating,macedonia,preventing,accommodation,homeland,explored,invaded,provisional,transform,sphere,unsuccessfully,missionaries,conservatives,highlights,traces,organisms,openly,dancers,fossils,absent,monarchy,combining,lanes,stint,dynamics,chains,missiles,screening,module,tribune,generating,miners,nottingham,seoul,unofficial,owing,linking,rehabilitation,citation,louisville,mollusk,depicts,differential,zimbabwe,kosovo,recommendations,responses,pottery,scorer,aided,exceptions,dialects,telecommunications,defines,elderly,lunar,coupled,flown,25th,espn,formula_1,bordered,fragments,guidelines,gymnasium,valued,complexity,papal,presumably,maternal,challenging,reunited,advancing,comprised,uncertain,favorable,twelfth,correspondent,nobility,livestock,expressway,chilean,tide,researcher,emissions,profits,lengths,accompanying,witnessed,itunes,drainage,slope,reinforced,feminist,sanskrit,develops,physicians,outlets,isbn,coordinator,averaged,termed,occupy,diagnosed,yearly,humanitarian,prospect,spacecraft,stems,enacted,linux,ancestors,karnataka,constitute,immigrant,thriller,ecclesiastical,generals,celebrations,enhance,heating,advocated,evident,advances,bombardment,watershed,shuttle,wicket,twitter,adds,branded,teaches,schemes,pension,advocacy,conservatory,cairo,varsity,freshwater,providence,seemingly,shells,cuisine,specially,peaks,intensive,publishes,trilogy,skilled,nacional,unemployment,destinations,parameters,verses,trafficking,determination,infinite,savings,alignment,linguistic,countryside,dissolution,measurements,advantages,licence,subfamily,highlands,modest,regent,algeria,crest,teachings,knockout,brewery,combine,conventions,descended,chassis,primitive,fiji,explicitly,cumberland,uruguay,laboratories,bypass,elect,informal,preceded,holocaust,tackle,minneapolis,quantity,securities,console,doctoral,religions,commissioners,expertise,unveiled,precise,diplomat,standings,infant,disciplines,sicily,endorsed,systematic,charted,armored,mild,lateral,townships,hurling,prolific,invested,wartime,compatible,galleries,moist,battlefield,decoration,convent,tubes,terrestrial,nominee,requests,delegate,leased,dubai,polar,applying,addresses,munster,sings,commercials,teamed,dances,eleventh,midland,cedar,flee,sandstone,snails,inspection,divide,asset,themed,comparable,paramount,dairy,archaeology,intact,institutes,rectangular,instances,phases,reflecting,substantially,applies,vacant,lacked,copa,coloured,encounters,sponsors,encoded,possess,revenues,ucla,chaired,a.m.,enabling,playwright,stoke,sociology,tibetan,frames,motto,financing,illustrations,gibraltar,chateau,bolivia,transmitted,enclosed,persuaded,urged,folded,suffolk,regulated,bros.,submarines,myth,oriental,malaysian,effectiveness,narrowly,acute,sunk,replied,utilized,tasmania,consortium,quantities,gains,parkway,enlarged,sided,employers,adequate,accordingly,assumption,ballad,mascot,distances,peaking,saxony,projected,affiliation,limitations,metals,guatemala,scots,theaters,kindergarten,verb,employer,differs,discharge,controller,seasonal,marching,guru,campuses,avoided,vatican,maori,excessive,chartered,modifications,caves,monetary,sacramento,mixing,institutional,celebrities,irrigation,shapes,broadcaster,anthem,attributes,demolition,offshore,specification,surveys,yugoslav,contributor,auditorium,lebanese,capturing,airports,classrooms,chennai,paths,tendency,determining,lacking,upgrade,sailors,detected,kingdoms,sovereignty,freely,decorative,momentum,scholarly,georges,gandhi,speculation,transactions,undertook,interact,similarities,cove,teammate,constituted,painters,tends,madagascar,partnerships,afghan,personalities,attained,rebounds,masses,synagogue,reopened,asylum,embedded,imaging,catalogue,defenders,taxonomy,fiber,afterward,appealed,communists,lisbon,rica,judaism,adviser,batsman,ecological,commands,lgbt,cooling,accessed,wards,shiva,employs,thirds,scenic,worcester,tallest,contestant,humanities,economist,textile,constituencies,motorway,tram,percussion,cloth,leisure,1880s,baden,flags,resemble,riots,coined,sitcom,composite,implies,daytime,tanzania,penalties,optional,competitor,excluded,steering,reversed,autonomy,reviewer,breakthrough,professionally,damages,pomeranian,deputies,valleys,ventures,highlighted,electorate,mapping,shortened,executives,tertiary,specimen,launching,bibliography,sank,pursuing,binary,descendant,marched,natives,ideology,turks,adolf,archdiocese,tribunal,exceptional,nigerian,preference,fails,loading,comeback,vacuum,favored,alter,remnants,consecrated,spectators,trends,patriarch,feedback,paved,sentences,councillor,astronomy,advocates,broader,commentator,commissions,identifying,revealing,theatres,incomplete,enables,constituent,reformation,tract,haiti,atmospheric,screened,explosive,czechoslovakia,acids,symbolic,subdivision,liberals,incorporate,challenger,erie,filmmaker,laps,kazakhstan,organizational,evolutionary,chemicals,dedication,riverside,fauna,moths,maharashtra,annexed,gen.,resembles,underwater,garnered,timeline,remake,suited,educator,hectares,automotive,feared,latvia,finalist,narrator,portable,airways,plaque,designing,villagers,licensing,flank,statues,struggles,deutsche,migrated,cellular,jacksonville,wimbledon,defining,highlight,preparatory,planets,cologne,employ,frequencies,detachment,readily,libya,resign,halt,helicopters,reef,landmarks,collaborative,irregular,retaining,helsinki,folklore,weakened,viscount,interred,professors,memorable,mega,repertoire,rowing,dorsal,albeit,progressed,operative,coronation,liner,telugu,domains,philharmonic,detect,bengali,synthetic,tensions,atlas,dramatically,paralympics,xbox,shire,kiev,lengthy,sued,notorious,seas,screenwriter,transfers,aquatic,pioneers,unesco,radius,abundant,tunnels,syndicated,inventor,accreditation,janeiro,exeter,ceremonial,omaha,cadet,predators,resided,prose,slavic,precision,abbot,deity,engaging,cambodia,estonian,compliance,demonstrations,protesters,reactor,commodore,successes,chronicles,mare,extant,listings,minerals,tonnes,parody,cultivated,traders,pioneering,supplement,slovak,preparations,collision,partnered,vocational,atoms,malayalam,welcomed,documentation,curved,functioning,presently,formations,incorporates,nazis,botanical,nucleus,ethical,greeks,metric,automated,whereby,stance,europeans,duet,disability,purchasing,email,telescope,displaced,sodium,comparative,processor,inning,precipitation,aesthetic,import,coordination,feud,alternatively,mobility,tibet,regained,succeeding,hierarchy,apostolic,catalog,reproduction,inscriptions,vicar,clusters,posthumously,rican,loosely,additions,photographic,nowadays,selective,derivative,keyboards,guides,collectively,affecting,combines,operas,networking,decisive,terminated,continuity,finishes,ancestor,consul,heated,simulation,leipzig,incorporating,georgetown,formula_2,circa,forestry,portrayal,councillors,advancement,complained,forewings,confined,transaction,definitions,reduces,televised,1890s,rapids,phenomena,belarus,alps,landscapes,quarterly,specifications,commemorate,continuation,isolation,antenna,downstream,patents,ensuing,tended,saga,lifelong,columnist,labeled,gymnastics,papua,anticipated,demise,encompasses,madras,antarctica,interval,icon,rams,midlands,ingredients,priory,strengthen,rouge,explicit,gaza,aging,securing,anthropology,listeners,adaptations,underway,vista,malay,fortified,lightweight,violations,concerto,financed,jesuit,observers,trustee,descriptions,nordic,resistant,opted,accepts,prohibition,andhra,inflation,negro,wholly,imagery,spur,instructed,gloucester,cycles,middlesex,destroyers,statewide,evacuated,hyderabad,peasants,mice,shipyard,coordinate,pitching,colombian,exploring,numbering,compression,countess,hiatus,exceed,raced,archipelago,traits,soils,o'connor,vowel,android,facto,angola,amino,holders,logistics,circuits,emergence,kuwait,partition,emeritus,outcomes,submission,promotes,barack,negotiated,loaned,stripped,50th,excavations,treatments,fierce,participant,exports,decommissioned,cameo,remarked,residences,fuselage,mound,undergo,quarry,node,midwest,specializing,occupies,etc.,showcase,molecule,offs,modules,salon,exposition,revision,peers,positioned,hunters,competes,algorithms,reside,zagreb,calcium,uranium,silicon,airs,counterpart,outlet,collectors,sufficiently,canberra,inmates,anatomy,ensuring,curves,aviv,firearms,basque,volcano,thrust,sheikh,extensions,installations,aluminum,darker,sacked,emphasized,aligned,asserted,pseudonym,spanning,decorations,eighteenth,orbital,spatial,subdivided,notation,decay,macedonian,amended,declining,cyclist,feat,unusually,commuter,birthplace,latitude,activation,overhead,30th,finalists,whites,encyclopedia,tenor,qatar,survives,complement,concentrations,uncommon,astronomical,bangalore,pius,genome,memoir,recruit,prosecutor,modification,paired,container,basilica,arlington,displacement,germanic,mongolia,proportional,debates,matched,calcutta,rows,tehran,aerospace,prevalent,arise,lowland,24th,spokesman,supervised,advertisements,clash,tunes,revelation,wanderers,quarterfinals,fisheries,steadily,memoirs,pastoral,renewable,confluence,acquiring,strips,slogan,upstream,scouting,analyst,practitioners,turbine,strengthened,heavier,prehistoric,plural,excluding,isles,persecution,turin,rotating,villain,hemisphere,unaware,arabs,corpus,relied,singular,unanimous,schooling,passive,angles,dominance,instituted,aria,outskirts,balanced,beginnings,financially,structured,parachute,viewer,attitudes,subjected,escapes,derbyshire,erosion,addressing,styled,declaring,originating,colts,adjusted,stained,occurrence,fortifications,baghdad,nitrogen,localities,yemen,galway,debris,lodz,victorious,pharmaceutical,substances,unnamed,dwelling,atop,developmental,activism,voter,refugee,forested,relates,overlooking,genocide,kannada,insufficient,oversaw,partisan,dioxide,recipients,factions,mortality,capped,expeditions,receptors,reorganized,prominently,atom,flooded,flute,orchestral,scripts,mathematician,airplay,detached,rebuilding,dwarf,brotherhood,salvation,expressions,arabian,cameroon,poetic,recruiting,bundesliga,inserted,scrapped,disabilities,evacuation,pasha,undefeated,crafts,rituals,aluminium,norm,pools,submerged,occupying,pathway,exams,prosperity,wrestlers,promotions,basal,permits,nationalism,trim,merge,gazette,tributaries,transcription,caste,porto,emerge,modeled,adjoining,counterparts,paraguay,redevelopment,renewal,unreleased,equilibrium,similarity,minorities,soviets,comprise,nodes,tasked,unrelated,expired,johan,precursor,examinations,electrons,socialism,exiled,admiralty,floods,wigan,nonprofit,lacks,brigades,screens,repaired,hanover,fascist,labs,osaka,delays,judged,statutory,colt,col.,offspring,solving,bred,assisting,retains,somalia,grouped,corresponds,tunisia,chaplain,eminent,chord,22nd,spans,viral,innovations,possessions,mikhail,kolkata,icelandic,implications,introduces,racism,workforce,alto,compulsory,admits,censorship,onset,reluctant,inferior,iconic,progression,liability,turnout,satellites,behavioral,coordinated,exploitation,posterior,averaging,fringe,krakow,mountainous,greenwich,para,plantations,reinforcements,offerings,famed,intervals,constraints,individually,nutrition,1870s,taxation,threshold,tomatoes,fungi,contractor,ethiopian,apprentice,diabetes,wool,gujarat,honduras,norse,bucharest,23rd,arguably,accompany,prone,teammates,perennial,vacancy,polytechnic,deficit,okinawa,functionality,reminiscent,tolerance,transferring,myanmar,concludes,neighbours,hydraulic,economically,slower,plots,charities,synod,investor,catholicism,identifies,bronx,interpretations,adverse,judiciary,hereditary,nominal,sensor,symmetry,cubic,triangular,tenants,divisional,outreach,representations,passages,undergoing,cartridge,testified,exceeded,impacts,limiting,railroads,defeats,regain,rendering,humid,retreated,reliability,governorate,antwerp,infamous,implied,packaging,lahore,trades,billed,extinction,ecole,rejoined,recognizes,projection,qualifications,stripes,forts,socially,lexington,accurately,sexuality,westward,wikipedia,pilgrimage,abolition,choral,stuttgart,nests,expressing,strikeouts,assessed,monasteries,reconstructed,humorous,marxist,fertile,consort,urdu,patronage,peruvian,devised,lyric,baba,nassau,communism,extraction,popularly,markings,inability,litigation,accounted,processed,emirates,tempo,cadets,eponymous,contests,broadly,oxide,courtyard,frigate,directory,apex,outline,regency,chiefly,patrols,secretariat,cliffs,residency,privy,armament,australians,dorset,geometric,genetics,scholarships,fundraising,flats,demographic,multimedia,captained,documentaries,updates,canvas,blockade,guerrilla,songwriting,administrators,intake,drought,implementing,fraction,cannes,refusal,inscribed,meditation,announcing,exported,ballots,formula_3,curator,basel,arches,flour,subordinate,confrontation,gravel,simplified,berkshire,patriotic,tuition,employing,servers,castile,posting,combinations,discharged,miniature,mutations,constellation,incarnation,ideals,necessity,granting,ancestral,crowds,pioneered,mormon,methodology,rama,indirect,complexes,bavarian,patrons,uttar,skeleton,bollywood,flemish,viable,bloc,breeds,triggered,sustainability,tailed,referenced,comply,takeover,latvian,homestead,platoon,communal,nationality,excavated,targeting,sundays,posed,physicist,turret,endowment,marginal,dispatched,commentators,renovations,attachment,collaborations,ridges,barriers,obligations,shareholders,prof.,defenses,presided,rite,backgrounds,arbitrary,affordable,gloucestershire,thirteenth,inlet,miniseries,possesses,detained,pressures,subscription,realism,solidarity,proto,postgraduate,noun,burmese,abundance,homage,reasoning,anterior,robust,fencing,shifting,vowels,garde,profitable,loch,anchored,coastline,samoa,terminology,prostitution,magistrate,venezuelan,speculated,regulate,fixture,colonists,digit,induction,manned,expeditionary,computational,centennial,principally,vein,preserving,engineered,numerical,cancellation,conferred,continually,borne,seeded,advertisement,unanimously,treaties,infections,ions,sensors,lowered,amphibious,lava,fourteenth,bahrain,niagara,nicaragua,squares,congregations,26th,periodic,proprietary,1860s,contributors,seller,overs,emission,procession,presumed,illustrator,zinc,gases,tens,applicable,stretches,reproductive,sixteenth,apparatus,accomplishments,canoe,guam,oppose,recruitment,accumulated,limerick,namibia,staging,remixes,ordnance,uncertainty,pedestrian,temperate,treason,deposited,registry,cerambycidae,attracting,lankan,reprinted,shipbuilding,homosexuality,neurons,eliminating,1900s,resume,ministries,beneficial,blackpool,surplus,northampton,licenses,constructing,announcer,standardized,alternatives,taipei,inadequate,failures,yields,medalist,titular,obsolete,torah,burlington,predecessors,lublin,retailers,castles,depiction,issuing,gubernatorial,propulsion,tiles,damascus,discs,alternating,pomerania,peasant,tavern,redesignated,27th,illustration,focal,mans,codex,specialists,productivity,antiquity,controversies,promoter,pits,companions,behaviors,lyrical,prestige,creativity,swansea,dramas,approximate,feudal,tissues,crude,campaigned,unprecedented,chancel,amendments,surroundings,allegiance,exchanges,align,firmly,optimal,commenting,reigning,landings,obscure,1850s,contemporaries,paternal,devi,endurance,communes,incorporation,denominations,exchanged,routing,resorts,amnesty,slender,explores,suppression,heats,pronunciation,centred,coupe,stirling,freelance,treatise,linguistics,laos,informs,discovering,pillars,encourages,halted,robots,definitive,maturity,tuberculosis,venetian,silesian,unchanged,originates,mali,lincolnshire,quotes,seniors,premise,contingent,distribute,danube,gorge,logging,dams,curling,seventeenth,specializes,wetlands,deities,assess,thickness,rigid,culminated,utilities,substrate,insignia,nile,assam,shri,currents,suffrage,canadians,mortar,asteroid,bosnian,discoveries,enzymes,sanctioned,replica,hymn,investigators,tidal,dominate,derivatives,converting,leinster,verbs,honoured,criticisms,dismissal,discrete,masculine,reorganization,unlimited,wurttemberg,sacks,allocation,bahn,jurisdictions,participates,lagoon,famine,communion,culminating,surveyed,shortage,cables,intersects,cassette,foremost,adopting,solicitor,outright,bihar,reissued,farmland,dissertation,turnpike,baton,photographed,christchurch,kyoto,finances,rails,histories,linebacker,kilkenny,accelerated,dispersed,handicap,absorption,rancho,ceramic,captivity,cites,font,weighed,mater,utilize,bravery,extract,validity,slovenian,seminars,discourse,ranged,duel,ironically,warships,sega,temporal,surpassed,prolonged,recruits,northumberland,greenland,contributes,patented,eligibility,unification,discusses,reply,translates,beirut,relies,torque,northward,reviewers,monastic,accession,neural,tramway,heirs,sikh,subscribers,amenities,taliban,audit,rotterdam,wagons,kurdish,favoured,combustion,meanings,persia,browser,diagnostic,niger,formula_4,denomination,dividing,parameter,branding,badminton,leningrad,sparked,hurricanes,beetles,propeller,mozambique,refined,diagram,exhaust,vacated,readings,markers,reconciliation,determines,concurrent,imprint,primera,organism,demonstrating,filmmakers,vanderbilt,affiliates,traction,evaluated,defendants,megachile,investigative,zambia,assassinated,rewarded,probable,staffordshire,foreigners,directorate,nominees,consolidation,commandant,reddish,differing,unrest,drilling,bohemia,resembling,instrumentation,considerations,haute,promptly,variously,dwellings,clans,tablet,enforced,cockpit,semifinal,hussein,prisons,ceylon,emblem,monumental,phrases,correspond,crossover,outlined,characterised,acceleration,caucus,crusade,protested,composing,rajasthan,habsburg,rhythmic,interception,inherent,cooled,ponds,spokesperson,gradual,consultation,kuala,globally,suppressed,builders,avengers,suffix,integer,enforce,fibers,unionist,proclamation,uncovered,infrared,adapt,eisenhower,utilizing,captains,stretched,observing,assumes,prevents,analyses,saxophone,caucasus,notices,villains,dartmouth,mongol,hostilities,stretching,veterinary,lenses,texture,prompting,overthrow,excavation,islanders,masovian,battleship,biographer,replay,degradation,departing,luftwaffe,fleeing,oversight,immigrated,serbs,fishermen,strengthening,respiratory,italians,denotes,radial,escorted,motif,wiltshire,expresses,accessories,reverted,establishments,inequality,protocols,charting,famously,satirical,entirety,trench,friction,atletico,sampling,subset,weekday,upheld,sharply,correlation,incorrect,mughal,travelers,hasan,earnings,offset,evaluate,specialised,recognizing,flexibility,nagar,postseason,algebraic,capitalism,crystals,melodies,polynomial,racecourse,defences,austro,wembley,attracts,anarchist,resurrection,reviewing,decreasing,prefix,ratified,mutation,displaying,separating,restoring,assemblies,ordinance,priesthood,cruisers,appoint,moldova,imports,directive,epidemic,militant,senegal,signaling,restriction,critique,retrospective,nationalists,undertake,sioux,canals,algerian,redesigned,philanthropist,depict,conceptual,turbines,intellectuals,eastward,applicants,contractors,vendors,undergone,namesake,ensured,tones,substituted,hindwings,arrests,tombs,transitional,principality,reelection,taiwanese,cavity,manifesto,broadcasters,spawned,thoroughbred,identities,generators,proposes,hydroelectric,johannesburg,cortex,scandinavian,killings,aggression,boycott,catalyst,physiology,fifteenth,waterfront,chromosome,organist,costly,calculation,cemeteries,flourished,recognise,juniors,merging,disciples,ashore,workplace,enlightenment,diminished,debated,hailed,podium,educate,mandated,distributor,litre,electromagnetic,flotilla,estuary,peterborough,staircase,selections,melodic,confronts,wholesale,integrate,intercepted,catalonia,unite,immense,palatinate,switches,earthquakes,occupational,successors,praising,concluding,faculties,firstly,overhaul,empirical,metacritic,inauguration,evergreen,laden,winged,philosophers,amalgamated,geoff,centimeters,napoleonic,upright,planting,brewing,fined,sensory,migrants,wherein,inactive,headmaster,warwickshire,siberia,terminals,denounced,academia,divinity,bilateral,clive,omitted,peerage,relics,apartheid,syndicate,fearing,fixtures,desirable,dismantled,ethnicity,valves,biodiversity,aquarium,ideological,visibility,creators,analyzed,tenant,balkan,postwar,supplier,smithsonian,risen,morphology,digits,bohemian,wilmington,vishnu,demonstrates,aforementioned,biographical,mapped,khorasan,phosphate,presentations,ecosystem,processors,calculations,mosaic,clashes,penned,recalls,coding,angular,lattice,macau,accountability,extracted,pollen,therapeutic,overlap,violinist,deposed,candidacy,infants,covenant,bacterial,restructuring,dungeons,ordination,conducts,builds,invasive,customary,concurrently,relocation,cello,statutes,borneo,entrepreneurs,sanctions,packet,rockefeller,piedmont,comparisons,waterfall,receptions,glacial,surge,signatures,alterations,advertised,enduring,somali,botanist,100th,canonical,motifs,longitude,circulated,alloy,indirectly,margins,preserves,internally,besieged,shale,peripheral,drained,baseman,reassigned,tobago,soloist,socio,grazing,contexts,roofs,portraying,ottomans,shrewsbury,noteworthy,lamps,supplying,beams,qualifier,portray,greenhouse,stronghold,hitter,rites,cretaceous,urging,derive,nautical,aiming,fortunes,verde,donors,reliance,exceeding,exclusion,exercised,simultaneous,continents,guiding,pillar,gradient,poznan,eruption,clinics,moroccan,indicator,trams,piers,parallels,fragment,teatro,potassium,satire,compressed,businessmen,influx,seine,perspectives,shelters,decreases,mounting,formula_5,confederacy,equestrian,expulsion,mayors,liberia,resisted,affinity,shrub,unexpectedly,stimulus,amtrak,deported,perpendicular,statesman,wharf,storylines,romanesque,weights,surfaced,interceptions,dhaka,crambidae,orchestras,rwanda,conclude,constitutes,subsidiaries,admissions,prospective,shear,bilingual,campaigning,presiding,domination,commemorative,trailing,confiscated,petrol,acquisitions,polymer,onlyinclude,chloride,elevations,resolutions,hurdles,pledged,likelihood,objected,erect,encoding,databases,aristotle,hindus,marshes,bowled,ministerial,grange,acronym,annexation,squads,ambient,pilgrims,botany,sofla,astronomer,planetary,descending,bestowed,ceramics,diplomacy,metabolism,colonization,potomac,africans,engraved,recycling,commitments,resonance,disciplinary,jamaican,narrated,spectral,tipperary,waterford,stationary,arbitration,transparency,threatens,crossroads,slalom,oversee,centenary,incidence,economies,livery,moisture,newsletter,autobiographical,bhutan,propelled,dependence,moderately,adobe,barrels,subdivisions,outlook,labelled,stratford,arising,diaspora,barony,automobiles,ornamental,slated,norms,primetime,generalized,analysts,vectors,libyan,yielded,certificates,rooted,vernacular,belarusian,marketplace,prediction,fairfax,malawi,viruses,wooded,demos,mauritius,prosperous,coincided,liberties,huddersfield,ascent,warnings,hinduism,glucose,pulitzer,unused,filters,illegitimate,acquitted,protestants,canopy,staple,psychedelic,winding,abbas,pathways,cheltenham,lagos,niche,invaders,proponents,barred,conversely,doncaster,recession,embraced,rematch,concession,emigration,upgrades,bowls,tablets,remixed,loops,kensington,shootout,monarchs,organizers,harmful,punjabi,broadband,exempt,neolithic,profiles,portrays,parma,cyrillic,quasi,attested,regimental,revive,torpedoes,heidelberg,rhythms,spherical,denote,hymns,icons,theologian,qaeda,exceptionally,reinstated,comune,playhouse,lobbying,grossing,viceroy,delivers,visually,armistice,utrecht,syllable,vertices,analogous,annex,refurbished,entrants,knighted,disciple,rhetoric,detailing,inactivated,ballads,algae,intensified,favourable,sanitation,receivers,pornography,commemorated,cannons,entrusted,manifold,photographers,pueblo,textiles,steamer,myths,marquess,onward,liturgical,romney,uzbekistan,consistency,denoted,hertfordshire,convex,hearings,sulfur,universidad,podcast,selecting,emperors,arises,justices,1840s,mongolian,exploited,termination,digitally,infectious,sedan,symmetric,penal,illustrate,formulation,attribute,problematic,modular,inverse,berth,searches,rutgers,leicestershire,enthusiasts,lockheed,upwards,transverse,accolades,backward,archaeologists,crusaders,nuremberg,defects,ferries,vogue,containers,openings,transporting,separates,lumpur,purchases,attain,wichita,topology,woodlands,deleted,periodically,syntax,overturned,musicals,corp.,strasbourg,instability,nationale,prevailing,cache,marathi,versailles,unmarried,grains,straits,antagonist,segregation,assistants,d'etat,contention,dictatorship,unpopular,motorcycles,criterion,analytical,salzburg,militants,hanged,worcestershire,emphasize,paralympic,erupted,convinces,offences,oxidation,nouns,populace,atari,spanned,hazardous,educators,playable,births,baha'i,preseason,generates,invites,meteorological,handbook,foothills,enclosure,diffusion,mirza,convergence,geelong,coefficient,connector,formula_6,cylindrical,disasters,pleaded,knoxville,contamination,compose,libertarian,arrondissement,franciscan,intercontinental,susceptible,initiation,malaria,unbeaten,consonants,waived,saloon,popularized,estadio,pseudo,interdisciplinary,transports,transformers,carriages,bombings,revolves,ceded,collaborator,celestial,exemption,colchester,maltese,oceanic,ligue,crete,shareholder,routed,depictions,ridden,advisors,calculate,lending,guangzhou,simplicity,newscast,scheduling,snout,eliot,undertaking,armenians,nottinghamshire,whitish,consulted,deficiency,salle,cinemas,superseded,rigorous,kerman,convened,landowners,modernization,evenings,pitches,conditional,scandinavia,differed,formulated,cyclists,swami,guyana,dunes,electrified,appalachian,abdomen,scenarios,prototypes,sindh,consonant,adaptive,boroughs,wolverhampton,modelling,cylinders,amounted,minimize,ambassadors,lenin,settler,coincide,approximation,grouping,murals,bullying,registers,rumours,engagements,energetic,vertex,annals,bordering,geologic,yellowish,runoff,converts,allegheny,facilitated,saturdays,colliery,monitored,rainforest,interfaces,geographically,impaired,prevalence,joachim,paperback,slowed,shankar,distinguishing,seminal,categorized,authorised,auspices,bandwidth,asserts,rebranded,balkans,supplemented,seldom,weaving,capsule,apostles,populous,monmouth,payload,symphonic,densely,shoreline,managerial,masonry,antioch,averages,textbooks,royalist,coliseum,tandem,brewers,diocesan,posthumous,walled,incorrectly,distributions,ensued,reasonably,graffiti,propagation,automation,harmonic,augmented,middleweight,limbs,elongated,landfall,comparatively,literal,grossed,koppen,wavelength,1830s,cerebral,boasts,congestion,physiological,practitioner,coasts,cartoonist,undisclosed,frontal,launches,burgundy,qualifiers,imposing,stade,flanked,assyrian,raided,multiplayer,montane,chesapeake,pathology,drains,vineyards,intercollegiate,semiconductor,grassland,convey,citations,predominant,rejects,benefited,yahoo,graphs,busiest,encompassing,hamlets,explorers,suppress,minors,graphical,calculus,sediment,intends,diverted,mainline,unopposed,cottages,initiate,alumnus,towed,autism,forums,darlington,modernist,oxfordshire,lectured,capitalist,suppliers,panchayat,actresses,foundry,southbound,commodity,wesleyan,divides,palestinians,luton,caretaker,nobleman,mutiny,organizer,preferences,nomenclature,splits,unwilling,offenders,timor,relying,halftime,semitic,arithmetic,milestone,jesuits,arctiidae,retrieved,consuming,contender,edged,plagued,inclusive,transforming,khmer,federally,insurgents,distributing,amherst,rendition,prosecutors,viaduct,disqualified,kabul,liturgy,prevailed,reelected,instructors,swimmers,aperture,churchyard,interventions,totals,darts,metropolis,fuels,fluent,northbound,correctional,inflicted,barrister,realms,culturally,aristocratic,collaborating,emphasizes,choreographer,inputs,ensembles,humboldt,practised,endowed,strains,infringement,archaeologist,congregational,magna,relativity,efficiently,proliferation,mixtape,abruptly,regeneration,commissioning,yukon,archaic,reluctantly,retailer,northamptonshire,universally,crossings,boilers,nickelodeon,revue,abbreviation,retaliation,scripture,routinely,medicinal,benedictine,kenyan,retention,deteriorated,glaciers,apprenticeship,coupling,researched,topography,entrances,anaheim,pivotal,compensate,arched,modify,reinforce,dusseldorf,journeys,motorsport,conceded,sumatra,spaniards,quantitative,loire,cinematography,discarded,botswana,morale,engined,zionist,philanthropy,sainte,fatalities,cypriot,motorsports,indicators,pricing,institut,bethlehem,implicated,gravitational,differentiation,rotor,thriving,precedent,ambiguous,concessions,forecast,conserved,fremantle,asphalt,landslide,middlesbrough,formula_7,humidity,overseeing,chronological,diaries,multinational,crimean,turnover,improvised,youths,declares,tasmanian,canadiens,fumble,refinery,weekdays,unconstitutional,upward,guardians,brownish,imminent,hamas,endorsement,naturalist,martyrs,caledonia,chords,yeshiva,reptiles,severity,mitsubishi,fairs,installment,substitution,repertory,keyboardist,interpreter,silesia,noticeable,rhineland,transmit,inconsistent,booklet,academies,epithet,pertaining,progressively,aquatics,scrutiny,prefect,toxicity,rugged,consume,o'donnell,evolve,uniquely,cabaret,mediated,landowner,transgender,palazzo,compilations,albuquerque,induce,sinai,remastered,efficacy,underside,analogue,specify,possessing,advocating,compatibility,liberated,greenville,mecklenburg,header,memorials,sewage,rhodesia,1800s,salaries,atoll,coordinating,partisans,repealed,amidst,subjective,optimization,nectar,evolving,exploits,madhya,styling,accumulation,raion,postage,responds,buccaneers,frontman,brunei,choreography,coated,kinetic,sampled,inflammatory,complementary,eclectic,norte,vijay,a.k.a,mainz,casualty,connectivity,laureate,franchises,yiddish,reputed,unpublished,economical,periodicals,vertically,bicycles,brethren,capacities,unitary,archeological,tehsil,domesday,wehrmacht,justification,angered,mysore,fielded,abuses,nutrients,ambitions,taluk,battleships,symbolism,superiority,neglect,attendees,commentaries,collaborators,predictions,yorker,breeders,investing,libretto,informally,coefficients,memorandum,pounder,collingwood,tightly,envisioned,arbor,mistakenly,captures,nesting,conflicting,enhancing,streetcar,manufactures,buckinghamshire,rewards,commemorating,stony,expenditure,tornadoes,semantic,relocate,weimar,iberian,sighted,intending,ensign,beverages,expectation,differentiate,centro,utilizes,saxophonist,catchment,transylvania,ecosystems,shortest,sediments,socialists,ineffective,kapoor,formidable,heroine,guantanamo,prepares,scattering,pamphlet,verified,elector,barons,totaling,shrubs,pyrenees,amalgamation,mutually,longitudinal,comte,negatively,masonic,envoy,sexes,akbar,mythical,tonga,bishopric,assessments,malaya,warns,interiors,reefs,reflections,neutrality,musically,nomadic,waterways,provence,collaborate,scaled,adulthood,emerges,euros,optics,incentives,overland,periodical,liege,awarding,realization,slang,affirmed,schooner,hokkaido,czechoslovak,protectorate,undrafted,disagreed,commencement,electors,spruce,swindon,fueled,equatorial,inventions,suites,slovene,backdrop,adjunct,energies,remnant,inhabit,alliances,simulcast,reactors,mosques,travellers,outfielder,plumage,migratory,benin,experimented,fibre,projecting,drafting,laude,evidenced,northernmost,indicted,directional,replication,croydon,comedies,jailed,organizes,devotees,reservoirs,turrets,originate,economists,songwriters,junta,trenches,mounds,proportions,comedic,apostle,azerbaijani,farmhouse,resembled,disrupted,playback,mixes,diagonal,relevance,govern,programmer,gdansk,maize,soundtracks,tendencies,mastered,impacted,believers,kilometre,intervene,chairperson,aerodrome,sails,subsidies,ensures,aesthetics,congresses,ratios,sardinia,southernmost,functioned,controllers,downward,randomly,distortion,regents,palatine,disruption,spirituality,vidhan,tracts,compiler,ventilation,anchorage,symposium,assert,pistols,excelled,avenues,convoys,moniker,constructions,proponent,phased,spines,organising,schleswig,policing,campeonato,mined,hourly,croix,lucrative,authenticity,haitian,stimulation,burkina,espionage,midfield,manually,staffed,awakening,metabolic,biographies,entrepreneurship,conspicuous,guangdong,preface,subgroup,mythological,adjutant,feminism,vilnius,oversees,honourable,tripoli,stylized,kinase,societe,notoriety,altitudes,configurations,outward,transmissions,announces,auditor,ethanol,clube,nanjing,mecca,haifa,blogs,postmaster,paramilitary,depart,positioning,potent,recognizable,spire,brackets,remembrance,overlapping,turkic,articulated,scientology,operatic,deploy,readiness,biotechnology,restrict,cinematographer,inverted,synonymous,administratively,westphalia,commodities,replaces,downloads,centralized,munitions,preached,sichuan,fashionable,implementations,matrices,hiv/aids,loyalist,luzon,celebrates,hazards,heiress,mercenaries,synonym,creole,ljubljana,technician,auditioned,technicians,viewpoint,wetland,mongols,princely,sharif,coating,dynasties,southward,doubling,formula_8,mayoral,harvesting,conjecture,goaltender,oceania,spokane,welterweight,bracket,gatherings,weighted,newscasts,mussolini,affiliations,disadvantage,vibrant,spheres,sultanate,distributors,disliked,establishes,marches,drastically,yielding,jewellery,yokohama,vascular,airlift,canons,subcommittee,repression,strengths,graded,outspoken,fused,pembroke,filmography,redundant,fatigue,repeal,threads,reissue,pennant,edible,vapor,corrections,stimuli,commemoration,dictator,anand,secession,amassed,orchards,pontifical,experimentation,greeted,bangor,forwards,decomposition,quran,trolley,chesterfield,traverse,sermons,burials,skier,climbs,consultants,petitioned,reproduce,parted,illuminated,kurdistan,reigned,occupants,packaged,geometridae,woven,regulating,protagonists,crafted,affluent,clergyman,consoles,migrant,supremacy,attackers,caliph,defect,convection,rallies,huron,resin,segunda,quota,warship,overseen,criticizing,shrines,glamorgan,lowering,beaux,hampered,invasions,conductors,collects,bluegrass,surrounds,substrates,perpetual,chronology,pulmonary,executions,crimea,compiling,noctuidae,battled,tumors,minsk,novgorod,serviced,yeast,computation,swamps,theodor,baronetcy,salford,uruguayan,shortages,odisha,siberian,novelty,cinematic,invitational,decks,dowager,oppression,bandits,appellate,state-of-the-art,clade,palaces,signalling,galaxies,industrialist,tensor,learnt,incurred,magistrates,binds,orbits,ciudad,willingness,peninsular,basins,biomedical,shafts,marlborough,bournemouth,withstand,fitzroy,dunedin,variance,steamship,integrating,muscular,fines,akron,bulbophyllum,malmo,disclosed,cornerstone,runways,medicines,twenty20,gettysburg,progresses,frigates,bodied,transformations,transforms,helens,modelled,versatile,regulator,pursuits,legitimacy,amplifier,scriptures,voyages,examines,presenters,octagonal,poultry,formula_9,anatolia,computed,migrate,directorial,hybrids,localized,preferring,guggenheim,persisted,grassroots,inflammation,fishery,otago,vigorous,professions,instructional,inexpensive,insurgency,legislators,sequels,surnames,agrarian,stainless,nairobi,minas,forerunner,aristocracy,transitions,sicilian,showcased,doses,hiroshima,summarized,gearbox,emancipation,limitation,nuclei,seismic,abandonment,dominating,appropriations,occupations,electrification,hilly,contracting,exaggerated,entertainer,kazan,oricon,cartridges,characterization,parcel,maharaja,exceeds,aspiring,obituary,flattened,contrasted,narration,replies,oblique,outpost,fronts,arranger,talmud,keynes,doctrines,endured,confesses,fortification,supervisors,kilometer,academie,jammu,bathurst,piracy,prostitutes,navarre,cumulative,cruises,lifeboat,twinned,radicals,interacting,expenditures,wexford,libre,futsal,curated,clockwise,colloquially,procurement,immaculate,lyricist,enhancement,porcelain,alzheimer,highlighting,judah,disagreements,storytelling,sheltered,wroclaw,vaudeville,contrasts,neoclassical,compares,contrasting,deciduous,francaise,descriptive,cyclic,reactive,antiquities,meiji,repeats,creditors,forcibly,newmarket,picturesque,impending,uneven,bison,raceway,solvent,ecumenical,optic,professorship,harvested,waterway,banjo,pharaoh,geologist,scanning,dissent,recycled,unmanned,retreating,gospels,aqueduct,branched,tallinn,groundbreaking,syllables,hangar,designations,procedural,craters,cabins,encryption,anthropologist,montevideo,outgoing,inverness,chattanooga,fascism,calais,chapels,groundwater,downfall,misleading,robotic,tortricidae,pixel,handel,prohibit,crewe,renaming,reprised,kickoff,leftist,spaced,integers,causeway,pines,authorship,organise,ptolemy,accessibility,virtues,lesions,iroquois,qur'an,atheist,synthesized,biennial,confederates,dietary,skaters,stresses,tariff,koreans,intercity,republics,quintet,baroness,naive,amplitude,insistence,tbilisi,residues,grammatical,diversified,egyptians,accompaniment,vibration,repository,mandal,topological,distinctions,coherent,invariant,batters,nuevo,internationals,implements,follower,bahia,widened,independents,cantonese,totaled,guadalajara,wolverines,befriended,muzzle,surveying,hungarians,medici,deportation,rayon,approx,recounts,attends,clerical,hellenic,furnished,alleging,soluble,systemic,gallantry,bolshevik,intervened,hostel,gunpowder,specialising,stimulate,leiden,removes,thematic,floral,bafta,printers,conglomerate,eroded,analytic,successively,lehigh,thessaloniki,kilda,clauses,ascended,nehru,scripted,tokugawa,competence,diplomats,exclude,consecration,freedoms,assaults,revisions,blacksmith,textual,sparse,concacaf,slain,uploaded,enraged,whaling,guise,stadiums,debuting,dormitory,cardiovascular,yunnan,dioceses,consultancy,notions,lordship,archdeacon,collided,medial,airfields,garment,wrestled,adriatic,reversal,refueling,verification,jakob,horseshoe,intricate,veracruz,sarawak,syndication,synthesizer,anthologies,stature,feasibility,guillaume,narratives,publicized,antrim,intermittent,constituents,grimsby,filmmaking,doping,unlawful,nominally,transmitting,documenting,seater,internationale,ejected,steamboat,alsace,boise,ineligible,geared,vassal,mustered,ville,inline,pairing,eurasian,kyrgyzstan,barnsley,reprise,stereotypes,rushes,conform,firefighters,deportivo,revolutionaries,rabbis,concurrency,charters,sustaining,aspirations,algiers,chichester,falkland,morphological,systematically,volcanoes,designate,artworks,reclaimed,jurist,anglia,resurrected,chaotic,feasible,circulating,simulated,environmentally,confinement,adventist,harrisburg,laborers,ostensibly,universiade,pensions,influenza,bratislava,octave,refurbishment,gothenburg,putin,barangay,annapolis,breaststroke,illustrates,distorted,choreographed,promo,emphasizing,stakeholders,descends,exhibiting,intrinsic,invertebrates,evenly,roundabout,salts,formula_10,strata,inhibition,branching,stylistic,rumored,realises,mitochondrial,commuted,adherents,logos,bloomberg,telenovela,guineas,charcoal,engages,winery,reflective,siena,cambridgeshire,ventral,flashback,installing,engraving,grasses,traveller,rotated,proprietor,nationalities,precedence,sourced,trainers,cambodian,reductions,depleted,saharan,classifications,biochemistry,plaintiffs,arboretum,humanist,fictitious,aleppo,climates,bazaar,his/her,homogeneous,multiplication,moines,indexed,linguist,skeletal,foliage,societal,differentiated,informing,mammal,infancy,archival,cafes,malls,graeme,musee,schizophrenia,fargo,pronouns,derivation,descend,ascending,terminating,deviation,recaptured,confessions,weakening,tajikistan,bahadur,pasture,b/hip,donegal,supervising,sikhs,thinkers,euclidean,reinforcement,friars,portage,fuscous,lucknow,synchronized,assertion,choirs,privatization,corrosion,multitude,skyscraper,royalties,ligament,usable,spores,directs,clashed,stockport,fronted,dependency,contiguous,biologist,backstroke,powerhouse,frescoes,phylogenetic,welding,kildare,gabon,conveyed,augsburg,severn,continuum,sahib,lille,injuring,passeriformesfamily,succeeds,translating,unitarian,startup,turbulent,outlying,philanthropic,stanislaw,idols,claremont,conical,haryana,armagh,blended,implicit,conditioned,modulation,rochdale,labourers,coinage,shortstop,potsdam,gears,obesity,bestseller,advisers,bouts,comedians,jozef,lausanne,taxonomic,correlated,columbian,marne,indications,psychologists,libel,edict,beaufort,disadvantages,renal,finalized,racehorse,unconventional,disturbances,falsely,zoology,adorned,redesign,executing,narrower,commended,appliances,stalls,resurgence,saskatoon,miscellaneous,permitting,epoch,formula_11,cumbria,forefront,vedic,eastenders,disposed,supermarkets,rower,inhibitor,magnesium,colourful,yusuf,harrow,formulas,centrally,balancing,ionic,nocturnal,consolidate,ornate,raiding,charismatic,accelerate,nominate,residual,dhabi,commemorates,attribution,uninhabited,mindanao,atrocities,genealogical,romani,applicant,enactment,abstraction,trough,pulpit,minuscule,misconduct,grenades,timely,supplements,messaging,curvature,ceasefire,telangana,susquehanna,braking,redistribution,shreveport,neighbourhoods,gregorian,widowed,khuzestan,empowerment,scholastic,evangelist,peptide,topical,theorist,historia,thence,sudanese,museo,jurisprudence,masurian,frankish,headlined,recounted,netball,petitions,tolerant,hectare,truncated,southend,methane,captives,reigns,massif,subunit,acidic,weightlifting,footballers,sabah,britannia,tunisian,segregated,sawmill,withdrawing,unpaid,weaponry,somme,perceptions,unicode,alcoholism,durban,wrought,waterfalls,jihad,auschwitz,upland,eastbound,adjective,anhalt,evaluating,regimes,guildford,reproduced,pamphlets,hierarchical,maneuvers,hanoi,fabricated,repetition,enriched,arterial,replacements,tides,globalization,adequately,westbound,satisfactory,fleets,phosphorus,lastly,neuroscience,anchors,xinjiang,membranes,improvisation,shipments,orthodoxy,submissions,bolivian,mahmud,ramps,leyte,pastures,outlines,flees,transmitters,fares,sequential,stimulated,novice,alternately,symmetrical,breakaway,layered,baronets,lizards,blackish,edouard,horsepower,penang,principals,mercantile,maldives,overwhelmingly,hawke,rallied,prostate,conscription,juveniles,maccabi,carvings,strikers,sudbury,spurred,improves,lombardy,macquarie,parisian,elastic,distillery,shetland,humane,brentford,wrexham,warehouses,routines,encompassed,introductory,isfahan,instituto,palais,revolutions,sporadic,impoverished,portico,fellowships,speculative,enroll,dormant,adhere,fundamentally,sculpted,meritorious,template,upgrading,reformer,rectory,uncredited,indicative,creeks,galveston,radically,hezbollah,firearm,educating,prohibits,trondheim,locus,refit,headwaters,screenings,lowlands,wasps,coarse,attaining,sedimentary,perished,pitchfork,interned,cerro,stagecoach,aeronautical,liter,transitioned,haydn,inaccurate,legislatures,bromwich,knesset,spectroscopy,butte,asiatic,degraded,concordia,catastrophic,lobes,wellness,pensacola,periphery,hapoel,theta,horizontally,freiburg,liberalism,pleas,durable,warmian,offenses,mesopotamia,shandong,unsuitable,hospitalized,appropriately,phonetic,encompass,conversions,observes,illnesses,breakout,assigns,crowns,inhibitors,nightly,manifestation,fountains,maximize,alphabetical,sloop,expands,newtown,widening,gaddafi,commencing,camouflage,footprint,tyrol,barangays,universite,highlanders,budgets,query,lobbied,westchester,equator,stipulated,pointe,distinguishes,allotted,embankment,advises,storing,loyalists,fourier,rehearsals,starvation,gland,rihanna,tubular,expressive,baccalaureate,intersections,revered,carbonate,eritrea,craftsmen,cosmopolitan,sequencing,corridors,shortlisted,bangladeshi,persians,mimic,parades,repetitive,recommends,flanks,promoters,incompatible,teaming,ammonia,greyhound,solos,improper,legislator,newsweek,recurrent,vitro,cavendish,eireann,crises,prophets,mandir,strategically,guerrillas,formula_12,ghent,contenders,equivalence,drone,sociological,hamid,castes,statehood,aland,clinched,relaunched,tariffs,simulations,williamsburg,rotate,mediation,smallpox,harmonica,lodges,lavish,restrictive,o'sullivan,detainees,polynomials,echoes,intersecting,learners,elects,charlemagne,defiance,epsom,liszt,facilitating,absorbing,revelations,padua,pieter,pious,penultimate,mammalian,montenegrin,supplementary,widows,aromatic,croats,roanoke,trieste,legions,subdistrict,babylonian,grasslands,volga,violently,sparsely,oldies,telecommunication,respondents,quarries,downloadable,commandos,taxpayer,catalytic,malabar,afforded,copying,declines,nawab,junctions,assessing,filtering,classed,disused,compliant,christoph,gottingen,civilizations,hermitage,caledonian,whereupon,ethnically,springsteen,mobilization,terraces,indus,excel,zoological,enrichment,simulate,guitarists,registrar,cappella,invoked,reused,manchu,configured,uppsala,genealogy,mergers,casts,curricular,rebelled,subcontinent,horticultural,parramatta,orchestrated,dockyard,claudius,decca,prohibiting,turkmenistan,brahmin,clandestine,obligatory,elaborated,parasitic,helix,constraint,spearheaded,rotherham,eviction,adapting,albans,rescues,sociologist,guiana,convicts,occurrences,kamen,antennas,asturias,wheeled,sanitary,deterioration,trier,theorists,baseline,announcements,valea,planners,factual,serialized,serials,bilbao,demoted,fission,jamestown,cholera,alleviate,alteration,indefinite,sulfate,paced,climatic,valuation,artisans,proficiency,aegean,regulators,fledgling,sealing,influencing,servicemen,frequented,cancers,tambon,narayan,bankers,clarified,embodied,engraver,reorganisation,dissatisfied,dictated,supplemental,temperance,ratification,puget,nutrient,pretoria,papyrus,uniting,ascribed,cores,coptic,schoolhouse,barrio,1910s,armory,defected,transatlantic,regulates,ported,artefacts,specifies,boasted,scorers,mollusks,emitted,navigable,quakers,projective,dialogues,reunification,exponential,vastly,banners,unsigned,dissipated,halves,coincidentally,leasing,purported,escorting,estimation,foxes,lifespan,inflorescence,assimilation,showdown,staunch,prologue,ligand,superliga,telescopes,northwards,keynote,heaviest,taunton,redeveloped,vocalists,podlaskie,soyuz,rodents,azores,moravian,outset,parentheses,apparel,domestically,authoritative,polymers,monterrey,inhibit,launcher,jordanian,folds,taxis,mandates,singled,liechtenstein,subsistence,marxism,ousted,governorship,servicing,offseason,modernism,prism,devout,translators,islamist,chromosomes,pitted,bedfordshire,fabrication,authoritarian,javanese,leaflets,transient,substantive,predatory,sigismund,assassinate,diagrams,arrays,rediscovered,reclamation,spawning,fjord,peacekeeping,strands,fabrics,highs,regulars,tirana,ultraviolet,athenian,filly,barnet,naacp,nueva,favourites,terminates,showcases,clones,inherently,interpreting,bjorn,finely,lauded,unspecified,chola,pleistocene,insulation,antilles,donetsk,funnel,nutritional,biennale,reactivated,southport,primate,cavaliers,austrians,interspersed,restarted,suriname,amplifiers,wladyslaw,blockbuster,sportsman,minogue,brightness,benches,bridgeport,initiating,israelis,orbiting,newcomers,externally,scaling,transcribed,impairment,luxurious,longevity,impetus,temperament,ceilings,tchaikovsky,spreads,pantheon,bureaucracy,1820s,heraldic,villas,formula_13,galician,meath,avoidance,corresponded,headlining,connacht,seekers,rappers,solids,monograph,scoreless,opole,isotopes,himalayas,parodies,garments,microscopic,republished,havilland,orkney,demonstrators,pathogen,saturated,hellenistic,facilitates,aerodynamic,relocating,indochina,laval,astronomers,bequeathed,administrations,extracts,nagoya,torquay,demography,medicare,ambiguity,renumbered,pursuant,concave,syriac,electrode,dispersal,henan,bialystok,walsall,crystalline,puebla,janata,illumination,tianjin,enslaved,coloration,championed,defamation,grille,johor,rejoin,caspian,fatally,planck,workings,appointing,institutionalized,wessex,modernized,exemplified,regatta,jacobite,parochial,programmers,blending,eruptions,insurrection,regression,indices,sited,dentistry,mobilized,furnishings,levant,primaries,ardent,nagasaki,conqueror,dorchester,opined,heartland,amman,mortally,wellesley,bowlers,outputs,coveted,orthography,immersion,disrepair,disadvantaged,curate,childless,condensed,codice_1,remodeled,resultant,bolsheviks,superfamily,saxons,2010s,contractual,rivalries,malacca,oaxaca,magnate,vertebrae,quezon,olympiad,yucatan,tyres,macro,specialization,commendation,caliphate,gunnery,exiles,excerpts,fraudulent,adjustable,aramaic,interceptor,drumming,standardization,reciprocal,adolescents,federalist,aeronautics,favorably,enforcing,reintroduced,zhejiang,refining,biplane,banknotes,accordion,intersect,illustrating,summits,classmate,militias,biomass,massacres,epidemiology,reworked,wrestlemania,nantes,auditory,taxon,elliptical,chemotherapy,asserting,avoids,proficient,airmen,yellowstone,multicultural,alloys,utilization,seniority,kuyavian,huntsville,orthogonal,bloomington,cultivars,casimir,internment,repulsed,impedance,revolving,fermentation,parana,shutout,partnering,empowered,islamabad,polled,classify,amphibians,greyish,obedience,4x100,projectile,khyber,halfback,relational,d'ivoire,synonyms,endeavour,padma,customized,mastery,defenceman,berber,purge,interestingly,covent,promulgated,restricting,condemnation,hillsborough,walkers,privateer,intra,captaincy,naturalized,huffington,detecting,hinted,migrating,bayou,counterattack,anatomical,foraging,unsafe,swiftly,outdated,paraguayan,attire,masjid,endeavors,jerseys,triassic,quechua,growers,axial,accumulate,wastewater,cognition,fungal,animator,pagoda,kochi,uniformly,antibody,yerevan,hypotheses,combatants,italianate,draining,fragmentation,snowfall,formative,inversion,kitchener,identifier,additive,lucha,selects,ashland,cambrian,racetrack,trapping,congenital,primates,wavelengths,expansions,yeomanry,harcourt,wealthiest,awaited,punta,intervening,aggressively,vichy,piloted,midtown,tailored,heyday,metadata,guadalcanal,inorganic,hadith,pulses,francais,tangent,scandals,erroneously,tractors,pigment,constabulary,jiangsu,landfill,merton,basalt,astor,forbade,debuts,collisions,exchequer,stadion,roofed,flavour,sculptors,conservancy,dissemination,electrically,undeveloped,existent,surpassing,pentecostal,manifested,amend,formula_14,superhuman,barges,tunis,analytics,argyll,liquids,mechanized,domes,mansions,himalayan,indexing,reuters,nonlinear,purification,exiting,timbers,triangles,decommissioning,departmental,causal,fonts,americana,sept.,seasonally,incomes,razavi,sheds,memorabilia,rotational,terre,sutra,protege,yarmouth,grandmaster,annum,looted,imperialism,variability,liquidation,baptised,isotope,showcasing,milling,rationale,hammersmith,austen,streamlined,acknowledging,contentious,qaleh,breadth,turing,referees,feral,toulon,unofficially,identifiable,standout,labeling,dissatisfaction,jurgen,angrily,featherweight,cantons,constrained,dominates,standalone,relinquished,theologians,markedly,italics,downed,nitrate,likened,gules,craftsman,singaporean,pixels,mandela,moray,parity,departement,antigen,academically,burgh,brahma,arranges,wounding,triathlon,nouveau,vanuatu,banded,acknowledges,unearthed,stemming,authentication,byzantines,converge,nepali,commonplace,deteriorating,recalling,palette,mathematicians,greenish,pictorial,ahmedabad,rouen,validation,u.s.a.,'best,malvern,archers,converter,undergoes,fluorescent,logistical,notification,transvaal,illicit,symphonies,stabilization,worsened,fukuoka,decrees,enthusiast,seychelles,blogger,louvre,dignitaries,burundi,wreckage,signage,pinyin,bursts,federer,polarization,urbana,lazio,schism,nietzsche,venerable,administers,seton,kilograms,invariably,kathmandu,farmed,disqualification,earldom,appropriated,fluctuations,kermanshah,deployments,deformation,wheelbase,maratha,psalm,bytes,methyl,engravings,skirmish,fayette,vaccines,ideally,astrology,breweries,botanic,opposes,harmonies,irregularities,contended,gaulle,prowess,constants,aground,filipinos,fresco,ochreous,jaipur,willamette,quercus,eastwards,mortars,champaign,braille,reforming,horned,hunan,spacious,agitation,draught,specialties,flourishing,greensboro,necessitated,swedes,elemental,whorls,hugely,structurally,plurality,synthesizers,embassies,assad,contradictory,inference,discontent,recreated,inspectors,unicef,commuters,embryo,modifying,stints,numerals,communicated,boosted,trumpeter,brightly,adherence,remade,leases,restrained,eucalyptus,dwellers,planar,grooves,gainesville,daimler,anzac,szczecin,cornerback,prized,peking,mauritania,khalifa,motorized,lodging,instrumentalist,fortresses,cervical,formula_15,passerine,sectarian,researches,apprenticed,reliefs,disclose,gliding,repairing,queue,kyushu,literate,canoeing,sacrament,separatist,calabria,parkland,flowed,investigates,statistically,visionary,commits,dragoons,scrolls,premieres,revisited,subdued,censored,patterned,elective,outlawed,orphaned,leyland,richly,fujian,miniatures,heresy,plaques,countered,nonfiction,exponent,moravia,dispersion,marylebone,midwestern,enclave,ithaca,federated,electronically,handheld,microscopy,tolls,arrivals,climbers,continual,cossacks,moselle,deserts,ubiquitous,gables,forecasts,deforestation,vertebrates,flanking,drilled,superstructure,inspected,consultative,bypassed,ballast,subsidy,socioeconomic,relic,grenada,journalistic,administering,accommodated,collapses,appropriation,reclassified,foreword,porte,assimilated,observance,fragmented,arundel,thuringia,gonzaga,shenzhen,shipyards,sectional,ayrshire,sloping,dependencies,promenade,ecuadorian,mangrove,constructs,goalscorer,heroism,iteration,transistor,omnibus,hampstead,cochin,overshadowed,chieftain,scalar,finishers,ghanaian,abnormalities,monoplane,encyclopaedia,characterize,travancore,baronetage,bearers,biking,distributes,paving,christened,inspections,banco,humber,corinth,quadratic,albanians,lineages,majored,roadside,inaccessible,inclination,darmstadt,fianna,epilepsy,propellers,papacy,montagu,bhutto,sugarcane,optimized,pilasters,contend,batsmen,brabant,housemates,sligo,ascot,aquinas,supervisory,accorded,gerais,echoed,nunavut,conservatoire,carniola,quartermaster,gminas,impeachment,aquitaine,reformers,quarterfinal,karlsruhe,accelerator,coeducational,archduke,gelechiidae,seaplane,dissident,frenchman,palau,depots,hardcover,aachen,darreh,denominational,groningen,parcels,reluctance,drafts,elliptic,counters,decreed,airship,devotional,contradiction,formula_16,undergraduates,qualitative,guatemalan,slavs,southland,blackhawks,detrimental,abolish,chechen,manifestations,arthritis,perch,fated,hebei,peshawar,palin,immensely,havre,totalling,rampant,ferns,concourse,triples,elites,olympian,larva,herds,lipid,karabakh,distal,monotypic,vojvodina,batavia,multiplied,spacing,spellings,pedestrians,parchment,glossy,industrialization,dehydrogenase,patriotism,abolitionist,mentoring,elizabethan,figurative,dysfunction,abyss,constantin,middletown,stigma,mondays,gambia,gaius,israelites,renounced,nepalese,overcoming,buren,sulphur,divergence,predation,looting,iberia,futuristic,shelved,anthropological,innsbruck,escalated,clermont,entrepreneurial,benchmark,mechanically,detachments,populist,apocalyptic,exited,embryonic,stanza,readership,chiba,landlords,expansive,boniface,therapies,perpetrators,whitehall,kassel,masts,carriageway,clinch,pathogens,mazandaran,undesirable,teutonic,miocene,nagpur,juris,cantata,compile,diffuse,dynastic,reopening,comptroller,o'neal,flourish,electing,scientifically,departs,welded,modal,cosmology,fukushima,libertadores,chang'an,asean,generalization,localization,afrikaans,cricketers,accompanies,emigrants,esoteric,southwards,shutdown,prequel,fittings,innate,wrongly,equitable,dictionaries,senatorial,bipolar,flashbacks,semitism,walkway,lyrically,legality,sorbonne,vigorously,durga,samoan,karel,interchanges,patna,decider,registering,electrodes,anarchists,excursion,overthrown,gilan,recited,michelangelo,advertiser,kinship,taboo,cessation,formula_17,premiers,traversed,madurai,poorest,torneo,exerted,replicate,spelt,sporadically,horde,landscaping,razed,hindered,esperanto,manchuria,propellant,jalan,baha'is,sikkim,linguists,pandit,racially,ligands,dowry,francophone,escarpment,behest,magdeburg,mainstay,villiers,yangtze,grupo,conspirators,martyrdom,noticeably,lexical,kazakh,unrestricted,utilised,sired,inhabits,proofs,joseon,pliny,minted,buddhists,cultivate,interconnected,reuse,viability,australasian,derelict,resolving,overlooks,menon,stewardship,playwrights,thwarted,filmfare,disarmament,protections,bundles,sidelined,hypothesized,singer/songwriter,forage,netted,chancery,townshend,restructured,quotation,hyperbolic,succumbed,parliaments,shenandoah,apical,kibbutz,storeys,pastors,lettering,ukrainians,hardships,chihuahua,avail,aisles,taluka,antisemitism,assent,ventured,banksia,seamen,hospice,faroe,fearful,woreda,outfield,chlorine,transformer,tatar,panoramic,pendulum,haarlem,styria,cornice,importing,catalyzes,subunits,enamel,bakersfield,realignment,sorties,subordinates,deanery,townland,gunmen,tutelage,evaluations,allahabad,thrace,veneto,mennonite,sharia,subgenus,satisfies,puritan,unequal,gastrointestinal,ordinances,bacterium,horticulture,argonauts,adjectives,arable,duets,visualization,woolwich,revamped,euroleague,thorax,completes,originality,vasco,freighter,sardar,oratory,sects,extremes,signatories,exporting,arisen,exacerbated,departures,saipan,furlongs,d'italia,goring,dakar,conquests,docked,offshoot,okrug,referencing,disperse,netting,summed,rewritten,articulation,humanoid,spindle,competitiveness,preventive,facades,westinghouse,wycombe,synthase,emulate,fostering,abdel,hexagonal,myriad,caters,arjun,dismay,axiom,psychotherapy,colloquial,complemented,martinique,fractures,culmination,erstwhile,atrium,electronica,anarchism,nadal,montpellier,algebras,submitting,adopts,stemmed,overcame,internacional,asymmetric,gallipoli,gliders,flushing,extermination,hartlepool,tesla,interwar,patriarchal,hitherto,ganges,combatant,marred,philology,glastonbury,reversible,isthmus,undermined,southwark,gateshead,andalusia,remedies,hastily,optimum,smartphone,evade,patrolled,beheaded,dopamine,waivers,ugandan,gujarati,densities,predicting,intestinal,tentative,interstellar,kolonia,soloists,penetrated,rebellions,qeshlaq,prospered,colegio,deficits,konigsberg,deficient,accessing,relays,kurds,politburo,codified,incarnations,occupancy,cossack,metaphysical,deprivation,chopra,piccadilly,formula_18,makeshift,protestantism,alaskan,frontiers,faiths,tendon,dunkirk,durability,autobots,bonuses,coinciding,emails,gunboat,stucco,magma,neutrons,vizier,subscriptions,visuals,envisaged,carpets,smoky,schema,parliamentarian,immersed,domesticated,parishioners,flinders,diminutive,mahabharata,ballarat,falmouth,vacancies,gilded,twigs,mastering,clerics,dalmatia,islington,slogans,compressor,iconography,congolese,sanction,blends,bulgarians,moderator,outflow,textures,safeguard,trafalgar,tramways,skopje,colonialism,chimneys,jazeera,organisers,denoting,motivations,ganga,longstanding,deficiencies,gwynedd,palladium,holistic,fascia,preachers,embargo,sidings,busan,ignited,artificially,clearwater,cemented,northerly,salim,equivalents,crustaceans,oberliga,quadrangle,historiography,romanians,vaults,fiercely,incidental,peacetime,tonal,bhopal,oskar,radha,pesticides,timeslot,westerly,cathedrals,roadways,aldershot,connectors,brahmins,paler,aqueous,gustave,chromatic,linkage,lothian,specialises,aggregation,tributes,insurgent,enact,hampden,ghulam,federations,instigated,lyceum,fredrik,chairmanship,floated,consequent,antagonists,intimidation,patriarchate,warbler,heraldry,entrenched,expectancy,habitation,partitions,widest,launchers,nascent,ethos,wurzburg,lycee,chittagong,mahatma,merseyside,asteroids,yokosuka,cooperatives,quorum,redistricting,bureaucratic,yachts,deploying,rustic,phonology,chorale,cellist,stochastic,crucifixion,surmounted,confucian,portfolios,geothermal,crested,calibre,tropics,deferred,nasir,iqbal,persistence,essayist,chengdu,aborigines,fayetteville,bastion,interchangeable,burlesque,kilmarnock,specificity,tankers,colonels,fijian,quotations,enquiry,quito,palmerston,delle,multidisciplinary,polynesian,iodine,antennae,emphasised,manganese,baptists,galilee,jutland,latent,excursions,skepticism,tectonic,precursors,negligible,musique,misuse,vitoria,expressly,veneration,sulawesi,footed,mubarak,chongqing,chemically,midday,ravaged,facets,varma,yeovil,ethnographic,discounted,physicists,attache,disbanding,essen,shogunate,cooperated,waikato,realising,motherwell,pharmacology,sulfide,inward,expatriate,devoid,cultivar,monde,andean,groupings,goran,unaffected,moldovan,postdoctoral,coleophora,delegated,pronoun,conductivity,coleridge,disapproval,reappeared,microbial,campground,olsztyn,fostered,vaccination,rabbinical,champlain,milestones,viewership,caterpillar,effected,eupithecia,financier,inferred,uzbek,bundled,bandar,balochistan,mysticism,biosphere,holotype,symbolizes,lovecraft,photons,abkhazia,swaziland,subgroups,measurable,falkirk,valparaiso,ashok,discriminatory,rarity,tabernacle,flyweight,jalisco,westernmost,antiquarian,extracellular,margrave,colspan=9,midsummer,digestive,reversing,burgeoning,substitutes,medallist,khrushchev,guerre,folio,detonated,partido,plentiful,aggregator,medallion,infiltration,shaded,santander,fared,auctioned,permian,ramakrishna,andorra,mentors,diffraction,bukit,potentials,translucent,feminists,tiers,protracted,coburg,wreath,guelph,adventurer,he/she,vertebrate,pipelines,celsius,outbreaks,australasia,deccan,garibaldi,unionists,buildup,biochemical,reconstruct,boulders,stringent,barbed,wording,furnaces,pests,befriends,organises,popes,rizal,tentacles,cadre,tallahassee,punishments,occidental,formatted,mitigation,rulings,rubens,cascades,inducing,choctaw,volta,synagogues,movable,altarpiece,mitigate,practise,intermittently,encountering,memberships,earns,signify,retractable,amounting,pragmatic,wilfrid,dissenting,divergent,kanji,reconstituted,devonian,constitutions,levied,hendrik,starch,costal,honduran,ditches,polygon,eindhoven,superstars,salient,argus,punitive,purana,alluvial,flaps,inefficient,retracted,advantageous,quang,andersson,danville,binghamton,symbolize,conclave,shaanxi,silica,interpersonal,adept,frans,pavilions,lubbock,equip,sunken,limburg,activates,prosecutions,corinthian,venerated,shootings,retreats,parapet,orissa,riviere,animations,parodied,offline,metaphysics,bluffs,plume,piety,fruition,subsidized,steeplechase,shanxi,eurasia,angled,forecasting,suffragan,ashram,larval,labyrinth,chronicler,summaries,trailed,merges,thunderstorms,filtered,formula_19,advertisers,alpes,informatics,parti,constituting,undisputed,certifications,javascript,molten,sclerosis,rumoured,boulogne,hmong,lewes,breslau,notts,bantu,ducal,messengers,radars,nightclubs,bantamweight,carnatic,kaunas,fraternal,triggering,controversially,londonderry,visas,scarcity,offaly,uprisings,repelled,corinthians,pretext,kuomintang,kielce,empties,matriculated,pneumatic,expos,agile,treatises,midpoint,prehistory,oncology,subsets,hydra,hypertension,axioms,wabash,reiterated,swapped,achieves,premio,ageing,overture,curricula,challengers,subic,selangor,liners,frontline,shutter,validated,normalized,entertainers,molluscs,maharaj,allegation,youngstown,synth,thoroughfare,regionally,pillai,transcontinental,pedagogical,riemann,colonia,easternmost,tentatively,profiled,herefordshire,nativity,meuse,nucleotide,inhibits,huntingdon,throughput,recorders,conceding,domed,homeowners,centric,gabled,canoes,fringes,breeder,subtitled,fluoride,haplogroup,zionism,izmir,phylogeny,kharkiv,romanticism,adhesion,usaaf,delegations,lorestan,whalers,biathlon,vaulted,mathematically,pesos,skirmishes,heisman,kalamazoo,gesellschaft,launceston,interacts,quadruple,kowloon,psychoanalysis,toothed,ideologies,navigational,valence,induces,lesotho,frieze,rigging,undercarriage,explorations,spoof,eucharist,profitability,virtuoso,recitals,subterranean,sizeable,herodotus,subscriber,huxley,pivot,forewing,warring,boleslaw,bharatiya,suffixes,trois,percussionist,downturn,garrisons,philosophies,chants,mersin,mentored,dramatist,guilds,frameworks,thermodynamic,venomous,mehmed,assembling,rabbinic,hegemony,replicas,enlargement,claimant,retitled,utica,dumfries,metis,deter,assortment,tubing,afflicted,weavers,rupture,ornamentation,transept,salvaged,upkeep,callsign,rajput,stevenage,trimmed,intracellular,synchronization,consular,unfavorable,royalists,goldwyn,fasting,hussars,doppler,obscurity,currencies,amiens,acorn,tagore,townsville,gaussian,migrations,porta,anjou,graphite,seaport,monographs,gladiators,metrics,calligraphy,sculptural,swietokrzyskie,tolombeh,eredivisie,shoals,queries,carts,exempted,fiberglass,mirrored,bazar,progeny,formalized,mukherjee,professed,amazon.com,cathode,moreton,removable,mountaineers,nagano,transplantation,augustinian,steeply,epilogue,adapter,decisively,accelerating,mediaeval,substituting,tasman,devonshire,litres,enhancements,himmler,nephews,bypassing,imperfect,argentinian,reims,integrates,sochi,ascii,licences,niches,surgeries,fables,versatility,indra,footpath,afonso,crore,evaporation,encodes,shelling,conformity,simplify,updating,quotient,overt,firmware,umpires,architectures,eocene,conservatism,secretion,embroidery,f.c..,tuvalu,mosaics,shipwreck,prefectural,cohort,grievances,garnering,centerpiece,apoptosis,djibouti,bethesda,formula_20,shonen,richland,justinian,dormitories,meteorite,reliably,obtains,pedagogy,hardness,cupola,manifolds,amplification,steamers,familial,dumbarton,jerzy,genital,maidstone,salinity,grumman,signifies,presbytery,meteorology,procured,aegis,streamed,deletion,nuestra,mountaineering,accords,neuronal,khanate,grenoble,axles,dispatches,tokens,turku,auctions,propositions,planters,proclaiming,recommissioned,stravinsky,obverse,bombarded,waged,saviour,massacred,reformist,purportedly,resettlement,ravenna,embroiled,minden,revitalization,hikers,bridging,torpedoed,depletion,nizam,affectionately,latitudes,lubeck,spore,polymerase,aarhus,nazism,101st,buyout,galerie,diets,overflow,motivational,renown,brevet,deriving,melee,goddesses,demolish,amplified,tamworth,retake,brokerage,beneficiaries,henceforth,reorganised,silhouette,browsers,pollutants,peron,lichfield,encircled,defends,bulge,dubbing,flamenco,coimbatore,refinement,enshrined,grizzlies,capacitor,usefulness,evansville,interscholastic,rhodesian,bulletins,diamondbacks,rockers,platted,medalists,formosa,transporter,slabs,guadeloupe,disparate,concertos,violins,regaining,mandible,untitled,agnostic,issuance,hamiltonian,brampton,srpska,homology,downgraded,florentine,epitaph,kanye,rallying,analysed,grandstand,infinitely,antitrust,plundered,modernity,colspan=3|total,amphitheatre,doric,motorists,yemeni,carnivorous,probabilities,prelate,struts,scrapping,bydgoszcz,pancreatic,signings,predicts,compendium,ombudsman,apertura,appoints,rebbe,stereotypical,valladolid,clustered,touted,plywood,inertial,kettering,curving,d'honneur,housewives,grenadier,vandals,barbarossa,necked,waltham,reputedly,jharkhand,cistercian,pursues,viscosity,organiser,cloister,islet,stardom,moorish,himachal,strives,scripps,staggered,blasts,westwards,millimeters,angolan,hubei,agility,admirals,mordellistena,coincides,platte,vehicular,cordillera,riffs,schoolteacher,canaan,acoustics,tinged,reinforcing,concentrates,daleks,monza,selectively,musik,polynesia,exporter,reviving,macclesfield,bunkers,ballets,manors,caudal,microbiology,primes,unbroken,outcry,flocks,pakhtunkhwa,abelian,toowoomba,luminous,mould,appraisal,leuven,experimentally,interoperability,hideout,perak,specifying,knighthood,vasily,excerpt,computerized,niels,networked,byzantium,reaffirmed,geographer,obscured,fraternities,mixtures,allusion,accra,lengthened,inquest,panhandle,pigments,revolts,bluetooth,conjugate,overtaken,foray,coils,breech,streaks,impressionist,mendelssohn,intermediary,panned,suggestive,nevis,upazila,rotunda,mersey,linnaeus,anecdotes,gorbachev,viennese,exhaustive,moldavia,arcades,irrespective,orator,diminishing,predictive,cohesion,polarized,montage,avian,alienation,conus,jaffna,urbanization,seawater,extremity,editorials,scrolling,dreyfus,traverses,topographic,gunboats,extratropical,normans,correspondents,recognises,millennia,filtration,ammonium,voicing,complied,prefixes,diplomas,figurines,weakly,gated,oscillator,lucerne,embroidered,outpatient,airframe,fractional,disobedience,quarterbacks,formula_21,shinto,chiapas,epistle,leakage,pacifist,avignon,penrith,renders,mantua,screenplays,gustaf,tesco,alphabetically,rations,discharges,headland,tapestry,manipur,boolean,mediator,ebenezer,subchannel,fable,bestselling,ateneo,trademarks,recurrence,dwarfs,britannica,signifying,vikram,mediate,condensation,censuses,verbandsgemeinde,cartesian,sprang,surat,britons,chelmsford,courtenay,statistic,retina,abortions,liabilities,closures,mississauga,skyscrapers,saginaw,compounded,aristocrat,msnbc,stavanger,septa,interpretive,hinder,visibly,seeding,shutouts,irregularly,quebecois,footbridge,hydroxide,implicitly,lieutenants,simplex,persuades,midshipman,heterogeneous,officiated,crackdown,lends,tartu,altars,fractions,dissidents,tapered,modernisation,scripting,blazon,aquaculture,thermodynamics,sistan,hasidic,bellator,pavia,propagated,theorized,bedouin,transnational,mekong,chronicled,declarations,kickstarter,quotas,runtime,duquesne,broadened,clarendon,brownsville,saturation,tatars,electorates,malayan,replicated,observable,amphitheater,endorsements,referral,allentown,mormons,pantomime,eliminates,typeface,allegorical,varna,conduction,evoke,interviewer,subordinated,uyghur,landscaped,conventionally,ascend,edifice,postulated,hanja,whitewater,embarking,musicologist,tagalog,frontage,paratroopers,hydrocarbons,transliterated,nicolae,viewpoints,surrealist,asheville,falklands,hacienda,glide,opting,zimbabwean,discal,mortgages,nicaraguan,yadav,ghosh,abstracted,castilian,compositional,cartilage,intergovernmental,forfeited,importation,rapping,artes,republika,narayana,condominium,frisian,bradman,duality,marche,extremist,phosphorylation,genomes,allusions,valencian,habeas,ironworks,multiplex,harpsichord,emigrate,alternated,breda,waffen,smartphones,familiarity,regionalliga,herbaceous,piping,dilapidated,carboniferous,xviii,critiques,carcinoma,sagar,chippewa,postmodern,neapolitan,excludes,notoriously,distillation,tungsten,richness,installments,monoxide,chand,privatisation,molded,maths,projectiles,luoyang,epirus,lemma,concentric,incline,erroneous,sideline,gazetted,leopards,fibres,renovate,corrugated,unilateral,repatriation,orchestration,saeed,rockingham,loughborough,formula_22,bandleader,appellation,openness,nanotechnology,massively,tonnage,dunfermline,exposes,moored,ridership,motte,eurobasket,majoring,feats,silla,laterally,playlist,downwards,methodologies,eastbourne,daimyo,cellulose,leyton,norwalk,oblong,hibernian,opaque,insular,allegory,camogie,inactivation,favoring,masterpieces,rinpoche,serotonin,portrayals,waverley,airliner,longford,minimalist,outsourcing,excise,meyrick,qasim,organisational,synaptic,farmington,gorges,scunthorpe,zoned,tohoku,librarians,davao,decor,theatrically,brentwood,pomona,acquires,planter,capacitors,synchronous,skateboarding,coatings,turbocharged,ephraim,capitulation,scoreboard,hebrides,ensues,cereals,ailing,counterpoint,duplication,antisemitic,clique,aichi,oppressive,transcendental,incursions,rename,renumbering,powys,vestry,bitterly,neurology,supplanted,affine,susceptibility,orbiter,activating,overlaps,ecoregion,raman,canoer,darfur,microorganisms,precipitated,protruding,torun,anthropologists,rennes,kangaroos,parliamentarians,edits,littoral,archived,begum,rensselaer,microphones,ypres,empower,etruscan,wisden,montfort,calibration,isomorphic,rioting,kingship,verbally,smyrna,cohesive,canyons,fredericksburg,rahul,relativistic,micropolitan,maroons,industrialized,henchmen,uplift,earthworks,mahdi,disparity,cultured,transliteration,spiny,fragmentary,extinguished,atypical,inventors,biosynthesis,heralded,curacao,anomalies,aeroplane,surya,mangalore,maastricht,ashkenazi,fusiliers,hangzhou,emitting,monmouthshire,schwarzenegger,ramayana,peptides,thiruvananthapuram,alkali,coimbra,budding,reasoned,epithelial,harbors,rudimentary,classically,parque,ealing,crusades,rotations,riparian,pygmy,inertia,revolted,microprocessor,calendars,solvents,kriegsmarine,accademia,cheshmeh,yoruba,ardabil,mitra,genomic,notables,propagate,narrates,univision,outposts,polio,birkenhead,urinary,crocodiles,pectoral,barrymore,deadliest,rupees,chaim,protons,comical,astrophysics,unifying,formula_23,vassals,cortical,audubon,pedals,tenders,resorted,geophysical,lenders,recognising,tackling,lanarkshire,doctrinal,annan,combating,guangxi,estimating,selectors,tribunals,chambered,inhabiting,exemptions,curtailed,abbasid,kandahar,boron,bissau,150th,codenamed,wearer,whorl,adhered,subversive,famer,smelting,inserting,mogadishu,zoologist,mosul,stumps,almanac,olympiacos,stamens,participatory,cults,honeycomb,geologists,dividend,recursive,skiers,reprint,pandemic,liber,percentages,adversely,stoppage,chieftains,tubingen,southerly,overcrowding,unorganized,hangars,fulfil,hails,cantilever,woodbridge,pinus,wiesbaden,fertilization,fluorescence,enhances,plenary,troublesome,episodic,thrissur,kickboxing,allele,staffing,garda,televisions,philatelic,spacetime,bullpen,oxides,leninist,enrolling,inventive,truro,compatriot,ruskin,normative,assay,gotha,murad,illawarra,gendarmerie,strasse,mazraeh,rebounded,fanfare,liaoning,rembrandt,iranians,emirate,governs,latency,waterfowl,chairmen,katowice,aristocrats,eclipsed,sentient,sonatas,interplay,sacking,decepticons,dynamical,arbitrarily,resonant,petar,velocities,alludes,wastes,prefectures,belleville,sensibility,salvadoran,consolidating,medicaid,trainees,vivekananda,molar,porous,upload,youngster,infused,doctorates,wuhan,annihilation,enthusiastically,gamespot,kanpur,accumulating,monorail,operetta,tiling,sapporo,finns,calvinist,hydrocarbon,sparrows,orienteering,cornelis,minster,vuelta,plebiscite,embraces,panchayats,focussed,remediation,brahman,olfactory,reestablished,uniqueness,northumbria,rwandan,predominately,abode,ghats,balances,californian,uptake,bruges,inert,westerns,reprints,cairn,yarra,resurfaced,audible,rossini,regensburg,italiana,fleshy,irrigated,alerts,yahya,varanasi,marginalized,expatriates,cantonment,normandie,sahitya,directives,rounder,hulls,fictionalized,constables,inserts,hipped,potosi,navies,biologists,canteen,husbandry,augment,fortnight,assamese,kampala,o'keefe,paleolithic,bluish,promontory,consecutively,striving,niall,reuniting,dipole,friendlies,disapproved,thrived,netflix,liberian,dielectric,medway,strategist,sankt,pickups,hitters,encode,rerouted,claimants,anglesey,partitioned,cavan,flutes,reared,repainted,armaments,bowed,thoracic,balliol,piero,chaplains,dehestan,sender,junkers,sindhi,sickle,dividends,metallurgy,honorific,berths,namco,springboard,resettled,gansu,copyrighted,criticizes,utopian,bendigo,ovarian,binomial,spaceflight,oratorio,proprietors,supergroup,duplicated,foreground,strongholds,revolved,optimize,layouts,westland,hurler,anthropomorphic,excelsior,merchandising,reeds,vetoed,cryptography,hollyoaks,monash,flooring,ionian,resilience,johnstown,resolves,lawmakers,alegre,wildcards,intolerance,subculture,selector,slums,formulate,bayonet,istvan,restitution,interchangeably,awakens,rostock,serpentine,oscillation,reichstag,phenotype,recessed,piotr,annotated,preparedness,consultations,clausura,preferential,euthanasia,genoese,outcrops,freemasonry,geometrical,genesee,islets,prometheus,panamanian,thunderbolt,terraced,stara,shipwrecks,futebol,faroese,sharqi,aldermen,zeitung,unify,formula_24,humanism,syntactic,earthen,blyth,taxed,rescinded,suleiman,cymru,dwindled,vitality,superieure,resupply,adolphe,ardennes,rajiv,profiling,olympique,gestation,interfaith,milosevic,tagline,funerary,druze,silvery,plough,shrubland,relaunch,disband,nunatak,minimizing,excessively,waned,attaching,luminosity,bugle,encampment,electrostatic,minesweeper,dubrovnik,rufous,greenock,hochschule,assyrians,extracting,malnutrition,priya,attainment,anhui,connotations,predicate,seabirds,deduced,pseudonyms,gopal,plovdiv,refineries,imitated,kwazulu,terracotta,tenets,discourses,brandeis,whigs,dominions,pulmonate,landslides,tutors,determinant,richelieu,farmstead,tubercles,technicolor,hegel,redundancy,greenpeace,shortening,mules,distilled,xxiii,fundamentalist,acrylic,outbuildings,lighted,corals,signaled,transistors,cavite,austerity,76ers,exposures,dionysius,outlining,commutative,permissible,knowledgeable,howrah,assemblage,inhibited,crewmen,mbit/s,pyramidal,aberdeenshire,bering,rotates,atheism,howitzer,saone,lancet,fermented,contradicted,materiel,ofsted,numeric,uniformity,josephus,nazarene,kuwaiti,noblemen,pediment,emergent,campaigner,akademi,murcia,perugia,gallen,allsvenskan,finned,cavities,matriculation,rosters,twickenham,signatory,propel,readable,contends,artisan,flamboyant,reggio,italo,fumbles,widescreen,rectangle,centimetres,collaborates,envoys,rijeka,phonological,thinly,refractive,civilisation,reductase,cognate,dalhousie,monticello,lighthouses,jitsu,luneburg,socialite,fermi,collectible,optioned,marquee,jokingly,architecturally,kabir,concubine,nationalisation,watercolor,wicklow,acharya,pooja,leibniz,rajendra,nationalized,stalemate,bloggers,glutamate,uplands,shivaji,carolingian,bucuresti,dasht,reappears,muscat,functionally,formulations,hinged,hainan,catechism,autosomal,incremental,asahi,coeur,diversification,multilateral,fewest,recombination,finisher,harrogate,hangul,feasts,photovoltaic,paget,liquidity,alluded,incubation,applauded,choruses,malagasy,hispanics,bequest,underparts,cassava,kazimierz,gastric,eradication,mowtowr,tyrosine,archbishopric,e9e9e9,unproductive,uxbridge,hydrolysis,harbours,officio,deterministic,devonport,kanagawa,breaches,freetown,rhinoceros,chandigarh,janos,sanatorium,liberator,inequalities,agonist,hydrophobic,constructors,nagorno,snowboarding,welcomes,subscribed,iloilo,resuming,catalysts,stallions,jawaharlal,harriers,definitively,roughriders,hertford,inhibiting,elgar,randomized,incumbents,episcopate,rainforests,yangon,improperly,kemal,interpreters,diverged,uttarakhand,umayyad,phnom,panathinaikos,shabbat,diode,jiangxi,forbidding,nozzle,artistry,licensee,processions,staffs,decimated,expressionism,shingle,palsy,ontology,mahayana,maribor,sunil,hostels,edwardian,jetty,freehold,overthrew,eukaryotic,schuylkill,rawalpindi,sheath,recessive,ferenc,mandibles,berlusconi,confessor,convergent,ababa,slugging,rentals,sephardic,equivalently,collagen,markov,dynamically,hailing,depressions,sprawling,fairgrounds,indistinguishable,plutarch,pressurized,banff,coldest,braunschweig,mackintosh,sociedad,wittgenstein,tromso,airbase,lecturers,subtitle,attaches,purified,contemplated,dreamworks,telephony,prophetic,rockland,aylesbury,biscay,coherence,aleksandar,judoka,pageants,theses,homelessness,luthor,sitcoms,hinterland,fifths,derwent,privateers,enigmatic,nationalistic,instructs,superimposed,conformation,tricycle,dusan,attributable,unbeknownst,laptops,etching,archbishops,ayatollah,cranial,gharbi,interprets,lackawanna,abingdon,saltwater,tories,lender,minaj,ancillary,ranching,pembrokeshire,topographical,plagiarism,murong,marque,chameleon,assertions,infiltrated,guildhall,reverence,schenectady,formula_25,kollam,notary,mexicana,initiates,abdication,basra,theorems,ionization,dismantling,eared,censors,budgetary,numeral,verlag,excommunicated,distinguishable,quarried,cagliari,hindustan,symbolizing,watertown,descartes,relayed,enclosures,militarily,sault,devolved,dalian,djokovic,filaments,staunton,tumour,curia,villainous,decentralized,galapagos,moncton,quartets,onscreen,necropolis,brasileiro,multipurpose,alamos,comarca,jorgen,concise,mercia,saitama,billiards,entomologist,montserrat,lindbergh,commuting,lethbridge,phoenician,deviations,anaerobic,denouncing,redoubt,fachhochschule,principalities,negros,announcers,seconded,parrots,konami,revivals,approving,devotee,riyadh,overtook,morecambe,lichen,expressionist,waterline,silverstone,geffen,sternites,aspiration,behavioural,grenville,tripura,mediums,genders,pyotr,charlottesville,sacraments,programmable,ps100,shackleton,garonne,sumerian,surpass,authorizing,interlocking,lagoons,voiceless,advert,steeple,boycotted,alouettes,yosef,oxidative,sassanid,benefiting,sayyid,nauru,predetermined,idealism,maxillary,polymerization,semesters,munchen,conor,outfitted,clapham,progenitor,gheorghe,observational,recognitions,numerically,colonized,hazrat,indore,contaminants,fatality,eradicate,assyria,convocation,cameos,skillful,skoda,corfu,confucius,overtly,ramadan,wollongong,placements,d.c..,permutation,contemporaneous,voltages,elegans,universitat,samar,plunder,dwindling,neuter,antonin,sinhala,campania,solidified,stanzas,fibrous,marburg,modernize,sorcery,deutscher,florets,thakur,disruptive,infielder,disintegration,internazionale,vicariate,effigy,tripartite,corrective,klamath,environs,leavenworth,sandhurst,workmen,compagnie,hoseynabad,strabo,palisades,ordovician,sigurd,grandsons,defection,viacom,sinhalese,innovator,uncontrolled,slavonic,indexes,refrigeration,aircrew,superbike,resumption,neustadt,confrontations,arras,hindenburg,ripon,embedding,isomorphism,dwarves,matchup,unison,lofty,argos,louth,constitutionally,transitive,newington,facelift,degeneration,perceptual,aviators,enclosing,igneous,symbolically,academician,constitutionality,iso/iec,sacrificial,maturation,apprentices,enzymology,naturalistic,hajji,arthropods,abbess,vistula,scuttled,gradients,pentathlon,etudes,freedmen,melaleuca,thrice,conductive,sackville,franciscans,stricter,golds,kites,worshiped,monsignor,trios,orally,tiered,primacy,bodywork,castleford,epidemics,alveolar,chapelle,chemists,hillsboro,soulful,warlords,ngati,huguenot,diurnal,remarking,luger,motorways,gauss,jahan,cutoff,proximal,bandai,catchphrase,jonubi,ossetia,codename,codice_2,throated,itinerant,chechnya,riverfront,leela,evoked,entailed,zamboanga,rejoining,circuitry,haymarket,khartoum,feuds,braced,miyazaki,mirren,lubusz,caricature,buttresses,attrition,characterizes,widnes,evanston,materialism,contradictions,marist,midrash,gainsborough,ulithi,turkmen,vidya,escuela,patrician,inspirations,reagent,premierships,humanistic,euphrates,transitioning,belfry,zedong,adaption,kaliningrad,lobos,epics,waiver,coniferous,polydor,inductee,refitted,moraine,unsatisfactory,worsening,polygamy,rajya,nested,subgenre,broadside,stampeders,lingua,incheon,pretender,peloton,persuading,excitation,multan,predates,tonne,brackish,autoimmune,insulated,podcasts,iraqis,bodybuilding,condominiums,midlothian,delft,debtor,asymmetrical,lycaenidae,forcefully,pathogenic,tamaulipas,andaman,intravenous,advancements,senegalese,chronologically,realigned,inquirer,eusebius,dekalb,additives,shortlist,goldwater,hindustani,auditing,caterpillars,pesticide,nakhon,ingestion,lansdowne,traditionalist,northland,thunderbirds,josip,nominating,locale,ventricular,animators,verandah,epistles,surveyors,anthems,dredd,upheaval,passaic,anatolian,svalbard,associative,floodplain,taranaki,estuaries,irreducible,beginners,hammerstein,allocate,coursework,secreted,counteract,handwritten,foundational,passover,discoverer,decoding,wares,bourgeoisie,playgrounds,nazionale,abbreviations,seanad,golan,mishra,godavari,rebranding,attendances,backstory,interrupts,lettered,hasbro,ultralight,hormozgan,armee,moderne,subdue,disuse,improvisational,enrolment,persists,moderated,carinthia,hatchback,inhibitory,capitalized,anatoly,abstracts,albemarle,bergamo,insolvency,sentai,cellars,walloon,joked,kashmiri,dirac,materialized,renomination,homologous,gusts,eighteens,centrifugal,storied,baluchestan,formula_26,poincare,vettel,infuriated,gauges,streetcars,vedanta,stately,liquidated,goguryeo,swifts,accountancy,levee,acadian,hydropower,eustace,comintern,allotment,designating,torsion,molding,irritation,aerobic,halen,concerted,plantings,garrisoned,gramophone,cytoplasm,onslaught,requisitioned,relieving,genitive,centrist,jeong,espanola,dissolving,chatterjee,sparking,connaught,varese,arjuna,carpathian,empowering,meteorologist,decathlon,opioid,hohenzollern,fenced,ibiza,avionics,footscray,scrum,discounts,filament,directories,a.f.c,stiffness,quaternary,adventurers,transmits,harmonious,taizong,radiating,germantown,ejection,projectors,gaseous,nahuatl,vidyalaya,nightlife,redefined,refuted,destitute,arista,potters,disseminated,distanced,jamboree,kaohsiung,tilted,lakeshore,grained,inflicting,kreis,novelists,descendents,mezzanine,recast,fatah,deregulation,ac/dc,australis,kohgiluyeh,boreal,goths,authoring,intoxicated,nonpartisan,theodosius,pyongyang,shree,boyhood,sanfl,plenipotentiary,photosynthesis,presidium,sinaloa,honshu,texan,avenida,transmembrane,malays,acropolis,catalunya,vases,inconsistencies,methodists,quell,suisse,banat,simcoe,cercle,zealanders,discredited,equine,sages,parthian,fascists,interpolation,classifying,spinoff,yehuda,cruised,gypsum,foaled,wallachia,saraswati,imperialist,seabed,footnotes,nakajima,locales,schoolmaster,drosophila,bridgehead,immanuel,courtier,bookseller,niccolo,stylistically,portmanteau,superleague,konkani,millimetres,arboreal,thanjavur,emulation,sounders,decompression,commoners,infusion,methodological,osage,rococo,anchoring,bayreuth,formula_27,abstracting,symbolized,bayonne,electrolyte,rowed,corvettes,traversing,editorship,sampler,presidio,curzon,adirondack,swahili,rearing,bladed,lemur,pashtun,behaviours,bottling,zaire,recognisable,systematics,leeward,formulae,subdistricts,smithfield,vijaya,buoyancy,boosting,cantonal,rishi,airflow,kamakura,adana,emblems,aquifer,clustering,husayn,woolly,wineries,montessori,turntable,exponentially,caverns,espoused,pianists,vorpommern,vicenza,latterly,o'rourke,williamstown,generale,kosice,duisburg,poirot,marshy,mismanagement,mandalay,dagenham,universes,chiral,radiated,stewards,vegan,crankshaft,kyrgyz,amphibian,cymbals,infrequently,offenbach,environmentalist,repatriated,permutations,midshipmen,loudoun,refereed,bamberg,ornamented,nitric,selim,translational,dorsum,annunciation,gippsland,reflector,informational,regia,reactionary,ahmet,weathering,erlewine,legalized,berne,occupant,divas,manifests,analyzes,disproportionate,mitochondria,totalitarian,paulista,interscope,anarcho,correlate,brookfield,elongate,brunel,ordinal,precincts,volatility,equaliser,hittite,somaliland,ticketing,monochrome,ubuntu,chhattisgarh,titleholder,ranches,referendums,blooms,accommodates,merthyr,religiously,ryukyu,tumultuous,checkpoints,anode,mi'kmaq,cannonball,punctuation,remodelled,assassinations,criminology,alternates,yonge,pixar,namibian,piraeus,trondelag,hautes,lifeboats,shoal,atelier,vehemently,sadat,postcode,jainism,lycoming,undisturbed,lutherans,genomics,popmatters,tabriz,isthmian,notched,autistic,horsham,mites,conseil,bloomsbury,seung,cybertron,idris,overhauled,disbandment,idealized,goldfields,worshippers,lobbyist,ailments,paganism,herbarium,athenians,messerschmitt,faraday,entangled,'olya,untreated,criticising,howitzers,parvati,lobed,debussy,atonement,tadeusz,permeability,mueang,sepals,degli,optionally,fuelled,follies,asterisk,pristina,lewiston,congested,overpass,affixed,pleads,telecasts,stanislaus,cryptographic,friesland,hamstring,selkirk,antisubmarine,inundated,overlay,aggregates,fleur,trolleybus,sagan,ibsen,inductees,beltway,tiled,ladders,cadbury,laplace,ascetic,micronesia,conveying,bellingham,cleft,batches,usaid,conjugation,macedon,assisi,reappointed,brine,jinnah,prairies,screenwriting,oxidized,despatches,linearly,fertilizers,brazilians,absorbs,wagga,modernised,scorsese,ashraf,charlestown,esque,habitable,nizhny,lettres,tuscaloosa,esplanade,coalitions,carbohydrates,legate,vermilion,standardised,galleria,psychoanalytic,rearrangement,substation,competency,nationalised,reshuffle,reconstructions,mehdi,bougainville,receivership,contraception,enlistment,conducive,aberystwyth,solicitors,dismisses,fibrosis,montclair,homeowner,surrealism,s.h.i.e.l.d,peregrine,compilers,1790s,parentage,palmas,rzeszow,worldview,eased,svenska,housemate,bundestag,originator,enlisting,outwards,reciprocity,formula_28,carbohydrate,democratically,firefighting,romagna,acknowledgement,khomeini,carbide,quests,vedas,characteristically,guwahati,brixton,unintended,brothels,parietal,namur,sherbrooke,moldavian,baruch,milieu,undulating,laurier,entre,dijon,ethylene,abilene,heracles,paralleling,ceres,dundalk,falun,auspicious,chisinau,polarity,foreclosure,templates,ojibwe,punic,eriksson,biden,bachchan,glaciation,spitfires,norsk,nonviolent,heidegger,algonquin,capacitance,cassettes,balconies,alleles,airdate,conveys,replays,classifies,infrequent,amine,cuttings,rarer,woking,olomouc,amritsar,rockabilly,illyrian,maoist,poignant,tempore,stalinist,segmented,bandmate,mollusc,muhammed,totalled,byrds,tendered,endogenous,kottayam,aisne,oxidase,overhears,illustrators,verve,commercialization,purplish,directv,moulded,lyttelton,baptismal,captors,saracens,georgios,shorten,polity,grids,fitzwilliam,sculls,impurities,confederations,akhtar,intangible,oscillations,parabolic,harlequin,maulana,ovate,tanzanian,singularity,confiscation,qazvin,speyer,phonemes,overgrown,vicarage,gurion,undocumented,niigata,thrones,preamble,stave,interment,liiga,ataturk,aphrodite,groupe,indentured,habsburgs,caption,utilitarian,ozark,slovenes,reproductions,plasticity,serbo,dulwich,castel,barbuda,salons,feuding,lenape,wikileaks,swamy,breuning,shedding,afield,superficially,operationally,lamented,okanagan,hamadan,accolade,furthering,adolphus,fyodor,abridged,cartoonists,pinkish,suharto,cytochrome,methylation,debit,colspan=9|,refine,taoist,signalled,herding,leaved,bayan,fatherland,rampart,sequenced,negation,storyteller,occupiers,barnabas,pelicans,nadir,conscripted,railcars,prerequisite,furthered,columba,carolinas,markup,gwalior,franche,chaco,eglinton,ramparts,rangoon,metabolites,pollination,croat,televisa,holyoke,testimonial,setlist,safavid,sendai,georgians,shakespearean,galleys,regenerative,krzysztof,overtones,estado,barbary,cherbourg,obispo,sayings,composites,sainsbury,deliberation,cosmological,mahalleh,embellished,ascap,biala,pancras,calumet,grands,canvases,antigens,marianas,defenseman,approximated,seedlings,soren,stele,nuncio,immunology,testimonies,glossary,recollections,suitability,tampere,venous,cohomology,methanol,echoing,ivanovich,warmly,sterilization,imran,multiplying,whitechapel,undersea,xuanzong,tacitus,bayesian,roundhouse,correlations,rioters,molds,fiorentina,bandmates,mezzo,thani,guerilla,200th,premiums,tamils,deepwater,chimpanzees,tribesmen,selwyn,globo,turnovers,punctuated,erode,nouvelle,banbury,exponents,abolishing,helical,maimonides,endothelial,goteborg,infield,encroachment,cottonwood,mazowiecki,parable,saarbrucken,reliever,epistemology,artistes,enrich,rationing,formula_29,palmyra,subfamilies,kauai,zoran,fieldwork,arousal,creditor,friuli,celts,comoros,equated,escalation,negev,tallied,inductive,anion,netanyahu,mesoamerican,lepidoptera,aspirated,remit,westmorland,italic,crosse,vaclav,fuego,owain,balmain,venetians,ethnicities,deflected,ticino,apulia,austere,flycatcher,reprising,repressive,hauptbahnhof,subtype,ophthalmology,summarizes,eniwetok,colonisation,subspace,nymphalidae,earmarked,tempe,burnet,crests,abbots,norwegians,enlarge,ashoka,frankfort,livorno,malware,renters,singly,iliad,moresby,rookies,gustavus,affirming,alleges,legume,chekhov,studded,abdicated,suzhou,isidore,townsite,repayment,quintus,yankovic,amorphous,constructor,narrowing,industrialists,tanganyika,capitalization,connective,mughals,rarities,aerodynamics,worthing,antalya,diagnostics,shaftesbury,thracian,obstetrics,benghazi,multiplier,orbitals,livonia,roscommon,intensify,ravel,oaths,overseer,locomotion,necessities,chickasaw,strathclyde,treviso,erfurt,aortic,contemplation,accrington,markazi,predeceased,hippocampus,whitecaps,assemblyman,incursion,ethnography,extraliga,reproducing,directorship,benzene,byway,stupa,taxable,scottsdale,onondaga,favourably,countermeasures,lithuanians,thatched,deflection,tarsus,consuls,annuity,paralleled,contextual,anglian,klang,hoisted,multilingual,enacting,samaj,taoiseach,carthaginian,apologised,hydrology,entrant,seamless,inflorescences,mugabe,westerners,seminaries,wintering,penzance,mitre,sergeants,unoccupied,delimitation,discriminate,upriver,abortive,nihon,bessarabia,calcareous,buffaloes,patil,daegu,streamline,berks,chaparral,laity,conceptions,typified,kiribati,threaded,mattel,eccentricity,signified,patagonia,slavonia,certifying,adnan,astley,sedition,minimally,enumerated,nikos,goalless,walid,narendra,causa,missoula,coolant,dalek,outcrop,hybridization,schoolchildren,peasantry,afghans,confucianism,shahr,gallic,tajik,kierkegaard,sauvignon,commissar,patriarchs,tuskegee,prussians,laois,ricans,talmudic,officiating,aesthetically,baloch,antiochus,separatists,suzerainty,arafat,shading,u.s.c,chancellors,inc..,toolkit,nepenthes,erebidae,solicited,pratap,kabbalah,alchemist,caltech,darjeeling,biopic,spillway,kaiserslautern,nijmegen,bolstered,neath,pahlavi,eugenics,bureaus,retook,northfield,instantaneous,deerfield,humankind,selectivity,putative,boarders,cornhuskers,marathas,raikkonen,aliabad,mangroves,garages,gulch,karzai,poitiers,chernobyl,thane,alexios,belgrano,scion,solubility,urbanized,executable,guizhou,nucleic,tripled,equalled,harare,houseguests,potency,ghazi,repeater,overarching,regrouped,broward,ragtime,d'art,nandi,regalia,campsites,mamluk,plating,wirral,presumption,zenit,archivist,emmerdale,decepticon,carabidae,kagoshima,franconia,guarani,formalism,diagonally,submarginal,denys,walkways,punts,metrolink,hydrographic,droplets,upperside,martyred,hummingbird,antebellum,curiously,mufti,friary,chabad,czechs,shaykh,reactivity,berklee,turbonilla,tongan,sultans,woodville,unlicensed,enmity,dominicans,operculum,quarrying,watercolour,catalyzed,gatwick,'what,mesozoic,auditors,shizuoka,footballing,haldane,telemundo,appended,deducted,disseminate,o'shea,pskov,abrasive,entente,gauteng,calicut,lemurs,elasticity,suffused,scopula,staining,upholding,excesses,shostakovich,loanwords,naidu,championnat,chromatography,boasting,goaltenders,engulfed,salah,kilogram,morristown,shingles,shi'a,labourer,renditions,frantisek,jekyll,zonal,nanda,sheriffs,eigenvalues,divisione,endorsing,ushered,auvergne,cadres,repentance,freemasons,utilising,laureates,diocletian,semiconductors,o'grady,vladivostok,sarkozy,trackage,masculinity,hydroxyl,mervyn,muskets,speculations,gridiron,opportunistic,mascots,aleutian,fillies,sewerage,excommunication,borrowers,capillary,trending,sydenham,synthpop,rajah,cagayan,deportes,kedah,faure,extremism,michoacan,levski,culminates,occitan,bioinformatics,unknowingly,inciting,emulated,footpaths,piacenza,dreadnought,viceroyalty,oceanographic,scouted,combinatorial,ornithologist,cannibalism,mujahideen,independiente,cilicia,hindwing,minimized,odeon,gyorgy,rubles,purchaser,collieries,kickers,interurban,coiled,lynchburg,respondent,plzen,detractors,etchings,centering,intensification,tomography,ranjit,warblers,retelling,reinstatement,cauchy,modulus,redirected,evaluates,beginner,kalateh,perforated,manoeuvre,scrimmage,internships,megawatts,mottled,haakon,tunbridge,kalyan,summarised,sukarno,quetta,canonized,henryk,agglomeration,coahuila,diluted,chiropractic,yogyakarta,talladega,sheik,cation,halting,reprisals,sulfuric,musharraf,sympathizers,publicised,arles,lectionary,fracturing,startups,sangha,latrobe,rideau,ligaments,blockading,cremona,lichens,fabaceae,modulated,evocative,embodies,battersea,indistinct,altai,subsystem,acidity,somatic,formula_30,tariq,rationality,sortie,ashlar,pokal,cytoplasmic,valour,bangla,displacing,hijacking,spectrometry,westmeath,weill,charing,goias,revolvers,individualized,tenured,nawaz,piquet,chanted,discard,bernd,phalanx,reworking,unilaterally,subclass,yitzhak,piloting,circumvent,disregarded,semicircular,viscous,tibetans,endeavours,retaliated,cretan,vienne,workhouse,sufficiency,aurangzeb,legalization,lipids,expanse,eintracht,sanjak,megas,125th,bahraini,yakima,eukaryotes,thwart,affirmation,peloponnese,retailing,carbonyl,chairwoman,macedonians,dentate,rockaway,correctness,wealthier,metamorphic,aragonese,fermanagh,pituitary,schrodinger,evokes,spoiler,chariots,akita,genitalia,combe,confectionery,desegregation,experiential,commodores,persepolis,viejo,restorations,virtualization,hispania,printmaking,stipend,yisrael,theravada,expended,radium,tweeted,polygonal,lippe,charente,leveraged,cutaneous,fallacy,fragrant,bypasses,elaborately,rigidity,majid,majorca,kongo,plasmodium,skits,audiovisual,eerste,staircases,prompts,coulthard,northwestward,riverdale,beatrix,copyrights,prudential,communicates,mated,obscenity,asynchronous,analyse,hansa,searchlight,farnborough,patras,asquith,qarah,contours,fumbled,pasteur,redistributed,almeria,sanctuaries,jewry,israelite,clinicians,koblenz,bookshop,affective,goulburn,panelist,sikorsky,cobham,mimics,ringed,portraiture,probabilistic,girolamo,intelligible,andalusian,jalal,athenaeum,eritrean,auxiliaries,pittsburg,devolution,sangam,isolating,anglers,cronulla,annihilated,kidderminster,synthesize,popularised,theophilus,bandstand,innumerable,chagrin,retroactively,weser,multiples,birdlife,goryeo,pawnee,grosser,grappling,tactile,ahmadinejad,turboprop,erdogan,matchday,proletarian,adhering,complements,austronesian,adverts,luminaries,archeology,impressionism,conifer,sodomy,interracial,platoons,lessen,postings,pejorative,registrations,cookery,persecutions,microbes,audits,idiosyncratic,subsp,suspensions,restricts,colouring,ratify,instrumentals,nucleotides,sulla,posits,bibliotheque,diameters,oceanography,instigation,subsumed,submachine,acceptor,legation,borrows,sedge,discriminated,loaves,insurers,highgate,detectable,abandons,kilns,sportscaster,harwich,iterations,preakness,arduous,tensile,prabhu,shortwave,philologist,shareholding,vegetative,complexities,councilors,distinctively,revitalize,automaton,amassing,montreux,khanh,surabaya,nurnberg,pernambuco,cuisines,charterhouse,firsts,tercera,inhabitant,homophobia,naturalism,einar,powerplant,coruna,entertainments,whedon,rajputs,raton,democracies,arunachal,oeuvre,wallonia,jeddah,trolleybuses,evangelism,vosges,kiowa,minimise,encirclement,undertakes,emigrant,beacons,deepened,grammars,publius,preeminent,seyyed,repechage,crafting,headingley,osteopathic,lithography,hotly,bligh,inshore,betrothed,olympians,formula_31,dissociation,trivandrum,arran,petrovic,stettin,disembarked,simplification,bronzes,philo,acrobatic,jonsson,conjectured,supercharged,kanto,detects,cheeses,correlates,harmonics,lifecycle,sudamericana,reservists,decayed,elitserien,parametric,113th,dusky,hogarth,modulo,symbiotic,monopolies,discontinuation,converges,southerners,tucuman,eclipses,enclaves,emits,famicom,caricatures,artistically,levelled,mussels,erecting,mouthparts,cunard,octaves,crucible,guardia,unusable,lagrangian,droughts,ephemeral,pashto,canis,tapering,sasebo,silurian,metallurgical,outscored,evolves,reissues,sedentary,homotopy,greyhawk,reagents,inheriting,onshore,tilting,rebuffed,reusable,naturalists,basingstoke,insofar,offensives,dravidian,curators,planks,rajan,isoforms,flagstaff,preside,globular,egalitarian,linkages,biographers,goalscorers,molybdenum,centralised,nordland,jurists,ellesmere,rosberg,hideyoshi,restructure,biases,borrower,scathing,redress,tunnelling,workflow,magnates,mahendra,dissenters,plethora,transcriptions,handicrafts,keyword,xi'an,petrograd,unser,prokofiev,90deg,madan,bataan,maronite,kearny,carmarthen,termini,consulates,disallowed,rockville,bowery,fanzine,docklands,bests,prohibitions,yeltsin,selassie,naturalization,realisation,dispensary,tribeca,abdulaziz,pocahontas,stagnation,pamplona,cuneiform,propagating,subsurface,christgau,epithelium,schwerin,lynching,routledge,hanseatic,upanishad,glebe,yugoslavian,complicity,endowments,girona,mynetworktv,entomology,plinth,ba'ath,supercup,torus,akkadian,salted,englewood,commandery,belgaum,prefixed,colorless,dartford,enthroned,caesarea,nominative,sandown,safeguards,hulled,formula_32,leamington,dieppe,spearhead,generalizations,demarcation,llanelli,masque,brickwork,recounting,sufism,strikingly,petrochemical,onslow,monologues,emigrating,anderlecht,sturt,hossein,sakhalin,subduction,novices,deptford,zanjan,airstrikes,coalfield,reintroduction,timbaland,hornby,messianic,stinging,universalist,situational,radiocarbon,strongman,rowling,saloons,traffickers,overran,fribourg,cambrai,gravesend,discretionary,finitely,archetype,assessor,pilipinas,exhumed,invocation,interacted,digitized,timisoara,smelter,teton,sexism,precepts,srinagar,pilsudski,carmelite,hanau,scoreline,hernando,trekking,blogging,fanbase,wielded,vesicles,nationalization,banja,rafts,motoring,luang,takeda,girder,stimulates,histone,sunda,nanoparticles,attains,jumpers,catalogued,alluding,pontus,ancients,examiners,shinkansen,ribbentrop,reimbursement,pharmacological,ramat,stringed,imposes,cheaply,transplanted,taiping,mizoram,looms,wallabies,sideman,kootenay,encased,sportsnet,revolutionized,tangier,benthic,runic,pakistanis,heatseekers,shyam,mishnah,presbyterians,stadt,sutras,straddles,zoroastrian,infer,fueling,gymnasts,ofcom,gunfight,journeyman,tracklist,oshawa,ps500,pa'in,mackinac,xiongnu,mississippian,breckinridge,freemason,bight,autoroute,liberalization,distantly,thrillers,solomons,presumptive,romanization,anecdotal,bohemians,unpaved,milder,concurred,spinners,alphabets,strenuous,rivieres,kerrang,mistreatment,dismounted,intensively,carlist,dancehall,shunting,pluralism,trafficked,brokered,bonaventure,bromide,neckar,designates,malian,reverses,sotheby,sorghum,serine,environmentalists,languedoc,consulship,metering,bankstown,handlers,militiamen,conforming,regularity,pondicherry,armin,capsized,consejo,capitalists,drogheda,granular,purged,acadians,endocrine,intramural,elicit,terns,orientations,miklos,omitting,apocryphal,slapstick,brecon,pliocene,affords,typography,emigre,tsarist,tomasz,beset,nishi,necessitating,encyclical,roleplaying,journeyed,inflow,sprints,progressives,novosibirsk,cameroonian,ephesus,speckled,kinshasa,freiherr,burnaby,dalmatian,torrential,rigor,renegades,bhakti,nurburgring,cosimo,convincingly,reverting,visayas,lewisham,charlottetown,charadriiformesfamily,transferable,jodhpur,converters,deepening,camshaft,underdeveloped,protease,polonia,uterine,quantify,tobruk,dealerships,narasimha,fortran,inactivity,1780s,victors,categorised,naxos,workstation,skink,sardinian,chalice,precede,dammed,sondheim,phineas,tutored,sourcing,uncompromising,placer,tyneside,courtiers,proclaims,pharmacies,hyogo,booksellers,sengoku,kursk,spectrometer,countywide,wielkopolski,bobsleigh,shetty,llywelyn,consistory,heretics,guinean,cliches,individualism,monolithic,imams,usability,bursa,deliberations,railings,torchwood,inconsistency,balearic,stabilizer,demonstrator,facet,radioactivity,outboard,educates,d'oyly,heretical,handover,jurisdictional,shockwave,hispaniola,conceptually,routers,unaffiliated,trentino,formula_33,cypriots,intervenes,neuchatel,formulating,maggiore,delisted,alcohols,thessaly,potable,estimator,suborder,fluency,mimicry,clergymen,infrastructures,rivals.com,baroda,subplot,majlis,plano,clinching,connotation,carinae,savile,intercultural,transcriptional,sandstones,ailerons,annotations,impresario,heinkel,scriptural,intermodal,astrological,ribbed,northeastward,posited,boers,utilise,kalmar,phylum,breakwater,skype,textured,guideline,azeri,rimini,massed,subsidence,anomalous,wolfsburg,polyphonic,accrediting,vodacom,kirov,captaining,kelantan,logie,fervent,eamon,taper,bundeswehr,disproportionately,divination,slobodan,pundits,hispano,kinetics,reunites,makati,ceasing,statistician,amending,chiltern,eparchy,riverine,melanoma,narragansett,pagans,raged,toppled,breaching,zadar,holby,dacian,ochre,velodrome,disparities,amphoe,sedans,webpage,williamsport,lachlan,groton,baring,swastika,heliport,unwillingness,razorbacks,exhibitors,foodstuffs,impacting,tithe,appendages,dermot,subtypes,nurseries,balinese,simulating,stary,remakes,mundi,chautauqua,geologically,stockade,hakka,dilute,kalimantan,pahang,overlapped,fredericton,baha'u'llah,jahangir,damping,benefactors,shomali,triumphal,cieszyn,paradigms,shielded,reggaeton,maharishi,zambian,shearing,golestan,mirroring,partitioning,flyover,songbook,incandescent,merrimack,huguenots,sangeet,vulnerabilities,trademarked,drydock,tantric,honoris,queenstown,labelling,iterative,enlists,statesmen,anglicans,herge,qinghai,burgundian,islami,delineated,zhuge,aggregated,banknote,qatari,suitably,tapestries,asymptotic,charleroi,majorities,pyramidellidae,leanings,climactic,tahir,ramsar,suppressor,revisionist,trawler,ernakulam,penicillium,categorization,slits,entitlement,collegium,earths,benefice,pinochet,puritans,loudspeaker,stockhausen,eurocup,roskilde,alois,jaroslav,rhondda,boutiques,vigor,neurotransmitter,ansar,malden,ferdinando,sported,relented,intercession,camberwell,wettest,thunderbolts,positional,oriel,cloverleaf,penalized,shoshone,rajkumar,completeness,sharjah,chromosomal,belgians,woolen,ultrasonic,sequentially,boleyn,mordella,microsystems,initiator,elachista,mineralogy,rhododendron,integrals,compostela,hamza,sawmills,stadio,berlioz,maidens,stonework,yachting,tappeh,myocardial,laborer,workstations,costumed,nicaea,lanark,roundtable,mashhad,nablus,algonquian,stuyvesant,sarkar,heroines,diwan,laments,intonation,intrigues,almaty,feuded,grandes,algarve,rehabilitate,macrophages,cruciate,dismayed,heuristic,eliezer,kozhikode,covalent,finalised,dimorphism,yaroslavl,overtaking,leverkusen,middlebury,feeders,brookings,speculates,insoluble,lodgings,jozsef,cysteine,shenyang,habilitation,spurious,brainchild,mtdna,comique,albedo,recife,partick,broadening,shahi,orientated,himalaya,swabia,palme,mennonites,spokeswoman,conscripts,sepulchre,chartres,eurozone,scaffold,invertebrate,parishad,bagan,heian,watercolors,basse,supercomputer,commences,tarragona,plainfield,arthurian,functor,identically,murex,chronicling,pressings,burrowing,histoire,guayaquil,goalkeeping,differentiable,warburg,machining,aeneas,kanawha,holocene,ramesses,reprisal,qingdao,avatars,turkestan,cantatas,besieging,repudiated,teamsters,equipping,hydride,ahmadiyya,euston,bottleneck,computations,terengganu,kalinga,stela,rediscovery,'this,azhar,stylised,karelia,polyethylene,kansai,motorised,lounges,normalization,calculators,1700s,goalkeepers,unfolded,commissary,cubism,vignettes,multiverse,heaters,briton,sparingly,childcare,thorium,plock,riksdag,eunuchs,catalysis,limassol,perce,uncensored,whitlam,ulmus,unites,mesopotamian,refraction,biodiesel,forza,fulda,unseated,mountbatten,shahrak,selenium,osijek,mimicking,antimicrobial,axons,simulcasting,donizetti,swabian,sportsmen,hafiz,neared,heraclius,locates,evaded,subcarpathian,bhubaneswar,negeri,jagannath,thaksin,aydin,oromo,lateran,goldsmiths,multiculturalism,cilia,mihai,evangelists,lorient,qajar,polygons,vinod,mechanised,anglophone,prefabricated,mosses,supervillain,airliners,biofuels,iodide,innovators,valais,wilberforce,logarithm,intelligentsia,dissipation,sanctioning,duchies,aymara,porches,simulators,mostar,telepathic,coaxial,caithness,burghs,fourths,stratification,joaquim,scribes,meteorites,monarchist,germination,vries,desiring,replenishment,istria,winemaking,tammany,troupes,hetman,lanceolate,pelagic,triptych,primeira,scant,outbound,hyphae,denser,bentham,basie,normale,executes,ladislaus,kontinental,herat,cruiserweight,activision,customization,manoeuvres,inglewood,northwood,waveform,investiture,inpatient,alignments,kiryat,rabat,archimedes,ustad,monsanto,archetypal,kirkby,sikhism,correspondingly,catskill,overlaid,petrels,widowers,unicameral,federalists,metalcore,gamerankings,mussel,formula_34,lymphocytes,cystic,southgate,vestiges,immortals,kalam,strove,amazons,pocono,sociologists,sopwith,adheres,laurens,caregivers,inspecting,transylvanian,rebroadcast,rhenish,miserables,pyrams,blois,newtonian,carapace,redshirt,gotland,nazir,unilever,distortions,linebackers,federalism,mombasa,lumen,bernoulli,favouring,aligarh,denounce,steamboats,dnieper,stratigraphic,synths,bernese,umass,icebreaker,guanajuato,heisenberg,boldly,diodes,ladakh,dogmatic,scriptwriter,maritimes,battlestar,symposia,adaptable,toluca,bhavan,nanking,ieyasu,picardy,soybean,adalbert,brompton,deutsches,brezhnev,glandular,laotian,hispanicized,ibadan,personification,dalit,yamuna,regio,dispensed,yamagata,zweibrucken,revising,fandom,stances,participle,flavours,khitan,vertebral,crores,mayaguez,dispensation,guntur,undefined,harpercollins,unionism,meena,leveling,philippa,refractory,telstra,judea,attenuation,pylons,elaboration,elegy,edging,gracillariidae,residencies,absentia,reflexive,deportations,dichotomy,stoves,sanremo,shimon,menachem,corneal,conifers,mordellidae,facsimile,diagnoses,cowper,citta,viticulture,divisive,riverview,foals,mystics,polyhedron,plazas,airspeed,redgrave,motherland,impede,multiplicity,barrichello,airships,pharmacists,harvester,clays,payloads,differentiating,popularize,caesars,tunneling,stagnant,circadian,indemnity,sensibilities,musicology,prefects,serfs,metra,lillehammer,carmarthenshire,kiosks,welland,barbican,alkyl,tillandsia,gatherers,asociacion,showings,bharati,brandywine,subversion,scalable,pfizer,dawla,barium,dardanelles,nsdap,konig,ayutthaya,hodgkin,sedimentation,completions,purchasers,sponsorships,maximizing,banked,taoism,minot,enrolls,fructose,aspired,capuchin,outages,artois,carrollton,totality,osceola,pawtucket,fontainebleau,converged,queretaro,competencies,botha,allotments,sheaf,shastri,obliquely,banding,catharines,outwardly,monchengladbach,driest,contemplative,cassini,ranga,pundit,kenilworth,tiananmen,disulfide,formula_35,townlands,codice_3,looping,caravans,rachmaninoff,segmentation,fluorine,anglicised,gnostic,dessau,discern,reconfigured,altrincham,rebounding,battlecruiser,ramblers,1770s,convective,triomphe,miyagi,mourners,instagram,aloft,breastfeeding,courtyards,folkestone,changsha,kumamoto,saarland,grayish,provisionally,appomattox,uncial,classicism,mahindra,elapsed,supremes,monophyletic,cautioned,formula_36,noblewoman,kernels,sucre,swaps,bengaluru,grenfell,epicenter,rockhampton,worshipful,licentiate,metaphorical,malankara,amputated,wattle,palawan,tankobon,nobunaga,polyhedra,transduction,jilin,syrians,affinities,fluently,emanating,anglicized,sportscar,botanists,altona,dravida,chorley,allocations,kunming,luanda,premiering,outlived,mesoamerica,lingual,dissipating,impairments,attenborough,balustrade,emulator,bakhsh,cladding,increments,ascents,workington,qal'eh,winless,categorical,petrel,emphasise,dormer,toros,hijackers,telescopic,solidly,jankovic,cession,gurus,madoff,newry,subsystems,northside,talib,englishmen,farnese,holographic,electives,argonne,scrivener,predated,brugge,nauvoo,catalyses,soared,siddeley,graphically,powerlifting,funicular,sungai,coercive,fusing,uncertainties,locos,acetic,diverge,wedgwood,dressings,tiebreaker,didactic,vyacheslav,acreage,interplanetary,battlecruisers,sunbury,alkaloids,hairpin,automata,wielkie,interdiction,plugins,monkees,nudibranch,esporte,approximations,disabling,powering,characterisation,ecologically,martinsville,termen,perpetuated,lufthansa,ascendancy,motherboard,bolshoi,athanasius,prunus,dilution,invests,nonzero,mendocino,charan,banque,shaheed,counterculture,unita,voivode,hospitalization,vapour,supermarine,resistor,steppes,osnabruck,intermediates,benzodiazepines,sunnyside,privatized,geopolitical,ponta,beersheba,kievan,embody,theoretic,sangh,cartographer,blige,rotors,thruway,battlefields,discernible,demobilized,broodmare,colouration,sagas,policymakers,serialization,augmentation,hoare,frankfurter,transnistria,kinases,detachable,generational,converging,antiaircraft,khaki,bimonthly,coadjutor,arkhangelsk,kannur,buffers,livonian,northwich,enveloped,cysts,yokozuna,herne,beeching,enron,virginian,woollen,excepting,competitively,outtakes,recombinant,hillcrest,clearances,pathe,cumbersome,brasov,u.s.a,likud,christiania,cruciform,hierarchies,wandsworth,lupin,resins,voiceover,sitar,electrochemical,mediacorp,typhus,grenadiers,hepatic,pompeii,weightlifter,bosniak,oxidoreductase,undersecretary,rescuers,ranji,seleucid,analysing,exegesis,tenancy,toure,kristiansand,110th,carillon,minesweepers,poitou,acceded,palladian,redevelop,naismith,rifled,proletariat,shojo,hackensack,harvests,endpoint,kuban,rosenborg,stonehenge,authorisation,jacobean,revocation,compatriots,colliding,undetermined,okayama,acknowledgment,angelou,fresnel,chahar,ethereal,mg/kg,emmet,mobilised,unfavourable,cultura,characterizing,parsonage,skeptics,expressways,rabaul,medea,guardsmen,visakhapatnam,caddo,homophobic,elmwood,encircling,coexistence,contending,seljuk,mycologist,infertility,moliere,insolvent,covenants,underpass,holme,landesliga,workplaces,delinquency,methamphetamine,contrived,tableau,tithes,overlying,usurped,contingents,spares,oligocene,molde,beatification,mordechai,balloting,pampanga,navigators,flowered,debutant,codec,orogeny,newsletters,solon,ambivalent,ubisoft,archdeaconry,harpers,kirkus,jabal,castings,kazhagam,sylhet,yuwen,barnstaple,amidships,causative,isuzu,watchtower,granules,canaveral,remuneration,insurer,payout,horizonte,integrative,attributing,kiwis,skanderbeg,asymmetry,gannett,urbanism,disassembled,unaltered,precluded,melodifestivalen,ascends,plugin,gurkha,bisons,stakeholder,industrialisation,abbotsford,sextet,bustling,uptempo,slavia,choreographers,midwives,haram,javed,gazetteer,subsection,natively,weighting,lysine,meera,redbridge,muchmusic,abruzzo,adjoins,unsustainable,foresters,kbit/s,cosmopterigidae,secularism,poetics,causality,phonograph,estudiantes,ceausescu,universitario,adjoint,applicability,gastropods,nagaland,kentish,mechelen,atalanta,woodpeckers,lombards,gatineau,romansh,avraham,acetylcholine,perturbation,galois,wenceslaus,fuzhou,meandering,dendritic,sacristy,accented,katha,therapeutics,perceives,unskilled,greenhouses,analogues,chaldean,timbre,sloped,volodymyr,sadiq,maghreb,monogram,rearguard,caucuses,mures,metabolite,uyezd,determinism,theosophical,corbet,gaels,disruptions,bicameral,ribosomal,wolseley,clarksville,watersheds,tarsi,radon,milanese,discontinuous,aristotelian,whistleblower,representational,hashim,modestly,localised,atrial,hazara,ravana,troyes,appointees,rubus,morningside,amity,aberdare,ganglia,wests,zbigniew,aerobatic,depopulated,corsican,introspective,twinning,hardtop,shallower,cataract,mesolithic,emblematic,graced,lubrication,republicanism,voronezh,bastions,meissen,irkutsk,oboes,hokkien,sprites,tenet,individualist,capitulated,oakville,dysentery,orientalist,hillsides,keywords,elicited,incised,lagging,apoel,lengthening,attractiveness,marauders,sportswriter,decentralization,boltzmann,contradicts,draftsman,precipitate,solihull,norske,consorts,hauptmann,riflemen,adventists,syndromes,demolishing,customize,continuo,peripherals,seamlessly,linguistically,bhushan,orphanages,paraul,lessened,devanagari,quarto,responders,patronymic,riemannian,altoona,canonization,honouring,geodetic,exemplifies,republica,enzymatic,porters,fairmount,pampa,sufferers,kamchatka,conjugated,coachella,uthman,repositories,copious,headteacher,awami,phoneme,homomorphism,franconian,moorland,davos,quantified,kamloops,quarks,mayoralty,weald,peacekeepers,valerian,particulate,insiders,perthshire,caches,guimaraes,piped,grenadines,kosciuszko,trombonist,artemisia,covariance,intertidal,soybeans,beatified,ellipse,fruiting,deafness,dnipropetrovsk,accrued,zealous,mandala,causation,junius,kilowatt,bakeries,montpelier,airdrie,rectified,bungalows,toleration,debian,pylon,trotskyist,posteriorly,two-and-a-half,herbivorous,islamists,poetical,donne,wodehouse,frome,allium,assimilate,phonemic,minaret,unprofitable,darpa,untenable,leaflet,bitcoin,zahir,thresholds,argentino,jacopo,bespoke,stratified,wellbeing,shiite,basaltic,timberwolves,secrete,taunts,marathons,isomers,carre,consecrators,penobscot,pitcairn,sakha,crosstown,inclusions,impassable,fenders,indre,uscgc,jordi,retinue,logarithmic,pilgrimages,railcar,cashel,blackrock,macroscopic,aligning,tabla,trestle,certify,ronson,palps,dissolves,thickened,silicate,taman,walsingham,hausa,lowestoft,rondo,oleksandr,cuyahoga,retardation,countering,cricketing,holborn,identifiers,hells,geophysics,infighting,sculpting,balaji,webbed,irradiation,runestone,trusses,oriya,sojourn,forfeiture,colonize,exclaimed,eucharistic,lackluster,glazing,northridge,gutenberg,stipulates,macroeconomic,priori,outermost,annular,udinese,insulating,headliner,godel,polytope,megalithic,salix,sharapova,derided,muskegon,braintree,plateaus,confers,autocratic,isomer,interstitial,stamping,omits,kirtland,hatchery,evidences,intifada,111th,podgorica,capua,motivating,nuneaton,jakub,korsakov,amitabh,mundial,monrovia,gluten,predictor,marshalling,d'orleans,levers,touchscreen,brantford,fricative,banishment,descendent,antagonism,ludovico,loudspeakers,formula_37,livelihoods,manassas,steamships,dewsbury,uppermost,humayun,lures,pinnacles,dependents,lecce,clumps,observatories,paleozoic,dedicating,samiti,draughtsman,gauls,incite,infringing,nepean,pythagorean,convents,triumvirate,seigneur,gaiman,vagrant,fossa,byproduct,serrated,renfrewshire,sheltering,achaemenid,dukedom,catchers,sampdoria,platelet,bielefeld,fluctuating,phenomenology,strikeout,ethnology,prospectors,woodworking,tatra,wildfires,meditations,agrippa,fortescue,qureshi,wojciech,methyltransferase,accusative,saatchi,amerindian,volcanism,zeeland,toyama,vladimirovich,allege,polygram,redox,budgeted,advisories,nematode,chipset,starscream,tonbridge,hardening,shales,accompanist,paraded,phonographic,whitefish,sportive,audiobook,kalisz,hibernation,latif,duels,ps200,coxeter,nayak,safeguarding,cantabria,minesweeping,zeiss,dunams,catholicos,sawtooth,ontological,nicobar,bridgend,unclassified,intrinsically,hanoverian,rabbitohs,kenseth,alcalde,northumbrian,raritan,septuagint,presse,sevres,origen,dandenong,peachtree,intersected,impeded,usages,hippodrome,novara,trajectories,customarily,yardage,inflected,yanow,kalan,taverns,liguria,librettist,intermarriage,1760s,courant,gambier,infanta,ptolemaic,ukulele,haganah,sceptical,manchukuo,plexus,implantation,hilal,intersex,efficiencies,arbroath,hagerstown,adelphi,diario,marais,matti,lifes,coining,modalities,divya,bletchley,conserving,ivorian,mithridates,generative,strikeforce,laymen,toponymy,pogrom,satya,meticulously,agios,dufferin,yaakov,fortnightly,cargoes,deterrence,prefrontal,przemysl,mitterrand,commemorations,chatsworth,gurdwara,abuja,chakraborty,badajoz,geometries,artiste,diatonic,ganglion,presides,marymount,nanak,cytokines,feudalism,storks,rowers,widens,politico,evangelicals,assailants,pittsfield,allowable,bijapur,telenovelas,dichomeris,glenelg,herbivores,keita,inked,radom,fundraisers,constantius,boheme,portability,komnenos,crystallography,derrida,moderates,tavistock,fateh,spacex,disjoint,bristles,commercialized,interwoven,empirically,regius,bulacan,newsday,showa,radicalism,yarrow,pleura,sayed,structuring,cotes,reminiscences,acetyl,edicts,escalators,aomori,encapsulated,legacies,bunbury,placings,fearsome,postscript,powerfully,keighley,hildesheim,amicus,crevices,deserters,benelux,aurangabad,freeware,ioannis,carpathians,chirac,seceded,prepaid,landlocked,naturalised,yanukovych,soundscan,blotch,phenotypic,determinants,twente,dictatorial,giessen,composes,recherche,pathophysiology,inventories,ayurveda,elevating,gravestone,degeneres,vilayet,popularizing,spartanburg,bloemfontein,previewed,renunciation,genotype,ogilvy,tracery,blacklisted,emissaries,diploid,disclosures,tupolev,shinjuku,antecedents,pennine,braganza,bhattacharya,countable,spectroscopic,ingolstadt,theseus,corroborated,compounding,thrombosis,extremadura,medallions,hasanabad,lambton,perpetuity,glycol,besancon,palaiologos,pandey,caicos,antecedent,stratum,laserdisc,novitiate,crowdfunding,palatal,sorceress,dassault,toughness,celle,cezanne,vientiane,tioga,hander,crossbar,gisborne,cursor,inspectorate,serif,praia,sphingidae,nameplate,psalter,ivanovic,sitka,equalised,mutineers,sergius,outgrowth,creationism,haredi,rhizomes,predominate,undertakings,vulgate,hydrothermal,abbeville,geodesic,kampung,physiotherapy,unauthorised,asteraceae,conservationist,minoan,supersport,mohammadabad,cranbrook,mentorship,legitimately,marshland,datuk,louvain,potawatomi,carnivores,levies,lyell,hymnal,regionals,tinto,shikoku,conformal,wanganui,beira,lleida,standstill,deloitte,formula_40,corbusier,chancellery,mixtapes,airtime,muhlenberg,formula_39,bracts,thrashers,prodigious,gironde,chickamauga,uyghurs,substitutions,pescara,batangas,gregarious,gijon,paleo,mathura,pumas,proportionally,hawkesbury,yucca,kristiania,funimation,fluted,eloquence,mohun,aftermarket,chroniclers,futurist,nonconformist,branko,mannerisms,lesnar,opengl,altos,retainers,ashfield,shelbourne,sulaiman,divisie,gwent,locarno,lieder,minkowski,bivalve,redeployed,cartography,seaway,bookings,decays,ostend,antiquaries,pathogenesis,formula_38,chrysalis,esperance,valli,motogp,homelands,bridged,bloor,ghazal,vulgaris,baekje,prospector,calculates,debtors,hesperiidae,titian,returner,landgrave,frontenac,kelowna,pregame,castelo,caius,canoeist,watercolours,winterthur,superintendents,dissonance,dubstep,adorn,matic,salih,hillel,swordsman,flavoured,emitter,assays,monongahela,deeded,brazzaville,sufferings,babylonia,fecal,umbria,astrologer,gentrification,frescos,phasing,zielona,ecozone,candido,manoj,quadrilateral,gyula,falsetto,prewar,puntland,infinitive,contraceptive,bakhtiari,ohrid,socialization,tailplane,evoking,havelock,macapagal,plundering,104th,keynesian,templars,phrasing,morphologically,czestochowa,humorously,catawba,burgas,chiswick,ellipsoid,kodansha,inwards,gautama,katanga,orthopaedic,heilongjiang,sieges,outsourced,subterminal,vijayawada,hares,oration,leitrim,ravines,manawatu,cryogenic,tracklisting,about.com,ambedkar,degenerated,hastened,venturing,lobbyists,shekhar,typefaces,northcote,rugen,'good,ornithology,asexual,hemispheres,unsupported,glyphs,spoleto,epigenetic,musicianship,donington,diogo,kangxi,bisected,polymorphism,megawatt,salta,embossed,cheetahs,cruzeiro,unhcr,aristide,rayleigh,maturing,indonesians,noire,llano,ffffff,camus,purges,annales,convair,apostasy,algol,phage,apaches,marketers,aldehyde,pompidou,kharkov,forgeries,praetorian,divested,retrospectively,gornji,scutellum,bitumen,pausanias,magnification,imitations,nyasaland,geographers,floodlights,athlone,hippolyte,expositions,clarinetist,razak,neutrinos,rotax,sheykh,plush,interconnect,andalus,cladogram,rudyard,resonator,granby,blackfriars,placido,windscreen,sahel,minamoto,haida,cations,emden,blackheath,thematically,blacklist,pawel,disseminating,academical,undamaged,raytheon,harsher,powhatan,ramachandran,saddles,paderborn,capping,zahra,prospecting,glycine,chromatin,profane,banska,helmand,okinawan,dislocation,oscillators,insectivorous,foyle,gilgit,autonomic,tuareg,sluice,pollinated,multiplexed,granary,narcissus,ranchi,staines,nitra,goalscoring,midwifery,pensioners,algorithmic,meetinghouse,biblioteca,besar,narva,angkor,predate,lohan,cyclical,detainee,occipital,eventing,faisalabad,dartmoor,kublai,courtly,resigns,radii,megachilidae,cartels,shortfall,xhosa,unregistered,benchmarks,dystopian,bulkhead,ponsonby,jovanovic,accumulates,papuan,bhutanese,intuitively,gotaland,headliners,recursion,dejan,novellas,diphthongs,imbued,withstood,analgesic,amplify,powertrain,programing,maidan,alstom,affirms,eradicated,summerslam,videogame,molla,severing,foundered,gallium,atmospheres,desalination,shmuel,howmeh,catolica,bossier,reconstructing,isolates,lyase,tweets,unconnected,tidewater,divisible,cohorts,orebro,presov,furnishing,folklorist,simplifying,centrale,notations,factorization,monarchies,deepen,macomb,facilitation,hennepin,declassified,redrawn,microprocessors,preliminaries,enlarging,timeframe,deutschen,shipbuilders,patiala,ferrous,aquariums,genealogies,vieux,unrecognized,bridgwater,tetrahedral,thule,resignations,gondwana,registries,agder,dataset,felled,parva,analyzer,worsen,coleraine,columella,blockaded,polytechnique,reassembled,reentry,narvik,greys,nigra,knockouts,bofors,gniezno,slotted,hamasaki,ferrers,conferring,thirdly,domestication,photojournalist,universality,preclude,ponting,halved,thereupon,photosynthetic,ostrava,mismatch,pangasinan,intermediaries,abolitionists,transited,headings,ustase,radiological,interconnection,dabrowa,invariants,honorius,preferentially,chantilly,marysville,dialectical,antioquia,abstained,gogol,dirichlet,muricidae,symmetries,reproduces,brazos,fatwa,bacillus,ketone,paribas,chowk,multiplicative,dermatitis,mamluks,devotes,adenosine,newbery,meditative,minefields,inflection,oxfam,conwy,bystrica,imprints,pandavas,infinitesimal,conurbation,amphetamine,reestablish,furth,edessa,injustices,frankston,serjeant,4x200,khazar,sihanouk,longchamp,stags,pogroms,coups,upperparts,endpoints,infringed,nuanced,summing,humorist,pacification,ciaran,jamaat,anteriorly,roddick,springboks,faceted,hypoxia,rigorously,cleves,fatimid,ayurvedic,tabled,ratna,senhora,maricopa,seibu,gauguin,holomorphic,campgrounds,amboy,coordinators,ponderosa,casemates,ouachita,nanaimo,mindoro,zealander,rimsky,cluny,tomaszow,meghalaya,caetano,tilak,roussillon,landtag,gravitation,dystrophy,cephalopods,trombones,glens,killarney,denominated,anthropogenic,pssas,roubaix,carcasses,montmorency,neotropical,communicative,rabindranath,ordinated,separable,overriding,surged,sagebrush,conciliation,codice_4,durrani,phosphatase,qadir,votive,revitalized,taiyuan,tyrannosaurus,graze,slovaks,nematodes,environmentalism,blockhouse,illiteracy,schengen,ecotourism,alternation,conic,wields,hounslow,blackfoot,kwame,ambulatory,volhynia,hordaland,croton,piedras,rohit,drava,conceptualized,birla,illustrative,gurgaon,barisal,tutsi,dezong,nasional,polje,chanson,clarinets,krasnoyarsk,aleksandrovich,cosmonaut,d'este,palliative,midseason,silencing,wardens,durer,girders,salamanders,torrington,supersonics,lauda,farid,circumnavigation,embankments,funnels,bajnoksag,lorries,cappadocia,jains,warringah,retirees,burgesses,equalization,cusco,ganesan,algal,amazonian,lineups,allocating,conquerors,usurper,mnemonic,predating,brahmaputra,ahmadabad,maidenhead,numismatic,subregion,encamped,reciprocating,freebsd,irgun,tortoises,governorates,zionists,airfoil,collated,ajmer,fiennes,etymological,polemic,chadian,clerestory,nordiques,fluctuated,calvados,oxidizing,trailhead,massena,quarrels,dordogne,tirunelveli,pyruvate,pulsed,athabasca,sylar,appointee,serer,japonica,andronikos,conferencing,nicolaus,chemin,ascertained,incited,woodbine,helices,hospitalised,emplacements,to/from,orchestre,tyrannical,pannonia,methodism,pop/rock,shibuya,berbers,despot,seaward,westpac,separator,perpignan,alamein,judeo,publicize,quantization,ethniki,gracilis,menlo,offside,oscillating,unregulated,succumbing,finnmark,metrical,suleyman,raith,sovereigns,bundesstrasse,kartli,fiduciary,darshan,foramen,curler,concubines,calvinism,larouche,bukhara,sophomores,mohanlal,lutheranism,monomer,eamonn,'black,uncontested,immersive,tutorials,beachhead,bindings,permeable,postulates,comite,transformative,indiscriminate,hofstra,associacao,amarna,dermatology,lapland,aosta,babur,unambiguous,formatting,schoolboys,gwangju,superconducting,replayed,adherent,aureus,compressors,forcible,spitsbergen,boulevards,budgeting,nossa,annandale,perumal,interregnum,sassoon,kwajalein,greenbrier,caldas,triangulation,flavius,increment,shakhtar,nullified,pinfall,nomen,microfinance,depreciation,cubist,steeper,splendour,gruppe,everyman,chasers,campaigners,bridle,modality,percussive,darkly,capes,velar,picton,triennial,factional,padang,toponym,betterment,norepinephrine,112th,estuarine,diemen,warehousing,morphism,ideologically,pairings,immunization,crassus,exporters,sefer,flocked,bulbous,deseret,booms,calcite,bohol,elven,groot,pulau,citigroup,wyeth,modernizing,layering,pastiche,complies,printmaker,condenser,theropod,cassino,oxyrhynchus,akademie,trainings,lowercase,coxae,parte,chetniks,pentagonal,keselowski,monocoque,morsi,reticulum,meiosis,clapboard,recoveries,tinge,an/fps,revista,sidon,livre,epidermis,conglomerates,kampong,congruent,harlequins,tergum,simplifies,epidemiological,underwriting,tcp/ip,exclusivity,multidimensional,mysql,columbine,ecologist,hayat,sicilies,levees,handset,aesop,usenet,pacquiao,archiving,alexandrian,compensatory,broadsheet,annotation,bahamian,d'affaires,interludes,phraya,shamans,marmara,customizable,immortalized,ambushes,chlorophyll,diesels,emulsion,rheumatoid,voluminous,screenwriters,tailoring,sedis,runcorn,democratization,bushehr,anacostia,constanta,antiquary,sixtus,radiate,advaita,antimony,acumen,barristers,reichsbahn,ronstadt,symbolist,pasig,cursive,secessionist,afrikaner,munnetra,inversely,adsorption,syllabic,moltke,idioms,midline,olimpico,diphosphate,cautions,radziwill,mobilisation,copelatus,trawlers,unicron,bhaskar,financiers,minimalism,derailment,marxists,oireachtas,abdicate,eigenvalue,zafar,vytautas,ganguly,chelyabinsk,telluride,subordination,ferried,dived,vendee,pictish,dimitrov,expiry,carnation,cayley,magnitudes,lismore,gretna,sandwiched,unmasked,sandomierz,swarthmore,tetra,nanyang,pevsner,dehradun,mormonism,rashi,complying,seaplanes,ningbo,cooperates,strathcona,mornington,mestizo,yulia,edgbaston,palisade,ethno,polytopes,espirito,tymoshenko,pronunciations,paradoxical,taichung,chipmunks,erhard,maximise,accretion,kanda,`abdu'l,narrowest,umpiring,mycenaean,divisor,geneticist,ceredigion,barque,hobbyists,equates,auxerre,spinose,cheil,sweetwater,guano,carboxylic,archiv,tannery,cormorant,agonists,fundacion,anbar,tunku,hindrance,meerut,concordat,secunderabad,kachin,achievable,murfreesboro,comprehensively,forges,broadest,synchronised,speciation,scapa,aliyev,conmebol,tirelessly,subjugated,pillaged,udaipur,defensively,lakhs,stateless,haasan,headlamps,patterning,podiums,polyphony,mcmurdo,mujer,vocally,storeyed,mucosa,multivariate,scopus,minimizes,formalised,certiorari,bourges,populate,overhanging,gaiety,unreserved,borromeo,woolworths,isotopic,bashar,purify,vertebra,medan,juxtaposition,earthwork,elongation,chaudhary,schematic,piast,steeped,nanotubes,fouls,achaea,legionnaires,abdur,qmjhl,embraer,hardback,centerville,ilocos,slovan,whitehorse,mauritian,moulding,mapuche,donned,provisioning,gazprom,jonesboro,audley,lightest,calyx,coldwater,trigonometric,petroglyphs,psychoanalyst,congregate,zambezi,fissure,supervises,bexley,etobicoke,wairarapa,tectonics,emphasises,formula_41,debugging,linfield,spatially,ionizing,ungulates,orinoco,clades,erlangen,news/talk,vols.,ceara,yakovlev,finsbury,entanglement,fieldhouse,graphene,intensifying,grigory,keyong,zacatecas,ninian,allgemeine,keswick,societa,snorri,femininity,najib,monoclonal,guyanese,postulate,huntly,abbeys,machinist,yunus,emphasising,ishaq,urmia,bremerton,pretenders,lumiere,thoroughfares,chikara,dramatized,metathorax,taiko,transcendence,wycliffe,retrieves,umpired,steuben,racehorses,taylors,kuznetsov,montezuma,precambrian,canopies,gaozong,propodeum,disestablished,retroactive,shoreham,rhizome,doubleheader,clinician,diwali,quartzite,shabaab,agassiz,despatched,stormwater,luxemburg,callao,universidade,courland,skane,glyph,dormers,witwatersrand,curacy,qualcomm,nansen,entablature,lauper,hausdorff,lusaka,ruthenian,360deg,cityscape,douai,vaishnava,spars,vaulting,rationalist,gygax,sequestration,typology,pollinates,accelerators,leben,colonials,cenotaph,imparted,carthaginians,equaled,rostrum,gobind,bodhisattva,oberst,bicycling,arabi,sangre,biophysics,hainaut,vernal,lunenburg,apportioned,finches,lajos,nenad,repackaged,zayed,nikephoros,r.e.m,swaminarayan,gestalt,unplaced,crags,grohl,sialkot,unsaturated,gwinnett,linemen,forays,palakkad,writs,instrumentalists,aircrews,badged,terrapins,180deg,oneness,commissariat,changi,pupation,circumscribed,contador,isotropic,administrated,fiefs,nimes,intrusions,minoru,geschichte,nadph,tainan,changchun,carbondale,frisia,swapo,evesham,hawai'i,encyclopedic,transporters,dysplasia,formula_42,onsite,jindal,guetta,judgements,narbonne,permissions,paleogene,rationalism,vilna,isometric,subtracted,chattahoochee,lamina,missa,greville,pervez,lattices,persistently,crystallization,timbered,hawaiians,fouling,interrelated,masood,ripening,stasi,gamal,visigothic,warlike,cybernetics,tanjung,forfar,cybernetic,karelian,brooklands,belfort,greifswald,campeche,inexplicably,refereeing,understory,uninterested,prius,collegiately,sefid,sarsfield,categorize,biannual,elsevier,eisteddfod,declension,autonoma,procuring,misrepresentation,novelization,bibliographic,shamanism,vestments,potash,eastleigh,ionized,turan,lavishly,scilly,balanchine,importers,parlance,'that,kanyakumari,synods,mieszko,crossovers,serfdom,conformational,legislated,exclave,heathland,sadar,differentiates,propositional,konstantinos,photoshop,manche,vellore,appalachia,orestes,taiga,exchanger,grozny,invalidated,baffin,spezia,staunchly,eisenach,robustness,virtuosity,ciphers,inlets,bolagh,understandings,bosniaks,parser,typhoons,sinan,luzerne,webcomic,subtraction,jhelum,businessweek,ceske,refrained,firebox,mitigated,helmholtz,dilip,eslamabad,metalwork,lucan,apportionment,provident,gdynia,schooners,casement,danse,hajjiabad,benazir,buttress,anthracite,newsreel,wollaston,dispatching,cadastral,riverboat,provincetown,nantwich,missal,irreverent,juxtaposed,darya,ennobled,electropop,stereoscopic,maneuverability,laban,luhansk,udine,collectibles,haulage,holyrood,materially,supercharger,gorizia,shkoder,townhouses,pilate,layoffs,folkloric,dialectic,exuberant,matures,malla,ceuta,citizenry,crewed,couplet,stopover,transposition,tradesmen,antioxidant,amines,utterance,grahame,landless,isere,diction,appellant,satirist,urbino,intertoto,subiaco,antonescu,nehemiah,ubiquitin,emcee,stourbridge,fencers,103rd,wranglers,monteverdi,watertight,expounded,xiamen,manmohan,pirie,threefold,antidepressant,sheboygan,grieg,cancerous,diverging,bernini,polychrome,fundamentalism,bihari,critiqued,cholas,villers,tendulkar,dafydd,vastra,fringed,evangelization,episcopalian,maliki,sana'a,ashburton,trianon,allegany,heptathlon,insufficiently,panelists,pharrell,hexham,amharic,fertilized,plumes,cistern,stratigraphy,akershus,catalans,karoo,rupee,minuteman,quantification,wigmore,leutnant,metanotum,weeknights,iridescent,extrasolar,brechin,deuterium,kuching,lyricism,astrakhan,brookhaven,euphorbia,hradec,bhagat,vardar,aylmer,positron,amygdala,speculators,unaccompanied,debrecen,slurry,windhoek,disaffected,rapporteur,mellitus,blockers,fronds,yatra,sportsperson,precession,physiologist,weeknight,pidgin,pharma,condemns,standardize,zetian,tibor,glycoprotein,emporia,cormorants,amalie,accesses,leonhard,denbighshire,roald,116th,will.i.am,symbiosis,privatised,meanders,chemnitz,jabalpur,shing,secede,ludvig,krajina,homegrown,snippets,sasanian,euripides,peder,cimarron,streaked,graubunden,kilimanjaro,mbeki,middleware,flensburg,bukovina,lindwall,marsalis,profited,abkhaz,polis,camouflaged,amyloid,morgantown,ovoid,bodleian,morte,quashed,gamelan,juventud,natchitoches,storyboard,freeview,enumeration,cielo,preludes,bulawayo,1600s,olympiads,multicast,faunal,asura,reinforces,puranas,ziegfeld,handicraft,seamount,kheil,noche,hallmarks,dermal,colorectal,encircle,hessen,umbilicus,sunnis,leste,unwin,disclosing,superfund,montmartre,refuelling,subprime,kolhapur,etiology,bismuth,laissez,vibrational,mazar,alcoa,rumsfeld,recurve,ticonderoga,lionsgate,onlookers,homesteads,filesystem,barometric,kingswood,biofuel,belleza,moshav,occidentalis,asymptomatic,northeasterly,leveson,huygens,numan,kingsway,primogeniture,toyotomi,yazoo,limpets,greenbelt,booed,concurrence,dihedral,ventrites,raipur,sibiu,plotters,kitab,109th,trackbed,skilful,berthed,effendi,fairing,sephardi,mikhailovich,lockyer,wadham,invertible,paperbacks,alphabetic,deuteronomy,constitutive,leathery,greyhounds,estoril,beechcraft,poblacion,cossidae,excreted,flamingos,singha,olmec,neurotransmitters,ascoli,nkrumah,forerunners,dualism,disenchanted,benefitted,centrum,undesignated,noida,o'donoghue,collages,egrets,egmont,wuppertal,cleave,montgomerie,pseudomonas,srinivasa,lymphatic,stadia,resold,minima,evacuees,consumerism,ronde,biochemist,automorphism,hollows,smuts,improvisations,vespasian,bream,pimlico,eglin,colne,melancholic,berhad,ousting,saale,notaulices,ouest,hunslet,tiberias,abdomina,ramsgate,stanislas,donbass,pontefract,sucrose,halts,drammen,chelm,l'arc,taming,trolleys,konin,incertae,licensees,scythian,giorgos,dative,tanglewood,farmlands,o'keeffe,caesium,romsdal,amstrad,corte,oglethorpe,huntingdonshire,magnetization,adapts,zamosc,shooto,cuttack,centrepiece,storehouse,winehouse,morbidity,woodcuts,ryazan,buddleja,buoyant,bodmin,estero,austral,verifiable,periyar,christendom,curtail,shura,kaifeng,cotswold,invariance,seafaring,gorica,androgen,usman,seabird,forecourt,pekka,juridical,audacious,yasser,cacti,qianlong,polemical,d'amore,espanyol,distrito,cartographers,pacifism,serpents,backa,nucleophilic,overturning,duplicates,marksman,oriente,vuitton,oberleutnant,gielgud,gesta,swinburne,transfiguration,1750s,retaken,celje,fredrikstad,asuka,cropping,mansard,donates,blacksmiths,vijayanagara,anuradhapura,germinate,betis,foreshore,jalandhar,bayonets,devaluation,frazione,ablaze,abidjan,approvals,homeostasis,corollary,auden,superfast,redcliffe,luxembourgish,datum,geraldton,printings,ludhiana,honoree,synchrotron,invercargill,hurriedly,108th,three-and-a-half,colonist,bexar,limousin,bessemer,ossetian,nunataks,buddhas,rebuked,thais,tilburg,verdicts,interleukin,unproven,dordrecht,solent,acclamation,muammar,dahomey,operettas,4x400,arrears,negotiators,whitehaven,apparitions,armoury,psychoactive,worshipers,sculptured,elphinstone,airshow,kjell,o'callaghan,shrank,professorships,predominance,subhash,coulomb,sekolah,retrofitted,samos,overthrowing,vibrato,resistors,palearctic,datasets,doordarshan,subcutaneous,compiles,immorality,patchwork,trinidadian,glycogen,pronged,zohar,visigoths,freres,akram,justo,agora,intakes,craiova,playwriting,bukhari,militarism,iwate,petitioners,harun,wisla,inefficiency,vendome,ledges,schopenhauer,kashi,entombed,assesses,tenn.,noumea,baguio,carex,o'donovan,filings,hillsdale,conjectures,blotches,annuals,lindisfarne,negated,vivek,angouleme,trincomalee,cofactor,verkhovna,backfield,twofold,automaker,rudra,freighters,darul,gharana,busway,formula_43,plattsburgh,portuguesa,showrunner,roadmap,valenciennes,erdos,biafra,spiritualism,transactional,modifies,carne,107th,cocos,gcses,tiverton,radiotherapy,meadowlands,gunma,srebrenica,foxtel,authenticated,enslavement,classicist,klaipeda,minstrels,searchable,infantrymen,incitement,shiga,nadp+,urals,guilders,banquets,exteriors,counterattacks,visualized,diacritics,patrimony,svensson,transepts,prizren,telegraphy,najaf,emblazoned,coupes,effluent,ragam,omani,greensburg,taino,flintshire,cd/dvd,lobbies,narrating,cacao,seafarers,bicolor,collaboratively,suraj,floodlit,sacral,puppetry,tlingit,malwa,login,motionless,thien,overseers,vihar,golem,specializations,bathhouse,priming,overdubs,winningest,archetypes,uniao,acland,creamery,slovakian,lithographs,maryborough,confidently,excavating,stillborn,ramallah,audiencia,alava,ternary,hermits,rostam,bauxite,gawain,lothair,captions,gulfstream,timelines,receded,mediating,petain,bastia,rudbar,bidders,disclaimer,shrews,tailings,trilobites,yuriy,jamil,demotion,gynecology,rajinikanth,madrigals,ghazni,flycatchers,vitebsk,bizet,computationally,kashgar,refinements,frankford,heralds,europe/africa,levante,disordered,sandringham,queues,ransacked,trebizond,verdes,comedie,primitives,figurine,organists,culminate,gosport,coagulation,ferrying,hoyas,polyurethane,prohibitive,midfielders,ligase,progesterone,defectors,sweetened,backcountry,diodorus,waterside,nieuport,khwaja,jurong,decried,gorkha,ismaili,300th,octahedral,kindergartens,paseo,codification,notifications,disregarding,risque,reconquista,shortland,atolls,texarkana,perceval,d'etudes,kanal,herbicides,tikva,nuova,gatherer,dissented,soweto,dexterity,enver,bacharach,placekicker,carnivals,automate,maynooth,symplectic,chetnik,militaire,upanishads,distributive,strafing,championing,moiety,miliband,blackadder,enforceable,maung,dimer,stadtbahn,diverges,obstructions,coleophoridae,disposals,shamrocks,aural,banca,bahru,coxed,grierson,vanadium,watermill,radiative,ecoregions,berets,hariri,bicarbonate,evacuations,mallee,nairn,rushden,loggia,slupsk,satisfactorily,milliseconds,cariboo,reine,cyclo,pigmentation,postmodernism,aqueducts,vasari,bourgogne,dilemmas,liquefied,fluminense,alloa,ibaraki,tenements,kumasi,humerus,raghu,labours,putsch,soundcloud,bodybuilder,rakyat,domitian,pesaro,translocation,sembilan,homeric,enforcers,tombstones,lectureship,rotorua,salamis,nikolaos,inferences,superfortress,lithgow,surmised,undercard,tarnow,barisan,stingrays,federacion,coldstream,haverford,ornithological,heerenveen,eleazar,jyoti,murali,bamako,riverbed,subsidised,theban,conspicuously,vistas,conservatorium,madrasa,kingfishers,arnulf,credential,syndicalist,sheathed,discontinuity,prisms,tsushima,coastlines,escapees,vitis,optimizing,megapixel,overground,embattled,halide,sprinters,buoys,mpumalanga,peculiarities,106th,roamed,menezes,macao,prelates,papyri,freemen,dissertations,irishmen,pooled,sverre,reconquest,conveyance,subjectivity,asturian,circassian,formula_45,comdr,thickets,unstressed,monro,passively,harmonium,moveable,dinar,carlsson,elysees,chairing,b'nai,confusingly,kaoru,convolution,godolphin,facilitator,saxophones,eelam,jebel,copulation,anions,livres,licensure,pontypridd,arakan,controllable,alessandria,propelling,stellenbosch,tiber,wolka,liberators,yarns,d'azur,tsinghua,semnan,amhara,ablation,melies,tonality,historique,beeston,kahne,intricately,sonoran,robespierre,gyrus,boycotts,defaulted,infill,maranhao,emigres,framingham,paraiba,wilhelmshaven,tritium,skyway,labial,supplementation,possessor,underserved,motets,maldivian,marrakech,quays,wikimedia,turbojet,demobilization,petrarch,encroaching,sloops,masted,karbala,corvallis,agribusiness,seaford,stenosis,hieronymus,irani,superdraft,baronies,cortisol,notability,veena,pontic,cyclin,archeologists,newham,culled,concurring,aeolian,manorial,shouldered,fords,philanthropists,105th,siddharth,gotthard,halim,rajshahi,jurchen,detritus,practicable,earthenware,discarding,travelogue,neuromuscular,elkhart,raeder,zygmunt,metastasis,internees,102nd,vigour,upmarket,summarizing,subjunctive,offsets,elizabethtown,udupi,pardubice,repeaters,instituting,archaea,substandard,technische,linga,anatomist,flourishes,velika,tenochtitlan,evangelistic,fitchburg,springbok,cascading,hydrostatic,avars,occasioned,filipina,perceiving,shimbun,africanus,consternation,tsing,optically,beitar,45deg,abutments,roseville,monomers,huelva,lotteries,hypothalamus,internationalist,electromechanical,hummingbirds,fibreglass,salaried,dramatists,uncovers,invokes,earners,excretion,gelding,ancien,aeronautica,haverhill,stour,ittihad,abramoff,yakov,ayodhya,accelerates,industrially,aeroplanes,deleterious,dwelt,belvoir,harpalus,atpase,maluku,alasdair,proportionality,taran,epistemological,interferometer,polypeptide,adjudged,villager,metastatic,marshalls,madhavan,archduchess,weizmann,kalgoorlie,balan,predefined,sessile,sagaing,brevity,insecticide,psychosocial,africana,steelworks,aether,aquifers,belem,mineiro,almagro,radiators,cenozoic,solute,turbocharger,invicta,guested,buccaneer,idolatry,unmatched,paducah,sinestro,dispossessed,conforms,responsiveness,cyanobacteria,flautist,procurator,complementing,semifinalist,rechargeable,permafrost,cytokine,refuges,boomed,gelderland,franchised,jinan,burnie,doubtless,randomness,colspan=12,angra,ginebra,famers,nuestro,declarative,roughness,lauenburg,motile,rekha,issuer,piney,interceptors,napoca,gipsy,formulaic,formula_44,viswanathan,ebrahim,thessalonica,galeria,muskogee,unsold,html5,taito,mobutu,icann,carnarvon,fairtrade,morphisms,upsilon,nozzles,fabius,meander,murugan,strontium,episcopacy,sandinista,parasol,attenuated,bhima,primeval,panay,ordinator,negara,osteoporosis,glossop,ebook,paradoxically,grevillea,modoc,equating,phonetically,legumes,covariant,dorje,quatre,bruxelles,pyroclastic,shipbuilder,zhaozong,obscuring,sveriges,tremolo,extensible,barrack,multnomah,hakon,chaharmahal,parsing,volumetric,astrophysical,glottal,combinatorics,freestanding,encoder,paralysed,cavalrymen,taboos,heilbronn,orientalis,lockport,marvels,ozawa,dispositions,waders,incurring,saltire,modulate,papilio,phenol,intermedia,rappahannock,plasmid,fortify,phenotypes,transiting,correspondences,leaguer,larnaca,incompatibility,mcenroe,deeming,endeavoured,aboriginals,helmed,salar,arginine,werke,ferrand,expropriated,delimited,couplets,phoenicians,petioles,ouster,anschluss,protectionist,plessis,urchins,orquesta,castleton,juniata,bittorrent,fulani,donji,mykola,rosemont,chandos,scepticism,signer,chalukya,wicketkeeper,coquitlam,programmatic,o'brian,carteret,urology,steelhead,paleocene,konkan,bettered,venkatesh,surfacing,longitudinally,centurions,popularization,yazid,douro,widths,premios,leonards,gristmill,fallujah,arezzo,leftists,ecliptic,glycerol,inaction,disenfranchised,acrimonious,depositing,parashah,cockatoo,marechal,bolzano,chios,cablevision,impartiality,pouches,thickly,equities,bentinck,emotive,boson,ashdown,conquistadors,parsi,conservationists,reductive,newlands,centerline,ornithologists,waveguide,nicene,philological,hemel,setanta,masala,aphids,convening,casco,matrilineal,chalcedon,orthographic,hythe,replete,damming,bolivarian,admixture,embarks,borderlands,conformed,nagarjuna,blenny,chaitanya,suwon,shigeru,tatarstan,lingayen,rejoins,grodno,merovingian,hardwicke,puducherry,prototyping,laxmi,upheavals,headquarter,pollinators,bromine,transom,plantagenet,arbuthnot,chidambaram,woburn,osamu,panelling,coauthored,zhongshu,hyaline,omissions,aspergillus,offensively,electrolytic,woodcut,sodom,intensities,clydebank,piotrkow,supplementing,quipped,focke,harbinger,positivism,parklands,wolfenbuttel,cauca,tryptophan,taunus,curragh,tsonga,remand,obscura,ashikaga,eltham,forelimbs,analogs,trnava,observances,kailash,antithesis,ayumi,abyssinia,dorsally,tralee,pursuers,misadventures,padova,perot,mahadev,tarim,granth,licenced,compania,patuxent,baronial,korda,cochabamba,codices,karna,memorialized,semaphore,playlists,mandibular,halal,sivaji,scherzinger,stralsund,foundries,ribosome,mindfulness,nikolayevich,paraphyletic,newsreader,catalyze,ioannina,thalamus,gbit/s,paymaster,sarab,500th,replenished,gamepro,cracow,formula_46,gascony,reburied,lessing,easement,transposed,meurthe,satires,proviso,balthasar,unbound,cuckoos,durbar,louisbourg,cowes,wholesalers,manet,narita,xiaoping,mohamad,illusory,cathal,reuptake,alkaloid,tahrir,mmorpg,underlies,anglicanism,repton,aharon,exogenous,buchenwald,indigent,odostomia,milled,santorum,toungoo,nevsky,steyr,urbanisation,darkseid,subsonic,canaanite,akiva,eglise,dentition,mediators,cirencester,peloponnesian,malmesbury,durres,oerlikon,tabulated,saens,canaria,ischemic,esterhazy,ringling,centralization,walthamstow,nalanda,lignite,takht,leninism,expiring,circe,phytoplankton,promulgation,integrable,breeches,aalto,menominee,borgo,scythians,skrull,galleon,reinvestment,raglan,reachable,liberec,airframes,electrolysis,geospatial,rubiaceae,interdependence,symmetrically,simulcasts,keenly,mauna,adipose,zaidi,fairport,vestibular,actuators,monochromatic,literatures,congestive,sacramental,atholl,skytrain,tycho,tunings,jamia,catharina,modifier,methuen,tapings,infiltrating,colima,grafting,tauranga,halides,pontificate,phonetics,koper,hafez,grooved,kintetsu,extrajudicial,linkoping,cyberpunk,repetitions,laurentian,parnu,bretton,darko,sverdlovsk,foreshadowed,akhenaten,rehnquist,gosford,coverts,pragmatism,broadleaf,ethiopians,instated,mediates,sodra,opulent,descriptor,enugu,shimla,leesburg,officership,giffard,refectory,lusitania,cybermen,fiume,corus,tydfil,lawrenceville,ocala,leviticus,burghers,ataxia,richthofen,amicably,acoustical,watling,inquired,tiempo,multiracial,parallelism,trenchard,tokyopop,germanium,usisl,philharmonia,shapur,jacobites,latinized,sophocles,remittances,o'farrell,adder,dimitrios,peshwa,dimitar,orlov,outstretched,musume,satish,dimensionless,serialised,baptisms,pagasa,antiviral,1740s,quine,arapaho,bombardments,stratosphere,ophthalmic,injunctions,carbonated,nonviolence,asante,creoles,sybra,boilermakers,abington,bipartite,permissive,cardinality,anheuser,carcinogenic,hohenlohe,surinam,szeged,infanticide,generically,floorball,'white,automakers,cerebellar,homozygous,remoteness,effortlessly,allude,'great,headmasters,minting,manchurian,kinabalu,wemyss,seditious,widgets,marbled,almshouses,bards,subgenres,tetsuya,faulting,kickboxer,gaulish,hoseyn,malton,fluvial,questionnaires,mondale,downplayed,traditionalists,vercelli,sumatran,landfills,gamesradar,exerts,franciszek,unlawfully,huesca,diderot,libertarians,professorial,laane,piecemeal,conidae,taiji,curatorial,perturbations,abstractions,szlachta,watercraft,mullah,zoroastrianism,segmental,khabarovsk,rectors,affordability,scuola,diffused,stena,cyclonic,workpiece,romford,'little,jhansi,stalag,zhongshan,skipton,maracaibo,bernadotte,thanet,groening,waterville,encloses,sahrawi,nuffield,moorings,chantry,annenberg,islay,marchers,tenses,wahid,siegen,furstenberg,basques,resuscitation,seminarians,tympanum,gentiles,vegetarianism,tufted,venkata,fantastical,pterophoridae,machined,superposition,glabrous,kaveri,chicane,executors,phyllonorycter,bidirectional,jasta,undertones,touristic,majapahit,navratilova,unpopularity,barbadian,tinian,webcast,hurdler,rigidly,jarrah,staphylococcus,igniting,irrawaddy,stabilised,airstrike,ragas,wakayama,energetically,ekstraklasa,minibus,largemouth,cultivators,leveraging,waitangi,carnaval,weaves,turntables,heydrich,sextus,excavate,govind,ignaz,pedagogue,uriah,borrowings,gemstones,infractions,mycobacterium,batavian,massing,praetor,subalpine,massoud,passers,geostationary,jalil,trainsets,barbus,impair,budejovice,denbigh,pertain,historicity,fortaleza,nederlandse,lamenting,masterchef,doubs,gemara,conductance,ploiesti,cetaceans,courthouses,bhagavad,mihailovic,occlusion,bremerhaven,bulwark,morava,kaine,drapery,maputo,conquistador,kaduna,famagusta,first-past-the-post,erudite,galton,undated,tangential,filho,dismembered,dashes,criterium,darwen,metabolized,blurring,everard,randwick,mohave,impurity,acuity,ansbach,chievo,surcharge,plantain,algoma,porosity,zirconium,selva,sevenoaks,venizelos,gwynne,golgi,imparting,separatism,courtesan,idiopathic,gravestones,hydroelectricity,babar,orford,purposeful,acutely,shard,ridgewood,viterbo,manohar,expropriation,placenames,brevis,cosine,unranked,richfield,newnham,recoverable,flightless,dispersing,clearfield,abu'l,stranraer,kempe,streamlining,goswami,epidermal,pieta,conciliatory,distilleries,electrophoresis,bonne,tiago,curiosities,candidature,picnicking,perihelion,lintel,povoa,gullies,configure,excision,facies,signers,1730s,insufficiency,semiotics,streatham,deactivation,entomological,skippers,albacete,parodying,escherichia,honorees,singaporeans,counterterrorism,tiruchirappalli,omnivorous,metropole,globalisation,athol,unbounded,codice_5,landforms,classifier,farmhouses,reaffirming,reparation,yomiuri,technologists,mitte,medica,viewable,steampunk,konya,kshatriya,repelling,edgewater,lamiinae,devas,potteries,llandaff,engendered,submits,virulence,uplifted,educationist,metropolitans,frontrunner,dunstable,forecastle,frets,methodius,exmouth,linnean,bouchet,repulsion,computable,equalling,liceo,tephritidae,agave,hydrological,azarenka,fairground,l'homme,enforces,xinhua,cinematographers,cooperstown,sa'id,paiute,christianization,tempos,chippenham,insulator,kotor,stereotyped,dello,cours,hisham,d'souza,eliminations,supercars,passau,rebrand,natures,coote,persephone,rededicated,cleaved,plenum,blistering,indiscriminately,cleese,safed,recursively,compacted,revues,hydration,shillong,echelons,garhwal,pedimented,grower,zwolle,wildflower,annexing,methionine,petah,valens,famitsu,petiole,specialities,nestorian,shahin,tokaido,shearwater,barberini,kinsmen,experimenter,alumnae,cloisters,alumina,pritzker,hardiness,soundgarden,julich,ps300,watercourse,cementing,wordplay,olivet,demesne,chasseurs,amide,zapotec,gaozu,porphyry,absorbers,indium,analogies,devotions,engravers,limestones,catapulted,surry,brickworks,gotra,rodham,landline,paleontologists,shankara,islip,raucous,trollope,arpad,embarkation,morphemes,recites,picardie,nakhchivan,tolerances,formula_47,khorramabad,nichiren,adrianople,kirkuk,assemblages,collider,bikaner,bushfires,roofline,coverings,reredos,bibliotheca,mantras,accentuated,commedia,rashtriya,fluctuation,serhiy,referential,fittipaldi,vesicle,geeta,iraklis,immediacy,chulalongkorn,hunsruck,bingen,dreadnoughts,stonemason,meenakshi,lebesgue,undergrowth,baltistan,paradoxes,parlement,articled,tiflis,dixieland,meriden,tejano,underdogs,barnstable,exemplify,venter,tropes,wielka,kankakee,iskandar,zilina,pharyngeal,spotify,materialised,picts,atlantique,theodoric,prepositions,paramilitaries,pinellas,attlee,actuated,piedmontese,grayling,thucydides,multifaceted,unedited,autonomously,universelle,utricularia,mooted,preto,incubated,underlie,brasenose,nootka,bushland,sensu,benzodiazepine,esteghlal,seagoing,amenhotep,azusa,sappers,culpeper,smokeless,thoroughbreds,dargah,gorda,alumna,mankato,zdroj,deleting,culvert,formula_49,punting,wushu,hindering,immunoglobulin,standardisation,birger,oilfield,quadrangular,ulama,recruiters,netanya,1630s,communaute,istituto,maciej,pathan,meher,vikas,characterizations,playmaker,interagency,intercepts,assembles,horthy,introspection,narada,matra,testes,radnicki,estonians,csiro,instar,mitford,adrenergic,crewmembers,haaretz,wasatch,lisburn,rangefinder,ordre,condensate,reforestation,corregidor,spvgg,modulator,mannerist,faulted,aspires,maktoum,squarepants,aethelred,piezoelectric,mulatto,dacre,progressions,jagiellonian,norge,samaria,sukhoi,effingham,coxless,hermetic,humanists,centrality,litters,stirlingshire,beaconsfield,sundanese,geometrically,caretakers,habitually,bandra,pashtuns,bradenton,arequipa,laminar,brickyard,hitchin,sustains,shipboard,ploughing,trechus,wheelers,bracketed,ilyushin,subotica,d'hondt,reappearance,bridgestone,intermarried,fulfilment,aphasia,birkbeck,transformational,strathmore,hornbill,millstone,lacan,voids,solothurn,gymnasiums,laconia,viaducts,peduncle,teachta,edgware,shinty,supernovae,wilfried,exclaim,parthia,mithun,flashpoint,moksha,cumbia,metternich,avalanches,militancy,motorist,rivadavia,chancellorsville,federals,gendered,bounding,footy,gauri,caliphs,lingam,watchmaker,unrecorded,riverina,unmodified,seafloor,droit,pfalz,chrysostom,gigabit,overlordship,besiege,espn2,oswestry,anachronistic,ballymena,reactivation,duchovny,ghani,abacetus,duller,legio,watercourses,nord-pas-de-calais,leiber,optometry,swarms,installer,sancti,adverbs,iheartmedia,meiningen,zeljko,kakheti,notional,circuses,patrilineal,acrobatics,infrastructural,sheva,oregonian,adjudication,aamir,wloclawek,overfishing,obstructive,subtracting,aurobindo,archeologist,newgate,'cause,secularization,tehsils,abscess,fingal,janacek,elkhorn,trims,kraftwerk,mandating,irregulars,faintly,congregationalist,sveti,kasai,mishaps,kennebec,provincially,durkheim,scotties,aicte,rapperswil,imphal,surrenders,morphs,nineveh,hoxha,cotabato,thuringian,metalworking,retold,shogakukan,anthers,proteasome,tippeligaen,disengagement,mockumentary,palatial,erupts,flume,corrientes,masthead,jaroslaw,rereleased,bharti,labors,distilling,tusks,varzim,refounded,enniskillen,melkite,semifinalists,vadodara,bermudian,capstone,grasse,origination,populus,alesi,arrondissements,semigroup,verein,opossum,messrs.,portadown,bulbul,tirupati,mulhouse,tetrahedron,roethlisberger,nonverbal,connexion,warangal,deprecated,gneiss,octet,vukovar,hesketh,chambre,despatch,claes,kargil,hideo,gravelly,tyndale,aquileia,tuners,defensible,tutte,theotokos,constructivist,ouvrage,dukla,polisario,monasticism,proscribed,commutation,testers,nipissing,codon,mesto,olivine,concomitant,exoskeleton,purports,coromandel,eyalet,dissension,hippocrates,purebred,yaounde,composting,oecophoridae,procopius,o'day,angiogenesis,sheerness,intelligencer,articular,felixstowe,aegon,endocrinology,trabzon,licinius,pagodas,zooplankton,hooghly,satie,drifters,sarthe,mercian,neuilly,tumours,canal+,scheldt,inclinations,counteroffensive,roadrunners,tuzla,shoreditch,surigao,predicates,carnot,algeciras,militaries,generalize,bulkheads,gawler,pollutant,celta,rundgren,microrna,gewog,olimpija,placental,lubelski,roxburgh,discerned,verano,kikuchi,musicale,l'enfant,ferocity,dimorphic,antigonus,erzurum,prebendary,recitative,discworld,cyrenaica,stigmella,totnes,sutta,pachuca,ulsan,downton,landshut,castellan,pleural,siedlce,siecle,catamaran,cottbus,utilises,trophic,freeholders,holyhead,u.s.s,chansons,responder,waziristan,suzuka,birding,shogi,asker,acetone,beautification,cytotoxic,dixit,hunterdon,cobblestone,formula_48,kossuth,devizes,sokoto,interlaced,shuttered,kilowatts,assiniboine,isaak,salto,alderney,sugarloaf,franchising,aggressiveness,toponyms,plaintext,antimatter,henin,equidistant,salivary,bilingualism,mountings,obligate,extirpated,irenaeus,misused,pastoralists,aftab,immigrating,warping,tyrolean,seaforth,teesside,soundwave,oligarchy,stelae,pairwise,iupac,tezuka,posht,orchestrations,landmass,ironstone,gallia,hjalmar,carmelites,strafford,elmhurst,palladio,fragility,teleplay,gruffudd,karoly,yerba,potok,espoo,inductance,macaque,nonprofits,pareto,rock'n'roll,spiritualist,shadowed,skateboarder,utterances,generality,congruence,prostrate,deterred,yellowknife,albarn,maldon,battlements,mohsen,insecticides,khulna,avellino,menstruation,glutathione,springdale,parlophone,confraternity,korps,countrywide,bosphorus,preexisting,damodar,astride,alexandrovich,sprinting,crystallized,botev,leaching,interstates,veers,angevin,undaunted,yevgeni,nishapur,northerners,alkmaar,bethnal,grocers,sepia,tornus,exemplar,trobe,charcot,gyeonggi,larne,tournai,lorain,voided,genji,enactments,maxilla,adiabatic,eifel,nazim,transducer,thelonious,pyrite,deportiva,dialectal,bengt,rosettes,labem,sergeyevich,synoptic,conservator,statuette,biweekly,adhesives,bifurcation,rajapaksa,mammootty,republique,yusef,waseda,marshfield,yekaterinburg,minnelli,fundy,fenian,matchups,dungannon,supremacist,panelled,drenthe,iyengar,fibula,narmada,homeport,oceanside,precept,antibacterial,altarpieces,swath,ospreys,lillooet,legnica,lossless,formula_50,galvatron,iorga,stormont,rsfsr,loggers,kutno,phenomenological,medallists,cuatro,soissons,homeopathy,bituminous,injures,syndicates,typesetting,displacements,dethroned,makassar,lucchese,abergavenny,targu,alborz,akb48,boldface,gastronomy,sacra,amenity,accumulator,myrtaceae,cornices,mourinho,denunciation,oxbow,diddley,aargau,arbitrage,bedchamber,gruffydd,zamindar,klagenfurt,caernarfon,slowdown,stansted,abrasion,tamaki,suetonius,dukakis,individualistic,ventrally,hotham,perestroika,ketones,fertilisation,sobriquet,couplings,renderings,misidentified,rundfunk,sarcastically,braniff,concours,dismissals,elegantly,modifiers,crediting,combos,crucially,seafront,lieut,ischemia,manchus,derivations,proteases,aristophanes,adenauer,porting,hezekiah,sante,trulli,hornblower,foreshadowing,ypsilanti,dharwad,khani,hohenstaufen,distillers,cosmodrome,intracranial,turki,salesian,gorzow,jihlava,yushchenko,leichhardt,venables,cassia,eurogamer,airtel,curative,bestsellers,timeform,sortied,grandview,massillon,ceding,pilbara,chillicothe,heredity,elblag,rogaland,ronne,millennial,batley,overuse,bharata,fille,campbelltown,abeyance,counterclockwise,250cc,neurodegenerative,consigned,electromagnetism,sunnah,saheb,exons,coxswain,gleaned,bassoons,worksop,prismatic,immigrate,pickets,takeo,bobsledder,stosur,fujimori,merchantmen,stiftung,forli,endorses,taskforce,thermally,atman,gurps,floodplains,enthalpy,extrinsic,setubal,kennesaw,grandis,scalability,durations,showrooms,prithvi,outro,overruns,andalucia,amanita,abitur,hipper,mozambican,sustainment,arsene,chesham,palaeolithic,reportage,criminality,knowsley,haploid,atacama,shueisha,ridgefield,astern,getafe,lineal,timorese,restyled,hollies,agincourt,unter,justly,tannins,mataram,industrialised,tarnovo,mumtaz,mustapha,stretton,synthetase,condita,allround,putra,stjepan,troughs,aechmea,specialisation,wearable,kadokawa,uralic,aeros,messiaen,existentialism,jeweller,effigies,gametes,fjordane,cochlear,interdependent,demonstrative,unstructured,emplacement,famines,spindles,amplitudes,actuator,tantalum,psilocybe,apnea,monogatari,expulsions,seleucus,tsuen,hospitaller,kronstadt,eclipsing,olympiakos,clann,canadensis,inverter,helio,egyptologist,squamous,resonate,munir,histology,torbay,khans,jcpenney,veterinarians,aintree,microscopes,colonised,reflectors,phosphorylated,pristimantis,tulare,corvinus,multiplexing,midweek,demosthenes,transjordan,ecija,tengku,vlachs,anamorphic,counterweight,radnor,trinitarian,armidale,maugham,njsiaa,futurism,stairways,avicenna,montebello,bridgetown,wenatchee,lyonnais,amass,surinamese,streptococcus,m*a*s*h,hydrogenation,frazioni,proscenium,kalat,pennsylvanian,huracan,tallying,kralove,nucleolar,phrygian,seaports,hyacinthe,ignace,donning,instalment,regnal,fonds,prawn,carell,folktales,goaltending,bracknell,vmware,patriarchy,mitsui,kragujevac,pythagoras,soult,thapa,disproved,suwalki,secures,somoza,l'ecole,divizia,chroma,herders,technologist,deduces,maasai,rampur,paraphrase,raimi,imaged,magsaysay,ivano,turmeric,formula_51,subcommittees,axillary,ionosphere,organically,indented,refurbishing,pequot,violinists,bearn,colle,contralto,silverton,mechanization,etruscans,wittelsbach,pasir,redshirted,marrakesh,scarp,plein,wafers,qareh,teotihuacan,frobenius,sinensis,rehoboth,bundaberg,newbridge,hydrodynamic,traore,abubakar,adjusts,storytellers,dynamos,verbandsliga,concertmaster,exxonmobil,appreciable,sieradz,marchioness,chaplaincy,rechristened,cunxu,overpopulation,apolitical,sequencer,beaked,nemanja,binaries,intendant,absorber,filamentous,indebtedness,nusra,nashik,reprises,psychedelia,abwehr,ligurian,isoform,resistive,pillaging,mahathir,reformatory,lusatia,allerton,ajaccio,tepals,maturin,njcaa,abyssinian,objector,fissures,sinuous,ecclesiastic,dalits,caching,deckers,phosphates,wurlitzer,navigated,trofeo,berea,purefoods,solway,unlockable,grammys,kostroma,vocalizations,basilan,rebuke,abbasi,douala,helsingborg,ambon,bakar,runestones,cenel,tomislav,pigmented,northgate,excised,seconda,kirke,determinations,dedicates,vilas,pueblos,reversion,unexploded,overprinted,ekiti,deauville,masato,anaesthesia,endoplasmic,transponders,aguascalientes,hindley,celluloid,affording,bayeux,piaget,rickshaws,eishockey,camarines,zamalek,undersides,hardwoods,hermitian,mutinied,monotone,blackmails,affixes,jpmorgan,habermas,mitrovica,paleontological,polystyrene,thana,manas,conformist,turbofan,decomposes,logano,castration,metamorphoses,patroness,herbicide,mikolaj,rapprochement,macroeconomics,barranquilla,matsudaira,lintels,femina,hijab,spotsylvania,morpheme,bitola,baluchistan,kurukshetra,otway,extrusion,waukesha,menswear,helder,trung,bingley,protester,boars,overhang,differentials,exarchate,hejaz,kumara,unjustified,timings,sharpness,nuovo,taisho,sundar,etc..,jehan,unquestionably,muscovy,daltrey,canute,paneled,amedeo,metroplex,elaborates,telus,tetrapods,dragonflies,epithets,saffir,parthenon,lucrezia,refitting,pentateuch,hanshin,montparnasse,lumberjacks,sanhedrin,erectile,odors,greenstone,resurgent,leszek,amory,substituents,prototypical,viewfinder,monck,universiteit,joffre,revives,chatillon,seedling,scherzo,manukau,ashdod,gympie,homolog,stalwarts,ruinous,weibo,tochigi,wallenberg,gayatri,munda,satyagraha,storefronts,heterogeneity,tollway,sportswriters,binocular,gendarmes,ladysmith,tikal,ortsgemeinde,ja'far,osmotic,linlithgow,bramley,telecoms,pugin,repose,rupaul,sieur,meniscus,garmisch,reintroduce,400th,shoten,poniatowski,drome,kazakhstani,changeover,astronautics,husserl,herzl,hypertext,katakana,polybius,antananarivo,seong,breguet,reliquary,utada,aggregating,liangshan,sivan,tonawanda,audiobooks,shankill,coulee,phenolic,brockton,bookmakers,handsets,boaters,wylde,commonality,mappings,silhouettes,pennines,maurya,pratchett,singularities,eschewed,pretensions,vitreous,ibero,totalitarianism,poulenc,lingered,directx,seasoning,deputation,interdict,illyria,feedstock,counterbalance,muzik,buganda,parachuted,violist,homogeneity,comix,fjords,corsairs,punted,verandahs,equilateral,laoghaire,magyars,117th,alesund,televoting,mayotte,eateries,refurbish,nswrl,yukio,caragiale,zetas,dispel,codecs,inoperable,outperformed,rejuvenation,elstree,modernise,contributory,pictou,tewkesbury,chechens,ashina,psionic,refutation,medico,overdubbed,nebulae,sandefjord,personages,eccellenza,businessperson,placename,abenaki,perryville,threshing,reshaped,arecibo,burslem,colspan=3|turnout,rebadged,lumia,erinsborough,interactivity,bitmap,indefatigable,theosophy,excitatory,gleizes,edsel,bermondsey,korce,saarinen,wazir,diyarbakir,cofounder,liberalisation,onsen,nighthawks,siting,retirements,semyon,d'histoire,114th,redditch,venetia,praha,'round,valdosta,hieroglyphic,postmedial,edirne,miscellany,savona,cockpits,minimization,coupler,jacksonian,appeasement,argentines,saurashtra,arkwright,hesiod,folios,fitzalan,publica,rivaled,civitas,beermen,constructivism,ribeira,zeitschrift,solanum,todos,deformities,chilliwack,verdean,meagre,bishoprics,gujrat,yangzhou,reentered,inboard,mythologies,virtus,unsurprisingly,rusticated,museu,symbolise,proportionate,thesaban,symbian,aeneid,mitotic,veliki,compressive,cisterns,abies,winemaker,massenet,bertolt,ahmednagar,triplemania,armorial,administracion,tenures,smokehouse,hashtag,fuerza,regattas,gennady,kanazawa,mahmudabad,crustal,asaph,valentinian,ilaiyaraaja,honeyeater,trapezoidal,cooperatively,unambiguously,mastodon,inhospitable,harnesses,riverton,renewables,djurgardens,haitians,airings,humanoids,boatswain,shijiazhuang,faints,veera,punjabis,steepest,narain,karlovy,serre,sulcus,collectives,1500m,arion,subarctic,liberally,apollonius,ostia,droplet,headstones,norra,robusta,maquis,veronese,imola,primers,luminance,escadrille,mizuki,irreconcilable,stalybridge,temur,paraffin,stuccoed,parthians,counsels,fundamentalists,vivendi,polymath,sugababes,mikko,yonne,fermions,vestfold,pastoralist,kigali,unseeded,glarus,cusps,amasya,northwesterly,minorca,astragalus,verney,trevelyan,antipathy,wollstonecraft,bivalves,boulez,royle,divisao,quranic,bareilly,coronal,deviates,lulea,erectus,petronas,chandan,proxies,aeroflot,postsynaptic,memoriam,moyne,gounod,kuznetsova,pallava,ordinating,reigate,'first,lewisburg,exploitative,danby,academica,bailiwick,brahe,injective,stipulations,aeschylus,computes,gulden,hydroxylase,liveries,somalis,underpinnings,muscovite,kongsberg,domus,overlain,shareware,variegated,jalalabad,agence,ciphertext,insectivores,dengeki,menuhin,cladistic,baerum,betrothal,tokushima,wavelet,expansionist,pottsville,siyuan,prerequisites,carpi,nemzeti,nazar,trialled,eliminator,irrorated,homeward,redwoods,undeterred,strayed,lutyens,multicellular,aurelian,notated,lordships,alsatian,idents,foggia,garros,chalukyas,lillestrom,podlaski,pessimism,hsien,demilitarized,whitewashed,willesden,kirkcaldy,sanctorum,lamia,relaying,escondido,paediatric,contemplates,demarcated,bluestone,betula,penarol,capitalise,kreuznach,kenora,115th,hold'em,reichswehr,vaucluse,m.i.a,windings,boys/girls,cajon,hisar,predictably,flemington,ysgol,mimicked,clivina,grahamstown,ionia,glyndebourne,patrese,aquaria,sleaford,dayal,sportscenter,malappuram,m.b.a.,manoa,carbines,solvable,designator,ramanujan,linearity,academicians,sayid,lancastrian,factorial,strindberg,vashem,delos,comyn,condensing,superdome,merited,kabaddi,intransitive,bideford,neuroimaging,duopoly,scorecards,ziggler,heriot,boyars,virology,marblehead,microtubules,westphalian,anticipates,hingham,searchers,harpist,rapides,morricone,convalescent,mises,nitride,metrorail,matterhorn,bicol,drivetrain,marketer,snippet,winemakers,muban,scavengers,halberstadt,herkimer,peten,laborious,stora,montgomeryshire,booklist,shamir,herault,eurostar,anhydrous,spacewalk,ecclesia,calliostoma,highschool,d'oro,suffusion,imparts,overlords,tagus,rectifier,counterinsurgency,ministered,eilean,milecastle,contre,micromollusk,okhotsk,bartoli,matroid,hasidim,thirunal,terme,tarlac,lashkar,presque,thameslink,flyby,troopship,renouncing,fatih,messrs,vexillum,bagration,magnetite,bornholm,androgynous,vehement,tourette,philosophic,gianfranco,tuileries,codice_6,radially,flexion,hants,reprocessing,setae,burne,palaeographically,infantryman,shorebirds,tamarind,moderna,threading,militaristic,crohn,norrkoping,125cc,stadtholder,troms,klezmer,alphanumeric,brome,emmanuelle,tiwari,alchemical,formula_52,onassis,bleriot,bipedal,colourless,hermeneutics,hosni,precipitating,turnstiles,hallucinogenic,panhellenic,wyandotte,elucidated,chita,ehime,generalised,hydrophilic,biota,niobium,rnzaf,gandhara,longueuil,logics,sheeting,bielsko,cuvier,kagyu,trefoil,docent,pancrase,stalinism,postures,encephalopathy,monckton,imbalances,epochs,leaguers,anzio,diminishes,pataki,nitrite,amuro,nabil,maybach,l'aquila,babbler,bacolod,thutmose,evora,gaudi,breakage,recur,preservative,60deg,mendip,functionaries,columnar,maccabiah,chert,verden,bromsgrove,clijsters,dengue,pastorate,phuoc,principia,viareggio,kharagpur,scharnhorst,anyang,bosons,l'art,criticises,ennio,semarang,brownian,mirabilis,asperger,calibers,typographical,cartooning,minos,disembark,supranational,undescribed,etymologically,alappuzha,vilhelm,lanao,pakenham,bhagavata,rakoczi,clearings,astrologers,manitowoc,bunuel,acetylene,scheduler,defamatory,trabzonspor,leaded,scioto,pentathlete,abrahamic,minigames,aldehydes,peerages,legionary,1640s,masterworks,loudness,bryansk,likeable,genocidal,vegetated,towpath,declination,pyrrhus,divinely,vocations,rosebery,associazione,loaders,biswas,oeste,tilings,xianzong,bhojpuri,annuities,relatedness,idolator,psers,constriction,chuvash,choristers,hanafi,fielders,grammarian,orpheum,asylums,millbrook,gyatso,geldof,stabilise,tableaux,diarist,kalahari,panini,cowdenbeath,melanin,4x100m,resonances,pinar,atherosclerosis,sheringham,castlereagh,aoyama,larks,pantograph,protrude,natak,gustafsson,moribund,cerevisiae,cleanly,polymeric,holkar,cosmonauts,underpinning,lithosphere,firuzabad,languished,mingled,citrate,spadina,lavas,daejeon,fibrillation,porgy,pineville,ps1000,cobbled,emamzadeh,mukhtar,dampers,indelible,salonika,nanoscale,treblinka,eilat,purporting,fluctuate,mesic,hagiography,cutscenes,fondation,barrens,comically,accrue,ibrox,makerere,defections,'there,hollandia,skene,grosseto,reddit,objectors,inoculation,rowdies,playfair,calligrapher,namor,sibenik,abbottabad,propellants,hydraulically,chloroplasts,tablelands,tecnico,schist,klasse,shirvan,bashkortostan,bullfighting,north/south,polski,hanns,woodblock,kilmore,ejecta,ignacy,nanchang,danubian,commendations,snohomish,samaritans,argumentation,vasconcelos,hedgehogs,vajrayana,barents,kulkarni,kumbakonam,identifications,hillingdon,weirs,nayanar,beauvoir,messe,divisors,atlantiques,broods,affluence,tegucigalpa,unsuited,autodesk,akash,princeps,culprits,kingstown,unassuming,goole,visayan,asceticism,blagojevich,irises,paphos,unsound,maurier,pontchartrain,desertification,sinfonietta,latins,especial,limpet,valerenga,glial,brainstem,mitral,parables,sauropod,judean,iskcon,sarcoma,venlo,justifications,zhuhai,blavatsky,alleviated,usafe,steppenwolf,inversions,janko,chagall,secretory,basildon,saguenay,pergamon,hemispherical,harmonized,reloading,franjo,domaine,extravagance,relativism,metamorphosed,labuan,baloncesto,gmail,byproducts,calvinists,counterattacked,vitus,bubonic,120th,strachey,ritually,brookwood,selectable,savinja,incontinence,meltwater,jinja,1720s,brahmi,morgenthau,sheaves,sleeved,stratovolcano,wielki,utilisation,avoca,fluxus,panzergrenadier,philately,deflation,podlaska,prerogatives,kuroda,theophile,zhongzong,gascoyne,magus,takao,arundell,fylde,merdeka,prithviraj,venkateswara,liepaja,daigo,dreamland,reflux,sunnyvale,coalfields,seacrest,soldering,flexor,structuralism,alnwick,outweighed,unaired,mangeshkar,batons,glaad,banshees,irradiated,organelles,biathlete,cabling,chairlift,lollapalooza,newsnight,capacitive,succumbs,flatly,miramichi,burwood,comedienne,charteris,biotic,workspace,aficionados,sokolka,chatelet,o'shaughnessy,prosthesis,neoliberal,refloated,oppland,hatchlings,econometrics,loess,thieu,androids,appalachians,jenin,pterostichinae,downsized,foils,chipsets,stencil,danza,narrate,maginot,yemenite,bisects,crustacean,prescriptive,melodious,alleviation,empowers,hansson,autodromo,obasanjo,osmosis,daugava,rheumatism,moraes,leucine,etymologies,chepstow,delaunay,bramall,bajaj,flavoring,approximates,marsupials,incisive,microcomputer,tactically,waals,wilno,fisichella,ursus,hindmarsh,mazarin,lomza,xenophobia,lawlessness,annecy,wingers,gornja,gnaeus,superieur,tlaxcala,clasps,symbolises,slats,rightist,effector,blighted,permanence,divan,progenitors,kunsthalle,anointing,excelling,coenzyme,indoctrination,dnipro,landholdings,adriaan,liturgies,cartan,ethmia,attributions,sanctus,trichy,chronicon,tancred,affinis,kampuchea,gantry,pontypool,membered,distrusted,fissile,dairies,hyposmocoma,craigie,adarsh,martinsburg,taxiway,30deg,geraint,vellum,bencher,khatami,formula_53,zemun,teruel,endeavored,palmares,pavements,u.s..,internationalization,satirized,carers,attainable,wraparound,muang,parkersburg,extinctions,birkenfeld,wildstorm,payers,cohabitation,unitas,culloden,capitalizing,clwyd,daoist,campinas,emmylou,orchidaceae,halakha,orientales,fealty,domnall,chiefdom,nigerians,ladislav,dniester,avowed,ergonomics,newsmagazine,kitsch,cantilevered,benchmarking,remarriage,alekhine,coldfield,taupo,almirante,substations,apprenticeships,seljuq,levelling,eponym,symbolising,salyut,opioids,underscore,ethnologue,mohegan,marikina,libro,bassano,parse,semantically,disjointed,dugdale,padraig,tulsi,modulating,xfinity,headlands,mstislav,earthworms,bourchier,lgbtq,embellishments,pennants,rowntree,betel,motet,mulla,catenary,washoe,mordaunt,dorking,colmar,girardeau,glentoran,grammatically,samad,recreations,technion,staccato,mikoyan,spoilers,lyndhurst,victimization,chertsey,belafonte,tondo,tonsberg,narrators,subcultures,malformations,edina,augmenting,attests,euphemia,cabriolet,disguising,1650s,navarrese,demoralized,cardiomyopathy,welwyn,wallachian,smoothness,planktonic,voles,issuers,sardasht,survivability,cuauhtemoc,thetis,extruded,signet,raghavan,lombok,eliyahu,crankcase,dissonant,stolberg,trencin,desktops,bursary,collectivization,charlottenburg,triathlete,curvilinear,involuntarily,mired,wausau,invades,sundaram,deletions,bootstrap,abellio,axiomatic,noguchi,setups,malawian,visalia,materialist,kartuzy,wenzong,plotline,yeshivas,parganas,tunica,citric,conspecific,idlib,superlative,reoccupied,blagoevgrad,masterton,immunological,hatta,courbet,vortices,swallowtail,delves,haridwar,diptera,boneh,bahawalpur,angering,mardin,equipments,deployable,guanine,normality,rimmed,artisanal,boxset,chandrasekhar,jools,chenar,tanakh,carcassonne,belatedly,millville,anorthosis,reintegration,velde,surfactant,kanaan,busoni,glyphipterix,personas,fullness,rheims,tisza,stabilizers,bharathi,joost,spinola,mouldings,perching,esztergom,afzal,apostate,lustre,s.league,motorboat,monotheistic,armature,barat,asistencia,bloomsburg,hippocampal,fictionalised,defaults,broch,hexadecimal,lusignan,ryanair,boccaccio,breisgau,southbank,bskyb,adjoined,neurobiology,aforesaid,sadhu,langue,headship,wozniacki,hangings,regulus,prioritized,dynamism,allier,hannity,shimin,antoninus,gymnopilus,caledon,preponderance,melayu,electrodynamics,syncopated,ibises,krosno,mechanistic,morpeth,harbored,albini,monotheism,'real,hyperactivity,haveli,writer/director,minato,nimoy,caerphilly,chitral,amirabad,fanshawe,l'oreal,lorde,mukti,authoritarianism,valuing,spyware,hanbury,restarting,stato,embed,suiza,empiricism,stabilisation,stari,castlemaine,orbis,manufactory,mauritanian,shoji,taoyuan,prokaryotes,oromia,ambiguities,embodying,slims,frente,innovate,ojibwa,powdery,gaeltacht,argentinos,quatermass,detergents,fijians,adaptor,tokai,chileans,bulgars,oxidoreductases,bezirksliga,conceicao,myosin,nellore,500cc,supercomputers,approximating,glyndwr,polypropylene,haugesund,cockerell,tudman,ashbourne,hindemith,bloodlines,rigveda,etruria,romanos,steyn,oradea,deceleration,manhunter,laryngeal,fraudulently,janez,wendover,haplotype,janaki,naoki,belizean,mellencamp,cartographic,sadhana,tricolour,pseudoscience,satara,bytow,s.p.a.,jagdgeschwader,arcot,omagh,sverdrup,masterplan,surtees,apocrypha,ahvaz,d'amato,socratic,leumit,unnumbered,nandini,witold,marsupial,coalesced,interpolated,gimnasia,karadzic,keratin,mamoru,aldeburgh,speculator,escapement,irfan,kashyap,satyajit,haddington,solver,rothko,ashkelon,kickapoo,yeomen,superbly,bloodiest,greenlandic,lithic,autofocus,yardbirds,poona,keble,javan,sufis,expandable,tumblr,ursuline,swimwear,winwood,counsellors,aberrations,marginalised,befriending,workouts,predestination,varietal,siddhartha,dunkeld,judaic,esquimalt,shabab,ajith,telefonica,stargard,hoysala,radhakrishnan,sinusoidal,strada,hiragana,cebuano,monoid,independencia,floodwaters,mildura,mudflats,ottokar,translit,radix,wigner,philosophically,tephritid,synthesizing,castletown,installs,stirner,resettle,bushfire,choirmaster,kabbalistic,shirazi,lightship,rebus,colonizers,centrifuge,leonean,kristofferson,thymus,clackamas,ratnam,rothesay,municipally,centralia,thurrock,gulfport,bilinear,desirability,merite,psoriasis,macaw,erigeron,consignment,mudstone,distorting,karlheinz,ramen,tailwheel,vitor,reinsurance,edifices,superannuation,dormancy,contagion,cobden,rendezvoused,prokaryotic,deliberative,patricians,feigned,degrades,starlings,sopot,viticultural,beaverton,overflowed,convener,garlands,michiel,ternopil,naturelle,biplanes,bagot,gamespy,ventspils,disembodied,flattening,profesional,londoners,arusha,scapular,forestall,pyridine,ulema,eurodance,aruna,callus,periodontal,coetzee,immobilized,o'meara,maharani,katipunan,reactants,zainab,microgravity,saintes,britpop,carrefour,constrain,adversarial,firebirds,brahmo,kashima,simca,surety,surpluses,superconductivity,gipuzkoa,cumans,tocantins,obtainable,humberside,roosting,'king,formula_54,minelayer,bessel,sulayman,cycled,biomarkers,annealing,shusha,barda,cassation,djing,polemics,tuple,directorates,indomitable,obsolescence,wilhelmine,pembina,bojan,tambo,dioecious,pensioner,magnificat,1660s,estrellas,southeasterly,immunodeficiency,railhead,surreptitiously,codeine,encores,religiosity,tempera,camberley,efendi,boardings,malleable,hagia,input/output,lucasfilm,ujjain,polymorphisms,creationist,berners,mickiewicz,irvington,linkedin,endures,kinect,munition,apologetics,fairlie,predicated,reprinting,ethnographer,variances,levantine,mariinsky,jadid,jarrow,asia/oceania,trinamool,waveforms,bisexuality,preselection,pupae,buckethead,hieroglyph,lyricists,marionette,dunbartonshire,restorer,monarchical,pazar,kickoffs,cabildo,savannas,gliese,dench,spoonbills,novelette,diliman,hypersensitivity,authorising,montefiore,mladen,qu'appelle,theistic,maruti,laterite,conestoga,saare,californica,proboscis,carrickfergus,imprecise,hadassah,baghdadi,jolgeh,deshmukh,amusements,heliopolis,berle,adaptability,partenkirchen,separations,baikonur,cardamom,southeastward,southfield,muzaffar,adequacy,metropolitana,rajkot,kiyoshi,metrobus,evictions,reconciles,librarianship,upsurge,knightley,badakhshan,proliferated,spirituals,burghley,electroacoustic,professing,featurette,reformists,skylab,descriptors,oddity,greyfriars,injects,salmond,lanzhou,dauntless,subgenera,underpowered,transpose,mahinda,gatos,aerobatics,seaworld,blocs,waratahs,joris,giggs,perfusion,koszalin,mieczyslaw,ayyubid,ecologists,modernists,sant'angelo,quicktime,him/her,staves,sanyo,melaka,acrocercops,qigong,iterated,generalizes,recuperation,vihara,circassians,psychical,chavo,memoires,infiltrates,notaries,pelecaniformesfamily,strident,chivalric,pierrepont,alleviating,broadsides,centipede,b.tech,reinterpreted,sudetenland,hussite,covenanters,radhika,ironclads,gainsbourg,testis,penarth,plantar,azadegan,beano,espn.com,leominster,autobiographies,nbcuniversal,eliade,khamenei,montferrat,undistinguished,ethnological,wenlock,fricatives,polymorphic,biome,joule,sheaths,astrophysicist,salve,neoclassicism,lovat,downwind,belisarius,forma,usurpation,freie,depopulation,backbench,ascenso,'high,aagpbl,gdanski,zalman,mouvement,encapsulation,bolshevism,statny,voyageurs,hywel,vizcaya,mazra'eh,narthex,azerbaijanis,cerebrospinal,mauretania,fantail,clearinghouse,bolingbroke,pequeno,ansett,remixing,microtubule,wrens,jawahar,palembang,gambian,hillsong,fingerboard,repurposed,sundry,incipient,veolia,theologically,ulaanbaatar,atsushi,foundling,resistivity,myeloma,factbook,mazowiecka,diacritic,urumqi,clontarf,provokes,intelsat,professes,materialise,portobello,benedictines,panionios,introverted,reacquired,bridport,mammary,kripke,oratorios,vlore,stoning,woredas,unreported,antti,togolese,fanzines,heuristics,conservatories,carburetors,clitheroe,cofounded,formula_57,erupting,quinnipiac,bootle,ghostface,sittings,aspinall,sealift,transferase,boldklub,siskiyou,predominated,francophonie,ferruginous,castrum,neogene,sakya,madama,precipitous,'love,posix,bithynia,uttara,avestan,thrushes,seiji,memorably,septimius,libri,cibernetico,hyperinflation,dissuaded,cuddalore,peculiarity,vaslui,grojec,albumin,thurles,casks,fasteners,fluidity,buble,casals,terek,gnosticism,cognates,ulnar,radwanska,babylonians,majuro,oxidizer,excavators,rhythmically,liffey,gorakhpur,eurydice,underscored,arborea,lumumba,tuber,catholique,grama,galilei,scrope,centreville,jacobin,bequests,ardeche,polygamous,montauban,terai,weatherboard,readability,attainder,acraea,transversely,rivets,winterbottom,reassures,bacteriology,vriesea,chera,andesite,dedications,homogenous,reconquered,bandon,forrestal,ukiyo,gurdjieff,tethys,sparc,muscogee,grebes,belchatow,mansa,blantyre,palliser,sokolow,fibroblasts,exmoor,misaki,soundscapes,housatonic,middelburg,convenor,leyla,antipope,histidine,okeechobee,alkenes,sombre,alkene,rubik,macaques,calabar,trophee,pinchot,'free,frusciante,chemins,falaise,vasteras,gripped,schwarzenberg,cumann,kanchipuram,acoustically,silverbacks,fangio,inset,plympton,kuril,vaccinations,recep,theropods,axils,stavropol,encroached,apoptotic,papandreou,wailers,moonstone,assizes,micrometers,hornchurch,truncation,annapurna,egyptologists,rheumatic,promiscuity,satiric,fleche,caloptilia,anisotropy,quaternions,gruppo,viscounts,awardees,aftershocks,sigint,concordance,oblasts,gaumont,stent,commissars,kesteven,hydroxy,vijayanagar,belorussian,fabricius,watermark,tearfully,mamet,leukaemia,sorkh,milepost,tattooing,vosta,abbasids,uncompleted,hedong,woodwinds,extinguishing,malus,multiplexes,francoist,pathet,responsa,bassists,'most,postsecondary,ossory,grampian,saakashvili,alito,strasberg,impressionistic,volador,gelatinous,vignette,underwing,campanian,abbasabad,albertville,hopefuls,nieuwe,taxiways,reconvened,recumbent,pathologists,unionized,faversham,asymptotically,romulo,culling,donja,constricted,annesley,duomo,enschede,lovech,sharpshooter,lansky,dhamma,papillae,alanine,mowat,delius,wrest,mcluhan,podkarpackie,imitators,bilaspur,stunting,pommel,casemate,handicaps,nagas,testaments,hemings,necessitate,rearward,locative,cilla,klitschko,lindau,merion,consequential,antic,soong,copula,berthing,chevrons,rostral,sympathizer,budokan,ranulf,beria,stilt,replying,conflated,alcibiades,painstaking,yamanashi,calif.,arvid,ctesiphon,xizong,rajas,caxton,downbeat,resurfacing,rudders,miscegenation,deathmatch,foregoing,arthropod,attestation,karts,reapportionment,harnessing,eastlake,schola,dosing,postcolonial,imtiaz,formula_55,insulators,gunung,accumulations,pampas,llewelyn,bahnhof,cytosol,grosjean,teaneck,briarcliff,arsenio,canara,elaborating,passchendaele,searchlights,holywell,mohandas,preventable,gehry,mestizos,ustinov,cliched,'national,heidfeld,tertullian,jihadist,tourer,miletus,semicircle,outclassed,bouillon,cardinalate,clarifies,dakshina,bilayer,pandyan,unrwa,chandragupta,formula_56,portola,sukumaran,lactation,islamia,heikki,couplers,misappropriation,catshark,montt,ploughs,carib,stator,leaderboard,kenrick,dendrites,scape,tillamook,molesworth,mussorgsky,melanesia,restated,troon,glycoside,truckee,headwater,mashup,sectoral,gangwon,docudrama,skirting,psychopathology,dramatised,ostroleka,infestations,thabo,depolarization,wideroe,eisenbahn,thomond,kumaon,upendra,foreland,acronyms,yaqui,retaking,raphaelite,specie,dupage,villars,lucasarts,chloroplast,werribee,balsa,ascribe,havant,flava,khawaja,tyumen,subtract,interrogators,reshaping,buzzcocks,eesti,campanile,potemkin,apertures,snowboarder,registrars,handbooks,boyar,contaminant,depositors,proximate,jeunesse,zagora,pronouncements,mists,nihilism,deified,margraviate,pietersen,moderators,amalfi,adjectival,copepods,magnetosphere,pallets,clemenceau,castra,perforation,granitic,troilus,grzegorz,luthier,dockyards,antofagasta,ffestiniog,subroutine,afterword,waterwheel,druce,nitin,undifferentiated,emacs,readmitted,barneveld,tapers,hittites,infomercials,infirm,braathens,heligoland,carpark,geomagnetic,musculoskeletal,nigerien,machinima,harmonize,repealing,indecency,muskoka,verite,steubenville,suffixed,cytoskeleton,surpasses,harmonia,imereti,ventricles,heterozygous,envisions,otsego,ecoles,warrnambool,burgenland,seria,rawat,capistrano,welby,kirin,enrollments,caricom,dragonlance,schaffhausen,expanses,photojournalism,brienne,etude,referent,jamtland,schemas,xianbei,cleburne,bicester,maritima,shorelines,diagonals,bjelke,nonpublic,aliasing,m.f.a,ovals,maitreya,skirmishing,grothendieck,sukhothai,angiotensin,bridlington,durgapur,contras,gakuen,skagit,rabbinate,tsunamis,haphazard,tyldesley,microcontroller,discourages,hialeah,compressing,septimus,larvik,condoleezza,psilocybin,protectionism,songbirds,clandestinely,selectmen,wargame,cinemascope,khazars,agronomy,melzer,latifah,cherokees,recesses,assemblymen,basescu,banaras,bioavailability,subchannels,adenine,o'kelly,prabhakar,leonese,dimethyl,testimonials,geoffroy,oxidant,universiti,gheorghiu,bohdan,reversals,zamorin,herbivore,jarre,sebastiao,infanterie,dolmen,teddington,radomsko,spaceships,cuzco,recapitulation,mahoning,bainimarama,myelin,aykroyd,decals,tokelau,nalgonda,rajasthani,121st,quelled,tambov,illyrians,homilies,illuminations,hypertrophy,grodzisk,inundation,incapacity,equilibria,combats,elihu,steinitz,berengar,gowda,canwest,khosrau,maculata,houten,kandinsky,onside,leatherhead,heritable,belvidere,federative,chukchi,serling,eruptive,patan,entitlements,suffragette,evolutions,migrates,demobilisation,athleticism,trope,sarpsborg,kensal,translink,squamish,concertgebouw,energon,timestamp,competences,zalgiris,serviceman,codice_7,spoofing,assange,mahadevan,skien,suceava,augustan,revisionism,unconvincing,hollande,drina,gottlob,lippi,broglie,darkening,tilapia,eagerness,nacht,kolmogorov,photometric,leeuwarden,jrotc,haemorrhage,almanack,cavalli,repudiation,galactose,zwickau,cetinje,houbraken,heavyweights,gabonese,ordinals,noticias,museveni,steric,charaxes,amjad,resection,joinville,leczyca,anastasius,purbeck,subtribe,dalles,leadoff,monoamine,jettisoned,kaori,anthologized,alfreton,indic,bayezid,tottori,colonizing,assassinating,unchanging,eusebian,d'estaing,tsingtao,toshio,transferases,peronist,metrology,equus,mirpur,libertarianism,kovil,indole,'green,abstention,quantitatively,icebreakers,tribals,mainstays,dryandra,eyewear,nilgiri,chrysanthemum,inositol,frenetic,merchantman,hesar,physiotherapist,transceiver,dancefloor,rankine,neisse,marginalization,lengthen,unaided,rework,pageantry,savio,striated,funen,witton,illuminates,frass,hydrolases,akali,bistrita,copywriter,firings,handballer,tachinidae,dmytro,coalesce,neretva,menem,moraines,coatbridge,crossrail,spoofed,drosera,ripen,protour,kikuyu,boleslav,edwardes,troubadours,haplogroups,wrasse,educationalist,sroda,khaneh,dagbladet,apennines,neuroscientist,deplored,terje,maccabees,daventry,spaceport,lessening,ducats,singer/guitarist,chambersburg,yeong,configurable,ceremonially,unrelenting,caffe,graaf,denizens,kingsport,ingush,panhard,synthesised,tumulus,homeschooled,bozorg,idiomatic,thanhouser,queensway,radek,hippolytus,inking,banovina,peacocks,piaui,handsworth,pantomimes,abalone,thera,kurzweil,bandura,augustinians,bocelli,ferrol,jiroft,quadrature,contravention,saussure,rectification,agrippina,angelis,matanzas,nidaros,palestrina,latium,coriolis,clostridium,ordain,uttering,lanchester,proteolytic,ayacucho,merseburg,holbein,sambalpur,algebraically,inchon,ostfold,savoia,calatrava,lahiri,judgeship,ammonite,masaryk,meyerbeer,hemorrhagic,superspeedway,ningxia,panicles,encircles,khmelnytsky,profusion,esher,babol,inflationary,anhydride,gaspe,mossy,periodicity,nacion,meteorologists,mahjong,interventional,sarin,moult,enderby,modell,palgrave,warners,montcalm,siddha,functionalism,rilke,politicized,broadmoor,kunste,orden,brasileira,araneta,eroticism,colquhoun,mamba,blacktown,tubercle,seagrass,manoel,camphor,neoregelia,llandudno,annexe,enplanements,kamien,plovers,statisticians,iturbide,madrasah,nontrivial,publican,landholders,manama,uninhabitable,revivalist,trunkline,friendliness,gurudwara,rocketry,unido,tripos,besant,braque,evolutionarily,abkhazian,staffel,ratzinger,brockville,bohemond,intercut,djurgarden,utilitarianism,deploys,sastri,absolutism,subhas,asghar,fictions,sepinwall,proportionately,titleholders,thereon,foursquare,machinegun,knightsbridge,siauliai,aqaba,gearboxes,castaways,weakens,phallic,strzelce,buoyed,ruthenia,pharynx,intractable,neptunes,koine,leakey,netherlandish,preempted,vinay,terracing,instigating,alluvium,prosthetics,vorarlberg,politiques,joinery,reduplication,nebuchadnezzar,lenticular,banka,seaborne,pattinson,helpline,aleph,beckenham,californians,namgyal,franziska,aphid,branagh,transcribe,appropriateness,surakarta,takings,propagates,juraj,b0d3fb,brera,arrayed,tailback,falsehood,hazleton,prosody,egyptology,pinnate,tableware,ratan,camperdown,ethnologist,tabari,classifiers,biogas,126th,kabila,arbitron,apuestas,membranous,kincardine,oceana,glories,natick,populism,synonymy,ghalib,mobiles,motherboards,stationers,germinal,patronised,formula_58,gaborone,torts,jeezy,interleague,novaya,batticaloa,offshoots,wilbraham,filename,nswrfl,'well,trilobite,pythons,optimally,scientologists,rhesus,pilsen,backdrops,batang,unionville,hermanos,shrikes,fareham,outlawing,discontinuing,boisterous,shamokin,scanty,southwestward,exchangers,unexpired,mewar,h.m.s,saldanha,pawan,condorcet,turbidity,donau,indulgences,coincident,cliques,weeklies,bardhaman,violators,kenai,caspase,xperia,kunal,fistula,epistemic,cammell,nephi,disestablishment,rotator,germaniawerft,pyaar,chequered,jigme,perlis,anisotropic,popstars,kapil,appendices,berat,defecting,shacks,wrangel,panchayath,gorna,suckling,aerosols,sponheim,talal,borehole,encodings,enlai,subduing,agong,nadar,kitsap,syrmia,majumdar,pichilemu,charleville,embryology,booting,literati,abutting,basalts,jussi,repubblica,hertogenbosch,digitization,relents,hillfort,wiesenthal,kirche,bhagwan,bactrian,oases,phyla,neutralizing,helsing,ebooks,spearheading,margarine,'golden,phosphor,picea,stimulants,outliers,timescale,gynaecology,integrator,skyrocketed,bridgnorth,senecio,ramachandra,suffragist,arrowheads,aswan,inadvertent,microelectronics,118th,sofer,kubica,melanesian,tuanku,balkh,vyborg,crystallographic,initiators,metamorphism,ginzburg,looters,unimproved,finistere,newburyport,norges,immunities,franchisees,asterism,kortrijk,camorra,komsomol,fleurs,draughts,patagonian,voracious,artin,collaborationist,revolucion,revitalizing,xaver,purifying,antipsychotic,disjunct,pompeius,dreamwave,juvenal,beinn,adiyaman,antitank,allama,boletus,melanogaster,dumitru,caproni,aligns,athabaskan,stobart,phallus,veikkausliiga,hornsey,buffering,bourbons,dobruja,marga,borax,electrics,gangnam,motorcyclist,whidbey,draconian,lodger,galilean,sanctification,imitates,boldness,underboss,wheatland,cantabrian,terceira,maumee,redefining,uppercase,ostroda,characterise,universalism,equalized,syndicalism,haringey,masovia,deleuze,funkadelic,conceals,thuan,minsky,pluralistic,ludendorff,beekeeping,bonfires,endoscopic,abuts,prebend,jonkoping,amami,tribunes,yup'ik,awadh,gasification,pforzheim,reforma,antiwar,vaishnavism,maryville,inextricably,margrethe,empresa,neutrophils,sanctified,ponca,elachistidae,curiae,quartier,mannar,hyperplasia,wimax,busing,neologism,florins,underrepresented,digitised,nieuw,cooch,howards,frege,hughie,plied,swale,kapellmeister,vajpayee,quadrupled,aeronautique,dushanbe,custos,saltillo,kisan,tigray,manaus,epigrams,shamanic,peppered,frosts,promotion/relegation,concedes,zwingli,charentes,whangarei,hyung,spring/summer,sobre,eretz,initialization,sawai,ephemera,grandfathered,arnaldo,customised,permeated,parapets,growths,visegrad,estudios,altamont,provincia,apologises,stoppard,carburettor,rifts,kinematic,zhengzhou,eschatology,prakrit,folate,yvelines,scapula,stupas,rishon,reconfiguration,flutist,1680s,apostolate,proudhon,lakshman,articulating,stortford,faithfull,bitterns,upwelling,qur'anic,lidar,interferometry,waterlogged,koirala,ditton,wavefunction,fazal,babbage,antioxidants,lemberg,deadlocked,tolled,ramapo,mathematica,leiria,topologies,khali,photonic,balti,1080p,corrects,recommenced,polyglot,friezes,tiebreak,copacabana,cholmondeley,armband,abolishment,sheamus,buttes,glycolysis,cataloged,warrenton,sassari,kishan,foodservice,cryptanalysis,holmenkollen,cosplay,machi,yousuf,mangal,allying,fertiliser,otomi,charlevoix,metallurg,parisians,bottlenose,oakleigh,debug,cidade,accede,ligation,madhava,pillboxes,gatefold,aveyron,sorin,thirsk,immemorial,menelik,mehra,domingos,underpinned,fleshed,harshness,diphthong,crestwood,miskolc,dupri,pyrausta,muskingum,tuoba,prodi,incidences,waynesboro,marquesas,heydar,artesian,calinescu,nucleation,funders,covalently,compaction,derbies,seaters,sodor,tabular,amadou,peckinpah,o'halloran,zechariah,libyans,kartik,daihatsu,chandran,erzhu,heresies,superheated,yarder,dorde,tanjore,abusers,xuanwu,juniperus,moesia,trusteeship,birdwatching,beatz,moorcock,harbhajan,sanga,choreographic,photonics,boylston,amalgamate,prawns,electrifying,sarath,inaccurately,exclaims,powerpoint,chaining,cpusa,adulterous,saccharomyces,glogow,vfl/afl,syncretic,simla,persisting,functors,allosteric,euphorbiaceae,juryo,mlada,moana,gabala,thornycroft,kumanovo,ostrovsky,sitio,tutankhamun,sauropods,kardzhali,reinterpretation,sulpice,rosyth,originators,halesowen,delineation,asesoria,abatement,gardai,elytra,taillights,overlays,monsoons,sandpipers,ingmar,henrico,inaccuracy,irwell,arenabowl,elche,pressburg,signalman,interviewees,sinkhole,pendle,ecommerce,cellos,nebria,organometallic,surrealistic,propagandist,interlaken,canandaigua,aerials,coutinho,pascagoula,tonopah,letterkenny,gropius,carbons,hammocks,childe,polities,hosiery,donitz,suppresses,diaghilev,stroudsburg,bagram,pistoia,regenerating,unitarians,takeaway,offstage,vidin,glorification,bakunin,yavapai,lutzow,sabercats,witney,abrogated,gorlitz,validating,dodecahedron,stubbornly,telenor,glaxosmithkline,solapur,undesired,jellicoe,dramatization,four-and-a-half,seawall,waterpark,artaxerxes,vocalization,typographic,byung,sachsenhausen,shepparton,kissimmee,konnan,belsen,dhawan,khurd,mutagenesis,vejle,perrot,estradiol,formula_60,saros,chiloe,misiones,lamprey,terrains,speke,miasto,eigenvectors,haydock,reservist,corticosteroids,savitri,shinawatra,developmentally,yehudi,berates,janissaries,recapturing,rancheria,subplots,gresley,nikkatsu,oryol,cosmas,boavista,formula_59,playfully,subsections,commentated,kathakali,dorid,vilaine,seepage,hylidae,keiji,kazakhs,triphosphate,1620s,supersede,monarchists,falla,miyako,notching,bhumibol,polarizing,secularized,shingled,bronislaw,lockerbie,soleyman,bundesbahn,latakia,redoubts,boult,inwardly,invents,ondrej,minangkabau,newquay,permanente,alhaji,madhav,malini,ellice,bookmaker,mankiewicz,etihad,o'dea,interrogative,mikawa,wallsend,canisius,bluesy,vitruvius,noord,ratifying,mixtec,gujranwala,subprefecture,keelung,goiania,nyssa,shi'ite,semitone,ch'uan,computerised,pertuan,catapults,nepomuk,shruti,millstones,buskerud,acolytes,tredegar,sarum,armia,dell'arte,devises,custodians,upturned,gallaudet,disembarking,thrashed,sagrada,myeon,undeclared,qumran,gaiden,tepco,janesville,showground,condense,chalon,unstaffed,pasay,undemocratic,hauts,viridis,uninjured,escutcheon,gymkhana,petaling,hammam,dislocations,tallaght,rerum,shias,indios,guaranty,simplicial,benares,benediction,tajiri,prolifically,huawei,onerous,grantee,ferencvaros,otranto,carbonates,conceit,digipak,qadri,masterclasses,swamiji,cradock,plunket,helmsman,119th,salutes,tippecanoe,murshidabad,intelligibility,mittal,diversifying,bidar,asansol,crowdsourcing,rovere,karakoram,grindcore,skylights,tulagi,furrows,ligne,stuka,sumer,subgraph,amata,regionalist,bulkeley,teletext,glorify,readied,lexicographer,sabadell,predictability,quilmes,phenylalanine,bandaranaike,pyrmont,marksmen,quisling,viscountess,sociopolitical,afoul,pediments,swazi,martyrology,nullify,panagiotis,superconductors,veldenz,jujuy,l'isle,hematopoietic,shafi,subsea,hattiesburg,jyvaskyla,kebir,myeloid,landmine,derecho,amerindians,birkenau,scriabin,milhaud,mucosal,nikaya,freikorps,theoretician,proconsul,o'hanlon,clerked,bactria,houma,macular,topologically,shrubby,aryeh,ghazali,afferent,magalhaes,moduli,ashtabula,vidarbha,securitate,ludwigsburg,adoor,varun,shuja,khatun,chengde,bushels,lascelles,professionnelle,elfman,rangpur,unpowered,citytv,chojnice,quaternion,stokowski,aschaffenburg,commutes,subramaniam,methylene,satrap,gharb,namesakes,rathore,helier,gestational,heraklion,colliers,giannis,pastureland,evocation,krefeld,mahadeva,churchmen,egret,yilmaz,galeazzo,pudukkottai,artigas,generalitat,mudslides,frescoed,enfeoffed,aphorisms,melilla,montaigne,gauliga,parkdale,mauboy,linings,prema,sapir,xylophone,kushan,rockne,sequoyah,vasyl,rectilinear,vidyasagar,microcosm,san'a,carcinogen,thicknesses,aleut,farcical,moderating,detested,hegemonic,instalments,vauban,verwaltungsgemeinschaft,picayune,razorback,magellanic,moluccas,pankhurst,exportation,waldegrave,sufferer,bayswater,1up.com,rearmament,orangutans,varazdin,b.o.b,elucidate,harlingen,erudition,brankovic,lapis,slipway,urraca,shinde,unwell,elwes,euboea,colwyn,srivijaya,grandstands,hortons,generalleutnant,fluxes,peterhead,gandhian,reals,alauddin,maximized,fairhaven,endow,ciechanow,perforations,darters,panellist,manmade,litigants,exhibitor,tirol,caracalla,conformance,hotelier,stabaek,hearths,borac,frisians,ident,veliko,emulators,schoharie,uzbeks,samarra,prestwick,wadia,universita,tanah,bucculatrix,predominates,genotypes,denounces,roadsides,ganassi,keokuk,philatelist,tomic,ingots,conduits,samplers,abdus,johar,allegories,timaru,wolfpacks,secunda,smeaton,sportivo,inverting,contraindications,whisperer,moradabad,calamities,bakufu,soundscape,smallholders,nadeem,crossroad,xenophobic,zakir,nationalliga,glazes,retroflex,schwyz,moroder,rubra,quraysh,theodoros,endemol,infidels,km/hr,repositioned,portraitist,lluis,answerable,arges,mindedness,coarser,eyewall,teleported,scolds,uppland,vibraphone,ricoh,isenburg,bricklayer,cuttlefish,abstentions,communicable,cephalopod,stockyards,balto,kinston,armbar,bandini,elphaba,maxims,bedouins,sachsen,friedkin,tractate,pamir,ivanovo,mohini,kovalainen,nambiar,melvyn,orthonormal,matsuyama,cuernavaca,veloso,overstated,streamer,dravid,informers,analyte,sympathized,streetscape,gosta,thomasville,grigore,futuna,depleting,whelks,kiedis,armadale,earner,wynyard,dothan,animating,tridentine,sabri,immovable,rivoli,ariege,parley,clinker,circulates,junagadh,fraunhofer,congregants,180th,buducnost,formula_62,olmert,dedekind,karnak,bayernliga,mazes,sandpiper,ecclestone,yuvan,smallmouth,decolonization,lemmy,adjudicated,retiro,legia,benue,posit,acidification,wahab,taconic,floatplane,perchlorate,atria,wisbech,divestment,dallara,phrygia,palustris,cybersecurity,rebates,facie,mineralogical,substituent,proteges,fowey,mayenne,smoothbore,cherwell,schwarzschild,junin,murrumbidgee,smalltalk,d'orsay,emirati,calaveras,titusville,theremin,vikramaditya,wampanoag,burra,plaines,onegin,emboldened,whampoa,langa,soderbergh,arnaz,sowerby,arendal,godunov,pathanamthitta,damselfly,bestowing,eurosport,iconoclasm,outfitters,acquiesced,badawi,hypotension,ebbsfleet,annulus,sohrab,thenceforth,chagatai,necessitates,aulus,oddities,toynbee,uniontown,innervation,populaire,indivisible,rossellini,minuet,cyrene,gyeongju,chania,cichlids,harrods,1690s,plunges,abdullahi,gurkhas,homebuilt,sortable,bangui,rediff,incrementally,demetrios,medaille,sportif,svend,guttenberg,tubules,carthusian,pleiades,torii,hoppus,phenyl,hanno,conyngham,teschen,cronenberg,wordless,melatonin,distinctiveness,autos,freising,xuanzang,dunwich,satanism,sweyn,predrag,contractually,pavlovic,malaysians,micrometres,expertly,pannonian,abstaining,capensis,southwesterly,catchphrases,commercialize,frankivsk,normanton,hibernate,verso,deportees,dubliners,codice_8,condors,zagros,glosses,leadville,conscript,morrisons,usury,ossian,oulton,vaccinium,civet,ayman,codrington,hadron,nanometers,geochemistry,extractor,grigori,tyrrhenian,neocollyris,drooping,falsification,werft,courtauld,brigantine,orhan,chapultepec,supercopa,federalized,praga,havering,encampments,infallibility,sardis,pawar,undirected,reconstructionist,ardrossan,varuna,pastimes,archdiocesan,fledging,shenhua,molise,secondarily,stagnated,replicates,ciencias,duryodhana,marauding,ruislip,ilyich,intermixed,ravenswood,shimazu,mycorrhizal,icosahedral,consents,dunblane,follicular,pekin,suffield,muromachi,kinsale,gauche,businesspeople,thereto,watauga,exaltation,chelmno,gorse,proliferate,drainages,burdwan,kangra,transducers,inductor,duvalier,maguindanao,moslem,uncaf,givenchy,plantarum,liturgics,telegraphs,lukashenko,chenango,andante,novae,ironwood,faubourg,torme,chinensis,ambala,pietermaritzburg,virginians,landform,bottlenecks,o'driscoll,darbhanga,baptistery,ameer,needlework,naperville,auditoriums,mullingar,starrer,animatronic,topsoil,madura,cannock,vernet,santurce,catocala,ozeki,pontevedra,multichannel,sundsvall,strategists,medio,135th,halil,afridi,trelawny,caloric,ghraib,allendale,hameed,ludwigshafen,spurned,pavlo,palmar,strafed,catamarca,aveiro,harmonization,surah,predictors,solvay,mande,omnipresent,parenthesis,echolocation,equaling,experimenters,acyclic,lithographic,sepoys,katarzyna,sridevi,impoundment,khosrow,caesarean,nacogdoches,rockdale,lawmaker,caucasians,bahman,miyan,rubric,exuberance,bombastic,ductile,snowdonia,inlays,pinyon,anemones,hurries,hospitallers,tayyip,pulleys,treme,photovoltaics,testbed,polonium,ryszard,osgoode,profiting,ironwork,unsurpassed,nepticulidae,makai,lumbini,preclassic,clarksburg,egremont,videography,rehabilitating,ponty,sardonic,geotechnical,khurasan,solzhenitsyn,henna,phoenicia,rhyolite,chateaux,retorted,tomar,deflections,repressions,harborough,renan,brumbies,vandross,storia,vodou,clerkenwell,decking,universo,salon.com,imprisoning,sudwest,ghaziabad,subscribing,pisgah,sukhumi,econometric,clearest,pindar,yildirim,iulia,atlases,cements,remaster,dugouts,collapsible,resurrecting,batik,unreliability,thiers,conjunctions,colophon,marcher,placeholder,flagella,wolds,kibaki,viviparous,twelver,screenshots,aroostook,khadr,iconographic,itasca,jaume,basti,propounded,varro,be'er,jeevan,exacted,shrublands,creditable,brocade,boras,bittern,oneonta,attentional,herzliya,comprehensible,lakeville,discards,caxias,frankland,camerata,satoru,matlab,commutator,interprovincial,yorkville,benefices,nizami,edwardsville,amigaos,cannabinoid,indianola,amateurliga,pernicious,ubiquity,anarchic,novelties,precondition,zardari,symington,sargodha,headphone,thermopylae,mashonaland,zindagi,thalberg,loewe,surfactants,dobro,crocodilians,samhita,diatoms,haileybury,berwickshire,supercritical,sofie,snorna,slatina,intramolecular,agung,osteoarthritis,obstetric,teochew,vakhtang,connemara,deformations,diadem,ferruccio,mainichi,qualitatively,refrigerant,rerecorded,methylated,karmapa,krasinski,restatement,rouvas,cubitt,seacoast,schwarzkopf,homonymous,shipowner,thiamine,approachable,xiahou,160th,ecumenism,polistes,internazionali,fouad,berar,biogeography,texting,inadequately,'when,4kids,hymenoptera,emplaced,cognomen,bellefonte,supplant,michaelmas,uriel,tafsir,morazan,schweinfurt,chorister,ps400,nscaa,petipa,resolutely,ouagadougou,mascarene,supercell,konstanz,bagrat,harmonix,bergson,shrimps,resonators,veneta,camas,mynydd,rumford,generalmajor,khayyam,web.com,pappus,halfdan,tanana,suomen,yutaka,bibliographical,traian,silat,noailles,contrapuntal,agaricus,'special,minibuses,1670s,obadiah,deepa,rorschach,malolos,lymington,valuations,imperials,caballeros,ambroise,judicature,elegiac,sedaka,shewa,checksum,gosforth,legionaries,corneille,microregion,friedrichshafen,antonis,surnamed,mycelium,cantus,educations,topmost,outfitting,ivica,nankai,gouda,anthemic,iosif,supercontinent,antifungal,belarusians,mudaliar,mohawks,caversham,glaciated,basemen,stevan,clonmel,loughton,deventer,positivist,manipuri,tensors,panipat,changeup,impermeable,dubbo,elfsborg,maritimo,regimens,bikram,bromeliad,substratum,norodom,gaultier,queanbeyan,pompeo,redacted,eurocopter,mothballed,centaurs,borno,copra,bemidji,'home,sopron,neuquen,passo,cineplex,alexandrov,wysokie,mammoths,yossi,sarcophagi,congreve,petkovic,extraneous,waterbirds,slurs,indias,phaeton,discontented,prefaced,abhay,prescot,interoperable,nordisk,bicyclists,validly,sejong,litovsk,zanesville,kapitanleutnant,kerch,changeable,mcclatchy,celebi,attesting,maccoll,sepahan,wayans,veined,gaudens,markt,dansk,soane,quantized,petersham,forebears,nayarit,frenzied,queuing,bygone,viggo,ludwik,tanka,hanssen,brythonic,cornhill,primorsky,stockpiles,conceptualization,lampeter,hinsdale,mesoderm,bielsk,rosenheim,ultron,joffrey,stanwyck,khagan,tiraspol,pavelic,ascendant,empoli,metatarsal,descentralizado,masada,ligier,huseyin,ramadi,waratah,tampines,ruthenium,statoil,mladost,liger,grecian,multiparty,digraph,maglev,reconsideration,radiography,cartilaginous,taizu,wintered,anabaptist,peterhouse,shoghi,assessors,numerator,paulet,painstakingly,halakhic,rocroi,motorcycling,gimel,kryptonian,emmeline,cheeked,drawdown,lelouch,dacians,brahmana,reminiscence,disinfection,optimizations,golders,extensor,tsugaru,tolling,liman,gulzar,unconvinced,crataegus,oppositional,dvina,pyrolysis,mandan,alexius,prion,stressors,loomed,moated,dhivehi,recyclable,relict,nestlings,sarandon,kosovar,solvers,czeslaw,kenta,maneuverable,middens,berkhamsted,comilla,folkways,loxton,beziers,batumi,petrochemicals,optimised,sirjan,rabindra,musicality,rationalisation,drillers,subspaces,'live,bbwaa,outfielders,tsung,danske,vandalised,norristown,striae,kanata,gastroenterology,steadfastly,equalising,bootlegging,mannerheim,notodontidae,lagoa,commentating,peninsulas,chishti,seismology,modigliani,preceptor,canonically,awardee,boyaca,hsinchu,stiffened,nacelle,bogor,dryness,unobstructed,yaqub,scindia,peeters,irritant,ammonites,ferromagnetic,speechwriter,oxygenated,walesa,millais,canarian,faience,calvinistic,discriminant,rasht,inker,annexes,howth,allocates,conditionally,roused,regionalism,regionalbahn,functionary,nitrates,bicentenary,recreates,saboteurs,koshi,plasmids,thinned,124th,plainview,kardashian,neuville,victorians,radiates,127th,vieques,schoolmates,petru,tokusatsu,keying,sunaina,flamethrower,'bout,demersal,hosokawa,corelli,omniscient,o'doherty,niksic,reflectivity,transdev,cavour,metronome,temporally,gabba,nsaids,geert,mayport,hematite,boeotia,vaudreuil,torshavn,sailplane,mineralogist,eskisehir,practises,gallifrey,takumi,unease,slipstream,hedmark,paulinus,ailsa,wielkopolska,filmworks,adamantly,vinaya,facelifted,franchisee,augustana,toppling,velvety,crispa,stonington,histological,genealogist,tactician,tebow,betjeman,nyingma,overwinter,oberoi,rampal,overwinters,petaluma,lactarius,stanmore,balikpapan,vasant,inclines,laminate,munshi,sociedade,rabbah,septal,boyband,ingrained,faltering,inhumans,nhtsa,affix,l'ordre,kazuki,rossendale,mysims,latvians,slaveholders,basilicata,neuburg,assize,manzanillo,scrobipalpa,formula_61,belgique,pterosaurs,privateering,vaasa,veria,northport,pressurised,hobbyist,austerlitz,sahih,bhadra,siliguri,bistrica,bursaries,wynton,corot,lepidus,lully,libor,libera,olusegun,choline,mannerism,lymphocyte,chagos,duxbury,parasitism,ecowas,morotai,cancion,coniston,aggrieved,sputnikmusic,parle,ammonian,civilisations,malformation,cattaraugus,skyhawks,d'arc,demerara,bronfman,midwinter,piscataway,jogaila,threonine,matins,kohlberg,hubli,pentatonic,camillus,nigam,potro,unchained,chauvel,orangeville,cistercians,redeployment,xanthi,manju,carabinieri,pakeha,nikolaevich,kantakouzenos,sesquicentennial,gunships,symbolised,teramo,ballo,crusading,l'oeil,bharatpur,lazier,gabrovo,hysteresis,rothbard,chaumont,roundel,ma'mun,sudhir,queried,newts,shimane,presynaptic,playfield,taxonomists,sensitivities,freleng,burkinabe,orfeo,autovia,proselytizing,bhangra,pasok,jujutsu,heung,pivoting,hominid,commending,formula_64,epworth,christianized,oresund,hantuchova,rajputana,hilversum,masoretic,dayak,bakri,assen,magog,macromolecules,waheed,qaida,spassky,rumped,protrudes,preminger,misogyny,glencairn,salafi,lacunae,grilles,racemes,areva,alighieri,inari,epitomized,photoshoot,one-of-a-kind,tring,muralist,tincture,backwaters,weaned,yeasts,analytically,smaland,caltrans,vysocina,jamuna,mauthausen,175th,nouvelles,censoring,reggina,christology,gilad,amplifying,mehmood,johnsons,redirects,eastgate,sacrum,meteoric,riverbanks,guidebooks,ascribes,scoparia,iconoclastic,telegraphic,chine,merah,mistico,lectern,sheung,aethelstan,capablanca,anant,uspto,albatrosses,mymensingh,antiretroviral,clonal,coorg,vaillant,liquidator,gigas,yokai,eradicating,motorcyclists,waitakere,tandon,nears,montenegrins,250th,tatsuya,yassin,atheistic,syncretism,nahum,berisha,transcended,owensboro,lakshmana,abteilung,unadorned,nyack,overflows,harrisonburg,complainant,uematsu,frictional,worsens,sangguniang,abutment,bulwer,sarma,apollinaire,shippers,lycia,alentejo,porpoises,optus,trawling,augustow,blackwall,workbench,westmount,leaped,sikandar,conveniences,stornoway,culverts,zoroastrians,hristo,ansgar,assistive,reassert,fanned,compasses,delgada,maisons,arima,plonsk,verlaine,starstruck,rakhine,befell,spirally,wyclef,expend,colloquium,formula_63,albertus,bellarmine,handedness,holon,introns,movimiento,profitably,lohengrin,discoverers,awash,erste,pharisees,dwarka,oghuz,hashing,heterodox,uloom,vladikavkaz,linesman,rehired,nucleophile,germanicus,gulshan,songz,bayerische,paralympian,crumlin,enjoined,khanum,prahran,penitent,amersfoort,saranac,semisimple,vagrants,compositing,tualatin,oxalate,lavra,ironi,ilkeston,umpqua,calum,stretford,zakat,guelders,hydrazine,birkin,spurring,modularity,aspartate,sodermanland,hopital,bellary,legazpi,clasico,cadfael,hypersonic,volleys,pharmacokinetics,carotene,orientale,pausini,bataille,lunga,retailed,m.phil,mazowieckie,vijayan,rawal,sublimation,promissory,estimators,ploughed,conflagration,penda,segregationist,otley,amputee,coauthor,sopra,pellew,wreckers,tollywood,circumscription,permittivity,strabane,landward,articulates,beaverbrook,rutherglen,coterminous,whistleblowers,colloidal,surbiton,atlante,oswiecim,bhasa,lampooned,chanter,saarc,landkreis,tribulation,tolerates,daiichi,hatun,cowries,dyschirius,abercromby,attock,aldwych,inflows,absolutist,l'histoire,committeeman,vanbrugh,headstock,westbourne,appenzell,hoxton,oculus,westfalen,roundabouts,nickelback,trovatore,quenching,summarises,conservators,transmutation,talleyrand,barzani,unwillingly,axonal,'blue,opining,enveloping,fidesz,rafah,colborne,flickr,lozenge,dulcimer,ndebele,swaraj,oxidize,gonville,resonated,gilani,superiore,endeared,janakpur,shepperton,solidifying,memoranda,sochaux,kurnool,rewari,emirs,kooning,bruford,unavailability,kayseri,judicious,negating,pterosaur,cytosolic,chernihiv,variational,sabretooth,seawolves,devalued,nanded,adverb,volunteerism,sealers,nemours,smederevo,kashubian,bartin,animax,vicomte,polotsk,polder,archiepiscopal,acceptability,quidditch,tussock,seminaire,immolation,belge,coves,wellingborough,khaganate,mckellen,nayaka,brega,kabhi,pontoons,bascule,newsreels,injectors,cobol,weblog,diplo,biggar,wheatbelt,erythrocytes,pedra,showgrounds,bogdanovich,eclecticism,toluene,elegies,formalize,andromedae,airworthiness,springville,mainframes,overexpression,magadha,bijelo,emlyn,glutamine,accenture,uhuru,metairie,arabidopsis,patanjali,peruvians,berezovsky,accion,astrolabe,jayanti,earnestly,sausalito,recurved,1500s,ramla,incineration,galleons,laplacian,shiki,smethwick,isomerase,dordevic,janow,jeffersonville,internationalism,penciled,styrene,ashur,nucleoside,peristome,horsemanship,sedges,bachata,medes,kristallnacht,schneerson,reflectance,invalided,strutt,draupadi,destino,partridges,tejas,quadrennial,aurel,halych,ethnomusicology,autonomist,radyo,rifting,shi'ar,crvena,telefilm,zawahiri,plana,sultanates,theodorus,subcontractors,pavle,seneschal,teleports,chernivtsi,buccal,brattleboro,stankovic,safar,dunhuang,electrocution,chastised,ergonomic,midsomer,130th,zomba,nongovernmental,escapist,localize,xuzhou,kyrie,carinthian,karlovac,nisan,kramnik,pilipino,digitisation,khasi,andronicus,highwayman,maior,misspelling,sebastopol,socon,rhaetian,archimandrite,partway,positivity,otaku,dingoes,tarski,geopolitics,disciplinarian,zulfikar,kenzo,globose,electrophilic,modele,storekeeper,pohang,wheldon,washers,interconnecting,digraphs,intrastate,campy,helvetic,frontispiece,ferrocarril,anambra,petraeus,midrib,endometrial,dwarfism,mauryan,endocytosis,brigs,percussionists,furtherance,synergistic,apocynaceae,krona,berthier,circumvented,casal,siltstone,precast,ethnikos,realists,geodesy,zarzuela,greenback,tripathi,persevered,interments,neutralization,olbermann,departements,supercomputing,demobilised,cassavetes,dunder,ministering,veszprem,barbarism,'world,pieve,apologist,frentzen,sulfides,firewalls,pronotum,staatsoper,hachette,makhachkala,oberland,phonon,yoshihiro,instars,purnima,winslet,mutsu,ergative,sajid,nizamuddin,paraphrased,ardeidae,kodagu,monooxygenase,skirmishers,sportiva,o'byrne,mykolaiv,ophir,prieta,gyllenhaal,kantian,leche,copan,herero,ps250,gelsenkirchen,shalit,sammarinese,chetwynd,wftda,travertine,warta,sigmaringen,concerti,namespace,ostergotland,biomarker,universals,collegio,embarcadero,wimborne,fiddlers,likening,ransomed,stifled,unabated,kalakaua,khanty,gongs,goodrem,countermeasure,publicizing,geomorphology,swedenborg,undefended,catastrophes,diverts,storyboards,amesbury,contactless,placentia,festivity,authorise,terrane,thallium,stradivarius,antonine,consortia,estimations,consecrate,supergiant,belichick,pendants,butyl,groza,univac,afire,kavala,studi,teletoon,paucity,gonbad,koninklijke,128th,stoichiometric,multimodal,facundo,anatomic,melamine,creuse,altan,brigands,mcguinty,blomfield,tsvangirai,protrusion,lurgan,warminster,tenzin,russellville,discursive,definable,scotrail,lignin,reincorporated,o'dell,outperform,redland,multicolored,evaporates,dimitrie,limbic,patapsco,interlingua,surrogacy,cutty,potrero,masud,cahiers,jintao,ardashir,centaurus,plagiarized,minehead,musings,statuettes,logarithms,seaview,prohibitively,downforce,rivington,tomorrowland,microbiologist,ferric,morag,capsid,kucinich,clairvaux,demotic,seamanship,cicada,painterly,cromarty,carbonic,tupou,oconee,tehuantepec,typecast,anstruther,internalized,underwriters,tetrahedra,flagrant,quakes,pathologies,ulrik,nahal,tarquini,dongguan,parnassus,ryoko,senussi,seleucia,airasia,einer,sashes,d'amico,matriculating,arabesque,honved,biophysical,hardinge,kherson,mommsen,diels,icbms,reshape,brasiliensis,palmach,netaji,oblate,functionalities,grigor,blacksburg,recoilless,melanchthon,reales,astrodome,handcrafted,memes,theorizes,isma'il,aarti,pirin,maatschappij,stabilizes,honiara,ashbury,copts,rootes,defensed,queiroz,mantegna,galesburg,coraciiformesfamily,cabrillo,tokio,antipsychotics,kanon,173rd,apollonia,finial,lydian,hadamard,rangi,dowlatabad,monolingual,platformer,subclasses,chiranjeevi,mirabeau,newsgroup,idmanyurdu,kambojas,walkover,zamoyski,generalist,khedive,flanges,knowle,bande,157th,alleyn,reaffirm,pininfarina,zuckerberg,hakodate,131st,aditi,bellinzona,vaulter,planking,boscombe,colombians,lysis,toppers,metered,nahyan,queensryche,minho,nagercoil,firebrand,foundress,bycatch,mendota,freeform,antena,capitalisation,martinus,overijssel,purists,interventionist,zgierz,burgundians,hippolyta,trompe,umatilla,moroccans,dictionnaire,hydrography,changers,chota,rimouski,aniline,bylaw,grandnephew,neamt,lemnos,connoisseurs,tractive,rearrangements,fetishism,finnic,apalachicola,landowning,calligraphic,circumpolar,mansfeld,legible,orientalism,tannhauser,blamey,maximization,noinclude,blackbirds,angara,ostersund,pancreatitis,glabra,acleris,juried,jungian,triumphantly,singlet,plasmas,synesthesia,yellowhead,unleashes,choiseul,quanzhong,brookville,kaskaskia,igcse,skatepark,jatin,jewellers,scaritinae,techcrunch,tellurium,lachaise,azuma,codeshare,dimensionality,unidirectional,scolaire,macdill,camshafts,unassisted,verband,kahlo,eliya,prelature,chiefdoms,saddleback,sockers,iommi,coloratura,llangollen,biosciences,harshest,maithili,k'iche,plical,multifunctional,andreu,tuskers,confounding,sambre,quarterdeck,ascetics,berdych,transversal,tuolumne,sagami,petrobras,brecker,menxia,instilling,stipulating,korra,oscillate,deadpan,v/line,pyrotechnic,stoneware,prelims,intracoastal,retraining,ilija,berwyn,encrypt,achievers,zulfiqar,glycoproteins,khatib,farmsteads,occultist,saman,fionn,derulo,khilji,obrenovic,argosy,toowong,dementieva,sociocultural,iconostasis,craigslist,festschrift,taifa,intercalated,tanjong,penticton,sharad,marxian,extrapolation,guises,wettin,prabang,exclaiming,kosta,famas,conakry,wanderings,'aliabad,macleay,exoplanet,bancorp,besiegers,surmounting,checkerboard,rajab,vliet,tarek,operable,wargaming,haldimand,fukuyama,uesugi,aggregations,erbil,brachiopods,tokyu,anglais,unfavorably,ujpest,escorial,armagnac,nagara,funafuti,ridgeline,cocking,o'gorman,compactness,retardant,krajowa,barua,coking,bestows,thampi,chicagoland,variably,o'loughlin,minnows,schwa,shaukat,polycarbonate,chlorinated,godalming,gramercy,delved,banqueting,enlil,sarada,prasanna,domhnall,decadal,regressive,lipoprotein,collectable,surendra,zaporizhia,cycliste,suchet,offsetting,formula_65,pudong,d'arte,blyton,quonset,osmania,tientsin,manorama,proteomics,bille,jalpaiguri,pertwee,barnegat,inventiveness,gollancz,euthanized,henricus,shortfalls,wuxia,chlorides,cerrado,polyvinyl,folktale,straddled,bioengineering,eschewing,greendale,recharged,olave,ceylonese,autocephalous,peacebuilding,wrights,guyed,rosamund,abitibi,bannockburn,gerontology,scutari,souness,seagram,codice_9,'open,xhtml,taguig,purposed,darbar,orthopedics,unpopulated,kisumu,tarrytown,feodor,polyhedral,monadnock,gottorp,priam,redesigning,gasworks,elfin,urquiza,homologation,filipovic,bohun,manningham,gornik,soundness,shorea,lanus,gelder,darke,sandgate,criticality,paranaense,153rd,vieja,lithograph,trapezoid,tiebreakers,convalescence,yan'an,actuaries,balad,altimeter,thermoelectric,trailblazer,previn,tenryu,ancaster,endoscopy,nicolet,discloses,fracking,plaine,salado,americanism,placards,absurdist,propylene,breccia,jirga,documenta,ismailis,161st,brentano,dallas/fort,embellishment,calipers,subscribes,mahavidyalaya,wednesbury,barnstormers,miwok,schembechler,minigame,unterberger,dopaminergic,inacio,nizamabad,overridden,monotype,cavernous,stichting,sassafras,sotho,argentinean,myrrh,rapidity,flatts,gowrie,dejected,kasaragod,cyprinidae,interlinked,arcseconds,degeneracy,infamously,incubate,substructure,trigeminal,sectarianism,marshlands,hooliganism,hurlers,isolationist,urania,burrard,switchover,lecco,wilts,interrogator,strived,ballooning,volterra,raciborz,relegating,gilding,cybele,dolomites,parachutist,lochaber,orators,raeburn,backend,benaud,rallycross,facings,banga,nuclides,defencemen,futurity,emitters,yadkin,eudonia,zambales,manasseh,sirte,meshes,peculiarly,mcminnville,roundly,boban,decrypt,icelanders,sanam,chelan,jovian,grudgingly,penalised,subscript,gambrinus,poaceae,infringements,maleficent,runciman,148th,supersymmetry,granites,liskeard,eliciting,involution,hallstatt,kitzbuhel,shankly,sandhills,inefficiencies,yishuv,psychotropic,nightjars,wavell,sangamon,vaikundar,choshu,retrospectives,pitesti,gigantea,hashemi,bosna,gakuin,siochana,arrangers,baronetcies,narayani,temecula,creston,koscierzyna,autochthonous,wyandot,anniston,igreja,mobilise,buzau,dunster,musselburgh,wenzhou,khattak,detoxification,decarboxylase,manlius,campbells,coleoptera,copyist,sympathisers,suisun,eminescu,defensor,transshipment,thurgau,somerton,fluctuates,ambika,weierstrass,lukow,giambattista,volcanics,romanticized,innovated,matabeleland,scotiabank,garwolin,purine,d'auvergne,borderland,maozhen,pricewaterhousecoopers,testator,pallium,scout.com,mv/pi,nazca,curacies,upjohn,sarasvati,monegasque,ketrzyn,malory,spikelets,biomechanics,haciendas,rapped,dwarfed,stews,nijinsky,subjection,matsu,perceptible,schwarzburg,midsection,entertains,circuitous,epiphytic,wonsan,alpini,bluefield,sloths,transportable,braunfels,dictum,szczecinek,jukka,wielun,wejherowo,hucknall,grameen,duodenum,ribose,deshpande,shahar,nexstar,injurious,dereham,lithographer,dhoni,structuralist,progreso,deschutes,christus,pulteney,quoins,yitzchak,gyeongsang,breviary,makkah,chiyoda,jutting,vineland,angiosperms,necrotic,novelisation,redistribute,tirumala,140th,featureless,mafic,rivaling,toyline,2/1st,martius,saalfeld,monthan,texian,kathak,melodramas,mithila,regierungsbezirk,509th,fermenting,schoolmate,virtuosic,briain,kokoda,heliocentric,handpicked,kilwinning,sonically,dinars,kasim,parkways,bogdanov,luxembourgian,halland,avesta,bardic,daugavpils,excavator,qwest,frustrate,physiographic,majoris,'ndrangheta,unrestrained,firmness,montalban,abundances,preservationists,adare,executioners,guardsman,bonnaroo,neglects,nazrul,pro12,hoorn,abercorn,refuting,kabud,cationic,parapsychology,troposphere,venezuelans,malignancy,khoja,unhindered,accordionist,medak,visby,ejercito,laparoscopic,dinas,umayyads,valmiki,o'dowd,saplings,stranding,incisions,illusionist,avocets,buccleuch,amazonia,fourfold,turboprops,roosts,priscus,turnstile,areal,certifies,pocklington,spoofs,viseu,commonalities,dabrowka,annam,homesteaders,daredevils,mondrian,negotiates,fiestas,perennials,maximizes,lubavitch,ravindra,scrapers,finials,kintyre,violas,snoqualmie,wilders,openbsd,mlawa,peritoneal,devarajan,congke,leszno,mercurial,fakir,joannes,bognor,overloading,unbuilt,gurung,scuttle,temperaments,bautzen,jardim,tradesman,visitations,barbet,sagamore,graaff,forecasters,wilsons,assis,l'air,shariah,sochaczew,russa,dirge,biliary,neuve,heartbreakers,strathearn,jacobian,overgrazing,edrich,anticline,parathyroid,petula,lepanto,decius,channelled,parvathi,puppeteers,communicators,francorchamps,kahane,longus,panjang,intron,traite,xxvii,matsuri,amrit,katyn,disheartened,cacak,omonia,alexandrine,partaking,wrangling,adjuvant,haskovo,tendrils,greensand,lammermoor,otherworld,volusia,stabling,one-and-a-half,bresson,zapatista,eotvos,ps150,webisodes,stepchildren,microarray,braganca,quanta,dolne,superoxide,bellona,delineate,ratha,lindenwood,bruhl,cingulate,tallies,bickerton,helgi,bevin,takoma,tsukuba,statuses,changeling,alister,bytom,dibrugarh,magnesia,duplicating,outlier,abated,goncalo,strelitz,shikai,mardan,musculature,ascomycota,springhill,tumuli,gabaa,odenwald,reformatted,autocracy,theresienstadt,suplex,chattopadhyay,mencken,congratulatory,weatherfield,systema,solemnity,projekt,quanzhou,kreuzberg,postbellum,nobuo,mediaworks,finisterre,matchplay,bangladeshis,kothen,oocyte,hovered,aromas,afshar,browed,teases,chorlton,arshad,cesaro,backbencher,iquique,vulcans,padmini,unabridged,cyclase,despotic,kirilenko,achaean,queensberry,debre,octahedron,iphigenia,curbing,karimnagar,sagarmatha,smelters,surrealists,sanada,shrestha,turridae,leasehold,jiedushi,eurythmics,appropriating,correze,thimphu,amery,musicomh,cyborgs,sandwell,pushcart,retorts,ameliorate,deteriorates,stojanovic,spline,entrenchments,bourse,chancellorship,pasolini,lendl,personage,reformulated,pubescens,loiret,metalurh,reinvention,nonhuman,eilema,tarsal,complutense,magne,broadview,metrodome,outtake,stouffville,seinen,bataillon,phosphoric,ostensible,opatow,aristides,beefheart,glorifying,banten,romsey,seamounts,fushimi,prophylaxis,sibylla,ranjith,goslar,balustrades,georgiev,caird,lafitte,peano,canso,bankura,halfpenny,segregate,caisson,bizerte,jamshedpur,euromaidan,philosophie,ridged,cheerfully,reclassification,aemilius,visionaries,samoans,wokingham,chemung,wolof,unbranched,cinerea,bhosle,ourense,immortalised,cornerstones,sourcebook,khufu,archimedean,universitatea,intermolecular,fiscally,suffices,metacomet,adjudicator,stablemate,specks,glace,inowroclaw,patristic,muharram,agitating,ashot,neurologic,didcot,gamla,ilves,putouts,siraj,laski,coaling,diarmuid,ratnagiri,rotulorum,liquefaction,morbihan,harel,aftershock,gruiformesfamily,bonnier,falconiformesfamily,adorns,wikis,maastrichtian,stauffenberg,bishopsgate,fakhr,sevenfold,ponders,quantifying,castiel,opacity,depredations,lenten,gravitated,o'mahony,modulates,inuktitut,paston,kayfabe,vagus,legalised,balked,arianism,tendering,sivas,birthdate,awlaki,khvajeh,shahab,samtgemeinde,bridgeton,amalgamations,biogenesis,recharging,tsukasa,mythbusters,chamfered,enthronement,freelancers,maharana,constantia,sutil,messines,monkton,okanogan,reinvigorated,apoplexy,tanahashi,neues,valiants,harappan,russes,carding,volkoff,funchal,statehouse,imitative,intrepidity,mellotron,samaras,turkana,besting,longitudes,exarch,diarrhoea,transcending,zvonareva,darna,ramblin,disconnection,137th,refocused,diarmait,agricole,ba'athist,turenne,contrabass,communis,daviess,fatimids,frosinone,fittingly,polyphyletic,qanat,theocratic,preclinical,abacha,toorak,marketplaces,conidia,seiya,contraindicated,retford,bundesautobahn,rebuilds,climatology,seaworthy,starfighter,qamar,categoria,malai,hellinsia,newstead,airworthy,catenin,avonmouth,arrhythmias,ayyavazhi,downgrade,ashburnham,ejector,kinematics,petworth,rspca,filmation,accipitridae,chhatrapati,g/mol,bacau,agama,ringtone,yudhoyono,orchestrator,arbitrators,138th,powerplants,cumbernauld,alderley,misamis,hawai`i,cuando,meistriliiga,jermyn,alans,pedigrees,ottavio,approbation,omnium,purulia,prioress,rheinland,lymphoid,lutsk,oscilloscope,ballina,iliac,motorbikes,modernising,uffizi,phylloxera,kalevala,bengalis,amravati,syntheses,interviewers,inflectional,outflank,maryhill,unhurt,profiler,nacelles,heseltine,personalised,guarda,herpetologist,airpark,pigot,margaretha,dinos,peleliu,breakbeat,kastamonu,shaivism,delamere,kingsville,epigram,khlong,phospholipids,journeying,lietuvos,congregated,deviance,celebes,subsoil,stroma,kvitova,lubricating,layoff,alagoas,olafur,doron,interuniversity,raycom,agonopterix,uzice,nanna,springvale,raimundo,wrested,pupal,talat,skinheads,vestige,unpainted,handan,odawara,ammar,attendee,lapped,myotis,gusty,ciconiiformesfamily,traversal,subfield,vitaphone,prensa,hasidism,inwood,carstairs,kropotkin,turgenev,dobra,remittance,purim,tannin,adige,tabulation,lethality,pacha,micronesian,dhruva,defensemen,tibeto,siculus,radioisotope,sodertalje,phitsanulok,euphonium,oxytocin,overhangs,skinks,fabrica,reinterred,emulates,bioscience,paragliding,raekwon,perigee,plausibility,frolunda,erroll,aznar,vyasa,albinus,trevally,confederacion,terse,sixtieth,1530s,kendriya,skateboarders,frontieres,muawiyah,easements,shehu,conservatively,keystones,kasem,brutalist,peekskill,cowry,orcas,syllabary,paltz,elisabetta,denticles,hampering,dolni,eidos,aarau,lermontov,yankton,shahbaz,barrages,kongsvinger,reestablishment,acetyltransferase,zulia,mrnas,slingsby,eucalypt,efficacious,weybridge,gradation,cinematheque,malthus,bampton,coexisted,cisse,hamdi,cupertino,saumarez,chionodes,libertine,formers,sakharov,pseudonymous,vol.1,mcduck,gopalakrishnan,amberley,jorhat,grandmasters,rudiments,dwindle,param,bukidnon,menander,americanus,multipliers,pulawy,homoerotic,pillbox,cd+dvd,epigraph,aleksandrow,extrapolated,horseshoes,contemporain,angiography,hasselt,shawinigan,memorization,legitimized,cyclades,outsold,rodolphe,kelis,powerball,dijkstra,analyzers,incompressible,sambar,orangeburg,osten,reauthorization,adamawa,sphagnum,hypermarket,millipedes,zoroaster,madea,ossuary,murrayfield,pronominal,gautham,resellers,ethers,quarrelled,dolna,stragglers,asami,tangut,passos,educacion,sharaf,texel,berio,bethpage,bezalel,marfa,noronha,36ers,genteel,avram,shilton,compensates,sweetener,reinstalled,disables,noether,1590s,balakrishnan,kotaro,northallerton,cataclysm,gholam,cancellara,schiphol,commends,longinus,albinism,gemayel,hamamatsu,volos,islamism,sidereal,pecuniary,diggings,townsquare,neosho,lushan,chittoor,akhil,disputation,desiccation,cambodians,thwarting,deliberated,ellipsis,bahini,susumu,separators,kohneh,plebeians,kultur,ogaden,pissarro,trypeta,latur,liaodong,vetting,datong,sohail,alchemists,lengthwise,unevenly,masterly,microcontrollers,occupier,deviating,farringdon,baccalaureat,theocracy,chebyshev,archivists,jayaram,ineffectiveness,scandinavians,jacobins,encomienda,nambu,g/cm3,catesby,paavo,heeded,rhodium,idealised,10deg,infective,mecyclothorax,halevy,sheared,minbari,audax,lusatian,rebuffs,hitfix,fastener,subjugate,tarun,binet,compuserve,synthesiser,keisuke,amalric,ligatures,tadashi,ignazio,abramovich,groundnut,otomo,maeve,mortlake,ostrogoths,antillean,todor,recto,millimetre,espousing,inaugurate,paracetamol,galvanic,harpalinae,jedrzejow,reassessment,langlands,civita,mikan,stikine,bijar,imamate,istana,kaiserliche,erastus,federale,cytosine,expansionism,hommes,norrland,smriti,snapdragon,gulab,taleb,lossy,khattab,urbanised,sesto,rekord,diffuser,desam,morganatic,silting,pacts,extender,beauharnais,purley,bouches,halfpipe,discontinuities,houthi,farmville,animism,horni,saadi,interpretative,blockades,symeon,biogeographic,transcaucasian,jetties,landrieu,astrocytes,conjunto,stumpings,weevils,geysers,redux,arching,romanus,tazeh,marcellinus,casein,opava,misrata,anare,sattar,declarer,dreux,oporto,venta,vallis,icosahedron,cortona,lachine,mohammedan,sandnes,zynga,clarin,diomedes,tsuyoshi,pribram,gulbarga,chartist,superettan,boscawen,altus,subang,gating,epistolary,vizianagaram,ogdensburg,panna,thyssen,tarkovsky,dzogchen,biograph,seremban,unscientific,nightjar,legco,deism,n.w.a,sudha,siskel,sassou,flintlock,jovial,montbeliard,pallida,formula_66,tranquillity,nisei,adornment,'people,yamhill,hockeyallsvenskan,adopters,appian,lowicz,haplotypes,succinctly,starogard,presidencies,kheyrabad,sobibor,kinesiology,cowichan,militum,cromwellian,leiningen,ps1.5,concourses,dalarna,goldfield,brzeg,faeces,aquarii,matchless,harvesters,181st,numismatics,korfball,sectioned,transpires,facultative,brandishing,kieron,forages,menai,glutinous,debarge,heathfield,1580s,malang,photoelectric,froome,semiotic,alwar,grammophon,chiaroscuro,mentalist,maramures,flacco,liquors,aleutians,marvell,sutlej,patnaik,qassam,flintoff,bayfield,haeckel,sueno,avicii,exoplanets,hoshi,annibale,vojislav,honeycombs,celebrant,rendsburg,veblen,quails,141st,carronades,savar,narrations,jeeva,ontologies,hedonistic,marinette,godot,munna,bessarabian,outrigger,thame,gravels,hoshino,falsifying,stereochemistry,nacionalista,medially,radula,ejecting,conservatorio,odile,ceiba,jaina,essonne,isometry,allophones,recidivism,iveco,ganda,grammarians,jagan,signposted,uncompressed,facilitators,constancy,ditko,propulsive,impaling,interbank,botolph,amlaib,intergroup,sorbus,cheka,debye,praca,adorning,presbyteries,dormition,strategos,qarase,pentecostals,beehives,hashemite,goldust,euronext,egress,arpanet,soames,jurchens,slovenska,copse,kazim,appraisals,marischal,mineola,sharada,caricaturist,sturluson,galba,faizabad,overwintering,grete,uyezds,didsbury,libreville,ablett,microstructure,anadolu,belenenses,elocution,cloaks,timeslots,halden,rashidun,displaces,sympatric,germanus,tuples,ceska,equalize,disassembly,krautrock,babangida,memel,deild,gopala,hematology,underclass,sangli,wawrinka,assur,toshack,refrains,nicotinic,bhagalpur,badami,racetracks,pocatello,walgreens,nazarbayev,occultation,spinnaker,geneon,josias,hydrolyzed,dzong,corregimiento,waistcoat,thermoplastic,soldered,anticancer,lactobacillus,shafi'i,carabus,adjournment,schlumberger,triceratops,despotate,mendicant,krishnamurti,bahasa,earthworm,lavoisier,noetherian,kalki,fervently,bhawan,saanich,coquille,gannet,motagua,kennels,mineralization,fitzherbert,svein,bifurcated,hairdressing,felis,abounded,dimers,fervour,hebdo,bluffton,aetna,corydon,clevedon,carneiro,subjectively,deutz,gastropoda,overshot,concatenation,varman,carolla,maharshi,mujib,inelastic,riverhead,initialized,safavids,rohini,caguas,bulges,fotbollforbund,hefei,spithead,westville,maronites,lytham,americo,gediminas,stephanus,chalcolithic,hijra,gnu/linux,predilection,rulership,sterility,haidar,scarlatti,saprissa,sviatoslav,pointedly,sunroof,guarantor,thevar,airstrips,pultusk,sture,129th,divinities,daizong,dolichoderus,cobourg,maoists,swordsmanship,uprated,bohme,tashi,largs,chandi,bluebeard,householders,richardsonian,drepanidae,antigonish,elbasan,occultism,marca,hypergeometric,oirat,stiglitz,ignites,dzungar,miquelon,pritam,d'automne,ulidiid,niamey,vallecano,fondo,billiton,incumbencies,raceme,chambery,cadell,barenaked,kagame,summerside,haussmann,hatshepsut,apothecaries,criollo,feint,nasals,timurid,feltham,plotinus,oxygenation,marginata,officinalis,salat,participations,ising,downe,izumo,unguided,pretence,coursed,haruna,viscountcy,mainstage,justicia,powiat,takara,capitoline,implacable,farben,stopford,cosmopterix,tuberous,kronecker,galatians,kweli,dogmas,exhorted,trebinje,skanda,newlyn,ablative,basidia,bhiwani,encroachments,stranglers,regrouping,tubal,shoestring,wawel,anionic,mesenchymal,creationists,pyrophosphate,moshi,despotism,powerbook,fatehpur,rupiah,segre,ternate,jessore,b.i.g,shevardnadze,abounds,gliwice,densest,memoria,suborbital,vietcong,ratepayers,karunanidhi,toolbar,descents,rhymney,exhortation,zahedan,carcinomas,hyperbaric,botvinnik,billets,neuropsychological,tigranes,hoards,chater,biennially,thistles,scotus,wataru,flotillas,hungama,monopolistic,payouts,vetch,generalissimo,caries,naumburg,piran,blizzards,escalates,reactant,shinya,theorize,rizzoli,transitway,ecclesiae,streptomyces,cantal,nisibis,superconductor,unworkable,thallus,roehampton,scheckter,viceroys,makuuchi,ilkley,superseding,takuya,klodzko,borbon,raspberries,operand,w.a.k.o,sarabande,factionalism,egalitarianism,temasek,torbat,unscripted,jorma,westerner,perfective,vrije,underlain,goldfrapp,blaenau,jomon,barthes,drivetime,bassa,bannock,umaga,fengxiang,zulus,sreenivasan,farces,codice_10,freeholder,poddebice,imperialists,deregulated,wingtip,o'hagan,pillared,overtone,hofstadter,149th,kitano,saybrook,standardizing,aldgate,staveley,o'flaherty,hundredths,steerable,soltan,empted,cruyff,intramuros,taluks,cotonou,marae,karur,figueres,barwon,lucullus,niobe,zemlya,lathes,homeported,chaux,amyotrophic,opines,exemplars,bhamo,homomorphisms,gauleiter,ladin,mafiosi,airdrieonians,b/soul,decal,transcaucasia,solti,defecation,deaconess,numidia,sampradaya,normalised,wingless,schwaben,alnus,cinerama,yakutsk,ketchikan,orvieto,unearned,monferrato,rotem,aacsb,loong,decoders,skerries,cardiothoracic,repositioning,pimpernel,yohannan,tenebrionoidea,nargis,nouvel,costliest,interdenominational,noize,redirecting,zither,morcha,radiometric,frequenting,irtysh,gbagbo,chakri,litvinenko,infotainment,ravensbruck,harith,corbels,maegashira,jousting,natan,novus,falcao,minis,railed,decile,rauma,ramaswamy,cavitation,paranaque,berchtesgaden,reanimated,schomberg,polysaccharides,exclusionary,cleon,anurag,ravaging,dhanush,mitchells,granule,contemptuous,keisei,rolleston,atlantean,yorkist,daraa,wapping,micrometer,keeneland,comparably,baranja,oranje,schlafli,yogic,dinajpur,unimpressive,masashi,recreativo,alemannic,petersfield,naoko,vasudeva,autosport,rajat,marella,busko,wethersfield,ssris,soulcalibur,kobani,wildland,rookery,hoffenheim,kauri,aliphatic,balaclava,ferrite,publicise,victorias,theism,quimper,chapbook,functionalist,roadbed,ulyanovsk,cupen,purpurea,calthorpe,teofilo,mousavi,cochlea,linotype,detmold,ellerslie,gakkai,telkom,southsea,subcontractor,inguinal,philatelists,zeebrugge,piave,trochidae,dempo,spoilt,saharanpur,mihrab,parasympathetic,barbarous,chartering,antiqua,katsina,bugis,categorizes,altstadt,kandyan,pambansa,overpasses,miters,assimilating,finlandia,uneconomic,am/fm,harpsichordist,dresdner,luminescence,authentically,overpowers,magmatic,cliftonville,oilfields,skirted,berthe,cuman,oakham,frelimo,glockenspiel,confection,saxophonists,piaseczno,multilevel,antipater,levying,maltreatment,velho,opoczno,harburg,pedophilia,unfunded,palettes,plasterwork,breve,dharmendra,auchinleck,nonesuch,blackmun,libretti,rabbani,145th,hasselbeck,kinnock,malate,vanden,cloverdale,ashgabat,nares,radians,steelworkers,sabor,possums,catterick,hemispheric,ostra,outpaced,dungeness,almshouse,penryn,texians,1000m,franchitti,incumbency,texcoco,newar,tramcars,toroidal,meitetsu,spellbound,agronomist,vinifera,riata,bunko,pinas,ba'al,github,vasilyevich,obsolescent,geodesics,ancestries,tujue,capitalised,unassigned,throng,unpaired,psychometric,skegness,exothermic,buffered,kristiansund,tongued,berenger,basho,alitalia,prolongation,archaeologically,fractionation,cyprinid,echinoderms,agriculturally,justiciar,sonam,ilium,baits,danceable,grazer,ardahan,grassed,preemption,glassworks,hasina,ugric,umbra,wahhabi,vannes,tinnitus,capitaine,tikrit,lisieux,scree,hormuz,despenser,jagiellon,maisonneuve,gandaki,santarem,basilicas,lancing,landskrona,weilburg,fireside,elysian,isleworth,krishnamurthy,filton,cynon,tecmo,subcostal,scalars,triglycerides,hyperplane,farmingdale,unione,meydan,pilings,mercosur,reactivate,akiba,fecundity,jatra,natsume,zarqawi,preta,masao,presbyter,oakenfold,rhodri,ferran,ruizong,cloyne,nelvana,epiphanius,borde,scutes,strictures,troughton,whitestone,sholom,toyah,shingon,kutuzov,abelard,passant,lipno,cafeterias,residuals,anabaptists,paratransit,criollos,pleven,radiata,destabilizing,hadiths,bazaars,mannose,taiyo,crookes,welbeck,baoding,archelaus,nguesso,alberni,wingtips,herts,viasat,lankans,evreux,wigram,fassbinder,ryuichi,storting,reducible,olesnica,znojmo,hyannis,theophanes,flatiron,mustering,rajahmundry,kadir,wayang,prome,lethargy,zubin,illegality,conall,dramedy,beerbohm,hipparchus,ziarat,ryuji,shugo,glenorchy,microarchitecture,morne,lewinsky,cauvery,battenberg,hyksos,wayanad,hamilcar,buhari,brazo,bratianu,solms,aksaray,elamite,chilcotin,bloodstock,sagara,dolny,reunified,umlaut,proteaceae,camborne,calabrian,dhanbad,vaxjo,cookware,potez,rediffusion,semitones,lamentations,allgau,guernica,suntory,pleated,stationing,urgell,gannets,bertelsmann,entryway,raphitomidae,acetaldehyde,nephrology,categorizing,beiyang,permeate,tourney,geosciences,khana,masayuki,crucis,universitaria,slaskie,khaimah,finno,advani,astonishingly,tubulin,vampiric,jeolla,sociale,cleethorpes,badri,muridae,suzong,debater,decimation,kenyans,mutualism,pontifex,middlemen,insee,halevi,lamentation,psychopathy,brassey,wenders,kavya,parabellum,prolactin,inescapable,apses,malignancies,rinzai,stigmatized,menahem,comox,ateliers,welshpool,setif,centimetre,truthfulness,downfield,drusus,woden,glycosylation,emanated,agulhas,dalkeith,jazira,nucky,unifil,jobim,operon,oryzomys,heroically,seances,supernumerary,backhouse,hashanah,tatler,imago,invert,hayato,clockmaker,kingsmill,swiecie,analogously,golconda,poste,tacitly,decentralised,ge'ez,diplomatically,fossiliferous,linseed,mahavira,pedestals,archpriest,byelection,domiciled,jeffersonian,bombus,winegrowing,waukegan,uncultivated,haverfordwest,saumur,communally,disbursed,cleeve,zeljeznicar,speciosa,vacationers,sigur,vaishali,zlatko,iftikhar,cropland,transkei,incompleteness,bohra,subantarctic,slieve,physiologic,similis,klerk,replanted,'right,chafee,reproducible,bayburt,regicide,muzaffarpur,plurals,hanyu,orthologs,diouf,assailed,kamui,tarik,dodecanese,gorne,on/off,179th,shimoga,granaries,carlists,valar,tripolitania,sherds,simmern,dissociated,isambard,polytechnical,yuvraj,brabazon,antisense,pubmed,glans,minutely,masaaki,raghavendra,savoury,podcasting,tachi,bienville,gongsun,ridgely,deform,yuichi,binders,canna,carcetti,llobregat,implored,berri,njegos,intermingled,offload,athenry,motherhouse,corpora,kakinada,dannebrog,imperio,prefaces,musicologists,aerospatiale,shirai,nagapattinam,servius,cristoforo,pomfret,reviled,entebbe,stane,east/west,thermometers,matriarchal,siglo,bodil,legionnaire,ze'ev,theorizing,sangeetha,horticulturist,uncountable,lookalike,anoxic,ionospheric,genealogists,chicopee,imprinting,popish,crematoria,diamondback,cyathea,hanzhong,cameramen,halogaland,naklo,waclaw,storehouses,flexed,comuni,frits,glauca,nilgiris,compresses,nainital,continuations,albay,hypoxic,samajwadi,dunkerque,nanticoke,sarwar,interchanged,jubal,corba,jalgaon,derleth,deathstroke,magny,vinnytsia,hyphenated,rimfire,sawan,boehner,disrepute,normalize,aromanian,dualistic,approximant,chama,karimabad,barnacles,sanok,stipends,dyfed,rijksmuseum,reverberation,suncorp,fungicides,reverie,spectrograph,stereophonic,niazi,ordos,alcan,karaite,lautrec,tableland,lamellar,rieti,langmuir,russula,webern,tweaks,hawick,southerner,morphy,naturalisation,enantiomer,michinoku,barbettes,relieves,carburettors,redruth,oblates,vocabularies,mogilev,bagmati,galium,reasserted,extolled,symon,eurosceptic,inflections,tirtha,recompense,oruro,roping,gouverneur,pared,yayoi,watermills,retooled,leukocytes,jubilant,mazhar,nicolau,manheim,touraine,bedser,hambledon,kohat,powerhouses,tlemcen,reuven,sympathetically,afrikaners,interes,handcrafts,etcher,baddeley,wodonga,amaury,155th,vulgarity,pompadour,automorphisms,1540s,oppositions,prekmurje,deryni,fortifying,arcuate,mahila,bocage,uther,nozze,slashes,atlantica,hadid,rhizomatous,azeris,'with,osmena,lewisville,innervated,bandmaster,outcropping,parallelogram,dominicana,twang,ingushetia,extensional,ladino,sastry,zinoviev,relatable,nobilis,cbeebies,hitless,eulima,sporangia,synge,longlisted,criminalized,penitential,weyden,tubule,volyn,priestesses,glenbrook,kibbutzim,windshaft,canadair,falange,zsolt,bonheur,meine,archangels,safeguarded,jamaicans,malarial,teasers,badging,merseyrail,operands,pulsars,gauchos,biotin,bambara,necaxa,egmond,tillage,coppi,anxiolytic,preah,mausoleums,plautus,feroz,debunked,187th,belediyespor,mujibur,wantage,carboxyl,chettiar,murnau,vagueness,racemic,backstretch,courtland,municipio,palpatine,dezful,hyperbola,sreekumar,chalons,altay,arapahoe,tudors,sapieha,quilon,burdensome,kanya,xxviii,recension,generis,siphuncle,repressor,bitrate,mandals,midhurst,dioxin,democratique,upholds,rodez,cinematographic,epoque,jinping,rabelais,zhytomyr,glenview,rebooted,khalidi,reticulata,122nd,monnaie,passersby,ghazals,europaea,lippmann,earthbound,tadic,andorran,artvin,angelicum,banksy,epicentre,resemblances,shuttled,rathaus,bernt,stonemasons,balochi,siang,tynemouth,cygni,biosynthetic,precipitates,sharecroppers,d'annunzio,softbank,shiji,apeldoorn,polycyclic,wenceslas,wuchang,samnites,tamarack,silmarillion,madinah,palaeontology,kirchberg,sculpin,rohtak,aquabats,oviparous,thynne,caney,blimps,minimalistic,whatcom,palatalization,bardstown,direct3d,paramagnetic,kamboja,khash,globemaster,lengua,matej,chernigov,swanage,arsenals,cascadia,cundinamarca,tusculum,leavers,organics,warplanes,'three,exertions,arminius,gandharva,inquires,comercio,kuopio,chabahar,plotlines,mersenne,anquetil,paralytic,buckminster,ambit,acrolophus,quantifiers,clacton,ciliary,ansaldo,fergana,egoism,thracians,chicoutimi,northbrook,analgesia,brotherhoods,hunza,adriaen,fluoridation,snowfalls,soundboard,fangoria,cannibalistic,orthogonius,chukotka,dindigul,manzoni,chainz,macromedia,beltline,muruga,schistura,provable,litex,initio,pneumoniae,infosys,cerium,boonton,cannonballs,d'une,solvency,mandurah,houthis,dolmens,apologists,radioisotopes,blaxploitation,poroshenko,stawell,coosa,maximilien,tempelhof,espouse,declaratory,hambro,xalapa,outmoded,mihiel,benefitting,desirous,archeparchy,repopulated,telescoping,captor,mackaye,disparaged,ramanathan,crowne,tumbled,technetium,silted,chedi,nievre,hyeon,cartoonish,interlock,infocom,rediff.com,dioramas,timekeeping,concertina,kutaisi,cesky,lubomirski,unapologetic,epigraphic,stalactites,sneha,biofilm,falconry,miraflores,catena,'outstanding,prospekt,apotheosis,o'odham,pacemakers,arabica,gandhinagar,reminisces,iroquoian,ornette,tilling,neoliberalism,chameleons,pandava,prefontaine,haiyan,gneisenau,utama,bando,reconstitution,azaria,canola,paratroops,ayckbourn,manistee,stourton,manifestos,lympne,denouement,tractatus,rakim,bellflower,nanometer,sassanids,turlough,presbyterianism,varmland,20deg,phool,nyerere,almohad,manipal,vlaanderen,quickness,removals,makow,circumflex,eatery,morane,fondazione,alkylation,unenforceable,galliano,silkworm,junior/senior,abducts,phlox,konskie,lofoten,buuren,glyphosate,faired,naturae,cobbles,taher,skrulls,dostoevsky,walkout,wagnerian,orbited,methodically,denzil,sarat,extraterritorial,kohima,d'armor,brinsley,rostropovich,fengtian,comitatus,aravind,moche,wrangell,giscard,vantaa,viljandi,hakoah,seabees,muscatine,ballade,camanachd,sothern,mullioned,durad,margraves,maven,arete,chandni,garifuna,142nd,reading/literature,thickest,intensifies,trygve,khaldun,perinatal,asana,powerline,acetylation,nureyev,omiya,montesquieu,riverwalk,marly,correlating,intermountain,bulgar,hammerheads,underscores,wiretapping,quatrain,ruisseau,newsagent,tuticorin,polygyny,hemsworth,partisanship,banna,istrian,evaporator".split(","),
    female_names: "mary,patricia,linda,barbara,elizabeth,jennifer,maria,susan,margaret,dorothy,lisa,nancy,karen,betty,helen,sandra,donna,carol,ruth,sharon,michelle,laura,sarah,kimberly,deborah,jessica,shirley,cynthia,angela,melissa,brenda,amy,anna,rebecca,virginia,kathleen,pamela,martha,debra,amanda,stephanie,carolyn,christine,marie,janet,catherine,frances,ann,joyce,diane,alice,julie,heather,teresa,doris,gloria,evelyn,jean,cheryl,mildred,katherine,joan,ashley,judith,rose,janice,kelly,nicole,judy,christina,kathy,theresa,beverly,denise,tammy,irene,jane,lori,rachel,marilyn,andrea,kathryn,louise,sara,anne,jacqueline,wanda,bonnie,julia,ruby,lois,tina,phyllis,norma,paula,diana,annie,lillian,emily,robin,peggy,crystal,gladys,rita,dawn,connie,florence,tracy,edna,tiffany,carmen,rosa,cindy,grace,wendy,victoria,edith,kim,sherry,sylvia,josephine,thelma,shannon,sheila,ethel,ellen,elaine,marjorie,carrie,charlotte,monica,esther,pauline,emma,juanita,anita,rhonda,hazel,amber,eva,debbie,april,leslie,clara,lucille,jamie,joanne,eleanor,valerie,danielle,megan,alicia,suzanne,michele,gail,bertha,darlene,veronica,jill,erin,geraldine,lauren,cathy,joann,lorraine,lynn,sally,regina,erica,beatrice,dolores,bernice,audrey,yvonne,annette,marion,dana,stacy,ana,renee,ida,vivian,roberta,holly,brittany,melanie,loretta,yolanda,jeanette,laurie,katie,kristen,vanessa,alma,sue,elsie,beth,jeanne,vicki,carla,tara,rosemary,eileen,terri,gertrude,lucy,tonya,ella,stacey,wilma,gina,kristin,jessie,natalie,agnes,vera,charlene,bessie,delores,melinda,pearl,arlene,maureen,colleen,allison,tamara,joy,georgia,constance,lillie,claudia,jackie,marcia,tanya,nellie,minnie,marlene,heidi,glenda,lydia,viola,courtney,marian,stella,caroline,dora,vickie,mattie,maxine,irma,mabel,marsha,myrtle,lena,christy,deanna,patsy,hilda,gwendolyn,jennie,nora,margie,nina,cassandra,leah,penny,kay,priscilla,naomi,carole,olga,billie,dianne,tracey,leona,jenny,felicia,sonia,miriam,velma,becky,bobbie,violet,kristina,toni,misty,mae,shelly,daisy,ramona,sherri,erika,katrina,claire,lindsey,lindsay,geneva,guadalupe,belinda,margarita,sheryl,cora,faye,ada,sabrina,isabel,marguerite,hattie,harriet,molly,cecilia,kristi,brandi,blanche,sandy,rosie,joanna,iris,eunice,angie,inez,lynda,madeline,amelia,alberta,genevieve,monique,jodi,janie,kayla,sonya,jan,kristine,candace,fannie,maryann,opal,alison,yvette,melody,luz,susie,olivia,flora,shelley,kristy,mamie,lula,lola,verna,beulah,antoinette,candice,juana,jeannette,pam,kelli,whitney,bridget,karla,celia,latoya,patty,shelia,gayle,della,vicky,lynne,sheri,marianne,kara,jacquelyn,erma,blanca,myra,leticia,pat,krista,roxanne,angelica,robyn,adrienne,rosalie,alexandra,brooke,bethany,sadie,bernadette,traci,jody,kendra,nichole,rachael,mable,ernestine,muriel,marcella,elena,krystal,angelina,nadine,kari,estelle,dianna,paulette,lora,mona,doreen,rosemarie,desiree,antonia,janis,betsy,christie,freda,meredith,lynette,teri,cristina,eula,leigh,meghan,sophia,eloise,rochelle,gretchen,cecelia,raquel,henrietta,alyssa,jana,gwen,jenna,tricia,laverne,olive,tasha,silvia,elvira,delia,kate,patti,lorena,kellie,sonja,lila,lana,darla,mindy,essie,mandy,lorene,elsa,josefina,jeannie,miranda,dixie,lucia,marta,faith,lela,johanna,shari,camille,tami,shawna,elisa,ebony,melba,ora,nettie,tabitha,ollie,winifred,kristie,alisha,aimee,rena,myrna,marla,tammie,latasha,bonita,patrice,ronda,sherrie,addie,francine,deloris,stacie,adriana,cheri,abigail,celeste,jewel,cara,adele,rebekah,lucinda,dorthy,effie,trina,reba,sallie,aurora,lenora,etta,lottie,kerri,trisha,nikki,estella,francisca,josie,tracie,marissa,karin,brittney,janelle,lourdes,laurel,helene,fern,elva,corinne,kelsey,ina,bettie,elisabeth,aida,caitlin,ingrid,iva,eugenia,christa,goldie,maude,jenifer,therese,dena,lorna,janette,latonya,candy,consuelo,tamika,rosetta,debora,cherie,polly,dina,jewell,fay,jillian,dorothea,nell,trudy,esperanza,patrica,kimberley,shanna,helena,cleo,stefanie,rosario,ola,janine,mollie,lupe,alisa,lou,maribel,susanne,bette,susana,elise,cecile,isabelle,lesley,jocelyn,paige,joni,rachelle,leola,daphne,alta,ester,petra,graciela,imogene,jolene,keisha,lacey,glenna,gabriela,keri,ursula,lizzie,kirsten,shana,adeline,mayra,jayne,jaclyn,gracie,sondra,carmela,marisa,rosalind,charity,tonia,beatriz,marisol,clarice,jeanine,sheena,angeline,frieda,lily,shauna,millie,claudette,cathleen,angelia,gabrielle,autumn,katharine,jodie,staci,lea,christi,justine,elma,luella,margret,dominique,socorro,martina,margo,mavis,callie,bobbi,maritza,lucile,leanne,jeannine,deana,aileen,lorie,ladonna,willa,manuela,gale,selma,dolly,sybil,abby,ivy,dee,winnie,marcy,luisa,jeri,magdalena,ofelia,meagan,audra,matilda,leila,cornelia,bianca,simone,bettye,randi,virgie,latisha,barbra,georgina,eliza,leann,bridgette,rhoda,haley,adela,nola,bernadine,flossie,ila,greta,ruthie,nelda,minerva,lilly,terrie,letha,hilary,estela,valarie,brianna,rosalyn,earline,catalina,ava,mia,clarissa,lidia,corrine,alexandria,concepcion,tia,sharron,rae,dona,ericka,jami,elnora,chandra,lenore,neva,marylou,melisa,tabatha,serena,avis,allie,sofia,jeanie,odessa,nannie,harriett,loraine,penelope,milagros,emilia,benita,allyson,ashlee,tania,esmeralda,eve,pearlie,zelma,malinda,noreen,tameka,saundra,hillary,amie,althea,rosalinda,lilia,alana,clare,alejandra,elinor,lorrie,jerri,darcy,earnestine,carmella,noemi,marcie,liza,annabelle,louisa,earlene,mallory,carlene,nita,selena,tanisha,katy,julianne,lakisha,edwina,maricela,margery,kenya,dollie,roxie,roslyn,kathrine,nanette,charmaine,lavonne,ilene,tammi,suzette,corine,kaye,chrystal,lina,deanne,lilian,juliana,aline,luann,kasey,maryanne,evangeline,colette,melva,lawanda,yesenia,nadia,madge,kathie,ophelia,valeria,nona,mitzi,mari,georgette,claudine,fran,alissa,roseann,lakeisha,susanna,reva,deidre,chasity,sheree,elvia,alyce,deirdre,gena,briana,araceli,katelyn,rosanne,wendi,tessa,berta,marva,imelda,marietta,marci,leonor,arline,sasha,madelyn,janna,juliette,deena,aurelia,josefa,augusta,liliana,lessie,amalia,savannah,anastasia,vilma,natalia,rosella,lynnette,corina,alfreda,leanna,amparo,coleen,tamra,aisha,wilda,karyn,maura,mai,evangelina,rosanna,hallie,erna,enid,mariana,lacy,juliet,jacklyn,freida,madeleine,mara,cathryn,lelia,casandra,bridgett,angelita,jannie,dionne,annmarie,katina,beryl,millicent,katheryn,diann,carissa,maryellen,liz,lauri,helga,gilda,rhea,marquita,hollie,tisha,tamera,angelique,francesca,kaitlin,lolita,florine,rowena,reyna,twila,fanny,janell,ines,concetta,bertie,alba,brigitte,alyson,vonda,pansy,elba,noelle,letitia,deann,brandie,louella,leta,felecia,sharlene,lesa,beverley,isabella,herminia,terra,celina,tori,octavia,jade,denice,germaine,michell,cortney,nelly,doretha,deidra,monika,lashonda,judi,chelsey,antionette,margot,adelaide,leeann,elisha,dessie,libby,kathi,gayla,latanya,mina,mellisa,kimberlee,jasmin,renae,zelda,elda,justina,gussie,emilie,camilla,abbie,rocio,kaitlyn,edythe,ashleigh,selina,lakesha,geri,allene,pamala,michaela,dayna,caryn,rosalia,jacquline,rebeca,marybeth,krystle,iola,dottie,belle,griselda,ernestina,elida,adrianne,demetria,delma,jaqueline,arleen,virgina,retha,fatima,tillie,eleanore,cari,treva,wilhelmina,rosalee,maurine,latrice,jena,taryn,elia,debby,maudie,jeanna,delilah,catrina,shonda,hortencia,theodora,teresita,robbin,danette,delphine,brianne,nilda,danna,cindi,bess,iona,winona,vida,rosita,marianna,racheal,guillermina,eloisa,celestine,caren,malissa,lona,chantel,shellie,marisela,leora,agatha,soledad,migdalia,ivette,christen,athena,janel,veda,pattie,tessie,tera,marilynn,lucretia,karrie,dinah,daniela,alecia,adelina,vernice,shiela,portia,merry,lashawn,dara,tawana,verda,alene,zella,sandi,rafaela,maya,kira,candida,alvina,suzan,shayla,lettie,samatha,oralia,matilde,larissa,vesta,renita,delois,shanda,phillis,lorri,erlinda,cathrine,barb,isabell,ione,gisela,roxanna,mayme,kisha,ellie,mellissa,dorris,dalia,bella,annetta,zoila,reta,reina,lauretta,kylie,christal,pilar,charla,elissa,tiffani,tana,paulina,leota,breanna,jayme,carmel,vernell,tomasa,mandi,dominga,santa,melodie,lura,alexa,tamela,mirna,kerrie,venus,felicita,cristy,carmelita,berniece,annemarie,tiara,roseanne,missy,cori,roxana,pricilla,kristal,jung,elyse,haydee,aletha,bettina,marge,gillian,filomena,zenaida,harriette,caridad,vada,aretha,pearline,marjory,marcela,flor,evette,elouise,alina,damaris,catharine,belva,nakia,marlena,luanne,lorine,karon,dorene,danita,brenna,tatiana,louann,julianna,andria,philomena,lucila,leonora,dovie,romona,mimi,jacquelin,gaye,tonja,misti,chastity,stacia,roxann,micaela,velda,marlys,johnna,aura,ivonne,hayley,nicki,majorie,herlinda,yadira,perla,gregoria,antonette,shelli,mozelle,mariah,joelle,cordelia,josette,chiquita,trista,laquita,georgiana,candi,shanon,hildegard,stephany,magda,karol,gabriella,tiana,roma,richelle,oleta,jacque,idella,alaina,suzanna,jovita,tosha,nereida,marlyn,kyla,delfina,tena,stephenie,sabina,nathalie,marcelle,gertie,darleen,thea,sharonda,shantel,belen,venessa,rosalina,genoveva,clementine,rosalba,renate,renata,georgianna,floy,dorcas,ariana,tyra,theda,mariam,juli,jesica,vikki,verla,roselyn,melvina,jannette,ginny,debrah,corrie,violeta,myrtis,latricia,collette,charleen,anissa,viviana,twyla,nedra,latonia,hellen,fabiola,annamarie,adell,sharyn,chantal,niki,maud,lizette,lindy,kesha,jeana,danelle,charline,chanel,valorie,dortha,cristal,sunny,leone,leilani,gerri,debi,andra,keshia,eulalia,easter,dulce,natividad,linnie,kami,georgie,catina,brook,alda,winnifred,sharla,ruthann,meaghan,magdalene,lissette,adelaida,venita,trena,shirlene,shameka,elizebeth,dian,shanta,latosha,carlotta,windy,rosina,mariann,leisa,jonnie,dawna,cathie,astrid,laureen,janeen,holli,fawn,vickey,teressa,shante,rubye,marcelina,chanda,terese,scarlett,marnie,lulu,lisette,jeniffer,elenor,dorinda,donita,carman,bernita,altagracia,aleta,adrianna,zoraida,lyndsey,janina,starla,phylis,phuong,kyra,charisse,blanch,sanjuanita,rona,nanci,marilee,maranda,brigette,sanjuana,marita,kassandra,joycelyn,felipa,chelsie,bonny,mireya,lorenza,kyong,ileana,candelaria,sherie,lucie,leatrice,lakeshia,gerda,edie,bambi,marylin,lavon,hortense,garnet,evie,tressa,shayna,lavina,kyung,jeanetta,sherrill,shara,phyliss,mittie,anabel,alesia,thuy,tawanda,joanie,tiffanie,lashanda,karissa,enriqueta,daria,daniella,corinna,alanna,abbey,roxane,roseanna,magnolia,lida,joellen,coral,carleen,tresa,peggie,novella,nila,maybelle,jenelle,carina,nova,melina,marquerite,margarette,josephina,evonne,cinthia,albina,toya,tawnya,sherita,myriam,lizabeth,lise,keely,jenni,giselle,cheryle,ardith,ardis,alesha,adriane,shaina,linnea,karolyn,felisha,dori,darci,artie,armida,zola,xiomara,vergie,shamika,nena,nannette,maxie,lovie,jeane,jaimie,inge,farrah,elaina,caitlyn,felicitas,cherly,caryl,yolonda,yasmin,teena,prudence,pennie,nydia,mackenzie,orpha,marvel,lizbeth,laurette,jerrie,hermelinda,carolee,tierra,mirian,meta,melony,kori,jennette,jamila,yoshiko,susannah,salina,rhiannon,joleen,cristine,ashton,aracely,tomeka,shalonda,marti,lacie,kala,jada,ilse,hailey,brittani,zona,syble,sherryl,nidia,marlo,kandice,kandi,alycia,ronna,norene,mercy,ingeborg,giovanna,gemma,christel,audry,zora,vita,trish,stephaine,shirlee,shanika,melonie,mazie,jazmin,inga,hettie,geralyn,fonda,estrella,adella,sarita,rina,milissa,maribeth,golda,evon,ethelyn,enedina,cherise,chana,velva,tawanna,sade,mirta,karie,jacinta,elna,davina,cierra,ashlie,albertha,tanesha,nelle,mindi,lorinda,larue,florene,demetra,dedra,ciara,chantelle,ashly,suzy,rosalva,noelia,lyda,leatha,krystyna,kristan,karri,darline,darcie,cinda,cherrie,awilda,almeda,rolanda,lanette,jerilyn,gisele,evalyn,cyndi,cleta,carin,zina,zena,velia,tanika,charissa,talia,margarete,lavonda,kaylee,kathlene,jonna,irena,ilona,idalia,candis,candance,brandee,anitra,alida,sigrid,nicolette,maryjo,linette,hedwig,christiana,alexia,tressie,modesta,lupita,lita,gladis,evelia,davida,cherri,cecily,ashely,annabel,agustina,wanita,shirly,rosaura,hulda,yetta,verona,thomasina,sibyl,shannan,mechelle,leandra,lani,kylee,kandy,jolynn,ferne,eboni,corene,alysia,zula,nada,moira,lyndsay,lorretta,jammie,hortensia,gaynell,adria,vina,vicenta,tangela,stephine,norine,nella,liana,leslee,kimberely,iliana,glory,felica,emogene,elfriede,eden,eartha,carma,ocie,lennie,kiara,jacalyn,carlota,arielle,otilia,kirstin,kacey,johnetta,joetta,jeraldine,jaunita,elana,dorthea,cami,amada,adelia,vernita,tamar,siobhan,renea,rashida,ouida,nilsa,meryl,kristyn,julieta,danica,breanne,aurea,anglea,sherron,odette,malia,lorelei,leesa,kenna,kathlyn,fiona,charlette,suzie,shantell,sabra,racquel,myong,mira,martine,lucienne,lavada,juliann,elvera,delphia,christiane,charolette,carri,asha,angella,paola,ninfa,leda,stefani,shanell,palma,machelle,lissa,kecia,kathryne,karlene,julissa,jettie,jenniffer,corrina,carolann,alena,rosaria,myrtice,marylee,liane,kenyatta,judie,janey,elmira,eldora,denna,cristi,cathi,zaida,vonnie,viva,vernie,rosaline,mariela,luciana,lesli,karan,felice,deneen,adina,wynona,tarsha,sheron,shanita,shani,shandra,randa,pinkie,nelida,marilou,lyla,laurene,laci,janene,dorotha,daniele,dani,carolynn,carlyn,berenice,ayesha,anneliese,alethea,thersa,tamiko,rufina,oliva,mozell,marylyn,kristian,kathyrn,kasandra,kandace,janae,domenica,debbra,dannielle,chun,arcelia,zenobia,sharen,sharee,lavinia,kacie,jackeline,huong,felisa,emelia,eleanora,cythia,cristin,claribel,anastacia,zulma,zandra,yoko,tenisha,susann,sherilyn,shay,shawanda,romana,mathilda,linsey,keiko,joana,isela,gretta,georgetta,eugenie,desirae,delora,corazon,antonina,anika,willene,tracee,tamatha,nichelle,mickie,maegan,luana,lanita,kelsie,edelmira,bree,afton,teodora,tamie,shena,linh,keli,kaci,danyelle,arlette,albertine,adelle,tiffiny,simona,nicolasa,nichol,nakisha,maira,loreen,kizzy,fallon,christene,bobbye,ying,vincenza,tanja,rubie,roni,queenie,margarett,kimberli,irmgard,idell,hilma,evelina,esta,emilee,dennise,dania,carie,risa,rikki,particia,masako,luvenia,loree,loni,lien,gigi,florencia,denita,billye,tomika,sharita,rana,nikole,neoma,margarite,madalyn,lucina,laila,kali,jenette,gabriele,evelyne,elenora,clementina,alejandrina,zulema,violette,vannessa,thresa,retta,patience,noella,nickie,jonell,chaya,camelia,bethel,anya,suzann,mila,lilla,laverna,keesha,kattie,georgene,eveline,estell,elizbeth,vivienne,vallie,trudie,stephane,magaly,madie,kenyetta,karren,janetta,hermine,drucilla,debbi,celestina,candie,britni,beckie,amina,zita,yolande,vivien,vernetta,trudi,pearle,patrina,ossie,nicolle,loyce,letty,katharina,joselyn,jonelle,jenell,iesha,heide,florinda,florentina,elodia,dorine,brunilda,brigid,ashli,ardella,twana,tarah,shavon,serina,rayna,ramonita,margurite,lucrecia,kourtney,kati,jesenia,crista,ayana,alica,alia,vinnie,suellen,romelia,rachell,olympia,michiko,kathaleen,jolie,jessi,janessa,hana,elease,carletta,britany,shona,salome,rosamond,regena,raina,ngoc,nelia,louvenia,lesia,latrina,laticia,larhonda,jina,jacki,emmy,deeann,coretta,arnetta,thalia,shanice,neta,mikki,micki,lonna,leana,lashunda,kiley,joye,jacqulyn,ignacia,hyun,hiroko,henriette,elayne,delinda,dahlia,coreen,consuela,conchita,babette,ayanna,anette,albertina,shawnee,shaneka,quiana,pamelia,merri,merlene,margit,kiesha,kiera,kaylene,jodee,jenise,erlene,emmie,dalila,daisey,casie,belia,babara,versie,vanesa,shelba,shawnda,nikia,naoma,marna,margeret,madaline,lawana,kindra,jutta,jazmine,janett,hannelore,glendora,gertrud,garnett,freeda,frederica,florance,flavia,carline,beverlee,anjanette,valda,tamala,shonna,sarina,oneida,merilyn,marleen,lurline,lenna,katherin,jeni,gracia,glady,farah,enola,dominque,devona,delana,cecila,caprice,alysha,alethia,vena,theresia,tawny,shakira,samara,sachiko,rachele,pamella,marni,mariel,maren,malisa,ligia,lera,latoria,larae,kimber,kathern,karey,jennefer,janeth,halina,fredia,delisa,debroah,ciera,angelika,andree,altha,vivan,terresa,tanna,sudie,signe,salena,ronni,rebbecca,myrtie,malika,maida,leonarda,kayleigh,ethyl,ellyn,dayle,cammie,brittni,birgit,avelina,asuncion,arianna,akiko,venice,tyesha,tonie,tiesha,takisha,steffanie,sindy,meghann,manda,macie,kellye,kellee,joslyn,inger,indira,glinda,glennis,fernanda,faustina,eneida,elicia,digna,dell,arletta,willia,tammara,tabetha,sherrell,sari,rebbeca,pauletta,natosha,nakita,mammie,kenisha,kazuko,kassie,earlean,daphine,corliss,clotilde,carolyne,bernetta,augustina,audrea,annis,annabell,tennille,tamica,selene,rosana,regenia,qiana,markita,macy,leeanne,laurine,jessenia,janita,georgine,genie,emiko,elvie,deandra,dagmar,corie,collen,cherish,romaine,porsha,pearlene,micheline,merna,margorie,margaretta,lore,jenine,hermina,fredericka,elke,drusilla,dorathy,dione,celena,brigida,allegra,tamekia,synthia,sook,slyvia,rosann,reatha,raye,marquetta,margart,ling,layla,kymberly,kiana,kayleen,katlyn,karmen,joella,emelda,eleni,detra,clemmie,cheryll,chantell,cathey,arnita,arla,angle,angelic,alyse,zofia,thomasine,tennie,sherly,sherley,sharyl,remedios,petrina,nickole,myung,myrle,mozella,louanne,lisha,latia,krysta,julienne,jeanene,jacqualine,isaura,gwenda,earleen,cleopatra,carlie,audie,antonietta,alise,verdell,tomoko,thao,talisha,shemika,savanna,santina,rosia,raeann,odilia,nana,minna,magan,lynelle,karma,joeann,ivana,inell,ilana,gudrun,dreama,crissy,chante,carmelina,arvilla,annamae,alvera,aleida,yanira,vanda,tianna,stefania,shira,nicol,nancie,monserrate,melynda,melany,lovella,laure,kacy,jacquelynn,hyon,gertha,eliana,christena,christeen,charise,caterina,carley,candyce,arlena,ammie,willette,vanita,tuyet,syreeta,penney,nyla,maryam,marya,magen,ludie,loma,livia,lanell,kimberlie,julee,donetta,diedra,denisha,deane,dawne,clarine,cherryl,bronwyn,alla,valery,tonda,sueann,soraya,shoshana,shela,sharleen,shanelle,nerissa,meridith,mellie,maye,maple,magaret,lili,leonila,leonie,leeanna,lavonia,lavera,kristel,kathey,kathe,jann,ilda,hildred,hildegarde,genia,fumiko,evelin,ermelinda,elly,dung,doloris,dionna,danae,berneice,annice,alix,verena,verdie,shawnna,shawana,shaunna,rozella,randee,ranae,milagro,lynell,luise,loida,lisbeth,karleen,junita,jona,isis,hyacinth,hedy,gwenn,ethelene,erline,donya,domonique,delicia,dannette,cicely,branda,blythe,bethann,ashlyn,annalee,alline,yuko,vella,trang,towanda,tesha,sherlyn,narcisa,miguelina,meri,maybell,marlana,marguerita,madlyn,lory,loriann,leonore,leighann,laurice,latesha,laronda,katrice,kasie,kaley,jadwiga,glennie,gearldine,francina,epifania,dyan,dorie,diedre,denese,demetrice,delena,cristie,cleora,catarina,carisa,barbera,almeta,trula,tereasa,solange,sheilah,shavonne,sanora,rochell,mathilde,margareta,maia,lynsey,lawanna,launa,kena,keena,katia,glynda,gaylene,elvina,elanor,danuta,danika,cristen,cordie,coletta,clarita,carmon,brynn,azucena,aundrea,angele,verlie,verlene,tamesha,silvana,sebrina,samira,reda,raylene,penni,norah,noma,mireille,melissia,maryalice,laraine,kimbery,karyl,karine,jolanda,johana,jesusa,jaleesa,jacquelyne,iluminada,hilaria,hanh,gennie,francie,floretta,exie,edda,drema,delpha,barbar,assunta,ardell,annalisa,alisia,yukiko,yolando,wonda,waltraud,veta,temeka,tameika,shirleen,shenita,piedad,ozella,mirtha,marilu,kimiko,juliane,jenice,janay,jacquiline,hilde,elois,echo,devorah,chau,brinda,betsey,arminda,aracelis,apryl,annett,alishia,veola,usha,toshiko,theola,tashia,talitha,shery,renetta,reiko,rasheeda,obdulia,mika,melaine,meggan,marlen,marget,marceline,mana,magdalen,librada,lezlie,latashia,lasandra,kelle,isidra,inocencia,gwyn,francoise,erminia,erinn,dimple,devora,criselda,armanda,arie,ariane,angelena,aliza,adriene,adaline,xochitl,twanna,tomiko,tamisha,taisha,susy,rutha,rhona,noriko,natashia,merrie,marinda,mariko,margert,loris,lizzette,leisha,kaila,joannie,jerrica,jene,jannet,janee,jacinda,herta,elenore,doretta,delaine,daniell,claudie,britta,apolonia,amberly,alease,yuri,waneta,tomi,sharri,sandie,roselle,reynalda,raguel,phylicia,patria,olimpia,odelia,mitzie,minda,mignon,mica,mendy,marivel,maile,lynetta,lavette,lauryn,latrisha,lakiesha,kiersten,kary,josphine,jolyn,jetta,janise,jacquie,ivelisse,glynis,gianna,gaynelle,danyell,danille,dacia,coralee,cher,ceola,arianne,aleshia,yung,williemae,trinh,thora,sherika,shemeka,shaunda,roseline,ricki,melda,mallie,lavonna,latina,laquanda,lala,lachelle,klara,kandis,johna,jeanmarie,jaye,grayce,gertude,emerita,ebonie,clorinda,ching,chery,carola,breann,blossom,bernardine,becki,arletha,argelia,alita,yulanda,yessenia,tobi,tasia,sylvie,shirl,shirely,shella,shantelle,sacha,rebecka,providencia,paulene,misha,miki,marline,marica,lorita,latoyia,lasonya,kerstin,kenda,keitha,kathrin,jaymie,gricelda,ginette,eryn,elina,elfrieda,danyel,cheree,chanelle,barrie,aurore,annamaria,alleen,ailene,aide,yasmine,vashti,treasa,tiffaney,sheryll,sharie,shanae,raisa,neda,mitsuko,mirella,milda,maryanna,maragret,mabelle,luetta,lorina,letisha,latarsha,lanelle,lajuana,krissy,karly,karena,jessika,jerica,jeanelle,jalisa,jacelyn,izola,euna,etha,domitila,dominica,daina,creola,carli,camie,brittny,ashanti,anisha,aleen,adah,yasuko,valrie,tona,tinisha,terisa,taneka,simonne,shalanda,serita,ressie,refugia,olene,margherita,mandie,maire,lyndia,luci,lorriane,loreta,leonia,lavona,lashawnda,lakia,kyoko,krystina,krysten,kenia,kelsi,jeanice,isobel,georgiann,genny,felicidad,eilene,deloise,deedee,conception,clora,cherilyn,calandra,armandina,anisa,tiera,theressa,stephania,sima,shyla,shonta,shera,shaquita,shala,rossana,nohemi,nery,moriah,melita,melida,melani,marylynn,marisha,mariette,malorie,madelene,ludivina,loria,lorette,loralee,lianne,lavenia,laurinda,lashon,kimi,keila,katelynn,jone,joane,jayna,janella,hertha,francene,elinore,despina,delsie,deedra,clemencia,carolin,bulah,brittanie,blondell,bibi,beaulah,beata,annita,agripina,virgen,valene,twanda,tommye,tarra,tari,tammera,shakia,sadye,ruthanne,rochel,rivka,pura,nenita,natisha,ming,merrilee,melodee,marvis,lucilla,leena,laveta,larita,lanie,keren,ileen,georgeann,genna,frida,eufemia,emely,edyth,deonna,deadra,darlena,chanell,cathern,cassondra,cassaundra,bernarda,berna,arlinda,anamaria,vertie,valeri,torri,stasia,sherise,sherill,sanda,ruthe,rosy,robbi,ranee,quyen,pearly,palmira,onita,nisha,niesha,nida,merlyn,mayola,marylouise,marth,margene,madelaine,londa,leontine,leoma,leia,lauralee,lanora,lakita,kiyoko,keturah,katelin,kareen,jonie,johnette,jenee,jeanett,izetta,hiedi,heike,hassie,giuseppina,georgann,fidela,fernande,elwanda,ellamae,eliz,dusti,dotty,cyndy,coralie,celesta,alverta,xenia,wava,vanetta,torrie,tashina,tandy,tambra,tama,stepanie,shila,shaunta,sharan,shaniqua,shae,setsuko,serafina,sandee,rosamaria,priscila,olinda,nadene,muoi,michelina,mercedez,maryrose,marcene,magali,mafalda,lannie,kayce,karoline,kamilah,kamala,justa,joline,jennine,jacquetta,iraida,georgeanna,franchesca,emeline,elane,ehtel,earlie,dulcie,dalene,classie,chere,charis,caroyln,carmina,carita,bethanie,ayako,arica,alysa,alessandra,akilah,adrien,zetta,youlanda,yelena,yahaira,xuan,wendolyn,tijuana,terina,teresia,suzi,sherell,shavonda,shaunte,sharda,shakita,sena,ryann,rubi,riva,reginia,rachal,parthenia,pamula,monnie,monet,michaele,melia,malka,maisha,lisandra,lekisha,lean,lakendra,krystin,kortney,kizzie,kittie,kera,kendal,kemberly,kanisha,julene,jule,johanne,jamee,halley,gidget,fredricka,fleta,fatimah,eusebia,elza,eleonore,dorthey,doria,donella,dinorah,delorse,claretha,christinia,charlyn,bong,belkis,azzie,andera,aiko,adena,yajaira,vania,ulrike,toshia,tifany,stefany,shizue,shenika,shawanna,sharolyn,sharilyn,shaquana,shantay,rozanne,roselee,remona,reanna,raelene,phung,petronila,natacha,nancey,myrl,miyoko,miesha,merideth,marvella,marquitta,marhta,marchelle,lizeth,libbie,lahoma,ladawn,kina,katheleen,katharyn,karisa,kaleigh,junie,julieann,johnsie,janean,jaimee,jackqueline,hisako,herma,helaine,gwyneth,gita,eustolia,emelina,elin,edris,donnette,donnetta,dierdre,denae,darcel,clarisa,cinderella,chia,charlesetta,charita,celsa,cassy,cassi,carlee,bruna,brittaney,brande,billi,antonetta,angla,angelyn,analisa,alane,wenona,wendie,veronique,vannesa,tobie,tempie,sumiko,sulema,somer,sheba,sharice,shanel,shalon,rosio,roselia,renay,rema,reena,ozie,oretha,oralee,ngan,nakesha,milly,marybelle,margrett,maragaret,manie,lurlene,lillia,lieselotte,lavelle,lashaunda,lakeesha,kaycee,kalyn,joya,joette,jenae,janiece,illa,grisel,glayds,genevie,gala,fredda,eleonor,debera,deandrea,corrinne,cordia,contessa,colene,cleotilde,chantay,cecille,beatris,azalee,arlean,ardath,anjelica,anja,alfredia,aleisha,zada,yuonne,xiao,willodean,vennie,vanna,tyisha,tova,torie,tonisha,tilda,tien,sirena,sherril,shanti,shan,senaida,samella,robbyn,renda,reita,phebe,paulita,nobuko,nguyet,neomi,mikaela,melania,maximina,marg,maisie,lynna,lilli,lashaun,lakenya,lael,kirstie,kathline,kasha,karlyn,karima,jovan,josefine,jennell,jacqui,jackelyn,hien,grazyna,florrie,floria,eleonora,dwana,dorla,delmy,deja,dede,dann,crysta,clelia,claris,chieko,cherlyn,cherelle,charmain,chara,cammy,arnette,ardelle,annika,amiee,amee,allena,yvone,yuki,yoshie,yevette,yael,willetta,voncile,venetta,tula,tonette,timika,temika,telma,teisha,taren,stacee,shawnta,saturnina,ricarda,pasty,onie,nubia,marielle,mariella,marianela,mardell,luanna,loise,lisabeth,lindsy,lilliana,lilliam,lelah,leigha,leanora,kristeen,khalilah,keeley,kandra,junko,joaquina,jerlene,jani,jamika,hsiu,hermila,genevive,evia,eugena,emmaline,elfreda,elene,donette,delcie,deeanna,darcey,clarinda,cira,chae,celinda,catheryn,casimira,carmelia,camellia,breana,bobette,bernardina,bebe,basilia,arlyne,amal,alayna,zonia,zenia,yuriko,yaeko,wynell,willena,vernia,tora,terrilyn,terica,tenesha,tawna,tajuana,taina,stephnie,sona,sina,shondra,shizuko,sherlene,sherice,sharika,rossie,rosena,rima,rheba,renna,natalya,nancee,melodi,meda,matha,marketta,maricruz,marcelene,malvina,luba,louetta,leida,lecia,lauran,lashawna,laine,khadijah,katerine,kasi,kallie,julietta,jesusita,jestine,jessia,jeffie,janyce,isadora,georgianne,fidelia,evita,eura,eulah,estefana,elsy,eladia,dodie,denisse,deloras,delila,daysi,crystle,concha,claretta,charlsie,charlena,carylon,bettyann,asley,ashlea,amira,agueda,agnus,yuette,vinita,victorina,tynisha,treena,toccara,tish,thomasena,tegan,soila,shenna,sharmaine,shantae,shandi,saran,sarai,sana,rosette,rolande,regine,otelia,olevia,nicholle,necole,naida,myrta,myesha,mitsue,minta,mertie,margy,mahalia,madalene,loura,lorean,lesha,leonida,lenita,lavone,lashell,lashandra,lamonica,kimbra,katherina,karry,kanesha,jong,jeneva,jaquelyn,gilma,ghislaine,gertrudis,fransisca,fermina,ettie,etsuko,ellan,elidia,edra,dorethea,doreatha,denyse,deetta,daine,cyrstal,corrin,cayla,carlita,camila,burma,bula,buena,barabara,avril,alaine,zana,wilhemina,wanetta,verline,vasiliki,tonita,tisa,teofila,tayna,taunya,tandra,takako,sunni,suanne,sixta,sharell,seema,rosenda,robena,raymonde,pamila,ozell,neida,mistie,micha,merissa,maurita,maryln,maryetta,marcell,malena,makeda,lovetta,lourie,lorrine,lorilee,laurena,lashay,larraine,laree,lacresha,kristle,keva,keira,karole,joie,jinny,jeannetta,jama,heidy,gilberte,gema,faviola,evelynn,enda,elli,ellena,divina,dagny,collene,codi,cindie,chassidy,chasidy,catrice,catherina,cassey,caroll,carlena,candra,calista,bryanna,britteny,beula,bari,audrie,audria,ardelia,annelle,angila,alona,allyn".split(","),
    surnames: "smith,johnson,williams,jones,brown,davis,miller,wilson,moore,taylor,anderson,jackson,white,harris,martin,thompson,garcia,martinez,robinson,clark,rodriguez,lewis,lee,walker,hall,allen,young,hernandez,king,wright,lopez,hill,green,adams,baker,gonzalez,nelson,carter,mitchell,perez,roberts,turner,phillips,campbell,parker,evans,edwards,collins,stewart,sanchez,morris,rogers,reed,cook,morgan,bell,murphy,bailey,rivera,cooper,richardson,cox,howard,ward,torres,peterson,gray,ramirez,watson,brooks,sanders,price,bennett,wood,barnes,ross,henderson,coleman,jenkins,perry,powell,long,patterson,hughes,flores,washington,butler,simmons,foster,gonzales,bryant,alexander,griffin,diaz,hayes,myers,ford,hamilton,graham,sullivan,wallace,woods,cole,west,owens,reynolds,fisher,ellis,harrison,gibson,mcdonald,cruz,marshall,ortiz,gomez,murray,freeman,wells,webb,simpson,stevens,tucker,porter,hicks,crawford,boyd,mason,morales,kennedy,warren,dixon,ramos,reyes,burns,gordon,shaw,holmes,rice,robertson,hunt,black,daniels,palmer,mills,nichols,grant,knight,ferguson,stone,hawkins,dunn,perkins,hudson,spencer,gardner,stephens,payne,pierce,berry,matthews,arnold,wagner,willis,watkins,olson,carroll,duncan,snyder,hart,cunningham,lane,andrews,ruiz,harper,fox,riley,armstrong,carpenter,weaver,greene,elliott,chavez,sims,peters,kelley,franklin,lawson,fields,gutierrez,schmidt,carr,vasquez,castillo,wheeler,chapman,montgomery,richards,williamson,johnston,banks,meyer,bishop,mccoy,howell,alvarez,morrison,hansen,fernandez,garza,harvey,burton,nguyen,jacobs,reid,fuller,lynch,garrett,romero,welch,larson,frazier,burke,hanson,mendoza,moreno,bowman,medina,fowler,brewer,hoffman,carlson,silva,pearson,holland,fleming,jensen,vargas,byrd,davidson,hopkins,herrera,wade,soto,walters,neal,caldwell,lowe,jennings,barnett,graves,jimenez,horton,shelton,barrett,obrien,castro,sutton,mckinney,lucas,miles,rodriquez,chambers,holt,lambert,fletcher,watts,bates,hale,rhodes,pena,beck,newman,haynes,mcdaniel,mendez,bush,vaughn,parks,dawson,santiago,norris,hardy,steele,curry,powers,schultz,barker,guzman,page,munoz,ball,keller,chandler,weber,walsh,lyons,ramsey,wolfe,schneider,mullins,benson,sharp,bowen,barber,cummings,hines,baldwin,griffith,valdez,hubbard,salazar,reeves,warner,stevenson,burgess,santos,tate,cross,garner,mann,mack,moss,thornton,mcgee,farmer,delgado,aguilar,vega,glover,manning,cohen,harmon,rodgers,robbins,newton,blair,higgins,ingram,reese,cannon,strickland,townsend,potter,goodwin,walton,rowe,hampton,ortega,patton,swanson,goodman,maldonado,yates,becker,erickson,hodges,rios,conner,adkins,webster,malone,hammond,flowers,cobb,moody,quinn,pope,osborne,mccarthy,guerrero,estrada,sandoval,gibbs,gross,fitzgerald,stokes,doyle,saunders,wise,colon,gill,alvarado,greer,padilla,waters,nunez,ballard,schwartz,mcbride,houston,christensen,klein,pratt,briggs,parsons,mclaughlin,zimmerman,buchanan,moran,copeland,pittman,brady,mccormick,holloway,brock,poole,logan,bass,marsh,drake,wong,jefferson,morton,abbott,sparks,norton,huff,massey,figueroa,carson,bowers,roberson,barton,tran,lamb,harrington,boone,cortez,clarke,mathis,singleton,wilkins,cain,underwood,hogan,mckenzie,collier,luna,phelps,mcguire,bridges,wilkerson,nash,summers,atkins,wilcox,pitts,conley,marquez,burnett,cochran,chase,davenport,hood,gates,ayala,sawyer,vazquez,dickerson,hodge,acosta,flynn,espinoza,nicholson,monroe,wolf,morrow,whitaker,oconnor,skinner,ware,molina,kirby,huffman,gilmore,dominguez,oneal,lang,combs,kramer,hancock,gallagher,gaines,shaffer,wiggins,mathews,mcclain,fischer,wall,melton,hensley,bond,dyer,grimes,contreras,wyatt,baxter,snow,mosley,shepherd,larsen,hoover,beasley,petersen,whitehead,meyers,garrison,shields,horn,savage,olsen,schroeder,hartman,woodard,mueller,kemp,deleon,booth,patel,calhoun,wiley,eaton,cline,navarro,harrell,humphrey,parrish,duran,hutchinson,hess,dorsey,bullock,robles,beard,dalton,avila,rich,blackwell,johns,blankenship,trevino,salinas,campos,pruitt,callahan,montoya,hardin,guerra,mcdowell,stafford,gallegos,henson,wilkinson,booker,merritt,atkinson,orr,decker,hobbs,tanner,knox,pacheco,stephenson,glass,rojas,serrano,marks,hickman,sweeney,strong,mcclure,conway,roth,maynard,farrell,lowery,hurst,nixon,weiss,trujillo,ellison,sloan,juarez,winters,mclean,boyer,villarreal,mccall,gentry,carrillo,ayers,lara,sexton,pace,hull,leblanc,browning,velasquez,leach,chang,sellers,herring,noble,foley,bartlett,mercado,landry,durham,walls,barr,mckee,bauer,rivers,bradshaw,pugh,velez,rush,estes,dodson,morse,sheppard,weeks,camacho,bean,barron,livingston,middleton,spears,branch,blevins,chen,kerr,mcconnell,hatfield,harding,solis,frost,giles,blackburn,pennington,woodward,finley,mcintosh,koch,mccullough,blanchard,rivas,brennan,mejia,kane,benton,buckley,valentine,maddox,russo,mcknight,buck,moon,mcmillan,crosby,berg,dotson,mays,roach,chan,richmond,meadows,faulkner,oneill,knapp,kline,ochoa,jacobson,gay,hendricks,horne,shepard,hebert,cardenas,mcintyre,waller,holman,donaldson,cantu,morin,gillespie,fuentes,tillman,bentley,peck,key,salas,rollins,gamble,dickson,santana,cabrera,cervantes,howe,hinton,hurley,spence,zamora,yang,mcneil,suarez,petty,gould,mcfarland,sampson,carver,bray,macdonald,stout,hester,melendez,dillon,farley,hopper,galloway,potts,joyner,stein,aguirre,osborn,mercer,bender,franco,rowland,sykes,pickett,sears,mayo,dunlap,hayden,wilder,mckay,coffey,mccarty,ewing,cooley,vaughan,bonner,cotton,holder,stark,ferrell,cantrell,fulton,lott,calderon,pollard,hooper,burch,mullen,fry,riddle,levy,duke,odonnell,britt,daugherty,berger,dillard,alston,frye,riggs,chaney,odom,duffy,fitzpatrick,valenzuela,mayer,alford,mcpherson,acevedo,barrera,cote,reilly,compton,mooney,mcgowan,craft,clemons,wynn,nielsen,baird,stanton,snider,rosales,bright,witt,hays,holden,rutledge,kinney,clements,castaneda,slater,hahn,burks,delaney,pate,lancaster,sharpe,whitfield,talley,macias,burris,ratliff,mccray,madden,kaufman,beach,goff,cash,bolton,mcfadden,levine,byers,kirkland,kidd,workman,carney,mcleod,holcomb,finch,sosa,haney,franks,sargent,nieves,downs,rasmussen,bird,hewitt,foreman,valencia,oneil,delacruz,vinson,dejesus,hyde,forbes,gilliam,guthrie,wooten,huber,barlow,boyle,mcmahon,buckner,rocha,puckett,langley,knowles,cooke,velazquez,whitley,vang,shea,rouse,hartley,mayfield,elder,rankin,hanna,cowan,lucero,arroyo,slaughter,haas,oconnell,minor,boucher,archer,boggs,dougherty,andersen,newell,crowe,wang,friedman,bland,swain,holley,pearce,childs,yarbrough,galvan,proctor,meeks,lozano,mora,rangel,bacon,villanueva,schaefer,rosado,helms,boyce,goss,stinson,ibarra,hutchins,covington,crowley,hatcher,mackey,bunch,womack,polk,dodd,childress,childers,villa,springer,mahoney,dailey,belcher,lockhart,griggs,costa,brandt,walden,moser,tatum,mccann,akers,lutz,pryor,orozco,mcallister,lugo,davies,shoemaker,rutherford,newsome,magee,chamberlain,blanton,simms,godfrey,flanagan,crum,cordova,escobar,downing,sinclair,donahue,krueger,mcginnis,gore,farris,webber,corbett,andrade,starr,lyon,yoder,hastings,mcgrath,spivey,krause,harden,crabtree,kirkpatrick,arrington,ritter,mcghee,bolden,maloney,gagnon,dunbar,ponce,pike,mayes,beatty,mobley,kimball,butts,montes,eldridge,braun,hamm,gibbons,moyer,manley,herron,plummer,elmore,cramer,rucker,pierson,fontenot,rubio,goldstein,elkins,wills,novak,hickey,worley,gorman,katz,dickinson,broussard,woodruff,crow,britton,nance,lehman,bingham,zuniga,whaley,shafer,coffman,steward,delarosa,neely,mata,davila,mccabe,kessler,hinkle,welsh,pagan,goldberg,goins,crouch,cuevas,quinones,mcdermott,hendrickson,samuels,denton,bergeron,ivey,locke,haines,snell,hoskins,byrne,arias,corbin,beltran,chappell,downey,dooley,tuttle,couch,payton,mcelroy,crockett,groves,cartwright,dickey,mcgill,dubois,muniz,tolbert,dempsey,cisneros,sewell,latham,vigil,tapia,rainey,norwood,stroud,meade,tipton,kuhn,hilliard,bonilla,teague,gunn,greenwood,correa,reece,pineda,phipps,frey,kaiser,ames,gunter,schmitt,milligan,espinosa,bowden,vickers,lowry,pritchard,costello,piper,mcclellan,lovell,sheehan,hatch,dobson,singh,jeffries,hollingsworth,sorensen,meza,fink,donnelly,burrell,tomlinson,colbert,billings,ritchie,helton,sutherland,peoples,mcqueen,thomason,givens,crocker,vogel,robison,dunham,coker,swartz,keys,ladner,richter,hargrove,edmonds,brantley,albright,murdock,boswell,muller,quintero,padgett,kenney,daly,connolly,inman,quintana,lund,barnard,villegas,simons,huggins,tidwell,sanderson,bullard,mcclendon,duarte,draper,marrero,dwyer,abrams,stover,goode,fraser,crews,bernal,godwin,conklin,mcneal,baca,esparza,crowder,bower,brewster,mcneill,rodrigues,leal,coates,raines,mccain,mccord,miner,holbrook,swift,dukes,carlisle,aldridge,ackerman,starks,ricks,holliday,ferris,hairston,sheffield,lange,fountain,doss,betts,kaplan,carmichael,bloom,ruffin,penn,kern,bowles,sizemore,larkin,dupree,seals,metcalf,hutchison,henley,farr,mccauley,hankins,gustafson,curran,waddell,ramey,cates,pollock,cummins,messer,heller,funk,cornett,palacios,galindo,cano,hathaway,pham,enriquez,salgado,pelletier,painter,wiseman,blount,feliciano,houser,doherty,mead,mcgraw,swan,capps,blanco,blackmon,thomson,mcmanus,burkett,gleason,dickens,cormier,voss,rushing,rosenberg,hurd,dumas,benitez,arellano,marin,caudill,bragg,jaramillo,huerta,gipson,colvin,biggs,vela,platt,cassidy,tompkins,mccollum,dolan,daley,crump,sneed,kilgore,grove,grimm,davison,brunson,prater,marcum,devine,dodge,stratton,rosas,choi,tripp,ledbetter,hightower,feldman,epps,yeager,posey,scruggs,cope,stubbs,richey,overton,trotter,sprague,cordero,butcher,stiles,burgos,woodson,horner,bassett,purcell,haskins,akins,ziegler,spaulding,hadley,grubbs,sumner,murillo,zavala,shook,lockwood,driscoll,dahl,thorpe,redmond,putnam,mcwilliams,mcrae,romano,joiner,sadler,hedrick,hager,hagen,fitch,coulter,thacker,mansfield,langston,guidry,ferreira,corley,conn,rossi,lackey,baez,saenz,mcnamara,mcmullen,mckenna,mcdonough,link,engel,browne,roper,peacock,eubanks,drummond,stringer,pritchett,parham,mims,landers,grayson,schafer,egan,timmons,ohara,keen,hamlin,finn,cortes,mcnair,nadeau,moseley,michaud,rosen,oakes,kurtz,jeffers,calloway,beal,bautista,winn,suggs,stern,stapleton,lyles,laird,montano,dawkins,hagan,goldman,bryson,barajas,lovett,segura,metz,lockett,langford,hinson,eastman,hooks,smallwood,shapiro,crowell,whalen,triplett,chatman,aldrich,cahill,youngblood,ybarra,stallings,sheets,reeder,connelly,bateman,abernathy,winkler,wilkes,masters,hackett,granger,gillis,schmitz,sapp,napier,souza,lanier,gomes,weir,otero,ledford,burroughs,babcock,ventura,siegel,dugan,bledsoe,atwood,wray,varner,spangler,anaya,staley,kraft,fournier,belanger,wolff,thorne,bynum,burnette,boykin,swenson,purvis,pina,khan,duvall,darby,xiong,kauffman,healy,engle,benoit,valle,steiner,spicer,shaver,randle,lundy,chin,calvert,staton,neff,kearney,darden,oakley,medeiros,mccracken,crenshaw,perdue,dill,whittaker,tobin,washburn,hogue,goodrich,easley,bravo,dennison,shipley,kerns,jorgensen,crain,villalobos,maurer,longoria,keene,coon,witherspoon,staples,pettit,kincaid,eason,madrid,echols,lusk,stahl,currie,thayer,shultz,mcnally,seay,maher,gagne,barrow,nava,moreland,honeycutt,hearn,diggs,caron,whitten,westbrook,stovall,ragland,munson,meier,looney,kimble,jolly,hobson,goddard,culver,burr,presley,negron,connell,tovar,huddleston,ashby,salter,root,pendleton,oleary,nickerson,myrick,judd,jacobsen,bain,adair,starnes,matos,busby,herndon,hanley,bellamy,doty,bartley,yazzie,rowell,parson,gifford,cullen,christiansen,benavides,barnhart,talbot,mock,crandall,connors,bonds,whitt,gage,bergman,arredondo,addison,lujan,dowdy,jernigan,huynh,bouchard,dutton,rhoades,ouellette,kiser,herrington,hare,blackman,babb,allred,rudd,paulson,ogden,koenig,geiger,begay,parra,lassiter,hawk,esposito,waldron,ransom,prather,chacon,vick,sands,roark,parr,mayberry,greenberg,coley,bruner,whitman,skaggs,shipman,leary,hutton,romo,medrano,ladd,kruse,askew,schulz,alfaro,tabor,mohr,gallo,bermudez,pereira,bliss,reaves,flint,comer,woodall,naquin,guevara,delong,carrier,pickens,tilley,schaffer,knutson,fenton,doran,vogt,vann,prescott,mclain,landis,corcoran,zapata,hyatt,hemphill,faulk,dove,boudreaux,aragon,whitlock,trejo,tackett,shearer,saldana,hanks,mckinnon,koehler,bourgeois,keyes,goodson,foote,lunsford,goldsmith,flood,winslow,sams,reagan,mccloud,hough,esquivel,naylor,loomis,coronado,ludwig,braswell,bearden,huang,fagan,ezell,edmondson,cronin,nunn,lemon,guillory,grier,dubose,traylor,ryder,dobbins,coyle,aponte,whitmore,smalls,rowan,malloy,cardona,braxton,borden,humphries,carrasco,ruff,metzger,huntley,hinojosa,finney,madsen,ernst,dozier,burkhart,bowser,peralta,daigle,whittington,sorenson,saucedo,roche,redding,fugate,avalos,waite,lind,huston,hawthorne,hamby,boyles,boles,regan,faust,crook,beam,barger,hinds,gallardo,willoughby,willingham,eckert,busch,zepeda,worthington,tinsley,hoff,hawley,carmona,varela,rector,newcomb,kinsey,dube,whatley,ragsdale,bernstein,becerra,yost,mattson,felder,cheek,handy,grossman,gauthier,escobedo,braden,beckman,mott,hillman,flaherty,dykes,stockton,stearns,lofton,coats,cavazos,beavers,barrios,tang,mosher,cardwell,coles,burnham,weller,lemons,beebe,aguilera,parnell,harman,couture,alley,schumacher,redd,dobbs,blum,blalock,merchant,ennis,denson,cottrell,brannon,bagley,aviles,watt,sousa,rosenthal,rooney,dietz,blank,paquette,mcclelland,duff,velasco,lentz,grubb,burrows,barbour,ulrich,shockley,rader,beyer,mixon,layton,altman,weathers,stoner,squires,shipp,priest,lipscomb,cutler,caballero,zimmer,willett,thurston,storey,medley,epperson,shah,mcmillian,baggett,torrez,hirsch,dent,poirier,peachey,farrar,creech,barth,trimble,dupre,albrecht,sample,lawler,crisp,conroy,wetzel,nesbitt,murry,jameson,wilhelm,patten,minton,matson,kimbrough,guinn,croft,toth,pulliam,nugent,newby,littlejohn,dias,canales,bernier,baron,singletary,renteria,pruett,mchugh,mabry,landrum,brower,stoddard,cagle,stjohn,scales,kohler,kellogg,hopson,gant,tharp,gann,zeigler,pringle,hammons,fairchild,deaton,chavis,carnes,rowley,matlock,kearns,irizarry,carrington,starkey,lopes,jarrell,craven,baum,littlefield,linn,humphreys,etheridge,cuellar,chastain,bundy,speer,skelton,quiroz,pyle,portillo,ponder,moulton,machado,killian,hutson,hitchcock,dowling,cloud,burdick,spann,pedersen,levin,leggett,hayward,dietrich,beaulieu,barksdale,wakefield,snowden,briscoe,bowie,berman,ogle,mcgregor,laughlin,helm,burden,wheatley,schreiber,pressley,parris,alaniz,agee,swann,snodgrass,schuster,radford,monk,mattingly,harp,girard,cheney,yancey,wagoner,ridley,lombardo,hudgins,gaskins,duckworth,coburn,willey,prado,newberry,magana,hammonds,elam,whipple,slade,serna,ojeda,liles,dorman,diehl,upton,reardon,michaels,goetz,eller,bauman,baer,layne,hummel,brenner,amaya,adamson,ornelas,dowell,cloutier,castellanos,wellman,saylor,orourke,moya,montalvo,kilpatrick,durbin,shell,oldham,kang,garvin,foss,branham,bartholomew,templeton,maguire,holton,rider,monahan,mccormack,beaty,anders,streeter,nieto,nielson,moffett,lankford,keating,heck,gatlin,delatorre,callaway,adcock,worrell,unger,robinette,nowak,jeter,brunner,steen,parrott,overstreet,nobles,montanez,clevenger,brinkley,trahan,quarles,pickering,pederson,jansen,grantham,gilchrist,crespo,aiken,schell,schaeffer,lorenz,leyva,harms,dyson,wallis,pease,leavitt,cheng,cavanaugh,batts,warden,seaman,rockwell,quezada,paxton,linder,houck,fontaine,durant,caruso,adler,pimentel,mize,lytle,cleary,cason,acker,switzer,isaacs,higginbotham,waterman,vandyke,stamper,sisk,shuler,riddick,mcmahan,levesque,hatton,bronson,bollinger,arnett,okeefe,gerber,gannon,farnsworth,baughman,silverman,satterfield,mccrary,kowalski,grigsby,greco,cabral,trout,rinehart,mahon,linton,gooden,curley,baugh,wyman,weiner,schwab,schuler,morrissey,mahan,bunn,thrasher,spear,waggoner,qualls,purdy,mcwhorter,mauldin,gilman,perryman,newsom,menard,martino,graf,billingsley,artis,simpkins,salisbury,quintanilla,gilliland,fraley,foust,crouse,scarborough,grissom,fultz,marlow,markham,madrigal,lawton,barfield,whiting,varney,schwarz,gooch,arce,wheat,truong,poulin,hurtado,selby,gaither,fortner,culpepper,coughlin,brinson,boudreau,bales,stepp,holm,schilling,morrell,kahn,heaton,gamez,causey,turpin,shanks,schrader,meek,isom,hardison,carranza,yanez,scroggins,schofield,runyon,ratcliff,murrell,moeller,irby,currier,butterfield,ralston,pullen,pinson,estep,carbone,hawks,ellington,casillas,spurlock,sikes,motley,mccartney,kruger,isbell,houle,burk,tomlin,quigley,neumann,lovelace,fennell,cheatham,bustamante,skidmore,hidalgo,forman,culp,bowens,betancourt,aquino,robb,milner,martel,gresham,wiles,ricketts,dowd,collazo,bostic,blakely,sherrod,kenyon,gandy,ebert,deloach,allard,sauer,robins,olivares,gillette,chestnut,bourque,paine,hite,hauser,devore,crawley,chapa,talbert,poindexter,meador,mcduffie,mattox,kraus,harkins,choate,wren,sledge,sanborn,kinder,geary,cornwell,barclay,abney,seward,rhoads,howland,fortier,benner,vines,tubbs,troutman,rapp,mccurdy,deluca,westmoreland,havens,guajardo,clary,seal,meehan,herzog,guillen,ashcraft,waugh,renner,milam,elrod,churchill,breaux,bolin,asher,windham,tirado,pemberton,nolen,noland,knott,emmons,cornish,christenson,brownlee,barbee,waldrop,pitt,olvera,lombardi,gruber,gaffney,eggleston,banda,archuleta,slone,prewitt,pfeiffer,nettles,mena,mcadams,henning,gardiner,cromwell,chisholm,burleson,vest,oglesby,mccarter,lumpkin,wofford,vanhorn,thorn,teel,swafford,stclair,stanfield,ocampo,herrmann,hannon,arsenault,roush,mcalister,hiatt,gunderson,forsythe,duggan,delvalle,cintron,wilks,weinstein,uribe,rizzo,noyes,mclendon,gurley,bethea,winstead,maples,guyton,giordano,alderman,valdes,polanco,pappas,lively,grogan,griffiths,bobo,arevalo,whitson,sowell,rendon,fernandes,farrow,benavidez,ayres,alicea,stump,smalley,seitz,schulte,gilley,gallant,canfield,wolford,omalley,mcnutt,mcnulty,mcgovern,hardman,harbin,cowart,chavarria,brink,beckett,bagwell,armstead,anglin,abreu,reynoso,krebs,jett,hoffmann,greenfield,forte,burney,broome,sisson,trammell,partridge,mace,lomax,lemieux,gossett,frantz,fogle,cooney,broughton,pence,paulsen,muncy,mcarthur,hollins,beauchamp,withers,osorio,mulligan,hoyle,dockery,cockrell,begley,amador,roby,rains,lindquist,gentile,everhart,bohannon,wylie,sommers,purnell,fortin,dunning,breeden,vail,phelan,phan,marx,cosby,colburn,boling,biddle,ledesma,gaddis,denney,chow,bueno,berrios,wicker,tolliver,thibodeaux,nagle,lavoie,fisk,crist,barbosa,reedy,locklear,kolb,himes,behrens,beckwith,weems,wahl,shorter,shackelford,rees,muse,cerda,valadez,thibodeau,saavedra,ridgeway,reiter,mchenry,majors,lachance,keaton,ferrara,clemens,blocker,applegate,needham,mojica,kuykendall,hamel,escamilla,doughty,burchett,ainsworth,vidal,upchurch,thigpen,strauss,spruill,sowers,riggins,ricker,mccombs,harlow,buffington,sotelo,olivas,negrete,morey,macon,logsdon,lapointe,bigelow,bello,westfall,stubblefield,lindley,hein,hawes,farrington,breen,birch,wilde,steed,sepulveda,reinhardt,proffitt,minter,messina,mcnabb,maier,keeler,gamboa,donohue,basham,shinn,crooks,cota,borders,bills,bachman,tisdale,tavares,schmid,pickard,gulley,fonseca,delossantos,condon,batista,wicks,wadsworth,martell,littleton,ison,haag,folsom,brumfield,broyles,brito,mireles,mcdonnell,leclair,hamblin,gough,fanning,binder,winfield,whitworth,soriano,palumbo,newkirk,mangum,hutcherson,comstock,carlin,beall,bair,wendt,watters,walling,putman,otoole,morley,mares,lemus,keener,hundley,dial,damico,billups,strother,mcfarlane,lamm,eaves,crutcher,caraballo,canty,atwell,taft,siler,rust,rawls,rawlings,prieto,mcneely,mcafee,hulsey,hackney,galvez,escalante,delagarza,crider,bandy,wilbanks,stowe,steinberg,renfro,masterson,massie,lanham,haskell,hamrick,dehart,burdette,branson,bourne,babin,aleman,worthy,tibbs,smoot,slack,paradis,mull,luce,houghton,gantt,furman,danner,christianson,burge,ashford,arndt,almeida,stallworth,shade,searcy,sager,noonan,mclemore,mcintire,maxey,lavigne,jobe,ferrer,falk,coffin,byrnes,aranda,apodaca,stamps,rounds,peek,olmstead,lewandowski,kaminski,dunaway,bruns,brackett,amato,reich,mcclung,lacroix,koontz,herrick,hardesty,flanders,cousins,cato,cade,vickery,shank,nagel,dupuis,croteau,cotter,stuckey,stine,porterfield,pauley,moffitt,knudsen,hardwick,goforth,dupont,blunt,barrows,barnhill,shull,rash,loftis,lemay,kitchens,horvath,grenier,fuchs,fairbanks,culbertson,calkins,burnside,beattie,ashworth,albertson,wertz,vaught,vallejo,turk,tuck,tijerina,sage,peterman,marroquin,marr,lantz,hoang,demarco,cone,berube,barnette,wharton,stinnett,slocum,scanlon,sander,pinto,mancuso,lima,headley,epstein,counts,clarkson,carnahan,boren,arteaga,adame,zook,whittle,whitehurst,wenzel,saxton,reddick,puente,handley,haggerty,earley,devlin,chaffin,cady,acuna,solano,sigler,pollack,pendergrass,ostrander,janes,francois,crutchfield,chamberlin,brubaker,baptiste,willson,reis,neeley,mullin,mercier,lira,layman,keeling,higdon,espinal,chapin,warfield,toledo,pulido,peebles,nagy,montague,mello,lear,jaeger,hogg,graff,furr,soliz,poore,mendenhall,mclaurin,maestas,gable,barraza,tillery,snead,pond,neill,mcculloch,mccorkle,lightfoot,hutchings,holloman,harness,dorn,bock,zielinski,turley,treadwell,stpierre,starling,somers,oswald,merrick,easterling,bivens,truitt,poston,parry,ontiveros,olivarez,moreau,medlin,lenz,knowlton,fairley,cobbs,chisolm,bannister,woodworth,toler,ocasio,noriega,neuman,moye,milburn,mcclanahan,lilley,hanes,flannery,dellinger,danielson,conti,blodgett,beers,weatherford,strain,karr,hitt,denham,custer,coble,clough,casteel,bolduc,batchelor,ammons,whitlow,tierney,staten,sibley,seifert,schubert,salcedo,mattison,laney,haggard,grooms,dees,cromer,cooks,colson,caswell,zarate,swisher,shin,ragan,pridgen,mcvey,matheny,lafleur,franz,ferraro,dugger,whiteside,rigsby,mcmurray,lehmann,jacoby,hildebrand,hendrick,headrick,goad,fincher,drury,borges,archibald,albers,woodcock,trapp,soares,seaton,monson,luckett,lindberg,kopp,keeton,healey,garvey,gaddy,fain,burchfield,wentworth,strand,stack,spooner,saucier,ricci,plunkett,pannell,ness,leger,freitas,fong,elizondo,duval,beaudoin,urbina,rickard,partin,mcgrew,mcclintock,ledoux,forsyth,faison,devries,bertrand,wasson,tilton,scarbrough,leung,irvine,garber,denning,corral,colley,castleberry,bowlin,bogan,beale,baines,trice,rayburn,parkinson,nunes,mcmillen,leahy,kimmel,higgs,fulmer,carden,bedford,taggart,spearman,prichard,morrill,koonce,heinz,hedges,guenther,grice,findley,dover,creighton,boothe,bayer,arreola,vitale,valles,raney,osgood,hanlon,burley,bounds,worden,weatherly,vetter,tanaka,stiltner,nevarez,mosby,montero,melancon,harter,hamer,goble,gladden,gist,ginn,akin,zaragoza,tarver,sammons,royster,oreilly,muir,morehead,luster,kingsley,kelso,grisham,glynn,baumann,alves,yount,tamayo,paterson,oates,menendez,longo,hargis,gillen,desantis,conover,breedlove,sumpter,scherer,rupp,reichert,heredia,creel,cohn,clemmons,casas,bickford,belton,bach,williford,whitcomb,tennant,sutter,stull,mccallum,langlois,keel,keegan,dangelo,dancy,damron,clapp,clanton,bankston,oliveira,mintz,mcinnis,martens,mabe,laster,jolley,hildreth,hefner,glaser,duckett,demers,brockman,blais,alcorn,agnew,toliver,tice,seeley,najera,musser,mcfall,laplante,galvin,fajardo,doan,coyne,copley,clawson,cheung,barone,wynne,woodley,tremblay,stoll,sparrow,sparkman,schweitzer,sasser,samples,roney,legg,heim,farias,colwell,christman,bratcher,winchester,upshaw,southerland,sorrell,sells,mccloskey,martindale,luttrell,loveless,lovejoy,linares,latimer,embry,coombs,bratton,bostick,venable,tuggle,toro,staggs,sandlin,jefferies,heckman,griffis,crayton,clem,browder,thorton,sturgill,sprouse,royer,rousseau,ridenour,pogue,perales,peeples,metzler,mesa,mccutcheon,mcbee,hornsby,heffner,corrigan,armijo,plante,peyton,paredes,macklin,hussey,hodgson,granados,frias,becnel,batten,almanza,turney,teal,sturgeon,meeker,mcdaniels,limon,keeney,hutto,holguin,gorham,fishman,fierro,blanchette,rodrigue,reddy,osburn,oden,lerma,kirkwood,keefer,haugen,hammett,chalmers,brinkman,baumgartner,zhang,valerio,tellez,steffen,shumate,sauls,ripley,kemper,guffey,evers,craddock,carvalho,blaylock,banuelos,balderas,wheaton,turnbull,shuman,pointer,mosier,mccue,ligon,kozlowski,johansen,ingle,herr,briones,snipes,rickman,pipkin,pantoja,orosco,moniz,lawless,kunkel,hibbard,galarza,enos,bussey,schott,salcido,perreault,mcdougal,mccool,haight,garris,easton,conyers,atherton,wimberly,utley,spellman,smithson,slagle,ritchey,rand,petit,osullivan,oaks,nutt,mcvay,mccreary,mayhew,knoll,jewett,harwood,cardoza,ashe,arriaga,zeller,wirth,whitmire,stauffer,rountree,redden,mccaffrey,martz,larose,langdon,humes,gaskin,faber,devito,cass,almond,wingfield,wingate,villareal,tyner,smothers,severson,reno,pennell,maupin,leighton,janssen,hassell,hallman,halcomb,folse,fitzsimmons,fahey,cranford,bolen,battles,battaglia,wooldridge,trask,rosser,regalado,mcewen,keefe,fuqua,echevarria,caro,boynton,andrus,viera,vanmeter,taber,spradlin,seibert,provost,prentice,oliphant,laporte,hwang,hatchett,hass,greiner,freedman,covert,chilton,byars,wiese,venegas,swank,shrader,roberge,mullis,mortensen,mccune,marlowe,kirchner,keck,isaacson,hostetler,halverson,gunther,griswold,fenner,durden,blackwood,ahrens,sawyers,savoy,nabors,mcswain,mackay,lavender,lash,labbe,jessup,fullerton,cruse,crittenden,correia,centeno,caudle,canady,callender,alarcon,ahern,winfrey,tribble,salley,roden,musgrove,minnick,fortenberry,carrion,bunting,batiste,whited,underhill,stillwell,rauch,pippin,perrin,messenger,mancini,lister,kinard,hartmann,fleck,wilt,treadway,thornhill,spalding,rafferty,pitre,patino,ordonez,linkous,kelleher,homan,galbraith,feeney,curtin,coward,camarillo,buss,bunnell,bolt,beeler,autry,alcala,witte,wentz,stidham,shively,nunley,meacham,martins,lemke,lefebvre,hynes,horowitz,hoppe,holcombe,dunne,derr,cochrane,brittain,bedard,beauregard,torrence,strunk,soria,simonson,shumaker,scoggins,oconner,moriarty,kuntz,ives,hutcheson,horan,hales,garmon,fitts,bohn,atchison,wisniewski,vanwinkle,sturm,sallee,prosser,moen,lundberg,kunz,kohl,keane,jorgenson,jaynes,funderburk,freed,durr,creamer,cosgrove,batson,vanhoose,thomsen,teeter,smyth,redmon,orellana,maness,heflin,goulet,frick,forney,bunker,asbury,aguiar,talbott,southard,mowery,mears,lemmon,krieger,hickson,elston,duong,delgadillo,dayton,dasilva,conaway,catron,bruton,bradbury,bordelon,bivins,bittner,bergstrom,beals,abell,whelan,tejada,pulley,pino,norfleet,nealy,maes,loper,gatewood,frierson,freund,finnegan,cupp,covey,catalano,boehm,bader,yoon,walston,tenney,sipes,rawlins,medlock,mccaskill,mccallister,marcotte,maclean,hughey,henke,harwell,gladney,gilson,chism,caskey,brandenburg,baylor,villasenor,veal,thatcher,stegall,petrie,nowlin,navarrete,lombard,loftin,lemaster,kroll,kovach,kimbrell,kidwell,hershberger,fulcher,cantwell,bustos,boland,bobbitt,binkley,wester,weis,verdin,tong,tiller,sisco,sharkey,seymore,rosenbaum,rohr,quinonez,pinkston,malley,logue,lessard,lerner,lebron,krauss,klinger,halstead,haller,getz,burrow,alger,shores,pfeifer,perron,nelms,munn,mcmaster,mckenney,manns,knudson,hutchens,huskey,goebel,flagg,cushman,click,castellano,carder,bumgarner,wampler,spinks,robson,neel,mcreynolds,mathias,maas,loera,jenson,florez,coons,buckingham,brogan,berryman,wilmoth,wilhite,thrash,shephard,seidel,schulze,roldan,pettis,obryan,maki,mackie,hatley,frazer,fiore,chesser,bottoms,bisson,benefield,allman,wilke,trudeau,timm,shifflett,mundy,milliken,mayers,leake,kohn,huntington,horsley,hermann,guerin,fryer,frizzell,foret,flemming,fife,criswell,carbajal,bozeman,boisvert,angulo,wallen,tapp,silvers,ramsay,oshea,orta,moll,mckeever,mcgehee,linville,kiefer,ketchum,howerton,groce,gass,fusco,corbitt,betz,bartels,amaral,aiello,weddle,sperry,seiler,runyan,raley,overby,osteen,olds,mckeown,matney,lauer,lattimore,hindman,hartwell,fredrickson,fredericks,espino,clegg,carswell,cambell,burkholder,woodbury,welker,totten,thornburg,theriault,stitt,stamm,stackhouse,scholl,saxon,rife,razo,quinlan,pinkerton,olivo,nesmith,nall,mattos,lafferty,justus,giron,geer,fielder,drayton,dortch,conners,conger,boatwright,billiot,barden,armenta,tibbetts,steadman,slattery,rinaldi,raynor,pinckney,pettigrew,milne,matteson,halsey,gonsalves,fellows,durand,desimone,cowley,cowles,brill,barham,barela,barba,ashmore,withrow,valenti,tejeda,spriggs,sayre,salerno,peltier,peel,merriman,matheson,lowman,lindstrom,hyland,giroux,earls,dugas,dabney,collado,briseno,baxley,whyte,wenger,vanover,vanburen,thiel,schindler,schiller,rigby,pomeroy,passmore,marble,manzo,mahaffey,lindgren,laflamme,greathouse,fite,calabrese,bayne,yamamoto,wick,townes,thames,reinhart,peeler,naranjo,montez,mcdade,mast,markley,marchand,leeper,kellum,hudgens,hennessey,hadden,gainey,coppola,borrego,bolling,beane,ault,slaton,pape,null,mulkey,lightner,langer,hillard,ethridge,enright,derosa,baskin,weinberg,turman,somerville,pardo,noll,lashley,ingraham,hiller,hendon,glaze,cothran,cooksey,conte,carrico,abner,wooley,swope,summerlin,sturgis,sturdivant,stott,spurgeon,spillman,speight,roussel,popp,nutter,mckeon,mazza,magnuson,lanning,kozak,jankowski,heyward,forster,corwin,callaghan,bays,wortham,usher,theriot,sayers,sabo,poling,loya,lieberman,laroche,labelle,howes,harr,garay,fogarty,everson,durkin,dominquez,chaves,chambliss,witcher,vieira,vandiver,terrill,stoker,schreiner,moorman,liddell,lawhorn,krug,irons,hylton,hollenbeck,herrin,hembree,goolsby,goodin,gilmer,foltz,dinkins,daughtry,caban,brim,briley,bilodeau,wyant,vergara,tallent,swearingen,stroup,scribner,quillen,pitman,mccants,maxfield,martinson,holtz,flournoy,brookins,brody,baumgardner,straub,sills,roybal,roundtree,oswalt,mcgriff,mcdougall,mccleary,maggard,gragg,gooding,godinez,doolittle,donato,cowell,cassell,bracken,appel,zambrano,reuter,perea,nakamura,monaghan,mickens,mcclinton,mcclary,marler,kish,judkins,gilbreath,freese,flanigan,felts,erdmann,dodds,chew,brownell,boatright,barreto,slayton,sandberg,saldivar,pettway,odum,narvaez,moultrie,montemayor,merrell,lees,keyser,hoke,hardaway,hannan,gilbertson,fogg,dumont,deberry,coggins,buxton,bucher,broadnax,beeson,araujo,appleton,amundson,aguayo,ackley,yocum,worsham,shivers,sanches,sacco,robey,rhoden,pender,ochs,mccurry,madera,luong,knotts,jackman,heinrich,hargrave,gault,comeaux,chitwood,caraway,boettcher,bernhardt,barrientos,zink,wickham,whiteman,thorp,stillman,settles,schoonover,roque,riddell,pilcher,phifer,novotny,macleod,hardee,haase,grider,doucette,clausen,bevins,beamon,badillo,tolley,tindall,soule,snook,seale,pinkney,pellegrino,nowell,nemeth,mondragon,mclane,lundgren,ingalls,hudspeth,hixson,gearhart,furlong,downes,dibble,deyoung,cornejo,camara,brookshire,boyette,wolcott,surratt,sellars,segal,salyer,reeve,rausch,labonte,haro,gower,freeland,fawcett,eads,driggers,donley,collett,bromley,boatman,ballinger,baldridge,volz,trombley,stonge,shanahan,rivard,rhyne,pedroza,matias,jamieson,hedgepeth,hartnett,estevez,eskridge,denman,chiu,chinn,catlett,carmack,buie,bechtel,beardsley,bard,ballou,ulmer,skeen,robledo,rincon,reitz,piazza,munger,moten,mcmichael,loftus,ledet,kersey,groff,fowlkes,crumpton,clouse,bettis,villagomez,timmerman,strom,santoro,roddy,penrod,musselman,macpherson,leboeuf,harless,haddad,guido,golding,fulkerson,fannin,dulaney,dowdell,cottle,ceja,cate,bosley,benge,albritton,voigt,trowbridge,soileau,seely,rohde,pearsall,paulk,orth,nason,mota,mcmullin,marquardt,madigan,hoag,gillum,gabbard,fenwick,danforth,cushing,cress,creed,cazares,bettencourt,barringer,baber,stansberry,schramm,rutter,rivero,oquendo,necaise,mouton,montenegro,miley,mcgough,marra,macmillan,lamontagne,jasso,horst,hetrick,heilman,gaytan,gall,fortney,dingle,desjardins,dabbs,burbank,brigham,breland,beaman,arriola,yarborough,wallin,toscano,stowers,reiss,pichardo,orton,michels,mcnamee,mccrory,leatherman,kell,keister,horning,hargett,guay,ferro,deboer,dagostino,carper,blanks,beaudry,towle,tafoya,stricklin,strader,soper,sonnier,sigmon,schenk,saddler,pedigo,mendes,lunn,lohr,lahr,kingsbury,jarman,hume,holliman,hofmann,haworth,harrelson,hambrick,flick,edmunds,dacosta,crossman,colston,chaplin,carrell,budd,weiler,waits,valentino,trantham,tarr,solorio,roebuck,powe,plank,pettus,pagano,mink,luker,leathers,joslin,hartzell,gambrell,cepeda,carty,caputo,brewington,bedell,ballew,applewhite,warnock,walz,urena,tudor,reel,pigg,parton,mickelson,meagher,mclellan,mcculley,mandel,leech,lavallee,kraemer,kling,kipp,kehoe,hochstetler,harriman,gregoire,grabowski,gosselin,gammon,fancher,edens,desai,brannan,armendariz,woolsey,whitehouse,whetstone,ussery,towne,testa,tallman,studer,strait,steinmetz,sorrells,sauceda,rolfe,paddock,mitchem,mcginn,mccrea,lovato,hazen,gilpin,gaynor,fike,devoe,delrio,curiel,burkhardt,bode,backus,zinn,watanabe,wachter,vanpelt,turnage,shaner,schroder,sato,riordan,quimby,portis,natale,mckoy,mccown,kilmer,hotchkiss,hesse,halbert,gwinn,godsey,delisle,chrisman,canter,arbogast,angell,acree,yancy,woolley,wesson,weatherspoon,trainor,stockman,spiller,sipe,rooks,reavis,propst,porras,neilson,mullens,loucks,llewellyn,kumar,koester,klingensmith,kirsch,kester,honaker,hodson,hennessy,helmick,garrity,garibay,drain,casarez,callis,botello,aycock,avant,wingard,wayman,tully,theisen,szymanski,stansbury,segovia,rainwater,preece,pirtle,padron,mincey,mckelvey,mathes,larrabee,kornegay,klug,ingersoll,hecht,germain,eggers,dykstra,deering,decoteau,deason,dearing,cofield,carrigan,bonham,bahr,aucoin,appleby,almonte,yager,womble,wimmer,weimer,vanderpool,stancil,sprinkle,romine,remington,pfaff,peckham,olivera,meraz,maze,lathrop,koehn,hazelton,halvorson,hallock,haddock,ducharme,dehaven,caruthers,brehm,bosworth,bost,bias,beeman,basile,bane,aikens,wold,walther,tabb,suber,strawn,stocker,shirey,schlosser,riedel,rembert,reimer,pyles,peele,merriweather,letourneau,latta,kidder,hixon,hillis,hight,herbst,henriquez,haygood,hamill,gabel,fritts,eubank,dawes,correll,bushey,buchholz,brotherton,botts,barnwell,auger,atchley,westphal,veilleux,ulloa,stutzman,shriver,ryals,pilkington,moyers,marrs,mangrum,maddux,lockard,laing,kuhl,harney,hammock,hamlett,felker,doerr,depriest,carrasquillo,carothers,bogle,bischoff,bergen,albanese,wyckoff,vermillion,vansickle,thibault,tetreault,stickney,shoemake,ruggiero,rawson,racine,philpot,paschal,mcelhaney,mathison,legrand,lapierre,kwan,kremer,jiles,hilbert,geyer,faircloth,ehlers,egbert,desrosiers,dalrymple,cotten,cashman,cadena,boardman,alcaraz,wyrick,therrien,tankersley,strickler,puryear,plourde,pattison,pardue,mcginty,mcevoy,landreth,kuhns,koon,hewett,giddens,emerick,eades,deangelis,cosme,ceballos,birdsong,benham,bemis,armour,anguiano,welborn,tsosie,storms,shoup,sessoms,samaniego,rood,rojo,rhinehart,raby,northcutt,myer,munguia,morehouse,mcdevitt,mallett,lozada,lemoine,kuehn,hallett,grim,gillard,gaylor,garman,gallaher,feaster,faris,darrow,dardar,coney,carreon,braithwaite,boylan,boyett,bixler,bigham,benford,barragan,barnum,zuber,wyche,westcott,vining,stoltzfus,simonds,shupe,sabin,ruble,rittenhouse,richman,perrone,mulholland,millan,lomeli,kite,jemison,hulett,holler,hickerson,herold,hazelwood,griffen,gause,forde,eisenberg,dilworth,charron,chaisson,bristow,breunig,brace,boutwell,bentz,belk,bayless,batchelder,baran,baeza,zimmermann,weathersby,volk,toole,theis,tedesco,searle,schenck,satterwhite,ruelas,rankins,partida,nesbit,morel,menchaca,levasseur,kaylor,johnstone,hulse,hollar,hersey,harrigan,harbison,guyer,gish,giese,gerlach,geller,geisler,falcone,elwell,doucet,deese,darr,corder,chafin,byler,bussell,burdett,brasher,bowe,bellinger,bastian,barner,alleyne,wilborn,weil,wegner,tatro,spitzer,smithers,schoen,resendez,parisi,overman,obrian,mudd,mahler,maggio,lindner,lalonde,lacasse,laboy,killion,kahl,jessen,jamerson,houk,henshaw,gustin,graber,durst,duenas,davey,cundiff,conlon,colunga,coakley,chiles,capers,buell,bricker,bissonnette,bartz,bagby,zayas,volpe,treece,toombs,thom,terrazas,swinney,skiles,silveira,shouse,senn,ramage,moua,langham,kyles,holston,hoagland,herd,feller,denison,carraway,burford,bickel,ambriz,abercrombie,yamada,weidner,waddle,verduzco,thurmond,swindle,schrock,sanabria,rosenberger,probst,peabody,olinger,nazario,mccafferty,mcbroom,mcabee,mazur,matherne,mapes,leverett,killingsworth,heisler,griego,gosnell,frankel,franke,ferrante,fenn,ehrlich,christopherso,chasse,caton,brunelle,bloomfield,babbitt,azevedo,abramson,ables,abeyta,youmans,wozniak,wainwright,stowell,smitherman,samuelson,runge,rothman,rosenfeld,peake,owings,olmos,munro,moreira,leatherwood,larkins,krantz,kovacs,kizer,kindred,karnes,jaffe,hubbell,hosey,hauck,goodell,erdman,dvorak,doane,cureton,cofer,buehler,bierman,berndt,banta,abdullah,warwick,waltz,turcotte,torrey,stith,seger,sachs,quesada,pinder,peppers,pascual,paschall,parkhurst,ozuna,oster,nicholls,lheureux,lavalley,kimura,jablonski,haun,gourley,gilligan,croy,cotto,cargill,burwell,burgett,buckman,booher,adorno,wrenn,whittemore,urias,szabo,sayles,saiz,rutland,rael,pharr,pelkey,ogrady,nickell,musick,moats,mather,massa,kirschner,kieffer,kellar,hendershot,gott,godoy,gadson,furtado,fiedler,erskine,dutcher,dever,daggett,chevalier,brake,ballesteros,amerson,wingo,waldon,trott,silvey,showers,schlegel,ritz,pepin,pelayo,parsley,palermo,moorehead,mchale,lett,kocher,kilburn,iglesias,humble,hulbert,huckaby,hartford,hardiman,gurney,grigg,grasso,goings,fillmore,farber,depew,dandrea,cowen,covarrubias,burrus,bracy,ardoin,thompkins,standley,radcliffe,pohl,persaud,parenteau,pabon,newson,newhouse,napolitano,mulcahy,malave,keim,hooten,hernandes,heffernan,hearne,greenleaf,glick,fuhrman,fetter,faria,dishman,dickenson,crites,criss,clapper,chenault,castor,casto,bugg,bove,bonney,anderton,allgood,alderson,woodman,warrick,toomey,tooley,tarrant,summerville,stebbins,sokol,searles,schutz,schumann,scheer,remillard,raper,proulx,palmore,monroy,messier,melo,melanson,mashburn,manzano,lussier,jenks,huneycutt,hartwig,grimsley,fulk,fielding,fidler,engstrom,eldred,dantzler,crandell,calder,brumley,breton,brann,bramlett,boykins,bianco,bancroft,almaraz,alcantar,whitmer,whitener,welton,vineyard,rahn,paquin,mizell,mcmillin,mckean,marston,maciel,lundquist,liggins,lampkin,kranz,koski,kirkham,jiminez,hazzard,harrod,graziano,grammer,gendron,garrido,fordham,englert,dryden,demoss,deluna,crabb,comeau,brummett,blume,benally,wessel,vanbuskirk,thorson,stumpf,stockwell,reams,radtke,rackley,pelton,niemi,newland,nelsen,morrissette,miramontes,mcginley,mccluskey,marchant,luevano,lampe,lail,jeffcoat,infante,hinman,gaona,eady,desmarais,decosta,dansby,cisco,choe,breckenridge,bostwick,borg,bianchi,alberts,wilkie,whorton,vargo,tait,soucy,schuman,ousley,mumford,lippert,leath,lavergne,laliberte,kirksey,kenner,johnsen,izzo,hiles,gullett,greenwell,gaspar,galbreath,gaitan,ericson,delapaz,croom,cottingham,clift,bushnell,bice,beason,arrowood,waring,voorhees,truax,shreve,shockey,schatz,sandifer,rubino,rozier,roseberry,pieper,peden,nester,nave,murphey,malinowski,macgregor,lafrance,kunkle,kirkman,hipp,hasty,haddix,gervais,gerdes,gamache,fouts,fitzwater,dillingham,deming,deanda,cedeno,cannady,burson,bouldin,arceneaux,woodhouse,whitford,wescott,welty,weigel,torgerson,toms,surber,sunderland,sterner,setzer,riojas,pumphrey,puga,metts,mcgarry,mccandless,magill,lupo,loveland,llamas,leclerc,koons,kahler,huss,holbert,heintz,haupt,grimmett,gaskill,ellingson,dorr,dingess,deweese,desilva,crossley,cordeiro,converse,conde,caldera,cairns,burmeister,burkhalter,brawner,bott,youngs,vierra,valladares,shrum,shropshire,sevilla,rusk,rodarte,pedraza,nino,merino,mcminn,markle,mapp,lajoie,koerner,kittrell,kato,hyder,hollifield,heiser,hazlett,greenwald,fant,eldredge,dreher,delafuente,cravens,claypool,beecher,aronson,alanis,worthen,wojcik,winger,whitacre,valverde,valdivia,troupe,thrower,swindell,suttles,stroman,spires,slate,shealy,sarver,sartin,sadowski,rondeau,rolon,rascon,priddy,paulino,nolte,munroe,molloy,mciver,lykins,loggins,lenoir,klotz,kempf,hupp,hollowell,hollander,haynie,harkness,harker,gottlieb,frith,eddins,driskell,doggett,densmore,charette,cassady,byrum,burcham,buggs,benn,whitted,warrington,vandusen,vaillancourt,steger,siebert,scofield,quirk,purser,plumb,orcutt,nordstrom,mosely,michalski,mcphail,mcdavid,mccraw,marchese,mannino,lefevre,largent,lanza,kress,isham,hunsaker,hoch,hildebrandt,guarino,grijalva,graybill,fick,ewell,ewald,cusick,crumley,coston,cathcart,carruthers,bullington,bowes,blain,blackford,barboza,yingling,wert,weiland,varga,silverstein,sievers,shuster,shumway,runnels,rumsey,renfroe,provencher,polley,mohler,middlebrooks,kutz,koster,groth,glidden,fazio,deen,chipman,chenoweth,champlin,cedillo,carrero,carmody,buckles,brien,boutin,bosch,berkowitz,altamirano,wilfong,wiegand,waites,truesdale,toussaint,tobey,tedder,steelman,sirois,schnell,robichaud,richburg,plumley,pizarro,piercy,ortego,oberg,neace,mertz,mcnew,matta,lapp,lair,kibler,howlett,hollister,hofer,hatten,hagler,falgoust,engelhardt,eberle,dombrowski,dinsmore,daye,casares,braud,balch,autrey,wendel,tyndall,strobel,stoltz,spinelli,serrato,reber,rathbone,palomino,nickels,mayle,mathers,mach,loeffler,littrell,levinson,leong,lemire,lejeune,lazo,lasley,koller,kennard,hoelscher,hintz,hagerman,greaves,fore,eudy,engler,corrales,cordes,brunet,bidwell,bennet,tyrrell,tharpe,swinton,stribling,southworth,sisneros,savoie,samons,ruvalcaba,ries,ramer,omara,mosqueda,millar,mcpeak,macomber,luckey,litton,lehr,lavin,hubbs,hoard,hibbs,hagans,futrell,exum,evenson,culler,carbaugh,callen,brashear,bloomer,blakeney,bigler,addington,woodford,unruh,tolentino,sumrall,stgermain,smock,sherer,rayner,pooler,oquinn,nero,mcglothlin,linden,kowal,kerrigan,ibrahim,harvell,hanrahan,goodall,geist,fussell,fung,ferebee,eley,eggert,dorsett,dingman,destefano,colucci,clemmer,burnell,brumbaugh,boddie,berryhill,avelar,alcantara,winder,winchell,vandenberg,trotman,thurber,thibeault,stlouis,stilwell,sperling,shattuck,sarmiento,ruppert,rumph,renaud,randazzo,rademacher,quiles,pearman,palomo,mercurio,lowrey,lindeman,lawlor,larosa,lander,labrecque,hovis,holifield,henninger,hawkes,hartfield,hann,hague,genovese,garrick,fudge,frink,eddings,dinh,cribbs,calvillo,bunton,brodeur,bolding,blanding,agosto,zahn,wiener,trussell,tello,teixeira,speck,sharma,shanklin,sealy,scanlan,santamaria,roundy,robichaux,ringer,rigney,prevost,polson,nord,moxley,medford,mccaslin,mcardle,macarthur,lewin,lasher,ketcham,keiser,heine,hackworth,grose,grizzle,gillman,gartner,frazee,fleury,edson,edmonson,derry,cronk,conant,burress,burgin,broom,brockington,bolick,boger,birchfield,billington,baily,bahena,armbruster,anson,yoho,wilcher,tinney,timberlake,thielen,sutphin,stultz,sikora,serra,schulman,scheffler,santillan,rego,preciado,pinkham,mickle,lomas,lizotte,lent,kellerman,keil,johanson,hernadez,hartsfield,haber,gorski,farkas,eberhardt,duquette,delano,cropper,cozart,cockerham,chamblee,cartagena,cahoon,buzzell,brister,brewton,blackshear,benfield,aston,ashburn,arruda,wetmore,weise,vaccaro,tucci,sudduth,stromberg,stoops,showalter,shears,runion,rowden,rosenblum,riffle,renfrow,peres,obryant,leftwich,lark,landeros,kistler,killough,kerley,kastner,hoggard,hartung,guertin,govan,gatling,gailey,fullmer,fulford,flatt,esquibel,endicott,edmiston,edelstein,dufresne,dressler,dickman,chee,busse,bonnett,berard,yoshida,velarde,veach,vanhouten,vachon,tolson,tolman,tennyson,stites,soler,shutt,ruggles,rhone,pegues,neese,muro,moncrief,mefford,mcphee,mcmorris,mceachern,mcclurg,mansour,mader,leija,lecompte,lafountain,labrie,jaquez,heald,hash,hartle,gainer,frisby,farina,eidson,edgerton,dyke,durrett,duhon,cuomo,cobos,cervantez,bybee,brockway,borowski,binion,beery,arguello,amaro,acton,yuen,winton,wigfall,weekley,vidrine,vannoy,tardiff,shoop,shilling,schick,safford,prendergast,pilgrim,pellerin,osuna,nissen,nalley,moller,messner,messick,merrifield,mcguinness,matherly,marcano,mahone,lemos,lebrun,jara,hoffer,herren,hecker,haws,haug,gwin,gober,gilliard,fredette,favela,echeverria,downer,donofrio,desrochers,crozier,corson,bechtold,argueta,aparicio,zamudio,westover,westerman,utter,troyer,thies,tapley,slavin,shirk,sandler,roop,rimmer,raymer,radcliff,otten,moorer,millet,mckibben,mccutchen,mcavoy,mcadoo,mayorga,mastin,martineau,marek,madore,leflore,kroeger,kennon,jimerson,hostetter,hornback,hendley,hance,guardado,granado,gowen,goodale,flinn,fleetwood,fitz,durkee,duprey,dipietro,dilley,clyburn,brawley,beckley,arana,weatherby,vollmer,vestal,tunnell,trigg,tingle,takahashi,sweatt,storer,snapp,shiver,rooker,rathbun,poisson,perrine,perri,parmer,parke,pare,papa,palmieri,midkiff,mecham,mccomas,mcalpine,lovelady,lillard,lally,knopp,kile,kiger,haile,gupta,goldsberry,gilreath,fulks,friesen,franzen,flack,findlay,ferland,dreyer,dore,dennard,deckard,debose,crim,coulombe,chancey,cantor,branton,bissell,barns,woolard,witham,wasserman,spiegel,shoffner,scholz,ruch,rossman,petry,palacio,paez,neary,mortenson,millsap,miele,menke,mckim,mcanally,martines,lemley,larochelle,klaus,klatt,kaufmann,kapp,helmer,hedge,halloran,glisson,frechette,fontana,eagan,distefano,danley,creekmore,chartier,chaffee,carillo,burg,bolinger,berkley,benz,basso,bash,zelaya,woodring,witkowski,wilmot,wilkens,wieland,verdugo,urquhart,tsai,timms,swiger,swaim,sussman,pires,molnar,mcatee,lowder,loos,linker,landes,kingery,hufford,higa,hendren,hammack,hamann,gillam,gerhardt,edelman,delk,deans,curl,constantine,cleaver,claar,casiano,carruth,carlyle,brophy,bolanos,bibbs,bessette,beggs,baugher,bartel,averill,andresen,amin,adames,valente,turnbow,swink,sublett,stroh,stringfellow,ridgway,pugliese,poteat,ohare,neubauer,murchison,mingo,lemmons,kwon,kellam,kean,jarmon,hyden,hudak,hollinger,henkel,hemingway,hasson,hansel,halter,haire,ginsberg,gillispie,fogel,flory,etter,elledge,eckman,deas,currin,crafton,coomer,colter,claxton,bulter,braddock,bowyer,binns,bellows,baskerville,barros,ansley,woolf,wight,waldman,wadley,tull,trull,tesch,stouffer,stadler,slay,shubert,sedillo,santacruz,reinke,poynter,neri,neale,mowry,moralez,monger,mitchum,merryman,manion,macdougall,litchfield,levitt,lepage,lasalle,khoury,kavanagh,karns,ivie,huebner,hodgkins,halpin,garica,eversole,dutra,dunagan,duffey,dillman,dillion,deville,dearborn,damato,courson,coulson,burdine,bousquet,bonin,bish,atencio,westbrooks,wages,vaca,toner,tillis,swett,struble,stanfill,solorzano,slusher,sipple,silvas,shults,schexnayder,saez,rodas,rager,pulver,penton,paniagua,meneses,mcfarlin,mcauley,matz,maloy,magruder,lohman,landa,lacombe,jaimes,holzer,holst,heil,hackler,grundy,gilkey,farnham,durfee,dunton,dunston,duda,dews,craver,corriveau,conwell,colella,chambless,bremer,boutte,bourassa,blaisdell,backman,babineaux,audette,alleman,towner,taveras,tarango,sullins,suiter,stallard,solberg,schlueter,poulos,pimental,owsley,okelley,moffatt,metcalfe,meekins,medellin,mcglynn,mccowan,marriott,marable,lennox,lamoureux,koss,kerby,karp,isenberg,howze,hockenberry,highsmith,hallmark,gusman,greeley,giddings,gaudet,gallup,fleenor,eicher,edington,dimaggio,dement,demello,decastro,bushman,brundage,brooker,bourg,blackstock,bergmann,beaton,banister,argo,appling,wortman,watterson,villalpando,tillotson,tighe,sundberg,sternberg,stamey,shipe,seeger,scarberry,sattler,sain,rothstein,poteet,plowman,pettiford,penland,partain,pankey,oyler,ogletree,ogburn,moton,merkel,lucier,lakey,kratz,kinser,kershaw,josephson,imhoff,hendry,hammon,frisbie,frawley,fraga,forester,eskew,emmert,drennan,doyon,dandridge,cawley,carvajal,bracey,belisle,batey,ahner,wysocki,weiser,veliz,tincher,sansone,sankey,sandstrom,rohrer,risner,pridemore,pfeffer,persinger,peery,oubre,nowicki,musgrave,murdoch,mullinax,mccary,mathieu,livengood,kyser,klink,kimes,kellner,kavanaugh,kasten,imes,hoey,hinshaw,hake,gurule,grube,grillo,geter,gatto,garver,garretson,farwell,eiland,dunford,decarlo,corso,colman,collard,cleghorn,chasteen,cavender,carlile,calvo,byerly,brogdon,broadwater,breault,bono,bergin,behr,ballenger,amick,tamez,stiffler,steinke,simmon,shankle,schaller,salmons,sackett,saad,rideout,ratcliffe,ranson,plascencia,petterson,olszewski,olney,olguin,nilsson,nevels,morelli,montiel,monge,michaelson,mertens,mcchesney,mcalpin,mathewson,loudermilk,lineberry,liggett,kinlaw,kight,jost,hereford,hardeman,halpern,halliday,hafer,gaul,friel,freitag,forsberg,evangelista,doering,dicarlo,dendy,delp,deguzman,dameron,curtiss,cosper,cauthen,bradberry,bouton,bonnell,bixby,bieber,beveridge,bedwell,barhorst,bannon,baltazar,baier,ayotte,attaway,arenas,abrego,turgeon,tunstall,thaxton,tenorio,stotts,sthilaire,shedd,seabolt,scalf,salyers,ruhl,rowlett,robinett,pfister,perlman,pepe,parkman,nunnally,norvell,napper,modlin,mckellar,mcclean,mascarenas,leibowitz,ledezma,kuhlman,kobayashi,hunley,holmquist,hinkley,hazard,hartsell,gribble,gravely,fifield,eliason,doak,crossland,carleton,bridgeman,bojorquez,boggess,auten,woosley,whiteley,wexler,twomey,tullis,townley,standridge,santoyo,rueda,riendeau,revell,pless,ottinger,nigro,nickles,mulvey,menefee,mcshane,mcloughlin,mckinzie,markey,lockridge,lipsey,knisley,knepper,kitts,kiel,jinks,hathcock,godin,gallego,fikes,fecteau,estabrook,ellinger,dunlop,dudek,countryman,chauvin,chatham,bullins,brownfield,boughton,bloodworth,bibb,baucom,barbieri,aubin,armitage,alessi,absher,abbate,zito,woolery,wiggs,wacker,tynes,tolle,telles,tarter,swarey,strode,stockdale,stalnaker,spina,schiff,saari,risley,rameriz,rakes,pettaway,penner,paulus,palladino,omeara,montelongo,melnick,mehta,mcgary,mccourt,mccollough,marchetti,manzanares,lowther,leiva,lauderdale,lafontaine,kowalczyk,knighton,joubert,jaworski,huth,hurdle,housley,hackman,gulick,gordy,gilstrap,gehrke,gebhart,gaudette,foxworth,endres,dunkle,cimino,caddell,brauer,braley,bodine,blackmore,belden,backer,ayer,andress,wisner,vuong,valliere,twigg,tavarez,strahan,steib,staub,sowder,seiber,schutt,scharf,schade,rodriques,risinger,renshaw,rahman,presnell,piatt,nieman,nevins,mcilwain,mcgaha,mccully,mccomb,massengale,macedo,lesher,kearse,jauregui,husted,hudnall,holmberg,hertel,hardie,glidewell,frausto,fassett,dalessandro,dahlgren,corum,constantino,conlin,colquitt,colombo,claycomb,cardin,buller,boney,bocanegra,biggers,benedetto,araiza,andino,albin,zorn,werth,weisman,walley,vanegas,ulibarri,towe,tedford,teasley,suttle,steffens,stcyr,squire,singley,sifuentes,shuck,schram,sass,rieger,ridenhour,rickert,richerson,rayborn,rabe,raab,pendley,pastore,ordway,moynihan,mellott,mckissick,mcgann,mccready,mauney,marrufo,lenhart,lazar,lafave,keele,kautz,jardine,jahnke,jacobo,hord,hardcastle,hageman,giglio,gehring,fortson,duque,duplessis,dicken,derosier,deitz,dalessio,cram,castleman,candelario,callison,caceres,bozarth,biles,bejarano,bashaw,avina,armentrout,alverez,acord,waterhouse,vereen,vanlandingham,strawser,shotwell,severance,seltzer,schoonmaker,schock,schaub,schaffner,roeder,rodrigez,riffe,rasberry,rancourt,railey,quade,pursley,prouty,perdomo,oxley,osterman,nickens,murphree,mounts,merida,maus,mattern,masse,martinelli,mangan,lutes,ludwick,loney,laureano,lasater,knighten,kissinger,kimsey,kessinger,honea,hollingshead,hockett,heyer,heron,gurrola,gove,glasscock,gillett,galan,featherstone,eckhardt,duron,dunson,dasher,culbreth,cowden,cowans,claypoole,churchwell,chabot,caviness,cater,caston,callan,byington,burkey,boden,beckford,atwater,archambault,alvey,alsup,whisenant,weese,voyles,verret,tsang,tessier,sweitzer,sherwin,shaughnessy,revis,remy,prine,philpott,peavy,paynter,parmenter,ovalle,offutt,nightingale,newlin,nakano,myatt,muth,mohan,mcmillon,mccarley,mccaleb,maxson,marinelli,maley,liston,letendre,kain,huntsman,hirst,hagerty,gulledge,greenway,grajeda,gorton,goines,gittens,frederickson,fanelli,embree,eichelberger,dunkin,dixson,dillow,defelice,chumley,burleigh,borkowski,binette,biggerstaff,berglund,beller,audet,arbuckle,allain,alfano,youngman,wittman,weintraub,vanzant,vaden,twitty,stollings,standifer,sines,shope,scalise,saville,posada,pisano,otte,nolasco,mier,merkle,mendiola,melcher,mejias,mcmurry,mccalla,markowitz,manis,mallette,macfarlane,lough,looper,landin,kittle,kinsella,kinnard,hobart,helman,hellman,hartsock,halford,hage,gordan,glasser,gayton,gattis,gastelum,gaspard,frisch,fitzhugh,eckstein,eberly,dowden,despain,crumpler,crotty,cornelison,chouinard,chamness,catlin,cann,bumgardner,budde,branum,bradfield,braddy,borst,birdwell,bazan,banas,bade,arango,ahearn,addis,zumwalt,wurth,wilk,widener,wagstaff,urrutia,terwilliger,tart,steinman,staats,sloat,rives,riggle,revels,reichard,prickett,poff,pitzer,petro,pell,northrup,nicks,moline,mielke,maynor,mallon,magness,lingle,lindell,lieb,lesko,lebeau,lammers,lafond,kiernan,ketron,jurado,holmgren,hilburn,hayashi,hashimoto,harbaugh,guillot,gard,froehlich,feinberg,falco,dufour,drees,doney,diep,delao,daves,dail,crowson,coss,congdon,carner,camarena,butterworth,burlingame,bouffard,bloch,bilyeu,barta,bakke,baillargeon,avent,aquilar,zeringue,yarber,wolfson,vogler,voelker,truss,troxell,thrift,strouse,spielman,sistrunk,sevigny,schuller,schaaf,ruffner,routh,roseman,ricciardi,peraza,pegram,overturf,olander,odaniel,millner,melchor,maroney,machuca,macaluso,livesay,layfield,laskowski,kwiatkowski,kilby,hovey,heywood,hayman,havard,harville,haigh,hagood,grieco,glassman,gebhardt,fleischer,fann,elson,eccles,cunha,crumb,blakley,bardwell,abshire,woodham,wines,welter,wargo,varnado,tutt,traynor,swaney,stricker,stoffel,stambaugh,sickler,shackleford,selman,seaver,sansom,sanmiguel,royston,rourke,rockett,rioux,puleo,pitchford,nardi,mulvaney,middaugh,malek,leos,lathan,kujawa,kimbro,killebrew,houlihan,hinckley,herod,hepler,hamner,hammel,hallowell,gonsalez,gingerich,gambill,funkhouser,fricke,fewell,falkner,endsley,dulin,drennen,deaver,dambrosio,chadwell,castanon,burkes,brune,brisco,brinker,bowker,boldt,berner,beaumont,beaird,bazemore,barrick,albano,younts,wunderlich,weidman,vanness,toland,theobald,stickler,steiger,stanger,spies,spector,sollars,smedley,seibel,scoville,saito,rummel,rowles,rouleau,roos,rogan,roemer,ream,raya,purkey,priester,perreira,penick,paulin,parkins,overcash,oleson,neves,muldrow,minard,midgett,michalak,melgar,mcentire,mcauliffe,marte,lydon,lindholm,leyba,langevin,lagasse,lafayette,kesler,kelton,kaminsky,jaggers,humbert,huck,howarth,hinrichs,higley,gupton,guimond,gravois,giguere,fretwell,fontes,feeley,faucher,eichhorn,ecker,earp,dole,dinger,derryberry,demars,deel,copenhaver,collinsworth,colangelo,cloyd,claiborne,caulfield,carlsen,calzada,caffey,broadus,brenneman,bouie,bodnar,blaney,blanc,beltz,behling,barahona,yockey,winkle,windom,wimer,villatoro,trexler,teran,taliaferro,sydnor,swinson,snelling,smtih,simonton,simoneaux,simoneau,sherrer,seavey,scheel,rushton,rupe,ruano,rippy,reiner,reiff,rabinowitz,quach,penley,odle,nock,minnich,mckown,mccarver,mcandrew,longley,laux,lamothe,lafreniere,kropp,krick,kates,jepson,huie,howse,howie,henriques,haydon,haught,hatter,hartzog,harkey,grimaldo,goshorn,gormley,gluck,gilroy,gillenwater,giffin,fluker,feder,eyre,eshelman,eakins,detwiler,delrosario,davisson,catalan,canning,calton,brammer,botelho,blakney,bartell,averett,askins,aker,witmer,winkelman,widmer,whittier,weitzel,wardell,wagers,ullman,tupper,tingley,tilghman,talton,simard,seda,scheller,sala,rundell,rost,ribeiro,rabideau,primm,pinon,peart,ostrom,ober,nystrom,nussbaum,naughton,murr,moorhead,monti,monteiro,melson,meissner,mclin,mcgruder,marotta,makowski,majewski,madewell,lunt,lukens,leininger,lebel,lakin,kepler,jaques,hunnicutt,hungerford,hoopes,hertz,heins,halliburton,grosso,gravitt,glasper,gallman,gallaway,funke,fulbright,falgout,eakin,dostie,dorado,dewberry,derose,cutshall,crampton,costanzo,colletti,cloninger,claytor,chiang,campagna,burd,brokaw,broaddus,bretz,brainard,binford,bilbrey,alpert,aitken,ahlers,zajac,woolfolk,witten,windle,wayland,tramel,tittle,talavera,suter,straley,specht,sommerville,soloman,skeens,sigman,sibert,shavers,schuck,schmit,sartain,sabol,rosenblatt,rollo,rashid,rabb,polston,nyberg,northrop,navarra,muldoon,mikesell,mcdougald,mcburney,mariscal,lozier,lingerfelt,legere,latour,lagunas,lacour,kurth,killen,kiely,kayser,kahle,isley,huertas,hower,hinz,haugh,gumm,galicia,fortunato,flake,dunleavy,duggins,doby,digiovanni,devaney,deltoro,cribb,corpuz,coronel,coen,charbonneau,caine,burchette,blakey,blakemore,bergquist,beene,beaudette,bayles,ballance,bakker,bailes,asberry,arwood,zucker,willman,whitesell,wald,walcott,vancleave,trump,strasser,simas,shick,schleicher,schaal,saleh,rotz,resnick,rainer,partee,ollis,oller,oday,noles,munday,mong,millican,merwin,mazzola,mansell,magallanes,llanes,lewellen,lepore,kisner,keesee,jeanlouis,ingham,hornbeck,hawn,hartz,harber,haffner,gutshall,guth,grays,gowan,finlay,finkelstein,eyler,enloe,dungan,diez,dearman,cull,crosson,chronister,cassity,campion,callihan,butz,breazeale,blumenthal,berkey,batty,batton,arvizu,alderete,aldana,albaugh,abernethy,wolter,wille,tweed,tollefson,thomasson,teter,testerman,sproul,spates,southwick,soukup,skelly,senter,sealey,sawicki,sargeant,rossiter,rosemond,repp,pifer,ormsby,nickelson,naumann,morabito,monzon,millsaps,millen,mcelrath,marcoux,mantooth,madson,macneil,mackinnon,louque,leister,lampley,kushner,krouse,kirwan,jessee,janson,jahn,jacquez,islas,hutt,holladay,hillyer,hepburn,hensel,harrold,gingrich,geis,gales,fults,finnell,ferri,featherston,epley,ebersole,eames,dunigan,drye,dismuke,devaughn,delorenzo,damiano,confer,collum,clower,clow,claussen,clack,caylor,cawthon,casias,carreno,bluhm,bingaman,bewley,belew,beckner,auld,amey,wolfenbarger,wilkey,wicklund,waltman,villalba,valero,valdovinos,ullrich,tyus,twyman,trost,tardif,tanguay,stripling,steinbach,shumpert,sasaki,sappington,sandusky,reinhold,reinert,quijano,placencia,pinkard,phinney,perrotta,pernell,parrett,oxendine,owensby,orman,nuno,mori,mcroberts,mcneese,mckamey,mccullum,markel,mardis,maines,lueck,lubin,lefler,leffler,larios,labarbera,kershner,josey,jeanbaptiste,izaguirre,hermosillo,haviland,hartshorn,hafner,ginter,getty,franck,fiske,dufrene,doody,davie,dangerfield,dahlberg,cuthbertson,crone,coffelt,chidester,chesson,cauley,caudell,cantara,campo,caines,bullis,bucci,brochu,bogard,bickerstaff,benning,arzola,antonelli,adkinson,zellers,wulf,worsley,woolridge,whitton,westerfield,walczak,vassar,truett,trueblood,trawick,townsley,topping,tobar,telford,steverson,stagg,sitton,sill,sergent,schoenfeld,sarabia,rutkowski,rubenstein,rigdon,prentiss,pomerleau,plumlee,philbrick,patnode,oloughlin,obregon,nuss,morell,mikell,mele,mcinerney,mcguigan,mcbrayer,lollar,kuehl,kinzer,kamp,joplin,jacobi,howells,holstein,hedden,hassler,harty,halle,greig,gouge,goodrum,gerhart,geier,geddes,gast,forehand,ferree,fendley,feltner,esqueda,encarnacion,eichler,egger,edmundson,eatmon,doud,donohoe,donelson,dilorenzo,digiacomo,diggins,delozier,dejong,danford,crippen,coppage,cogswell,clardy,cioffi,cabe,brunette,bresnahan,blomquist,blackstone,biller,bevis,bevan,bethune,benbow,baty,basinger,balcom,andes,aman,aguero,adkisson,yandell,wilds,whisenhunt,weigand,weeden,voight,villar,trottier,tillett,suazo,setser,scurry,schuh,schreck,schauer,samora,roane,rinker,reimers,ratchford,popovich,parkin,natal,melville,mcbryde,magdaleno,loehr,lockman,lingo,leduc,larocca,lamere,laclair,krall,korte,koger,jalbert,hughs,higbee,henton,heaney,haith,gump,greeson,goodloe,gholston,gasper,gagliardi,fregoso,farthing,fabrizio,ensor,elswick,elgin,eklund,eaddy,drouin,dorton,dizon,derouen,deherrera,davy,dampier,cullum,culley,cowgill,cardoso,cardinale,brodsky,broadbent,brimmer,briceno,branscum,bolyard,boley,bennington,beadle,baur,ballentine,azure,aultman,arciniega,aguila,aceves,yepez,woodrum,wethington,weissman,veloz,trusty,troup,trammel,tarpley,stivers,steck,sprayberry,spraggins,spitler,spiers,sohn,seagraves,schiffman,rudnick,rizo,riccio,rennie,quackenbush,puma,plott,pearcy,parada,paiz,munford,moskowitz,mease,mcnary,mccusker,lozoya,longmire,loesch,lasky,kuhlmann,krieg,koziol,kowalewski,konrad,kindle,jowers,jolin,jaco,horgan,hine,hileman,hepner,heise,heady,hawkinson,hannigan,haberman,guilford,grimaldi,garton,gagliano,fruge,follett,fiscus,ferretti,ebner,easterday,eanes,dirks,dimarco,depalma,deforest,cruce,craighead,christner,candler,cadwell,burchell,buettner,brinton,brazier,brannen,brame,bova,bomar,blakeslee,belknap,bangs,balzer,athey,armes,alvis,alverson,alvardo,yeung,wheelock,westlund,wessels,volkman,threadgill,thelen,tague,symons,swinford,sturtevant,straka,stier,stagner,segarra,seawright,rutan,roux,ringler,riker,ramsdell,quattlebaum,purifoy,poulson,permenter,peloquin,pasley,pagel,osman,obannon,nygaard,newcomer,munos,motta,meadors,mcquiston,mcniel,mcmann,mccrae,mayne,matte,legault,lechner,kucera,krohn,kratzer,koopman,jeske,horrocks,hock,hibbler,hesson,hersh,harvin,halvorsen,griner,grindle,gladstone,garofalo,frampton,forbis,eddington,diorio,dingus,dewar,desalvo,curcio,creasy,cortese,cordoba,connally,cluff,cascio,capuano,canaday,calabro,bussard,brayton,borja,bigley,arnone,arguelles,acuff,zamarripa,wooton,widner,wideman,threatt,thiele,templin,teeters,synder,swint,swick,sturges,stogner,stedman,spratt,siegfried,shetler,scull,savino,sather,rothwell,rook,rone,rhee,quevedo,privett,pouliot,poche,pickel,petrillo,pellegrini,peaslee,partlow,otey,nunnery,morelock,morello,meunier,messinger,mckie,mccubbin,mccarron,lerch,lavine,laverty,lariviere,lamkin,kugler,krol,kissel,keeter,hubble,hickox,hetzel,hayner,hagy,hadlock,groh,gottschalk,goodsell,gassaway,garrard,galligan,firth,fenderson,feinstein,etienne,engleman,emrick,ellender,drews,doiron,degraw,deegan,dart,crissman,corr,cookson,coil,cleaves,charest,chapple,chaparro,castano,carpio,byer,bufford,bridgewater,bridgers,brandes,borrero,bonanno,aube,ancheta,abarca,abad,wooster,wimbush,willhite,willams,wigley,weisberg,wardlaw,vigue,vanhook,unknow,torre,tasker,tarbox,strachan,slover,shamblin,semple,schuyler,schrimsher,sayer,salzman,rubalcava,riles,reneau,reichel,rayfield,rabon,pyatt,prindle,poss,polito,plemmons,pesce,perrault,pereyra,ostrowski,nilsen,niemeyer,munsey,mundell,moncada,miceli,meader,mcmasters,mckeehan,matsumoto,marron,marden,lizarraga,lingenfelter,lewallen,langan,lamanna,kovac,kinsler,kephart,keown,kass,kammerer,jeffreys,hysell,hosmer,hardnett,hanner,guyette,greening,glazer,ginder,fromm,fluellen,finkle,fessler,essary,eisele,duren,dittmer,crochet,cosentino,cogan,coelho,cavin,carrizales,campuzano,brough,bopp,bookman,bobb,blouin,beesley,battista,bascom,bakken,badgett,arneson,anselmo,albino,ahumada,woodyard,wolters,wireman,willison,warman,waldrup,vowell,vantassel,twombly,toomer,tennison,teets,tedeschi,swanner,stutz,stelly,sheehy,schermerhorn,scala,sandidge,salters,salo,saechao,roseboro,rolle,ressler,renz,renn,redford,raposa,rainbolt,pelfrey,orndorff,oney,nolin,nimmons,nardone,myhre,morman,menjivar,mcglone,mccammon,maxon,marciano,manus,lowrance,lorenzen,lonergan,lollis,littles,lindahl,lamas,lach,kuster,krawczyk,knuth,knecht,kirkendall,keitt,keever,kantor,jarboe,hoye,houchens,holter,holsinger,hickok,helwig,helgeson,hassett,harner,hamman,hames,hadfield,goree,goldfarb,gaughan,gaudreau,gantz,gallion,frady,foti,flesher,ferrin,faught,engram,donegan,desouza,degroot,cutright,crowl,criner,coan,clinkscales,chewning,chavira,catchings,carlock,bulger,buenrostro,bramblett,brack,boulware,bookout,bitner,birt,baranowski,baisden,allmon,acklin,yoakum,wilbourn,whisler,weinberger,washer,vasques,vanzandt,vanatta,troxler,tomes,tindle,tims,throckmorton,thach,stpeter,stlaurent,stenson,spry,spitz,songer,snavely,shroyer,shortridge,shenk,sevier,seabrook,scrivner,saltzman,rosenberry,rockwood,robeson,roan,reiser,ramires,raber,posner,popham,piotrowski,pinard,peterkin,pelham,peiffer,peay,nadler,musso,millett,mestas,mcgowen,marques,marasco,manriquez,manos,mair,lipps,leiker,krumm,knorr,kinslow,kessel,kendricks,kelm,irick,ickes,hurlburt,horta,hoekstra,heuer,helmuth,heatherly,hampson,hagar,haga,greenlaw,grau,godbey,gingras,gillies,gibb,gayden,gauvin,garrow,fontanez,florio,finke,fasano,ezzell,ewers,eveland,eckenrode,duclos,drumm,dimmick,delancey,defazio,dashiell,cusack,crowther,crigger,cray,coolidge,coldiron,cleland,chalfant,cassel,camire,cabrales,broomfield,brittingham,brisson,brickey,braziel,brazell,bragdon,boulanger,boman,bohannan,beem,barre,azar,ashbaugh,armistead,almazan,adamski,zendejas,winburn,willaims,wilhoit,westberry,wentzel,wendling,visser,vanscoy,vankirk,vallee,tweedy,thornberry,sweeny,spradling,spano,smelser,shim,sechrist,schall,scaife,rugg,rothrock,roesler,riehl,ridings,render,ransdell,radke,pinero,petree,pendergast,peluso,pecoraro,pascoe,panek,oshiro,navarrette,murguia,moores,moberg,michaelis,mcwhirter,mcsweeney,mcquade,mccay,mauk,mariani,marceau,mandeville,maeda,lunde,ludlow,loeb,lindo,linderman,leveille,leith,larock,lambrecht,kulp,kinsley,kimberlin,kesterson,hoyos,helfrich,hanke,grisby,goyette,gouveia,glazier,gile,gerena,gelinas,gasaway,funches,fujimoto,flynt,fenske,fellers,fehr,eslinger,escalera,enciso,duley,dittman,dineen,diller,devault,collings,clymer,clowers,chavers,charland,castorena,castello,camargo,bunce,bullen,boyes,borchers,borchardt,birnbaum,birdsall,billman,benites,bankhead,ange,ammerman,adkison,winegar,wickman,warr,warnke,villeneuve,veasey,vassallo,vannatta,vadnais,twilley,towery,tomblin,tippett,theiss,talkington,talamantes,swart,swanger,streit,stines,stabler,spurling,sobel,sine,simmers,shippy,shiflett,shearin,sauter,sanderlin,rusch,runkle,ruckman,rorie,roesch,richert,rehm,randel,ragin,quesenberry,puentes,plyler,plotkin,paugh,oshaughnessy,ohalloran,norsworthy,niemann,nader,moorefield,mooneyham,modica,miyamoto,mickel,mebane,mckinnie,mazurek,mancilla,lukas,lovins,loughlin,lotz,lindsley,liddle,levan,lederman,leclaire,lasseter,lapoint,lamoreaux,lafollette,kubiak,kirtley,keffer,kaczmarek,housman,hiers,hibbert,herrod,hegarty,hathorn,greenhaw,grafton,govea,futch,furst,franko,forcier,foran,flickinger,fairfield,eure,emrich,embrey,edgington,ecklund,eckard,durante,deyo,delvecchio,dade,currey,creswell,cottrill,casavant,cartier,cargile,capel,cammack,calfee,burse,burruss,brust,brousseau,bridwell,braaten,borkholder,bloomquist,bjork,bartelt,amburgey,yeary,whitefield,vinyard,vanvalkenburg,twitchell,timmins,tapper,stringham,starcher,spotts,slaugh,simonsen,sheffer,sequeira,rosati,rhymes,quint,pollak,peirce,patillo,parkerson,paiva,nilson,nevin,narcisse,mitton,merriam,merced,meiners,mckain,mcelveen,mcbeth,marsden,marez,manke,mahurin,mabrey,luper,krull,hunsicker,hornbuckle,holtzclaw,hinnant,heston,hering,hemenway,hegwood,hearns,halterman,guiterrez,grote,granillo,grainger,glasco,gilder,garren,garlock,garey,fryar,fredricks,fraizer,foshee,ferrel,felty,everitt,evens,esser,elkin,eberhart,durso,duguay,driskill,doster,dewall,deveau,demps,demaio,delreal,deleo,darrah,cumberbatch,culberson,cranmer,cordle,colgan,chesley,cavallo,castellon,castelli,carreras,carnell,carlucci,bontrager,blumberg,blasingame,becton,artrip,andujar,alkire,alder,zukowski,zuckerman,wroblewski,wrigley,woodside,wigginton,westman,westgate,werts,washam,wardlow,walser,waiters,tadlock,stringfield,stimpson,stickley,standish,spurlin,spindler,speller,spaeth,sotomayor,sluder,shryock,shepardson,shatley,scannell,santistevan,rosner,resto,reinhard,rathburn,prisco,poulsen,pinney,phares,pennock,pastrana,oviedo,ostler,nauman,mulford,moise,moberly,mirabal,metoyer,metheny,mentzer,meldrum,mcinturff,mcelyea,mcdougle,massaro,lumpkins,loveday,lofgren,lirette,lesperance,lefkowitz,ledger,lauzon,lachapelle,klassen,keough,kempton,kaelin,jeffords,hsieh,hoyer,horwitz,hoeft,hennig,haskin,gourdine,golightly,girouard,fulgham,fritsch,freer,frasher,foulk,firestone,fiorentino,fedor,ensley,englehart,eells,dunphy,donahoe,dileo,dibenedetto,dabrowski,crick,coonrod,conder,coddington,chunn,chaput,cerna,carreiro,calahan,braggs,bourdon,bollman,bittle,bauder,barreras,aubuchon,anzalone,adamo,zerbe,willcox,westberg,weikel,waymire,vroman,vinci,vallejos,truesdell,troutt,trotta,tollison,toles,tichenor,symonds,surles,strayer,stgeorge,sroka,sorrentino,solares,snelson,silvestri,sikorski,shawver,schumaker,schorr,schooley,scates,satterlee,satchell,rymer,roselli,robitaille,riegel,regis,reames,provenzano,priestley,plaisance,pettey,palomares,nowakowski,monette,minyard,mclamb,mchone,mccarroll,masson,magoon,maddy,lundin,licata,leonhardt,landwehr,kircher,kinch,karpinski,johannsen,hussain,houghtaling,hoskinson,hollaway,holeman,hobgood,hiebert,goggin,geissler,gadbois,gabaldon,fleshman,flannigan,fairman,eilers,dycus,dunmire,duffield,dowler,deloatch,dehaan,deemer,clayborn,christofferso,chilson,chesney,chatfield,carron,canale,brigman,branstetter,bosse,borton,bonar,biron,barroso,arispe,zacharias,zabel,yaeger,woolford,whetzel,weakley,veatch,vandeusen,tufts,troxel,troche,traver,townsel,talarico,swilley,sterrett,stenger,speakman,sowards,sours,souders,souder,soles,sobers,snoddy,smither,shute,shoaf,shahan,schuetz,scaggs,santini,rosson,rolen,robidoux,rentas,recio,pixley,pawlowski,pawlak,paull,overbey,orear,oliveri,oldenburg,nutting,naugle,mossman,misner,milazzo,michelson,mcentee,mccullar,mccree,mcaleer,mazzone,mandell,manahan,malott,maisonet,mailloux,lumley,lowrie,louviere,lipinski,lindemann,leppert,leasure,labarge,kubik,knisely,knepp,kenworthy,kennelly,kelch,kanter,houchin,hosley,hosler,hollon,holleman,heitman,haggins,gwaltney,goulding,gorden,geraci,gathers,frison,feagin,falconer,espada,erving,erikson,eisenhauer,ebeling,durgin,dowdle,dinwiddie,delcastillo,dedrick,crimmins,covell,cournoyer,coria,cohan,cataldo,carpentier,canas,campa,brode,brashears,blaser,bicknell,bednar,barwick,ascencio,althoff,almodovar,alamo,zirkle,zabala,wolverton,winebrenner,wetherell,westlake,wegener,weddington,tuten,trosclair,tressler,theroux,teske,swinehart,swensen,sundquist,southall,socha,sizer,silverberg,shortt,shimizu,sherrard,shaeffer,scheid,scheetz,saravia,sanner,rubinstein,rozell,romer,rheaume,reisinger,randles,pullum,petrella,payan,nordin,norcross,nicoletti,nicholes,newbold,nakagawa,monteith,milstead,milliner,mellen,mccardle,liptak,leitch,latimore,larrison,landau,laborde,koval,izquierdo,hymel,hoskin,holte,hoefer,hayworth,hausman,harrill,harrel,hardt,gully,groover,grinnell,greenspan,graver,grandberry,gorrell,goldenberg,goguen,gilleland,fuson,feldmann,everly,dyess,dunnigan,downie,dolby,deatherage,cosey,cheever,celaya,caver,cashion,caplinger,cansler,byrge,bruder,breuer,breslin,brazelton,botkin,bonneau,bondurant,bohanan,bogue,bodner,boatner,blatt,bickley,belliveau,beiler,beier,beckstead,bachmann,atkin,altizer,alloway,allaire,albro,abron,zellmer,yetter,yelverton,wiens,whidden,viramontes,vanwormer,tarantino,tanksley,sumlin,strauch,strang,stice,spahn,sosebee,sigala,shrout,seamon,schrum,schneck,schantz,ruddy,romig,roehl,renninger,reding,polak,pohlman,pasillas,oldfield,oldaker,ohanlon,ogilvie,norberg,nolette,neufeld,nellis,mummert,mulvihill,mullaney,monteleone,mendonca,meisner,mcmullan,mccluney,mattis,massengill,manfredi,luedtke,lounsbury,liberatore,lamphere,laforge,jourdan,iorio,iniguez,ikeda,hubler,hodgdon,hocking,heacock,haslam,haralson,hanshaw,hannum,hallam,haden,garnes,garces,gammage,gambino,finkel,faucett,ehrhardt,eggen,dusek,durrant,dubay,dones,depasquale,delucia,degraff,decamp,davalos,cullins,conard,clouser,clontz,cifuentes,chappel,chaffins,celis,carwile,byram,bruggeman,bressler,brathwaite,brasfield,bradburn,boose,bodie,blosser,bertsch,bernardi,bernabe,bengtson,barrette,astorga,alday,albee,abrahamson,yarnell,wiltse,wiebe,waguespack,vasser,upham,turek,traxler,torain,tomaszewski,tinnin,tiner,tindell,styron,stahlman,staab,skiba,sheperd,seidl,secor,schutte,sanfilippo,ruder,rondon,rearick,procter,prochaska,pettengill,pauly,neilsen,nally,mullenax,morano,meads,mcnaughton,mcmurtry,mcmath,mckinsey,matthes,massenburg,marlar,margolis,malin,magallon,mackin,lovette,loughran,loring,longstreet,loiselle,lenihan,kunze,koepke,kerwin,kalinowski,kagan,innis,innes,holtzman,heinemann,harshman,haider,haack,grondin,grissett,greenawalt,goudy,goodlett,goldston,gokey,gardea,galaviz,gafford,gabrielson,furlow,fritch,fordyce,folger,elizalde,ehlert,eckhoff,eccleston,ealey,dubin,diemer,deschamps,delapena,decicco,debolt,cullinan,crittendon,crase,cossey,coppock,coots,colyer,cluck,chamberland,burkhead,bumpus,buchan,borman,birkholz,berardi,benda,behnke,barter,amezquita,wotring,wirtz,wingert,wiesner,whitesides,weyant,wainscott,venezia,varnell,tussey,thurlow,tabares,stiver,stell,starke,stanhope,stanek,sisler,sinnott,siciliano,shehan,selph,seager,scurlock,scranton,santucci,santangelo,saltsman,rogge,rettig,renwick,reidy,reider,redfield,premo,parente,paolucci,palmquist,ohler,netherton,mutchler,morita,mistretta,minnis,middendorf,menzel,mendosa,mendelson,meaux,mcspadden,mcquaid,mcnatt,manigault,maney,mager,lukes,lopresti,liriano,letson,lechuga,lazenby,lauria,larimore,krupp,krupa,kopec,kinchen,kifer,kerney,kerner,kennison,kegley,karcher,justis,johson,jellison,janke,huskins,holzman,hinojos,hefley,hatmaker,harte,halloway,hallenbeck,goodwyn,glaspie,geise,fullwood,fryman,frakes,fraire,farrer,enlow,engen,ellzey,eckles,earles,dunkley,drinkard,dreiling,draeger,dinardo,dills,desroches,desantiago,curlee,crumbley,critchlow,coury,courtright,coffield,cleek,charpentier,cardone,caples,cantin,buntin,bugbee,brinkerhoff,brackin,bourland,blassingame,beacham,banning,auguste,andreasen,amann,almon,alejo,adelman,abston,yerger,wymer,woodberry,windley,whiteaker,westfield,weibel,wanner,waldrep,villani,vanarsdale,utterback,updike,triggs,topete,tolar,tigner,thoms,tauber,tarvin,tally,swiney,sweatman,studebaker,stennett,starrett,stannard,stalvey,sonnenberg,smithey,sieber,sickles,shinault,segars,sanger,salmeron,rothe,rizzi,restrepo,ralls,ragusa,quiroga,papenfuss,oropeza,okane,mudge,mozingo,molinaro,mcvicker,mcgarvey,mcfalls,mccraney,matus,magers,llanos,livermore,linehan,leitner,laymon,lawing,lacourse,kwong,kollar,kneeland,kennett,kellett,kangas,janzen,hutter,huling,hofmeister,hewes,harjo,habib,guice,grullon,greggs,grayer,granier,grable,gowdy,giannini,getchell,gartman,garnica,ganey,gallimore,fetters,fergerson,farlow,fagundes,exley,esteves,enders,edenfield,easterwood,drakeford,dipasquale,desousa,deshields,deeter,dedmon,debord,daughtery,cutts,courtemanche,coursey,copple,coomes,collis,cogburn,clopton,choquette,chaidez,castrejon,calhoon,burbach,bulloch,buchman,bruhn,bohon,blough,baynes,barstow,zeman,zackery,yardley,yamashita,wulff,wilken,wiliams,wickersham,wible,whipkey,wedgeworth,walmsley,walkup,vreeland,verrill,umana,traub,swingle,summey,stroupe,stockstill,steffey,stefanski,statler,stapp,speights,solari,soderberg,shunk,shorey,shewmaker,sheilds,schiffer,schank,schaff,sagers,rochon,riser,rickett,reale,raglin,polen,plata,pitcock,percival,palen,orona,oberle,nocera,navas,nault,mullings,montejano,monreal,minick,middlebrook,meece,mcmillion,mccullen,mauck,marshburn,maillet,mahaney,magner,maclin,lucey,litteral,lippincott,leite,leaks,lamarre,jurgens,jerkins,jager,hurwitz,hughley,hotaling,horstman,hohman,hocker,hively,hipps,hessler,hermanson,hepworth,helland,hedlund,harkless,haigler,gutierez,grindstaff,glantz,giardina,gerken,gadsden,finnerty,farnum,encinas,drakes,dennie,cutlip,curtsinger,couto,cortinas,corby,chiasson,carle,carballo,brindle,borum,bober,blagg,berthiaume,beahm,batres,basnight,backes,axtell,atterberry,alvares,alegria,woodell,wojciechowski,winfree,winbush,wiest,wesner,wamsley,wakeman,verner,truex,trafton,toman,thorsen,theus,tellier,tallant,szeto,strope,stills,simkins,shuey,shaul,servin,serio,serafin,salguero,ryerson,rudder,ruark,rother,rohrbaugh,rohrbach,rohan,rogerson,risher,reeser,pryce,prokop,prins,priebe,prejean,pinheiro,petrone,petri,penson,pearlman,parikh,natoli,murakami,mullikin,mullane,motes,morningstar,mcveigh,mcgrady,mcgaughey,mccurley,marchan,manske,lusby,linde,likens,licon,leroux,lemaire,legette,laskey,laprade,laplant,kolar,kittredge,kinley,kerber,kanagy,jetton,janik,ippolito,inouye,hunsinger,howley,howery,horrell,holthaus,hiner,hilson,hilderbrand,hartzler,harnish,harada,hansford,halligan,hagedorn,gwynn,gudino,greenstein,greear,gracey,goudeau,goodner,ginsburg,gerth,gerner,fujii,frier,frenette,folmar,fleisher,fleischmann,fetzer,eisenman,earhart,dupuy,dunkelberger,drexler,dillinger,dilbeck,dewald,demby,deford,craine,chesnut,casady,carstens,carrick,carino,carignan,canchola,bushong,burman,buono,brownlow,broach,britten,brickhouse,boyden,boulton,borland,bohrer,blubaugh,bever,berggren,benevides,arocho,arends,amezcua,almendarez,zalewski,witzel,winkfield,wilhoite,vangundy,vanfleet,vanetten,vandergriff,urbanski,troiano,thibodaux,straus,stoneking,stjean,stillings,stange,speicher,speegle,smeltzer,slawson,simmonds,shuttleworth,serpa,senger,seidman,schweiger,schloss,schimmel,schechter,sayler,sabatini,ronan,rodiguez,riggleman,richins,reamer,prunty,porath,plunk,piland,philbrook,pettitt,perna,peralez,pascale,padula,oboyle,nivens,nickols,mundt,munden,montijo,mcmanis,mcgrane,mccrimmon,manzi,mangold,malick,mahar,maddock,losey,litten,leedy,leavell,ladue,krahn,kluge,junker,iversen,imler,hurtt,huizar,hubbert,howington,hollomon,holdren,hoisington,heiden,hauge,hartigan,gutirrez,griffie,greenhill,gratton,granata,gottfried,gertz,gautreaux,furry,furey,funderburg,flippen,fitzgibbon,drucker,donoghue,dildy,devers,detweiler,despres,denby,degeorge,cueto,cranston,courville,clukey,cirillo,chivers,caudillo,butera,bulluck,buckmaster,braunstein,bracamonte,bourdeau,bonnette".split(","),
    us_tv_and_film: "you,i,to,that,it,me,what,this,know,i'm,no,have,my,don't,just,not,do,be,your,we,it's,so,but,all,well,oh,about,right,you're,get,here,out,going,like,yeah,if,can,up,want,think,that's,now,go,him,how,got,did,why,see,come,good,really,look,will,okay,back,can't,mean,tell,i'll,hey,he's,could,didn't,yes,something,because,say,take,way,little,make,need,gonna,never,we're,too,she's,i've,sure,our,sorry,what's,let,thing,maybe,down,man,very,there's,should,anything,said,much,any,even,off,please,doing,thank,give,thought,help,talk,god,still,wait,find,nothing,again,things,let's,doesn't,call,told,great,better,ever,night,away,believe,feel,everything,you've,fine,last,keep,does,put,around,stop,they're,i'd,guy,isn't,always,listen,wanted,guys,huh,those,big,lot,happened,thanks,won't,trying,kind,wrong,talking,guess,care,bad,mom,remember,getting,we'll,together,dad,leave,understand,wouldn't,actually,hear,baby,nice,father,else,stay,done,wasn't,course,might,mind,every,enough,try,hell,came,someone,you'll,whole,yourself,idea,ask,must,coming,looking,woman,room,knew,tonight,real,son,hope,went,hmm,happy,pretty,saw,girl,sir,friend,already,saying,next,job,problem,minute,thinking,haven't,heard,honey,matter,myself,couldn't,exactly,having,probably,happen,we've,hurt,boy,dead,gotta,alone,excuse,start,kill,hard,you'd,today,car,ready,without,wants,hold,wanna,yet,seen,deal,once,gone,morning,supposed,friends,head,stuff,worry,live,truth,face,forget,true,cause,soon,knows,telling,wife,who's,chance,run,move,anyone,person,bye,somebody,heart,miss,making,meet,anyway,phone,reason,damn,lost,looks,bring,case,turn,wish,tomorrow,kids,trust,check,change,anymore,least,aren't,working,makes,taking,means,brother,hate,ago,says,beautiful,gave,fact,crazy,sit,afraid,important,rest,fun,kid,word,watch,glad,everyone,sister,minutes,everybody,bit,couple,whoa,either,mrs,feeling,daughter,wow,gets,asked,break,promise,door,close,hand,easy,question,tried,far,walk,needs,mine,killed,hospital,anybody,alright,wedding,shut,able,die,perfect,stand,comes,hit,waiting,dinner,funny,husband,almost,pay,answer,cool,eyes,news,child,shouldn't,yours,moment,sleep,read,where's,sounds,sonny,pick,sometimes,bed,date,plan,hours,lose,hands,serious,shit,behind,inside,ahead,week,wonderful,fight,past,cut,quite,he'll,sick,it'll,eat,nobody,goes,save,seems,finally,lives,worried,upset,carly,met,brought,seem,sort,safe,weren't,leaving,front,shot,loved,asking,running,clear,figure,hot,felt,parents,drink,absolutely,how's,daddy,sweet,alive,sense,meant,happens,bet,blood,ain't,kidding,lie,meeting,dear,seeing,sound,fault,ten,buy,hour,speak,lady,jen,thinks,christmas,outside,hang,possible,worse,mistake,ooh,handle,spend,totally,giving,here's,marriage,realize,unless,sex,send,needed,scared,picture,talked,ass,hundred,changed,completely,explain,certainly,sign,boys,relationship,loves,hair,lying,choice,anywhere,future,weird,luck,she'll,turned,touch,kiss,crane,questions,obviously,wonder,pain,calling,somewhere,throw,straight,cold,fast,words,food,none,drive,feelings,they'll,marry,drop,cannot,dream,protect,twenty,surprise,sweetheart,poor,looked,mad,except,gun,y'know,dance,takes,appreciate,especially,situation,besides,pull,hasn't,worth,sheridan,amazing,expect,swear,piece,busy,happening,movie,we'd,catch,perhaps,step,fall,watching,kept,darling,dog,honor,moving,till,admit,problems,murder,he'd,evil,definitely,feels,honest,eye,broke,missed,longer,dollars,tired,evening,starting,entire,trip,niles,suppose,calm,imagine,fair,caught,blame,sitting,favor,apartment,terrible,clean,learn,frasier,relax,accident,wake,prove,smart,message,missing,forgot,interested,table,nbsp,mouth,pregnant,ring,careful,shall,dude,ride,figured,wear,shoot,stick,follow,angry,write,stopped,ran,standing,forgive,jail,wearing,ladies,kinda,lunch,cristian,greenlee,gotten,hoping,phoebe,thousand,ridge,paper,tough,tape,count,boyfriend,proud,agree,birthday,they've,share,offer,hurry,feet,wondering,decision,ones,finish,voice,herself,would've,mess,deserve,evidence,cute,dress,interesting,hotel,enjoy,quiet,concerned,staying,beat,sweetie,mention,clothes,fell,neither,mmm,fix,respect,prison,attention,holding,calls,surprised,bar,keeping,gift,hadn't,putting,dark,owe,ice,helping,normal,aunt,lawyer,apart,plans,jax,girlfriend,floor,whether,everything's,box,judge,upstairs,sake,mommy,possibly,worst,acting,accept,blow,strange,saved,conversation,plane,mama,yesterday,lied,quick,lately,stuck,difference,store,she'd,bought,doubt,listening,walking,cops,deep,dangerous,buffy,sleeping,chloe,rafe,join,card,crime,gentlemen,willing,window,walked,guilty,likes,fighting,difficult,soul,joke,favorite,uncle,promised,bother,seriously,cell,knowing,broken,advice,somehow,paid,losing,push,helped,killing,boss,liked,innocent,rules,learned,thirty,risk,letting,speaking,ridiculous,afternoon,apologize,nervous,charge,patient,boat,how'd,hide,detective,planning,huge,breakfast,horrible,awful,pleasure,driving,hanging,picked,sell,quit,apparently,dying,notice,congratulations,visit,could've,c'mon,letter,decide,forward,fool,showed,smell,seemed,spell,memory,pictures,slow,seconds,hungry,hearing,kitchen,ma'am,should've,realized,kick,grab,discuss,fifty,reading,idiot,suddenly,agent,destroy,bucks,shoes,peace,arms,demon,livvie,consider,papers,incredible,witch,drunk,attorney,tells,knock,ways,gives,nose,skye,turns,keeps,jealous,drug,sooner,cares,plenty,extra,outta,weekend,matters,gosh,opportunity,impossible,waste,pretend,jump,eating,proof,slept,arrest,breathe,perfectly,warm,pulled,twice,easier,goin,dating,suit,romantic,drugs,comfortable,finds,checked,divorce,begin,ourselves,closer,ruin,smile,laugh,treat,fear,what'd,otherwise,excited,mail,hiding,stole,pacey,noticed,fired,excellent,bringing,bottom,note,sudden,bathroom,honestly,sing,foot,remind,charges,witness,finding,tree,dare,hardly,that'll,steal,silly,contact,teach,shop,plus,colonel,fresh,trial,invited,roll,reach,dirty,choose,emergency,dropped,butt,credit,obvious,locked,loving,nuts,agreed,prue,goodbye,condition,guard,fuckin,grow,cake,mood,crap,crying,belong,partner,trick,pressure,dressed,taste,neck,nurse,raise,lots,carry,whoever,drinking,they'd,breaking,file,lock,wine,spot,paying,assume,asleep,turning,viki,bedroom,shower,nikolas,camera,fill,reasons,forty,bigger,nope,breath,doctors,pants,freak,movies,folks,cream,wild,truly,desk,convince,client,threw,hurts,spending,answers,shirt,chair,rough,doin,sees,ought,empty,wind,aware,dealing,pack,tight,hurting,guest,arrested,salem,confused,surgery,expecting,deacon,unfortunately,goddamn,bottle,beyond,whenever,pool,opinion,starts,jerk,secrets,falling,necessary,barely,dancing,tests,copy,cousin,ahem,twelve,tess,skin,fifteen,speech,orders,complicated,nowhere,escape,biggest,restaurant,grateful,usual,burn,address,someplace,screw,everywhere,regret,goodness,mistakes,details,responsibility,suspect,corner,hero,dumb,terrific,whoo,hole,memories,o'clock,teeth,ruined,bite,stenbeck,liar,showing,cards,desperate,search,pathetic,spoke,scare,marah,afford,settle,stayed,checking,hired,heads,concern,blew,alcazar,champagne,connection,tickets,happiness,saving,kissing,hated,personally,suggest,prepared,onto,downstairs,ticket,it'd,loose,holy,duty,convinced,throwing,kissed,legs,loud,saturday,babies,where'd,warning,miracle,carrying,blind,ugly,shopping,hates,sight,bride,coat,clearly,celebrate,brilliant,wanting,forrester,lips,custody,screwed,buying,toast,thoughts,reality,lexie,attitude,advantage,grandfather,sami,grandma,someday,roof,marrying,powerful,grown,grandmother,fake,must've,ideas,exciting,familiar,bomb,bout,harmony,schedule,capable,practically,correct,clue,forgotten,appointment,deserves,threat,bloody,lonely,shame,jacket,hook,scary,investigation,invite,shooting,lesson,criminal,victim,funeral,considering,burning,strength,harder,sisters,pushed,shock,pushing,heat,chocolate,miserable,corinthos,nightmare,brings,zander,crash,chances,sending,recognize,healthy,boring,feed,engaged,headed,treated,knife,drag,badly,hire,paint,pardon,behavior,closet,warn,gorgeous,milk,survive,ends,dump,rent,remembered,thanksgiving,rain,revenge,prefer,spare,pray,disappeared,aside,statement,sometime,meat,fantastic,breathing,laughing,stood,affair,ours,depends,protecting,jury,brave,fingers,murdered,explanation,picking,blah,stronger,handsome,unbelievable,anytime,shake,oakdale,wherever,pulling,facts,waited,lousy,circumstances,disappointed,weak,trusted,license,nothin,trash,understanding,slip,sounded,awake,friendship,stomach,weapon,threatened,mystery,vegas,understood,basically,switch,frankly,cheap,lifetime,deny,clock,garbage,why'd,tear,ears,indeed,changing,singing,tiny,decent,avoid,messed,filled,touched,disappear,exact,pills,kicked,harm,fortune,pretending,insurance,fancy,drove,cared,belongs,nights,lorelai,lift,timing,guarantee,chest,woke,burned,watched,heading,selfish,drinks,doll,committed,elevator,freeze,noise,wasting,ceremony,uncomfortable,staring,files,bike,stress,permission,thrown,possibility,borrow,fabulous,doors,screaming,bone,xander,what're,meal,apology,anger,honeymoon,bail,parking,fixed,wash,stolen,sensitive,stealing,photo,chose,lets,comfort,worrying,pocket,mateo,bleeding,shoulder,ignore,talent,tied,garage,dies,demons,dumped,witches,rude,crack,bothering,radar,soft,meantime,gimme,kinds,fate,concentrate,throat,prom,messages,intend,ashamed,somethin,manage,guilt,interrupt,guts,tongue,shoe,basement,sentence,purse,glasses,cabin,universe,repeat,mirror,wound,travers,tall,engagement,therapy,emotional,jeez,decisions,soup,thrilled,stake,chef,moves,extremely,moments,expensive,counting,shots,kidnapped,cleaning,shift,plate,impressed,smells,trapped,aidan,knocked,charming,attractive,argue,puts,whip,embarrassed,package,hitting,bust,stairs,alarm,pure,nail,nerve,incredibly,walks,dirt,stamp,terribly,friendly,damned,jobs,suffering,disgusting,stopping,deliver,riding,helps,disaster,bars,crossed,trap,talks,eggs,chick,threatening,spoken,introduce,confession,embarrassing,bags,impression,gate,reputation,presents,chat,suffer,argument,talkin,crowd,homework,coincidence,cancel,pride,solve,hopefully,pounds,pine,mate,illegal,generous,outfit,maid,bath,punch,freaked,begging,recall,enjoying,prepare,wheel,defend,signs,painful,yourselves,maris,that'd,suspicious,cooking,button,warned,sixty,pity,yelling,awhile,confidence,offering,pleased,panic,hers,gettin,refuse,grandpa,testify,choices,cruel,mental,gentleman,coma,cutting,proteus,guests,expert,benefit,faces,jumped,toilet,sneak,halloween,privacy,smoking,reminds,twins,swing,solid,options,commitment,crush,ambulance,wallet,gang,eleven,option,laundry,assure,stays,skip,fail,discussion,clinic,betrayed,sticking,bored,mansion,soda,sheriff,suite,handled,busted,load,happier,studying,romance,procedure,commit,assignment,suicide,minds,swim,yell,llanview,chasing,proper,believes,humor,hopes,lawyers,giant,latest,escaped,parent,tricks,insist,dropping,cheer,medication,flesh,routine,sandwich,handed,false,beating,warrant,awfully,odds,treating,thin,suggesting,fever,sweat,silent,clever,sweater,mall,sharing,assuming,judgment,goodnight,divorced,surely,steps,confess,math,listened,comin,answered,vulnerable,bless,dreaming,chip,zero,pissed,nate,kills,tears,knees,chill,brains,unusual,packed,dreamed,cure,lookin,grave,cheating,breaks,locker,gifts,awkward,thursday,joking,reasonable,dozen,curse,quartermaine,millions,dessert,rolling,detail,alien,delicious,closing,vampires,wore,tail,secure,salad,murderer,spit,offense,dust,conscience,bread,answering,lame,invitation,grief,smiling,pregnancy,prisoner,delivery,guards,virus,shrink,freezing,wreck,massimo,wire,technically,blown,anxious,cave,holidays,cleared,wishes,caring,candles,bound,charm,pulse,jumping,jokes,boom,occasion,silence,nonsense,frightened,slipped,dimera,blowing,relationships,kidnapping,spin,tool,roxy,packing,blaming,wrap,obsessed,fruit,torture,personality,there'll,fairy,necessarily,seventy,print,motel,underwear,grams,exhausted,believing,freaking,carefully,trace,touching,messing,recovery,intention,consequences,belt,sacrifice,courage,enjoyed,attracted,remove,testimony,intense,heal,defending,unfair,relieved,loyal,slowly,buzz,alcohol,surprises,psychiatrist,plain,attic,who'd,uniform,terrified,cleaned,zach,threaten,fella,enemies,satisfied,imagination,hooked,headache,forgetting,counselor,andie,acted,badge,naturally,frozen,sakes,appropriate,trunk,dunno,costume,sixteen,impressive,kicking,junk,grabbed,understands,describe,clients,owns,affect,witnesses,starving,instincts,happily,discussing,deserved,strangers,surveillance,admire,questioning,dragged,barn,deeply,wrapped,wasted,tense,hoped,fellas,roommate,mortal,fascinating,stops,arrangements,agenda,literally,propose,honesty,underneath,sauce,promises,lecture,eighty,torn,shocked,backup,differently,ninety,deck,biological,pheebs,ease,creep,waitress,telephone,ripped,raising,scratch,rings,prints,thee,arguing,ephram,asks,oops,diner,annoying,taggert,sergeant,blast,towel,clown,habit,creature,bermuda,snap,react,paranoid,handling,eaten,therapist,comment,sink,reporter,nurses,beats,priority,interrupting,warehouse,loyalty,inspector,pleasant,excuses,threats,guessing,tend,praying,motive,unconscious,mysterious,unhappy,tone,switched,rappaport,sookie,neighbor,loaded,swore,piss,balance,toss,misery,thief,squeeze,lobby,goa'uld,geez,exercise,forth,booked,sandburg,poker,eighteen,d'you,bury,everyday,digging,creepy,wondered,liver,hmmm,magical,fits,discussed,moral,helpful,searching,flew,depressed,aisle,cris,amen,vows,neighbors,darn,cents,arrange,annulment,useless,adventure,resist,fourteen,celebrating,inch,debt,violent,sand,teal'c,celebration,reminded,phones,paperwork,emotions,stubborn,pound,tension,stroke,steady,overnight,chips,beef,suits,boxes,cassadine,collect,tragedy,spoil,realm,wipe,surgeon,stretch,stepped,nephew,neat,limo,confident,perspective,climb,punishment,finest,springfield,hint,furniture,blanket,twist,proceed,fries,worries,niece,gloves,soap,signature,disappoint,crawl,convicted,flip,counsel,doubts,crimes,accusing,shaking,remembering,hallway,halfway,bothered,madam,gather,cameras,blackmail,symptoms,rope,ordinary,imagined,cigarette,supportive,explosion,trauma,ouch,furious,cheat,avoiding,whew,thick,oooh,boarding,approve,urgent,shhh,misunderstanding,drawer,phony,interfere,catching,bargain,tragic,respond,punish,penthouse,thou,rach,ohhh,insult,bugs,beside,begged,absolute,strictly,socks,senses,sneaking,reward,polite,checks,tale,physically,instructions,fooled,blows,tabby,bitter,adorable,y'all,tested,suggestion,jewelry,alike,jacks,distracted,shelter,lessons,constable,circus,audition,tune,shoulders,mask,helpless,feeding,explains,sucked,robbery,objection,behave,valuable,shadows,courtroom,confusing,talented,smarter,mistaken,customer,bizarre,scaring,motherfucker,alert,vecchio,reverend,foolish,compliment,bastards,worker,wheelchair,protective,gentle,reverse,picnic,knee,cage,wives,wednesday,voices,toes,stink,scares,pour,cheated,slide,ruining,filling,exit,cottage,upside,proves,parked,diary,complaining,confessed,pipe,merely,massage,chop,spill,prayer,betray,waiter,scam,rats,fraud,brush,tables,sympathy,pill,filthy,seventeen,employee,bracelet,pays,fairly,deeper,arrive,tracking,spite,shed,recommend,oughta,nanny,menu,diet,corn,roses,patch,dime,devastated,subtle,bullets,beans,pile,confirm,strings,parade,borrowed,toys,straighten,steak,premonition,planted,honored,exam,convenient,traveling,laying,insisted,dish,aitoro,kindly,grandson,donor,temper,teenager,proven,mothers,denial,backwards,tent,swell,noon,happiest,drives,thinkin,spirits,potion,holes,fence,whatsoever,rehearsal,overheard,lemme,hostage,bench,tryin,taxi,shove,moron,impress,needle,intelligent,instant,disagree,stinks,rianna,recover,groom,gesture,constantly,bartender,suspects,sealed,legally,hears,dresses,sheet,psychic,teenage,knocking,judging,accidentally,waking,rumor,manners,homeless,hollow,desperately,tapes,referring,item,genoa,gear,majesty,cried,tons,spells,instinct,quote,motorcycle,convincing,fashioned,aids,accomplished,grip,bump,upsetting,needing,invisible,forgiveness,feds,compare,bothers,tooth,inviting,earn,compromise,cocktail,tramp,jabot,intimate,dignity,dealt,souls,informed,gods,dressing,cigarettes,alistair,leak,fond,corky,seduce,liquor,fingerprints,enchantment,butters,stuffed,stavros,emotionally,transplant,tips,oxygen,nicely,lunatic,drill,complain,announcement,unfortunate,slap,prayers,plug,opens,oath,o'neill,mutual,yacht,remembers,fried,extraordinary,bait,warton,sworn,stare,safely,reunion,burst,might've,dive,aboard,expose,buddies,trusting,booze,sweep,sore,scudder,properly,parole,ditch,canceled,speaks,glow,wears,thirsty,skull,ringing,dorm,dining,bend,unexpected,pancakes,harsh,flattered,ahhh,troubles,fights,favourite,eats,rage,undercover,spoiled,sloane,shine,destroying,deliberately,conspiracy,thoughtful,sandwiches,plates,nails,miracles,fridge,drank,contrary,beloved,allergic,washed,stalking,solved,sack,misses,forgiven,bent,maciver,involve,dragging,cooked,pointing,foul,dull,beneath,heels,faking,deaf,stunt,jealousy,hopeless,fears,cuts,scenario,necklace,crashed,accuse,restraining,homicide,helicopter,firing,safer,auction,videotape,tore,reservations,pops,appetite,wounds,vanquish,ironic,fathers,excitement,anyhow,tearing,sends,rape,laughed,belly,dealer,cooperate,accomplish,wakes,spotted,sorts,reservation,ashes,tastes,supposedly,loft,intentions,integrity,wished,towels,suspected,investigating,inappropriate,lipstick,lawn,compassion,cafeteria,scarf,precisely,obsession,loses,lighten,infection,granddaughter,explode,balcony,this'll,spying,publicity,depend,cracked,conscious,ally,absurd,vicious,invented,forbid,directions,defendant,bare,announce,screwing,salesman,robbed,leap,lakeview,insanity,reveal,possibilities,kidnap,gown,chairs,wishing,setup,punished,criminals,regrets,raped,quarters,lamp,dentist,anyways,anonymous,semester,risks,owes,lungs,explaining,delicate,tricked,eager,doomed,adoption,stab,sickness,scum,floating,envelope,vault,sorel,pretended,potatoes,plea,photograph,payback,misunderstood,kiddo,healing,cascade,capeside,stabbed,remarkable,brat,privilege,passionate,nerves,lawsuit,kidney,disturbed,cozy,tire,shirts,oven,ordering,delay,risky,monsters,honorable,grounded,closest,breakdown,bald,abandon,scar,collar,worthless,sucking,enormous,disturbing,disturb,distract,deals,conclusions,vodka,dishes,crawling,briefcase,wiped,whistle,sits,roast,rented,pigs,flirting,deposit,bottles,topic,riot,overreacting,logical,hostile,embarrass,casual,beacon,amusing,altar,claus,survival,skirt,shave,porch,ghosts,favors,drops,dizzy,chili,advise,strikes,rehab,photographer,peaceful,leery,heavens,fortunately,fooling,expectations,cigar,weakness,ranch,practicing,examine,cranes,bribe,sail,prescription,hush,fragile,forensics,expense,drugged,cows,bells,visitor,suitcase,sorta,scan,manticore,insecure,imagining,hardest,clerk,wrist,what'll,starters,silk,pump,pale,nicer,haul,flies,boot,thumb,there'd,how're,elders,quietly,pulls,idiots,erase,denying,ankle,amnesia,accepting,heartbeat,devane,confront,minus,legitimate,fixing,arrogant,tuna,supper,slightest,sins,sayin,recipe,pier,paternity,humiliating,genuine,snack,rational,minded,guessed,weddings,tumor,humiliated,aspirin,spray,picks,eyed,drowning,contacts,ritual,perfume,hiring,hating,docks,creatures,visions,thanking,thankful,sock,nineteen,fork,throws,teenagers,stressed,slice,rolls,plead,ladder,kicks,detectives,assured,tellin,shallow,responsibilities,repay,howdy,girlfriends,deadly,comforting,ceiling,verdict,insensitive,spilled,respected,messy,interrupted,halliwell,blond,bleed,wardrobe,takin,murders,backs,underestimate,justify,harmless,frustrated,fold,enzo,communicate,bugging,arson,whack,salary,rumors,obligation,liking,dearest,congratulate,vengeance,rack,puzzle,fires,courtesy,caller,blamed,tops,quiz,prep,curiosity,circles,barbecue,sunnydale,spinning,psychotic,cough,accusations,resent,laughs,freshman,envy,drown,bartlet,asses,sofa,poster,highness,dock,apologies,theirs,stat,stall,realizes,psych,mmmm,fools,understandable,treats,succeed,stir,relaxed,makin,gratitude,faithful,accent,witter,wandering,locate,inevitable,gretel,deed,crushed,controlling,smelled,robe,gossip,gambling,cosmetics,accidents,surprising,stiff,sincere,rushed,refrigerator,preparing,nightmares,mijo,ignoring,hunch,fireworks,drowned,brass,whispering,sophisticated,luggage,hike,explore,emotion,crashing,contacted,complications,shining,rolled,righteous,reconsider,goody,geek,frightening,ethics,creeps,courthouse,camping,affection,smythe,haircut,essay,baked,apologized,vibe,respects,receipt,mami,hats,destructive,adore,adopt,tracked,shorts,reminding,dough,creations,cabot,barrel,snuck,slight,reporters,pressing,magnificent,madame,lazy,glorious,fiancee,bits,visitation,sane,kindness,shoulda,rescued,mattress,lounge,lifted,importantly,glove,enterprises,disappointment,condo,beings,admitting,yelled,waving,spoon,screech,satisfaction,reads,nailed,worm,tick,resting,marvelous,fuss,cortlandt,chased,pockets,luckily,lilith,filing,conversations,consideration,consciousness,worlds,innocence,forehead,aggressive,trailer,slam,quitting,inform,delighted,daylight,danced,confidential,aunts,washing,tossed,spectra,marrow,lined,implying,hatred,grill,corpse,clues,sober,offended,morgue,infected,humanity,distraction,cart,wired,violation,promising,harassment,glue,d'angelo,cursed,brutal,warlocks,wagon,unpleasant,proving,priorities,mustn't,lease,flame,disappearance,depressing,thrill,sitter,ribs,flush,earrings,deadline,corporal,collapsed,update,snapped,smack,melt,figuring,delusional,coulda,burnt,tender,sperm,realise,pork,popped,interrogation,esteem,choosing,undo,pres,prayed,plague,manipulate,insulting,detention,delightful,coffeehouse,betrayal,apologizing,adjust,wrecked,wont,whipped,rides,reminder,monsieur,faint,bake,distress,correctly,complaint,blocked,tortured,risking,pointless,handing,dumping,cups,alibi,struggling,shiny,risked,mummy,mint,hose,hobby,fortunate,fleischman,fitting,curtain,counseling,rode,puppet,modeling,memo,irresponsible,humiliation,hiya,freakin,felony,choke,blackmailing,appreciated,tabloid,suspicion,recovering,pledge,panicked,nursery,louder,jeans,investigator,homecoming,frustrating,buys,busting,buff,sleeve,irony,dope,declare,autopsy,workin,torch,prick,limb,hysterical,goddamnit,fetch,dimension,crowded,clip,climbing,bonding,woah,trusts,negotiate,lethal,iced,fantasies,deeds,bore,babysitter,questioned,outrageous,kiriakis,insulted,grudge,driveway,deserted,definite,beep,wires,suggestions,searched,owed,lend,drunken,demanding,costanza,conviction,bumped,weigh,touches,tempted,shout,resolve,relate,poisoned,meals,invitations,haunted,bogus,autograph,affects,tolerate,stepping,spontaneous,sleeps,probation,manny,fist,spectacular,hostages,heroin,havin,habits,encouraging,consult,burgers,boyfriends,bailed,baggage,watches,troubled,torturing,teasing,sweetest,qualities,postpone,overwhelmed,malkovich,impulse,classy,charging,amazed,policeman,hypocrite,humiliate,hideous,d'ya,costumes,bluffing,betting,bein,bedtime,alcoholic,vegetable,tray,suspicions,spreading,splendid,shrimp,shouting,pressed,nooo,grieving,gladly,fling,eliminate,cereal,aaah,sonofabitch,paralyzed,lotta,locks,guaranteed,dummy,despise,dental,briefing,bluff,batteries,whatta,sounding,servants,presume,handwriting,fainted,dried,allright,acknowledge,whacked,toxic,reliable,quicker,overwhelming,lining,harassing,fatal,endless,dolls,convict,whatcha,unlikely,shutting,positively,overcome,goddam,essence,dose,diagnosis,cured,bully,ahold,yearbook,tempting,shelf,prosecution,pouring,possessed,greedy,wonders,thorough,spine,rath,psychiatric,meaningless,latte,jammed,ignored,fiance,evidently,contempt,compromised,cans,weekends,urge,theft,suing,shipment,scissors,responding,proposition,noises,matching,hormones,hail,grandchildren,gently,smashed,sexually,sentimental,nicest,manipulated,intern,handcuffs,framed,errands,entertaining,crib,carriage,barge,spends,slipping,seated,rubbing,rely,reject,recommendation,reckon,headaches,float,embrace,corners,whining,sweating,skipped,mountie,motives,listens,cristobel,cleaner,cheerleader,balsom,unnecessary,stunning,scent,quartermaines,pose,montega,loosen,info,hottest,haunt,gracious,forgiving,errand,cakes,blames,abortion,sketch,shifts,plotting,perimeter,pals,mere,mattered,lonigan,interference,eyewitness,enthusiasm,diapers,strongest,shaken,punched,portal,catches,backyard,terrorists,sabotage,organs,needy,cuff,civilization,woof,who'll,prank,obnoxious,mates,hereby,gabby,faked,cellar,whitelighter,void,strangle,sour,muffins,interfering,demonic,clearing,boutique,barrington,terrace,smoked,righty,quack,petey,pact,knot,ketchup,disappearing,cordy,uptight,ticking,terrifying,tease,swamp,secretly,rejection,reflection,realizing,rays,mentally,marone,doubted,deception,congressman,cheesy,toto,stalling,scoop,ribbon,immune,expects,destined,bets,bathing,appreciation,accomplice,wander,shoved,sewer,scroll,retire,lasts,fugitive,freezer,discount,cranky,crank,clearance,bodyguard,anxiety,accountant,whoops,volunteered,talents,stinking,remotely,garlic,decency,cord,beds,altogether,uniforms,tremendous,popping,outa,observe,lung,hangs,feelin,dudes,donation,disguise,curb,bites,antique,toothbrush,realistic,predict,landlord,hourglass,hesitate,consolation,babbling,tipped,stranded,smartest,repeating,puke,psst,paycheck,overreacted,macho,juvenile,grocery,freshen,disposal,cuffs,caffeine,vanished,unfinished,ripping,pinch,flattering,expenses,dinners,colleague,ciao,belthazor,attorneys,woulda,whereabouts,waitin,truce,tripped,tasted,steer,poisoning,manipulative,immature,husbands,heel,granddad,delivering,condoms,addict,trashed,raining,pasta,needles,leaning,detector,coolest,batch,appointments,almighty,vegetables,spark,perfection,pains,momma,mole,meow,hairs,getaway,cracking,compliments,behold,verge,tougher,timer,tapped,taped,specialty,snooping,shoots,rendezvous,pentagon,leverage,jeopardize,janitor,grandparents,forbidden,clueless,bidding,ungrateful,unacceptable,tutor,serum,scuse,pajamas,mouths,lure,irrational,doom,cries,beautifully,arresting,approaching,traitor,sympathetic,smug,smash,rental,prostitute,premonitions,jumps,inventory,darlin,committing,banging,asap,worms,violated,vent,traumatic,traced,sweaty,shaft,overboard,insight,healed,grasp,experiencing,crappy,crab,chunk,awww,stain,shack,reacted,pronounce,poured,moms,marriages,jabez,handful,flipped,fireplace,embarrassment,disappears,concussion,bruises,brakes,twisting,swept,summon,splitting,sloppy,settling,reschedule,notch,hooray,grabbing,exquisite,disrespect,thornhart,straw,slapped,shipped,shattered,ruthless,refill,payroll,numb,mourning,manly,hunk,entertain,drift,dreadful,doorstep,confirmation,chops,appreciates,vague,tires,stressful,stashed,stash,sensed,preoccupied,predictable,noticing,madly,gunshot,dozens,dork,confuse,cleaners,charade,chalk,cappuccino,bouquet,amulet,addiction,who've,warming,unlock,satisfy,sacrificed,relaxing,lone,blocking,blend,blankets,addicted,yuck,hunger,hamburger,greeting,greet,gravy,gram,dreamt,dice,caution,backpack,agreeing,whale,taller,supervisor,sacrifices,phew,ounce,irrelevant,gran,felon,favorites,farther,fade,erased,easiest,convenience,compassionate,cane,backstage,agony,adores,veins,tweek,thieves,surgical,strangely,stetson,recital,proposing,productive,meaningful,immunity,hassle,goddamned,frighten,dearly,cease,ambition,wage,unstable,salvage,richer,refusing,raging,pumping,pressuring,mortals,lowlife,intimidated,intentionally,inspire,forgave,devotion,despicable,deciding,dash,comfy,breach,bark,aaaah,switching,swallowed,stove,screamed,scars,russians,pounding,poof,pipes,pawn,legit,invest,farewell,curtains,civilized,caviar,boost,token,superstition,supernatural,sadness,recorder,psyched,motivated,microwave,hallelujah,fraternity,dryer,cocoa,chewing,acceptable,unbelievably,smiled,smelling,simpler,respectable,remarks,khasinau,indication,gutter,grabs,fulfill,flashlight,ellenor,blooded,blink,blessings,beware,uhhh,turf,swings,slips,shovel,shocking,puff,mirrors,locking,heartless,fras,childish,cardiac,utterly,tuscany,ticked,stunned,statesville,sadly,purely,kiddin,jerks,hitch,flirt,fare,equals,dismiss,christening,casket,c'mere,breakup,biting,antibiotics,accusation,abducted,witchcraft,thread,runnin,punching,paramedics,newest,murdering,masks,lawndale,initials,grampa,choking,charms,careless,bushes,buns,bummed,shred,saves,saddle,rethink,regards,precinct,persuade,meds,manipulating,llanfair,leash,hearted,guarantees,fucks,disgrace,deposition,bookstore,boil,vitals,veil,trespassing,sidewalk,sensible,punishing,overtime,optimistic,obsessing,notify,mornin,jeopardy,jaffa,injection,hilarious,desires,confide,cautious,yada,where're,vindictive,vial,teeny,stroll,sittin,scrub,rebuild,posters,ordeal,nuns,intimacy,inheritance,exploded,donate,distracting,despair,crackers,wildwind,virtue,thoroughly,tails,spicy,sketches,sights,sheer,shaving,seize,scarecrow,refreshing,prosecute,platter,napkin,misplaced,merchandise,loony,jinx,heroic,frankenstein,ambitious,syrup,solitary,resemblance,reacting,premature,lavery,flashes,cheque,awright,acquainted,wrapping,untie,salute,realised,priceless,partying,lightly,lifting,kasnoff,insisting,glowing,generator,explosives,cutie,confronted,buts,blouse,ballistic,antidote,analyze,allowance,adjourned,unto,understatement,tucked,touchy,subconscious,screws,sarge,roommates,rambaldi,offend,nerd,knives,irresistible,incapable,hostility,goddammit,fuse,frat,curfew,blackmailed,walkin,starve,sleigh,sarcastic,recess,rebound,pinned,parlor,outfits,livin,heartache,haired,fundraiser,doorman,discreet,dilucca,cracks,considerate,climbed,catering,apophis,zoey,urine,strung,stitches,sordid,sark,protector,phoned,pets,hostess,flaw,flavor,deveraux,consumed,confidentiality,bourbon,straightened,specials,spaghetti,prettier,powerless,playin,playground,paranoia,instantly,havoc,exaggerating,eavesdropping,doughnuts,diversion,deepest,cutest,comb,bela,behaving,anyplace,accessory,workout,translate,stuffing,speeding,slime,royalty,polls,marital,lurking,lottery,imaginary,greetings,fairwinds,elegant,elbow,credibility,credentials,claws,chopped,bridal,bedside,babysitting,witty,unforgivable,underworld,tempt,tabs,sophomore,selfless,secrecy,restless,okey,movin,metaphor,messes,meltdown,lecter,incoming,gasoline,diefenbaker,buckle,admired,adjustment,warmth,throats,seduced,queer,parenting,noses,luckiest,graveyard,gifted,footsteps,dimeras,cynical,wedded,verbal,unpredictable,tuned,stoop,slides,sinking,rigged,plumbing,lingerie,hankey,greed,everwood,elope,dresser,chauffeur,bulletin,bugged,bouncing,temptation,strangest,slammed,sarcasm,pending,packages,orderly,obsessive,murderers,meteor,inconvenience,glimpse,froze,execute,courageous,consulate,closes,bosses,bees,amends,wuss,wolfram,wacky,unemployed,testifying,syringe,stew,startled,sorrow,sleazy,shaky,screams,rsquo,remark,poke,nutty,mentioning,mend,inspiring,impulsive,housekeeper,foam,fingernails,conditioning,baking,whine,thug,starved,sniffing,sedative,programmed,picket,paged,hound,homosexual,homo,hips,forgets,flipping,flea,flatter,dwell,dumpster,choo,assignments,ants,vile,unreasonable,tossing,thanked,steals,souvenir,scratched,psychopath,outs,obstruction,obey,lump,insists,harass,gloat,filth,edgy,didn,coroner,confessing,bruise,betraying,bailing,appealing,adebisi,wrath,wandered,waist,vain,traps,stepfather,poking,obligated,heavenly,dilemma,crazed,contagious,coaster,cheering,bundle,vomit,thingy,speeches,robbing,raft,pumped,pillows,peep,packs,neglected,m'kay,loneliness,intrude,helluva,gardener,forresters,drooling,betcha,vase,supermarket,squat,spitting,rhyme,relieve,receipts,racket,pictured,pause,overdue,motivation,morgendorffer,kidnapper,insect,horns,feminine,eyeballs,dumps,disappointing,crock,convertible,claw,clamp,canned,cambias,bathtub,avanya,artery,weep,warmer,suspense,summoned,spiders,reiber,raving,pushy,postponed,ohhhh,noooo,mold,laughter,incompetent,hugging,groceries,drip,communicating,auntie,adios,wraps,wiser,willingly,weirdest,timmih,thinner,swelling,swat,steroids,sensitivity,scrape,rehearse,prophecy,ledge,justified,insults,hateful,handles,doorway,chatting,buyer,buckaroo,bedrooms,askin,ammo,tutoring,subpoena,scratching,privileges,pager,mart,intriguing,idiotic,grape,enlighten,corrupt,brunch,bridesmaid,barking,applause,acquaintance,wretched,superficial,soak,smoothly,sensing,restraint,posing,pleading,payoff,oprah,nemo,morals,loaf,jumpy,ignorant,herbal,hangin,germs,generosity,flashing,doughnut,clumsy,chocolates,captive,behaved,apologise,vanity,stumbled,preview,poisonous,perjury,parental,onboard,mugged,minding,linen,knots,interviewing,humour,grind,greasy,goons,drastic,coop,comparing,cocky,clearer,bruised,brag,bind,worthwhile,whoop,vanquishing,tabloids,sprung,spotlight,sentencing,racist,provoke,pining,overly,locket,imply,impatient,hovering,hotter,fest,endure,dots,doren,debts,crawled,chained,brit,breaths,weirdo,warmed,wand,troubling,tok'ra,strapped,soaked,skipping,scrambled,rattle,profound,musta,mocking,misunderstand,limousine,kacl,hustle,forensic,enthusiastic,duct,drawers,devastating,conquer,clarify,chores,cheerleaders,cheaper,callin,blushing,barging,abused,yoga,wrecking,wits,waffles,virginity,vibes,uninvited,unfaithful,teller,strangled,scheming,ropes,rescuing,rave,postcard,o'reily,morphine,lotion,lads,kidneys,judgement,itch,indefinitely,grenade,glamorous,genetically,freud,discretion,delusions,crate,competent,bakery,argh,ahhhh,wedge,wager,unfit,tripping,torment,superhero,stirring,spinal,sorority,seminar,scenery,rabble,pneumonia,perks,override,ooooh,mija,manslaughter,mailed,lime,lettuce,intimidate,guarded,grieve,grad,frustration,doorbell,chinatown,authentic,arraignment,annulled,allergies,wanta,verify,vegetarian,tighter,telegram,stalk,spared,shoo,satisfying,saddam,requesting,pens,overprotective,obstacles,notified,nasedo,grandchild,genuinely,flushed,fluids,floss,escaping,ditched,cramp,corny,bunk,bitten,billions,bankrupt,yikes,wrists,ultrasound,ultimatum,thirst,sniff,shakes,salsa,retrieve,reassuring,pumps,neurotic,negotiating,needn't,monitors,millionaire,lydecker,limp,incriminating,hatchet,gracias,gordie,fills,feeds,doubting,decaf,biopsy,whiz,voluntarily,ventilator,unpack,unload,toad,spooked,snitch,schillinger,reassure,persuasive,mystical,mysteries,matrimony,mails,jock,headline,explanations,dispatch,curly,cupid,condolences,comrade,cassadines,bulb,bragging,awaits,assaulted,ambush,adolescent,abort,yank,whit,vaguely,undermine,tying,swamped,stabbing,slippers,slash,sincerely,sigh,setback,secondly,rotting,precaution,pcpd,melting,liaison,hots,hooking,headlines,haha,ganz,fury,felicity,fangs,encouragement,earring,dreidel,dory,donut,dictate,decorating,cocktails,bumps,blueberry,believable,backfired,backfire,apron,adjusting,vous,vouch,vitamins,ummm,tattoos,slimy,sibling,shhhh,renting,peculiar,parasite,paddington,marries,mailbox,magically,lovebirds,knocks,informant,exits,drazen,distractions,disconnected,dinosaurs,dashwood,crooked,conveniently,wink,warped,underestimated,tacky,shoving,seizure,reset,pushes,opener,mornings,mash,invent,indulge,horribly,hallucinating,festive,eyebrows,enjoys,desperation,dealers,darkest,daph,boragora,belts,bagel,authorization,auditions,agitated,wishful,wimp,vanish,unbearable,tonic,suffice,suction,slaying,safest,rocking,relive,puttin,prettiest,noisy,newlyweds,nauseous,misguided,mildly,midst,liable,judgmental,indy,hunted,givin,fascinated,elephants,dislike,deluded,decorate,crummy,contractions,carve,bottled,bonded,bahamas,unavailable,twenties,trustworthy,surgeons,stupidity,skies,remorse,preferably,pies,nausea,napkins,mule,mourn,melted,mashed,inherit,greatness,golly,excused,dumbo,drifting,delirious,damaging,cubicle,compelled,comm,chooses,checkup,boredom,bandages,alarms,windshield,who're,whaddya,transparent,surprisingly,sunglasses,slit,roar,reade,prognosis,probe,pitiful,persistent,peas,nosy,nagging,morons,masterpiece,martinis,limbo,liars,irritating,inclined,hump,hoynes,fiasco,eatin,cubans,concentrating,colorful,clam,cider,brochure,barto,bargaining,wiggle,welcoming,weighing,vanquished,stains,sooo,snacks,smear,sire,resentment,psychologist,pint,overhear,morality,landingham,kisser,hoot,holling,handshake,grilled,formality,elevators,depths,confirms,boathouse,accidental,westbridge,wacko,ulterior,thugs,thighs,tangled,stirred,snag,sling,sleaze,rumour,ripe,remarried,puddle,pins,perceptive,miraculous,longing,lockup,librarian,impressions,immoral,hypothetically,guarding,gourmet,gabe,faxed,extortion,downright,digest,cranberry,bygones,buzzing,burying,bikes,weary,taping,takeout,sweeping,stepmother,stale,senor,seaborn,pros,pepperoni,newborn,ludicrous,injected,geeks,forged,faults,drue,dire,dief,desi,deceiving,caterer,calmed,budge,ankles,vending,typing,tribbiani,there're,squared,snowing,shades,sexist,rewrite,regretted,raises,picky,orphan,mural,misjudged,miscarriage,memorize,leaking,jitters,invade,interruption,illegally,handicapped,glitch,gittes,finer,distraught,dispose,dishonest,digs,dads,cruelty,circling,canceling,butterflies,belongings,barbrady,amusement,alias,zombies,where've,unborn,swearing,stables,squeezed,sensational,resisting,radioactive,questionable,privileged,portofino,owning,overlook,orson,oddly,interrogate,imperative,impeccable,hurtful,hors,heap,graders,glance,disgust,devious,destruct,crazier,countdown,chump,cheeseburger,burglar,berries,ballroom,assumptions,annoyed,allergy,admirer,admirable,activate,underpants,twit,tack,strokes,stool,sham,scrap,retarded,resourceful,remarkably,refresh,pressured,precautions,pointy,nightclub,mustache,maui,lace,hunh,hubby,flare,dont,dokey,dangerously,crushing,clinging,choked,chem,cheerleading,checkbook,cashmere,calmly,blush,believer,amazingly,alas,what've,toilets,tacos,stairwell,spirited,sewing,rubbed,punches,protects,nuisance,motherfuckers,mingle,kynaston,knack,kinkle,impose,gullible,godmother,funniest,friggin,folding,fashions,eater,dysfunctional,drool,dripping,ditto,cruising,criticize,conceive,clone,cedars,caliber,brighter,blinded,birthdays,banquet,anticipate,annoy,whim,whichever,volatile,veto,vested,shroud,rests,reindeer,quarantine,pleases,painless,orphans,orphanage,offence,obliged,negotiation,narcotics,mistletoe,meddling,manifest,lookit,lilah,intrigued,injustice,homicidal,gigantic,exposing,elves,disturbance,disastrous,depended,demented,correction,cooped,cheerful,buyers,brownies,beverage,basics,arvin,weighs,upsets,unethical,swollen,sweaters,stupidest,sensation,scalpel,props,prescribed,pompous,objections,mushrooms,mulwray,manipulation,lured,internship,insignificant,inmate,incentive,fulfilled,disagreement,crypt,cornered,copied,brightest,beethoven,attendant,amaze,yogurt,wyndemere,vocabulary,tulsa,tactic,stuffy,respirator,pretends,polygraph,pennies,ordinarily,olives,necks,morally,martyr,leftovers,joints,hopping,homey,hints,heartbroken,forge,florist,firsthand,fiend,dandy,crippled,corrected,conniving,conditioner,clears,chemo,bubbly,bladder,beeper,baptism,wiring,wench,weaknesses,volunteering,violating,unlocked,tummy,surrogate,subid,stray,startle,specifics,slowing,scoot,robbers,rightful,richest,qfxmjrie,puffs,pierced,pencils,paralysis,makeover,luncheon,linksynergy,jerky,jacuzzi,hitched,hangover,fracture,flock,firemen,disgusted,darned,clams,borrowing,banged,wildest,weirder,unauthorized,stunts,sleeves,sixties,shush,shalt,retro,quits,pegged,painfully,paging,omelet,memorized,lawfully,jackets,intercept,ingredient,grownup,glued,fulfilling,enchanted,delusion,daring,compelling,carton,bridesmaids,bribed,boiling,bathrooms,bandage,awaiting,assign,arrogance,antiques,ainsley,turkeys,trashing,stockings,stalked,stabilized,skates,sedated,robes,respecting,psyche,presumptuous,prejudice,paragraph,mocha,mints,mating,mantan,lorne,loads,listener,itinerary,hepatitis,heave,guesses,fading,examining,dumbest,dishwasher,deceive,cunning,cripple,convictions,confided,compulsive,compromising,burglary,bumpy,brainwashed,benes,arnie,affirmative,adrenaline,adamant,watchin,waitresses,transgenic,toughest,tainted,surround,stormed,spree,spilling,spectacle,soaking,shreds,sewers,severed,scarce,scamming,scalp,rewind,rehearsing,pretentious,potions,overrated,obstacle,nerds,meems,mcmurphy,maternity,maneuver,loathe,fertility,eloping,ecstatic,ecstasy,divorcing,dignan,costing,clubhouse,clocks,candid,bursting,breather,braces,bending,arsonist,adored,absorb,valiant,uphold,unarmed,topolsky,thrilling,thigh,terminate,sustain,spaceship,snore,sneeze,smuggling,salty,quaint,patronize,patio,morbid,mamma,kettle,joyous,invincible,interpret,insecurities,impulses,illusions,holed,exploit,drivin,defenseless,dedicate,cradle,coupon,countless,conjure,cardboard,booking,backseat,accomplishment,wordsworth,wisely,valet,vaccine,urges,unnatural,unlucky,truths,traumatized,tasting,swears,strawberries,steaks,stats,skank,seducing,secretive,scumbag,screwdriver,schedules,rooting,rightfully,rattled,qualifies,puppets,prospects,pronto,posse,polling,pedestal,palms,muddy,morty,microscope,merci,lecturing,inject,incriminate,hygiene,grapefruit,gazebo,funnier,cuter,bossy,booby,aides,zende,winthrop,warrants,valentines,undressed,underage,truthfully,tampered,suffers,speechless,sparkling,sidelines,shrek,railing,puberty,pesky,outrage,outdoors,motions,moods,lunches,litter,kidnappers,itching,intuition,imitation,humility,hassling,gallons,drugstore,dosage,disrupt,dipping,deranged,debating,cuckoo,cremated,craziness,cooperating,circumstantial,chimney,blinking,biscuits,admiring,weeping,triad,trashy,soothing,slumber,slayers,skirts,siren,shindig,sentiment,rosco,riddance,quaid,purity,proceeding,pretzels,panicking,mckechnie,lovin,leaked,intruding,impersonating,ignorance,hamburgers,footprints,fluke,fleas,festivities,fences,feisty,evacuate,emergencies,deceived,creeping,craziest,corpses,conned,coincidences,bounced,bodyguards,blasted,bitterness,baloney,ashtray,apocalypse,zillion,watergate,wallpaper,telesave,sympathize,sweeter,startin,spades,sodas,snowed,sleepover,signor,seein,retainer,restroom,rested,repercussions,reliving,reconcile,prevail,preaching,overreact,o'neil,noose,moustache,manicure,maids,landlady,hypothetical,hopped,homesick,hives,hesitation,herbs,hectic,heartbreak,haunting,gangs,frown,fingerprint,exhausting,everytime,disregard,cling,chevron,chaperone,blinding,bitty,beads,battling,badgering,anticipation,upstanding,unprofessional,unhealthy,turmoil,truthful,toothpaste,tippin,thoughtless,tagataya,shooters,senseless,rewarding,propane,preposterous,pigeons,pastry,overhearing,obscene,negotiable,loner,jogging,itchy,insinuating,insides,hospitality,hormone,hearst,forthcoming,fists,fifties,etiquette,endings,destroys,despises,deprived,cuddy,crust,cloak,circumstance,chewed,casserole,bidder,bearer,artoo,applaud,appalling,vowed,virgins,vigilante,undone,throttle,testosterone,tailor,symptom,swoop,suitcases,stomp,sticker,stakeout,spoiling,snatched,smoochy,smitten,shameless,restraints,researching,renew,refund,reclaim,raoul,puzzles,purposely,punks,prosecuted,plaid,picturing,pickin,parasites,mysteriously,multiply,mascara,jukebox,interruptions,gunfire,furnace,elbows,duplicate,drapes,deliberate,decoy,cryptic,coupla,condemn,complicate,colossal,clerks,clarity,brushed,banished,argon,alarmed,worships,versa,uncanny,technicality,sundae,stumble,stripping,shuts,schmuck,satin,saliva,robber,relentless,reconnect,recipes,rearrange,rainy,psychiatrists,policemen,plunge,plugged,patched,overload,o'malley,mindless,menus,lullaby,lotte,leavin,killin,karinsky,invalid,hides,grownups,griff,flaws,flashy,flaming,fettes,evicted,dread,degrassi,dealings,dangers,cushion,bowel,barged,abide,abandoning,wonderfully,wait'll,violate,suicidal,stayin,sorted,slamming,sketchy,shoplifting,raiser,quizmaster,prefers,needless,motherhood,momentarily,migraine,lifts,leukemia,leftover,keepin,hinks,hellhole,gowns,goodies,gallon,futures,entertained,eighties,conspiring,cheery,benign,apiece,adjustments,abusive,abduction,wiping,whipping,welles,unspeakable,unidentified,trivial,transcripts,textbook,supervise,superstitious,stricken,stimulating,spielberg,slices,shelves,scratches,sabotaged,retrieval,repressed,rejecting,quickie,ponies,peeking,outraged,o'connell,moping,moaning,mausoleum,licked,kovich,klutz,interrogating,interfered,insulin,infested,incompetence,hyper,horrified,handedly,gekko,fraid,fractured,examiner,eloped,disoriented,dashing,crashdown,courier,cockroach,chipped,brushing,bombed,bolts,baths,baptized,astronaut,assurance,anemia,abuela,abiding,withholding,weave,wearin,weaker,suffocating,straws,straightforward,stench,steamed,starboard,sideways,shrinks,shortcut,scram,roasted,roaming,riviera,respectfully,repulsive,psychiatry,provoked,penitentiary,painkillers,ninotchka,mitzvah,milligrams,midge,marshmallows,looky,lapse,kubelik,intellect,improvise,implant,goa'ulds,giddy,geniuses,fruitcake,footing,fightin,drinkin,doork,detour,cuddle,crashes,combo,colonnade,cheats,cetera,bailiff,auditioning,assed,amused,alienate,aiding,aching,unwanted,topless,tongues,tiniest,superiors,soften,sheldrake,rawley,raisins,presses,plaster,nessa,narrowed,minions,merciful,lawsuits,intimidating,infirmary,inconvenient,imposter,hugged,honoring,holdin,hades,godforsaken,fumes,forgery,foolproof,folder,flattery,fingertips,exterminator,explodes,eccentric,dodging,disguised,crave,constructive,concealed,compartment,chute,chinpokomon,bodily,astronauts,alimony,accustomed,abdominal,wrinkle,wallow,valium,untrue,uncover,trembling,treasures,torched,toenails,timed,termites,telly,taunting,taransky,talker,succubus,smarts,sliding,sighting,semen,seizures,scarred,savvy,sauna,saddest,sacrificing,rubbish,riled,ratted,rationally,provenance,phonse,perky,pedal,overdose,nasal,nanites,mushy,movers,missus,midterm,merits,melodramatic,manure,knitting,invading,interpol,incapacitated,hotline,hauling,gunpoint,grail,ganza,framing,flannel,faded,eavesdrop,desserts,calories,breathtaking,bleak,blacked,batter,aggravated,yanked,wigand,whoah,unwind,undoubtedly,unattractive,twitch,trimester,torrance,timetable,taxpayers,strained,stared,slapping,sincerity,siding,shenanigans,shacking,sappy,samaritan,poorer,politely,paste,oysters,overruled,nightcap,mosquito,millimeter,merrier,manhood,lucked,kilos,ignition,hauled,harmed,goodwill,freshmen,fenmore,fasten,farce,exploding,erratic,drunks,ditching,d'artagnan,cramped,contacting,closets,clientele,chimp,bargained,arranging,anesthesia,amuse,altering,afternoons,accountable,abetting,wolek,waved,uneasy,toddy,tattooed,spauldings,sliced,sirens,schibetta,scatter,rinse,remedy,redemption,pleasures,optimism,oblige,mmmmm,masked,malicious,mailing,kosher,kiddies,judas,isolate,insecurity,incidentally,heals,headlights,growl,grilling,glazed,flunk,floats,fiery,fairness,exercising,excellency,disclosure,cupboard,counterfeit,condescending,conclusive,clicked,cleans,cholesterol,cashed,broccoli,brats,blueprints,blindfold,billing,attach,appalled,alrighty,wynant,unsolved,unreliable,toots,tighten,sweatshirt,steinbrenner,steamy,spouse,sonogram,slots,sleepless,shines,retaliate,rephrase,redeem,rambling,quilt,quarrel,prying,proverbial,priced,prescribe,prepped,pranks,possessive,plaintiff,pediatrics,overlooked,outcast,nightgown,mumbo,mediocre,mademoiselle,lunchtime,lifesaver,leaned,lambs,interns,hounding,hellmouth,hahaha,goner,ghoul,gardening,frenzy,foyer,extras,exaggerate,everlasting,enlightened,dialed,devote,deceitful,d'oeuvres,cosmetic,contaminated,conspired,conning,cavern,carving,butting,boiled,blurry,babysit,ascension,aaaaah,wildly,whoopee,whiny,weiskopf,walkie,vultures,vacations,upfront,unresolved,tampering,stockholders,snaps,sleepwalking,shrunk,sermon,seduction,scams,revolve,phenomenal,patrolling,paranormal,ounces,omigod,nightfall,lashing,innocents,infierno,incision,humming,haunts,gloss,gloating,frannie,fetal,feeny,entrapment,discomfort,detonator,dependable,concede,complication,commotion,commence,chulak,caucasian,casually,brainer,bolie,ballpark,anwar,analyzing,accommodations,youse,wring,wallowing,transgenics,thrive,tedious,stylish,strippers,sterile,squeezing,squeaky,sprained,solemn,snoring,shattering,shabby,seams,scrawny,revoked,residue,reeks,recite,ranting,quoting,predicament,plugs,pinpoint,petrified,pathological,passports,oughtta,nighter,navigate,kippie,intrigue,intentional,insufferable,hunky,how've,horrifying,hearty,hamptons,grazie,funerals,forks,fetched,excruciating,enjoyable,endanger,dumber,drying,diabolical,crossword,corry,comprehend,clipped,classmates,candlelight,brutally,brutality,boarded,bathrobe,authorize,assemble,aerobics,wholesome,whiff,vermin,trophies,trait,tragically,toying,testy,tasteful,stocked,spinach,sipping,sidetracked,scrubbing,scraping,sanctity,robberies,ridin,retribution,refrain,realities,radiant,protesting,projector,plutonium,payin,parting,o'reilly,nooooo,motherfucking,measly,manic,lalita,juggling,jerking,intro,inevitably,hypnosis,huddle,horrendous,hobbies,heartfelt,harlin,hairdresser,gonorrhea,fussing,furtwangler,fleeting,flawless,flashed,fetus,eulogy,distinctly,disrespectful,denies,crossbow,cregg,crabs,cowardly,contraction,contingency,confirming,condone,coffins,cleansing,cheesecake,certainty,cages,c'est,briefed,bravest,bosom,boils,binoculars,bachelorette,appetizer,ambushed,alerted,woozy,withhold,vulgar,utmost,unleashed,unholy,unhappiness,unconditional,typewriter,typed,twists,supermodel,subpoenaed,stringing,skeptical,schoolgirl,romantically,rocked,revoir,reopen,puncture,preach,polished,planetarium,penicillin,peacefully,nurturing,more'n,mmhmm,midgets,marklar,lodged,lifeline,jellyfish,infiltrate,hutch,horseback,heist,gents,frickin,freezes,forfeit,flakes,flair,fathered,eternally,epiphany,disgruntled,discouraged,delinquent,decipher,danvers,cubes,credible,coping,chills,cherished,catastrophe,bombshell,birthright,billionaire,ample,affections,admiration,abbotts,whatnot,watering,vinegar,unthinkable,unseen,unprepared,unorthodox,underhanded,uncool,timeless,thump,thermometer,theoretically,tapping,tagged,swung,stares,spiked,solves,smuggle,scarier,saucer,quitter,prudent,powdered,poked,pointers,peril,penetrate,penance,opium,nudge,nostrils,neurological,mockery,mobster,medically,loudly,insights,implicate,hypocritical,humanly,holiness,healthier,hammered,haldeman,gunman,gloom,freshly,francs,flunked,flawed,emptiness,drugging,dozer,derevko,deprive,deodorant,cryin,crocodile,coloring,colder,cognac,clocked,clippings,charades,chanting,certifiable,caterers,brute,brochures,botched,blinders,bitchin,banter,woken,ulcer,tread,thankfully,swine,swimsuit,swans,stressing,steaming,stamped,stabilize,squirm,snooze,shuffle,shredded,seafood,scratchy,savor,sadistic,rhetorical,revlon,realist,prosecuting,prophecies,polyester,petals,persuasion,paddles,o'leary,nuthin,neighbour,negroes,muster,meningitis,matron,lockers,letterman,legged,indictment,hypnotized,housekeeping,hopelessly,hallucinations,grader,goldilocks,girly,flask,envelopes,downside,doves,dissolve,discourage,disapprove,diabetic,deliveries,decorator,crossfire,criminally,containment,comrades,complimentary,chatter,catchy,cashier,cartel,caribou,cardiologist,brawl,booted,barbershop,aryan,angst,administer,zellie,wreak,whistles,vandalism,vamps,uterus,upstate,unstoppable,understudy,tristin,transcript,tranquilizer,toxins,tonsils,stempel,spotting,spectator,spatula,softer,snotty,slinging,showered,sexiest,sensual,sadder,rimbaud,restrain,resilient,remission,reinstate,rehash,recollection,rabies,popsicle,plausible,pediatric,patronizing,ostrich,ortolani,oooooh,omelette,mistrial,marseilles,loophole,laughin,kevvy,irritated,infidelity,hypothermia,horrific,groupie,grinding,graceful,goodspeed,gestures,frantic,extradition,echelon,disks,dawnie,dared,damsel,curled,collateral,collage,chant,calculating,bumping,bribes,boardwalk,blinds,blindly,bleeds,bickering,beasts,backside,avenge,apprehended,anguish,abusing,youthful,yells,yanking,whomever,when'd,vomiting,vengeful,unpacking,unfamiliar,undying,tumble,trolls,treacherous,tipping,tantrum,tanked,summons,straps,stomped,stinkin,stings,staked,squirrels,sprinkles,speculate,sorting,skinned,sicko,sicker,shootin,shatter,seeya,schnapps,s'posed,ronee,respectful,regroup,regretting,reeling,reckoned,ramifications,puddy,projections,preschool,plissken,platonic,permalash,outdone,outburst,mutants,mugging,misfortune,miserably,miraculously,medications,margaritas,manpower,lovemaking,logically,leeches,latrine,kneel,inflict,impostor,hypocrisy,hippies,heterosexual,heightened,hecuba,healer,gunned,grooming,groin,gooey,gloomy,frying,friendships,fredo,firepower,fathom,exhaustion,evils,endeavor,eggnog,dreaded,d'arcy,crotch,coughing,coronary,cookin,consummate,congrats,companionship,caved,caspar,bulletproof,brilliance,breakin,brash,blasting,aloud,airtight,advising,advertise,adultery,aches,wronged,upbeat,trillion,thingies,tending,tarts,surreal,specs,specialize,spade,shrew,shaping,selves,schoolwork,roomie,recuperating,rabid,quart,provocative,proudly,pretenses,prenatal,pharmaceuticals,pacing,overworked,originals,nicotine,murderous,mileage,mayonnaise,massages,losin,interrogated,injunction,impartial,homing,heartbreaker,hacks,glands,giver,fraizh,flips,flaunt,englishman,electrocuted,dusting,ducking,drifted,donating,cylon,crutches,crates,cowards,comfortably,chummy,chitchat,childbirth,businesswoman,brood,blatant,bethy,barring,bagged,awakened,asbestos,airplanes,worshipped,winnings,why're,visualize,unprotected,unleash,trays,thicker,therapists,takeoff,streisand,storeroom,stethoscope,stacked,spiteful,sneaks,snapping,slaughtered,slashed,simplest,silverware,shits,secluded,scruples,scrubs,scraps,ruptured,roaring,receptionist,recap,raditch,radiator,pushover,plastered,pharmacist,perverse,perpetrator,ornament,ointment,nineties,napping,nannies,mousse,moors,momentary,misunderstandings,manipulator,malfunction,laced,kivar,kickin,infuriating,impressionable,holdup,hires,hesitated,headphones,hammering,groundwork,grotesque,graces,gauze,gangsters,frivolous,freeing,fours,forwarding,ferrars,faulty,fantasizing,extracurricular,empathy,divorces,detonate,depraved,demeaning,deadlines,dalai,cursing,cufflink,crows,coupons,comforted,claustrophobic,casinos,camped,busboy,bluth,bennetts,baskets,attacker,aplastic,angrier,affectionate,zapped,wormhole,weaken,unrealistic,unravel,unimportant,unforgettable,twain,suspend,superbowl,stutter,stewardess,stepson,standin,spandex,souvenirs,sociopath,skeletons,shivering,sexier,selfishness,scrapbook,ritalin,ribbons,reunite,remarry,relaxation,rattling,rapist,psychosis,prepping,poses,pleasing,pisses,piling,persecuted,padded,operatives,negotiator,natty,menopause,mennihan,martimmys,loyalties,laynie,lando,justifies,intimately,inexperienced,impotent,immortality,horrors,hooky,hinges,heartbreaking,handcuffed,gypsies,guacamole,grovel,graziella,goggles,gestapo,fussy,ferragamo,feeble,eyesight,explosions,experimenting,enchanting,doubtful,dizziness,dismantle,detectors,deserving,defective,dangling,dancin,crumble,creamed,cramping,conceal,clockwork,chrissakes,chrissake,chopping,cabinets,brooding,bonfire,blurt,bloated,blackmailer,beforehand,bathed,bathe,barcode,banish,badges,babble,await,attentive,aroused,antibodies,animosity,ya'll,wrinkled,wonderland,willed,whisk,waltzing,waitressing,vigilant,upbringing,unselfish,uncles,trendy,trajectory,striped,stamina,stalled,staking,stacks,spoils,snuff,snooty,snide,shrinking,senora,secretaries,scoundrel,saline,salads,rundown,riddles,relapse,recommending,raspberry,plight,pecan,pantry,overslept,ornaments,niner,negligent,negligence,nailing,mucho,mouthed,monstrous,malpractice,lowly,loitering,logged,lingering,lettin,lattes,kamal,juror,jillefsky,jacked,irritate,intrusion,insatiable,infect,impromptu,icing,hmmmm,hefty,gasket,frightens,flapping,firstborn,faucet,estranged,envious,dopey,doesn,disposition,disposable,disappointments,dipped,dignified,deceit,dealership,deadbeat,curses,coven,counselors,concierge,clutches,casbah,callous,cahoots,brotherly,britches,brides,bethie,beige,autographed,attendants,attaboy,astonishing,appreciative,antibiotic,aneurysm,afterlife,affidavit,zoning,whats,whaddaya,vasectomy,unsuspecting,toula,topanga,tonio,toasted,tiring,terrorized,tenderness,tailing,sweats,suffocated,sucky,subconsciously,starvin,sprouts,spineless,sorrows,snowstorm,smirk,slicery,sledding,slander,simmer,signora,sigmund,seventies,sedate,scented,sandals,rollers,retraction,resigning,recuperate,receptive,racketeering,queasy,provoking,priors,prerogative,premed,pinched,pendant,outsiders,orbing,opportunist,olanov,neurologist,nanobot,mommies,molested,misread,mannered,laundromat,intercom,inspect,insanely,infatuation,indulgent,indiscretion,inconsiderate,hurrah,howling,herpes,hasta,harassed,hanukkah,groveling,groosalug,gander,galactica,futile,fridays,flier,fixes,exploiting,exorcism,evasive,endorse,emptied,dreary,dreamy,downloaded,dodged,doctored,disobeyed,disneyland,disable,dehydrated,contemplating,coconuts,cockroaches,clogged,chilling,chaperon,cameraman,bulbs,bucklands,bribing,brava,bracelets,bowels,bluepoint,appetizers,appendix,antics,anointed,analogy,almonds,yammering,winch,weirdness,wangler,vibrations,vendor,unmarked,unannounced,twerp,trespass,travesty,transfusion,trainee,towelie,tiresome,straightening,staggering,sonar,socializing,sinus,sinners,shambles,serene,scraped,scones,scepter,sarris,saberhagen,ridiculously,ridicule,rents,reconciled,radios,publicist,pubes,prune,prude,precrime,postponing,pluck,perish,peppermint,peeled,overdo,nutshell,nostalgic,mulan,mouthing,mistook,meddle,maybourne,martimmy,lobotomy,livelihood,lippman,likeness,kindest,kaffee,jocks,jerked,jeopardizing,jazzed,insured,inquisition,inhale,ingenious,holier,helmets,heirloom,heinous,haste,harmsway,hardship,hanky,gutters,gruesome,groping,goofing,godson,glare,finesse,figuratively,ferrie,endangerment,dreading,dozed,dorky,dmitri,divert,discredit,dialing,cufflinks,crutch,craps,corrupted,cocoon,cleavage,cannery,bystander,brushes,bruising,bribery,brainstorm,bolted,binge,ballistics,astute,arroway,adventurous,adoptive,addicts,addictive,yadda,whitelighters,wematanye,weeds,wedlock,wallets,vulnerability,vroom,vents,upped,unsettling,unharmed,trippin,trifle,tracing,tormenting,thats,syphilis,subtext,stickin,spices,sores,smacked,slumming,sinks,signore,shitting,shameful,shacked,septic,seedy,righteousness,relish,rectify,ravishing,quickest,phoebs,perverted,peeing,pedicure,pastrami,passionately,ozone,outnumbered,oregano,offender,nukes,nosed,nighty,nifty,mounties,motivate,moons,misinterpreted,mercenary,mentality,marsellus,lupus,lumbar,lovesick,lobsters,leaky,laundering,latch,jafar,instinctively,inspires,indoors,incarcerated,hundredth,handkerchief,gynecologist,guittierez,groundhog,grinning,goodbyes,geese,fullest,eyelashes,eyelash,enquirer,endlessly,elusive,disarm,detest,deluding,dangle,cotillion,corsage,conjugal,confessional,cones,commandment,coded,coals,chuckle,christmastime,cheeseburgers,chardonnay,celery,campfire,calming,burritos,brundle,broflovski,brighten,borderline,blinked,bling,beauties,bauers,battered,articulate,alienated,ahhhhh,agamemnon,accountants,y'see,wrongful,wrapper,workaholic,winnebago,whispered,warts,vacate,unworthy,unanswered,tonane,tolerated,throwin,throbbing,thrills,thorns,thereof,there've,tarot,sunscreen,stretcher,stereotype,soggy,sobbing,sizable,sightings,shucks,shrapnel,sever,senile,seaboard,scorned,saver,rebellious,rained,putty,prenup,pores,pinching,pertinent,peeping,paints,ovulating,opposites,occult,nutcracker,nutcase,newsstand,newfound,mocked,midterms,marshmallow,marbury,maclaren,leans,krudski,knowingly,keycard,junkies,juilliard,jolinar,irritable,invaluable,inuit,intoxicating,instruct,insolent,inexcusable,incubator,illustrious,hunsecker,houseguest,homosexuals,homeroom,hernia,harming,handgun,hallways,hallucination,gunshots,groupies,groggy,goiter,gingerbread,giggling,frigging,fledged,fedex,fairies,exchanging,exaggeration,esteemed,enlist,drags,dispense,disloyal,disconnect,desks,dentists,delacroix,degenerate,daydreaming,cushions,cuddly,corroborate,complexion,compensated,cobbler,closeness,chilled,checkmate,channing,carousel,calms,bylaws,benefactor,ballgame,baiting,backstabbing,artifact,airspace,adversary,actin,accuses,accelerant,abundantly,abstinence,zissou,zandt,yapping,witchy,willows,whadaya,vilandra,veiled,undress,undivided,underestimating,ultimatums,twirl,truckload,tremble,toasting,tingling,tents,tempered,sulking,stunk,sponges,spills,softly,snipers,scourge,rooftop,riana,revolting,revisit,refreshments,redecorating,recapture,raysy,pretense,prejudiced,precogs,pouting,poofs,pimple,piles,pediatrician,padre,packets,paces,orvelle,oblivious,objectivity,nighttime,nervosa,mexicans,meurice,melts,matchmaker,maeby,lugosi,lipnik,leprechaun,kissy,kafka,introductions,intestines,inspirational,insightful,inseparable,injections,inadvertently,hussy,huckabees,hittin,hemorrhaging,headin,haystack,hallowed,grudges,granilith,grandkids,grading,gracefully,godsend,gobbles,fragrance,fliers,finchley,farts,eyewitnesses,expendable,existential,dorms,delaying,degrading,deduction,darlings,danes,cylons,counsellor,contraire,consciously,conjuring,congratulating,cokes,buffay,brooch,bitching,bistro,bijou,bewitched,benevolent,bends,bearings,barren,aptitude,amish,amazes,abomination,worldly,whispers,whadda,wayward,wailing,vanishing,upscale,untouchable,unspoken,uncontrollable,unavoidable,unattended,trite,transvestite,toupee,timid,timers,terrorizing,swana,stumped,strolling,storybook,storming,stomachs,stoked,stationery,springtime,spontaneity,spits,spins,soaps,sentiments,scramble,scone,rooftops,retract,reflexes,rawdon,ragged,quirky,quantico,psychologically,prodigal,pounce,potty,pleasantries,pints,petting,perceive,onstage,notwithstanding,nibble,newmans,neutralize,mutilated,millionaires,mayflower,masquerade,mangy,macreedy,lunatics,lovable,locating,limping,lasagna,kwang,keepers,juvie,jaded,ironing,intuitive,intensely,insure,incantation,hysteria,hypnotize,humping,happenin,griet,grasping,glorified,ganging,g'night,focker,flunking,flimsy,flaunting,fixated,fitzwallace,fainting,eyebrow,exonerated,ether,electrician,egotistical,earthly,dusted,dignify,detonation,debrief,dazzling,dan'l,damnedest,daisies,crushes,crucify,contraband,confronting,collapsing,cocked,clicks,cliche,circled,chandelier,carburetor,callers,broads,breathes,bloodshed,blindsided,blabbing,bialystock,bashing,ballerina,aviva,arteries,anomaly,airstrip,agonizing,adjourn,aaaaa,yearning,wrecker,witnessing,whence,warhead,unsure,unheard,unfreeze,unfold,unbalanced,ugliest,troublemaker,toddler,tiptoe,threesome,thirties,thermostat,swipe,surgically,subtlety,stung,stumbling,stubs,stride,strangling,sprayed,socket,smuggled,showering,shhhhh,sabotaging,rumson,rounding,risotto,repairman,rehearsed,ratty,ragging,radiology,racquetball,racking,quieter,quicksand,prowl,prompt,premeditated,prematurely,prancing,porcupine,plated,pinocchio,peeked,peddle,panting,overweight,overrun,outing,outgrown,obsess,nursed,nodding,negativity,negatives,musketeers,mugger,motorcade,merrily,matured,masquerading,marvellous,maniacs,lovey,louse,linger,lilies,lawful,kudos,knuckle,juices,judgments,itches,intolerable,intermission,inept,incarceration,implication,imaginative,huckleberry,holster,heartburn,gunna,groomed,graciously,fulfillment,fugitives,forsaking,forgives,foreseeable,flavors,flares,fixation,fickle,fantasize,famished,fades,expiration,exclamation,erasing,eiffel,eerie,earful,duped,dulles,dissing,dissect,dispenser,dilated,detergent,desdemona,debriefing,damper,curing,crispina,crackpot,courting,cordial,conflicted,comprehension,commie,cleanup,chiropractor,charmer,chariot,cauldron,catatonic,bullied,buckets,brilliantly,breathed,booths,boardroom,blowout,blindness,blazing,biologically,bibles,biased,beseech,barbaric,balraj,audacity,anticipating,alcoholics,airhead,agendas,admittedly,absolution,youre,yippee,wittlesey,withheld,willful,whammy,weakest,washes,virtuous,videotapes,vials,unplugged,unpacked,unfairly,turbulence,tumbling,tricking,tremendously,traitors,torches,tinga,thyroid,teased,tawdry,taker,sympathies,swiped,sundaes,suave,strut,stepdad,spewing,spasm,socialize,slither,simulator,shutters,shrewd,shocks,semantics,schizophrenic,scans,savages,rya'c,runny,ruckus,royally,roadblocks,rewriting,revoke,repent,redecorate,recovers,recourse,ratched,ramali,racquet,quince,quiche,puppeteer,puking,puffed,problemo,praises,pouch,postcards,pooped,poised,piled,phoney,phobia,patching,parenthood,pardner,oozing,ohhhhh,numbing,nostril,nosey,neatly,nappa,nameless,mortuary,moronic,modesty,midwife,mcclane,matuka,maitre,lumps,lucid,loosened,loins,lawnmower,lamotta,kroehner,jinxy,jessep,jamming,jailhouse,jacking,intruders,inhuman,infatuated,indigestion,implore,implanted,hormonal,hoboken,hillbilly,heartwarming,headway,hatched,hartmans,harping,grapevine,gnome,forties,flyin,flirted,fingernail,exhilarating,enjoyment,embark,dumper,dubious,drell,docking,disillusioned,dishonor,disbarred,dicey,custodial,counterproductive,corned,cords,contemplate,concur,conceivable,cobblepot,chickened,checkout,carpe,cap'n,campers,buyin,bullies,braid,boxed,bouncy,blueberries,blubbering,bloodstream,bigamy,beeped,bearable,autographs,alarming,wretch,wimps,widower,whirlwind,whirl,warms,vandelay,unveiling,undoing,unbecoming,turnaround,touche,togetherness,tickles,ticker,teensy,taunt,sweethearts,stitched,standpoint,staffers,spotless,soothe,smothered,sickening,shouted,shepherds,shawl,seriousness,schooled,schoolboy,s'mores,roped,reminders,raggedy,preemptive,plucked,pheromones,particulars,pardoned,overpriced,overbearing,outrun,ohmigod,nosing,nicked,neanderthal,mosquitoes,mortified,milky,messin,mecha,markinson,marivellas,mannequin,manderley,madder,macready,lookie,locusts,lifetimes,lanna,lakhi,kholi,impersonate,hyperdrive,horrid,hopin,hogging,hearsay,harpy,harboring,hairdo,hafta,grasshopper,gobble,gatehouse,foosball,floozy,fished,firewood,finalize,felons,euphemism,entourage,elitist,elegance,drokken,drier,dredge,dossier,diseased,diarrhea,diagnose,despised,defuse,d'amour,contesting,conserve,conscientious,conjured,collars,clogs,chenille,chatty,chamomile,casing,calculator,brittle,breached,blurted,birthing,bikinis,astounding,assaulting,aroma,appliance,antsy,amnio,alienating,aliases,adolescence,xerox,wrongs,workload,willona,whistling,werewolves,wallaby,unwelcome,unseemly,unplug,undermining,ugliness,tyranny,tuesdays,trumpets,transference,ticks,tangible,tagging,swallowing,superheroes,studs,strep,stowed,stomping,steffy,sprain,spouting,sponsoring,sneezing,smeared,slink,shakin,sewed,seatbelt,scariest,scammed,sanctimonious,roasting,rightly,retinal,rethinking,resented,reruns,remover,racks,purest,progressing,presidente,preeclampsia,postponement,portals,poppa,pliers,pinning,pelvic,pampered,padding,overjoyed,ooooo,one'll,octavius,nonono,nicknames,neurosurgeon,narrows,misled,mislead,mishap,milltown,milking,meticulous,mediocrity,meatballs,machete,lurch,layin,knockin,khruschev,jurors,jumpin,jugular,jeweler,intellectually,inquiries,indulging,indestructible,indebted,imitate,ignores,hyperventilating,hyenas,hurrying,hermano,hellish,heheh,harshly,handout,grunemann,glances,giveaway,getup,gerome,furthest,frosting,frail,forwarded,forceful,flavored,flammable,flaky,fingered,fatherly,ethic,embezzlement,duffel,dotted,distressed,disobey,disappearances,dinky,diminish,diaphragm,deuces,creme,courteous,comforts,coerced,clots,clarification,chunks,chickie,chases,chaperoning,cartons,caper,calves,caged,bustin,bulging,bringin,boomhauer,blowin,blindfolded,biscotti,ballplayer,bagging,auster,assurances,aschen,arraigned,anonymity,alters,albatross,agreeable,adoring,abduct,wolfi,weirded,watchers,washroom,warheads,vincennes,urgency,understandably,uncomplicated,uhhhh,twitching,treadmill,thermos,tenorman,tangle,talkative,swarm,surrendering,summoning,strive,stilts,stickers,squashed,spraying,sparring,soaring,snort,sneezed,slaps,skanky,singin,sidle,shreck,shortness,shorthand,sharper,shamed,sadist,rydell,rusik,roulette,resumes,respiration,recount,reacts,purgatory,princesses,presentable,ponytail,plotted,pinot,pigtails,phillippe,peddling,paroled,orbed,offends,o'hara,moonlit,minefield,metaphors,malignant,mainframe,magicks,maggots,maclaine,loathing,leper,leaps,leaping,lashed,larch,larceny,lapses,ladyship,juncture,jiffy,jakov,invoke,infantile,inadmissible,horoscope,hinting,hideaway,hesitating,heddy,heckles,hairline,gripe,gratifying,governess,goebbels,freddo,foresee,fascination,exemplary,executioner,etcetera,escorts,endearing,eaters,earplugs,draped,disrupting,disagrees,dimes,devastate,detain,depositions,delicacy,darklighter,cynicism,cyanide,cutters,cronus,continuance,conquering,confiding,compartments,combing,cofell,clingy,cleanse,christmases,cheered,cheekbones,buttle,burdened,bruenell,broomstick,brained,bozos,bontecou,bluntman,blazes,blameless,bizarro,bellboy,beaucoup,barkeep,awaken,astray,assailant,appease,aphrodisiac,alleys,yesss,wrecks,woodpecker,wondrous,wimpy,willpower,wheeling,weepy,waxing,waive,videotaped,veritable,untouched,unlisted,unfounded,unforeseen,twinge,triggers,traipsing,toxin,tombstone,thumping,therein,testicles,telephones,tarmac,talby,tackled,swirling,suicides,suckered,subtitles,sturdy,strangler,stockbroker,stitching,steered,standup,squeal,sprinkler,spontaneously,splendor,spiking,spender,snipe,snagged,skimming,siddown,showroom,shovels,shotguns,shoelaces,shitload,shellfish,sharpest,shadowy,seizing,scrounge,scapegoat,sayonara,saddled,rummaging,roomful,renounce,reconsidered,recharge,realistically,radioed,quirks,quadrant,punctual,practising,pours,poolhouse,poltergeist,pocketbook,plainly,picnics,pesto,pawing,passageway,partied,oneself,numero,nostalgia,nitwit,neuro,mixer,meanest,mcbeal,matinee,margate,marce,manipulations,manhunt,manger,magicians,loafers,litvack,lightheaded,lifeguard,lawns,laughingstock,ingested,indignation,inconceivable,imposition,impersonal,imbecile,huddled,housewarming,horizons,homicides,hiccups,hearse,hardened,gushing,gushie,greased,goddamit,freelancer,forging,fondue,flustered,flung,flinch,flicker,fixin,festivus,fertilizer,farted,faggots,exonerate,evict,enormously,encrypted,emdash,embracing,duress,dupres,dowser,doormat,disfigured,disciplined,dibbs,depository,deathbed,dazzled,cuttin,cures,crowding,crepe,crammed,copycat,contradict,confidant,condemning,conceited,commute,comatose,clapping,circumference,chuppah,chore,choksondik,chestnuts,briault,bottomless,bonnet,blokes,berluti,beret,beggars,bankroll,bania,athos,arsenic,apperantly,ahhhhhh,afloat,accents,zipped,zeros,zeroes,zamir,yuppie,youngsters,yorkers,wisest,wipes,wield,whyn't,weirdos,wednesdays,vicksburg,upchuck,untraceable,unsupervised,unpleasantness,unhook,unconscionable,uncalled,trappings,tragedies,townie,thurgood,things'll,thine,tetanus,terrorize,temptations,tanning,tampons,swarming,straitjacket,steroid,startling,starry,squander,speculating,sollozzo,sneaked,slugs,skedaddle,sinker,silky,shortcomings,sellin,seasoned,scrubbed,screwup,scrapes,scarves,sandbox,salesmen,rooming,romances,revere,reproach,reprieve,rearranging,ravine,rationalize,raffle,punchy,psychobabble,provocation,profoundly,prescriptions,preferable,polishing,poached,pledges,pirelli,perverts,oversized,overdressed,outdid,nuptials,nefarious,mouthpiece,motels,mopping,mongrel,missin,metaphorically,mertin,memos,melodrama,melancholy,measles,meaner,mantel,maneuvering,mailroom,luring,listenin,lifeless,licks,levon,legwork,kneecaps,kippur,kiddie,kaput,justifiable,insistent,insidious,innuendo,innit,indecent,imaginable,horseshit,hemorrhoid,hella,healthiest,haywire,hamsters,hairbrush,grouchy,grisly,gratuitous,glutton,glimmer,gibberish,ghastly,gentler,generously,geeky,fuhrer,fronting,foolin,faxes,faceless,extinguisher,expel,etched,endangering,ducked,dodgeball,dives,dislocated,discrepancy,devour,derail,dementia,daycare,cynic,crumbling,cowardice,covet,cornwallis,corkscrew,cookbook,commandments,coincidental,cobwebs,clouded,clogging,clicking,clasp,chopsticks,chefs,chaps,cashing,carat,calmer,brazen,brainwashing,bradys,bowing,boned,bloodsucking,bleachers,bleached,bedpan,bearded,barrenger,bachelors,awwww,assures,assigning,asparagus,apprehend,anecdote,amoral,aggravation,afoot,acquaintances,accommodating,yakking,worshipping,wladek,willya,willies,wigged,whoosh,whisked,watered,warpath,volts,violates,valuables,uphill,unwise,untimely,unsavory,unresponsive,unpunished,unexplained,tubby,trolling,toxicology,tormented,toothache,tingly,timmiihh,thursdays,thoreau,terrifies,temperamental,telegrams,talkie,takers,symbiote,swirl,suffocate,stupider,strapping,steckler,springing,someway,sleepyhead,sledgehammer,slant,slams,showgirl,shoveling,shmoopy,sharkbait,shan't,scrambling,schematics,sandeman,sabbatical,rummy,reykjavik,revert,responsive,rescheduled,requisition,relinquish,rejoice,reckoning,recant,rebadow,reassurance,rattlesnake,ramble,primed,pricey,prance,pothole,pocus,persist,perpetrated,pekar,peeling,pastime,parmesan,pacemaker,overdrive,ominous,observant,nothings,noooooo,nonexistent,nodded,nieces,neglecting,nauseating,mutated,musket,mumbling,mowing,mouthful,mooseport,monologue,mistrust,meetin,masseuse,mantini,mailer,madre,lowlifes,locksmith,livid,liven,limos,liberating,lhasa,leniency,leering,laughable,lashes,lasagne,laceration,korben,katan,kalen,jittery,jammies,irreplaceable,intubate,intolerant,inhaler,inhaled,indifferent,indifference,impound,impolite,humbly,heroics,heigh,guillotine,guesthouse,grounding,grips,gossiping,goatee,gnomes,gellar,frutt,frobisher,freudian,foolishness,flagged,femme,fatso,fatherhood,fantasized,fairest,faintest,eyelids,extravagant,extraterrestrial,extraordinarily,escalator,elevate,drivel,dissed,dismal,disarray,dinnertime,devastation,dermatologist,delicately,defrost,debutante,debacle,damone,dainty,cuvee,culpa,crucified,creeped,crayons,courtship,convene,congresswoman,concocted,compromises,comprende,comma,coleslaw,clothed,clinically,chickenshit,checkin,cesspool,caskets,calzone,brothel,boomerang,bodega,blasphemy,bitsy,bicentennial,berlini,beatin,beards,barbas,barbarians,backpacking,arrhythmia,arousing,arbitrator,antagonize,angling,anesthetic,altercation,aggressor,adversity,acathla,aaahhh,wreaking,workup,wonderin,wither,wielding,what'm,what'cha,waxed,vibrating,veterinarian,venting,vasey,valor,validate,upholstery,untied,unscathed,uninterrupted,unforgiving,undies,uncut,twinkies,tucking,treatable,treasured,tranquility,townspeople,torso,tomei,tipsy,tinsel,tidings,thirtieth,tantrums,tamper,talky,swayed,swapping,suitor,stylist,stirs,standoff,sprinklers,sparkly,snobby,snatcher,smoother,sleepin,shrug,shoebox,sheesh,shackles,setbacks,sedatives,screeching,scorched,scanned,satyr,roadblock,riverbank,ridiculed,resentful,repellent,recreate,reconvene,rebuttal,realmedia,quizzes,questionnaire,punctured,pucker,prolong,professionalism,pleasantly,pigsty,penniless,paychecks,patiently,parading,overactive,ovaries,orderlies,oracles,oiled,offending,nudie,neonatal,neighborly,moops,moonlighting,mobilize,mmmmmm,milkshake,menial,meats,mayan,maxed,mangled,magua,lunacy,luckier,liters,lansbury,kooky,knowin,jeopardized,inkling,inhalation,inflated,infecting,incense,inbound,impractical,impenetrable,idealistic,i'mma,hypocrites,hurtin,humbled,hologram,hokey,hocus,hitchhiking,hemorrhoids,headhunter,hassled,harts,hardworking,haircuts,hacksaw,genitals,gazillion,gammy,gamesphere,fugue,footwear,folly,flashlights,fives,filet,extenuating,estrogen,entails,embezzled,eloquent,egomaniac,ducts,drowsy,drones,doree,donovon,disguises,diggin,deserting,depriving,defying,deductible,decorum,decked,daylights,daybreak,dashboard,damnation,cuddling,crunching,crickets,crazies,councilman,coughed,conundrum,complimented,cohaagen,clutching,clued,clader,cheques,checkpoint,chats,channeling,ceases,carasco,capisce,cantaloupe,cancelling,campsite,burglars,breakfasts,bra'tac,blueprint,bleedin,blabbed,beneficiary,basing,avert,atone,arlyn,approves,apothecary,antiseptic,aleikuum,advisement,zadir,wobbly,withnail,whattaya,whacking,wedged,wanders,vaginal,unimaginable,undeniable,unconditionally,uncharted,unbridled,tweezers,tvmegasite,trumped,triumphant,trimming,treading,tranquilizers,toontown,thunk,suture,suppressing,strays,stonewall,stogie,stepdaughter,stace,squint,spouses,splashed,speakin,sounder,sorrier,sorrel,sombrero,solemnly,softened,snobs,snippy,snare,smoothing,slump,slimeball,slaving,silently,shiller,shakedown,sensations,scrying,scrumptious,screamin,saucy,santoses,roundup,roughed,rosary,robechaux,retrospect,rescind,reprehensible,repel,remodeling,reconsidering,reciprocate,railroaded,psychics,promos,prob'ly,pristine,printout,priestess,prenuptial,precedes,pouty,phoning,peppy,pariah,parched,panes,overloaded,overdoing,nymphs,nother,notebooks,nearing,nearer,monstrosity,milady,mieke,mephesto,medicated,marshals,manilow,mammogram,m'lady,lotsa,loopy,lesion,lenient,learner,laszlo,kross,kinks,jinxed,involuntary,insubordination,ingrate,inflatable,incarnate,inane,hypoglycemia,huntin,humongous,hoodlum,honking,hemorrhage,helpin,hathor,hatching,grotto,grandmama,gorillas,godless,girlish,ghouls,gershwin,frosted,flutter,flagpole,fetching,fatter,faithfully,exert,evasion,escalate,enticing,enchantress,elopement,drills,downtime,downloading,dorks,doorways,divulge,dissociative,disgraceful,disconcerting,deteriorate,destinies,depressive,dented,denim,decruz,decidedly,deactivate,daydreams,curls,culprit,cruelest,crippling,cranberries,corvis,copped,commend,coastguard,cloning,cirque,churning,chock,chivalry,catalogues,cartwheels,carols,canister,buttered,bundt,buljanoff,bubbling,brokers,broaden,brimstone,brainless,bores,badmouthing,autopilot,ascertain,aorta,ampata,allenby,accosted,absolve,aborted,aaagh,aaaaaah,yonder,yellin,wyndham,wrongdoing,woodsboro,wigging,wasteland,warranty,waltzed,walnuts,vividly,veggie,unnecessarily,unloaded,unicorns,understated,unclean,umbrellas,twirling,turpentine,tupperware,triage,treehouse,tidbit,tickled,threes,thousandth,thingie,terminally,teething,tassel,talkies,swoon,switchboard,swerved,suspiciously,subsequentlyne,subscribe,strudel,stroking,strictest,stensland,starin,stannart,squirming,squealing,sorely,softie,snookums,sniveling,smidge,sloth,skulking,simian,sightseeing,siamese,shudder,shoppers,sharpen,shannen,semtex,secondhand,seance,scowl,scorn,safekeeping,russe,rummage,roshman,roomies,roaches,rinds,retrace,retires,resuscitate,rerun,reputations,rekall,refreshment,reenactment,recluse,ravioli,raves,raking,purses,punishable,punchline,puked,prosky,previews,poughkeepsie,poppins,polluted,placenta,pissy,petulant,perseverance,pears,pawns,pastries,partake,panky,palate,overzealous,orchids,obstructing,objectively,obituaries,obedient,nothingness,musty,motherly,mooning,momentous,mistaking,minutemen,milos,microchip,meself,merciless,menelaus,mazel,masturbate,mahogany,lysistrata,lillienfield,likable,liberate,leveled,letdown,larynx,lardass,lainey,lagged,klorel,kidnappings,keyed,karmic,jeebies,irate,invulnerable,intrusive,insemination,inquire,injecting,informative,informants,impure,impasse,imbalance,illiterate,hurled,hunts,hematoma,headstrong,handmade,handiwork,growling,gorky,getcha,gesundheit,gazing,galley,foolishly,fondness,floris,ferocious,feathered,fateful,fancies,fakes,faker,expire,ever'body,essentials,eskimos,enlightening,enchilada,emissary,embolism,elsinore,ecklie,drenched,drazi,doped,dogging,doable,dislikes,dishonesty,disengage,discouraging,derailed,deformed,deflect,defer,deactivated,crips,constellations,congressmen,complimenting,clubbing,clawing,chromium,chimes,chews,cheatin,chaste,cellblock,caving,catered,catacombs,calamari,bucking,brulee,brits,brisk,breezes,bounces,boudoir,binks,better'n,bellied,behrani,behaves,bedding,balmy,badmouth,backers,avenging,aromatherapy,armpit,armoire,anythin,anonymously,anniversaries,aftershave,affliction,adrift,admissible,adieu,acquittal,yucky,yearn,whitter,whirlpool,wendigo,watchdog,wannabes,wakey,vomited,voicemail,valedictorian,uttered,unwed,unrequited,unnoticed,unnerving,unkind,unjust,uniformed,unconfirmed,unadulterated,unaccounted,uglier,turnoff,trampled,tramell,toads,timbuktu,throwback,thimble,tasteless,tarantula,tamale,takeovers,swish,supposing,streaking,stargher,stanzi,stabs,squeamish,splattered,spiritually,spilt,speciality,smacking,skywire,skips,skaara,simpatico,shredding,showin,shortcuts,shite,shielding,shamelessly,serafine,sentimentality,seasick,schemer,scandalous,sainted,riedenschneider,rhyming,revel,retractor,retards,resurrect,remiss,reminiscing,remanded,reiben,regains,refuel,refresher,redoing,redheaded,reassured,rearranged,rapport,qumar,prowling,prejudices,precarious,powwow,pondering,plunger,plunged,pleasantville,playpen,phlegm,perfected,pancreas,paley,ovary,outbursts,oppressed,ooohhh,omoroca,offed,o'toole,nurture,nursemaid,nosebleed,necktie,muttering,munchies,mucking,mogul,mitosis,misdemeanor,miscarried,millionth,migraines,midler,manicurist,mandelbaum,manageable,malfunctioned,magnanimous,loudmouth,longed,lifestyles,liddy,lickety,leprechauns,komako,klute,kennel,justifying,irreversible,inventing,intergalactic,insinuate,inquiring,ingenuity,inconclusive,incessant,improv,impersonation,hyena,humperdinck,hubba,housework,hoffa,hither,hissy,hippy,hijacked,heparin,hellooo,hearth,hassles,hairstyle,hahahaha,hadda,guys'll,gutted,gulls,gritty,grievous,graft,gossamer,gooder,gambled,gadgets,fundamentals,frustrations,frolicking,frock,frilly,foreseen,footloose,fondly,flirtation,flinched,flatten,farthest,exposer,evading,escrow,empathize,embryos,embodiment,ellsberg,ebola,dulcinea,dreamin,drawbacks,doting,doose,doofy,disturbs,disorderly,disgusts,detox,denominator,demeanor,deliriously,decode,debauchery,croissant,cravings,cranked,coworkers,councilor,confuses,confiscate,confines,conduit,compress,combed,clouding,clamps,cinch,chinnery,celebratory,catalogs,carpenters,carnal,canin,bundys,bulldozer,buggers,bueller,brainy,booming,bookstores,bloodbath,bittersweet,bellhop,beeping,beanstalk,beady,baudelaire,bartenders,bargains,averted,armadillo,appreciating,appraised,antlers,aloof,allowances,alleyway,affleck,abject,zilch,youore,xanax,wrenching,wouldn,witted,wicca,whorehouse,whooo,whips,vouchers,victimized,vicodin,untested,unsolicited,unfocused,unfettered,unfeeling,unexplainable,understaffed,underbelly,tutorial,tryst,trampoline,towering,tirade,thieving,thang,swimmin,swayzak,suspecting,superstitions,stubbornness,streamers,strattman,stonewalling,stiffs,stacking,spout,splice,sonrisa,smarmy,slows,slicing,sisterly,shrill,shined,seeming,sedley,seatbelts,scour,scold,schoolyard,scarring,salieri,rustling,roxbury,rewire,revved,retriever,reputable,remodel,reins,reincarnation,rance,rafters,rackets,quail,pumbaa,proclaim,probing,privates,pried,prewedding,premeditation,posturing,posterity,pleasurable,pizzeria,pimps,penmanship,penchant,pelvis,overturn,overstepped,overcoat,ovens,outsmart,outed,ooohh,oncologist,omission,offhand,odour,nyazian,notarized,nobody'll,nightie,navel,nabbed,mystique,mover,mortician,morose,moratorium,mockingbird,mobsters,mingling,methinks,messengered,merde,masochist,martouf,martians,marinara,manray,majorly,magnifying,mackerel,lurid,lugging,lonnegan,loathsome,llantano,liberace,leprosy,latinos,lanterns,lamest,laferette,kraut,intestine,innocencia,inhibitions,ineffectual,indisposed,incurable,inconvenienced,inanimate,improbable,implode,hydrant,hustling,hustled,huevos,how'm,hooey,hoods,honcho,hinge,hijack,heimlich,hamunaptra,haladki,haiku,haggle,gutsy,grunting,grueling,gribbs,greevy,grandstanding,godparents,glows,glistening,gimmick,gaping,fraiser,formalities,foreigner,folders,foggy,fitty,fiends,fe'nos,favours,eyeing,extort,expedite,escalating,epinephrine,entitles,entice,eminence,eights,earthlings,eagerly,dunville,dugout,doublemeat,doling,dispensing,dispatcher,discoloration,diners,diddly,dictates,diazepam,derogatory,delights,defies,decoder,dealio,danson,cutthroat,crumbles,croissants,crematorium,craftsmanship,could'a,cordless,cools,conked,confine,concealing,complicates,communique,cockamamie,coasters,clobbered,clipping,clipboard,clemenza,cleanser,circumcision,chanukah,certainaly,cellmate,cancels,cadmium,buzzed,bumstead,bucko,browsing,broth,braver,boggling,bobbing,blurred,birkhead,benet,belvedere,bellies,begrudge,beckworth,banky,baldness,baggy,babysitters,aversion,astonished,assorted,appetites,angina,amiss,ambulances,alibis,airway,admires,adhesive,yoyou,xxxxxx,wreaked,wracking,woooo,wooing,wised,wilshire,wedgie,waging,violets,vincey,uplifting,untrustworthy,unmitigated,uneventful,undressing,underprivileged,unburden,umbilical,tweaking,turquoise,treachery,tosses,torching,toothpick,toasts,thickens,tereza,tenacious,teldar,taint,swill,sweatin,subtly,subdural,streep,stopwatch,stockholder,stillwater,stalkers,squished,squeegee,splinters,spliced,splat,spied,spackle,sophistication,snapshots,smite,sluggish,slithered,skeeters,sidewalks,sickly,shrugs,shrubbery,shrieking,shitless,settin,sentinels,selfishly,scarcely,sangria,sanctum,sahjhan,rustle,roving,rousing,rosomorf,riddled,responsibly,renoir,remoray,remedial,refundable,redirect,recheck,ravenwood,rationalizing,ramus,ramelle,quivering,pyjamas,psychos,provocations,prouder,protestors,prodded,proctologist,primordial,pricks,prickly,precedents,pentangeli,pathetically,parka,parakeet,panicky,overthruster,outsmarted,orthopedic,oncoming,offing,nutritious,nuthouse,nourishment,nibbling,newlywed,narcissist,mutilation,mundane,mummies,mumble,mowed,morvern,mortem,mopes,molasses,misplace,miscommunication,miney,midlife,menacing,memorizing,massaging,masking,magnets,luxuries,lounging,lothario,liposuction,lidocaine,libbets,levitate,leeway,launcelot,larek,lackeys,kumbaya,kryptonite,knapsack,keyhole,katarangura,juiced,jakey,ironclad,invoice,intertwined,interlude,interferes,injure,infernal,indeedy,incur,incorrigible,incantations,impediment,igloo,hysterectomy,hounded,hollering,hindsight,heebie,havesham,hasenfuss,hankering,hangers,hakuna,gutless,gusto,grubbing,grrrr,grazed,gratification,grandeur,gorak,godammit,gnawing,glanced,frostbite,frees,frazzled,fraulein,fraternizing,fortuneteller,formaldehyde,followup,foggiest,flunky,flickering,firecrackers,figger,fetuses,fates,eyeliner,extremities,extradited,expires,exceedingly,evaporate,erupt,epileptic,entrails,emporium,egregious,eggshells,easing,duwayne,droll,dreyfuss,dovey,doubly,doozy,donkeys,donde,distrust,distressing,disintegrate,discreetly,decapitated,dealin,deader,dashed,darkroom,dares,daddies,dabble,cushy,cupcakes,cuffed,croupier,croak,crapped,coursing,coolers,contaminate,consummated,construed,condos,concoction,compulsion,commish,coercion,clemency,clairvoyant,circulate,chesterton,checkered,charlatan,chaperones,categorically,cataracts,carano,capsules,capitalize,burdon,bullshitting,brewed,breathless,breasted,brainstorming,bossing,borealis,bonsoir,bobka,boast,blimp,bleep,bleeder,blackouts,bisque,billboards,beatings,bayberry,bashed,bamboozled,balding,baklava,baffled,backfires,babak,awkwardness,attest,attachments,apologizes,anyhoo,antiquated,alcante,advisable,aahhh,aaahh,zatarc,yearbooks,wuddya,wringing,womanhood,witless,winging,whatsa,wetting,waterproof,wastin,vogelman,vocation,vindicated,vigilance,vicariously,venza,vacuuming,utensils,uplink,unveil,unloved,unloading,uninhibited,unattached,tweaked,turnips,trinkets,toughen,toting,topside,terrors,terrify,technologically,tarnish,tagliati,szpilman,surly,supple,summation,suckin,stepmom,squeaking,splashmore,souffle,solitaire,solicitation,solarium,smokers,slugged,slobbering,skylight,skimpy,sinuses,silenced,sideburns,shrinkage,shoddy,shhhhhh,shelled,shareef,shangri,seuss,serenade,scuffle,scoff,scanners,sauerkraut,sardines,sarcophagus,salvy,rusted,russells,rowboat,rolfsky,ringside,respectability,reparations,renegotiate,reminisce,reimburse,regimen,raincoat,quibble,puzzled,purposefully,pubic,proofing,prescribing,prelim,poisons,poaching,personalized,personable,peroxide,pentonville,payphone,payoffs,paleontology,overflowing,oompa,oddest,objecting,o'hare,o'daniel,notches,nobody'd,nightstand,neutralized,nervousness,nerdy,needlessly,naquadah,nappy,nantucket,nambla,mountaineer,motherfuckin,morrie,monopolizing,mohel,mistreated,misreading,misbehave,miramax,minivan,milligram,milkshakes,metamorphosis,medics,mattresses,mathesar,matchbook,matata,marys,malucci,magilla,lymphoma,lowers,lordy,linens,lindenmeyer,limelight,leapt,laxative,lather,lapel,lamppost,laguardia,kindling,kegger,kawalsky,juries,jokin,jesminder,interning,innermost,injun,infallible,industrious,indulgence,incinerator,impossibility,impart,illuminate,iguanas,hypnotic,hyped,hospitable,hoses,homemaker,hirschmuller,helpers,headset,guardianship,guapo,grubby,granola,granddaddy,goren,goblet,gluttony,globes,giorno,getter,geritol,gassed,gaggle,foxhole,fouled,foretold,floorboards,flippers,flaked,fireflies,feedings,fashionably,farragut,fallback,facials,exterminate,excites,everything'll,evenin,ethically,ensue,enema,empath,eluded,eloquently,eject,edema,dumpling,droppings,dolled,distasteful,disputing,displeasure,disdain,deterrent,dehydration,defied,decomposing,dawned,dailies,custodian,crusts,crucifix,crowning,crier,crept,craze,crawls,couldn,correcting,corkmaster,copperfield,cooties,contraption,consumes,conspire,consenting,consented,conquers,congeniality,complains,communicator,commendable,collide,coladas,colada,clout,clooney,classifieds,clammy,civility,cirrhosis,chink,catskills,carvers,carpool,carelessness,cardio,carbs,capades,butabi,busmalis,burping,burdens,bunks,buncha,bulldozers,browse,brockovich,breakthroughs,bravado,boogety,blossoms,blooming,bloodsucker,blight,betterton,betrayer,belittle,beeps,bawling,barts,bartending,bankbooks,babish,atropine,assertive,armbrust,anyanka,annoyance,anemic,anago,airwaves,aimlessly,aaargh,aaand,yoghurt,writhing,workable,winking,winded,widen,whooping,whiter,whatya,wazoo,voila,virile,vests,vestibule,versed,vanishes,urkel,uproot,unwarranted,unscheduled,unparalleled,undergrad,tweedle,turtleneck,turban,trickery,transponder,toyed,townhouse,thyself,thunderstorm,thinning,thawed,tether,technicalities,tau'ri,tarnished,taffeta,tacked,systolic,swerve,sweepstakes,swabs,suspenders,superwoman,sunsets,succulent,subpoenas,stumper,stosh,stomachache,stewed,steppin,stepatech,stateside,spicoli,sparing,soulless,sonnets,sockets,snatching,smothering,slush,sloman,slashing,sitters,simpleton,sighs,sidra,sickens,shunned,shrunken,showbiz,shopped,shimmering,shagging,semblance,segue,sedation,scuzzlebutt,scumbags,screwin,scoundrels,scarsdale,scabs,saucers,saintly,saddened,runaways,runaround,rheya,resenting,rehashing,rehabilitated,regrettable,refreshed,redial,reconnecting,ravenous,raping,rafting,quandary,pylea,putrid,puffing,psychopathic,prunes,probate,prayin,pomegranate,plummeting,planing,plagues,pinata,pithy,perversion,personals,perched,peeps,peckish,pavarotti,pajama,packin,pacifier,overstepping,okama,obstetrician,nutso,nuance,normalcy,nonnegotiable,nomak,ninny,nines,nicey,newsflash,neutered,nether,negligee,necrosis,navigating,narcissistic,mylie,muses,momento,moisturizer,moderation,misinformed,misconception,minnifield,mikkos,methodical,mebbe,meager,maybes,matchmaking,masry,markovic,malakai,luzhin,lusting,lumberjack,loopholes,loaning,lightening,leotard,launder,lamaze,kubla,kneeling,kibosh,jumpsuit,joliet,jogger,janover,jakovasaurs,irreparable,innocently,inigo,infomercial,inexplicable,indispensable,impregnated,impossibly,imitating,hunches,hummus,houmfort,hothead,hostiles,hooves,hooligans,homos,homie,hisself,heyyy,hesitant,hangout,handsomest,handouts,hairless,gwennie,guzzling,guinevere,grungy,goading,glaring,gavel,gardino,gangrene,fruitful,friendlier,freckle,freakish,forthright,forearm,footnote,flops,fixer,firecracker,finito,figgered,fezzik,fastened,farfetched,fanciful,familiarize,faire,fahrenheit,extravaganza,exploratory,explanatory,everglades,eunuch,estas,escapade,erasers,emptying,embarassing,dweeb,dutiful,dumplings,dries,drafty,dollhouse,dismissing,disgraced,discrepancies,disbelief,disagreeing,digestion,didnt,deviled,deviated,demerol,delectable,decaying,decadent,dears,dateless,d'algout,cultivating,cryto,crumpled,crumbled,cronies,crease,craves,cozying,corduroy,congratulated,confidante,compressions,complicating,compadre,coerce,classier,chums,chumash,chivalrous,chinpoko,charred,chafing,celibacy,carted,carryin,carpeting,carotid,cannibals,candor,butterscotch,busts,busier,bullcrap,buggin,brookside,brodski,brassiere,brainwash,brainiac,botrelle,bonbon,boatload,blimey,blaring,blackness,bipartisan,bimbos,bigamist,biebe,biding,betrayals,bestow,bellerophon,bedpans,bassinet,basking,barzini,barnyard,barfed,backups,audited,asinine,asalaam,arouse,applejack,annoys,anchovies,ampule,alameida,aggravate,adage,accomplices,yokel,y'ever,wringer,witwer,withdrawals,windward,willfully,whorfin,whimsical,whimpering,weddin,weathered,warmest,wanton,volant,visceral,vindication,veggies,urinate,uproar,unwritten,unwrap,unsung,unsubstantiated,unspeakably,unscrupulous,unraveling,unquote,unqualified,unfulfilled,undetectable,underlined,unattainable,unappreciated,ummmm,ulcers,tylenol,tweak,turnin,tuatha,tropez,trellis,toppings,tootin,toodle,tinkering,thrives,thespis,theatrics,thatherton,tempers,tavington,tartar,tampon,swelled,sutures,sustenance,sunflowers,sublet,stubbins,strutting,strewn,stowaway,stoic,sternin,stabilizing,spiraling,spinster,speedometer,speakeasy,soooo,soiled,sneakin,smithereens,smelt,smacks,slaughterhouse,slacks,skids,sketching,skateboards,sizzling,sixes,sirree,simplistic,shouts,shorted,shoelace,sheeit,shards,shackled,sequestered,selmak,seduces,seclusion,seamstress,seabeas,scoops,scooped,scavenger,satch,s'more,rudeness,romancing,rioja,rifkin,rieper,revise,reunions,repugnant,replicating,repaid,renewing,relaxes,rekindle,regrettably,regenerate,reels,reciting,reappear,readin,ratting,rapes,rancher,rammed,rainstorm,railroading,queers,punxsutawney,punishes,pssst,prudy,proudest,protectors,procrastinating,proactive,priss,postmortem,pompoms,poise,pickings,perfectionist,peretti,people'll,pecking,patrolman,paralegal,paragraphs,paparazzi,pankot,pampering,overstep,overpower,outweigh,omnipotent,odious,nuwanda,nurtured,newsroom,neeson,needlepoint,necklaces,neato,muggers,muffler,mousy,mourned,mosey,mopey,mongolians,moldy,misinterpret,minibar,microfilm,mendola,mended,melissande,masturbating,masbath,manipulates,maimed,mailboxes,magnetism,m'lord,m'honey,lymph,lunge,lovelier,lefferts,leezak,ledgers,larraby,laloosh,kundun,kozinski,knockoff,kissin,kiosk,kennedys,kellman,karlo,kaleidoscope,jeffy,jaywalking,instructing,infraction,informer,infarction,impulsively,impressing,impersonated,impeach,idiocy,hyperbole,hurray,humped,huhuh,hsing,hordes,hoodlums,honky,hitchhiker,hideously,heaving,heathcliff,headgear,headboard,hazing,harem,handprint,hairspray,gutiurrez,goosebumps,gondola,glitches,gasping,frolic,freeways,frayed,fortitude,forgetful,forefathers,fonder,foiled,foaming,flossing,flailing,fitzgeralds,firehouse,finders,fiftieth,fellah,fawning,farquaad,faraway,fancied,extremists,exorcist,exhale,ethros,entrust,ennui,energized,encephalitis,embezzling,elster,elixir,electrolytes,duplex,dryers,drexl,dredging,drawback,don'ts,dobisch,divorcee,disrespected,disprove,disobeying,disinfectant,dingy,digress,dieting,dictating,devoured,devise,detonators,desist,deserter,derriere,deron,deceptive,debilitating,deathwok,daffodils,curtsy,cursory,cuppa,cumin,cronkite,cremation,credence,cranking,coverup,courted,countin,counselling,cornball,contentment,consensual,compost,cluett,cleverly,cleansed,cleanliness,chopec,chomp,chins,chime,cheswick,chessler,cheapest,chatted,cauliflower,catharsis,catchin,caress,camcorder,calorie,cackling,bystanders,buttoned,buttering,butted,buries,burgel,buffoon,brogna,bragged,boutros,bogeyman,blurting,blurb,blowup,bloodhound,blissful,birthmark,bigot,bestest,belted,belligerent,beggin,befall,beeswax,beatnik,beaming,barricade,baggoli,badness,awoke,artsy,artful,aroun,armpits,arming,annihilate,anise,angiogram,anaesthetic,amorous,ambiance,alligators,adoration,admittance,adama,abydos,zonked,zhivago,yorkin,wrongfully,writin,wrappers,worrywart,woops,wonderfalls,womanly,wickedness,whoopie,wholeheartedly,whimper,which'll,wheelchairs,what'ya,warranted,wallop,wading,wacked,virginal,vermouth,vermeil,verger,ventriss,veneer,vampira,utero,ushers,urgently,untoward,unshakable,unsettled,unruly,unlocks,ungodly,undue,uncooperative,uncontrollably,unbeatable,twitchy,tumbler,truest,triumphs,triplicate,tribbey,tortures,tongaree,tightening,thorazine,theres,testifies,teenaged,tearful,taxing,taldor,syllabus,swoops,swingin,suspending,sunburn,stuttering,stupor,strides,strategize,strangulation,stooped,stipulation,stingy,stapled,squeaks,squawking,spoilsport,splicing,spiel,spencers,spasms,spaniard,softener,sodding,soapbox,smoldering,smithbauer,skittish,sifting,sickest,sicilians,shuffling,shrivel,segretti,seeping,securely,scurrying,scrunch,scrote,screwups,schenkman,sawing,savin,satine,sapiens,salvaging,salmonella,sacrilege,rumpus,ruffle,roughing,rotted,rondall,ridding,rickshaw,rialto,rhinestone,restrooms,reroute,requisite,repress,rednecks,redeeming,rayed,ravell,raked,raincheck,raffi,racked,pushin,profess,prodding,procure,presuming,preppy,prednisone,potted,posttraumatic,poorhouse,podiatrist,plowed,pledging,playroom,plait,placate,pinback,picketing,photographing,pharoah,petrak,petal,persecuting,perchance,pellets,peeved,peerless,payable,pauses,pathologist,pagliacci,overwrought,overreaction,overqualified,overheated,outcasts,otherworldly,opinionated,oodles,oftentimes,occured,obstinate,nutritionist,numbness,nubile,nooooooo,nobodies,nepotism,neanderthals,mushu,mucus,mothering,mothballs,monogrammed,molesting,misspoke,misspelled,misconstrued,miscalculated,minimums,mince,mildew,mighta,middleman,mementos,mellowed,mayol,mauled,massaged,marmalade,mardi,makings,lundegaard,lovingly,loudest,lotto,loosing,loompa,looming,longs,loathes,littlest,littering,lifelike,legalities,laundered,lapdog,lacerations,kopalski,knobs,knitted,kittridge,kidnaps,kerosene,karras,jungles,jockeys,iranoff,invoices,invigorating,insolence,insincere,insectopia,inhumane,inhaling,ingrates,infestation,individuality,indeterminate,incomprehensible,inadequacy,impropriety,importer,imaginations,illuminating,ignite,hysterics,hypodermic,hyperventilate,hyperactive,humoring,honeymooning,honed,hoist,hoarding,hitching,hiker,hightail,hemoglobin,hell'd,heinie,growin,grasped,grandparent,granddaughters,gouged,goblins,gleam,glades,gigantor,get'em,geriatric,gatekeeper,gargoyles,gardenias,garcon,garbo,gallows,gabbing,futon,fulla,frightful,freshener,fortuitous,forceps,fogged,fodder,foamy,flogging,flaun,flared,fireplaces,feverish,favell,fattest,fattening,fallow,extraordinaire,evacuating,errant,envied,enchant,enamored,egocentric,dussander,dunwitty,dullest,dropout,dredged,dorsia,doornail,donot,dongs,dogged,dodgy,ditty,dishonorable,discriminating,discontinue,dings,dilly,dictation,dialysis,delly,delightfully,daryll,dandruff,cruddy,croquet,cringe,crimp,credo,crackling,courtside,counteroffer,counterfeiting,corrupting,copping,conveyor,contusions,contusion,conspirator,consoling,connoisseur,confetti,composure,compel,colic,coddle,cocksuckers,coattails,cloned,claustrophobia,clamoring,churn,chugga,chirping,chasin,chapped,chalkboard,centimeter,caymans,catheter,casings,caprica,capelli,cannolis,cannoli,camogli,camembert,butchers,butchered,busboys,bureaucrats,buckled,bubbe,brownstone,bravely,brackley,bouquets,botox,boozing,boosters,bodhi,blunders,blunder,blockage,biocyte,betrays,bested,beryllium,beheading,beggar,begbie,beamed,bastille,barstool,barricades,barbecues,barbecued,bandwagon,backfiring,bacarra,avenged,autopsies,aunties,associating,artichoke,arrowhead,appendage,apostrophe,antacid,ansel,annul,amuses,amped,amicable,amberg,alluring,adversaries,admirers,adlai,acupuncture,abnormality,aaaahhhh,zooming,zippity,zipping,zeroed,yuletide,yoyodyne,yengeese,yeahhh,wrinkly,wracked,withered,winks,windmills,whopping,wendle,weigart,waterworks,waterbed,watchful,wantin,wagging,waaah,vying,ventricle,varnish,vacuumed,unreachable,unprovoked,unmistakable,unfriendly,unfolding,underpaid,uncuff,unappealing,unabomber,typhoid,tuxedos,tushie,turds,tumnus,troubadour,trinium,treaters,treads,transpired,transgression,tought,thready,thins,thinners,techs,teary,tattaglia,tassels,tarzana,tanking,tablecloths,synchronize,symptomatic,sycophant,swimmingly,sweatshop,surfboard,superpowers,sunroom,sunblock,sugarplum,stupidly,strumpet,strapless,stooping,stools,stealthy,stalks,stairmaster,staffer,sshhh,squatting,squatters,spectacularly,sorbet,socked,sociable,snubbed,snorting,sniffles,snazzy,snakebite,smuggler,smorgasbord,smooching,slurping,slouch,slingshot,slaved,skimmed,sisterhood,silliest,sidarthur,sheraton,shebang,sharpening,shanghaied,shakers,sendoff,scurvy,scoliosis,scaredy,scagnetti,sawchuk,saugus,sasquatch,sandbag,saltines,s'pose,roston,rostle,riveting,ristle,rifling,revulsion,reverently,retrograde,restful,resents,reptilian,reorganize,renovating,reiterate,reinvent,reinmar,reibers,reechard,recuse,reconciling,recognizance,reclaiming,recitation,recieved,rebate,reacquainted,rascals,railly,quintuplets,quahog,pygmies,puzzling,punctuality,prosthetic,proms,probie,preys,preserver,preppie,poachers,plummet,plumbers,plannin,pitying,pitfalls,piqued,pinecrest,pinches,pillage,pigheaded,physique,pessimistic,persecute,perjure,percentile,pentothal,pensky,penises,peini,pazzi,pastels,parlour,paperweight,pamper,pained,overwhelm,overalls,outrank,outpouring,outhouse,outage,ouija,obstructed,obsessions,obeying,obese,o'riley,o'higgins,nosebleeds,norad,noooooooo,nononono,nonchalant,nippy,neurosis,nekhorvich,necronomicon,naquada,n'est,mystik,mystified,mumps,muddle,mothership,moped,monumentally,monogamous,mondesi,misogynistic,misinterpreting,mindlock,mending,megaphone,meeny,medicating,meanie,masseur,markstrom,marklars,margueritas,manifesting,maharajah,lukewarm,loveliest,loran,lizardo,liquored,lipped,lingers,limey,lemkin,leisurely,lathe,latched,lapping,ladle,krevlorneswath,kosygin,khakis,kenaru,keats,kaitlan,julliard,jollies,jaundice,jargon,jackals,invisibility,insipid,inflamed,inferiority,inexperience,incinerated,incinerate,incendiary,incan,inbred,implicating,impersonator,hunks,horsing,hooded,hippopotamus,hiked,hetson,hetero,hessian,henslowe,hendler,hellstrom,headstone,hayloft,harbucks,handguns,hallucinate,haldol,haggling,gynaecologist,gulag,guilder,guaranteeing,groundskeeper,grindstone,grimoir,grievance,griddle,gribbit,greystone,graceland,gooders,goeth,gentlemanly,gelatin,gawking,ganged,fukes,fromby,frenchmen,foursome,forsley,forbids,footwork,foothold,floater,flinging,flicking,fittest,fistfight,fireballs,fillings,fiddling,fennyman,felonious,felonies,feces,favoritism,fatten,fanatics,faceman,excusing,excepted,entwined,entree,ensconced,eladio,ehrlichman,easterland,dueling,dribbling,drape,downtrodden,doused,dosed,dorleen,dokie,distort,displeased,disown,dismount,disinherited,disarmed,disapproves,diperna,dined,diligent,dicaprio,depress,decoded,debatable,dealey,darsh,damsels,damning,dad'll,d'oeuvre,curlers,curie,cubed,crikey,crepes,countrymen,cornfield,coppers,copilot,copier,cooing,conspiracies,consigliere,condoning,commoner,commies,combust,comas,colds,clawed,clamped,choosy,chomping,chimps,chigorin,chianti,cheep,checkups,cheaters,celibate,cautiously,cautionary,castell,carpentry,caroling,carjacking,caritas,caregiver,cardiology,candlesticks,canasta,cain't,burro,burnin,bunking,bumming,bullwinkle,brummel,brooms,brews,breathin,braslow,bracing,botulism,boorish,bloodless,blayne,blatantly,blankie,bedbugs,becuase,barmaid,bared,baracus,banal,bakes,backpacks,attentions,atrocious,ativan,athame,asunder,astound,assuring,aspirins,asphyxiation,ashtrays,aryans,arnon,apprehension,applauding,anvil,antiquing,antidepressants,annoyingly,amputate,altruistic,alotta,alerting,afterthought,affront,affirm,actuality,abysmal,absentee,yeller,yakushova,wuzzy,wriggle,worrier,woogyman,womanizer,windpipe,windbag,willin,whisking,whimsy,wendall,weeny,weensy,weasels,watery,watcha,wasteful,waski,washcloth,waaay,vouched,viznick,ventriloquist,vendettas,veils,vayhue,vamanos,vadimus,upstage,uppity,unsaid,unlocking,unintentionally,undetected,undecided,uncaring,unbearably,tween,tryout,trotting,trini,trimmings,trickier,treatin,treadstone,trashcan,transcendent,tramps,townsfolk,torturous,torrid,toothpicks,tolerable,tireless,tiptoeing,timmay,tillinghouse,tidying,tibia,thumbing,thrusters,thrashing,these'll,thatos,testicular,teriyaki,tenors,tenacity,tellers,telemetry,tarragon,switchblade,swicker,swells,sweatshirts,swatches,surging,supremely,sump'n,succumb,subsidize,stumbles,stuffs,stoppin,stipulate,stenographer,steamroll,stasis,stagger,squandered,splint,splendidly,splashy,splashing,specter,sorcerers,somewheres,somber,snuggled,snowmobile,sniffed,snags,smugglers,smudged,smirking,smearing,slings,sleet,sleepovers,sleek,slackers,siree,siphoning,singed,sincerest,sickened,shuffled,shriveled,shorthanded,shittin,shish,shipwrecked,shins,sheetrock,shawshank,shamu,sha're,servitude,sequins,seascape,scrapings,scoured,scorching,sandpaper,saluting,salud,ruffled,roughnecks,rougher,rosslyn,rosses,roost,roomy,romping,revolutionize,reprimanded,refute,refrigerated,reeled,redundancies,rectal,recklessly,receding,reassignment,reapers,readout,ration,raring,ramblings,raccoons,quarantined,purging,punters,psychically,premarital,pregnancies,predisposed,precautionary,pollute,podunk,plums,plaything,pixilated,pitting,piranhas,pieced,piddles,pickled,photogenic,phosphorous,pffft,pestilence,pessimist,perspiration,perps,penticoff,passageways,pardons,panics,pancamo,paleontologist,overwhelms,overstating,overpaid,overdid,outlive,orthodontist,orgies,oreos,ordover,ordinates,ooooooh,oooohhh,omelettes,officiate,obtuse,obits,nymph,novocaine,noooooooooo,nipping,nilly,nightstick,negate,neatness,natured,narcotic,narcissism,namun,nakatomi,murky,muchacho,mouthwash,motzah,morsel,morph,morlocks,mooch,moloch,molest,mohra,modus,modicum,mockolate,misdemeanors,miscalculation,middies,meringue,mercilessly,meditating,mayakovsky,maximillian,marlee,markovski,maniacal,maneuvered,magnificence,maddening,lutze,lunged,lovelies,lorry,loosening,lookee,littered,lilac,lightened,laces,kurzon,kurtzweil,kind've,kimono,kenji,kembu,keanu,kazuo,jonesing,jilted,jiggling,jewelers,jewbilee,jacqnoud,jacksons,ivories,insurmountable,innocuous,innkeeper,infantery,indulged,indescribable,incoherent,impervious,impertinent,imperfections,hunnert,huffy,horsies,horseradish,hollowed,hogwash,hockley,hissing,hiromitsu,hidin,hereafter,helpmann,hehehe,haughty,happenings,hankie,handsomely,halliwells,haklar,haise,gunsights,grossly,grope,grocer,grits,gripping,grabby,glorificus,gizzard,gilardi,gibarian,geminon,gasses,garnish,galloping,gairwyn,futterman,futility,fumigated,fruitless,friendless,freon,foregone,forego,floored,flighty,flapjacks,fizzled,ficus,festering,farbman,fabricate,eyghon,extricate,exalted,eventful,esophagus,enterprising,entail,endor,emphatically,embarrasses,electroshock,easel,duffle,drumsticks,dissection,dissected,disposing,disparaging,disorientation,disintegrated,disarming,devoting,dessaline,deprecating,deplorable,delve,degenerative,deduct,decomposed,deathly,dearie,daunting,dankova,cyclotron,cyberspace,cutbacks,culpable,cuddled,crumpets,cruelly,crouching,cranium,cramming,cowering,couric,cordesh,conversational,conclusively,clung,clotting,cleanest,chipping,chimpanzee,chests,cheapen,chainsaws,censure,catapult,caravaggio,carats,captivating,calrissian,butlers,busybody,bussing,bunion,bulimic,budging,brung,browbeat,brokenhearted,brecher,breakdowns,bracebridge,boning,blowhard,blisters,blackboard,bigotry,bialy,bhamra,bended,begat,battering,baste,basquiat,barricaded,barometer,balled,baited,badenweiler,backhand,ascenscion,argumentative,appendicitis,apparition,anxiously,antagonistic,angora,anacott,amniotic,ambience,alonna,aleck,akashic,ageless,abouts,aawwww,aaaaarrrrrrggghhh,aaaaaa,zendi,yuppies,yodel,y'hear,wrangle,wombosi,wittle,withstanding,wisecracks,wiggling,wierd,whittlesley,whipper,whattya,whatsamatter,whatchamacallit,whassup,whad'ya,weakling,warfarin,waponis,wampum,wadn't,vorash,vizzini,virtucon,viridiana,veracity,ventilated,varicose,varcon,vandalized,vamos,vamoose,vaccinated,vacationing,usted,urinal,uppers,unwittingly,unsealed,unplanned,unhinged,unhand,unfathomable,unequivocally,unbreakable,unadvisedly,udall,tynacorp,tuxes,tussle,turati,tunic,tsavo,trussed,troublemakers,trollop,tremors,transsexual,transfusions,toothbrushes,toned,toddlers,tinted,tightened,thundering,thorpey,this'd,thespian,thaddius,tenuous,tenths,tenement,telethon,teleprompter,teaspoon,taunted,tattle,tardiness,taraka,tappy,tapioca,tapeworm,talcum,tacks,swivel,swaying,superpower,summarize,sumbitch,sultry,suburbia,styrofoam,stylings,strolls,strobe,stockpile,stewardesses,sterilized,sterilize,stealin,stakeouts,squawk,squalor,squabble,sprinkled,sportsmanship,spokes,spiritus,sparklers,spareribs,sowing,sororities,sonovabitch,solicit,softy,softness,softening,snuggling,snatchers,snarling,snarky,snacking,smears,slumped,slowest,slithering,sleazebag,slayed,slaughtering,skidded,skated,sivapathasundaram,sissies,silliness,silences,sidecar,sicced,shylock,shtick,shrugged,shriek,shoves,should'a,shortcake,shockingly,shirking,shaves,shatner,sharpener,shapely,shafted,sexless,septum,selflessness,seabea,scuff,screwball,scoping,scooch,scolding,schnitzel,schemed,scalper,santy,sankara,sanest,salesperson,sakulos,safehouse,sabers,runes,rumblings,rumbling,ruijven,ringers,righto,rhinestones,retrieving,reneging,remodelling,relentlessly,regurgitate,refills,reeking,reclusive,recklessness,recanted,ranchers,rafer,quaking,quacks,prophesied,propensity,profusely,problema,prided,prays,postmark,popsicles,poodles,pollyanna,polaroids,pokes,poconos,pocketful,plunging,plugging,pleeease,platters,pitied,pinetti,piercings,phooey,phonies,pestering,periscope,pentagram,pelts,patronized,paramour,paralyze,parachutes,pales,paella,paducci,owatta,overdone,overcrowded,overcompensating,ostracized,ordinate,optometrist,operandi,omens,okayed,oedipal,nuttier,nuptial,nunheim,noxious,nourish,notepad,nitroglycerin,nibblet,neuroses,nanosecond,nabbit,mythic,munchkins,multimillion,mulroney,mucous,muchas,mountaintop,morlin,mongorians,moneybags,mom'll,molto,mixup,misgivings,mindset,michalchuk,mesmerized,merman,mensa,meaty,mbwun,materialize,materialistic,masterminded,marginally,mapuhe,malfunctioning,magnify,macnamara,macinerney,machinations,macadamia,lysol,lurks,lovelorn,lopsided,locator,litback,litany,linea,limousines,limes,lighters,liebkind,levity,levelheaded,letterhead,lesabre,leron,lepers,lefts,leftenant,laziness,layaway,laughlan,lascivious,laryngitis,lapsed,landok,laminated,kurten,kobol,knucklehead,knowed,knotted,kirkeby,kinsa,karnovsky,jolla,jimson,jettison,jeric,jawed,jankis,janitors,jango,jalopy,jailbreak,jackers,jackasses,invalidate,intercepting,intercede,insinuations,infertile,impetuous,impaled,immerse,immaterial,imbeciles,imagines,idyllic,idolized,icebox,i'd've,hypochondriac,hyphen,hurtling,hurried,hunchback,hullo,horsting,hoooo,homeboys,hollandaise,hoity,hijinks,hesitates,herrero,herndorff,helplessly,heeyy,heathen,hearin,headband,harrassment,harpies,halstrom,hahahahaha,hacer,grumbling,grimlocks,grift,greets,grandmothers,grander,grafts,gordievsky,gondorff,godorsky,glscripts,gaudy,gardeners,gainful,fuses,fukienese,frizzy,freshness,freshening,fraught,frantically,foxbooks,fortieth,forked,foibles,flunkies,fleece,flatbed,fisted,firefight,fingerpaint,filibuster,fhloston,fenceline,femur,fatigues,fanucci,fantastically,familiars,falafel,fabulously,eyesore,expedient,ewwww,eviscerated,erogenous,epidural,enchante,embarassed,embarass,embalming,elude,elspeth,electrocute,eigth,eggshell,echinacea,eases,earpiece,earlobe,dumpsters,dumbshit,dumbasses,duloc,duisberg,drummed,drinkers,dressy,dorma,doily,divvy,diverting,dissuade,disrespecting,displace,disorganized,disgustingly,discord,disapproving,diligence,didja,diced,devouring,detach,destructing,desolate,demerits,delude,delirium,degrade,deevak,deemesa,deductions,deduce,debriefed,deadbeats,dateline,darndest,damnable,dalliance,daiquiri,d'agosta,cussing,cryss,cripes,cretins,crackerjack,cower,coveting,couriers,countermission,cotswolds,convertibles,conversationalist,consorting,consoled,consarn,confides,confidentially,commited,commiserate,comme,comforter,comeuppance,combative,comanches,colosseum,colling,coexist,coaxing,cliffside,chutes,chucked,chokes,childlike,childhoods,chickening,chenowith,charmingly,changin,catsup,captioning,capsize,cappucino,capiche,candlewell,cakewalk,cagey,caddie,buxley,bumbling,bulky,buggered,brussel,brunettes,brumby,brotha,bronck,brisket,bridegroom,braided,bovary,bookkeeper,bluster,bloodline,blissfully,blase,billionaires,bicker,berrisford,bereft,berating,berate,bendy,belive,belated,beikoku,beens,bedspread,bawdy,barreling,baptize,banya,balthazar,balmoral,bakshi,bails,badgered,backstreet,awkwardly,auras,attuned,atheists,astaire,assuredly,arrivederci,appetit,appendectomy,apologetic,antihistamine,anesthesiologist,amulets,albie,alarmist,aiight,adstream,admirably,acquaint,abound,abominable,aaaaaaah,zekes,zatunica,wussy,worded,wooed,woodrell,wiretap,windowsill,windjammer,windfall,whisker,whims,whatiya,whadya,weirdly,weenies,waunt,washout,wanto,waning,victimless,verdad,veranda,vandaley,vancomycin,valise,vaguest,upshot,unzip,unwashed,untrained,unstuck,unprincipled,unmentionables,unjustly,unfolds,unemployable,uneducated,unduly,undercut,uncovering,unconsciousness,unconsciously,tyndareus,turncoat,turlock,tulle,tryouts,trouper,triplette,trepkos,tremor,treeger,trapeze,traipse,tradeoff,trach,torin,tommorow,tollan,toity,timpani,thumbprint,thankless,tell'em,telepathy,telemarketing,telekinesis,teevee,teeming,tarred,tambourine,talentless,swooped,switcheroo,swirly,sweatpants,sunstroke,suitors,sugarcoat,subways,subterfuge,subservient,subletting,stunningly,strongbox,striptease,stravanavitch,stradling,stoolie,stodgy,stocky,stifle,stealer,squeezes,squatter,squarely,sprouted,spool,spindly,speedos,soups,soundly,soulmates,somebody'll,soliciting,solenoid,sobering,snowflakes,snowballs,snores,slung,slimming,skulk,skivvies,skewered,skewer,sizing,sistine,sidebar,sickos,shushing,shunt,shugga,shone,shol'va,sharpened,shapeshifter,shadowing,shadoe,selectman,sefelt,seared,scrounging,scribbling,scooping,scintillating,schmoozing,scallops,sapphires,sanitarium,sanded,safes,rudely,roust,rosebush,rosasharn,rondell,roadhouse,riveted,rewrote,revamp,retaliatory,reprimand,replicators,replaceable,remedied,relinquishing,rejoicing,reincarnated,reimbursed,reevaluate,redid,redefine,recreating,reconnected,rebelling,reassign,rearview,rayne,ravings,ratso,rambunctious,radiologist,quiver,quiero,queef,qualms,pyrotechnics,pulsating,psychosomatic,proverb,promiscuous,profanity,prioritize,preying,predisposition,precocious,precludes,prattling,prankster,povich,potting,postpartum,porridge,polluting,plowing,pistachio,pissin,pickpocket,physicals,peruse,pertains,personified,personalize,perjured,perfecting,pepys,pepperdine,pembry,peering,peels,pedophile,patties,passkey,paratrooper,paraphernalia,paralyzing,pandering,paltry,palpable,pagers,pachyderm,overstay,overestimated,overbite,outwit,outgrow,outbid,ooops,oomph,oohhh,oldie,obliterate,objectionable,nygma,notting,noches,nitty,nighters,newsstands,newborns,neurosurgery,nauseated,nastiest,narcolepsy,mutilate,muscled,murmur,mulva,mulling,mukada,muffled,morgues,moonbeams,monogamy,molester,molestation,molars,moans,misprint,mismatched,mirth,mindful,mimosas,millander,mescaline,menstrual,menage,mellowing,medevac,meddlesome,matey,manicures,malevolent,madmen,macaroons,lydell,lycra,lunchroom,lunching,lozenges,looped,litigious,liquidate,linoleum,lingk,limitless,limber,lilacs,ligature,liftoff,lemmiwinks,leggo,learnin,lazarre,lawyered,lactose,knelt,kenosha,kemosabe,jussy,junky,jordy,jimmies,jeriko,jakovasaur,issacs,isabela,irresponsibility,ironed,intoxication,insinuated,inherits,ingest,ingenue,inflexible,inflame,inevitability,inedible,inducement,indignant,indictments,indefensible,incomparable,incommunicado,improvising,impounded,illogical,ignoramus,hydrochloric,hydrate,hungover,humorless,humiliations,hugest,hoverdrone,hovel,hmmph,hitchhike,hibernating,henchman,helloooo,heirlooms,heartsick,headdress,hatches,harebrained,hapless,hanen,handsomer,hallows,habitual,guten,gummy,guiltier,guidebook,gstaad,gruff,griss,grieved,grata,gorignak,goosed,goofed,glowed,glitz,glimpses,glancing,gilmores,gianelli,geraniums,garroway,gangbusters,gamblers,galls,fuddy,frumpy,frowning,frothy,fro'tak,frere,fragrances,forgettin,follicles,flowery,flophouse,floatin,flirts,flings,flatfoot,fingerprinting,fingerprinted,fingering,finald,fillet,fianc,femoral,federales,fawkes,fascinates,farfel,fambly,falsified,fabricating,exterminators,expectant,excusez,excrement,excercises,evian,etins,esophageal,equivalency,equate,equalizer,entrees,enquire,endearment,empathetic,emailed,eggroll,earmuffs,dyslexic,duper,duesouth,drunker,druggie,dreadfully,dramatics,dragline,downplay,downers,dominatrix,doers,docket,docile,diversify,distracts,disloyalty,disinterested,discharging,disagreeable,dirtier,dinghy,dimwitted,dimoxinil,dimmy,diatribe,devising,deviate,detriment,desertion,depressants,depravity,deniability,delinquents,defiled,deepcore,deductive,decimate,deadbolt,dauthuille,dastardly,daiquiris,daggers,dachau,curiouser,curdled,cucamonga,cruller,cruces,crosswalk,crinkle,crescendo,cremate,counseled,couches,cornea,corday,copernicus,contrition,contemptible,constipated,conjoined,confounded,condescend,concoct,conch,compensating,committment,commandeered,comely,coddled,cockfight,cluttered,clunky,clownfish,cloaked,clenched,cleanin,civilised,circumcised,cimmeria,cilantro,chutzpah,chucking,chiseled,chicka,chattering,cervix,carrey,carpal,carnations,cappuccinos,candied,calluses,calisthenics,bushy,burners,budington,buchanans,brimming,braids,boycotting,bouncers,botticelli,botherin,bookkeeping,bogyman,bogged,bloodthirsty,blintzes,blanky,binturong,billable,bigboote,bewildered,betas,bequeath,behoove,befriend,bedpost,bedded,baudelaires,barreled,barboni,barbeque,bangin,baltus,bailout,backstabber,baccarat,awning,augie,arguillo,archway,apricots,apologising,annyong,anchorman,amenable,amazement,allspice,alannis,airfare,airbags,ahhhhhhhhh,ahhhhhhhh,ahhhhhhh,agitator,adrenal,acidosis,achoo,accessorizing,accentuate,abrasions,abductor,aaaahhh,aaaaaaaa,aaaaaaa,zeroing,zelner,zeldy,yevgeny,yeska,yellows,yeesh,yeahh,yamuri,wouldn't've,workmanship,woodsman,winnin,winked,wildness,whoring,whitewash,whiney,when're,wheezer,wheelman,wheelbarrow,westerburg,weeding,watermelons,washboard,waltzes,wafting,voulez,voluptuous,vitone,vigilantes,videotaping,viciously,vices,veruca,vermeer,verifying,vasculitis,valets,upholstered,unwavering,untold,unsympathetic,unromantic,unrecognizable,unpredictability,unmask,unleashing,unintentional,unglued,unequivocal,underrated,underfoot,unchecked,unbutton,unbind,unbiased,unagi,uhhhhh,tugging,triads,trespasses,treehorn,traviata,trappers,transplants,trannie,tramping,tracheotomy,tourniquet,tooty,toothless,tomarrow,toasters,thruster,thoughtfulness,thornwood,tengo,tenfold,telltale,telephoto,telephoned,telemarketer,tearin,tastic,tastefully,tasking,taser,tamed,tallow,taketh,taillight,tadpoles,tachibana,syringes,sweated,swarthy,swagger,surges,supermodels,superhighway,sunup,sun'll,sulfa,sugarless,sufficed,subside,strolled,stringy,strengthens,straightest,straightens,storefront,stopper,stockpiling,stimulant,stiffed,steyne,sternum,stepladder,stepbrother,steers,steelheads,steakhouse,stathis,stankylecartmankennymr,standoffish,stalwart,squirted,spritz,sprig,sprawl,spousal,sphincter,spenders,spearmint,spatter,spangled,southey,soured,sonuvabitch,somethng,snuffed,sniffs,smokescreen,smilin,slobs,sleepwalker,sleds,slays,slayage,skydiving,sketched,skanks,sixed,siphoned,siphon,simpering,sigfried,sidearm,siddons,sickie,shuteye,shuffleboard,shrubberies,shrouded,showmanship,shouldn't've,shoplift,shiatsu,sentries,sentance,sensuality,seething,secretions,searing,scuttlebutt,sculpt,scowling,scouring,scorecard,schoolers,schmucks,scepters,scaly,scalps,scaffolding,sauces,sartorius,santen,salivating,sainthood,saget,saddens,rygalski,rusting,ruination,rueland,rudabaga,rottweiler,roofies,romantics,rollerblading,roldy,roadshow,rickets,rible,rheza,revisiting,retentive,resurface,restores,respite,resounding,resorting,resists,repulse,repressing,repaying,reneged,refunds,rediscover,redecorated,reconstructive,recommitted,recollect,receptacle,reassess,reanimation,realtors,razinin,rationalization,ratatouille,rashum,rasczak,rancheros,rampler,quizzing,quips,quartered,purring,pummeling,puede,proximo,prospectus,pronouncing,prolonging,procreation,proclamations,principled,prides,preoccupation,prego,precog,prattle,pounced,potshots,potpourri,porque,pomegranates,polenta,plying,pluie,plesac,playmates,plantains,pillowcase,piddle,pickers,photocopied,philistine,perpetuate,perpetually,perilous,pawned,pausing,pauper,parter,parlez,parlay,pally,ovulation,overtake,overstate,overpowering,overpowered,overconfident,overbooked,ovaltine,outweighs,outings,ottos,orrin,orifice,orangutan,oopsy,ooooooooh,oooooo,ooohhhh,ocular,obstruct,obscenely,o'dwyer,nutjob,nunur,notifying,nostrand,nonny,nonfat,noblest,nimble,nikes,nicht,newsworthy,nestled,nearsighted,ne'er,nastier,narco,nakedness,muted,mummified,mudda,mozzarella,moxica,motivator,motility,mothafucka,mortmain,mortgaged,mores,mongers,mobbed,mitigating,mistah,misrepresented,mishke,misfortunes,misdirection,mischievous,mineshaft,millaney,microwaves,metzenbaum,mccovey,masterful,masochistic,marliston,marijawana,manya,mantumbi,malarkey,magnifique,madrona,madox,machida,m'hidi,lullabies,loveliness,lotions,looka,lompoc,litterbug,litigator,lithe,liquorice,linds,limericks,lightbulb,lewises,letch,lemec,layover,lavatory,laurels,lateness,laparotomy,laboring,kuato,kroff,krispy,krauts,knuckleheads,kitschy,kippers,kimbrow,keypad,keepsake,kebab,karloff,junket,judgemental,jointed,jezzie,jetting,jeeze,jeeter,jeesus,jeebs,janeane,jails,jackhammer,ixnay,irritates,irritability,irrevocable,irrefutable,irked,invoking,intricacies,interferon,intents,insubordinate,instructive,instinctive,inquisitive,inlay,injuns,inebriated,indignity,indecisive,incisors,incacha,inalienable,impresses,impregnate,impregnable,implosion,idolizes,hypothyroidism,hypoglycemic,huseni,humvee,huddling,honing,hobnobbing,hobnob,histrionics,histamine,hirohito,hippocratic,hindquarters,hikita,hikes,hightailed,hieroglyphics,heretofore,herbalist,hehey,hedriks,heartstrings,headmistress,headlight,hardheaded,happend,handlebars,hagitha,habla,gyroscope,guys'd,guy'd,guttersnipe,grump,growed,grovelling,groan,greenbacks,gravedigger,grating,grasshoppers,grandiose,grandest,grafted,gooood,goood,gooks,godsakes,goaded,glamorama,giveth,gingham,ghostbusters,germane,georgy,gazzo,gazelles,gargle,garbled,galgenstein,gaffe,g'day,fyarl,furnish,furies,fulfills,frowns,frowned,frighteningly,freebies,freakishly,forewarned,foreclose,forearms,fordson,fonics,flushes,flitting,flemmer,flabby,fishbowl,fidgeting,fevers,feigning,faxing,fatigued,fathoms,fatherless,fancier,fanatical,factored,eyelid,eyeglasses,expresso,expletive,expectin,excruciatingly,evidentiary,ever'thing,eurotrash,eubie,estrangement,erlich,epitome,entrap,enclose,emphysema,embers,emasculating,eighths,eardrum,dyslexia,duplicitous,dumpty,dumbledore,dufus,duddy,duchamp,drunkenness,drumlin,drowns,droid,drinky,drifts,drawbridge,dramamine,douggie,douchebag,dostoyevsky,doodling,don'tcha,domineering,doings,dogcatcher,doctoring,ditzy,dissimilar,dissecting,disparage,disliking,disintegrating,dishwalla,dishonored,dishing,disengaged,disavowed,dippy,diorama,dimmed,dilate,digitalis,diggory,dicing,diagnosing,devola,desolation,dennings,denials,deliverance,deliciously,delicacies,degenerates,degas,deflector,defile,deference,decrepit,deciphered,dawdle,dauphine,daresay,dangles,dampen,damndest,cucumbers,cucaracha,cryogenically,croaks,croaked,criticise,crisper,creepiest,creams,crackle,crackin,covertly,counterintelligence,corrosive,cordially,cops'll,convulsions,convoluted,conversing,conga,confrontational,confab,condolence,condiments,complicit,compiegne,commodus,comings,cometh,collusion,collared,cockeyed,clobber,clemonds,clarithromycin,cienega,christmasy,christmassy,chloroform,chippie,chested,cheeco,checklist,chauvinist,chandlers,chambermaid,chakras,cellophane,caveat,cataloguing,cartmanland,carples,carny,carded,caramels,cappy,caped,canvassing,callback,calibrated,calamine,buttermilk,butterfingers,bunsen,bulimia,bukatari,buildin,budged,brobich,bringer,brendell,brawling,bratty,braised,boyish,boundless,botch,boosh,bookies,bonbons,bodes,bobunk,bluntly,blossoming,bloomers,bloodstains,bloodhounds,blech,biter,biometric,bioethics,bijan,bigoted,bicep,bereaved,bellowing,belching,beholden,beached,batmobile,barcodes,barch,barbecuing,bandanna,backwater,backtrack,backdraft,augustino,atrophy,atrocity,atley,atchoo,asthmatic,assoc,armchair,arachnids,aptly,appetizing,antisocial,antagonizing,anorexia,anini,andersons,anagram,amputation,alleluia,airlock,aimless,agonized,agitate,aggravating,aerosol,acing,accomplishing,accidently,abuser,abstain,abnormally,aberration,aaaaahh,zlotys,zesty,zerzura,zapruder,zantopia,yelburton,yeess,y'knowwhati'msayin,wwhat,wussies,wrenched,would'a,worryin,wormser,wooooo,wookiee,wolchek,wishin,wiseguys,windbreaker,wiggy,wieners,wiedersehen,whoopin,whittled,wherefore,wharvey,welts,wellstone,wedges,wavered,watchit,wastebasket,wango,waken,waitressed,wacquiem,vrykolaka,voula,vitally,visualizing,viciousness,vespers,vertes,verily,vegetarians,vater,vaporize,vannacutt,vallens,ussher,urinating,upping,unwitting,untangle,untamed,unsanitary,unraveled,unopened,unisex,uninvolved,uninteresting,unintelligible,unimaginative,undeserving,undermines,undergarments,unconcerned,tyrants,typist,tykes,tybalt,twosome,twits,tutti,turndown,tularemia,tuberculoma,tsimshian,truffaut,truer,truant,trove,triumphed,tripe,trigonometry,trifled,trifecta,tribulations,tremont,tremoille,transcends,trafficker,touchin,tomfoolery,tinkered,tinfoil,tightrope,thousan,thoracotomy,thesaurus,thawing,thatta,tessio,temps,taxidermist,tator,tachycardia,t'akaya,swelco,sweetbreads,swatting,supercollider,sunbathing,summarily,suffocation,sueleen,succinct,subsided,submissive,subjecting,subbing,subatomic,stupendous,stunted,stubble,stubbed,streetwalker,strategizing,straining,straightaway,stoli,stiffer,stickup,stens,steamroller,steadwell,steadfast,stateroom,stans,sshhhh,squishing,squinting,squealed,sprouting,sprimp,spreadsheets,sprawled,spotlights,spooning,spirals,speedboat,spectacles,speakerphone,southglen,souse,soundproof,soothsayer,sommes,somethings,solidify,soars,snorted,snorkeling,snitches,sniping,snifter,sniffin,snickering,sneer,snarl,smila,slinking,slanted,slanderous,slammin,skimp,skilosh,siteid,sirloin,singe,sighing,sidekicks,sicken,showstopper,shoplifter,shimokawa,sherborne,shavadai,sharpshooters,sharking,shagged,shaddup,senorita,sesterces,sensuous,seahaven,scullery,scorcher,schotzie,schnoz,schmooze,schlep,schizo,scents,scalping,scalped,scallop,scalding,sayeth,saybrooke,sawed,savoring,sardine,sandstorm,sandalwood,salutations,sagman,s'okay,rsvp'd,rousted,rootin,romper,romanovs,rollercoaster,rolfie,robinsons,ritzy,ritualistic,ringwald,rhymed,rheingold,rewrites,revoking,reverts,retrofit,retort,retinas,respirations,reprobate,replaying,repaint,renquist,renege,relapsing,rekindled,rejuvenating,rejuvenated,reinstating,recriminations,rechecked,reassemble,rears,reamed,reacquaint,rayanne,ravish,rathole,raspail,rarest,rapists,rants,racketeer,quittin,quitters,quintessential,queremos,quellek,quelle,quasimodo,pyromaniac,puttanesca,puritanical,purer,puree,pungent,pummel,puedo,psychotherapist,prosecutorial,prosciutto,propositioning,procrastination,probationary,primping,preventative,prevails,preservatives,preachy,praetorians,practicality,powders,potus,postop,positives,poser,portolano,portokalos,poolside,poltergeists,pocketed,poach,plummeted,plucking,plimpton,playthings,plastique,plainclothes,pinpointed,pinkus,pinks,pigskin,piffle,pictionary,piccata,photocopy,phobias,perignon,perfumes,pecks,pecked,patently,passable,parasailing,paramus,papier,paintbrush,pacer,paaiint,overtures,overthink,overstayed,overrule,overestimate,overcooked,outlandish,outgrew,outdoorsy,outdo,orchestrate,oppress,opposable,oooohh,oomupwah,okeydokey,okaaay,ohashi,of'em,obscenities,oakie,o'gar,nurection,nostradamus,norther,norcom,nooch,nonsensical,nipped,nimbala,nervously,neckline,nebbleman,narwhal,nametag,n'n't,mycenae,muzak,muumuu,mumbled,mulvehill,muggings,muffet,mouthy,motivates,motaba,moocher,mongi,moley,moisturize,mohair,mocky,mmkay,mistuh,missis,misdeeds,mincemeat,miggs,miffed,methadone,messieur,menopausal,menagerie,mcgillicuddy,mayflowers,matrimonial,matick,masai,marzipan,maplewood,manzelle,mannequins,manhole,manhandle,malfunctions,madwoman,machiavelli,lynley,lynched,lurconis,lujack,lubricant,looove,loons,loofah,lonelyhearts,lollipops,lineswoman,lifers,lexter,lepner,lemony,leggy,leafy,leadeth,lazerus,lazare,lawford,languishing,lagoda,ladman,kundera,krinkle,krendler,kreigel,kowolski,knockdown,knifed,kneed,kneecap,kids'll,kennie,kenmore,keeled,kazootie,katzenmoyer,kasdan,karak,kapowski,kakistos,julyan,jockstrap,jobless,jiggly,jaunt,jarring,jabbering,irrigate,irrevocably,irrationally,ironies,invitro,intimated,intently,intentioned,intelligently,instill,instigator,instep,inopportune,innuendoes,inflate,infects,infamy,indiscretions,indiscreet,indio,indignities,indict,indecision,inconspicuous,inappropriately,impunity,impudent,impotence,implicates,implausible,imperfection,impatience,immutable,immobilize,idealist,iambic,hysterically,hyperspace,hygienist,hydraulics,hydrated,huzzah,husks,hunched,huffed,hubris,hubbub,hovercraft,houngan,hosed,horoscopes,hopelessness,hoodwinked,honorably,honeysuckle,homegirl,holiest,hippity,hildie,hieroglyphs,hexton,herein,heckle,heaping,healthilizer,headfirst,hatsue,harlot,hardwired,halothane,hairstyles,haagen,haaaaa,gutting,gummi,groundless,groaning,gristle,grills,graynamore,grabbin,goodes,goggle,glittering,glint,gleaming,glassy,girth,gimbal,giblets,gellers,geezers,geeze,garshaw,gargantuan,garfunkel,gangway,gandarium,gamut,galoshes,gallivanting,gainfully,gachnar,fusionlips,fusilli,furiously,frugal,fricking,frederika,freckling,frauds,fountainhead,forthwith,forgo,forgettable,foresight,foresaw,fondling,fondled,fondle,folksy,fluttering,fluffing,floundering,flirtatious,flexing,flatterer,flaring,fixating,finchy,figurehead,fiendish,fertilize,ferment,fending,fellahs,feelers,fascinate,fantabulous,falsify,fallopian,faithless,fairer,fainter,failings,facetious,eyepatch,exxon,extraterrestrials,extradite,extracurriculars,extinguish,expunged,expelling,exorbitant,exhilarated,exertion,exerting,excercise,everbody,evaporated,escargot,escapee,erases,epizootics,epithelials,ephrum,entanglements,enslave,engrossed,emphatic,emeralds,ember,emancipated,elevates,ejaculate,effeminate,eccentricities,easygoing,earshot,dunks,dullness,dulli,dulled,drumstick,dropper,driftwood,dregs,dreck,dreamboat,draggin,downsizing,donowitz,dominoes,diversions,distended,dissipate,disraeli,disqualify,disowned,dishwashing,disciplining,discerning,disappoints,dinged,digested,dicking,detonating,despising,depressor,depose,deport,dents,defused,deflecting,decryption,decoys,decoupage,decompress,decibel,decadence,deafening,dawning,dater,darkened,dappy,dallying,dagon,czechoslovakians,cuticles,cuteness,cupboards,culottes,cruisin,crosshairs,cronyn,criminalistics,creatively,creaming,crapping,cranny,cowed,contradicting,constipation,confining,confidences,conceiving,conceivably,concealment,compulsively,complainin,complacent,compels,communing,commode,comming,commensurate,columnists,colonoscopy,colchicine,coddling,clump,clubbed,clowning,cliffhanger,clang,cissy,choosers,choker,chiffon,channeled,chalet,cellmates,cathartic,caseload,carjack,canvass,canisters,candlestick,candlelit,camry,calzones,calitri,caldy,byline,butterball,bustier,burlap,bureaucrat,buffoons,buenas,brookline,bronzed,broiled,broda,briss,brioche,briar,breathable,brays,brassieres,boysenberry,bowline,boooo,boonies,booklets,bookish,boogeyman,boogey,bogas,boardinghouse,bluuch,blundering,bluer,blowed,blotchy,blossomed,bloodwork,bloodied,blithering,blinks,blathering,blasphemous,blacking,birdson,bings,bfmid,bfast,bettin,berkshires,benjamins,benevolence,benched,benatar,bellybutton,belabor,behooves,beddy,beaujolais,beattle,baxworth,baseless,barfing,bannish,bankrolled,banek,ballsy,ballpoint,baffling,badder,badda,bactine,backgammon,baako,aztreonam,authoritah,auctioning,arachtoids,apropos,aprons,apprised,apprehensive,anythng,antivenin,antichrist,anorexic,anoint,anguished,angioplasty,angio,amply,ampicillin,amphetamines,alternator,alcove,alabaster,airlifted,agrabah,affidavits,admonished,admonish,addled,addendum,accuser,accompli,absurdity,absolved,abrusso,abreast,aboot,abductions,abducting,aback,ababwa,aaahhhh,zorin,zinthar,zinfandel,zillions,zephyrs,zatarcs,zacks,youuu,yokels,yardstick,yammer,y'understand,wynette,wrung,wreaths,wowed,wouldn'ta,worming,wormed,workday,woodsy,woodshed,woodchuck,wojadubakowski,withering,witching,wiseass,wiretaps,wining,willoby,wiccaning,whupped,whoopi,whoomp,wholesaler,whiteness,whiner,whatchya,wharves,wenus,weirdoes,weaning,watusi,waponi,waistband,wackos,vouching,votre,vivica,viveca,vivant,vivacious,visor,visitin,visage,vicrum,vetted,ventriloquism,venison,varnsen,vaporized,vapid,vanstock,uuuuh,ushering,urologist,urination,upstart,uprooted,unsubtitled,unspoiled,unseat,unseasonably,unseal,unsatisfying,unnerve,unlikable,unleaded,uninsured,uninspired,unicycle,unhooked,unfunny,unfreezing,unflattering,unfairness,unexpressed,unending,unencumbered,unearth,undiscovered,undisciplined,understan,undershirt,underlings,underline,undercurrent,uncivilized,uncharacteristic,umpteenth,uglies,tuney,trumps,truckasaurus,trubshaw,trouser,tringle,trifling,trickster,trespassers,trespasser,traumas,trattoria,trashes,transgressions,trampling,tp'ed,toxoplasmosis,tounge,tortillas,topsy,topple,topnotch,tonsil,tions,timmuh,timithious,tilney,tighty,tightness,tightens,tidbits,ticketed,thyme,threepio,thoughtfully,thorkel,thommo,thing'll,thefts,that've,thanksgivings,tetherball,testikov,terraforming,tepid,tendonitis,tenboom,telex,teenybopper,tattered,tattaglias,tanneke,tailspin,tablecloth,swooping,swizzle,swiping,swindled,swilling,swerving,sweatshops,swaddling,swackhammer,svetkoff,supossed,superdad,sumptuous,sugary,sugai,subvert,substantiate,submersible,sublimating,subjugation,stymied,strychnine,streetlights,strassmans,stranglehold,strangeness,straddling,straddle,stowaways,stotch,stockbrokers,stifling,stepford,steerage,steena,statuary,starlets,staggeringly,ssshhh,squaw,spurt,spungeon,spritzer,sprightly,sprays,sportswear,spoonful,splittin,splitsville,speedily,specialise,spastic,sparrin,souvlaki,southie,sourpuss,soupy,soundstage,soothes,somebody'd,softest,sociopathic,socialized,snyders,snowmobiles,snowballed,snatches,smugness,smoothest,smashes,sloshed,sleight,skyrocket,skied,skewed,sixpence,sipowicz,singling,simulates,shyness,shuvanis,showoff,shortsighted,shopkeeper,shoehorn,shithouse,shirtless,shipshape,shifu,shelve,shelbyville,sheepskin,sharpens,shaquille,shanshu,servings,sequined,seizes,seashells,scrambler,scopes,schnauzer,schmo,schizoid,scampered,savagely,saudis,santas,sandovals,sanding,saleswoman,sagging,s'cuse,rutting,ruthlessly,runneth,ruffians,rubes,rosalita,rollerblades,rohypnol,roasts,roadies,ritten,rippling,ripples,rigoletto,richardo,rethought,reshoot,reserving,reseda,rescuer,reread,requisitions,repute,reprogram,replenish,repetitious,reorganizing,reinventing,reinvented,reheat,refrigerators,reenter,recruiter,recliner,rawdy,rashes,rajeski,raison,raisers,rages,quinine,questscape,queller,pygmalion,pushers,pusan,purview,pumpin,pubescent,prudes,provolone,propriety,propped,procrastinate,processional,preyed,pretrial,portent,pooling,poofy,polloi,policia,poacher,pluses,pleasuring,platitudes,plateaued,plaguing,pittance,pinheads,pincushion,pimply,pimped,piggyback,piecing,phillipe,philipse,philby,pharaohs,petyr,petitioner,peshtigo,pesaram,persnickety,perpetrate,percolating,pepto,penne,penell,pemmican,peeks,pedaling,peacemaker,pawnshop,patting,pathologically,patchouli,pasts,pasties,passin,parlors,paltrow,palamon,padlock,paddling,oversleep,overheating,overdosed,overcharge,overblown,outrageously,ornery,opportune,oooooooooh,oohhhh,ohhhhhh,ogres,odorless,obliterated,nyong,nymphomaniac,ntozake,novocain,nough,nonnie,nonissue,nodules,nightmarish,nightline,niceties,newsman,needra,nedry,necking,navour,nauseam,nauls,narim,namath,nagged,naboo,n'sync,myslexia,mutator,mustafi,musketeer,murtaugh,murderess,munching,mumsy,muley,mouseville,mortifying,morgendorffers,moola,montel,mongoloid,molestered,moldings,mocarbies,mo'ss,mixers,misrell,misnomer,misheard,mishandled,miscreant,misconceptions,miniscule,millgate,mettle,metricconverter,meteors,menorah,mengele,melding,meanness,mcgruff,mcarnold,matzoh,matted,mastectomy,massager,marveling,marooned,marmaduke,marick,manhandled,manatees,man'll,maltin,maliciously,malfeasance,malahide,maketh,makeovers,maiming,machismo,lumpectomy,lumbering,lucci,lording,lorca,lookouts,loogie,loners,loathed,lissen,lighthearted,lifer,lickin,lewen,levitation,lestercorp,lessee,lentils,legislate,legalizing,lederhosen,lawmen,lasskopf,lardner,lambeau,lamagra,ladonn,lactic,lacquer,labatier,krabappel,kooks,knickknacks,klutzy,kleynach,klendathu,kinross,kinkaid,kind'a,ketch,kesher,karikos,karenina,kanamits,junshi,jumbled,joust,jotted,jobson,jingling,jigalong,jerries,jellies,jeeps,javna,irresistable,internist,intercranial,inseminated,inquisitor,infuriate,inflating,infidelities,incessantly,incensed,incase,incapacitate,inasmuch,inaccuracies,imploding,impeding,impediments,immaturity,illegible,iditarod,icicles,ibuprofen,i'i'm,hymie,hydrolase,hunker,humps,humons,humidor,humdinger,humbling,huggin,huffing,housecleaning,hothouse,hotcakes,hosty,hootenanny,hootchie,hoosegow,honks,honeymooners,homily,homeopathic,hitchhikers,hissed,hillnigger,hexavalent,hewwo,hershe,hermey,hergott,henny,hennigans,henhouse,hemolytic,helipad,heifer,hebrews,hebbing,heaved,headlock,harrowing,harnessed,hangovers,handi,handbasket,halfrek,hacene,gyges,guys're,gundersons,gumption,gruntmaster,grubs,grossie,groped,grins,greaseball,gravesite,gratuity,granma,grandfathers,grandbaby,gradski,gracing,gossips,gooble,goners,golitsyn,gofer,godsake,goddaughter,gnats,gluing,glares,givers,ginza,gimmie,gimmee,gennero,gemme,gazpacho,gazed,gassy,gargling,gandhiji,galvanized,gallbladder,gaaah,furtive,fumigation,fucka,fronkonsteen,frills,freezin,freewald,freeloader,frailty,forger,foolhardy,fondest,fomin,followin,follicle,flotation,flopping,floodgates,flogged,flicked,flenders,fleabag,fixings,fixable,fistful,firewater,firelight,fingerbang,finalizing,fillin,filipov,fiderer,felling,feldberg,feign,faunia,fatale,farkus,fallible,faithfulness,factoring,eyeful,extramarital,exterminated,exhume,exasperated,eviscerate,estoy,esmerelda,escapades,epoxy,enticed,enthused,entendre,engrossing,endorphins,emptive,emmys,eminently,embezzler,embarressed,embarrassingly,embalmed,eludes,eling,elated,eirie,egotitis,effecting,eerily,eecom,eczema,earthy,earlobes,eally,dyeing,dwells,duvet,duncans,dulcet,droves,droppin,drools,drey'auc,downriver,domesticity,dollop,doesnt,dobler,divulged,diversionary,distancing,dispensers,disorienting,disneyworld,dismissive,disingenuous,disheveled,disfiguring,dinning,dimming,diligently,dilettante,dilation,dickensian,diaphragms,devastatingly,destabilize,desecrate,deposing,deniece,demony,delving,delicates,deigned,defraud,deflower,defibrillator,defiantly,defenceless,defacing,deconstruction,decompose,deciphering,decibels,deceptively,deceptions,decapitation,debutantes,debonair,deadlier,dawdling,davic,darwinism,darnit,darks,danke,danieljackson,dangled,cytoxan,cutout,cutlery,curveball,curfews,cummerbund,crunches,crouched,crisps,cripples,crilly,cribs,crewman,creepin,creeds,credenza,creak,crawly,crawlin,crawlers,crated,crackheads,coworker,couldn't've,corwins,coriander,copiously,convenes,contraceptives,contingencies,contaminating,conniption,condiment,concocting,comprehending,complacency,commendatore,comebacks,com'on,collarbone,colitis,coldly,coiffure,coffers,coeds,codependent,cocksucking,cockney,cockles,clutched,closeted,cloistered,cleve,cleats,clarifying,clapped,cinnabar,chunnel,chumps,cholinesterase,choirboy,chocolatey,chlamydia,chigliak,cheesie,chauvinistic,chasm,chartreuse,charo,charnier,chapil,chalked,chadway,certifiably,cellulite,celled,cavalcade,cataloging,castrated,cassio,cashews,cartouche,carnivore,carcinogens,capulet,captivated,capt'n,cancellations,campin,callate,callar,caffeinated,cadavers,cacophony,cackle,buzzes,buttoning,busload,burglaries,burbs,buona,bunions,bullheaded,buffs,bucyk,buckling,bruschetta,browbeating,broomsticks,broody,bromly,brolin,briefings,brewskies,breathalyzer,breakups,bratwurst,brania,braiding,brags,braggin,bradywood,bottomed,bossa,bordello,bookshelf,boogida,bondsman,bolder,boggles,bludgeoned,blowtorch,blotter,blips,blemish,bleaching,blainetologists,blading,blabbermouth,birdseed,bimmel,biloxi,biggly,bianchinni,betadine,berenson,belus,belloq,begets,befitting,beepers,beelzebub,beefed,bedridden,bedevere,beckons,beaded,baubles,bauble,battleground,bathrobes,basketballs,basements,barroom,barnacle,barkin,barked,baretta,bangles,bangler,banality,bambang,baltar,ballplayers,bagman,baffles,backroom,babysat,baboons,averse,audiotape,auctioneer,atten,atcha,astonishment,arugula,arroz,antihistamines,annoyances,anesthesiology,anatomically,anachronism,amiable,amaretto,allahu,alight,aimin,ailment,afterglow,affronte,advil,adrenals,actualization,acrost,ached,accursed,accoutrements,absconded,aboveboard,abetted,aargh,aaaahh,zuwicky,zolda,ziploc,zakamatak,youve,yippie,yesterdays,yella,yearns,yearnings,yearned,yawning,yalta,yahtzee,y'mean,y'are,wuthering,wreaks,worrisome,workiiing,wooooooo,wonky,womanizing,wolodarsky,wiwith,withdraws,wishy,wisht,wipers,wiper,winos,windthorne,windsurfing,windermere,wiggled,wiggen,whwhat,whodunit,whoaaa,whittling,whitesnake,whereof,wheezing,wheeze,whatd'ya,whataya,whammo,whackin,wellll,weightless,weevil,wedgies,webbing,weasly,wayside,waxes,waturi,washy,washrooms,wandell,waitaminute,waddya,waaaah,vornac,vishnoor,virulent,vindictiveness,vinceres,villier,vigeous,vestigial,ventilate,vented,venereal,veering,veered,veddy,vaslova,valosky,vailsburg,vaginas,vagas,urethra,upstaged,uploading,unwrapping,unwieldy,untapped,unsatisfied,unquenchable,unnerved,unmentionable,unlovable,unknowns,uninformed,unimpressed,unhappily,unguarded,unexplored,undergarment,undeniably,unclench,unclaimed,uncharacteristically,unbuttoned,unblemished,ululd,uhhhm,tweeze,tutsami,tushy,tuscarora,turkle,turghan,turbinium,tubers,trucoat,troxa,tropicana,triquetra,trimmers,triceps,trespassed,traya,traumatizing,transvestites,trainors,tradin,trackers,townies,tourelles,toucha,tossin,tortious,topshop,topes,tonics,tongs,tomsk,tomorrows,toiling,toddle,tizzy,tippers,timmi,thwap,thusly,ththe,thrusts,throwers,throwed,throughway,thickening,thermonuclear,thelwall,thataway,terrifically,tendons,teleportation,telepathically,telekinetic,teetering,teaspoons,tarantulas,tapas,tanned,tangling,tamales,tailors,tahitian,tactful,tachy,tablespoon,syrah,synchronicity,synch,synapses,swooning,switchman,swimsuits,sweltering,sweetly,suvolte,suslov,surfed,supposition,suppertime,supervillains,superfluous,superego,sunspots,sunning,sunless,sundress,suckah,succotash,sublevel,subbasement,studious,striping,strenuously,straights,stonewalled,stillness,stilettos,stevesy,steno,steenwyck,stargates,stammering,staedert,squiggly,squiggle,squashing,squaring,spreadsheet,spramp,spotters,sporto,spooking,splendido,spittin,spirulina,spiky,spate,spartacus,spacerun,soonest,something'll,someth,somepin,someone'll,sofas,soberly,sobered,snowmen,snowbank,snowballing,snivelling,sniffling,snakeskin,snagging,smush,smooter,smidgen,smackers,slumlord,slossum,slimmer,slighted,sleepwalk,sleazeball,skokie,skeptic,sitarides,sistah,sipped,sindell,simpletons,simony,silkwood,silks,silken,sightless,sideboard,shuttles,shrugging,shrouds,showy,shoveled,shouldn'ta,shoplifters,shitstorm,sheeny,shapetype,shaming,shallows,shackle,shabbily,shabbas,seppuku,senility,semite,semiautomatic,selznick,secretarial,sebacio,scuzzy,scummy,scrutinized,scrunchie,scribbled,scotches,scolded,scissor,schlub,scavenging,scarin,scarfing,scallions,scald,savour,savored,saute,sarcoidosis,sandbar,saluted,salish,saith,sailboats,sagittarius,sacre,saccharine,sacamano,rushdie,rumpled,rumba,rulebook,rubbers,roughage,rotisserie,rootie,roofy,roofie,romanticize,rittle,ristorante,rippin,rinsing,ringin,rincess,rickety,reveling,retest,retaliating,restorative,reston,restaurateur,reshoots,resetting,resentments,reprogramming,repossess,repartee,renzo,remore,remitting,remeber,relaxants,rejuvenate,rejections,regenerated,refocus,referrals,reeno,recycles,recrimination,reclining,recanting,reattach,reassigning,razgul,raved,rattlesnakes,rattles,rashly,raquetball,ransack,raisinettes,raheem,radisson,radishes,raban,quoth,qumari,quints,quilts,quilting,quien,quarreled,purty,purblind,punchbowl,publically,psychotics,psychopaths,psychoanalyze,pruning,provasik,protectin,propping,proportioned,prophylactic,proofed,prompter,procreate,proclivities,prioritizing,prinze,pricked,press'll,presets,prescribes,preocupe,prejudicial,prefex,preconceived,precipice,pralines,pragmatist,powerbar,pottie,pottersville,potsie,potholes,posses,posies,portkey,porterhouse,pornographers,poring,poppycock,poppers,pomponi,pokin,poitier,podiatry,pleeze,pleadings,playbook,platelets,plane'arium,placebos,place'll,pistachios,pirated,pinochle,pineapples,pinafore,pimples,piggly,piddling,picon,pickpockets,picchu,physiologically,physic,phobic,philandering,phenomenally,pheasants,pewter,petticoat,petronis,petitioning,perturbed,perpetuating,permutat,perishable,perimeters,perfumed,percocet,per'sus,pepperjack,penalize,pelting,pellet,peignoir,pedicures,peckers,pecans,pawning,paulsson,pattycake,patrolmen,patois,pathos,pasted,parishioner,parcheesi,parachuting,papayas,pantaloons,palpitations,palantine,paintballing,overtired,overstress,oversensitive,overnights,overexcited,overanxious,overachiever,outwitted,outvoted,outnumber,outlast,outlander,out've,orphey,orchestrating,openers,ooooooo,okies,ohhhhhhhhh,ohhhhhhhh,ogling,offbeat,obsessively,obeyed,o'hana,o'bannon,o'bannion,numpce,nummy,nuked,nuances,nourishing,nosedive,norbu,nomlies,nomine,nixed,nihilist,nightshift,newmeat,neglectful,neediness,needin,naphthalene,nanocytes,nanite,naivete,n'yeah,mystifying,myhnegon,mutating,musing,mulled,muggy,muerto,muckraker,muchachos,mountainside,motherless,mosquitos,morphed,mopped,moodoo,moncho,mollem,moisturiser,mohicans,mocks,mistresses,misspent,misinterpretation,miscarry,minuses,mindee,mimes,millisecond,milked,mightn't,mightier,mierzwiak,microchips,meyerling,mesmerizing,mershaw,meecrob,medicate,meddled,mckinnons,mcgewan,mcdunnough,mcats,mbien,matzah,matriarch,masturbated,masselin,martialed,marlboros,marksmanship,marinate,marchin,manicured,malnourished,malign,majorek,magnon,magnificently,macking,machiavellian,macdougal,macchiato,macaws,macanaw,m'self,lydells,lusts,lucite,lubricants,lopper,lopped,loneliest,lonelier,lomez,lojack,loath,liquefy,lippy,limps,likin,lightness,liesl,liebchen,licious,libris,libation,lhamo,leotards,leanin,laxatives,lavished,latka,lanyard,lanky,landmines,lameness,laddies,lacerated,labored,l'amour,kreskin,kovitch,kournikova,kootchy,konoss,knknow,knickety,knackety,kmart,klicks,kiwanis,kissable,kindergartners,kilter,kidnet,kid'll,kicky,kickbacks,kickback,kholokov,kewpie,kendo,katra,kareoke,kafelnikov,kabob,junjun,jumba,julep,jordie,jondy,jolson,jenoff,jawbone,janitorial,janiro,ipecac,invigorated,intruded,intros,intravenously,interruptus,interrogations,interject,interfacing,interestin,insuring,instilled,insensitivity,inscrutable,inroads,innards,inlaid,injector,ingratitude,infuriates,infra,infliction,indelicate,incubators,incrimination,inconveniencing,inconsolable,incestuous,incas,incarcerate,inbreeding,impudence,impressionists,impeached,impassioned,imipenem,idling,idiosyncrasies,icebergs,hypotensive,hydrochloride,hushed,humus,humph,hummm,hulking,hubcaps,hubald,howya,howbout,how'll,housebroken,hotwire,hotspots,hotheaded,horrace,hopsfield,honto,honkin,honeymoons,homewrecker,hombres,hollers,hollerin,hoedown,hoboes,hobbling,hobble,hoarse,hinky,highlighters,hexes,heru'ur,hernias,heppleman,hell're,heighten,heheheheheh,heheheh,hedging,heckling,heckled,heavyset,heatshield,heathens,heartthrob,headpiece,hayseed,haveo,hauls,hasten,harridan,harpoons,hardens,harcesis,harbouring,hangouts,halkein,haleh,halberstam,hairnet,hairdressers,hacky,haaaa,h'yah,gusta,gushy,gurgling,guilted,gruel,grudging,grrrrrr,grosses,groomsmen,griping,gravest,gratified,grated,goulash,goopy,goona,goodly,godliness,godawful,godamn,glycerin,glutes,glowy,globetrotters,glimpsed,glenville,glaucoma,girlscout,giraffes,gilbey,gigglepuss,ghora,gestating,gelato,geishas,gearshift,gayness,gasped,gaslighting,garretts,garba,gablyczyck,g'head,fumigating,fumbling,fudged,fuckwad,fuck're,fuchsia,fretting,freshest,frenchies,freezers,fredrica,fraziers,fraidy,foxholes,fourty,fossilized,forsake,forfeits,foreclosed,foreal,footsies,florists,flopped,floorshow,floorboard,flinching,flecks,flaubert,flatware,flatulence,flatlined,flashdance,flail,flagging,fiver,fitzy,fishsticks,finetti,finelli,finagle,filko,fieldstone,fibber,ferrini,feedin,feasting,favore,fathering,farrouhk,farmin,fairytale,fairservice,factoid,facedown,fabled,eyeballin,extortionist,exquisitely,expedited,exorcise,existentialist,execs,exculpatory,exacerbate,everthing,eventuality,evander,euphoric,euphemisms,estamos,erred,entitle,enquiries,enormity,enfants,endive,encyclopedias,emulating,embittered,effortless,ectopic,ecirc,easely,earphones,earmarks,dweller,durslar,durned,dunois,dunking,dunked,dumdum,dullard,dudleys,druthers,druggist,drossos,drooled,driveways,drippy,dreamless,drawstring,drang,drainpipe,dozing,dotes,dorkface,doorknobs,doohickey,donnatella,doncha,domicile,dokos,dobermans,dizzying,divola,ditsy,distaste,disservice,dislodged,dislodge,disinherit,disinformation,discounting,dinka,dimly,digesting,diello,diddling,dictatorships,dictators,diagnostician,devours,devilishly,detract,detoxing,detours,detente,destructs,desecrated,derris,deplore,deplete,demure,demolitions,demean,delish,delbruck,delaford,degaulle,deftly,deformity,deflate,definatly,defector,decrypted,decontamination,decapitate,decanter,dardis,dampener,damme,daddy'll,dabbling,dabbled,d'etre,d'argent,d'alene,d'agnasti,czechoslovakian,cymbal,cyberdyne,cutoffs,cuticle,curvaceous,curiousity,crowing,crowed,croutons,cropped,criminy,crescentis,crashers,cranwell,coverin,courtrooms,countenance,cosmically,cosign,corroboration,coroners,cornflakes,copperpot,copperhead,copacetic,coordsize,convulsing,consults,conjures,congenial,concealer,compactor,commercialism,cokey,cognizant,clunkers,clumsily,clucking,cloves,cloven,cloths,clothe,clods,clocking,clings,clavicle,classless,clashing,clanking,clanging,clamping,civvies,citywide,circulatory,circuited,chronisters,chromic,choos,chloroformed,chillun,cheesed,chatterbox,chaperoned,channukah,cerebellum,centerpieces,centerfold,ceecee,ccedil,cavorting,cavemen,cauterized,cauldwell,catting,caterine,cassiopeia,carves,cartwheel,carpeted,carob,caressing,carelessly,careening,capricious,capitalistic,capillaries,candidly,camaraderie,callously,calfskin,caddies,buttholes,busywork,busses,burps,burgomeister,bunkhouse,bungchow,bugler,buffets,buffed,brutish,brusque,bronchitis,bromden,brolly,broached,brewskis,brewin,brean,breadwinner,brana,bountiful,bouncin,bosoms,borgnine,bopping,bootlegs,booing,bombosity,bolting,boilerplate,bluey,blowback,blouses,bloodsuckers,bloodstained,bloat,bleeth,blackface,blackest,blackened,blacken,blackballed,blabs,blabbering,birdbrain,bipartisanship,biodegradable,biltmore,bilked,big'uns,bidet,besotted,bernheim,benegas,bendiga,belushi,bellboys,belittling,behinds,begone,bedsheets,beckoning,beaute,beaudine,beastly,beachfront,bathes,batak,baser,baseballs,barbella,bankrolling,bandaged,baerly,backlog,backin,babying,azkaban,awwwww,aviary,authorizes,austero,aunty,attics,atreus,astounded,astonish,artemus,arses,arintero,appraiser,apathetic,anybody'd,anxieties,anticlimactic,antar,anglos,angleman,anesthetist,androscoggin,andolini,andale,amway,amuck,amniocentesis,amnesiac,americano,amara,alvah,altruism,alternapalooza,alphabetize,alpaca,allus,allergist,alexandros,alaikum,akimbo,agoraphobia,agides,aggrhh,aftertaste,adoptions,adjuster,addictions,adamantium,activator,accomplishes,aberrant,aaaaargh,aaaaaaaaaaaaa,a'ight,zzzzzzz,zucchini,zookeeper,zirconia,zippers,zequiel,zellary,zeitgeist,zanuck,zagat,you'n,ylang,yes'm,yenta,yecchh,yecch,yawns,yankin,yahdah,yaaah,y'got,xeroxed,wwooww,wristwatch,wrangled,wouldst,worthiness,worshiping,wormy,wormtail,wormholes,woosh,wollsten,wolfing,woefully,wobbling,wintry,wingding,windstorm,windowtext,wiluna,wilting,wilted,willick,willenholly,wildflowers,wildebeest,whyyy,whoppers,whoaa,whizzing,whizz,whitest,whistled,whist,whinny,wheelies,whazzup,whatwhatwhaaat,whato,whatdya,what'dya,whacks,wewell,wetsuit,welluh,weeps,waylander,wavin,wassail,wasnt,warneford,warbucks,waltons,wallbanger,waiving,waitwait,vowing,voucher,vornoff,vorhees,voldemort,vivre,vittles,vindaloo,videogames,vichyssoise,vicarious,vesuvius,verguenza,ven't,velveteen,velour,velociraptor,vastness,vasectomies,vapors,vanderhof,valmont,validates,valiantly,vacuums,usurp,usernum,us'll,urinals,unyielding,unvarnished,unturned,untouchables,untangled,unsecured,unscramble,unreturned,unremarkable,unpretentious,unnerstand,unmade,unimpeachable,unfashionable,underwrite,underlining,underling,underestimates,underappreciated,uncouth,uncork,uncommonly,unclog,uncircumcised,unchallenged,uncas,unbuttoning,unapproved,unamerican,unafraid,umpteen,umhmm,uhwhy,ughuh,typewriters,twitches,twitched,twirly,twinkling,twinges,twiddling,turners,turnabout,tumblin,tryed,trowel,trousseau,trivialize,trifles,tribianni,trenchcoat,trembled,traumatize,transitory,transients,transfuse,transcribing,tranq,trampy,traipsed,trainin,trachea,traceable,touristy,toughie,toscanini,tortola,tortilla,torreon,toreador,tommorrow,tollbooth,tollans,toidy,togas,tofurkey,toddling,toddies,toasties,toadstool,to've,tingles,timin,timey,timetables,tightest,thuggee,thrusting,thrombus,throes,thrifty,thornharts,thinnest,thicket,thetas,thesulac,tethered,testaburger,tersenadine,terrif,terdlington,tepui,temping,tector,taxidermy,tastebuds,tartlets,tartabull,tar'd,tantamount,tangy,tangles,tamer,tabula,tabletops,tabithia,szechwan,synthedyne,svenjolly,svengali,survivalists,surmise,surfboards,surefire,suprise,supremacists,suppositories,superstore,supercilious,suntac,sunburned,summercliff,sullied,sugared,suckle,subtleties,substantiated,subsides,subliminal,subhuman,strowman,stroked,stroganoff,streetlight,straying,strainer,straighter,straightener,stoplight,stirrups,stewing,stereotyping,stepmommy,stephano,stashing,starshine,stairwells,squatsie,squandering,squalid,squabbling,squab,sprinkling,spreader,spongy,spokesmen,splintered,spittle,spitter,spiced,spews,spendin,spect,spearchucker,spatulas,southtown,soused,soshi,sorter,sorrowful,sooth,some'in,soliloquy,soiree,sodomized,sobriki,soaping,snows,snowcone,snitching,snitched,sneering,snausages,snaking,smoothed,smoochies,smarten,smallish,slushy,slurring,sluman,slithers,slippin,sleuthing,sleeveless,skinless,skillfully,sketchbook,skagnetti,sista,sinning,singularly,sinewy,silverlake,siguto,signorina,sieve,sidearms,shying,shunning,shtud,shrieks,shorting,shortbread,shopkeepers,shmancy,shizzit,shitheads,shitfaced,shipmates,shiftless,shelving,shedlow,shavings,shatters,sharifa,shampoos,shallots,shafter,sha'nauc,sextant,serviceable,sepsis,senores,sendin,semis,semanski,selflessly,seinfelds,seers,seeps,seductress,secaucus,sealant,scuttling,scusa,scrunched,scissorhands,schreber,schmancy,scamps,scalloped,savoir,savagery,sarong,sarnia,santangel,samool,sallow,salino,safecracker,sadism,sacrilegious,sabrini,sabath,s'aright,ruttheimer,rudest,rubbery,rousting,rotarian,roslin,roomed,romari,romanica,rolltop,rolfski,rockettes,roared,ringleader,riffing,ribcage,rewired,retrial,reting,resuscitated,restock,resale,reprogrammed,replicant,repentant,repellant,repays,repainting,renegotiating,rendez,remem,relived,relinquishes,relearn,relaxant,rekindling,rehydrate,refueled,refreshingly,refilling,reexamine,reeseman,redness,redeemable,redcoats,rectangles,recoup,reciprocated,reassessing,realy,realer,reachin,re'kali,rawlston,ravages,rappaports,ramoray,ramming,raindrops,rahesh,radials,racists,rabartu,quiches,quench,quarreling,quaintly,quadrants,putumayo,put'em,purifier,pureed,punitis,pullout,pukin,pudgy,puddings,puckering,pterodactyl,psychodrama,psats,protestations,protectee,prosaic,propositioned,proclivity,probed,printouts,prevision,pressers,preset,preposition,preempt,preemie,preconceptions,prancan,powerpuff,potties,potpie,poseur,porthole,poops,pooping,pomade,polyps,polymerized,politeness,polisher,polack,pocketknife,poatia,plebeian,playgroup,platonically,platitude,plastering,plasmapheresis,plaids,placemats,pizzazz,pintauro,pinstripes,pinpoints,pinkner,pincer,pimento,pileup,pilates,pigmen,pieeee,phrased,photocopies,phoebes,philistines,philanderer,pheromone,phasers,pfeffernuesse,pervs,perspire,personify,perservere,perplexed,perpetrating,perkiness,perjurer,periodontist,perfunctory,perdido,percodan,pentameter,pentacle,pensive,pensione,pennybaker,pennbrooke,penhall,pengin,penetti,penetrates,pegnoir,peeve,peephole,pectorals,peckin,peaky,peaksville,paxcow,paused,patted,parkishoff,parkers,pardoning,paraplegic,paraphrasing,paperers,papered,pangs,paneling,palooza,palmed,palmdale,palatable,pacify,pacified,owwwww,oversexed,overrides,overpaying,overdrawn,overcompensate,overcomes,overcharged,outmaneuver,outfoxed,oughtn't,ostentatious,oshun,orthopedist,or'derves,ophthalmologist,operagirl,oozes,oooooooh,onesie,omnis,omelets,oktoberfest,okeydoke,ofthe,ofher,obstetrical,obeys,obeah,o'henry,nyquil,nyanyanyanyah,nuttin,nutsy,nutball,nurhachi,numbskull,nullifies,nullification,nucking,nubbin,nourished,nonspecific,noing,noinch,nohoho,nobler,nitwits,newsprint,newspaperman,newscaster,neuropathy,netherworld,neediest,navasky,narcissists,napped,nafta,mache,mykonos,mutilating,mutherfucker,mutha,mutates,mutate,musn't,murchy,multitasking,mujeeb,mudslinging,muckraking,mousetrap,mourns,mournful,motherf,mostro,morphing,morphate,moralistic,moochy,mooching,monotonous,monopolize,monocle,molehill,moland,mofet,mockup,mobilizing,mmmmmmm,mitzvahs,mistreating,misstep,misjudge,misinformation,misdirected,miscarriages,miniskirt,mindwarped,minced,milquetoast,miguelito,mightily,midstream,midriff,mideast,microbe,methuselah,mesdames,mescal,men'll,memma,megaton,megara,megalomaniac,meeee,medulla,medivac,meaninglessness,mcnuggets,mccarthyism,maypole,may've,mauve,mateys,marshack,markles,marketable,mansiere,manservant,manse,manhandling,mallomars,malcontent,malaise,majesties,mainsail,mailmen,mahandra,magnolias,magnified,magev,maelstrom,machu,macado,m'boy,m'appelle,lustrous,lureen,lunges,lumped,lumberyard,lulled,luego,lucks,lubricated,loveseat,loused,lounger,loski,lorre,loora,looong,loonies,loincloth,lofts,lodgers,lobbing,loaner,livered,liqueur,ligourin,lifesaving,lifeguards,lifeblood,liaisons,let'em,lesbianism,lence,lemonlyman,legitimize,leadin,lazars,lazarro,lawyering,laugher,laudanum,latrines,lations,laters,lapels,lakefront,lahit,lafortunata,lachrymose,l'italien,kwaini,kruczynski,kramerica,kowtow,kovinsky,korsekov,kopek,knowakowski,knievel,knacks,kiowas,killington,kickball,keyworth,keymaster,kevie,keveral,kenyons,keggers,keepsakes,kechner,keaty,kavorka,karajan,kamerev,kaggs,jujyfruit,jostled,jonestown,jokey,joists,jocko,jimmied,jiggled,jests,jenzen,jenko,jellyman,jedediah,jealitosis,jaunty,jarmel,jankle,jagoff,jagielski,jackrabbits,jabbing,jabberjaw,izzat,irresponsibly,irrepressible,irregularity,irredeemable,inuvik,intuitions,intubated,intimates,interminable,interloper,intercostal,instyle,instigate,instantaneously,ining,ingrown,ingesting,infusing,infringe,infinitum,infact,inequities,indubitably,indisputable,indescribably,indentation,indefinable,incontrovertible,inconsequential,incompletes,incoherently,inclement,incidentals,inarticulate,inadequacies,imprudent,improprieties,imprison,imprinted,impressively,impostors,importante,imperious,impale,immodest,immobile,imbedded,imbecilic,illegals,idn't,hysteric,hypotenuse,hygienic,hyeah,hushpuppies,hunhh,humpback,humored,hummed,humiliates,humidifier,huggy,huggers,huckster,hotbed,hosing,hosers,horsehair,homebody,homebake,holing,holies,hoisting,hogwallop,hocks,hobbits,hoaxes,hmmmmm,hisses,hippest,hillbillies,hilarity,heurh,herniated,hermaphrodite,hennifer,hemlines,hemline,hemery,helplessness,helmsley,hellhound,heheheheh,heeey,hedda,heartbeats,heaped,healers,headstart,headsets,headlong,hawkland,havta,haulin,harvey'll,hanta,hansom,hangnail,handstand,handrail,handoff,hallucinogen,hallor,halitosis,haberdashery,gypped,guy'll,gumbel,guerillas,guava,guardrail,grunther,grunick,groppi,groomer,grodin,gripes,grinds,grifters,gretch,greevey,greasing,graveyards,grandkid,grainy,gouging,gooney,googly,goldmuff,goldenrod,goingo,godly,gobbledygook,gobbledegook,glues,gloriously,glengarry,glassware,glamor,gimmicks,giggly,giambetti,ghoulish,ghettos,ghali,gether,geriatrics,gerbils,geosynchronous,georgio,gente,gendarme,gelbman,gazillionth,gayest,gauging,gastro,gaslight,gasbag,garters,garish,garas,gantu,gangy,gangly,gangland,galling,gadda,furrowed,funnies,funkytown,fugimotto,fudging,fuckeen,frustrates,froufrou,froot,fromberge,frizzies,fritters,frightfully,friendliest,freeloading,freelancing,freakazoid,fraternization,framers,fornication,fornicating,forethought,footstool,foisting,focussing,focking,flurries,fluffed,flintstones,fledermaus,flayed,flawlessly,flatters,flashbang,flapped,fishies,firmer,fireproof,firebug,fingerpainting,finessed,findin,financials,finality,fillets,fiercest,fiefdom,fibbing,fervor,fentanyl,fenelon,fedorchuk,feckless,feathering,faucets,farewells,fantasyland,fanaticism,faltered,faggy,faberge,extorting,extorted,exterminating,exhumation,exhilaration,exhausts,exfoliate,excels,exasperating,exacting,everybody'd,evasions,espressos,esmail,errrr,erratically,eroding,ernswiler,epcot,enthralled,ensenada,enriching,enrage,enhancer,endear,encrusted,encino,empathic,embezzle,emanates,electricians,eking,egomaniacal,egging,effacing,ectoplasm,eavesdropped,dummkopf,dugray,duchaisne,drunkard,drudge,droop,droids,drips,dripped,dribbles,drazens,downy,downsize,downpour,dosages,doppelganger,dopes,doohicky,dontcha,doneghy,divining,divest,diuretics,diuretic,distrustful,disrupts,dismemberment,dismember,disinfect,disillusionment,disheartening,discourteous,discotheque,discolored,dirtiest,diphtheria,dinks,dimpled,didya,dickwad,diatribes,diathesis,diabetics,deviants,detonates,detests,detestable,detaining,despondent,desecration,derision,derailing,deputized,depressors,dependant,dentures,denominators,demur,demonology,delts,dellarte,delacour,deflated,defib,defaced,decorators,deaqon,davola,datin,darwinian,darklighters,dandelions,dampened,damaskinos,dalrimple,d'peshu,d'hoffryn,d'astier,cynics,cutesy,cutaway,curmudgeon,curdle,culpability,cuisinart,cuffing,crypts,cryptid,crunched,crumblers,crudely,crosscheck,croon,crissake,crevasse,creswood,creepo,creases,creased,creaky,cranks,crabgrass,coveralls,couple'a,coughs,coslaw,corporeal,cornucopia,cornering,corks,cordoned,coolly,coolin,cookbooks,contrite,contented,constrictor,confound,confit,confiscating,condoned,conditioners,concussions,comprendo,comers,combustible,combusted,collingswood,coldness,coitus,codicil,coasting,clydesdale,cluttering,clunker,clunk,clumsiness,clotted,clothesline,clinches,clincher,cleverness,clench,clein,cleanses,claymores,clammed,chugging,chronically,christsakes,choque,chompers,chiseling,chirpy,chirp,chinks,chingachgook,chickenpox,chickadee,chewin,chessboard,chargin,chanteuse,chandeliers,chamdo,chagrined,chaff,certs,certainties,cerreno,cerebrum,censured,cemetary,caterwauling,cataclysmic,casitas,cased,carvel,carting,carrear,carolling,carolers,carnie,cardiogram,carbuncle,capulets,canines,candaules,canape,caldecott,calamitous,cadillacs,cachet,cabeza,cabdriver,buzzards,butai,businesswomen,bungled,bumpkins,bummers,bulldoze,buffybot,bubut,bubbies,brrrrr,brownout,brouhaha,bronzing,bronchial,broiler,briskly,briefcases,bricked,breezing,breeher,breakable,breadstick,bravenet,braved,brandies,brainwaves,brainiest,braggart,bradlee,boys're,boys'll,boys'd,boutonniere,bossed,bosomy,borans,boosts,bookshelves,bookends,boneless,bombarding,bollo,boinked,boink,bluest,bluebells,bloodshot,blockhead,blockbusters,blithely,blather,blankly,bladders,blackbeard,bitte,bippy,biogenetics,bilge,bigglesworth,bicuspids,beususe,betaseron,besmirch,bernece,bereavement,bentonville,benchley,benching,bembe,bellyaching,bellhops,belie,beleaguered,behrle,beginnin,begining,beenie,beefs,beechwood,becau,beaverhausen,beakers,bazillion,baudouin,barrytown,barringtons,barneys,barbs,barbers,barbatus,bankrupted,bailiffs,backslide,baby'd,baaad,b'fore,awwwk,aways,awakes,automatics,authenticate,aught,aubyn,attired,attagirl,atrophied,asystole,astroturf,assertiveness,artichokes,arquillians,aright,archenemy,appraise,appeased,antin,anspaugh,anesthetics,anaphylactic,amscray,ambivalence,amalio,alriiight,alphabetized,alpena,alouette,allora,alliteration,allenwood,allegiances,algerians,alcerro,alastor,ahaha,agitators,aforethought,advertises,admonition,adirondacks,adenoids,acupuncturist,acula,actuarial,activators,actionable,achingly,accusers,acclimated,acclimate,absurdly,absorbent,absolvo,absolutes,absences,abdomenizer,aaaaaaaaah,aaaaaaaaaa,a'right".split(","),
    male_names: "james,john,robert,michael,william,david,richard,charles,joseph,thomas,christopher,daniel,paul,mark,donald,george,kenneth,steven,edward,brian,ronald,anthony,kevin,jason,matthew,gary,timothy,jose,larry,jeffrey,frank,scott,eric,stephen,andrew,raymond,gregory,joshua,jerry,dennis,walter,patrick,peter,harold,douglas,henry,carl,arthur,ryan,roger,joe,juan,jack,albert,jonathan,justin,terry,gerald,keith,samuel,willie,ralph,lawrence,nicholas,roy,benjamin,bruce,brandon,adam,harry,fred,wayne,billy,steve,louis,jeremy,aaron,randy,eugene,carlos,russell,bobby,victor,ernest,phillip,todd,jesse,craig,alan,shawn,clarence,sean,philip,chris,johnny,earl,jimmy,antonio,danny,bryan,tony,luis,mike,stanley,leonard,nathan,dale,manuel,rodney,curtis,norman,marvin,vincent,glenn,jeffery,travis,jeff,chad,jacob,melvin,alfred,kyle,francis,bradley,jesus,herbert,frederick,ray,joel,edwin,don,eddie,ricky,troy,randall,barry,bernard,mario,leroy,francisco,marcus,micheal,theodore,clifford,miguel,oscar,jay,jim,tom,calvin,alex,jon,ronnie,bill,lloyd,tommy,leon,derek,darrell,jerome,floyd,leo,alvin,tim,wesley,dean,greg,jorge,dustin,pedro,derrick,dan,zachary,corey,herman,maurice,vernon,roberto,clyde,glen,hector,shane,ricardo,sam,rick,lester,brent,ramon,tyler,gilbert,gene,marc,reginald,ruben,brett,nathaniel,rafael,edgar,milton,raul,ben,cecil,duane,andre,elmer,brad,gabriel,ron,roland,jared,adrian,karl,cory,claude,erik,darryl,neil,christian,javier,fernando,clinton,ted,mathew,tyrone,darren,lonnie,lance,cody,julio,kurt,allan,clayton,hugh,max,dwayne,dwight,armando,felix,jimmie,everett,ian,ken,bob,jaime,casey,alfredo,alberto,dave,ivan,johnnie,sidney,byron,julian,isaac,clifton,willard,daryl,virgil,andy,salvador,kirk,sergio,seth,kent,terrance,rene,eduardo,terrence,enrique,freddie,stuart,fredrick,arturo,alejandro,joey,nick,luther,wendell,jeremiah,evan,julius,donnie,otis,trevor,luke,homer,gerard,doug,kenny,hubert,angelo,shaun,lyle,matt,alfonso,orlando,rex,carlton,ernesto,pablo,lorenzo,omar,wilbur,blake,horace,roderick,kerry,abraham,rickey,ira,andres,cesar,johnathan,malcolm,rudolph,damon,kelvin,rudy,preston,alton,archie,marco,pete,randolph,garry,geoffrey,jonathon,felipe,bennie,gerardo,dominic,loren,delbert,colin,guillermo,earnest,benny,noel,rodolfo,myron,edmund,salvatore,cedric,lowell,gregg,sherman,devin,sylvester,roosevelt,israel,jermaine,forrest,wilbert,leland,simon,irving,owen,rufus,woodrow,sammy,kristopher,levi,marcos,gustavo,jake,lionel,marty,gilberto,clint,nicolas,laurence,ismael,orville,drew,ervin,dewey,wilfred,josh,hugo,ignacio,caleb,tomas,sheldon,erick,frankie,darrel,rogelio,terence,alonzo,elias,bert,elbert,ramiro,conrad,noah,grady,phil,cornelius,lamar,rolando,clay,percy,bradford,merle,darin,amos,terrell,moses,irvin,saul,roman,darnell,randal,tommie,timmy,darrin,brendan,toby,van,abel,dominick,emilio,elijah,cary,domingo,aubrey,emmett,marlon,emanuel,jerald,edmond,emil,dewayne,otto,teddy,reynaldo,bret,jess,trent,humberto,emmanuel,stephan,louie,vicente,lamont,garland,micah,efrain,heath,rodger,demetrius,ethan,eldon,rocky,pierre,eli,bryce,antoine,robbie,kendall,royce,sterling,grover,elton,cleveland,dylan,chuck,damian,reuben,stan,leonardo,russel,erwin,benito,hans,monte,blaine,ernie,curt,quentin,agustin,jamal,devon,adolfo,tyson,wilfredo,bart,jarrod,vance,denis,damien,joaquin,harlan,desmond,elliot,darwin,gregorio,kermit,roscoe,esteban,anton,solomon,norbert,elvin,nolan,carey,rod,quinton,hal,brain,rob,elwood,kendrick,darius,moises,marlin,fidel,thaddeus,cliff,marcel,ali,raphael,bryon,armand,alvaro,jeffry,dane,joesph,thurman,ned,sammie,rusty,michel,monty,rory,fabian,reggie,kris,isaiah,gus,avery,loyd,diego,adolph,millard,rocco,gonzalo,derick,rodrigo,gerry,rigoberto,alphonso,rickie,noe,vern,elvis,bernardo,mauricio,hiram,donovan,basil,nickolas,scot,vince,quincy,eddy,sebastian,federico,ulysses,heriberto,donnell,denny,gavin,emery,romeo,jayson,dion,dante,clement,coy,odell,jarvis,bruno,issac,dudley,sanford,colby,carmelo,nestor,hollis,stefan,donny,linwood,beau,weldon,galen,isidro,truman,delmar,johnathon,silas,frederic,irwin,merrill,charley,marcelino,carlo,trenton,kurtis,aurelio,winfred,vito,collin,denver,leonel,emory,pasquale,mohammad,mariano,danial,landon,dirk,branden,adan,numbers,clair,buford,bernie,wilmer,emerson,zachery,jacques,errol,josue,edwardo,wilford,theron,raymundo,daren,tristan,robby,lincoln,jame,genaro,octavio,cornell,hung,arron,antony,herschel,alva,giovanni,garth,cyrus,cyril,ronny,stevie,lon,kennith,carmine,augustine,erich,chadwick,wilburn,russ,myles,jonas,mitchel,mervin,zane,jamel,lazaro,alphonse,randell,johnie,jarrett,ariel,abdul,dusty,luciano,seymour,scottie,eugenio,mohammed,arnulfo,lucien,ferdinand,thad,ezra,aldo,rubin,mitch,earle,abe,marquis,lanny,kareem,jamar,boris,isiah,emile,elmo,aron,leopoldo,everette,josef,eloy,dorian,rodrick,reinaldo,lucio,jerrod,weston,hershel,lemuel,lavern,burt,jules,gil,eliseo,ahmad,nigel,efren,antwan,alden,margarito,refugio,dino,osvaldo,les,deandre,normand,kieth,ivory,trey,norberto,napoleon,jerold,fritz,rosendo,milford,sang,deon,christoper,alfonzo,lyman,josiah,brant,wilton,rico,jamaal,dewitt,brenton,yong,olin,faustino,claudio,judson,gino,edgardo,alec,jarred,donn,trinidad,tad,porfirio,odis,lenard,chauncey,tod,mel,marcelo,kory,augustus,keven,hilario,bud,sal,orval,mauro,dannie,zachariah,olen,anibal,milo,jed,thanh,amado,lenny,tory,richie,horacio,brice,mohamed,delmer,dario,mac,jonah,jerrold,robt,hank,sung,rupert,rolland,kenton,damion,chi,antone,waldo,fredric,bradly,kip,burl,tyree,jefferey,ahmed,willy,stanford,oren,moshe,mikel,enoch,brendon,quintin,jamison,florencio,darrick,tobias,minh,hassan,giuseppe,demarcus,cletus,tyrell,lyndon,keenan,werner,theo,geraldo,columbus,chet,bertram,markus,huey,hilton,dwain,donte,tyron,omer,isaias,hipolito,fermin,chung,adalberto,jamey,teodoro,mckinley,maximo,raleigh,lawerence,abram,rashad,emmitt,daron,chong,samual,otha,miquel,eusebio,dong,domenic,darron,wilber,renato,hoyt,haywood,ezekiel,chas,florentino,elroy,clemente,arden,neville,edison,deshawn,carrol,shayne,nathanial,jordon,danilo,claud,sherwood,raymon,rayford,cristobal,ambrose,titus,hyman,felton,ezequiel,erasmo,lonny,milan,lino,jarod,herb,andreas,rhett,jude,douglass,cordell,oswaldo,ellsworth,virgilio,toney,nathanael,benedict,mose,hong,isreal,garret,fausto,arlen,zack,modesto,francesco,manual,gaylord,gaston,filiberto,deangelo,michale,granville,malik,zackary,tuan,nicky,cristopher,antione,malcom,korey,jospeh,colton,waylon,hosea,shad,santo,rudolf,rolf,renaldo,marcellus,lucius,kristofer,harland,arnoldo,rueben,leandro,kraig,jerrell,jeromy,hobert,cedrick,arlie,winford,wally,luigi,keneth,jacinto,graig,franklyn,edmundo,leif,jeramy,willian,vincenzo,shon,michal,lynwood,jere,elden,darell,broderick,alonso".split(",")
}, $70ee3d84ec5f3050$var$adjacency_graphs_1 = $70ee3d84ec5f3050$var$adjacency_graphs = {
    qwerty: {
        "!": [
            "`~",
            null,
            null,
            "2@",
            "qQ",
            null
        ],
        '"': [
            ";:",
            "[{",
            "]}",
            null,
            null,
            "/?"
        ],
        "#": [
            "2@",
            null,
            null,
            "4$",
            "eE",
            "wW"
        ],
        $: [
            "3#",
            null,
            null,
            "5%",
            "rR",
            "eE"
        ],
        "%": [
            "4$",
            null,
            null,
            "6^",
            "tT",
            "rR"
        ],
        "&": [
            "6^",
            null,
            null,
            "8*",
            "uU",
            "yY"
        ],
        "'": [
            ";:",
            "[{",
            "]}",
            null,
            null,
            "/?"
        ],
        "(": [
            "8*",
            null,
            null,
            "0)",
            "oO",
            "iI"
        ],
        ")": [
            "9(",
            null,
            null,
            "-_",
            "pP",
            "oO"
        ],
        "*": [
            "7&",
            null,
            null,
            "9(",
            "iI",
            "uU"
        ],
        "+": [
            "-_",
            null,
            null,
            null,
            "]}",
            "[{"
        ],
        ",": [
            "mM",
            "kK",
            "lL",
            ".>",
            null,
            null
        ],
        "-": [
            "0)",
            null,
            null,
            "=+",
            "[{",
            "pP"
        ],
        ".": [
            ",<",
            "lL",
            ";:",
            "/?",
            null,
            null
        ],
        "/": [
            ".>",
            ";:",
            "'\"",
            null,
            null,
            null
        ],
        0: [
            "9(",
            null,
            null,
            "-_",
            "pP",
            "oO"
        ],
        1: [
            "`~",
            null,
            null,
            "2@",
            "qQ",
            null
        ],
        2: [
            "1!",
            null,
            null,
            "3#",
            "wW",
            "qQ"
        ],
        3: [
            "2@",
            null,
            null,
            "4$",
            "eE",
            "wW"
        ],
        4: [
            "3#",
            null,
            null,
            "5%",
            "rR",
            "eE"
        ],
        5: [
            "4$",
            null,
            null,
            "6^",
            "tT",
            "rR"
        ],
        6: [
            "5%",
            null,
            null,
            "7&",
            "yY",
            "tT"
        ],
        7: [
            "6^",
            null,
            null,
            "8*",
            "uU",
            "yY"
        ],
        8: [
            "7&",
            null,
            null,
            "9(",
            "iI",
            "uU"
        ],
        9: [
            "8*",
            null,
            null,
            "0)",
            "oO",
            "iI"
        ],
        ":": [
            "lL",
            "pP",
            "[{",
            "'\"",
            "/?",
            ".>"
        ],
        ";": [
            "lL",
            "pP",
            "[{",
            "'\"",
            "/?",
            ".>"
        ],
        "<": [
            "mM",
            "kK",
            "lL",
            ".>",
            null,
            null
        ],
        "=": [
            "-_",
            null,
            null,
            null,
            "]}",
            "[{"
        ],
        ">": [
            ",<",
            "lL",
            ";:",
            "/?",
            null,
            null
        ],
        "?": [
            ".>",
            ";:",
            "'\"",
            null,
            null,
            null
        ],
        "@": [
            "1!",
            null,
            null,
            "3#",
            "wW",
            "qQ"
        ],
        A: [
            null,
            "qQ",
            "wW",
            "sS",
            "zZ",
            null
        ],
        B: [
            "vV",
            "gG",
            "hH",
            "nN",
            null,
            null
        ],
        C: [
            "xX",
            "dD",
            "fF",
            "vV",
            null,
            null
        ],
        D: [
            "sS",
            "eE",
            "rR",
            "fF",
            "cC",
            "xX"
        ],
        E: [
            "wW",
            "3#",
            "4$",
            "rR",
            "dD",
            "sS"
        ],
        F: [
            "dD",
            "rR",
            "tT",
            "gG",
            "vV",
            "cC"
        ],
        G: [
            "fF",
            "tT",
            "yY",
            "hH",
            "bB",
            "vV"
        ],
        H: [
            "gG",
            "yY",
            "uU",
            "jJ",
            "nN",
            "bB"
        ],
        I: [
            "uU",
            "8*",
            "9(",
            "oO",
            "kK",
            "jJ"
        ],
        J: [
            "hH",
            "uU",
            "iI",
            "kK",
            "mM",
            "nN"
        ],
        K: [
            "jJ",
            "iI",
            "oO",
            "lL",
            ",<",
            "mM"
        ],
        L: [
            "kK",
            "oO",
            "pP",
            ";:",
            ".>",
            ",<"
        ],
        M: [
            "nN",
            "jJ",
            "kK",
            ",<",
            null,
            null
        ],
        N: [
            "bB",
            "hH",
            "jJ",
            "mM",
            null,
            null
        ],
        O: [
            "iI",
            "9(",
            "0)",
            "pP",
            "lL",
            "kK"
        ],
        P: [
            "oO",
            "0)",
            "-_",
            "[{",
            ";:",
            "lL"
        ],
        Q: [
            null,
            "1!",
            "2@",
            "wW",
            "aA",
            null
        ],
        R: [
            "eE",
            "4$",
            "5%",
            "tT",
            "fF",
            "dD"
        ],
        S: [
            "aA",
            "wW",
            "eE",
            "dD",
            "xX",
            "zZ"
        ],
        T: [
            "rR",
            "5%",
            "6^",
            "yY",
            "gG",
            "fF"
        ],
        U: [
            "yY",
            "7&",
            "8*",
            "iI",
            "jJ",
            "hH"
        ],
        V: [
            "cC",
            "fF",
            "gG",
            "bB",
            null,
            null
        ],
        W: [
            "qQ",
            "2@",
            "3#",
            "eE",
            "sS",
            "aA"
        ],
        X: [
            "zZ",
            "sS",
            "dD",
            "cC",
            null,
            null
        ],
        Y: [
            "tT",
            "6^",
            "7&",
            "uU",
            "hH",
            "gG"
        ],
        Z: [
            null,
            "aA",
            "sS",
            "xX",
            null,
            null
        ],
        "[": [
            "pP",
            "-_",
            "=+",
            "]}",
            "'\"",
            ";:"
        ],
        "\\": [
            "]}",
            null,
            null,
            null,
            null,
            null
        ],
        "]": [
            "[{",
            "=+",
            null,
            "\\|",
            null,
            "'\""
        ],
        "^": [
            "5%",
            null,
            null,
            "7&",
            "yY",
            "tT"
        ],
        _: [
            "0)",
            null,
            null,
            "=+",
            "[{",
            "pP"
        ],
        "`": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ],
        a: [
            null,
            "qQ",
            "wW",
            "sS",
            "zZ",
            null
        ],
        b: [
            "vV",
            "gG",
            "hH",
            "nN",
            null,
            null
        ],
        c: [
            "xX",
            "dD",
            "fF",
            "vV",
            null,
            null
        ],
        d: [
            "sS",
            "eE",
            "rR",
            "fF",
            "cC",
            "xX"
        ],
        e: [
            "wW",
            "3#",
            "4$",
            "rR",
            "dD",
            "sS"
        ],
        f: [
            "dD",
            "rR",
            "tT",
            "gG",
            "vV",
            "cC"
        ],
        g: [
            "fF",
            "tT",
            "yY",
            "hH",
            "bB",
            "vV"
        ],
        h: [
            "gG",
            "yY",
            "uU",
            "jJ",
            "nN",
            "bB"
        ],
        i: [
            "uU",
            "8*",
            "9(",
            "oO",
            "kK",
            "jJ"
        ],
        j: [
            "hH",
            "uU",
            "iI",
            "kK",
            "mM",
            "nN"
        ],
        k: [
            "jJ",
            "iI",
            "oO",
            "lL",
            ",<",
            "mM"
        ],
        l: [
            "kK",
            "oO",
            "pP",
            ";:",
            ".>",
            ",<"
        ],
        m: [
            "nN",
            "jJ",
            "kK",
            ",<",
            null,
            null
        ],
        n: [
            "bB",
            "hH",
            "jJ",
            "mM",
            null,
            null
        ],
        o: [
            "iI",
            "9(",
            "0)",
            "pP",
            "lL",
            "kK"
        ],
        p: [
            "oO",
            "0)",
            "-_",
            "[{",
            ";:",
            "lL"
        ],
        q: [
            null,
            "1!",
            "2@",
            "wW",
            "aA",
            null
        ],
        r: [
            "eE",
            "4$",
            "5%",
            "tT",
            "fF",
            "dD"
        ],
        s: [
            "aA",
            "wW",
            "eE",
            "dD",
            "xX",
            "zZ"
        ],
        t: [
            "rR",
            "5%",
            "6^",
            "yY",
            "gG",
            "fF"
        ],
        u: [
            "yY",
            "7&",
            "8*",
            "iI",
            "jJ",
            "hH"
        ],
        v: [
            "cC",
            "fF",
            "gG",
            "bB",
            null,
            null
        ],
        w: [
            "qQ",
            "2@",
            "3#",
            "eE",
            "sS",
            "aA"
        ],
        x: [
            "zZ",
            "sS",
            "dD",
            "cC",
            null,
            null
        ],
        y: [
            "tT",
            "6^",
            "7&",
            "uU",
            "hH",
            "gG"
        ],
        z: [
            null,
            "aA",
            "sS",
            "xX",
            null,
            null
        ],
        "{": [
            "pP",
            "-_",
            "=+",
            "]}",
            "'\"",
            ";:"
        ],
        "|": [
            "]}",
            null,
            null,
            null,
            null,
            null
        ],
        "}": [
            "[{",
            "=+",
            null,
            "\\|",
            null,
            "'\""
        ],
        "~": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ]
    },
    dvorak: {
        "!": [
            "`~",
            null,
            null,
            "2@",
            "'\"",
            null
        ],
        '"': [
            null,
            "1!",
            "2@",
            ",<",
            "aA",
            null
        ],
        "#": [
            "2@",
            null,
            null,
            "4$",
            ".>",
            ",<"
        ],
        $: [
            "3#",
            null,
            null,
            "5%",
            "pP",
            ".>"
        ],
        "%": [
            "4$",
            null,
            null,
            "6^",
            "yY",
            "pP"
        ],
        "&": [
            "6^",
            null,
            null,
            "8*",
            "gG",
            "fF"
        ],
        "'": [
            null,
            "1!",
            "2@",
            ",<",
            "aA",
            null
        ],
        "(": [
            "8*",
            null,
            null,
            "0)",
            "rR",
            "cC"
        ],
        ")": [
            "9(",
            null,
            null,
            "[{",
            "lL",
            "rR"
        ],
        "*": [
            "7&",
            null,
            null,
            "9(",
            "cC",
            "gG"
        ],
        "+": [
            "/?",
            "]}",
            null,
            "\\|",
            null,
            "-_"
        ],
        ",": [
            "'\"",
            "2@",
            "3#",
            ".>",
            "oO",
            "aA"
        ],
        "-": [
            "sS",
            "/?",
            "=+",
            null,
            null,
            "zZ"
        ],
        ".": [
            ",<",
            "3#",
            "4$",
            "pP",
            "eE",
            "oO"
        ],
        "/": [
            "lL",
            "[{",
            "]}",
            "=+",
            "-_",
            "sS"
        ],
        0: [
            "9(",
            null,
            null,
            "[{",
            "lL",
            "rR"
        ],
        1: [
            "`~",
            null,
            null,
            "2@",
            "'\"",
            null
        ],
        2: [
            "1!",
            null,
            null,
            "3#",
            ",<",
            "'\""
        ],
        3: [
            "2@",
            null,
            null,
            "4$",
            ".>",
            ",<"
        ],
        4: [
            "3#",
            null,
            null,
            "5%",
            "pP",
            ".>"
        ],
        5: [
            "4$",
            null,
            null,
            "6^",
            "yY",
            "pP"
        ],
        6: [
            "5%",
            null,
            null,
            "7&",
            "fF",
            "yY"
        ],
        7: [
            "6^",
            null,
            null,
            "8*",
            "gG",
            "fF"
        ],
        8: [
            "7&",
            null,
            null,
            "9(",
            "cC",
            "gG"
        ],
        9: [
            "8*",
            null,
            null,
            "0)",
            "rR",
            "cC"
        ],
        ":": [
            null,
            "aA",
            "oO",
            "qQ",
            null,
            null
        ],
        ";": [
            null,
            "aA",
            "oO",
            "qQ",
            null,
            null
        ],
        "<": [
            "'\"",
            "2@",
            "3#",
            ".>",
            "oO",
            "aA"
        ],
        "=": [
            "/?",
            "]}",
            null,
            "\\|",
            null,
            "-_"
        ],
        ">": [
            ",<",
            "3#",
            "4$",
            "pP",
            "eE",
            "oO"
        ],
        "?": [
            "lL",
            "[{",
            "]}",
            "=+",
            "-_",
            "sS"
        ],
        "@": [
            "1!",
            null,
            null,
            "3#",
            ",<",
            "'\""
        ],
        A: [
            null,
            "'\"",
            ",<",
            "oO",
            ";:",
            null
        ],
        B: [
            "xX",
            "dD",
            "hH",
            "mM",
            null,
            null
        ],
        C: [
            "gG",
            "8*",
            "9(",
            "rR",
            "tT",
            "hH"
        ],
        D: [
            "iI",
            "fF",
            "gG",
            "hH",
            "bB",
            "xX"
        ],
        E: [
            "oO",
            ".>",
            "pP",
            "uU",
            "jJ",
            "qQ"
        ],
        F: [
            "yY",
            "6^",
            "7&",
            "gG",
            "dD",
            "iI"
        ],
        G: [
            "fF",
            "7&",
            "8*",
            "cC",
            "hH",
            "dD"
        ],
        H: [
            "dD",
            "gG",
            "cC",
            "tT",
            "mM",
            "bB"
        ],
        I: [
            "uU",
            "yY",
            "fF",
            "dD",
            "xX",
            "kK"
        ],
        J: [
            "qQ",
            "eE",
            "uU",
            "kK",
            null,
            null
        ],
        K: [
            "jJ",
            "uU",
            "iI",
            "xX",
            null,
            null
        ],
        L: [
            "rR",
            "0)",
            "[{",
            "/?",
            "sS",
            "nN"
        ],
        M: [
            "bB",
            "hH",
            "tT",
            "wW",
            null,
            null
        ],
        N: [
            "tT",
            "rR",
            "lL",
            "sS",
            "vV",
            "wW"
        ],
        O: [
            "aA",
            ",<",
            ".>",
            "eE",
            "qQ",
            ";:"
        ],
        P: [
            ".>",
            "4$",
            "5%",
            "yY",
            "uU",
            "eE"
        ],
        Q: [
            ";:",
            "oO",
            "eE",
            "jJ",
            null,
            null
        ],
        R: [
            "cC",
            "9(",
            "0)",
            "lL",
            "nN",
            "tT"
        ],
        S: [
            "nN",
            "lL",
            "/?",
            "-_",
            "zZ",
            "vV"
        ],
        T: [
            "hH",
            "cC",
            "rR",
            "nN",
            "wW",
            "mM"
        ],
        U: [
            "eE",
            "pP",
            "yY",
            "iI",
            "kK",
            "jJ"
        ],
        V: [
            "wW",
            "nN",
            "sS",
            "zZ",
            null,
            null
        ],
        W: [
            "mM",
            "tT",
            "nN",
            "vV",
            null,
            null
        ],
        X: [
            "kK",
            "iI",
            "dD",
            "bB",
            null,
            null
        ],
        Y: [
            "pP",
            "5%",
            "6^",
            "fF",
            "iI",
            "uU"
        ],
        Z: [
            "vV",
            "sS",
            "-_",
            null,
            null,
            null
        ],
        "[": [
            "0)",
            null,
            null,
            "]}",
            "/?",
            "lL"
        ],
        "\\": [
            "=+",
            null,
            null,
            null,
            null,
            null
        ],
        "]": [
            "[{",
            null,
            null,
            null,
            "=+",
            "/?"
        ],
        "^": [
            "5%",
            null,
            null,
            "7&",
            "fF",
            "yY"
        ],
        _: [
            "sS",
            "/?",
            "=+",
            null,
            null,
            "zZ"
        ],
        "`": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ],
        a: [
            null,
            "'\"",
            ",<",
            "oO",
            ";:",
            null
        ],
        b: [
            "xX",
            "dD",
            "hH",
            "mM",
            null,
            null
        ],
        c: [
            "gG",
            "8*",
            "9(",
            "rR",
            "tT",
            "hH"
        ],
        d: [
            "iI",
            "fF",
            "gG",
            "hH",
            "bB",
            "xX"
        ],
        e: [
            "oO",
            ".>",
            "pP",
            "uU",
            "jJ",
            "qQ"
        ],
        f: [
            "yY",
            "6^",
            "7&",
            "gG",
            "dD",
            "iI"
        ],
        g: [
            "fF",
            "7&",
            "8*",
            "cC",
            "hH",
            "dD"
        ],
        h: [
            "dD",
            "gG",
            "cC",
            "tT",
            "mM",
            "bB"
        ],
        i: [
            "uU",
            "yY",
            "fF",
            "dD",
            "xX",
            "kK"
        ],
        j: [
            "qQ",
            "eE",
            "uU",
            "kK",
            null,
            null
        ],
        k: [
            "jJ",
            "uU",
            "iI",
            "xX",
            null,
            null
        ],
        l: [
            "rR",
            "0)",
            "[{",
            "/?",
            "sS",
            "nN"
        ],
        m: [
            "bB",
            "hH",
            "tT",
            "wW",
            null,
            null
        ],
        n: [
            "tT",
            "rR",
            "lL",
            "sS",
            "vV",
            "wW"
        ],
        o: [
            "aA",
            ",<",
            ".>",
            "eE",
            "qQ",
            ";:"
        ],
        p: [
            ".>",
            "4$",
            "5%",
            "yY",
            "uU",
            "eE"
        ],
        q: [
            ";:",
            "oO",
            "eE",
            "jJ",
            null,
            null
        ],
        r: [
            "cC",
            "9(",
            "0)",
            "lL",
            "nN",
            "tT"
        ],
        s: [
            "nN",
            "lL",
            "/?",
            "-_",
            "zZ",
            "vV"
        ],
        t: [
            "hH",
            "cC",
            "rR",
            "nN",
            "wW",
            "mM"
        ],
        u: [
            "eE",
            "pP",
            "yY",
            "iI",
            "kK",
            "jJ"
        ],
        v: [
            "wW",
            "nN",
            "sS",
            "zZ",
            null,
            null
        ],
        w: [
            "mM",
            "tT",
            "nN",
            "vV",
            null,
            null
        ],
        x: [
            "kK",
            "iI",
            "dD",
            "bB",
            null,
            null
        ],
        y: [
            "pP",
            "5%",
            "6^",
            "fF",
            "iI",
            "uU"
        ],
        z: [
            "vV",
            "sS",
            "-_",
            null,
            null,
            null
        ],
        "{": [
            "0)",
            null,
            null,
            "]}",
            "/?",
            "lL"
        ],
        "|": [
            "=+",
            null,
            null,
            null,
            null,
            null
        ],
        "}": [
            "[{",
            null,
            null,
            null,
            "=+",
            "/?"
        ],
        "~": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ]
    },
    keypad: {
        "*": [
            "/",
            null,
            null,
            null,
            "-",
            "+",
            "9",
            "8"
        ],
        "+": [
            "9",
            "*",
            "-",
            null,
            null,
            null,
            null,
            "6"
        ],
        "-": [
            "*",
            null,
            null,
            null,
            null,
            null,
            "+",
            "9"
        ],
        ".": [
            "0",
            "2",
            "3",
            null,
            null,
            null,
            null,
            null
        ],
        "/": [
            null,
            null,
            null,
            null,
            "*",
            "9",
            "8",
            "7"
        ],
        0: [
            null,
            "1",
            "2",
            "3",
            ".",
            null,
            null,
            null
        ],
        1: [
            null,
            null,
            "4",
            "5",
            "2",
            "0",
            null,
            null
        ],
        2: [
            "1",
            "4",
            "5",
            "6",
            "3",
            ".",
            "0",
            null
        ],
        3: [
            "2",
            "5",
            "6",
            null,
            null,
            null,
            ".",
            "0"
        ],
        4: [
            null,
            null,
            "7",
            "8",
            "5",
            "2",
            "1",
            null
        ],
        5: [
            "4",
            "7",
            "8",
            "9",
            "6",
            "3",
            "2",
            "1"
        ],
        6: [
            "5",
            "8",
            "9",
            "+",
            null,
            null,
            "3",
            "2"
        ],
        7: [
            null,
            null,
            null,
            "/",
            "8",
            "5",
            "4",
            null
        ],
        8: [
            "7",
            null,
            "/",
            "*",
            "9",
            "6",
            "5",
            "4"
        ],
        9: [
            "8",
            "/",
            "*",
            "-",
            "+",
            null,
            "6",
            "5"
        ]
    },
    mac_keypad: {
        "*": [
            "/",
            null,
            null,
            null,
            null,
            null,
            "-",
            "9"
        ],
        "+": [
            "6",
            "9",
            "-",
            null,
            null,
            null,
            null,
            "3"
        ],
        "-": [
            "9",
            "/",
            "*",
            null,
            null,
            null,
            "+",
            "6"
        ],
        ".": [
            "0",
            "2",
            "3",
            null,
            null,
            null,
            null,
            null
        ],
        "/": [
            "=",
            null,
            null,
            null,
            "*",
            "-",
            "9",
            "8"
        ],
        0: [
            null,
            "1",
            "2",
            "3",
            ".",
            null,
            null,
            null
        ],
        1: [
            null,
            null,
            "4",
            "5",
            "2",
            "0",
            null,
            null
        ],
        2: [
            "1",
            "4",
            "5",
            "6",
            "3",
            ".",
            "0",
            null
        ],
        3: [
            "2",
            "5",
            "6",
            "+",
            null,
            null,
            ".",
            "0"
        ],
        4: [
            null,
            null,
            "7",
            "8",
            "5",
            "2",
            "1",
            null
        ],
        5: [
            "4",
            "7",
            "8",
            "9",
            "6",
            "3",
            "2",
            "1"
        ],
        6: [
            "5",
            "8",
            "9",
            "-",
            "+",
            null,
            "3",
            "2"
        ],
        7: [
            null,
            null,
            null,
            "=",
            "8",
            "5",
            "4",
            null
        ],
        8: [
            "7",
            null,
            "=",
            "/",
            "9",
            "6",
            "5",
            "4"
        ],
        9: [
            "8",
            "=",
            "/",
            "*",
            "-",
            "+",
            "6",
            "5"
        ],
        "=": [
            null,
            null,
            null,
            null,
            "/",
            "9",
            "8",
            "7"
        ]
    }
};
$70ee3d84ec5f3050$var$adjacency_graphs$1 = $70ee3d84ec5f3050$var$adjacency_graphs_1, $70ee3d84ec5f3050$var$calc_average_degree = function(a) {
    var e, i, r, n, s;
    for(r in e = 0, a)s = a[r], e += function() {
        var e, a, i;
        for(i = [], a = 0, e = s.length; a < e; a++)(n = s[a]) && i.push(n);
        return i;
    }().length;
    return e /= function() {
        var e;
        for(i in e = [], a)a[i], e.push(i);
        return e;
    }().length;
}, $70ee3d84ec5f3050$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE = 1e4, $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR = $70ee3d84ec5f3050$var$BRUTEFORCE_CARDINALITY = 10, $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR = 50;
var $70ee3d84ec5f3050$var$DATE_MAX_YEAR, $70ee3d84ec5f3050$var$DATE_MIN_YEAR, $70ee3d84ec5f3050$var$DATE_SPLITS, $70ee3d84ec5f3050$var$GRAPHS, $70ee3d84ec5f3050$var$L33T_TABLE, $70ee3d84ec5f3050$var$RANKED_DICTIONARIES, $70ee3d84ec5f3050$var$REGEXEN, $70ee3d84ec5f3050$var$adjacency_graphs$2, $70ee3d84ec5f3050$var$build_ranked_dict, $70ee3d84ec5f3050$var$frequency_lists$1, $70ee3d84ec5f3050$var$lst, $70ee3d84ec5f3050$var$matching, $70ee3d84ec5f3050$var$name, $70ee3d84ec5f3050$var$scoring$1, $70ee3d84ec5f3050$var$scoring_1 = $70ee3d84ec5f3050$var$scoring = {
    nCk: function(e, a) {
        var i, r, n, s;
        if (e < a) return 0;
        if (0 === a) return 1;
        for(i = r = n = 1, s = a; 1 <= s ? r <= s : s <= r; i = 1 <= s ? ++r : --r)n *= e, n /= i, e -= 1;
        return n;
    },
    log10: function(e) {
        return Math.log(e) / Math.log(10);
    },
    log2: function(e) {
        return Math.log(e) / Math.log(2);
    },
    factorial: function(e) {
        var a, i, r, n;
        if (e < 2) return 1;
        for(a = 1, i = r = 2, n = e; 2 <= n ? r <= n : n <= r; i = 2 <= n ? ++r : --r)a *= i;
        return a;
    },
    most_guessable_match_sequence: function(l, e, c) {
        var a, i, r, n, s, o, t, d, m, u, h, g, p, b, y, k, f, v, w, z, j, x, q;
        for(null == c && (c = !1), h = l.length, u = function() {
            var e, a, i;
            for(i = [], e = 0, a = h; 0 <= a ? e < a : a < e; 0 <= a ? ++e : --e)i.push([]);
            return i;
        }(), g = 0, s = e.length; g < s; g++)u[(d = e[g]).j].push(d);
        for(k = 0, o = u.length; k < o; k++)u[k].sort(function(e, a) {
            return e.i - a.i;
        });
        for(p = {
            m: function() {
                var e, a, i;
                for(a = [], i = 0, e = h; 0 <= e ? i < e : e < i; 0 <= e ? ++i : --i)a.push({});
                return a;
            }(),
            pi: function() {
                var e, a, i;
                for(a = [], i = 0, e = h; 0 <= e ? i < e : e < i; 0 <= e ? ++i : --i)a.push({});
                return a;
            }(),
            g: function() {
                var e, a, i;
                for(a = [], i = 0, e = h; 0 <= e ? i < e : e < i; 0 <= e ? ++i : --i)a.push({});
                return a;
            }()
        }, q = this, j = function(e, a) {
            var i, r, n, s, o, t;
            for(r in s = e.j, o = q.estimate_guesses(e, l), 1 < a && (o *= p.pi[e.i - 1][a - 1]), n = q.factorial(a) * o, c || (n += Math.pow($70ee3d84ec5f3050$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE, a - 1)), t = p.g[s])if (i = t[r], !(a < r) && i <= n) return;
            return p.g[s][a] = n, p.m[s][a] = e, p.pi[s][a] = o;
        }, a = function(e) {
            var i, r, n, a, s, o;
            for(d = m(0, e), j(d, 1), s = [], i = o = 1, a = e; 1 <= a ? o <= a : a <= o; i = 1 <= a ? ++o : --o)d = m(i, e), s.push(function() {
                var e, a;
                for(r in a = [], e = p.m[i - 1])n = e[r], r = parseInt(r), "bruteforce" !== n.pattern && a.push(j(d, r + 1));
                return a;
            }());
            return s;
        }, m = function(e, a) {
            return {
                pattern: "bruteforce",
                token: l.slice(e, +a + 1 || 9e9),
                i: e,
                j: a
            };
        }, z = function(e) {
            var a, i, r, n, s, o, t;
            for(i in o = [], n = e - 1, s = void 0, r = 1 / 0, t = p.g[n])(a = t[i]) < r && (s = i, r = a);
            for(; 0 <= n;)d = p.m[n][s], o.unshift(d), n = d.i - 1, s--;
            return o;
        }, r = w = 0, f = h; 0 <= f ? w < f : f < w; r = 0 <= f ? ++w : --w){
            for(x = 0, t = (v = u[r]).length; x < t; x++)if (0 < (d = v[x]).i) for(n in p.m[d.i - 1])n = parseInt(n), j(d, n + 1);
            else j(d, 1);
            a(r);
        }
        return b = (y = z(h)).length, i = 0 === l.length ? 1 : p.g[h - 1][b], {
            password: l,
            guesses: i,
            guesses_log10: this.log10(i),
            sequence: y
        };
    },
    estimate_guesses: function(e, a) {
        var i, r;
        return null != e.guesses || (r = 1, e.token.length < a.length && (r = 1 === e.token.length ? $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR : $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR), i = ({
            bruteforce: this.bruteforce_guesses,
            dictionary: this.dictionary_guesses,
            spatial: this.spatial_guesses,
            repeat: this.repeat_guesses,
            sequence: this.sequence_guesses,
            regex: this.regex_guesses,
            date: this.date_guesses
        })[e.pattern].call(this, e), e.guesses = Math.max(i, r), e.guesses_log10 = this.log10(e.guesses)), e.guesses;
    },
    bruteforce_guesses: function(e) {
        var a, i;
        return (a = Math.pow($70ee3d84ec5f3050$var$BRUTEFORCE_CARDINALITY, e.token.length)) === Number.POSITIVE_INFINITY && (a = Number.MAX_VALUE), i = 1 === e.token.length ? $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR + 1 : $70ee3d84ec5f3050$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR + 1, Math.max(a, i);
    },
    repeat_guesses: function(e) {
        return e.base_guesses * e.repeat_count;
    },
    sequence_guesses: function(e) {
        var a, i;
        return a = "a" === (i = e.token.charAt(0)) || "A" === i || "z" === i || "Z" === i || "0" === i || "1" === i || "9" === i ? 4 : i.match(/\d/) ? 10 : 26, e.ascending || (a *= 2), a * e.token.length;
    },
    MIN_YEAR_SPACE: 20,
    REFERENCE_YEAR: (new Date).getFullYear(),
    regex_guesses: function(e) {
        var a, i;
        if (a = {
            alpha_lower: 26,
            alpha_upper: 26,
            alpha: 52,
            alphanumeric: 62,
            digits: 10,
            symbols: 33
        }, e.regex_name in a) return Math.pow(a[e.regex_name], e.token.length);
        switch(e.regex_name){
            case "recent_year":
                return i = Math.abs(parseInt(e.regex_match[0]) - this.REFERENCE_YEAR), i = Math.max(i, this.MIN_YEAR_SPACE);
        }
    },
    date_guesses: function(e) {
        var a;
        return a = 365 * Math.max(Math.abs(e.year - this.REFERENCE_YEAR), this.MIN_YEAR_SPACE), e.separator && (a *= 4), a;
    },
    KEYBOARD_AVERAGE_DEGREE: $70ee3d84ec5f3050$var$calc_average_degree($70ee3d84ec5f3050$var$adjacency_graphs$1.qwerty),
    KEYPAD_AVERAGE_DEGREE: $70ee3d84ec5f3050$var$calc_average_degree($70ee3d84ec5f3050$var$adjacency_graphs$1.keypad),
    KEYBOARD_STARTING_POSITIONS: function() {
        var e, a;
        for($70ee3d84ec5f3050$var$k in a = [], e = $70ee3d84ec5f3050$var$adjacency_graphs$1.qwerty)$70ee3d84ec5f3050$var$v = e[$70ee3d84ec5f3050$var$k], a.push($70ee3d84ec5f3050$var$k);
        return a;
    }().length,
    KEYPAD_STARTING_POSITIONS: function() {
        var e, a;
        for($70ee3d84ec5f3050$var$k in a = [], e = $70ee3d84ec5f3050$var$adjacency_graphs$1.keypad)$70ee3d84ec5f3050$var$v = e[$70ee3d84ec5f3050$var$k], a.push($70ee3d84ec5f3050$var$k);
        return a;
    }().length,
    spatial_guesses: function(e) {
        var a, i, r, n, s, o, t, l, c, d, m, u, h, g, p, b, y;
        for(n = "qwerty" === (d = e.graph) || "dvorak" === d ? (g = this.KEYBOARD_STARTING_POSITIONS, this.KEYBOARD_AVERAGE_DEGREE) : (g = this.KEYPAD_STARTING_POSITIONS, this.KEYPAD_AVERAGE_DEGREE), s = 0, a = e.token.length, b = e.turns, o = l = 2, m = a; 2 <= m ? l <= m : m <= l; o = 2 <= m ? ++l : --l)for(t = c = 1, u = Math.min(b, o - 1); 1 <= u ? c <= u : u <= c; t = 1 <= u ? ++c : --c)s += this.nCk(o - 1, t - 1) * g * Math.pow(n, t);
        if (e.shifted_count) {
            if (i = e.shifted_count, r = e.token.length - e.shifted_count, 0 === i || 0 == r) s *= 2;
            else {
                for(p = 0, o = y = 1, h = Math.min(i, r); 1 <= h ? y <= h : h <= y; o = 1 <= h ? ++y : --y)p += this.nCk(i + r, o);
                s *= p;
            }
        }
        return s;
    },
    dictionary_guesses: function(e) {
        var a;
        return e.base_guesses = e.rank, e.uppercase_variations = this.uppercase_variations(e), e.l33t_variations = this.l33t_variations(e), a = e.reversed ? 2 : 1, e.base_guesses * e.uppercase_variations * e.l33t_variations * a;
    },
    START_UPPER: /^[A-Z][^A-Z]+$/,
    END_UPPER: /^[^A-Z]+[A-Z]$/,
    ALL_UPPER: /^[^a-z]+$/,
    ALL_LOWER: /^[^A-Z]+$/,
    uppercase_variations: function(e) {
        var a, i, n, r, s, o, t, l, c, d, m, u;
        if ((u = e.token).match(this.ALL_LOWER) || u.toLowerCase() === u) return 1;
        for(o = 0, s = (l = [
            this.START_UPPER,
            this.END_UPPER,
            this.ALL_UPPER
        ]).length; o < s; o++)if (d = l[o], u.match(d)) return 2;
        for(i = function() {
            var e, a, i, r;
            for(r = [], a = 0, e = (i = u.split("")).length; a < e; a++)(n = i[a]).match(/[A-Z]/) && r.push(n);
            return r;
        }().length, a = function() {
            var e, a, i, r;
            for(r = [], a = 0, e = (i = u.split("")).length; a < e; a++)(n = i[a]).match(/[a-z]/) && r.push(n);
            return r;
        }().length, m = 0, r = t = 1, c = Math.min(i, a); 1 <= c ? t <= c : c <= t; r = 1 <= c ? ++t : --t)m += this.nCk(i + a, r);
        return m;
    },
    l33t_variations: function(e) {
        var a, i, r, n, s, o, t, l, c, d, m, u;
        if (!e.l33t) return 1;
        for(d in u = 1, l = e.sub)if (m = l[d], n = e.token.toLowerCase().split(""), a = function() {
            var e, a, i;
            for(i = [], a = 0, e = n.length; a < e; a++)(r = n[a]) === d && i.push(r);
            return i;
        }().length, i = function() {
            var e, a, i;
            for(i = [], a = 0, e = n.length; a < e; a++)(r = n[a]) === m && i.push(r);
            return i;
        }().length, 0 === a || 0 === i) u *= 2;
        else {
            for(t = 0, s = o = 1, c = Math.min(i, a); 1 <= c ? o <= c : c <= o; s = 1 <= c ? ++o : --o)t += this.nCk(i + a, s);
            u *= t;
        }
        return u;
    }
};
for($70ee3d84ec5f3050$var$name in $70ee3d84ec5f3050$var$adjacency_graphs$2 = $70ee3d84ec5f3050$var$adjacency_graphs_1, $70ee3d84ec5f3050$var$scoring$1 = $70ee3d84ec5f3050$var$scoring_1, $70ee3d84ec5f3050$var$build_ranked_dict = function(e) {
    var a, i, r, n;
    for(n = {}, a = 1, r = 0, i = e.length; r < i; r++)n[e[r]] = a, a += 1;
    return n;
}, $70ee3d84ec5f3050$var$RANKED_DICTIONARIES = {}, $70ee3d84ec5f3050$var$frequency_lists$1 = $70ee3d84ec5f3050$var$frequency_lists_1)$70ee3d84ec5f3050$var$lst = $70ee3d84ec5f3050$var$frequency_lists$1[$70ee3d84ec5f3050$var$name], $70ee3d84ec5f3050$var$RANKED_DICTIONARIES[$70ee3d84ec5f3050$var$name] = $70ee3d84ec5f3050$var$build_ranked_dict($70ee3d84ec5f3050$var$lst);
$70ee3d84ec5f3050$var$GRAPHS = {
    qwerty: $70ee3d84ec5f3050$var$adjacency_graphs$2.qwerty,
    dvorak: $70ee3d84ec5f3050$var$adjacency_graphs$2.dvorak,
    keypad: $70ee3d84ec5f3050$var$adjacency_graphs$2.keypad,
    mac_keypad: $70ee3d84ec5f3050$var$adjacency_graphs$2.mac_keypad
}, $70ee3d84ec5f3050$var$L33T_TABLE = {
    a: [
        "4",
        "@"
    ],
    b: [
        "8"
    ],
    c: [
        "(",
        "{",
        "[",
        "<"
    ],
    e: [
        "3"
    ],
    g: [
        "6",
        "9"
    ],
    i: [
        "1",
        "!",
        "|"
    ],
    l: [
        "1",
        "|",
        "7"
    ],
    o: [
        "0"
    ],
    s: [
        "$",
        "5"
    ],
    t: [
        "+",
        "7"
    ],
    x: [
        "%"
    ],
    z: [
        "2"
    ]
}, $70ee3d84ec5f3050$var$REGEXEN = {
    recent_year: /19\d\d|200\d|201\d/g
}, $70ee3d84ec5f3050$var$DATE_MAX_YEAR = 2050, $70ee3d84ec5f3050$var$DATE_MIN_YEAR = 1e3, $70ee3d84ec5f3050$var$DATE_SPLITS = {
    4: [
        [
            1,
            2
        ],
        [
            2,
            3
        ]
    ],
    5: [
        [
            1,
            3
        ],
        [
            2,
            3
        ]
    ],
    6: [
        [
            1,
            2
        ],
        [
            2,
            4
        ],
        [
            4,
            5
        ]
    ],
    7: [
        [
            1,
            3
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            4,
            6
        ]
    ],
    8: [
        [
            2,
            4
        ],
        [
            4,
            6
        ]
    ]
};
var $70ee3d84ec5f3050$var$time_estimates, $70ee3d84ec5f3050$var$feedback, $70ee3d84ec5f3050$var$scoring$2, $70ee3d84ec5f3050$var$feedback$1, $70ee3d84ec5f3050$var$matching$1, $70ee3d84ec5f3050$var$scoring$3, $70ee3d84ec5f3050$var$time, $70ee3d84ec5f3050$var$time_estimates$1, $70ee3d84ec5f3050$var$zxcvbn, $70ee3d84ec5f3050$var$matching_1 = $70ee3d84ec5f3050$var$matching = {
    empty: function(a) {
        var i;
        return 0 === function() {
            var e;
            for(i in e = [], a)e.push(i);
            return e;
        }().length;
    },
    extend: function(e, a) {
        return e.push.apply(e, a);
    },
    translate: function(n, s) {
        var o;
        return (function() {
            var e, a, i, r;
            for(r = [], a = 0, e = (i = n.split("")).length; a < e; a++)o = i[a], r.push(s[o] || o);
            return r;
        })().join("");
    },
    mod: function(e, a) {
        return (e % a + a) % a;
    },
    sorted: function(e) {
        return e.sort(function(e, a) {
            return e.i - a.i || e.j - a.j;
        });
    },
    omnimatch: function(e) {
        var a, i, r, n, s;
        for(n = [], s = 0, a = (r = [
            this.dictionary_match,
            this.reverse_dictionary_match,
            this.l33t_match,
            this.spatial_match,
            this.repeat_match,
            this.sequence_match,
            this.regex_match,
            this.date_match
        ]).length; s < a; s++)i = r[s], this.extend(n, i.call(this, e));
        return this.sorted(n);
    },
    dictionary_match: function(e, a) {
        var i, r, n, s, o, t, l, c, d, m, u, h, g, p;
        for(i in null == a && (a = $70ee3d84ec5f3050$var$RANKED_DICTIONARIES), o = [], s = e.length, c = e.toLowerCase(), a)for(m = a[i], r = t = 0, u = s; 0 <= u ? t < u : u < t; r = 0 <= u ? ++t : --t)for(n = l = h = r, g = s; h <= g ? l < g : g < l; n = h <= g ? ++l : --l)c.slice(r, +n + 1 || 9e9) in m && (d = m[p = c.slice(r, +n + 1 || 9e9)], o.push({
            pattern: "dictionary",
            i: r,
            j: n,
            token: e.slice(r, +n + 1 || 9e9),
            matched_word: p,
            rank: d,
            dictionary_name: i,
            reversed: !1,
            l33t: !1
        }));
        return this.sorted(o);
    },
    reverse_dictionary_match: function(e, a) {
        var i, r, n, s, o, t;
        for(null == a && (a = $70ee3d84ec5f3050$var$RANKED_DICTIONARIES), t = e.split("").reverse().join(""), s = 0, i = (n = this.dictionary_match(t, a)).length; s < i; s++)(r = n[s]).token = r.token.split("").reverse().join(""), r.reversed = !0, o = [
            e.length - 1 - r.j,
            e.length - 1 - r.i
        ], r.i = o[0], r.j = o[1];
        return this.sorted(n);
    },
    set_user_input_dictionary: function(e) {
        return $70ee3d84ec5f3050$var$RANKED_DICTIONARIES.user_inputs = $70ee3d84ec5f3050$var$build_ranked_dict(e.slice());
    },
    relevant_l33t_subtable: function(e, a) {
        var i, r, n, s, o, t, l, c, d, m;
        for(o = {}, s = 0, r = (t = e.split("")).length; s < r; s++)i = t[s], o[i] = !0;
        for(n in m = {}, a)d = a[n], 0 < (l = function() {
            var e, a, i;
            for(i = [], a = 0, e = d.length; a < e; a++)(c = d[a]) in o && i.push(c);
            return i;
        }()).length && (m[n] = l);
        return m;
    },
    enumerate_l33t_subs: function(y) {
        var e, k, f, c, a, i, r, n, s, o, t, l, d, m, v;
        for(a = function() {
            var e;
            for(c in e = [], y)e.push(c);
            return e;
        }(), v = [
            []
        ], k = function(e) {
            var r, a, i, n, s, o, t, l;
            for(a = [], s = {}, o = 0, n = e.length; o < n; o++)t = e[o], (r = function() {
                var e, a, i;
                for(i = [], l = a = 0, e = t.length; a < e; l = ++a)c = t[l], i.push([
                    c,
                    l
                ]);
                return i;
            }()).sort(), (i = (function() {
                var e, a, i;
                for(i = [], l = a = 0, e = r.length; a < e; l = ++a)c = r[l], i.push(c + "," + l);
                return i;
            })().join("-")) in s || (s[i] = !0, a.push(t));
            return a;
        }, (f = function(e) {
            var a, i, r, n, s, o, t, l, c, d, m, u, h, g, p, b;
            if (e.length) {
                for(i = e[0], h = e.slice(1), t = [], l = 0, s = (m = y[i]).length; l < s; l++)for(n = m[l], c = 0, o = v.length; c < o; c++){
                    for(a = -1, r = d = 0, u = (g = v[c]).length; 0 <= u ? d < u : u < d; r = 0 <= u ? ++d : --d)if (g[r][0] === n) {
                        a = r;
                        break;
                    }
                    -1 === a ? (b = g.concat([
                        [
                            n,
                            i
                        ]
                    ]), t.push(b)) : ((p = g.slice(0)).splice(a, 1), p.push([
                        n,
                        i
                    ]), t.push(g), t.push(p));
                }
                return v = k(t), f(h);
            }
        })(a), m = [], s = 0, r = v.length; s < r; s++){
            for(d = {}, o = 0, n = (l = v[s]).length; o < n; o++)i = (t = l[o])[0], e = t[1], d[i] = e;
            m.push(d);
        }
        return m;
    },
    l33t_match: function(e, a, i) {
        var r, n, s, o, t, l, c, d, m, u, h, g, p, b, y, k;
        for(null == a && (a = $70ee3d84ec5f3050$var$RANKED_DICTIONARIES), null == i && (i = $70ee3d84ec5f3050$var$L33T_TABLE), c = [], d = 0, s = (u = this.enumerate_l33t_subs(this.relevant_l33t_subtable(e, i))).length; d < s && (g = u[d], !this.empty(g)); d++)for(b = this.translate(e, g), m = 0, o = (h = this.dictionary_match(b, a)).length; m < o; m++)if (t = h[m], (y = e.slice(t.i, +t.j + 1 || 9e9)).toLowerCase() !== t.matched_word) {
            for(p in l = {}, g)r = g[p], -1 !== y.indexOf(p) && (l[p] = r);
            t.l33t = !0, t.token = y, t.sub = l, t.sub_display = (function() {
                var e;
                for(n in e = [], l)k = l[n], e.push(n + " -> " + k);
                return e;
            })().join(", "), c.push(t);
        }
        return this.sorted(c.filter(function(e) {
            return 1 < e.token.length;
        }));
    },
    spatial_match: function(e, a) {
        var i, r, n;
        for(r in null == a && (a = $70ee3d84ec5f3050$var$GRAPHS), n = [], a)i = a[r], this.extend(n, this.spatial_match_helper(e, i, r));
        return this.sorted(n);
    },
    SHIFTED_RX: /[~!@#$%^&*()_+QWERTYUIOP{}|ASDFGHJKL:"ZXCVBNM<>?]/,
    spatial_match_helper: function(e, a, i) {
        var r, n, s, o, t, l, c, d, m, u, h, g, p, b;
        for(h = [], c = 0; c < e.length - 1;)for(d = c + 1, m = null, b = 0, p = "qwerty" !== i && "dvorak" !== i || !this.SHIFTED_RX.exec(e.charAt(c)) ? 0 : 1;;){
            if (t = !1, o = l = -1, n = a[e.charAt(d - 1)] || [], d < e.length) {
                for(s = e.charAt(d), g = 0, u = n.length; g < u; g++)if (o += 1, (r = n[g]) && -1 !== r.indexOf(s)) {
                    t = !0, l = o, 1 === r.indexOf(s) && (p += 1), m !== l && (b += 1, m = l);
                    break;
                }
            }
            if (!t) {
                2 < d - c && h.push({
                    pattern: "spatial",
                    i: c,
                    j: d - 1,
                    token: e.slice(c, d),
                    graph: i,
                    turns: b,
                    shifted_count: p
                }), c = d;
                break;
            }
            d += 1;
        }
        return h;
    },
    repeat_match: function(e) {
        var a, i, r, n, s, o, t, l, c, d, m, u, h, g, p;
        for(g = [], s = /(.+)\1+/g, d = /(.+?)\1+/g, m = /^(.+?)\1+$/, c = 0; c < e.length && (s.lastIndex = d.lastIndex = c, o = s.exec(e), u = d.exec(e), null != o);)n = o[0].length > u[0].length ? (h = o, m.exec(h[0])[1]) : (h = u)[1], t = (p = [
            h.index,
            h.index + h[0].length - 1
        ])[0], l = p[1], r = (a = $70ee3d84ec5f3050$var$scoring$1.most_guessable_match_sequence(n, this.omnimatch(n))).sequence, i = a.guesses, g.push({
            pattern: "repeat",
            i: t,
            j: l,
            token: h[0],
            base_token: n,
            base_guesses: i,
            base_matches: r,
            repeat_count: h[0].length / n.length
        }), c = l + 1;
        return g;
    },
    MAX_DELTA: 5,
    sequence_match: function(t) {
        var e, a, i, r, n, s, o, l, c, d;
        if (1 === t.length) return [];
        for(d = this, c = function(e, a, i) {
            var r, n, s, o;
            if ((1 < a - e || 1 === Math.abs(i)) && 0 < (r = Math.abs(i)) && r <= d.MAX_DELTA) return o = t.slice(e, +a + 1 || 9e9), s = /^[a-z]+$/.test(o) ? (n = "lower", 26) : /^[A-Z]+$/.test(o) ? (n = "upper", 26) : /^\d+$/.test(o) ? (n = "digits", 10) : (n = "unicode", 26), l.push({
                pattern: "sequence",
                i: e,
                j: a,
                token: t.slice(e, +a + 1 || 9e9),
                sequence_name: n,
                sequence_space: s,
                ascending: 0 < i
            });
        }, l = [], a = 0, n = null, r = s = 1, o = t.length; 1 <= o ? s < o : o < s; r = 1 <= o ? ++s : --s)e = t.charCodeAt(r) - t.charCodeAt(r - 1), null == n && (n = e), e !== n && (c(a, i = r - 1, n), a = i, n = e);
        return c(a, t.length - 1, n), l;
    },
    regex_match: function(e, a) {
        var i, r, n, s;
        for($70ee3d84ec5f3050$var$name in null == a && (a = $70ee3d84ec5f3050$var$REGEXEN), i = [], a)for((r = a[$70ee3d84ec5f3050$var$name]).lastIndex = 0; n = r.exec(e);)s = n[0], i.push({
            pattern: "regex",
            token: s,
            i: n.index,
            j: n.index + n[0].length - 1,
            regex_name: $70ee3d84ec5f3050$var$name,
            regex_match: n
        });
        return this.sorted(i);
    },
    date_match: function(e) {
        var a, i, r, n, s, o, t, l, c, d, m, u, h, g, p, b, y, k, f, v, w, z, j, x, q, _, E, A, S, R, I, T, N, C;
        for(u = [], h = /^\d{4,8}$/, g = /^(\d{1,4})([\s\/\\_.-])(\d{1,2})\2(\d{1,4})$/, o = y = 0, w = e.length - 4; 0 <= w ? y <= w : w <= y; o = 0 <= w ? ++y : --y)for(t = k = z = o + 3, j = o + 7; (z <= j ? k <= j : j <= k) && !(t >= e.length); t = z <= j ? ++k : --k)if (C = e.slice(o, +t + 1 || 9e9), h.exec(C)) {
            for(r = [], f = 0, d = (x = $70ee3d84ec5f3050$var$DATE_SPLITS[C.length]).length; f < d; f++)l = (q = x[f])[0], c = q[1], null != (s = this.map_ints_to_dmy([
                parseInt(C.slice(0, l)),
                parseInt(C.slice(l, c)),
                parseInt(C.slice(c))
            ])) && r.push(s);
            if (0 < r.length) {
                for(a = r[0], b = (p = function(e) {
                    return Math.abs(e.year - $70ee3d84ec5f3050$var$scoring$1.REFERENCE_YEAR);
                })(r[0]), v = 0, m = (_ = r.slice(1)).length; v < m; v++)(n = p(i = _[v])) < b && (a = (E = [
                    i,
                    n
                ])[0], b = E[1]);
                u.push({
                    pattern: "date",
                    token: C,
                    i: o,
                    j: t,
                    separator: "",
                    year: a.year,
                    month: a.month,
                    day: a.day
                });
            }
        }
        for(o = T = 0, A = e.length - 6; 0 <= A ? T <= A : A <= T; o = 0 <= A ? ++T : --T)for(t = N = S = o + 5, R = o + 9; (S <= R ? N <= R : R <= N) && !(t >= e.length); t = S <= R ? ++N : --N)C = e.slice(o, +t + 1 || 9e9), null != (I = g.exec(C)) && null != (s = this.map_ints_to_dmy([
            parseInt(I[1]),
            parseInt(I[3]),
            parseInt(I[4])
        ])) && u.push({
            pattern: "date",
            token: C,
            i: o,
            j: t,
            separator: I[2],
            year: s.year,
            month: s.month,
            day: s.day
        });
        return this.sorted(u.filter(function(e) {
            var a, i, r, n;
            for(a = !1, n = 0, i = u.length; n < i; n++)if (e !== (r = u[n]) && r.i <= e.i && r.j >= e.j) {
                a = !0;
                break;
            }
            return !a;
        }));
    },
    map_ints_to_dmy: function(e) {
        var a, i, r, n, s, o, t, l, c, d, m, u, h, g, p, b;
        if (!(31 < e[1] || e[1] <= 0)) {
            for(o = p = l = t = 0, r = e.length; o < r; o++){
                if (99 < (i = e[o]) && i < $70ee3d84ec5f3050$var$DATE_MIN_YEAR || $70ee3d84ec5f3050$var$DATE_MAX_YEAR < i) return;
                31 < i && (l += 1), 12 < i && (t += 1), i <= 0 && (p += 1);
            }
            if (!(2 <= l || 3 === t || 2 <= p)) {
                for(c = 0, n = (d = [
                    [
                        e[2],
                        e.slice(0, 2)
                    ],
                    [
                        e[0],
                        e.slice(1, 3)
                    ]
                ]).length; c < n; c++)if (b = (u = d[c])[0], g = u[1], $70ee3d84ec5f3050$var$DATE_MIN_YEAR <= b && b <= $70ee3d84ec5f3050$var$DATE_MAX_YEAR) return null != (a = this.map_ints_to_dm(g)) ? {
                    year: b,
                    month: a.month,
                    day: a.day
                } : void 0;
                for(m = 0, s = d.length; m < s; m++)if (b = (h = d[m])[0], g = h[1], null != (a = this.map_ints_to_dm(g))) return {
                    year: b = this.two_to_four_digit_year(b),
                    month: a.month,
                    day: a.day
                };
            }
        }
    },
    map_ints_to_dm: function(e) {
        var a, i, r, n, s, o;
        for(n = 0, i = (s = [
            e,
            e.slice().reverse()
        ]).length; n < i; n++)if (a = (o = s[n])[0], r = o[1], 1 <= a && a <= 31 && 1 <= r && r <= 12) return {
            day: a,
            month: r
        };
    },
    two_to_four_digit_year: function(e) {
        return 99 < e ? e : 50 < e ? e + 1900 : e + 2e3;
    }
}, $70ee3d84ec5f3050$var$time_estimates_1 = $70ee3d84ec5f3050$var$time_estimates = {
    estimate_attack_times: function(e) {
        var a, i, r, n;
        for(r in a = {}, i = {
            online_throttling_100_per_hour: e / (100 / 3600),
            online_no_throttling_10_per_second: e / 10,
            offline_slow_hashing_1e4_per_second: e / 1e4,
            offline_fast_hashing_1e10_per_second: e / 1e10
        })n = i[r], a[r] = this.display_time(n);
        return {
            crack_times_seconds: i,
            crack_times_display: a,
            score: this.guesses_to_score(e)
        };
    },
    guesses_to_score: function(e) {
        return e < 1005 ? 0 : e < 1e6 + 5 ? 1 : e < 1e8 + 5 ? 2 : e < 1e10 + 5 ? 3 : 4;
    },
    display_time: function(e) {
        var a, i, r, n, s, o;
        return o = 12 * (n = 2678400), r = (s = e < 1 ? [
            null,
            "less than a second"
        ] : e < 60 ? [
            a = Math.round(e),
            a + " second"
        ] : e < 3600 ? [
            a = Math.round(e / 60),
            a + " minute"
        ] : e < 86400 ? [
            a = Math.round(e / 3600),
            a + " hour"
        ] : e < n ? [
            a = Math.round(e / 86400),
            a + " day"
        ] : e < o ? [
            a = Math.round(e / n),
            a + " month"
        ] : e < 321408e4 ? [
            a = Math.round(e / o),
            a + " year"
        ] : [
            null,
            "centuries"
        ])[1], null != (i = s[0]) && 1 !== i && (r += "s"), r;
    }
}, $70ee3d84ec5f3050$var$feedback_1 = $70ee3d84ec5f3050$var$feedback = {
    default_feedback: {
        warning: "",
        suggestions: [
            "Use a few words, avoid common phrases",
            "No need for symbols, digits, or uppercase letters"
        ]
    },
    get_feedback: function(e, a) {
        var i, r, n, s, o, t;
        if (0 === a.length) return this.default_feedback;
        if (2 < e) return {
            warning: "",
            suggestions: []
        };
        for(s = a[0], r = 0, n = (t = a.slice(1)).length; r < n; r++)(o = t[r]).token.length > s.token.length && (s = o);
        return i = "Add another word or two. Uncommon words are better.", null != ($70ee3d84ec5f3050$var$feedback = this.get_match_feedback(s, 1 === a.length)) ? ($70ee3d84ec5f3050$var$feedback.suggestions.unshift(i), null == $70ee3d84ec5f3050$var$feedback.warning && ($70ee3d84ec5f3050$var$feedback.warning = "")) : $70ee3d84ec5f3050$var$feedback = {
            warning: "",
            suggestions: [
                i
            ]
        }, $70ee3d84ec5f3050$var$feedback;
    },
    get_match_feedback: function(e, a) {
        switch(e.pattern){
            case "dictionary":
                return this.get_dictionary_match_feedback(e, a);
            case "spatial":
                return e.graph.toUpperCase(), {
                    warning: 1 === e.turns ? "Straight rows of keys are easy to guess" : "Short keyboard patterns are easy to guess",
                    suggestions: [
                        "Use a longer keyboard pattern with more turns"
                    ]
                };
            case "repeat":
                return {
                    warning: 1 === e.base_token.length ? 'Repeats like "aaa" are easy to guess' : 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"',
                    suggestions: [
                        "Avoid repeated words and characters"
                    ]
                };
            case "sequence":
                return {
                    warning: "Sequences like abc or 6543 are easy to guess",
                    suggestions: [
                        "Avoid sequences"
                    ]
                };
            case "regex":
                if ("recent_year" === e.regex_name) return {
                    warning: "Recent years are easy to guess",
                    suggestions: [
                        "Avoid recent years",
                        "Avoid years that are associated with you"
                    ]
                };
                break;
            case "date":
                return {
                    warning: "Dates are often easy to guess",
                    suggestions: [
                        "Avoid dates and years that are associated with you"
                    ]
                };
        }
    },
    get_dictionary_match_feedback: function(e, a) {
        var i, r, n, s;
        return n = "passwords" === e.dictionary_name ? !a || e.l33t || e.reversed ? e.guesses_log10 <= 4 ? "This is similar to a commonly used password" : void 0 : e.rank <= 10 ? "This is a top-10 common password" : e.rank <= 100 ? "This is a top-100 common password" : "This is a very common password" : "english_wikipedia" === e.dictionary_name ? a ? "A word by itself is easy to guess" : void 0 : "surnames" === (i = e.dictionary_name) || "male_names" === i || "female_names" === i ? a ? "Names and surnames by themselves are easy to guess" : "Common names and surnames are easy to guess" : "", r = [], (s = e.token).match($70ee3d84ec5f3050$var$scoring$2.START_UPPER) ? r.push("Capitalization doesn't help very much") : s.match($70ee3d84ec5f3050$var$scoring$2.ALL_UPPER) && s.toLowerCase() !== s && r.push("All-uppercase is almost as easy to guess as all-lowercase"), e.reversed && 4 <= e.token.length && r.push("Reversed words aren't much harder to guess"), e.l33t && r.push("Predictable substitutions like '@' instead of 'a' don't help very much"), {
            warning: n,
            suggestions: r
        };
    }
};
$70ee3d84ec5f3050$var$matching$1 = $70ee3d84ec5f3050$var$matching_1, $70ee3d84ec5f3050$var$scoring$3 = $70ee3d84ec5f3050$var$scoring$2 = $70ee3d84ec5f3050$var$scoring_1, $70ee3d84ec5f3050$var$time_estimates$1 = $70ee3d84ec5f3050$var$time_estimates_1, $70ee3d84ec5f3050$var$feedback$1 = $70ee3d84ec5f3050$var$feedback_1, $70ee3d84ec5f3050$var$time = function() {
    return (new Date).getTime();
};
var $70ee3d84ec5f3050$var$main = $70ee3d84ec5f3050$var$zxcvbn = function(e, a) {
    var i, r, n, s, o, t, l, c, d, m, u;
    for(null == a && (a = []), m = $70ee3d84ec5f3050$var$time(), d = [], n = 0, s = a.length; n < s; n++)"string" != (l = typeof (i = a[n])) && "number" != l && "boolean" != l || d.push(i.toString().toLowerCase());
    for(t in $70ee3d84ec5f3050$var$matching$1.set_user_input_dictionary(d), o = $70ee3d84ec5f3050$var$matching$1.omnimatch(e), (c = $70ee3d84ec5f3050$var$scoring$3.most_guessable_match_sequence(e, o)).calc_time = $70ee3d84ec5f3050$var$time() - m, r = $70ee3d84ec5f3050$var$time_estimates$1.estimate_attack_times(c.guesses))u = r[t], c[t] = u;
    return c.feedback = $70ee3d84ec5f3050$var$feedback$1.get_feedback(c.score, c.sequence), c;
}, $70ee3d84ec5f3050$var$itemStyle = {
    flexBasis: 0,
    flexGrow: 1,
    position: "relative",
    maxWidth: "100%",
    width: "100%",
    height: 2
}, $70ee3d84ec5f3050$var$Item = function(e) {
    var a = e.score, i = e.itemNum, r = e.barColors, n = r[0];
    return i <= a && (n = r[a]), $70ee3d84ec5f3050$var$React__default.createElement("div", {
        style: $70ee3d84ec5f3050$var$__assign($70ee3d84ec5f3050$var$__assign({}, $70ee3d84ec5f3050$var$itemStyle), {
            backgroundColor: n
        })
    });
}, $70ee3d84ec5f3050$var$rootStyle = {
    position: "relative"
}, $70ee3d84ec5f3050$var$wrapStyle = {
    display: "flex",
    alignItems: "center",
    margin: "5px 0 0"
}, $70ee3d84ec5f3050$var$spaceStyle = {
    width: 4
}, $70ee3d84ec5f3050$var$descStyle = {
    margin: "5px 0 0",
    color: "#898792",
    fontSize: 14,
    textAlign: "right"
}, $70ee3d84ec5f3050$var$PasswordStrengthBar = function(e) {
    function a() {
        var l = null !== e && e.apply(this, arguments) || this;
        return l.state = {
            score: 0
        }, l.setScore = function() {
            var e = l.props, a = e.password, i = e.minLength, r = e.userInputs, n = e.onChangeScore, s = null, o = 0, t = {};
            a.length >= i && (s = $70ee3d84ec5f3050$var$main(a, r), o = s.score, t = s.feedback), l.setState({
                score: o
            }, function() {
                n && n(o, t);
            });
        }, l;
    }
    return $70ee3d84ec5f3050$var$__extends(a, e), a.prototype.componentDidMount = function() {
        this.setScore();
    }, a.prototype.componentDidUpdate = function(e) {
        var a = this.props.password;
        e.password !== a && this.setScore();
    }, a.prototype.render = function() {
        var e = this.props, a = e.className, i = e.style, r = e.scoreWordClassName, n = e.scoreWordStyle, s = e.password, o = e.barColors, t = e.scoreWords, l = e.minLength, c = e.shortScoreWord, d = this.state.score, m = s.length >= l ? t[d] : c;
        return $70ee3d84ec5f3050$var$React__default.createElement("div", {
            className: a,
            style: $70ee3d84ec5f3050$var$__assign($70ee3d84ec5f3050$var$__assign({}, $70ee3d84ec5f3050$var$rootStyle), i)
        }, $70ee3d84ec5f3050$var$React__default.createElement("div", {
            style: $70ee3d84ec5f3050$var$wrapStyle
        }, [
            1,
            2,
            3,
            4
        ].map(function(e) {
            return $70ee3d84ec5f3050$var$React__default.createElement($dvPqk.Fragment, {
                key: "password-strength-bar-item-" + e
            }, 1 < e && $70ee3d84ec5f3050$var$React__default.createElement("div", {
                style: $70ee3d84ec5f3050$var$spaceStyle
            }), $70ee3d84ec5f3050$var$React__default.createElement($70ee3d84ec5f3050$var$Item, {
                score: d,
                itemNum: e,
                barColors: o
            }));
        })), $70ee3d84ec5f3050$var$React__default.createElement("p", {
            className: r,
            style: $70ee3d84ec5f3050$var$__assign($70ee3d84ec5f3050$var$__assign({}, $70ee3d84ec5f3050$var$descStyle), n)
        }, m));
    }, a.defaultProps = {
        className: void 0,
        style: void 0,
        scoreWordClassName: void 0,
        scoreWordStyle: void 0,
        password: "",
        userInputs: [],
        barColors: [
            "#ddd",
            "#ef4836",
            "#f6b44d",
            "#2b90ef",
            "#25c281"
        ],
        scoreWords: [
            "weak",
            "weak",
            "okay",
            "good",
            "strong"
        ],
        minLength: 4,
        shortScoreWord: "too short",
        onChangeScore: void 0
    }, a;
}($70ee3d84ec5f3050$var$React__default.Component);
module.exports.default = $70ee3d84ec5f3050$var$PasswordStrengthBar;

});


parcelRegister("5rKSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f73d5a69b5012f6$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $3f73d5a69b5012f6$var$SvgCheckLarge = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M8.933 20 2 13.026l2.051-2.052 4.882 4.841L20.79 4l2.051 2.092z"
        })
    }));
var $3f73d5a69b5012f6$export$2e2bcd8739ae039 = $3f73d5a69b5012f6$var$SvgCheckLarge;

});

parcelRegister("fzwaN", function(module, exports) {

$parcel$export(module.exports, "AccountListItemWithNavigation", function () { return $7ad2e1028eebd6f2$export$4ca3d760b9912a86; });
$parcel$export(module.exports, "AccountListItemWithButtonActions", function () { return $7ad2e1028eebd6f2$export$fadfa4e22713fab; });

var $7YWoO = parcelRequire("7YWoO");

var $im5sL = parcelRequire("im5sL");

var $3lzdj = parcelRequire("3lzdj");
var $jOOuf = parcelRequire("jOOuf");
var $fqWHZ = parcelRequire("fqWHZ");

var $izjX7 = parcelRequire("izjX7");

var $8kt8E = parcelRequire("8kt8E");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");
const $7ad2e1028eebd6f2$export$d716ac1319a90d28 = "mb-2 rounded-lg shadow-sm ";
const $7ad2e1028eebd6f2$var$TitleColumn = ({ title: title, subtitles: subtitles, icon: icon })=>{
    const subtitleList = Array.isArray(subtitles) ? subtitles : subtitles ? [
        subtitles
    ] : [];
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
        justify: "start",
        gap: 4,
        children: [
            icon && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "hidden text-muted-foreground sm:block",
                children: icon
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
                justify: "start",
                align: "start",
                gap: 0,
                children: [
                    title && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                        className: (0, $izjX7.cn)("font-semibold", {
                            "mb-0": !subtitles
                        }),
                        children: title
                    }),
                    subtitles && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fqWHZ.Stack), {
                        gap: 2,
                        align: "start",
                        children: subtitleList.map((subtitle, index)=>/*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                children: subtitle
                            }, `${subtitle?.toString()}${index}`))
                    })
                ]
            })
        ]
    });
};
const $7ad2e1028eebd6f2$var$AccountListItemContent = ({ title: title, titleCentered: titleCentered = false, subtitles: subtitles, icon: icon, midColumn: midColumn, endColumn: endColumn })=>{
    const isMobile = (0, $gUV6W.default)((0, $5OqMf.mobileBreakpoint));
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
        cols: 3,
        gap: 1,
        className: (0, $izjX7.cn)("w-full p-4", {
            "grid-cols-[1fr_fit-content(60px)]": isMobile
        }),
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                order: 1,
                span: isMobile ? 1 : midColumn ? 1 : 2,
                className: (0, $izjX7.cn)({
                    "flex items-center": titleCentered
                }),
                children: /*#__PURE__*/ (0, $7YWoO.jsx)($7ad2e1028eebd6f2$var$TitleColumn, {
                    title: title,
                    subtitles: subtitles,
                    icon: icon
                })
            }),
            midColumn && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                order: {
                    base: 3,
                    sm: 2
                },
                span: {
                    base: 2,
                    sm: 1
                },
                className: "flex items-center mt-2 sm:mt-0",
                children: midColumn
            }),
            endColumn && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                order: {
                    base: 2,
                    sm: 3
                },
                span: 1,
                className: "flex items-start justify-end sm:items-center",
                children: endColumn
            })
        ]
    });
};
const $7ad2e1028eebd6f2$var$ArrowAndOptionalText = ({ actionText: actionText })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
        gap: 2,
        children: [
            actionText && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                className: "hidden md:block",
                children: actionText
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $im5sL.default), {})
        ]
    });
};
const $7ad2e1028eebd6f2$export$4ca3d760b9912a86 = ({ title: title, titleCentered: titleCentered = false, subtitles: subtitles, icon: icon, midColumn: midColumn, actionText: actionText, onClick: onClick, link: link, marked: marked = false })=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
        className: (0, $izjX7.cn)($7ad2e1028eebd6f2$export$d716ac1319a90d28, "hover:cursor-pointer hover:bg-surface-default-hover", {
            "bg-surface-default": !marked,
            "text-button-tertiary-bg-hover": marked
        }),
        "data-testid": "list-item-with-navigation",
        children: link ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
            to: link,
            className: "no-underline",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7YWoO.jsx)($7ad2e1028eebd6f2$var$AccountListItemContent, {
                title: title,
                titleCentered: titleCentered,
                subtitles: subtitles,
                icon: icon,
                midColumn: midColumn,
                endColumn: /*#__PURE__*/ (0, $7YWoO.jsx)($7ad2e1028eebd6f2$var$ArrowAndOptionalText, {
                    actionText: actionText
                })
            })
        }) : /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
            type: "button",
            className: "text-left size-full",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7YWoO.jsx)($7ad2e1028eebd6f2$var$AccountListItemContent, {
                title: title,
                titleCentered: titleCentered,
                subtitles: subtitles,
                icon: icon,
                midColumn: midColumn,
                endColumn: /*#__PURE__*/ (0, $7YWoO.jsx)($7ad2e1028eebd6f2$var$ArrowAndOptionalText, {
                    actionText: actionText
                })
            })
        })
    }, title);
const $7ad2e1028eebd6f2$export$fadfa4e22713fab = ({ title: title, titleCentered: titleCentered = false, subtitles: subtitles, icon: icon, midColumn: midColumn, actions: actions, marked: marked = false })=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
        className: (0, $izjX7.cn)($7ad2e1028eebd6f2$export$d716ac1319a90d28, {
            "bg-surface-default": !marked,
            "bg-button-tertiary-bg-hover": marked
        }),
        "data-testid": "list-item-with-button",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)($7ad2e1028eebd6f2$var$AccountListItemContent, {
            title: title,
            titleCentered: titleCentered,
            subtitles: subtitles,
            icon: icon,
            midColumn: midColumn,
            endColumn: actions
        })
    });

});

parcelRegister("eEIow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e72fbe89dc1bd059$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $7qw1I = parcelRequire("7qw1I");

var $ezbi8 = parcelRequire("ezbi8");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $e72fbe89dc1bd059$var$AlertMessage = ({ warning: warning, className: className })=>{
    const Message = ()=>(0, $7qw1I.documentToReactComponents)(warning.message);
    let variant;
    switch(warning.theme){
        case "Warning":
            variant = "error";
            break;
        case "Information":
            variant = "information";
            break;
        case "Important":
            variant = "warning";
            break;
        default:
            variant = "information";
    }
    const classNames = (0, $izjX7.cn)([
        "justify-center px-0 [&>div>div>div>div>p]:mb-0 [&>div]:max-w-[--main-column-max-width]",
        "[&>div]:px-3 sm:[&>div]:px-4",
        className
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
        fullWidth: true,
        variant: variant,
        showCloseButton: false,
        className: classNames,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)(Message, {})
    });
};
var $e72fbe89dc1bd059$export$2e2bcd8739ae039 = (0, $gBcml.observer)($e72fbe89dc1bd059$var$AlertMessage);

});

parcelRegister("dWcIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31c473c9dfe2ad00$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $isIf6 = parcelRequire("isIf6");
const $31c473c9dfe2ad00$var$StoreLogoComponent = ({ placement: placement, ...rest })=>{
    const isMobile = (0, $gUV6W.default)((0, $5OqMf.mobileBreakpoint));
    if (!(0, $isIf6.default).storeLogo[placement]) return;
    const width = (0, $isIf6.default).storeLogo[placement].mobileWidth ? isMobile ? (0, $isIf6.default).storeLogo[placement].mobileWidth : (0, $isIf6.default).storeLogo[placement].width : (0, $isIf6.default).storeLogo[placement].width;
    return /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
        width: width,
        src: (0, $isIf6.default).storeLogo[placement].url,
        ...rest,
        alt: `${(0, $isIf6.default).storeCompanyName} logo`
    });
};
var $31c473c9dfe2ad00$export$2e2bcd8739ae039 = (0, $gBcml.observer)($31c473c9dfe2ad00$var$StoreLogoComponent);

});

parcelRegister("5koBm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e11e761978c7704$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $3e11e761978c7704$var$SvgExpandMore = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m12 15.031-5-5L8.063 8.97 12 12.906l3.938-3.937L17 10.03z"
        })
    }));
var $3e11e761978c7704$export$2e2bcd8739ae039 = $3e11e761978c7704$var$SvgExpandMore;

});

parcelRegister("inMER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15d3141a6cb99307$export$2e2bcd8739ae039; });

var $dvPqk = parcelRequire("dvPqk");

var $gtsdT = parcelRequire("gtsdT");
function $15d3141a6cb99307$var$useOutsideClick(refs, callback) {
    (0, $dvPqk.useEffect)(()=>{
        function handleClickOutside(event) {
            if (event.target === null) return;
            const clickOutside = refs.reduce((p, ref)=>{
                if (ref instanceof Element) {
                    const isOutside = p && !ref.contains(event.target);
                    (0, $gtsdT.logger).log("utils", "Checking outside click for ref:", ref, "isOutside:", isOutside, "event: ", event);
                    return isOutside;
                }
                if (ref?.current) return p && !ref.current.contains(event.target);
                return p;
            }, true);
            if (clickOutside) callback();
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        refs
    ]);
}
var $15d3141a6cb99307$export$2e2bcd8739ae039 = $15d3141a6cb99307$var$useOutsideClick;

});

parcelRegister("inCq0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6182d1066cf6024$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $d6182d1066cf6024$var$SvgClock = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m15.14 15.984 1.196-1.195-3.492-3.492V6.375h-1.688V12zM12 21a8.8 8.8 0 0 1-3.497-.703 9.1 9.1 0 0 1-2.866-1.934 9.1 9.1 0 0 1-1.934-2.87A8.8 8.8 0 0 1 3 11.99q0-1.864.703-3.505a8.9 8.9 0 0 1 1.934-2.859 9.2 9.2 0 0 1 2.87-1.922A8.8 8.8 0 0 1 12.01 3q1.864 0 3.505.709a9.1 9.1 0 0 1 2.854 1.924 9.1 9.1 0 0 1 1.922 2.857A8.8 8.8 0 0 1 21 12q0 1.86-.703 3.497a9.2 9.2 0 0 1-1.922 2.866 8.9 8.9 0 0 1-2.862 1.934A8.8 8.8 0 0 1 12 21m.011-1.687q3.035 0 5.168-2.145t2.134-5.18q0-3.033-2.134-5.167t-5.168-2.133q-3.035 0-5.179 2.133t-2.144 5.168 2.144 5.179 5.18 2.145"
        })
    }));
var $d6182d1066cf6024$export$2e2bcd8739ae039 = $d6182d1066cf6024$var$SvgClock;

});

parcelRegister("9bzp5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95394292106e23df$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $9FOUz = parcelRequire("9FOUz");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $6fuyt = parcelRequire("6fuyt");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $8Wejn = parcelRequire("8Wejn");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");

var $4daag = parcelRequire("4daag");

var $1SASl = parcelRequire("1SASl");
const $95394292106e23df$var$DeliveryDateButton = ({ render: render, size: size = "compact", inline: inline })=>{
    const isDesktop = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).sm);
    const labels = [
        {
            flag: "selected",
            label: "Valgt leveringsdag"
        },
        {
            flag: "selectable",
            label: "Tilgjengelig for levering"
        },
        {
            flag: "cancelled",
            label: "Ikke tilgjengelig"
        }
    ];
    const handleChange = (dates)=>{
        const date = dates[0];
        if (date) {
            (0, $8Wejn.default).clearAvailability();
            (0, $9Vhxl.default).changeDeliveryDate(date);
            (0, $6fuyt.sendDeliveryDateChange)();
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1SASl.default), {
        monthCount: isDesktop ? 2 : 1,
        min: (0, $9FOUz.default)(new Date()),
        render: render,
        size: size,
        dates: (0, $76PCP.default).deliveryDateForPicker(),
        onDatesChange: handleChange,
        getDayFlags: (0, $9Vhxl.default).getDayFlags,
        closeOnChange: true,
        inline: inline,
        currentMonthOnly: true,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4daag.default), {
            flagLabels: labels
        })
    });
};
var $95394292106e23df$export$2e2bcd8739ae039 = (0, $gBcml.observer)($95394292106e23df$var$DeliveryDateButton);

});
parcelRegister("4daag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a4dbf3c88292ab$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
const $a8a4dbf3c88292ab$var$style = {
    "--button-border-radius": "0.25rem"
};
const $a8a4dbf3c88292ab$var$CalendarKey = ({ flag: flag, label: label, size: size })=>{
    const keyClassName = (0, $izjX7.cn)("rounded-button border-2 border-solid leading-none", {
        "h-7 w-7 px-button-compact-padding-x py-button-compact-padding-y": size === "compact",
        "h-8 w-8 px-button-regular-padding-x py-button-regular-padding-y": size === "regular",
        "border-calendar-selected-bg bg-calendar-selected-bg text-calendar-selected-text": flag === "selected",
        "border-button-secondary-border bg-button-secondary-bg text-button-secondary-text": flag === "secondary",
        "border-calendar-cancelled-border bg-calendar-cancelled-bg text-calendar-cancelled-text": flag === "cancelled",
        "bg-calendar-selectable-bg border-0": flag === "selectable"
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        role: "presentation",
        className: (0, $izjX7.cn)("flex flex-grow-0 items-center gap-1", {
            "text-sm": size === "compact"
        }),
        style: $a8a4dbf3c88292ab$var$style,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: keyClassName
            }),
            label
        ]
    });
};
const $a8a4dbf3c88292ab$var$CalendarKeys = ({ flagLabels: flagLabels, size: size = "compact" })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: flagLabels.map(({ flag: flag, label: label })=>/*#__PURE__*/ (0, $7YWoO.jsx)($a8a4dbf3c88292ab$var$CalendarKey, {
                flag: flag,
                label: label,
                size: size
            }, flag))
    });
};
var $a8a4dbf3c88292ab$export$2e2bcd8739ae039 = $a8a4dbf3c88292ab$var$CalendarKeys;

});

parcelRegister("1SASl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1cbdc565e8a297c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");

var $fPI54 = parcelRequire("fPI54");

var $6e7IR = parcelRequire("6e7IR");
const $f1cbdc565e8a297c$var$DatePicker = ({ render: render, mode: mode, dates: dates, size: size = "compact", closeOnChange: closeOnChange, hide: hide, inline: inline, onHide: onHide = ()=>{}, children: children, ...props })=>{
    const onDatesChange = props.onDatesChange || (()=>{});
    const [selectedDates, setSelectedDates] = (0, $dvPqk.useState)(dates);
    const [show, setShow] = (0, $dvPqk.useState)(false);
    const ref = (0, $dvPqk.useRef)(null);
    (0, $dvPqk.useEffect)(()=>{
        if (hide && show) {
            setSelectedDates(dates);
            const referenceElement = ref.current?.querySelector("input,button") || null;
            setShow(false);
            referenceElement?.focus();
            onHide();
        }
    }, [
        hide
    ]);
    (0, $dvPqk.useEffect)(()=>{
        if (show) setSelectedDates(dates);
    }, [
        show
    ]);
    const handleChange = (dates)=>{
        setSelectedDates(dates);
        onDatesChange(dates);
        if (closeOnChange) {
            if (mode !== "range" || dates.length === 2) {
                const referenceElement = ref.current?.querySelector("input,button") || null;
                setShow(false);
                referenceElement?.focus();
            }
        }
    };
    const calendarProps = {
        ...props,
        dates: dates,
        mode: mode,
        onDatesChange: handleChange,
        isArrowFocus: true
    };
    const calendarWrapperCN = (0, $izjX7.cn)({
        "m-3": size === "compact",
        "m-4": size === "regular"
    });
    const keysWrapperCN = (0, $izjX7.cn)(calendarWrapperCN, "flex flex-col justify-between gap-1 px-3 sm:flex-row");
    (0, $dvPqk.useEffect)(()=>{
        const referenceElement = ref.current?.querySelector("input,button") || null;
        const handleBlur = (e)=>{
            if (e.target !== referenceElement && ref.current && !ref.current.contains(e.relatedTarget)) {
                e.preventDefault();
                e.stopPropagation();
                referenceElement?.focus();
            }
        };
        if (ref.current) ref.current.addEventListener("focusout", handleBlur);
        return ()=>ref.current?.removeEventListener("focusout", handleBlur);
    }, []);
    if (inline && show) return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fPI54.default), {
                ...calendarProps
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: keysWrapperCN,
                children: children
            })
        ]
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6e7IR.Popover), {
        placement: "bottom",
        open: show,
        onOpenChange: setShow,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6e7IR.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: render(selectedDates, show, setShow)
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6e7IR.PopoverContent), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: calendarWrapperCN,
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fPI54.default), {
                            ...calendarProps
                        })
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: keysWrapperCN,
                        children: children
                    })
                ]
            })
        ]
    });
};
var $f1cbdc565e8a297c$export$2e2bcd8739ae039 = $f1cbdc565e8a297c$var$DatePicker;

});
parcelRegister("fPI54", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13491e51fffef0c2$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $fbCoc = parcelRequire("fbCoc");

var $dvPqk = parcelRequire("dvPqk");

var $4udGV = parcelRequire("4udGV");

var $PW26M = parcelRequire("PW26M");
const $13491e51fffef0c2$var$defaultDayFlags = (_date)=>{
    return {
        selectable: true
    };
};
const $13491e51fffef0c2$var$dateCompare = (a, b)=>a.getTime() - b.getTime();
const $13491e51fffef0c2$var$getMonthAndYear = (dates)=>{
    const monthAndYearDate = (0, $4udGV.getFirstDate)(dates) || new Date();
    return {
        month: monthAndYearDate.getMonth(),
        year: monthAndYearDate.getFullYear()
    };
};
const $13491e51fffef0c2$var$Calendar = ({ dates: dates, getDayFlags: getDayFlags = $13491e51fffef0c2$var$defaultDayFlags, onDatesChange: onDatesChange, monthCount: monthCount = 1, currentMonthOnly: currentMonthOnly, showWeekNumber: showWeekNumber, mode: mode = "single", size: size = "compact", min: min, max: max, ...props })=>{
    const monthAndYear = $13491e51fffef0c2$var$getMonthAndYear(dates);
    const { month: initialMonth = monthAndYear.month } = props;
    const { year: initialYear = monthAndYear.year } = props;
    const [month, setMonth] = (0, $dvPqk.useState)(initialMonth);
    const [year, setYear] = (0, $dvPqk.useState)(initialYear);
    (0, $dvPqk.useEffect)(()=>{
        if (mode === "range" && dates.length > 1) {
            const monthAndYear = $13491e51fffef0c2$var$getMonthAndYear(dates);
            const { month: month = monthAndYear.month } = props;
            const { year: year = monthAndYear.year } = props;
            setMonth(month);
            setYear(year);
        }
    }, [
        props.month,
        props.year,
        dates
    ]);
    const getDayFlagsByMode = {
        single: (date)=>({
                ...getDayFlags(date),
                selected: !!dates.length && (0, $fbCoc.default)(date, dates[0])
            }),
        multi: (date)=>({
                ...getDayFlags(date),
                selected: dates.some((d)=>(0, $fbCoc.default)(d, date))
            }),
        range: (date)=>({
                ...getDayFlags(date),
                selected: dates.some((d)=>(0, $fbCoc.default)(d, date)),
                inRange: dates.length === 2 && (0, $4udGV.isDateBetween)(date, dates[0], dates[1])
            })
    };
    const handleClickByMode = {
        single: (date)=>onDatesChange([
                date
            ]),
        multi: (date)=>{
            if (dates.some((d)=>(0, $fbCoc.default)(d, date))) onDatesChange(dates.filter((d)=>!(0, $fbCoc.default)(d, date)).sort());
            else onDatesChange([
                ...dates,
                date
            ].sort());
        },
        range: (date)=>{
            if (dates.length === 2 && !dates.some((d)=>(0, $fbCoc.default)(d, date))) {
                onDatesChange([
                    date
                ]);
                return;
            }
            if (dates.some((d)=>(0, $fbCoc.default)(d, date))) onDatesChange(dates.filter((d)=>!(0, $fbCoc.default)(date, d)).sort($13491e51fffef0c2$var$dateCompare));
            else onDatesChange([
                ...dates,
                date
            ].sort($13491e51fffef0c2$var$dateCompare));
        }
    };
    const selecting = mode === "range" && dates.length === 1 && dates[0] || undefined;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $PW26M.default), {
        ...props,
        "data-testid": "delivery-calendar",
        selecting: selecting,
        getDayFlags: getDayFlagsByMode[mode],
        monthCount: monthCount,
        month: month,
        year: year,
        onDayClicked: handleClickByMode[mode],
        currentMonthOnly: currentMonthOnly,
        showWeekNumber: showWeekNumber,
        size: size,
        min: min,
        max: max
    });
};
var $13491e51fffef0c2$export$2e2bcd8739ae039 = $13491e51fffef0c2$var$Calendar;

});
parcelRegister("PW26M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87ef1331964718ce$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $a4r3l = parcelRequire("a4r3l");
var $doGx2 = parcelRequire("doGx2");

var $cGjF4 = parcelRequire("cGjF4");
var $3lzdj = parcelRequire("3lzdj");

var $izjX7 = parcelRequire("izjX7");

var $kuUjW = parcelRequire("kuUjW");
var $1Qg53 = parcelRequire("1Qg53");
var $fbCoc = parcelRequire("fbCoc");
var $koTPy = parcelRequire("koTPy");

var $dvPqk = parcelRequire("dvPqk");

var $5OqMf = parcelRequire("5OqMf");

var $4udGV = parcelRequire("4udGV");

var $h0cPN = parcelRequire("h0cPN");
const $87ef1331964718ce$var$style = {
    "--button-border-radius": "0.25rem"
};
const $87ef1331964718ce$var$Months = ({ min: min, max: max, monthCount: monthCount, month: month, year: year, selecting: selecting, getDayFlags: getDayFlags, onDayClicked: onDayClicked, onBlur: onBlur, isArrowFocus: isArrowFocus, ...props })=>{
    const [monthAndYears, setMonthAndYears] = (0, $dvPqk.useState)((0, $4udGV.getMonthAndYears)(month, year, monthCount, min, max));
    const [calendarMatrix, setCalendarMatrix] = (0, $dvPqk.useState)((0, $4udGV.createCalendarMatrix)([
        (0, $4udGV.getPreviousMonth)(monthAndYears[0]),
        ...monthAndYears,
        (0, $4udGV.getNextMonth)(monthAndYears[monthAndYears.length - 1])
    ], getDayFlags));
    const [hovering, setHovering] = (0, $dvPqk.useState)();
    const [focusedDate, setFocusedDate] = (0, $dvPqk.useState)();
    const ref = (0, $dvPqk.useRef)(null);
    const lowestMonthAndYear = (0, $dvPqk.useMemo)(()=>(0, $4udGV.getLowestMonthAndYear)(min), [
        min
    ]);
    const highestMonthAndYear = (0, $dvPqk.useMemo)(()=>(0, $4udGV.getHighestMonthAndYear)(max), [
        max
    ]);
    const previousMonthAndYear = (0, $dvPqk.useMemo)(()=>{
        const previous = (0, $4udGV.getPreviousMonth)(monthAndYears[0]);
        if ((0, $4udGV.monthAndYearCompare)(previous, lowestMonthAndYear) >= 0) return previous;
    }, [
        monthAndYears,
        lowestMonthAndYear
    ]);
    const nextMonthAndYear = (0, $dvPqk.useMemo)(()=>{
        const next = (0, $4udGV.getNextMonth)(monthAndYears[monthAndYears.length - 1]);
        if ((0, $4udGV.monthAndYearCompare)(next, highestMonthAndYear) <= 0) return next;
    }, [
        monthAndYears,
        highestMonthAndYear
    ]);
    (0, $dvPqk.useEffect)(()=>{
        if (document.activeElement && ref.current) {
            if (ref.current === document.activeElement || ref.current.contains(document.activeElement)) {
                const focusedDay = ref.current?.querySelector('[data-focused="true"]');
                if (focusedDay && focusedDay instanceof HTMLElement) focusedDay.focus();
            }
        }
    }, [
        monthAndYears,
        focusedDate
    ]);
    (0, $dvPqk.useEffect)(()=>{
        setCalendarMatrix((0, $4udGV.createCalendarMatrix)([
            (0, $4udGV.getPreviousMonth)(monthAndYears[0]),
            ...monthAndYears,
            (0, $4udGV.getNextMonth)(monthAndYears[monthAndYears.length - 1])
        ], getDayFlags));
        const handleFocus = (e)=>{
            if (e.target === ref.current) setFocusedDate((0, $4udGV.getSelectedOrFirstSelectableDate)(monthAndYears, getDayFlags));
        };
        const handleFocusOut = (e)=>{
            if (ref.current) {
                if (e.relatedTarget instanceof HTMLElement) {
                    if (!ref.current?.contains(e.relatedTarget)) setFocusedDate(undefined);
                }
            }
        };
        if (ref.current) {
            ref.current.addEventListener("focus", handleFocus);
            ref.current.addEventListener("focusout", handleFocusOut);
        }
        if (focusedDate && !(0, $4udGV.isInMonthYears)(focusedDate, monthAndYears)) setFocusedDate((0, $4udGV.getSelectedOrFirstSelectableDate)(monthAndYears, getDayFlags));
        return ()=>{
            ref.current?.removeEventListener("focus", handleFocus);
            ref.current?.removeEventListener("focusout", handleFocusOut);
        };
    }, [
        monthAndYears
    ]);
    (0, $dvPqk.useEffect)(()=>{
        const handleFocus = (e)=>{
            if (e.target instanceof HTMLElement) {
                const focusedDay = e.target.querySelector('[data-focused="true"]');
                if (focusedDay && focusedDay instanceof HTMLElement) focusedDay.focus();
            }
        };
        if (ref.current) ref.current.addEventListener("focus", handleFocus);
        return ()=>{
            if (ref.current) ref.current.removeEventListener("focus", handleFocus);
        };
    }, [
        ref
    ]);
    (0, $dvPqk.useEffect)(()=>{
        setMonthAndYears((0, $4udGV.getMonthAndYears)(month, year, monthCount, min, max));
    }, [
        monthCount,
        month,
        year,
        min,
        max
    ]);
    (0, $dvPqk.useEffect)(()=>{
        const handleMouseOver = (e)=>{
            if (e.target instanceof HTMLElement) {
                const { date: date } = e.target.dataset;
                if (date) setHovering(new Date(date));
            }
        };
        const handleFocusIn = (e)=>{
            if (e.target instanceof HTMLElement) {
                const { date: date } = e.target.dataset;
                if (date) setHovering(new Date(date));
            }
        };
        if (ref.current) {
            if (selecting) {
                ref.current.addEventListener("mouseover", handleMouseOver);
                ref.current.addEventListener("focusin", handleFocusIn);
            }
        }
        return ()=>{
            if (ref.current) {
                ref.current.removeEventListener("mouseover", handleMouseOver);
                ref.current.removeEventListener("focusin", handleFocusIn);
            }
        };
    }, [
        selecting
    ]);
    const augmentedGetDayFlags = (date)=>{
        const flags = getDayFlags(date);
        if (selecting && hovering) {
            if ((0, $4udGV.isDateBetween)(date, selecting, hovering)) flags.inRange = true;
            else flags.inRange = false;
        }
        if (focusedDate && (0, $fbCoc.default)(focusedDate, date)) flags.focused = true;
        return flags;
    };
    const { size: size } = props;
    const handleDayClicked = (date, element)=>{
        const flags = augmentedGetDayFlags(date);
        setHovering(undefined);
        if (flags.selectable) setFocusedDate(date);
        if (onDayClicked) onDayClicked(date, element);
    };
    const handleNavigation = (to)=>{
        let newMonthsAndYears = monthAndYears;
        if (to.month === nextMonthAndYear?.month && to.year === nextMonthAndYear.year) {
            newMonthsAndYears = [
                ...monthAndYears,
                nextMonthAndYear
            ];
            newMonthsAndYears.shift();
            setMonthAndYears(newMonthsAndYears);
        }
        if (to.month === previousMonthAndYear?.month && to.year === previousMonthAndYear.year) {
            newMonthsAndYears = [
                previousMonthAndYear,
                ...monthAndYears
            ];
            newMonthsAndYears.pop();
            setMonthAndYears(newMonthsAndYears);
        }
    };
    (0, $dvPqk.useEffect)(()=>{
        const keydownHandler = (e)=>{
            const { key: key } = e;
            if ((0, $4udGV.isArrowDirection)(key) && focusedDate) {
                e.preventDefault();
                e.stopPropagation();
                onArrowKeyDown(key);
            }
        };
        ref.current?.addEventListener("keydown", keydownHandler);
        return ()=>{
            ref.current?.removeEventListener("keydown", keydownHandler);
        };
    }, [
        ref,
        focusedDate
    ]);
    const className = (0, $izjX7.cn)({
        "grid divide-x divide-y-0 divide-solid divide-ink-brand-subtle": monthCount > 1,
        "grid-cols-2": monthCount === 2,
        "grid-cols-3": monthCount === 3,
        "grid-cols-4": monthCount === 4,
        "!outline-0": isArrowFocus
    });
    const onArrowKeyDown = (direction)=>{
        if (focusedDate) {
            const targetDate = (0, $4udGV.getRelativeDate)(focusedDate, direction, calendarMatrix);
            if (targetDate) {
                const earliestDate = new Date(monthAndYears[0].year, monthAndYears[0].month, 1);
                const latestDate = (0, $koTPy.default)(new Date(monthAndYears[monthAndYears.length - 1].year, monthAndYears[monthAndYears.length - 1].month, 1));
                if ((0, $1Qg53.default)(targetDate, earliestDate) || (0, $kuUjW.default)(targetDate, latestDate)) handleNavigation({
                    year: targetDate.getFullYear(),
                    month: targetDate.getMonth()
                });
                setFocusedDate(targetDate);
            }
        }
    };
    const optionalProps = isArrowFocus ? {
        tabIndex: 0
    } : {};
    const monthHeaderStyle = (0, $izjX7.cn)("h-8 text-center leading-8", {
        "text-[14px]": size === "compact"
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "px-3",
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
                    gap: 0,
                    cols: monthAndYears.length,
                    className: "relative w-full",
                    children: [
                        monthAndYears.map((monthAndYear)=>{
                            const { month: month, year: year } = monthAndYear;
                            return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: monthHeaderStyle,
                                children: [
                                    (0, $5OqMf.monthNames)[month],
                                    ", ",
                                    year
                                ]
                            }, `monthAndYearHeader-${month}-${year}`);
                        }),
                        !!previousMonthAndYear && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "absolute left-0",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                variant: "tertiary",
                                size: size,
                                onClick: ()=>handleNavigation(previousMonthAndYear),
                                icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a4r3l.default), {})
                            })
                        }),
                        !!nextMonthAndYear && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "absolute right-0",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                variant: "tertiary",
                                size: size,
                                onClick: ()=>handleNavigation(nextMonthAndYear),
                                icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $doGx2.default), {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                ref: ref,
                className: className,
                ...optionalProps,
                style: $87ef1331964718ce$var$style,
                children: monthAndYears.map((monthAndYear)=>{
                    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "px-3",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $h0cPN.default), {
                            getDayFlags: augmentedGetDayFlags,
                            ...monthAndYear,
                            ...props,
                            focusedDate: focusedDate,
                            onArrowKeyDown: onArrowKeyDown,
                            onDayClicked: handleDayClicked
                        })
                    }, `month-grid-${monthAndYear.month}-${monthAndYear.year}`);
                })
            })
        ]
    });
};
var $87ef1331964718ce$export$2e2bcd8739ae039 = $87ef1331964718ce$var$Months;

});
parcelRegister("a4r3l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $754f43411a8b2fe6$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $754f43411a8b2fe6$var$SvgChevronLeft = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m14 17-5-5 5-5 1.063 1.063L11.125 12l3.938 3.938z"
        })
    }));
var $754f43411a8b2fe6$export$2e2bcd8739ae039 = $754f43411a8b2fe6$var$SvgChevronLeft;

});

parcelRegister("doGx2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c0e8237b5d13bc2$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $9c0e8237b5d13bc2$var$SvgChevronRight = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M13.938 12 10 8.063 11.063 7l5 5-5 5L10 15.938z"
        })
    }));
var $9c0e8237b5d13bc2$export$2e2bcd8739ae039 = $9c0e8237b5d13bc2$var$SvgChevronRight;

});

parcelRegister("h0cPN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1970cbf00b44e8a5$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");
var $jOOuf = parcelRequire("jOOuf");

var $izjX7 = parcelRequire("izjX7");

var $fjQgv = parcelRequire("fjQgv");

var $dvPqk = parcelRequire("dvPqk");

var $5OqMf = parcelRequire("5OqMf");

var $kt37g = parcelRequire("kt37g");
const $1970cbf00b44e8a5$var$Month = ({ month: month, year: year, showWeekNumber: showWeekNumber, weekStartsOn: weekStartsOn = 1, currentMonthOnly: currentMonthOnly = false, getDayFlags: getDayFlags, size: size = "compact", onDayClicked: onDayClicked = ()=>{}, onArrowKeyDown: onArrowKeyDown, focusedDate: focusedDate })=>{
    const weekCount = (0, $dvPqk.useMemo)(()=>(0, $fjQgv.default)(new Date(year, month, 1), {
            weekStartsOn: weekStartsOn
        }), [
        weekStartsOn,
        month,
        year
    ]);
    const weekIndices = (0, $dvPqk.useMemo)(()=>Array.from(Array(weekCount).keys()), [
        weekCount
    ]);
    const days = (0, $dvPqk.useMemo)(()=>(0, $5OqMf.weekDayNames).map((_n, i, arr)=>arr[(i + weekStartsOn) % 7]), [
        weekIndices,
        weekStartsOn
    ]);
    const dayOfWeekCN = (0, $izjX7.cn)("text-center", {
        "text-sm": size === "compact"
    });
    const style = {
        "--button-border-radius": "0.25rem"
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
        className: "items-start",
        style: style,
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
            cols: showWeekNumber ? 8 : 7,
            gap: 0,
            children: [
                showWeekNumber && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {}),
                days.map((day)=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: dayOfWeekCN,
                        children: day
                    }, `day-${day}-month-${month}-year-${year}`)),
                weekIndices.map((weekIndex)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $kt37g.default), {
                        weekIndex: weekIndex,
                        month: month,
                        year: year,
                        size: size,
                        getDayFlags: getDayFlags,
                        showWeekNumber: showWeekNumber,
                        currentMonthOnly: currentMonthOnly,
                        weekStartsOn: weekStartsOn,
                        onDayClicked: onDayClicked,
                        isArrowFocus: !!onArrowKeyDown,
                        focusedDate: focusedDate
                    }, `week-${weekIndex}-${month}-${year}`))
            ]
        })
    });
};
var $1970cbf00b44e8a5$export$2e2bcd8739ae039 = $1970cbf00b44e8a5$var$Month;

});
parcelRegister("kt37g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d7a7b25219785e1$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $iRBte = parcelRequire("iRBte");
var $fbCoc = parcelRequire("fbCoc");

var $dvPqk = parcelRequire("dvPqk");

var $4udGV = parcelRequire("4udGV");

var $lXoWu = parcelRequire("lXoWu");
const $3d7a7b25219785e1$var$Week = ({ weekIndex: weekIndex, month: month, year: year, weekStartsOn: weekStartsOn = 1, showWeekNumber: showWeekNumber = false, currentMonthOnly: currentMonthOnly, isArrowFocus: isArrowFocus, focusedDate: focusedDate, getDayFlags: getDayFlags, size: size, onDayClicked: onDayClicked })=>{
    const dates = (0, $dvPqk.useMemo)(()=>{
        return (0, $4udGV.datesForWeek)(weekIndex, {
            month: month,
            year: year
        }, weekStartsOn);
    }, [
        weekIndex,
        month,
        year
    ]);
    const thursday = (0, $dvPqk.useMemo)(()=>dates.find((date)=>date.getDay() === 4), [
        dates
    ]);
    const weekNumber = showWeekNumber && thursday ? (0, $iRBte.default)(thursday) : undefined;
    const weekNumberCN = (0, $izjX7.cn)("flex items-center justify-center", "text-ink-brand-subtle", {
        "text-sm": size === "compact"
    });
    const dayFlags = (date)=>{
        const notInMonth = date.getMonth() !== month;
        const flags = getDayFlags(date);
        if (!notInMonth && focusedDate && (0, $fbCoc.default)(focusedDate, date)) flags.focused = true;
        return {
            ...flags,
            notInMonth: notInMonth,
            focused: flags.focused && !notInMonth
        };
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            typeof weekNumber === "number" && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: weekNumberCN,
                children: weekNumber
            }),
            dates.map((date)=>{
                if (currentMonthOnly && date.getMonth() !== month) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {}, `${date.toISOString()}-${month}`);
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lXoWu.default), {
                    date: date,
                    ...dayFlags(date),
                    size: size,
                    onDayClicked: onDayClicked,
                    isArrowFocus: isArrowFocus
                }, `${date.toISOString()}-${month}`);
            })
        ]
    });
};
var $3d7a7b25219785e1$export$2e2bcd8739ae039 = $3d7a7b25219785e1$var$Week;

});
parcelRegister("iRBte", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbba3e124b3f5272$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hhNDN = parcelRequire("hhNDN");

var $g02FC = parcelRequire("g02FC");

var $hFacL = parcelRequire("hFacL");
var $dbba3e124b3f5272$var$MILLISECONDS_IN_WEEK = 604800000;
function $dbba3e124b3f5272$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var diff = (0, $hhNDN.default)(date).getTime() - (0, $g02FC.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $dbba3e124b3f5272$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("hhNDN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c95a87d432bcfdc2$export$2e2bcd8739ae039; });

var $7NesW = parcelRequire("7NesW");

var $hFacL = parcelRequire("hFacL");
function $c95a87d432bcfdc2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    return (0, $7NesW.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});

parcelRegister("g02FC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba5eb7b138e2407b$export$2e2bcd8739ae039; });

var $6b1h0 = parcelRequire("6b1h0");

var $hhNDN = parcelRequire("hhNDN");

var $hFacL = parcelRequire("hFacL");
function $ba5eb7b138e2407b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var year = (0, $6b1h0.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $hhNDN.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("6b1h0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47f4c203e344ac3c$export$2e2bcd8739ae039; });

var $8pX4r = parcelRequire("8pX4r");

var $hhNDN = parcelRequire("hhNDN");

var $hFacL = parcelRequire("hFacL");
function $47f4c203e344ac3c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $hFacL.default)(1, arguments);
    var date = (0, $8pX4r.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $hhNDN.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $hhNDN.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("lXoWu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e79d153d9fc8253$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $b3J4G = parcelRequire("b3J4G");

var $cGjF4 = parcelRequire("cGjF4");

var $izjX7 = parcelRequire("izjX7");

var $akfNn = parcelRequire("akfNn");

var $dvPqk = parcelRequire("dvPqk");

var $5OqMf = parcelRequire("5OqMf");
const $2e79d153d9fc8253$export$20bce677d7c5d811 = ({ notInMonth: notInMonth, disabled: disabled, holiday: holiday, cancelled: cancelled, paused: paused, loading: loading, inRange: inRange, focused: focused, selected: selected, secondary: secondary, delivery: delivery, extraDelivery: extraDelivery })=>(0, $izjX7.cn)("m-px !no-underline", {
        "text-ink-brand-subtle hover:text-ink-brand-default": notInMonth,
        "!border-transparent !bg-transparent": disabled,
        "!text-calendar-holiday-text": holiday,
        "hover:!bg-calendar-holiday-bg-hover": holiday && !disabled,
        "!border-calendar-cancelled-border !bg-calendar-cancelled-bg": cancelled,
        "!text-calendar-cancelled-text": cancelled && !holiday,
        "!border-calendar-paused-border !bg-calendar-paused-bg !text-calendar-paused-text hover:!bg-calendar-paused-bg-hover": paused,
        "!border-button-primary-bg !bg-button-primary-bg !text-ink-default [&>svg]:!fill-base-0": !paused && loading,
        "[&>svg]:!fill-ink-default": paused && loading,
        "!bg-button-tertiary-bg-hover": inRange,
        "outline outline-2 outline-ink-focus": focused && !notInMonth,
        "bg-calendar-extra-bg hover:bg-calendar-extra-bg-hover hover:border-calendar-extra-bg-hover hover:no-underline": extraDelivery,
        "bg-calendar-selectable-bg hover:bg-calendar-selectable-bg-hover hover:border-calendar-selectable-bg-hover hover:no-underline": delivery && !selected && !notInMonth && !secondary,
        "!text-calendar-selected-text !bg-calendar-selected-bg !border-calendar-selected-bg hover:brightness-200 hover:filter": selected && !notInMonth
    });
const $2e79d153d9fc8253$var$Day = ({ date: date, className: className = "", size: size, isArrowFocus: isArrowFocus = false, onDayClicked: onDayClicked, selected: selected = false, selectable: selectable = true, secondary: secondary = false, holiday: holiday = false, cancelled: cancelled = false, disabled: disabled = false, notInMonth: notInMonth = false, loading: loading = false, paused: paused = false, inRange: inRange = false, focused: focused = false, delivery: delivery = false, extraDelivery: nowindow = false, ...props })=>{
    const ref = (0, $dvPqk.useRef)(null);
    const dayFlags = {
        delivery: delivery,
        selectable: selectable,
        secondary: secondary,
        holiday: holiday,
        cancelled: cancelled,
        disabled: disabled,
        notInMonth: notInMonth,
        loading: loading,
        inRange: inRange,
        selected: selected,
        paused: paused,
        focused: focused,
        extraDelivery: nowindow
    };
    const dayOfMonth = (0, $dvPqk.useMemo)(()=>date.getDate(), [
        date
    ]);
    const buttonCN = (0, $izjX7.cn)(className, $2e79d153d9fc8253$export$20bce677d7c5d811(dayFlags));
    const variant = !notInMonth && secondary ? "secondary" : "tertiary";
    const handleClick = ()=>{
        if (selectable && ref.current && ref.current instanceof HTMLElement) onDayClicked(date, ref.current);
    };
    const handleKeyDown = (e)=>{
        const { key: key, shiftKey: shiftKey } = e;
        if (key === "Tab" && shiftKey) {
            e.preventDefault();
            const monthsElement = e.currentTarget.closest('div[tabIndex="0"]');
            if (monthsElement) {
                const focusableElements = (0, $5OqMf.getKeyboardFocusableElements)();
                const monthsIndex = focusableElements.findIndex((focusable)=>focusable === monthsElement);
                if (monthsIndex) focusableElements[monthsIndex - 1].focus();
            }
        }
    };
    const optionalProps = isArrowFocus ? {
        tabIndex: -1,
        onKeyDown: handleKeyDown
    } : {};
    if (focused && !notInMonth) optionalProps["data-focused"] = true;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $cGjF4.Button), {
        ref: ref,
        "data-testid": disabled ? undefined : "day-button",
        variant: variant,
        size: size,
        disabled: disabled || cancelled,
        "data-date": (0, $akfNn.default)(date, {
            representation: "date"
        }),
        ...props,
        ...optionalProps,
        className: buttonCN,
        onClick: handleClick,
        children: [
            !loading && dayOfMonth,
            !!loading && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3J4G.default), {
                className: "animate-spin"
            })
        ]
    });
};
var $2e79d153d9fc8253$export$2e2bcd8739ae039 = $2e79d153d9fc8253$var$Day;

});







parcelRegister("dV1cT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a22188ec9522b819$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $a22188ec9522b819$var$SvgPen = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M6.5 18.125h1.063l7.812-7.812-1.062-1.063L6.5 17.063zm-1.5 1.5v-3.187L16.438 5l3.187 3.188L8.188 19.624zm9.834-9.834-.521-.541 1.062 1.063z"
        })
    }));
var $a22188ec9522b819$export$2e2bcd8739ae039 = $a22188ec9522b819$var$SvgPen;

});

parcelRegister("7dAjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c05539ca8c9d0261$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $gyNqR = parcelRequire("gyNqR");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $c05539ca8c9d0261$var$justifyClassName = {
    start: "justify-start",
    around: "justify-around",
    between: "justify-between",
    end: "justify-end",
    center: "justify-center"
};
const $c05539ca8c9d0261$var$lgAlignItemsClassName = {
    start: "lg:items-start",
    stretch: "lg:items-stretch",
    end: "lg:items-end",
    center: "lg:items-center",
    baseline: "lg:items-baseline"
};
/**
 * The InfoLine element displays a row of data with a label and a value.
 * On desktop the label is shown on the same line as the value.
 * On mobile the label is shown above the line with the value because the label and value often take too much horisontal space.
 */ const $c05539ca8c9d0261$var$InfoLine = ({ label: label, labelClassName: labelClassName = "", value: value, valueClassName: valueClassName = "", className: className = "", align: align = "between", valign: valign = "center", margin: margin = false, rowOnMobile: rowOnMobile = false, onClick: onClick = ()=>{} })=>{
    const classNames = (0, $izjX7.cn)(`flex ${$c05539ca8c9d0261$var$justifyClassName[align]}`, className, {
        [`flex-col flex-wrap items-start lg:flex-row ${$c05539ca8c9d0261$var$lgAlignItemsClassName[valign]}`]: !rowOnMobile,
        "mb-2": margin
    });
    return(// biome-ignore lint/a11y/noStaticElementInteractions: maybe this should be a button when an onClick is provided?
    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: classNames,
        onClick: onClick,
        "data-testid": "info-line",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: `lg:pr-1 ${labelClassName}`,
                children: (0, $gyNqR.default)(label) ? `${label}:` : ""
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: `lg:pl-1 lg:text-right ${valueClassName} ${(0, $gyNqR.default)(value) ? "font-bold" : ""}`,
                "data-testid": "info-line-value",
                children: value ?? ""
            })
        ]
    }));
};
var $c05539ca8c9d0261$export$2e2bcd8739ae039 = (0, $gBcml.observer)($c05539ca8c9d0261$var$InfoLine);

});

parcelRegister("5V760", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $011cc5492a14f3e0$export$4b85d3515bd863a5; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $lFdyG = parcelRequire("lFdyG");

var $9u2QX = parcelRequire("9u2QX");
function $011cc5492a14f3e0$export$4b85d3515bd863a5({ className: t, isLabelHidden: r = !0, placeholder: n, label: l, onChange: d, isDisabled: o, autoComplete: c = "off", onKeyDown: f, value: b, ref: u, ...m }) {
    const a = (0, $dvPqk.useId)();
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("search", {
        className: (0, $6sMuH.cn)("flex flex-col gap-y-2 w-full", t),
        children: [
            r ? null : /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lFdyG.FormDetails), {
                id: a,
                isLabelHidden: r,
                label: l
            }),
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: "relative overflow-clip flex items-center rounded-full [&:has(:focus-visible)]:ring ring-information-600",
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "absolute left-2 pointer-events-none fill-ink-disabled",
                        children: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $9u2QX.default), {
                            className: "w-6 h-6"
                        })
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)("input", {
                        autoComplete: c,
                        className: (0, $6sMuH.cn)("block w-full text-base rounded-full bg-base-50 p-2 text-ink-brand-default placeholder:text-ink-disabled", // border
                        "border-2 border-base-400 hover:border-ink-brand-default", // focus
                        "focus-visible:border-link-default outline-none focus-visible:bg-base-0", // disabled
                        o && "cursor-not-allowed bg-base-50 text-ink-disabled border-base-300", "pl-8"),
                        disabled: o,
                        id: a,
                        name: l,
                        onChange: d,
                        onKeyDown: f,
                        placeholder: n,
                        ref: u,
                        type: "search",
                        value: b,
                        ...m
                    })
                ]
            })
        ]
    });
}
$011cc5492a14f3e0$export$4b85d3515bd863a5.displayName = "Search";

});
parcelRegister("9u2QX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e7920f77c7cb659$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $6e7920f77c7cb659$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m19.334 21-5.991-5.992a6 6 0 0 1-1.748.82 7 7 0 0 1-2.03.3q-2.736 0-4.65-1.915Q3 12.299 3 9.563 3 6.83 4.914 4.915 6.83 3 9.564 3t4.649 1.914 1.914 4.65q0 1.029-.273 1.969a6 6 0 0 1-.82 1.735l6.016 6.017zm-9.77-7.31q1.74 0 2.933-1.193 1.194-1.193 1.194-2.933T12.497 6.63 9.564 5.436 6.63 6.63Q5.436 7.822 5.436 9.564q0 1.74 1.194 2.933 1.192 1.194 2.934 1.194"
        })
    }));

});


parcelRegister("igSaW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4d3bebfa116f4a4$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $d4d3bebfa116f4a4$var$SvgBin = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M5.286 21V6.214H4V4.286h5.143V3h5.143v1.286h5.143v1.928h-1.286V21zm1.928-1.929h9V6.214h-9zm1.929-1.928h1.928v-9H9.143zm3.214 0h1.929v-9h-1.929z"
        })
    }));
var $d4d3bebfa116f4a4$export$2e2bcd8739ae039 = $d4d3bebfa116f4a4$var$SvgBin;

});

parcelRegister("azSBj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b3786d7b5ab396b$export$2e2bcd8739ae039; });

var $4pfJj = parcelRequire("4pfJj");

var $3jH8d = parcelRequire("3jH8d");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $7b3786d7b5ab396b$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = (0, $3jH8d.default)(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = (0, $3jH8d.default)(lower);
        lower = lower === lower ? lower : 0;
    }
    return (0, $4pfJj.default)((0, $3jH8d.default)(number), lower, upper);
}
var $7b3786d7b5ab396b$export$2e2bcd8739ae039 = $7b3786d7b5ab396b$var$clamp;

});
parcelRegister("4pfJj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3355b2dc8f2cf841$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $3355b2dc8f2cf841$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
var $3355b2dc8f2cf841$export$2e2bcd8739ae039 = $3355b2dc8f2cf841$var$baseClamp;

});


parcelRegister("6wnBz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fab835bfa90056e$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $exyFT = parcelRequire("exyFT");

var $9AGLN = parcelRequire("9AGLN");
var $jOOuf = parcelRequire("jOOuf");
var $fqWHZ = parcelRequire("fqWHZ");

var $loTcB = parcelRequire("loTcB");
var $cYzPN = parcelRequire("cYzPN");
var $jQCqo = parcelRequire("jQCqo");
var $7FZkz = parcelRequire("7FZkz");
var $gIlix = parcelRequire("gIlix");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $gtsdT = parcelRequire("gtsdT");

var $cLLe3 = parcelRequire("cLLe3");

var $hjZoX = parcelRequire("hjZoX");

var $3Uk2n = parcelRequire("3Uk2n");

var $a7WSl = parcelRequire("a7WSl");

var $6Fwsu = parcelRequire("6Fwsu");

var $kUJJo = parcelRequire("kUJJo");

var $76PCP = parcelRequire("76PCP");

var $hOaHV = parcelRequire("hOaHV");

var $gvoND = parcelRequire("gvoND");
const $5fab835bfa90056e$var$textMuted = "text-muted";
const $5fab835bfa90056e$var$AddToFavoriteModal = ({ isOpen: isOpen = false, onCloseModal: onCloseModal, favoriteListAdded: favoriteListAdded })=>{
    const [mode, setMode] = (0, $dvPqk.useState)("existingList");
    const favoriteLists = (0, $jQCqo.default)((0, $gIlix.default)((0, $hOaHV.default).allFavoriteLists), (l)=>(0, $7FZkz.default)(l.listName));
    const onClose = ()=>{
        onCloseModal();
        setMode("existingList");
    };
    if (mode === "existingList") return /*#__PURE__*/ (0, $7YWoO.jsx)($5fab835bfa90056e$var$AddToExistingList, {
        favoriteLists: favoriteLists,
        onClose: onClose,
        onAddedToList: favoriteListAdded,
        setMode: setMode,
        isOpen: isOpen
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)($5fab835bfa90056e$var$AddNewList, {
        onClose: onClose,
        onNewListAdded: favoriteListAdded,
        isOpen: isOpen
    });
};
const $5fab835bfa90056e$var$AddNewList = (0, $gBcml.observer)(({ onClose: onClose, isOpen: isOpen, onNewListAdded: onNewListAdded })=>{
    const cartItems = (0, $76PCP.default).items;
    const favoriteItems = (0, $cYzPN.default)((0, $loTcB.default)(cartItems, "sku"), "qty");
    const skus = cartItems.map(({ sku: sku })=>sku);
    const qtySum = cartItems.reduce((prev, item)=>prev + item.qty, 0);
    const handleSubmit = async (data)=>{
        try {
            if (data.listName === undefined) return {};
            const list = await (0, $hOaHV.default).createNewListInStorage(data.listName);
            (0, $gvoND.default).addSuccess("Opprettet", "Favorittlisten har blitt opprettet.");
            if (typeof list === "object") {
                const listId = (0, $hOaHV.default).getFavoriteListByName(data.listName)?.id;
                if (listId) (0, $hOaHV.default).addMultipleFavorites(skus, list.id, favoriteItems);
            }
            onNewListAdded();
            onClose();
            return {
                resetFormFields: true
            };
        } catch (err) {
            (0, $gtsdT.logger).error("favorites", "Error creating favorite list:", err);
            (0, $gvoND.default).addError("Det oppsto en feil", "Kunne ikke opprette favorittlisten. Pr\xf8v igjen senere.");
            return {
                resetFormFields: false
            };
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kUJJo.default), {
        title: "Lagre ny favorittliste",
        isOpen: isOpen,
        name: "Legg til i favorittliste",
        zIndex: 1050,
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $a7WSl.default), {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6Fwsu.default), {
                    type: "text",
                    initialValue: "",
                    name: "listName",
                    label: "",
                    placeholder: "Navn p\xe5 listen",
                    validator: (0, $3Uk2n.validateFavoriteListName),
                    "data-testid": "add-new-favorite-list-from-cart-input",
                    required: true
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)("small", {
                    className: $5fab835bfa90056e$var$textMuted,
                    children: [
                        "Du \xf8nsker \xe5 legge til ",
                        qtySum,
                        " produkter \u2013 ",
                        skus.length,
                        " varelinje(r) \u2013 i denne favorittlisten."
                    ]
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                    justify: "end",
                    gap: 1,
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                            variant: "secondary",
                            className: "me-2",
                            onClick: onClose,
                            children: "Avbryt"
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                            variant: "primary",
                            type: "submit",
                            "data-testid": "save-new-favorite-list-from-cart-button",
                            children: "Lagre"
                        })
                    ]
                })
            ]
        })
    });
});
const $5fab835bfa90056e$var$AddToExistingList = (0, $gBcml.observer)(({ favoriteLists: favoriteLists, onAddedToList: onAddedToList, setMode: setMode, isOpen: isOpen, onClose: onClose })=>{
    const cartItems = (0, $76PCP.default).items;
    const skus = cartItems.map(({ sku: sku })=>sku);
    const favoriteItems = (0, $cYzPN.default)((0, $loTcB.default)(cartItems, "sku"), "qty");
    const [checkedLists, setCheckedLists] = (0, $dvPqk.useState)([]);
    const onCheckList = (listId)=>{
        setCheckedLists([
            ...checkedLists,
            listId
        ]);
    };
    const onUncheckList = (listId)=>{
        const newList = checkedLists.filter((id)=>id !== listId);
        setCheckedLists(newList);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        checkedLists.map((listId)=>{
            (0, $hOaHV.default).addMultipleFavorites(skus, listId, favoriteItems);
        });
        onAddedToList();
        onClose();
        (0, $gvoND.default).addSuccess("Lagret", "Favorittlisten har blitt oppdatert med nye produkter.");
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $kUJJo.default), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Lagre som favorittliste",
        name: "Legg til i favorittliste",
        zIndex: 1050,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
                align: "center",
                gap: 0,
                className: "mb-6",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        size: "regular",
                        variant: "tertiary",
                        icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $exyFT.default), {}),
                        onClick: ()=>setMode("newList"),
                        "data-testid": "create-new-favorite-list-from-cart-button",
                        children: "Lag ny liste"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("small", {
                        className: $5fab835bfa90056e$var$textMuted,
                        children: "Opprett en ny liste med de valgte varene"
                    })
                ]
            }),
            favoriteLists.length > 0 && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "px-0 py-2 md:px-3",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                                className: "m-0",
                                children: "Legg til i eksisterende liste"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("small", {
                                className: $5fab835bfa90056e$var$textMuted,
                                children: "Velg listen du \xf8nsker \xe5 legge varene i."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
                            align: "start",
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                    className: "p-0 m-0 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hjZoX.default), {
                                        cutoff: 5,
                                        items: favoriteLists.map((list)=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9AGLN.Checkbox), {
                                                    label: list.listName,
                                                    onChange: (event)=>event.target.checked ? onCheckList(list.id) : onUncheckList(list.id),
                                                    isChecked: checkedLists?.includes(list.id),
                                                    className: "mb-1"
                                                })
                                            }, `add-to-favorite-list-${list.id}`))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                                    justify: "end",
                                    align: "end",
                                    gap: 2,
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                            variant: "primary",
                                            type: "submit",
                                            disabled: checkedLists.length === 0,
                                            children: "Lagre"
                                        }),
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                            variant: "secondary",
                                            onClick: onClose,
                                            children: "Avbryt"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
});
var $5fab835bfa90056e$export$2e2bcd8739ae039 = (0, $gBcml.observer)($5fab835bfa90056e$var$AddToFavoriteModal);

});
parcelRegister("exyFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a95f0b7206d58537$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
const $a95f0b7206d58537$var$SvgAdd = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M9.763 12.238H2.75V9.762h7.012V2.75h2.476v7.012h7.012v2.476h-7.012v7.012H9.762z"
        })
    }));
var $a95f0b7206d58537$export$2e2bcd8739ae039 = $a95f0b7206d58537$var$SvgAdd;

});

parcelRegister("hjZoX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ad95463f910548$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $hNQAU = parcelRequire("hNQAU");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $cLLe3 = parcelRequire("cLLe3");
const $f4ad95463f910548$var$ExpandableList = ({ items: items, cutoff: cutoff = 3 })=>{
    const [lastVisibleListIndex, setLastVisibleListIndex] = (0, $dvPqk.useState)(0);
    const chunkList = (0, $hNQAU.default)(items, cutoff);
    const chunkStyle = "transition-[max-height] duration-500 overflow-hidden";
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        children: chunkList.map((list, index)=>{
            const heightStyle = index <= lastVisibleListIndex ? "max-h-[250px]" : "max-h-0";
            return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: (0, $izjX7.cn)(chunkStyle, heightStyle),
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            id: `visible-list-${index}`,
                            className: "flex flex-col",
                            children: index <= lastVisibleListIndex && list.map((element)=>element)
                        })
                    }),
                    index - 1 === lastVisibleListIndex && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        variant: "tertiary",
                        className: "my-2 size-fit",
                        onClick: ()=>setLastVisibleListIndex(lastVisibleListIndex + 1),
                        "aria-controls": `visible-list-${index}`,
                        children: "Vis flere"
                    })
                ]
            }, `favoritelists-list-${index + 1}`);
        })
    });
};
var $f4ad95463f910548$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f4ad95463f910548$var$ExpandableList);

});


parcelRegister("f7TNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b4e2db47dd28514$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $g9Bxb = parcelRequire("g9Bxb");
const $2b4e2db47dd28514$var$ProductImage = ({ product: product, size: size, ...rest })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
        loading: "lazy",
        width: size,
        src: (0, $g9Bxb.productImageUrl)(product.sku, size),
        ...rest,
        alt: `Produktbilde av ${product.name}`
    });
};
var $2b4e2db47dd28514$export$2e2bcd8739ae039 = (0, $gBcml.observer)($2b4e2db47dd28514$var$ProductImage);

});

parcelRegister("83iWS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8e79f11fbba2bd8$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $jOVmP = parcelRequire("jOVmP");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $i6TQx = parcelRequire("i6TQx");
const $e8e79f11fbba2bd8$var$DiscountLabel = (0, $gBcml.observer)(({ sku: sku })=>{
    const applicablePromotions = (0, $i6TQx.default).getPromotionsBySku(sku);
    return applicablePromotions.map((promotion)=>/*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: `rounded px-2 py-1 text-xxs ${promotion.applicable ? "bg-promotion text-base-0" : "bg-base-100 text-base-600"}`,
                    children: promotion.banner
                }),
                !promotion.applicable && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOVmP.Tooltip), {
                    tooltipText: promotion.inapplicableReason ?? "",
                    tooltipPosition: "top"
                })
            ]
        }, promotion.id));
});
var $e8e79f11fbba2bd8$export$2e2bcd8739ae039 = $e8e79f11fbba2bd8$var$DiscountLabel;

});

parcelRegister("9pPHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7198bcb993937aa$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $ezbi8 = parcelRequire("ezbi8");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $bZiDo = parcelRequire("bZiDo");
const $c7198bcb993937aa$var$LeadTimeWarning = ({ sku: sku, product: product, className: className = "" })=>{
    const productData = product ? product : (0, $bZiDo.default).resolveSku(sku);
    if (productData === undefined) return null;
    const hasLeadTime = !(0, $bEEBX.default)(productData.leadTime);
    const isMiniTank = productData.miniTank;
    if (!hasLeadTime && !isMiniTank) return null;
    const alertInfoText = isMiniTank ? "En minitank kan ikke reduseres i antall eller slettes etter innsending av ordre." : "Dette produktet er ikke mulig \xe5 levere p\xe5 kort varsel.";
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $ezbi8.Alert), {
            fullWidth: true,
            variant: "information",
            showCloseButton: false,
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    className: "m-0 text-xs",
                    children: alertInfoText
                }),
                hasLeadTime ? /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                    className: "m-0 text-xs",
                    children: [
                        "Leveringstid: ",
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("strong", {
                            children: [
                                productData.leadTime,
                                " dager"
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
};
var $c7198bcb993937aa$export$2e2bcd8739ae039 = (0, $gBcml.observer)($c7198bcb993937aa$var$LeadTimeWarning);

});

parcelRegister("8ldyR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $666292e741228a0a$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $666292e741228a0a$var$notificationBadgeStyle = (0, $izjX7.cn)("bg-notification-bg text-notification-text", "size-5 rounded-full text-center align-middle text-xs leading-5");
const $666292e741228a0a$var$NotificationsBadge = ({ count: count })=>{
    if (count > 0) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: $666292e741228a0a$var$notificationBadgeStyle,
        role: "img",
        "aria-label": `${count} uleste varslinger`,
        children: count
    });
};
var $666292e741228a0a$export$2e2bcd8739ae039 = (0, $gBcml.observer)($666292e741228a0a$var$NotificationsBadge);

});

parcelRegister("eCExY", function(module, exports) {

$parcel$export(module.exports, "useMenuItems", function () { return $fe7b1643af034206$export$aad046bd9909db8f; });

var $8kt8E = parcelRequire("8kt8E");

var $bcbvQ = parcelRequire("bcbvQ");

var $biFcX = parcelRequire("biFcX");

var $isIf6 = parcelRequire("isIf6");

var $Z5T7p = parcelRequire("Z5T7p");
const $fe7b1643af034206$var$allMenuItems = ()=>[
        {
            name: "Brukere og innlogging",
            link: "/customer/account"
        },
        {
            name: "Kampanjer",
            link: "/customer/promotions",
            featureFlag: (0, $isIf6.default).promotionsPage.enabled
        },
        {
            name: "Leveringsdager",
            link: "/customer/deliveries"
        },
        {
            name: "Ordrer",
            link: "/customer/orders"
        },
        {
            name: "Favorittlister",
            link: "/customer/favorites"
        },
        {
            name: "Abonnement",
            link: "/customer/subscriptions",
            featureFlag: (0, $biFcX.default).hasCustomerFeature((0, $Z5T7p.FEATURE_NAME).subscriptionOrderAvailable),
            hiddenOnPunchout: true
        },
        {
            name: "Fakturaer",
            link: "/customer/invoices",
            featureFlag: (0, $biFcX.default).hasCustomerFeature((0, $Z5T7p.FEATURE_NAME).invoicePaymentAvailable)
        },
        {
            name: "Avtalt sortiment",
            link: "/customer/contractual",
            featureFlag: (0, $biFcX.default).contractualRecommendations
        },
        {
            name: "Reklamasjoner",
            link: "/customer/claims",
            featureFlag: (0, $biFcX.default).claimsEnabled
        },
        {
            name: "Varslinger",
            link: "/customer/notifications",
            featureFlag: (0, $biFcX.default).notificationsEnabled
        },
        {
            name: "N\xf8kkeltall",
            link: "/customer/keyfigures",
            featureFlag: (0, $biFcX.default).keyFiguresAvailable
        },
        {
            name: "Bedriftsinformasjon",
            link: "/customer/companyInfo"
        }
    ];
const $fe7b1643af034206$export$aad046bd9909db8f = ()=>{
    const [currentUrl] = (0, $8kt8E.useLocation)();
    return $fe7b1643af034206$var$allMenuItems().filter((menuItem)=>{
        if (menuItem.featureFlag !== undefined && !menuItem.featureFlag) return false;
        if (menuItem.hiddenOnPunchout && (0, $bcbvQ.default).isPunchoutSession()) return false;
        return true;
    }).map((menuItem)=>({
            ...menuItem,
            isActive: currentUrl.includes(menuItem.link)
        }));
};

});

parcelRegister("6tjXJ", function(module, exports) {

$parcel$export(module.exports, "Chip", function () { return $4b64efa103b778fd$export$5a7f9a6004988d01; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");
const $4b64efa103b778fd$export$5a7f9a6004988d01 = (0, $dvPqk.forwardRef)(({ children: s, icon: e = null, iconPosition: r = "right", className: o, as: i = "button", checked: t = !1, onClick: n, disabled: b, ...d }, p)=>{
    const a = !!e;
    return /* @__PURE__ */ (0, $7YWoO.jsx)(i, {
        ...d,
        "aria-pressed": t,
        className: (0, $6sMuH.cn)(// common
        "bg-chip-default rounded-full p-2 cursor-pointer flex items-center justify-center min-w-20", // Border
        "border-button-primary-bg", // Hover
        "hover:bg-chip-default-hover", // for hasIcon
        a && "no-underline [&>svg]:ring", // for checked
        t && "bg-chip-active text-base-0 hover:bg-chip-active-hover", // for disabled
        b && "bg-button-disabled-bg text-ink-disabled hover:bg-button-disabled-bg cursor-not-allowed", // for override
        o),
        onClick: n,
        ref: p,
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("span", {
            className: (0, $6sMuH.cn)(a && "flex items-center gap-x-1"),
            children: [
                r === "left" ? e : null,
                s,
                r === "right" ? e : null
            ]
        })
    });
});
$4b64efa103b778fd$export$5a7f9a6004988d01.displayName = "Chip";

});

parcelRegister("jYTqr", function(module, exports) {

$parcel$export(module.exports, "TextArea", function () { return $e8be9d3e190b6649$export$f5c9f3c2c4054eec; });

var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $eVBn0 = parcelRequire("eVBn0");

var $lFdyG = parcelRequire("lFdyG");
function $e8be9d3e190b6649$export$f5c9f3c2c4054eec({ className: s, isDisabled: o, placeholder: l, isLabelHidden: f, value: r, label: b, description: c, maxLength: t, showMaxLength: m, errorMessage: u = "", showErrorMessage: d = !1, tooltipPosition: x = "right", tooltipText: p = "", rows: k = 4, onChange: g, ...v }) {
    const h = r == null ? void 0 : r.toString().length, n = (0, $dvPqk.useId)();
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("flex flex-col gap-2 w-full", s),
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lFdyG.FormDetails), {
                description: c,
                id: n,
                isLabelHidden: f,
                label: b,
                tooltipPosition: x,
                tooltipText: p
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("textarea", {
                className: (0, $6sMuH.cn)(// basic layout
                "block w-full transition-colors rounded text-base resize-y p-2 m-0 text-ink-brand-default font-sans placeholder:text-ink-disabled", // border
                "border border-ink-disabled hover:border-ink-brand-default focus-visible:ring-offset-1 focus-visible:ring-offset-ink-brand-default", // focus
                "focus-visible:border-ink-brand-default focus-visible:ring-2 focus-visible:ring-information-600 focus-visible:outline-none", // Invalid state
                "data-[invalid]:border-error-600 data-[invalid]:data-[hover]:border-error-600", // Disabled state
                o && "!bg-base-50 !cursor-not-allowed !text-ink-disabled", // Error state
                d && "!border-error-600"),
                disabled: o,
                id: n,
                maxLength: t,
                onChange: g,
                placeholder: l,
                rows: k,
                value: r,
                ...v
            }),
            m ? /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: (0, $6sMuH.cn)("flex justify-end text-xs text-ink-brand-default"),
                children: [
                    h,
                    "/",
                    t
                ]
            }) : null,
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $eVBn0.FormError), {
                errorMessage: u,
                showErrorMessage: d
            })
        ]
    });
}
$e8be9d3e190b6649$export$f5c9f3c2c4054eec.displayName = "TextArea";

});

parcelRegister("Xd520", function(module, exports) {
module.exports = $parcel$import("5LZhG").then(()=>parcelRequire('i7S3f'));

});

parcelRegister("4DOgN", function(module, exports) {
module.exports = $parcel$import("ccUj9").then(()=>parcelRequire('jsX6u'));

});

parcelRegister("4BzDY", function(module, exports) {
module.exports = $parcel$import("8N176").then(()=>parcelRequire('cczJx'));

});

parcelRegister("dqsOV", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("g1w0i"),
    $parcel$import("btW7r"),
    $parcel$import("auDuq")
]).then(()=>parcelRequire('3U5pN'));

});

parcelRegister("iP1Cb", function(module, exports) {
module.exports = $parcel$import("8CiBu").then(()=>parcelRequire('kjTLP'));

});

parcelRegister("ihZxD", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("btW7r"),
    $parcel$import("hB7AO")
]).then(()=>parcelRequire('eYxlk'));

});

parcelRegister("4pDmq", function(module, exports) {
module.exports = $parcel$import("6mypk").then(()=>parcelRequire('cp7HX'));

});

parcelRegister("e9jzP", function(module, exports) {
module.exports = $parcel$import("ghVjE").then(()=>parcelRequire('PIrZX'));

});

parcelRegister("mhqlt", function(module, exports) {
module.exports = $parcel$import("5ScJ1").then(()=>parcelRequire('7QGTC'));

});

parcelRegister("bdlGO", function(module, exports) {
module.exports = $parcel$import("9pOdu").then(()=>parcelRequire('ax0EU'));

});

parcelRegister("6o7QV", function(module, exports) {
module.exports = $parcel$import("ci0YQ").then(()=>parcelRequire('hN2V7'));

});

parcelRegister("fsuvZ", function(module, exports) {
module.exports = $parcel$import("hIETI").then(()=>parcelRequire('amr3n'));

});

parcelRegister("7Sli3", function(module, exports) {
module.exports = $parcel$import("lPuTa").then(()=>parcelRequire('7STpz'));

});

parcelRegister("9Ofyy", function(module, exports) {
module.exports = $parcel$import("ernzT").then(()=>parcelRequire('aY0Bg'));

});

parcelRegister("2RKVy", function(module, exports) {
module.exports = $parcel$import("4Wnio").then(()=>parcelRequire('5GcFk'));

});

parcelRegister("ev1AS", function(module, exports) {
module.exports = $parcel$import("k5JYs").then(()=>parcelRequire('4CO4e'));

});

var $0c537aa739c6f17e$exports = {};
$parcel$extendImportMap({
    "5VRsK": "logo.0aa2addb.png",
    "62Hhy": "Isdalen_premium_ICECREAM_CMYK_positiv.bc374aa4.svg",
    "MCPlP": "Isdalen_premium_ICECREAM_negativ_positiv.cbd92ef8.svg",
    "e063Z": "logo_med_tekst.85b4910f.svg",
    "eV24G": "footer_cow.2c11f05a.svg",
    "3mguL": "footer_grass.317d3c34.svg",
    "dxK8z": "logo_blue.cd635927.svg",
    "aUKr0": "logo_white.65f1fead.svg",
    "jfhKr": "julekalender_header.c941c5b8.png",
    "ffzN1": "julekalender_header_mobil.b2e5c3dd.png",
    "ho149": "julekalender_footer.c513983f.png",
    "5LZhG": "BarcodeScanner.011bf942.js",
    "ccUj9": "Cart.e904d339.js",
    "8N176": "CustomerRoutes.3d1e4b96.js",
    "3op7A": "CompanyInfo.826d0fef.js",
    "jIikO": "AccountInfo.95231f90.js",
    "kgsc2": "DeliveryDates.411313e4.js",
    "6Xf7e": "Orders.998a99d1.js",
    "is7Lp": "OrderDetails.8169e4dd.js",
    "h5z25": "FavoriteLists.870e3fca.js",
    "5c8w7": "FavoriteDetails.7d9286e8.js",
    "bEKLv": "Subscriptions.0b6bcb1d.js",
    "e3VE1": "SubscriptionDetails.3939a5a3.js",
    "f4iiQ": "Invoices.f46cfd4f.js",
    "bQN12": "ClaimsOverview.3ace8d3e.js",
    "cBhA3": "ClaimDetails.9727bbab.js",
    "hNY63": "CreateClaim.59db1c29.js",
    "8We71": "ClaimConfirmation.813d243b.js",
    "KGt1F": "NotificationsWrapper.748cd7f9.js",
    "eSrD2": "ContractualRecommendationsPage.89b3c60e.js",
    "4OnKe": "BoughtPreviously.14ae59b4.js",
    "66XU5": "QuickOrder.13dd57de.js",
    "7Kzzp": "KeyFiguresPage.548e6d1d.js",
    "auDuq": "ProductListPage.798cecb3.js",
    "btW7r": "ProductListPage.ecb18849.js",
    "g1w0i": "ProductListPage.544a1b6b.js",
    "8CiBu": "Home.bf2b7c00.js",
    "hB7AO": "SearchResult.7918a434.js",
    "bBgPR": "SearchResultsForProducts.81cfbb16.js",
    "7P1jg": "SearchResultsForV2Article.f2878d2a.js",
    "eu4ag": "SearchResultsForRecipe.1fed949b.js",
    "6mypk": "ProductDetailsPage.ae883cbf.js",
    "ghVjE": "OrderConfirmation.2d5e11b9.js",
    "5ScJ1": "SubscriptionConfirmation.39fe47fe.js",
    "9pOdu": "PickupConfirmation.e4b39e6f.js",
    "ci0YQ": "CmsContentPreview.8c4e8bce.js",
    "hIETI": "CmsContent.c81d5f30.js",
    "lPuTa": "ContactFormPage.7084b842.js",
    "ernzT": "SwitchCompanyPunchoutPage.57788221.js",
    "4Wnio": "AdventCalendarPage.e0a6662a.js",
    "k5JYs": "CookiePage.9bfdce7d.js"
});


var $7YWoO = parcelRequire("7YWoO");

var $7c65l = parcelRequire("7c65l");
var $2c7a1a9aa845011a$exports = {};
(function(f) {
    var g;
    $2c7a1a9aa845011a$exports = f();
})(function() {
    var define, module1, exports;
    var _$src_1 = {};
    function _extends() {
        return _extends = Object.assign ? Object.assign.bind() : function(n) {
            for(var e = 1; e < arguments.length; e++){
                var t = arguments[e];
                for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
            }
            return n;
        }, _extends.apply(null, arguments);
    }
    function _inheritsLoose(t, o) {
        t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
    }
    function _setPrototypeOf(t, e) {
        return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t;
        }, _setPrototypeOf(t, e);
    }
    _$src_1 = /*#__PURE__*/ function() {
        function BugsnagPluginReact() {
            // Fetch React from the window object, if it exists
            var globalReact = typeof window !== 'undefined' && window.React;
            this.name = 'react';
            this.lazy = arguments.length === 0 && !globalReact;
            if (!this.lazy) {
                this.React = (arguments.length <= 0 ? undefined : arguments[0]) || globalReact;
                if (!this.React) throw new Error('@bugsnag/plugin-react reference to `React` was undefined');
            }
        }
        var _proto = BugsnagPluginReact.prototype;
        _proto.load = function load(client) {
            if (!this.lazy) {
                var ErrorBoundary = createClass(this.React, client);
                ErrorBoundary.createErrorBoundary = function() {
                    return ErrorBoundary;
                };
                return ErrorBoundary;
            }
            var BugsnagPluginReactLazyInitializer = function() {
                throw new Error("@bugsnag/plugin-react was used incorrectly. Valid usage is as follows:\nPass React to the plugin constructor\n\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact(React)] })`\nand then call `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()`\n\nOr if React is not available until after Bugsnag has started,\nconstruct the plugin with no arguments\n  `Bugsnag.start({ plugins: [new BugsnagPluginReact()] })`,\nthen pass in React when available to construct your error boundary\n  `const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)`");
            };
            BugsnagPluginReactLazyInitializer.createErrorBoundary = function(React) {
                if (!React) throw new Error('@bugsnag/plugin-react reference to `React` was undefined');
                return createClass(React, client);
            };
            return BugsnagPluginReactLazyInitializer;
        };
        return BugsnagPluginReact;
    }();
    var formatComponentStack = function(str) {
        var lines = str.split(/\n/g);
        var ret = '';
        for(var line = 0, len = lines.length; line < len; line++)if (lines[line].length) ret += "" + (ret.length ? '\n' : '') + lines[line].trim();
        return ret;
    };
    var createClass = function(React, client) {
        return /*#__PURE__*/ function(_React$Component) {
            function ErrorBoundary(props) {
                var _this;
                _this = _React$Component.call(this, props) || this;
                _this.state = {
                    error: null,
                    info: null
                };
                _this.handleClearError = _this.handleClearError.bind(_this);
                return _this;
            }
            _inheritsLoose(ErrorBoundary, _React$Component);
            var _proto2 = ErrorBoundary.prototype;
            _proto2.handleClearError = function handleClearError() {
                this.setState({
                    error: null,
                    info: null
                });
            };
            _proto2.componentDidCatch = function componentDidCatch(error, info) {
                var onError = this.props.onError;
                var handledState = {
                    severity: 'error',
                    unhandled: true,
                    severityReason: {
                        type: 'unhandledException'
                    }
                };
                var event = client.Event.create(error, true, handledState, 1);
                if (info && info.componentStack) info.componentStack = formatComponentStack(info.componentStack);
                event.addMetadata('react', info);
                client._notify(event, onError);
                this.setState({
                    error: error,
                    info: info
                });
            };
            _proto2.render = function render() {
                var error = this.state.error;
                if (error) {
                    var FallbackComponent = this.props.FallbackComponent;
                    if (FallbackComponent) return React.createElement(FallbackComponent, _extends({}, this.state, {
                        clearError: this.handleClearError
                    }));
                    return null;
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React.Component);
    };
    _$src_1.formatComponentStack = formatComponentStack;
    _$src_1["default"] = _$src_1;
    return _$src_1;
});



var $ioVMT = parcelRequire("ioVMT");

var $bEEBX = parcelRequire("bEEBX");

var $dvPqk = parcelRequire("dvPqk");

var $bcbvQ = parcelRequire("bcbvQ");

var $a2SqC = parcelRequire("a2SqC");
parcelRequire("aRCaF");

var $ljb3n = parcelRequire("ljb3n");
var $4ac77edab4d44fe3$export$882461b6382ed46c;
var $4ac77edab4d44fe3$export$757ceba2d55c277e;
'use strict';

var $im7eH = parcelRequire("im7eH");
var $4ac77edab4d44fe3$var$i;
$4ac77edab4d44fe3$export$882461b6382ed46c = $im7eH.createRoot;
$4ac77edab4d44fe3$export$757ceba2d55c277e = $im7eH.hydrateRoot;



var $7YWoO = parcelRequire("7YWoO");

var $7c65l = parcelRequire("7c65l");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $j6ChH = parcelRequire("j6ChH");

var $8kt8E = parcelRequire("8kt8E");



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $iklLr = parcelRequire("iklLr");

var $hNpRa = parcelRequire("hNpRa");

var $gb3X9 = parcelRequire("gb3X9");

var $bcbvQ = parcelRequire("bcbvQ");
/**
 * Page for showing the "Årets Matglede" campaign report.
 */ const $be3fda7fc03da394$var$JoyOfFoodCampaignPage = ()=>{
    (0, $iklLr.default)("SEGMENTED_CONTENT");
    if (!(0, $bcbvQ.default).isLoggedIn()) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hNpRa.default), {});
    const reportName = (0, $bcbvQ.default).getCurrentCompany()?.customerGroup.startsWith("010|") ? "aretsmatglede_dagligvare" : "aretsmatglede";
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gb3X9.default), {
        reportName: reportName,
        title: `Utvikling for ${(0, $bcbvQ.default).getCurrentCompany()?.name}`,
        mobileHeightRatio: 4
    });
};
var $be3fda7fc03da394$export$2e2bcd8739ae039 = (0, $gBcml.observer)($be3fda7fc03da394$var$JoyOfFoodCampaignPage);



var $8ZCSm = parcelRequire("8ZCSm");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $7YWoO = parcelRequire("7YWoO");

var $b3J4G = parcelRequire("b3J4G");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $4udGV = parcelRequire("4udGV");

var $lKrOo = parcelRequire("lKrOo");

var $9Vhxl = parcelRequire("9Vhxl");

var $kUJJo = parcelRequire("kUJJo");
const $8bf7bc4ef5f58a43$var$ChangeDeliveryDateModal = ()=>{
    const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
    if ((0, $bEEBX.default)(currentDelivery?.date)) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kUJJo.default), {
        TitleIcon: ()=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3J4G.default), {
                className: "h-5 w-5 animate-spin"
            }),
        name: "Oppdaterer produkter og priser",
        title: "Oppdaterer produkter og priser",
        isOpen: (0, $9Vhxl.default).changingDeliveryDate && !(0, $lKrOo.default).is("DELIVERY_DATES_LOADING"),
        showCloseButton: false,
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
            children: [
                "Det hender at nye produkter er tilgjengelig eller andre priser gjelder n\xe5r man bytter leveringsdag, derfor m\xe5 vi hente et oppdatert produktutvalg og prisliste for ",
                /*#__PURE__*/ (0, $7YWoO.jsx)("strong", {
                    children: (0, $4udGV.formatDate)(currentDelivery?.date, true, true, false)
                }),
                "."
            ]
        })
    });
};
var $8bf7bc4ef5f58a43$export$2e2bcd8739ae039 = (0, $gBcml.observer)($8bf7bc4ef5f58a43$var$ChangeDeliveryDateModal);



var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");
const $7e3692a626553f69$var$outerCN = (0, $izjX7.cn)("flex", "flex-row", "justify-center", "w-full");
const $7e3692a626553f69$var$innerCN = (0, $izjX7.cn)("flex", "flex-row", "w-full", "max-w-[--main-column-max-width]", "px-3 sm:px-4 md:px-12", "shrink-0");
const $7e3692a626553f69$var$MainColumn = /*#__PURE__*/ (0, $dvPqk.forwardRef)(({ children: children, className: className = "", as: Component = "div", ...rest }, ref)=>/*#__PURE__*/ (0, $7YWoO.jsx)(Component, {
        ref: ref,
        className: (0, $izjX7.cn)([
            $7e3692a626553f69$var$outerCN,
            className
        ]),
        ...rest,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: $7e3692a626553f69$var$innerCN,
            children: children
        })
    }));
var $7e3692a626553f69$export$2e2bcd8739ae039 = $7e3692a626553f69$var$MainColumn;



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $5OqMf = parcelRequire("5OqMf");

var $4udGV = parcelRequire("4udGV");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");

var $isIf6 = parcelRequire("isIf6");

var $cLLe3 = parcelRequire("cLLe3");

var $kUJJo = parcelRequire("kUJJo");
const $3df4e69ebf2f1ee7$var$ExpiredDeadlineModal = ()=>{
    const [showModal, setShowModal] = (0, $dvPqk.useState)(false);
    const [nextDelivery, setNextDelivery] = (0, $dvPqk.useState)((0, $9Vhxl.default).getNextDeliveryDateForOrderType((0, $76PCP.default).orderType));
    const expiration = (0, $9Vhxl.default).getCurrentDeliveryExpiration();
    const orderType = (0, $76PCP.default).orderType;
    const deliveryDescription = orderType === (0, $isIf6.default).defaultOrderType ? "med leveranse" : orderType === "HPN" ? "klar for henting etter" : orderType === "WAS" ? "med f\xf8rste levering" : "";
    (0, $dvPqk.useEffect)(()=>{
        if (expiration === 0) {
            (0, $9Vhxl.default).removeExpiredDeliveryDates();
            const next = (0, $9Vhxl.default).getNextDeliveryDateForOrderType((0, $76PCP.default).orderType);
            setNextDelivery(next);
            setShowModal(true);
        }
    }, [
        expiration
    ]);
    const handleClose = ()=>{
        (0, $9Vhxl.default).selectNextDeliveryDateForOrderType((0, $76PCP.default).orderType);
        setShowModal(false);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $kUJJo.default), {
        isOpen: showModal,
        title: "Bestillingsfristen har utl\xf8pt",
        onClose: handleClose,
        name: "Advarsel: Bestillingsfristen har utl\xf8pt",
        children: [
            !!nextDelivery && /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                children: [
                    "Den nye fristen er ",
                    (0, $4udGV.formatDateTime)(nextDelivery.deadline),
                    " ",
                    deliveryDescription,
                    " ",
                    (0, $4udGV.formatDate)(nextDelivery.date, true)
                ]
            }),
            !nextDelivery && /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                children: [
                    "Vi finner dessverre ikke flere alternativer for ordretype",
                    " ",
                    (0, $5OqMf.translateOrderType)(orderType, (0, $isIf6.default).storeId).toLowerCase(),
                    ". Ta kontakt med kundeservice."
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                    variant: "primary",
                    onClick: handleClose,
                    children: "OK"
                })
            })
        ]
    });
};
var $3df4e69ebf2f1ee7$export$2e2bcd8739ae039 = (0, $gBcml.observer)($3df4e69ebf2f1ee7$var$ExpiredDeadlineModal);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $g9Bxb = parcelRequire("g9Bxb");

var $a2SqC = parcelRequire("a2SqC");
const $55089934d55e26ff$var$FlyingProduct = ({ plane: plane })=>{
    (0, $dvPqk.useEffect)(()=>{
        setTimeout(()=>{
            (0, $a2SqC.default).takeOff(plane.animationId);
        }, 200);
    }, []);
    return /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
        alt: "Produkt p\xe5 vei til handlekurven",
        src: (0, $g9Bxb.productImageUrl)(plane.sku, plane.sourceWidth),
        className: "dsp-flyer",
        style: {
            top: plane.y,
            left: plane.x,
            height: plane.height
        }
    });
};
var $55089934d55e26ff$export$2e2bcd8739ae039 = (0, $gBcml.observer)($55089934d55e26ff$var$FlyingProduct);



var $9Vrue = parcelRequire("9Vrue");

var $7YWoO = parcelRequire("7YWoO");

var $9AGLN = parcelRequire("9AGLN");
var $34rNI = parcelRequire("34rNI");
var $4OT0V = parcelRequire("4OT0V");
var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $2ATfN = parcelRequire("2ATfN");

var $gps2w = parcelRequire("gps2w");

var $eqquT = parcelRequire("eqquT");

var $9O4MK = parcelRequire("9O4MK");

var $j8VJ1 = parcelRequire("j8VJ1");

var $hvflL = parcelRequire("hvflL");

var $jQKuj = parcelRequire("jQKuj");

var $eRLkK = parcelRequire("eRLkK");

var $bnLGb = parcelRequire("bnLGb");

var $b3KIl = parcelRequire("b3KIl");

var $gfl5j = parcelRequire("gfl5j");

var $iJZQ7 = parcelRequire("iJZQ7");

var $jzfk4 = parcelRequire("jzfk4");
let $d32222fa8a29d156$var$w = (0, $dvPqk.createContext)(null);
$d32222fa8a29d156$var$w.displayName = "GroupContext";
let $d32222fa8a29d156$var$ee = (0, $dvPqk.Fragment);
function $d32222fa8a29d156$var$te(r) {
    var i;
    let [t, u] = (0, $dvPqk.useState)(null), [c, h] = (0, $jzfk4.useLabels)(), [a, v] = (0, $gfl5j.useDescriptions)(), n = (0, $dvPqk.useMemo)(()=>({
            switch: t,
            setSwitch: u,
            labelledby: c,
            describedby: a
        }), [
        t,
        u,
        c,
        a
    ]), d = {}, y = r;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(v, {
        name: "Switch.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement(h, {
        name: "Switch.Label",
        props: {
            htmlFor: (i = n.switch) == null ? void 0 : i.id,
            onClick (m) {
                t && (m.currentTarget.tagName === "LABEL" && m.preventDefault(), t.click(), t.focus({
                    preventScroll: !0
                }));
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement($d32222fa8a29d156$var$w.Provider, {
        value: n
    }, (0, $b3KIl.render)({
        ourProps: d,
        theirProps: y,
        defaultTag: $d32222fa8a29d156$var$ee,
        name: "Switch.Group"
    }))));
}
let $d32222fa8a29d156$var$re = "button";
function $d32222fa8a29d156$var$ae(r, i) {
    var t;
    let u = (0, $9O4MK.useId)(), { id: c = `headlessui-switch-${u}`, checked: h, defaultChecked: a = !1, onChange: v, disabled: n = !1, name: d, value: y, form: m, ...g } = r, l = (0, $dvPqk.useContext)($d32222fa8a29d156$var$w), p = (0, $dvPqk.useRef)(null), x = (0, $hvflL.useSyncRefs)(p, i, l === null ? null : l.setSwitch), [o, f] = (0, $2ATfN.useControllable)(h, v, a), S = (0, $eqquT.useEvent)(()=>f == null ? void 0 : f(!o)), T = (0, $eqquT.useEvent)((e)=>{
        if ((0, $eRLkK.isDisabledReactIssue7711)(e.currentTarget)) return e.preventDefault();
        e.preventDefault(), S();
    }), $ = (0, $eqquT.useEvent)((e)=>{
        e.key === (0, $iJZQ7.Keys).Space ? (e.preventDefault(), S()) : e.key === (0, $iJZQ7.Keys).Enter && (0, $bnLGb.attemptSubmit)(e.currentTarget);
    }), L = (0, $eqquT.useEvent)((e)=>e.preventDefault()), I = (0, $dvPqk.useMemo)(()=>({
            checked: o
        }), [
        o
    ]), P = {
        id: c,
        ref: x,
        role: "switch",
        type: (0, $j8VJ1.useResolveButtonType)(r, p),
        tabIndex: r.tabIndex === -1 ? 0 : (t = r.tabIndex) != null ? t : 0,
        "aria-checked": o,
        "aria-labelledby": l == null ? void 0 : l.labelledby,
        "aria-describedby": l == null ? void 0 : l.describedby,
        disabled: n,
        onClick: T,
        onKeyUp: $,
        onKeyPress: L
    }, R = (0, $gps2w.useDisposables)();
    return (0, $dvPqk.useEffect)(()=>{
        var e;
        let k = (e = p.current) == null ? void 0 : e.closest("form");
        k && a !== void 0 && R.addEventListener(k, "reset", ()=>{
            f(a);
        });
    }, [
        p,
        f
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).Fragment, null, d != null && o && (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).createElement((0, $jQKuj.Hidden), {
        features: (0, $jQKuj.Features).Hidden,
        ...(0, $b3KIl.compact)({
            as: "input",
            type: "checkbox",
            hidden: !0,
            readOnly: !0,
            disabled: n,
            form: m,
            checked: o,
            name: d,
            value: y
        })
    }), (0, $b3KIl.render)({
        ourProps: P,
        theirProps: g,
        slot: I,
        defaultTag: $d32222fa8a29d156$var$re,
        name: "Switch"
    }));
}
let $d32222fa8a29d156$var$le = (0, $b3KIl.forwardRefWithAs)($d32222fa8a29d156$var$ae), $d32222fa8a29d156$var$oe = $d32222fa8a29d156$var$te, $d32222fa8a29d156$export$b5d5cf8927ab7262 = Object.assign($d32222fa8a29d156$var$le, {
    Group: $d32222fa8a29d156$var$oe,
    Label: (0, $jzfk4.Label),
    Description: (0, $gfl5j.Description)
});


function $a26c85f8e5c7e41c$export$b5d5cf8927ab7262({ isEnabled: i, label: r, onChange: l, isLabelHidden: c = !1, isDisabled: t, className: d }) {
    const n = (0, $dvPqk.useId)();
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("flex gap-1 items-center", d),
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)((0, $d32222fa8a29d156$export$b5d5cf8927ab7262), {
                as: (0, $dvPqk.Fragment),
                checked: i,
                disabled: t,
                onChange: l,
                children: ({ checked: s })=>/* @__PURE__ */ (0, $7YWoO.jsxs)("button", {
                        className: (0, $6sMuH.cn)(// button css reset
                        "m-0 appearance-none font-inherit cursor-pointer", "group relative flex items-center rounded-full h-8 p-1 w-14", // animation
                        "transition-colors duration-200 ease-in-out", // focus
                        "focus:outline-none focus-visible:ring data-[checked]:bg-primary", "border-base-transparent", s ? "bg-surface-action hover:bg-base-600" : "bg-base-400 hover:bg-base-600", // disabled state
                        "data-[disabled]:cursor-not-allowed"),
                        id: n,
                        type: "button",
                        children: [
                            /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                className: "sr-only",
                                children: typeof r == "string" ? r : "Switch"
                            }),
                            /* @__PURE__ */ (0, $7YWoO.jsx)("span", {
                                className: (0, $6sMuH.cn)("pointer-events-none bg-base-0 inline-block size-6 rounded-full ring-0 shadow transition duration-200 ease-in-out group-data-[checked]:translate-x-6", // disabled state
                                "group-data-[disabled]:bg-base-300", s ? "translate-x-[24px] md:group-hover:translate-x-[22px]" : "-translate-x-0 md:group-hover:translate-x-0", t ? "bg-base-300 cursor-not-allowed" : "")
                            })
                        ]
                    })
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("label", {
                className: (0, $6sMuH.cn)("text-base text-ink-default", c && "sr-only"),
                htmlFor: n,
                children: r
            })
        ]
    });
}
$a26c85f8e5c7e41c$export$b5d5cf8927ab7262.displayName = "Switch";


parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $9n21e = parcelRequire("9n21e");

var $a2SqC = parcelRequire("a2SqC");

var $8ri8d = parcelRequire("8ri8d");
const $e1d5b126ce0a03e1$var$LoggerSettingsModal = ()=>{
    const [enabledTags, setEnabledTags] = (0, $dvPqk.useState)([]);
    const [allTagsEnabled, setAllTagsEnabled] = (0, $dvPqk.useState)(false);
    (0, $dvPqk.useEffect)(()=>{
        const currentEnabledTags = (0, $gtsdT.logger).getEnabledTags();
        setEnabledTags(currentEnabledTags);
        const allTagsAreEnabled = (0, $gtsdT.logTags).every((tag)=>currentEnabledTags.includes(tag));
        setAllTagsEnabled(allTagsAreEnabled);
    }, [
        (0, $a2SqC.default).showLoggerModal
    ]);
    const toggleTag = (tag)=>{
        if ((0, $gtsdT.logger).isEnabled(tag)) (0, $gtsdT.logger).disable(tag);
        else (0, $gtsdT.logger).enable(tag);
        setEnabledTags((0, $gtsdT.logger).getEnabledTags());
    };
    const toggleAllTags = ()=>{
        const newState = !allTagsEnabled;
        setAllTagsEnabled(newState);
        if (newState) {
            (0, $gtsdT.logger).enableAllTags();
            setEnabledTags((0, $gtsdT.logger).getEnabledTags());
        } else {
            (0, $gtsdT.logger).disableAllTags();
            setEnabledTags([]);
        }
    };
    const configCatOptions = [
        {
            label: "Off",
            value: "-1"
        },
        {
            label: "Error",
            value: "1"
        },
        {
            label: "Warn & error",
            value: "2"
        },
        {
            label: "Info, warn & error",
            value: "3"
        },
        {
            label: "All",
            value: "4"
        }
    ];
    const handleChange = (e)=>{
        const level = e.target.value;
        (0, $9n21e.setConfigCatLogLevelInStorage)(level);
        alert("ConfigCat-loggniv\xe5 er oppdatert. Refresh siden for at endringen skal tre i kraft (configCatClient m\xe5 reinitialiseres).");
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $34rNI.Modal), {
        size: "xl",
        title: "Innstillinger for logging",
        isOpen: (0, $a2SqC.default).showLoggerModal,
        onClose: (0, $a2SqC.default).toggleLoggerModal,
        className: "bg-background-tinted",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                className: "mb-6",
                children: "Velg hvilke tags du \xf8nsker \xe5 aktivere for console-logging:"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "flex flex-row gap-4",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a26c85f8e5c7e41c$export$b5d5cf8927ab7262), {
                    isEnabled: allTagsEnabled,
                    onChange: toggleAllTags,
                    label: "Skru p\xe5 alle tags"
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ri8d.default), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                className: "flex flex-wrap gap-4",
                children: (0, $gtsdT.logTags).map((tag)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                        className: "mb-2 flex",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9AGLN.Checkbox), {
                            isChecked: enabledTags.includes(tag),
                            onChange: ()=>toggleTag(tag),
                            "aria-label": `Toggle logging for ${tag}`,
                            label: tag,
                            isDisabled: allTagsEnabled
                        })
                    }, tag))
            }),
            (0, $8ZCSm.ENV_NAME) !== "prod" && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        className: "mt-12",
                        children: "Velg niv\xe5 av logging for ConfigCat:"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4OT0V.RadioGroup), {
                        options: configCatOptions,
                        initialValue: (0, $9n21e.getConfigCatLogLevelFromStorage)(),
                        label: "",
                        onChange: handleChange,
                        horizontal: true
                    })
                ]
            })
        ]
    });
};
var $e1d5b126ce0a03e1$export$2e2bcd8739ae039 = (0, $gBcml.observer)($e1d5b126ce0a03e1$var$LoggerSettingsModal);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $lKrOo = parcelRequire("lKrOo");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");

var $kUJJo = parcelRequire("kUJJo");
const $ab9c9c718aa6093e$var$hideModal = ()=>{
    (0, $lKrOo.default).transitionToIfPossible("NOT_LOGGED_IN");
};
const $ab9c9c718aa6093e$var$toLogin = ()=>{
    (0, $a2SqC.default).showLoginModal();
};
const $ab9c9c718aa6093e$var$ForcedLogoutModal = ()=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $kUJJo.default), {
        name: "Automatisk utlogget",
        isOpen: (0, $lKrOo.default).is("FORCED_LOGOUT"),
        onClose: $ab9c9c718aa6093e$var$hideModal,
        title: "Du har blitt logget ut...",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        children: "Fordi du har v\xe6rt borte en stund, s\xe5 har vi for sikkerhets skyld logget deg ut av l\xf8sningen."
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        children: " Du kan s\xe5 klart logge inn igjen og fortsette handleturen din om du trenger det."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex justify-end gap-2",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        onClick: $ab9c9c718aa6093e$var$toLogin,
                        children: "Til innlogging"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        variant: "secondary",
                        onClick: $ab9c9c718aa6093e$var$hideModal,
                        children: "Lukk"
                    })
                ]
            })
        ]
    });
var $ab9c9c718aa6093e$export$2e2bcd8739ae039 = (0, $gBcml.observer)($ab9c9c718aa6093e$var$ForcedLogoutModal);



var $7YWoO = parcelRequire("7YWoO");

var $cY4Gr = parcelRequire("cY4Gr");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $lKrOo = parcelRequire("lKrOo");

var $a2SqC = parcelRequire("a2SqC");

var $kUJJo = parcelRequire("kUJJo");

var $7YWoO = parcelRequire("7YWoO");

var $ezbi8 = parcelRequire("ezbi8");
var $3SASj = parcelRequire("3SASj");

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");

var $f2Bp8 = parcelRequire("f2Bp8");

var $bcbvQ = parcelRequire("bcbvQ");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");
const $1f9eaeafd625cbed$var$LoginSms = ()=>{
    const form = (0, $dvPqk.useMemo)(()=>(0, $Kk7R3.makeAutoObservable)({
            mobileNumber: (0, $f2Bp8.getPhoneNumberFromStorage)(),
            code: "",
            error: null,
            loading: false
        }), []);
    (0, $dvPqk.useEffect)(()=>{
        const disposer = (0, $Kk7R3.autorun)(()=>(0, $f2Bp8.setPhoneNumberInStorage)(form.mobileNumber));
        return ()=>disposer();
    }, [
        form
    ]);
    const requestCode = ()=>{
        if (form.mobileNumber.length === 0) {
            form.error = "mobile";
            return;
        }
        if (form.loading) return;
        form.loading = true;
        (0, $bcbvQ.default).requestSmsLoginOtp(form.mobileNumber).finally(()=>{
            form.loading = false;
        });
        (0, $6fuyt.sendLoginStep)();
    };
    const verifyCode = ()=>{
        if (form.code.length === 0) {
            form.error = "code";
            return;
        }
        (0, $bcbvQ.default).verifySmsLoginOtp(form.code).then(()=>{
            form.code = "";
            form.mobileNumber = "";
        }).catch((err)=>{
            form.error = err;
        });
    };
    const abortSMSLogin = (0, $Kk7R3.action)(()=>{
        (0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).USERNAME);
        (0, $bcbvQ.default).codeChallengeId = null;
    });
    const handleKeyPress = (event)=>{
        form.error = null;
        if (event.key === "Enter") {
            if ((0, $bEEBX.default)((0, $bcbvQ.default).codeChallengeId)) requestCode();
            else verifyCode();
        }
    };
    const isCodeSent = !(0, $bEEBX.default)((0, $bcbvQ.default).codeChallengeId);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "pb-2",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)("b", {
                        children: "Logg inn med mobilnummer"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex flex-col gap-4 pb-5",
                children: [
                    !isCodeSent ? /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        children: "Fyll inn mobilnummer og motta engangskode p\xe5 SMS."
                    }) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
                        variant: "success",
                        showCloseButton: false,
                        children: "En SMS med engangskode er sendt til mobilnummeret som er registrert p\xe5 din konto."
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                        label: "Mobilnummer",
                        placeholder: "8 siffer",
                        value: form.mobileNumber,
                        onChange: (e)=>{
                            form.mobileNumber = (0, $5OqMf.formatPhoneNumber)(e.target.value);
                        },
                        onKeyDown: handleKeyPress,
                        autoFocus: true,
                        disabled: isCodeSent,
                        type: "tel",
                        showErrorMessage: form.error === "mobile"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                        label: "Engangskode fra SMS",
                        value: form.code,
                        placeholder: "6 siffer",
                        onChange: (e)=>{
                            // Last parameter used to be e.currentTarget.prev - TODO: Ask Fredrik how this worked
                            form.code = (0, $5OqMf.formatOtp)(e.target.value, e.target.value);
                        },
                        type: "otp",
                        disabled: !isCodeSent,
                        autoFocus: isCodeSent,
                        showErrorMessage: form.error === "code",
                        errorMessage: "Koden som er angitt stemmer ikke. Vennligst pr\xf8v p\xe5 nytt."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                variant: "primary",
                size: "regular",
                onClick: (0, $bEEBX.default)((0, $bcbvQ.default).codeChallengeId) ? requestCode : verifyCode,
                loading: form.loading,
                disabled: form.loading,
                children: (0, $bEEBX.default)((0, $bcbvQ.default).codeChallengeId) ? "Send engangskode" : "Logg inn med kode"
            }),
            isCodeSent ? /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "pt-6",
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $ezbi8.Alert), {
                    variant: "information",
                    showCloseButton: false,
                    children: [
                        "Har du ikke mottatt en SMS fra oss? Logg inn med ",
                        /*#__PURE__*/ (0, $7YWoO.jsx)("strong", {
                            children: "e-post/kundenummer"
                        }),
                        " og oppdater mobilnummer p\xe5 din konto."
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex items-center gap-2 py-2",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("hr", {
                        className: "login-divider"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        className: "m-0 text-center",
                        children: "Eller"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("hr", {
                        className: "login-divider"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                size: "regular",
                variant: "secondary",
                onClick: abortSMSLogin,
                children: "Logg inn med e-post/kundenummer"
            })
        ]
    });
};
var $1f9eaeafd625cbed$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1f9eaeafd625cbed$var$LoginSms);



var $7YWoO = parcelRequire("7YWoO");

var $7YWoO = parcelRequire("7YWoO");
const $a4d728f8f69d980e$var$SvgLightning = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m7.375 21 3.375-6.75L4 13.125 14.688 3h1.687L13 9.75l6.75 1.125L9.063 21zm4.266-4.781L16.117 12l-5.648-.96 1.64-3.259-4.476 4.242 5.648.938z"
        })
    }));
var $a4d728f8f69d980e$export$2e2bcd8739ae039 = $a4d728f8f69d980e$var$SvgLightning;



var $3SASj = parcelRequire("3SASj");

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $aMYzM = parcelRequire("aMYzM");

var $gtsdT = parcelRequire("gtsdT");

var $f2Bp8 = parcelRequire("f2Bp8");

var $BjdTh = parcelRequire("BjdTh");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");

var $4r4cM = parcelRequire("4r4cM");
const $bd68fe17c48f5d90$var$LoginUsername = ()=>{
    const [params] = (0, $8kt8E.useSearchParams)();
    const customerNumberParam = params.get("kundenr");
    const formState = (0, $dvPqk.useMemo)(()=>(0, $Kk7R3.makeAutoObservable)({
            username: customerNumberParam ?? (0, $f2Bp8.getUserNameFromStorage)(),
            password: "",
            error: null
        }), []);
    const locale = (0, $BjdTh.default)();
    (0, $dvPqk.useEffect)(()=>{
        return (0, $Kk7R3.autorun)(()=>(0, $f2Bp8.setUserNameInStorage)(formState.username));
    }, []);
    const attemptLogin = (0, $Kk7R3.action)(()=>{
        formState.error = null;
        (0, $bcbvQ.default).login(formState.username, formState.password).catch((error)=>{
            (0, $gtsdT.logger).warn("auth", "Login failed", error);
            formState.error = error;
        });
    });
    const handleKeyPress = (event)=>{
        if (event.key === "Enter") attemptLogin();
    };
    const error = formState.error;
    let errorMessage = (0, $aMYzM.genericLoginErrorByLocale)[locale];
    let gaErrorTracking;
    if (error instanceof (0, $aMYzM.BackendIssueError)) {
        const backendMessages = (0, $aMYzM.backendIssueMessagesByLocale)[locale];
        const errorMap = {
            "Unable to load assortment, error from backend": "fetch_assortment_error",
            "Unable to load delivery dates / pickup": "fetch_delivery_dates_error",
            "Unable to load favourites, error from backend": "fetch_favourites_error",
            "Missing delivery dates": "missing_delivery_dates_error"
        };
        const trackingText = errorMap[error.message];
        if (trackingText) {
            gaErrorTracking = {
                context: "login",
                text: trackingText
            };
            errorMessage = backendMessages[error.message];
        }
    }
    if (error instanceof (0, $aMYzM.WrongUsernameOrPasswordError)) errorMessage = (0, $aMYzM.getCredentialsErrorMessage)(formState.username, locale);
    if (error instanceof (0, $aMYzM.ServerNotFoundError)) {
        gaErrorTracking = {
            context: "login",
            text: "server_error"
        };
        errorMessage = (0, $aMYzM.networkErrorMessageByLocale)[locale];
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "flex flex-col",
        children: (0, $a2SqC.default).accessLevel === 2 ? /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "py-6 font-bold text-ink-warning",
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a4d728f8f69d980e$export$2e2bcd8739ae039), {}),
                " Du har n\xe5 KS-tilgang. Last siden p\xe5 nytt (F5) for \xe5 komme tilbake til normal tilgang."
            ]
        }) : /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    className: "pt-2 pb-4",
                    children: "Skriv inn ditt kundenummer eller din e-postadresse for \xe5 logge inn."
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                            "data-testid": "login-number-or-email-input",
                            label: "E-postadresse/ kundenummer",
                            name: "username",
                            value: formState.username,
                            onChange: (0, $Kk7R3.action)((e)=>{
                                formState.username = e.target.value;
                            }),
                            onKeyDown: handleKeyPress,
                            autoFocus: true,
                            showErrorMessage: !(0, $bEEBX.default)(formState.error)
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                            "data-testid": "login-password-input",
                            label: "Passord",
                            name: "password",
                            type: "password",
                            value: formState.password,
                            onChange: (0, $Kk7R3.action)((e)=>{
                                formState.password = e.target.value;
                            }),
                            onKeyDown: handleKeyPress,
                            showErrorMessage: !(0, $bEEBX.default)(formState.error),
                            errorMessage: ""
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "flex justify-end",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                variant: "tertiary",
                                onClick: ()=>(0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_EMAIL),
                                children: "Glemt passord?"
                            })
                        }),
                        error ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
                            showCloseButton: false,
                            gaErrorTracking: gaErrorTracking,
                            children: errorMessage
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "flex flex-col gap-2 pt-2",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                            "data-testid": "login-submit-button",
                            variant: "primary",
                            size: "regular",
                            onClick: attemptLogin,
                            loading: (0, $lKrOo.default).is("CHECKING_LOGIN"),
                            children: (0, $lKrOo.default).is("LOGIN_MODAL") && "Logg inn"
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("hr", {
                                    className: "login-divider"
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    className: "m-0 text-center",
                                    children: "Eller"
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)("hr", {
                                    className: "login-divider"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                            size: "regular",
                            variant: "secondary",
                            onClick: ()=>(0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).SMS),
                            children: "Logg inn med mobilnummer"
                        })
                    ]
                })
            ]
        })
    });
};
var $bd68fe17c48f5d90$export$2e2bcd8739ae039 = (0, $gBcml.observer)($bd68fe17c48f5d90$var$LoginUsername);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $bcbvQ = parcelRequire("bcbvQ");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");

var $7YWoO = parcelRequire("7YWoO");

var $3SASj = parcelRequire("3SASj");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $gCpkF = parcelRequire("gCpkF");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");
const $a38b7070d209d1f4$var$InputEmail = ()=>{
    const [email, setEmail] = (0, $dvPqk.useState)("");
    const [invalidEmail, setInvalidEmail] = (0, $dvPqk.useState)(false);
    const codeSent = !(0, $bEEBX.default)((0, $bcbvQ.default).resetPasswordId.data);
    (0, $dvPqk.useEffect)(()=>{
        if (codeSent) (0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_OTP);
    }, [
        codeSent
    ]);
    const onSubmit = async (event)=>{
        event.preventDefault();
        setInvalidEmail(false);
        if (email.length === 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($gCpkF)))(email)) setInvalidEmail(true);
        else await (0, $bcbvQ.default).requestResetPasswordOtp(email);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Fyll inn e-postadresse for \xe5 motta engangskode over e-post."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("form", {
                noValidate: true,
                onSubmit: onSubmit,
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                        label: "E-postadresse",
                        type: "email",
                        value: email,
                        onChange: (e)=>setEmail(e.target.value),
                        autoFocus: true,
                        disabled: (0, $duLFK.isWaitingForData)((0, $bcbvQ.default).resetPasswordId),
                        showErrorMessage: invalidEmail || (0, $duLFK.isErrorOccured)((0, $bcbvQ.default).resetPasswordId),
                        errorMessage: (0, $duLFK.isErrorOccured)((0, $bcbvQ.default).resetPasswordId) ? "Vi fant ingen bruker med denne e-postadressen" : "E-postadressen er ikke gyldig."
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        variant: "primary",
                        size: "regular",
                        type: "submit",
                        loading: (0, $duLFK.isWaitingForData)((0, $bcbvQ.default).resetPasswordId),
                        children: "Send engangskode"
                    })
                ]
            })
        ]
    });
};
var $a38b7070d209d1f4$export$2e2bcd8739ae039 = (0, $gBcml.observer)($a38b7070d209d1f4$var$InputEmail);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $duLFK = parcelRequire("duLFK");

var $bcbvQ = parcelRequire("bcbvQ");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");

var $4r4cM = parcelRequire("4r4cM");

var $3Uk2n = parcelRequire("3Uk2n");

var $a7WSl = parcelRequire("a7WSl");

var $6Fwsu = parcelRequire("6Fwsu");

var $2nIQC = parcelRequire("2nIQC");
const $03d12a1f711e3637$var$InputOtp = ()=>{
    const resetSuccess = (0, $bcbvQ.default).resetPasswordProgress.data;
    (0, $dvPqk.useEffect)(()=>{
        if (resetSuccess) (0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_SUCCESS);
    }, [
        resetSuccess
    ]);
    const handleSubmit = async (submittedFormValues)=>{
        await (0, $bcbvQ.default).attemptResetPassword(submittedFormValues.otp, submittedFormValues.password);
        return (0, $duLFK.isErrorOccured)((0, $bcbvQ.default).resetPasswordProgress) ? {
            resetFormFields: false
        } : {
            resetFormFields: true
        };
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Du har f\xe5tt tilsendt engangskode over e-post. Fyll inn koden og oppgi nytt passord."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $a7WSl.default), {
                onSubmit: handleSubmit,
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6Fwsu.default), {
                        name: "otp",
                        label: "Engangskode (6 tegn)",
                        initialValue: "",
                        validator: (0, $3Uk2n.validateOtpCode),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2nIQC.default), {
                        name: "password"
                    }),
                    (0, $duLFK.isErrorOccured)((0, $bcbvQ.default).resetPasswordProgress) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
                        showCloseButton: false,
                        gaErrorTracking: {
                            context: "login",
                            text: "reset_password_error"
                        },
                        children: "Noe gikk galt ved endring av passord. Pr\xf8v igjen senere."
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        type: "submit",
                        size: "full",
                        disabled: (0, $duLFK.isWaitingForData)((0, $bcbvQ.default).resetPasswordProgress),
                        trackingName: "Bekreft nytt passord innloggingsmodal",
                        children: "Sett nytt passord"
                    })
                ]
            })
        ]
    });
};
var $03d12a1f711e3637$export$2e2bcd8739ae039 = (0, $gBcml.observer)($03d12a1f711e3637$var$InputOtp);



var $7YWoO = parcelRequire("7YWoO");

var $ezbi8 = parcelRequire("ezbi8");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $d1c9608746232bde$var$ResetSuccess = ()=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
        variant: "success",
        showCloseButton: false,
        children: "Passordet ditt har blitt oppdatert. Du kan n\xe5 pr\xf8ve \xe5 logge inn med nytt passord."
    });
var $d1c9608746232bde$export$2e2bcd8739ae039 = (0, $gBcml.observer)($d1c9608746232bde$var$ResetSuccess);


const $6e9528f6abfca919$var$ResetPassword = ({ title: title, showBackToLogInText: showBackToLogInText = true })=>{
    const [, redirectTo] = (0, $8kt8E.useLocation)();
    const [searchParams, _] = (0, $8kt8E.useSearchParams)();
    const isNewAccount = searchParams.get("newaccount") === "true";
    const { loginMode: loginMode } = (0, $a2SqC.default);
    const abortResetPassword = ()=>{
        (0, $a2SqC.default).switchLoginMode((0, $a2SqC.LOGIN_MODE).USERNAME);
        (0, $bcbvQ.default).clearResetPassword();
        redirectTo("/");
    };
    const renderFormContent = ()=>{
        switch(loginMode){
            case (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_EMAIL:
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a38b7070d209d1f4$export$2e2bcd8739ae039), {});
            case (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_OTP:
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $03d12a1f711e3637$export$2e2bcd8739ae039), {});
            case (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_SUCCESS:
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $d1c9608746232bde$export$2e2bcd8739ae039), {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("b", {
                    children: title
                })
            }),
            renderFormContent(),
            loginMode !== (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_SUCCESS && !isNewAccount ? /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("hr", {
                        className: "login-divider"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        className: "m-0 text-center",
                        children: "Eller"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("hr", {
                        className: "login-divider"
                    })
                ]
            }) : null,
            showBackToLogInText || loginMode === (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_SUCCESS ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                size: "regular",
                variant: "secondary",
                onClick: abortResetPassword,
                children: "Tilbake til innlogging"
            }) : null
        ]
    });
};
var $6e9528f6abfca919$export$2e2bcd8739ae039 = (0, $gBcml.observer)($6e9528f6abfca919$var$ResetPassword);


const $2eb997ad4ed0ebf9$var$LoginModal = ()=>{
    const [params] = (0, $8kt8E.useSearchParams)();
    const isNewAccount = params.get("newaccount") === "true";
    const showModal = (0, $lKrOo.default).is("LOGIN_MODAL") || (0, $lKrOo.default).is("CHECKING_LOGIN");
    const { loginMode: loginMode, hideLoginModal: hideLoginModal } = (0, $a2SqC.default);
    const hideModal = ()=>{
        hideLoginModal();
    };
    const renderContent = ()=>{
        switch(loginMode){
            case (0, $a2SqC.LOGIN_MODE).USERNAME:
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bd68fe17c48f5d90$export$2e2bcd8739ae039), {});
            case (0, $a2SqC.LOGIN_MODE).SMS:
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1f9eaeafd625cbed$export$2e2bcd8739ae039), {});
            case (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_EMAIL:
            case (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_OTP:
            case (0, $a2SqC.LOGIN_MODE).RESET_PASSWORD_SUCCESS:
                return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6e9528f6abfca919$export$2e2bcd8739ae039), {
                    title: isNewAccount ? "Sett passord" : "Glemt passord?",
                    showBackToLogInText: !isNewAccount
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kUJJo.default), {
        title: "Logg inn",
        name: "Logg inn",
        TitleIcon: (0, $cY4Gr.default),
        isOpen: showModal,
        onClose: hideModal,
        size: "md",
        children: renderContent()
    });
};
var $2eb997ad4ed0ebf9$export$2e2bcd8739ae039 = (0, $gBcml.observer)($2eb997ad4ed0ebf9$var$LoginModal);



var $7YWoO = parcelRequire("7YWoO");
const $838e5ccbb81e27c3$var$preprodCN = "w-full bg-surface-warning text-ink-warning p-2 text-center print:hidden";
const $838e5ccbb81e27c3$var$PreprodInfo = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: $838e5ccbb81e27c3$var$preprodCN,
        children: "Du er n\xe5 i test-milj\xf8et."
    });
};
var $838e5ccbb81e27c3$export$2e2bcd8739ae039 = $838e5ccbb81e27c3$var$PreprodInfo;



var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");
function $8f6fd37647893ec3$var$ScrollToTop() {
    const [location] = (0, $8kt8E.useLocation)();
    const previousLocation = (0, $dvPqk.useRef)("");
    (0, $dvPqk.useEffect)(()=>{
        const previous = previousLocation.current;
        if (!previous || !previous.startsWith("/produkter") || !location.startsWith("/produkter")) window.scrollTo(0, 0);
        previousLocation.current = location;
    }, [
        location
    ]);
    return null;
}
var $8f6fd37647893ec3$export$2e2bcd8739ae039 = $8f6fd37647893ec3$var$ScrollToTop;


parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $gtsdT = parcelRequire("gtsdT");
function $5080050ca13989ff$var$getBrowserVisibilityEventName() {
    if (typeof document.visibilityState !== "undefined" || typeof document.hidden !== "undefined") // Opera 12.10 and Firefox 18 and later support
    return "visibilitychange";
    if (typeof document.msHidden !== "undefined") return "msvisibilitychange";
    if (typeof document.webkitHidden !== "undefined") return "webkitvisibilitychange";
}
const $5080050ca13989ff$var$getBrowserDocumentVisibilityProp = ()=>[
        "visibilityState",
        "hidden",
        "msHidden",
        "webkitHidden"
    ].find((p)=>typeof document[p] !== "undefined");
const $5080050ca13989ff$var$desiredValueForVisible = {
    visibilityState: "visible",
    hidden: false,
    msHidden: false,
    webkitHidden: false
};
const $5080050ca13989ff$var$getIsDocumentVisible = ()=>{
    const propName = $5080050ca13989ff$var$getBrowserDocumentVisibilityProp();
    return propName !== undefined && document[propName] === $5080050ca13989ff$var$desiredValueForVisible[propName];
};
const $5080050ca13989ff$var$SessionChecker = ({ onChange: onChange })=>{
    const handleVisiblityChange = (0, $dvPqk.useCallback)(()=>onChange($5080050ca13989ff$var$getIsDocumentVisible()), [
        onChange
    ]);
    (0, $dvPqk.useEffect)(()=>{
        const visibilityEventName = $5080050ca13989ff$var$getBrowserVisibilityEventName();
        if (!visibilityEventName) {
            (0, $gtsdT.logger).warn("auth", "Unable to determine browser visibility event name for this broweser, disabling visiblity change handler.");
            return;
        }
        document.addEventListener(visibilityEventName, handleVisiblityChange, false);
        return ()=>{
            document.removeEventListener(visibilityEventName, handleVisiblityChange);
        };
    });
    return null;
};
var $5080050ca13989ff$export$2e2bcd8739ae039 = (0, $gBcml.observer)($5080050ca13989ff$var$SessionChecker);



var $7YWoO = parcelRequire("7YWoO");

var $5rKSh = parcelRequire("5rKSh");

var $jOOuf = parcelRequire("jOOuf");

var $c3PBx = parcelRequire("c3PBx");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $fzwaN = parcelRequire("fzwaN");

var $kUJJo = parcelRequire("kUJJo");
const $4adbd804e19d4e3f$var$pathsToRedirect = {
    "/checkout/confirmation": "/",
    "/customer/favorites/": "/customer/favorites",
    "/customer/subscriptions/": "/customer/subscriptions",
    "/customer/orders/": "/customer/orders",
    "/customer/claims/": "/customer/claims"
};
const $4adbd804e19d4e3f$var$SwitchCompanyModal = ()=>{
    const [path, navigate] = (0, $8kt8E.useLocation)();
    const companies = (0, $bcbvQ.default).companies ? [
        ...(0, $bcbvQ.default).companies
    ].sort((a, b)=>a.name.localeCompare(b.name)) : [];
    const selectCompany = (customerNumber)=>{
        if (customerNumber !== (0, $bcbvQ.default).currentCompany) {
            (0, $bcbvQ.default).changeCompany(customerNumber);
            // Stops iterating when first path is found
            (0, $c3PBx.default)($4adbd804e19d4e3f$var$pathsToRedirect, (to, startsWithPath)=>{
                if (path.startsWith(startsWithPath)) {
                    navigate(to);
                    return true;
                }
                return false;
            });
        }
    };
    const handleClose = ()=>{
        if ((0, $bcbvQ.default).currentCompany) (0, $lKrOo.default).transitionTo("LOGGED_IN");
        else (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kUJJo.default), {
        size: "lg",
        title: "Velg firma",
        name: "Endre firma",
        isOpen: (0, $lKrOo.default).is("COMPANY_SELECTION"),
        onClose: handleClose,
        className: "bg-background-tinted",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("nav", {
            "aria-label": "Liste over firmaer",
            children: /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                className: "p-0",
                children: companies.map((company, index)=>{
                    if (company.customerNumber === (0, $bcbvQ.default).currentCompany) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fzwaN.AccountListItemWithButtonActions), {
                        title: company?.name,
                        subtitles: /*#__PURE__*/ (0, $7YWoO.jsx)("small", {
                            children: company?.customerNumber
                        }, "subtitle"),
                        actions: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                                align: "center",
                                gap: 1,
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                        className: "hidden text-sm sm:block",
                                        children: "N\xe5v\xe6rende firma"
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5rKSh.default), {})
                                ]
                            }, "current-company")
                        ],
                        marked: true
                    }, `switch-company-${company.customerNumber}`);
                    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fzwaN.AccountListItemWithNavigation), {
                        title: company?.name,
                        subtitles: /*#__PURE__*/ (0, $7YWoO.jsx)("small", {
                            children: company?.customerNumber
                        }),
                        onClick: ()=>selectCompany(company.customerNumber)
                    }, `switch-company-${company.customerNumber}-${index}`);
                })
            })
        })
    });
};
var $4adbd804e19d4e3f$export$2e2bcd8739ae039 = (0, $gBcml.observer)($4adbd804e19d4e3f$var$SwitchCompanyModal);



var $7YWoO = parcelRequire("7YWoO");

var $ezbi8 = parcelRequire("ezbi8");

var $izjX7 = parcelRequire("izjX7");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $gvoND = parcelRequire("gvoND");
const $29b68b9e01ef24ae$var$fadeDuration = 500;
const $29b68b9e01ef24ae$var$durationStyle = "duration-500";
const $29b68b9e01ef24ae$var$SingleToast = (0, $gBcml.observer)(({ toast: toast })=>{
    const { duration: duration, id: id, show: showProp, title: title, type: type, persist: persist } = toast;
    const [show, setShow] = (0, $dvPqk.useState)(showProp);
    const [finished, setFinished] = (0, $dvPqk.useState)(false);
    const variant = type === "success" ? "success" : type === "error" ? "error" : "information";
    (0, $dvPqk.useEffect)(()=>{
        if (persist) return;
        // Hides the toast after the duration time
        const timeoutId = setTimeout(()=>{
            setShow(false);
        }, duration);
        return ()=>clearTimeout(timeoutId);
    }, [
        duration
    ]);
    (0, $dvPqk.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            if (!show) setFinished(true);
        }, $29b68b9e01ef24ae$var$fadeDuration);
        return ()=>clearTimeout(timeoutId);
    }, [
        show
    ]);
    if (finished) return null;
    const onClose = (0, $Kk7R3.action)(()=>{
        setShow(false);
        (0, $gvoND.default).toasts = (0, $gvoND.default).toasts.filter((t)=>t.id !== id);
    });
    const borderStyles = (0, $izjX7.cn)("border", {
        "border-error-600": variant === "error",
        "border-success-600": variant === "success"
    });
    const alertStyles = (0, $izjX7.cn)(borderStyles, "transition-opacity", $29b68b9e01ef24ae$var$durationStyle, {
        "opacity-100": show,
        "opacity-0": !show
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "m-3 w-96",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
            variant: variant,
            title: title,
            className: alertStyles,
            onClose: onClose,
            children: toast.message.split("\n").map((line, i)=>/*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    children: line
                }, `${i + 1}`))
        })
    });
});
const $29b68b9e01ef24ae$var$ToastDisplay = ()=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "fixed top-0 left-0 z-40",
        "data-testid": "toast-display",
        children: (0, $gvoND.default).toasts.map((toast)=>/*#__PURE__*/ (0, $7YWoO.jsx)($29b68b9e01ef24ae$var$SingleToast, {
                toast: toast
            }, toast.id))
    });
var $29b68b9e01ef24ae$export$2e2bcd8739ae039 = (0, $gBcml.observer)($29b68b9e01ef24ae$var$ToastDisplay);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $jlTfJ = parcelRequire("jlTfJ");

var $eEIow = parcelRequire("eEIow");
const $1fe441d34deee6cc$var$TopBarWarnings = ()=>{
    const warnings = (0, $jlTfJ.default).getCurrentWarnings();
    const filteredWarnings = warnings.filter((c)=>c.warningtype?.includes("Toppen av alle sider"));
    if (filteredWarnings.length === 0) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)("aside", {
        className: "print:hidden",
        children: filteredWarnings.map((warning)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $eEIow.default), {
                warning: warning,
                className: "md:[&>div]:px-12"
            }, warning.internalName))
    });
};
var $1fe441d34deee6cc$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1fe441d34deee6cc$var$TopBarWarnings);



var $7YWoO = parcelRequire("7YWoO");

var $bEEBX = parcelRequire("bEEBX");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $j6ChH = parcelRequire("j6ChH");

var $gtsdT = parcelRequire("gtsdT");

var $bcbvQ = parcelRequire("bcbvQ");
const $bcb2274662c413fd$var$VURBIS_API_URL = "https://vurbismarketplace.com";
const $bcb2274662c413fd$var$VurbisPunchoutScript = ()=>{
    if (!(0, $bcbvQ.default).isLoggedIn()) return null;
    if (!(0, $bcbvQ.default).isPunchoutSession()) return null;
    if ((0, $bEEBX.default)((0, $bcbvQ.default).user?.additionalInfo.VURBIS_SESSION_ID)) (0, $gtsdT.logger).warn("auth", "VURBIS_SESSION_ID is missing in user additional info even if this is a punchout session");
    // Helmet is necessary for React to execute the script references in the script tag inserted
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j6ChH.Helmet), {
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("script", {
            src: `${$bcb2274662c413fd$var$VURBIS_API_URL}/api/punchout/files/${(0, $bcbvQ.default).user?.additionalInfo.VURBIS_SESSION_ID}/enterprise.js`
        })
    });
};
(0, $Kk7R3.autorun)(()=>{
    const currentCompany = (0, $bcbvQ.default).currentCompany;
    if ((0, $bEEBX.default)(currentCompany)) {
        window.cartId = undefined;
        return;
    }
    window.cartId = currentCompany;
});
var $bcb2274662c413fd$export$2e2bcd8739ae039 = (0, $gBcml.observer)($bcb2274662c413fd$var$VurbisPunchoutScript);



var $7YWoO = parcelRequire("7YWoO");

var $3lzdj = parcelRequire("3lzdj");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $8ZCSm = parcelRequire("8ZCSm");


var $7YWoO = parcelRequire("7YWoO");

var $4rjCr = parcelRequire("4rjCr");
const $b4477699e86cddcf$var$cleanUpTelephoneNumber = (telNr)=>telNr.replace(/[^0-9+]/g, "");
const $b4477699e86cddcf$var$PhoneLink = ({ telephoneNumber: telephoneNumber, ...props })=>{
    const phone = $b4477699e86cddcf$var$cleanUpTelephoneNumber(telephoneNumber);
    if (!phone.length) return null;
    const href = `tel:${phone}`;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
        iconPosition: "left",
        ...props,
        href: href,
        children: telephoneNumber
    });
};
var $b4477699e86cddcf$export$2e2bcd8739ae039 = $b4477699e86cddcf$var$PhoneLink;



var $dWcIP = parcelRequire("dWcIP");

var $jlTfJ = parcelRequire("jlTfJ");

var $a2SqC = parcelRequire("a2SqC");

var $isIf6 = parcelRequire("isIf6");

var $7YWoO = parcelRequire("7YWoO");

var $5OqMf = parcelRequire("5OqMf");

var $6pY3b = parcelRequire("6pY3b");

var $jlTfJ = parcelRequire("jlTfJ");
const $89c5c3016b028d85$var$ContentfulFooterLink = ({ content: content })=>{
    if (content?.sys?.contentType?.sys?.id === "v2_article") {
        const article = content;
        const id = article.sys.id;
        const linkText = article.fields.title;
        const fullUrl = `/${(0, $jlTfJ.default).urlData.data.find((data)=>data.id === id)?.fullUrl}`;
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
            href: fullUrl,
            className: "text-headerFooterText no-underline hover:underline",
            trackingLocationName: "Footer",
            children: linkText
        });
    }
    if (content?.sys?.contentType?.sys?.id === "externalLink") {
        const externalLink = content;
        const url = externalLink.fields.url;
        const linkText = externalLink.fields.linkText;
        const linkClassName = "text-headerFooterText no-underline hover:underline";
        if ((0, $5OqMf.isExternalLink)(url)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.ExternalLink), {
            href: url,
            className: linkClassName,
            children: linkText
        });
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
            trackingLocationName: "Footer",
            href: url,
            className: linkClassName,
            children: linkText
        });
    }
    if (content?.sys?.contentType?.sys?.id === "linkToMedia") {
        const externalLink = content;
        const url = externalLink.fields.media?.fields.file?.url;
        const linkText = externalLink.fields.linkText;
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.DownloadLink), {
            href: url,
            className: "text-headerFooterText no-underline hover:underline",
            children: linkText
        });
    }
};
var $89c5c3016b028d85$export$2e2bcd8739ae039 = $89c5c3016b028d85$var$ContentfulFooterLink;



var $7YWoO = parcelRequire("7YWoO");

var $isIf6 = parcelRequire("isIf6");
const $932900803037570a$var$FooterDecorationImage = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "self-end bg-transparent pr-2",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "flex items-end gap-2",
            children: [
                (0, $isIf6.default).footerDecorationImageUrl1 && /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                    alt: "Temabilde",
                    width: 11.04,
                    height: 6.87,
                    src: (0, $isIf6.default).footerDecorationImageUrl1
                }),
                (0, $isIf6.default).footerDecorationImageUrl2 && /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                    alt: "Temabilde",
                    width: 48.73,
                    height: 30,
                    src: (0, $isIf6.default).footerDecorationImageUrl2
                })
            ]
        })
    });
};
var $932900803037570a$export$2e2bcd8739ae039 = $932900803037570a$var$FooterDecorationImage;


const $df1dc429abb84f60$var$openingHourKey = (openingHour)=>openingHour && typeof openingHour === "object" && "key" in openingHour && typeof openingHour.key === "string" && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        children: openingHour.key
    });
const $df1dc429abb84f60$var$openingHourValue = (openingHour)=>openingHour && typeof openingHour === "object" && "value" in openingHour && typeof openingHour.value === "string" && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        children: openingHour.value
    });
const $df1dc429abb84f60$var$sectionClasses = "flex flex-col gap-4";
const $df1dc429abb84f60$var$Footer = ()=>{
    const { siteName: siteName } = (0, $isIf6.default);
    const { dataVersion: dataVersion } = (0, $a2SqC.default);
    const footerContent = (0, $jlTfJ.default).footerContent.data;
    const currentYear = new Date().getFullYear();
    const columnCustomerServiceLabel = footerContent?.fields.columnCustomerServiceLabel;
    const columnTwoLabel = footerContent?.fields.column2label;
    const columnTwoLinks = footerContent?.fields.column2links;
    const columnThreeLabel = footerContent?.fields.column3label;
    const columnThreeLinks = footerContent?.fields.column3links;
    const columnFourLabel = footerContent?.fields.column4label;
    const columnFourLinks = footerContent?.fields.column4links;
    const termsAndConditionLinks = footerContent?.fields.termsAndConditions;
    const [showVersionInfo, setShowVersionInfo] = (0, $dvPqk.useState)(false);
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "flex flex-col w-full px-2 lg:px-0 print:hidden",
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
                    cols: 12,
                    gap: {
                        base: 4,
                        lg: 12
                    },
                    className: "my-14",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                            span: {
                                base: 12,
                                lg: 3,
                                sm: 6
                            },
                            className: $df1dc429abb84f60$var$sectionClasses,
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                                    className: "text-xl",
                                    children: columnCustomerServiceLabel
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("ul", {
                                    className: "px-0",
                                    children: [
                                        footerContent?.fields.openingHours && Array.isArray(footerContent.fields.openingHours) && footerContent.fields.openingHours?.map((openingHour, index)=>/*#__PURE__*/ (0, $7YWoO.jsxs)("li", {
                                                className: "flex gap-8 pb-4",
                                                children: [
                                                    $df1dc429abb84f60$var$openingHourKey(openingHour),
                                                    $df1dc429abb84f60$var$openingHourValue(openingHour)
                                                ]
                                            }, `OpeningHourLine ${index + 1}`)),
                                        /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b4477699e86cddcf$export$2e2bcd8739ae039), {
                                                className: "pb-4 underline text-headerFooterText hover:underline",
                                                telephoneNumber: footerContent?.fields.contactNumber || ""
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        columnTwoLinks && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                            span: {
                                base: 12,
                                lg: 3,
                                sm: 6
                            },
                            className: $df1dc429abb84f60$var$sectionClasses,
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                                    className: "text-xl",
                                    children: columnTwoLabel
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                                    className: "px-0",
                                    children: columnTwoLinks?.map((link)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                            className: "pb-4",
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $89c5c3016b028d85$export$2e2bcd8739ae039), {
                                                content: link
                                            })
                                        }, link.sys.id))
                                })
                            ]
                        }),
                        columnThreeLinks && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                            span: {
                                base: 12,
                                lg: 3,
                                sm: 6
                            },
                            className: $df1dc429abb84f60$var$sectionClasses,
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                                    className: "text-xl",
                                    children: columnThreeLabel
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                                    className: "px-0",
                                    children: columnThreeLinks?.map((link)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                            className: "pb-4",
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $89c5c3016b028d85$export$2e2bcd8739ae039), {
                                                content: link
                                            })
                                        }, link.sys.id))
                                })
                            ]
                        }),
                        columnFourLinks && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid).Col, {
                            span: {
                                base: 12,
                                lg: 3,
                                sm: 6
                            },
                            className: $df1dc429abb84f60$var$sectionClasses,
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                                    className: "text-xl",
                                    children: columnFourLabel
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                                    className: "px-0",
                                    children: columnFourLinks?.map((link)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                            className: "pb-4",
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $89c5c3016b028d85$export$2e2bcd8739ae039), {
                                                content: link
                                            })
                                        }, link.sys.id))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "flex flex-col w-full",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $932900803037570a$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: "-mt-[1px] flex w-full flex-col justify-between gap-6 border-t border-solid pt-6 lg:flex-row lg:text-right",
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                    className: "flex flex-col gap-6 lg:flex-row",
                                    children: termsAndConditionLinks?.map((termsAndConditionLink)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $89c5c3016b028d85$export$2e2bcd8739ae039), {
                                            content: termsAndConditionLink
                                        }, termsAndConditionLink.sys.id))
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsxs)("button", {
                                            type: "button",
                                            className: "cursor-default",
                                            onClick: ()=>setShowVersionInfo(!showVersionInfo),
                                            children: [
                                                "\xa9 ",
                                                currentYear,
                                                " ",
                                                siteName
                                            ]
                                        }),
                                        showVersionInfo && // biome-ignore lint/a11y/noStaticElementInteractions: should be a button
                                        /*#__PURE__*/ (0, $7YWoO.jsxs)("span", {
                                            className: "absolute left-0 text-sm cursor-pointer top-8 text-nowrap lg:left-auto lg:right-0",
                                            onClick: ()=>(0, $a2SqC.default).checkDataVersion(true),
                                            children: [
                                                "d.",
                                                dataVersion,
                                                " | b.",
                                                (0, $8ZCSm.APP_VERSION)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "flex justify-center mt-12 mb-14",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                                to: "/",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dWcIP.default), {
                                    placement: "footer"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $df1dc429abb84f60$export$2e2bcd8739ae039 = (0, $gBcml.observer)($df1dc429abb84f60$var$Footer);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $7YWoO = parcelRequire("7YWoO");

var $5koBm = parcelRequire("5koBm");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");

var $7YWoO = parcelRequire("7YWoO");

var $2sXUk = parcelRequire("2sXUk");
var $3cSFY = parcelRequire("3cSFY");
var $eVT1x = parcelRequire("eVT1x");
var $2sXUk = parcelRequire("2sXUk");

var $9NHzr = parcelRequire("9NHzr");

var $dvPqk = parcelRequire("dvPqk");

var $inMER = parcelRequire("inMER");

var $cLLe3 = parcelRequire("cLLe3");

const $218da65502949c19$var$ColumnDropdown = ({ open: open, onOpenChange: onOpenChange, referenceElement: referenceElement, withCloseButton: withCloseButton = false, children: children })=>{
    const arrowRef = (0, $dvPqk.useRef)(null);
    const dropdownContainerRef = (0, $dvPqk.useRef)(null);
    const { refs: refs, context: context, floatingStyles: floatingStyles } = (0, $eVT1x.useFloating)({
        placement: "bottom",
        open: open,
        onOpenChange: onOpenChange,
        transform: false,
        elements: {
            reference: referenceElement
        },
        whileElementsMounted: (0, $3cSFY.autoUpdate),
        middleware: [
            (0, $2sXUk.offset)(9),
            (0, $2sXUk.size)({
                apply ({ elements: elements }) {
                    const popupContainer = elements.floating.firstElementChild;
                    if (popupContainer) popupContainer.style.left = `${-elements.floating.getBoundingClientRect().left}px`;
                }
            }),
            (0, $2sXUk.arrow)({
                element: arrowRef
            })
        ]
    });
    (0, $inMER.default)([
        dropdownContainerRef,
        referenceElement
    ], ()=>{
        onOpenChange(false);
    });
    (0, $dvPqk.useEffect)(()=>{
        const keyDownHandler = (event)=>{
            if (event.key === "Escape" && open) onOpenChange(false);
        };
        window.addEventListener("keydown", keyDownHandler);
        return ()=>{
            window.removeEventListener("keydown", keyDownHandler);
        };
    }, [
        open,
        onOpenChange
    ]);
    if (!open) return null;
    const arrowClasses = "fill-base-0 [&>path:first-of-type]:stroke-ink-border-subtle [&>path:last-of-type]:stroke-base-0";
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        ref: refs.setFloating,
        className: "left-0 top-0 absolute w-max !min-w-[100vw] flex z-50 bg-base-0 overflow-visible",
        style: floatingStyles,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "absolute w-[100vw] left-0 top-[-1px]",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        ref: dropdownContainerRef,
                        className: "w-full border rounded-lg border-ink-border-subtle bg-base-0",
                        children: [
                            withCloseButton && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex justify-end w-full p-2",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                    variant: "tertiary",
                                    onClick: ()=>onOpenChange(false),
                                    icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9NHzr.default), {})
                                })
                            }),
                            children
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eVT1x.FloatingArrow), {
                ref: arrowRef,
                context: context,
                className: arrowClasses,
                strokeWidth: 1
            })
        ]
    });
};
var $218da65502949c19$export$2e2bcd8739ae039 = $218da65502949c19$var$ColumnDropdown;




var $25aT1 = parcelRequire("25aT1");

var $jlTfJ = parcelRequire("jlTfJ");

var $9yKIH = parcelRequire("9yKIH");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $isIf6 = parcelRequire("isIf6");

var $7YWoO = parcelRequire("7YWoO");

var $7YWoO = parcelRequire("7YWoO");

var $fqWHZ = parcelRequire("fqWHZ");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");
const $097d9e57992819cb$var$listItemClassName = (0, $izjX7.cn)([
    "mb-2 list-none"
]);
const $097d9e57992819cb$var$topLevelListItemClassName = (0, $izjX7.cn)([
    "uppercase",
    "font-bold"
]);
const $097d9e57992819cb$var$MegaMenuCol = ({ cat: cat, onClick: onClick, columnIndex: columnIndex, productsUrl: productsUrl })=>{
    const emitOnClickAndTrackLinkClick = (url, linkName)=>{
        (0, $6fuyt.sendInternalLinkClick)(url, "Megamenu", linkName);
        onClick();
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fqWHZ.Stack), {
        className: "grow basis-1/3",
        justify: "start",
        align: "start",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("ul", {
            className: "text-xs",
            children: [
                columnIndex === 0 && /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                    className: (0, $izjX7.cn)($097d9e57992819cb$var$listItemClassName, $097d9e57992819cb$var$topLevelListItemClassName),
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                        to: productsUrl,
                        onClick: ()=>emitOnClickAndTrackLinkClick(productsUrl, "Alle produkter"),
                        children: "Alle Produkter"
                    })
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                    className: (0, $izjX7.cn)($097d9e57992819cb$var$listItemClassName, $097d9e57992819cb$var$topLevelListItemClassName),
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                        to: cat.fullUrl,
                        onClick: ()=>emitOnClickAndTrackLinkClick(cat.fullUrl, cat.name),
                        children: cat.name
                    })
                }),
                cat.children.filter((c)=>c.visible).map((subcat)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                        className: $097d9e57992819cb$var$listItemClassName,
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                            to: subcat.fullUrl,
                            onClick: ()=>emitOnClickAndTrackLinkClick(subcat.fullUrl, subcat.name),
                            children: subcat.name
                        })
                    }, subcat.url_key))
            ]
        })
    });
};
var $097d9e57992819cb$export$2e2bcd8739ae039 = (0, $gBcml.observer)($097d9e57992819cb$var$MegaMenuCol);


const $539913ff0f87dda4$var$MegaMenu = ({ cat: cat, onHide: onHide })=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "flex w-full flex-row justify-between px-12 pt-4",
        children: cat.children.map((subcat, index)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $097d9e57992819cb$export$2e2bcd8739ae039), {
                columnIndex: index,
                cat: subcat,
                productsUrl: cat.fullUrl,
                onClick: ()=>onHide()
            }, subcat.url_key))
    });
var $539913ff0f87dda4$export$2e2bcd8739ae039 = $539913ff0f87dda4$var$MegaMenu;


const $1e6588ced94d5ff0$var$itemCN = (0, $izjX7.cn)([
    "py-[--topnav-categories-padding-y]",
    "!text-headerFooterText"
]);
const $1e6588ced94d5ff0$var$Category = (0, $gBcml.observer)(({ cat: cat })=>{
    const [show, setShow] = (0, $dvPqk.useState)(false);
    const [referenceElement, setReferenceElement] = (0, $dvPqk.useState)(null);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                ref: setReferenceElement,
                className: "font-medium",
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("button", {
                    type: "button",
                    className: (0, $izjX7.cn)($1e6588ced94d5ff0$var$itemCN, "ps-0"),
                    onClick: ()=>setShow(!show),
                    children: [
                        (0, $5OqMf.titleCase)(cat.name),
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5koBm.default), {
                            className: "inline"
                        })
                    ]
                })
            }),
            !!referenceElement && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $218da65502949c19$export$2e2bcd8739ae039), {
                open: show,
                referenceElement: referenceElement,
                onOpenChange: setShow,
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $539913ff0f87dda4$export$2e2bcd8739ae039), {
                    cat: cat,
                    onHide: ()=>setShow(false)
                })
            })
        ]
    });
});
const $1e6588ced94d5ff0$var$categoriesClassName = (0, $izjX7.cn)([
    "w-full bg-headerFooterBackground"
]);
const $1e6588ced94d5ff0$var$categoriesNavigationContainerClassName = (0, $izjX7.cn)([
    "flex shrink-0 grow flex-row items-center",
    "w-full py-[--topnav-padding-y]"
]);
const $1e6588ced94d5ff0$var$categoriesItemsClassName = (0, $izjX7.cn)([
    "flex w-full flex-row items-center justify-start gap-4"
]);
const $1e6588ced94d5ff0$var$Categories = ()=>{
    const { categories: categories } = (0, $25aT1.default);
    const { productDropdownEnabled: productDropdownEnabled } = (0, $isIf6.default);
    const isSideMenu = (0, $biFcX.default).navigationTestVariant === "sidemenu";
    const isTopMenu = (0, $biFcX.default).navigationTestVariant === "topmenu";
    const isMegaMenu = !isSideMenu && !isTopMenu;
    const categoryTree = productDropdownEnabled ? categories : (categories[0]?.children || categories).filter((cat)=>(0, $bZiDo.default).resolveSkus(cat.skus, true).length);
    const isMenuItemVisible = (menuItem)=>menuItem.contentType === "v2_article" && (0, $9yKIH.default).isArticleVisible(menuItem.id) || menuItem.contentType !== "v2_article";
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: $1e6588ced94d5ff0$var$categoriesClassName,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7YWoO.jsx)("nav", {
                className: $1e6588ced94d5ff0$var$categoriesNavigationContainerClassName,
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: $1e6588ced94d5ff0$var$categoriesItemsClassName,
                    children: [
                        isMegaMenu && productDropdownEnabled && categoryTree.map((cat)=>/*#__PURE__*/ (0, $7YWoO.jsx)($1e6588ced94d5ff0$var$Category, {
                                cat: cat
                            }, cat.id)),
                        !(isMegaMenu && productDropdownEnabled) && categoryTree.map((cat)=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "py-[--topnav-categories-padding-y] font-medium",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                                    className: $1e6588ced94d5ff0$var$itemCN,
                                    to: cat.fullUrl,
                                    onClick: ()=>(0, $6fuyt.sendInternalLinkClick)(cat.fullUrl, "Navbar", (0, $5OqMf.titleCase)(cat.name)),
                                    children: (0, $5OqMf.titleCase)(cat.name)
                                })
                            }, cat.id)),
                        (0, $jlTfJ.default).mainMenuItems.map((menuItem)=>isMenuItemVisible(menuItem) && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                                    className: $1e6588ced94d5ff0$var$itemCN,
                                    to: menuItem.url,
                                    onClick: ()=>(0, $6fuyt.sendInternalLinkClick)(menuItem.url, "Navbar", menuItem.title),
                                    children: menuItem.title
                                })
                            }, menuItem.id))
                    ]
                })
            })
        })
    });
};
var $1e6588ced94d5ff0$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1e6588ced94d5ff0$var$Categories);



var $7YWoO = parcelRequire("7YWoO");

var $inCq0 = parcelRequire("inCq0");
var $1KGvE = parcelRequire("1KGvE");

var $izjX7 = parcelRequire("izjX7");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gtsdT = parcelRequire("gtsdT");

var $5OqMf = parcelRequire("5OqMf");

var $duLFK = parcelRequire("duLFK");

var $4udGV = parcelRequire("4udGV");

var $cLLe3 = parcelRequire("cLLe3");


var $9bzp5 = parcelRequire("9bzp5");

var $9Vrue = parcelRequire("9Vrue");

var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");

var $7YWoO = parcelRequire("7YWoO");

var $inCq0 = parcelRequire("inCq0");
var $dV1cT = parcelRequire("dV1cT");

var $jOOuf = parcelRequire("jOOuf");
var $fqWHZ = parcelRequire("fqWHZ");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $8aSS4 = parcelRequire("8aSS4");

var $4udGV = parcelRequire("4udGV");

var $cLLe3 = parcelRequire("cLLe3");

var $7dAjM = parcelRequire("7dAjM");

var $6pY3b = parcelRequire("6pY3b");

var $76PCP = parcelRequire("76PCP");
const $e7d8001c74cd4e48$var$SubscriptionEditingDeliveryInfo = (0, $gBcml.observer)(()=>{
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    if ((0, $bEEBX.default)((0, $76PCP.default).editing)) return null;
    const label = (0, $76PCP.default).editing.instanceDate ? `planlagt levering (${(0, $4udGV.formatDate)((0, $4udGV.parseM3Date)((0, $76PCP.default).editing.instanceDate))}), abo. ` : "abonnement";
    const { orderNumber: orderNumber } = (0, $76PCP.default).editing;
    const redirectUrl = (0, $76PCP.default).editing.deadline ? `/customer/orders/${orderNumber}` : `/customer/subscriptions/${orderNumber}`;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex w-full flex-wrap items-center justify-between gap-4 lg:flex-row",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6pY3b.InternalLink), {
                href: "/checkout/cart",
                children: [
                    "Endrer ",
                    label,
                    " #",
                    orderNumber
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                onClick: ()=>{
                    (0, $76PCP.default).stopEditOrderMode().then(()=>redirectTo(redirectUrl));
                },
                children: "Avbryt endring"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                className: "m-0 text-sm",
                children: [
                    "Endringene kan gj\xf8res direkte i handlekurven. ",
                    /*#__PURE__*/ (0, $7YWoO.jsx)("br", {}),
                    " Oppdater abonnement for \xe5 lagre endringer."
                ]
            })
        ]
    });
});
const $e7d8001c74cd4e48$var$DefaultEditingDeliveryInfo = (0, $gBcml.observer)(()=>{
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    if ((0, $bEEBX.default)((0, $76PCP.default).editing)) return null;
    const { orderNumber: orderNumber } = (0, $76PCP.default).editing;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-wrap justify-between gap-4 lg:flex-row",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $inCq0.default), {}),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7dAjM.default), {
                                rowOnMobile: true,
                                label: "Endringsfrist",
                                align: "start",
                                value: (0, $4udGV.formatDateTime)((0, $76PCP.default).editing.deadline, true, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                        onClick: ()=>{
                            (0, $76PCP.default).stopEditOrderMode().then(()=>redirectTo(`/customer/orders/${orderNumber}`));
                        },
                        children: "Avbryt endring"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $cLLe3.default), {
                        iconPosition: "left",
                        icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dV1cT.default), {}),
                        to: "/checkout/cart",
                        variant: "tertiary",
                        children: [
                            "Endrer ordre #",
                            (0, $76PCP.default).editing.orderNumber
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "flex",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    className: "m-0 text-sm",
                    children: "Endringene kan gj\xf8res direkte i handlekurven. G\xe5 til kassen og send inn ordren for \xe5 lagre endringene."
                })
            })
        ]
    });
});
// Separate top bar when we are editing an order. TypeScript is a silly goose and doesn't understand that the existing check
// ensures the same thing as this added section section. To keep it easily humanly readable I am leaving both.
const $e7d8001c74cd4e48$var$ChangeOrderOrSubscription = ()=>{
    if ((0, $76PCP.default).isEditing() && !(0, $bEEBX.default)((0, $76PCP.default).editing)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOOuf.Group), {
        justify: "center",
        className: "bg-surface-default shadow-md",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
            className: "w-full max-w-[--main-column-max-width] px-3 py-6 md:px-12",
            children: [
                (0, $76PCP.default).editing.orderType === (0, $8aSS4.ORDERTYPE).WAS && /*#__PURE__*/ (0, $7YWoO.jsx)($e7d8001c74cd4e48$var$SubscriptionEditingDeliveryInfo, {}),
                (0, $76PCP.default).editing.orderType !== (0, $8aSS4.ORDERTYPE).WAS && /*#__PURE__*/ (0, $7YWoO.jsx)($e7d8001c74cd4e48$var$DefaultEditingDeliveryInfo, {})
            ]
        })
    });
    return null;
};
var $e7d8001c74cd4e48$export$2e2bcd8739ae039 = (0, $gBcml.observer)($e7d8001c74cd4e48$var$ChangeOrderOrSubscription);



var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $4udGV = parcelRequire("4udGV");

var $9Vhxl = parcelRequire("9Vhxl");

var $8z7vy = parcelRequire("8z7vy");
const $a8aaa31098c7660b$var$getMode = (deliveryDate, expiration)=>{
    if (deliveryDate && expiration !== null) {
        if (expiration === 0) return "expired";
        if (expiration > (0, $8z7vy.SIXTY_MINUTES)) return "GT60";
        if (expiration > (0, $8z7vy.TEN_MINUTES)) return "LTE60";
        return "LTE10";
    }
    return "none";
};
const $a8aaa31098c7660b$var$deadlineClassName = (0, $izjX7.cn)([
    "w-[210px]"
]);
const $a8aaa31098c7660b$var$conspicuousClassName = (0, $izjX7.cn)([
    $a8aaa31098c7660b$var$deadlineClassName,
    "text-error-600"
]);
const $a8aaa31098c7660b$var$Deadline = ()=>{
    const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
    const expiration = (0, $9Vhxl.default).getCurrentDeliveryExpiration();
    const mode = (0, $dvPqk.useMemo)(()=>$a8aaa31098c7660b$var$getMode(currentDelivery, expiration), [
        currentDelivery,
        expiration
    ]);
    const formattedDate = currentDelivery ? (0, $4udGV.formatDateTime)(currentDelivery.deadline, true, true) : "";
    const formattedTimePeriod = typeof expiration === "number" ? (0, $8z7vy.formatTimePeriod)(expiration) : "";
    const className = mode === "LTE10" || mode === "expired" ? $a8aaa31098c7660b$var$conspicuousClassName : $a8aaa31098c7660b$var$deadlineClassName;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            mode === "GT60" && /*#__PURE__*/ (0, $7YWoO.jsx)("time", {
                className: className,
                dateTime: currentDelivery?.deadline.toISOString(),
                children: formattedDate
            }),
            (mode === "LTE60" || mode === "LTE10") && /*#__PURE__*/ (0, $7YWoO.jsx)("time", {
                className: className,
                children: formattedTimePeriod
            }),
            " ",
            mode === "expired" && /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                className: className,
                children: "Utl\xf8pt"
            })
        ]
    });
};
var $a8aaa31098c7660b$export$2e2bcd8739ae039 = (0, $gBcml.observer)($a8aaa31098c7660b$var$Deadline);


const $0334f5711cbbecb9$var$className = (0, $izjX7.cn)([
    "flex flex-row justify-start gap-8 py-2"
]);
const $0334f5711cbbecb9$var$itemClassName = (0, $izjX7.cn)([
    "flex flex-row items-center gap-2"
]);
const $0334f5711cbbecb9$var$iconAndLabelClassName = (0, $izjX7.cn)([
    "flex items-center",
    "font-bold"
]);
const $0334f5711cbbecb9$var$DeliveryInfo = ()=>{
    if (!(0, $bcbvQ.default).isLoggedIn() || (0, $bcbvQ.default).error) return null;
    if ((0, $duLFK.isLoading)((0, $9Vhxl.default).deliveryDates)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {
        label: "Laster leveringsdager..."
    });
    if ((0, $76PCP.default).isEditing() && !(0, $bEEBX.default)((0, $76PCP.default).editing)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $e7d8001c74cd4e48$export$2e2bcd8739ae039), {});
    const dayLabel = (0, $5OqMf.translateDayLabel)((0, $76PCP.default).orderType);
    const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
    if (currentDelivery === null) {
        (0, $gtsdT.logger).log("delivery", "No current delivery found");
        return null;
    }
    const renderDeliveryDateButton = (_dates, isPickerOpen, setPickerOpen)=>{
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
            variant: "tertiary",
            onClick: ()=>setPickerOpen(!isPickerOpen),
            children: "Endre"
        });
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
        className: "shadow-md bg-surface-default",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: $0334f5711cbbecb9$var$className,
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: $0334f5711cbbecb9$var$itemClassName,
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: $0334f5711cbbecb9$var$iconAndLabelClassName,
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $inCq0.default), {
                                    className: "mr-2"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    className: "m-0 p-0",
                                    children: "Frist:"
                                })
                            ]
                        }),
                        !!currentDelivery.deadline && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a8aaa31098c7660b$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: $0334f5711cbbecb9$var$itemClassName,
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: $0334f5711cbbecb9$var$iconAndLabelClassName,
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1KGvE.default), {
                                    className: "mr-2"
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                                    className: "m-0 p-0",
                                    children: [
                                        dayLabel,
                                        ":"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    children: [
                                        (0, $4udGV.formatDeliveryDate)(currentDelivery.date, (0, $76PCP.default).orderType, currentDelivery.interval),
                                        " |"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9bzp5.default), {
                                    render: renderDeliveryDateButton
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $0334f5711cbbecb9$export$2e2bcd8739ae039 = (0, $gBcml.observer)($0334f5711cbbecb9$var$DeliveryInfo);



var $7YWoO = parcelRequire("7YWoO");


var $jOOuf = parcelRequire("jOOuf");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $7YWoO = parcelRequire("7YWoO");

var $7YWoO = parcelRequire("7YWoO");
const $d6b6e9a1dd1c25ef$var$SvgBarcodeScanner = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M2 20v-4.571h1.714v2.857h2.857V20zm16 0v-1.714h2.857v-2.857h1.714V20zM4.857 17.143V6.857h1.714v10.286zm2.857 0V6.857h1.143v10.286zm2.857 0V6.857h1.715v10.286zm2.858 0V6.857h2.285v10.286zm3.142 0V6.857h1.143v10.286zm2 0V6.857h1.143v10.286zM2 8.57V4h4.571v1.714H3.714v2.857zm18.857 0V5.714H18V4h4.571v4.571z"
        })
    }));
var $d6b6e9a1dd1c25ef$export$2e2bcd8739ae039 = $d6b6e9a1dd1c25ef$var$SvgBarcodeScanner;


parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $jQJ4P = parcelRequire("jQJ4P");

var $biFcX = parcelRequire("biFcX");

var $cLLe3 = parcelRequire("cLLe3");
const $71ea9ab48e165d13$var$BarcodeScannerButton = (props)=>{
    const isDesktop = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).xl);
    if (!(0, $biFcX.default).barcodeScannerEnabled) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        ...props,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $d6b6e9a1dd1c25ef$export$2e2bcd8739ae039), {}),
            iconPosition: "left",
            variant: "tertiary",
            size: "iconOnly",
            onClick: (0, $jQJ4P.default).showModal,
            trackingName: "Skanner",
            children: isDesktop ? "Skanner" : ""
        })
    });
};
var $71ea9ab48e165d13$export$2e2bcd8739ae039 = (0, $gBcml.observer)($71ea9ab48e165d13$var$BarcodeScannerButton);




var $7YWoO = parcelRequire("7YWoO");

var $gri2z = parcelRequire("gri2z");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $cLLe3 = parcelRequire("cLLe3");
const $728e657274d71764$var$FavoriteListButton = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
        to: "/customer/favorites",
        iconPosition: "left",
        size: "iconOnly",
        variant: "tertiary",
        icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gri2z.default), {}),
        "aria-label": "favorittlister",
        trackingName: "Favorittlister",
        "data-testid": "go-to-favorite-list-menu-button",
        children: (0, $gUV6W.default)((0, $5OqMf.mediaQueries).xl) ? "Favorittlister" : ""
    });
};
var $728e657274d71764$export$2e2bcd8739ae039 = (0, $gBcml.observer)($728e657274d71764$var$FavoriteListButton);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $lKrOo = parcelRequire("lKrOo");

var $jlTfJ = parcelRequire("jlTfJ");

var $a2SqC = parcelRequire("a2SqC");

var $cLLe3 = parcelRequire("cLLe3");

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
parcelRequire("1wfes");
var $8f7hb = parcelRequire("8f7hb");

var $aRCaF = parcelRequire("aRCaF");

var $a2SqC = parcelRequire("a2SqC");
const $7c37f063337fb6c1$var$TranslationText = ({ textKey: textKey, count: count, interpolation: interpolation, defaultText: defaultText })=>{
    const { t: t } = (0, $8f7hb.useTranslation)();
    if ((0, $a2SqC.default).showTranslationKeys) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: `${textKey}`
    });
    if ((0, $a2SqC.default).showDefaultTranslationText) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: defaultText || "No default text provided"
    });
    if (count !== undefined) {
        const key = (0, $aRCaF.getKeyPlural)(textKey, count);
        const translation = t(key, {
            count: count,
            ...interpolation
        });
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
            children: translation
        });
    }
    const translation = t(textKey, interpolation);
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: translation
    });
};
var $7c37f063337fb6c1$export$2e2bcd8739ae039 = (0, $gBcml.observer)($7c37f063337fb6c1$var$TranslationText);


const $2d294969301bc389$var$LoginButton = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: !(0, $jlTfJ.default).isPreviewMode && !(0, $lKrOo.default).is("START_UP") && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
            "data-testid": "login-button",
            size: "regular",
            className: "mr-2",
            onClick: (0, $a2SqC.default).showLoginModal,
            trackingName: "Logg inn navbar",
            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7c37f063337fb6c1$export$2e2bcd8739ae039), {
                textKey: "Login.LoginButton",
                defaultText: "Logg inn"
            })
        })
    });
};
var $2d294969301bc389$export$2e2bcd8739ae039 = (0, $gBcml.observer)($2d294969301bc389$var$LoginButton);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $isIf6 = parcelRequire("isIf6");

var $cLLe3 = parcelRequire("cLLe3");
const $b6dd253ba0bf40f5$var$NewCustomerButton = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
        size: "regular",
        variant: "tertiary",
        as: "a",
        to: (0, $isIf6.default).newCustomerForm,
        children: "Bli kunde"
    });
};
var $b6dd253ba0bf40f5$export$2e2bcd8739ae039 = (0, $gBcml.observer)($b6dd253ba0bf40f5$var$NewCustomerButton);



var $dWcIP = parcelRequire("dWcIP");

var $7YWoO = parcelRequire("7YWoO");

var $5V760 = parcelRequire("5V760");

var $izjX7 = parcelRequire("izjX7");
var $51363497a9c3dd8e$exports = {};
"use strict";
function $51363497a9c3dd8e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $51363497a9c3dd8e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $51363497a9c3dd8e$var$_typeof(o);
}
var $51363497a9c3dd8e$var$_exec$, $51363497a9c3dd8e$var$_exec;
function $51363497a9c3dd8e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $51363497a9c3dd8e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $51363497a9c3dd8e$var$_toPropertyKey(o.key), o);
    }
}
function $51363497a9c3dd8e$var$_createClass(e, r, t) {
    return r && $51363497a9c3dd8e$var$_defineProperties(e.prototype, r), t && $51363497a9c3dd8e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $51363497a9c3dd8e$var$_callSuper(t, o, e) {
    return o = $51363497a9c3dd8e$var$_getPrototypeOf(o), $51363497a9c3dd8e$var$_possibleConstructorReturn(t, $51363497a9c3dd8e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $51363497a9c3dd8e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $51363497a9c3dd8e$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $51363497a9c3dd8e$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $51363497a9c3dd8e$var$_assertThisInitialized(t);
}
function $51363497a9c3dd8e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $51363497a9c3dd8e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($51363497a9c3dd8e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $51363497a9c3dd8e$var$_getPrototypeOf(t) {
    return $51363497a9c3dd8e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $51363497a9c3dd8e$var$_getPrototypeOf(t);
}
function $51363497a9c3dd8e$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $51363497a9c3dd8e$var$_setPrototypeOf(t, e);
}
function $51363497a9c3dd8e$var$_setPrototypeOf(t, e) {
    return $51363497a9c3dd8e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $51363497a9c3dd8e$var$_setPrototypeOf(t, e);
}
function $51363497a9c3dd8e$var$_defineProperty(e, r, t) {
    return (r = $51363497a9c3dd8e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $51363497a9c3dd8e$var$_toPropertyKey(t) {
    var i = $51363497a9c3dd8e$var$_toPrimitive(t, "string");
    return "symbol" == $51363497a9c3dd8e$var$_typeof(i) ? i : i + "";
}
function $51363497a9c3dd8e$var$_toPrimitive(t, r) {
    if ("object" != $51363497a9c3dd8e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $51363497a9c3dd8e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $dvPqk = parcelRequire("dvPqk");
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $4504l = parcelRequire("4504l");
function $fd553423b647e927$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fd553423b647e927$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $fd553423b647e927$var$_arrayLikeToArray(r);
}
function $fd553423b647e927$var$_defineProperty(e, r, t) {
    return (r = $fd553423b647e927$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $fd553423b647e927$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $fd553423b647e927$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fd553423b647e927$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd553423b647e927$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd553423b647e927$var$ownKeys(Object(t), true).forEach(function(r) {
            $fd553423b647e927$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd553423b647e927$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fd553423b647e927$var$_toConsumableArray(r) {
    return $fd553423b647e927$var$_arrayWithoutHoles(r) || $fd553423b647e927$var$_iterableToArray(r) || $fd553423b647e927$var$_unsupportedIterableToArray(r) || $fd553423b647e927$var$_nonIterableSpread();
}
function $fd553423b647e927$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fd553423b647e927$var$_toPropertyKey(t) {
    var i = $fd553423b647e927$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fd553423b647e927$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fd553423b647e927$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fd553423b647e927$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $fd553423b647e927$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap._setPausedState(true);
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0 && !trapStack[trapStack.length - 1]._isManuallyPaused()) trapStack[trapStack.length - 1]._setPausedState(false);
    }
};
var $fd553423b647e927$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var $fd553423b647e927$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $fd553423b647e927$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $fd553423b647e927$var$isKeyForward = function isKeyForward(e) {
    return $fd553423b647e927$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $fd553423b647e927$var$isKeyBackward = function isKeyBackward(e) {
    return $fd553423b647e927$var$isTabEvent(e) && e.shiftKey;
};
var $fd553423b647e927$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $fd553423b647e927$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var $fd553423b647e927$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $fd553423b647e927$var$internalTrapStack = [];
var $fd553423b647e927$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $fd553423b647e927$var$internalTrapStack;
    var config = $fd553423b647e927$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $fd553423b647e927$var$isKeyForward,
        isKeyBackward: $fd553423b647e927$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @param {Object} options
   * @param {boolean} [options.hasFallback] True if the option could be a selector string
   *  and the option allows for a fallback scenario in the case where the selector is
   *  valid but does not match a node (i.e. the queried node doesn't exist in the DOM).
   * @param {Array} [options.params] Params to pass to the option if it's a function.
   * @returns {undefined | null | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `null` if the option didn't resolve
   *  to a node but `options.hasFallback=true`, `false` if the option resolved to `false`
   *  (node explicitly not given); otherwise, the resolved DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node, unless the option is a selector string and `options.hasFallback=true`.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$hasFallback = _ref2.hasFallback, hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? [] : _ref2$params;
        var optionValue = config[optionName];
        if (typeof optionValue === 'function') optionValue = optionValue.apply(void 0, $fd553423b647e927$var$_toConsumableArray(params));
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === 'string') {
            try {
                node = doc.querySelector(optionValue); // resolve to node, or null if fails
            } catch (err) {
                throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
            }
            if (!node) {
                if (!hasFallback) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            // else, `node` MUST be `null` because that's what `Document.querySelector()` returns
            //  if the selector is valid but doesn't match anything
            }
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption('initialFocus', {
            hasFallback: true
        });
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || node && !(0, $4504l.isFocusable)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption('fallbackFocus');
            }
        } else if (node === null) // option is a VALID selector string that doesn't yield a node: use the `fallbackFocus`
        //  option instead of the default behavior when the option isn't specified at all
        node = getNodeForOption('fallbackFocus');
        if (!node) throw new Error('Your focus-trap needs to have at least one focusable element');
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $4504l.tabbable)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $4504l.focusable)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $4504l.isTabbable)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $4504l.isTabbable)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $4504l.getTabIndex)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $4504l.isTabbable)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $4504l.isTabbable)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
        ) throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var _getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return _getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var _tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === _getActiveElement(document)) return;
        if (!node || !node.focus) {
            _tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($fd553423b647e927$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption('setReturnFocus', {
            params: [
                previousActiveElement
            ]
        });
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref3) {
        var target = _ref3.target, event = _ref3.event, _ref3$isBackward = _ref3.isBackward, isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
        target = target || $fd553423b647e927$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = state.tabbableGroups.findIndex(function(_ref4) {
                    var firstTabbableNode = _ref4.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $4504l.isFocusable)(target, config.tabbableOptions) && !(0, $4504l.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $4504l.getTabIndex)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$fd553423b647e927$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = state.tabbableGroups.findIndex(function(_ref5) {
                    var lastTabbableNode = _ref5.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $4504l.isFocusable)(target, config.tabbableOptions) && !(0, $4504l.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $4504l.getTabIndex)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$fd553423b647e927$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $fd553423b647e927$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($fd553423b647e927$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($fd553423b647e927$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $fd553423b647e927$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $4504l.getTabIndex)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $4504l.getTabIndex)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) _tryFocus(nextNode);
            else _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($fd553423b647e927$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            _tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkTabKey = function checkTabKey(event) {
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    // we use a different event phase for the Escape key to allow canceling the event and checking for this in escapeDeactivates
    var checkEscapeKey = function checkEscapeKey(event) {
        if ($fd553423b647e927$var$isEscapeEvent(event) && $fd553423b647e927$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
        }
    };
    var checkClick = function checkClick(e) {
        var target = $fd553423b647e927$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($fd553423b647e927$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($fd553423b647e927$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $fd553423b647e927$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $fd553423b647e927$var$delay(function() {
            _tryFocus(getInitialFocusNode());
        }) : _tryFocus(getInitialFocusNode());
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('touchstart', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('click', checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkTabKey, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkEscapeKey);
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkTabKey, true);
        doc.removeEventListener('keydown', checkEscapeKey);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) _tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, 'onActivate');
            var onPostActivate = getOption(activateOptions, 'onPostActivate');
            var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = _getActiveElement(doc);
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $fd553423b647e927$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $fd553423b647e927$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, 'onDeactivate');
            var onPostDeactivate = getOption(options, 'onPostDeactivate');
            var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
            var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $fd553423b647e927$var$delay(function() {
                    if (returnFocus) _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = true;
            return this._setPausedState(true, pauseOptions);
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = false;
            if (trapStack[trapStack.length - 1] !== this) return this;
            return this._setPausedState(false, unpauseOptions);
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === 'string' ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    Object.defineProperties(trap, {
        _isManuallyPaused: {
            value: function value() {
                return state.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function value(paused, options) {
                if (state.paused === paused) return this;
                state.paused = paused;
                if (paused) {
                    var onPause = getOption(options, 'onPause');
                    var onPostPause = getOption(options, 'onPostPause');
                    onPause === null || onPause === void 0 || onPause();
                    removeListeners();
                    updateObservedNodes();
                    onPostPause === null || onPostPause === void 0 || onPostPause();
                } else {
                    var onUnpause = getOption(options, 'onUnpause');
                    var onPostUnpause = getOption(options, 'onPostUnpause');
                    onUnpause === null || onUnpause === void 0 || onUnpause();
                    updateTabbableNodes();
                    addListeners();
                    updateObservedNodes();
                    onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
                }
                return this;
            }
        }
    });
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};


var $51363497a9c3dd8e$var$createFocusTrap = $fd553423b647e927$export$360440dfcba94c00;

var $4504l = parcelRequire("4504l");
var $51363497a9c3dd8e$var$isFocusable = $4504l.isFocusable;
/**
 * The major version of React currently running.
 * @type {number}
 */ var $51363497a9c3dd8e$var$reactVerMajor = parseInt(($51363497a9c3dd8e$var$_exec$ = ($51363497a9c3dd8e$var$_exec = /^(\d+)\./.exec($dvPqk.version)) === null || $51363497a9c3dd8e$var$_exec === void 0 ? void 0 : $51363497a9c3dd8e$var$_exec[1]) !== null && $51363497a9c3dd8e$var$_exec$ !== void 0 ? $51363497a9c3dd8e$var$_exec$ : 0, 10);
/**
 * @type {import('../index.d.ts').FocusTrap}
 */ var $51363497a9c3dd8e$var$FocusTrap = /*#__PURE__*/ function(_React$Component) {
    function FocusTrap(props) {
        var _this;
        $51363497a9c3dd8e$var$_classCallCheck(this, FocusTrap);
        _this = $51363497a9c3dd8e$var$_callSuper(this, FocusTrap, [
            props
        ]);
        /**
     * Gets the node for the given option, which is expected to be an option that
     *  can be either a DOM node, a string that is a selector to get a node, `false`
     *  (if a node is explicitly NOT given), or a function that returns any of these
     *  values.
     * @param {string} optionName
     * @returns {undefined | false | HTMLElement | SVGElement} Returns
     *  `undefined` if the option is not specified; `false` if the option
     *  resolved to `false` (node explicitly not given); otherwise, the resolved
     *  DOM node.
     * @throws {Error} If the option is set, not `false`, and is not, or does not
     *  resolve to a node.
     */ $51363497a9c3dd8e$var$_defineProperty(_this, "getNodeForOption", function(optionName) {
            var _this$internalOptions;
            // use internal options first, falling back to original options
            var optionValue = (_this$internalOptions = this.internalOptions[optionName]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName];
            if (typeof optionValue === 'function') {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                optionValue = optionValue.apply(void 0, params);
            }
            if (optionValue === true) optionValue = undefined; // use default value
            if (!optionValue) {
                if (optionValue === undefined || optionValue === false) return optionValue;
                // else, empty string (invalid), null (invalid), 0 (invalid)
                throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
            }
            var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
            if (typeof optionValue === 'string') {
                var _this$getDocument;
                node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue); // resolve to node, or null if fails
                if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
            return node;
        });
        _this.handleDeactivate = _this.handleDeactivate.bind(_this);
        _this.handlePostDeactivate = _this.handlePostDeactivate.bind(_this);
        _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind(_this);
        // focus-trap options used internally when creating the trap
        _this.internalOptions = {
            // We need to hijack the returnFocusOnDeactivate option,
            // because React can move focus into the element before we arrived at
            // this lifecycle hook (e.g. with autoFocus inputs). So the component
            // captures the previouslyFocusedElement in componentWillMount,
            // then (optionally) returns focus to it in componentWillUnmount.
            returnFocusOnDeactivate: false,
            // the rest of these are also related to deactivation of the trap, and we
            //  need to use them and control them as well
            checkCanReturnFocus: null,
            onDeactivate: _this.handleDeactivate,
            onPostDeactivate: _this.handlePostDeactivate,
            // we need to special-case this setting as well so that we can know if we should
            //  NOT return focus if the trap gets auto-deactivated as the result of an
            //  outside click (otherwise, we'll always think we should return focus because
            //  of how we manage that flag internally here)
            clickOutsideDeactivates: _this.handleClickOutsideDeactivates
        };
        // original options provided by the consumer
        _this.originalOptions = {
            // because of the above `internalOptions`, we maintain our own flag for
            //  this option, and default it to `true` because that's focus-trap's default
            returnFocusOnDeactivate: true,
            // because of the above `internalOptions`, we keep these separate since
            //  they're part of the deactivation process which we configure (internally) to
            //  be shared between focus-trap and focus-trap-react
            onDeactivate: null,
            onPostDeactivate: null,
            checkCanReturnFocus: null,
            // the user's setting, defaulted to false since focus-trap defaults this to false
            clickOutsideDeactivates: false
        };
        var focusTrapOptions = props.focusTrapOptions;
        for(var optionName in focusTrapOptions){
            if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) continue;
            if (optionName === 'returnFocusOnDeactivate' || optionName === 'onDeactivate' || optionName === 'onPostDeactivate' || optionName === 'checkCanReturnFocus' || optionName === 'clickOutsideDeactivates') {
                _this.originalOptions[optionName] = focusTrapOptions[optionName];
                continue; // exclude from internalOptions
            }
            _this.internalOptions[optionName] = focusTrapOptions[optionName];
        }
        // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
        //  node that was clicked, and `allowDeactivation` is the result of the consumer's
        //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
        //  function) whether to allow or deny auto-deactivation on click on this outside node
        _this.outsideClick = null;
        // elements from which to create the focus trap on mount; if a child is used
        //  instead of the `containerElements` prop, we'll get the child's related
        //  element when the trap renders and then is declared 'mounted'
        _this.focusTrapElements = props.containerElements || [];
        // now we remember what the currently focused element is, not relying on focus-trap
        _this.updatePreviousElement();
        return _this;
    }
    /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */ $51363497a9c3dd8e$var$_inherits(FocusTrap, _React$Component);
    return $51363497a9c3dd8e$var$_createClass(FocusTrap, [
        {
            key: "getDocument",
            value: function getDocument() {
                // SSR: careful to check if `document` exists before accessing it as a variable
                return this.props.focusTrapOptions.document || (typeof document !== 'undefined' ? document : undefined);
            }
        },
        {
            key: "getReturnFocusNode",
            value: function getReturnFocusNode() {
                var node = this.getNodeForOption('setReturnFocus', this.previouslyFocusedElement);
                return node ? node : node === false ? false : this.previouslyFocusedElement;
            }
        },
        {
            key: "updatePreviousElement",
            value: function updatePreviousElement() {
                var currentDocument = this.getDocument();
                if (currentDocument) this.previouslyFocusedElement = currentDocument.activeElement;
            }
        },
        {
            key: "deactivateTrap",
            value: function deactivateTrap() {
                // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
                //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
                //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
                //  will initiate its auto-deactivation process, which will call our own
                //  handleDeactivate(), which will call into this method
                if (!this.focusTrap || !this.focusTrap.active) return;
                this.focusTrap.deactivate({
                    // NOTE: we never let the trap return the focus since we do that ourselves
                    returnFocus: false,
                    // we'll call this in our own post deactivate handler so make sure the trap doesn't
                    //  do it prematurely
                    checkCanReturnFocus: null,
                    // let it call the user's original deactivate handler, if any, instead of
                    //  our own which calls back into this function
                    onDeactivate: this.originalOptions.onDeactivate
                });
            }
        },
        {
            key: "handleClickOutsideDeactivates",
            value: function handleClickOutsideDeactivates(event) {
                // use consumer's option (or call their handler) as the permission or denial
                var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === 'function' ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
                 : this.originalOptions.clickOutsideDeactivates; // boolean
                if (allowDeactivation) // capture the outside target that was clicked so we can use it in the deactivation
                //  process since the consumer allowed it to cause auto-deactivation
                this.outsideClick = {
                    target: event.target,
                    allowDeactivation: allowDeactivation
                };
                return allowDeactivation;
            }
        },
        {
            key: "handleDeactivate",
            value: function handleDeactivate() {
                if (this.originalOptions.onDeactivate) this.originalOptions.onDeactivate.call(null); // call user's handler out of context
                this.deactivateTrap();
            }
        },
        {
            key: "handlePostDeactivate",
            value: function handlePostDeactivate() {
                var _this2 = this;
                var finishDeactivation = function finishDeactivation() {
                    var returnFocusNode = _this2.getReturnFocusNode();
                    var canReturnFocus = !!// did the consumer allow it?
                    (_this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
                    returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && // was there an outside click that allowed deactivation?
                    (!_this2.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
                    _this2.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
                    //  as a result of the click-through) -- in which case do NOT restore focus
                    //  to `returnFocusNode` because focus should remain on the outside node
                    !$51363497a9c3dd8e$var$isFocusable(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions)));
                    var _this2$internalOption = _this2.internalOptions.preventScroll, preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;
                    if (canReturnFocus) // return focus to the element that had focus when the trap was activated
                    returnFocusNode.focus({
                        preventScroll: preventScroll
                    });
                    if (_this2.originalOptions.onPostDeactivate) _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"
                    _this2.outsideClick = null; // reset: no longer needed
                };
                if (this.originalOptions.checkCanReturnFocus) this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
                .then(finishDeactivation, finishDeactivation);
                else finishDeactivation();
            }
        },
        {
            key: "setupFocusTrap",
            value: function setupFocusTrap() {
                if (this.focusTrap) // trap already exists: it's possible we're in StrictMode and we're being remounted,
                //  in which case, we will have deactivated the trap when we got unmounted (remember,
                //  StrictMode, in development, purposely unmounts and remounts components after
                //  mounting them the first time to make sure they have reusable state,
                //  @see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state) so now
                //  we need to restore the state of the trap according to our component state
                // NOTE: Strict mode __violates__ assumptions about the `componentWillUnmount()` API
                //  which clearly states -- even for React 18 -- that, "Once a component instance is
                //  unmounted, __it will never be mounted again.__" (emphasis ours). So when we get
                //  unmounted, we assume we're gone forever and we deactivate the trap. But then
                //  we get remounted and we're supposed to restore state. But if you had paused,
                //  we've now deactivated (we don't know we're amount to get remounted again)
                //  which means we need to reactivate and then pause. Otherwise, do nothing.
                {
                    if (this.props.active && !this.focusTrap.active) {
                        this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                } else {
                    var nodesExist = this.focusTrapElements.some(Boolean);
                    if (nodesExist) {
                        this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions);
                        if (this.props.active) this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.active) this.setupFocusTrap();
            // else, wait for later activation in case the `focusTrapOptions` will be updated
            //  again before the trap is activated (e.g. if waiting to know what the document
            //  object will be, so the Trap must be rendered, but the consumer is waiting to
            //  activate until they have obtained the document from a ref)
            //  @see https://github.com/focus-trap/focus-trap-react/issues/539
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.focusTrap) {
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrap.updateContainerElements(this.props.containerElements);
                    var hasActivated = !prevProps.active && this.props.active;
                    var hasDeactivated = prevProps.active && !this.props.active;
                    var hasPaused = !prevProps.paused && this.props.paused;
                    var hasUnpaused = prevProps.paused && !this.props.paused;
                    if (hasActivated) {
                        this.updatePreviousElement();
                        this.focusTrap.activate();
                    }
                    if (hasDeactivated) {
                        this.deactivateTrap();
                        return; // un/pause does nothing on an inactive trap
                    }
                    if (hasPaused) this.focusTrap.pause();
                    if (hasUnpaused) this.focusTrap.unpause();
                } else {
                    // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
                    //  it either means it shouldn't be active, or it should be but none of
                    //  of given `containerElements` were present in the DOM the last time
                    //  we tried to create the trap
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrapElements = this.props.containerElements;
                    // don't create the trap unless it should be active in case the consumer
                    //  is still updating `focusTrapOptions`
                    //  @see https://github.com/focus-trap/focus-trap-react/issues/539
                    if (this.props.active) {
                        this.updatePreviousElement();
                        this.setupFocusTrap();
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.deactivateTrap();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var child = this.props.children ? $dvPqk.Children.only(this.props.children) : undefined;
                if (child) {
                    if (child.type && child.type === $dvPqk.Fragment) throw new Error('A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.');
                    var callbackRef = function callbackRef(element) {
                        var containerElements = _this3.props.containerElements;
                        if (child) {
                            // React 19 moved the `ref` to an official prop
                            if ($51363497a9c3dd8e$var$reactVerMajor >= 19) {
                                if (typeof child.props.ref === 'function') child.props.ref(element);
                                else if (child.props.ref) child.props.ref.current = element;
                            } else {
                                // older versions of React had the `ref` separate from props (still works in R19
                                //  but results in a deprecation warning in Dev builds)
                                if (typeof child.ref === 'function') child.ref(element);
                                else if (child.ref) child.ref.current = element;
                            }
                        }
                        _this3.focusTrapElements = containerElements ? containerElements : [
                            element
                        ];
                    };
                    var childWithRef = $dvPqk.cloneElement(child, {
                        ref: callbackRef
                    });
                    return childWithRef;
                }
                return null;
            }
        }
    ]);
}($dvPqk.Component); // NOTE: While React 19 REMOVED support for `propTypes`, support for `defaultProps`
//  __for class components ONLY__ remains: "Class components will continue to support
//  defaultProps since there is no ES6 alternative."
//  @see https://react.dev/blog/2024/04/25/react-19-upgrade-guide#removed-proptypes-and-defaultprops
$51363497a9c3dd8e$var$FocusTrap.defaultProps = {
    active: true,
    paused: false,
    focusTrapOptions: {},
    _createFocusTrap: $51363497a9c3dd8e$var$createFocusTrap
};
// 🔺 DEPRECATED: default export
$51363497a9c3dd8e$exports = $51363497a9c3dd8e$var$FocusTrap;
// named export
$51363497a9c3dd8e$exports.FocusTrap = $51363497a9c3dd8e$var$FocusTrap;



var $d4mYJ = parcelRequire("d4mYJ");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $jECH9 = parcelRequire("jECH9");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $BjdTh = parcelRequire("BjdTh");

var $hFzdq = parcelRequire("hFzdq");

var $iX5v3 = parcelRequire("iX5v3");

var $isIf6 = parcelRequire("isIf6");


var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $jECH9 = parcelRequire("jECH9");

var $BjdTh = parcelRequire("BjdTh");

var $hFzdq = parcelRequire("hFzdq");

var $6pY3b = parcelRequire("6pY3b");

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $iB77C = parcelRequire("iB77C");

var $jECH9 = parcelRequire("jECH9");

var $jlTfJ = parcelRequire("jlTfJ");

var $hFzdq = parcelRequire("hFzdq");

var $iX5v3 = parcelRequire("iX5v3");

var $aFpyD = parcelRequire("aFpyD");

var $cZFWp = parcelRequire("cZFWp");
const $2ab4a10bec910422$var$hide = ()=>(0, $hFzdq.default).clear((0, $jECH9.SEARCH_TYPE).QuickSearch, true);
const $2ab4a10bec910422$var$CmsContentHit = ({ hit: hit, position: position, locale: locale, searchDomain: searchDomain, queryID: queryID })=>{
    const [location] = (0, $8kt8E.useLocation)();
    const articleUrlData = (0, $jlTfJ.default).urlData.data.find((data)=>data.id === hit.objectID);
    if (!articleUrlData) return null;
    let image;
    let displayTitle = (0, $iX5v3.getLocalizedString)(hit.fields?.title || {}, locale);
    const articleUrl = `/${articleUrlData.fullUrl}`;
    if (hit.fields && "headerImage" in hit.fields) {
        const imageId = hit.fields?.headerImage?.[0, $iB77C.DEFAULT_LOCALE]?.sys.id;
        image = /*#__PURE__*/ (0, $7YWoO.jsx)((0, $aFpyD.default), {
            className: "rounded-2",
            placement: "aboveFold",
            width: 100,
            ratio: "16x9",
            entryId: imageId
        });
    }
    if (hit.fields && "recipeData" in hit.fields && hit.fields.recipeData && hit.fields.recipeData[0, $iB77C.DEFAULT_LOCALE] && hit.fields.recipeData[0, $iB77C.DEFAULT_LOCALE].image) {
        displayTitle = hit.fields.recipeData[0, $iB77C.DEFAULT_LOCALE].displayName || displayTitle;
        const recipeImage = hit.fields.recipeData[0, $iB77C.DEFAULT_LOCALE].image;
        if (recipeImage.url && recipeImage.title) image = /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cZFWp.default), {
            className: "rounded-md",
            placement: "aboveFold",
            width: 100,
            ratio: "16x9",
            url: recipeImage.url,
            title: recipeImage.title
        });
    }
    const handleClick = (id, position, url)=>{
        (0, $hFzdq.default).reportAlgoliaClick(id, searchDomain.indexName, queryID, position, true, (0, $jECH9.SEARCH_TYPE).QuickSearch);
        (0, $hFzdq.default).reportArticleViewed(id, searchDomain.indexName, queryID);
        if (url === location) $2ab4a10bec910422$var$hide();
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "flex items-center justify-between px-1 py-2 hover:bg-[--search-quick-results-item-bg-hover] lg:pr-6",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
            to: articleUrl,
            onClick: ()=>handleClick(hit.objectID, position, articleUrl),
            className: "flex items-center",
            children: [
                !!image && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: "min-w-20 max-w-20",
                    children: image
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: "mx-2 grow overflow-ellipsis",
                    children: displayTitle
                })
            ]
        })
    });
};
var $2ab4a10bec910422$export$2e2bcd8739ae039 = (0, $gBcml.observer)($2ab4a10bec910422$var$CmsContentHit);


const $2a2232e1f59392dc$var$hide = ()=>(0, $hFzdq.default).clear((0, $jECH9.SEARCH_TYPE).QuickSearch, true);
const $2a2232e1f59392dc$var$HitsForCmsContent = ({ searchDomain: searchDomain, maxHits: maxHits = Number.MAX_VALUE, isNarrow: isNarrow = false })=>{
    const results = (0, $hFzdq.default)[(0, $jECH9.SEARCH_TYPE).QuickSearch].results.find((result)=>result.name === searchDomain.name);
    const hits = (results?.hits || []).slice(0, maxHits);
    const locale = (0, $BjdTh.default)();
    const containerCN = (0, $izjX7.cn)("grid gap-y-3", {
        "lg:grid-cols-3 lg:gap-x-8": !isNarrow
    });
    if (results && hits.length) {
        const { queryID: queryID } = results;
        return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                        className: "pb-2",
                        children: searchDomain.displayName(locale)
                    })
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: containerCN,
                    children: hits.map((hit, i)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $2ab4a10bec910422$export$2e2bcd8739ae039), {
                            hit: hit,
                            position: i + 1,
                            locale: locale,
                            searchDomain: searchDomain,
                            queryID: queryID
                        }, hit.objectID))
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                        className: "my-2 inline-block p-2",
                        onClick: ()=>$2a2232e1f59392dc$var$hide(),
                        href: `/search/${searchDomain.name}?q=${results.query}`,
                        children: `${searchDomain.linkText(locale)} med '${results.query}'`
                    })
                })
            ]
        });
    }
    return null;
};
var $2a2232e1f59392dc$export$2e2bcd8739ae039 = (0, $gBcml.observer)($2a2232e1f59392dc$var$HitsForCmsContent);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $gtsdT = parcelRequire("gtsdT");

var $jECH9 = parcelRequire("jECH9");

var $BjdTh = parcelRequire("BjdTh");

var $biFcX = parcelRequire("biFcX");

var $luszM = parcelRequire("luszM");

var $hFzdq = parcelRequire("hFzdq");

var $6pY3b = parcelRequire("6pY3b");

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $g9Bxb = parcelRequire("g9Bxb");

var $6fuyt = parcelRequire("6fuyt");

var $jECH9 = parcelRequire("jECH9");

var $aRSTV = parcelRequire("aRSTV");

var $bcbvQ = parcelRequire("bcbvQ");

var $bZiDo = parcelRequire("bZiDo");

var $hFzdq = parcelRequire("hFzdq");

var $27iE3 = parcelRequire("27iE3");
const $bc3238a8da7caaa5$var$hide = ()=>(0, $hFzdq.default).clear((0, $jECH9.SEARCH_TYPE).QuickSearch, true);
const $bc3238a8da7caaa5$var$ProductHit = ({ hit: hit, position: position, algoliaIndex: algoliaIndex, queryID: queryID, product: product, numberOfHits: numberOfHits })=>{
    const imageRef = (0, $dvPqk.useRef)(null);
    const productUrl = (0, $bZiDo.default).getUrl(hit);
    // Callbacks for Algolia event reporting (Personalization, A/B testing etc relies on this)
    const callbacks = {
        addToCart: (product)=>{
            (0, $hFzdq.default).reportAlgoliaAddToCart(product.sku, algoliaIndex, queryID, true, (0, $jECH9.SEARCH_TYPE).QuickSearch);
        },
        click: (product, _listName, position)=>{
            (0, $hFzdq.default).reportAlgoliaClick(product.sku, algoliaIndex, queryID, position, true, (0, $jECH9.SEARCH_TYPE).QuickSearch);
        }
    };
    const hitClicked = ()=>{
        (0, $hFzdq.default).reportAlgoliaClick(hit.sku, algoliaIndex, queryID, position, true, (0, $jECH9.SEARCH_TYPE).QuickSearch);
        if (product) (0, $6fuyt.sendProductClick)(product, {
            type: (0, $aRSTV.LIST_TYPE).SEARCH,
            name: "Quick search",
            length: numberOfHits
        }, position);
        $bc3238a8da7caaa5$var$hide();
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex items-center justify-between px-1 py-2 hover:bg-[--search-quick-results-item-bg-hover] lg:pr-4",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
                onClick: hitClicked,
                to: productUrl,
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                        alt: `Produktbilde av ${hit.name}`,
                        loading: "lazy",
                        width: 48,
                        src: (0, $g9Bxb.productImageUrl)(hit.sku, 48),
                        className: "p-0",
                        ref: imageRef
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "mx-2 basis-full",
                        children: hit.name
                    })
                ]
            }),
            (0, $bcbvQ.default).isLoggedIn() && product && !product.expired && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "w-14 shrink-0 grow-0",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $27iE3.default), {
                    product: product,
                    qty: 1,
                    listInformation: {
                        type: (0, $aRSTV.LIST_TYPE).SEARCH,
                        name: "Quick search",
                        length: numberOfHits
                    },
                    callbacks: callbacks,
                    position: position,
                    imageRefFn: ()=>imageRef,
                    className: "lg:ml-2"
                })
            })
        ]
    });
};
var $bc3238a8da7caaa5$export$2e2bcd8739ae039 = (0, $gBcml.observer)($bc3238a8da7caaa5$var$ProductHit);


const $910dbeba29d12c3c$var$hide = ()=>(0, $hFzdq.default).clear((0, $jECH9.SEARCH_TYPE).QuickSearch, true);
const $910dbeba29d12c3c$var$HitsForProduct = ({ searchDomain: searchDomain, maxHits: maxHits = Number.MAX_VALUE })=>{
    const locale = (0, $BjdTh.default)();
    const productResults = searchDomain ? (0, $hFzdq.default)[(0, $jECH9.SEARCH_TYPE).QuickSearch].results.find((result)=>result.name === searchDomain.name && searchDomain.type === "product") : undefined;
    if (!productResults) return null;
    const sortedProducts = (0, $luszM.prioritizeAgreementAssortment)(productResults.products, (0, $biFcX.default).prioritizeAgreementAssortment);
    const queryID = productResults.queryID;
    const products = sortedProducts.filter((p)=>p).slice(0, maxHits);
    const productsCount = products?.length;
    const hasProducts = !!products?.length;
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: hasProducts && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "flex w-full flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)("h3", {
                        className: "pb-2",
                        children: searchDomain.displayName(locale)
                    })
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: "grid gap-y-2 lg:grid-cols-3 lg:gap-x-8",
                    children: products.map((product, i)=>{
                        const hit = productResults.hits.find((h)=>h.sku === product.sku);
                        if (!hit) {
                            (0, $gtsdT.logger).warn("search", `Products contained product not available in search result, ${product.sku}`);
                            return null;
                        }
                        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bc3238a8da7caaa5$export$2e2bcd8739ae039), {
                            hit: hit,
                            product: product,
                            position: i + 1,
                            algoliaIndex: searchDomain?.indexName || "",
                            queryID: queryID,
                            numberOfHits: productsCount
                        }, product.sku);
                    })
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                        className: "my-2 inline-block p-2",
                        onClick: ()=>$910dbeba29d12c3c$var$hide(),
                        href: `/search/${searchDomain.name}?q=${productResults.query}`,
                        children: `${searchDomain.linkText(locale)} med '${productResults.query}'`
                    })
                })
            ]
        })
    });
};
var $910dbeba29d12c3c$export$2e2bcd8739ae039 = (0, $gBcml.observer)($910dbeba29d12c3c$var$HitsForProduct);


const $3ae7689da384cdf1$var$hide = ()=>(0, $hFzdq.default).clear((0, $jECH9.SEARCH_TYPE).QuickSearch, true);
const $3ae7689da384cdf1$var$performQuickSearch = (0, $d4mYJ.default)((locale)=>{
    (0, $hFzdq.default).performSearches((0, $jECH9.SEARCH_TYPE).QuickSearch, locale);
}, 85);
const $3ae7689da384cdf1$var$searchDomains = (0, $isIf6.default).searchConfig.searchDomains;
const $3ae7689da384cdf1$var$SearchField = ()=>{
    const [location, redirectTo] = (0, $8kt8E.useLocation)();
    const quickSearchRef = (0, $dvPqk.useRef)(null);
    const [referenceElement, setReferenceElement] = (0, $dvPqk.useState)(null);
    const locale = (0, $BjdTh.default)();
    const isXl = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).xl);
    const isLg = (0, $gUV6W.default)((0, $5OqMf.mediaQueries).lg);
    const results = (0, $hFzdq.default)[(0, $jECH9.SEARCH_TYPE).QuickSearch].results;
    const totalHits = results.reduce((total, result)=>total + result.hits.length, 0);
    const hasHits = !!totalHits;
    const isOpen = hasHits && !!(0, $hFzdq.default).query;
    const resultsWithHits = results.filter((result)=>result.hits.length);
    const hasHitsForMultipleNonProductDomains = resultsWithHits.length > 2 || resultsWithHits.length === 2 && !resultsWithHits.find((result)=>result.searchDomainType === "product");
    const nonProdDomainCN = (0, $izjX7.cn)("m-4 md:flex-1");
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" && (0, $hFzdq.default).query !== "") {
            redirectTo(`/search?q=${(0, $hFzdq.default).query}`);
            $3ae7689da384cdf1$var$hide();
        }
        if (e.key === "Escape") $3ae7689da384cdf1$var$hide();
    };
    const handleChange = (0, $Kk7R3.action)((e)=>{
        (0, $hFzdq.default).query = e.target.value;
        $3ae7689da384cdf1$var$performQuickSearch(locale);
    });
    // Clear the search field if you navigate to a new page, except for the search result page
    (0, $dvPqk.useEffect)(()=>{
        if (location !== "/search") $3ae7689da384cdf1$var$hide();
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $51363497a9c3dd8e$exports.FocusTrap), {
        active: isOpen,
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    ref: setReferenceElement,
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5V760.Search), {
                        onChange: handleChange,
                        placeholder: "S\xf8k i hele butikken",
                        label: "",
                        isLabelHidden: true,
                        value: (0, $hFzdq.default).query,
                        autoComplete: "off",
                        onKeyDown: handleKeyDown
                    })
                }),
                !!referenceElement && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    ref: quickSearchRef,
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $218da65502949c19$export$2e2bcd8739ae039), {
                        open: isOpen,
                        onOpenChange: (open)=>{
                            if (!open) $3ae7689da384cdf1$var$hide();
                        },
                        referenceElement: referenceElement,
                        withCloseButton: true,
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "flex flex-row flex-wrap",
                            children: resultsWithHits.map((results)=>{
                                const searchDomain = $3ae7689da384cdf1$var$searchDomains.find((searchDomain)=>searchDomain.type === results.searchDomainType);
                                if (searchDomain) {
                                    if (results.searchDomainType === "product") return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                        className: "m-4 basis-full",
                                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $910dbeba29d12c3c$export$2e2bcd8739ae039), {
                                            searchDomain: searchDomain,
                                            maxHits: (0, $iX5v3.getMaxHitsForSearchDomain)(results.searchDomainType, resultsWithHits, isLg, isXl)
                                        })
                                    }, searchDomain.name);
                                    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                        className: nonProdDomainCN,
                                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2a2232e1f59392dc$export$2e2bcd8739ae039), {
                                            searchDomain: searchDomain,
                                            maxHits: (0, $iX5v3.getMaxHitsForSearchDomain)(results.searchDomainType, resultsWithHits, isLg, isXl),
                                            isNarrow: hasHitsForMultipleNonProductDomains
                                        })
                                    }, searchDomain.name);
                                }
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $3ae7689da384cdf1$export$2e2bcd8739ae039 = (0, $gBcml.observer)($3ae7689da384cdf1$var$SearchField);



var $bcbvQ = parcelRequire("bcbvQ");

var $a2SqC = parcelRequire("a2SqC");

var $7YWoO = parcelRequire("7YWoO");

var $b3yR7 = parcelRequire("b3yR7");

var $cGjF4 = parcelRequire("cGjF4");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $5OqMf = parcelRequire("5OqMf");

var $7YWoO = parcelRequire("7YWoO");

var $9NHzr = parcelRequire("9NHzr");

var $cGjF4 = parcelRequire("cGjF4");

var $izjX7 = parcelRequire("izjX7");

var $dvPqk = parcelRequire("dvPqk");

var $im7eH = parcelRequire("im7eH");

var $inMER = parcelRequire("inMER");

var $5OqMf = parcelRequire("5OqMf");
const $6f1c94b86aee40f6$var$commonBorderClassName = (0, $izjX7.cn)("border-0 border-solid print:hidden");
const $6f1c94b86aee40f6$var$rightBorderClassName = (0, $izjX7.cn)("border-r border-r-ink-border-subtle", $6f1c94b86aee40f6$var$commonBorderClassName);
const $6f1c94b86aee40f6$var$leftBorderClassName = (0, $izjX7.cn)("border-l border-l-ink-border-subtle", $6f1c94b86aee40f6$var$commonBorderClassName);
const $6f1c94b86aee40f6$var$commonClassName = (0, $izjX7.cn)("fixed bottom-0 top-0 z-20", "transition duration-300 ease-in-out", "z-50 bg-base-0", "flex flex-col");
const $6f1c94b86aee40f6$var$slideFromSideClassName = {
    left: (0, $izjX7.cn)($6f1c94b86aee40f6$var$commonClassName, "left-0", $6f1c94b86aee40f6$var$rightBorderClassName),
    right: (0, $izjX7.cn)($6f1c94b86aee40f6$var$commonClassName, "right-0", $6f1c94b86aee40f6$var$leftBorderClassName)
};
const $6f1c94b86aee40f6$var$visibleClassName = (0, $izjX7.cn)("translate-x-0");
const $6f1c94b86aee40f6$var$invisibleClassName = {
    left: (0, $izjX7.cn)("-translate-x-full"),
    right: (0, $izjX7.cn)("translate-x-full")
};
const $6f1c94b86aee40f6$var$headerContainerClassName = (0, $izjX7.cn)("flex", "justify-between", "items-center", "m-3");
const $6f1c94b86aee40f6$var$bodyContainerClass = (0, $izjX7.cn)("m-3", "overflow-y-scroll", "grow", "relative");
const $6f1c94b86aee40f6$var$SlideFromSideContainer = /*#__PURE__*/ (0, $dvPqk.forwardRef)(({ show: show, onHide: onHide, renderHeader: renderHeader, renderFooter: renderFooter, side: side = "left", children: children }, forwardedRef)=>{
    const ref = (0, $dvPqk.useRef)(null);
    (0, $inMER.default)([
        ref
    ], ()=>{
        onHide();
    });
    (0, $dvPqk.useImperativeHandle)(forwardedRef, ()=>ref.current);
    (0, $dvPqk.useEffect)(()=>{
        const bodyElement = document.body;
        const bodyClasses = [
            "fixed",
            "overflow-hidden",
            "top-0",
            "bottom-0",
            "left-0",
            "right-0"
        ];
        if (show) bodyElement.classList.add(...bodyClasses);
        else bodyElement.classList.remove(...bodyClasses);
    }, [
        show
    ]);
    (0, $dvPqk.useEffect)(()=>{
        const keydownHandler = (e)=>{
            if (e.key === "Escape") onHide();
        };
        if (show) document.addEventListener("keydown", keydownHandler);
        else document.removeEventListener("keydown", keydownHandler);
        return ()=>removeEventListener("keydown", keydownHandler);
    }, [
        show
    ]);
    (0, $dvPqk.useEffect)(()=>{
        if (show && ref && typeof ref !== "function") {
            const firstFocusable = ref.current?.querySelector((0, $5OqMf.focusableElementCssSelector));
            firstFocusable?.focus();
        }
    }, [
        show,
        ref
    ]);
    const className = (0, $izjX7.cn)($6f1c94b86aee40f6$var$slideFromSideClassName[side], show ? $6f1c94b86aee40f6$var$visibleClassName : $6f1c94b86aee40f6$var$invisibleClassName[side]);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: className,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: $6f1c94b86aee40f6$var$headerContainerClassName,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: renderHeader()
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                            variant: "tertiary",
                            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9NHzr.default), {}),
                            onClick: ()=>onHide()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: $6f1c94b86aee40f6$var$bodyContainerClass,
                children: children
            }),
            renderFooter ? renderFooter() : null
        ]
    });
});
const $6f1c94b86aee40f6$var$backdropClassName = (0, $izjX7.cn)("fixed inset-0 z-40 bg-base-900 opacity-50");
const $6f1c94b86aee40f6$var$Backdrop = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: $6f1c94b86aee40f6$var$backdropClassName
    });
};
const $6f1c94b86aee40f6$var$SlideFromSide = /*#__PURE__*/ (0, $dvPqk.forwardRef)(({ children: children, show: show, ...props }, _ref)=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
        children: /*#__PURE__*/ (0, $im7eH.createPortal)(/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
            children: [
                show && /*#__PURE__*/ (0, $7YWoO.jsx)($6f1c94b86aee40f6$var$Backdrop, {}),
                /*#__PURE__*/ (0, $7YWoO.jsx)($6f1c94b86aee40f6$var$SlideFromSideContainer, {
                    show: show,
                    ...props,
                    children: children
                })
            ]
        }), document.body)
    });
});
var $6f1c94b86aee40f6$export$2e2bcd8739ae039 = $6f1c94b86aee40f6$var$SlideFromSide;



var $bcbvQ = parcelRequire("bcbvQ");

var $76PCP = parcelRequire("76PCP");

var $isIf6 = parcelRequire("isIf6");

var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $76PCP = parcelRequire("76PCP");

var $7YWoO = parcelRequire("7YWoO");

var $igSaW = parcelRequire("igSaW");
var $gri2z = parcelRequire("gri2z");
var $kbwK7 = parcelRequire("kbwK7");

var $cGjF4 = parcelRequire("cGjF4");
var $1A6xS = parcelRequire("1A6xS");

var $izjX7 = parcelRequire("izjX7");

var $azSBj = parcelRequire("azSBj");

var $kneHr = parcelRequire("kneHr");

var $3xOZa = parcelRequire("3xOZa");

var $Kk7R3 = parcelRequire("Kk7R3");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $6wnBz = parcelRequire("6wnBz");

var $gtsdT = parcelRequire("gtsdT");

var $6fuyt = parcelRequire("6fuyt");

var $aRSTV = parcelRequire("aRSTV");

var $5OqMf = parcelRequire("5OqMf");

var $f7TNd = parcelRequire("f7TNd");

var $83iWS = parcelRequire("83iWS");

var $lAgRA = parcelRequire("lAgRA");

var $9pPHV = parcelRequire("9pPHV");

var $76PCP = parcelRequire("76PCP");

var $bZiDo = parcelRequire("bZiDo");

var $luszM = parcelRequire("luszM");

var $i6TQx = parcelRequire("i6TQx");

var $gvoND = parcelRequire("gvoND");
const $bfb23b2a9046f566$var$className = (0, $izjX7.cn)("border-b-px border-0 border-solid border-b-ink-border-subtle pb-4 last:border-b-0");
const $bfb23b2a9046f566$var$oneBorderBaseCN = (0, $izjX7.cn)("border-0 border-solid");
const $bfb23b2a9046f566$var$borderBottomCN = (0, $izjX7.cn)($bfb23b2a9046f566$var$oneBorderBaseCN, "border-b-[1px] border-b-ink-border-subtle");
const $bfb23b2a9046f566$var$borderTopCN = (0, $izjX7.cn)($bfb23b2a9046f566$var$oneBorderBaseCN, "border-t-[1px] border-t-ink-border-subtle");
const $bfb23b2a9046f566$var$desktopClassName = (0, $izjX7.cn)([
    "hidden @[575px]:block"
]);
const $bfb23b2a9046f566$var$mobileClassName = (0, $izjX7.cn)([
    "block @[575px]:hidden px-2"
]);
const $bfb23b2a9046f566$var$outerRowCN = (0, $izjX7.cn)([
    "flex flex-row justify-stretch"
]);
const $bfb23b2a9046f566$var$RecyclingChange = (0, $gBcml.observer)(({ product: product })=>{
    if (product.recyclingChargeBaseUnit === 0) return null;
    const conversion = (0, $luszM.isDistributionPack)(product.unit) ? product.conversionFactor : 1;
    const recyclingCharge = product.recyclingChargeBaseUnit * conversion;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("small", {
        children: [
            "+ ",
            (0, $5OqMf.formatPrice)(recyclingCharge),
            " pant"
        ]
    });
});
const $bfb23b2a9046f566$var$MiniCartItem = (0, $gBcml.observer)(({ item: item, onCartChanged: onCartChanged, listInformation: listInformation })=>{
    const itemPosition = (0, $76PCP.default).items.findIndex((i)=>i.sku === item.sku);
    const handleInputStepperChange = (0, $Kk7R3.action)((newQty)=>{
        if ((0, $76PCP.default).isEditing()) {
            const validRange = (0, $76PCP.default).getValidQtyRange(item.sku);
            item.qty = (0, $azSBj.default)(newQty, validRange.min, validRange.max);
            if (!(0, $5OqMf.inRangeInclusive)(newQty, validRange)) (0, $gvoND.default).addError("Begrensninger p\xe5 ordren", `Ordren som du redigerer har begrensninger som gj\xf8r at du ikke kan endre antallet p\xe5 denne varen til ${newQty}.`, {
                context: "orders",
                text: "change_order_error"
            });
        } else {
            const oldQty = item.qty;
            item.qty = newQty;
            if (oldQty < newQty) (0, $6fuyt.sendAddToCart)([
                {
                    sku: item.sku,
                    qty: newQty - item.qty
                }
            ], listInformation);
            else if (oldQty > newQty) (0, $6fuyt.sendRemoveFromCart)([
                {
                    sku: item.sku,
                    qty: oldQty - newQty,
                    position: itemPosition + 1
                }
            ], listInformation);
        }
        (0, $76PCP.default).saveCartToServer();
        (0, $76PCP.default).updateCartDependencies();
        onCartChanged();
        return newQty;
    });
    const product = (0, $bZiDo.default).resolveSku(item.sku);
    if ((0, $3xOZa.default)(product)) {
        (0, $gtsdT.logger).warn("cart", `Customer has unavailable product in cart with sku ${item.sku}`);
        (0, $76PCP.default).removeFromCart(item.sku);
        return null;
    }
    const removeFromCart = ()=>{
        (0, $6fuyt.sendRemoveFromCart)([
            {
                sku: item.sku,
                qty: item.qty,
                position: itemPosition + 1
            }
        ], listInformation);
        (0, $76PCP.default).removeFromCart(item.sku);
        onCartChanged();
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: $bfb23b2a9046f566$var$className,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: (0, $izjX7.cn)($bfb23b2a9046f566$var$desktopClassName),
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: $bfb23b2a9046f566$var$outerRowCN,
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "mt-3 grow-0 px-2",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f7TNd.default), {
                                product: product,
                                size: 48,
                                className: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: "flex shrink grow flex-col",
                            children: [
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                            className: "my-3 py-2 text-base",
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                                                to: (0, $bZiDo.default).getUrl(product),
                                                children: product.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                            icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $igSaW.default), {
                                                width: 24,
                                                height: 24
                                            }),
                                            variant: "tertiary",
                                            className: "self-start",
                                            onClick: removeFromCart
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    className: "flex flex-row flex-wrap items-center gap-2 py-1",
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $83iWS.default), {
                                            sku: item.sku
                                        }),
                                        /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                "Art. nr: ",
                                                item.sku
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    className: "text-sm font-bold",
                                    children: [
                                        (0, $5OqMf.formatPrice)(product.price),
                                        " pr ",
                                        (0, $5OqMf.formatUnit)(product.unit)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)($bfb23b2a9046f566$var$RecyclingChange, {
                                    product: product
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9pPHV.default), {
                                    product: product
                                }),
                                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    className: "mr-4 mt-4 flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1A6xS.InputStepper), {
                                                min: 1,
                                                value: item.qty,
                                                onChange: handleInputStepperChange
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lAgRA.default), {
                                            className: "min-w-[140px] text-right",
                                            price: item.qty * (0, $kneHr.default)(product.priceBeforeDiscount, 0),
                                            newPrice: item.qty * (0, $kneHr.default)(product.price, 0) - (0, $i6TQx.default).getPromotionDiscount(item.sku)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: $bfb23b2a9046f566$var$mobileClassName,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "mb-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "mr-2 mt-3",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f7TNd.default), {
                                    product: product,
                                    size: 48
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "mt-3",
                                children: product.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "mb-4 flex flex-wrap items-end justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: "flex flex-col flex-wrap gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                        className: "flex gap-4",
                                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $83iWS.default), {
                                            sku: item.sku
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                        className: "text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                                className: "font-bold",
                                                children: (0, $5OqMf.formatPrice)(product.price)
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7YWoO.jsxs)("span", {
                                                className: "text-xs",
                                                children: [
                                                    "per ",
                                                    (0, $5OqMf.formatUnit)(product.unit)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lAgRA.default), {
                                price: item.qty * (0, $kneHr.default)(product.priceBeforeDiscount, 0),
                                newPrice: item.qty * (0, $kneHr.default)(product.price, 0) - (0, $i6TQx.default).getPromotionDiscount(item.sku),
                                className: "mt-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1A6xS.InputStepper), {
                                    value: item.qty,
                                    min: 1,
                                    onChange: handleInputStepperChange
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                variant: "tertiary",
                                onClick: removeFromCart,
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $igSaW.default), {
                                    width: 24,
                                    height: 24
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
const $bfb23b2a9046f566$var$MiniCartOrderLines = ({ items: items })=>{
    const qtySum = items.reduce((p, i)=>p + i.qty, 0);
    const [favoriteModalOpen, setFavoriteModalOpen] = (0, $dvPqk.useState)(false);
    const addToFavoriteText = "Lagre handlekurven som favorittliste";
    const favoriteAddedText = "Lagret som favorittliste";
    const [favoriteListAdded, setFavoriteListAdded] = (0, $dvPqk.useState)(false);
    const listInformation = {
        type: (0, $aRSTV.LIST_TYPE).CART,
        name: "Minicart",
        length: items.length
    };
    const heartIcon = favoriteListAdded ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $kbwK7.default), {
        className: "text-[--dsp-color-ink-favorites]"
    }) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $gri2z.default), {});
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: (0, $izjX7.cn)("mt-6 px-1 pb-4 text-xxs @[575px]:px-2", $bfb23b2a9046f566$var$borderBottomCN),
                children: [
                    qtySum,
                    " produkter | ",
                    items.length,
                    " varelinjer"
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "w-full",
                children: items.map((ol, _i)=>/*#__PURE__*/ (0, $7YWoO.jsx)($bfb23b2a9046f566$var$MiniCartItem, {
                        item: ol,
                        onCartChanged: ()=>setFavoriteListAdded(false),
                        listInformation: listInformation
                    }, ol.sku))
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: `flex items-end py-6 ${$bfb23b2a9046f566$var$borderTopCN} [&>button>svg]:hover:text-[--dsp-color-ink-favorites]`,
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                    variant: "secondary",
                    icon: heartIcon,
                    iconPosition: "left",
                    onClick: ()=>setFavoriteModalOpen(true),
                    children: favoriteListAdded ? favoriteAddedText : addToFavoriteText
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6wnBz.default), {
                isOpen: favoriteModalOpen,
                onCloseModal: ()=>setFavoriteModalOpen(false),
                favoriteListAdded: ()=>{
                    setFavoriteListAdded(true);
                    (0, $6fuyt.sendAddCartToFavoriteList)("minicart");
                }
            })
        ]
    });
};
var $bfb23b2a9046f566$export$2e2bcd8739ae039 = (0, $gBcml.observer)($bfb23b2a9046f566$var$MiniCartOrderLines);


const $4d641ed7634108b6$var$EmptyCart = (0, $gBcml.observer)(()=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "grow flex flex-col justify-center items-center",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("h4", {
            children: "Du har ingen varer i handlekurven"
        })
    }));
const $4d641ed7634108b6$var$MiniCartContent = ()=>{
    const items = (0, $76PCP.default).items;
    const empty = items.length === 0;
    return !empty ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bfb23b2a9046f566$export$2e2bcd8739ae039), {
        items: items
    }) : /*#__PURE__*/ (0, $7YWoO.jsx)($4d641ed7634108b6$var$EmptyCart, {});
};
var $4d641ed7634108b6$export$2e2bcd8739ae039 = (0, $gBcml.observer)($4d641ed7634108b6$var$MiniCartContent);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $5OqMf = parcelRequire("5OqMf");

var $4udGV = parcelRequire("4udGV");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");

var $7YWoO = parcelRequire("7YWoO");

var $izjX7 = parcelRequire("izjX7");

var $gyNqR = parcelRequire("gyNqR");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");
const $7f3e12a66bfa9ade$var$justifyClassName = {
    start: "justify-start",
    around: "justify-around",
    between: "justify-between",
    end: "justify-end",
    center: "justify-center"
};
const $7f3e12a66bfa9ade$var$lgAlignItemsClassName = {
    start: "@[575px]:items-start",
    stretch: "@[575px]:items-stretch",
    end: "@[575px]:items-end",
    center: "@[575px]:items-center",
    baseline: "@[575px]:items-baseline"
};
/**
 * The InfoLine element displays a row of data with a label and a value.
 * On desktop the label is shown on the same line as the value.
 * On mobile the label is shown above the line with the value because the label and value often take too much horisontal space.
 */ const $7f3e12a66bfa9ade$var$MiniCartInfoLine = ({ label: label, labelClassName: labelClassName = "", value: value, valueClassName: valueClassName = "", className: className = "", align: align = "between", valign: valign = "center", margin: margin = false, rowOnMobile: rowOnMobile = false, onClick: onClick = ()=>{} })=>{
    const classNames = (0, $izjX7.cn)(`flex ${$7f3e12a66bfa9ade$var$justifyClassName[align]}`, className, {
        [`flex-col flex-wrap items-start @[575px]:flex-row ${$7f3e12a66bfa9ade$var$lgAlignItemsClassName[valign]}`]: !rowOnMobile,
        "mb-2": margin
    });
    return(// biome-ignore lint/a11y/noStaticElementInteractions: should be a button when onClick is provided?
    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: classNames,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: `@[575px]:pr-1 ${labelClassName}`,
                children: (0, $gyNqR.default)(label) ? `${label}:` : ""
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: `@[575px]:pl-1 @[575px]:text-right ${valueClassName} ${(0, $gyNqR.default)(value) ? "font-bold" : ""}`,
                children: value ?? ""
            })
        ]
    }));
};
var $7f3e12a66bfa9ade$export$2e2bcd8739ae039 = (0, $gBcml.observer)($7f3e12a66bfa9ade$var$MiniCartInfoLine);


const $e5585470f5fe31df$var$MiniCartDates = ()=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "px-1 @[575px]:px-2",
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7f3e12a66bfa9ade$export$2e2bcd8739ae039), {
                    margin: true,
                    label: "Bestillingsfrist",
                    value: (0, $4udGV.formatDateTime)((0, $9Vhxl.default).getCurrentDelivery()?.deadline, true, true)
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7f3e12a66bfa9ade$export$2e2bcd8739ae039), {
                    margin: true,
                    label: (0, $5OqMf.translateDayLabel)((0, $76PCP.default).orderType),
                    value: (0, $4udGV.formatDeliveryDate)((0, $9Vhxl.default).getCurrentDelivery()?.date, (0, $76PCP.default).orderType, (0, $9Vhxl.default).getCurrentDelivery()?.interval)
                })
            ]
        })
    });
var $e5585470f5fe31df$export$2e2bcd8739ae039 = (0, $gBcml.observer)($e5585470f5fe31df$var$MiniCartDates);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $5OqMf = parcelRequire("5OqMf");

var $cLLe3 = parcelRequire("cLLe3");

var $8ri8d = parcelRequire("8ri8d");

var $76PCP = parcelRequire("76PCP");

var $jAf35 = parcelRequire("jAf35");

var $i6TQx = parcelRequire("i6TQx");

var $isIf6 = parcelRequire("isIf6");
const $1e34da252c61641d$var$MiniCartGoToCart = ()=>{
    const cartSummaryBeforeDiscount = (0, $76PCP.default).getCartTotalBeforeDiscount();
    const cartSummary = (0, $76PCP.default).getCartTotal();
    const deliveryCharge = (0, $jAf35.default).currentDeliveryCharge();
    const totalCartSum = cartSummary.total + cartSummary.recyclingCharge + (deliveryCharge?.currentFee?.fee ?? 0) - (0, $i6TQx.default).getTotalPromotionDiscountForCart();
    const discountFromM3Promotions = cartSummaryBeforeDiscount.total - cartSummary.total;
    const totalCartDiscount = (0, $i6TQx.default).getTotalPromotionDiscountForCart() + discountFromM3Promotions;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "mb-2 w-full px-3 lg:px-4",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ri8d.default), {}),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex justify-between p-2",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: "Total sum"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "font-bold",
                        children: (0, $5OqMf.formatPrice)(totalCartSum)
                    })
                ]
            }),
            cartSummary.recyclingCharge > 0 && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex justify-between px-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: "Inkludert pant"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: (0, $5OqMf.formatPrice)(cartSummary.recyclingCharge)
                    })
                ]
            }),
            (0, $isIf6.default).deliveryFee.enabled && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "mb-4 mt-1 flex justify-between px-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: "Inkludert leveringsgebyr"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: (0, $5OqMf.formatPrice)(deliveryCharge?.currentFee?.fee)
                    })
                ]
            }),
            totalCartDiscount > 0 && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "mb-4 mt-1 flex justify-between px-2 text-sm text-promotion",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: "Inkludert rabatt"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: `- ${(0, $5OqMf.formatPrice)(totalCartDiscount)}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "flex justify-center p-2",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                    to: "/checkout/cart",
                    onClick: (0, $76PCP.default).hideMiniCart,
                    className: "w-full",
                    "data-testid": "go-to-cart-button",
                    size: "full",
                    children: "G\xe5 til handlekurv"
                })
            })
        ]
    });
};
var $1e34da252c61641d$export$2e2bcd8739ae039 = (0, $gBcml.observer)($1e34da252c61641d$var$MiniCartGoToCart);


const $f82aabd82d0f9e63$var$MiniCart = ()=>{
    const itemCount = (0, $76PCP.default).items.reduce((s, i)=>s + i.qty, 0);
    const isLoggedIn = (0, $bcbvQ.default).isLoggedIn();
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                "data-testid": "minicart-button",
                variant: isLoggedIn && itemCount === 0 ? "secondary" : "primary",
                size: "full",
                id: "mini-cart",
                onClick: (0, $76PCP.default).showMiniCart,
                disabled: !isLoggedIn,
                icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3yR7.default), {}),
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    className: "ml-1 font-bold",
                    children: isLoggedIn ? itemCount : 0
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6f1c94b86aee40f6$export$2e2bcd8739ae039), {
                show: (0, $76PCP.default).miniCartVisible,
                side: "right",
                onHide: (0, $76PCP.default).hideMiniCart,
                renderHeader: ()=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $7YWoO.Fragment), {
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                            className: "m-0 px-1 py-0 @[575px]:px-2",
                            children: (0, $5OqMf.translateOrderType)((0, $76PCP.default).orderType, (0, $isIf6.default).storeCompanyName)
                        })
                    }),
                renderFooter: ()=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $1e34da252c61641d$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "flex min-h-full w-[min(90vw,576px)] flex-col @container",
                    children: [
                        (0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $e5585470f5fe31df$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4d641ed7634108b6$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        ]
    });
};
var $f82aabd82d0f9e63$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f82aabd82d0f9e63$var$MiniCart);



var $7YWoO = parcelRequire("7YWoO");

var $5koBm = parcelRequire("5koBm");
var $7YWoO = parcelRequire("7YWoO");
const $f916b915668dfb40$var$SvgLogout = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M5 19V5h7v1.5H6.5v11H12V19zm10.5-3.5-1.062-1.062 1.687-1.688H10v-1.5h6.125l-1.687-1.687L15.5 8.5 19 12z"
        })
    }));
var $f916b915668dfb40$export$2e2bcd8739ae039 = $f916b915668dfb40$var$SvgLogout;


var $cY4Gr = parcelRequire("cY4Gr");

var $cGjF4 = parcelRequire("cGjF4");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $8ldyR = parcelRequire("8ldyR");

var $6fuyt = parcelRequire("6fuyt");

var $gUV6W = parcelRequire("gUV6W");

var $5OqMf = parcelRequire("5OqMf");

var $eCExY = parcelRequire("eCExY");

var $6e7IR = parcelRequire("6e7IR");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $jlTfJ = parcelRequire("jlTfJ");

var $biFcX = parcelRequire("biFcX");

var $2JqjA = parcelRequire("2JqjA");

var $3oCZd = parcelRequire("3oCZd");
const $a8af60e56ef5c38a$var$UserMenu = ()=>{
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    const [show, setShow] = (0, $dvPqk.useState)(false);
    const menuItems = (0, $eCExY.useMenuItems)();
    const buttonRef = (0, $dvPqk.useRef)(null);
    const newPromotionArticlesCount = (0, $jlTfJ.default).getNewPromotionArticlesCount();
    const notificationsCount = (0, $2JqjA.default).notifications.data.length;
    const totalNotificationsCount = notificationsCount + newPromotionArticlesCount;
    const activateSwitchCompany = (e)=>{
        (0, $lKrOo.default).transitionTo("COMPANY_SELECTION");
        e.preventDefault();
    };
    const showSwitchCompany = (0, $bcbvQ.default).companies && (0, $bcbvQ.default).companies.length > 1 && !(0, $bcbvQ.default).isPunchoutSession();
    const logoutAndRedirect = ()=>{
        if ((0, $bcbvQ.default).isPunchoutSession()) {
            (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
            window.location.replace("/");
        }
        redirectTo("/");
        (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
    };
    const handleClick = ()=>{
        setShow(!show);
    };
    const handleButtonKeyDown = (e)=>{
        if (e.key === "Escape") setShow(false);
    };
    const listItemClasses = "px-5 py-3 hover:bg-surface-default-hover w-full text-start flex items-center";
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6e7IR.Popover), {
        open: show,
        onOpenChange: setShow,
        children: [
            (0, $biFcX.default).notificationsEnabled && totalNotificationsCount > 0 && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "z-10 -mr-4",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ldyR.default), {
                    count: totalNotificationsCount
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6e7IR.PopoverTrigger), {
                className: "flex",
                asChild: true,
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                    ref: buttonRef,
                    onKeyDown: handleButtonKeyDown,
                    onClick: handleClick,
                    "aria-expanded": show,
                    "aria-label": "Min konto",
                    "aria-controls": "user-menu",
                    size: "iconOnly",
                    iconPosition: "left",
                    icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cY4Gr.default), {}),
                    variant: "tertiary",
                    "data-testid": "user-menu-button",
                    children: (0, $gUV6W.default)((0, $5OqMf.mediaQueries).xl) && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex flex-row items-center",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                className: "text-nowrap",
                                children: "Min konto"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("span", {
                                className: "-mb-[2px] pl-1 text-xs",
                                children: [
                                    "(",
                                    (0, $bcbvQ.default).currentCompany,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5koBm.default), {
                                className: "w-6 h-6 -my-2 -me-2"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6e7IR.PopoverContent), {
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("ul", {
                    className: "px-0 mb-0 text-sm",
                    onClick: ()=>{
                        buttonRef.current?.focus();
                        setShow(false);
                    },
                    onKeyDown: (e)=>{
                        if (e.key === "Escape") {
                            buttonRef.current?.focus();
                            setShow(false);
                        }
                    },
                    children: [
                        showSwitchCompany && /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
                                className: "flex w-full",
                                type: "button",
                                onClick: activateSwitchCompany,
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                    className: listItemClasses,
                                    children: "Bytt firma"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "border-t border-b border-ink-border-subtle",
                            children: menuItems.map((menuItem)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                                        to: menuItem.link,
                                        className: "hover:no-underline",
                                        onClick: ()=>(0, $6fuyt.sendInternalLinkClick)(menuItem.link, "User menu", (0, $3oCZd.getNotificationsTrackingText)(menuItem.name, notificationsCount, newPromotionArticlesCount)),
                                        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                            className: (0, $izjX7.cn)(listItemClasses, {
                                                "bg-surface-default-hover": menuItem.isActive
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                                    children: menuItem.name
                                                }),
                                                /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                                    className: "ml-1",
                                                    children: menuItem.name === "Varslinger" && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ldyR.default), {
                                                        count: notificationsCount
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                                    className: "ml-1",
                                                    children: menuItem.name === "Kampanjer" && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ldyR.default), {
                                                        count: newPromotionArticlesCount
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, menuItem.name))
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
                                className: "flex w-full",
                                type: "button",
                                onClick: logoutAndRedirect,
                                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    className: listItemClasses,
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f916b915668dfb40$export$2e2bcd8739ae039), {
                                            className: "ml-[-2.4px] h-[24px] w-[24px]"
                                        }),
                                        "Logg ut"
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $a8af60e56ef5c38a$export$2e2bcd8739ae039 = (0, $gBcml.observer)($a8af60e56ef5c38a$var$UserMenu);


const $c6e294f0a7ba307f$var$className = (0, $izjX7.cn)([
    "bg-base-0",
    "w-full",
    "h-[75px]"
]);
const $c6e294f0a7ba307f$var$DesktopSearchBar = ()=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: $c6e294f0a7ba307f$var$className,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                className: $c6e294f0a7ba307f$var$className,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "mr-auto flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                                to: "/",
                                "data-testid": "header-logo",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dWcIP.default), {
                                    placement: "searchbar"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "ml-12 mr-4 min-w-fit lg:min-w-[--search-input-min-width]",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3ae7689da384cdf1$export$2e2bcd8739ae039), {})
                            }),
                            (0, $a2SqC.default).accessLevel === 2 && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: "font-bold text-error-600",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a4d728f8f69d980e$export$2e2bcd8739ae039), {}),
                                    " Du har n\xe5 KS-tilgang. Last p\xe5 nytt (F5) for \xe5 avslutte."
                                ]
                            }),
                            (0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $71ea9ab48e165d13$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    (0, $bcbvQ.default).isLoggedIn() ? /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $728e657274d71764$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "pl-1 pr-2",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a8af60e56ef5c38a$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2d294969301bc389$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "pl-2 pr-4",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b6dd253ba0bf40f5$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f82aabd82d0f9e63$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
var $c6e294f0a7ba307f$export$2e2bcd8739ae039 = (0, $gBcml.observer)($c6e294f0a7ba307f$var$DesktopSearchBar);


const $06cfcff520480a38$var$DesktopHeader = ()=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $c6e294f0a7ba307f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1e6588ced94d5ff0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $0334f5711cbbecb9$export$2e2bcd8739ae039), {})
        ]
    });
var $06cfcff520480a38$export$2e2bcd8739ae039 = (0, $gBcml.observer)($06cfcff520480a38$var$DesktopHeader);



var $7YWoO = parcelRequire("7YWoO");

var $ljb3n = parcelRequire("ljb3n");
var $b3J4G = parcelRequire("b3J4G");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $4udGV = parcelRequire("4udGV");

var $kUJJo = parcelRequire("kUJJo");

var $lKrOo = parcelRequire("lKrOo");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");
const $48e8d530d3831c9a$var$IconIndicator = (0, $gBcml.observer)(({ target: target, progress: progress })=>{
    if (progress === target) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b3J4G.default), {
        className: "size-5 animate-spin flex-shrink-0"
    });
    if (progress > target) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ljb3n.default), {
        className: "size-5 text-ink-success flex-shrink-0"
    });
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "size-5 flex-shrink-0",
        children: "\xa0"
    });
});
const $48e8d530d3831c9a$var$ProgressLine = (0, $gBcml.observer)(({ step: step, label: label, progress: progress })=>{
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex items-center gap-1",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)($48e8d530d3831c9a$var$IconIndicator, {
                target: step,
                progress: progress
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "break-words",
                children: label
            })
        ]
    });
});
const $48e8d530d3831c9a$var$LoginProgress = ()=>{
    let assortmentText = "Henter deres produkter og priser";
    if (!(0, $bEEBX.default)((0, $9Vhxl.default).getCurrentDelivery()) && !(0, $bEEBX.default)((0, $76PCP.default).orderType)) {
        assortmentText += " for ";
        assortmentText += (0, $4udGV.formatDate)((0, $9Vhxl.default).getCurrentDelivery()?.date, true);
    }
    let progress = 0;
    switch((0, $lKrOo.default).currentState){
        case "VERIFY_SESSION":
            progress = 1;
            break;
        case "LOGGING_IN":
            progress = 2;
            break;
        case "COMPANY_SELECTED":
            progress = 2;
            break;
        case "FEATURES_LOADING":
            progress = 3;
            break;
        case "DELIVERY_DATES_LOADING":
            progress = 4;
            break;
        case "ASSORTMENT_LOADING":
            progress = 4;
            break;
        case "NOTIFICATIONS_LOADING":
            progress = 5;
            break;
    }
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $kUJJo.default), {
        name: "Innloggingsfremdrift",
        isOpen: progress !== 0,
        title: "Gj\xf8r klar butikken...",
        className: "space-y-2",
        size: "lg",
        showCloseButton: false,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)($48e8d530d3831c9a$var$ProgressLine, {
                step: 1,
                progress: progress,
                label: "Verifiserer innlogging"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($48e8d530d3831c9a$var$ProgressLine, {
                step: 2,
                progress: progress,
                label: "Henter info om kundeforholdet"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($48e8d530d3831c9a$var$ProgressLine, {
                step: 3,
                progress: progress,
                label: "Skrur p\xe5 korrekte ordretyper"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($48e8d530d3831c9a$var$ProgressLine, {
                step: 4,
                progress: progress,
                label: assortmentText
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)($48e8d530d3831c9a$var$ProgressLine, {
                step: 5,
                progress: progress,
                label: "Henter eventuelle varslinger"
            })
        ]
    });
};
var $48e8d530d3831c9a$export$2e2bcd8739ae039 = (0, $gBcml.observer)($48e8d530d3831c9a$var$LoginProgress);



var $7YWoO = parcelRequire("7YWoO");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");


var $7YWoO = parcelRequire("7YWoO");

var $jOOuf = parcelRequire("jOOuf");

var $izjX7 = parcelRequire("izjX7");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");






var $bcbvQ = parcelRequire("bcbvQ");


var $7YWoO = parcelRequire("7YWoO");

var $a4r3l = parcelRequire("a4r3l");
var $doGx2 = parcelRequire("doGx2");
var $7YWoO = parcelRequire("7YWoO");
const $3f657eec5de8324a$var$SvgMenu = (props)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, props, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "M3 17.571v-1.928h18v1.928zm0-4.821v-1.929h18v1.929zm0-4.821V6h18v1.929z"
        })
    }));
var $3f657eec5de8324a$export$2e2bcd8739ae039 = $3f657eec5de8324a$var$SvgMenu;



var $izjX7 = parcelRequire("izjX7");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");

var $8ldyR = parcelRequire("8ldyR");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");

var $eCExY = parcelRequire("eCExY");

var $cLLe3 = parcelRequire("cLLe3");


var $9Vrue = parcelRequire("9Vrue");

var $dWcIP = parcelRequire("dWcIP");

var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $25aT1 = parcelRequire("25aT1");

var $jlTfJ = parcelRequire("jlTfJ");

var $2JqjA = parcelRequire("2JqjA");

var $3oCZd = parcelRequire("3oCZd");
const $360d6c0d22279987$var$hasChildren = (cat)=>!(0, $bEEBX.default)(cat.children) && cat.children.length > 0;
const $360d6c0d22279987$var$drillDownTree = (menuItems, path)=>{
    // Make sure this doesn't crash if called without data
    if (path.length === 0) return undefined;
    const [lookForKey, ...rest] = path;
    const foundItem = menuItems.find((mi)=>mi.url_key === lookForKey);
    // No more path to process, we found the item.
    if (rest.length === 0) return foundItem;
    if ((0, $bEEBX.default)(foundItem)) return undefined;
    return $360d6c0d22279987$var$drillDownTree(foundItem.children, rest);
};
const $360d6c0d22279987$var$itemCN = (0, $izjX7.cn)("flex cursor-pointer font-bold");
const $360d6c0d22279987$var$RootMenu = (0, $gBcml.observer)(()=>{
    const path = (0, $25aT1.default).mobile.path;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("ul", {
        className: "flex flex-col gap-3",
        children: [
            (0, $25aT1.default).categories.map((cat)=>/*#__PURE__*/ (0, $7YWoO.jsxs)("li", {
                    className: $360d6c0d22279987$var$itemCN,
                    onClick: ()=>path.push(cat.url_key),
                    onKeyDown: ()=>path.push(cat.url_key),
                    children: [
                        (0, $5OqMf.titleCase)(cat.name),
                        " ",
                        $360d6c0d22279987$var$hasChildren(cat) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $doGx2.default), {
                            className: "mr-4"
                        })
                    ]
                }, cat.id)),
            (0, $jlTfJ.default).mainMenuItems.map((menuItem)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                    className: $360d6c0d22279987$var$itemCN,
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                        to: menuItem.url,
                        onClick: ()=>(0, $25aT1.default).showMenu(false),
                        children: menuItem.title
                    })
                }, menuItem.id))
        ]
    });
});
const $360d6c0d22279987$var$SubMenu = (0, $gBcml.observer)(()=>{
    const path = (0, $25aT1.default).mobile.path;
    const selectedItem = $360d6c0d22279987$var$drillDownTree((0, $25aT1.default).categories, path);
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    const handleClick = (cat)=>{
        if (!$360d6c0d22279987$var$hasChildren(cat)) {
            (0, $25aT1.default).showMenu(false);
            redirectTo(cat.fullUrl);
        } else path.push(cat.url_key);
    };
    const goBack = ()=>{
        (0, $25aT1.default).mobile.path.pop();
    };
    if ((0, $bEEBX.default)(selectedItem)) return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        children: "Det oppsto den feil under lasting av kategoriene."
    });
    const visibleItems = selectedItem.children.filter((c)=>c.visible);
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("h2", {
                className: "mb-4 flex cursor-pointer items-center",
                onClick: goBack,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a4r3l.default), {
                        className: "mr-4"
                    }),
                    " ",
                    (0, $5OqMf.titleCase)(selectedItem.name)
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
                className: "cursor-pointer underline",
                onClick: ()=>(0, $25aT1.default).showMenu(false),
                to: `/${path.join("/")}.html`,
                children: [
                    "Se alle produkter i ",
                    (0, $5OqMf.titleCase)(selectedItem.name)
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("ul", {
                className: "mt-4 flex flex-col gap-3",
                children: visibleItems.map((cat)=>/*#__PURE__*/ (0, $7YWoO.jsxs)("li", {
                        className: "flex cursor-pointer items-center justify-between font-bold",
                        onClick: ()=>handleClick(cat),
                        children: [
                            (0, $5OqMf.titleCase)(cat.name),
                            " ",
                            $360d6c0d22279987$var$hasChildren(cat) && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $doGx2.default), {})
                        ]
                    }, cat.id))
            })
        ]
    });
});
const $360d6c0d22279987$var$MobileCategories = ()=>{
    const [_, redirectTo] = (0, $8kt8E.useLocation)();
    const menuItems = (0, $eCExY.useMenuItems)();
    const showSwitchCompany = (0, $bcbvQ.default).companies && (0, $bcbvQ.default).companies.length > 1;
    const newPromotionArticlesCount = (0, $jlTfJ.default).getNewPromotionArticlesCount();
    const notificationsCount = (0, $2JqjA.default).notifications.data.length;
    if ((0, $25aT1.default).categories.length === 0) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {});
    const hideMenu = ()=>{
        (0, $25aT1.default).showMenu(false);
    };
    const activateSwitchCompany = (e)=>{
        (0, $lKrOo.default).transitionTo("COMPANY_SELECTION");
        e.preventDefault();
    };
    const mobileMenuHeader = ()=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $dWcIP.default), {
            className: "ml-2",
            placement: "searchbar"
        });
    const menuBodyClassName = "m-2 flex min-w-[80vw] flex-col";
    const borderClassName = "border-b border-ink-border-subtle pb-4 mb-4";
    const logout = ()=>{
        if ((0, $bcbvQ.default).isPunchoutSession()) {
            (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
            window.location.replace("/");
        } else {
            redirectTo("/");
            (0, $lKrOo.default).transitionTo("NOT_LOGGED_IN");
        }
        hideMenu();
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                variant: "tertiary",
                icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3f657eec5de8324a$export$2e2bcd8739ae039), {}),
                onClick: ()=>(0, $25aT1.default).showMenu(true),
                trackingName: "Vis mobilmeny"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6f1c94b86aee40f6$export$2e2bcd8739ae039), {
                renderHeader: mobileMenuHeader,
                show: (0, $25aT1.default).mobile.visible,
                onHide: ()=>hideMenu(),
                children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: menuBodyClassName,
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: borderClassName,
                            children: (0, $25aT1.default).mobile.path.length === 0 ? /*#__PURE__*/ (0, $7YWoO.jsx)($360d6c0d22279987$var$RootMenu, {}) : /*#__PURE__*/ (0, $7YWoO.jsx)($360d6c0d22279987$var$SubMenu, {})
                        }),
                        (0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: borderClassName,
                            children: /*#__PURE__*/ (0, $7YWoO.jsxs)("ul", {
                                className: "flex flex-col gap-3",
                                children: [
                                    menuItems.map((menuItem)=>/*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                            onClick: hideMenu,
                                            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Link), {
                                                to: menuItem.link,
                                                className: (0, $izjX7.cn)("flex gap-1 items-center", {
                                                    underline: menuItem.isActive
                                                }),
                                                onClick: ()=>(0, $6fuyt.sendInternalLinkClick)(menuItem.link, "Mobile menu", (0, $3oCZd.getNotificationsTrackingText)(menuItem.name, notificationsCount, newPromotionArticlesCount)),
                                                children: [
                                                    /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                                        children: menuItem.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                                        children: menuItem.name === "Varslinger" && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ldyR.default), {
                                                            count: notificationsCount
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7YWoO.jsx)("span", {
                                                        children: menuItem.name === "Kampanjer" && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8ldyR.default), {
                                                            count: newPromotionArticlesCount
                                                        })
                                                    })
                                                ]
                                            })
                                        }, menuItem.name)),
                                    (0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
                                            type: "button",
                                            onClick: logout,
                                            "data-testid": "logout-button",
                                            children: "Logg ut"
                                        })
                                    })
                                ]
                            })
                        }),
                        showSwitchCompany && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: borderClassName,
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)("button", {
                                type: "button",
                                onClick: activateSwitchCompany,
                                children: "Bytt firma"
                            })
                        }),
                        (0, $bcbvQ.default).isLoggedIn() && /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                            className: "text-sm",
                            children: [
                                "Logget inn som",
                                /*#__PURE__*/ (0, $7YWoO.jsx)("br", {}),
                                (0, $bcbvQ.default).currentCompany,
                                " ",
                                (0, $bcbvQ.default).getCurrentCompany()?.name ?? ""
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $360d6c0d22279987$export$2e2bcd8739ae039 = (0, $gBcml.observer)($360d6c0d22279987$var$MobileCategories);



var $7YWoO = parcelRequire("7YWoO");

var $inCq0 = parcelRequire("inCq0");

var $bEEBX = parcelRequire("bEEBX");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $5OqMf = parcelRequire("5OqMf");

var $4udGV = parcelRequire("4udGV");

var $cLLe3 = parcelRequire("cLLe3");

var $6e7IR = parcelRequire("6e7IR");

var $9bzp5 = parcelRequire("9bzp5");

var $7dAjM = parcelRequire("7dAjM");

var $76PCP = parcelRequire("76PCP");

var $9Vhxl = parcelRequire("9Vhxl");
const $20f56bb5eedb5dbe$var$MobileDeliveryInfo = ()=>{
    const ref = (0, $dvPqk.useRef)(null);
    const [show, setShow] = (0, $dvPqk.useState)(false);
    const currentDelivery = (0, $9Vhxl.default).getCurrentDelivery();
    if ((0, $bEEBX.default)(currentDelivery)) return null;
    const dayLabel = (0, $5OqMf.translateDayLabel)((0, $76PCP.default).orderType);
    const renderDeliveryDateButton = (_dates, isPickerOpen, setPickerOpen)=>{
        return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
            className: "m-2",
            variant: "secondary",
            size: "regular",
            onClick: ()=>setPickerOpen(!isPickerOpen),
            children: "Endre leveringsdag"
        });
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6e7IR.Popover), {
        open: show,
        onOpenChange: setShow,
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6e7IR.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                    icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $inCq0.default), {}),
                    ref: ref,
                    variant: "tertiary",
                    size: "iconOnly",
                    onClick: ()=>setShow(!show),
                    trackingName: "Leveringsinfo"
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $6e7IR.PopoverContent), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "px-3 pt-3 w-[300px]",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7dAjM.default), {
                                margin: true,
                                label: "Bestillingsfrist",
                                value: (0, $4udGV.formatDateTime)(currentDelivery.deadline, true, true)
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7dAjM.default), {
                                margin: true,
                                label: dayLabel,
                                value: (0, $4udGV.formatDate)(currentDelivery.date, true, false, true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9bzp5.default), {
                        render: renderDeliveryDateButton,
                        inline: true
                    })
                ]
            })
        ]
    });
};
var $20f56bb5eedb5dbe$export$2e2bcd8739ae039 = (0, $gBcml.observer)($20f56bb5eedb5dbe$var$MobileDeliveryInfo);


const $7988263b27f3ee4a$var$className = (0, $izjX7.cn)([
    "bg-[--color-base-0]",
    "w-full"
]);
const $7988263b27f3ee4a$var$groupClassName = (0, $izjX7.cn)([
    "my-2",
    "w-full"
]);
const $7988263b27f3ee4a$var$BurgerMenuAndCart = ()=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: $7988263b27f3ee4a$var$className,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                align: "center",
                justify: "between",
                className: $7988263b27f3ee4a$var$groupClassName,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $360d6c0d22279987$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex items-center justify-end p-0",
                        children: [
                            (0, $bcbvQ.default).isLoggedIn() ? /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $71ea9ab48e165d13$export$2e2bcd8739ae039), {
                                        className: "mx-2"
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $728e657274d71764$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $20f56bb5eedb5dbe$export$2e2bcd8739ae039), {})
                                ]
                            }) : /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2d294969301bc389$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b6dd253ba0bf40f5$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "pl-4",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f82aabd82d0f9e63$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        })
    });
var $7988263b27f3ee4a$export$2e2bcd8739ae039 = (0, $gBcml.observer)($7988263b27f3ee4a$var$BurgerMenuAndCart);



var $7YWoO = parcelRequire("7YWoO");

var $jOOuf = parcelRequire("jOOuf");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $8kt8E = parcelRequire("8kt8E");


var $dWcIP = parcelRequire("dWcIP");

const $f9e9488f02b01671$var$MobileSearchBar = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "w-full bg-headerFooterBackground",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "flex items-center py-2",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Link), {
                            to: "/",
                            children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dWcIP.default), {
                                placement: "searchbarMobile"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "flex-auto py-2",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3ae7689da384cdf1$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
};
var $f9e9488f02b01671$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f9e9488f02b01671$var$MobileSearchBar);


const $34ea561e0cfcc68a$var$MobileHeader = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $7988263b27f3ee4a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f9e9488f02b01671$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $e7d8001c74cd4e48$export$2e2bcd8739ae039), {})
        ]
    });
};
var $34ea561e0cfcc68a$export$2e2bcd8739ae039 = (0, $gBcml.observer)($34ea561e0cfcc68a$var$MobileHeader);



var $7YWoO = parcelRequire("7YWoO");

var $5rKSh = parcelRequire("5rKSh");
var $9NHzr = parcelRequire("9NHzr");

var $eYDe5 = parcelRequire("eYDe5");
var $ezbi8 = parcelRequire("ezbi8");
var $ghmTa = parcelRequire("ghmTa");
var $cGjF4 = parcelRequire("cGjF4");
var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $6sMuH = parcelRequire("6sMuH");

var $cGjF4 = parcelRequire("cGjF4");

var $4rjCr = parcelRequire("4rjCr");

var $7YWoO = parcelRequire("7YWoO");
const $f664ea2efee063a2$export$2e2bcd8739ae039 = (t)=>(0, $7YWoO.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, t, {
        children: (0, $7YWoO.jsx)("path", {
            fill: "inherit",
            d: "m14 17-5-5 5-5 1.063 1.063L11.125 12l3.938 3.938z"
        })
    }));



var $Vdcm1 = parcelRequire("Vdcm1");
const $0c39b0cc23227f0c$var$c = (d, x, r = !1)=>typeof d > "u" ? "" : typeof d == "string" && r ? d : typeof d == "object" ? d[x] ?? "" : "";
function $0c39b0cc23227f0c$export$144901db2ea8e967({ ariaLabel: d = "Carousel", children: x, className: r, header: g, href: b, linkTitle: C, numVisible: l = {
    default: 1.2,
    sm: 2.2,
    md: 3,
    lg: 3,
    xl: 3
}, size: I = "full", headingLevel: S = "h2" }) {
    const [n, u] = (0, $dvPqk.useState)(0), [T, z] = (0, $dvPqk.useState)(!1), [A, B] = (0, $dvPqk.useState)(!0), [t, v] = (0, $dvPqk.useState)(l.default), p = (0, $dvPqk.useRef)(null), N = (0, $dvPqk.Children).toArray(x), s = N.length, W = ((e)=>{
        const o = {
            sm: "w-full sm:w-[400px]",
            md: "w-full sm:w-[600px] md:w-[800px]",
            lg: "w-full sm:w-[800px] md:w-[1000px]",
            xl: "w-full sm:w-[1000px] md:w-[1200px]",
            full: "w-full"
        };
        return typeof e == "number" ? `w-full sm:w-[${e}px]` : o[e] || o.full;
    })(I), k = (0, $dvPqk.useCallback)(()=>{
        const e = window.innerWidth;
        e < 640 && l.default ? v(l.default) : e < 768 && l.sm ? v(l.sm) : e < 1024 && l.md ? v(l.md) : e < 1280 && l.lg ? v(l.lg) : l.xl ? v(l.xl) : v(l.default);
        const o = s > t;
        z(o && n > 0), B(o && n < s - t);
    }, [
        l,
        s,
        t,
        n
    ]);
    (0, $dvPqk.useEffect)(()=>(k(), window.addEventListener("resize", k), ()=>{
            window.removeEventListener("resize", k);
        }), [
        k
    ]);
    const m = (0, $dvPqk.useCallback)((e)=>{
        if (p.current) {
            const o = p.current, h = o.clientWidth / t;
            o.scrollTo({
                left: e * h,
                behavior: "smooth"
            }), u(e);
        }
    }, [
        t
    ]), P = (0, $dvPqk.useCallback)(()=>{
        const e = Math.max(n - t, 0);
        m(e);
    }, [
        n,
        m,
        t
    ]), R = (0, $dvPqk.useCallback)(()=>{
        const e = Math.min(n + t, s - t);
        m(e);
    }, [
        n,
        s,
        t,
        m
    ]), L = (0, $dvPqk.useCallback)(()=>{
        if (p.current) {
            const e = p.current, o = e.clientWidth / t, h = e.scrollWidth - e.clientWidth, f = e.scrollLeft;
            if (Math.abs(h - f) < 1) {
                const w = Math.ceil(s - t);
                u(w);
            } else {
                const w = Math.round(f / o);
                w !== n && u(w);
            }
        }
    }, [
        n,
        t,
        s
    ]);
    (0, $dvPqk.useEffect)(()=>{
        const e = p.current;
        if (e) {
            let o, h, f;
            const w = ()=>{
                clearTimeout(o), o = window.setTimeout(()=>{
                    clearTimeout(h), window.innerWidth >= 768 && (h = window.setTimeout(()=>{
                        m(n);
                    }, 150)), clearTimeout(f), f = window.setTimeout(()=>{
                        z(n > 0), B(n < s - t);
                    }, 50);
                }, 100);
            };
            return e.addEventListener("scroll", L), e.addEventListener("scroll", w), ()=>{
                e.removeEventListener("scroll", L), e.removeEventListener("scroll", w), clearTimeout(o), clearTimeout(f);
            };
        }
    }, [
        n,
        L,
        m,
        t,
        s
    ]);
    const D = {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::WebkitScrollbar": {
            display: "none"
        }
    }, O = S;
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("flex w-full h-full relative flex-col items-center min-w-96", $0c39b0cc23227f0c$var$c(r, "container", !0)),
        children: [
            g ? /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: (0, $6sMuH.cn)("flex justify-between items-center pl-4 mr-auto", W, $0c39b0cc23227f0c$var$c(r, "header")),
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)(O, {
                        className: "text-xl font-bold text-gray-900",
                        children: g
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                        href: b,
                        children: C
                    })
                ]
            }) : null,
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                "aria-label": d,
                "aria-live": "polite",
                className: (0, $6sMuH.cn)("flex relative h-full flex-row items-center mr-auto", W, $0c39b0cc23227f0c$var$c(r, "navigation")),
                role: "region",
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                        "aria-label": "Previous",
                        className: (0, $6sMuH.cn)("absolute hidden -left-16 md:block z-10", T ? "" : "invisible", $0c39b0cc23227f0c$var$c(r, "prevButton")),
                        disabled: !T,
                        icon: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $f664ea2efee063a2$export$2e2bcd8739ae039), {}),
                        onClick: P,
                        size: "iconOnly",
                        variant: "secondary"
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        "aria-live": "polite",
                        className: (0, $6sMuH.cn)("overflow-x-auto flex relative md:snap-x md:snap-mandatory scroll-smooth", W, $0c39b0cc23227f0c$var$c(r, "content")),
                        ref: p,
                        role: "list",
                        style: D,
                        children: N.map((e, o)=>{
                            const f = (0, $dvPqk.isValidElement)(e) && e.key ? `${e.key}-${o}` : `carousel-item-${o}`;
                            return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                                className: "flex-shrink-0 flex justify-center md:snap-center",
                                role: "listitem",
                                style: {
                                    width: `calc(100% / ${t})`
                                },
                                children: e
                            }, f);
                        })
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                        "aria-label": "Next",
                        className: (0, $6sMuH.cn)("absolute -right-16 hidden md:block", A ? "" : "invisible", $0c39b0cc23227f0c$var$c(r, "nextButton")),
                        disabled: !A,
                        icon: /* @__PURE__ */ (0, $7YWoO.jsx)((0, $Vdcm1.default), {}),
                        onClick: R,
                        size: "iconOnly"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)($0c39b0cc23227f0c$var$Q, {
                className: $0c39b0cc23227f0c$var$c(r, "dots"),
                currentIndex: n,
                dotActiveClassName: $0c39b0cc23227f0c$var$c(r, "dotActive"),
                dotClassName: $0c39b0cc23227f0c$var$c(r, "dot"),
                dotInactiveClassName: $0c39b0cc23227f0c$var$c(r, "dotInactive"),
                onDotClick: m,
                totalItems: s,
                visibleItems: t
            })
        ]
    });
}
$0c39b0cc23227f0c$export$144901db2ea8e967.displayName = "Carousel";
function $0c39b0cc23227f0c$var$Q({ className: d, dotClassName: x, dotActiveClassName: r, dotInactiveClassName: g, totalItems: b, visibleItems: C, currentIndex: l, onDotClick: I }) {
    const S = Math.max(1, b - Math.floor(C) + 1);
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)("flex justify-center gap-2 mt-4 md:hidden", d),
        children: Array.from({
            length: S
        }).map((n, u)=>{
            const T = u === S - 1 ? l >= b - C : l === u;
            return /* @__PURE__ */ (0, $7YWoO.jsx)("button", {
                "aria-label": `Go to slide ${u + 1}`,
                className: (0, $6sMuH.cn)("w-4 h-4 rounded-full transition-colors", x, T ? (0, $6sMuH.cn)("bg-surface-action", r) : (0, $6sMuH.cn)("bg-surface-default-hover", g)),
                onClick: ()=>{
                    I(u);
                },
                type: "button"
            }, `dot-${u}`);
        })
    });
}


var $7YWoO = parcelRequire("7YWoO");
function $28beb29f2d26ddf6$export$42c20acb2971398c({ children: e, className: l = "" }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: `h-full w-full px-2 py-4 ${l}`,
        children: e
    });
}
$28beb29f2d26ddf6$export$42c20acb2971398c.displayName = "CarouselItem";


var $9AGLN = parcelRequire("9AGLN");
var $6tjXJ = parcelRequire("6tjXJ");
var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $hGi4c = parcelRequire("hGi4c");
const $0855e751f2dfbb2b$var$i = (t, s, o = !1)=>typeof t > "u" ? "" : typeof t == "string" && o ? t : typeof t == "object" ? t[s] ?? "" : "", $0855e751f2dfbb2b$export$f631859cab12b342 = (0, $dvPqk.forwardRef)(({ title: t, description: s, image: o, imageAlt: b, variant: y = "white", hasShadow: w = !0, href: d = "", to: f = "", className: r, tags: u, defaultTagVariant: k = "base", defaultTagProps: x, forceVertical: a = !1, aspectRatio: h = "", headingLevel: j = "h2", as: c = "a", ...C }, $)=>{
    const E = {
        white: "bg-surface-default text-ink-default",
        transparent: "bg-base-transparent",
        inverted: "bg-button-primary-bg text-button-primary-text"
    }[y], T = ()=>!u || u.length === 0 ? null : /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
            className: (0, $6sMuH.cn)("flex gap-x-2", $0855e751f2dfbb2b$var$i(r, "tags")),
            children: u.map((n, m)=>{
                if (!n) return null;
                if ((0, $dvPqk.isValidElement)(n)) return (0, $dvPqk.cloneElement)(n, {
                    key: `tag-${m}`
                });
                if (typeof n == "string") return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
                    textColor: "var(--color-ink-brand-default)",
                    variant: k,
                    ...x || {},
                    children: n
                }, `tag-${m}`);
                const { text: z, ...A } = n;
                return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
                    textColor: "var(--color-ink-brand-default)",
                    ...x || {},
                    ...A,
                    children: z
                }, `tag-${m}`);
            })
        }), q = j;
    let p = {};
    return c === "a" && d ? p = {
        href: d
    } : c !== "a" && f && (p = {
        to: f
    }), /* @__PURE__ */ (0, $7YWoO.jsx)(c, {
        ref: $,
        ...p,
        className: (0, $6sMuH.cn)("@container rounded-card-lg overflow-clip h-full w-full group inline-block no-underline", w && "drop-shadow-md", E, $0855e751f2dfbb2b$var$i(r, "container", !0)),
        ...C,
        children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
            className: (0, $6sMuH.cn)("flex h-full", a ? "flex-col" : "@sm:flex-col"),
            children: [
                /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                    className: (0, $6sMuH.cn)("flex-shrink-0", a ? "w-full" : [
                        "w-32",
                        "@sm:w-full"
                    ], "relative", a ? "aspect-[5/4]" : [
                        "aspect-square",
                        "@sm:aspect-video"
                    ], "overflow-hidden", $0855e751f2dfbb2b$var$i(r, "image")),
                    style: h ? {
                        aspectRatio: h
                    } : void 0,
                    children: typeof o == "string" ? /* @__PURE__ */ (0, $7YWoO.jsx)("img", {
                        alt: b,
                        className: "size-full absolute inset-0 object-cover group-hover:scale-105 duration-300",
                        src: o
                    }) : /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "w-full h-full",
                        children: o
                    })
                }),
                /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                    className: (0, $6sMuH.cn)("flex flex-col gap-2 p-3 flex-1", a ? "px-4 pt-4 pb-5" : [
                        "@sm:px-4",
                        "@sm:pt-4",
                        "@sm:pb-5"
                    ], "@xl:items-start @xl:justify-center", $0855e751f2dfbb2b$var$i(r, "content")),
                    children: [
                        T(),
                        t ? /* @__PURE__ */ (0, $7YWoO.jsx)(q, {
                            className: (0, $6sMuH.cn)("text-lg @sm:text-2xl text-ink-brand-default leading-tight m-0 line-clamp-2 @xl:line-clamp-3 font-medium", (d || f) && "group-hover:underline underline-offset-4", $0855e751f2dfbb2b$var$i(r, "title")),
                            children: t
                        }) : null,
                        s ? /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                            className: (0, $6sMuH.cn)("hidden text-lg @sm:line-clamp-2", $0855e751f2dfbb2b$var$i(r, "description")),
                            children: s
                        }) : null
                    ]
                })
            ]
        })
    });
});
$0855e751f2dfbb2b$export$f631859cab12b342.displayName = "ContentCard";


var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");
const $309997bcbd683695$var$g = {
    row: "flex-row",
    column: "flex-col",
    "row-reverse": "flex-row-reverse",
    "column-reverse": "flex-col-reverse"
}, $309997bcbd683695$var$f = {
    start: "items-start",
    center: "items-center",
    end: "items-end",
    between: "items-between",
    around: "items-around",
    evenly: "items-evenly"
}, $309997bcbd683695$var$i = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
    between: "justify-between",
    around: "justify-around",
    evenly: "justify-evenly"
}, $309997bcbd683695$var$w = {
    nowrap: "flex-nowrap",
    wrap: "flex-wrap",
    "wrap-reverse": "flex-wrap-reverse"
}, $309997bcbd683695$var$S = {
    0: "gap-0",
    1: "gap-1",
    2: "gap-2",
    3: "gap-3",
    4: "gap-4",
    5: "gap-5",
    6: "gap-6",
    8: "gap-8",
    10: "gap-10",
    12: "gap-12",
    16: "gap-16",
    20: "gap-20",
    24: "gap-24",
    32: "gap-32",
    40: "gap-40",
    48: "gap-48",
    56: "gap-56",
    64: "gap-64"
};
function $309997bcbd683695$export$f51f4c4ede09e011({ children: e, direction: r = "row", align: t = "center", justify: a = "center", wrap: n = "nowrap", className: s = "", gap: p = 4, ...o }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
        className: (0, $6sMuH.cn)("flex", $309997bcbd683695$var$S[p], $309997bcbd683695$var$g[r], $309997bcbd683695$var$f[t], $309997bcbd683695$var$i[a], $309997bcbd683695$var$w[n], s),
        ...o,
        children: e
    });
}
$309997bcbd683695$export$f51f4c4ede09e011.displayName = "Flex";


var $lFdyG = parcelRequire("lFdyG");
var $eVBn0 = parcelRequire("eVBn0");
var $3lzdj = parcelRequire("3lzdj");
var $3ofZR = parcelRequire("3ofZR");
var $jOOuf = parcelRequire("jOOuf");
var $3SASj = parcelRequire("3SASj");
var $1A6xS = parcelRequire("1A6xS");
var $4rjCr = parcelRequire("4rjCr");
var $34rNI = parcelRequire("34rNI");
var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");
function $b7d2dabf5cc2b3fa$export$1bc430945f060dd1({ imageUrl: o = "/api/placeholder/1200/800", children: c, title: i, description: d, speed: r = 0.5, className: f, headingLevel: u = "h2" }) {
    const [a, s] = (0, $dvPqk.useState)(0), t = (0, $dvPqk.useRef)(null);
    (0, $dvPqk.useEffect)(()=>{
        const l = ()=>{
            if (!t.current) return;
            s(window.scrollY);
            const m = -t.current.getBoundingClientRect().top;
            s(m * r);
        };
        return window.addEventListener("scroll", l), l(), ()=>{
            window.removeEventListener("scroll", l);
        };
    }, [
        r,
        a
    ]);
    const x = u;
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("relative overflow-hidden h-[500px] w-full", f),
        ref: t,
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: "absolute inset-0 w-full h-full",
                style: {
                    transform: `translateY(${a}px)`
                },
                children: /* @__PURE__ */ (0, $7YWoO.jsx)("img", {
                    alt: "Parallax background",
                    className: "w-full h-[120%] object-cover",
                    src: o
                })
            }),
            /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center transition-opacity duration-300",
                children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                    className: "relative z-10 text-white px-4 text-center",
                    children: [
                        /* @__PURE__ */ (0, $7YWoO.jsx)(x, {
                            className: "text-4xl font-bold mb-4 text-base-0 text-shadow-default",
                            children: i
                        }),
                        /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                            className: "text-xl text-base-0 text-shadow-default",
                            children: d
                        }),
                        c
                    ]
                })
            })
        ]
    });
}
$b7d2dabf5cc2b3fa$export$1bc430945f060dd1.displayName = "Parallax";


var $7YWoO = parcelRequire("7YWoO");

var $6sMuH = parcelRequire("6sMuH");

var $dvPqk = parcelRequire("dvPqk");

var $hGi4c = parcelRequire("hGi4c");

var $7YWoO = parcelRequire("7YWoO");
const $2f986b181defeaa2$export$2e2bcd8739ae039 = (l)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, l, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#A8DA3D",
                d: "m17.115 10.684-6.432 6.43H12a5.115 5.115 0 0 0 5.114-5.113zM12 6.886a5.114 5.114 0 0 0-5.115 5.11v1.3219999999999998l6.433-6.432z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#005532",
                d: "M12 17.115h-1.317l6.432-6.431V12a5.115 5.115 0 0 1-5.114 5.114M6.886 12a5.115 5.115 0 0 1 5.116-5.113h1.316l-6.432 6.432v-1.319M3 21h9a9 9 0 0 0 9-9V3h-9a9 9 0 0 0-9 8.996z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "m9.806 15.292.013-.014c.184-.183.168-.402-.288-.859-.438-.438-.645-.44-.82-.264l-.022.02a5 5 0 0 0-.34-.34l.097-.097c.628-.63 1.145-.596 1.763.008.651.634.624 1.216.066 1.774 0 0-.029.024-.123.118a7 7 0 0 0-.346-.347m-1.628-1.287c.43.44 1.368 1.374 1.803 1.803l-.426.427c-.155.155-.281.292-.42.436a11 11 0 0 0-.352-.35l.03-.03c.099-.1.104-.199-.021-.34-.126-.143-.646-.662-.769-.769s-.22-.126-.317-.029l-.044.045c-.079-.084-.26-.265-.343-.344.044-.04.275-.264.432-.422zM11.669 12.914c-.091.093-.2.184-.325.216.046-.092.024-.171-.062-.257-.092-.092-.17-.119-.246-.069-.15-.133-.203-.358.02-.582.242-.24.46-.197.634-.02.231.23.22.471-.021.712m-.925-.448c-.029.255.158.477.494.813.277.278.411.296.508.2.075-.076.079-.19-.068-.342.118-.107.366-.356.477-.476.327.3.338.725-.116 1.18-.461.46-.867.521-1.326.062-.553-.553-.435-1.033.031-1.437M12.622 11.376c-.35-.244-.247-.545-.027-.766.29-.29.595-.264 1.095.236.501.501.523.8.231 1.09-.22.221-.52.323-.765-.025.172-.137.152-.215-.082-.449-.19-.191-.303-.257-.453-.086m-.323 1.098a32 32 0 0 0-.862-.862c-.079-.069-.174-.137-.241-.069l-.024.024a8 8 0 0 0-.284-.283c.121-.115.6-.6.695-.71l1.586 1.586a.5.5 0 0 0 .06.41c-.11.101-.335.326-.435.437-.125-.153-.315-.342-.495-.533M13.46 9.551c-.189.19-.414.19-.61-.008-.197-.197-.192-.417-.004-.606.192-.19.415-.193.609 0 .19.192.197.423.006.614m1.279.687c.092.082.155.092.233.013l.014-.013c.065.07.217.223.288.288 0 0-.272.263-.422.412-.15.15-.412.422-.412.422a9 9 0 0 0-.288-.288l.01-.01c.082-.082.066-.14-.015-.231a9 9 0 0 0-.451-.456c-.094-.085-.152-.08-.215-.016l-.02.021a7 7 0 0 0-.282-.28c.181-.182.548-.559.708-.72.184.2.76.776.852.858M16.186 8.382c.498.498.39.962-.079 1.39.079-.231-.245-.556-.5-.81-.291-.291-.38-.228-.454-.171-.248-.165-.23-.435-.057-.608.298-.299.702-.189 1.09.2m-1.463 1.41c-.498-.498-.39-.961.079-1.389-.08.23.247.556.501.81.29.291.38.228.454.17.248.165.23.435.057.609-.299.298-.702.188-1.091-.2"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#C4E570",
                d: "M10.726 19.832a.4.4 0 0 0 .213.054.35.35 0 0 0 .197-.049.3.3 0 0 0 .116-.17q.04-.12.04-.324 0-.075-.005-.148a.6.6 0 0 0-.027-.144zm.426-.967a.34.34 0 0 0-.228-.07q-.201 0-.279.146a.86.86 0 0 0-.076.393q0 .202.043.328zm.327-.077q.17.196.17.543 0 .357-.126.51a.7.7 0 0 1-.26.215.8.8 0 0 1-.316.058.8.8 0 0 1-.36-.076l-.18.263-.163-.1.188-.275q-.213-.219-.213-.586 0-.363.19-.572.191-.207.523-.207a.76.76 0 0 1 .37.084l.172-.253.164.107-.182.264zM13.23 19.958l-.64-.702.111.78-.318.045-.215-1.495.318-.046.098.678.402-.75.39-.056-.455.772.718.716zM15.023 18.95a1 1 0 0 0-.086-.313 2 2 0 0 0-.092-.194.8.8 0 0 0-.143-.165q-.102-.097-.313-.01-.19.078-.204.242t.08.393q.105.254.23.35.128.1.322.02a.35.35 0 0 0 .164-.121.3.3 0 0 0 .042-.201m-.656.551q-.282-.117-.423-.46-.14-.337-.041-.6.097-.266.405-.392.324-.132.573-.007.252.126.383.447.133.324.076.518a.7.7 0 0 1-.159.299.8.8 0 0 1-.27.174q-.299.124-.544.021M16.947 18.27l-.712.5-.869-1.235.256-.18.721 1.027.506-.356zM17.816 16.818a1 1 0 0 0-.214-.248 2 2 0 0 0-.165-.134.8.8 0 0 0-.2-.088q-.135-.043-.288.126-.137.151-.08.305.06.155.241.32.203.184.36.22.157.033.298-.122a.35.35 0 0 0 .096-.18.32.32 0 0 0-.048-.2m-.357.778q-.306.015-.58-.234-.268-.243-.295-.525-.025-.28.199-.527.234-.26.515-.253.28.008.537.24.26.235.29.435a.7.7 0 0 1-.014.338.8.8 0 0 1-.169.274q-.218.24-.483.252M19.17 15.565a.9.9 0 0 1-.2.26.672.672 0 0 1-.539.15.9.9 0 0 1-.29-.103q-.381-.202-.422-.498a.853.853 0 0 1 .477-.912l.09.232a1 1 0 0 0-.155.11.5.5 0 0 0-.114.15q-.127.24-.004.38.124.14.31.239.302.16.444.084a.5.5 0 0 0 .27-.404l-.303-.161-.126.236-.24-.076.299-.563.64.341a1.2 1.2 0 0 1-.136.535M19.677 14.322l-1.444-.443.095-.31 1.444.442zM20.017 12.35a.8.8 0 0 1 .044.197q.012.11-.002.223a1.2 1.2 0 0 1-.197.538l-.227-.14q.074-.115.116-.22a.9.9 0 0 0 .056-.225.5.5 0 0 0-.02-.217.15.15 0 0 0-.134-.11.16.16 0 0 0-.128.04.5.5 0 0 0-.1.174l-.074.195q-.08.215-.211.278a.46.46 0 0 1-.254.05.41.41 0 0 1-.313-.202.67.67 0 0 1-.08-.437q.018-.152.075-.296a.8.8 0 0 1 .142-.24l.201.172a.8.8 0 0 0-.162.385.33.33 0 0 0 .024.187.14.14 0 0 0 .116.084.13.13 0 0 0 .109-.032.4.4 0 0 0 .084-.152l.071-.195a.634.634 0 0 1 .223-.315q.092-.071.258-.053.134.015.233.096a.5.5 0 0 1 .15.215M20.09 10.54l-.786.533h.788v.322H18.58v-.322h.686l-.686-.506v-.393l.7.56.81-.609zM5.442 13.28a.4.4 0 0 0 .055-.212.36.36 0 0 0-.049-.198.3.3 0 0 0-.168-.117 1 1 0 0 0-.324-.041q-.076 0-.148.003a.6.6 0 0 0-.145.025zm-.965-.433a.34.34 0 0 0-.073.227q-.001.202.145.28a.85.85 0 0 0 .393.08q.202.001.328-.04zm-.075-.327q.197-.17.545-.167.356.003.51.13a.7.7 0 0 1 .211.262q.057.134.056.316a.8.8 0 0 1-.079.36l.263.181-.1.162-.276-.19q-.22.213-.587.21-.363-.003-.57-.195-.206-.191-.204-.524a.75.75 0 0 1 .087-.369l-.252-.173.108-.165.263.185zM5.813 11.03l-.854.416.78.112-.046.318-1.495-.215.046-.318.678.098-.607-.599.056-.388.613.654.89-.488zM5.92 9.34a1 1 0 0 0-.285-.16 2 2 0 0 0-.202-.07.8.8 0 0 0-.218-.016q-.141.006-.227.217-.078.188.029.314a.9.9 0 0 0 .336.22q.253.103.412.082.16-.02.239-.215a.35.35 0 0 0 .029-.202.3.3 0 0 0-.113-.17m-.07.853q-.283.118-.625-.022-.336-.14-.456-.394-.12-.255.006-.563.134-.323.399-.413t.586.042q.324.134.422.31.098.177.102.323a.8.8 0 0 1-.066.314q-.124.3-.369.403M7.193 8.085l-.5.712-1.236-.868.18-.256 1.026.721.355-.505zM7.811 6.887a1 1 0 0 0-.188-.267 2 2 0 0 0-.152-.15.8.8 0 0 0-.192-.107q-.129-.055-.297.098-.152.137-.11.297.045.159.21.342.184.201.337.251.152.05.308-.092a.35.35 0 0 0 .113-.17.3.3 0 0 0-.029-.202m-.43.74q-.305-.014-.554-.288-.244-.27-.244-.55.002-.283.248-.507.26-.235.537-.202.279.035.512.29.236.26.248.461a.7.7 0 0 1-.047.335.8.8 0 0 1-.195.256q-.24.218-.505.205M9.286 6.443a.9.9 0 0 1-.31.103.678.678 0 0 1-.53-.177.9.9 0 0 1-.184-.247q-.204-.382-.072-.65a.86.86 0 0 1 .906-.49l-.054.245a1 1 0 0 0-.191.004.5.5 0 0 0-.178.06q-.24.128-.216.313t.123.371q.16.302.32.318a.5.5 0 0 0 .45-.183l-.161-.304-.236.125-.156-.197.562-.299.34.64a1.15 1.15 0 0 1-.413.368M10.199 6.038l-.444-1.444.31-.095.444 1.443zM11.838 5.65a.8.8 0 0 1-.182.09 1 1 0 0 1-.218.049q-.288.034-.569-.068l.085-.254q.128.045.24.062a.9.9 0 0 0 .232.003.5.5 0 0 0 .206-.068.15.15 0 0 0 .077-.156.16.16 0 0 0-.07-.116.44.44 0 0 0-.191-.057l-.207-.028q-.225-.028-.319-.141a.46.46 0 0 1-.105-.236.4.4 0 0 1 .123-.35.67.67 0 0 1 .408-.179q.151-.017.305.005.152.022.266.083l-.121.235a.8.8 0 0 0-.412-.07.33.33 0 0 0-.177.067.14.14 0 0 0-.055.133.13.13 0 0 0 .056.098.4.4 0 0 0 .167.047l.206.025q.103.014.184.043a.6.6 0 0 1 .174.102q.091.071.111.239a.45.45 0 0 1-.04.248.5.5 0 0 1-.174.195M13.452 5.699l-.534-.787V5.7h-.321V4.19h.321v.686l.506-.687h.393l-.56.7.608.81z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M19.224 5.428c-.103.433-.565.937-.681.89-.15-.06.053-.916.001-.973s-.19-.003-.372.035c-.247.055-.488.11-.508.05-.019-.061.522-.663 1.304-.761.392-.042.36.328.256.759M4.777 18.57c.103-.432.566-.934.68-.889.15.062-.052.918 0 .974.05.057.19.004.373-.036.246-.054.487-.109.506-.048.018.061-.521.662-1.304.76-.39.041-.359-.327-.255-.76"
            })
        ]
    }));



var $7YWoO = parcelRequire("7YWoO");
const $d747d09a8ba086cb$export$2e2bcd8739ae039 = (f)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, f, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "url(#nokkelhull_svg__a)",
                d: "M3 3h18v18H3z"
            }),
            (0, $7YWoO.jsxs)("defs", {
                children: [
                    (0, $7YWoO.jsx)("pattern", {
                        id: "nokkelhull_svg__a",
                        width: 1,
                        height: 1,
                        patternContentUnits: "objectBoundingBox",
                        children: (0, $7YWoO.jsx)("use", {
                            xlinkHref: "#nokkelhull_svg__b",
                            transform: "scale(.00196)"
                        })
                    }),
                    (0, $7YWoO.jsx)("image", {
                        xlinkHref: "data:image/png;base64,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",
                        id: "nokkelhull_svg__b",
                        width: 511,
                        height: 511,
                        preserveAspectRatio: "none"
                    })
                ]
            })
        ]
    }));



var $7YWoO = parcelRequire("7YWoO");
const $309111dd3b0210e5$export$2e2bcd8739ae039 = (v)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, v, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M7.34 3a3.413 3.413 0 0 0-3.403 3.403V21H16.67a3.41 3.41 0 0 0 3.393-3.403V3z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#79B61D",
                d: "M7.34 4.092a2.315 2.315 0 0 0-2.315 2.315v7.459h11.768a2.217 2.217 0 0 0 2.175-2.213V4.092z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#E31919",
                d: "M16.67 19.908a2.315 2.315 0 0 0 2.315-2.315V14.93h-7.462v4.977z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M7.969 10.343h.405v2.049a.4.4 0 0 1-.436.42.51.51 0 0 1-.507-.31l-.6-1.254q.02.095.025.193v1.35h-.398v-2.448h.386l1.001 2.074c.043.094.132.083.132 0zM9.532 10.692c-.166 0-.25.085-.25.276v1.2c0 .193.084.276.25.276h.488c.165 0 .248-.085.248-.276v-1.2c0-.193-.083-.276-.248-.276zm1.142.233v1.266a.56.56 0 0 1-.625.6H9.5a.557.557 0 0 1-.618-.6v-1.266a.56.56 0 0 1 .618-.578h.551a.56.56 0 0 1 .626.578M12.389 11.396a.31.31 0 0 0 .173-.249v-.18c0-.192-.085-.275-.25-.275h-.722v1.23zm-1.202-1.053h1.157a.56.56 0 0 1 .626.579v.262a.55.55 0 0 1-.276.438l-.386.25.696.919h-.463l-.548-.708-.407.268v.44h-.4zM15.219 11.352v.839a.56.56 0 0 1-.623.6h-.552a.56.56 0 0 1-.62-.6v-1.266a.56.56 0 0 1 .62-.578h.965v.349h-.932c-.164 0-.249.085-.249.276v1.2c0 .193.085.276.249.276h.488c.166 0 .25-.085.25-.276v-.405h-.578v-.415zM9.124 5.24v3.245c0 .089-.088.102-.13 0L7.45 5.232h-.984V9.56h.91V6.988l.965 2.087a.83.83 0 0 0 .727.515h.124q.111 0 .22-.025a.86.86 0 0 0 .376-.181.82.82 0 0 0 .272-.648V5.24zM17.117 12.453h-.76c-.164 0-.25-.085-.25-.275v-.406h1.01v-.42h-1.01v-.386c0-.193.086-.276.25-.276h.76v-.347h-.793a.56.56 0 0 0-.62.579v1.265a.56.56 0 0 0 .62.6h.793zM15.076 5.253v.917h1.079v3.405h.933V6.17h1.071v-.917zM11.71 5.26l.852 1.604.928-1.605h1.11l-1.517 2.628v1.672h-.972V7.887l-1.513-2.628z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#E31919",
                d: "M7.93 14.93H5.03v4.978H7.93z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#004495",
                d: "M10.46 14.93H8.99v4.978h1.47z"
            })
        ]
    }));



var $7YWoO = parcelRequire("7YWoO");
const $39567371f305f701$export$2e2bcd8739ae039 = (s)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, s, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#106B45",
                d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "m7.928 14.546-.22.545-.654-.291.219-.546c-.728-.436-1.128-1.272-1.128-2.108 0-1.273.91-2.473 2.437-2.473.218 0 .436.036.654.072l.291-.654.655.29-.29.619c.726.436 1.162 1.272 1.162 2.146 0 1.272-.908 2.472-2.436 2.472a4 4 0 0 1-.69-.072m-.364-.982L8.909 10.4c-.109-.036-.218-.036-.363-.036-1.019 0-1.637.872-1.637 1.782.037.545.255 1.09.655 1.418m2.654-1.418c0-.546-.218-1.092-.618-1.419l-1.346 3.164c.11.036.255.036.364.036.946 0 1.6-.872 1.6-1.781m3.054.763 1.31 1.564h-.91L12.51 13.09v1.382h-.727V9.782h.728v2.981l1.163-1.381h.909zm1.456 0c0-.872.654-1.636 1.672-1.636s1.672.764 1.672 1.672c0 .91-.654 1.673-1.672 1.673-1.018-.036-1.672-.8-1.672-1.71m2.58 0c0-.545-.362-.982-.944-.982-.546 0-.91.473-.91 1.019s.364 1.017.91 1.017c.582-.036.945-.509.945-1.054"
            })
        ]
    }));



var $7YWoO = parcelRequire("7YWoO");
const $28cceb028976732a$export$2e2bcd8739ae039 = (v)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, v, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M19.415 3H5v19h14.415z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M5.613 3.613h1.39V3H5v19h10.186v-.613H5.613zM9.229 3v.613h9.573v17.774h-1.39V22h2.003V3z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M8.394 18.064c-.065.07-.158.115-.346.115h-.497v-.713h.497c.188 0 .281.046.346.114a.36.36 0 0 1 .094.245.34.34 0 0 1-.094.24m-.321-1.086h-1.07v2.85h.548v-1.16h.522c.366 0 .586-.09.74-.253a.86.86 0 0 0 .225-.59.86.86 0 0 0-.224-.59c-.16-.168-.375-.257-.741-.257M10.412 17.866l.362.842h-.724zm-.57 1.331h1.144l.269.631h.574l-1.221-2.85h-.387l-1.222 2.85h.574zM12.584 16.978h-.386v2.85h.55v-1.857l1.588 1.857h.386v-2.85h-.55v1.856zM17.413 16.978h-2.057v.488h.754v2.362h.55v-2.362h.753zM17.413 14.872H7.003v.283h10.41zM9.886 7.3a2.435 2.435 0 0 1 2.338-1.713c1.27 0 2.37.952 2.37 2.285 0 .898-.456 1.554-.953 2.125l-1.576 1.83h2.58v1.27H9.835v-.847l2.601-2.95c.571-.646.73-1.069.73-1.45 0-.518-.402-.994-.963-.994-.497 0-.857.339-1.005.836z"
            })
        ]
    }));



var $7YWoO = parcelRequire("7YWoO");
const $dfcc2a4e563d62c8$export$2e2bcd8739ae039 = (v)=>(0, $7YWoO.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1.5em",
        height: "1.5em",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        focusable: "false",
        "aria-hidden": "true"
    }, v, {
        children: [
            (0, $7YWoO.jsx)("path", {
                fill: "#fff",
                d: "M19.415 3H5v19h14.415z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M5.613 3.613h1.39V3H5v19h10.186v-.613H5.613zM9.228 3v.613h9.574v17.774h-1.39V22h2.003V3z"
            }),
            (0, $7YWoO.jsx)("path", {
                fill: "#231F20",
                d: "M8.394 18.064c-.065.07-.159.115-.346.115h-.497v-.713h.497c.187 0 .28.046.346.114a.35.35 0 0 1 .094.245.34.34 0 0 1-.094.24m-.321-1.086h-1.07v2.85h.548v-1.16h.522c.366 0 .586-.09.74-.253a.86.86 0 0 0 .225-.59.86.86 0 0 0-.224-.59c-.16-.168-.375-.257-.741-.257M10.412 17.866l.362.842h-.724zm-.57 1.33h1.144l.269.632h.574l-1.221-2.85h-.387l-1.222 2.85h.574zM12.585 16.978h-.387v2.85h.55v-1.857l1.587 1.857h.387v-2.85h-.55v1.856zM17.413 16.978h-2.056v.488h.753v2.362h.55v-2.362h.753zM17.413 14.872H7.003v.283h10.41zM10.628 11.226c.307.433.815.74 1.375.74.698 0 1.386-.55 1.386-1.343 0-.772-.635-1.354-1.46-1.354-.296 0-.613.073-.888.211v-.846l1.385-1.639H9.951v-1.27h4.495v.847l-1.343 1.65c1.015.39 1.713 1.28 1.713 2.4 0 1.566-1.227 2.613-2.76 2.613-.92 0-1.798-.413-2.454-1.153z"
            })
        ]
    }));


const $5e6c03daec6acafb$var$n = (e, l, i = !1)=>typeof e > "u" ? "" : typeof e == "string" && i ? e : typeof e == "object" ? e[l] ?? "" : "", $5e6c03daec6acafb$export$d6d4e18f2794ac22 = (0, $dvPqk.forwardRef)(({ image: e, imageAlt: l, title: i, headingLevel: d = "h3", badges: c = [], href: m, as: u = "a", label: a, backgroundColor: p = "white", className: t }, g)=>{
    const h = {
        white: "bg-surface-default",
        transparent: "bg-base-transparent"
    }[p], b = {
        debio: (0, $2f986b181defeaa2$export$2e2bcd8739ae039),
        nokkelhull: (0, $d747d09a8ba086cb$export$2e2bcd8739ae039),
        nytNorge: (0, $309111dd3b0210e5$export$2e2bcd8739ae039),
        okologisk: (0, $39567371f305f701$export$2e2bcd8739ae039),
        pant2Kr: (0, $28cceb028976732a$export$2e2bcd8739ae039),
        pant3Kr: (0, $dfcc2a4e563d62c8$export$2e2bcd8739ae039)
    }, v = d;
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: (0, $6sMuH.cn)("inline-flex relative p-3 flex-col gap-3 justify-center items-center rounded-card-lg overflow-clip text-link-default hover:-translate-y-1 duration-300 transition-all", h, $5e6c03daec6acafb$var$n(t, "container", !0)),
        ref: g,
        children: [
            /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                className: "relative",
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)("img", {
                        alt: l,
                        className: (0, $6sMuH.cn)("mix-blend-darken", $5e6c03daec6acafb$var$n(t, "image")),
                        height: 120,
                        src: e,
                        width: 120
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: (0, $6sMuH.cn)("absolute top-2 right-0 flex flex-col", $5e6c03daec6acafb$var$n(t, "badges")),
                        children: c.map((f)=>{
                            const k = b[f];
                            return /* @__PURE__ */ (0, $7YWoO.jsx)(k, {}, f);
                        })
                    })
                ]
            }),
            a ? /* @__PURE__ */ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
                className: (0, $6sMuH.cn)("absolute inline-block left-3 top-3", $5e6c03daec6acafb$var$n(t, "label")),
                size: "small",
                children: a
            }, a) : null,
            i ? /* @__PURE__ */ (0, $7YWoO.jsx)(u, {
                className: "no-underline text-ink-brand-default outline-none focus-visible:ring rounded max-w-36 text-center",
                href: m || null,
                children: /* @__PURE__ */ (0, $7YWoO.jsx)(v, {
                    className: (0, $6sMuH.cn)("hover:underline before:absolute before:inset-0 before:z-0", $5e6c03daec6acafb$var$n(t, "title")),
                    children: i
                })
            }) : null
        ]
    });
});
$5e6c03daec6acafb$export$d6d4e18f2794ac22.displayName = "ProductCardSimple";


var $4OT0V = parcelRequire("4OT0V");
var $hGZvy = parcelRequire("hGZvy");
var $5V760 = parcelRequire("5V760");
var $i4tzf = parcelRequire("i4tzf");
var $1Q5Iy = parcelRequire("1Q5Iy");
var $fqWHZ = parcelRequire("fqWHZ");
var $cR6lR = parcelRequire("cR6lR");
var $aqsnV = parcelRequire("aqsnV");
var $4Y3YK = parcelRequire("4Y3YK");
var $l83zr = parcelRequire("l83zr");
var $2RPNt = parcelRequire("2RPNt");
var $gVtxS = parcelRequire("gVtxS");
var $hGi4c = parcelRequire("hGi4c");
var $jYTqr = parcelRequire("jYTqr");
var $7YWoO = parcelRequire("7YWoO");

var $lDdsZ = parcelRequire("lDdsZ");
function $54f46d7c7a17a785$export$af3ec21f6cfb5e30({ children: r, label: e, onChange: s, defaultValue: o }) {
    return /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
        className: "flex flex-col gap-y-2",
        children: [
            e ? /* @__PURE__ */ (0, $7YWoO.jsx)("p", {
                className: "text-ink-brand-default text-lg",
                children: e
            }) : null,
            /* @__PURE__ */ (0, $7YWoO.jsxs)((0, $lDdsZ.RadioGroup), {
                defaultValue: o,
                onChange: (t)=>{
                    s({
                        target: {
                            value: t
                        }
                    });
                },
                children: [
                    /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lDdsZ.RadioGroup).Label, {
                        as: "span",
                        className: "sr-only",
                        children: e
                    }),
                    /* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                        className: "flex items-center gap-x-0.5 bg-chip-default w-max rounded-full p-1",
                        children: r
                    })
                ]
            })
        ]
    });
}
$54f46d7c7a17a785$export$af3ec21f6cfb5e30.displayName = "ToggleGroup";


var $7YWoO = parcelRequire("7YWoO");

var $dvPqk = parcelRequire("dvPqk");

var $lDdsZ = parcelRequire("lDdsZ");
function $52c7eda9c50e95c3$var$m(t) {
    return t.type === (0, $lDdsZ.RadioGroup).Label || t.type === (0, $lDdsZ.RadioGroup).Description;
}
function $52c7eda9c50e95c3$export$b453109e13abe10b({ children: t, value: p, icon: r }) {
    return /* @__PURE__ */ (0, $7YWoO.jsx)((0, $lDdsZ.RadioGroup).Option, {
        className: ({ active: i, checked: e })=>`${i ? "ring-2 ring-offset-2 ring-offset-button-primary-bg z-10" : ""}
      ${e ? "bg-button-primary-bg text-button-primary-text hover:bg-button-primary-bg-hover z-10" : "bg-chip-default hover:bg-chip-default-hover text-ink-brand-default"}
          relative flex cursor-pointer rounded-full p-2 focus:outline-none`,
        value: p,
        children: ({ checked: i })=>/* @__PURE__ */ (0, $7YWoO.jsx)("div", {
                className: "flex w-full items-center justify-between",
                children: /* @__PURE__ */ (0, $7YWoO.jsxs)("div", {
                    className: "flex items-center gap-x-2",
                    children: [
                        r && (0, $dvPqk.isValidElement)(r) ? (0, $dvPqk.cloneElement)(r, {
                            style: {
                                width: "var(--spacing-4)",
                                height: "var(--spacing-4)"
                            }
                        }) : null,
                        (0, $dvPqk.Children).map(t, (e)=>(0, $dvPqk.isValidElement)(e) && $52c7eda9c50e95c3$var$m(e) ? (0, $dvPqk.cloneElement)(e, {
                                checked: i
                            }) : e)
                    ]
                })
            })
    });
}
$52c7eda9c50e95c3$export$b453109e13abe10b.displayName = "ToggleGroupItem";


var $jOVmP = parcelRequire("jOVmP");
var $lgHX0 = parcelRequire("lgHX0");
parcelRequire("8TkRM");
var $gBcml = parcelRequire("gBcml");

var $dvPqk = parcelRequire("dvPqk");

var $cZSqT = parcelRequire("cZSqT");
const $e726ecee6b5865a1$var$Components = ()=>{
    const [isModalOpen, setIsModalOpen] = (0, $dvPqk.useState)(false);
    const [isSwitchOn, setIsSwitchOn] = (0, $dvPqk.useState)(false);
    const [isChipActive, setIsChipActive] = (0, $dvPqk.useState)(false);
    const [showChipIcon, setShowChipIcon] = (0, $dvPqk.useState)(true);
    const [isChecked, setIsChecked] = (0, $dvPqk.useState)(false);
    const onClose = ()=>{
        setIsModalOpen(false);
    };
    const onOpen = ()=>{
        setIsModalOpen(true);
    };
    const handleToggleSwitch = ()=>{
        setIsSwitchOn(!isSwitchOn);
    };
    const handleChipClick = ()=>{
        setIsChipActive(!isChipActive);
    };
    const handleChipRemoveClick = ()=>{
        setShowChipIcon(!showChipIcon);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "flex flex-col items-center justify-center gap-y-28 p-8 xl:p-40",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                className: "text-3xl font-bold",
                children: "Oversikt over komponenter fra KREM"
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Accordion"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eYDe5.Accordion), {
                        label: "Question 1",
                        children: "Answer 1"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Alert"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ezbi8.Alert), {
                        variant: "success",
                        title: "Success",
                        children: "Alert"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Breadcrumbs"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ghmTa.Breadcrumbs), {
                        items: [
                            {
                                label: "Home",
                                href: "/"
                            },
                            {
                                label: "Components",
                                href: "/components",
                                current: true
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Button"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex flex-wrap gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                className: "w-fit",
                                variant: "primary",
                                children: "Primary"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                className: "w-fit",
                                variant: "secondary",
                                children: "Secondary"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                className: "w-fit",
                                variant: "tertiary",
                                children: "Tertiary"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                className: "w-fit",
                                variant: "destructive",
                                children: "Destructive"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Carousel and Recipe Card"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $0c39b0cc23227f0c$export$144901db2ea8e967), {
                        numVisible: {
                            default: 1.9,
                            sm: 1.9,
                            md: 2.5,
                            lg: 3,
                            xl: 3
                        },
                        size: "md",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $28beb29f2d26ddf6$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                                    compactRating: true,
                                    href: "#",
                                    image: "https://www.tine.no/_/recipeimage/w_2560%2Ch_1440%2Cc_fill%2Cx_1024%2Cy_576%2Cg_xy_center/recipeimage/mzk4deb35usrg69xr5r7.jpg",
                                    rating: 4.8,
                                    tag: "Vegetarian",
                                    title: "Item 1: Norwegian Brie Wrap with Lingonberry Jam"
                                })
                            }, 1),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $28beb29f2d26ddf6$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                                    compactRating: true,
                                    href: "#",
                                    image: "https://www.tine.no/_/recipeimage/w_2560%2Ch_1440%2Cc_fill%2Cx_1024%2Cy_576%2Cg_xy_center/recipeimage/mzk4deb35usrg69xr5r7.jpg",
                                    rating: 4.8,
                                    tag: "Vegetarian",
                                    title: "Jarlsberg Cheese"
                                })
                            }, 2),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $28beb29f2d26ddf6$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                                    compactRating: true,
                                    href: "#",
                                    image: "https://www.tine.no/_/recipeimage/w_2560%2Ch_1440%2Cc_fill%2Cx_1024%2Cy_576%2Cg_xy_center/recipeimage/mzk4deb35usrg69xr5r7.jpg",
                                    rating: 4.8,
                                    tag: "Vegetarian",
                                    title: "Item 3: Creamy Havarti Wrap with Roasted Peppers"
                                })
                            }, 3),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $28beb29f2d26ddf6$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                                    compactRating: true,
                                    href: "#",
                                    image: "https://www.tine.no/_/recipeimage/w_2560%2Ch_1440%2Cc_fill%2Cx_1024%2Cy_576%2Cg_xy_center/recipeimage/mzk4deb35usrg69xr5r7.jpg",
                                    tag: "Vegetarian",
                                    title: "Item 4: Sn\xf8frisk Cream Cheese Wrap with Salmon and Dill"
                                })
                            }, 4),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $28beb29f2d26ddf6$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                                    compactRating: true,
                                    href: "#",
                                    image: "https://www.tine.no/_/recipeimage/w_2560%2Ch_1440%2Cc_fill%2Cx_1024%2Cy_576%2Cg_xy_center/recipeimage/mzk4deb35usrg69xr5r7.jpg",
                                    rating: 4.8,
                                    tag: "Vegetarian",
                                    title: "Item 5: N\xf8kkelost Cheese Wrap with Pickled Cucumbers"
                                })
                            }, 5),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $28beb29f2d26ddf6$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                                    compactRating: true,
                                    href: "#",
                                    image: "https://www.tine.no/_/recipeimage/w_2560%2Ch_1440%2Cc_fill%2Cx_1024%2Cy_576%2Cg_xy_center/recipeimage/mzk4deb35usrg69xr5r7.jpg",
                                    tag: "Vegetarian",
                                    title: "Item 6: Goat Cheese Wrap with Honey and Walnuts"
                                })
                            }, 6),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $28beb29f2d26ddf6$export$42c20acb2971398c), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGZvy.RecipeCard), {
                                    compactRating: true,
                                    href: "#",
                                    image: "https://www.tine.no/_/recipeimage/w_2560%2Ch_1440%2Cc_fill%2Cx_1024%2Cy_576%2Cg_xy_center/recipeimage/mzk4deb35usrg69xr5r7.jpg",
                                    tag: "Vegetarian",
                                    title: "Item 6: Goat Cheese Wrap with Honey and Walnuts"
                                })
                            }, 7)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Checkbox"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9AGLN.Checkbox), {
                        label: "Checkbox",
                        isChecked: isChecked,
                        onChange: ()=>{
                            setIsChecked(!isChecked);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Content Card"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $0855e751f2dfbb2b$export$f631859cab12b342), {
                        className: "max-w-[600px]",
                        description: "En kort tekst her...",
                        hasShadow: true,
                        href: "#",
                        image: "https://www.tine.no/b%C3%A6rekraft/_/image/ff0df4f9-7051-4244-8d4f-69be9cc087c1:c08ac1f54bbeef90b6c33c0c5c0c22e1b0d8dda8/block-1120-630/aarsrapport2020_forsidebilde.jpg",
                        tags: [
                            "Tema"
                        ],
                        title: "Overskrift til inlegget...",
                        variant: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Flex"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $309997bcbd683695$export$f51f4c4ede09e011), {
                        align: "start",
                        direction: "row",
                        gap: 4,
                        justify: "start",
                        wrap: "nowrap",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "1"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "2"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "3"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Form"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("form", {
                        className: "flex max-w-96 flex-col gap-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lFdyG.FormDetails), {
                                label: "Form details - Input",
                                tooltipPosition: "right",
                                tooltipText: "Tooltip text"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3SASj.Input), {
                                label: "",
                                placeholder: "Placeholder"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $eVBn0.FormError), {
                                errorMessage: "Form Error",
                                showErrorMessage: true
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1Q5Iy.Select), {
                                label: "Select",
                                options: [
                                    {
                                        label: "Option 1",
                                        value: "option1"
                                    },
                                    {
                                        label: "Kjede: VESTFOLD OG TELEMARKK INNKJ\xd8P (GR00002661)",
                                        value: "option2"
                                    },
                                    {
                                        label: "Option 3",
                                        value: "option3"
                                    }
                                ],
                                value: {
                                    label: "Option 1",
                                    value: "option1"
                                },
                                onChange: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4OT0V.RadioGroup), {
                                label: "Radio Group",
                                onChange: ()=>{},
                                options: [
                                    {
                                        label: "Alternativ 1",
                                        value: "option1"
                                    },
                                    {
                                        label: "Alternativ 2",
                                        value: "option2"
                                    },
                                    {
                                        label: "Alternativ 3",
                                        value: "option3"
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jYTqr.TextArea), {
                                errorMessage: "Error message",
                                label: "Textarea",
                                maxLength: 100,
                                onChange: ()=>{},
                                placeholder: "Placeholder",
                                rows: 4,
                                showMaxLength: true,
                                value: ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Grid & Grid Simple"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
                        className: "",
                        cols: 12,
                        gap: 4,
                        type: "media",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                className: "bg-grassGreen-100 p-4 text-center",
                                span: 4,
                                children: "Child 1"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                className: "bg-grassGreen-500 p-4 text-center",
                                span: 4,
                                children: "Child 2"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                                className: "bg-grassGreen-900 p-4 text-center",
                                span: 4,
                                children: "Child 3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3ofZR.GridSimple), {
                        className: "",
                        cols: 3,
                        gap: 4,
                        type: "media",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 w-full items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "1"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 w-full items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "2"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 w-full items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "3"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Group"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $jOOuf.Group), {
                        align: "start",
                        className: "",
                        gap: 4,
                        justify: "start",
                        wrap: "nowrap",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "1"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "2"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "3"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Inputstepper"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1A6xS.InputStepper), {
                        max: 10,
                        min: 0,
                        value: 1
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Link"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4rjCr.Link), {
                        href: "#",
                        children: "Link"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Modal"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                        children: "Click the button to open the modal"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                        className: "mt-8 w-fit",
                        onClick: onOpen,
                        variant: "primary",
                        children: "Open Modal"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $34rNI.Modal), {
                        isOpen: isModalOpen,
                        onClose: onClose,
                        title: "Title",
                        description: "Here is a description",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                            className: "flex flex-col space-y-4",
                            children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1Q5Iy.Select), {
                                        label: "Select",
                                        options: [
                                            {
                                                label: "Option 1",
                                                value: "option1"
                                            }
                                        ],
                                        value: {
                                            label: "Option 1",
                                            value: "option1"
                                        },
                                        onChange: ()=>{}
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $jOVmP.Tooltip), {
                                        tooltipText: "Tooltip",
                                        tooltipPosition: "right"
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                        className: "ml-auto flex items-center gap-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                                variant: "primary",
                                                children: "Prim\xe6r"
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cGjF4.Button), {
                                                onClick: onClose,
                                                variant: "secondary",
                                                children: "Lukk"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "ProductCard"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5e6c03daec6acafb$export$d6d4e18f2794ac22), {
                        className: "w-fit",
                        image: "https://aps.brandmaster.com/v03/product/12590/3498/small/hovedbilde/tine_handel_artnr_3498__small.png",
                        imageAlt: "Product image",
                        title: "Product name over two lines of text",
                        label: "Label",
                        href: "/",
                        backgroundColor: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Parallax"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $b7d2dabf5cc2b3fa$export$1bc430945f060dd1), {
                        description: "Scroll to see the magic happen",
                        imageUrl: "https://a.vev.design/r/DcoF0h-2-P0_1080.jpg",
                        title: "Parallax"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5V760.Search), {
                        className: "w-full",
                        placeholder: "Search",
                        label: "Search",
                        value: "",
                        onChange: ()=>{}
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Section Card"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $i4tzf.SectionCard), {
                        title: "Section card",
                        description: "Here is a description",
                        image: "https://a.vev.design/r/DcoF0h-2-P0_1080.jpg",
                        buttonVariant: "primary",
                        ctaLabel: "Click",
                        href: "#"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Stack"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $fqWHZ.Stack), {
                        align: "start",
                        className: "",
                        gap: 4,
                        justify: "start",
                        wrap: "nowrap",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "1"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "2"
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "flex size-16 items-center justify-center bg-information-100",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                    children: "3"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Switch"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $a26c85f8e5c7e41c$export$b5d5cf8927ab7262), {
                        isEnabled: isSwitchOn,
                        label: "Switch",
                        onChange: handleToggleSwitch
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Table"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $cR6lR.Table), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $l83zr.TableHeader), {
                                children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $gVtxS.TableRow), {
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2RPNt.TableHeaderCell), {
                                            id: "Header 1",
                                            children: "Header 1"
                                        }),
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2RPNt.TableHeaderCell), {
                                            id: "Header 2",
                                            children: "Header 2"
                                        }),
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2RPNt.TableHeaderCell), {
                                            id: "Header 3",
                                            children: "Header 3"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $aqsnV.TableBody), {
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $gVtxS.TableRow), {
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Y3YK.TableCell), {
                                                headers: "Header 1",
                                                children: "Cell 1"
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Y3YK.TableCell), {
                                                headers: "Header 2",
                                                children: "Cell 2"
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Y3YK.TableCell), {
                                                headers: "Header 3",
                                                children: "Cell 3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $gVtxS.TableRow), {
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Y3YK.TableCell), {
                                                headers: "Header 1",
                                                children: "Cell 4"
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Y3YK.TableCell), {
                                                headers: "Header 2",
                                                children: "Cell 5"
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4Y3YK.TableCell), {
                                                headers: "Header 3",
                                                children: "Cell 6"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Tag"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hGi4c.Tag), {
                        lip: "none",
                        variant: "base",
                        children: "Tag"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Video "
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lgHX0.VideoPlayer), {
                        poster: "https://www.tine.no/_/recipeimage/w_1024%2Ch_576%2Cc_fill%2Cx_1500%2Cy_937%2Cg_xy_center/recipeimage/426615.jpg",
                        videoId: "sg_5IHHY_n4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Chip"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: "flex w-fit items-center gap-x-4",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6tjXJ.Chip), {
                                children: "Chip"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6tjXJ.Chip), {
                                onClick: handleChipClick,
                                checked: isChipActive,
                                icon: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5rKSh.default), {}),
                                iconPosition: "left",
                                children: "Chip with icon"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6tjXJ.Chip), {
                                onClick: handleChipRemoveClick,
                                icon: showChipIcon ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9NHzr.default), {}) : undefined,
                                children: "Chip with close"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "ToggleGroup"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $54f46d7c7a17a785$export$af3ec21f6cfb5e30), {
                        onChange: ()=>{},
                        defaultValue: "1",
                        "aria-label": "Velg alternativ",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $52c7eda9c50e95c3$export$b453109e13abe10b), {
                                value: "1",
                                children: "Item 1"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $52c7eda9c50e95c3$export$b453109e13abe10b), {
                                value: "2",
                                children: "Item 2"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $52c7eda9c50e95c3$export$b453109e13abe10b), {
                                value: "3",
                                children: "Item 3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: "flex w-full flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h1", {
                        children: "Skal kanskje i KREM etterhvert"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                        children: "Informasjonsboks"
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cZSqT.default), {
                        title: "Mehmets tips",
                        theme: "main",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                            children: "Bruk dekorative elementer i salatbuffeten som hele chili, hvitl\xf8ksranker, gresskar og urter for \xe5 skape en innbydende og fargerik opplevelse for gjestene. Et ekstra pluss? Pynten kan senere brukes i matlagingen."
                        })
                    })
                ]
            })
        ]
    });
};
var $e726ecee6b5865a1$export$2e2bcd8739ae039 = (0, $gBcml.observer)($e726ecee6b5865a1$var$Components);



var $bcbvQ = parcelRequire("bcbvQ");

var $lKrOo = parcelRequire("lKrOo");

var $jQJ4P = parcelRequire("jQJ4P");

var $25aT1 = parcelRequire("25aT1");

var $jlTfJ = parcelRequire("jlTfJ");

var $9Vhxl = parcelRequire("9Vhxl");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $a2SqC = parcelRequire("a2SqC");

var $isIf6 = parcelRequire("isIf6");

const $f999e54dedf3fc06$var$BarcodeScanner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("Xd520")));

const $f999e54dedf3fc06$var$Cart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("4DOgN")));

const $f999e54dedf3fc06$var$CustomerRoutes = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("4BzDY")));

const $f999e54dedf3fc06$var$ProductListPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("dqsOV")));

const $f999e54dedf3fc06$var$Home = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("iP1Cb")));

const $f999e54dedf3fc06$var$SearchResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("ihZxD")));

const $f999e54dedf3fc06$var$ProductDetailsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("4pDmq")));

const $f999e54dedf3fc06$var$OrderConfirmation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("e9jzP")));

const $f999e54dedf3fc06$var$SubscriptionConfirmation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("mhqlt")));

const $f999e54dedf3fc06$var$PickupConfirmation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("bdlGO")));

const $f999e54dedf3fc06$var$CmsContentPreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("6o7QV")));

const $f999e54dedf3fc06$var$CmsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("fsuvZ")));

const $f999e54dedf3fc06$var$ContactFormPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("7Sli3")));

const $f999e54dedf3fc06$var$SwitchCompanyPunchoutPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("9Ofyy")));

const $f999e54dedf3fc06$var$AdventCalendar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("2RKVy")));

const $f999e54dedf3fc06$var$CookiePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))).lazy(()=>(parcelRequire("ev1AS")));
const $f999e54dedf3fc06$var$App = ()=>{
    const [location, redirectTo] = (0, $8kt8E.useLocation)();
    (0, $dvPqk.useEffect)(()=>{
        async function fetchData() {
            await (0, $a2SqC.default).ensureDataVersionAvailable();
            await (0, $biFcX.default).fetchEnabledConfigCatFeatures();
            try {
                await (0, $jlTfJ.default).fillStore(location);
                (0, $9Vhxl.default).fetchHolidays();
                await (0, $bZiDo.default).fillStore();
                await (0, $25aT1.default).fillStore();
            } catch (err) {
                const actualError = (0, $aMYzM.ensureError)(err);
                // If we end up here, likelihood is that we attempted to load an old data file from the CDN.
                // We will attempt to check versions on CDN and then refresh the window to fetch new data.
                await (0, $a2SqC.default).handleMissingDataFileError(actualError);
            }
            try {
                const isImpersonating = (0, $bcbvQ.default).getSessionFromQuery();
                if (isImpersonating) redirectTo("/");
                (0, $bZiDo.default).loadGuestAssortment();
                await (0, $bcbvQ.default).verifySession(null);
            } catch (err) {
                if (!(err instanceof (0, $aMYzM.TokenExpiryError))) {
                    const wrappedError = (0, $aMYzM.ensureError)(err);
                    (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).notify(wrappedError, (e)=>{
                        e.context = "Session Check during startup";
                    });
                    (0, $gtsdT.logger).log("auth", "Not already logged in, reason: ", wrappedError);
                }
            }
        }
        fetchData();
        window.addEventListener("keydown", (0, $a2SqC.default).handleShortcutKeypress);
        return ()=>{
            window.removeEventListener("keydown", (0, $a2SqC.default).handleShortcutKeypress);
        };
    }, []);
    const isDesktop = (0, $gUV6W.default)((0, $5OqMf.desktopBreakpoint));
    const isPunchoutCompanySelect = (0, $bcbvQ.default).isPunchoutSession() && (0, $lKrOo.default).is("COMPANY_SELECTION");
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $j6ChH.Helmet), {
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("title", {
                    children: (0, $isIf6.default).siteName
                })
            }),
            isPunchoutCompanySelect && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dvPqk.Suspense), {
                fallback: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {}),
                children: /*#__PURE__*/ (0, $7YWoO.jsx)($f999e54dedf3fc06$var$SwitchCompanyPunchoutPage, {})
            }),
            !isPunchoutCompanySelect && /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                children: [
                    (0, $8ZCSm.ENV_NAME) !== "prod" && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $838e5ccbb81e27c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1fe441d34deee6cc$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("header", {
                        className: "relative z-30 print:hidden",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8f6fd37647893ec3$export$2e2bcd8739ae039), {}),
                            isDesktop ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $06cfcff520480a38$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7YWoO.jsx)((0, $34ea561e0cfcc68a$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7e3692a626553f69$export$2e2bcd8739ae039), {
                        as: "main",
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "min-h-[90vh] w-full pb-20 pt-6 print:text-[80%]",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dvPqk.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {}),
                                    children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $8kt8E.Switch), {
                                        children: [
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: /^(?<fullUrl>\/)$/,
                                                component: $f999e54dedf3fc06$var$Home
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/home",
                                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Redirect), {
                                                    to: "/",
                                                    replace: true
                                                })
                                            }),
                                            (0, $8ZCSm.ENV_NAME) !== "prod" && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/components",
                                                component: (0, $e726ecee6b5865a1$export$2e2bcd8739ae039)
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/produkter/:cat2/:cat3",
                                                children: (p)=>/*#__PURE__*/ (0, $7YWoO.jsx)($f999e54dedf3fc06$var$ProductListPage, {
                                                        ...p
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/produkter/:cat2",
                                                children: (p)=>/*#__PURE__*/ (0, $7YWoO.jsx)($f999e54dedf3fc06$var$ProductListPage, {
                                                        ...p
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/produkter.html",
                                                children: ()=>/*#__PURE__*/ (0, $7YWoO.jsx)($f999e54dedf3fc06$var$ProductListPage, {})
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/customer/*",
                                                component: $f999e54dedf3fc06$var$CustomerRoutes
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/checkout/cart",
                                                component: $f999e54dedf3fc06$var$Cart
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/checkout/confirmation/subscription",
                                                component: $f999e54dedf3fc06$var$SubscriptionConfirmation
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/checkout/confirmation/pickup",
                                                component: $f999e54dedf3fc06$var$PickupConfirmation
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/checkout/confirmation",
                                                component: $f999e54dedf3fc06$var$OrderConfirmation
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/search/:type?",
                                                component: $f999e54dedf3fc06$var$SearchResult
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/produkt/:slug",
                                                children: (p)=>/*#__PURE__*/ (0, $7YWoO.jsx)($f999e54dedf3fc06$var$ProductDetailsPage, {
                                                        ...p
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/kontakt",
                                                component: $f999e54dedf3fc06$var$ContactFormPage
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/kampanjer/arets-matglede-rapport",
                                                component: (0, $be3fda7fc03da394$export$2e2bcd8739ae039)
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/julekalender",
                                                component: $f999e54dedf3fc06$var$AdventCalendar
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: "/informasjonskapsler",
                                                component: $f999e54dedf3fc06$var$CookiePage
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: /^\/_preview\/(?<fullUrl>.*)$/,
                                                component: $f999e54dedf3fc06$var$CmsContentPreview
                                            }),
                                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8kt8E.Route), {
                                                path: /^\/(?<fullUrl>.*)$/,
                                                component: $f999e54dedf3fc06$var$CmsContent
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                id: "megamenu-root"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                id: "quicksearch-root"
                            }),
                            (0, $a2SqC.default).planes.map((p)=>/*#__PURE__*/ (0, $7YWoO.jsx)((0, $55089934d55e26ff$export$2e2bcd8739ae039), {
                                    plane: p
                                }, p.animationId)),
                            (0, $biFcX.default).barcodeScannerEnabled && (0, $jQJ4P.default).modalVisible && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dvPqk.Suspense), {
                                fallback: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {
                                    modal: true
                                }),
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)($f999e54dedf3fc06$var$BarcodeScanner, {})
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8bf7bc4ef5f58a43$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4adbd804e19d4e3f$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3df4e69ebf2f1ee7$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsx)("footer", {
                        className: "bg-headerFooterBackground [&>*]:text-headerFooterText",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $df1dc429abb84f60$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $29b68b9e01ef24ae$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $2eb997ad4ed0ebf9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $48e8d530d3831c9a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ab9c9c718aa6093e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $5080050ca13989ff$export$2e2bcd8739ae039), {
                onChange: (vis)=>(0, $bcbvQ.default).verifyStillLoggedIn(vis)
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bcb2274662c413fd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $e1d5b126ce0a03e1$export$2e2bcd8739ae039), {})
        ]
    });
};
var $f999e54dedf3fc06$export$2e2bcd8739ae039 = (0, $gBcml.observer)($f999e54dedf3fc06$var$App);



var $8ZCSm = parcelRequire("8ZCSm");

var $gtsdT = parcelRequire("gtsdT");

var $cLLe3 = parcelRequire("cLLe3");

var $4r4cM = parcelRequire("4r4cM");

var $isIf6 = parcelRequire("isIf6");
/**
 * Add global error reporting for Bugsnag, adds additional context to the report before sending
 */ (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).start({
    apiKey: (0, $8ZCSm.BUGSNAG_ID) ?? "",
    plugins: [
        new (0, (/*@__PURE__*/$parcel$interopDefault($2c7a1a9aa845011a$exports)))()
    ],
    releaseStage: (0, $8ZCSm.BUGSNAG_STAGE),
    appVersion: (0, $8ZCSm.APP_VERSION),
    enabledBreadcrumbTypes: [
        "error",
        "manual",
        "navigation",
        "process",
        "request",
        "state"
    ],
    onError: (event)=>{
        (0, $gtsdT.logger).log("logger", "Decorating error report for Bugsnag...", event.originalError);
        if ((0, $bcbvQ.default).isLoggedIn() && !(0, $bEEBX.default)((0, $bcbvQ.default).user) && !(0, $bEEBX.default)((0, $bcbvQ.default).currentCompany)) event.setUser((0, $bcbvQ.default).currentCompany, (0, $bcbvQ.default).user.email, (0, $bcbvQ.default).getCurrentCompany()?.name);
        // Add data to identify context for data used
        event.addMetadata("session", {
            loggedIn: (0, $bcbvQ.default).isLoggedIn(),
            dataUsed: (0, $a2SqC.default).dataVersion
        });
        // Add request data to error report if error contains such data
        if (!(0, $bEEBX.default)(event.originalError?.response)) {
            const resp = event.originalError.response;
            (0, $gtsdT.logger).log("logger", `Error was related to a request, adding request context for ${resp.status} response`);
            event.addMetadata("fetch", {
                url: resp.url,
                status: resp.status,
                statusText: resp.statusText,
                success: resp.ok,
                body: event.originalError.text
            });
        }
    }
});
const $f43a6040b7b2f8a4$var$bugSnagReactPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($7c65l))).getPlugin("react");
if ((0, $bEEBX.default)($f43a6040b7b2f8a4$var$bugSnagReactPlugin)) throw new Error("Unabe to ");
const $f43a6040b7b2f8a4$var$BugsnagErrorBoundary = $f43a6040b7b2f8a4$var$bugSnagReactPlugin.createErrorBoundary((0, (/*@__PURE__*/$parcel$interopDefault($dvPqk))));
const $f43a6040b7b2f8a4$var$UpgradeHapppened = ()=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("h2", {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ljb3n.default), {
                        className: "inline fill-success-600"
                    }),
                    " En ny versjon av ",
                    (0, $isIf6.default).siteName,
                    " er tilgjengelig!"
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Trykk p\xe5 knappen under for \xe5 laste inn den nye versjonen og fortsette handleturen."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                onClick: ()=>window.location.reload(),
                children: "Fortsett"
            })
        ]
    });
const $f43a6040b7b2f8a4$var$UnexpectedError = ()=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $4r4cM.default), {
        showCloseButton: false,
        fullWidth: true,
        title: "Det har oppst\xe5tt en uforutsett feil!",
        gaErrorTracking: {
            context: "site",
            text: "generic_site_error"
        },
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                children: "Du kan pr\xf8ve \xe5 trykke p\xe5 knappen under for \xe5 starte om websiden."
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                children: [
                    "Feilen har blitt automatisk rapportert inn til ",
                    (0, $isIf6.default).storeCompanyName,
                    ", s\xe5 vi kommer til \xe5 unders\xf8ke problemet n\xe6rmere for \xe5 se om vi kan unng\xe5 at dette skjer i fremtiden."
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                variant: "primary",
                onClick: ()=>window.location.reload(),
                children: "Start om siden"
            })
        ]
    });
const $f43a6040b7b2f8a4$var$SuggestedAction = ({ error: error })=>/*#__PURE__*/ (0, $7YWoO.jsx)("div", {
        className: "flex items-center justify-center m-12",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: "w-full p-12 shadow bg-surface-default",
            children: (0, $ioVMT.default)(error?.message, "Failed to fetch dynamically imported module") ? /*#__PURE__*/ (0, $7YWoO.jsx)($f43a6040b7b2f8a4$var$UpgradeHapppened, {}) : /*#__PURE__*/ (0, $7YWoO.jsx)($f43a6040b7b2f8a4$var$UnexpectedError, {})
        })
    });
const $f43a6040b7b2f8a4$var$el = document.getElementById("root");
if ($f43a6040b7b2f8a4$var$el) {
    const root = (0, $4ac77edab4d44fe3$export$882461b6382ed46c)($f43a6040b7b2f8a4$var$el);
    root.render(/*#__PURE__*/ (0, $7YWoO.jsx)($f43a6040b7b2f8a4$var$BugsnagErrorBoundary, {
        FallbackComponent: $f43a6040b7b2f8a4$var$SuggestedAction,
        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $f999e54dedf3fc06$export$2e2bcd8739ae039), {})
    }));
}


//# sourceMappingURL=repo.e48fac5b.js.map
